(function () {
  'use strict';

  /* @ngdoc object
   * @name core
   * @description
   *
   */
  angular
    .module('core', [
      'ui.router',
      'ngStorage',
      'ui.bootstrap'
    ]);
}());

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name core.factory:ConfigService
   *
   * @description
   *
   */
  ConfigServiceProvider.$inject = ["$sessionStorageProvider"];
  angular
    .module('core')
    .provider('ConfigService', ConfigServiceProvider);

  function ConfigServiceProvider($sessionStorageProvider) {
    //TODO: Move all constants that can be configurable here
    var defaultLocale = 'bh';
    //var url = 'http://teamcity01.hermes.si/Comtrade.Banking.BIH.WebAPI/'; //NOTE: API MUST END WITH / 'http://WIZARD/API/';
    var serverId = '1';
    //var localCityCode = "bs_sr";
    var url = 'https://www.e-hypo.ba/api_test/'; //dodan novi API za BIH
    var authorizationUrl = 'http://www.e-hypo.ba/OAuthServer/oauth/authorize';
    var logoutUrl = 'http://www.e-hypo.ba/OAuthServer/oauth/logout';

    return {
      defaultLocale: defaultLocale,
      serverId: serverId,
      $get: ["$sessionStorage", function ($sessionStorage) {
        var ConfigServiceBase = {};
        ConfigServiceBase.addQueryString = function addQueryString(uri, parameters) {
          var delimiter = (uri.indexOf('?') == -1) ? '?' : '&';
          for (var parameterName in parameters) {
            var parameterValue = parameters[parameterName];
            uri += delimiter + encodeURIComponent(parameterName) + '=' + encodeURIComponent(parameterValue);
            delimiter = '&';
          }
          return uri;
        };

        var host = window.location;
        var pathname = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
        var defaultRedirectUrl = host.protocol + '//' + host.host + pathname + '/login.html';

        if ($sessionStorage.stateRequest == undefined) {
          $sessionStorage.stateRequest = Math.random();
        }

        ConfigServiceBase.defaultLocale = defaultLocale; //Dejan: Dodao sam defaultLocale jer je bio undefined
        ConfigServiceBase.serverId = serverId;
        ConfigServiceBase.url = url;
        ConfigServiceBase.clientId = 'eBank'; //TODO: Change this to real clientId
        ConfigServiceBase.defaultRedirectUrl = defaultRedirectUrl;//'http://localhost/Comtrade.Banking.WebAPI/Areas/Swagger/o2c.html'//defaultRedirectUrl;
        ConfigServiceBase.authorizationUrl = ConfigServiceBase.addQueryString(authorizationUrl, {
          'client_id': ConfigServiceBase.clientId,
          'redirect_uri': ConfigServiceBase.defaultRedirectUrl,
          'state': $sessionStorage.stateRequest,
          'scope': 'BAO2000',
          'login_hint': 'general',
          'response_type': 'token'
        });
        ConfigServiceBase.logoutUrl = ConfigServiceBase.addQueryString(logoutUrl, {
          'client_id': ConfigServiceBase.clientId,
          'redirect_uri': ConfigServiceBase.defaultRedirectUrl,
          'state': $sessionStorage.stateRequest,
          'scope': 'BAO2000',
          'login_hint': 'general',
          'response_type': 'token'
        });
        ConfigServiceBase.authDebug = true;
        //ConfigServiceBase.localCityCode = localCityCode;

        return ConfigServiceBase;
      }]
    };
  }
}());
/*
 * http://localhost:59468/OAuth/Authorize?client_id=7890ab
 * &redirect_uri=http%3A%2F%2Flocalhost%3A38515%2FHome%2FSignIn&state=my-nonce&scope=bio%20notes&login_hint=ct_mtoken&response_type=token
 * */

(function () {
  'use strict';

  /* @ngdoc object
   * @name comtradeBankingWeb
   * @description
   *
   */
  angular
    .module('comtradeBankingWeb', [
      'ui.router',
      'ngSanitize',
      'ui.select',
      'ngCookies',
      'ngPatternRestrict',
      'tmh.dynamicLocale',
      'home',
      'template',
      'materialAdmin',
      'accounts',
      'core',
      'dashboard',
      'transactions',
      'statements',
      'localization',
      'messages',
      'eInvoices',
      'paymentTemplates',
      'payments',
      'user',
      'timeline',
      'orders',
      'ngMap',
      'settings',
      'navigation',
      'angular-click-outside',
      'ui.mask',
      'investments',
      'employeePayroll',
      'toastr',
      'app.constants',
      'ui-notification',
      'alert',
      'documents',
      'sepa',
      'base64',
      'ab-base64',
      'blockade',
      'viber',
      'secure3d'
    ]);
}());

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/tabs/tabset.html',
    '<div class="clearfix">\n' +
    '    <ul class="tab-nav" ng-class="{\'tn-vertical\': vertical, \'tn-justified\': justified, \'tab-nav-right\': right}" ng-transclude></ul>\n' +
    '    <div class="tab-content">\n' +
    '        <div class="tab-pane"\n' +
    '             ng-repeat="tab in tabs"\n' +
    '             ng-class="{active: tab.active}"\n' +
    '             tab-content-transclude="tab">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div> \n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/pagination/pagination.html',
    '<ul class="pagination">\n' +
    '    <li ng-if="boundaryLinks" ng-class="{disabled: noPrevious()}"><a href ng-click="selectPage(1, $event)"><i class="zmdi zmdi-more-horiz"><i></i></i></a></li>\n' +
    '    <li ng-if="directionLinks" ng-class="{disabled: noPrevious()}"><a href ng-click="selectPage(page - 1, $event)"><i class="zmdi zmdi-chevron-left"></i></a></li>\n' +
    '    <li ng-repeat="page in pages track by $index" ng-class="{active: page.active}"><a href ng-click="selectPage(page.number, $event)">{{page.text}}</a></li>\n' +
    '    <li ng-if="directionLinks" ng-class="{disabled: noNext()}"><a href ng-click="selectPage(page + 1, $event)"><i class="zmdi zmdi-chevron-right"></i></a></li>\n' +
    '    <li ng-if="boundaryLinks" ng-class="{disabled: noNext()}"><a href ng-click="selectPage(totalPages, $event)"><i class="zmdi zmdi-more-horiz"><i></i></i></a></li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/pagination/pager.html',
    '<ul class="pager">\n' +
    '    <li ng-class="{disabled: noPrevious(), previous: align}"><a href ng-click="selectPage(page - 1, $event)">Previous</a></li>\n' +
    '    <li ng-class="{disabled: noNext(), next: align}"><a href ng-click="selectPage(page + 1, $event)">Next</a></li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/datepicker/year.html',
    '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}" class="dp-table">\n' +
    '    <thead>\n' +
    '        <tr class="tr-dpnav">\n' +
    '            <th><button type="button" class="pull-left btn-dp" ng-click="move(-1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-left"></i></button></th>\n' +
    '            <th colspan="3"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="w-100 btn-dp" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><div class="dp-title">{{title}}</div></button></th>\n' +
    '            <th><button type="button" class="pull-right btn-dp" ng-click="move(1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-right"></i></button></th>\n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="row in rows track by $index">\n' +
    '            <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}">\n' +
    '                <button type="button" class="w-100 btn-dp btn-dpbody" ng-class="{\'dp-selected\': dt.selected, \'dp-active\': isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1">\n' +
    '                    <span ng-class="::{\'dp-day-today\': dt.current}">{{::dt.label}}</span></button>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/datepicker/popup.html',
    '<ul class="dropdown-menu" ng-keydown="keydown($event)">\n' +
    '	<li ng-transclude></li>\n' +
    '	<li ng-if="showButtonBar" class="dp-actions clearfix">\n' +
    '        <button type="button" class="btn btn-link" ng-click="select(\'today\')">{{ getText(\'current\') }}</button>\n' +
    '        <button type="button" class="btn btn-link" ng-click="close()">{{ getText(\'close\') }}</button>\n' +
    '	</li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/datepicker/month.html',
    '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}" class="dp-table">\n' +
    '    <thead>\n' +
    '        <tr class="tr-dpnav">\n' +
    '              <th><button type="button" class="pull-left btn-dp" ng-click="move(-1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-left"></i></button></th>\n' +
    '              <th>\n' +
    '                  <button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" class="w-100 btn-dp"><div class="dp-title">{{title}}</div></button>\n' +
    '            </th>\n' +
    '              <th><button type="button" class="pull-right btn-dp" ng-click="move(1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-right"></i></button></th>\n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="row in rows track by $index">\n' +
    '              <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n' +
    '                    <button type="button" class="w-100 btn-dp btn-dpbody" ng-class="{\'dp-selected\': dt.selected, \'dp-active\': isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'dp-day-today\': dt.current}">{{::dt.label}}</span></button>\n' +
    '              </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/datepicker/day.html',
    '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}" class="dp-table dpt-day">\n' +
    '    <thead>\n' +
    '        <tr class="tr-dpnav">\n' +
    '              <th><button type="button" class="pull-left btn-dp" ng-click="move(-1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-left"></i></button></th>\n' +
    '              <th colspan="{{::5 + showWeeks}}">\n' +
    '                  <button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" class="w-100 btn-dp"><div class="dp-title">{{title}}</div></button>\n' +
    '            </th>\n' +
    '              <th><button type="button" class="pull-right btn-dp" ng-click="move(1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-right"></i></button></th>\n' +
    '        </tr>\n' +
    '        <tr class="tr-dpday">\n' +
    '              <th ng-if="showWeeks" class="text-center"></th>\n' +
    '              <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="row in rows track by $index">\n' +
    '              <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n' +
    '              <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n' +
    '                    <button type="button" class="w-100 btn-dp btn-dpday btn-dpbody" ng-class="{\'dp-today\': dt.current, \'dp-selected\': dt.selected, \'dp-active\': isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'dp-day-muted\': dt.secondary, \'dp-day-today\': dt.current}">{{::dt.label}}</span></button>\n' +
    '              </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/carousel/carousel.html',
    '<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n' +
    '    <ol class="carousel-indicators" ng-show="slides.length > 1">\n' +
    '        <li ng-repeat="slide in slides | orderBy:\'index\' track by $index" ng-class="{active: isActive(slide)}" ng-click="select(slide)"></li>\n' +
    '    </ol>\n' +
    '    <div class="carousel-inner" ng-transclude></div>\n' +
    '    <a class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1"><span class="zmdi zmdi-chevron-left"></span></a>\n' +
    '    <a class="right carousel-control" ng-click="next()" ng-show="slides.length > 1"><span class="zmdi zmdi-chevron-right"></span></a>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/tabs/tabset.html',
    '<div class="clearfix">\n' +
    '    <ul class="tab-nav" ng-class="{\'tn-vertical\': vertical, \'tn-justified\': justified, \'tab-nav-right\': right}" ng-transclude></ul>\n' +
    '    <div class="tab-content">\n' +
    '        <div class="tab-pane"\n' +
    '             ng-repeat="tab in tabs"\n' +
    '             ng-class="{active: tab.active}"\n' +
    '             tab-content-transclude="tab">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div> \n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/pagination/pagination.html',
    '<ul class="pagination">\n' +
    '    <li ng-if="boundaryLinks" ng-class="{disabled: noPrevious()}"><a href ng-click="selectPage(1, $event)"><i class="zmdi zmdi-more-horiz"><i></i></i></a></li>\n' +
    '    <li ng-if="directionLinks" ng-class="{disabled: noPrevious()}"><a href ng-click="selectPage(page - 1, $event)"><i class="zmdi zmdi-chevron-left"></i></a></li>\n' +
    '    <li ng-repeat="page in pages track by $index" ng-class="{active: page.active}"><a href ng-click="selectPage(page.number, $event)">{{page.text}}</a></li>\n' +
    '    <li ng-if="directionLinks" ng-class="{disabled: noNext()}"><a href ng-click="selectPage(page + 1, $event)"><i class="zmdi zmdi-chevron-right"></i></a></li>\n' +
    '    <li ng-if="boundaryLinks" ng-class="{disabled: noNext()}"><a href ng-click="selectPage(totalPages, $event)"><i class="zmdi zmdi-more-horiz"><i></i></i></a></li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/pagination/pager.html',
    '<ul class="pager">\n' +
    '    <li ng-class="{disabled: noPrevious(), previous: align}"><a href ng-click="selectPage(page - 1, $event)">Previous</a></li>\n' +
    '    <li ng-class="{disabled: noNext(), next: align}"><a href ng-click="selectPage(page + 1, $event)">Next</a></li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/datepicker/year.html',
    '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}" class="dp-table">\n' +
    '    <thead>\n' +
    '        <tr class="tr-dpnav">\n' +
    '            <th><button type="button" class="pull-left btn-dp" ng-click="move(-1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-left"></i></button></th>\n' +
    '            <th colspan="3"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="w-100 btn-dp" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><div class="dp-title">{{title}}</div></button></th>\n' +
    '            <th><button type="button" class="pull-right btn-dp" ng-click="move(1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-right"></i></button></th>\n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="row in rows track by $index">\n' +
    '            <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}">\n' +
    '                <button type="button" class="w-100 btn-dp btn-dpbody" ng-class="{\'dp-selected\': dt.selected, \'dp-active\': isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1">\n' +
    '                    <span ng-class="::{\'dp-day-today\': dt.current}">{{::dt.label}}</span></button>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/datepicker/popup.html',
    '<ul class="dropdown-menu" ng-keydown="keydown($event)">\n' +
    '	<li ng-transclude></li>\n' +
    '	<li ng-if="showButtonBar" class="dp-actions clearfix">\n' +
    '        <button type="button" class="btn btn-link" ng-click="select(\'today\')">{{ getText(\'current\') }}</button>\n' +
    '        <button type="button" class="btn btn-link" ng-click="close()">{{ getText(\'close\') }}</button>\n' +
    '	</li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/datepicker/month.html',
    '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}" class="dp-table">\n' +
    '    <thead>\n' +
    '        <tr class="tr-dpnav">\n' +
    '              <th><button type="button" class="pull-left btn-dp" ng-click="move(-1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-left"></i></button></th>\n' +
    '              <th>\n' +
    '                  <button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" class="w-100 btn-dp"><div class="dp-title">{{title}}</div></button>\n' +
    '            </th>\n' +
    '              <th><button type="button" class="pull-right btn-dp" ng-click="move(1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-right"></i></button></th>\n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="row in rows track by $index">\n' +
    '              <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n' +
    '                    <button type="button" class="w-100 btn-dp btn-dpbody" ng-class="{\'dp-selected\': dt.selected, \'dp-active\': isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'dp-day-today\': dt.current}">{{::dt.label}}</span></button>\n' +
    '              </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/datepicker/day.html',
    '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}" class="dp-table dpt-day">\n' +
    '    <thead>\n' +
    '        <tr class="tr-dpnav">\n' +
    '              <th><button type="button" class="pull-left btn-dp" ng-click="move(-1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-left"></i></button></th>\n' +
    '              <th colspan="{{::5 + showWeeks}}">\n' +
    '                  <button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" class="w-100 btn-dp"><div class="dp-title">{{title}}</div></button>\n' +
    '            </th>\n' +
    '              <th><button type="button" class="pull-right btn-dp" ng-click="move(1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-right"></i></button></th>\n' +
    '        </tr>\n' +
    '        <tr class="tr-dpday">\n' +
    '              <th ng-if="showWeeks" class="text-center"></th>\n' +
    '              <th ng-repeat="label in ::labels track by $index" class="text-center padding-calendar" ><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="row in rows track by $index">\n' +
    '              <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n' +
    '              <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n' +
    '                    <button type="button" class="w-100 btn-dp btn-dpday btn-dpbody" ng-class="{\'dp-today\': dt.current, \'dp-selected\': dt.selected, \'dp-active\': isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'dp-day-muted\': dt.secondary, \'dp-day-today\': dt.current}">{{::dt.label}}</span></button>\n' +
    '              </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/carousel/carousel.html',
    '<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n' +
    '    <ol class="carousel-indicators" ng-show="slides.length > 1">\n' +
    '        <li ng-repeat="slide in slides | orderBy:\'index\' track by $index" ng-class="{active: isActive(slide)}" ng-click="select(slide)"></li>\n' +
    '    </ol>\n' +
    '    <div class="carousel-inner" ng-transclude></div>\n' +
    '    <a class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1"><span class="zmdi zmdi-chevron-left"></span></a>\n' +
    '    <a class="right carousel-control" ng-click="next()" ng-show="slides.length > 1"><span class="zmdi zmdi-chevron-right"></span></a>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('viber/viber.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="viber-ctn" style="position: relative;">\n' +
    '        <img class="img-ctn" src="img/hypo/addikochat.png"/>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-12 t-a-c p-t-15 ">\n' +
    '        <h4 class="c-appblue" translate="viber.conditionHeader"></h4>\n' +
    '        <h4 class="c-appblue underline" translate="viber.conditionHeader2"></h4>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row p-b-15">\n' +
    '      <div class="col-sm-12">\n' +
    '        <div class="image">\n' +
    '          <img src="img/hypo/viber/sl-v1.png" alt="" />\n' +
    '          <!--<h2>A Movie in the Park:<br />Kung Fu Panda</h2>-->\n' +
    '\n' +
    '            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text1"></div>\n' +
    '            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text2"></div>\n' +
    '            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text3"></div>\n' +
    '            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text4"></div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row" style="margin-top:10px;">\n' +
    '      <div class="col-sm-12 viber-txt-center">\n' +
    '          <label class="viber-display-inline">\n' +
    '            <a ng-href="{{viber.conditionLink}}" target="_blank" style="color:blue;" translate ="viber.viberCondition1"></a>\n' +
    '          </label>\n' +
    '        <label class="viber-display-inline">{{viber.bankAddition}} {{APP_GLOBAL_SETTINGS.defaultData.BiHLocation}}</label>\n' +
    '        <label class="viber-display-inline" translate="viber.viberCondition2"></label>\n' +
    '        <label class="viber-display-inline"><a href="https://www.viber.com/en/terms" target="_blank" style="color:blue;" translate="viber.viberCondition3"></a></label>\n' +
    '        <label class="viber-display-inline" translate="viber.viberCondition4"></label>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-12 viber-txt-center p-t-10">\n' +
    '        <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value ng-binding">\n' +
    '          <label class="p-0" translate="viber.agree">Slažem se sa Opštim uvjetima Vajber banke</label>\n' +
    '          <input type="checkbox" ng-model="viber.agree">\n' +
    '          <i class="input-helper"></i>\n' +
    '        </label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '    <div class="row">\n' +
    '\n' +
    '\n' +
    '      <div class="col-sm-12 t-a-c">\n' +
    '        <button class="btn btn-default" data-ui-sref="{{viber.checkViberActivation() ? \'viber.activate-new\' : \'viber.activate\'}}" ng-disabled="!viber.agree" translate="viber.activate">\n' +
    '          Aktiviraj\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('viber/viber-deactivated.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="viber-ctn">\n' +
    '        <img class="img-ctn" src="img/hypo/addikochat.png"/>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- use for all countries except SRB -->\n' +
    '    <div ng-if="APP_GLOBAL_SETTINGS.defaultData.ViberSmsActivation == \'false\'" class="row">\n' +
    '      <div class="col-sm-12 t-a-c">\n' +
    '        <p class="m-t-10 f-16" translate="viber.deactivateText">Vaš nalog je trenutno aktivan</p>\n' +
    '        <div class="col-sm-12">\n' +
    '          <button class="btn btn-primary" type="submit" translate="viber.deactivate"\n' +
    '                  ng-click="viberDeactivate.deactivateViber();">\n' +
    '            Deaktiviraj\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- use only for SRB environment -->\n' +
    '    <div class="row p-t-15" ng-if="APP_GLOBAL_SETTINGS.defaultData.ViberSmsActivation == \'true\'">\n' +
    '      <div class="col-sm-offset-3 col-sm-6">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-12 t-a-c">\n' +
    '            <h4 translate="viber.activeMessage"></h4>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-12">\n' +
    '            <div class="table-responsive table-blue-border">\n' +
    '              <table class="table table-striped">\n' +
    '                <tr>\n' +
    '                  <td class="po-desc-label" translate="viber.mobileNumber"></td>\n' +
    '                  <td class="po-desc-label">{{viberDeactivate.gsm}}</td>\n' +
    '                </tr>\n' +
    '                <tr>\n' +
    '                <td class="po-desc-label" translate="viber.activationDate"></td>\n' +
    '                <td class="po-desc-label" >{{viberDeactivate.date}}</td>\n' +
    '                </tr>\n' +
    '              </table>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row p-t-10">\n' +
    '          <div class="col-xs-12 t-a-c">\n' +
    '            <button class="btn btn-default" translate="viber.deactivate" ng-click="viberDeactivate.deactivateViber();">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('viber/viber-activate.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="viber-ctn" style="position: relative;">\n' +
    '\n' +
    '        <img class="img-ctn" src="img/hypo/addikochat.png"/>\n' +
    '\n' +
    '        <p  class="viber-title" translate="viber.activationWay" style="position:absolute; bottom:0;right:0;left:0;">Izaberite način aktivacije</p>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12 p-0">\n' +
    '        <div class="msg-tab-container">\n' +
    '          <div class="msg-tab" translate="viber.scanQrCode">Skeniranje QR code</div>\n' +
    '          <div class="msg-tab" style="border-left: 1px solid white;" translate="viber.activationCode">Aktivacijski kod\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- environment for countries different from CRO-->\n' +
    '    <div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'hr\'">\n' +
    '        <div class="col-md-6">\n' +
    '\n' +
    '          <div class="m-t-10 t-a-c">\n' +
    '            <image width="150" height="150" class="m-l-30"\n' +
    '                   data-ng-src="{{\'data:image/bmp;base64,\' + viberActivate.qrCodeUrl}}"></image>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="p-10 f-14" data-ng-repeat="item in viberActivate.scanQrCodeConditions">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-1 col-xs-3 viber-bullet">{{$index + 1}}</div>\n' +
    '              <div class="col-sm-11 col-xs-9" translate="{{item}}"></div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-6">\n' +
    '          <div class="m-t-10 t-a-c">\n' +
    '            <p class="f-14" translate="viber.yourActivationCode">Vaš kod za aktivaciju: </p>\n' +
    '            <p class="viber-code-wrap">{{viberActivate.text}}</p>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="activationCodeWrapper">\n' +
    '            <div class="p-10 f-14" data-ng-repeat="item in viberActivate.activationCodeConditions">\n' +
    '              <div class="row">\n' +
    '                <div class="col-sm-1 col-xs-3 viber-bullet">{{$index + 1}}</div>\n' +
    '                <div class="col-sm-11 col-xs-9" translate="{{item}}"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- code related to CRO environment-->\n' +
    '\n' +
    '    <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\'">\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-6">\n' +
    '          <div class="m-t-10 t-a-c">\n' +
    '            <image width="150" height="150" class="m-l-30"\n' +
    '                   data-ng-src="{{\'data:image/bmp;base64,\' + viberActivate.qrCodeUrl}}"></image>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="p-10 f-14" data-ng-repeat="item in viberActivate.scanQrCodeConditions">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-1 col-xs-3 viber-bullet">{{$index + 1}}</div>\n' +
    '              <div class="col-sm-11 col-xs-9" translate="{{item}}"></div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-6">\n' +
    '          <div class="m-t-10 t-a-c">\n' +
    '            <p class="f-14" translate="viber.yourActivationCode">Vaš kod za aktivaciju: </p>\n' +
    '            <p class="viber-code-wrap">{{viberActivate.text}}</p>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="activationCodeWrapper">\n' +
    '            <div class="p-10 f-14" data-ng-repeat="item in viberActivate.activationCodeConditions">\n' +
    '              <div class="row">\n' +
    '                <div class="col-sm-1 col-xs-3 viber-bullet">{{$index + 1}}</div>\n' +
    '                <div class="col-sm-11 col-xs-9" translate="{{item}}"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12 t-a-c">\n' +
    '          <img src="img/hypo/activation steps.png" alt="" width="85%">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row f-14">\n' +
    '        <div class="col-xs-4" data-ng-repeat="item in viberActivate.additionalActivationConditions">\n' +
    '          <div class="col-xs-2 col-sm-2 viber-bullet">{{$index + 3}}</div>\n' +
    '          <div class="col-xs-10 col-sm-10 p-r-0" translate="{{item}}"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('viber/viber-activate-new.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="viber-ctn" style="position: relative;">\n' +
    '        <img class="img-ctn" src="img/hypo/addikochat.png"/>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row p-t-15">\n' +
    '      <div class="col-xs-12">\n' +
    '        <div class="image-steps">\n' +
    '\n' +
    '          <img src="img/hypo/viber/Koraci_aktivacije.png" alt=""/>\n' +
    '\n' +
    '          <div class="text-in-picture text-in-picture-1">\n' +
    '            <div class="col-xs-3 col-sm-2 viber-bullet">1</div>\n' +
    '            <div class="col-xs-8 col-sm-10" translate="viber.step1"></div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="text-in-picture text-in-picture-2">\n' +
    '            <div class="col-xs-3 col-sm-2 viber-bullet">2</div>\n' +
    '            <div class="col-xs-9 col-sm-10" translate="viber.step2"></div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="text-in-picture text-in-picture-3">\n' +
    '            <div class="col-xs-3 col-sm-2 viber-bullet">3</div>\n' +
    '            <div class="col-xs-9 col-sm-10" translate="viber.step3"></div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="text-in-picture text-in-picture-4">\n' +
    '            <div class="col-xs-3 col-sm-2 viber-bullet">4</div>\n' +
    '            <div class="col-xs-9 col-sm-10" translate="viber.step4"></div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-xs-6 t-a-c">\n' +
    '            <button class="btn btn-default" translate="viber.becomeFollower" ng-click="viberActivateNew.becomeFollower();"></button>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-xs-6 t-a-c">\n' +
    '            <button class="btn btn-default" translate="viber.activate" ng-click="viberActivateNew.activate();"></button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('user/user.tpl.html',
    '<h2>user</h2>\n' +
    '<p>{{user.ctrlName}}</p>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('transactions/transactions.tpl.html',
    '<h2>transactions</h2>\n' +
    '<p>{{transactions.ctrlName}}</p>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('transactions/transactions-reclamation.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div class="exchange-rate-header m-b-10">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12 f-20" translate="reclamation.title"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="trans-complain-container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '            <label translate="reclamation.number"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field" ng-switch-default>{{::tReclamation.tempReclamationObj.id}}</label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field" ng-switch-when="sl">{{::tReclamation.tempReclamationObj.transactionId}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.paymentReference"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::tReclamation.tempReclamationObj.referenceNumber}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.bookingDate"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::tReclamation.tempReclamationObj.bookingDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.valueDate"></label>\n' +
    '            <label  class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::tReclamation.tempReclamationObj.valueDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.amount"></label>\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-9 p-r-0">\n' +
    '                <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field t-a-r">{{::tReclamation.tempReclamationObj.amount| number: 2}}</label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-3 p-l-0">\n' +
    '                <label class="tr-input-lbl wrap-text p-l-10 p-r-10 tr-amount-ctn input-field">{{::tReclamation.tempReclamationObj.currencySymbol}}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.purpose"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::tReclamation.tempReclamationObj.detail.purpose}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="form-group">\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field" translate="reclamation.wantComplain"></label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.description"></label>\n' +
    '            <!--<input type="text" class="form-control input-field" data-ng-model="tReclamation.tempReclamationObj.reclamationInput">-->\n' +
    '            <textarea ng-pattern-restrict="{{tReclamation.regexPatterns.allowedCharsDPStextArea}}"\n' +
    '                      ng-model="tReclamation.tempReclamationObj.reclamationInput"\n' +
    '                      class="form-control"\n' +
    '                      id="reclamationInput"\n' +
    '                      cols="30"\n' +
    '                      rows="5"\n' +
    '                      ></textarea>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row m-t-10">\n' +
    '      <div class="col-sm-12 c-red bold-font">\n' +
    '        <div class="col-lg-3 col-sm-6 ">\n' +
    '          <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn m-0"\n' +
    '                  translate="reclamation.cancel"\n' +
    '                  data-ng-click="tReclamation.cancel();">\n' +
    '\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-lg-3 col-sm-6 pull-right ">\n' +
    '          <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn m-0 pull-right"\n' +
    '                  translate="reclamation.confirm"\n' +
    '                  ng-disabled="tReclamation.formSubmitted"\n' +
    '                  data-ng-click="tReclamation.createReclamation();">\n' +
    '\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('timeline/timeline.tpl.html',
    '<div class="timeline-row p-r-15 p-l-15">\n' +
    '\n' +
    '\n' +
    '  <div class="col-sm-12 l-h-50 p-0 bgm-white" style="z-index:1;">\n' +
    '    <span translate="dashboard.bankTimeline" class="f-17 m-l-20 c-appblue"></span>\n' +
    '  </div>\n' +
    '  <div class="col-sm-12 p-l-20 p-r-20 bgm-white" style="z-index:1;">\n' +
    '    <div class="col-sm-6 col-xs-12 p-0">\n' +
    '      <div ng-include="\'timeline/timeline-filter.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '    <div class="col-sm-6 col-xs-12 p-0">\n' +
    '      <div class="dropdown acc-period-select pull-right" style="display: inline-block">\n' +
    '        <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '          {{dashboard.selectedPeriod.item.description | translate}}\n' +
    '          <span class="caret"></span>\n' +
    '        </button>\n' +
    '        <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '          <li data-ng-repeat="period in dashboard.periodList">\n' +
    '            <a href="" class="f-13" data-ng-click="dashboard.timelineTimeFilter(period)">\n' +
    '              {{period.item.description | translate}}\n' +
    '            </a>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">\n' +
    '\n' +
    '    <ul class="hypo-timeline" kcd-recompile="dashboard.timelineListGrouped">\n' +
    '      <li class="time-label">\n' +
    '        <span>{{\'dashboard.pendingPayments\'|translate}} |\n' +
    '          <span data-ng-click="dashboard.hidePendingPayments()" ng-show="dashboard.pendingPaymentsOpened" class="c-blue pointer">\n' +
    '            <b>{{\'dashboard.hide\'|translate}}</b>\n' +
    '          </span>\n' +
    '          <span data-ng-click="dashboard.showPendingPayments()" ng-show="!dashboard.pendingPaymentsOpened" class="c-blue pointer">\n' +
    '            <b>{{\'dashboard.show\'|translate}}</b>\n' +
    '          </span>\n' +
    '        </span>\n' +
    '      </li>\n' +
    '      <li ng-show="dashboard.pendingPaymentsOpened" ng-repeat="payment in dashboard.pendingPaymentsList.result">\n' +
    '        <i class="icon icon-clock-o currency-icon-change-tl"></i>\n' +
    '        <div class="hypo-timeline-item payment-item" ng-click="tlItem.selected = !tlItem.selected;" ng-class="{\'opened\': tlItem.selected}">\n' +
    '          <div class="hypo-timeline-body payment-tl-height">\n' +
    '\n' +
    '            <div class="col-xs-6">\n' +
    '              <h4 class="m-b-0 m-t-0 c-gray"><div class="bold-font wrap-text">{{::payment.purpose}}</div></h4>\n' +
    '              <p class="m-b-0 m-t-0 iban-style">{{::payment.toAccountNumber}} {{::payment.receiverName}}</p>\n' +
    '              <p class="m-b-0 bold-font">{{payment.dueDate | date: \'shortDate\'}}</p>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6"><span class="pull-right t-a-r f-18"><b>{{::payment.amount|number:2}} {{::payment.currencySymbol}}</b></span></div>\n' +
    '          </div>\n' +
    '          <div ng-if="tlItem.selected" class="transaction-details">\n' +
    '            <div data-ng-include="\'dashboard/tl-payment-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '\n' +
    '      <div class="t-a-c p-10 no-data-image" ng-if="dashboard.timelineListGrouped.result.length == 0">\n' +
    '        <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '        <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '      </div>\n' +
    '\n' +
    '      <li data-ng-repeat="tlItem in ::dashboard.timelineListGrouped.result" ng-class="{\'time-label\': tlItem.isVirtual === true}">\n' +
    '\n' +
    '        <span ng-if="tlItem.isVirtual === true && tlItem.showDate">{{tlItem.dateValue | date:\'shortDate\'}}</span>\n' +
    '        <span ng-if="tlItem.isVirtual === true && tlItem.showText">{{tlItem.dateLabel | translate}}</span>\n' +
    '\n' +
    '        <i ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'TransactionCredit\'" class="icon icon-priliv"></i>\n' +
    '        <i ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'TransactionDebit\'" class="icon icon-odliv"></i>\n' +
    '        <i ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'MessageIn\'" class="icon icon-messagein currency-icon-change-tl"></i>\n' +
    '        <i ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'MessageOut\'" class="icon icon-messageout currency-icon-change-tl"></i>\n' +
    '        <i ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'LoginSuccessful\'" class="icon icon-login currency-icon-change-tl"></i>\n' +
    '        <i ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'LoginFailed\'" class="icon icon-close currency-icon-change-tl"></i>\n' +
    '\n' +
    '        <div ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'TransactionCredit\'" class="hypo-timeline-item transaction-item" ng-click="tlItem.selected = !tlItem.selected; dashboard.getTransactionDetails(tlItem);" ng-class="{\'opened\': tlItem.selected}">\n' +
    '          <div class="hypo-timeline-body">\n' +
    '            <div class="col-xs-6 col-sm-8 p-l-0 p-r-0">\n' +
    '              <h4 class="m-b-0 m-t-0 c-gray no-wrap-text"><b>{{::tlItem.description}}</b></h4>\n' +
    '              <p class="m-b-0 m-t-0 no-wrap-text" ng-if="tlItem.payerName">{{::tlItem.payerName}}</p>\n' +
    '              <p class="m-b-0 m-t-0 no-wrap-text" ng-if="tlItem.payeeName">{{::tlItem.payeeName}}</p>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::tlItem.credit | number:2}} {{::tlItem.currency}}</b></span></div>\n' +
    '          </div>\n' +
    '          <div ng-if="tlItem.selected" class="m-l-0 transaction-details">\n' +
    '            <div data-ng-include="\'dashboard/tl-transaction-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'TransactionDebit\'" class="hypo-timeline-item transaction-item" ng-click="tlItem.selected = !tlItem.selected; dashboard.getTransactionDetails(tlItem);" ng-class="{\'opened\': tlItem.selected}">\n' +
    '          <div class="hypo-timeline-body">\n' +
    '            <div class="col-xs-6 col-sm-8 p-l-0 p-r-0">\n' +
    '              <h4 class="m-b-0 m-t-0 c-gray no-wrap-text"><b>{{::tlItem.description}}</b></h4>\n' +
    '              <p class="m-b-0 m-t-0 no-wrap-text" ng-if="tlItem.payeeName">{{::tlItem.payeeName}}</p>\n' +
    '              <p class="m-b-0 m-t-0 no-wrap-text" ng-if="tlItem.payerName">{{::tlItem.payerName}}</p>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::tlItem.debit | number:2}} {{::tlItem.currency}}</b></span></div>\n' +
    '          </div>\n' +
    '          <div ng-if="tlItem.selected" class="m-l-0 transaction-details">\n' +
    '            <div data-ng-include="\'dashboard/tl-transaction-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'EInvoice\'" class="hypo-timeline-item msg-item" ng-click="tlItem.selected = !tlItem.selected; dashboard.getEinvoiceDetails(tlItem);">\n' +
    '          <div class="bubble einvoice" ng-class="{\'m-b-0\': tlItem.selected}">\n' +
    '            <p class="no-bottom-margin c-white"><b>{{::tlItem.description}}\n' +
    '              <span class="msg-action pull-right hidden-xs"><a href="">{{\'timeline.itemTypeStatus.\'+tlItem.itemType | translate}}</a></span>\n' +
    '              </b></p>\n' +
    '          </div>\n' +
    '          <div ng-if="tlItem.selected" class="einvoice-details">\n' +
    '            <div data-ng-include="\'dashboard/tl-einvoice-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'MessageOut\'" class="hypo-timeline-item msg-item" ng-click="tlItem.selected = !tlItem.selected; dashboard.getMessageDetails(tlItem);">\n' +
    '          <div class="bubble message" ng-class="{\'m-b-0\': tlItem.selected}">\n' +
    '            <p class="msg-label no-bottom-margin"><span ng-if="tlItem.description">{{::\'timeline.msgWith\'| translate}}</span><span ng-if="!tlItem.description">{{::\'timeline.msgWithout\'| translate}}</span><b>{{::tlItem.description}}</b>{{::\'timeline.msgSent\'| translate}}<b>{{dashboard.getDateFromDatestring(tlItem.date)|date:\'medium\'}}</b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div ng-if="tlItem.selected" class="timeline-details">\n' +
    '            <div data-ng-include="\'dashboard/tl-message-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'MessageIn\'" class="hypo-timeline-item msg-item" ng-click="tlItem.selected = !tlItem.selected; dashboard.getMessageDetails(tlItem);">\n' +
    '          <div class="bubble message" ng-class="{\'m-b-0\': tlItem.selected}">\n' +
    '            <p class="msg-label no-bottom-margin"><span ng-if="tlItem.description">{{::\'timeline.msgWith\'| translate}}</span><span ng-if="!tlItem.description">{{::\'timeline.msgWithout\'| translate}}</span><b>{{::tlItem.description}}</b>{{::\'timeline.msgReceived\'| translate}}<b>{{dashboard.getDateFromDatestring(tlItem.date)|date:\'medium\'}}</b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div ng-if="tlItem.selected" class="timeline-details">\n' +
    '            <div data-ng-include="\'dashboard/tl-message-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'LoginSuccessful\'" class="hypo-timeline-item msg-item">\n' +
    '          <div class="bubble">\n' +
    '            <p ng-if="!tlItem.lastLogin" class="msg-label no-bottom-margin no-wrap-text f-16">{{::tlItem.group}} <b>{{::tlItem.date | date:\'medium\'}}</b></p>\n' +
    '            <p ng-if="tlItem.lastLogin" class="msg-label no-bottom-margin no-wrap-text f-16">{{\'header.lastLogin\' | translate}} <b>{{::tlItem.date | date:\'medium\'}}</b></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="tlItem.isVirtual == undefined && tlItem.itemType ==\'LoginFailed\'" class="hypo-timeline-item msg-item">\n' +
    '          <div class="bubble">\n' +
    '            <p class="msg-label no-bottom-margin no-wrap-text f-16"><b>{{::tlItem.itemType}}, {{::tlItem.date | date:\'medium\'}}</b></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="col-md-12 text-center p-t-15">\n' +
    '  <button class="btn btn-default" ng-hide="dashboard.timelineListGrouped.hasMore == false" data-ng-click="dashboard.loadMoreTimelineItemsGrouped()" type="input" translate="dashboard.loadEvents">Load older events</button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('timeline/timeline-item-details-modal.tpl.html',
    '<div ng-switch="tlItemDetailsModal.timelineItem.referenceType">\n' +
    '  <div ng-switch-when="Transaction">\n' +
    '    <div data-ng-include="\'dashboard/tl-transaction-details.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '  <div ng-switch-when="EInvoice">\n' +
    '    <div data-ng-include="\'dashboard/tl-einvoice-details.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '  <div ng-switch-when="Message">\n' +
    '    <div data-ng-include="\'dashboard/tl-message-details.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '    <!--<div ng-switch-when="Message">\n' +
    '    <div data-ng-include="\'dashboard/tl-transaction-details.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '  <div ng-switch-when="Statement">\n' +
    '    <div data-ng-include="\'dashboard/tl-transaction-details.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '  <div ng-switch-when="Account">\n' +
    '    <div data-ng-include="\'dashboard/tl-transaction-details.tpl.html\'"></div>\n' +
    '  </div>-->\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('timeline/timeline-filter.tpl.html',
    '<div class="tml-filter-container" style="overflow: hidden;" ng-class="{\'tmlf-wide\': dashboard.searchInputExpanded}" id="searchFilterExpandedDiv"\n' +
    '     click-outside="dashboard.searchFilterExpanded = false;">\n' +
    '    <div id="searchBtnLeftDiv" class="inner-section left">\n' +
    '        <i class="icon icon-search  icon-hc-2x m-l-5"></i>\n' +
    '    </div>\n' +
    '    <div id="searchBtnCenterDiv" class="inner-section center">\n' +
    '        <input id="searchTimelineInput" type="text" class="search-input"\n' +
    '               placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '               ng-model="dashboard.timelineSearchFilter.descriptionFTS" ng-model-options="{ debounce: 300 }"\n' +
    '              ng-change="dashboard.timelineSearchAction();">\n' +
    '    </div>\n' +
    '    <div ng-show="dashboard.searchInputExpanded" id="searchBtnRightDiv" class="inner-section right pull-right">\n' +
    '      <i ng-show="dashboard.timelineSearchFilter.descriptionFTS" class="zmdi zmdi-tag-close pull-left zmdi-hc-2x m-r-0"\n' +
    '         ng-click="dashboard.timelineSearchFilter.descriptionFTS = \'\'; dashboard.timelineSearchAction();">\n' +
    '      </i>\n' +
    '      <i class="icon icon-filter icon-hc-2x i-r-0 pull-right"\n' +
    '         ng-click="dashboard.searchFilterExpanded = !dashboard.searchFilterExpanded"></i>\n' +
    '    </div>\n' +
    '    <div class="tml-filter-selection" ng-class="{\'opened\': dashboard.searchFilterExpanded}">\n' +
    '        <div class="tml-filter-type-selection-wrapper">\n' +
    '            <div ng-class="{\'selected\': dashboard.timelineItemTypeSelected === 1}" class="tmlf-type-item" ng-click="dashboard.selectTimelineItemType(\'all\')" translate="timelineFilter.all"></div>\n' +
    '            <div ng-class="{\'selected\': dashboard.timelineItemTypeSelected === 2}" class="tmlf-type-item" ng-click="dashboard.selectTimelineItemType(\'credit\')" translate="timelineFilter.credit"></div>\n' +
    '            <div ng-class="{\'selected\': dashboard.timelineItemTypeSelected === 3}" class="tmlf-type-item" ng-click="dashboard.selectTimelineItemType(\'debit\')" translate="timelineFilter.debit"></div>\n' +
    '            <div ng-class="{\'selected\': dashboard.timelineItemTypeSelected === 4}" class="tmlf-type-item" style="border-right:none !important" ng-click="dashboard.selectTimelineItemType(\'others\')" translate="timelineFilter.others"></div>\n' +
    '        </div>\n' +
    '        <div class="m-t-15" style="overflow:auto">\n' +
    '            <div class="col-xs-5 p-l-5 p-r-5">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="f-12-s" translate="timelineFilter.amountFrom"></label>\n' +
    '                    <input ng-keyup="$event.keyCode == 13 && dashboard.applyTimelineFilter()" type="text" class="form-control-db" ng-model="dashboard.timelineFilter.amountGTE" amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" autocomplete="off">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-5 p-l-0 p-r-5">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="f-12-s" translate="timelineFilter.amountTo"></label>\n' +
    '                    <input ng-keyup="$event.keyCode == 13 && dashboard.applyTimelineFilter()" type="text" class="form-control-db" ng-model="dashboard.timelineFilter.amountLTE" amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" autocomplete="off">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-2 p-l-0 p-r-5 p-t-25" >\n' +
    '                <select name="" id="" class="form-control-db" ng-options="option.symbol for option in dashboard.currenciesList" ng-model="dashboard.currencySelectObject">\n' +
    '                </select>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="m-b-15" style="overflow:auto">\n' +
    '            <div class="col-xs-6 t-a-l p-l-5">\n' +
    '                <button class="btn btn-primary app-btn-gray" ng-click="dashboard.timelineItemTypeSelected = 1; dashboard.resetTimelineFilter();dashboard.searchFilterExpanded = false;dashboard.applyTimelineFilter();" translate="timelineFilter.reset"></button>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 t-a-r p-r-5">\n' +
    '                <button class="btn btn-default app-btn-blue w-100" ng-click="dashboard.applyTimelineFilter();" translate="timelineFilter.apply"></button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/sidebar-left.html',
    '<div class="sidebar-inner c-overflow">    \n' +
    '    <div class="profile-menu">\n' +
    '        <a href="" toggle-submenu>\n' +
    '            <div class="profile-pic">\n' +
    '                <img src="img/profile-pics/1.jpg" alt="">\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="profile-info">\n' +
    '                Malinda Hollaway\n' +
    '\n' +
    '                <i class="zmdi zmdi-caret-down"></i>\n' +
    '            </div>\n' +
    '        </a>\n' +
    '\n' +
    '        <ul class="main-menu">\n' +
    '            <li>\n' +
    '                <a data-ui-sref="pages.profile.profile-about" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-account"></i> View Profile</a>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <a href=""><i class="zmdi zmdi-input-antenna"></i> Privacy Settings</a>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <a href=""><i class="zmdi zmdi-settings"></i> Settings</a>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <a href=""><i class="zmdi zmdi-time-restore"></i> Logout</a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '\n' +
    '    <ul class="main-menu">\n' +
    '        \n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="home" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-home"></i> Home</a>\n' +
    '        </li>\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'headers\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-view-compact"></i> Headers</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="headers.textual-menu" data-ng-click="mactrl.sidebarStat($event)">Textual menu</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="headers.image-logo" data-ng-click="mactrl.sidebarStat($event)">Image logo</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="headers.mainmenu-on-top" data-ng-click="mactrl.sidebarStat($event)">Mainmenu on top</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="typography" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-format-underlined"></i> Typography</a>\n' +
    '        </li>\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'widgets\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-widgets"></i> Widgets</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="widgets.widget-templates" data-ng-click="mactrl.sidebarStat($event)">Templates</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="widgets.widgets" data-ng-click="mactrl.sidebarStat($event)">Widgets</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        \n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'tables\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-view-list"></i> Tables</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="tables.tables" data-ng-click="mactrl.sidebarStat($event)">Tables</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="tables.data-table" data-ng-click="mactrl.sidebarStat($event)">Data Tables</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        \n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'form\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-collection-text"></i> Forms</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.basic-form-elements" data-ng-click="mactrl.sidebarStat($event)">Basic Form Elements</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.form-components" data-ng-click="mactrl.sidebarStat($event)">Form Components</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.form-examples" data-ng-click="mactrl.sidebarStat($event)">Form Examples</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.form-validations" data-ng-click="mactrl.sidebarStat($event)">Form Validation</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'user-interface\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-swap-alt"></i>User Interface</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.ui-bootstrap" data-ng-click="mactrl.sidebarStat($event)">UI Bootstrap</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.colors" data-ng-click="mactrl.sidebarStat($event)">Colors</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.animations" data-ng-click="mactrl.sidebarStat($event)">Animations</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.box-shadow" data-ng-click="mactrl.sidebarStat($event)">Box Shadow</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.buttons" data-ng-click="mactrl.sidebarStat($event)">Buttons</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.icons" data-ng-click="mactrl.sidebarStat($event)">Icons</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.alerts" data-ng-click="mactrl.sidebarStat($event)">Alerts</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.preloaders" data-ng-click="mactrl.sidebarStat($event)">Preloaders</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.notifications-dialogs" data-ng-click="mactrl.sidebarStat($event)">Notifications & Dialogs</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.media" data-ng-click="mactrl.sidebarStat($event)">Media</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.other-components" data-ng-click="mactrl.sidebarStat($event)">Others</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'charts\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-trending-up"></i>Charts</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="charts.flot-charts" data-ng-click="mactrl.sidebarStat($event)">Flot Charts</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="charts.other-charts" data-ng-click="mactrl.sidebarStat($event)">Other Charts</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="calendar" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-calendar"></i> Calendar</a>\n' +
    '        </li>\n' +
    '        \n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'photo-gallery\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-image"></i>Photo Gallery</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="photo-gallery.photos" data-ng-click="mactrl.sidebarStat($event)">Default</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="photo-gallery.timeline" data-ng-click="mactrl.sidebarStat($event)">Timeline</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        \n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="generic-classes" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-layers"></i> Generic Classes</a>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'pages\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-collection-item"></i> Sample Pages</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.profile.profile-about" data-ng-click="mactrl.sidebarStat($event)">Profile</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.listview" data-ng-click="mactrl.sidebarStat($event)">List View</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.messages" data-ng-click="mactrl.sidebarStat($event)">Messages</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.pricing-table" data-ng-click="mactrl.sidebarStat($event)">Pricing Table</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.contacts" data-ng-click="mactrl.sidebarStat($event)">Contacts</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.invoice" data-ng-click="mactrl.sidebarStat($event)">Invoice</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.wall" data-ng-click="mactrl.sidebarStat($event)">Wall</a></li>\n' +
    '                <li><a href="login.html">Login and Sign Up</a></li>\n' +
    '                <li><a href="lockscreen.html">Lockscreen</a></li>\n' +
    '                <li><a href="404.html">Error 404</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="sub-menu">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-menu"></i> 3 Level Menu</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a href="">Level 2 link</a></li>\n' +
    '                <li><a href="">Another level 2 Link</a></li>\n' +
    '                <li class="sub-menu">\n' +
    '                    <a href="" toggle-submenu>I have children too</a>\n' +
    '\n' +
    '                    <ul>\n' +
    '                        <li><a href="">Level 3 link</a></li>\n' +
    '                        <li><a href="">Another Level 3 link</a></li>\n' +
    '                        <li><a href="">Third one</a></li>\n' +
    '                    </ul>\n' +
    '                </li>\n' +
    '                <li><a href="">One more 2</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li>\n' +
    '            <a href="https://wrapbootstrap.com/theme/material-admin-responsive-angularjs-WB011H985"><i class="zmdi zmdi-money"></i> Buy this template</a>\n' +
    '        </li>\n' +
    '    </ul>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/profile-menu.html',
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-about">About</a></li>\n' +
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-timeline">Timeline</a></li>\n' +
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-photos">Photos</a></li>\n' +
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-connections">Connections</a></li>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/header.html',
    '<ul class="header-inner clearfix">\n' +
    '    <li id="menu-trigger" data-target="mainmenu" data-toggle-sidebar data-model-left="mactrl.sidebarToggle.left" data-ng-class="{ \'open\': mactrl.sidebarToggle.left === true }">\n' +
    '        <div class="line-wrap">\n' +
    '            <div class="line top"></div>\n' +
    '            <div class="line center"></div>\n' +
    '            <div class="line bottom"></div>  \n' +
    '        </div>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="logo hidden-xs">\n' +
    '        <a data-ui-sref="home" data-ng-click="mactrl.sidebarStat($event)">Material Admin</a>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="pull-right">\n' +
    '        <ul class="top-menu">\n' +
    '\n' +
    '            <li id="toggle-width">\n' +
    '                <div class="toggle-switch">\n' +
    '                    <input id="tw-switch" type="checkbox" hidden="hidden" data-change-layout="mactrl.layoutType">\n' +
    '                    <label for="tw-switch" class="ts-helper"></label>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '\n' +
    '            <li id="top-search">\n' +
    '                <a href="" data-ng-click="hctrl.openSearch()"><i class="tm-icon zmdi zmdi-search"></i></a>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tm-icon zmdi zmdi-email"></i>\n' +
    '                    <i class="tmn-counts">6</i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg stop-propagate pull-right">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Messages\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" ng-href="" ng-repeat="w in hctrl.messageResult.list">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" ng-src="img/profile-pics/{{ w.img }}" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">{{ w.user }}</div>\n' +
    '                                        <small class="lv-small">{{ w.text }}</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="clearfix"></div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tm-icon zmdi zmdi-notifications"></i>\n' +
    '                    <i class="tmn-counts">9</i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg stop-propagate pull-right">\n' +
    '                    <div class="listview" id="notifications">\n' +
    '                        <div class="lv-header">\n' +
    '                            Notification\n' +
    '\n' +
    '                            <ul class="actions">\n' +
    '                                <li>\n' +
    '                                    <a href="" data-ng-click="hctrl.clearNotification($event)">\n' +
    '                                        <i class="zmdi zmdi-check-all"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" ng-href="" ng-repeat="w in hctrl.messageResult.list">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" ng-src="img/profile-pics/{{ w.img }}" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">{{ w.user }}</div>\n' +
    '                                        <small class="lv-small">{{ w.text }}</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="clearfix"></div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View Previous</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown hidden-xs" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tm-icon zmdi zmdi-view-list-alt"></i>\n' +
    '                    <i class="tmn-counts">2</i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu pull-right dropdown-menu-lg">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Tasks\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">HTML5 Validation Report</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style="width: 95%">\n' +
    '                                        <span class="sr-only">95% Complete (success)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Google Chrome Extension</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n' +
    '                                        <span class="sr-only">80% Complete (success)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Social Intranet Projects</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">\n' +
    '                                        <span class="sr-only">20% Complete</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Bootstrap Admin Template</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">\n' +
    '                                        <span class="sr-only">60% Complete (warning)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Youtube Client App</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n' +
    '                                        <span class="sr-only">80% Complete (danger)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="clearfix"></div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tm-icon zmdi zmdi-more-vert"></i>\n' +
    '                </a>\n' +
    '                <ul class="dropdown-menu dm-icon pull-right">\n' +
    '                    <li class="skin-switch hidden-xs">\n' +
    '                        <span ng-repeat="w in mactrl.skinList | limitTo : 6" class="ss-skin bgm-{{ w }}" data-ng-click="mactrl.skinSwitch(w)"></span>\n' +
    '                    </li>\n' +
    '                    <li class="divider hidden-xs"></li>\n' +
    '                    <li class="hidden-xs">\n' +
    '                        <a data-ng-click="hctrl.fullScreen()" href=""><i class="zmdi zmdi-fullscreen"></i> Toggle Fullscreen</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a data-ng-click="hctrl.clearLocalStorage()" href=""><i class="zmdi zmdi-delete"></i> Clear Local Storage</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href=""><i class="zmdi zmdi-face"></i> Privacy Settings</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href=""><i class="zmdi zmdi-settings"></i> Other Settings</a>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '            </li>\n' +
    '            <li class="hidden-xs" data-target="chat" data-toggle-sidebar data-model-right="mactrl.sidebarToggle.right" data-ng-class="{ \'open\': mactrl.sidebarToggle.right === true }">\n' +
    '                <a href=""><i class="tm-icon zmdi zmdi-comment-alt-text"></i></a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '\n' +
    '<!-- Top Search Content -->\n' +
    '<div id="top-search-wrap">\n' +
    '    <div class="tsw-inner">\n' +
    '        <i id="top-search-close" class="zmdi zmdi-arrow-left" data-ng-click="hctrl.closeSearch()"></i>\n' +
    '        <input type="text">\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/header-top-menu.html',
    '<ul class="header-inner clearfix">\n' +
    '    <li id="menu-trigger" data-trigger=".ha-menu" class="visible-xs">\n' +
    '        <div class="line-wrap">\n' +
    '            <div class="line top"></div>\n' +
    '            <div class="line center"></div>\n' +
    '            <div class="line bottom"></div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="logo hidden-xs">\n' +
    '        <a data-ui-sref="home">Material Admin</a>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="pull-right">\n' +
    '        <ul class="top-menu">\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tmn-counts">6</i>\n' +
    '                    <i class="tm-icon zmdi zmdi-email"></i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Messages\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle>\n' +
    '                    <i class="tmn-counts">9</i>\n' +
    '                    <i class="tm-icon zmdi zmdi-notifications"></i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview" id="notifications">\n' +
    '                        <div class="lv-header">\n' +
    '                            Notification\n' +
    '\n' +
    '                            <ul class="actions">\n' +
    '                                <li class="dropdown">\n' +
    '                                    <a href="" data-clear="notification">\n' +
    '                                        <i class="zmdi zmdi-check-all"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View Previous</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tmn-counts">2</i>\n' +
    '                    <i class="tm-icon zmdi zmdi-view-list-alt"></i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu pull-right dropdown-menu-lg">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Tasks\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">HTML5 Validation Report</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style="width: 95%">\n' +
    '                                        <span class="sr-only">95% Complete (success)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Google Chrome Extension</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n' +
    '                                        <span class="sr-only">80% Complete (success)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Social Intranet Projects</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">\n' +
    '                                        <span class="sr-only">20% Complete</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Bootstrap Admin Template</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">\n' +
    '                                        <span class="sr-only">60% Complete (warning)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Youtube Client App</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n' +
    '                                        <span class="sr-only">80% Complete (danger)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href=""><i class="tm-icon zmdi zmdi-more-vert"></i></a>\n' +
    '                <ul class="dropdown-menu dm-icon pull-right">\n' +
    '                    <li class="hidden-xs">\n' +
    '                        <a data-ng-click="hctrl.fullScreen()" href=""><i class="zmdi zmdi-fullscreen"></i> Toggle Fullscreen</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a data-ng-click="hctrl.clearLocalStorage()" href=""><i class="zmdi zmdi-delete"></i> Clear Local Storage</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href=""><i class="zmdi zmdi-face"></i> Privacy Settings</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href=""><i class="zmdi zmdi-settings"></i> Other Settings</a>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '\n' +
    '<div class="search">\n' +
    '    <div class="fg-line">\n' +
    '        <input type="text" class="form-control" placeholder="Search...">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<nav class="ha-menu">\n' +
    '    <ul>\n' +
    '        <li class="waves-effect" data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="home" data-ng-click="mactrl.sidebarStat($event)">Home</a>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown data-ng-class="{ \'active\': mactrl.$state.includes(\'headers\') }">\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Headers</div>\n' +
    '\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active" ><a data-ui-sref="headers.textual-menu">Textual menu</a></li>\n' +
    '                <li data-ui-sref-active="active" ><a data-ui-sref="headers.image-logo">Image logo</a></li>\n' +
    '                <li data-ui-sref-active="active" ><a data-ui-sref="headers.mainmenu-on-top">Mainmenu on top</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="waves-effect" data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="typography">Typography</a>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Widgets</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="widgets.widget-templates">Templates</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="widgets.widgets">Widgets</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Tables</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="tables.tables">Normal Tables</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="tables.data-table">Data Tables</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Forms</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.basic-form-elements">Basic Form Elements</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.form-components">Form Components</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.form-examples">Form Examples</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.form-validations">Form Validation</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>User Interface</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.ui-bootstrap">UI Bootstrap</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.colors">Colors</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.animations">Animations</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.box-shadow">Box Shadow</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.buttons">Buttons</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.icons">Icons</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.alerts">Alerts</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.preloaders">Preloaders</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.notifications-dialogs">Notifications & Dialogs</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.media">Media</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.other-components">Others</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Charts</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="charts.flot-charts">Flot Charts</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="charts.other-charts">Other Charts</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="waves-effect" data-ui-sref-active="active"><a data-ui-sref="calendar">Calendar</a></li>\n' +
    '    </ul>\n' +
    '</nav>\n' +
    '\n' +
    '<div class="skin-switch dropdown hidden-xs" uib-dropdown>\n' +
    '    <button uib-dropdown-toggle class="btn ss-icon"><i class="zmdi zmdi-palette"></i></button>\n' +
    '    <div class="dropdown-menu">\n' +
    '        <span ng-repeat="w in mactrl.skinList" class="ss-skin bgm-{{ w }}" data-ng-click="mactrl.skinSwitch(w)"></span>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/header-textual-menu.html',
    '<ul class="header-inner clearfix">\n' +
    '    <li id="menu-trigger" data-target="mainmenu" data-toggle-sidebar data-model-left="mactrl.sidebarToggle.left" data-ng-class="{ \'open\': mactrl.sidebarToggle.left === true }">\n' +
    '        <div class="line-wrap">\n' +
    '            <div class="line top"></div>\n' +
    '            <div class="line center"></div>\n' +
    '            <div class="line bottom"></div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="logo hidden-xs">\n' +
    '        <a data-ui-sref="home" data-ng-click="mactrl.sidebarStat($event)">Material Admin</a>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="pull-right">\n' +
    '        <ul class="top-menu">\n' +
    '            <li id="top-search" data-ng-click="hctrl.openSearch()">\n' +
    '                <a href=""><span class="tm-label">Search</span></a>\n' +
    '            </li>\n' +
    '\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Messages</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Messages\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown hidden-xs" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Notification</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview" id="notifications">\n' +
    '                        <div class="lv-header">\n' +
    '                            Notification\n' +
    '\n' +
    '                            <ul class="actions">\n' +
    '                                <li class="dropdown">\n' +
    '                                    <a href="" data-clear="notification">\n' +
    '                                        <i class="zmdi zmdi-check-all"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View Previous</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="hidden-xs">\n' +
    '                <a target="_blank" href="https://wrapbootstrap.com/theme/superflat-simple-responsive-admin-theme-WB082P91H">\n' +
    '                    <span class="tm-label">Link</span>\n' +
    '                </a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '\n' +
    '\n' +
    '<!-- Top Search Content -->\n' +
    '<div id="top-search-wrap">\n' +
    '    <div class="tsw-inner">\n' +
    '        <i id="top-search-close" data-ng-click="hctrl.closeSearch()" class="zmdi zmdi-arrow-left"></i>\n' +
    '        <input type="text">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/header-image-logo.html',
    '<ul class="header-inner clearfix">\n' +
    '    <li id="menu-trigger" data-target="mainmenu" data-toggle-sidebar data-model-left="mactrl.sidebarToggle.left" data-ng-class="{ \'open\': mactrl.sidebarToggle.left === true }">\n' +
    '        <div class="line-wrap">\n' +
    '            <div class="line top"></div>\n' +
    '            <div class="line center"></div>\n' +
    '            <div class="line bottom"></div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="hidden-xs">\n' +
    '        <a href="index.html" class="m-l-10" data-ng-click="mactrl.sidebarStat($event)"><img src="img/demo/logo.png" alt=""></a>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="pull-right">\n' +
    '        <ul class="top-menu">\n' +
    '            <li id="top-search" data-ng-click="hctrl.openSearch()">\n' +
    '                <a href=""><span class="tm-label">Search</span></a>\n' +
    '            </li>\n' +
    '\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Messages</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Messages\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown hidden-xs" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Notification</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview" id="notifications">\n' +
    '                        <div class="lv-header">\n' +
    '                            Notification\n' +
    '\n' +
    '                            <ul class="actions">\n' +
    '                                <li class="dropdown">\n' +
    '                                    <a href="" data-clear="notification">\n' +
    '                                        <i class="zmdi zmdi-check-all"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View Previous</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="hidden-xs">\n' +
    '                <a target="_blank" href="https://wrapbootstrap.com/theme/superflat-simple-responsive-admin-theme-WB082P91H">\n' +
    '                    <span class="tm-label">Link</span>\n' +
    '                </a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '\n' +
    '\n' +
    '<!-- Top Search Content -->\n' +
    '<div id="top-search-wrap">\n' +
    '    <div class="tsw-inner">\n' +
    '        <i id="top-search-close" data-ng-click="hctrl.closeSearch()" class="zmdi zmdi-arrow-left"></i>\n' +
    '        <input type="text">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/footer.html',
    'Copyright &copy; 2015 Material Admin\n' +
    '\n' +
    '<ul class="f-menu">\n' +
    '    <li><a href="">Home</a></li>\n' +
    '    <li><a href="">Dashboard</a></li>\n' +
    '    <li><a href="">Reports</a></li>\n' +
    '    <li><a href="">Support</a></li>\n' +
    '    <li><a href="">Contact</a></li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template1/chat.html',
    '<div class="chat-search">\n' +
    '    <div class="fg-line">\n' +
    '        <input type="text" class="form-control" placeholder="Search People">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="listview">\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                <i class="chat-status-busy"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Jonathan Morris</div>\n' +
    '                <small class="lv-small">Available</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">David Belle</div>\n' +
    '                <small class="lv-small">Last seen 3 hours ago</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                <i class="chat-status-online"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                <small class="lv-small">Availble</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                <i class="chat-status-online"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Glenn Jecobs</div>\n' +
    '                <small class="lv-small">Availble</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/5.jpg" alt="">\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Bill Phillips</div>\n' +
    '                <small class="lv-small">Last seen 3 days ago</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/6.jpg" alt="">\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Wendy Mitchell</div>\n' +
    '                <small class="lv-small">Last seen 2 minutes ago</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/7.jpg" alt="">\n' +
    '                <i class="chat-status-busy"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Teena Bell Ann</div>\n' +
    '                <small class="lv-small">Busy</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/template.tpl.html',
    '<h2>template</h2>\n' +
    '<p>{{template.ctrlName}}</p>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/sidebar-left.html',
    '<div class="sidebar-inner c-overflow">    \n' +
    '    <div class="profile-menu">\n' +
    '        <a href="" toggle-submenu>\n' +
    '            <div class="profile-pic">\n' +
    '                <img src="img/profile-pics/1.jpg" alt="">\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="profile-info">\n' +
    '                Malinda Hollaway\n' +
    '\n' +
    '                <i class="zmdi zmdi-caret-down"></i>\n' +
    '            </div>\n' +
    '        </a>\n' +
    '\n' +
    '        <ul class="main-menu">\n' +
    '            <li>\n' +
    '                <a data-ui-sref="pages.profile.profile-about" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-account"></i> View Profile</a>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <a href=""><i class="zmdi zmdi-input-antenna"></i> Privacy Settings</a>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <a href=""><i class="zmdi zmdi-settings"></i> Settings</a>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <a href=""><i class="zmdi zmdi-time-restore"></i> Logout</a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '\n' +
    '    <ul class="main-menu">\n' +
    '        \n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="home" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-home"></i> Home</a>\n' +
    '        </li>\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'headers\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-view-compact"></i> Headers</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="headers.textual-menu" data-ng-click="mactrl.sidebarStat($event)">Textual menu</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="headers.image-logo" data-ng-click="mactrl.sidebarStat($event)">Image logo</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="headers.mainmenu-on-top" data-ng-click="mactrl.sidebarStat($event)">Mainmenu on top</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="typography" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-format-underlined"></i> Typography</a>\n' +
    '        </li>\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'widgets\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-widgets"></i> Widgets</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="widgets.widget-templates" data-ng-click="mactrl.sidebarStat($event)">Templates</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="widgets.widgets" data-ng-click="mactrl.sidebarStat($event)">Widgets</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        \n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'tables\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-view-list"></i> Tables</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="tables.tables" data-ng-click="mactrl.sidebarStat($event)">Tables</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="tables.data-table" data-ng-click="mactrl.sidebarStat($event)">Data Tables</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        \n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'form\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-collection-text"></i> Forms</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.basic-form-elements" data-ng-click="mactrl.sidebarStat($event)">Basic Form Elements</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.form-components" data-ng-click="mactrl.sidebarStat($event)">Form Components</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.form-examples" data-ng-click="mactrl.sidebarStat($event)">Form Examples</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="form.form-validations" data-ng-click="mactrl.sidebarStat($event)">Form Validation</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'user-interface\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-swap-alt"></i>User Interface</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.ui-bootstrap" data-ng-click="mactrl.sidebarStat($event)">UI Bootstrap</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.colors" data-ng-click="mactrl.sidebarStat($event)">Colors</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.animations" data-ng-click="mactrl.sidebarStat($event)">Animations</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.box-shadow" data-ng-click="mactrl.sidebarStat($event)">Box Shadow</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.buttons" data-ng-click="mactrl.sidebarStat($event)">Buttons</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.icons" data-ng-click="mactrl.sidebarStat($event)">Icons</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.alerts" data-ng-click="mactrl.sidebarStat($event)">Alerts</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.preloaders" data-ng-click="mactrl.sidebarStat($event)">Preloaders</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.notifications-dialogs" data-ng-click="mactrl.sidebarStat($event)">Notifications & Dialogs</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.media" data-ng-click="mactrl.sidebarStat($event)">Media</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="user-interface.other-components" data-ng-click="mactrl.sidebarStat($event)">Others</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'charts\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-trending-up"></i>Charts</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="charts.flot-charts" data-ng-click="mactrl.sidebarStat($event)">Flot Charts</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="charts.other-charts" data-ng-click="mactrl.sidebarStat($event)">Other Charts</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="calendar" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-calendar"></i> Calendar</a>\n' +
    '        </li>\n' +
    '        \n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'photo-gallery\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-image"></i>Photo Gallery</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="photo-gallery.photos" data-ng-click="mactrl.sidebarStat($event)">Default</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="photo-gallery.timeline" data-ng-click="mactrl.sidebarStat($event)">Timeline</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        \n' +
    '        <li data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="generic-classes" data-ng-click="mactrl.sidebarStat($event)"><i class="zmdi zmdi-layers"></i> Generic Classes</a>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="sub-menu" data-ng-class="{ \'active toggled\': mactrl.$state.includes(\'pages\') }">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-collection-item"></i> Sample Pages</a>\n' +
    '            <ul>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.profile.profile-about" data-ng-click="mactrl.sidebarStat($event)">Profile</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.listview" data-ng-click="mactrl.sidebarStat($event)">List View</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.messages" data-ng-click="mactrl.sidebarStat($event)">Messages</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.pricing-table" data-ng-click="mactrl.sidebarStat($event)">Pricing Table</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.contacts" data-ng-click="mactrl.sidebarStat($event)">Contacts</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.invoice" data-ng-click="mactrl.sidebarStat($event)">Invoice</a></li>\n' +
    '                <li><a data-ui-sref-active="active" data-ui-sref="pages.wall" data-ng-click="mactrl.sidebarStat($event)">Wall</a></li>\n' +
    '                <li><a href="login.html">Login and Sign Up</a></li>\n' +
    '                <li><a href="lockscreen.html">Lockscreen</a></li>\n' +
    '                <li><a href="404.html">Error 404</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="sub-menu">\n' +
    '            <a href="" toggle-submenu><i class="zmdi zmdi-menu"></i> 3 Level Menu</a>\n' +
    '\n' +
    '            <ul>\n' +
    '                <li><a href="">Level 2 link</a></li>\n' +
    '                <li><a href="">Another level 2 Link</a></li>\n' +
    '                <li class="sub-menu">\n' +
    '                    <a href="" toggle-submenu>I have children too</a>\n' +
    '\n' +
    '                    <ul>\n' +
    '                        <li><a href="">Level 3 link</a></li>\n' +
    '                        <li><a href="">Another Level 3 link</a></li>\n' +
    '                        <li><a href="">Third one</a></li>\n' +
    '                    </ul>\n' +
    '                </li>\n' +
    '                <li><a href="">One more 2</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li>\n' +
    '            <a href="https://wrapbootstrap.com/theme/material-admin-responsive-angularjs-WB011H985"><i class="zmdi zmdi-money"></i> Buy this template</a>\n' +
    '        </li>\n' +
    '    </ul>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/profile-menu.html',
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-about">About</a></li>\n' +
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-timeline">Timeline</a></li>\n' +
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-photos">Photos</a></li>\n' +
    '<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-connections">Connections</a></li>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/header.html',
    '<div class="main-header">\n' +
    '  <div class="p-l-20 p-r-20 hidden-xs">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-7 ">\n' +
    '        <ul class="nav navbar-nav">\n' +
    '          <li>\n' +
    '\n' +
    '            <span class="header-app-name"><span style="vertical-align:sub"><img data-ng-src="img/logo/AB_Logo.svg" alt="Addiko Bank"></span></span>\n' +
    '            <!--<img class="top-header-logo-img" src="img/hypo/hypobank_logo_grey@2x.png" height="25px" alt="" />-->\n' +
    '          </li>\n' +
    '          <li class="dropdown">\n' +
    '            <a class="dropdown-toggle language-select" data-toggle="dropdown" role="button" aria-haspopup="true"\n' +
    '               aria-expanded="false">{{hctrl.selectedLanguage.translate | translate}}\n' +
    '              <i class="zmdi zmdi-caret-down zmdi-hc-lg"></i></a>\n' +
    '            <ul class="dropdown-menu" ng-if="hctrl.countryCode !== \'bh\'">\n' +
    '              <li ng-repeat="language in hctrl.languageOptions">\n' +
    '                <a ng-click="hctrl.changeLanguage(language.code)">{{language.translate | translate}}</a>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '            <!-- in case of BiH show flags -->\n' +
    '            <ul class="dropdown-menu" ng-if="hctrl.countryCode === \'bh\'">\n' +
    '              <li ng-repeat="language in hctrl.languageOptions">\n' +
    '                <a ng-click="hctrl.changeLanguage(language.code)"><img ng-src="{{\'img/hypo/flags/\' + language.flag}}" height="35px" alt="" />{{language.translate | translate}}</a>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '\n' +
    '            <!-- end in case of BiH show flags -->\n' +
    '            <!--<ul class="dropdown-menu">\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'en\');"><img src="img/hypo/flags/en.png" height="35px" alt="" /> {{\'header.langEn\' | translate}}</a>\n' +
    '                </li>\n' +
    '                <li role="separator" class="divider"></li>\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'hr\');"><img src="img/hypo/flags/hr.png" height="35px" alt="" /> {{\'header.langHr\' | translate}}</a>\n' +
    '                </li>\n' +
    '                <li role="separator" class="divider"></li>\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'sr\');"><img src="img/hypo/flags/sr.png" height="35px" alt="" /> {{\'header.langSr\' | translate}}</a>\n' +
    '                </li>\n' +
    '                <li role="separator" class="divider"></li>\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'mtr\');"><img src="img/hypo/flags/mtr.png" height="35px" alt="" /> {{\'header.langMtr\' | translate}}</a>\n' +
    '                </li>\n' +
    '                <li role="separator" class="divider"></li>\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'ba\');"><img src="img/hypo/flags/ba.png" height="35px" alt="" /> {{\'header.langBa\' | translate}}</a>\n' +
    '                </li>\n' +
    '                <li role="separator" class="divider"></li>\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'sl\');"><img src="img/hypo/flags/sl.png" height="35px" alt="" /> {{\'header.langSl\' | translate}}</a>\n' +
    '                </li>\n' +
    '                <li role="separator" class="divider"></li>\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'de\');"><img src="img/hypo/flags/de.png" height="35px" alt="" /> {{\'header.langDe\' | translate}}</a>\n' +
    '                </li>\n' +
    '                <li role="separator" class="divider"></li>\n' +
    '                <li>\n' +
    '                    <a ng-click="hctrl.changeLanguage(\'ru\');"><img src="img/hypo/flags/ru.png" height="35px" alt="" /> {{\'header.langRu\' | translate}}</a>\n' +
    '                </li>\n' +
    '            </ul>-->\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-5">\n' +
    '        <div class="row custom-l-h-60">\n' +
    '            <span class="logout-link pull-right">\n' +
    '             <a href="" ng-click="hctrl.logOut()">\n' +
    '                <i class="icon icon-logout"></i>\n' +
    '             </a>\n' +
    '              <!--<a translate="header.logout"></a>-->\n' +
    '            </span>\n' +
    '            <span class="login-info-username pull-right m-r-10">\n' +
    '                {{APP_GLOBAL_SETTINGS.userSettings.firstName}} {{APP_GLOBAL_SETTINGS.userSettings.middleName}} {{APP_GLOBAL_SETTINGS.userSettings.lastName}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <!--            <div class="col-sm-4 notifications-wrapper">\n' +
    '                      <ul class="top-menu">\n' +
    '                          &lt;!&ndash;MESSAGES&ndash;&gt;\n' +
    '                          <li class="dropdown" uib-dropdown="" ng-click="hctrl.openMessagesNotificationLink();"><a uib-dropdown-toggle="" href="" class="dropdown-toggle" aria-haspopup="true" aria-expanded="false"><i class="tm-icon zmdi zmdi-comment-text-alt"></i> <i ng-if="hctrl.messagesList.result.length" class="tmn-counts  ">{{hctrl.messagesList.result.length}}</i></a>\n' +
    '                              <div class="dropdown-menu dropdown-menu-lg stop-propagate pull-left">\n' +
    '                                  <div class="listview">\n' +
    '                                      <div class="lv-header">{{\'header.notificationMessages\' | translate}}\n' +
    '                                      </div>\n' +
    '                                      <div class="t-a-c p-10" ng-if="hctrl.messagesList.result.length == 0">\n' +
    '                                        <i class="zmdi zmdi-cloud-off zmdi-hc-3x"></i>\n' +
    '                                        <h6 translate="header.noMessages"></h6>\n' +
    '                                      </div>\n' +
    '                                      <div class="lv-body mCustomScrollbar" data-mcs-theme="minimal-dark" ng-if="hctrl.messagesList.result.length > 0">\n' +
    '                                          <div class="list-group">\n' +
    '                                              <div ng-hide="hctrl.openReplySection" ng-repeat="message in hctrl.messagesList.result | limitTo:hctrl.numberOfMessagesToShow">\n' +
    '                                                  <a ng-class-even="\'even-list-item\'" class="list-group-item" ng-class="{\'animated flipOutX\':hctrl.messageMarkedAsReadId===message.id}">\n' +
    '                                                      <div class="m-b-10">\n' +
    '                                                          <span class="notification-message-date">{{message.creationDate| date:\'shortDate\'}}</span>\n' +
    '                                                          <span style="color:orange;" class="pull-right" translate="header.notificationMessagesUnread"></span>\n' +
    '                                                      </div>\n' +
    '                                                      <h4 class="list-group-item-heading">{{message.subject}}</h4>\n' +
    '                                                      <div class="list-group-item-text notification-message-body has-error" ng-bind-html="message.body"></div>\n' +
    '                                                      <div class="t-a-r m-t-10">\n' +
    '                                                          <button ng-hide="hctrl.openReplySection" type="input" class="btn btn-sm btn-default app-btn-blue" ng-click="hctrl.markMessageAsRead(message)">{{\'header.notificationMessagesMarkAsRead\' | translate}}</button>\n' +
    '                                                          <button ng-hide="hctrl.openReplySection" type="input" class="btn btn-sm btn-default app-btn-blue" ng-click="hctrl.openReplySectionAction($event,message)">{{\'header.notificationMessagesReply\' | translate}}</button>\n' +
    '\n' +
    '                                                      </div>\n' +
    '\n' +
    '                                                  </a>\n' +
    '                                              </div>\n' +
    '                                              <div ng-show="hctrl.openReplySection">\n' +
    '                                                  <a class="list-group-item">\n' +
    '                                                      <div class="m-b-10">\n' +
    '                                                          <span class="notification-message-date">{{hctrl.messageToShow.creationDate| date:\'shortDate\' }}</span>\n' +
    '                                                          <span style="color:orange;" class="pull-right" translate="header.notificationMessagesUnread"></span>\n' +
    '                                                      </div>\n' +
    '                                                      <h4 class="list-group-item-heading">{{hctrl.messageToShow.subject}}</h4>\n' +
    '                                                      <div class="list-group-item-text notification-message-body has-error" ng-bind-html="hctrl.messageToShow.body"></div>\n' +
    '                                                      <div class="m-t-10" ng-click="$event.preventDefault();" ng-class="{\'animated fadeInDown\': hctrl.openReplySection, \'animated zoomOutRight\': hctrl.messageSuccessfullySent}">\n' +
    '                                                          <form name="sendMessageForm" novalidate>\n' +
    '                                                              <input name="subject" required ng-model="hctrl.sendMessageObject.subject" type="text" class="form-control m-b-5" placeholder="{{\'header.notificationMessagesPlaceholderSubject\' | translate}}" ng-class="{\'b-c-error\': sendMessageForm.subject.$invalid}">\n' +
    '                                                              <textarea name="body" required ng-model="hctrl.sendMessageObject.body" class="form-control" ng-class="{\'b-c-error\': sendMessageForm.body.$invalid}" rows="3" placeholder="{{\'header.notificationMessagesPlaceholder\' | translate}}"></textarea>\n' +
    '                                                              <div class="t-a-r m-t-10">\n' +
    '                                                                  <button ng-show="hctrl.openReplySection" type="input" class="btn btn-sm btn-default app-btn-blue" ng-click="hctrl.cancelReply()" translate="header.notificationMessagesCancelSend"></button>\n' +
    '                                                                  <button ng-show="hctrl.openReplySection" type="input" class="btn btn-sm btn-default app-btn-blue" ng-click="hctrl.sendMessage($event)" ng-disabled="!sendMessageForm.$valid" translate="header.notificationMessagesSend"></button>\n' +
    '                                                              </div>\n' +
    '                                                          </form>\n' +
    '                                                      </div>\n' +
    '                                                  </a>\n' +
    '                                              </div>\n' +
    '                                          </div>\n' +
    '                                      </div>\n' +
    '                                      <div class="clearfix"></div><a class="lv-footer" href="">{{\'header.notificationMessagesViewAll\' | translate}}</a></div>\n' +
    '                                </div>\n' +
    '                          </li>\n' +
    '                          &lt;!&ndash;/MESSAGES&ndash;&gt;\n' +
    '                          &lt;!&ndash;E-INVOICES&ndash;&gt;\n' +
    '                        <li ng-if="hctrl.countryCode!=\'sr\'" class="dropdown" uib-dropdown=""><a uib-dropdown-toggle="" href="" class="dropdown-toggle" aria-haspopup="true" aria-expanded="false"><i class="tm-icon zmdi zmdi-file-text"></i> <i ng-if="hctrl.eInvoiceDocumentsList.result.length" class="tmn-counts ">{{hctrl.eInvoiceDocumentsList.result.length}}</i></a>\n' +
    '                          <div class="dropdown-menu dropdown-menu-lg stop-propagate pull-left">\n' +
    '                            <div class="listview">\n' +
    '                                      <div class="lv-header">{{\'header.notificationEInvoices\' | translate}}</div>\n' +
    '                                      <div class="t-a-c p-10" ng-if="hctrl.eInvoiceDocumentsList.result.length == 0">\n' +
    '                                        <i class="zmdi zmdi-cloud-off zmdi-hc-3x"></i>\n' +
    '                                        <h6 translate="header.noeInvoices"></h6>\n' +
    '                                      </div>\n' +
    '                                      <div class="lv-body mCustomScrollbar" data-mcs-theme="minimal-dark" ng-if="hctrl.eInvoiceDocumentsList.result.length > 0">\n' +
    '                                          <div class="list-group">\n' +
    '                                              <div ng-repeat="eInvoice in hctrl.eInvoiceDocumentsList.result | limitTo:10">\n' +
    '                                                  <a ng-class-even="\'even-list-item\'" class="list-group-item">\n' +
    '\n' +
    '                                                      <h4 class="list-group-item-heading">{{eInvoice.creditorName}}</h4>\n' +
    '                                                      <p class="list-group-item-text notification-einvoice-body">{{eInvoice.purpose}}</p>\n' +
    '                                                      <div class="m-t-10 m-b-10">\n' +
    '                                                          <span class="notification-einvoice-date">{{\'header.notificationEInvoicesDueDate\' | translate}}: <b>{{eInvoice.valueDate| date:\'shortDate\' }}</b></span>\n' +
    '                                                          <span class="notification-einvoice-amount pull-right"><b>{{eInvoice.amount|number:2}} {{eInvoice.currencySymbol}}</b></span>\n' +
    '                                                      </div>\n' +
    '                                                      <div class="t-a-r">\n' +
    '                                                          <button type="input" class="btn btn-sm btn-default app-btn-blue" ng-click="hctrl.openEInvoicesModal(eInvoice)">{{\'header.notificationEInvoicesPay\' | translate}}</button>\n' +
    '                                                      </div>\n' +
    '                                                  </a>\n' +
    '                                              </div>\n' +
    '                                          </div>\n' +
    '                                      </div>\n' +
    '                                      <div class="clearfix"></div><a class="lv-footer" data-ui-sref="eInvoices.einvoicesOverview">{{\'header.notificationEInvoicesViewAll\' | translate}}</a>\n' +
    '                                    </div>\n' +
    '                              </div>\n' +
    '                          </li>\n' +
    '                          &lt;!&ndash;/E-INVOICES&ndash;&gt;\n' +
    '                          &lt;!&ndash;PENDING PAYMENTS&ndash;&gt;\n' +
    '                          <li class="dropdown" uib-dropdown=""><a uib-dropdown-toggle="" href="" class="dropdown-toggle" aria-haspopup="true" aria-expanded="false"><i class="tm-icon zmdi zmdi-time-interval"></i> <i ng-if="hctrl.pendingPaymentsList.result.length" class="tmn-counts  ">{{hctrl.pendingPaymentsList.result.length}}</i></a>\n' +
    '                              <div class="dropdown-menu dropdown-menu-lg stop-propagate pull-left">\n' +
    '                                <div class="listview">\n' +
    '                                      <div class="lv-header bg-warning c-white f-14"><i class="zmdi zmdi-time-interval"></i> {{\'header.notificationPendingPayments\' | translate}}</div>\n' +
    '                                      <div class="t-a-c p-10" ng-if="hctrl.pendingPaymentsList.result.length == 0">\n' +
    '                                        <i class="zmdi zmdi-cloud-off zmdi-hc-3x"></i>\n' +
    '                                        <h6 translate="header.noPendingPayments"></h6>\n' +
    '                                      </div>\n' +
    '                                      <div class="lv-body mCustomScrollbar" data-mcs-theme="minimal-dark" ng-if="hctrl.pendingPaymentsList.result.length > 0">\n' +
    '                                          <div class="list-group">\n' +
    '                                              <div ng-repeat="pendingPayment in hctrl.pendingPaymentsList.result">\n' +
    '                                                  <a ng-class-even="\'even-list-item\'" class="list-group-item">\n' +
    '\n' +
    '                                                      <h4 class="list-group-item-heading">{{pendingPayment.receiverName}}</h4>\n' +
    '                                                      <p class="list-group-item-text notification-einvoice-body clickable-link">{{pendingPayment.purpose}}</p>\n' +
    '                                                      <div class="m-t-10 m-b-10">\n' +
    '                                                          <span class="notification-einvoice-date">{{\'header.notificationPendingPaymentsDateLabel\' | translate}}: <b>{{pendingPayment.dueDate| date:\'shortDate\' }}</b></span>\n' +
    '                                                          <span class="notification-einvoice-amount pull-right"><b>{{pendingPayment.amount|number:2}} {{pendingPayment.currencySymbol}}</b></span>\n' +
    '                                                      </div>\n' +
    '                                                  </a>\n' +
    '                                              </div>\n' +
    '                                          </div>\n' +
    '                                      </div>\n' +
    '                                      <div class="clearfix"></div><a class="lv-footer" data-ui-sref="payments">{{\'header.notificationPendingPaymentsViewAll\' | translate}}</a>\n' +
    '                                  </div>\n' +
    '                              </div>\n' +
    '                          </li>\n' +
    '                          &lt;!&ndash;/PENDING PAYMENTS&ndash;&gt;\n' +
    '                          &lt;!&ndash;REJECTED PAYMENTS&ndash;&gt;\n' +
    '                          <li class="dropdown" uib-dropdown=""><a uib-dropdown-toggle="" href="" class="dropdown-toggle" aria-haspopup="true" aria-expanded="false"><i class="tm-icon zmdi zmdi-alert-triangle"></i> <i ng-if="hctrl.rejectedPaymentsList.result.length" class="tmn-counts">{{hctrl.rejectedPaymentsList.result.length}}</i></a>\n' +
    '                              <div class="dropdown-menu dropdown-menu-lg stop-propagate pull-left">\n' +
    '                                  <div class="listview">\n' +
    '                                      <div class="lv-header bg-danger c-white f-14"><i class="zmdi zmdi-alert-triangle"></i> {{\'header.notificationRejectedPayments\' | translate}}</div>\n' +
    '                                      <div class="t-a-c p-10" ng-if="hctrl.rejectedPaymentsList.result.length == 0">\n' +
    '                                        <i class="zmdi zmdi-cloud-off zmdi-hc-3x"></i>\n' +
    '                                        <h6 translate="header.noRejectedPayments"></h6>\n' +
    '                                      </div>\n' +
    '                                      <div class="lv-body mCustomScrollbar" data-mcs-theme="minimal-dark" ng-if="hctrl.rejectedPaymentsList.result.length > 0">\n' +
    '                                          <div class="list-group">\n' +
    '                                              <div ng-repeat="rejectedPayment in hctrl.rejectedPaymentsList.result">\n' +
    '                                                  <a ng-class-even="\'even-list-item\'" class="list-group-item">\n' +
    '                                                      <h4 class="list-group-item-heading">{{rejectedPayment.receiverName}}</h4>\n' +
    '                                                      <p class="list-group-item-text notification-einvoice-body clickable-link">{{rejectedPayment.purpose}}</p>\n' +
    '                                                      <div class="m-t-10 m-b-10">\n' +
    '                                                        <span class="notification-einvoice-date">{{\'header.notificationRejectedPaymentsDateLabel\' | translate}}: <b>{{rejectedPayment.dueDate| date:\'shortDate\' }}</b></span>\n' +
    '                                                          <span class="notification-einvoice-amount pull-right"><b>{{rejectedPayment.amount|number:2}} {{rejectedPayment.currencySymbol}}</b></span>\n' +
    '                                                      </div>\n' +
    '                                                  </a>\n' +
    '                                              </div>\n' +
    '                                          </div>\n' +
    '                                      </div>\n' +
    '                                      <div class="clearfix"></div><a class="lv-footer" data-ui-sref="payments">{{\'header.notificationRejectedPaymentsViewAll\' | translate}}</a>\n' +
    '                                  </div>\n' +
    '                              </div>\n' +
    '                          </li>\n' +
    '                          &lt;!&ndash;/REJECTED PAYMENTS&ndash;&gt;\n' +
    '                          &lt;!&ndash;SETTINGS&ndash;&gt;\n' +
    '                          <li class="dropdown hidden-sm hidden-md hidden-lg" uib-dropdown="" is-open="hctrl.mobileSettingsDropdownIsOpen">\n' +
    '                              <a uib-dropdown-toggle="" href="" class="dropdown-toggle" aria-haspopup="true" aria-expanded="false">\n' +
    '                                  <i class="tm-icon zmdi zmdi-settings"></i>\n' +
    '                              </a>\n' +
    '                              <div class="dropdown-menu dropdown-menu-lg stop-propagate pull-left">\n' +
    '                                  <div class="listview">\n' +
    '                                      <div class="lv-header f-14"><i class="zmdi zmdi-settings"></i> Settings</div>\n' +
    '                                      <div class="lv-body mCustomScrollbar" data-mcs-theme="minimal-dark">\n' +
    '                                          <ul class="list-group">\n' +
    '                                              <li class="list-group-item">\n' +
    '                                                  <div>\n' +
    '                                                      <h4 class="login-info-username">{{\'header.signedInAs\' | translate}} {{hctrl.userSettings.result[0].firstName}} {{hctrl.userSettings.result[0].middleName}} {{hctrl.userSettings.result[0].lastName}}</h4>\n' +
    '                                                      <p class="last-login-info">{{\'header.lastLogin\' | translate}}: {{hctrl.getDate() | date:\'shortDate\'}}</p>\n' +
    '                                                  </div>\n' +
    '                                                  <br>\n' +
    '                                                  <div class="t-a-c">\n' +
    '                                                      <button style="width:100%" class="btn btn-default app-btn-blue btn-sm"><i class="zmdi zmdi-square-right"></i> {{\'header.logout\' | translate}}</button>\n' +
    '                                                  </div>\n' +
    '\n' +
    '                                              </li>\n' +
    '                                              <li class="list-group-item">\n' +
    '                                                  <p>Choose app language:</p>\n' +
    '                                                  <div class="list-group">\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'en\'); hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/en.png" height="20px" alt="" /> {{\'header.langEn\' | translate}}</a>\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'hr\');  hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/hr.png" height="20px" alt="" /> {{\'header.langHr\' | translate}}</a>\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'sr\');  hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/sr.png" height="20px" alt="" /> {{\'header.langSr\' | translate}}</a>\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'mtr\');  hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/mtr.png" height="20px" alt="" /> {{\'header.langMtr\' | translate}}</a>\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'ba\');  hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/ba.png" height="20px" alt="" /> {{\'header.langBa\' | translate}}</a>\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'sl\');  hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/sl.png" height="20px" alt="" /> {{\'header.langSl\' | translate}}</a>\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'de\');  hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/de.png" height="20px" alt="" /> {{\'header.langDe\' | translate}}</a>\n' +
    '                                                      <a class="list-group-item" ng-click="hctrl.changeLanguage(\'ru\');  hctrl.closeMobileSettingsDropdown();"><img src="img/hypo/flags/ru.png" height="20px" alt="" /> {{\'header.langRu\' | translate}}</a>\n' +
    '                                                  </div>\n' +
    '                                              </li>\n' +
    '                                          </ul>\n' +
    '                                      </div>\n' +
    '                                      <div class="clearfix"></div><a class="lv-footer" data-ui-sref="payments">View all settings</a></div>\n' +
    '                              </div>\n' +
    '                          </li>\n' +
    '                          &lt;!&ndash;/SETTINGS&ndash;&gt;\n' +
    '                      </ul>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-4 hidden-xs login-info-wrapper p-l-0 p-r-0">\n' +
    '                      <img style="float:right;" src="img/hypo/illustration.png" height="60px" alt="" class="hidden-sm hidden-xs" />\n' +
    '                      <div>\n' +
    '                          <h4 class="login-info-username">{{\'header.signedInAs\' | translate}} {{hctrl.userSettings.result[0].firstName}} {{hctrl.userSettings.result[0].middleName}} {{hctrl.userSettings.result[0].lastName}} - <span class="logout-link"><a href="">{{\'header.logout\' | translate}}</a></span></h4>\n' +
    '                          <p class="last-login-info">{{\'header.lastLogin\' | translate}}: {{hctrl.getDate() | date:\'shortDate\'}}</p>\n' +
    '                      </div>\n' +
    '\n' +
    '                  </div>-->\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="visible-xs">\n' +
    '    <span class="header-app-name pull-right p-r-20"><span style="vertical-align:sub"><img data-ng-src="img/logo/AB_Logo.svg" alt="Addiko Bank"></span></span>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<!--<nav id="appHeader" class="navbar navbar-default">\n' +
    '    <div class="container">\n' +
    '        &lt;!&ndash; Brand and toggle get grouped for better mobile display &ndash;&gt;\n' +
    '        <div class="navbar-header">\n' +
    '            <button id="mobileMenuBtn" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-hypo-navbar-collapse-1" aria-expanded="true">\n' +
    '                <span class="sr-only">Toggle navigation</span>\n' +
    '                <span class="icon-bar"></span>\n' +
    '                <span class="icon-bar"></span>\n' +
    '                <span class="icon-bar"></span>\n' +
    '            </button>\n' +
    '            <a class="navbar-brand visible-xs hidden-sm hidden-md hidden-lg"><img id="brandImg" src="img/hypo/hypobank_logo_grey@2x.png" height="40px" alt="" /></a>\n' +
    '            &lt;!&ndash;<span class="header-label-on-phone hidden-sm hidden-md hidden-lg">Dashboard</span>&ndash;&gt;\n' +
    '        </div>\n' +
    '        &lt;!&ndash; Collect the nav links, forms, and other content for toggling &ndash;&gt;\n' +
    '        <div class="collapse navbar-collapse" id="bs-hypo-navbar-collapse-1">\n' +
    '            <ul class="nav navbar-nav" ng-init="menuSelected=1">\n' +
    '                <li class="app-header-custom-li">\n' +
    '                    <div ng-click="hctrl.closeMobileMenu(\'mobileMenuBtn\')" class="app-header-menu-div" data-ui-sref="dashboard" data-ui-sref-active="selected toggled"><a href="">{{\'header.dashboard\' | translate}}</a></div>\n' +
    '                </li>\n' +
    '              <li>\n' +
    '              </li>\n' +
    '                <li class="app-header-custom-li">\n' +
    '                    <div ng-click="hctrl.closeMobileMenu(\'mobileMenuBtn\')" class="app-header-menu-div" data-ui-sref="accounts" data-ng-class="{ \'selected toggled\': hctrl.isModuleActive(\'accounts\') }"><a href="">{{\'header.accounts\' | translate}}</a></div>\n' +
    '                </li>\n' +
    '                <li class="app-header-custom-li">\n' +
    '                    <div ng-click="hctrl.closeMobileMenu(\'mobileMenuBtn\')" class="app-header-menu-div" data-ui-sref="payments" data-ui-sref-active="selected toggled" ng-class="{selected: menuSelected == 3}"><a href="">{{\'header.payments\' | translate}}</a></div>\n' +
    '                </li>\n' +
    '                <li class="app-header-custom-li">\n' +
    '                    <div ng-click="hctrl.closeMobileMenu(\'mobileMenuBtn\')" class="app-header-menu-div" data-ui-sref="orders" data-ui-sref-active="selected toggled"><a href="">{{\'header.orders\' | translate}}</a></div>\n' +
    '                </li>\n' +
    '                <li class="app-header-custom-li">\n' +
    '                    <div ng-click="hctrl.closeMobileMenu(\'mobileMenuBtn\')" class="app-header-menu-div" data-ui-sref="branches" data-ui-sref-active="selected toggled" ng-class="{selected: menuSelected == 4}"><a href="">{{\'header.branches\' | translate}}</a></div>\n' +
    '                </li>\n' +
    '                <li class="app-header-custom-li">\n' +
    '                    <div ng-click="hctrl.closeMobileMenu(\'mobileMenuBtn\')" class="app-header-menu-div" data-ui-sref="settings" data-ui-sref-active="selected toggled" ng-class="{selected: menuSelected == 4}"><a href="">{{\'header.settings\' | translate}}</a></div>\n' +
    '                </li>\n' +
    '\n' +
    '            </ul>\n' +
    '        </div>\n' +
    '        &lt;!&ndash; /.navbar-collapse &ndash;&gt;\n' +
    '    </div>\n' +
    '\n' +
    '    &lt;!&ndash; /.container-fluid &ndash;&gt;\n' +
    '</nav>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/header-top-menu.html',
    '<ul class="header-inner clearfix">\n' +
    '    <li id="menu-trigger" data-trigger=".ha-menu" class="visible-xs">\n' +
    '        <div class="line-wrap">\n' +
    '            <div class="line top"></div>\n' +
    '            <div class="line center"></div>\n' +
    '            <div class="line bottom"></div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="logo hidden-xs">\n' +
    '        <a data-ui-sref="home">Material Admin</a>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="pull-right">\n' +
    '        <ul class="top-menu">\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tmn-counts">6</i>\n' +
    '                    <i class="tm-icon zmdi zmdi-email"></i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Messages\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle>\n' +
    '                    <i class="tmn-counts">9</i>\n' +
    '                    <i class="tm-icon zmdi zmdi-notifications"></i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview" id="notifications">\n' +
    '                        <div class="lv-header">\n' +
    '                            Notification\n' +
    '\n' +
    '                            <ul class="actions">\n' +
    '                                <li class="dropdown">\n' +
    '                                    <a href="" data-clear="notification">\n' +
    '                                        <i class="zmdi zmdi-check-all"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View Previous</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <i class="tmn-counts">2</i>\n' +
    '                    <i class="tm-icon zmdi zmdi-view-list-alt"></i>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu pull-right dropdown-menu-lg">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Tasks\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">HTML5 Validation Report</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style="width: 95%">\n' +
    '                                        <span class="sr-only">95% Complete (success)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Google Chrome Extension</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n' +
    '                                        <span class="sr-only">80% Complete (success)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Social Intranet Projects</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">\n' +
    '                                        <span class="sr-only">20% Complete</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Bootstrap Admin Template</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">\n' +
    '                                        <span class="sr-only">60% Complete (warning)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="lv-item">\n' +
    '                                <div class="lv-title m-b-5">Youtube Client App</div>\n' +
    '\n' +
    '                                <div class="progress">\n' +
    '                                    <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n' +
    '                                        <span class="sr-only">80% Complete (danger)</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href=""><i class="tm-icon zmdi zmdi-more-vert"></i></a>\n' +
    '                <ul class="dropdown-menu dm-icon pull-right">\n' +
    '                    <li class="hidden-xs">\n' +
    '                        <a data-ng-click="hctrl.fullScreen()" href=""><i class="zmdi zmdi-fullscreen"></i> Toggle Fullscreen</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a data-ng-click="hctrl.clearLocalStorage()" href=""><i class="zmdi zmdi-delete"></i> Clear Local Storage</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href=""><i class="zmdi zmdi-face"></i> Privacy Settings</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href=""><i class="zmdi zmdi-settings"></i> Other Settings</a>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '\n' +
    '<div class="search">\n' +
    '    <div class="fg-line">\n' +
    '        <input type="text" class="form-control" placeholder="Search...">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<nav class="ha-menu">\n' +
    '    <ul>\n' +
    '        <li class="waves-effect" data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="home" data-ng-click="mactrl.sidebarStat($event)">Home</a>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown data-ng-class="{ \'active\': mactrl.$state.includes(\'headers\') }">\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Headers</div>\n' +
    '\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active" ><a data-ui-sref="headers.textual-menu">Textual menu</a></li>\n' +
    '                <li data-ui-sref-active="active" ><a data-ui-sref="headers.image-logo">Image logo</a></li>\n' +
    '                <li data-ui-sref-active="active" ><a data-ui-sref="headers.mainmenu-on-top">Mainmenu on top</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="waves-effect" data-ui-sref-active="active">\n' +
    '            <a data-ui-sref="typography">Typography</a>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Widgets</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="widgets.widget-templates">Templates</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="widgets.widgets">Widgets</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Tables</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="tables.tables">Normal Tables</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="tables.data-table">Data Tables</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Forms</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.basic-form-elements">Basic Form Elements</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.form-components">Form Components</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.form-examples">Form Examples</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="form.form-validations">Form Validation</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>User Interface</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.ui-bootstrap">UI Bootstrap</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.colors">Colors</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.animations">Animations</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.box-shadow">Box Shadow</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.buttons">Buttons</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.icons">Icons</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.alerts">Alerts</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.preloaders">Preloaders</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.notifications-dialogs">Notifications & Dialogs</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.media">Media</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="user-interface.other-components">Others</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="dropdown" uib-dropdown>\n' +
    '            <div class="waves-effect" uib-dropdown-toggle>Charts</div>\n' +
    '            <ul class="dropdown-menu">\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="charts.flot-charts">Flot Charts</a></li>\n' +
    '                <li data-ui-sref-active="active"><a data-ui-sref="charts.other-charts">Other Charts</a></li>\n' +
    '            </ul>\n' +
    '        </li>\n' +
    '        <li class="waves-effect" data-ui-sref-active="active"><a data-ui-sref="calendar">Calendar</a></li>\n' +
    '    </ul>\n' +
    '</nav>\n' +
    '\n' +
    '<div class="skin-switch dropdown hidden-xs" uib-dropdown>\n' +
    '    <button uib-dropdown-toggle class="btn ss-icon"><i class="zmdi zmdi-palette"></i></button>\n' +
    '    <div class="dropdown-menu">\n' +
    '        <span ng-repeat="w in mactrl.skinList" class="ss-skin bgm-{{ w }}" data-ng-click="mactrl.skinSwitch(w)"></span>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/header-textual-menu.html',
    '<ul class="header-inner clearfix">\n' +
    '    <li id="menu-trigger" data-target="mainmenu" data-toggle-sidebar data-model-left="mactrl.sidebarToggle.left" data-ng-class="{ \'open\': mactrl.sidebarToggle.left === true }">\n' +
    '        <div class="line-wrap">\n' +
    '            <div class="line top"></div>\n' +
    '            <div class="line center"></div>\n' +
    '            <div class="line bottom"></div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="logo hidden-xs">\n' +
    '        <a data-ui-sref="home" data-ng-click="mactrl.sidebarStat($event)">Material Admin</a>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="pull-right">\n' +
    '        <ul class="top-menu">\n' +
    '            <li id="top-search" data-ng-click="hctrl.openSearch()">\n' +
    '                <a href=""><span class="tm-label">Search</span></a>\n' +
    '            </li>\n' +
    '\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Messages</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Messages\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown hidden-xs" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Notification</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview" id="notifications">\n' +
    '                        <div class="lv-header">\n' +
    '                            Notification\n' +
    '\n' +
    '                            <ul class="actions">\n' +
    '                                <li class="dropdown">\n' +
    '                                    <a href="" data-clear="notification">\n' +
    '                                        <i class="zmdi zmdi-check-all"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View Previous</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="hidden-xs">\n' +
    '                <a target="_blank" href="https://wrapbootstrap.com/theme/superflat-simple-responsive-admin-theme-WB082P91H">\n' +
    '                    <span class="tm-label">Link</span>\n' +
    '                </a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '\n' +
    '\n' +
    '<!-- Top Search Content -->\n' +
    '<div id="top-search-wrap">\n' +
    '    <div class="tsw-inner">\n' +
    '        <i id="top-search-close" data-ng-click="hctrl.closeSearch()" class="zmdi zmdi-arrow-left"></i>\n' +
    '        <input type="text">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/header-image-logo.html',
    '<ul class="header-inner clearfix">\n' +
    '    <li id="menu-trigger" data-target="mainmenu" data-toggle-sidebar data-model-left="mactrl.sidebarToggle.left" data-ng-class="{ \'open\': mactrl.sidebarToggle.left === true }">\n' +
    '        <div class="line-wrap">\n' +
    '            <div class="line top"></div>\n' +
    '            <div class="line center"></div>\n' +
    '            <div class="line bottom"></div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="hidden-xs">\n' +
    '        <a href="index.html" class="m-l-10" data-ng-click="mactrl.sidebarStat($event)"><img src="img/demo/logo.png" alt=""></a>\n' +
    '    </li>\n' +
    '\n' +
    '    <li class="pull-right">\n' +
    '        <ul class="top-menu">\n' +
    '            <li id="top-search" data-ng-click="hctrl.openSearch()">\n' +
    '                <a href=""><span class="tm-label">Search</span></a>\n' +
    '            </li>\n' +
    '\n' +
    '            <li class="dropdown" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Messages</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview">\n' +
    '                        <div class="lv-header">\n' +
    '                            Messages\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '                        <a class="lv-footer" href="">View All</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="dropdown hidden-xs" uib-dropdown>\n' +
    '                <a uib-dropdown-toggle href="">\n' +
    '                    <span class="tm-label">Notification</span>\n' +
    '                </a>\n' +
    '                <div class="dropdown-menu dropdown-menu-lg pull-right">\n' +
    '                    <div class="listview" id="notifications">\n' +
    '                        <div class="lv-header">\n' +
    '                            Notification\n' +
    '\n' +
    '                            <ul class="actions">\n' +
    '                                <li class="dropdown">\n' +
    '                                    <a href="" data-clear="notification">\n' +
    '                                        <i class="zmdi zmdi-check-all"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="lv-body">\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">David Belle</div>\n' +
    '                                        <small class="lv-small">Cum sociis natoque penatibus et magnis dis parturient montes</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Jonathan Morris</div>\n' +
    '                                        <small class="lv-small">Nunc quis diam diamurabitur at dolor elementum, dictum turpis vel</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                                        <small class="lv-small">Phasellus a ante et est ornare accumsan at vel magnauis blandit turpis at augue ultricies</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Glenn Jecobs</div>\n' +
    '                                        <small class="lv-small">Ut vitae lacus sem ellentesque maximus, nunc sit amet varius dignissim, dui est consectetur neque</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                            <a class="lv-item" href="">\n' +
    '                                <div class="media">\n' +
    '                                    <div class="pull-left">\n' +
    '                                        <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body">\n' +
    '                                        <div class="lv-title">Bill Phillips</div>\n' +
    '                                        <small class="lv-small">Proin laoreet commodo eros id faucibus. Donec ligula quam, imperdiet vel ante placerat</small>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <a class="lv-footer" href="">View Previous</a>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </li>\n' +
    '            <li class="hidden-xs">\n' +
    '                <a target="_blank" href="https://wrapbootstrap.com/theme/superflat-simple-responsive-admin-theme-WB082P91H">\n' +
    '                    <span class="tm-label">Link</span>\n' +
    '                </a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '\n' +
    '\n' +
    '<!-- Top Search Content -->\n' +
    '<div id="top-search-wrap">\n' +
    '    <div class="tsw-inner">\n' +
    '        <i id="top-search-close" data-ng-click="hctrl.closeSearch()" class="zmdi zmdi-arrow-left"></i>\n' +
    '        <input type="text">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/footer.html',
    '<div class="container-fluid hidden-xs">\n' +
    '  <div class="row footer-row">\n' +
    '<div class="row">\n' +
    '  <div class="col-md-3 hidden-xs hidden-sm">\n' +
    '    <span class="footer-app-name"><span ><img data-ng-src="img/logo/AB_Logo.svg" style="width: 90%;" alt="Addiko Bank"></span></span><br>\n' +
    '  </div>\n' +
    '  <div class="footer-item col-sm-4 col-md-3 p-b-15" ng-if="footer.countryCode === \'hr\'">\n' +
    '    <div class="pull-left">\n' +
    '      <i class="icon icon-club footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left">\n' +
    '      <a ng-href="{{footer.clubLink}}" target="_blank"><p class="footer-item-text pointer" translate="navigation.hypoClub"></p></a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="footer-item col-sm-4 col-md-3 p-b-15" ng-if="footer.countryCode === \'hr\'">\n' +
    '    <div class="pull-left">\n' +
    '      <i class="icon icon-etrade footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left">\n' +
    '      <a ng-href="{{footer.eTradeLink}}" target="_blank"><p class="footer-item-text pointer" translate="navigation.eTrade"></p></a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="footer-item col-sm-4 col-md-3 p-b-15" ng-if="footer.countryCode === \'hr\'">\n' +
    '    <div class="pull-left">\n' +
    '      <i class="icon icon-chat footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left">\n' +
    '      <p class="footer-item-text pointer" translate="footer.notificationDepth" ng-click="footer.openModal()"></p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-if="footer.countryCode === \'mne\'" class="footer-item col-sm-4 col-md-3">\n' +
    '    <div class="pull-left">\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="pull-left">\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="footer-item col-sm-4 col-md-3">\n' +
    '    <div class="pull-left">\n' +
    '      <i class="icon icon-freecall footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left">\n' +
    '      <p ng-if="footer.countryCode != \'bh\'" class="footer-item-text" translate="footer.freeCall"></p>\n' +
    '      <p ng-if="footer.countryCode === \'bh\'" class="footer-item-text" translate="footer.freeCallBh"></p>\n' +
    '      <p class="footer-item-number">{{::footer.configData.LocalCall}}</p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="footer.countryCode === \'hr\'" class="footer-item col-sm-4 col-md-3">\n' +
    '    <div class="pull-left">\n' +
    '      <i class="icon icon-contact footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div  class="pull-left">\n' +
    '      <p class="footer-item-text" translate="footer.internationalCall"></p>\n' +
    '      <p class="footer-item-number">{{::footer.configData.InternationalCall}}</p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="footer-item col-sm-4 col-md-3">\n' +
    '    <div class="pull-left">\n' +
    '      <i class="icon icon-message footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left">\n' +
    '      <p class="footer-item-text" translate="footer.email"></p>\n' +
    '      <p class="footer-item-number" ng-click="footer.pushGtmEmailEvent();"><a href="mailto:{{::footer.configData.infoEmail}}">{{::footer.configData.infoEmail}}</a></p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="footer-item col-sm-8 col-md-6" ng-if="footer.countryCode !== \'hr\'"></div>\n' +
    '  <div class="footer-item col-sm-8 col-md-9" ng-if="footer.countryCode === \'hr\'"></div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="footer-item col-xs-6 pull-right m-r-30">\n' +
    '        <span ng-if="footer.appVersion" class="footer-item-number pull-right f-13 p-l-30"><span ng-if="APP_GLOBAL_SETTINGS.defaultData.IsTest">TEST </span><span translate="footer.version">Version:</span> {{footer.appVersion}}<span>.</span>{{footer.serverVersion}}</span>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<div class="clearfix visible-xs footer-container">\n' +
    '  <div class="col-xs-12 footer-item-wrapper" ng-if="footer.countryCode === \'hr\'">\n' +
    '    <div class="pull-left col-xs-2">\n' +
    '      <i class="icon icon-club footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left col-xs-10">\n' +
    '      <a ng-href="{{footer.clubLink}}" target="_blank"><p class="footer-item-text pointer" translate="navigation.hypoClub"></p></a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 footer-item-wrapper" ng-if="footer.countryCode === \'hr\'">\n' +
    '    <div class="pull-left col-xs-2">\n' +
    '      <i class="icon icon-etrade footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left col-xs-10">\n' +
    '      <a ng-href="{{footer.eTradeLink}}" target="_blank"><p class="footer-item-text pointer" translate="navigation.eTrade"></p></a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 footer-item-wrapper" ng-if="footer.countryCode === \'hr\'">\n' +
    '    <div class="pull-left col-xs-2">\n' +
    '      <i class="icon icon-chat footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left col-xs-10">\n' +
    '      <p class="footer-item-text pointer" translate="footer.notificationDepth" ng-click="footer.openModal()"></p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="col-xs-12 footer-item-wrapper">\n' +
    '    <div class="pull-left col-xs-2">\n' +
    '      <i class="icon icon-freecall footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left col-xs-10">\n' +
    '      <p ng-if="footer.countryCode != \'bh\'" class="footer-item-text" translate="footer.freeCall"></p>\n' +
    '      <p ng-if="footer.countryCode === \'bh\'" class="footer-item-text" translate="footer.freeCallBh"></p>\n' +
    '      <p class="footer-item-number">{{::footer.configData.LocalCall}}</p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="footer.countryCode === \'hr\'" class="col-xs-12 footer-item-wrapper">\n' +
    '    <div class="pull-left col-xs-2">\n' +
    '      <i class="icon icon-contact footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div  class="pull-left col-xs-10">\n' +
    '      <p class="footer-item-text" translate="footer.internationalCall"></p>\n' +
    '      <p class="footer-item-number">{{::footer.configData.InternationalCall}}</p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 footer-item-wrapper">\n' +
    '    <div class="pull-left col-xs-2">\n' +
    '      <i class="icon icon-message footer-icon"></i>\n' +
    '    </div>\n' +
    '    <div class="pull-left col-xs-10">\n' +
    '      <p class="footer-item-text" translate="footer.email"></p>\n' +
    '      <p class="footer-item-number"><a href="mailto:{{::footer.configData.infoEmail}}">{{::footer.configData.infoEmail}}</a></p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 footer-item-wrapper">\n' +
    '    <div class="pull-left col-xs-2">\n' +
    '    </div>\n' +
    '    <div class="pull-left col-xs-10">\n' +
    '      <p class="footer-item-text" ng-if="APP_GLOBAL_SETTINGS.defaultData.IsTest">TEST</p>\n' +
    '      <p class="footer-item-text" translate="footer.version"></p>\n' +
    '      <p class="footer-item-number">{{footer.appVersion}}</p>\n' +
    '      <p class="footer-item-text" translate="footer.server"></p>\n' +
    '      <p class="footer-item-number">{{footer.serverVersion}}</p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/footer-hypo.html',
    'Copyright &copy; 2015 Material Admin\n' +
    '\n' +
    '<ul class="f-menu">\n' +
    '    <li><a href="">Home</a></li>\n' +
    '    <li><a href="">Dashboard</a></li>\n' +
    '    <li><a href="">Reports</a></li>\n' +
    '    <li><a href="">Support</a></li>\n' +
    '    <li><a href="">Contact</a></li>\n' +
    '</ul>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/chat.html',
    '<div class="chat-search">\n' +
    '    <div class="fg-line">\n' +
    '        <input type="text" class="form-control" placeholder="Search People">\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="listview">\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/2.jpg" alt="">\n' +
    '                <i class="chat-status-busy"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Jonathan Morris</div>\n' +
    '                <small class="lv-small">Available</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/1.jpg" alt="">\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">David Belle</div>\n' +
    '                <small class="lv-small">Last seen 3 hours ago</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/3.jpg" alt="">\n' +
    '                <i class="chat-status-online"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Fredric Mitchell Jr.</div>\n' +
    '                <small class="lv-small">Availble</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/4.jpg" alt="">\n' +
    '                <i class="chat-status-online"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Glenn Jecobs</div>\n' +
    '                <small class="lv-small">Availble</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/5.jpg" alt="">\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Bill Phillips</div>\n' +
    '                <small class="lv-small">Last seen 3 days ago</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/6.jpg" alt="">\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Wendy Mitchell</div>\n' +
    '                <small class="lv-small">Last seen 2 minutes ago</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '    <a class="lv-item" href="">\n' +
    '        <div class="media">\n' +
    '            <div class="pull-left p-relative">\n' +
    '                <img class="lv-img-sm" src="img/profile-pics/7.jpg" alt="">\n' +
    '                <i class="chat-status-busy"></i>\n' +
    '            </div>\n' +
    '            <div class="media-body">\n' +
    '                <div class="lv-title">Teena Bell Ann</div>\n' +
    '                <small class="lv-small">Busy</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </a>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('statements/statements.tpl.html',
    '<h2>statements</h2>\n' +
    '<p>{{statements.ctrlName}}</p>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('settings/sms-and-notification-modal.tpl.html',
    '<div>\n' +
    '  <div ng-if="smsAndNotificationModal.step != 3" class="modal-header smsModalHeader">\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-12">{{smsAndNotificationModal.object.orderObject.description}}</div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '  <div class="p-t-20" ng-if="smsAndNotificationModal.step == 1">\n' +
    '    <ng-form name="smsAndNotificationModal.smsAndNotifForm">\n' +
    '\n' +
    '\n' +
    '    <div class="modal-body">\n' +
    '      <!-- FOR ACCOUNT / NAME -->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label ng-if="!smsAndNotificationModal.object.accountBased" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.user"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.accountBased" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.forAccount"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="!smsAndNotificationModal.object.accountBased" class="domp-form-label-resume">{{smsAndNotificationModal.object.user.firstName}} {{smsAndNotificationModal.object.user.lastName}}</label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.accountBased" class="domp-form-label-resume">{{smsAndNotificationModal.object.account.iban | formatIban}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- FOR ACCOUNT / NAME END -->\n' +
    '\n' +
    '      <!--ORDER DESC-->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label class="domp-form-label-review" translate="settings.smsModal.orderDesc"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="!smsAndNotificationModal.object.value && smsAndNotificationModal.object.type == \'SMS\'"\n' +
    '                   class="domp-form-label-resume" translate="settings.smsModal.receivingSmsStart"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.value  && smsAndNotificationModal.object.type == \'SMS\'" class="domp-form-label-resume"\n' +
    '                   translate="settings.smsModal.receivingSmsStop"></label>\n' +
    '            <label ng-if="!smsAndNotificationModal.object.value  && smsAndNotificationModal.object.type == \'EMAIL\'"\n' +
    '                   class="domp-form-label-resume" translate="settings.smsModal.receivingEmailStart"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.value  && smsAndNotificationModal.object.type == \'EMAIL\'" class="domp-form-label-resume"\n' +
    '                   translate="settings.smsModal.receivingEmailStop"></label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--ORDER DESC END-->\n' +
    '\n' +
    '      <!--MOBILE PHONE / SMS-->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'EMAIL\'" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.email"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'SMS\'" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.gsm"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'EMAIL\'" class="domp-form-label-resume">{{smsAndNotificationModal.object.user.notificationEmail}}</label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'SMS\'" class="domp-form-label-resume">{{smsAndNotificationModal.object.user.gsm}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--MOBILE PHONE / SMS END-->\n' +
    '\n' +
    '      <!-- ADDITIONAL (for specific order id == 30)-->\n' +
    '      <!--PERIOD & AMOUNT-->\n' +
    '      <div ng-if="(smsAndNotificationModal.object.orderObject.subOrderId == \'30\') ">\n' +
    '        <div  class="row p-b-10">\n' +
    '          <div class="col-xs-12">\n' +
    '            <div class="col-xs-12  col-sm-4 p-t-10">\n' +
    '              <label class="domp-form-label-review" translate="settings.smsModal.period"></label>\n' +
    '            </div>\n' +
    '            <div ng-if="!smsAndNotificationModal.object.value" class="col-xs-12 col-sm-6">\n' +
    '              <div class="row m-t-10 m-b-10">\n' +
    '                <div class="col-xs-6 col-sm-4">\n' +
    '                  <input type="radio" name="optradio" ng-model="smsAndNotificationModal.periodType" ng-value="smsAndNotificationModal.periods.periodTypes[0]">\n' +
    '                  <span translate="settings.smsModal.daily"></span></div>\n' +
    '                <div class="col-xs-6 col-sm-8"></div>\n' +
    '              </div>\n' +
    '              <div class="row m-t-10 m-b-10">\n' +
    '                <div class="col-xs-6 col-sm-4 p-t-10">\n' +
    '                  <input type="radio" name="optradio" ng-model="smsAndNotificationModal.periodType"  ng-value="smsAndNotificationModal.periods.periodTypes[2]">\n' +
    '                  <span translate="settings.smsModal.weekly"></span></div>\n' +
    '                <div class="col-xs-6 col-sm-8">\n' +
    '                  <select ng-disabled="smsAndNotificationModal.periodType.id != \'W\'" name="weeklyTimePeriod"\n' +
    '                          class="form-control input-field p-l-15 p-r-10"\n' +
    '                          ng-options="option.description | translate for option in smsAndNotificationModal.periods.weeklyTimePeriods"\n' +
    '                          ng-model="smsAndNotificationModal.weeklyTimePeriod">\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row m-t-10 m-b-10">\n' +
    '                <div class="col-xs-6 col-sm-4 p-t-10">\n' +
    '                  <input type="radio" name="optradio" ng-model="smsAndNotificationModal.periodType"  ng-value="smsAndNotificationModal.periods.periodTypes[1]">\n' +
    '                  <span translate="settings.smsModal.monthly"></span></div>\n' +
    '                <div class="col-xs-6 col-sm-8">\n' +
    '                  <select ng-disabled="smsAndNotificationModal.periodType.id != \'M\'" name="monthlyTimePeriod"\n' +
    '                                              class="form-control input-field p-l-15 p-r-10"\n' +
    '                                              ng-options="option.description for option in smsAndNotificationModal.periods.monthlyTimePeriods"\n' +
    '                                              ng-model="smsAndNotificationModal.monthlyTimePeriod">\n' +
    '                </select></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="smsAndNotificationModal.object.value" class="col-xs-12 col-sm-6 p-t-10">\n' +
    '              <label class="domp-form-label-resume">{{smsAndNotificationModal.periodType.description | translate}}<span ng-if="smsAndNotificationModal.period">, {{smsAndNotificationModal.period.description}}</span></label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row p-b-10">\n' +
    '          <div class="col-xs-12">\n' +
    '            <div class="col-sm-4 p-t-10">\n' +
    '              <label class="domp-form-label-review"  translate="settings.smsModal.dailyTimePeriod"></label>\n' +
    '            </div>\n' +
    '            <div class="col-sm-3">\n' +
    '              <div class="form-group">\n' +
    '                <select ng-if="!smsAndNotificationModal.object.value" name="dailyTimePeriod"\n' +
    '                        class="form-control input-field p-l-15 p-r-10"\n' +
    '                        ng-options="option.description for option in smsAndNotificationModal.periods.dailyTimePeriods"\n' +
    '                        ng-model="smsAndNotificationModal.dailyTimePeriod">\n' +
    '                </select>\n' +
    '                <label ng-if="smsAndNotificationModal.object.value" class="domp-form-label-resume p-t-10">{{ smsAndNotificationModal.dailyTimePeriod.description }}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--PERIOD & AMOUNT END-->\n' +
    '\n' +
    '      <!-- ADDITIONAL (for specific order id == 40 or 50)-->\n' +
    '      <!--PERIOD -->\n' +
    '      <div ng-if="(smsAndNotificationModal.object.orderObject.subOrderId == \'40\' || smsAndNotificationModal.object.orderObject.subOrderId == \'50\') ">\n' +
    '        <div class="row p-b-10">\n' +
    '          <div class="col-xs-12">\n' +
    '            <div class="col-sm-4 p-t-10">\n' +
    '              <label class="domp-form-label-review"  translate="settings.smsModal.dailyTimePeriod"></label>\n' +
    '            </div>\n' +
    '            <div class="col-sm-3">\n' +
    '              <div class="form-group">\n' +
    '                <select ng-if="!smsAndNotificationModal.object.value" name="dailyTimePeriod"\n' +
    '                        class="form-control input-field p-l-15 p-r-10"\n' +
    '                        ng-options="option.description for option in smsAndNotificationModal.periods.dailyTimePeriods"\n' +
    '                        ng-model="smsAndNotificationModal.dailyTimePeriod">\n' +
    '                </select>\n' +
    '                <label ng-if="smsAndNotificationModal.object.value" class="domp-form-label-resume p-t-10">{{ smsAndNotificationModal.dailyTimePeriod.description }}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--PERIOD & AMOUNT END-->\n' +
    '\n' +
    '      <!--AMOUNT-->\n' +
    '      <div ng-if="smsAndNotificationModal.tempObj.showAmount" class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4 p-t-10">\n' +
    '            <label ng-if="smsAndNotificationModal.object.orderObject.subOrderId !== \'70\'" class="domp-form-label-review" translate="settings.smsModal.noticeAmount"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.orderObject.subOrderId === \'70\'" class="domp-form-label-review" translate="settings.smsModal.noticeAmountAbove"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-3">\n' +
    '            <div class="form-group">\n' +
    '              <input ng-if="!smsAndNotificationModal.object.value " type="text" class="form-control input-field t-a-r" name="noticeAmount" id="noticeAmount"\n' +
    '                     amount-input-mask max-amount="99999999999.99" required\n' +
    '                     placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                     maxlength="17"\n' +
    '                     ng-class="{\'domp-error\': smsAndNotificationModal.smsAndNotifForm.noticeAmount.$invalid && smsAndNotificationModal.tempObj.formSubmitted}"\n' +
    '                     ng-model="smsAndNotificationModal.tempObj.amount">\n' +
    '              <label ng-if="smsAndNotificationModal.object.value" class="domp-form-label-resume p-t-10">{{ smsAndNotificationModal.tempObj.amount.replace(",",".") | currency:"" }}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--AMOUNT END-->\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12 p-l-30 p-t-20">\n' +
    '          <label class="checkbox checkbox-inline-inline checkbox-value">\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="smsAndNotificationModal.tempOrderObj.agreeTerms">\n' +
    '            <i class="input-helper"></i>\n' +
    '            <span\n' +
    '              ng-if="smsAndNotificationModal.object.type == \'EMAIL\' && !smsAndNotificationModal.object.value"\n' +
    '              translate="settings.smsModal.orderNoticeStart"></span>\n' +
    '            <span ng-if="smsAndNotificationModal.object.value"\n' +
    '                  translate="settings.smsModal.orderNoticeStop"></span>\n' +
    '            <span\n' +
    '              ng-if="smsAndNotificationModal.object.type == \'SMS\' && !smsAndNotificationModal.object.value">\n' +
    '              <span translate="settings.smsModal.orderSmsStart1"></span>\n' +
    '              <span><a class="underline" href="https://www.addiko.si/splosni-pogoji" translate="settings.smsModal.orderSmsStartLink" target="_blank"></a></span>\n' +
    '              <span translate="settings.smsModal.orderSmsStart2"></span>\n' +
    '            </span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '      <div class="col-xs-12">\n' +
    '\n' +
    '        <button class="btn btn-primary pull-left" translate="settings.smsModal.cancel" ng-click="$close()"></button>\n' +
    '        <button ng-disabled="!smsAndNotificationModal.tempOrderObj.agreeTerms" class="btn btn-default pull-right"\n' +
    '                ng-click="smsAndNotificationModal.next();"\n' +
    '                translate="settings.smsModal.next"></button>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    </ng-form>\n' +
    '  </div>\n' +
    '\n' +
    '  <!--COMMON STEP 2 START-->\n' +
    '  <div class="p-t-20" ng-if="smsAndNotificationModal.step == 2">\n' +
    '\n' +
    '    <div class="modal-body">\n' +
    '      <!-- ORDER DATE -->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.orderDate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label class="domp-form-label-resume">{{smsAndNotificationModal.orderDate | date:\'dd.MM.yyyy HH:mm:ss\' }}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- ORDER DATE END -->\n' +
    '\n' +
    '      <!-- ORDER TYPE -->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.orderType"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-8">\n' +
    '            <label class="domp-form-label-resume">{{smsAndNotificationModal.object.orderObject.description}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- FORDER TYPE END -->\n' +
    '\n' +
    '      <!-- FOR ACCOUNT / NAME -->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label ng-if="!smsAndNotificationModal.object.accountBased" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.user"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.accountBased" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.forAccount"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="!smsAndNotificationModal.object.accountBased" class="domp-form-label-resume">{{smsAndNotificationModal.object.user.firstName}} {{smsAndNotificationModal.object.user.lastName}}</label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.accountBased" class="domp-form-label-resume">{{smsAndNotificationModal.object.account.iban | formatIban}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- FOR ACCOUNT / NAME END -->\n' +
    '\n' +
    '      <!--ORDER DESC-->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label class="domp-form-label-review" translate="settings.smsModal.orderDesc"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="!smsAndNotificationModal.object.value && smsAndNotificationModal.object.type == \'SMS\'"\n' +
    '                   class="domp-form-label-resume" translate="settings.smsModal.receivingSmsStart"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.value  && smsAndNotificationModal.object.type == \'SMS\'" class="domp-form-label-resume"\n' +
    '                   translate="settings.smsModal.receivingSmsStop"></label>\n' +
    '            <label ng-if="!smsAndNotificationModal.object.value  && smsAndNotificationModal.object.type == \'EMAIL\'"\n' +
    '                   class="domp-form-label-resume" translate="settings.smsModal.receivingEmailStart"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.value  && smsAndNotificationModal.object.type == \'EMAIL\'" class="domp-form-label-resume"\n' +
    '                   translate="settings.smsModal.receivingEmailStop"></label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--ORDER DESC END-->\n' +
    '\n' +
    '      <!--MOBILE PHONE / SMS-->\n' +
    '      <div class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'EMAIL\'" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.email"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'SMS\'" class="domp-form-label-review"\n' +
    '                   translate="settings.smsModal.gsm"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'EMAIL\'" class="domp-form-label-resume">{{smsAndNotificationModal.object.user.notificationEmail}}</label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.type == \'SMS\'" class="domp-form-label-resume">{{smsAndNotificationModal.object.user.gsm}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--MOBILE PHONE / SMS END-->\n' +
    '\n' +
    '      <!--ID == 30 SPECIFIC START-->\n' +
    '      <div ng-if="smsAndNotificationModal.object.orderObject.subOrderId == \'30\'">\n' +
    '        <!--PERIOD & AMOUNT-->\n' +
    '        <div>\n' +
    '          <div class="row p-b-10">\n' +
    '            <div class="col-xs-12">\n' +
    '              <div class="col-sm-4 p-t-10">\n' +
    '                <label class="domp-form-label-review" translate="settings.smsModal.period"></label>\n' +
    '              </div>\n' +
    '              <div ng-if="!smsAndNotificationModal.object.value" class="col-sm-4 p-t-10">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label-resume" ng-if="smsAndNotificationModal.periodType.id == \'D\'">\n' +
    '                    {{smsAndNotificationModal.periodType.description | translate}}\n' +
    '                  </label>\n' +
    '                  <label class="domp-form-label-resume" ng-if="smsAndNotificationModal.periodType.id == \'W\'">\n' +
    '                    {{smsAndNotificationModal.periodType.description | translate}}, {{smsAndNotificationModal.weeklyTimePeriod.description | translate}}\n' +
    '                  </label>\n' +
    '                  <label class="domp-form-label-resume" ng-if="smsAndNotificationModal.periodType.id == \'M\'">\n' +
    '                    {{smsAndNotificationModal.periodType.description | translate}}, {{smsAndNotificationModal.monthlyTimePeriod.description | translate}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div ng-if="smsAndNotificationModal.object.value" class="col-sm-4 p-t-10">\n' +
    '                <label class="domp-form-label-resume">{{smsAndNotificationModal.periodType.description | translate}}<span ng-if="smsAndNotificationModal.period">, {{smsAndNotificationModal.period.description}}</span></label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row p-b-10">\n' +
    '            <div class="col-xs-12">\n' +
    '              <div class="col-sm-4 p-t-10">\n' +
    '                <label class="domp-form-label-review" translate="settings.smsModal.dailyTimePeriod"></label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-4 p-t-10">\n' +
    '                <div class="form-group">\n' +
    '                  <label ng-if="!smsAndNotificationModal.object.value"\n' +
    '                         class="domp-form-label-resume">{{smsAndNotificationModal.dailyTimePeriod.description}}</label>\n' +
    '                  <label ng-if="smsAndNotificationModal.object.value"\n' +
    '                         class="domp-form-label-resume ">{{ smsAndNotificationModal.dailyTimePeriod.description }}</label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!--PERIOD & AMOUNT END-->\n' +
    '\n' +
    '      </div>\n' +
    '      <!--ID == 30 SPECIFIC END-->\n' +
    '\n' +
    '      <!--ID == 40 or 50 SPECIFIC START-->\n' +
    '        <!--PERIOD & AMOUNT-->\n' +
    '        <div class="row p-b-10" ng-if="smsAndNotificationModal.object.orderObject.subOrderId == \'40\' || smsAndNotificationModal.object.orderObject.subOrderId == \'50\'">\n' +
    '          <div class="col-xs-12">\n' +
    '            <div class="col-sm-4 p-t-10">\n' +
    '              <label class="domp-form-label-review" translate="settings.smsModal.dailyTimePeriod"></label>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 p-t-10">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-resume ">{{ smsAndNotificationModal.dailyTimePeriod.description }}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!--PERIOD & AMOUNT END-->\n' +
    '      <!--ID == 40 or 50 SPECIFIC END-->\n' +
    '\n' +
    '\n' +
    '\n' +
    '      <div ng-if="smsAndNotificationModal.tempObj.showAmount" class="row p-b-10">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label ng-if="smsAndNotificationModal.object.orderObject.subOrderId !== \'70\'" class="domp-form-label-review" translate="settings.smsModal.noticeAmount"></label>\n' +
    '            <label ng-if="smsAndNotificationModal.object.orderObject.subOrderId === \'70\'" class="domp-form-label-review" translate="settings.smsModal.noticeAmountAbove"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-3">\n' +
    '            <div class="form-group">\n' +
    '              <label ng-if="!smsAndNotificationModal.object.value" class="domp-form-label-resume">{{smsAndNotificationModal.tempObj.amount | currency:""}}</label>\n' +
    '              <label ng-if="smsAndNotificationModal.object.value" class="domp-form-label-resume">{{smsAndNotificationModal.tempObj.amount.replace(",",".") | currency:""}}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!--RECEIVING NOTICES AND GENERALN TERMS-->\n' +
    '      <div ng-if="!smsAndNotificationModal.object.value" class="row">\n' +
    '        <div class="col-xs-12 p-t-20">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label class="domp-form-label-review" translate="settings.smsModal.agreedToReceiveNotices"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="smsAndNotificationModal.tempOrderObj.agreeTerms" translate="settings.smsModal.yes"\n' +
    '                   class="domp-form-label-resume"></label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div ng-if="smsAndNotificationModal.object.type == \'SMS\'" class="row">\n' +
    '        <div class="col-xs-12 p-t-20">\n' +
    '          <div class="col-sm-4">\n' +
    '            <label  ng-if="!smsAndNotificationModal.object.value" class="domp-form-label-review" translate="settings.smsModal.agreedToGeneralTerms"></label>\n' +
    '            <label  ng-if="smsAndNotificationModal.object.value" class="domp-form-label-review" translate="settings.smsModal.agreedToStopTerms"></label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <label ng-if="smsAndNotificationModal.tempOrderObj.agreeTerms" translate="settings.smsModal.yes"\n' +
    '                   class="domp-form-label-resume"></label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--RECEIVING NOTICES AND GENERALN TERMS-->\n' +
    '    </div>\n' +
    '\n' +
    '    <!--FOOTER-->\n' +
    '    <div class="modal-footer">\n' +
    '      <div class="col-xs-12">\n' +
    '        <button class="btn btn-primary pull-left" translate="settings.smsModal.back"\n' +
    '                ng-click="smsAndNotificationModal.step = 1;smsAndNotificationModal.tempOrderObj.agreeTerms = false;"></button>\n' +
    '        <button class="btn btn-primary pull-left" translate="settings.smsModal.cancel" ng-click="$close()"></button>\n' +
    '        <button class="btn btn-default pull-right" ng-click="smsAndNotificationModal.confirm();"\n' +
    '                ng-disabled="smsAndNotificationModal.confirmationInProgress"\n' +
    '                translate="domesticPayment.confirmBtn"></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--FOOTER END-->\n' +
    '\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <!--COMMON STEP 2 END-->\n' +
    '\n' +
    '  <div ng-if="smsAndNotificationModal.step == 3">\n' +
    '    <div class="modal-body p-0">\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-4 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '            <div class="currency-check-icon msg-pad">\n' +
    '              <i class="icon icon-confirm zmdi-hc-5x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-8 m-t-30 m-b-30" style="max-width: 688px;">\n' +
    '            <h2 class=" f-28" translate="settings.smsModal.successMsg"></h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer modal-footer-padding">\n' +
    '      <div class="col-xs-12">\n' +
    '        <button class="btn btn-default m-5 pull-right" ng-click="$close()" translate="settings.smsModal.newOrder">\n' +
    '        </button>\n' +
    '        <button class="btn btn-default m-5 pull-right" translate="settings.smsModal.archive">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('settings/settings.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12" style="z-index:1;">\n' +
    '        <div class="tmplt-list-title col-md-12 p-r-0 p-l-0 m-b-15">\n' +
    '          <h2 class="title-style" translate="settings.title">Settings</h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Title -->\n' +
    '\n' +
    '\n' +
    '    <div class="row"\n' +
    '         ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\'">\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="po-type-container">\n' +
    '          <div class=" no-wrap-text cursor-pointer"\n' +
    '               translate="{{APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'settings.tabAccount\' : \'settings.tabAccountHR\'}}"\n' +
    '               ng-click="settings.selectTab(\'account\', \'settings.tabAccount\')"\n' +
    '               ng-class="{\'selected\': settings.selectedTab == \'account\',\n' +
    '                          \'settings-tab cro\': APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\',\n' +
    '                          \'settings-tab width-100 text-left\': APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' && !APP_GLOBAL_SETTINGS.defaultData.ShowUserSettingsNotification,\n' +
    '                          \'settings-tab\': APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' && APP_GLOBAL_SETTINGS.defaultData.ShowUserSettingsNotification }">\n' +
    '            Account\n' +
    '          </div>\n' +
    '          <!-- Sakriti Notifications tab -->\n' +
    '          <div class="no-wrap-text cursor-pointer"\n' +
    '               ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' && APP_GLOBAL_SETTINGS.defaultData.ShowUserSettingsNotification"\n' +
    '               translate="settings.tabNotifications"\n' +
    '               ng-class="{\'selected\': settings.selectedTab == \'notifications\',\n' +
    '                          \'settings-tab cro\': APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\',\n' +
    '                          \'settings-tab\': APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' }"\n' +
    '               ng-click="settings.selectTab(\'notifications\', \'settings.tabNotifications\')">\n' +
    '            Notifications\n' +
    '          </div>\n' +
    '          <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '               class="settings-tab cro no-wrap-text cursor-pointer"\n' +
    '               translate="settings.tabSecurity"\n' +
    '               ng-class="{\'selected\': settings.selectedTab == \'security\'}"\n' +
    '               ng-click="settings.selectTab(\'security\', \'settings.tabSecurity\')">\n' +
    '            Security\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-switch="settings.selectedTab">\n' +
    '      <!-- ======================  -->\n' +
    '      <!-- START: ACCOUNT TAB      -->\n' +
    '      <!-- ======================  -->\n' +
    '      <div ng-switch-when="account" class="settings-content m-b-30">\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <h4 class="settings-conc-info">\n' +
    '              <span translate="settings.contactInfo" style="font-weight: bold"><b>Your contact information</b></span>\n' +
    '            </h4>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="!settings.editUserSettingsActive">\n' +
    '          <!-- START View User settings-->\n' +
    '          <div class="row">\n' +
    '            <div class="form-group col-md-4">\n' +
    '              <label class="sett-conc-info" translate="settings.contactInfoName">Name</label>\n' +
    '              <p class="settings-details">{{settings.model.userSettings.firstName}}\n' +
    '                {{settings.model.userSettings.lastName}}</p>\n' +
    '            </div>\n' +
    '            <div class="form-group col-md-4">\n' +
    '              <label class="sett-conc-info" translate="settings.contactInfoAddress">Address</label>\n' +
    '              <!--<div class="settings-details">{{settings.model.userSettings.street}}-->\n' +
    '                <!--{{settings.model.userSettings.houseNumber}}-->\n' +
    '              <!--</div>-->\n' +
    '\n' +
    '              <div class="settings-details">{{settings.model.userSettings.address1}}\n' +
    '              </div>\n' +
    '              <div class="settings-details">{{settings.model.userSettings.postalCode}}\n' +
    '                {{settings.model.userSettings.city}}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-md-4">\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row m-t-15" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '\n' +
    '            <!-- ===========  -->\n' +
    '            <!-- START: EMAIL -->\n' +
    '            <!-- ===========  -->\n' +
    '            <div ng-switch-default class="form-group">\n' +
    '              <div class="col-md-4">\n' +
    '                <label class="sett-conc-info">Email</label>\n' +
    '                <p class="settings-details">{{settings.model.userSettings.notificationEmail}}</p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- Slovenia -->\n' +
    '            <div ng-switch-when="sl" class="form-group clearfix">\n' +
    '              <!-- View -->\n' +
    '\n' +
    '              <div class="col-md-4" ng-if="!settings.editEmail">\n' +
    '                <label class="sett-conc-info" translate="settings.emailAddress">Email</label>\n' +
    '                <p class="settings-details">{{settings.model.userSettings.notificationEmail}}</p>\n' +
    '              </div>\n' +
    '              <!-- Edit -->\n' +
    '              <form name="settings.emailForm">\n' +
    '                <div class="col-md-4" ng-show="settings.editEmail">\n' +
    '                  <input type="email" class="form-control" name="mail"\n' +
    '                         ng-model="settings.model.userSettingsEditInput.notificationEmail" required>\n' +
    '                  <div class="c-red" ng-show="settings.emailForm.mail.$error.required"\n' +
    '                       translate="settings.emailRequiredErroMsg"></div>\n' +
    '                  <div class="c-red" ng-show="settings.emailForm.mail.$error.email"\n' +
    '                       translate="settings.invalidEmailRequiredErroMsg"></div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-4" style="margin:-5px;">\n' +
    '                  <button class="btn btn-default m-l-5" ng-if="!settings.editEmail" translate="settings.changeEMail" ng-click="settings.editUserEmail()"></button>\n' +
    '                  <button class="btn btn-primary" ng-if="settings.editEmail" translate="settings.contactInfoCancelBtn" ng-click="settings.editEmail = false"></button>\n' +
    '                  <button class="btn btn-default" ng-if="settings.editEmail" translate="settings.contactInfoConfirmBtn" ng-disabled="settings.emailForm.$invalid" ng-click="settings.confirmUserEmailChange()"></button>\n' +
    '                </div>\n' +
    '              </form>\n' +
    '            </div>\n' +
    '            <!-- ===========  -->\n' +
    '            <!-- END: EMAIL -->\n' +
    '            <!-- ===========  -->\n' +
    '\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row">\n' +
    '            <div ng-if="settings.country != \'sl\'" class="form-group col-md-4">\n' +
    '              <label class="sett-conc-info" translate="settings.contactInfoPhone">Phone</label>\n' +
    '              <p class="settings-details">{{settings.model.userSettings.dayPhoneCountryCode}} {{settings.model.userSettings.dayPhoneOperator}} {{settings.model.userSettings.dayPhone}}</p>\n' +
    '            </div>\n' +
    '            <div class="form-group clearfix">\n' +
    '              <div class="col-md-4">\n' +
    '              <label class="sett-conc-info" translate="settings.gsm">GSM</label>\n' +
    '              <p class="settings-details">{{settings.model.userSettings.gsmCountryCode}} {{settings.model.userSettings.gsmOperator}} {{settings.model.userSettings.gsm}}</p>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-md-4" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                <button class="btn btn-default" translate="mobilePhoneSettings.setMobilePhoneNumber" ng-click="settings.setMobilePhoneNumber(settings.model.userSettings.gsm)"></button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END View User settings-->\n' +
    '        <!-- START Edit User settings-->\n' +
    '        <ng-form name="settings.contactForm" ng-if="settings.editUserSettingsActive">\n' +
    '          <div class="row form-group">\n' +
    '            <div class="col-md-4 col-sm-6">\n' +
    '              <label translate="settings.contactInfoName" class="sett-conc-info">Name</label>\n' +
    '              <p class="settings-details">{{settings.model.userSettings.firstName}}\n' +
    '                {{settings.model.userSettings.lastName}}</p>\n' +
    '            </div>\n' +
    '            <div class="col-md-4 col-sm-6">\n' +
    '              <div class="col-lg-12 p-0">\n' +
    '                <label translate="settings.contactInfoAddress" class="sett-conc-info">Address</label>\n' +
    '              </div>\n' +
    '              <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                <div class="row form-group m-0 p-0">\n' +
    '                  <div class="col-lg-8 col-xs-8 p-0 p-b-15">\n' +
    '                    <input type="text" name="street" class=" col-xs-12 settings-input"\n' +
    '                           placeholder="{{\'settings.street\'| translate}}"\n' +
    '                           ng-model="settings.model.userSettingsEditInput.street" capitalize required>\n' +
    '\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-4 col-lg-4 p-0 p-l-5 p-b-15">\n' +
    '                    <input type="text" name="houseNumber" class="col-xs-12 settings-input"\n' +
    '                           placeholder="{{\'settings.houseNumber\'| translate}}"\n' +
    '                           ng-model="settings.model.userSettingsEditInput.houseNumber" required>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="row form-group m-0 p-0">\n' +
    '                  <div class="col-lg-4 col-xs-4 p-0 p-b-15">\n' +
    '                    <input type="text" name="postalCode" class="col-xs-12 settings-input"\n' +
    '                           placeholder="{{\'settings.postalCode\'| translate}}"\n' +
    '                           ng-model="settings.model.userSettingsEditInput.postalCode"\n' +
    '                           ng-required="!settings.model.userSettingsEditInput.city">\n' +
    '                  </div>\n' +
    '                  <div class="col-lg-8 col-xs-8 p-0 p-l-5 p-b-15">\n' +
    '                    <input type="text" name="city" class="col-xs-12 settings-input"\n' +
    '                           placeholder="{{\'settings.city\'| translate}}"\n' +
    '                           ng-model="settings.model.userSettingsEditInput.city"\n' +
    '                           capitalize="" ng-required="!settings.model.userSettingsEditInput.postalCode">\n' +
    '                  </div>\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                <!--<div class="settings-details">{{settings.model.userSettings.street}}-->\n' +
    '                  <!--{{settings.model.userSettings.houseNumber}}-->\n' +
    '                <!--</div>-->\n' +
    '\n' +
    '                <div class="settings-details">{{settings.model.userSettings.address1}}\n' +
    '                </div>\n' +
    '                <div class="settings-details">{{settings.model.userSettings.postalCode}}\n' +
    '                  {{settings.model.userSettings.city}}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="c-red" ng-show="settings.contactForm.street.$error.required"\n' +
    '                   translate="settings.streetRequiredErrMsg"></div>\n' +
    '              <div class="c-red" ng-show="settings.contactForm.houseNumber.$error.required"\n' +
    '                   translate="settings.houseNumRequiredErrMsg"></div>\n' +
    '              <div class="c-red"\n' +
    '                   ng-show="settings.contactForm.postalCode.$error.required && settings.contactForm.city.$error.required"\n' +
    '                   translate="settings.cityOrPostalCodeRequiredErrMsg"></div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row form-group">\n' +
    '\n' +
    '            <div class="col-md-4 col-xs-12 col-sm-6">\n' +
    '\n' +
    '              <div class="col-lg-12 p-0">\n' +
    '                <label class="sett-conc-info">Email</label>\n' +
    '              </div>\n' +
    '              <div class="col-lg-12 col-xs-12 p-0 p-b-15">\n' +
    '                <input type="email" class="form-control" name="mail"\n' +
    '                       ng-model="settings.model.userSettingsEditInput.notificationEmail" required>\n' +
    '                <div class="c-red" ng-show="settings.contactForm.mail.$error.required"\n' +
    '                     translate="settings.emailRequiredErroMsg"></div>\n' +
    '                <div class="c-red" ng-show="settings.contactForm.mail.$error.email"\n' +
    '                     translate="settings.invalidEmailRequiredErroMsg"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row form-group">\n' +
    '            <div ng-if="settings.country != \'sl\'" class="col-md-4 col-xs-12 col-sm-6">\n' +
    '              <div class="col-lg-12 p-0">\n' +
    '                <label translate="settings.contactInfoPhone" class="sett-conc-info">Phone</label>\n' +
    '              </div>\n' +
    '              <div>\n' +
    '                <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                  <div ng-switch-when="sl">\n' +
    '                    <div class="col-lg-12 col-xs-12 p-0 p-b-15">\n' +
    '                      <!--<input type="text" class="form-control" ng-pattern-restrict="{{settings.regexPatterns.phoneValidation}}"-->\n' +
    '                      <!--ng-model="settings.model.userSettingsEditInput.dayPhone">-->\n' +
    '                      <p class="settings-details">{{settings.model.userSettings.dayPhone}}</p>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div ng-switch-default>\n' +
    '                    <div class="col-lg-3 col-xs-3 p-0 p-b-15">\n' +
    '                      <input type="text" class="form-control" maxlength="4"\n' +
    '                             ng-pattern-restrict="{{settings.regexPatterns.phoneValidationWithPlus}}"\n' +
    '                             ng-model="settings.model.userSettingsEditInput.dayPhoneCountryCode">\n' +
    '                    </div>\n' +
    '                    <div class="col-lg-3 col-xs-3 p-0 p-b-15">\n' +
    '                      <input type="text" class="form-control" maxlength="4"\n' +
    '                             ng-pattern-restrict="{{settings.regexPatterns.phoneValidations}}"\n' +
    '                             ng-model="settings.model.userSettingsEditInput.dayPhoneOperator">\n' +
    '                    </div>\n' +
    '                    <div class="col-lg-6 col-xs-6 p-0 p-b-15">\n' +
    '                      <input type="text" class="form-control"\n' +
    '                             ng-pattern-restrict="{{settings.regexPatterns.phoneValidation}}"\n' +
    '                             ng-model="settings.model.userSettingsEditInput.dayPhone">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-md-4 col-xs-12 col-sm-6">\n' +
    '              <div class="col-lg-12 p-0">\n' +
    '                <label translate="settings.gsm" class="sett-conc-info">GSM</label>\n' +
    '              </div>\n' +
    '              <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                <div ng-switch-when="sl" class="col-lg-12 col-xs-12 p-0 p-b-15">\n' +
    '                  <!--<input type="text" class="form-control" ng-pattern-restrict="{{settings.regexPatterns.phoneValidation}}"-->\n' +
    '                  <!--ng-model="settings.model.userSettingsEditInput.gsm">-->\n' +
    '                  <p class="settings-details">{{settings.model.userSettingsEditInput.gsm}}</p>\n' +
    '                </div>\n' +
    '                <div ng-switch-default>\n' +
    '                  <div class="col-lg-3 col-xs-3 p-0 p-b-15">\n' +
    '                    <input type="text" class="form-control" maxlength="4"\n' +
    '                           ng-pattern-restrict="{{settings.regexPatterns.phoneValidationWithPlus}}"\n' +
    '                           ng-model="settings.model.userSettingsEditInput.gsmCountryCode">\n' +
    '                  </div>\n' +
    '                  <div class="col-lg-3 col-xs-3 p-0 p-b-15">\n' +
    '                    <input type="text" class="form-control" maxlength="4"\n' +
    '                           ng-pattern-restrict="{{settings.regexPatterns.phoneValidations}}"\n' +
    '                           ng-model="settings.model.userSettingsEditInput.gsmOperator">\n' +
    '                  </div>\n' +
    '                  <div class="col-lg-6 col-xs-6 p-0 p-b-15">\n' +
    '                    <input type="text" class="form-control"\n' +
    '                           ng-pattern-restrict="{{settings.regexPatterns.phoneValidation}}"\n' +
    '                           ng-model="settings.model.userSettingsEditInput.gsm">\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </ng-form>\n' +
    '        <!-- END Edit User settings-->\n' +
    '        <!--<hr>-->\n' +
    '        <div ng-if="settings.country != \'sl\'" class="form-group">\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-12">\n' +
    '              <h4 class="settings-conc-info" translate="settings.statementsDelivery">Statement delivery</h4>\n' +
    '            </div>\n' +
    '            <div ng-show="settings.editUserSettingsActive">\n' +
    '              <div class="col-md-6">\n' +
    '                <label>\n' +
    '                  <input type="radio" ng-model="settings.model.userSettingsEditInput.mailUserType" value="0">\n' +
    '                  <span translate="settings.statementsDeliveryPaper" class="stat-deliv">Home delivery of paper statements</span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-md-6">\n' +
    '                <label>\n' +
    '                  <input type="radio" ng-model="settings.model.userSettingsEditInput.mailUserType" value="1">\n' +
    '                  <span translate="settings.statementsDeliveryElectronic" class="stat-deliv"> Electronic statements in HYPOnet</span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="form-group"></div>\n' +
    '            <div ng-show="!settings.editUserSettingsActive">\n' +
    '              <div class="col-md-6">\n' +
    '                <label>\n' +
    '                  <input type="radio" ng-model="settings.model.userSettings.mailUserType" disabled value="0">\n' +
    '                  <span translate="settings.statementsDeliveryPaper" class="stat-deliv">Home delivery of paper statements</span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-md-6">\n' +
    '                <label>\n' +
    '                  <input type="radio" ng-model="settings.model.userSettings.mailUserType" disabled value="1">\n' +
    '                  <span translate="settings.statementsDeliveryElectronic" class="stat-deliv"> Electronic statements in HYPOnet</span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row form-group">\n' +
    '          <div class="col-xs-6 col-sm-6">\n' +
    '            <button class="btn btn-primary" ng-show="settings.editUserSettingsActive"\n' +
    '                    ng-click="settings.cancelUserSettingsEdit()" translate="settings.contactInfoCancelBtn">Cancel\n' +
    '            </button>\n' +
    '            <!--    <button   class="btn btn-primary"\n' +
    '        data-ui-sref="dashboard"\n' +
    '        ng-show="settings.editUserSettingsActive"\n' +
    '        ng-click="settings.cancelUserSettingsEdit()"\n' +
    '        translate="settings.contactInfoCancelBtn">Cancel</button> -->\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 col-sm-6 t-a-r">\n' +
    '            <button class="btn btn-default" ng-show="settings.editUserSettingsActive"\n' +
    '                    ng-disabled="settings.contactForm.$invalid" ng-click="settings.confirmUserSettingsEdit()"\n' +
    '                    translate="settings.contactInfoConfirmBtn">Confirm\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-offset-6 col-xs-6 col-sm-6 t-a-r">\n' +
    '            <button class="btn btn-default"\n' +
    '                    ng-show="!settings.editUserSettingsActive"\n' +
    '                    ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                    ng-click="settings.editUserSettings()" translate="settings.contactInfoBtn">\n' +
    '              Edit\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- ======================  -->\n' +
    '      <!-- END: ACCOUNT TAB        -->\n' +
    '      <!-- ======================  -->\n' +
    '\n' +
    '      <!-- ======================  -->\n' +
    '      <!-- START: NOTIFICATIONS TAB  -->\n' +
    '      <!-- ======================  -->\n' +
    '      <div ng-switch-when="notifications" class="settings-content">\n' +
    '        <!-- SLOVENIA -->\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" class="row form-group">\n' +
    '          <div class="col-md-12">\n' +
    '\n' +
    '            <p class="p-t-10 p-b-10">\n' +
    '              <span translate="settings.notificationsNote"></span>\n' +
    '              <a class="underline" ng-href="https://www.addiko.si/ceniki" target="_blank"\n' +
    '                 translate="settings.notificationsNoteLink"></a>\n' +
    '            </p>\n' +
    '\n' +
    '            <h4 class="settings-conc-info p-b-15" translate="settings.userBasedNotifications">\n' +
    '              <b>User based notifications</b>\n' +
    '            </h4>\n' +
    '            <table class="table settings-notifications-table">\n' +
    '              <tbody>\n' +
    '              <tr>\n' +
    '                <td><b>EMAIL</b></td>\n' +
    '                <td><b>SMS</b></td>\n' +
    '                <td></td>\n' +
    '              </tr>\n' +
    '              <tr ng-repeat="item in settings.userBasedNotificationsList">\n' +
    '                <td ng-if="item.emailNotificaton.enabled" class="col-md-2 underline cursor-pointer"\n' +
    '                    translate="settings.disableMail"\n' +
    '                    ng-click="settings.changeSettings(item, true, \'EMAIL\', false);"></td>\n' +
    '                <td ng-if="!item.emailNotificaton.enabled" class="col-md-2 underline cursor-pointer"\n' +
    '                    translate="settings.enableMail"\n' +
    '                    ng-click="settings.changeSettings(item, false, \'EMAIL\', false);"></td>\n' +
    '                <td ng-if="item.smsNotification.enabled && item.subOrderId != \'10\'"\n' +
    '                    class="col-md-2 underline cursor-pointer" translate="settings.disableSms"\n' +
    '                    ng-click="settings.changeSettings(item, true, \'SMS\', false);"></td>\n' +
    '                <td ng-if="!item.smsNotification.enabled && item.subOrderId != \'10\'"\n' +
    '                    class="col-md-2 underline cursor-pointer" translate="settings.enableSms"\n' +
    '                    ng-click="settings.changeSettings(item, false, \'SMS\', false);"></td>\n' +
    '                <td ng-if="item.subOrderId == \'10\'"\n' +
    '                    class="col-md-2 underline cursor-pointer"></td>\n' +
    '                <td class="col-md-8">{{item.description}}</td>\n' +
    '\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <hr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'">\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" class="row form-group">\n' +
    '          <div class="col-md-12">\n' +
    '            <h4 class="settings-conc-info p-b-15" translate="settings.accountBasedNotifications">\n' +
    '              <b>Account based notifications</b>\n' +
    '            </h4>\n' +
    '          </div>\n' +
    '          <div class="form-group">\n' +
    '            <label class="col-lg-2 col-md-2 col-sm-12 col-xs-12 col-form-label settings-conc-info"\n' +
    '                   style="font-weight: normal" translate="settings.forAccount">For account:</label>\n' +
    '            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">\n' +
    '              <select name="trrAccounts"\n' +
    '                      class="form-control input-field p-l-15 p-r-10"\n' +
    '                      ng-options="(option.iban + \' \' + option.friendlyName) for option in settings.trrAccounts"\n' +
    '                      ng-change="settings.loadSmsAndNotifications();"\n' +
    '                      ng-model="settings.selectedTrrAccount">\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" class="row form-group">\n' +
    '          <div class="col-md-12">\n' +
    '            <table class="table settings-notifications-table">\n' +
    '              <tbody>\n' +
    '              <tr>\n' +
    '                <td><b>EMAIL</b></td>\n' +
    '                <td><b>SMS</b></td>\n' +
    '                <td></td>\n' +
    '              </tr>\n' +
    '              <tr ng-repeat="item in settings.accountBasedNotificationsList">\n' +
    '                <td ng-if="item.emailNotificaton.enabled" class="col-md-2 underline cursor-pointer"\n' +
    '                    translate="settings.disableMail"\n' +
    '                    ng-click="settings.changeSettings(item, true, \'EMAIL\', true);"></td>\n' +
    '                <td ng-if="!item.emailNotificaton.enabled" class="col-md-2 underline cursor-pointer"\n' +
    '                    translate="settings.enableMail" ng-click="settings.changeSettings(item,false, \'EMAIL\', true);"></td>\n' +
    '                <td ng-if="item.smsNotification.enabled" class="col-md-2 underline cursor-pointer"\n' +
    '                    translate="settings.disableSms" ng-click="settings.changeSettings(item, true, \'SMS\', true);"></td>\n' +
    '                <td ng-if="!item.smsNotification.enabled" class="col-md-2 underline cursor-pointer"\n' +
    '                    translate="settings.enableSms" ng-click="settings.changeSettings(item,false, \'SMS\', true);"></td>\n' +
    '                <td class="col-md-8">{{item.description}}</td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- CROATIA -->\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'hr\'" class="row form-group">\n' +
    '          <div class="col-md-12">\n' +
    '\n' +
    '            <table class="table settings-notifications-table-cro">\n' +
    '              <tbody>\n' +
    '              <tr>\n' +
    '                <td class="no-top-border show-bottom-border" translate="settings.showNotificationFor"></td>\n' +
    '                <td class="no-top-border show-bottom-border t-a-c"><span>SMS</span></td>\n' +
    '                <td class="no-top-border show-bottom-border disable-bold-font t-a-c"><span>Email</span></td>\n' +
    '              </tr>\n' +
    '              <tr class="p-t-15" ng-repeat="item in settings.notificationsList.modifiedList" ng-if="item.notificationType">\n' +
    '                <td class="col-md-6 no-top-border" ng-bind="item.notificationType"></td>\n' +
    '                <td class="col-md-2 no-top-border t-a-c checkbox-like-radio">\n' +
    '                  <span ng-click="settings.updateNotificationItem(item, \'sms\');">\n' +
    '                    <input id="smsCheckBox_{{$index}}" type="checkbox" ng-model="item.isActive">\n' +
    '                    <label for="smsCheckBox_{{$index}}"></label>\n' +
    '                  </span>\n' +
    '                </td>\n' +
    '                <td class="col-md-2 no-top-border t-a-c checkbox-like-radio">\n' +
    '                  <span ng-click="settings.updateNotificationItem(item, \'email\');">\n' +
    '                    <input id="emailCheckBox_{{$index}}" type="checkbox" ng-model="item.isEmail"\n' +
    '                           >\n' +
    '                    <label for="emailCheckBox_{{$index}}"></label>\n' +
    '                  </span>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <hr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'hr\'">\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'hr\'" class="row form-group">\n' +
    '          <div class="col-md-12">\n' +
    '            <label class="p-l-10 notification-additional-infos">\n' +
    '              {{"settings.notificationSmsNumber" | translate}} {{settings.model.userSettings.gsmCountryCode}} {{settings.model.userSettings.gsmOperator}} {{settings.model.userSettings.gsm}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-md-12">\n' +
    '            <label class="p-l-10 notification-additional-infos">\n' +
    '              {{"settings.notificationMailAddress" | translate}} {{settings.model.userSettings.notificationEmail}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '      <!-- ======================  -->\n' +
    '      <!-- END: NOTIFICATIONS TAB  -->\n' +
    '      <!-- ======================  -->\n' +
    '\n' +
    '      <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'hr\' && settings.selectedTab === \'notifications\'" class="row p-t-15">\n' +
    '        <div class="col-md-12">\n' +
    '          <button class="btn btn-primary pull-left"\n' +
    '                  ng-click="settings.editUserSettings()"\n' +
    '                  translate="payments.cancel">\n' +
    '          </button>\n' +
    '          <button class="btn btn-default pull-right"\n' +
    '                  ng-click="settings.updateUserSettings()"\n' +
    '                  translate="settings.contactInfoConfirmBtn">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <!-- =================== -->\n' +
    '      <!-- START: SECURITY TAB -->\n' +
    '      <!-- =================== -->\n' +
    '      <div ng-switch-when="security" class="settings-content">\n' +
    '\n' +
    '        <ng-form ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" name="settings.securityForm">\n' +
    '          <!-- SLOVENIA -->\n' +
    '          <div ng-switch-when="sl">\n' +
    '            <h4 class="settings-conc-info bold-font" translate="settings.additionalTransactionsInfo">\n' +
    '              <b>Additional transactions confirmation</b>\n' +
    '            </h4>\n' +
    '            <div class="row form-group">\n' +
    '              <div class="col-md-6">\n' +
    '                <label>\n' +
    '                  <input type="radio" ng-model="settings.model.security.transactionConfirmation" value="0"\n' +
    '                         ng-disabled="!settings.securityEditActive">\n' +
    '                  <span translate="settings.passwordFromOTP"\n' +
    '                        class="stat-deliv">Password from OTP password generator</span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-md-6">\n' +
    '                <label>\n' +
    '                  <input type="radio" ng-model="settings.model.security.transactionConfirmation" value="1"\n' +
    '                         ng-disabled="!settings.securityEditActive">\n' +
    '                  <span translate="settings.passwordFromSMS"\n' +
    '                        class="stat-deliv">Receive password via SMS on mobile phone</span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <p>\n' +
    '              <span translate="settings.transactionsConfirmationText"></span><a\n' +
    '              href="https://www.addiko.si/potrjevanje-transakcij-v-spletni-banki-addiko-ebank" class="underline"\n' +
    '              target="blank" translate="settings.transactionsConfirmationLink"></a>\n' +
    '            </p>\n' +
    '            <div class="row form-group">\n' +
    '              <div class="col-md-12">\n' +
    '                <span>\n' +
    '                  <button class="btn btn-primary" ng-if="settings.securityEditActive"\n' +
    '                          ng-click="settings.securityEditActive = !settings.securityEditActive"\n' +
    '                          translate="settings.contactInfoCancelBtn">Cancel\n' +
    '                    Cancel\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '                <span class="pull-right">\n' +
    '                  <button class="btn btn-default" ng-if="!settings.securityEditActive"\n' +
    '                          ng-click="settings.securityEditActive = !settings.securityEditActive"\n' +
    '                          translate="settings.contactInfoBtn">\n' +
    '                    Edit\n' +
    '                  </button>\n' +
    '                  <button class="btn btn-default" ng-if="settings.securityEditActive"\n' +
    '                          ng-click="settings.securityEditConfirm()" ng-disabled="settings.confirmButtonPressed"\n' +
    '                          translate="settings.contactInfoConfirmBtn">\n' +
    '                    Save\n' +
    '                  </button>\n' +
    '                    <button class="btn btn-default" data-ui-sref="settings.orderSoftToken"\n' +
    '                            translate="settings.orderSoftToken">\n' +
    '                    Order soft token\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <hr>\n' +
    '            <h4 class="settings-conc-info bold-font" translate="settings.blockadeOfAddikoEbank">\n' +
    '              <b>BLOCKADE OF ADDIKO EBANK OPERATIONS</b>\n' +
    '            </h4>\n' +
    '            <p translate="settings.blockadeOfAddikoEBankText">You can disable the us of the Addiko EBank and/or the\n' +
    '              Addiko Mobile bank for a fixed or indefinite period of time.</p>\n' +
    '            <div class="row form-group">\n' +
    '              <div class="col-md-12 text-right">\n' +
    '                <button class="btn btn-default" style="text-transform: uppercase"\n' +
    '                        ng-click="settings.securitySetBlockade()" translate="settings.setBlockade">\n' +
    '                  Set blockade\n' +
    '                </button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-12">\n' +
    '                <h4 class="settings-conc-info bold-font" translate="settings.unsubscribeHeader"></h4>\n' +
    '                <p translate="settings.unsubscribeText"></p>\n' +
    '              </div>\n' +
    '                  <div class="col-md-12 text-right">\n' +
    '                    <button class="btn btn-default"\n' +
    '                            ng-disabled="!settings.model.userSettings.mobileBankEnabled"\n' +
    '                            ng-click="settings.updateUserMobileSetting()"\n' +
    '                            translate="settings.unsubscribeButton">\n' +
    '                      Set blockade\n' +
    '                    </button>\n' +
    '                  </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <!-- SERBIA/MONTENEGRO/BIH -->\n' +
    '          <div ng-switch-default>\n' +
    '            <div class="row form-group">\n' +
    '              <div class="col-md-6">\n' +
    '                <label class="domp-form-label" translate="settings.oldPass">Old password</label>\n' +
    '                <input type="password" name="oldPass" id="oldPass" ng-model="settings.model.security.oldPassword"\n' +
    '                       minlength="{{settings.inputOptions.minLengthOld}}"\n' +
    '                       maxlength="{{settings.inputOptions.maxLength}}"\n' +
    '                       ng-blur="settings.inputOptions.oldPassValid = true"\n' +
    '                       class="form-control" required/>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="settings.country == \'bh\' && settings.inputOptions.oldPassValid && (settings.securityForm.oldPass.$error.minlength || settings.securityForm.oldPass.$error.maxlength)"\n' +
    '                      translate="settings.lengthOldError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row form-group">\n' +
    '              <div class="col-md-6">\n' +
    '                <label class="domp-form-label" translate="settings.newPass">New password</label>\n' +
    '                <input type="password" class="form-control" name="newPass" id="newPass"\n' +
    '                       minlength="{{settings.inputOptions.minLength}}"\n' +
    '                       maxlength="{{settings.inputOptions.maxLength}}"\n' +
    '                       ng-blur="settings.checkForValidation();"\n' +
    '                       ng-model="settings.model.security.newPassword" required/>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="settings.country == \'bh\' && settings.inputOptions.checkForValidation && (settings.securityForm.newPass.$error.minlength || settings.securityForm.newPass.$error.maxlength)"\n' +
    '                      translate="settings.lengthError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row  form-group" ng-class="{\'domp-to-section p-0 p-b-20\': settings.country == \'bh\'}">\n' +
    '              <div class="col-md-6">\n' +
    '                <label class="domp-form-label" translate="settings.againPass">Again new password</label>\n' +
    '                <input name="confirmNewPassword" type="password" class="form-control"\n' +
    '                       minlength="{{settings.inputOptions.minLength}}"\n' +
    '                       maxlength="{{settings.inputOptions.maxLength}}"\n' +
    '                       ng-model="settings.model.security.confirmNewPassword" ng-blur="settings.compareNewPassword()"\n' +
    '                       required/>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="settings.securityForm.confirmNewPassword.$error.incorrect"\n' +
    '                      translate="settings.noMatch"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="settings.model.userSettings.linkList.itemList.mothersLastName && settings.country == \'bh\'"\n' +
    '                 class="row  form-group">\n' +
    '              <div class="col-xs-6">\n' +
    '                <label class="domp-form-label" translate="settings.mothersLastName ">Mothers last name</label>\n' +
    '                <input name="confirmNewPassword" type="text" class="form-control"\n' +
    '                       ng-model="settings.model.security.mothersLastName"/>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="settings.securityForm.mothersLastName.$error.incorrect"\n' +
    '                      translate="settings.required"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="settings.model.userSettings.linkList.itemList.email && settings.country == \'bh\'"\n' +
    '                 class="row form-group">\n' +
    '              <div class="col-xs-6">\n' +
    '                <label class="domp-form-label" translate="settings.email">Email</label>\n' +
    '                <input name="email" type="text" class="form-control"\n' +
    '                       ng-model="settings.model.security.email"/>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="settings.securityForm.email.$error.incorrect"\n' +
    '                      translate="settings.required"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row ">\n' +
    '              <div class="col-md-6">\n' +
    '                <button class="btn btn-default pull-right" type="submit" translate="settings.change"\n' +
    '                        ng-click="settings.change()"></button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </ng-form>\n' +
    '      </div>\n' +
    '      <!-- ==================  -->\n' +
    '      <!-- END SECURITY TAB -->\n' +
    '      <!-- =================== -->\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('settings/order-soft-token.tpl.html',
    '<section id="main">\n' +
    '    <div class="container-fluid">\n' +
    '        <!-- START Title -->\n' +
    '        <div class="row">\n' +
    '            <div class="col-md-12" style="z-index:1;">\n' +
    '                <div class="tmplt-list-title col-md-12 p-r-0 p-l-0 m-b-15">\n' +
    '                    <h2 class="title-style" translate="orderSoftToken.title">Naročilo programskega generatorja gesel</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <!-- END Title -->\n' +
    '\n' +
    '\n' +
    '        <div class="row p-l-15">\n' +
    '            <div class="col-sm-12 ost-info-section">\n' +
    '                <p class="ost-info-txt" translate="orderSoftToken.infoTxt1">Oddate lahko naročilo za programski generator gesel, ki ga lahko uporabljate namesto strojnega generatorja gesel. Programski generator je aplikacija na vašem mobilnem telefonu, ki omogoča generiranje enkratnih gesel za vstop v Addiko EBanko ter Addiko Mobile in lahko v celoti nadomešča strojni generator gesel.\n' +
    '                </p>\n' +
    '                <p class="ost-info-txt m-b-0">\n' +
    '                    <span translate="orderSoftToken.infoTxt2">Po uspešni izvedbi naročila boste v poštni predal Addiko EBanke ter na številko vašega mobilnega telefona prejeli 2 ločena aktivacijska ključa za aktiviranje programskega generatorja gesel (Soft tokena), ki služi generiranju enkratnih gesel. Več informacij o programskem generatorju gesel lahko dobite</span> <span translate="orderSoftToken.linkTxt" class="underline pointer-cst" ng-click="orderSoftToken.openWebsite();">na naši spletni strani. [https://www.addiko.si/pristop-k-spletni-banki-addiko-ebank]</span>\n' +
    '                </p>\n' +
    '            </div>\n' +
    '          <form name="orderSoftToken.orderSoftTokenForm" novalidate ng-if="orderSoftToken.steps.step1">\n' +
    '            <div class="col-sm-12 col-xs-12 ost-edit-section bg-white">\n' +
    '              <div class="col-md-6 col-xs-12 p-r-0">\n' +
    '                  <label class="ost-label col-md-12 p-l-0" translate="settings.emailAddress"></label>\n' +
    '                  <div class="col-md-12 p-l-0">\n' +
    '                    <div class="col-md-8 p-l-0" ng-if="orderSoftToken.userSettings.notificationEmail && orderSoftToken.changeEmailButton">\n' +
    '                      <p class="ost-value m-b-0">{{orderSoftToken.userSettings.notificationEmail}}</p>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!--<input type="text" class="form-control disabled" name="notificationEmail"-->\n' +
    '                         <!--data-ng-model="orderSoftToken.notificationEmail"-->\n' +
    '                         <!--data-ng-class="{\'domp-error\': orderSoftToken.orderSoftTokenForm.notificationEmail.$invalid && orderSoftToken.formSubmitted}"-->\n' +
    '                         <!--ng-disabled="orderSoftToken.changeEmailButton && orderSoftToken.userSettings.notificationEmail"-->\n' +
    '                         <!--ng-if="!orderSoftToken.userSettings.notificationEmail || !orderSoftToken.changeEmailButton"-->\n' +
    '                         <!--required>-->\n' +
    '\n' +
    '                    <!--<span class="c-red"\n' +
    '                          ng-show="orderSoftToken.orderSoftTokenForm.notificationEmail.$error.required && orderSoftToken.formSubmitted"\n' +
    '                          translate="orderSoftToken.notificationEmailError"></span>-->\n' +
    '                  </div>\n' +
    '                <!--<div class="col-md-12 p-l-0 p-t-15 col-xs-12 p-r-0">-->\n' +
    '                    <!--<div class="col-md-6 col-xs-12 p-r-0 p-l-0 p-b-20" ng-show="orderSoftToken.changeEmailButton && orderSoftToken.userSettings.notificationEmail">-->\n' +
    '                      <!--<button class="btn btn-primary app-btn-blue" data-ng-model="orderSoftToken.changeEmailButton" data-ng-click="orderSoftToken.changeEmail()" translate="orderSoftToken.changeEmail">Change email</button>-->\n' +
    '                    <!--</div>-->\n' +
    '                  <!--<div class="col-md-3 col-xs-3 pull-right" ng-show="!orderSoftToken.changeEmailButton || !orderSoftToken.userSettings.notificationEmail">-->\n' +
    '                    <!--<button class="btn btn-primary app-btn-blue pull-right" data-ng-model="orderSoftToken.changeEmailButton" data-ng-click="orderSoftToken.changeEmailOk()" translate="orderSoftToken.okBtn">OK</button>-->\n' +
    '                  <!--</div>-->\n' +
    '                  <!--<div class="col-md-3 col-xs-3 pull-right" ng-show="!orderSoftToken.changeEmailButton || !orderSoftToken.userSettings.notificationEmail">-->\n' +
    '                      <!--<button class="btn btn-primary app-btn-blue pull-right" data-ng-model="orderSoftToken.changeEmailButton" data-ng-click="orderSoftToken.changeEmailCancel()" translate="orderSoftToken.cancelBtn">Cancel</button>-->\n' +
    '                   <!--</div>-->\n' +
    '                  <!--</div>-->\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-6 col-xs-12 p-r-0">\n' +
    '                    <label class="ost-label col-md-12 p-l-0" translate="settings.gsm"></label>\n' +
    '                    <div class="col-md-12 p-l-0">\n' +
    '                      <div class="col-md-8 p-l-0" >\n' +
    '                        <p ng-if="orderSoftToken.userSettings.gsm" class="ost-value m-b-0">{{orderSoftToken.userSettings.gsm}}</p>\n' +
    '                        <button ng-if="!orderSoftToken.userSettings.gsm" class="btn btn-default" translate="mobilePhoneSettings.setMobilePhoneNumber"  ng-click="orderSoftToken.setMobilePhoneNumber(orderSoftToken.userSettings.gsm)"></button>\n' +
    '                      </div>\n' +
    '\n' +
    '                    <!--<input type="text" class="form-control disabled" name="gsm"-->\n' +
    '                           <!--data-ng-model="orderSoftToken.gsm"-->\n' +
    '                           <!--data-ng-class="{\'domp-error\': orderSoftToken.orderSoftTokenForm.gsm.$invalid && orderSoftToken.formSubmitted}"-->\n' +
    '                           <!--ng-disabled="orderSoftToken.changeGsmButton && orderSoftToken.userSettings.gsm"-->\n' +
    '                           <!--ng-if="!orderSoftToken.userSettings.gsm || !orderSoftToken.changeGsmButton"-->\n' +
    '                           <!--required>-->\n' +
    '\n' +
    '                    <!--<span class="c-red"\n' +
    '                          ng-show="orderSoftToken.orderSoftTokenForm.gsm.$error.required && orderSoftToken.formSubmitted"\n' +
    '                          translate="orderSoftToken.gsm"></span>-->\n' +
    '                  </div>\n' +
    '                  <!--<div class="col-md-12 p-l-0 p-t-15 col-xs-12 p-r-0">-->\n' +
    '                    <!--<div class="col-md-6 col-xs-12 p-r-0 p-l-0 p-b-20" ng-show="orderSoftToken.changeGsmButton && orderSoftToken.userSettings.gsm">-->\n' +
    '                      <!--<button class="btn btn-primary app-btn-blue" data-ng-model="orderSoftToken.changeGsmButton" data-ng-click="orderSoftToken.changeGsm()" translate="orderSoftToken.changeGsm">Change email</button>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--<div class="col-md-3 pull-right col-xs-3" ng-show="!orderSoftToken.changeGsmButton || !orderSoftToken.userSettings.gsm">-->\n' +
    '                      <!--<button class="btn btn-primary app-btn-blue pull-right" data-ng-model="orderSoftToken.changeGsmButton" data-ng-click="orderSoftToken.changeGsmOk()" translate="orderSoftToken.okBtn">OK</button>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--<div class="col-md-3 pull-right col-xs-3" ng-show="!orderSoftToken.changeGsmButton || !orderSoftToken.userSettings.gsm">-->\n' +
    '                      <!--<button class="btn btn-primary app-btn-blue pull-right" data-ng-model="orderSoftToken.changeGsmButton" data-ng-click="orderSoftToken.changeGsmCancel()" translate="orderSoftToken.cancelBtn">Cancel</button>-->\n' +
    '                    <!--</div>-->\n' +
    '                  <!--</div>-->\n' +
    '                </div>\n' +
    '                <div class="col-sm-12 p-l-0 p-r-0 p-b-0 p-t-15 col-xs-12">\n' +
    '\n' +
    '                        <div class="col-md-6">\n' +
    '                            <button class="btn btn-primary pull-left ng-scope" type="button" translate="orderSoftToken.cancelBtn" data-ui-sref="settings">Cancel</button>\n' +
    '                        </div>\n' +
    '                        <div class="col-md-6">\n' +
    '                            <button class="btn btn-default pull-right ng-scope" type="submit" translate="orderSoftToken.nextBtn" ng-disabled="orderSoftToken.validationInProgress || (!orderSoftToken.userSettings.gsm || !orderSoftToken.userSettings.notificationEmail)" ng-click="orderSoftToken.submitOrder();">Next</button>\n' +
    '                        </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '          <!-- ================= -->\n' +
    '          <!-- ====  STEP 2 ==== -->\n' +
    '          <!-- ================= -->\n' +
    '          <div class="col-sm-12 col-xs-12 ost-edit-section" ng-if="orderSoftToken.steps.step2">\n' +
    '            <div class="intp-form-container bottom-border">\n' +
    '              <div class="row">\n' +
    '                <div class="col-md-4">\n' +
    '                  <label class="domp-form-label" translate="orderSoftToken.nameAndSurmane"></label>\n' +
    '                </div>\n' +
    '                <div class="col-md-8">\n' +
    '                  <label class="domp-form-label-resume">\n' +
    '                    {{orderSoftToken.responseModel.nameAndSurname}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row">\n' +
    '                <div class="col-md-4">\n' +
    '                  <label class="domp-form-label" translate="settings.emailAddress"></label>\n' +
    '                </div>\n' +
    '                <div class="col-md-8">\n' +
    '                  <label class="domp-form-label-resume">\n' +
    '                    {{orderSoftToken.responseModel.email}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row">\n' +
    '                <div class="col-md-4">\n' +
    '                  <label class="domp-form-label" translate="settings.gsm"></label>\n' +
    '                </div>\n' +
    '                <div class="col-md-8">\n' +
    '                  <label class="domp-form-label-resume">\n' +
    '                    {{orderSoftToken.responseModel.phoneNumber}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="intp-form-container">\n' +
    '              <div class="row">\n' +
    '                <div class="col-xs-6 t-a-l">\n' +
    '                  <button class="btn btn-primary pull-left ng-scope" type="button" translate="orderSoftToken.backBtn" ng-click="orderSoftToken.back();">Back</button>\n' +
    '                </div>\n' +
    '                <div class="col-xs-6 t-a-r">\n' +
    '                  <button class="btn btn-default pull-right ng-scope" type="submit" translate="orderSoftToken.okBtn" ng-disabled="orderSoftToken.confirmationInProgress" ng-click="orderSoftToken.confirmSoftTokenOrder();">Next</button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('settings/mobile-phone-number.tpl.html',
    '<div id="main">\n' +
    '  <div class="container-fluid p-t-15">\n' +
    '    <h2 class="m-l-0 f-28 m-t-0 m-b-0 title-style" translate="mobilePhoneSettings.title"></h2>\n' +
    '\n' +
    '    <div ng-show="vm.steps.input" class="alert alert-info m-t-10"\n' +
    '         style="background: white; color: black; border: 1px solid lightgray">\n' +
    '      <p translate="mobilePhoneSettings.headerInfoText"></p>\n' +
    '    </div>\n' +
    '    <!-- ================= -->\n' +
    '    <!-- START: Step Input-->\n' +
    '    <!-- ================= -->\n' +
    '    <ng-form ng-show="vm.steps.input" name="vm.phoneNumberForm">\n' +
    '      <div class="domp-from-section p-15 m-t-25">\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-3">\n' +
    '            <label class="domp-form-label">{{"mobilePhoneSettings.mobilePhoneLabel" | translate }}</label>\n' +
    '          </div>\n' +
    '          <div class="col-md-5">\n' +
    '            <input type="text" class="form-control" ng-model="vm.model.gsm"\n' +
    '                   name="gsm"\n' +
    '                   ui-mask="999 999 999"\n' +
    '                   ui-mask-placeholder\n' +
    '                   ui-mask-placeholder-char="_"\n' +
    '                   required/>\n' +
    '            <div class="c-red"\n' +
    '                 ng-show="vm.phoneNumberForm.gsm.$error.required && vm.formSubmitted"\n' +
    '                 translate="mobilePhoneSettings.gsmPhoneError">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '              <input name="isConfirmed" type="checkbox" ng-model="vm.model.isConfirmed" required>\n' +
    '              <i class="input-helper"></i>\n' +
    '              <span translate="mobilePhoneSettings.confirmMobilePhone"></span>\n' +
    '            </label>\n' +
    '            <span class="c-red"\n' +
    '                  ng-show="vm.phoneNumberForm.isConfirmed.$error.required && vm.formSubmitted"\n' +
    '                  translate="mobilePhoneSettings.requiredField">\n' +
    '          </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-8">\n' +
    '            <p class="m-0"><b>{{ "mobilePhoneSettings.firstConfirmationTitle" | translate | uppercase }}</b></p>\n' +
    '            <p translate="mobilePhoneSettings.firstConfirmationText"></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-8">\n' +
    '            <p class="m-0"><b>{{" mobilePhoneSettings.changingExistingNumberTitle" | translate | uppercase }}</b></p>\n' +
    '            <p translate="mobilePhoneSettings.changingExistingNumberText"></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-8">\n' +
    '            <p class="m-0"><b>{{ "mobilePhoneSettings.newPhoneNumberTitle" | translate | uppercase}}</b></p>\n' +
    '            <p translate="mobilePhoneSettings.newPhoneNumberText"></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row  m-t-25">\n' +
    '        <div class="form-group clearfix">\n' +
    '          <div class="col-md-12">\n' +
    '            <button class="btn btn-primary pull-left" ui-sref="settings" translate="payments.cancel"></button>\n' +
    '            <button class="btn btn-default pull-right" translate="orders.next" ng-click="vm.next()" ng-disabled="vm.validationInProgress"></button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </ng-form>\n' +
    '    <!-- ================= -->\n' +
    '    <!-- END: Step Input-->\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ================= -->\n' +
    '    <!-- START: Step Resume -->\n' +
    '    <!-- ================= -->\n' +
    '    <ng-form ng-show="vm.steps.resume" name="vm.phoneNumberResumeForm">\n' +
    '      <div class="domp-from-section p-15 m-t-25">\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="mobilePhoneSettings.orderDate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-5">\n' +
    '            <p><b>{{vm.model.orderDate | date: \'dd.MM.yyyy hh:mm:ss\'}}</b></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="mobilePhoneSettings.orderType"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-5">\n' +
    '            <p><b translate="mobilePhoneSettings.orderTypeInfo"></b></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="mobilePhoneSettings.mobilePhoneLabel"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-5">\n' +
    '            <p><b>{{ vm.model.gsmPhoneFormatted }}</b></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="mobilePhoneSettings.dataConfirmation"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-5">\n' +
    '            <p>\n' +
    '              <b ng-if="vm.model.isConfirmed" translate="alert.yes"></b>\n' +
    '              <b ng-if="!vm.model.isConfirmed" translate="alert.no"></b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row p-t-20">\n' +
    '          <div class="col-md-12">\n' +
    '            <label class="domp-form-label" translate="mobilePhoneSettings.additionalPaymentConfirmationTitle"></label>\n' +
    '            <p translate="mobilePhoneSettings.additionalPaymentConfirmationText"></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <p class="m-b-5" translate="mobilePhoneSettings.SMSCode"></p>\n' +
    '          </div>\n' +
    '          <div class="col-md-4">\n' +
    '            <input type="text" name="signData" class="form-control" maxlength="8" ng-model="vm.model.signData" required>\n' +
    '            <div class="c-red"\n' +
    '                 ng-show="vm.phoneNumberResumeForm.signData.$error.required && vm.resumeFormSubmitted"\n' +
    '                 translate="mobilePhoneSettings.SMSCodeRequired">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row  m-t-25">\n' +
    '          <div class="form-group clearfix">\n' +
    '            <div class="col-md-12">\n' +
    '              <button class="btn btn-primary pull-left" translate="domesticPayment.back"\n' +
    '                      ng-click="vm.steps.resume = false; vm.steps.input = true;"></button>\n' +
    '              <button class="btn btn-default pull-right" translate="termDeposit.confirmBtnLabel"\n' +
    '                      ng-disabled="vm.confirmationInProgress"\n' +
    '                      ng-click="vm.confirm()"></button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </ng-form>\n' +
    '    <!-- ================= -->\n' +
    '    <!-- END: Step Resume -->\n' +
    '    <!-- ================= -->\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row">\n' +
    '      <div class="tmplt-list-title col-md-12 p-r-0 m-b-15">\n' +
    '\n' +
    '        <h2 translate="sepa.header" class="f-28"></h2>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">\n' +
    '        <div class="accounts-dropdown m-b-10" ng-if="sepa.currentAccounts.length > 0">\n' +
    '          <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '               data-ng-click="sepa.fromAccountDropdown = !sepa.fromAccountDropdown"\n' +
    '               ng-style="sepa.model.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + sepa.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '              <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{sepa.model.fromAccountSelect.friendlyName}}</b>\n' +
    '              <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                <i class="zmdi"\n' +
    '                   ng-class="{\'zmdi-star favorite-account\':sepa.model.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!sepa.model.fromAccountSelect.isFavorite}">\n' +
    '                </i>\n' +
    '              </span>\n' +
    '            </h4>\n' +
    '            <p class="m-b-0 m-t-0 iban-style">{{sepa.model.fromAccountSelect.iban}}</p>\n' +
    '            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '              {{sepa.model.fromAccountSelect.availableBalance| number:2}}\n' +
    '              {{sepa.model.fromAccountSelect.currencySymbol}}\n' +
    '            </p>\n' +
    '            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '            <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '          </div>\n' +
    '          <div class="from-accounts-list m-l-15" ng-show="sepa.fromAccountDropdown" scrollable>\n' +
    '            <div class="accounts-list-item p-0" data-ng-repeat="item in sepa.currentAccounts"\n' +
    '                 data-ng-click="sepa.setAccountFrom(item);">\n' +
    '\n' +
    '              <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                   ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                  <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                  <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                      ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                </h4>\n' +
    '                <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                  {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                </p>\n' +
    '                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="accounts-dropdown m-b-10" ng-if="sepa.currentAccounts.length == 0">\n' +
    '          <div class="debit-account-widget dashboard-widget-item" style="height: 141px;"\n' +
    '               ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '            <div class="m-t-30 m-b-30">\n' +
    '              <p translate="internalTransfer.nodata"></p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-sm-6 col-lg-6 m-b-20">\n' +
    '        <div class="account-item-add-message app-dblue-card" ng-click="sepa.addNewSetting()">\n' +
    '          <div class="round-btn-container2">\n' +
    '            <div class="round-btn-m">\n' +
    '              <i class="icon icon-add icon-add-msg bold-font f-24"></i>\n' +
    '            </div>\n' +
    '            <div class="round-btn-label-msg">\n' +
    '              <h3 class="round-btn-label-msg f-20">{{\'sepa.addNew\'| translate}}</h3>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- NEED NEW TIMELINE !!!!!???????  -->\n' +
    '\n' +
    '    <div data-ng-include="\'sepa/sepa-timeline.tpl.html\'"></div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-transactions-overview.tpl.html',
    '<section id="main" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row">\n' +
    '      <div class="tmplt-list-title col-md-12 p-r-0 m-b-15" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '        <h2 ng-switch-default translate="sepa.transactionsHeader" class="f-28"></h2>\n' +
    '        <h2 ng-switch-when="hr" translate="navigation.sepaTransactions_CRO" class="f-28"></h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ================ -->\n' +
    '    <!-- DEFAULT -->\n' +
    '    <!-- =============== -->\n' +
    '    <div ng-switch-default>\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12 col-sm-6 col-lg-5 m-b-20">\n' +
    '          <div class="account-item-add-message app-dblue-card " ng-click="sepaTrans.goToNewSepa()">\n' +
    '            <div class="round-btn-container2">\n' +
    '              <div class="round-btn-m">\n' +
    '                <i class="icon icon-add icon-add-msg bold-font f-24"></i>\n' +
    '              </div>\n' +
    '              <div class="round-btn-label-msg">\n' +
    '                <h3 class="round-btn-label-msg f-20" translate="sepa.addNew"></h3>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12" style="z-index:1;">\n' +
    '          <!-- Easier way to duplicate code - than modifying CSS width-->\n' +
    '          <div class="po-type-container">\n' +
    '            <div ng-class="{\'selected\': sepaTrans.paymentsTypeSelected === 1}"\n' +
    '                 ng-click="sepaTrans.selectPaymentsType(\'Waiting\', \'sepa.paymentsType.pendingTab\')"\n' +
    '                 class="po-type-tab no-wrap-text" style="width:33%"\n' +
    '                 translate="sepa.paymentsType.pendingTab"></div>\n' +
    '            <div ng-class="{\'selected\': sepaTrans.paymentsTypeSelected === 2}"\n' +
    '                 ng-click="sepaTrans.selectPaymentsType(\'Rejected\', \'sepa.paymentsType.rejectedTab\')"\n' +
    '                 class="po-type-tab no-wrap-text" style="width:34%">\n' +
    '              {{ \'sepa.paymentsType.rejectedTab\' | translate}}\n' +
    '              <!--            <div class="pull-right tab-bubble">\n' +
    '                            <div class="dn-item-bubble">123</div>\n' +
    '                          </div>-->\n' +
    '            </div>\n' +
    '            <div ng-class="{\'selected\': sepaTrans.paymentsTypeSelected === 3}"\n' +
    '                 ng-click="sepaTrans.selectPaymentsType(\'Processed\', \'sepa.paymentsType.executedTab\')"\n' +
    '                 class="po-type-tab no-wrap-text" style="width:33%"\n' +
    '                 translate="sepa.paymentsType.executedTab"></div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="po-filter-row col-sm-12 clearfix p-20 bgm-white" style="z-index:1;">\n' +
    '\n' +
    '            <div class="col-sm-6 col-xs-12  p-0" style="height:40px">\n' +
    '              <!--<div class="tml-filter-container tmlf-wide" id="searchFilterExpandedDiv">-->\n' +
    '              <!--<div id="searchBtnLeftDiv" class="inner-section left">-->\n' +
    '              <!--<i class="icon icon-search i-p24 m-l-5"></i>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--<div id="searchBtnCenterDiv" class="inner-section center">-->\n' +
    '              <!--<input id="searchTimelineInput" type="text" class="search-input"\n' +
    '              placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '              ng-model="sepaTrans.paymentSearch" ng-model-options="{debounce: 300}">-->\n' +
    '              <!--</div>-->\n' +
    '              <!--<div id="searchBtnRightDiv" class="inner-section right">-->\n' +
    '              <!--<i ng-show="sepaTrans.paymentSearch.length" class="zmdi zmdi-tag-close  zmdi-hc-2x m-r-0" ng-click="sepaTrans.paymentSearch = \'\';"></i>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--</div>-->\n' +
    '              <div ng-include="\'sepa/sepa-overview-filter.tpl.html\'" style="height:40px"></div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-6 col-xs-12 p-0 m-m-t-10">\n' +
    '              <div class="dropdown acc-period-select pull-right" style="display: inline-block">\n' +
    '                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"\n' +
    '                        aria-haspopup="true"\n' +
    '                        aria-expanded="true">\n' +
    '                  {{ sepaTrans.selectedPeriod.item.description | translate}}\n' +
    '                  <span class="caret"></span>\n' +
    '                </button>\n' +
    '                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                  <li data-ng-repeat="period in sepaTrans.periodList">\n' +
    '                    <a href="" class="f-13" data-ng-click="sepaTrans.sepaPeriodFilter(period)">\n' +
    '                      {{period.item.description| translate}}\n' +
    '                    </a>\n' +
    '                  </li>\n' +
    '                </ul>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div class="timeline-row payments col-sm-12 no-padding">\n' +
    '            <div class="hypo-timeline-wrapper app-white-card p-0 p-b-10 p-t-10">\n' +
    '              <div class="t-a-c p-10 no-data-image" ng-if="!sepaTrans.timelineListGrouped.result.length">\n' +
    '                <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                <h3 class="no-data-label" translate="sepa.noData"></h3>\n' +
    '              </div>\n' +
    '              <ul class="hypo-timeline payments-list" ng-if="sepaTrans.timelineListGrouped.result.length !== 0">\n' +
    '                <li class=""\n' +
    '                    ng-repeat="payment in sepaTrans.timelineListGrouped.result| filter: sepaTrans.paymentSearch">\n' +
    '                  <span class="currency-time-frame" style="margin-left:14px;" ng-if="payment.isVirtual">{{payment.valueDate| date:\'shortDate\'}}</span>\n' +
    '                  <i ng-if="!payment.isVirtual" class="icon icon-change currency-icon-change icon-lh"></i>\n' +
    '                  <div ng-if="!payment.isVirtual" class="hypo-timeline-item payment-item"\n' +
    '                       ng-class="{\'opened\': payment.selected}" ng-click="sepaTrans.showDetails(payment)">\n' +
    '                    <div class="hypo-timeline-body">\n' +
    '                      <div class="col-xs-9">\n' +
    '                        <h4 ng-if="payment.purpose" class="m-b-0 m-t-0 c-gray"\n' +
    '                            ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                          <div class="bold-font-payment wrap-text" ng-switch-default>{{::payment.purpose}}</div>\n' +
    '                          <div class="bold-font-payment" style="white-space:normal; word-wrap: break-word"\n' +
    '                               ng-switch-when="sl">{{::payment.purpose}}\n' +
    '                          </div>\n' +
    '                        </h4>\n' +
    '                        <h4 ng-if="!payment.purpose" class="m-b-0 m-t-0 bold-font-payment">\n' +
    '                          <div>{{\'paymentsTypeGroup.\' + payment.paymentTypeGroup | translate}}</div>\n' +
    '                        </h4>\n' +
    '\n' +
    '                        <p class="m-b-0 m-t-0 iban-style-paym wrap-text">{{::payment.toAccountNumber}}\n' +
    '                          {{::payment.receiverName}}</p>\n' +
    '                        <p ng-show="paymentsOverview.showPaymentId" class="m-b-0 m-t-0 iban-style" id="paymentId">\n' +
    '                          {{::payment.id}}</p>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <!-- Other payment types -->\n' +
    '                      <div ng-if="sepaTrans.paymentsTypeSelected !== 5" class="col-xs-3">\n' +
    '                      <span class="pull-right t-a-r f-18">\n' +
    '                        <b class="price-payment" style="font-weight:600; font-size:22px;"\n' +
    '                           ng-if="::payment.sepaComplaintAmount2">{{::payment.sepaComplaintAmount2|number:2}} {{::payment.destinationCurrencySymbol}}</b>\n' +
    '                        <b class="price-payment" style="font-weight: 600; font-size:22px; "\n' +
    '                           ng-if="::!payment.sepaComplaintAmount2">{{::payment.amount|number:2}} EUR</b>\n' +
    '                        <br/>\n' +
    '                        <span ng-class="{\'text-danger\': payment.status === \'Rejected\'}"\n' +
    '                              ng-if="payment.status === \'Rejected\'" translate="paymentsOverview.rejected"\n' +
    '                              style="color:#d70303;"></span>\n' +
    '                        <span ng-if="payment.status === \'Processed\'" translate="paymentsOverview.processed"\n' +
    '                              style="color:#042603;"></span>\n' +
    '                        <span ng-if="payment.status === \'Cancelled\'" translate="paymentsOverview.cancelled"></span>\n' +
    '                        <span style="color:#9eabd5;" ng-if="payment.status === \'InProcessing\'"\n' +
    '                              translate="paymentsOverview.inProcessing"></span>\n' +
    '                        <span ng-if="payment.status === \'Opened\'" translate="paymentsOverview.open"></span>\n' +
    '                        <span ng-if="payment.status === \'WaitingQueue\'"\n' +
    '                              translate="paymentsOverview.waitingQueque"></span>\n' +
    '                        <span ng-if="payment.status === \'Signed\'" translate="paymentsOverview.signed"></span>\n' +
    '                      </span>\n' +
    '                      </div>\n' +
    '                      <div class="clear"></div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="payment.selected" class="sepaComplaint-details">\n' +
    '                      <i ng-if="!payment.isVirtual" class="icon icon-change currency-icon-change-2"></i>\n' +
    '                      <div>\n' +
    '                        <table class="table table-transparent table-responsive">\n' +
    '                          <tbody>\n' +
    '                          <tr ng-if="paymentsOverview.paymentsTypeSelected === 5">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlStatus"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label" ng-class="{\'text-danger\': payment.status === \'Rejected\'}"\n' +
    '                                    ng-if="payment.status === \'Rejected\'" translate="paymentsOverview.rejected"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Processed\'"\n' +
    '                                    translate="paymentsOverview.processed"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Cancelled\'"\n' +
    '                                    translate="paymentsOverview.cancelled"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'InProcessing\'"\n' +
    '                                    translate="paymentsOverview.inProcessing"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Opened\'"\n' +
    '                                    translate="paymentsOverview.open"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'WaitingQueue\'"\n' +
    '                                    translate="paymentsOverview.waitingQueque"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Signed\'"\n' +
    '                                    translate="paymentsOverview.signed"></span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!-- START: DETAILS -->\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.payerAccNumber"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.senderAccount}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.recAccNumber"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.receiverAccount}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.uniMandateRef"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.mandateReference}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.dueDate"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.paymentDate| date:\'shortDate\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.creditorInd"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label"><span ng-if="!payment.receiverIdentificator">/</span>{{::payment.receiverIdentificator}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.recReference"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label"><span ng-if="!payment.receiverReference">/</span>{{::payment.receiverReference}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="payment.status === \'Rejected\'">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.messageAboutError"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                            <span class="po-value-label"><span\n' +
    '                              ng-if="!payment.message">/</span>{{::payment.message}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!-- END: DETAILS -->\n' +
    '\n' +
    '                          <tr>\n' +
    '                            <td colspan="2">\n' +
    '                              <div>\n' +
    '                                <!--TEST BUTTON-->\n' +
    '                                <!--<button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"-->\n' +
    '                                <!--translate="paymentActions.recall"-->\n' +
    '                                <!--ng-click="sepaTrans.refund(payment)">-->\n' +
    '                                <!--Recall payment-->\n' +
    '                                <!--</button>-->\n' +
    '                                <span class="pull-right" ng-repeat="actionObject in payment.allowedActionList.itemList">\n' +
    '                                  <span ng-switch="actionObject.methodName">\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                            translate="paymentActions.recall"\n' +
    '                                            ng-if="actionObject.isEnabled" ng-switch-when="RecallAllowed"\n' +
    '                                            ng-click="sepaTrans.refund(payment)">\n' +
    '                                      Recall payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                            translate="paymentActions.sign"\n' +
    '                                            ng-if="actionObject.isEnabled && payment.status != \'WaitingQueue\'"\n' +
    '                                            ng-switch-when="SignAllowed"\n' +
    '                                            data-ng-click="sepaTrans.signPayment(payment)">\n' +
    '                                      Sign payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                            translate="paymentActions.delete"\n' +
    '                                            ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed"\n' +
    '                                            ng-click="sepaTrans.deletePaymentAction(payment.id)">\n' +
    '                                      Delete payment\n' +
    '                                    </button>\n' +
    '                                  </span>\n' +
    '                                </span>\n' +
    '                                <span ng-if="payment.linkList.itemList.complaint">\n' +
    '                                  <button ng-if="payment.status == \'Waiting\'"\n' +
    '                                          class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                          translate="sepa.complaint"\n' +
    '                                          ng-disabled="payment.isDisabled"\n' +
    '                                          ng-click="sepaTrans.complaint(payment); $event.stopPropagation();">\n' +
    '                                    Complaint\n' +
    '                                  </button>\n' +
    '                                  <button ng-if="payment.status == \'Processed\'"\n' +
    '                                          class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                          translate="sepa.refund"\n' +
    '                                          ng-disabled="payment.isDisabled"\n' +
    '                                          ng-click="sepaTrans.refund(payment);">\n' +
    '                                    Refund\n' +
    '                                  </button>\n' +
    '                                </span>\n' +
    '                              </div>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          </tbody>\n' +
    '                        </table>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </li>\n' +
    '              </ul>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 t-a-c m-t-15">\n' +
    '          <button ng-if="sepaTrans.timelineListGrouped.hasMore == true"\n' +
    '                  data-ng-click="sepaTrans.loadMore()" type="input"\n' +
    '                  class="btn btn-default app-btn-blue-inverse show-all-accounts-btn"\n' +
    '                  translate="paymentsOverview.loadMoreBtn">Load more\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ================ -->\n' +
    '    <!-- CROATIA -->\n' +
    '    <!-- =============== -->\n' +
    '    <div ng-switch-when="hr">\n' +
    '      <!-- START: Timeline -->\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12" style="z-index:1;">\n' +
    '          <!-- START: Tabs  -->\n' +
    '          <div class="po-type-container">\n' +
    '            <div ng-class="{\'selected\': sepaTrans.paymentsTypeSelected === 1}"\n' +
    '                 ng-click="sepaTrans.selectPaymentsType(\'Waiting\', \'sepa.directDebitTabs.pending\')"\n' +
    '                 class="po-type-tab no-wrap-text" style="width:33%"\n' +
    '                 translate="sepa.directDebitTabs.pending"></div>\n' +
    '            <div ng-class="{\'selected\': sepaTrans.paymentsTypeSelected === 3}"\n' +
    '                 ng-click="sepaTrans.selectPaymentsType(\'Processed\', \'sepa.directDebitTabs.processed\')"\n' +
    '                 class="po-type-tab no-wrap-text" style="width:33%"\n' +
    '                 translate="sepa.directDebitTabs.processed">\n' +
    '            </div>\n' +
    '            <div ng-class="{\'selected\': sepaTrans.paymentsTypeSelected === 2}"\n' +
    '                 ng-click="sepaTrans.selectPaymentsType(\'Rejected\', \'sepa.directDebitTabs.rejected\')"\n' +
    '                 class="po-type-tab no-wrap-text" style="width:34%"\n' +
    '                 translate="sepa.directDebitTabs.rejected">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- END: Tabs  -->\n' +
    '          <div class="po-filter-row col-sm-12 clearfix p-20 bgm-white" style="z-index:1;">\n' +
    '            <div class="col-sm-6 col-xs-12  p-0" style="height:40px">\n' +
    '              <div ng-include="\'sepa/sepa-overview-filter.tpl.html\'" style="height:40px"></div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 col-xs-12 p-0 m-m-t-10">\n' +
    '              <div class="dropdown acc-period-select pull-right" style="display: inline-block">\n' +
    '                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"\n' +
    '                        aria-haspopup="true"\n' +
    '                        aria-expanded="true">\n' +
    '                  {{ sepaTrans.selectedPeriod.item.description | translate}}\n' +
    '                  <span class="caret"></span>\n' +
    '                </button>\n' +
    '                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                  <li data-ng-repeat="period in sepaTrans.periodList">\n' +
    '                    <a href="" class="f-13" data-ng-click="sepaTrans.sepaPeriodFilter(period)">\n' +
    '                      {{period.item.description| translate}}\n' +
    '                    </a>\n' +
    '                  </li>\n' +
    '                </ul>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="timeline-row payments col-sm-12 no-padding">\n' +
    '            <div class="hypo-timeline-wrapper app-white-card p-0 p-b-10 p-t-10">\n' +
    '              <div class="t-a-c p-10 no-data-image" ng-if="!sepaTrans.timelineListGrouped.result.length">\n' +
    '                <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                <h3 class="no-data-label" translate="sepa.noData"></h3>\n' +
    '              </div>\n' +
    '              <ul class="hypo-timeline payments-list" ng-if="sepaTrans.timelineListGrouped.result.length !== 0">\n' +
    '                <li class=""\n' +
    '                    ng-repeat="payment in sepaTrans.timelineListGrouped.result| filter: sepaTrans.paymentSearch">\n' +
    '                  <span class="currency-time-frame" style="margin-left:14px;" ng-if="payment.isVirtual">{{payment.valueDate| date:\'shortDate\'}}</span>\n' +
    '                  <i ng-if="!payment.isVirtual" class="icon icon-change currency-icon-change icon-lh"></i>\n' +
    '                  <div ng-if="!payment.isVirtual" class="hypo-timeline-item payment-item"\n' +
    '                       ng-class="{\'opened\': payment.selected}" ng-click="sepaTrans.showDetails(payment)">\n' +
    '                    <div class="hypo-timeline-body">\n' +
    '                      <div class="col-xs-9">\n' +
    '                        <h4 ng-if="payment.purpose" class="m-b-0 m-t-0 c-gray"\n' +
    '                            ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                          <div class="bold-font-payment wrap-text" ng-switch-default>{{::payment.purpose}}</div>\n' +
    '                          <div class="bold-font-payment" style="white-space:normal; word-wrap: break-word"\n' +
    '                               ng-switch-when="sl">{{::payment.purpose}}\n' +
    '                          </div>\n' +
    '                        </h4>\n' +
    '                        <h4 ng-if="!payment.purpose" class="m-b-0 m-t-0 bold-font-payment">\n' +
    '                          <div>{{\'paymentsTypeGroup.\' + payment.paymentTypeGroup | translate}}</div>\n' +
    '                        </h4>\n' +
    '\n' +
    '                        <p class="m-b-0 m-t-0 iban-style-paym wrap-text">{{::payment.toAccountNumber}}\n' +
    '                          {{::payment.receiverName}}</p>\n' +
    '                        <p ng-show="paymentsOverview.showPaymentId" class="m-b-0 m-t-0 iban-style" id="paymentId">\n' +
    '                          {{::payment.id}}</p>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <!-- Other payment types -->\n' +
    '                      <div ng-if="sepaTrans.paymentsTypeSelected !== 5" class="col-xs-3">\n' +
    '                      <span class="pull-right t-a-r f-18">\n' +
    '                        <b class="price-payment" style="font-weight:600; font-size:22px;"\n' +
    '                           ng-if="::payment.sepaComplaintAmount2">{{::payment.sepaComplaintAmount2|number:2}} {{::payment.destinationCurrencySymbol}}</b>\n' +
    '                        <b class="price-payment" style="font-weight: 600; font-size:22px; "\n' +
    '                           ng-if="::!payment.sepaComplaintAmount2">{{::payment.amount|number:2}} {{::payment.curr}}</b>\n' +
    '                        <br/>\n' +
    '                        <span ng-class="{\'text-danger\': payment.status === \'Rejected\'}"\n' +
    '                              ng-if="payment.status === \'Rejected\'" translate="paymentsOverview.rejected"\n' +
    '                              style="color:#d70303;"></span>\n' +
    '                        <span ng-if="payment.status === \'Processed\'" translate="paymentsOverview.processed"\n' +
    '                              style="color:#042603;"></span>\n' +
    '                        <span ng-if="payment.status === \'Cancelled\'" translate="paymentsOverview.cancelled"></span>\n' +
    '                        <span style="color:#9eabd5;" ng-if="payment.status === \'InProcessing\'"\n' +
    '                              translate="paymentsOverview.inProcessing"></span>\n' +
    '                        <span ng-if="payment.status === \'Opened\'" translate="paymentsOverview.open"></span>\n' +
    '                        <span ng-if="payment.status === \'WaitingQueue\'"\n' +
    '                              translate="paymentsOverview.waitingQueque"></span>\n' +
    '                        <span ng-if="payment.status === \'Signed\'" translate="paymentsOverview.signed"></span>\n' +
    '                      </span>\n' +
    '                      </div>\n' +
    '                      <div class="clear"></div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="payment.selected" class="sepaComplaint-details">\n' +
    '                      <i ng-if="!payment.isVirtual" class="icon icon-change currency-icon-change-2"></i>\n' +
    '                      <div>\n' +
    '                        <table class="table table-transparent table-responsive">\n' +
    '                          <tbody>\n' +
    '                          <tr ng-if="paymentsOverview.paymentsTypeSelected === 5">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlStatus"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label" ng-class="{\'text-danger\': payment.status === \'Rejected\'}"\n' +
    '                                    ng-if="payment.status === \'Rejected\'" translate="paymentsOverview.rejected"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Processed\'"\n' +
    '                                    translate="paymentsOverview.processed"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Cancelled\'"\n' +
    '                                    translate="paymentsOverview.cancelled"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'InProcessing\'"\n' +
    '                                    translate="paymentsOverview.inProcessing"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Opened\'"\n' +
    '                                    translate="paymentsOverview.open"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'WaitingQueue\'"\n' +
    '                                    translate="paymentsOverview.waitingQueque"></span>\n' +
    '                              <span class="po-value-label" ng-if="payment.status === \'Signed\'"\n' +
    '                                    translate="paymentsOverview.signed"></span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!-- START: DETAILS -->\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="sepa.transactionId"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.transactionId}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="sepa.transactionDetails.payerAccount"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.senderAccount}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="sepa.transactionDetails.receiverAccount"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.receiverAccount}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="sepa.receiverName"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.receiverName}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="sepa.receiverNumber"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.receiverReference}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="sepaTrans.paymentsTypeSelected === 2 && payment.message">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="sepa.additionalInfo"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.message}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!--<tr>-->\n' +
    '                            <!--<td>-->\n' +
    '                              <!--<span class="po-desc-label" translate="paymentsOverview.dueDate"></span>-->\n' +
    '                            <!--</td>-->\n' +
    '                            <!--<td>-->\n' +
    '                              <!--<span class="po-value-label">{{::payment.paymentDate| date:\'shortDate\'}}</span>-->\n' +
    '                            <!--</td>-->\n' +
    '                          <!--</tr>-->\n' +
    '                          <!--<tr>-->\n' +
    '                            <!--<td>-->\n' +
    '                              <!--<span class="po-desc-label" translate="paymentsOverview.creditorInd"></span>-->\n' +
    '                            <!--</td>-->\n' +
    '                            <!--<td>-->\n' +
    '                              <!--<span class="po-value-label"><span ng-if="!payment.receiverIdentificator">/</span>{{::payment.receiverIdentificator}}</span>-->\n' +
    '                            <!--</td>-->\n' +
    '                          <!--</tr>-->\n' +
    '                          <!--<tr>-->\n' +
    '                            <!--<td>-->\n' +
    '                              <!--<span class="po-desc-label" translate="paymentsOverview.recReference"></span>-->\n' +
    '                            <!--</td>-->\n' +
    '                            <!--<td>-->\n' +
    '                              <!--<span class="po-value-label"><span ng-if="!payment.receiverReference">/</span>{{::payment.receiverReference}}</span>-->\n' +
    '                            <!--</td>-->\n' +
    '                          <!--</tr>-->\n' +
    '                          <!--<tr ng-if="payment.status === \'Rejected\'">-->\n' +
    '                            <!--<td>-->\n' +
    '                              <!--<span class="po-desc-label" translate="paymentsOverview.messageAboutError"></span>-->\n' +
    '                            <!--</td>-->\n' +
    '                            <!--<td>-->\n' +
    '                            <!--<span class="po-value-label"><span-->\n' +
    '                              <!--ng-if="!payment.message">/</span>{{::payment.message}}</span>-->\n' +
    '                            <!--</td>-->\n' +
    '                          <!--</tr>-->\n' +
    '                          <!-- END: DETAILS -->\n' +
    '\n' +
    '                          <tr ng-if="sepaTrans.paymentsTypeSelected === 1 && payment.complaint">\n' +
    '                            <td colspan="2">\n' +
    '                              <div>\n' +
    '                                <span class="pull-right">\n' +
    '                                   <button class="btn btn-default app-btn-blue-inverse pull-right" ui-sref="sepa.accepted-refusal-cro({transactionId: payment.transactionId})" translate="sepa.refusalOrderBtn">\n' +
    '                                    Refusal\n' +
    '                                  </button>\n' +
    '                                </span>\n' +
    '                              </div>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!--U detaljima obradjenih SDD naloga prikazati opciju Povrat SDD naloga samo ako je complaint=true-->\n' +
    '                          <tr ng-if="sepaTrans.paymentsTypeSelected === 3 && payment.complaint">\n' +
    '                            <td colspan="2">\n' +
    '                              <div>\n' +
    '                                <span class="pull-right">\n' +
    '                                   <button class="btn btn-default app-btn-blue-inverse pull-right"\n' +
    '                                           ng-click="sepaTrans.refuseSepaOrder(payment.transactionId)"\n' +
    '                                           translate="sepa.sddPaymentReturn">\n' +
    '                                    Refusal\n' +
    '                                  </button>\n' +
    '                                </span>\n' +
    '                              </div>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          </tbody>\n' +
    '                        </table>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </li>\n' +
    '              </ul>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 t-a-c m-t-15">\n' +
    '          <button ng-if="sepaTrans.timelineListGrouped.hasMore == true"\n' +
    '                  data-ng-click="sepaTrans.loadMore()" type="input"\n' +
    '                  class="btn btn-default app-btn-blue-inverse show-all-accounts-btn"\n' +
    '                  translate="paymentsOverview.loadMoreBtn">Load more\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END: Timeline -->\n' +
    '\n' +
    '      <div class="row m-t-20 m-b-20">\n' +
    '        <div class="col-xs-12 col-sm-6 col-lg-6 m-b-20">\n' +
    '          <div class="account-item-add-message app-dblue-card " ui-sref="sepa.refusal-cro">\n' +
    '            <div class="round-btn-container2">\n' +
    '              <div class="round-btn-m">\n' +
    '                <i class="icon icon-add icon-add-msg bold-font f-24"></i>\n' +
    '              </div>\n' +
    '              <div class="round-btn-label-msg">\n' +
    '                <h3 class="round-btn-label-msg f-20" translate="sepa.refusalTitle"></h3>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="timeline-row col-md-12">\n' +
    '          <div class="t-a-c p-10 no-data-image" ng-if="sepaTrans.sepaDDComplaints.length == 0">\n' +
    '            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '            <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '          </div>\n' +
    '          <div class="app-white-card p-t-15"\n' +
    '               ng-hide="sepaTrans.sepaDDComplaints.result.length == 0">\n' +
    '            <ul class="hypo-timeline p-t-10">\n' +
    '              <li ng-class="{\'time-label p-t-15\': term.isVirtual}"\n' +
    '                  ng-repeat="sepaComplaint in sepaTrans.sepaDDComplaints.result">\n' +
    '              <span class="currency-time-frame" style="margin-left:14px"\n' +
    '                    ng-if="sepaComplaint.isVirtual === true">\n' +
    '                {{(sepaComplaint.valueDate) | date:\'shortDate\'}}\n' +
    '              </span>\n' +
    '                <i class="zmdi zmdi-timer" ng-if="!sepaComplaint.isVirtual"></i>\n' +
    '                <div ng-if="!sepaComplaint.isVirtual" class="hypo-timeline-item payment-item"\n' +
    '                     ng-click="sepaTrans.showComplaintDetails(sepaComplaint)" ng-class="{\'opened\': sepaComplaint.selected}">\n' +
    '                  <div class="hypo-timeline-body">\n' +
    '                    <div class="col-xs-8">\n' +
    '                      <h4 class="m-b-0 m-t-10 ">\n' +
    '                        <b class="m-r-10">{{sepaComplaint.sepaDDComplaintOrderType.description}} </b> <b class="c-gray"> {{sepaComplaint.receiverName}}</b>\n' +
    '                      </h4>\n' +
    '                    </div>\n' +
    '                    <!--<div class="col-xs-8 visible-xs p-l-0">-->\n' +
    '                      <!--<h4 class="m-b-0 m-t-10 f-12 c-gray">-->\n' +
    '                        <!--<b>{{sepaComplaint.receiverName}}</b>-->\n' +
    '                      <!--</h4>-->\n' +
    '                    <!--</div>-->\n' +
    '\n' +
    '                    <div class="col-xs-4">\n' +
    '                      <span class="pull-right t-a-r m-t-5 f-18">\n' +
    '                        <b>{{sepaComplaint.amount|number:2}} HRK\n' +
    '                        </b>\n' +
    '                        <br/>\n' +
    '                        <span ng-switch="sepaComplaint.statusCode">\n' +
    '                          <span ng-switch-when="0" translate="sepa.status_created"></span>\n' +
    '                          <span ng-switch-when="1" translate="sepa.status_processed"></span>\n' +
    '                          <span ng-switch-when="2" translate="sepa.status_rejected"></span>\n' +
    '                          {{sepaComplaint.translatedStatus | translate}}\n' +
    '                        </span>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <!--<div class="col-xs-4 visible-xs p-r-0">-->\n' +
    '                      <!--<span class="pull-right t-a-r m-t-5 f-12">-->\n' +
    '                        <!--<b>-->\n' +
    '                          <!--{{sepaComplaint.amount|number:2}} HRK-->\n' +
    '                        <!--</b>-->\n' +
    '                        <!--<br/>-->\n' +
    '                        <!--<span ng-switch="sepaComplaint.statusCode">-->\n' +
    '                          <!--<span ng-switch-when="0" translate="sepa.status_created"></span>-->\n' +
    '                          <!--<span ng-switch-when="1" translate="sepa.status_processed"></span>-->\n' +
    '                          <!--<span ng-switch-when="2" translate="sepa.status_rejected"></span>-->\n' +
    '                          <!--{{sepaComplaint.translatedStatus | translate}}-->\n' +
    '                        <!--</span>-->\n' +
    '                      <!--</span>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <div class="clear"></div>\n' +
    '                  </div>\n' +
    '                  <div ng-if="sepaComplaint.selected" class="transaction-details">\n' +
    '                  <div data-ng-include="\'sepa/sepa-complaints-timeline-details.tpl.html\'"></div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '          <div class="show-more-btn">\n' +
    '            <button ng-if="sepaTrans.sepaDDComplaints.hasMore"\n' +
    '                    data-ng-click="sepaTrans.loadMoreSepaDDComplaints()"\n' +
    '                    type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                    translate="messages.loadMore">\n' +
    '              Load older events\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-timeline.tpl.html',
    '<!-- TIMELINE CONTAINER -->\n' +
    '<!--\n' +
    '<div class="row p-15">\n' +
    '   <div class="col-xs-4 dropdown acc-period-select " style="display: inline-block">\n' +
    '    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '      {{termDeposit.selectedPeriod.item.description | translate}}\n' +
    '      <span class="caret"></span>\n' +
    '    </button>\n' +
    '    <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '      <li data-ng-repeat="period in termDeposit.periodList">\n' +
    '        <a href="" class="f-13" data-ng-click="termDeposit.paymentsPeriodFilter(period)">\n' +
    '          {{period.item.description | translate}}\n' +
    '        </a>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '   <div class="col-xs-8 pull-right">\n' +
    '    <label class="checkbox checkbox-inline m-l-15 pull-right">\n' +
    '      <input type="checkbox" data-ng-model="termDeposit.allRequests" data-ng-click="termDeposit.loadAllAccountsTimeline()">\n' +
    '      <span class="input-helper" translate="ebook.showAllRequests">Prikaži zahtjeve za sve račune</span>\n' +
    '    </label>\n' +
    '  </div>\n' +
    '</div>\n' +
    '-->\n' +
    '<div class="timeline-row col-sm-12 no-padding">\n' +
    '  <div class="t-a-c p-10 no-data-image" ng-if="sepa.debitAccountList.length == 0">\n' +
    '    <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '    <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '  </div>\n' +
    '  <div class="hypo-timeline-wrapper app-white-card" ng-hide="sepa.debitAccountList.length == 0">\n' +
    '    <ul class="hypo-timeline sepa-timeline" kcd-recompile="sepa.timelineListGrouped" >\n' +
    '      <li ng-class="{\'time-label\': item.isVirtual}" ng-repeat="item in sepa.debitAccountList">\n' +
    '        <h4 class="timeline-separator-title bold-font" style="background: none; border: none; font-size: none" ng-if="item.isVirtual === true">{{item.date | date: \'shortDate\'}}</h4>\n' +
    '        <i class="zmdi zmdi-sepa icon i-p24 icon-settings" ng-if="!item.isVirtual"></i>\n' +
    '        <div ng-if="!item.isVirtual" class="hypo-timeline-item payment-item"><!-- if clickable ng-click="item.selected = !item.selected;" ng-class="{\'opened\': item.selected}"> -->\n' +
    '          <div class="hypo-timeline-body">\n' +
    '            <div class="col-xs-7 hidden-xs">\n' +
    '              <h4 class="m-b-0 m-t-10">\n' +
    '                <b>{{item.settingType.description}}</b>\n' +
    '              </h4>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-xs-5 hidden-xs p-r-10">\n' +
    '              <span class="pull-right t-a-r f-18">\n' +
    '                <b class="m-r-10" ng-if="item.hasOwnProperty(\'maxAmount\')">{{item.maxAmount|number:2}} {{ sepa.model.fromAccountSelect.currencySymbol}}</b>\n' +
    '                  <b class="m-r-10" ng-click="sepa.openSwitchItemActiveStateModal(item);"><span style="text-decoration: underline;" ng-if="item.activated" translate="sepa.isActive"></span><span style="text-decoration: underline;" ng-if="!item.activated" translate="sepa.notActive"></span></b>\n' +
    '                  <button ng-disabled="item.settingType.id == 4 || item.editInProgress" class="btn btn-default domp-review-and-submit-btn " type="button" translate="sepa.edit" data-ng-click="sepa.edit(item);" >Edit</button>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-xs-6 visible-xs p-l-0">\n' +
    '              <h4 class="m-b-0 m-t-10 f-12">\n' +
    '                <b>{{item.settingType.description}}</b>\n' +
    '              </h4>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 visible-xs p-r-0">\n' +
    '              <span class="pull-right t-a-r f-12">\n' +
    '                <b class="m-r-10" ng-if="item.hasOwnProperty(\'maxAmount\')">{{item.maxAmount|number:2}} {{ sepa.model.fromAccountSelect.currencySymbol}}</b>\n' +
    '                  <b class="m-r-10" ng-click="sepa.openSwitchItemActiveStateModal(item);"><span style="text-decoration: underline;" ng-if="item.activated" translate="sepa.isActive"></span><span style="text-decoration: underline;" ng-if="!item.activated" translate="sepa.notActive"></span></b>\n' +
    '                  <button ng-if="item.settingType.id != 4 || item.editInProgress" class="btn btn-default domp-review-and-submit-btn " type="button" translate="sepa.edit" data-ng-click="sepa.edit(item);" >Edit</button>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\'" class=" col-xs-12 col-sm-7">\n' +
    '              <p class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                <span ng-if="item.receiverName">{{item.receiverName}}<br></span>\n' +
    '                <span ng-if="item.receiverId">{{item.receiverId}}<br></span>\n' +
    '                <span ng-if="item.executionPeriod">{{\'sepa.executionPeriodLabel\' | translate}}{{\'sepa.executionPeriod.\'+item.executionPeriod | translate}}</span>\n' +
    '              </p>\n' +
    '            </div>\n' +
    '            <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\'" class="col-xs-12 col-sm-4 t-a-r">\n' +
    '              <span ng-if="item.dateFrom" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                <span translate="sepa.dateFrom"></span>: <span>{{item.dateFrom |date: \'shortDate\'}}</span>\n' +
    '              </span>\n' +
    '              <br>\n' +
    '              <span ng-if="item.dateTo" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                <span translate="sepa.dateTo"></span>: <span>{{item.dateTo | date: \'shortDate\'}}</span>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '            <div class="clear"></div>\n' +
    '          </div>\n' +
    '          <!-- <div ng-if="item.selected" class="transaction-details">\n' +
    '            <div data-ng-include="\'sepa/sepa-timeline-details.tpl.html\'"></div>\n' +
    '          </div> -->\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '<!--    <div class="show-more-btn ">\n' +
    '      <button ng-hide="sepa.timelineListGrouped.hasMore == false" data-ng-click="sepa.loadMoreTimelineItemsGrouped(false)" type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents">Load older events</button>\n' +
    '    </div>-->\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!-- END TIMELINE -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-refusal-cro.tpl.html',
    '<section id="main" ng-if="vm.pageLoaded">\n' +
    '\n' +
    '  <div class="container-fluid clearfix m-b-40">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <h3 translate="sepa.refusalTitle">SEPA REFUSAL</h3>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- START FORM    -->\n' +
    '    <!-- ============= -->\n' +
    '    <!-- ======= -->\n' +
    '    <!-- START -->\n' +
    '    <!-- ======= -->\n' +
    '    <div ng-form name="vm.refusalForm"\n' +
    '         ng-if="vm.step == \'start\'"\n' +
    '         class="bg-white p-20 m-t-15 clearfix"\n' +
    '         novalidate>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">\n' +
    '          <div class="accounts-dropdown m-b-10" ng-if="vm.currentAccounts.length > 0">\n' +
    '            <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                 data-ng-click="vm.fromAccountDropdown = !vm.fromAccountDropdown"\n' +
    '                 ng-style="vm.model.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + vm.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '              <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{vm.model.fromAccountSelect.friendlyName}}</b>\n' +
    '                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                <i class="zmdi"\n' +
    '                   ng-class="{\'zmdi-star favorite-account\':vm.model.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!vm.model.fromAccountSelect.isFavorite}">\n' +
    '                </i>\n' +
    '              </span>\n' +
    '              </h4>\n' +
    '              <p class="m-b-0 m-t-0 iban-style">{{vm.model.fromAccountSelect.iban}}</p>\n' +
    '              <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                {{vm.model.fromAccountSelect.availableBalance| number:2}}\n' +
    '                {{vm.model.fromAccountSelect.currencySymbol}}\n' +
    '              </p>\n' +
    '              <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '              <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '            </div>\n' +
    '            <div class="from-accounts-list m-l-15" ng-show="vm.fromAccountDropdown" scrollable>\n' +
    '              <div class="accounts-list-item p-0" data-ng-repeat="item in vm.currentAccounts"\n' +
    '                   data-ng-click="vm.setAccountFrom(item);">\n' +
    '\n' +
    '                <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                     ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                        ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="accounts-dropdown m-b-10" ng-if="vm.currentAccounts.length == 0">\n' +
    '            <div class="debit-account-widget dashboard-widget-item" style="height: 141px;"\n' +
    '                 ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '              <div class="m-t-30 m-b-30">\n' +
    '                <p translate="internalTransfer.nodata"></p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.executionDate">\n' +
    '              Datum izvršenja\n' +
    '            </label>\n' +
    '            <div class="input-group ">\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     id="executionDate"\n' +
    '                     name="executionDate"\n' +
    '                     uib-datepicker-popup="shortDate"\n' +
    '                     data-ng-model="vm.model.executionDate"\n' +
    '                     show-weeks="false"\n' +
    '                     is-open="vm.executionDateDatepickerOpen"\n' +
    '                     datepicker-options="vm.dateOptions"\n' +
    '                     date-disabled="vm.datesDisabled(date, mode)"\n' +
    '                     ng-change="vm.onExecutionDateChange()"\n' +
    '                     show-button-bar="false"\n' +
    '                     readonly\n' +
    '                     required>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button data-ng-click="vm.executionDateDatepickerOpen = !vm.executionDateDatepickerOpen" type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                        style="border:1px solid #062a42;">\n' +
    '                  <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                </button>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.amount">\n' +
    '              Iznos\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="amount"\n' +
    '                   name="amount"\n' +
    '                   ng-model="vm.model.amount"\n' +
    '                   amount-input-mask\n' +
    '                   allow-empty="true"/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.identifierApproval">\n' +
    '              Identifikator suglasnosti\n' +
    '            </label>\n' +
    '            <input ng-class="{\'domp-error\': vm.formSubmitted && vm.refusalForm.identifierApproval.$invalid }"\n' +
    '                   type="text" class="form-control input-field"\n' +
    '                   id="identifierApproval"\n' +
    '                   name="identifierApproval"\n' +
    '                   ng-model="vm.model.identifierApproval"\n' +
    '                   required\n' +
    '                   maxlength="35"/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverId">\n' +
    '              Identifikator primatelja\n' +
    '            </label>\n' +
    '            <input type="text" name="receiverId" id="receiverId"\n' +
    '                   class="input-field form-control"\n' +
    '                   ng-class="{\'domp-error\': vm.formSubmitted && vm.refusalForm.receiverId.$invalid }"\n' +
    '                   ng-model="vm.model.receiverId"\n' +
    '                   ng-blur="vm.findIdInCreditorList(vm.model.receiverId)"\n' +
    '                   maxlength="32"\n' +
    '                   autocomplete="off" required>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverName">\n' +
    '              Naziv i sjedište primatelja plaćanja\n' +
    '            </label>\n' +
    '            <input ng-class="{\'domp-error\': vm.formSubmitted && vm.refusalForm.receiverName.$invalid }"\n' +
    '                   type="text" class="form-control input-field"\n' +
    '                   id="receiverName"\n' +
    '                   name="receiverName"\n' +
    '                   ng-model="vm.model.receiverName"\n' +
    '                   ng-readonly="vm.creditorInListExist"\n' +
    '                   required/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverAccount">\n' +
    '              Račun primatelja plaćanja\n' +
    '            </label>\n' +
    '            <input ng-class="{\'domp-error\': vm.formSubmitted && vm.refusalForm.receiverAccount.$invalid }"\n' +
    '                   type="text" class="form-control input-field"\n' +
    '                   id="receiverAccount"\n' +
    '                   name="receiverAccount"\n' +
    '                   ng-model="vm.model.receiverAccount"\n' +
    '                   required/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverNumber">\n' +
    '              Detalji plaćanja (poziv na broj primatelja)\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="receiverNumber"\n' +
    '                   name="receiverNumber"\n' +
    '                   ng-model="vm.model.receiverNumber"/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-20">\n' +
    '        <div class="col-md-12">\n' +
    '          <button class="btn btn-primary"\n' +
    '                  type="button"\n' +
    '                  translate="sepa.cancelBtnLabel"\n' +
    '                  ui-sref="sepa.transactions">\n' +
    '          </button>\n' +
    '\n' +
    '          <button class="btn btn-default pull-right"\n' +
    '                  type="submit"\n' +
    '                  translate="sepa.confirm"\n' +
    '                  ng-click="vm.submit(vm.refusalForm);"\n' +
    '                  ng-disabled="vm.submitButtonDisabled">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ======= -->\n' +
    '    <!-- RESUME -->\n' +
    '    <!-- ======= -->\n' +
    '    <div ng-if="vm.step == \'resume\'" class="bg-white p-20 m-t-15 clearfix">\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review" translate="sepa.executionDate">\n' +
    '            Datum izvršenja\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{ vm.model.executionDate | date: \'shortDate\' }}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review" translate="sepa.amount">\n' +
    '            Iznos\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{ vm.model.amount | currency:"" }}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review" translate="sepa.identifierApproval">\n' +
    '            Identifikator suglasnosti\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{ vm.model.identifierApproval }}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review" translate="sepa.receiverId">\n' +
    '            Identifikator primatelja\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{ vm.model.receiverId }}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review" translate="sepa.receiverName">\n' +
    '            Iznos\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{ vm.model.receiverName }}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review" translate="sepa.receiverAccount">\n' +
    '            Račun primatelja plaćanja\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{ vm.model.receiverAccount }}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review" translate="sepa.receiverNumber">\n' +
    '            Detalji plaćanja (poziv na broj primatelja)\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{ vm.model.receiverNumber }}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-20">\n' +
    '        <div class="col-md-12">\n' +
    '          <!--<button class="btn btn-primary"-->\n' +
    '                  <!--type="button"-->\n' +
    '                  <!--translate="sepa.cancelBtnLabel"-->\n' +
    '                  <!--ng-click="vm.step = \'start\'">-->\n' +
    '          <!--</button>-->\n' +
    '\n' +
    '          <button class="btn btn-default pull-right"\n' +
    '                  type="submit"\n' +
    '                  translate="eInvoicesModal.sign"\n' +
    '                  ng-click="vm.step = \'sign\';">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ============= -->\n' +
    '    <!-- SIGN FORM   -->\n' +
    '    <!-- ============= -->\n' +
    '    <div class="bg-white p-20 m-t-15 clearfix" ng-if="vm.step == \'sign\'">\n' +
    '      <!--<div class="row">-->\n' +
    '      <!--<div class="col-md-12">-->\n' +
    '      <!--<h4 translate="termDeposit.signTitle"></h4>-->\n' +
    '      <!--</div>-->\n' +
    '      <!--</div>-->\n' +
    '      <div class="col-xs-12 m-t-30 m-b-30">\n' +
    '        <div class="col-xs-12 m-b-20">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeDescription\' | translate}}</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeFirstCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field" disabled ng-value="vm.responseModel.challenge">\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeSecondCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field"\n' +
    '                 data-ng-model="vm.model.insertChallenge"\n' +
    '                 placeholder="{{\'signPayments.challengeSecondCode\' | translate}}"\n' +
    '                 autofocus>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '          <button class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                  data-ng-click="vm.confirmSign()"\n' +
    '                  ng-disabled="vm.model.insertChallenge === \'\' || vm.confirmSignBtnDisabled"\n' +
    '                  translate="signPayments.confirm">\n' +
    '            Confirm\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-overview-filter.tpl.html',
    '<div class="tml-filter-container tmlf-wide" id="searchFilterExpandedDiv">\n' +
    '  <div id="searchBtnLeftDiv" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="inner-section left">\n' +
    '    <i ng-switch-default class="icon icon-search i-p24 m-l-5"></i>\n' +
    '    <i ng-switch-when="sl" ng-click="sepaTrans.applyPaymentsFilter();" class="icon icon-search i-p24 m-l-5"></i>\n' +
    '  </div>\n' +
    '  <div id="searchBtnCenterDiv" class="inner-section center">\n' +
    '    <input id="searchTimelineInput" type="text" class="search-input"\n' +
    '           placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '           ng-model="sepaTrans.paymentSearch" ng-model-options="{debounce: 300}">\n' +
    '  </div>\n' +
    '  <div id="searchBtnRightDiv" class="inner-section right" ng-init="sepaTrans.showDeleteInputBtn = false">\n' +
    '    <i ng-show="!sepaTrans.showDeleteInputBtn" class="icon icon-filter i-p24 i-lh12 m-r-0" ng-click="sepaTrans.toggleFilterSelection();"></i>\n' +
    '    <i ng-show="sepaTrans.showDeleteInputBtn" class="zmdi zmdi-tag-close  zmdi-hc-2x m-r-0" ng-click="sepaTrans.paymentsFilter.purposeFTS = \'\'; sepaTrans.showDeleteInputBtn = false"></i>\n' +
    '  </div>\n' +
    '  <div class="tml-filter-selection" ng-class="{\'opened\': sepaTrans.searchFilterExpanded}">\n' +
    '    <div class="m-t-15" style="overflow:auto">\n' +
    '      <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '        <div class="form-group">\n' +
    '          <label class="f-12-s" translate="timelineFilter.amountFrom"></label>\n' +
    '          <input ng-keyup="$event.keyCode == 13 && sepaTrans.applyPaymentsFilter()" type="text"\n' +
    '                 class="form-control-db"\n' +
    '                 ng-model="sepaTrans.sepaFilter.amountGTE"\n' +
    '                 amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00"\n' +
    '                 maxlength="12" autocomplete="off">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 p-l-0 p-r-5">\n' +
    '        <div class="form-group">\n' +
    '          <label class="f-12-s" translate="timelineFilter.amountTo"></label>\n' +
    '          <input ng-keyup="$event.keyCode == 13 && sepaTrans.applyPaymentsFilter()" type="text"\n' +
    '                 class="form-control-db" ng-model="sepaTrans.sepaFilter.amountLTE"\n' +
    '                 amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" autocomplete="off">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--<div class="col-xs-2 p-0 p-t-25">-->\n' +
    '        <!--<select name="" id="" class="form-control-db"-->\n' +
    '                <!--ng-options="option.symbol for option in sepaTrans.currenciesList"-->\n' +
    '                <!--ng-model="sepaTrans.currencySelectObject">-->\n' +
    '        <!--</select>-->\n' +
    '      <!--</div>-->\n' +
    '    </div>\n' +
    '    <div class="m-b-15" style="overflow:auto">\n' +
    '      <div class="col-xs-6 t-a-l p-l-5">\n' +
    '        <button class="btn btn-primary app-btn-gray" ng-click="sepaTrans.resetPaymentsFilter();" translate="timelineFilter.reset"></button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r p-r-5">\n' +
    '        <button class="btn btn-default app-btn-blue w-100" ng-click="sepaTrans.applyPaymentsFilter();" translate="timelineFilter.apply"></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-order-refund-cro.tpl.html',
    '<section id="main" ng-if="vm.pageLoaded">\n' +
    '\n' +
    '  <div class="container-fluid clearfix m-b-40">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <h3 translate="sepa.sddPaymentReturn"></h3>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- START FORM    -->\n' +
    '    <!-- ============= -->\n' +
    '    <!-- ======= -->\n' +
    '    <!-- START -->\n' +
    '    <!-- ======= -->\n' +
    '    <div ng-form name="vm.refusalForm"\n' +
    '         ng-if="vm.step == \'start\'"\n' +
    '         class="bg-white p-20 m-t-15 clearfix"\n' +
    '         novalidate>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.payerAccount">\n' +
    '              Račun platitelja\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="fromAccount"\n' +
    '                   name="fromAccount"\n' +
    '                   ng-value="vm.model.senderAccount"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.amount">\n' +
    '              Iznos\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="amount"\n' +
    '                   name="amount"\n' +
    '                   ng-value="(vm.model.amount | currency: \'\') + \' HRK\'"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.transactionId">\n' +
    '              ID naloga\n' +
    '            </label>\n' +
    '            <input type="text" name="transactionId" id=transactionIdreceiverId"\n' +
    '                   class="input-field form-control"\n' +
    '                   ng-value="vm.model.transactionId"\n' +
    '                   readonly>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverName">\n' +
    '              Naziv i sjedište primatelja plaćanja\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="receiverName"\n' +
    '                   name="receiverName"\n' +
    '                   ng-value="vm.model.receiverName"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverAccount">\n' +
    '              Račun primatelja plaćanja\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="receiverAccount"\n' +
    '                   name="receiverAccount"\n' +
    '                   ng-value="vm.model.receiverAccount"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverNumber">\n' +
    '              Detalji plaćanja (poziv na broj primatelja)\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="receiverNumber"\n' +
    '                   name="receiverNumber"\n' +
    '                   ng-value="vm.model.receiverNumber"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-20">\n' +
    '        <div class="col-md-12">\n' +
    '          <button class="btn btn-primary"\n' +
    '                  type="button"\n' +
    '                  translate="sepa.cancelBtnLabel"\n' +
    '                  ui-sref="sepa.transactions">\n' +
    '          </button>\n' +
    '\n' +
    '          <button class="btn btn-default pull-right"\n' +
    '                  type="submit"\n' +
    '                  translate="sepa.confirm"\n' +
    '                  ng-click="vm.submit(vm.refusalForm);"\n' +
    '                  ng-disabled="vm.submitButtonDisabled">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- SIGN FORM   -->\n' +
    '    <!-- ============= -->\n' +
    '    <div class="bg-white p-20 m-t-15 clearfix" ng-if="vm.step == \'sign\'">\n' +
    '      <div class="col-xs-12 m-t-30 m-b-30">\n' +
    '        <div class="col-xs-12 m-b-20">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeDescription\' | translate}}</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeFirstCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field" disabled ng-value="vm.responseModel.challenge">\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeSecondCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field"\n' +
    '                 data-ng-model="vm.model.insertChallenge"\n' +
    '                 placeholder="{{\'signPayments.challengeSecondCode\' | translate}}"\n' +
    '                 autofocus>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '          <button class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                  data-ng-click="vm.confirmSign()"\n' +
    '                  ng-disabled="vm.model.insertChallenge === \'\' || vm.confirmSignBtnDisabled"\n' +
    '                  translate="signPayments.confirm">\n' +
    '            Confirm\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-new.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid m-t-30">\n' +
    '    <div class="row f-14">\n' +
    '\n' +
    '      <div class="col-sm-12">\n' +
    '        <div class="app-white-card m-b-15">\n' +
    '          <div class="intp-header-wrapper bottom-border" ng-show="!sepa.steps.step3">\n' +
    '            <div class="row p-10">\n' +
    '              <div class="col-xs-12">\n' +
    '                <h2 class="title-style" translate="sepa.newSepaHeader">New SEPA</h2>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div ng-show="sepa.steps.step1">\n' +
    '            <form name="sepa.sepaForm" novalidate>\n' +
    '              <div class="intp-form-container bottom-border">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-6 p-0">\n' +
    '                    <div class="col-sm-12">\n' +
    '                      <label class="ntd-form-label m-b-5" translate="sepa.debitAccountSelectLabel"></label>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12">\n' +
    '\n' +
    '                      <div class="accounts-dropdown m-b-10" ng-if="sepa.accountsFrom.length > 0">\n' +
    '\n' +
    '                        <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                             data-ng-click="sepa.fromAccountDropdown = !sepa.fromAccountDropdown"\n' +
    '                             ng-style="sepa.model.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + sepa.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                          <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                            <b\n' +
    '                              class="col-xs-10 p-0 m-t-10  no-wrap-text">{{sepa.model.fromAccountSelect.friendlyName}}</b>\n' +
    '                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                              <i class="zmdi"\n' +
    '                                 ng-class="{\'zmdi-star favorite-account\':sepa.model.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!sepa.model.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                          </h4>\n' +
    '                          <p class="m-b-0 m-t-0 iban-style">{{sepa.model.fromAccountSelect.iban}}</p>\n' +
    '                          <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                            {{sepa.model.fromAccountSelect.availableBalance| number:2}}\n' +
    '                            {{sepa.model.fromAccountSelect.currencySymbol}}\n' +
    '                          </p>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                          <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                        </div>\n' +
    '                        <div class="from-accounts-list m-l-15" ng-show="sepa.fromAccountDropdown" scrollable>\n' +
    '                          <div class="accounts-list-item p-0" data-ng-repeat="item in sepa.accountsFrom"\n' +
    '                               data-ng-click="sepa.setAccountFrom(item);">\n' +
    '\n' +
    '                            <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                                 ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                              <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                                  <i class="zmdi"\n' +
    '                                     ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                              </h4>\n' +
    '                              <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                              <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                              </p>\n' +
    '                              <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                      </div>\n' +
    '\n' +
    '                      <div class="accounts-dropdown m-b-10" ng-if="sepa.accountsFrom.length == 0">\n' +
    '\n' +
    '                        <div class="debit-account-widget dashboard-widget-item" style="height: 141px;"\n' +
    '                             ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                          <div class="m-t-30 m-b-30">\n' +
    '                            <p translate="internalTransfer.nodata"></p>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6 p-0">\n' +
    '\n' +
    '                    <div class="col-xs-12">\n' +
    '                      <label class="domp-form-label ng-scope" translate="sepa.limitType">Limit type</label>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12 p-t-5">\n' +
    '                      <div class="form-group" ng-class="{\'m-b-0\': sepa.model.settingTypeSelected.id == \'0\' && sepa.sepaTempObj.formSubmitted}">\n' +
    '                        <select class="form-control input-field"\n' +
    '                                name="sepaType"\n' +
    '                                ng-class="{\'domp-error\': sepa.model.settingTypeSelected.id == \'0\' && sepa.sepaTempObj.formSubmitted}"\n' +
    '                                ng-model="sepa.model.settingTypeSelected"\n' +
    '                                ng-options="option.description for option in sepa.settingType"\n' +
    '                                ng-change="sepa.onSettingTypeChange()"\n' +
    '                                required>\n' +
    '                        </select>\n' +
    '                      </div>\n' +
    '                      <span class="c-red" ng-show="sepa.model.settingTypeSelected.id == \'0\' && sepa.sepaTempObj.formSubmitted"\n' +
    '                            translate="sepa.requiredSettingTypeError">\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div ng-if="sepa.model.settingTypeSelected.id != \'4\'" class="col-xs-12">\n' +
    '                      <label class="ntd-form-label m-b-5" translate="sepa.amountInputLabel"></label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="sepa.model.settingTypeSelected.id != \'4\'" class="col-xs-12">\n' +
    '                      <div class="input-group">\n' +
    '                        <input type="text"\n' +
    '                               class="form-control input-field t-a-r ng-empty ng-invalid ng-invalid-required ng-invalid-maxlength ng-valid-min ng-valid-max ng-dirty ng-valid-parse ng-touched"\n' +
    '                               name="amountInput" id="amountInput" autocomplete="off" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                               amount-input-mask="" maxlength="12" ng-model="sepa.model.amountInput"\n' +
    '                               ng-required="sepa.model.settingTypeSelected.id != \'4\'"\n' +
    '                               ng-class="{\'domp-error\': sepa.paymentForm.amountInput.$invalid && sepa.model.formSubmitted}">\n' +
    '                        <span class="input-group-btn">\n' +
    '                          <button type="button"\n' +
    '                                  class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero ng-binding"\n' +
    '                                  style="border:1px solid #062a42;">\n' +
    '                            {{sepa.model.fromAccountSelect.currencySymbol}}\n' +
    '                          </button>\n' +
    '                        </span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="intp-form-container bottom-border">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-6 t-a-l">\n' +
    '                    <button type="button" class="btn btn-primary" translate="sepa.cancelBtnLabel"\n' +
    '                            ng-click="sepa.cancel()">\n' +
    '                    </button>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-6 t-a-r">\n' +
    '                    <button type="button" class="btn btn-default" translate="sepa.refundComplaint.next"\n' +
    '                            ng-disabled="!sepa.sepaForm.$valid" ng-click="sepa.confirm(sepaForm);">\n' +
    '                    </button>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </form>\n' +
    '          </div>\n' +
    '\n' +
    '          <!-- =============== -->\n' +
    '          <!-- Second step     -->\n' +
    '          <!-- =============== -->\n' +
    '          <div ng-show="sepa.steps.step2">\n' +
    '\n' +
    '            <div class="intp-form-container bottom-border">\n' +
    '              <div class="row">\n' +
    '                <div class="col-sm-4">\n' +
    '                  <label class="domp-form-label-review" translate="settings.forAccount"></label>:\n' +
    '                </div>\n' +
    '                <div class="col-sm-8 domp-form-label-resume">\n' +
    '                 {{sepa.model.fromAccountSelect.iban}} - {{sepa.model.fromAccountSelect.accountDescription}}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row">\n' +
    '                <div class="col-sm-4">\n' +
    '                  <label class="domp-form-label-review" translate="sepa.limitType"></label>:\n' +
    '                </div>\n' +
    '                <div class="col-sm-8 domp-form-label-resume">\n' +
    '                  {{sepa.model.settingTypeSelected.description}}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div ng-if="sepa.model.settingTypeSelected.id != \'4\'" class="row">\n' +
    '                <div class="col-sm-4">\n' +
    '                  <label class="domp-form-label-review" translate="termDeposit.amountInputLabel"></label>\n' +
    '                </div>\n' +
    '                <div class="col-sm-8 domp-form-label-resume">\n' +
    '                  {{sepa.model.amountInput | number:2}}\n' +
    '                  {{sepa.model.fromAccountSelect.currencySymbol}}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="intp-form-container bottom-border">\n' +
    '              <div class="row">\n' +
    '                <div class="col-md-12 m-t-20 t-a-r">\n' +
    '                    <!--<button class="btn btn-primary m-r-5 pull-left"-->\n' +
    '                            <!--data-ui-sref="sepa.settings"-->\n' +
    '                            <!--translate="termDeposit.cancelActionLabel">Cancel-->\n' +
    '                    <!--</button>-->\n' +
    '                    <button class="btn btn-primary pull-left"\n' +
    '                            ng-click="sepa.steps = {}; sepa.steps.step1 = true;"\n' +
    '                            translate="sepa.back">Back\n' +
    '                    </button>\n' +
    '                    <button class="btn btn-default pull-right"\n' +
    '                            ng-disabled="sepa.okButtonDisabled"\n' +
    '                            translate="sepa.confirmBtnLabel"\n' +
    '                            ng-click="sepa.ok()">Confirm\n' +
    '                    </button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!--<div ng-show="sepa.steps.step1" data-ng-include="\'orders/deposit-overview-timeline.tpl.html\'"></div>-->\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-new-cro.tpl.html',
    '<section id="main" ng-if="vm.pageLoaded">\n' +
    '\n' +
    '  <div class="container-fluid m-b-40">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <h3 translate="sepa.title"></h3>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- START FORM    -->\n' +
    '    <!-- ============= -->\n' +
    '    <div ng-if="vm.step == \'start\'" ng-form class="bg-white p-20 m-t-15 clearfix" name="vm.sepaForm" novalidate>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="domp-form-label ng-scope" translate="sepa.toAccount">To acccount</label>\n' +
    '          <div class="accounts-dropdown m-b-10" ng-if="vm.accountsFrom.length > 0">\n' +
    '            <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                 data-ng-click="vm.fromAccountDropdown = !vm.fromAccountDropdown"\n' +
    '                 ng-style="vm.model.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + vm.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '              <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{vm.model.fromAccountSelect.friendlyName}}</b>\n' +
    '                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                  <i class="zmdi"\n' +
    '                     ng-class="{\'zmdi-star favorite-account\':vm.model.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!vm.model.fromAccountSelect.isFavorite}"></i>\n' +
    '                </span>\n' +
    '              </h4>\n' +
    '              <p class="m-b-0 m-t-0 iban-style">{{vm.model.fromAccountSelect.iban}}</p>\n' +
    '              <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                {{vm.model.fromAccountSelect.availableBalance| number:2}}\n' +
    '                {{vm.model.fromAccountSelect.currencySymbol}}\n' +
    '              </p>\n' +
    '              <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '              <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '            </div>\n' +
    '            <div class="from-accounts-list m-l-15" ng-show="vm.fromAccountDropdown" scrollable>\n' +
    '              <div class="accounts-list-item p-0" data-ng-repeat="item in vm.accountsFrom"\n' +
    '                   data-ng-click="vm.setAccountFrom(item);">\n' +
    '\n' +
    '                <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                     ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                        <i class="zmdi"\n' +
    '                           ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i>\n' +
    '                    </span>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="accounts-dropdown m-b-10" ng-if="vm.accountsFrom.length == 0">\n' +
    '\n' +
    '            <div class="debit-account-widget dashboard-widget-item" style="height: 141px;"\n' +
    '                 ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '              <div class="m-t-30 m-b-30">\n' +
    '                <p translate="internalTransfer.nodata"></p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label ng-scope" translate="sepa.settingType">Setting type</label>\n' +
    '            <select class="form-control input-field"\n' +
    '                    name="sepaType"\n' +
    '                    ng-model="vm.model.sepaSettingType"\n' +
    '                    ng-options="\'sepa.executionType.\' + option.id | translate for option in vm.sepaSettingsTypesOptions"\n' +
    '                    ng-change="vm.onSettingTypeChange(vm.model.sepaSettingType)"\n' +
    '                    required>\n' +
    '            </select>\n' +
    '            <p class="m-t-10 c-red" ng-if="vm.model.sepaSettingType.descriptionAlert">\n' +
    '              {{vm.model.sepaSettingType.descriptionAlert}}\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <hr>\n' +
    '      <!-- START: Date from and date to (Always shown) -->\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.dateFrom">Datum od</label>\n' +
    '            <div class="input-group ">\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     id="dateFrom"\n' +
    '                     name="dateFrom"\n' +
    '                     uib-datepicker-popup="shortDate"\n' +
    '                     data-ng-model="vm.model.dateFrom"\n' +
    '                     show-weeks="false"\n' +
    '                     is-open="vm.dateFromDatepickerOpen"\n' +
    '                     datepicker-options="vm.dateOptions"\n' +
    '                     date-disabled="vm.datesFromDisabled(date, mode)"\n' +
    '                     ng-change="vm.onDateFromChange()"\n' +
    '                     show-button-bar="false"\n' +
    '                     readonly\n' +
    '                     required>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button data-ng-click="vm.dateFromDatepickerOpen = !vm.dateFromDatepickerOpen" type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                        style="border:1px solid #062a42;">\n' +
    '                  <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                </button>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.dateTo">Datum do</label>\n' +
    '            <div class="input-group ">\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     id="dateTo" name="dateTo"\n' +
    '                     uib-datepicker-popup="shortDate"\n' +
    '                     data-ng-model="vm.model.dateTo"\n' +
    '                     show-weeks="false"\n' +
    '                     is-open="vm.dateToDatepickerOpen"\n' +
    '                     datepicker-options="vm.dateOptions"\n' +
    '                     date-disabled="vm.datesToDisabled(date, mode)"\n' +
    '                     show-button-bar="false"\n' +
    '                     readonly>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button data-ng-click="vm.dateToDatepickerOpen = !vm.dateToDatepickerOpen" type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                        style="border:1px solid #062a42;">\n' +
    '                  <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                </button>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END: Date from and date to (Always shown) -->\n' +
    '      <!-- START: Id primatelja, naziv primatelja (Shown if different than BLOCK_ALL) -->\n' +
    '      <div class="row" ng-if="vm.model.sepaSettingType.id != \'BLOCK_ALL\'">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <div click-outside="vm.searchFilterExpanded = false;"\n' +
    '                 outside-if-not="expandReceiverSearch">\n' +
    '              <!--<div>-->\n' +
    '              <label class="domp-form-label" translate="sepa.receiverId">\n' +
    '                Identifikator primatelja\n' +
    '              </label>\n' +
    '              <input type="text" name="receiverId" id="receiverId"\n' +
    '                     class="input-field form-control"\n' +
    '                     ng-class="{\'domp-error\': vm.formSubmitted && vm.sepaForm.receiverId.$invalid }"\n' +
    '                     ng-model="vm.model.receiverId"\n' +
    '                     ng-blur="vm.findIdInCreditorList(vm.model.receiverId)"\n' +
    '                     maxlength="32"\n' +
    '                     autocomplete="off" required>\n' +
    '              <!--<div class="col-sm-12 col-xs-12 domp-filter-container p-10"-->\n' +
    '              <!--ng-class="{\'domp-error-custom-payee\': vm.formSubmitted && vm.sepaForm.receiverId.$invalid }"-->\n' +
    '              <!--style="margin-bottom:15px;">-->\n' +
    '              <!--<div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 p-0 p-t-5 inner-section pull-left">-->\n' +
    '              <!--<i class="icon icon-search domp-search-sign m-l-5"></i>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--<div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 p-r-0 inner-section input-div searchrow">-->\n' +
    '              <!--<input type="text" name="receiverId" id="receiverId" class="search-input"-->\n' +
    '              <!--ng-model="vm.model.receiverId"-->\n' +
    '              <!--ng-change="vm.searchRecieverId()"-->\n' +
    '              <!--required-->\n' +
    '              <!--autocomplete="off">-->\n' +
    '              <!--</div>-->\n' +
    '              <!--<div id="expandReceiverSearch" class="inner-section pull-right m-r-5 cursor-pointer"-->\n' +
    '              <!--ng-click="vm.toggleFilterSelection()">-->\n' +
    '              <!--<i class="zmdi zmdi-close domp-close-sign"-->\n' +
    '              <!--ng-show="vm.model.receiverId != \'\'"-->\n' +
    '              <!--ng-click="vm.removeSearch()"></i>-->\n' +
    '              <!--<i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"-->\n' +
    '              <!--ng-show="vm.model.receiverId == \'\'"></i>-->\n' +
    '              <!--</div>-->\n' +
    '\n' +
    '              <!--&lt;!&ndash; List found &ndash;&gt;-->\n' +
    '              <!--<div class="domp-filter-selection search-row"-->\n' +
    '              <!--ng-class="{\'opened\': vm.searchFilterExpanded}">-->\n' +
    '              <!--<div class="domp-filter-type-selection-wrapper"-->\n' +
    '              <!--ng-repeat="creditor in vm.sepaCreditorList | filter: vm.searchCreditorBy"-->\n' +
    '              <!--ng-click="vm.selectCreditor (creditor.creditorId)">-->\n' +
    '              <!--<div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">-->\n' +
    '              <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--<div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">-->\n' +
    '              <!--<p class="domp-list-name m-0">{{creditor.name}}</p>-->\n' +
    '              <!--<p class="domp-list-number m-0">{{creditor.address}}, {{creditor.city}}</p>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--<span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentCro.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentCro.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></span>-->\n' +
    '              <!--</div>-->\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverName">\n' +
    '              Naziv primatelja\n' +
    '            </label>\n' +
    '            <!--<div ng-if="vm.creditorInListExist" >-->\n' +
    '            <!--<label class="domp-form-label">-->\n' +
    '            <!--{{ vm.model.receiverName }}-->\n' +
    '            <!--</label>-->\n' +
    '            <!--</div>-->\n' +
    '            <input ng-class="{\'domp-error\': vm.formSubmitted && vm.sepaForm.receiverName.$invalid }"\n' +
    '                   type="text" class="form-control input-field"\n' +
    '                   id="receiverName"\n' +
    '                   name="receiverName"\n' +
    '                   ng-model="vm.model.receiverName"\n' +
    '                   ng-readonly="vm.creditorInListExist"\n' +
    '                   required/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END: Id primatelja, naziv primatelja -->\n' +
    '      <span ng-if="vm.model.sepaSettingType.id == \'AMOUNT\' || vm.model.sepaSettingType.id == \'WHITE_LIST\'">\n' +
    '        <!-- START: Identifikator suglasnosti, maksimalni iznos terećenja, dinamika izvršenja -->\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label" translate="sepa.identifierApproval">\n' +
    '                Identifikator suglasnosti\n' +
    '              </label>\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     id="identifierApproval"\n' +
    '                     name="identifierApproval"\n' +
    '                     ng-model="vm.model.identifierApproval"\n' +
    '                     maxlength="35"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-md-4">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label" translate="sepa.dynamicExecution">Dinamika izvršenja</label>\n' +
    '              <select class="form-control input-field"\n' +
    '                      id="dynamicExecution"\n' +
    '                      name="dynamicExecution"\n' +
    '                      ng-model="vm.model.dynamicExecution"\n' +
    '                      ng-options="\'sepa.executionPeriod.\' + option.id | translate for option in vm.executionPeriodTypesOptions">\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END: Identifikator suglasnosti, dinamika izvršenja -->\n' +
    '        <!-- START: maksimalni iznos terećenja-->\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label" translate="sepa.singleChargeMaxAmount">\n' +
    '                Maksimalni iznos pojedinačnog terećenja\n' +
    '              </label>\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     id="singleChargeMaxAmount"\n' +
    '                     name="singleChargeMaxAmount"\n' +
    '                     ng-model="vm.model.singleChargeMaxAmount"\n' +
    '                     amount-input-mask\n' +
    '                     allow-empty="true"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END: maksimalni iznos terećenja-->\n' +
    '      </span>\n' +
    '      <!-- BUTTONS -->\n' +
    '      <div class="row m-t-20">\n' +
    '        <div class="col-md-12">\n' +
    '          <button class="btn btn-primary"\n' +
    '                  type="button"\n' +
    '                  translate="sepa.cancelBtnLabel"\n' +
    '                  ui-sref="sepa.settings-cro">\n' +
    '          </button>\n' +
    '\n' +
    '          <button class="btn btn-default pull-right"\n' +
    '                  type="submit"\n' +
    '                  translate="sepa.confirm"\n' +
    '                  ng-click="vm.submit(vm.sepaForm);"\n' +
    '                  ng-disabled="vm.sepaBtnDisabled || vm.settingTypeInvalid">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- RESUME FORM   -->\n' +
    '    <!-- ============= -->\n' +
    '    <div ng-if="vm.step == \'resume\'" class="bg-white p-20 m-t-15 clearfix">\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review ng-scope" translate="sepa.toAccount"></label>\n' +
    '          <label class="domp-form-label-resume ng-binding">{{ vm.model.fromAccountSelect.iban }}</label>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review ng-scope" translate="sepa.settingType"></label>\n' +
    '          <label class="domp-form-label-resume ng-binding">{{ vm.model.sepaSettingType.description }}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <hr>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review ng-scope" translate="sepa.dateFrom"></label>\n' +
    '          <label class="domp-form-label-resume ng-binding">{{ vm.model.dateFrom | date: "shortDate" }}</label>\n' +
    '        </div>\n' +
    '        <div ng-show="vm.model.dateTo" class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review ng-scope" translate="sepa.dateTo"></label>\n' +
    '          <label class="domp-form-label-resume ng-binding">{{ vm.model.dateTo | date: "shortDate" }}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row" ng-if="vm.model.sepaSettingType.id != \'BLOCK_ALL\'">\n' +
    '        <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review ng-scope" translate="sepa.receiverId"></label>\n' +
    '          <label class="domp-form-label-resume ng-binding">{{ vm.model.receiverId }}</label>\n' +
    '        </div>\n' +
    '        <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '          <label class="domp-form-label-review ng-scope" translate="sepa.receiverName"></label>\n' +
    '          <label class="domp-form-label-resume ng-binding">{{ vm.model.receiverName }}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <span ng-if="vm.model.sepaSettingType.id == \'AMOUNT\' || vm.model.sepaSettingType.id == \'WHITE_LIST\'">\n' +
    '        <div class="row">\n' +
    '          <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12"\n' +
    '               ng-if="vm.model.identifierApproval != \'\'">\n' +
    '            <label class="domp-form-label-review ng-scope" translate="sepa.identifierApproval"></label>\n' +
    '            <label class="domp-form-label-resume ng-binding">{{ vm.model.identifierApproval }}</label>\n' +
    '          </div>\n' +
    '          <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12"\n' +
    '               ng-if="vm.model.dynamicExecution.description != \'\'">\n' +
    '            <label class="domp-form-label-review ng-scope" translate="sepa.dynamicExecution"></label>\n' +
    '            <label class="domp-form-label-resume ng-binding">{{ vm.model.dynamicExecution.description }}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '            <label class="domp-form-label-review ng-scope" translate="sepa.singleChargeMaxAmount"></label>\n' +
    '            <label class="domp-form-label-resume ng-binding">{{ vm.model.singleChargeMaxAmount | currency:"" }}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </span>\n' +
    '\n' +
    '      <div class="row m-t-20">\n' +
    '        <div class="col-md-12">\n' +
    '          <!--<button class="btn btn-primary"-->\n' +
    '          <!--type="button"-->\n' +
    '          <!--translate="sepa.cancelBtnLabel"-->\n' +
    '          <!--ng-click="vm.step = \'start\'">-->\n' +
    '          <!--</button>-->\n' +
    '\n' +
    '          <button class="btn btn-default pull-right"\n' +
    '                  type="submit"\n' +
    '                  translate="eInvoicesModal.sign"\n' +
    '                  ng-click="vm.step = \'sign\';">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- SIGN FORM   -->\n' +
    '    <!-- ============= -->\n' +
    '    <div class="bg-white p-20 m-t-15 clearfix" ng-if="vm.step == \'sign\'">\n' +
    '      <!--<div class="row">-->\n' +
    '      <!--<div class="col-md-12">-->\n' +
    '      <!--<h4 translate="termDeposit.signTitle"></h4>-->\n' +
    '      <!--</div>-->\n' +
    '      <!--</div>-->\n' +
    '      <div class="col-xs-12 m-t-30 m-b-30">\n' +
    '        <div class="col-xs-12 m-b-20">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeDescription\' | translate}}</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeFirstCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field" disabled ng-value="vm.responseModel.challenge">\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeSecondCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field"\n' +
    '                 data-ng-model="vm.model.insertChallenge"\n' +
    '                 placeholder="{{\'signPayments.challengeSecondCode\' | translate}}"\n' +
    '                 autofocus>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '          <button class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                  data-ng-click="vm.confirmSign()"\n' +
    '                  ng-disabled="vm.model.insertChallenge === \'\' || vm.confirmSignBtnDisabled"\n' +
    '                  translate="signPayments.confirm">\n' +
    '            Confirm\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- NOTE -->\n' +
    '    <!-- ============= -->\n' +
    '    <p class="p-15 bold-font" ng-if="vm.step == \'start\'">\n' +
    '      <span translate="sepa.newSepaHint1"></span>\n' +
    '      <a class="cursor-pointer" style="text-decoration: underline"\n' +
    '            ng-href="{{APP_GLOBAL_SETTINGS.defaultData.BankChargesMain}}" target="_blank"\n' +
    '            translate="sepa.newSepaHint2">\n' +
    '      </a>\n' +
    '    </p>\n' +
    '  </div>\n' +
    '</section>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-cro.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row">\n' +
    '      <div class="tmplt-list-title col-md-12 p-r-0 m-b-15">\n' +
    '\n' +
    '        <h2 translate="sepa.header_CRO" class="f-28"></h2>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-12 col-sm-6 col-lg-6 m-b-20">\n' +
    '        <div class="account-item-add-message app-dblue-card" ng-click="vm.addNewSetting()">\n' +
    '          <div class="round-btn-container2">\n' +
    '            <div class="round-btn-m">\n' +
    '              <i class="icon icon-add icon-add-msg bold-font f-24"></i>\n' +
    '            </div>\n' +
    '            <div class="round-btn-label-msg">\n' +
    '              <h3 class="round-btn-label-msg f-20">{{\'sepa.addNew\'| translate}}</h3>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- NEED NEW TIMELINE !!!!!???????  -->\n' +
    '\n' +
    '    <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '      <div class="po-type-container" ng-switch-default>\n' +
    '        <div ng-class="{\'selected\': vm.overviewTabType === \'overview\'}"\n' +
    '             ng-click="vm.overviewTabType = \'overview\'"\n' +
    '             class="po-type-tab no-wrap-text"\n' +
    '             style="width: 33.33%"\n' +
    '             translate="sepa.sepaSettingsRestrictions">\n' +
    '          Pregled ograničenja i zabrana\n' +
    '        </div>\n' +
    '        <div ng-class="{\'selected\': vm.overviewTabType === \'history\'}"\n' +
    '             ng-click="vm.overviewTabType = \'history\'"\n' +
    '             class="po-type-tab no-wrap-text"\n' +
    '             style="width: 33.33%"\n' +
    '             translate="sepa.sepaSettingsHistory">\n' +
    '          Povijest ograničenja i zabrana\n' +
    '        </div>\n' +
    '        <div ng-class="{\'selected\': vm.overviewTabType === \'requests\'}"\n' +
    '             ng-click="vm.overviewTabType = \'requests\'"\n' +
    '             class="po-type-tab no-wrap-text"\n' +
    '             style="width: 33.33%"\n' +
    '             translate="sepa.sepaRequestsOverview">\n' +
    '          Pregled zahtjeva\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- =================== -->\n' +
    '    <!--Pregled ograničenja-->\n' +
    '    <!-- =================== -->\n' +
    '    <div class="timeline-row col-sm-12 no-padding" ng-if="vm.overviewTabType == \'overview\'">\n' +
    '      <div class="t-a-c p-10 no-data-image" ng-if="vm.sepaDDSettings.length == 0">\n' +
    '        <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '        <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '      </div>\n' +
    '      <div class="hypo-timeline-wrapper app-white-card m-b-30" ng-hide="vm.sepaDDSettings.length == 0">\n' +
    '        <ul class="hypo-timeline sepa-timeline" kcd-recompile="vm.timelineListGrouped">\n' +
    '          <li ng-class="{\'time-label\': item.isVirtual}" ng-repeat="item in vm.sepaDDSettings">\n' +
    '            <h4 class="timeline-separator-title bold-font" style="background: none; border: none; font-size: none"\n' +
    '                ng-if="item.isVirtual === true">{{item.description}}</h4>\n' +
    '            <i class="zmdi zmdi-sepa icon i-p24 icon-settings"\n' +
    '               ng-class="{\'sepa-cro-timeline-icon-empty\' : item.typeId === \'BLOCK_ALL\', \'sepa-cro-timeline-icon\': item.typeId != \'BLOCK_ALL\'}"\n' +
    '               ng-if="!item.isVirtual"></i>\n' +
    '            <div ng-if="!item.isVirtual" class="hypo-timeline-item payment-item" style="height: 100px">\n' +
    '              <!-- if clickable ng-click="item.selected = !item.selected;" ng-class="{\'opened\': item.selected}"> -->\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-md-6 col-sm-12 m-b-5 clearfix">\n' +
    '                  <!-- Hide receiver name and id for BLOCK_ALL (not exist) -->\n' +
    '                  <h4 class="m-b-0 m-t-10">\n' +
    '                    <div class="m-t-5">\n' +
    '                      <b>{{item.accountIBAN}}</b>\n' +
    '                    </div>\n' +
    '                    <div ng-if="item.typeId != \'BLOCK_ALL\'" class="m-t-5">\n' +
    '                      <label class="m-b-0">{{item.receiverName}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="item.typeId != \'BLOCK_ALL\'" class="m-t-5">\n' +
    '                      <label class="m-b-0">ID: {{item.receiverId}}</label>\n' +
    '                    </div>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '                <div class="col-md-3 col-sm-12">\n' +
    '                  <h4 class="m-b-0 m-t-10">\n' +
    '                    <div class="m-r-10" ng-if="item.hasOwnProperty(\'maxAmount\')">{{item.maxAmount|number:2}} {{\n' +
    '                      vm.model.fromAccountSelect.currencySymbol}}\n' +
    '                    </div>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '                <div class="col-md-3 col-sm-12 m-b-5 clearfix">\n' +
    '                  <b class="m-r-10 t-a-r f-18">\n' +
    '                    <span ng-if="item.activated" class="underline"\n' +
    '                          ng-click="vm.deactivate(item)"\n' +
    '                          translate="sepa.isActive">\n' +
    '                    </span>\n' +
    '                    <span ng-if="!item.activated"\n' +
    '                          translate="sepa.notActive">\n' +
    '                    </span>\n' +
    '                  </b>\n' +
    '                  <br>\n' +
    '                  <div ng-if="item.dateFrom" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span translate="sepa.dateFrom"></span>: <span>{{item.dateFrom |date: \'shortDate\'}}</span>\n' +
    '                  </div>\n' +
    '                  <div ng-if="item.dateTo" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span translate="sepa.dateTo"></span>: <span>{{item.dateTo | date: \'shortDate\'}}</span>\n' +
    '                  </div>\n' +
    '                  <div class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span ng-if="item.executionPeriod">{{\'sepa.executionPeriodLabel\' | translate}}{{\'sepa.executionPeriod.\'+item.executionPeriod | translate}}</span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <!--<div class=" col-md-12">-->\n' +
    '                <!--<p class="m-b-0 m-t-0 iban-style-paym wrap-text">-->\n' +
    '                <!--&lt;!&ndash;<span ng-if="item.receiverName">{{item.receiverName}}<br></span>&ndash;&gt;-->\n' +
    '                <!--&lt;!&ndash;<span ng-if="item.receiverId">{{item.receiverId}}<br></span>&ndash;&gt;-->\n' +
    '                <!--<span ng-if="item.executionPeriod">{{\'sepa.executionPeriodLabel\' | translate}}{{\'sepa.executionPeriod.\'+item.executionPeriod | translate}}</span>-->\n' +
    '                <!--</p>-->\n' +
    '                <!--</div>-->\n' +
    '                <!--<div class="col-md-12 m-t-10">-->\n' +
    '                <!--&lt;!&ndash;<button ng-disabled="item.settingType.id == 4 || item.editInProgress"&ndash;&gt;-->\n' +
    '                <!--&lt;!&ndash;class="btn btn-default domp-review-and-submit-btn m-b-5" type="button" translate="sepa.edit"&ndash;&gt;-->\n' +
    '                <!--&lt;!&ndash;data-ng-click="vm.edit(item);">&ndash;&gt;-->\n' +
    '                <!--&lt;!&ndash;Edit&ndash;&gt;-->\n' +
    '                <!--&lt;!&ndash;</button>&ndash;&gt;-->\n' +
    '                <!--<button class="btn btn-default domp-review-and-submit-btn"-->\n' +
    '                <!--ng-if="item.activated"-->\n' +
    '                <!--type="button"-->\n' +
    '                <!--ng-disabled="vm.deactivateBtnDisabled"-->\n' +
    '                <!--translate="sepa.deactivate"-->\n' +
    '                <!--data-ng-click="vm.deactivate(item);">-->\n' +
    '                <!--Deactivate-->\n' +
    '                <!--</button>-->\n' +
    '                <!--</div>-->\n' +
    '              </div>\n' +
    '              <div class="clear"></div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- =================== -->\n' +
    '    <!--Povijest ogranicenja-->\n' +
    '    <!-- =================== -->\n' +
    '    <div class="timeline-row col-sm-12 no-padding m-b-30" ng-if="vm.overviewTabType == \'history\'">\n' +
    '      <div class="t-a-c p-10 no-data-image" ng-if="vm.sepaDDSettingsHistory.length == 0">\n' +
    '        <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '        <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '      </div>\n' +
    '      <div class="hypo-timeline-wrapper app-white-card" ng-hide="vm.sepaDDSettingsHistory.length == 0">\n' +
    '        <ul class="hypo-timeline sepa-timeline" kcd-recompile="vm.timelineListGrouped">\n' +
    '          <li ng-class="{\'time-label\': item.isVirtual}" ng-repeat="item in vm.sepaDDSettingsHistory">\n' +
    '            <h4 class="timeline-separator-title bold-font" style="background: none; border: none; font-size: none"\n' +
    '                ng-if="item.isVirtual === true">{{item.date | date: \'shortDate\'}}</h4>\n' +
    '            <i class="zmdi zmdi-sepa icon i-p24 icon-settings"\n' +
    '               ng-class="{\'sepa-cro-timeline-icon-empty\' : item.typeId === \'BLOCK_ALL\', \'sepa-cro-timeline-icon\': item.typeId != \'BLOCK_ALL\'}"\n' +
    '               ng-if="!item.isVirtual"></i>\n' +
    '            <div ng-if="!item.isVirtual" class="hypo-timeline-item payment-item" style="height: 100px">\n' +
    '              <!-- if clickable ng-click="item.selected = !item.selected;" ng-class="{\'opened\': item.selected}"> -->\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-md-6 col-sm-12 m-b-5 clearfix">\n' +
    '                  <!--<h4 class="m-b-0 m-t-10">-->\n' +
    '                  <!--<div><b>{{item.settingType.description}}</b></div>-->\n' +
    '                  <!--<span ng-if="item.typeId != \'BLOCK_ALL\'">-->\n' +
    '                  <!--<div class="m-t-5"><b>{{item.receiverName}}</b></div>-->\n' +
    '                  <!--<div class="m-t-5"><b>ID: {{item.receiverId}}</b></div>-->\n' +
    '                  <!--</span>-->\n' +
    '                  <!--</h4>-->\n' +
    '\n' +
    '                  <h4 class="m-b-0 m-t-10">\n' +
    '                    <div><b>{{item.accountIBAN}}</b></div>\n' +
    '                    <div><label class="m-b-0 m-t-5">{{item.settingType.description}}</label></div>\n' +
    '                    <span ng-if="item.typeId != \'BLOCK_ALL\'">\n' +
    '                      <div class="m-t-5"><label class="m-b-0">{{item.receiverName}}</label></div>\n' +
    '                      <div class="m-t-5"><label class="m-b-0">ID: {{item.receiverId}}</label></div>\n' +
    '                    </span>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '                <div class="col-md-3 col-sm-12">\n' +
    '                  <h4 class="m-b-0 m-t-10">\n' +
    '                    <div class="m-r-10" ng-if="item.hasOwnProperty(\'maxAmount\')">{{item.maxAmount|number:2}} {{\n' +
    '                      vm.model.fromAccountSelect.currencySymbol}}\n' +
    '                    </div>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '                <div class="col-md-3 col-sm-12 m-b-5 clearfix">\n' +
    '                  <b class="m-r-10 t-a-r f-18">\n' +
    '                    <span ng-if="item.activated"\n' +
    '                          translate="sepa.isActive">\n' +
    '                    </span>\n' +
    '                    <span ng-if="!item.activated"\n' +
    '                          translate="sepa.notActive">\n' +
    '                    </span>\n' +
    '                  </b>\n' +
    '                  <br>\n' +
    '                  <span ng-if="item.dateFrom" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span translate="sepa.dateFrom"></span>: <span>{{item.dateFrom |date: \'shortDate\'}}</span>\n' +
    '                  </span>\n' +
    '                  <br>\n' +
    '                  <span ng-if="item.dateTo" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span translate="sepa.dateTo"></span>: <span>{{item.dateTo | date: \'shortDate\'}}</span>\n' +
    '                  </span>\n' +
    '                  <span class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span ng-if="item.executionPeriod">{{\'sepa.executionPeriodLabel\' | translate}}{{\'sepa.executionPeriod.\'+item.executionPeriod | translate}}</span>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '                <!--<div class=" col-md-12">-->\n' +
    '                <!--<p class="m-b-0 m-t-0 iban-style-paym wrap-text">-->\n' +
    '                <!--&lt;!&ndash;<span ng-if="item.receiverName">{{item.receiverName}}<br></span>&ndash;&gt;-->\n' +
    '                <!--&lt;!&ndash;<span ng-if="item.receiverId">{{item.receiverId}}<br></span>&ndash;&gt;-->\n' +
    '                <!--<span ng-if="item.executionPeriod">{{\'sepa.executionPeriodLabel\' | translate}}{{\'sepa.executionPeriod.\'+item.executionPeriod | translate}}</span>-->\n' +
    '                <!--</p>-->\n' +
    '                <!--</div>-->\n' +
    '                <div class="clear"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- =================== -->\n' +
    '    <!-- Pregled zahtjeva -->\n' +
    '    <!-- =================== -->\n' +
    '    <div class="timeline-row col-sm-12 no-padding m-b-30" ng-if="vm.overviewTabType == \'requests\'">\n' +
    '      <div class="t-a-c p-10 no-data-image" ng-if="vm.sepaDDRequests.length == 0">\n' +
    '        <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '        <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '      </div>\n' +
    '      <div class="hypo-timeline-wrapper app-white-card" ng-hide="vm.sepaDDRequests.length == 0">\n' +
    '        <ul class="hypo-timeline sepa-timeline" kcd-recompile="vm.timelineListGrouped">\n' +
    '          <li ng-class="{\'time-label\': item.isVirtual}" ng-repeat="item in vm.sepaDDRequests">\n' +
    '            <h4 class="timeline-separator-title bold-font" style="background: none; border: none; font-size: none"\n' +
    '                ng-if="item.isVirtual === true">{{item.date | date: \'shortDate\'}}</h4>\n' +
    '            <i class="zmdi zmdi-sepa icon i-p24 icon-settings"\n' +
    '               ng-class="{\'sepa-cro-timeline-icon-empty\' : item.typeId === \'BLOCK_ALL\', \'sepa-cro-timeline-icon\': item.typeId != \'BLOCK_ALL\'}"\n' +
    '               ng-if="!item.isVirtual"></i>\n' +
    '            <div ng-if="!item.isVirtual" class="hypo-timeline-item payment-item" style="height: 100px">\n' +
    '              <!-- if clickable ng-click="item.selected = !item.selected;" ng-class="{\'opened\': item.selected}"> -->\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-md-6 col-sm-12 m-b-5 clearfix">\n' +
    '                  <!--<h4 class="m-b-0 m-t-10">-->\n' +
    '                    <!--<div><b>{{item.settingType.description}}</b></div>-->\n' +
    '                    <!--<span ng-if="item.typeId != \'BLOCK_ALL\'">-->\n' +
    '                      <!--<div class="m-t-5"><b>{{item.receiverName}}</b></div>-->\n' +
    '                      <!--<div class="m-t-5"><b>ID: {{item.receiverId}}</b></div>-->\n' +
    '                    <!--</span>-->\n' +
    '                  <!--</h4>-->\n' +
    '\n' +
    '                  <h4 class="m-b-0 m-t-10">\n' +
    '                    <div><b>{{item.accountIBAN}}</b></div>\n' +
    '                    <div><label class="m-b-0 m-t-5">{{item.settingType.description}}</label></div>\n' +
    '                    <span ng-if="item.typeId != \'BLOCK_ALL\'">\n' +
    '                      <div class="m-t-5"><label class="m-b-0">{{item.receiverName}}</label></div>\n' +
    '                      <div class="m-t-5"><label class="m-b-0">ID: {{item.receiverId}}</label></div>\n' +
    '                    </span>\n' +
    '                  </h4>\n' +
    '\n' +
    '                </div>\n' +
    '                <div class="col-md-3 col-sm-12">\n' +
    '                  <div class="m-r-10 f-18" ng-switch="item.typeId">\n' +
    '                    <span ng-switch-default>\n' +
    '                      <b translate="sepa.activation"></b>\n' +
    '                    </span>\n' +
    '                    <span ng-switch-when="DEACTIVATE_REQ">\n' +
    '                      <b translate="sepa.deactivation">DEACTIVATION</b>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <div class="m-b-0 m-t-10 m-r-10" ng-if="item.hasOwnProperty(\'maxAmount\')">{{item.maxAmount|number:2}}\n' +
    '                    {{ vm.model.fromAccountSelect.currencySymbol}}\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="col-md-3 col-sm-12 m-b-5 clearfix">\n' +
    '                  <b class="m-r-10 t-a-r f-18">\n' +
    '                    <span ng-switch="item.status">\n' +
    '                      <span ng-switch-when="0" translate="sepa.status_created"></span>\n' +
    '                      <span ng-switch-when="2" translate="sepa.status_recalled"></span>\n' +
    '                      <span ng-switch-when="3" translate="sepa.status_processed"></span>\n' +
    '                      <span ng-switch-when="4" translate="sepa.status_rejected"></span>\n' +
    '                    </span>\n' +
    '                  </b>\n' +
    '                  <br>\n' +
    '                  <span ng-if="item.dateFrom" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span translate="sepa.dateFrom"></span>: <span>{{item.dateFrom |date: \'shortDate\'}}</span>\n' +
    '                  </span>\n' +
    '                  <br>\n' +
    '                  <span ng-if="item.dateTo" class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span translate="sepa.dateTo"></span>: <span>{{item.dateTo | date: \'shortDate\'}}</span>\n' +
    '                  </span>\n' +
    '                  <span class="m-b-0 m-t-0 iban-style-paym wrap-text">\n' +
    '                    <span ng-if="item.executionPeriod">{{\'sepa.executionPeriodLabel\' | translate}}{{\'sepa.executionPeriod.\'+item.executionPeriod | translate}}</span>\n' +
    '                  </span>\n' +
    '\n' +
    '                </div>\n' +
    '                <!--<div class=" col-md-12">-->\n' +
    '                  <!--<p class="m-b-0 m-t-0 iban-style-paym wrap-text">-->\n' +
    '                    <!--&lt;!&ndash;<span ng-if="item.receiverName">{{item.receiverName}}<br></span>&ndash;&gt;-->\n' +
    '                    <!--&lt;!&ndash;<span ng-if="item.receiverId">{{item.receiverId}}<br></span>&ndash;&gt;-->\n' +
    '                  <!--</p>-->\n' +
    '                <!--</div>-->\n' +
    '                <div class="clear"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-complaints-timeline-details.tpl.html',
    '<div class="table-responsive">\n' +
    '  <table class="table table-transparent">\n' +
    '    <tbody>\n' +
    '\n' +
    '    <tr ng-if="sepaComplaint.transactionId">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="sepa.transactionId"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{sepaComplaint.transactionId}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="sepa.payerAccount"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{sepaComplaint.accountIBAN}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="sepa.receiverId"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{sepaComplaint.receiverIdentificator}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="sepa.receiverAccount"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{sepaComplaint.receiverAccount}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="sepa.receiverNumber"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{sepaComplaint.receiverReference}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="sepa.executionDate"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{sepaComplaint.inputValueDate | date: "shortDate" }}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    </tbody>\n' +
    '  </table>\n' +
    '</div>\n' +
    '<!-- MOBILE -->\n' +
    '<!--<div class="table-responsive visible-xs">-->\n' +
    '  <!--<table class="table table-transparent f-10">-->\n' +
    '    <!--<tbody>-->\n' +
    '    <!--<tr>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-desc-label-xs" translate="sepa.receiverId"></span>-->\n' +
    '      <!--</td>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-value-label-xs">{{sepaComplaint.receiverIdentificator | date: \'shortDate\'}}</span>-->\n' +
    '      <!--</td>-->\n' +
    '    <!--</tr>-->\n' +
    '    <!--<tr>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-desc-label-xs" translate="sepa.receiverAccount"></span>-->\n' +
    '      <!--</td>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-value-label-xs">{{sepaComplaint.receiverAccount}}</span>-->\n' +
    '      <!--</td>-->\n' +
    '    <!--</tr>-->\n' +
    '    <!--<tr>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-desc-label-xs" translate="sepa.receiverNumber"></span>-->\n' +
    '      <!--</td>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-value-label-xs">{{sepaComplaint.receiverReference}}</span>-->\n' +
    '      <!--</td>-->\n' +
    '    <!--</tr>-->\n' +
    '    <!--<tr>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-desc-label-xs" translate="sepa.executionDate"></span>-->\n' +
    '      <!--</td>-->\n' +
    '      <!--<td>-->\n' +
    '        <!--<span class="po-value-label-xs">{{sepaComplaint.inputValueDate | date: "shortDate" }}</span>-->\n' +
    '      <!--</td>-->\n' +
    '    <!--</tr>-->\n' +
    '    <!--</tbody>-->\n' +
    '  <!--</table>-->\n' +
    '<!--</div>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-complaint-refund.tpl.html',
    '<ng-form name="vm.refundForm">\n' +
    '  <section id="main">\n' +
    '    <div class="container">\n' +
    '      <div class="exchange-rate-header m-b-10">\n' +
    '        <div class="row" ng-switch="vm.type">\n' +
    '          <div class="col-sm-12 f-20" ng-switch-when="refund" translate="sepa.refundComplaint.refundTitle"></div>\n' +
    '          <div class="col-sm-12 f-20" ng-switch-when="complaint" translate="sepa.refundComplaint.complaintTitle"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- STEP 1 -->\n' +
    '      <div class="trans-complain-container">\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.paymentStatus"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{\'sepa.sepaStatus.\'+vm.model.status | translate}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.executionDate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.paymentDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.payersAccNumber"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.senderAccount}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.recipient"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.receiverName}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.recAccNumber"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.receiverAccount}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.uniqueMandateReference"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.mandateReference}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.recIdentifier"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.receiverIdentificator}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.recRefNumber"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.receiverReference}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="reclamation.amount"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.amount | currency:""}}\n' +
    '              {{APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row  m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.valuteDate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.valuteDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row  m-t-10">\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-desc-label" translate="sepa.refundComplaint.paymentPurpose"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-6">\n' +
    '            <label class="po-value-label">{{vm.model.purpose}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- STEP 1-->\n' +
    '        <div ng-if="vm.formStep == 1">\n' +
    '          <div class="row m-t-10">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '              <div class="form-group">\n' +
    '                <div ng-switch="vm.type">\n' +
    '                  <label class="po-desc-label" ng-switch-when="refund" translate="sepa.refundComplaint.reasonForRefund"></label>\n' +
    '                  <label class="po-desc-label" ng-switch-when="complaint" translate="sepa.refundComplaint.reasonForComplaint"></label>\n' +
    '                </div>\n' +
    '                <select class="form-control" ng-model="vm.inputModel.reasonForcomplaint"\n' +
    '                        name="reasonForComplaint"\n' +
    '                        ng-options="reason.description for reason in vm.complaintReasonTypes"\n' +
    '                        ng-class="{\'domp-error\': vm.refundForm.reasonForComplaint.$invalid && vm.formSubmitted}"\n' +
    '                        required>\n' +
    '                </select>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row" ng-if="vm.inputModel.reasonForcomplaint.id == \'DOD_OBRAZ\'">\n' +
    '            <div class="col-sm-12">\n' +
    '              <div class="form-group">\n' +
    '                <label class="po-desc-label" translate="sepa.refundComplaint.additionalExplanation"></label>\n' +
    '                <textarea ng-pattern-restrict="{{vm.regexPatterns.allowedCharsDPStextArea}}"\n' +
    '                          ng-model="vm.inputModel.extra"\n' +
    '                          name="extra"\n' +
    '                          style="resize: none;"\n' +
    '                          class="form-control"\n' +
    '                          id="reclamationInput"\n' +
    '                          cols="30"\n' +
    '                          rows="5">\n' +
    '                </textarea>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- STEP 2-->\n' +
    '        <div ng-if="vm.formStep == 2">\n' +
    '          <div class="row m-t-10">\n' +
    '            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">\n' +
    '              <div class="form-group">\n' +
    '                <div ng-switch="vm.type">\n' +
    '                  <label class="po-desc-label" ng-switch-when="refund" translate="sepa.refundComplaint.reasonForRefund"></label>\n' +
    '                  <label class="po-desc-label" ng-switch-when="complaint" translate="sepa.refundComplaint.reasonForComplaint"></label>\n' +
    '                </div>\n' +
    '                <br>\n' +
    '                <label class="po-value-label">{{vm.inputModel.reasonForcomplaint.description}}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row" ng-if="vm.inputModel.reasonForcomplaint.id == \'DOD_OBRAZ\' && vm.inputModel.extra">\n' +
    '            <div class="col-sm-12">\n' +
    '              <div class="form-group">\n' +
    '                <label class="po-desc-label" translate="sepa.refundComplaint.additionalExplanation"></label>\n' +
    '                <br>\n' +
    '                <label class="po-value-label">{{vm.inputModel.extra}}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- BUTTONS -->\n' +
    '    <div ng-if="vm.formStep == 1" class="row m-t-10">\n' +
    '      <div class="col-sm-12 c-red bold-font">\n' +
    '        <div class="col-lg-3 col-sm-6 ">\n' +
    '          <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn m-0"\n' +
    '                  translate="sepa.refundComplaint.cancel"\n' +
    '                  ui-sref="sepa.transactions({selectedTab:vm.status})">\n' +
    '\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-lg-3 col-sm-6 pull-right ">\n' +
    '          <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn m-0 pull-right"\n' +
    '                  translate="sepa.refundComplaint.next"\n' +
    '                  ng-disabled="vm.confirmButtonDisabled"\n' +
    '                  ng-click="vm.next()">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="vm.formStep == 2" class="row m-t-10">\n' +
    '      <div class="col-sm-12 c-red bold-font">\n' +
    '        <div class="col-lg-3 col-sm-6 ">\n' +
    '          <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn m-0"\n' +
    '                  translate="orders.back"\n' +
    '                  ng-click="vm.back();">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-lg-3 col-sm-6 pull-right ">\n' +
    '          <button class="btn btn-default app-btn-blue domp-sign-btn m-0 pull-right"\n' +
    '                  translate="domesticPayment.confirmBtn"\n' +
    '                  ng-disabled="vm.confirmButtonDisabled"\n' +
    '                  ng-click="vm.confirm()">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </section>\n' +
    '</ng-form>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('sepa/sepa-accepted-refusal-cro.tpl.html',
    '<section id="main" ng-if="vm.pageLoaded">\n' +
    '\n' +
    '  <div class="container-fluid clearfix m-b-40">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <h3 translate="sepa.refusalAcceptedTitle">SEPA REFUSAL</h3>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- START FORM    -->\n' +
    '    <!-- ============= -->\n' +
    '    <!-- ======= -->\n' +
    '    <!-- START -->\n' +
    '    <!-- ======= -->\n' +
    '    <div ng-form name="vm.refusalForm"\n' +
    '         ng-if="vm.step == \'start\'"\n' +
    '         class="bg-white p-20 m-t-15 clearfix"\n' +
    '         novalidate>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.payerAccount">\n' +
    '              Račun platitelja\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="fromAccount"\n' +
    '                   name="fromAccount"\n' +
    '                   ng-value="vm.model.senderAccount"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.amount">\n' +
    '              Iznos\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="amount"\n' +
    '                   name="amount"\n' +
    '                   ng-value="(vm.model.amount | currency: \'\') + \' HRK\'"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.transactionId">\n' +
    '              ID naloga\n' +
    '            </label>\n' +
    '            <input type="text" name="transactionId" id=transactionIdreceiverId"\n' +
    '                   class="input-field form-control"\n' +
    '                   ng-value="vm.model.transactionId"\n' +
    '                   readonly>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverName">\n' +
    '              Naziv i sjedište primatelja plaćanja\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="receiverName"\n' +
    '                   name="receiverName"\n' +
    '                   ng-value="vm.model.receiverName"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverAccount">\n' +
    '              Račun primatelja plaćanja\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="receiverAccount"\n' +
    '                   name="receiverAccount"\n' +
    '                   ng-value="vm.model.receiverAccount"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label" translate="sepa.receiverNumber">\n' +
    '              Detalji plaćanja (poziv na broj primatelja)\n' +
    '            </label>\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   id="receiverNumber"\n' +
    '                   name="receiverNumber"\n' +
    '                   ng-value="vm.model.receiverNumber"\n' +
    '                   readonly/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-20">\n' +
    '        <div class="col-md-12">\n' +
    '          <button class="btn btn-primary"\n' +
    '                  type="button"\n' +
    '                  translate="sepa.cancelBtnLabel"\n' +
    '                  ui-sref="sepa.transactions">\n' +
    '          </button>\n' +
    '\n' +
    '          <button class="btn btn-default pull-right"\n' +
    '                  type="submit"\n' +
    '                  translate="sepa.confirm"\n' +
    '                  ng-click="vm.submit(vm.refusalForm);"\n' +
    '                  ng-disabled="vm.submitButtonDisabled">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============= -->\n' +
    '    <!-- SIGN FORM   -->\n' +
    '    <!-- ============= -->\n' +
    '    <div class="bg-white p-20 m-t-15 clearfix" ng-if="vm.step == \'sign\'">\n' +
    '      <div class="col-xs-12 m-t-30 m-b-30">\n' +
    '        <div class="col-xs-12 m-b-20">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeDescription\' | translate}}</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeFirstCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field" disabled ng-value="vm.responseModel.challenge">\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12">\n' +
    '          <span class="f-w-bold">{{\'signPayments.challengeSecondCode\' | translate}}</span>\n' +
    '          <input type="text" class="form-control input-field"\n' +
    '                 data-ng-model="vm.model.insertChallenge"\n' +
    '                 placeholder="{{\'signPayments.challengeSecondCode\' | translate}}"\n' +
    '                 autofocus>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '          <button class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                  data-ng-click="vm.confirmSign()"\n' +
    '                  ng-disabled="vm.model.insertChallenge === \'\' || vm.confirmSignBtnDisabled"\n' +
    '                  translate="signPayments.confirm">\n' +
    '            Confirm\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('secure3d/secure3d.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-12 p-0">\n' +
    '        <div class="secure-3d-bg">\n' +
    '          <span  class="secure-3d-title">3D Secure</span>\n' +
    '          <span class="secure-3d-subtitle" translate="secure3d.text5"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-12 secure3d-container p-t-30">\n' +
    '        <div class="secure3d-text p-b-15" translate="secure3d.text1"></div>\n' +
    '        <div class="secure3d-text p-b-15" translate="secure3d.text12"></div>\n' +
    '        <div class="secure3d-text bold-font p-b-30">\n' +
    '          {{\'secure3d.text2\' | translate}}\n' +
    '          <a class="secure3d-link" href="https://www.addiko.hr/" target="_blank" translate="secure3d.text3link"></a>\n' +
    '          {{\'secure3d.text4\'| translate}}\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-12 t-a-c p-t-15">\n' +
    '\n' +
    '        <button class="btn btn-secure3d" title="{{ \'secure3d.buttonTitle\' | translate }}" type="submit" ng-click="secure3d.goToLink();" translate="secure3d.buttonText"></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/tl-currency-details.tpl.html',
    '<table class="table table-transparent table-responsive" style="font-size: 17px;color: #9e9e9e !important;font-family: CharlieMedium;" >\n' +
    '  <tbody>\n' +
    '  <!--<tr>-->\n' +
    '    <!--<td>-->\n' +
    '      <!--<span class="po-desc-label" translate="paymentsOverview.povlStatus">Status:</span>-->\n' +
    '    <!--</td>-->\n' +
    '    <!--<td>-->\n' +
    '      <!--<span class="po-value-label">-->\n' +
    '        <!--<span class="po-value-label" ng-class="{\'text-danger\': payment.status === \'Rejected\'}" ng-if="payment.status === \'Rejected\'" translate="paymentsOverview.rejected"></span>-->\n' +
    '        <!--<span class="po-value-label" ng-if="payment.status === \'Processed\'" translate="paymentsOverview.processed"></span>-->\n' +
    '        <!--<span class="po-value-label" ng-if="payment.status === \'Cancelled\'" translate="paymentsOverview.cancelled"></span>-->\n' +
    '        <!--<span class="po-value-label" ng-if="payment.status === \'InProcessing\'" translate="paymentsOverview.inProcessing"></span>-->\n' +
    '        <!--<span class="po-value-label" ng-if="payment.status === \'Opened\'" translate="paymentsOverview.open"></span>-->\n' +
    '        <!--<span class="po-value-label" ng-if="payment.status === \'WaitingQueue\'" translate="paymentsOverview.waitingQueque"></span>-->\n' +
    '      <!--</span>-->\n' +
    '    <!--</td>-->\n' +
    '  <!--</tr>-->\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="paymentsOverview.povlId">Payment id:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="po-value-label">{{::payment.id}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <!--<tr>-->\n' +
    '    <!--<td>-->\n' +
    '      <!--<span class="po-desc-label" translate="paymentsOverview.povlReceiver">Receiver name:</span>-->\n' +
    '    <!--</td>-->\n' +
    '    <!--<td>-->\n' +
    '      <!--<span class="po-value-label">{{::payment.receiverName}}</span>-->\n' +
    '    <!--</td>-->\n' +
    '  <!--</tr>-->\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="paymentsOverview.povlFrom">From account:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="po-value-label">{{::payment.fromAccountNumber}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="paymentsOverview.povlTo">To account:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="po-value-label">{{::payment.toAccountNumber}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\'" class="po-desc-label" translate="paymentsOverview.povlAmount">Amount:</span>\n' +
    '      <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" class="po-desc-label" translate="paymentsOverview.povlAmountSlo">Amount:</span>\n' +
    '    </td>\n' +
    '    <td ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\'">\n' +
    '      <span class="po-value-label" ng-if="!payment.transactionAmount2">{{payment.amount|number:2}} {{::payment.currencySymbol}}</span>\n' +
    '      <span class="po-value-label" ng-if="payment.transactionAmount2">{{payment.transactionAmount2|number:2}} {{::payment.destinationCurrencySymbol}}</span>\n' +
    '    </td>\n' +
    '    <td ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'">\n' +
    '      <span class="po-value-label" ng-if="payment.amount">{{payment.amount|number:2}} {{::payment.currencySymbol}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="currencyConversion.when">Due date:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="po-value-label">{{::payment.dueDate| date:\'shortDate\'}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && payment.status == \'Rejected\'">\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="paymentsOverview.povlNote_SLO">Opis greske</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="po-value-label">{{::payment.note}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td colspan="2">\n' +
    '      <div>\n' +
    '                    <span class="pull-right" ng-repeat="actionObject in payment.allowedActionList.itemList">\n' +
    '                        <span ng-switch on="actionObject.methodName">\n' +
    '                            <button ng-if="actionObject.isEnabled" ng-switch-when="RecallAllowed" ng-click="currencyConversion.recallPaymentAction(payment.id);"\n' +
    '                                    class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase" translate="currencyConversion.recallPayment"\n' +
    '                                    translate="paymentActions.recall"></button>\n' +
    '                            <button ng-if="actionObject.isEnabled" ng-switch-when="SignAllowed" ng-click="currencyConversion.signPaymentAction(payment);"\n' +
    '                                    class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                                    translate="paymentActions.sign"></button>\n' +
    '                            <button ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed" ng-click="currencyConversion.deletePaymentAction(payment.id, \'timeline\');"\n' +
    '                                    class="btn btn-primary-warning app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                                    translate="paymentActions.delete"></button>\n' +
    '                        </span>\n' +
    '                    </span>\n' +
    '      </div>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/statement-confirm-modal.tpl.html',
    '<div class="statementModal">\n' +
    '       <div class="row">\n' +
    '        <div class="col-md-3">\n' +
    '      <i class="icon icon-statement zmdi-hc-4x p-r-10 col-sm-1 p-l-0" style="color:white;margin-left:102px; margin-top:45px;"></i>\n' +
    '      \n' +
    '        </div>\n' +
    '        <div class="col-md-9">\n' +
    '            <div class="modal-header statement-confirm-header" style="padding-bottom: 8px;">\n' +
    '                <h3 class="state-title-top" translate="statementConfirmModalTranslations.title"></h3>\n' +
    '            </div>\n' +
    '            <div class="modal-body text-center">\n' +
    '                <ng-form name="statementConfirmModal.statementForm" style="color:white">\n' +
    '                    <p translate="statementConfirmModalTranslations.p1" class="state-title-par"></p>\n' +
    '                    <h3 translate="statementConfirmModalTranslations.title" class="state-title-top"></h3>\n' +
    '                    <p style="text-align:left;" class="state-title-par">\n' +
    '                        <span translate="statementConfirmModalTranslations.p2"></span> {{statementConfirmModal.selectedCountry.amountInput}} {{statementConfirmModal.selectedCountry.chargeAccountInput.currencySymbol}}\n' +
    '                        <span translate="statementConfirmModalTranslations.p2_2"></span> {{statementConfirmModal.selectedCountry.bankCountrySelect.description}}\n' +
    '                        <span translate="statementConfirmModalTranslations.p2_0"></span>\n' +
    '                    </p>\n' +
    '                    <p>\n' +
    '                        <label class="radio-inline state-title-par sel-spacing">\n' +
    '                            <input ng-model="statementConfirmModal.model.stateOption" value="0" type="radio">\n' +
    '                            <span translate="statementConfirmModalTranslations.radioMerchandise"></span>\n' +
    '                        </label>\n' +
    '                        <label class="radio-inline state-title-par sel-spacing">\n' +
    '                            <input ng-model="statementConfirmModal.model.stateOption" value="1" type="radio">\n' +
    '                            <span translate="statementConfirmModalTranslations.radioPresent"></span>\n' +
    '                        </label>\n' +
    '                        <label class="radio-inline state-title-par sel-spacing">\n' +
    '                            <input ng-model="statementConfirmModal.model.stateOption" value="2" type="radio">\n' +
    '                            <span translate="statementConfirmModalTranslations.radioOther"></span>\n' +
    '                        </label>\n' +
    '                    </p>\n' +
    '                    <p translate="statementConfirmModalTranslations.p2_1" class="state-title-par">\n' +
    '                        detailed explanation (specification)*\n' +
    '                    </p>\n' +
    '\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-md-12">\n' +
    '                            <textarea name="information" class="form-control statement-confirm-textarea" ng-class="{\'statement-confirm-information-error\': statementConfirmModal.statementForm.$error.required && statementConfirmModal.statementForm.submitted}" ng-model="statementConfirmModal.model.information" ng-required="statementConfirmModal.model.stateOption != 1" maxlength="200" style="border-radius: 7px;border-style:none;">\n' +
    '                            </textarea>\n' +
    '                            <p translate="statementConfirmModalTranslations.p4" class="state-title-par" style="text-align:left;margin-top:9px;"></p>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </ng-form>\n' +
    '            </div>\n' +
    '            <div class="modal-footer">\n' +
    '                <div class="row">\n' +
    '                    <div class="col-md-12">\n' +
    '                        <button class="btn btn-primary-red statementBtnConf" ng-click="statementConfirmModal.confirm()"><span translate="statementConfirmModalTranslations.confirmButton"></span></button>\n' +
    '                        <button class="btn btn-primary-red statementBtnClose" ng-click="$close()"><span translate="statementConfirmModalTranslations.cancelButton"></span></button>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/savings-pay-in.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div class="row exchange-rates">\n' +
    '      <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12">\n' +
    '        <div class="domp-header-wrapper p-r-20 p-l-10" ng-show="savingsPayIn.currentStep!=3">\n' +
    '          <div class="row domp-header-row">\n' +
    '            <div class="domp-header-left col-sm-12 col-md-12 col-lg-12 col-xs-12">\n' +
    '              <h2 translate="savings.savingsPayIn"></h2>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!----------------------->\n' +
    '        <div class="internal-transfer-body" ng-show="savingsPayIn.currentStep == 1">\n' +
    '          <form name="savingsPayIn.savingsPayInForm" novalidate>\n' +
    '            <div class="p-10"> </div>\n' +
    '            <div class="exchange-rates-body">\n' +
    '              <div class="row m-b-30">\n' +
    '                <div class="col-sm-5">\n' +
    '                  <!-- CUSTOM FROM Accounts dropdown-->\n' +
    '                  <label class="bold-font f-18" translate="payments.fromAccount"></label>\n' +
    '                  <div class="accounts-dropdown m-b-10" ng-if="savingsPayIn.accountsFrom.length > 0">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item" data-ng-click="savingsPayIn.toggleFromAccount();"  ng-style="savingsPayIn.tempObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + savingsPayIn.tempObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                             <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                        {{savingsPayIn.tempObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                          <i class="zmdi "\n' +
    '                             ng-class="{\'zmdi-star favorite-account\':savingsPayIn.tempObj.fromAccountSelect.isFavorite,\n' +
    '                                       \'zmdi-star-outline\':!savingsPayIn.tempObj.fromAccountSelect.isFavorite}"></i>\n' +
    '                        </span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{savingsPayIn.tempObj.fromAccountSelect.iban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{savingsPayIn.tempObj.fromAccountSelect.availableBalance | number:2}} {{savingsPayIn.tempObj.fromAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      <span class="caret-icon" ng-if="savingsPayIn.accountsFrom.length > 1">\n' +
    '                        <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <div class="accounts-list m-l-15 m-r-15" ng-show="savingsPayIn.fromAccountDropdown" scrollable>\n' +
    '                      <div class="accounts-list-item p-0" data-ng-repeat="item in savingsPayIn.accountsFrom" data-ng-click="savingsPayIn.setAccountFrom(item);">\n' +
    '                          <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                              <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <span class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</span>\n' +
    '                                   <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                              </h4>\n' +
    '                        <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                        <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">{{item.availableBalance | number:2}} {{item.currencySymbol}}</p>\n' +
    '                         <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                    </div>\n' +
    '                  <div class="accounts-dropdown m-b-10" ng-if="savingsPayIn.accountsFrom.length == 0">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item" style="height: 133px; line-height: 133px" translate="core.noAccounts">\n' +
    '                      No available accounts\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <label class="bold-font" translate="internalTransfer.amount"></label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field t-a-r" name="fromAccountAmountInput" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask maxlength="12" data-ng-model="savingsPayIn.tempObj.fromAccountAmountInput"\n' +
    '          ng-class="{\'domp-error\': savingsPayIn.savingsPayInForm.fromAccountAmountInput.$invalid && savingsPayIn.tempObj.formSubmitted}" required>\n' +
    '                    <span class="input-group-btn">\n' +
    '                      <button type="button" class="btn input-group-app-btn domp-btn-height" disabled>\n' +
    '                        {{savingsPayIn.tempObj.fromAccountSelect.currencySymbol}}\n' +
    '                      </button>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <span class="c-red" ng-show="savingsPayIn.savingsPayInForm.fromAccountAmountInput.$error.required &&\n' +
    '                                               savingsPayIn.tempObj.formSubmitted" translate="internalTransfer.amountInputError">\n' +
    '                  </span>\n' +
    '                  <span class="c-red" ng-show="savingsPayIn.savingsPayInForm.fromAccountAmountInput.$error.maxlength &&\n' +
    '                                               savingsPayIn.tempObj.formSubmitted" translate="internalTransfer.amountLengthError">\n' +
    '                  </span>\n' +
    '\n' +
    '         <!--         <div class="col-lg-12 col-md-8 no-padding-on-phone p-r-0 p-l-0 p-t-10">\n' +
    '                    <label class="bold-font" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '                    <div class="p-0">\n' +
    '                      <input type="text" class="form-control input-field" name="purposeOfPaymentInput" id="purposeOfPaymentInput" ng-maxlength="135" maxlength="135" ng-model="savingsPayIn.tempObj.purposeOfPaymentInput" required ng-class="{\'domp-error\': savingsPayIn.savingsPayInForm.purposeOfPaymentInput.$invalid && savingsPayIn.tempObj.formSubmitted}" ng-blur="savingsPayIn.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', savingsPayIn.tempObj.purposeOfPaymentInput)">\n' +
    '                      <span class="c-red" ng-show="savingsPayIn.savingsPayInForm.purposeOfPaymentInput.$error.required && savingsPayIn.tempObj.formSubmitted" translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                    </div>\n' +
    '                  </div>-->\n' +
    '                </div>\n' +
    '                <div class="col-sm-2">\n' +
    '                  <div class="t-a-c exchange-office-middle">\n' +
    '                    <i class="zmdi zmdi-long-arrow-right zmdi-hc-2x"></i>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-sm-5">\n' +
    '                  <!-- CUSTOM TO Accounts dropdown -->\n' +
    '                  <label class="bold-font f-18" translate="payments.toAccount"></label>\n' +
    '                  <div class="accounts-dropdown m-b-10" ng-if="savingsPayIn.accountTo.length > 0">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item domp-acc-widget-foreign" data-ng-click="savingsPayIn.toggleToAccount();" ng-style="savingsPayIn.tempObj.toAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + savingsPayIn.tempObj.toAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                           <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                        {{savingsPayIn.tempObj.toAccountSelect.friendlyName}} </b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                          <i class="zmdi "\n' +
    '                             ng-class="{\'zmdi-star favorite-account\':account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                        </span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style" ng-if="!savingsPayIn.tempObj.toAccountSelect.iban">{{savingsPayIn.tempObj.toAccountSelect.accountNumber}}</p>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style" ng-if="savingsPayIn.tempObj.toAccountSelect.iban">{{savingsPayIn.tempObj.toAccountSelect.iban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{savingsPayIn.tempObj.toAccountSelect.availableBalance | number:2}} {{savingsPayIn.tempObj.toAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      <span class="caret-icon" ng-if="savingsPayIn.accountTo.length > 1">\n' +
    '                        <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <div class="from-accounts-list m-l-15" ng-show="savingsPayIn.toAccountDropdown" scrollable>\n' +
    '                      <div class="accounts-list-item p-0" data-ng-repeat="item in savingsPayIn.accountTo" data-ng-click="savingsPayIn.setAccountTo(item);">\n' +
    '                          <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '\n' +
    '                          <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                       <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                              <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                              </h4>\n' +
    '                        <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                        <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">{{item.availableBalance | number:2}} {{item.currencySymbol}}</p>\n' +
    '                        <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- END TO ACCOUNT CONTROL -->\n' +
    '\n' +
    '                  <!--<div class="row">-->\n' +
    '                    <!--<div class="col-lg-12 col-sm-8 col-md-8 p-t-10">-->\n' +
    '                      <!--<label class="bold-font" translate="internalTransfer.when"></label>-->\n' +
    '                      <!--<div class="input-group">-->\n' +
    '                        <!--<input type="text" class="form-control input-field" name="dueDateInput" uib-datepicker-popup="shortDate" data-ng-model="savingsPayIn.tempObj.dueDateInput" show-weeks="false" is-open="savingsPayIn.datePickerOpened" datepicker-options="savingsPayIn.dateOptions" ng-class="{\'domp-error\': savingsPayIn.savingsPayInForm.dueDateInput.$invalid && savingsPayIn.tempObj.formSubmitted}" required>-->\n' +
    '                        <!--<span class="input-group-btn">-->\n' +
    '                          <!--<button data-ng-click="savingsPayIn.openDatePicker()" type="button"-->\n' +
    '                                  <!--class="btn input-group-app-btn domp-btn-height"><i class="icon icon-calendar" style="font-size: 21px;"></i>-->\n' +
    '                          <!--</button>-->\n' +
    '                        <!--</span>-->\n' +
    '                      <!--</div>-->\n' +
    '                    <!--</div>-->\n' +
    '                  <!--</div>-->\n' +
    '<!--\n' +
    '                  <label class="bold-font" translate="currencyConversion.amount"></label>\n' +
    '\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-8 col-xs-8 p-r-0">\n' +
    '                      <input type="text" class="form-control input-field t-a-r" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" data-input-mask="\'core.moneyFormat.mask\'" data-input-mask-options="{reverse: true,optional: true}" data-ng-model="savingsPayIn.tempObj.toAccountAmountInput" disabled>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-4 col-xs-4 p-l-0">\n' +
    '                      <select class="form-control input-field" ng-options="item.symbol for item in savingsPayIn.currencyList" data-ng-model="savingsPayIn.tempObj.toCurrencySymbol" data-ng-change="savingsPayIn.changeSellCurrency();" ng-disabled="savingsPayIn.tempObj.fromCurrencyInput != savingsPayIn.localCurrency">\n' +
    '                      </select>\n' +
    '                    </div> -->\n' +
    '                    <!--<div class="col-sm-4 col-xs-4 p-l-0">\n' +
    '<input type="text" class="form-control input-field" data-ng-model="savingsPayIn.tempObj.buyCurrencyInput.symbol">\n' +
    '</div> -->\n' +
    '                </div>\n' +
    '\n' +
    '                  <!-- In case of empty to account list -->\n' +
    '                  <div class="accounts-dropdown m-b-10" ng-if="savingsPayIn.accountTo.length == 0">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item" style="height: 133px; line-height: 133px" translate="core.noAccounts">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <label class="bold-font" translate="internalTransfer.when"></label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field" name="dueDateInput"\n' +
    '                           uib-datepicker-popup="shortDate" data-ng-model="savingsPayIn.tempObj.dueDateInput"\n' +
    '                           show-weeks="false" is-open="savingsPayIn.datePickerOpened"\n' +
    '                           datepicker-options="savingsPayIn.dateOptions"\n' +
    '                           ng-class="{\'domp-error\': savingsPayIn.savingsPayInForm.dueDateInput.$invalid && savingsPayIn.tempObj.formSubmitted}"\n' +
    '                           required>\n' +
    '                        <span class="input-group-btn">\n' +
    '                          <button data-ng-click="savingsPayIn.openDatePicker()" type="button"\n' +
    '                                  class="btn input-group-app-btn domp-btn-height"><i class="icon icon-calendar"\n' +
    '                                                                                     style="font-size: 21px;"></i>\n' +
    '                          </button>\n' +
    '                        </span>\n' +
    '                  </div>\n' +
    '\n' +
    '              </div>\n' +
    '          </div>\n' +
    '              <div class="row">\n' +
    '                <div class="col-xs-6 t-a-l">\n' +
    '                  <button class="btn btn-primary" translate="payments.cancel"\n' +
    '                          data-ui-sref="payments.paymentsOverview">\n' +
    '                  </button>\n' +
    '                </div>\n' +
    '                <div class="col-xs-6 t-a-r">\n' +
    '                  <button class="btn btn-default domp-review-and-submit-btn" translate="currencyConversion.confirm"\n' +
    '                          data-ng-click="savingsPayIn.savingsPayInSubmit();"\n' +
    '                          ng-disabled="savingsPayIn.accountsFrom.length==0 || savingsPayIn.accountTo.length==0">\n' +
    '                    <!--  ng-disabled="savingsPayIn.accountsFrom.length == 0" -->\n' +
    '\n' +
    '                  </button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Internal transfer STEP 2 -->\n' +
    '        <div ng-show="savingsPayIn.currentStep === 2">\n' +
    '          <div data-ng-include="\'payments/savings-pay-in-resume.tpl.html\'">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Internal transfer STEP 3 -->\n' +
    '        <div ng-show="savingsPayIn.currentStep === 3">\n' +
    '          <div data-ng-include="\'payments/savings-pay-in-final.tpl.html\'"></div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/savings-pay-in-resume.tpl.html',
    '<form name="savingsPayInForm" novalidate>\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="exchange-resume-label" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '          <label class="d-block exchange-resume-val">{{savingsPayIn.paymentResponse.fromAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <label class="exchange-resume-label" translate="domesticPayment.amountInputLabel">Amount</label>\n' +
    '            <label class="d-block exchange-resume-val">\n' +
    '              {{savingsPayIn.paymentResponse.amount | number:2}}\n' +
    '              {{savingsPayIn.paymentResponse.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <label class="exchange-resume-label" translate="domesticPayment.dateInputLabel">When</label>\n' +
    '            <label class="d-block exchange-resume-val">{{savingsPayIn.paymentResponse.dueDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="exchange-resume-label" translate="currencyConversion.toAccount">To account</label>\n' +
    '          <label class="d-block exchange-resume-val">{{savingsPayIn.paymentResponse.toAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="exchange-resume-label" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '          <label class="d-block exchange-resume-val">{{savingsPayIn.paymentResponse.purpose}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- SMS auth old -->\n' +
    '<!--  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-12" ng-if="savingsPayIn.smsAuthentificate != true">\n' +
    '        <div class="form-group">\n' +
    '          <label class="exchange-resume-label" translate="currencyConversion.smsAuthentification"></label>\n' +
    '          <button class="btn btn-default confirm-btn d-block" translate="currencyConversion.sendSms"\n' +
    '                  data-ng-click="savingsPayIn.showSMSAuthentification();"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-12" ng-if="savingsPayIn.smsAuthentificate == true">\n' +
    '        <div class="form-group">\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   data-ng-model="savingsPayIn.smsPasswordInput"\n' +
    '                   placeholder="{{\'currencyConversion.smsPassword\' | translate}}">\n' +
    '            <span class="input-group-btn">\n' +
    '              <button class="btn btn-default input-group-app-btn domp-btn-height">\n' +
    '                <i class="zmdi zmdi-lock"></i>\n' +
    '              </button>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>-->\n' +
    '\n' +
    '  <div class="m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-9 col-xs-6">\n' +
    '        <button class="btn btn-primary" translate="currencyConversion.back"\n' +
    '                data-ng-click="savingsPayIn.backTosavingsPayIn();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary" translate="payments.edit"\n' +
    '                data-ng-click="savingsPayIn.editPayment();"\n' +
    '                >\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary-warning" translate="payments.delete"\n' +
    '                data-ng-click="savingsPayIn.deletePayment();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-3 col-xs-6">\n' +
    '        <div class="pull-right">\n' +
    '<!--          <button class="btn btn-primary confirm-btn"\n' +
    '                  translate="currencyConversion.sign"\n' +
    '                  ng-disabled="!savingsPayInForm.$dirty && savingsPayIn.smsAuthentificate == false"\n' +
    '                  data-ng-click="savingsPayIn.signPayment();">\n' +
    '          </button>-->\n' +
    '          <button class="btn btn-default"\n' +
    '                  translate="currencyConversion.sign"\n' +
    '                  data-ui-sref="payments.sign({paymentId: savingsPayIn.paymentResponse.id, type: \'saving\'})">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/savings-pay-in-final.tpl.html',
    '<div class="currency-conversion-msg" >\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{savingsPayIn.paymentResponse.amount}}\n' +
    '            {{savingsPayIn.paymentResponse.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{savingsPayIn.paymentResponse.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{savingsPayIn.paymentResponse.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments.tpl.html',
    '<section id="main">\n' +
    '  <div class="container payments">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-4 no-padding-on-phone">\n' +
    '        <div class="app-white-card m-b-15">\n' +
    '          <div class="row no-margin">\n' +
    '            <div class="col-xs-6 text-center min-h-108 bottom-border r-border payment-link p-b-10 p-t-10">\n' +
    '              <a data-ui-sref="payments.internalTransfer">\n' +
    '                <div>\n' +
    '                  <i class="zmdi zmdi-flash zmdi-hc-2x"></i>\n' +
    '                </div>\n' +
    '                <div translate="payments.internalTransfer">\n' +
    '                </div>\n' +
    '              </a>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-xs-6 text-center min-h-108 bottom-border payment-link p-b-10 p-t-10">\n' +
    '              <a data-ui-sref="payments.currencyConversion">\n' +
    '                <div>\n' +
    '                  <i class="zmdi zmdi-refresh zmdi-hc-2x"></i>\n' +
    '                </div>\n' +
    '                <div translate="payments.currencyConversion">\n' +
    '                </div>\n' +
    '              </a>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-xs-6 text-center min-h-108 r-border payment-link p-b-10 p-t-10">\n' +
    '                <a data-ui-sref="payments.domesticPayment">\n' +
    '                <div>\n' +
    '                  <i class="zmdi zmdi-book zmdi-hc-2x"></i>\n' +
    '                </div>\n' +
    '                <div translate="payments.domesticPayments">\n' +
    '                </div>\n' +
    '              </a>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-xs-6 text-center min-h-108 payment-link p-b-10 p-t-10" ng-if="payments.countryCode!=\'sr\'">\n' +
    '              <a data-ui-sref="payments.internationalPayment">\n' +
    '                <div>\n' +
    '                  <i class="zmdi zmdi-globe zmdi-hc-2x"></i>\n' +
    '                </div>\n' +
    '                <div translate="payments.internationalPayment">\n' +
    '                </div>\n' +
    '              </a>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 text-center min-h-108 payment-link p-b-10 p-t-10" ng-if="payments.countryCode==\'sr\'">\n' +
    '              <a href="">\n' +
    '                <div>\n' +
    '                  <i class="zmdi zmdi-globe zmdi-hc-2x"></i>\n' +
    '                </div>\n' +
    '                <div translate="payments.internationalPayment">\n' +
    '                </div>\n' +
    '              </a>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- E-Invoice list -->\n' +
    '        <div class="templates-list app-white-card m-b-15" ng-show="payments.countryCode!=\'sr\' && payments.countryCode!=undefined">\n' +
    '          <div class="header-card row no-margin">\n' +
    '            <i class="zmdi zmdi-file-text zmdi-hc-2x p-r-10 col-sm-1 p-l-0"></i>\n' +
    '            <span class="col-sm-6 p-l-10" translate="payments.eInvoices"></span>\n' +
    '            <h5 class="col-sm-4 pull-right eim-sub-label" data-ui-sref="eInvoices.einvoicesIssuersOverview" translate="payments.subscribe"></h5>\n' +
    '            <!--<a href="" class="col-sm-9 pull-right c-white l-h-25 f-14" translate="payments.subscribe"></a>-->\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="list" scrollable>\n' +
    '            <div class="p-b-25" ng-show="payments.eInvoiceDocumentsList.result.length > 0">\n' +
    '              <div kcd-recompile="payments.eInvoiceDocumentsList.result">\n' +
    '                <div class="list-item inner-list-el"\n' +
    '                     data-ng-repeat="eInvoice in ::payments.eInvoiceDocumentsList.result"\n' +
    '                     data-ng-class="{\'last-list-item\': $last, \'list-colored-el\': $odd}">\n' +
    '                  <div class="m-b-10">\n' +
    '                    <b>{{::eInvoice.creditorName}}</b>\n' +
    '                  </div>\n' +
    '                  <div class="m-b-10 wrap-text">\n' +
    '                    <a data-ui-sref="eInvoices.detail({eInvoiceId: eInvoice.id})">\n' +
    '                      {{::eInvoice.purpose}}\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-6 col-xs-6 col-md-3">{{\'payments.due\' | translate}}{{::eInvoice.valueDate|\n' +
    '                      date:\'shortDate\' }}\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-6 col-xs-6 col-md-5">\n' +
    '                      <b class="pull-right bold-font">{{::eInvoice.amount|number:2}} {{::eInvoice.currencySymbol}}</b>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 col-xs-12 col-md-4 margin-top-btn">\n' +
    '                      <button class="btn btn-default app-btn-blue pull-right"\n' +
    '                              data-ng-click="payments.openEInvoicesModal(eInvoice)"\n' +
    '                              translate="payments.pay">\n' +
    '                      </button>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="t-a-c p-10 no-data-image" ng-hide="payments.eInvoiceDocumentsList.result.length > 0">\n' +
    '              <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '              <h5 class="no-data-label" translate="payments.noEinvoices"></h5>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '         <!-- <div ng-show="payments.eInvoiceDocumentsList.hasMore"> -->\n' +
    '          <div ng-hide="payments.eInvoiceDocumentsList.result.length == 0">\n' +
    '             <a data-ui-sref="eInvoices.einvoicesOverview" class="lv-footer f-14" translate="payments.showMoreInvoices"></a>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Templates list -->\n' +
    '      <div class="col-sm-4 no-padding-on-phone">\n' +
    '        <div class="app-white-card templates-list m-b-15">\n' +
    '          <div class="header-card">\n' +
    '            <i class="zmdi zmdi-star zmdi-hc-2x cell-display"></i>\n' +
    '            <span class="cell-display align-vertical-middle p-l-10"\n' +
    '                  translate="payments.templates"></span>\n' +
    '          </div>\n' +
    '          <div class="form-group no-margin">\n' +
    '            <div class="input-group">\n' +
    '              <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">\n' +
    '                <button class="btn btn-default" type="submit" style="box-shadow:none;">\n' +
    '                  <i class="icon icon-search"></i>\n' +
    '                </button>\n' +
    '              </div>\n' +
    '              <input type="text" class="form-control srch-input"\n' +
    '                     placeholder="{{\'payments.searchTemplateName\' | translate}}" name="srch-term" id="srch-term"\n' +
    '                     data-ng-model="searchTemplateText.name">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!--<div class="text-center">-->\n' +
    '          <!--<span class="pointer-cst" data-ng-click="payments.getTopUsedTemplates()"-->\n' +
    '          <!--data-ng-class="{\'active-link\': payments.topUsed}"-->\n' +
    '          <!--translate="payments.topUsed"></span>-->\n' +
    '          <!--<span class="pointer-cst" data-ng-click="payments.getTemplatesAlphabetically()"-->\n' +
    '          <!--data-ng-class="{\'active-link\': payments.templateAlphabetically}"-->\n' +
    '          <!--translate="payments.alphabetically">-->\n' +
    '          <!--</span>-->\n' +
    '          <!--</div>-->\n' +
    '          <div class="list" scrollable>\n' +
    '            <div class="p-b-25" ng-show="payments.templateList.result.length > 0">\n' +
    '              <div>\n' +
    '                <div class="list-item inner-list-el"\n' +
    '                     data-ng-repeat="templateItem in payments.templateList.result | filter: searchTemplateText"\n' +
    '                     data-ng-class="{\'last-list-item\': $last, \'list-colored-el\': $odd}">\n' +
    '                  <div class="row m-b-10">\n' +
    '                    <div class="col-md-10 col-sm-10 col-xs-11">\n' +
    '                      <div class="wrap-text">\n' +
    '                        <a href="">\n' +
    '                          {{::templateItem.name}}\n' +
    '                        </a>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-md-2 col-sm-2 col-xs-1">\n' +
    '                      <div class="dropdown">\n' +
    '                        <a href="" class="dropdown-toggle" data-toggle="dropdown">\n' +
    '                          <i class="zmdi zmdi-more-vert more-opt-hover"></i>\n' +
    '                        </a>\n' +
    '                        <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                          <li>\n' +
    '                            <a href="" class="f-13" data-ng-click="payments.deleteTemplate(templateItem.id);">\n' +
    '                              {{\'payments.delete\' | translate}}\n' +
    '                              <i class="zmdi zmdi-delete zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                            </a>\n' +
    '                          </li>\n' +
    '                          <li>\n' +
    '                            <a href="" class="f-13" data-ng-click="payments.editTemplate(templateItem);">\n' +
    '                              {{\'payments.edit\' | translate}}\n' +
    '                              <i class="zmdi zmdi-edit zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                            </a>\n' +
    '                          </li>\n' +
    '                        </ul>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-12 col-md-8">\n' +
    '                      <span>{{::templateItem.formType}}</span>\n' +
    '                  <span ng-show="templateItem.payeeName">\n' +
    '                    <span translate="payments.to"></span>\n' +
    '                    <b>{{::templateItem.payeeName}}</b>\n' +
    '                  </span>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 col-md-4 margin-top-btn">\n' +
    '                      <button class="btn btn-default app-btn-blue pull-right"\n' +
    '                              data-ng-click="payments.openTemplateModal(templateItem);"\n' +
    '                              translate="payments.pay">\n' +
    '                      </button>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="t-a-c p-10 no-data-image" ng-hide="payments.templateList.result.length > 0">\n' +
    '              <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '              <h5 class="no-data-label" translate="payments.noTemplates"></h5>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-show="payments.templateList.hasMore">\n' +
    '            <a href="" class="lv-footer f-14" translate="payments.showMoreTemplates"\n' +
    '               data-ng-click="payments.loadMoreTemplates()">\n' +
    '            </a>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- SEPA direct debit -->\n' +
    '        <div class="templates-list app-white-card">\n' +
    '          <div class="header-card row no-margin">\n' +
    '            <i class="zmdi zmdi-folder zmdi-hc-2x col-sm-3 l-h-25"></i>\n' +
    '            <span class="col-sm-9 l-h-25"\n' +
    '                  translate="payments.sepaDirectDebit"></span>\n' +
    '            <!--<a href="" class="col-xs-3 col-sm-12 pull-right c-white l-h-25 f-14" translate="payments.settings"></a>-->\n' +
    '          </div>\n' +
    '          <div style="padding: 10px 15px;">\n' +
    '            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer scelerisque pretium porta.\n' +
    '            Curabitur blandit nibh sed nulla consectetur, porttitor placerat urna commodo. Vestibulum finibus mi risus,\n' +
    '            vitae tempor massa viverra sit amet. Fusce efficitur bibendum augue.\n' +
    '            Aenean lobortis laoreet massa, a lacinia nibh egestas quis. Nam id justo eget ex consequat iaculis.\n' +
    '            Sed quis nisi ante. Sed a dignissim ipsum.\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-show="payments.templateList.hasMore">\n' +
    '            <a href="" class="lv-footer f-14" translate="payments.viewAllTransactions">\n' +
    '            </a>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-4 no-padding-on-phone">\n' +
    '\n' +
    '        <div class="app-white-card payment-blue-box m-b-15">\n' +
    '          <div>\n' +
    '            <div class="cell-display">\n' +
    '                <a data-ui-sref="payments.paymentsOverview" translate="payments.allPastPayments">\n' +
    '              </a>\n' +
    '            </div>\n' +
    '            <div class="cell-display align-vertical-middle chavron-icon">\n' +
    '              <i class="zmdi zmdi-chevron-right zmdi-hc-2x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div>\n' +
    '            <div class="cell-display">\n' +
    '              <a data-ui-sref="payments.exchangeRates" translate="payments.exchangeRatesList">\n' +
    '              </a>\n' +
    '            </div>\n' +
    '            <div class="cell-display align-vertical-middle chavron-icon">\n' +
    '              <i class="zmdi zmdi-chevron-right zmdi-hc-2x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div>\n' +
    '            <div class="cell-display">\n' +
    '              <a href="" translate="payments.donationToCharity">\n' +
    '              </a>\n' +
    '            </div>\n' +
    '            <div class="cell-display align-vertical-middle chavron-icon">\n' +
    '              <i class="zmdi zmdi-chevron-right zmdi-hc-2x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <!--<div class="wb-list-wrapper app-white-card m-b-15">-->\n' +
    '          <!--<a href="">-->\n' +
    '            <!--<div class="wb-list-item-lg">-->\n' +
    '              <!--<span class="m-l-15 f-14" translate="payments.allPastPayments">-->\n' +
    '              <!--</span>-->\n' +
    '              <!--<i class="zmdi zmdi-chevron-right pull-right"></i>-->\n' +
    '            <!--</div>-->\n' +
    '          <!--</a>-->\n' +
    '          <!--<hr class="m-b-5 m-t-5">-->\n' +
    '          <!--<a data-ui-sref="payments.exchangeRates">-->\n' +
    '            <!--<div class="wb-list-item-lg">-->\n' +
    '              <!--<span class="m-l-15 f-14" translate="payments.exchangeRatesList">-->\n' +
    '              <!--</span>-->\n' +
    '              <!--<i class="zmdi zmdi-chevron-right pull-right"></i>-->\n' +
    '            <!--</div>-->\n' +
    '          <!--</a>-->\n' +
    '          <!--<hr class="m-b-5 m-t-5">-->\n' +
    '          <!--<a href="">-->\n' +
    '            <!--<div class="wb-list-item-lg">-->\n' +
    '              <!--<span class="m-l-15  f-14" translate="payments.donationToCharity">-->\n' +
    '              <!--</span>-->\n' +
    '              <!--<i class="zmdi zmdi-chevron-right pull-right"></i>-->\n' +
    '            <!--</div>-->\n' +
    '          <!--</a>-->\n' +
    '\n' +
    '        <!--</div>-->\n' +
    '\n' +
    '        <!--Rejected payments list-->\n' +
    '        <div class="app-white-card rejected-payment-box m-b-15">\n' +
    '          <div class="row no-margin header-card bg-danger">\n' +
    '            <div class="col-sm-7 col-xs-6">\n' +
    '              <i class="zmdi zmdi-alert-triangle zmdi-hc-2x cell-display c-white"></i>\n' +
    '            <span class="cell-display align-vertical-middle p-l-10 f-14 c-white"\n' +
    '                  translate="payments.rejectedPayments"></span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-5 col-xs-6">\n' +
    '              <div class="dropdown acc-period-select pull-right">\n' +
    '                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"\n' +
    '                        aria-haspopup="true" aria-expanded="true">\n' +
    '                  {{payments.rejectedPeriod.item.description}}\n' +
    '                  <span class="caret"></span>\n' +
    '                </button>\n' +
    '                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                  <li data-ng-repeat="period in payments.periodList">\n' +
    '                    <a href="" class="f-13" data-ng-click="payments.rejectedPaymentsTimeFilter(period);">\n' +
    '                      {{period.item.description}}\n' +
    '                    </a>\n' +
    '                  </li>\n' +
    '                </ul>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="list" scrollable>\n' +
    '            <div class="p-b-25" ng-show="payments.rejectedPaymentsList.result.length > 0">\n' +
    '              <div kcd-recompile="payments.rejectedPaymentsList.result">\n' +
    '                <div class="list-item inner-list-el"\n' +
    '                     data-ng-repeat="rejectedItem in ::payments.rejectedPaymentsList.result"\n' +
    '                     data-ng-class="{\'last-list-item\': $last, \'list-colored-el\': $odd}">\n' +
    '\n' +
    '                  <div class="row m-b-10">\n' +
    '                    <div class="col-md-10 col-sm-10 col-xs-11">\n' +
    '                      <div class="wrap-text">\n' +
    '                        <a href="">\n' +
    '                          {{::rejectedItem.purpose}}\n' +
    '                        </a>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-md-2 col-sm-2 col-xs-1">\n' +
    '                      <div class="dropdown">\n' +
    '                        <a href="" class="dropdown-toggle" data-toggle="dropdown">\n' +
    '                          <i class="zmdi zmdi-more-vert more-opt-hover"></i>\n' +
    '                        </a>\n' +
    '                        <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                          <li data-ng-repeat="actionObject in rejectedItem.allowedActionList.itemList">\n' +
    '                            <div ng-switch on="actionObject.methodName">\n' +
    '                              <a ng-if="actionObject.isEnabled" ng-switch-when="SignAllowed" class="f-13" data-ng-click="payments.signPayment(rejectedItem.id);">\n' +
    '                              {{\'payments.delete\' | translate}}\n' +
    '                              <i class="zmdi zmdi-delete zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                            </a>\n' +
    '                              <a ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed" class="f-13" data-ng-click="payments.deletePayment(rejectedItem.id);">\n' +
    '                                {{\'payments.delete\' | translate}}\n' +
    '                                <i class="zmdi zmdi-delete zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                              </a>\n' +
    '                              <a ng-if="actionObject.isEnabled" ng-switch-when="RecallAllowed" class="f-13" data-ng-click="payments.recallPayment(rejectedItem.id);">\n' +
    '                                {{\'payments.delete\' | translate}}\n' +
    '                                <i class="zmdi zmdi-delete zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                              </a>\n' +
    '                            </div>\n' +
    '                          </li>\n' +
    '                        </ul>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="m-b-10">\n' +
    '                  <span>\n' +
    '                    {{::rejectedItem.valueDate | date: \'shortDate\'}}\n' +
    '                  </span>\n' +
    '                  <span ng-show="rejectedItem.formType">\n' +
    '                    {{::rejectedItem.formType}}\n' +
    '                  </span>\n' +
    '                  <span ng-show="rejectedItem.amount">\n' +
    '                     of <b>{{::rejectedItem.amount | number:2}} {{::rejectedItem.currencySymbol}}</b>\n' +
    '                  </span>\n' +
    '                  <span ng-show="rejectedItem.receiverName">\n' +
    '                     to <b>{{::rejectedItem.receiverName}}</b>\n' +
    '                  </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="t-a-c p-10 no-data-image" ng-if="payments.rejectedPaymentsList.result.length == 0">\n' +
    '              <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '              <h5 class="no-data-label" translate="payments.noRejectedPayments"></h5>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-show="payments.rejectedPaymentsList.result.length > 0">\n' +
    '            <a href="" class="lv-footer f-14" translate="payments.moreRejected"\n' +
    '               data-ng-click="payments.loadMoreRejectedPayments();">\n' +
    '            </a>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <!--Pending payments-->\n' +
    '        <div class="app-white-card pending-payment-box">\n' +
    '          <div class="row no-margin header-card bg-warning">\n' +
    '            <div class="col-sm-12">\n' +
    '              <i class="zmdi zmdi-hourglass-alt zmdi-hc-2x cell-display c-white"></i>\n' +
    '              <span class="cell-display align-vertical-middle p-l-10 f-14 c-white"\n' +
    '                    translate="payments.pendingPayments"></span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="list" scrollable>\n' +
    '            <div class="p-b-25" ng-show="payments.pendingPaymentsList.result.length > 0">\n' +
    '              <div kcd-recompile="payments.pendingPaymentsList.result">\n' +
    '                <div class="list-item inner-list-el"\n' +
    '                     data-ng-repeat="pendingItem in ::payments.pendingPaymentsList.result"\n' +
    '                     data-ng-class="{\'last-list-item\': $last, \'list-colored-el\': $odd}">\n' +
    '\n' +
    '                  <div class="row m-b-10">\n' +
    '                    <div class="col-md-10 col-sm-10 col-xs-11">\n' +
    '                      <div class="wrap-text">\n' +
    '                        <a href="">\n' +
    '                          {{::pendingItem.purpose}}\n' +
    '                        </a>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-md-2 col-sm-2 col-xs-1">\n' +
    '                      <div class="dropdown">\n' +
    '                        <a href="" class="dropdown-toggle" data-toggle="dropdown">\n' +
    '                          <i class="zmdi zmdi-more-vert more-opt-hover"></i>\n' +
    '                        </a>\n' +
    '                        <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                          <li data-ng-repeat="actionObject in pendingItem.allowedActionList.itemList">\n' +
    '                            <div ng-switch on="actionObject.methodName">\n' +
    '                              <a ng-if="actionObject.isEnabled" ng-switch-when="SignAllowed" class="f-13" data-ng-click="payments.signPayment(pendingItem.id);">\n' +
    '                                {{\'payments.delete\' | translate}}\n' +
    '                                <i class="zmdi zmdi-delete zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                              </a>\n' +
    '                              <a ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed" class="f-13" data-ng-click="payments.deletePayment(pendingItem.id);">\n' +
    '                                {{\'payments.delete\' | translate}}\n' +
    '                                <i class="zmdi zmdi-delete zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                              </a>\n' +
    '                              <a ng-if="actionObject.isEnabled" ng-switch-when="RecallAllowed" class="f-13" data-ng-click="payments.recallPayment(pendingItem.id);">\n' +
    '                                {{\'payments.delete\' | translate}}\n' +
    '                                <i class="zmdi zmdi-delete zmdi-hc-lg m-l-15 pull-right"></i>\n' +
    '                              </a>\n' +
    '                            </div>\n' +
    '                          </li>\n' +
    '                        </ul>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div>\n' +
    '                  <span>\n' +
    '                    {{::pendingItem.valueDate | date: \'shortDate\'}}\n' +
    '                  </span> -\n' +
    '                  <span ng-show="pendingItem.formType">\n' +
    '                    {{::pendingItem.formType}}\n' +
    '                  </span>\n' +
    '                  <span ng-show="pendingItem.amount">\n' +
    '                     of <b>{{::pendingItem.amount | number:2}} {{::pendingItem.currencySymbol}}</b>\n' +
    '                  </span>\n' +
    '                  <span ng-show="pendingItem.receiverName">\n' +
    '                     to <b>{{::pendingItem.receiverName}}</b>\n' +
    '                  </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="t-a-c p-10 no-data-image" ng-if="payments.pendingPaymentsList.result.length == 0">\n' +
    '              <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '              <h5 class="no-data-label" translate="payments.noPendingPayments"></h5>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-show="payments.pendingPaymentsList.result.length > 0">\n' +
    '            <a href="" class="lv-footer f-14" translate="payments.morePending"\n' +
    '               data-ng-click="payments.loadMorePendingPayments()">\n' +
    '            </a>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-sign-resume.tpl.html',
    '<div>\n' +
    '  <div class="exchange-rate-header">\n' +
    '    <div class="row">\n' +
    '      <div ng-show="paymentsOverview.selectedPaymentForSign.id" class="col-sm-12 col-xs-6 f-20" translate="paymentSignModal.title"></div>\n' +
    '      <div ng-show="paymentsOverview.paymentsGroupList.id" class="col-sm-12 col-xs-6 f-20" translate="paymentsAndTransferOverview.groupedPaymentsLabel"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Actions for payments group -->\n' +
    '  <div ng-show="paymentsOverview.paymentsGroupList.id" class="row m-b-10">\n' +
    '    <span class="col-xs-12 m-t-20" ng-show="!paymentsOverview.areAllPaymentsDueDateValid"\n' +
    '          translate="signPayments.paymentsInvalidDueDate"></span>\n' +
    '          <span class="col-xs-12 payments-filter-active" ng-show="paymentsOverview.dueDateUpdateAllowed && !paymentsOverview.areAllPaymentsDueDateValid"\n' +
    '                data-ng-click="paymentsOverview.updateGroupPaymentDates()" translate="signPayments.updatePaymentsDueDate">\n' +
    '          </span>\n' +
    '    <div class="col-xs-12 m-t-15">\n' +
    '      <button class="btn btn-primary col-xs-3 pull-right" data-ng-click="paymentsOverview.signGroupPayments()"\n' +
    '              ng-disabled="!paymentsOverview.areAllPaymentsDueDateValid"\n' +
    '              translate="paymentsAndTransferOverview.signAllAction"></button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Actions for single payment -->\n' +
    '  <div ng-show="paymentsOverview.selectedPaymentForSign.id" class="row m-b-10">\n' +
    '    <span class="col-xs-12 m-t-20" ng-show="!paymentsOverview.isPaymentDueDateValid"\n' +
    '          translate="signPayments.singlePaymentInvalidDueDate"></span>\n' +
    '          <span class="col-xs-12 payments-filter-active" ng-show="paymentsOverview.dueDateUpdateAllowed && !paymentsOverview.isPaymentDueDateValid"\n' +
    '                data-ng-click="paymentsOverview.updateSinglePaymentDate()" translate="signPayments.updatePaymentDueDate">\n' +
    '          </span>\n' +
    '    <div class="col-xs-12 m-t-15">\n' +
    '      <button class="btn btn-primary col-xs-3 pull-right" data-ng-click="paymentsOverview.signSinglePayment()"\n' +
    '              ng-disabled="!paymentsOverview.isPaymentDueDateValid"\n' +
    '              translate="paymentSignModal.title"></button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Header for payments sign -->\n' +
    '  <div class="row group-sign-header p-t-20 p-b-10 m-t-15">\n' +
    '    <div class="col-xs-5">\n' +
    '            <span class="col-xs-6" translate="payments.fromAccount">\n' +
    '              From account\n' +
    '            </span>\n' +
    '            <span class="col-xs-6" translate="payments.toAccount">\n' +
    '              To account\n' +
    '            </span>\n' +
    '    </div>\n' +
    '          <span class="col-xs-2" translate="loanPayment.purpose" >\n' +
    '            Purpose\n' +
    '          </span>\n' +
    '          <span class="col-xs-2 t-a-r" translate="domesticPayment.amountInputLabel">\n' +
    '            Amount\n' +
    '          </span>\n' +
    '    <div class="col-xs-3">\n' +
    '            <span class="col-xs-6" translate="signPayments.dateCreated">\n' +
    '            Date created\n' +
    '            </span>\n' +
    '            <span class="col-xs-6" translate="signPayments.dueDate">\n' +
    '              Due date\n' +
    '            </span>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Details for group of payments -->\n' +
    '  <div ng-if="paymentsOverview.paymentsGroupList.id" class="row group-sign-content" data-ng-repeat="payment in paymentsOverview.paymentsGroupList.paymentList">\n' +
    '    <div class="col-xs-5">\n' +
    '            <span class="col-xs-6">\n' +
    '            {{payment.fromAccountNumber}}\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '              {{payment.toAccountNumber}}\n' +
    '            </span>\n' +
    '    </div>\n' +
    '          <span class="col-xs-2 t-a-l" title="{{payment.purpose}}">\n' +
    '            {{ payment.purpose | limitTo: 40 }}{{payment.purpose.length > 40 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <span class="col-xs-2 t-a-r">\n' +
    '            {{payment.amount|number:2}} {{::payment.currencySymbol}}\n' +
    '          </span>\n' +
    '    <div class="col-xs-3">\n' +
    '            <span class="col-xs-6">\n' +
    '            {{payment.dateCreated| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '              {{payment.dueDate| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Details for single payment -->\n' +
    '  <div ng-if="paymentsOverview.selectedPaymentForSign.id" class="row group-sign-content">\n' +
    '    <div class="col-xs-5">\n' +
    '            <span class="col-xs-6">\n' +
    '            {{paymentsOverview.selectedPaymentForSign.fromAccountNumber}}\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '              {{paymentsOverview.selectedPaymentForSign.toAccountNumber}}\n' +
    '            </span>\n' +
    '    </div>\n' +
    '          <span class="col-xs-2 t-a-l" title="{{payment.purpose}}">\n' +
    '            {{ paymentsOverview.selectedPaymentForSign.purpose | limitTo: 40 }}{{paymentsOverview.selectedPaymentForSign.purpose.length > 40 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <span class="col-xs-2 t-a-r">\n' +
    '            {{paymentsOverview.selectedPaymentForSign.amount|number:2}} {{::paymentsOverview.selectedPaymentForSign.currencySymbol}}\n' +
    '          </span>\n' +
    '    <div class="col-xs-3">\n' +
    '            <span class="col-xs-6">\n' +
    '            {{paymentsOverview.selectedPaymentForSign.dateCreated| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '              {{paymentsOverview.selectedPaymentForSign.dueDate| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-return.tpl.html',
    '<section id="main">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row">\n' +
    '            <div class="col-lg-12 col-md-12 col-sm-12 p-r-0" style="z-index:1;">\n' +
    '                <div class="tmplt-list-title col-lg-12 col-md-12 col-sm-12 col-xs-12 p-r-0 p-l-0 m-b-15">\n' +
    '                    <h2 class="title-style" translate="paymentsReturn.titleLabel">List of payments</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12" style="z-index:1;">\n' +
    '                <div class="po-type-container">\n' +
    '                    <div ng-class="{\'selected\': paymentsReturn.paymentsTypeSelected === 1}" ng-click="paymentsReturn.selectPaymentsType(\'open\', \'paymentsReturn.openedTab\')" class="col-xs-6 payments-return-type-tab no-wrap-text" translate="paymentsReturn.openedTab"></div>\n' +
    '                    <div ng-class="{\'selected\': paymentsReturn.paymentsTypeSelected === 2}" ng-click="paymentsReturn.selectPaymentsType(\'archived\', \'paymentsReturn.archivedTab\')" class="col-xs-6 payments-return-type-tab no-wrap-text" translate="paymentsReturn.archivedTab"></div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="po-filter-row clearfix p-20 bgm-white" style="z-index:1;">\n' +
    '\n' +
    '                    <!-- Filter -->\n' +
    '                    <div class="col-md-6 col-xs-12 p-0 p-b-10">\n' +
    '                        <div ng-include="\'payments/payments-return-filter.tpl.html\'" style="height:40px"></div>\n' +
    '                    </div>\n' +
    '                    <div class="col-md-6 col-xs-12 p-0 p-b-10">\n' +
    '                        <div class="dropdown acc-period-select pull-right" style="display: inline-block">\n' +
    '                            <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '                                {{paymentsReturn.selectedPeriod.item.description | translate}}\n' +
    '                                <span class="caret"></span>\n' +
    '                            </button>\n' +
    '                            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                                <li data-ng-repeat="period in paymentsReturn.periodList">\n' +
    '                                    <a href="" class="f-13" data-ng-click="paymentsReturn.paymentsPeriodFilter(period)">\n' +
    '                  {{period.item.description | translate}}\n' +
    '                </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="timeline-row payments col-sm-12 no-padding">\n' +
    '                    <div class="hypo-timeline-wrapper app-white-card p-0 p-b-10 p-t-10">\n' +
    '                        <div class="t-a-c p-10 no-data-image" ng-if="paymentsReturn.paymentsOverviewList.result.length === 0">\n' +
    '                            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                            <h3 class="no-data-label" translate="paymentsOverview.noPaymentData"></h3>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <ul class="hypo-timeline payments-list" ng-if="paymentsReturn.paymentsOverviewList.result.length !== 0">\n' +
    '\n' +
    '                            <li class="" ng-repeat="payment in paymentsReturn.paymentsOverviewList.result">\n' +
    '                                <i class="icon icon-change currency-icon-change icon-lh"></i>\n' +
    '                                <div class="hypo-timeline-item payment-item" ng-class="{\'opened\': payment.selected}" ng-click="paymentsReturn.togglePaymentDetails(payment)">\n' +
    '                                    <div class="hypo-timeline-body">\n' +
    '                                        <div class="col-xs-6">\n' +
    '                                            <h4 ng-if="payment.purpose" class="m-b-0 m-t-0 c-gray"><b>{{::payment.purpose}}</b></h4>\n' +
    '                                            <h4 ng-if="!payment.purpose" class="m-b-0 m-t-0 c-gray"><b>{{::payment.paymentTypeGroup}}</b></h4>\n' +
    '                                            <p class="m-b-0 m-t-0 iban-style">{{::payment.fromAccountNumber}}</p>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                        <div class="col-xs-6">\n' +
    '                                            <span class="pull-right t-a-r m-t-5 f-18">\n' +
    '                      <b>{{::payment.amount|number:2}} {{::payment.currencySymbol}}</b><br/>\n' +
    '                    <!--<span ng-class="{\'text-danger\': payment.status === \'Rejected\'}">{{::payment.status}}</span>-->\n' +
    '                                            <span class="po-value-label">\n' +
    '                      <span class="po-value-label" ng-class="{\'text-danger\': payment.status === \'Rejected\'}" ng-if="payment.status === \'Rejected\'" translate="paymentsOverview.rejected"></span>\n' +
    '                                            <span class="po-value-label" ng-if="payment.status === \'Processed\'" translate="paymentsOverview.processed"></span>\n' +
    '                                            <span class="po-value-label" ng-if="payment.status === \'Cancelled\'" translate="paymentsOverview.cancelled"></span>\n' +
    '                                            <span class="po-value-label" ng-if="payment.status === \'InProcessing\'" translate="paymentsOverview.inProcessing"></span>\n' +
    '                                            <span class="po-value-label" ng-if="payment.status === \'Opened\'" translate="paymentsOverview.open"></span>\n' +
    '                                            <span class="po-value-label" ng-if="payment.status === \'WaitingQueue\'" translate="paymentsOverview.waitingQueque"></span>\n' +
    '                                            </span>\n' +
    '                                            </span>\n' +
    '                                        </div>\n' +
    '                                        <div class="clear"></div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                    <div ng-if="payment.selected" class="transaction-details">\n' +
    '                                        <div>\n' +
    '                                            <table class="table table-transparent table-responsive">\n' +
    '                                                <tbody>\n' +
    '                                                    <tr>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.povlStatus"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.status}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr ng-if="payment.status === \'Rejected\'">\n' +
    '                                                        <td ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                                                            <span ng-switch-default class="po-desc-label" translate="paymentsOverview.povlNote"></span>\n' +
    '                                                            <span ng-switch-when="sl" class="po-desc-label" translate="paymentsOverview.povlNote_SLO"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.note}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '\n' +
    '                                                    <tr>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.povlId"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.id}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.povlReceiver"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.receiverName}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.povlFrom"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.fromAccountNumber}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.povlTo"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.toAccountNumber}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.povlAmount"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.amount|number:2}} {{::payment.currencySymbol}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr ng-if="payment.referenceTo">\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.referenceTo"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.referenceTo}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-desc-label" translate="paymentsOverview.povlDueDate"></span>\n' +
    '                                                        </td>\n' +
    '                                                        <td>\n' +
    '                                                            <span class="po-value-label">{{::payment.dueDate| date:\'shortDate\'}}</span>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                    <tr>\n' +
    '                                                        <td colspan="2">\n' +
    '                                                            <div>\n' +
    '                                                                <!-- Show actions only if current tab is \'Opened\'-->\n' +
    '                                                                <span ng-if="paymentsReturn.paymentsTypeSelected === 1">\n' +
    '                              <button ng-click="paymentsReturn.rejectPaymentRecall(payment.id);"\n' +
    '                                      class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase pull-left"\n' +
    '                                      translate="paymentActions.rejectRecall">Reject recall</button>\n' +
    '\n' +
    '                              <!-- TODO: Check will user immediately sign payment, or there will be read only form first -->\n' +
    '                                                                    <button ng-click="paymentsReturn.pushGtmApproveRecallEvent();" data-ui-sref="payments.sign({paymentId: payment.id})"\n' +
    '                                      class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                                      translate="paymentActions.approveRecall">Approve recall</button>\n' +
    '                            </span>\n' +
    '                                                            </div>\n' +
    '                                                        </td>\n' +
    '                                                    </tr>\n' +
    '                                                </tbody>\n' +
    '                                            </table>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 t-a-c m-t-15">\n' +
    '                <button ng-if="paymentsReturn.paymentsOverviewList.hasMore == true" data-ng-click="paymentsReturn.loadMorePayments()" type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn" translate="paymentsOverview.loadMoreBtn">Load more\n' +
    '                </button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-return-filter.tpl.html',
    '<div class="tml-filter-container tmlf-wide" id="searchFilterExpandedDiv">\n' +
    '    <div id="searchBtnLeftDiv" class="inner-section left">\n' +
    '        <i class="icon icon-search  zmdi-hc-2x m-l-5"></i>\n' +
    '    </div>\n' +
    '    <div id="searchBtnCenterDiv" class="inner-section center">\n' +
    '        <input id="searchTimelineInput" type="text" class="search-input" placeholder="{{\'timelineFilter.placeholder\'|translate}}" ng-model="paymentsReturn.paymentsFilter.purposeFTS" ng-model-options="{ debounce: 300 }">\n' +
    '    </div>\n' +
    '    <div id="searchBtnRightDiv" class="inner-section right" ng-init="paymentsReturn.showDeleteInputBtn = false">\n' +
    '        <i ng-show="!paymentsReturn.showDeleteInputBtn" class="icon icon-filter  zmdi-hc-2x m-r-0" ng-click="paymentsReturn.toggleFilterSelection();"></i>\n' +
    '        <i ng-show="paymentsReturn.showDeleteInputBtn" class="zmdi zmdi-tag-close  zmdi-hc-2x m-r-0" ng-click="paymentsReturn.paymentsFilter.purposeFTS = \'\'; paymentsReturn.showDeleteInputBtn = false"></i>\n' +
    '    </div>\n' +
    '    <div class="tml-filter-selection" ng-class="{\'opened\': paymentsReturn.searchFilterExpanded}">\n' +
    '        <div class="m-t-15" style="overflow:auto">\n' +
    '            <div class="col-xs-4 p-l-5 p-r-5">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="f-12-s" translate="timelineFilter.amountFrom"></label>\n' +
    '                    <input ng-keyup="$event.keyCode == 13 && paymentsReturn.applyPaymentsFilter()" type="text" class="form-control-db" ng-model="paymentsReturn.paymentsFilter.amountGTE" amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" autocomplete="off">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-4 p-l-0 p-r-5">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="f-12-s" translate="timelineFilter.amountTo"></label>\n' +
    '                    <input ng-keyup="$event.keyCode == 13 && paymentsReturn.applyPaymentsFilter()" type="text" class="form-control-db" ng-model="paymentsReturn.paymentsFilter.amountLTE" amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" autocomplete="off">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-4 p-l-0 p-r-5" style="padding-top:23px;">\n' +
    '                <select name="" id="" class="form-control-db" ng-options="option.symbol for option in paymentsReturn.currenciesList" ng-model="paymentsReturn.currencySelectObject">\n' +
    '                </select>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="m-b-15" style="overflow:auto">\n' +
    '            <div class="col-xs-6 t-a-l p-l-5">\n' +
    '                <button class="btn btn-primary app-btn-gray" ng-click="paymentsReturn.resetPaymentsFilter();" translate="timelineFilter.reset"></button>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 t-a-r p-r-5">\n' +
    '                <button class="btn btn-default app-btn-blue w-100" ng-click="paymentsReturn.applyPaymentsFilter();" translate="timelineFilter.apply"></button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-recall-modal.tpl.html',
    '<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <div ng-switch-default>\n' +
    '    <div class="modal-header statement-confirm-header p-10">\n' +
    '      <h3 translate="paymentsReturn.modalTitle"></h3>\n' +
    '    </div>\n' +
    '    <div class="modal-body text-center m-t-10">\n' +
    '      <ng-form name="paymentsRecallModal.recallForm">\n' +
    '\n' +
    '        <div class="form-group" class="col-xs-12">\n' +
    '          <label class="domp-form-label pull-left" translate="paymentsReturn.recallReason">Razlog za povrat</label>\n' +
    '          <select class="form-control input-field" ng-model="paymentsRecallModal.recallReasonObject.reasonCode"\n' +
    '                  ng-options="reason.value as reason.key | translate for reason in paymentsRecallModal.recallReasonsList">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <label class="domp-form-label pull-left" translate="paymentsReturn.additionalInfo">Razlog za povrat</label>\n' +
    '            <textarea name="recallInfo" id="recallInfo" class="form-control statement-confirm-textarea"\n' +
    '                      ng-class="{\'statement-confirm-information-error\': paymentsRecallModal.recallForm.$error.required && paymentsRecallModal.formSubmitted}"\n' +
    '                      ng-model="paymentsRecallModal.recallReasonObject.additionalInformation"\n' +
    '                      ng-required="paymentsRecallModal.recallReasonObject.reasonCode === \'FRAD\'"\n' +
    '                      maxlength="200">\n' +
    '        </textarea>\n' +
    '            <span class="c-red"\n' +
    '                  ng-show="paymentsRecallModal.recallForm.recallInfo.$error.required && paymentsRecallModal.formSubmitted"\n' +
    '                  translate="paymentsReturn.additionalInfoError"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </ng-form>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <button class="btn btn-default" ng-click="$close()"><span\n' +
    '            translate="statementConfirmModalTranslations.cancelButton"></span></button>\n' +
    '          <button class="btn btn-primary" ng-click="paymentsRecallModal.confirm()"><span\n' +
    '            translate="statementConfirmModalTranslations.confirmButton"></span></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-switch-when="sl">\n' +
    '    <div class="modal-header statement-confirm-header p-10">\n' +
    '      <h3 translate="paymentActions.cancelPayment"></h3>\n' +
    '    </div>\n' +
    '    <div class="modal-body m-t-10">\n' +
    '      <table class="table table-transparent table-responsive">\n' +
    '        <tbody>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="paymentsOverview.povlStatus">Status:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label" ng-if="paymentsRecallModal.payment.status === \'WaitingQueue\'" translate="paymentsOverview.waitingQueque"></span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="paymentsOverview.povlId">Payment id:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label">{{::paymentsRecallModal.payment.id}}</span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="paymentsOverview.povlReceiver">Receiver name:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label">{{::paymentsRecallModal.payment.receiverName}}</span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="paymentsOverview.povlFrom">From account:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label">{{::paymentsRecallModal.payment.fromAccountNumber}}</span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="paymentsOverview.povlTo">To account:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label">{{::paymentsRecallModal.payment.toAccountNumber}}</span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="paymentsOverview.povlAmount">Amount:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label">{{::paymentsRecallModal.payment.amount|number:2}} {{::paymentsRecallModal.payment.currencySymbol}}</span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="signPayments.dateCreated">Create date:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label">{{::paymentsRecallModal.payment.dateCreated| date:\'shortDate\'}}</span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <span class="po-desc-label" translate="paymentsOverview.povlDueDate">Due date:</span>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <span class="po-value-label">{{::paymentsRecallModal.payment.dueDate| date:\'shortDate\'}}</span>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal-footer">\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <button class="btn btn-primary" ng-click="$close()"><span\n' +
    '            translate="statementConfirmModalTranslations.cancelButton"></span></button>\n' +
    '          <button class="btn btn-default" ng-click="paymentsRecallModal.confirm()"><span\n' +
    '            translate="statementConfirmModalTranslations.confirmButton"></span></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-overview.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-12 col-md-12 col-sm-12" style="z-index:1;">\n' +
    '        <div class="tmplt-list-title col-lg-12 col-md-12 col-sm-12 col-xs-12 p-r-0 m-b-15 p-0">\n' +
    '          <h2 class="title-style" translate="paymentsOverview.titleLabel">List of payments</h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12" style="z-index:1;">\n' +
    '        <!-- Easier way to duplicate code - than modifying CSS width-->\n' +
    '        <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '          <div class="po-type-container" ng-switch-default>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 1}" ng-click="paymentsOverview.selectPaymentsType(\'all\', \'paymentsOverview.paymentsType.allTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.allTab"></div>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 2}" ng-click="paymentsOverview.selectPaymentsType(\'processed\', \'paymentsOverview.paymentsType.realizedTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.realizedTab"></div>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 3}" ng-click="paymentsOverview.selectPaymentsType(\'pending\', \'paymentsOverview.paymentsType.pendingTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.pendingTab"></div>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 4}" ng-click="paymentsOverview.selectPaymentsType(\'rejected\', \'paymentsOverview.paymentsType.rejectedTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.rejectedTab"></div>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 5}" ng-click="paymentsOverview.selectPaymentsType(\'not-signed\', \'paymentsOverview.paymentsType.notSigned\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.notSigned"></div>\n' +
    '          </div>\n' +
    '          <div class="po-type-container" ng-switch-when="sl">\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 1}" ng-click="paymentsOverview.selectPaymentsType(\'all\', \'paymentsOverview.paymentsType.allTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.allTab" style="width: 25%"></div>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 2}" ng-click="paymentsOverview.selectPaymentsType(\'processed\', \'paymentsOverview.paymentsType.realizedTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.realizedTab" style="width: 25%"></div>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 3}" ng-click="paymentsOverview.selectPaymentsType(\'pending\', \'paymentsOverview.paymentsType.pendingTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.pendingTab" style="width: 25%"></div>\n' +
    '            <div ng-class="{\'selected\': paymentsOverview.paymentsTypeSelected === 4}" ng-click="paymentsOverview.selectPaymentsType(\'rejected\', \'paymentsOverview.paymentsType.rejectedTab\')" class="po-type-tab no-wrap-text" translate="paymentsOverview.paymentsType.rejectedTab" style="width: 25%"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="po-filter-row col-sm-12 clearfix p-20 bgm-white" style="z-index:1;">\n' +
    '\n' +
    '          <!-- Show only for not signed payments -->\n' +
    '          <div ng-if="paymentsOverview.paymentsTypeSelected === 5" class="col-xs-12 m-t-10 m-b-10 p-r-0">\n' +
    '\n' +
    '            <div class="col-xs-6">\n' +
    '              <span translate="paymentsOverview.selectNone" class="f-uppercase f-18 cursor-pointer" data-ng-click="paymentsOverview.selectNonePaymentsForSign()" data-ng-class="{\'payments-filter-active\': paymentsOverview.areNonePaymentsSelected}"></span> /\n' +
    '              <span translate="paymentsOverview.selectAll" class="f-uppercase f-18 cursor-pointer" data-ng-click="paymentsOverview.selectAllPaymentsForSign()" data-ng-class="{\'payments-filter-active\': paymentsOverview.areAllPaymentsSelected}"></span>\n' +
    '            </div>\n' +
    '\n' +
    '            <button ng-hide="paymentsOverview.areNonePaymentsSelected" class="btn btn-primary col-xs-4 pull-right p-r-0" data-ng-click="paymentsOverview.signSelectedPaymentsAction()" translate="paymentsOverview.signSelectedPayments"></button>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-sm-6 col-xs-12  p-0">\n' +
    '            <div ng-include="\'payments/payments-overview-filter.tpl.html\'" style="height:40px"></div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6 col-xs-12 p-0 m-m-t-10">\n' +
    '            <div class="dropdown acc-period-select pull-right" style="display: inline-block">\n' +
    '              <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '                {{paymentsOverview.selectedPeriod.item.description| translate}}\n' +
    '                <span class="caret"></span>\n' +
    '              </button>\n' +
    '              <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                <li data-ng-repeat="period in paymentsOverview.periodList">\n' +
    '                  <a href="" class="f-13" data-ng-click="paymentsOverview.paymentsPeriodFilter(period)">\n' +
    '                    {{period.item.description| translate}}\n' +
    '                  </a>\n' +
    '                </li>\n' +
    '              </ul>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '        <div class="timeline-row payments col-sm-12 no-padding">\n' +
    '          <div class="hypo-timeline-wrapper app-white-card p-0 p-b-10 p-t-10">\n' +
    '            <div class="t-a-c p-10 no-data-image" ng-if="paymentsOverview.paymentsOverviewList.result.length === 0">\n' +
    '              <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '              <h3 class="no-data-label" translate="paymentsOverview.noPaymentData"></h3>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\' && paymentsOverview.paymentsTypeSelected === 3" class="row p-b-15"\n' +
    '                 ng-show="paymentsOverview.paymentsOverviewListGrouped.result.length > 0">\n' +
    '              <div class="col-xs-12 t-a-c hidden-xs">\n' +
    '                <label class="balance-sum-label ng-scope">\n' +
    '                  {{\'paymentsOverview.totalPendingSum\' | translate}} <span ng-repeat="(currencyKey, sum) in paymentsOverview.paymentsOverviewListGrouped.result[1].sumAmount">{{sum | number:2}} {{currencyKey | uppercase}} | </span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <ul class="hypo-timeline payments-list" ng-if="paymentsOverview.paymentsOverviewListGrouped.result.length !== 0">\n' +
    '              <li class="" ng-repeat="payment in paymentsOverview.paymentsOverviewListGrouped.result">\n' +
    '                <span class="currency-time-frame" style="margin-left:14px;" ng-if="payment.isVirtual">{{payment.date| date:\'shortDate\'}}</span>\n' +
    '                <i ng-if="!payment.isVirtual" class="icon icon-change currency-icon-change icon-lh"></i>\n' +
    '                <div ng-if="!payment.isVirtual" class="hypo-timeline-item payment-item" ng-class="{\'opened\': payment.selected}" ng-click="paymentsOverview.togglePaymentDetails(payment)" >\n' +
    '                  <div class="hypo-timeline-body">\n' +
    '                    <div class="col-xs-8">\n' +
    '                      <h4 ng-if="payment.purpose" class="m-b-0 m-t-0 c- no-wrap-text" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                        <span class="bold-font-payment" ng-switch-default>{{::payment.purpose}}</span>\n' +
    '                        <span class="bold-font-payment" style="white-space: normal" ng-switch-when="sl">\n' +
    '                          {{::payment.purpose}}\n' +
    '                        </span>\n' +
    '                      </h4>\n' +
    '                      <h4 ng-if="!payment.purpose" class="m-b-0 m-t-0 bold-font-payment">{{\'paymentsTypeGroup.\' + payment.paymentTypeGroup| translate}}</h4>\n' +
    '\n' +
    '                      <p class="m-b-0 m-t-0 iban-style-paym wrap-text">{{::payment.toAccountNumber}} {{::payment.receiverName}}</p>\n' +
    '                      <p ng-show="paymentsOverview.showPaymentId" class="m-b-0 m-t-0 iban-style" id="paymentId">{{::payment.id}}</p>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Not signed payments -->\n' +
    '                    <div class="col-xs-4" ng-if="paymentsOverview.paymentsTypeSelected === 5">\n' +
    '                      <span class="col-xs-9 t-a-r price-payment" ng-if="payment.transactionAmount2"><b>{{::payment.transactionAmount2|number:2}} {{::payment.destinationCurrencySymbol}}</b></span>\n' +
    '                      <span class="col-xs-9 t-a-r price-payment" ng-if="!payment.transactionAmount2"><b>{{::payment.amount|number:2}} {{::payment.currencySymbol}}</b></span>\n' +
    '                      <span class="col-xs-3 f-18 pull-right">\n' +
    '                        <div class="checkbox checkbox-height" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                          <label>\n' +
    '                            <input type="checkbox" ng-model="payment.isSelectedForSign"\n' +
    '                                   ng-click="paymentsOverview.togglePaymentForSign($event);">\n' +
    '                            <i class="input-helper"></i>\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Other payment types -->\n' +
    '                    <div ng-if="paymentsOverview.paymentsTypeSelected !== 5" class="col-xs-4">\n' +
    '                      <span class="pull-right t-a-r f-18">\n' +
    '                        <b class="price-payment" style="font-weight:600; font-size:22px;" ng-if="::payment.transactionAmount2">{{::payment.transactionAmount2|number:2}} {{::payment.destinationCurrencySymbol}}</b>\n' +
    '                        <b class="price-payment" style="font-weight: 600; font-size:22px; " ng-if="::!payment.transactionAmount2">{{::payment.amount|number:2}} {{::payment.currencySymbol}}</b>\n' +
    '                        <br/>\n' +
    '                        <span ng-class="{\'text-danger\': payment.status === \'Rejected\', \'payment-gray-status\': payment.status === \'InProcessing\'}"\n' +
    '                              translate="{{\'paymentsOverview.\'+payment.status}}" ></span>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <div class="clear"></div>\n' +
    '                  </div>\n' +
    '                  <div ng-if="payment.selected" class="transaction-details">\n' +
    '                    <i ng-if="!payment.isVirtual" class="icon icon-change currency-icon-change-2"></i>\n' +
    '                    <div>\n' +
    '                      <table class="table table-transparent table-responsive">\n' +
    '                        <tbody>\n' +
    '                          <tr ng-if="paymentsOverview.paymentsTypeSelected === 5">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlStatus"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span ng-class="{\'text-danger\': payment.status === \'Rejected\', \'payment-gray-status\': payment.status === \'InProcessing\'}"\n' +
    '                                    translate="{{\'paymentsOverview.\'+payment.status}}" ></span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="payment.status === \'Rejected\'">\n' +
    '                            <td ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                              <span ng-switch-default class="po-desc-label" translate="paymentsOverview.povlNote"></span>\n' +
    '                              <span ng-switch-when="sl" class="po-desc-label" translate="paymentsOverview.povlNote_SLO"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.note}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td >\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlId"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.id}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="::payment.referenceNumber">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.referenceNumber"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.referenceNumber}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="::payment.receiverName">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlReceiver"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.receiverName}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlFrom"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.fromAccountNumber}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlTo"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{::payment.toAccountNumber}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span ng-if="paymentsOverview.countryCode !== \'sl\' || payment.paymentTypeGroup !== \'CurrencyExchange\'" class="po-desc-label" translate="paymentsOverview.povlAmount"></span>\n' +
    '                              <span ng-if="paymentsOverview.countryCode === \'sl\' && payment.paymentTypeGroup === \'CurrencyExchange\'" class="po-desc-label" translate="paymentsOverview.povlAmountSlo"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label" ng-if="::payment.transactionAmount2">{{::payment.transactionAmount2|number:2}} {{::payment.destinationCurrencySymbol}}</span>\n' +
    '                              <span class="po-value-label" ng-if="::!payment.transactionAmount2">{{::payment.amount|number:2}} {{::payment.currencySymbol}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="::payment.agreedRate && paymentsOverview.countryCode === \'sr\'">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="currencyConversion.agreedRate"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label" ng-if="::payment.calculatedAmount">{{::payment.agreedRate| number:4}} </span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="::payment.calculatedAmount && paymentsOverview.countryCode === \'sr\'">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="currencyConversion.calculatedAmount"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label" ng-if="::payment.calculatedAmount && !payment.transactionAmount2">{{::payment.calculatedAmount| number:2}} {{::payment.destinationCurrencySymbol}}</span>\n' +
    '                              <span class="po-value-label" ng-if="::payment.calculatedAmount && payment.transactionAmount2">{{::payment.calculatedAmount| number:2}} {{::payment.currencySymbol}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr  ng-if="payment.referenceTo && payment.paymentTypeGroup === \'DomesticPayment\'"\n' +
    '                               ng-hide="payment.referenceTo === \'00\' && (paymentsOverview.countryCode === \'mn\' || paymentsOverview.countryCode === \'mne\' || paymentsOverview.countryCode === \'sr\')">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.referenceTo"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span ng-if="paymentsOverview.countryCode != \'hr\'" class="po-value-label">{{ ::paymentsOverview.split(payment.referenceTo)}}</span>\n' +
    '                              <span ng-if="paymentsOverview.countryCode === \'hr\'" class="po-value-label">{{ ::payment.referenceTo}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!-- reference field related to BiH environment-->\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.reference">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.referenceNumberLabel"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.reference}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!-- end reference field related to BiH environment-->\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="signPayments.dateCreated"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.dateCreated| date:\'shortDate\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr>\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.povlDueDate"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.dueDate| date:\'shortDate\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="(payment.status === \'Rejected\' || payment.status === \'InProcessing\' || payment.status === \'Processed\') && paymentsOverview.signList.length === 1">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label">{{paymentsOverview.signList[0].action}}</span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{paymentsOverview.signList[0].signerName}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="(payment.status === \'Rejected\' || payment.status === \'InProcessing\' || payment.status === \'Processed\') && paymentsOverview.signList.length === 1">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.signDate"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{paymentsOverview.signList[0].signDate| date: \'shortDate\'}} {{paymentsOverview.signList[0].signTime| date: \'mediumTime\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="(payment.status === \'Rejected\' || payment.status === \'InProcessing\' || payment.status === \'Processed\') && paymentsOverview.signList.length > 1">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label">{{paymentsOverview.signList[0].action}}</span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{paymentsOverview.signList[0].signerName}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="(payment.status === \'Rejected\' || payment.status === \'InProcessing\' || payment.status === \'Processed\') && paymentsOverview.signList.length > 1">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.signDate"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{paymentsOverview.signList[0].signDate| date: \'shortDate\'}} {{paymentsOverview.signList[1].signTime| date: \'mediumTime\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="(payment.status === \'Rejected\' || payment.status === \'InProcessing\' || payment.status === \'Processed\') && paymentsOverview.signList.length > 1">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label">{{paymentsOverview.signList[1].action}}</span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{paymentsOverview.signList[1].signerName}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="(payment.status === \'Rejected\' || payment.status === \'InProcessing\' || payment.status === \'Processed\') && paymentsOverview.signList.length > 1">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="paymentsOverview.signDate"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{paymentsOverview.signList[1].signDate| date: \'shortDate\'}} {{paymentsOverview.signList[1].signTime| date: \'mediumTime\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <!-- PUBLIC REVENUE SECTON DETAILS -->\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.taxPayerId">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.taxPayerNumber"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.taxPayerId}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.revenuePaymentType">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.paymentType"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.revenuePaymentType}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.revenueCode">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.revenueCode"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.revenueCode}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.municipality">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.municipality"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.municipality}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.taxPeriodFrom">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.taxPeriodFrom"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.taxPeriodFrom | date: \'shortDate\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.taxPeriodTo">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.taxPeriodTo"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.taxPeriodTo | date: \'shortDate\'}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '\n' +
    '                          <tr ng-if="payment.revenuePaymentDetails.budgetOrganization">\n' +
    '                            <td>\n' +
    '                              <span class="po-desc-label" translate="domesticPayment.budgetOrganisation"></span>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                              <span class="po-value-label">{{payment.revenuePaymentDetails.budgetOrganization}}</span>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <!-- END PUBLIC REVENUE SECTON DETAILS -->\n' +
    '\n' +
    '                          <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                            <td colspan="2">\n' +
    '                              <div>\n' +
    '                                <span class="pull-right" ng-repeat="actionObject in payment.allowedActionList.itemList">\n' +
    '                                  <span ng-switch on="actionObject.methodName">\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.recall"\n' +
    '                                            ng-if="actionObject.isEnabled" ng-switch-when="RecallAllowed"\n' +
    '                                            ng-click="paymentsOverview.recallPaymentAction(payment)">\n' +
    '                                      Recall payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.sign"\n' +
    '                                            ng-if="actionObject.isEnabled" ng-switch-when="SignAllowed"\n' +
    '                                            data-ng-click="paymentsOverview.signPayment(payment)">\n' +
    '                                      Sign payment\n' +
    '                                    </button>\n' +
    '                                    <button  class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.delete"\n' +
    '                                             ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed"\n' +
    '                                             ng-click="paymentsOverview.deletePaymentAction(payment.id)">\n' +
    '                                      Delete payment\n' +
    '                                    </button>\n' +
    '                                    <button  class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.complaint"\n' +
    '                                             ng-if="actionObject.isEnabled && paymentsOverview.countryCode == \'sl\'" ng-switch-when="AppealAllowed"\n' +
    '                                             ng-click="paymentsOverview.complaintPayment(payment)">\n' +
    '                                      Complaint payment\n' +
    '                                    </button>\n' +
    '                                    <button  class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.repeat"\n' +
    '                                             ng-if="actionObject.isEnabled && paymentsOverview.countryCode == \'sl\'" ng-switch-when="InsertAllowed"\n' +
    '                                             ng-click="paymentsOverview.repeatPayment(payment)">\n' +
    '                                      Copy payment\n' +
    '                                    </button>\n' +
    '                                  </span>\n' +
    '                                </span>\n' +
    '                                <span>\n' +
    '                                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.copy"\n' +
    '                                          ng-hide="paymentsOverview.countryCode == \'sl\' || (paymentsOverview.countryCode == \'sr\' && payment.paymentTypeGroup != \'DomesticPayment\') || (payment.paymentTypeGroup == \'LocalCurrencyTransfer\' && paymentsOverview.countryCode == \'bh\')"\n' +
    '                                          ng-if="payment.status != \'Rejected\'"\n' +
    '                                          ng-click="paymentsOverview.repeatPayment(payment);"\n' +
    '                                          >Copy payment</button>\n' +
    '                                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.edit"\n' +
    '                                          ng-if="payment.status === \'Opened\' && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                                          ng-click="paymentsOverview.editPayment(payment);">\n' +
    '                                    Edit payment\n' +
    '                                  </button>\n' +
    '                                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.repeat"\n' +
    '                                          ng-hide="(payment.paymentTypeGroup == \'LocalCurrencyTransfer\' && paymentsOverview.countryCode == \'bh\')"\n' +
    '                                          ng-if="payment.status === \'Rejected\' && paymentsOverview.countryCode != \'sl\'"\n' +
    '                                          ng-click="paymentsOverview.repeatPayment(payment);">\n' +
    '                                    Repeat payment\n' +
    '                                  </button>\n' +
    '                                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.print"\n' +
    '                                          ng-hide="payment.status === \'Opened\'"\n' +
    '                                          ng-click="paymentsOverview.printPayment(payment.id);">\n' +
    '                                    Print payment\n' +
    '                                  </button>\n' +
    '                                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.confirmation"\n' +
    '                                          ng-click="paymentsOverview.confirmRealizedPayment(payment)"\n' +
    '                                          ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && payment.status != \'Cancelled\'">\n' +
    '                                    Confirmation\n' +
    '                                  </button>\n' +
    '                                </span>\n' +
    '                              </div>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                          <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                            <td colspan="2">\n' +
    '                              <div>\n' +
    '                                <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.confirmation"\n' +
    '                                        ng-if="payment.status == \'Processed\'"\n' +
    '                                        ng-click="paymentsOverview.confirmRealizedPayment(payment)">\n' +
    '                                  Confirmation\n' +
    '                                </button>\n' +
    '                                <span class="pull-right" ng-repeat="actionObject in payment.allowedActionList.itemList">\n' +
    '                                  <span ng-switch on="actionObject.methodName">\n' +
    '                                    <!-- methodName missing-->\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.printSlo"\n' +
    '                                            ng-if="actionObject.isEnabled"\n' +
    '                                            ng-switch-when="DownloadLinkAllowed"\n' +
    '                                            ng-click="paymentsOverview.printPayment(payment.id);">\n' +
    '                                      Print payment\n' +
    '                                    </button>\n' +
    '                                    <button  class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.complaint"\n' +
    '                                             ng-if="actionObject.isEnabled"\n' +
    '                                             ng-switch-when="AppealAllowed"\n' +
    '                                             ng-click="paymentsOverview.complaintPayment(payment)">\n' +
    '                                      Complaint payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.repeat"\n' +
    '                                                  ng-if="actionObject.isEnabled"\n' +
    '                                                  ng-switch-when="InsertAllowed"\n' +
    '                                                  ng-click="paymentsOverview.repeatPayment(payment);">\n' +
    '                                      Repeat payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.cancelPayment"\n' +
    '                                            ng-if="actionObject.isEnabled"\n' +
    '                                            ng-switch-when="RecallAllowed"\n' +
    '                                            ng-click="paymentsOverview.cancelPaymentAction(payment)">\n' +
    '                                      Recall payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.changePayment"\n' +
    '                                            ng-if="actionObject.isEnabled"\n' +
    '                                            ng-switch-when="UpdateAllowed"\n' +
    '                                            ng-click="paymentsOverview.changePaymentAction(payment)">\n' +
    '                                      Recall payment\n' +
    '                                    </button>\n' +
    '                                  </span>\n' +
    '                                </span>\n' +
    '\n' +
    '                                <span class="pull-right">\n' +
    '                                  <!-- SLO SPECIFIC show Execute/Izvedba button only if Cancelled and dueDate > new Date() -->\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.execute"\n' +
    '                                    ng-if="payment.status === \'Cancelled\' && paymentsOverview.checkDate(payment.dueDate)"\n' +
    '                                    ng-click="paymentsOverview.repeatPayment(payment, \'repeatCancelled\');">\n' +
    '                                    Repeat payment\n' +
    '                                    </button>\n' +
    '\n' +
    '                                  <!--Button for testing :D -->\n' +
    '                                  <!--<button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.execute"-->\n' +
    '                                  <!--ng-if="paymentsOverview.countryCode == \'sl\' && payment.status === \'Cancelled\'"-->\n' +
    '                                  <!--ng-click="paymentsOverview.repeatPayment(payment, \'repeatCancelled\');">-->\n' +
    '                                  <!--Change payment-->\n' +
    '                                  <!--</button>-->\n' +
    '                                  <!--SLO SPECIFIC END-->\n' +
    '                                </span>\n' +
    '                                <!--<button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="paymentActions.copy"-->\n' +
    '                                        <!--ng-if="payment.status != \'Rejected\'"-->\n' +
    '                                        <!--ng-click="paymentsOverview.repeatPayment(payment);">-->\n' +
    '                                  <!--Copy payment-->\n' +
    '                                <!--</button>-->\n' +
    '\n' +
    '                              </div>\n' +
    '                            </td>\n' +
    '                          </tr>\n' +
    '                        </tbody>\n' +
    '                      </table>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 t-a-c m-t-15">\n' +
    '        <button ng-if="paymentsOverview.paymentsOverviewListGrouped.hasMore == true" data-ng-click="paymentsOverview.loadMorePayments()" type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn" translate="paymentsOverview.loadMoreBtn">Load more</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-overview-filter.tpl.html',
    '<div class="tml-filter-container tmlf-wide" id="searchFilterExpandedDiv">\n' +
    '    <div id="searchBtnLeftDiv" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="inner-section left">\n' +
    '        <i ng-switch-default class="icon icon-search i-p24 m-l-5"></i>\n' +
    '        <i ng-switch-when="sl" ng-click="paymentsOverview.applyPaymentsFilter();" class="icon icon-search i-p24 m-l-5"></i>\n' +
    '    </div>\n' +
    '    <div id="searchBtnCenterDiv" class="inner-section center">\n' +
    '        <input id="searchTimelineInput" type="text" class="search-input" placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '               ng-model="paymentsOverview.paymentsFilter.purposeFTS" ng-model-options="{ debounce: 300 }"\n' +
    '               ng-keyup="$event.keyCode == 13 && paymentsOverview.applyPaymentsFilter()"\n' +
    '        >\n' +
    '    </div>\n' +
    '    <div id="searchBtnRightDiv" class="inner-section right pull-right" ng-init="paymentsOverview.showDeleteInputBtn = false">\n' +
    '        <i ng-show="paymentsOverview.paymentsFilter.purposeFTS" class="zmdi zmdi-tag-close  zmdi-hc-2x m-r-0"\n' +
    '          ng-click="paymentsOverview.paymentsFilter.purposeFTS = \'\'; paymentsOverview.showDeleteInputBtn = false"></i>\n' +
    '        <i class="icon icon-filter i-p24 i-lh12 m-r-0 pull-right"\n' +
    '           ng-click="paymentsOverview.searchFilterExpanded = !paymentsOverview.searchFilterExpanded"></i>\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="tml-filter-selection" ng-class="{\'opened\': paymentsOverview.searchFilterExpanded, \'h-510\': ((paymentsOverview.dateFromOpen || paymentsOverview.dateToOpen) && paymentsOverview.countryCode === \'sl\')}">\n' +
    '      <!-- START: Row Date from and date to -->\n' +
    '      <div class="m-t-15 clearfix" ng-if="paymentsOverview.viewName == \'payments_overview\'">\n' +
    '        <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '          <div class="form-group m-b-0">\n' +
    '            <label class="f-12-s" translate="paymentsOverview.dateFrom">Date from</label>\n' +
    '            <div class="input-group">\n' +
    '              <input type="text" class="form-control-db"\n' +
    '                     ng-value="paymentsOverview.paymentsFilter.dateCreatedGTE | date: \'shortDate\'"\n' +
    '                     readonly>\n' +
    '              <span class="input-group-btn">\n' +
    '                  <button data-ng-click="paymentsOverview.dateFromOpen = !paymentsOverview.dateFromOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-6 p-l-0 p-r-5">\n' +
    '          <div class="form-group m-b-0">\n' +
    '            <label class="f-12-s" translate="paymentsOverview.dateTo">Date to</label>\n' +
    '            <div class="input-group">\n' +
    '              <input type="text" class="form-control-db"\n' +
    '                     ng-value="paymentsOverview.paymentsFilter.dateCreatedLTE | date: \'shortDate\'"\n' +
    '                     readonly>\n' +
    '              <span class="input-group-btn">\n' +
    '                  <button data-ng-click="paymentsOverview.dateToOpen = !paymentsOverview.dateToOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-6 p-l-0 p-r-5">\n' +
    '          <!-- Date from datepicker-->\n' +
    '          <div data-ng-model="paymentsOverview.paymentsFilter.dateCreatedGTE"\n' +
    '               show-weeks="false"\n' +
    '               show-button-bar="false"\n' +
    '               is-open="paymentsOverview.dateFromOpen"\n' +
    '               ng-change="paymentsOverview.onDateFromChange()"\n' +
    '               uib-datepicker-popup="shortDate"\n' +
    '                required="">\n' +
    '          </div>\n' +
    '          <!-- Date to datepicker-->\n' +
    '          <div data-ng-model="paymentsOverview.paymentsFilter.dateCreatedLTE"\n' +
    '               show-weeks="false"\n' +
    '               show-button-bar="false"\n' +
    '               is-open="paymentsOverview.dateToOpen"\n' +
    '               ng-change="paymentsOverview.onDateToChange()"\n' +
    '               date-disabled="paymentsOverview.datesToDisabled(date, mode)"\n' +
    '               uib-datepicker-popup="shortDate">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <span class="p-l-5 p-t-5 c-red" ng-if="!paymentsOverview.transactionFilterYearDateRangeValid">\n' +
    '        <span translate="core.filter.maxDateRange"></span>\n' +
    '      </span>\n' +
    '        <!-- END: Row Date from and date to -->\n' +
    '\n' +
    '        <div class="m-t-15" style="overflow:auto">\n' +
    '            <div class="col-xs-5 p-l-5 p-r-5">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="f-12-s" translate="timelineFilter.amountFrom"></label>\n' +
    '                    <input ng-keyup="$event.keyCode == 13 && paymentsOverview.applyPaymentsFilter()" type="text" class="form-control-db" ng-model="paymentsOverview.paymentsFilter.amountGTE" amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" autocomplete="off">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-5 p-l-5 p-r-5">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="f-12-s" translate="timelineFilter.amountTo"></label>\n' +
    '                    <input ng-keyup="$event.keyCode == 13 && paymentsOverview.applyPaymentsFilter()" type="text" class="form-control-db" ng-model="paymentsOverview.paymentsFilter.amountLTE" amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" autocomplete="off">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-2 p-0 p-r-5 p-t-25">\n' +
    '                <select name="" id="" class="form-control-db" ng-options="option.symbol for option in paymentsOverview.currenciesList" ng-model="paymentsOverview.currencySelectObject">\n' +
    '                </select>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="m-b-15" style="overflow:auto">\n' +
    '            <div class="col-xs-6 t-a-l p-l-5">\n' +
    '                <button class="btn btn-primary app-btn-gray" ng-click="paymentsOverview.resetPaymentsFilter();" translate="timelineFilter.reset"></button>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 t-a-r p-r-5">\n' +
    '                <button class="btn btn-default app-btn-blue w-100" ng-disabled="!paymentsOverview.transactionFilterYearDateRangeValid"\n' +
    '                        ng-click="paymentsOverview.applyPaymentsFilter();" translate="timelineFilter.apply"></button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-group-sign.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div>\n' +
    '      <div class="exchange-rate-header">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12 col-xs-6 f-20" translate="paymentsAndTransferOverview.groupedPaymentsLabel"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Large screens start -->\n' +
    '      <!-- Header for payments sign -->\n' +
    '      <div class="row group-sign-header p-t-20 p-b-10 m-t-15 hidden-xs">\n' +
    '        <div class="col-sm-5">\n' +
    '            <span class="col-sm-6" translate="payments.fromAccount">\n' +
    '              From account\n' +
    '            </span>\n' +
    '            <span class="col-sm-6" translate="payments.toAccount">\n' +
    '              To account\n' +
    '            </span>\n' +
    '        </div>\n' +
    '          <span class="col-sm-2" translate="loanPayment.purpose">\n' +
    '            Purpose\n' +
    '          </span>\n' +
    '          <span class="col-sm-2 t-a-r" translate="domesticPayment.amountInputLabel">\n' +
    '            Amount\n' +
    '          </span>\n' +
    '        <div class="col-sm-3">\n' +
    '            <span class="col-sm-6" translate="signPayments.dateCreated">\n' +
    '            Date created\n' +
    '            </span>\n' +
    '            <span class="col-sm-6" translate="signPayments.dueDate">\n' +
    '              Due date\n' +
    '            </span>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Details for group of payments -->\n' +
    '      <div class="row group-sign-content hidden-xs word-break"\n' +
    '           data-ng-repeat="payment in paymentsSign.paymentsGroupList.paymentList">\n' +
    '        <div class="col-sm-5">\n' +
    '            <span class="col-sm-6">\n' +
    '            {{payment.fromAccountNumber}}\n' +
    '            </span>\n' +
    '            <span class="col-sm-6">\n' +
    '              {{payment.toAccountNumber}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '          <span class="col-sm-2" title="{{payment.purpose}}">\n' +
    '            {{ payment.purpose | limitTo: 40 }}{{payment.purpose.length > 40 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <span class="col-sm-2 t-a-r">\n' +
    '            {{payment.amount|number:2}} {{::payment.currencySymbol}}\n' +
    '          </span>\n' +
    '        <div class="col-sm-3">\n' +
    '            <span class="col-sm-6">\n' +
    '            {{payment.dateCreated| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '            <span class="col-sm-6">\n' +
    '              {{payment.dueDate| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Large screens end -->\n' +
    '\n' +
    '      <!-- Small screens start -->\n' +
    '\n' +
    '      <div class="row visible-xs sign-payment-mobile m-t-5 m-b-5 group-sign-container"\n' +
    '           data-ng-repeat="payment in paymentsSign.paymentsGroupList.paymentList">\n' +
    '\n' +
    '        <div class="col-xs-12">\n' +
    '            <span class="col-xs-6 f-w-bold" translate="payments.fromAccount">\n' +
    '              From account\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '            {{payment.fromAccountNumber}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 ">\n' +
    '            <span class="col-xs-6 f-w-bold" translate="payments.toAccount">\n' +
    '              To account\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '              {{payment.toAccountNumber}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 ">\n' +
    '          <span class="col-xs-6 f-w-bold" translate="loanPayment.purpose">\n' +
    '            Purpose\n' +
    '          </span>\n' +
    '          <span class="col-xs-6" title="{{payment.purpose}}">\n' +
    '            {{ payment.purpose | limitTo: 40 }}{{payment.purpose.length > 40 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '          <span class="col-xs-6 f-w-bold" translate="domesticPayment.amountInputLabel">\n' +
    '            Amount\n' +
    '          </span>\n' +
    '          <span class="col-xs-6">\n' +
    '            {{payment.amount|number:2}} {{::payment.currencySymbol}}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '            <span class="col-xs-6 f-w-bold" translate="signPayments.dateCreated">\n' +
    '            Date created\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '              {{payment.dateCreated| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '            <span class="col-xs-6 f-w-bold" translate="signPayments.dueDate">\n' +
    '              Due date\n' +
    '            </span>\n' +
    '            <span class="col-xs-6">\n' +
    '              {{payment.dueDate| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Small screens end -->\n' +
    '\n' +
    '      <!-- Actions for payments group -->\n' +
    '      <div class="row m-b-10">\n' +
    '          <span class="col-xs-12 m-t-20" ng-show="!paymentsSign.areAllPaymentsDueDateValid"\n' +
    '                translate="signPayments.paymentsInvalidDueDate">\n' +
    '          </span>\n' +
    '          <span class="col-xs-12 payments-filter-active"\n' +
    '                ng-show="paymentsSign.dueDateUpdateAllowed && !paymentsSign.areAllPaymentsDueDateValid"\n' +
    '                data-ng-click="paymentsSign.updateGroupPaymentDates()" translate="signPayments.updatePaymentsDueDate">\n' +
    '          </span>\n' +
    '\n' +
    '        <!-- SMS Validation -->\n' +
    '        <div class="col-xs-12 m-t-30" ng-if="paymentsSign.paymentsGroupList.linkList.itemList.requestOTP">\n' +
    '          <div class="col-xs-12 m-b-20">\n' +
    '              <span ng-if="paymentsSign.countryCode != \'bh\' && paymentsSign.countryCode != \'sl\'" class="f-w-bold">\n' +
    '                {{\'signPayments.SmsDescription\' | translate}}\n' +
    '              </span>\n' +
    '            <span ng-if="paymentsSign.countryCode === \'bh\'" class="f-w-bold">\n' +
    '                {{\'signPayments.SmsDescriptionBh\' | translate}}\n' +
    '              </span>\n' +
    '            <span ng-if="paymentsSign.countryCode === \'sl\'" class="f-w-bold">\n' +
    '                {{\'signPayments.SmsDescriptionSLO\' | translate}}\n' +
    '            </span>\n' +
    '          </div>\n' +
    '            <div class="row p-10">\n' +
    '                <div ng-if="paymentsSign.countryCode === \'mne\'" class="col-xs-12 m-5">\n' +
    '                    <p> <span translate="signPayments.infoDomMne0"></span>\n' +
    '                            <span><a href="{{\'signPayments.infoDomMneLink\' | translate}}"\n' +
    '                                     translate="signPayments.infoDomMne1"></a></span></p>\n' +
    '                </div>\n' +
    '                <div ng-if="paymentsSign.countryCode === \'sr\'" class="col-xs-12 m-5">\n' +
    '                    <p> <span translate="signPayments.infoDomSrb0"></span>\n' +
    '                            <span><a href="{{\'signPayments.infoDomSrbLink\' | translate}}" translate="signPayments.infoDomSrb1"></a></span></p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '          <div class="col-xs-8 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '              <span class="f-w-bold">{{\'signPayments.SmsCode\' | translate}}</span>\n' +
    '              <div class="input-group">\n' +
    '                <input id="smsInput" type="text" class="form-control input-field text-uppercase"\n' +
    '                       data-ng-model="paymentsSign.smsPasswordInput"\n' +
    '                       placeholder="{{\'currencyConversion.smsPassword\' | translate}}"\n' +
    '                       auto-focus>\n' +
    '                <span class="input-group-btn">\n' +
    '                  <!--<button class="btn btn-default input-group-app-btn domp-btn-height"-->\n' +
    '                          <!--data-ng-click="paymentsSign.toggleInputVisibility()">-->\n' +
    '                    <!--<i data-ng-show="paymentsSign.showInput" class="zmdi zmdi-lock"></i>-->\n' +
    '                    <!--<i data-ng-show="!paymentsSign.showInput" class="zmdi zmdi-lock-open"></i>-->\n' +
    '                  <!--</button>-->\n' +
    '                </span>\n' +
    '                <span class="input-group-btn" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                  <button class="btn btn-default input-group-app-btn domp-btn-height"\n' +
    '                          data-ng-click="paymentsSign.sendSMS()"\n' +
    '                          ng-disabled="paymentsSign.signButtonDisabled"\n' +
    '                          uib-tooltip="{{\'signPayments.resendSms\' | translate}}">\n' +
    '                    <i class="zmdi zmdi-refresh-sync"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-2 col-xs-6 m-t-20">\n' +
    '            <button class="btn btn-primary" data-ng-click="paymentsSign.cancelGroupPayments()"\n' +
    '                    translate="signPayments.cancel"></button>\n' +
    '          </div>\n' +
    '          <div class="col-sm-2 col-xs-6 m-t-20 pull-right">\n' +
    '            <button class="btn btn-default"\n' +
    '                    data-ng-click="paymentsSign.signGroupPayments()"\n' +
    '                    ng-disabled="paymentsSign.formSubmitted || !paymentsSign.areAllPaymentsDueDateValid || paymentsSign.smsPasswordInput === \'\'"\n' +
    '                    translate="paymentsAndTransferOverview.confirm"></button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Challenge response validation -->\n' +
    '        <div class="col-xs-12 m-t-30" ng-if="!paymentsSign.paymentsGroupList.linkList.itemList.requestOTP && !paymentsSign.paymentsGroupList.linkList.itemList.requestMiniToken" >\n' +
    '          <div class="col-xs-12 m-b-20">\n' +
    '            <span class="f-w-bold">\n' +
    '              {{\'signPayments.challengeDescription\' | translate}}\n' +
    '            </span>\n' +
    '          </div>\n' +
    '          <div class="col-sm-4 col-xs-6">\n' +
    '            <span class="f-w-bold">{{\'signPayments.challengeFirstCode\' | translate}}</span>\n' +
    '            <input type="text" class="form-control input-field" disabled\n' +
    '                   data-ng-model="paymentsSign.paymentsGroupList.challenge">\n' +
    '          </div>\n' +
    '          <div class="col-sm-4 col-xs-6">\n' +
    '            <div class="form-group">\n' +
    '              <span class="f-w-bold">{{\'signPayments.challengeSecondCode\' | translate}}</span>\n' +
    '              <div class="input-group">\n' +
    '                <input type="text" class="form-control input-field"\n' +
    '                       data-ng-model="paymentsSign.challengeResponse"\n' +
    '                       placeholder="{{\'signPayments.challengeSecondCode\' | translate}}"\n' +
    '                       auto-focus>\n' +
    '            <span class="input-group-btn">\n' +
    '              <!--<button class="btn btn-default input-group-app-btn domp-btn-height"-->\n' +
    '                      <!--data-ng-click="paymentsSign.toggleInputVisibility()">-->\n' +
    '                    <!--&lt;!&ndash;<i data-ng-show="paymentsSign.showInput" class="zmdi zmdi-lock"></i>&ndash;&gt;-->\n' +
    '                    <!--<i data-ng-show="!paymentsSign.showInput" class="zmdi zmdi-lock-open"></i>-->\n' +
    '              <!--</button>-->\n' +
    '            </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-sm-2 col-xs-6 m-t-20">\n' +
    '            <button class="btn btn-primary col-xs-12 " data-ng-click="paymentsSign.cancelGroupPayments()"\n' +
    '                    translate="signPayments.cancel"></button>\n' +
    '          </div>\n' +
    '          <div class="col-sm-2 col-xs-6 m-t-20">\n' +
    '            <button class="btn btn-default col-xs-12 " data-ng-click="paymentsSign.signGroupPayments()"\n' +
    '                    ng-disabled="paymentsSign.formSubmitted || !paymentsSign.areAllPaymentsDueDateValid || paymentsSign.challengeResponse === \'\'"\n' +
    '                    translate="paymentsAndTransferOverview.confirm"></button>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- MiniToken validation (FOR NOW ONLY BIH ENVIRONMENT) -->\n' +
    '        <div class="col-xs-12 m-t-30" ng-if="paymentsSign.paymentsGroupList.linkList.itemList.requestMiniToken" >\n' +
    '          <form id="miniTokenForm" autocomplete="off" novalidate>\n' +
    '            <div class="col-xs-12 m-b-20">\n' +
    '              <span class="f-w-bold">{{\'signPayments.OtpDescriptionBh\' | translate}}</span>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 col-md-6">\n' +
    '              <div class="form-group">\n' +
    '                <div class="wrap-text f-w-bold" style="font-weight:500;">{{\'signPayments.otpLabel\' |\n' +
    '                  translate}}\n' +
    '                </div>\n' +
    '                <input id="spahaMT" name="spahaMT" type="text" class="form-control input-field"\n' +
    '                       data-ng-model="paymentsSign.challengeResponse"\n' +
    '                       ng-pattern-restrict="{{paymentsSign.regexPatterns.onlyNumbers}}"\n' +
    '                       placeholder="{{\'signPayments.challengeSecondCodeBh\' | translate}}" autocomplete="off" auto-focus>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-2 col-xs-6 m-t-20">\n' +
    '              <button class="btn btn-primary col-xs-12 " data-ng-click="paymentsSign.cancelGroupPayments()"\n' +
    '                      translate="signPayments.cancel"></button>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-12 m-t-20 pull-right">\n' +
    '              <button class="btn btn-default col-xs-12 " data-ng-click="paymentsSign.signGroupPayments()"\n' +
    '                      ng-disabled="paymentsSign.formSubmitted || !paymentsSign.areAllPaymentsDueDateValid"\n' +
    '                      translate="paymentsAndTransferOverview.confirm"></button>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-final-step.tpl.html',
    '<section id="main">\n' +
    '    <div class="container">\n' +
    '\n' +
    '        <div class="currency-conversion-msg">\n' +
    '            <div class="payment-successful-wrapper">\n' +
    '                <div class="row">\n' +
    '                    <div class="col-xs-2 m-t-30 m-b-30 msg-pad">\n' +
    '                        <div class="currency-check-icon msg-pad">\n' +
    '                            <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                  <!-- Old design. Commented on 14.06 -->\n' +
    '<!--                    <div class="col-xs-10 m-t-30 m-b-30">\n' +
    '                        <h2 class="c-white f-28" ng-if="paymentsFinal.selectedPayment.paymentTypeGroup !== \'CurrencyExchange\'" translate="internalTransfer.transferComplete"></h2>\n' +
    '                        <h2 class="c-white f-28" ng-if="paymentsFinal.selectedPayment.paymentTypeGroup === \'CurrencyExchange\'" translate="currencyConversion.moneyExchangeComplete"></h2>\n' +
    '                        <div class="f-15">\n' +
    '                            <span ng-if="paymentsFinal.selectedPayment.paymentTypeGroup !== \'CurrencyExchange\'" translate="internalTransfer.successfullyTransfer"></span>\n' +
    '                            <span ng-if="paymentsFinal.selectedPayment.paymentTypeGroup === \'CurrencyExchange\'" translate="currencyConversion.successfullyExchange"></span>\n' +
    '                            <span>\n' +
    '                              {{paymentsFinal.selectedPayment.amount}}\n' +
    '                              {{paymentsFinal.selectedPayment.currencySymbol}}\n' +
    '                            </span>\n' +
    '                            <span translate="payments.fromAcc">from</span>\n' +
    '                            <span>{{paymentsFinal.selectedPayment.fromAccountNumber}}</span>\n' +
    '                            <span translate="payments.toAcc">to</span>\n' +
    '                            <span>{{paymentsFinal.selectedPayment.toAccountNumber}}</span>\n' +
    '                        </div>\n' +
    '                    </div>-->\n' +
    '                  <div class="col-xs-10 m-t-30 m-b-30 int-payment">\n' +
    '\n' +
    '\n' +
    '\n' +
    '                    <!-- For all countries except SLO -->\n' +
    '                    <div ng-if="paymentsFinal.countryCode != \'sl\'" class="f-15">\n' +
    '\n' +
    '                      <h2 class="c-white f-28" translate="signPayments.finalStepSuccessfullySigned"></h2>\n' +
    '\n' +
    '                      <div ng-if="paymentsFinal.defaultData.bankCharges || paymentsFinal.defaultData.BankChargesLink">\n' +
    '                        <span translate="signPayments.finalStepPaymentServices"></span>\n' +
    '                        <a ng-if="paymentsFinal.defaultData.bankCharges" ng-href="{{paymentsFinal.bankCharges}}" class="bank-tariff-link" target="_blank" translate="signPayments.finalStepBankTariff" class="pull-right"></a>\n' +
    '                        <a ng-if="paymentsFinal.defaultData.BankChargesLink" ng-href="{{paymentsFinal.defaultData.BankChargesLink}}" class="bank-tariff-link" target="_blank" translate="signPayments.finalStepBankTariff" class="pull-right"></a>\n' +
    '                      </div>\n' +
    '                      <div class="m-t-15" >\n' +
    '                        <span translate="signPayments.finalStepStatus"></span>\n' +
    '                        <span ng-if="paymentsFinal.paymentType !== \'group\'">\n' +
    '                        <!--{{paymentsFinal.selectedPayment.status | translate}}-->\n' +
    '                        {{\'paymentsFinal.\'+paymentsFinal.selectedPayment.status | translate}}\n' +
    '                        </span>\n' +
    '                        <span ng-if="paymentsFinal.paymentType === \'group\'">\n' +
    '                        {{\'paymentsFinal.\'+paymentsFinal.paymentsGroupList.statusId  | translate}}\n' +
    '                        </span>\n' +
    '                      </div>\n' +
    '                      <div>\n' +
    '                        <span translate="signPayments.finalStepPaymentID"></span>\n' +
    '                        <span ng-if="paymentsFinal.paymentType !== \'group\'">\n' +
    '                        {{paymentsFinal.selectedPayment.id}}\n' +
    '                        </span>\n' +
    '                        <span ng-if="paymentsFinal.paymentType === \'group\'">\n' +
    '                        {{paymentsFinal.paymentsGroupList.id}}\n' +
    '                        </span>\n' +
    '                      </div>\n' +
    '                      <div ng-if="paymentsFinal.paymentType === \'group\'">\n' +
    '                        <span translate="signPayments.finalStepNumberOfPayments"></span>\n' +
    '                        <span>\n' +
    '                        {{paymentsFinal.paymentsGroupList.paymentList.length}}\n' +
    '                        </span>\n' +
    '                      </div>\n' +
    '                      <div class="m-t-15" >\n' +
    '                        <span translate="signPayments.finalStepSentForProcessing"></span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- For SLO -->\n' +
    '                    <div ng-if="paymentsFinal.countryCode === \'sl\'">\n' +
    '\n' +
    '                        <h2 class="c-white f-28" translate="signPayments.finalStepPaymentSloHeader"></h2>\n' +
    '\n' +
    '                        <p class="f-16">\n' +
    '                            <span translate="signPayments.finalStepPaymentID"></span>\n' +
    '                            <span id="selectedPaymentId">{{paymentsFinal.selectedPayment.id}}</span>\n' +
    '                        </p>\n' +
    '\n' +
    '                        <p class="f-16">\n' +
    '                            <span translate="signPayments.finalStepPaymentSloSubHeader"></span><a href="#!/payments/payments-overview" translate="navigation.paymentsList"></a>.<br>\n' +
    '                            <span translate="signPayments.finalStepPaymentSloText"></span>\n' +
    '                        </p>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row m-t-20" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                <!-- Save template only for Domestic or foreign payments-->\n' +
    '                <div ng-switch-default class="col-xs-12 col-sm-4" ng-show="paymentsFinal.canBeSavedToTemplate">\n' +
    '                    <a href="" data-ui-sref="paymentTemplates.saveTemplate({paymentId: paymentsFinal.selectedPayment.id, type: paymentsFinal.paymentType, paymentObject: paymentsFinal.selectedPayment })" >\n' +
    '                        <span class="money-exchange-icon"><i class="icon icon-archive zmdi-hc-2x" style="color:#062a42;"></i></span>\n' +
    '                        <span class="f-18 money-exchange-text" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '              <div ng-switch-when="sl" ng-if="!paymentsFinal.isFromTemplate" class="col-xs-12 col-sm-4" ng-show="paymentsFinal.canBeSavedToTemplate">\n' +
    '                    <a href="" data-ui-sref="paymentTemplates.saveTemplate({paymentId: paymentsFinal.selectedPayment.id, type: paymentsFinal.paymentType, paymentObject: paymentsFinal.selectedPayment })" >\n' +
    '                        <span class="money-exchange-icon"><i class="icon icon-archive zmdi-hc-2x" style="color:#062a42;"></i></span>\n' +
    '                        <span class="f-18 money-exchange-text" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-xs-12" ng-if="paymentsFinal.paymentType !== \'group\'" ng-class="{\'col-sm-6\': !paymentsFinal.canBeSavedToTemplate, \'col-sm-4\': paymentsFinal.canBeSavedToTemplate}">\n' +
    '                    <a href="" data-ng-click="paymentsFinal.makeAnotherPayment();" >\n' +
    '                        <span class="money-exchange-icon"><i class="icon icon-reclam zmdi-hc-2x" style="color:#062a42;"></i></span>\n' +
    '                        <span class="f-18 money-exchange-text" translate="internalTransfer.makeAnotherPayment" ></span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-xs-12 col-sm-4" ng-class="{\'col-sm-6\': !paymentsFinal.canBeSavedToTemplate, \'col-sm-4\': paymentsFinal.canBeSavedToTemplate}">\n' +
    '                    <a href="" data-ng-click="paymentsFinal.goToListOfPayments()">\n' +
    '                        <span class="money-exchange-icon"><i class="icon icon-clean zmdi-hc-2x" style="color:#062a42;"></i></span>\n' +
    '                        <span class="f-18 money-exchange-text" translate="currencyConversion.goToPayments"></span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payments-and-transfer-overview.tpl.html',
    '<section id="main">\n' +
    '    <div class="container">\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-12 no-padding-on-phone p-r-0">\n' +
    '\n' +
    '                <!--REJECTED PAYMENTS-->\n' +
    '\n' +
    '                <div class="pato-wrapper">\n' +
    '                    <div class="pato-dropdown" ng-click="patoCtrl.isRejectedPaymentsPanelOpen = !patoCtrl.isRejectedPaymentsPanelOpen">\n' +
    '                        <div class="row">\n' +
    '                            <div class="h-100 col-xs-8 p-l-25 pato-dropdown-label-div">\n' +
    '                                <div class="pato-dropdown-label pato-line-height no-wrap-text" translate="paymentsAndTransferOverview.rejectedLabel"></div>\n' +
    '                            </div>\n' +
    '                            <div class="h-100 col-xs-3 p-l-0 p-r-0 pato-dropdown-counter-div">\n' +
    '                                <div class="pato-dropdown-counter">{{patoCtrl.rejectedPaymentsList.result.length}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="h-100 col-xs-1 p-r-25 p-l-0 pato-dropdown-icon-div"><i class="pato-line-height zmdi zmdi-chevron-down pull-right zmdi-hc-2x"></i></div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div ng-show="patoCtrl.isRejectedPaymentsPanelOpen" class="animated fadeIn pato-dropdown-content">\n' +
    '                        <div class="pato-payment-item-container" ng-repeat="payment in patoCtrl.rejectedPaymentsList.result">\n' +
    '                            <div class="col-xs-2 p-l-5 p-r-5 pato-pic-date-div">\n' +
    '                                <div class="month">{{::payment.dueDate | date:\'d\'}}</div>\n' +
    '                                <div class="year">{{::payment.dueDate | date:\'MMMM\'}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-4 p-l-5 p-r-5 pato-pic-label-div">\n' +
    '                                <div class="purpose no-wrap-text">{{::payment.purpose}}</div>\n' +
    '                                <div class="account">{{::payment.fromAccountNumber}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-4 p-l-5 p-r-5 pato-pic-amount-div">\n' +
    '                                <div class="amount">{{::payment.amount | number:2}} {{::payment.currencySymbol}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-2 p-l-5 p-r-5 pato-pic-action-div">\n' +
    '                                <button class="btn app-btn-blue f-uppercase" translate="paymentsAndTransferOverview.repeatAction"\n' +
    '                                data-ng-click="patoCtrl.navigateToPaymentForm({paymentTypeGroup: payment.paymentTypeGroup, id: payment.id});"></button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <br>\n' +
    '                <br>\n' +
    '\n' +
    '                <!--EINVOICES PAYMENTS-->\n' +
    '\n' +
    '                <div class="pato-wrapper" ng-if="patoCtrl.countryCode !== \'sr\'">\n' +
    '                    <div class="pato-dropdown" ng-click="patoCtrl.isEInvoicesPanelOpen = !patoCtrl.isEInvoicesPanelOpen">\n' +
    '                        <div class="row">\n' +
    '                            <div class="h-100 col-xs-8 p-l-25 pato-dropdown-label-div">\n' +
    '                                <div class="pato-dropdown-label pato-line-height no-wrap-text" translate="paymentsAndTransferOverview.eInvoicesLabel"></div>\n' +
    '                            </div>\n' +
    '                            <div class="h-100 col-xs-3 p-l-0 p-r-0 pato-dropdown-counter-div">\n' +
    '                                <div class="pato-dropdown-counter">{{patoCtrl.eInvoiceDocumentsList.result.length}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="h-100 col-xs-1 p-r-25 p-l-0 pato-dropdown-icon-div"><i class="pato-line-height zmdi zmdi-chevron-down pull-right zmdi-hc-2x"></i></div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div ng-show="patoCtrl.isEInvoicesPanelOpen" class="animated fadeIn pato-dropdown-content">\n' +
    '                        <div class="pato-payment-item-container" ng-repeat="einvoice in patoCtrl.eInvoiceDocumentsList.result">\n' +
    '                            <div class="col-xs-2 p-l-5 p-r-5 pato-pic-date-div">\n' +
    '                                <div class="month">{{::einvoice.valueDate | date:\'d\'}}</div>\n' +
    '                                <div class="year">{{::einvoice.valueDate | date:\'MMMM\'}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-4 p-l-5 p-r-5 pato-pic-label-div">\n' +
    '                                <div class="purpose no-wrap-text">{{::einvoice.purpose}}</div>\n' +
    '                                <div class="account">{{::einvoice.paymentReferenceNumber}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-4 p-l-5 p-r-5 pato-pic-amount-div">\n' +
    '                                <div class="amount">{{::einvoice.amount | number:2}} {{::einvoice.currencySymbol}}</div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-2 p-l-5 p-r-5 pato-pic-action-div">\n' +
    '                                <button class="btn app-btn-blue f-uppercase" translate="paymentsAndTransferOverview.payAction"\n' +
    '                                data-ng-click="patoCtrl.navigatoEInvoicePayment(einvoice.id);"></button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <br>\n' +
    '                <br>\n' +
    '\n' +
    '                <!--GROUPED PAYMENTS-->\n' +
    '\n' +
    '              <!-- New grouped payments -->\n' +
    '              <div class="pato-wrapper">\n' +
    '                <div class="pato-dropdown" ng-click="patoCtrl.isGroupedPaymentsPanelOpen = !patoCtrl.isGroupedPaymentsPanelOpen">\n' +
    '                  <div class="row">\n' +
    '                    <div class="h-100 col-xs-8 p-l-25 pato-dropdown-label-div">\n' +
    '                      <div class="pato-dropdown-label pato-line-height no-wrap-text" translate="paymentsAndTransferOverview.groupedPaymentsLabel"></div>\n' +
    '                    </div>\n' +
    '                    <div class="h-100 col-xs-3 p-l-0 p-r-0 pato-dropdown-counter-div">\n' +
    '                      <div class="pato-dropdown-counter">{{patoCtrl.groupedPayments.payments.length}}</div>\n' +
    '                    </div>\n' +
    '                      <div class="h-100 col-xs-1 p-r-25 p-l-0 pato-dropdown-icon-div"><i class="pato-line-height zmdi zmdi-chevron-down pull-right zmdi-hc-2x"></i></div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div ng-show="patoCtrl.isGroupedPaymentsPanelOpen" class="animated fadeIn pato-dropdown-content">\n' +
    '                  <div data-ng-repeat="payment in patoCtrl.groupedPayments.payments" class="clearfix pato-group-item-container">\n' +
    '                    <div class="col-xs-2 p-l-5 p-r-5 pato-pic-date-div">\n' +
    '                      <div class="month">{{::patoCtrl.getToday() | date:\'d\'}}</div>\n' +
    '                      <div class="year">{{::patoCtrl.getToday() | date:\'MMMM\'}}</div>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-5 p-l-5 p-r-5">\n' +
    '                      <div class="purpose no-wrap-text">{{::payment.paymentList.length}} {{\'paymentsAndTransferOverview.paymentsToSign\'| translate}}</div>\n' +
    '                      <div class="purpose no-wrap-text">{{::payment.description}}</div>\n' +
    '                      <div class="group-list">\n' +
    '                        <ul>\n' +
    '                          <li ng-repeat="singlePayment in payment.paymentList">{{::singlePayment.purpose}}</li>\n' +
    '                        </ul>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-3 p-l-5 p-r-5 pato-pic-amount-div">\n' +
    '                      <div ng-if="payment.paymentList.length > 0" class="amount">{{::payment.totalPaymentsAmount | number:2}} {{::payment.paymentList[0].currencySymbol}}</div>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-2 p-l-5 p-r-5 pato-pic-action-div">\n' +
    '                      <button class="btn app-btn-blue f-uppercase" translate="paymentsAndTransferOverview.signAllAction"></button>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payment-update-date-modal.tpl.html',
    '<div class="modal-background">\n' +
    '  <div class="modal-header p-10 t-a-c">\n' +
    '    <h3 class="white-text-block" translate="signPayments.updatePaymentDueDate"></h3>\n' +
    '  </div>\n' +
    '  <div class="modal-body m-t-10 m-b-30 f-18">\n' +
    '    <span class="col-xs-12 m-t-20 white-text-block"\n' +
    '          translate="signPayments.singlePaymentInvalidDueDate"></span>\n' +
    '  </div>\n' +
    '  <div class="modal-footer m-t-30">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <button class="btn btn-primary" ng-click="$close()"><span\n' +
    '          translate="signPayments.cancel"></span></button>\n' +
    '        <button class="btn btn-default" ng-click="$close(\'confirm\')"><span\n' +
    '          translate="signPayments.confirm"></span></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payment-update-currency-date-modal.tpl.html',
    '<div class="modal-background">\n' +
    '  <div class="modal-header p-10 t-a-c">\n' +
    '    <h3 class="white-text-block" translate="signPayments.paymentExecutionDateTitle"></h3>\n' +
    '  </div>\n' +
    '  <div class="modal-body m-t-10 m-b-30 f-18">\n' +
    '    <span ng-if="errorMessage" class="col-xs-12 m-t-20 white-text-block"\n' +
    '          ng-bind="errorMessage"></span>\n' +
    '    <span ng-if="!errorMessage" class="col-xs-12 m-t-20 white-text-block"\n' +
    '          translate="signPayments.paymentExecutionDateBody"></span>\n' +
    '  </div>\n' +
    '  <div class="modal-footer m-t-30">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <button class="btn btn-primary" ng-click="$close()"><span\n' +
    '          translate="signPayments.cancel"></span></button>\n' +
    '        <button class="btn btn-default" ng-click="$close(\'confirm\')"><span\n' +
    '          translate="signPayments.confirm"></span></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payment-sign.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div>\n' +
    '      <div class="exchange-rate-header">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6 col-xs-12 f-28" translate="paymentSignModal.title"></div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Larger screens start -->\n' +
    '\n' +
    '      <!-- Header for payments sign -->\n' +
    '      <div class="row group-sign-header p-t-20  m-t-15 hidden-xs">\n' +
    '        <div class="col-sm-5">\n' +
    '                    <span class="col-sm-6 group-sign-header" translate="payments.fromAccount">\n' +
    '              From account\n' +
    '            </span>\n' +
    '          <span class="col-sm-6" translate="payments.toAccount">\n' +
    '              To account\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <span class="col-sm-2" translate="loanPayment.purpose">\n' +
    '            Purpose\n' +
    '          </span>\n' +
    '        <span class="col-sm-2 " translate="domesticPayment.amountInputLabel">\n' +
    '            Amount\n' +
    '          </span>\n' +
    '        <div class="col-sm-3">\n' +
    '                    <span ng-if="paymentsSign.selectedPaymentForSign.dateCreated" class="col-sm-6"\n' +
    '                          translate="signPayments.dateCreated">\n' +
    '            Date created\n' +
    '            </span>\n' +
    '          <span class="col-sm-6" translate="signPayments.dueDate">\n' +
    '              Due date\n' +
    '            </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Details for single payment -->\n' +
    '      <div class="row group-sign-content hidden-xs p-b-15 word-break">\n' +
    '        <div class="col-sm-5">\n' +
    '                    <span class="col-sm-6">\n' +
    '            {{paymentsSign.selectedPaymentForSign.fromAccountNumber}}\n' +
    '            </span>\n' +
    '          <span class="col-sm-6">\n' +
    '              {{paymentsSign.selectedPaymentForSign.toAccountNumber}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <span class="col-sm-2" title="{{payment.purpose}}">\n' +
    '            {{ paymentsSign.selectedPaymentForSign.purpose | limitTo: 40 }}{{paymentsSign.selectedPaymentForSign.purpose.length > 40 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '        <span class="col-sm-2">\n' +
    '            {{paymentsSign.selectedPaymentForSign.amount|number:2}} {{::paymentsSign.selectedPaymentForSign.currencySymbol}}\n' +
    '          </span>\n' +
    '        <div class="col-sm-3">\n' +
    '                    <span ng-if="paymentsSign.selectedPaymentForSign.dateCreated" class="col-sm-6">\n' +
    '            {{paymentsSign.selectedPaymentForSign.dateCreated| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '          <span class="col-sm-6">\n' +
    '              {{paymentsSign.selectedPaymentForSign.dueDate| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Larger screens end -->\n' +
    '\n' +
    '      <!-- Small screens start -->\n' +
    '      <div class="row visible-xs sign-payment-mobile">\n' +
    '\n' +
    '        <div class="col-xs-12">\n' +
    '                    <span class="col-xs-6 f-w-bold" translate="payments.fromAccount">\n' +
    '              From account\n' +
    '            </span>\n' +
    '          <span class="col-xs-6">\n' +
    '            {{paymentsSign.selectedPaymentForSign.fromAccountNumber}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '                    <span class="col-xs-6 f-w-bold" translate="payments.toAccount">\n' +
    '              To account\n' +
    '            </span>\n' +
    '          <span class="col-xs-6">\n' +
    '              {{paymentsSign.selectedPaymentForSign.toAccountNumber}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '                    <span class="col-xs-6 f-w-bold" translate="loanPayment.purpose">\n' +
    '            Purpose\n' +
    '          </span>\n' +
    '          <span class="col-xs-6" title="{{payment.purpose}}">\n' +
    '            {{ paymentsSign.selectedPaymentForSign.purpose | limitTo: 40 }}{{paymentsSign.selectedPaymentForSign.purpose.length > 40 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '                    <span class="col-xs-6 f-w-bold" translate="domesticPayment.amountInputLabel">\n' +
    '            Amount\n' +
    '          </span>\n' +
    '          <span class="col-xs-6">\n' +
    '            {{paymentsSign.selectedPaymentForSign.amount|number:2}} {{::paymentsSign.selectedPaymentForSign.currencySymbol}}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '                    <span ng-if="paymentsSign.selectedPaymentForSign.dateCreated" class="col-xs-6 f-w-bold"\n' +
    '                          translate="signPayments.dateCreated">\n' +
    '            Date created\n' +
    '            </span>\n' +
    '          <span class="col-xs-6">\n' +
    '              {{paymentsSign.selectedPaymentForSign.dateCreated| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12">\n' +
    '                    <span class="col-xs-6 f-w-bold" translate="signPayments.dueDate">\n' +
    '              Due date\n' +
    '            </span>\n' +
    '          <span class="col-xs-6">\n' +
    '              {{paymentsSign.selectedPaymentForSign.dueDate| date:\'shortDate\'}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Small screens end -->\n' +
    '\n' +
    '      <!-- Actions for single payment -->\n' +
    '      <div class="row m-b-10">\n' +
    '        <span class="col-xs-12 m-t-20" ng-show="!paymentsSign.isPaymentDueDateValid"\n' +
    '              translate="signPayments.singlePaymentInvalidDueDate"></span>\n' +
    '        <span class="col-xs-12 payments-filter-active"\n' +
    '              ng-show="paymentsSign.dueDateUpdateAllowed && !paymentsSign.isPaymentDueDateValid"\n' +
    '              data-ng-click="paymentsSign.updateSinglePaymentDate()" translate="signPayments.updatePaymentDueDate">\n' +
    '          </span>\n' +
    '\n' +
    '        <!-- SMS Validation -->\n' +
    '        <div class="col-xs-12 m-t-30" ng-if="paymentsSign.selectedPaymentForSign.linkList.itemList.requestOTP">\n' +
    '          <!--<form id="nform1" autocomplete="off" novalidate>-->\n' +
    '            <div class="col-xs-12 m-b-20">\n' +
    '              <span ng-if="paymentsSign.countryCode != \'bh\' && paymentsSign.countryCode != \'sl\'" class="f-w-bold">\n' +
    '                {{\'signPayments.SmsDescription\' | translate}}\n' +
    '              </span>\n' +
    '              <span ng-if="paymentsSign.countryCode === \'bh\'" class="f-w-bold">\n' +
    '                {{\'signPayments.SmsDescriptionBh\' | translate}}\n' +
    '              </span>\n' +
    '              <span ng-if="paymentsSign.countryCode === \'sl\'" class="f-w-bold">\n' +
    '                {{\'signPayments.SmsDescriptionSLO\' | translate}}\n' +
    '              </span>\n' +
    '            </div>\n' +
    '            <div class="row p-10">\n' +
    '              <div ng-if="paymentsSign.countryCode === \'mne\'" class="col-xs-12 m-5">\n' +
    '                <p><span translate="signPayments.infoDomMne0"></span>\n' +
    '                  <span><a href="{{\'signPayments.infoDomMneLink\' | translate}}"\n' +
    '                           translate="signPayments.infoDomMne1"></a></span></p>\n' +
    '              </div>\n' +
    '              <div ng-if="paymentsSign.countryCode === \'sr\'" class="col-xs-12 m-5">\n' +
    '                <p><span translate="signPayments.infoDomSrb0"></span>\n' +
    '                  <span><a href="{{\'signPayments.infoDomSrbLink\' | translate}}"\n' +
    '                           translate="signPayments.infoDomSrb1"></a></span></p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 col-sm-4">\n' +
    '              <div class="form-group">\n' +
    '                <span class="f-w-bold">{{\'signPayments.SmsCode\' | translate}}</span>\n' +
    '                <div class="input-group">\n' +
    '                  <input id="nedim1" name="nedim1" type="text"\n' +
    '                         class="form-control input-field text-uppercase"\n' +
    '                         data-ng-model="paymentsSign.smsPasswordInput"\n' +
    '                         placeholder="{{\'currencyConversion.smsPassword\' | translate}}"\n' +
    '                         autocomplete="off"\n' +
    '                         auto-focus>\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <!--<button id="smsInput" class="btn btn-default input-group-app-btn domp-btn-height"-->\n' +
    '                    <!--data-ng-click="paymentsSign.toggleInputVisibility()">-->\n' +
    '                    <!--<i data-ng-show="paymentsSign.showInput" class="zmdi zmdi-lock"></i>-->\n' +
    '                    <!--<i data-ng-show="!paymentsSign.showInput" class="zmdi zmdi-lock-open"></i>-->\n' +
    '                    <!--</button>-->\n' +
    '                  </span>\n' +
    '                  <span class="input-group-btn" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                    <button class="btn btn-default input-group-app-btn domp-btn-height"\n' +
    '                            data-ng-click="paymentsSign.sendSMS()"\n' +
    '                            ng-disabled="paymentsSign.signButtonDisabled"\n' +
    '                            uib-tooltip="{{\'signPayments.resendSms\' | translate}}">\n' +
    '                      <i class="zmdi zmdi-refresh-sync"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                  <span class="input-group-btn" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.additionalTransactionConfirmation.id == 1">\n' +
    '                    <button class="btn btn-default input-group-app-btn domp-btn-height"\n' +
    '                            data-ng-click="paymentsSign.requestSMSCodeForSlo()"\n' +
    '                            ng-disabled="paymentsSign.resendSMSInProgress || paymentsSign.repeatSmsCounter == 3"\n' +
    '                            uib-tooltip="{{\'signPayments.resendSmsSlo\' | translate}}" tooltip-class="tooltip-fullwidth">\n' +
    '                      <i class="zmdi zmdi-refresh-sync"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-4 col-sm-4 col-sm-offset-4  m-t-20">\n' +
    '              <!-- TODO: Refactor ng-disabled statement -->\n' +
    '              <button id="signConfirm" class="btn btn-default pull-right" data-ng-click="paymentsSign.signSinglePayment()"\n' +
    '                      ng-disabled="paymentsSign.formSubmitted ||!paymentsSign.isPaymentDueDateValid || paymentsSign.smsPasswordInput === \'\'"\n' +
    '                      translate="signPayments.confirm"></button>\n' +
    '            </div>\n' +
    '          <!--</form>-->\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Challenge response validation -->\n' +
    '        <div ng-if="!paymentsSign.selectedPaymentForSign.linkList.itemList.requestOTP && !paymentsSign.selectedPaymentForSign.linkList.itemList.requestMiniToken" class="col-xs-12 m-t-30">\n' +
    '\n' +
    '          <!--<form id="nform2" autocomplete="off" novalidate>-->\n' +
    '\n' +
    '            <div ng-if="paymentsSign.countryCode != \'sl\'">\n' +
    '              <div class="col-xs-12 m-b-20">\n' +
    '                            <span class="f-w-bold">\n' +
    '                        {{\'signPayments.challengeDescription\' | translate}}\n' +
    '                      </span>\n' +
    '              </div>\n' +
    '              <div class="col-md-4 col-sm-6 col-xs-6">\n' +
    '                <div class="form-group">\n' +
    '                  <div class="wrap-text f-w-bold" style="font-weight:500;">{{\'signPayments.challengeFirstCode\' |\n' +
    '                    translate}}\n' +
    '                  </div>\n' +
    '                  <input type="text" class="form-control input-field" disabled\n' +
    '                         data-ng-model="paymentsSign.selectedPaymentForSign.challenge">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-md-4 col-sm-6 col-xs-6">\n' +
    '                <div class="form-group">\n' +
    '                  <div class="wrap-text f-w-bold" style="font-weight:500;">{{\'signPayments.challengeSecondCode\' |\n' +
    '                    translate}}\n' +
    '                  </div>\n' +
    '                  <!--<div class="input-group">-->\n' +
    '                  <input id="nedim" name="nedim" type="text" class="form-control input-field"\n' +
    '                         data-ng-model="paymentsSign.challengeResponse"\n' +
    '                         ng-pattern-restrict="{{paymentsSign.regexPatterns.onlyNumbers}}"\n' +
    '                         placeholder="{{\'signPayments.challengeSecondCode\' | translate}}" autocomplete="off" auto-focus>\n' +
    '                  <!--<span class="input-group-btn">-->\n' +
    '                  <!--<button id="smsInput" class="btn btn-default input-group-app-btn domp-btn-height"-->\n' +
    '                  <!--data-ng-click="paymentsSign.toggleInputVisibility()" style="border:1px solid #062a42;">-->\n' +
    '                  <!--<i data-ng-show="paymentsSign.showInput" class="zmdi zmdi-lock" ></i>-->\n' +
    '                  <!--<i data-ng-show="!paymentsSign.showInput" class="zmdi zmdi-lock-open"></i>-->\n' +
    '                  <!--</button>-->\n' +
    '                  <!--</span>-->\n' +
    '                  <!--</div>-->\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-12 m-t-20 pull-right">\n' +
    '              <!-- TODO: Refactor ng-disabled statement -->\n' +
    '              <button id="signConfirm" ng-if="paymentsSign.countryCode != \'sl\'" class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                      data-ng-click="paymentsSign.signSinglePayment()"\n' +
    '                      ng-disabled="paymentsSign.formSubmitted || !paymentsSign.isPaymentDueDateValid || paymentsSign.challengeResponse === \'\'"\n' +
    '                      translate="signPayments.confirm"></button>\n' +
    '              <button id="signConfirm" ng-if="paymentsSign.countryCode === \'sl\'" class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                      data-ng-click="paymentsSign.signSinglePayment()" ng-disabled="paymentsSign.formSubmitted"\n' +
    '                      translate="signPayments.confirm"></button>\n' +
    '            </div>\n' +
    '          <!--</form>-->\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <!-- MiniToken validation (FOR NOW ONLY BIH ENVIRONMENT) -->\n' +
    '        <div ng-if="paymentsSign.selectedPaymentForSign.linkList.itemList.requestMiniToken" class="col-xs-12 m-t-30">\n' +
    '          <!--<form id="miniTokenForm" autocomplete="off" novalidate>-->\n' +
    '            <div class="col-xs-12 m-b-20">\n' +
    '              <span class="f-w-bold">{{\'signPayments.OtpDescriptionBh\' | translate}}</span>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 col-md-6">\n' +
    '              <div class="form-group">\n' +
    '                <div class="wrap-text f-w-bold" style="font-weight:500;">{{\'signPayments.otpLabel\' |\n' +
    '                  translate}}\n' +
    '                </div>\n' +
    '                <input id="spahaMT" name="spahaMT" type="text" class="form-control input-field"\n' +
    '                       data-ng-model="paymentsSign.challengeResponse"\n' +
    '                       ng-pattern-restrict="{{paymentsSign.regexPatterns.onlyNumbers}}"\n' +
    '                       placeholder="{{\'signPayments.challengeSecondCodeBh\' | translate}}" autocomplete="off" auto-focus>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-12 m-t-20 pull-right">\n' +
    '              <button id="signConfirm" class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                      data-ng-click="paymentsSign.signSinglePayment()"\n' +
    '                      ng-disabled="paymentsSign.formSubmitted || !paymentsSign.isPaymentDueDateValid "\n' +
    '                      translate="signPayments.confirm"></button>\n' +
    '            </div>\n' +
    '          <!--</form>-->\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payment-sign-modal.tpl.html',
    '<div class="p-l-15 p-r-15 f-14" ng-hide="eInvoicesModal.signSuccess">\n' +
    '  <form name="paymentSignModal.signPaymentForm" novalidate>\n' +
    '    <div class="row eim-header p-10 bottom-border">\n' +
    '      <b class="f-18 p-l-10" translate="paymentSignModal.title"></b>\n' +
    '      <i class="zmdi zmdi-close zmdi-hc-2x pull-right pointer-cst eim-header-btn-close" data-ng-click="paymentSignModal.closeModal();"></i>\n' +
    '    </div>\n' +
    '    <div class="row p-10 bottom-border">\n' +
    '      <div class="eim-details col-md-12 col-sm-12 no-padding-on-phone">\n' +
    '        <label translate="paymentSignModal.challengeResponse"></label>\n' +
    '        <input type="text" name="challengeResponseInput"\n' +
    '               data-ng-class="{\'domp-error\': paymentSignModal.signPaymentForm.challengeResponseInput.$invalid && paymentSignModal.formSubmitted}"\n' +
    '               class="form-control" data-ng-model="paymentSignModal.challengeResponseInput" required>\n' +
    '        <span class="c-red"\n' +
    '              ng-show="paymentSignModal.signPaymentForm.challengeResponseInput.$error.required && paymentSignModal.formSubmitted"\n' +
    '              translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row p-10 eim-footer">\n' +
    '      <div class="eim-btn p-r-5 t-a-c">\n' +
    '        <button class="btn btn-default app-btn-blue ng-scope eim-action-button w-100"\n' +
    '                translate="paymentSignModal.ok"\n' +
    '                data-ng-click="paymentSignModal.signPayment();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payment-reclamation.tpl.html',
    '<section id="main" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <div class="container" ng-switch-default>\n' +
    '    <div class="exchange-rate-header m-b-10">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12 f-20" translate="reclamation.title"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="trans-complain-container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.number"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::vm.model.id}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.paymentReference"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::vm.model.referenceNumber}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.bookingDate"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::vm.model.bookingDate | date:\n' +
    '              \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.valueDate"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::vm.model.valueDate | date:\n' +
    '              \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.amount"></label>\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-9 p-r-0">\n' +
    '                <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field t-a-r">{{::vm.model.amount| number:\n' +
    '                  2}}</label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-3 p-l-0">\n' +
    '                <label class="tr-input-lbl wrap-text p-l-10 p-r-10 tr-amount-ctn input-field">{{::vm.model.currencySymbol}}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6 col-xs-6">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.purpose"></label>\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field">{{::vm.model.purpose}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="form-group">\n' +
    '            <label class="tr-input-lbl wrap-text p-l-10 p-r-10 input-field"\n' +
    '                   translate="reclamation.wantComplain"></label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="form-group">\n' +
    '            <label translate="reclamation.description"></label>\n' +
    '            <textarea ng-pattern-restrict="{{vm.regexPatterns.allowedCharsDPStextArea}}"\n' +
    '                      ng-model="vm.input.comment"\n' +
    '                      class="form-control"\n' +
    '                      id="reclamationInput"\n' +
    '                      cols="30"\n' +
    '                      rows="5"\n' +
    '                      maxlength="250"\n' +
    '                      style="resize: none"\n' +
    '            ></textarea>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="container" ng-switch-when="sl">\n' +
    '    <div class="exchange-rate-header m-b-10">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12 f-20" translate="reclamation.title"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="trans-complain-container">\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label"><b>{{::vm.model.purpose}}</b></label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="paymentsOverview.povlId"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-value-label">{{::vm.model.id}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-10" ng-if="vm.model.referenceNumber">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="paymentsOverview.referenceNumber"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-value-label">{{::vm.model.referenceNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-10" ng-if="vm.model.receiverName">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="paymentsOverview.povlReceiver"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-value-label">{{::vm.model.receiverName}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="paymentsOverview.povlFrom"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-value-label">{{::vm.model.fromAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="paymentsOverview.povlTo"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-value-label">{{::vm.model.toAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="paymentsOverview.povlAmount"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-value-label" ng-if="::vm.model.transactionAmount2">{{::vm.model.transactionAmount2|number:2}}\n' +
    '            {{::vm.model.destinationCurrencySymbol}}</label>\n' +
    '          <label class="po-value-label" ng-if="::!vm.model.transactionAmount2">{{::vm.model.amount|number:2}}\n' +
    '            {{::vm.model.currencySymbol}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="signPayments.dateCreated"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <span class="po-value-label">{{vm.model.dateCreated| date:\'shortDate\'}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-6">\n' +
    '          <label class="po-desc-label" translate="paymentsOverview.povlDueDate"></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-6">\n' +
    '          <span class="po-value-label">{{vm.model.dueDate| date:\'shortDate\'}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-10">\n' +
    '        <div class="col-md-12">\n' +
    '          <label class="po-desc-label" translate="reclamation.description"></label>\n' +
    '          <textarea ng-pattern-restrict="{{vm.regexPatterns.allowedCharsText}}"\n' +
    '                    ng-model="vm.input.comment"\n' +
    '                    class="form-control"\n' +
    '                    id="reclamationInput"\n' +
    '                    cols="30"\n' +
    '                    rows="5"\n' +
    '                    maxlength="250"\n' +
    '                    style="resize: none">\n' +
    '            </textarea>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="row m-t-10">\n' +
    '      <div class="col-sm-12 c-red bold-font">\n' +
    '        <div class="col-lg-3 col-sm-6 ">\n' +
    '          <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn m-0"\n' +
    '                  translate="reclamation.cancel"\n' +
    '                  data-ng-click="vm.cancel()">\n' +
    '\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-lg-3 col-sm-6 pull-right ">\n' +
    '          <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn m-0 pull-right"\n' +
    '                  translate="reclamation.confirm"\n' +
    '                  ng-disabled="vm.confirmButtonDisabled"\n' +
    '                  data-ng-click="vm.confirm();">\n' +
    '\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payment-final-step-directive.tpl.html',
    '<div class="intp-form-container light-bcg bottom-border">\n' +
    '  <div class="row">\n' +
    '    <div class="col-sm-6 text-center int-ctn-h">\n' +
    '      <div class="int-b-bottom">\n' +
    '        <div class="int-l-ctn-height">\n' +
    '          <img src="img/hypo/check-circle-success.png" height="100px" alt=""/>\n' +
    '        </div>\n' +
    '        <div class="f-18 m-b-10" translate="internalTransfer.signSuccess"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-sm-6 int-l-border">\n' +
    '      <p class="int-header" translate="internalTransfer.saveAsTemplate"></p>\n' +
    '      <form name="paymentFinalStep.templateForm" novalidate>\n' +
    '        <div class="form-group">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 ng-class="{\'domp-error\': paymentFinalStep.templateForm.templateName.$invalid && paymentFinalStep.formSubmitted}"\n' +
    '                 name="templateName" data-ng-model="paymentFinalStep.templateNameInput"\n' +
    '                 placeholder="{{\'internalTransfer.templateName\' | translate}}" required>\n' +
    '          <span class="c-red"\n' +
    '                ng-show="paymentFinalStep.templateForm.templateName.$error.required && paymentFinalStep.formSubmitted"\n' +
    '                translate="internalTransfer.templateNameError"></span>\n' +
    '\n' +
    '        </div>\n' +
    '        <button class="btn btn-primary app-btn-blue int-btn-save w-100 m-b-5"\n' +
    '                data-ng-click="paymentFinalStep.saveAsTemplate();">\n' +
    '          Save\n' +
    '        </button>\n' +
    '      </form>\n' +
    '\n' +
    '      <hr class="int-h-line">\n' +
    '\n' +
    '      <div class="text-center">\n' +
    '        <button class="btn btn-primary app-btn-blue int-btn-save w-100 m-b-5"\n' +
    '                translate="internalTransfer.newPayment"\n' +
    '                data-ng-click="paymentFinalStep.navigateToPaymentsPage();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary app-btn-blue int-btn-save w-100 m-b-5"\n' +
    '                translate="internalTransfer.toPaymentOverview"\n' +
    '                data-ng-click="paymentFinalStep.navigateToAllPaymentsPage();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/payment-confirmation-modal-slo.tpl.html',
    '<div class="modal-header">\n' +
    '  <h3 class="modal-title" id="modal-title" translate="paymentsOverview.orderPaymentConfirmation"></h3>\n' +
    '</div>\n' +
    '<ng-form name="orderPaymentForm">\n' +
    '  <div class="modal-body" id="modal-body">\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <table class="table table-transparent table-responsive">\n' +
    '          <tbody>\n' +
    '          <tr>\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="paymentsOverview.povlId"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label">{{::vm.payment.id}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr ng-if="::vm.payment.referenceNumber">\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="paymentsOverview.referenceNumber"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label">{{::vm.payment.referenceNumber}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr ng-if="::vm.payment.receiverName">\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="paymentsOverview.povlReceiver"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label">{{::vm.payment.receiverName}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr>\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="paymentsOverview.povlFrom"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label">{{::vm.payment.fromAccountNumber}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr>\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="paymentsOverview.povlTo"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label">{{::vm.payment.toAccountNumber}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr>\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="paymentsOverview.povlAmount"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label" ng-if="::vm.payment.transactionAmount2">{{::vm.payment.transactionAmount2|number:2}} {{::vm.payment.destinationCurrencySymbol}}</span>\n' +
    '              <span class="po-value-label" ng-if="::!vm.payment.transactionAmount2">{{::vm.payment.amount|number:2}} {{::vm.payment.currencySymbol}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr>\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="signPayments.dateCreated"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label">{{vm.payment.dateCreated| date:\'shortDate\'}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr>\n' +
    '            <td>\n' +
    '              <span class="po-desc-label" translate="paymentsOverview.povlDueDate"></span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '              <span class="po-value-label">{{vm.payment.dueDate| date:\'shortDate\'}}</span>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          </tbody>\n' +
    '\n' +
    '        </table>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <hr>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12 p-m-15">\n' +
    '        <h3 class="capitalize" translate="paymentsOverview.recepientInfo">RECIPIENT INFORMATION</h3>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row m-b-20">\n' +
    '      <div class="col-md-4">\n' +
    '        <span class="capitalize" translate="paymentsOverview.receiveConfirmation">I would like to receive the confirmation to the following address</span>:\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <textarea name="address" ng-model="vm.model.address" class="form-control statement-confirm-textarea"\n' +
    '                  minlength="5" ng-min="5" required\n' +
    '                  style="border-radius: 7px;border-style:none; border-style: inset !important;">\n' +
    '        </textarea>\n' +
    '        <span class="c-red" ng-show="orderPaymentForm.address.$error.minlength" translate="paymentsOverview.minLength5"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row m-b-20">\n' +
    '      <div class="col-md-4">\n' +
    '        <span class="capitalize" translate="paymentsOverview.orderComment"></span>:\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <input type="text" name="note" ng-model="vm.model.note" class="form-control"/>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row m-b-20">\n' +
    '      <div class="col-md-12">\n' +
    '        <span translate="paymentsOverview.orderPaymentConfMsg1"></span>\n' +
    '        <a href="https://www.addiko.si/ceniki " target="_blank" class="underline" translate="paymentsOverview.orderPaymentConfMsg2"></a>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '  </div>\n' +
    '  <div class="modal-footer">\n' +
    '    <button class="btn btn-default pull-right" type="button" ng-click="vm.ok(orderPaymentForm)" translate="paymentsOverview.orderConfirmationBtn"\n' +
    '            ng-disabled="orderPaymentForm.$invalid || vm.confirmBtnDisabled">NEXT\n' +
    '    </button>\n' +
    '    <button class="btn btn-warning pull-left" type="button" ng-click="vm.cancel()" translate="payments.cancel">CANCEL\n' +
    '    </button>\n' +
    '  </div>\n' +
    '</ng-form>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/loan-payment.tpl.html',
    '<section id="main">\n' +
    '    <div class="container-fluid p-b-20">\n' +
    '\n' +
    '        <div class="exchange-rate-header" ng-show="loanPayment.currentStep != 3">\n' +
    '            <div class="row">\n' +
    '                <div class="col-sm-12 title-style" translate="loanPayment.loanPayment"></div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="internal-transfer-body bg-white p-b-0" ng-if="loanPayment.currentStep == 1">\n' +
    '            <form name="loanPayment.loanPaymentForm" novalidate>\n' +
    '                <div class="exchange-rates-body m-b-10 p-b-10">\n' +
    '                    <div class="row m-b-30">\n' +
    '                        <div class="col-sm-6">\n' +
    '                            <!-- CUSTOM FROM Accounts dropdown-->\n' +
    '                            <label class=" f-18" translate="payments.fromAccount"></label>\n' +
    '                            <div class="accounts-dropdown">\n' +
    '                                <!--<div class="debit-account-widget dashboard-widget-item account-drop-height" data-ng-click="loanPayment.toggleFromAccount();">\n' +
    '                                    <h4 class="no-wrap-text bold-font">\n' +
    '                                      {{loanPayment.tempLoanObj.fromAccountSelect.accountDescription}}\n' +
    '                                    <span class="favorite-star-container">\n' +
    '                                    <i class="zmdi "\n' +
    '                                       ng-class="{\'zmdi-star favorite-account\':loanPayment.tempLoanObj.fromAccountSelect.isFavorite,\n' +
    '                                       \'zmdi-star-outline\':!loanPayment.tempLoanObj.fromAccountSelect.isFavorite}"></i>\n' +
    '                                    </span>\n' +
    '                                    </h4>\n' +
    '                                                        <p class="no-bottom-margin">{{loanPayment.tempLoanObj.fromAccountSelect.iban}}</p>\n' +
    '                                                        <p class="m-b-0 bold-font f-18">\n' +
    '                                                            {{loanPayment.tempLoanObj.fromAccountSelect.availableBalance | number:2}} {{loanPayment.tempLoanObj.fromAccountSelect.currencySymbol}}\n' +
    '                                                        </p>\n' +
    '                                                        <span class="d-block m-b-9" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                        <span class="caret-icon">\n' +
    '                                    <i class="zmdi zmdi-caret-down zmdi-hc-2x"></i>\n' +
    '                                  </span>\n' +
    '                                </div>-->\n' +
    '\n' +
    '                                <div class="debit-account-widget dashboard-widget-item" data-ng-click="loanPayment.toggleFromAccount();"  ng-style="loanPayment.tempLoanObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + loanPayment.tempLoanObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{loanPayment.tempLoanObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':loanPayment.tempLoanObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!loanPayment.tempLoanObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                                    </h4>\n' +
    '                                    <p class="m-b-0 m-t-0 iban-style">{{loanPayment.tempLoanObj.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                        {{loanPayment.tempLoanObj.fromAccountSelect.availableBalance | number:2}} {{loanPayment.tempLoanObj.fromAccountSelect.currencySymbol}}\n' +
    '                                    </p>\n' +
    '                                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                    <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <!--<div class="accounts-list m-l-15 m-r-15" ng-show="loanPayment.fromAccountDropdown" scrollable>\n' +
    '                                    <div class="accounts-list-item" data-ng-repeat="item in loanPayment.accountsFrom" data-ng-click="loanPayment.setAccountFrom(item);">\n' +
    '                                        <span class="d-block f-16 bold-font">{{item.accountDescription}}</span>\n' +
    '                                        <span class="d-block">{{item.iban}}</span>\n' +
    '                                        <span class="d-block bold-font f-18">{{item.availableBalance | number:2}} {{item.currencySymbol}}</span>\n' +
    '                                        <span class="d-block" translate="currencyConversion.availableBalance"></span>\n' +
    '                                    </div>\n' +
    '                                </div>-->\n' +
    '\n' +
    '                                <div class="from-accounts-list m-l-15" ng-show="loanPayment.fromAccountDropdown" scrollable>\n' +
    '                                    <div class="accounts-list-item p-0" data-ng-repeat="item in loanPayment.accountsFrom" data-ng-click="loanPayment.setAccountFrom(item);">\n' +
    '\n' +
    '                                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                            </h4>\n' +
    '                                            <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                                            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                                            </p>\n' +
    '                                            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="col-sm-6">\n' +
    '                            <label class=" f-18" translate="internalTransfer.amount"></label>\n' +
    '                            <div class="input-group">\n' +
    '                              <input type="text" class="form-control input-field t-a-r"\n' +
    '                                     placeholder="{{\'eInvoicesModal.amountPlaceholder\' | translate}}"\n' +
    '                                     amount-input-mask\n' +
    '                                     max-amount="{{loanPayment.maxAmount}}"\n' +
    '                                     maxlength="{{loanPayment.maxLength}}"\n' +
    '                                     data-ng-model="loanPayment.tempLoanObj.amountInput"\n' +
    '                                     ng-class="{\'domp-error\': loanPayment.loanPaymentForm.amountInput.$invalid && loanPayment.tempLoanObj.formSubmitted}" required>\n' +
    '                                <span class="input-group-btn">\n' +
    '            <button type="button" class="btn input-group-app-btn domp-btn-height" style="border:1px solid #062a42;" disabled>\n' +
    '              {{loanPayment.tempLoanObj.fromAccountSelect.currencySymbol}}\n' +
    '            </button>\n' +
    '            </span>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <span class="c-red" ng-show="loanPayment.loanPaymentForm.amountInput.$error.required && loanPayment.tempLoanObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                            <span class="c-red" ng-show="loanPayment.loanPaymentForm.amountInput.$error.maxlength && loanPayment.tempLoanObj.formSubmitted" translate="internalTransfer.amountLengthError"></span>\n' +
    '\n' +
    '                          <label class="p-t-15 f-18" translate="internalTransfer.dueDate"></label>\n' +
    '                            <div class="input-group col-xs-12">\n' +
    '\n' +
    '                                <input uib-datepicker-popup="shortDate" ng-if="loanPayment.countryCode != \'sl\'" type="text" class="form-control input-field" name="dueDateInput" data-ng-model="loanPayment.tempLoanObj.dueDateInput" readonly>\n' +
    '                                <input ng-if="loanPayment.countryCode === \'sl\'" type="text" class="form-control input-field" name="dueDateInput"\n' +
    '                                       uib-datepicker-popup="shortDate" data-ng-model="loanPayment.tempLoanObj.dueDateInput"\n' +
    '                                       show-weeks="false" is-open="loanPayment.datePickerOpened"\n' +
    '                                       datepicker-options="loanPayment.dateOptions"\n' +
    '                                       current-text="{{\'core.period.today\' | translate}}"\n' +
    '                                       clear-text="{{\'core.datePicker.clearBtn\' | translate}}"\n' +
    '                                       close-text="{{\'core.datePicker.doneBtn\' | translate}}"\n' +
    '                                       ng-class="{\'domp-error\': loanPayment.loanPaymentForm.dueDateInput.$invalid && loanPayment.tempLoanObj.formSubmitted}"\n' +
    '                                       ng-readonly="true"\n' +
    '                                       required>\n' +
    '\n' +
    '                                <span ng-if="loanPayment.countryCode === \'sl\'" class="input-group-btn">\n' +
    '                                  <button data-ng-click="loanPayment.openDatePicker()" type="button"\n' +
    '                                          class="btn input-group-app-btn domp-btn-height" style="border:1px solid #062a42;"><i\n' +
    '                                    class="icon icon-calendar" style="font-size: 21px;" ></i>\n' +
    '                                  </button>\n' +
    '                                </span>\n' +
    '                            </div>\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '              <div class="exchange-rates-body m-b-10 p-b-10">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-12 col-sm-6 ">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-xs-12">\n' +
    '                        <label class=" f-18" translate="payments.toAccount"></label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row p-b-20">\n' +
    '                      <div class="col-xs-12">\n' +
    '                      <input type="text" class="form-control input-field"\n' +
    '                             data-ng-model="loanPayment.tempLoanObj.toAccountInput" disabled>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-xs-12 col-sm-6">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-xs-12">\n' +
    '                        <label class=" f-18" translate="loanPayment.recieverNumber"></label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row p-b-15">\n' +
    '                      <div class="col-xs-6 col-sm-2 p-r-5 p-b-5">\n' +
    '                        <input type="text" data-ng-model="loanPayment.tempLoanObj.receiverNumberCountryCode"\n' +
    '                               class="form-control input-field t-a-c" readonly>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-6 col-sm-2 p-l-5 p-r-5 p-b-5 hidden-xs">\n' +
    '                        <input type="text" data-ng-model="loanPayment.tempLoanObj.receiverNumber1"\n' +
    '                               class="form-control input-field t-a-c" readonly>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-6 col-sm-2 p-l-5 p-b-5 visible-xs">\n' +
    '                        <input type="text" data-ng-model="loanPayment.tempLoanObj.receiverNumber1"\n' +
    '                               class="form-control input-field t-a-c" readonly>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-12 col-sm-8 p-b-5">\n' +
    '                        <input type="text" data-ng-model="loanPayment.tempLoanObj.receiverNumber2"\n' +
    '                               class="form-control input-field" readonly>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="row m-b-10" >\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <label class=" f-18" translate="internationalPayment.paymentPurpose"></label>\n' +
    '                    <input type="text" class="form-control input-field" name="paymentPurposeInput"\n' +
    '                           data-ng-model="loanPayment.tempLoanObj.paymentPurposeInput"\n' +
    '                           ng-class="{\'domp-error\': loanPayment.loanPaymentForm.paymentPurposeInput.$invalid && loanPayment.tempLoanObj.formSubmitted}"\n' +
    '                           required>\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="loanPayment.loanPaymentForm.paymentPurposeInput.$error.required && loanPayment.tempLoanObj.formSubmitted"\n' +
    '                          translate="internalTransfer.paymentPurposeInputError">\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '            </form>\n' +
    '        </div>\n' +
    '        <div class="internal-transfer-body p-b-0" ng-if="loanPayment.currentStep == 1">\n' +
    '          <div class="row p-b-10">\n' +
    '            <div class="col-xs-6 t-a-l">\n' +
    '              <button class="btn btn-primary" translate="payments.cancel"\n' +
    '                      data-ui-sref="loansOverview">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="col-xs-6 t-a-r">\n' +
    '              <button ng-switch-default class="btn btn-default domp-review-and-submit-btn" translate="currencyConversion.confirm" data-ng-click="loanPayment.submitLoanPayment();">\n' +
    '              </button>\n' +
    '              <button ng-switch-when="sl" class="btn btn-default domp-review-and-submit-btn" ng-disabled="(loanPayment.nextButtonPressed || loanPayment.secondValidateInProgress) || !loanPayment.tempLoanObj.amountInput" translate="domesticPayment.confirmBtnSlo" data-ng-click="loanPayment.submitLoanPayment();">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Internal transfer STEP 2 -->\n' +
    '        <div ng-if="loanPayment.currentStep == 2">\n' +
    '            <div data-ng-include="\'payments/loan-payment-resume.tpl.html\'">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Internal transfer STEP 3 -->\n' +
    '        <div ng-if="loanPayment.currentStep == 3">\n' +
    '            <div data-ng-include="\'payments/internal-transfer-final.tpl.html\'">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/loan-payment-resume.tpl.html',
    '<form name="loanPaymentForm" novalidate>\n' +
    '  <div class="domp-to-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{loanPayment.paymentResponse.fromAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '              <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel">Amount</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              {{loanPayment.paymentResponse.amount | currency:""}}\n' +
    '              {{loanPayment.paymentResponse.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <!--<div class="col-sm-6">-->\n' +
    '            <!--<label class="domp-form-label-review" translate="domesticPayment.bankCharges">Bank charges</label>-->\n' +
    '              <!--<a ng-href="{{loanPayment.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges" class="domp-form-label-resume">Check the bank charges</a>-->\n' +
    '          <!--</div>-->\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12 p-t-10">\n' +
    '            <label class="domp-form-label-review" translate="loanPayment.when">When</label>\n' +
    '            <label class="d-block domp-form-label-resume">{{loanPayment.paymentResponse.dueDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-to-section m-t-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.toAccount">To account</label>\n' +
    '          <label class="d-block domp-form-label-resume">{{loanPayment.paymentResponse.toAccountNumber }}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review"  translate="loanPayment.referenceNumber">Reference number</label>\n' +
    '          <label class="d-block domp-form-label-resume">\n' +
    '            {{loanPayment.tempLoanObj.receiverNumberCountryCode}} {{loanPayment.tempLoanObj.receiverNumber1}} {{loanPayment.tempLoanObj.receiverNumber2}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--<div class="row">\n' +
    '     <div class="col-sm-6"></div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="exchange-resume-label"  translate="loanPayment.exchangeRate">Exchange rate</label>\n' +
    '          <label class="d-block exchange-resume-val">no info</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>-->\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- SMS auth -->\n' +
    '<!--  <div class="domp-to-section m-t-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-12" ng-if="loanPayment.smsAuthentificate != true">\n' +
    '        <div class="form-group">\n' +
    '          <label class="exchange-resume-label" translate="currencyConversion.smsAuthentification"></label>\n' +
    '          <button class="btn btn-default confirm-btn d-block" translate="currencyConversion.sendSms"\n' +
    '                  data-ng-click="loanPayment.showSMSAuthentification();"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-12" ng-if="loanPayment.smsAuthentificate == true">\n' +
    '        <div class="form-group">\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   data-ng-model="loanPayment.smsPasswordInput"\n' +
    '                   placeholder="{{\'currencyConversion.smsPassword\' | translate}}">\n' +
    '          <span class="input-group-btn">\n' +
    '            <button class="btn btn-default input-group-app-btn domp-btn-height">\n' +
    '              <i class="zmdi zmdi-lock"></i>\n' +
    '            </button>\n' +
    '          </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>-->\n' +
    '\n' +
    '  <div class="m-t-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-12 col-sm-9 hidden-xs">\n' +
    '        <button class="btn btn-primary " translate="currencyConversion.back"\n' +
    '                ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                data-ng-click="loanPayment.backToLoanPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="loanPayment.countryCode != \'sl\'" class="btn btn-primary" translate="payments.edit"\n' +
    '                data-ng-click="loanPayment.editPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="loanPayment.countryCode === \'sl\'" class="btn btn-primary" translate="domesticPayment.back"\n' +
    '                data-ng-click="loanPayment.editPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="loanPayment.countryCode != \'sl\'" class="btn btn-primary-warning" translate="payments.delete"\n' +
    '                data-ng-click="loanPayment.deletePayment();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-12 col-sm-9 visible-xs">\n' +
    '        <button ng-if="loanPayment.countryCode != \'sl\'" class="btn btn-default col-xs-12 m-b-5"\n' +
    '                translate="currencyConversion.sign"\n' +
    '                data-ui-sref="payments.sign({payment: loanPayment.paymentResponse, paymentId: loanPayment.paymentResponse.id, type: \'loan\'})">\n' +
    '        </button>\n' +
    '        <button ng-if="loanPayment.countryCode === \'sl\'" class="btn btn-default col-xs-12 m-b-5"\n' +
    '                translate="currencyConversion.sign"\n' +
    '                ng-disabled="loanPayment.confirmButtonPressed"\n' +
    '                ng-click="loanPayment.sign()">\n' +
    '\n' +
    '        </button>\n' +
    '\n' +
    '        <button class="btn btn-primary col-xs-12 m-b-5" translate="currencyConversion.back"\n' +
    '                ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                data-ng-click="loanPayment.backToLoanPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="loanPayment.countryCode != \'sl\'" class="btn btn-primary col-xs-6 " translate="payments.edit"\n' +
    '                data-ng-click="loanPayment.editPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="loanPayment.countryCode === \'sl\'" class="btn btn-primary col-xs-6 " translate="domesticPayment.back"\n' +
    '                data-ng-click="loanPayment.editPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="loanPayment.countryCode != \'sl\'" class="btn btn-primary-warning col-xs-6 " translate="payments.delete"\n' +
    '                data-ng-click="loanPayment.deletePayment();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-6 col-sm-3 col-xs-6 hidden-xs">\n' +
    '        <div class="pull-right">\n' +
    '<!--          <button class="btn btn-default confirm-btn"\n' +
    '                  translate="currencyConversion.sign"\n' +
    '                  ng-disabled="!loanPaymentForm.$dirty && loanPayment.smsAuthentificate == false"\n' +
    '                  data-ng-click="loanPayment.signPayment();">\n' +
    '          </button>-->\n' +
    '          <button ng-if="loanPayment.countryCode != \'sl\'" class="btn btn-default"\n' +
    '                  translate="currencyConversion.sign"\n' +
    '                  data-ui-sref="payments.sign({payment: loanPayment.paymentResponse, paymentId: loanPayment.paymentResponse.id, type: \'loan\'})">\n' +
    '          </button>\n' +
    '          <button ng-if="loanPayment.countryCode === \'sl\'" class="btn btn-default"\n' +
    '                  ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation"\n' +
    '                  ng-disabled="loanPayment.confirmButtonPressed"\n' +
    '                  ng-click="loanPayment.sign()">\n' +
    '            <span ng-switch-when="sl" translate="domesticPayment.confirmBtn"></span>\n' +
    '            <span ng-switch-default translate="currencyConversion.sign"></span>\n' +
    '          </button>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/loan-payment-final.tpl.html',
    '<div class="currency-conversion-msg">\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{loanPayment.paymentResponse.amount}}\n' +
    '            {{loanPayment.paymentResponse.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span>from</span>\n' +
    '          <span>{{loanPayment.paymentResponse.fromAccountNumber}}</span>\n' +
    '          <span>to</span>\n' +
    '          <span>{{loanPayment.paymentResponse.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="loanPayment.backToLoanPayment();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/international-payment.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="exchange-rates">\n' +
    '      <div class="no-padding-on-phone">\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\'" data-ng-include="\'payments/international-payment-cro.tpl.html\'"></div>\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" data-ng-include="\'payments/international-payment-slo.tpl.html\'"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/international-payment-slo.tpl.html',
    '<section ng-controller="InternationalPaymentSloCtrl as internationalPayment">\n' +
    '  <div>\n' +
    '    <span ng-if="internationalPayment.steps.step1">\n' +
    '      <!-- START Title -->\n' +
    '      <div class="domp-header-wrapper col-sm-12 p-0">\n' +
    '        <div class="domp-header-row">\n' +
    '          <h2 class="intp-title f-28" translate="internationalPayment.international"></h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Title-->\n' +
    '      <div class="domp-select-section col-sm-12 p-0">\n' +
    '        <!-- ADD SELECT FROM TEMPLATE HERE ! -->\n' +
    '        <!-- FIRST BOX -->\n' +
    '        <form name="internationalPayment.paymentForm" novalidate>\n' +
    '\n' +
    '          <!--SELECT TEMPLATE CUSTOM -->\n' +
    '\n' +
    '          <div class="domp-template-filter-container">\n' +
    '            <div class="domp-select-template" ng-click="internationalPayment.toggleTemplateFilterSelection()"\n' +
    '                 ng-show="internationalPayment.templateName == \'\'">\n' +
    '              <div class="select-template label-select">\n' +
    '                <label class="p-t-10 f-18 p-t-5" translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-selected-template" ng-show="internationalPayment.templateName != \'\'">\n' +
    '              <div class="select-template label-template-selected p-l-10 p-t-5" ng-show="internationalPayment.templateName != \'\'">\n' +
    '                <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                <img ng-if="internationalPayment.selectedTemplate.imageId" ng-src="{{internationalPayment.selectedTemplate.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img-40"/>\n' +
    '                <img ng-if="!internationalPayment.selectedTemplate.imageId" class="tpl-rounded-img-40" alt="Ico"/>\n' +
    '\n' +
    '                <label class="p-l-10 selected-template-label"><b>{{internationalPayment.templateName}}</b></label>\n' +
    '                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5"\n' +
    '                   ng-click="internationalPayment.removeTemplate()"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-template-filter-selection" ng-class="{\'opened\': internationalPayment.searchTemplateFilterExpanded}">\n' +
    '              <div class="search-template">\n' +
    '                <div class="inner-section left">\n' +
    '                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                </div>\n' +
    '                <div class="inner-section center" style="width: 50%">\n' +
    '                  <input id="searchTemplatesInput" type="text" class="search-input"\n' +
    '                         ng-model="internationalPayment.tmpSearchText.name"\n' +
    '                         ng-change="internationalPayment.searchTemplate(internationalPayment.tmpSearchText.name)"\n' +
    '                         placeholder="{{\'dashboard.searchTemplatesPlaceholder\'| translate}}">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="domp-template-filter">\n' +
    '                <div class="m-b-10">\n' +
    '                  <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfTemplates"></h4>\n' +
    '                  <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                    <a href="" class="list-group-item"  data-ng-repeat="template in internationalPayment.templateList.result| filter:internationalPayment.tmpSearchText"\n' +
    '                       ng-click="internationalPayment.selectTemplate(template.id)">\n' +
    '                      <div class="row m-r-0">\n' +
    '                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 p-r-0 domp-select-label">\n' +
    '                          <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                          <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img"/>\n' +
    '                          <img ng-if="!template.imageId" class="tpl-rounded-img" alt="Ico"/>\n' +
    '                        </div>\n' +
    '                        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label p-t-15"  style="padding-left: 50px !important;">\n' +
    '                          <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                          <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM END-->\n' +
    '          <!-- END FIRST ROW-->\n' +
    '\n' +
    '          <!-- START SECOND BOX-->\n' +
    '          <div class="receiver-section " style="padding: 10px;background-color:#fff;">\n' +
    '            <div class="row">\n' +
    '              <!-- START From Account - Custom Dropdown -->\n' +
    '              <div class="col-md-6">\n' +
    '                <label class="domp-form-label " translate="payments.fromAccount"></label>\n' +
    '                <div class="accounts-dropdown m-b-10">\n' +
    '                  <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                       data-ng-click="internationalPayment.showAccountToDropdown = !internationalPayment.showAccountToDropdown"\n' +
    '                       ng-style="internationalPayment.tempForpObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + internationalPayment.tempForpObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                        {{internationalPayment.tempForpObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                      <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                        <i class="zmdi"\n' +
    '                           ng-class="{\'zmdi-star favorite-account\':internationalPayment.tempForpObj.fromAccountSelect.isFavorite,\n' +
    '                           \'zmdi-star-outline\': !internationalPayment.tempForpObj.fromAccountSelect.isFavorite}"></i>\n' +
    '                      </span>\n' +
    '                    </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{internationalPayment.tempForpObj.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                      {{internationalPayment.tempForpObj.fromAccountSelect.availableBalance| number:2}}\n' +
    '                      {{internationalPayment.tempForpObj.fromAccountSelect.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    <span class="caret-icon">\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <div class="from-accounts-list" ng-show="internationalPayment.showAccountToDropdown"\n' +
    '                       scrollable>\n' +
    '                    <div class="accounts-list-item p-0"\n' +
    '                         data-ng-repeat="item in internationalPayment.accountsFrom"\n' +
    '                         data-ng-click="internationalPayment.setChargeAccount(item); internationalPayment.showAccountToDropdown = !internationalPayment.showAccountToDropdown">\n' +
    '\n' +
    '                      <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                        <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                          <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                          <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite, \'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                        </h4>\n' +
    '                        <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                        <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                          {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                        </p>\n' +
    '                        <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END From Account - CUSTOM DROPDOWN-->\n' +
    '              <!-- START Amount and Date -->\n' +
    '              <div class="col-md-6">\n' +
    '                <!--<div class="row">-->\n' +
    '                <!-- START Amount -->\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="amountInput"\n' +
    '                         translate="internationalPayment.totalAmount">Amount:</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field t-a-r" name="amountInput"\n' +
    '                           id="amountInput"\n' +
    '                           autocomplete="off"\n' +
    '                           placeholder="{{\'eInvoicesModal.amountPlaceholder\'| translate}}"\n' +
    '                           amount-input-mask\n' +
    '                           maxlength="14"\n' +
    '                           max-amount="99999999999.99"\n' +
    '                           ng-model="internationalPayment.tempForpObj.amountInput" required\n' +
    '                           ng-class="{\'domp-error\': internationalPayment.paymentForm.amountInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                           ng-readonly="internationalPayment.disableAllFields && internationalPayment.disableAllFieldsForProcessedPayment">\n' +
    '                    <span class="input-group-btn">\n' +
    '                      <select type="button"\n' +
    '                              class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;"\n' +
    '                              ng-model="internationalPayment.tempForpObj.totalAmountCurrency"\n' +
    '                              ng-change="internationalPayment.checkCountryAndSymbol();"\n' +
    '                              ng-options="item.symbol as item.symbol for item in internationalPayment.currenciesOptions"\n' +
    '                              ng-disabled="internationalPayment.disableAllFields && internationalPayment.disableAllFieldsForProcessedPayment">\n' +
    '                        <!--{{internationalPayment.tempForpObj.fromAccountSelect.currencySymbol}}-->\n' +
    '                        <!--                        <select class="form-control input-field p-l-15 p-r-10"\n' +
    '                                                       >\n' +
    '                                                </select>-->\n' +
    '\n' +
    '                      </select>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.amountInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="internalTransfer.amountInputError">\n' +
    '                  </span>\n' +
    '                  <span class="c-red" ng-show="internationalPayment.paymentForm.amountInput.$error.maxAmount && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="internalTransfer.amountLengthError">\n' +
    '                  </span>\n' +
    '\n' +
    '                  <!--</div>-->\n' +
    '                </div>\n' +
    '                <!-- End Amount-->\n' +
    '                <!-- START Date-->\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="dateInput"\n' +
    '                         translate="internationalPayment.paymentDate">Date:</label>\n' +
    '                    <input type="text" class="form-control input-field" name="dateInput" id="dateInput"\n' +
    '                           uib-datepicker-popup="dd.MM.yyyy"\n' +
    '                           ng-model="internationalPayment.tempForpObj.dueDateInput"\n' +
    '                           readonly>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Date-->\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="receiver-section" style="padding:10px;background-color:#fff;">\n' +
    '            <div class="row">\n' +
    '              <div class="col-lg-6 col-md-6 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="toAccountInput" translate="internationalPayment.toAccountInputLabel_SLO">\n' +
    '                    Account number\n' +
    '                  </label>\n' +
    '                  <input ng-show="!internationalPayment.isFromTemplate" type="text" class="form-control input-field"\n' +
    '                         capitalize\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.allLettersNumbersDashesSlo}}"\n' +
    '                         ui-mask="{{internationalPayment.uiMask}}"\n' +
    '                         ui-mask-placeholder\n' +
    '                         ui-mask-placeholder-char="space"\n' +
    '                         ui-options="internationalPayment.uiMaskOptions"\n' +
    '                         ng-model="internationalPayment.tempForpObj.toAccountInput"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.toAccountInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         name="toAccountInput" id="toAccountInput"\n' +
    '                         ng-trim="false"\n' +
    '                         maxlength="{{domesticPaymentSlo.ibanMaxlength}}"\n' +
    '                         ng-change="internationalPayment.addSpaceForIban(internationalPayment.tempForpObj.toAccountInput); internationalPayment.selectCountry(internationalPayment.tempForpObj.toAccountInput);"\n' +
    '                         ng-blur="\n' +
    '                                 internationalPayment.fillReceiver(internationalPayment.tempForpObj.toAccountInput);\n' +
    '                                 internationalPayment.getBicByIban(internationalPayment.tempForpObj.toAccountInput)"\n' +
    '                         ng-readonly="internationalPayment.disableAllFields"\n' +
    '                          required>\n' +
    '                  <label ng-show="internationalPayment.isFromTemplate" class="domp-form-label-resume">{{internationalPayment.tempForpObj.toAccountInput}}</label>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.toAccountInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="domesticPayment.receiverAccountErrorHR">\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '              <!-- /////////// SELECT CUSTOM ///////////// -->\n' +
    '              <div class="col-sm-6 col-xs-12">\n' +
    '                <div class="form-group clearfix">\n' +
    '                  <label class="domp-form-label" for="toAccountInput" translate="internationalPayment.toPayee2">To payee </label>\n' +
    '                  <label ng-if="internationalPayment.isFromTemplate" class="domp-form-label-resume">\n' +
    '                    {{internationalPayment.tempForpObj.receiversNameInput}}\n' +
    '                  </label>\n' +
    '\n' +
    '                  <div ng-if="!internationalPayment.isFromTemplate" class="col-sm-12 col-xs-12 domp-filter-container"\n' +
    '                       ng-class="{\'domp-error-custom-payee\': internationalPayment.paymentForm.payeeSearchFilter.$invalid && internationalPayment.tempForpObj.formSubmitted}">\n' +
    '                    <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                      <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                      <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" class="search-input"\n' +
    '                             ng-model="internationalPayment.tempForpObj.receiversNameInput"\n' +
    '                             ng-change="internationalPayment.searchPayee()"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.receiverNameInput}}"\n' +
    '                             autocomplete="off"\n' +
    '                             required maxlength="34" ng-maxlength="34"\n' +
    '                             ng-readonly="internationalPayment.disableAllFields">\n' +
    '                    </div>\n' +
    '                    <div ng-hide="internationalPayment.disableAllFields" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                         ng-click="internationalPayment.toggleFilterSelection()">\n' +
    '                      <i class="zmdi zmdi-close domp-close-sign" ng-show="internationalPayment.tempForpObj.receiversNameInput"\n' +
    '                         ng-click="internationalPayment.removeSearch()"></i>\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                         ng-show="!internationalPayment.tempForpObj.receiversNameInput"></i>\n' +
    '                    </div>\n' +
    '                    <div class="domp-filter-selection search-row"\n' +
    '                         ng-class="{\'opened\': internationalPayment.searchFilterExpanded}">\n' +
    '                      <div class="domp-filter-type-selection-wrapper"\n' +
    '                           ng-repeat="payee in internationalPayment.payeeList| filter:internationalPayment.searchPayeeBy"\n' +
    '                           ng-click="internationalPayment.selectPayee(payee.id)">\n' +
    '                        <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                          <i class="zmdi zmdi-account-circle"></i>\n' +
    '                        </div>\n' +
    '                        <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                          <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                          <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                          ng-show="internationalPayment.paymentForm.payeeSearchFilter.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                          translate="domesticPayment.toPayeeInputError">\n' +
    '                    </span>\n' +
    '                    <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                          ng-show="internationalPayment.paymentForm.payeeSearchFilter.$error.maxlength"\n' +
    '                          translate="internationalPayment.maxlength34">\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '              <!--//////////////SELECT CUSTOM END/////////////////////// -->\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-6"><div class="p-l-0">\n' +
    '                    <select class="form-control input-field p-l-15 p-r-10" name="receiversCountry" id="receiversCountry"\n' +
    '                            ng-options="option as option.description | translate for option in internationalPayment.bankCountries"\n' +
    '                            ng-model="internationalPayment.tempForpObj.receiversCountry"\n' +
    '                            ng-class="{\'domp-error-custom-payee\': internationalPayment.tempForpObj.receiversCountry.code == \' \' && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                            ng-required="internationalPayment.tempForpObj.receiversCountry.code == \' \'">\n' +
    '                    </select>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '              <div class="col-md-6">\n' +
    '                <div class="form-group">\n' +
    '                  <!-- <label class="domp-form-label" for="receiversAddressInput"\n' +
    '                         translate="domesticPayment.receiversAddressInputLabel">Receiver\'s address:</label> -->\n' +
    '\n' +
    '                  <!--ng-blur="internationalPayment.replaceUnallowedCharsDPS(\'receiversAddressInput\', internationalPayment.tempForpObj.receiversAddressInput)"-->\n' +
    '                  <input type="text" class="form-control input-field"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.receiverNameInput}}"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.receiversAddressInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         name="receiversAddressInput" id="receiversAddressInput"\n' +
    '                         ng-model="internationalPayment.tempForpObj.receiversAddressInput"\n' +
    '                         maxlength="34" ng-maxlength="34" required\n' +
    '                         ng-readonly="internationalPayment.disableAllFields">\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.receiversAddressInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="domesticPayment.receiverAddressError"></span>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.receiversAddressInput.$error.maxlength"\n' +
    '                        translate="internationalPayment.maxlength34"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '\n' +
    '              <div class="col-md-offset-6 col-lg-6 col-md-6 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <!-- <label class="domp-form-label" for="receiversPostalCodeAndCityInput"\n' +
    '                         translate="domesticPayment.receiversPostalCodeAndCityInputLabel">Receiver\'s postal code and\n' +
    '                    city:</label> -->\n' +
    '                  <!--ng-blur="internationalPayment.replaceUnallowedCharsDPS(\'receiversAddressInput\', internationalPayment.tempForpObj.receiversAddressInput)"-->\n' +
    '                  <input type="text" class="form-control input-field"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.receiverNameInput}}"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.receiversPostalCodeAndCityInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         name="receiversPostalCodeAndCityInput" id="receiversPostalCodeAndCityInput"\n' +
    '                         ng-model="internationalPayment.tempForpObj.receiversPostalCodeAndCityInput"\n' +
    '                         maxlength="34" ng-maxlength="34" required\n' +
    '                         ng-readonly="internationalPayment.disableAllFields">\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.receiversPostalCodeAndCityInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="payments.receiversPostalCodeAndCityInputRequired"></span>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.receiversPostalCodeAndCityInput.$error.maxlength"\n' +
    '                        translate="internationalPayment.maxlength34"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="receiver-section" style="padding: 10px; background-color:#fff;">\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-12 form-group">\n' +
    '                <div class="no-padding-on-phone">\n' +
    '                  <label class="domp-form-label domp-purpose-label" for="paymentPurposeInput"\n' +
    '                         translate="internationalPayment.paymentPurpose">Purpose of payment</label>\n' +
    '                  <div class="p-0">\n' +
    '                    <input type="text" class="form-control input-field"\n' +
    '                           data-ng-model="internationalPayment.tempForpObj.paymentPurposeInput"\n' +
    '                           id="paymentPurposeInput"\n' +
    '                           name="paymentPurposeInput"\n' +
    '                           ng-pattern-restrict="{{internationalPayment.regexPatterns.standardInput}}"\n' +
    '                           ng-class="{\'domp-error\': internationalPayment.paymentForm.paymentPurposeInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                           required\n' +
    '                           maxlength="136"\n' +
    '                           ng-maxlength="136"\n' +
    '                           ng-readonly="internationalPayment.disableAllFields && internationalPayment.disableAllFieldsForProcessedPayment">\n' +
    '\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="internationalPayment.paymentForm.paymentPurposeInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                          translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="internationalPayment.paymentForm.paymentPurposeInput.$error.maxlength"\n' +
    '                          translate="internationalPayment.maxlength34"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- START BIC -->\n' +
    '          <div class="purpose-section" style="padding: 10px">\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-4">\n' +
    '                <div class="form-group clearfix">\n' +
    '                  <label class="domp-form-label" translate="payments.bicNumber_SLO">\n' +
    '                    BIC Address\n' +
    '                  </label>\n' +
    '                  <input type="text" name="bicAddress" class="form-control input-field"\n' +
    '                         ng-if="!internationalPayment.bicCodeDisabled"\n' +
    '                         ng-model="internationalPayment.tempForpObj.beneficiarySWIFTCode"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.onlyNumbersAndLetters}}"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.bicAddress.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         maxlength="11"\n' +
    '                         ng-change="internationalPayment.checkToAccountInputLength();"\n' +
    '                         capitalize\n' +
    '                         ng-readonly="internationalPayment.disableAllFields">\n' +
    '                  <label ng-if="internationalPayment.bicCodeDisabled" class="domp-form-label-resume">\n' +
    '                    {{internationalPayment.tempForpObj.beneficiarySWIFTCode}}\n' +
    '                  </label>\n' +
    '\n' +
    '                  <span class="c-red" translate="payments.bicNumberMaxLength"\n' +
    '                        ng-show="internationalPayment.paymentForm.bicAddress.$error.properLength && internationalPayment.tempForpObj.formSubmitted">\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-md-4">\n' +
    '                <div class="form-group clearfix">\n' +
    '                  <label class="domp-form-label" translate="payments.bicCountry_SLO">\n' +
    '                    Country\n' +
    '                  </label>\n' +
    '                  <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 domp-filter-container"\n' +
    '                       ng-class="{\'domp-error-custom-payee\': internationalPayment.paymentForm.countrySearchFilter.$invalid && internationalPayment.tempForpObj.formSubmitted}">\n' +
    '                    <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                      <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 inner-section input-div searchrow">\n' +
    '                      <input type="text" class="search-input" name="countrySearchFilter"\n' +
    '                             ng-model="internationalPayment.countrySearchFilter"\n' +
    '                             ng-change="internationalPayment.countrySearchFilterExpanded = true;"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.onlyNumbersAndLettersWithSuskavci}}"\n' +
    '                             required\n' +
    '                             autocomplete="off"\n' +
    '                             ng-readonly="internationalPayment.disableAllFields">\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div ng-hide="internationalPayment.disableAllFields" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                         ng-click="internationalPayment.countrySearchFilterExpanded = !internationalPayment.countrySearchFilterExpanded">\n' +
    '                      <i class="zmdi zmdi-close domp-close-sign"\n' +
    '                         ng-show="internationalPayment.countrySearchFilter"\n' +
    '                         ng-click="internationalPayment.removeSelectedCountry()"></i>\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                         ng-show="!internationalPayment.countrySearchFilter"></i>\n' +
    '                    </div>\n' +
    '                    <!--Dropdown menu -->\n' +
    '                    <div class="domp-filter-selection search-row"\n' +
    '                         ng-class="{\'opened\': internationalPayment.countrySearchFilterExpanded}">\n' +
    '                      <div class="domp-filter-type-selection-wrapper"\n' +
    '                           ng-repeat="country in internationalPayment.countriesOptions| filter: internationalPayment.countrySearchFilter"\n' +
    '                           ng-click="internationalPayment.onCountrySelect(country)">\n' +
    '                        <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                          <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '                        </div>\n' +
    '                        <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                          <p class="domp-list-name m-0">{{country.code}} {{country.description}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="c-red"\n' +
    '                       ng-show="internationalPayment.paymentForm.countrySearchFilter.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                       translate="payments.bicCountryRequired"></div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-8 col-xs-12 col-sm-12">\n' +
    '                <div class="form-group">\n' +
    '                  <!-- Required if Bic number is empty -->\n' +
    '                  <label class="domp-form-label" translate="payments.bicBankName">Bank Name</label>\n' +
    '                  <!--<input type="text" class="form-control input-field"-->\n' +
    '                  <!--name="bankNameInput"-->\n' +
    '                  <!--ng-model="internationalPayment.tempForpObj.bankNameInput"-->\n' +
    '                  <!--ng-required="!internationalPayment.bicCodeSearchFilter">     -->\n' +
    '                  <input type="text" class="form-control input-field"\n' +
    '                         name="bankNameInput" maxlength="34"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.bankNameInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.receiverNameInput}}"\n' +
    '                         replace-specific-chars\n' +
    '                         ng-model="internationalPayment.tempForpObj.bankNameInput"\n' +
    '                         autocomplete="off"\n' +
    '                         required\n' +
    '                         ng-readonly="internationalPayment.disableAllFields">\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.bankNameInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="payments.bicBankNameRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!--              <div class="col-md-4">\n' +
    '                              <div class="form-group">\n' +
    '                                <label class="domp-form-label" translate="payments.bicRecipientStatus">Primatelj (osoba)</label>\n' +
    '                                <select class="form-control input-field"\n' +
    '                                        ng-model="internationalPayment.tempForpObj.recipientStatusRadiobutton.type">\n' +
    '                                  <option value=2>{{"payments.bicRecipientStatusOptionPhysical"| translate}}</option>\n' +
    '                                  <option value=1>{{"payments.bicRecipientStatusOptionLegal"| translate}}</option>\n' +
    '                                </select>\n' +
    '                              </div>\n' +
    '                            </div>-->\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-4 m-t-15">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="payments.bicAddress">Bank Address</label>\n' +
    '                  <input name="bankAddressInput" type="text" class="form-control input-field"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.receiverNameInput}}"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.bankAddressInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         ng-model="internationalPayment.tempForpObj.bankAddressInput"\n' +
    '                         replace-specific-chars maxlength="34"\n' +
    '                         autocomplete="off"\n' +
    '                         required\n' +
    '                         ng-readonly="internationalPayment.disableAllFields">\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.bankAddressInput.$invalid && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="payments.bankAddressInputRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-md-4 m-t-15">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="payments.bicCity">Bank City</label>\n' +
    '                  <input type="text" class="form-control input-field" name="bicCity"\n' +
    '                         ng-model="internationalPayment.tempForpObj.bankCityInput"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.receiverNameInput}}"\n' +
    '                         replace-specific-chars maxlength="34"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.bicCity.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         required\n' +
    '                         ng-readonly="internationalPayment.disableAllFields">\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.bicCity.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="payments.bicCityRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-md-4">\n' +
    '\n' +
    '                <div class="form-group m-t-15">\n' +
    '                  <label class="domp-form-label" translate="payments.bicBankCharges">Troškovna opcija:</label>\n' +
    '                  <select class="form-control input-field"\n' +
    '                          ng-model="internationalPayment.tempForpObj.bankChargesRadiobutton.type"\n' +
    '                          ng-disabled="(internationalPayment.EUCountrySelected && internationalPayment.EUSymbolSelected) || internationalPayment.disableAllFields">\n' +
    '                    <option value=0>SHA</option>\n' +
    '                    <option value=1>OUR</option>\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- END BIC -->\n' +
    '\n' +
    '          <section class="row p-t-15">\n' +
    '          <div class="col-xs-12 col-sm-3 p-l-30 pull-right" style="line-height: 39px; text-decoration: underline">\n' +
    '            <a class="pull-right" ng-href="{{internationalPayment.defaultData.BankChargesLink}}" target="_blank" translate="domesticPayment.checkBankCharges">\n' +
    '            </a>\n' +
    '          </div>\n' +
    '        </section>\n' +
    '\n' +
    '          <div class="intp-form-container m-b-30">\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-6 t-a-l">\n' +
    '                <button  class="btn btn-primary" translate="payments.cancel"\n' +
    '                        type="button"\n' +
    '                        data-ui-sref="payments.paymentsOverview">\n' +
    '                </button>\n' +
    '              </div>\n' +
    '              <div class="col-xs-6 t-a-r">\n' +
    '                <button\n' +
    '                        ng-if="!internationalPayment.tempForpObj.bankCountrySelect.amlControl"\n' +
    '                        class="btn btn-default domp-review-and-submit-btn"\n' +
    '                        translate="domesticPayment.confirmBtnSlo"\n' +
    '                        ng-disabled="internationalPayment.nextButtonPressed || internationalPayment.secondValidateInProgress"\n' +
    '                        data-ng-click="internationalPayment.submitInternationalPayment($event);">\n' +
    '                </button>\n' +
    '                <button\n' +
    '                        ng-if="internationalPayment.tempForpObj.bankCountrySelect.amlControl"\n' +
    '                        class="btn btn-default domp-review-and-submit-btn"\n' +
    '                        translate="domesticPayment.confirmBtnSlo"\n' +
    '                        ng-disabled="internationalPayment.nextButtonPressed || internationalPayment.secondValidateInProgress"\n' +
    '                        data-ng-click="internationalPayment.submitInternationalPayment($event);">\n' +
    '                </button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '        <!-- END NEW SECOND BOX -->\n' +
    '\n' +
    '      </div>\n' +
    '    </span>\n' +
    '    <!-- START STEP NUMBER 2 -->\n' +
    '    <div ng-if="internationalPayment.steps.step2">\n' +
    '      <div data-ng-include="\'payments/international-payment-resume.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '    <!-- END STEP NUMBER 2-->\n' +
    '    <!-- START STEP NUMBER 3 -->\n' +
    '    <div ng-if="internationalPayment.steps.step3">\n' +
    '      <payment-final-step payment="internationalPayment.paymentResponse" is-modal="false"></payment-final-step>\n' +
    '    </div>\n' +
    '    <!-- END STEP NUMBER 3 -->\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/international-payment-resume.tpl.html',
    '<!--------------------------- CRO --------------------------->\n' +
    '<div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" class="intp-form-container bottom-border">\n' +
    '  <!-- START NEW -->\n' +
    '  <div class="receiver-section p-10" >\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.fromAccount">\n' +
    '            From account\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.fromAccountNumber}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.fromAccountNumber}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.totalAmount">\n' +
    '            Total amount and valute\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.amount| number:2}} {{internationalPayment.paymentResponse.currencySymbol}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.amount}} {{internationalPayment.paymentResponse.currencySymbol}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group" ng-show="false">\n' +
    '          <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '            <uib-accordion-group>\n' +
    '              <uib-accordion-heading>\n' +
    '                <div class="sepa-heading input-field" ng-click="internationalPayment.clearSepaPayer();">\n' +
    '                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                    <label class="domp-form-label-review-sepa"\n' +
    '                           translate="internationalPayment.sepaDebitorLabel">\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                      class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                </div>\n' +
    '              </uib-accordion-heading>\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     ng-model="internationalPayment.tempForpObj.payersSepaInput1">\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     ng-model="internationalPayment.tempForpObj.payersSepaInput2">\n' +
    '            </uib-accordion-group>\n' +
    '          </uib-accordion>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.paymentDate">\n' +
    '            Payment date\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.dueDate| date: \'shortDate\'}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.dueDate | date: \'shortDate\'}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="receiver-section p-10" >\n' +
    '    <div class="row m-t-10">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '          <label ng-switch-default class="domp-form-label-review" translate="internationalPayment.toAccountInputLabel">\n' +
    '          </label>\n' +
    '          <label ng-switch-when="sl" class="domp-form-label-review" translate="internationalPayment.toAccountInputLabel_SLO">\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.toAccountNumber}}\n' +
    '          </label>\n' +
    '          <label ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.receiverCountry}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.toAccountNumber}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.toPayee2">\n' +
    '            To payee\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.receiverName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.receiverName}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.receiverName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.receiverName}}\n' +
    '          </label>\n' +
    '\n' +
    '          <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{internationalPayment.paymentResponse.foreignPayment.receiverAddress1}}\n' +
    '            </label>\n' +
    '\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{internationalPayment.paymentResponse.foreignPayment.receiverCity}}\n' +
    '            </label>\n' +
    '          </span>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.receiverName}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row m-t-10" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group" ng-show="false">\n' +
    '          <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '            <uib-accordion-group>\n' +
    '              <uib-accordion-heading>\n' +
    '                <div class="sepa-heading input-field" ng-click="internationalPayment.clearSepaPayer();">\n' +
    '                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                    <label class="domp-form-label-review-sepa"\n' +
    '                           translate="internationalPayment.sepaDebitorLabel">\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                      class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                </div>\n' +
    '              </uib-accordion-heading>\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     ng-model="internationalPayment.tempForpObj.payersSepaInput1">\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     ng-model="internationalPayment.tempForpObj.payersSepaInput2">\n' +
    '            </uib-accordion-group>\n' +
    '          </uib-accordion>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label ng-if="internationalPayment.paymentResponse.receiverAddress1" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.receiverAddress1}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.receiverAddress1" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.receiverAddress1}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row m-t-10" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <div class="col-md-6 col-md-offset-6">\n' +
    '        <div class="form-group">\n' +
    '          <label ng-if="internationalPayment.paymentResponse.receiverCity" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.receiverCity}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.receiverCity" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.receiverCity}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="receiver-section p-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.purposeCode">\n' +
    '            Purpose code\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.purposeCodeValue}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.purposeCodeValue}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.paymentMode">\n' +
    '            Payment mode\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.modalityCode}}\n' +
    '          </label>\n' +
    '          <!--<select class="form-control input-field p-l-15 p-r-10" style="cursor: auto"-->\n' +
    '          <!--ng-options="item.id as (item.id + \' - \' + item.description) for item in internationalPayment.paymentModeOptions"-->\n' +
    '          <!--ng-model="internationalPayment.paymentResponse.modalityCode"-->\n' +
    '          <!--disabled>-->\n' +
    '          <!--</select>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.paymentPurpose">\n' +
    '            Payment purpose\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.purpose}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.purpose}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="receiver-section p-10" >\n' +
    '    <div class="row m-t-10" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.paymentPurpose">\n' +
    '            Payment purpose\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.purpose}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row m-t-10" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <div class="col-md-4">\n' +
    '        <label class="domp-form-label-review" translate="payments.bicNumber_SLO"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{internationalPayment.paymentResponse.foreignPayment.beneficiarySWIFTCode}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="col-md-4">\n' +
    '        <label class="domp-form-label-review" translate="payments.bicCountry"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCountryCode}} - {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCountry}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row m-t-10" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicAddress">\n' +
    '            BIC Address\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiarySWIFTCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiarySWIFTCode}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiarySWIFTCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiarySWIFTCode}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.beneficiarySWIFTCode}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicCountry">\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankCountryCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankCountryCode}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCountryCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCountryCode}}\n' +
    '          </label>\n' +
    '          <!--<select class="form-control input-field p-l-15 p-r-10" style="cursor: auto"-->\n' +
    '          <!--ng-options="country.code as (country.code + \'-\' + country.description) for country in internationalPayment.countriesOptions"-->\n' +
    '          <!--ng-model="internationalPayment.paymentResponse.beneficiaryBankCountryCode"-->\n' +
    '          <!--disabled>-->\n' +
    '          <!--</select>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4" >\n' +
    '        <label class="domp-form-label-review" translate="internationalPayment.chargeAccount">Charge account</label>\n' +
    '        <label ng-if="internationalPayment.paymentResponse.chargeAccount" class="domp-form-label-resume">\n' +
    '          {{internationalPayment.paymentResponse.chargeAccount}}\n' +
    '        </label>\n' +
    '        <label ng-if="internationalPayment.paymentResponse.foreignPayment.chargeAccount" class="domp-form-label-resume">\n' +
    '          {{internationalPayment.paymentResponse.foreignPayment.chargeAccount}}\n' +
    '        </label>\n' +
    '        <!--<input type="text" class="form-control input-field"-->\n' +
    '        <!--name="chargeAccount"-->\n' +
    '        <!--data-ng-model="internationalPayment.paymentResponse.chargeAccount"-->\n' +
    '        <!--readonly>-->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row m-t-10">\n' +
    '      <div class="col-xs-8">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicBankName">Bank Name</label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankName}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankName}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.beneficiaryBankName}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4" >\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicRecipientStatus">Receiver (person)</label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            <div ng-switch="internationalPayment.paymentResponse.payeeLegalForm">\n' +
    '              <div ng-switch-when="1">\n' +
    '                {{"payments.bicRecipientStatusOptionLegal"| translate}}\n' +
    '              </div>\n' +
    '              <div ng-switch-when="2">\n' +
    '                {{"payments.bicRecipientStatusOptionPhysical"| translate}}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row m-t-10">\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '           <label ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="domp-form-label-review" translate="payments.bicAddress">BIC Address</label>\n' +
    '          <label class="domp-form-label-review" > </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankAddress" class="domp-form-label-resume m-t-5">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankAddress}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankAddress" class="domp-form-label-resume m-t-5">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankAddress}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '           <label ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="domp-form-label-review" translate="payments.bicCity">BIC City</label>\n' +
    '          <label class="domp-form-label-review" > </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankCity" class="domp-form-label-resume m-t-5">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankCity}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCity" class="domp-form-label-resume m-t-5">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCity}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicBankCharges">Troškovna opcija:</label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            <div ng-switch="internationalPayment.paymentResponse.paymentCharges">\n' +
    '              <div ng-switch-when="3">\n' +
    '                SHA\n' +
    '              </div>\n' +
    '              <div ng-switch-when="1">\n' +
    '                OUR\n' +
    '              </div>\n' +
    '              <div ng-switch-when="2">\n' +
    '                BEN\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <a ng-href="{{APP_GLOBAL_SETTINGS.defaultData.BankChargesLink}}" target="_blank" translate="domesticPayment.checkBankCharges" class="domp-form-label-resume"></a>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="!internationalPayment.paymentResponse.beneficiarySWIFTCode && !internationalPayment.paymentResponse.foreignPayment.beneficiarySWIFTCode" class="msg-ctn m-t-10 p-10" translate="internationalPayment.noBicBankInfo"></div>\n' +
    '\n' +
    '</div>\n' +
    '<!-- START: Buttons -->\n' +
    '<div class="domp-footer-wrapper" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-10 form-group">\n' +
    '      <button class="btn btn-primary " translate="currencyConversion.back"\n' +
    '              data-ng-click="internationalPayment.newPayment();">\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary-warning"\n' +
    '              translate="domesticPayment.delete"\n' +
    '              ng-click="internationalPayment.deletePayment();">\n' +
    '        Delete\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary "\n' +
    '              translate="domesticPayment.edit"\n' +
    '              ng-click="internationalPayment.editPayment();">\n' +
    '        Edit\n' +
    '      </button>\n' +
    '      <!--      <button class="btn btn-primary app-btn-blue domp-resume-btn pull-right"\n' +
    '                    ng-click="internationalPayment.signPayment();">\n' +
    '              Sign\n' +
    '            </button>-->\n' +
    '    </div>\n' +
    '    <div class="col-md-2 form-group">\n' +
    '      <button class="btn btn-default"\n' +
    '              translate="domesticPayment.sign"\n' +
    '              data-ui-sref="payments.sign({paymentId: internationalPayment.paymentResponse.id, type: \'international\'})">\n' +
    '        Sign\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<!-- END: Buttons-->\n' +
    '<!--------------------------- END CRO --------------------------->\n' +
    '\n' +
    '\n' +
    '<!--------------------------- SLO --------------------------->\n' +
    '<div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" class="intp-form-container bottom-border">\n' +
    '  <!-- START NEW -->\n' +
    '  <div class="receiver-section p-20" >\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.fromAccount">\n' +
    '            From account\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.fromAccountNumber}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.totalAmount">\n' +
    '            Total amount and valute\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.amount| number:2}} {{internationalPayment.paymentResponse.currencySymbol}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="form-group" >\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.paymentChargesAmount">\n' +
    '            Payment charges amount\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            <!--{{internationalPayment.paymentResponse.paymentChargesAmount | currency:""}} {{internationalPayment.paymentResponse.currencySymbol}}-->\n' +
    '            {{internationalPayment.paymentResponse.paymentChargesAmount | currency:""}} {{APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group" ng-show="false">\n' +
    '          <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '            <uib-accordion-group>\n' +
    '              <uib-accordion-heading>\n' +
    '                <div class="sepa-heading input-field" ng-click="internationalPayment.clearSepaPayer();">\n' +
    '                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                    <label class="domp-form-label-review-sepa"\n' +
    '                           translate="internationalPayment.sepaDebitorLabel">\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                    class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                </div>\n' +
    '              </uib-accordion-heading>\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     ng-model="internationalPayment.tempForpObj.payersSepaInput1">\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     ng-model="internationalPayment.tempForpObj.payersSepaInput2">\n' +
    '            </uib-accordion-group>\n' +
    '          </uib-accordion>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.paymentDate">\n' +
    '            Payment date\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.dueDate| date: \'shortDate\'}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.dueDate | date: \'shortDate\'}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="receiver-section p-20" >\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.toAccountInputLabel">\n' +
    '            Account number\n' +
    '          </label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.toAccountNumber}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.receiverCountryCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.tempForpObj.receiversCountry.description}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.toPayee2">\n' +
    '            To payee\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.receiverName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.receiverName}}\n' +
    '          </label>\n' +
    '\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.receiverName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.receiverName}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.receiverAddress1" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.receiverAddress1}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.receiverCity" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.receiverCity}}\n' +
    '          </label>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="receiver-section p-20" >\n' +
    '    <div ng-if="internationalPayment.paymentResponse.purpose" class="row p-b-20">\n' +
    '      <div class="col-xs-12">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="internationalPayment.paymentPurpose">Purpose of payment</label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.purpose" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.purpose}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicNumber_SLO">\n' +
    '            Swift number\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiarySWIFTCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiarySWIFTCode}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiarySWIFTCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiarySWIFTCode}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicCountry_SLO">\n' +
    '            Country\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankCountryCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankCountryCode}} {{internationalPayment.paymentResponse.beneficiaryBankCountry}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCountryCode" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCountryCode}} {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCountry}}\n' +
    '          </label>\n' +
    '          <!--<select class="form-control input-field p-l-15 p-r-10" style="cursor: auto"-->\n' +
    '          <!--ng-options="country.code as (country.code + \'-\' + country.description) for country in internationalPayment.countriesOptions"-->\n' +
    '          <!--ng-model="internationalPayment.paymentResponse.beneficiaryBankCountryCode"-->\n' +
    '          <!--disabled>-->\n' +
    '          <!--</select>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--<div class="col-md-4" >-->\n' +
    '        <!--<label class="domp-form-label-review" translate="internationalPayment.chargeAccount">Charge account</label>-->\n' +
    '        <!--<label ng-if="internationalPayment.paymentResponse.chargeAccount" class="domp-form-label-resume">-->\n' +
    '          <!--{{internationalPayment.paymentResponse.chargeAccount}}-->\n' +
    '        <!--</label>-->\n' +
    '        <!--<label ng-if="internationalPayment.paymentResponse.foreignPayment.chargeAccount" class="domp-form-label-resume">-->\n' +
    '          <!--{{internationalPayment.paymentResponse.foreignPayment.chargeAccount}}-->\n' +
    '        <!--</label>-->\n' +
    '        <!--&lt;!&ndash;<input type="text" class="form-control input-field"&ndash;&gt;-->\n' +
    '        <!--&lt;!&ndash;name="chargeAccount"&ndash;&gt;-->\n' +
    '        <!--&lt;!&ndash;data-ng-model="internationalPayment.paymentResponse.chargeAccount"&ndash;&gt;-->\n' +
    '        <!--&lt;!&ndash;readonly>&ndash;&gt;-->\n' +
    '      <!--</div>-->\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-8">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicBankName">Bank Name</label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankName}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankName" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankName}}\n' +
    '          </label>\n' +
    '          <!--<input type="text" class="form-control input-field"-->\n' +
    '          <!--value="{{internationalPayment.paymentResponse.beneficiaryBankName}}"-->\n' +
    '          <!--readonly>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row p-t-10 p-b-10">\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicAddress">Bank Address</label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankAddress" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankAddress}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankAddress" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankAddress}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicCity">Bank City</label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.beneficiaryBankCity" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.beneficiaryBankCity}}\n' +
    '          </label>\n' +
    '          <label ng-if="internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCity" class="domp-form-label-resume">\n' +
    '            {{internationalPayment.paymentResponse.foreignPayment.beneficiaryBankCity}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="payments.bicBankCharges">Troškovna opcija:</label>\n' +
    '          <label class="domp-form-label-resume">\n' +
    '            <div ng-switch="internationalPayment.paymentResponse.foreignPayment.paymentCharges">\n' +
    '              <div ng-switch-when="0">\n' +
    '                SHA\n' +
    '              </div>\n' +
    '              <div ng-switch-when="1">\n' +
    '                OUR\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <a ng-href="{{APP_GLOBAL_SETTINGS.defaultData.BankChargesLink}}" target="_blank" translate="domesticPayment.checkBankCharges" class="domp-form-label-resume">\n' +
    '            </a>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!--<div ng-if="!internationalPayment.paymentResponse.beneficiarySWIFTCode && !internationalPayment.paymentResponse.foreignPayment.beneficiarySWIFTCode"-->\n' +
    '       <!--class="msg-ctn m-t-10 p-20"-->\n' +
    '       <!--translate="internationalPayment.noBicBankInfo"></div>-->\n' +
    '\n' +
    '</div>\n' +
    '<!-- START: Buttons -->\n' +
    '<div class="p-20 clearfix"  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'">\n' +
    '  <section class="row">\n' +
    '    <div class="col-xs-6 col-sm-2" >\n' +
    '      <button class="btn btn-primary " ng-click="internationalPayment.editPayment();" translate="domesticPayment.back">\n' +
    '        Edit\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="col-xs-6 col-sm-2" ng-if="internationalPayment.actionLinks.delete">\n' +
    '      <button class="btn btn-primary-warning"ng-click="internationalPayment.deletePayment();"\n' +
    '              translate="domesticPayment.delete">Delete\n' +
    '      </button>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-2 pull-right">\n' +
    '      <button class="btn btn-default pull-right"\n' +
    '              translate="domesticPayment.confirmBtn"\n' +
    '              ng-disabled="internationalPayment.signPaymentInProgress"\n' +
    '              ng-click="internationalPayment.signOrFinishPayment()"\n' +
    '              >\n' +
    '        Sign\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </section>\n' +
    '</div>\n' +
    '<!-- END: Buttons-->\n' +
    '<!--------------------------- END SLO --------------------------->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/international-payment-cro.tpl.html',
    '<section ng-controller="InternationalPaymentCroCtrl as internationalPayment">\n' +
    '  <div>\n' +
    '    <span ng-if="internationalPayment.steps.step1">\n' +
    '      <!-- START Title -->\n' +
    '      <div class="domp-header-wrapper col-sm-12 p-0">\n' +
    '        <div class="domp-header-row">\n' +
    '          <h2 class="intp-title f-28" translate="internationalPayment.international"></h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Title-->\n' +
    '      <div class="domp-select-section col-sm-12 p-0">\n' +
    '        <!-- ADD SELECT FROM TEMPLATE HERE ! -->\n' +
    '        <!-- FIRST BOX -->\n' +
    '        <form name="internationalPayment.paymentForm" novalidate>\n' +
    '\n' +
    '          <!--SELECT TEMPLATE CUSTOM -->\n' +
    '\n' +
    '          <div class="domp-template-filter-container">\n' +
    '            <div class="domp-select-template" ng-click="internationalPayment.toggleTemplateFilterSelection()"\n' +
    '                 ng-show="internationalPayment.templateName == \'\'">\n' +
    '              <div class="select-template label-select">\n' +
    '                <label class="p-t-10 f-18 p-t-5"\n' +
    '                       translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-selected-template" ng-show="internationalPayment.templateName != \'\'">\n' +
    '              <div class="select-template label-template-selected p-l-10 p-t-5"\n' +
    '                   ng-show="internationalPayment.templateName != \'\'">\n' +
    '                <i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>\n' +
    '                <label class="p-l-10 selected-template-label"><b>{{internationalPayment.templateName}}</b></label>\n' +
    '                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5"\n' +
    '                   ng-click="internationalPayment.removeTemplate()"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-template-filter-selection"\n' +
    '                 ng-class="{\'opened\': internationalPayment.searchTemplateFilterExpanded}">\n' +
    '              <div class="search-template">\n' +
    '                <div class="inner-section left">\n' +
    '                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                </div>\n' +
    '                <div class="inner-section center" style="width: 50%">\n' +
    '                  <input id="searchTemplatesInput" type="text" class="search-input"\n' +
    '                         ng-model="internationalPayment.tmpSearchText.name"\n' +
    '                         ng-change="internationalPayment.searchTemplate(internationalPayment.tmpSearchText.name)"\n' +
    '                         placeholder="{{\'dashboard.searchTemplatesPlaceholder\'| translate}}">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="domp-template-filter">\n' +
    '                <div class="m-b-10">\n' +
    '                  <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfTemplates"></h4>\n' +
    '                  <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                    <a href="" class="list-group-item"\n' +
    '                       data-ng-repeat="template in internationalPayment.templateList.result| filter:internationalPayment.tmpSearchText"\n' +
    '                       ng-click="internationalPayment.selectTemplate(template.id)">\n' +
    '                      <div class="row m-r-0">\n' +
    '                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 p-r-0 domp-select-label"><i\n' +
    '                          class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i></div>\n' +
    '                        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label">\n' +
    '                          <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                          <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM END-->\n' +
    '          <!-- END FIRST ROW-->\n' +
    '\n' +
    '          <!-- START SECOND BOX-->\n' +
    '          <div class="receiver-section " style="padding: 10px;background-color:#fff;">\n' +
    '            <div class="row">\n' +
    '              <!-- START From Account - Custom Dropdown -->\n' +
    '              <div class="col-md-6">\n' +
    '                <label class="domp-form-label " translate="payments.fromAccount"></label>\n' +
    '                <div class="accounts-dropdown m-b-10">\n' +
    '                  <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                       data-ng-click="internationalPayment.showAccountToDropdown = !internationalPayment.showAccountToDropdown"\n' +
    '                       ng-style="internationalPayment.tempForpObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + internationalPayment.tempForpObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                        {{internationalPayment.tempForpObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                      <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                        <i class="zmdi"\n' +
    '                           ng-class="{\'zmdi-star favorite-account\':account.isFavorite, \'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                      </span>\n' +
    '                    </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{internationalPayment.tempForpObj.fromAccountSelect.iban}}</p>\n' +
    '                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                      {{internationalPayment.tempForpObj.fromAccountSelect.availableBalance| number:2}}\n' +
    '                      {{internationalPayment.tempForpObj.fromAccountSelect.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    <span class="caret-icon">\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <div class="from-accounts-list" ng-show="internationalPayment.showAccountToDropdown"\n' +
    '                       scrollable>\n' +
    '                    <div class="accounts-list-item p-0"\n' +
    '                         data-ng-repeat="item in internationalPayment.accountsFrom"\n' +
    '                         data-ng-click="internationalPayment.setChargeAccount(item); internationalPayment.showAccountToDropdown = !internationalPayment.showAccountToDropdown">\n' +
    '\n' +
    '                      <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                           ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                        <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                          <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                          <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                              ng-class="{\'zmdi-star favorite-account\':item.isFavorite, \'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                        </h4>\n' +
    '                        <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                        <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                          {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                        </p>\n' +
    '                        <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END From Account - CUSTOM DROPDOWN-->\n' +
    '              <!-- START Amount and Date -->\n' +
    '              <div class="col-md-6">\n' +
    '                <!--<div class="row">-->\n' +
    '                <!-- START Amount -->\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="amountInput"\n' +
    '                         translate="internationalPayment.totalAmount">Amount:</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field t-a-r" name="amountInput"\n' +
    '                           id="amountInput"\n' +
    '                           autocomplete="off"\n' +
    '                           placeholder="{{\'eInvoicesModal.amountPlaceholder\'| translate}}"\n' +
    '                           amount-input-mask\n' +
    '                           maxlength="12"\n' +
    '                           ng-model="internationalPayment.tempForpObj.amountInput" required\n' +
    '                           ng-class="{\'domp-error\': internationalPayment.paymentForm.amountInput.$invalid && internationalPayment.tempForpObj.formSubmitted}">\n' +
    '                    <span class="input-group-btn">\n' +
    '                      <button type="button"\n' +
    '                              class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                              style="border:1px solid #062a42;">\n' +
    '                        {{internationalPayment.tempForpObj.fromAccountSelect.currencySymbol}}\n' +
    '                      </button>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.amountInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="internalTransfer.amountInputError">\n' +
    '                  </span>\n' +
    '                  <!--</div>-->\n' +
    '                </div>\n' +
    '                <!-- End Amount-->\n' +
    '                <!-- START Date-->\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="dateInput"\n' +
    '                         translate="internationalPayment.paymentDate">Date:</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field" name="dateInput" id="dateInput"\n' +
    '                           uib-datepicker-popup="shortDate" show-weeks="false"\n' +
    '                           ng-model="internationalPayment.tempForpObj.dueDateInput"\n' +
    '                           show-weeks="false" is-open="internationalPayment.datePickerOpened"\n' +
    '                           datepicker-options="internationalPayment.dateOptions"\n' +
    '                           date-disabled="internationalPayment.disabled(date, mode)" readonly>\n' +
    '                    <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="input-group-btn">\n' +
    '                      <button ng-switch-default data-ng-click="internationalPayment.openDatePicker()" type="button"\n' +
    '                              class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                              style="border:1px solid #062a42;">\n' +
    '                        <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                      </button>\n' +
    '                      <button ng-switch-when="sl" class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                              style="border:1px solid #062a42;">\n' +
    '                        <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                      </button>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Date-->\n' +
    '            </div>\n' +
    '\n' +
    '            <!-- END Amount and Date -->\n' +
    '            <!-- START  Real Debitor -->\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                    <uib-accordion-group>\n' +
    '                      <uib-accordion-heading>\n' +
    '                        <div class="sepa-heading input-field" ng-click="internationalPayment.clearSepaPayer();">\n' +
    '                          <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                            <label class="domp-form-label-sepa"\n' +
    '                                   translate="internationalPayment.sepaDebitorLabel">\n' +
    '                            </label>\n' +
    '                          </div>\n' +
    '                          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                            class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                        </div>\n' +
    '                      </uib-accordion-heading>\n' +
    '                      <input type="text" class="form-control input-field"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                             ng-model="internationalPayment.tempForpObj.payersSepaInput1" style="margin-bottom:10px;">\n' +
    '                      <input type="text" class="form-control input-field"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                             ng-model="internationalPayment.tempForpObj.payersSepaInput2">\n' +
    '                    </uib-accordion-group>\n' +
    '                  </uib-accordion>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END  Real Debitor -->\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="receiver-section" style="padding:10px;background-color:#fff;">\n' +
    '            <div class="row">\n' +
    '              <div class="col-lg-6 col-md-6 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="toAccountInput"\n' +
    '                         translate="internationalPayment.toAccountInputLabel">\n' +
    '                    Account number\n' +
    '                  </label>\n' +
    '                  <!--<input type="text" class="form-control input-field"-->\n' +
    '                  <!--capitalize-->\n' +
    '                  <!--ui-mask="AA99 9999 9999 9999 9999 9999 9999 9999 99" ui-mask-placeholder-->\n' +
    '                  <!--ui-mask-placeholder-char="_"-->\n' +
    '                  <!--ui-options="internationalPayment.uiMaskOptions"-->\n' +
    '                  <!--ng-model="internationalPayment.tempForpObj.toAccountInput"-->\n' +
    '                  <!--ng-change="internationalPayment.paymentForm.toAccountInput.$invalid = (internationalPayment.tempForpObj.toAccountInput.length) ? false : true"-->\n' +
    '                  <!--ng-class="{\'domp-error\': internationalPayment.paymentForm.toAccountInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"-->\n' +
    '                  <!--name="toAccountInput" id="toAccountInput"-->\n' +
    '                  <!--required-->\n' +
    '                  <!--ng-blur="-->\n' +
    '                  <!--internationalPayment.fillReceiver(internationalPayment.tempForpObj.toAccountInput);-->\n' +
    '                  <!--internationalPayment.getBicByIban(internationalPayment.tempForpObj.toAccountInput)"> -->\n' +
    '                  <input type="text" class="form-control input-field"\n' +
    '                         capitalize\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.allLettersNumbersSpacesIntlCro}}"\n' +
    '                         ui-options="internationalPayment.uiMaskOptions"\n' +
    '                         ng-model="internationalPayment.tempForpObj.toAccountInput"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.toAccountInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         name="toAccountInput" id="toAccountInput"\n' +
    '                         ng-trim="false"\n' +
    '                         ng-change="internationalPayment.addSpaceForIban(internationalPayment.tempForpObj.toAccountInput)"\n' +
    '                         ng-blur="\n' +
    '                             internationalPayment.fillReceiver(internationalPayment.tempForpObj.toAccountInput);\n' +
    '                             internationalPayment.getBicByIban(internationalPayment.tempForpObj.toAccountInput)">\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.toAccountInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="domesticPayment.receiverAccountErrorHR">\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- /////////// SELECT CUSTOM ///////////// -->\n' +
    '              <div class="col-sm-6 col-xs-12">\n' +
    '                <div class="form-group clearfix">\n' +
    '                  <label class="domp-form-label" for="toAccountInput"\n' +
    '                         translate="internationalPayment.toPayee2">To payee </label>\n' +
    '                  <div class="col-sm-12 col-xs-12 domp-filter-container"\n' +
    '                       ng-class="{\'domp-error-custom-payee\': internationalPayment.paymentForm.payeeSearchFilter.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                       style="margin-bottom:16px;">\n' +
    '                    <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                      <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                      <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" class="search-input"\n' +
    '                             ng-model="internationalPayment.tempForpObj.receiversNameInput"\n' +
    '                             ng-change="internationalPayment.searchPayee()"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                             autocomplete="off"\n' +
    '                             required maxlength="70" ng-maxlength="70">\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                         ng-click="internationalPayment.toggleFilterSelection()">\n' +
    '                      <i class="zmdi zmdi-close domp-close-sign"\n' +
    '                         ng-show="internationalPayment.tempForpObj.receiversNameInput"\n' +
    '                         ng-click="internationalPayment.removeSearch()"></i>\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                         ng-show="!internationalPayment.tempForpObj.receiversNameInput"></i>\n' +
    '                    </div>\n' +
    '                    <div class="domp-filter-selection search-row"\n' +
    '                         ng-class="{\'opened\': internationalPayment.searchFilterExpanded}">\n' +
    '                      <div class="domp-filter-type-selection-wrapper"\n' +
    '                           ng-repeat="payee in internationalPayment.payeeList| filter:internationalPayment.searchPayeeBy"\n' +
    '                           ng-click="internationalPayment.selectPayee(payee.id)">\n' +
    '                        <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                          <i class="zmdi zmdi-account-circle"></i>\n' +
    '                        </div>\n' +
    '                        <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                          <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                          <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                          ng-show="internationalPayment.paymentForm.payeeSearchFilter.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                          translate="domesticPayment.toPayeeInputError"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '              <!--//////////////SELECT CUSTOM END/////////////////////// -->\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-offset-6 col-md-6">\n' +
    '                <div class="form-group">\n' +
    '                  <!-- <label class="domp-form-label" for="receiversAddressInput"\n' +
    '                         translate="domesticPayment.receiversAddressInputLabel">Receiver\'s address:</label> -->\n' +
    '                  <input type="text" class="form-control input-field"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.receiversAddressInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         name="receiversAddressInput" id="receiversAddressInput"\n' +
    '                         ng-model="internationalPayment.tempForpObj.receiversAddressInput"\n' +
    '                         ng-blur="internationalPayment.replaceUnallowedCharsDPS(\'receiversAddressInput\', internationalPayment.tempForpObj.receiversAddressInput)"\n' +
    '                         maxlength="35" ng-maxlength="35" required>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.receiversAddressInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="domesticPayment.receiverAddressError"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '\n' +
    '              <div class="col-md-offset-6 col-lg-6 col-md-6 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <!-- <label class="domp-form-label" for="receiversPostalCodeAndCityInput"\n' +
    '                         translate="domesticPayment.receiversPostalCodeAndCityInputLabel">Receiver\'s postal code and\n' +
    '                    city:</label> -->\n' +
    '                  <input type="text" class="form-control input-field"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.receiversPostalCodeAndCityInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         name="receiversPostalCodeAndCityInput" id="receiversPostalCodeAndCityInput"\n' +
    '                         ng-model="internationalPayment.tempForpObj.receiversPostalCodeAndCityInput"\n' +
    '                         ng-blur="internationalPayment.replaceUnallowedCharsDPS(\'receiversPostalCodeAndCityInput\', internationalPayment.tempForpObj.receiversPostalCodeAndCityInput)"\n' +
    '                         maxlength="35" ng-maxlength="35">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <div class="form-group clearfix">\n' +
    '                  <label class="domp-form-label" translate="payments.bicCountry">\n' +
    '                    Country\n' +
    '                  </label>\n' +
    '                  <div class="col-xs-12 domp-filter-container h-55"\n' +
    '                       ng-class="{\'domp-error-custom-payee\': internationalPayment.paymentForm.countrySearchFilter.$invalid && internationalPayment.tempForpObj.formSubmitted}">\n' +
    '                    <div class="col-xs-1 inner-section left">\n' +
    '                      <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-9 col-sm-10 inner-section input-div searchrow">\n' +
    '                      <input type="text" class="search-input" name="countrySearchFilter"\n' +
    '                             ng-model="internationalPayment.countrySearchFilter"\n' +
    '                             ng-change="internationalPayment.countrySearchFilterExpanded = true;"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.onlyNumbersAndLettersWithSuskavci}}"\n' +
    '                             required\n' +
    '                             autocomplete="off">\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-xs-1 inner-section right"\n' +
    '                         ng-click="internationalPayment.countrySearchFilterExpanded = !internationalPayment.countrySearchFilterExpanded">\n' +
    '                      <i class="zmdi zmdi-close domp-close-sign"\n' +
    '                         ng-show="internationalPayment.countrySearchFilter"\n' +
    '                         ng-click="internationalPayment.removeSelectedCountry()"></i>\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                         ng-show="!internationalPayment.countrySearchFilter"></i>\n' +
    '                    </div>\n' +
    '                    <!--Dropdown menu -->\n' +
    '                    <div class="domp-filter-selection search-row"\n' +
    '                         ng-class="{\'opened\': internationalPayment.countrySearchFilterExpanded}">\n' +
    '                      <div class="domp-filter-type-selection-wrapper"\n' +
    '                           ng-repeat="country in internationalPayment.countriesOptions| filter: internationalPayment.countrySearchFilter"\n' +
    '                           ng-click="internationalPayment.onCountrySelect(country)">\n' +
    '                        <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                          <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '                        </div>\n' +
    '                        <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                          <p class="domp-list-name m-0">{{country.code}} {{country.description}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="c-red"\n' +
    '                       ng-show="internationalPayment.paymentForm.countrySearchFilter.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                       translate="payments.bicCountryRequired"></div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6 p-t-30">\n' +
    '                <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                  <uib-accordion-group style="margin-top: 0px">\n' +
    '                    <uib-accordion-heading>\n' +
    '                      <div class="sepa-heading input-field" ng-click="internationalPayment.clearSepaReceiver();">\n' +
    '                        <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                          <label class="domp-form-label-sepa" translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                          class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                      </div>\n' +
    '                    </uib-accordion-heading>\n' +
    '                    <input type="text" class="form-control input-field"\n' +
    '                           ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPSwithoutSuskavci}}"\n' +
    '                           ng-model="internationalPayment.tempForpObj.receiversSepaInput1" style="margin-bottom:10px;">\n' +
    '                    <input type="text" class="form-control input-field"\n' +
    '                           ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPSwithoutSuskavci}}"\n' +
    '                           ng-model="internationalPayment.tempForpObj.receiversSepaInput2">\n' +
    '                  </uib-accordion-group>\n' +
    '                </uib-accordion>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="receiver-section" style="padding: 10px; background-color:#fff;">\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-6">\n' +
    '                <div class="form-group">\n' +
    '                  <div class="no-padding-on-phone">\n' +
    '                    <label class="domp-form-label" for="purposeCodeSelect"\n' +
    '                           translate="internationalPayment.purposeCode">Purpose code</label>\n' +
    '                    <div class="p-l-0">\n' +
    '                      <select class="form-control input-field p-l-15 p-r-10" name="purposeCodeSelect"\n' +
    '                              id="purposeCodeSelect"\n' +
    '                              ng-options="item.optionValue for item in internationalPayment.purposeCodes"\n' +
    '                              ng-model="internationalPayment.tempForpObj.purposeCodeSelect"\n' +
    '                              ng-change="internationalPayment.purposeCodeChange(internationalPayment.tempForpObj.purposeCodeSelect)"></select>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-md-6">\n' +
    '                <label translate="payments.paymentMode" class="domp-form-label">\n' +
    '                  Payment mode:\n' +
    '                </label>\n' +
    '                <div class="p-l-0">\n' +
    '                  <select name="paymentMode"\n' +
    '                          class="form-control input-field p-l-15 p-r-10"\n' +
    '                          ng-options="item.id as (item.id +   \' - \' +   item.description) for item in internationalPayment.paymentModeOptions"\n' +
    '                          ng-model="internationalPayment.tempForpObj.modalityCode">\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-12 form-group">\n' +
    '                <div class="no-padding-on-phone">\n' +
    '                  <label class="domp-form-label domp-purpose-label" for="paymentPurposeInput"\n' +
    '                         translate="internationalPayment.paymentPurpose">Purpose of payment</label>\n' +
    '                  <div class="p-0">\n' +
    '                    <input type="text" class="form-control input-field"\n' +
    '                           data-ng-model="internationalPayment.tempForpObj.paymentPurposeInput"\n' +
    '                           name="paymentPurposeInput"\n' +
    '                           ng-pattern-restrict="{{internationalPayment.regexPatterns.purposeOfPaymentValidation}}"\n' +
    '                           ng-class="{\'domp-error\': internationalPayment.paymentForm.paymentPurposeInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                           required>\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="internationalPayment.paymentForm.paymentPurposeInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                          translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="internationalPayment.paymentForm.purposeOfPaymentInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                          translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- START BIC -->\n' +
    '          <div class="purpose-section" style="padding: 10px">\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-12 col-sm-6">\n' +
    '                <div class="form-group clearfix">\n' +
    '                  <label class="domp-form-label" translate="payments.bicAddress">\n' +
    '                    BIC Address\n' +
    '                  </label>\n' +
    '                  <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 domp-filter-container h-45"\n' +
    '                       ng-class="{\'domp-error-custom-payee\': internationalPayment.paymentForm.bicCodeSearchFilter.$invalid && internationalPayment.tempForpObj.formSubmitted}">\n' +
    '                    <div class="col-xs-1 col-lg-1  inner-section left">\n' +
    '                      <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-9 col-lg-10  inner-section input-div searchrow">\n' +
    '                      <input type="text" class="search-input" name="bicCodeSearchFilter"\n' +
    '                             ng-model="internationalPayment.bicCodeSearchFilter"\n' +
    '                             ng-change="internationalPayment.searchBICNumber(internationalPayment.bicCodeSearchFilter)"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.onlyNumbersAndLetters}}"\n' +
    '                             autocomplete="off"\n' +
    '                             capitalize="">\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-xs-1 col-lg-1 inner-section right"\n' +
    '                         ng-click="internationalPayment.bicCodeSearchFilterExpanded = !internationalPayment.bicCodeSearchFilterExpanded">\n' +
    '                      <i class="zmdi zmdi-close domp-close-sign" ng-show="internationalPayment.bicCodeSearchFilter"\n' +
    '                         ng-click="internationalPayment.removeBicCodeSearch()"></i>\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                         ng-show="!internationalPayment.bicCodeSearchFilter"></i>\n' +
    '                    </div>\n' +
    '                    <!--Dropdown menu -->\n' +
    '                    <div class="domp-filter-selection search-row"\n' +
    '                         ng-class="{\'opened\': internationalPayment.bicCodeSearchFilterExpanded}">\n' +
    '                      <div class="domp-filter-type-selection-wrapper"\n' +
    '                           ng-repeat="bicBank in internationalPayment.bicBankOptions| filter:internationalPayment.bicCodeSearchFilter"\n' +
    '                           ng-click="internationalPayment.onBicBankSelected(bicBank)">\n' +
    '                        <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                          <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '                        </div>\n' +
    '                        <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                          <p class="domp-list-name m-0">{{bicBank.bicCode}}{{bicBank.branchCode}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <span class="c-red" translate="payments.bicNumberRequired"\n' +
    '                          ng-show="internationalPayment.paymentForm.bicCodeSearchFilter.$error.required && internationalPayment.tempForpObj.formSubmitted">\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12 col-sm-6 ">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-12">\n' +
    '\n' +
    '                  <!-- Required if Bic number is empty -->\n' +
    '                  <label class="domp-form-label" translate="payments.bicBankName">Bank Name</label>\n' +
    '                    <!--<input type="text" class="form-control input-field"-->\n' +
    '                    <!--name="bankNameInput"-->\n' +
    '                    <!--ng-model="internationalPayment.tempForpObj.bankNameInput"-->\n' +
    '                    <!--ng-required="!internationalPayment.bicCodeSearchFilter">     -->\n' +
    '                  <input type="text" class="form-control input-field"\n' +
    '                         name="bankNameInput" maxlength="35"\n' +
    '                         ng-class="{\'domp-error\': internationalPayment.paymentForm.bankNameInput.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                         ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                         replace-specific-chars\n' +
    '                         ng-model="internationalPayment.tempForpObj.bankNameInput"\n' +
    '                         autocomplete="off"\n' +
    '                         required>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="internationalPayment.paymentForm.bankNameInput.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                        translate="payments.bicBankNameRequired"></span>\n' +
    '\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-12">\n' +
    '\n' +
    '                      <label class="domp-form-label"></label>\n' +
    '                      <input type="text" class="form-control input-field"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                             replace-specific-chars maxlength="35"\n' +
    '                             autocomplete="off"\n' +
    '                             ng-model="internationalPayment.tempForpObj.bankAddressInput">\n' +
    '\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-12">\n' +
    '\n' +
    '                      <label class="domp-form-label"></label>\n' +
    '                      <input type="text" class="form-control input-field" name="bicCity"\n' +
    '                             ng-model="internationalPayment.tempForpObj.bankCityInput"\n' +
    '                             ng-pattern-restrict="{{internationalPayment.regexPatterns.allowedCharsDPS}}"\n' +
    '                             replace-specific-chars maxlength="35"\n' +
    '                             ng-class="{\'domp-error\': internationalPayment.paymentForm.bicCity.$invalid && internationalPayment.tempForpObj.formSubmitted}"\n' +
    '                             required>\n' +
    '                      <span class="c-red"\n' +
    '                            ng-show="internationalPayment.paymentForm.bicCity.$error.required && internationalPayment.tempForpObj.formSubmitted"\n' +
    '                            translate="payments.bicCityRequired"></span>\n' +
    '\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row p-t-20">\n' +
    '              <div class="col-sm-4">\n' +
    '                <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="internationalPayment.chargeAccount">Charge account</label>\n' +
    '                <select type="text" class="form-control input-field"\n' +
    '                        name="chargeAccount"\n' +
    '                        data-ng-model="internationalPayment.tempForpObj.chargeAccountInput"\n' +
    '                        ng-options="(account.accountNumber +   \' \' +   account.currencySymbol) for account in internationalPayment.chargeAccountOptions">\n' +
    '                </select>\n' +
    '                  </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-4">\n' +
    '\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="payments.bicBankCharges">Troškovna opcija:</label>\n' +
    '                  <select class="form-control input-field"\n' +
    '                          ng-model="internationalPayment.tempForpObj.bankChargesRadiobutton.type"\n' +
    '                          ng-disabled="internationalPayment.EUCountrySelected">\n' +
    '                    <option value=3>SHA</option>\n' +
    '                    <option value=1>OUR</option>\n' +
    '                    <option value=2>BEN</option>\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-4">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="payments.bicRecipientStatus">Primatelj (osoba)</label>\n' +
    '                  <select class="form-control input-field"\n' +
    '                          ng-model="internationalPayment.tempForpObj.recipientStatusRadiobutton.type">\n' +
    '                    <option value=2>{{"payments.bicRecipientStatusOptionPhysical"| translate}}</option>\n' +
    '                    <option value=1>{{"payments.bicRecipientStatusOptionLegal"| translate}}</option>\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- END BIC -->\n' +
    '\n' +
    '          <div class="intp-form-container m-b-30">\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-6 t-a-l">\n' +
    '                <button class="btn btn-primary" translate="payments.cancel"\n' +
    '                        type="button"\n' +
    '                        data-ui-sref="payments.paymentsOverview">\n' +
    '                </button>\n' +
    '              </div>\n' +
    '              <div class="col-xs-6 t-a-r">\n' +
    '                <button type="submit"\n' +
    '                        ng-if="!internationalPayment.tempForpObj.bankCountrySelect.amlControl"\n' +
    '                        class="btn btn-default domp-review-and-submit-btn"\n' +
    '                        translate="domesticPayment.confirmBtn"\n' +
    '                        data-ng-click="internationalPayment.submitInternationalPayment($event);">\n' +
    '                </button>\n' +
    '                <button type="submit"\n' +
    '                        ng-if="internationalPayment.tempForpObj.bankCountrySelect.amlControl"\n' +
    '                        class="btn btn-default domp-review-and-submit-btn"\n' +
    '                        translate="domesticPayment.confirmBtn"\n' +
    '                        data-ng-click="internationalPayment.submitInternationalPayment($event);">\n' +
    '                </button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '        <!-- END NEW SECOND BOX -->\n' +
    '\n' +
    '      </div>\n' +
    '    </span>\n' +
    '    <!-- START STEP NUMBER 2 -->\n' +
    '    <div ng-if="internationalPayment.steps.step2">\n' +
    '      <div data-ng-include="\'payments/international-payment-resume.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '    <!-- END STEP NUMBER 2-->\n' +
    '    <!-- START STEP NUMBER 3 -->\n' +
    '    <div ng-if="internationalPayment.steps.step3">\n' +
    '      <payment-final-step payment="internationalPayment.paymentResponse" is-modal="false"></payment-final-step>\n' +
    '    </div>\n' +
    '    <!-- END STEP NUMBER 3 -->\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/internal-transfer.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '\n' +
    '    <div class="internal-transfer-header" ng-show="internalTransfer.currentStep != 3">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12 f-28" translate="internalTransfer.transferToAccount"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="internalTransfer.currentStep == 1">\n' +
    '      <form name="internalTransfer.internalTransferForm" novalidate>\n' +
    '        <div class="internal-transfer-body col-sm-12">\n' +
    '          <div class="row m-b-30">\n' +
    '            <div class="col-sm-5">\n' +
    '              <!-- CUSTOM FROM Accounts dropdown-->\n' +
    '              <label class="bold-font f-18" translate="payments.fromAccount"></label>\n' +
    '              <div class="accounts-dropdown m-b-10" ng-if="internalTransfer.accountsFrom.length > 0">\n' +
    '                <div class="debit-account-widget dashboard-widget-item"\n' +
    '                     data-ng-click="internalTransfer.toggleFromAccount();"\n' +
    '                     ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{internalTransfer.tempIntObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                        ng-class="{\'zmdi-star favorite-account\':internalTransfer.tempIntObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!internalTransfer.tempIntObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{internalTransfer.tempIntObj.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{internalTransfer.tempIntObj.fromAccountSelect.availableBalance | number:2}}\n' +
    '                    {{internalTransfer.tempIntObj.fromAccountSelect.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                    <span ng-switch-when="sl" class="caret-icon"\n' +
    '                          ng-if="internalTransfer.accountsFrom.length > 1 && !internalTransfer.fromTemplate"><i\n' +
    '                    class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                    <span ng-switch-default class="caret-icon"\n' +
    '                          ng-if="internalTransfer.accountsFrom.length > 1"><i\n' +
    '                    class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                  </span>\n' +
    '\n' +
    '                </div>\n' +
    '                <div class="from-accounts-list" ng-show="internalTransfer.fromAccountDropdown" scrollable>\n' +
    '                  <div class="accounts-list-item p-0" data-ng-repeat="item in internalTransfer.accountsFrom"\n' +
    '                       data-ng-click="internalTransfer.setAccountFrom(item);">\n' +
    '                    <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                         ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                            ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="accounts-dropdown m-b-10" ng-if="internalTransfer.accountsFrom.length == 0">\n' +
    '                <div class="debit-account-widget dashboard-widget-item" style="height: 133px; line-height: 133px"\n' +
    '                     translate="internalTransfer.nodata"\n' +
    '                     ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  No available accounts\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <label class="bold-font m-t-20 f-18" translate="internalTransfer.amount"></label>\n' +
    '              <div class="input-group">\n' +
    '                <input type="text" class="form-control input-field t-a-r"\n' +
    '                       name="amountInput"\n' +
    '                       placeholder="{{\'domesticPayment.amountPlaceholder\' | translate}}"\n' +
    '                       amount-input-mask max-amount="99999999999.99"\n' +
    '                       data-ng-model="internalTransfer.tempIntObj.amountInput"\n' +
    '                       ng-class="{\'domp-error\': internalTransfer.internalTransferForm.amountInput.$invalid &&\n' +
    '                       internalTransfer.tempIntObj.formSubmitted}"\n' +
    '                       maxlength="17"\n' +
    '                       required\n' +
    '                       ng-readonly="internalTransfer.disableAllFields && internalTransfer.disableAllFieldsForProcessedPayment">\n' +
    '                <span class="input-group-btn">\n' +
    '                 <button type="button" class="btn input-group-app-btn domp-btn-height" style="border:1px solid #062a42;"\n' +
    '                         disabled>\n' +
    '                   {{internalTransfer.tempIntObj.fromAccountSelect.currencySymbol}}\n' +
    '                 </button>\n' +
    '            </span>\n' +
    '              </div>\n' +
    '              <span class="c-red" ng-show="internalTransfer.internalTransferForm.amountInput.$error.required &&\n' +
    '              internalTransfer.tempIntObj.formSubmitted" translate="internalTransfer.amountInputError">\n' +
    '              </span>\n' +
    '              <!--                            <span class="c-red" ng-show="internalTransfer.internalTransferForm.amountInput.$error.maxlength &&\n' +
    '                            internalTransfer.tempIntObj.formSubmitted" translate="internalTransfer.amountLengthError">\n' +
    '                            </span>-->\n' +
    '              <span ng-if="internalTransfer.countryCode != \'bh\'" class="c-red" ng-show="internalTransfer.internalTransferForm.amountInput.$error.maxAmount &&\n' +
    '              internalTransfer.tempIntObj.formSubmitted" translate="internalTransfer.amountLengthError">\n' +
    '              </span>\n' +
    '              <span ng-if="internalTransfer.countryCode === \'bh\'" class="c-red" ng-show="internalTransfer.internalTransferForm.amountInput.$error.maxAmount &&\n' +
    '              internalTransfer.tempIntObj.formSubmitted" translate="internalTransfer.amountLengthErrorBh">\n' +
    '              </span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-2">\n' +
    '              <div class="t-a-c exchange-office-middle">\n' +
    '                <i class="zmdi zmdi-long-arrow-right zmdi-hc-2x"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-5">\n' +
    '              <!-- CUSTOM TO Accounts dropdown -->\n' +
    '              <div ng-if="!internalTransfer.fromLoan">\n' +
    '                <label class="bold-font f-18" translate="payments.toAccount"></label>\n' +
    '                <div class="accounts-dropdown m-b-10" ng-if="internalTransfer.accountsTo.length > 0">\n' +
    '                  <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                       data-ng-click="internalTransfer.toggleToAccount();"\n' +
    '                       ng-style="internalTransfer.tempIntObj.toAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.toAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{internalTransfer.tempIntObj.toAccountSelect.friendlyName}}</b>\n' +
    '                      <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                          ng-class="{\'zmdi-star favorite-account\':internalTransfer.tempIntObj.toAccountSelect.isFavorite,\'zmdi-star-outline\':!internalTransfer.tempIntObj.toAccountSelect.isFavorite}"></i></span>\n' +
    '                    </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{internalTransfer.tempIntObj.toAccountSelect.iban | formatIban}}</p>\n' +
    '                    <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                         ng-if="internalTransfer.tempIntObj.toAccountSelect.hasOwnProperty(\'availableBalance\')">\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.availableBalance | number:2}}\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                            ng-if="internalTransfer.tempIntObj.toAccountSelect.hasOwnProperty(\'availableBalance\')"></span>\n' +
    '                      <!--na kreditima nema available balance, pa ispisuje balance -->\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                         ng-if="!internalTransfer.tempIntObj.toAccountSelect.hasOwnProperty(\'availableBalance\')">\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.balance | number:2}}\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                            ng-if="!internalTransfer.tempIntObj.toAccountSelect.hasOwnProperty(\'availableBalance\')"></span>\n' +
    '                    </span>\n' +
    '                    <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                         ng-if="internalTransfer.tempIntObj.toAccountSelect.availableBalance">\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.availableBalance | number:2}}\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                            ng-if="internalTransfer.tempIntObj.toAccountSelect.availableBalance"></span>\n' +
    '                      <!--na kreditima nema available balance, pa ispisuje balance -->\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                         ng-if="!internalTransfer.tempIntObj.toAccountSelect.availableBalance">\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.balance | number:2}}\n' +
    '                        {{internalTransfer.tempIntObj.toAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                            ng-if="!internalTransfer.tempIntObj.toAccountSelect.availableBalance"></span>\n' +
    '                    </span>\n' +
    '\n' +
    '                    <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                    <span ng-switch-when="sl" class="caret-icon"\n' +
    '                          ng-if="internalTransfer.accountsTo.length > 1 && !internalTransfer.fromTemplate"><i\n' +
    '                      class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                    <span ng-switch-default class="caret-icon"\n' +
    '                          ng-if="internalTransfer.accountsTo.length > 1"><i\n' +
    '                      class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                  </span>\n' +
    '\n' +
    '                  </div>\n' +
    '                  <div class="from-accounts-list" ng-show="internalTransfer.toAccountDropdown" scrollable>\n' +
    '                    <div class="accounts-list-item p-0" data-ng-repeat="item in internalTransfer.accountsTo"\n' +
    '                         data-ng-click="internalTransfer.setAccountTo(item);">\n' +
    '                      <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                           ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                        <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                          <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                          <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                              ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                        </h4>\n' +
    '                        <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                        <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                          <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                             ng-if="item.hasOwnProperty(\'availableBalance\')">\n' +
    '                            {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                          </p>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                                ng-if="item.hasOwnProperty(\'availableBalance\')"></span>\n' +
    '                          <!--na kreditima nema available balance, pa ispisuje balance -->\n' +
    '                          <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                             ng-if="!item.hasOwnProperty(\'availableBalance\')">\n' +
    '                            {{item.balance | number:2}} {{item.currencySymbol}}\n' +
    '                          </p>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                                ng-if="!item.hasOwnProperty(\'availableBalance\')"></span>\n' +
    '                        </span>\n' +
    '                        <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                          <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                             ng-if="item.availableBalance">\n' +
    '                            {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                          </p>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                                ng-if="item.availableBalance"></span>\n' +
    '                          <!--na kreditima nema available balance, pa ispisuje balance -->\n' +
    '                          <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                             ng-if="!item.availableBalance">\n' +
    '                            {{item.balance | number:2}} {{item.currencySymbol}}\n' +
    '                          </p>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"\n' +
    '                                ng-if="!item.availableBalance"></span>\n' +
    '                        </span>\n' +
    '\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="accounts-dropdown m-b-10" ng-if="!internalTransfer.accountsTo.length">\n' +
    '                  <div ng-switch-default class="debit-account-widget dashboard-widget-item" style="height: 133px; line-height: 133px"\n' +
    '                       translate="internalTransfer.nodata"\n' +
    '                       ng-style="internalTransfer.tempIntObj.toAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.toAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    No available accounts\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div ng-switch-when="sl" class="debit-account-widget-empty" style="height: 133px;">\n' +
    '                    <span translate="internalTransfer.toAccountNoData"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '\n' +
    '              <!-- TO ACCOUNT CONTROL SPECIFIC FOR SERBIA LOAN -->\n' +
    '              <div class="accounts-dropdown m-b-10" ng-if="internalTransfer.fromLoan">\n' +
    '                <label class="bold-font f-18" translate="payments.toAccount"></label>\n' +
    '                <div class="debit-account-widget dashboard-widget-item"\n' +
    '                     ng-style="internalTransfer.tempIntObj.toAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.toAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-12 p-0 m-t-10  no-wrap-text">{{internalTransfer.tempIntObj.toAccountSelect.friendlyName}}</b>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{internalTransfer.tempIntObj.toAccountSelect.iban | formatIban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                     ng-if="internalTransfer.tempIntObj.toAccountSelect.availableBalance">\n' +
    '                    {{internalTransfer.tempIntObj.toAccountSelect.availableBalance | number:2}}\n' +
    '                    {{internalTransfer.tempIntObj.toAccountSelect.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text"\n' +
    '                     ng-if="!internalTransfer.tempIntObj.toAccountSelect.availableBalance">\n' +
    '                    {{internalTransfer.tempIntObj.toAccountSelect.balance | number:2}}\n' +
    '                    {{internalTransfer.tempIntObj.toAccountSelect.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '\n' +
    '              <!-- END TO ACCOUNT CONTROL -->\n' +
    '\n' +
    '              <label ng-if="internalTransfer.countryCode != \'sr\' && internalTransfer.countryCode != \'mne\'"\n' +
    '                     class="bold-font m-t-20 f-18" translate="internalTransfer.when"></label>\n' +
    '              <div ng-if="internalTransfer.countryCode != \'sr\' && internalTransfer.countryCode != \'mne\'"\n' +
    '                   class="input-group">\n' +
    '                <input type="text" class="form-control input-field"\n' +
    '                       name="dueDateInput"\n' +
    '                       uib-datepicker-popup="shortDate"\n' +
    '                       data-ng-model="internalTransfer.tempIntObj.dueDateInput"\n' +
    '                       show-weeks="false" is-open="internalTransfer.datePickerOpened"\n' +
    '                       datepicker-options="internalTransfer.dateOptions"\n' +
    '                       current-text="{{\'core.period.today\' | translate}}"\n' +
    '                       clear-text="{{\'core.datePicker.clearBtn\' | translate}}"\n' +
    '                       close-text="{{\'core.datePicker.doneBtn\' | translate}}"\n' +
    '                       ng-class="{\'domp-error\': internalTransfer.internalTransferForm.dueDateInput.$invalid && internalTransfer.tempIntObj.formSubmitted}"\n' +
    '                       ng-readonly="true" required>\n' +
    '\n' +
    '                <span class="input-group-btn">\n' +
    '                        <button ng-disabled="internalTransfer.disableAllFields && internalTransfer.disableAllFieldsForProcessedPayment"\n' +
    '                                data-ng-click="internalTransfer.openDatePicker()" type="button"\n' +
    '                                class="btn input-group-app-btn domp-btn-height" style="border:1px solid #062a42;"><i\n' +
    '                          class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                        </button>\n' +
    '                  </span>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <hr>\n' +
    '\n' +
    '          <div class="row">\n' +
    '            <div class="col-xs-6 t-a-l">\n' +
    '              <button class="btn btn-primary" type="button" translate="payments.cancel"\n' +
    '                      data-ui-sref="payments.paymentsOverview">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 t-a-r">\n' +
    '              <button ng-if="internalTransfer.countryCode != \'sl\'" class="btn btn-default domp-review-and-submit-btn"\n' +
    '                      type="submit"\n' +
    '                      translate="currencyConversion.confirm"\n' +
    '                      data-ng-click="internalTransfer.internalTransferSubmit();"\n' +
    '                      ng-disabled="internalTransfer.accountsFrom.length == 0 || internalTransfer.accountsTo.length == 0"\n' +
    '                      is-same-account="{{internalTransfer.isSameAccounts}}">\n' +
    '              </button>\n' +
    '              <button ng-if="internalTransfer.countryCode === \'sl\'" class="btn btn-default domp-review-and-submit-btn"\n' +
    '                      type="submit"\n' +
    '                      translate="domesticPayment.confirmBtnSlo"\n' +
    '                      data-ng-click="internalTransfer.internalTransferSubmit();"\n' +
    '                      ng-disabled="internalTransfer.nextButtonPressed || (internalTransfer.accountsFrom.length == 0 || internalTransfer.accountsTo.length == 0)"\n' +
    '                      is-same-account="{{internalTransfer.isSameAccounts}}">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Internal transfer STEP 2 -->\n' +
    '    <div ng-if="internalTransfer.currentStep == 2">\n' +
    '      <div data-ng-include="\'payments/internal-transfer-resume.tpl.html\'">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Internal transfer STEP 3 -->\n' +
    '    <div ng-if="internalTransfer.currentStep == 3">\n' +
    '      <div data-ng-include="\'payments/internal-transfer-final.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/internal-transfer-resume.tpl.html',
    '<form name="internalTransferForm" novalidate>\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{internalTransfer.paymentResponse.fromAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel">Amount</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              {{internalTransfer.paymentResponse.amount | currency: ""}}\n' +
    '              {{internalTransfer.paymentResponse.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6" ng-if="internalTransfer.countryCode !== \'bh\'">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.bankCharges">Bank charges</label>\n' +
    '              <a ng-if="!internalTransfer.paymentResponse.hasOwnProperty(\'paymentChargesAmount\')" ng-href="{{internalTransfer.bankCharges}}"\n' +
    '                 target="_blank" translate="domesticPayment.checkBankCharges" class="domp-form-label-resume">Check the bank charges</a>\n' +
    '            <label ng-if="internalTransfer.paymentResponse.hasOwnProperty(\'paymentChargesAmount\')" class="d-block domp-form-label-resume">\n' +
    '              {{internalTransfer.paymentResponse.paymentChargesAmount | currency:""}}\n' +
    '              {{APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency}}\n' +
    '            </label>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel">When</label>\n' +
    '            <label class="d-block domp-form-label-resume">{{internalTransfer.paymentResponse.dueDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="currencyConversion.toAccount">To account</label>\n' +
    '          <label class="d-block domp-form-label-resume">{{internalTransfer.paymentResponse.toAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '    <div class="row p-10">\n' +
    '        <div ng-if="internalTransfer.countryCode === \'mne\'" class="col-xs-12">\n' +
    '            <dl>\n' +
    '                <dt><span translate="internalTransfer.infoMne0"></span></dt>\n' +
    '                <dd>- <span translate="internalTransfer.infoMne1"></span></dd>\n' +
    '                <dd>- <span translate="internalTransfer.infoMne2"></span></dd>\n' +
    '            </dl>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '  <div class="m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-9 p-b-10 col-xs-12 hidden-xs">\n' +
    '        <button ng-if="internalTransfer.countryCode != \'sl\'" class="btn btn-primary " translate="currencyConversion.back"\n' +
    '                data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        </button>\n' +
    '        <button ng-if="internalTransfer.countryCode != \'sl\'" class="btn btn-primary" translate="payments.edit"\n' +
    '                data-ng-click="internalTransfer.editPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="internalTransfer.countryCode == \'sl\'" class="btn btn-primary" translate="domesticPayment.back"\n' +
    '                data-ng-click="internalTransfer.editPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="internalTransfer.countryCode != \'sl\'" class="btn btn-primary-warning " translate="payments.delete"\n' +
    '                data-ng-click="internalTransfer.deletePayment();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-9 p-b-10 col-xs-12 visible-xs-block">\n' +
    '        <button ng-if="internalTransfer.countryCode != \'sl\'" class="btn btn-default btn-block"\n' +
    '\n' +
    '                data-ng-click="internalTransfer.signPayment()">\n' +
    '\n' +
    '          <span  translate="currencyConversion.sign"></span>\n' +
    '        </button>\n' +
    '        <button ng-if="internalTransfer.countryCode === \'sl\'" class="btn btn-default btn-block"\n' +
    '                ng-disabled="internalTransfer.confirmButtonPressed"\n' +
    '                data-ng-click="internalTransfer.signPayment()">\n' +
    '\n' +
    '          <span  translate="domesticPayment.confirmBtn"></span>\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary btn-block" translate="currencyConversion.back"\n' +
    '                data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary btn-block" translate="payments.edit"\n' +
    '                data-ng-click="internalTransfer.editPayment();">\n' +
    '        </button>\n' +
    '        <button ng-if="internalTransfer.countryCode != \'sl\'" class="btn btn-primary-warning btn-block" translate="payments.delete"\n' +
    '                data-ng-click="internalTransfer.deletePayment();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-3 col-xs-12 hidden-xs">\n' +
    '\n' +
    '          <button ng-if="internalTransfer.countryCode != \'sl\'" class="btn btn-default col-xs-12"\n' +
    '\n' +
    '                  data-ng-click="internalTransfer.signPayment()">\n' +
    '\n' +
    '            <span translate="currencyConversion.sign"></span>\n' +
    '          </button>\n' +
    '\n' +
    '        <button ng-if="internalTransfer.countryCode === \'sl\'" class="btn btn-default col-xs-12"\n' +
    '                ng-disabled="internalTransfer.confirmButtonPressed"\n' +
    '                data-ng-click="internalTransfer.signPayment()">\n' +
    '\n' +
    '          <span translate="domesticPayment.confirmBtn"></span>\n' +
    '        </button>\n' +
    '\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/internal-transfer-final.tpl.html',
    '<div class="currency-conversion-msg">\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{internalTransfer.paymentResponse.amount}}\n' +
    '            {{internalTransfer.paymentResponse.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{internalTransfer.paymentResponse.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{internalTransfer.paymentResponse.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/exchange-rates-directive.tpl.html',
    '<div class="wb-list-wrapper app-white-card m-b-15 o-auto" ng-class="{\'exchange-rates-ctn\': exchangeRates.countryCode !==\'mne\'}" scrollable>\n' +
    '\n' +
    '  <div>\n' +
    '      <span translate="currencyCalculator.updated">Updated</span>\n' +
    '    <span>{{exchangeRates.currentDate | date:\'shortDate\'}}</span>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-show="exchangeObjectList.result.length > 0">\n' +
    '    <!-- Data table -->\n' +
    '    <!--<div class="col-sm-12 hidden-xs p-t-10 p-b-10 rates-header">-->\n' +
    '      <!--<div class="col-sm-5" translate="payments.currencyName"></div>-->\n' +
    '      <!--<div class="col-sm-1" translate="payments.code"></div>-->\n' +
    '      <!--<div class="col-sm-1" translate="payments.unit"></div>-->\n' +
    '      <!--<div class="col-sm-2" translate="payments.buyRate"></div>-->\n' +
    '      <!--<div class="col-sm-2" translate="payments.sellRate"></div>-->\n' +
    '      <!--<div class="col-sm-1" translate="payments.action"></div>-->\n' +
    '    <!--</div>-->\n' +
    '    <div class="col-sm-12 p-t-5 p-b-5 exchange-list-item no-padding"\n' +
    '         data-ng-repeat="exchangeItem in ::exchangeObjectList.result"\n' +
    '         data-ng-class="{\'last-list-item\': $last, \'list-colored-el\': $odd}">\n' +
    '      <div class="col-md-6 col-sm-4 currency-ctn">\n' +
    '        <div class="hidden-xs l-height-65">\n' +
    '          <img data-ng-src="img/hypo/flags/currency/{{exchangeItem.currencySymbol}}.png" height="40px" alt="">\n' +
    '          <span class="p-l-10 bold-font">{{::exchangeItem.currencySymbol}}</span>\n' +
    '        </div>\n' +
    '        <div class="hidden-sm hidden-md hidden-lg">\n' +
    '          <table class="table">\n' +
    '            <thead>\n' +
    '            <tr>\n' +
    '              <th colspan="2">\n' +
    '                <img data-ng-src="img/hypo/flags/currency/{{exchangeItem.currencySymbol}}.png" height="25px" alt="">\n' +
    '                {{::exchangeItem.currencySymbol}}\n' +
    '              </th>\n' +
    '              <!--<th>-->\n' +
    '                <!--<button type="button" class="btn btn-default app-btn-blue"-->\n' +
    '                        <!--data-ng-click="exchangeRates.buy(exchangeItem);"-->\n' +
    '                        <!--translate="payments.buy">-->\n' +
    '                <!--</button>-->\n' +
    '              <!--</th>-->\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody>\n' +
    '            <!--<tr>-->\n' +
    '              <!--<td>Code</td>-->\n' +
    '              <!--<td>{{::exchangeItem.currencySymbol}}</td>-->\n' +
    '            <!--</tr>-->\n' +
    '            <tr>\n' +
    '              <td translate="payments.unit"></td>\n' +
    '              <td>1 {{::exchangeItem.currencySymbol}}</td>\n' +
    '            </tr>\n' +
    '            <tr>\n' +
    '              <td translate="payments.buyRate"></td>\n' +
    '              <td ng-if="exchangeRates.countryCode != \'bh\'" >1 {{::exchangeItem.buyRate}}</td>\n' +
    '              <td ng-if="exchangeRates.countryCode == \'bh\'" >1 {{::exchangeItem.buyRate | number:10}}</td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="exchangeRates.countryCode != \'sl\'">\n' +
    '              <td translate="payments.middleRate"></td>\n' +
    '              <td ng-if="exchangeRates.countryCode != \'bh\'" >1 {{::exchangeItem.calculationRate}}</td>\n' +
    '              <td ng-if="exchangeRates.countryCode == \'bh\'" >1 {{::exchangeItem.calculationRate | number:10}}</td>\n' +
    '            </tr>\n' +
    '            <tr>\n' +
    '              <td translate="payments.sellRate"></td>\n' +
    '              <td ng-if="exchangeRates.countryCode != \'bh\'" >{{::exchangeItem.sellRate}}</td>\n' +
    '              <td ng-if="exchangeRates.countryCode == \'bh\'" >{{::exchangeItem.sellRate | number:10}}</td>\n' +
    '            </tr>\n' +
    '\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '      <!--<div class="col-sm-1 hidden-xs">{{::exchangeItem.currencySymbol}}</div>-->\n' +
    '      <div class="col-md-2 col-sm-2 hidden-xs l-height-65">{{::exchangeItem.currency.currencyUnit}} {{::exchangeItem.currencySymbol}}</div>\n' +
    '      <div class="col-md-4 col-sm-6 hidden-xs bold-font ex-rates">\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6 col-lg-7"  translate="payments.buyRate"></div>\n' +
    '          <div ng-if="exchangeRates.countryCode != \'bh\'" class="col-sm-6 col-lg-4">{{::exchangeItem.buyRate}}</div>\n' +
    '          <div ng-if="exchangeRates.countryCode == \'bh\'" class="col-sm-6 col-lg-4">{{::exchangeItem.buyRate | number:10}}</div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row" ng-if="exchangeRates.countryCode != \'sl\'">\n' +
    '          <div class="col-sm-6 col-lg-7" translate="payments.middleRate"></div>\n' +
    '          <div ng-if="exchangeRates.countryCode != \'bh\'" class="col-sm-6 col-lg-4">{{::exchangeItem.calculationRate}}</div>\n' +
    '          <div ng-if="exchangeRates.countryCode == \'bh\'" class="col-sm-6 col-lg-4">{{::exchangeItem.calculationRate | number:10}}</div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6 col-lg-7" translate="payments.sellRate"></div>\n' +
    '          <div ng-if="exchangeRates.countryCode != \'bh\'" class="col-sm-6 col-lg-4">{{::exchangeItem.sellRate}}</div>\n' +
    '          <div ng-if="exchangeRates.countryCode == \'bh\'" class="col-sm-6 col-lg-4">{{::exchangeItem.sellRate | number:10}}</div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <!--<div class="col-sm-1 hidden-xs">-->\n' +
    '        <!--<button type="button" class="btn btn-default app-btn-blue" data-ng-click="exchangeRates.buy(exchangeItem);"-->\n' +
    '                <!--translate="payments.buy">-->\n' +
    '        <!--</button>-->\n' +
    '      <!--</div>-->\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '  <div ng-show="exchangeObjectList.result.length == 0">\n' +
    '    No exchange rates info!\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/e-book-pay.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row exchange-rates">\n' +
    '      <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12">\n' +
    '        <div class="domp-header-wrapper p-r-20 p-l-10" ng-show="eBookPay.currentStep!=3">\n' +
    '          <div class="row domp-header-row">\n' +
    '            <div class="domp-header-left col-sm-12 col-md-12 col-lg-12 col-xs-12">\n' +
    '              <h2 ng-if="eBookPay.ebookType === \'Pay In\'" translate="ebook.ebookPayIn"></h2>\n' +
    '              <h2 ng-if="eBookPay.ebookType === \'Pay Out\'" translate="ebook.ebookPayOut"></h2>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!----------------------->\n' +
    '        <div class="internal-transfer-body" ng-if="eBookPay.currentStep == 1">\n' +
    '          <form name="eBookPay.eBookPayForm" novalidate>\n' +
    '            <div class="p-10">\n' +
    '            </div>\n' +
    '            <div class="exchange-rates-body">\n' +
    '              <div class="row m-b-30">\n' +
    '                <div class="col-sm-5">\n' +
    '                  <!-- CUSTOM FROM Accounts dropdown-->\n' +
    '\n' +
    '                  <label class="bold-font f-18" translate="payments.fromAccount"></label>\n' +
    '                  <div class="accounts-dropdown m-b-10" ng-if="eBookPay.accountsFrom.length > 0">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item" ng-click="eBookPay.toggleFromAccount()" ng-style="eBookPay.tempEbookObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + eBookPay.tempEbookObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                          {{eBookPay.tempEbookObj.fromAccountSelect.friendlyName}} </b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                          <i class="zmdi "\n' +
    '                             ng-class="{\'zmdi-star favorite-account\':eBookPay.tempEbookObj.fromAccountSelect.isFavorite,\n' +
    '                                       \'zmdi-star-outline\':!eBookPay.tempEbookObj.fromAccountSelect.isFavorite}"></i>\n' +
    '                        </span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{eBookPay.tempEbookObj.fromAccountSelect.accountNumber}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{eBookPay.tempEbookObj.fromAccountSelect.availableBalance | number:2}}\n' +
    '                        {{eBookPay.tempEbookObj.fromAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      <span class="caret-icon" ng-if="eBookPay.accountsFrom.length > 1">\n' +
    '                        <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <div class="accounts-list m-l-15 m-r-15" ng-show="eBookPay.fromAccountDropdown" scrollable>\n' +
    '                      <div class="accounts-list-item p-0" data-ng-repeat="item in eBookPay.accountsFrom"\n' +
    '                           data-ng-click="eBookPay.setAccountFrom(item);">\n' +
    '                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"  ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}" >\n' +
    '                          <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                          </h4>\n' +
    '                          <p class="m-b-0 m-t-0 iban-style">{{item.accountNumber}}</p>\n' +
    '                          <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                            {{item.availableBalance | number: 2}}\n' +
    '                            {{item.currencySymbol}}\n' +
    '                          </p>\n' +
    '                          <span class="d-block m-t-5 m-b-10">Available balance</span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="accounts-dropdown m-b-10" ng-if="eBookPay.accountsFrom.length == 0">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item" style="height: 133px; line-height: 133px"  ng-style="eBookPay.tempEbookObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + eBookPay.tempEbookObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      No available accounts\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '\n' +
    '                  <label class="bold-font" translate="internalTransfer.amount"></label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field t-a-r"\n' +
    '                           name="fromAccountAmountInput"\n' +
    '                           placeholder="{{\'eInvoicesModal.amountPlaceholder\' | translate}}"\n' +
    '                           amount-input-mask\n' +
    '                           maxlength="12"\n' +
    '                           data-ng-model="eBookPay.tempEbookObj.fromAccountAmountInput"\n' +
    '                           ng-if="eBookPay.ebookType===\'Pay In\'"\n' +
    '                           ng-blur="eBookPay.exchangeCurrency(false)"\n' +
    '                           ng-class="{\'domp-error\': eBookPay.eBookPayForm.fromAccountAmountInput.$invalid &&\n' +
    '                                     eBookPay.tempEbookObj.formSubmitted}"\n' +
    '                           required >\n' +
    '                    <input type="text" class="form-control input-field t-a-r"\n' +
    '                           name="fromAccountAmountInput"\n' +
    '                           placeholder="{{\'eInvoicesModal.amountPlaceholder\' | translate}}"\n' +
    '                           amount-input-mask\n' +
    '                           maxlength="12"\n' +
    '                           data-ng-model="eBookPay.tempEbookObj.fromAccountAmountInput"\n' +
    '                           ng-if="eBookPay.ebookType===\'Pay Out\'"\n' +
    '                           ng-class="{\'domp-error\': eBookPay.eBookPayForm.fromAccountAmountInput.$invalid &&\n' +
    '                                     eBookPay.tempEbookObj.formSubmitted}"\n' +
    '                           required>\n' +
    '                    <span class="input-group-btn">\n' +
    '                      <button type="button" class="btn input-group-app-btn domp-btn-height" style="border:1px solid #062a42;" disabled>\n' +
    '                        {{eBookPay.tempEbookObj.fromAccountSelect.currencySymbol}}\n' +
    '                      </button>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <span class="c-red" ng-show="eBookPay.eBookPayForm.fromAccountAmountInput.$error.required &&\n' +
    '                                               eBookPay.tempEbookObj.formSubmitted" translate="internalTransfer.amountInputError">\n' +
    '                  </span>\n' +
    '                  <span class="c-red" ng-show="eBookPay.eBookPayForm.fromAccountAmountInput.$error.maxlength &&\n' +
    '                                               eBookPay.tempEbookObj.formSubmitted"\n' +
    '                        translate="internalTransfer.amountLengthError">\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '                <div class="col-sm-2">\n' +
    '                  <div class="t-a-c exchange-office-middle">\n' +
    '                    <i class="zmdi zmdi-long-arrow-right zmdi-hc-2x"></i>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="col-md-5 col-sm-5">\n' +
    '                  <label class="bold-font f-18" translate="payments.toAccount"></label>\n' +
    '                  <!-- CUSTOM TO Accounts dropdown -->\n' +
    '                  <div class="accounts-dropdown">\n' +
    '\n' +
    '                    <div class="accounts-dropdown m-b-10" ng-if="eBookPay.accountsTo.length > 0">\n' +
    '                      <div class="debit-account-widget dashboard-widget-item"\n' +
    '                           data-ng-click="eBookPay.toggleToAccount();" ng-style="eBookPay.tempEbookObj.toAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + eBookPay.tempEbookObj.toAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                        <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                          <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                            {{eBookPay.tempEbookObj.toAccountSelect.friendlyName}} </b>\n' +
    '                          <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                            <i class="zmdi "\n' +
    '                               ng-class="{\'zmdi-star favorite-account\':account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                          </span>\n' +
    '                        </h4>\n' +
    '                        <p class="m-b-0 m-t-0 iban-style">{{eBookPay.tempEbookObj.toAccountSelect.accountNumber}}</p>\n' +
    '                        <p ng-show="eBookPay.tempEbookObj.hasEbookWithSelectedCurrency" class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                          {{eBookPay.tempEbookObj.toAccountSelect.availableBalance | number:2}}\n' +
    '                          {{eBookPay.tempEbookObj.toAccountSelect.currencySymbol}}\n' +
    '                        </p>\n' +
    '\n' +
    '                        <p ng-show="!eBookPay.tempEbookObj.hasEbookWithSelectedCurrency" translate="internalTransfer.nodata"\n' +
    '                           class="e-book-pay-in-no-data"></p>\n' +
    '\n' +
    '                        <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                        <span class="caret-icon" ng-if="eBookPay.accountsTo.length > 1">\n' +
    '                          <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                        </span>\n' +
    '                      </div>\n' +
    '                      <div class="from-accounts-list" ng-show="eBookPay.toAccountDropdown" scrollable>\n' +
    '                        <div class="accounts-list-item p-0" data-ng-repeat="item in eBookPay.accountsTo"\n' +
    '                             data-ng-click="eBookPay.setAccountTo(item);">\n' +
    '                          <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"  ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}" >\n' +
    '                            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                              <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                              <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                            </h4>\n' +
    '                            <p class="m-b-0 m-t-0 iban-style">{{item.accountNumber}}</p>\n' +
    '                            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                              {{item.availableBalance | number: 2}}\n' +
    '                              {{item.currencySymbol}}\n' +
    '                            </p>\n' +
    '                            <span class="d-block m-t-5 m-b-10">Available balance</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="accounts-dropdown m-b-10" ng-if="eBookPay.accountsTo.length == 0">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item" style="height: 133px; line-height: 133px" ng-style="eBookPay.tempEbookObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + eBookPay.tempEbookObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}" >\n' +
    '                      No available accounts\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- END TO ACCOUNT CONTROL -->\n' +
    '\n' +
    '                  <label class="bold-font" translate="currencyConversion.amount" ng-if="eBookPay.ebookType === \'Pay In\'"></label>\n' +
    '\n' +
    '                  <div class="row" ng-if="eBookPay.ebookType === \'Pay In\'">\n' +
    '                    <div class="col-sm-8 col-xs-8 p-r-0">\n' +
    '                      <input type="text" class="form-control input-field t-a-r"\n' +
    '                             placeholder="{{\'eInvoicesModal.amountPlaceholder\' | translate}}"\n' +
    '                             amount-input-mask\n' +
    '                             maxlength="12"\n' +
    '                             data-ng-model="eBookPay.tempEbookObj.toAccountAmountInput" disabled>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-4 col-xs-4 p-l-0">\n' +
    '                      <select class="form-control input-field" ng-options="item for item in eBookPay.currencyList"\n' +
    '                              data-ng-model="eBookPay.tempEbookObj.toCurrencySymbol"\n' +
    '                              data-ng-change="eBookPay.changeSellCurrency(true);"\n' +
    '                              ng-disabled="eBookPay.tempEbookObj.fromCurrencyInput != eBookPay.localCurrency" style="border:1px solid #062a42;">\n' +
    '                      </select>\n' +
    '                    </div>\n' +
    '                    <!--<div class="col-sm-4 col-xs-4 p-l-0">\n' +
    '<input type="text" class="form-control input-field" data-ng-model="eBookPay.tempEbookObj.buyCurrencyInput.symbol">\n' +
    '</div> -->\n' +
    '                  </div>\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-8 col-md-12 p-t-10">\n' +
    '                      <label class="bold-font" translate="internalTransfer.when"></label>\n' +
    '                      <div class="input-group">\n' +
    '                        <input type="text" class="form-control input-field" name="dueDateInput"\n' +
    '                               uib-datepicker-popup="shortDate" data-ng-model="eBookPay.tempEbookObj.dueDateInput"\n' +
    '                               show-weeks="false" is-open="eBookPay.datePickerOpened"\n' +
    '                               datepicker-options="eBookPay.dateOptions"\n' +
    '                               ng-class="{\'domp-error\': eBookPay.eBookPayForm.dueDateInput.$invalid && eBookPay.tempEbookObj.formSubmitted}"\n' +
    '                               required>\n' +
    '                        <span class="input-group-btn">\n' +
    '                          <button data-ng-click="eBookPay.openDatePicker()" type="button"\n' +
    '                                  class="btn input-group-app-btn domp-btn-height" style="border:1px solid #062a42;"><i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                          </button>\n' +
    '                        </span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="row">\n' +
    '                <div class="col-xs-6 t-a-l">\n' +
    '                  <button class="btn btn-primary" translate="payments.cancel"\n' +
    '                          data-ui-sref="payments.paymentsOverview">\n' +
    '                  </button>\n' +
    '                </div>\n' +
    '                <div class="col-xs-6 t-a-r">\n' +
    '                  <div class="pull-right">\n' +
    '                    <button class="btn btn-default app-btn-blue w-100 domp-review-and-submit-btn"\n' +
    '                            translate="currencyConversion.confirm"\n' +
    '                            data-ng-click="eBookPay.eBookPaySubmit();"\n' +
    '                            ng-disabled="eBookPay.submitButtonDisabled"\n' +
    '                            >\n' +
    '                      <!--  ng-disabled="eBookPay.accountsFrom.length == 0" -->\n' +
    '\n' +
    '                    </button>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Internal transfer STEP 2 -->\n' +
    '        <div ng-if="eBookPay.currentStep == 2">\n' +
    '          <div data-ng-include="\'payments/e-book-pay-resume.tpl.html\'">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Internal transfer STEP 3 -->\n' +
    '        <div ng-if="eBookPay.currentStep == 3">\n' +
    '          <div data-ng-include="\'payments/e-book-pay-final.tpl.html\'"></div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/e-book-pay-resume.tpl.html',
    '<form name="eBookPayForm" novalidate>\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{eBookPay.paymentResponse.fromAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel">Amount</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              {{eBookPay.paymentResponse.amount | currency:""}}\n' +
    '              {{eBookPay.paymentResponse.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel">When</label>\n' +
    '            <label class="d-block domp-form-label-resume">{{eBookPay.paymentResponse.dueDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="currencyConversion.toAccount">To account</label>\n' +
    '          <label class="d-block domp-form-label-resume">{{eBookPay.paymentResponse.toAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6" ng-if="eBookPay.ebookType===\'Pay In\'">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '          <label class="d-block domp-form-label-resume">{{eBookPay.paymentResponse.purpose}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-9 col-xs-6">\n' +
    '        <button class="btn btn-primary" translate="currencyConversion.back"\n' +
    '                data-ng-click="eBookPay.backToEbookPay();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary" translate="payments.edit"\n' +
    '                data-ng-click="eBookPay.editPayment();"\n' +
    '                >\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary-warning" translate="payments.delete"\n' +
    '                data-ng-click="eBookPay.deletePayment();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-3 col-xs-6">\n' +
    '        <div class="pull-right">\n' +
    '          <button class="btn btn-default"\n' +
    '                  translate="currencyConversion.sign"\n' +
    '                  data-ui-sref="payments.sign({paymentId: eBookPay.paymentResponse.id, type: \'ebook\'})">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/e-book-final.tpl.html',
    '<div class="currency-conversion-msg" >\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{eBookPayIn.paymentResponse.amount}}\n' +
    '            {{eBookPayIn.paymentResponse.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{eBookPayIn.paymentResponse.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{eBookPayIn.paymentResponse.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="exchange-rates">\n' +
    '      <div class="no-padding-on-phone">\n' +
    '\n' +
    '        <div ng-if="domesticPayment.location==\'hr\'" data-ng-include="\'payments/domestic-payment-cro.tpl.html\'"></div>\n' +
    '        <div ng-if="domesticPayment.location==\'sr\'" data-ng-include="\'payments/domestic-payment-srb.tpl.html\'"></div>\n' +
    '        <div ng-if="domesticPayment.location==\'mne\'" data-ng-include="\'payments/domestic-payment-mne.tpl.html\'"></div>\n' +
    '        <div ng-if="domesticPayment.location==\'sl\'" data-ng-include="\'payments/domestic-payment-slo.tpl.html\'"></div>\n' +
    '        <div ng-if="domesticPayment.location==\'bh\'" data-ng-include="\'payments/domestic-payment-bh.tpl.html\'"></div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment-srb.tpl.html',
    '<div ng-controller="DomesticPaymentSrbCtrl as domesticPaymentSrb">\n' +
    '  <div class="domp-header-wrapper col-sm-12 p-0" ng-show="domesticPaymentSrb.currentStep!=3">\n' +
    '    <div class="domp-header-row">\n' +
    '        <h2 class="f-28" translate="domesticPayment.header">Domestic Payment</h2>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="domp-body-wrapper">\n' +
    '    <div ng-if="domesticPaymentSrb.currentStep === 1" class="domp-step-1">\n' +
    '      <form novalidate name="domesticPaymentSrb.domesticPaymentForm">\n' +
    '        <div class="domp-select-section col-sm-12 p-0">\n' +
    '\n' +
    '          <!--SELECT TEMPLATE CUSTOM -->\n' +
    '\n' +
    '          <div class="domp-template-filter-container">\n' +
    '            <div class="domp-select-template" ng-click="domesticPaymentSrb.toggleTemplateFilterSelection()" ng-show="domesticPaymentSrb.templateName==\'\'">\n' +
    '              <div class="select-template label-select">\n' +
    '                <label class="p-t-10 f-18 p-t-5" translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                  <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '              <!-- Icon\n' +
    '                    <div class="col-lg-1 col-md-1 col-sm-2 col-xs-3">\n' +
    '                      <div ng-if="!template.imageId" class="invoice-icon">ico</div>\n' +
    '                      <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico"\n' +
    '                           class="tpl-rounded-img"/>\n' +
    '                    </div>\n' +
    '              -->\n' +
    '            <div class="domp-selected-template" ng-show="domesticPaymentSrb.templateName!=\'\'">\n' +
    '              <div class="select-template label-template-selected p-l-10 p-t-5" ng-show="domesticPaymentSrb.templateName!=\'\'">\n' +
    '<!--                <i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;" >\n' +
    '\n' +
    '                </i>-->\n' +
    '\n' +
    '                  <img ng-if="domesticPaymentSrb.selectedTemplate.imageId" ng-src="{{domesticPaymentSrb.selectedTemplate.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img-40"/>\n' +
    '                  <div ng-if="!domesticPaymentSrb.selectedTemplate.imageId" class="invoice-icon tpl-rounded-img-40" >ico</div>\n' +
    '                <label class="p-l-10 selected-template-label top-2"><b>{{domesticPaymentSrb.templateName}}</b></label>\n' +
    '                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5" ng-click="domesticPaymentSrb.removeTemplate()"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-template-filter-selection" ng-class="{\'opened\': domesticPaymentSrb.searchTemplateFilterExpanded}">\n' +
    '              <div class="search-template">\n' +
    '                <div class="inner-section left">\n' +
    '                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                </div>\n' +
    '                <div class="inner-section center" style="width: 50%;">\n' +
    '                  <input id="searchTemplatesInput" type="text" class="search-input" ng-model="domesticPaymentSrb.tmpSearchText.name" ng-change="domesticPaymentSrb.searchTemplate(domesticPaymentSrb.tmpSearchText.name)" placeholder="{{\'dashboard.searchTemplatesPlaceholder\' | translate}}">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="domp-template-filter">\n' +
    '                <div class="m-b-10">\n' +
    '                  <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfTemplates"></h4>\n' +
    '                  <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                    <a href="" class="list-group-item" data-ng-repeat="template in domesticPaymentSrb.templateList.result | filter:domesticPaymentSrb.tmpSearchText" ng-click="domesticPaymentSrb.selectTemplate(template.id)">\n' +
    '                      <div class="row m-r-0">\n' +
    '                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 p-r-0">\n' +
    '<!--                            <i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                            <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img"/>\n' +
    '                            <div ng-if="!template.imageId" class="invoice-icon tpl-rounded-img">ico</div>\n' +
    '                        </div>\n' +
    '                          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label p-t-15" style="padding-left: 50px !important;">\n' +
    '                          <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                          <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM END-->\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <div class="col-sm-12 domp-from-section">\n' +
    '          <!-- CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '          <div class="col-sm-6 domp-acc-dropdown">\n' +
    '            <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '            <div class="accounts-dropdown">\n' +
    '              <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="domesticPaymentSrb.toggleFromAccount();"  ng-style="domesticPaymentSrb.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + domesticPaymentSrb.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}" >\n' +
    '                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{domesticPaymentSrb.tempDompObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':domesticPaymentSrb.tempDompObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!domesticPaymentSrb.tempDompObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                                </h4>\n' +
    '                <p class="m-b-0 m-t-0 iban-style">{{domesticPaymentSrb.tempDompObj.fromAccountSelect.iban}}</p>\n' +
    '                <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                  {{domesticPaymentSrb.tempDompObj.fromAccountSelect.availableBalance | number:2}} {{domesticPaymentSrb.tempDompObj.fromAccountSelect.currencySymbol}}\n' +
    '                </p>\n' +
    '                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                <span class="caret-icon" ng-hide="domesticPaymentSrb.isRetrieval"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '              </div>\n' +
    '              <div class="from-accounts-list" ng-show="domesticPaymentSrb.fromAccountDropdown" scrollable>\n' +
    '                <div class="accounts-list-item p-0" data-ng-repeat="item in domesticPaymentSrb.paymentTypeGroupDomestic.result[0].debitAccountList" data-ng-click="domesticPaymentSrb.setAccountFrom(item);">\n' +
    '                  <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                        </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                      {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <div class="row m-r-0">\n' +
    '              <div class="col-sm-12">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="amountInput" translate="domesticPayment.amountInputLabel">Amount:</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask maxlength="12" ng-model="domesticPaymentSrb.tempDompObj.amountInput" required ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.amountInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" ng-disabled="domesticPaymentSrb.isRetrieval">\n' +
    '                    <span class="input-group-btn">\n' +
    '                                              <button type="button" class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">{{domesticPaymentSrb.defaultCurrency}}</button>\n' +
    '                                         </span>\n' +
    '                  </div>\n' +
    '                  <span class="c-red" ng-show="domesticPaymentSrb.domesticPaymentForm.amountInput.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row m-r-0">\n' +
    '              <div class="col-sm-8">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="dateInput" translate="domesticPayment.dateInputLabel">Date:</label>\n' +
    '                  <div class="input-group ">\n' +
    '                    <input type="text" class="form-control input-field" name="dateInput" id="dateInput" uib-datepicker-popup="shortDate" data-ng-model="domesticPaymentSrb.tempDompObj.dateInput" show-weeks="false" is-open="domesticPaymentSrb.datePickerOpened" datepicker-options="domesticPaymentSrb.dateOptions"  readonly>\n' +
    '                    <span class="input-group-btn">\n' +
    '                            <button data-ng-click="domesticPaymentSrb.openDatePicker()" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;"><i\n' +
    '                              class="icon icon-calendar" style="font-size: 21px;"></i></button>\n' +
    '                          </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-12 receiver-section">\n' +
    '          <div class="row m-r-0">\n' +
    '            <!-- Start Account number - input -->\n' +
    '            <div class="col-sm-6 col-xs-12 right-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toAccountInputLabelSRB">\n' +
    '                  Account number\n' +
    '                </label>\n' +
    '                <input type="text" class="form-control input-field" name="toAccountInput" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.onlyNumbersAndDashes}}" capitalize ng-minlength="6" dn-custom-maxlength="18" dn-exclude="-" ng-blur="domesticPaymentSrb.fillReceiver(domesticPaymentSrb.tempDompObj.toAccountInput); domesticPaymentSrb.fillReceiver(domesticPaymentSrb.tempDompObj.toAccountInput);" id="toAccountInput" ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.toAccountInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" ng-model="domesticPaymentSrb.tempDompObj.toAccountInput" required ng-disabled="domesticPaymentSrb.isRetrieval">\n' +
    '                <div class="c-red" ng-show="domesticPaymentSrb.domesticPaymentForm.toAccountInput.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="domesticPayment.receiverAccountError"></div>\n' +
    '                <div class="c-red" ng-show="domesticPaymentSrb.domesticPaymentForm.$error.minlength" translate="payments.minimalAccountNumber"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END Account number - input -->\n' +
    '            <!-- /////////// SELECT CUSTOM ///////////// -->\n' +
    '            <div click-outside="domesticPaymentSrb.searchFilterExpanded = false;" outside-if-not="expandPayeeSearchFilterSRB" class="col-sm-6 col-xs-12 left-section">\n' +
    '              <div  class="form-group" ng-hide="domesticPaymentSrb.isRetrieval">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toPayee">To payee</label>\n' +
    '                <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': domesticPaymentSrb.domesticPaymentForm.payeeSearchFilter.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}">\n' +
    '                  <div  class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                    <i  class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                    <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.allowedCharsDPS}}"\n' +
    '                           class="search-input" ng-model="domesticPaymentSrb.tempDompObj.receiversNameInput" ng-change="domesticPaymentSrb.searchPayee()"\n' +
    '                           required maxlength="35" ng-maxlength="35" autocomplete="off"\n' +
    '                           >\n' +
    '                  </div>\n' +
    '                  <div id="expandPayeeSearchFilterSRB" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right" ng-click="domesticPaymentSrb.toggleFilterSelection()">\n' +
    '                    <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentSrb.tempDompObj.receiversNameInput!=\'\'" ng-click="domesticPaymentSrb.removeSearch()"></i>\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right" ng-show="domesticPaymentSrb.tempDompObj.receiversNameInput==\'\'"></i>\n' +
    '                  </div>\n' +
    '                    <div class="domp-filter-selection search-row" ng-class="{\'opened\': domesticPaymentSrb.searchFilterExpanded}">\n' +
    '                    <div class="domp-filter-type-selection-wrapper" ng-repeat="payee in domesticPaymentSrb.payeeList | filter:domesticPaymentSrb.searchPayeeBy" ng-click="domesticPaymentSrb.selectPayee(payee.id)">\n' +
    '                      <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                        <i class="zmdi zmdi-account-circle"></i>\n' +
    '                      </div>\n' +
    '                      <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                        <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                        <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentSrb.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></span>\n' +
    '              </div>\n' +
    '              <div class="form-group" ng-hide="!domesticPaymentSrb.isRetrieval">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toPayee">To payee</label>\n' +
    '                <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.receiversAddressInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" name="payeeSearchFilter" id="payeeSearchFilter" ng-model="domesticPaymentSrb.tempDompObj.receiversNameInput" ng-blur="domesticPaymentSrb.replaceUnallowedCharsDPS(\'receiversAddressInput\', domesticPaymentSrb.tempDompObj.receiversAddressInput)" maxlength="35" ng-maxlength="35" required ng-disabled="domesticPaymentSrb.isRetrieval">\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentSrb.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!--//////////////SELECT CUSTOM END/////////////////////// -->\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 left-section"> </div>\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 right-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="receiversAddressInput" translate="domesticPayment.receiversAddressInputLabel">Receiver\'s address:</label>\n' +
    '                <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.receiversAddressInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" name="receiversAddressInput" id="receiversAddressInput" ng-model="domesticPaymentSrb.tempDompObj.receiversAddressInput" ng-blur="domesticPaymentSrb.replaceUnallowedCharsDPS(\'receiversAddressInput\', domesticPaymentSrb.tempDompObj.receiversAddressInput)" maxlength="35" ng-maxlength="35" required ng-disabled="domesticPaymentSrb.isRetrieval">\n' +
    '                <span class="c-red" ng-show="domesticPaymentSrb.domesticPaymentForm.receiversAddressInput.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="domesticPayment.receiverAddressError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 left-section"> </div>\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 right-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="receiversPostalCodeAndCityInput" translate="domesticPayment.receiversPostalCodeAndCityInputLabel">Receiver\'s postal code and city:\n' +
    '                </label>\n' +
    '                <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.receiversPostalCodeAndCityInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" name="receiversPostalCodeAndCityInput" id="receiversPostalCodeAndCityInput" ng-model="domesticPaymentSrb.tempDompObj.receiversPostalCodeAndCityInput" ng-blur="domesticPaymentSrb.replaceUnallowedCharsDPS(\'receiversPostalCodeAndCityInput\', domesticPaymentSrb.tempDompObj.receiversPostalCodeAndCityInput)" maxlength="35" ng-maxlength="35" ng-disabled="domesticPaymentSrb.isRetrieval">\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 purpose-section">\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <div class="col-lg-12 col-md-4 no-padding-on-phone p-r-0 p-l-0">\n' +
    '                  <label class="domp-form-label" for="purposeCodeSelect" translate="domesticPayment.purposeCodeSelectLabel">Purpose code</label>\n' +
    '                  <div class="p-l-0">\n' +
    '                    <select class="form-control input-field p-l-15 p-r-10" name="purposeCodeSelect" id="purposeCodeSelect" ng-options="option.optionValue for option in domesticPaymentSrb.purposeCodesList.result" ng-model="domesticPaymentSrb.tempDompObj.purposeCodeSelect" ng-change="domesticPaymentSrb.changePurpose(domesticPaymentSrb.tempDompObj.purposeCodeSelect)" ng-disabled="domesticPaymentSrb.isRetrieval"></select>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="col-lg-12 col-md-8 no-padding-on-phone p-r-0 p-l-0 p-t-10">\n' +
    '                  <label class="domp-form-label domp-purpose-label" for="purposeOfPaymentInput" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '                  <div class="p-0">\n' +
    '                    <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.purposeOfPaymentValidation}}" name="purposeOfPaymentInput" id="purposeOfPaymentInput" ng-maxlength="105" maxlength="105" ng-model="domesticPaymentSrb.tempDompObj.purposeOfPaymentInput" required ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" ng-blur="domesticPaymentSrb.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', domesticPaymentSrb.tempDompObj.purposeOfPaymentInput)" ng-disabled="domesticPaymentSrb.isRetrieval">\n' +
    '                    <span class="c-red" ng-show="domesticPaymentSrb.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- START Reference number - input -->\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 left-section">\n' +
    '              <div class="col-xs-12 p-l-0">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.referenceNumberLabel">Reference number:</label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-3 col-xs-4 p-l-0 p-r-5">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect" id="referenceModelSelect" ng-model="domesticPaymentSrb.tempDompObj.referenceModelSelect" >\n' +
    '                    <option ng-repeat="item in domesticPaymentSrb.referenceModelList">{{item}}</option>\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-9 col-xs-8 p-l-0 p-r-0">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <!-- Reference number for Serbia allows only uppercase letters, numbers and dashes-->\n' +
    '                  <!-- capitalize (attribute) directive forces uppercase letters-->\n' +
    '                  <input type="text" id="referenceNumberInput" class="form-control input-field" name="referenceNumberInput" ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" maxlength="22" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.allLettersNumbersDashes}}" ng-if="domesticPaymentSrb.tempDompObj.referenceModelSelect!=\'97\' && domesticPaymentSrb.tempDompObj.referenceModelSelect!=\'11\'" ng-model="domesticPaymentSrb.tempDompObj.referenceNumberInput" capitalize/>\n' +
    '                  <input type="text" id="referenceNumberInput" ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" class="form-control input-field" name="referenceNumberInput" maxlength="22" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.allLettersNumbersDashes}}" ng-blur="domesticPaymentSrb.checkModul97Reference(\'97\' + domesticPaymentSrb.tempDompObj.referenceNumberInput)" ng-if="domesticPaymentSrb.tempDompObj.referenceModelSelect==\'97\'" ng-model="domesticPaymentSrb.tempDompObj.referenceNumberInput" capitalize required/>\n' +
    '                  <input type="text" id="referenceNumberInput" ng-class="{\'domp-error\': domesticPaymentSrb.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentSrb.tempDompObj.formSubmitted}" class="form-control input-field" name="referenceNumberInput" maxlength="22" ng-pattern-restrict="{{domesticPaymentSrb.regexPatterns.allLettersNumbersDashes}}" ng-if="domesticPaymentSrb.tempDompObj.referenceModelSelect==\'11\'" ng-model="domesticPaymentSrb.tempDompObj.referenceNumberInput" capitalize required/>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- START Error messages -->\n' +
    '              <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-if="domesticPaymentSrb.tempDompObj.referenceModelSelect==\'97\' &&\n' +
    '                 domesticPaymentSrb.domesticPaymentForm.referenceNumberInput.$error.modul97reference == true " translate="domesticPayment.referenceModelInputInvalid">\n' +
    '              </div>\n' +
    '              <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-if="domesticPaymentSrb.domesticPaymentForm.referenceNumberInput.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="domesticPayment.referenceModelInputError">\n' +
    '              </div>\n' +
    '              <!--<div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-show="domesticPaymentSrb.domesticPaymentForm.referenceNumberInput.$error.required && domesticPaymentSrb.tempDompObj.formSubmitted" translate="domesticPayment.referenceModelInputError"></div>-->\n' +
    '              <!--   <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-show="domesticPayment.domesticPaymentForm.referenceModelInput.$invalid && domesticPayment.tempDompObj.referenceModelInput != \'\' && !domesticPayment.tempDompObj.formSubmitted" translate="domesticPayment.referenceModelInputInvalid"></span> -->\n' +
    '              <!-- END Error messages -->\n' +
    '            </div>\n' +
    '            <!-- END Reference number input -->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="domp-footer-wrapper">\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-sm-6 col-lg-6 col-md-6 p-l-30">\n' +
    '              <div class="col-xs-12 p-l-10">\n' +
    '                <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                    <input type="checkbox" ng-model="domesticPaymentSrb.tempDompObj.isUrgentPaymentCheckbox" ng-click="domesticPaymentSrb.pushGtmUrgentPaymentEvent();">\n' +
    '                  <i class="input-helper"></i> {{\'domesticPayment.selectUrgentLabelSRB\' | translate}} <i uib-tooltip="{{\'domesticPayment.urgentPaymentInfo\' | translate}}" tooltip-append-to-body="true" tooltip-trigger="mouseenter" tooltip-placement="top" class="icon icon-question" style="font-weight: bolder; color:#ff4d5a;"></i>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 col-lg-6 col-md-6">\n' +
    '              <div class="col-lg-7 col-md-6 col-sm-5"></div>\n' +
    '              <div class="col-lg-5 col-md-6 col-sm-7 col-xs-12 p-r-5 p-t-10 charges-label">\n' +
    '                  <a ng-href="{{domesticPaymentSrb.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges" class="pull-right">Check the bank charges</a>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-xs-6 t-a-l">\n' +
    '              <button class="btn btn-primary" type="button" translate="payments.cancel"\n' +
    '                      data-ui-sref="payments.paymentsOverview">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 t-a-r">\n' +
    '              <button class="btn btn-default" type="submit"\n' +
    '                      translate="domesticPayment.confirmBtn"\n' +
    '                      ng-click="domesticPaymentSrb.submitPayment();"></button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '    <div ng-if="domesticPaymentSrb.currentStep === 2" class="domp-step-2" ng-include="\'payments/domestic-payment-resume.tpl.html\'"></div>\n' +
    '    <div ng-if="domesticPaymentSrb.currentStep == 3">\n' +
    '      <div data-ng-include="\'payments/domestic-payment-final.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment-slo.tpl.html',
    '<div ng-controller="DomesticPaymentSloCtrl as domesticPaymentSlo">\n' +
    '  <div class="domp-header-wrapper" ng-show="domesticPaymentSlo.currentStep != 3">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <h2  class="f-28" translate="domesticPayment.headerSl">Domestic Payment</h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="domp-body-wrapper">\n' +
    '    <div ng-if="domesticPaymentSlo.currentStep === 1" class="domp-step-1">\n' +
    '      <form novalidate name="domesticPaymentSlo.domesticPaymentForm">\n' +
    '\n' +
    '        <div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM-->\n' +
    '          <div ng-if="!domesticPaymentSlo.disableAllFields" class="domp-template-filter-container" style="position: relative">\n' +
    '            <div class="domp-select-template" ng-click="domesticPaymentSlo.toggleTemplateFilterSelection(); domesticPaymentSlo.donationTemplateListExpanded = false;"\n' +
    '                 ng-show="domesticPaymentSlo.templateName == \'\'">\n' +
    '              <div class="select-template label-select">\n' +
    '                <label class="col-xs-10 p-t-15 f-18 hidden-xs" translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                <label class="col-xs-10 p-t-15 f-10 visible-xs" translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-selected-template" ng-show="domesticPaymentSlo.templateName != \'\'">\n' +
    '              <div class="select-template label-template-selected p-l-10 p-t-5" ng-show="domesticPaymentSlo.templateName != \'\'">\n' +
    '                <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '\n' +
    '                <img ng-if="domesticPaymentSlo.selectedTemplate.imageId" ng-src="{{domesticPaymentSlo.selectedTemplate.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img-40"/>\n' +
    '                <img ng-if="!domesticPaymentSlo.selectedTemplate.imageId" class="tpl-rounded-img-40" alt="Ico"/>\n' +
    '\n' +
    '                <label class="p-l-10 selected-template-label top-2"><b>{{domesticPaymentSlo.templateName}}</b></label>\n' +
    '                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5" ng-click="domesticPaymentSlo.removeTemplate()"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-template-filter-selection" ng-class="{\'opened\': domesticPaymentSlo.searchTemplateFilterExpanded}">\n' +
    '              <div class="search-template">\n' +
    '                <div class="inner-section left">\n' +
    '                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                </div>\n' +
    '                <div class="inner-section center" style="width:50%;">\n' +
    '                  <input id="searchTemplatesInput" type="text" class="search-input" ng-model="domesticPaymentSlo.tmpSearchText.name" ng-change="domesticPaymentSlo.searchTemplate(domesticPaymentSlo.tmpSearchText.name)" placeholder="{{\'dashboard.searchTemplatesPlaceholder\'| translate}}">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="domp-template-filter">\n' +
    '                <div class="m-b-10">\n' +
    '                  <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfTemplates"></h4>\n' +
    '                  <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                    <a href="" class="list-group-item" data-ng-repeat="template in domesticPaymentSlo.templateList.result| filter:domesticPaymentSlo.tmpSearchText" ng-click="domesticPaymentSlo.selectTemplate(template.id)">\n' +
    '                      <div class="row m-r-0">\n' +
    '                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 p-r-0">\n' +
    '                          <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                          <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img"/>\n' +
    '                          <img ng-if="!template.imageId" class="tpl-rounded-img" alt="Ico"/>\n' +
    '                        </div>\n' +
    '                        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label p-t-15"  style="padding-left: 50px !important;">\n' +
    '                          <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                          <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM END-->\n' +
    '        </div>\n' +
    '\n' +
    '        <!--SELECT HUMANITARIAN TEMPLATE CUSTOM-->\n' +
    '          <div ng-if="!domesticPaymentSlo.disableAllFields" class="domp-template-filter-container" style="position: relative">\n' +
    '            <div class="domp-select-template" ng-click="domesticPaymentSlo.donationTemplateListExpanded = !domesticPaymentSlo.donationTemplateListExpanded; domesticPaymentSlo.searchTemplateFilterExpanded = false;" ng-show="domesticPaymentSlo.humanitarianName == \'\'">\n' +
    '              <div class="select-template label-select">\n' +
    '                <label class="col-xs-10 p-t-15 f-18 hidden-xs" translate="domesticPayment.selectHumanitarianOrganisationLabel"></label>\n' +
    '                <label class="col-xs-10 p-t-15 f-10 visible-xs" translate="domesticPayment.selectHumanitarianOrganisationLabel"></label>\n' +
    '                <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-selected-template" ng-show="domesticPaymentSlo.humanitarianName != \'\'">\n' +
    '              <div class="select-template label-template-selected p-l-10 p-t-5" ng-show="domesticPaymentSlo.humanitarianName != \'\'">\n' +
    '                <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '\n' +
    '                <i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>\n' +
    '\n' +
    '                <label class="p-l-10 selected-template-label"><b>{{domesticPaymentSlo.humanitarianName}}</b></label>\n' +
    '                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5" ng-click="domesticPaymentSlo.removeHumanitarian()"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-template-filter-selection" ng-class="{\'opened\': domesticPaymentSlo.donationTemplateListExpanded}">\n' +
    '              <div class="search-template">\n' +
    '                <div class="inner-section left">\n' +
    '                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                </div>\n' +
    '                <div class="inner-section center" style="width:50%;">\n' +
    '                  <input id="searchTemplatesInput" type="text" class="search-input" ng-model="domesticPaymentSlo.hOrganisationNameSearch" placeholder="Search organisation">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="domp-template-filter">\n' +
    '                <div class="m-b-10">\n' +
    '                  <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfOrganisations"></h4>\n' +
    '                  <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                    <a href="" class="list-group-item" data-ng-repeat="template in domesticPaymentSlo.humaniOrgList | filter:domesticPaymentSlo.hOrganisationNameSearch"\n' +
    '                       ng-click="domesticPaymentSlo.selectHumanitarian(template)">\n' +
    '                      <div class="row m-r-0">\n' +
    '                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 p-r-0">\n' +
    '                          <i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>\n' +
    '                          <!--                          <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img"/>\n' +
    '                                                    <img ng-if="!template.imageId" class="tpl-rounded-img" alt="Ico"/>-->\n' +
    '                        </div>\n' +
    '                        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label p-t-15"  style="padding-left: 50px !important;">\n' +
    '                          <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                          <!--<p class="list-group-item-text">{{template.toAccountNumber}}</p>-->\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        <!--SELECT HUMANITARIAN TEMPLATE CUSTOM END-->\n' +
    '\n' +
    '        <div class="domp-from-section p-20">\n' +
    '          <section class="row">\n' +
    '            <!-- START CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12">\n' +
    '              <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '              <div class="accounts-dropdown">\n' +
    '                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="domesticPaymentSlo.toggleFromAccount();" ng-style="domesticPaymentSlo.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + domesticPaymentSlo.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{domesticPaymentSlo.tempDompObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':domesticPaymentSlo.tempDompObj.fromAccountSelect.isFavorite, \'zmdi-star-outline\':!domesticPaymentSlo.tempDompObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{domesticPaymentSlo.tempDompObj.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{domesticPaymentSlo.tempDompObj.fromAccountSelect.availableBalance| number:2}} {{domesticPaymentSlo.tempDompObj.fromAccountSelect.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                </div>\n' +
    '                <div class="from-accounts-list " ng-show="domesticPaymentSlo.fromAccountDropdown" scrollable>\n' +
    '                  <div class="accounts-list-item p-0" data-ng-repeat="item in domesticPaymentSlo.paymentTypeGroupDomestic.result[0].debitAccountList" data-ng-click="domesticPaymentSlo.setAccountFrom(item);">\n' +
    '\n' +
    '                    <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite, \'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="amountInput" translate="domesticPayment.amountInputLabel">Amount:</label>\n' +
    '                <div class="input-group">\n' +
    '                  <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                         placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                         amount-input-mask  max-amount="99999999999.99" maxlength="17" ng-model="domesticPaymentSlo.tempDompObj.amountInput"\n' +
    '                         required\n' +
    '                         ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.amountInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                         ng-readonly="domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment">\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <button type="button" class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                            ng-if="domesticPayment.countryCode != \'sr\'" style="border:1px solid #062a42;">{{domesticPaymentSlo.defaultCurrency}}</button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '                <span class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.amountInput.$error.maxAmount && domesticPaymentSlo.tempDompObj.formSubmitted" translate="internalTransfer.amountLengthError"></span>\n' +
    '                <span class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.amountInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="dateInput" translate="domesticPayment.dateInputLabel">Date:</label>\n' +
    '                <div class="input-group ">\n' +
    '                  <input type="text" class="form-control input-field" name="dateInput"\n' +
    '                         ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.dateInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                         id="dateInput" uib-datepicker-popup="shortDate" data-ng-model="domesticPaymentSlo.tempDompObj.dateInput"\n' +
    '                         show-weeks="false" is-open="domesticPaymentSlo.datePickerOpened" datepicker-options="domesticPaymentSlo.dateOptions"\n' +
    '                         date-disabled="domesticPaymentSlo.disabled(date, mode)" readonly required ng-if="domesticPaymentSlo.disabledSunday">\n' +
    '                  <input type="text" class="form-control input-field" name="dateInput" id="dateInput"\n' +
    '                         uib-datepicker-popup="shortDate" data-ng-model="domesticPaymentSlo.tempDompObj.dateInput"\n' +
    '                         show-weeks="false" is-open="domesticPaymentSlo.datePickerOpened" datepicker-options="domesticPaymentSlo.dateOptions"\n' +
    '                         readonly\n' +
    '                         ng-if="!domesticPaymentSlo.disabledSunday">\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <button ng-disabled="domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment" data-ng-click="domesticPaymentSlo.openDatePicker()" type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '                      <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '\n' +
    '          <section class="row" ng-if="!domesticPaymentSlo.naturalPerson">\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '              <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                <uib-accordion-group>\n' +
    '                  <uib-accordion-heading>\n' +
    '                    <div class="sepa-heading input-field">\n' +
    '                      <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                        <label class="domp-form-label-sepa" translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                    </div>\n' +
    '                  </uib-accordion-heading>\n' +
    '                  <input id="payersSepaInput1" ng-readonly="domesticPaymentSlo.disableAllFields" type="text" class="form-control input-field"\n' +
    '                         ng-model="domesticPaymentSlo.tempDompObj.payersSepaInput1"\n' +
    '                         ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.standardInput}}" style="margin-bottom:10px;" maxlength="70">\n' +
    '                  <!--<input id="payersSepaInput2" ng-readonly="domesticPaymentSlo.disableAllFields" type="text" class="form-control input-field" -->\n' +
    '                         <!--ng-model="domesticPaymentSlo.tempDompObj.payersSepaInput2" ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.standardInput}}" -->\n' +
    '                         <!--maxlength="70">-->\n' +
    '                </uib-accordion-group>\n' +
    '              </uib-accordion>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <div class="domp-from-section clearfix">\n' +
    '\n' +
    '          <div class="col-md-6 p-0">\n' +
    '            <!-- START: IBAN PREJEMNIKA-->\n' +
    '            <div class="form-group col-xs-12">\n' +
    '              <div>\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toAccountInputLabelSLO">\n' +
    '                  Account number\n' +
    '                </label>\n' +
    '                <input ng-show="!domesticPaymentSlo.isFromTemplate || domesticPaymentSlo.isSecondaryTemplateResponseEmpty" ng-readonly="domesticPaymentSlo.disableAllFields" type="text" class="form-control input-field"\n' +
    '                       style="text-transform: uppercase;"\n' +
    '                       ng-blur="\n' +
    '                       domesticPaymentSlo.getBicByIban(domesticPaymentSlo.tempDompObj.toAccountInput);\n' +
    '                       domesticPaymentSlo.checkIban(domesticPaymentSlo.tempDompObj.toAccountInput);\n' +
    '                       domesticPaymentSlo.checkAccountsEquality();"\n' +
    '                       ng-change="domesticPaymentSlo.addSpaceForIban(domesticPaymentSlo.tempDompObj.toAccountInput);"\n' +
    '                       ui-mask="{{domesticPaymentSlo.uiMask}}"\n' +
    '                       ui-mask-placeholder\n' +
    '                       ui-mask-placeholder-char="space"\n' +
    '                       maxlength="{{domesticPaymentSlo.ibanMaxlength}}"\n' +
    '                       ng-keyup="$event.keyCode == 13 && domesticPaymentSlo.checkIfNaturalPerson(domesticPaymentSlo.tempDompObj.toAccountInput);"\n' +
    '                       ng-model="domesticPaymentSlo.tempDompObj.toAccountInput"\n' +
    '                       ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.toAccountInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                       name="toAccountInput" id="toAccountInput" required\n' +
    '                       ng-disabled="domesticPaymentSlo.toAccountDisabled">\n' +
    '                <label name="toAccountInput" ng-show="domesticPaymentSlo.isFromTemplate && !domesticPaymentSlo.isSecondaryTemplateResponseEmpty" class="domp-form-label-resume">\n' +
    '                  {{domesticPaymentSlo.tempDompObj.toAccountInput}}\n' +
    '                </label>\n' +
    '                <!--<div class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted" -->\n' +
    '                <!--translate="domesticPayment.receiverAccountError"></div>-->\n' +
    '                <!--<div class="c-red"-->\n' +
    '                <!--ng-show="!domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.required -->\n' +
    '                <!--&& !domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.accountEquality -->\n' +
    '                <!--&& domesticPaymentSlo.domesticPaymentForm.toAccountInput.$invalid -->\n' +
    '                <!--&& domesticPaymentSlo.tempDompObj.formSubmitted" -->\n' +
    '                <!--translate="domesticPayment.ibanStructError"></div>-->\n' +
    '                <div class="c-red"\n' +
    '                     ng-show="!domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.accountEquality\n' +
    '                     && (domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.required ||\n' +
    '                     domesticPaymentSlo.domesticPaymentForm.toAccountInput.$invalid ||\n' +
    '                     domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.minlength ) &&\n' +
    '                      domesticPaymentSlo.tempDompObj.formSubmitted"\n' +
    '                     translate="domesticPayment.ibanStructError"></div>\n' +
    '                <!--<div class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.accountEquality && domesticPaymentSlo.tempDompObj.formSubmitted" translate="domesticPayment.accountEqualityError"></div>-->\n' +
    '                <!--<div class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.toAccountInput.$error.minlength && domesticPaymentSlo.tempDompObj.formSubmitted" translate="domesticPayment.toAccountMinlength19"></div>-->\n' +
    '              </div>\n' +
    '              <div ng-hide="true" class="form-group">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.bicBankPrejemnika">\n' +
    '                  BIC banke prejemnika\n' +
    '                </label>\n' +
    '                <input ng-readonly="domesticPaymentSlo.disableAllFields" type="text" class="form-control input-field"  ng-model="domesticPaymentSlo.tempDompObj.beneficiarySWIFTCode"  name="beneficiarySWIFTCode" id="beneficiarySWIFTCode" disabled>\n' +
    '                <a ng-href="{{domesticPaymentSlo.defaultData.SepaRegisterLink}}" target="_blank" translate="domesticPayment.sepaRegister" class="underline">SEPA register</a>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END: IBAN PREJEMNIKA-->\n' +
    '            <!-- START: COUNTRIES -->\n' +
    '            <div class="form-group col-xs-12" ng-if="!domesticPaymentSlo.naturalPerson" >\n' +
    '              <div class="p-l-0">\n' +
    '                <select class="form-control input-field p-l-15 p-r-10" name="receiversCountry" id="receiversCountry"\n' +
    '                        ng-options="option.countryCode as option.description | translate for option in domesticPaymentSlo.countriesCodeList.result"\n' +
    '                        ng-model="domesticPaymentSlo.tempDompObj.receiversCountry"\n' +
    '\n' +
    '                        ng-disabled="domesticPaymentSlo.naturalPerson || domesticPaymentSlo.disableAllFields">\n' +
    '                </select>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END: COUNTRIES -->\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-if="!domesticPaymentSlo.naturalPerson"  class="col-md-6 p-0">\n' +
    '            <!-- START: NAZIV-->\n' +
    '            <div  click-outside="domesticPaymentSlo.searchFilterExpanded = false;" outside-if-not="expandPayeeSearchFilterSLO">\n' +
    '              <div class="form-group col-xs-12">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toPayee2">To payee</label>\n' +
    '                <label ng-if="domesticPaymentSlo.isFromTemplate && !domesticPaymentSlo.isSecondaryTemplateResponseEmpty" class="domp-form-label-resume">\n' +
    '                  {{domesticPaymentSlo.tempDompObj.receiversNameInput}}\n' +
    '                </label>\n' +
    '\n' +
    '                <div ng-if="!domesticPaymentSlo.isFromTemplate || domesticPaymentSlo.isSecondaryTemplateResponseEmpty" class="col-sm-12 col-xs-12 domp-filter-container input-field" ng-class="{\'domp-error-custom-payee\': domesticPaymentSlo.domesticPaymentForm.payeeSearchFilter.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}">\n' +
    '                  <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                    <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                    <input ng-readonly="domesticPaymentSlo.disableAllFields" type="text" name="payeeSearchFilter" id="payeeSearchFilter" class="search-input"\n' +
    '                           ng-model="domesticPaymentSlo.tempDompObj.receiversNameInput"\n' +
    '                           ng-change="domesticPaymentSlo.searchPayee()"\n' +
    '                           ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.receiverNameInput}}"\n' +
    '                           maxlength="70"\n' +
    '                           autocomplete="off"\n' +
    '                           ng-disabled="domesticPaymentSlo.toAccountDisabled || domesticPaymentSlo.naturalPerson"\n' +
    '                           ng-class="{\'bcg-white\': domesticPaymentSlo.toAccountDisabled }"\n' +
    '                           style="background: none;"\n' +
    '                           ng-required="!domesticPaymentSlo.naturalPerson && !domesticPaymentSlo.toAccountDisabled"\n' +
    '                    >\n' +
    '                  </div>\n' +
    '                  <div ng-hide="domesticPaymentSlo.disableAllFields" id="expandPayeeSearchFilterSLO"\n' +
    '                       class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                       ng-click="domesticPaymentSlo.toggleFilterSelection()">\n' +
    '                    <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentSlo.tempDompObj.receiversNameInput != \'\'"\n' +
    '                       ng-click="domesticPaymentSlo.removeSearch()"></i>\n' +
    '                    <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                       ng-show="domesticPaymentSlo.tempDompObj.receiversNameInput == \'\'"></i>\n' +
    '                  </div>\n' +
    '                  <div class="domp-filter-selection search-row" ng-class="{\'opened\': domesticPaymentSlo.searchFilterExpanded}">\n' +
    '                    <div class="domp-filter-type-selection-wrapper" ng-repeat="payee in  domesticPaymentSlo.payeeList| filter:domesticPaymentSlo.searchPayeeBy"\n' +
    '                         ng-click="domesticPaymentSlo.selectPayee(payee.id)">\n' +
    '                      <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                        <i class="zmdi zmdi-account-circle"></i>\n' +
    '                      </div>\n' +
    '                      <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                        <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                        <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentSlo.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END: NAZIV-->\n' +
    '\n' +
    '            <!-- START: NASLOV -->\n' +
    '            <div class="form-group col-xs-12">\n' +
    '              <!-- <label class="domp-form-label" for="receiversAddressInput" translate="domesticPayment.receiversAddressInputLabel">Receiver\'s address:</label> -->\n' +
    '              <input ng-readonly="domesticPaymentSlo.disableAllFields" type="text" class="form-control input-field" name="receiversAddressInput"\n' +
    '                     ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.receiverNameInput}}"\n' +
    '                     ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.receiversAddressInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                     ng-model="domesticPaymentSlo.tempDompObj.receiversAddressInput"\n' +
    '                     ng-blur="domesticPaymentSlo.replaceUnallowedCharsDPS(\'receiversAddressInput\', domesticPaymentSlo.tempDompObj.receiversAddressInput)"\n' +
    '                     maxlength="70" ng-maxlength="70"\n' +
    '                     ng-required="!domesticPaymentSlo.naturalPerson">\n' +
    '              <span class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.receiversAddressInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted" translate="domesticPayment.receiverAddressError"></span>\n' +
    '            </div>\n' +
    '            <!-- END: NASLOV -->\n' +
    '            <!-- START: THIRD -->\n' +
    '            <div class="form-group col-xs-12">\n' +
    '              <input ng-readonly="domesticPaymentSlo.disableAllFields" type="text" class="form-control input-field"\n' +
    '                     name="receiversPostalCodeAndCityInput"\n' +
    '                     ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.receiverNameInput}}"\n' +
    '                     ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.receiversPostalCodeAndCityInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                     ng-model="domesticPaymentSlo.tempDompObj.receiversPostalCodeAndCityInput"\n' +
    '                     ng-blur="domesticPaymentSlo.replaceUnallowedCharsDPS(\'receiversPostalCodeAndCityInput\', domesticPaymentSlo.tempDompObj.receiversPostalCodeAndCityInput)"\n' +
    '                     maxlength="70"\n' +
    '                     ng-required="!domesticPaymentSlo.naturalPerson">\n' +
    '              <span class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.receiversPostalCodeAndCityInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted" translate="domesticPayment.receiversPostalCodeAndCityInputError"></span>\n' +
    '            </div>\n' +
    '            <!-- END: THIRD-->\n' +
    '            <!-- START: UPNIK -->\n' +
    '            <div class="form-group col-xs-12">\n' +
    '                <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                  <uib-accordion-group>\n' +
    '                    <uib-accordion-heading>\n' +
    '                      <div class="sepa-heading input-field">\n' +
    '                        <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                          <label class="domp-form-label-sepa" translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                      </div>\n' +
    '                    </uib-accordion-heading>\n' +
    '                    <input ng-readonly="domesticPaymentSlo.disableAllFields" id="receiversSepaInput1" type="text" class="form-control input-field"\n' +
    '                           ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.allowedCharsDPS}}" ng-model="domesticPaymentSlo.tempDompObj.receiversSepaInput1" style="margin-bottom:10px;" maxlength="70">\n' +
    '                    <!--<input ng-readonly="domesticPaymentSlo.disableAllFields" id="receiversSepaInput2" type="text" class="form-control input-field" -->\n' +
    '                    <!--ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.allowedCharsDPS}}" ng-model="domesticPaymentSlo.tempDompObj.receiversSepaInput2" maxlength="35">-->\n' +
    '                  </uib-accordion-group>\n' +
    '                </uib-accordion>\n' +
    '            </div>\n' +
    '            <!-- END: UPNIK -->\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="domp-from-section p-20">\n' +
    '          <section class="row" ng-if="!domesticPaymentSlo.naturalPerson || domesticPaymentSlo.paymentTypeIsLoar">\n' +
    '            <div ng-if="!domesticPaymentSlo.naturalPerson" class="col-lg-6 col-md-6 col-xs-12 col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="purposeCodeSelect" translate="domesticPayment.purposeCodeSelectLabel">Purpose code</label>\n' +
    '                <div class="p-l-0">\n' +
    '                  <select ng-disabled="(domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment) || domesticPaymentSlo.disableAllFieldsForChange"\n' +
    '                          class="form-control input-field p-l-15 p-r-10" name="purposeCodeSelect"\n' +
    '                          id="purposeCodeSelect"\n' +
    '                          ng-options="option.optionValue for option in domesticPaymentSlo.purposeCodesList.result"\n' +
    '                          ng-model="domesticPaymentSlo.tempDompObj.purposeCodeSelect"\n' +
    '                          ng-change="domesticPaymentSlo.changePurpose(domesticPaymentSlo.tempDompObj.purposeCodeSelect)"></select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="!domesticPaymentSlo.naturalPerson || domesticPaymentSlo.paymentTypeIsLoar" class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12 pull-right">\n' +
    '              <div class="col-xs-12 p-l-0">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.referenceNumberLabel">Reference number:\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-3 col-xs-3 p-l-0 p-r-5">\n' +
    '                <select ng-disabled="(domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment) || domesticPaymentSlo.disableAllFieldsForChange"  type="text" class="form-control input-field p-l-15 p-r-10"\n' +
    '                        ng-options="option.name as option.value for option in domesticPaymentSlo.referenceList "\n' +
    '                        name="referenceModel" id="referenceModel"\n' +
    '                        ng-model="domesticPaymentSlo.referenceHR"\n' +
    '                        ng-change="domesticPaymentSlo.setPurposeMaxlengthValue(); domesticPaymentSlo.setRefModelToDefault(); domesticPaymentSlo.tempDompObj.referenceNumberInput = \'\';"\n' +
    '                        required>\n' +
    '                </select>\n' +
    '              </div>\n' +
    '              <div ng-if="domesticPaymentSlo.referenceHR == \'SI\'" class="col-sm-3 col-xs-3 p-l-0 p-r-5">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <select ng-disabled="(domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment) || domesticPaymentSlo.disableAllFieldsForChange"\n' +
    '                          class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect" id="referenceModelSelect"\n' +
    '                          ng-class="{\'domp-error\': domesticPaymentSlo.tempDompObj.referenceModelSelect.split(\' \').join(\'\') === \'\' && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                          ng-model="domesticPaymentSlo.tempDompObj.referenceModelSelect"\n' +
    '                          ng-options="item as item for item in domesticPaymentSlo.referenceModelList"\n' +
    '                          ng-change="domesticPaymentSlo.clearReferenceNumber();domesticPaymentSlo.setPurposeMaxlengthValue();"\n' +
    '                          required>\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div  class="col-sm-6 col-xs-6 p-l-0 p-r-0" ng-if="domesticPaymentSlo.tempDompObj.referenceModelSelect != \'99\' && domesticPaymentSlo.referenceHR != \'NRC\'">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <input ng-readonly="(domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment) || domesticPaymentSlo.disableAllFieldsForChange"\n' +
    '                         ng-class="{\'domp-error\': domesticPaymentSlo.referenceHR == \'RF\' && domesticPaymentSlo.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                         type="text" id="referenceNumberInput"\n' +
    '                         name="referenceNumberInput"\n' +
    '                         class="form-control input-field"\n' +
    '                         ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.allLettersNumbersDashes}}"\n' +
    '                         ng-model="domesticPaymentSlo.tempDompObj.referenceNumberInput"\n' +
    '                         maxlength="{{(domesticPaymentSlo.referenceHR == \'RF\') ? 23 : 22 }}"\n' +
    '                        ng-required="domesticPaymentSlo.referenceHR == \'RF\'">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <span ng-if="domesticPaymentSlo.referenceHR === \'NRC\'" class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 m-t-5"\n' +
    '                    ng-show="domesticPaymentSlo.domesticPaymentForm.referenceNumberInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted"\n' +
    '                    translate="domesticPayment.referenceModelInputError"></span>\n' +
    '              <span ng-if="domesticPaymentSlo.referenceHR === \'RF\'" class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 m-t-5"\n' +
    '                    ng-show="domesticPaymentSlo.domesticPaymentForm.referenceNumberInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted"\n' +
    '                    translate="domesticPayment.referenceModelInputRFError"></span>\n' +
    '              <span ng-if="domesticPaymentSlo.referenceHR === \'SI\'" class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 m-t-5"\n' +
    '                    ng-show="domesticPaymentSlo.tempDompObj.referenceModelSelect.split(\' \').join(\'\') === \'\' && domesticPaymentSlo.tempDompObj.formSubmitted"\n' +
    '                    translate="domesticPayment.referenceModelInputSIError"></span>\n' +
    '\n' +
    '            </div>\n' +
    '          </section>\n' +
    '\n' +
    '\n' +
    '\n' +
    '          <div class="row ">\n' +
    '            <div class="col-md-12">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label domp-purpose-label" for="purposeOfPaymentInput" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '                <!--<div class="p-0" ng-switch="domesticPaymentSlo.referenceHR">-->\n' +
    '                  <input ng-readonly="domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment" type="text"\n' +
    '                         class="form-control input-field"\n' +
    '                         ng-if="domesticPaymentSlo.referenceHR == \'NRC\'"\n' +
    '                         ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.standardInput}}"\n' +
    '                         name="purposeOfPaymentInput" id="purposeOfPaymentInput" maxlength="140" ng-maxlength="140"\n' +
    '                         ng-model="domesticPaymentSlo.tempDompObj.purposeOfPaymentInput" required\n' +
    '                         ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                         ng-blur="domesticPaymentSlo.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', domesticPaymentSlo.tempDompObj.purposeOfPaymentInput)">\n' +
    '                  <input ng-readonly="domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment" type="text" class="form-control input-field"\n' +
    '                         ng-if="domesticPaymentSlo.referenceHR == \'SI\' && domesticPaymentSlo.tempDompObj.referenceModelSelect == \'99\'"\n' +
    '                         ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.standardInput}}"\n' +
    '                         name="purposeOfPaymentInput" id="purposeOfPaymentInput" maxlength="140" ng-maxlength="140"\n' +
    '                         ng-model="domesticPaymentSlo.tempDompObj.purposeOfPaymentInput" required\n' +
    '                         ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                         ng-blur="domesticPaymentSlo.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', domesticPaymentSlo.tempDompObj.purposeOfPaymentInput)">\n' +
    '                  <input ng-readonly="domesticPaymentSlo.disableAllFields && domesticPaymentSlo.disableAllFieldsForProcessedPayment" type="text" class="form-control input-field"\n' +
    '                         ng-if="domesticPaymentSlo.referenceHR != \'NRC\' && domesticPaymentSlo.tempDompObj.referenceModelSelect != \'99\'"\n' +
    '                         ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.standardInput}}"\n' +
    '                         name="purposeOfPaymentInput" id="purposeOfPaymentInput" maxlength="140" ng-maxlength="140"\n' +
    '                         ng-model="domesticPaymentSlo.tempDompObj.purposeOfPaymentInput" required\n' +
    '                         ng-class="{\'domp-error\': domesticPaymentSlo.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentSlo.tempDompObj.formSubmitted}"\n' +
    '                         ng-blur="domesticPaymentSlo.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', domesticPaymentSlo.tempDompObj.purposeOfPaymentInput)">\n' +
    '                  <span class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted" translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                  <span class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.purposeOfPaymentInput.$error.maxlength && domesticPaymentSlo.tempDompObj.formSubmitted">{{\'domesticPayment.paymentPurposeLengthError1\'|translate}} {{domesticPaymentSlo.purposeMaxlengthValue}} {{\'domesticPayment.paymentPurposeLengthError2\'|translate}}</span>\n' +
    '\n' +
    '                <!--</div>-->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '        <section class="row p-t-15">\n' +
    '          <div class="col-xs-12 col-sm-2 p-l-30">\n' +
    '            <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value" ng-if="domesticPaymentSlo.hideUrgency === false">\n' +
    '              <input ng-readonly="domesticPaymentSlo.disableAllFields" type="checkbox"\n' +
    '                     ng-change="domesticPaymentSlo.showInfo();"\n' +
    '                     ng-model="domesticPaymentSlo.tempDompObj.isUrgentPaymentCheckbox">\n' +
    '              <i class="input-helper"></i>\n' +
    '              <span uib-tooltip="{{\'domesticPayment.urgentPaymentInfo\'| translate}}"\n' +
    '                    tooltip-append-to-body="true" tooltip-trigger="mouseenter"\n' +
    '                    tooltip-placement="top">{{\'domesticPayment.selectUrgentLabelSLO\'| translate}}\n' +
    '              </span>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-4 p-l-30" style="line-height: 39px; text-decoration: underline">\n' +
    '            <a ng-href="{{domesticPaymentSlo.defaultData.ProvisionLink}}" target="_blank" translate="domesticPayment.timetableForProvisionLink">\n' +
    '              Check the bank charges\n' +
    '            </a>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-3 p-l-30 " style="line-height: 39px; text-decoration: underline">\n' +
    '            <a ng-href="{{domesticPaymentSlo.defaultData.SepaCodesLink}}" target="_blank" translate="domesticPayment.SEPAcodesLink">\n' +
    '            </a>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-3 p-l-30 " style="line-height: 39px; text-decoration: underline">\n' +
    '            <a ng-href="{{domesticPaymentSlo.defaultData.BankChargesLink}}" target="_blank" translate="domesticPayment.checkBankCharges">\n' +
    '            </a>\n' +
    '          </div>\n' +
    '        </section>\n' +
    '        <section class="row clearfix p-15">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-6">\n' +
    '              <button class="btn btn-primary pull-left" type="button" translate="payments.cancel"\n' +
    '                      data-ui-sref="payments.paymentsOverview">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '              <button class="btn btn-default pull-right"\n' +
    '                      type="button"\n' +
    '                      translate="domesticPayment.confirmBtnSlo" ng-click="domesticPaymentSlo.submitPayment();"\n' +
    '                      ng-disabled="domesticPaymentSlo.nextButtonPressed || domesticPaymentSlo.secondValidateInProgress"></button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </section>\n' +
    '\n' +
    '    </form>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- Step 2 and 3 -->\n' +
    '  <div ng-if="domesticPaymentSlo.currentStep === 2" class="domp-step-2" ng-include="\'payments/domestic-payment-resume.tpl.html\'"></div>\n' +
    '  <div ng-if="domesticPaymentSlo.currentStep == 3" class="domp-step-2" ng-include="\'payments/domestic-payment-final.tpl.html\'">\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment-resume.tpl.html',
    '<!-- START Domestic payment Croatia - Resume -->\n' +
    '<div ng-show="domesticPayment.location == \'hr\'">\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.tempDompObj.fromAccountSelect.accountDescription}}</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.fromAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{domesticPaymentCro.insertedPaymentObject.amount| currency:""}}\n' +
    '          {{domesticPaymentCro.insertedPaymentObject.currencySymbol}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.bankCharges"></label>\n' +
    '        <a ng-href="{{domesticPaymentCro.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges"\n' +
    '           class="domp-form-label-resume">Check the bank charges</a>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-lg-offset-4 col-md-offset-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.dueDate|\n' +
    '          date:\'shortDate\'}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.debtorName}}</label>\n' +
    '        <label class="domp-form-label-resume"\n' +
    '               ng-if="!domesticPaymentCro.insertedPaymentObject.debtorName2 && !domesticPaymentCro.insertedPaymentObject.debtorName">-</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.debtorName2}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toAccountInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.toAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toPayee">To payee</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.receiverName}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.receiversAddressInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.receiverAddress1}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.receiversPostalCodeAndCityInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.receiverCity}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.creditorName}}</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.creditorName2}}</label>\n' +
    '        <label class="domp-form-label-resume"\n' +
    '               ng-if="!domesticPaymentCro.insertedPaymentObject.creditorName2 && !domesticPaymentCro.insertedPaymentObject.creditorName">-</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.purposeCodeSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.purposeCodeDPS}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.purposeOfPaymentInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.insertedPaymentObject.purpose}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review domp-reference-number-label"\n' +
    '               translate="domesticPayment.referenceNumberLabel">Reference number</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentCro.referenceHR}}{{domesticPaymentCro.split(domesticPaymentCro.insertedPaymentObjectDomp.referenceTo)}}</label>\n' +
    '        <label class="domp-form-label-resume"\n' +
    '               ng-if="domesticPaymentCro.insertedPaymentObject.referenceTo == \' \' || domesticPaymentCro.insertedPaymentObject.referenceTo == undefined">-</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <section class="row p-20" ng-if="domesticPaymentCro.tempDompObj.isUrgentPaymentCheckbox == true">\n' +
    '    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">\n' +
    '      <i class="zmdi zmdi-check urgent-label"></i>\n' +
    '      <label class="urgent-label" translate="domesticPayment.urgentPayment"></label>\n' +
    '    </div>\n' +
    '  </section>\n' +
    '\n' +
    '  <!-- Buttons -->\n' +
    '  <div class="p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <button class="btn btn-primary " ng-click="domesticPaymentCro.newPayment();"\n' +
    '              translate="domesticPayment.newPayment">New payment\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary " ng-click="domesticPaymentCro.editPayment();" translate="domesticPayment.edit">\n' +
    '        Edit\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary-warning" ng-click="domesticPaymentCro.deletePayment();"\n' +
    '              translate="domesticPayment.delete">Delete\n' +
    '      </button>\n' +
    '      <button class="btn btn-default app-btn-blue domp-sign-btn pull-right"\n' +
    '              data-ui-sref="payments.sign({paymentId: domesticPaymentCro.insertedPaymentObject.id, type: \'domestic\'})"\n' +
    '              translate="domesticPayment.sign">Sign\n' +
    '      </button>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<!-- END Domestic payment Croatia - Resume -->\n' +
    '\n' +
    '<!-- MNE -->\n' +
    '\n' +
    '<div ng-show="domesticPayment.location == \'mne\'">\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{domesticPaymentMne.tempDompObj.fromAccountSelect.accountDescription}}</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.fromAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{domesticPaymentMne.insertedPaymentObject.amount| currency:""}}\n' +
    '          {{domesticPaymentMne.insertedPaymentObject.currencySymbol}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.bankCharges"></label>\n' +
    '        <a ng-href="{{domesticPaymentMne.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges"\n' +
    '           class="domp-form-label-resume">Check the bank charges</a>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-lg-offset-4 col-md-offset-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.dueDate|\n' +
    '          date:\'shortDate\'}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toAccountInputLabelSRB"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.toAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toPayee">To payee</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.receiverName}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.receiversAddressInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.receiverAddress1}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.receiversPostalCodeAndCityInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.receiverCity}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.purposeCodeSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.purposeCodeDPS}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.purposeOfPaymentInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.insertedPaymentObject.purpose}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review domp-reference-number-label"\n' +
    '               translate="domesticPayment.referenceNumberLabel">Reference number</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentMne.referenceHR}}{{domesticPaymentMne.split(domesticPaymentMne.insertedPaymentObjectDomp.referenceTo)}}</label>\n' +
    '        <label class="domp-form-label-resume"\n' +
    '               ng-if="domesticPaymentMne.insertedPaymentObject.referenceTo == \' \' || domesticPaymentMne.insertedPaymentObject.referenceTo == undefined">-</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <section class="row p-20" ng-if="domesticPaymentMne.tempDompObj.isUrgentPaymentCheckbox == true">\n' +
    '    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">\n' +
    '      <i class="zmdi zmdi-check urgent-label"></i>\n' +
    '      <label class="urgent-label" translate="domesticPayment.urgentPayment"></label>\n' +
    '    </div>\n' +
    '  </section>\n' +
    '\n' +
    '  <!-- Buttons -->\n' +
    '  <div class="p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <button class="btn btn-primary " ng-click="domesticPaymentMne.newPayment();"\n' +
    '              translate="domesticPayment.newPayment">New payment\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary " ng-click="domesticPaymentMne.editPayment();" translate="domesticPayment.edit">\n' +
    '        Edit\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary-warning" ng-click="domesticPaymentMne.deletePayment();"\n' +
    '              translate="domesticPayment.delete">Delete\n' +
    '      </button>\n' +
    '      <button class="btn btn-default app-btn-blue domp-sign-btn pull-right"\n' +
    '              data-ui-sref="payments.sign({paymentId: domesticPaymentMne.insertedPaymentObject.id, type: \'domestic\'})"\n' +
    '              translate="domesticPayment.sign">Sign\n' +
    '      </button>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- SRB -->\n' +
    '\n' +
    '<div ng-show="domesticPayment.location == \'sr\'">\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 domp-from-section">\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-l-0">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{domesticPaymentSrb.tempDompObj.fromAccountSelect.accountDescription}}</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.fromAccountNumber}}</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-l-0">\n' +
    '      <div class="row">\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0">\n' +
    '          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{domesticPaymentSrb.insertedPaymentObject.amount| currency:""}}\n' +
    '              {{domesticPaymentSrb.insertedPaymentObject.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.bankCharges"></label>\n' +
    '            <a ng-href="{{domesticPaymentSrb.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges"\n' +
    '               class="domp-form-label-resume">Check the bank charges</a>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-5">\n' +
    '          <div class="m-t-25 m-b-0">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.dueDate|\n' +
    '              date:\'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 receiver-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toAccountInputLabelSRB"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.toAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.toPayee">To payee</label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.receiverName}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5 p-l-0"></div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '        <div class="m-t-15 m-b-0">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.receiversAddressInputLabel"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.receiverAddress1}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '        <div class="m-t-25 m-b-0">\n' +
    '          <label class="domp-form-label-review"\n' +
    '                 translate="domesticPayment.receiversPostalCodeAndCityInputLabel"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.receiverCity}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 purpose-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5 no-padding-on-phone p-l-0">\n' +
    '        <div class="col-lg-4 col-md-4 col-sm-6 p-r-0">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.purposeCodeSelectLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.purposeCodeDPS}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-lg-8 col-md-8 col-sm-8">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.purposeOfPaymentInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{domesticPaymentSrb.insertedPaymentObject.purpose}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone p-l-0">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.referenceNumberLabel">Reference number</label>\n' +
    '          <label class="domp-form-label-resume" ng-if="domesticPaymentSrb.insertedPaymentObject.referenceTo != \'00\'">{{domesticPaymentSrb.split(domesticPaymentSrb.insertedPaymentObjectDomp.referenceTo)}}</label>\n' +
    '          <label class="domp-form-label-resume" ng-if="!domesticPaymentSrb.insertedPaymentObject.referenceTo">-</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row" ng-if="domesticPaymentSrb.tempDompObj.isUrgentPaymentCheckbox == true">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '        <i class="zmdi zmdi-check urgent-label"></i>\n' +
    '        <label class="urgent-label" translate="domesticPayment.urgentPayment"></label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- SMS auth old -->\n' +
    '  <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 purpose-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-12" ng-if="domesticPaymentSrb.smsAuthentificate != true">\n' +
    '        <div class="form-group">\n' +
    '          <label class="exchange-resume-label" translate="currencyConversion.smsAuthentification"></label>\n' +
    '          <button class="btn btn-default confirm-btn d-block" translate="currencyConversion.sendSms" data-ng-click="domesticPaymentSrb.showSMSAuthentification();"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-12" ng-if="domesticPaymentSrb.smsAuthentificate == true">\n' +
    '        <div class="form-group">\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control input-field" data-ng-model="domesticPaymentSrb.smsPasswordInput" placeholder="{{\'currencyConversion.smsPassword\' | translate}}">\n' +
    '            <span class="input-group-btn">\n' +
    '              <button class="btn btn-default input-group-app-btn domp-btn-height">\n' +
    '                <i class="zmdi zmdi-lock"></i>\n' +
    '              </button>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>-->\n' +
    '\n' +
    '  <div ng-if="domesticPayment.location == \'hr\'" class="domp-footer-wrapper">\n' +
    '    <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">\n' +
    '      <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3 m-r-10 btn btn-primary-warning "\n' +
    '              ng-click="domesticPaymentSrb.deletePayment();" translate="domesticPayment.delete">Delete\n' +
    '      </button>\n' +
    '\n' +
    '      <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3 btn btn-primary" ng-click="domesticPaymentSrb.editPayment();"\n' +
    '              translate="domesticPayment.edit">Edit\n' +
    '      </button>\n' +
    '\n' +
    '      <!--<button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-primary app-btn-blue domp-sign-btn pull-right" ng-click="domesticPaymentSrb.signPayment();" ng-disabled="!domesticPaymentSrb.$dirty && domesticPaymentSrb.smsAuthentificate == false">Sign</button>-->\n' +
    '      <button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default pull-right"\n' +
    '              data-ui-sref="payments.sign({paymentId: domesticPaymentSrb.insertedPaymentObject.id, type: \'domestic\'})"\n' +
    '              translate="domesticPayment.sign">Sign\n' +
    '      </button>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="domesticPayment.location != \'hr\'" class="domp-footer-wrapper">\n' +
    '    <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">\n' +
    '\n' +
    '      <button class="btn btn-primary " ng-click="domesticPaymentSrb.newPayment();"\n' +
    '              translate="domesticPayment.newPayment">New payment\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary" ng-click="domesticPaymentSrb.editPayment();" translate="domesticPayment.edit">\n' +
    '        Edit\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary-warning " ng-click="domesticPaymentSrb.deletePayment();"\n' +
    '              translate="domesticPayment.delete">Delete\n' +
    '      </button>\n' +
    '      <!--<button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-primary app-btn-blue domp-sign-btn pull-right" ng-click="domesticPaymentSrb.signPayment();" ng-disabled="!domesticPaymentSrb.$dirty && domesticPaymentSrb.smsAuthentificate == false">Sign</button>-->\n' +
    '      <button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default pull-right"\n' +
    '              data-ui-sref="payments.sign({paymentId: domesticPaymentSrb.insertedPaymentObject.id, type: \'domestic\'})"\n' +
    '              translate="domesticPayment.sign">Sign\n' +
    '      </button>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!-- START Domestic payment Slovenia - Resume -->\n' +
    '<div ng-show="domesticPayment.location == \'sl\'">\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '        <label ng-if="domesticPaymentSlo.tempDompObj.fromAccountSelect.friendlyName" class="domp-form-label-resume">\n' +
    '          {{domesticPaymentSlo.tempDompObj.fromAccountSelect.friendlyName}}</label>\n' +
    '        <label ng-if="!domesticPaymentSlo.tempDompObj.fromAccountSelect.friendlyName" class="domp-form-label-resume">\n' +
    '          {{domesticPaymentSlo.tempDompObj.fromAccountSelect.accountDescription}}\n' +
    '        </label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.fromAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{domesticPaymentSlo.insertedPaymentObject.amount| currency:""}}\n' +
    '          {{domesticPaymentSlo.insertedPaymentObject.currencySymbol}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.bankCharges"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{domesticPaymentSlo.insertedPaymentObject.paymentChargesAmount | currency: ""}}\n' +
    '          {{domesticPaymentSlo.insertedPaymentObject.currencySymbol}}\n' +
    '        </label>\n' +
    '        <a ng-href="{{domesticPaymentSlo.defaultData.BankChargesLink}}" target="_blank" translate="domesticPayment.checkBankCharges" class="domp-form-label-resume">\n' +
    '\n' +
    '        </a>\n' +
    '\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-xs-12 col-sm-4" ng-if="!domesticPaymentSlo.naturalPerson && domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '        <label id="payersSepaInput1" class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName}}</label>\n' +
    '        <!--<label class="domp-form-label-resume"-->\n' +
    '        <!--ng-if="!domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName2 && !domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName">-</label>-->\n' +
    '        <!--<label id="payersSepaInput2" class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName2}}</label>-->\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-xs-12" ng-class="{\'col-md-offset-4\': domesticPaymentSlo.naturalPerson || !domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName}">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.dueDate|\n' +
    '          date:\'shortDate\'}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <!--<section class="row" ng-if="!domesticPaymentSlo.naturalPerson && domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName" >-->\n' +
    '      <!--<div class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">-->\n' +
    '        <!--<label class="domp-form-label-review" translate="domesticPayment.sepaDebitorLabel"></label>-->\n' +
    '        <!--<label id="payersSepaInput1" class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName}}</label>-->\n' +
    '        <!--&lt;!&ndash;<label class="domp-form-label-resume"&ndash;&gt;-->\n' +
    '               <!--&lt;!&ndash;ng-if="!domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName2 && !domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName">-</label>&ndash;&gt;-->\n' +
    '        <!--&lt;!&ndash;<label id="payersSepaInput2" class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.debtorName2}}</label>&ndash;&gt;-->\n' +
    '      <!--</div>-->\n' +
    '    <!--</section>-->\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toAccountInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.toAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12" ng-if="!domesticPaymentSlo.naturalPerson">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toPayee">To payee</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.domesticPayment.receiverName}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row" ng-if="!domesticPaymentSlo.naturalPerson" >\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.receiversAddressInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.domesticPayment.receiverAddress1}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row" ng-if="!domesticPaymentSlo.naturalPerson" >\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.receiversPostalCodeAndCityInputLabelSlo"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.domesticPayment.receiverCity}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '    <section class="row" ng-if="!domesticPaymentSlo.naturalPerson && domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.creditorName" >\n' +
    '      <div class="form-group col-lg-6 col-md-offset-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '        <label id="receiversSepaInput1" class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.sepaUpnIdentificators.creditorName}}</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-from-section p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12" ng-if="!domesticPaymentSlo.naturalPerson" >\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.purposeCodeSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.purposeCodeDPS}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.purposeOfPaymentInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentSlo.insertedPaymentObject.purpose}}</label>\n' +
    '      </div>\n' +
    '      <div class="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12" ng-if="!domesticPaymentSlo.naturalPerson" >\n' +
    '        <label class="domp-form-label-review domp-reference-number-label"\n' +
    '               translate="domesticPayment.referenceNumberLabel">Reference number</label>\n' +
    '        <label class="domp-form-label-resume" ng-if="domesticPaymentSlo.insertedPaymentObject.domesticPayment.referenceTo">{{domesticPaymentSlo.formatReferenceNumber(domesticPaymentSlo.insertedPaymentObject.domesticPayment.referenceTo)}}</label>\n' +
    '        <label class="domp-form-label-resume"\n' +
    '               ng-if="domesticPaymentSlo.insertedPaymentObject.domesticPayment.referenceTo == \' \' || domesticPaymentSlo.insertedPaymentObject.domesticPayment.referenceTo == undefined">-</label>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '  <section class="row p-20" ng-if="domesticPaymentSlo.tempDompObj.isUrgentPaymentCheckbox == true">\n' +
    '    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">\n' +
    '      <i class="zmdi zmdi-check urgent-label"></i>\n' +
    '      <label class="urgent-label" translate="domesticPayment.urgentPayment"></label>\n' +
    '    </div>\n' +
    '  </section>\n' +
    '\n' +
    '  <!-- Buttons -->\n' +
    '  <div class="p-20 clearfix">\n' +
    '    <section class="row">\n' +
    '      <div class="col-xs-6 col-sm-2">\n' +
    '        <button class="btn btn-primary " ng-click="domesticPaymentSlo.editPayment();" translate="domesticPayment.back">\n' +
    '          Edit\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-sm-2" ng-if="domesticPaymentSlo.actionLinks.delete">\n' +
    '        <button class="btn btn-primary-warning" ng-click="domesticPaymentSlo.deletePayment();"\n' +
    '                translate="domesticPayment.delete">Delete\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <!--<button class="btn btn-default app-btn-blue domp-sign-btn pull-right" ng-if="domesticPaymentSlo.signLink" -->\n' +
    '      <!--data-ui-sref="payments.sign({paymentId: domesticPaymentSlo.insertedPaymentObject.id, type: \'domestic\'})" translate="domesticPayment.sign">Sign</button>-->\n' +
    '      <div class="col-xs-12 col-sm-3 pull-right" ng-if="domesticPaymentSlo.insertedPaymentObject.linkList.itemList.sign">\n' +
    '        <!--<button class="btn btn-default app-btn-blue domp-sign-btn pull-right"-->\n' +
    '                <!--ng-click="domesticPaymentSlo.sign();" translate="domesticPayment.sign">Sign-->\n' +
    '        <!--</button>-->\n' +
    '        <button class="btn btn-default app-btn-blue domp-sign-btn pull-right"\n' +
    '                ng-click="domesticPaymentSlo.signOrFinishPayment()"\n' +
    '                ng-disabled="domesticPaymentSlo.confirmButtonPressed"\n' +
    '                translate="domesticPayment.confirmBtn">Sign\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <!--<div class="col-xs-6 col-sm-2 pull-right" ng-if="domesticPaymentSlo.actionLinks.requestOTP">-->\n' +
    '        <!--<input type="text" class="form-control input-field" data-ng-model="domesticPaymentSlo.requestOtpInput"-->\n' +
    '               <!--ng-pattern-restrict="{{paymentsSign.regexPatterns.onlyNumbers}}"-->\n' +
    '               <!--placeholder="{{\'signPayments.challengeSecondCode\' | translate}}" autocomplete="off" auto-focus>-->\n' +
    '      <!--</div>-->\n' +
    '\n' +
    '    </section>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<!-- END Domestic payment Slovenia - Resume -->\n' +
    '\n' +
    '<!-- START Domestic payment BiH - Resume -->\n' +
    '<div ng-show="domesticPayment.location == \'bh\'">\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 domp-from-section">\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-l-0">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{domesticPaymentBh.tempDompObj.fromAccountSelect.accountDescription}}</label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.fromAccountNumber}}</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-l-0">\n' +
    '      <div class="row">\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0">\n' +
    '          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{domesticPaymentBh.insertedPaymentObject.amount| currency:""}}\n' +
    '              {{domesticPaymentBh.insertedPaymentObject.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div ng-if="!domesticPaymentBh.insertedPaymentObject.paymentSubTypeGroup" class="col-lg-6 col-md-6 col-sm-6 col-xs-7" ng-if="domesticPaymentBh.insertedPaymentObject.bankCharges">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.bankCharges"></label>\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{domesticPaymentBh.insertedPaymentObject.bankCharges.feeAmount | currency:""}} BAM\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-5">\n' +
    '          <div class="m-t-25 m-b-0">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.dueDate|\n' +
    '              date:\'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 receiver-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toAccountInputLabelSRB"></label>\n' +
    '        <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.toAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0"\n' +
    '           ng-if="domesticPaymentBh.insertedPaymentObject.receiverName">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.toPayee">To payee</label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.receiverName}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row" ng-if="domesticPaymentBh.insertedPaymentObject.receiverAddress1">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5 p-l-0"></div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '        <div class="m-t-15 m-b-0">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.receiversAddressInputLabel"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.receiverAddress1}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 purpose-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5 no-padding-on-phone p-l-0">\n' +
    '        <div class="col-lg-4 col-md-4 col-sm-6 p-r-0" ng-if="domesticPaymentBh.insertedPaymentObject.purposeCodeDPS">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.purposeCodeSelectLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.purposeCodeDPS}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-lg-8 col-md-8 col-sm-8" ng-if="domesticPaymentBh.insertedPaymentObject.purpose">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.purposeOfPaymentInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.purpose}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone p-l-0"\n' +
    '           ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.reference">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.referenceNumberLabel">Reference number</label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.reference}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row" ng-if="domesticPaymentBh.tempDompObj.isUrgentPaymentCheckbox == true">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '        <i class="zmdi zmdi-check urgent-label"></i>\n' +
    '        <label class="urgent-label" translate="domesticPayment.urgentPayment"></label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- PUBLIC REVENUE DETAIL SECTION -->\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 domp-from-section revenue-section"\n' +
    '       ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone" ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.taxPayerId">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.taxPayerNumber"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.taxPayerId}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone" ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.revenuePaymentType">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.paymentType"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.revenuePaymentType}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone" ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.revenueCode">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.revenueCode"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.revenueCode}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone" ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.municipality">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.municipality"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.municipality}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone" ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.taxPeriodFrom">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.taxPeriodFrom"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.taxPeriodFrom\n' +
    '            | date: \'shortDate\'}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone" ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.taxPeriodTo">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.taxPeriodTo"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.taxPeriodTo\n' +
    '            | date: \'shortDate\'}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone" ng-if="domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.budgetOrganization">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.budgetOrganisation"></label>\n' +
    '          <label class="domp-form-label-resume">{{domesticPaymentBh.insertedPaymentObject.revenuePaymentDetails.budgetOrganization}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '  <!-- END REVENUE DETAIL SECTION -->\n' +
    '  <div class="domp-footer-wrapper">\n' +
    '    <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">\n' +
    '\n' +
    '      <button class="btn btn-primary " ng-click="domesticPaymentBh.newPayment();"\n' +
    '              translate="domesticPayment.newPayment">New payment\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary" ng-click="domesticPaymentBh.editPayment();" translate="domesticPayment.edit">\n' +
    '        Edit\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary-warning " ng-click="domesticPaymentBh.deletePayment();"\n' +
    '              translate="domesticPayment.delete">Delete\n' +
    '      </button>\n' +
    '      <!--<button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-primary app-btn-blue domp-sign-btn pull-right" ng-click="domesticPaymentSrb.signPayment();" ng-disabled="!domesticPaymentSrb.$dirty && domesticPaymentSrb.smsAuthentificate == false">Sign</button>-->\n' +
    '      <button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default pull-right"\n' +
    '              data-ui-sref="payments.sign({paymentId: domesticPaymentBh.insertedPaymentObject.id, type: \'domestic\'})"\n' +
    '              translate="domesticPayment.sign">Sign\n' +
    '      </button>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<!-- END Domestic payment BiH - Resume -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment-mne.tpl.html',
    '<div ng-controller="DomesticPaymentMneCtrl as domesticPaymentMne">\n' +
    '    <div class="domp-header-wrapper" ng-show="domesticPaymentMne.currentStep != 3">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '            <h2 class="f-28" translate="domesticPayment.header">Domestic Payment</h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '    <div class="domp-body-wrapper">\n' +
    '        <div ng-if="domesticPaymentMne.currentStep === 1" class="domp-step-1">\n' +
    '            <ng-form novalidate name="domesticPaymentMne.domesticPaymentForm">\n' +
    '                <div class="domp-select-section col-sm-12 p-0">\n' +
    '\n' +
    '                    <!--SELECT TEMPLATE CUSTOM -->\n' +
    '\n' +
    '                    <div class="domp-template-filter-container">\n' +
    '                        <div class="domp-select-template" ng-click="domesticPaymentMne.toggleTemplateFilterSelection()" ng-show="domesticPaymentMne.templateName==\'\'">\n' +
    '                            <div class="select-template label-select">\n' +
    '                                <label class="p-t-10 f-18 p-t-5" translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                                <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="domp-selected-template" ng-show="domesticPaymentMne.templateName!=\'\'">\n' +
    '                            <div class="select-template label-template-selected p-l-10 p-t-5" ng-show="domesticPaymentMne.templateName!=\'\'">\n' +
    '\n' +
    '                              <img ng-if="domesticPaymentMne.selectedTemplate.imageId" ng-src="{{domesticPaymentMne.selectedTemplate.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img-40"/>\n' +
    '                              <img ng-if="!domesticPaymentMne.selectedTemplate.imageId" class="tpl-rounded-img-40" alt="Ico"/>\n' +
    '\n' +
    '                                <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                                <label class="p-l-10 selected-template-label top-2" ><b>{{domesticPaymentMne.templateName}}</b></label>\n' +
    '                                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5" ng-click="domesticPaymentMne.removeTemplate()"></i>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="domp-template-filter-selection" ng-class="{\'opened\': domesticPaymentMne.searchTemplateFilterExpanded}">\n' +
    '                            <div class="search-template">\n' +
    '                                <div class="inner-section left">\n' +
    '                                    <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                                </div>\n' +
    '                                <div class="inner-section center" style="width:50%;">\n' +
    '                                    <input id="searchTemplatesInput" type="text" class="search-input" ng-model="domesticPaymentMne.tmpSearchText.name" ng-change="domesticPaymentMne.searchTemplate(domesticPaymentMne.tmpSearchText.name)" placeholder="{{\'dashboard.searchTemplatesPlaceholder\' | translate}}">\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="domp-template-filter">\n' +
    '                                <div class="m-b-10">\n' +
    '                                    <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfTemplates"></h4>\n' +
    '                                    <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                                        <a href="" class="list-group-item" data-ng-repeat="template in domesticPaymentMne.templateList.result | filter:domesticPaymentMne.tmpSearchText" ng-click="domesticPaymentMne.selectTemplate(template.id)">\n' +
    '                                            <div class="row m-r-0">\n' +
    '                                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 p-r-0">\n' +
    '                                                  <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                                                  <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img"/>\n' +
    '                                                  <img ng-if="!template.imageId" class="tpl-rounded-img" alt="Ico"/>\n' +
    '                                                </div>\n' +
    '                                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label p-t-15" style="padding-left: 70px !important;">\n' +
    '                                                    <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                                                    <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </a>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <!--SELECT TEMPLATE CUSTOM END-->\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-sm-12 domp-from-section">\n' +
    '                    <!-- CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '                    <div class="col-sm-6 domp-acc-dropdown">\n' +
    '                        <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '                        <div class="accounts-dropdown">\n' +
    '                            <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="domesticPaymentMne.toggleFromAccount();"  ng-style="domesticPaymentMne.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + domesticPaymentMne.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{domesticPaymentMne.tempDompObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':domesticPaymentMne.tempDompObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!domesticPaymentMne.tempDompObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                                </h4>\n' +
    '                                <p class="m-b-0 m-t-0 iban-style">{{domesticPaymentMne.tempDompObj.fromAccountSelect.iban}}</p>\n' +
    '                                <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                    {{domesticPaymentMne.tempDompObj.fromAccountSelect.availableBalance | number:2}} {{domesticPaymentMne.tempDompObj.fromAccountSelect.currencySymbol}}\n' +
    '                                </p>\n' +
    '                                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                            </div>\n' +
    '                            <div class="from-accounts-list" ng-show="domesticPaymentMne.fromAccountDropdown" scrollable>\n' +
    '                                <div class="accounts-list-item p-0" data-ng-repeat="item in domesticPaymentMne.paymentTypeGroupDomestic.result[0].debitAccountList" data-ng-click="domesticPaymentMne.setAccountFrom(item);">\n' +
    '                                    <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                        <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                        </h4>\n' +
    '                                        <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                                        <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                            {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                                        </p>\n' +
    '                                        <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-6">\n' +
    '                        <div class="row ">\n' +
    '                            <div class="col-sm-12">\n' +
    '                                <div class="form-group">\n' +
    '                                    <label class="domp-form-label" for="amountInput" translate="domesticPayment.amountInputLabel">Amount:</label>\n' +
    '                                    <div class="input-group">\n' +
    '                                        <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput" amount-input-mask maxlength="12" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" ng-model="domesticPaymentMne.tempDompObj.amountInput" required ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.amountInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}">\n' +
    '                                        <span class="input-group-btn">\n' +
    '                    <button type="button" class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">{{domesticPaymentMne.defaultCurrency}}</button>\n' +
    '                  </span>\n' +
    '                                    </div>\n' +
    '                                    <span class="c-red" ng-show="domesticPaymentMne.domesticPaymentForm.amountInput.$error.required && domesticPaymentMne.tempDompObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="row ">\n' +
    '                            <div class="col-sm-8">\n' +
    '                                <div class="form-group">\n' +
    '                                    <label class="domp-form-label" for="dateInput" translate="domesticPayment.dateInputLabel">Date:</label>\n' +
    '                                    <div class="input-group ">\n' +
    '                                      <input type="text" class="form-control input-field" name="dateInput" id="dateInput" uib-datepicker-popup="shortDate2" data-ng-model="domesticPaymentMne.tempDompObj.dateInput" ng-required="true" show-weeks="false" is-open="domesticPaymentMne.datePickerOpened" datepicker-options="domesticPaymentMne.dateOptions" date-disabled="domesticPaymentMne.disabled(date, mode)" readonly>\n' +
    '                                        <span class="input-group-btn">\n' +
    '                    <button data-ng-click="domesticPaymentMne.openDatePicker()" type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '          <i class="icon icon-calendar" style="font-size: 21px;"></i></button>\n' +
    '                  </span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-sm-12 receiver-section">\n' +
    '                    <div class="row ">\n' +
    '                        <div class="col-sm-6 col-xs-12 right-section">\n' +
    '                            <div class="form-group">\n' +
    '                                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toAccountInputLabelSRB">\n' +
    '                                    Account number\n' +
    '                                </label>\n' +
    '                                <!--<input type="text" class="form-control input-field" ui-mask="999-9999999999999-99" ui-mask-placeholder ui-mask-placeholder-char="_" ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.toAccountInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" name="toAccountInput" id="toAccountInput" ng-model="domesticPaymentMne.tempDompObj.toAccountInput" maxlength="21" ng-maxlength="21" required>-->\n' +
    '                              <input type="text" class="form-control input-field" name="toAccountInput" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.onlyNumbersAndDashes}}" capitalize ng-minlength="6" dn-custom-maxlength="18" dn-exclude="-" id="toAccountInput" ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.toAccountInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" ng-model="domesticPaymentMne.tempDompObj.toAccountInput" ng-blur="domesticPaymentMne.fillReceiver(domesticPaymentMne.tempDompObj.toAccountInput)" required>\n' +
    '                                  <div class="c-red" ng-show="domesticPaymentMne.domesticPaymentForm.toAccountInput.$error.required && domesticPaymentMne.tempDompObj.formSubmitted" translate="domesticPayment.receiverAccountError"></div>\n' +
    '                                  <div class="c-red" ng-show="domesticPaymentMne.domesticPaymentForm.$error.minlength" translate="payments.minimalAccountNumber"></div>\n' +
    '\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <!-- /////////// SELECT CUSTOM ///////////// -->\n' +
    '                        <div click-outside="domesticPaymentMne.searchFilterExpanded = false;" outside-if-not="expandPayeeSearchFilterMNE" class="col-sm-6 col-xs-12 left-section">\n' +
    '                            <div class="form-group">\n' +
    '                                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toPayee">To payee</label>\n' +
    '                                <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': domesticPaymentMne.domesticPaymentForm.payeeSearchFilter.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}">\n' +
    '                                    <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                                        <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                                    </div>\n' +
    '                                    <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                                        <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" class="search-input" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.allowedCharsDPS}}" ng-model="domesticPaymentMne.tempDompObj.receiversNameInput" ng-change="domesticPaymentMne.searchPayee()" required maxlength="35" ng-maxlength="35" autocomplete="off">\n' +
    '                                    </div>\n' +
    '                                    <div id="expandPayeeSearchFilterMNE" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right" ng-click="domesticPaymentMne.toggleFilterSelection()">\n' +
    '                                        <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentMne.tempDompObj.receiversNameInput != \'\'" ng-click="domesticPaymentMne.removeSearch()"></i>\n' +
    '                                        <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right" ng-show="domesticPaymentMne.tempDompObj.receiversNameInput == \'\'"></i>\n' +
    '                                    </div>\n' +
    '                                    <div class="domp-filter-selection search-row" ng-class="{\'opened\': domesticPaymentMne.searchFilterExpanded}">\n' +
    '                                        <div class="domp-filter-type-selection-wrapper" ng-repeat="payee in domesticPaymentMne.payeeList | filter:domesticPaymentMne.searchPayeeBy" ng-click="domesticPaymentMne.selectPayee(payee.id)">\n' +
    '                                            <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                                                <i class="zmdi zmdi-account-circle"></i>\n' +
    '                                            </div>\n' +
    '                                            <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                                                <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                                                <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentMne.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentMne.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></span>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <!--//////////////SELECT CUSTOM END/////////////////////// -->\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row ">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 left-section"></div>\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 right-section">\n' +
    '                            <div class="form-group">\n' +
    '                                <label class="domp-form-label" for="receiversAddressInput" translate="domesticPayment.receiversAddressInputLabel">Receiver\'s address:</label>\n' +
    '                                <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.receiversAddressInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" name="receiversAddressInput" id="receiversAddressInput" ng-model="domesticPaymentMne.tempDompObj.receiversAddressInput" ng-blur="domesticPaymentMne.replaceUnallowedCharsDPS(\'receiversAddressInput\', domesticPaymentMne.tempDompObj.receiversAddressInput)" maxlength="35" ng-maxlength="35" required>\n' +
    '                                <span class="c-red" ng-show="domesticPaymentMne.domesticPaymentForm.receiversAddressInput.$error.required && domesticPaymentMne.tempDompObj.formSubmitted" translate="domesticPayment.receiverAddressError"></span>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="row ">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 left-section"></div>\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 right-section">\n' +
    '                            <div class="form-group">\n' +
    '                                <label class="domp-form-label" for="receiversPostalCodeAndCityInput" translate="domesticPayment.receiversPostalCodeAndCityInputLabel">\n' +
    '                                    Receiver\'s postal code and city:</label>\n' +
    '                                <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.receiversPostalCodeAndCityInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" name="receiversPostalCodeAndCityInput" id="receiversPostalCodeAndCityInput" ng-model="domesticPaymentMne.tempDompObj.receiversPostalCodeAndCityInput" ng-blur="domesticPaymentMne.replaceUnallowedCharsDPS(\'receiversPostalCodeAndCityInput\', domesticPaymentMne.tempDompObj.receiversPostalCodeAndCityInput)" maxlength="35" ng-maxlength="35">\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="col-lg-12 col-md-12 col-sm-12 purpose-section">\n' +
    '                    <div class="row ">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 left-section">\n' +
    '                            <div class="form-group">\n' +
    '                                <div class="col-lg-12  no-padding-on-phone p-r-0 p-l-0">\n' +
    '                                    <label class="domp-form-label" for="purposeCodeSelect" translate="domesticPayment.purposeCodeSelectLabel">Purpose code</label>\n' +
    '                                    <div class="p-l-0">\n' +
    '                                        <select class="form-control input-field p-l-15 p-r-10" name="purposeCodeSelect" id="purposeCodeSelect" ng-options="option.optionValue for option in domesticPaymentMne.purposeCodesList.result" ng-model="domesticPaymentMne.tempDompObj.purposeCodeSelect" ng-change="domesticPaymentMne.changePurpose(domesticPaymentMne.tempDompObj.purposeCodeSelect)"></select>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="col-lg-12  no-padding-on-phone p-r-0 p-l-0 p-t-10">\n' +
    '                                  <label class="domp-form-label domp-purpose-label" for="purposeOfPaymentInput" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '                                    <div class="p-0">\n' +
    '                                        <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.purposeOfPaymentValidation}}" name="purposeOfPaymentInput" id="purposeOfPaymentInput" ng-maxlength="105" maxlength="105" ng-model="domesticPaymentMne.tempDompObj.purposeOfPaymentInput" required ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" ng-blur="domesticPaymentMne.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', domesticPaymentMne.tempDompObj.purposeOfPaymentInput)">\n' +
    '                                        <span class="c-red" ng-show="domesticPaymentMne.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentMne.tempDompObj.formSubmitted" translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 left-section">\n' +
    '<!--                            <div class="col-sm-3 col-xs-4 p-l-0">\n' +
    '                                <label class="domp-form-label" translate="domesticPayment.referenceModelLabel">Model</label>\n' +
    '                            </div>-->\n' +
    '                            <div class="col-sm-3 col-xs-4 p-l-0 p-r-5">\n' +
    '                                <label class="domp-form-label" translate="domesticPayment.referenceModelLabel">Model</label>\n' +
    '                                <div class="form-group m-b-0">\n' +
    '                                    <select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect" id="referenceModelSelect" ng-model="domesticPaymentMne.tempDompObj.referenceModelSelect">\n' +
    '                                        <option ng-repeat="item in domesticPaymentMne.referenceModelList">{{item}}</option>\n' +
    '                                    </select>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="col-sm-9 col-xs-12 p-l-0 p-r-0">\n' +
    '                                <label class="domp-form-label" translate="domesticPayment.referenceNumberLabel">Reference number</label>\n' +
    '                                <div class="form-group m-b-0">\n' +
    '                                    <input type="text" id="referenceNumberInput" ng-if="domesticPaymentMne.tempDompObj.referenceModelSelect == \'18\'" name="referenceNumberInput" maxlength="22" class="form-control input-field" ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" ng-model="domesticPaymentMne.tempDompObj.referenceNumberInput" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.allLettersNumbersDashes}}" capitalize required>\n' +
    '                                    <input type="text" id="referenceNumberInput" ng-if="domesticPaymentMne.tempDompObj.referenceModelSelect == \'05\'" name="referenceNumberInput" maxlength="22" class="form-control input-field" ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" ng-model="domesticPaymentMne.tempDompObj.referenceNumberInput" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.allLettersNumbersDashes}}" capitalize required>\n' +
    '                                    <input type="text" id="referenceNumberInput" ng-if="domesticPaymentMne.tempDompObj.referenceModelSelect != \'05\' && domesticPaymentMne.tempDompObj.referenceModelSelect != \'18\'" name="referenceNumberInput" maxlength="22" class="form-control input-field" ng-class="{\'domp-error\': domesticPaymentMne.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentMne.tempDompObj.formSubmitted}" ng-model="domesticPaymentMne.tempDompObj.referenceNumberInput" ng-pattern-restrict="{{domesticPaymentMne.regexPatterns.allLettersNumbersDashes}}" capitalize>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                          <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-if="domesticPaymentMne.domesticPaymentForm.referenceNumberInput.$error.required && domesticPaymentMne.tempDompObj.formSubmitted" translate="domesticPayment.referenceModelInputError"></div>\n' +
    '\n' +
    '                            <!--   <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-show="domesticPayment.domesticPaymentForm.referenceModelInput.$invalid && domesticPayment.tempDompObj.referenceModelInput != \'\' && !domesticPayment.tempDompObj.formSubmitted" translate="domesticPayment.referenceModelInputInvalid"></span> -->\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="domp-footer-wrapper">\n' +
    '                    <div class="row ">\n' +
    '                        <div class="col-sm-6 col-lg-6 col-md-6 col-xs-12 p-l-30">\n' +
    '                            <div class="col-xs-12 p-l-10">\n' +
    '                                <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value" ng-click="domesticPaymentMne.pushGtmUrgentPaymentEvent();">\n' +
    '                                    <input type="checkbox" ng-model="domesticPaymentMne.tempDompObj.isUrgentPaymentCheckbox">\n' +
    '                                  <i class="input-helper"></i> {{\'domesticPayment.selectUrgentLabel\' | translate}} <i uib-tooltip="{{\'domesticPayment.urgentPaymentInfo\' | translate}}" tooltip-append-to-body="true"  tooltip-trigger="mouseenter" tooltip-placement="top" class="icon icon-question" style="font-weight: bolder; color:#ff4d5a;"></i>\n' +
    '                                </label>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-sm-6 col-lg-6 col-md-6 col-xs-12">\n' +
    '                            <div class="col-lg-7 col-md-6 col-sm-5 "></div>\n' +
    '                            <div class="col-lg-5 col-md-6 col-sm-7 col-xs-12 p-r-5 p-t-10 charges-label">\n' +
    '                                <a ng-href="{{domesticPaymentMne.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges" >Check the bank charges</a>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="row p-10">\n' +
    '                      <div class="col-xs-6 t-a-l">\n' +
    '                        <button class="btn btn-primary" type="button" translate="payments.cancel"\n' +
    '                                data-ui-sref="payments.paymentsOverview">\n' +
    '                        </button>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-6 t-a-r">\n' +
    '                        <button class="btn btn-default domp-review-and-submit-btn" type="submit" translate="domesticPayment.confirmBtn"\n' +
    '                        ng-click="domesticPaymentMne.submitPayment();"></button>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </ng-form>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-if="domesticPaymentMne.currentStep === 2" class="domp-step-2" ng-include="\'payments/domestic-payment-resume.tpl.html\'"></div>\n' +
    '    <div ng-if="domesticPaymentMne.currentStep == 3">\n' +
    '        <div data-ng-include="\'payments/domestic-payment-final.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment-final.tpl.html',
    '<div class="currency-conversion-msg" ng-show="domesticPayment.location==\'hr\'">\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{domesticPaymentCro.insertedPaymentObject.amount | number:2}}\n' +
    '            {{domesticPaymentCro.insertedPaymentObject.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{domesticPaymentCro.insertedPaymentObject.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{domesticPaymentCro.insertedPaymentObject.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<div class="currency-conversion-msg" ng-show="domesticPayment.location==\'sr\'">\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{domesticPaymentSrb.insertedPaymentObject.amount | number:2}}\n' +
    '            {{domesticPaymentSrb.insertedPaymentObject.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{domesticPaymentSrb.insertedPaymentObject.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{domesticPaymentSrb.insertedPaymentObject.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="currency-conversion-msg" ng-show="domesticPayment.location==\'mne\'">\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{domesticPaymentMne.insertedPaymentObject.amount | number:2}}\n' +
    '            {{domesticPaymentMne.insertedPaymentObject.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{domesticPaymentMne.insertedPaymentObject.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{domesticPaymentMne.insertedPaymentObject.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="currency-conversion-msg" ng-show="domesticPayment.location==\'sl\'">\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="internalTransfer.transferComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="internalTransfer.successfullyTransfer"></span>\n' +
    '          <span>\n' +
    '            {{domesticPaymentSlo.insertedPaymentObject.amount | number:2}}\n' +
    '            {{domesticPaymentSlo.insertedPaymentObject.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{domesticPaymentSlo.insertedPaymentObject.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{domesticPaymentSlo.insertedPaymentObject.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-4">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment-cro.tpl.html',
    '<div ng-controller="DomesticPaymentCroCtrl as domesticPaymentCro">\n' +
    '  <div class="domp-header-wrapper" ng-show="domesticPaymentCro.currentStep != 3">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <h2 class="f-28" translate="domesticPayment.header">Domestic Payment</h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="domp-body-wrapper">\n' +
    '    <div ng-if="domesticPaymentCro.currentStep === 1" class="domp-step-1">\n' +
    '      <form novalidate name="domesticPaymentCro.domesticPaymentForm">\n' +
    '\n' +
    '        <div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM-->\n' +
    '          <div class="domp-template-filter-container" style="position: relative">\n' +
    '            <div class="domp-select-template" ng-click="domesticPaymentCro.toggleTemplateFilterSelection()" ng-show="domesticPaymentCro.templateName == \'\'">\n' +
    '              <div class="select-template label-select">\n' +
    '                <label class="p-t-10 f-18 p-t-5" translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-selected-template" ng-show="domesticPaymentCro.templateName != \'\'">\n' +
    '              <div class="select-template label-template-selected p-l-10 p-t-5" ng-show="domesticPaymentCro.templateName != \'\'">\n' +
    '                <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '\n' +
    '                <img ng-if="domesticPaymentCro.selectedTemplate.imageId" ng-src="{{domesticPaymentCro.selectedTemplate.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img-40"/>\n' +
    '                <img ng-if="!domesticPaymentCro.selectedTemplate.imageId" class="tpl-rounded-img-40" alt="Ico"/>\n' +
    '\n' +
    '                <label class="p-l-10 selected-template-label top-2"><b>{{domesticPaymentCro.templateName}}</b></label>\n' +
    '                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5" ng-click="domesticPaymentCro.removeTemplate()"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-template-filter-selection" ng-class="{\'opened\': domesticPaymentCro.searchTemplateFilterExpanded}">\n' +
    '              <div class="search-template">\n' +
    '                <div class="inner-section left">\n' +
    '                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                </div>\n' +
    '                <div class="inner-section center" style="width:50%;">\n' +
    '                  <input id="searchTemplatesInput" type="text" class="search-input" ng-model="domesticPaymentCro.tmpSearchText.name" ng-change="domesticPaymentCro.searchTemplate(domesticPaymentCro.tmpSearchText.name)" placeholder="{{\'dashboard.searchTemplatesPlaceholder\'| translate}}">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="domp-template-filter">\n' +
    '                <div class="m-b-10">\n' +
    '                  <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfTemplates"></h4>\n' +
    '                  <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                    <a href="" class="list-group-item" data-ng-repeat="template in domesticPaymentCro.templateList.result| filter:domesticPaymentCro.tmpSearchText" ng-click="domesticPaymentCro.selectTemplate(template.id)">\n' +
    '                      <div class="row m-r-0">\n' +
    '                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 p-r-0">\n' +
    '                          <!--<i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                          <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img"/>\n' +
    '                          <img ng-if="!template.imageId" class="tpl-rounded-img" alt="Ico"/>\n' +
    '                        </div>\n' +
    '                        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label p-t-15"  style="padding-left: 50px !important;">\n' +
    '                          <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                          <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM END-->\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="domp-from-section p-20">\n' +
    '          <section class="row">\n' +
    '            <!-- START CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12">\n' +
    '              <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '              <div class="accounts-dropdown">\n' +
    '                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="domesticPaymentCro.toggleFromAccount();" ng-style="domesticPaymentCro.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + domesticPaymentCro.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{domesticPaymentCro.tempDompObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':domesticPaymentCro.tempDompObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!domesticPaymentCro.tempDompObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{domesticPaymentCro.tempDompObj.fromAccountSelect.iban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{domesticPaymentCro.tempDompObj.fromAccountSelect.availableBalance| number:2}} {{domesticPaymentCro.tempDompObj.fromAccountSelect.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                </div>\n' +
    '                <div class="from-accounts-list" ng-show="domesticPaymentCro.fromAccountDropdown" scrollable>\n' +
    '                  <div class="accounts-list-item p-0" data-ng-repeat="item in domesticPaymentCro.paymentTypeGroupDomestic.result[0].debitAccountList" data-ng-click="domesticPaymentCro.setAccountFrom(item);">\n' +
    '\n' +
    '                    <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="amountInput" translate="domesticPayment.amountInputLabel">Amount:</label>\n' +
    '                <div class="input-group">\n' +
    '                  <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask maxlength="12" ng-model="domesticPaymentCro.tempDompObj.amountInput" required ng-class="{\'domp-error\': domesticPaymentCro.domesticPaymentForm.amountInput.$invalid && domesticPaymentCro.tempDompObj.formSubmitted}">\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <button type="button" class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                            ng-if="domesticPayment.countryCode != \'sr\'" style="border:1px solid #062a42;">{{domesticPaymentCro.defaultCurrency}}</button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '                <span class="c-red" ng-show="domesticPaymentCro.domesticPaymentForm.amountInput.$error.required && domesticPaymentCro.tempDompObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="dateInput" translate="domesticPayment.dateInputLabel">Date:</label>\n' +
    '                <div class="input-group ">\n' +
    '                  <input type="text" class="form-control input-field" name="dateInput" id="dateInput" uib-datepicker-popup="shortDate" data-ng-model="domesticPaymentCro.tempDompObj.dateInput" show-weeks="false" is-open="domesticPaymentCro.datePickerOpened" datepicker-options="domesticPaymentCro.dateOptions" date-disabled="domesticPaymentCro.disabled(date, mode)" readonly ng-if="domesticPaymentCro.disabledSunday">\n' +
    '                  <input type="text" class="form-control input-field" name="dateInput" id="dateInput" uib-datepicker-popup="shortDate" data-ng-model="domesticPaymentCro.tempDompObj.dateInput" show-weeks="false" is-open="domesticPaymentCro.datePickerOpened" datepicker-options="domesticPaymentCro.dateOptions" readonly ng-if="!domesticPaymentCro.disabledSunday">\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <button data-ng-click="domesticPaymentCro.openDatePicker()" type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '                      <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '\n' +
    '          <section class="row">\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '              <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                <uib-accordion-group>\n' +
    '                  <uib-accordion-heading>\n' +
    '                    <div class="sepa-heading input-field">\n' +
    '                      <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                        <label class="domp-form-label-sepa" translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                    </div>\n' +
    '                  </uib-accordion-heading>\n' +
    '                  <input type="text" class="form-control input-field" ng-model="domesticPaymentCro.tempDompObj.payersSepaInput1" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allowedCharsDPS}}" style="margin-bottom:10px;" maxlength="35">\n' +
    '                  <input type="text" class="form-control input-field" ng-model="domesticPaymentCro.tempDompObj.payersSepaInput2" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allowedCharsDPS}}" maxlength="35">\n' +
    '                </uib-accordion-group>\n' +
    '              </uib-accordion>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <div class="domp-from-section p-20">\n' +
    '          <section class="row">\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '              <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toAccountInputLabel">\n' +
    '                Account number\n' +
    '              </label>\n' +
    '              <input type="text" class="form-control input-field" capitalize ui-mask="HR 99 9999 9999 9999 9999 9" ui-mask-placeholder ui-mask-placeholder-char="_" ui-options="domesticPaymentCro.uiMaskOptions" minlength="21" ng-model="domesticPaymentCro.tempDompObj.toAccountInput" ng-class="{\'domp-error\': domesticPaymentCro.domesticPaymentForm.toAccountInput.$invalid && domesticPaymentCro.tempDompObj.formSubmitted}" name="toAccountInput" id="toAccountInput" required ng-blur="domesticPaymentCro.fillReceiver(domesticPaymentCro.tempDompObj.toAccountInput)">\n' +
    '              <span class="c-red" ng-show="domesticPaymentCro.domesticPaymentForm.toAccountInput.$error.required && domesticPaymentCro.tempDompObj.formSubmitted" translate="domesticPayment.receiverAccountError"></span>\n' +
    '              <span class="c-red" ng-show="!domesticPaymentCro.domesticPaymentForm.toAccountInput.$error.required && domesticPaymentCro.domesticPaymentForm.toAccountInput.$invalid && domesticPaymentCro.tempDompObj.formSubmitted" translate="domesticPayment.ibanStructError"></span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div click-outside="domesticPaymentCro.searchFilterExpanded = false;" outside-if-not="expandPayeeSearchFilterCRO">\n' +
    '              <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toPayee2">To payee</label>\n' +
    '                <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': domesticPaymentCro.domesticPaymentForm.payeeSearchFilter.$invalid && domesticPaymentCro.tempDompObj.formSubmitted}" style="margin-bottom:15px;">\n' +
    '                  <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                    <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                    <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" class="search-input" ng-model="domesticPaymentCro.tempDompObj.receiversNameInput" ng-change="domesticPaymentCro.searchPayee()" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allowedCharsDPS}}" required maxlength="70" ng-maxlength="70" autocomplete="off">\n' +
    '                  </div>\n' +
    '                  <div id="expandPayeeSearchFilterCRO" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right" ng-click="domesticPaymentCro.toggleFilterSelection()">\n' +
    '                    <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentCro.tempDompObj.receiversNameInput != \'\'" ng-click="domesticPaymentCro.removeSearch()"></i>\n' +
    '                    <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right" ng-show="domesticPaymentCro.tempDompObj.receiversNameInput == \'\'"></i>\n' +
    '                  </div>\n' +
    '                  <div class="domp-filter-selection search-row" ng-class="{\'opened\': domesticPaymentCro.searchFilterExpanded}">\n' +
    '                    <div class="domp-filter-type-selection-wrapper" ng-repeat="payee in domesticPaymentCro.payeeList| filter:domesticPaymentCro.searchPayeeBy" ng-click="domesticPaymentCro.selectPayee(payee.id)">\n' +
    '                      <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                        <i class="zmdi zmdi-account-circle"></i>\n' +
    '                      </div>\n' +
    '                      <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                        <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                        <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentCro.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentCro.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '          <section class="row">\n' +
    '            <div class="form-group col-md-offset-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '              <!-- <label class="domp-form-label" for="receiversAddressInput" translate="domesticPayment.receiversAddressInputLabel">Receiver\'s address:</label> -->\n' +
    '              <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentCro.domesticPaymentForm.receiversAddressInput.$invalid && domesticPaymentCro.tempDompObj.formSubmitted}" name="receiversAddressInput" id="receiversAddressInput" ng-model="domesticPaymentCro.tempDompObj.receiversAddressInput" ng-blur="domesticPaymentCro.replaceUnallowedCharsDPS(\'receiversAddressInput\', domesticPaymentCro.tempDompObj.receiversAddressInput)" maxlength="35" ng-maxlength="35" required>\n' +
    '              <span class="c-red" ng-show="domesticPaymentCro.domesticPaymentForm.receiversAddressInput.$error.required && domesticPaymentCro.tempDompObj.formSubmitted" translate="domesticPayment.receiverAddressError"></span>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '          <section class="row">\n' +
    '            <div class="form-group col-md-offset-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '              <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentCro.domesticPaymentForm.receiversPostalCodeAndCityInput.$invalid && domesticPaymentCro.tempDompObj.formSubmitted}" name="receiversPostalCodeAndCityInput" id="receiversPostalCodeAndCityInput" ng-model="domesticPaymentCro.tempDompObj.receiversPostalCodeAndCityInput" ng-blur="domesticPaymentCro.replaceUnallowedCharsDPS(\'receiversPostalCodeAndCityInput\', domesticPaymentCro.tempDompObj.receiversPostalCodeAndCityInput)" maxlength="35" ng-maxlength="35">\n' +
    '            </div>\n' +
    '          </section>\n' +
    '          <section class="row">\n' +
    '            <div class="form-group col-md-offset-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">\n' +
    '\n' +
    '              <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                <uib-accordion-group>\n' +
    '                  <uib-accordion-heading>\n' +
    '                    <div class="sepa-heading input-field">\n' +
    '                      <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                        <label class="domp-form-label-sepa" translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></div>\n' +
    '                    </div>\n' +
    '                  </uib-accordion-heading>\n' +
    '                  <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allowedCharsDPS}}" ng-model="domesticPaymentCro.tempDompObj.receiversSepaInput1" style="margin-bottom:10px;" maxlength="35">\n' +
    '                  <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allowedCharsDPS}}" ng-model="domesticPaymentCro.tempDompObj.receiversSepaInput2" maxlength="35">\n' +
    '                </uib-accordion-group>\n' +
    '              </uib-accordion>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="domp-from-section p-20">\n' +
    '          <section class="row">\n' +
    '            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="purposeCodeSelect" translate="domesticPayment.purposeCodeSelectLabel">Purpose code</label>\n' +
    '                <div class="p-l-0">\n' +
    '                  <select class="form-control input-field p-l-15 p-r-10" name="purposeCodeSelect" id="purposeCodeSelect" ng-options="option.optionValue for option in domesticPaymentCro.purposeCodesList.result" ng-model="domesticPaymentCro.tempDompObj.purposeCodeSelect" ng-change="domesticPaymentCro.changePurpose(domesticPaymentCro.tempDompObj.purposeCodeSelect)"></select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label domp-purpose-label" for="purposeOfPaymentInput" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '                <div class="p-0">\n' +
    '                  <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.purposeOfPaymentValidation}}" name="purposeOfPaymentInput" id="purposeOfPaymentInput" ng-maxlength="105" maxlength="105" ng-model="domesticPaymentCro.tempDompObj.purposeOfPaymentInput" required ng-class="{\'domp-error\': domesticPaymentCro.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentCro.tempDompObj.formSubmitted}" ng-blur="domesticPaymentCro.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', domesticPaymentCro.tempDompObj.purposeOfPaymentInput)">\n' +
    '                  <span class="c-red" ng-show="domesticPaymentCro.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentCro.tempDompObj.formSubmitted" translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12">\n' +
    '              <div class="col-xs-12 p-l-0">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.referenceNumberLabel">Reference number:\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-3 col-xs-3 p-l-0 p-r-5">\n' +
    '                <input type="text" class="form-control input-field" ng-model="domesticPaymentCro.referenceHR" readonly>\n' +
    '              </div>\n' +
    '              <div class="col-sm-3 col-xs-3 p-l-0 p-r-5">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <!--<select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect"\n' +
    'id="referenceModelSelect" ng-model="domesticPaymentCro.tempDompObj.referenceModelSelect">\n' +
    '<option ng-if="domesticPaymentCro.referenceModelList" ng-repeat="item in domesticPaymentCro.referenceModelList">{{item}}</option>\n' +
    '</select>-->\n' +
    '                  <select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect" id="referenceModelSelect" ng-model="domesticPaymentCro.tempDompObj.referenceModelSelect" ng-options="item as item for item in domesticPaymentCro.referenceModelList" ng-change="domesticPaymentCro.clearReferenceNumber()">\n' +
    '                  </select>\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6 col-xs-6 p-l-0 p-r-0" ng-if="domesticPaymentCro.tempDompObj.referenceModelSelect != \'99\'">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <input type="text" id="referenceNumberInput" name="referenceNumberInput" maxlength="22" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentCro.regexPatterns.allNumbersDashes}}" ng-model="domesticPaymentCro.tempDompObj.referenceNumberInput">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6 col-xs-6 p-l-0 p-r-0" ng-if="domesticPaymentCro.tempDompObj.referenceModelSelect == \'99\'">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <input type="text" class="form-control input-field" name="referenceNumberInput" id="referenceNumberInput2" readonly>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-show="domesticPaymentCro.domesticPaymentForm.referenceNumberInput.$error.required && domesticPaymentCro.tempDompObj.formSubmitted" translate="domesticPayment.referenceModelInputError"></span>\n' +
    '            </div>\n' +
    '          </section>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '        <section class="row p-t-15">\n' +
    '          <div class="col-sm-12 col-lg-6 col-md-6 p-l-30">\n' +
    '            <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value" ng-if="domesticPaymentCro.hideUrgency === false">\n' +
    '                <input type="checkbox" ng-model="domesticPaymentCro.tempDompObj.isUrgentPaymentCheckbox" ng-click="domesticPaymentCro.pushGtmUrgentPaymentEvent();">\n' +
    '              <i class="input-helper"></i>\n' +
    '              <span uib-tooltip="{{\'domesticPayment.urgentPaymentInfo\'| translate}}"\n' +
    '                    tooltip-append-to-body="true" tooltip-trigger="mouseenter"\n' +
    '                    tooltip-placement="top">{{\'domesticPayment.selectUrgentLabel\'| translate}}\n' +
    '              </span>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-12 col-lg-6 col-md-6 p-l-30 t-a-r" style="line-height: 39px;">\n' +
    '            <a ng-href="{{domesticPaymentCro.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges">\n' +
    '              Check the bank charges\n' +
    '            </a>\n' +
    '          </div>\n' +
    '        </section>\n' +
    '        <section class="row clearfix p-15">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-6">\n' +
    '              <button class="btn btn-primary pull-left" type="button" translate="payments.cancel"\n' +
    '                      data-ui-sref="payments.paymentsOverview">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '                    <div class="col-md-6">\n' +
    '              <button class="btn btn-default pull-right" type="submit"\n' +
    '                      translate="domesticPayment.confirmBtn" ng-click="domesticPaymentCro.submitPayment();"></button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </section>\n' +
    '\n' +
    '    </form>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- Step 2 and 3 -->\n' +
    '  <div ng-if="domesticPaymentCro.currentStep === 2" class="domp-step-2" ng-include="\'payments/domestic-payment-resume.tpl.html\'"></div>\n' +
    '  <div ng-if="domesticPaymentCro.currentStep == 3">\n' +
    '    <div data-ng-include="\'payments/domestic-payment-final.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/domestic-payment-bh.tpl.html',
    '<div ng-controller="DomesticPaymentBhCtrl as domesticPaymentBh">\n' +
    '  <div class="domp-header-wrapper col-sm-12 p-0" ng-show="domesticPaymentBh.currentStep!=3">\n' +
    '    <div class="domp-header-row">\n' +
    '      <h2 class="f-28" translate="domesticPayment.header" ng-if="!domesticPaymentBh.tempDompObj.isInternal">Domestic Payment</h2>\n' +
    '      <h2 class="f-28" translate="internalTransfer.transferToAccountLink" ng-if="domesticPaymentBh.tempDompObj.isInternal">Transfer to my account</h2>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="domp-body-wrapper">\n' +
    '    <div ng-if="domesticPaymentBh.currentStep === 1" class="domp-step-1">\n' +
    '      <form novalidate name="domesticPaymentBh.domesticPaymentForm">\n' +
    '        <div class="domp-select-section col-sm-12 p-0" ng-if="!domesticPaymentBh.tempDompObj.isInternal">\n' +
    '          <!--SELECT TEMPLATE CUSTOM -->\n' +
    '          <div class="domp-template-filter-container">\n' +
    '            <div class="domp-select-template" ng-click="domesticPaymentBh.toggleTemplateFilterSelection()" ng-show="domesticPaymentBh.templateName==\'\'">\n' +
    '              <div class="select-template label-select">\n' +
    '                <label class="p-t-10 f-18 p-t-5" translate="domesticPayment.selectFromTemplate">Select from template</label>\n' +
    '                <i class="zmdi zmdi-chevron-down zmdi-hc-2x pull-right m-t-5"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="domp-selected-template" ng-show="domesticPaymentBh.templateName!=\'\'">\n' +
    '              <div class="select-template label-template-selected p-l-10 p-t-5" ng-show="domesticPaymentBh.templateName!=\'\'">\n' +
    '                <img ng-if="domesticPaymentBh.selectedTemplate.imageId" ng-src="{{domesticPaymentBh.selectedTemplate.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img-40"/>\n' +
    '                <div ng-if="!domesticPaymentBh.selectedTemplate.imageId" class="invoice-icon tpl-rounded-img-40 inline-block-display" >ico</div>\n' +
    '                <label class="p-l-10 selected-template-label top-2"><b>{{domesticPaymentBh.templateName}}</b></label>\n' +
    '                <i class="zmdi zmdi-close zmdi-hc-2x pull-right p-t-5" ng-click="domesticPaymentBh.removeTemplate()"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="domp-template-filter-selection" ng-class="{\'opened\': domesticPaymentBh.searchTemplateFilterExpanded}">\n' +
    '              <div class="search-template">\n' +
    '                <div class="inner-section left">\n' +
    '                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                </div>\n' +
    '                <div class="inner-section center" style="width: 50%;">\n' +
    '                  <input id="searchTemplatesInput" type="text" class="search-input" ng-model="domesticPaymentBh.tmpSearchText.name" ng-change="domesticPaymentBh.searchTemplate(domesticPaymentBh.tmpSearchText.name)" placeholder="{{\'dashboard.searchTemplatesPlaceholder\' | translate}}">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="domp-template-filter">\n' +
    '                <div class="m-b-10">\n' +
    '                  <h4 class="p-l-5 m-t-20" translate="domesticPayment.listOfTemplates"></h4>\n' +
    '                  <div class="list-group" style="border-top: 2px solid #9eabd7;" scrollable>\n' +
    '                    <a href="" class="list-group-item" data-ng-repeat="template in domesticPaymentBh.templateList.result | filter:domesticPaymentBh.tmpSearchText" ng-click="domesticPaymentBh.selectTemplate(template.id)">\n' +
    '                      <div class="row m-r-0">\n' +
    '                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 p-r-0">\n' +
    '                          <!--                            <i class="zmdi zmdi-account-circle zmdi-hc-2x" style="font-size: 2.8em;"></i>-->\n' +
    '                          <img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico" class="tpl-rounded-img"/>\n' +
    '                          <div ng-if="!template.imageId" class="invoice-icon tpl-rounded-img">ico</div>\n' +
    '                        </div>\n' +
    '                        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 domp-name-label p-t-15" style="padding-left: 50px !important;">\n' +
    '                          <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                          <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!--SELECT TEMPLATE CUSTOM END-->\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <div class="col-sm-12 domp-from-section">\n' +
    '          <!-- CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '          <div class="col-sm-6 domp-acc-dropdown">\n' +
    '            <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '            <div class="accounts-dropdown">\n' +
    '              <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="domesticPaymentBh.toggleFromAccount();"  ng-style="domesticPaymentBh.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + domesticPaymentBh.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}" >\n' +
    '                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                  <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{domesticPaymentBh.tempDompObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                  <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':domesticPaymentBh.tempDompObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!domesticPaymentBh.tempDompObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                </h4>\n' +
    '                <p class="m-b-0 m-t-0 iban-style">{{domesticPaymentBh.tempDompObj.fromAccountSelect.iban}}</p>\n' +
    '                <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                  {{domesticPaymentBh.tempDompObj.fromAccountSelect.availableBalance | number:2}} {{domesticPaymentBh.tempDompObj.fromAccountSelect.currencySymbol}}\n' +
    '                </p>\n' +
    '                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                <span class="caret-icon" ng-hide="domesticPaymentBh.isRetrieval"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '              </div>\n' +
    '              <div class="from-accounts-list" ng-show="domesticPaymentBh.fromAccountDropdown" scrollable>\n' +
    '                <div class="accounts-list-item p-0" data-ng-repeat="item in domesticPaymentBh.paymentTypeGroupDomestic.result[0].debitAccountList" data-ng-click="domesticPaymentBh.setAccountFrom(item);">\n' +
    '                  <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                      <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                    </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                      {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <div class="row m-r-0">\n' +
    '              <div class="col-sm-12">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="amountInput" translate="domesticPayment.amountInputLabel">Amount:</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask maxlength="12" ng-model="domesticPaymentBh.tempDompObj.amountInput" required ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.amountInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}" ng-disabled="domesticPaymentBh.isRetrieval">\n' +
    '                    <span class="input-group-btn">\n' +
    '                                              <button type="button" class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">{{domesticPaymentBh.defaultCurrency}}</button>\n' +
    '                                         </span>\n' +
    '                  </div>\n' +
    '                  <span class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.amountInput.$error.required && domesticPaymentBh.tempDompObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row m-r-0">\n' +
    '              <div class="col-sm-8">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="dateInput" translate="domesticPayment.dateInputLabel">Date:</label>\n' +
    '                  <div class="input-group ">\n' +
    '                    <input type="text" class="form-control input-field" name="dateInput" id="dateInput"\n' +
    '                           uib-datepicker-popup="shortDate"\n' +
    '                           data-ng-model="domesticPaymentBh.tempDompObj.dateInput"\n' +
    '                           show-weeks="false"\n' +
    '                           is-open="domesticPaymentBh.datePickerOpened"\n' +
    '                           datepicker-options="domesticPaymentBh.dateOptions"\n' +
    '                           readonly\n' +
    '                           current-text="{{\'core.period.today\' | translate}}"\n' +
    '                           clear-text="{{\'core.datePicker.clearBtn\' | translate}}"\n' +
    '                           close-text="{{\'core.datePicker.doneBtn\' | translate}}"\n' +
    '                           >\n' +
    '                    <span class="input-group-btn">\n' +
    '                            <button data-ng-click="domesticPaymentBh.openDatePicker()" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;"><i\n' +
    '                              class="icon icon-calendar" style="font-size: 21px;"></i></button>\n' +
    '                          </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-12 receiver-section">\n' +
    '          <div class="row m-r-0">\n' +
    '            <!-- Start Account number - input -->\n' +
    '            <div class="col-sm-6 col-xs-12 right-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toAccountInputLabelSRB">\n' +
    '                  Account number\n' +
    '                </label>\n' +
    '                <input type="text" class="form-control input-field" name="toAccountInput"\n' +
    '                       ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.onlyNumbers}}" id="toAccountInput"\n' +
    '                       ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.toAccountInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}"\n' +
    '                       ng-model="domesticPaymentBh.tempDompObj.toAccountInput"\n' +
    '                       ng-blur="domesticPaymentBh.checkIsRevenueAccount(); domesticPaymentBh.checkToAccountInputLength();"\n' +
    '                       ng-change="domesticPaymentBh.checkToAccountInputLength();"\n' +
    '                       maxlength="16"\n' +
    '                       required ng-disabled="domesticPaymentBh.isRetrieval || !domesticPaymentBh.revenueAccountsLoaded">\n' +
    '                <div class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.toAccountInput.$error.required && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                     translate="domesticPayment.receiverAccountError">\n' +
    '                </div>\n' +
    '                <!--<div class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.toAccountInput.$error.minlength && domesticPaymentBh.tempDompObj.formSubmitted"-->\n' +
    '                     <!--translate="domesticPayment.receiverAccountMinLengthError">-->\n' +
    '                <!--</div>-->\n' +
    '                <div ng-if="domesticPaymentBh.tempDompObj.isInternal">\n' +
    '                  <div class="c-red"\n' +
    '                       ng-show="domesticPaymentBh.domesticPaymentForm.toAccountInput.$error.properLength && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                       translate="domesticPayment.receiverAccountLengthError">\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div ng-if="!domesticPaymentBh.tempDompObj.isInternal">\n' +
    '                  <div class="c-red"\n' +
    '                       ng-show="domesticPaymentBh.domesticPaymentForm.toAccountInput.$error.properLength && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                       translate="domesticPayment.domesticReceiverAccountLengthError">\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END Account number - input -->\n' +
    '            <!-- /////////// SELECT CUSTOM ///////////// -->\n' +
    '            <div click-outside="domesticPaymentBh.searchFilterExpanded = false;" outside-if-not="expandPayeeSearchFilterSRB" class="col-sm-6 col-xs-12 left-section"\n' +
    '            ng-if="!domesticPaymentBh.tempDompObj.isInternal">\n' +
    '              <div  class="form-group" ng-hide="domesticPaymentBh.isRetrieval">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toPayee">To payee</label>\n' +
    '                <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': domesticPaymentBh.domesticPaymentForm.payeeSearchFilter.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}">\n' +
    '                  <div  class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                    <i  class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                    <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.allowedCharsDPS}}"\n' +
    '                           class="search-input" ng-model="domesticPaymentBh.tempDompObj.receiversNameInput" ng-change="domesticPaymentBh.searchPayee()"\n' +
    '                           required maxlength="35" ng-maxlength="35" autocomplete="off">\n' +
    '                  </div>\n' +
    '                  <div id="expandPayeeSearchFilterSRB" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right" ng-click="domesticPaymentBh.toggleFilterSelection()">\n' +
    '                    <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentBh.tempDompObj.receiversNameInput!=\'\'" ng-click="domesticPaymentBh.removeSearch()"></i>\n' +
    '                    <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right" ng-show="domesticPaymentBh.tempDompObj.receiversNameInput==\'\'"></i>\n' +
    '                  </div>\n' +
    '                  <div class="domp-filter-selection search-row" ng-class="{\'opened\': domesticPaymentBh.searchFilterExpanded}">\n' +
    '                    <div class="domp-filter-type-selection-wrapper" ng-repeat="payee in domesticPaymentBh.payeeList | filter:domesticPaymentBh.searchPayeeBy" ng-click="domesticPaymentBh.selectPayee(payee);">\n' +
    '                      <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                        <i class="zmdi zmdi-account-circle"></i>\n' +
    '                      </div>\n' +
    '                      <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                        <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                        <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentBh.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentBh.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></span>\n' +
    '              </div>\n' +
    '              <div class="form-group" ng-hide="!domesticPaymentBh.isRetrieval">\n' +
    '                <label class="domp-form-label" for="toAccountInput" translate="domesticPayment.toPayee">To payee</label>\n' +
    '                <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.receiversAddressInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}" name="payeeSearchFilter" id="payeeSearchFilter" ng-model="domesticPaymentBh.tempDompObj.receiversNameInput" ng-blur="domesticPaymentBh.replaceUnallowedCharsDPS(\'receiversAddressInput\', domesticPaymentBh.tempDompObj.receiversAddressInput)" maxlength="35" ng-maxlength="35" required ng-disabled="domesticPaymentBh.isRetrieval">\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0" ng-show="domesticPaymentBh.domesticPaymentForm.payeeSearchFilter.$error.required && domesticPaymentBh.tempDompObj.formSubmitted" translate="domesticPayment.toPayeeInputError"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!--//////////////SELECT CUSTOM END/////////////////////// -->\n' +
    '            <div class="col-sm-6 col-xs-12 left-section" ng-if="domesticPaymentBh.tempDompObj.isInternal">\n' +
    '              <label class="domp-form-label domp-purpose-label" for="purposeOfPaymentInput"\n' +
    '                     translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '              <div class="p-0">\n' +
    '                <input type="text" class="form-control input-field"\n' +
    '                       ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.purposeOfPaymentValidation}}"\n' +
    '                       name="purposeOfPaymentInput" id="purposeOfPaymentInput" maxlength="35"\n' +
    '                       ng-model="domesticPaymentBh.tempDompObj.purposeOfPaymentInput" required\n' +
    '                       ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}"\n' +
    '                       ng-disabled="domesticPaymentBh.isRetrieval">\n' +
    '                <span class="c-red"\n' +
    '                      ng-show="domesticPaymentBh.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                      translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row m-r-0" ng-if="!domesticPaymentBh.tempDompObj.isInternal">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 left-section"> </div>\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 right-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="receiversAddressInput" translate="domesticPayment.receiversAddressInputLabel">Receiver\'s address:</label>\n' +
    '                <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.allowedCharsDPS}}" ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.receiversAddressInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}" name="receiversAddressInput" id="receiversAddressInput" ng-model="domesticPaymentBh.tempDompObj.receiversAddressInput" maxlength="35" ng-maxlength="35" required ng-disabled="domesticPaymentBh.isRetrieval">\n' +
    '                <span class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.receiversAddressInput.$error.required && domesticPaymentBh.tempDompObj.formSubmitted" translate="domesticPayment.receiverAddressError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 purpose-section" ng-if="!domesticPaymentBh.tempDompObj.isInternal">\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <div class="col-lg-12 col-md-4 no-padding-on-phone p-r-0 p-l-0">\n' +
    '                  <label class="domp-form-label" for="purposeCodeSelect" translate="domesticPayment.purposeCodeSelectLabel">Purpose code</label>\n' +
    '                  <div class="p-l-0">\n' +
    '                    <select class="form-control input-field p-l-15 p-r-10" name="purposeCodeSelect" id="purposeCodeSelect" ng-options="option.optionValue for option in domesticPaymentBh.purposeCodesList.result" ng-model="domesticPaymentBh.tempDompObj.purposeCodeSelect" ng-change="domesticPaymentBh.changePurpose(domesticPaymentBh.tempDompObj.purposeCodeSelect)" ng-disabled="domesticPaymentBh.isRetrieval"></select>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="col-lg-12 col-md-8 no-padding-on-phone p-r-0 p-l-0 p-t-10">\n' +
    '                  <label class="domp-form-label domp-purpose-label" for="purposeOfPaymentInput" translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</label>\n' +
    '                  <div class="p-0">\n' +
    '                    <input type="text" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.purposeOfPaymentValidation}}" name="purposeOfPaymentInput" id="purposeOfPaymentInput" ng-maxlength="105" maxlength="105" ng-model="domesticPaymentBh.tempDompObj.purposeOfPaymentInput" required ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.purposeOfPaymentInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}" ng-blur="domesticPaymentBh.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', domesticPaymentBh.tempDompObj.purposeOfPaymentInput)" ng-disabled="domesticPaymentBh.isRetrieval">\n' +
    '                    <span class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentBh.tempDompObj.formSubmitted" translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- START Reference number - input -->\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 left-section">\n' +
    '              <div class="col-xs-12 p-l-0">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.referenceNumberLabel">Reference number:</label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-12 col-xs-12 p-l-0 p-r-0">\n' +
    '                <div class="form-group m-b-0">\n' +
    '                  <input type="text" id="referenceNumberInput" class="form-control input-field" name="referenceNumberInput"\n' +
    '                         ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.referenceNumberInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}"\n' +
    '                         ng-maxlength="{{domesticPaymentBh.referenceMaxLength}}" ng-pattern-restrict="{{domesticPaymentBh.referencePattern}}"\n' +
    '                         ng-model="domesticPaymentBh.tempDompObj.referenceNumberInput" ng-blur="domesticPaymentBh.completeReferenceNumber()"\n' +
    '                         ng-change="domesticPaymentBh.validateReferenceNumber(); domesticPaymentBh.checkReferenceNumber();"/>\n' +
    '                  <div class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.referenceNumberInput.$error.referenceNumberRequired && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                       translate="domesticPayment.referenceNumberRequired">\n' +
    '                  </div>\n' +
    '                  <div class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.referenceNumberInput.$error.maxlength && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                       translate="domesticPayment.referenceNumberMaxLength">\n' +
    '                  </div>\n' +
    '                  <div class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.referenceNumberInput.$error.validReferenceNumber && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                       translate="domesticPayment.referenceNumberError">\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END Reference number input -->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Payee field in case of Internal Transfer -->\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 purpose-section" ng-if="domesticPaymentBh.tempDompObj.isInternal">\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 left-section">\n' +
    '              <label class="domp-form-label" for="purposeCodeSelect" translate="domesticPayment.toPayee">To payee</label>\n' +
    '              <input type="text" class="form-control input-field" name="receiverNameInput"\n' +
    '                     maxlength="35"\n' +
    '                     ng-model="domesticPaymentBh.tempDompObj.receiversNameInput">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- End Payee field in case of Internal Transfer -->\n' +
    '\n' +
    '        <!-- Internal transfer BiH checkbox -->\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 purpose-section" ng-if="!domesticPaymentBh.tempDompObj.selectedRevenueAccount">\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 left-section">\n' +
    '              <label class="checkbox checkbox-inline">\n' +
    '                <input type="checkbox" data-ng-model="domesticPaymentBh.tempDompObj.isInternal" data-ng-click="domesticPaymentBh.toggleInternalPayment();">\n' +
    '                <span class="input-helper" translate="internalTransfer.transferToAccountLink">Internal transfer</span>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- End Internal transfer BiH checkbox -->\n' +
    '\n' +
    '        <!-- PUBLIC REVENUE SECTION -->\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 purpose-section revenue-section" ng-if="domesticPaymentBh.tempDompObj.selectedRevenueAccount && !domesticPayment.tempDompObj.isInternal">\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-sm-6 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.taxPayerNumber"></label>\n' +
    '                <input type="text" class="form-control input-field" name="taxCollectorInput" data-ng-model="domesticPaymentBh.tempDompObj.taxPayerId"\n' +
    '                       ng-class="{\'domp-error\': domesticPaymentBh.domesticPaymentForm.taxCollectorInput.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}"\n' +
    '                       maxlength="13" ng-maxlength="13" ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.onlyNumbers}}" required>\n' +
    '                <div class="c-red" ng-show="domesticPaymentBh.domesticPaymentForm.taxCollectorInput.$error.required && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                     translate="domesticPayment.taxPayerError">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-6 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.paymentType"></label>\n' +
    '                <select class="form-control input-field" data-ng-model="domesticPaymentBh.tempDompObj.paymentType">\n' +
    '                  <option ng-repeat="paymentType in domesticPaymentBh.tempDompObj.paymentTypes">{{paymentType}}</option>\n' +
    '                </select>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row m-r-0">\n' +
    '            <div click-outside="domesticPaymentBh.revenueCodeFilterExpanded = false;" outside-if-not="expandRevenueCodeFilter" class="col-sm-6 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.revenueCode"></label>\n' +
    '                <!-- REVENUE TYPE AUTOCOMPLETE -->\n' +
    '                <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': domesticPaymentBh.domesticPaymentForm.revenueCodeFilter.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}">\n' +
    '                  <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                    <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                    <input type="text" name="revenueCodeFilter" class="search-input"\n' +
    '                           ng-model="domesticPaymentBh.tempDompObj.revenueCode"\n' +
    '                           ng-change="domesticPaymentBh.openRevenueCodes()" ng-maxlength="6" maxlength="6"\n' +
    '                           ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.onlyNumbers}}"\n' +
    '                           autocomplete="off" required>\n' +
    '                  </div>\n' +
    '                  <div id="expandRevenueCodeFilter" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                       ng-click="domesticPaymentBh.toggleRevenueCodes();">\n' +
    '                    <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentBh.tempDompObj.revenueCode!=\'\'"\n' +
    '                       ng-click="domesticPaymentBh.closeRevenueCodes()"></i>\n' +
    '                    <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right ng-hide"\n' +
    '                       ng-show="domesticPaymentBh.tempDompObj.revenueCode==\'\'"></i>\n' +
    '                  </div>\n' +
    '                  <div class="domp-filter-selection search-row"\n' +
    '                       ng-class="{\'opened\': domesticPaymentBh.revenueCodeFilterExpanded}">\n' +
    '                    <div class="domp-filter-type-selection-wrapper"\n' +
    '                         ng-repeat="revenueCode in domesticPaymentBh.tempDompObj.revenueCodes | filter: domesticPaymentBh.filterRevenueCodes"\n' +
    '                         ng-click="domesticPaymentBh.selectRevenueCode(revenueCode)">\n' +
    '                      <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                        <p class="domp-list-name m-0">{{revenueCode.description}}</p>\n' +
    '                        <p class="domp-list-number m-0">{{revenueCode.code}}</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="domesticPaymentBh.domesticPaymentForm.revenueCodeFilter.$error.required && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                      translate="domesticPayment.revenueCodeError">\n' +
    '                </div>\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="domesticPaymentBh.domesticPaymentForm.revenueCodeFilter.$error.revenueCodeExistance && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                      translate="domesticPayment.revenueCodeExistanceError">\n' +
    '                </div>\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="domesticPaymentBh.domesticPaymentForm.revenueCodeFilter.$error.revenueCodeType && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                      translate="domesticPayment.revenueCodeTypeError">\n' +
    '                </div>\n' +
    '                <!-- END REVENUE TYPE AUTOCOMPLETE -->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div click-outside="domesticPaymentBh.municipalityFilterExpanded = false;" outside-if-not="expandMunicipalityFilter" class="col-sm-6 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.municipality"></label>\n' +
    '                <!-- MUNICIPALITY AUTOCOMPLETE -->\n' +
    '                <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': domesticPaymentBh.domesticPaymentForm.municipalityFilter.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}">\n' +
    '                  <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                    <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                    <input type="text" name="municipalityFilter" class="search-input"\n' +
    '                           ng-model="domesticPaymentBh.tempDompObj.municipality"\n' +
    '                           ng-change="domesticPaymentBh.openMunicipalities()"\n' +
    '                           ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.onlyNumbers}}"\n' +
    '                           ng-maxlength="3" maxlength="3" autocomplete="off" required>\n' +
    '                  </div>\n' +
    '                  <div id="expandMunicipalityFilter" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                       ng-click="domesticPaymentBh.toggleMunicipalities()">\n' +
    '                    <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentBh.tempDompObj.municipality!=\'\'"\n' +
    '                       ng-click="domesticPaymentBh.removeMunicipalities()"></i>\n' +
    '                    <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right ng-hide"\n' +
    '                       ng-show="domesticPaymentBh.tempDompObj.municipality==\'\'"></i>\n' +
    '                  </div>\n' +
    '                  <div class="domp-filter-selection search-row"\n' +
    '                       ng-class="{\'opened\': domesticPaymentBh.municipalityFilterExpanded}">\n' +
    '                    <div class="domp-filter-type-selection-wrapper"\n' +
    '                         ng-repeat="municipality in domesticPaymentBh.tempDompObj.municipalities |filter: domesticPaymentBh.filterMunicipalities"\n' +
    '                         ng-click="domesticPaymentBh.selectMunicipality(municipality)">\n' +
    '                      <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                        <p class="domp-list-name m-0">{{municipality.description}}</p>\n' +
    '                        <p class="domp-list-number m-0">{{municipality.codeString}}</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                     ng-show="domesticPaymentBh.domesticPaymentForm.municipalityFilter.$error.required && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                     translate="domesticPayment.municipalityError">\n' +
    '                </div>\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                      ng-show="domesticPaymentBh.domesticPaymentForm.municipalityFilter.$error.municipalityExistance && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                      translate="domesticPayment.municipalityExistanceError">\n' +
    '                </div>\n' +
    '                <!-- END MUNICIPALITY AUTOCOMPLETE -->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-sm-6 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label m-t-15" translate="domesticPayment.taxPeriodFrom"></label>\n' +
    '                <div class="input-group ">\n' +
    '                  <input type="text" class="form-control input-field" name="taxPeriodFrom"\n' +
    '                         uib-datepicker-popup="shortDate" data-ng-model="domesticPaymentBh.tempDompObj.taxPeriodFrom"\n' +
    '                         show-weeks="false" is-open="domesticPaymentBh.taxPeriodFromOpened"\n' +
    '                         data-ng-change="domesticPaymentBh.validateTaxPeriod()" readonly>\n' +
    '                    <span class="input-group-btn">\n' +
    '                            <button data-ng-click="domesticPaymentBh.openTaxPeriodFrom()" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                    style="border:1px solid #062a42;"><i\n' +
    '                              class="icon icon-calendar" style="font-size: 21px;"></i></button>\n' +
    '                          </span>\n' +
    '                </div>\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                     ng-show="domesticPaymentBh.domesticPaymentForm.taxPeriodFrom.$error.taxPeriodRange && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                     translate="domesticPayment.taxPeriodRangeError">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-6 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label m-t-15" translate="domesticPayment.taxPeriodTo"></label>\n' +
    '                <div class="input-group ">\n' +
    '                  <input type="text" class="form-control input-field" name="taxPeriodTo"\n' +
    '                         uib-datepicker-popup="shortDate" data-ng-model="domesticPaymentBh.tempDompObj.taxPeriodTo"\n' +
    '                         show-weeks="false" is-open="domesticPaymentBh.taxPeriodToOpened"\n' +
    '                         data-ng-change="domesticPaymentBh.validateTaxPeriod()" readonly>\n' +
    '                    <span class="input-group-btn">\n' +
    '                            <button data-ng-click="domesticPaymentBh.openTaxPeriodTo()" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                    style="border:1px solid #062a42;"><i\n' +
    '                              class="icon icon-calendar" style="font-size: 21px;"></i></button>\n' +
    '                          </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row m-r-0">\n' +
    '            <div click-outside="domesticPaymentBh.budgetOrganizationFilterExpanded = false;" outside-if-not="expandBudgFilterOrg" class="col-sm-6 left-section">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="domesticPayment.budgetOrganisation"></label>\n' +
    '                <!-- BUDGET ORGANIZATIONS AUTOCOMPLETE -->\n' +
    '                <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': domesticPaymentBh.domesticPaymentForm.budgetOrganizationFilter.$invalid && domesticPaymentBh.tempDompObj.formSubmitted}">\n' +
    '                  <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                    <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                    <input type="text" name="budgetOrganizationFilter" class="search-input"\n' +
    '                           ng-model="domesticPaymentBh.tempDompObj.budgetOrganization"\n' +
    '                           ng-change="domesticPaymentBh.openBudgetOrganizations()" maxlength="7"\n' +
    '                           ng-pattern-restrict="{{domesticPaymentBh.regexPatterns.onlyNumbers}}"\n' +
    '                           ng-maxlength="7" autocomplete="off" required>\n' +
    '                  </div>\n' +
    '                  <div id="expandBudgFilterOrg" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                       ng-click="domesticPaymentBh.toggleBudgetOrganizations()">\n' +
    '                    <i class="zmdi zmdi-close domp-close-sign" ng-show="domesticPaymentBh.tempDompObj.budgetOrganization!=\'\'"\n' +
    '                       ng-click="domesticPaymentBh.closeBudgetOrganization()"></i>\n' +
    '                    <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right ng-hide"\n' +
    '                       ng-show="domesticPaymentBh.tempDompObj.budgetOrganization==\'\'"></i>\n' +
    '                  </div>\n' +
    '                  <div class="domp-filter-selection search-row"\n' +
    '                       ng-class="{\'opened\': domesticPaymentBh.budgetOrganizationFilterExpanded}">\n' +
    '                    <div class="domp-filter-type-selection-wrapper"\n' +
    '                         ng-repeat="organization in domesticPaymentBh.tempDompObj.budgetOrganizations |filter: domesticPaymentBh.filterBudgetOrganizations"\n' +
    '                         ng-click="domesticPaymentBh.selectBudgetOrganization(organization)">\n' +
    '                      <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                        <p class="domp-list-name m-0">{{organization.description}}</p>\n' +
    '                        <p class="domp-list-number m-0">{{organization.budgetOrganisationNumber}}</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '                     ng-show="domesticPaymentBh.domesticPaymentForm.budgetOrganizationFilter.$error.required && domesticPaymentBh.tempDompObj.formSubmitted"\n' +
    '                     translate="domesticPayment.budgetOrganizationError">\n' +
    '                </div>\n' +
    '                <!-- END BUDGET ORGANIZATIONS -->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END PUBLIC REVENUE SECTION -->\n' +
    '\n' +
    '        <div class="domp-footer-wrapper">\n' +
    '          <div class="row m-r-0">\n' +
    '            <div ng-if="!domesticPaymentBh.tempDompObj.isInternal" class="col-sm-6 col-lg-6 col-md-6 p-l-30">\n' +
    '              <div class="col-xs-12 p-l-10">\n' +
    '                <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                    <input type="checkbox" ng-model="domesticPaymentBh.tempDompObj.isUrgentPaymentCheckbox" ng-click="domesticPaymentBh.pushGtmUrgentPaymentEvent();">\n' +
    '                  <i class="input-helper"></i> {{\'domesticPayment.selectUrgentLabelSRB\' | translate}} <i uib-tooltip="{{\'domesticPayment.urgentPaymentInfo\' | translate}}" tooltip-append-to-body="true" tooltip-trigger="mouseenter" tooltip-placement="top" class="icon icon-question" style="font-weight: bolder; color:#ff4d5a;"></i>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!--<div class="col-sm-6 col-lg-6 col-md-6 pull-right">-->\n' +
    '              <!--<div class="col-lg-7 col-md-6 col-sm-5"></div>-->\n' +
    '              <!--<div class="col-lg-5 col-md-6 col-sm-7 col-xs-12 p-r-5 p-t-10 charges-label">-->\n' +
    '                <!--<a ng-href="{{domesticPaymentBh.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges" class="pull-right">Check the bank charges</a>-->\n' +
    '              <!--</div>-->\n' +
    '            <!--</div>-->\n' +
    '          </div>\n' +
    '          <div class="row m-r-0">\n' +
    '            <div class="col-xs-6 t-a-l">\n' +
    '              <button class="btn btn-primary" type="button" translate="payments.cancel"\n' +
    '                      data-ui-sref="payments.paymentsOverview">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 t-a-r">\n' +
    '              <button class="btn btn-default" type="submit"\n' +
    '                      translate="domesticPayment.confirmBtn"\n' +
    '                      ng-click="domesticPaymentBh.submitPayment();"></button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '    <div ng-if="domesticPaymentBh.currentStep === 2" class="domp-step-2" ng-include="\'payments/domestic-payment-resume.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/currency-conversion.tpl.html',
    '<section id="main">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="exchange-rate-header-2" ng-if="currencyConversion.currentStep != 3">\n' +
    '            <div class="row m-t-20">\n' +
    '                <div class="col-sm-8 col-xs-12 f-28" translate="currencyConversion.exchangeOffice"></div>\n' +
    '                <div class="col-sm-4 col-xs-12 wrap-text" ng-if="currencyConversion.currentStep == 1" data-ng-click="currencyConversion.openCurrencyCalculate();">\n' +
    '                    <!--<i class="icon icon-change zmdi-hc-2x exchange-office-icon" style="color: #ff4d5a;"></i>-->\n' +
    '                    <span class="f-14 pointer-cst m-l-10" translate="currencyConversion.exchangeRatesCalculator" style="text-decoration: underline;color: #ff4d5a;"></span>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="currencyConversion.currentStep == 1">\n' +
    '          <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="alert alert-info"\n' +
    '               style="background: white; color: black; border: 1px solid lightgray" role="alert">\n' +
    '            <p>\n' +
    '              <a translate="currencyConversion.bankCurrencyInfoMsg11"></a>\n' +
    '              <a class="underline" href="https://icalc.addiko.si/" target="blank" translate="currencyConversion.bankCurrencyInfoMsg12"></a>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '\n' +
    '            <div class="exchange-rates-body">\n' +
    '                <form name="currencyConversion.currencyForm" novalidate>\n' +
    '                    <div class="row m-b-10">\n' +
    '                        <div class="col-md-5 col-sm-5">\n' +
    '                            <label class="bold-font f-18" translate="payments.fromAccount"></label>\n' +
    '\n' +
    '                            <!-- CUSTOM Accounts dropdown -->\n' +
    '                            <div class="accounts-dropdown m-b-10" ng-if="currencyConversion.fromAccountsList.length > 0">\n' +
    '                                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="currencyConversion.toggleFromAccount();"  ng-style="currencyConversion.tempExchangeObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + currencyConversion.tempExchangeObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{currencyConversion.tempExchangeObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':currencyConversion.tempExchangeObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!currencyConversion.tempExchangeObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                                    </h4>\n' +
    '                                    <p class="m-b-0 m-t-0 iban-style">{{currencyConversion.tempExchangeObj.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                        {{currencyConversion.tempExchangeObj.fromAccountSelect.availableBalance | number:2}} {{currencyConversion.tempExchangeObj.fromAccountSelect.currencySymbol}}\n' +
    '                                    </p>\n' +
    '                                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                    <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                                </div>\n' +
    '                                <div class="from-accounts-list m-l-15 m-r-15" ng-show="currencyConversion.fromAccountDropdown" scrollable>\n' +
    '                                    <div class="accounts-list-item p-0" data-ng-repeat="item in currencyConversion.fromAccountsList" data-ng-click="currencyConversion.setAccountFrom(item);">\n' +
    '\n' +
    '                                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                            </h4>\n' +
    '                                            <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                                            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                                            </p>\n' +
    '                                            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '\n' +
    '                                        </div>\n' +
    '\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="accounts-dropdown m-b-10" ng-if="currencyConversion.fromAccountsList.length == 0">\n' +
    '                                <div class="debit-account-widget dashboard-widget-item" style="height: 141px;" ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                  <div class="m-t-30 m-b-30">\n' +
    '                                    <p translate="internalTransfer.nodata"></p>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="row">\n' +
    '\n' +
    '                                <div class="col-sm-12">\n' +
    '                                    <label class="exchange-rate-label f-18" translate="currencyConversion.sellingAmount"></label>\n' +
    '                                    <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="input-group z-index-0">\n' +
    '                                        <input ng-switch-default type="text" class="form-control input-field t-a-r" name="amountInput" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                                               amount-input-mask data-ng-model="currencyConversion.tempExchangeObj.fromAccountAmountInput"\n' +
    '                                               ng-blur="currencyConversion.setFromCurrency();"\n' +
    '                                               ng-class="{\'domp-error\': currencyConversion.currencyForm.amountInput.$invalid && currencyConversion.tempExchangeObj.formSubmitted}"\n' +
    '                                               required>\n' +
    '                                      <input ng-switch-when="sl" type="text" class="form-control input-field t-a-r" name="amountInput" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                                               amount-input-mask data-ng-model="currencyConversion.tempExchangeObj.fromAccountAmountInput"\n' +
    '                                               maxlength="14"\n' +
    '                                               maximal-amount\n' +
    '                                               minimal-amount\n' +
    '                                               ng-disabled="currencyConversion.disableInputFields"\n' +
    '                                             ng-keyup="$event.keyCode == 13 && currencyConversion.setFromCurrency($event);"\n' +
    '                                               ng-blur="currencyConversion.setFromCurrency();"\n' +
    '                                               ng-class="{\'domp-error\': currencyConversion.currencyForm.amountInput.$invalid && currencyConversion.tempExchangeObj.formSubmitted}"\n' +
    '                                               required>\n' +
    '                                        <span class="input-group-btn">\n' +
    '                 <button type="button" class="btn input-group-app-btn disabled ng-scope" style="border:1px solid #062a42;">\n' +
    '                   {{currencyConversion.tempExchangeObj.sellCurrencyInput}}\n' +
    '                 </button>\n' +
    '                </span>\n' +
    '                                    </div>\n' +
    '                                    <span class="c-red" ng-show="currencyConversion.currencyForm.amountInput.$error.required && currencyConversion.tempExchangeObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                                    <span class="c-red" ng-show="currencyConversion.currencyForm.amountInput.$error.minimalAmount">\n' +
    '                                      <span  translate="internalTransfer.minAmount10Error"></span> {{10 | currency:""}} EUR\n' +
    '                                    </span>\n' +
    '                                    <span class="c-red" ng-show="currencyConversion.currencyForm.amountInput.$error.maximalAmount" >\n' +
    '                                      <span translate="internalTransfer.amountLengthError"></span> EUR\n' +
    '                                   </span>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && currencyConversion.tempExchangeObj.sellCurrencyInput"\n' +
    '                              ng-bind="(\'currencyConversion.exchangeRateRatio\' | translate) + \' 1 \'+ (currencyConversion.localCurrency) +\n' +
    '                              \' = \' + (currencyConversion.fromAccountCalculationRate | currency:\'\':4) + \' \' + (currencyConversion.tempExchangeObj.sellCurrencyInput)" class="exchange-rate">\n' +
    '                        </span>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="col-md-2 col-sm-2 col-xs-12 p-0">\n' +
    '                            <div class="t-a-c exchange-office-middle">\n' +
    '                                <!--<i class="icon icon-change zmdi-hc-2x" style="font-size:35px;color:#ff4d5a;"></i>-->\n' +
    '                                <i class="zmdi zmdi-long-arrow-right zmdi-hc-2x" style="font-size:35px;color:#ff4d5a;"></i>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="col-md-5 col-sm-5">\n' +
    '                            <label class="bold-font f-18" translate="payments.toAccount"></label>\n' +
    '\n' +
    '                            <!-- CUSTOM Accounts dropdown -->\n' +
    '                            <div class="accounts-dropdown m-b-10" ng-if="currencyConversion.tempExchangeObj.toAccountSelect && currencyConversion.toAccountsList.length > 0">\n' +
    '                                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="currencyConversion.toggleToAccount();" ng-style="currencyConversion.tempExchangeObj.toAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + currencyConversion.tempExchangeObj.toAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{currencyConversion.tempExchangeObj.toAccountSelect.friendlyName}}</b>\n' +
    '                                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':currencyConversion.tempExchangeObj.toAccountSelect.isFavorite,\'zmdi-star-outline\':!currencyConversion.tempExchangeObj.toAccountSelect.isFavorite}"></i></span>\n' +
    '                                    </h4>\n' +
    '                                    <p class="m-b-0 m-t-0 iban-style">{{currencyConversion.tempExchangeObj.toAccountSelect.iban | formatIban}}</p>\n' +
    '                                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                        {{currencyConversion.tempExchangeObj.toAccountSelect.availableBalance | number:2}} {{currencyConversion.tempExchangeObj.toAccountSelect.currencySymbol}}\n' +
    '                                    </p>\n' +
    '                                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                    <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                                </div>\n' +
    '                                <div class="from-accounts-list m-l-15" ng-show="currencyConversion.toAccountDropdown" scrollable>\n' +
    '                                    <div class="accounts-list-item p-0" data-ng-repeat="item in currencyConversion.toAccountsList" data-ng-click="currencyConversion.setAccountTo(item);">\n' +
    '\n' +
    '                                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                            </h4>\n' +
    '                                            <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                                            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                                            </p>\n' +
    '                                            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="accounts-dropdown m-b-10" ng-if="!currencyConversion.tempExchangeObj.toAccountSelect  || currencyConversion.toAccountsList.length == 0">\n' +
    '                                <div class="debit-account-widget dashboard-widget-item domp-acc-widget"  ng-style="currencyConversion.tempExchangeObj.toAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + currencyConversion.tempExchangeObj.toAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                  <div class="m-t-30 m-b-30">\n' +
    '                                    <p class="m-b-0 m-t-0 iban-style" translate="internalTransfer.nodata"></p>\n' +
    '                                    <p class="m-b-0 m-t-0 iban-style">{{currencyConversion.tempExchangeObj.toAccountSelect.iban}}</p>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="row"  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                                <div class="col-sm-12">\n' +
    '                                    <label class="exchange-rate-label f-18" translate="currencyConversion.buyingAmount"></label>\n' +
    '                                    <div class="row">\n' +
    '                                        <div class="col-sm-8 col-xs-8 p-r-0">\n' +
    '                                            <input type="text" class="t-a-c form-control input-field t-a-r" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                                                   name="toAmountInput"\n' +
    '                                                   amount-input-mask\n' +
    '\n' +
    '                                                   data-ng-model="currencyConversion.tempExchangeObj.toAccountAmountInput" ng-blur="currencyConversion.setToCurrency();"\n' +
    '                                                   ng-class="{\'domp-error\': currencyConversion.currencyForm.amountInput.$invalid && currencyConversion.tempExchangeObj.formSubmitted}" required>\n' +
    '\n' +
    '                                          <span class="c-red" ng-show="currencyConversion.currencyForm.toAmountInput.$error.required && currencyConversion.tempExchangeObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                                          <!--<span class="c-red" ng-show="currencyConversion.currencyForm.toAmountInput.$error.maxlength && currencyConversion.tempExchangeObj.formSubmitted" translate="internalTransfer.amountInputError"></span>-->\n' +
    '                                        </div>\n' +
    '\n' +
    '                                        <!-- Set buying currency -->\n' +
    '                                        <div class="col-sm-4 col-xs-4 p-l-0" ng-if="currencyConversion.localCurrency === \'HRK\' && currencyConversion.tempExchangeObj.sellCurrencyInput == currencyConversion.localCurrency">\n' +
    '                                            <select class="form-control input-field" ng-options="item.symbol for item in currencyConversion.currencyList" data-ng-model="currencyConversion.tempExchangeObj.buyCurrencyInput" data-ng-change="currencyConversion.changeSellCurrency();" ng-disabled="currencyConversion.tempExchangeObj.sellCurrencyInput != currencyConversion.localCurrency">\n' +
    '                                            </select>\n' +
    '                                        </div>\n' +
    '                                        <div class="col-sm-4 col-xs-4 p-l-0" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                                          <button type="button" class="btn input-group-app-btn disabled ng-scope" style="border:1px solid #062a42;">\n' +
    '                                            {{currencyConversion.tempExchangeObj.buyCurrencyInput.symbol}}\n' +
    '                                          </button>\n' +
    '                                            <!--<select class="form-control input-field" ng-options="item.symbol for item in currencyConversion.currencyList" data-ng-model="currencyConversion.tempExchangeObj.buyCurrencyInput" data-ng-change="currencyConversion.changeSellCurrency();">-->\n' +
    '                                            <!--</select>-->\n' +
    '                                        </div>\n' +
    '                                        <!--<div class="col-sm-4 col-xs-4 p-l-0" ng-if="currencyConversion.localCurrency === \'RSD\' || currencyConversion.localCurrency === \'EUR\'">-->\n' +
    '                                        <!--<input type="text" class="form-control input-field" data-ng-model="currencyConversion.tempExchangeObj.buyCurrencyInput.symbol" readonly>-->\n' +
    '                                        <!--</div>-->\n' +
    '                                        <div class="col-sm-4 col-xs-4 p-l-0" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && (currencyConversion.tempExchangeObj.sellCurrencyInput != currencyConversion.localCurrency || currencyConversion.localCurrency != \'HRK\')">\n' +
    '                                            <input type="text" class="t-a-c form-control input-field" data-ng-model="currencyConversion.tempExchangeObj.buyCurrencyInput.symbol" readonly>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                          <div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '\n' +
    '                            <div class="col-sm-12">\n' +
    '                              <label class="exchange-rate-label f-18" translate="currencyConversion.buyingAmount"></label>\n' +
    '                              <div class="input-group z-index-0">\n' +
    '                                <input type="text" class="t-a-c form-control input-field t-a-r" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                                       name="toAmountInput"\n' +
    '                                       amount-input-mask\n' +
    '                                       maxlength="14"\n' +
    '                                       maximal-amount\n' +
    '                                       minimal-amount\n' +
    '                                       ng-keyup="$event.keyCode == 13 && currencyConversion.setToCurrency($event);"\n' +
    '                                       ng-disabled="currencyConversion.disableInputFields"\n' +
    '                                       data-ng-model="currencyConversion.tempExchangeObj.toAccountAmountInput" ng-blur="currencyConversion.setToCurrency();"\n' +
    '                                       ng-class="{\'domp-error\': currencyConversion.currencyForm.amountInput.$invalid && currencyConversion.tempExchangeObj.formSubmitted}">\n' +
    '\n' +
    '                                <span class="input-group-btn">\n' +
    '                 <button type="button" class="btn input-group-app-btn disabled ng-scope" style="border:1px solid #062a42;">\n' +
    '                                            {{currencyConversion.tempExchangeObj.toAccountSelect.currencySymbol}}\n' +
    '                 </button>\n' +
    '                </span>\n' +
    '                              </div>\n' +
    '                              <span class="c-red" ng-show="currencyConversion.currencyForm.toAmountInput.$error.required && currencyConversion.tempExchangeObj.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                              <span class="c-red" ng-show="currencyConversion.currencyForm.toAmountInput.$error.minimalAmount">\n' +
    '                                            <span  translate="internalTransfer.minAmount10Error"></span> {{10 | currency:""}} EUR\n' +
    '                              </span>\n' +
    '                              <span class="c-red" ng-show="currencyConversion.currencyForm.toAmountInput.$error.maximalAmount" >\n' +
    '                                      <span translate="internalTransfer.amountLengthError"></span> EUR\n' +
    '                             </span>\n' +
    '                              <!--<span class="c-red" ng-show="currencyConversion.currencyForm.toAmountInput.$error.maxlength && currencyConversion.tempExchangeObj.formSubmitted" translate="internalTransfer.amountInputError"></span>-->\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                         <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'bh\' && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                               ng-bind="(\'currencyConversion.exchangeRateRatio\' | translate) + \' 1 \'+ (currencyConversion.foreignCurrency) +\n' +
    '                          \' = \' + (currencyConversion.fixedAmount) + \' \' + (currencyConversion.localCurrency)"\n' +
    '                                                       class="exchange-rate" >\n' +
    '                          </span>\n' +
    '                          <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '                               ng-bind="(\'currencyConversion.exchangeRateRatio\' | translate) + \' 1 \'+ (currencyConversion.localCurrency) +\n' +
    '                          \' = \' + (currencyConversion.fixedAmount | currency: \'\':4) + \' \' + (currencyConversion.foreignCurrency)"\n' +
    '                                                       class="exchange-rate" >\n' +
    '                          </span>\n' +
    '                          <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\'"\n' +
    '                                ng-bind="(\'currencyConversion.exchangeRateRatio\' | translate) + \' 1 \'+ (currencyConversion.foreignCurrency) +\n' +
    '                          \' = \' + (currencyConversion.fixedAmount | number:6) + \' \' + (currencyConversion.localCurrency)"\n' +
    '                                class="exchange-rate" >\n' +
    '                          </span>\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                  <div class="row m-t-10">\n' +
    '                    <div class="col-xs-6 t-a-l">\n' +
    '                      <button class="btn btn-primary" type="button" translate="payments.cancel"\n' +
    '                              data-ui-sref="payments.paymentsOverview">\n' +
    '                      </button>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-6 t-a-r">\n' +
    '                      <button ng-if="currencyConversion.countryCode != \'hr\' && currencyConversion.countryCode != \'sl\'" class="btn btn-default"\n' +
    '                              translate="currencyConversion.confirm"\n' +
    '                              data-ng-click="currencyConversion.submitCurrencyConversion();"\n' +
    '                              ng-disabled="currencyConversion.currencyForm.$invalid">\n' +
    '                      </button>\n' +
    '                      <a ng-if="currencyConversion.countryCode === \'sl\'" class="btn btn-default p-t-10" translate="domesticPayment.confirmBtnSlo"\n' +
    '                              data-ng-click="currencyConversion.submitCurrencyConversion($event);"\n' +
    '                              ng-disabled="currencyConversion.nextButtonPressed || (currencyConversion.fromAccountsList.length == 0 ||\n' +
    '                              currencyConversion.toAccountsList.length == 0 || currencyConversion.currencyForm.$invalid)">\n' +
    '                      </a>\n' +
    '                      <button ng-if="currencyConversion.countryCode == \'hr\'" class="btn btn-default"\n' +
    '                              translate="currencyConversion.confirm"\n' +
    '                              data-ng-click="currencyConversion.submitCurrencyConversion();"\n' +
    '                              ng-disabled="currencyConversion.fromAccountsList.length == 0 || !currencyConversion.currencyForm.$valid">\n' +
    '                      </button>\n' +
    '\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '            <!-- TIMELINE CONTAINER -->\n' +
    '            <div class="col-sm-12 l-h-50 p-0" style="background-color: white;border-bottom: 2px solid #9eabd5;">\n' +
    '                <span translate="currencyConversion.exchangeOrder" class="bold-font f-17 m-l-20 ng-scope"></span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-12 no-padding bg-white" style="padding-top:10px;">\n' +
    '\n' +
    '                <br>\n' +
    '               <div class="dropdown acc-period-select col-xl-3 col-md-3 col-sm-3">\n' +
    '                    <button class="btn btn-default dropdown-toggle p-l-30 p-r-30" type="button" data-toggle="dropdown">\n' +
    '                        {{currencyConversion.selectedPeriod.item.description | translate}}\n' +
    '                        <span class="caret"></span>\n' +
    '                    </button>\n' +
    '                    <ul class="dropdown-menu">\n' +
    '                        <li data-ng-repeat="period in currencyConversion.periodList">\n' +
    '                            <a href="" class="f-13" data-ng-click="currencyConversion.timelineTimeFilter(period);">\n' +
    '                {{period.item.description | translate}}\n' +
    '              </a>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="timeline-row col-sm-12 no-padding">\n' +
    '                <div class="t-a-c p-10 no-data-image" ng-if="currencyConversion.currencyExchangeListGrouped.result.length == 0">\n' +
    '                    <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                    <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '                </div>\n' +
    '                <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0" ng-hide="currencyConversion.currencyExchangeListGrouped.result.length == 0">\n' +
    '                    <ul class="hypo-timeline" kcd-recompile="currencyConversion.currencyExchangeListGrouped">\n' +
    '                        <li ng-class="{\'time-label\': payment.isVirtual}" ng-repeat="payment in currencyConversion.currencyExchangeListGrouped.result">\n' +
    '                            <span class="currency-time-frame" ng-if="payment.isVirtual === true">{{payment.date | date:\'shortDate\'}}</span>\n' +
    '                            <i class="icon icon-change currency-icon-change" ng-if="!payment.isVirtual"></i>\n' +
    '                            <div ng-if="!payment.isVirtual" class="hypo-timeline-item payment-item" ng-click="payment.selected = !payment.selected;" ng-class="{\'opened\': payment.selected}">\n' +
    '                                <div class="hypo-timeline-body">\n' +
    '                                    <div class="col-xs-6">\n' +
    '                                        <h4 class="m-b-0 m-t-0 c-gray">\n' +
    '                      <b ng-if="!payment.transactionAmount2">{{::payment.amount |number:2}} {{::payment.currencySymbol}}</b>\n' +
    '                      <b ng-if="payment.transactionAmount2">{{::payment.transactionAmount2 |number:2}} {{::payment.destinationCurrencySymbol}}</b>\n' +
    '<!--                      <span translate="payments.to"></span>\n' +
    '                      <b>{{::payment.toAccountNumber}}</b> -->\n' +
    '                    </h4>\n' +
    '                                        <p class="m-b-0 m-t-0 iban-style">\n' +
    '                                          {{::payment.fromAccountNumber}} -\n' +
    '                                          {{::payment.toAccountNumber}}\n' +
    '                                        </p>\n' +
    '                                      <p ng-show="currencyConversion.showPaymentId" class="m-b-0 m-t-0" id="paymentId">{{::payment.id}}</p>\n' +
    '                                    </div>\n' +
    '                                  <div class="col-xs-6"><span class="pull-right t-a-r m-t-10"><b style="font-size:17px;">\n' +
    '                                      <b>\n' +
    '                                        <span class="po-value-label" ng-class="{\'text-danger\': payment.status === \'Rejected\'}" ng-if="payment.status === \'Rejected\'" translate="paymentsOverview.rejected"></span>\n' +
    '                                        <span class="po-value-label" ng-if="payment.status === \'Processed\'" translate="paymentsOverview.processed"></span>\n' +
    '                                        <span class="po-value-label" ng-if="payment.status === \'Cancelled\'" translate="paymentsOverview.cancelled"></span>\n' +
    '                                        <span class="po-value-label" ng-if="payment.status === \'InProcessing\'" translate="paymentsOverview.inProcessing"></span>\n' +
    '                                        <span class="po-value-label" ng-if="payment.status === \'Opened\'" translate="paymentsOverview.open"></span>\n' +
    '                                        <span class="po-value-label" ng-if="payment.status === \'WaitingQueue\'" translate="paymentsOverview.waitingQueque"></span>\n' +
    '                                      </b>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                                <div ng-if="payment.selected" class="transaction-details" >\n' +
    '                                     <i class="icon icon-change currency-icon-change-two" ng-if="!payment.isVirtual"></i>\n' +
    '                                    <div data-ng-include="\'payments/tl-currency-details.tpl.html\'"></div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="show-more-btn ">\n' +
    '                <button ng-hide="currencyConversion.currencyExchangeListGrouped.hasMore == false" data-ng-click="currencyConversion.loadMoreTimelineItems()" type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents">Load older events</button>\n' +
    '            </div>\n' +
    '\n' +
    '            <!-- END TIMELINE -->\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Currency conversion STEP 2 -->\n' +
    '        <div ng-if="currencyConversion.currentStep == 2" ng-include="\'payments/currency-conversion-resume.tpl.html\'"></div>\n' +
    '\n' +
    '        <!-- Currency conversion STEP 3 -->\n' +
    '        <div ng-if="currencyConversion.currentStep == 3" ng-include="\'payments/currency-conversion-final.tpl.html\'"></div>\n' +
    '\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/currency-conversion-resume.tpl.html',
    '<form name="currencyResume" novalidate>\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{currencyConversion.paymentResponse.fromAccountNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="currencyConversion.amount">Amount</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              <label ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                {{currencyConversion.tempExchangeObj.fromAccountAmountInput | currency:""}} {{currencyConversion.tempExchangeObj.sellCurrencyInput}}\n' +
    '              </label>\n' +
    '              <label ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && currencyConversion.paymentResponse.amount">{{currencyConversion.paymentResponse.amount| currency:""}}</label>\n' +
    '              <label ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && (currencyConversion.paymentResponse.transactionAmount2 || currencyConversion.paymentResponse.currencyExchange.transactionAmount2)">{{currencyConversion.paymentResponse.transactionAmount2| currency:""}}{{currencyConversion.paymentResponse.currencyExchange.transactionAmount2| currency:""}}</label>\n' +
    '              <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && (!currencyConversion.paymentResponse.transactionAmount2 && !currencyConversion.paymentResponse.currencyExchange.transactionAmount2)">\n' +
    '                {{currencyConversion.paymentResponse.currencySymbol}}\n' +
    '              </span>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '              <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && (currencyConversion.paymentResponse.transactionAmount2 || currencyConversion.paymentResponse.currencyExchange.transactionAmount2)">\n' +
    '                {{currencyConversion.paymentResponse.destinationCurrencySymbol}}{{currencyConversion.paymentResponse.currencyExchange.destinationCurrencySymbol}}\n' +
    '              </span>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6" ng-if="currencyConversion.countryCode !== \'bh\'">\n' +
    '            <label class="domp-form-label-review" translate="currencyConversion.bankCharges">Bank charges</label>\n' +
    '            <!--<label class="d-block exchange-resume-val" translate="domesticPayment.checkBankCharges">no info</label>-->\n' +
    '            <a ng-if="!currencyConversion.paymentResponse.hasOwnProperty(\'paymentChargesAmount\')" ng-href="{{currencyConversion.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges" class="d-block domp-form-label-resume">Check the bank charges</a>\n' +
    '            <label ng-if="currencyConversion.paymentResponse.hasOwnProperty(\'paymentChargesAmount\')" class="d-block domp-form-label-resume">{{currencyConversion.paymentResponse.paymentChargesAmount | currency:""}} {{APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency}}</label>\n' +
    '            <a ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="d-block domp-form-label-resume" href="https://icalc.addiko.si/" target="_blank" translate="currencyCalculator.exchangeRates"></a>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!--<div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">-->\n' +
    '          <!--<div class="col-sm-12">-->\n' +
    '            <!--<label class="domp-form-label-review" translate="currencyConversion.exchangeRate">Exchange rate</label>-->\n' +
    '            <!--<label class="d-block domp-form-label-resume">-->\n' +
    '            <!--<span-->\n' +
    '                  <!--ng-bind="\'1 \'+ (currencyConversion.localCurrency) +-->\n' +
    '                          <!--\' = \' + (currencyConversion.fromAccountCalculationRate | number:4) + \' \' + (currencyConversion.tempExchangeObj.sellCurrencyInput)">-->\n' +
    '            <!--</span>-->\n' +
    '            <!--</label>-->\n' +
    '          <!--</div>-->\n' +
    '        <!--</div>-->\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <label class="domp-form-label-review" translate="currencyConversion.when">Date</label>\n' +
    '            <label class="d-block domp-form-label-resume">{{currencyConversion.paymentResponse.dueDate | date: \'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-12">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="currencyConversion.toAccount">To account</label>\n' +
    '          <label class="d-block domp-form-label-resume">{{currencyConversion.paymentResponse.toAccountNumber}}</label>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-3 col-xs-12" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '        <label class="domp-form-label-review" translate="currencyConversion.amount">Amount to</label>\n' +
    '        <label class="d-block domp-form-label-resume">\n' +
    '          <label>{{currencyConversion.tempExchangeObj.toAccountAmountInput | currency:""}} {{currencyConversion.tempExchangeObj.buyCurrencyInput.symbol}}</label>\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="col-sm-3 col-xs-12" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="currencyConversion.exchangeRate">Exchange rate</label>\n' +
    '          <label class="d-block domp-form-label-resume">\n' +
    '            <span ng-if="currencyConversion.countryCode == \'sr\'"\n' +
    '                  ng-bind="\'1 \'+ (currencyConversion.foreignCurrency) + \' = \' + (currencyConversion.fixedAmount | number:4) + \' \' + (currencyConversion.localCurrency)"\n' +
    '                  class="ng-binding">\n' +
    '                    </span>\n' +
    '            <span ng-if="currencyConversion.countryCode == \'bh\'"\n' +
    '                  ng-bind="\'1 \'+ (currencyConversion.foreignCurrency) + \' = \' + (currencyConversion.fixedAmount | number:6) + \' \' + (currencyConversion.localCurrency)"\n' +
    '                  class="ng-binding">\n' +
    '                    </span>\n' +
    '            <span\n' +
    '              ng-if="currencyConversion.countryCode == \'hr\' || currencyConversion.countryCode == \'mne\'"\n' +
    '              ng-bind="\'1 \'+ (currencyConversion.foreignCurrency) + \' = \' + (currencyConversion.fixedAmount | number:2) + \' \' + (currencyConversion.localCurrency)"\n' +
    '              class="ng-binding">\n' +
    '                    </span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <!--<div class="form-group" ng-if="currencyConversion.toAccountCalculationRate && (currencyConversion.countryCode == \'hr\')">-->\n' +
    '            <!--<div class="col-md-offset-6 col-md-3 col-xs-12">-->\n' +
    '              <!--<div class="form-group">-->\n' +
    '                <!--<label class="domp-form-label-review" translate="currencyConversion.exchangeRate">Exchange rate</label>-->\n' +
    '                <!--<label class="d-block domp-form-label-resume">-->\n' +
    '                  <!--<span ng-bind="\'1 \'+ (currencyConversion.localCurrency) +-->\n' +
    '                              <!--\' = \' + (currencyConversion.toAccountCalculationRate | number:4) + \' \' + (currencyConversion.tempExchangeObj.buyCurrencyInput.symbol)">-->\n' +
    '                 <!--</span>-->\n' +
    '                <!--</label>-->\n' +
    '              <!--</div>-->\n' +
    '            <!--</div>-->\n' +
    '        <!--</div>-->\n' +
    '      </div>\n' +
    '        <div ng-if="currencyConversion.countryCode == \'sr\'" class="col-sm-3 col-xs-12">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="currencyConversion.calculatedAmount">Calculated amount</label>\n' +
    '          <label class="d-block domp-form-label-resume">{{currencyConversion.paymentResponse.calculatedAmount | number:2}}\n' +
    '              <span ng-if="currencyConversion.paymentResponse.transactionAmount2">\n' +
    '                {{currencyConversion.paymentResponse.currencySymbol}}\n' +
    '              </span>\n' +
    '              <span ng-if="!currencyConversion.paymentResponse.transactionAmount2">\n' +
    '                {{currencyConversion.paymentResponse.destinationCurrencySymbol}}\n' +
    '              </span>\n' +
    '\n' +
    '          </label>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row" ng-if="currencyConversion.toAccountCalculationRate && (currencyConversion.countryCode == \'mne\')">\n' +
    '      <div class="col-md-offset-6 col-md-3 col-xs-12">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label-review" translate="currencyConversion.exchangeRate">Exchange rate</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              <span ng-bind="\'1 \'+ (currencyConversion.localCurrency) +\n' +
    '                          \' = \' + (currencyConversion.toAccountCalculationRate | number:4) + \' \' + (currencyConversion.tempExchangeObj.buyCurrencyInput.symbol)">\n' +
    '             </span>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-9 col-xs-9">\n' +
    '        <button ng-if="currencyConversion.countryCode != \'sl\'" class="btn btn-primary" translate="currencyConversion.back"\n' +
    '                data-ng-click="currencyConversion.backToCurrencyConversion();"></button>\n' +
    '        <button ng-if="currencyConversion.countryCode != \'sl\'" class="btn btn-primary" translate="payments.edit"\n' +
    '                data-ng-click="currencyConversion.editPayment();"></button>\n' +
    '        <button ng-if="currencyConversion.countryCode == \'sl\'" class="btn btn-primary" translate="domesticPayment.back"\n' +
    '                data-ng-click="currencyConversion.editPayment();"></button>\n' +
    '        <button ng-if="currencyConversion.countryCode != \'sl\'" class="btn btn-primary-warning " translate="payments.delete"\n' +
    '                data-ng-click="currencyConversion.deletePaymentAction(undefined, \'step2\');"></button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-3 col-xs-3">\n' +
    '        <div class="pull-right">\n' +
    '<!--          <button class="btn btn-default confirm-btn"\n' +
    '                  translate="currencyConversion.sign"\n' +
    '                  data-ui-sref="payments.sign({paymentId: currencyConversion.paymentResponse.id, type: \'exchange\'})">\n' +
    '\n' +
    '          </button>-->\n' +
    '          <button ng-if="currencyConversion.countryCode != \'sl\'" class="btn btn-default"\n' +
    '                  translate="currencyConversion.sign"\n' +
    '                  data-ng-click="currencyConversion.signPaymentAction(currencyConversion.paymentResponse);">\n' +
    '          </button>\n' +
    '          <button ng-if="currencyConversion.countryCode == \'sl\'" class="btn btn-default"\n' +
    '                  translate="domesticPayment.confirmBtn"\n' +
    '                  ng-disabled="currencyConversion.confirmButtonPressed"\n' +
    '                  data-ng-click="currencyConversion.signPaymentAction(currencyConversion.paymentResponse);">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/currency-conversion-final.tpl.html',
    '<div class="currency-conversion-msg">\n' +
    '  <div class="app-white-card">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-1">\n' +
    '        <div class="currency-check-icon">\n' +
    '          <i class="zmdi zmdi-check zmdi-hc-3x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-11">\n' +
    '        <h3 translate="currencyConversion.moneyExchangeComplete"></h3>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="currencyConversion.successfullyExchange"></span>\n' +
    '          <span>\n' +
    '            {{currencyConversion.paymentResponse.amount}}\n' +
    '            {{currencyConversion.paymentResponse.currencySymbol}}\n' +
    '          </span>\n' +
    '          <span translate="payments.fromAcc">from</span>\n' +
    '          <span>{{currencyConversion.paymentResponse.fromAccountNumber}}</span>\n' +
    '          <span translate="payments.toAcc">to</span>\n' +
    '          <span>{{currencyConversion.paymentResponse.toAccountNumber}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20">\n' +
    '    <div class="col-sm-6">\n' +
    '      <a href="" data-ng-click="currencyConversion.clearInput();">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.makeAnotherExchange"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '    <div class="col-sm-6">\n' +
    '      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">\n' +
    '        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>\n' +
    '        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/currency-calculator-modal.tpl.html',
    '<div class="p-t-20 p-b-20 p-l-20 p-r-20" ng-class="{\'cust-p-69\': currencyCalculator.countryCode == \'mne\'}">\n' +
    '  <div class="row">\n' +
    '    <div class="col-sm-9 col-xs-9">\n' +
    '      <h4 ng-if="currencyCalculator.countryCode !== \'mne\'" translate="currencyCalculator.exchangeCalculator"></h4>\n' +
    '      <h4 ng-if="currencyCalculator.countryCode === \'mne\'" translate="currencyCalculator.exchangeRates"></h4>\n' +
    '      <h4></h4>\n' +
    '    </div>\n' +
    '    <div class="col-sm-3 col-xs-3" ng-if="currencyCalculator.countryCode !== \'mne\'">\n' +
    '      <i class="zmdi zmdi-close zmdi-hc-2x pull-right pointer-cst" data-ng-click="currencyCalculator.closeModal();"></i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row msg-ctn" ng-if="currencyCalculator.countryCode === \'hr\'">\n' +
    '    <div class="col-sm-12">\n' +
    '      <p translate="currencyCalculator.msg1"></p>\n' +
    '      <p translate="currencyCalculator.msg2"></p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-t-20" ng-if="currencyCalculator.countryCode !== \'mne\'">\n' +
    '\n' +
    '    <div class="col-sm-6">\n' +
    '      <div class="form-group">\n' +
    '        <label translate="currencyConversion.selling">Selling amount</label>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-8 col-xs-8 p-r-0">\n' +
    '            <input type="text" class="form-control input-field t-a-r"\n' +
    '                   placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                   amount-input-mask\n' +
    '                   data-ng-model="currencyCalculator.fromAmountInput"\n' +
    '                   maxlength="12"\n' +
    '                   ng-blur="currencyCalculator.setFromCurrency();">\n' +
    '          </div>\n' +
    '          <div class="col-sm-4 col-xs-4 p-l-0">\n' +
    '            <select class="form-control input-field" style="margin-left:-1px"\n' +
    '                    ng-options="item.symbol for item in currencyCalculator.fromCurrencyList"\n' +
    '                    ng-model="currencyCalculator.fromCurrencySelect"\n' +
    '                    ng-change="currencyCalculator.fromCurrencyChange();">\n' +
    '            <</select>\n' +
    '            <!--<input type="text" class="form-control input-field" data-ng-model="currencyCalculator.localCurrency" readonly>-->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-6">\n' +
    '      <div class="form-group">\n' +
    '        <label translate="currencyConversion.buying">Buying amount</label>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-8 col-xs-8 p-r-0">\n' +
    '            <input type="text" class="form-control input-field t-a-r"\n' +
    '                   placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                   amount-input-mask\n' +
    '                   data-ng-model="currencyCalculator.toAmountInput"\n' +
    '                   maxlength="12"\n' +
    '				   ng-blur="currencyCalculator.setToCurrency();">\n' +
    '          </div>\n' +
    '          <div class="col-sm-4 col-xs-4 p-l-0">\n' +
    '            <select class="form-control input-field" style="margin-left:-1px"\n' +
    '                    ng-options="item.symbol for item in currencyCalculator.toCurrencyList"\n' +
    '                    ng-model="currencyCalculator.toCurrencySelect"\n' +
    '            ng-change="currencyCalculator.toCurrencyChange();">\n' +
    '            </select>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <div>\n' +
    '    <exchange-rates ng-if="currencyCalculator.exchangeRatesList.result.length > 0"\n' +
    '                    exchanges="currencyCalculator.exchangeRatesList"\n' +
    '                    country-code="{{currencyCalculator.countryCode}}"\n' +
    '                    exchange-rates-date="currencyCalculator.ratesDate"></exchange-rates>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!--<h2>currencyCalculatorModal</h2>-->\n' +
    '<!--<p>{{currencyCalculatorModal.ctrlName}}</p>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/change-payment-modal.tpl.html',
    '<div class="statementModal logout-modal-frame"  >\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div  style="color: white; padding-top: 50px;">\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '\n' +
    '      <div class="col-xs-12">\n' +
    '        <div class="logout-modal-header" >{{internationalPayment.msg}}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(\'yes\')" translate="domesticPayment.changePaymentModal.yes">Yes</button>\n' +
    '    <button class="btn btn-primary-red statementBtnClose logout-btns" ng-click="$close()" translate="domesticPayment.changePaymentModal.no">No</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payments/change-payment-date-modal.tpl.html',
    '<div class="statementModal logout-modal-frame"  >\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div  style="color: white; padding-top: 50px;">\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '\n' +
    '      <div class="col-xs-12">\n' +
    '        <div class="logout-modal-header" >{{changePaymentDateModal.obj.msg}}\n' +
    '          <span ng-if="!changePaymentDateModal.obj.isSepaAndUrgent && changePaymentDateModal.obj.domestic && changePaymentDateModal.obj.type == \'ToAccountNumber\' && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '            {{\'domesticPayment.secondNotInSEPAMessage\' | translate}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-if="changePaymentDateModal.obj.type == \'ToAccountNumber\' && !changePaymentDateModal.obj.isSepaAndUrgent" class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(\'yes\')" translate="domesticPayment.changePaymentModal.yes">Yes</button>\n' +
    '    <button class="btn btn-primary-red statementBtnClose logout-btns" ng-click="$close()" translate="domesticPayment.changePaymentModal.no">No</button>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-if="changePaymentDateModal.obj.type == \'ToAccountNumber\' && changePaymentDateModal.obj.isSepaAndUrgent" class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red statementBtnClose logout-btns" ng-click="$close()" translate="domesticPayment.changePaymentModal.ok">Ok</button>\n' +
    '  </div>\n' +
    '  <div ng-if="changePaymentDateModal.obj.type == \'UpdateOldDate\'" class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(\'yes\')" translate="domesticPayment.changePaymentModal.confirm">Yes</button>\n' +
    '    <button class="btn btn-primary-red statementBtnClose logout-btns" ng-click="$close()" translate="domesticPayment.changePaymentModal.cancel">No</button>\n' +
    '  </div>\n' +
    '  <div ng-if="changePaymentDateModal.obj.type == \'Info\'" class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red statementBtnClose logout-btns" ng-click="$close()" translate="domesticPayment.changePaymentModal.close">Close</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-templates/template-list-overview.tpl.html',
    '<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <div ng-switch-default>\n' +
    '    <div ng-include="\'payment-templates/template-list-overview-other.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '  <div ng-switch-when="sl">\n' +
    '    <div ng-include="\'payment-templates/template-list-overview-slo.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-templates/template-list-overview-slo.tpl.html',
    '<section ng-controller="TemplateListOverviewSloCtrl as templateListOverview" id="main">\n' +
    '  <div class="container-fluid p-b-20">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-12">\n' +
    '        <h2 class="f-28" translate="templatesList.header"></h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-12 col-md-12 col-sm-12">\n' +
    '        <!-- START Search -->\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 tmplt-list-section">\n' +
    '          <div class="col-lg-12 col-md-12 col-sm-12 ">\n' +
    '            <div id="searchBtnLeftDiv" class="inner-section left">\n' +
    '              <i class="icon icon-search  icon-hc-2x m-l-5 tml-search-container"></i>\n' +
    '            </div>\n' +
    '            <div class="form-group search-field searchrow">\n' +
    '              <input type="text" class="form-control input-field"\n' +
    '                     name="searchTemplateList" id="searchTemplateList"\n' +
    '                     ng-model="templateListOverview.searchTemplateListApi"\n' +
    '                     ng-change="templateListOverview.searchTemplate(templateListOverview.searchTemplateListApi)"\n' +
    '                     placeholder="{{\'templatesList.searchTemplates\'| translate}}"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- END Search -->\n' +
    '\n' +
    '          <div class="tmplt-list-label col-lg-12 col-md-12 col-sm-12" translate="templateSearch.templatesList">\n' +
    '            List of templates\n' +
    '          </div>\n' +
    '\n' +
    '          <!-- Template list -->\n' +
    '          <div class="col-sm-12 col-md-12 tab-field"\n' +
    '               data-ng-repeat="template in templateListOverview.templateList.result| filter:templateListOverview.searchTemplateList"\n' +
    '               ng-show="templateListOverview.templateList.result.length != 0">\n' +
    '\n' +
    '            <!-- TEMPLATE DETAILS -->\n' +
    '            <div class="container invoice-card">\n' +
    '              <div class="row">\n' +
    '                <div class="invoice-card-top gray-card col-lg-12 col-md-12 col-sm-12 col-xs-12 m-p-0">\n' +
    '\n' +
    '                  <!-- Icon -->\n' +
    '                  <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 m-p-0 hidden-xs">\n' +
    '                    <div ng-if="!template.imageId" class="invoice-icon">ico</div>\n' +
    '                    <div ng-if="template.imageId"\n' +
    '                         ng-style="{\'background-image\': \'url(\' + template.imageDownloadLink + \')\'}"\n' +
    '                         class="t-icon-ctn"></div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 p-0 visible-xs">\n' +
    '                    <div ng-if="!template.imageId" class="invoice-icon">ico</div>\n' +
    '                    <div ng-if="template.imageId"\n' +
    '                         ng-style="{\'background-image\': \'url(\' + template.imageDownloadLink + \')\'}"\n' +
    '                         class="t-icon-ctn-xs"></div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-9 col-md-9 col-sm-8 col-xs-6 cust-pl-30 hidden-xs">\n' +
    '                    <div class="invoice-type wrap-text">\n' +
    '                      <b>{{::template.name}}</b>\n' +
    '                      <br/>\n' +
    '                      <span class="text-muted" ng-bind="::template.toAccountNumber"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-9 col-md-9 col-sm-8 col-xs-6 p-r-0 visible-xs">\n' +
    '                    <div class="invoice-type wrap-text f-13">\n' +
    '                      <b>{{::template.name}}</b>\n' +
    '                      <br/>\n' +
    '                      <span class="text-muted f-12" ng-bind="::template.toAccountNumber"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 m-p-0">\n' +
    '                    <span class="col-sm-6">\n' +
    '                      <i class="icon icon-arrdown i-c31 cursor-pointer"\n' +
    '                         ng-click="templateListOverview.toggleDetails(template)"></i>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <!-- Delete template -->\n' +
    '                  <div class="invoice-card-top-right gray-card col-lg-1 col-md-1 col-sm-1 col-xs-2 pull-right">\n' +
    '                    <span class="pull-right tmplt-delete-sign">\n' +
    '                      <i class="icon icon-close i-dblue i-lh21 cursor-pointer"\n' +
    '                         data-ng-click="templateListOverview.deleteTemplate(template)"></i>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row tmplt-card-detail" ng-class="{collapse: !template.openedDetails}">\n' +
    '                <div class="tmplt-content tmplt-from-section container m-t-0">\n' +
    '                  <div ng-if="!template.editable">\n' +
    '                    <div class="row container-template" ng-if="template.sepaUpnIdentificators.debtorName || template.sepaUpnIdentificators.debtorName2">\n' +
    '                      <div class="col-sm-6">\n' +
    '                        <label class="invoice-inline-title text-muted"\n' +
    '                               translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '                        <label class="tmplt-detail-label-description black-text p-0">{{template.sepaUpnIdentificators.debtorName}}</label>\n' +
    '                        <label class="tmplt-detail-label-description black-text">{{template.sepaUpnIdentificators.debtorName2}}</label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- ============================================== -->\n' +
    '                <!------------------START: DETAIL VIEW --------------->\n' +
    '                <!-- ============================================== -->\n' +
    '                <div ng-if="!template.editable">\n' +
    '                  <div\n' +
    '                    ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\' || template.paymentTypeGroup == \'LocalCurrencyTransfer\'">\n' +
    '                    <div class="tmplt-content tmplt-payee-section">\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-sm-6" ng-if="template.toAccountNumber != \'\'">\n' +
    '                          <span class="invoice-inline-title text-muted" translate="templatesList.accountNumber"><b>Account number</b></span>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.toAccountNumber == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.toAccountNumber != undefined && template.toAccountNumber != \'\'">{{template.toAccountNumber}}\n' +
    '                            </label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.toAccountNumber == undefined || template.toAccountNumber == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.toAccountNumber != undefined">\n' +
    '                            <label class="black-text">{{template.toAccountNumber}}</label>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="col-sm-6" ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\'">\n' +
    '                          <span class="invoice-inline-title text-muted"\n' +
    '                                translate="templatesList.toPayee"><b>To payee</b>\n' +
    '                          </span>\n' +
    '                          <div class="word-break" ng-if="templateListOverview.updateResponse.receiverName == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverName != undefined && template.receiverName != \'\'">{{template.receiverName}}</label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverName == undefined || template.receiverName == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverName != undefined">\n' +
    '                            <label class="black-text">{{template.receiverName}}</label>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\'">\n' +
    '                        <div class="col-sm-offset-6 col-sm-6">\n' +
    '                          <span class="invoice-inline-title text-muted" translate="templatesList.payeeStreet"><b>Payee street</b></span>\n' +
    '                          <div class="word-break"\n' +
    '                               ng-if="templateListOverview.updateResponse.receiverAddress1 == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverAddress1 != undefined && template.receiverAddress1 != \'\'">{{template.receiverAddress1}}</label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverAddress1 == undefined || template.receiverAddress1 == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div class="word-break"\n' +
    '                               ng-if="templateListOverview.updateResponse.receiverAddress1 != undefined">\n' +
    '                            <label class="black-text">{{template.receiverAddress1}}</label>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\'">\n' +
    '                        <div class="col-sm-6 col-sm-offset-6">\n' +
    '                          <span class="invoice-inline-title text-muted"\n' +
    '                                translate="templatesList.payeeCity">\n' +
    '                            <b>\n' +
    '                            Payee city\n' +
    '                            </b>\n' +
    '                          </span>\n' +
    '                          <div class="word-break" ng-if="templateListOverview.updateResponse.receiverCity == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverCity != undefined && template.receiverCity != \'\'">{{template.receiverCity}}</label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverCity == undefined || template.receiverCity == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverCity != undefined">\n' +
    '                            <label class="black-text">{{template.receiverCity}}</label>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="template.sepaUpnIdentificators.creditorName || template.sepaUpnIdentificators.creditorName2">\n' +
    '                        <div class="col-sm-6"></div>\n' +
    '                        <div class="col-sm-6">\n' +
    '                            <label class="invoice-inline-title text-muted" translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '                            <label class="tmplt-detail-label-description black-text p-0">{{template.sepaUpnIdentificators.creditorName}}</label>\n' +
    '                            <label class="tmplt-detail-label-description black-text">{{template.sepaUpnIdentificators.creditorName2}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div ng-if="template.paymentTypeGroup === \'ForeignPayment\'" class="receiver-section p-20"\n' +
    '                       style="padding: 10px">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="eInvoiceDetail.recipientAccount">\n' +
    '                            Account number\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text hidden-xs">\n' +
    '                            {{template.toAccountNumber}}\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text visible-xs f-16">\n' +
    '                            {{template.toAccountNumber}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="domesticPayment.toPayee">\n' +
    '                            To payee\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.receiverName}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-6"></div>\n' +
    '                      <div class="col-md-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="paymentTemplates.address">\n' +
    '                            Address\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.receiverAddress1}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-6 col-md-offset-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label"\n' +
    '                                 translate="domesticPayment.receiversPostalCodeAndCityInputLabel">\n' +
    '                            Address\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.receiverCity}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- Foreign purpose start -->\n' +
    '\n' +
    '                  <div ng-if="template.paymentTypeGroup == \'ForeignPayment\'">\n' +
    '                    <!--<div class="row">-->\n' +
    '                      <!--<div class="col-md-6">-->\n' +
    '                        <!--<div class="form-group">-->\n' +
    '                          <!--<label class="domp-template-label" translate="templatesList.purposeCode">-->\n' +
    '                            <!--Purpose code-->\n' +
    '                          <!--</label>-->\n' +
    '                          <!--<label class="domp-template-text">-->\n' +
    '                            <!--{{template.purposeCodeDPS}}-->\n' +
    '                          <!--</label>-->\n' +
    '                          <!--&lt;!&ndash;<label ng-if="template.purpose && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"&ndash;&gt;-->\n' +
    '                          <!--&lt;!&ndash;class="domp-template-text">&ndash;&gt;-->\n' +
    '                          <!--&lt;!&ndash;{{template.purpose}}&ndash;&gt;-->\n' +
    '                          <!--&lt;!&ndash;</label>&ndash;&gt;-->\n' +
    '                        <!--</div>-->\n' +
    '                      <!--</div>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <div class="col-md-12">\n' +
    '                      <div class="form-group">\n' +
    '                        <label class="domp-template-label" translate="internationalPayment.paymentPurpose">\n' +
    '                          Payment purpose\n' +
    '                        </label>\n' +
    '                        <label class="domp-template-text word-break">\n' +
    '                          {{template.purpose}}\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="receiver-section p-20" ng-if="template.paymentTypeGroup == \'LocalCurrencyTransfer\'">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-12">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="internationalPayment.paymentPurpose">\n' +
    '                            Payment purpose\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text word-break">\n' +
    '                            {{template.purpose}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- Foreign purpose end -->\n' +
    '\n' +
    '                  <!-- Foreign BIC start -->\n' +
    '\n' +
    '                  <div ng-if="template.paymentTypeGroup === \'ForeignPayment\'" class="receiver-section p-20">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicNumber_SLO">\n' +
    '                            BIC number\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiarySWIFTCode}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicCountry_SLO">\n' +
    '                            Country\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.recipientCountry.code}} {{template.recipientCountry.description}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-12">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicBankName">Bank Name</label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiaryBankName}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicAddress">BIC Address</label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiaryBankAddress}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicCity">BIC City</label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiaryBankCity}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicBankCharges">\n' +
    '                            Troškovna opcija:</label>\n' +
    '                          <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                            <!-- Map for other-->\n' +
    '                            <label ng-switch-default class="domp-template-text">\n' +
    '                              <div ng-switch="template.paymentCharges">\n' +
    '                                <div ng-switch-when="3">\n' +
    '                                  SHA\n' +
    '                                </div>\n' +
    '                                <div ng-switch-when="1">\n' +
    '                                  OUR\n' +
    '                                </div>\n' +
    '                                <div ng-switch-when="2">\n' +
    '                                  BEN\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </label>\n' +
    '                            <!-- Map for Slovenia-->\n' +
    '                            <label ng-switch-when="sl" class="domp-template-text">\n' +
    '                              <div ng-switch="template.paymentCharges">\n' +
    '                                <div ng-switch-when="0">\n' +
    '                                  SHA\n' +
    '                                </div>\n' +
    '                                <div ng-switch-when="1">\n' +
    '                                  OUR\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </label>\n' +
    '                          </span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- Foreign BIC end -->\n' +
    '\n' +
    '                  <div class="tmplt-content tmplt-purpose-section">\n' +
    '                    <div class="row"\n' +
    '                         ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\'">\n' +
    '                      <div class="col-sm-6">\n' +
    '                        <span class="invoice-inline-title text-muted" translate="templatesList.purposeCode"><b>Purpose code</b></span>\n' +
    '\n' +
    '                        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                          <label class="black-text">\n' +
    '                          <span ng-if="template.purposeCodeDPS != undefined && template.purposeCodeDPS != \'\'">\n' +
    '                            {{::template.purposeCodeDPS}} -\n' +
    '                          </span>\n' +
    '                            {{::template.purpose}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.purposeCode}}\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-label" translate="internationalPayment.paymentPurpose">\n' +
    '                            Payment purpose\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text word-break">\n' +
    '                            {{template.purpose}}\n' +
    '                          </label>\n' +
    '\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="(template.purposeCodeDPS == undefined || template.purposeCodeDPS == \'\') && (template.purpose == undefined || template.purpose == \'\')">-</label>\n' +
    '                      </div>\n' +
    '                      <div class="col-sm-6">\n' +
    '                        <span class="invoice-inline-title text-muted" translate="templatesList.referenceNumber"><b>Reference number</b></span>\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="template.referenceTo && templateListOverview.countryCode == \'sl\'">{{templateListOverview.formatReferenceNumber(template.referenceTo)}}</label>\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="!template.referenceTo">-</label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- REVENUE PAYMENT INFO -->\n' +
    '                  <div class="tmplt-content tmplt-purpose-section"\n' +
    '                       ng-if="template.paymentTypeGroup === \'RevenuePayment\'">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.accountNumber"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.toAccountNumber}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.purposeCode"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.purpose + \'-\' +\n' +
    '                            template.purposeCodeDPS}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.toPayee"></label>\n' +
    '                          <label class="domp-form-label-resume word-break">{{template.receiverName}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.payeeStreet"></label>\n' +
    '                          <label class="domp-form-label-resume word-break">{{template.receiverAddress1}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.taxPayerNumber"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.taxPayerId}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.paymentType"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.revenuePaymentType}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.revenueCode"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.revenueCode}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.municipality"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.municipality}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.taxPeriodFrom"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.taxPeriodFrom | date: \'shortDate\'}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.taxPeriodTo"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.taxPeriodTo | date: \'shortDate\'}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.budgetOrganisation"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.budgetOrganization}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.referenceNumber"></label>\n' +
    '                          <label ng-if="template.reference"\n' +
    '                                 class="domp-form-label-resume">{{template.reference}}</label>\n' +
    '                          <label ng-if="!template.reference" class="domp-form-label-resume"> - </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <!-- END REVENUE PAYMENT INFO -->\n' +
    '\n' +
    '                  <div class="row">\n' +
    '\n' +
    '\n' +
    '                    <div class=" text-right p-r-10 ">\n' +
    '                      <button class="btn btn-default editTemplate pull-right" translate="templatesList.edit"\n' +
    '                              ng-if="template.paymentSubTypeGroup != \'LocalCurrencyTransfer\' &&\n' +
    '                              template.paymentSubTypeGroup != \'ForeignCurrencyTransfer\' &&\n' +
    '                              template.paymentSubTypeGroup != \'CurrencyExchange\' &&\n' +
    '                              template.paymentSubTypeGroup != \'PaymentNotSupported\'"\n' +
    '                              ng-click="templateListOverview.editTemplate(template)">Edit\n' +
    '                      </button>\n' +
    '                      <button ng-if="templateListOverview.countryCode == \'sl\'"\n' +
    '                              class="btn btn-default editTemplate pull-right" translate="templatesList.pay"\n' +
    '                              ng-click="templateListOverview.goToPayment(template)">Pay\n' +
    '                      </button>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <!-- ============================================== -->\n' +
    '                <!------------------END:  DETAIL VIEW ---------------->\n' +
    '                <!-- ============================================== -->\n' +
    '\n' +
    '\n' +
    '                <!--==============================================================================-->\n' +
    '                <!------------------------------- EDITABLE START ----------------------------------->\n' +
    '                <!--==============================================================================-->\n' +
    '                <div ng-if="template.editable">\n' +
    '                  <form name="templateListOverview.templatesListForm" novalidate>\n' +
    '                    <div class="row m-t-20" id="spaha0">\n' +
    '                      <div class="col-xs-12 col-md-6 col-lg-6">\n' +
    '                        <div class="hidden-xs t-a-c">\n' +
    '                          <div class="col-lg-12 text-left">\n' +
    '                            <span class="template-headers" translate="paymentTemplates.templateIcon">\n' +
    '                              Template icon\n' +
    '                            </span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="visible-xs ">\n' +
    '                          <div class="col-xs-12 col-md-6 col-lg-6 text-left">\n' +
    '                            <span class="template-headers" translate="paymentTemplates.templateIcon">\n' +
    '                              Template icon\n' +
    '                            </span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div>\n' +
    '                          <div class="dropdown hidden-xs t-a-c">\n' +
    '                            <div\n' +
    '                              class="btn pull-left btn-default dropdown-toggle img-selector-btn edit-tmpl-img-selector"\n' +
    '                              type="button"\n' +
    '                              data-toggle="dropdown">\n' +
    '                              <div>\n' +
    '                                <img class="img-circle edit-tmpl-selected-img"\n' +
    '                                     ng-src="{{templateListOverview.selectedImage.downloadLink}}" alt="Ico"/>\n' +
    '                              </div>\n' +
    '                              <span class="caret-icon edit-tmpl-caret">\n' +
    '                                <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                            <div class="dropdown-menu edit-tmpl-img-container" role="menu" aria-labelledby="menu1">\n' +
    '                              <div ng-repeat="image in templateListOverview.images"\n' +
    '                                   data-ng-click="templateListOverview.selectImage(image)">\n' +
    '                                <div class="col-xs-12 img-option">\n' +
    '                                  <img class="img-circle edit-tmpl-img" ng-src="{{image.downloadLink}}" alt="Ico">\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="dropdown visible-xs">\n' +
    '                            <div\n' +
    '                              class="btn pull-left btn-default dropdown-toggle img-selector-btn edit-tmpl-img-selector"\n' +
    '                              type="button"\n' +
    '                              data-toggle="dropdown">\n' +
    '                              <div>\n' +
    '                                <img class="img-circle edit-tmpl-selected-img"\n' +
    '                                     ng-src="{{templateListOverview.selectedImage.downloadLink}}" alt="Ico"/>\n' +
    '                              </div>\n' +
    '                              <span class="caret-icon edit-tmpl-caret">\n' +
    '                                <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                            <div class="dropdown-menu edit-tmpl-img-container" role="menu" aria-labelledby="menu1">\n' +
    '                              <div ng-repeat="image in templateListOverview.images"\n' +
    '                                   data-ng-click="templateListOverview.selectImage(image)">\n' +
    '                                <div class="col-xs-12 img-option">\n' +
    '                                  <img class="img-circle edit-tmpl-img" ng-src="{{image.downloadLink}}" alt="Ico">\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-12 col-md-6 col-lg-6">\n' +
    '                        <span class="invoice-inline-title text-muted" translate="paymentTemplates.templateName">\n' +
    '                          Template name\n' +
    '                        </span>\n' +
    '                        <div>\n' +
    '                          <input type="text" class="form-control input-field"\n' +
    '                                 id="templateNameInput" name="templateNameInput"\n' +
    '                                 data-ng-model="templateListOverview.tempObj.templateName"\n' +
    '                                 placeholder="{{\'internalTransfer.templateName\'| translate}}"\n' +
    '                                 required\n' +
    '                                 ng-class="{\'domp-error\': templateListOverview.templatesListForm.templateNameInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                 maxlength="35">\n' +
    '                          <span class="c-red"\n' +
    '                                ng-show="templateListOverview.templatesListForm.purposeOfPaymentInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row m-t-20" ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\' && template.paymentTypeGroup != \'ForeignPayment\'">\n' +
    '                      <div class="col-sm-6">\n' +
    '                        <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                          <uib-accordion-group>\n' +
    '                            <uib-accordion-heading>\n' +
    '                              <div class="sepa-heading input-field">\n' +
    '                                <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                                  <label class="domp-form-label-sepa"\n' +
    '                                         translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                                  class="icon icon-arrdown"></i></div>\n' +
    '                              </div>\n' +
    '                            </uib-accordion-heading>\n' +
    '                            <input type="text" class="form-control input-field"\n' +
    '                                   ng-model="templateListOverview.tempObj.payersSepaInput1"\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                   maxlength="35">\n' +
    '                          </uib-accordion-group>\n' +
    '                        </uib-accordion>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row m-t-25 p-r-15" id="spaha1">\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-xs-12 col-sm-6 p-b-10">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12 col-sm-12">\n' +
    '                              <div class="col-md-12 col-sm-6 m-b-15">\n' +
    '                                <div class="row">\n' +
    '                                  <div class="col-xs-12">\n' +
    '                                      <span class="invoice-inline-title text-muted"\n' +
    '                                            translate="templatesList.accountNumber"><b>Account number</b></span>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                                <div>\n' +
    '                                  <label class="black-text">\n' +
    '                                    {{templateListOverview.tempObj.toAccountInput}}\n' +
    '                                  </label>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <!-- START: SELECT PAYEE -->\n' +
    '                        <div ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\'"\n' +
    '                             class="col-xs-12 col-sm-6 p-l-30">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12 col-sm-12">\n' +
    '                              <span class="invoice-inline-title text-muted"\n' +
    '                                    translate="templatesList.toPayee"><b>To payee</b></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                          <div class="row p-l-15 p-r-15">\n' +
    '                            <div class="col-sm-12 col-xs-12 domp-filter-container"\n' +
    '                                 ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.payeeSearchFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                                <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                              </div>\n' +
    '                              <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                                <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" class="search-input"\n' +
    '                                       ng-model="templateListOverview.payeeSearchFilter"\n' +
    '                                       ng-change="templateListOverview.searchPayee()"\n' +
    '                                       ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                       required\n' +
    '                                       maxlength="{{templateListOverview.fieldMaxLength}}" ng-maxlength="templateListOverview.fieldMaxLength" autocomplete="off">\n' +
    '                              </div>\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                                   ng-click="templateListOverview.toggleFilterSelection()">\n' +
    '                                <i class="icon icon-close domp-close-sign i-lh17"\n' +
    '                                   ng-show="templateListOverview.payeeSearchFilter != \'\'"\n' +
    '                                   ng-click="templateListOverview.removeSearch()"></i>\n' +
    '                                <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                                   ng-show="templateListOverview.payeeSearchFilter == \'\'"></i>\n' +
    '                              </div>\n' +
    '                              <div class="domp-filter-selection search-row"\n' +
    '                                   ng-class="{\'opened\': templateListOverview.searchFilterExpanded}">\n' +
    '                                <div class="domp-filter-type-selection-wrapper"\n' +
    '                                     ng-repeat="payee in templateListOverview.payeeList| filter:templateListOverview.searchPayeeBy"\n' +
    '                                     ng-click="templateListOverview.selectPayee(payee.id)">\n' +
    '                                  <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                                    <i class="zmdi zmdi-account-circle" style="color:#9eabd5"></i>\n' +
    '                                  </div>\n' +
    '                                  <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                                    <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                                    <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                        <!-- END: SELECT PAYEE -->\n' +
    '                      </div>\n' +
    '\n' +
    '                      <div class="row" ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\'">\n' +
    '                        <div class="col-xs-12 col-sm-6">\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-6 m-t-10 p-l-30">\n' +
    '                          <input type="text" class="form-control input-field" name="receiversAddressInput"\n' +
    '                                 id="receiversAddressInput" ng-maxlength="templateListOverview.fieldMaxLength" maxlength="{{templateListOverview.fieldMaxLength}}"\n' +
    '                                 ng-model="templateListOverview.tempObj.receiversAddressInput" required\n' +
    '                                 ng-class="{\'domp-error\': templateListOverview.templatesListForm.receiversAddressInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                 ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                 ng-change="templateListOverview.checkInputChanges(template.paymentTypeGroup)">\n' +
    '                          <span class="c-red"\n' +
    '                                ng-show="templateListOverview.templatesListForm.receiversAddressInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="domesticPayment.receiverAddressError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\'">\n' +
    '                        <div class="col-xs-12 col-sm-6"></div>\n' +
    '                        <div class="col-xs-12 col-sm-6 m-t-10 p-l-30">\n' +
    '                          <input type="text" class="form-control input-field" name="receiversPostalCodeAndCityInput"\n' +
    '                                 id="receiversPostalCodeAndCityInput" ng-maxlength="templateListOverview.fieldMaxLength" maxlength="{{templateListOverview.fieldMaxLength}}"\n' +
    '                                 ng-model="templateListOverview.tempObj.receiversPostalCodeAndCityInput" required\n' +
    '                                 ng-class="{\'domp-error\': templateListOverview.templatesListForm.receiversPostalCodeAndCityInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                 ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                 ng-change="templateListOverview.checkInputChanges(template.paymentTypeGroup)">\n' +
    '                          <span class="c-red"\n' +
    '                                ng-show="templateListOverview.templatesListForm.receiversPostalCodeAndCityInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="domesticPayment.receiverCityError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="template.paymentTypeGroup != \'LocalCurrencyTransfer\' && template.paymentTypeGroup != \'ForeignPayment\'">\n' +
    '                        <div class="col-xs-12 col-sm-6"></div>\n' +
    '                        <div class="col-xs-12 col-sm-6 m-t-10 p-l-30">\n' +
    '                          <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                            <uib-accordion-group>\n' +
    '                              <uib-accordion-heading>\n' +
    '                                <div class="sepa-heading input-field">\n' +
    '                                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                                    <label class="domp-form-label-sepa"\n' +
    '                                           translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '                                  </div>\n' +
    '                                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                                    class="icon icon-arrdown"></i></div>\n' +
    '                                </div>\n' +
    '                              </uib-accordion-heading>\n' +
    '                              <input type="text" class="form-control input-field"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     ng-model="templateListOverview.tempObj.receiversSepaInput1" maxlength="35">\n' +
    '                            </uib-accordion-group>\n' +
    '                          </uib-accordion>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row" id="spaha2">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20 m-b-10">\n' +
    '                        <div class="row" ng-if="template.paymentTypeGroup != \'ForeignPayment\' && template.paymentTypeGroup != \'LocalCurrencyTransfer\'">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted m-b-5"\n' +
    '                                  translate="domesticPayment.purposeCodeSelectLabel">\n' +
    '                              Purpose code\n' +
    '                            </span>\n' +
    '                            <select class="form-control input-field" name="purposeCodeSelect"\n' +
    '                                    id="purposeCodeSelect"\n' +
    '                                    ng-options="option.optionValue for option in templateListOverview.purposeCodesList.result"\n' +
    '                                    ng-model="templateListOverview.tempObj.purposeCodeSelect"\n' +
    '                                    ng-change="templateListOverview.changePurpose(templateListOverview.tempObj.purposeCodeSelect)">\n' +
    '                            </select>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <!-- REFERENCE INPUT FOR SLO ENVIRONMENT -->\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20"\n' +
    '                           ng-if="template.paymentTypeGroup != \'ForeignPayment\' && template.paymentTypeGroup != \'LocalCurrencyTransfer\'">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted m-b-5"\n' +
    '                                  translate="domesticPayment.referenceNumberLabel">Reference number</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-6 col-sm-3 p-r-0">\n' +
    '                            <div class="col-xs-12 p-l-0 p-r-0">\n' +
    '                              <select type="text"\n' +
    '                                      class="form-control input-field p-l-15 p-r-10 ng-pristine ng-valid ng-not-empty ng-touched"\n' +
    '                                      name="referenceModelSelect" id="referenceModelSelect"\n' +
    '                                      ng-model="templateListOverview.tempObj.referenceModelSelect"\n' +
    '                                      ng-options="option.name as option.value for option in templateListOverview.referenceList "\n' +
    '                                      ng-change="templateListOverview.referenceModelListSelect = \'\'; templateListOverview.tempObj.referenceNumberInput = \'\';">\n' +
    '                              </select>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <span ng-if="templateListOverview.tempObj.referenceModelSelect != \'NRC\'">\n' +
    '                          <div class="col-xs-6 col-sm-2 p-0 hidden-xs m-b-10"\n' +
    '                               ng-if="templateListOverview.tempObj.referenceModelSelect != \'RF\'">\n' +
    '\n' +
    '                            <select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect"\n' +
    '                                    id="referenceModelList"\n' +
    '\n' +
    '                                    ng-model="templateListOverview.referenceModelListSelect"\n' +
    '                                    ng-options="item as item for item in templateListOverview.referenceModelList"\n' +
    '                                    ng-change="templateListOverview.tempObj.referenceNumberInput = (templateListOverview.referenceModelListSelect == \'99\') ? \'\' : templateListOverview.tempObj.referenceNumberInput">\n' +
    '                            </select>\n' +
    '\n' +
    '                          </div>\n' +
    '\n' +
    '                          <div class="col-sm-6 col-xs-6 p-l-0 p-r-0"\n' +
    '                               ng-if="templateListOverview.referenceModelListSelect != \'99\'">\n' +
    '                            <div class="form-group m-b-0">\n' +
    '                              <input type="text" id="referenceNumberInput" name="referenceNumberInput"\n' +
    '                                     class="form-control input-field"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allLettersNumbersDashes}}"\n' +
    '                                     ng-model="templateListOverview.tempObj.referenceNumberInput" maxlength="{{(templateListOverview.tempObj.referenceModelSelect == \'RF\') ? 23 : 22 }}">\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="col-sm-6 col-xs-6 p-l-0 p-r-0"\n' +
    '                               ng-if="templateListOverview.referenceModelListSelect == \'99\'">\n' +
    '                            <div class="form-group m-b-0">\n' +
    '                              <input type="text" class="form-control input-field" name="referenceNumberInput"\n' +
    '                                     id="referenceNumberInput2" readonly>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          </span>\n' +
    '\n' +
    '                          <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"\n' +
    '                                ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="domesticPayment.referenceModelInputError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <!-- END REFERENCE INPUT FOR SLO ENVIRONMENT -->\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-12">\n' +
    '                            <span class="invoice-inline-title text-muted"\n' +
    '                                  translate="domesticPayment.purposeOfPaymentInputLabel">\n' +
    '                              Purpose\n' +
    '                            </span>\n' +
    '                        <div class="form-group">\n' +
    '                          <div class="p-0">\n' +
    '                            <input type="text" class="form-control input-field"\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.standardInput}}"\n' +
    '                                   name="purposeOfPaymentInput" id="purposeOfPaymentInput" maxlength="140" ng-maxlength="140"\n' +
    '                                   ng-model="templateListOverview.tempObj.purposeOfPaymentInput" required\n' +
    '                                   ng-class="{\'domp-error\': templateListOverview.templatesListForm.purposeOfPaymentInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                   ng-blur="templateListOverview.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', templateListOverview.tempObj.purposeOfPaymentInput)">\n' +
    '                            <span class="c-red"\n' +
    '                                  ng-show="domesticPaymentSlo.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted"\n' +
    '                                  translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- PUBLIC REVENUE EDIT -->\n' +
    '                    <!-- ng-if="template.paymentTypeGroup === \'RevenuePayment\'" -->\n' +
    '                    <div class="row" ng-if="template.paymentTypeGroup === \'RevenuePayment\'">\n' +
    '                      <div data-ng-include="\'payment-templates/public-revenue-section.tpl.html\'"></div>\n' +
    '                    </div>\n' +
    '                    <!-- END PUBLIC REVENUE SECTION -->\n' +
    '\n' +
    '\n' +
    '                    <!-- DOMESTIC PAYMENT END -->\n' +
    '                    <!-- START BIC -->\n' +
    '                    <div ng-if="template.paymentTypeGroup === \'ForeignPayment\'" id="spaha3">\n' +
    '                      <div class="row m-t-25">\n' +
    '                        <div class="col-xs-12 col-sm-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicNumber">\n' +
    '                                BIC Number\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                            <div ng-switch-when="sl" class="row p-r-15 p-l-15">\n' +
    '                              <input type="text" name="bicNumber" class="form-control input-field"\n' +
    '                                     ng-model="templateListOverview.tempObj.swiftCodeInput"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbersAndLetters}}"\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.bicNumber.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     maxlength="11"\n' +
    '                                     capitalize>\n' +
    '                              <span class="c-red" translate="payments.bicNumberRequired"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.bicNumber.$error.required && templateListOverview.tempObj.formSubmitted">\n' +
    '                                </span>\n' +
    '                            </div>\n' +
    '                            <div ng-switch-default class="row p-r-15 p-l-15">\n' +
    '                              <div class="col-xs-12 domp-filter-container"\n' +
    '                                   ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.bicCodeSearchFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '                                <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 inner-section input-div searchrow">\n' +
    '                                  <input type="text" class="search-input" name="bicCodeSearchFilter"\n' +
    '                                         ng-model="templateListOverview.bicCodeSearchFilter"\n' +
    '                                         ng-change="templateListOverview.searchBICNumber(templateListOverview.bicCodeSearchFilter)"\n' +
    '                                         ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbersAndLetters}}"\n' +
    '                                         autocomplete="off"\n' +
    '                                         required\n' +
    '                                         capitalize="">\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                                     ng-click="templateListOverview.bicCodeSearchFilterExpanded = !templateListOverview.bicCodeSearchFilterExpanded">\n' +
    '                                  <i class="icon icon-close domp-close-sign"\n' +
    '                                     ng-show="templateListOverview.bicCodeSearchFilter"\n' +
    '                                     ng-click="templateListOverview.removeBicCodeSearch()"></i>\n' +
    '                                  <i class="icon icon-arrdown m-r-0 pull-right"\n' +
    '                                     ng-show="!templateListOverview.bicCodeSearchFilter"></i>\n' +
    '                                </div>\n' +
    '                                <!--Dropdown menu -->\n' +
    '                                <div class="domp-filter-selection search-row"\n' +
    '                                     ng-class="{\'opened\': templateListOverview.bicCodeSearchFilterExpanded}">\n' +
    '                                  <div class="domp-filter-type-selection-wrapper"\n' +
    '                                       ng-repeat="bicBank in templateListOverview.bicBankOptions| filter:templateListOverview.bicCodeSearchFilter"\n' +
    '                                       ng-click="templateListOverview.onBicBankSelected(bicBank.bicCode)">\n' +
    '                                    <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                                      <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                                      <p class="domp-list-name m-0">{{bicBank.bicCode}}</p>\n' +
    '                                    </div>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                                <span class="c-red" translate="payments.bicNumberRequired"\n' +
    '                                      ng-show="templateListOverview.templatesListForm.bicCodeSearchFilter.$error.required && templateListOverview.tempObj.formSubmitted">\n' +
    '                              </span>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicCountry">\n' +
    '                                Country\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row p-r-15 p-l-15">\n' +
    '                            <div class="col-xs-12 domp-filter-container"\n' +
    '                                 ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.countrySearchFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                                <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                              </div>\n' +
    '                              <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 inner-section input-div searchrow">\n' +
    '                                <input type="text" class="search-input" name="countrySearchFilter"\n' +
    '                                       ng-model="templateListOverview.countrySearchFilter"\n' +
    '                                       ng-change="templateListOverview.countrySearchFilterExpanded = true;"\n' +
    '                                       ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbersAndLettersWithSuskavci}}"\n' +
    '                                       required\n' +
    '                                       autocomplete="off">\n' +
    '                              </div>\n' +
    '\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                                   ng-click="templateListOverview.countrySearchFilterExpanded = !templateListOverview.countrySearchFilterExpanded">\n' +
    '                                <i class="zmdi zmdi-close domp-close-sign"\n' +
    '                                   ng-show="templateListOverview.countrySearchFilter"\n' +
    '                                   ng-click="templateListOverview.removeSelectedCountry()"></i>\n' +
    '                                <i class="icon icon-arrdown  m-r-0 pull-right"\n' +
    '                                   ng-show="!templateListOverview.countrySearchFilter"></i>\n' +
    '                              </div>\n' +
    '                              <!--Dropdown menu -->\n' +
    '                              <div class="domp-filter-selection search-row"\n' +
    '                                   ng-class="{\'opened\': templateListOverview.countrySearchFilterExpanded}">\n' +
    '                                <div class="domp-filter-type-selection-wrapper"\n' +
    '                                     ng-repeat="country in templateListOverview.countriesOptions| filter: templateListOverview.countrySearchFilter"\n' +
    '                                     ng-click="templateListOverview.onCountrySelect(country)">\n' +
    '                                  <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                                    <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '                                  </div>\n' +
    '                                  <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                                    <p class="domp-list-name m-0">{{country.code}} {{country.description}}</p>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                            <div class="c-red"\n' +
    '                                 ng-show="templateListOverview.templatesListForm.countrySearchFilter.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                 translate="payments.bicCountryRequired"></div>\n' +
    '\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <div class="row m-t-25">\n' +
    '                        <div class="col-xs-12 col-md-4">\n' +
    '                          <!-- Required if Bic number is empty -->\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted"\n' +
    '                                    translate="payments.bicBankName">Bank Name</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <input type="text" class="form-control input-field"\n' +
    '                                     name="bankNameInput"\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.bankNameInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     replace-specific-chars\n' +
    '                                     ng-model="templateListOverview.tempObj.bankNameInput"\n' +
    '                                     autocomplete="off"\n' +
    '                                     required>\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.bankNameInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="payments.bicBankNameRequired"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-md-4" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicRecipientStatus">Receiver (person)</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <select class="form-control input-field"\n' +
    '                                      ng-model="templateListOverview.tempObj.recipientStatusRadiobutton.type">\n' +
    '                                <option value=2>{{"payments.bicRecipientStatusOptionPhysical"| translate}}</option>\n' +
    '                                <option value=1>{{"payments.bicRecipientStatusOptionLegal"| translate}}</option>\n' +
    '                              </select>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <div class="row m-t-25">\n' +
    '                        <div class="col-md-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted"\n' +
    '                                    translate="payments.bicAddress">BIC Address</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <input type="text" class="form-control input-field"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     replace-specific-chars\n' +
    '                                     autocomplete="off"\n' +
    '                                     ng-model="templateListOverview.tempObj.bankAddressInput">\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                        <div class="col-md-4">\n' +
    '\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicCity">BIC City</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <input type="text" class="form-control input-field" name="bicCity"\n' +
    '                                     ng-model="templateListOverview.tempObj.bankCityInput"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     replace-specific-chars\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.bicCity.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     required>\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.bicCity.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="payments.bicCityRequired"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                        <div class="col-md-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicBankCharges">Troškovna opcija:</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="col-xs-12">\n' +
    '                              <select ng-switch-default\n' +
    '                                      class="form-control input-field"\n' +
    '                                      ng-model="templateListOverview.tempObj.bankChargesRadiobutton.type">\n' +
    '                                <option value=3>SHA</option>\n' +
    '                                <option value=1>OUR</option>\n' +
    '                                <option value=2>BEN</option>\n' +
    '                              </select>\n' +
    '                              <select ng-switch-when="sl"\n' +
    '                                      class="form-control input-field"\n' +
    '                                      ng-model="templateListOverview.tempObj.bankChargesRadiobutton.type">\n' +
    '                                <option value=0>SHA</option>\n' +
    '                                <option value=1>OUR</option>\n' +
    '                              </select>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <!-- END BIC -->\n' +
    '\n' +
    '\n' +
    '                    <!-- Save/Cancel action start -->\n' +
    '\n' +
    '                    <div class="row  p-t-20">\n' +
    '                      <button class="btn btn-primary editTemplate" translate="templatesList.cancel"\n' +
    '                              ng-click="templateListOverview.cancel(template)">Cancel\n' +
    '                      </button>\n' +
    '                      <button class="btn btn-default editTemplate pull-right" translate="templatesList.save"\n' +
    '                              ng-click="templateListOverview.saveTemplate(template)"\n' +
    '                              ng-disabled="templateListOverview.saveButtonPressed">Edit\n' +
    '                      </button>\n' +
    '                    </div>\n' +
    '                    <!-- Save/Cancel actions end -->\n' +
    '                  </form>\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- EDITABLE END-->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="m-10 text-center" ng-if="templateListOverview.templateList.hasMore">\n' +
    '        <hr>\n' +
    '        <button class="btn btn-default" ng-click="templateListOverview.loadMoreTemplates()"\n' +
    '                translate="messages.loadMore">Load more\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-templates/template-list-overview-other.tpl.html',
    '<section ng-controller="TemplateListOverviewOtherCtrl as templateListOverview" id="main">\n' +
    '  <div class="container-fluid p-b-20">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-12">\n' +
    '        <h2 class="f-28" translate="templatesList.header"></h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-12 col-md-12 col-sm-12">\n' +
    '\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 tmplt-list-section">\n' +
    '\n' +
    '          <!-- Search -->\n' +
    '          <div class="col-lg-12 col-md-12 col-sm-12 ">\n' +
    '            <div id="searchBtnLeftDiv" class="inner-section left">\n' +
    '              <i class="icon icon-search  icon-hc-2x m-l-5 tml-search-container"></i>\n' +
    '            </div>\n' +
    '            <div class="form-group search-field searchrow">\n' +
    '              <input ng-if="templateListOverview.countryCode != \'sl\'" type="text" class="form-control input-field" name="searchTemplateList" id="searchTemplateList"\n' +
    '                     ng-model="templateListOverview.searchTemplateList"\n' +
    '                     placeholder="{{\'templatesList.searchTemplates\'| translate}}"/>\n' +
    '\n' +
    '              <input ng-if="templateListOverview.countryCode == \'sl\'" type="text" class="form-control input-field" name="searchTemplateList" id="searchTemplateList"\n' +
    '                     ng-model="templateListOverview.searchTemplateListApi"\n' +
    '                     ng-change="templateListOverview.searchTemplate(templateListOverview.searchTemplateListApi)"\n' +
    '                     placeholder="{{\'templatesList.searchTemplates\'| translate}}"/>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div class="tmplt-list-label col-lg-12 col-md-12 col-sm-12" translate="templateSearch.templatesList">List of\n' +
    '            templates\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <!-- Template list -->\n' +
    '          <div class="col-sm-12 col-md-12 tab-field"\n' +
    '               data-ng-repeat="template in templateListOverview.templateList.result| filter:templateListOverview.searchTemplateList"\n' +
    '               ng-show="templateListOverview.templateList.result.length != 0">\n' +
    '\n' +
    '            <!-- TEMPLATE DETAILS -->\n' +
    '            <div class="container invoice-card">\n' +
    '              <div class="row">\n' +
    '                <div class="invoice-card-top gray-card col-lg-12 col-md-12 col-sm-12 col-xs-12 m-p-0">\n' +
    '\n' +
    '                  <!-- Icon -->\n' +
    '                  <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 m-p-0 hidden-xs">\n' +
    '                    <div ng-if="!template.imageId" class="invoice-icon">ico</div>\n' +
    '                    <!--<img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico"-->\n' +
    '                    <!--class="tpl-rounded-img"/>-->\n' +
    '                    <div ng-if="template.imageId"\n' +
    '                         ng-style="{\'background-image\': \'url(\' + template.imageDownloadLink + \')\'}"\n' +
    '                         class="t-icon-ctn"></div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 p-0 visible-xs">\n' +
    '                    <div ng-if="!template.imageId" class="invoice-icon">ico</div>\n' +
    '                    <!--<img ng-if="template.imageId" ng-src="{{template.imageDownloadLink}}" alt="Ico"-->\n' +
    '                    <!--class="tpl-rounded-img"/>-->\n' +
    '                    <div ng-if="template.imageId"\n' +
    '                         ng-style="{\'background-image\': \'url(\' + template.imageDownloadLink + \')\'}"\n' +
    '                         class="t-icon-ctn-xs"></div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-9 col-md-9 col-sm-8 col-xs-6 cust-pl-30 hidden-xs">\n' +
    '                    <div class="invoice-type wrap-text">\n' +
    '                      <b>{{::template.name}}</b>\n' +
    '                      <br/>\n' +
    '                      <span class="text-muted" ng-bind="::template.toAccountNumber"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-9 col-md-9 col-sm-8 col-xs-6 p-r-0 visible-xs">\n' +
    '                    <div class="invoice-type wrap-text f-13">\n' +
    '                      <b>{{::template.name}}</b>\n' +
    '                      <br/>\n' +
    '                      <span class="text-muted f-12" ng-bind="::template.toAccountNumber"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 m-p-0">\n' +
    '                    <span class="col-sm-6">\n' +
    '                      <i class="icon icon-arrdown i-c31 cursor-pointer"\n' +
    '                         ng-click="templateListOverview.toggleDetails(template)"></i>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <!-- Delete template -->\n' +
    '                  <div class="invoice-card-top-right gray-card col-lg-1 col-md-1 col-sm-1 col-xs-2 pull-right">\n' +
    '                    <span class="pull-right tmplt-delete-sign">\n' +
    '                      <i class="icon icon-close i-dblue i-lh21 cursor-pointer"\n' +
    '                         data-ng-click="templateListOverview.deleteTemplate(template)"></i>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row tmplt-card-detail" ng-class="{collapse: !template.openedDetails}">\n' +
    '                <div class="tmplt-content tmplt-from-section container m-t-0">\n' +
    '\n' +
    '                  <!--         <div class="tmplt-content tmplt-from-section container m-t-0">\n' +
    '  <div class="row">\n' +
    '  <div class="col-sm-6">\n' +
    '  <span class="invoice-inline-title text-muted"\n' +
    '  translate="templatesList.fromAccount"><b>From account</b></span>\n' +
    '  <label class="tmplt-detail-label-description black-text">\n' +
    '  {{::templateListOverview.account.accountDescription}}</label>\n' +
    '  <label class="domp-form-label-accnumber">{{domesticPayment.insertedPaymentObject.fromAccountNumber}}</label>\n' +
    '  <label class="tmplt-detail-label-balance black-text">{{::templateListOverview.account.availableBalance\n' +
    '  | number:2}} {{::templateListOverview.account.currencySymbol}}</label>\n' +
    '  </div>\n' +
    '  </div>-->\n' +
    '                  <!--      <div class="col-sm-6" ng-if="template.amount!=\'\'">\n' +
    '  <span class="invoice-inline-title text-muted"\n' +
    '  translate="templatesList.amount"><b>Amount</b></span>\n' +
    '  <label class="black-text">\n' +
    '  {{::template.amount | number:2}} {{::templateListOverview.account.currencySymbol}}\n' +
    '  </label>\n' +
    '  <br/>\n' +
    '  </div>-->\n' +
    '\n' +
    '                  <div ng-if="!template.editable && (templateListOverview.countryCode === \'hr\' || templateListOverview.countryCode === \'sl\')">\n' +
    '                    <div class="row container-template" ng-if="template.debtorName || template.debtorName2">\n' +
    '                      <div class="col-sm-6">\n' +
    '                        <label class="invoice-inline-title text-muted"\n' +
    '                               translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '                        <label class="tmplt-detail-label-description black-text p-0">{{template.debtorName}}</label>\n' +
    '                        <label class="tmplt-detail-label-description black-text">{{template.debtorName2}}</label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- NON EDITABLE START -->\n' +
    '                <div ng-if="!template.editable">\n' +
    '                  <div ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\'">\n' +
    '                    <div class="tmplt-content tmplt-payee-section">\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-sm-6" ng-if="template.toAccountNumber != \'\'">\n' +
    '                          <span class="invoice-inline-title text-muted" translate="templatesList.accountNumber"><b>Account number</b></span>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.toAccountNumber == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.toAccountNumber != undefined && template.toAccountNumber != \'\'">{{template.toAccountNumber}}\n' +
    '                            </label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.toAccountNumber == undefined || template.toAccountNumber == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.toAccountNumber != undefined">\n' +
    '                            <label class="black-text">{{template.toAccountNumber}}</label>\n' +
    '                            <!--<label class="black-text">{{templateListOverview.updateResponse.toAccountNumber}}</label>-->\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-sm-6">\n' +
    '                          <span class="invoice-inline-title text-muted"\n' +
    '                                translate="templatesList.toPayee"><b>To payee</b></span>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverName == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverName != undefined && template.receiverName != \'\'">{{template.receiverName}}</label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverName == undefined || template.receiverName == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverName != undefined">\n' +
    '                            <label class="black-text">{{template.receiverName}}</label>\n' +
    '                            <!--<label class="black-text">{{templateListOverview.updateResponse.receiverName}}</label>-->\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-sm-6" ng-show="templateListOverview.countryCode === \'sl\'">\n' +
    '                          <!--<span class="invoice-inline-title text-muted" translate="templatesList.bicBankPrejemnika"><b>BICBANK</b></span>-->\n' +
    '                          <!--<div ng-if="templateListOverview.updateResponse.receiverCity == undefined">-->\n' +
    '                          <!--<label class="black-text"-->\n' +
    '                          <!--ng-if="template.beneficiarySWIFTCode">{{template.beneficiarySWIFTCode}}</label>-->\n' +
    '                          <!--<label class="black-text"-->\n' +
    '                          <!--ng-if="!template.beneficiarySWIFTCode">-</label>-->\n' +
    '                          <!--</div>-->\n' +
    '                        </div>\n' +
    '                        <div class="col-sm-6" ng-show="templateListOverview.countryCode != \'sl\'">\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="col-sm-6">\n' +
    '                          <span class="invoice-inline-title text-muted" translate="templatesList.payeeStreet"><b>Payee street</b></span>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverAddress1 == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverAddress1 != undefined && template.receiverAddress1 != \'\'">{{template.receiverAddress1}}</label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverAddress1 == undefined || template.receiverAddress1 == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverAddress1 != undefined">\n' +
    '                            <label class="black-text">{{template.receiverAddress1}}</label>\n' +
    '                            <!--<label class="black-text">{{templateListOverview.updateResponse.receiverAddress1}}</label>-->\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-sm-6"></div>\n' +
    '                        <div class="col-sm-6" ng-if="templateListOverview.countryCode !== \'bh\'">\n' +
    '                          <span class="invoice-inline-title text-muted"\n' +
    '                                translate="templatesList.payeeCity"><b>Payee city</b></span>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverCity == undefined">\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverCity != undefined && template.receiverCity != \'\'">{{template.receiverCity}}</label>\n' +
    '                            <label class="black-text"\n' +
    '                                   ng-if="template.receiverCity == undefined || template.receiverCity == \'\'">-</label>\n' +
    '                          </div>\n' +
    '                          <div ng-if="templateListOverview.updateResponse.receiverCity != undefined">\n' +
    '                            <label class="black-text">{{template.receiverCity}}</label>\n' +
    '                            <!--<label class="black-text">{{templateListOverview.updateResponse.receiverCity}}</label>-->\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="templateListOverview.countryCode === \'hr\' || templateListOverview.countryCode === \'sl\'">\n' +
    '                        <div class="col-sm-6"></div>\n' +
    '                        <div class="col-sm-6">\n' +
    '                          <div ng-if="template.creditorName || template.creditorName2">\n' +
    '                            <label class="invoice-inline-title text-muted"\n' +
    '                                   translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '                            <label class="tmplt-detail-label-description black-text p-0">{{template.creditorName}}</label>\n' +
    '                            <label class="tmplt-detail-label-description black-text">{{template.creditorName2}}</label>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div ng-if="template.paymentTypeGroup === \'ForeignPayment\'" class="receiver-section p-20"\n' +
    '                       style="padding: 10px">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="eInvoiceDetail.recipientAccount">\n' +
    '                            Account number\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text hidden-xs">\n' +
    '                            {{template.toAccountNumber}}\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text visible-xs f-16">\n' +
    '                            {{template.toAccountNumber}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="domesticPayment.toPayee">\n' +
    '                            To payee\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.receiverName}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-6"></div>\n' +
    '                      <div class="col-md-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="accessInvestment.address">\n' +
    '                            Address\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.receiverAddress1}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-6 col-md-offset-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label"\n' +
    '                                 translate="domesticPayment.receiversPostalCodeAndCityInputLabel">\n' +
    '                            Address\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.receiverCity}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- Foreign purpose start -->\n' +
    '\n' +
    '                  <div ng-if="template.paymentTypeGroup === \'ForeignPayment\'" class="receiver-section p-20">\n' +
    '                    <div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                      <div class="col-md-6">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="templatesList.purposeCode">\n' +
    '                            Purpose code\n' +
    '                          </label>\n' +
    '                          <label  class="domp-template-text">\n' +
    '                            {{template.purposeCodeDPS}}\n' +
    '                          </label>\n' +
    '                          <label ng-if="template.purpose && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="domp-template-text">\n' +
    '                            {{template.purpose}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <div class="col-md-6" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.paymentMode">\n' +
    '                            Payment mode\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.modalityFullName}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-12">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="internationalPayment.paymentPurpose">\n' +
    '                            Payment purpose\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.purpose}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- Foreign purpose end -->\n' +
    '\n' +
    '                  <!-- Foreign BIC start -->\n' +
    '\n' +
    '                  <div ng-if="template.paymentTypeGroup === \'ForeignPayment\'" class="receiver-section p-20">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicNumber">\n' +
    '                            BIC number\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiarySWIFTCode}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicCountry">\n' +
    '                            Country\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiaryBankCountryCode}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <!-- CHECK !!! -->\n' +
    '                      <!--                      <div class="col-md-4">\n' +
    '  <label class="domp-form-label-review" translate="templateListOverview.chargeAccount">Charge account</label>\n' +
    '  <label class="domp-template-text">\n' +
    '  {{template.chargeAccount}}\n' +
    '  </label>\n' +
    '  </div>-->\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-8 temp-bank-name">\n' +
    '                        <div class="form-group temp-bank-name">\n' +
    '                          <label class="domp-template-label" translate="payments.bicBankName">Bank Name</label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiaryBankName}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-4"  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                        <div class="form-group template-receiver">\n' +
    '                          <label class="domp-template-label" translate="payments.bicRecipientStatus">Receiver\n' +
    '                            (person)</label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            <div ng-switch="template.payeeLegalForm">\n' +
    '                              <div ng-switch-when="1">\n' +
    '                                {{"payments.bicRecipientStatusOptionLegal"| translate}}\n' +
    '                              </div>\n' +
    '                              <div ng-switch-when="2">\n' +
    '                                {{"payments.bicRecipientStatusOptionPhysical"| translate}}\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicAddress">BIC Address</label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiaryBankAddress}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicCity">BIC City</label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.beneficiaryBankCity}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-md-4">\n' +
    '                        <div class="form-group">\n' +
    '                          <label class="domp-template-label" translate="payments.bicBankCharges">\n' +
    '                            Troškovna opcija:</label>\n' +
    '                          <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                            <!-- Map for other-->\n' +
    '                            <label ng-switch-default class="domp-template-text">\n' +
    '                              <div ng-switch="template.paymentCharges">\n' +
    '                                <div ng-switch-when="3">\n' +
    '                                  SHA\n' +
    '                                </div>\n' +
    '                                <div ng-switch-when="1">\n' +
    '                                  OUR\n' +
    '                                </div>\n' +
    '                                <div ng-switch-when="2">\n' +
    '                                  BEN\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </label>\n' +
    '                            <!-- Map for Slovenia-->\n' +
    '                            <label ng-switch-when="sl" class="domp-template-text">\n' +
    '                              <div ng-switch="template.paymentCharges">\n' +
    '                                <div ng-switch-when="0">\n' +
    '                                  SHA\n' +
    '                                </div>\n' +
    '                                <div ng-switch-when="1">\n' +
    '                                  OUR\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </label>\n' +
    '                          </span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- Foreign BIC end -->\n' +
    '\n' +
    '                  <div class="tmplt-content tmplt-purpose-section">\n' +
    '                    <div class="row" ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\'">\n' +
    '                      <div class="col-sm-6">\n' +
    '                        <span class="invoice-inline-title text-muted" translate="templatesList.purposeCode"><b>Purpose code</b></span>\n' +
    '\n' +
    '                        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                          <label class="black-text">\n' +
    '                          <span ng-if="template.purposeCodeDPS != undefined && template.purposeCodeDPS != \'\'">\n' +
    '                            {{::template.purposeCodeDPS}} -\n' +
    '                          </span>\n' +
    '                            {{::template.purpose}}\n' +
    '                          </label>\n' +
    '                        </div>\n' +
    '                        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                          <label  class="domp-template-text">\n' +
    '                            {{template.purposeCode}}\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-label" translate="internationalPayment.paymentPurpose">\n' +
    '                            Payment purpose\n' +
    '                          </label>\n' +
    '                          <label class="domp-template-text">\n' +
    '                            {{template.purpose}}\n' +
    '                          </label>\n' +
    '\n' +
    '\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="(template.purposeCodeDPS == undefined || template.purposeCodeDPS == \'\') && (template.purpose == undefined || template.purpose == \'\')">-</label>\n' +
    '                      </div>\n' +
    '                      <div class="col-sm-3" ng-class="{\'col-sm-6\': templateListOverview.countryCode == \'slo\'}" ng-if="templateListOverview.countryCode !== \'bh\'">\n' +
    '                        <span class="invoice-inline-title text-muted" translate="templatesList.referenceNumber"><b>Reference number</b></span>\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="template.referenceTo && templateListOverview.countryCode === \'hr\'">HR{{template.referenceTo}}</label>\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="template.referenceTo && templateListOverview.countryCode !== \'hr\' && templateListOverview.countryCode !== \'sl\'">{{template.referenceTo}}</label>\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="template.referenceTo && templateListOverview.countryCode == \'sl\'">{{templateListOverview.formatReferenceNumber(template.referenceTo)}}</label>\n' +
    '                        <label class="black-text"\n' +
    '                               ng-if="!template.referenceTo">-</label>\n' +
    '                      </div>\n' +
    '                      <div class="col-sm-3" ng-if="templateListOverview.countryCode === \'bh\' && template.reference">\n' +
    '                        <span class="invoice-inline-title text-muted" translate="templatesList.referenceNumber"><b>Reference number</b></span>\n' +
    '                        <label class="black-text">{{template.reference}}</label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- REVENUE PAYMENT INFO -->\n' +
    '                  <div class="tmplt-content tmplt-purpose-section" ng-if="template.paymentTypeGroup === \'RevenuePayment\'">\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.accountNumber"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.toAccountNumber}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.purposeCode"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.purpose + \'-\' + template.purposeCodeDPS}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.toPayee"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.receiverName}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.payeeStreet"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.receiverAddress1}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.taxPayerNumber"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.taxPayerId}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.paymentType"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.revenuePaymentType}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.revenueCode"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.revenueCode}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.municipality"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.municipality}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.taxPeriodFrom"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.taxPeriodFrom | date: \'shortDate\'}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.taxPeriodTo"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.taxPeriodTo | date: \'shortDate\'}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="domesticPayment.budgetOrganisation"></label>\n' +
    '                          <label class="domp-form-label-resume">{{template.budgetOrganization}}</label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone">\n' +
    '                        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '                          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                                 translate="templatesList.referenceNumber"></label>\n' +
    '                          <label ng-if="template.reference" class="domp-form-label-resume">{{template.reference}}</label>\n' +
    '                          <label ng-if="!template.reference" class="domp-form-label-resume"> - </label>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <!-- END REVENUE PAYMENT INFO -->\n' +
    '\n' +
    '                  <div class="row">\n' +
    '\n' +
    '\n' +
    '                    <div class=" text-right p-r-10 ">\n' +
    '                      <!--        <div class="col-md-8 add-template-fav ">\n' +
    '                                <span class="col-lg-1 col-md-1 col-sm-1 "><i class="zmdi zmdi-star-outline zmdi-hc-2x template-fav"></i></span>\n' +
    '                                <span class="col-lg-10 col-md-10 col-sm-10 p-l-0 m-t-5"\n' +
    '                                      translate="templatesList.addTemplateToFavorites" style="font-weight: bold;"><p>Add this template to favorites</p></span>\n' +
    '                              </div> -->\n' +
    '\n' +
    '                      <button class="btn btn-default editTemplate pull-right" translate="templatesList.edit"\n' +
    '                              ng-click="templateListOverview.editTemplate(template)">Edit\n' +
    '                      </button>\n' +
    '                      <button ng-if="templateListOverview.countryCode == \'sl\'" class="btn btn-default editTemplate pull-right" translate="templatesList.pay"\n' +
    '                              ng-click="templateListOverview.goToPayment(template)">Pay\n' +
    '                      </button>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '                <!-- NON EDITABLE END-->\n' +
    '\n' +
    '                <!--==========================-->\n' +
    '                <!-- EDITABLE START -->\n' +
    '                <!--==========================-->\n' +
    '                <div ng-if="template.editable">\n' +
    '                  <form name="templateListOverview.templatesListForm" novalidate>\n' +
    '                    <div class="row m-t-20" id="spaha0">\n' +
    '                      <div class="col-xs-12 col-md-6 col-lg-6">\n' +
    '                        <div class="hidden-xs t-a-c">\n' +
    '                          <div class="col-lg-12 text-left">\n' +
    '                            <span class="template-headers" translate="paymentTemplates.templateIcon">\n' +
    '                              Template icon\n' +
    '                            </span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="visible-xs ">\n' +
    '                          <div class="col-xs-12 col-md-6 col-lg-6 text-left">\n' +
    '                            <span class="template-headers" translate="paymentTemplates.templateIcon">\n' +
    '                              Template icon\n' +
    '                            </span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div>\n' +
    '                          <div class="dropdown hidden-xs t-a-c">\n' +
    '                            <div class="btn pull-left btn-default dropdown-toggle img-selector-btn edit-tmpl-img-selector"\n' +
    '                                 type="button"\n' +
    '                                 data-toggle="dropdown">\n' +
    '                              <div>\n' +
    '                                <img class="img-circle edit-tmpl-selected-img"\n' +
    '                                     ng-src="{{templateListOverview.selectedImage.downloadLink}}" alt="Ico"/>\n' +
    '                              </div>\n' +
    '                              <span class="caret-icon edit-tmpl-caret">\n' +
    '                                <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                            <div class="dropdown-menu edit-tmpl-img-container" role="menu" aria-labelledby="menu1">\n' +
    '                              <div ng-repeat="image in templateListOverview.images"\n' +
    '                                   data-ng-click="templateListOverview.selectImage(image)">\n' +
    '                                <div class="col-xs-12 img-option">\n' +
    '                                  <img class="img-circle edit-tmpl-img" ng-src="{{image.downloadLink}}" alt="Ico">\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="dropdown visible-xs">\n' +
    '                            <div class="btn pull-left btn-default dropdown-toggle img-selector-btn edit-tmpl-img-selector"\n' +
    '                                 type="button"\n' +
    '                                 data-toggle="dropdown">\n' +
    '                              <div>\n' +
    '                                <img class="img-circle edit-tmpl-selected-img"\n' +
    '                                     ng-src="{{templateListOverview.selectedImage.downloadLink}}" alt="Ico"/>\n' +
    '                              </div>\n' +
    '                              <span class="caret-icon edit-tmpl-caret">\n' +
    '                                <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                            <div class="dropdown-menu edit-tmpl-img-container" role="menu" aria-labelledby="menu1">\n' +
    '                              <div ng-repeat="image in templateListOverview.images"\n' +
    '                                   data-ng-click="templateListOverview.selectImage(image)">\n' +
    '                                <div class="col-xs-12 img-option">\n' +
    '                                  <img class="img-circle edit-tmpl-img" ng-src="{{image.downloadLink}}" alt="Ico">\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-12 col-md-6 col-lg-6">\n' +
    '                        <span class="invoice-inline-title text-muted" translate="paymentTemplates.templateName">\n' +
    '                          Template name\n' +
    '                        </span>\n' +
    '                        <div>\n' +
    '                          <input type="text" class="form-control input-field"\n' +
    '                                 id="templateNameInput" name="templateNameInput"\n' +
    '                                 data-ng-model="templateListOverview.tempObj.templateName"\n' +
    '                                 placeholder="{{\'internalTransfer.templateName\'| translate}}"\n' +
    '                                 required\n' +
    '                                 ng-class="{\'domp-error\': templateListOverview.templatesListForm.templateNameInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                 maxlength="35">\n' +
    '                          <span class="c-red"\n' +
    '                                ng-show="templateListOverview.templatesListForm.purposeOfPaymentInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="row m-t-20" ng-if="template.editable && (templateListOverview.countryCode === \'hr\' || templateListOverview.countryCode === \'sl\')" >\n' +
    '                      <div class="col-sm-6">\n' +
    '                        <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                          <uib-accordion-group>\n' +
    '                            <uib-accordion-heading>\n' +
    '                              <div class="sepa-heading input-field">\n' +
    '                                <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                                  <label class="domp-form-label-sepa" translate="domesticPayment.sepaDebitorLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                                  class="icon icon-arrdown"></i></div>\n' +
    '                              </div>\n' +
    '                            </uib-accordion-heading>\n' +
    '                            <input type="text" class="form-control input-field"\n' +
    '                                   ng-model="templateListOverview.tempObj.payersSepaInput1"\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                   maxlength="35">\n' +
    '                            <input type="text" class="form-control input-field"\n' +
    '                                   ng-model="templateListOverview.tempObj.payersSepaInput2"\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                   maxlength="35">\n' +
    '                          </uib-accordion-group>\n' +
    '                        </uib-accordion>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row m-t-25 p-r-15" id="spaha1">\n' +
    '\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-xs-12 col-sm-6 p-b-10" ng-if="templateListOverview.countryCode === \'hr\' || templateListOverview.countryCode === \'sl\'">\n' +
    '\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12 col-sm-12">\n' +
    '\n' +
    '                              <div ng-if="templateListOverview.countryCode === \'hr\'">\n' +
    '                                <div class="row">\n' +
    '                                  <div class="col-xs-12 ">\n' +
    '                                    <span class="invoice-inline-title text-muted" translate="templatesList.accountNumber"><b>Account number</b></span>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                                <div class="col-xs-12 ">\n' +
    '                                  <input ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\'" type="text"\n' +
    '                                         class="form-control input-field" capitalize\n' +
    '                                         ui-mask="{{templateListOverview.uiMask}}"\n' +
    '                                         ui-mask-placeholder ui-mask-placeholder-char="_"\n' +
    '                                         ui-options="templateListOverview.croIbanMaskOptions"\n' +
    '                                         ng-model="templateListOverview.tempObj.toAccountInput"\n' +
    '                                         ng-class="{\'domp-error\': templateListOverview.templatesListForm.toAccountInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                         name="toAccountInput" id="toAccountInput" required\n' +
    '                                         ng-blur="templateListOverview.checkInputChanges(template.paymentTypeGroup)">\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                              <div ng-if="templateListOverview.countryCode === \'sl\'">\n' +
    '\n' +
    '                                <div class="col-md-12 col-sm-6 m-b-15">\n' +
    '                                  <div class="row">\n' +
    '                                    <div class="col-xs-12">\n' +
    '                                      <span class="invoice-inline-title text-muted" translate="templatesList.accountNumber"><b>Account number</b></span>\n' +
    '                                    </div>\n' +
    '                                  </div>\n' +
    '                                  <!--<input ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\'" type="text"-->\n' +
    '                                  <!--class="form-control input-field" capitalize-->\n' +
    '                                  <!--ui-mask="{{templateListOverview.uiMask}}"-->\n' +
    '                                  <!--ui-mask-placeholder ui-mask-placeholder-char="_"-->\n' +
    '                                  <!--ui-options="templateListOverview.croIbanMaskOptions"-->\n' +
    '                                  <!--ng-model="templateListOverview.tempObj.toAccountInput"-->\n' +
    '                                  <!--ng-class="{\'domp-error\': templateListOverview.templatesListForm.toAccountInput.$invalid && templateListOverview.tempObj.formSubmitted}"-->\n' +
    '                                  <!--name="toAccountInput" id="toAccountInput" required-->\n' +
    '                                  <!--ng-blur="templateListOverview.getBicByIban2(templateListOverview.tempObj.toAccountInput)">-->\n' +
    '                                  <div ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\'">\n' +
    '                                    <label class="black-text">\n' +
    '                                      {{templateListOverview.tempObj.toAccountInput}}\n' +
    '                                    </label>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                                <!--<div ng-if="template.paymentTypeGroup === \'DomesticPayment\' || template.paymentTypeGroup === \'SEPAPayment\'" class="col-xs-12 col-sm-6 m-b-15">-->\n' +
    '                                <!--<div class="row">-->\n' +
    '                                <!--<div class="col-xs-12">-->\n' +
    '                                <!--<span class="invoice-inline-title text-muted" translate="templatesList.bicBankPrejemnika"><b>BICBank</b></span>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--<input type="text"-->\n' +
    '                                <!--class="form-control input-field" capitalize-->\n' +
    '\n' +
    '                                <!--ng-model="templateListOverview.tempObj.beneficiarySWIFTCode"-->\n' +
    '                                <!--ng-class="{\'domp-error\': templateListOverview.templatesListForm.beneficiarySWIFTCode.$invalid && templateListOverview.tempObj.formSubmitted}"-->\n' +
    '                                <!--name="beneficiarySWIFTCode" id="beneficiarySWIFTCode"-->\n' +
    '                                <!--&gt;-->\n' +
    '                                <!--</div>-->\n' +
    '\n' +
    '                              </div>\n' +
    '\n' +
    '\n' +
    '                              <input ng-if="template.paymentTypeGroup === \'ForeignPayment\' && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" type="text"\n' +
    '                                     class="form-control input-field"\n' +
    '                                     capitalize\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allLettersNumbersSpaces}}"\n' +
    '                                     ui-options="templateListOverview.uiMaskOptions"\n' +
    '                                     ng-model="templateListOverview.tempObj.toAccountInput"\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.paymentForm.toAccountInputForp.$invalid && templateListOverview.tempForpObj.formSubmitted}"\n' +
    '                                     name="toAccountInputForp" id="toAccountInputForp"\n' +
    '                                     required\n' +
    '                                     maxlength="39"\n' +
    '                                     ng-trim="false"\n' +
    '                                     ng-change="templateListOverview.addSpaceForIban(templateListOverview.tempForpObj.toAccountInputForp)"\n' +
    '                                     ng-blur="templateListOverview.fillReceiver(templateListOverview.tempForpObj.toAccountInputForp);\n' +
    '                                           templateListOverview.getBicByIban(templateListOverview.tempForpObj.toAccountInputForp)">\n' +
    '                              <div class="col-xs-12" ng-if="template.paymentTypeGroup === \'ForeignPayment\' && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                                <label  class="black-text">\n' +
    '                                  {{templateListOverview.tempObj.toAccountInput}}\n' +
    '                                </label>\n' +
    '                              </div>\n' +
    '\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.toAccountInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="domesticPayment.receiverAccountError"></span>\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.toAccountInputForp.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="domesticPayment.receiverAccountError"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '\n' +
    '                        <div class="col-xs-12 col-sm-6 p-b-10" ng-if="templateListOverview.countryCode !== \'hr\' && templateListOverview.countryCode !== \'sl\'">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12 col-sm-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="templatesList.accountNumber"><b>Account number</b></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                          <div class="row" ng-if="templateListOverview.countryCode !== \'bh\'">\n' +
    '                            <div class="col-xs-12 col-sm-12">\n' +
    '                              <input id="toAccountInputSrb" name="toAccountInputSrb"\n' +
    '                                     type="text" class="form-control input-field"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allLettersNumbersDashes}}"\n' +
    '                                     capitalize\n' +
    '                                     dn-custom-maxlength="18" dn-exclude="-"\n' +
    '                                     ng-blur="templateListOverview.formatAccountNumber(templateListOverview.tempObj.toAccountInput)"\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.toAccountInputSrb.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     ng-model="templateListOverview.tempObj.toAccountInput" required\n' +
    '                                     ng-disabled="templateListOverview.isRetrieval">\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.toAccountInputSrb.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="domesticPayment.receiverAccountError"></span>\n' +
    '                              <span class="c-red" ng-show="templateListOverview.templatesListForm.$error.minlength"\n' +
    '                                    translate="payments.minimalAccountNumber"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                          <!-- TO ACCOUNT INPUT FOR BIH ENVIRONMENT -->\n' +
    '                          <div class="row" ng-if="templateListOverview.countryCode === \'bh\'">\n' +
    '                            <div class="col-xs-12 col-sm-12">\n' +
    '                              <input type="text" class="form-control input-field" name="toAccountInput"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbers}}"\n' +
    '                                     ng-maxlength="16" maxlength="16"\n' +
    '                                     ng-minlength="16"\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.toAccountInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     ng-model="templateListOverview.tempObj.toAccountInput"\n' +
    '                                     ng-blur="templateListOverview.checkIsRevenueAccount()"\n' +
    '                                     required>\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.toAccountInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="domesticPayment.receiverAccountError"></span>\n' +
    '                              <span class="c-red" ng-show="templateListOverview.templatesListForm.$error.minlength"\n' +
    '                                    translate="payments.minimalAccountNumber"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <!-- END TO ACCOUNT INPUT FOR BIH ENVIRONMENT -->\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                        <!-- /////////// SELECT PAYEE ///////////// -->\n' +
    '                        <div class=" col-xs-12 col-sm-6 p-l-30">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12 col-sm-12">\n' +
    '                              <span class="invoice-inline-title text-muted"\n' +
    '                                    translate="templatesList.toPayee"><b>To payee</b></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                          <div class="row p-l-15 p-r-15">\n' +
    '                            <div class="col-sm-12 col-xs-12 domp-filter-container"\n' +
    '                                 ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.payeeSearchFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                                <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                              </div>\n' +
    '                              <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '                                <input type="text" name="payeeSearchFilter" id="payeeSearchFilter" class="search-input"\n' +
    '                                       ng-model="templateListOverview.payeeSearchFilter"\n' +
    '                                       ng-change="templateListOverview.searchPayee()"\n' +
    '                                       ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                       required\n' +
    '                                       maxlength="70" ng-maxlength="70" autocomplete="off">\n' +
    '                              </div>\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                                   ng-click="templateListOverview.toggleFilterSelection()">\n' +
    '                                <i class="icon icon-close domp-close-sign i-lh17"\n' +
    '                                   ng-show="templateListOverview.payeeSearchFilter != \'\'"\n' +
    '                                   ng-click="templateListOverview.removeSearch()"></i>\n' +
    '                                <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                                   ng-show="templateListOverview.payeeSearchFilter == \'\'"></i>\n' +
    '                              </div>\n' +
    '                              <div class="domp-filter-selection search-row"\n' +
    '                                   ng-class="{\'opened\': templateListOverview.searchFilterExpanded}">\n' +
    '                                <div class="domp-filter-type-selection-wrapper"\n' +
    '                                     ng-repeat="payee in templateListOverview.payeeList| filter:templateListOverview.searchPayeeBy"\n' +
    '                                     ng-click="templateListOverview.selectPayee(payee.id)">\n' +
    '                                  <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                                    <i class="zmdi zmdi-account-circle" style="color:#9eabd5"></i>\n' +
    '                                  </div>\n' +
    '                                  <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                                    <p class="domp-list-name m-0">{{payee.receiverName}}</p>\n' +
    '                                    <p class="domp-list-number m-0">{{payee.toAccountNumber}}</p>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                        <!--//////////////SELECT PAYEE END/////////////////////// -->\n' +
    '                      </div>\n' +
    '\n' +
    '\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-xs-12 col-sm-6">\n' +
    '\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-6 m-t-10 p-l-30">\n' +
    '                          <!--   <span class="invoice-inline-title text-muted"\n' +
    '                                   translate="domesticPayment.receiversAddressInputLabel"><b>Payee street</b></span> -->\n' +
    '                          <input type="text" class="form-control input-field" name="receiversAddressInput"\n' +
    '                                 id="receiversAddressInput" ng-maxlength="70" maxlength="70"\n' +
    '                                 ng-model="templateListOverview.tempObj.receiversAddressInput" required\n' +
    '                                 ng-class="{\'domp-error\': templateListOverview.templatesListForm.receiversAddressInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                 ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                 ng-change="templateListOverview.checkInputChanges(template.paymentTypeGroup)">\n' +
    '                          <span class="c-red"\n' +
    '                                ng-show="templateListOverview.templatesListForm.receiversAddressInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="domesticPayment.receiverAddressError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="templateListOverview.countryCode !== \'bh\'">\n' +
    '                        <div class="col-xs-12 col-sm-6"></div>\n' +
    '                        <div class="col-xs-12 col-sm-6 m-t-10 p-l-30">\n' +
    '                          <!--<span class="invoice-inline-title text-muted"\n' +
    '                                translate="domesticPayment.receiversPostalCodeAndCityInputLabel"><b>Payee city</b></span> -->\n' +
    '                          <input type="text" class="form-control input-field" name="receiversPostalCodeAndCityInput"\n' +
    '                                 id="receiversPostalCodeAndCityInput" ng-maxlength="70" maxlength="70"\n' +
    '                                 ng-model="templateListOverview.tempObj.receiversPostalCodeAndCityInput" required\n' +
    '                                 ng-class="{\'domp-error\': templateListOverview.templatesListForm.receiversPostalCodeAndCityInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                 ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                 ng-change="templateListOverview.checkInputChanges(template.paymentTypeGroup)">\n' +
    '                          <span class="c-red"\n' +
    '                                ng-show="templateListOverview.templatesListForm.receiversPostalCodeAndCityInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="domesticPayment.receiverCityError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="row" ng-if="templateListOverview.countryCode === \'hr\' || templateListOverview.countryCode === \'sl\'">\n' +
    '                        <div class="col-xs-12 col-sm-6" ></div>\n' +
    '                        <div class="col-xs-12 col-sm-6 m-t-10 p-l-30">\n' +
    '                          <uib-accordion close-others="true" class="domp-sepa-accordion">\n' +
    '                            <uib-accordion-group>\n' +
    '                              <uib-accordion-heading>\n' +
    '                                <div class="sepa-heading input-field">\n' +
    '                                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 p-0">\n' +
    '                                    <label class="domp-form-label-sepa"\n' +
    '                                           translate="domesticPayment.sepaReceiverLabel"></label>\n' +
    '                                  </div>\n' +
    '                                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-sepa pull-right"><i\n' +
    '                                    class="icon icon-arrdown"></i></div>\n' +
    '                                </div>\n' +
    '                              </uib-accordion-heading>\n' +
    '                              <input type="text" class="form-control input-field"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     ng-model="templateListOverview.tempObj.receiversSepaInput1" maxlength="35">\n' +
    '                              <input type="text" class="form-control input-field"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     ng-model="templateListOverview.tempObj.receiversSepaInput2" maxlength="35">\n' +
    '                            </uib-accordion-group>\n' +
    '                          </uib-accordion>\n' +
    '\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row m-t-25" id="spaha2">\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20 m-b-10">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted m-b-5"\n' +
    '                                  translate="domesticPayment.purposeCodeSelectLabel">Purpose code</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <select class="form-control input-field " name="purposeCodeSelect"\n' +
    '                                    id="purposeCodeSelect"\n' +
    '                                    ng-options="option.optionValue for option in templateListOverview.purposeCodesList.result"\n' +
    '                                    ng-model="templateListOverview.tempObj.purposeCodeSelect"\n' +
    '                                    ng-change="templateListOverview.changePurpose(templateListOverview.tempObj.purposeCodeSelect)"></select>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="row m-t-20">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted"\n' +
    '                                  translate="domesticPayment.purposeOfPaymentInputLabel">Purpose</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <input type="text" class="form-control input-field "\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.purposeOfPaymentValidation}}"\n' +
    '                                   name="purposeOfPaymentInput" id="purposeOfPaymentInput" ng-maxlength="135"\n' +
    '                                   maxlength="135"\n' +
    '                                   ng-model="templateListOverview.tempObj.purposeOfPaymentInput" required\n' +
    '                                   ng-class="{\'domp-error\': templateListOverview.templatesListForm.purposeOfPaymentInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                   ng-blur="templateListOverview.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', templateListOverview.tempObj.purposeOfPaymentInput)">\n' +
    '                            <span class="c-red"\n' +
    '                                  ng-show="templateListOverview.templatesListForm.purposeOfPaymentInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                  translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '                        <div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '                          <div class="col-md-12">\n' +
    '                            <div class="form-group">\n' +
    '                              <div class="p-0" ng-switch="templateListOverview.tempObj.referenceModelSelect">\n' +
    '                                <input type="text" class="form-control input-field"\n' +
    '                                       ng-switch-when="NRC"\n' +
    '                                       placeholder="test1"\n' +
    '                                       ng-pattern-restrict="{{templateListOverview.regexPatterns.standardInput}}"\n' +
    '                                       name="purposeOfPaymentInput" id="purposeOfPaymentInput" maxlength="140"\n' +
    '                                       ng-model="templateListOverview.tempObj.purposeOfPaymentInput" required\n' +
    '                                       ng-class="{\'domp-error\': templateListOverview.templatesListForm.purposeOfPaymentInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                       ng-blur="templateListOverview.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', templateListOverview.tempObj.purposeOfPaymentInput)">\n' +
    '\n' +
    '                                <input type="text" class="form-control input-field"\n' +
    '                                       ng-switch-default\n' +
    '                                       placeholder="test2"\n' +
    '                                       ng-pattern-restrict="{{templateListOverview.regexPatterns.standardInput}}"\n' +
    '                                       name="purposeOfPaymentInput" id="purposeOfPaymentInput" maxlength="34"\n' +
    '                                       ng-model="templateListOverview.tempObj.purposeOfPaymentInput" required\n' +
    '                                       ng-class="{\'domp-error\': templateListOverview.templatesListForm.purposeOfPaymentInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                       ng-blur="templateListOverview.replaceUnallowedCharsDPS(\'purposeOfPaymentInput\', templateListOverview.tempObj.purposeOfPaymentInput)">\n' +
    '                                <span class="c-red" ng-show="domesticPaymentSlo.domesticPaymentForm.purposeOfPaymentInput.$error.required && domesticPaymentSlo.tempDompObj.formSubmitted" translate="internalTransfer.paymentPurposeInputError"></span>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20"\n' +
    '                           ng-if="templateListOverview.countryCode && templateListOverview.countryCode === \'hr\' && template.paymentTypeGroup !== \'ForeignPayment\'">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted m-b-5"\n' +
    '                                  translate="domesticPayment.referenceNumberLabel">Reference number</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-6 col-sm-2">\n' +
    '                            <input type="text" class="form-control input-field t-a-c" value="HR" readonly>\n' +
    '                          </div>\n' +
    '                          <div class="col-xs-6 col-sm-2 p-0 hidden-xs m-b-10">\n' +
    '\n' +
    '                            <select class="form-control input-field t-a-c" name="referenceModelSelect"\n' +
    '                                    id="referenceModelSelect"\n' +
    '                                    ng-model="templateListOverview.tempObj.referenceModelSelect">\n' +
    '                              <option ng-repeat="item in templateListOverview.referenceModelList">{{item}}</option>\n' +
    '                            </select>\n' +
    '\n' +
    '                          </div>\n' +
    '                          <div class="col-xs-6 col-sm-2 visible-xs m-b-10">\n' +
    '\n' +
    '                            <select class="form-control input-field t-a-c" name="referenceModelSelect"\n' +
    '                                    id="referenceModelSelect"\n' +
    '                                    ng-model="templateListOverview.tempObj.referenceModelSelect">\n' +
    '                              <option ng-repeat="item in templateListOverview.referenceModelList">{{item}}</option>\n' +
    '                            </select>\n' +
    '\n' +
    '                          </div>\n' +
    '                          <div class="col-xs-12 col-sm-8"\n' +
    '                               ng-if="templateListOverview.tempObj.referenceModelSelect != \'99\'">\n' +
    '\n' +
    '                            <input type="text" name="referenceNumberInput" maxlength="22"\n' +
    '                                   class="form-control input-field"\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.allNumbersDashes}}"\n' +
    '                                   ng-if="templateListOverview.tempObj.referenceModelSelect != \'99\'"\n' +
    '                                   ng-model="templateListOverview.tempObj.referenceNumberInput">\n' +
    '\n' +
    '                          </div>\n' +
    '                          <div class="col-xs-12 col-sm-8"\n' +
    '                               ng-if="templateListOverview.tempObj.referenceModelSelect == \'99\'">\n' +
    '\n' +
    '                            <input type="text" class="form-control input-field"\n' +
    '                                   name="referenceNumberInput" readonly>\n' +
    '\n' +
    '                          </div>\n' +
    '                          <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"\n' +
    '                                ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="domesticPayment.referenceModelInputError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20"\n' +
    '                           ng-if="templateListOverview.countryCode === \'hr\' && template.paymentTypeGroup === \'ForeignPayment\'">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <label translate="payments.paymentMode" class="domp-form-label">\n' +
    '                              Payment mode:\n' +
    '                            </label>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <select name="paymentMode"\n' +
    '                                    class="form-control input-field p-l-15 p-r-10"\n' +
    '                                    ng-options="item.id as (item.id +         \' - \' +         item.description) for item in templateListOverview.paymentModeOptions"\n' +
    '                                    ng-model="templateListOverview.tempObj.modalityCode">\n' +
    '                            </select>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <!-- REFERENCE INPUT FOR BIH ENVIRONMENT -->\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20"\n' +
    '                           ng-if="templateListOverview.countryCode === \'bh\'">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted m-b-5"\n' +
    '                                  translate="domesticPayment.referenceNumberLabel">Reference number</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <input type="text" id="referenceNumberInput" class="form-control input-field" name="referenceNumberInput"\n' +
    '                               ng-class="{\'domp-error\': templateListOverview.templatesListForm.referenceNumberInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                               ng-maxlength="{{templateListOverview.referenceMaxLength}}"  ng-pattern-restrict="{{templateListOverview.referencePattern}}"\n' +
    '                               ng-model="templateListOverview.tempObj.referenceNumberInput"\n' +
    '                               ng-change="templateListOverview.validateReferenceNumber(); templateListOverview.checkReferenceNumber();"\n' +
    '                               ng-blur="templateListOverview.completeReferenceNumber();">\n' +
    '                        <div class="c-red" ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.referenceNumberRequired && templateListOverview.tempObj.formSubmitted"\n' +
    '                             translate="domesticPayment.referenceNumberRequired">\n' +
    '                        </div>\n' +
    '                        <div class="c-red" ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.maxlength && templateListOverview.tempObj.formSubmitted"\n' +
    '                             translate="domesticPayment.referenceNumberMaxLength">\n' +
    '                        </div>\n' +
    '                        <div class="c-red" ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.validReferenceNumber && templateListOverview.tempObj.formSubmitted"\n' +
    '                             translate="domesticPayment.referenceNumberError">\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <!-- END REFERENCE INPUT FOR BIH ENVIRONMENT -->\n' +
    '\n' +
    '                      <!-- REFERENCE INPUT FOR SLO ENVIRONMENT -->\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20"\n' +
    '                           ng-if="templateListOverview.countryCode === \'sl\' && template.paymentTypeGroup != \'ForeignPayment\'">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted m-b-5"\n' +
    '                                  translate="domesticPayment.referenceNumberLabel">Reference number</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-6 col-sm-3 p-r-0">\n' +
    '                            <div class="col-xs-12 p-l-0 p-r-0">\n' +
    '                              <!--<input type="text" class="form-control input-field" ng-model="domesticPaymentSlo.referenceHR" readonly>-->\n' +
    '                              <select type="text" class="form-control input-field p-l-15 p-r-10 ng-pristine ng-valid ng-not-empty ng-touched"\n' +
    '                                      name="referenceModelSelect" id="referenceModelSelect"\n' +
    '                                      ng-model="templateListOverview.tempObj.referenceModelSelect"\n' +
    '                                      ng-change="templateListOverview.checkPurposeOfPaymentLength()">\n' +
    '                                <option value="SI">SI</option>\n' +
    '                                <option value="RF">RF</option>\n' +
    '                                <option value="NRC">NRC</option>\n' +
    '                              </select>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <span ng-if="templateListOverview.tempObj.referenceModelSelect != \'NRC\'">\n' +
    '                          <div class="col-xs-6 col-sm-2 p-0 hidden-xs m-b-10" ng-if="templateListOverview.tempObj.referenceModelSelect != \'RF\'">\n' +
    '\n' +
    '                            <select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect" id="referenceModelList"\n' +
    '\n' +
    '                                    ng-model="templateListOverview.referenceModelListSelect"\n' +
    '                                    ng-options="item as item for item in templateListOverview.referenceModelList"\n' +
    '                                    ng-change="templateListOverview.tempObj.referenceNumberInput = (templateListOverview.referenceModelListSelect == \'99\') ? \'\' : templateListOverview.tempObj.referenceNumberInput">\n' +
    '                            </select>\n' +
    '\n' +
    '                          </div>\n' +
    '\n' +
    '                          <div class="col-sm-6 col-xs-6 p-l-0 p-r-0" ng-if="templateListOverview.referenceModelListSelect != \'99\'">\n' +
    '                            <div class="form-group m-b-0">\n' +
    '                              <input type="text" id="referenceNumberInput" name="referenceNumberInput" class="form-control input-field" ng-pattern-restrict="{{templateListOverview.regexPatterns.allLettersNumbersDashes}}" ng-model="templateListOverview.tempObj.referenceNumberInput" maxlength=\'22\'>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="col-sm-6 col-xs-6 p-l-0 p-r-0" ng-if="templateListOverview.referenceModelListSelect == \'99\'">\n' +
    '                            <div class="form-group m-b-0">\n' +
    '                              <input type="text" class="form-control input-field" name="referenceNumberInput" id="referenceNumberInput2" readonly>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          </span>\n' +
    '\n' +
    '\n' +
    '                          <!--<div class="col-xs-6 col-sm-2 visible-xs m-b-10">-->\n' +
    '                          <!--<div ng-switch="templateListOverview.tempObj.referenceModelSelect" class="form-group m-b-0">-->\n' +
    '                          <!--<input ng-switch-when="NRC" type="text" id="referenceNumberInput" name="referenceNumberInput" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.allNumbersDashes}}" ng-model="domesticPaymentSlo.tempDompObj.referenceNumberInput" maxlength=\'140\'>-->\n' +
    '                          <!--&lt;!&ndash; SL or RF &ndash;&gt;-->\n' +
    '                          <!--<input ng-switch-default type="text" id="referenceNumberInput" name="referenceNumberInput" class="form-control input-field" ng-pattern-restrict="{{domesticPaymentSlo.regexPatterns.allNumbersDashes}}" ng-model="domesticPaymentSlo.tempDompObj.referenceNumberInput" maxlength=\'34\'>-->\n' +
    '                          <!--</div>-->\n' +
    '\n' +
    '                          <!--</div>-->\n' +
    '                          <!--<div class="col-xs-12 col-sm-7">-->\n' +
    '\n' +
    '                          <!--<input type="text" name="referenceNumberInput" maxlength="22"-->\n' +
    '                          <!--class="form-control input-field"-->\n' +
    '                          <!--ng-pattern-restrict="{{templateListOverview.regexPatterns.allNumbersDashes}}"-->\n' +
    '                          <!--ng-model="templateListOverview.tempObj.referenceNumberInput">-->\n' +
    '\n' +
    '                          <!--</div>-->\n' +
    '\n' +
    '                          <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"\n' +
    '                                ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                translate="domesticPayment.referenceModelInputError"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <!-- END REFERENCE INPUT FOR SLO ENVIRONMENT -->\n' +
    '\n' +
    '                      <!--SRB/MNE RESP-->\n' +
    '                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 m-t-20"\n' +
    '                           ng-if="templateListOverview.countryCode !== \'hr\' && templateListOverview.countryCode !== \'bh\' && templateListOverview.countryCode !== \'sl\'">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12">\n' +
    '                            <span class="invoice-inline-title text-muted m-b-5"\n' +
    '                                  translate="domesticPayment.referenceNumberLabel">Reference number</span>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-xs-12 col-sm-3">\n' +
    '\n' +
    '                            <select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect"\n' +
    '                                    ng-model="templateListOverview.tempObj.referenceModelSelect"\n' +
    '                                    ng-change="templateListOverview.tempObj.referenceNumberInput = \'\'">\n' +
    '                              <option ng-repeat="item in templateListOverview.referenceModelList track by $index">{{item}}</option>\n' +
    '                            </select>\n' +
    '\n' +
    '                          </div>\n' +
    '                          <div class="col-xs-12 col-sm-9">\n' +
    '\n' +
    '                            <!-- Reference number for Serbia allows only uppercase letters, numbers and dashes-->\n' +
    '                            <!-- capitalize (attribute) directive forces uppercase letters-->\n' +
    '                            <input type="text" class="form-control input-field" name="referenceNumberInput"\n' +
    '                                   ng-class="{\'domp-error\': templateListOverview.templatesListForm.referenceNumberInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                   maxlength="22"\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.allLettersNumbersDashes}}"\n' +
    '                                   ng-if="templateListOverview.tempObj.referenceModelSelect != \'97\'"\n' +
    '                                   ng-model="templateListOverview.tempObj.referenceNumberInput" capitalize/>\n' +
    '                            <input type="text"\n' +
    '                                   ng-class="{\'domp-error\': templateListOverview.templatesListForm.referenceNumberInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                   class="form-control input-field" name="referenceNumberInput" maxlength="22"\n' +
    '                                   ng-pattern-restrict="{{templateListOverview.regexPatterns.allLettersNumbersDashes}}"\n' +
    '                                   ng-blur="templateListOverview.checkModul97Reference(\'97\' + templateListOverview.tempObj.referenceNumberInput)"\n' +
    '                                   ng-if="templateListOverview.tempObj.referenceModelSelect == \'97\'"\n' +
    '                                   ng-model="templateListOverview.tempObj.referenceNumberInput" capitalize required/>\n' +
    '\n' +
    '                          </div>\n' +
    '                          <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" ng-if="templateListOverview.tempObj.referenceModelSelect == \'97\' &&\n' +
    '                                    templateListOverview.templatesListForm.referenceNumberInput.$error.modul97reference == true"\n' +
    '                               translate="domesticPayment.referenceModelInputInvalid">\n' +
    '                          </div>\n' +
    '                          <!-- START Error messages -->\n' +
    '                          <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"\n' +
    '                               ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                               translate="domesticPayment.referenceModelInputError"></div>\n' +
    '                          <!-- END Error messages -->\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <!--END SRB/MNE RESP-->\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- PUBLIC REVENUE EDIT -->\n' +
    '                    <!-- ng-if="template.paymentTypeGroup === \'RevenuePayment\'" -->\n' +
    '                    <div class="row" ng-if="template.paymentTypeGroup === \'RevenuePayment\'">\n' +
    '                      <div data-ng-include="\'payment-templates/public-revenue-section.tpl.html\'"></div>\n' +
    '                    </div>\n' +
    '                    <!-- END PUBLIC REVENUE SECTION -->\n' +
    '\n' +
    '\n' +
    '                    <!-- Cro reference number start -->\n' +
    '\n' +
    '                    <!--<div class="col-sm-6 left-section"-->\n' +
    '                    <!--ng-if="templateListOverview.countryCode && templateListOverview.countryCode === \'hr\' && template.paymentTypeGroup !== \'ForeignPayment\'">-->\n' +
    '                    <!--<div class="col-xs-12 p-l-0">-->\n' +
    '                    <!--<span class="invoice-inline-title text-muted"-->\n' +
    '                    <!--translate="domesticPayment.referenceNumberLabel">Reference-->\n' +
    '                    <!--number:</span>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--<div class="col-sm-2 col-xs-2 p-l-0 p-r-5">-->\n' +
    '                    <!--<input type="text" class="form-control input-field" value="HR" readonly>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--<div class="col-sm-2 col-xs-2 p-l-0 p-r-5">-->\n' +
    '                    <!--<div class="form-group m-b-0">-->\n' +
    '                    <!--<select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect"-->\n' +
    '                    <!--id="referenceModelSelect"-->\n' +
    '                    <!--ng-model="templateListOverview.tempObj.referenceModelSelect">-->\n' +
    '                    <!--<option ng-repeat="item in templateListOverview.referenceModelList">{{item}}</option>-->\n' +
    '                    <!--</select>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--<div class="col-sm-8 col-xs-8 p-l-0 p-r-0"-->\n' +
    '                    <!--ng-if="templateListOverview.tempObj.referenceModelSelect!=\'99\'">-->\n' +
    '                    <!--<div class="form-group m-b-0">-->\n' +
    '                    <!--<input type="text" name="referenceNumberInput" maxlength="22"-->\n' +
    '                    <!--class="form-control input-field"-->\n' +
    '                    <!--ng-pattern-restrict="{{templateListOverview.regexPatterns.allNumbersDashes}}"-->\n' +
    '                    <!--ng-if="templateListOverview.tempObj.referenceModelSelect!=\'99\'"-->\n' +
    '                    <!--ng-model="templateListOverview.tempObj.referenceNumberInput">-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--<div class="col-sm-8 col-xs-8 p-l-0 p-r-0"-->\n' +
    '                    <!--ng-if="templateListOverview.tempObj.referenceModelSelect==\'99\'">-->\n' +
    '                    <!--<div class="form-group m-b-0">-->\n' +
    '                    <!--<input type="text" class="form-control input-field"-->\n' +
    '                    <!--name="referenceNumberInput" readonly>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--<span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"-->\n' +
    '                    <!--ng-show="templateListOverview.templatesListForm.referenceNumberInput.$error.required && templateListOverview.tempObj.formSubmitted"-->\n' +
    '                    <!--translate="domesticPayment.referenceModelInputError"></span>-->\n' +
    '                    <!--</div>-->\n' +
    '\n' +
    '                    <!-- Cro reference number end -->\n' +
    '\n' +
    '                    <!-- Cro foreign payment mode start -->\n' +
    '\n' +
    '                    <!--<div-->\n' +
    '                    <!--ng-if="templateListOverview.countryCode === \'hr\' && template.paymentTypeGroup === \'ForeignPayment\'">-->\n' +
    '                    <!--<div class="col-md-6">-->\n' +
    '                    <!--<label translate="payments.paymentMode" class="domp-form-label">-->\n' +
    '                    <!--Payment mode:-->\n' +
    '                    <!--</label>-->\n' +
    '                    <!--<div class="p-l-0">-->\n' +
    '                    <!--<select name="paymentMode"-->\n' +
    '                    <!--class="form-control input-field p-l-15 p-r-10"-->\n' +
    '                    <!--ng-options="item.id as (item.id + \' - \' + item.description) for item in templateListOverview.paymentModeOptions"-->\n' +
    '                    <!--ng-model="templateListOverview.tempObj.modalityCode">-->\n' +
    '                    <!--</select>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--</div>-->\n' +
    '                    <!--</div>-->\n' +
    '\n' +
    '                    <!-- Cro foreign payment mode end -->\n' +
    '\n' +
    '\n' +
    '                    <!-- DOMESTIC PAYMENT END -->\n' +
    '\n' +
    '\n' +
    '                    <!-- START BIC -->\n' +
    '                    <div ng-if="template.paymentTypeGroup === \'ForeignPayment\'" id="spaha3">\n' +
    '                      <div class="row m-t-25">\n' +
    '                        <div class="col-xs-12 col-sm-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicNumber">\n' +
    '                                BIC Number\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                            <div ng-switch-when="sl" class="row p-r-15 p-l-15">\n' +
    '                              <input type="text" name="bicNumber" class="form-control input-field"\n' +
    '                                     ng-model="templateListOverview.tempObj.swiftCodeInput"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbersAndLetters}}"\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.bicNumber.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     capitalize\n' +
    '                                     required>\n' +
    '                              <span class="c-red" translate="payments.bicNumberRequired"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.bicNumber.$error.required && templateListOverview.tempObj.formSubmitted">\n' +
    '                                </span>\n' +
    '                            </div>\n' +
    '                            <div ng-switch-default class="row p-r-15 p-l-15">\n' +
    '                              <div class="col-xs-12 domp-filter-container"\n' +
    '                                   ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.bicCodeSearchFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '                                <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                                  <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 inner-section input-div searchrow">\n' +
    '                                  <input type="text" class="search-input" name="bicCodeSearchFilter"\n' +
    '                                         ng-model="templateListOverview.bicCodeSearchFilter"\n' +
    '                                         ng-change="templateListOverview.searchBICNumber(templateListOverview.bicCodeSearchFilter)"\n' +
    '                                         ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbersAndLetters}}"\n' +
    '                                         autocomplete="off"\n' +
    '                                         required\n' +
    '                                         capitalize="">\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                                     ng-click="templateListOverview.bicCodeSearchFilterExpanded = !templateListOverview.bicCodeSearchFilterExpanded">\n' +
    '                                  <i class="icon icon-close domp-close-sign"\n' +
    '                                     ng-show="templateListOverview.bicCodeSearchFilter"\n' +
    '                                     ng-click="templateListOverview.removeBicCodeSearch()"></i>\n' +
    '                                  <i class="icon icon-arrdown m-r-0 pull-right"\n' +
    '                                     ng-show="!templateListOverview.bicCodeSearchFilter"></i>\n' +
    '                                </div>\n' +
    '                                <!--Dropdown menu -->\n' +
    '                                <div class="domp-filter-selection search-row"\n' +
    '                                     ng-class="{\'opened\': templateListOverview.bicCodeSearchFilterExpanded}">\n' +
    '                                  <div class="domp-filter-type-selection-wrapper"\n' +
    '                                       ng-repeat="bicBank in templateListOverview.bicBankOptions| filter:templateListOverview.bicCodeSearchFilter"\n' +
    '                                       ng-click="templateListOverview.onBicBankSelected(bicBank.bicCode)">\n' +
    '                                    <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                                      <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                                      <p class="domp-list-name m-0">{{bicBank.bicCode}}</p>\n' +
    '                                    </div>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                                <span class="c-red" translate="payments.bicNumberRequired"\n' +
    '                                      ng-show="templateListOverview.templatesListForm.bicCodeSearchFilter.$error.required && templateListOverview.tempObj.formSubmitted">\n' +
    '                              </span>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicCountry">\n' +
    '                                Country\n' +
    '                              </span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row p-r-15 p-l-15">\n' +
    '                            <div class="col-xs-12 domp-filter-container"\n' +
    '                                 ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.countrySearchFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                                <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                              </div>\n' +
    '                              <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 inner-section input-div searchrow">\n' +
    '                                <input type="text" class="search-input" name="countrySearchFilter"\n' +
    '                                       ng-model="templateListOverview.countrySearchFilter"\n' +
    '                                       ng-change="templateListOverview.countrySearchFilterExpanded = true;"\n' +
    '                                       ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbersAndLettersWithSuskavci}}"\n' +
    '                                       required\n' +
    '                                       autocomplete="off">\n' +
    '                              </div>\n' +
    '\n' +
    '                              <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                                   ng-click="templateListOverview.countrySearchFilterExpanded = !templateListOverview.countrySearchFilterExpanded">\n' +
    '                                <i class="zmdi zmdi-close domp-close-sign"\n' +
    '                                   ng-show="templateListOverview.countrySearchFilter"\n' +
    '                                   ng-click="templateListOverview.removeSelectedCountry()"></i>\n' +
    '                                <i class="icon icon-arrdown  m-r-0 pull-right"\n' +
    '                                   ng-show="!templateListOverview.countrySearchFilter"></i>\n' +
    '                              </div>\n' +
    '                              <!--Dropdown menu -->\n' +
    '                              <div class="domp-filter-selection search-row"\n' +
    '                                   ng-class="{\'opened\': templateListOverview.countrySearchFilterExpanded}">\n' +
    '                                <div class="domp-filter-type-selection-wrapper"\n' +
    '                                     ng-repeat="country in templateListOverview.countriesOptions| filter: templateListOverview.countrySearchFilter"\n' +
    '                                     ng-click="templateListOverview.onCountrySelect(country)">\n' +
    '                                  <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                                    <!--<i class="zmdi zmdi-account-circle"></i>-->\n' +
    '                                  </div>\n' +
    '                                  <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                                    <p class="domp-list-name m-0">{{country.code}} {{country.description}}</p>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                            <div class="c-red"\n' +
    '                                 ng-show="templateListOverview.templatesListForm.countrySearchFilter.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                 translate="payments.bicCountryRequired"></div>\n' +
    '\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <div class="row m-t-25">\n' +
    '                        <div class="col-xs-12 col-md-4">\n' +
    '                          <!-- Required if Bic number is empty -->\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted"\n' +
    '                                    translate="payments.bicBankName">Bank Name</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <input type="text" class="form-control input-field"\n' +
    '                                     name="bankNameInput"\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.bankNameInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     replace-specific-chars\n' +
    '                                     ng-model="templateListOverview.tempObj.bankNameInput"\n' +
    '                                     autocomplete="off"\n' +
    '                                     required>\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.bankNameInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="payments.bicBankNameRequired"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-md-4" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicRecipientStatus">Receiver (person)</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <select class="form-control input-field"\n' +
    '                                      ng-model="templateListOverview.tempObj.recipientStatusRadiobutton.type">\n' +
    '                                <option value=2>{{"payments.bicRecipientStatusOptionPhysical"| translate}}</option>\n' +
    '                                <option value=1>{{"payments.bicRecipientStatusOptionLegal"| translate}}</option>\n' +
    '                              </select>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                      <div class="row m-t-25">\n' +
    '                        <div class="col-md-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted"\n' +
    '                                    translate="payments.bicAddress">BIC Address</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <input type="text" class="form-control input-field"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     replace-specific-chars\n' +
    '                                     autocomplete="off"\n' +
    '                                     ng-model="templateListOverview.tempObj.bankAddressInput">\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                        <div class="col-md-4">\n' +
    '\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicCity">BIC City</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <input type="text" class="form-control input-field" name="bicCity"\n' +
    '                                     ng-model="templateListOverview.tempObj.bankCityInput"\n' +
    '                                     ng-pattern-restrict="{{templateListOverview.regexPatterns.allowedCharsDPS}}"\n' +
    '                                     replace-specific-chars\n' +
    '                                     ng-class="{\'domp-error\': templateListOverview.templatesListForm.bicCity.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '                                     required>\n' +
    '                              <span class="c-red"\n' +
    '                                    ng-show="templateListOverview.templatesListForm.bicCity.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '                                    translate="payments.bicCityRequired"></span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                        <div class="col-md-4">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <span class="invoice-inline-title text-muted" translate="payments.bicBankCharges">Troškovna opcija:</span>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="col-xs-12" >\n' +
    '                              <select ng-switch-default\n' +
    '                                      class="form-control input-field"\n' +
    '                                      ng-model="templateListOverview.tempObj.bankChargesRadiobutton.type">\n' +
    '                                <option value=3>SHA</option>\n' +
    '                                <option value=1>OUR</option>\n' +
    '                                <option value=2>BEN</option>\n' +
    '                              </select>\n' +
    '                              <select ng-switch-when="sl"\n' +
    '                                      class="form-control input-field"\n' +
    '                                      ng-model="templateListOverview.tempObj.bankChargesRadiobutton.type">\n' +
    '                                <option value=0>SHA</option>\n' +
    '                                <option value=1>OUR</option>\n' +
    '                              </select>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <!-- END BIC -->\n' +
    '\n' +
    '\n' +
    '                    <!-- Save/Cancel action start -->\n' +
    '\n' +
    '                    <div class="row  p-t-20">\n' +
    '                      <button class="btn btn-primary editTemplate" translate="templatesList.cancel"\n' +
    '                              ng-click="templateListOverview.cancel(template)">Cancel\n' +
    '                      </button>\n' +
    '                      <button class="btn btn-default editTemplate pull-right" translate="templatesList.save"\n' +
    '                              ng-click="templateListOverview.saveTemplate(template)">Edit\n' +
    '                      </button>\n' +
    '                    </div>\n' +
    '                    <!-- Save/Cancel actions end -->\n' +
    '                  </form>\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- EDITABLE END-->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="m-10 text-center" ng-if="templateListOverview.templateList.hasMore">\n' +
    '        <hr>\n' +
    '        <button class="btn btn-default" ng-click="templateListOverview.loadMoreTemplates()"\n' +
    '                translate="messages.loadMore">Load more\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-templates/public-revenue-section.tpl.html',
    '<!-- PUBLIC REVENUE SECTION -->\n' +
    '<div class="col-lg-12 col-md-12 col-sm-12 purpose-section revenue-section">\n' +
    '  <div class="row m-r-0">\n' +
    '    <div class="col-sm-6 left-section">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label" translate="domesticPayment.taxPayerNumber"></label>\n' +
    '        <input type="text" class="form-control input-field" name="taxCollectorInput" data-ng-model="templateListOverview.tempObj.taxPayerId"\n' +
    '               ng-class="{\'domp-error\': templateListOverview.templatesListForm.taxCollectorInput.$invalid && templateListOverview.tempObj.formSubmitted}"\n' +
    '               maxlength="13" ng-maxlength="13" ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbers}}" required>\n' +
    '        <div class="c-red" ng-show="templateListOverview.templatesListForm.taxCollectorInput.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.taxPayerError">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-6 left-section">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label" translate="domesticPayment.paymentType"></label>\n' +
    '        <select class="form-control input-field" data-ng-model="templateListOverview.tempObj.paymentType">\n' +
    '          <option ng-repeat="paymentType in templateListOverview.tempObj.paymentTypes">{{paymentType}}</option>\n' +
    '        </select>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-r-0">\n' +
    '    <div click-outside="templateListOverview.revenueCodeFilterExpanded = false;" outside-if-not="expandRevenueCodeFilter" class="col-sm-6 left-section">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label" translate="domesticPayment.revenueCode"></label>\n' +
    '        <!-- REVENUE TYPE AUTOCOMPLETE -->\n' +
    '        <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.revenueCodeFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '          <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '            <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '          </div>\n' +
    '          <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '            <input type="text" name="revenueCodeFilter" class="search-input"\n' +
    '                   ng-model="templateListOverview.tempObj.revenueCode"\n' +
    '                   ng-change="templateListOverview.openRevenueCodes()" ng-maxlength="6" maxlength="6"\n' +
    '                   ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbers}}"\n' +
    '                   autocomplete="off" required>\n' +
    '          </div>\n' +
    '          <div id="expandRevenueCodeFilter" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '               ng-click="templateListOverview.toggleRevenueCodes();">\n' +
    '            <i class="zmdi zmdi-close domp-close-sign" ng-show="templateListOverview.tempObj.revenueCode!=\'\'"\n' +
    '               ng-click="templateListOverview.closeRevenueCodes()"></i>\n' +
    '            <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right ng-hide"\n' +
    '               ng-show="templateListOverview.tempObj.revenueCode==\'\'"></i>\n' +
    '          </div>\n' +
    '          <div class="domp-filter-selection search-row"\n' +
    '               ng-class="{\'opened\': templateListOverview.revenueCodeFilterExpanded}">\n' +
    '            <div class="domp-filter-type-selection-wrapper"\n' +
    '                 ng-repeat="revenueCode in templateListOverview.tempObj.revenueCodes | filter: templateListOverview.filterRevenueCodes"\n' +
    '                 ng-click="templateListOverview.selectRevenueCode(revenueCode)">\n' +
    '              <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                <p class="domp-list-name m-0">{{revenueCode.description}}</p>\n' +
    '                <p class="domp-list-number m-0">{{revenueCode.code}}</p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '             ng-show="templateListOverview.templatesListForm.revenueCodeFilter.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.revenueCodeError">\n' +
    '        </div>\n' +
    '        <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '             ng-show="templateListOverview.templatesListForm.revenueCodeFilter.$error.revenueCodeExistance && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.revenueCodeExistanceError">\n' +
    '        </div>\n' +
    '        <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '             ng-show="templateListOverview.templatesListForm.revenueCodeFilter.$error.revenueCodeType && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.revenueCodeTypeError">\n' +
    '        </div>\n' +
    '        <!-- END REVENUE TYPE AUTOCOMPLETE -->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div click-outside="templateListOverview.municipalityFilterExpanded = false;" outside-if-not="expandMunicipalityFilter" class="col-sm-6 left-section">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label" translate="domesticPayment.municipality"></label>\n' +
    '        <!-- MUNICIPALITY AUTOCOMPLETE -->\n' +
    '        <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.municipalityFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '          <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '            <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '          </div>\n' +
    '          <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '            <input type="text" name="municipalityFilter" class="search-input"\n' +
    '                   ng-model="templateListOverview.tempObj.municipality"\n' +
    '                   ng-change="templateListOverview.openMunicipalities()"\n' +
    '                   ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbers}}"\n' +
    '                   ng-maxlength="3" maxlength="3" autocomplete="off" required>\n' +
    '          </div>\n' +
    '          <div id="expandMunicipalityFilter" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '               ng-click="templateListOverview.toggleMunicipalities()">\n' +
    '            <i class="zmdi zmdi-close domp-close-sign" ng-show="templateListOverview.tempObj.municipality!=\'\'"\n' +
    '               ng-click="templateListOverview.removeMunicipalities()"></i>\n' +
    '            <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right ng-hide"\n' +
    '               ng-show="templateListOverview.tempObj.municipality==\'\'"></i>\n' +
    '          </div>\n' +
    '          <div class="domp-filter-selection search-row"\n' +
    '               ng-class="{\'opened\': templateListOverview.municipalityFilterExpanded}">\n' +
    '            <div class="domp-filter-type-selection-wrapper"\n' +
    '                 ng-repeat="municipality in templateListOverview.tempObj.municipalities |filter: templateListOverview.filterMunicipalities"\n' +
    '                 ng-click="templateListOverview.selectMunicipality(municipality)">\n' +
    '              <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                <p class="domp-list-name m-0">{{municipality.description}}</p>\n' +
    '                <p class="domp-list-number m-0">{{municipality.codeString}}</p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '             ng-show="templateListOverview.templatesListForm.municipalityFilter.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.municipalityError">\n' +
    '        </div>\n' +
    '        <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '             ng-show="templateListOverview.templatesListForm.municipalityFilter.$error.municipalityExistance && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.municipalityExistanceError">\n' +
    '        </div>\n' +
    '        <!-- END MUNICIPALITY AUTOCOMPLETE -->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-r-0">\n' +
    '    <div class="col-sm-6 left-section">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label m-t-15" translate="domesticPayment.taxPeriodFrom"></label>\n' +
    '        <div class="input-group ">\n' +
    '          <input type="text" class="form-control input-field" name="taxPeriodFrom"\n' +
    '                 uib-datepicker-popup="shortDate" data-ng-model="templateListOverview.tempObj.taxPeriodFrom"\n' +
    '                 show-weeks="false" is-open="templateListOverview.taxPeriodFromOpened"\n' +
    '                 datepicker-options="templateListOverview.dateOptions"\n' +
    '                 data-ng-change="templateListOverview.validateTaxPeriod()" readonly>\n' +
    '                    <span class="input-group-btn">\n' +
    '                            <button data-ng-click="templateListOverview.openTaxPeriodFrom()" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                    style="border:1px solid #062a42;"><i\n' +
    '                              class="icon icon-calendar" style="font-size: 21px;"></i></button>\n' +
    '                          </span>\n' +
    '        </div>\n' +
    '        <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '             ng-show="templateListOverview.templatesListForm.taxPeriodFrom.$error.taxPeriodRange && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.taxPeriodRangeError">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-6 left-section">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label m-t-15" translate="domesticPayment.taxPeriodTo"></label>\n' +
    '        <div class="input-group ">\n' +
    '          <input type="text" class="form-control input-field" name="taxPeriodTo"\n' +
    '                 uib-datepicker-popup="shortDate" data-ng-model="templateListOverview.tempObj.taxPeriodTo"\n' +
    '                 show-weeks="false" is-open="templateListOverview.taxPeriodToOpened"\n' +
    '                 datepicker-options="templateListOverview.dateOptions"\n' +
    '                 data-ng-change="templateListOverview.validateTaxPeriod()" readonly>\n' +
    '                    <span class="input-group-btn">\n' +
    '                            <button data-ng-click="templateListOverview.openTaxPeriodTo()" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                    style="border:1px solid #062a42;"><i\n' +
    '                              class="icon icon-calendar" style="font-size: 21px;"></i></button>\n' +
    '                          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-r-0">\n' +
    '    <div click-outside="templateListOverview.budgetOrganizationFilterExpanded = false;" outside-if-not="expandBudgFilterOrg" class="col-sm-6 left-section">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label" translate="domesticPayment.budgetOrganisation"></label>\n' +
    '        <!-- BUDGET ORGANIZATIONS AUTOCOMPLETE -->\n' +
    '        <div class="col-sm-12 col-xs-12 domp-filter-container" ng-class="{\'domp-error-custom-payee\': templateListOverview.templatesListForm.budgetOrganizationFilter.$invalid && templateListOverview.tempObj.formSubmitted}">\n' +
    '          <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '            <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '          </div>\n' +
    '          <div class="col-sm-9 col-md-9 col-lg-10 col-xs-9 inner-section input-div searchrow">\n' +
    '            <input type="text" name="budgetOrganizationFilter" class="search-input"\n' +
    '                   ng-model="templateListOverview.tempObj.budgetOrganization"\n' +
    '                   ng-change="templateListOverview.openBudgetOrganizations()" maxlength="7"\n' +
    '                   ng-pattern-restrict="{{templateListOverview.regexPatterns.onlyNumbers}}"\n' +
    '                   ng-maxlength="7" autocomplete="off" required>\n' +
    '          </div>\n' +
    '          <div id="expandBudgFilterOrg" class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '               ng-click="templateListOverview.toggleBudgetOrganizations()">\n' +
    '            <i class="zmdi zmdi-close domp-close-sign" ng-show="templateListOverview.tempObj.budgetOrganization!=\'\'"\n' +
    '               ng-click="templateListOverview.closeBudgetOrganization()"></i>\n' +
    '            <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right ng-hide"\n' +
    '               ng-show="templateListOverview.tempObj.budgetOrganization==\'\'"></i>\n' +
    '          </div>\n' +
    '          <div class="domp-filter-selection search-row"\n' +
    '               ng-class="{\'opened\': templateListOverview.budgetOrganizationFilterExpanded}">\n' +
    '            <div class="domp-filter-type-selection-wrapper"\n' +
    '                 ng-repeat="organization in templateListOverview.tempObj.budgetOrganizations |filter: templateListOverview.filterBudgetOrganizations"\n' +
    '                 ng-click="templateListOverview.selectBudgetOrganization(organization)">\n' +
    '              <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                <p class="domp-list-name m-0">{{organization.description}}</p>\n' +
    '                <p class="domp-list-number m-0">{{organization.budgetOrganisationNumber}}</p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0"\n' +
    '             ng-show="templateListOverview.templatesListForm.budgetOrganizationFilter.$error.required && templateListOverview.tempObj.formSubmitted"\n' +
    '             translate="domesticPayment.budgetOrganizationError">\n' +
    '        </div>\n' +
    '        <!-- END BUDGET ORGANIZATIONS -->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<!-- END PUBLIC REVENUE SECTION -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-templates/payment-templates.tpl.html',
    '<h2>paymentTemplates</h2>\n' +
    '<p>{{paymentTemplates.ctrlName}}</p>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-templates/payment-templates-modal.tpl.html',
    '<div class="p-l-15 p-r-15 f-14" ng-hide="paymentTemplatesModal.paymentResponse">\n' +
    '  <div class="row ptm-header p-10 bottom-border">\n' +
    '    <b class="f-18">{{paymentTemplatesModal.paymentObject.name}}</b>\n' +
    '    <i class="zmdi zmdi-close zmdi-hc-2x pull-right pointer-cst" data-ng-click="paymentTemplatesModal.closeModal();"></i>\n' +
    '  </div>\n' +
    '  <div class="row p-10 bottom-border">\n' +
    '    <div class="col-sm-4 ptm-left-section">\n' +
    '\n' +
    '      <div class="m-b-5">\n' +
    '        <label class="ptm-label" translate="paymentTemplates.payingFrom"></label>\n' +
    '        <p class="ptm-acc-info wrap-text" title="{{paymentTemplatesModal.paymentObject.fromAccount}}">\n' +
    '          {{paymentTemplatesModal.paymentObject.fromAccount}}\n' +
    '        </p>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="m-b-5">\n' +
    '        <label class="ptm-label" translate="paymentTemplates.payingTo"></label>\n' +
    '        <p class="ptm-acc-info wrap-text" title="{{paymentTemplatesModal.paymentObject.toAccountNumber}}">\n' +
    '          {{paymentTemplatesModal.paymentObject.toAccountNumber}}\n' +
    '        </p>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="col-sm-8 ptm-right-section">\n' +
    '      <form name="paymentTemplatesModal.templateForm">\n' +
    '        <div class="m-b-10">\n' +
    '          <span class="m-b-5 ptm-label" translate="paymentTemplates.howMuch">How much?</span>\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control" data-input-mask="\'core.moneyFormat.mask\'" data-input-mask-options="{reverse: true,optional: true}" placeholder="" maxlength="22" autocomplete="off" style="text-align: right;" data-ng-model="paymentTemplatesModal.paymentObject.amount">\n' +
    '            <div class="input-group-addon qp-amount">{{paymentTemplatesModal.paymentObject.accountCurrency}}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="m-b-10">\n' +
    '          <span class="m-b-5 ptm-label" translate="paymentTemplates.description"></span>\n' +
    '          <input name="description" class="form-control" rows="3" data-ng-model="paymentTemplatesModal.paymentObject.purpose" maxlength="134" required>\n' +
    '          <span class="error c-red" ng-show="paymentTemplatesModal.templateForm.description.$error.required" translate="paymentTemplates.descriptionError"></span>\n' +
    '        </div>\n' +
    '        <div class="m-b-10">\n' +
    '          <span class="m-b-5 ptm-label" translate="paymentTemplates.when"></span>\n' +
    '          <div>\n' +
    '            <input class="form-control" type="text" data-ng-click="paymentTemplatesModal.openDatePicker()" uib-datepicker-popup="shortDate" data-ng-model="paymentTemplatesModal.paymentObject.dueDate" show-weeks="false" is-open="paymentTemplatesModal.datePickerOpened" datepicker-options="paymentTemplatesModal.dateOptions">\n' +
    '            <span ng-hide="paymentTemplatesModal.validDate" class="c-red" translate="paymentTemplates.invalidDate"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row p-10 ptm-footer">\n' +
    '    <a href="" class="clickable-link">\n' +
    '      <span translate="paymentTemplates.showFullPaymentForm" data-ng-click="paymentTemplatesModal.navigateToFullPaymentsForm();"></span>\n' +
    '    </a>\n' +
    '    <button ng-hide="paymentTemplatesModal.paymentObject.forEdit == true" class="btn btn-default app-btn-blue pull-right ptm-pay-btn m-l-10" data-ng-click="paymentTemplatesModal.executePayment();" translate="paymentTemplates.pay"></button>\n' +
    '    <button class="btn btn-default app-btn-blue ptm-pay-btn pull-right m-l-10" data-ng-click="paymentTemplatesModal.saveTemplate();" translate="paymentTemplates.save"></button>\n' +
    '    <button class="btn btn-default app-btn-blue ptm-pay-btn pull-right" data-ng-click="paymentTemplatesModal.deleteTemplate();" translate="paymentTemplates.delete"></button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- Signed document info -->\n' +
    '<div ng-if="paymentTemplatesModal.paymentResponse && !paymentTemplatesModal.signSuccess" class="f-14">\n' +
    '  <table class="table table-striped">\n' +
    '    <thead>\n' +
    '      <tr>\n' +
    '        <th class="row ptm-header p-l-10" colspan="2">\n' +
    '          <b class="f-18" translate="paymentTemplates.signMsg"></b>\n' +
    '          <i class="zmdi zmdi-close zmdi-hc-2x pull-right pointer-cst eim-header-btn-close" data-ng-click="paymentTemplatesModal.closeModal();"></i>\n' +
    '        </th>\n' +
    '      </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.fromAccountNumber">\n' +
    '        <td class="bold-font" translate="paymentTemplates.fromAccount"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentObject.fromAccountNumber}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.toAccountNumber">\n' +
    '        <td class="bold-font" translate="paymentTemplates.toAccount"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.toAccountNumber}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.receiverName">\n' +
    '        <td class="bold-font" translate="paymentTemplates.receiver"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.receiverName}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.receiverAddress1 && paymentTemplatesModal.paymentResponse.receiverCity">\n' +
    '        <td class="bold-font" translate="paymentTemplates.receiverAddress"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.receiverAddress1 + \', \' + paymentTemplatesModal.paymentResponse.receiverCity}}\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.amount">\n' +
    '        <td class="bold-font" translate="paymentTemplates.amount"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.amount + \' \' + paymentTemplatesModal.paymentResponse.currencySymbol}}\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.purpose">\n' +
    '        <td class="bold-font" translate="paymentTemplates.description"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.purpose}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.status">\n' +
    '        <td class="bold-font" translate="paymentTemplates.status"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.status}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.intermediateBankName">\n' +
    '        <td class="bold-font" translate="paymentTemplates.bankName"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.intermediateBankName}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.intermediateBankAddress">\n' +
    '        <td class="bold-font" translate="paymentTemplates.bankAddress"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.intermediateBankAddress + \', \' + paymentTemplatesModal.paymentResponse.intermediateBankAddress2}}\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="paymentTemplatesModal.paymentResponse.dueDate">\n' +
    '        <td class="bold-font" translate="paymentTemplates.dueDate"></td>\n' +
    '        <td>{{paymentTemplatesModal.paymentResponse.dueDate | date:\'shortDate\'}}</td>\n' +
    '      </tr>\n' +
    '      <tr class="row p-10 ptm-footer">\n' +
    '        <td class="ptm-btn">\n' +
    '          <!--<button class="btn btn-default app-btn-blue pull-right ptm-pay-btn" data-ng-click="paymentTemplatesModal.signPayment();" translate="paymentTemplates.signPayment"></button>-->\n' +
    '          <button class="btn btn-default app-btn-blue pull-right ptm-pay-btn" data-ui-sref="payments.sign({paymentId: paymentTemplatesModal.paymentResponse.id})" translate="paymentTemplates.signPayment"></button>\n' +
    '          <button class="btn btn-default app-btn-blue pull-right ptm-pay-btn m-r-15" data-ng-click="paymentTemplatesModal.closeModal();" translate="paymentTemplates.cancel"></button>\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '    </tbody>\n' +
    '  </table>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!-- Save as template -->\n' +
    '<div ng-if="paymentTemplatesModal.signSuccess">\n' +
    '  <div class="row ptm-header p-10 bottom-border">\n' +
    '    <b class="f-18" translate="paymentTemplates.saveTemplate"></b>\n' +
    '    <i class="zmdi zmdi-close zmdi-hc-2x pull-right pointer-cst eim-header-btn-close" data-ng-click="paymentTemplatesModal.closeModal();"></i>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <payment-final-step payment="paymentTemplatesModal.paymentResponse"\n' +
    '                        close="paymentTemplatesModal.closeModal();"\n' +
    '                        is-modal="true"\n' +
    '                        template-name="paymentTemplatesModal.paymentObject.name"\n' +
    '                        template-id="paymentTemplatesModal.paymentObject.id">\n' +
    '    </payment-final-step>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-templates/payment-new-template.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '\n' +
    '    <div class="exchange-rate-header">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 col-xs-12 f-20" translate="paymentTemplates.saveTemplate"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-xs-12 m-t-15">\n' +
    '      <div class="col-sm-3 col-xs-5">\n' +
    '          <span class="template-headers" translate="paymentTemplates.templateIcon">\n' +
    '            Template icon\n' +
    '          </span>\n' +
    '          <div class="dropdown">\n' +
    '            <div class="dropdown-toggle img-selector-btn" type="button" data-toggle="dropdown">\n' +
    '\n' +
    '              <div class="circ-img-container">\n' +
    '                <img ng-src="{{newTemplate.selectedImage.downloadLink}}" alt="Ico"/>\n' +
    '              </div>\n' +
    '\n' +
    '                <span class="caret-icon caret-cursor">\n' +
    '                  <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                </span>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="dropdown-menu tmpl-img-selector" role="menu" aria-labelledby="menu1">\n' +
    '              <div ng-repeat="image in newTemplate.images" data-ng-click="newTemplate.selectImage(image)">\n' +
    '                <div class="col-xs-12 img-option">\n' +
    '                  <img class="tmpl-img" ng-src="{{image.downloadLink}}" alt="Ico">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="col-sm-9 col-xs-7">\n' +
    '          <span class="template-headers" translate="paymentTemplates.templateName">\n' +
    '            Template name\n' +
    '          </span>\n' +
    '        <input type="text" class="form-control input-field"\n' +
    '               data-ng-model="newTemplate.templateNameInput"\n' +
    '               placeholder="{{\'internalTransfer.templateName\' | translate}}"\n' +
    '               maxlength="35">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-xs-12">\n' +
    '      <button class="btn btn-default m-t-20 col-sm-3 col-xs-6 pull-right m-r-15"\n' +
    '              data-ng-click="newTemplate.saveAsTemplate();"\n' +
    '              translate="paymentTemplates.save"\n' +
    '              ng-disabled="newTemplate.templateNameInput === \'\' || newTemplate.formSubmitted">\n' +
    '        Save\n' +
    '      </button>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/term-deposit.tpl.html',
    '<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <div ng-switch-when="sl">\n' +
    '    <div ng-include="\'orders/term-deposit-slo.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '  <div ng-switch-default>\n' +
    '    <div ng-include="\'orders/term-deposit-other.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/term-deposit-slo.tpl.html',
    '<section id="main" ng-controller="TermDepositCtrlSlo as termDeposit">\n' +
    '  <div ng-show="termDeposit.isPageLoaded" class="container-fluid clearfix f-14 m-t-25 m-b-20">\n' +
    '    <div ng-show="!termDeposit.steps.step3">\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <h2 class="title-style m-t-0 m-b-20" translate="termDeposit.termDepositHeader"></h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <div class="alert alert-info" style="background: white; color: black; border: 1px solid lightgray"\n' +
    '               role="alert">\n' +
    '            <p class="bold-font" translate="termDeposit.taxationOfInterestTitle"></p>\n' +
    '            <p translate="termDeposit.taxationOfInterestMsg">\n' +
    '            <div class="row p-t-10 p-l-15 p-r-15">\n' +
    '              <div class="col-xs-4 p-0"><a href="https://www.addiko.si/varcevanja" target="_blank" class="underline">{{\n' +
    '                \'termDeposit.headerLink1\' | translate}}</a></div>\n' +
    '              <div class="col-xs-4 p-0"><a href="https://www.addiko.si/obrestne-mere" target="_blank" class="underline">{{\n' +
    '                \'termDeposit.headerLink2\' | translate}}</a></div>\n' +
    '              <div class="col-xs-4 p-0"><a href="https://www.bsi.si/jamstvo-vlog.asp?MapaId=150" target="_blank"\n' +
    '                                           class="underline">{{ \'termDeposit.headerLink3\' | translate}}</a></div>\n' +
    '            </div>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-12"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ====  STEP 1 ==== -->\n' +
    '    <!-- ================= -->\n' +
    '    <div ng-form="termDeposit.termDepositForm" class="clearfix bg-white" ng-show="termDeposit.steps.step1" novalidate>\n' +
    '      <div class="intp-form-container bottom-border">\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-5">\n' +
    '            <label class="ntd-form-label compact"\n' +
    '                   translate="termDeposit.depositType">\n' +
    '            </label>\n' +
    '            <select name="depositType"\n' +
    '                    ng-options="key for (key, value) in termDeposit.depositOrderGroupOptions"\n' +
    '                    value="{{key}}"\n' +
    '                    ng-model="termDeposit.depositGroup"\n' +
    '                    ng-change="termDeposit.onDepositGroupChange(termDeposit.depositGroup)"\n' +
    '                    class="form-control h-45"\n' +
    '                    required>\n' +
    '            </select>\n' +
    '            <span class="c-red"\n' +
    '                  ng-show="termDeposit.termDepositForm.depositType.$error.required && termDeposit.formSubmitted"\n' +
    '                  translate="core.requiredField"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-5">\n' +
    '            <label class="ntd-form-label compact" translate="termDeposit.debitAccountSelectLabel"></label>\n' +
    '            <div class="accounts-dropdown m-b-10" ng-if="termDeposit.accountsFrom.length > 0">\n' +
    '              <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                   data-ng-click="termDeposit.toggleFromAccount();"\n' +
    '                   ng-style="termDeposit.model.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + termDeposit.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                  <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{termDeposit.model.fromAccountSelect.friendlyName}}</b>\n' +
    '                  <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                    <i class="zmdi"\n' +
    '                       ng-class="{\'zmdi-star favorite-account\':termDeposit.model.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!termDeposit.model.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                </h4>\n' +
    '                <p class="m-b-0 m-t-0 iban-style">\n' +
    '                  {{termDeposit.model.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                  {{termDeposit.model.fromAccountSelect.availableBalance | number:2}}\n' +
    '                  {{termDeposit.model.fromAccountSelect.currencySymbol}}\n' +
    '                </p>\n' +
    '                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '              </div>\n' +
    '              <div class="from-accounts-list m-l-15" ng-show="termDeposit.fromAccountDropdown" scrollable>\n' +
    '                <div class="accounts-list-item p-0" data-ng-repeat="item in termDeposit.accountsFrom"\n' +
    '                     data-ng-click="termDeposit.setAccountFrom(item);">\n' +
    '\n' +
    '                  <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                       ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                      <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                          ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                    </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                      {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="accounts-dropdown m-b-10"\n' +
    '                 ng-if="!termDeposit.accountsFrom.length || termDeposit.accountsFrom.length === 0">\n' +
    '              <!--<div class="debit-account-widget dashboard-widget-item" style="height: 114px; line-height: 114px" translate="internalTransfer.noData"  ng-style="termDeposit.model.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + termDeposit.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  No available accounts\n' +
    '              </div>-->\n' +
    '              <div class="debit-account-widget dashboard-widget-item" style="height: 141px;"\n' +
    '                   ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                <div class="m-t-30 m-b-30">\n' +
    '                  <p translate="internalTransfer.nodata"></p>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div>\n' +
    '              <span class="c-red" ng-show="termDeposit.termDepositForm.amount.$error.currency">\n' +
    '                    <span translate="termDeposit.wrongDepositCurrency"></span>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-md-7">\n' +
    '            <div class="form-group clearfix m-t-10">\n' +
    '              <div class="col-sm-6 col-xs-12">\n' +
    '                <div class="col-md-12 p-0">\n' +
    '                  <label class="ntd-form-label compact" translate="termDeposit.termDepositDuration"></label>\n' +
    '                </div>\n' +
    '                <div class="col-md-5 col-xs-5 p-0">\n' +
    '                  <input class="form-control t-a-r h-45" maxlength="6"\n' +
    '                         name="maturityInDays"\n' +
    '                         ng-show="!termDeposit.durationReadonly"\n' +
    '                         ng-pattern-restrict="{{termDeposit.regexPatterns.onlyNumbers}}"\n' +
    '                         ng-blur="termDeposit.calculateMaturityDateWithDays(termDeposit.model.maturityInDays)"\n' +
    '                         ng-model="termDeposit.model.maturityInDays"\n' +
    '                         required/>\n' +
    '                  <input class="form-control t-a-r h-45" maxlength="6"\n' +
    '                         name="maturityInDays"\n' +
    '                         ng-show="termDeposit.durationReadonly"\n' +
    '                         ng-value="termDeposit.model.maturityInDays"\n' +
    '                         readonly\n' +
    '                         required/>\n' +
    '                  <label class="ntd-form-label compact pull-right"\n' +
    '                         translate="termDeposit.durationInDays">\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '                <div class="col-md-2 col-xs-2 p-10 text-center">\n' +
    '                  <label class="ntd-form-label compact"\n' +
    '                         translate="termDeposit.durationOr">\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '                <div class="col-md-5 col-xs-5 p-0">\n' +
    '\n' +
    '                  <input class="form-control t-a-r h-45" maxlength="3"\n' +
    '                         name="maturityInMonths"\n' +
    '                         ng-show="!termDeposit.durationReadonly"\n' +
    '                         ng-pattern-restrict="{{termDeposit.regexPatterns.onlyNumbers}}"\n' +
    '                         ng-blur="termDeposit.calculateMaturityDate(termDeposit.model.maturityInMonths)"\n' +
    '                         ng-model="termDeposit.model.maturityInMonths"\n' +
    '                         ng-readonly="termDeposit.durationReadonly"/>\n' +
    '                  <input class="form-control t-a-r h-45" maxlength="3"\n' +
    '                         name="maturityInMonths"\n' +
    '                         ng-show="termDeposit.durationReadonly"\n' +
    '                         ng-value="termDeposit.model.maturityInMonths"\n' +
    '                         readonly/>\n' +
    '                  <label class="ntd-form-label compact pull-right"\n' +
    '                         translate="termDeposit.durationInMonths">\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '                <div class="col-md-12 col-xs-12 p-0">\n' +
    '\n' +
    '                <span class="c-red"\n' +
    '                      ng-show="termDeposit.depositTypeGroup == 1 &&\n' +
    '                                termDeposit.termDepositForm.maturityInDays.$error.duration &&\n' +
    '                                (termDeposit.termDepositForm.maturityInDays.$dirty || termDeposit.termDepositForm.maturityInMonths.$dirty) &&\n' +
    '                                termDeposit.termDepositDurationMessageShown">\n' +
    '                      <span translate="termDeposit.wrongDepositDuration"></span>\n' +
    '                </span>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="termDeposit.depositTypeGroup == 2 &&\n' +
    '                termDeposit.termDepositForm.maturityInDays.$error.duration &&\n' +
    '                (termDeposit.termDepositForm.maturityInDays.$dirty || termDeposit.termDepositForm.maturityInMonths.$dirty) &&\n' +
    '                termDeposit.termDepositDurationMessageShown">\n' +
    '                <div><span translate="termDeposit.durationRastociDepozitMsg"></span></div>\n' +
    '                </span>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="termDeposit.depositTypeGroup == 3 &&\n' +
    '                                termDeposit.termDepositForm.maturityInDays.$error.duration &&\n' +
    '                                (termDeposit.termDepositForm.maturityInDays.$dirty || termDeposit.termDepositForm.maturityInMonths.$dirty) &&\n' +
    '                                termDeposit.termDepositDurationMessageShown">\n' +
    '                    <span translate="termDeposit.durationZlataJesenMsg"></span>\n' +
    '                </span>\n' +
    '\n' +
    '                  <!--<span class="c-red" ng-show="termDeposit.termDepositForm.maturityInMonths.$error.minvalue">-->\n' +
    '                  <!--<span translate="termDeposit.minDepDurationErr"></span>-->\n' +
    '                  <!--{{termDeposit.minDurationInDays}}-->\n' +
    '                  <!--<span translate="termDeposit.days"></span>-->\n' +
    '                  <!--</span>-->\n' +
    '                  <!--<span class="c-red" ng-show="termDeposit.termDepositForm.maturityInMonths.$error.maxvalue">-->\n' +
    '                  <!--<span translate="termDeposit.maxDepDurationErr"></span>-->\n' +
    '                  <!--{{termDeposit.maxDurationInDays}}-->\n' +
    '                  <!--<span translate="termDeposit.days"></span>-->\n' +
    '                  <!--</span>-->\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-sm-6 col-xs-12">\n' +
    '                <label class="ntd-form-label compact"\n' +
    '                       translate="termDeposit.maturityDate">\n' +
    '                </label>\n' +
    '                <div class="input-group">\n' +
    '                  <input type="text" class="form-control t-a-r h-45"\n' +
    '                         name="maturityDate"\n' +
    '                         ng-model="termDeposit.model.maturityDate"\n' +
    '                         uib-datepicker-popup="shortDate"\n' +
    '                         datepicker-options="termDeposit.dateOptions"\n' +
    '                         show-weeks="false" date-disabled="termDeposit.disabled(date, mode)"\n' +
    '                         is-open="termDeposit.isDatepickerOpen"\n' +
    '                         ng-change="termDeposit.calculateMaturityDays(termDeposit.model.maturityDate)"\n' +
    '                         readonly>\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <button data-ng-click="termDeposit.isDatepickerOpen = !termDeposit.isDatepickerOpen" type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                            style="border:1px solid #062a42;">\n' +
    '                      <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '\n' +
    '                <span class="c-red"\n' +
    '                      ng-show="termDeposit.termDepositForm.$error.dateDisabled">\n' +
    '                  <span translate="orders.maturityDateNonWorkingErr"></span>\n' +
    '              </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="form-group clearfix m-t-10">\n' +
    '              <div class="col-md-6 col-xs-12">\n' +
    '                <label class="ntd-form-label compact" translate="termDeposit.amountInputLabel"></label>\n' +
    '                <div class="input-group">\n' +
    '                  <input required type="text" class="form-control h-45 t-a-r"\n' +
    '                         name="amount"\n' +
    '                         amount-input-mask\n' +
    '                         placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00"\n' +
    '                         maxlength="14" max-amount="99999999999.99"\n' +
    '                         ng-model="termDeposit.model.amount"\n' +
    '                         ng-blur="termDeposit.amountChanged(termDeposit.model.amount)"\n' +
    '                         required/>\n' +
    '                  <span class="input-group-btn">\n' +
    '                      <!--<select type="button"-->\n' +
    '                    <!--class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero p-5"-->\n' +
    '                    <!--style="border:1px solid #062a42;"-->\n' +
    '                    <!--ng-model="termDeposit.model.currency"-->\n' +
    '                    <!--ng-options="item.symbol as item.symbol for item in termDeposit.currenciesList">-->\n' +
    '                    <!--</select>-->\n' +
    '                      <button\n' +
    '                        class="btn btn-default input-group-app-btn dark-border domp-btn-height disabled z-zero p-5"\n' +
    '                        style="pointer-events: none; border: 1px solid">\n' +
    '                        {{termDeposit.model.currency}}\n' +
    '                      </button>\n' +
    '                    </span>\n' +
    '                </div>\n' +
    '                <div>\n' +
    '                  <span class="c-red"\n' +
    '                        ng-show="termDeposit.termDepositForm.amount.$invalid && termDeposit.termDepositForm.maturityInDays.$valid">\n' +
    '                        <!--<span translate="termDeposit.wrongDepositAmount"></span>-->\n' +
    '                        <span class="c-red"\n' +
    '                              ng-show="\n' +
    '                              termDeposit.termDepositForm.amount.$touched &&\n' +
    '                              termDeposit.termDepositForm.amount.$error.minamount &&\n' +
    '                              termDeposit.termDepositForm.maturityInDays.$valid">\n' +
    '                            <span translate="termDeposit.wrongMinDepositAmount"></span>\n' +
    '                            {{termDeposit.model.depositType.minAmount | currency: ""}} {{termDeposit.model.currency}}.\n' +
    '                        </span>\n' +
    '                        <span class="c-red"\n' +
    '                              ng-show="termDeposit.termDepositForm.amount.$error.maxAmount && termDeposit.termDepositForm.maturityInDays.$valid">\n' +
    '                            <span translate="termDeposit.wrongMaxDepositAmount"></span>\n' +
    '                            {{ 99999999999.99 | currency: ""}} {{termDeposit.model.currency}}.\n' +
    '                        </span>\n' +
    '                  </span>\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-md-6 col-xs-12">\n' +
    '                <label class="ntd-form-label compact"\n' +
    '                       translate="termDeposit.totalInterestRateInputLabel">\n' +
    '                </label>\n' +
    '                <input type="text" class="form-control t-a-r  h-45" readonly\n' +
    '                       ng-value="(termDeposit.model.totalInterestRate | currency:\'\') + \' %\'">\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-7 col-xs-md-12 col-md-offset-5 col-xs-offset-0 ">\n' +
    '            <div ng-if="termDeposit.assignmentOfInterestisShown" class="form-group col-md-6 col-xs-12">\n' +
    '              <label class="ntd-form-label compact"\n' +
    '                     translate="termDeposit.assignmentOfInterest">\n' +
    '              </label>\n' +
    '              <select class="form-control h-45"\n' +
    '                      ng-options="option.id as option.value | translate for option in termDeposit.assignmentOfInterestOptions"\n' +
    '                      ng-model="termDeposit.assignmentOfInterestId"\n' +
    '                      style="cursor: auto !important"\n' +
    '                      ng-disabled="termDeposit.assignemntOfInterestIsDisabled || termDeposit.depositTypeGroup == 2">\n' +
    '              </select>\n' +
    '            </div>\n' +
    '            <div class="form-group col-md-6 col-xs-12">\n' +
    '              <label class="ntd-form-label compact"\n' +
    '                     translate="termDeposit.interestPayout">\n' +
    '              </label>\n' +
    '              <select class="form-control h-45"\n' +
    '                      ng-model="termDeposit.model.interestPayout"\n' +
    '                      ng-options="option as option.value | translate for option in termDeposit.interestPayoutOptions"\n' +
    '                      ng-change="termDeposit.onInterestPayoutChange(termDeposit.model.interestPayout.id)"\n' +
    '                      ng-disabled="termDeposit.interestPayoutDisabled || termDeposit.depositTypeGroup == 2"\n' +
    '                      style="cursor: auto !important"\n' +
    '                      required>\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-12">\n' +
    '            <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '              <input id="userApproves" type="checkbox" ng-model="termDeposit.userApproves" required>\n' +
    '              <i class="input-helper"></i>\n' +
    '              <a translate="termDeposit.termsAndConditions"></a>\n' +
    '              <!--<a ng-class="{\'underline\': termDeposit.model.depositType.periodType}"-->\n' +
    '                 <!--ng-href="{{termDeposit.model.depositType.depositTermsAndConditionsLink}}" target="_blank"-->\n' +
    '                 <!--translate="termDeposit.termsAndConditions1"></a>  -->\n' +
    '              <a class="underline"\n' +
    '                 href="\n' +
    '                 {{(termDeposit.depositGroup[0].group == 2) ? \'https://www.addiko.si/sites/addiko.si/files/content/file/file_download/si_splosni_pogoji_obcani_rastoci_depozit_2.pdf\' :\n' +
    '                   (termDeposit.depositGroup[0].group == 1 || termDeposit.depositGroup[0].group == 3) ? \'https://www.addiko.si/sites/addiko.si/files/content/file/file_download/si_splosni_pogoji_obcani_depoziti_2_0.pdf\' :\n' +
    '                  \'\'\n' +
    '                  }}"\n' +
    '                 target="_blank"\n' +
    '                 translate="termDeposit.termsAndConditions1"></a>\n' +
    '              <!--<span ng-if="termDeposit.depositGroup[0].group == 3" translate="termDeposit.termsAndConditions1"></span>-->\n' +
    '              <a translate="termDeposit.termsAndConditions2"></a>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!--<div class="row m-t-10" ng-if="termDeposit.confirmChangedMaturityDateShow">-->\n' +
    '        <!--<div class="col-md-12">-->\n' +
    '        <!--<label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">-->\n' +
    '        <!--<input id="userApproves" type="checkbox" ng-model="termDeposit.userApprovesMaturityChange" required>-->\n' +
    '        <!--<i class="input-helper"></i><a translate="orders.maturityDateChangedConfirm"></a>-->\n' +
    '        <!--</label>-->\n' +
    '        <!--</div>-->\n' +
    '        <!--</div>-->\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="intp-form-container bottom-border">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-6 t-a-l">\n' +
    '            <button class="btn btn-primary"\n' +
    '                    translate="termDeposit.cancelBtnLabel"\n' +
    '                    data-ui-sref="depositAccountsOverview">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 t-a-r">\n' +
    '            <button class="btn btn-default"\n' +
    '                    translate="orders.next"\n' +
    '                    ng-click="termDeposit.next();"\n' +
    '                    ng-disabled="termDeposit.nextButtonPressed || (termDeposit.termDepositForm.$invalid || !termDeposit.userApproves || !termDeposit.model.depositType)">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ====  STEP 2 ==== -->\n' +
    '    <!-- ================= -->\n' +
    '    <div class="clearfix bg-white" ng-if="termDeposit.steps.step2">\n' +
    '      <div class="intp-form-container bottom-border">\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.vrstaDepozita"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.responseModel.depositType.typeName}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.debitAccountSelectLabel"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.responseModel.fromAccountSelect.iban | formatIban}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.maturityDate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.responseModel.maturityDate | date: \'shortDate\'}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.termDepositDuration"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.model.maturityInDays}} <label translate="termDeposit.durationInDays"></label>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.amountInputLabel"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.responseModel.amount | currency:""}} {{termDeposit.responseModel.currency}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.totalInterestRateInputLabel"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.model.totalInterestRate | currency:""}} %\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.assignmentOfInterest"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.model.interestRange.value | translate}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.interestPayout"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{termDeposit.model.interestPayout.value | translate }}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="intp-form-container">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-6 t-a-l">\n' +
    '            <button class="btn btn-primary"\n' +
    '                    translate="orders.back"\n' +
    '                    ng-click="termDeposit.back()">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 t-a-r">\n' +
    '            <button class="btn btn-default"\n' +
    '                    translate="termDeposit.confirmBtnLabel"\n' +
    '                    ng-disabled="termDeposit.confirmButtonPressed"\n' +
    '                    ng-click="termDeposit.confirm();">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ====  STEP 3 ==== -->\n' +
    '    <!-- ================= -->\n' +
    '    <div ng-if="termDeposit.steps.step3">\n' +
    '      <div class="payment-successful-wrapper">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '            <div class="currency-check-icon msg-pad">\n' +
    '              <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-10 m-t-30 m-b-30">\n' +
    '            <h2 class="c-white f-28" translate="orders.successOrder"></h2>\n' +
    '            <!--<div class="f-16">-->\n' +
    '            <!--<span translate="eInvoicesSubscribe.applicationCompleteText" translate-values="vm.issuer"></span>-->\n' +
    '            <!--</div>-->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <a href="" data-ng-click="termDeposit.newTermDeposit()">\n' +
    '            <span class="money-exchange-icon"><i class="icon icon-einvoice zmdi-hc-2x"></i></span>\n' +
    '            <span class="f-18 money-exchange-text" translate="termDeposit.newDepositOrder"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ====  TIMELINE ==== -->\n' +
    '    <!-- ================= -->\n' +
    '    <div class="m-t-30" ng-if="!termDeposit.steps.step2 && !termDeposit.steps.step3" ng-show="termDeposit.steps.step1"\n' +
    '         data-ng-include="\'orders/deposit-overview-timeline.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/term-deposit-resume.tpl.html',
    '<div class="intp-form-container light-bcg bottom-border">\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-4">\n' +
    '          <label class="domp-form-label-review" translate="termDeposit.debitAccountSelectLabel"></label>\n' +
    '        </div>\n' +
    '      <div class="col-sm-8 domp-form-label-resume">\n' +
    '            {{termDeposit.tempTermDepositObj.fromAccountSelect.friendlyName}} <br/> {{termDeposit.tempTermDepositObj.fromAccountSelect.iban}}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div class="intp-form-container bottom-border">\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-4">\n' +
    '          <label class="domp-form-label-review" translate="termDeposit.amountInputLabel"></label>\n' +
    '        </div>\n' +
    '      <div class="col-sm-8 domp-form-label-resume">\n' +
    '            {{termDeposit.insertDepositOrderResponse.amount | number:2}} {{termDeposit.tempTermDepositObj.fromAccountSelect.currencySymbol}}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-4">\n' +
    '          <label class="domp-form-label-review" translate="termDeposit.stimulativeInterestRateInputLabel"></label>\n' +
    '        </div>\n' +
    '      <div class="col-sm-8 domp-form-label-resume">\n' +
    '            {{termDeposit.tempTermDepositObj.stimulativeInterestRate}} %\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-4">\n' +
    '          <label class="domp-form-label-review" translate="termDeposit.totalInterestRateInputLabel"></label>\n' +
    '        </div>\n' +
    '      <div class="col-sm-8 domp-form-label-resume">\n' +
    '            {{termDeposit.tempTermDepositObj.totalInterestRate}} %\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-4">\n' +
    '          <label class="domp-form-label-review" translate="termDeposit.maturityInMonthsSelectLabel"></label>\n' +
    '        </div>\n' +
    '      <div class="col-sm-8 domp-form-label-resume">\n' +
    '            {{termDeposit.tempTermDepositObj.maturityInMonths.periodFrom}}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div class="intp-form-container light-bcg bottom-border">\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-4">\n' +
    '          <label class="domp-form-label-review" translate="termDeposit.interestRatePayoutTypeSelectLabel"></label>\n' +
    '        </div>\n' +
    '      <div class="col-sm-8 domp-form-label-resume">\n' +
    '            {{termDeposit.selectedTermDepositPayoutType.description|translate}}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <div class="m-t-20 t-a-r">\n' +
    '                <button ng-if="vm.contryCode != \'sl\'" class="btn btn-primary m-r-5" ng-click="termDeposit.editAction()" translate="termDeposit.editActionLabel">Edit</button>\n' +
    '                <button class="btn btn-primary m-r-30" ng-click="termDeposit.cancelAction()" translate="termDeposit.cancelActionLabel">Cancel</button>\n' +
    '                <button class="btn btn-default" ng-click="termDeposit.signAction()" translate="termDeposit.signActionLabel">Sign</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/term-deposit-other.tpl.html',
    '<section id="main" ng-controller="TermDepositCtrlOther as termDeposit">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row f-14">\n' +
    '\n' +
    '            <div class="col-sm-12">\n' +
    '                <div class="app-white-card m-b-15">\n' +
    '                    <div class="intp-header-wrapper bottom-border" ng-show="!termDeposit.steps.step3">\n' +
    '                        <div class="row intp-header-row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                                <h2 class="title-style" translate="termDeposit.termDepositHeader"></h2>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div ng-show="termDeposit.steps.step1">\n' +
    '                        <form name="termDepositForm" novalidate>\n' +
    '                            <div class="intp-form-container bottom-border">\n' +
    '                                <div class="row">\n' +
    '                                    <div class="col-sm-6 p-0">\n' +
    '                                        <div class="col-sm-12">\n' +
    '                                            <label class="ntd-form-label m-b-5" translate="termDeposit.debitAccountSelectLabel"></label>\n' +
    '                                        </div>\n' +
    '                                        <div class="col-sm-12" >\n' +
    '\n' +
    '                                            <div class="accounts-dropdown m-b-10" ng-if="termDeposit.accountsFrom.length > 0">\n' +
    '                                                <!--<div class="debit-account-widget dashboard-widget-item bc-size-10" data-ng-click="termDeposit.toggleFromAccount();">\n' +
    '                                                    <h4 class="no-wrap-text bold-font">\n' +
    '                                                        {{termDeposit.tempTermDepositObj.fromAccountSelect.friendlyName}}\n' +
    '                                                        <span class="favorite-star-container">\n' +
    '                                                            <i class="zmdi "\n' +
    '                                                               ng-class="{\'zmdi-star favorite-account\':termDeposit.tempTermDepositObj.fromAccountSelect.isFavorite,\n' +
    '                                                                         \'zmdi-star-outline\':!termDeposit.tempTermDepositObj.fromAccountSelect.isFavorite}"></i>\n' +
    '                                                        </span>\n' +
    '                                                    </h4>\n' +
    '                                                    <p class="no-bottom-margin">{{termDeposit.tempTermDepositObj.fromAccountSelect.iban}}</p>\n' +
    '                                                    <p class="m-b-0 bold-font f-18">\n' +
    '                                                        {{termDeposit.tempTermDepositObj.fromAccountSelect.availableBalance | number:2}} {{termDeposit.tempTermDepositObj.fromAccountSelect.currencySymbol}}\n' +
    '                                                    </p>\n' +
    '                                                    <span class="d-block m-b-9" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                    <span class="caret-icon">\n' +
    '                                                        <i class="zmdi zmdi-caret-down zmdi-hc-2x"></i>\n' +
    '                                                    </span>\n' +
    '                                                </div>\n' +
    '                                                <div class="accounts-list m-l-15 m-r-15" style="border:1px solid black;" ng-show="termDeposit.fromAccountDropdown" scrollable>\n' +
    '                                                    <div class="accounts-list-item" data-ng-repeat="item in termDeposit.accountsFrom" data-ng-click="termDeposit.setAccountFrom(item);">\n' +
    '                                                        <span class="d-block f-16 bold-font">{{item.friendlyName}}</span>\n' +
    '                                                        <span class="d-block">{{item.iban}}</span>\n' +
    '                                                        <span class="d-block bold-font f-18">{{item.availableBalance | number:2}} {{item.currencySymbol}}</span>\n' +
    '                                                        <span class="d-block" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                    </div>\n' +
    '                                                </div>-->\n' +
    '\n' +
    '\n' +
    '                                                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="termDeposit.toggleFromAccount();"  ng-style="termDeposit.tempTermDepositObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + termDeposit.tempTermDepositObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{termDeposit.tempTermDepositObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                                                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':termDeposit.tempTermDepositObj.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!termDeposit.tempTermDepositObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                                                    </h4>\n' +
    '                                                    <p class="m-b-0 m-t-0 iban-style">{{termDeposit.tempTermDepositObj.fromAccountSelect.iban}}</p>\n' +
    '                                                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                        {{termDeposit.tempTermDepositObj.fromAccountSelect.availableBalance | number:2}} {{termDeposit.tempTermDepositObj.fromAccountSelect.currencySymbol}}\n' +
    '                                                    </p>\n' +
    '                                                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                    <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                                                </div>\n' +
    '                                                <div class="from-accounts-list m-l-15" ng-show="termDeposit.fromAccountDropdown" scrollable>\n' +
    '                                                    <div class="accounts-list-item p-0" data-ng-repeat="item in termDeposit.accountsFrom" data-ng-click="termDeposit.setAccountFrom(item);">\n' +
    '\n' +
    '                                                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                                            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                                                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                                                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                                            </h4>\n' +
    '                                                            <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                                                            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                                {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                                                            </p>\n' +
    '                                                            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                        </div>\n' +
    '\n' +
    '                                                    </div>\n' +
    '                                                </div>\n' +
    '\n' +
    '                                            </div>\n' +
    '\n' +
    '                                            <div class="accounts-dropdown m-b-10" ng-if="!termDeposit.accountsFrom.length || termDeposit.accountsFrom.length === 0">\n' +
    '                                                <!--<div class="debit-account-widget dashboard-widget-item" style="height: 114px; line-height: 114px" translate="internalTransfer.noData"  ng-style="termDeposit.tempTermDepositObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + termDeposit.tempTermDepositObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                                    No available accounts\n' +
    '                                                </div>-->\n' +
    '                                              <div class="debit-account-widget dashboard-widget-item" style="height: 141px;"\n' +
    '                                                   ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                                <div class="m-t-30 m-b-30">\n' +
    '                                                  <p translate="internalTransfer.nodata"></p>\n' +
    '                                                </div>\n' +
    '                                              </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                    <div class="col-sm-6 p-0">\n' +
    '                                        <div class="col-xs-12">\n' +
    '                                            <label class="ntd-form-label m-b-5" translate="termDeposit.amountInputLabel"></label>\n' +
    '                                        </div>\n' +
    '                                        <div class="col-xs-12">\n' +
    '                                            <div class="input-group">\n' +
    '                                                <input required type="text" class="form-control h-48 t-a-r"  amount-input-mask placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" maxlength="12" ng-model="termDeposit.tempTermDepositObj.amount" ng-change="termDeposit.amountChanged(termDeposit.tempTermDepositObj.amount)">\n' +
    '                                                <span class="input-group-btn">\n' +
    '                                                    <button type="button" class="btn btn-default input-group-app-btn" disabled>{{termDeposit.tempTermDepositObj.fromAccountSelect.currencySymbol}}</button>\n' +
    '                                                    </span>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                        <div class="col-sm-4 col-xs-12 m-t-10">\n' +
    '                                            <div class="hidden-sm hidden-md hidden-lg">\n' +
    '                                                <label class="ntd-form-label compact" translate="termDeposit.maturityInMonthsSelectLabel"></label>\n' +
    '                                            </div>\n' +
    '                                            <div>\n' +
    '                                                <select ng-options="option.periodFrom for option in termDeposit.maturityInMonthsList" ng-model="termDeposit.tempTermDepositObj.maturityInMonths" class="form-control t-a-c"></select>\n' +
    '                                            </div>\n' +
    '                                            <div class="hidden-xs">\n' +
    '                                                <label class="ntd-form-label compact" translate="termDeposit.maturityInMonthsSelectLabel"></label>\n' +
    '                                            </div>\n' +
    '\n' +
    '                                        </div>\n' +
    '                                        <div class="col-sm-4 col-xs-12 m-t-10">\n' +
    '                                            <div class="hidden-sm hidden-md hidden-lg">\n' +
    '                                                <label class="ntd-form-label compact" translate="termDeposit.stimulativeInterestRateInputLabel"></label>\n' +
    '                                            </div>\n' +
    '                                            <div>\n' +
    '                                                <input type="text" class="form-control t-a-r" readonly ng-value="termDeposit.tempTermDepositObj.stimulativeInterestRate + \' %\'">\n' +
    '                                            </div>\n' +
    '                                            <div class="hidden-xs">\n' +
    '                                                <label class="ntd-form-label compact" translate="termDeposit.stimulativeInterestRateInputLabel"></label>\n' +
    '                                            </div>\n' +
    '\n' +
    '                                        </div>\n' +
    '                                        <div class="col-sm-4 col-xs-12 m-t-10">\n' +
    '                                            <div class="hidden-sm hidden-md hidden-lg">\n' +
    '                                                <label class="ntd-form-label compact" translate="termDeposit.totalInterestRateInputLabel"></label>\n' +
    '                                            </div>\n' +
    '                                            <div>\n' +
    '                                                <input type="text" class="form-control t-a-r" readonly ng-value="termDeposit.tempTermDepositObj.totalInterestRate + \' %\'">\n' +
    '                                            </div>\n' +
    '                                            <div class="hidden-xs">\n' +
    '                                                <label class="ntd-form-label compact" translate="termDeposit.totalInterestRateInputLabel"></label>\n' +
    '                                            </div>\n' +
    '\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="intp-form-container bottom-border">\n' +
    '                                <div class="row">\n' +
    '                                    <div class="col-sm-6">\n' +
    '                                        <!--<label class="ntd-form-label" translate="termDeposit.interestRatePayoutTypeSelectLabel"></label>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="col-sm-6">\n' +
    '\n' +
    '                                        <div ng-init="termDeposit.isPayoutTypeSelectionCollapsed = true">\n' +
    '                                            <button type="button" class="btn btn-default w-100 m-l-5 m-r-5" ng-click="termDeposit.isPayoutTypeSelectionCollapsed = !termDeposit.isPayoutTypeSelectionCollapsed"><span style="\n' +
    '                                                top: 5px;\n' +
    '                                                max-width: 80%;\n' +
    '                                                overflow: hidden;\n' +
    '                                                display: inline-block;\n' +
    '                                                white-space: nowrap;\n' +
    '                                                position: relative;\n' +
    '                                                text-overflow: ellipsis;\n' +
    '                                                ">{{termDeposit.selectedTermDepositPayoutType.description|translate}}</span><span class="zmdi zmdi-caret-down pull-right zmdi-hc-2x"></span></button>\n' +
    '                                            <div uib-collapse="termDeposit.isPayoutTypeSelectionCollapsed">\n' +
    '                                                <div class="">\n' +
    '                                                    <ul class="list-group">\n' +
    '                                                        <li class="list-group-item list-hover-selection" ng-repeat="payoutItem in termDeposit.termDepositPayoutTypeList">\n' +
    '                                                            <a ng-click="termDeposit.selectPayoutType(payoutItem);" href="">\n' +
    '                                                                <p class="m-b-5">{{payoutItem.description|translate}}\n' +
    '                                                                    <br>{{payoutItem.explanation|translate}}</p>\n' +
    '                                                            </a>\n' +
    '                                                        </li>\n' +
    '                                                    </ul>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="intp-form-container bottom-border">\n' +
    '                                <div class="row">\n' +
    '                                    <div class="col-sm-12">\n' +
    '                                        <label class="ntd-form-label active-link pointer" translate="termDeposit.contractDraftLinkLabel" ng-click="termDeposit.getContractDraft()"></label>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="row">\n' +
    '                                    <div class="col-sm-12">\n' +
    '                                        <div>\n' +
    '                                            <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value pointer">\n' +
    '                                                <input type="checkbox" ng-model="termDeposit.isCondition1Checked" required>\n' +
    '                                                <i class="input-helper"></i>\n' +
    '                                            </label><a class="m-l-25 pointer" ng-click="termDeposit.openConditionsLink(termDeposit.configData.DepositOrderConditionURLs.GeneralConditionURL)">{{\'termDeposit.generalConditionsLinkLabel1\' | translate}}</a>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="row">\n' +
    '                                    <div class="col-sm-12">\n' +
    '                                        <div>\n' +
    '                                            <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value pointer">\n' +
    '                                                <input type="checkbox" ng-model="termDeposit.isCondition2Checked" required>\n' +
    '                                                <i class="input-helper"></i>\n' +
    '                                            </label><a class="m-l-25 pointer" ng-click="termDeposit.openConditionsLink(termDeposit.configData.DepositOrderConditionURLs.SecureConditionURL)">{{\'termDeposit.generalConditionsLinkLabel2\' | translate}}</a>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                          <div class="intp-form-container bottom-border">\n' +
    '                            <div class="row">\n' +
    '                              <div class="col-xs-6 t-a-l">\n' +
    '                                <button type="button" class="btn btn-primary" translate="termDeposit.cancelBtnLabel"\n' +
    '                                        data-ui-sref="depositAccountsOverview">\n' +
    '                                </button>\n' +
    '                              </div>\n' +
    '                              <div class="col-xs-6 t-a-r">\n' +
    '                                <button type="button" class="btn btn-default" translate="termDeposit.confirmBtnLabel"\n' +
    '                                        ng-disabled="!termDepositForm.$valid" ng-click="termDeposit.confirmAction();">\n' +
    '                                </button>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </form>\n' +
    '                    </div>\n' +
    '                    <div ng-show="termDeposit.steps.step2">\n' +
    '                        <div data-ng-include="\'orders/term-deposit-resume.tpl.html\'">\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="row" ng-show="termDeposit.steps.step3">\n' +
    '                      <div class="exchange-rate-header m-l-25">\n' +
    '                        <div class="row">\n' +
    '                          <div class="col-sm-6 col-xs-12 f-20" translate="termDeposit.signTitle"></div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-12 m-t-30 m-b-30">\n' +
    '                          <div class="col-xs-12 m-b-20">\n' +
    '                              <span class="f-w-bold">{{\'signPayments.challengeDescription\' | translate}}</span>\n' +
    '                          </div>\n' +
    '                          <div class="col-sm-4 col-xs-12">\n' +
    '                              <span class="f-w-bold">{{\'signPayments.challengeFirstCode\' | translate}}</span>\n' +
    '                              <input type="text" class="form-control input-field" disabled data-ng-model="termDeposit.insertDepositOrderResponse.challenge">\n' +
    '                          </div>\n' +
    '                          <div class="col-sm-4 col-xs-12">\n' +
    '                              <span class="f-w-bold">{{\'signPayments.challengeSecondCode\' | translate}}</span>\n' +
    '                              <input type="text" class="form-control input-field" data-ng-model="termDeposit.challengeResponse" ng-pattern-restrict="{{termDeposit.regexPatterns.onlyNumbers}}" placeholder="{{\'signPayments.challengeSecondCode\' | translate}}" autofocus>\n' +
    '                          </div>\n' +
    '                          <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '                              <button class="btn btn-primary col-sm-8 col-xs-4 pull-right" data-ng-click="termDeposit.signConfirmAction()" ng-disabled="termDeposit.challengeResponse === \'\'"\n' +
    '                                      translate="signPayments.confirm">Confirm</button>\n' +
    '                          </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div ng-show="termDeposit.steps.step1" data-ng-include="\'orders/deposit-overview-timeline.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/savings-order-overview-timeline.tpl.html',
    '<!-- TIMELINE CONTAINER -->\n' +
    '<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <div class="row p-15">\n' +
    '    <div class="col-xs-4 dropdown acc-period-select " style="display: inline-block">\n' +
    '      <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"\n' +
    '              aria-expanded="true">\n' +
    '        {{savingsAccount.selectedPeriod.item.description | translate}}\n' +
    '        <span class="caret"></span>\n' +
    '      </button>\n' +
    '      <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '        <li data-ng-repeat="period in savingsAccount.periodList">\n' +
    '          <a href="" class="f-13" data-ng-click="savingsAccount.paymentsPeriodFilter(period)">\n' +
    '            {{period.item.description | translate}}\n' +
    '          </a>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '    </div>\n' +
    '    <div class="col-xs-8 pull-right" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <label class="checkbox checkbox-inline m-l-15 pull-right">\n' +
    '        <input type="checkbox" data-ng-model="savingsAccount.allRequests"\n' +
    '               data-ng-click="savingsAccount.loadAllAccountsTimeline()">\n' +
    '        <span class="input-helper" translate="ebook.showAllRequests">Prikaži zahtjeve za sve račune</span>\n' +
    '      </label>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- ================== -->\n' +
    '  <!-- Slovenia -->\n' +
    '  <!-- ================== -->\n' +
    '  <div ng-switch-when="sl">\n' +
    '    <div class="timeline-row col-sm-12 no-padding">\n' +
    '      <div class="t-a-c p-10 no-data-image" ng-if="savingsAccount.timelineListGrouped.result.length == 0">\n' +
    '        <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '        <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '      </div>\n' +
    '      <div class="hypo-timeline-wrapper app-white-card" ng-hide="savingsAccount.timelineListGrouped.result.length == 0">\n' +
    '        <ul class="hypo-timeline" kcd-recompile="savingsAccount.timelineListGrouped">\n' +
    '          <li ng-class="{\'time-label\': term.isVirtual}" ng-repeat="term in savingsAccount.timelineListGrouped.result">\n' +
    '          <span class="currency-time-frame"\n' +
    '                ng-if="term.isVirtual === true">{{(term.valueDate) | date:\'shortDate\'}}</span>\n' +
    '            <i class="zmdi zmdi-timer z-index-1" ng-if="!term.isVirtual"></i>\n' +
    '            <div ng-if="!term.isVirtual" class="hypo-timeline-item payment-item"\n' +
    '                 ng-click="savingsAccount.showOrderDetails(term)" ng-class="{\'opened\': term.selected}">\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-xs-8 hidden-xs">\n' +
    '                  <h4 class="m-b-0 m-t-10 c-gray">\n' +
    '                    <b translate="savingsOrder.newSavingsOrderTimelineTitle"></b><b>,</b>\n' +
    '                    <b>{{\'termDeposit.request\' | translate}}</b>\n' +
    '                    <b>{{term.id}}<span ng-if="term.durationInMonths != 0">, {{term.durationInMonths}} {{ \'termDeposit.month\' | translate }}</span></b>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-xs-8 visible-xs p-l-0">\n' +
    '                  <h4 class="m-b-0 m-t-10 f-12 c-gray">\n' +
    '                    <b translate="savingsOrder.newSavingsOrderTimelineTitle"></b><b>,</b>\n' +
    '                    <b>{{\'termDeposit.request\' | translate}}</b>\n' +
    '                    <b>{{term.id}}, {{term.durationInMonths}} {{ \'termDeposit.month\' | translate }}</b>\n' +
    '\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '                <!-- Other term types -->\n' +
    '                <div class="col-xs-4 hidden-xs">\n' +
    '                            <span class="pull-right t-a-r m-t-5 f-18">\n' +
    '                            <span  ng-if="term.firstDepositAmount"><b>{{term.firstDepositAmount|currency:""}} {{::term.currency}}</b><br/></span>\n' +
    '                            <span ng-if="term.monthlyDepositAmount"><b>{{term.monthlyDepositAmount|currency:""}} {{::term.currency}}</b><br/></span>\n' +
    '                            <span>{{term.translatedStatus | translate}}</span>\n' +
    '                            </span>\n' +
    '                </div>\n' +
    '                <div class="col-xs-4 visible-xs p-r-0">\n' +
    '                            <span class="pull-right t-a-r m-t-5 f-12">\n' +
    '                            <span ng-if="term.firstDepositAmount"><b >{{term.firstDepositAmount|currency:""}} {{::term.currency}}</b><br/></span>\n' +
    '                            <span ng-if="term.monthlyDepositAmount"><b>{{term.monthlyDepositAmount|currency:""}} {{::term.currency}}</b><br/></span>\n' +
    '                            <span>{{term.translatedStatus | translate}}</span>\n' +
    '                            </span>\n' +
    '                </div>\n' +
    '                <div class="clear"></div>\n' +
    '              </div>\n' +
    '\n' +
    '              <!-- ========= -->\n' +
    '              <!-- DETAILS -->\n' +
    '              <!-- ========= -->\n' +
    '              <div ng-if="term.selected" class="transaction-details">\n' +
    '\n' +
    '                <div class="table-responsive hidden-xs">\n' +
    '                  <table class="table table-transparent">\n' +
    '                    <tbody>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.dateOfEntry"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label"> {{ term.savingEnteredDate | date: \'shortDate\' }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr ng-if="term.endDate">\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.executionDate"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label"> {{ term.endDate | date: \'shortDate\' }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.savingOrderName"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label"> {{ term.savingPurpose }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.savingsCurrency"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label">{{ term.savingCurrencyType }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.fromAccount"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label"> {{ term.sourceAccount }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <!--<span class="po-desc-label" translate="savingsOrder.initialAmount"></span>-->\n' +
    '                        <span class="po-desc-label" ng-if="term.firstDepositAmount"\n' +
    '                              translate="savingsOrder.initialDepositAmount"></span>\n' +
    '                        <span class="po-desc-label" ng-if="term.monthlyDepositAmount"\n' +
    '                              translate="savingsOrder.monthlyDepositAmount"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label" ng-if="term.firstDepositAmount">{{term.firstDepositAmount|currency:""}}</span>\n' +
    '                        <span class="po-value-label" ng-if="term.monthlyDepositAmount">{{term.monthlyDepositAmount|currency:""}}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.currency"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label"> {{ term.currency }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr  ng-if="term.hasOwnProperty(\'savingRate\')">\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.realInterestRate"></span>\n' +
    '                      </td>\n' +
    '                      <td >\n' +
    '                        <span class="po-value-label">\n' +
    '                          {{ term.savingRate }} %</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr ng-if="term.hasOwnProperty(\'referenceSavingRate\')">\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.referenceInterestRate"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label">\n' +
    '                          {{ term.referenceSavingRate }} %</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label" translate="savingsOrder.dateOfOpening"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label"> {{ term.savingEnteredDate | date: \'shortDate\' }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '\n' +
    '                    <tr ng-if="term.durationInMonths >= 1">\n' +
    '                      <td><span class="po-desc-label" translate="accounts.annualAssignmentOfInterests"></span></td>\n' +
    '                      <td><span class="po-value-label" translate="alert.yes"></span></td>\n' +
    '                    </tr>\n' +
    '\n' +
    '                    <div\n' +
    '                      ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && term.allowedActionList.itemList.length">\n' +
    '                      <tr ng-repeat-start="item in term.allowedActionList.itemList"\n' +
    '                          ng-if="item.methodName === \'DownloadLinkAllowed\'">\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="depositDetails.contract"></span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                        <span class="po-value-label">\n' +
    '                          <button class="btn btn-default" ng-click="savingsAccount.downloadContract(term.id)"\n' +
    '                                  translate="messages.downloadAttachment">Download</button>\n' +
    '                        </span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '\n' +
    '                      <tr ng-repeat-end ng-if="item.methodName === \'DownloadTermsLinkAllowed\'">\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="depositDetails.termsAndConditions"></span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">\n' +
    '                            <button class="btn btn-default"\n' +
    '                                    ng-click="savingsAccount.downloadTermsAndConditions(term.id)"\n' +
    '                                    translate="messages.downloadAttachment">Download</button>\n' +
    '                          </span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                    </div>\n' +
    '\n' +
    '                    </tbody>\n' +
    '                  </table>\n' +
    '                </div>\n' +
    '                <!-- ========= -->\n' +
    '                <!-- MOBILE -->\n' +
    '                <!-- ========= -->\n' +
    '                <div class="table-responsive visible-xs">\n' +
    '                  <table class="table table-transparent f-10">\n' +
    '                    <tbody>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.dateOfEntry"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.savingEnteredDate | date: \'shortDate\' }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr ng-if="term.endDate">\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.executionDate"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.endDate | date: \'shortDate\' }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.savingOrderName"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.savingPurpose }} </span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.savingsCurrency"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs">{{ term.savingCurrencyType }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.fromAccount"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.sourceAccount }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <!--<span class="po-desc-label-xs" translate="savingsOrder.initialAmount"></span>-->\n' +
    '                        <span class="po-desc-label-xs" ng-if="term.firstDepositAmount"\n' +
    '                              translate="savingsOrder.initialDepositAmount"></span>\n' +
    '                        <span class="po-desc-label-xs" ng-if="term.monthlyDepositAmount"\n' +
    '                              translate="savingsOrder.monthlyDepositAmount"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs" ng-if="term.firstDepositAmount">{{term.firstDepositAmount|currency:""}}</span>\n' +
    '                        <span class="po-value-label-xs" ng-if="term.monthlyDepositAmount">{{term.monthlyDepositAmount|currency:""}}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.currency"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.currency }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr ng-if="term.hasOwnProperty(\'savingRate\')">\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.realInterestRate"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.savingRate }} %</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr ng-if="term.hasOwnProperty(\'referenceSavingRate\')">\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.referenceInterestRate"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.referenceSavingRate }} %</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr>\n' +
    '                      <td>\n' +
    '                        <span class="po-desc-label-xs" translate="savingsOrder.dateOfOpening"></span>\n' +
    '                      </td>\n' +
    '                      <td>\n' +
    '                        <span class="po-value-label-xs"> {{ term.savingEnteredDate | date: \'shortDate\' }}</span>\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                    <tr ng-if="term.durationInMonths >= 1">\n' +
    '                      <td><span class="po-desc-label" translate="accounts.annualAssignmentOfInterests"></span></td>\n' +
    '                      <td><span class="po-value-label" translate="alert.yes"></span></td>\n' +
    '                    </tr>\n' +
    '                    <div\n' +
    '                      ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && term.allowedActionList.itemList.length">\n' +
    '                      <tr ng-repeat-start="item in term.allowedActionList.itemList"\n' +
    '                          ng-if="item.methodName === \'DownloadLinkAllowed\'">\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label-xs" translate="depositDetails.contract"></span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                        <span class="po-value-label-xs">\n' +
    '                          <button class="btn btn-default" ng-click="savingsAccount.downloadContract(term.id)"\n' +
    '                                  translate="messages.downloadAttachment">Download</button>\n' +
    '                        </span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '\n' +
    '                      <tr ng-repeat-end ng-if="item.methodName === \'DownloadTermsLinkAllowed\'">\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label-xs" translate="depositDetails.termsAndConditions"></span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label-xs">\n' +
    '                            <button class="btn btn-default"\n' +
    '                                    ng-click="savingsAccount.downloadTermsAndConditions(term.id)"\n' +
    '                                    translate="messages.downloadAttachment">Download</button>\n' +
    '                          </span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                    </div>\n' +
    '                    </tbody>\n' +
    '                  </table>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '      <div class="show-more-btn ">\n' +
    '        <button ng-if="savingsAccount.timelineListGrouped.hasMore"\n' +
    '                data-ng-click="savingsAccount.loadMoreTimelineItemsGrouped()"\n' +
    '                type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                translate="dashboard.loadEvents">Load older events\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- END TIMELINE -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/orders.tpl.html',
    '<div>\n' +
    '  <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '       ng-include="\'orders/orders-other.tpl.html\'">\n' +
    '  </div>\n' +
    '  <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '       ng-include="\'orders/orders-slo.tpl.html\'">\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/orders-slo.tpl.html',
    '<section id="main" ng-controller="OrdersSloCtrl as vm">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="domp-header-wrapper" ng-hide="vm.step === \'complete\'">\n' +
    '      <div class="domp-header-row">\n' +
    '        <h2 class="f-28" ng-if="vm.step === \'order\'" translate="orders.title"></h2>\n' +
    '        <span ng-if="vm.step === \'confirm\'">\n' +
    '            <h2 ng-if="vm.authorisationTypeId == 1" class="f-28" translate="orders.permanentAthorisation"></h2>\n' +
    '            <h2 ng-if="vm.authorisationTypeId == 0" class="f-28" translate="orders.cancelAuthorisation"></h2>\n' +
    '        </span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================  -->\n' +
    '    <!-- START: First step -->\n' +
    '    <!-- ================  -->\n' +
    '    <div ng-if="vm.step === \'order\'">\n' +
    '      <!-- START: Poblastilo select -->\n' +
    '      <div class="row p-l-15 p-r-15 m-b-20">\n' +
    '        <select class="form-control input-field p-l-15 p-r-10" name="orderSelect" id="orderSelect"\n' +
    '                ng-model="vm.authorisationTypeId"\n' +
    '                ng-options="option.id as option.description | translate for option in vm.authorizationTypeOptions"\n' +
    '                ng-change="vm.onAuthorisationTypeChange()">\n' +
    '        </select>\n' +
    '      </div>\n' +
    '      <!-- END: Poblastilo select -->\n' +
    '\n' +
    '      <!-- START: Note -->\n' +
    '      <div class="row" ng-if="vm.authorisationTypeId == 1">\n' +
    '        <div class="col-md-12">\n' +
    '          <div class="alert alert-info " style="background: white; color: black; border: 1px solid lightgray">\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-12"></div>\n' +
    '              <div class="row">\n' +
    '                <div class="col-xs-12">\n' +
    '                  <span translate="orders.note1Slo"></span>\n' +
    '                  <a href="https://www.addiko.si/ceniki" target="_blank" class="underline"><span\n' +
    '                    translate="orders.note2SloLink"></span></a>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END: Note -->\n' +
    '\n' +
    '      <form novalidate name="vm.orderForm">\n' +
    '        <!-- START: Select order type -->\n' +
    '        <div class="row p-l-15 p-r-15">\n' +
    '          <select class="form-control input-field p-l-15 p-r-10" name="orderSelect" id="orderSelect"\n' +
    '                  ng-model="vm.orderType" ng-change="vm.setOrderType()"\n' +
    '                  ng-options="\'orders.types.\'+orderType.typeId | translate for orderType in vm.orderTypes track by orderType.typeId">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '        <!-- END: Select order type -->\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <div class="container domp-from-section">\n' +
    '              <div class="row p-15">\n' +
    '                <!-- CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '                <div class="col-sm-6 domp-acc-dropdown">\n' +
    '                  <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '\n' +
    '                  <div class="accounts-dropdown">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                         data-ng-click="vm.fromAccountDropdown = !vm.fromAccountDropdown"\n' +
    '                         ng-style="vm.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + vm.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                          {{vm.fromAccountSelect.friendlyName}} </b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                          <i class="zmdi" ng-class="{\n' +
    '                              \'zmdi-star favorite-account\'\n' +
    '                                :account.isFavorite, \'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                        </span>\n' +
    '                      </h4>\n' +
    '                      <p ng-if="vm.countryCode == \'sl\'" class="m-b-0 m-t-0 iban-style">{{vm.fromAccountSelect.iban |\n' +
    '                        formatIban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{vm.fromAccountSelect.availableBalance | currency: ""}} {{vm.fromAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      <span class="caret-icon">\n' +
    '                        <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <div class="from-accounts-list m-l-0" ng-show="vm.fromAccountDropdown" scrollable>\n' +
    '                      <div class="accounts-list-item p-0"\n' +
    '                           data-ng-repeat="item in vm.accountList"\n' +
    '                           data-ng-click="vm.setAccountFrom(item);">\n' +
    '                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                             ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                          <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                                ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                          </h4>\n' +
    '                          <p ng-if="vm.countryCode == \'sl\'" class="m-b-0 m-t-0 iban-style">{{item.iban |\n' +
    '                            formatIban}}</p>\n' +
    '                          <span class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">{{item.availableBalance | currency: ""}} {{item.currencySymbol}}</span>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="col-sm-6">\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-12">\n' +
    '                      <div class="form-group">\n' +
    '                        <label class="domp-form-label-review" for="amountInput"\n' +
    '                               translate="domesticPayment.amountInputLabel"></label>\n' +
    '                        <div class="input-group">\n' +
    '\n' +
    '                          <input ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" max-amount="999999999.99"\n' +
    '                                 type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                                 placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask\n' +
    '                                 maxlength="12" ng-model="vm.amountInput" required\n' +
    '                                 ng-class="{\'domp-error\': vm.orderForm.amountInput.$invalid && vm.formSubmitted}"\n' +
    '                                 ng-maxlength="12"/>\n' +
    '                          <span class="input-group-btn">\n' +
    '                            <button type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                                    ng-if="vm.countryCode != \'sr\'" style="border:1px solid #062a42;">\n' +
    '                              {{vm.defaultCurrency}}\n' +
    '                            </button>\n' +
    '                          </span>\n' +
    '                        </div>\n' +
    '                        <span class="c-red"\n' +
    '                              ng-show="vm.orderForm.amountInput.$error.maxAmount && vm.formSubmitted">\n' +
    '                            <span translate="termDeposit.wrongMaxDepositAmount"></span>\n' +
    '                            {{ 999999999.99 | currency: ""}} {{termDeposit.model.currency}}.\n' +
    '                        </span>\n' +
    '                        <span class="c-red" ng-if="vm.orderForm.amountInput.$error.required && vm.formSubmitted"\n' +
    '                              translate="internalTransfer.amountInputError"></span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="row" ng-if="vm.authorisationTypeId == 1">\n' +
    '                      <span class="p-t-15">\n' +
    '                      <div class="col-md-12">\n' +
    '                       <label class="domp-form-label" for="dateBegin" translate="orders.paymentDayOfEachMonth"></label>\n' +
    '                      </div>\n' +
    '                      <div class="col-xs-5">\n' +
    '                        <div class="form-group">\n' +
    '                          <select ng-model="vm.dayOfBeginning" ng-change="vm.modifyDate();"\n' +
    '                                  class="form-control input-group"\n' +
    '                                  ng-options="day.value as day.text for day in vm.dayOfBeginningSelectOptions">\n' +
    '                          </select>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                        <div class="col-xs-1 p-0">\n' +
    '                          <i class="zmdi zmdi-alert-circle-o zmdi-hc-2x p-t-5"\n' +
    '                             uib-tooltip="{{\'orders.nonWorkingDayMsg\'| translate}}" tooltip-append-to-body="true"\n' +
    '                             tooltip-trigger="mouseenter"\n' +
    '                             tooltip-placement="top"></i>\n' +
    '                        </div>\n' +
    '\n' +
    '                      </span>\n' +
    '                  </div>\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-6" ng-if="vm.authorisationTypeId == 1">\n' +
    '                      <div class="form-group m-0">\n' +
    '                        <label class="domp-form-label" for="dateBegin" translate="orders.dateBegin"></label>\n' +
    '                        <div class="input-group">\n' +
    '                          <input type="text" class="form-control input-field" name="dateBegin" id="dateBegin"\n' +
    '                                 ng-change="vm.dateOfBeginningChange()"\n' +
    '                                 show-button-bar="false"\n' +
    '                                 uib-datepicker-popup="shortDate" data-ng-model="vm.dateBegin" show-weeks="false"\n' +
    '                                 date-disabled="vm.dateDisabled(date, mode)"\n' +
    '                                 is-open="datePickerBeginOpened" datepicker-options="vm.dateOfBeginningOptions"\n' +
    '                                 ng-class="{ \'domp-error\' : vm.orderForm.dateBegin.$invalid && vm.formSubmitted}"\n' +
    '                                 required readonly>\n' +
    '                          <span class="input-group-btn">\n' +
    '                              <button data-ng-click="datePickerBeginOpened = !datePickerBeginOpened" type="button"\n' +
    '                                      class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                      style="border:1px solid #062a42;">\n' +
    '                                <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                              </button>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <span class="c-red" ng-show="vm.orderForm.dateBegin.$error.required && vm.formSubmitted"\n' +
    '                            translate="orders.dateRequired"></span>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-6">\n' +
    '                      <div class="form-group m-0">\n' +
    '                        <label class="domp-form-label" for="dateCancel" translate="orders.dateCancel"></label>\n' +
    '                        <div class="input-group date-to">\n' +
    '                          <input type="text" class="form-control input-field" name="dateCancel" id="dateCancel"\n' +
    '                                 uib-datepicker-popup="shortDate"\n' +
    '                                 data-ng-model="vm.dateCancel"\n' +
    '                                 show-weeks="false"\n' +
    '                                 is-open="datePickerEndOpened"\n' +
    '                                 date-disabled="vm.disabled(date, mode)"\n' +
    '                                 datepicker-options="vm.dateOfCancellationOptions"\n' +
    '                                 ng-class="{ \'domp-error\' : vm.orderForm.dateCancel.$invalid && vm.formSubmitted}"\n' +
    '                                 required\n' +
    '                                 readonly\n' +
    '                                 popup-placement="bottom-right"/>\n' +
    '                          <span class="input-group-btn">\n' +
    '                              <button data-ng-click="datePickerEndOpened = !datePickerEndOpened" type="button"\n' +
    '                                      class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                      style="border:1px solid #062a42;">\n' +
    '                                <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                              </button>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <span class="c-red" ng-show="vm.orderForm.dateCancel.$error.required && vm.formSubmitted"\n' +
    '                            translate="orders.dateRequired"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!--RECIPIENT IBAN  / RECIPIENT (company/name and address) START -->\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <div class="container domp-from-section">\n' +
    '              <div class="row  p-15">\n' +
    '                <div class="col-sm-6">\n' +
    '                  <label ng-if="vm.countryCode == \'sl\' && vm.orderType.typeId !== \'trr\'" class="domp-form-label"\n' +
    '                         for="beneficiaryIBAN" translate="orders.beneficiaryIBANforSavings"></label>\n' +
    '                  <label ng-if="vm.countryCode != \'sl\' || vm.orderType.typeId === \'trr\'" class="domp-form-label"\n' +
    '                         for="beneficiaryIBAN" translate="orders.beneficiaryIBAN"></label>\n' +
    '                  <input ng-if="vm.countryCode == \'sl\' && vm.orderType.typeId === \'trr\'" type="text"\n' +
    '                         class="form-control input-field"\n' +
    '                         capitalize\n' +
    '                         ui-mask="{{vm.uiMask}}"\n' +
    '                         ui-mask-placeholder\n' +
    '                         ui-mask-placeholder-char="space"\n' +
    '                         ui-options="vm.uiMaskOptions"\n' +
    '                         maxlength="34"\n' +
    '                         ng-model="vm.beneficiaryIBAN"\n' +
    '                         ng-class="{ \'domp-error\' : vm.orderForm.beneficiaryIBAN.$invalid && vm.formSubmitted}"\n' +
    '                         name="beneficiaryIBAN" id="beneficiaryIBAN"\n' +
    '                         required/>\n' +
    '\n' +
    '                  <select ng-if="vm.countryCode == \'sl\' && vm.orderType.typeId !== \'trr\'"\n' +
    '                          ng-model="vm.selectedSavingAccount"\n' +
    '                          ng-change="vm.modifyDate();"\n' +
    '                          class=" h-45 form-control input-gro1up"\n' +
    '                          ng-options="(account.iban + \' \' + account.friendlyName) for account in vm.savingAccounts">\n' +
    '                  </select>\n' +
    '\n' +
    '                  <span class="c-red" ng-show="vm.orderForm.beneficiaryIBAN.$error.required && vm.formSubmitted"\n' +
    '                        translate="domesticPayment.receiverAccountError"></span>\n' +
    '                </div>\n' +
    '                <div ng-if="vm.countryCode != \'sl\' || vm.orderType.typeId === \'trr\'" class="col-sm-6">\n' +
    '                  <label ng-if="vm.countryCode != \'sl\'" class="domp-form-label" for="beneficiaryName"\n' +
    '                         translate="orders.beneficiaryName"></label>\n' +
    '                  <label ng-if="vm.countryCode === \'sl\'" class="domp-form-label" for="beneficiaryName"\n' +
    '                         translate="domesticPayment.toPayee2"></label>\n' +
    '                  <input type="text" class="form-control input-field" name="beneficiaryName" id="beneficiaryName"\n' +
    '                         required ng-pattern-restrict="{{vm.regexPatterns.allowedCharsDPS}}"\n' +
    '                         ng-class="{ \'domp-error\' : vm.orderForm.beneficiaryName.$invalid && vm.formSubmitted}"\n' +
    '                         maxlength="{{vm.inputOptions.beneficiaryName.maxLength}}"\n' +
    '                         ng-model="vm.beneficiaryName">\n' +
    '                  <span class="c-red" ng-show="vm.orderForm.beneficiaryName.$error.required && vm.formSubmitted"\n' +
    '                        translate="orders.beneficiaryNameRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row  p-15"\n' +
    '                   ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && vm.orderType.typeId === \'trr\'">\n' +
    '                <div class="col-xs-12 col-sm-6 col-sm-offset-6">\n' +
    '                  <input type="text" class="form-control input-field" name="receviersAddress" id="receviersAddress"\n' +
    '                         required ng-pattern-restrict="{{vm.regexPatterns.allowedCharsDPS}}"\n' +
    '                         ng-class="{ \'domp-error\' : vm.orderForm.receviersAddress.$invalid && vm.formSubmitted}"\n' +
    '                         maxlength="{{vm.inputOptions.receviersAddress.maxLength}}"\n' +
    '                         ng-model="vm.receviersAddress">\n' +
    '                  <span class="c-red" ng-show="vm.orderForm.receviersAddress.$error.required && vm.formSubmitted"\n' +
    '                        translate="orders.receviersAddressRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- Show if Authorisation -->\n' +
    '        <div class="row" ng-if="vm.authorisationTypeId == 1">\n' +
    '          <div class="col-sm-12">\n' +
    '            <div class="container domp-from-section">\n' +
    '              <div class="row  p-15">\n' +
    '                <div class="col-sm-12 p-t-10">\n' +
    '                  <div class="form-group m-b-0">\n' +
    '                    <label ng-if="vm.countryCode == \'sl\'" class="domp-form-label" for="description"\n' +
    '                           translate="orders.purpose"></label>\n' +
    '                    <input type="text" class="form-control input-field" name="description" id="description" required\n' +
    '                           ng-pattern-restrict="{{vm.regexPatterns.allowedCharsDPS}}"\n' +
    '                           maxlength="{{vm.descriptionMaxLength}}"\n' +
    '                           ng-class="{ \'domp-error\' : vm.orderForm.description.$invalid && vm.formSubmitted}"\n' +
    '                           ng-model="vm.description"/>\n' +
    '                  </div>\n' +
    '                  <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"\n' +
    '                        ng-show="vm.orderForm.description.$error.required && vm.formSubmitted"\n' +
    '                        translate="orders.descriptionRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <!--<div class="row  p-15">-->\n' +
    '              <!--<div class="col-sm-6">-->\n' +
    '              <!--<span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"-->\n' +
    '              <!--ng-show="vm.orderForm.referenceNumber.$error.required && vm.formSubmitted"-->\n' +
    '              <!--translate="domesticPayment.referenceModelInputError"></span>-->\n' +
    '              <!--</div>-->\n' +
    '              <!--</div>-->\n' +
    '\n' +
    '              <div class="row p-15">\n' +
    '                <div class="col-xs-12">\n' +
    '                  <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                    <input type="checkbox"\n' +
    '                           ng-model="vm.agreedWithTerms">\n' +
    '                    <i class="input-helper"></i>\n' +
    '                    <span>{{\'orders.agreeTerms\'| translate}}\n' +
    '                    </span>\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row p-10">\n' +
    '          <div class="col-xs-6 t-a-l">\n' +
    '            <button class="btn btn-primary" type="button" translate="orders.cancel" data-ui-sref="dashboard">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 t-a-r">\n' +
    '            <button ng-if="vm.authorisationTypeId == 1" class="btn btn-default pull-right" type="submit"\n' +
    '                    ng-disabled="!vm.agreedWithTerms || vm.nextButtonPressed"\n' +
    '                    ng-click="vm.openPermanentOrder()">\n' +
    '              <span translate="domesticPayment.confirmBtnSlo"></span>\n' +
    '            </button>\n' +
    '            <button ng-if="vm.authorisationTypeId == 0" class="btn btn-default pull-right" type="submit"\n' +
    '                    ng-click="vm.validateClosePermanentOrder()">\n' +
    '              <span translate="domesticPayment.confirmBtnSlo"></span>\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '      <!-- TIMELINE CONTAINER -->\n' +
    '      <div data-ng-include="\'orders/orders-overview-timeline.tpl.html\'"></div>\n' +
    '      <!--<div ng-if="vm.authorisationTypeId == 0" data-ng-include="\'orders/closing-orders-overview-timeline.tpl.html\'"></div>-->\n' +
    '      <!-- END TIMELINE -->\n' +
    '    </div>\n' +
    '    <!-- ================  -->\n' +
    '    <!-- END: First step -->\n' +
    '    <!-- ================  -->\n' +
    '\n' +
    '    <!-- =================== -->\n' +
    '    <!-- START: Confirm step -->\n' +
    '    <!-- =================== -->\n' +
    '    <div ng-if="vm.step === \'confirm\'">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container domp-from-section">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                    <label class="domp-form-label-review" translate="payments.fromAccount"></label>\n' +
    '                </span>\n' +
    '                <p>\n' +
    '                  <!--<label ng-if="vm.countryCode != \'sl\'" class="domp-form-label-resume">{{vm.fromAccountSelect.iban}}</label>-->\n' +
    '                  <label class="domp-form-label-resume">{{vm.insertedOrderObject.fromAccountNumber}}</label>\n' +
    '                </p>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.insertedOrderObject.amount | number:2}} {{vm.insertedOrderObject.currencySymbol}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="vm.authorisationTypeId == 1" class="row">\n' +
    '              <div class="col-sm-6 col-xs-offset-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                 <label class="domp-form-label-review" translate="orders.paymentDayOfEachMonth"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.dayOfBeginning}}.\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row p-t-10">\n' +
    '              <div class="col-md-6"></div>\n' +
    '              <div ng-if="vm.authorisationTypeId == 1" class="col-sm-3">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                 <label class="domp-form-label-review" translate="orders.dateBegin"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.dateBegin| date: \'shortDate\'}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-3">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                     <label class="domp-form-label-review" translate="orders.dateCancel"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.dateCancel| date: \'shortDate\'}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container domp-from-section">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                  <label ng-if="vm.countryCode == \'sl\' && vm.orderType.typeId !== \'trr\'" class="domp-form-label"\n' +
    '                         for="beneficiaryIBAN" translate="orders.beneficiaryIBANforSavings"></label>\n' +
    '                  <label ng-if="vm.countryCode != \'sl\' || vm.orderType.typeId === \'trr\'" class="domp-form-label"\n' +
    '                         for="beneficiaryIBAN" translate="orders.beneficiaryIBAN"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.insertedOrderObject.payeeAccount}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' || vm.orderType.typeId === \'trr\'"\n' +
    '                   class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                     <label ng-if="vm.countryCode != \'sl\'" class="domp-form-label-review"\n' +
    '                            translate="orders.beneficiaryName"></label>\n' +
    '                     <label ng-if="vm.countryCode == \'sl\'" class="domp-form-label-review"\n' +
    '                            translate="domesticPayment.toPayee2"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.insertedOrderObject.payeeName}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="vm.countryCode == \'sl\' && vm.orderType.typeId === \'trr\'" class="row">\n' +
    '              <div class="col-sm-6 col-xs-offset-6">\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.insertedOrderObject.payeeAddress}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="vm.authorisationTypeId == 1">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container domp-from-section">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                  <label class="domp-form-label-review" translate="orders.purpose"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.description}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="!vm.orderSigned">\n' +
    '        <div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 m-t-10">\n' +
    '\n' +
    '          <button ng-if="vm.authorisationTypeId == 0" class="col-lg-3 col-md-3 col-sm-4 col-xs-4 btn btn-primary"\n' +
    '                  translate="domesticPayment.back" ng-click="vm.step = \'order\'">\n' +
    '          </button>\n' +
    '          <button ng-if="vm.authorisationTypeId == 1" class="col-lg-3 col-md-3 col-sm-4 col-xs-4 btn btn-primary"\n' +
    '                  translate="domesticPayment.back" ng-click="vm.editOrder()">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 m-t-10">\n' +
    '          <button ng-if="vm.authorisationTypeId == 1"\n' +
    '                  class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default pull-right"\n' +
    '                  ng-disabled="vm.confirmButtonPressed"\n' +
    '                  translate="domesticPayment.confirmBtn" ng-click="vm.sign()">\n' +
    '          </button>\n' +
    '          <button ng-if="vm.authorisationTypeId == 0"\n' +
    '                  class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default pull-right"\n' +
    '                  translate="domesticPayment.confirmBtn" ng-click="vm.confirmClosePermanentOrder()">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Container for signing form -->\n' +
    '      <div class="row m-b-10" ng-if="vm.orderSigned">\n' +
    '        <div class="col-xs-12 m-t-30">\n' +
    '          <form name="vm.challengeForm" novalidate>\n' +
    '            <div class="col-xs-12 m-b-20">\n' +
    '              <span class="f-w-bold">\n' +
    '          {{\'signPayments.challengeDescription\'| translate}}\n' +
    '        </span>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-6">\n' +
    '              <span class="f-w-bold">{{\'signPayments.challengeFirstCode\'| translate}}</span>\n' +
    '              <input type="text" class="form-control input-field" disabled\n' +
    '                     data-ng-model="vm.insertedOrderObject.challenge">\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-6">\n' +
    '              <span class="f-w-bold">{{\'signPayments.challengeSecondCode\'| translate}}</span>\n' +
    '              <div class="input-group">\n' +
    '                <input type="{{vm.showTokenInput ? \'text\' : \'password\'}}" class="form-control input-field"\n' +
    '                       data-ng-model="vm.model.password2" ng-pattern-restrict="{{vm.regexPatterns.onlyNumbers}}"\n' +
    '                       placeholder="{{\'signPayments.challengeSecondCode\'| translate}}" autofocus>\n' +
    '                <span class="input-group-btn">\n' +
    '            <button class="btn btn-default input-group-app-btn domp-btn-height"\n' +
    '                    data-ng-click="vm.showTokenInput = !vm.showTokenInput" style="border:1px solid #062a42;">\n' +
    '              <i class="icon icon-lock"></i>\n' +
    '            </button>\n' +
    '          </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '              <button class="btn btn-default col-sm-8 col-xs-4 pull-right" ng-disabled="vm.confirmButtonPressed"\n' +
    '                      data-ng-click="vm.sign()" translate="signPayments.confirm">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- =================== -->\n' +
    '    <!-- END: Confirm step -->\n' +
    '    <!-- =================== -->\n' +
    '\n' +
    '    <!-- =================== -->\n' +
    '    <!-- START: Complete step -->\n' +
    '    <!-- =================== -->\n' +
    '    <div ng-if="vm.step === \'complete\'" class="currency-conversion-msg">\n' +
    '      <div class="payment-successful-wrapper">\n' +
    '        <div class="row m-t-20">\n' +
    '          <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '            <div class="currency-check-icon msg-pad">\n' +
    '              <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-9 m-t-30 m-b-30" style="max-width: 688px;">\n' +
    '            <h2 ng-if="vm.authorisationTypeId == 1" class="c-white f-28" translate="orders.completeText"></h2>\n' +
    '            <h2 ng-if="vm.authorisationTypeId == 0" class="c-white f-28" translate="orders.completeCancelText"></h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-20 p-l-10">\n' +
    '        <!-- Save template only for Domestic or foreign payments-->\n' +
    '        <div class="col-xs-12 col-sm-4">\n' +
    '          <a href="javascript:void(0)" ng-click="vm.newOrder()">\n' +
    '            <span class="money-exchange-icon"><i class="icon icon-einvoiceadd zmdi-hc-2x"></i></span>\n' +
    '            <span class="f-18 bold-font" translate="orders.makeNew"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- =================== -->\n' +
    '    <!-- END: Complete step -->\n' +
    '    <!-- =================== -->\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/orders-overview-timeline.tpl.html',
    ' <div class="row m-t-20">\n' +
    '        <div class="col-sm-12">\n' +
    '          <h4 translate="orders.standingOrders"></h4>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12 m-b-5">\n' +
    '          <div class="dropdown acc-period-select pull-right">\n' +
    '            <button class="btn btn-default dropdown-toggle p-l-30 p-r-30" type="button" data-toggle="dropdown">\n' +
    '              {{vm.selectedPeriod.item.description| translate}}\n' +
    '              <span class="caret"></span>\n' +
    '            </button>\n' +
    '            <ul class="dropdown-menu">\n' +
    '              <li data-ng-repeat="period in vm.periodList">\n' +
    '                <a href="" class="f-13" data-ng-click="vm.timelineTimeFilter(period);">\n' +
    '                  {{period.item.description| translate}}\n' +
    '                </a>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="timeline-row col-sm-12">\n' +
    '          <div class="t-a-c p-10 no-data-image" ng-if="vm.ordersListGrouped.result.length == 0">\n' +
    '            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '            <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '          </div>\n' +
    '          <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0" ng-hide="vm.ordersListGrouped.result.length == 0">\n' +
    '            <ul class="hypo-timeline" kcd-recompile="vm.ordersListGrouped">\n' +
    '              <li ng-repeat="order in vm.ordersListGrouped.result">\n' +
    '                <i class="icon icon-insurance currency-icon-change icon-lh"></i>\n' +
    '                <div class="hypo-timeline-item payment-item" ng-click=" vm.expandDetails(order); order.selected = !order.selected" ng-class="{\'opened\': order.selected}">\n' +
    '                  <div class="hypo-timeline-body">\n' +
    '                    <div class="col-xs-6">\n' +
    '\n' +
    '                      <h4>\n' +
    '                        {{order.orderType.description}}\n' +
    '                      </h4>\n' +
    '\n' +
    '                      <span class="text-muted text-uppercase">\n' +
    '                        {{order.date}}\n' +
    '                      </span>\n' +
    '\n' +
    '                    </div>\n' +
    '                    <!--<div class="col-xs-6"><span class="pull-right t-a-r m-t-10"><b>{{order.statusId| orderStatusString | translate}}</b></span></div>-->\n' +
    '                    <div class="col-xs-6">\n' +
    '                      <span class="pull-right t-a-r m-t-10"><b translate="orders.{{order.status}}"></b></span>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12">\n' +
    '                      <span class="text-muted">\n' +
    '                        {{order.dateCreated| date:\'shortDate\'}}\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <div class="clear"></div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div ng-if="order.selected" class="transaction-details">\n' +
    '                        <div data-ng-include="\'orders/orders-overview-timeline-details.tpl.html\'"></div>\n' +
    '                  </div>\n' +
    '\n' +
    '                </div>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="show-more-btn ">\n' +
    '          <button ng-hide="vm.ordersListGrouped.hasMore == false" data-ng-click="vm.loadMoreTimelineItems()" type="input"\n' +
    '                  class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents"></button>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/orders-overview-timeline-details.tpl.html',
    '<div>\n' +
    '    <table class="table table-transparent table-responsive">\n' +
    '        <tbody>\n' +
    '            <tr ng-if="order.id">\n' +
    '              <td>\n' +
    '                <span class="po-desc-label" translate="orderDetails.orderId"></span>\n' +
    '              </td>\n' +
    '              <td>\n' +
    '                <span class="po-value-label">{{order.id }}</span>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="order.payeeName">\n' +
    '                <td>\n' +
    '                    <span class="po-desc-label" translate="orderDetails.name"></span>\n' +
    '                </td>\n' +
    '                <td>\n' +
    '                    <span class="po-value-label">{{order.payeeName }}</span>\n' +
    '                </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && order.payeeAddress">\n' +
    '                <td>\n' +
    '                    <span class="po-desc-label" translate="orderDetails.payeeAddress"></span>\n' +
    '                </td>\n' +
    '                <td>\n' +
    '                    <span class="po-value-label">{{order.payeeAddress }}</span>\n' +
    '                </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="order.fromAccountNumber && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '              <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlFrom"></span>\n' +
    '              </td>\n' +
    '              <td>\n' +
    '                <span class="po-value-label">{{order.fromAccountNumber}}</span>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="order.payeeAccount">\n' +
    '                <td>\n' +
    '                    <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" class="po-desc-label" translate="orderDetails.payeeAccount"></span>\n' +
    '                    <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="po-desc-label" translate="paymentsOverview.povlTo"></span>\n' +
    '                </td>\n' +
    '                <td>\n' +
    '                    <span class="po-value-label">{{order.payeeAccount}}</span>\n' +
    '                </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="order.amount">\n' +
    '                <td>\n' +
    '                    <span class="po-desc-label" translate="orderDetails.amount"></span>\n' +
    '                </td>\n' +
    '                <td>\n' +
    '                    <span class="po-value-label">{{order.amount | number:2}} {{order.currencySymbol}}</span>\n' +
    '                </td>\n' +
    '            </tr>\n' +
    '\n' +
    '            <!--<tr ng-if="order.orderType.id">-->\n' +
    '                <!--<td>-->\n' +
    '                    <!--<span class="po-desc-label" translate="orderDetails.orderTypeId"></span>-->\n' +
    '                <!--</td>-->\n' +
    '                <!--<td>-->\n' +
    '                    <!--<span class="po-value-label">{{order.orderType.id}}</span>-->\n' +
    '                <!--</td>-->\n' +
    '            <!--</tr>-->\n' +
    '            <tr ng-if="order.purpose">\n' +
    '                <td>\n' +
    '                    <span class="po-desc-label" translate="orderDetails.purpose"></span>\n' +
    '                </td>\n' +
    '                <td>\n' +
    '                    <span class="po-value-label">{{order.purpose}}</span>\n' +
    '                </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="order.dateCreated">\n' +
    '                <td>\n' +
    '                    <span class="po-desc-label" translate="orderDetails.dateCreated"></span>\n' +
    '                </td>\n' +
    '                <td>\n' +
    '                    <span class="po-value-label">{{order.dateCreated | date: \'shortDate\'}}</span>\n' +
    '                </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && order.firstPaymentDate">\n' +
    '              <td>\n' +
    '                <span class="po-desc-label" translate="orderDetails.firstPaymentDate"></span>\n' +
    '              </td>\n' +
    '              <td>\n' +
    '                <span class="po-value-label">{{order.firstPaymentDate | date: \'shortDate\'}}</span>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && order.lastPaymentDate">\n' +
    '              <td>\n' +
    '                <span class="po-desc-label" translate="orderDetails.lastPaymentDate"></span>\n' +
    '              </td>\n' +
    '              <td>\n' +
    '                <span class="po-value-label">{{order.lastPaymentDate | date: \'shortDate\'}}</span>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            <tr ng-if="order.status != \'Signed\' && vm.countryCode != \'sl\'">\n' +
    '                <td colspan="2">\n' +
    '                    <div>\n' +
    '                        <span>\n' +
    '                            <button\n' +
    '                            ng-click="vm.closeOrder(order.id);"\n' +
    '                            class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                            translate="orderDetails.close">Close order</button>\n' +
    '                          </span>\n' +
    '                    </div>\n' +
    '                </td>\n' +
    '            </tr>\n' +
    '        </tbody>\n' +
    '    </table>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/orders-other.tpl.html',
    '<section id="main" ng-controller="OrdersOtherCtrl as vm">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="domp-header-wrapper" ng-hide="vm.step === \'complete\'">\n' +
    '      <div class="domp-header-row">\n' +
    '        <h2 class="f-28" ng-if="vm.step === \'order\'" translate="orders.title"></h2>\n' +
    '        <h2 class="f-28" ng-if="vm.step === \'confirm\'" translate="orders.titleConfirmation"></h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="vm.step === \'order\'">\n' +
    '\n' +
    '      <form novalidate name="vm.orderForm">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <div class="container domp-from-section">\n' +
    '              <div class="row p-15">\n' +
    '                <!-- CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '                <div class="col-sm-6 domp-acc-dropdown">\n' +
    '                  <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '\n' +
    '                  <div class="accounts-dropdown">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                         data-ng-click="vm.fromAccountDropdown = !vm.fromAccountDropdown"\n' +
    '                         ng-style="vm.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + vm.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                          {{vm.fromAccountSelect.friendlyName}} </b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                          <i class="zmdi" ng-class="{\n' +
    '                              \'zmdi-star favorite-account\'\n' +
    '                                :account.isFavorite, \'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                        </span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{vm.fromAccountSelect.iban }}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{vm.fromAccountSelect.availableBalance | currency: ""}} {{vm.fromAccountSelect.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      <span class="caret-icon">\n' +
    '                        <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                      </span>\n' +
    '                    </div>\n' +
    '                    <div class="from-accounts-list m-l-0" ng-show="vm.fromAccountDropdown" scrollable>\n' +
    '                      <div class="accounts-list-item p-0"\n' +
    '                           data-ng-repeat="item in vm.accountList"\n' +
    '                           data-ng-click="vm.setAccountFrom(item);">\n' +
    '                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                             ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                          <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                                ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                          </h4>\n' +
    '                          <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                          <span class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">{{item.availableBalance | currency: ""}} {{item.currencySymbol}}</span>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="col-sm-6">\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-12">\n' +
    '                      <div class="form-group">\n' +
    '                        <label class="domp-form-label-review" for="amountInput"\n' +
    '                               translate="domesticPayment.amountInputLabel"></label>\n' +
    '                        <div class="input-group">\n' +
    '                          <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                                 placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask\n' +
    '                                 maxlength="12" ng-model="vm.amountInput" required\n' +
    '                                 ng-class="{\'domp-error\': vm.orderForm.amountInput.$invalid && vm.formSubmitted}"\n' +
    '                                 ng-maxlength="11"/>\n' +
    '                          <span class="input-group-btn">\n' +
    '                            <button type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                                    ng-if="vm.countryCode != \'sr\'" style="border:1px solid #062a42;">\n' +
    '                              {{vm.defaultCurrency}}\n' +
    '                            </button>\n' +
    '                          </span>\n' +
    '                        </div>\n' +
    '                        <span class="c-red" ng-if="vm.orderForm.amountInput.$error.required && vm.formSubmitted"\n' +
    '                              translate="internalTransfer.amountInputError"></span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-sm-6">\n' +
    '                      <div class="form-group">\n' +
    '                        <label class="domp-form-label" for="dateBegin" translate="orders.dateBegin"></label>\n' +
    '                        <div class="input-group">\n' +
    '                          <input type="text" class="form-control input-field" name="dateBegin" id="dateBegin"\n' +
    '                                 uib-datepicker-popup="shortDate" data-ng-model="vm.dateBegin" show-weeks="false"\n' +
    '                                 is-open="datePickerBeginOpened" datepicker-options="vm.dateOptions"\n' +
    '                                 show-button-bar="false"\n' +
    '                                 ng-class="{ \'domp-error\' : vm.orderForm.dateBegin.$invalid && vm.formSubmitted}"\n' +
    '                                 required readonly>\n' +
    '                          <span class="input-group-btn">\n' +
    '                            <button data-ng-click="datePickerBeginOpened = !datePickerBeginOpened" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                    style="border:1px solid #062a42;">\n' +
    '                              <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                            </button>\n' +
    '                          </span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                      <span class="c-red" ng-show="vm.orderForm.dateBegin.$error.required && vm.formSubmitted"\n' +
    '                            translate="orders.dateRequired"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!--RECIPIENT IBAN  / RECIPIENT (company/name and address) START -->\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <div class="container domp-from-section">\n' +
    '              <div class="row  p-15">\n' +
    '                <div class="col-sm-6">\n' +
    '                  <label class="domp-form-label" for="beneficiaryIBAN" translate="orders.beneficiaryIBAN"></label>\n' +
    '                  <input ng-if="vm.countryCode == \'hr\'" type="text" class="form-control input-field" capitalize\n' +
    '                         ui-mask="HR 99 9999 9999 9999 9999 9"\n' +
    '                         ui-mask-placeholder\n' +
    '                         ui-mask-placeholder-char="_"\n' +
    '                         ui-options="vm.uiMaskOptions"\n' +
    '                         minlength="21"\n' +
    '                         ng-model="vm.beneficiaryIBAN"\n' +
    '                         ng-class="{\'domp-error\': vm.orderForm.beneficiaryIBAN.$invalid && vm.formSubmitted}"\n' +
    '                         name="beneficiaryIBAN" id="beneficiaryIBAN"\n' +
    '                         required />\n' +
    '\n' +
    '                  <span class="c-red" ng-show="vm.orderForm.beneficiaryIBAN.$error.required && vm.formSubmitted"\n' +
    '                        translate="domesticPayment.receiverAccountError"></span>\n' +
    '                </div>\n' +
    '                <div class="col-sm-6">\n' +
    '                  <label  class="domp-form-label" for="beneficiaryName" translate="orders.beneficiaryName"></label>\n' +
    '                  <input type="text" class="form-control input-field" name="beneficiaryName" id="beneficiaryName"\n' +
    '                         required ng-pattern-restrict="{{vm.regexPatterns.allowedCharsDPS}}"\n' +
    '                         ng-class="{ \'domp-error\' : vm.orderForm.beneficiaryName.$invalid && vm.formSubmitted}"\n' +
    '                         ng-model="vm.beneficiaryName">\n' +
    '                  <span class="c-red" ng-show="vm.orderForm.beneficiaryName.$error.required && vm.formSubmitted"\n' +
    '                        translate="orders.beneficiaryNameRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row  p-15">\n' +
    '                <div class="col-sm-6">\n' +
    '                    <div class="col-xs-12 p-l-0">\n' +
    '                      <label class="domp-form-label" for="referenceNumber"\n' +
    '                             translate="domesticPayment.referenceNumberLabel"></label>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-2 col-xs-2 p-l-0 p-r-5">\n' +
    '                      <input type="text" class="form-control input-field" value="HR"\n' +
    '                             readonly>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-2 col-xs-2 p-l-0 p-r-5">\n' +
    '                      <div class="form-group m-b-0">\n' +
    '                        <select class="form-control input-field p-l-15 p-r-10" name="referenceModelSelect"\n' +
    '                                id="referenceModelSelect" ng-model="vm.referenceModelSelect">\n' +
    '                          <option ng-repeat="item in vm.referenceModelList">{{item}}</option>\n' +
    '                        </select>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-8 col-xs-8 p-l-0 p-r-0" ng-if="vm.referenceModelSelect != \'99\'">\n' +
    '                      <div class="form-group m-b-0">\n' +
    '                        <input type="text" id="referenceNumber" name="referenceNumber"\n' +
    '                               ng-if="vm.referenceModelSelect != \'99\'" maxlength="22" class="form-control input-field"\n' +
    '                               ng-pattern-restrict="{{vm.regexPatterns.allNumbersDashes}}"\n' +
    '                               ng-model="vm.referenceNumber"/>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-8 col-xs-8 p-l-0 p-r-0" ng-if="vm.referenceModelSelect == \'99\'">\n' +
    '                      <div class="form-group m-b-0">\n' +
    '                        <input type="text" class="form-control input-field" name="referenceNumber" id="referenceNumber"\n' +
    '                               ng-model="vm.referenceNumber"\n' +
    '                               readonly/>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"\n' +
    '                        ng-show="vm.orderForm.referenceNumber.$error.required && vm.formSubmitted"\n' +
    '                        translate="domesticPayment.referenceModelInputError"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12">\n' +
    '            <div class="container domp-from-section">\n' +
    '              <div class="row  p-15">\n' +
    '                <div class="col-sm-12 p-t-10">\n' +
    '                  <div class="form-group m-b-0">\n' +
    '                    <label class="domp-form-label" for="description" translate="orders.description"></label>\n' +
    '                    <input type="text" class="form-control input-field" name="description" id="description" required\n' +
    '                           ng-pattern-restrict="{{vm.regexPatterns.allowedCharsDPS}}"\n' +
    '                           maxlength="{{vm.descriptionMaxLength}}"\n' +
    '                           ng-class="{ \'domp-error\' : vm.orderForm.description.$invalid && vm.formSubmitted}"\n' +
    '                           ng-model="vm.description"/>\n' +
    '                  </div>\n' +
    '                  <span class="c-red col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"\n' +
    '                        ng-show="vm.orderForm.description.$error.required && vm.formSubmitted"\n' +
    '                        translate="orders.descriptionRequired"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row  p-15">\n' +
    '          <div class="col-sm-12">\n' +
    '            <div class="container">\n' +
    '              <div class="controls readonly">\n' +
    '                  <label class="domp-form-label" translate="orders.note"></label>\n' +
    '                  <br>\n' +
    '                  <span translate="orders.note1"></span>\n' +
    '                  <br>\n' +
    '                  <span translate="orders.note2"></span>\n' +
    '                  <br>\n' +
    '                  <span translate="orders.note3"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <div class="row p-10">\n' +
    '          <div class="col-xs-6 t-a-l">\n' +
    '            <button class="btn btn-primary" type="button" translate="orders.cancel" data-ui-sref="dashboard">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 t-a-r">\n' +
    '            <button class="btn btn-default pull-right" type="submit"\n' +
    '                    ng-click="vm.confirm()">\n' +
    '              <span translate="domesticPayment.confirmBtn"></span>\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '      <!-- TIMELINE CONTAINER -->\n' +
    '      <div data-ng-include="\'orders/orders-overview-timeline.tpl.html\'"></div>\n' +
    '      <!-- END TIMELINE -->\n' +
    '    </div>\n' +
    '    <div ng-if="vm.step === \'confirm\'">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container domp-from-section">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                    <label class="domp-form-label-review" translate="payments.fromAccount"></label>\n' +
    '                </span>\n' +
    '                <p>\n' +
    '                  <!--<label ng-if="vm.countryCode != \'sl\'" class="domp-form-label-resume">{{vm.fromAccountSelect.iban}}</label>-->\n' +
    '                  <label class="domp-form-label-resume">{{vm.insertedOrderObject.fromAccountNumber}}</label>\n' +
    '                </p>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.insertedOrderObject.amount | number:2}} {{vm.insertedOrderObject.currencySymbol}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row p-t-10">\n' +
    '              <div class="col-sm-3 col-xs-offset-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                 <label class="domp-form-label-review" translate="orders.dateBegin"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.dateBegin| date: \'shortDate\'}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container domp-from-section">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                  <label class="domp-form-label" for="beneficiaryIBAN" translate="orders.beneficiaryIBAN"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.insertedOrderObject.payeeAccount}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                     <label class="domp-form-label-review" translate="orders.beneficiaryName"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.insertedOrderObject.payeeName}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container domp-from-section">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                  <label class="domp-form-label-review" translate="orders.description"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.description}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6">\n' +
    '                <span class="invoice-inline-title text-muted">\n' +
    '                    <label class="domp-form-label-review" translate="domesticPayment.referenceNumberLabel"></label>\n' +
    '                </span>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  <b>HR{{vm.referenceModelSelect}}{{vm.referenceNumber}}</b>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="!vm.orderSigned">\n' +
    '        <div  class="col-lg-6 col-md-6 col-xs-6 col-sm-6 m-t-10">\n' +
    '          <button  class="col-lg-3 col-md-3 col-sm-4 col-xs-4 m-r-10 btn btn-primary-warning" translate="payments.delete"\n' +
    '                  ng-click="vm.deleteOrder()">\n' +
    '          </button>\n' +
    '          <button  class="col-lg-3 col-md-3 col-sm-4 col-xs-4 btn btn-primary"\n' +
    '                  translate="orders.edit" ng-click="vm.editOrder()">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 m-t-10">\n' +
    '          <button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default pull-right"\n' +
    '                  translate="internalTransfer.sign" ng-click="vm.orderSigned = true">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Container for signing form -->\n' +
    '      <div class="row m-b-10" ng-if="vm.orderSigned">\n' +
    '        <div class="col-xs-12 m-t-30">\n' +
    '          <form name="vm.challengeForm" novalidate>\n' +
    '            <div class="col-xs-12 m-b-20">\n' +
    '              <span class="f-w-bold">\n' +
    '          {{\'signPayments.challengeDescription\'| translate}}\n' +
    '        </span>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-6">\n' +
    '              <span class="f-w-bold">{{\'signPayments.challengeFirstCode\'| translate}}</span>\n' +
    '              <input type="text" class="form-control input-field" disabled\n' +
    '                     data-ng-model="vm.insertedOrderObject.challenge">\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-6">\n' +
    '              <span class="f-w-bold">{{\'signPayments.challengeSecondCode\'| translate}}</span>\n' +
    '              <div class="input-group">\n' +
    '                <input type="{{vm.showTokenInput ? \'text\' : \'password\'}}" class="form-control input-field"\n' +
    '                       data-ng-model="vm.model.password2" ng-pattern-restrict="{{vm.regexPatterns.onlyNumbers}}"\n' +
    '                       placeholder="{{\'signPayments.challengeSecondCode\'| translate}}" autofocus>\n' +
    '                <span class="input-group-btn">\n' +
    '            <button class="btn btn-default input-group-app-btn domp-btn-height"\n' +
    '                    data-ng-click="vm.showTokenInput = !vm.showTokenInput" style="border:1px solid #062a42;">\n' +
    '              <i class="icon icon-lock"></i>\n' +
    '            </button>\n' +
    '          </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '              <button class="btn btn-default col-sm-8 col-xs-4 pull-right" ng-disabled="vm.confirmSignedButtonDisabled"\n' +
    '                      data-ng-click="vm.sign()" translate="signPayments.confirm">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="vm.step === \'complete\'" class="currency-conversion-msg">\n' +
    '      <div class="payment-successful-wrapper">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '            <div class="currency-check-icon msg-pad">\n' +
    '              <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-9 m-t-30 m-b-30" style="max-width: 688px;">\n' +
    '            <h2 class="c-white f-28" translate="orders.completeText"></h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-20 p-l-10">\n' +
    '        <!-- Save template only for Domestic or foreign payments-->\n' +
    '        <div class="col-xs-12 col-sm-4">\n' +
    '          <a href="javascript:void(0)" ng-click="vm.newOrder()">\n' +
    '            <span class="money-exchange-icon"><i class="icon icon-einvoiceadd zmdi-hc-2x"></i></span>\n' +
    '            <span class="f-18 bold-font" translate="orders.makeNew"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/new-savings-order-slo.tpl.html',
    '<section id="main" ng-show="savingsAccount.isPageLoaded">\n' +
    '  <div ng-show="savingsAccount.isPageLoaded" class="container-fluid clearfix f-14 m-t-25 m-b-20">\n' +
    '    <div ng-show="!savingsAccount.steps.step3">\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <h2 class="title-style m-t-0 m-b-20" translate="savingsOrder.title"></h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <div class="alert alert-info" style="background: white; color: black; border: 1px solid lightgray"\n' +
    '               role="alert">\n' +
    '            <p class="bold-font" translate="termDeposit.taxationOfInterestTitle"></p>\n' +
    '            <p translate="savingsOrder.taxationOfInterestMsg">\n' +
    '            <div class="row p-t-10 p-l-15 p-r-15">\n' +
    '              <div class="col-xs-6 p-0"><a href="https://www.addiko.si/addiko-varcevalni-racun-5-dni" target="_blank"\n' +
    '                                           class="underline">{{ \'savingsOrder.headerLink1\' | translate}}</a></div>\n' +
    '              <div class="col-xs-6 p-0"><a href="https://www.addiko.si/addiko-varcevanje-plus" target="_blank"\n' +
    '                                           class="underline">{{ \'savingsOrder.headerLink2\' | translate}}</a></div>\n' +
    '            </div>\n' +
    '            <div class="row p-t-10 p-l-15 p-r-15">\n' +
    '              <div class="col-xs-6 p-0"><a href="https://www.addiko.si/obrestne-mere" target="_blank" class="underline">{{\n' +
    '                \'savingsOrder.headerLink3\' | translate}}</a></div>\n' +
    '              <div class="col-xs-6 p-0"><a href="https://www.bsi.si/jamstvo-vlog.asp?MapaId=150" target="_blank"\n' +
    '                                           class="underline">{{ \'savingsOrder.headerLink4\' | translate}}</a></div>\n' +
    '            </div>\n' +
    '            </p>\n' +
    '            <!--<p><a class="underline p-r-5" href="">Test 1</a> <a class="underline p-r-5" href="">Test 2</a> <a-->\n' +
    '            <!--class="underline" href="">Test 3</a></p>-->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-12"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ====  STEP 1 ==== -->\n' +
    '    <!-- ================= -->\n' +
    '    <div ng-form="savingsAccount.savingsOrderForm" class="clearfix bg-white" ng-show="savingsAccount.steps.step1"\n' +
    '         novalidate>\n' +
    '      <div class="intp-form-container bottom-border">\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-5">\n' +
    '            <label class="ntd-form-label compact"\n' +
    '                   translate="savingsOrder.savingsType">\n' +
    '            </label>\n' +
    '            <select name="savingTypesGroup"\n' +
    '                    ng-options="key for (key, value) in savingsAccount.savingOrderTypesGroupOptions"\n' +
    '                    value="{{key}}"\n' +
    '                    ng-model="savingsAccount.savingTypesGroup"\n' +
    '                    ng-change="savingsAccount.onSavingOrderTypesGroupChange(savingsAccount.savingTypesGroup)"\n' +
    '                    class="form-control h-45"\n' +
    '                    required>\n' +
    '            </select>\n' +
    '\n' +
    '            <span class="c-red"\n' +
    '                  ng-show="savingsAccount.savingsOrderForm.savingTypesGroup.$error.required && savingsAccount.formSubmitted"\n' +
    '                  translate="core.requiredField"></span>\n' +
    '          </div>\n' +
    '          <div class="col-md-7" ng-if="savingsAccount.selectedSavingTypesGroupId != 1">\n' +
    '            <div ng-show="!savingsAccount.durationInputHidden" class="col-sm-6 col-xs-12">\n' +
    '              <div class="col-md-12 p-0">\n' +
    '                <label class="ntd-form-label compact" translate="savingsOrder.duration"></label>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-md-5 col-xs-5 p-0">\n' +
    '                <input class="form-control t-a-r h-45" maxlength="6"\n' +
    '                       name="maturityInDays"\n' +
    '                       ng-pattern-restrict="{{savingsAccount.regexPatterns.onlyNumbers}}"\n' +
    '                       ng-blur="savingsAccount.calculateMaturityDateWithDays(savingsAccount.model.maturityInDays)"\n' +
    '                       ng-model="savingsAccount.model.maturityInDays"\n' +
    '                       required/>\n' +
    '                <label class="ntd-form-label compact pull-right"\n' +
    '                       translate="termDeposit.durationInDays">\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-md-2 col-xs-2 p-10 text-center">\n' +
    '                <label class="ntd-form-label compact"\n' +
    '                       translate="termDeposit.durationOr">\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col-md-5 col-xs-5 p-0">\n' +
    '                <input class="form-control t-a-r h-45" maxlength="3"\n' +
    '                       name="maturityInMonths"\n' +
    '                       ng-pattern-restrict="{{savingsAccount.regexPatterns.onlyNumbers}}"\n' +
    '                       ng-blur="savingsAccount.calculateMaturityDate(savingsAccount.model.maturityInMonths)"\n' +
    '                       ng-model="savingsAccount.model.maturityInMonths"/>\n' +
    '                <label class="ntd-form-label compact pull-right"\n' +
    '                       translate="termDeposit.durationInMonths">\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <!-- Error message -->\n' +
    '              <div class="col-md-12 col-xs-12 p-0">\n' +
    '                  <span class="c-red" ng-show="savingsAccount.savingsOrderForm.maturityInMonths.$error.minvalue">\n' +
    '                  <span translate="savingsOrder.minSavingDuration"></span>\n' +
    '                  {{savingsAccount.minimalDurationForSelectedGroup}}\n' +
    '                  <span translate="termDeposit.days"></span>\n' +
    '                </span>\n' +
    '                <span class="c-red" ng-show="savingsAccount.savingsOrderForm.maturityInMonths.$error.maxvalue">\n' +
    '                  <span translate="savingsOrder.maxSavingDuration"></span>\n' +
    '                  {{savingsAccount.maxSavingDuration}}\n' +
    '                  <span translate="termDeposit.days"></span>\n' +
    '                </span>\n' +
    '                <!--<span class="c-red" ng-show="savingsAccount.savingsOrderForm.maturityInMonths.$error.maxvalue">-->\n' +
    '                <!--<span translate="termDeposit.maxDepDurationErr"></span>-->\n' +
    '                <!--{{savingsAccount.minimalDurationForSelectedGroup}}-->\n' +
    '                <!--<span translate="termDeposit.days"></span>-->\n' +
    '                <!--</span>-->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-6 col-xs-12">\n' +
    '              <label class="ntd-form-label compact"\n' +
    '                     translate="termDeposit.maturityDate">\n' +
    '              </label>\n' +
    '              <div class="input-group">\n' +
    '                <input type="text" class="form-control t-a-r h-45" readonly\n' +
    '                       name="maturityDate"\n' +
    '                       ng-model="savingsAccount.model.maturityDate"\n' +
    '                       uib-datepicker-popup="shortDate"\n' +
    '                       datepicker-options="savingsAccount.dateOptions"\n' +
    '                       show-weeks="false" date-disabled="savingsAccount.disabled(date, mode)"\n' +
    '                       is-open="savingsAccount.isDatepickerOpen"\n' +
    '                       ng-change="savingsAccount.calculateMaturityDays(savingsAccount.model.maturityDate)"\n' +
    '                       readonly/>\n' +
    '\n' +
    '                <span class="input-group-btn">\n' +
    '                    <button data-ng-click="savingsAccount.isDatepickerOpen = !savingsAccount.isDatepickerOpen"\n' +
    '                            type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                            style="border:1px solid #062a42;">\n' +
    '                      <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '              </div>\n' +
    '              <span class="c-red"\n' +
    '                    ng-show="savingsAccount.savingsOrderForm.$error.dateDisabled">\n' +
    '                  <span translate="orders.maturityDateNonWorkingErr"></span>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-5">\n' +
    '            <label class="ntd-form-label compact" translate="savingsOrder.fromAccount"></label>\n' +
    '            <div class="accounts-dropdown m-b-10" ng-if="savingsAccount.accountsFrom.length > 0">\n' +
    '              <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                   data-ng-click="savingsAccount.toggleFromAccount();"\n' +
    '                   ng-style="savingsAccount.model.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + savingsAccount.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                  <b\n' +
    '                    class="col-xs-10 p-0 m-t-10  no-wrap-text">{{savingsAccount.model.fromAccountSelect.friendlyName}}</b>\n' +
    '                  <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                    <i class="zmdi"\n' +
    '                       ng-class="{\'zmdi-star favorite-account\':savingsAccount.model.fromAccountSelect.isFavorite,\'zmdi-star-outline\':!savingsAccount.model.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                </h4>\n' +
    '                <p class="m-b-0 m-t-0 iban-style">\n' +
    '                  {{savingsAccount.model.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                  {{savingsAccount.model.fromAccountSelect.availableBalance | number:2}}\n' +
    '                  {{savingsAccount.model.fromAccountSelect.currencySymbol}}\n' +
    '                </p>\n' +
    '                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '              </div>\n' +
    '              <div class="from-accounts-list m-l-15" ng-show="savingsAccount.fromAccountDropdown" scrollable>\n' +
    '                <div class="accounts-list-item p-0" data-ng-repeat="item in savingsAccount.accountsFrom"\n' +
    '                     data-ng-click="savingsAccount.setAccountFrom(item);">\n' +
    '\n' +
    '                  <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                       ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                      <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi"\n' +
    '                                                                                          ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                    </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                      {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="accounts-dropdown m-b-10"\n' +
    '                 ng-if="!savingsAccount.accountsFrom.length || savingsAccount.accountsFrom.length === 0">\n' +
    '              <!--<div class="debit-account-widget dashboard-widget-item" style="height: 114px; line-height: 114px" translate="internalTransfer.noData"  ng-style="savingsAccount.model.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + savingsAccount.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  No available accounts\n' +
    '              </div>-->\n' +
    '              <div class="debit-account-widget dashboard-widget-item" style="height: 141px;"\n' +
    '                   ng-style="internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + internalTransfer.tempIntObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                <div class="m-t-30 m-b-30">\n' +
    '                  <p translate="internalTransfer.nodata"></p>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-md-7">\n' +
    '            <div class="form-group clearfix m-t-10">\n' +
    '              <div class="col-md-6 col-xs-12">\n' +
    '                <span ng-switch="savingsAccount.model.savingsType.periodType">\n' +
    '                      <label class="ntd-form-label compact" ng-switch-when="K"\n' +
    '                             translate="savingsOrder.initialDepositAmount"></label>\n' +
    '                       <label class="ntd-form-label compact" ng-switch-when="D"\n' +
    '                             translate="savingsOrder.monthlyDepositAmount"></label>\n' +
    '                  <label class="ntd-form-label compact" ng-switch-default\n' +
    '                             translate="savingsOrder.monthlyDepositAmount"></label>\n' +
    '                </span>\n' +
    '\n' +
    '                <div class="input-group">\n' +
    '                  <input required type="text" class="form-control h-45 t-a-r"\n' +
    '                         name="amount"\n' +
    '                         amount-input-mask\n' +
    '                         placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00"\n' +
    '                         maxlength="14" max-amount="99999999999.99"\n' +
    '                         ng-model="savingsAccount.model.amount"\n' +
    '                         ng-blur="savingsAccount.amountChanged(savingsAccount.model.amount)"\n' +
    '                         required/>\n' +
    '                  <span class="input-group-btn">\n' +
    '                       <button\n' +
    '                         class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero p-5 dark-border"\n' +
    '                         style="pointer-events: none;">\n' +
    '                        {{savingsAccount.model.currency}}\n' +
    '                      </button>\n' +
    '                    </span>\n' +
    '                </div>\n' +
    '                <!--<span class="c-red"-->\n' +
    '                <!--ng-show="savingsAccount.savingsOrderForm.amount.$error.required">-->\n' +
    '                <!--<span translate="internalTransfer.amountInputError"></span>-->\n' +
    '                <!--</span>-->\n' +
    '                <span class="c-red"\n' +
    '                      ng-show="\n' +
    '                      savingsAccount.savingsOrderForm.amount.$touched &&\n' +
    '                      savingsAccount.savingsOrderForm.amount.$error.minamount &&\n' +
    '                      savingsAccount.model.savingsType.minInstalment">\n' +
    '                  <span translate="termDeposit.minAmountLabel"></span>\n' +
    '                  {{savingsAccount.model.savingsType.minInstalment | currency: ""}} {{savingsAccount.model.currency}}.\n' +
    '                </span>\n' +
    '                <span class="c-red"\n' +
    '                      ng-show="savingsAccount.savingsOrderForm.amount.$error.maxAmount && savingsAccount.savingsOrderForm.amount.$dirty">\n' +
    '                            <span translate="termDeposit.wrongMaxDepositAmount"></span>\n' +
    '                            {{ 99999999999.99 | currency: ""}} {{savingsAccount.model.currency}}.\n' +
    '                </span>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-md-6 col-xs-12">\n' +
    '                <label class="ntd-form-label compact"\n' +
    '                       translate="termDeposit.totalInterestRateInputLabel">\n' +
    '                </label>\n' +
    '                <input type="text" class="form-control t-a-r  h-45" readonly\n' +
    '                       ng-value="(savingsAccount.model.totalInterestRate | currency:\'\': 3) + \' %\'">\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="form-group m-t-10">\n' +
    '              <div class="col-md-6 col-xs-12"\n' +
    '                   ng-if="savingsAccount.model.savingsType.savingType != 5 && savingsAccount.assignmentOfInterestisShown">\n' +
    '                <label class="ntd-form-label compact"\n' +
    '                       translate="termDeposit.assignmentOfInterest">\n' +
    '                </label>\n' +
    '                <select class="form-control h-45"\n' +
    '                        ng-options="option.id as option.value | translate for option in savingsAccount.assignmentOfInterestOptions"\n' +
    '                        ng-model="savingsAccount.assignmentOfInterestId"\n' +
    '                        ng-disabled="savingsAccount.assignemntOfInterestIsDisabled">\n' +
    '                </select>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10" ng-hide="savingsAccount.savingsPeriodType == \'K\'">\n' +
    '          <div class="col-md-5 col-xs-12">\n' +
    '            <label class="ntd-form-label compact"\n' +
    '                   translate="savingsOrder.orderPaymentDay">\n' +
    '            </label>\n' +
    '            <select class="form-control h-45" ng-model="savingsAccount.model.standingOrderPayment"\n' +
    '                    ng-options="option.name for option in savingsAccount.standingOrderPaymentDayOptions"\n' +
    '                    ng-change="savingsAccount.onStndOrderPaymentDayChange(savingsAccount.model.standingOrderPayment.value)">\n' +
    '            </select>\n' +
    '          </div>\n' +
    '          <div class="col-md-7 col-xs-md-12">\n' +
    '            <div class="form-group col-md-6 col-xs-12">\n' +
    '              <label class="ntd-form-label compact"\n' +
    '                     translate="savingsOrder.firstPayment">\n' +
    '              </label>\n' +
    '              <input type="text" class="form-control h-45"\n' +
    '                     ng-value="savingsAccount.model.firstPaymentDate | date: \'shortDate\'" readonly>\n' +
    '            </div>\n' +
    '            <div class="form-group col-md-6 col-xs-12">\n' +
    '              <label class="ntd-form-label compact"\n' +
    '                     translate="savingsOrder.lastPayment">\n' +
    '              </label>\n' +
    '              <input type="text" class="form-control h-45"\n' +
    '                     ng-value="savingsAccount.model.lastPaymentDate | date: \'shortDate\'" readonly>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-10">\n' +
    '          <div class="col-md-12">\n' +
    '            <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '              <input id="userApproves" type="checkbox" ng-model="savingsAccount.userApproves" required>\n' +
    '              <i class="input-helper"></i>\n' +
    '              <span translate="savingsOrder.termsAndConditions"></span>\n' +
    '              <a class="underline"\n' +
    '                 href="\n' +
    '                 {{(savingsAccount.savingTypesGroup[0].savingGroup == 1) ? \'https://www.addiko.si/sites/addiko.si/files/content/file/file_download/si_splosni_pogoji_obcani_varcevalni_racuni_2.pdf\' :\n' +
    '                   (savingsAccount.savingTypesGroup[0].savingGroup == 2 || savingsAccount.savingTypesGroup[0].savingGroup == 3) ? \'https://www.addiko.si/sites/addiko.si/files/content/file/file_download/si_splosni_pogoji_obcani_varcevanj_2.pdf\' :\n' +
    '                  \'\'\n' +
    '                  }}"\n' +
    '                 target="_blank"\n' +
    '                 translate="savingsOrder.termsAndConditions1"></a>\n' +
    '              <!--<span ng-if="savingsAccount.savingTypesGroup[0].savingGroup == 3" translate="savingsOrder.termsAndConditions1"></span>-->\n' +
    '              <span translate="savingsOrder.termsAndConditions2"></span>\n' +
    '              <span ng-if="savingsAccount.selectedSavingTypesGroupId != 1"\n' +
    '                    translate="savingsOrder.termsAndConditions3AddikoPlus"></span>\n' +
    '            </label>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <div class="intp-form-container bottom-border">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-6 t-a-l">\n' +
    '            <button type="button" class="btn btn-primary"\n' +
    '                    translate="termDeposit.cancelBtnLabel"\n' +
    '                    data-ui-sref="depositAccountsOverview">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 t-a-r">\n' +
    '            <button type="button" class="btn btn-default"\n' +
    '                    translate="orders.next"\n' +
    '                    ng-click="savingsAccount.next();"\n' +
    '                    ng-disabled="savingsAccount.nextButtonPressed || (!savingsAccount.savingsOrderForm.$valid || !savingsAccount.userApproves)">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ====  STEP 2 ==== -->\n' +
    '    <!-- ================= -->\n' +
    '    <div class="clearfix bg-white" ng-if="savingsAccount.steps.step2">\n' +
    '      <div class="intp-form-container bottom-border">\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="savingsOrder.savingsType"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.model.savingsType.savingDescription}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="savingsOrder.dateOfOpening"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.model.dateOfOpening | date:\'shortDate\'}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="savingsOrder.fromAccount"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.responseModel.fromAccountSelect.iban | formatIban}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="savingsAccount.selectedSavingTypesGroupId != 1">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.maturityDate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.responseModel.maturityDate | date: \'shortDate\'}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '             <span ng-switch="savingsAccount.model.savingsType.periodType">\n' +
    '                  <label class="ntd-form-label compact" ng-switch-when="K"\n' +
    '                         translate="savingsOrder.initialDepositAmount"></label>\n' +
    '                   <label class="ntd-form-label compact" ng-switch-when="D"\n' +
    '                          translate="savingsOrder.monthlyDepositAmount"></label>\n' +
    '              <label class="ntd-form-label compact" ng-switch-default\n' +
    '                     translate="savingsOrder.monthlyDepositAmount"></label>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.responseModel.amount | currency: ""}} {{savingsAccount.responseModel.currency}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="savingsAccount.model.savingsType.savingOrderTypeCalculationList.length">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.realRate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.model.savingsType.savingOrderTypeCalculationList[0].realRate | currency: "":3}} %\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="savingsAccount.model.savingsType.savingOrderTypeCalculationList.length">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.referenceRate"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.model.savingsType.savingOrderTypeCalculationList[0].referenceRateAmount | currency: "":3}} %\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <label class="domp-form-label" translate="termDeposit.totalInterestRateInputLabel"></label>\n' +
    '          </div>\n' +
    '          <div class="col-md-8">\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{savingsAccount.model.totalInterestRate | currency: "":3}} %\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="savingsAccount.model.savingsType.savingType != 5">\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="termDeposit.assignmentOfInterest"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{savingsAccount.model.interestRange.value | translate}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="savingsOrder.firstPayment"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{savingsAccount.model.firstPaymentDate | date: \'shortDate\'}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="savingsOrder.lastPayment"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{savingsAccount.model.lastPaymentDate | date: \'shortDate\'}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="intp-form-container">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-6 t-a-l">\n' +
    '            <button class="btn btn-primary"\n' +
    '                    translate="orders.back"\n' +
    '                    ng-click="savingsAccount.back()">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 t-a-r">\n' +
    '            <button class="btn btn-default"\n' +
    '                    translate="termDeposit.confirmBtnLabel"\n' +
    '                    ng-disabled="savingsAccount.confirmButtonPressed"\n' +
    '                    ng-click="savingsAccount.confirm();">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ====  STEP 3 ==== -->\n' +
    '    <!-- ================= -->\n' +
    '    <div ng-if="savingsAccount.steps.step3">\n' +
    '      <div class="payment-successful-wrapper">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '            <div class="currency-check-icon msg-pad">\n' +
    '              <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-10 m-t-30 m-b-30">\n' +
    '            <h2 class="c-white f-28" translate="orders.successOrder"></h2>\n' +
    '            <!--<div class="f-16">-->\n' +
    '            <!--<span translate="eInvoicesSubscribe.applicationCompleteText" translate-values="vm.issuer"></span>-->\n' +
    '            <!--</div>-->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '          <a href="" data-ng-click="savingsAccount.newSavingsOrder()">\n' +
    '            <span class="money-exchange-icon"><i class="icon icon-einvoice zmdi-hc-2x"></i></span>\n' +
    '            <span class="f-18 money-exchange-text" translate="savingsOrder.newSavingsOrder"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="m-t-30" ng-if="savingsAccount.steps.step1"\n' +
    '         data-ng-include="\'orders/savings-order-overview-timeline.tpl.html\'">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/deposit-overview-timeline.tpl.html',
    '<!-- TIMELINE CONTAINER -->\n' +
    '<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <div class="row p-15">\n' +
    '    <div class="col-xs-4 dropdown acc-period-select " style="display: inline-block">\n' +
    '      <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"\n' +
    '              aria-expanded="true">\n' +
    '        {{termDeposit.selectedPeriod.item.description | translate}}\n' +
    '        <span class="caret"></span>\n' +
    '      </button>\n' +
    '      <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '        <li data-ng-repeat="period in termDeposit.periodList">\n' +
    '          <a href="" class="f-13" data-ng-click="termDeposit.paymentsPeriodFilter(period)">\n' +
    '            {{period.item.description | translate}}\n' +
    '          </a>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '    </div>\n' +
    '    <div class="col-xs-8 pull-right"  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <label class="checkbox checkbox-inline m-l-15 pull-right">\n' +
    '        <input type="checkbox" data-ng-model="termDeposit.allRequests"\n' +
    '               data-ng-click="termDeposit.loadAllAccountsTimeline()">\n' +
    '        <span class="input-helper" translate="ebook.showAllRequests">Prikaži zahtjeve za sve račune</span>\n' +
    '      </label>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- ================== -->\n' +
    '  <!-- Other -->\n' +
    '  <!-- ================== -->\n' +
    '  <div ng-switch-default>\n' +
    '    <div class="timeline-row col-sm-12 no-padding">\n' +
    '      <div class="t-a-c p-10 no-data-image" ng-if="termDeposit.timelineListGrouped.result.length == 0">\n' +
    '        <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '        <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '      </div>\n' +
    '      <div class="hypo-timeline-wrapper app-white-card" ng-hide="termDeposit.timelineListGrouped.result.length == 0">\n' +
    '        <ul class="hypo-timeline" kcd-recompile="termDeposit.timelineListGrouped">\n' +
    '          <li ng-class="{\'time-label\': term.isVirtual}" ng-repeat="term in termDeposit.timelineListGrouped.result">\n' +
    '          <span class="currency-time-frame"\n' +
    '                ng-if="term.isVirtual === true">{{(term.valueDate) | date:\'shortDate\'}}</span>\n' +
    '            <i class="zmdi zmdi-timer" ng-if="!term.isVirtual"></i>\n' +
    '            <div ng-if="!term.isVirtual" class="hypo-timeline-item payment-item"\n' +
    '                 ng-click="termDeposit.showOrderDetails(term)" ng-class="{\'opened\': term.selected}">\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-xs-8 hidden-xs">\n' +
    '                  <h4 class="m-b-0 m-t-10 c-gray">\n' +
    '                    <b ng-if="term.depositType == \'CREATE\'" translate="termDeposit.newDepositOrder">}</b>\n' +
    '                    <b ng-if="term.depositType != \'CREATE\'" translate="termDeposit.earlyTermination"></b>\n' +
    '                    <b>, {{\'termDeposit.request\' | translate}}</b>\n' +
    '                    <b>{{term.id}}</b>\n' +
    '                    <b ng-if="term.termPeriod && term.termPeriod > 1">, {{term.termPeriod}} {{ \'termDeposit.month\' |\n' +
    '                      translate }}</b>\n' +
    '                    <b ng-if="term.termPeriod && term.termPeriod === 1"> , {{term.termPeriod}} {{ \'termDeposit.oneMonth\'\n' +
    '                      |\n' +
    '                      translate }}</b>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-xs-8 visible-xs p-l-0">\n' +
    '                  <h4 class="m-b-0 m-t-10 f-12 c-gray">\n' +
    '                    <b ng-if="term.depositType == \'CREATE\'" translate="termDeposit.newDepositOrder">}</b>\n' +
    '                    <b ng-if="term.depositType != \'CREATE\'" translate="termDeposit.earlyTermination"></b>\n' +
    '                    <b>, {{\'termDeposit.request\' | translate}}</b>\n' +
    '                    <b>{{term.id}}</b>\n' +
    '                    <b ng-if="term.termPeriod && term.termPeriod > 1">, {{term.termPeriod}} {{ \'termDeposit.month\' |\n' +
    '                      translate }}</b>\n' +
    '                    <b ng-if="term.termPeriod && term.termPeriod === 1"> , {{term.termPeriod}} {{ \'termDeposit.oneMonth\'\n' +
    '                      |\n' +
    '                      translate }}</b>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '                <!-- Other term types -->\n' +
    '                <div class="col-xs-4 hidden-xs">\n' +
    '                            <span class="pull-right t-a-r m-t-5 f-18">\n' +
    '                            <b>{{term.amount|number:2}} {{term.currencySymbol}}</b><br/>\n' +
    '                            <span>{{term.translatedStatus | translate}}</span>\n' +
    '                            </span>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-xs-4 visible-xs p-r-0">\n' +
    '                            <span class="pull-right t-a-r m-t-5 f-12">\n' +
    '                            <b>{{term.amount|number:2}} {{::term.currencySymbol}}</b><br/>\n' +
    '                            <span>{{term.translatedStatus | translate}}</span>\n' +
    '                            </span>\n' +
    '                </div>\n' +
    '                <div class="clear"></div>\n' +
    '              </div>\n' +
    '              <div ng-if="term.selected" class="transaction-details">\n' +
    '                <div data-ng-include="\'orders/deposit-overview-timeline-details.tpl.html\'"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '      <div class="show-more-btn ">\n' +
    '        <button ng-if="termDeposit.timelineListGrouped.hasMore"\n' +
    '                data-ng-click="termDeposit.loadMoreTimelineItemsGrouped()"\n' +
    '                type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                translate="dashboard.loadEvents">Load older events\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- ================== -->\n' +
    '  <!-- Slovenia -->\n' +
    '  <!-- ================== -->\n' +
    '  <div ng-switch-when="sl">\n' +
    '    <div class="timeline-row col-sm-12 no-padding">\n' +
    '      <div class="t-a-c p-10 no-data-image" ng-if="termDeposit.timelineListGrouped.result.length == 0">\n' +
    '        <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '        <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '      </div>\n' +
    '      <div class="hypo-timeline-wrapper app-white-card" ng-hide="termDeposit.timelineListGrouped.result.length == 0">\n' +
    '        <ul class="hypo-timeline" kcd-recompile="termDeposit.timelineListGrouped">\n' +
    '          <li ng-class="{\'time-label\': term.isVirtual}" ng-repeat="term in termDeposit.timelineListGrouped.result">\n' +
    '          <span class="currency-time-frame"\n' +
    '                ng-if="term.isVirtual === true">{{(term.valueDate) | date:\'shortDate\'}}</span>\n' +
    '            <i class="zmdi zmdi-timer" ng-if="!term.isVirtual"></i>\n' +
    '            <div ng-if="!term.isVirtual" class="hypo-timeline-item payment-item"\n' +
    '                 ng-click="termDeposit.showOrderDetails(term)" ng-class="{\'opened\': term.selected}">\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-xs-8 hidden-xs">\n' +
    '                  <h4 class="m-b-0 m-t-10 c-gray">\n' +
    '                    <b translate="termDeposit.makeTermDepositTimelineTitle"></b>\n' +
    '                    <b>, {{\'termDeposit.request\' | translate}}</b>\n' +
    '                    <b>{{term.id}}, {{term.termPeriod}} {{ \'termDeposit.durationInDays\' | translate }}</b>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-xs-8 visible-xs p-l-0">\n' +
    '                  <h4 class="m-b-0 m-t-10 f-12 c-gray">\n' +
    '                    <b translate="termDeposit.makeTermDepositTimelineTitle"></b>\n' +
    '                    <b>, {{\'termDeposit.request\' | translate}}</b>\n' +
    '                    <b>{{term.id}}, {{term.termPeriod}} {{ \'termDeposit.durationInDays\' | translate }}</b>\n' +
    '\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '                <!-- Other term types -->\n' +
    '                <div class="col-xs-4 hidden-xs">\n' +
    '                            <span class="pull-right t-a-r m-t-5 f-18">\n' +
    '                            <b>{{term.amount|number:2}} {{term.currencySymbol}}</b><br/>\n' +
    '                            <span>{{term.translatedStatus | translate}}</span>\n' +
    '                            </span>\n' +
    '                </div>\n' +
    '                <div class="col-xs-4 visible-xs p-r-0">\n' +
    '                            <span class="pull-right t-a-r m-t-5 f-12">\n' +
    '                            <b>{{term.amount|number:2}} {{::term.currencySymbol}}</b><br/>\n' +
    '                            <span>{{term.translatedStatus | translate}}</span>\n' +
    '                            </span>\n' +
    '                </div>\n' +
    '                <div class="clear"></div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div ng-if="term.selected" class="transaction-details">\n' +
    '                <div data-ng-include="\'orders/deposit-overview-timeline-details.tpl.html\'"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '      <div class="show-more-btn ">\n' +
    '        <button ng-if="termDeposit.timelineListGrouped.hasMore"\n' +
    '                data-ng-click="termDeposit.loadMoreTimelineItemsGrouped()"\n' +
    '                type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                translate="dashboard.loadEvents">Load older events\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- END TIMELINE -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/deposit-overview-timeline-details.tpl.html',
    '<div class="table-responsive hidden-xs">\n' +
    '  <table class="table table-transparent">\n' +
    '    <tbody>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="termDeposit.vrstaDepozita"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label"> {{term.depositType}} </span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="depositDetails.contractDate"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.processedDate | date: \'shortDate\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="termDeposit.executionDate"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.acceptedDate | date: \'shortDate\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="termDeposit.maturityDate"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.validToDate | date: \'shortDate\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="termDeposit.totalInterestRateInputLabel"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.interestRate | currency:""}} %</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="depositDetails.depositType"></span>\n' +
    '      </td>\n' +
    '      <td ng-switch-default>\n' +
    '        <span ng-if="term.currencySymbol === \'HRK\'" class="po-value-label"\n' +
    '              translate="depositDetails.domesticType"></span>\n' +
    '        <span ng-if="term.currencySymbol != \'HRK\'" class="po-value-label" translate="depositDetails.foreignType"></span>\n' +
    '      </td>\n' +
    '      <td ng-switch-when="sl">\n' +
    '        <span ng-if="term.currencySymbol == \'EUR\'" class="po-value-label"\n' +
    '              translate="depositDetails.domesticType"></span>\n' +
    '        <span ng-if="term.currencySymbol != \'EUR\'" class="po-value-label" translate="depositDetails.foreignType"></span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="depositDetails.payoutType"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.payoutTypeTranslate | translate}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="depositDetails.account"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.accountNumber}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="accounts.annualAssignmentOfInterests"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.assignmentOfInterest}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && term.allowedActionList.itemList.length">\n' +
    '      <tr ng-repeat-start="item in term.allowedActionList.itemList" ng-if="item.methodName === \'DownloadLinkAllowed\'">\n' +
    '        <td>\n' +
    '          <span class="po-desc-label" translate="depositDetails.contract"></span>\n' +
    '        </td>\n' +
    '        <td>\n' +
    '            <span class="po-value-label">\n' +
    '              <button class="btn btn-default" ng-click="termDeposit.downloadContract(term.id)" translate="messages.downloadAttachment">Download</button>\n' +
    '            </span>\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '\n' +
    '      <tr ng-repeat-end ng-if="item.methodName === \'DownloadTermsLinkAllowed\'">\n' +
    '        <td>\n' +
    '          <span class="po-desc-label" translate="depositDetails.termsAndConditions"></span>\n' +
    '        </td>\n' +
    '        <td>\n' +
    '          <span class="po-value-label">\n' +
    '            <button class="btn btn-default" ng-click="termDeposit.downloadTermsAndConditions(term.id)" translate="messages.downloadAttachment">Download</button>\n' +
    '          </span>\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '    </div>\n' +
    '\n' +
    '    <tr ng-if="term.referenceNumber">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="depositDetails.contract"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.referenceNumber}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && term.message && (term.status == \'Unrealised\' || term.status == \'Cancelled\')">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="depositDetails.note"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.message}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && term.orderTypeId">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="depositDetails.contract"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{term.orderTypeId}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '\n' +
    '\n' +
    '    </tbody>\n' +
    '  </table>\n' +
    '</div>\n' +
    '<!-- MOBILE -->\n' +
    '<div class="table-responsive visible-xs">\n' +
    '  <table class="table table-transparent f-10">\n' +
    '    <tbody>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="termDeposit.vrstaDepozita"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.depositType}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="depositDetails.contractDate"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.processedDate | date: \'shortDate\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="termDeposit.executionDate"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.acceptedDate | date: \'shortDate\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="termDeposit.maturityDate"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.validToDate | date: \'shortDate\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="termDeposit.totalInterestRateInputLabel"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.interestRate | currency:""}} %</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="accounts.annualAssignmentOfInterests"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.assignmentOfInterest}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="depositDetails.depositType"></span>\n' +
    '      </td>\n' +
    '      <td ng-switch-default>\n' +
    '        <span ng-if="term.currencySymbol === \'HRK\'" class="po-value-label-xs"\n' +
    '              translate="depositDetails.domesticType"></span>\n' +
    '        <span ng-if="term.currencySymbol != \'HRK\'" class="po-value-label-xs"\n' +
    '              translate="depositDetails.foreignType"></span>\n' +
    '      </td>\n' +
    '      <td ng-switch-when="sl">\n' +
    '        <span ng-if="term.currencySymbol == \'EUR\'" class="po-value-label-xs"\n' +
    '              translate="depositDetails.domesticType"></span>\n' +
    '        <span ng-if="term.currencySymbol != \'EUR\'" class="po-value-label-xs"\n' +
    '              translate="depositDetails.foreignType"></span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\'">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="depositDetails.payoutType"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.payoutTypeTranslate | translate}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="depositDetails.account"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.accountNumber}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <tr ng-if="term.referenceNumber">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="depositDetails.contract"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.referenceNumber}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && term.message && (term.status == \'Unrealised\' || term.status == \'Cancelled\')">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="depositDetails.note"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.message}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && term.orderTypeId">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label-xs" translate="depositDetails.contract"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label-xs">{{term.orderTypeId}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && term.allowedActionList.itemList.length">\n' +
    '      <tr ng-repeat-start="item in term.allowedActionList.itemList" ng-if="item.methodName === \'DownloadLinkAllowed\'">\n' +
    '        <td>\n' +
    '          <span class="po-desc-label-xs" translate="depositDetails.contract"></span>\n' +
    '        </td>\n' +
    '        <td>\n' +
    '            <span class="po-value-label-xs">\n' +
    '              <button class="btn btn-default" ng-click="termDeposit.downloadContract(term.id)" translate="messages.downloadAttachment">Download</button>\n' +
    '            </span>\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '\n' +
    '      <tr ng-repeat-end ng-if="item.methodName === \'DownloadTermsLinkAllowed\'">\n' +
    '        <td>\n' +
    '          <span class="po-desc-label-xs" translate="depositDetails.termsAndConditions"></span>\n' +
    '        </td>\n' +
    '        <td>\n' +
    '          <span class="po-value-label-xs">\n' +
    '            <button class="btn btn-default" ng-click="termDeposit.downloadTermsAndConditions(term.id)" translate="messages.downloadAttachment">Download</button>\n' +
    '          </span>\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '    </div>\n' +
    '\n' +
    '    </tbody>\n' +
    '  </table>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/closing-orders-overview-timeline.tpl.html',
    '<div class="row m-t-20">\n' +
    '  <div class="col-sm-12">\n' +
    '    <h4 translate="orders.standingOrders"></h4>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row">\n' +
    '  <div class="col-sm-12 m-b-5">\n' +
    '    <div class="dropdown acc-period-select pull-right">\n' +
    '      <button class="btn btn-default dropdown-toggle p-l-30 p-r-30" type="button" data-toggle="dropdown">\n' +
    '        {{vm.selectedPeriod.item.description| translate}}\n' +
    '        <span class="caret"></span>\n' +
    '      </button>\n' +
    '      <ul class="dropdown-menu">\n' +
    '        <li data-ng-repeat="period in vm.periodList">\n' +
    '          <a href="" class="f-13" data-ng-click="vm.timelineTimeFilter(period);">\n' +
    '            {{period.item.description| translate}}\n' +
    '          </a>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row">\n' +
    '  <div class="timeline-row col-sm-12">\n' +
    '    <div class="t-a-c p-10 no-data-image" ng-if="vm.ordersListGrouped.result.length == 0">\n' +
    '      <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '      <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '    </div>\n' +
    '    <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0" ng-hide="vm.ordersListGrouped.result.length == 0">\n' +
    '      <ul class="hypo-timeline" kcd-recompile="vm.ordersListGrouped">\n' +
    '        <li ng-repeat="order in vm.ordersListGrouped.result">\n' +
    '          <i class="icon icon-insurance currency-icon-change icon-lh"></i>\n' +
    '          <div class="hypo-timeline-item payment-item"\n' +
    '               ng-click=" vm.expandDetails(order); order.selected = !order.selected"\n' +
    '               ng-class="{\'opened\': order.selected}">\n' +
    '            <div class="hypo-timeline-body">\n' +
    '              <div class="col-xs-6">\n' +
    '\n' +
    '                <h4>\n' +
    '                  {{order.orderType.description}}\n' +
    '                </h4>\n' +
    '\n' +
    '                <span class="text-muted text-uppercase">\n' +
    '                        {{order.date}}\n' +
    '                      </span>\n' +
    '\n' +
    '              </div>\n' +
    '              <!--<div class="col-xs-6"><span class="pull-right t-a-r m-t-10"><b>{{order.statusId| orderStatusString | translate}}</b></span></div>-->\n' +
    '              <div class="col-xs-6">\n' +
    '                <span class="pull-right t-a-r m-t-10"><b>{{\'orders.\'+order.status | translate}}</b></span>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12">\n' +
    '                      <span class="text-muted">\n' +
    '                        {{order.dateCreated| date:\'short\'}}\n' +
    '                      </span>\n' +
    '              </div>\n' +
    '              <div class="clear"></div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="order.selected" class="transaction-details">\n' +
    '              <div>\n' +
    '                <table class="table table-transparent table-responsive">\n' +
    '                  <tbody>\n' +
    '                  <tr ng-if="order.id">\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="orderDetails.orderId"></span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{order.id }}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr ng-if="order.payeeName">\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="orderDetails.name"></span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{order.payeeName }}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr ng-if="order.payeeName">\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="orderDetails.payeeAccount"></span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{order.payeeAccount}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr ng-if="order.amount">\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="orderDetails.amount"></span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{order.amount | number:2}} {{order.currencySymbol}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr ng-if="order.purpose">\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="orderDetails.purpose"></span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{order.purpose}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr ng-if="order.dateCreated">\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="orderDetails.dateCreated"></span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{order.dateCreated | date: \'medium\'}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr ng-if="order.status != \'Signed\' && vm.countryCode != \'sl\'">\n' +
    '                    <td colspan="2">\n' +
    '                      <div>\n' +
    '                        <span>\n' +
    '                            <button\n' +
    '                              ng-click="vm.closeOrder(order.id);"\n' +
    '                              class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                              translate="orderDetails.close">Close order</button>\n' +
    '                          </span>\n' +
    '                      </div>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  </tbody>\n' +
    '                </table>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="show-more-btn ">\n' +
    '    <button ng-hide="vm.ordersListGrouped.hasMore == false" data-ng-click="vm.loadMoreTimelineItems()" type="input"\n' +
    '            class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '            translate="dashboard.loadEvents"></button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/cancel-deposit.tpl.html',
    '<section id="main">\n' +
    '    <div class="container">\n' +
    '        <div class="row f-14">\n' +
    '\n' +
    '            <div class="col-sm-12">\n' +
    '                <div class="app-white-card m-b-15">\n' +
    '\n' +
    '\n' +
    '                    <div ng-show="cancelDeposit.steps.step1">\n' +
    '                        <div class="intp-header-wrapper bottom-border">\n' +
    '                            <div class="row intp-header-row">\n' +
    '                                <div class="col-xs-12">\n' +
    '                                    <h2 class="intp-title" translate="cancelDeposit.cancelDepositHeader"></h2>\n' +
    '                                    <h4 translate="cancelDeposit.cancelDepositSubheader"></h4>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="intp-form-container bottom-border">\n' +
    '\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <label class="ntd-form-label" translate="cancelDeposit.capitalAmountLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <input type="text" class="form-control t-a-r" readonly ng-value="cancelDeposit.depositAccountCloseOverViewResponse.capital + \' \' + cancelDeposit.depositAccount.currencySymbol">\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <label class="ntd-form-label" translate="cancelDeposit.approvedInteresLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <input type="text" class="form-control t-a-r" readonly ng-value="cancelDeposit.depositAccountCloseOverViewResponse.approvedInterest + \' %\'">\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <label class="ntd-form-label" translate="cancelDeposit.approvedInteresAmountLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <input type="text" class="form-control t-a-r" readonly ng-value="cancelDeposit.depositAccountCloseOverViewResponse.approvedInterestInAmountOf + \' \' + cancelDeposit.depositAccount.currencySymbol">\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <label class="ntd-form-label" translate="cancelDeposit.chargesLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <input type="text" class="form-control t-a-r" readonly\n' +
    '                                           ng-value="cancelDeposit.depositAccountCloseOverViewResponse.prematureCharges + \' \'\n' +
    '                                           + (APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\') ? \'HRK\' : cancelDeposit.depositAccount.currencySymbol">\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <label class="ntd-form-label" translate="cancelDeposit.totalAmountLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <input type="text" class="form-control t-a-r" readonly ng-value="cancelDeposit.depositAccountCloseOverViewResponse.totalTransferAmount + \' \' + cancelDeposit.depositAccount.currencySymbol">\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <label class="ntd-form-label" translate="cancelDeposit.accountForFundLabel"></label>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <input type="text" class="form-control t-a-r" readonly ng-value="cancelDeposit.depositAccountCloseOverViewResponse.payoutAccount">\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="row">\n' +
    '                            <div class="col-sm-3 col-xs-6 t-a-c m-t-10 m-b-10">\n' +
    '                                <button class="btn btn-primary" translate="cancelDeposit.cancelBtn" data-ng-click="cancelDeposit.backToAccount()">Cancel</button>\n' +
    '                            </div>\n' +
    '                            <div class="col-sm-3 col-sm-offset-6 col-xs-6 t-a-c m-t-10 m-b-10">\n' +
    '                                <button class="btn btn-default" translate="cancelDeposit.confirmBtn" ng-click="cancelDeposit.confirmCancelDeposit();">Confirm</button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="p-20" ng-show="cancelDeposit.steps.step2">\n' +
    '                       <div class="row">\n' +
    '                           <div class="col-xs-12">\n' +
    '                               <h4><span translate="cancelDeposit.successInfoLabel1"></span> {{cancelDeposit.canceledDepositOrder.id}} <span translate="cancelDeposit.successInfoLabel2"></span></h4>\n' +
    '                           </div>\n' +
    '                       </div>\n' +
    '                       <br>\n' +
    '                        <div class="row">\n' +
    '                            <div class="col-sm-3 col-xs-6 t-a-l m-t-10 m-b-10">\n' +
    '                                <button class="btn btn-default" translate="cancelDeposit.requestBtn">Cancel</button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('orders/add-new-express-loan.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div ng-show="!addNewExpressLoan.steps.step3">\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12" style="z-index:1;">\n' +
    '          <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="tmplt-list-title col-md-12 p-r-0 p-l-0 m-b-15">\n' +
    '            <h2 ng-switch-default class="title-style" translate="addNewExpressLoan.header">Change overdraft limit</h2>\n' +
    '            <h2 ng-switch-when="sl" class="title-style" translate="addNewExpressLoan.header_SLO">Change overdraft limit</h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <div class="alert alert-info" style="background: white; color: black; border: 1px solid lightgray" role="alert">\n' +
    '            <p translate="addNewExpressLoan.note1"></p>\n' +
    '            <p>\n' +
    '              <span translate="addNewExpressLoan.note2"></span>\n' +
    '              <a href="https://www.addiko.si/ceniki" target="blank" class="underline" translate="addNewExpressLoan.noteLink1"></a>\n' +
    '              <span translate="addNewExpressLoan.noteAnd"></span>\n' +
    '              <a href="https://www.addiko.si/obrestne-mere" target="blank" class="underline" translate="addNewExpressLoan.noteLink2"></a>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Title -->\n' +
    '\n' +
    '    <div class="p-20 bg-white clearfix">\n' +
    '\n' +
    '      <!-- ================= -->\n' +
    '      <!-- ====  STEP 1 ==== -->\n' +
    '      <!-- ================= -->\n' +
    '      <div ng-show="addNewExpressLoan.steps.step1" >\n' +
    '      <ng-form name="addNewExpressLoan.newExpressLoanForm">\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-6">\n' +
    '              <label class="domp-form-label" translate="addNewExpressLoan.account">Account</label>\n' +
    '              <!-- START Dropdown account -->\n' +
    '              <div class="accounts-dropdown">\n' +
    '                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="addNewExpressLoan.showAccountToDropdown = !addNewExpressLoan.showAccountToDropdown" ng-style="addNewExpressLoan.selectedAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + addNewExpressLoan.selectedAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                                            {{addNewExpressLoan.selectedAccount.friendlyName}}</b>\n' +
    '                                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                                            <i class="zmdi"\n' +
    '                                               ng-class="{\'zmdi-star favorite-account\': account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                                        </span>\n' +
    '                                    </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{addNewExpressLoan.selectedAccount.iban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{addNewExpressLoan.selectedAccount.availableBalance | number:2}} {{addNewExpressLoan.selectedAccount.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  <span class="caret-icon">\n' +
    '                                        <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                                    </span>\n' +
    '                </div>\n' +
    '                <div class="from-accounts-list m-l-15" style="z-index:12343" ng-show="addNewExpressLoan.showAccountToDropdown" scrollable>\n' +
    '                  <div class="accounts-list-item p-0" data-ng-repeat="account in addNewExpressLoan.accountList" data-ng-click="addNewExpressLoan.selectAccount(account); addNewExpressLoan.showAccountToDropdown = !addNewExpressLoan.showAccountToDropdown">\n' +
    '                    <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="account.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + account.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{account.friendlyName}}</b>\n' +
    '                                                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                            </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{account.iban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{account.availableBalance | number:2}} {{account.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Dropdown account -->\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="col-xs-6">\n' +
    '              <!-- START Amount -->\n' +
    '              <div class="col-xs-12 p-0">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="addNewExpressLoan.amount">Amount</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input id="amount" name="amount" type="text" class="form-control input-field t-a-r" amount-input-mask placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" ng-model="addNewExpressLoan.tempObj.amount" ng-class="{\'domp-error\': addNewExpressLoan.newExpressLoanForm.amount.$invalid && addNewExpressLoan.formSubmitted}" maxlength="12" autocomplete="off" required>\n' +
    '                    <span class="input-group-btn">\n' +
    '                        <button type="button"\n' +
    '                                class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                                style="border:1px solid #062a42;">\n' +
    '                            {{addNewExpressLoan.selectedAccount.currencySymbol}}\n' +
    '                        </button>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <label class="c-red" ng-show="addNewExpressLoan.newExpressLoanForm.amount.$error.required && addNewExpressLoan.formSubmitted" translate="cashWithdrawalTranslate.amountRequired">\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Amount-->\n' +
    '              <div class="col-md-12 col-xs-12 p-0">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="dateInput" translate="addNewExpressLoan.approvalDate">Date:</label>\n' +
    '                  <div class="input-group ">\n' +
    '                    <input type="text" class="form-control input-field" name="dateInput"\n' +
    '                           ng-class="{\'domp-error\': addNewExpressLoan.NewExpressLoanForm.dateInput.$invalid && addNewExpressLoan.formSubmitted}"\n' +
    '                           id="dateInput" uib-datepicker-popup="shortDate" data-ng-model="addNewExpressLoan.tempObj.dateInput"\n' +
    '                           show-weeks="false" is-open="addNewExpressLoan.datePickerOpened" datepicker-options="addNewExpressLoan.dateOptions"\n' +
    '                           show-button-bar="false"\n' +
    '                           date-disabled="addNewExpressLoan.disabled(date, mode)"\n' +
    '                           readonly required>\n' +
    '                    <span class="input-group-btn">\n' +
    '                      <button ng-readonly="addNewExpressLoan.disableAllFields" data-ng-click="addNewExpressLoan.openDatePicker()" type="button"\n' +
    '                              class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '                        <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                      </button>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-md-6 p-0">\n' +
    '                  <div class="form-group">\n' +
    '                    <label class="domp-form-label" translate="addNewExpressLoan.cardType"></label>\n' +
    '                    <input name="monthsOfCredit" class="form-control input-field p-l-15 p-r-10"\n' +
    '                           ng-class="{\'domp-error\': addNewExpressLoan.newExpressLoanForm.monthsOfCredit.$invalid && addNewExpressLoan.formSubmitted}"\n' +
    '                           ng-pattern-restrict="{{addNewExpressLoan.regexPatterns.onlyNumbersWithoutFirstZero}}"\n' +
    '                           ng-model="addNewExpressLoan.tempObj.monthsOfCredit"\n' +
    '                           maxlength="3"\n' +
    '                           required/>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-6 p-r-0">\n' +
    '                  <div class="form-group">\n' +
    '                    <label class="domp-form-label" translate="addNewExpressLoan.paymentDay"></label>\n' +
    '                    <select name="paymentDay" class="form-control input-field p-l-15 p-r-10" ng-options="option.description for option in addNewExpressLoan.paymentDays " ng-model="addNewExpressLoan.tempObj.paymentDay">\n' +
    '                    </select>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          <div class="row p-b-20 p-t-20">\n' +
    '            <div class="col-md-12">\n' +
    '              <button class="btn btn-primary app-btn-blue pull-right domp-review-and-submit-btn pull-left" data-ui-sref="loansOverview">\n' +
    '                <span translate="addNewExpressLoan.cancel">Cancel</span>\n' +
    '              </button>\n' +
    '              <button class="btn btn-default  pull-right " ng-disabled="addNewExpressLoan.nextButtonPressed" ng-click="addNewExpressLoan.validateCreditPossibilityOrder()">\n' +
    '                <span translate="orders.next">Next</span>\n' +
    '              </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </ng-form>\n' +
    '    </div>\n' +
    '\n' +
    '      <!-- ================= -->\n' +
    '      <!-- ====  STEP 2 ==== -->\n' +
    '      <!-- ================= -->\n' +
    '      <div class="clearfix bg-white" ng-if="addNewExpressLoan.steps.step2">\n' +
    '        <div class="intp-form-container bottom-border">\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="addNewExpressLoan.account"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{addNewExpressLoan.responseModel.creditTransferAccount | formatIban}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '       <!-- <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="addNewExpressLoan.paymentAccount"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{addNewExpressLoan.responseModel.paymentAccount}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>-->\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="addNewExpressLoan.amount"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{addNewExpressLoan.responseModel.amount | currency:""}} {{addNewExpressLoan.selectedAccount.currencySymbol}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="addNewExpressLoan.cardType"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{addNewExpressLoan.responseModel.period}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="addNewExpressLoan.paymentDay"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{addNewExpressLoan.responseModel.orderTearDate.id }}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-4">\n' +
    '              <label class="domp-form-label" translate="addNewExpressLoan.approvalDate"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-8">\n' +
    '              <label class="domp-form-label-resume">\n' +
    '                {{addNewExpressLoan.responseModel.approvalDate | date: \'shortDate\'}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="intp-form-container">\n' +
    '          <div class="row">\n' +
    '            <div class="col-xs-6 t-a-l">\n' +
    '              <button class="btn btn-primary"\n' +
    '                      translate="orders.back"\n' +
    '                      ng-click="addNewExpressLoan.back()">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 t-a-r">\n' +
    '              <button class="btn btn-default"\n' +
    '                      translate="addNewExpressLoan.confirm"\n' +
    '                      ng-disabled="addNewExpressLoan.confirmButtonPressed"\n' +
    '                      ng-click="addNewExpressLoan.confirmCreditPossibilityOrder();">\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- ================= -->\n' +
    '      <!-- ====  STEP 3 ==== -->\n' +
    '      <!-- ================= -->\n' +
    '      <div ng-if="addNewExpressLoan.steps.step3">\n' +
    '        <div class="payment-successful-wrapper">\n' +
    '          <div class="row">\n' +
    '            <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '              <div class="currency-check-icon msg-pad">\n' +
    '                <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-10 m-t-30 m-b-30">\n' +
    '              <h2 class="c-white f-28" translate="orders.successOrder"></h2>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-4">\n' +
    '            <a href="" data-ng-click="addNewExpressLoan.addNewExpressLoan()">\n' +
    '              <span class="money-exchange-icon"><i class="icon icon-einvoice zmdi-hc-2x"></i></span>\n' +
    '              <span class="f-18 money-exchange-text" translate="addNewExpressLoan.addNewExpressLoan"></span>\n' +
    '            </a>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('navigation/secondary-navigation.tpl.html',
    '<!-- Tablet and desktop -->\n' +
    '<div id="secondaryNavigationLarge" class="sn-body-container hidden-xs" ng-if="navigation.isSecondaryNavigationOpen"\n' +
    '     click-outside="navigation.closeSecondaryNavigation()" outside-if-not="primaryNavigationLarge">\n' +
    '\n' +
    '  <!-- Accounts -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Accounts\'">\n' +
    '      <div class="navigation-item" data-ui-sref="accountsOverview" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'AccountsOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.allAccountsOverview"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="navigation-scrollable-height" scrollable>\n' +
    '      <!-- First show user favorite items, then sort by iban -->\n' +
    '      <li class="no-bullet-list"\n' +
    '          data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '          data-ui-sref="accounts({accountId: item.accountId})" data-ng-click="navigation.closeSecondaryNavigation()">\n' +
    '        <div class="navigation-item">\n' +
    '\n' +
    '          <span class="navigation-item-header">\n' +
    '            {{ item.friendlyName | limitTo: 15 }}{{item.friendlyName.length > 15 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <span ng-if="navigation.countryCode != \'sl\' || item.accountType.group != \'CardAccountTypes\'" class="navigation-item-iban">{{item.iban | formatIban}}</span>\n' +
    '          <span ng-if="navigation.countryCode == \'sl\' && (item.accountType.group === \'CardAccountTypes\')" class="navigation-item-iban" ng-bind="item.accountNumber"></span>\n' +
    '\n' +
    '          <i ng-if="!item.isFavorite" class="zmdi zmdi-star-outline zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <i ng-if="item.isFavorite" class="zmdi zmdi-star zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '\n' +
    '          <!--<span class="navigation-item-value" ng-bind="(item.availableBalance | number:2) + \' \' + (item.currencySymbol)"></span>-->\n' +
    '<!--          <amount-formatter amount="{{item.availableBalance| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                            currency="{{item.currencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '          <span class="navigation-item-description" translate="navigation.availableBalance"></span>-->\n' +
    '          <amount-formatter amount="{{item.balance| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                            currency="{{item.currencySymbol}}" from-type="navigation" aditional-val="{{item.availableBalance| number:2}}"></amount-formatter>\n' +
    '          <span ng-if="navigation.countryCode == \'sl\' && item.accountType.group === \'CardAccountTypes\'" class="navigation-item-description" translate="accounts.accBalance"></span>\n' +
    '          <span ng-if="navigation.countryCode !== \'sl\' || item.accountType.group !== \'CardAccountTypes\'"  class="navigation-item-description" translate="accounts.balance"></span>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '<!-- Deposits -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Deposit\'">\n' +
    '      <div class="navigation-item" data-ui-sref="depositAccountsOverview"  data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'DepositAccountsOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" ng-if="navigation.countryCode != \'sr\' && navigation.countryCode != \'mne\'" translate="navigation.allDepositOverview"></span>\n' +
    '      <span class="navigation-item-header-smaller" ng-if="navigation.countryCode == \'sr\' || navigation.countryCode == \'mne\'" translate="navigation.allDepositOverviewSerbMne"></span>\n' +
    '    </div>\n' +
    '    <div class="navigation-scrollable-height" scrollable>\n' +
    '      <!-- First show user favorite items, then sort by iban -->\n' +
    '      <li class="no-bullet-list"\n' +
    '          data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '          data-ui-sref="accounts({accountId: item.accountId})" data-ng-click="navigation.closeSecondaryNavigation()">\n' +
    '        <div class="navigation-item">\n' +
    '\n' +
    '          <span class="navigation-item-header">\n' +
    '            {{ item.friendlyName | limitTo: 15 }}{{item.friendlyName.length > 15 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <span class="navigation-item-iban" ng-bind="item.iban"></span>\n' +
    '\n' +
    '          <i ng-if="!item.isFavorite" class="zmdi zmdi-star-outline zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <i ng-if="item.isFavorite" class="zmdi zmdi-star zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '\n' +
    '          <!--<span class="navigation-item-value" ng-bind="(item.availableBalance | number:2) + \' \' + (item.currencySymbol)"></span>-->\n' +
    '          <!-- <div ng-if="item.accountType.group !== \'SavingAccountTypes\' && item.accountType.group !== \'DepositAccountTypes\'">\n' +
    '            <amount-formatter amount="{{item.availableBalance| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                              currency="{{item.currencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '            <span class="navigation-item-description" translate="navigation.availableBalance"></span>\n' +
    '          </div>-->\n' +
    '          <div>\n' +
    '            <amount-formatter amount="{{item.balance| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                              currency="{{item.currencySymbol}}" from-type="navigation" aditional-val="{{item.availableBalance| number:2}}"></amount-formatter>\n' +
    '            <span class="navigation-item-description" translate="navigation.balance"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Payments -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Payments\'">\n' +
    '    <!-- <div class="navigation-item" data-ui-sref="payments.paymentsAndTransferOverview" data-ng-click="navigation.closeSecondaryNavigation()">\n' +
    '     <span class="navigation-item-header-smaller" translate="navigation.paymentsAndTransfers"></span>\n' +
    '   </div>\n' +
    '    -->\n' +
    '    <div class="navigation-scrollable-height" scrollable>\n' +
    '        <div class="navigation-item" data-ui-sref="payments.paymentsOverview" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'PaymentsOverview\', true);">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.paymentsList"></span>\n' +
    '      </div>\n' +
    '        <div class="navigation-item" data-ui-sref="payments.domesticPayment" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'DomesticPayment\', true);">\n' +
    '        <span ng-if="navigation.countryCode != \'sl\'" class="navigation-item-header-smaller" translate="navigation.domesticPayment"></span>\n' +
    '        <span ng-if="navigation.countryCode == \'sl\'" class="navigation-item-header-smaller" translate="navigation.domesticPaymentSl"></span>\n' +
    '      </div>\n' +
    '\n' +
    '        <div class="navigation-item" data-ui-sref="payments.internalTransfer" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'TransferToMyAccount\', true);">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.transferToMyAccount"></span>\n' +
    '      </div>\n' +
    '\n' +
    '        <div class="navigation-item" data-ui-sref="payments.internationalPayment" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'InternationalPayment\', true);"\n' +
    '          ng-if="navigation.countryCode === \'hr\' || navigation.countryCode === \'sl\' " >\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.internationalPayment"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <!--<div class="navigation-item" data-ui-sref="payments.currencyConversion" data-ng-click="navigation.closeSecondaryNavigation()">-->\n' +
    '        <!--<span class="navigation-item-header-smaller" translate="navigation.exchangeOffice"></span>-->\n' +
    '      <!--</div>-->\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="payments.currencyConversion"\n' +
    '           data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'CurrencyConversion\', true);" ng-if="navigation.countryCode != \'mne\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.exchangeOffice"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="payments.exchangeRates"\n' +
    '           data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'ExchangeRates\', true);" ng-if="navigation.countryCode == \'mne\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.exchangeRates"></span>\n' +
    '      </div>\n' +
    '\n' +
    '        <div class="navigation-item" data-ui-sref="eInvoices.einvoicesOverview"\n' +
    '             data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'eInvoicesOverview\', true);"\n' +
    '             ng-if="navigation.links.eInvoiceSubscriptions" >\n' +
    '        <span class="navigation-item-header-smaller"\n' +
    '              translate="{{APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'navigation.eInvoicesSlo\':\'navigation.eInvoices\' }}"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <!--\n' +
    '        <div class="navigation-item" data-ui-sref="payments.paymentsOverview" data-ng-click="navigation.closeSecondaryNavigation()">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.paymentsList"></span>\n' +
    '      </div>\n' +
    '      -->\n' +
    '\n' +
    '      <!--<div class="navigation-item">-->\n' +
    '      <!--<span class="navigation-item-header-smaller" translate="navigation.directDebitsList"></span>-->\n' +
    '      <!--</div>-->\n' +
    '\n' +
    '        <div class="navigation-item"  data-ui-sref="paymentTemplates.templateListOverview" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'TemplateListOverview\', true);">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.myTemplatesList"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'N\'"\n' +
    '           class="navigation-item" data-ui-sref="orders" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'StandingOrders\', true);" ng-if="navigation.links.orders">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.standingOrders"></span>\n' +
    '      </div>\n' +
    '\n' +
    '        <div class="navigation-item" data-ui-sref="payments.paymentsReturn" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'PaymentsReturn\', true);" ng-if="navigation.countryCode === \'hr\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.paymentsReturn"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- TODO: needs better implementation, waiting for API -->\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="sepa.transactions" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaTransactions\', true);" ng-if="navigation.countryCode === \'sl\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.sepaTransactions"></span>\n' +
    '      </div>\n' +
    '      <div class="navigation-item" data-ui-sref="sepa.transactions" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaTransactions\', true);" ng-if="navigation.countryCode === \'hr\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.sepaTransactions_CRO"></span>\n' +
    '      </div>\n' +
    '        <div class="navigation-item" data-ui-sref="sepa.settings" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaSettings\', true);" ng-if="navigation.countryCode === \'sl\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.sepa"></span>\n' +
    '      </div>\n' +
    '      <div class="navigation-item" data-ui-sref="sepa.settings-cro" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaSettings\', true);" ng-if="navigation.countryCode === \'hr\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.sepa_CRO"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Loans -->\n' +
    '    <div ng-show="navigation.currentNavigationItem === \'Loans\'" ui-sref="loansOverview" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'LoansOverview\', true);">\n' +
    '    <div class="navigation-item">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.loansOverview"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="navigation-scrollable-height" scrollable>\n' +
    '      <li class="no-bullet-list" data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '          data-ui-sref="accounts({accountId: item.accountId})" data-ng-click="navigation.closeSecondaryNavigation()">\n' +
    '        <div class="navigation-item">\n' +
    '          <span class="navigation-item-header">\n' +
    '            {{ item.friendlyName | limitTo: 15 }}{{item.friendlyName.length > 15 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <i ng-if="!item.isFavorite" class="zmdi zmdi-star-outline zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <i ng-if="item.isFavorite" class="zmdi zmdi-star zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <!--<span class="navigation-item-value"-->\n' +
    '          <!--ng-bind="(item.loanAccount.loanAmount | number:2) + \' \' + (item.loanAccount.loanAmountCurrencySymbol)"></span>-->\n' +
    '\n' +
    '          <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '              <span ng-switch-when="hr">\n' +
    '                 <amount-formatter  amount="{{item.loanAccount.loanAmount| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                                   currency="{{item.loanAccount.loanAmountCurrencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '                 <span class="navigation-item-description" translate="navigation.allowedLoan"></span>\n' +
    '              </span>\n' +
    '              <span ng-switch-when="sl">\n' +
    '                 <amount-formatter ng-if="item.accountType.group == \'LoanAccountType\' && item.balance" amount="{{item.balance | number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                           currency="EUR" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '\n' +
    '                <amount-formatter  ng-if="item.accountType.group != \'LoanAccountType\'" amount="{{item.balance | number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                           currency="{{item.loanAccount.loanAmountCurrencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '                <span ng-if="item.balance" class="navigation-item-description" translate="navigation.loanBalance"></span>\n' +
    '              </span>\n' +
    '              <span ng-switch-default>\n' +
    '              <!--BIH, Serbia, Montenegro-->\n' +
    '              <amount-formatter ng-if="item.accountType.group == \'LoanAccountType\' && item.balance" amount="{{item.balance | number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                                currency="{{item.currencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '                <span ng-if="item.balance" class="navigation-item-description" translate="navigation.loanBalance"></span>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '\n' +
    '          <!--          <span class="navigation-item-description"\n' +
    '                          ng-bind="(item.loanAccount.installmentAmount) + \' \' + (item.loanAccount.installmentCurrencySymbol)"></span>-->\n' +
    '\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Investments -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Investments\'">\n' +
    '\n' +
    '      <div class="navigation-item" ui-sref="investments.list" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'InvestmentsOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.investmentsOverview"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <li class="no-bullet-list" data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '        data-ui-sref="investments.overview({fundId: item.id})"\n' +
    '        data-ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="navigation-item">\n' +
    '        <span class="navigation-item-header wrap-text d-block">{{item.fundName}}</span>\n' +
    '        <span class="navigation-item-header" style="margin-right: 0 !important; position: absolute; right: 0; top: 8px;;"><i class="zmdi zmdi-star-outline zmdi-hc-lg" style="float: right !important;"></i></span>\n' +
    '        <div ng-if="item.totalShareValue != undefined">\n' +
    '          <amount-formatter amount="{{item.totalShareValue| number: 2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                            currency="{{item.currency}}" from-type="navigation"></amount-formatter>\n' +
    '          <span class="navigation-item-description" translate="investOverview.totalShareValue"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </li>\n' +
    '    <li class="no-bullet-list" >\n' +
    '      <div class="navigation-item" ui-sref-opts="{reload: true, notify: true}" data-ng-click="navigation.gotoNewOrder();">\n' +
    '        <span class="navigation-item-header" translate="navigation.newOrder">New Order</span>\n' +
    '      </div>\n' +
    '    </li>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Settings -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Settings\'">\n' +
    '      <div class="navigation-item" data-ui-sref="settings" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'Settings\', true);">\n' +
    '      <span class="navigation-item-header-smaller" data-ui-sref="settings" translate="navigation.settings"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Buttons -->\n' +
    '  <div class="accounts-overview-navigation-footer navigation-item" ng-if="(navigation.currentNavigationItem == \'Accounts\' || navigation.currentNavigationItem == \'Deposit\') &&\n' +
    '       (navigation.countryCode != \'sr\' && navigation.countryCode != \'sl\')">\n' +
    '      <div class="term-deposit-navigation-btn" ng-if="navigation.links.openingPermanentOrders" ui-sref="orders.termDeposit" ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'NewTermDeposit\', true);">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <span class="new-term-deposit-label" translate="accountsOverview.newTermDepositButtonLabel"></span>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="term-deposit-navigation-btn" ng-if="navigation.links.eSavingBookRequests"  ui-sref="newEbook({myParam:navigation.generalTerms})" ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'eSavingBookRequests\', true);">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <div ng-switch="navigation.countryCode">\n' +
    '          <span ng-switch-when="sl" class="new-term-deposit-label" translate="accountsOverview.newSavingButtonLabel_SLO"></span>\n' +
    '          <span ng-switch-default class="new-term-deposit-label" translate="accountsOverview.newESavingAccountButtonLabel"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '<!--    <button ng-if="navigation.countryCode === \'hr\'" ui-sref="orders.termDeposit" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <b translate="accountsOverview.newTermDepositButtonLabel"></b>\n' +
    '    </button>-->\n' +
    '<!--    <button ng-if="navigation.countryCode != \'hr\'" >\n' +
    '      <b translate="accountsOverview.newTermDepositButtonLabel"></b>\n' +
    '    </button>-->\n' +
    '<!--    <button ui-sref="newEbook" ng-click="navigation.closeSecondaryNavigation()"\n' +
    '            ng-if="navigation.countryCode != \'sr\' && navigation.countryCode != \'mne\'">\n' +
    '      <b translate="accountsOverview.newESavingAccountButtonLabel" ></b>\n' +
    '    </button>-->\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Button Group For Slovenia-->\n' +
    '    <div class="accounts-overview-navigation-footer navigation-item" ng-if="(navigation.currentNavigationItem == \'Accounts\' || navigation.currentNavigationItem == \'Deposit\' || navigation.currentNavigationItem == \'Loans\') && (navigation.countryCode == \'sl\')">\n' +
    '\n' +
    '    <div class="term-deposit-navigation-btn" ng-if="navigation.currentNavigationItem == \'Accounts\'" ng-click="navigation.openPayLifeBalancePage(); navigation.closeSecondaryNavigation()">\n' +
    '\n' +
    '      <span class="new-term-deposit-label" translate="accountsOverview.masterCardStateButtonLabel_SLO">Prepaid MasterCard balance</span>\n' +
    '    </div>\n' +
    '    <div class="term-deposit-navigation-btn" ng-if="navigation.currentNavigationItem == \'Accounts\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'" ui-sref="masterCardNew" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <span class="new-term-deposit-label" translate="accountsOverview.newSavingButtonLabel_SLO">New MasterCard Order</span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="term-deposit-navigation-btn"\n' +
    '         ng-if="navigation.links.openingPermanentOrders && navigation.currentNavigationItem == \'Deposit\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'"\n' +
    '         ui-sref="orders.termDeposit" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <span class="new-term-deposit-label" translate="accountsOverview.newTermDepositButtonLabel"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Treba ga pokazati - Not yet implemented -->\n' +
    '    <!--<div class="term-deposit-navigation-btn" ng-if="navigation.links.eSavingBookRequests && navigation.currentNavigationItem == \'Deposit\'"  ui-sref="newEbook({myParam:navigation.generalTerms})" ng-click="navigation.closeSecondaryNavigation()">-->\n' +
    '    <div class="term-deposit-navigation-btn"\n' +
    '         ng-if="navigation.currentNavigationItem == \'Deposit\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'"\n' +
    '         ui-sref="orders.newSavingsOrder" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <div>\n' +
    '        <span class="new-term-deposit-label" translate="accountsOverview.newESavingAccountButtonLabel_SLO"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="term-deposit-navigation-btn" ng-if="navigation.currentNavigationItem == \'Loans\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'"\n' +
    '           ui-sref="orders.addNewExpressLoan" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '          <div class="add-term-deposit-navigation-wrapper">\n' +
    '              <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '          </div>\n' +
    '          <span class="new-term-deposit-label" translate="addNewExpressLoan.addNewExpressLoan">New Express Loan Order</span>\n' +
    '      </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!-------------------------------------------------->\n' +
    '<!--           On small devices                   -->\n' +
    '<!-------------------------------------------------->\n' +
    '\n' +
    '<div id="secondaryNavigationMobile" class="sn-body-container visible-xs" ng-if="navigation.isMobileSecondaryNavigationOpen"\n' +
    '     click-outside="navigation.closeMobileNavigation()">\n' +
    '\n' +
    '  <!-- Accounts -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Accounts\'">\n' +
    '      <div class="navigation-item" data-ui-sref="accountsOverview" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'AccountsOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.allAccountsOverview"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="navigation-scrollable-height" scrollable>\n' +
    '      <li class="no-bullet-list" data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '          data-ui-sref="accounts({accountId: item.accountId})" data-ng-click="navigation.closeMobileNavigation()">\n' +
    '        <div class="navigation-item">\n' +
    '          <span class="navigation-item-header">\n' +
    '            {{ item.friendlyName | limitTo: 15 }}{{item.friendlyName.length > 15 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <span class="navigation-item-description" ng-bind="item.iban"></span>\n' +
    '          <i ng-if="!item.isFavorite" class="zmdi zmdi-star-outline zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <i ng-if="item.isFavorite" class="zmdi zmdi-star zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <!--<span class="navigation-item-value" ng-bind="(item.balance | number:2) + \' \' + (item.currencySymbol)"></span>-->\n' +
    '          <amount-formatter amount="{{item.balance| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                            currency="{{item.currencySymbol}}" from-type="navigation"></amount-formatter>\n' +
    '          <span class="navigation-item-description" translate="navigation.availableBalance"></span>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Deposit\'">\n' +
    '      <div class="navigation-item" data-ui-sref="depositAccountsOverview" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'DepositAccountsOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" ng-if="navigation.countryCode != \'sr\' && navigation.countryCode != \'mne\'" translate="navigation.allDepositOverview"></span>\n' +
    '      <span class="navigation-item-header-smaller" ng-if="navigation.countryCode == \'sr\' || navigation.countryCode == \'mne\'" translate="navigation.allDepositOverviewSerbMne"></span>\n' +
    '    </div>\n' +
    '    <div class="navigation-scrollable-height" scrollable>\n' +
    '      <!-- First show user favorite items, then sort by iban -->\n' +
    '      <li class="no-bullet-list"\n' +
    '          data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '          data-ui-sref="accounts({accountId: item.accountId})" data-ng-click="navigation.closeMobileNavigation()">\n' +
    '        <div class="navigation-item">\n' +
    '\n' +
    '          <span class="navigation-item-header">\n' +
    '            {{ item.friendlyName | limitTo: 15 }}{{item.friendlyName.length > 15 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <span class="navigation-item-iban" ng-bind="item.iban"></span>\n' +
    '\n' +
    '          <i ng-if="!item.isFavorite" class="zmdi zmdi-star-outline zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <i ng-if="item.isFavorite" class="zmdi zmdi-star zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '\n' +
    '          <!--<span class="navigation-item-value" ng-bind="(item.availableBalance | number:2) + \' \' + (item.currencySymbol)"></span>-->\n' +
    '          <amount-formatter amount="{{item.availableBalance| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                            currency="{{item.currencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '          <span class="navigation-item-description" translate="navigation.availableBalance"></span>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="accounts-overview-navigation-footer navigation-item" ng-if="(navigation.currentNavigationItem == \'Accounts\' || navigation.currentNavigationItem == \'Deposit\') &&\n' +
    '       (navigation.countryCode != \'sr\' && navigation.countryCode != \'sl\')">\n' +
    '    <div class="term-deposit-navigation-btn" ng-if="navigation.links.openingPermanentOrders" ui-sref="orders.termDeposit" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <span class="new-term-deposit-label m-t-10" translate="accountsOverview.newTermDepositButtonLabel"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="term-deposit-navigation-btn" ng-if="navigation.links.eSavingBookRequests"  ui-sref="newEbook({myParam:navigation.generalTerms})" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <div ng-switch="navigation.countryCode">\n' +
    '          <span ng-switch-default class="new-term-deposit-label m-t-10" translate="accountsOverview.newESavingAccountButtonLabel"></span>\n' +
    '          <span ng-switch-when="sl"  class="new-term-deposit-label m-t-10" translate="accountsOverview.newSavingButtonLabel_SLO"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '<!--    <button ui-sref="orders.termDeposit" data-ng-click="navigation.closeMobileNavigation()">\n' +
    '      <b translate="accountsOverview.newTermDepositButtonLabel"></b>\n' +
    '    </button>-->\n' +
    '<!--    <button ui-sref="newEbook" data-ng-click="navigation.closeMobileNavigation()" ng-if="navigation.countryCode != \'sr\' && navigation.countryCode != \'mne\'">\n' +
    '      <b translate="accountsOverview.newESavingAccountButtonLabel"></b>\n' +
    '    </button>-->\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="accounts-overview-navigation-footer navigation-item" ng-if="navigation.countryCode == \'sl\'" style="bottom: 40px;">\n' +
    '\n' +
    '    <div class="term-deposit-navigation-btn" ng-if="navigation.currentNavigationItem == \'Accounts\'" ng-click="navigation.openPayLifeBalancePage(); navigation.closeSecondaryNavigation()">\n' +
    '\n' +
    '      <span class="new-term-deposit-label">Prepaid MasterCard balance</span>\n' +
    '    </div>\n' +
    '    <div class="term-deposit-navigation-btn" ng-if="navigation.currentNavigationItem == \'Accounts\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'" ui-sref="masterCardNew" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <span class="new-term-deposit-label">New MasterCard Order</span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="term-deposit-navigation-btn"\n' +
    '         ng-if="navigation.links.openingPermanentOrders && navigation.currentNavigationItem == \'Deposit\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'" ui-sref="orders.termDeposit" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <span class="new-term-deposit-label m-t-10" translate="accountsOverview.newTermDepositButtonLabel"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <!--<div class="term-deposit-navigation-btn" ng-if="navigation.links.eSavingBookRequests"  ui-sref="newEbook({myParam:navigation.generalTerms})" ng-click="navigation.closeSecondaryNavigation()">-->\n' +
    '    <div class="term-deposit-navigation-btn" ng-if="navigation.currentNavigationItem == \'Deposit\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'" ui-sref="orders.newSavingsOrder" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '      <div class="add-term-deposit-navigation-wrapper">\n' +
    '        <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '      </div>\n' +
    '      <span class="new-term-deposit-label" translate="accountsOverview.newESavingAccountButtonLabel_SLO"></span>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="term-deposit-navigation-btn" ng-if="navigation.currentNavigationItem == \'Loans\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'" ui-sref="orders.addNewExpressLoan" ng-click="navigation.closeSecondaryNavigation()">\n' +
    '          <div class="add-term-deposit-navigation-wrapper">\n' +
    '              <i class="icon icon-add c-white f-w-bolder"></i>\n' +
    '          </div>\n' +
    '          <span class="new-term-deposit-label">New Express Loan Order</span>\n' +
    '      </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Payments -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Payments\'" scrollable>\n' +
    '    <!-- <div class="navigation-item" data-ui-sref="payments.paymentsAndTransferOverview" data-ng-click="navigation.closeMobileNavigation()">\n' +
    '    <span class="navigation-item-header-smaller" translate="navigation.paymentsAndTransfers"></span>\n' +
    '  </div>\n' +
    '    -->\n' +
    '      <div class="navigation-item" data-ui-sref="payments.paymentsOverview" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'PaymentsOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.paymentsList"></span>\n' +
    '    </div>\n' +
    '      <div class="navigation-item" data-ui-sref="payments.domesticPayment" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'DomesticPayment\', true);">\n' +
    '      <span ng-if="navigation.countryCode != \'sl\'" class="navigation-item-header-smaller" translate="navigation.domesticPayment"></span>\n' +
    '      <span ng-if="navigation.countryCode == \'sl\'" class="navigation-item-header-smaller" translate="navigation.domesticPaymentSl"></span>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="payments.internalTransfer" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'TransferToMyAccount\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.transferToMyAccount"></span>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="payments.internationalPayment" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'InternationalPayment\', true);"\n' +
    '         ng-if="navigation.countryCode === \'hr\' || navigation.countryCode === \'sl\'">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.internationalPayment"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <!--<div class="navigation-item" data-ui-sref="payments.currencyConversion" data-ng-click="navigation.closeMobileNavigation()">-->\n' +
    '      <!--<span class="navigation-item-header-smaller" translate="navigation.exchangeOffice"></span>-->\n' +
    '    <!--</div>-->\n' +
    '\n' +
    '    <div class="navigation-item" data-ui-sref="payments.currencyConversion"\n' +
    '         data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'CurrencyConversion\', true);" ng-if="navigation.countryCode != \'mne\'">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.exchangeOffice"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="navigation-item" data-ui-sref="payments.exchangeRates"\n' +
    '         data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'ExchangeRates\', true);" ng-if="navigation.countryCode == \'mne\'">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.exchangeRates"></span>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="navigation-item" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'eInvoicesOverview\', true);" data-ui-sref="eInvoices.einvoicesOverview" ng-if="navigation.links.eInvoiceSubscriptions">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.eInvoices"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <!--<div class="navigation-item" data-ui-sref="payments.paymentsOverview" data-ng-click="navigation.closeMobileNavigation()">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.paymentsList"></span>\n' +
    '    </div>-->\n' +
    '\n' +
    '    <!--    <div class="navigation-item">\n' +
    '          <span class="navigation-item-header-smaller" translate="navigation.directDebitsList"></span>\n' +
    '        </div>-->\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="paymentTemplates.templateListOverview" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'TemplateListOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.myTemplatesList"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'N\'"\n' +
    '         class="navigation-item" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'StandingOrders\', true);" data-ui-sref="orders" ng-if="navigation.links.orders">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.standingOrders"></span>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="payments.paymentsReturn" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'PaymentsReturn\', true);" ng-if="navigation.countryCode === \'hr\'">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.paymentsReturn"></span>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <!-- TODO: needs better implementation, waiting for API -->\n' +
    '\n' +
    '\n' +
    '      <div class="navigation-item" data-ui-sref="sepa.transactions" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaTransactions\', true);" ng-if="navigation.countryCode === \'sl\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.sepaTransactions"></span>\n' +
    '      </div>\n' +
    '      <div class="navigation-item" data-ui-sref="sepa.transactions" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaTransactions\', true);" ng-if="navigation.countryCode === \'hr\'">\n' +
    '        <span class="navigation-item-header-smaller" translate="navigation.sepaTransactions_CRO"></span>\n' +
    '      </div>\n' +
    '      <div class="navigation-item" data-ui-sref="sepa.settings" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaSettings\', true);" ng-if="navigation.countryCode === \'sl\'">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.sepa"></span>\n' +
    '    </div>\n' +
    '    <div class="navigation-item" data-ui-sref="sepa.settings-cro" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'SepaSettings\', true);" ng-if="navigation.countryCode === \'hr\'">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.sepa_CRO"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Loans -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Loans\'">\n' +
    '      <div class="navigation-item" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'LoansOverview\', true);" data-ui-sref="loansOverview">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.loansOverview"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="navigation-scrollable-height" scrollable>\n' +
    '      <li class="no-bullet-list" data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '          data-ui-sref="accounts({accountId: item.accountId})" data-ng-click="navigation.closeMobileNavigation()">\n' +
    '        <div class="navigation-item">\n' +
    '          <span class="navigation-item-header" >\n' +
    '            {{ item.friendlyName | limitTo: 15 }}{{item.friendlyName.length > 15 ? \'...\' : \'\'}}\n' +
    '          </span>\n' +
    '          <i ng-if="!item.isFavorite" class="zmdi zmdi-star-outline zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <i ng-if="item.isFavorite" class="zmdi zmdi-star zmdi-hc-2x pull-right favorite-icon"></i>\n' +
    '          <!--<span class="navigation-item-value"-->\n' +
    '          <!--ng-bind="(item.loanAccount.loanAmount | number:2) + \' \' + (item.loanAccount.loanAmountCurrencySymbol)"></span>-->\n' +
    '          <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '              <span ng-switch-when="hr">\n' +
    '                 <amount-formatter  amount="{{item.loanAccount.loanAmount| number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                                    currency="{{item.loanAccount.loanAmountCurrencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '                 <span class="navigation-item-description" translate="navigation.allowedLoan"></span>\n' +
    '              </span>\n' +
    '            <span ng-switch-when="sl">\n' +
    '                 <amount-formatter ng-if="item.accountType.group == \'LoanAccountType\' && item.balance" amount="{{item.balance | number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                                   currency="EUR" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '\n' +
    '                <amount-formatter  ng-if="item.accountType.group != \'LoanAccountType\'" amount="{{item.balance | number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                                   currency="{{item.loanAccount.loanAmountCurrencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '                <span ng-if="item.balance" class="navigation-item-description" translate="navigation.loanBalance"></span>\n' +
    '              </span>\n' +
    '            <span ng-switch-default>\n' +
    '              <!--BIH, Serbia, Montenegro-->\n' +
    '              <amount-formatter ng-if="item.accountType.group == \'LoanAccountType\' && item.balance" amount="{{item.balance | number:2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                            currency="{{item.currencySymbol}}" from-type="navigation" aditional-val="{{item.balance| number:2}}"></amount-formatter>\n' +
    '                <span ng-if="item.balance" class="navigation-item-description" translate="navigation.loanBalance"></span>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '          <!--          <span class="navigation-item-description"\n' +
    '                          ng-bind="(item.loanAccount.installmentAmount) + \' \' + (item.loanAccount.installmentCurrencySymbol)"></span>-->\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Investments -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Investments\'">\n' +
    '\n' +
    '      <div class="navigation-item" ui-sref="investments.list" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'InvestmentsOverview\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.investmentsOverview"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <li class="no-bullet-list" data-ng-repeat="item in navigation.navigationSubItems"\n' +
    '        data-ui-sref="investments.overview({fundId: item.id})"\n' +
    '        data-ng-click="navigation.closeMobileNavigation()">\n' +
    '      <div class="navigation-item">\n' +
    '        <span class="navigation-item-header">{{item.fundName}}\n' +
    '          <i class="zmdi zmdi-star-outline zmdi-hc-lg pull-right"></i>\n' +
    '        </span>\n' +
    '        <div ng-if="item.totalShareValue != undefined">\n' +
    '          <amount-formatter amount="{{item.totalShareValue| number: 2}}" custom-classes="navigation-item-value nav-amount-lbl"\n' +
    '                            currency="{{item.currency}}" from-type="navigation"></amount-formatter>\n' +
    '          <span class="navigation-item-description" translate="investOverview.totalShareValue"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </li>\n' +
    '    <li class="no-bullet-list" data-ng-click="navigation.closeMobileNavigation()">\n' +
    '      <div class="navigation-item" ui-sref-opts="{reload: true, notify: true}" data-ng-click="navigation.gotoNewOrder();">\n' +
    '        <span class="navigation-item-header"  translate="navigation.newOrder">New Order</span>\n' +
    '      </div>\n' +
    '    </li>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Settings -->\n' +
    '  <div ng-show="navigation.currentNavigationItem === \'Settings\'">\n' +
    '      <div class="navigation-item" data-ui-sref="settings" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'Settings\', true);">\n' +
    '      <span class="navigation-item-header-smaller" translate="navigation.settings"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('navigation/primary-navigation.tpl.html',
    '<div id="primaryNavigationLarge" class="hidden-xs primary-navigation" scrollable>\n' +
    '\n' +
    '    <ul class="primary-navigation-list p-t-10">\n' +
    '        <li data-ui-sref="dashboard" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'Dashboard\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon"><i class="icon i-p24 icon-home"></i></div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.dashboard"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li ng-class="{\'selected\': navigation.currentNavigationItem === \'Accounts\'}" data-ng-click="navigation.toggleSecondaryNavigation(\'Accounts\')">\n' +
    '            <a class="visible-md visible-lg">\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon i-p24 icon-card"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.accountsAndCards"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '            <a class="visible-sm">\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon"><i class="icon i-p24 icon-payment"></i></div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.accounts"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li ng-class="{\'selected\': navigation.currentNavigationItem === \'Payments\'}" data-ng-click="navigation.toggleSecondaryNavigation(\'Payments\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper payments-nav-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon i-p24 icon-movem"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label notifications-label">\n' +
    '                        <p translate="navigation.payments"></p>\n' +
    '                    </div>\n' +
    '                    <div class="pull-right visible-md visible-lg">\n' +
    '                      <div class="dn-item-bubble"\n' +
    '                           ng-class="{\'dn-item-bubble-active\': navigation.isSecondaryNavigationOpen && navigation.currentNavigationItem === \'Payments\'}"\n' +
    '                           popover-append-to-body="true"\n' +
    '                           uib-popover-template="\'navigation/notifications-popover-template.tpl.html\'"\n' +
    '                           popover-trigger="mouseenter">{{navigation.totalNotificationsCount}}</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '\n' +
    '      <!-- This is currenty just for BIH environment -->\n' +
    '      <li ng-if="APP_GLOBAL_SETTINGS.userSettings.isViberUser  == \'Y\' || navigation.countryCode === \'bh\' || navigation.countryCode === \'mne\'"\n' +
    '          ng-class="{\'selected\': navigation.currentNavigationItem === \'Viber\'}" data-ng-click="navigation.checkUserViberActivation()">\n' +
    '        <a>\n' +
    '          <div class="nav-item-wrapper payments-nav-wrapper">\n' +
    '            <div class="ni-icon">\n' +
    '              <i class="icon i-p24 icon-chat"></i>\n' +
    '            </div>\n' +
    '            <div class="ni-label notifications-label">\n' +
    '              <p translate="navigation.viberBanking"></p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '\n' +
    '\n' +
    '      <li ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'N\'"\n' +
    '          ng-class="{\'selected\': navigation.currentNavigationItem === \'Deposit\'}" data-ng-click="navigation.toggleSecondaryNavigation(\'Deposit\')">\n' +
    '        <a>\n' +
    '          <div class="nav-item-wrapper payments-nav-wrapper">\n' +
    '            <div class="ni-icon">\n' +
    '              <i class="icon i-p24 icon-savings"></i>\n' +
    '            </div>\n' +
    '            <div class="ni-label notifications-label">\n' +
    '              <p ng-if="navigation.countryCode != \'sr\' && navigation.countryCode != \'mne\'" translate="navigation.allDeposits"></p>\n' +
    '              <p ng-if="navigation.countryCode == \'sr\' || navigation.countryCode == \'mne\'" translate="navigation.allDepositOverviewSerbMne"></p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '        <li ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'N\'"\n' +
    '            ng-class="{\'selected\': navigation.currentNavigationItem === \'Loans\'}" data-ng-click="navigation.toggleSecondaryNavigation(\'Loans\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon i-p24 icon-loan"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.loans"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li ng-class="{\'selected\': navigation.currentNavigationItem === \'Investments\'}" data-ng-click="navigation.toggleSecondaryNavigation(\'Investments\')"\n' +
    '            ng-if="navigation.links.funds">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon i-p24 icon-investment"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.investments"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <!--<li ng-class="{\'selected\': navigation.currentNavigationItem === \'Settings\'}" data-ng-click="navigation.toggleSecondaryNavigation(\'Settings\')">-->\n' +
    '        <li data-ui-sref="settings"  data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'Settings\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon"><i class="icon i-p24 icon-settings"></i></div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.settings"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ui-sref="messages" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'Messages\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon i-p24 icon-message"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label notifications-label">\n' +
    '                        <p translate="navigation.messages"></p>\n' +
    '                    </div>\n' +
    '                    <div class="pull-right visible-md visible-lg">\n' +
    '                      <div class="dn-item-bubble"\n' +
    '                           popover-append-to-body="true"\n' +
    '                           uib-popover="{{APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'navigation.newMessagesSlo\' : \'navigation.newMessages\' | translate}}{{navigation.unreadMessagesNotification}}"\n' +
    '                           popover-trigger="mouseenter">{{navigation.unreadMessagesNotification}}\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ui-sref="employeePayroll" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'EmployeePayroll\')" ng-if="navigation.links.employeePayrolls && (APP_GLOBAL_SETTINGS.userSettings.hasOwnProperty(\'employee\') && APP_GLOBAL_SETTINGS.userSettings.employee != \'0\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon i-p24 icon-employee"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.employeePayroll"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ui-sref="documents" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'Documents\')" ng-if="navigation.countryCode === \'sl\'">\n' +
    '        <a>\n' +
    '          <div class="nav-item-wrapper">\n' +
    '            <div class="ni-icon">\n' +
    '              <i class="icon i-p24 icon-employee"></i>\n' +
    '            </div>\n' +
    '            <div class="ni-label notifications-label">\n' +
    '              <p translate="navigation.documents"></p>\n' +
    '            </div>\n' +
    '            <!--<div class="pull-right visible-md visible-lg">-->\n' +
    '              <!--<div class="dn-item-bubble" popover-trigger="mouseenter">23</div>-->\n' +
    '            <!--</div>-->\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '        <!--<li data-ui-sref="secure3d"  data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'3DSecure\')" ng-if="navigation.countryCode === \'hr\'">-->\n' +
    '          <!--<a>-->\n' +
    '            <!--<div class="nav-item-wrapper">-->\n' +
    '              <!--<div class="ni-icon" style="padding: 1px;"><i class="icon i-p24 icon-info" ></i></div>-->\n' +
    '              <!--<div class="ni-label">-->\n' +
    '                <!--<p translate="navigation.secure3d"></p>-->\n' +
    '              <!--</div>-->\n' +
    '            <!--</div>-->\n' +
    '          <!--</a>-->\n' +
    '        <!--</li>-->\n' +
    '\n' +
    '    </ul>\n' +
    '</div>\n' +
    '\n' +
    '<div id="smallNavigationHeader" class="visible-xs">\n' +
    '\n' +
    '    <div class="small-navigation-header" ng-show="navigation.isMobilePrimaryNavigationOpen">\n' +
    '        <a class="pointer" data-ng-click="navigation.closeMobilePrimaryNavigation()">\n' +
    '            <i class="zmdi zmdi-close zmdi-hc-2x" style="font-size: 26px"></i>\n' +
    '        </a>\n' +
    '        <a class="pointer" ng-click="navigation.logOut()">\n' +
    '            <i class="icon icon-logout pull-right"></i>\n' +
    '        </a>\n' +
    '        <span class="user-info-white pull-right">\n' +
    '      {{navigation.userSettings.result[0].firstName}} {{navigation.userSettings.result[0].lastName}}\n' +
    '    </span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="small-navigation-header" data-ng-click="navigation.backToPrimaryNavigation()" ng-show="navigation.isMobileSecondaryNavigationOpen">\n' +
    '        <a class=" pointer">\n' +
    '            <i class="small-navigation-header-chevron zmdi zmdi-chevron-left zmdi-hc-2x"></i>\n' +
    '        </a>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-show="!navigation.isMobilePrimaryNavigationOpen && !navigation.isMobileSecondaryNavigationOpen">\n' +
    '        <a class="navigation-header-icon pointer" data-ng-click="navigation.openPrimaryNavigation()">\n' +
    '            <i class="zmdi zmdi-menu zmdi-hc-2x"></i>\n' +
    '        </a>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div id="primaryNavigationMobile" class="visible-xs primary-navigation" scrollable ng-if="navigation.isMobilePrimaryNavigationOpen && !navigation.isMobileSecondaryNavigationOpen"\n' +
    '     click-outside="navigation.closeMobileNavigation()" outside-if-not="smallNavigationHeader">\n' +
    '    <ul class="primary-navigation-list p-t-10">\n' +
    '        <li data-ui-sref="dashboard" data-ng-click="navigation.closeMobilePrimaryNavigation(); navigation.pushGtmNavigationEvent(\'Dashboard\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon"><i class="icon icon-home"></i></div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.dashboard"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ng-click="navigation.toggleSecondaryNavigation(\'Accounts\', true)">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon-pn icon-account"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.accountsAndCards"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ng-click="navigation.toggleSecondaryNavigation(\'Payments\', true)">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper payments-nav-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon icon-movem"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.payments"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <!--<button class="badge badge-warning visible-lg pull-right" uib-popover="Test 123" popover-title="Title" popover-trigger="mouseenter">5</button>-->\n' +
    '                <!--<span class="badge badge-warning visible-lg pull-right" uib-popover="Test 123" popover-title="Title" popover-trigger="mouseenter">5</span>-->\n' +
    '            </a>\n' +
    '        </li>\n' +
    '\n' +
    '      <!-- This is currenty just for BIH environment -->\n' +
    '      <li ng-if="(navigation.countryCode != \'sl\' && APP_GLOBAL_SETTINGS.userSettings.isViberUser  == \'Y\') || navigation.countryCode === \'bh\'"\n' +
    '          ng-class="{\'selected\': navigation.currentNavigationItem === \'Viber\'}" data-ng-click="navigation.checkUserViberActivation()">\n' +
    '        <a>\n' +
    '          <div class="nav-item-wrapper payments-nav-wrapper">\n' +
    '            <div class="ni-icon">\n' +
    '              <i class="icon i-p24 icon-chat"></i>\n' +
    '            </div>\n' +
    '            <div class="ni-label notifications-label">\n' +
    '              <p translate="navigation.viberBanking"></p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '\n' +
    '\n' +
    '      <li data-ng-click="navigation.toggleSecondaryNavigation(\'Deposit\', true)">\n' +
    '        <a>\n' +
    '          <div class="nav-item-wrapper">\n' +
    '            <div class="ni-icon">\n' +
    '              <i class="icon icon-savings"></i>\n' +
    '            </div>\n' +
    '            <div class="ni-label">\n' +
    '             <!-- <p translate="navigation.deposit"></p>-->\n' +
    '               <p ng-if="navigation.countryCode != \'sr\' && navigation.countryCode != \'mne\'" translate="navigation.allDeposits"></p>\n' +
    '              <p ng-if="navigation.countryCode == \'sr\' || navigation.countryCode == \'mne\'" translate="navigation.allDepositOverviewSerbMne"></p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '        <li data-ng-click="navigation.toggleSecondaryNavigation(\'Loans\', true)">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon icon-loan"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.loans"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ng-click="navigation.toggleSecondaryNavigation(\'Investments\', true)" ng-if="navigation.links.funds" >\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon icon-investment"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.investments"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <!--<li data-ng-click="navigation.toggleSecondaryNavigation(\'Settings\', true)">-->\n' +
    '        <li data-ui-sref="settings"  data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'Settings\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon"><i class="icon icon-settings"></i></div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.settings"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ui-sref="messages" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'Messages\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon"><i class="icon icon-message"></i></div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.messages"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ui-sref="employeePayroll" data-ng-click="navigation.closeMobileNavigation(); navigation.pushGtmNavigationEvent(\'EmployeePayroll\')" ng-if="navigation.links.employeePayrolls && (APP_GLOBAL_SETTINGS.userSettings.hasOwnProperty(\'employee\') && APP_GLOBAL_SETTINGS.userSettings.employee != \'0\')">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon icon-employee"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.employeePayroll"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ui-sref="documents" data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'Documents\')" ng-if="navigation.countryCode === \'sl\'">\n' +
    '        <a>\n' +
    '          <div class="nav-item-wrapper">\n' +
    '            <div class="ni-icon">\n' +
    '              <i class="icon icon-employee"></i>\n' +
    '            </div>\n' +
    '            <div class="ni-label">\n' +
    '              <p translate="navigation.documents"></p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '      <!--<li  data-ui-sref="secure3d"  data-ng-click="navigation.closeSecondaryNavigation(); navigation.pushGtmNavigationEvent(\'3DSecure\')"-->\n' +
    '          <!--ng-if="navigation.countryCode === \'hr\'">-->\n' +
    '        <!--<a>-->\n' +
    '          <!--<div class="nav-item-wrapper">-->\n' +
    '            <!--<div class="ni-icon">-->\n' +
    '              <!--<i class="icon icon-info"></i>-->\n' +
    '            <!--</div>-->\n' +
    '            <!--<div class="ni-label">-->\n' +
    '              <!--<p translate="navigation.secure3d"></p>-->\n' +
    '            <!--</div>-->\n' +
    '          <!--</div>-->\n' +
    '        <!--</a>-->\n' +
    '      <!--</li>-->\n' +
    '      <!--<li  data-ng-click="navigation.closeMobileNavigation()" ng-if="navigation.countryCode === \'hr\'">\n' +
    '            <a ng-href="{{navigation.clubLink}}" target="_blank">\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon icon-hypo-club"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.hypoClub"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>\n' +
    '        <li data-ng-click="navigation.closeMobileNavigation()" ng-if="navigation.countryCode === \'hr\'">\n' +
    '            <a>\n' +
    '                <div class="nav-item-wrapper">\n' +
    '                    <div class="ni-icon">\n' +
    '                        <i class="icon icon-etrade"></i>\n' +
    '                    </div>\n' +
    '                    <div class="ni-label">\n' +
    '                        <p translate="navigation.eTrade"></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </a>\n' +
    '        </li>-->\n' +
    '      <!-- Change language -->\n' +
    '      <li>\n' +
    '        <select class="form-control nav-language-selector" ng-model="navigation.selectedLanguage"\n' +
    '                ng-options="language as language.translate | translate for language in navigation.languageOptions"\n' +
    '                ng-change="navigation.changeLanguage()">\n' +
    '        </select>\n' +
    '\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('navigation/notifications-popover-template.tpl.html',
    '<div>\n' +
    '  <div class="popover-notifications-wrapper">\n' +
    '    <span ng-bind="navigation.rejectedPaymentsNotifications"></span>\n' +
    '    <span translate="dashboardNotification.rejected"></span>\n' +
    '  </div>\n' +
    '  <div class="popover-notifications-wrapper" ng-if="navigation.countryCode === \'hr\' || navigation.countryCode === \'sl\'">\n' +
    '    <span ng-bind="navigation.eInvoiceNotifications"></span>\n' +
    '    <span translate="{{APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'dashboardNotification.einvoiceSlo\' : \'dashboardNotification.einvoice\'}}"></span>\n' +
    '  </div>\n' +
    '  <div class="popover-notifications-wrapper">\n' +
    '    <span ng-bind="navigation.unsignedPaymentsNotifications"></span>\n' +
    '    <span ng-if="navigation.countryCode != \'sl\'" translate="dashboardNotification.unsigned"></span>\n' +
    '    <span ng-if="navigation.countryCode === \'sl\'" translate="dashboardNotification.pending"></span>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('navigation/navigation.tpl.html',
    '<div ng-include="\'navigation/primary-navigation.tpl.html\'"></div>\n' +
    '<div ng-if="navigation.isSecondaryNavigationOpen" class="secondary-navigation hidden-xs" ng-class="{\'sn-open\': navigation.isSecondaryNavigationOpen}" ng-include="\'navigation/secondary-navigation.tpl.html\'"></div>\n' +
    '<div ng-if="navigation.isMobileSecondaryNavigationOpen" class="secondary-navigation visible-xs" ng-class="{\'sn-open\': navigation.isMobileSecondaryNavigationOpen}" ng-include="\'navigation/secondary-navigation.tpl.html\'"></div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('messages/new-message.tpl.html',
    '<section id="main">\n' +
    '    <!--<div class="new-msg-title" ng-if="newMessage.showSuccessSection === false" >\n' +
    '        <span ng-if="!newMessage.isReplyMessage" translate="newMessage.titleLabel"></span>\n' +
    '        <span ng-if="newMessage.isReplyMessage" translate="newMessage.titleReplyLabel"></span>\n' +
    '    </div>-->\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row exchange-rates">\n' +
    '            <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12">\n' +
    '                <div ng-if="newMessage.showSuccessSection === false" class="domp-header-wrapper col-sm-12 p-0" >\n' +
    '                    <div class="domp-header-row">\n' +
    '                        <h2 class="f-28 " ng-if="!newMessage.isReplyMessage" translate="newMessage.titleLabel">New message</h2>\n' +
    '                        <h2 class="f-28 " ng-if="newMessage.isReplyMessage" translate="newMessage.titleReplyLabel">Reply message</h2>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="domp-body-wrapper" ng-if="newMessage.showSuccessSection === false">\n' +
    '                    <div class="p-t-20 p-b-20">\n' +
    '                        <form name="sendMessageForm" class="new-msg-form" role="form" novalidate>\n' +
    '                            <div ng-if="newMessage.countryCode != \'sl\'" class="form-group">\n' +
    '                                <label class="new-msg-form-label p-t-20 f-18" for="msgSubject" translate="newMessage.subjectLabel">Subject</label>\n' +
    '                                <input ng-required="newMessage.countryCode != \'sl\'" name="msgSubject"\n' +
    '                                       ng-model="newMessage.sendMessageObject.subject" type="msgSubject"\n' +
    '                                       maxlength="{{newMessage.inputOptions.maxLength}}"\n' +
    '                                       class="form-control" id="msgSubject"\n' +
    '                                       placeholder="{{\'newMessage.subjectPlaceholder\'|translate}}"\n' +
    '                                       ng-class="{\'b-c-error\': sendMessageForm.msgSubject.$invalid}">\n' +
    '                            </div>\n' +
    '                            <div class="form-group">\n' +
    '                                <label class="new-msg-form-label f-18" for="msgBody" translate="newMessage.bodyLabel">Message</label>\n' +
    '                                <textarea required\n' +
    '                                          ng-pattern-restrict="{{newMessage.regex.disallowStarQutoesEtc}}"\n' +
    '\n' +
    '                                          ng-model="newMessage.sendMessageObject.body"\n' +
    '                                          class="form-control"\n' +
    '                                          name="msgBody"\n' +
    '                                          id="msgBody"\n' +
    '                                          cols="30"\n' +
    '                                          rows="10"\n' +
    '                                          ng-class="{\'b-c-error\': sendMessageForm.msgBody.$invalid}"\n' +
    '\n' +
    '                                          ></textarea>\n' +
    '\n' +
    '                            </div>\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-xs-6 col-sm-6 t-a-l">\n' +
    '                                    <button class="btn btn-primary" data-ui-sref="messages" translate="newMessage.backBtn">BACK</button>\n' +
    '                                </div>\n' +
    '                                <div class="col-xs-6 col-sm-6 t-a-r">\n' +
    '                                    <button class="btn btn-default" ng-click="newMessage.sendMessage(sendMessageForm);" ng-disabled="newMessage.sendButtonPressed || !sendMessageForm.$valid" translate="newMessage.sendBtn">SEND</button>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                        </form>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '                <!--<div class="msg-success-section" ng-if="newMessage.showSuccessSection === true">\n' +
    '                    <div class="msg-sent-success m-b-30">\n' +
    '                        <div class="icon-wrapper">\n' +
    '                            <i class="zmdi zmdi-check zmdi-hc-2x"></i>\n' +
    '                        </div>\n' +
    '                        <div class="label-wrapper"><span class="no-wrap-text">\n' +
    '                            <b class="f-18" translate="newMessage.successLabel1">Message sent</b>\n' +
    '                            <br> {{\'newMessage.successLabel2\'|translate}} "{{newMessage.successfulMessageSubject}}"</span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div>\n' +
    '                        <div class="col-xs-12 col-sm-4 p-0">\n' +
    '                            <div class="pointer msa-round-btn-container" ng-click="newMessage.showSuccessSection = false;newMessage.isReplyMessage = false;">\n' +
    '                                <div class="msa-round-btn"><i class="zmdi zmdi-plus zmdi-hc-2x"></i></div>\n' +
    '                                <div class="msa-round-btn-label" translate="newMessage.newLabel">Create new message</div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-8 p-0" data-ui-sref="messages">\n' +
    '                            <div class="pointer msa-round-btn-container">\n' +
    '                                <div class="msa-round-btn"><i class="zmdi zmdi-comments zmdi-hc-2x"></i></div>\n' +
    '                                <div class="msa-round-btn-label" translate="newMessage.goToMsgsLabel">Go to messages</div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>-->\n' +
    '\n' +
    '\n' +
    '        <div class="currency-conversion-msg p-t-20" ng-if="newMessage.showSuccessSection === true">\n' +
    '            <div class="payment-successful-wrapper">\n' +
    '                <div class="row p-t-30 p-b-30">\n' +
    '                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">\n' +
    '                        <div class="currency-check-icon-no-line-height " >\n' +
    '                            <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                  <div class="col-xs-12 col-sm-6 col-lg-8 hidden-xs hidden-md">\n' +
    '                    <h2 class="c-white f-28" translate="newMessage.successLabel1">Message sent</h2>\n' +
    '                    <div class="f-15">\n' +
    '                      <div ng-if="newMessage.countryCode != \'sl\'">\n' +
    '                        <span>{{\'newMessage.successLabel2\'|translate}}"{{newMessage.successfulMessageSubject}}"{{\'newMessage.successLabel3\'|translate}}</span>\n' +
    '                      </div>\n' +
    '                      <div ng-if="newMessage.countryCode == \'sl\'">\n' +
    '                        <span>{{\'newMessage.successLabel2\'|translate}} {{\'newMessage.successLabel3\'|translate}}</span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-12 col-lg-8 col-md-8 col-sm-6 visible-xs visible-md  t-a-c">\n' +
    '                    <h2 class="c-white f-28" translate="newMessage.successLabel1">Message sent</h2>\n' +
    '                    <div class="f-15">\n' +
    '                      <div ng-if="newMessage.countryCode != \'sl\'">\n' +
    '                        <span>{{\'newMessage.successLabel2\'|translate}}"{{newMessage.successfulMessageSubject}}"{{\'newMessage.successLabel3\'|translate}}</span>\n' +
    '                      </div>\n' +
    '                      <div ng-if="newMessage.countryCode == \'sl\'">\n' +
    '                        <span>{{\'newMessage.successLabel2\'|translate}} {{\'newMessage.successLabel3\'|translate}}</span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row m-t-20 p-l-10 p-b-20">\n' +
    '                <!-- Save template only for Domestic or foreign payments-->\n' +
    '                <div class="col-xs-12 col-sm-4" >\n' +
    '                    <a href=""  ng-click="newMessage.createNewMessage()">\n' +
    '                        <span class="money-exchange-icon"><i class="icon icon-messnew zmdi-hc-2x"></i></span>\n' +
    '                        <span class="f-18 bold-font" translate="newMessage.newLabel">Create new message</span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-xs-12 col-sm-4"  >\n' +
    '                    <a data-ui-sref="messages" >\n' +
    '                        <span class="money-exchange-icon"><i class="icon icon-message zmdi-hc-2x"></i></span>\n' +
    '                        <span class="f-18 bold-font" translate="newMessage.goToMsgsLabel">Go to messages</span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('messages/messages.tpl.html',
    '<section id="main">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row" >\n' +
    '            <div class="tmplt-list-title col-md-12 p-r-0 m-b-15">\n' +
    '\n' +
    '                 <h2 translate="newMessage.header" class="f-28"></h2>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '\n' +
    '                <div class="col-xs-12 col-sm-6 col-lg-4 m-b-20">\n' +
    '                    <div class="account-item-add-message app-dblue-card " data-ui-sref="newMessage">\n' +
    '                        <div class="round-btn-container2">\n' +
    '                            <div class="round-btn-m">\n' +
    '                                <i class="icon icon-add icon-add-msg bold-font f-24"></i>\n' +
    '                            </div>\n' +
    '                            <div class="round-btn-label-msg">\n' +
    '                                <h3 class="round-btn-label-msg f-20">{{\'messages.createBtn\'| translate}}</h3>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '          </div>\n' +
    '      <div class="row">\n' +
    '            <div class="col-xs-12 p-r-0 no-padding-on-phone">\n' +
    '                <div class="msg-view-container m-b-20">\n' +
    '                    <div class="msg-tab-container">\n' +
    '                        <div class="msg-tab" ng-class="{\'selected\':messages.messageSelectedTab === 1, \'msg-tab-bh\':messages.countryCode === \'sl\'}"\n' +
    '                             ng-click="messages.messageSearchInput = \'\';\n' +
    '                             messages.selectTab(1, APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'messages.receivedPersonalTab\' : \'messages.receivedTab\')"\n' +
    '                             translate="{{APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'messages.receivedPersonalTab\' : \'messages.receivedTab\'}}">Received</div>\n' +
    '                      <div ng-if="messages.countryCode === \'sl\'" class="msg-tab" ng-style="" style="border-right:none;"\n' +
    '                           ng-class="{\'selected\':messages.messageSelectedTab === 3, \'msg-tab-bh\':messages.countryCode === \'sl\'}"\n' +
    '                           ng-click="messages.messageSearchInput = \'\'; messages.selectTab(3, \'messages.receivedGlobalTab\')"\n' +
    '                           translate="messages.receivedGlobalTab">Global</div>\n' +
    '                      <div class="msg-tab" style="border-right:none;" ng-class="{\'selected\':messages.messageSelectedTab === 2, \'msg-tab-bh\':messages.countryCode === \'sl\'}"\n' +
    '                             ng-click="messages.messageSearchInput = \'\'; messages.selectTab(2,\'messages.sentTab\')"\n' +
    '                             translate="messages.sentTab">Sent</div>\n' +
    '\n' +
    '                    </div>\n' +
    '                    <div class="msg-content-container">\n' +
    '                        <div class="row">\n' +
    '                            <div class="col-sm-6 col-xs-12">\n' +
    '                                <div class="form-group search-field">\n' +
    '                                    <div id="searchBtnLeftDiv" class="inner-section left">\n' +
    '                                        <i class="icon icon-search  icon-hc-2x m-l-5 tml-search-container"></i>\n' +
    '                                    </div>\n' +
    '                                    <input type="text" class="form-control input-field" ng-model="messages.messageSearchInput.subject">\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="col-sm-6 col-xs-12">\n' +
    '                                <div class="dropdown acc-period-select pull-right" style="display: inline-block">\n' +
    '                                    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '                                        {{messages.selectedPeriod.item.description | translate}}\n' +
    '                                        <span class="caret"></span>\n' +
    '                                    </button>\n' +
    '                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                                        <li data-ng-repeat="period in messages.periodList">\n' +
    '                                            <a href="" class="f-13" data-ng-click="messages.timeFilter(period)">\n' +
    '                        {{period.item.description| translate}}\n' +
    '                      </a>\n' +
    '                                        </li>\n' +
    '                                    </ul>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                      <div class="received-section m-t-20" ng-show="messages.messageSelectedTab === 1">\n' +
    '                            <h4 ng-if="messages.unreadMessagesList.result.length !== 0" translate="messages.unreadLabel">Unread messages</h4>\n' +
    '                            <div class="m-b-10" ng-repeat="message in messages.unreadMessagesList.result | filter:messages.messageSearchInput | limitTo: messages.paginationLimitUnread()">\n' +
    '                                <div class="container invoice-card" style="border-bottom: solid 1px #e1e3eb;">\n' +
    '                                    <div class="row invoice-card-top vertical-align pointer-cst" style="border-bottom: none" ng-click="messages.expandMessage(message, \'unread\')">\n' +
    '\n' +
    '                                        <div class="col-sm-1 col-xs-1">\n' +
    '                                            <div class="invoice-icon img-responsive"><i class="icon icon-messagein bold-font msg-ico-style"></i></div>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                      <div class="col-sm-6 col-xs-4">\n' +
    '                                        <div>\n' +
    '                                          <h3 class="invoice-type-message">{{::message.subject}}</h3>\n' +
    '                                          <h4 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && message.hasOwnProperty(\'objectId\')">\n' +
    '                                            <span ng-if="message.messageType == \'Payment\'" translate="messages.paymentCode"></span>\n' +
    '                                            <span ng-if="message.messageType == \'Order\'" translate="messages.orderCode"></span>\n' +
    '                                            <a ng-class="{\'underline\': message.messageType == \'Payment\'}" href="" ng-click="messages.openPayment(message); $event.stopPropagation()" >\n' +
    '                                              {{::message.objectId}}\n' +
    '                                            </a>\n' +
    '                                          </h4>\n' +
    '                                          <span class="text-muted-message">{{::message.creationDate| date:\'medium\'}}</span>\n' +
    '                                        </div>\n' +
    '                                      </div>\n' +
    '\n' +
    '                                        <div class="col-sm-5 col-xs-7">\n' +
    '                                            <div class="row ">\n' +
    '\n' +
    '                                                <div class="col-sm-2 col-xs-2 pull-right">\n' +
    '                                                    <span class="icon icon-arrdown i-c31"></span>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                    <div class="row invoice-card-detail" style="border-top: solid 1px #e1e3eb;" ng-if="message.selected">\n' +
    '                                      <div>\n' +
    '                                        <!--<div class="col-sm-11 col-sm-offset-1">-->\n' +
    '                                          <!--<h4 ng-if="message.orderType.description">{{message.orderType.description}}</h4>-->\n' +
    '                                        <!--</div>-->\n' +
    '                                      </div>\n' +
    '                                        <div class="invoice-content container">\n' +
    '\n' +
    '                                            <div class="row m-b-20">\n' +
    '                                                <div class="col-sm-11 col-sm-offset-1">\n' +
    '                                                  <h4>  <span class=" pre-line-text" ng-bind-html="message.body"></span></h4>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                            <div class="msg-actions">\n' +
    '<!--                                                <div class="col-xs-6 col-sm-6 p-0">\n' +
    '                                                    <button ng-if="message.messageType !== \'Order\' && message.messageType !== \'Global\'" class="btn btn-primary-warning" ng-click="messages.deleteMessage(message.id, \'unread\');" translate="messages.deleteBtn">Delete</button>\n' +
    '                                                </div>-->\n' +
    '                                                <div class="col-xs-12 t-a-r p-0">\n' +
    '                                                    <button ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                                                            class="btn btn-primary" translate="messages.printBtn" data-ng-click="messages.printMessage(message.id)">Print</button>\n' +
    '                                                    <button class="btn btn-default" ng-click="messages.replyToMessage(message.id);" translate="messages.replyBtn">Reply</button>\n' +
    '                                                    <button ng-if="message.attachmentList" class="btn btn-primary" ng-click="messages.downloadMessageAttachment(message.linkList);" translate="messages.downloadAttachment">Download attachment</button>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="m-b-10" ng-if="messages.unreadMessagesList.hasMore == true && messages.countryCode != \'sl\'">\n' +
    '                                <button class="btn btn-default"\n' +
    '                                        ng-click="messages.loadMoreMessages(\'u\')" translate="messages.loadMore">Load more</button>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="m-b-10" ng-show="messages.hasMoreItemsToShowUnread()">\n' +
    '                              <button class="btn btn-default"\n' +
    '                                      ng-click="messages.showMoreItemsUnread();"\n' +
    '                                      translate="messages.loadMore">Load more</button>\n' +
    '                            </div>\n' +
    '\n' +
    '\n' +
    '                            <h4 ng-if="messages.readMessagesList.result.length !== 0" class=" text-muted-msg m-t-30" translate="messages.readLabel">Read messages</h4>\n' +
    '                            <div class="m-b-10" ng-repeat="message in messages.readMessagesList.result| filter:messages.messageSearchInput | limitTo: messages.paginationLimitRead()">\n' +
    '                                <div class="container invoice-card" style="border-bottom: solid 1px #e1e3eb;">\n' +
    '                                    <div class="row invoice-card-top vertical-align pointer-cst" style="border-bottom: none" ng-click="messages.expandMessage(message, \'read\'); einvoicesOverview.archiveObj.archiveCtnOpened = false;">\n' +
    '\n' +
    '                                        <div class="col-sm-1 col-xs-1">\n' +
    '                                            <div class="invoice-icon img-responsive"><i class="icon icon-messagein bold-font msg-ico-style"></i></div>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                        <div class="col-sm-6 col-xs-4">\n' +
    '                                            <div>\n' +
    '                                                <h3 class="invoice-type-message">{{::message.subject}}</h3>\n' +
    '                                                <h4 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && message.hasOwnProperty(\'objectId\')">\n' +
    '                                                  <span ng-if="message.messageType == \'Payment\'" translate="messages.paymentCode"></span>\n' +
    '                                                  <span ng-if="message.messageType == \'Order\'" translate="messages.orderCode"></span>\n' +
    '                                                    <a ng-class="{\'underline\': message.messageType == \'Payment\'}" href="" ng-click="messages.openPayment(message); $event.stopPropagation()" >\n' +
    '                                                     {{::message.objectId}}\n' +
    '                                                    </a>\n' +
    '                                                </h4>\n' +
    '                                                <span class="text-muted-message">{{::message.creationDate| date:\'medium\'}}</span>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                        <div class="col-sm-5 col-xs-7">\n' +
    '                                            <div class="row vertical-align">\n' +
    '                                                <div class="col-sm-5 col-xs-5"></div>\n' +
    '                                                <div class="col-sm-5 col-xs-5"></div>\n' +
    '                                                <div class="col-sm-2 col-xs-2">\n' +
    '                                                    <span class="icon icon-arrdown i-c31"></span>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                    <div class="row invoice-card-detail" style="border-top: solid 1px #e1e3eb;" ng-class="{collapse: !message.selected}">\n' +
    '                                        <div>\n' +
    '                                          <div class="col-sm-11 col-sm-offset-1">\n' +
    '                                            <h4 ng-if="message.orderType.description">{{message.orderType.description}}</h4>\n' +
    '                                          </div>\n' +
    '                                        </div>\n' +
    '                                        <div class="invoice-content container">\n' +
    '                                            <div class="row m-b-20">\n' +
    '                                                <div class="col-sm-11 col-sm-offset-1">\n' +
    '                                                    <!--<p class="f-15 message-body text-muted-message pre-line-text " ng-bind-html="message.body"></p>-->\n' +
    '                                                  <h4>  <span class=" pre-line-text" ng-bind-html="message.body"></span></h4>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                            <div class="msg-actions">\n' +
    '                                                <div class="col-xs-6 col-sm-6 p-0">\n' +
    '                                                </div>\n' +
    '                                                <div class="col-xs-6 col-sm-6 t-a-r p-0">\n' +
    '                                                    <button class="btn btn-primary" translate="messages.printBtn" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                                                            data-ng-click="messages.printMessage(message.id);" style="width: 100px">Print</button>\n' +
    '                                                    <button class="btn btn-default" ng-click="messages.replyToMessage(message.id);" translate="messages.replyBtn" style="width: 100px">Reply</button>\n' +
    '                                                    <button ng-if="message.attachmentList" class="btn btn-primary" ng-click="messages.downloadMessageAttachment(message.linkList);" translate="messages.downloadAttachment">Download attachment</button>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="m-b-10" ng-if="messages.readMessagesList.hasMore == true && messages.countryCode != \'sl\'">\n' +
    '                                <button class="btn btn-default" data-ng-click="messages.loadMoreMessages(\'r\')" translate="messages.loadMore">Load more</button>\n' +
    '                            </div>\n' +
    '                            <div class="m-b-10" ng-show="messages.hasMoreItemsToShowRead()">\n' +
    '                              <button class="btn btn-default"\n' +
    '                                      ng-click="messages.showMoreItemsRead();"\n' +
    '                                      translate="messages.loadMore">Load more</button>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="messages.unreadMessagesList.result.length == 0 && messages.readMessagesList.result.length == 0">\n' +
    '                                <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                                <h3 class="no-data-label" translate="messages.noData"></h3>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                      <div class="sent-section m-t-20" ng-show="messages.messageSelectedTab === 2">\n' +
    '                            <div class="m-b-10" ng-repeat="message in messages.sentMessagesList.result | filter:messages.messageSearchInput">\n' +
    '                                <div class="container invoice-card" style="border-bottom: solid 1px #e1e3eb;">\n' +
    '                                    <div class="row invoice-card-top vertical-align pointer-cst" style="border-bottom: none" ng-click="messages.expandMessage(message, \'sent\')">\n' +
    '\n' +
    '                                        <div class="col-sm-1 col-xs-1">\n' +
    '                                            <div class="invoice-icon img-responsive"><i class="icon icon-messageout bold-font msg-ico-style"></i></div>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                        <div class="col-sm-6 col-xs-4">\n' +
    '                                            <div class="invoice-type">\n' +
    '                                              <h3 class="invoice-type-message">{{::message.subject}}</h3>\n' +
    '                                              <span class="text-muted-message">{{::message.creationDate| date:\'medium\'}}</span>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                        <div class="col-sm-5 col-xs-7">\n' +
    '                                            <div class="row vertical-align">\n' +
    '                                                <div class="col-sm-5 col-xs-5"></div>\n' +
    '                                                <div class="col-sm-5 col-xs-5"></div>\n' +
    '                                                <div class="col-sm-2 col-xs-2">\n' +
    '                                                    <span class="icon icon-arrdown i-c31"></span>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                    <div class="row invoice-card-detail" style="border-top: solid 1px #e1e3eb;" ng-if="message.selected">\n' +
    '                                        <div class="invoice-content container">\n' +
    '                                            <div class="row">\n' +
    '                                                <div class="col-sm-11 col-sm-offset-1">\n' +
    '                                                    <!--<p class="f-14 pre-line-text" ng-bind-html="message.body"></p>-->\n' +
    '                                                  <h4>  <span class=" pre-line-text" ng-bind-html="message.body"></span></h4>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <!--New design end-->\n' +
    '\n' +
    '                            </div>\n' +
    '                            <div class="m-b-10" ng-if="messages.sentMessagesList.hasMore == true">\n' +
    '                                <button class="btn btn-default" data-ng-click="messages.loadMoreMessages(\'s\')" translate="messages.loadMore">Load more</button>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="messages.sentMessagesList.result.length == 0">\n' +
    '                                <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                                <h3 class="no-data-label" translate="messages.noData"></h3>\n' +
    '                            </div>\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                      <div class="received-section m-t-20" ng-show="messages.messageSelectedTab === 3">\n' +
    '                        <h4 ng-if="messages.globalMessagesList.result.length !== 0" translate="messages.globalLabel">Global messages</h4>\n' +
    '                        <div class="m-b-10" ng-repeat="message in messages.globalMessagesList.result | filter:messages.messageSearchInput">\n' +
    '                          <div class="container invoice-card" style="border-bottom: solid 1px #e1e3eb;">\n' +
    '                            <div class="row invoice-card-top vertical-align pointer-cst" style="border-bottom: none" ng-click="messages.expandMessage(message, \'unread\')">\n' +
    '\n' +
    '                              <div class="col-sm-1 col-xs-1">\n' +
    '                                <div class="invoice-icon img-responsive"><i class="icon icon-messagein bold-font msg-ico-style"></i></div>\n' +
    '                              </div>\n' +
    '\n' +
    '                              <div class="col-sm-6 col-xs-4">\n' +
    '                                <div>\n' +
    '                                  <h3 class="invoice-type-message">{{::message.subject}}</h3>\n' +
    '                                  <h4 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && message.hasOwnProperty(\'objectId\')">\n' +
    '                                    <span ng-if="message.messageType == \'Payment\'" translate="messages.paymentCode"></span>\n' +
    '                                    <span ng-if="message.messageType == \'Order\'" translate="messages.orderCode"></span>\n' +
    '                                    <a ng-class="{\'underline\': message.messageType == \'Payment\'}" href="" ng-click="messages.openPayment(message); $event.stopPropagation()" >\n' +
    '                                      {{::message.objectId}}\n' +
    '                                    </a>\n' +
    '                                  </h4>\n' +
    '                                  <span class="text-muted-message">{{::message.creationDate| date:\'medium\'}}</span>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '\n' +
    '                              <div class="col-sm-5 col-xs-7">\n' +
    '                                <div class="row ">\n' +
    '\n' +
    '                                  <div class="col-sm-2 col-xs-2 pull-right">\n' +
    '                                    <span class="icon icon-arrdown i-c31"></span>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                            <div class="row invoice-card-detail" style="border-top: solid 1px #e1e3eb;" ng-if="message.selected">\n' +
    '                              <div>\n' +
    '                                <div class="col-sm-11 col-sm-offset-1">\n' +
    '                                  <h4 ng-if="message.orderType.description">{{message.orderType.description}}</h4>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                              <div class="invoice-content container">\n' +
    '\n' +
    '                                <div class="row m-b-20">\n' +
    '                                  <div class="col-sm-11 col-sm-offset-1">\n' +
    '                                    <!--<p class="message-body f-14 text-muted-message pre-line-text" ng-bind-html="message.body"></p>-->\n' +
    '                                    <h4>  <span class=" pre-line-text" ng-bind-html="message.body"></span></h4>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                                <div class="msg-actions">\n' +
    '                                  <!--                                                <div class="col-xs-6 col-sm-6 p-0">\n' +
    '                                                                                      <button ng-if="message.messageType !== \'Order\' && message.messageType !== \'Global\'" class="btn btn-primary-warning" ng-click="messages.deleteMessage(message.id, \'unread\');" translate="messages.deleteBtn">Delete</button>\n' +
    '                                                                                  </div>-->\n' +
    '                                  <div class="col-xs-12 t-a-r p-0">\n' +
    '                                    <button ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                                            class="btn btn-primary" translate="messages.printBtn" data-ng-click="messages.printMessage(message.id)">Print</button>\n' +
    '                                    <button class="btn btn-default" ng-click="messages.replyToMessage(message.id);" translate="messages.replyBtn">Reply</button>\n' +
    '                                    <button ng-if="message.attachmentList" class="btn btn-primary" ng-click="messages.downloadMessageAttachment(message.linkList);" translate="messages.downloadAttachment">Download attachment</button>\n' +
    '                                  </div>\n' +
    '                                </div>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="m-b-10" ng-if="messages.globalMessagesList.hasMore == true">\n' +
    '                          <button class="btn btn-default" ng-click="messages.loadMoreMessages(\'global\')" translate="messages.loadMore">Load more</button>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="messages.globalMessagesList.result.length == 0">\n' +
    '                          <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                          <h3 class="no-data-label" translate="messages.noData"></h3>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('material-admin/material-admin.tpl.original.html',
    '<header id="header" data-current-skin={{mactrl.currentSkin}} data-ng-include="\'template/header.html\'" data-ng-controller="headerCtrl as hctrl"></header>\n' +
    '\n' +
    '<section id="main">\n' +
    '    <aside id="sidebar" data-ng-include="\'template/sidebar-left.html\'" data-ng-class="{ \'toggled\': mactrl.sidebarToggle.left === true }"></aside>\n' +
    '\n' +
    '    <aside id="chat" data-ng-include="\'template/chat.html\'" data-ng-class="{ \'toggled\': mactrl.sidebarToggle.right === true }"></aside>\n' +
    '\n' +
    '    <section id="content">\n' +
    '\n' +
    '        <div class="container">\n' +
    '            <div class="block-header">\n' +
    '                <h2>Dashboard</h2>\n' +
    '\n' +
    '                <ul class="actions">\n' +
    '                    <li>\n' +
    '                        <a href="">\n' +
    '                            <i class="zmdi zmdi-trending-up"></i>\n' +
    '                        </a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href="">\n' +
    '                            <i class="zmdi zmdi-check-all"></i>\n' +
    '                        </a>\n' +
    '                    </li>\n' +
    '                    <li class="dropdown" uib-dropdown>\n' +
    '                        <a href="" uib-dropdown-toggle>\n' +
    '                            <i class="zmdi zmdi-more-vert"></i>\n' +
    '                        </a>\n' +
    '\n' +
    '                        <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                            <li>\n' +
    '                                <a href="">Refresh</a>\n' +
    '                            </li>\n' +
    '                            <li>\n' +
    '                                <a href="">Manage Widgets</a>\n' +
    '                            </li>\n' +
    '                            <li>\n' +
    '                                <a href="">Widgets Settings</a>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="card">\n' +
    '                <div class="card-header">\n' +
    '                    <h2>Sales Statistics <small>Vestibulum purus quam scelerisque, mollis nonummy metus</small></h2>\n' +
    '\n' +
    '                    <ul class="actions">\n' +
    '                        <li>\n' +
    '                            <a href="">\n' +
    '                                <i class="zmdi zmdi-refresh-alt"></i>\n' +
    '                            </a>\n' +
    '                        </li>\n' +
    '                        <li>\n' +
    '                            <a href="">\n' +
    '                                <i class="zmdi zmdi-download"></i>\n' +
    '                            </a>\n' +
    '                        </li>\n' +
    '                        <li class="dropdown" uib-dropdown>\n' +
    '                            <a href="" uib-dropdown-toggle>\n' +
    '                                <i class="zmdi zmdi-more-vert"></i>\n' +
    '                            </a>\n' +
    '\n' +
    '                            <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                                <li>\n' +
    '                                    <a href="">Change Date Range</a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="">Change Graph Type</a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="">Other Settings</a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="card-body">\n' +
    '                    <div class="chart-edge">\n' +
    '                        <div class="flot-chart" data-curvedline-chart></div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="mini-charts">\n' +
    '                <div class="row">\n' +
    '                    <div class="col-sm-6 col-md-3">\n' +
    '                        <div class="mini-charts-item bgm-cyan">\n' +
    '                            <div class="clearfix">\n' +
    '                                <div class="chart stats-bar" data-sparkline-bar></div>\n' +
    '                                <div class="count">\n' +
    '                                    <small>Website Traffics</small>\n' +
    '                                    <h2>987,459</h2>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-sm-6 col-md-3">\n' +
    '                        <div class="mini-charts-item bgm-lightgreen">\n' +
    '                            <div class="clearfix">\n' +
    '                                <div class="chart stats-bar-2" data-sparkline-bar></div>\n' +
    '                                <div class="count">\n' +
    '                                    <small>Website Impressions</small>\n' +
    '                                    <h2>356,785K</h2>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-sm-6 col-md-3">\n' +
    '                        <div class="mini-charts-item bgm-orange">\n' +
    '                            <div class="clearfix">\n' +
    '                                <div class="chart stats-line" data-sparkline-line></div>\n' +
    '                                <div class="count">\n' +
    '                                    <small>Total Sales</small>\n' +
    '                                    <h2>$ 458,778</h2>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-sm-6 col-md-3">\n' +
    '                        <div class="mini-charts-item bgm-bluegray">\n' +
    '                            <div class="clearfix">\n' +
    '                                <div class="chart stats-line-2" data-sparkline-line></div>\n' +
    '                                <div class="count">\n' +
    '                                    <small>Support Tickets</small>\n' +
    '                                    <h2>23,856</h2>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '            <div class="dash-widgets">\n' +
    '                <div class="row">\n' +
    '                    <div class="col-md-3 col-sm-6">\n' +
    '                        <div id="site-visits" class="dash-widget-item bgm-teal">\n' +
    '                            <div class="dash-widget-header">\n' +
    '                                <div class="p-20">\n' +
    '                                    <div class="dash-widget-visits" data-sparkline-line></div>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="dash-widget-title">For the past 30 days</div>\n' +
    '\n' +
    '                                <ul class="actions actions-alt">\n' +
    '                                    <li class="dropdown" uib-dropdown>\n' +
    '                                        <a href="" uib-dropdown-toggle>\n' +
    '                                            <i class="zmdi zmdi-more-vert"></i>\n' +
    '                                        </a>\n' +
    '\n' +
    '                                        <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                                            <li>\n' +
    '                                                <a href="">Refresh</a>\n' +
    '                                            </li>\n' +
    '                                            <li>\n' +
    '                                                <a href="">Manage Widgets</a>\n' +
    '                                            </li>\n' +
    '                                            <li>\n' +
    '                                                <a href="">Widgets Settings</a>\n' +
    '                                            </li>\n' +
    '                                        </ul>\n' +
    '                                    </li>\n' +
    '                                </ul>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="p-20">\n' +
    '\n' +
    '                                <small>Page Views</small>\n' +
    '                                <h3 class="m-0 f-400">47,896,536</h3>\n' +
    '\n' +
    '                                <br/>\n' +
    '\n' +
    '                                <small>Site Visitors</small>\n' +
    '                                <h3 class="m-0 f-400">24,456,799</h3>\n' +
    '\n' +
    '                                <br/>\n' +
    '\n' +
    '                                <small>Total Clicks</small>\n' +
    '                                <h3 class="m-0 f-400">13,965</h3>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-md-3 col-sm-6">\n' +
    '                        <div id="pie-charts" class="dash-widget-item">\n' +
    '                            <div class="bgm-pink">\n' +
    '                                <div class="dash-widget-header">\n' +
    '                                    <div class="dash-widget-title">Email Statistics</div>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="clearfix"></div>\n' +
    '\n' +
    '                                <div class="text-center p-20 m-t-25">\n' +
    '                                    <div class="easy-pie main-pie" data-percent="75" data-easypie-chart>\n' +
    '                                        <div class="percent">45</div>\n' +
    '                                        <div class="pie-title">Total Emails Sent</div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="p-t-20 p-b-20 text-center">\n' +
    '                                <div class="easy-pie sub-pie-1" data-percent="56" data-easypie-chart>\n' +
    '                                    <div class="percent">56</div>\n' +
    '                                    <div class="pie-title">Bounce Rate</div>\n' +
    '                                </div>\n' +
    '                                <div class="easy-pie sub-pie-2" data-percent="84" data-easypie-chart>\n' +
    '                                    <div class="percent">84</div>\n' +
    '                                    <div class="pie-title">Total Opened</div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-md-3 col-sm-6">\n' +
    '                        <div class="dash-widget-item bgm-lime">\n' +
    '                            <div id="weather-widget" data-weather-widget></div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-md-3 col-sm-6">\n' +
    '                        <div id="best-selling" class="dash-widget-item" data-ng-controller="bestsellingCtrl as wctrl">\n' +
    '                            <div class="dash-widget-header">\n' +
    '                                <div class="dash-widget-title">Best Sellings</div>\n' +
    '                                <img src="img/widgets/alpha.jpg" alt="">\n' +
    '                                <div class="main-item">\n' +
    '                                    <small>Samsung Galaxy Alpha</small>\n' +
    '                                    <h2>$799.99</h2>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="listview p-t-5">\n' +
    '                                <a class="lv-item" href="" data-ng-repeat="w in wctrl.bsResult.list">\n' +
    '                                    <div class="media">\n' +
    '                                        <div class="pull-left">\n' +
    '                                            <img class="lv-img-sm" data-ng-src="img/widgets/{{ w.img }}" alt="">\n' +
    '                                        </div>\n' +
    '                                        <div class="media-body">\n' +
    '                                            <div class="lv-title">{{ w.name }}</div>\n' +
    '                                            <small class="lv-small">{{ w.range }}</small>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </a>\n' +
    '\n' +
    '                                <div class="clearfix"></div>\n' +
    '\n' +
    '                                <a class="lv-footer" href="">\n' +
    '                                    View All\n' +
    '                                </a>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row">\n' +
    '                <div class="col-sm-6">\n' +
    '                    <!-- Recent Items -->\n' +
    '                    <div class="card" data-ng-controller="recentitemCtrl as rictrl">\n' +
    '                        <div class="card-header">\n' +
    '                            <h2>Recent Items <small>Phasellus condimentum ipsum id auctor imperdie</small></h2>\n' +
    '                            <ul class="actions">\n' +
    '                                <li class="dropdown" uib-dropdown>\n' +
    '                                    <a href="" uib-dropdown-toggle>\n' +
    '                                        <i class="zmdi zmdi-more-vert"></i>\n' +
    '                                    </a>\n' +
    '\n' +
    '                                    <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                                        <li>\n' +
    '                                            <a href="">Refresh</a>\n' +
    '                                        </li>\n' +
    '                                        <li>\n' +
    '                                            <a href="">Settings</a>\n' +
    '                                        </li>\n' +
    '                                        <li>\n' +
    '                                            <a href="">Other Settings</a>\n' +
    '                                        </li>\n' +
    '                                    </ul>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="card-body m-t-0">\n' +
    '                            <table class="table table-inner table-vmiddle">\n' +
    '                                <thead>\n' +
    '                                <tr>\n' +
    '                                    <th>ID</th>\n' +
    '                                    <th>Name</th>\n' +
    '                                    <th style="width: 60px">Price</th>\n' +
    '                                </tr>\n' +
    '                                </thead>\n' +
    '                                <tbody>\n' +
    '                                <tr data-ng-repeat="w in rictrl.riResult.list">\n' +
    '                                    <td class="f-500 c-cyan">{{ w.id }}</td>\n' +
    '                                    <td>{{ w.name }}</td>\n' +
    '                                    <td class="f-500 c-cyan">{{ w.price }}</td>\n' +
    '                                </tr>\n' +
    '                                </tbody>\n' +
    '                            </table>\n' +
    '                        </div>\n' +
    '                        <div id="recent-items-chart" class="flot-chart" data-line-chart></div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Todo Lists -->\n' +
    '                    <div id="todo-lists" data-ng-controller="todoCtrl as tctrl">\n' +
    '                        <div class="tl-header">\n' +
    '                            <h2>Todo Lists</h2>\n' +
    '                            <small>Add, edit and manage your Todo Lists</small>\n' +
    '\n' +
    '                            <ul class="actions actions-alt">\n' +
    '                                <li class="dropdown" uib-dropdown>\n' +
    '                                    <a href="" uib-dropdown-toggle>\n' +
    '                                        <i class="zmdi zmdi-more-vert"></i>\n' +
    '                                    </a>\n' +
    '\n' +
    '                                    <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                                        <li>\n' +
    '                                            <a href="">Refresh</a>\n' +
    '                                        </li>\n' +
    '                                        <li>\n' +
    '                                            <a href="">Manage Widgets</a>\n' +
    '                                        </li>\n' +
    '                                        <li>\n' +
    '                                            <a href="">Widgets Settings</a>\n' +
    '                                        </li>\n' +
    '                                    </ul>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="clearfix"></div>\n' +
    '\n' +
    '                        <div class="tl-body">\n' +
    '                            <div id="add-tl-item" data-ng-class="{ \'toggled\': tctrl.addTodoStat }" data-ng-click="tctrl.addTodoStat = true">\n' +
    '                                <i class="add-new-item zmdi zmdi-plus" data-ng-click="tctrl.addTodo($event)"></i>\n' +
    '\n' +
    '                                <div class="add-tl-body">\n' +
    '                                    <textarea placeholder="What you want to do..." data-ng-model="tctrl.todo"></textarea>\n' +
    '\n' +
    '                                    <div class="add-tl-actions">\n' +
    '                                        <a class="zmdi zmdi-close" data-tl-action="dismiss" data-ng-click="tctrl.addTodoStat = false; $event.stopPropagation()"></a>\n' +
    '                                        <a class="zmdi zmdi-check" data-tl-action="save" data-ng-click="tctrl.addTodoStat = false; $event.stopPropagation()"></a>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '\n' +
    '                            <div class="checkbox media" data-ng-repeat="w in tctrl.tdResult.list">\n' +
    '                                <div class="pull-right">\n' +
    '                                    <ul class="actions actions-alt">\n' +
    '                                        <li class="dropdown" uib-dropdown>\n' +
    '                                            <a href="" uib-dropdown-toggle>\n' +
    '                                                <i class="zmdi zmdi-more-vert"></i>\n' +
    '                                            </a>\n' +
    '\n' +
    '                                            <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                                                <li><a href="">Delete</a></li>\n' +
    '                                                <li><a href="">Archive</a></li>\n' +
    '                                            </ul>\n' +
    '                                        </li>\n' +
    '                                    </ul>\n' +
    '                                </div>\n' +
    '                                <div class="media-body">\n' +
    '                                    <label>\n' +
    '                                        <input type="checkbox">\n' +
    '                                        <i class="input-helper"></i>\n' +
    '                                        <span>{{ w.todo }}</span>\n' +
    '                                    </label>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-sm-6">\n' +
    '                    <!-- Calendar -->\n' +
    '                    <div id="calendar-widget" data-full-calendar></div>\n' +
    '\n' +
    '                    <!-- Recent Posts -->\n' +
    '                    <div class="card" data-ng-controller="recentpostCtrl as rpctrl">\n' +
    '                        <div class="card-header ch-alt m-b-20">\n' +
    '                            <h2>Recent Posts <small>Phasellus condimentum ipsum id auctor imperdie</small></h2>\n' +
    '                            <ul class="actions">\n' +
    '                                <li>\n' +
    '                                    <a href="">\n' +
    '                                        <i class="zmdi zmdi-refresh-alt"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="">\n' +
    '                                        <i class="zmdi zmdi-download"></i>\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                                <li class="dropdown" uib-dropdown>\n' +
    '                                    <a href="" uib-dropdown-toggle>\n' +
    '                                        <i class="zmdi zmdi-more-vert"></i>\n' +
    '                                    </a>\n' +
    '\n' +
    '                                    <ul class="dropdown-menu dropdown-menu-right">\n' +
    '                                        <li>\n' +
    '                                            <a href="">Change Date Range</a>\n' +
    '                                        </li>\n' +
    '                                        <li>\n' +
    '                                            <a href="">Change Graph Type</a>\n' +
    '                                        </li>\n' +
    '                                        <li>\n' +
    '                                            <a href="">Other Settings</a>\n' +
    '                                        </li>\n' +
    '                                    </ul>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '\n' +
    '                            <button class="btn bgm-cyan btn-float"><i class="zmdi zmdi-plus"></i></button>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="card-body">\n' +
    '                            <div class="listview">\n' +
    '\n' +
    '                                <a class="lv-item" href="" data-ng-repeat="w in rpctrl.rpResult.list">\n' +
    '                                    <div class="media">\n' +
    '                                        <div class="pull-left">\n' +
    '                                            <img class="lv-img-sm" data-ng-src="img/profile-pics/{{ w.img }}" alt="">\n' +
    '                                        </div>\n' +
    '                                        <div class="media-body">\n' +
    '                                            <div class="lv-title">{{ w.user }}</div>\n' +
    '                                            <small class="lv-small">{{ w.text }}</small>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </a>\n' +
    '\n' +
    '                                <div class="clearfix"></div>\n' +
    '\n' +
    '                                <a class="lv-footer" href="">View All</a>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </section>\n' +
    '</section>\n' +
    '\n' +
    '<footer id="footer" data-ng-include="\'template/footer.html\'"></footer>\n' +
    '<!--<footer id="footer-hypo" data-ng-include="\'template/footer-hypo.html\'"></footer>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('material-admin/material-admin.tpl.html',
    '<section id="main" data-ng-controller="MaterialAdminCtrl as mactrl">\n' +
    '    <script type="text/ng-template" id="tlItemModalContent.html">\n' +
    '        <div class="modal-header">\n' +
    '            <h3 class="modal-title">Template details</h3>\n' +
    '        </div>\n' +
    '        <div class="modal-body">\n' +
    '            <p class="m-b-5">Template id: <b>{{tlItem.id}}</b></p>\n' +
    '            <p class="m-b-5">Account id: <b>{{tlItem.accountId}}</b></p>\n' +
    '            <p class="m-b-5" style="text-transform:capitalize">Template name: <b>{{tlItem.name}}</b></p>\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <button type="input"class="btn btn-default app-btn-blue" ng-click="cancel()">Close</button>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '    <div class="container">\n' +
    '        <div class="row main-row">\n' +
    '            <div class="side-column col-sm-4 p-0">\n' +
    '                <div class="wb-list-wrapper app-white-card m-b-15">\n' +
    '                    <a href="">\n' +
    '                        <div class="wb-list-item-lg">Quick payment or transfer<i class="zmdi zmdi-chevron-right pull-right"></i></div>\n' +
    '                    </a>\n' +
    '                    <div class="visible-xs">\n' +
    '                        <hr class="m-b-0 m-t-0 iban-style">\n' +
    '                        <a href="">\n' +
    '                            <div class="wb-list-item-lg">Pay template<i class="zmdi zmdi-chevron-right pull-right"></i></div>\n' +
    '                        </a>\n' +
    '                    </div>\n' +
    '                    <div class="hidden-xs">\n' +
    '                        <div class="form-group">\n' +
    '                            <div class="input-group">\n' +
    '                                <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">\n' +
    '                                    <button class="btn btn-default" type="submit" style="box-shadow:none;">\n' +
    '                                        <i class="glyphicon glyphicon-search"></i>\n' +
    '                                    </button>\n' +
    '                                </div>\n' +
    '                                <input data-ng-model="tmpSearchText.name" type="text" class="form-control srch-input" placeholder="Search templates" name="srch-term" id="srch-term">\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <a data-ng-repeat="template in templateList.result | filter:tmpSearchText | limitTo : 5" href="">\n' +
    '                            <div ng-click="openTlItemModal(template, \'sm\')" class="wb-list-item" style="text-transform:capitalize;" data-ng-class="{\'wb-list-item-last\':$last}">{{template.name}}<i class="zmdi zmdi-chevron-right pull-right"></i></div>\n' +
    '                        </a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="hidden-xs">\n' +
    '                    <div data-ng-include="\'template/dashboard/instant-loan.tpl.html\'"></div>\n' +
    '                    <div data-ng-include="\'template/dashboard/contact-us.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="main-column col-sm-8 no-padding-on-phone">\n' +
    '                <div class="row">\n' +
    '                    <div class="col-sm-12 col-md-6 m-b-15">\n' +
    '                        <a href="">\n' +
    '                            <div class="debit-account-widget p-15 app-white-card">\n' +
    '                                <h4>Current account</h4>\n' +
    '                                <h2 class="no-bottom-margin">1.200,32 HRK</h2>\n' +
    '                                <p class="m-b-0">989,23 HRK available</p>\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 col-md-6 m-b-15">\n' +
    '                        <a href="">\n' +
    '                            <div class="savings-account-widget p-15 app-white-card">\n' +
    '                                <h4>Savings account</h4>\n' +
    '                                <h2 class="no-bottom-margin">1.200,32 RSD</h2>\n' +
    '                                <p class="m-b-0">989,23 RSD available</p>\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 col-md-6 m-b-15">\n' +
    '                        <a href="">\n' +
    '                            <div class="credit-master-account-widget p-15 app-white-card no-bottom-radius">\n' +
    '                                <h4>MasterCard Gold</h4>\n' +
    '                                <h2 class="no-bottom-margin">1.200,32 RSD</h2>\n' +
    '                                <p class="m-b-0">989,23 RSD available</p>\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '                        <uib-progressbar style="height:10px;" value="55"></uib-progressbar>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 col-md-6 m-b-15">\n' +
    '                        <a href="">\n' +
    '                            <div class="credit-visa-account-widget p-15 app-white-card no-bottom-radius">\n' +
    '                                <h4>Visa</h4>\n' +
    '                                <h2 class="no-bottom-margin">1.200,32 RSD</h2>\n' +
    '                                <p class="m-b-0">989,23 RSD available</p>\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '                        <uib-progressbar style="height:10px;" value="72"></uib-progressbar>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 hidden-xs" style="text-align:center;">\n' +
    '                        <button type="input"class="btn btn-default app-btn-blue-inverse show-all-accounts-btn">Show more accounts</button>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '                <h4 class="m-t-15 m-b-15 hidden-xs">Your bank timeline</h4>\n' +
    '                <div class="timeline-row com-sm-12">\n' +
    '                    <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">\n' +
    '                        <ul class="hypo-timeline">\n' +
    '                            <!-- timeline time label pending -->\n' +
    '                            <li class="time-label htl-item-pending">\n' +
    '                                <span class="bg-white htl-item-pending">Pending</span>\n' +
    '                            </li>\n' +
    '                            <!-- timeline item -->\n' +
    '                            <li>\n' +
    '                                <i class="zmdi zmdi-time-interval icon-pending"></i>\n' +
    '                                <div class="hypo-timeline-item htl-item-pending">\n' +
    '                                    <div class="hypo-timeline-body">\n' +
    '                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Monthly Salary</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-income">+ 700,00 HRK</div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </li>\n' +
    '                            <!-- timeline time label -->\n' +
    '                            <li class="time-label">\n' +
    '                                <span class="bg-white">Today</span>\n' +
    '                            </li>\n' +
    '                            <!-- timeline item -->\n' +
    '                            <li>\n' +
    '                                <i class="fa fa-income"></i>\n' +
    '                                <div class="hypo-timeline-item">\n' +
    '                                    <div class="hypo-timeline-body">\n' +
    '                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Monthly Salary</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-income">+ 700,00 HRK</div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </li>\n' +
    '                            <li>\n' +
    '                                <i class="fa fa-outcome"></i>\n' +
    '                                <div class="hypo-timeline-item">\n' +
    '                                    <div class="hypo-timeline-body">\n' +
    '                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Shop Payment</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-outcome">- 70,00 HRK</div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </li>\n' +
    '                            <!-- timeline time label -->\n' +
    '                            <li class="time-label">\n' +
    '                                <span class="bg-white">24. Feb</span>\n' +
    '                            </li>\n' +
    '                            <!-- timeline item -->\n' +
    '                            <li>\n' +
    '                                <i class="zmdi zmdi-forward item-online-payment"></i>\n' +
    '                                <div class="hypo-timeline-item">\n' +
    '                                    <div class="hypo-timeline-body">\n' +
    '                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Monthly Salary</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>\n' +
    '                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-income">+ 700,00 HRK</div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </li>\n' +
    '                            <li class="htl-login-item">\n' +
    '                                <span class=htl-login-label>\n' +
    '                                    <i class="zmdi zmdi-circle"></i>\n' +
    '                                    <span class="login-desc">Login at 19:23 from mobile device</span>\n' +
    '                                <span class="login-desc-light hidden-xs">  (iOS Safari, IP 193.123.234.21)</span>\n' +
    '                                </span>\n' +
    '                            </li>\n' +
    '                            <!-- timeline time label -->\n' +
    '                            <li class="time-label">\n' +
    '                                <span class="bg-white">23. Feb</span>\n' +
    '                            </li>\n' +
    '                            <!-- timeline item -->\n' +
    '                            <li>\n' +
    '                                <div class="hypo-timeline-item msg-item">\n' +
    '                                    <div class="bubble">\n' +
    '                                        <p class="msg-label no-bottom-margin">You received new e-invoice from Elektro Ljubljana d.o.o\n' +
    '                                            <span class="msg-action pull-right hidden-xs"><a href="">View it</a></span>\n' +
    '                                        </p>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="com-sm-12 visible-xs">\n' +
    '                    <div data-ng-include="\'template/dashboard/instant-loan.tpl.html\'"></div>\n' +
    '                    <div data-ng-include="\'template/dashboard/contact-us.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<footer id="footer" data-ng-include="\'template/footer.html\'"></footer>\n' +
    '<!--<footer id="footer-hypo" data-ng-include="\'template/footer-hypo.html\'"></footer>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('material-admin/material-admin.FrontPage.tpl.html',
    '<header id="header" data-current-skin={{mactrl.currentSkin}} data-ng-include="\'template/header.html\'" data-ng-controller="headerCtrl as hctrl"></header>\n' +
    '\n' +
    '<section id="main" data-ng-controller="MaterialAdminCtrl as mactrl">\n' +
    '    <div class="container" ng-init="cddMenuSelected=1">\n' +
    '        <div class="row">\n' +
    '            <!--LEFT COLUMN-->\n' +
    '            <div class="col-md-3">\n' +
    '                <div id="paymentMenuAccounts" class="pm-wrapper app-white-card">\n' +
    '                    <div class="pm-item">Make a payment</div>\n' +
    '                    <div class="pm-item">Manage payments</div>\n' +
    '                    <div class="pm-item">Manage payees</div>\n' +
    '                    <div class="pm-item pm-item-last">Manage cards</div>\n' +
    '                </div>\n' +
    '                <br/>\n' +
    '                <div id="quickPaymentFormDiv" class="app-white-card">\n' +
    '                    <div class="form-group">\n' +
    '                        <div class="input-group">\n' +
    '                            <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">\n' +
    '                                <button class="btn btn-default" type="submit" style="box-shadow:none;">\n' +
    '                                    <i class="glyphicon glyphicon-search"></i>\n' +
    '                                </button>\n' +
    '                            </div>\n' +
    '                            <input type="text" class="form-control srch-input" placeholder="Search" name="srch-term" id="srch-term">\n' +
    '\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <br/>\n' +
    '                    <form id="quickPaymentForm">\n' +
    '                        <div class="form-group">\n' +
    '                            <label for="qpAccountFrom">Filter by type:</label>\n' +
    '                            <div id="customCheckbox" class="checkbox-group-div" ng-init="cbSelected=1">\n' +
    '                                <div class="hypo-cb-item" ng-click="cbSelected=1">\n' +
    '                                    <div class="hypo-cb-item-img" style="background:url(\'{{cbSelected == 1 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}\') no-repeat center;background-size: 24px 24px;background-position-x: left;">\n' +
    '                                        <!--<img ng-src="{{cbSelected == 1 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}" height="100%" width="100%"/>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="hypo-cb-item-label">All</div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item" ng-click="cbSelected=2">\n' +
    '                                    <div class="hypo-cb-item-img" style="background:url(\'{{cbSelected == 2 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}\') no-repeat center;background-size: 24px 24px;background-position-x: left;">\n' +
    '                                        <!--<img ng-src="{{cbSelected == 1 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}" height="100%" width="100%"/>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="hypo-cb-item-label">Credit (+)</div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item" ng-click="cbSelected=3">\n' +
    '                                    <div class="hypo-cb-item-img" style="background:url(\'{{cbSelected == 3 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}\') no-repeat center;background-size: 24px 24px;background-position-x: left;">\n' +
    '                                        <!--<img ng-src="{{cbSelected == 1 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}" height="100%" width="100%"/>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="hypo-cb-item-label">Debit (-)</div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item" ng-click="cbSelected=4">\n' +
    '                                    <div class="hypo-cb-item-img" style="background:url(\'{{cbSelected == 4 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}\') no-repeat center;background-size: 24px 24px;background-position-x: left;">\n' +
    '                                        <!--<img ng-src="{{cbSelected == 1 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}" height="100%" width="100%"/>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="hypo-cb-item-label">ATM withdrawals</div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item hypo-cb-item-last" ng-click="cbSelected=5">\n' +
    '                                    <div class="hypo-cb-item-img" style="background:url(\'{{cbSelected == 5 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}\') no-repeat center;background-size: 24px 24px;background-position-x: left;">\n' +
    '                                        <!--<img ng-src="{{cbSelected == 1 && \'../img/hypo/checkbox-yes.png\' || \'../img/hypo/checkbox-no.png\'}}" height="100%" width="100%"/>-->\n' +
    '                                    </div>\n' +
    '                                    <div class="hypo-cb-item-label">Standing orders</div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="form-group">\n' +
    '                            <label for="qpAmount">Amount range</label>\n' +
    '                            <div class="input-group">\n' +
    '                                <input type="text" class="form-control" id="qpAmount" placeholder="Enter amount">\n' +
    '                                <div class="input-group-addon qp-amount">RSD</div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="form-group">\n' +
    '                            <label for="qpAmount">To</label>\n' +
    '                            <div class="input-group">\n' +
    '                                <input type="text" class="form-control" id="qpAmount" placeholder="Enter amount">\n' +
    '                                <div class="input-group-addon qp-amount">RSD</div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <button id="qpSubmitBtn" type="submit" style="width:100%;" class="btn btn-default app-btn-gray">Reset</button>\n' +
    '                        <div style="height:10px;"></div>\n' +
    '                        <button id="qpSubmitBtn" type="submit" style="width:100%;" class="btn btn-default app-btn-blue">Apply</button>\n' +
    '                    </form>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="visible-xs-block visible-sm-block" style="height:10px;">\n' +
    '\n' +
    '            </div>\n' +
    '            <!--CENTER COLUMN-->\n' +
    '            <div class="col-md-9 frontPage">\n' +
    '\n' +
    '\n' +
    '                <div class="personalFirstRow carousel slide" data-ride="carousel">\n' +
    '                    <!--  <div id="timelineViewSelector" ng-init="timelineViewSelectorSelected=1">\n' +
    '            <div class="timeline-view-select-label" ng-click="timelineViewSelectorSelected=1" ng-class="{selected: timelineViewSelectorSelected == 1}">Transactions</div>\n' +
    '            <div class="timeline-view-select-label" ng-click="timelineViewSelectorSelected=2" ng-class="{selected: timelineViewSelectorSelected == 2}">Pdf statements</div>\n' +
    '          </div>-->\n' +
    '                    <!-- Wrapper for slides -->\n' +
    '                    <div class="carousel-inner" role="listbox">\n' +
    '\n' +
    '                        <div class="item active">\n' +
    '                            <div class="slide-padding">\n' +
    '                                <div class="col-md-12">\n' +
    '                                    <h2 class="boldBlueHeader">New mobile banking app</h2>\n' +
    '                                    <p class="blueFont">Secure, quick payments, instant products and more</p>\n' +
    '                                    <button type="submit" style="width:25%;font-size:0.9em;" class="downloadTodayBtn btn btn-default app-btn-blue">Download today</button>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="item">\n' +
    '                            <div class="slide-padding">\n' +
    '                                <div class="col-md-12">\n' +
    '                                    <h1 class="boldBlueHeader">New mobile banking app</h1>\n' +
    '                                    <h4>Secure, quick payments, instant products and more</h4>\n' +
    '                                    <br/>\n' +
    '                                    <button type="submit" style="width:20%;" class="downloadToday2Btn btn btn-default app-btn-blue">Download today</button>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '\n' +
    '                    <!--  <div id="periodViewSelector" ng-init="timelineViewSelectorSelected=1">\n' +
    '            <div class="period-view-select-div left" ng-click="timelineViewSelectorSelected=1" ng-class="{selected: timelineViewSelectorSelected == 1}">Period:</div>\n' +
    '            <div class="period-view-select-div right" ng-click="timelineViewSelectorSelected=2" ng-class="{selected: timelineViewSelectorSelected == 2}">\n' +
    '              <div class="dropdown acc-period-select" ng-init="periodSelectorLabel=\'This week\'">\n' +
    '                <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '                  {{periodSelectorLabel}}\n' +
    '                  <span class="caret" style="color:#FF4D5A;"></span>\n' +
    '                </button>\n' +
    '                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                  <li>\n' +
    '                    <a ng-click="periodSelectorLabel=\'Yesterday\'">Yesterday</a>\n' +
    '                  </li>\n' +
    '                  <li>\n' +
    '                    <a ng-click="periodSelectorLabel=\'This Month\'">This Month</a>\n' +
    '                  </li>\n' +
    '                  <li>\n' +
    '                    <a ng-click="periodSelectorLabel=\'This year\'">This year</a>\n' +
    '                  </li>\n' +
    '                </ul>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>-->\n' +
    '\n' +
    '                    <!-- Left and right controls -->\n' +
    '                    <a ng-non-bindable class="left carousel-control" href="personalFirstRow" role="button" data-slide="prev" style="background-image: none;width:10%;">\n' +
    '                        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>\n' +
    '                        <span class="sr-only">Previous</span>\n' +
    '                    </a>\n' +
    '                    <a ng-non-bindable class="right carousel-control" href="personalFirstRow" role="button" data-slide="next" style="background-image: none;width:10%;">\n' +
    '                        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>\n' +
    '                        <span class="sr-only">Next</span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '                <!--SECOND ROW-->\n' +
    '                <div class="personalHome">\n' +
    '                    <div class="personalSecondRow">\n' +
    '                        <h2 class="boldBlueHeader">Hypo rewards</h2>\n' +
    '                      <!--  <p class="lowerText">The more you use the app the more points you will earn which will let you claim some great rewards.</p>-->\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <!--THIRD ROW-->\n' +
    '                <div class="personalHome">\n' +
    '                    <div class="personalThirdRow">\n' +
    '                        <h2 class="boldBlueHeader">Housing loans</h2>\n' +
    '                        <br/>\n' +
    '                        <p class="lowerText2">We have some great loans that could help you purchase the property of your dreams.</p>\n' +
    '                         <br/> <br/> <br/> <br/>\n' +
    '                        <p class="lowerText2">*Low rates</p><br/>\n' +
    '                        <p class="lowerText2">*Quick approval</p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<footer id="footer" data-ng-include="\'template/footer.html\'"></footer>\n' +
    '<!--<footer id="footer-hypo" data-ng-include="\'template/footer-hypo.html\'"></footer>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('material-admin/material-admin.DashboardPage.tpl.html',
    '<header id="header" data-current-skin={{mactrl.currentSkin}} data-ng-include="\'template/header.html\'" data-ng-controller="HeaderCtrl as hctrl"></header>\n' +
    '\n' +
    '<section id="main">\n' +
    '  <div class="container" ng-init="cddMenuSelected=1">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-3">\n' +
    '        <div id="changeDashboardDisplay" class="app-white-card">\n' +
    '          <div class="col-md-6 cdd-menu cdd-menu-left" ng-click="cddMenuSelected=1" ng-class="{selected: cddMenuSelected == 1}">Accounts</div>\n' +
    '          <div class="col-md-6 cdd-menu cdd-menu-right" ng-click="cddMenuSelected=2" ng-class="{selected: cddMenuSelected == 2}">Timeline</div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6"></div>\n' +
    '      <div class="col-md-3"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <br/>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <!--LEFT COLUMN-->\n' +
    '      <div class="col-md-3">\n' +
    '        <div id="quickPaymentFormDiv" class="app-white-card">\n' +
    '          <h4>\n' +
    '            Make a quick payment/transfer\n' +
    '          </h4>\n' +
    '          <br/>\n' +
    '          <form id="quickPaymentForm">\n' +
    '            <div class="form-group">\n' +
    '              <label for="qpAccountFrom">From</label>\n' +
    '              <select id="qpAccountFrom" class="form-control">\n' +
    '                <option value="" disabled selected hidden style="color:lightgray;">Select account</option>\n' +
    '                <option value="0">54693456333 RSD</option>\n' +
    '                <option value="1">54693456333 RSD</option>\n' +
    '              </select>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label for="qpAccountTo">To</label>\n' +
    '              <select id="qpAccountTo" class="form-control">\n' +
    '                <option value="" disabled selected hidden style="color:lightgray;">Select account</option>\n' +
    '                <option value="0">54693456333 RSD</option>\n' +
    '                <option value="1">54693456333 RSD</option>\n' +
    '              </select>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label for="qpAmount">Amount</label>\n' +
    '              <div class="input-group">\n' +
    '                <input type="text" class="form-control" id="qpAmount" placeholder="Enter amount">\n' +
    '                <div class="input-group-addon qp-amount">RSD</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <button id="qpSubmitBtn" type="submit" style="width:100%;" class="btn btn-default app-btn-blue">Make payment</button>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '        <br/>\n' +
    '        <div id="paymentMenu" class="app-white-card">\n' +
    '          <div class="pm-item">Currency exchange</div>\n' +
    '          <div class="pm-item">Loan</div>\n' +
    '          <div class="pm-item">Savings account</div>\n' +
    '          <div class="pm-item">Credit card</div>\n' +
    '          <div class="pm-item pm-item-last">Travel insurance</div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="visible-xs-block visible-sm-block" style="height:10px;"></div>\n' +
    '      <!--CENTER COLUMN-->\n' +
    '      <div class="col-md-6">\n' +
    '        <div id="currentAccountWidget" class="p10 app-white-card">\n' +
    '          <div class="col-md-8 wc-right-div">\n' +
    '            <h4>Euro current</h4>\n' +
    '            <h2 class="no-bottom-margin">1.200,32 RSD</h2>\n' +
    '            <p>989,23 RSD available</p>\n' +
    '          </div>\n' +
    '          <div class="col-md-4 wc-left-div">\n' +
    '            <div class="wc-left-div-wrapper">\n' +
    '              <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">View account</button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <br/>\n' +
    '        <div id="creditAccountWidget" class="p10 app-white-card">\n' +
    '          <div class="col-md-8 wc-right-div">\n' +
    '            <h4>Credit card</h4>\n' +
    '            <h2 class="no-bottom-margin">2.100,32 RSD</h2>\n' +
    '            <p>1989,23 RSD available</p>\n' +
    '            <p class="no-bottom-margin">\n' +
    '              <b>Payment due date: 12//11/15</b>\n' +
    '            </p>\n' +
    '            <p>\n' +
    '              <b>Minimum payment: 20.000 RSD</b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div class="col-md-4 wc-left-div">\n' +
    '            <div class="wc-left-div-wrapper">\n' +
    '              <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">View account</button>\n' +
    '              <div style="height:5px;"></div>\n' +
    '              <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">Pay card</button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <br/>\n' +
    '        <div id="savingsAccountWidget" class="p10 app-white-card">\n' +
    '          <div class="col-md-8 wc-right-div">\n' +
    '            <h4>Car savings fund</h4>\n' +
    '            <h2 class="no-bottom-margin">35.000,000,00 RSD</h2>\n' +
    '            <p>reached of 50.000,000,00</p>\n' +
    '          </div>\n' +
    '          <div class="col-md-4 wc-left-div">\n' +
    '            <div class="wc-left-div-wrapper">\n' +
    '              <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">View savings</button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--RIGHT COLUMN-->\n' +
    '      <div class="col-md-3">\n' +
    '        <div id="curentStatusView" class="app-white-card">\n' +
    '          <h4>Since pay day you have spent</h4>\n' +
    '          <h2>1.200,00 RSD</h2>\n' +
    '          <hr/>\n' +
    '          <p>\n' +
    '            At this spend rate you will save\n' +
    '            <b>1.002,92 RSD</b>\n' +
    '            by the end of the month.\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <br/>\n' +
    '        <div id="didYouKnowView" class="app-white-card">\n' +
    '          <h4>Did you know?</h4>\n' +
    '          <br/>\n' +
    '          <p>\n' +
    '            George Washington, Abraham Lincoln, Andrew Jackson – most of our paper currency features U.S. presidents. There are only two exceptions: Alexander Hamilton is on the $10 bill and Benjamin Franklin is on the $100.\n' +
    '          </p>\n' +
    '          <br/>\n' +
    '          <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">Find out more</button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '\n' +
    '<footer id="footer" data-ng-include="\'template/footer.html\'"></footer>\n' +
    '<!--<footer id="footer-hypo" data-ng-include="\'template/footer-hypo.html\'"></footer>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('material-admin/material-admin.AccountsPage.tpl.html',
    '<header id="header" data-current-skin={{mactrl.currentSkin}} data-ng-include="\'template/header.html\'" data-ng-controller="headerCtrl as hctrl"></header>\n' +
    '\n' +
    '<section id="main" data-ng-controller="MaterialAdminCtrl as mactrl">\n' +
    '    <div class="container" ng-init="cddMenuSelected=1">\n' +
    '        <div class="row">\n' +
    '            <!--LEFT COLUMN-->\n' +
    '            <div class="col-md-3">\n' +
    '                <div id="paymentMenuAccounts" class="pm-wrapper app-white-card">\n' +
    '                    <div class="pm-item">Make a payment <span class="icon-angle-right pull-right"></span></div>\n' +
    '                    <div class="pm-item">Manage payments</div>\n' +
    '                    <div class="pm-item">Manage payees</div>\n' +
    '                    <div class="pm-item pm-item-last">Manage cards</div>\n' +
    '                </div>\n' +
    '                <br/>\n' +
    '                <div id="quickPaymentFormDiv" class="app-white-card">\n' +
    '                    <div class="form-group">\n' +
    '                        <div class="input-group">\n' +
    '                            <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">\n' +
    '                                <button class="btn btn-default" type="submit" style="box-shadow:none;">\n' +
    '                                    <i class="glyphicon glyphicon-search"></i>\n' +
    '                                </button>\n' +
    '                            </div>\n' +
    '                            <input type="text" class="form-control srch-input" placeholder="Search" name="srch-term" id="srch-term">\n' +
    '\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <br/>\n' +
    '                    <form id="quickPaymentForm">\n' +
    '                        <div class="form-group">\n' +
    '                            <label for="qpAccountFrom">Filter by type:</label>\n' +
    '                            <div id="customCheckbox" class="checkbox-group-div">\n' +
    '                                <div class="hypo-cb-item">\n' +
    '                                    <div class="radio m-b-0">\n' +
    '                                        <label>\n' +
    '                                            <input type="radio" name="sample" value="">\n' +
    '                                            <i class="input-helper"></i> All\n' +
    '                                        </label>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item">\n' +
    '                                    <div class="radio m-b-0">\n' +
    '                                        <label>\n' +
    '                                            <input type="radio" name="sample" value="">\n' +
    '                                            <i class="input-helper"></i> Credit (+)\n' +
    '                                        </label>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item">\n' +
    '                                    <div class="radio m-b-0">\n' +
    '                                        <label>\n' +
    '                                            <input type="radio" name="sample" value="">\n' +
    '                                            <i class="input-helper"></i> Debit (-)\n' +
    '                                        </label>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item">\n' +
    '                                    <div class="radio m-b-0">\n' +
    '                                        <label>\n' +
    '                                            <input type="radio" name="sample" value="">\n' +
    '                                            <i class="input-helper"></i> ATM withdrawals\n' +
    '                                        </label>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="hypo-cb-item hypo-cb-item-last">\n' +
    '                                    <div class="radio m-b-0">\n' +
    '                                        <label>\n' +
    '                                            <input type="radio" name="sample" value="">\n' +
    '                                            <i class="input-helper"></i> Standing orders\n' +
    '                                        </label>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <br />\n' +
    '                        <div class="form-group">\n' +
    '                            <label for="qpAmount">Amount range</label>\n' +
    '                            <div class="input-group">\n' +
    '                                <input type="text" class="form-control" id="qpAmount" placeholder="Enter amount">\n' +
    '                                <div class="input-group-addon qp-amount">RSD</div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="form-group">\n' +
    '                            <label for="qpAmount">To</label>\n' +
    '                            <div class="input-group">\n' +
    '                                <input type="text" class="form-control" id="qpAmount" placeholder="Enter amount">\n' +
    '                                <div class="input-group-addon qp-amount">RSD</div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <button id="qpSubmitBtn" type="submit" style="width:100%;" class="btn btn-default app-btn-gray">Reset</button>\n' +
    '                        <div style="height:10px;"></div>\n' +
    '                        <button id="qpSubmitBtn" type="submit" style="width:100%;" class="btn btn-default app-btn-blue">Apply</button>\n' +
    '                    </form>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="visible-xs-block visible-sm-block" style="height:10px;"></div>\n' +
    '            <!--CENTER COLUMN-->\n' +
    '            <div class="col-md-9">\n' +
    '                <div id="myCarousel" class="carousel slide" data-ride="carousel">\n' +
    '                    <div id="timelineViewSelector" ng-init="timelineViewSelectorSelected=1">\n' +
    '                        <div class="timeline-view-select-label" ng-click="timelineViewSelectorSelected=1" ng-class="{selected: timelineViewSelectorSelected == 1}">Transactions</div>\n' +
    '                        <div class="timeline-view-select-label" ng-click="timelineViewSelectorSelected=2" ng-class="{selected: timelineViewSelectorSelected == 2}">Pdf statements</div>\n' +
    '                    </div>\n' +
    '                    <!-- Wrapper for slides -->\n' +
    '                    <div class="carousel-inner" role="listbox">\n' +
    '\n' +
    '                        <div class="item active">\n' +
    '                            <div id="" class="slide-padding">\n' +
    '                                <div class="col-md-12">\n' +
    '                                    <h4 class="no-bottom-margin">Euro account</h4>\n' +
    '                                    <p>Acc no: 1234567890</p>\n' +
    '                                    <h1>1.200,000,32 RSD</h1>\n' +
    '                                    <br/>\n' +
    '                                    <p class="no-bottom-margin">\n' +
    '                                        <b>Available to spend: 602.14 RSD</b>\n' +
    '                                    </p>\n' +
    '                                    <p>\n' +
    '                                        <b>Overdraft limit: 2,000 RSD</b>\n' +
    '                                    </p>\n' +
    '                                    <br/>\n' +
    '                                    <p>\n' +
    '                                        <a style="color:black;">\n' +
    '                                            <u>More information</u>\n' +
    '                                        </a>\n' +
    '                                    </p>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="item">\n' +
    '                            <div id="" class="slide-padding">\n' +
    '                                <div class="col-md-12">\n' +
    '                                    <h4 class="no-bottom-margin">Card account</h4>\n' +
    '                                    <p>Acc no: 9876543210</p>\n' +
    '                                    <h1>2.300,32 RSD</h1>\n' +
    '                                    <br/>\n' +
    '                                    <p class="no-bottom-margin">\n' +
    '                                        <b>Available to spend: 1602.14 RSD</b>\n' +
    '                                    </p>\n' +
    '                                    <p>\n' +
    '                                        <b>Overdraft limit: 8,000 RSD</b>\n' +
    '                                    </p>\n' +
    '                                    <br/>\n' +
    '                                    <p>\n' +
    '                                        <a>\n' +
    '                                            <u>More information</u>\n' +
    '                                        </a>\n' +
    '                                    </p>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div id="periodViewSelector" ng-init="timelineViewSelectorSelected=1" ng-show="timelineViewSelectorSelected == 1">\n' +
    '                        <div class="period-view-select-div left">Period:</div>\n' +
    '                        <div class="period-view-select-div right">\n' +
    '                            <div class="dropdown acc-period-select" ng-init="periodSelectorLabel=\'This week\'">\n' +
    '                                <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '                                    {{periodSelectorLabel}}\n' +
    '                                    <span class="caret" style="color:#FF4D5A;"></span>\n' +
    '                                </button>\n' +
    '                                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                                    <li>\n' +
    '                                        <a ng-click="periodSelectorLabel=\'Yesterday\'">Yesterday</a>\n' +
    '                                    </li>\n' +
    '                                    <li>\n' +
    '                                        <a ng-click="periodSelectorLabel=\'This Month\'">This Month</a>\n' +
    '                                    </li>\n' +
    '                                    <li>\n' +
    '                                        <a ng-click="periodSelectorLabel=\'This year\'">This year</a>\n' +
    '                                    </li>\n' +
    '                                </ul>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Left and right controls -->\n' +
    '                    <a ng-non-bindable class="left carousel-control" class="left carousel-control" href="#myCarousel" role="button" data-slide="prev" style="background-image: none;width:10%;">\n' +
    '                        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>\n' +
    '                        <span class="sr-only">Previous</span>\n' +
    '                    </a>\n' +
    '                    <a ng-non-bindable class="right carousel-control" class="right carousel-control" href="#myCarousel" role="button" data-slide="next" style="background-image: none;width:10%;">\n' +
    '                        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>\n' +
    '                        <span class="sr-only">Next</span>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '                <br>\n' +
    '                <div class="hypo-timeline-header-line  visible-md-block visible-sm-block visible-lg-block">\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-sm-3 t-a-c">Description</div>\n' +
    '                        <div class="col-sm-3 t-a-c">Out</div>\n' +
    '                        <div class="col-sm-3 t-a-c">In</div>\n' +
    '                        <div class="col-sm-3 t-a-c">Balance</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">\n' +
    '                    <ul class="hypo-timeline">\n' +
    '                        <!-- timeline time label -->\n' +
    '                        <li class="time-label">\n' +
    '                            <span class="bg-white">04/02</span>\n' +
    '                        </li>\n' +
    '                        <!-- /.timeline-label -->\n' +
    '                        <!-- timeline item -->\n' +
    '                        <li>\n' +
    '                            <i class="fa fa-income"></i>\n' +
    '\n' +
    '                            <div class="hypo-timeline-item">\n' +
    '\n' +
    '                                <div class="hypo-timeline-body">\n' +
    '                                    <div class="row">\n' +
    '                                        <div class="col-sm-3 t-a-c">Aman Market</div>\n' +
    '                                        <div class="col-sm-3 t-a-c"></div>\n' +
    '                                        <div class="col-sm-3 t-a-c">+1.500,00</div>\n' +
    '                                        <div class="col-sm-3 t-a-c">+700,00</div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </li>\n' +
    '                        <li>\n' +
    '                            <i class="fa fa-outcome"></i>\n' +
    '\n' +
    '                            <div class="hypo-timeline-item">\n' +
    '\n' +
    '                                <div class="hypo-timeline-body">\n' +
    '                                    <div class="row">\n' +
    '                                        <div class="col-sm-3 t-a-c">Aman Market</div>\n' +
    '                                        <div class="col-sm-3 t-a-c">-2.000,00</div>\n' +
    '                                        <div class="col-sm-3 t-a-c"></div>\n' +
    '                                        <div class="col-sm-3 t-a-c">+700,00</div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </li>\n' +
    '                        <!-- END timeline item -->\n' +
    '                        <!-- timeline item -->\n' +
    '                        <li>\n' +
    '                            <i class="fa fa-sort-asc"></i>\n' +
    '\n' +
    '                            <div class="hypo-timeline-item">\n' +
    '\n' +
    '                                <div class="hypo-timeline-body">\n' +
    '                                    <div class="row">\n' +
    '                                        <div class="col-sm-3 col-xs-12 t-a-c" style="margin-top: 5px">November</div>\n' +
    '                                        <div class="col-sm-3 col-xs-12 t-a-c"></div>\n' +
    '                                        <div class="col-sm-3 col-xs-12 t-a-c">\n' +
    '                                            <p class="statement-action no-bottom-margin">Download</p>\n' +
    '                                        </div>\n' +
    '                                        <div class="col-sm-3 col-xs-12 t-a-c">\n' +
    '                                            <p class="statement-action no-bottom-margin">View statement</p>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </li>\n' +
    '\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '                <!--TRANSACTIONS TIMELINE-->\n' +
    '                <div class="table-responsive" ng-show="timelineViewSelectorSelected == 1">\n' +
    '                    <table class="table table-fixed">\n' +
    '                        <thead>\n' +
    '                            <tr>\n' +
    '                                <th></th>\n' +
    '                                <th style="background-color:#EDECEC;">Description</th>\n' +
    '                                <th style="background-color:#EDECEC;">Account</th>\n' +
    '                                <th style="background-color:#EDECEC;">Out</th>\n' +
    '                                <th style="background-color:#EDECEC;">In</th>\n' +
    '                                <th style="background-color:#EDECEC;">Balance</th>\n' +
    '                            </tr>\n' +
    '                        </thead>\n' +
    '                        <tbody>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/line.png\') no-repeat center;background-size: auto 100%;">\n' +
    '                                    <span class="tl-badge-label">{{timelineData[0].desc}}</span>\n' +
    '                                </td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/shopping.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>{{data.name}}</td>\n' +
    '                                <td>Euro Account</td>\n' +
    '                                <td>-100,00</td>\n' +
    '                                <td></td>\n' +
    '                                <td>+1300,32</td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/money.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>Aman Market</td>\n' +
    '                                <td>Euro Account</td>\n' +
    '                                <td>-100,00</td>\n' +
    '                                <td></td>\n' +
    '                                <td>+1300,32</td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/money.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>Aman Market</td>\n' +
    '                                <td>Euro Account</td>\n' +
    '                                <td>-100,00</td>\n' +
    '                                <td></td>\n' +
    '                                <td>+1300,32</td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/line.png\') no-repeat center;background-size: auto 100%;">\n' +
    '                                    <span class="tl-badge-label">4/2</span>\n' +
    '                                </td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/shopping.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>Aman Market</td>\n' +
    '                                <td>Euro Account</td>\n' +
    '                                <td>-100,00</td>\n' +
    '                                <td></td>\n' +
    '                                <td>+1300,32</td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/page2xh.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td colspan="5">\n' +
    '                                    <div class="bubble">\n' +
    '                                        <p class="msg-label no-bottom-margin">October statement for Euro current Account is available\n' +
    '                                            <span class="glyphicon glyphicon-star-empty pull-right"></span>\n' +
    '                                        </p>\n' +
    '                                        <div>\n' +
    '                                            <p class="msg-action no-bottom-margin">Dismiss</p>\n' +
    '                                            <p class="msg-action no-bottom-margin">View statement</p>\n' +
    '                                        </div>\n' +
    '\n' +
    '                                    </div>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/money.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>\n' +
    '                                    November\n' +
    '                                </td>\n' +
    '                                <td colspan="4" class="statement-btn-cell">\n' +
    '                                    <p class="statement-action no-bottom-margin">Download</p>\n' +
    '                                    <p class="statement-action no-bottom-margin">View statement</p>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '                </div>\n' +
    '                <!--STATEMENTS TABLE-->\n' +
    '                <div class="table-responsive" ng-show="timelineViewSelectorSelected == 2">\n' +
    '                    <table class="table table-fixed">\n' +
    '                        <thead>\n' +
    '                            <tr>\n' +
    '                                <th></th>\n' +
    '                                <th style="background-color:#EDECEC; color:#EDECEC !important;">Description</th>\n' +
    '                                <th style="background-color:#EDECEC; color:#EDECEC !important;">Account</th>\n' +
    '                                <th style="background-color:#EDECEC; color:#EDECEC !important;">Out</th>\n' +
    '                                <th style="background-color:#EDECEC; color:#EDECEC !important;">In</th>\n' +
    '                                <th style="background-color:#EDECEC; color:#EDECEC !important;">Balance</th>\n' +
    '                            </tr>\n' +
    '                        </thead>\n' +
    '                        <tbody>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/line.png\') no-repeat center;background-size: auto 100%;">\n' +
    '                                    <span class="tl-badge-label">\n' +
    '                                        2016\n' +
    '                                    </span>\n' +
    '                                </td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                                <td></td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/money.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>\n' +
    '                                    November\n' +
    '                                </td>\n' +
    '                                <td colspan="4" class="statement-btn-cell">\n' +
    '                                    <p class="statement-action no-bottom-margin">Download</p>\n' +
    '                                    <p class="statement-action no-bottom-margin">View statement</p>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/money.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>\n' +
    '                                    Oktober\n' +
    '                                </td>\n' +
    '                                <td colspan="4" class="statement-btn-cell">\n' +
    '                                    <p class="statement-action no-bottom-margin">Download</p>\n' +
    '                                    <p class="statement-action no-bottom-margin">View statement</p>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/money.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>\n' +
    '                                    September\n' +
    '                                </td>\n' +
    '                                <td colspan="4" class="statement-btn-cell">\n' +
    '                                    <p class="statement-action no-bottom-margin">Download</p>\n' +
    '                                    <p class="statement-action no-bottom-margin">View statement</p>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td class="tl-badge-icon" style="background:url(\'../img/hypo/timeline/money.png\') no-repeat center;background-size: auto 100%;"></td>\n' +
    '                                <td>\n' +
    '                                    August\n' +
    '                                </td>\n' +
    '                                <td colspan="4" class="statement-btn-cell">\n' +
    '                                    <p class="statement-action no-bottom-margin">Download</p>\n' +
    '                                    <p class="statement-action no-bottom-margin">View statement</p>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<footer id="footer" data-ng-include="\'template/footer.html\'"></footer>\n' +
    '<!--<footer id="footer-hypo" data-ng-include="\'template/footer-hypo.html\'"></footer>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('material-admin/in-depth-modal.tpl.html',
    '<div class="notificationModal">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12">\n' +
    '      <div class="depth-modal-body text-left">\n' +
    '        <p translate="footer.dearClients" class="p-t-20 t-a-l"></p>\n' +
    '        <p translate="footer.modalText1"></p>\n' +
    '        <p translate="footer.modalText2"></p>\n' +
    '        <p translate="footer.modalText3"></p>\n' +
    '        <p translate="footer.regards" class="m-b-10"></p>\n' +
    '      </div>\n' +
    '      <div class="modal-footer">\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <button class="btn btn-primary-red statementBtnClose" ng-click="$close()"><span translate="footer.closeButton"></span></button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/tl-investment-transactions-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '  <tbody>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label"  translate="investOverview.shareAccount">Share account:</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="tridm-value-label">{{transaction.shareAccount}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="investOverview.dateOfEntry">Date of entry:</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="tridm-value-label">{{transaction.dateOfEntry | date: \'shortDate\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label"  translate="investOverview.shareQuant">Share quantity:</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="tridm-value-label">{{transaction.shareQuantity | currency: \'\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="investOverview.shareValue">Share value:</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="tridm-value-label">{{transaction.shareValue | currency: \'\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="investOverview.chargeValue">Charge value:</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="tridm-value-label">{{transaction.chargeValue | currency: \'\'}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/tl-investment-order-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '  <tbody>\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="investOverview.sharedAccount">:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="tridm-value-label">{{::order.accountNumberBuy}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="investOverview.invAmount">Amount:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="tridm-value-label">\n' +
    '        {{order.invAmount | number:2 }}\n' +
    '        {{::order.amountCurCode}}\n' +
    '      </span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="investOverview.invDate">Date:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="tridm-value-label">{{order.invAmountDate | date: \'shortDate\'}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="investOverview.buyAccount">Buy account id:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="tridm-value-label">{{::order.invBuyAccId}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td>\n' +
    '      <span class="po-desc-label" translate="investOverview.fundName">Fund name:</span>\n' +
    '    </td>\n' +
    '    <td>\n' +
    '      <span class="tridm-value-label">{{::order.fundName}}</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <!--<td>-->\n' +
    '      <!--<span class="po-desc-label" translate="investOverview.povlDueDate">Due date:</span>-->\n' +
    '    <!--</td>-->\n' +
    '    <!--<td>-->\n' +
    '      <!--<span class="po-value-label">{{::order.dueDate| date:\'shortDate\'}}</span>-->\n' +
    '    <!--</td>-->\n' +
    '  <!--</tr>-->\n' +
    '  <!--<tr>-->\n' +
    '    <!--<td colspan="2">-->\n' +
    '      <!--<div>-->\n' +
    '                    <!--<span class="pull-right" ng-repeat="actionObject in order.allowedActionList.itemList">-->\n' +
    '                        <!--<span ng-switch on="actionObject.methodName">-->\n' +
    '                            <!--<button ng-if="actionObject.isEnabled" ng-switch-when="RecallAllowed" ng-click="currencyConversion.recallPaymentAction(payment.id);"-->\n' +
    '                                    <!--class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase" translate="currencyConversion.recallPayment"-->\n' +
    '                                    <!--translate="paymentActions.recall"></button>-->\n' +
    '                            <!--<button ng-if="actionObject.isEnabled" ng-switch-when="SignAllowed" ng-click="currencyConversion.signPaymentAction(payment.id);"-->\n' +
    '                                    <!--class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"-->\n' +
    '                                    <!--translate="paymentActions.sign"></button>-->\n' +
    '                            <!--<button ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed" ng-click="currencyConversion.deletePaymentAction(payment.id, \'timeline\');"-->\n' +
    '                                    <!--class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"-->\n' +
    '                                    <!--translate="paymentActions.delete"></button>-->\n' +
    '                        <!--</span>-->\n' +
    '                    <!--</span>-->\n' +
    '      <!--</div>-->\n' +
    '    <!--</td>-->\n' +
    '  <!--</tr>-->\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investments.tpl.html',
    '<!--<section id="main">-->\n' +
    '  <!--<div class="container">-->\n' +
    '    <span>\n' +
    '        <!-- START Title -->\n' +
    '        <!--<div class="domp-header-wrapper col-sm-12 p-o">-->\n' +
    '          <!--<div class="domp-header-row">-->\n' +
    '            <!--<h2 class="intp-title" translate="invest.header"></h2>-->\n' +
    '          <!--</div>-->\n' +
    '        <!--</div>-->\n' +
    '      <!-- END Title-->\n' +
    '      <div class="domp-select-section col-sm-12 p-0">\n' +
    '        <!-- ADD SELECT FROM TEMPLATE HERE ! -->\n' +
    '        <!-- FIRST BOX -->\n' +
    '        <ng-form name="investments.paymentForm" novalidate>\n' +
    '          <!-- END FIRST ROW-->\n' +
    '\n' +
    '          <!-- START SECOND BOX-->\n' +
    '          <div class="receiver-section" style="padding: 10px">\n' +
    '            <div class="row">\n' +
    '              <!-- START From Account - Custom Dropdown -->\n' +
    '              <div class="col-md-6">\n' +
    '                <label class="domp-form-label" translate="invest.accountFrom"></label>\n' +
    '                <div class="accounts-dropdown">\n' +
    '                  <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                       data-ng-click="investments.showAccountToDropdown = !investments.showAccountToDropdown" ng-style="investments.tempInvestObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + investments.tempInvestObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font">\n' +
    '                      {{investments.tempInvestObj.fromAccountSelect.friendlyName}}\n' +
    '                                    <span class="favorite-star-container">\n' +
    '                                      <i class="zmdi"\n' +
    '                                         ng-class="{\'zmdi-star favorite-account\':account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                                    </span>\n' +
    '                    </h4>\n' +
    '                    <p class="no-bottom-margin">{{investments.tempInvestObj.fromAccountSelect.iban}}</p>\n' +
    '                    <p class="m-b-0 bold-font domp-available-balance">\n' +
    '                      {{investments.tempInvestObj.fromAccountSelect.availableBalance | number:2}}\n' +
    '                      {{investments.tempInvestObj.fromAccountSelect.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-b-9" translate="currencyConversion.availableBalance"></span>\n' +
    '    <span class="caret-icon">\n' +
    '                                    <i class="zmdi zmdi-caret-down zmdi-hc-2x"></i>\n' +
    '                                  </span>\n' +
    '                  </div>\n' +
    '                  <div class="from-accounts-list" ng-show="investments.showAccountToDropdown" scrollable>\n' +
    '                    <div class="accounts-list-item" data-ng-repeat="item in investments.accountsFrom"\n' +
    '                         data-ng-click="investments.setAccountFrom(item); investments.showAccountToDropdown = !investments.showAccountToDropdown">\n' +
    '                      <span class="d-block f-16 bold-font">{{item.friendlyName}}</span>\n' +
    '                      <span class="d-block">{{item.iban}}</span>\n' +
    '                      <span\n' +
    '                        class="d-block bold-font">{{item.availableBalance | number: 2}} {{item.currencySymbol}}</span>\n' +
    '                      <span class="d-block" translate="currencyConversion.availableBalance"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END From Account - CUSTOM DROPDOWN-->\n' +
    '              <!-- START Amount and Date -->\n' +
    '              <div class="col-md-6">\n' +
    '                <!--<div class="row">-->\n' +
    '                <!-- START Amount -->\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="amountInput" translate="invest.amountInputLabel">Amount:</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                           autocomplete="off" placeholder="{{\'invest.amountPlaceholder\'| translate}}"\n' +
    '                           data-input-mask="\'core.moneyFormat.mask\'"\n' +
    '                           data-input-mask-options="{reverse: true,optional: true}"\n' +
    '                           mask-val=\'investments.tempInvestObj.amountInput\'\n' +
    '                           ng-model="investments.tempInvestObj.amountInput"\n' +
    '                           required\n' +
    '                           ng-class="{\'domp-error\': investments.paymentForm.amountInput.$invalid && investments.tempInvestObj.formSubmitted}"\n' +
    '                           maxlength="11">\n' +
    '        <span class="input-group-btn">\n' +
    '                                      <button type="button"\n' +
    '                                              class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">\n' +
    '                                        {{investments.tempInvestObj.fromAccountSelect.currencySymbol}}\n' +
    '                                      </button>\n' +
    '                                    </span>\n' +
    '                  </div>\n' +
    '      <span class="c-red"\n' +
    '            ng-show="investments.paymentForm.amountInput.$error.required && investments.tempInvestObj.formSubmitted"\n' +
    '            translate="internalTransfer.amountInputError">\n' +
    '                                </span>\n' +
    '                  <!--</div>-->\n' +
    '                </div>\n' +
    '                <!-- End Amount-->\n' +
    '                <!-- START Date-->\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="dateInput" translate="invest.date">Date</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input type="text" class="form-control input-field" name="dateInput" id="dateInput"\n' +
    '                           uib-datepicker-popup="shortDate" show-weeks="false"\n' +
    '                           ng-model="investments.tempInvestObj.dueDateInput" show-weeks="false"\n' +
    '                           is-open="investments.datePickerOpened" datepicker-options="investments.dateOptions"\n' +
    '                           readonly>\n' +
    '        <span class="input-group-btn">\n' +
    '                                      <button data-ng-click="investments.openDatePicker()" type="button"\n' +
    '                                              class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '                                        <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                                      </button>\n' +
    '                                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Date-->\n' +
    '\n' +
    '\n' +
    '              <!-- END Amount and Date -->\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="receiver-section" style="padding: 10px">\n' +
    '            <div class="row">\n' +
    '              <div class="col-lg-6 col-md-6 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" for="toAccountInput" translate="invest.accountTo">\n' +
    '                    Account number\n' +
    '                  </label>\n' +
    '                  <input type="text" class="form-control input-field" capitalize\n' +
    '                         ng-pattern-restrict="{{investments.regexPatterns.allLettersNumbersSpaces}}"\n' +
    '                         ui-options="investments.uiMaskOptions"\n' +
    '                         ng-model="investments.tempInvestObj.toAccountInput"\n' +
    '                         ng-class="{\'domp-error\': investments.paymentForm.toAccountInput.$invalid && investments.tempInvestObj.formSubmitted}"\n' +
    '                         name="toAccountInput" id="toAccountInput" required maxlength="39" ng-trim="false">\n' +
    '          <span class="c-red"\n' +
    '                ng-show="investments.paymentForm.toAccountInput.$error.required && investments.tempInvestObj.formSubmitted"\n' +
    '                translate="domesticPayment.receiverAccountError"></span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-lg-6 col-md-6 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="invest.fundName"></label>\n' +
    '                  <select class="form-control input-field" data-ng-model="investments.tempInvestObj.fundSelect"\n' +
    '                          ng-options="item.fundName for item in investments.fundList"\n' +
    '                  ng-change="investments.fundChange();">\n' +
    '                  </select>\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-offset-6 col-sm-offset-6 col-lg-6 col-md-6 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="invest.accountType">Account\n' +
    '                    type</label>\n' +
    '                  <select class="form-control input-field p-l-15 p-r-10"\n' +
    '                          ng-model="investments.tempInvestObj.accountType"\n' +
    '                          ng-options="item.key| translate for item in investments.accountTypes">\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-12 form-group">\n' +
    '                <div class="no-padding-on-phone">\n' +
    '                  <label class="domp-form-label domp-purpose-label"\n' +
    '                         translate="invest.comment">Comment</label>\n' +
    '                  <div class="p-0">\n' +
    '                    <input type="text" class="form-control input-field"\n' +
    '                           data-ng-model="investments.tempInvestObj.comment"\n' +
    '                           name="comment"\n' +
    '                           ng-class="{\'domp-error\': investments.paymentForm.paymentPurposeInput.$invalid && investments.tempInvestObj.formSubmitted}">\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </ng-form>\n' +
    '        <!-- END NEW SECOND BOX -->\n' +
    '\n' +
    '        <div class="intp-form-container">\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-12 col-lg-12 col-md-12 p-l-0">\n' +
    '              <div class="col-xs-12">\n' +
    '                <label class="checkbox checkbox-inline-inline checkbox-value">\n' +
    '                  {{\'invest.belowComment\' | translate}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-md-12 text-right">\n' +
    '            <button type="button" class="btn btn-default "\n' +
    '                    translate="domesticPayment.confirmBtn"\n' +
    '                    ng-disabled="investments.submitButtonDisabled"\n' +
    '                    data-ng-click="investments.submitInvestment($event);">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '  </span>\n' +
    '\n' +
    '\n' +
    '    <!-- START STEP NUMBER 2 -->\n' +
    '    <!--<div ng-if="investments.steps.step2">-->\n' +
    '    <!--<div data-ng-include="\'payments/international-payment-resume.tpl.html\'"></div>-->\n' +
    '    <!--</div>-->\n' +
    '    <!--&lt;!&ndash; END STEP NUMBER 2&ndash;&gt;-->\n' +
    '    <!--&lt;!&ndash; START STEP NUMBER 3 &ndash;&gt;-->\n' +
    '    <!--<div ng-if="investments.steps.step3">-->\n' +
    '    <!--<payment-final-step payment="investments.paymentResponse" is-modal="false"></payment-final-step>-->\n' +
    '    <!--</div>-->\n' +
    '    <!-- END STEP NUMBER 3 -->\n' +
    '\n' +
    '  <!--</div>-->\n' +
    '<!--</section>-->\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investments-overview.tpl.html',
    '<section id="main" ng-if="investmentsOverview.selectedFund">\n' +
    '  <div class="container-fluid">\n' +
    '\n' +
    '    <!-- Account informations -->\n' +
    '    <div class="account-header-container clearfix">\n' +
    '\n' +
    '      <!-- Carousel navigation start -->\n' +
    '      <div class="row" data-ng-show="investmentsOverview.fundList.length > 1">\n' +
    '        <ol class="custom-carousel-indicators pull-right">\n' +
    '          <li data-ng-repeat="fund in investmentsOverview.fundList"\n' +
    '              data-ng-class="{\'active\': investmentsOverview.currentIndex === fund.index}"\n' +
    '              data-ng-click="investmentsOverview.chooseFromCarousel(fund.id);">\n' +
    '          </li>\n' +
    '        </ol>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="pull-right icon-container m-r-15" ng-if="investmentsOverview.isNextButtonVisible"\n' +
    '           data-ng-click="investmentsOverview.goToNextItem()">\n' +
    '        <a class="account-navigation-icons">\n' +
    '          <i class="zmdi zmdi-chevron-right zmdi-hc-4x"></i>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="pull-left icon-container m-l-15" ng-if="investmentsOverview.isPreviousButtonVisible"\n' +
    '           data-ng-click="investmentsOverview.goToPreviousItem()">\n' +
    '        <a class="account-navigation-icons">\n' +
    '          <i class="zmdi zmdi-chevron-left zmdi-hc-4x"></i>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '      <!-- Carousel navigation end -->\n' +
    '\n' +
    '      <!--<div class="row">-->\n' +
    '      <div class="col-xs-8 account-header-inner m-l-25">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-12 no-padding">\n' +
    '            <h2 class="account-name m-l-15">\n' +
    '              {{investmentsOverview.selectedFund.fundName}}\n' +
    '            </h2>\n' +
    '            <h4 class="m-15 c-white">{{investmentsOverview.selectedFund.shareAccount}}</h4>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6 white-text-block" ng-if="investmentsOverview.selectedFund.totalShareValue != undefined">\n' +
    '            <div class="f-24">{{investmentsOverview.selectedFund.totalShareValue| number:2}}\n' +
    '              {{investmentsOverview.selectedFund.currency}}\n' +
    '            </div>\n' +
    '            <hr class="account-header-line"/>\n' +
    '            <div class="f-16" translate="investOverview.totalShareValue"></div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6 white-text-block" ng-if="investmentsOverview.selectedFund.shareQuantity != undefined">\n' +
    '            <div class="f-24">{{investmentsOverview.selectedFund.shareQuantity| number:4}}\n' +
    '            </div>\n' +
    '            <hr class="account-header-line"/>\n' +
    '            <div class="f-16" translate="investOverview.shareQuantity"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <div ng-if="investmentsOverview.investmentDetailsOpen" class="row p-t-20 p-b-20">\n' +
    '          <div class="col-sm-6 white-text-block m-b-10">\n' +
    '            <h4 class="c-white">{{investmentsOverview.selectedFund.isin}}</h4>\n' +
    '            <div class="f-16">ISIN</div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6 white-text-block m-b-10">\n' +
    '            <h4 class="f-20 c-white">{{investmentsOverview.selectedFund.validationDate| date: "shortDate" }}</h4>\n' +
    '            <div class="f-16" translate="invest.date">Date</div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6 white-text-block m-b-10" ng-if="investmentsOverview.selectedFund.fundType">\n' +
    '            <h4 class="f-20 c-white">{{investmentsOverview.selectedFund.fundType}}</h4>\n' +
    '            <div class="f-16" translate="investOverview.fundType"></div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6 white-text-block m-b-10" ng-if="investmentsOverview.selectedFund.accountType">\n' +
    '            <h4 class="f-20 c-white">{{investmentsOverview.selectedFund.accountType}}</h4>\n' +
    '            <div class="f-16" translate="invest.accountType"></div>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6 white-text-block m-b-10" ng-if="investmentsOverview.selectedFund.sharePrice">\n' +
    '            <h4 class="f-20 c-white">{{investmentsOverview.selectedFund.sharePrice| number:2}} {{investmentsOverview.selectedFund.currency}}</h4>\n' +
    '            <div class="f-16" translate="investOverview.sharePrice"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '      </div>\n' +
    '      <!--</div>-->\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="row m-b-10">\n' +
    '      <div class="col-md-12 text-center">\n' +
    '        <div style="background-color: white; color: red" ng-if="!investmentsOverview.investmentDetailsOpen"\n' +
    '             data-ng-click="investmentsOverview.investmentDetailsOpen = !investmentsOverview.investmentDetailsOpen;investmentsOverview.toggleGtmDetailsOpenEvent(investmentsOverview.investmentDetailsOpen);"\n' +
    '             translate="accounts.accAccountAndCardsMoreDetails">\n' +
    '        </div>\n' +
    '        <div  style="background-color: white; color: red" ng-if="investmentsOverview.investmentDetailsOpen"\n' +
    '             data-ng-click="investmentsOverview.investmentDetailsOpen = !investmentsOverview.investmentDetailsOpen;investmentsOverview.toggleGtmDetailsOpenEvent(investmentsOverview.investmentDetailsOpen);"\n' +
    '              translate="accounts.accAccountAndCardsLessDetails">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- Investments button section -->\n' +
    '    <div class="row">\n' +
    '      <div class="p-10 clearfix">\n' +
    '        <div class="col-xs-12 col-sm-4 m-b-20">\n' +
    '          <a data-ui-sref="investments.form.new({orderType: \'new\', fundId: investmentsOverview.selectedFund.id})">\n' +
    '              <div class="round-btn-container" ng-click="investmentsOverview.pushGTMevent(\'BuyStocks\');">\n' +
    '              <div class="round-btn"><i class="icon icon-stockbuy" style="font-size:2em"></i></div>\n' +
    '              <div class="round-btn-label inv-btn-height" translate="investOverview.buyStocks"></div>\n' +
    '            </div>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-sm-4 m-b-20" ng-if="investmentsOverview.selectedFund.accountType === \'Investitor\'">\n' +
    '          <a href="" data-ui-sref="investments.form.new({orderType: \'sell\', fundId: investmentsOverview.selectedFund.id})">\n' +
    '              <div class="round-btn-container" ng-click="investmentsOverview.pushGTMevent(\'SellStocks\');">\n' +
    '              <div class="round-btn"><i class="icon icon-stocksell" style="font-size:2em"></i></div>\n' +
    '              <div class="round-btn-label inv-btn-height" translate="investOverview.sellStocks"></div>\n' +
    '            </div>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-sm-4 m-b-20" ng-if="investmentsOverview.selectedFund.accountType === \'Investitor\'">\n' +
    '          <a href="" data-ui-sref="investments.form.new({orderType: \'replace\', fundId: investmentsOverview.selectedFund.id})">\n' +
    '              <div class="round-btn-container" ng-click="investmentsOverview.pushGTMevent(\'ReplaceStocks\');">\n' +
    '              <div class="round-btn"><i class="icon icon-stock-change" style="font-size:2em"></i></div>\n' +
    '              <div class="round-btn-label inv-btn-height" translate="investOverview.replaceStocks">\n' +
    '                Replacement funds\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- TAB section -->\n' +
    '    <div class="msg-tab-container">\n' +
    '      <div class="msg-tab" ng-class="{\'selected\':investmentsOverview.selectedTab === 1}"\n' +
    '           ng-click="investmentsOverview.selectTab(1, \'investOverview.transactions\')"\n' +
    '           translate="investOverview.transactions">\n' +
    '      </div>\n' +
    '      <div class="msg-tab" style="border-right:none;" ng-class="{\'selected\':investmentsOverview.selectedTab === 2}"\n' +
    '           ng-click="investmentsOverview.selectTab(2, \'investOverview.orders\');"\n' +
    '           translate="investOverview.orders">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Filter container  -->\n' +
    '    <!-- TODO: fiters not implemented on API -->\n' +
    '    <div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ============================= -->\n' +
    '    <!-- START: TRANSACTIONS TIMELINE -->\n' +
    '    <!-- ============================= -->\n' +
    '    <!-- TODO: map with transactions from API-->\n' +
    '    <div ng-show="investmentsOverview.selectedTab == 1">\n' +
    '      <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">\n' +
    '        <ul class="hypo-timeline" kcd-recompile="investmentsOverview.investmentTransactionListGrouped">\n' +
    '\n' +
    '          <div class="t-a-c p-10 no-data-image" ng-if="investmentsOverview.investmentTransactionListGrouped.result.length == 0">\n' +
    '            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '            <h3 class="no-data-label" translate="investOverview.noTransactionData"></h3>\n' +
    '          </div>\n' +
    '          <li ng-class="{\'time-label\': transaction.isVirtual}" ng-repeat="transaction in investmentsOverview.investmentTransactionListGrouped.result">\n' +
    '            <span class="currency-time-frame" ng-if="transaction.isVirtual == true">{{transaction.date| date:\'shortDate\'}}</span>\n' +
    '            <i ng-if="transaction.isVirtual == undefined" data-ng-class="{\'zmdi zmdi-caret-up\': transaction.type == \'Credit\',\'zmdi zmdi-caret-down\': transaction.type == \'Debit\'}"></i>\n' +
    '            <!--<i class="zmdi zmdi-money" ng-if="!transaction.isVirtual"></i>-->\n' +
    '            <div ng-if="!transaction.isVirtual" class="hypo-timeline-item payment-item" ng-click="transaction.selected = !transaction.selected;" ng-class="{\'opened\': transaction.selected}">\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-xs-6 col-sm-8 p-l-0 p-r-0">\n' +
    '                  <h4 class="m-b-0 m-t-0 c-gray no-wrap-text"><b>{{::transaction.fundName}}</b></h4>\n' +
    '                  <!--<p class="m-b-0 m-t-0 no-wrap-text">{{::transaction.detail.purpose}}</p>-->\n' +
    '                </div>\n' +
    '                <div class="col-xs-6 col-sm-4 p-l-0 p-r-0">\n' +
    '                  <span class="pull-right t-a-r m-t-5 f-18"><b>\n' +
    '                      {{transaction.amount| number:2}} {{::transaction.currency}}</b>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div ng-if="transaction.selected" class="transaction-details">\n' +
    '                <div data-ng-include="\'investments/tl-investment-transactions-details.tpl.html\'"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '      <div class="show-more-btn">\n' +
    '        <button ng-show="investmentsOverview.investmentTransactionListGrouped.hasMore" data-ng-click="investmentsOverview.loadMoreInvestmentTransaction()"\n' +
    '                class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ============================= -->\n' +
    '    <!-- END: TRANSACTIONS TIMELINE    -->\n' +
    '    <!-- ============================= -->\n' +
    '\n' +
    '    <!-- ========================= -->\n' +
    '    <!-- START: ORDERS TIMELINE       -->\n' +
    '    <!-- ========================= -->\n' +
    '    <div ng-show="investmentsOverview.selectedTab == 2">\n' +
    '      <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">\n' +
    '        <ul class="hypo-timeline" kcd-recompile="investmentsOverview.investmentOrderListGrouped">\n' +
    '\n' +
    '          <div class="t-a-c p-10 no-data-image" ng-if="investmentsOverview.investmentOrderListGrouped.result.length == 0">\n' +
    '            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '            <h3 class="no-data-label" translate="dashboard.noOrderData"></h3>\n' +
    '          </div>\n' +
    '\n' +
    '          <li ng-class="{\'time-label\': order.isVirtual}" ng-repeat="order in investmentsOverview.investmentOrderListGrouped.result">\n' +
    '            <span class="currency-time-frame" ng-if="order.isVirtual === true">{{order.date| date: \'shortDate\'}}</span>\n' +
    '            <i class="zmdi zmdi-money" ng-if="!order.isVirtual"></i>\n' +
    '            <div ng-if="!order.isVirtual" class="hypo-timeline-item payment-item"  ng-class="{\'opened\': order.selected}">\n' +
    '              <div class="hypo-timeline-body" ng-click="order.selected = !order.selected;">\n' +
    '                <div class="col-xs-4">\n' +
    '                  <div ng-switch="order.amountType">\n' +
    '                    <h4 class="m-b-0 m-t-0 c-gray" ng-switch-when="2">\n' +
    '                      <b>{{order.invAmount|number:2}} {{::order.amountCurCode}}</b>\n' +
    '                    </h4>\n' +
    '                    <h4 class="m-b-0 m-t-0 c-gray" ng-switch-when="1">\n' +
    '                      <b>{{order.invAmount|number:2}} {{::order.sellingCurSym}}</b>\n' +
    '                    </h4>\n' +
    '                    <h4 class="m-b-0 m-t-0 c-gray" ng-switch-when="3">\n' +
    '                      <b>{{order.invAmount|number:2}}</b>\n' +
    '                    </h4>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{::order.accountNumberBuy}}</p>\n' +
    '\n' +
    '                  <h4 ng-switch="order.orderStatus">\n' +
    '                    <span ng-switch-when="0" translate="investOverview.status_created">Created</span>\n' +
    '                    <span ng-switch-when="2" translate="investOverview.status_recalled">Recalled</span>\n' +
    '                    <span ng-switch-when="3" translate="investOverview.status_processed">Processed</span>\n' +
    '                    <span ng-switch-when="4" translate="investOverview.status_rejected">Rejected</span>\n' +
    '                    <span ng-switch-when="5" translate="investOverview.status_closed">Closed</span>\n' +
    '                    <span ng-switch-when="6" translate="investOverview.status_signed">Signed</span>\n' +
    '                    <span ng-switch-when="7" translate="investOverview.status_inProcess">In Process</span>\n' +
    '                    <span ng-switch-when="8" translate="investOverview.status_canceled">Canceled</span>\n' +
    '                  </h4>\n' +
    '                </div>\n' +
    '                <div class="col-xs-4" ng-switch="order.orderType">\n' +
    '                  <h4 class="m-b-0 m-t-0 c-gray"  ng-switch-when="1" translate="investOverview.buyStocks"></h4>\n' +
    '                  <h4  class="m-b-0 m-t-0 c-gray" ng-switch-when="2" translate="investOverview.sellStocks"></h4>\n' +
    '                  <h4 class="m-b-0 m-t-0 c-gray" ng-switch-when="3" translate="investOverview.replaceStocks"></h4>\n' +
    '                </div>\n' +
    '                <div class="col-xs-4"><span class="pull-right t-a-r m-t-10"><b>{{::order.validationDate| date:\'shortDate\'}}</b></span></div>\n' +
    '              </div>\n' +
    '              <div ng-if="order.selected" class="transaction-details">\n' +
    '                <div data-ng-include="\'investments/tl-investment-order-details.tpl.html\'"></div>\n' +
    '                <div class="pull-right" ng-if="order.orderStatus == 0">\n' +
    '                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="investOverview.copyOrder" ng-click="investmentsOverview.copyOrder(investmentsOverview.selectedFund.id, order)">Copy order</button>\n' +
    '                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="investOverview.editOrder" ng-click="investmentsOverview.editOrder(investmentsOverview.selectedFund.id, order)">Edit order</button>\n' +
    '                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="investOverview.deleteOrder" ng-disabled="investmentsOverview.deleteButtonDisabled" ng-click="investmentsOverview.deleteInvestment(order.orderId)">Delete order</button>\n' +
    '                  <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10" translate="investOverview.signOrder" ng-click="investmentsOverview.signOrder(order)">Sign order</button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '      <div class="show-more-btn">\n' +
    '        <button ng-show="investmentsOverview.investmentOrderListGrouped.hasMore" data-ng-click="investmentsOverview.loadMoreInvestmentOrders()"\n' +
    '                class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ========================= -->\n' +
    '    <!-- END: ORDERS TIMELINE      -->\n' +
    '    <!-- ========================= -->\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investments-list.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="m-b-30">\n' +
    '      <!-- START Title -->\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <h2>\n' +
    '            <h2 class="f-28" translate="investmentsList.invOverview"></h2>\n' +
    '          </h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Title -->\n' +
    '      <!-- START Investments View-->\n' +
    '      <div class="row m-b-15">\n' +
    '        <div class="col-md-6 col-sm-6 m-b-15" data-ng-repeat="fundItem in investmentsList.fundsList">\n' +
    '          <div class="account-item-widget app-red-card cursor-pointer" style="height: 180px;" data-ui-sref="investments.overview({fundId: fundItem.id})">\n' +
    '            <h4 class="acc-name c-white m-t-0 m-b-0">\n' +
    '              <b class="col-xs-10 p-0  no-wrap-text ng-binding">{{::fundItem.fundName}}</b>\n' +
    '            </h4>\n' +
    '            <span class="c-white f-14 no-wrap-text">{{::fundItem.isin}}</span>\n' +
    '            <br/>\n' +
    '            <span class="c-white f-14 no-wrap-text">{{::fundItem.shareAccount}}</span>\n' +
    '            <div ng-if="fundItem.shareQuantity">\n' +
    '              <amount-formatter amount="{{fundItem.shareQuantity|number:2}}"\n' +
    '                                custom-classes="c-white" currency="{{fundItem.currency}}" from-type="dashboard" aditional-val=""\n' +
    '                                has-underline="true">\n' +
    '              </amount-formatter>\n' +
    '              <p class="c-white f-14 m-t-5 m-b-0" translate="investOverview.shareQuantity"></p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--END Investments View -->\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investment-sign.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <h1 translate="invest.signInvestment"></h1>\n' +
    '    <div class="m-b-30">\n' +
    '      <div class="receiver-section" style="padding: 15px">\n' +
    '        <div class="domp-to-section m-t-10 m-b-10">\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-6 col-xs-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" ng-if="investmentSign.investment.accountNumberBuy" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '                <label class="d-block domp-form-label-resume">{{investmentSign.investment.accountNumberBuy}}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 col-xs-6">\n' +
    '              <div class="row">\n' +
    '                <div class="col-sm-6" ng-if="investmentSign.investment.invAmount && investmentSign.investment.amountType == 2">\n' +
    '                  <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel">Amount</label>\n' +
    '                  <label class="d-block domp-form-label-resume">\n' +
    '                    {{investmentSign.investment.invAmount|number:2}}\n' +
    '                    {{investmentSign.investment.amountCurCode|| investment.responseModel.sellingCurSym}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '                <div class="col-sm-6" ng-if="investmentSign.investment.invAmount && investmentSign.investment.amountType == 3">\n' +
    '                  <label class="domp-form-label-review" translate="invest.quantityInputLabel">Quantity</label>\n' +
    '                  <label class="d-block domp-form-label-resume">\n' +
    '                    {{investmentSign.investment.invAmount | number: 4}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-sm-6">\n' +
    '                  <!--<label class="exchange-resume-label" translate="domesticPayment.dateInputLabel">When</label>-->\n' +
    '                  <label ng-show="investmentSign.orderTypeText != \'new\'" class="domp-form-label-review" for="dateInput" translate="invest.dueDate">Date</label>\n' +
    '                  <label ng-show="investmentSign.orderTypeText == \'new\'" class="domp-form-label-review" for="dateInput" translate="invest.dateNewOrder">Date</label>\n' +
    '                  <label class="d-block domp-form-label-resume">\n' +
    '                    {{investmentSign.investment.invAmountDate| date:\'shortDate\'}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row">\n' +
    '                <div class="col-sm-6">\n' +
    '                  <label class="domp-form-label-review" translate="invest.buyingFond"></label>\n' +
    '                  <label class="d-block domp-form-label-resume">{{investmentSign.investment.fundName}}</label>\n' +
    '                </div>\n' +
    '                <div class="col-sm-6 domp-form-label-review" ng-show="investmentSign.investment.accountType">\n' +
    '                  <label class="domp-form-label-review" translate="invest.accountType"></label>\n' +
    '                  <label class="d-block domp-form-label-resume">no info</label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="domp-to-section m-b-10">\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-6 col-xs-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" translate="invest.note"></label>\n' +
    '                <label class="d-block domp-form-label-resume">{{investmentSign.investment.note}}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- END Buttons -->\n' +
    '        <div class="row m-b-10">\n' +
    '          <div class="col-xs-12 m-t-30">\n' +
    '            <form name="investmentSign.challengeForm" novalidate>\n' +
    '              <div class="col-xs-12 m-b-20">\n' +
    '                <span class="f-w-bold">\n' +
    '                  {{\'signPayments.challengeDescription\'| translate}}\n' +
    '                </span>\n' +
    '              </div>\n' +
    '              <div class="col-sm-4 col-xs-6">\n' +
    '                <div class="f-w-bold wrap-text">{{\'signPayments.challengeFirstCode\'| translate}}</div>\n' +
    '                <input type="text" class="form-control input-field" disabled\n' +
    '                       data-ng-model="investmentSign.investment.challenge">\n' +
    '              </div>\n' +
    '              <div class="col-sm-4 col-xs-6">\n' +
    '                <div class="f-w-bold wrap-text">{{\'signPayments.challengeSecondCode\'| translate}}</div>\n' +
    '                <div class="input-group">\n' +
    '                  <input type="{{investmentSign.showTokenInput ? \'text\' : \'password\'}}" class="form-control input-field"\n' +
    '                         data-ng-model="investmentSign.model.password2"\n' +
    '                         ng-pattern-restrict="{{investmentSign.regexPatterns.onlyNumbers}}"\n' +
    '                         placeholder="{{\'signPayments.challengeSecondCode\'| translate}}">\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <button class="btn btn-default input-group-app-btn domp-btn-height" data-ng-click="investmentSign.showTokenInput = !investmentSign.showTokenInput" style="border:1px solid #062a42;">\n' +
    '                      <i class="zmdi zmdi-lock"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '              <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '                <button class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                        ng-disabled="investmentSign.confirmSignedButtonDisabled"\n' +
    '                        data-ng-click="investmentSign.confirmSignedInvestment()"\n' +
    '                        translate="signPayments.confirm">\n' +
    '                </button>\n' +
    '              </div>\n' +
    '            </form>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investment-resume.tpl.html',
    '<div class="receiver-section" style="padding: 15px">\n' +
    '  <div class="domp-to-section m-t-10 m-b-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" ng-if="investment.responseModel.accountIBAN"\n' +
    '                 translate="{{investment.model.orderType == 2 ? \'invest.accountTo\':\'invest.accountFrom\'}}"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{investment.responseModel.accountIBAN}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6" ng-if="investment.responseModel.invAmount && investment.model.amountType == 2">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel">Amount</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              {{investment.responseModel.invAmount|number:2}}\n' +
    '              {{investment.responseModel.amountCurCode|| investment.responseModel.sellingCurSym}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6" ng-if="investment.responseModel.invAmount && investment.model.amountType == 3">\n' +
    '            <label class="domp-form-label-review" translate="investOverview.shareQuantity">Quantity</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              {{investment.responseModel.invAmount|number:4}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-sm-6">\n' +
    '            <!--<label class="exchange-resume-label" translate="domesticPayment.dateInputLabel">When</label>-->\n' +
    '            <label ng-show="investment.orderTypeText != \'new\'" class="domp-form-label-review" for="dateInput" translate="invest.dueDate">Date</label>\n' +
    '            <label ng-show="investment.orderTypeText == \'new\'" class="domp-form-label-review" for="dateInput" translate="invest.dateNewOrder">Date</label>\n' +
    '            <label class="d-block domp-form-label-resume">\n' +
    '              {{investment.responseModel.invAmountDate| date:\'shortDate\'}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <span ng-switch="investment.responseModel.orderType">\n' +
    '              <label ng-switch-when="1" class="domp-form-label-review" translate="invest.buyingFond"></label>\n' +
    '              <label ng-switch-when="2" class="domp-form-label-review" translate="invest.sellingFond"></label>\n' +
    '              <label ng-switch-when="3" class="domp-form-label-review" translate="invest.replacementFond"></label>\n' +
    '            </span>\n' +
    '            <label class="d-block domp-form-label-resume">{{investment.responseModel.fundName}}</label>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6 domp-form-label-review" ng-show="investment.responseModel.accountType">\n' +
    '            <label class="domp-form-label-review" translate="invest.accountType"></label>\n' +
    '            <label class="d-block domp-form-label-resume">no info</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="domp-to-section m-b-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="invest.note"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{investment.responseModel.note}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- START Buttons -->\n' +
    '  <div class="row" ng-if="!investment.investmentSigned">\n' +
    '    <div class="col-md-10 p-b-10">\n' +
    '      <button class="btn btn-primary " translate="invest.back"\n' +
    '              data-ui-sref="investments.form.new({orderType: investment.orderTypeText, fundId: investment.fundId})"  ui-sref-opts="{reload:true}">\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary" translate="payments.edit"\n' +
    '              data-ui-sref="investments.form.new({orderType: investment.orderTypeText, fundId: investment.fundId})">\n' +
    '      </button>\n' +
    '      <button class="btn btn-primary-warning " translate="payments.delete"\n' +
    '              ng-disabled="investment.deleteButtonDisabled"\n' +
    '              data-ng-click="investment.delete();">\n' +
    '      </button>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-2 p-b-10">\n' +
    '        <button class="btn btn-default"\n' +
    '                translate="currencyConversion.sign"\n' +
    '                ng-disabled="investment.signButtonDisabled"\n' +
    '                ng-click="investment.investmentSigned = true">\n' +
    '        </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- END Buttons -->\n' +
    '  <div class="row m-b-10" ng-if="investment.investmentSigned">\n' +
    '    <div class="col-xs-12 m-t-30">\n' +
    '      <form name="investment.challengeForm" novalidate>\n' +
    '        <div class="col-xs-12 m-b-20">\n' +
    '          <span class="f-w-bold">\n' +
    '            {{\'signPayments.challengeDescription\'| translate}}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-6">\n' +
    '          <div class="f-w-bold wrap-text">{{\'signPayments.challengeFirstCode\'| translate}}</div>\n' +
    '          <input type="text" class="form-control input-field" disabled\n' +
    '                 data-ng-model="investment.responseModel.challenge">\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-6">\n' +
    '          <div class="f-w-bold wrap-text">{{\'signPayments.challengeSecondCode\'| translate}}</div>\n' +
    '          <div class="input-group">\n' +
    '            <input type="{{investment.showTokenInput ? \'text\' : \'password\'}}" class="form-control input-field"\n' +
    '                   data-ng-model="investment.model.password2"\n' +
    '                   ng-pattern-restrict="{{investment.regexPatterns.onlyNumbers}}"\n' +
    '                   placeholder="{{\'signPayments.challengeSecondCode\'| translate}}">\n' +
    '            <span class="input-group-btn">\n' +
    '              <button class="btn btn-default input-group-app-btn domp-btn-height" data-ng-click="investment.showTokenInput = !investment.showTokenInput" style="border:1px solid #062a42;">\n' +
    '                <i class="zmdi zmdi-lock"></i>\n' +
    '              </button>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="col-sm-4 col-xs-12 m-t-20">\n' +
    '          <button class="btn btn-default col-sm-8 col-xs-4 pull-right"\n' +
    '                  ng-disabled="investment.confirmSignedButtonDisabled"\n' +
    '                  data-ng-click="investment.confirmSignedInvestment()"\n' +
    '                  translate="signPayments.confirm">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investment-form.tpl.html',
    '<div class="receiver-section" style="padding: 15px">\n' +
    '  <ng-form name="investment.fundsForm">\n' +
    '    <div class="row form-group">\n' +
    '      <!-- START From Account - Custom Dropdown -->\n' +
    '      <div class="col-md-6">\n' +
    '        <label class="domp-form-label" translate="{{investment.model.orderType == 2 ? \'invest.accountTo\':\'invest.accountFrom\'}}"></label>\n' +
    '        <div class="accounts-dropdown">\n' +
    '          <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '               data-ng-click="investment.showAccountToDropdown = !investment.showAccountToDropdown"  ng-style="investment.model.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + investment.model.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '              <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                {{investment.model.fromAccountSelect.friendlyName}}</b>\n' +
    '              <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                <i class="zmdi"\n' +
    '                   ng-class="{\'zmdi-star favorite-account\':account.isFavorite, \'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '              </span>\n' +
    '            </h4>\n' +
    '            <p class="m-b-0 m-t-0 iban-style">{{investment.model.fromAccountSelect.iban}}</p>\n' +
    '            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '              {{investment.model.fromAccountSelect.availableBalance| number:2}}\n' +
    '              {{investment.model.fromAccountSelect.currencySymbol}}\n' +
    '            </p>\n' +
    '            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '            <span class="caret-icon">\n' +
    '              <i class="zmdi zmdi-caret-down zmdi-hc-2x"></i>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '          <div class="from-accounts-list " ng-show="investment.showAccountToDropdown" scrollable>\n' +
    '            <div class="accounts-list-item p-0" data-ng-repeat="item in investment.accountsFromList"\n' +
    '                 data-ng-click="investment.setAccountFrom(item); investment.showAccountToDropdown = !investment.showAccountToDropdown">\n' +
    '              <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                  <span class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</span>\n' +
    '                  <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite, \'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                </h4>\n' +
    '                <span class="m-b-0 m-t-0 iban-style">{{item.iban}}</span>\n' +
    '                <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">{{item.availableBalance| number: 2}} {{item.currencySymbol}}</p>\n' +
    '                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END From Account - CUSTOM DROPDOWN-->\n' +
    '      <!-- START Amount and Date -->\n' +
    '      <div class="col-md-6">\n' +
    '        <!-- START: SELL FUNDS -->\n' +
    '        <div class="clearfix" ng-if="investment.model.orderType != 1">\n' +
    '          <!-- Label -->\n' +
    '          <div style="margin-top: 29px">\n' +
    '            <!-- Type -->\n' +
    '            <div class="form-group col-md-6" style="padding: 2px">\n' +
    '              <select  class="form-control input-field"\n' +
    '                       data-ng-model="investment.model.amountType"\n' +
    '                       ng-options="amountType.id as amountType.name |  translate for amountType in investment.amountTypes"\n' +
    '                       ng-change="investment.onAmountTypeChange(investment.model.amountType)">\n' +
    '              </select>\n' +
    '            </div>\n' +
    '            <!-- Label -->\n' +
    '            <div class="col-md-6" style="padding: 2px">\n' +
    '              <div>\n' +
    '                <div class="input-group" ng-if="investment.model.amountType == 2">\n' +
    '                  <input type="text"  class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                         autocomplete="off" placeholder="{{\'invest.amountPlaceholder\'| translate}}"\n' +
    '                         amount-input-mask\n' +
    '                         ng-model="investment.model.amountInput"\n' +
    '                         required\n' +
    '                         ng-class="{\'domp-error\': investment.fundsForm.amountInput.$invalid && investment.formSubmitted}"\n' +
    '                         maxlength="12">\n' +
    '                  <span class="input-group-btn">\n' +
    '                    <button type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">\n' +
    '                      {{investment.model.fromAccountSelect.currencySymbol}}\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                </div>\n' +
    '                <div ng-if="investment.model.amountType == 3" >\n' +
    '                  <input\n' +
    '                    type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                    autocomplete="off"  placeholder="eg. 10"\n' +
    '                    amount-input-mask fraction="4"\n' +
    '                    ng-model="investment.model.invQuantity"\n' +
    '                    ng-class="{\'domp-error\': investment.fundsForm.amountInput.$invalid && investment.formSubmitted}"\n' +
    '                    maxlength="12"\n' +
    '                    required>\n' +
    '                </div>\n' +
    '\n' +
    '                <span class="c-red"\n' +
    '                      ng-show="investment.fundsForm.amountInput.$error.min && investment.formSubmitted || investment.fundsForm.amountInput.$error.required && investment.formSubmitted"\n' +
    '                      translate="invest.amountMinAmountError">\n' +
    '                </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END: SELL FUNDS -->\n' +
    '\n' +
    '        <!--<div class="row">-->\n' +
    '        <!-- START Amount -->\n' +
    '        <div class="form-group" ng-if="investment.model.orderType == 1">\n' +
    '          <label class="domp-form-label" for="amountInput" translate="invest.amountInputLabel">Amount:</label>\n' +
    '          <div class="input-group">\n' +
    '            <input id="amountInput" type="text" ng-if="investment.model.orderType == 1" class="form-control input-field t-a-r" name="amountInput"\n' +
    '                   autocomplete="off" placeholder="{{\'invest.amountPlaceholder\'| translate}}"\n' +
    '                   amount-input-mask\n' +
    '                   ng-model="investment.model.amountInput"\n' +
    '                   min="100"\n' +
    '                   required\n' +
    '                   ng-class="{\'domp-error\': investment.fundsForm.amountInput.$invalid && investment.formSubmitted}"\n' +
    '                   maxlength="12">\n' +
    '            <input type="text" ng-if="investment.model.orderType != 1" class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                   autocomplete="off" placeholder="{{\'invest.amountPlaceholder\'| translate}}"\n' +
    '                   amount-input-mask\n' +
    '                   ng-model="investment.model.amountInput"\n' +
    '                   required\n' +
    '                   ng-class="{\'domp-error\': investment.fundsForm.amountInput.$invalid && investment.formSubmitted}"\n' +
    '                   maxlength="12">\n' +
    '            <span class="input-group-btn">\n' +
    '              <button type="button"\n' +
    '                      class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">\n' +
    '                {{investment.model.fromAccountSelect.currencySymbol}}\n' +
    '              </button>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '          <span class="c-red"\n' +
    '                ng-show="investment.fundsForm.amountInput.$error.min && investment.formSubmitted || investment.fundsForm.amountInput.$error.required && investment.formSubmitted"\n' +
    '                translate="invest.amountMinAmountError">\n' +
    '          </span>\n' +
    '          <br>\n' +
    '          <span class="c-red"\n' +
    '                ng-show="investment.fundsForm.amountInput.$error.min && investment.formSubmitted"\n' +
    '                translate="invest.amountMinAmountError2">\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <!-- End Amount-->\n' +
    '        <!-- START Date-->\n' +
    '        <div class="form-group">\n' +
    '          <label ng-show="investment.orderTypeText != \'new\'" class="domp-form-label" for="dateInput" translate="invest.dueDate">Date</label>\n' +
    '          <label ng-show="investment.orderTypeText == \'new\'" class="domp-form-label" for="dateInput" translate="invest.dateNewOrder">Date</label>\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" name="dateInput" class="form-control input-field"\n' +
    '                   ng-model="investment.model.dueDateInput"\n' +
    '                   uib-datepicker-popup="shortDate"\n' +
    '                   datepicker-options="investment.dateOptions"\n' +
    '                   date-disabled="investment.dateDisabled(date, mode)"\n' +
    '                   is-open="investment.datePickerOpened"\n' +
    '                   readonly>\n' +
    '            <span class="input-group-btn">\n' +
    '              <button data-ng-click="investment.datePickerOpened = !investment.datePickerOpened"\n' +
    '                      class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '                <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '              </button>\n' +
    '            </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Date-->\n' +
    '      <!-- END Amount and Date -->\n' +
    '    </div>\n' +
    '    <hr>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" translate="invest.fundName"></label>\n' +
    '          <select class="form-control input-field"\n' +
    '                  data-ng-model="investment.model.fundSelect"\n' +
    '                  ng-options="item.fundName for item in investment.fundList"\n' +
    '                  ng-change="investment.onFundSelect(investment.model.fundSelect);"\n' +
    '                  ng-disabled="investment.fundId">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6" ng-if="investment.model.orderType !== 3">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" for="toAccountInput" translate="{{investment.model.orderType != 1 ? \'invest.accountFrom\':\'invest.accountTo\'}}">\n' +
    '            Account number\n' +
    '          </label>\n' +
    '          <input type="text" class="form-control input-field" capitalize\n' +
    '                 ng-pattern-restrict="{{investment.regexPatterns.allLettersNumbersSpaces}}"\n' +
    '                 ng-model="investment.model.toAccountInput"\n' +
    '                 ng-class="{\'domp-error\': investment.fundsForm.toAccountInput.$invalid && investment.formSubmitted}"\n' +
    '                 name="toAccountInput" id="toAccountInput" required maxlength="39" ng-trim="false"\n' +
    '                 readonly>\n' +
    '          <span class="c-red"\n' +
    '                ng-show="investment.fundsForm.toAccountInput.$error.required && investment.formSubmitted"\n' +
    '                translate="domesticPayment.receiverAccountError"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row" ng-if="investment.model.orderType == 3">\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" translate="invest.fundNameReplace"></label>\n' +
    '          <select class="form-control input-field"\n' +
    '                  data-ng-model="investment.model.fundSelectReplace"\n' +
    '                  data-ng-change="investment.fundSelectReplaceChange(investment.model.fundSelectReplace);"\n' +
    '                  ng-options="item.fundName for item in investment.fundReplacementList">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" for="fundSelectReplaceInput" translate="invest.accountTo">\n' +
    '            Account number\n' +
    '          </label>\n' +
    '          <input type="text" class="form-control input-field" capitalize\n' +
    '                 ng-pattern-restrict="{{investment.regexPatterns.allLettersNumbersSpaces}}"\n' +
    '                 id="fundSelectReplaceInput"\n' +
    '                 ng-model="investment.model.fundSelectReplaceInput"\n' +
    '                 ng-class="{\'domp-error\': investment.fundsForm.fundSelectReplaceInput.$invalid && investment.formSubmitted}"\n' +
    '                 name="fundSelectReplaceInput" required maxlength="39" ng-trim="false"\n' +
    '                 readonly>\n' +
    '          <span class="c-red"\n' +
    '                ng-show="investment.fundsForm.fundSelectReplaceInput.$error.required && investment.formSubmitted"\n' +
    '                translate="domesticPayment.receiverAccountError"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" translate="invest.accountType">\n' +
    '            Account type</label>\n' +
    '          <select class="form-control input-field p-l-15 p-r-10"\n' +
    '                  ng-disabled="investment.fundId"\n' +
    '                  ng-model="investment.model.accountType" ng-change="investment.getUserInvestmentAccounts();">\n' +
    '            <option value="1">{{"invest.investor"| translate}}</option>\n' +
    '            <option value="2">{{"invest.loan"| translate}}</option>\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Shared accounts related to selected fund -->\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6" ng-if="investment.model.investmentAccount.shareAccount">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" translate="invest.accounts">Accounts</label>\n' +
    '          <select class="form-control input-field p-l-15 p-r-10" ng-model="investment.model.investmentAccount" ng-options="item.shareAccount for item in investment.investmentAccountList">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12 form-group">\n' +
    '        <div class="no-padding-on-phone">\n' +
    '          <label class="domp-form-label domp-purpose-label"\n' +
    '                 translate="invest.comment">Comment</label>\n' +
    '          <div class="p-0">\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   data-ng-model="investment.model.comment"\n' +
    '                   name="comment"\n' +
    '                   ng-pattern-restrict="{{investment.regexPatterns.allowedCharsDPStextArea}}"\n' +
    '                   ng-class="{\'domp-error\': investment.fundsForm.paymentPurposeInput.$invalid && investment.formSubmitted}">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </ng-form>\n' +
    '\n' +
    '  <div class="intp-form-container">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-12 col-lg-12 col-md-12 p-l-0">\n' +
    '        <div class="col-xs-12">\n' +
    '          <label class="checkbox checkbox-inline-inline checkbox-value">\n' +
    '            {{\'invest.bellowComment\'| translate}}\n' +
    '            <b><a href ng-click="investment.openBrochure()">{{\'invest.bellowComment2\'| translate}}</a></b>\n' +
    '            {{\'invest.bellowComment3\'| translate}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6 col-xs-6 col-sm-6">\n' +
    '        <button class="btn btn-primary pull-left" ng-if="investment.fundId" translate="invest.back"\n' +
    '                data-ui-sref="investments.overview({fundId: investment.fundId})">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary pull-left" ng-if="!investment.fundId" translate="invest.back"\n' +
    '                data-ui-sref="investments.list">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="col-md-6 col-xs-6 col-sm-6">\n' +
    '        <button class="btn btn-default pull-right main-form-btn"\n' +
    '                translate="domesticPayment.confirmBtn"\n' +
    '                ng-disabled="investment.submitButtonDisabled"\n' +
    '                data-ng-click="investment.submit()">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investment-confirm-modal.tpl.html',
    '<div class="statementModal" style="padding: 50px">\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--    X\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <div  style="color: white; padding-top: 50px;">\n' +
    '              <i class="icon icon-add pull-right close-icon-x" ng-click="$close()"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        END X-->\n' +
    '    <!--    <div class="row">\n' +
    '          <div class="col-md-12 col-xs-12 col-sm-12">\n' +
    '            <div class="logout-modal-header" translate="invest.buyInvestmentPopup">Do you really want to log out?</span>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12 col-xs-12 col-sm-12">\n' +
    '        <h4 class="investment-confirm-modal-header">\n' +
    '          {{ \'invest.buyInvestmentPopup1\' | translate : {invFund : investmentFundName} }}\n' +
    '        </h4>\n' +
    '        <h4 class="investment-confirm-modal-header" translate="invest.buyInvestmentPopup2"></h4>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose" ng-click="$close(true)" translate="core.sweetAlertTranslation.yes"></button>\n' +
    '    <button class="btn btn-primary-red pull-left  statementBtnClose" ng-click="$close()" translate="core.sweetAlertTranslation.no"></button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/investment-base.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row domp-header-wrapper">\n' +
    '      <div class="domp-header-row col-md-12">\n' +
    '        <h2 ng-if="investment.model.orderType == 1" class="intp-title" translate="investOverview.buyStocks">Buy stocks</h2>\n' +
    '        <h2 ng-if="investment.model.orderType == 2" class="intp-title" translate="investOverview.sellStocks">Sell stock</h2>\n' +
    '        <h2 ng-if="investment.model.orderType == 3" class="intp-title" translate="investOverview.replaceStocks">Replace stock</h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="m-b-30">\n' +
    '      <ui-view/>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('investments/access-investments.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-12" style="z-index:1;">\n' +
    '        <div class="tmplt-list-title col-md-12 p-r-0 m-b-15">\n' +
    '          <h3>\n' +
    '            <b translate="accessInvestment.accession"></b>\n' +
    '          </h3>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.nameSurname"></label>\n' +
    '        <input type="text" class="form-control input-field" data-ng-model="accessInv.tempAccessionObj.nameSurnameInput" disabled>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.address"></label>\n' +
    '        <input type="text" class="form-control input-field" data-ng-model="accessInv.tempAccessionObj.addressInput" disabled>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.identificationNumber"></label>\n' +
    '        <input type="text" class="form-control input-field"\n' +
    '               data-ng-model="accessInv.tempAccessionObj.identificationNumberInput">\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.issuer"></label>\n' +
    '        <input type="text" class="form-control input-field" data-ng-model="accessInv.tempAccessionObj.issuerInput">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.phone"></label>\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control input-field" data-ng-model="accessInv.tempAccessionObj.personalHomePhoneInput">\n' +
    '                 <span class="input-group-btn">\n' +
    '                        <button type="button"\n' +
    '                                class="btn input-group-app-btn domp-btn-height"><i\n' +
    '                          class="glyphicon glyphicon-phone"></i>\n' +
    '                        </button>\n' +
    '                  </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.emailNotification"></label>\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control input-field"\n' +
    '                 data-ng-model="accessInv.tempAccessionObj.personalEmailInput">\n' +
    '                 <span class="input-group-btn">\n' +
    '                        <button type="button"\n' +
    '                                class="btn input-group-app-btn domp-btn-height"\n' +
    '                                ng-class="{\'red-email\': accessInv.tempAccessionObj.sendViaEmail}"\n' +
    '                        data-ng-click="accessInv.tempAccessionObj.sendViaEmail = !accessInv.tempAccessionObj.sendViaEmail;"><i\n' +
    '                          class="glyphicon glyphicon-envelope"></i>\n' +
    '                        </button>\n' +
    '                  </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.bank"></label>\n' +
    '          <input type="text" class="form-control input-field" data-ng-model="accessInv.tempAccessionObj.bankInput" disabled>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.accountNumberInput"></label>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-4">\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   data-ng-model="accessInv.tempAccessionObj.toAccount1Input" disabled>\n' +
    '          </div>\n' +
    '          <div class="col-sm-8">\n' +
    '            <input type="text" class="form-control input-field"\n' +
    '                   data-ng-model="accessInv.tempAccessionObj.toAccount2Input">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '<!-- employment data -->\n' +
    '    <div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <label class="bold-font m-t-20 f-18" translate="accessInvestment.personalStatus"></label>\n' +
    '          <select class="form-control" ng-model="accessInv.tempAccessionObj.personalStatus" ng-options="eData.key | translate for eData in accessInv.personalStatusData">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-6">\n' +
    '          <label class="bold-font m-t-20 f-18" translate="accessInvestment.employer"></label>\n' +
    '          <select class="form-control" ng-model="accessInv.tempAccessionObj.employerType" ng-options="eData.key | translate for eData in accessInv.employerTypeData">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <label class="bold-font m-t-20 f-18" translate="accessInvestment.vocation"></label>\n' +
    '          <input type="text" class="form-control input-field" data-ng-model="accessInv.tempAccessionObj.professionInput">\n' +
    '        </div>\n' +
    '        <div class="col-sm-6">\n' +
    '          <label class="bold-font m-t-20 f-18" translate="accessInvestment.profession"></label>\n' +
    '          <input type="text" class="form-control input-field" data-ng-model="accessInv.tempAccessionObj.occupationInput">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '<!-- end employment data -->\n' +
    '\n' +
    '    <!-- Investment data -->\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.plannedYearInvestment"></label>\n' +
    '        <select class="form-control" ng-model="accessInv.tempAccessionObj.plannedInvestments" ng-options="plannedInv.key | translate for plannedInv in accessInv.plannedInvestmentsType">\n' +
    '        </select>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="bold-font m-t-20 f-18" translate="accessInvestment.fundsInvestment"></label>\n' +
    '        <select class="form-control" ng-model="accessInv.tempAccessionObj.investFrom" ng-options="invFrom.key | translate for invFrom in accessInv.investFromType">\n' +
    '        </select>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- end investment data  -->\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-12 msg-container">\n' +
    '        <div translate="accessInvestment.msg1" class="m-b-10"></div>\n' +
    '        <div translate="accessInvestment.msg2"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row m-b-20">\n' +
    '      <div class="col-sm-12">\n' +
    '        <hr/>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-6 t-a-l">\n' +
    '        <button class="btn btn-primary" type="button" translate="payments.cancel" data-ui-sref="dashboard">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r">\n' +
    '        <button class="btn btn-default domp-review-and-submit-btn" type="submit"\n' +
    '                data-ng-click="accessInv.submit();"\n' +
    '                translate="invest.add">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/home.tpl.html',
    '<section id="main" data-ng-controller="MaterialAdminCtrl as mactrl">\n' +
    '  <div class="container" ng-init="cddMenuSelected=1">\n' +
    '    <div class="row">\n' +
    '      <!--LEFT COLUMN-->\n' +
    '\n' +
    '      <!--CENTER COLUMN-->\n' +
    '      <div class="col-md-12 frontPage">\n' +
    '\n' +
    '\n' +
    '        <div class=" slide" data-ride="carousel">\n' +
    '          <!--  <div id="timelineViewSelector" ng-init="timelineViewSelectorSelected=1">\n' +
    '  <div class="timeline-view-select-label" ng-click="timelineViewSelectorSelected=1" ng-class="{selected: timelineViewSelectorSelected == 1}">Transactions</div>\n' +
    '  <div class="timeline-view-select-label" ng-click="timelineViewSelectorSelected=2" ng-class="{selected: timelineViewSelectorSelected == 2}">Pdf statements</div>\n' +
    '</div>-->\n' +
    '          <!-- Wrapper for slides -->\n' +
    '          <div class="carousel-inner" role="listbox">\n' +
    '\n' +
    '            <div class="item active">\n' +
    '              <div class="slide-padding">\n' +
    '                <div class="col-md-12">\n' +
    '                  <h2 class="boldBlueHeader">New mobile banking app</h2>\n' +
    '                  <p class="blueFont">Secure, quick payments, instant products and more</p>\n' +
    '                  <button type="submit" style="width:25%;font-size:0.9em;" class="downloadTodayBtn btn btn-default app-btn-blue">Download today</button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="item">\n' +
    '              <div class="slide-padding">\n' +
    '                <div class="col-md-12">\n' +
    '                  <h1 class="boldBlueHeader">New mobile banking app</h1>\n' +
    '                  <h4>Secure, quick payments, instant products and more</h4>\n' +
    '                  <br/>\n' +
    '                  <button type="submit" style="width:20%;" class="downloadToday2Btn btn btn-default app-btn-blue">Download today</button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <!--  <div id="periodViewSelector" ng-init="timelineViewSelectorSelected=1">\n' +
    '  <div class="period-view-select-div left" ng-click="timelineViewSelectorSelected=1" ng-class="{selected: timelineViewSelectorSelected == 1}">Period:</div>\n' +
    '  <div class="period-view-select-div right" ng-click="timelineViewSelectorSelected=2" ng-class="{selected: timelineViewSelectorSelected == 2}">\n' +
    '    <div class="dropdown acc-period-select" ng-init="periodSelectorLabel=\'This week\'">\n' +
    '      <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '        {{periodSelectorLabel}}\n' +
    '        <span class="caret" style="color:#FF4D5A;"></span>\n' +
    '      </button>\n' +
    '      <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '        <li>\n' +
    '          <a ng-click="periodSelectorLabel=\'Yesterday\'">Yesterday</a>\n' +
    '        </li>\n' +
    '        <li>\n' +
    '          <a ng-click="periodSelectorLabel=\'This Month\'">This Month</a>\n' +
    '        </li>\n' +
    '        <li>\n' +
    '          <a ng-click="periodSelectorLabel=\'This year\'">This year</a>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>-->\n' +
    '\n' +
    '          <!-- Left and right controls -->\n' +
    '          <a ng-non-bindable class="left carousel-control" href="personalFirstRow" role="button" data-slide="prev" style="background-image: none;width:10%;">\n' +
    '            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>\n' +
    '            <span class="sr-only">Previous</span>\n' +
    '          </a>\n' +
    '          <a ng-non-bindable class="right carousel-control" href="personalFirstRow" role="button" data-slide="next" style="background-image: none;width:10%;">\n' +
    '            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>\n' +
    '            <span class="sr-only">Next</span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '        <!--SECOND ROW-->\n' +
    '        <div class="personalHome">\n' +
    '          <div class="personalSecondRow">\n' +
    '            <h2 class="boldBlueHeader">Hypo rewards</h2>\n' +
    '            <!--  <p class="lowerText">The more you use the app the more points you will earn which will let you claim some great rewards.</p>-->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!--THIRD ROW-->\n' +
    '        <div class="personalHome">\n' +
    '          <div class="personalThirdRow">\n' +
    '            <h2 class="boldBlueHeader">Housing loans</h2>\n' +
    '            <br/>\n' +
    '            <p class="lowerText2">We have some great loans that could help you purchase the property of your dreams.</p>\n' +
    '            <br/> <br/> <br/> <br/>\n' +
    '            <p class="lowerText2">*Low rates</p><br/>\n' +
    '            <p class="lowerText2">*Quick approval</p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '<footer id="footer" data-ng-include="\'template/footer.html\'"></footer>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('employee-payroll/employee-payroll.tpl.html',
    '<section id="main">\n' +
    '    <div class="container">\n' +
    '        <div class="row main-row">\n' +
    '            <div class="tmplt-list-title col-md-12 p-r-0 m-b-15">\n' +
    '                <h2 translate="employee.header" class="title-style"></h2>\n' +
    '            </div>\n' +
    '            <div class="timeline-row col-sm-12">\n' +
    '\n' +
    '                <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">\n' +
    '\n' +
    '                    <ul class="hypo-timeline" kcd-recompile="employeePayroll.timelineListGrouped">\n' +
    '\n' +
    '                        <div class="t-a-c p-10 no-data-image" ng-if="employeePayroll.timelineListGrouped.result.length == 0">\n' +
    '                            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                            <h3 class="no-data-label" translate="employee.noTimelineData"></h3>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <li data-ng-repeat="tlItem in ::employeePayroll.timelineListGrouped.result" ng-class="{\'time-label\': tlItem.isVirtual === true}">\n' +
    '\n' +
    '                            <span ng-if="tlItem.isVirtual === true" class="salary-date">{{tlItem.date}}</span>\n' +
    '\n' +
    '\n' +
    '                            <i ng-if="tlItem.isVirtual != true" class="icon icon-salary salary-right"></i>\n' +
    '\n' +
    '                            <div ng-if="tlItem.isVirtual == undefined" class="hypo-timeline-item msg-item">\n' +
    '                                <div class="bubble message">\n' +
    '                                    <div class="msg-label no-bottom-margin"><span>{{tlItem.customDate | date: \'MMM\' }} - </span><span>{{::tlItem.id}}</span>\n' +
    '                                        <i class="icon icon-acrobat pdf-icon"></i>\n' +
    '                                        <a type="text" translate="employee.downloadPdf" class="pull-right " style="padding: 2px 5px;" data-ng-click="employeePayroll.downloadPdf(tlItem.id);"><i class="icon icon-acrobat" ></i>Download PDF</a>\n' +
    '\n' +
    '                                    </div>\n' +
    '\n' +
    '                                </div>\n' +
    '\n' +
    '                            </div>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '                <div class="show-more-btn ">\n' +
    '                    <button ng-hide="employeePayroll.timelineListGrouped.hasMore == false" data-ng-click="employeePayroll.loadMoreTimelineItemsGrouped()" type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents">Load older events</button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/einvoices-register.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid" ng-show="vm.step == \'register\'">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="domp-header-wrapper col-sm-12 p-o">\n' +
    '        <div class="domp-header-row">\n' +
    '          <h2 class="intp-title" translate="eInvoicesSubscribe.newRegistration"></h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Title-->\n' +
    '    <form name="vm.einvoiceSubscribeForm" novalidate class="p-15 bg-white">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container gray-card2">\n' +
    '            <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="row">\n' +
    '              <!-- START CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '              <div class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12">\n' +
    '                <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '                <div class="accounts-dropdown">\n' +
    '                  <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="vm.toggleFromAccount();" ng-style="vm.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + vm.tempDompObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{vm.tempDompObj.fromAccountSelect.friendlyName}}</b>\n' +
    '                      <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':vm.tempDompObj.fromAccountSelect.isFavorite, \'zmdi-star-outline\':!vm.tempDompObj.fromAccountSelect.isFavorite}"></i></span>\n' +
    '                    </h4>\n' +
    '                    <p class="m-b-0 m-t-0 iban-style">{{vm.tempDompObj.fromAccountSelect.iban}}</p>\n' +
    '                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                      {{vm.tempDompObj.fromAccountSelect.availableBalance| number:2}} {{vm.tempDompObj.fromAccountSelect.currencySymbol}}\n' +
    '                    </p>\n' +
    '                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                  </div>\n' +
    '                  <div class="from-accounts-list " ng-show="vm.fromAccountDropdown" scrollable>\n' +
    '                    <div class="accounts-list-item p-0" data-ng-repeat="item in vm.accounts" data-ng-click="vm.setAccountFrom(item);">\n' +
    '\n' +
    '                      <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ? {\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                        <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                          <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                          <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite, \'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                        </h4>\n' +
    '                        <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                        <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                          {{item.availableBalance| number:2}} {{item.currencySymbol}}\n' +
    '                        </p>\n' +
    '                        <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '\n' +
    '              <div  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="col-xs-12 col-sm-6">\n' +
    '                <div  class="row p-b-20">\n' +
    '                  <div class="col-xs-6">\n' +
    '                    <label class="domp-form-label" for="requestType" translate="eInvoicesModal.requestType"></label>\n' +
    '                    <select name="requestType"\n' +
    '                            id="requestType"\n' +
    '                            class="form-control input-field p-l-15 p-r-10"\n' +
    '                            ng-options="option.value | translate for option in vm.requestTypes"\n' +
    '                            ng-model="vm.requestType"\n' +
    '                            required>\n' +
    '                    </select>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-6">\n' +
    '                    <label class="domp-form-label" for="gsm" translate="eInvoicesModal.gsm"></label>\n' +
    '                    <input type="text"\n' +
    '                           class="form-control input-field"\n' +
    '                           ng-model="vm.gsm"\n' +
    '                           name="gsm"\n' +
    '                           id="gsm"\n' +
    '                           data-ng-class="{\'domp-error\': vm.einvoiceSubscribeForm.gsm.$invalid && vm.formSubmitted}" />\n' +
    '                  </div>\n' +
    '                  </div>\n' +
    '                  <div class="row">\n' +
    '                  <div class="col-xs-12">\n' +
    '                    <label class="domp-form-label" for="email" translate="eInvoicesSubscribe.yourContactEmail"></label>\n' +
    '                    <input type="text"\n' +
    '                           class="form-control input-field"\n' +
    '                           ng-model="vm.email"\n' +
    '                           name="email"\n' +
    '                           id="email"\n' +
    '                           data-ng-class="{\'domp-error\': vm.einvoiceSubscribeForm.email.$invalid && vm.formSubmitted}" />\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="vm.einvoiceSubscribeForm.email.$error.required && vm.formSubmitted"\n' +
    '                          translate="eInvoicesSubscribe.einvoiceSubscribeEmailInputError"></span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '\n' +
    '              <div class="col-sm-6">\n' +
    '\n' +
    '                <div class="form-group clearfix">\n' +
    '                  <div>\n' +
    '                    <label ng-if="vm.countryCode != \'sl\'" class="domp-form-label" translate="eInvoicesSubscribe.einvoiceIssuer"></label>\n' +
    '                    <label ng-if="vm.countryCode == \'sl\'" class="domp-form-label"  translate="eInvoicesSubscribe.einvoiceIssuerSlo"></label>\n' +
    '                  </div>\n' +
    '                  <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '                       class="col-lg-3 col-sm-3 col-md-3 col-xs-3 p-l-0 p-r-5">\n' +
    '                    <input type="text"\n' +
    '                           ng-model="vm.taxIdSearch"\n' +
    '                           ng-model-options="{ allowInvalid: true, debounce: 500 }"\n' +
    '                           ng-change="vm.searchIssuers(\'id\');"\n' +
    '                           class="form-control input-field"\n' +
    '                           ng-readonly="vm.issuer"\n' +
    '                           required/>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div ng-class="{\'col-lg-9 col-sm-9 col-md-9 col-xs-9\': APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\',\n' +
    '                                  \'col-lg-12 col-sm-12 col-md-12\': APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\',\n' +
    '                                  \'domp-error-custom-payee\': vm.paymentForm.issuerSearchInput.$invalid && vm.tempForpObj.formSubmitted}"\n' +
    '                       class="p-t-0 domp-filter-container"\n' +
    '                       style="height: 45px">\n' +
    '\n' +
    '                    <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section left">\n' +
    '                      <i class="icon icon-search domp-search-sign m-l-5"></i>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 inner-section input-div searchrow">\n' +
    '\n' +
    '\n' +
    '                      <input ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                             type="text" class="search-input" name="issuerSearchInput"\n' +
    '                             ng-model="vm.issuerSearchInput"\n' +
    '                             ng-change="vm.searchExpanded = true;"\n' +
    '                             placeholder={{eInvoicesSubscribe.selectIssuer}}\n' +
    '                             required\n' +
    '                             ng-readonly="vm.issuer"\n' +
    '                             autocomplete="off">\n' +
    '                      <input ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '                             type="text" class="search-input" name="issuerSearchInput"\n' +
    '                             ng-model="vm.issuerSearchInput"\n' +
    '                             ng-model-options="{ debounce: 500 }"\n' +
    '                             ng-change="vm.searchIssuers(\'name\')"\n' +
    '                             placeholder={{eInvoicesSubscribe.selectIssuer}}\n' +
    '                             required\n' +
    '                             ng-readonly="vm.issuer"\n' +
    '                             autocomplete="off">\n' +
    '                    </div>\n' +
    '\n' +
    '\n' +
    '                    <div class="col-sm-1 col-md-1 col-lg-1 col-xs-1 inner-section right"\n' +
    '                         ng-click="vm.searchExpanded = !vm.searchExpanded; vm.removeSelectedIssuer();">\n' +
    '                      <i class="zmdi zmdi-close domp-close-sign"\n' +
    '                         ng-show="vm.issuerSearchInput"></i>\n' +
    '                      <i class="zmdi zmdi-chevron-down zmdi-hc-2x m-r-0 pull-right"\n' +
    '                         ng-show="!vm.issuerSearchInput"></i>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!--Dropdown menu -->\n' +
    '                    <div class="domp-filter-selection search-row"\n' +
    '                         ng-class="{\'opened\': vm.searchExpanded, \'domp-error\': vm.einvoiceSubscribeForm.issuer.$invalid && vm.formSubmitted}">\n' +
    '                      <div class="domp-filter-type-selection-wrapper"\n' +
    '                           ng-repeat="issuer in vm.issuers"\n' +
    '                           ng-click="vm.issuerSelected(issuer)">\n' +
    '                        <div class="domp-list icon col-lg-1 col-md-1 col-sm-1 col-xs-1">\n' +
    '                        </div>\n' +
    '                        <div class="domp-list payee col-lg-5 col-md-5 col-sm-5 col-xs-5">\n' +
    '                          <p class="domp-list-name m-0">\n' +
    '                            <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">{{issuer.identificationNumber}} -</span>\n' +
    '                            {{issuer.name}}\n' +
    '                          </p>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="vm.einvoiceSubscribeForm.issuer.$error.required && vm.formSubmitted"\n' +
    '                          translate="eInvoicesSubscribe.einvoiceIssuerInputError">\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6">\n' +
    '                <label class="domp-form-label" for="referenceNumber" translate="eInvoicesSubscribe.referenceFromIssuer"></label>\n' +
    '                <input ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" type="text"\n' +
    '                       class="form-control input-field"\n' +
    '                       ng-model="vm.referenceNumber"\n' +
    '                       name="referenceNumber"\n' +
    '                       id="referenceNumber"\n' +
    '                       required\n' +
    '                       data-ng-class="{\'domp-error\': vm.einvoiceSubscribeForm.referenceNumber.$invalid && vm.formSubmitted}" />\n' +
    '                <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" class="c-red"\n' +
    '                      ng-show="vm.einvoiceSubscribeForm.referenceNumber.$error.required && vm.formSubmitted"\n' +
    '                      translate="eInvoicesSubscribe.einvoiceReferenceFromIssuerInputError"></span>\n' +
    '\n' +
    '                <input ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" type="text"\n' +
    '                       class="form-control input-field"\n' +
    '                       ng-model="vm.referenceNumber"\n' +
    '                       name="referenceNumber"\n' +
    '                       id="referenceNumber"\n' +
    '                       ng-blur="vm.checkIfRequiredAndValid(vm.referenceNumber);"\n' +
    '                       ng-required = "vm.issuer.referenceRequired"\n' +
    '                       data-ng-class="{\'domp-error\': vm.einvoiceSubscribeForm.referenceNumber.$invalid && vm.formSubmitted || vm.einvoiceSubscribeForm.referenceNumber.$error.referenceRequired }" />\n' +
    '                <span class="di-block" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && vm.issuer.mask">{{vm.issuer.mask}}</span>\n' +
    '                <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="c-red"\n' +
    '                      ng-show="vm.einvoiceSubscribeForm.referenceNumber.$error.required &&\n' +
    '                      vm.formSubmitted ||\n' +
    '                      vm.einvoiceSubscribeForm.referenceNumber.$error.referenceRequired"\n' +
    '                      translate="eInvoicesSubscribe.einvoiceReferenceFromIssuerInputError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="row p-t-20">\n' +
    '              <div ng-if="vm.issuer.iban" class="col-xs-12 col-sm-6">\n' +
    '                <label class="domp-form-label"  translate="eInvoicesModal.issuerIban"></label>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.iban | formatIban}}\n' +
    '                </label>\n' +
    '\n' +
    '              </div>\n' +
    '              <div ng-if="vm.issuer.address || vm.issuer.city || vm.issuer.country" class="col-xs-12 col-sm-6">\n' +
    '                <label class="domp-form-label"  translate="eInvoicesModal.issuerAddress"></label>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.address}}\n' +
    '                </label>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.city}}\n' +
    '                </label>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.country}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="vm.countryCode != \'sl\'">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container gray-card2">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-6">\n' +
    '                <label class="domp-form-label" for="email" translate="eInvoicesSubscribe.yourContactEmail"></label>\n' +
    '                <input type="text"\n' +
    '                       class="form-control input-field"\n' +
    '                       ng-model="vm.email"\n' +
    '                       name="email"\n' +
    '                       id="email"\n' +
    '                       ng-disabled="!vm.editingEmail"\n' +
    '                       data-ng-class="{\'domp-error\': vm.einvoiceSubscribeForm.email.$invalid && vm.formSubmitted}" />\n' +
    '                <span class="c-red"\n' +
    '                      ng-show="vm.einvoiceSubscribeForm.email.$error.required && vm.formSubmitted"\n' +
    '                      translate="eInvoicesSubscribe.einvoiceSubscribeEmailInputError"></span>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-sm-6">\n' +
    '                <label class="mock-label domp-form-label">&nbsp;</label>\n' +
    '                <button class="btn btn-default" name="emailChangeButton" id="emailChangeButton"\n' +
    '                        ng-click="vm.editEmail()"\n' +
    '                        ng-if="!vm.editingEmail"\n' +
    '                        translate="eInvoicesSubscribe.changeEmail">\n' +
    '                </button>\n' +
    '\n' +
    '                <button class="btn btn-primary" name="emailUpdateButton" id="emailUpdateButton"\n' +
    '                        ng-click="vm.updateEmail()"\n' +
    '                        ng-if="vm.editingEmail"\n' +
    '                        translate="eInvoicesSubscribe.updateEmail">\n' +
    '                </button>\n' +
    '\n' +
    '                <button class="btn btn-default" name="emailCancelButton" id="emailCancelButton"\n' +
    '                        ng-click="vm.cancelEmail()"\n' +
    '                        ng-if="vm.editingEmail"\n' +
    '                        translate="eInvoicesModal.btnCancel">\n' +
    '                </button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div ng-if="vm.countryCode == \'sl\'"  class="row p-20">\n' +
    '        <div class="col-xs-12"><label class="domp-form-label" translate="eInvoicesSubscribe.statement"></label></div>\n' +
    '        <div class="col-xs-12"><label class="domp-form-label" translate="eInvoicesSubscribe.statementTitle"></label></div>\n' +
    '        <div class="col-xs-12">\n' +
    '          <span translate="eInvoicesSubscribe.statementText"></span>\n' +
    '          <span class="underline"><a ng-href="https://www.addiko.si/splosni-pogoji" target="_blank" translate="eInvoicesSubscribe.statementTextLink1"></a></span>\n' +
    '          <span translate="eInvoicesSubscribe.statementTextAnd"></span>\n' +
    '          <span class="underline"><a ng-href="https://www.addiko.si/splosni-pogoji" target="_blank" translate="eInvoicesSubscribe.statementTextLink2"></a></span>\n' +
    '          <span translate="eInvoicesSubscribe.statementTextEnd"></span>\n' +
    '        </div>\n' +
    '        <div ng-if="vm.issuer.termsOfServiceLink" >\n' +
    '          <div class="col-xs-12 p-t-10">\n' +
    '            <label class="domp-form-label" translate="eInvoicesSubscribe.statementTitle2"></label>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12"><span>{{vm.issuer.terms}}</span></div>\n' +
    '          <div class="col-xs-12">\n' +
    '            <a class="underline" ng-href="{{vm.issuer.termsOfServiceLink}}" target="_blank" translate="eInvoicesSubscribe.statementText2"></a>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container gray-card2">\n' +
    '            <div class="row">\n' +
    '              <div class="col-sm-12">\n' +
    '                <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                  <input id="userApproves" type="checkbox" class="" ng-model="vm.userApproves" ng-change="vm.checkDisabled()" required>\n' +
    '                  <i class="input-helper"></i>\n' +
    '                  <a ng-if="vm.countryCode != \'sl\'" translate="eInvoicesSubscribe.termsAndConditions"></a>\n' +
    '                  <a ng-if="vm.countryCode === \'sl\'" translate="eInvoicesSubscribe.termsAndConditionsSlo"></a>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.countryCode != \'sl\' && vm.issuer.termsOfServiceLink">\n' +
    '              <div class="col-sm-12">\n' +
    '                <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                  <input id="userAgrees" type="checkbox" class="" ng-model="vm.userAgrees" ng-change="vm.checkDisabled()" required>\n' +
    '                  <i class="input-helper"></i>\n' +
    '                  <a ng-href="{{vm.issuer.termsOfServiceLink}}" target="_blank" translate="eInvoicesSubscribe.specialConditions"></a>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.issuer.ReferenceLink">\n' +
    '              <div class="col-sm-12">\n' +
    '                <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                  <input id="referenceLink" type="checkbox" class="" ng-model="vm.ReferenceLink" ng-change="vm.checkDisabled()" required>\n' +
    '                  <i class="input-helper"></i>\n' +
    '                  <a ng-href="{{vm.issuer.ReferenceLink}}" target="_blank" translate="eInvoicesSubscribe.referenceExplanation"></a>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </form>\n' +
    '    <div class="row m-t-10 m-b-30">\n' +
    '      <div class="col-xs-6 t-a-l">\n' +
    '        <button class="btn btn-primary" data-ui-sref=\'eInvoices.einvoicesOverview\'\n' +
    '                translate="eInvoicesSubscribe.cancel"></button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '        <button class="btn btn-default" ng-click="vm.resume()" translate="sepa.refundComplaint.next"\n' +
    '                ng-disabled="!vm.userApproves || !vm.issuer || vm.einvoiceSubscribeForm.referenceNumber.$error.referenceRequired"></button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <button class="btn btn-default" ng-click="vm.register()"\n' +
    '                translate="eInvoicesSubscribe.register"\n' +
    '                ng-disabled="vm.disabled"></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="container-fluid m-t-20" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && vm.step == \'resume\'">\n' +
    '    <div class="p-15 bg-white">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '          <div class="container gray-card2">\n' +
    '            <div class="row">\n' +
    '              <div class="form-group col-lg-6 col-md-6 col-xs-12 col-sm-12">\n' +
    '                <label class="domp-form-label" translate="payments.fromAccount"></label>\n' +
    '                <label ng-if="vm.countryCode != \'sl\'" class="domp-form-label-resume">{{vm.tempDompObj.fromAccountSelect.iban}}</label>\n' +
    '                <label ng-if="vm.countryCode == \'sl\'" class="domp-form-label-resume">{{vm.tempDompObj.fromAccountSelect.iban | formatIban}}</label>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12 col-sm-6">\n' +
    '                <div  class="row p-b-20">\n' +
    '                  <div class="col-xs-6">\n' +
    '                    <label class="domp-form-label" for="requestType" translate="eInvoicesModal.requestType"></label>\n' +
    '                    <label class="domp-form-label-resume">{{vm.requestType.value | translate}}</label>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-6">\n' +
    '                    <label class="domp-form-label" for="gsm" translate="eInvoicesModal.gsm"></label>\n' +
    '                    <label class="domp-form-label-resume">{{vm.gsm}}</label>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div>\n' +
    '                  <label class="domp-form-label" for="email" translate="eInvoicesSubscribe.yourContactEmail"></label>\n' +
    '                  <label class="domp-form-label-resume">{{vm.email}}</label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row m-t-15">\n' +
    '              <div class="col-sm-6">\n' +
    '                <div class="form-group clearfix">\n' +
    '                    <label ng-if="vm.countryCode != \'sl\'" class="domp-form-label" translate="eInvoicesSubscribe.einvoiceIssuer"></label>\n' +
    '                    <label ng-if="vm.countryCode == \'sl\'" class="domp-form-label"  translate="eInvoicesSubscribe.einvoiceIssuerSlo"></label>\n' +
    '                    <label class="domp-form-label-resume">{{vm.taxIdSearch}} - {{vm.issuerSearchInput}}</label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-sm-6">\n' +
    '                <label class="domp-form-label" for="referenceNumber" translate="eInvoicesSubscribe.referenceFromIssuer"></label>\n' +
    '                <label class="domp-form-label-resume">{{vm.referenceNumber}}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '            <div class="row p-b-20">\n' +
    '              <div ng-if="vm.issuer.iban" class="col-xs-12 col-sm-6">\n' +
    '                <label class="domp-form-label" translate="eInvoicesModal.issuerIban"></label>\n' +
    '                <label ng-if="vm.countryCode != \'sl\'" class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.iban }}\n' +
    '                </label>\n' +
    '                <label ng-if="vm.countryCode == \'sl\'" class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.iban | formatIban}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div ng-if="vm.issuer.address || vm.issuer.city || vm.issuer.country" class="col-xs-12 col-sm-6">\n' +
    '                <label class="domp-form-label"  translate="eInvoicesModal.issuerAddress"></label>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.address}}\n' +
    '                </label>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.city}}\n' +
    '                </label>\n' +
    '                <label class="domp-form-label-resume">\n' +
    '                  {{vm.issuer.country}}\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="vm.countryCode == \'sl\'"  class="row">\n' +
    '              <div class="col-xs-12"><label class="domp-form-label" translate="eInvoicesSubscribe.statement"></label></div>\n' +
    '              <div class="col-xs-12"><label class="domp-form-label" translate="eInvoicesSubscribe.statementTitle"></label></div>\n' +
    '              <div class="col-xs-12">\n' +
    '                <span translate="eInvoicesSubscribe.statementText"></span>\n' +
    '                <span class="underline"><a ng-href="https://www.addiko.si/splosni-pogoji" target="_blank" translate="eInvoicesSubscribe.statementTextLink1"></a></span>\n' +
    '                <span translate="eInvoicesSubscribe.statementTextAnd"></span>\n' +
    '                <span class="underline"><a ng-href="https://www.addiko.si/splosni-pogoji" target="_blank" translate="eInvoicesSubscribe.statementTextLink2"></a></span>\n' +
    '                <span translate="eInvoicesSubscribe.statementTextEnd"></span>\n' +
    '              </div>\n' +
    '\n' +
    '              <div ng-if="vm.issuer.termsOfServiceLink" >\n' +
    '                <div class="col-xs-12 p-t-10">\n' +
    '                  <label class="domp-form-label" translate="eInvoicesSubscribe.statementTitle2"></label>\n' +
    '                </div>\n' +
    '                <div class="col-xs-12"><span>{{vm.issuer.terms}}</span></div>\n' +
    '                <div class="col-xs-12">\n' +
    '                  <a class="underline" ng-href="{{vm.issuer.termsOfServiceLink}}" target="_blank" translate="eInvoicesSubscribe.statementText2"></a>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row m-t-10 m-b-30">\n' +
    '      <div class="col-xs-6 t-a-l">\n' +
    '        <button class="btn btn-primary"\n' +
    '                ng-click="vm.step = \'register\'"\n' +
    '                translate="domesticPayment.back"></button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r">\n' +
    '        <button class="btn btn-default" ng-click="vm.register()" translate="eInvoicesSubscribe.register" ng-disabled="vm.registerButtonPressed">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="container" ng-if="vm.step == \'done\'">\n' +
    '    <div class="payment-successful-wrapper">\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '          <div class="currency-check-icon msg-pad">\n' +
    '            <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-10 m-t-30 m-b-30">\n' +
    '          <h2 class="c-white f-28" translate="eInvoicesSubscribe.applicationComplete"></h2>\n' +
    '          <div class="f-16">\n' +
    '            <span ng-if="vm.countryCode != \'sl\'" translate="eInvoicesSubscribe.applicationCompleteText" translate-values="vm.issuer"></span>\n' +
    '            <span ng-if="vm.countryCode === \'sl\'" translate="eInvoicesSubscribe.applicationCompleteTextSlo" translate-values="vm.issuer"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row m-t-20">\n' +
    '      <div class="col-sm-4">\n' +
    '        <a href="" data-ng-click="vm.registerNew()">\n' +
    '          <span class="money-exchange-icon"><i class="icon icon-einvoice zmdi-hc-2x"></i></span>\n' +
    '          <span class="f-18 money-exchange-text"  translate="eInvoicesSubscribe.registrationNew"></span>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-4">\n' +
    '        <a href="" ng-click="vm.goToEInvoices();">\n' +
    '          <span class="money-exchange-icon"><i class="icon icon-einvoiceadd zmdi-hc-2x"></i></span>\n' +
    '          <span ng-if="vm.countryCode !== \'sl\'" class="f-18 money-exchange-text" translate="eInvoicesSubscribe.goToList"> </span>\n' +
    '          <span ng-if="vm.countryCode === \'sl\'" class="f-18 money-exchange-text" translate="eInvoicesSubscribe.goToListSlo"> </span>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/einvoices-payment-resume.tpl.html',
    '<div class="row p-10">\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 domp-from-section">\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-l-0">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>\n' +
    '        <label class="domp-form-label-resume">\n' +
    '          {{vm.fromAccountSelect.accountDescription}}\n' +
    '        </label>\n' +
    '        <label class="domp-form-label-accnumber">{{vm.paymentResponse.fromAccountNumber}}</label>\n' +
    '        <label class="domp-form-label-balance" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '          {{vm.fromAccountSelect.availableBalance |number:2}}\n' +
    '          {{vm.fromAccountSelect.currencySymbol}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-l-0">\n' +
    '      <div class="row">\n' +
    '        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0">\n' +
    '          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">\n' +
    '              {{vm.paymentResponse.amount | currency: ""}}\n' +
    '              {{vm.paymentResponse.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.bankCharges"></label>\n' +
    '            <a  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                ng-href="{{vm.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges"\n' +
    '                class="domp-form-label-resume">Check the bank charges</a>\n' +
    '            <label class="domp-form-label-resume" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '              {{vm.paymentResponse.paymentChargesAmount | currency: ""}}\n' +
    '              {{vm.paymentResponse.currencySymbol}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-5">\n' +
    '          <div class="m-t-25 m-b-0">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.dateInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{vm.paymentResponse.dueDate |date:\'shortDate\'}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 receiver-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '        <label class="domp-form-label-review" translate="domesticPayment.toAccountInputLabel"></label>\n' +
    '        <label class="domp-form-label-resume">{{vm.paymentResponse.toAccountNumber}}</label>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.toPayee">To payee</label>\n' +
    '          <label class="domp-form-label-resume">{{vm.paymentResponse.domesticPayment.receiverName}}</label>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <!--<div class="col-lg-6 col-md-6 col-sm-6 col-xs-5 p-l-0"></div>-->\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5 p-l-0"></div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '        <div class="m-t-15 m-b-0">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.receiversAddressInputLabel"></label>\n' +
    '          <label class="domp-form-label-resume">{{vm.paymentResponse.domesticPayment.receiverAddress1}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '        <div class="m-t-25 m-b-0">\n' +
    '          <label class="domp-form-label-review" translate="domesticPayment.receiversPostalCodeAndCityInputLabel"></label>\n' +
    '          <label class="domp-form-label-resume">{{vm.paymentResponse.domesticPayment.receiverCity}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 purpose-section">\n' +
    '    <div class="row">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5 no-padding-on-phone p-l-0">\n' +
    '        <div class="col-lg-8 col-md-8 col-sm-8">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label-review" translate="domesticPayment.purposeOfPaymentInputLabel"></label>\n' +
    '            <label class="domp-form-label-resume">{{vm.paymentResponse.purpose}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 no-padding-on-phone p-l-0">\n' +
    '        <div class="col-lg-6 col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="domp-form-label-review domp-reference-number-label"\n' +
    '                 translate="domesticPayment.referenceNumberLabel">Reference number</label>\n' +
    '          <label ng-if="vm.countryCode != \'sl\'" class="domp-form-label-resume">{{vm.paymentResponse.domesticPayment.referenceTo}}</label>\n' +
    '          <label class="domp-form-label-resume"\n' +
    '                 ng-if="vm.countryCode != \'sl\' && vm.paymentResponse.domesticPayment.referenceTo ==\' \' || vm.paymentResponse.domesticPayment.referenceTo == undefined">\n' +
    '            -\n' +
    '          </label>\n' +
    '          <label ng-if="vm.countryCode == \'sl\'" class="domp-form-label-resume">{{vm.invoice.paymentReferenceNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row" ng-if="vm.isUrgentPaymentCheckbox == true">\n' +
    '      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '        <i class="zmdi zmdi-check urgent-label"></i>\n' +
    '        <label class="urgent-label" translate="domesticPayment.urgentPayment"></label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <section ng-if="vm.countryCode == \'sl\'" class="row p-t-15">\n' +
    '      <div class="col-xs-12 col-sm-5 p-l-30" style="line-height: 39px;">\n' +
    '        <a class="underline pull-right" ng-href="{{vm.defaultData.ProvisionLink}}" target="_blank" translate="domesticPayment.timetableForProvisionLink">\n' +
    '          Check the bank charges\n' +
    '        </a>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-sm-3 p-l-30 " style="line-height: 39px;">\n' +
    '        <a class="underline" ng-href="{{vm.defaultData.SepaCodesLink}}" target="_blank" translate="domesticPayment.SEPAcodesLink">\n' +
    '        </a>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-sm-3 p-l-30 " style="line-height: 39px;">\n' +
    '        <a class="underline" ng-href="{{vm.defaultData.BankChargesLink}}" target="_blank" translate="domesticPayment.checkBankCharges">\n' +
    '        </a>\n' +
    '      </div>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="row domp-footer-wrapper p-10">\n' +
    '  <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">\n' +
    '    <button ng-if="vm.countryCode != \'sl\'" class="col-lg-2 col-md-2 col-sm-2 col-xs-3 m-r-10 btn btn-primary-warning"\n' +
    '            translate="eInvoicesModal.delete"\n' +
    '            ng-click="vm.deletePayment();">\n' +
    '    </button>\n' +
    '\n' +
    '    <button  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"  class="col-lg-2 col-md-2 col-sm-2 col-xs-3 btn btn-primary"\n' +
    '             translate="eInvoicesModal.edit"\n' +
    '             ng-click="vm.editPayment();">\n' +
    '    </button>\n' +
    '    <button ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="col-lg-2 col-md-2 col-sm-2 col-xs-3 btn btn-primary"\n' +
    '            translate="domesticPayment.back"\n' +
    '            ng-click="vm.editPayment();">\n' +
    '    </button>\n' +
    '\n' +
    '    <button ng-if="vm.countryCode != \'sl\'" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default  pull-right"\n' +
    '            translate="eInvoicesModal.sign"\n' +
    '            data-ui-sref="payments.sign({paymentId: vm.paymentResponse.id, type: \'einvoice\'})">\n' +
    '    </button>\n' +
    '\n' +
    '    <button ng-if="vm.countryCode == \'sl\'" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-default  pull-right"\n' +
    '            translate="domesticPayment.confirmBtn"\n' +
    '            ng-disabled="vm.confirmationInProgress"\n' +
    '            ng-click="vm.signPayment()">\n' +
    '    </button>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/einvoices-overview.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div>\n' +
    '\n' +
    '      <div class="redesign-title col-sm-12">\n' +
    '        <h2 class="f-28" translate="{{ APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'eInvoicesModal.einvoicesSlo\' : \'eInvoicesModal.einvoices\'}}"> </h2>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '         <div class="col-xs-12 col-sm-6 m-b-20">\n' +
    '              <div class="account-item-add-message app-dblue-card" ng-click="einvoicesOverview.registerIssuer()">\n' +
    '                <div class="round-btn-container2" >\n' +
    '                  <div class="round-btn-m">\n' +
    '                    <i class="icon-r icon-add icon-add-msg"></i>\n' +
    '                  </div>\n' +
    '                  <div class="round-btn-label-msg" >\n' +
    '                    <h3 class="round-btn-label-msg">{{\'eInvoiceOverview.register\' | translate}}</h3>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '        <div class="msg-tab-container cursor-pointer">\n' +
    '          <div class="msg-tab-bh einv-tab"\n' +
    '               ng-class="{\'selected\': einvoicesOverview.showSubmenuItemType == \'unpaidTab\', \'msg-tab-bh-fourth\' : APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' }"\n' +
    '               ng-click="einvoicesOverview.selectTab(\'unpaidTab\', \'eInvoicesModal.waitingForPayment\')">\n' +
    '            <a class="ver--align" translate="{{ APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'eInvoicesModal.waitingForPaymentSlo\' : \'eInvoicesModal.waitingForPayment\'}}"></a>\n' +
    '          </div>\n' +
    '          <div class="einv-tab msg-tab-bh cursor-pointer"\n' +
    '               ng-class="{\'selected\': einvoicesOverview.showSubmenuItemType==\'processedTab\', \'msg-tab-bh-fourth\' : APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'}"\n' +
    '               ng-click="einvoicesOverview.selectTab(\'processedTab\', \'eInvoicesModal.processedTab\')">\n' +
    '            <a class="ver--align" translate="{{ APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'eInvoicesModal.processedTabSlo\' : \'eInvoicesModal.processedTab\'}}"></a>\n' +
    '          </div>\n' +
    '\n' +
    '          <!--FOURTH TAB - eGeneralDocs for SLO-->\n' +
    '          <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '               class="einv-tab msg-tab-bh-fourth"\n' +
    '               ng-class="{\'selected\': einvoicesOverview.showSubmenuItemType==\'documentsTab\'}"\n' +
    '               ng-click="einvoicesOverview.selectTab(\'documentsTab\', \'eInvoiceOverview.documentsTab\')">\n' +
    '            <a class="ver--align" translate="eInvoiceOverview.documentsTab"></a>\n' +
    '          </div>\n' +
    '          <!--FOURTH TAB - eGeneralDocs for SLO END-->\n' +
    '\n' +
    '          <div class="einv-tab msg-tab-bh"\n' +
    '               ng-class="{\'selected\': einvoicesOverview.showSubmenuItemType==\'listTab\', \'msg-tab-bh-fourth\' : APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'}"\n' +
    '               ng-click="einvoicesOverview.selectTab(\'listTab\', \'eInvoiceRegistration.listOfRegistrations\')">\n' +
    '            <a class="ver--align" translate="eInvoiceRegistration.listOfRegistrations"></a>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- TABS -->\n' +
    '      <div class="row">\n' +
    '      <div class="col-sm-12">\n' +
    '        <div class="bg-white">\n' +
    '          <!--UNPAID TAB-->\n' +
    '            <div  ng-if="einvoicesOverview.showSubmenuItemType == \'unpaidTab\'">\n' +
    '              <!-- eInvoices to pay -->\n' +
    '              <div kcd-recompile="einvoicesOverview.einvoicesListFirstTab.result">\n' +
    '\n' +
    '                <div class="row">\n' +
    '                  <!-- Filter e-invoices to pay by name -->\n' +
    '                  <div ng-if="einvoicesOverview.einvoicesListFirstTab.result.length > 0">\n' +
    '                    <div class="col-sm-12 col-md-12">\n' +
    '                      <div class="row m-5">\n' +
    '                        <div class="col-xs-12"> <h4 translate="eInvoiceOverview.eInvoicesToPay" class="subtitle"></h4></div>\n' +
    '                      </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-5">\n' +
    '                      <div class="row m-5">\n' +
    '                        <div class="col-xs-12">\n' +
    '                          <div class="form-group search-field">\n' +
    '                            <input type="text" class="form-control input-field" data-ng-model="einvoicesOverview.searcheinvoicesToPay.creditorName"\n' +
    '                                   placeholder="{{\'eInvoicesModal.creditorNameSearch\' | translate}}"/>\n' +
    '                            <i class="glyphicon glyphicon-search"></i>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div ng-show="einvoicesOverview.einvoicesListFirstTab.result.length != 0"\n' +
    '                       class="col-sm-12 col-md-12 tab-field"\n' +
    '                       data-ng-repeat="eInvoice in einvoicesOverview.einvoicesListFirstTab.result | filter: einvoicesOverview.searcheinvoicesToPay">\n' +
    '\n' +
    '                    <div class="p-20" data-ng-include="\'e-invoices/e-invoice-detail.tpl.html\'"></div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="einvoicesOverview.einvoicesListFirstTab.result.length == 0 || !einvoicesOverview.einvoicesListFirstTab.result">\n' +
    '                <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                <h3 class="no-data-label" translate="eInvoicesModal.noAvailableEInvoices"></h3>\n' +
    '              </div>\n' +
    '              <br/>\n' +
    '              <div class="show-more-btn ">\n' +
    '                <button ng-show="einvoicesOverview.einvoicesListFirstTab.hasMore == true"\n' +
    '                        data-ng-click="einvoicesOverview.loadMoreEinvoicesFirstTab(false)"\n' +
    '                        type="input"\n' +
    '                        class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                        translate="eInvoicesModal.loadMoreEinvoices"></button>\n' +
    '              </div>\n' +
    '              <div class="clear"></div>\n' +
    '            </div>\n' +
    '          <!--UNPAID TAB END-->\n' +
    '\n' +
    '          <!--PROCESSED TAB-->\n' +
    '            <div ng-if="einvoicesOverview.showSubmenuItemType == \'processedTab\'">\n' +
    '              <!-- eInvoices to pay -->\n' +
    '              <div kcd-recompile="einvoicesOverview.einvoicesListSecondTab.result">\n' +
    '\n' +
    '                <div class="row">\n' +
    '\n' +
    '                  <!-- Status filter -->\n' +
    '                  <div class="col-xs-6 col-xs-offset-6">\n' +
    '                    <div class="dropdown acc-period-select m-30 pull-right" style="display: inline-block">\n' +
    '                      <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"\n' +
    '                              aria-haspopup="true" aria-expanded="true">\n' +
    '                        {{einvoicesOverview.processedFilter.item.description | translate}}\n' +
    '                        <span class="caret"></span>\n' +
    '                      </button>\n' +
    '                      <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                        <li data-ng-repeat="filter in einvoicesOverview.processedFilterList">\n' +
    '                          <a href="" class="f-13" data-ng-click="einvoicesOverview.processedFilterChange(filter)">\n' +
    '                            {{filter.item.description | translate}}\n' +
    '                          </a>\n' +
    '                        </li>\n' +
    '                      </ul>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-sm-12 col-md-12 col-xs-12 tab-field"\n' +
    '                       data-ng-repeat="eInvoice in einvoicesOverview.einvoicesListSecondTab.result"\n' +
    '                       ng-show="einvoicesOverview.einvoicesListSecondTab.result.length != 0">\n' +
    '\n' +
    '                    <div class="p-20" data-ng-include="\'e-invoices/e-invoice-detail.tpl.html\'"></div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="einvoicesOverview.einvoicesListSecondTab.result.length == 0 || !einvoicesOverview.einvoicesListSecondTab.result">\n' +
    '                <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                <h3 class="no-data-label" translate="eInvoicesModal.noAvailableEInvoices"></h3>\n' +
    '              </div>\n' +
    '              <br/>\n' +
    '              <div class="show-more-btn ">\n' +
    '                <button ng-show="einvoicesOverview.einvoicesListSecondTab.hasMore == true"\n' +
    '                        data-ng-click="einvoicesOverview.loadMoreEinvoicesSecondTab(false)"\n' +
    '                        type="input"\n' +
    '                        class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                        translate="eInvoicesModal.loadMoreEinvoices"></button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          <!--PROCESSED TAB END -->\n' +
    '\n' +
    '          <!--LIST OF REGISTRATION TAB-->\n' +
    '            <div ng-if="einvoicesOverview.showSubmenuItemType == \'listTab\'">\n' +
    '              <div kcd-recompile="einvoicesOverview.registrationsListActive.result">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-6 col-xs-offset-6">\n' +
    '                    <div class="dropdown acc-period-select m-30 pull-right" style="display: inline-block">\n' +
    '                      <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"\n' +
    '                              aria-haspopup="true" aria-expanded="true">\n' +
    '                        {{einvoicesOverview.processedRegsFilter.item.description | translate}}\n' +
    '                        <span class="caret"></span>\n' +
    '                      </button>\n' +
    '                      <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                        <li data-ng-repeat="filter in einvoicesOverview.processedRegsFilterList">\n' +
    '                          <a href="" class="f-13" data-ng-click="einvoicesOverview.processedRegsFilterChange(filter)">{{filter.item.description | translate}}</a>\n' +
    '                        </li>\n' +
    '                      </ul>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-12 col-md-12 tab-field"\n' +
    '                       data-ng-repeat="registration in einvoicesOverview.registrationsListActive.result"\n' +
    '                       ng-show="einvoicesOverview.registrationsListActive.result.length != 0">\n' +
    '\n' +
    '                    <div class="p-20" data-ng-include="\'e-invoices/e-invoice-registration-detail.tpl.html\'"></div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="einvoicesOverview.registrationsListActive.result.length == 0 || !einvoicesOverview.registrationsListActive.result">\n' +
    '                <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '                <h3 class="no-data-label" translate="eInvoicesModal.noData"></h3>\n' +
    '              </div>\n' +
    '              <br/>\n' +
    '              <div class="show-more-btn ">\n' +
    '                <button ng-show="einvoicesOverview.registrationsListActive.hasMore == true"\n' +
    '                        data-ng-click="einvoicesOverview.loadMoreEinvoicesThirdTab(false)"\n' +
    '                        type="input"\n' +
    '                        class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                        translate="eInvoicesModal.loadMoreRegistrationsDeregistrations"></button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          <!--LIST OF REGISTRATION TAB END-->\n' +
    '\n' +
    '          <!-- DOCUMENTS TAB START -->\n' +
    '          <div ng-if="einvoicesOverview.showSubmenuItemType == \'documentsTab\'">\n' +
    '            <div kcd-recompile="einvoicesOverview.documentsListTab.result">\n' +
    '              <div class="row">\n' +
    '                <div ng-if="einvoicesOverview.documentsListTab.result.length > 0">\n' +
    '\n' +
    '                  <div class="col-sm-5 p-t-30">\n' +
    '                    <div class="row m-5">\n' +
    '                      <div class="col-xs-12">\n' +
    '                        <div class="form-group search-field">\n' +
    '                          <input type="text" class="form-control input-field" data-ng-model="einvoicesOverview.searchEDocumentToPay.creditorName"\n' +
    '                                 placeholder="{{\'eInvoicesModal.creditorNameSearch\' | translate}}"/>\n' +
    '                          <i class="glyphicon glyphicon-search"></i>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="col-sm-12 col-md-12 tab-field"\n' +
    '                     data-ng-repeat="eDocument in einvoicesOverview.documentsListTab.result  | filter: einvoicesOverview.searchEDocumentToPay"\n' +
    '                     ng-show="einvoicesOverview.documentsListTab.result.length != 0">\n' +
    '\n' +
    '                  <div class="p-20" data-ng-include="\'e-invoices/e-document-details.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="einvoicesOverview.documentsListTab.result.length == 0 || !einvoicesOverview.documentsListTab.result">\n' +
    '              <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '              <h3 class="no-data-label" translate="eInvoicesModal.noData"></h3>\n' +
    '            </div>\n' +
    '            <br/>\n' +
    '            <div class="show-more-btn ">\n' +
    '              <button ng-show="einvoicesOverview.documentsListTab.hasMore == true"\n' +
    '                      data-ng-click="einvoicesOverview.loadMoreEInvoicesFourthTab(false)"\n' +
    '                      type="input"\n' +
    '                      class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                      translate="eInvoicesModal.loadMoreRegistrationsDeregistrations"></button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- DOCUMENTS TAB END -->\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      </div>\n' +
    '      <!-- TABS END -->\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/einvoices-issuers-overview.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div class="row">\n' +
    '      <!-- LEFT -->\n' +
    '      <div class="col-sm-4 no-padding-on-phone">\n' +
    '        <div class="wb-list-wrapper app-white-card m-b-15">\n' +
    '          <div>\n' +
    '            <div class="cell-display">\n' +
    '              <i class="zmdi zmdi-chevron-left zmdi-hc-2x"></i>\n' +
    '            </div>\n' +
    '            <div class="cell-display p-l-20 align-vertical-middle">\n' +
    '              <a href="" class="custom-link" data-ng-click="einvoicesIssuersOverview.goBack();" translate="eInvoiceDetail.goBack"></a>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="app-white-card m-b-15 white-card-einvoice">\n' +
    '          <div class="cell-display align-vertical-middle p-l-15 p-r-15">\n' +
    '            <a href="" class="custom-link-16 custom-link" translate="eInvoicesIssuersOverview.submittedApplications"></a>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="app-white-card m-b-15 white-card-einvoice">\n' +
    '          <p class="p-t-10 p-r-10 p-l-10">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Suscipit, ab! Sunt dolores est ullam modi accusamus, iusto esse molestiae, cumque nihil doloremque? Modi quae, necessitatibus explicabo autem error sunt iusto. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Suscipit, ab! Sunt dolores est ullam modi accusamus, iusto esse molestiae, cumque nihil doloremque? Modi quae, necessitatibus explicabo autem error sunt iusto\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--CENTER-->\n' +
    '      <div class="col-md-8 col-sm-8 col-xs-12 white-card p-l-0 p-r-0">\n' +
    '        <div class="header-card row no-margin header-issuer">\n' +
    '          <b translate="eInvoicesIssuersOverview.header"></b>\n' +
    '        </div>\n' +
    '        <div class="col-md-6 col-sm-12 col-xs-12 issue-div">\n' +
    '          <span class="col-md-12 col-sm-4 col-xs-6 issue-label" translate="eInvoicesIssuersOverview.issuerName"><b></b></span>\n' +
    '\n' +
    '          <div class="col-md-10 col-sm-12 col-xs-12 input-group name-search">\n' +
    '            <div class="input-group-btn srch-icon">\n' +
    '              <button class="btn btn-default btn-search" type="submit">\n' +
    '                <i class="glyphicon glyphicon-search"></i>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <input type="text" class="form-control srch-input acc-search-input" ng-model="einvoicesIssuersOverview.einvoicesIssuersSearchFilter.searchByName.name" placeholder="{{\'eInvoicesIssuersOverview.searchByNamePlaceholder\' | translate}}" name="srch-term" id="srch-term">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-6 col-sm-12 col-xs-12 issue-div">\n' +
    '          <span class="col-md-12 col-sm-4 col-xs-6 issue-label" translate="eInvoicesIssuersOverview.issuerTaxId"><b></b></span>\n' +
    '\n' +
    '          <div class="col-md-10 col-sm-12 col-xs-12 input-group name-search m-b-5 ">\n' +
    '            <div class="input-group-btn srch-icon">\n' +
    '              <button class="btn btn-default btn-search" type="submit">\n' +
    '                <i class="glyphicon glyphicon-search"></i>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <input type="text" class="form-control srch-input acc-search-input" ng-model="einvoicesIssuersOverview.einvoicesIssuersSearchFilter.searchById.identificationNumber" placeholder="{{\'eInvoicesIssuersOverview.searchByTaxIdPlaceholder\' | translate}}" name="srch-term" id="srch-term">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-hide="einvoicesIssuersOverview.einvoicesIssuersList.result.length == 0">\n' +
    '          <div class="hidden-xs col-md-12">\n' +
    '            <div class="col-md-5 col-sm-4 col-xs-12 issuer-name-label" translate="eInvoicesIssuersOverview.issuerName">Issuer name</div>\n' +
    '            <div class="col-md-5 col-sm-5 col-xs-12 issuer-taxID-label" translate="eInvoicesIssuersOverview.issuerTax">Tax ID / Account</div>\n' +
    '            <div class="col-md-2 col-sm-3 col-xs-12 issuer-button-label"></div>\n' +
    '            <div class="col-md-12">\n' +
    '              <hr/> </div>\n' +
    '          </div>\n' +
    '          <div kcd-recompile="einvoicesIssuersOverview.einvoicesIssuersList.result">\n' +
    '            <div class="col-md-12 " ng-repeat="issuer in ::einvoicesIssuersOverview.einvoicesIssuersList.result | filter:einvoicesIssuersOverview.einvoicesIssuersSearchFilter.searchByName | filter:einvoicesIssuersOverview.einvoicesIssuersSearchFilter.searchById">\n' +
    '              <div class="col-md-5 col-xs-12 issuer-name-value"><b>{{::issuer.name}}</b></div>\n' +
    '              <div class="col-md-5 col-xs-12 issuer-taxID-value">{{::issuer.identificationNumber}}\n' +
    '                <br/>{{::issuer.iban}}</div>\n' +
    '              <div class="col-md-2 col-xs-12 issuer-button-value">\n' +
    '                <button class="btn btn-default app-btn-blue pull-right btn-sm" translate="eInvoicesIssuersOverview.subscribe" data-ui-sref="eInvoices.einvoiceSubscribe({issuerId: issuer.id})">Subscribe</button>\n' +
    '              </div>\n' +
    '              <div class="col-md-12 col-sm-12 col-xs-12">\n' +
    '                <hr/>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="t-a-c p-10 m-t-20 no-data-image" ng-show="einvoicesIssuersOverview.einvoicesIssuersList.result.length == 0">\n' +
    '          <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '          <h3 class="no-data-label" translate="eInvoicesIssuersOverview.noData"></h3>\n' +
    '        </div>\n' +
    '        <div class="col-md-4 col-sm-4 col-xs-3"></div>\n' +
    '        <div class="col-md-4 col-sm-4 col-xs-5 load-more-issuers">\n' +
    '          <button ng-hide="einvoicesIssuersOverview.einvoicesIssuersList.hasMore == false" data-ng-click="einvoicesIssuersOverview.loadMoreIssuers()" type="input" class="btn btn-default app-btn-blue-inverse " translate="eInvoicesIssuersOverview.showMore">Show more issuers</button>\n' +
    '        </div>\n' +
    '        <div class="col-md-4 col-sm-4 col-xs-4"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/einvoice-subscribe.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div class="row f-14">\n' +
    '      <div class="col-sm-4 no-padding-on-phone">\n' +
    '\n' +
    '        <div class="wb-list-wrapper app-white-card m-b-15">\n' +
    '          <div>\n' +
    '            <div class="cell-display">\n' +
    '              <i class="zmdi zmdi-chevron-left zmdi-hc-2x"></i>\n' +
    '            </div>\n' +
    '            <div class="cell-display p-l-20 align-vertical-middle">\n' +
    '              <a href="" data-ng-click="einvoiceSubscribe.goBack();" class="custom-link" translate="eInvoicesSubscribe.goBack"></a>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="wb-list-wrapper app-white-card m-b-15 hidden-xs">\n' +
    '          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- CENTER -->\n' +
    '      <div class="col-sm-8 no-padding-on-phone">\n' +
    '        <div class="app-white-card m-b-15">\n' +
    '          <div class="sbscr-header-wrapper bottom-border">\n' +
    '            <div class="sbscr-header-card row no-margin ">\n' +
    '              <h2 class="col-md-8 header-label" translate="eInvoicesSubscribe.subscribeToEinvoice"></h2>\n' +
    '\n' +
    '              <div class="col-md-4 col-xs-4">\n' +
    '                <h2>\n' +
    '                  <span class="sbscr-step-icon pull-right">\n' +
    '                    <i class="zmdi zmdi-circle"\n' +
    '                       ng-class="{\'sbscr-active-step\': einvoiceSubscribe.steps.step1}"></i>\n' +
    '                    <i class="zmdi zmdi-circle"\n' +
    '                       ng-class="{\'sbscr-active-step\': einvoiceSubscribe.steps.step2}"></i>\n' +
    '                    <i class="zmdi zmdi-circle"\n' +
    '                       ng-class="{\'sbscr-active-step\': einvoiceSubscribe.steps.step3}"></i>\n' +
    '                  </span>\n' +
    '                </h2>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="sbscr-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</div>\n' +
    '          <div ng-show="einvoiceSubscribe.steps.step1">\n' +
    '            <form name="einvoiceSubscribe.einvoiceSubscribeForm" novalidate>\n' +
    '              <div class="sbscr-form-container light-bcg bottom-border">\n' +
    '                <div>\n' +
    '                  <div class="row" data-ng-repeat="error in einvoiceSubscribe.customErrorLabels">\n' +
    '                    <div class="col-sm-6">\n' +
    '                      <div class="c-red">{{error}}</div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <!-- ISSUER-->\n' +
    '                <div class="row m-l-0">\n' +
    '                  <div class="col-md-4 col-sm-6 p-l-0 sbscr-sbttl-blue">\n' +
    '                    <div class="p-l-10" > <h4 class="sbscr-sbttl" translate="eInvoicesSubscribe.einvoiceIssuer"></h4>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-md-8"></div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="sbscr-group-label sbscr-label-height" translate="eInvoicesSubscribe.einvoiceIssuer">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6 sbscr-label-value">{{einvoiceSubscribe.issuerObject.name}}</div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="sbscr-group-label intp-label-height" translate="eInvoicesSubscribe.issuerAddress">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6 sbscr-label-value">Adresa</div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="sbscr-group-label intp-label-height" translate="eInvoicesSubscribe.issuerAccount">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6 sbscr-label-value">{{einvoiceSubscribe.issuerObject.iban}}</div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-5 col-md-5">\n' +
    '                    <div class="sbscr-group-label intp-label-height" translate="eInvoicesSubscribe.referenceFromIssuer">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-1 col-xs-1 col-md-1 p-r-0">\n' +
    '                    <span class="pull-right" uib-tooltip="{{\'eInvoicesSubscribe.tooltipInfo\' | translate}}">\n' +
    '                      <i class="zmdi zmdi-help-outline zmdi-hc-lg"></i>\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="form-group">\n' +
    '                      <input type="text" class="form-control" name="einvoiceReferenceFromIssuerInput"\n' +
    '                             data-ng-model="einvoiceSubscribe.tempObj.einvoiceReferenceFromIssuerInput"\n' +
    '                             data-ng-class="{\'domp-error\': einvoiceSubscribe.einvoiceSubscribeForm.einvoiceReferenceFromIssuerInput.$invalid && einvoiceSubscribe.tempObj.formSubmitted}"\n' +
    '                             required>\n' +
    '                      <span class="c-red"\n' +
    '                            ng-show="eInvoicesSubscribe.einvoiceSubscribeForm.einvoiceReferenceFromIssuerInput.$error.required && einvoiceSubscribe.tempObj.formSubmitted"\n' +
    '                            translate="eInvoicesSubscribe.einvoiceReferenceFromIssuerInputError"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <!-- RECEIVER-->\n' +
    '                <div class="row m-l-0">\n' +
    '                  <div class="col-md-4 col-sm-6 p-l-0 sbscr-sbttl-blue">\n' +
    '                    <div class="p-l-10"> <h4 class="sbscr-sbttl" translate="eInvoicesSubscribe.einvoiceReceiver"></h4>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-md-8"></div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="sbscr-group-label sbscr-label-height" translate="eInvoicesSubscribe.receiversName">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="sbscr-label-value">{{einvoiceSubscribe.userSettings.result[0].firstName}} {{einvoiceSubscribe.userSettings.result[0].lastName}}</div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="sbscr-group-label intp-label-height" translate="eInvoicesSubscribe.receiversAddress">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6 sbscr-label-value">{{einvoiceSubscribe.userSettings.result[0].address1}}</div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="sbscr-group-label intp-label-height" translate="eInvoicesSubscribe.receiversTaxId">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6 sbscr-label-value">{{einvoiceSubscribe.userSettings.result[0].identificationNumber}}</div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-5 col-md-5">\n' +
    '                    <div class="sbscr-group-label intp-label-height" translate="eInvoicesSubscribe.yourContactEmail">\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-1 col-xs-1 col-md-1 p-r-0">\n' +
    '                    <span class="pull-right" uib-tooltip="{{\'eInvoicesSubscribe.tooltipInfoEmail\' | translate}}">\n' +
    '                    <i class="zmdi zmdi-help-outline zmdi-hc-lg"></i>\n' +
    '                  </span>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-6">\n' +
    '                    <div class="form-group">\n' +
    '                      <input type="text" class="form-control disabled" name="einvoiceSubscribeEmailInput"\n' +
    '                             data-ng-model="einvoiceSubscribe.tempObj.einvoiceSubscribeEmailInput"\n' +
    '                             data-ng-class="{\'domp-error\': eInvoicesSubscribe.einvoiceSubscribeForm.einvoiceSubscribeEmailInput.$invalid && einvoiceSubscribe.tempObj.formSubmitted}"\n' +
    '                             ng-disabled="einvoiceSubscribe.changeEmailButton" required>\n' +
    '                      <span class="c-red"\n' +
    '                            ng-show="eInvoicesSubscribe.einvoiceSubscribeForm.einvoiceSubscribeEmailInput.$error.required && einvoiceSubscribe.tempObj.formSubmitted"\n' +
    '                            translate="eInvoicesSubscribe.einvoiceSubscribeEmailInputError"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-md-8">\n' +
    '                    <label class="checkbox checkbox-inline-inline ebrm-checkbox-value">\n' +
    '                      <input type="checkbox" ng-model="einvoiceSubscribe.tempObj.userApproves">\n' +
    '                      <span class="input-helper terms-label"><a href="" target="_blank" translate="eInvoicesSubscribe.termsAndConditions"></a></span>\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '                  <div class="col-md-4" ng-show="einvoiceSubscribe.changeEmailButton">\n' +
    '                    <button class="btn btn-primary app-btn-blue pull-right" data-ng-model="einvoiceSubscribe.changeEmailButton" data-ng-click="einvoiceSubscribe.changeEmail()" translate="eInvoicesSubscribe.changeEmail">Change email</button>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <div class="col-md-3 reset-btn" ng-show="!einvoiceSubscribe.changeEmailButton">\n' +
    '                    <button class="btn btn-primary app-btn-blue pull-right" data-ng-model="einvoiceSubscribe.changeEmailButton" data-ng-click="einvoiceSubscribe.changeEmailCancel()" translate="eInvoicesSubscribe.cancel">Cancel</button>\n' +
    '                  </div>\n' +
    '                  <div class="col-md-1" ng-show="!einvoiceSubscribe.changeEmailButton">\n' +
    '                    <button class="btn btn-primary app-btn-blue pull-right" data-ng-model="einvoiceSubscribe.changeEmailButton" data-ng-click="einvoiceSubscribe.changeEmailOk()" translate="eInvoicesSubscribe.ok">OK</button>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                  <div class="col-md-8" ng-show="einvoiceSubscribe.specialConditionsApprovementVisible">\n' +
    '                    <label class="checkbox checkbox-inline-inline ebrm-checkbox-value">\n' +
    '                      <input type="checkbox">\n' +
    '                      <span class="input-helper terms-label"><a href="" target="_blank" translate="eInvoicesSubscribe.specialConditions"></a></span>\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="intp-form-container">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-sm-12 text-center">\n' +
    '                    <button class="btn btn-primary app-btn-blue domp-review-and-submit-btn main-form-btn" data-ng-click="einvoiceSubscribe.einvoiceSubscribeSubmit()" translate="eInvoicesSubscribe.reviewandSubmit">\n' +
    '                    </button>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </form>\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-show="internalTransfer.steps.step2">\n' +
    '            <div data-ng-include="\'payments/internal-transfer-resume.tpl.html\'">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-show="internalTransfer.steps.step3">\n' +
    '            <payment-final-step payment="internalTransfer.paymentResponse" is-modal="false"></payment-final-step>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/e-invoices-pay.tpl.html',
    '<section id="main">\n' +
    '\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="domp-header-wrapper" ng-show="vm.step === \'pay\' ||  vm.step === \'verify\'">\n' +
    '            <div class="domp-header-row">\n' +
    '                <h2 class="f-28" translate="eInvoicesModal.headerLabel">E-Invoice Payment</h2>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- PAYMENT STEP -->\n' +
    '        <div class="row domp-body-wrapper p-10" ng-if="vm.step === \'pay\'">\n' +
    '            <form novalidate name="vm.paymentForm">\n' +
    '                  <div class="col-sm-12 domp-from-section">\n' +
    '                    <div class="col-sm-12">\n' +
    '\n' +
    '                            <div class="row">\n' +
    '                                <!-- CUSTOM ACCOUNTS DROPDOWN -->\n' +
    '                                <div class="col-sm-6 domp-acc-dropdown">\n' +
    '                                    <label class="domp-form-label" for="issuer" translate="payments.fromAccount"></label>\n' +
    '                                    <div class="accounts-dropdown">\n' +
    '                                        <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="vm.fromAccountDropdown = !vm.fromAccountDropdown" ng-style="vm.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + vm.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                      <b class="col-xs-10 p-0 m-t-10  no-wrap-text">  {{vm.fromAccountSelect.friendlyName}} </b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                    </span>\n' +
    '                  </h4>\n' +
    '                                            <p class="m-b-0 m-t-0 iban-style">{{vm.fromAccountSelect.iban | formatIban}}</p>\n' +
    '                                            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                {{vm.fromAccountSelect.availableBalance| number:2}} {{vm.fromAccountSelect.currencySymbol}}\n' +
    '                                            </p>\n' +
    '                                            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                            <span class="caret-icon"><i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i></span>\n' +
    '                                        </div>\n' +
    '                                        <div class="from-accounts-list m-l-0" ng-show="vm.fromAccountDropdown" scrollable>\n' +
    '                                            <div class="accounts-list-item p-0" data-ng-repeat="item in vm.paymentTypeGroupDomestic.result[0].debitAccountList" data-ng-click="vm.setAccountFrom(item);">\n' +
    '\n' +
    '                                                <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                        </h4>\n' +
    '                                                    <p class="m-b-0 m-t-0 iban-style">{{item.iban | formatIban}}</p>\n' +
    '                                                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                        {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                                                    </p>\n' +
    '                                                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                </div>\n' +
    '\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <div class="row">\n' +
    '                                        <div class="col-sm-12">\n' +
    '                                            <div class="form-group">\n' +
    '                                                <label class="domp-form-label" for="referenceNumber" translate="domesticPayment.amountInputLabel"></label>\n' +
    '                                                <div class="input-group">\n' +
    '                                                    <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput" placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask maxlength="12" ng-model="vm.amountInput" required ng-class="{\'domp-error\': vm.paymentForm.amountInput.$invalid && vm.formSubmitted}" readonly />\n' +
    '                                                    <span class="input-group-btn">\n' +
    '                        <button type="button" class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" ng-if="vm.countryCode != \'sr\'" style="border:1px solid #062a42;">\n' +
    '                          {{vm.defaultCurrency}}\n' +
    '                        </button>\n' +
    '                      </span>\n' +
    '                                                </div>\n' +
    '                                                <span class="c-red" ng-show="vm.paymentForm.amountInput.$error.required && vm.formSubmitted" translate="internalTransfer.amountInputError"></span>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                    <div class="row">\n' +
    '                                        <div class="col-sm-6">\n' +
    '                                            <div class="form-group">\n' +
    '                                                <label class="domp-form-label" for="dateInput" translate="domesticPayment.dateInputLabel">Date:</label>\n' +
    '                                                <div class="input-group ">\n' +
    '                                                    <input type="text" class="form-control input-field" name="dateInput" id="dateInput" date-disabled="vm.disabled(date, mode)" uib-datepicker-popup="shortDate" data-ng-model="vm.dateInput" show-weeks="false" is-open="vm.datePickerOpened" datepicker-options="vm.dateOptions" readonly>\n' +
    '                                                    <span class="input-group-btn">\n' +
    '                        <button data-ng-click="vm.datePickerOpened = !vm.datePickerOpened" type="button" class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                        </button>\n' +
    '                      </span>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                 <div class="row">\n' +
    '                    <div class="col-sm-12">\n' +
    '                        <div class="col-sm-12 receiver-section">\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <p>\n' +
    '                                        <span class="invoice-inline-title text-muted"><b translate="eInvoicePayment.accNumber">Account number</b></span>\n' +
    '                                        <b><span ng-show="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\'">\n' +
    '                                            <span ng-if="vm.invoice.iban">{{vm.invoice.iban}}</span>\n' +
    '                                            <span ng-if="!vm.invoice.iban">{{vm.invoice.creditorBank}} - {{vm.invoice.creditorAccount}}</span>\n' +
    '                                          </span></b>\n' +
    '                                        <b><span ng-show="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">{{vm.invoice.creditorAccount}}</span></b>\n' +
    '                                    </p>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6" ng-if="vm.invoice.creditorName">\n' +
    '                                    <p>\n' +
    '                                        <span class="invoice-inline-title text-muted"><b translate="eInvoicePayment.toPayee">To payee</b></span>\n' +
    '                                        <b>{{vm.invoice.creditorName}}</b>\n' +
    '                                    </p>\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row" ng-if="vm.invoice.creditorAddress">\n' +
    '\n' +
    '                                <div class="col-sm-6"></div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <p>\n' +
    '                                        <span class="invoice-inline-title text-muted"><b translate="eInvoicePayment.recAddress">Receiver\'s address</b></span>\n' +
    '                                        <b>{{vm.invoice.creditorAddress}}</b>\n' +
    '                                    </p>\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row" ng-if="vm.invoice.creditorCity">\n' +
    '                                <div class="col-sm-6"></div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <p>\n' +
    '                                        <span class="invoice-inline-title text-muted"><b translate="eInvoicePayment.recPostalCity">Receiver\'s postal code and city</b></span>\n' +
    '                                        <b>{{vm.invoice.creditorCity}}</b>\n' +
    '                                    </p>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                    <div class="col-sm-12">\n' +
    '                        <div class="col-sm-12 receiver-section">\n' +
    '                            <div class="row">\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <p>\n' +
    '                                        <span class="invoice-inline-title text-muted"><b translate="eInvoicePayment.purpose">Purpose</b></span>\n' +
    '                                        <input type="text" class="form-control"\n' +
    '                                               data-ng-model="vm.invoice.purpose" maxlength="140">\n' +
    '                                    </p>\n' +
    '                                </div>\n' +
    '                                <div class="col-sm-6">\n' +
    '                                    <p>\n' +
    '                                        <span class="invoice-inline-title text-muted"><b translate="eInvoicesModal.refNumberLabel"></b></span>\n' +
    '                                        <b>{{vm.invoice.paymentReferenceNumber}}</b>\n' +
    '                                    </p>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                    <div class="col-sm-12">\n' +
    '                        <div class="col-sm-12 receiver-section">\n' +
    '                          <div class="row">\n' +
    '                              <div class="col-sm-6" ng-if="vm.invoice.status === \'Archived\' || vm.invoice.status === \'Rejected\'">\n' +
    '                                    <p>\n' +
    '                                      <span class="invoice-inline-title text-muted">\n' +
    '                                        <b translate="eInvoiceDetail.noteArchive" ng-if="vm.invoice.status === \'Archived\'"></b>\n' +
    '                                        <b translate="eInvoiceDetail.noteRejected" ng-if="vm.invoice.status === \'Rejected\'"></b>\n' +
    '                                      </span>\n' +
    '                                      <b>{{vm.invoice.userComment}}</b>\n' +
    '                                    </p>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '\n' +
    '                            <div ng-if="vm.countryCode != \'sl\'" class="row">\n' +
    '                                <div class="col-sm-12 pull-right text-right charges-label">\n' +
    '                                    <a ng-href="{{vm.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges" class="pull-right">Check the bank\n' +
    '                    charges</a>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '              <section ng-if="vm.countryCode == \'sl\'" class="row p-t-30">\n' +
    '\n' +
    '                <div class="col-xs-12 col-sm-2 p-l-30">\n' +
    '                  <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value" ng-if="vm.hideUrgency === false">\n' +
    '                    <input type="checkbox"\n' +
    '                           ng-change="vm.showInfo();"\n' +
    '                           ng-model="vm.isUrgentPaymentCheckbox">\n' +
    '                    <i class="input-helper"></i>\n' +
    '                    <span uib-tooltip="{{\'domesticPayment.urgentPaymentInfo\'| translate}}"\n' +
    '                          tooltip-append-to-body="true" tooltip-trigger="mouseenter"\n' +
    '                          tooltip-placement="top">{{\'domesticPayment.selectUrgentLabelSLO\'| translate}}\n' +
    '                    </span>\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '                <div class="col-xs-12 col-sm-4 p-l-30" style="line-height: 39px;">\n' +
    '                  <a class="underline pull-right" ng-href="{{vm.defaultData.ProvisionLink}}" target="_blank" translate="domesticPayment.timetableForProvisionLink">\n' +
    '                    Check the bank charges\n' +
    '                  </a>\n' +
    '                </div>\n' +
    '                <div class="col-xs-12 col-sm-3 p-l-30 " style="line-height: 39px;">\n' +
    '                  <a class="underline" ng-href="{{vm.defaultData.SepaCodesLink}}" target="_blank" translate="domesticPayment.SEPAcodesLink">\n' +
    '                  </a>\n' +
    '                </div>\n' +
    '                <div class="col-xs-12 col-sm-3 p-l-30 " style="line-height: 39px;">\n' +
    '                  <a class="underline" ng-href="{{vm.defaultData.BankChargesLink}}" target="_blank" translate="domesticPayment.checkBankCharges">\n' +
    '                  </a>\n' +
    '                </div>\n' +
    '              </section>\n' +
    '              <div class="row m-t-10">\n' +
    '                <div class="col-xs-6 t-a-l">\n' +
    '                  <button class="btn btn-primary" translate="payments.cancel"\n' +
    '                          ng-click="vm.goBack()">\n' +
    '                  </button>\n' +
    '                </div>\n' +
    '                <div class="col-xs-6 t-a-r">\n' +
    '                  <button ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" class="btn btn-default app-btn-blue pull-right domp-review-and-submit-btn"\n' +
    '                          ng-click="vm.confirmPayment()" translate="domesticPayment.confirmBtn"></button>\n' +
    '                  <button ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="btn btn-default app-btn-blue pull-right domp-review-and-submit-btn"\n' +
    '                          ng-click="vm.confirmPayment()" translate="domesticPayment.confirmBtnSlo" ng-disabled="vm.validateInProgress || vm.secondValidationInProgress"></button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </form>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- VERIFY PAYMENT STEP -->\n' +
    '        <div ng-if="vm.step === \'verify\'">\n' +
    '            <div data-ng-include="\'e-invoices/einvoices-payment-resume.tpl.html\'" />\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- FINAL STEP -->\n' +
    '        <div class="row domp-body-wrapper p-10" ng-if="vm.step === \'final\'">\n' +
    '\n' +
    '            <div class="container status-container status-border">\n' +
    '                <div class="row vertical-align">\n' +
    '                    <div class="col-sm-1 text-right">\n' +
    '                        <span class="glyphicon glyphicon-ok"></span>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-sm-11 ">\n' +
    '                        <h2>E-invoice successfully paid</h2> You have successfully payed the E-invoice.\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '            <br/>\n' +
    '            <br/>\n' +
    '            <a href="#!e-invoices/overview">Go to e-invoice list</a>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/e-invoices-modal.tpl.html',
    '<div class="p-l-15 p-r-15 f-14" ng-hide="eInvoicesModal.signSuccess">\n' +
    '  <div class="row eim-header p-10 bottom-border">\n' +
    '    <b class="f-18 p-l-10" translate="eInvoicesModal.headerLabel">E-Invoice Payment</b>\n' +
    '    <i class="zmdi zmdi-close zmdi-hc-2x pull-right pointer-cst eim-header-btn-close" data-ng-click="eInvoicesModal.closeModal();"></i>\n' +
    '  </div>\n' +
    '  <div class="row p-10 bottom-border">\n' +
    '    <form name="eInvoicePaymentForm">\n' +
    '      <div class="eim-details col-md-12 col-sm-12 no-padding-on-phone">\n' +
    '        <div class="form-group col-md-6 col-sm-6 p-l-0">\n' +
    '          <label class="eim-label" translate="eInvoicesModal.issuerLabel">Issuer:</label>\n' +
    '          <br>\n' +
    '          <div class="eim-value-label">{{eInvoicesModal.eInvoiceObject.creditorName}}</div>\n' +
    '          <div class="eim-value-label">{{eInvoicesModal.eInvoiceObject.creditorCity}}</div>\n' +
    '        </div>\n' +
    '        <div class="form-group col-md-6 col-sm-6 p-r-0">\n' +
    '          <label class="eim-label" translate="eInvoicesModal.purposeLabel">Purpose:</label>\n' +
    '          <br>\n' +
    '          <div class="eim-value-label">{{eInvoicesModal.eInvoiceObject.purpose}}</div>\n' +
    '        </div>\n' +
    '        <div class="form-group">\n' +
    '          <div class="cell-display col-md-6 col-sm-6 p-l-0">\n' +
    '            <label class="eim-label" translate="eInvoicesModal.amountLabel ">Amount:</label>\n' +
    '            <br>\n' +
    '            <div class="input-group">\n' +
    '              <input type="text" class="form-control t-a-r" data-ng-model="eInvoicesModal.tempDompObj.amount" name="amount" id="amount" placeholder="{{\'eInvoicesModal.amountPlaceholder\'| translate}}" amount-input-mask required ng-class="{\'domp-error\': eInvoicePaymentForm.amount.$invalid}">\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button" class="btn btn-default input-group-app-btn disabled">{{eInvoicesModal.eInvoiceObject.currencySymbol}}</button>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="form-group">\n' +
    '          <div class="cell-display col-md-6 col-sm-6 p-r-0">\n' +
    '            <label class="eim-label" translate="eInvoicesModal.refNumberLabel ">Reference number:</label>\n' +
    '            <br>\n' +
    '            <div class="eim-value-label">{{eInvoicesModal.eInvoiceObject.paymentReferenceNumber}}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="eim-instruction col-md-12 col-sm-12">\n' +
    '        <b translate="eInvoicesModal.instructionLabel">Select payment date and confirm payment</b>\n' +
    '      </div>\n' +
    '      <div class="col-md-6 col-sm-6 p-l-10">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" for="fromAccountSelect" translate="eInvoicesModal.fromAccountPayLabel"></label>\n' +
    '          <select class="form-control" name="fromAccountSelect" id="fromAccountSelect" ng-options="option.optionValue for option in eInvoicesModal.paymentTypeGroupDomestic.result[0].debitAccountList" ng-model="eInvoicesModal.tempDompObj.fromAccountSelect"></select>\n' +
    '          <!--    <label class="m-b-0 m-t-0 f-13"><span translate="eInvoicesModal.availableAmountLabel"></span>{{eInvoicesModal.tempDompObj.fromAccountSelect.balance | number:2}} {{eInvoicesModal.tempDompObj.fromAccountSelect.currencySymbol}}</label> -->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6 col-sm-6 p-r-0">\n' +
    '        <div class="form-group">\n' +
    '          <div class="m-b-15 p-l-10">\n' +
    '            <span class="eim-label" translate="eInvoicesModal.paymentDateLabel ">Payment date</span>\n' +
    '          </div>\n' +
    '          <div class="radio-ctn" ng-init="eInvoicesModal.paymentDateOption.val=1">\n' +
    '            <div class="col-md-12 col-sm-12 m-b-10">\n' +
    '              <label class="radio radio-inline m-r-20 radio-value">\n' +
    '                <input type="radio" data-ng-model="eInvoicesModal.paymentDateOption.val" name="paymentDateOptions " value="1">\n' +
    '                <i class="input-helper p-l-5"></i> {{\'eInvoicesModal.today\' | translate}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-md-12 col-sm-12 m-b-10">\n' +
    '              <label class="radio radio-inline m-r-20 radio-value">\n' +
    '                <input type="radio" data-ng-model="eInvoicesModal.paymentDateOption.val" name="paymentDateOptions " value="2">\n' +
    '                <i class="input-helper p-l-5"></i> {{\'eInvoicesModal.dueDate\' | translate}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-md-12 col-sm-12 m-b-10">\n' +
    '              <label class="radio radio-inline m-r-20 radio-value">\n' +
    '                <input type="radio" data-ng-model="eInvoicesModal.paymentDateOption.val" name="paymentDateOptions " value="3">\n' +
    '                <i class="input-helper p-l-5"></i> {{\'eInvoicesModal.otherDate\' | translate}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-md-12 col-sm-12 form-group" ng-if="eInvoicesModal.paymentDateOption.val==3">\n' +
    '            <div class="input-group">\n' +
    '              <input type="text" class="form-control no-border-input" name="dueDateInput" uib-datepicker-popup="shortDate" data-ng-model="eInvoicesModal.tempDompObj.dateInput" show-weeks="false" is-open="eInvoicesModal.datePickerOpened" datepicker-options="eInvoicesModal.dateOptions" required>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button data-ng-click="eInvoicesModal.openDatePicker()" type="button"\n' +
    '                        class="btn btn-default input-group-app-btn"><i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                </button>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </form>\n' +
    '</div>\n' +
    '<div class="row p-10 eim-footer">\n' +
    '  <a href="" class="clickable-link eim-link p-l-10 p-t-10" data-ng-click="eInvoicesModal.goToEInvoiceDetail();">\n' +
    '    <span translate="eInvoicesModal.viewEinvoice"></span>\n' +
    '  </a>\n' +
    '  <div class="eim-btn p-r-5">\n' +
    '    <button class="btn btn-default app-btn-blue ng-scope pull-right eim-action-button" data-ng-click="eInvoicesModal.executePayment(eInvoicesModal.eInvoiceObject); " translate="eInvoicesModal.btnPay ">\n' +
    '      Pay\n' +
    '    </button>\n' +
    '    <button class="btn btn-default app-btn-blue ng-scope pull-right m-r-15 eim-action-button" data-ng-click="eInvoicesModal.closeModal(); " translate="eInvoicesModal.btnCancel ">\n' +
    '      Cancel\n' +
    '    </button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '</div>\n' +
    '<!-- verify and sign -->\n' +
    '<div ng-hide="eInvoicesModal.paymentResponse && !eInvoicesModal.signSuccess" class="f-14">\n' +
    '  <table class="table table-striped">\n' +
    '    <thead>\n' +
    '      <tr>\n' +
    '        <th class="eim-sgn-header p-l-10" colspan="2">\n' +
    '          <b class="f-18" translate="eInvoicesModal.signHeaderLabel"></b>\n' +
    '          <i class="zmdi zmdi-close zmdi-hc-2x pull-right pointer-cst eim-header-btn-close" data-ng-click="eInvoicesModal.closeModal();"></i>\n' +
    '        </th>\n' +
    '      </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.fromAccountNumber">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.fromAccount"></td>\n' +
    '        <td>{{eInvoicesModal.paymentObject.fromAccountNumber}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.toAccountNumber">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.toAccount"></td>\n' +
    '        <td>{{eInvoicesModal.paymentObject.toAccountNumber}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.receiverName">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.receiver"></td>\n' +
    '        <td>{{eInvoicesModal.paymentResponse.receiverName}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.receiverAddress1 && eInvoicesModal.paymentResponse.receiverCity">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.receiverAddress"></td>\n' +
    '        <td>{{eInvoicesModal.paymentResponse.receiverAddress1 + \', \' + eInvoicesModal.paymentResponse.receiverCity}}\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.amount">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.amount"></td>\n' +
    '        <td>{{eInvoicesModal.paymentResponse.amount | currency: ""}} {{eInvoicesModal.paymentResponse.currencySymbol}}\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.purpose">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.description"></td>\n' +
    '        <td>{{eInvoicesModal.paymentResponse.purpose}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.intermediateBankName">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.bankName"></td>\n' +
    '        <td>{{eInvoicesModal.paymentResponse.intermediateBankName}}</td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.intermediateBankAddress">\n' +
    '        <td class="bold-font" translate="eInvoicesModal.bankAddress"></td>\n' +
    '        <td>{{eInvoicesModal.paymentResponse.intermediateBankAddress + \', \' + eInvoicesModal.paymentResponse.intermediateBankAddress2}}\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="eInvoicesModal.paymentResponse.dueDate">\n' +
    '        <td class="bold-font" translate="eInvoiceDetail.dueDate"></td>\n' +
    '        <td>{{eInvoicesModal.paymentResponse.dueDate | date:\'shortDate\'}}</td>\n' +
    '      </tr>\n' +
    '      <tr class="row eim-footer">\n' +
    '        <td class="eim-btn p-r-5">\n' +
    '          <!--<button class="btn btn-default app-btn-blue ng-scope pull-right eim-action-button" data-ng-click="eInvoicesModal.signPayment();" translate="eInvoicesModal.btnSign">-->\n' +
    '          <button class="btn btn-default app-btn-blue ng-scope pull-right eim-action-button" data-ui-sref="payments.sign({paymentId: eInvoicesModal.paymentResponse.id})" translate="eInvoicesModal.btnSign">\n' +
    '            Sign\n' +
    '          </button>\n' +
    '          <button class="btn btn-default app-btn-blue ng-scope pull-right m-r-15 eim-action-button" data-ng-click="eInvoicesModal.goBack();" translate="eInvoicesModal.btnEdit">\n' +
    '            Back\n' +
    '          </button>\n' +
    '          <button class="btn btn-default app-btn-blue ng-scope pull-right m-r-15 eim-action-button" data-ng-click="eInvoicesModal.closeModal(); " translate="eInvoicesModal.btnCancel">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </td>\n' +
    '      </tr>\n' +
    '    </tbody>\n' +
    '  </table>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/e-invoices-detail.tpl.html',
    '<section id="main">\n' +
    '    <div class="container">\n' +
    '        <div class="row f-14">\n' +
    '            <!--<div class="col-sm-4 no-padding-on-phone">\n' +
    '\n' +
    '                <div class="wb-list-wrapper app-white-card m-b-15">\n' +
    '                    <div>\n' +
    '                        <div class="cell-display">\n' +
    '                            <i class="zmdi zmdi-chevron-left zmdi-hc-2x"></i>\n' +
    '                        </div>\n' +
    '                        <div class="cell-display p-l-20 align-vertical-middle">\n' +
    '                            <a href="" data-ng-click="eInvoicesDetail.goBack();" class="custom-link" translate="eInvoiceDetail.goBack"></a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="app-white-card m-b-15 hidden-xs">\n' +
    '                    <div class="header-card">\n' +
    '                        <span translate="eInvoiceDetail.export"></span>\n' +
    '                    </div>\n' +
    '                    <div class="list">\n' +
    '                        <div class="list-item inner-list-el">\n' +
    '                            <a href="" class="cutom-link-title" translate="eInvoiceDetail.eInvoicePDF"></a>\n' +
    '                        </div>\n' +
    '                        <div class="list-item inner-list-el">\n' +
    '                            <a href="" class="cutom-link-title" translate="eInvoiceDetail.eInvoiceXML"></a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="app-white-card m-b-15 hidden-xs">\n' +
    '                    <div class="header-card">\n' +
    '                        <span translate="eInvoiceDetail.attachments"></span>\n' +
    '                    </div>\n' +
    '                    <div class="list">\n' +
    '                        <div class="list-item inner-list-el" ng-if="eInvoicesDetail.eInvoiceDocumentAttachmentList" data-ng-repeat="invoiceAttachment in ::eInvoicesDetail.eInvoiceDocumentAttachmentList">\n' +
    '                            <a href="" class="cutom-link-title">Attachment 1</a>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="list-item inner-list-el t-a-c no-data-image" ng-if="!eInvoicesDetail.eInvoiceDocumentAttachmentList">\n' +
    '                            <i class="zmdi zmdi-cloud-off zmdi-hc-3x"></i>\n' +
    '                            <h6 class="no-data-label" translate="eInvoiceDetail.noAttachments"></h6>\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="app-white-card m-b-15 hidden-xs">\n' +
    '                    <div class="list">\n' +
    '                        <div class="list-item inner-list-el">\n' +
    '                            <a href="" class="cutom-link-title" translate="eInvoiceDetail.unsubscribeEInvoices"></a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>-->\n' +
    '            <div class="col-sm-12 no-padding-on-phone">\n' +
    '                <div class="app-white-card m-b-15">\n' +
    '                    <div class="header-card">\n' +
    '                        <span translate="eInvoiceDetail.detail"></span>\n' +
    '                    </div>\n' +
    '                    <div class="p-t-10 p-l-15 p-r-15">\n' +
    '                        <div class="row bottom-border p-b-10">\n' +
    '                            <h4 class="col-sm-6" translate="eInvoiceDetail.unpaidInvoice">\n' +
    '              </h4>\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <button type="input" class="btn btn-default app-btn-blue" data-ng-click="eInvoicesDetail.openEInvoiceModal()" translate="eInvoiceDetail.pay"></button>\n' +
    '                                <button type="input" class="btn btn-default app-btn-blue m-l-20" translate="eInvoiceDetail.markAsPayed"></button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="row bottom-border p-t-10 p-b-10 light-bcg">\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceOverview.issuer"></div>\n' +
    '                                    <b>{{::eInvoicesDetail.eInvoiceObject.creditorName}}</b>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.issuerAccount">t</div>\n' +
    '                                    <b>{{::eInvoicesDetail.eInvoiceObject.creditorAccount}}</b>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.recipient"></div>\n' +
    '                                    <b>{{::eInvoicesDetail.eInvoiceObject.creditorName}}</b>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.recipientAccount"></div>\n' +
    '                                    <b>{{::eInvoicesDetail.eInvoiceObject.creditorAccount}}</b>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="row bottom-border p-t-10 p-b-10">\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.purpose"></div>\n' +
    '                                    <div class="wrap-text">\n' +
    '                                        <b>{{::eInvoicesDetail.eInvoiceObject.purpose}}</b>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.refNumber">t</div>\n' +
    '                                    <b>{{::eInvoicesDetail.eInvoiceObject.paymentReferenceNumber}}</b>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.amount">t</div>\n' +
    '                                    <b>{{::eInvoicesDetail.eInvoiceObject.amount}} {{::eInvoicesDetail.eInvoiceObject.currencySymbol}}</b>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.issueDate"></div>\n' +
    '                                    <b>{{::eInvoicesDetail.eInvoiceObject.valueDate | date:\'shortDate\'}}</b>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.purposeCode"></div>\n' +
    '                                    <b>no info</b>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.dueDate"></div>\n' +
    '                                    <b>no info</b>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="row p-t-10 p-b-10 light-bcg">\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.digitalSignature"></div>\n' +
    '                                    <div class="wrap-text">\n' +
    '                                        <b>no info</b>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div class="clickable-link eim-link" data-ng-click="eInvoicesDetail.toggleSignatureDetailView();">\n' +
    '                                        <!--<span translate="eInvoicesDetail.translateName"></span>-->\n' +
    '                                        <span translate="eInvoiceDetail.visibilityDigitalSignature"></span>\n' +
    '                                        <span class="inherit-font-size" ng-class="eInvoicesDetail.signatureDetail? \'zmdi zmdi-chevron-up\': \'zmdi zmdi-chevron-down\'"></span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="row p-b-10 light-bcg" ng-show="eInvoicesDetail.signatureDetail">\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.signatureId"></div>\n' +
    '                                    <div class="wrap-text">\n' +
    '                                        <b>no info</b>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.digitalCertNumber"></div>\n' +
    '                                    <div class="wrap-text">\n' +
    '                                        <b>no info</b>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="col-sm-6">\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.signatureName"></div>\n' +
    '                                    <div class="wrap-text">\n' +
    '                                        <b>no info</b>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="form-group">\n' +
    '                                    <div translate="eInvoiceDetail.certificateIssuer"></div>\n' +
    '                                    <div class="wrap-text">\n' +
    '                                        <b>no info</b>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="app-white-card m-b-15 hidden-sm hidden-md hidden-lg">\n' +
    '                <div class="header-card">\n' +
    '                    <span translate="eInvoiceDetail.export"></span>\n' +
    '                </div>\n' +
    '                <div class="list">\n' +
    '                    <div class="list-item inner-list-el">\n' +
    '                        <a href="" class="cutom-link-title" translate="eInvoiceDetail.eInvoicePDF"></a>\n' +
    '                    </div>\n' +
    '                    <div class="list-item inner-list-el">\n' +
    '                        <a href="" class="cutom-link-title" translate="eInvoiceDetail.eInvoiceXML"></a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="app-white-card m-b-15 hidden-sm hidden-md hidden-lg">\n' +
    '                <div class="header-card">\n' +
    '                    <span translate="eInvoiceDetail.attachments"></span>\n' +
    '                </div>\n' +
    '                <div class="list">\n' +
    '                    <div class="list-item inner-list-el">\n' +
    '                        <a href="" class="cutom-link-title">Attachment 1</a>\n' +
    '                    </div>\n' +
    '                    <div class="list-item inner-list-el">\n' +
    '                        <a href="" class="cutom-link-title">Attachment 2</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="app-white-card m-b-15 hidden-sm hidden-md hidden-lg">\n' +
    '                <div class="list">\n' +
    '                    <div class="list-item inner-list-el">\n' +
    '                        <a href="" class="cutom-link-title" translate="eInvoiceDetail.unsubscribeEInvoices"></a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/e-invoice-registration-detail.tpl.html',
    '<div class="container invoice-card m-b-0">\n' +
    '  <div class="row invoice-card-top pointer-cst" ng-click="isCollapsed1 = !isCollapsed1">\n' +
    '    <div class="col-sm-9 col-xs-7 p-10">\n' +
    '      <div class="invoice-type">\n' +
    '        <b ng-if="registration.issuerName">{{registration.issuerName}}</b>\n' +
    '        <b ng-if="!registration.issuerName">{{registration.issuerServiceName}}</b>\n' +
    '        <span ng-show="false" class="text-muted">{{registration.id}}</span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-sm-3 col-xs-4">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-9 col-xs-9" ng-class="{\'text-danger\': registration.serviceState === \'Rejected\'}" >\n' +
    '          <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" class="einvoice-status">{{\'eInvoiceStatus.\'+registration.serviceState | translate}}</span>\n' +
    '          <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="einvoice-status">{{\'eInvoiceRegistration.\'+registration.serviceState | translate}}</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-3 col-xs-3">\n' +
    '          <span class="icon icon-arrdown i-c31 cursor-pointer"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row invoice-card-detail" ng-class="{collapse: !isCollapsed1}">\n' +
    '    <div class="invoice-content container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.issuerIBAN"></span></span>\n' +
    '        <label ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="domp-template-text">\n' +
    '             <span ng-switch-default>{{registration.iban}}</span>\n' +
    '             <span ng-switch-when="sl">{{registration.eInvoiceIssuer.iban | formatIban}}</span>\n' +
    '        </label>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.refNumber"></span></span>\n' +
    '         <label class="domp-template-text">\n' +
    '              {{registration.paymentReferenceNumber}}\n' +
    '            </label>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.dateOfReg"></span></span>\n' +
    '              <label class="domp-template-text" ng-if="registration.acceptedDate">{{registration.acceptedDate | date:\'shortDate\'}}</label>\n' +
    '              <label class="domp-template-text" ng-if="!registration.acceptedDate">-</label>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.serviceName"></span></span>\n' +
    '            <label class="domp-template-text">{{registration.issuerServiceName}}</label>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.orderType"></span></span>\n' +
    '            <label class="domp-template-text" ng-show="registration.serviceType.toLowerCase() == \'registration\'" translate="eInvoiceDetail.registration"></label>\n' +
    '            <label class="domp-template-text" ng-show="registration.serviceType.toLowerCase() == \'deregistration\'" translate="eInvoiceDetail.deregistration"></label>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <div class="col-sm-6">\n' +
    '          <p ng-if="registration.serviceState === \'Rejected\'">\n' +
    '            <span class="invoice-inline-title">\n' +
    '              <span translate="eInvoiceDetail.noteRejected"></span>\n' +
    '            </span>\n' +
    '              <label class="domp-template-text" ng-if="registration.comment">{{registration.comment}}</label>\n' +
    '              <label class="domp-template-text" ng-if="!registration.comment">-</label>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12 pull-right text-right">\n' +
    '\n' +
    '          <button class="btn btn-primary" ng-if="registration.serviceState === \'Registered\'"\n' +
    '                  ng-click="einvoicesOverview.cancelRegistration(registration)" translate="eInvoiceDetail.cancelReg"></button>\n' +
    '\n' +
    '          <button class="btn btn-default" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && registration.serviceState === \'Rejected\' || registration.serviceState === \'Unregistered\'"\n' +
    '                  translate="eInvoiceDetail.regAgain"\n' +
    '                  ng-click="einvoicesOverview.registerAgain(registration)"></button>\n' +
    '\n' +
    '          <button class="btn btn-default" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && registration.serviceState === \'Rejected\' || registration.serviceState === \'Unregistered\'"\n' +
    '                  translate="eInvoiceDetail.regAgainSlo"\n' +
    '                  ng-click="einvoicesOverview.registerAgain(registration)"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/e-invoice-detail.tpl.html',
    '<div class="container invoice-card" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '  <div class="row invoice-card-top vertical-align pointer-cst"\n' +
    '       ng-click="isCollapsed1 = !isCollapsed1; einvoicesOverview.archiveObj.archiveCtnOpened = false;">\n' +
    '\n' +
    '    <div class="col-sm-6 col-xs-11 p-15">\n' +
    '      <div class="invoice-type">\n' +
    '        <b>{{eInvoice.creditorName}}</b>\n' +
    '        <br/>\n' +
    '        <span class="text-muted">{{eInvoice.valueDate| date:\'shortDate\'}}</span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-class="{\'col-sm-6 hidden-xs\': (eInvoice.status == \'Inserted\' || eInvoice.status == \'InProgress\'),\n' +
    '                   \'col-sm-7 hidden-xs\': (eInvoice.status == \'Archived\' || eInvoice.status == \'Processed\' || eInvoice.status == \'Rejected\')}">\n' +
    '      <div class="row vertical-align">\n' +
    '        <div ng-class="{\'col-sm-6 hidden-xs\': (eInvoice.status == \'Inserted\' || eInvoice.status == \'InProgress\'),\n' +
    '                       \'col-sm-5 hidden-xs\': (eInvoice.status == \'Archived\' || eInvoice.status == \'Processed\' || eInvoice.status == \'Rejected\')}">\n' +
    '\n' +
    '          <span class="einvoice-value pull-right">{{eInvoice.amount| number:2}} <span>{{eInvoice.currencySymbol}}</span></span>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <div ng-class="{\'col-sm-3 col-xs-5\': (eInvoice.status == \'Inserted\' || eInvoice.status == \'InProgress\'),\n' +
    '                       \'col-sm-6 col-xs-5\' :(eInvoice.status == \'Archived\' || eInvoice.status == \'Processed\' || eInvoice.status == \'Rejected\')}">\n' +
    '          <button class="btn btn-default p-5 pull-right" ng-if="eInvoice.status == \'Inserted\'"\n' +
    '                  ng-click="einvoicesOverview.pay(eInvoice, $event)"\n' +
    '                  translate="eInvoiceOverview.pay">\n' +
    '          </button>\n' +
    '          <label class="f-16 blue-label" ng-if="eInvoice.status == \'InProgress\'"\n' +
    '                 translate="eInvoiceOverview.inProgress">In progress</label>\n' +
    '\n' +
    '          <button\n' +
    '            ng-if="eInvoice.status == \'Archived\' || eInvoice.status == \'Processed\' || eInvoice.status == \'Rejected\'"\n' +
    '            class="btn btn-default p-5 pull-right" ng-click="einvoicesOverview.pay(eInvoice, $event)"\n' +
    '            translate="eInvoiceOverview.copy"></button>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-1 col-xs-2">\n' +
    '          <span class="glyphicon glyphicon-chevron-down"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="hidden-sm hidden-md hidden-lg col-xs-1">\n' +
    '      <span class="glyphicon glyphicon-chevron-down"></span>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row invoice-card-detail" ng-class="{collapse: !isCollapsed1}">\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '      <div class="row-md-sm-lg">\n' +
    '        <div class="col-sm-6 row-xs">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.issuer"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.creditorName}}<br/>\n' +
    '              {{eInvoice.creditorAddress}}<br/>\n' +
    '              {{eInvoice.creditorCity}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6 row-xs">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.recipient"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.creditorName}}<br/>\n' +
    '              {{eInvoice.creditorAddress}}<br/>\n' +
    '              {{eInvoice.creditorCity}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row-md-sm-lg">\n' +
    '        <div class="col-sm-6 row-xs">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.recipientAccount"></span></span>\n' +
    '            <b>{{eInvoice.creditorAccount}}</b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-6 row-xs">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.issuerAccount"></span></span>\n' +
    '            <b>{{eInvoice.creditorAccount}}</b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.purpose"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.purpose}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.issueDateOfEinvoice"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.valueDate| date:\'shortDate\'}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.refNumber"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.paymentReferenceNumber}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.amount"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.amount| number:2}} {{eInvoice.currencySymbol}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-12" ng-if="eInvoice.status == \'Rejected\' || eInvoice.status == \'Archived\'">\n' +
    '          <span class="invoice-inline-title">\n' +
    '            <span translate="eInvoiceDetail.noteRejected" ng-if="eInvoice.status == \'Rejected\'"></span>\n' +
    '            <span translate="eInvoiceDetail.noteArchived" ng-if="eInvoice.status == \'Archived\'"></span>\n' +
    '          </span>\n' +
    '          <p class="payment-description">\n' +
    '            {{eInvoice.userComment}}\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <!-- Archive input container -->\n' +
    '        <div ng-if="einvoicesOverview.archiveObj.archiveCtnOpened">\n' +
    '          <div class="col-sm-6 col-xs-10">\n' +
    '            <input type="text" class="form-control" placeholder="{{\'eInvoicesModal.enterComment\'| translate}}"\n' +
    '                   data-ng-model="einvoicesOverview.archiveObj.userComment">\n' +
    '          </div>\n' +
    '          <div class="col-sm-3 col-xs-2">\n' +
    '            <i class="zmdi zmdi-check zmdi-hc-2x edit-check-btn"\n' +
    '               ng-disabled="eInvoice.archiveEInvoiceInProgress"\n' +
    '               data-ng-click="einvoicesOverview.archiveEInvoice(eInvoice);"\n' +
    '               style="background-color: #ff4d5a; color:white;"></i>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="hidden-sm hidden-md hidden-lg col-xs-12 m-b-10"></div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="text-right pull-right p-r-5 p-l-0 col-xs-12 col-sm-2" ng-if="eInvoice.status == \'Inserted\'">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.pay(eInvoice, $event)"\n' +
    '                  translate="eInvoiceOverview.pay">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="text-right pull-right p-r-5 p-l-0 col-xs-12 col-sm-4"\n' +
    '             ng-if="eInvoice.status == \'Archived\' || eInvoice.status == \'Processed\' || eInvoice.status == \'Rejected\'">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.pay(eInvoice, $event)"\n' +
    '                  translate="eInvoiceOverview.copy">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="pull-right text-right p-r-5 p-l-0 col-xs-12 col-sm-2"\n' +
    '             ng-if="eInvoice.status == \'Inserted\' || eInvoice.status == \'InProgress\'">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.toggleArchiveContainer()"\n' +
    '                  translate="eInvoiceDetail.archive">Archive\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="pull-right text-right p-r-5 p-l-0  col-xs-12 col-sm-2">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.downloadPdf(eInvoice.id)"\n' +
    '                  ng-disabled="einvoicesOverview.downloadButtonPressed"\n' +
    '                  translate="eInvoiceDetail.download">Download\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-class="{collapse: !collapsedSignature}">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title" translate="eInvoiceDetail.digitalCertNumber"></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.signatureId"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.signatureName"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.certificateIssuer"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<! ------------------------------ ->\n' +
    '<! -- SLO -- >\n' +
    '<! ------------------------------ ->\n' +
    '\n' +
    '\n' +
    '<div class="container invoice-card" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '  <div class="row invoice-card-top vertical-align pointer-cst"\n' +
    '       ng-click="einvoicesOverview.showEInvoiceDetails(eInvoice)">\n' +
    '\n' +
    '    <div class="col-lg-5 col-md-4 col-sm-12 col-xs-12 p-15">\n' +
    '      <div class="invoice-type">\n' +
    '        <div><b>{{eInvoice.creditorName}}</b></div>\n' +
    '        <div class="text-muted">{{eInvoice.valueDate| date:\'shortDate\'}} <span ng-if="eInvoice.documentType">- {{\'eInvoicesModal.eDocumentType.\' + eInvoice.documentType | translate }}</span></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">\n' +
    '      <span class="einvoice-value pull-right">{{eInvoice.amount| number:2}} <span>{{eInvoice.currencySymbol}}</span></span>\n' +
    '    </div>\n' +
    '    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">\n' +
    '      <label class="f-16 blue-label m-t-10" translate="eInvoiceStatus.{{eInvoice.status}}">Status</label>\n' +
    '      <button\n' +
    '        ng-if="eInvoice.status == \'Reviewed\' || eInvoice.status == \'Inserted\'"\n' +
    '        class="btn btn-default p-5 pull-right" ng-click="einvoicesOverview.pay(eInvoice, $event)"\n' +
    '        translate="eInvoiceOverview.pay">\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="col-lg-1 col-md-1 hidden-sm hidden-xs t-a-r">\n' +
    '      <span class="glyphicon glyphicon-chevron-down"></span>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row invoice-card-detail" ng-class="{collapse: !eInvoice.isCollapsed1}">\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.issuer"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.creditorName}}<br/>\n' +
    '              {{eInvoice.creditorAddress}}<br/>\n' +
    '              {{eInvoice.creditorCity}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.recipient"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.debtorName}}<br/>\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 ">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.issuerAccount"></span></span>\n' +
    '            <b>{{eInvoice.creditorAccount | formatIban}}</b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.recipientAccount"></span></span>\n' +
    '            <b>{{eInvoice.debtorAccount}}</b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.purpose"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.purpose}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.issueDateOfEinvoice"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.valueDate| date:\'shortDate\'}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.refNumber"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.paymentReferenceNumber}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.dueDate"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.dueDate | date:\'shortDate\'}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.amount"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.amount| number:2}} {{eInvoice.currencySymbol}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.purposeCode"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.purposeCode}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '      <h3 translate="eInvoiceDetail.otherInfo">OSTALI PODATKI</h3>\n' +
    '      <h4 translate="eInvoiceDetail.digitalSignature"></h4>\n' +
    '      <br>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-3">\n' +
    '          <span class="invoice-inline-title" translate="eInvoiceDetail.signatureId">Oznaka podpisa</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-9">\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.eInvoiceDocumentDigitalSignatures[0].signatureId}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-3">\n' +
    '          <span class="invoice-inline-title" translate="eInvoiceDetail.signatureName">Ime digitalnog potrdila</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-9">\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.eInvoiceDocumentDigitalSignatures[0].certificateName}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-3">\n' +
    '          <span class="invoice-inline-title"\n' +
    '                translate="eInvoiceDetail.digitalCertNumber">Številka digitalnega potrdila</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-9">\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.eInvoiceDocumentDigitalSignatures[0].certificateNumber}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-3">\n' +
    '          <span class="invoice-inline-title" translate="eInvoiceDetail.certificateIssuer">Izdajatelj digitalnega potrdila</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-9">\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eInvoice.eInvoiceDocumentDigitalSignatures[0].certificateIssuer}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-3">\n' +
    '          <span class="invoice-inline-title" translate="eInvoiceDetail.digitalSignature">Status elektronskega podpisa</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-9">\n' +
    '          <p>\n' +
    '            <b ng-show="eInvoice.eInvoiceDocumentDigitalSignatures[0].signatureValid" translate="eInvoiceDetail.valid">\n' +
    '\n' +
    '            </b>\n' +
    '            <b ng-show="!eInvoice.eInvoiceDocumentDigitalSignatures[0].signatureValid"\n' +
    '               translate="eInvoiceDetail.invalid">\n' +
    '\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-3">\n' +
    '          <span ng-if="eInvoice.documentType !== \'eOpomina\' && eInvoice.documentType !== \'ePredacun\'"  class="invoice-inline-title" translate="eInvoiceDetail.statusOfEApplication">Status E-računa</span>\n' +
    '          <span ng-if="eInvoice.documentType === \'eOpomina\'" class="invoice-inline-title" translate="eInvoiceDetail.statusOfEApplicationOpomina">Status E-računa</span>\n' +
    '          <span ng-if="eInvoice.documentType === \'ePredacun\'"  class="invoice-inline-title" translate="eInvoiceDetail.statusOfEApplicationPredracun">Status E-računa</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-9">\n' +
    '          <p>\n' +
    '            <b translate="eInvoiceStatus.{{eInvoice.status}}">\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-3">\n' +
    '          <span class="invoice-inline-title" translate="eInvoiceDetail.paymentId">Id plačila</span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-9">\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              /\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '\n' +
    '      <div class="row">\n' +
    '\n' +
    '        <div class="text-right pull-right p-r-5 p-l-0 " ng-if="eInvoice.status == \'Reviewed\' || eInvoice.status == \'Inserted\'">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.pay(eInvoice, $event)"\n' +
    '                  translate="eInvoiceOverview.pay">\n' +
    '          </button>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <!--<div class="text-right pull-right p-r-5 p-l-0 " ng-if="eInvoice.status == \'Reviewed\' || eInvoice.status == \'Inserted\'">-->\n' +
    '          <!--<button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.reject(eInvoice, $event)"-->\n' +
    '                  <!--translate="eInvoiceOverview.reject">-->\n' +
    '          <!--</button>-->\n' +
    '        <!--</div>-->\n' +
    '\n' +
    '        <div class="pull-right text-right p-r-5 p-l-0"\n' +
    '             ng-if="eInvoice.status == \'Inserted\' || eInvoice.status == \'Reviewed\'">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.archiveEInvoice(eInvoice)"\n' +
    '                  ng-disabled="eInvoice.archiveEInvoiceInProgress"\n' +
    '                  translate="eInvoiceDetail.withdraw">Archive\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="pull-right text-right p-r-5 p-l-0">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.downloadPdf(eInvoice.id)"\n' +
    '                  ng-disabled="einvoicesOverview.downloadButtonPressed"\n' +
    '                  translate="eInvoiceDetail.download">Download\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-class="{collapse: !collapsedSignature}">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title" translate="eInvoiceDetail.digitalCertNumber"></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.signatureId"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.signatureName"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.certificateIssuer"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/e-invoice-archive.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '\n' +
    '    <div class="container status-container">\n' +
    '      <div class="row vertical-align">\n' +
    '        <div class="col-sm-1 text-right">\n' +
    '          <span class="glyphicon glyphicon-ok"></span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-sm-11 ">\n' +
    '          <h2>Archiving complete</h2>\n' +
    '          You have successfully archived the E-invoice.\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="container status-container">\n' +
    '      <div class="row vertical-align">\n' +
    '        <div class="col-sm-1 text-right">\n' +
    '          <span class="glyphicon glyphicon-info-sign"></span>\n' +
    '        </div>\n' +
    '        <div class="col-sm-11">\n' +
    '          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit\n' +
    '          amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis\n' +
    '          dis parturient montes, nascetur ridiculus mus.\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <br/><br/>\n' +
    '    <a href="#!e-invoices/overview">Go to e-invoice list</a>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('e-invoices/e-document-details.tpl.html',
    '<div class="container invoice-card">\n' +
    '  <!--E DOCUMENT MAIN ROW START-->\n' +
    '  <div class="row invoice-card-top vertical-align pointer-cst"\n' +
    '       ng-click="einvoicesOverview.showEDocumentDetails(eDocument)">\n' +
    '\n' +
    '    <div class="col-lg-6 col-md-5 col-sm-12 col-xs-12 p-15">\n' +
    '      <div class="invoice-type">\n' +
    '        <div><b>{{eDocument.creditorName}}</b></div>\n' +
    '        <div class="text-muted"> {{eDocument.postedDate | date:\'shortDate\'}} - <span ng-if="eDocument.documentType">{{\'eInvoicesModal.eDocumentType.\' + eDocument.documentType | translate }}</span></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">\n' +
    '      <span ng-if="eDocument.amount" class="einvoice-value pull-right">{{eDocument.amount| number:2}} <span>{{eDocument.currencySymbol}}</span> </span>\n' +
    '    </div>\n' +
    '    <div class="col-lg-2 col-md-3 col-sm-6 col-xs-6 t-a-r">\n' +
    '      <label class="f-16 blue-label m-t-10" translate="eInvoiceStatus.{{eDocument.status}}">Status</label>\n' +
    '      <!--<button-->\n' +
    '        <!--class="btn btn-default p-5 pull-right" ng-click="einvoicesOverview.pay(eInvoice, $event)"-->\n' +
    '        <!--translate="eInvoiceOverview.pay">-->\n' +
    '      <!--</button>-->\n' +
    '    </div>\n' +
    '    <div class="col-lg-1 col-md-1 hidden-sm hidden-xs t-a-r">\n' +
    '      <span class="glyphicon glyphicon-chevron-down"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!--E DOCUMENT MAIN ROW END -->\n' +
    '\n' +
    '  <!-- E DOCUMENT DETAILS START -->\n' +
    '  <div class="row invoice-card-detail" ng-class="{collapse: !eDocument.isCollapsed1}">\n' +
    '    <div class="invoice-content container">\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.issuer"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eDocument.creditorName}}<br/>\n' +
    '              {{eDocument.creditorAddress}}<br/>\n' +
    '              {{eDocument.creditorCity}}\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6">\n' +
    '          <span class="invoice-inline-title"><span translate="eInvoiceDetail.recipient"></span></span>\n' +
    '          <p>\n' +
    '            <b>\n' +
    '              {{eDocument.debtorName}}<br/>\n' +
    '            </b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-sm-6 ">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.issuerAccount"></span></span>\n' +
    '            <b>{{eDocument.creditorAccount | formatIban}}</b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '        <div class="col-sm-6">\n' +
    '          <p>\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.recipientAccount"></span></span>\n' +
    '            <b>{{eDocument.debtorAccount | formatIban}}</b>\n' +
    '          </p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="invoice-content container">\n' +
    '\n' +
    '      <!-- BUTTONS CONTAINER START -->\n' +
    '      <div class="row">\n' +
    '\n' +
    '        <!--<div class="text-right pull-right p-r-5 p-l-0 " ng-if="eDocument.status == \'Reviewed\' || eDocument.status == \'Inserted\' || eDocument.status == \'Delivered\' ">-->\n' +
    '          <!--<button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.reject(eDocument, $event)"-->\n' +
    '                  <!--translate="eInvoiceOverview.reject">-->\n' +
    '          <!--</button>-->\n' +
    '        <!--</div>-->\n' +
    '        <!--<div class="pull-right text-right p-r-5 p-l-0">-->\n' +
    '          <!--<button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.archiveEDocument(eDocument)"-->\n' +
    '                  <!--ng-disabled="eDocument.archiveEInvoiceInProgress"-->\n' +
    '                  <!--translate="eInvoiceDetail.withdraw">Archive-->\n' +
    '          <!--</button>-->\n' +
    '        <!--</div>-->\n' +
    '\n' +
    '        <div data-ng-repeat="doc in eDocument.eInvoiceDocumentAttachmentList" class="pull-right text-right p-r-5 p-l-0">\n' +
    '          <button class="btn btn-default col-xs-12" ng-click="einvoicesOverview.downloadDocumentPdf(eDocument.id, doc.id)"\n' +
    '                  ng-disabled="einvoicesOverview.downloadButtonPressed">{{doc.name}}\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- BUTTONS CONTAINER END -->\n' +
    '\n' +
    '      <!-- SIGNATURE CONTAINER START -->\n' +
    '      <div ng-class="{collapse: !collapsedSignature}">\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title" translate="eInvoiceDetail.digitalCertNumber"></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.signatureId"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.signatureName"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '          <div class="col-sm-6">\n' +
    '            <span class="invoice-inline-title"><span translate="eInvoiceDetail.certificateIssuer"></span></span>\n' +
    '            <p>\n' +
    '              <b>\n' +
    '                no info\n' +
    '              </b>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '      <!-- SIGNATURE CONTAINER END -->\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- E DOCUMENT DETAILS END -->\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('documents/documents.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div class="row main-row">\n' +
    '      <div class="tmplt-list-title col-md-12 p-r-0 m-b-15">\n' +
    '        <h2 translate="documents.header" class="title-style"></h2>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="timeline-row col-sm-12">\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '        <div class="hypo-timeline-wrapper app-white-card ">\n' +
    '\n' +
    '          <div class="row p-15" >\n' +
    '            <div class="col-sm-12 p-10 bgm-white" style="z-index:1;">\n' +
    '              <div class="col-sm-6 col-xs-12 p-0">\n' +
    '                <div class="tml-filter-container tmlf-wide" style="overflow: hidden;" id="searchFilterExpandedDiv" click-outside="dashboard.searchFilterExpanded = false;">\n' +
    '                  <div id="searchBtnLeftDiv" class="inner-section left" >\n' +
    '                    <i class="icon icon-search  icon-hc-2x m-l-5"></i>\n' +
    '                  </div>\n' +
    '                  <div id="searchBtnCenterDiv" class="inner-section center">\n' +
    '                    <input id="searchTimelineInput" type="text" class="search-input" placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '                           ng-model="domesticPaymentSlo.tmpSearchText" ng-model-options="{ debounce: 300 }"\n' +
    '                    >\n' +
    '                  </div>\n' +
    '                  <div ng-show="dashboard.searchInputExpanded" id="searchBtnRightDiv" class="inner-section right" ng-init="dashboard.showDeleteInputBtn = false">\n' +
    '                    <i ng-show="!dashboard.showDeleteInputBtn" class="icon icon-filter icon-hc-2x i-r-0" ng-click="dashboard.toggleFilterSelection();"></i>\n' +
    '                    <i ng-show="dashboard.showDeleteInputBtn" class="zmdi zmdi-tag-close  zmdi-hc-2x m-r-0" ng-click="dashboard.timelineSearchFilter.descriptionFTS = \'\'; dashboard.timelineSearchAction(); dashboard.showDeleteInputBtn = false"></i>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-sm-6 col-xs-12 p-0 p-r-10">\n' +
    '                <div class="dropdown acc-period-select pull-right" style="display: inline-block">\n' +
    '                  <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '                    {{documents.selectedPeriod.item.description | translate}}\n' +
    '                    <span class="caret"></span>\n' +
    '                  </button>\n' +
    '                  <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                    <li data-ng-repeat="period in documents.periodList">\n' +
    '                      <a href="" class="f-13" data-ng-click="documents.selectPeriod(period)">\n' +
    '                        {{period.item.description | translate}}\n' +
    '                      </a>\n' +
    '                    </li>\n' +
    '                  </ul>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div class="t-a-c m-t-10 p-10 no-data-image" ng-show="documents.timelineListGrouped.result.length == 0">\n' +
    '            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '            <h3 class="no-data-label" translate="documents.noItemData"></h3>\n' +
    '          </div>\n' +
    '          <div class="timeline-row col-sm-12 p-l-0 p-r-0"\n' +
    '               ng-show="documents.timelineListGrouped.result.length > 0">\n' +
    '            <div class="hypo-timeline-wrapper app-white-card no-top-radius p-b-10">\n' +
    '              <ul class="hypo-timeline" >\n' +
    '                <li data-ng-repeat="item in documents.timelineListGrouped.result | filter:domesticPaymentSlo.tmpSearchText" ng-class="{\'time-label\': item.isVirtual === true, \'tl-badge-icon\': item.isVirtual === undefined}">\n' +
    '                  <span ng-if="item.isVirtual === true" class="bg-white">{{item.date}}</span>\n' +
    '                  <i ng-if="item.isVirtual == undefined" class="zmdi icon f-18 lh-27 c-nar icon-acrobat"></i>\n' +
    '\n' +
    '                  <div ng-if="item.isVirtual == undefined" class="hypo-timeline-item">\n' +
    '\n' +
    '                    <div class="hypo-timeline-body">\n' +
    '                      <div class="row">\n' +
    '                        <div class="col-md-9 col-sm-6 col-xs-12 t-a-l ">\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              {{item.date | date}}\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                          <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                              <h4 ng-if="item.title" class="m-b-0 m-t-0 c-gray"><b>{{item.title}}</b></h4>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-md-3 col-sm-6 col-xs-12 t-a-r">\n' +
    '                          <button type="input" class="btn btn-default app-btn-orange m-b-0" translate="documents.download"\n' +
    '                                  ng-disabled="item.downloadPdfInProgress"\n' +
    '                                  ng-click="documents.downloadPdf(item)"></button>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </li>\n' +
    '              </ul>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="show-more-btn">\n' +
    '        <button ng-show="documents.timelineListGrouped.hasMore" data-ng-click="documents.loadMoreTimelineItemsGrouped()" type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="documents.loadEvents">Load older events</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('documents/documents-info.tpl.html',
    '<div class="modal-header statement-confirm-header p-10">\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-body text-center">\n' +
    '  <h3 translate="documents.titleModalInfo">Information</h3>\n' +
    '  <p>\n' +
    '    <span translate="documents.messageModalInfo">Bla bla</span>\n' +
    '  </p>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12">\n' +
    '      <button class="btn btn-default" ng-click="$close()"><span\n' +
    '        translate="documents.closeModalInfo"></span></button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/tl-transaction-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '  <tbody>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.description"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.description}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.amount"></span></td>\n' +
    '      <td>\n' +
    '        <span class="tlidm-value-label  outcome-tr" ng-if="tlItem.itemType==\'TransactionDebit\'">{{tlItem.amount | number:2}} {{tlItem.currency}}</span>\n' +
    '        <span class="tlidm-value-label  income-tr" ng-if="tlItem.itemType==\'TransactionCredit\'">{{tlItem.amount | number:2}} {{tlItem.currency}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="tlItem.payeeName || tlItem.payerName">\n' +
    '        <td class="left-col" ng-if="tlItem.itemType==\'TransactionCredit\'"><span class="tridm-key-label" translate="timeline.creditorName"></span></td>\n' +
    '        <td class="left-col" ng-if="tlItem.itemType==\'TransactionDebit\'"><span class="tridm-key-label" translate="timeline.debitorName"></span></td>\n' +
    '        <td class="right-col">\n' +
    '          <span ng-if="dashboard.countryCode != \'sl\'" class="tridm-value-label">\n' +
    '             <span ng-if="tlItem.payerName">{{tlItem.payerName}}</span>\n' +
    '             <span ng-if="tlItem.payeeName">{{tlItem.payeeName}}</span>\n' +
    '          </span>\n' +
    '          <span ng-if="dashboard.countryCode == \'sl\'" class="tridm-value-label">{{tlItem.detail.payeeName}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="tlItem.payeeAddress1">\n' +
    '      <td class="left-col" ng-if="tlItem.itemType==\'TransactionCredit\'"><span class="tridm-key-label" translate="timeline.creditorAddress"></span></td>\n' +
    '      <td class="left-col" ng-if="tlItem.itemType==\'TransactionDebit\'"><span class="tridm-key-label" translate="timeline.debitorAddress"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{tlItem.payeeAddress1}}</span></td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <tr ng-if="tlItem.detail.toAccountNumber">\n' +
    '      <td class="left-col" ng-if="tlItem.itemType==\'TransactionCredit\'"><span class="tridm-key-label" translate="timeline.creditorAccount"></span></td>\n' +
    '      <td class="left-col" ng-if="tlItem.itemType==\'TransactionDebit\'"><span class="tridm-key-label" translate="timeline.debitorAccount"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{tlItem.detail.toAccountNumber}}</span></td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <!--<tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.accountNumber"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.transaction.detail.toAccountNumber}}</span>\n' +
    '        <span class="tlidm-value-label" ng-if="!tlItem.transaction.detail.toAccountNumber">-</span>\n' +
    '      </td>\n' +
    '    </tr>-->\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.group"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.group}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.referenceType"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{\'timeline.\'+tlItem.referenceType | translate}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.bookingDate"></span></td>\n' +
    '      <!-- <td><span class="tlidm-value-label">{{tlItemDetailsModal.getDateObjectfromDateString(tlItemDetailsModal.timelineItem.date) | date:\'shortDate\'}}</span></td> -->\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.transaction.bookingDate | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.valueDate"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.transaction.valueDate | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '  <tr ng-if="dashboard.countryCode == \'hr\' && (tlItem.group == \'Tekući račun građana\' || tlItem.group == \'Žiro račun građana\')">\n' +
    '    <td colspan="2">\n' +
    '      <button type="button" translate="dashboard.confirmation" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '              data-ng-click = "dashboard.downloadTransactionReport(tlItem.transaction);">\n' +
    '      </button>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/tl-payment-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '    <tbody>\n' +
    '        <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlStatus">Status:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label" translate="{{\'paymentsOverview.\'+payment.status}}"></span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlId">Payment id:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label">{{::payment.id}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlReceiver">Receiver name:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label">{{::payment.receiverName}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlFrom">From account:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label">{{::payment.fromAccountNumber}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlTo">To account:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label">{{::payment.toAccountNumber}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlAmount">Amount:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label">{{::payment.amount|number:2}} {{::payment.currencySymbol}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '           <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="signPayments.dateCreated">Create date:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label">{{::payment.dateCreated| date:\'shortDate\'}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '            <td>\n' +
    '                <span class="po-desc-label" translate="paymentsOverview.povlDueDate">Due date:</span>\n' +
    '            </td>\n' +
    '            <td>\n' +
    '                <span class="po-value-label">{{::payment.dueDate| date:\'shortDate\'}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '\n' +
    '\n' +
    '        <tr>\n' +
    '            <td colspan="2">\n' +
    '                <div>\n' +
    '                    <span class="pull-right" ng-repeat="actionObject in payment.allowedActionList.itemList">\n' +
    '                        <span ng-switch on="actionObject.methodName">\n' +
    '                            <button ng-if="actionObject.isEnabled" ng-switch-when="RecallAllowed"\n' +
    '                                    ng-click="dashboard.recallPaymentAction(payment.id);"\n' +
    '                                    class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                                    translate="paymentActions.recall">Recall payment</button>\n' +
    '                            <!--<button ng-if="actionObject.isEnabled" ng-switch-when="SignAllowed" ng-click="dashboard.signPaymentAction(payment.id);" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase">Sign payment</button>-->\n' +
    '                          <button ng-if="actionObject.isEnabled" ng-switch-when="SignAllowed"\n' +
    '                                  data-ui-sref="payments.sign({paymentId: payment.id})"\n' +
    '                                  class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                                  translate="paymentActions.sign">Sign payment</button>\n' +
    '                            <button ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed"\n' +
    '                                    ng-click="dashboard.deletePaymentAction(payment.id);"\n' +
    '                                    class="btn btn-primary-warning app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                                    translate="paymentActions.delete">Delete payment</button>\n' +
    '                        </span>\n' +
    '                    </span>\n' +
    '                </div>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/tl-message-details.tpl.html',
    '<table class="table table-striped table-responsive">\n' +
    '  <!--<thead>-->\n' +
    '  <!--<tr>-->\n' +
    '  <!--<th class="tlidm-header" colspan="2">-->\n' +
    '  <!--<span class="tlidm-header-label" translate="timeline.tldmMessageDetails"></span><i class="zmdi zmdi-close pull-right pointer-cst tlidm-header-btn-close" data-ng-click="tlItemDetailsModal.closeModal();"></i>-->\n' +
    '  <!--</th>-->\n' +
    '  <!--</tr>-->\n' +
    '  <!--</thead>-->\n' +
    '  <tbody>\n' +
    '  <tr>\n' +
    '    <td style="width:160px;"><span class="tlidm-key-label" translate="timeline.tldmMessageDate"></span></td>\n' +
    '    <td style="text-align:left;"><span\n' +
    '      class="tlidm-value-label">{{tlItem.messageDetails.creationDate | date:\'medium\'}}</span></td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td style="width:160px;"><span class="tlidm-key-label" translate="timeline.tldmMessageSubject"></span></td>\n' +
    '    <td style="text-align:left;">\n' +
    '      <div class="row">\n' +
    '      <div class="col-xs-8" ng-class="{\'col-xs-12\': !tlItem.messageDetails.linkList}">\n' +
    '        <span class="tlidm-value-label">{{tlItem.messageDetails.subject}}</span>\n' +
    '      </div>\n' +
    '      <div ng-if="tlItem.messageDetails.linkList" class="col-xs-4">\n' +
    '        <button class="btn btn-primary pull-right  f-12"\n' +
    '                ng-click="dashboard.downloadMessageAttachment(tlItem.messageDetails.linkList);"\n' +
    '                translate="messages.downloadAttachment">Download attachment</button>\n' +
    '      </div>\n' +
    '      </div>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td style="width:160px;"><span class="tlidm-key-label" translate="timeline.tldmMessageDetails"></span></td>\n' +
    '    <!--<td style="text-align:left;"><span class="tlidm-value-label">{{dashboard.formatText(tlItem.messageDetails.body)}}</span></td>-->\n' +
    '    <td style="text-align:left;"><span class="tlidm-value-label pre-line-text"\n' +
    '                                       ng-bind="dashboard.formatText(tlItem.messageDetails.body)"></span></td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <!--<td style="width:160px;"><span class="tlidm-key-label" translate="timeline.tldmMessageDetails"></span></td>-->\n' +
    '    <!--<td style="text-align:left;"><span class="tlidm-value-label">{{dashboard.formatText(tlItem.messageDetails.body)}}</span></td>-->\n' +
    '  </tr>\n' +
    '  <tr ng-if="tlItem.referenceType == \'Payment\'">\n' +
    '    <td style="width:160px;"><span class="tlidm-key-label" translate="messages.paymentCode"></span></td>\n' +
    '    <td style="text-align:left;">\n' +
    '              <span class="tlidm-value-label underline cursor-pointer"\n' +
    '                    ng-click="dashboard.openPayment(tlItem.referenceId); $event.stopPropagation()">\n' +
    '                {{::tlItem.referenceId}}\n' +
    '              </span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '\n' +
    '  <tr ng-if="tlItem.messageDetails.hasOwnProperty(\'messageType\') && tlItem.messageDetails.messageType == \'Order\'">\n' +
    '    <td style="width:160px;">\n' +
    '      <span class="tlidm-key-label" translate="messages.orderCode"></span>\n' +
    '    </td>\n' +
    '    <td style="text-align:left;">\n' +
    '      <a class="tlidm-value-label" href="">{{tlItem.messageDetails.objectId}}</a>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/tl-einvoice-details.tpl.html',
    '<table class="table table-striped table-responsive">\n' +
    '  <!--<thead>-->\n' +
    '    <!--<tr>-->\n' +
    '      <!--<th class="tlidm-header" colspan="2">-->\n' +
    '        <!--<span class="tlidm-header-label" translate="timeline.einvoiceDetails"></span><i class="zmdi zmdi-close pull-right pointer-cst tlidm-header-btn-close" data-ng-click="tlItemDetailsModal.closeModal();"></i>-->\n' +
    '      <!--</th>-->\n' +
    '    <!--</tr>-->\n' +
    '  <!--</thead>-->\n' +
    '  <tbody>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.purpose"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.einvoiceDetails.purpose }}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.creditorName"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.einvoiceDetails.creditorName }}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.amount"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.einvoiceDetails.amount | number:2}}</span></td>\n' +
    '    </tr>\n' +
    '    <!--<tr>-->\n' +
    '      <!--<td><span class="tlidm-key-label" translate="timeline.referenceType"></span></td>-->\n' +
    '      <!--<td><span class="tlidm-value-label">{{dashboard.timelineItem.referenceType}}</span></td>-->\n' +
    '    <!--</tr>-->\n' +
    '    <tr>\n' +
    '      <td><span class="tlidm-key-label" translate="timeline.valueDate"></span></td>\n' +
    '      <td><span class="tlidm-value-label">{{tlItem.einvoiceDetails.valueDate | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/quick-payment-modal.tpl.html',
    '<div class="container qp-modal-container p-20">\n' +
    '    <div class="row qp-modal-header m-b-30">\n' +
    '        <div class="col-sm-12">\n' +
    '            <h1>Quick payment or transfer<span class="pull-right zmdi zmdi-close qp-close-btn" ng-click="qpModalCtrl.closeQPModal()"></span></h1>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row qp-modal-body">\n' +
    '        <div class="qpmb-from-section col-sm-6">\n' +
    '            <form role="form">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="qpm-form--label" for="">From:</label>\n' +
    '                    <div class="fg-line">\n' +
    '                        <select class="form-control no-bottom-radius">\n' +
    '                            <option value="Select an Option">My current account</option>\n' +
    '                            <option value="Option 1">Option 1</option>\n' +
    '                        </select>\n' +
    '                        <p class="available-info-wrapper">available <span class="pull-right">789654</span></p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="form-group">\n' +
    '                    <label class="qpm-form--label" for="qpAmount">How much?</label>\n' +
    '                    <div class="input-group">\n' +
    '                        <input type="text" class="form-control" amount-input-mask placeholder="" maxlength="12" autocomplete="off" style="text-align: right;">\n' +
    '                        <div class="input-group-addon qp-amount">HRK</div>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </form>\n' +
    '        </div>\n' +
    '        <div class="qpmb-to-section col-sm-6">\n' +
    '            <form role="form">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="qpm-form--label" for="">To:</label>\n' +
    '                    <div class="fg-line">\n' +
    '                        <div ng-show="qpModalCtrl.toAccountType==1">\n' +
    '                            <input type="text" class="form-control">\n' +
    '                        </div>\n' +
    '                        <select ng-show="qpModalCtrl.toAccountType==2" class="form-control no-bottom-radius">\n' +
    '                            <option value="Select an Option">My current account</option>\n' +
    '                            <option value="Option 1">Option 1</option>\n' +
    '                        </select>\n' +
    '                        <div class="btn-group btn-group-justified" role="group" aria-label="...">\n' +
    '                            <div class="btn-group" role="group">\n' +
    '                                <button type="button" class="btn btn-default qpm-btn-group" ng-class="{\'not-selected\':qpModalCtrl.toAccountType==2}" ng-click="qpModalCtrl.toAccountType=1">Other account</button>\n' +
    '                            </div>\n' +
    '                            <div class="btn-group" role="group">\n' +
    '                                <button type="button" class="btn btn-default qpm-btn-group" ng-class="{\'not-selected\':qpModalCtrl.toAccountType==1}" ng-click="qpModalCtrl.toAccountType=2">My account</button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="form-group">\n' +
    '                    <label class="qpm-form--label" for="qpAmount">What for?</label>\n' +
    '                    <div class="">\n' +
    '                        <input type="text" class="form-control">\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </form>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row qp-modal-footer m-t-20">\n' +
    '        <div class="col-sm-9">\n' +
    '            <h4 class="m-t-30">Transfer will be made today, {{qpModalCtrl.qpModalDate | date:\'shortDate\'}} <span class="clickable-link" type="text" ng-model="qpModalCtrl.qpModalDate"  uib-datepicker-popup="shortDate" datepicker-options="qpModalCtrl.dateOptions" ng-required="true" close-text="Close" is-open="qpModalCtrl.datepickerPopup.opened" ng-click="qpModalCtrl.openDatepicker()">(change date)</span></h4>\n' +
    '        </div>\n' +
    '        <div class="col-sm-3">\n' +
    '            <button type="submit" class="btn btn-primary m-t-10 app-btn-blue qpmf-btn-transfer">Transfer</button>\n' +
    '            <p class="m-t-10 m-b-0 t-a-c">Processing fee: 0,00 HRK</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/instant-loan.tpl.html',
    '<div ng-if="dashboard.countryCode === \'hr\'" class="banner-image-url"\n' +
    '     ng-style="{\'background-image\': \'url(\' + dashboard.bannerImageUrl + \')\'}">\n' +
    '  <div class="t-a-l" style="position:absolute; bottom: 0px; top:0px; left: 35px;">\n' +
    '      <h3 class="c-white fw-cl custom-underline" ng-if="dashboard.currentLang == \'hr\'"  style="">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.text1}}</h3>\n' +
    '      <h3 class="c-white fw-cl custom-underline" ng-if="dashboard.currentLang == \'en\'"  style="">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.textEng1}}</h3>\n' +
    '      <h3 class="c-white fw-cl custom-underline pull-left m-0" ng-if="dashboard.currentLang == \'hr\'">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.text2}}</h3>\n' +
    '      <h3 class="c-white fw-cl custom-underline pull-left m-0" ng-if="dashboard.currentLang == \'en\'">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.textEng2}} </h3>\n' +
    '\n' +
    '      <!--<h4 class="bold-font c-white" ng-if="dashboard.currentLang == \'en\'">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.textEng2}} </h4>-->\n' +
    '        <!--<button type="button" class="btn btn-default text-uppercase" style="background-color: #062a42">-->\n' +
    '            <!--<a ng-href="https://www.addiko.hr/addiko-blic-kredit" target="_blank"  translate="dashboard.apply"></a>-->\n' +
    '        <!--</button>-->\n' +
    '      <div style="position: absolute; bottom: 10px" ng-click="dashboard.pushGtmLinkEvent(\'Banner \' + APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.link);">\n' +
    '      <a ng-href="{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.link}}" target="_blank"\n' +
    '         class="btn btn-default text-uppercase" style="background-color: #062a42;line-height: 2.6;" translate="dashboard.apply">\n' +
    '      </a>\n' +
    '    </div>\n' +
    '\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div ng-if="dashboard.countryCode === \'bh\'" ng-click="dashboard.pushGtmLinkEvent(\'Reklamni banner\');">\n' +
    '  <a href="{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.link}}" target="_blank">\n' +
    '    <div style="height: 161px; background-color: #ff4d5a; background-size: auto 100%; background-repeat: no-repeat;" ng-style="{\'background-image\': \'url(\' + dashboard.bannerImageUrl + \')\'}">\n' +
    '    </div>\n' +
    '  </a>\n' +
    '</div>\n' +
    '\n' +
    '<div ng-if="dashboard.countryCode === \'sr\'" ng-click="dashboard.pushGtmLinkEvent(\'Banner - Kredit za refinansiranje\');">\n' +
    '    <a href="https://www.addiko.rs/kredit-za-refinansiranje?utm_source=digitalbanking&utm_medium=banner&utm_campaign=kesref_2016" target="_blank">\n' +
    '        <div style="height: 161px; background-color: #ff4d5a; background-size: auto 100%; background-repeat: no-repeat;" ng-style="{\'background-image\': \'url(\' + dashboard.bannerImageUrl + \')\'}">\n' +
    '        </div>\n' +
    '    </a>\n' +
    '</div>\n' +
    '\n' +
    '<div ng-if="dashboard.countryCode === \'mne\'" ng-click="dashboard.pushGtmLinkEvent(\'Banner - Restart kredit\');">\n' +
    '  <a href="https://www.addiko.me/restart-kredit-0" target="_blank">\n' +
    '    <div style="height: 161px; background-color: #ff4d5a; background-size: auto 100%; background-repeat: no-repeat;" ng-style="{\'background-image\': \'url(\' + dashboard.bannerImageUrl + \')\'}">\n' +
    '    </div>\n' +
    '  </a>\n' +
    '</div>\n' +
    '\n' +
    '<div ng-if="dashboard.countryCode === \'sl\'" style=\'height: 161px; background-position: center; background-size: cover;background-color: #ff4d5a;background-image: url("img/hypo/addiko-klub.png");\' class="pointer-cst" ng-click="dashboard.openAddikoClubSl();">\n' +
    '    <div class="p-20">\n' +
    '        <h3 class="c-white m-t-0 m-b-30"><b class="col-xs-12 p-0 f-30 no-wrap-text">Addiko klub</b></h3>\n' +
    '        <div style="padding-top: 13px">\n' +
    '\n' +
    '            <amount-formatter amount="{{dashboard.loyaltyPointsResult.loyaltyCurrentPoints|number:2}}" custom-classes="{{\'c-white\'}}" currency="{{\'dashboard.loyaltyCurrentPoints\' | translate}}" from-type="dashboard" aditional-val="" has-underline="true">\n' +
    '            </amount-formatter>\n' +
    '            <amount-formatter amount="{{dashboard.loyaltyPointsResult.loyaltyPreviousPoints|number:2}}" custom-classes="{{\'c-blue\'}}" currency="{{\'dashboard.loyaltyPreviousPoints\' | translate}}" from-type="addikoKlub" aditional-val="" has-underline="false">\n' +
    '            </amount-formatter>\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/dashboard.tpl.html',
    '<div id="main">\n' +
    '  <div ng-include="\'dashboard/dashboard-notifications.tpl.html\'"></div>\n' +
    '  <div class="container-fluid p-t-15">\n' +
    '    <!-- ROW START -->\n' +
    '    <div class="row p-b-15">\n' +
    '      <div class="col-md-6 col-xs-6">\n' +
    '        <h2 class="m-l-0 f-28 m-t-0 m-b-0 title-style" translate="dashboard.dashboardHeader"></h2>\n' +
    '      </div>\n' +
    '      <div class="col-md-6 col-xs-6">\n' +
    '        <div class="add-widget-container">\n' +
    '          <div class="add-widget-bubble pointer" ng-click="dashboard.openWidgetsModal();">\n' +
    '            <i class="zmdi zmdi-plus"></i> {{\'dashboard.addNewWidget1\'| translate}}\n' +
    '          </div>\n' +
    '          <span class="widget-label">{{\'dashboard.addNewWidget2\'| translate}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ROW END -->\n' +
    '    <!-- ROW START -->\n' +
    '    <div class="row p-b-15" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '\n' +
    '      <div ng-switch-default class="col-sm-12 col-md-6 m-b-15" data-ng-repeat="account in dashboard.accountList.result">\n' +
    '        <div ng-switch on="account.accountType.group">\n' +
    '          <div ng-switch-when="1">\n' +
    '            <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '          <div ng-switch-default>\n' +
    '            <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-switch-when="sl">\n' +
    '        <div class="col-sm-12 col-md-6 m-b-15" ng-if="dashboard.currentAndCreditAccounts.length" data-ng-repeat="account in dashboard.currentAndCreditAccounts">\n' +
    '          <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-12 col-md-6 m-b-15" ng-if="dashboard.savingAccounts.length" data-ng-repeat="account in dashboard.savingAccounts">\n' +
    '          <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-12 col-md-6 m-b-15" ng-if="dashboard.depositAccounts.length" data-ng-repeat="account in dashboard.depositAccounts">\n' +
    '          <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-12 col-md-6 m-b-15" ng-if="dashboard.loanAccounts.length" data-ng-repeat="account in dashboard.loanAccounts">\n' +
    '          <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '        </div>\n' +
    '        <div class="col-sm-12 col-md-6 m-b-15" ng-if="dashboard.giroAccounts.length" data-ng-repeat="account in dashboard.giroAccounts">\n' +
    '          <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <div class="col-sm-12 col-md-6 m-b-15" data-ng-include="\'dashboard/instant-loan.tpl.html\'"></div>\n' +
    '\n' +
    '      <!-- Start Viber banner (only for BiH environment) -->\n' +
    '      <div class="col-sm-12 col-md-6 m-b-15" ng-if="APP_GLOBAL_SETTINGS.userSettings.isViberUser  == \'Y\'" data-ng-click="dashboard.checkUserViberActivation();">\n' +
    '        <div class="banner-image-url cursor-pointer" style="height: 161px;"\n' +
    '             ng-style="{\'background-image\': \'url(\' + dashboard.viberImageUrl + \')\'}">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- End Viber banner -->\n' +
    '    </div>\n' +
    '    <!-- ROW END -->\n' +
    '    <!-- ROW START -->\n' +
    '    <div class="row p-b-15">\n' +
    '      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 p-b-10">\n' +
    '        <a data-ui-sref="payments.domesticPayment">\n' +
    '          <div class="round-btn-container">\n' +
    '            <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->\n' +
    '            <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>\n' +
    '            <div class="round-btn-label">{{\'dashboard.domesticPaymentBtn1\'|translate}}\n' +
    '              <br>{{\'dashboard.domesticPaymentBtn2\'|translate}}</div>\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 p-b-10">\n' +
    '        <a data-ui-sref="payments.internalTransfer">\n' +
    '          <div class="round-btn-container">\n' +
    '            <!--<div class="round-btn"><i class="zmdi zmdi-swap zmdi-hc-3x"></i></div>-->\n' +
    '            <div class="round-btn"><i class="icon icon-transfer" style="font-size:2em"></i></div>\n' +
    '            <div class="round-btn-label">{{\'dashboard.transferBtn1\'|translate}}\n' +
    '              <br>{{\'dashboard.transferBtn2\'|translate}}</div>\n' +
    '          </div>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 p-b-10">\n' +
    '        <div class="pointer round-btn-container" ng-click="dashboard.toggleTemplatesView();">\n' +
    '          <div class="round-btn"><i class="icon icon-template" style="font-size:1.6em"></i></div>\n' +
    '          <div class="round-btn-label">{{\'dashboard.templateBtn1\'|translate}}\n' +
    '            <br>{{\'dashboard.templateBtn2\'|translate}}</div>\n' +
    '        </div>\n' +
    '        <div class="templates-container animated fadeIn" ng-show="dashboard.showTemplatesView">\n' +
    '        <div class="form-group m-b-0">\n' +
    '          <div class="input-group" style="height:50px;border: 1px solid black;">\n' +
    '            <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">\n' +
    '              <button class="btn" type="submit" style="box-shadow:none;background-color: transparent;">\n' +
    '                <i class="glyphicon glyphicon-search" style="font-size:20px;"></i>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <input id="searchTemplatesInput" style="height:50px;" data-ng-model="dashboard.tmpSearchText.name" type="text" class="form-control srch-input" placeholder="{{\'dashboard.searchTemplatesPlaceholder\'| translate}}" ng-change="dashboard.toggleFavoriteTemplates(dashboard.tmpSearchText.name)">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="p-10 templates-search-container" scrollable>\n' +
    '          <div class="m-b-10" ng-show="false">\n' +
    '            <h4 translate="templateSearch.favorites"></h4>\n' +
    '            <div class="list-group">\n' +
    '              <a href="" class="list-group-item">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>\n' +
    '                  <div class="col-xs-10">\n' +
    '                    <h5 class="list-group-item-heading"><b>Favorite template 1</b></h5>\n' +
    '                    <p class="list-group-item-text">HR4015290098745696</p>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-1"><i class="zmdi zmdi-star zmdi-hc-2x"></i></div>\n' +
    '                </div>\n' +
    '              </a>\n' +
    '              <a href="" class="list-group-item">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>\n' +
    '                  <div class="col-xs-10">\n' +
    '                    <h5 class="list-group-item-heading"><b>Favorite template 1</b></h5>\n' +
    '                    <p class="list-group-item-text">HR4015290098745696</p>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-1"><i class="zmdi zmdi-star zmdi-hc-2x"></i></div>\n' +
    '                </div>\n' +
    '              </a>\n' +
    '              <a href="" class="list-group-item">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>\n' +
    '                  <div class="col-xs-10">\n' +
    '                    <h5 class="list-group-item-heading"><b>Favorite template 1</b></h5>\n' +
    '                    <p class="list-group-item-text">HR4015290098745696</p>\n' +
    '                  </div>\n' +
    '                  <div class="col-xs-1"><i class="zmdi zmdi-star zmdi-hc-2x"></i></div>\n' +
    '                </div>\n' +
    '              </a>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="m-b-10">\n' +
    '            <h4 translate="templateSearch.templatesList"></h4>\n' +
    '            <div class="list-group">\n' +
    '              <a href="" class="list-group-item" data-ng-repeat="template in dashboard.templateList.result| filter:dashboard.tmpSearchText" ng-click="dashboard.navigateToPaymentForm({id: template.id, type: template.paymentTypeGroup, template: template})">\n' +
    '                <div class="row">\n' +
    '                  <div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>\n' +
    '                  <div class="col-xs-11">\n' +
    '                    <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                    <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </a>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ROW END -->\n' +
    '    <div ng-include="\'timeline/timeline.tpl.html\'" class="row"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/dashboard-widget-modal.tpl.html',
    '<div class="dw-container container">\n' +
    '    <h1>&nbsp;<span class="pull-right"><i class="zmdi zmdi-close pointer" id="pointerModal" ng-click="dwModalCtrl.closeDashboardWidgetModal(true);" ng-hide="dwModalCtrl.markAsFavoriteInProgress"></i></span></h1>\n' +
    '    <div class="dw-scroll-wrapper" ng-class="{\'disabled-overlay\': dwModalCtrl.markAsFavoriteInProgress}" scrollable>\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-12" ng-if="dwModalCtrl.currentAndCreditAccounts.length !== 0">\n' +
    '                <div class="widgetDiv">\n' +
    '                    <img src="img/hypo/addWidget/current_account_h200.png" class="widgetIcon" style="width:50px; height:50px;">\n' +
    '                    <h5 class="c-white f-18 widgetHeader" translate="dashboardWidgets.current"></h5>\n' +
    '                    <hr/>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '                <div class="col-sm-6 col-md-4 col-xs-12 p-l-5 p-r-5 m-b-5" ng-repeat="currentAndCreditAccount in dwModalCtrl.currentAndCreditAccounts">\n' +
    '                    <div class="dw-account-card" ng-click="currentAndCreditAccount.isFavorite = !currentAndCreditAccount.isFavorite; dwModalCtrl.markAccountAsFavorite(currentAndCreditAccount);">\n' +
    '                        <div class="col-xs-11 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-t-0 m-b-0  no-wrap-text">{{currentAndCreditAccount.friendlyName}}</h4>\n' +
    '                            <!--<h6 class="m-t-0 m-b-0  no-wrap-text fw-cm">{{currentAndCreditAccount.iban | formatIban}} {{currentAndCreditAccount.currencySymbol}}</h6>-->\n' +
    '                            <h6 ng-if="currentAndCreditAccount.accountType.group !== \'CardAccountTypes\' || APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                                class="m-t-0 m-b-0  no-wrap-text fw-cm">{{currentAndCreditAccount.iban | formatIban}} {{currentAndCreditAccount.currencySymbol}}</h6>\n' +
    '                          <h6 ng-if="currentAndCreditAccount.accountType.group === \'CardAccountTypes\' && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '                              class="m-t-0 m-b-0  no-wrap-text fw-cm">{{currentAndCreditAccount.accountNumber }} {{currentAndCreditAccount.currencySymbol}}</h6>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-1 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-t-0 m-b-0"><span><i class="zmdi" style="padding:6px" ng-class="{\'zmdi-star favorite-account widget\':currentAndCreditAccount.isFavorite,\'zmdi-star-outline\':!currentAndCreditAccount.isFavorite}"></i></span></h4></div>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12" ng-if="dwModalCtrl.savingAccounts.length !== 0">\n' +
    '\n' +
    '            <div class="widgetDiv">\n' +
    '              <img src="img/hypo/addWidget/saving_account_h200.png" class="widgetIcon" style="width:50px; height:50px;">\n' +
    '              <h5 class="c-white f-18 widgetHeader" translate="dashboardWidgets.savingsTransactions"></h5>\n' +
    '              <hr/>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-6 col-md-4 col-xs-12 p-l-5 p-r-5 m-b-5" ng-repeat="savingAccount in dwModalCtrl.savingAccounts">\n' +
    '              <div class="dw-account-card" ng-click="savingAccount.isFavorite = !savingAccount.isFavorite; dwModalCtrl.markAccountAsFavorite(savingAccount);">\n' +
    '                <div class="col-xs-11 p-l-0 p-r-0">\n' +
    '                  <h4 class="m-t-0 m-b-0  no-wrap-text">{{savingAccount.friendlyName}}</h4>\n' +
    '                  <h6 class="m-t-0 m-b-0  no-wrap-text fw-cm">{{savingAccount.iban}} {{savingAccount.currencySymbol}}</h6>\n' +
    '                </div>\n' +
    '                <div class="col-xs-1 p-l-0 p-r-0">\n' +
    '                  <h4 class="m-t-0 m-b-0"><span><i class="zmdi" style="padding:6px" ng-class="{\'zmdi-star favorite-account widget\':savingAccount.isFavorite,\'zmdi-star-outline\':!savingAccount.isFavorite}"></i></span></h4></div>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-12" ng-if="dwModalCtrl.depositAccounts.length !== 0">\n' +
    '                <div class="widgetDiv">\n' +
    '                    <img src="img/hypo/addWidget/term_deposit_h200.png" class="widgetIcon" style="width:53px; height:50px;">\n' +
    '                    <h5 class="c-white f-18 widgetHeader" translate="dashboardWidgets.deposit"></h5>\n' +
    '                    <hr/>\n' +
    '                </div>\n' +
    '                <div class="col-sm-6 col-md-4 col-xs-12 p-l-5 p-r-5 m-b-5" ng-repeat="depositAccount in dwModalCtrl.depositAccounts">\n' +
    '                    <div class="dw-account-card" ng-click="depositAccount.isFavorite = !depositAccount.isFavorite; dwModalCtrl.markAccountAsFavorite(depositAccount);">\n' +
    '                        <div class="col-xs-11 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-t-0 m-b-0  no-wrap-text">{{depositAccount.friendlyName}}</h4>\n' +
    '                            <h6 class="m-t-0 m-b-0  no-wrap-text fw-cm">{{depositAccount.iban}} {{depositAccount.currencySymbol}}</h6>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-1 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-t-0 m-b-0"><span><i class="zmdi" style="padding:6px" ng-class="{\'zmdi-star favorite-account widget\':depositAccount.isFavorite,\'zmdi-star-outline\':!depositAccount.isFavorite}"></i></span></h4></div>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-sm-12" ng-if="dwModalCtrl.loanAccounts.length !== 0">\n' +
    '            <div class="widgetDiv">\n' +
    '              <img src="img/hypo/addWidget/loan_account_h200.png" class="widgetIcon" style="width:50px; height:50px;">\n' +
    '              <h5 class="c-white f-18 widgetHeader" translate="dashboardWidgets.loan"></h5>\n' +
    '              <hr/>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 col-md-4 col-xs-12 p-l-5 p-r-5 m-b-5" ng-repeat="loanAccount in dwModalCtrl.loanAccounts">\n' +
    '              <div class="dw-account-card" ng-click="loanAccount.isFavorite = !loanAccount.isFavorite; dwModalCtrl.markAccountAsFavorite(loanAccount);">\n' +
    '                <div class="col-xs-11 p-l-0 p-r-0">\n' +
    '                  <h4 class="m-t-0 m-b-0  no-wrap-text">{{loanAccount.friendlyName}}</h4>\n' +
    '                  <h6 class="m-t-0 m-b-0  no-wrap-text fw-cm">\n' +
    '                    {{loanAccount.iban}}\n' +
    '                    <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                      <span ng-switch-default>{{loanAccount.currencySymbol}}</span>\n' +
    '                      <span ng-switch-when="sl">{{APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency}}</span>\n' +
    '                    </span>\n' +
    '                  </h6>\n' +
    '                </div>\n' +
    '                <div class="col-xs-1 p-l-0 p-r-0">\n' +
    '                  <h4 class="m-t-0 m-b-0"><span><i class="zmdi" style="padding:6px" ng-class="{\'zmdi-star favorite-account widget\':loanAccount.isFavorite,\'zmdi-star-outline\':!loanAccount.isFavorite}"></i></span></h4></div>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-12" ng-if="dwModalCtrl.giroAccounts.length !== 0">\n' +
    '                <div class="widgetDiv">\n' +
    '                    <img src="img/hypo/addWidget/giro_account_h200.png" class="widgetIcon" style="width:50px; height:50px;">\n' +
    '                    <h5 class="c-white f-18 widgetHeader" translate="dashboardWidgets.giro"></h5>\n' +
    '                    <hr/>\n' +
    '                </div>\n' +
    '                <div class="col-sm-6 col-md-4 col-xs-12 p-l-5 p-r-5 m-b-5" ng-repeat="giroAccount in dwModalCtrl.giroAccounts">\n' +
    '                    <div class="dw-account-card" ng-click="giroAccount.isFavorite = !giroAccount.isFavorite; dwModalCtrl.markAccountAsFavorite(giroAccount);">\n' +
    '                        <div class="col-xs-11 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-t-0 m-b-0  no-wrap-text">{{giroAccount.friendlyName}}</h4>\n' +
    '                            <h6 class="m-t-0 m-b-0  no-wrap-text fw-cm">{{giroAccount.iban}}        {{giroAccount.currencySymbol}}</h6>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-1 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-t-0 m-b-0"><span><i class="zmdi" style="padding:6px" ng-class="{\'zmdi-star favorite-account widget\':giroAccount.isFavorite,\'zmdi-star-outline\':!giroAccount.isFavorite}"></i></span></h4></div>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <br>\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-12 col-sm-4 col-sm-offset-8">\n' +
    '            <button class="btn btn-primary-red app-btn-blue w-100 f-uppercase" ng-click="dwModalCtrl.closeDashboardWidgetModal(true);" translate="dashboardWidgets.addBtn"\n' +
    '            ng-disabled="dwModalCtrl.markAsFavoriteInProgress"></button>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/dashboard-timeline.tpl.html',
    '<header id="header" data-current-skin={{mactrl.currentSkin}} data-ng-include="\'template/header.html\'" data-ng-controller="headerCtrl as hctrl"></header>\n' +
    '\n' +
    '<section id="main">\n' +
    '  <div class="container" data-ng-controller="headerCtrl as hctrl">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-3">\n' +
    '        <div id="changeDashboardDisplay" class="app-white-card">\n' +
    '          <a href class="col-md-6 cdd-menu cdd-menu-left" data-ui-sref="dashboard">Accounts</a>\n' +
    '          <a href class="col-md-6 cdd-menu cdd-menu-right" data-ui-sref="dashboard.timeline" data-ng-class="{ \'selected\': hctrl.isModuleActive(\'dashboard.timeline\') }">Timeline</a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-md-6"></div>\n' +
    '      <div class="col-md-3"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <br/>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '\n' +
    '<footer id="footer" data-ng-include="\'template/footer.html\'"></footer>\n' +
    '<!--<footer id="footer-hypo" data-ng-include="\'template/footer-hypo.html\'"></footer>-->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/dashboard-notifications.tpl.html',
    '<div class="dn-wrapper" ng-show="APP_GLOBAL_SETTINGS.counters.countersLoaded && dashboard.showNotificationsPanel" ng-class="{\'animated fadeIn\':APP_GLOBAL_SETTINGS.counters.countersLoaded}">\n' +
    '  <i class="dn-close-btn pointer zmdi zmdi-close zmdi-hc-2x" ng-click="dashboard.dismissNotifications();"></i>\n' +
    '  <div class="last-login-info" ng-if="dashboard.userSettings.result[0].lastLoginDate">\n' +
    '    <span translate="header.lastLogin"></span>\n' +
    '    <span>{{dashboard.userSettings.result[0].lastLoginDate | date: \'dd.MM.yyyy hh:mm:ss\'}}</span>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12 dn-item-row">\n' +
    '          <div class="dn-item-bubble" ng-bind="APP_GLOBAL_SETTINGS.counters.rejectedPaymentsNotifications"></div>\n' +
    '            <div class="dn-item-label" translate="dashboardNotification.rejected" ui-sref="payments.paymentsOverview({myParam: \'rejected\'})" ng-click="dashboard.pushNotificationsGtmEvent(\'RejectedPayments\');"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '        <div class="col-xs-12 dn-item-row">\n' +
    '          <div class="dn-item-bubble" ng-bind="APP_GLOBAL_SETTINGS.counters.eInvoiceNotifications"></div>\n' +
    '            <div class="dn-item-label"\n' +
    '                 translate="{{APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' ? \'dashboardNotification.einvoiceSlo\' : \'dashboardNotification.einvoice\'}}" ui-sref="eInvoices.einvoicesOverview" ng-click="dashboard.pushNotificationsGtmEvent(\'eInvoices\');"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12 col-sm-5">\n' +
    '          <div class="dn-item-row">\n' +
    '            <div class="dn-item-bubble" ng-bind="APP_GLOBAL_SETTINGS.counters.unsignedPaymentsNotifications"></div>\n' +
    '            <div ng-switch="dashboard.countryCode">\n' +
    '                <div class="dn-item-label"  ng-switch-default translate="dashboardNotification.unsigned" ui-sref="payments.paymentsOverview({myParam: \'not-signed\'})" ng-click="dashboard.pushNotificationsGtmEvent(\'UnSignedPayments\');"></div>\n' +
    '                <div class="dn-item-label"  ng-switch-when="sl" translate="dashboardNotification.pending" ui-sref="payments.paymentsOverview({myParam: \'pending\'})" ng-click="dashboard.pushNotificationsGtmEvent(\'UnSignedPayments\');"></div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-sm-7">\n' +
    '          <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.lastLoginDate" class="p-t-5 pull-right hidden-xs" >\n' +
    '            <span class="dn-item-label" translate="header.lastLogin"></span>\n' +
    '            <span class="dn-item-label">{{APP_GLOBAL_SETTINGS.userSettings.lastLoginDate | date:\'dd.MM.yyyy HH:mm:ss\'}}</span>\n' +
    '            <!--<span>{{hctrl.userSettings.result[0].lastLoginDate}}</span>-->\n' +
    '          </div>\n' +
    '          <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.lastLoginDate" class="p-t-5 visible-xs" >\n' +
    '            <span class="dn-item-label" translate="header.lastLogin"></span>\n' +
    '            <span class="dn-item-label">{{APP_GLOBAL_SETTINGS.userSettings.lastLoginDate | date:\'dd.MM.yyyy HH:mm:ss\'}}</span>\n' +
    '            <!--<span>{{hctrl.userSettings.result[0].lastLoginDate}}</span>-->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/contact-us.tpl.html',
    '<div class="bw-list-wrapper app-blue-card">\n' +
    '    <a href="">\n' +
    '        <div class="bw-list-item-lg">{{\'dashboard.contact\' | translate}}<i class="zmdi zmdi-bwli-icon zmdi-comments pull-right"></i></div>\n' +
    '    </a>\n' +
    '    <a href="">\n' +
    '        <div class="bw-list-item-lg">{{\'dashboard.hypoClub\' | translate}}<i class="zmdi zmdi-bwli-icon zmdi-ticket-star pull-right"></i></div>\n' +
    '    </a>\n' +
    '    <a href="">\n' +
    '        <div class="bw-list-item-lg">{{\'dashboard.etrade\' | translate}}<i class="zmdi zmdi-bwli-icon zmdi-case pull-right"></i></div>\n' +
    '    </a>\n' +
    '    <a href="">\n' +
    '        <div class="bw-list-item-lg bw-list-item-last">{{\'dashboard.branch\' | translate}}<i class="zmdi zmdi-bwli-icon zmdi-pin-drop pull-right"></i></div>\n' +
    '    </a>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/VisaCardAccountItemWidget.tpl.html',
    '<a href="" data-ng-click="dashboard.gotoAccount(account.accountId)">\n' +
    '    <div class="credit-visa-account-widget p-15 app-white-card  dashboard-widget-item">\n' +
    '        <h4>{{account.accountDescription}}</h4>\n' +
    '        <h2 class="no-bottom-margin">{{account.balance|number:2}} {{account.currencySymbol}}</h2>\n' +
    '        <p class="m-b-0">{{account.availableBalance|number:2}} {{account.currencySymbol}} available</p>\n' +
    '    </div>\n' +
    '</a>\n' +
    '<uib-progressbar style="height:10px;" value="account.availableBalance" max="account.balance"></uib-progressbar>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/SavingsAccountItemWidget.tpl.html',
    '<a href="" data-ng-click="dashboard.gotoAccount(account.accountId)">\n' +
    '    <div class="savings-account-widget p-15 app-white-card  dashboard-widget-item">\n' +
    '        <h4>{{account.accountDescription}}</h4>\n' +
    '        <h2 class="no-bottom-margin">{{account.balance|number:2}} {{account.currencySymbol}}</h2>\n' +
    '        <p class="m-b-0">{{account.availableBalance|number:2}} {{account.currencySymbol}} available</p>\n' +
    '    </div>\n' +
    '</a>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/SavingsAccountItem.tpl.html',
    '<div id="savingsAccountWidget" class="p10 app-white-card">\n' +
    '  <div class="col-md-8 wc-right-div">\n' +
    '    <h4>Car savings fund</h4>\n' +
    '    <h2 class="no-bottom-margin">35.000,000,00 RSD</h2>\n' +
    '    <p>reached of 50.000,000,00</p>\n' +
    '  </div>\n' +
    '  <div class="col-md-4 wc-left-div">\n' +
    '    <div class="wc-left-div-wrapper">\n' +
    '      <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">View savings</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/MsCardAccountItemWidget.tpl.html',
    '<a href="" data-ng-click="dashboard.gotoAccount(account.accountId)">\n' +
    '    <div class="credit-master-account-widget p-15 app-white-card  dashboard-widget-item">\n' +
    '        <h4>{{account.accountDescription}}</h4>\n' +
    '        <h2 class="no-bottom-margin">{{account.balance|number:2}} {{account.currencySymbol}}</h2>\n' +
    '        <p class="m-b-0">{{account.availableBalance|number:2}} {{account.currencySymbol}} available</p>\n' +
    '    </div>\n' +
    '</a>\n' +
    '<uib-progressbar style="height:10px;" value="55"></uib-progressbar>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/DefaultAccountItem.tpl.html',
    '<div  id="currentAccountWidget" class="p10 app-white-card">\n' +
    '  <div class="col-md-8 wc-right-div">\n' +
    '    <h4>{{account.accountDescription}}</h4>\n' +
    '    <h2 class="no-bottom-margin">{{account.balance|number:2}} {{account.currencySymbol}}</h2>\n' +
    '    <p>{{account.availableBalance|number:2}} {{account.currencySymbol}} available</p>\n' +
    '  </div>\n' +
    '  <div class="col-md-4 wc-left-div">\n' +
    '    <div class="wc-left-div-wrapper">\n' +
    '      <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue" data-ng-click="dashboard.gotoAccount(account.accountId)">View account</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/CardAccountItem.tpl.html',
    '<!--TODO: Do we have all these fields? -->\n' +
    '<div id="creditAccountWidget" class="p10 app-white-card">\n' +
    '  <div class="col-md-8 wc-right-div">\n' +
    '    <h4>{{account.accountDescription}}</h4>\n' +
    '    <h2 class="no-bottom-margin">{{account.balance}} {{account.currencySymbol}}</h2>\n' +
    '    <p>{{account.availableBalance}} {{account.currencySymbol}} available</p>\n' +
    '    <p class="no-bottom-margin">\n' +
    '      <b>Payment due date: 12//11/15</b>\n' +
    '    </p>\n' +
    '    <p>\n' +
    '      <b>Minimum payment: 20.000 RSD</b>\n' +
    '    </p>\n' +
    '  </div>\n' +
    '  <div class="col-md-4 wc-left-div">\n' +
    '    <div class="wc-left-div-wrapper">\n' +
    '      <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">View account</button>\n' +
    '      <div style="height:5px;"></div>\n' +
    '      <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue">Pay card</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('dashboard/AccountItemWidget.tpl.html',
    '<a href="" data-ng-click="dashboard.gotoAccount(account.accountId)">\n' +
    '    <div class="account-item-widget app-red-card" ng-style="account.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + account.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}" ng-if="account.accountType.group != \'LoanAccountType\'">\n' +
    '        <h4 class="acc-name c-white m-t-0 m-b-0"><b class="col-xs-10 p-0  no-wrap-text">{{::account.friendlyName}}</b> <span class="col-xs-2 p-0 t-a-r c-white"><i class="c-white" ng-class="{\'icon icon-favourite favorite-account\':account.isFavorite,\'f-24 zmdi zmdi-star-outline\':!account.isFavorite}"></i></span></h4>\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '          <span ng-if="::account.iban" class="c-white f-14  no-wrap-text fw-cm">{{::account.iban | formatIban}}</span>\n' +
    '          <span ng-if="::!account.iban" class="c-white f-14  no-wrap-text fw-cm">{{::account.accountNumber}}</span>\n' +
    '        </div>\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '          <span ng-if="account.accountNumber && account.accountType.group == \'CardAccountTypes\' || !account.iban && account.accountType.group != \'CardAccountTypes\'" class="c-white f-14  no-wrap-text fw-cm">{{::account.accountNumber}}</span>\n' +
    '          <span ng-if="account.iban && account.accountType.group != \'CardAccountTypes\'" class="c-white f-14  no-wrap-text fw-cm">{{::account.iban | formatIban}}</span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="::account.accountType.group !== \'SavingAccountTypes\' && account.accountType.group !== \'DepositAccountTypes\'">\n' +
    '\n' +
    '            <amount-formatter amount="{{account.balance|number:2}}" custom-classes="{{\'c-white\'}}" currency="{{::account.currencySymbol}}" from-type="dashboard" aditional-val="{{account.availableBalance|number:2}}" has-underline="true">\n' +
    '            </amount-formatter>\n' +
    '            <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && account.accountType.group == \'CardAccountTypes\'" translate="accounts.accBalance" class="c-white balance-label m-t-5 m-b-0">Available balance</p>\n' +
    '            <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\' ||  account.accountType.group != \'CardAccountTypes\'" translate="accounts.balance" class="c-white balance-label m-t-5 m-b-0">Available balance</p>\n' +
    '        </div>\n' +
    '        <div ng-if="::(account.accountType.group === \'SavingAccountTypes\' || account.accountType.group === \'DepositAccountTypes\')">\n' +
    '            <amount-formatter amount="{{account.balance|number:2}}" custom-classes="{{\'c-white\'}}" currency="{{::account.currencySymbol}}" from-type="dashboard" aditional-val="{{account.balance|number:2}}" has-underline="true">\n' +
    '            </amount-formatter>\n' +
    '            <p translate="navigation.balance" class="c-white balance-label m-t-5 m-b-0">Balance</p>\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="account-item-widget app-red-card" ng-if="::account.accountType.group == \'LoanAccountType\'" ng-style="account.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + account.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '\n' +
    '        <h4 class="acc-name c-white m-t-0 m-b-0"><b class="col-xs-10 p-0  no-wrap-text">{{::account.friendlyName}} </b> <span class="col-xs-2 p-0 t-a-r c-white"><i class="c-white" ng-class="{\'icon icon-favourite favorite-account\':account.isFavorite,\'zmdi zmdi-star-outline\':!account.isFavorite}"></i></span></h4>\n' +
    '        <span ng-if="::account.iban" class="c-white f-14  no-wrap-text" fw-cm>{{::account.iban | formatIban}}</span>\n' +
    '        <span ng-if="::!account.iban" class="c-white f-14  no-wrap-text" fw-cm>{{::account.accountNumber}}</span>\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '          <amount-formatter amount="{{account.balance|number:2}}" custom-classes="{{\'c-white\'}}" currency="EUR" from-type="dashboard" aditional-val="{{account.loanAccount.loanAmount|number:2}}" has-underline="true">\n' +
    '          </amount-formatter>\n' +
    '          <p translate="navigation.loanBalance" class="c-white balance-label m-t-5 m-b-0">Loan amount</p>\n' +
    '        </div>\n' +
    '        <!-- ZA SRB I MNE -->\n' +
    '        <div ng-if="::(dashboard.countryCode !== \'hr\' && loansOverview.countryCode !== \'hr\') && (dashboard.countryCode !== \'sl\' && loansOverview.countryCode !== \'sl\')">\n' +
    '            <amount-formatter amount="{{account.balance|number:2}}" custom-classes="{{\'c-white\'}}" currency="{{::account.currencySymbol}}" from-type="dashboard" aditional-val="{{account.loanAccount.loanAmount|number:2}}" has-underline="true">\n' +
    '            </amount-formatter>\n' +
    '            <p translate="navigation.loanBalance" class="c-white balance-label m-t-5 m-b-0">Loan amount</p>\n' +
    '        </div>\n' +
    '        <!-- ZA CRO -->\n' +
    '        <div ng-if="::(dashboard.countryCode === \'hr\' || loansOverview.countryCode === \'hr\')">\n' +
    '            <amount-formatter ng-if="::!account.loanAccount.loanAmountCurrencySymbol" amount="{{account.loanAccount.loanAmount|number:2}}" custom-classes="{{\'c-white\'}}" currency="{{::account.currencySymbol}}" from-type="dashboard" aditional-val="{{account.balance|number:2}}" has-underline="true">\n' +
    '            </amount-formatter>\n' +
    '            <amount-formatter ng-if="::account.loanAccount.loanAmountCurrencySymbol" amount="{{account.loanAccount.loanAmount|number:2}}" custom-classes="{{\'c-white\'}}" currency="{{::account.loanAccount.loanAmountCurrencySymbol}}" from-type="dashboard" aditional-val="{{account.balance|number:2}}" has-underline="true">\n' +
    '            </amount-formatter>\n' +
    '            <p translate="dashboard.loanAmount" class="c-white balance-label m-t-5 m-b-0">Loan amount</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</a>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('core/scrollable-directive.tpl.html',
    '<div>{{scrollable.name}}</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('core/logout-confirm-modal.tpl.html',
    '<div class="statementModal logout-modal-frame"> \n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X--> \n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div  style="color: white; padding-top: 50px;">\n' +
    '         \n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-2 col-sm-3 col-xs-3">\n' +
    '        <i class="icon icon-circle icon-logout"></i>\n' +
    '      </div>\n' +
    '      <div class="col-md-10 col-sm-9 col-xs-9">\n' +
    '          <div class="logout-modal-header" translate="core.logoutModalTranslation.logoutMsg">Do you really want to log out?</div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(\'logout\')" translate="core.logoutModalTranslation.logoutBtn">Log out</button>\n' +
    '    <button class="btn btn-primary-red statementBtnClose logout-btns" ng-click="$close()" translate="core.logoutModalTranslation.cancel">Cancel</button>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('core/headroom-directive.tpl.html',
    '<div>{{headroom.name}}</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('core/error-alert-template.tpl.html',
    '<div class="ui-notification error-alert-container">\n' +
    '  <div class="error-alert-close-btn">\n' +
    '    <i class="icon icon-close"></i>\n' +
    '  </div>\n' +
    '  <div class="error-alert-mark">\n' +
    '    <i class="icon icon-warning"></i>\n' +
    '  </div>\n' +
    '  <div class="error-alert-content">\n' +
    '    <h3 ng-show="title" ng-bind-html="title" class="error-alert-title"></h3>\n' +
    '    <div class="message error-alert-body" ng-bind-html="message"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('core/core.tpl.html',
    '<h2>core</h2>\n' +
    '<p>{{core.ctrlName}}</p>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('core/auto-focus-directive.tpl.html',
    '<div>{{autoFocus.name}}</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('core/amount-formatter-directive.tpl.html',
    '<div class="amount-formater-wrapper no-wrap-text" ng-class="{\'has-underline\':amountFormatter.hasUnderline}">\n' +
    '  <span class="{{amountFormatter.customCss + \' \' + amountFormatter.fontClasses[0]}}">{{amountFormatter.amountObj.intPart}}</span>\n' +
    '  <span class="{{amountFormatter.customCss + \' \' + amountFormatter.fontClasses[1]}}">{{amountFormatter.amountObj.decimal}}</span>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('blockade/blockade.tpl.html',
    '<div id="main">\n' +
    '  <div class="container-fluid p-t-15">\n' +
    '    <h2 class="m-l-0 f-28 m-t-0 m-b-0 title-style" translate="blockade.title">Block Addiko EBank and/or Addiko\n' +
    '      mobile</h2>\n' +
    '    <div ng-show="vm.steps.input" class="alert alert-info m-t-10"\n' +
    '         style="background: white; color: black; border: 1px solid lightgray">\n' +
    '      <p translate="blockade.info1"></p>\n' +
    '      <p translate="blockade.info2"></p>\n' +
    '    </div>\n' +
    '    <!-- ================= -->\n' +
    '    <!-- START: Step Input-->\n' +
    '    <!-- ================= -->\n' +
    '    <ng-form ng-show="vm.steps.input" name="vm.blockadeForm">\n' +
    '      <div class="domp-from-section p-15 m-t-25">\n' +
    '        <div class="row">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-3">\n' +
    '              <label class="domp-form-label" translate="blockade.blockadeReason">Blockade reason:</label>\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '              <textarea name="blockadeReason" class="form-control" rows="5"\n' +
    '                        ng-model="vm.model.reason"\n' +
    '                        style="resize: none"\n' +
    '                        maxlength="255"\n' +
    '                        required>\n' +
    '              </textarea>\n' +
    '              <span class="c-red" ng-show="vm.formSubmitted && vm.blockadeForm.blockadeReason.$error.required">\n' +
    '                <span translate="blockade.errors.requiredField"></span>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-20">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-3">\n' +
    '              <label class="domp-form-label" translate="blockade.blockadeOf">Blockade of:</label>\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '              <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                <input name="blockWeb" type="checkbox" ng-model="vm.model.blockWeb"\n' +
    '                       ng-required="!vm.model.blockMobile">\n' +
    '                <i class="input-helper"></i>\n' +
    '                Addiko EBank\n' +
    '              </label>\n' +
    '              <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value">\n' +
    '                <input name="blockMobile" type="checkbox" ng-model="vm.model.blockMobile"\n' +
    '                       ng-required="!vm.model.blockWeb">\n' +
    '                <i class="input-helper"></i>\n' +
    '                Addiko Mobile\n' +
    '              </label>\n' +
    '              <span class="c-red"\n' +
    '                    ng-show="vm.formSubmitted && (vm.blockadeForm.blockWeb.$error.required || vm.blockadeForm.blockMobile.$error.required)">\n' +
    '                    <span translate="blockade.errors.blockadeOfErr"></span>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-20">\n' +
    '          <div class="form-group clearfix">\n' +
    '            <div class="col-md-3">\n' +
    '              <label class="domp-form-label" translate="blockade.timeRestrictedBlockade">\n' +
    '                Time-restricted blockade:\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="col-md-6 p-0">\n' +
    '              <div class="col-md-12">\n' +
    '                <label class="pointer">\n' +
    '                  <input type="radio" name="optradio" ng-model="vm.model.temporary" ng-value="false">\n' +
    '                  <i class="input-helper"></i>\n' +
    '                  <span translate="alert.no"></span>\n' +
    '                </label>\n' +
    '\n' +
    '                <p class="m-t-10" translate="blockade.timeRestrictedBlockadeText"></p>\n' +
    '\n' +
    '                <label class="pointer">\n' +
    '                  <input type="radio" name="optradio" ng-model="vm.model.temporary" ng-value="true">\n' +
    '                  <i class="input-helper"></i>\n' +
    '                  <span translate="alert.yes"></span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '              <div ng-if="vm.model.temporary" class="m-t-15 clearfix">\n' +
    '                <!-- START Date from - datepicker -->\n' +
    '                <div class="col-lg-6 col-md-6 col-sm-6 m-t-10">\n' +
    '                  <label translate="blockade.dateFrom">Date from</label>\n' +
    '                  <div class="input-group ">\n' +
    '                    <input name="dateFrom" type="text" class="form-control input-field"\n' +
    '                           uib-datepicker-popup="shortDate"\n' +
    '                           data-ng-model="vm.model.dateFrom"\n' +
    '                           show-weeks="false" is-open="vm.isFromDateDPOpen"\n' +
    '                           datepicker-options="vm.dateFromOptions"\n' +
    '                           ng-required="vm.model.temporary"\n' +
    '                           ng-change="vm.onDateFromChange()"\n' +
    '                           readonly>\n' +
    '                    <span class="input-group-btn">\n' +
    '                    <button ng-readonly="domesticPaymentSlo.disableAllFields"\n' +
    '                            data-ng-click="vm.isFromDateDPOpen = !vm.isFromDateDPOpen" type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                            style="border:1px solid #062a42;">\n' +
    '                      <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <!-- END Date from - datepicker -->\n' +
    '                <!-- START Date to- datepicker -->\n' +
    '                <div class="col-lg-6 col-md-6 col-sm-6 m-t-10">\n' +
    '                  <label translate="blockade.dateTo">Date to</label>\n' +
    '                  <div class="input-group ">\n' +
    '                    <input name="dateTo" type="text" class="form-control input-field"\n' +
    '                           uib-datepicker-popup="shortDate"\n' +
    '                           data-ng-model="vm.model.dateTo"\n' +
    '                           show-weeks="false" is-open="vm.isToDateDPOpen"\n' +
    '                           datepicker-options="vm.dateToOptions"\n' +
    '                           ng-required="vm.model.temporary"\n' +
    '                           readonly>\n' +
    '                    <span class="input-group-btn">\n' +
    '                    <button ng-readonly="domesticPaymentSlo.disableAllFields"\n' +
    '                            data-ng-click="vm.isToDateDPOpen = !vm.isToDateDPOpen" type="button"\n' +
    '                            class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                            style="border:1px solid #062a42;">\n' +
    '                      <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                    </button>\n' +
    '                  </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <!-- END Date to- datepicker -->\n' +
    '              </div>\n' +
    '              <span class="c-red"\n' +
    '                    ng-show="vm.formSubmitted && (vm.blockadeForm.datefrom.$error.required || vm.blockadeForm.dateTo.$error.required)">\n' +
    '                <span translate="blockade.errors.dateToAndFromRequired"></span>\n' +
    '              </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row  m-t-25">\n' +
    '        <div class="form-group clearfix">\n' +
    '          <div class="col-md-12">\n' +
    '            <button class="btn btn-primary pull-left" translate="payments.cancel" ui-sref="settings"></button>\n' +
    '            <button class="btn btn-default pull-right" translate="orders.next" ng-click="vm.next()"></button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </ng-form>\n' +
    '    <!-- ================= -->\n' +
    '    <!-- END: Step Input-->\n' +
    '    <!-- ================= -->\n' +
    '\n' +
    '    <!-- ================= -->\n' +
    '    <!-- START: Step Resume -->\n' +
    '    <!-- ================= -->\n' +
    '    <div ng-if="vm.steps.resume">\n' +
    '      <div class="domp-from-section p-15 m-t-25">\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-3">\n' +
    '              <label class="domp-form-label" translate="blockade.orderDate"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '              <b>{{vm.model.dateCreated | date: \'dd.MM.yyyy HH:mm:ss\'}}</b>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-3">\n' +
    '              <label class="domp-form-label" translate="blockade.orderTypeLabel"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '              <p>\n' +
    '                <b>\n' +
    '                  <span translate="blockade.orderTypeText"></span>\n' +
    '                  <span ng-if="vm.model.blockWeb">Addiko EBank</span>\n' +
    '                  <span ng-if="vm.model.blockWeb && vm.model.blockMobile" translate="blockade.and"></span>\n' +
    '                  <span ng-if="vm.model.blockMobile">Addiko Mobile</span>\n' +
    '                </b>\n' +
    '              </p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-3">\n' +
    '              <label class="domp-form-label" translate="blockade.blockadeTypeLabel"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '              <p ng-if="vm.model.temporary">\n' +
    '                <b>\n' +
    '                  <span translate="blockade.blockadeTypeText"></span>\n' +
    '                  <span> {{vm.model.dateFrom | date: \'shortDate\'}}</span>\n' +
    '                  <span translate="blockade.and"></span>\n' +
    '                  <span> {{vm.model.dateTo | date: \'shortDate\'}}</span>\n' +
    '                </b>\n' +
    '              </p>\n' +
    '              <p ng-if="!vm.model.temporary">\n' +
    '                <b>\n' +
    '                  <span translate="blockade.blockadeUnrestricted"></span>\n' +
    '                </b>\n' +
    '              </p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="form-group">\n' +
    '            <div class="col-md-3">\n' +
    '              <label class="domp-form-label" translate="blockade.blockadeReason"></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '              <p style="word-wrap: break-word;">\n' +
    '                <b>{{vm.model.reason}}</b>\n' +
    '              </p>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row  m-t-25">\n' +
    '        <div class="form-group clearfix">\n' +
    '          <div class="col-md-12">\n' +
    '            <button class="btn btn-primary pull-left" translate="domesticPayment.back"\n' +
    '                    ng-click="vm.steps.resume = false; vm.steps.input = true;"></button>\n' +
    '            <button class="btn btn-default pull-right" translate="termDeposit.confirmBtnLabel"\n' +
    '                    ng-click="vm.confirm()"></button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- ================= -->\n' +
    '    <!-- END: Step Resume -->\n' +
    '    <!-- ================= -->\n' +
    '    <!-- ================= -->\n' +
    '    <!-- START: Step Finish -->\n' +
    '    <!-- ================= -->\n' +
    '    <div ng-if="vm.steps.finish" class="m-t-25">\n' +
    '      <div class="payment-successful-wrapper">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '            <div class="currency-check-icon msg-pad">\n' +
    '              <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-10 m-t-30 m-b-30">\n' +
    '            <h2 class="c-white f-28" translate="blockade.blockadeFinishedTitle"></h2>\n' +
    '            <p ng-if="vm.model.temporary">\n' +
    '              <span translate="blockade.blockadeFinishedMsg1"></span>\n' +
    '              <span> {{vm.model.dateFrom | date: \'shortDate\'}}</span>\n' +
    '              <span translate="blockade.and"></span>\n' +
    '              <span> {{vm.model.dateTo | date: \'shortDate\'}}</span>\n' +
    '              <span translate="blockade.blockadeFinishedMsg2"></span>\n' +
    '              <span ng-if="vm.model.blockWeb">Addiko EBank</span>\n' +
    '              <span ng-if="vm.model.blockWeb && vm.model.blockMobile" translate="blockade.and"></span>\n' +
    '              <span ng-if="vm.model.blockMobile">Addiko Mobile</span>\n' +
    '              <span translate="blockade.blockadeFinishedMsg3"></span>\n' +
    '            </p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!--<div class="row">-->\n' +
    '      <!--<div class="col-md-4">-->\n' +
    '      <!--<a href="" data-ng-click="termDeposit.newTermDeposit()">-->\n' +
    '      <!--<span class="money-exchange-icon"><i class="icon icon-einvoice zmdi-hc-2x"></i></span>-->\n' +
    '      <!--<span class="f-18 money-exchange-text" translate="termDeposit.newDepositOrder"></span>-->\n' +
    '      <!--</a>-->\n' +
    '      <!--</div>-->\n' +
    '      <!--</div>-->\n' +
    '    </div>\n' +
    '    <!-- ================= -->\n' +
    '    <!-- END: Step Finish -->\n' +
    '    <!-- ================= -->\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/viber-deactivation.tpl.html',
    '<div>\n' +
    '\n' +
    '  <div class="row p-0 m-0" style="height: 50px; background-color: #ff4d5a;">\n' +
    '    <div class="col-md-11 c-white t-a-c">\n' +
    '      <p class="viber-deactivation-title">Addiko Chat Banking</p>\n' +
    '    </div>\n' +
    '    <div class="col-md-1">\n' +
    '      <div class="c-white">\n' +
    '        <i class="icon icon-add pull-right close-icon-x" ng-click="$close()" style="font-size: 40px;"></i>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="alert-msg-frame">\n' +
    '    <div class="row t-a-c m-t-10 m-b-10">\n' +
    '      <div class="f-18 m-t-10 m-b-10" translate="viber.deactivateModalText">Da li ste sigurni da želite da deaktivirate Addiko Viber Banking uslugu?</div>\n' +
    '    </div>\n' +
    '    <div class="row p-b-20 t-a-c">\n' +
    '      <div class="col-sm-12">\n' +
    '        <button class="btn btn-default viber-w-btn" translate="viber.deactivate" ng-click="$close(true)">Deaktiviraj</button>\n' +
    '      </div>\n' +
    '      <div class="col-sm-12 m-t-10">\n' +
    '        <button class="btn btn-primary viber-w-btn" translate="viber.cancel" ng-click="$close(false)">Odustani</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/update-mobile-setting.tpl.html',
    '<div class="modal-header">\n' +
    '  <h3 translate="settings.unsubscribeAlertHeader"></h3>\n' +
    '</div>\n' +
    '<div class="modal-body text-center">\n' +
    '  <p translate="settings.unsubscribeText"></p>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12">\n' +
    '      <button class="btn btn-default" ng-click="$close(false)"><span\n' +
    '        translate="alert.no"></span></button>\n' +
    '      <button class="btn btn-default" ng-click="$close(true)"><span\n' +
    '        translate="alert.yes"></span></button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/reject-e-document-alert.tpl.html',
    '<div class="modal-header smsModalHeader">\n' +
    '  <div class="row">\n' +
    '    <div class="col-xs-12" translate="eInvoicesModal.rejectDocumentAlert.headerText"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="p-t-20">\n' +
    '  <div class="modal-body">\n' +
    '    <div class="row p-b-10">\n' +
    '      <div class="col-xs-12">\n' +
    '          <div class="form-group">\n' +
    '            <label class="domp-form-label-review" translate="eInvoicesModal.rejectDocumentAlert.labelText"></label>\n' +
    '            <input type="text" class="form-control input-field" name="note" id="note"\n' +
    '                   required\n' +
    '                   maxlength="200"\n' +
    '                   ng-class="{\'domp-error\': vm.tempObj.form.note$invalid && vm.tempObj.formSubmitted}"\n' +
    '                   ng-model="vm.tempObj.note">\n' +
    '          </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="modal-footer">\n' +
    '    <div class="col-xs-12">\n' +
    '      <button class="btn btn-default m-5 pull-right" ng-click="$close(false);" translate="payments.cancel"></button>\n' +
    '      <button class="btn btn-default m-5 pull-right" ng-click="$close(vm.tempObj.note);"\n' +
    '              translate="domesticPayment.confirmBtn">\n' +
    '      </button>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/payments-return-info.tpl.html',
    '<div class="modal-header statement-confirm-header p-10">\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-body text-center">\n' +
    '  <h3 translate="accounts.title">Information</h3>\n' +
    '    <span translate="alert.paymentsReturnText"></span>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12">\n' +
    '      <button class="btn btn-default" ng-click="$close()"><span\n' +
    '        translate="accounts.close"></span></button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/info-alert.tpl.html',
    '<div class="statementModal alert-msg-frame">\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div style="color: white; padding-top: 43px;">\n' +
    '      <!--    <i class="icon icon-add pull-right close-icon-x" ng-click="$close()" style="font-size: 40px;"></i>-->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-2 col-sm-3 col-xs-2">\n' +
    '        <i class="icon alert-icon icon-info alert-icon-f"></i>\n' +
    '      </div>\n' +
    '      <div class="col-md-10 col-sm-9 col-xs-10">\n' +
    '        <span class="c-white alert-msg" translate="alert.information"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-12">\n' +
    '        <div class="logout-modal-header-2">\n' +
    '          <span>{{vm.data.text | translate}} </span><span>{{vm.data.id}}</span><span> {{vm.data.text2 | translate}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close()" translate="alert.cancel">Ok</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/image-alert.tpl.html',
    '<div class="statementModal alert-msg-frame">\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div style="color: white; padding-top: 43px;">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-2 col-sm-3 col-xs-2">\n' +
    '        <i class="icon alert-icon icon-info alert-icon-f"></i>\n' +
    '      </div>\n' +
    '      <div class="col-md-10 col-sm-9 col-xs-10">\n' +
    '        <span class="c-white alert-msg" translate="alert.qrCode"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row" ng-if="vm.data.msg">\n' +
    '      <div class="col-sm-12">\n' +
    '        {{vm.data.msg}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-12">\n' +
    '        <div class="logout-modal-header-2 t-a-c">\n' +
    '          <image width="150" height="150" data-ng-src="{{\'data:image/bmp;base64,\' + vm.data.baseUrl}}"></image>\n' +
    '        </div>\n' +
    '        <!--<image width="150" height="150" data-ng-src="{{\'data:image/png;base64,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\'}}"> </image>-->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close()" translate="alert.cancel">Ok</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/deleted-payment-alert.tpl.html',
    '<div class="statementModal alert-msg-frame">\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div style="color: white; padding-top: 43px;">\n' +
    '          <!--     <i class="icon icon-add pull-right close-icon-x" ng-click="$close()" style="font-size: 40px;"></i> -->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-2 col-sm-3 col-xs-2">\n' +
    '        <i class="icon alert-icon icon-delete alert-icon-f"></i>\n' +
    '      </div>\n' +
    '      <div class="col-md-10 col-sm-9 col-xs-10">\n' +
    '        <span class="c-white alert-msg" translate="alert.deleteAction"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="logout-modal-header-2 col-sm-12" ng-switch="vm.data.type">\n' +
    '        <div ng-switch-when="payment">\n' +
    '          {{\'alert.payment\' | translate}}\n' +
    '          "{{vm.data.paymentName}}" {{"paymentTemplates.deleteSuccess2"| translate}}\n' +
    '        </div>\n' +
    '        <div ng-switch-when="template">\n' +
    '          {{\'paymentTemplates.deleteSuccess1\' | translate}}\n' +
    '          "{{vm.data.paymentName}}" {{"paymentTemplates.deleteSuccess2"| translate}}\n' +
    '        </div>\n' +
    '        <div ng-switch-when="investment">\n' +
    '          {{\'alert.investment\' | translate}}\n' +
    '          "{{vm.data.paymentName}}" {{"paymentTemplates.deleteSuccess2"| translate}}\n' +
    '        </div>\n' +
    '        <div ng-switch-when="termDeposit">\n' +
    '          {{\'alert.termDeposit\' | translate}}\n' +
    '          "{{vm.data.paymentName}}" {{"paymentTemplates.deleteSuccess2"| translate}}\n' +
    '        </div>\n' +
    '        <div ng-switch-when="eSavingBook">\n' +
    '          {{\'alert.ebookOrder\' | translate}}\n' +
    '          "{{vm.data.paymentName}}" {{"paymentTemplates.deleteSuccess2"| translate}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close()">Ok</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/confirmation-alert.tpl.html',
    '<div class="statementModal alert-msg-frame">\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div style="color: white; padding-top: 43px;">\n' +
    '          <!--  <i class="icon icon-add pull-right close-icon-x" ng-click="$close(false)"  style="font-size: 40px;"></i> -->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-2 col-sm-3 col-xs-2">\n' +
    '        <i class="icon alert-icon icon-warning alert-icon-f"></i>\n' +
    '      </div>\n' +
    '      <div class="col-md-10 col-sm-9 col-xs-10">\n' +
    '        <span ng-if="vm.data.text" class="logout-modal-header-2">{{vm.data.text | translate}}</span>\n' +
    '        <span ng-if="!vm.data.text" class="c-white alert-msg" translate="alert.areYouSure"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(true)"\n' +
    '            translate="alert.yes">Yes\n' +
    '    </button>\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(false)"\n' +
    '            translate="alert.no">No\n' +
    '    </button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/block-card-alert.tpl.html',
    '<div class="statementModal logout-modal-frame">\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div style="color: white; padding-top: 43px;">\n' +
    '       <!--   <i class="icon icon-add pull-right close-icon-x" ng-click="$close()"></i> -->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-2 col-sm-3 col-xs-3">\n' +
    '        <i class="icon alert-icon icon-info alert-icon-f"></i>\n' +
    '      </div>\n' +
    '      <div class="col-md-10 col-sm-9 col-xs-9">\n' +
    '        <span class="c-white alert-msg" translate="alert.blockCardInfo"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose" ng-click="$close()" translate="alert.cancel">Ok</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/archive-einvoice-alert.tpl.html',
    '<div class="statementModal alert-msg-frame">\n' +
    '  <div class="modal-body p-0">\n' +
    '    <!--X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div style="color: white; padding-top: 43px;">\n' +
    '          <!--  <i class="icon icon-add pull-right close-icon-x" ng-click="$close(false)"  style="font-size: 40px;"></i> -->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!--END X-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-2 col-sm-3 col-xs-2">\n' +
    '        <i class="icon alert-icon icon-warning alert-icon-f"></i>\n' +
    '      </div>\n' +
    '      <div class="col-md-10 col-sm-9 col-xs-10">\n' +
    '        <p ng-if="vm.data.text" class="logout-modal-header-2" translate="eInvoicesModal.msg1"></p>\n' +
    '        <p ng-if="vm.data.text" class="logout-modal-header-2" translate="eInvoicesModal.msg2"></p>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer modal-footer-padding">\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(true)"\n' +
    '            translate="eInvoicesModal.confirm">Yes\n' +
    '    </button>\n' +
    '    <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(false)"\n' +
    '            translate="eInvoicesModal.cancel">No\n' +
    '    </button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/alert.tpl.html',
    '<h2>alert</h2>\n' +
    '<p>{{alert.ctrlName}}</p>\n' +
    '\n' +
    '<div><span></span></div>\n' +
    '<div>"Click me"</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/transactions-filter-directive.tpl.html',
    '<!-- TRANSACTION FILTER DIRECTIVE START -->\n' +
    '<div class="tml-filter-container tmlf-wide"\n' +
    '         stlye="overflow: hidden; margin: 15px">\n' +
    '      <!-- START Search text input -->\n' +
    '      <div class="inner-section left">\n' +
    '        <i class="icon icon-search  icon-hc-2x m-l-5"></i>\n' +
    '      </div>\n' +
    '      <div class="inner-section center">\n' +
    '        <input type="text" class="search-input"\n' +
    '               placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '               ng-model="vm.transactionFilterOptions.genericSearch" ng-model-options="{ debounce: 300 }"\n' +
    '               ng-change="vm.search()">\n' +
    '      </div>\n' +
    '      <div  class="inner-section right">\n' +
    '        <i class="icon icon-filter icon-hc-2x i-r-0" style="z-index: 100000"\n' +
    '           ng-show="!vm.transactionFilterOptions.genericSearch"\n' +
    '           ng-click="vm.showFilterOptionsWrapper = !vm.showFilterOptionsWrapper">\n' +
    '        </i>\n' +
    '        <i class="zmdi zmdi-tag-close  zmdi-hc-2x m-r-0"\n' +
    '           ng-show="vm.transactionFilterOptions.genericSearch"\n' +
    '           ng-click="vm.clearSearch();">\n' +
    '        </i>\n' +
    '      </div>\n' +
    '      <div class="tml-filter-selection" ng-class="{\'opened\': vm.showFilterOptionsWrapper, \'h-510\': ((vm.dateFromOpen || vm.dateToOpen) && vm.countryCode == \'sl\')}"\n' +
    '           style="z-index: 6">\n' +
    '        <div class="tml-filter-type-selection-wrapper">\n' +
    '          <div ng-class="{\'selected\': vm.transactionFilterOptions.transactionType === undefined}" class="tmlf-type-item"\n' +
    '               ng-click="vm.transactionFilterOptions.transactionType = undefined"\n' +
    '               translate="timelineFilter.all"\n' +
    '               style="width: 33.333%">\n' +
    '          </div>\n' +
    '          <div ng-class="{\'selected\': vm.transactionFilterOptions.transactionType == \'Credit\'}" class="tmlf-type-item"\n' +
    '               style="width: 33.333%"\n' +
    '               ng-click="vm.transactionFilterOptions.transactionType = \'Credit\'"\n' +
    '               translate="timelineFilter.credit"></div>\n' +
    '          <div ng-class="{\'selected\': vm.transactionFilterOptions.transactionType == \'Debit\'}" class="tmlf-type-item"\n' +
    '               style="width: 33.333%"\n' +
    '               ng-click="vm.transactionFilterOptions.transactionType = \'Debit\'"\n' +
    '               translate="timelineFilter.debit"></div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="vm.showStatementsFilter" class="m-t-15" style="overflow:auto">\n' +
    '          <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '            <div class="form-group">\n' +
    '              <label class="f-12-s" translate="transactions.statementsFilter"></label>\n' +
    '              <select class="form-control-db"\n' +
    '                      ng-options="option | date:\'shortDate\' for option in vm.statementDates"\n' +
    '                      ng-model="vm.transactionFilterOptions.selectedStatementDate">\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <!-- START: Row Date from and date to -->\n' +
    '        <div class="m-t-15 clearfix" ng-if="vm.allowCustomDatepicker">\n' +
    '          <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '            <div class="form-group m-b-0">\n' +
    '              <label class="f-12-s" translate="repaymentPlan.dateFrom">Date from</label>\n' +
    '              <div class="input-group">\n' +
    '                <input type="text" class="form-control-db"\n' +
    '                       ng-value="vm.transactionFilterOptions.dateFrom | date: \'shortDate\'"\n' +
    '                       readonly>\n' +
    '                <span class="input-group-btn">\n' +
    '                  <button data-ng-click="vm.dateFromOpen = !vm.dateFromOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 p-l-0 p-r-5">\n' +
    '            <div class="form-group m-b-0">\n' +
    '              <label class="f-12-s" translate="repaymentPlan.dateTo">Date to</label>\n' +
    '              <div class="input-group ">\n' +
    '                <input type="text" class="form-control-db"\n' +
    '                       ng-value="vm.transactionFilterOptions.dateTo | date: \'shortDate\'"\n' +
    '                       readonly>\n' +
    '                <span class="input-group-btn">\n' +
    '                  <button data-ng-click="vm.dateToOpen = !vm.dateToOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- Datepickers -->\n' +
    '          <div class="col-xs-6 p-l-0 p-r-5">\n' +
    '            <!-- Date from datepicker-->\n' +
    '            <div data-ng-model="vm.transactionFilterOptions.dateFrom"\n' +
    '                 show-weeks="false"\n' +
    '                 is-open="vm.dateFromOpen"\n' +
    '                 ng-change="vm.onDateFromChange()"\n' +
    '                 uib-datepicker-popup="shortDate">\n' +
    '            </div>\n' +
    '            <!-- Date to datepicker-->\n' +
    '            <div data-ng-model="vm.transactionFilterOptions.dateTo"\n' +
    '                 show-weeks="false"\n' +
    '                 is-open="vm.dateToOpen"\n' +
    '                 date-disabled="vm.datesToDisabled(date, mode)"\n' +
    '                 uib-datepicker-popup="shortDate">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END: Row Date from and date to -->\n' +
    '\n' +
    '        <div class="m-t-15" style="overflow:auto">\n' +
    '          <div class="col-xs-5 p-l-5 p-r-5">\n' +
    '            <div class="form-group">\n' +
    '              <label class="f-12-s" translate="timelineFilter.amountFrom"></label>\n' +
    '              <input ng-keyup="$event.keyCode == 13 && vm.applyFilter()" type="text" class="form-control-db"\n' +
    '                     ng-model="vm.transactionFilterOptions.amountGTE"\n' +
    '                     amount-input-mask maxlength="12"\n' +
    '                     placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" autocomplete="off">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-4 p-l-0 p-r-5">\n' +
    '            <div class="form-group">\n' +
    '              <label class="f-12-s" translate="timelineFilter.amountTo"></label>\n' +
    '              <input ng-keyup="$event.keyCode == 13 && vm.applyFilter()" type="text" class="form-control-db"\n' +
    '                     ng-model="vm.transactionFilterOptions.amountLTE"\n' +
    '                     amount-input-mask maxlength="12"\n' +
    '                     placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" autocomplete="off">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-3 p-l-0 p-r-5 p-t-25">\n' +
    '            <select class="form-control-db"\n' +
    '                    ng-options="option.symbol as option.symbol for option in vm.currenciesList"\n' +
    '                    ng-model="vm.transactionFilterOptions.currencySymbol">\n' +
    '            </select>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="m-b-15" style="overflow:auto">\n' +
    '          <div class="col-xs-6 t-a-l p-l-5">\n' +
    '            <button class="btn btn-primary app-btn-gray ng-scope" ng-click="vm.resetFilter();"\n' +
    '                    translate="timelineFilter.reset">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 t-a-r p-r-5">\n' +
    '            <button class="btn btn-default app-btn-blue w-100" ng-click="vm.applyFilter();"\n' +
    '                    translate="timelineFilter.apply">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Detail filter expanded -->\n' +
    '\n' +
    '    </div>\n' +
    '<!-- TRANSACTION FILTER DIRECTIVE END -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/transaction-division.tpl.html',
    '<form novalidate name="transactionDivision.tDivForm">\n' +
    '  <div class="row">\n' +
    '    <div class="col-sm-12">\n' +
    '      <div class="container domp-from-section">\n' +
    '        <div class="row p-15">\n' +
    '          <!--<div class="col-sm-6">-->\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="creationDate"\n' +
    '                       translate="transactionDivision.creationDate"></label>\n' +
    '                <input type="text" id="creationDate" class="form-control input-field"\n' +
    '                       data-ng-model="transactionDivision.tempTransDivObj.creationDate" disabled>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="fullName"\n' +
    '                       translate="transactionDivision.fullName"></label>\n' +
    '                <input type="text" id="fullName" class="form-control input-field"\n' +
    '                       data-ng-model="transactionDivision.tempTransDivObj.fullName" disabled>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="jmbg" translate="transactionDivision.jmbg"></label>\n' +
    '                <input type="text" id="jmbg" class="form-control input-field"\n' +
    '                       data-ng-model="transactionDivision.tempTransDivObj.jmbg" disabled>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="transactionDivision.transactionId || transactionDivision.reservationId" class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="reservationID" translate="transactionDivision.reservationNumber"></label>\n' +
    '                <input type="text" id="reservationID" class="form-control input-field"\n' +
    '                       data-ng-model="transactionDivision.tempTransDivObj.reservationID" disabled>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="transactionDate"\n' +
    '                       translate="transactionDivision.transactionDate"></label>\n' +
    '                <div class="input-group ">\n' +
    '                  <input type="text" class="form-control input-field" name="transactionDate" id="transactionDate"\n' +
    '                         uib-datepicker-popup="shortDate"\n' +
    '                         data-ng-model="transactionDivision.tempTransDivObj.transactionDate" show-weeks="false"\n' +
    '                         is-open="transactionDivision.datePickerBeginOpened"\n' +
    '                         datepicker-options="transactionDivision.dateOptions"\n' +
    '                         ng-class="{ \'domp-error\' : transactionDivision.tDivForm.transactionDate.$invalid && transactionDivision.formSubmitted}"\n' +
    '                         required\n' +
    '                         readonly>\n' +
    '                          <span class="input-group-btn">\n' +
    '                            <button\n' +
    '                              data-ng-click="transactionDivision.datePickerBeginOpened = !transactionDivision.datePickerBeginOpened"\n' +
    '                              type="button"\n' +
    '                              class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                              style="border:1px solid #062a42;">\n' +
    '                              <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                            </button>\n' +
    '                          </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '                    <span class="c-red"\n' +
    '                          ng-show="transactionDivision.tDivForm.transactionDate.$error.required && transactionDivision.formSubmitted"\n' +
    '                          translate="orders.dateRequired"></span>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="amountInput"\n' +
    '                       translate="domesticPayment.amountInputLabel"></label>\n' +
    '                <div class="input-group">\n' +
    '                  <input type="text" class="form-control input-field t-a-r" name="amountInput" id="amountInput"\n' +
    '                         placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" amount-input-mask\n' +
    '                         maxlength="12" ng-model="transactionDivision.tempTransDivObj.amountInput" required\n' +
    '                         ng-class="{\'domp-error\': transactionDivision.tDivForm.amountInput.$invalid && transactionDivision.formSubmitted}"\n' +
    '                         ng-maxlength="11"/>\n' +
    '                          <span class="input-group-btn">\n' +
    '                            <button type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                                    ng-if="vm.countryCode != \'sr\'" style="border:1px solid #062a42;">\n' +
    '                              {{transactionDivision.defaultCurrency}}\n' +
    '                            </button>\n' +
    '                          </span>\n' +
    '                </div>\n' +
    '                      <span class="c-red"\n' +
    '                            ng-if="transactionDivision.tDivForm.amountInput.$error.required && vm.formSubmitted"\n' +
    '                            translate="internalTransfer.amountInputError"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="numOfInstallment"\n' +
    '                       translate="transactionDivision.numOfInstallment"></label>\n' +
    '                <select class="form-control input-field" id="numOfInstallment"\n' +
    '                        data-ng-model="transactionDivision.tempTransDivObj.installmentNumber">\n' +
    '                  <option ng-repeat="installment in transactionDivision.installmentRange">{{installment}}</option>\n' +
    '                </select>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="sellingPlace"\n' +
    '                       translate="transactionDivision.sellingPlace"></label>\n' +
    '                <input type="text" id="sellingPlace" name="sellingPlace" class="form-control input-field"\n' +
    '                       ng-class="{\'domp-error\': transactionDivision.tDivForm.sellingPlace.$invalid && transactionDivision.formSubmitted}"\n' +
    '                       data-ng-model="transactionDivision.tempTransDivObj.transactionLocation" required>\n' +
    '                <div class="c-red"\n' +
    '                     ng-show="transactionDivision.tDivForm.sellingPlace.$error.required && transactionDivision.formSubmitted"\n' +
    '                     translate="transactionDivision.sellingPlaceError">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label-review" for="lastDigits"\n' +
    '                       translate="transactionDivision.lastDigits"></label>\n' +
    '                <input type="text" id="lastDigits" name="lastDigits" class="form-control input-field"\n' +
    '                       data-ng-model="transactionDivision.tempTransDivObj.cardNumber"\n' +
    '                       ng-class="{\'domp-error\': transactionDivision.tDivForm.lastDigits.$invalid && transactionDivision.formSubmitted}"\n' +
    '                       ng-pattern-restrict="{{transactionDivision.regexPatterns.onlyNumbers}}" ng-maxlength="4"\n' +
    '                       maxlength="4" ng-minlength="4" minlength="4" required>\n' +
    '                <div class="c-red"\n' +
    '                     ng-show="transactionDivision.tDivForm.lastDigits.$error.required && transactionDivision.formSubmitted"\n' +
    '                     translate="transactionDivision.lastDigitsError">\n' +
    '                </div>\n' +
    '                <div class="c-red"\n' +
    '                     ng-show="transactionDivision.tDivForm.lastDigits.$error.minlength && transactionDivision.formSubmitted"\n' +
    '                     translate="transactionDivision.lastDigitsLengthError">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!--</div>-->\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row p-10">\n' +
    '      <div class="col-xs-6 t-a-l">\n' +
    '        <button class="btn btn-primary" type="button" translate="transactionDivision.cancel" data-ui-sref="dashboard">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r">\n' +
    '        <button class="btn btn-default pull-right" type="submit" translate="transactionDivision.confirm"\n' +
    '                ng-click="transactionDivision.confirm()"></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-sm-12">\n' +
    '      <!-- TIMELINE CONTAINER -->\n' +
    '      <div class="row p-r-10 p-l-10">\n' +
    '        <div class="col-sm-12 l-h-50 p-0" style="background-color: white;border-bottom: 2px solid #9eabd5;">\n' +
    '          <span translate="transactionDivision.yourTransDiv" class="bold-font f-17 m-l-20 ng-scope"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <div class="row p-r-10 p-l-10">\n' +
    '        <div class="col-sm-12 no-padding bg-white" style="padding-top:10px;">\n' +
    '          <br>\n' +
    '          <div class="dropdown acc-period-select col-xl-3 col-md-3 col-sm-3">\n' +
    '            <button class="btn btn-default dropdown-toggle p-l-30 p-r-30" type="button" data-toggle="dropdown">\n' +
    '              {{transactionDivision.selectedPeriod.item.description | translate}}\n' +
    '              <span class="caret"></span>\n' +
    '            </button>\n' +
    '            <ul class="dropdown-menu">\n' +
    '              <li data-ng-repeat="period in transactionDivision.periodList">\n' +
    '                <a href="" class="f-13" data-ng-click="transactionDivision.timelineTimeFilter(period);">\n' +
    '                  {{period.item.description | translate}}\n' +
    '                </a>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="timeline-row col-sm-12 no-padding">\n' +
    '          <div class="t-a-c p-10 no-data-image"\n' +
    '               ng-if="transactionDivision.transactionDivisionGrouped.result.length == 0">\n' +
    '            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '            <h3 class="no-data-label" translate="dashboard.noTimelineData"></h3>\n' +
    '          </div>\n' +
    '          <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0"\n' +
    '               ng-hide="transactionDivision.transactionDivisionGrouped.result.length == 0">\n' +
    '            <ul class="hypo-timeline" kcd-recompile="transactionDivision.transactionDivisionGrouped">\n' +
    '              <li ng-class="{\'time-label\': tDiv.isVirtual}"\n' +
    '                  ng-repeat="tDiv in transactionDivision.transactionDivisionGrouped.result">\n' +
    '                <span class="currency-time-frame"\n' +
    '                      ng-if="tDiv.isVirtual === true">{{tDiv.date | date:\'shortDate\'}}</span>\n' +
    '                <i class="icon icon-change currency-icon-change" ng-if="!tDiv.isVirtual"></i>\n' +
    '                <div ng-if="!tDiv.isVirtual" class="hypo-timeline-item payment-item"\n' +
    '                     ng-click="tDiv.selected = !tDiv.selected;" ng-class="{\'opened\': tDiv.selected}">\n' +
    '                  <div class="hypo-timeline-body">\n' +
    '                    <div class="col-xs-6">\n' +
    '                      <h4 class="m-b-0 m-t-0 c-gray">\n' +
    '                        <b>{{tDiv.amount | number:2}} BAM</b>\n' +
    '                        <b>, {{::tDiv.transactionLocation}}</b>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">\n' +
    '                        {{tDiv.modificationDate | date:\'shortDate\'}}\n' +
    '                      </p>\n' +
    '                      <p ng-show="currencyConversion.showPaymentId" class="m-b-0 m-t-0" id="paymentId">\n' +
    '                        {{::payment.id}}</p>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-6">\n' +
    '                      <span class="pull-right t-a-r m-t-10">\n' +
    '                      <b style="font-size:17px;">\n' +
    '                            <span>\n' +
    '                              {{\'transactionDivision.\' + tDiv.status | translate}}\n' +
    '                            </span>\n' +
    '                      </b>\n' +
    '                        </span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <!-- TIMELINE ITEM DETAILS -->\n' +
    '                  <div ng-if="tDiv.selected" class="transaction-details">\n' +
    '                    <i class="icon icon-change currency-icon-change-two" ng-if="!tDiv.isVirtual"></i>\n' +
    '                    <table class="table table-transparent table-responsive"\n' +
    '                           style="font-size: 17px;color: #9e9e9e !important;font-family: CharlieMedium;">\n' +
    '                      <tbody>\n' +
    '                      <tr>\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="transactionDivision.amount">Amount:</span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">{{tDiv.amount|number:2}} BAM</span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <tr>\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="transactionDivision.transLocation">Transaction location:</span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">{{::tDiv.transactionLocation}}</span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <tr>\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="transactionDivision.cardNumber">Card number:</span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">{{::tDiv.cardNumber}}</span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <tr>\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="transactionDivision.status">Status:</span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">{{ \'transactionDivision.\' + tDiv.status | translate}}</span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <tr>\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="transactionDivision.installmentInfo">Status:</span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">{{tDiv.installmentNumber}}</span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <tr>\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label" translate="transactionDivision.creationDate">Creation date:</span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">{{tDiv.creationDate| date:\'shortDate\'}}</span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <tr>\n' +
    '                        <td>\n' +
    '                          <span class="po-desc-label"\n' +
    '                                translate="transactionDivision.transactionDate">Transaction date:</span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                          <span class="po-value-label">{{tDiv.valueDate| date:\'shortDate\'}}</span>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <!-- ACTIONS -->\n' +
    '                      <tr>\n' +
    '                        <td colspan="2">\n' +
    '                          <div>\n' +
    '                            <span class="pull-right" ng-repeat="actionObject in tDiv.allowedActionList.itemList">\n' +
    '                              <span ng-switch on="actionObject.methodName">\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                            translate="payments.edit"\n' +
    '                                            ng-if="actionObject.isEnabled" ng-switch-when="UpdateAllowed"\n' +
    '                                            ng-click="transactionDivision.editFromTimeline(tDiv.id)">\n' +
    '                                      Recall payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                            translate="currencyConversion.sign"\n' +
    '                                            ng-switch-when="SignAllowed"\n' +
    '                                            data-ng-click="transactionDivision.sign(tDiv.id)">\n' +
    '                                      Sign payment\n' +
    '                                    </button>\n' +
    '                                    <button class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase m-m-b-10"\n' +
    '                                            translate="payments.delete"\n' +
    '                                            ng-if="actionObject.isEnabled" ng-switch-when="DeleteAllowed"\n' +
    '                                            ng-click="transactionDivision.delete(tDiv.id)">\n' +
    '                                      Delete payment\n' +
    '                                    </button>\n' +
    '                                  </span>\n' +
    '                            </span>\n' +
    '                          </div>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '                      <!-- END ACTIONS -->\n' +
    '                      </tbody>\n' +
    '                    </table>\n' +
    '                  </div>\n' +
    '                  <!-- END TIMELINE ITEMS DETAILS-->\n' +
    '                </div>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="show-more-btn ">\n' +
    '          <button ng-hide="transactionDivision.transactionDivisionGrouped.hasMore == false"\n' +
    '                  data-ng-click="transactionDivision.loadMoreTimelineItems()" type="input"\n' +
    '                  class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn"\n' +
    '                  translate="dashboard.loadEvents">Load older events\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END TIMELINE -->\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</form>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/transaction-division-resume.tpl.html',
    '<form name="internalTransferForm" novalidate>\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="transactionDivision.amount"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.amount | number: 2}} BAM</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="domp-form-label-review" translate="transactionDivision.cardNumber">Card number</label>\n' +
    '        <label class="d-block domp-form-label-resume">\n' +
    '          {{transactionDivision.postResponseObj.cardNumber}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="domp-form-label-review" translate="transactionDivision.creatorName">Creator name</label>\n' +
    '        <label class="d-block domp-form-label-resume">\n' +
    '          {{transactionDivision.postResponseObj.creatorName}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="domp-form-label-review" translate="transactionDivision.transLocation">Transaction\n' +
    '          location</label>\n' +
    '        <label\n' +
    '          class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.transactionLocation}}</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6">\n' +
    '        <label class="domp-form-label-review" translate="transactionDivision.status">Status</label>\n' +
    '        <label class="d-block domp-form-label-resume">{{\'transactionDivision.\'+transactionDivision.postResponseObj.status | translate}}</label>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="transactionDivision.installmentNumber"></label>\n' +
    '          <label\n' +
    '            class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.installmentNumber}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="domp-to-section m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="transactionDivision.creationDate"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.creationDate | date:\n' +
    '            \'shortDate\'}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-sm-6 col-xs-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label-review" translate="transactionDivision.transactionDate"></label>\n' +
    '          <label class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.valueDate | date:\n' +
    '            \'shortDate\'}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="m-10">\n' +
    '    <div class="row">\n' +
    '      <div class="col-sm-9 p-b-10 col-xs-12 hidden-xs">\n' +
    '        <button class="btn btn-primary " translate="currencyConversion.back"\n' +
    '                data-ng-click="transactionDivision.new();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary" translate="payments.edit"\n' +
    '                data-ng-click="transactionDivision.edit();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary-warning " translate="payments.delete"\n' +
    '                data-ng-click="transactionDivision.delete();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-9 p-b-10 col-xs-12 visible-xs-block">\n' +
    '        <button class="btn btn-default btn-block"\n' +
    '                translate="currencyConversion.sign"\n' +
    '                data-ng-click="transactionDivision.sign()">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary btn-block" translate="currencyConversion.back"\n' +
    '                data-ng-click="transactionDivision.new();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary btn-block" translate="payments.edit"\n' +
    '                data-ng-click="transactionDivision.edit();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary-warning btn-block" translate="payments.delete"\n' +
    '                data-ng-click="transactionDivision.delete();">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-sm-3 col-xs-12 hidden-xs">\n' +
    '\n' +
    '        <button class="btn btn-default col-xs-12"\n' +
    '                translate="currencyConversion.sign"\n' +
    '                data-ng-click="transactionDivision.sign()">\n' +
    '        </button>\n' +
    '\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</form>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/transaction-division-final.tpl.html',
    '\n' +
    '  <div class="container">\n' +
    '\n' +
    '    <div class="currency-conversion-msg">\n' +
    '      <div class="payment-successful-wrapper">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-2 m-t-30 m-b-30 msg-pad">\n' +
    '            <div class="currency-check-icon msg-pad">\n' +
    '              <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-10 m-t-30 m-b-30 int-payment">\n' +
    '\n' +
    '            <!-- For all countries except SLO -->\n' +
    '            <div ng-if="paymentsFinal.countryCode != \'sl\'" class="f-15">\n' +
    '\n' +
    '              <h2 class="c-white f-28" translate="transactionDivision.successMessage"></h2>\n' +
    '\n' +
    '              <div class="m-t-15" >\n' +
    '                <span translate="transactionDivision.finalStepStatus"></span>\n' +
    '                <span>{{\'transactionDivision.\'+transactionDivision.postResponseObj.status | translate}}</span>\n' +
    '              </div>\n' +
    '              <div>\n' +
    '                <span translate="transactionDivision.finalStepId"></span>\n' +
    '                <span>{{transactionDivision.postResponseObj.id}}</span>\n' +
    '              </div>\n' +
    '              <div class="m-t-15" >\n' +
    '                <span translate="transactionDivision.finalStepSentForProcessing"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-20">\n' +
    '\n' +
    '        <div class="col-xs-12 col-sm-6">\n' +
    '          <a href="" data-ng-click="transactionDivision.goToCreatePage();" >\n' +
    '            <span class="money-exchange-icon"><i class="icon icon-reclam zmdi-hc-2x" style="color:#062a42;"></i></span>\n' +
    '            <span class="f-18 money-exchange-text" translate="transactionDivision.makeAnotherPayment" ></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/transaction-division-base.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div ng-if="transactionDivision.step != \'final\'" class="row domp-header-wrapper">\n' +
    '      <div class="domp-header-row col-md-12">\n' +
    '        <h2 class="f-28" translate="transactionDivision.title"></h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="m-b-30">\n' +
    '      <ui-view/>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/tl-ebook-savings.tpl.html',
    '<div ng-if="accounts.eBookRequests">\n' +
    '  <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0" ng-hide="accounts.eBookSavingsGrouped.result.length == 0">\n' +
    '    <div class="m-b-15 m-t-10">\n' +
    '      <span class="f-17 m-l-20" translate="ebook.timelineHeader" style="font-weight:400;color:#062a42;">\n' +
    '       Vremenski prikaz zahtjeva za eKnjižice\n' +
    '     </span>\n' +
    '    </div>\n' +
    '    <ul class="hypo-timeline" kcd-recompile="accounts.eBookSavingsGrouped">\n' +
    '      <li ng-class="{\'time-label\': eBookSavings.isVirtual}" ng-repeat="eBookSavings in accounts.eBookSavingsGrouped.result">\n' +
    '        <span class="currency-time-frame " ng-if="eBookSavings.isVirtual === true">{{eBookSavings.date | date:\'shortDate\' }}</span>\n' +
    '        <i class="zmdi zmdi-money" ng-if="!eBookSavings.isVirtual"></i>\n' +
    '        <div ng-if="!eBookSavings.isVirtual" class="hypo-timeline-item payment-item" data-ng-click="eBookSavings.selected = !eBookSavings.selected" ng-class="{\'opened\': eBookSavings.selected}">\n' +
    '          <div class="hypo-timeline-body">\n' +
    '            <div class="col-xs-6">\n' +
    '              <h4 class="m-b-0 m-t-0 c-darkgray">\n' +
    '              <p style="font-weight:500;font-size:18px;margin-bottom: 3px;">{{::eBookSavings.eSavingBookName}}</p>\n' +
    '            </h4>\n' +
    '              <div>\n' +
    '                <p style="font-weight:500;font-size:14px;color:#444;margin-bottom: 3px;">{{::eBookSavings.requestType}}</p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6"><span class="pull-right t-a-r m-t-10"><p style="font-weight:600;font-size:18px;color:#444;">{{::eBookSavings.status}}</p></span></div>\n' +
    '          </div>\n' +
    '          <div ng-if="eBookSavings.selected" class="transaction-details">\n' +
    '            <div data-ng-include="\'accounts/tl-ebook-savings-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="hypo-timeline-wrapper app-white-card t-a-c p-10 no-data-image" ng-if="accounts.eBookSavingsRequests.result.length == 0">\n' +
    '    <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '    <h3 class="no-data-label ng-scope" translate="internalTransfer.nodata"></h3>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="show-more-btn ">\n' +
    '    <button ng-show="accounts.eBookSavingsRequests.hasMore" data-ng-click="accounts.loadMoreSavingBookRequests();" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents">Load older events</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- from navigation or from open new eBook button -->\n' +
    '<div ng-if="newEBook.eBookRequests" class="col-sm-12 p-0">\n' +
    '  <div class="col-sm-12 p-0 app-white-card">\n' +
    '    <div class="col-sm-6 p-0 m-t-15">\n' +
    '      <span class="f-17 m-l-20" translate="ebook.timelineHeader" style="font-weight:400;color:#062a42;">\n' +
    '      Vremenski prikaz zahtjeva za eKnjižice\n' +
    '    </span>\n' +
    '    </div>\n' +
    '    <div class="col-sm-6 m-t-15 p-r-25">\n' +
    '      <label class="checkbox checkbox-inline m-l-15 pull-right">\n' +
    '        <input type="checkbox" data-ng-model="newEBook.allRequests" data-ng-click="newEBook.loadRequestsOnCheckbox()">\n' +
    '        <span class="input-helper" translate="ebook.showAllRequests" style="color:#ff4d5a;font-size:14px;font-weight:500;">Prikaži zahtjeve za sve račune</span>\n' +
    '      </label>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-sm-12 hypo-timeline-wrapper app-white-card p-tbl-10-r-0" ng-hide="newEBook.eBookSavingsGrouped.result.length == 0">\n' +
    '    <ul class="hypo-timeline" kcd-recompile="newEBook.eBookSavingsGrouped">\n' +
    '      <li ng-class="{\'time-label\': eBookSavings.isVirtual}" ng-repeat="eBookSavings in newEBook.eBookSavingsGrouped.result">\n' +
    '        <span class="currency-time-frame salary-date" ng-if="eBookSavings.isVirtual === true">{{eBookSavings.date | date:\'shortDate\' }}</span>\n' +
    '        <i class="icon icon-change currency-icon-change icon-lh" ng-if="!eBookSavings.isVirtual"></i>\n' +
    '        <div ng-if="!eBookSavings.isVirtual" class="hypo-timeline-item payment-item" data-ng-click="eBookSavings.selected = !eBookSavings.selected" ng-class="{\'opened\': eBookSavings.selected}">\n' +
    '          <div class="hypo-timeline-body">\n' +
    '            <div class="col-xs-6">\n' +
    '              <h4 class="m-b-0 m-t-0 c-darkgray">\n' +
    '              <p style="font-weight:500;font-size:18px;margin-bottom: 3px;">{{::eBookSavings.eSavingBookName}}</p>\n' +
    '            </h4>\n' +
    '              <div>\n' +
    '                <p style="font-weight:500;font-size:14px;color:#444;margin-bottom: 3px;">{{::eBookSavings.requestType}}</p>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6"><span class="pull-right t-a-r m-t-10"><p style="font-weight:600;font-size:18px;color:#444;">{{::eBookSavings.status}}</p></span></div>\n' +
    '          </div>\n' +
    '          <div ng-if="eBookSavings.selected" class="transaction-details">\n' +
    '            <div data-ng-include="\'accounts/tl-ebook-savings-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="show-more-btn ">\n' +
    '    <button ng-show="newEBook.eBookSavingsRequests.hasMore" data-ng-click="newEBook.loadMoreSavingBookRequests();" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="dashboard.loadEvents">Load older events</button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/tl-ebook-savings-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '  <tbody>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="ebook.createdBy"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{::eBookSavings.createdBy}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="accounts.accParentAccountIban">IBAN</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{::eBookSavings.iban}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="eBookSavings.eSavingBookNumber">\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="ebook.ebookNumber">Account number</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{::eBookSavings.eSavingBookNumber}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="ebook.requestType">Request type</span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{::eBookSavings.requestType}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <span class="po-desc-label" translate="ebook.status"></span>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <span class="po-value-label">{{::eBookSavings.status}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/savings-slo.tpl.html',
    '<div ng-controller="SavingsSloCtrl as savingsSlo">\n' +
    '  <section id="main">\n' +
    '    <div class="container-fluid">\n' +
    '      <!-- START Title -->\n' +
    '      <div style="padding: 15px">\n' +
    '        <div class="row">\n' +
    '          <div class="domp-header-wrapper col-sm-12 p-o">\n' +
    '            <div class="domp-header-row">\n' +
    '              <h2 translate="savingsSlo.title">Savings account</h2>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Title-->\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <div ng-if="cashWithdrawal.countryCode != \'sl\'" class="alert alert-info"\n' +
    '               style="background: white; color: black; border: 1px solid lightgray" role="alert">\n' +
    '\n' +
    '            <p translate="savingsSlo.infoNote1"></p>\n' +
    '            <p translate="savingsSlo.infoNote2"></p>\n' +
    '            <p translate="savingsSlo.infoNote3"></p>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="p-b-30">\n' +
    '        <div class="p-b-30">\n' +
    '          <ng-form name="savingsSlo.savingsForm">\n' +
    '            <div class="cash-withdrawing-section-frame">\n' +
    '              <div class="row">\n' +
    '                <div class="col-xs-12 col-sm-6">\n' +
    '                  <div class="form-group">\n' +
    '                    <label class="domp-form-label" translate="savingsSlo.vrstaVracevanja"></label>\n' +
    '                    <select name="vrstaVracevanja"\n' +
    '                            class="form-control input-field p-l-15 p-r-10"\n' +
    '                            ng-options="option.name for option in savingsSlo.vrstaVracevanja"\n' +
    '                            ng-model="savingsSlo.vrstaVracevanjaSelect"\n' +
    '                            required>\n' +
    '                    </select>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'1\'" class="col-xs-12 col-sm-3">\n' +
    '\n' +
    '                  <div class="form-group">\n' +
    '                    <label class="domp-form-label" translate="savingsSlo.durationInMonths"></label>\n' +
    '                    <select name="durationInMonths"\n' +
    '                            class="form-control input-field p-l-15 p-r-10"\n' +
    '                            ng-options="option.name for option in savingsSlo.durationInMonths"\n' +
    '                            ng-model="savingsSlo.durationInMonthsSelect"\n' +
    '                            required>\n' +
    '                    </select>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'1\'" class="col-xs-12 col-sm-3">\n' +
    '                  <label class="domp-form-label" translate="savingsSlo.maturityDate"></label>\n' +
    '                  <input type="text" class="form-control input-field" name="date"\n' +
    '                         ng-model="savingsSlo.maturityDate"\n' +
    '                         readonly>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row">\n' +
    '                <div class="col-xs-12 col-sm-6">\n' +
    '\n' +
    '                  <label ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'1\'" class="domp-form-label" translate="savingsSlo.transfersFromAndToAccount"></label>\n' +
    '                  <label ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'0\'" class="domp-form-label" translate="savingsSlo.initialAmountFromAccount"></label>\n' +
    '                  <div class="accounts-dropdown">\n' +
    '                    <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                         data-ng-click="cashWithdrawal.showAccountToDropdown = !cashWithdrawal.showAccountToDropdown" ng-style="cashWithdrawal.selectedAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + cashWithdrawal.selectedAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                          {{cashWithdrawal.selectedAccount.friendlyName}}</b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                  <i class="zmdi"\n' +
    '                     ng-class="{\'zmdi-star favorite-account\': account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                </span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{cashWithdrawal.selectedAccount.iban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{cashWithdrawal.selectedAccount.availableBalance | number:2}}\n' +
    '                        {{cashWithdrawal.selectedAccount.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                      <span class="caret-icon">\n' +
    '                  <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '              </span>\n' +
    '                    </div>\n' +
    '                    <div class="from-accounts-list m-l-15" ng-show="cashWithdrawal.showAccountToDropdown" scrollable>\n' +
    '                      <div class="accounts-list-item p-0"\n' +
    '                           data-ng-repeat="account in cashWithdrawal.accountList"\n' +
    '                           data-ng-click="cashWithdrawal.selectAccount(account); cashWithdrawal.showAccountToDropdown = !cashWithdrawal.showAccountToDropdown">\n' +
    '                        <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="account.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + account.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                          <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{account.friendlyName}}</b>\n' +
    '                            <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                          </h4>\n' +
    '                          <p class="m-b-0 m-t-0 iban-style">{{account.iban}}</p>\n' +
    '                          <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                            {{account.availableBalance | number:2}} {{account.currencySymbol}}\n' +
    '                          </p>\n' +
    '                          <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <!-- START Amount and Date -->\n' +
    '                <div class="col-xs-12 col-sm-6">\n' +
    '                  <!-- START Amount -->\n' +
    '                  <div class="row m-0">\n' +
    '                    <div class="form-group">\n' +
    '                      <label ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'0\'" class="domp-form-label" translate="savingsSlo.initialAmount"></label>\n' +
    '                      <label ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'1\'" class="domp-form-label" translate="savingsSlo.montlyDepositAmount"></label>\n' +
    '                      <div class="input-group">\n' +
    '                        <input id="amount" name="amount" type="text" class="form-control input-field t-a-r"\n' +
    '                               amount-input-mask\n' +
    '                               ng-model="cashWithdrawal.model.amount"\n' +
    '                               ng-class="{\'domp-error\': cashWithdrawal.cashWithdrawalForm.amount.$invalid && cashWithdrawal.formSubmitted}"\n' +
    '                               maxlength="12"\n' +
    '                               placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                               autocomplete="off"\n' +
    '                               required>\n' +
    '                        <span class="input-group-btn">\n' +
    '                <button type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">\n' +
    '                  {{savingsSlo.currencySymbol}}\n' +
    '                </button>\n' +
    '              </span>\n' +
    '                      </div>\n' +
    '                      <label class="c-red"\n' +
    '                             ng-show="cashWithdrawal.cashWithdrawalForm.amount.$error.required && cashWithdrawal.formSubmitted"\n' +
    '                             translate="savingsSlo.amountRequired">\n' +
    '                      </label>\n' +
    '                      <label class="c-red"\n' +
    '                             ng-show="!cashWithdrawal.cashWithdrawalForm.amount.$error.required && cashWithdrawal.cashWithdrawalForm.amount.$error.min && cashWithdrawal.formSubmitted">\n' +
    '                        {{"savingsSlo.amountMinAmountError" | translate}} {{cashWithdrawal.minAmount | currency:""}} {{cashWithdrawal.model.currencySymbol}}\n' +
    '                      </label>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- END Amount-->\n' +
    '                  <!-- START Date-->\n' +
    '\n' +
    '\n' +
    '                  <div class="row">\n' +
    '                    <div class="col-xs-6">\n' +
    '                      <label class="domp-form-label" translate="savingsSlo.realInterestRate"></label>\n' +
    '\n' +
    '                      <input type="text" class="form-control input-field" name="text"\n' +
    '\n' +
    '                             ng-model="savingsSlo.realInterestRate"\n' +
    '                             readonly>\n' +
    '\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-6">\n' +
    '                      <label class="domp-form-label" translate="savingsSlo.totalInterestRate"></label>\n' +
    '                      <input type="text" class="form-control input-field" name="text"\n' +
    '\n' +
    '                             ng-model="savingsSlo.totalInterestRate"\n' +
    '                             readonly>\n' +
    '\n' +
    '\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <!-- END Date-->\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '              <div ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'1\'" class="row p-t-20">\n' +
    '                <div class="col-xs-6">\n' +
    '                  <div class="form-group">\n' +
    '                    <label class="domp-form-label" translate="savingsSlo.standingOrderDay"></label>\n' +
    '                    <select name="branch"\n' +
    '                            class="form-control input-field p-l-15 p-r-10"\n' +
    '                            ng-options="option.name for option in savingsSlo.standingOrderDays"\n' +
    '                            ng-model="savingsSlo.standingOrderDaysSelect"\n' +
    '                            required>\n' +
    '                    </select>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="row p-t-20">\n' +
    '                <div class="col-xs-12">\n' +
    '                  <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value" >\n' +
    '                    <input type="checkbox" ng-model="savingsSlo.savingsSlo.termsAndCondtions">\n' +
    '                    <i class="input-helper"></i>\n' +
    '                    <span translate="savingsSlo.termsAndCondtionsInfo"></span>\n' +
    '                    <br>\n' +
    '                    <span ng-if="savingsSlo.vrstaVracevanjaSelect.value == \'1\'" translate="savingsSlo.info"></span>\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <section class="row p-t-20">\n' +
    '                <div class="form-group">\n' +
    '                  <div class="col-md-6">\n' +
    '                    <button class="btn btn-primary pull-left" type="button" translate="savingsSlo.cancel"></button>\n' +
    '                  </div>\n' +
    '                  <div class="col-md-6">\n' +
    '                    <button class="btn btn-default pull-right" type="submit" translate="savingsSlo.confirm" ng-click="savingsSlo.submitPayment();"></button>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </section>\n' +
    '            </div>\n' +
    '          </ng-form>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </section>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/repayment-plan.tpl.html',
    '<div class="col-sm-12 col-md-12">\n' +
    '  <div class="timeline-row col-sm-12 no-padding">\n' +
    '    <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">\n' +
    '      <ul class="hypo-timeline"\n' +
    '          ng-repeat="loanAccountPaymentPlan in accounts.selectedAccount.loanAccountPaymentPlanList">\n' +
    '        <!--ng-repeat="payment in dashboard.pendingPaymentsList.result | limitTo:dashboard.numberOfPendingPaymentsToShow"-->\n' +
    '        <li>\n' +
    '          <div class="time-group-badge">{{loanAccountPaymentPlan.nextInstallmentDate | date:\'mediumDate\'}}</div>\n' +
    '        </li>\n' +
    '        <li class="time-label" style="margin-left: 0" ng-click="loanAccountPaymentPlan.selected = !loanAccountPaymentPlan.selected">\n' +
    '          <i class="zmdi zmdi-timer" style="top:20px; z-index: 1;"></i>\n' +
    '          <div class="hypo-timeline-item payment-item" ng-class="{\'opened\': loanAccountPaymentPlan.selected}">\n' +
    '            \n' +
    '            <div class="hypo-timeline-body clearfix">\n' +
    '              <div class="col-md-6 col-xs-12">\n' +
    '                <h4 translate="repaymentPlan.instalment">Instalment</h4>\n' +
    '              </div>\n' +
    '                <div class="col-md-3 col-xs-12 " \n' +
    '                     ng-class="{\'col-md-6 pull-right\' : !loanAccountPaymentPlan.paymentAmount}">\n' +
    '                <div ng-show="loanAccountPaymentPlan.remainLoanBalance" class="pull-right t-a-r m-t-5  f-18">\n' +
    '                  <b class="price-payment" style="font-weight:600; font-size:22px;">{{::loanAccountPaymentPlan.remainLoanBalance|number:2}}\n' +
    '                    {{::accounts.selectedAccount.currencySymbol}}</b>\n' +
    '                  <br>\n' +
    '                  <span translate="repaymentPlan.loanBalance">Loan balance</span>\n' +
    '                </div>\n' +
    '                <!--<p class="m-b-0 m-t-0 iban-style">{{::payment.fromAccountNumber}}</p>-->\n' +
    '              </div>\n' +
    '              <div class="col-md-3 col-xs-12">\n' +
    '                <div ng-show="loanAccountPaymentPlan.paymentAmount" class="pull-right t-a-r m-t-5  f-15">\n' +
    '                  <b>{{::loanAccountPaymentPlan.paymentAmount|number:2}}\n' +
    '                    {{::accounts.selectedAccount.currencySymbol}}</b>\n' +
    '                  <br>\n' +
    '                  <span translate="repaymentPlan.instalment">Instalment</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- SHOW IF OPEN -->\n' +
    '            <div ng-if="loanAccountPaymentPlan.selected" class="transaction-details">\n' +
    '              <div>\n' +
    '                <table class="table table-transparent table-responsive">\n' +
    '                  <tr>\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="repaymentPlan.date">Date</span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{loanAccountPaymentPlan.nextInstallmentDateFrom | date: \'mediumDate\'}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '<!--                  <tr>\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="repaymentPlan.dateTo">Date to:</span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span\n' +
    '                        class="po-value-label">{{loanAccountPaymentPlan.nextInstallmentDate | date: \'mediumDate\'}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>-->\n' +
    '                  \n' +
    '                  <tr>\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="repaymentPlan.principalAmount">Principal amount:</span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{loanAccountPaymentPlan.matureCapital|number:2}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  \n' +
    '                  <tr>\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="repaymentPlan.interestAmount">Interest amount:</span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{loanAccountPaymentPlan.interestRegularAmount|number:2}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr>\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="repaymentPlan.paymentAmount">Payment amount:</span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{loanAccountPaymentPlan.paymentAmount|number:2}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr>\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="repaymentPlan.totalAnnuity">Total annuity:</span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{loanAccountPaymentPlan.totalAnnuityAmount|number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                  <tr>\n' +
    '                    <td>\n' +
    '                      <span class="po-desc-label" translate="repaymentPlan.balance">Balance:</span>\n' +
    '                    </td>\n' +
    '                    <td>\n' +
    '                      <span class="po-value-label">{{loanAccountPaymentPlan.remainLoanBalance|number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                </table>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </li>\n' +
    '\n' +
    '      </ul>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/new-e-book.tpl.html',
    '<section id="main" ng-if="newEBookSavingsDivider.countryCode == \'hr\'" >\n' +
    '    <div class="container" ng-controller="NewEBookCtrl as newEBook">\n' +
    '        <div class="row exchange-rates">\n' +
    '            <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12 no-padding-on-phone">\n' +
    '                <div class="domp-header-wrapper p-r-20 p-l-30" ng-show="newEBook.currentStep != 3">\n' +
    '                    <div class="row domp-header-row">\n' +
    '\n' +
    '                        <h2 class="f-28" translate="ebook.header">Create new eSaving book</h2>\n' +
    '\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="domp-body-wrapper">\n' +
    '                    <div ng-show="newEBook.currentStep === 1" class="domp-step-1">\n' +
    '                        <form novalidate name="newEBook.newEBookForm">\n' +
    '                            <div class="ebook-section col-lg-12 col-md-12 col-sm-12">\n' +
    '                                <div class="row">\n' +
    '                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '                                        <label class="domp-form-label" translate="ebook.name">Name</label>\n' +
    '\n' +
    '                                        <input type="text" class="form-control input-field " name="nameInput" id="nameInput" data-ng-model="newEBook.tempObj.nameInput" required ng-class="{\'domp-error\': newEBook.newEBookForm.nameInput.$invalid && newEBook.tempObj.formSubmitted}">\n' +
    '                                        <span class="c-red" ng-show="newEBook.newEBookForm.nameInput.$error.required && newEBook.tempObj.formSubmitted" translate="ebook.nameError"></span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="row p-t-10">\n' +
    '                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n' +
    '\n' +
    '                                        <!-- CUSTOM FROM Accounts dropdown-->\n' +
    '                                        <label class="domp-form-label" translate="ebook.fromAccount"></label>\n' +
    '                                        <div class="accounts-dropdown m-b-10" ng-if="newEBook.accountsFrom.length > 0">\n' +
    '                                            <div class="debit-account-widget dashboard-widget-item" data-ng-click="newEBook.toggleFromAccount();"  ng-style="newEBook.tempObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + newEBook.tempObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                                <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                                                     <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                      {{newEBook.tempObj.fromAccountSelect.friendlyName}} </b>\n' +
    '                      <span class=" col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                        <i class="zmdi "\n' +
    '                           ng-class="{\'zmdi-star favorite-account\':newEBook.tempObj.fromAccountSelect.isFavorite,\n' +
    '                                     \'zmdi-star-outline\':!newEBook.tempObj.fromAccountSelect.isFavorite}"></i>\n' +
    '                      </span>\n' +
    '                    </h4>\n' +
    '                                                <p class="m-b-0 m-t-0 iban-style">{{newEBook.tempObj.fromAccountSelect.iban}}</p>\n' +
    '                                              <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                    {{newEBook.tempObj.fromAccountSelect.availableBalance | number:2}} {{newEBook.tempObj.fromAccountSelect.currencySymbol}}\n' +
    '                                                </p>\n' +
    '                                                <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                <span class="caret-icon">\n' +
    '                     <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '                    </span>\n' +
    '                                            </div>\n' +
    '                                            <div class="from-accounts-list m-l-15" ng-show="newEBook.fromAccountDropdown" scrollable>\n' +
    '                                                <div class="accounts-list-item p-0" data-ng-repeat="item in newEBook.accountsFrom" data-ng-click="newEBook.setAccountFrom(item);">\n' +
    '                                                    <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="item.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + item.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                                        <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                     <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{item.friendlyName}}</b>\n' +
    '                                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                 </h4>\n' +
    '                                                        <p class="m-b-0 m-t-0 iban-style">{{item.iban}}</p>\n' +
    '                                                        <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                                            {{item.availableBalance | number:2}} {{item.currencySymbol}}\n' +
    '                                                        </p>\n' +
    '                                                        <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                    <div class="accounts-dropdown m-b-10" ng-if="newEBook.accountsFrom.length == 0">\n' +
    '                                        <div class="debit-account-widget dashboard-widget-item" style="height: 114px; line-height: 114px"  ng-style="newEBook.tempObj.fromAccountSelect.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + newEBook.tempObj.fromAccountSelect.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                            No available accounts\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="row p-t-20">\n' +
    '                                <label class="checkbox checkbox-inline m-l-15">\n' +
    '                                    <input type="checkbox" data-ng-model="newEBook.tempObj.checked">\n' +
    '                                    <span class="input-helper"><a ng-click="newEBook.pushGtmLinkEvent(newEBook.generalTerms)" ng-href="{{newEBook.generalTerms}}" target="_blank" translate="ebook.termsAndConditions" style="color:#ff4d5a; font-size: 14px;font-weight:500;">I accept General terms and conditions</a></span>\n' +
    '                                </label>\n' +
    '                            </div>\n' +
    '\n' +
    '\n' +
    '                            <div class="row p-t-20">\n' +
    '                                <div class="col-sm-12 c-red bold-font">\n' +
    '                                    <div class="pull-right"  style="width: 250px;">\n' +
    '                                        <button class="btn btn-default app-btn-blue w-100 domp-review-and-submit-btn" translate="ebook.createEbook" data-ng-click="newEBook.newRequestSubmit();" ng-disabled="newEBook.tempObj.checked===false">\n' +
    '                                        </button>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                    </div>\n' +
    '                    </form>\n' +
    '                    <div class="col-sm-12 p-0" ng-if="newEBook.displayeBookSavingRequest">\n' +
    '                        <div data-ng-include="\'accounts/tl-ebook-savings.tpl.html\'">\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div ng-show="newEBook.currentStep === 2">\n' +
    '                    <div data-ng-include="\'accounts/new-e-book-resume.tpl.html\'">\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div ng-show="newEBook.currentStep === 3">\n' +
    '                    <div data-ng-include="\'accounts/new-e-book-final.tpl.html\'">\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '\n' +
    '<div ng-if="newEBookSavingsDivider.countryCode == \'sl\'"  data-ng-include="\'accounts/savings-slo.tpl.html\'"></div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/new-e-book-resume.tpl.html',
    '\n' +
    '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 receiver-section">\n' +
    '  <div class="row">\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review ebook-label" translate="ebook.fullName">Name</label>\n' +
    '        <label class="domp-form-label-resume ebook-review">{{newEBook.insertedPaymentObject.createdBy}}</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '      <label class="domp-form-label-review ebook-label" translate="ebook.eSavingsBookName"></label>\n' +
    '      <label class="domp-form-label-resume ebook-review">{{newEBook.tempObj.nameInput}}</label>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">\n' +
    '        <div class="form-group m-t-15 m-b-0">\n' +
    '        <label class="domp-form-label-review ebook-label" translate="ebook.mainAccount"></label>\n' +
    '        <label class="domp-form-label-resume" style="font-weight:300;font-size:18px;color:#ff4d5a;">{{newEBook.tempObj.fromAccountSelect.friendlyName}}</label>\n' +
    '        <label class="domp-form-label-accnumber ebook-review" >{{newEBook.insertedPaymentObject.mainAccountNumber}}</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">\n' +
    '      <div class="m-t-15 m-b-0">\n' +
    '        <label class="domp-form-label-review ebook-label" translate="ebook.dateOfCreation"></label>\n' +
    '        <label class="domp-form-label-resume ebook-review">{{newEBook.insertedPaymentObject.dateOfCreation | date:\'shortDate\'}}</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '</div>\n' +
    '\n' +
    '  <!-- SMS auth old -->\n' +
    '<!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 purpose-section">\n' +
    '  <div class="row">\n' +
    '    <div class="col-sm-6 col-xs-12" ng-if="domesticPaymentCro.smsAuthentificate != true">\n' +
    '      <div class="form-group">\n' +
    '        <label class="exchange-resume-label" translate="currencyConversion.smsAuthentification"></label>\n' +
    '        <button class="btn btn-default confirm-btn d-block" translate="currencyConversion.sendSms" data-ng-click="domesticPaymentCro.showSMSAuthentification();"></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-sm-6 col-xs-12" ng-if="domesticPaymentCro.smsAuthentificate == true">\n' +
    '      <div class="form-group">\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control input-field" data-ng-model="domesticPaymentCro.smsPasswordInput" placeholder="{{\'currencyConversion.smsPassword\' | translate}}">\n' +
    '          <span class="input-group-btn">\n' +
    '            <button class="btn btn-default input-group-app-btn domp-btn-height">\n' +
    '              <i class="zmdi zmdi-lock"></i>\n' +
    '            </button>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>-->\n' +
    '\n' +
    '<div class="domp-footer-wrapper">\n' +
    '  <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">\n' +
    '    <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3 m-r-10 btn btn-primary-warning " translate="ebook.delete" ng-click="newEBook.deletePayment();">Delete</button>\n' +
    '\n' +
    '    <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3 btn btn-primary " translate="ebook.edit" ng-click="newEBook.editPayment();">Edit</button>\n' +
    '\n' +
    '    <!--<button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-primary app-btn-blue domp-sign-btn pull-right" ng-click="domesticPaymentSrb.signPayment();" ng-disabled="!domesticPaymentSrb.$dirty && domesticPaymentSrb.smsAuthentificate == false">Sign</button>-->\n' +
    '      <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3  m-r-10 btn btn-default pull-right" translate="ebook.confirm" ng-click="newEBook.sign()">Sign</button>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/new-e-book-final.tpl.html',
    '<div class="currency-conversion-msg">\n' +
    '  <div class="payment-successful-wrapper">\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-2 m-t-30 m-b-30 p-l-116 msg-pad">\n' +
    '        <div class="currency-check-icon msg-pad">\n' +
    '          <i class="icon icon-confirm c-white zmdi-hc-5x"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-10 m-t-30 m-b-30">\n' +
    '        <h2 class="c-white f-28" translate="ebook.completeRequest"></h2>\n' +
    '        <div class="f-16">\n' +
    '          <span translate="ebook.successfullRequest"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '</div>');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/master-card-order-limit.tpl.html',
    '<!--suppress ALL, XmlHighlighting -->\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12" style="z-index:1;">\n' +
    '        <div class="tmplt-list-title col-md-12 p-r-0 p-l-0 m-b-15">\n' +
    '          <h2 class="title-style" translate="masterCardOrder.header">Change overdraft limit</h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Title -->\n' +
    '\n' +
    '    <!-- START Note -->\n' +
    '    <div ng-if="masterCardOrder.step == 1" class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="alert alert-info " style="background: white; color: black; border: 1px solid lightgray">\n' +
    '          <div class="row">\n' +
    '            <div class="col-xs-12">\n' +
    '              <div>\n' +
    '                <span translate="masterCardOrder.info1"></span>\n' +
    '                <a href="https://www.addiko.si/ceniki" target="blank" class="underline" translate="masterCardOrder.infoLink"></a>\n' +
    '              <div>\n' +
    '              <span translate="masterCardOrder.info2"></span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    </div>\n' +
    '    </div>\n' +
    '    <!-- END Note -->\n' +
    '\n' +
    '    <div ng-if="masterCardOrder.step == 1"  class="p-20 bg-white">\n' +
    '      <ng-form name="masterCardOrder.masterCardOrderForm">\n' +
    '          <div class="row">\n' +
    '            <div class="col-xs-12 col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label for="cardAccount" class="domp-form-label" translate="masterCardOrder.cardAccount"></label>\n' +
    '                <input id="cardAccount" name="cardAccount" type="text" class="form-control input-field"\n' +
    '                       ng-model="masterCardOrder.tempObj.cardAccount"\n' +
    '                       disabled>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label for="cardType" class="domp-form-label" translate="masterCardOrder.cardType"></label>\n' +
    '                <select id="cardType" name="cardType" class="form-control input-field"\n' +
    '                       disabled\n' +
    '                       ng-options="option.description | translate for option in masterCardOrder.cardTypes"\n' +
    '                       ng-model="masterCardOrder.selectedAccount.cardType"\n' +
    '                       >\n' +
    '                  </select>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row p-t-15">\n' +
    '\n' +
    '            <div class="col-xs-12 col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label for="cardNumber" class="domp-form-label" translate="masterCardOrder.cardNumber"></label>\n' +
    '                <select id="cardNumber" name="cardNumber"\n' +
    '                        class="form-control input-field p-l-15 p-r-10"\n' +
    '                        disabled\n' +
    '                        ng-options="option.cardNumber + \' \'+ option.cardHolder for option in masterCardOrder.selectedAccount.cardList"\n' +
    '                        ng-model="masterCardOrder.selectedAccount.selectedCard">\n' +
    '                </select>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-sm-6" ng-if="masterCardOrder.selectedAccount.cardType.id == \'basic\'">\n' +
    '              <!-- START Amount -->\n' +
    '              <div class="col-xs-12 p-0">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="masterCardOrder.desiredLimit"></label>\n' +
    '                  <div class="input-group">\n' +
    '                    <input id="amount" name="amount" type="text"\n' +
    '                           class="form-control input-field t-a-r"\n' +
    '                           amount-input-mask\n' +
    '                           placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                           ng-model="masterCardOrder.tempObj.amount"\n' +
    '                           ng-class="{\'domp-error\': masterCardOrder.masterCardOrderForm.amount.$invalid && masterCardOrder.formSubmitted}"\n' +
    '                           maxlength="12"\n' +
    '                           autocomplete="off"\n' +
    '                           required>\n' +
    '                    <span class="input-group-btn">\n' +
    '                <button type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                        style="border:1px solid #062a42;">\n' +
    '                  {{masterCardOrder.selectedAccount.currencySymbol}}\n' +
    '                </button>\n' +
    '              </span>\n' +
    '                  </div>\n' +
    '                  <label class="c-red"\n' +
    '                         ng-show="masterCardOrder.masterCardOrderForm.amount.$error.required && masterCardOrder.formSubmitted"\n' +
    '                         translate="cashWithdrawalTranslate.amountRequired">\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Amount-->\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-sm-6" ng-if="masterCardOrder.selectedAccount.cardType.id != \'basic\'">\n' +
    '              <div class="form-group">\n' +
    '                <label for="limit" class="domp-form-label" translate="masterCardOrder.percentage"></label>\n' +
    '                <select id="limit" name="limit"\n' +
    '                        class="form-control input-field p-l-15 p-r-10"\n' +
    '                        ng-options="option.description for option in masterCardOrder.limits"\n' +
    '                        ng-model="masterCardOrder.tempObj.limit">\n' +
    '                </select>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row p-t-15">\n' +
    '            <div class="col-xs-12 col-sm-6">\n' +
    '              <div class="form-group">\n' +
    '                <label for="limitType" class="domp-form-label" translate="masterCardOrder.limitType"></label>\n' +
    '                <select name="limitType" id="limitType"\n' +
    '                        class="form-control input-field p-l-15 p-r-10"\n' +
    '                        ng-options="option.description for option in masterCardOrder.limitTypes"\n' +
    '                        ng-model="masterCardOrder.tempObj.limitType">\n' +
    '                </select>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-sm-3" ng-if="masterCardOrder.tempObj.limitType.id == \'Temporary\'">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="dateFrom" translate="masterCardOrder.dateFrom"></label>\n' +
    '                <div class="input-group">\n' +
    '                  <input type="text" class="form-control input-field" name="dateFrom" id="dateFrom"\n' +
    '                         uib-datepicker-popup="shortDate" data-ng-model="masterCardOrder.tempObj.dateFrom"\n' +
    '                         show-weeks="false"\n' +
    '                         is-open="dateFromOpened"\n' +
    '                         datepicker-options="masterCardOrder.dateOptions.dateFrom"\n' +
    '                         ng-class="{ \'domp-error\' : masterCardOrder.masterCardOrderForm.dateFrom.$invalid && masterCardOrder.formSubmitted}"\n' +
    '                         required readonly>\n' +
    '                  <span class="input-group-btn">\n' +
    '                            <button data-ng-click="dateFromOpened = !dateFromOpened" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                    style="border:1px solid #062a42;">\n' +
    '                              <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                            </button>\n' +
    '                          </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <span class="c-red" ng-show="masterCardOrder.masterCardOrderForm.dateBegin.$error.required && masterCardOrder.formSubmitted"\n' +
    '                    translate="orders.dateRequired"></span>\n' +
    '            </div>\n' +
    '            <div class="col-sm-3" ng-if="masterCardOrder.tempObj.limitType.id == \'Temporary\'">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" for="dateTo" translate="masterCardOrder.dateTo"></label>\n' +
    '                <div class="input-group date-to">\n' +
    '                  <input type="text" class="form-control input-field" name="dateTo" id="dateTo"\n' +
    '                         uib-datepicker-popup="shortDate"\n' +
    '                         data-ng-model="masterCardOrder.tempObj.dateTo"\n' +
    '                         show-weeks="false"\n' +
    '                         is-open="dateToOpened"\n' +
    '                         datepicker-options="masterCardOrder.dateOptions.dateTo"\n' +
    '                         ng-class="{ \'domp-error\' : masterCardOrder.masterCardOrderForm.dateTo.$invalid && masterCardOrder.formSubmitted}"\n' +
    '                         required readonly>\n' +
    '                  <span class="input-group-btn">\n' +
    '                            <button data-ng-click="dateToOpened = !dateToOpened" type="button"\n' +
    '                                    class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                                    style="border:1px solid #062a42;">\n' +
    '                              <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                            </button>\n' +
    '                          </span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <span class="c-red" ng-show="masterCardOrder.masterCardOrderForm.dateBegin.$error.required && masterCardOrder.formSubmitted"\n' +
    '                    translate="orders.dateRequired"></span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div class="row p-b-20 p-t-20">\n' +
    '            <div class="col-md-12">\n' +
    '              <button class="btn btn-primary app-btn-blue pull-right domp-review-and-submit-btn pull-left"\n' +
    '                      ng-click="masterCardOrder.goBackToAccount()">\n' +
    '                <span translate="payments.cancel">Cancel</span>\n' +
    '              </button>\n' +
    '              <button class="btn btn-default  pull-right "\n' +
    '                      ng-click="masterCardOrder.validate()"\n' +
    '                      ng-disabled="masterCardOrder.nextButtonPressed">\n' +
    '                <span translate="domesticPayment.confirmBtnSlo">Confirm</span>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '      </ng-form>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="masterCardOrder.step == 2">\n' +
    '      <div class="domp-to-section m-10">\n' +
    '        <div class="row p-b-20">\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label-review" translate="masterCardOrder.cardAccount"></label>\n' +
    '              <label class="d-block domp-form-label-resume">{{masterCardOrder.tempObj.cardAccount}}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label-review" translate="masterCardOrder.cardType"></label>\n' +
    '              <label class="d-block domp-form-label-resume">{{masterCardOrder.selectedAccount.cardType.description | translate }}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row p-b-20">\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="masterCardOrder.cardNumber"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCardOrder.selectedAccount.selectedCard.cardNumber + \' \'+masterCardOrder.selectedAccount.selectedCard.cardHolder }}</label>\n' +
    '          </div>\n' +
    '          <div ng-if="masterCardOrder.selectedAccount.cardType.id == \'basic\'" class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="masterCardOrder.desiredLimit"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCardOrder.tempObj.amount | number:2}} {{masterCardOrder.selectedAccount.currencySymbol}}</label>\n' +
    '          </div>\n' +
    '          <div ng-if="masterCardOrder.selectedAccount.cardType.id == \'additional\'" class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="masterCardOrder.percentage"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCardOrder.tempObj.limit.description}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div  class="row">\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="masterCardOrder.limitType"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCardOrder.tempObj.limitType.description}}</label>\n' +
    '          </div>\n' +
    '          <div ng-if="masterCardOrder.tempObj.limitType.id == \'Temporary\'" class="col-xs-6 col-sm-3">\n' +
    '            <label class="domp-form-label-review" translate="masterCardOrder.dateFrom"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCardOrder.insertedOrderObject.limitTypeTempDateFrom | date:\'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '          <div ng-if="masterCardOrder.tempObj.limitType.id == \'Temporary\'" class="col-xs-6 col-sm-3">\n' +
    '            <label class="domp-form-label-review" translate="masterCardOrder.dateTo"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCardOrder.insertedOrderObject.limitTypeTempDateTo | date:\'shortDate\'}}</label>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-12">\n' +
    '        <button class="btn btn-primary " translate="domesticPayment.back"\n' +
    '                data-ng-click="masterCardOrder.edit();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-default pull-right" data-ng-click="masterCardOrder.confirm()" ng-disabled="masterCardOrder.confirmButtonPressed">\n' +
    '          <span translate="domesticPayment.confirmBtn"></span>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/master-card-new.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12" style="z-index:1;">\n' +
    '        <div class="tmplt-list-title col-md-12 p-r-0 p-l-0 m-b-15">\n' +
    '          <h2 class="title-style" translate="masterCard.header">Change overdraft limit</h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Title -->\n' +
    '\n' +
    '    <!-- START Note -->\n' +
    '    <div ng-if="masterCard.step == 1" class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="alert alert-info " style="background: white; color: black; border: 1px solid lightgray" >\n' +
    '          <div class="row"><div class="col-xs-12"></div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-12">\n' +
    '                <span translate="masterCard.info"></span>\n' +
    '                <span><a ng-href="{{APP_GLOBAL_SETTINGS.defaultData.BankChargesLink}}" target="_blank" translate="masterCard.infoPrice" class="underline"></a></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="row p-t-20">\n' +
    '            <div class="col-xs-4 p-0"><a href="https://www.addiko.si/addiko-placilna-mastercard-kartica" target="_blank" class="underline">{{ \'masterCard.infoLink1\' | translate}}</a></div>\n' +
    '            <div class="col-xs-4 p-0"><a href="https://www.addiko.si/addiko-zlata-mastercard-kartica" target="_blank" class="underline">{{ \'masterCard.infoLink2\' | translate}}</a></div>\n' +
    '            <div class="col-xs-4 p-0"><a href="https://www.addiko.si/addiko-kreditna-mastercard-kartica" target="_blank" class="underline">{{ \'masterCard.infoLink3\' | translate}}</a></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Note -->\n' +
    '\n' +
    '    <div ng-if="masterCard.step == 1" class="p-b-30">\n' +
    '      <ng-form name="masterCard.masterCardForm">\n' +
    '        <div class="cash-withdrawing-section-frame">\n' +
    '          <div class="row p-t-30">\n' +
    '\n' +
    '            <div class="col-md-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="masterCard.cardType"></label>\n' +
    '                <select name="cardType"\n' +
    '                        class="form-control input-field p-l-15 p-r-10"\n' +
    '                        ng-options="option.description for option in masterCard.cardTypes"\n' +
    '                        ng-model="masterCard.tempObj.cardType">\n' +
    '                </select>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="masterCard.tempObj.cardType.id == \'creditMasterCard\'" class="col-md-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="masterCard.percentType"></label>\n' +
    '                <select name="cardType"\n' +
    '                        class="form-control input-field p-l-15 p-r-10"\n' +
    '                        ng-options="option.description for option in masterCard.percentTypes"\n' +
    '                        ng-model="masterCard.tempObj.percentType">\n' +
    '                </select>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '          </div>\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-6">\n' +
    '\n' +
    '              <label class="domp-form-label" translate="masterCard.account">Account</label>\n' +
    '              <!-- START Dropdown account -->\n' +
    '              <div class="accounts-dropdown">\n' +
    '                <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '                     data-ng-click="masterCard.showAccountToDropdown = !masterCard.showAccountToDropdown" ng-style="masterCard.selectedAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + masterCard.selectedAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                      {{masterCard.selectedAccount.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                  <i class="zmdi"\n' +
    '                     ng-class="{\'zmdi-star favorite-account\': account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                </span>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{masterCard.selectedAccount.iban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{masterCard.selectedAccount.availableBalance | number:2}}\n' +
    '                    {{masterCard.selectedAccount.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                  <span class="caret-icon">\n' +
    '                  <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '              </span>\n' +
    '                </div>\n' +
    '                <div class="from-accounts-list m-l-15" style="z-index:12343" ng-show="masterCard.showAccountToDropdown" scrollable>\n' +
    '                  <div class="accounts-list-item p-0"\n' +
    '                       data-ng-repeat="account in masterCard.accountList"\n' +
    '                       data-ng-click="masterCard.selectAccount(account); masterCard.showAccountToDropdown = !masterCard.showAccountToDropdown">\n' +
    '                    <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget"\n' +
    '                         ng-style="account.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + account.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                      <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                        <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{account.friendlyName}}</b>\n' +
    '                        <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                      </h4>\n' +
    '                      <p class="m-b-0 m-t-0 iban-style">{{account.iban}}</p>\n' +
    '                      <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                        {{account.availableBalance | number:2}} {{account.currencySymbol}}\n' +
    '                      </p>\n' +
    '                      <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Dropdown account -->\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-xs-6">\n' +
    '              <!-- START Amount -->\n' +
    '              <div class="col-xs-12 p-0">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="masterCard.amount">Amount</label>\n' +
    '                  <div class="input-group">\n' +
    '                    <!-- TODO:// check this mask!!!! -->\n' +
    '                    <input id="amount" name="amount" type="text" class="form-control input-field t-a-r"\n' +
    '                           amount-input-mask\n' +
    '                           placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                           ng-model="masterCard.tempObj.amount"\n' +
    '                           ng-class="{\'domp-error\': masterCard.masterCardForm.amount.$invalid && masterCard.formSubmitted}"\n' +
    '                           maxlength="12"\n' +
    '                           autocomplete="off"\n' +
    '                           required>\n' +
    '                    <span class="input-group-btn">\n' +
    '                <button type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                        style="border:1px solid #062a42;">\n' +
    '                  {{masterCard.selectedAccount.currencySymbol}}\n' +
    '                </button>\n' +
    '              </span>\n' +
    '                  </div>\n' +
    '                  <label class="c-red"\n' +
    '                         ng-show="masterCard.masterCardForm.amount.$error.required && masterCard.formSubmitted"\n' +
    '                         translate="cashWithdrawalTranslate.amountRequired">\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Amount-->\n' +
    '              <div class="col-xs-12 p-0">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="masterCard.paymentDay"></label>\n' +
    '                  <select name="paymentDay"\n' +
    '                          class="form-control input-field p-l-15 p-r-10"\n' +
    '                          ng-options="option.id for option in masterCard.paymentDays "\n' +
    '                          ng-model="masterCard.tempObj.paymentDay">\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div class="row p-b-20 p-t-20">\n' +
    '            <div class="col-md-12">\n' +
    '              <button class="btn btn-primary app-btn-blue pull-right domp-review-and-submit-btn pull-left"\n' +
    '                      data-ui-sref="accountsOverview">\n' +
    '                <span translate="payments.cancel">Cancel</span>\n' +
    '              </button>\n' +
    '              <button class="btn btn-default  pull-right "\n' +
    '                      ng-disabled="masterCard.nextButtonPressed"\n' +
    '                      ng-click="masterCard.validateMasterCardNew()">\n' +
    '                <span translate="domesticPayment.confirmBtnSlo">Confirm</span>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </ng-form>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="masterCard.step == 2">\n' +
    '      <div class="domp-to-section m-10">\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label-review" translate="masterCard.account"></label>\n' +
    '              <label class="d-block domp-form-label-resume">{{masterCard.insertedOrder.account}}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '                <label class="domp-form-label-review" translate="masterCard.amount">Amount</label>\n' +
    '                <label class="d-block domp-form-label-resume">\n' +
    '                  {{masterCard.insertedOrder.limitAmount | number:2 }}\n' +
    '                  {{masterCard.selectedAccount.currencySymbol}}\n' +
    '                </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div ng ng-if="masterCard.tempObj.cardType.id == \'creditMasterCard\'" class="col-sm-offset-6 col-xs-12 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label-review" translate="masterCard.percentType"></label>\n' +
    '              <label class="d-block domp-form-label-resume">\n' +
    '                {{masterCard.insertedOrder.monthlyShareOfLiabilities.id}}\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="masterCard.cardType"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCard.tempObj.cardType.description}}</label>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="masterCard.paymentDay"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{masterCard.insertedOrder.orderTearDate.id }}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-12">\n' +
    '        <button class="btn btn-primary " translate="domesticPayment.back"\n' +
    '                data-ng-click="masterCard.editMasterCardNew();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-default pull-right" data-ng-click="masterCard.confirmMasterCardNew()" ng-disabled="masterCard.confirmButtonPressed">\n' +
    '          <span translate="domesticPayment.confirmBtn"></span>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '</div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/loans-overview.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row main-row p-b-10">\n' +
    '      <div class="main-column col-xs-12">\n' +
    '        <!-- START Title -->\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <h2 class="f-28" translate="laonsOverview.title"></h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="m-b-15 col-md-6"\n' +
    '               ng-repeat="account in loansOverview.accounts | orderBy:[\'-isFavorite\',\'-iban\']"\n' +
    '               data-ng-click="loansOverview.goToAccount(account.accountId)"\n' +
    '               ng-class="{\'col-md-6\': !accountsOverview.multiAccounts.length}">\n' +
    '            <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && loansOverview.accounts && loansOverview.accounts.length == 0" class="row">\n' +
    '          <div class="col-xs-12">\n' +
    '            <h4 class="acc-name c-red m-t-0 m-b-0"><b class="col-xs-10 p-0  no-wrap-text" translate="laonsOverview.noData"></b></h4>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/deposit-accounts-overview.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div class="row main-row">\n' +
    '      <div class="main-column col-xs-12">\n' +
    '        <!-- START Title -->\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <h2>\n' +
    '              <h2  class="f-28" ng-if="depositAccountsOverview.countryCode === \'hr\'"  translate="depositAccountsOverview.title"></h2>\n' +
    '              <h2  class="f-28" ng-if="depositAccountsOverview.countryCode === \'sl\'"  translate="depositAccountsOverview.titleForSlo"></h2>\n' +
    '              <h2 class="f-28" ng-if="depositAccountsOverview.countryCode == \'sr\' || depositAccountsOverview.countryCode == \'mne\'"\n' +
    '                  translate="depositAccountsOverview.titleForSerbAndMne"></h2>\n' +
    '              <h2 class="f-28" ng-if="depositAccountsOverview.countryCode == \'bh\'" translate="depositAccountsOverview.titleForBh"></h2>\n' +
    '            </h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '          <div ng-switch-default class="m-b-15 col-md-6"\n' +
    '               ng-repeat="account in depositAccountsOverview.accounts | orderBy:[\'accountType.group\', \'-isFavorite\', \'iban\']"\n' +
    '               data-ng-click="depositAccountsOverview.goToAccount(account.accountId)"\n' +
    '               ng-class="{\'col-md-6\': !accountsOverview.multiAccounts.length}">\n' +
    '            <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '          <div ng-switch-when="sl" class="m-b-15 col-md-6"\n' +
    '               ng-repeat="account in depositAccountsOverview.accounts | orderBy:[\'-isFavorite\', \'-isOwn\', \'-accountType.group\']"\n' +
    '               data-ng-click="depositAccountsOverview.goToAccount(account.accountId)"\n' +
    '               ng-class="{\'col-md-6\': !accountsOverview.multiAccounts.length}">\n' +
    '            <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- START Add New Deposit and New eSaving Account Buttons -->\n' +
    '        <div ng-if="depositAccountsOverview.countryCode === \'hr\'" class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <div class="col-md-6 m-b-10 btn-padding-left">\n' +
    '                <div class="account-item-add app-dblue-card " ui-sref="orders.termDeposit" ng-click="depositAccountsOverview.pushGtmNavEvent(\'termDeposit\');">\n' +
    '                <div class="round-btn-container2">\n' +
    '                  <div class="round-btn2">\n' +
    '                    <i class="icon-r icon-add"></i>\n' +
    '                  </div>\n' +
    '                  <div class="round-btn-label2">\n' +
    '                    <b translate="accountsOverview.newTermDepositButtonLabel"></b>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-md-6 btn-padding-right">\n' +
    '                <div class="account-item-add app-dblue-card " ui-sref="newEbook" ng-click="depositAccountsOverview.pushGtmNavEvent(\'eBook\');">\n' +
    '                <div class="round-btn-container2">\n' +
    '\n' +
    '                  <div class="round-btn2">\n' +
    '                    <i class="icon-r icon-add"></i>\n' +
    '                  </div>\n' +
    '                  <div class="round-btn-label2" style="width: 180px">\n' +
    '                    <div ng-switch="depositAccountsOverview.countryCode" class="round-btn-label2">\n' +
    '                      <b ng-switch-default translate="accountsOverview.newESavingAccountButtonLabel"></b>\n' +
    '                      <b ng-switch-when="sl" translate="accountsOverview.newSavingButtonLabel_SLO"></b>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END Add New Deposit and New eSaving Account Buttons -->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/connected-debit-card.tpl.html',
    '<div class="col-md-12">\n' +
    '  <h3 translate="accounts.connectedDebitCards"></h3>\n' +
    '</div>\n' +
    '<div class="col-md-12" ng-repeat="card in accounts.selectedAccount.cardList">\n' +
    '  <div class="debit-card-group clearfix"\n' +
    '       ng-class="{\'debit-card-group-blocked\': (card.cardStatus !== \'Active\')}">\n' +
    '    <div class="col-xs-12 col-md-3">\n' +
    '      <div class="connected-debit-card-widget"></div>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12" ng-class="{\'col-md-6\': (APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\'), \'col-md-3\': (APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\' && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'bh\')}">\n' +
    '      <h3 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'bh\'">\n' +
    '        <span ng-if="card.hasOwnProperty(\'friendlyName\')">{{card.friendlyName}}</span>\n' +
    '        <span ng-if="!card.hasOwnProperty(\'friendlyName\')">{{accounts.selectedAccount.friendlyName}}</span>\n' +
    '      </h3>\n' +
    '      <h3 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\'"><span>{{accounts.selectedAccount.ownerName}}</span></h3>\n' +
    '\n' +
    '      <h5 ng-show="card.cardNumber && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"><b translate="accounts.creditCardNumber"></b>: {{accounts.formatCardNumber(card.cardNumber)}}</h5>\n' +
    '      <h5 ng-show="card.cardNumber && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">{{accounts.formatCardNumber(card.cardNumber)}}</h5>\n' +
    '      <!--<h5 ng-show="card.cardNumber">{{accounts.formatIban(card.cardNumber)}}</h5>-->\n' +
    '      <!--<h5 ng-show="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">{{accounts.selectedAccount.ownerName}}</h5>-->\n' +
    '      <h5 ng-show="card.cardType && accountsOverview.countryCode == \'hr\'">{{card.cardType}}</h5>\n' +
    '      <h5 ng-show="card.cardTypeDescription && accountsOverview.countryCode != \'hr\'">{{card.cardTypeDescription}}</h5>\n' +
    '      <h5 ng-show="card.validToDate" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '         <span  ng-switch-default><span translate="accounts.expDate">Expiry date: </span>{{card.validToDate | date: "dd.MM.yyyy"}}</span>\n' +
    '         <span ng-switch-when="sl" ><span translate="accounts.expDate_SLO">Expiry date: </span>{{card.validToDate | date: "MM.yyyy"}}</span>\n' +
    '      </h5>\n' +
    '      <h5 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'bh\'" ng-show="card.cardStatus"><b>Status:</b> {{\'accounts.\'+card.cardStatus | translate }}</h5>\n' +
    '      <h5 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\'" ng-show="card.cardStatus"><b>Status:</b> {{\'accounts.cardStatus.\'+card.cardStatus | translate }}</h5>\n' +
    '      <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '        <h5>\n' +
    '          <b translate="accounts.accApprovedLimit"></b>:\n' +
    '          {{card.limitAmount | currency: ""}} {{card.currency}}\n' +
    '        </h5>\n' +
    '        <h5>\n' +
    '          <b translate="accounts.limitForATM"></b>:\n' +
    '          {{card.limitAmountATM | currency: ""}}\n' +
    '        </h5>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-3" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <h3 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'bh\'" ng-show="accounts.selectedAccount.ownerName">{{accounts.selectedAccount.ownerName}}</h3>\n' +
    '    </div>\n' +
    '    <!--<p>Account: <a href="" ng-click="">Current account</a></p></div>-->\n' +
    '    <!--<div class="col-xs-1"></div>-->\n' +
    '    <div class="col-xs-12 col-md-3">\n' +
    '      <button class="btn btn-info btn-block"\n' +
    '              ng-hide="accounts.countryCode == \'hr\' || accounts.countryCode == \'sl\'"\n' +
    '              ng-disabled="card.selected"\n' +
    '              ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\'),\n' +
    '                          \'btn-card-blocked\': (card.cardStatus !== \'Active\')}"\n' +
    '              ng-click="accounts.updateCardStatus(accounts.selectedAccount.accountId, card)">\n' +
    '        <span ng-show="card.temporaryStatus && card.temporaryStatus == \'SentUnblockRequest\'" class="f-12" translate="accounts.unblockCardRequest">Unblock request sent</span>\n' +
    '        <span ng-show="card.temporaryStatus && card.temporaryStatus == \'SentBlockRequest\'" class="f-12" translate="accounts.blockCardRequest">Block request sent</span>\n' +
    '        <span ng-show="!card.temporaryStatus &&  card.cardStatus === \'Active\'" translate="accounts.blockCard"></span>\n' +
    '        <span ng-show="!card.temporaryStatus && card.cardStatus != \'Active\'" translate="accounts.unblockCard"></span>\n' +
    '      </button>\n' +
    '      <button class="btn btn-info btn-block"\n' +
    '              ng-show="accounts.countryCode == \'hr\'"\n' +
    '              ng-disabled="card.selected"\n' +
    '              ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\' && !card.temporaryStatus),\n' +
    '                         \'btn-card-blocked\': (card.cardStatus !== \'Active\' || card.temporaryStatus)}"\n' +
    '              ng-click="accounts.updateCardStatusCro()">\n' +
    '        <span ng-show="card.cardStatus === \'Active\'" translate="accounts.blockCard"></span>\n' +
    '        <span ng-hide="card.cardStatus === \'Active\'" translate="accounts.unblockCard"></span>\n' +
    '      </button>\n' +
    '      <button class="btn btn-info btn-block"\n' +
    '              ng-if="accounts.countryCode == \'sl\' && (card.cardStatus === \'Active\' || card.cardStatus === \'Blocked\')"\n' +
    '              ng-disabled="card.selected"\n' +
    '              ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\' && !card.temporaryStatus),\n' +
    '                         \'btn-card-blocked\': (card.cardStatus === \'Blocked\' || card.temporaryStatus)}"\n' +
    '              ng-click="accounts.updateCardStatusCro()">\n' +
    '        <span ng-show="card.cardStatus === \'Active\'" translate="accounts.blockCard"></span>\n' +
    '        <span ng-show="card.cardStatus === \'Blocked\'" translate="accounts.unblockCard"></span>\n' +
    '      </button>\n' +
    '\n' +
    '      <button class="btn btn-info btn-block"\n' +
    '              ng-hide="!accounts.links.transactions || accounts.countryCode == \'hr\'"\n' +
    '              ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\'),\n' +
    '                         \'btn-card-blocked\': (card.cardStatus !== \'Active\')}"\n' +
    '              ng-click="accounts.openCardTransactions(accounts.selectedAccount.accountId, card, $event)">\n' +
    '        <span ng-show="!card.collapsed" translate="accounts.accTransactions">Transactions</span>\n' +
    '        <span ng-show="card.collapsed" translate="accounts.accHideTransactions">Hide transactions</span>\n' +
    '      </button>\n' +
    '      <button class="btn btn-info btn-block" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '                       ng-show="accounts.links.cardReservation"\n' +
    '                       ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\'),\n' +
    '                         \'btn-card-blocked\': (card.cardStatus !== \'Active\')}"\n' +
    '                       ng-click="accounts.openCardReservations(accounts.selectedAccount.accountId, card, $event)">\n' +
    '      <span ng-show="!card.collapsedRes" translate="accounts.accReservations">Reservations</span>\n' +
    '      <span ng-show="card.collapsedRes" translate="accounts.accHideReservations">Hide reservations</span>\n' +
    '    </button>\n' +
    '      <button class="btn btn-info btn-block btn-card-active"\n' +
    '              ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && accounts.selectedAccount.accountType.group == \'CardAccountTypes\'\n' +
    '              && accounts.selectedAccount.isOwn && card.cardStatus === \'Active\'"\n' +
    '              data-ui-sref="masterCardOrder({accountId: accounts.selectedAccount.accountId, cardId: card.cardId })">\n' +
    '        <span translate="masterCardOrder.orderLimit">Order limit</span>\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-3 m-t-10" ng-hide="accounts.selectedAccount.ownerName"></div>\n' +
    '    <!--<div class="col-xs-12 col-md-3 m-t-10">-->\n' +
    '      <!--<button class="btn btn-info btn-block"-->\n' +
    '              <!--ng-hide="!accounts.links.transactions || accounts.countryCode == \'hr\'"-->\n' +
    '              <!--ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\'),-->\n' +
    '                         <!--\'btn-card-blocked\': (card.cardStatus !== \'Active\')}"-->\n' +
    '              <!--ng-click="accounts.openCardTransactions(accounts.selectedAccount.accountId, card, $event)">-->\n' +
    '        <!--<span ng-show="!card.collapsed" translate="accounts.accTransactions">Transactions</span>-->\n' +
    '        <!--<span ng-show="card.collapsed" translate="accounts.accHideTransactions">Hide transactions</span>-->\n' +
    '      <!--</button>-->\n' +
    '      <!--<button class="btn btn-info btn-block" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"-->\n' +
    '              <!--ng-show="accounts.links.cardReservation"-->\n' +
    '              <!--ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\'),-->\n' +
    '                         <!--\'btn-card-blocked\': (card.cardStatus !== \'Active\')}"-->\n' +
    '              <!--ng-click="accounts.openCardReservations(accounts.selectedAccount.accountId, card, $event)">-->\n' +
    '        <!--<span ng-show="!card.collapsedRes" translate="accounts.accReservations">Reservations</span>-->\n' +
    '        <!--<span ng-show="card.collapsedRes" translate="accounts.accHideReservations">Hide reservations</span>-->\n' +
    '      <!--</button>-->\n' +
    '    <!--</div>-->\n' +
    '  </div>\n' +
    '  <div ng-show="card.collapsed">\n' +
    '    <div ng-include="\'accounts/connected-cards-transactions.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '  <div ng-show="card.collapsedRes">\n' +
    '    <div ng-include="\'accounts/connected-cards-reservations.tpl.html\'"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/connected-cards-transactions.tpl.html',
    '\n' +
    '<div class="col-sm-12 col-md-12 p-r-0">\n' +
    '\n' +
    '    <div class="col-sm-12 col-md-6 p-0 m-t-5">\n' +
    '     <!--<transactions-filter ng-if="accounts.currenciesList.length" transactions="accounts.connectedCardTransactionsList.result"-->\n' +
    '                         <!--transaction-currency-list="accounts.currenciesList"-->\n' +
    '                          <!--data-statements="(accounts.countryCode === \'sl\')"-->\n' +
    '                         <!--transaction-filter-change="accounts.refreshCardTransactionsByFilter(filterParams)"-->\n' +
    '                         <!--currency="accounts.defaultCurrency">-->\n' +
    '    <!--</transactions-filter>-->\n' +
    '\n' +
    '      <div data-ng-include="\'accounts/connected-cards-transaction-filter.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '  <div id="periodViewSelector" class="period-selector">\n' +
    '    <div class="period-view-select-div left"><span translate="accounts.accPeriod"></span>:</div>\n' +
    '    <div class="period-view-select-div right">\n' +
    '      <div class="dropdown acc-period-select" ng-init="periodSelectorLabel=\'This week\'">\n' +
    '        <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"\n' +
    '                aria-expanded="true">\n' +
    '          {{accounts.connectedCardsSelectedPeriod.description | translate}}\n' +
    '          <span class="caret"></span>\n' +
    '        </button>\n' +
    '        <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '          <li data-ng-repeat="period in accounts.periodList">\n' +
    '            <a href ng-click="accounts.changeConnectedCardsTransactionPeriod(period)">{{period.description | translate}}</a>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    ' <div class="t-a-c p-10 m-t-20 m-b-30 no-data-image" ng-show="accounts.connectedCardTransactionsList.result.length == 0">\n' +
    '  <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '  <h3 class="no-data-label" translate="transactions.noData"></h3>\n' +
    '</div>\n' +
    '\n' +
    '<!--<div class="hypo-timeline-header-line col-sm-12 no-bottom-radius no-top-radius visible-md-block visible-sm-block visible-lg-block" ng-show="accounts.selectedAccount.transactions.result.length > 0">\n' +
    '<div class="col-md-6 col-sm-4 t-a-l p-0" translate="accounts.accDescription"></div>\n' +
    '<div class="col-md-3 col-sm-4 t-a-r p-0" translate="accounts.accAmount"></div>\n' +
    '<div class="col-md-3 col-sm-4 t-a-r p-0" translate="accounts.accBalance"></div>\n' +
    '</div>-->\n' +
    '\n' +
    '<div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" class="row p-t-15" ng-show="accounts.connectedCardTransactionsList.result.length > 0">\n' +
    '  <div class="col-xs-12 col-sm-6 t-a-r hidden-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumCredit\' | translate}} {{accounts.connectedCardTransactionsList.result[1].balanceSumCredit\n' +
    '      | number:2}} {{accounts.connectedCardTransactionsList.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 col-sm-6 t-a-l hidden-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumDebit\' | translate}} {{accounts.connectedCardTransactionsList.result[1].balanceSumDebit |\n' +
    '      number:2}} {{accounts.connectedCardTransactionsList.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="col-xs-12 t-a-c visible-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumCredit\' | translate}} {{accounts.connectedCardTransactionsList.result[1].balanceSumCredit\n' +
    '      | number:2}} {{accounts.connectedCardTransactionsList.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 t-a-c visible-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumDebit\' | translate}} {{accounts.connectedCardTransactionsList.result[1].balanceSumDebit |\n' +
    '      number:2}} {{accounts.connectedCardTransactionsList.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<div class="timeline-row col-sm-12 p-l-0 p-r-0" ng-show="accounts.connectedCardTransactionsList.result.length > 0">\n' +
    '  <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0 no-top-radius">\n' +
    '    <ul class="hypo-timeline statements-timeline">\n' +
    '      <li data-ng-repeat="transaction in accounts.connectedCardTransactionsList.result" ng-class="{\'time-label\': transaction.isVirtual === true, \'tl-badge-icon\': transaction.isVirtual === undefined}">\n' +
    '        <span ng-if="transaction.isVirtual === true">{{transaction.valueDate | date: \'shortDate\'}}</span>\n' +
    '          <i ng-if="transaction.isVirtual == undefined" data-ng-class="{\'icon icon-priliv\': transaction.credit != null,\'icon icon-odliv\': transaction.credit == null}"></i>\n' +
    '        <div ng-if="transaction.isVirtual == undefined" class="hypo-timeline-item transaction-item" data-ng-click="transaction.selected = !transaction.selected; accounts.getTransactionDetails(transaction);" ng-class="{\'opened\': transaction.selected}">\n' +
    '          <div class="hypo-timeline-body">\n' +
    '            <div class="col-xs-6 col-sm-8 p-l-0 p-r-0">\n' +
    '              <h4 class="m-b-0 m-t-0 c-gray no-wrap-text"><b>{{::transaction.detail.purpose}}</b></h4>\n' +
    '              <p class="m-b-0 m-t-0 no-wrap-text">{{::transaction.detail.purpose}}</p>\n' +
    '            </div>\n' +
    '            <div ng-if="transaction.credit == null" class="col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::transaction.debit | number:2}} {{::transaction.currencySymbol}}</b></span></div>\n' +
    '            <div ng-if="transaction.debit == null" class="col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::transaction.credit | number:2}} {{::transaction.currencySymbol}}</b></span></div>\n' +
    '\n' +
    '\n' +
    '          </div>\n' +
    '          <div ng-if="transaction.selected" class="m-l-0 transaction-details">\n' +
    '            <div data-ng-include="\'accounts/connected-cards-trans-details.tpl.html\'"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div ng-if="accounts.connectedCardTransactionsList.hasMore == true" class="col-xs-12 t-a-c m-t-15 m-b-15">\n' +
    '  <button data-ng-click="accounts.loadMoreConnectedCardsTransactions(false)"\n' +
    '          type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn"\n' +
    '          translate="paymentsOverview.loadMoreBtn">Load more</button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/connected-cards-transaction-filter.tpl.html',
    '<!-- CONNECTED CARDS TRANSACTION FILTER html START -->\n' +
    '<div class="tml-filter-container tmlf-wide"\n' +
    '     stlye="overflow: hidden; margin: 15px">\n' +
    '  <!-- START Search text input -->\n' +
    '  <div class="inner-section left">\n' +
    '    <i class="icon icon-search icon-hc-2x m-l-5"></i>\n' +
    '  </div>\n' +
    '  <div class="inner-section center">\n' +
    '    <input type="text" class="search-input"\n' +
    '           placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '           ng-model="accounts.transactionCardsFilterOptions.genericSearch" ng-model-options="{ debounce: 300 }"\n' +
    '           ng-change="accounts.searchCards()">\n' +
    '  </div>\n' +
    '  <div  class="inner-section right pull-right">\n' +
    '    <i class="zmdi zmdi-tag-close pull-left zmdi-hc-2x m-r-0"\n' +
    '       ng-show="accounts.transactionCardsFilterOptions.genericSearch"\n' +
    '       ng-click="accounts.clearCardsSearch();">\n' +
    '    </i>\n' +
    '    <i class="icon icon-filter icon-hc-2x i-r-0 pull-right" style="z-index: 100000"\n' +
    '       ng-click="accounts.showCardsFilterOptionsWrapper = !accounts.showCardsFilterOptionsWrapper">\n' +
    '    </i>\n' +
    '  </div>\n' +
    '  <div class="tml-filter-selection"\n' +
    '       ng-class="{\'opened\': accounts.showCardsFilterOptionsWrapper,\n' +
    '       \'h-430\': (accounts.transactionCards.dateFromOpen || accounts.transactionCards.dateToOpen) && !(accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\'),\n' +
    '       \'h-510\': ((accounts.transactionCards.dateFromOpen || accounts.transactionCards.dateToOpen) && accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\')}"\n' +
    '       style="z-index: 6">\n' +
    '    <div class="tml-filter-type-selection-wrapper">\n' +
    '      <div ng-class="{\'selected\': accounts.transactionCardsFilterOptions.transactionType === undefined}" class="tmlf-type-item"\n' +
    '           ng-click="accounts.transactionCardsFilterOptions.transactionType = undefined"\n' +
    '           translate="timelineFilter.all"\n' +
    '           style="width: 33.333%">\n' +
    '      </div>\n' +
    '      <div ng-class="{\'selected\': accounts.transactionCardsFilterOptions.transactionType == \'Credit\'}" class="tmlf-type-item"\n' +
    '           style="width: 33.333%"\n' +
    '           ng-click="accounts.transactionCardsFilterOptions.transactionType = \'Credit\'"\n' +
    '           translate="timelineFilter.credit"></div>\n' +
    '      <div ng-class="{\'selected\': accounts.transactionCardsFilterOptions.transactionType == \'Debit\'}" class="tmlf-type-item"\n' +
    '           style="width: 33.333%"\n' +
    '           ng-click="accounts.transactionCardsFilterOptions.transactionType = \'Debit\'"\n' +
    '           translate="timelineFilter.debit"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <span ng-if="(accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\')">\n' +
    '    <div class="m-t-15" style="overflow:auto">\n' +
    '      <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '        <div class="form-group m-b-0">\n' +
    '          <label class="f-12-s" translate="transactions.statementsFilter"></label>\n' +
    '          <select class="form-control-db"\n' +
    '                  ng-options="option | date:\'shortDate\' for option in accounts.statementDates"\n' +
    '                  ng-change="accounts.transactionCardsFilterOptions.dateFrom = undefined; accounts.transactionCardsFilterOptions.dateTo = undefined; accounts.transactionCards.transactionFilterYearDateRangeValid = true"\n' +
    '                  ng-model="accounts.transactionCardsFilterOptions.datePeriodStart">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- START: Row Date from and date to -->\n' +
    '    <div class="m-t-15 clearfix">\n' +
    '      <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '        <div class="form-group m-b-0">\n' +
    '          <label class="f-12-s" translate="repaymentPlan.dateFrom">Date from</label>\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control-db"\n' +
    '                   ng-class="{\'domp-error\': (!accounts.transactionCardsFilterOptions.datePeriodStart && !accounts.transactionCardsFilterOptions.dateFrom)}"\n' +
    '                   ng-value="accounts.transactionCardsFilterOptions.dateFrom | date: \'shortDate\'"\n' +
    '                   readonly>\n' +
    '            <span class="input-group-btn">\n' +
    '                  <button data-ng-click="accounts.transactionCards.dateFromOpen = !accounts.transactionCards.dateFromOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 p-l-0 p-r-5">\n' +
    '        <div class="form-group m-b-0">\n' +
    '          <label class="f-12-s" translate="repaymentPlan.dateTo">Date to</label>\n' +
    '          <div class="input-group ">\n' +
    '            <input type="text" class="form-control-db"\n' +
    '                   ng-class="{\'domp-error\': (!accounts.transactionCardsFilterOptions.datePeriodStart && !accounts.transactionCardsFilterOptions.dateTo)}"\n' +
    '                   ng-value="accounts.transactionCardsFilterOptions.dateTo | date: \'shortDate\'"\n' +
    '                   readonly>\n' +
    '            <span class="input-group-btn">\n' +
    '                  <button data-ng-click="accounts.transactionCards.dateToOpen = !accounts.transactionCards.dateToOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Datepickers -->\n' +
    '      <div class="col-xs-6 p-l-0 p-r-5 transactions-date-pickers">\n' +
    '        <!-- Date from datepicker-->\n' +
    '        <div data-ng-model="accounts.transactionCardsFilterOptions.dateFrom"\n' +
    '             show-weeks="false"\n' +
    '             is-open="accounts.transactionCards.dateFromOpen"\n' +
    '             ng-change="accounts.transactionCards.onDateFromChange();accounts.transactionCards.clearStatementDate();"\n' +
    '             uib-datepicker-popup="shortDate"\n' +
    '             show-button-bar="false"\n' +
    '             required="">\n' +
    '        </div>\n' +
    '        <!-- Date to datepicker-->\n' +
    '        <div data-ng-model="accounts.transactionCardsFilterOptions.dateTo"\n' +
    '             show-weeks="false"\n' +
    '             is-open="accounts.transactionCards.dateToOpen"\n' +
    '             ng-change="accounts.transactionCards.onDateToChange();accounts.transactionCards.clearStatementDate();"\n' +
    '             date-disabled="accounts.transactionCards.datesToDisabled(date, mode)"\n' +
    '             show-button-bar="false"\n' +
    '             uib-datepicker-popup="shortDate">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '      <span class="p-l-5 p-t-5 c-red" ng-if="!accounts.transactionCards.transactionFilterYearDateRangeValid">\n' +
    '        <span translate="core.filter.maxDateRange"></span>\n' +
    '      </span>\n' +
    '    <!-- END: Row Date from and date to -->\n' +
    '    </span>\n' +
    '    <div class="m-t-15" style="overflow:auto">\n' +
    '      <div class="col-xs-5 p-l-5 p-r-5">\n' +
    '        <div class="form-group">\n' +
    '          <label class="f-12-s" translate="timelineFilter.amountFrom"></label>\n' +
    '          <input ng-keyup="$event.keyCode == 13 && accounts.applyFilter()" type="text" class="form-control-db"\n' +
    '                 ng-model="accounts.transactionCardsFilterOptions.amountGTE"\n' +
    '                 amount-input-mask maxlength="12"\n' +
    '                 placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" autocomplete="off">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-4 p-l-0 p-r-5">\n' +
    '        <div class="form-group">\n' +
    '          <label class="f-12-s" translate="timelineFilter.amountTo"></label>\n' +
    '          <input ng-keyup="$event.keyCode == 13 && accounts.applyFilter()" type="text" class="form-control-db"\n' +
    '                 ng-model="accounts.transactionCardsFilterOptions.amountLTE"\n' +
    '                 amount-input-mask maxlength="12"\n' +
    '                 placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" autocomplete="off">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-3 p-l-0 p-r-5 p-t-25">\n' +
    '        <select class="form-control-db"\n' +
    '                ng-options="option.symbol as option.symbol for option in accounts.currenciesList"\n' +
    '                ng-model="accounts.transactionCardsFilterOptions.currencySymbol">\n' +
    '        </select>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="m-b-15" style="overflow:auto">\n' +
    '      <div class="col-xs-6 t-a-l p-l-5">\n' +
    '        <button class="btn btn-primary app-btn-gray ng-scope" ng-click="accounts.resetCardsFilter();"\n' +
    '                translate="timelineFilter.reset">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r p-r-5">\n' +
    '        <button class="btn btn-default app-btn-blue w-100" ng-click="accounts.applyCardsFilter();"\n' +
    '                ng-disabled="!accounts.transactionCards.transactionFilterYearDateRangeValid"\n' +
    '                translate="timelineFilter.apply">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- END Detail filter expanded -->\n' +
    '\n' +
    '</div>\n' +
    '<!-- CONNECTED CARDS TRANSACTION FILTER html END -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/connected-cards-trans-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '  <tbody>\n' +
    '    <tr>\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.description"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.detail.purpose}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.amount"></span></td>\n' +
    '      <td class="right-col">\n' +
    '        <span class="tridm-value-label outcome-tr" ng-if="transaction.debit"><span ng-if="accounts.countryCode == \'sr\'">- </span>{{transaction.debit | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '        <span class="tridm-value-label income-tr" ng-if="transaction.credit">{{transaction.credit | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.accountNumber"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.account.accountNumber}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.card"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.account.accountType.description}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.bookingDate"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.bookingDate | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.valueDate"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.valueDate | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr  ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="accounts.creditCardNumber"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.cardNumber}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="(APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\') && transaction.referenceNumber && transaction.referenceNumber != \'0\'">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.connCardReferenceAccount"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.referenceNumber}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr  ng-if="(APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\') && transaction.sourceAmount">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.transactionAndOriginalCurrency"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.sourceAmount | currency: ""}} {{transaction.sourceCurrencySymbol}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr  ng-if="transaction.hasOwnProperty(\'datePeriodStart\') && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.statementDate"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.datePeriodStart | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\' && !transaction.transactionDivision && accounts.additionalCheck(transaction, accounts.selectedAccount.accountType.id)">\n' +
    '      <td class="left-col"></td>\n' +
    '      <td class="right-col">\n' +
    '        <button type="button" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                data-ui-sref="transactionDivison.create({transactionId: transaction.id, card: card.cardNumber.substr(card.cardNumber.length - 4, 4)})">{{\'accounts.transDivisionBtn1\' | translate}} {{\'accounts.transDivisionBtn2\' | translate}}\n' +
    '        </button>\n' +
    '      </td>\n' +
    '      <!--<td>-->\n' +
    '      <!--<button ng-hide="accounts.countryCode != \'hr\'" type="button" translate="dashboard.confirmation" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"-->\n' +
    '      <!--data-ng-click = "accounts.downloadTransactionReport(transaction);">-->\n' +
    '      <!--</button>-->\n' +
    '      <!--</td>-->\n' +
    '    </tr>\n' +
    '    <!-- Transaction confirmation\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <button type="button" translate="dashboard.complaint" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase" data-ng-click="accounts.navigateToReclamationForm(transaction);">\n' +
    '        </button>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <button type="button" translate="dashboard.confirmation" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase" data-ng-click="accounts.downloadTransactionReport(transaction);">\n' +
    '        </button>\n' +
    '      </td>\n' +
    '</tr> -->\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/connected-cards-reservations.tpl.html',
    '<div class="col-sm-12 col-md-12 p-r-0">\n' +
    '    <!--    <div class="col-sm-12 col-md-6 p-0 p-t-5">\n' +
    '            <div ng-include="\'accounts/connected-cards-filter.tpl.html\'" style="height:40px"></div>\n' +
    '    </div>-->\n' +
    '    <div id="periodViewSelector" class="period-selector">\n' +
    '        <div class="period-view-select-div left"><span translate="accounts.accPeriod"></span>:</div>\n' +
    '        <div class="period-view-select-div right">\n' +
    '            <div class="dropdown acc-period-select" ng-init="periodSelectorLabel=\'This week\'">\n' +
    '                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n' +
    '                    {{accounts.connectedCardsSelectedPeriod.description | translate}}\n' +
    '                    <span class="caret"></span>\n' +
    '                </button>\n' +
    '                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '                    <li data-ng-repeat="period in accounts.periodList">\n' +
    '                        <a href ng-click="accounts.changeConnectedCardsReservationPeriod(period)">{{period.description | translate}}</a>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="t-a-c p-10 m-t-20 m-b-30 no-data-image" ng-show="accounts.connectedCardReservationsList.result.length == 0">\n' +
    '    <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '    <h3 class="no-data-label" translate="transactions.noData"></h3>\n' +
    '</div>\n' +
    '\n' +
    '<!--<div class="hypo-timeline-header-line col-sm-12 no-bottom-radius no-top-radius visible-md-block visible-sm-block visible-lg-block" ng-show="accounts.selectedAccount.transactions.result.length > 0">\n' +
    '<div class="col-md-6 col-sm-4 t-a-l p-0" translate="accounts.accDescription"></div>\n' +
    '<div class="col-md-3 col-sm-4 t-a-r p-0" translate="accounts.accAmount"></div>\n' +
    '<div class="col-md-3 col-sm-4 t-a-r p-0" translate="accounts.accBalance"></div>\n' +
    '</div>-->\n' +
    '\n' +
    '<div class="timeline-row col-sm-12 p-l-0 p-r-0" infinite-scroll=\'accounts.loadMoreConnectedCardsReservations(false)\' infinite-scroll-disabled=\'accounts.busy\' infinite-scroll-distance=\'1\' ng-show="accounts.connectedCardReservationsList.result.length > 0">\n' +
    '    <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0 no-top-radius">\n' +
    '        <ul class="hypo-timeline statements-timeline">\n' +
    '            <li data-ng-repeat="transaction in accounts.connectedCardReservationsList.result" ng-class="{\'time-label\': transaction.isVirtual === true, \'tl-badge-icon\': transaction.isVirtual === undefined}">\n' +
    '                <span ng-if="transaction.isVirtual === true">{{transaction.valueDate | date: \'shortDate\'}}</span>\n' +
    '                <i ng-if="transaction.isVirtual == undefined" data-ng-class="{\'icon icon-priliv\': transaction.credit != null,\'icon icon-odliv\': transaction.credit == null}"></i>\n' +
    '                <div ng-if="transaction.isVirtual == undefined" class="hypo-timeline-item transaction-item" data-ng-click="transaction.selected = !transaction.selected; accounts.getTransactionDetails(transaction);" ng-class="{\'opened\': transaction.selected}">\n' +
    '                    <div class="hypo-timeline-body">\n' +
    '                        <div class="col-xs-6 col-sm-8 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-b-0 m-t-0 c-gray no-wrap-text"><b>{{::transaction.purpose}}</b></h4>\n' +
    '                            <p class="m-b-0 m-t-0 no-wrap-text">{{::transaction.purpose}}</p>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-6 col-sm-4 p-l-0 p-r-0">\n' +
    '                            <span class="pull-right t-a-r m-t-5 f-18"><b>{{::transaction.amount }} {{::transaction.currency}}</b></span>\n' +
    '                            <!--<span class="pull-right t-a-r m-t-5 f-18"><b>{{::transaction.amount | number:2}} {{::transaction.currency}}</b></span>-->\n' +
    '                        </div>\n' +
    '                        <!--<div ng-if="transaction.transactionType == \'C\'" class="col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::transaction.sourceAmount | number:2}} {{::transaction.currency}}</b></span></div>-->\n' +
    '\n' +
    '                    </div>\n' +
    '                    <div ng-if="transaction.selected" class="m-l-0 transaction-details">\n' +
    '                        <div data-ng-include="\'accounts/connected-cards-reser-details.tpl.html\'"></div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/connected-cards-reser-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '  <tbody>\n' +
    '    <tr ng-if="transaction.description">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.description"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.description}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.amount"></span></td>\n' +
    '      <td class="right-col">\n' +
    '        <span class="tridm-value-label outcome-tr" ng-if="transaction.transactionType === \'D\'">{{transaction.amount }} {{transaction.currency}}</span>\n' +
    '        <span class="tridm-value-label income-tr" ng-if="transaction.transactionType === \'C\'">{{transaction.amount }} {{transaction.currency}}</span>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="transaction.account.accountNumber">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.accountNumber"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.account.accountNumber}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="transaction.account.accountType.description">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.card"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.account.accountType.description}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="transaction.reservationDate">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="reservations.reservationDate"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.reservationDate | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="transaction.valueDate">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.valueDate"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.valueDate | date:\'shortDate\'}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="transaction.referenceNumber">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="transactions.referenceNumber"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.referenceNumber }}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="transaction.transactionType">\n' +
    '      <td class="left-col"><span class="tridm-key-label" translate="reservations.transactionType"></span></td>\n' +
    '      <td class="right-col"><span class="tridm-value-label">{{transaction.transactionType}}</span></td>\n' +
    '    </tr>\n' +
    '    <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\' && !transaction.transactionDivision && accounts.additionalCheck(transaction, accounts.selectedAccount.accountType.id)">\n' +
    '      <td class="left-col"></td>\n' +
    '      <td class="right-col">\n' +
    '        <button type="button" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                data-ui-sref="transactionDivison.create({reservationId: transaction.reservationID, card: card.cardNumber.substr(card.cardNumber.length - 4, 4)})">{{\'accounts.transDivisionBtn1\' | translate}} {{\'accounts.transDivisionBtn2\' | translate}}\n' +
    '        </button>\n' +
    '      </td>\n' +
    '      <!--<td>-->\n' +
    '      <!--<button ng-hide="accounts.countryCode != \'hr\'" type="button" translate="dashboard.confirmation" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"-->\n' +
    '      <!--data-ng-click = "accounts.downloadTransactionReport(transaction);">-->\n' +
    '      <!--</button>-->\n' +
    '      <!--</td>-->\n' +
    '    </tr>\n' +
    '    <!-- Transaction confirmation\n' +
    '    <tr>\n' +
    '      <td>\n' +
    '        <button type="button" translate="dashboard.complaint" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase" data-ng-click="accounts.navigateToReclamationForm(transaction);">\n' +
    '        </button>\n' +
    '      </td>\n' +
    '      <td>\n' +
    '        <button type="button" translate="dashboard.confirmation" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase" data-ng-click="accounts.downloadTransactionReport(transaction);">\n' +
    '        </button>\n' +
    '      </td>\n' +
    '</tr> -->\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/connected-cards-block-modal.tpl.html',
    '<div class="modal-header statement-confirm-header p-10">\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-body text-center">\n' +
    '  <h3 translate="accounts.title">Information</h3>\n' +
    '    <p ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '      <span ng-switch-default translate="accounts.message"></span>\n' +
    '      <span ng-switch-when="sl" translate="accounts.message_SLO"></span>\n' +
    '      <span ng-switch-when="bh" translate="accounts.message_BH"></span>\n' +
    '    </p>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12">\n' +
    '      <button class="btn btn-default" ng-click="$close()"><span\n' +
    '        translate="accounts.close"></span></button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/close-e-book.tpl.html',
    '<section id="main">\n' +
    '  <div class="container">\n' +
    '    <div class="domp-header-wrapper p-r-20 p-l-10">\n' +
    '      <div class="row domp-header-row">\n' +
    '        <div class="domp-header-left col-sm-12 col-md-12 col-lg-12 col-xs-12">\n' +
    '          <h2 class="f-28" translate="closeEBookPageTranslation.title" style="margin-left: -22px;">Request for closing</h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="receiver-section" style="padding: 15px" ng-if="ebookAccount.eSavingBookCloseList.length === 0">\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '          <p style="color:#062A42;font-weight:300;font-size:21px;margin-left: -12px;">E Book Savings list is empty!</p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="e-receiver-section" ng-if="ebookAccount.eSavingBookCloseList.length >0">\n' +
    '      <div class="row e-table-header p-t-5 p-b-5">\n' +
    '        <div class="col-md-3 e-form-label-review t-a-c" translate="closeEBookPageTranslation.accountName"></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-3 e-form-label-review t-a-c" translate="closeEBookPageTranslation.account"></div>\n' +
    '        <div class="col-md-2"></div>\n' +
    '        <div class="col-md-2 e-form-label-review t-a-c" translate="closeEBookPageTranslation.transferAccount"></div>\n' +
    '      </div>\n' +
    '      <div class="row e-table-field">\n' +
    '        <div class="col-md-3 domp-form-label-resume" ng-if="ebookAccount.ebookName"><p class="t-a-c m-b-10">{{ebookAccount.ebookName}}</p></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-3 domp-form-label-resume" ng-if="ebookAccount.ebookNumber"><p class="t-a-c m-b-10">{{ebookAccount.ebookNumber}}</p></div>\n' +
    '        <div class="col-md-2"></div>\n' +
    '        <div class="col-md-2 domp-form-label-resume" ng-if="ebookAccount.transferToAccount"><p class="t-a-c m-b-10">{{ebookAccount.transferToAccount}}</p></div>\n' +
    '      </div>\n' +
    '      <div class="row e-table-header">\n' +
    '        <div class="col-md-2 e-form-label-review t-a-r" translate="closeEBookPageTranslation.balance"></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-2 e-form-label-review t-a-r" translate="closeEBookPageTranslation.transferAmount"></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-2 e-form-label-review t-a-c" translate="closeEBookPageTranslation.recognisedInterestRate"></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-2 e-form-label-review t-a-c p-r-0" translate="closeEBookPageTranslation.recognisedInterestAmount"></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row e-table-field" ng-repeat="eSavingBook in ebookAccount.eSavingBookCloseList">\n' +
    '        <div class="col-md-2 domp-form-label-resume"><p class="pull-right m-b-10">{{eSavingBook.balance | number:2}} {{eSavingBook.currencySymbol}}</p></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-2 domp-form-label-resume"><p class="pull-right m-b-10">{{eSavingBook.transferAmount | number:2}} {{eSavingBook.currencySymbol}}</p></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-2 domp-form-label-resume"><p class="t-a-c m-b-10">{{eSavingBook.recognisedInterestRate}}</p></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-2 domp-form-label-resume"><p class="pull-right m-b-10">{{eSavingBook.recognisedInterestAmount | number:2}} {{eSavingBook.currencySymbol}}</p></div>\n' +
    '        <div class="col-md-1"></div>\n' +
    '        <div class="col-md-12"><div class="col-md-12 e-table-border"></div></div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12" >\n' +
    '        <button type="input" class="btn btn-primary app-btn-blue m-t-5" ng-click="ebookAccount.cancel()" style="width: 160px;">\n' +
    '          <span translate="closeEBookPageTranslation.cancelButton"></span>\n' +
    '        </button>\n' +
    '        <button type="input" class="btn btn-default app-btn-blue m-t-5 pull-right" ng-click="ebookAccount.confirm()" style="width: 160px;">\n' +
    '          <span translate="closeEBookPageTranslation.confirmButton"></span>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/change-withdrawal-limit.tpl.html',
    '<section id="main">\n' +
    '    <div class="container-fluid">\n' +
    '        <!-- START Title -->\n' +
    '        <div class="row">\n' +
    '            <div class="col-md-12" style="z-index:1;">\n' +
    '                <div class="tmplt-list-title col-md-12 p-r-0 p-l-0 m-b-15">\n' +
    '                    <h2 class="title-style" translate="changeWithdrawal.header">Change overdraft limit</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <!-- END Title -->\n' +
    '\n' +
    '        <!-- START Note -->\n' +
    '        <div ng-if="changeWithdrawal.step == 1" class="row">\n' +
    '            <div class="col-md-12">\n' +
    '                <div class="alert alert-info " style="background: white; color: black; border: 1px solid lightgray">\n' +
    '                    <span translate="changeWithdrawal.infoNote1"></span>\n' +
    '                    <a href="https://www.addiko.si/ceniki" target="blank" class="underline">{{ \'changeWithdrawal.infoNote3\' | translate}}</a></p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <!-- END Note -->\n' +
    '\n' +
    '        <div ng-if="changeWithdrawal.step == 1" class="p-b-30">\n' +
    '            <ng-form name="changeWithdrawal.changeWithdrawalForm">\n' +
    '                <div class="cash-withdrawing-section-frame">\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-md-6">\n' +
    '\n' +
    '                            <label class="domp-form-label" translate="changeWithdrawal.fromAccount">Form account</label>\n' +
    '                            <!-- START Dropdown account -->\n' +
    '                            <div class="accounts-dropdown">\n' +
    '                                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="changeWithdrawal.showAccountToDropdown = !changeWithdrawal.showAccountToDropdown" ng-style="changeWithdrawal.selectedAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + changeWithdrawal.selectedAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                                    <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                      {{changeWithdrawal.selectedAccount.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                  <i class="zmdi"\n' +
    '                     ng-class="{\'zmdi-star favorite-account\': account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                </span>\n' +
    '                  </h4>\n' +
    '                                    <p class="m-b-0 m-t-0 iban-style">{{changeWithdrawal.selectedAccount.iban}}</p>\n' +
    '                                    <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                        {{changeWithdrawal.selectedAccount.availableBalance | number:2}} {{changeWithdrawal.selectedAccount.currencySymbol}}\n' +
    '                                    </p>\n' +
    '                                    <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <!-- END Dropdown account -->\n' +
    '\n' +
    '                        </div>\n' +
    '                        <div class="col-md-6">\n' +
    '\n' +
    '                            <div class="col-xs-12 p-b-95 hidden-xs">\n' +
    '\n' +
    '                            </div>\n' +
    '\n' +
    '                            <!-- START Amount -->\n' +
    '                            <div class="col-xs-12 p-0">\n' +
    '                                <div class="form-group">\n' +
    '                                    <label class="domp-form-label" translate="changeWithdrawal.amount">Amount</label>\n' +
    '                                    <div class="input-group">\n' +
    '                                        <!-- TODO:// check this mask!!!! -->\n' +
    '                                        <input id="amount" name="amount" type="text" class="form-control input-field t-a-r" amount-input-mask placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}" ng-model="changeWithdrawal.tempObj.amount" ng-class="{\'domp-error\': changeWithdrawal.changeWithdrawalForm.amount.$invalid && changeWithdrawal.formSubmitted}" maxlength="17" autocomplete="off" required>\n' +
    '                                        <span class="input-group-btn">\n' +
    '                <button type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero"\n' +
    '                        style="border:1px solid #062a42;">\n' +
    '                  {{changeWithdrawal.currencySymbol}}\n' +
    '                </button>\n' +
    '              </span>\n' +
    '                                    </div>\n' +
    '                                    <label class="c-red" ng-show="changeWithdrawal.changeWithdrawalForm.amount.$error.required && changeWithdrawal.formSubmitted" translate="changeWithdrawal.amountRequired">\n' +
    '                                    </label>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <!-- END Amount-->\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '\n' +
    '                    <div class="row p-t-30">\n' +
    '\n' +
    '                        <div class="col-md-6">\n' +
    '                            <div class="form-group">\n' +
    '                                <label class="domp-form-label" translate="changeWithdrawal.time">\n' +
    '                                    Time...\n' +
    '                                </label>\n' +
    '                                <select name="branch" class="form-control input-field p-l-15 p-r-10"\n' +
    '                                        ng-options="option.description for option in changeWithdrawal.timeLimits"\n' +
    '                                        ng-model="changeWithdrawal.tempObj.timeLimit" required>\n' +
    '                                </select>\n' +
    '\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="col-md-6">\n' +
    '                            <div class="form-group">\n' +
    '                                <label class="domp-form-label" translate="changeWithdrawal.spremembo">Spremembo</label>\n' +
    '                                <select name="branch" class="form-control input-field p-l-15 p-r-10"\n' +
    '                                        ng-options="option.description for option in changeWithdrawal.typeOptions "\n' +
    '                                        ng-model="changeWithdrawal.tempObj.typeOption" required>\n' +
    '                                </select>\n' +
    '\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '\n' +
    '                    <div class="row p-b-20 p-t-20">\n' +
    '                        <div class="col-md-12">\n' +
    '                            <button class="btn btn-primary app-btn-blue pull-right domp-review-and-submit-btn pull-left" ng-click="changeWithdrawal.goBackToAccount()">\n' +
    '                                <span translate="payments.cancel">Cancel</span>\n' +
    '                            </button>\n' +
    '                            <button class="btn btn-default  pull-right" ng-click="changeWithdrawal.validateCashWithdrawing();" ng-disabled="changeWithdrawal.nextButtonPressed">\n' +
    '                                <span translate="domesticPayment.confirmBtnSlo">Confirm</span>\n' +
    '                            </button>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </ng-form>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="changeWithdrawal.step == 2">\n' +
    '          <div class="domp-to-section m-10">\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-12 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label-review" translate="changeWithdrawal.fromAccount"></label>\n' +
    '                  <label class="d-block domp-form-label-resume">{{changeWithdrawal.insertedOrderObject.account}}</label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12 col-sm-6">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label-review" translate="changeWithdrawal.amount">Amount</label>\n' +
    '                  <label class="d-block domp-form-label-resume">\n' +
    '                    {{changeWithdrawal.insertedOrderObject.amount | number:2 }}\n' +
    '                    {{changeWithdrawal.selectedAccount.currencySymbol}}\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-xs-12 col-sm-6">\n' +
    '                <label class="domp-form-label-review" translate="changeWithdrawal.time"></label>\n' +
    '                <label class="d-block domp-form-label-resume">{{changeWithdrawal.tempObj.timeLimit.description}}</label>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12 col-sm-6">\n' +
    '                <label class="domp-form-label-review" translate="changeWithdrawal.spremembo"></label>\n' +
    '                <label class="d-block domp-form-label-resume">{{changeWithdrawal.tempObj.typeOption.description}}</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-xs-12">\n' +
    '            <button class="btn btn-primary " translate="domesticPayment.back"\n' +
    '                    data-ng-click="changeWithdrawal.editCashWithdrawing();">\n' +
    '            </button>\n' +
    '            <button class="btn btn-default pull-right" data-ng-click="changeWithdrawal.confirmCashWithdrawing()" ng-disabled="changeWithdrawal.confirmButtonPressed">\n' +
    '              <span translate="domesticPayment.confirmBtn"></span>\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/change-atm-withdrawal-limit.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12" style="z-index:1;">\n' +
    '        <div class="tmplt-list-title col-md-12 p-r-0 p-l-0 m-b-15">\n' +
    '          <h2 class="title-style" translate="changeATMWithdrawal.header">Change ATM withdrawal limit</h2>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Title -->\n' +
    '\n' +
    '    <!-- START Note -->\n' +
    '    <div ng-if="changeATM.step == 1" class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="alert alert-info " style="background: white; color: black; border: 1px solid lightgray">\n' +
    '          <p translate="changeATMWithdrawal.infoNote1"></p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Note -->\n' +
    '\n' +
    '    <div ng-if="changeATM.step == 1" class="p-b-30">\n' +
    '      <ng-form name="changeATM.changeATMWithdrawalForm">\n' +
    '        <div class="cash-withdrawing-section-frame">\n' +
    '          <div class="row">\n' +
    '            <div class="col-md-6">\n' +
    '\n' +
    '              <label class="domp-form-label" translate="changeWithdrawal.fromAccount">Form account</label>\n' +
    '              <!-- START Dropdown account -->\n' +
    '              <div class="accounts-dropdown">\n' +
    '                <div class="debit-account-widget dashboard-widget-item domp-acc-widget" data-ng-click="changeWithdrawal.showAccountToDropdown = !changeWithdrawal.showAccountToDropdown" ng-style="changeWithdrawal.selectedAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + changeWithdrawal.selectedAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                    <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '                      {{changeATM.selectedAccount.friendlyName}}</b>\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                  <i class="zmdi"\n' +
    '                     ng-class="{\'zmdi-star favorite-account\': changeATM.selectedAccount.isFavorite,\'zmdi-star-outline\':!changeATM.selectedAccount.isFavorite}"></i>\n' +
    '                </span>\n' +
    '                  </h4>\n' +
    '                  <p class="m-b-0 m-t-0 iban-style">{{changeATM.selectedAccount.iban}}</p>\n' +
    '                  <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                    {{changeATM.selectedAccount.availableBalance | number:2}} {{changeATM.selectedAccount.currencySymbol}}\n' +
    '                  </p>\n' +
    '                  <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Dropdown account -->\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="col-md-6">\n' +
    '\n' +
    '              <div class="col-xs-12 p-b-95 hidden-xs">\n' +
    '\n' +
    '              </div>\n' +
    '\n' +
    '              <!-- START Amount -->\n' +
    '              <div class="col-xs-12 p-0">\n' +
    '                <div class="form-group">\n' +
    '                  <label class="domp-form-label" translate="changeATMWithdrawal.desiredAmount">Desired amount (in EUR)</label>\n' +
    '                  <select class="form-control input-field p-l-15 p-r-10"\n' +
    '                          ng-options="amount.description for amount in changeATM.desiredAmounts"\n' +
    '                  data-ng-model="changeATM.selectedDesiredAmount">\n' +
    '                  </select>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <!-- END Amount-->\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div class="row p-t-30">\n' +
    '\n' +
    '            <div class="col-md-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="changeATMWithdrawal.for">For</label>\n' +
    '                <select ng-change="changeATM.selectForOption();" class="form-control input-field p-l-15 p-r-10" ng-options="option.description for option in changeATM.forOptions" ng-model="changeATM.type">\n' +
    '                </select>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-md-6">\n' +
    '              <div class="form-group">\n' +
    '                <label class="domp-form-label" translate="changeATMWithdrawal.nameSurname">Name and surname</label>\n' +
    '                <input type="text"\n' +
    '                       name="nameSurname"\n' +
    '                       id="nameSurname"\n' +
    '                       class="form-control input-field p-l-15 p-r-10"\n' +
    '                       data-ng-model="changeATM.user"\n' +
    '\n' +
    '                       maxlength="50"\n' +
    '                       required\n' +
    '                       ng-disabled="changeATM.type.id == \'uporabnik\'">\n' +
    '                <div class="c-red"\n' +
    '                     ng-show="changeATM.changeATMWithdrawalForm.nameSurname.$error.required && changeATM.formSubmitted"\n' +
    '                     translate="changeATMWithdrawal.nameSurnameRequired"></div>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div class="row p-b-20 p-t-20">\n' +
    '            <div class="col-md-12">\n' +
    '              <button class="btn btn-primary app-btn-blue pull-right domp-review-and-submit-btn pull-left" ng-click="changeATM.goBackToAccount()">\n' +
    '                <span translate="changeWithdrawal.cancelBtnLabel">Cancel</span>\n' +
    '              </button>\n' +
    '              <button class="btn btn-default  pull-right" ng-click="changeATM.validate();" ng-disabled="changeATM.nextButtonPressed">\n' +
    '                <span translate="domesticPayment.confirmBtnSlo">Confirm</span>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </ng-form>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="changeATM.step == 2">\n' +
    '      <div class="domp-to-section m-10">\n' +
    '        <div class="row p-b-20">\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label-review" translate="changeWithdrawal.fromAccount"></label>\n' +
    '              <label class="d-block domp-form-label-resume">{{changeATM.selectedAccount.iban}}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <div class="form-group">\n' +
    '              <label class="domp-form-label-review" translate="changeATMWithdrawal.desiredAmount"></label>\n' +
    '              <label class="d-block domp-form-label-resume">{{changeATM.selectedDesiredAmount.description}}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row p-b-20">\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review" translate="changeATMWithdrawal.for"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{changeATM.type.description}}</label>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label-review"  translate="changeATMWithdrawal.nameSurname"></label>\n' +
    '            <label class="d-block domp-form-label-resume">{{changeATM.user}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-12">\n' +
    '        <button class="btn btn-primary " translate="domesticPayment.back"\n' +
    '                data-ng-click="changeATM.edit();">\n' +
    '        </button>\n' +
    '        <button class="btn btn-default pull-right" data-ng-click="changeATM.submit()" ng-disabled="changeATM.submitButtonPressed">\n' +
    '          <span translate="domesticPayment.confirmBtn"></span>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/cash-withdrawal.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <!-- START Title -->\n' +
    '    <div style="padding: 15px">\n' +
    '      <div class="row">\n' +
    '        <div class="domp-header-wrapper col-sm-12 p-o">\n' +
    '          <div class="domp-header-row">\n' +
    '            <h2 translate="cashWithdrawalTranslate.title">Announcement for cash withdrawing</h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- END Title-->\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div ng-if="cashWithdrawal.countryCode != \'sl\'" class="alert alert-info"\n' +
    '             style="background: white; color: black; border: 1px solid lightgray" role="alert">\n' +
    '\n' +
    '          <p translate="cashWithdrawalTranslate.infoNote1"></p>\n' +
    '          <p translate="cashWithdrawalTranslate.infoNote2"></p>\n' +
    '        </div>\n' +
    '        <div ng-if="cashWithdrawal.countryCode == \'sl\'" class="alert alert-info"\n' +
    '             style="background: white; color: black; border: 1px solid lightgray" role="alert">\n' +
    '          <p translate="cashWithdrawalTranslate.infoNote1sl"></p>\n' +
    '          <p translate="cashWithdrawalTranslate.infoNote2sl"></p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="p-b-30">\n' +
    '      <ui-view/>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/cash-withdrawal-resume.tpl.html',
    '<div class="row">\n' +
    '  <div class="col-md-12">\n' +
    '    <div class="form-group">\n' +
    '      <h4>{{cashWithdrawal.updateResponse.orderType.description}}</h4>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="cash-withdrawing-section-frame">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-6">\n' +
    '      <label class="domp-form-label-review" translate="cashWithdrawalTranslate.fromAccount">From account</label>\n' +
    '      <label class="domp-form-label-resume">\n' +
    '        <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation" class="domp-form-label-resume">\n' +
    '          <span ng-switch-default>{{cashWithdrawal.updateResponse.iban}}</span>\n' +
    '          <span ng-switch-when="sl">\n' +
    '            {{cashWithdrawal.formatIban(cashWithdrawal.updateResponse.iban)}}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </label>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '      <!-- START Amount -->\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="cashWithdrawalTranslate.amount">Amount</label>\n' +
    '        <div class="domp-form-label-resume">\n' +
    '          <span class="p-r-10">{{cashWithdrawal.updateResponse.amount | currency:""}} </span>{{cashWithdrawal.updateResponse.currencySymbol}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <!-- START Amount and Date -->\n' +
    '    <div class="col-md-offset-6 col-md-3">\n' +
    '      <!-- END Amount-->\n' +
    '      <!-- START Date-->\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="cashWithdrawalTranslate.dateOfPayout">Date of payout</label>\n' +
    '        <div class="domp-form-label-resume">\n' +
    '          {{cashWithdrawal.updateResponse.withdrawalDate | date: \'shortDate\'}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Date-->\n' +
    '    </div>\n' +
    '    <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="col-md-3">\n' +
    '      <!-- END Amount-->\n' +
    '      <!-- START Date-->\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="cashWithdrawalTranslate.timeOfPayout">Time of payout</label>\n' +
    '        <div class="domp-form-label-resume">\n' +
    '          {{cashWithdrawal.updateResponse.withdrawalTime}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- END Date-->\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="cash-withdrawing-section-frame">\n' +
    '  <div class="row">\n' +
    '    <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" class="col-md-6">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="cashWithdrawalTranslate.phoneNumber">Phone number</label>\n' +
    '        <div class="domp-form-label-resume">\n' +
    '          {{cashWithdrawal.updateResponse.phoneNumber}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '      <div class="form-group">\n' +
    '        <label class="domp-form-label-review" translate="cashWithdrawalTranslate.placeOfCashTakeover">\n' +
    '          Place of cash takeover\n' +
    '        </label>\n' +
    '        <div class="domp-form-label-resume">\n' +
    '          {{cashWithdrawal.updateResponse.branchName}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12">\n' +
    '      <div class="form-group" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '        <label class="domp-form-label-review" translate="cashWithdrawalTranslate.note">Note</label>\n' +
    '        <div class="domp-form-label-resume word-break" ng-switch-default>\n' +
    '          {{cashWithdrawal.updateResponse.note}}\n' +
    '        </div>\n' +
    '        <p class="domp-form-label-resume word-break" ng-switch-when="sl">\n' +
    '          {{cashWithdrawal.updateResponse.withdrawalNotes}}\n' +
    '        </p>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="row">\n' +
    '  <div class="col-md-12">\n' +
    '    <div class="form-group">\n' +
    '      <!--<button class="btn btn-primary app-btn-blue domp-review-and-submit-btn"-->\n' +
    '      <!--ng-click="cashWithdrawal.cancelCashWithdrawing()">-->\n' +
    '      <!--<span translate="cashWithdrawalTranslate.cancelBtnLabel">Cancel</span>-->\n' +
    '      <!--</button>-->\n' +
    '      <button ng-if="cashWithdrawal.countryCode != \'sl\'" class="btn btn-primary-warning"\n' +
    '              ng-click="cashWithdrawal.deleteCashWithdrawing()"\n' +
    '              ng-disabled="cashWithdrawal.deleteCashWithdrawingBtnDisabled">Delete\n' +
    '      </button>\n' +
    '      <button ng-if="cashWithdrawal.countryCode != \'sl\'" class="btn btn-primary app-btn-blue domp-review-and-submit-btn"\n' +
    '              ng-click="cashWithdrawal.editCashWithdrawing()">Edit\n' +
    '      </button>\n' +
    '      <button ng-if="cashWithdrawal.countryCode === \'sl\'" class="btn btn-primary app-btn-blue domp-review-and-submit-btn"\n' +
    '              ng-click="cashWithdrawal.editCashWithdrawing()" translate="domesticPayment.back">Edit\n' +
    '      </button>\n' +
    '      <button class="btn btn-default pull-right"\n' +
    '              ng-click="cashWithdrawal.sendCashWithdrawing()"\n' +
    '              ng-disabled="cashWithdrawal.signCashWithdrawingBtnDisabled" translate="domesticPayment.confirmBtn">\n' +
    '        Send\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/cash-withdrawal-form.tpl.html',
    '<div class="p-b-30">\n' +
    '<ng-form name="cashWithdrawal.cashWithdrawalForm">\n' +
    '  <div class="cash-withdrawing-section-frame">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6">\n' +
    '\n' +
    '        <label class="domp-form-label" translate="cashWithdrawalTranslate.fromAccount">Form account</label>\n' +
    '        <div class="accounts-dropdown">\n' +
    '          <div class="debit-account-widget dashboard-widget-item domp-acc-widget"\n' +
    '               data-ng-click="cashWithdrawal.showAccountToDropdown = !cashWithdrawal.showAccountToDropdown" ng-style="cashWithdrawal.selectedAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + cashWithdrawal.selectedAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '            <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '                <b class="col-xs-10 p-0 m-t-10  no-wrap-text">\n' +
    '              {{cashWithdrawal.selectedAccount.friendlyName}}</b>\n' +
    '                <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container">\n' +
    '                  <i class="zmdi"\n' +
    '                     ng-class="{\'zmdi-star favorite-account\': account.isFavorite,\'zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                </span>\n' +
    '            </h4>\n' +
    '            <p class="m-b-0 m-t-0 iban-style">{{cashWithdrawal.selectedAccount.iban}}</p>\n' +
    '            <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '              {{cashWithdrawal.selectedAccount.availableBalance | number:2}}\n' +
    '              {{cashWithdrawal.selectedAccount.currencySymbol}}\n' +
    '            </p>\n' +
    '            <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '              <span class="caret-icon">\n' +
    '                  <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>\n' +
    '              </span>\n' +
    '          </div>\n' +
    '          <div class="from-accounts-list m-l-15" ng-show="cashWithdrawal.showAccountToDropdown" scrollable>\n' +
    '            <div class="accounts-list-item p-0"\n' +
    '                 data-ng-repeat="account in cashWithdrawal.accountList"\n' +
    '                 data-ng-click="cashWithdrawal.selectAccount(account); cashWithdrawal.showAccountToDropdown = !cashWithdrawal.showAccountToDropdown">\n' +
    '                <div class="debit-account-widget inverse dashboard-widget-item domp-acc-widget" ng-style="account.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + account.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                       <h4 class="no-wrap-text bold-font m-b-0">\n' +
    '            <b class="col-xs-10 p-0 m-t-10  no-wrap-text">{{account.friendlyName}}</b>\n' +
    '                             <span class="col-xs-2 p-0 t-a-r c-white favorite-star-container"><i class="zmdi" ng-class="{\'zmdi-star favorite-account\':item.isFavorite,\'zmdi-star-outline\':!item.isFavorite}"></i></span>\n' +
    '                                        </h4>\n' +
    '              <p class="m-b-0 m-t-0 iban-style">{{account.iban}}</p>\n' +
    '              <p class="m-b-0 bold-font f-size-26 domp-available-balance no-wrap-text">\n' +
    '                                            {{account.availableBalance | number:2}} {{account.currencySymbol}}\n' +
    '                                        </p>\n' +
    '              <span class="d-block m-t-5 m-b-10" translate="currencyConversion.availableBalance"></span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '        </div>\n' +
    '      <!-- START Amount and Date -->\n' +
    '      <div class="col-md-6">\n' +
    '        <!-- START Amount -->\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" translate="cashWithdrawalTranslate.amount">Amount</label>\n' +
    '          <div class="input-group" ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '            <!-- TODO:// check this mask!!!! -->\n' +
    '            <input id="amount" name="amount" type="text" class="form-control input-field t-a-r"\n' +
    '                   ng-switch-default\n' +
    '                   amount-input-mask\n' +
    '                   placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                   ng-model="cashWithdrawal.model.amount"\n' +
    '                   ng-class="{\'domp-error\': cashWithdrawal.cashWithdrawalForm.amount.$invalid && cashWithdrawal.formSubmitted}"\n' +
    '                   maxlength="{{cashWithdrawal.amountInputSettings.maxLength}}"\n' +
    '                   min="{{cashWithdrawal.minAmount}}"\n' +
    '                   autocomplete="off"\n' +
    '                   required>\n' +
    '            <input id="amount" name="amount" type="text" class="form-control input-field t-a-r"\n' +
    '                   ng-switch-when="sl"\n' +
    '                   amount-input-mask\n' +
    '                   placeholder="{{\'domesticPayment.amountPlaceholder\'| translate}}"\n' +
    '                   ng-model="cashWithdrawal.model.amount"\n' +
    '                   ng-class="{\'domp-error\': cashWithdrawal.cashWithdrawalForm.amount.$invalid && cashWithdrawal.formSubmitted}"\n' +
    '                   maxlength="{{cashWithdrawal.amountInputSettings.maxLength}}"\n' +
    '                   max-amount="{{cashWithdrawal.amountInputSettings.maxAmount}}"\n' +
    '                   min="{{cashWithdrawal.minAmount}}"\n' +
    '                   autocomplete="off"\n' +
    '                   required>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button"\n' +
    '                        class="btn btn-default input-group-app-btn domp-btn-height disabled z-zero" style="border:1px solid #062a42;">\n' +
    '                  {{cashWithdrawal.model.currencySymbol}}\n' +
    '                </button>\n' +
    '              </span>\n' +
    '          </div>\n' +
    '          <label class="c-red"\n' +
    '                 ng-show="cashWithdrawal.cashWithdrawalForm.amount.$error.required && cashWithdrawal.formSubmitted"\n' +
    '                 translate="cashWithdrawalTranslate.amountRequired">\n' +
    '          </label>\n' +
    '          <span class="c-red" ng-show="cashWithdrawal.cashWithdrawalForm.amount.$error.maxAmount" >\n' +
    '          <span translate="internalTransfer.amountLengthError"></span> {{cashWithdrawal.model.currencySymbol}}</span>\n' +
    '\n' +
    '          <label class="c-red"\n' +
    '                 ng-show="!cashWithdrawal.cashWithdrawalForm.amount.$error.required && cashWithdrawal.cashWithdrawalForm.amount.$error.min && cashWithdrawal.formSubmitted">\n' +
    '            {{"cashWithdrawalTranslate.amountMinAmountError" | translate}} {{cashWithdrawal.minAmount | currency:""}} {{cashWithdrawal.model.currencySymbol}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <!-- END Amount-->\n' +
    '        <!-- START Date-->\n' +
    '        <div class="row">\n' +
    '          <div class="col-xs-12" ng-class="{\'col-sm-6\': cashWithdrawal.countryCode == \'sl\'}">\n' +
    '            <label class="domp-form-label" translate="cashWithdrawalTranslate.dateOfPayout">Date of payout</label>\n' +
    '            <div class="input-group" ng-class="{\'ui-datepicker-today-hide\': APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'}">\n' +
    '              <input type="text" class="form-control input-field" name="date"\n' +
    '                     ng-class="{\'domp-error\': cashWithdrawal.cashWithdrawalForm.date.$invalid && cashWithdrawal.formSubmitted}"\n' +
    '                     uib-datepicker-popup="shortDate" show-weeks="false"\n' +
    '                     ng-model="cashWithdrawal.model.withdrawalDate"\n' +
    '                     show-weeks="false" is-open="datePickerOpen"\n' +
    '                     datepicker-options="cashWithdrawal.datePickerOptions"\n' +
    '                     date-disabled="cashWithdrawal.dateDisabled({date: date, mode: mode})"\n' +
    '                     required\n' +
    '                     readonly>\n' +
    '              <span class="input-group-btn">\n' +
    '                  <button data-ng-click="datePickerOpen = !datePickerOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero" style="border:1px solid #062a42;">\n' +
    '                    <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div ng-if="cashWithdrawal.countryCode == \'sl\'" class="col-xs-12 col-sm-6">\n' +
    '            <label class="domp-form-label" translate="cashWithdrawalTranslate.timeOfPayout">Time of payout</label>\n' +
    '            <select name="withdrawalTime"\n' +
    '                    class="form-control input-field p-l-15 p-r-10"\n' +
    '                    ng-options="option.id as option.value | translate for option in cashWithdrawal.withdrawalTimes"\n' +
    '                    ng-model="cashWithdrawal.withdrawalTimeId"\n' +
    '                    ng-change="cashWithdrawal.onTimeOfPayoutChange()"\n' +
    '                    required>\n' +
    '            </select>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <!-- END Date-->\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="cash-withdrawing-section-frame">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-6" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" translate="cashWithdrawalTranslate.phoneNumber">Phone number</label>\n' +
    '          <input name="branch"\n' +
    '                 class="form-control input-field"\n' +
    '                 ng-pattern-restrict="{{cashWithdrawal.regexPatterns.phoneValidation}}"\n' +
    '                 ng-model="cashWithdrawal.model.phoneNumber">\n' +
    '          </input>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-md-6">\n' +
    '        <div class="form-group">\n' +
    '          <label class="domp-form-label" translate="cashWithdrawalTranslate.placeOfCashTakeover">\n' +
    '            Place of cash takeover\n' +
    '          </label>\n' +
    '          <select name="branch"\n' +
    '                  class="form-control input-field p-l-15 p-r-10"\n' +
    '                  ng-options="branch.id as branch.name for branch in cashWithdrawal.branchList"\n' +
    '                  ng-model="cashWithdrawal.model.branchId"\n' +
    '                  required>\n' +
    '          </select>\n' +
    '          <label class="c-red"\n' +
    '                 ng-show="cashWithdrawal.cashWithdrawalForm.branch.$error.required && cashWithdrawal.formSubmitted"\n' +
    '                 translate="cashWithdrawalTranslate.placeOfCashTakeoverRequiredMsg">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="form-group">\n' +
    '          <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '\n' +
    '            <div ng-switch-when="sl">\n' +
    '              <label class="domp-form-label"\n' +
    '                     translate="cashWithdrawalTranslate.note_SLO"></label>\n' +
    '              <textarea name="note" class="form-control cash-withdrawing-note"\n' +
    '                        ng-pattern-restrict="{{cashWithdrawal.regexPatterns.allowedCharsDPS}}"\n' +
    '                        maxlength="200"\n' +
    '                        ng-model="cashWithdrawal.model.withdrawalNotes"></textarea>\n' +
    '            </div>\n' +
    '              <div ng-switch-default>\n' +
    '              <label class="domp-form-label"\n' +
    '                     translate="cashWithdrawalTranslate.note" >Note</label>\n' +
    '\n' +
    '\n' +
    '\n' +
    '            <textarea name="note" class="form-control cash-withdrawing-note"\n' +
    '                      ng-pattern-restrict="{{cashWithdrawal.regexPatterns.allowedCharsDPS}}"\n' +
    '                      maxlength="{{cashWithdrawal.maxlength}}"\n' +
    '                      ng-model="cashWithdrawal.model.note"></textarea>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  <div class="row p-b-30">\n' +
    '    <div class="col-md-12">\n' +
    '      <button class="btn btn-primary app-btn-blue pull-right domp-review-and-submit-btn pull-left"\n' +
    '              ng-click="cashWithdrawal.cancelCashWithdrawing()">\n' +
    '        <span translate="cashWithdrawalTranslate.cancelBtnLabel">Cancel</span>\n' +
    '      </button>\n' +
    '      <button class="btn btn-default  pull-right "\n' +
    '              ng-click="cashWithdrawal.confirmCashWithdrawing()"\n' +
    '              ng-disabled="cashWithdrawal.confirmCashWithdrawalBtnDisabled">\n' +
    '        <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'" translate="cashWithdrawalTranslate.confirmBtnLabel">Confirm</span>\n' +
    '        <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" translate="domesticPayment.confirmBtnSlo">Next</span>\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</ng-form>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/accountsSubmenu.tpl.html',
    '<div class="col-sm-12 col-md-12 col-xs-12 p-l-0 p-r-0 bg-white" style="min-height: 400px">\n' +
    '\n' +
    '  <div class="msg-tab-container cursor-pointer" ng-if="accounts.countryCode !== \'bh\'">\n' +
    '    <div class=" msg-tab"\n' +
    '         ng-class="{\'selected\':accounts.showSubmenuItemType==\'transactions\'}"\n' +
    '         ng-click=\'accounts.showSubmenu("transactions")\'>\n' +
    '      <a translate="accounts.accTransactions"></a>\n' +
    '    </div>\n' +
    '    <div class=" msg-tab cursor-pointer"\n' +
    '         ng-class="{\'selected\':accounts.showSubmenuItemType==\'statements\'}"\n' +
    '         ng-click=\'accounts.showSubmenu("statements")\'>\n' +
    '      <a translate="accounts.accPdfStatements"></a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!--Nothing smarter on my mind at the exact moment :D-->\n' +
    '  <div class="msg-tab-container cursor-pointer" ng-if="accounts.countryCode === \'bh\'">\n' +
    '    <div class=" msg-tab"\n' +
    '         ng-class="{\'selected\':accounts.showSubmenuItemType==\'transactions\',\n' +
    '         \'msg-tab-bh\':accounts.checkForAccountTypeId(accounts.selectedAccount.accountType.id) && accounts.selectedAccount.linkList.itemList.payInReservations}"\n' +
    '         ng-click=\'accounts.showSubmenu("transactions")\'>\n' +
    '      <a translate="accounts.accTransactions"></a>\n' +
    '    </div>\n' +
    '    <div class=" msg-tab cursor-pointer"\n' +
    '         ng-if="accounts.checkForAccountTypeId(accounts.selectedAccount.accountType.id);"\n' +
    '         ng-class="{\'selected\':accounts.showSubmenuItemType==\'statements\',\n' +
    '         \'msg-tab-bh\': accounts.checkForAccountTypeId(accounts.selectedAccount.accountType.id) && accounts.selectedAccount.linkList.itemList.payInReservations}"\n' +
    '         ng-click=\'accounts.showSubmenu("statements")\'>\n' +
    '      <a translate="accounts.accPdfStatements"></a>\n' +
    '    </div>\n' +
    '    <!-- Show reservations related to account just for BiH environment -->\n' +
    '    <div class=" msg-tab left-border-bh"\n' +
    '         ng-if="accounts.selectedAccount.linkList.itemList.payInReservations"\n' +
    '         ng-class="{\'selected\':accounts.showSubmenuItemType==\'reservations\',\n' +
    '           \'msg-tab-bh\': accounts.checkForAccountTypeId(accounts.selectedAccount.accountType.id) && accounts.selectedAccount.linkList.itemList.payInReservations}"\n' +
    '         ng-click=\'accounts.showSubmenu("reservations")\'>\n' +
    '      <a translate="accounts.accReservations"></a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '<div class="col-md-12" style="padding-top:20px;">\n' +
    '    <div class="col-sm-12 col-md-6 p-0" ng-hide="accounts.showSubmenuItemType==\'statements\' || accounts.showSubmenuItemType==\'reservations\'">\n' +
    '      <!--<transactions-filter ng-if="accounts.currenciesList.length" transactions="accounts.selectedAccount.transactions.result"-->\n' +
    '                           <!--transaction-currency-list="accounts.currenciesList"-->\n' +
    '                           <!--allow-custom-datepicker="true"-->\n' +
    '                           <!--data-statements="(accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\')"-->\n' +
    '                           <!--statement-dates="accounts.detailedFilter.statementDates"-->\n' +
    '                           <!--data-default-dates="accounts.defaultDates"-->\n' +
    '                           <!--transaction-filter-change="accounts.refreshTransactionsByFilter(filterParams)"-->\n' +
    '                           <!--currency="accounts.defaultCurrency">-->\n' +
    '      <!--</transactions-filter>-->\n' +
    '\n' +
    '      <div data-ng-include="\'accounts/accounts-transaction-filter.tpl.html\'"></div>\n' +
    '    </div>\n' +
    '    <div class="col-sm-12 col-md-6" ng-hide="accounts.showSubmenuItemType==\'statements\' || accounts.showSubmenuItemType==\'reservations\'">\n' +
    '      <div id="periodViewSelector" class="period-selector" ng-click=\'accounts.showSubmenu("transactions")\'>\n' +
    '        <div class="period-view-select-div left"><span translate="accounts.accPeriod"></span>:</div>\n' +
    '        <div class="period-view-select-div right period-margin">\n' +
    '          <div class="dropdown acc-period-select" ng-init="periodSelectorLabel=\'This week\'">\n' +
    '            <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"\n' +
    '                    aria-expanded="true">\n' +
    '              {{accounts.selectedPeriod.description | translate}}\n' +
    '              <span class="caret"></span>\n' +
    '            </button>\n' +
    '            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">\n' +
    '              <li data-ng-repeat="period in accounts.periodList">\n' +
    '                <a href ng-click="accounts.changeTransactionPeriod(period)">{{period.description | translate}}</a>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div class="col-xs-12">\n' +
    '  <div ng-if="accounts.showSubmenuItemType==\'transactions\'"\n' +
    '       data-ng-include="\'accounts/accounts-transactions.tpl.html\'"></div>\n' +
    '</div>\n' +
    '<div ng-if="accounts.showSubmenuItemType==\'statements\'" data-ng-include="\'accounts/accounts-statements.tpl.html\'"></div>\n' +
    '  <!-- reservations view just for BiH environment -->\n' +
    '  <div ng-if="accounts.showSubmenuItemType==\'reservations\'">\n' +
    '    <div class="t-a-c m-t-10 p-10 no-data-image" ng-show="accounts.selectedAccount.reservations.result.length == 0">\n' +
    '      <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '      <h3 class="no-data-label" translate="reservations.noData"></h3>\n' +
    '    </div>\n' +
    '    <div class="timeline-row col-sm-12 p-l-0 p-r-0" infinite-scroll=\'accounts.loadAccountReservations()\' infinite-scroll-disabled=\'accounts.busy\' infinite-scroll-distance=\'1\' ng-show="accounts.selectedAccount.reservations.result.length > 0">\n' +
    '      <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0 no-top-radius">\n' +
    '        <ul class="hypo-timeline statements-timeline">\n' +
    '          <li data-ng-repeat="reservation in accounts.selectedAccount.reservations.result" ng-class="{\'time-label\': reservation.isVirtual === true, \'tl-badge-icon\': reservation.isVirtual === undefined}">\n' +
    '            <span ng-if="reservation.isVirtual === true">{{reservation.valueDate | date: \'shortDate\'}}</span>\n' +
    '            <i ng-if="reservation.isVirtual == undefined" data-ng-class="{\'icon icon-priliv\': transaction.credit != null,\'icon icon-odliv\': transaction.credit == null}"></i>\n' +
    '            <div ng-if="reservation.isVirtual == undefined" class="hypo-timeline-item transaction-item" data-ng-click="reservation.selected = !reservation.selected;" ng-class="{\'opened\': reservation.selected}">\n' +
    '              <div class="hypo-timeline-body">\n' +
    '                <div class="col-xs-6 col-sm-8 p-l-0 p-r-0">\n' +
    '                  <h4 class="m-b-0 m-t-0 c-gray no-wrap-text"><b>{{::reservation.description}}</b></h4>\n' +
    '                  <p class="m-b-0 m-t-0 no-wrap-text">\n' +
    '                    <span>{{::reservation.transactionType}}</span>\n' +
    '                  </p>\n' +
    '                </div>\n' +
    '                <div style="font-weight:600; font-size:22px;" class="price-payment col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::reservation.amount | number:2}}</b></span></div>\n' +
    '              </div>\n' +
    '              <div ng-if="reservation.selected" class="m-l-0 transaction-details">\n' +
    '                <div data-ng-include="\'accounts/acc-reservation-details.tpl.html\'"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/accounts.tpl.html',
    '<section id="main" data-ng-controller="MaterialAdminCtrl as mactrl">\n' +
    '    <div class="container-fluid" ng-init="cddMenuSelected=1">\n' +
    '        <div>\n' +
    '            <!-- Account informations -->\n' +
    '            <div class="account-header-container" ng-if="accounts.selectedAccount">\n' +
    '\n' +
    '                <!-- Carousel navigation start -->\n' +
    '                <div class="row" data-ng-show="accounts.accountsForCarousel.length > 1">\n' +
    '                    <ol class="custom-carousel-indicators pull-right">\n' +
    '                        <li data-ng-repeat="account in accounts.accountsForCarousel" data-ng-class="{\'active\': accounts.currentIndex === account.index}" data-ng-click="accounts.chooseFromCarousel(account.accountId);"></li>\n' +
    '                    </ol>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="pull-right icon-container m-r-15" ng-if="accounts.isNextButtonVisible" data-ng-click="accounts.goToNextItem()">\n' +
    '                    <a class="account-navigation-icons">\n' +
    '                        <i class="zmdi zmdi-chevron-right zmdi-hc-4x"></i>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="pull-left icon-container m-l-15" ng-if="accounts.isPreviousButtonVisible" data-ng-click="accounts.goToPreviousItem()">\n' +
    '                    <a class="account-navigation-icons">\n' +
    '                        <i class="zmdi zmdi-chevron-left zmdi-hc-4x"></i>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '                <!-- Carousel navigation end -->\n' +
    '\n' +
    '                <div class="row account-carousel-row" ng-style="accounts.selectedAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + accounts.selectedAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <div class="col-xs-8 account-header-inner m-l-25" ng-switch on="accounts.selectedAccount.accountType.group">\n' +
    '                        <!-- Change name of account -->\n' +
    '                        <div class="row">\n' +
    '                            <div class="col-xs-12 no-padding">\n' +
    '                                <div ng-show="accounts.isEditable == true">\n' +
    '                                    <div class="col-sm-8 m-t-14 m-b-9">\n' +
    '                                        <input ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'"\n' +
    '                                               type="text" class="form-control"\n' +
    '                                               data-ng-model="accounts.newDescription"\n' +
    '                                               maxlength="50"\n' +
    '                                               ng-pattern-restrict="{{accounts.regexPatterns.standardInputFriendlyName}}">\n' +
    '                                        <input ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\'" type="text" class="form-control" data-ng-model="accounts.newDescription" maxlength="50">\n' +
    '                                    </div>\n' +
    '                                    <div class="col-sm-4 m-t-14 m-b-9">\n' +
    '                                        <i class="zmdi zmdi-check zmdi-hc-2x edit-check-btn" data-ng-click="accounts.editAccount();"></i>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <h2 class="account-name m-l-15" ng-show="accounts.selectedAccount.friendlyName && !accounts.isEditable">\n' +
    '                  <!--<span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">{{accounts.selectedAccount.accountNumber}} - </span> -->\n' +
    '                                  <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'">{{accounts.selectedAccount.friendlyName | limitTo: 28}}{{accounts.selectedAccount.friendlyName.length > 28 ? \'...\':\'\'}}</span>\n' +
    '                                  <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\'">{{accounts.selectedAccount.friendlyName}}</span>\n' +
    '\n' +
    '                  <a href="" class="p-l-30">\n' +
    '                    <span class="account-edit" data-ng-click="accounts.showEditAccount()"\n' +
    '                          translate="accounts.rename"></span>\n' +
    '                  </a>\n' +
    '\n' +
    '                  <a href="" data-ng-click="accounts.markAsFavorite()">\n' +
    '                    <i ng-if="!accounts.isFavoriteAccount" class="zmdi zmdi-star-outline "></i>\n' +
    '                    <i ng-if="accounts.isFavoriteAccount" class="zmdi zmdi-star is-favorite"></i>\n' +
    '                  </a>\n' +
    '                </h2>\n' +
    '\n' +
    '                  <h2 class="account-name m-l-15 f-20" ng-show="!accounts.selectedAccount.friendlyName && !accounts.isEditable">\n' +
    '                    <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'">\n' +
    '                      {{accounts.selectedAccount.accountType.description | limitTo: 28}}{{accounts.selectedAccount.accountType.description.length > 28 ? \'...\':\'\'}}\n' +
    '                    </span>\n' +
    '                    <span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\'">\n' +
    '                      {{accounts.selectedAccount.accountType.description}}\n' +
    '                    </span>\n' +
    '\n' +
    '                  <a href="" class="p-l-30">\n' +
    '                    <span class="account-edit" data-ng-click="accounts.showEditAccount()"\n' +
    '                          translate="accounts.rename"></span>\n' +
    '                  </a>\n' +
    '\n' +
    '                  <a href="" data-ng-click="accounts.markAsFavorite()">\n' +
    '                    <i ng-if="!accounts.isFavoriteAccount" class="zmdi zmdi-star-outline"></i>\n' +
    '                    <i ng-if="accounts.isFavoriteAccount" class="zmdi zmdi-star is-favorite"></i>\n' +
    '                  </a>\n' +
    '                </h2>\n' +
    '\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="col-xs-12 p-b-10" ng-show="accounts.isEditable">\n' +
    '\n' +
    '                                <span class="account-edit" translate="accounts.accResetName" data-ng-click="accounts.resetAccountName()"></span>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <!--<span ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="account-name-iban bold-font">-->\n' +
    '                          <!--{{accounts.selectedAccount.accountDescription}}-->\n' +
    '                        <!--</span>-->\n' +
    '                        <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                          <span class="account-name-iban" ng-switch-default ng-if="accounts.selectedAccount.iban" ng-bind="accounts.selectedAccount.iban"></span>\n' +
    '                          <span class="account-name-iban" ng-switch-when="sl" ng-if="accounts.selectedAccount.iban">\n' +
    '                            <span ng-if="accounts.selectedAccount.accountType.group != \'CardAccountTypes\'">{{accounts.selectedAccount.iban}}</span>\n' +
    '                            <span ng-if="accounts.selectedAccount.accountType.group === \'CardAccountTypes\'">{{accounts.selectedAccount.accountNumber}}</span>\n' +
    '                          </span>\n' +
    '                        </span>\n' +
    '                        <!-- <span ng-if="!accounts.selectedAccount.iban" ng-bind="accounts.selectedAccount.accountNumber"></span> -->\n' +
    '                        <span class="account-name-iban" ng-if="!accounts.selectedAccount.iban" ng-bind="accounts.selectedAccount.iban"></span>\n' +
    '                        <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                          <span ng-switch-default="">\n' +
    '                            <span class="account-name-iban" >{{accounts.selectedAccount.ownerName}}</span>\n' +
    '                          </span>\n' +
    '                          <span  ng-switch-when="sl">\n' +
    '                            <span class="account-name-iban" >{{accounts.selectedAccount.ownerName}}</span>\n' +
    '                            <!--<div class="account-name-iban" ng-show="accounts.selectedAccount.cardAccount.cardAccountType">{{accounts.selectedAccount.cardAccount.cardAccountType}}</div>-->\n' +
    '                            <!--<div class="account-name-iban" ng-show="accounts.selectedAccount.cardAccount.interestRateAmount"> <span translate="accounts.interestRate"></span>: {{accounts.selectedAccount.cardAccount.interestRateAmount}} %</div>-->\n' +
    '                            <!--<div class="account-name-iban" ng-show="accounts.selectedAccount.cardAccount.payDate"> <span translate="accounts.accDueDate"></span>: {{accounts.selectedAccount.cardAccount.payDate | date: \'dd.\'}}</div>-->\n' +
    '                          </span>\n' +
    '                        </span>\n' +
    '\n' +
    '                        <!--CURRENT-->\n' +
    '                        <div ng-switch-when="CurrentAccount">\n' +
    '                            <div data-ng-include="\'accounts/CurrentAccount-detail.tpl.html\'"></div>\n' +
    '                        </div>\n' +
    '                        <!--LOAN-->\n' +
    '                        <div ng-switch-when="LoanAccountType">\n' +
    '                            <div data-ng-include="\'accounts/LoanAccountType-detail.tpl.html\'"></div>\n' +
    '                        </div>\n' +
    '                        <!--CARD-->\n' +
    '                        <div ng-switch-when="CardAccountTypes">\n' +
    '                            <div data-ng-include="\'accounts/CardAccountTypes-detail.tpl.html\'"></div>\n' +
    '                        </div>\n' +
    '                        <!--SAVING ACCOUNT-->\n' +
    '                        <div ng-switch-when="SavingAccountTypes">\n' +
    '                            <div data-ng-include="\'accounts/SavingAccountTypes-detail.tpl.html\'"></div>\n' +
    '                        </div>\n' +
    '                        <!-- GIRO ACCOUNT-->\n' +
    '                        <div ng-switch-when="GiroAccount">\n' +
    '                            <div data-ng-include="\'accounts/GiroAccount-detail.tpl.html\'"></div>\n' +
    '                        </div>\n' +
    '                        <!--DEPOSIT-->\n' +
    '                        <div ng-switch-when="DepositAccountTypes">\n' +
    '                            <div data-ng-include="\'accounts/DepositAccountTypes-detail.tpl.html\'"></div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-xs-4">\n' +
    '                        <!-- TODO: Add image based on account type -->\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- Accounts & card details bottom part -->\n' +
    '                <div class="account-details-container clearfix">\n' +
    '                    <div class="account-open-more-details" ng-if="!accounts.isAccountDetailsOpen && accounts.countryCode != \'sr\'" data-ng-click="accounts.toggleAccountDetails()" translate="accounts.accAccountAndCardsMoreDetails">\n' +
    '                    </div>\n' +
    '                    <div class="account-open-more-details" ng-if="!accounts.isAccountDetailsOpen &&\n' +
    '                                                            accounts.countryCode == \'sr\' &&\n' +
    '                                                            accounts.selectedAccount.accountType.group !== \'LoanAccountType\' &&\n' +
    '                                                            accounts.selectedAccount.accountType.group !== \'DepositAccountTypes\' " data-ng-click="accounts.toggleAccountDetails()" translate="accounts.accAccountAndCardsMoreDetails1">\n' +
    '                    </div>\n' +
    '                    <div class="account-open-more-details" ng-if="!accounts.isAccountDetailsOpen &&\n' +
    '                                                            accounts.countryCode == \'sr\' &&\n' +
    '                                                            (accounts.selectedAccount.accountType.group === \'LoanAccountType\' ||\n' +
    '                                                            accounts.selectedAccount.accountType.group === \'DepositAccountTypes\') " data-ng-click="accounts.toggleAccountDetails()" translate="accounts.accAccountAndCardsMoreDetails">\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div ng-if="accounts.isAccountDetailsOpen">\n' +
    '\n' +
    '                        <!-- Connected debit cards-->\n' +
    '                        <div ng-if="accounts.selectedAccount.cardList"\n' +
    '                             ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' || (APP_GLOBAL_SETTINGS.userSettings.isViberUser == \'Y\' && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\')">\n' +
    '                            <div data-ng-include="\'accounts/connected-debit-card.tpl.html\'"></div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <!-- Authorized persons -->\n' +
    '                        <div class="row col-sm-12 p-0" ng-if="accounts.selectedAccount.accountType.group !== \'LoanAccountType\'">\n' +
    '                            <div  ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" class="account-container m-l-25 m-r-25">\n' +
    '                                <span class="acrs-acc-info-text m-b-5 auth-persons-text" translate="accounts.accAuthorizedPersons"></span>\n' +
    '                                <hr class="account-header-line" />\n' +
    '\n' +
    '                                <div class="ac-authorized-person-container" data-ng-repeat="item in accounts.selectedAccount.userAccountListFiltered">\n' +
    '                                    <span>{{item.user.firstName}} {{item.user.lastName}} </span>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="col-md-12" ng-if="accounts.selectedAccount.accountType.group == \'CurrentAccount\' && (APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\')">\n' +
    '                            <button class="btn btn-default app-btn-blue m-t-15 m-b-10" translate="orders.largeAmount" ng-click="accounts.goToCashWithdrawal()">\n' +
    '                                Large amount of cash withdrawal\n' +
    '                            </button>\n' +
    '                        </div>\n' +
    '                        <div class="col-md-12" ng-if="accounts.selectedAccount.accountType.group == \'CurrentAccount\' && (APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\') && accounts.selectedAccount.canCashWithDrawal">\n' +
    '                            <button class="btn btn-default app-btn-blue m-t-15 m-b-10" translate="orders.largeAmount" ng-click="accounts.goToCashWithdrawal()">\n' +
    '                                Large amount of cash withdrawal\n' +
    '                            </button>\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row col-xs-12">\n' +
    '                        <span class="account-open-more-details" ng-if="accounts.isAccountDetailsOpen" data-ng-click="accounts.toggleAccountDetails()" translate="accounts.accAccountAndCardsLessDetails">\n' +
    '                        </span>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row" ng-if="accounts.selectedAccount.accountType.group === \'CurrentAccount\'">\n' +
    '                <div class="col-xs-12">\n' +
    '                    <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5"\n' +
    '                         ng-hide="accounts.multiCurrency || (APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\' && APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency != accounts.selectedAccount.currencySymbol)">\n' +
    '                        <a data-ui-sref="payments.domesticPayment.fromAccount({accountId: accounts.selectedAccount.accountId})">\n' +
    '                            <div class="round-btn-container">\n' +
    '                                <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->\n' +
    '                                <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>\n' +
    '                                <div class="round-btn-label">{{\'dashboard.domesticPaymentBtn1\'|translate}}\n' +
    '                                    <br>{{\'dashboard.domesticPaymentBtn2\'|translate}}</div>\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                        <a ng-click="accounts.goToInternalPayment();" ng-if="!accounts.multiCurrency">\n' +
    '                            <div class="pointer round-btn-container">\n' +
    '                                <!--<div class="round-btn"><i class="zmdi zmdi-swap zmdi-hc-3x"></i></div>-->\n' +
    '                                <div class="round-btn"><i class="icon icon-transfer" style="font-size:2em"></i></div>\n' +
    '                                <div class="round-btn-label">{{\'dashboard.transferBtn1\'|translate}}\n' +
    '                                    <br>{{\'dashboard.transferBtn2\'|translate}}</div>\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '                        <a ng-click="accounts.goToForeignCurrencyTransfer()" ng-if="accounts.multiCurrency">\n' +
    '                            <div class="pointer round-btn-container">\n' +
    '                                <!--<div class="round-btn"><i class="zmdi zmdi-swap zmdi-hc-3x"></i></div>-->\n' +
    '                                <div class="round-btn"><i class="icon icon-transfer" style="font-size:2em"></i></div>\n' +
    '                                <div class="round-btn-label">{{\'dashboard.transferBtn1\'|translate}}\n' +
    '                                    <br>{{\'dashboard.transferBtn2\'|translate}}</div>\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                        <div ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\' && APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency != accounts.selectedAccount.currencySymbol"\n' +
    '                             class="pointer round-btn-container" ng-click="accounts.loadPaymentTemplates();">\n' +
    '                            <div class="round-btn"><i class="icon icon-template" style="font-size:1.6em"></i></div>\n' +
    '                            <div class="round-btn-label">{{\'dashboard.templateBtn1\'|translate}}\n' +
    '                                <br>{{\'dashboard.templateBtn2\'|translate}}</div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="templates-container animated fadeIn" ng-show="accounts.showTemplatesView">\n' +
    '                            <div class="form-group m-b-0">\n' +
    '                                <div class="input-group" style="height:50px;border: 1px solid black;">\n' +
    '                                    <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">\n' +
    '                                        <button class="btn" type="submit" style="box-shadow:none;background-color: transparent;">\n' +
    '                                            <i class="glyphicon glyphicon-search" style="font-size:20px;"></i>\n' +
    '                                        </button>\n' +
    '                                    </div>\n' +
    '                                    <input id="searchTemplatesInput" style="height:50px;" data-ng-model="accounts.searchTemplates" type="text" class="form-control srch-input" placeholder="{{\'dashboard.searchTemplatesPlaceholder\' | translate}}" ng-change="accounts.showTemplatesView = (accounts.searchTemplates == \'\') ? false : true">\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="p-10 templates-search-container" scrollable>\n' +
    '                                <!--<div class="m-b-10" ng-show="false">-->\n' +
    '                                <!--<h4 translate="templateSearch.favorites"></h4>-->\n' +
    '                                <!--<div class="list-group">-->\n' +
    '                                <!--<a href="" class="list-group-item">-->\n' +
    '                                <!--<div class="row">-->\n' +
    '                                <!--<div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>-->\n' +
    '                                <!--<div class="col-xs-10">-->\n' +
    '                                <!--<h5 class="list-group-item-heading"><b>Favorite template 1</b></h5>-->\n' +
    '                                <!--<p class="list-group-item-text">HR4015290098745696</p>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--<div class="col-xs-1"><i class="zmdi zmdi-star zmdi-hc-2x"></i></div>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--</a>-->\n' +
    '                                <!--<a href="" class="list-group-item">-->\n' +
    '                                <!--<div class="row">-->\n' +
    '                                <!--<div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>-->\n' +
    '                                <!--<div class="col-xs-10">-->\n' +
    '                                <!--<h5 class="list-group-item-heading"><b>Favorite template 1</b></h5>-->\n' +
    '                                <!--<p class="list-group-item-text">HR4015290098745696</p>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--<div class="col-xs-1"><i class="zmdi zmdi-star zmdi-hc-2x"></i></div>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--</a>-->\n' +
    '                                <!--<a href="" class="list-group-item">-->\n' +
    '                                <!--<div class="row">-->\n' +
    '                                <!--<div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>-->\n' +
    '                                <!--<div class="col-xs-10">-->\n' +
    '                                <!--<h5 class="list-group-item-heading"><b>Favorite template 1</b></h5>-->\n' +
    '                                <!--<p class="list-group-item-text">HR4015290098745696</p>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--<div class="col-xs-1"><i class="zmdi zmdi-star zmdi-hc-2x"></i></div>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--</a>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <!--</div>-->\n' +
    '                                <div class="m-b-10">\n' +
    '                                    <h4 translate="templateSearch.templatesList"></h4>\n' +
    '                                    <div class="list-group">\n' +
    '                                        <a href="" class="list-group-item" data-ng-repeat="template in accounts.templateList.result | filter:accounts.searchTemplates" ng-click="accounts.navigateToPaymentForm({id: template.id, type: template.paymentTypeGroup, template: template})">\n' +
    '                                            <div class="row">\n' +
    '                                                <div class="col-xs-1 p-r-0"><i class="zmdi zmdi-file-text zmdi-hc-2x"></i></div>\n' +
    '                                                <div class="col-xs-11">\n' +
    '                                                    <h5 class="list-group-item-heading"><b>{{template.name}}</b></h5>\n' +
    '                                                    <p class="list-group-item-text">{{template.toAccountNumber}}</p>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </a>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '\n' +
    '                  <!-- SLO - change withdrawal limit -->\n' +
    '                    <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5"\n' +
    '                         ng-if="accounts.countryCode === \'sl\' && accounts.selectedAccount.currencySymbol == \'EUR\' && accounts.selectedAccount.isOwn == true && APP_GLOBAL_SETTINGS.userSettings.isResident == \'Y\'">\n' +
    '                    <a ng-click="accounts.goToChangeWithdrawal()">\n' +
    '                      <div class="round-btn-container">\n' +
    '                        <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->\n' +
    '                        <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>\n' +
    '                        <div class="round-btn-label">{{\'navigation.withdrawal1\'|translate}}\n' +
    '                            <br>{{\'navigation.withdrawal2\'|translate}}\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                  <!-- SLO - change ATM withdrawal limit -->\n' +
    '                  <div class="col-xs-12 col-sm-6 m-b-20 p-l-5 p-r-5"\n' +
    '                       ng-if="accounts.countryCode === \'sl\' && accounts.selectedAccount.currencySymbol == \'EUR\' && accounts.selectedAccount.isOwn == true">\n' +
    '                    <a data-ui-sref="changeATMWithdrawal({accountId: accounts.selectedAccount.accountId})">\n' +
    '                      <div class="round-btn-container">\n' +
    '                        <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->\n' +
    '                        <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>\n' +
    '                        <div class="round-btn-label">{{\'navigation.changeATMWithdrawal1\'|translate}}\n' +
    '                            <br>{{\'navigation.changeATMWithdrawal2\'|translate}}</div>\n' +
    '                      </div>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '\n' +
    '                  <!-- SLO - master card order limit -->\n' +
    '                  <!--<div class="col-xs-12 col-sm-6 m-b-20 p-l-5 p-r-5"-->\n' +
    '                       <!--ng-if="accounts.countryCode === \'sl\'">-->\n' +
    '                    <!--<a data-ui-sref="masterCardOrder({accountId: accounts.selectedAccount.accountId})">-->\n' +
    '                      <!--<div class="round-btn-container">-->\n' +
    '                        <!--&lt;!&ndash;<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>&ndash;&gt;-->\n' +
    '                        <!--<div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>-->\n' +
    '                        <!--<div class="round-btn-label" translate="navigation.masterCardOrder"></div>-->\n' +
    '                      <!--</div>-->\n' +
    '                    <!--</a>-->\n' +
    '                  <!--</div>-->\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '            <!-- Account actions -->\n' +
    '            <div class="m-b-15">\n' +
    '                <div ng-if="accounts.selectedAccount.accountType.group === \'LoanAccountType\'">\n' +
    '                    <div class="col-xs-12">\n' +
    '                        <div ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\' && accounts.selectedAccount.accountType.id != \'1801\'" style="padding-left: 1px;">\n' +
    '                            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                                <div class="round-btn-container" data-ng-click="accounts.goToLoanPayment(); accounts.pushGtmPayInEvent(\'LoanAccount\');">\n' +
    '                                    <div class="round-btn"><i class="icon icon-epayin" style="font-size:2em"></i></div>\n' +
    '                                    <div class="round-btn-label" translate="accounts.accPayIn" style="padding-top:22px;"></div>\n' +
    '                                </div>\n' +
    '\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div style="padding-left: 1px;" ng-if="(APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sr\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'mne\')" data-ng-click="accounts.toggleRepaymentPlan()">\n' +
    '\n' +
    '                            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                                <div class="round-btn-container">\n' +
    '                                    <div class="round-btn"><i class="icon icon-epayin" style="font-size:2em"></i></div>\n' +
    '                                    <div ng-if="accounts.showRepaymentPlan" class="round-btn-label" translate="accounts.closeRepaymentPlan" style="padding-top:22px;">\n' +
    '                                    </div>\n' +
    '                                    <div ng-if="!accounts.showRepaymentPlan" class="round-btn-label" translate="accounts.accRepaymentPlan" style="padding-top:22px;">\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '              <div class="row">\n' +
    '                <div class="col-sm-3 col-xs-12 m-b-20"\n' +
    '                     ng-if="accounts.selectedAccount.accountType.group === \'CardAccountTypes\' && accounts.selectedAccount.linkList.itemList.payIn">\n' +
    '                  <div class="pointer round-btn-container">\n' +
    '                    <div class="round-btn"><i class="icon icon-ebin" style="font-size:2em"></i></div>\n' +
    '                    <div class="round-btn-label" translate="accounts.accPayIn"\n' +
    '                         data-ng-click="accounts.goToInternalPayment(); accounts.pushGtmPayInEvent(\'CardAccount\');"></div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- Transaction division button (specific for BiH environment) -->\n' +
    '                <div class="col-sm-3 col-xs-12 m-b-20"\n' +
    '                     ng-if="accounts.selectedAccount.linkList && accounts.selectedAccount.linkList.itemList.transactionDivisionLink">\n' +
    '                  <a data-ui-sref="transactionDivison.create">\n' +
    '                    <div class="pointer round-btn-container">\n' +
    '                      <!--<div class="round-btn"><i class="zmdi zmdi-home zmdi-hc-3x"></i></div>-->\n' +
    '                      <div class="round-btn"><i class="icon icon-domestic" style="font-size:2em"></i></div>\n' +
    '                      <div class="round-btn-label">{{\'accounts.transDivisionBtn1\'|translate}}\n' +
    '                        <br>{{\'accounts.transDivisionBtn2\'|translate}}\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </a>\n' +
    '                </div>\n' +
    '                <!-- End Transaction division button (specific for BiH environment) -->\n' +
    '              </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '                <!--MNE SPECIFIC START-->\n' +
    '                <div ng-if="(accounts.selectedAccount.accountType.group === \'SavingAccountTypes\' || accounts.selectedAccount.accountType.group === \'DepositAccountTypes\') &&\n' +
    '                    APP_GLOBAL_SETTINGS.defaultData.APILocation === \'mne\' && (accounts.selectedAccount.accountType.id.substr(0,2) === \'60\')">\n' +
    '\n' +
    '                    <button type="input" class="btn btn-default app-btn-blue m-t-5" ng-if="accounts.selectedAccount.accountType.id !== \'SVGSUB\'"\n' +
    '                            data-ng-click="accounts.goToSavingsPayIn(accounts.selectedAccount); accounts.pushGtmPayInEvent(\'DepositAccount\');" translate="accounts.accPayIn"></button>\n' +
    '                </div>\n' +
    '                <!--MNE SPECIFIC END-->\n' +
    '                <div ng-if="accounts.selectedAccount.accountType.group === \'SavingAccountTypes\' && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'mne\'">\n' +
    '                    <div class="col-xs-12 m-b-10">\n' +
    '                        <div class="col-xs-12 col-sm-4">\n' +
    '                            <div class="pointer round-btn-container">\n' +
    '\n' +
    '                                <div class="round-btn" ng-if="accounts.selectedAccount.accountType.id === \'SVGSUB\'"\n' +
    '                                     data-ng-click="accounts.goToEbookPay(\'Pay In\'); accounts.pushGtmPayInEvent(\'Ebook\');"><i class="icon icon-ebin" style="font-size:2em"></i>\n' +
    '                                </div>\n' +
    '                                <div class="round-btn-label" ng-if="accounts.selectedAccount.accountType.id === \'SVGSUB\'"\n' +
    '                                     data-ng-click="accounts.goToEbookPay(\'Pay In\'); accounts.pushGtmPayInEvent(\'Ebook\');" translate="accounts.eBookPayIn">\n' +
    '\n' +
    '                                </div>\n' +
    '\n' +
    '                              <div class="round-btn"  ng-if="accounts.selectedAccount.accountType.id !== \'SVGSUB\'"\n' +
    '                                   data-ng-click="accounts.goToSavingsPayIn(accounts.selectedAccount); accounts.pushGtmPayInEvent(\'SavingsAccount\');"><i class="icon icon-ebin" style="font-size:2em"></i>\n' +
    '                              </div>\n' +
    '                              <div class="round-btn-label" ng-if="accounts.selectedAccount.accountType.id !== \'SVGSUB\'"\n' +
    '                                   data-ng-click="accounts.goToSavingsPayIn(accounts.selectedAccount); accounts.pushGtmPayInEvent(\'SavingsAccount\');" translate="accounts.accPayIn">\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-4">\n' +
    '                            <div class="pointer round-btn-container" ng-if="accounts.selectedAccount.accountType.id === \'SVGSUB\'">\n' +
    '                                <div class="round-btn"><i class="icon icon-ebout" style="font-size:2em"></i></div>\n' +
    '                                <div class="round-btn-label" data-ng-click="accounts.goToEbookPay(\'Pay Out\')" translate="accounts.eBookPayOut"></div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <!--<button type="input" class="btn btn-default app-btn-blue m-t-5" ng-if="accounts.selectedAccount.accountType.id === \'SVGSUB\'"-->\n' +
    '                        <!--translate="accounts.accNewEbook" data-ng-click="accounts.goToNewEbook()"></button>-->\n' +
    '                        <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '                          <div ng-switch-default class="col-xs-12 col-sm-4">\n' +
    '                              <div class="pointer round-btn-container" ng-if="accounts.selectedAccount.accountType.id === \'SVGSUB\'">\n' +
    '                                  <div class="round-btn"><i class="icon icon-ebclose" style="font-size:2em"></i></div>\n' +
    '                                    <div class="round-btn-label" translate="accounts.closeEbook" data-ng-click="accounts.closeEbook(accounts.selectedAccount.accountId)">\n' +
    '                                  </div>\n' +
    '                              </div>\n' +
    '                          </div>\n' +
    '                          <div class="col-xs-12 col-sm-4" ng-switch-when="hr" ng-show="accounts.selectedAccount.currencySymbol == \'HRK\'">\n' +
    '                              <div class="pointer round-btn-container" ng-if="accounts.selectedAccount.accountType.id === \'SVGSUB\'">\n' +
    '                                  <div class="round-btn"><i class="icon icon-ebclose" style="font-size:2em"></i></div>\n' +
    '                                    <div class="round-btn-label" translate="accounts.closeEbook" data-ng-click="accounts.closeEbook(accounts.selectedAccount.accountId)">\n' +
    '                                  </div>\n' +
    '                              </div>\n' +
    '                          </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <!-- Displaying ebook saving requests -->\n' +
    '                    <!--<button type="input" class="btn btn-default app-btn-blue m-t-5" ng-if="accounts.selectedAccount.accountType.id === \'SVGSUB\' && accounts.eBookSavingsRequests.result.length > 0"-->\n' +
    '                    <!--ng-class="{\'ebook-req-btn\': accounts.displayeBookSavingRequest}"-->\n' +
    '                    <!--data-ng-click="accounts.showeSavingBookRequests();" translate="ebook.eBookRequests"></button>-->\n' +
    '                </div>\n' +
    '\n' +
    '                <div ng-if="accounts.selectedAccount.accountType.group === \'DepositAccountTypes\'">\n' +
    '                    <div class="row" style="padding-left: 1px;" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation==\'hr\'">\n' +
    '                        <div class="col-xs-12">\n' +
    '                            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                                <div class="round-btn-container">\n' +
    '                                    <div class="round-btn"><i class="icon icon-close" style="font-size:2em"></i></div>\n' +
    '                                    <!--<button type="input" class="btn btn-default app-btn-blue m-t-5" translate="accounts.accPayIn"></button>\n' +
    '          <button type="input" class="btn btn-default app-btn-blue m-t-5"\n' +
    '                  translate="accounts.accCancelAutoExtension"></button>\n' +
    '          <button type="input" class="btn btn-default app-btn-blue m-t-5"\n' +
    '                  translate="accounts.accCancelDeposit"\n' +
    '                  data-ng-click="accounts.cancelDepositAction()"></button>-->\n' +
    '                                    <div class="round-btn-label" translate="accounts.accCancelDeposit" data-ng-click="accounts.cancelDepositAction()" style="padding-top:22px;"></div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '                <div ng-if="accounts.selectedAccount.accountType.group === \'CurrentAccount\' && APP_GLOBAL_SETTINGS.defaultData.APILocation==\'hr\'">\n' +
    '                    <div class="row" style="padding-left: 1px;">\n' +
    '                        <div class="col-xs-12">\n' +
    '                            <div ng-if="accounts.selectedAccount.currencySymbol == \'HRK\'" class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                                <div class="round-btn-container">\n' +
    '                                    <div class="round-btn"><i class="icon icon-ebnew" style="font-size:2em"></i></div>\n' +
    '                                    <div class="round-btn-label" translate="accounts.accNewEbook" data-ng-click="accounts.goToNewEbook()"></div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                                <div class="round-btn-container">\n' +
    '                                    <div class="round-btn"><i class="icon icon-epayin" style="font-size:2em"></i></div>\n' +
    '                                    <div class="round-btn-label" translate="accounts.eBookPayIn" data-ng-click="accounts.goToEbookPay(\'Pay In\')"></div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div class="col-xs-12 col-sm-4 m-b-20 p-l-5 p-r-5">\n' +
    '                                <div class="round-btn-container">\n' +
    '                                    <div class="round-btn"><i class="icon icon-eborder" style="font-size:2em"></i></div>\n' +
    '                                    <!-- Displaying ebook saving requests -->\n' +
    '                                    <div class="round-btn-label" ng-class="{\'ebook-req-btn\': accounts.displayeBookSavingRequest}" data-ng-click="accounts.showeSavingBookRequests();" translate="ebook.eBookRequests"></div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <!-- Transactions & PDF statements -->\n' +
    '                <!--ng-show="accounts.selectedAccount.accountType.group!=\'LoanAccountType\'\n' +
    '        && accounts.selectedAccount.accountType.group!=\'DepositAccountTypes\'\n' +
    '        && !accounts.displayeBookSavingRequest"-->\n' +
    '                <div ng-if="accounts.accountLoaded && APP_GLOBAL_SETTINGS.defaultData.APILocation === \'mne\' && (accounts.selectedAccount.accountType.group!=\'LoanAccountType\'\n' +
    '        && (accounts.selectedAccount.accountType.id.substr(0,2) === \'60\' || accounts.selectedAccount.accountType.group!=\'DepositAccountTypes\')\n' +
    '        && !accounts.displayeBookSavingRequest)" class="col-sm-12 p-0 m-b-0 app-white-card no-bottom-radius">\n' +
    '                    <div data-ng-include="\'accounts/accountsSubmenu.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '                <div ng-if="accounts.accountLoaded && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'mne\' && (accounts.selectedAccount.accountType.group!=\'LoanAccountType\'\n' +
    '        && accounts.selectedAccount.accountType.group!=\'DepositAccountTypes\'\n' +
    '        && !accounts.displayeBookSavingRequest)" class="col-sm-12 p-0 m-b-0 app-white-card no-bottom-radius">\n' +
    '                    <div data-ng-include="\'accounts/accountsSubmenu.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- START Repayment plan-->\n' +
    '                <div ng-if="accounts.showRepaymentPlan && !accounts.displayeBookSavingRequest" class="col-sm-12 col-md-12 p-0 m-b-0 app-white-card no-bottom-radius">\n' +
    '                    <div data-ng-include="\'accounts/repayment-plan.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '                <!-- END Repayment plan-->\n' +
    '\n' +
    '                <!-- EBookSavings requests timeline -->\n' +
    '                <div ng-if="accounts.displayeBookSavingRequest">\n' +
    '                    <div data-ng-include="\'accounts/tl-ebook-savings.tpl.html\'">\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '                <!--      <div class="hidden-md hidden-sm hidden-lg"\n' +
    '                 data-ng-include="\'accounts/accounts-transaction-filter.tpl.html\'"></div>-->\n' +
    '\n' +
    '                <!--      <div class="col-sm-12 col-md-12 col-lg-12 no-padding-on-phone">\n' +
    '              <div class="grey-margin">\n' +
    '                &lt;!&ndash;<div class="row">&ndash;&gt;\n' +
    '                  <div class="col-sm-1 col-xs-2 favorite-container">\n' +
    '                    <a href="" data-ng-click="accounts.markAsFavorite();">\n' +
    '                      <i ng-if="!accounts.isFavoriteAccount" class="zmdi zmdi-star-outline zmdi-hc-2x"></i>\n' +
    '                      <i ng-if="accounts.isFavoriteAccount" class="zmdi zmdi-star zmdi-hc-2x is-favorite"></i>\n' +
    '                    </a>\n' +
    '                  </div>\n' +
    '                  <div class="col-sm-11 col-xs-10 no-padding">\n' +
    '                    &lt;!&ndash; container for editing accounts &ndash;&gt;\n' +
    '                    <div ng-show="accounts.isEditable == true">\n' +
    '                      <div class="col-sm-8 m-t-14 m-b-9">\n' +
    '                        <input type="text" class="form-control" data-ng-model="accounts.newDescription">\n' +
    '                      </div>\n' +
    '                      <div class="col-sm-4 m-t-14 m-b-9">\n' +
    '                        <i class="zmdi zmdi-check zmdi-hc-2x edit-check-btn" data-ng-click="accounts.editAccount();"></i>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <h2 class="account-name m-l-0" ng-show="accounts.selectedAccount.friendlyName != undefined && !accounts.isEditable">\n' +
    '                      {{accounts.selectedAccount.friendlyName}}\n' +
    '                      <a href="">\n' +
    '                        <span class="clickable-link account-edit" data-ng-click="accounts.showEditAccount();" translate="accounts.rename"></span>\n' +
    '                      </a>\n' +
    '                    </h2>\n' +
    '                    <h2 class="account-name" ng-show="accounts.selectedAccount.friendlyName == undefined && !accounts.isEditable">\n' +
    '                      {{accounts.selectedAccount.accountType.description}}\n' +
    '                      <a href="">\n' +
    '                        <span class="clickable-link account-edit" data-ng-click="accounts.showEditAccount();" translate="accounts.rename"></span>\n' +
    '                      </a>\n' +
    '                    </h2>\n' +
    '                  </div>\n' +
    '\n' +
    '                <div class="col-sm-12 ac-left-section p-l-25 p-b-10" ng-show="accounts.isEditable">\n' +
    '\n' +
    '                  <a href=""><span class="m-l-15 clickable-link" ng-show="accounts.selectedAccount.accountType.group==\'CurrentAccount\' || accounts.selectedAccount.accountType.group==\'CardAccountTypes\'" translate="accounts.accResetName"  data-ng-click="accounts.resetAccountName();"></span></a>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '              <div class="col-sm-12 p-0 m-b-15 app-white-card" ng-switch on="accounts.selectedAccount.accountType.group">\n' +
    '                &lt;!&ndash;CURRENT&ndash;&gt;\n' +
    '                <div ng-switch-when="CurrentAccount">\n' +
    '                  <div data-ng-include="\'accounts/CurrentAccount-detail.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '                &lt;!&ndash;LOAN&ndash;&gt;\n' +
    '                <div ng-switch-when="LoanAccountType">\n' +
    '                  <div data-ng-include="\'accounts/LoanAccountType-detail.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '                &lt;!&ndash;CARD&ndash;&gt;\n' +
    '                <div ng-switch-when="CardAccountTypes">\n' +
    '                  <div data-ng-include="\'accounts/CardAccountTypes-detail.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '                &lt;!&ndash;SAVING ACCOUNT&ndash;&gt;\n' +
    '                <div ng-switch-when="SavingAccountTypes">\n' +
    '                  <div data-ng-include="\'accounts/SavingAccountTypes-detail.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '                &lt;!&ndash; GIRO ACCOUNT&ndash;&gt;\n' +
    '                <div ng-switch-when="GiroAccount">\n' +
    '                  <div data-ng-include="\'accounts/GiroAccount-detail.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '                &lt;!&ndash;DEPOSIT&ndash;&gt;\n' +
    '                <div ng-switch-when="DepositAccountTypes">\n' +
    '                  <div data-ng-include="\'accounts/DepositAccountTypes-detail.tpl.html\'"></div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div ng-show="accounts.selectedAccount.accountType.group!=\'LoanAccountType\' && accounts.selectedAccount.accountType.group!=\'DepositAccountTypes\'" class="col-sm-12 p-0 m-b-0 app-white-card no-bottom-radius">\n' +
    '                <div data-ng-include="\'accounts/accountsSubmenu.tpl.html\'"></div>\n' +
    '              </div>\n' +
    '              <div class="hidden-md hidden-sm hidden-lg" data-ng-include="\'accounts/accounts-transaction-filter.tpl.html\'"></div>\n' +
    '            </div>-->\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/accounts-transactions.tpl.html',
    '<div class="row">\n' +
    '  <div class="col-xs-12">\n' +
    '    <div class="t-a-c m-t-10 p-10 no-data-image" ng-show="accounts.selectedAccount.transactions.result.length == 0">\n' +
    '      <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '      <h3 class="no-data-label" translate="transactions.noData"></h3>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!--<div class="hypo-timeline-header-line col-sm-12 no-bottom-radius no-top-radius visible-md-block visible-sm-block visible-lg-block" ng-show="accounts.selectedAccount.transactions.result.length > 0">\n' +
    '    <div class="col-md-6 col-sm-4 t-a-l p-0" translate="accounts.accDescription"></div>\n' +
    '    <div class="col-md-3 col-sm-4 t-a-r p-0" translate="accounts.accAmount"></div>\n' +
    '    <div class="col-md-3 col-sm-4 t-a-r p-0" translate="accounts.accBalance"></div>\n' +
    '</div>-->\n' +
    '<div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\'" class="row p-t-15" ng-show="accounts.selectedAccount.transactions.result.length > 0">\n' +
    '  <div class="col-xs-12 col-sm-6 t-a-r hidden-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumCredit\' | translate}} {{accounts.selectedAccount.transactions.result[1].balanceSumCredit\n' +
    '      | number:2}} {{accounts.selectedAccount.transactions.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 col-sm-6 t-a-l hidden-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumDebit\' | translate}} {{accounts.selectedAccount.transactions.result[1].balanceSumDebit |\n' +
    '      number:2}} {{accounts.selectedAccount.transactions.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="col-xs-12 t-a-c visible-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumCredit\' | translate}} {{accounts.selectedAccount.transactions.result[1].balanceSumCredit\n' +
    '      | number:2}} {{accounts.selectedAccount.transactions.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 t-a-c visible-xs">\n' +
    '    <label class="balance-sum-label ng-scope">\n' +
    '      {{\'transactions.balanceSumDebit\' | translate}} {{accounts.selectedAccount.transactions.result[1].balanceSumDebit |\n' +
    '      number:2}} {{accounts.selectedAccount.transactions.result[1].currencySymbol}}\n' +
    '    </label>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row">\n' +
    '\n' +
    '<div class="timeline-row col-sm-12 p-l-0 p-r-0" ng-show="accounts.selectedAccount.transactions.result.length > 0">\n' +
    '    <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0 no-top-radius">\n' +
    '        <ul class="hypo-timeline statements-timeline">\n' +
    '            <li data-ng-repeat="transaction in accounts.selectedAccount.transactions.result" ng-class="{\'time-label\': transaction.isVirtual === true, \'tl-badge-icon\': transaction.isVirtual === undefined}">\n' +
    '                <span ng-if="transaction.isVirtual === true">{{transaction.valueDate | date: \'shortDate\'}}</span>\n' +
    '                <i ng-if="transaction.isVirtual == undefined" data-ng-class="{\'icon icon-priliv\': transaction.credit != null,\'icon icon-odliv\': transaction.credit == null}"></i>\n' +
    '                <div ng-if="transaction.isVirtual == undefined" class="hypo-timeline-item transaction-item" data-ng-click="transaction.selected = !transaction.selected; accounts.getTransactionDetails(transaction);" ng-class="{\'opened\': transaction.selected}">\n' +
    '                    <div class="hypo-timeline-body">\n' +
    '                        <div class="col-xs-6 col-sm-8 p-l-0 p-r-0">\n' +
    '                            <h4 class="m-b-0 m-t-0 c-gray no-wrap-text"><b>{{::transaction.detail.purpose}}</b></h4>\n' +
    '                            <p class="m-b-0 m-t-0 no-wrap-text">\n' +
    '                              <span ng-if="transaction.detail.payeeName">{{transaction.detail.payeeName}}</span>\n' +
    '                              <span ng-if="transaction.detail.toAccountNumber && !transaction.toAccountNumber">&nbsp;{{::transaction.detail.toAccountNumber}}</span>\n' +
    '                              <span ng-if="transaction.toAccountNumber">{{::transaction.toAccountNumber}}</span>\n' +
    '                              <span ng-if="accounts.selectedAccount.iban && accounts.countryCode != \'hr\'">/ {{::accounts.selectedAccount.iban}}</span>\n' +
    '                              <span ng-if="transaction.detail.fromAccountNumber && accounts.countryCode == \'hr\'">/ {{::transaction.detail.fromAccountNumber}}</span>\n' +
    '                            </p>\n' +
    '                        </div>\n' +
    '                        <div style="font-weight:600; font-size:22px;" ng-if="transaction.credit == null" class="price-payment col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::transaction.amount | number:2}} {{::transaction.currencySymbol}}</b></span></div>\n' +
    '                        <div style="font-weight:600; font-size:22px;" ng-if="transaction.debit == null" class="price-payment col-xs-6 col-sm-4 p-l-0 p-r-0"><span class="pull-right t-a-r m-t-5 f-18"><b>{{::transaction.amount | number:2}} {{::transaction.currencySymbol}}</b></span></div>\n' +
    '\n' +
    '\n' +
    '                    </div>\n' +
    '                    <div ng-if="transaction.selected" class="m-l-0 transaction-details">\n' +
    '                        <div data-ng-include="\'accounts/acc-trans-detail-modal.tpl.html\'"></div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div ng-if="accounts.selectedAccount.transactions.hasMore == true" class="col-xs-12 t-a-c m-t-15 m-b-15">\n' +
    '  <button ng-if="accounts.selectedAccount.transactions.hasMore == true" data-ng-click="accounts.loadMoreTransactions()"\n' +
    '          type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn"\n' +
    '          translate="paymentsOverview.loadMoreBtn">Load more</button>\n' +
    '</div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/accounts-transaction-filter.tpl.html',
    '<!--<transactions-filter ng-if="accounts.currenciesList.length" transactions="accounts.selectedAccount.transactions.result"-->\n' +
    '<!--transaction-currency-list="accounts.currenciesList"-->\n' +
    '<!--allow-custom-datepicker="true"-->\n' +
    '<!--data-statements="(accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\')"-->\n' +
    '<!--statement-dates="accounts.detailedFilter.statementDates"-->\n' +
    '<!--data-default-dates="accounts.defaultDates"-->\n' +
    '<!--transaction-filter-change="accounts.refreshTransactionsByFilter(filterParams)"-->\n' +
    '<!--currency="accounts.defaultCurrency">-->\n' +
    '<!--</transactions-filter>-->\n' +
    '\n' +
    '<!-- TRANSACTION FILTER html START -->\n' +
    '<div class="tml-filter-container tmlf-wide"\n' +
    '     stlye="overflow: hidden; margin: 15px">\n' +
    '  <!-- START Search text input -->\n' +
    '  <div class="inner-section left">\n' +
    '    <i class="icon icon-search icon-hc-2x m-l-5"></i>\n' +
    '  </div>\n' +
    '  <div class="inner-section center">\n' +
    '    <input type="text" class="search-input"\n' +
    '           placeholder="{{\'timelineFilter.placeholder\'|translate}}"\n' +
    '           ng-model="accounts.transactionFilterOptions.genericSearch" ng-model-options="{ debounce: 300 }"\n' +
    '           ng-change="accounts.search()">\n' +
    '  </div>\n' +
    '  <div  class="inner-section right pull-right">\n' +
    '    <i class="zmdi zmdi-tag-close pull-left zmdi-hc-2x m-r-0"\n' +
    '       ng-show="accounts.transactionFilterOptions.genericSearch"\n' +
    '       ng-click="accounts.clearSearch();">\n' +
    '    </i>\n' +
    '    <i class="icon icon-filter icon-hc-2x i-r-0 pull-right" style="z-index: 100000"\n' +
    '       ng-click="accounts.showFilterOptionsWrapper = !accounts.showFilterOptionsWrapper">\n' +
    '    </i>\n' +
    '  </div>\n' +
    '  <div class="tml-filter-selection"\n' +
    '       ng-class="{\'opened\': accounts.showFilterOptionsWrapper,\n' +
    '       \'h-430\': (accounts.dateFromOpen || accounts.dateToOpen) && !(accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\'),\n' +
    '       \'h-510\': ((accounts.dateFromOpen || accounts.dateToOpen) && accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\')}"\n' +
    '       style="z-index: 6">\n' +
    '    <div class="tml-filter-type-selection-wrapper">\n' +
    '      <div ng-class="{\'selected\': accounts.transactionFilterOptions.transactionType === undefined}" class="tmlf-type-item"\n' +
    '           ng-click="accounts.transactionFilterOptions.transactionType = undefined"\n' +
    '           translate="timelineFilter.all"\n' +
    '           style="width: 33.333%">\n' +
    '      </div>\n' +
    '      <div ng-class="{\'selected\': accounts.transactionFilterOptions.transactionType == \'Credit\'}" class="tmlf-type-item"\n' +
    '           style="width: 33.333%"\n' +
    '           ng-click="accounts.transactionFilterOptions.transactionType = \'Credit\'"\n' +
    '           translate="timelineFilter.credit"></div>\n' +
    '      <div ng-class="{\'selected\': accounts.transactionFilterOptions.transactionType == \'Debit\'}" class="tmlf-type-item"\n' +
    '           style="width: 33.333%"\n' +
    '           ng-click="accounts.transactionFilterOptions.transactionType = \'Debit\'"\n' +
    '           translate="timelineFilter.debit"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="(accounts.selectedAccount.accountType.group == \'CardAccountTypes\' && accounts.countryCode === \'sl\')" class="m-t-15" style="overflow:auto">\n' +
    '      <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '        <div class="form-group m-b-0">\n' +
    '          <label class="f-12-s" translate="transactions.statementsFilter"></label>\n' +
    '          <select class="form-control-db"\n' +
    '                  ng-options="option | date:\'shortDate\' for option in accounts.statementDates"\n' +
    '                  ng-model="accounts.transactionFilterOptions.datePeriodStart"\n' +
    '                  ng-change="accounts.transactionFilterOptions.dateFrom = undefined; accounts.transactionFilterOptions.dateTo = undefined; accounts.transactionFilterYearDateRangeValid = true">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <!-- START: Row Date from and date to -->\n' +
    '    <div class="m-t-15 clearfix">\n' +
    '      <div class="col-xs-6 p-l-5 p-r-5">\n' +
    '        <div class="form-group m-b-0">\n' +
    '          <label class="f-12-s" translate="repaymentPlan.dateFrom">Date from</label>\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control-db"\n' +
    '                   ng-class="{\'domp-error\': (!accounts.transactionFilterOptions.datePeriodStart && !accounts.transactionFilterOptions.dateFrom)}"\n' +
    '                   ng-value="accounts.transactionFilterOptions.dateFrom | date: \'shortDate\'"\n' +
    '                   readonly>\n' +
    '            <span class="input-group-btn">\n' +
    '                  <button data-ng-click="accounts.dateFromOpen = !accounts.dateFromOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 p-l-0 p-r-5">\n' +
    '        <div class="form-group m-b-0">\n' +
    '          <label class="f-12-s" translate="repaymentPlan.dateTo">Date to</label>\n' +
    '          <div class="input-group ">\n' +
    '            <input type="text" class="form-control-db"\n' +
    '                   ng-class="{\'domp-error\': (!accounts.transactionFilterOptions.datePeriodStart && !accounts.transactionFilterOptions.dateTo)}"\n' +
    '                   ng-value="accounts.transactionFilterOptions.dateTo | date: \'shortDate\'"\n' +
    '                   readonly>\n' +
    '            <span class="input-group-btn">\n' +
    '                  <button data-ng-click="accounts.dateToOpen = !accounts.dateToOpen" type="button"\n' +
    '                          class="btn btn-default input-group-app-btn domp-btn-height z-zero"\n' +
    '                          style="border:1px solid #062a42; height: 35px">\n' +
    '                          <i class="icon icon-calendar" style="font-size: 21px;"></i>\n' +
    '                  </button>\n' +
    '                </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Datepickers -->\n' +
    '      <div class="col-xs-6 p-l-0 p-r-5 transactions-date-pickers">\n' +
    '        <!-- Date from datepicker-->\n' +
    '        <div data-ng-model="accounts.transactionFilterOptions.dateFrom"\n' +
    '             show-weeks="false"\n' +
    '             is-open="accounts.dateFromOpen"\n' +
    '             ng-change="accounts.onDateFromChange();accounts.clearStatementDate();"\n' +
    '             uib-datepicker-popup="shortDate"\n' +
    '             show-button-bar="false"\n' +
    '              required="">\n' +
    '        </div>\n' +
    '        <!-- Date to datepicker-->\n' +
    '        <div data-ng-model="accounts.transactionFilterOptions.dateTo"\n' +
    '             show-weeks="false"\n' +
    '             is-open="accounts.dateToOpen"\n' +
    '             ng-change="accounts.onDateToChange();accounts.clearStatementDate();"\n' +
    '             date-disabled="accounts.datesToDisabled(date, mode)"\n' +
    '             show-button-bar="false"\n' +
    '             uib-datepicker-popup="shortDate">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <span class="p-l-5 p-t-5 c-red" ng-if="!accounts.transactionFilterYearDateRangeValid">\n' +
    '        <span translate="core.filter.maxDateRange"></span>\n' +
    '    </span>\n' +
    '    <!-- END: Row Date from and date to -->\n' +
    '\n' +
    '    <div class="m-t-15" style="overflow:auto">\n' +
    '      <div class="col-xs-5 p-l-5 p-r-5">\n' +
    '        <div class="form-group">\n' +
    '          <label class="f-12-s" translate="timelineFilter.amountFrom"></label>\n' +
    '          <input ng-keyup="$event.keyCode == 13 && accounts.applyFilter()" type="text" class="form-control-db"\n' +
    '                 ng-model="accounts.transactionFilterOptions.amountGTE"\n' +
    '                 amount-input-mask maxlength="12"\n' +
    '                 placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" autocomplete="off">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-4 p-l-0 p-r-5">\n' +
    '        <div class="form-group">\n' +
    '          <label class="f-12-s" translate="timelineFilter.amountTo"></label>\n' +
    '          <input ng-keyup="$event.keyCode == 13 && accounts.applyFilter()" type="text" class="form-control-db"\n' +
    '                 ng-model="accounts.transactionFilterOptions.amountLTE"\n' +
    '                 amount-input-mask maxlength="12"\n' +
    '                 placeholder="{{\'accounts.accEg\' | translate}}: 000.000,00" autocomplete="off">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-xs-3 p-l-0 p-r-5 p-t-25">\n' +
    '        <select class="form-control-db"\n' +
    '                ng-options="option.symbol as option.symbol for option in accounts.currenciesList"\n' +
    '                ng-model="accounts.transactionFilterOptions.currencySymbol">\n' +
    '        </select>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="m-b-15" style="overflow:auto">\n' +
    '      <div class="col-xs-6 t-a-l p-l-5">\n' +
    '        <button class="btn btn-primary app-btn-gray ng-scope" ng-click="accounts.resetFilter();"\n' +
    '                translate="timelineFilter.reset">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 t-a-r p-r-5">\n' +
    '        <button class="btn btn-default app-btn-blue w-100" ng-click="accounts.applyFilter();"\n' +
    '                ng-disabled="!accounts.transactionFilterYearDateRangeValid"\n' +
    '                translate="timelineFilter.apply">\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- END Detail filter expanded -->\n' +
    '\n' +
    '</div>\n' +
    '<!-- TRANSACTION FILTER html END -->\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/accounts-statements.tpl.html',
    '<div ng-hide="accounts.showSubmenuItemType==\'transactions\'"></div>\n' +
    '<!-- <div class="statement-break col-sm-12 col-md-6" ng-hide="accounts.showSubmenuItemType==\'transactions\'"></div> -->\n' +
    '<div class="t-a-c m-t-10 p-10 no-data-image" ng-show="accounts.selectedAccount.statements.result.length == 0">\n' +
    '  <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>\n' +
    '   <h3 class="no-data-label" translate="transactions.noStatementData"></h3>\n' +
    '</div>\n' +
    '<div class="timeline-row col-sm-12 p-l-0 p-r-0" ng-show="accounts.selectedAccount.statements.result.length > 0">\n' +
    '  <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0 no-top-radius">\n' +
    '    <ul class="hypo-timeline">\n' +
    '      <li data-ng-repeat="statement in accounts.selectedAccount.statements.result" ng-class="{\'time-label\': statement.isVirtual === true, \'tl-badge-icon\': statement.isVirtual === undefined}">\n' +
    '        <span ng-if="statement.isVirtual === true" class="bg-white">{{statement.closeDateYear}}</span>\n' +
    '        <i ng-if="statement.isVirtual == undefined" class="zmdi icon f-18 lh-27 c-nar icon-acrobat"></i>\n' +
    '\n' +
    '        <div ng-if="statement.isVirtual == undefined" class="hypo-timeline-item">\n' +
    '\n' +
    '          <div class="hypo-timeline-body">\n' +
    '            <div class="row">\n' +
    '              <div class="col-md-9 col-sm-6 col-xs-12 t-a-l test">{{statement.closeDate | date}} - {{statement.statementId}}</div>\n' +
    '              <div class="col-md-3 col-sm-6 col-xs-12 t-a-c test" ng-if="accounts.countryCode !== \'bh\'">\n' +
    '                <button type="input" class="btn btn-default app-btn-orange m-b-0" translate="accounts.accDownloadPdf" ng-click="accounts.DownloadPDFStatement(statement.statementId, statement)"\n' +
    '                        ng-disabled="statement.downloadInProgress"></button>\n' +
    '              </div>\n' +
    '              <!-- Statements download button for BiH environment -->\n' +
    '              <div class="col-md-3 col-sm-6 col-xs-12 t-a-c test"\n' +
    '                   ng-if="accounts.countryCode === \'bh\' && statement.linkList.itemList.downloadStatement">\n' +
    '                <button type="input" class="btn btn-default app-btn-orange m-b-0" translate="accounts.accDownloadPdf"\n' +
    '                        ng-click="accounts.DownloadPDFStatement(statement.linkList.itemList.downloadStatement)"></button>\n' +
    '              </div>\n' +
    '              <!-- End statements download button for BiH environment -->\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div ng-if="accounts.selectedAccount.statements.hasMore == true" class="col-xs-12 t-a-c m-t-15 m-b-15">\n' +
    '  <button data-ng-click="accounts.loadMoreStatements()"\n' +
    '          type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn"\n' +
    '          translate="paymentsOverview.loadMoreBtn">Load more</button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/accounts-overview.tpl.html',
    '<section id="main">\n' +
    '  <div class="container-fluid">\n' +
    '    <div class="row main-row">\n' +
    '      <div class="main-column col-xs-12">\n' +
    '        <!-- START Title -->\n' +
    '        <div class="row">\n' +
    '          <div class="col-md-12">\n' +
    '            <h2>\n' +
    '              <h2 class="f-28" translate="accountsOverview.title"></h2>\n' +
    '            </h2>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END Title -->\n' +
    '        <!-- START Multi Accounts View-->\n' +
    '        <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '          <div ng-switch-default class="row m-b-15">\n' +
    '            <div ng-if="accountsOverview.multiAccounts.length"\n' +
    '                 ng-class="{\'col-md-6\': accountsOverview.singleAccounts.length, \'col-md-12\': !accountsOverview.singleAccounts.length}">\n' +
    '              <div class="col-md-12 multi-currency-account-card m-b-15"\n' +
    '                   ng-class="{\'col-md-6\': !accountsOverview.singleAccounts.length, \'col-md-12\': accountsOverview.singleAccounts.length}"\n' +
    '                   ng-repeat="multiAccount in accountsOverview.multiAccounts">\n' +
    '                <div style="background: #ff4d5a;">\n' +
    '                  <div class="multi-account-item-widget in-padding"\n' +
    '                       ng-style="multiAccount.accounts[0].linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + multiAccount.accounts[0].linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <!-- START MultiCard Title -->\n' +
    '                    <h4 class="acc-name c-white m-t-0 m-b-0">\n' +
    '                      <!--<b class="col-xs-10 p-0  no-wrap-text">\n' +
    '                        Multi-currency account\n' +
    '                      </b>-->\n' +
    '                      <b class="col-xs-10 p-0  no-wrap-text">{{multiAccount.accounts[0].friendlyName}}</b>\n' +
    '                    </h4>\n' +
    '                    <span ng-if="multiAccount.iban" class="c-white f-14  no-wrap-text">{{multiAccount.iban}}</span>\n' +
    '                    <!-- END MultiCard Title -->\n' +
    '                    <div class="no-padding no-margin"\n' +
    '                         ng-repeat="account in multiAccount.accounts">\n' +
    '                      <div data-ng-click="accountsOverview.goToAccount(account.accountId)">\n' +
    '                        <h4 class="acc-name c-white m-t-0 m-b-0">\n' +
    '                          <b class="col-xs-10 p-0  no-wrap-text"></b>\n' +
    '                          <span class="col-xs-2 p-0 t-a-r c-white">\n' +
    '                            <i class="c-white"\n' +
    '                               ng-class="{\'icon icon-favourite favorite-account\':account.isFavorite,\'zmdi zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                          </span>\n' +
    '                        </h4>\n' +
    '                        <h2 class="amount m-b-5 c-white">\n' +
    '                          <amount-formatter amount="{{account.balance|number:2}}" custom-classes="{{\'c-white\'}}"\n' +
    '                                            currency="{{account.currencySymbol}}" from-type="dashboard"\n' +
    '                                            aditional-val="{{account.balance|number:2}}" has-underline="true">\n' +
    '                          </amount-formatter>\n' +
    '                        </h2>\n' +
    '                        <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\' && account.accountType.group === \'CardAccountTypes\'" translate="accounts.accBalance" class="c-white balance-label m-t-5 m-b-0">Balance</p>\n' +
    '                        <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\' || account.accountType.group !== \'CardAccountTypes\'" translate="accounts.balance" class="c-white balance-label m-t-5 m-b-0">Balance</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END Multi accounts-->\n' +
    '            <!-- START Single accounts -->\n' +
    '            <div ng-if="accountsOverview.singleAccounts.length"\n' +
    '                 ng-class="{\'col-md-6\': accountsOverview.multiAccounts.length, \'col-md-12 no-padding\': !accountsOverview.multiAccounts.length}">\n' +
    '              <div class="m-b-15"\n' +
    '                   ng-repeat="account in accountsOverview.singleAccounts"\n' +
    '                   data-ng-click="accountsOverview.goToAccount(account.accountId)"\n' +
    '                   ng-class="{\'col-md-6\': !accountsOverview.multiAccounts.length}">\n' +
    '                <div data-ng-include="\'dashboard/AccountItemWidget.tpl.html\'"></div>\n' +
    '              </div>\n' +
    '              <!--</div>-->\n' +
    '            </div>\n' +
    '            <!-- END  Single accounts -->\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div ng-switch-when="sl" class="row m-b-15">\n' +
    '            <div ng-if="accountsOverview.multiAccounts.length"\n' +
    '                 ng-class="{\'col-md-6 p-0\': accountsOverview.cardAccounts.length, \'col-md-12\': !accountsOverview.cardAccounts.length}">\n' +
    '              <div class="col-md-12 multi-currency-account-card m-b-15 "\n' +
    '                   ng-class="{\'col-md-6\': !accountsOverview.cardAccounts.length, \'col-md-12\': accountsOverview.cardAccounts.length}"\n' +
    '                   ng-repeat="multiAccount in accountsOverview.multiAccounts | orderBy: [\'-isOwn\']">\n' +
    '                <div style="background: #ff4d5a;">\n' +
    '                  <div class="multi-account-item-widget in-padding"\n' +
    '                       ng-style="multiAccount.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + multiAccount.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                    <!-- START MultiCard Title -->\n' +
    '                    <h4 class="acc-name c-white m-t-0 m-b-0">\n' +
    '                      <!--<b class="col-xs-10 p-0  no-wrap-text">\n' +
    '                        Multi-currency account\n' +
    '                      </b>-->\n' +
    '                      <b class="col-xs-10 p-0  no-wrap-text">{{multiAccount.friendlyName}}</b>\n' +
    '                    </h4>\n' +
    '                    <span ng-if="multiAccount.iban" class="c-white f-14  no-wrap-text">\n' +
    '                      {{multiAccount.iban}}\n' +
    '                    </span>\n' +
    '                    <!-- END MultiCard Title -->\n' +
    '                    <div class="no-padding no-margin"\n' +
    '                         ng-repeat="account in multiAccount.subAccountList | orderBy: [\'sortOrderId\']">\n' +
    '                      <div data-ng-click="accountsOverview.goToAccount(account.accountId)">\n' +
    '                        <h4 class="acc-name c-white m-t-0 m-b-0">\n' +
    '                          <b class="col-xs-10 p-0  no-wrap-text"></b>\n' +
    '                          <span class="col-xs-2 p-0 t-a-r c-white">\n' +
    '                            <i class="c-white"\n' +
    '                               ng-class="{\'icon icon-favourite favorite-account\':account.isFavorite,\'zmdi zmdi-star-outline\':!account.isFavorite}"></i>\n' +
    '                          </span>\n' +
    '                        </h4>\n' +
    '                        <h2 class="amount m-b-5 c-white">\n' +
    '                          <amount-formatter amount="{{account.balance|number:2}}" custom-classes="{{\'c-white\'}}"\n' +
    '                                            currency="{{account.currencySymbol}}" from-type="dashboard"\n' +
    '                                            aditional-val="{{account.balance|number:2}}" has-underline="true">\n' +
    '                          </amount-formatter>\n' +
    '                        </h2>\n' +
    '                        <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\' && account.accountType.group === \'CardAccountTypes\'" translate="accounts.accBalance" class="c-white balance-label m-t-5 m-b-0">Balance</p>\n' +
    '                        <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\' || account.accountType.group !== \'CardAccountTypes\'" translate="accounts.balance" class="c-white balance-label m-t-5 m-b-0">Balance</p>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <!-- END Multi accounts-->\n' +
    '            <!-- START Single accounts -->\n' +
    '            <div ng-if="accountsOverview.cardAccounts.length"\n' +
    '                 ng-class="{\'col-md-6\': accountsOverview.multiAccounts.length, \'col-md-12 gno-paddin\': !accountsOverview.multiAccounts.length}">\n' +
    '              <div class="m-b-15"\n' +
    '                   ng-repeat="account in accountsOverview.cardAccounts | orderBy: [\'-isOwn\']"\n' +
    '                   data-ng-click="accountsOverview.goToAccount(account.accountId)"\n' +
    '                   ng-class="{\'col-md-6\': !accountsOverview.multiAccounts.length}">\n' +
    '\n' +
    '                <div class="account-item-widget app-red-card"\n' +
    '                     ng-style="account.linkList.itemList.imageUrl ?{\'background-image\': \'url(\' + account.linkList.itemList.imageUrl + \')\'} : {\'background-image\': \'url(img/hypo/current_account_h200.png)\'}">\n' +
    '                  <h4 class="acc-name c-white m-t-0 m-b-0">\n' +
    '                    <b class="col-xs-10 p-0  no-wrap-text">{{::account.friendlyName}}</b>\n' +
    '\n' +
    '                    <span class="col-xs-2 p-0 t-a-r c-white">\n' +
    '                      <i class="c-white"\n' +
    '                         ng-class="{\'icon icon-favourite favorite-account\':account.isFavorite,\'f-24 zmdi zmdi-star-outline\':!account.isFavorite}">\n' +
    '\n' +
    '                      </i>\n' +
    '                    </span>\n' +
    '                  </h4>\n' +
    '                  <span class="c-white f-14  no-wrap-text fw-cm">{{::account.accountNumber}}</span>\n' +
    '                  <h2 class="amount m-b-5 c-white">\n' +
    '                    <amount-formatter amount="{{account.balance|number:2}}" custom-classes="{{\'c-white\'}}"\n' +
    '                                      currency="{{account.currencySymbol}}" from-type="dashboard"\n' +
    '                                      aditional-val="{{account.balance|number:2}}" has-underline="true">\n' +
    '                    </amount-formatter>\n' +
    '                  </h2>\n' +
    '                  <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation === \'sl\' && account.accountType.group === \'CardAccountTypes\'" translate="accounts.accBalance" class="c-white balance-label m-t-5 m-b-0">Balance</p>\n' +
    '                  <p ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation !== \'sl\' || account.accountType.group !== \'CardAccountTypes\'" translate="accounts.balance" class="c-white balance-label m-t-5 m-b-0">Balance</p>\n' +
    '                  <div>\n' +
    '                    <!--<span class="c-white f-14  no-wrap-text fw-cm">-->\n' +
    '                      <!--{{account.iban}}-->\n' +
    '                    <!--</span>-->\n' +
    '\n' +
    '                    <!--<div ng-if="account.accountDescription" class="c-white f-14  no-wrap-text fw-cm">-->\n' +
    '                      <!--{{::account.accountDescription}}-->\n' +
    '                    <!--</div>-->\n' +
    '                  </div>\n' +
    '                  <!--<div class="p-t-15 amount-formater-wrapper has-underline"></div>-->\n' +
    '                  <!--<p class="p-t-15 c-white f-14  no-wrap-text fw-cm">-->\n' +
    '                    <!--<span translate="accounts.approvedLimit"></span>-->\n' +
    '                    <!--<span class="pull-right " ng-if="account.hasOwnProperty(\'limit\')">{{account.limit | number: 2}} {{::account.currencySymbol}}</span>-->\n' +
    '                    <!--<span class="pull-right" ng-if="!account.hasOwnProperty(\'limit\')"-->\n' +
    '                          <!--translate="accounts.dataNotAvailable"></span>-->\n' +
    '                  <!--</p>-->\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- END  Single accounts -->\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '        <!-- START Card list-->\n' +
    '        <div class="row" ng-if="accountsOverview.cards && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'"\n' +
    '        ng-hide="APP_GLOBAL_SETTINGS.userSettings.isViberUser == \'Y\'">\n' +
    '          <div class="col-md-12">\n' +
    '            <div class="debit-card-group clearfix"\n' +
    '                 style="background: white"\n' +
    '                 ng-repeat="card in accountsOverview.cards"\n' +
    '                 ng-class="{\'debit-card-group-blocked\': (card.cardStatus !== \'Active\')}">\n' +
    '              <div class="col-xs-12 col-sm-6 col-md-3">\n' +
    '                <div class="connected-debit-card-widget"></div>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12 col-sm-6 col-md-3">\n' +
    '                <h3>\n' +
    '                  {{card.accountName}}\n' +
    '                </h3>\n' +
    '\n' +
    '                <h5 ng-show="card.cardNumber">{{card.cardNumber}}</h5>\n' +
    '                <h5 ng-show="card.cardType && accountsOverview.countryCode == \'hr\'">{{card.cardType}}</h5>\n' +
    '                <h5 ng-show="card.cardTypeDescription && accountsOverview.countryCode != \'hr\'">\n' +
    '                  {{card.cardTypeDescription}}</h5>\n' +
    '                <h5 ng-show="card.validToDate">\n' +
    '                  <span translate="accounts.accLimitValidUntilDate">Expiry date:</span> {{card.validToDate| date:\n' +
    '                  "dd.MM.yyyy"}}\n' +
    '                </h5>\n' +
    '                <h5 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'bh\'" ng-show="card.cardStatus"><b>Status:</b> {{\'accounts.\' + card.cardStatus| translate }}</h5>\n' +
    '                <h5 ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\'" ng-show="card.cardStatus"><b>Status:</b> {{\'accounts.cardStatus.\' + card.cardStatus| translate }}</h5>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12 col-sm-6 col-md-3">\n' +
    '                <h3 ng-show="card.ownerName">{{card.ownerName}}</h3>\n' +
    '              </div>\n' +
    '              <div class="col-xs-12 col-sm-6 col-md-3">\n' +
    '                <button class="btn btn-info btn-block"\n' +
    '                        style="white-space: normal"\n' +
    '                        ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'hr\' || APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'"\n' +
    '                        ng-disabled="card.selected"\n' +
    '                        ng-class="{\n' +
    '                          \'btn-card-active\': (card.cardStatus === \'Active\'),\n' +
    '                          \'btn-card-blocked\': (card.cardStatus !== \'Active\')}"\n' +
    '                        ng-click="accountsOverview.updateCardStatus(card)">\n' +
    '                  <span ng-show="card.temporaryStatus && card.temporaryStatus == \'SentUnblockRequest\'"\n' +
    '                        translate="accounts.unblockCardRequest">Unblock request sent</span>\n' +
    '                  <span ng-show="card.temporaryStatus && card.temporaryStatus == \'SentBlockRequest\'"\n' +
    '                        translate="accounts.blockCardRequest">Block request sent</span>\n' +
    '                  <span ng-show="!card.temporaryStatus && card.cardStatus == \'Active\'"\n' +
    '                        translate="accounts.blockCard"></span>\n' +
    '                  <span ng-show="!card.temporaryStatus && card.cardStatus != \'Active\'"\n' +
    '                        translate="accounts.unblockCard"></span>\n' +
    '                </button>\n' +
    '                <!--                <button class="btn btn-info btn-block"\n' +
    '                                        ng-show="accountsOverview.countryCode == \'hr\'"\n' +
    '                                        ng-disabled="card.selected"\n' +
    '                                        ng-class="{\'btn-card-active\': (card.cardStatus === \'Active\'), \'btn-card-blocked\': (card.cardStatus !== \'Active\')}"\n' +
    '                                        ng-click="accountsOverview.updateCardStatusCro()">\n' +
    '                                  <span ng-show="card.cardStatus === \'Active\'" translate="accounts.blockCard"></span>\n' +
    '                                  <span ng-hide="card.cardStatus === \'Active\'" translate="accounts.unblockCard"></span>\n' +
    '                                </button>-->\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END Card list-->\n' +
    '        <!-- START Add New Deposit and New eSaving Account Buttons -->\n' +
    '        <div class="row">\n' +
    '          <div>\n' +
    '            <!--            <div ng-if="accountsOverview.currentCountry != \'hr\'" class="col-md-6 m-b-10">\n' +
    '                          <div class="account-item-add app-dblue-card " >\n' +
    '                            <div class="round-btn-container2">\n' +
    '                              <div class="round-btn2">\n' +
    '                                <i class="icon-r icon-add"></i>\n' +
    '                              </div>\n' +
    '                              <div class="round-btn-label2" style="width: 150px">\n' +
    '                                <b translate="accountsOverview.newTermDepositButtonLabel"></b>\n' +
    '                              </div>\n' +
    '                            </div>\n' +
    '                          </div>\n' +
    '                        </div>-->\n' +
    '\n' +
    '            <div ng-if="accountsOverview.currentCountry === \'hr\'" class="col-md-6 m-b-10 p-l-15">\n' +
    '              <div class="account-item-add app-dblue-card " ui-sref="orders.termDeposit">\n' +
    '                <div class="round-btn-container2">\n' +
    '                  <div class="round-btn2">\n' +
    '                    <i class="icon-r icon-add"></i>\n' +
    '                  </div>\n' +
    '                  <div class="round-btn-label2">\n' +
    '                    <b translate="accountsOverview.newTermDepositButtonLabel"></b>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="col-md-6 p-b-15"\n' +
    '                   ng-if="accountsOverview.currentCountry == \'sl\'">\n' +
    '                <div class="account-item-add app-dblue-card " ng-click="accountsOverview.openPayLifeBalancePage()">\n' +
    '                  <div class="round-btn-container2">\n' +
    '                    <div class="round-btn-label2" style="width: 100%">\n' +
    '                      <b translate="accountsOverview.masterCardStateButtonLabel_SLO"></b>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            <div class="col-md-6 p-b-15"\n' +
    '                 ng-if="accountsOverview.currentCountry != \'sr\' && accountsOverview.currentCountry != \'mne\' && accountsOverview.currentCountry != \'bh\'"\n' +
    '            ng-hide="accountsOverview.currentCountry == \'sl\' && APP_GLOBAL_SETTINGS.userSettings.isResident == \'N\'"\n' +
    '            >\n' +
    '              <div class="account-item-add app-dblue-card " ng-click="accountsOverview.openNewSavingOrMasterCard()">\n' +
    '                <div class="round-btn-container2">\n' +
    '\n' +
    '                  <div class="round-btn2">\n' +
    '                    <i class="icon-r icon-add"></i>\n' +
    '                  </div>\n' +
    '                  <div ng-switch="accountsOverview.currentCountry" class="round-btn-label2">\n' +
    '                    <b ng-switch-default translate="accountsOverview.newESavingAccountButtonLabel"></b>\n' +
    '                    <b ng-switch-when="sl" translate="accountsOverview.newSavingButtonLabel_SLO"></b>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <!-- END Add New Deposit and New eSaving Account Buttons -->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/acc-trans-detail-modal.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '    <tbody ng-hide="transaction.account.accountType.group==\'CardAccountTypes\' || transaction.countryCode==\'sr\'">\n' +
    '        <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && transaction.detail.purpose">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.description"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.detail.purpose}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr >\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.amount"></span></td>\n' +
    '            <td class="right-col">\n' +
    '                <span class="tridm-value-label outcome-tr" ng-if="transaction.debit"><span ng-if="accounts.countryCode == \'sr\'">- </span>{{transaction.amount | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '                <span class="tridm-value-label income-tr" ng-if="transaction.credit">{{transaction.amount | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.countryCode === \'hr\'">\n' +
    '            <td><span class="tlidm-key-label" translate="transactions.availableAmount"></span></td>\n' +
    '          <td><span class="tlidm-value-label">{{transaction.account.availableBalance | number:2}} {{transaction.account.currencySymbol}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && (transaction.credit && !transaction.creditorOrDebtorName || transaction.debit && !transaction.detail.payeeName)">\n' +
    '          <td class="left-col" ng-if="transaction.credit"><span class="tridm-key-label" translate="transactions.creditorName"></span></td>\n' +
    '          <td class="left-col" ng-if="transaction.debit"><span class="tridm-key-label" translate="transactions.debitorName"></span></td>\n' +
    '          <td class="right-col" ng-if="transaction.credit"><span class="tridm-value-label">{{transaction.creditorOrDebtorName }}</span></td>\n' +
    '          <td class="right-col" ng-if="transaction.debit"><span class="tridm-value-label">{{transaction.detail.payeeName}}</span></td>\n' +
    '        </tr>\n' +
    '      <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && !transaction.detail.payeeAddress1">\n' +
    '        <td class="left-col" ng-if="transaction.credit"><span class="tridm-key-label" translate="transactions.creditorAddress"></span></td>\n' +
    '        <td class="left-col" ng-if="transaction.debit"><span class="tridm-key-label" translate="transactions.debitorAddress"></span></td>\n' +
    '        <td class="right-col"><span class="tridm-value-label">{{transaction.detail.payeeAddress1}}</span></td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && transaction.detail.payeeCity">\n' +
    '        <td class="left-col"><span class="tridm-key-label" translate="transactions.payeeCity"></span></td>\n' +
    '        <td class="right-col"><span class="tridm-value-label">{{transaction.detail.payeeCity}}</span></td>\n' +
    '      </tr>\n' +
    '\n' +
    '        <tr ng-if="transaction.account.accountType.id !== \'SVGSUB\'"\n' +
    '            ng-hide="accounts.countryCode === \'sl\' && (!transaction.account.iban || !transaction.detail.hasOwnProperty(\'fromAccountNumber\')) ">\n' +
    '            <td ng-if="accounts.countryCode != \'bh\' && accounts.countryCode != \'sl\'" class="left-col"><span class="tridm-key-label" translate="transactions.ibanFrom"></span></td>\n' +
    '            <td  ng-if="accounts.countryCode == \'bh\'" class="left-col"><span class="tridm-key-label" translate="transactions.ibanFromBh"></span></td>\n' +
    '            <td  ng-if="accounts.countryCode == \'sl\'" class="left-col"><span class="tridm-key-label" translate="transactions.accountFrom"></span></td>\n' +
    '\n' +
    '            <!--<td ng-if="accounts.countryCode != \'bh\'" class="right-col"><span class="tridm-value-label">{{transaction.account.iban}}</span></td>-->\n' +
    '            <!--<td ng-if="accounts.countryCode == \'bh\' && transaction.debit" class="right-col"><span class="tridm-value-label">{{transaction.account.iban}}</span></td>-->\n' +
    '            <td ng-if="accounts.countryCode == \'bh\' && transaction.credit" class="right-col"><span class="tridm-value-label">{{transaction.detail.toAccountNumber}}</span></td>\n' +
    '            <td ng-if="transaction.debit" class="right-col"><span class="tridm-value-label">{{transaction.account.iban}}</span></td>\n' +
    '            <td ng-if="accounts.countryCode != \'bh\' && transaction.credit" class="right-col"><span class="tridm-value-label">{{transaction.detail.fromAccountNumber}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.account.accountType.id !== \'SVGSUB\'"\n' +
    '            ng-hide="accounts.countryCode === \'sl\' && !transaction.detail.hasOwnProperty(\'toAccountNumber\')">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.accountTo"></span></td>\n' +
    '          <td ng-if="accounts.countryCode != \'bh\'" class="right-col"><span class="tridm-value-label">{{transaction.detail.toAccountNumber}}</span></td>\n' +
    '          <td ng-if="accounts.countryCode == \'bh\' && transaction.debit" class="right-col"><span class="tridm-value-label">{{transaction.detail.toAccountNumber}}</span></td>\n' +
    '          <td ng-if="accounts.countryCode == \'bh\' && transaction.credit" class="right-col"><span class="tridm-value-label">{{transaction.account.iban}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.account.accountType.id === \'SVGSUB\'"  ng-hide="accounts.countryCode === \'sl\' && !transaction.hasOwnProperty(\'fromAccountNumber\')">\n' +
    '          <td class="left-col"><span class="tridm-key-label" translate="transactions.accountFrom"></span></td>\n' +
    '          <td class="right-col"><span class="tridm-value-label">{{transaction.fromAccountNumber}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.account.accountType.group==\'SavingAccountTypes\' && transaction.account.accountType.id ===\'SVGSUB\'"\n' +
    '            ng-hide="accounts.countryCode === \'sl\' && !transaction.hasOwnProperty(\'toAccountNumber\') && transaction.debit">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.accountTo"></span></td>\n' +
    '            <td class="right-col">\n' +
    '              <span ng-if="transaction.toAccountNumber" class="tridm-value-label">{{transaction.toAccountNumber}}</span>\n' +
    '              <span ng-if="!transaction.toAccountNumber && accounts.countryCode === \'sl\' && transaction.credit" class="tridm-value-label">{{accounts.selectedAccount.iban}}</span>\n' +
    '              <span ng-if="!transaction.toAccountNumber && accounts.countryCode === \'sl\' && transaction.debit" class="tridm-value-label">{{transaction.toAccountNumber}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.referenceNumber">\n' +
    '          <td class="left-col"><span class="tridm-key-label" translate="transactions.referenceNumber"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.referenceNumber}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.bookingDate">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.bookingDate"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.bookingDate | date:\'shortDate\'}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.valueDate">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.valueDate"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.valueDate | date:\'shortDate\'}}</span></td>\n' +
    '        </tr>\n' +
    '        <!-- Transaction confirmation -->\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <button type="button" translate="dashboard.complaint" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                    data-ng-click = "accounts.navigateToReclamationForm(transaction);">\n' +
    '            </button>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '            <button ng-hide="accounts.countryCode != \'hr\' || transaction.account.accountType.group ==\'SavingAccountTypes\' || transaction.account.accountType.group==\'DepositAccountTypes\' || transaction.account.accountType.group==\'LoanAccountType\'"  type="button" translate="dashboard.confirmation" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                    data-ng-click = "accounts.downloadTransactionReport(transaction);">\n' +
    '            </button>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '\n' +
    '    <!--za tekuci SRB-->\n' +
    '    <tbody ng-hide="transaction.account.accountType.group==\'CardAccountTypes\' || transaction.countryCode!=\'sr\'">\n' +
    '        <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && !transaction.detail.purpose">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.description"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.detail.purpose}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.amount"></span></td>\n' +
    '            <td class="right-col">\n' +
    '                <span class="tridm-value-label outcome-tr" ng-if="transaction.debit"><span ng-if="accounts.countryCode == \'sr\'">-</span> {{transaction.amount | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '                <span class="tridm-value-label income-tr" ng-if="transaction.credit">{{transaction.amount | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.countryCode === \'hr\'">\n' +
    '          <td class="left-col"><span class="tridm-key-label" translate="transactions.availableAmount"></span></td>\n' +
    '          <td class="right-col"><span class="tridm-value-label">{{transaction.account.availableBalance | number:2}}</span></td>\n' +
    '        </tr>\n' +
    '      <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && !transaction.detail.payeeName">\n' +
    '        <td class="left-col" ng-if="transaction.credit"><span class="tridm-key-label" translate="transactions.creditorName"></span></td>\n' +
    '        <td class="left-col" ng-if="transaction.debit"><span class="tridm-key-label" translate="transactions.debitorName"></span></td>\n' +
    '        <td class="right-col"><span class="tridm-value-label">{{transaction.detail.payeeName}}</span></td>\n' +
    '      </tr>\n' +
    '      <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && !transaction.detail.payeeAddress1">\n' +
    '        <td class="left-col" ng-if="transaction.credit"><span class="tridm-key-label" translate="transactions.creditorAddress"></span></td>\n' +
    '        <td class="left-col" ng-if="transaction.debit"><span class="tridm-key-label" translate="transactions.debitorAddress"></span></td>\n' +
    '        <td class="right-col"><span class="tridm-value-label">{{transaction.detail.payeeAddress1}}</span></td>\n' +
    '      </tr>\n' +
    '        <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && !transaction.detail.hasOwnProperty(\'toAccountNumber\')">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.accountNumber"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.detail.toAccountNumber}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.referenceNumber">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.referenceNumber"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.referenceNumber}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.bookingDate">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.date"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.bookingDate | date:\'shortDate\'}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.valueDate">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.valueDate"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.valueDate | date:\'shortDate\'}}</span></td>\n' +
    '        </tr>\n' +
    '        <!-- Transaction confirmation -->\n' +
    '        <tr>\n' +
    '          <td>\n' +
    '            <button type="button" translate="dashboard.complaint" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                    data-ng-click = "accounts.navigateToReclamationForm(transaction);">\n' +
    '            </button>\n' +
    '          </td>\n' +
    '          <td>\n' +
    '              <button type="button" translate="transactions.retrieval" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                      ng-if="transaction.retrieval && transaction.retrieval === true"\n' +
    '                      ng-click="accounts.retrievalRequest(transaction)">\n' +
    '              </button>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '\n' +
    '    </tbody>\n' +
    '    <!--za card cro i srb-->\n' +
    '    <tbody ng-hide="transaction.account.accountType.group!=\'CardAccountTypes\'">\n' +
    '        <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && !transaction.detail.purpose">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.description"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.detail.purpose}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr >\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.amount"></span></td>\n' +
    '            <td class="right-col">\n' +
    '              <span class="tridm-value-label outcome-tr" ng-if="transaction.debit"><span ng-if="accounts.countryCode == \'sr\'">- </span>{{transaction.amount | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '              <span class="tridm-value-label income-tr" ng-if="transaction.credit">{{transaction.amount | number:2}} {{transaction.currencySymbol}}</span>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '      <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <td class="left-col" ng-if="transaction.credit"><span class="tridm-key-label" translate="transactions.creditorName"></span></td>\n' +
    '        <td class="left-col" ng-if="transaction.debit"><span class="tridm-key-label" translate="transactions.debitorName"></span></td>\n' +
    '        <td class="right-col"><span class="tridm-value-label">{{transaction.detail.payeeName}}</span></td>\n' +
    '      </tr>\n' +
    '      <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <td class="left-col" ng-if="transaction.credit"><span class="tridm-key-label" translate="transactions.creditorAddress"></span></td>\n' +
    '        <td class="left-col" ng-if="transaction.debit"><span class="tridm-key-label" translate="transactions.debitorAddress"></span></td>\n' +
    '        <td class="right-col"><span class="tridm-value-label">{{transaction.detail.payeeAddress1}}</span></td>\n' +
    '      </tr>\n' +
    '        <tr ng-hide="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\' && !transaction.account.hasOwnProperty(\'accountNumber\')">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.accountNumber"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.account.accountNumber}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.card"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.account.accountType.description}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.referenceNumber && transaction.referenceNumber != \'0\'">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.referenceNumber"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.referenceNumber}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.bookingDate">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.bookingDate"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.bookingDate | date:\'shortDate\'}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.valueDate">\n' +
    '            <td class="left-col"><span class="tridm-key-label" translate="transactions.valueDate"></span></td>\n' +
    '            <td class="right-col"><span class="tridm-value-label">{{transaction.valueDate | date:\'shortDate\'}}</span></td>\n' +
    '        </tr>\n' +
    '        <tr ng-if="transaction.hasOwnProperty(\'datePeriodStart\') && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '          <td class="left-col"><span class="tridm-key-label" translate="transactions.statementPeriod"></span></td>\n' +
    '          <td class="right-col"><span class="tridm-value-label">{{transaction.datePeriodStart | date:\'shortDate\'}}</span></td>\n' +
    '        </tr>\n' +
    '        <!-- Transaction confirmation -->\n' +
    '        <tr>\n' +
    '          <td class="left-col"></td>\n' +
    '          <td class="right-col">\n' +
    '            <button type="button" translate="dashboard.complaint" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"\n' +
    '                    data-ng-click = "accounts.navigateToReclamationForm(transaction);">\n' +
    '            </button>\n' +
    '          </td>\n' +
    '          <!--<td>-->\n' +
    '            <!--<button ng-hide="accounts.countryCode != \'hr\'" type="button" translate="dashboard.confirmation" class="btn btn-primary app-btn-blue btn-sm m-r-5 m-l-5 f-uppercase"-->\n' +
    '                    <!--data-ng-click = "accounts.downloadTransactionReport(transaction);">-->\n' +
    '            <!--</button>-->\n' +
    '          <!--</td>-->\n' +
    '        </tr>\n' +
    '    </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/acc-reservation-details.tpl.html',
    '<table class="table table-transparent table-responsive">\n' +
    '  <tbody>\n' +
    '  <tr>\n' +
    '    <td class="left-col"><span class="tridm-key-label" translate="transactions.description"></span></td>\n' +
    '    <td class="right-col"><span class="tridm-value-label">{{reservation.description}}</span></td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td class="left-col"><span class="tridm-key-label" translate="transactions.amount"></span></td>\n' +
    '    <td class="right-col"><span class="tridm-value-label">{{reservation.amount}} BAM</span></td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td class="left-col"><span class="tridm-key-label" translate="reservations.originAmount"></span></td>\n' +
    '    <td class="right-col"><span class="tridm-value-label">{{reservation.sourceAmount}} {{reservation.sourceCurrency}}</span></td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td class="left-col"><span class="tridm-key-label" translate="reservations.reservationDate"></span></td>\n' +
    '    <td class="right-col"><span class="tridm-value-label">{{reservation.reservationDate | date:\'shortDate\'}}</span></td>\n' +
    '  </tr>\n' +
    '  <tr>\n' +
    '    <td class="left-col"><span class="tridm-key-label" translate="reservations.type"></span></td>\n' +
    '    <td class="right-col"><span class="tridm-value-label">{{reservation.transactionType}}</span></td>\n' +
    '  </tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/SavingAccountTypes-detail.tpl.html',
    '<!-- Saving account details -->\n' +
    '<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <!-- =============== -->\n' +
    '  <!-- SLOVENIA -->\n' +
    '  <!-- =============== -->\n' +
    '  <div ng-switch-when="sl">\n' +
    '    <div class="m-b-10">\n' +
    '      <span ng-if="accounts.selectedAccount.hasOwnProperty(\'availableBalance\')">\n' +
    '          <span class="account-header-value white-text-block">\n' +
    '            {{accounts.selectedAccount.balance | currency:""}} {{accounts.selectedAccount.currencySymbol}}\n' +
    '          </span>\n' +
    '         <hr class="account-header-line"/>\n' +
    '          <span class="m-t-neg-15 white-text-block" translate="accounts.savedFunds"></span>\n' +
    '       </span>\n' +
    '      <!-- Details -->\n' +
    '      <div ng-show="accounts.isAccountDetailsOpen">\n' +
    '        <div class="row p-t-20">\n' +
    '          <div class="col-xs-6 col-md-4 p-b-20">\n' +
    '            <span class="f-20 white-text-block">{{accounts.selectedAccount.availableBalance|currency:""}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '            <span class="white-text-block" translate="accounts.accCurrentBalance_SLO"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row p-t-20">\n' +
    '          <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '            <span\n' +
    '              class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '            <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositStartDate">\n' +
    '            <span\n' +
    '              class="f-20 white-text-block">{{accounts.selectedAccount.depositAccount.depositStartDate | date:\'shortDate\'}}</span>\n' +
    '            <span class="white-text-block" translate="accounts.openingDate"></span>\n' +
    '          </div>\n' +
    '          <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositDueDate">\n' +
    '            <span\n' +
    '              class="f-20 white-text-block">{{accounts.selectedAccount.depositAccount.depositDueDate | date:\'shortDate\'}}</span>\n' +
    '            <span class="white-text-block" translate="accounts.accDepositEndDate_SLO"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row p-t-20">\n' +
    '            <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.contractAmount && !accounts.selectedAccount.depositAccount.isShortTermSaving">\n' +
    '            <span class="f-20 white-text-block">{{accounts.selectedAccount.depositAccount.contractAmount | currency:""}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '            <span class="white-text-block" translate="accounts.minSavingBalance"></span>\n' +
    '          </div>\n' +
    '\n' +
    '            <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.minimunBalance && accounts.selectedAccount.depositAccount.isShortTermSaving">\n' +
    '                <span class="f-20 white-text-block">{{accounts.selectedAccount.depositAccount.minimunBalance | currency:""}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '                <span class="white-text-block" translate="accounts.minSavingBalance2"></span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="col-xs-6 col-md-4 p-b-20" ng-if="!accounts.selectedAccount.depositAccount.isShortTermSaving">\n' +
    '                <span class="f-20 white-text-block" ng-if="accounts.selectedAccount.depositAccount.depositInterestAmount">{{accounts.selectedAccount.depositAccount.depositInterestAmount | currency:""}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '                <span class="f-20 white-text-block" ng-if="!accounts.selectedAccount.depositAccount.depositInterestAmount">{{0|number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '                <span class="white-text-block" translate="accounts.interestToDate"></span>\n' +
    '            </div>\n' +
    '          <!--<div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositEndDate">-->\n' +
    '            <!--<span class="f-20 white-text-block">-->\n' +
    '               <!--{{accounts.selectedAccount.depositAccount.depositEndDate | date:\'shortDate\'}}</span>-->\n' +
    '            <!--<span class="white-text-block" translate="accounts.accDepositEndDate_SLO"></span>-->\n' +
    '          <!--</div>-->\n' +
    '          <div class="col-xs-12 p-b-20" ng-if="accounts.selectedAccount.depositAccount.destinationAccount && !accounts.selectedAccount.depositAccount.isShortTermSaving">\n' +
    '            <span class="f-20 white-text-block cursor-pointer" >\n' +
    '              {{accounts.selectedAccount.depositAccount.destinationAccount | formatIban}}\n' +
    '            </span>\n' +
    '            <span class="white-text-block" translate="accounts.destinationAccount_SLO"></span>\n' +
    '          </div>\n' +
    '          <!--<div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.sendingType">-->\n' +
    '            <!--<span-->\n' +
    '              <!--class="f-20 white-text-block">{{accounts.selectedAccount.depositAccount.sendingType }}</span>-->\n' +
    '            <!--<span class="white-text-block" translate="accounts.statementDeliveryMethod"></span>-->\n' +
    '          <!--</div>-->\n' +
    '\n' +
    '          <div ng-if="accounts.selectedAccount.depositAccount.isShortTermSaving == false" class="col-xs-6 col-md-4 p-b-20">\n' +
    '            <span class="f-20 white-text-block">\n' +
    '              <span ng-if="accounts.selectedAccount.depositAccount.demarcationOfInterests" translate="alert.yes"></span>\n' +
    '              <span ng-if="!accounts.selectedAccount.depositAccount.demarcationOfInterests" translate="alert.no"></span>\n' +
    '            </span>\n' +
    '            <span class="white-text-block" translate="accounts.annualAssignmentOfInterests"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row p-t-20">\n' +
    '          <div class="col-xs-12 col-md-12 p-b-20" ng-if="accounts.selectedAccount.depositAccount.interestDescription">\n' +
    '            <span\n' +
    '              class="f-20 white-text-block">{{accounts.selectedAccount.depositAccount.interestDescription }}  %</span>\n' +
    '            <span class="white-text-block" translate="accounts.interestRate"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- =============== -->\n' +
    '  <!-- Other countries -->\n' +
    '  <!-- =============== -->\n' +
    '  <div ng-switch-default>\n' +
    '    <div class="m-b-10">\n' +
    '    <span class="account-header-value white-text-block"\n' +
    '          ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '      <hr class="account-header-line"/>\n' +
    '      <span class="m-t-neg-15 white-text-block" translate="accounts.accCurrentBalance"></span>\n' +
    '\n' +
    '      <div class="row account-header-bottom">\n' +
    '        <div class="col-xs-12 col-md-4">\n' +
    '      <span class="f-20 white-text-block"\n' +
    '            ng-bind="(accounts.selectedAccount.availableBalance |number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '          <span class="white-text-block" translate="accounts.accCurrentBalance"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row p-t-20" ng-show="accounts.isAccountDetailsOpen">\n' +
    '        <!-- <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositStartDate">\n' +
    '          <span class="f-20 white-text-block">\n' +
    '            {{accounts.selectedAccount.depositAccount.depositStartDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accStartDate"></span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositEndDate">\n' +
    '          <span class="f-20 white-text-block">\n' +
    '            {{accounts.selectedAccount.depositAccount.depositEndDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accMaturityDate"></span>\n' +
    '        </div>-->\n' +
    '\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '          <span\n' +
    '            class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">\n' +
    '          <span class="f-20 white-text-block">{{\'accounts.\'+accounts.selectedAccount.status | translate}}</span>\n' +
    '          <span class="white-text-block" translate="ebook.status"></span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-4 p-b-20"\n' +
    '             ng-if="accounts.selectedAccount.parentAccount.iban && accounts.countryCode != \'bh\'">\n' +
    '          <span class="f-20 white-text-block">{{accounts.selectedAccount.parentAccount.iban}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accParentAccountIban"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/LoanAccountType-detail.tpl.html',
    '<!-- Loan details -->\n' +
    '<div class="m-b-10">\n' +
    '  <span ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '  <span ng-switch-when="hr" class="account-header-value white-text-block" ng-bind="(accounts.selectedAccount.loanAccount.loanAmount | number:2) + \' \' + (accounts.selectedAccount.loanAccount.installmentCurrencySymbol)"></span>\n' +
    '  <span ng-switch-when="sl" class="account-header-value white-text-block" ng-bind="(accounts.selectedAccount.balance | number:2) + \' EUR\'"></span>\n' +
    '  <span ng-switch-default ng-if="accounts.selectedAccount.balance" class="account-header-value white-text-block" ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '  </span>\n' +
    '\n' +
    '  <hr ng-if="(!accounts.countryCode===\'hr\' && accounts.selectedAccount.loanAccount.loanAmount) || (accounts.countryCode != \'hr\' && accounts.selectedAccount.balance)" class="account-header-line" />\n' +
    '  <span ng-if="accounts.countryCode===\'hr\'" class="m-t-neg-15 white-text-block" translate="accounts.accLoanAmount"></span>\n' +
    '  <span ng-if="accounts.countryCode!=\'hr\' && accounts.selectedAccount.balance" class="m-t-neg-15 white-text-block" translate="accounts.accLoanBalance"></span>\n' +
    '  <!-- provjeriti da li treba ovaj podatak\n' +
    '<span class="account-header-value white-text-block"\n' +
    'ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.installmentCurrencySymbol)"></span>\n' +
    '<hr class="account-header-line"/>\n' +
    '<span class="m-t-neg-15 white-text-block" translate="accounts.accLoanBalance"></span> -->\n' +
    '\n' +
    '  <div class="account-header-bottom">\n' +
    '    <div class="row" ng-class="{\'p-t-50\': !accounts.selectedAccount.loanAccount.installmentAmount }">\n' +
    '      <div ng-if="accounts.selectedAccount.loanAccount.installmentAmount" class="col-xs-12 col-md-4 m-t-10">\n' +
    '        <span class="f-20 white-text-block" ng-if="accounts.countryCode === \'hr\' || accounts.countryCode === \'sl\'"\n' +
    '              ng-bind="(accounts.selectedAccount.loanAccount.installmentAmount | number:2) + \' \' + (accounts.selectedAccount.loanAccount.installmentCurrencySymbol)">\n' +
    '        </span>\n' +
    '        <span class="f-20 white-text-block" ng-if="accounts.countryCode != \'hr\' && accounts.countryCode != \'sl\'"\n' +
    '              ng-bind="(accounts.selectedAccount.loanAccount.installmentAmount | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)">\n' +
    '        </span>\n' +
    '        <span class="white-text-block" translate="accounts.accAnnuity"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-t-10" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '          <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.interestRegularString}}</span>\n' +
    '          <span class="white-text-block"><span translate="accounts.accAnnuityConverted"></span> {{accounts.interestRate}}</span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-md-4" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <div ng-if="accounts.showConvertedLoansFields">\n' +
    '          <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.installmentInLocalCurrency | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '          <span class="white-text-block"><span translate="accounts.accAnnuityConverted"></span> {{accounts.defaultCurrency}}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="p-t-20" ng-show="accounts.isAccountDetailsOpen">\n' +
    '\n' +
    '    <div class="row" ng-show="accounts.countryCode===\'hr\'">\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.totalMatureDebit != undefind">\n' +
    '        <span class="f-20  white-text-block" ng-if="accounts.countryCode===\'hr\'">{{accounts.selectedAccount.loanAccount.totalMatureDebit | number:2}} {{accounts.selectedAccount.loanAccount.installmentCurrencySymbol}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accDueAmount"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.showConvertedLoansFields">\n' +
    '        <span class="f-20  white-text-block">{{accounts.selectedAccount.loanAccount.totalMatureInLocalCurrency | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '        <span class="white-text-block"><span translate="accounts.accTotalMatureConverted"></span>{{accounts.defaultCurrency}}</span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.notMatureCapital">\n' +
    '        <span class="f-20 white-text-block" ng-if="accounts.countryCode===\'hr\'">{{accounts.selectedAccount.loanAccount.notMatureCapital | number:2}} {{accounts.selectedAccount.loanAccount.installmentCurrencySymbol}}</span>\n' +
    '        <span class="f-20 white-text-block" ng-if="accounts.countryCode!=\'hr\'">{{accounts.selectedAccount.loanAccount.notMatureCapital | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accNotMatureCapital"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.showConvertedLoansFields">\n' +
    '        <span class="f-20  white-text-block">{{accounts.selectedAccount.loanAccount.notMatureCapitalInLocalCurrency | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '        <span class="white-text-block"><span translate="accounts.accNotMatureCapitalConverted"></span>{{accounts.defaultCurrency}}</span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.loanContractNumber">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.loanContractNumber}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accContractNumber"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.nextInstallmentDate">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.nextInstallmentDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accNewDebitDate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.dateApproved">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.dateApproved | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accDisbursementDate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.dueDate">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.dueDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accMaturityDate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '        <span ng-if="accounts.selectedAccount.balanceLastChangedDate" class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.interestRegular">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.interestRegular | number:2}} %\n' +
    '<!--          <span ng-if="accounts.countryCode===\'hr\'">{{accounts.selectedAccount.loanAccount.installmentCurrencySymbol}}</span>\n' +
    '          <span ng-if="accounts.countryCode!=\'hr\'">%</span></span>-->\n' +
    '        </span>\n' +
    '        <span class="white-text-block" translate="accounts.accMatureInterest"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.installmentsNumber">\n' +
    '        <span ng-if="accounts.selectedAccount.loanAccount.installmentsNumber" class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.installmentsNumber}}</span>\n' +
    '        <span ng-if="!accounts.selectedAccount.loanAccount.installmentsNumber" class="f-20 white-text-block">0</span>\n' +
    '        <span class="white-text-block" translate="accounts.accInstallmentNumber"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.installmentsPaidNumber" >\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.installmentsPaidNumber}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accInstallmentPaidNumber"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" data-ng-if="accounts.selectedAccount.loanAccount.installmentRemain" >\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.installmentRemain}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accInstallmentsRemain"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- SRB and MNE-->\n' +
    '    <div ng-show="accounts.countryCode != \'hr\'" class="row">\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.dateApproved">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.dateApproved | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accDisbursementDate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.loanAmount">\n' +
    '        <span class="f-20 white-text-block" ng-if="accounts.countryCode != \'sl\'">{{accounts.selectedAccount.loanAccount.loanAmount | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '        <span class="f-20 white-text-block" ng-if="accounts.countryCode == \'sl\'">{{accounts.selectedAccount.loanAccount.loanAmount | number:2}} {{accounts.selectedAccount.loanAccount.loanAmountCurrencySymbol}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accLoanAmount"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.nextInstallmentDate">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.nextInstallmentDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accNewDebitDate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.interestRegular">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.interestRegular | number:2}}\n' +
    '          <span ng-if="accounts.countryCode===\'hr\'">{{accounts.selectedAccount.loanAccount.installmentCurrencySymbol}}</span>\n' +
    '          <span ng-if="accounts.countryCode!=\'hr\'">%</span></span>\n' +
    '        <span class="white-text-block" translate="accounts.accMatureInterest"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.totalMatureDebit">\n' +
    '      <span class="f-20  white-text-block" ng-if="accounts.countryCode != \'bh\'">{{accounts.selectedAccount.loanAccount.totalMatureDebit | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="f-20  white-text-block" ng-if="accounts.countryCode == \'bh\'">{{accounts.selectedAccount.loanAccount.depositAmount | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accDueAmount"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '        <span ng-if="accounts.selectedAccount.balanceLastChangedDate" class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" data-ng-if="accounts.selectedAccount.loanAccount.installmentRemain" >\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.installmentRemain }}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accInstallmentsRemain"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.loanContractNumber">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.loanContractNumber}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accContractNumber"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.dueDate">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.dueDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accMaturityDate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.installmentsNumber">\n' +
    '        <span ng-if="accounts.selectedAccount.loanAccount.installmentsNumber" class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.installmentsNumber}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accInstallmentNumber"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.loanAccount.installmentsPaidNumber" >\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.loanAccount.installmentsPaidNumber}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accInstallmentPaidNumber"></span>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/GiroAccount-detail.tpl.html',
    '<!-- Giro account details -->\n' +
    '<div class="m-b-10">\n' +
    '  <span class="account-header-value white-text-block" ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '  <hr class="account-header-line" />\n' +
    '  <span class="m-t-neg-15 white-text-block" translate="accounts.accCurrentBalance"></span>\n' +
    '\n' +
    '  <div class="row account-header-bottom">\n' +
    '    <div class="col-xs-12 col-md-4">\n' +
    '      <span class="f-20 white-text-block" ng-bind="(accounts.selectedAccount.availableBalance|number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '      <span class="white-text-block" translate="accounts.accAvailableBalance"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row p-t-20" ng-show="accounts.isAccountDetailsOpen">\n' +
    '\n' +
    '    <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.reservedAmount" ng-show="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.reservedAmount|number:2}} {{accounts.selectedAccount.currencySymbol}}\n' +
    '      </span>\n' +
    '      <span class="white-text-block" translate="accounts.accReservations"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.balanceLastChangedDate|date:\'shortDate\'}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accDateLastChanged"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/DepositAccountTypes-detail.tpl.html',
    '<!-- Deposit account details -->\n' +
    '<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '\n' +
    '\n' +
    '  <!-- Deposit account details - OTHER-->\n' +
    '  <div class="m-b-10" ng-switch-default>\n' +
    '    <span class="account-header-value white-text-block"\n' +
    '          ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '    <hr class="account-header-line"/>\n' +
    '    <span class="m-t-neg-15 white-text-block size-balance" translate="accounts.accCurrentBalance"></span>\n' +
    '\n' +
    '    <div class="row account-header-bottom">\n' +
    '      <div class="col-xs-12 col-md-4">\n' +
    '        <span class="f-20 white-text-block"\n' +
    '              ng-bind="(accounts.selectedAccount.depositAccount.depositPrincipal |number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '        <span class="white-text-block size-balance" translate="accounts.accDepositPrincipal"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row p-t-20" ng-show="accounts.isAccountDetailsOpen">\n' +
    '\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '        <span\n' +
    '          class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">\n' +
    '        <span class="f-20 white-text-block">{{\'accounts.\'+accounts.selectedAccount.status | translate}}</span>\n' +
    '        <span class="white-text-block" translate="ebook.status"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositInterest">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.depositAccount.depositInterest | number:2}}%\n' +
    '      </span>\n' +
    '        <span class="white-text-block" translate="accounts.accDepositInterestRate"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositStartDate">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.depositAccount.depositStartDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accDepositStartDate"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositEndDate">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.depositAccount.depositEndDate | date:\'shortDate\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accDepositEndDate"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <!--<div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositTypeExternal">\n' +
    '        <span class="f-20 white-text-block">\n' +
    '          {{accounts.selectedAccount.depositAccount.depositTypeExternal}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accDepositTypeExternal"></span>\n' +
    '      </div>-->\n' +
    '\n' +
    '      <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositIdExternal">\n' +
    '      <span class="f-20 white-text-block cursor-pointer" data-ng-click="accounts.downloadContract()">\n' +
    '        {{accounts.selectedAccount.depositAccount.depositIdExternal}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accContractNumber"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- ================================ -->\n' +
    '  <!-- Deposit account details - SLOVENIA-->\n' +
    '  <!-- ================================ -->\n' +
    '\n' +
    '  <div class="m-b-10" ng-switch-when="sl">\n' +
    '    <span class="account-header-value white-text-block"\n' +
    '          ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '    <hr class="account-header-line"/>\n' +
    '    <span class="m-t-neg-15 white-text-block size-balance" translate="accounts.accCurrentBalance"></span>\n' +
    '\n' +
    '    <div class="row account-header-bottom">\n' +
    '      <div class="col-xs-12 col-md-4">\n' +
    '        <span class="f-20 white-text-block"\n' +
    '              ng-bind="(accounts.selectedAccount.depositAccount.depositPrincipal |number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '        <span class="white-text-block size-balance" translate="accounts.accDepositPrincipal"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-show="accounts.isAccountDetailsOpen">\n' +
    '      <div class="row p-t-20">\n' +
    '        <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.hasOwnProperty(\'depositInterestAmount\')">\n' +
    '            <span class="f-20 white-text-block cursor-pointer">\n' +
    '              {{accounts.selectedAccount.depositAccount.depositInterestAmount | number:2}} {{accounts.selectedAccount.currencySymbol}}\n' +
    '            </span>\n' +
    '          <span class="white-text-block" translate="accounts.interestToDate"></span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '        <span\n' +
    '          class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositInterest">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.depositAccount.depositInterest | number:2}}%\n' +
    '      </span>\n' +
    '          <span class="white-text-block" translate="accounts.accDepositInterestRate"></span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositStartDate">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.depositAccount.depositStartDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accDepositStartDate"></span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositEndDate">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        {{accounts.selectedAccount.depositAccount.depositEndDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accDepositEndDate_SLO"></span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div>\n' +
    '\n' +
    '          <!--<div class="col-xs-12 col-md-4 p-b-20"-->\n' +
    '               <!--ng-if="accounts.selectedAccount.depositAccount.depositIdExternalExtension ">-->\n' +
    '        <!--<span class="f-20 white-text-block cursor-pointer">-->\n' +
    '          <!--{{accounts.selectedAccount.depositAccount.depositIdExternalExtension }}</span>-->\n' +
    '            <!--<span class="white-text-block" translate="accounts.destinationAccount"></span>-->\n' +
    '          <!--</div>-->\n' +
    '          <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">\n' +
    '            <span class="f-20 white-text-block">{{\'accounts.\'+accounts.selectedAccount.status | translate}}</span>\n' +
    '            <span class="white-text-block" translate="ebook.status"></span>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-xs-12 col-md-4 p-b-20"\n' +
    '               ng-if="accounts.selectedAccount.depositAccount.depositProlongationNumLeft">\n' +
    '        <span class="f-20 white-text-block cursor-pointer">\n' +
    '          {{accounts.selectedAccount.depositAccount.depositProlongationNumLeft}}</span>\n' +
    '            <span class="white-text-block" translate="accounts.depositProlongationNumLeft"></span>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.depositAccount.depositPeriod">\n' +
    '        <span class="f-20 white-text-block cursor-pointer">\n' +
    '          {{accounts.selectedAccount.depositAccount.depositPeriod}} <span translate="accounts.days"></span>\n' +
    '        </span>\n' +
    '            <span class="white-text-block" translate="accounts.bindingSpan"></span>\n' +
    '          </div>\n' +
    '          <div class="col-xs-12 p-b-20" ng-if="accounts.selectedAccount.depositAccount.destinationAccount">\n' +
    '            <span class="f-20 white-text-block" >\n' +
    '              {{accounts.selectedAccount.depositAccount.destinationAccount | formatIban}}\n' +
    '            </span>\n' +
    '            <span class="white-text-block" translate="accounts.destinationAccount_SLO"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row p-t-20">\n' +
    '        <div class="col-xs-12 col-md-12 p-b-20" ng-if="accounts.selectedAccount.depositAccount.extensionType">\n' +
    '      <span class="f-20 white-text-block cursor-pointer">\n' +
    '        {{accounts.selectedAccount.depositAccount.extensionType}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.extensionType"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/CurrentAccount-detail.tpl.html',
    '<!-- Current account details -->\n' +
    '<div class="m-b-10">\n' +
    '  <span class="account-header-value white-text-block"\n' +
    '        ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '  <hr class="account-header-line"/>\n' +
    '  <span class="m-t-neg-15 white-text-block" translate="accounts.accCurrentBalance"></span>\n' +
    '\n' +
    '  <div class="row account-header-bottom">\n' +
    '    <div class="col-xs-12 col-md-4" >\n' +
    '    <span class="f-20 white-text-block"\n' +
    '          ng-bind="(accounts.selectedAccount.availableBalance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '      <span class="white-text-block" translate="accounts.accAvailableBalance"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row p-t-20" ng-show="accounts.isAccountDetailsOpen">\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '      <span class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '    </div>\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">\n' +
    '      <span class="f-20 white-text-block">{{\'accounts.\'+accounts.selectedAccount.status | translate}}</span>\n' +
    '      <span class="white-text-block" translate="ebook.status"></span>\n' +
    '    </div>\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.showField">\n' +
    '      <span class="f-20 white-text-block" ng-if="accounts.selectedAccount.limit">{{accounts.selectedAccount.limit|number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="f-20 white-text-block" ng-if="!accounts.selectedAccount.limit">0,00 {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accOverdraftLimit"></span>\n' +
    '    </div>\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.showField">\n' +
    '      <span class="f-20 white-text-block" ng-if="accounts.selectedAccount.limitValidUntilDate">{{accounts.selectedAccount.limitValidUntilDate | date:\'shortDate\'}}</span>\n' +
    '      <span class="f-20 white-text-block" ng-if="!accounts.selectedAccount.limitValidUntilDate && APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">-</span>\n' +
    '      <span class="f-20 white-text-block" ng-if="!accounts.selectedAccount.limitValidUntilDate && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'" translate="accounts.untilRevocation"></span>\n' +
    '      <span class="white-text-block" translate="accounts.accOverdraftLimitDue"></span>\n' +
    '    </div>\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.limitAmountATM  && accounts.selectedAccount.currencySymbol == \'EUR\'" ng-show="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <span class="f-20 white-text-block">{{accounts.selectedAccount.limitAmountATM | currency:""}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.limitAmountATM"></span>\n' +
    '    </div>\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.limitAmountPOS && accounts.selectedAccount.currencySymbol == \'EUR\'" ng-show="APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '      <span class="f-20 white-text-block">{{accounts.selectedAccount.limitAmountPOS | currency:""}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.limitAmountPOS"></span>\n' +
    '    </div>\n' +
    '     <!-- <div class="col-xs-12 col-md-4 p-b-20">\n' +
    '       <span class="f-20 white-text-block"  ng-if="accounts.selectedAccount.cardNumber">{{accounts.selectedAccount.cardNumber}}</span>\n' +
    '       <span class="f-20 white-text-block"  ng-if="!accounts.selectedAccount.cardNumber">-</span>\n' +
    '       <span class="white-text-block" translate="accounts.accCardNumber"></span>\n' +
    '    </div>-->\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.showField" ng-show="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '      <span class="f-20 white-text-block" ng-if="accounts.selectedAccount.reservedAmount && !accounts.selectedAccount.planedDebit">{{accounts.selectedAccount.reservedAmount | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="f-20 white-text-block" ng-if="accounts.selectedAccount.planedDebit">{{accounts.selectedAccount.planedDebit | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="f-20 white-text-block" ng-if="!accounts.selectedAccount.reservedAmount && !accounts.selectedAccount.planedDebit">0,00 {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accReservations"></span>\n' +
    '    </div>\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.numberOfPaymentsInQueue">\n' +
    '      <span class="f-20 white-text-block ng-binding ng-scope">{{accounts.selectedAccount.numberOfPaymentsInQueue}}</span>\n' +
    '      <span class="white-text-block ng-scope" translate="accounts.accPaymInQue">Payments in queue</span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('accounts/CardAccountTypes-detail.tpl.html',
    '<!-- Card account details -->\n' +
    '<div class="m-b-10">\n' +
    '  <div ng-if="accounts.selectedAccount.hasOwnProperty(\'balance\')">\n' +
    '    <span class="account-header-value white-text-block"\n' +
    '          ng-bind="(accounts.selectedAccount.balance | number:2) + \' \' + (accounts.selectedAccount.currencySymbol)"></span>\n' +
    '    <hr class="account-header-line"/>\n' +
    '    <span class="m-t-neg-15 white-text-block" translate="accounts.accBalance"></span>\n' +
    '  </div>\n' +
    '  <div ng-if="!accounts.selectedAccount.hasOwnProperty(\'balance\') && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '    <span class="account-header-value white-text-block">\n' +
    '      {{0 | number:2 }} {{accounts.selectedAccount.currencySymbol}}\n' +
    '    </span>\n' +
    '    <hr class="account-header-line"/>\n' +
    '    <span class="m-t-neg-15 white-text-block" translate="accounts.accBalance"></span>\n' +
    '  </div>\n' +
    '  <div class="row account-header-bottom" ng-show="!accounts.isAccountDetailsOpen"\n' +
    '       ng-class="{\'m-b-40\': !accounts.selectedAccount.hasOwnProperty(\'availableBalance\')}">\n' +
    '    <div ng-if="accounts.selectedAccount.hasOwnProperty(\'availableBalance\')" class="col-xs-12 col-md-4">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '      {{accounts.selectedAccount.availableBalance | number:2}}\n' +
    '      {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accAvailableToSpend"></span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <span ng-show="accounts.isAccountDetailsOpen && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'sl\'">\n' +
    '    <div class="row p-t-20">\n' +
    '     <div class="col-xs-6 col-md-6 p-b-20" ng-if="accounts.selectedAccount.iban">\n' +
    '      <span class="f-20  white-text-block">{{accounts.selectedAccount.iban}}</span>\n' +
    '      <!--<span class="white-text-block" translate="accounts.accountNumber"></span>-->\n' +
    '    </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row p-t-20">\n' +
    '    <!--<div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.cardAccountType">-->\n' +
    '      <!--<span class="f-20 white-text-block">{{accounts.selectedAccount.cardAccount.cardAccountType}}</span>-->\n' +
    '    <!--</div>-->\n' +
    '     <!--<div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.accountNumber">-->\n' +
    '      <!--<span class="f-20  white-text-block">-->\n' +
    '        <!--{{accounts.selectedAccount.accountNumber}}</span>-->\n' +
    '      <!--<span class="white-text-block" translate="accounts.accountNumber"></span>-->\n' +
    '    <!--</div>-->\n' +
    '\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">\n' +
    '      <span class="f-20  white-text-block">\n' +
    '        {{\'accounts.\'+accounts.selectedAccount.status | translate}}</span>\n' +
    '      <span class="white-text-block" translate="ebook.status"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '      <span\n' +
    '        class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.closingBalanceDate">\n' +
    '      <span class="f-20  white-text-block">\n' +
    '        <!--{{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>-->\n' +
    '        {{accounts.selectedAccount.cardAccount.closingBalanceDate | date:\'shortDate\'}}</span>\n' +
    '      <span class="white-text-block" translate="accounts.accDateLastChanged"></span>\n' +
    '    </div>\n' +
    '    </div>\n' +
    '  </span>\n' +
    '\n' +
    '  <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">\n' +
    '\n' +
    '    <div class="row p-t-20" ng-switch-when="sl" ng-show="accounts.isAccountDetailsOpen">\n' +
    '\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.interestRateAmount">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.cardAccount.interestRateAmount}} %</span>\n' +
    '        <span class="white-text-block" translate="accounts.interestRate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.payDate">\n' +
    '        <span class="f-20 white-text-block">{{accounts.selectedAccount.cardAccount.payDate | date: \'dd.\'}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accDueDate"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-md-4 p-b-20"  ng-hide="!accounts.selectedAccount.hasOwnProperty(\'limit\') && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\'">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        <span ng-if="accounts.selectedAccount.hasOwnProperty(\'limit\')">{{accounts.selectedAccount.limit | currency:""}} {{::accounts.selectedAccount.currencySymbol}}</span>\n' +
    '        <span ng-if="!accounts.selectedAccount.hasOwnProperty(\'limit\')" translate="accounts.dataNotAvailable"></span>\n' +
    '      </span>\n' +
    '        <span class="white-text-block" translate="accounts.accBalanceSlo"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.obligationAmount">\n' +
    '        <span class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.obligationAmount | number:2}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accObligationAmount"></span>\n' +
    '      </div>\n' +
    '      <div class="col-xs-12 col-md-4 p-b-20"\n' +
    '           ng-if="accounts.selectedAccount.cardAccount.outstandingAmount && accounts.selectedAccount.accountType.id === \'VISA\'">\n' +
    '        <span\n' +
    '          class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.outstandingAmount  | number:2}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accOutstandingAmount"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.hasOwnProperty(\'limitAmountAvailable\')">\n' +
    '             <span class="f-20  white-text-block">\n' +
    '               {{accounts.selectedAccount.cardAccount.limitAmountAvailable | number:2}}\n' +
    '               {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '        <span class="white-text-block" translate="accounts.accPosPaymentLimit"></span>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.limitValidUntilDate">\n' +
    '      <span class="f-20  white-text-block">\n' +
    '        {{accounts.selectedAccount.limitValidUntilDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accLimitValidUntilDate"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row p-t-20" ng-switch-default ng-show="accounts.isAccountDetailsOpen">\n' +
    '\n' +
    '        <div class="col-xs-12 col-md-4 p-b-20" ng-hide="!accounts.selectedAccount.hasOwnProperty(\'limit\') && APP_GLOBAL_SETTINGS.defaultData.APILocation == \'bh\'">\n' +
    '      <span class="f-20 white-text-block">\n' +
    '        <span ng-if="accounts.selectedAccount.hasOwnProperty(\'limit\')">{{accounts.selectedAccount.limit | currency:""}} {{::accounts.selectedAccount.currencySymbol}}</span>\n' +
    '        <span ng-if="!accounts.selectedAccount.hasOwnProperty(\'limit\')" translate="accounts.dataNotAvailable"></span>\n' +
    '      </span>\n' +
    '          <span class="white-text-block" translate="accounts.accApprovedLimit"></span>\n' +
    '        </div>\n' +
    '\n' +
    '        <!--<div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.payDate">-->\n' +
    '        <!--<span class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.payDate | date:\'shortDate\'}}</span>-->\n' +
    '        <!--<span class="white-text-block" translate="accounts.accDueDate"></span>-->\n' +
    '        <!--</div>-->\n' +
    '        <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.obligationAmount">\n' +
    '          <span\n' +
    '            class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.obligationAmount | currency: ""}} {{::accounts.selectedAccount.currencySymbol}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accObligationAmount"></span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-4 p-b-20"\n' +
    '             ng-if="accounts.selectedAccount.cardAccount.outstandingAmount && accounts.selectedAccount.accountType.id === \'VISA\'">\n' +
    '        <span\n' +
    '          class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.outstandingAmount  | number:2}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accOutstandingAmount"></span>\n' +
    '        </div>\n' +
    '        <!--   <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.limitAmountAtm">\n' +
    '             <span class="f-20  white-text-block">\n' +
    '               {{accounts.selectedAccount.cardAccount.limitAmountAtm | number: 2 }}\n' +
    '               {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '             <span class="white-text-block" translate="accounts.accAtmWithdrawalLimit"></span>\n' +
    '           </div>\n' +
    '\n' +
    '           <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.limitAmountAvailable">\n' +
    '             <span class="f-20  white-text-block">\n' +
    '               {{accounts.selectedAccount.cardAccount.limitAmountAvailable |number:2}}\n' +
    '               {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '             <span class="white-text-block" translate="accounts.accPosPaymentLimit"></span>\n' +
    '           </div>-->\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">\n' +
    '      <span class="f-20  white-text-block">\n' +
    '        {{\'accounts.\'+accounts.selectedAccount.status | translate}}</span>\n' +
    '          <span class="white-text-block" translate="ebook.status"></span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">\n' +
    '      <span class="f-20  white-text-block">\n' +
    '        {{accounts.selectedAccount.balanceLastChangedDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accDateLastChanged"></span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.limitValidUntilDate">\n' +
    '      <span class="f-20  white-text-block">\n' +
    '        {{accounts.selectedAccount.limitValidUntilDate | date:\'shortDate\'}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accLimitValidUntilDate"></span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-6 col-md-4 p-b-20" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != \'sl\'">\n' +
    '        <span class="f-20 white-text-block"\n' +
    '              ng-if="accounts.selectedAccount.reservedAmount && !accounts.selectedAccount.planedDebit">{{accounts.selectedAccount.reservedAmount | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '          <span class="f-20 white-text-block" ng-if="accounts.selectedAccount.planedDebit">{{accounts.selectedAccount.planedDebit | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '          <span class="f-20 white-text-block"\n' +
    '                ng-if="!accounts.selectedAccount.reservedAmount && !accounts.selectedAccount.planedDebit">{{0 | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>\n' +
    '          <span class="white-text-block" translate="accounts.accReservations"></span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '');
}]);

angular.module('comtradeBankingWeb').run(['$templateCache', function($templateCache) {
  $templateCache.put('login.html',
    '<!DOCTYPE html>\n' +
    '<html lang=\'en\' data-ng-app=\'comtradeBankingWeb\'>\n' +
    '<!--<base href="/">-->\n' +
    '<head>\n' +
    '  <title>Login handler</title>\n' +
    '  <meta name=\'viewport\' content=\'width=device-width, minimum-scale=1.0, initial-scale=1.0, user-scalable=yes\'>\n' +
    '  <!-- inject:head:js -->\n' +
    '  <!-- endinject -->\n' +
    '  <!-- inject:html -->\n' +
    '  <!-- endinject -->\n' +
    '  <!-- bower:css -->\n' +
    '  <!-- endbower -->\n' +
    '  <!-- inject:css -->\n' +
    '  <!-- endinject -->\n' +
    '</head>\n' +
    '<body>\n' +
    '<div data-ng-controller="LoginCtrl as login">\n' +
    '<!--  <div ng-cloak>{{login.errorKey}}</div>\n' +
    '  <div ng-cloak>{{login.errorDescription}}</div>-->\n' +
    '</div>\n' +
    '<!-- Older IE warning message -->\n' +
    '<!--[if lt IE 9]>\n' +
    '<div class="ie-warning">\n' +
    '  <h1 class="c-white">Warning!!</h1>\n' +
    '  <p>You are using an outdated version of Internet Explorer, please upgrade <br/>to any of the following web browsers to access this website.</p>\n' +
    '  <div class="iew-container">\n' +
    '    <ul class="iew-download">\n' +
    '      <li>\n' +
    '        <a href="http://www.google.com/chrome/">\n' +
    '          <img src="img/browsers/chrome.png" alt="">\n' +
    '          <div>Chrome</div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '      <li>\n' +
    '        <a href="https://www.mozilla.org/en-US/firefox/new/">\n' +
    '          <img src="img/browsers/firefox.png" alt="">\n' +
    '          <div>Firefox</div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '      <li>\n' +
    '        <a href="http://www.opera.com">\n' +
    '          <img src="img/browsers/opera.png" alt="">\n' +
    '          <div>Opera</div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '      <li>\n' +
    '        <a href="https://www.apple.com/safari/">\n' +
    '          <img src="img/browsers/safari.png" alt="">\n' +
    '          <div>Safari</div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '      <li>\n' +
    '        <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">\n' +
    '          <img src="img/browsers/ie.png" alt="">\n' +
    '          <div>IE (New)</div>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '  <p>Sorry for the inconvenience!</p>\n' +
    '</div>\n' +
    '<![endif]-->\n' +
    '\n' +
    '<!-- bower:js -->\n' +
    '<!-- endbower -->\n' +
    '<!-- inject:js -->\n' +
    '<!-- endinject -->\n' +
    '</body>\n' +
    '</html>\n' +
    '');
}]);

(function () {
  'use strict';

  /* @ngdoc object
   * @name localization
   * @description
   *
   */
  angular
    .module('localization', [
      'ui.router',
      'pascalprecht.translate'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      viber: {
        title: "Putem Viber aplikacije možete aktivirati Addiko Viber Chat Banking uslugu",
        activationWay: "Izaberite način aktivacije",
        scanQrCode: "Skeniranje QR koda",
        activationCode: "Aktivacioni kod",
        agree: "Prihvatam Opšte uslove poslovanja za servise Addiko elektronskog bankarstva - fizička lica i poljoprivrednici",
        activate: "Aktiviraj",
        deactivateText: "Vaš nalog je trenutno aktivan",
        deactivate: "Deaktiviraj",
        deactivateModalText: "Da li ste sigurni da želite deaktivirati uslugu Addiko Chat Banking?",
        cancel: "Odustani",
        activationSuccess: "Usluga Addiko Chat Banking je uspešno deaktivirana.",
        viberCondition1: "Opšti uslovi poslovanja za servise Addiko elektronskog bankarstva – fizička lica i poljoprivrednici ",
        viberCondition2: "primenjuju se i na usluge koje Klijent obavlja putem servisa Addiko Chat Banking. Vajber nalog koji će klijent koristiti za pristup ovom servisu banke biće korišćen u skladu sa ",
        viberCondition3: "uslovima i politikom Vajber aplikacije, ",
        viberCondition4: "za koju je klijent već dao saglasnost prilikom prijave na Vajber servis.",
        scanQrCodeC1: "Skenirajte prikazani QR kod putem Viber aplikacije (opcija 'More', 'QR code scanner').",
        scanQrCodeC2: "Nakon skeniranja, automatski ćete biti preusmereni na javni Viber nalog Addiko banke, gde će vas pozdraviti robotizovana aplikacija „Addiko chat bot“ uz zahtev da potvrdite / pošaljete aktivacioni kod. Pošaljite aktivacioni kod kroz Viber chat.",
        scanQrCodeC3: "Primićete SMS poruku sa verifikacionim kodom na broj telefona koji ste prijavili Banci prilikom ugovaranja ebanking/mbanking usluge.",
        scanQrCodeC4: "Unesite verifikacioni kod iz SMS poruke u Viber chat i pošaljite ga.",
        scanQrCodeC5: "Osmislite svoj  4-cifreni PIN. „Addiko chat bot“ će vam tražiti da 2 puta unesete ovaj PIN kako bi ste završili proces aktivacije Addiko Chat Banking-a.",
        scanQrCodeC6: "NAPOMENA: Ovaj PIN ćete ubuduće koristiti za pristup servisu  Addiko Chat Banking kao i prilikom potvrde transakcija obavljenih putem ovog kanala tako da ga OBAVEZNO zapamtite!.",
        activationCodeC1: "Pronadjite javni Viber nalog Addiko banke na Viber aplikaciji i izaberite opciju da postanete pratilac tog naloga („Follow“/“Pratilac“).",
        activationCodeC2: "Pokrenite chat opciju koja se nalazi u gornjem desnom uglu Viber aplikacije.",
        activationCodeC3: "U dnu ekrana uredjaja koji koristite za Viber (mobilni telefon, tablet, desktop računar) nalaze se komande Addiko Chat Banking servisa. Pokrenite komandu „Aktiviraj“.",
        activationCodeC4: "Unesite aktivacioni kod sa Addiko EBank stranice, u Viber chat. Pošaljite poruku sa popunjenim aktivacionim kodom.",
        activationCodeC5: "Primićete SMS poruku sa verifikacionim kodom na broj telefona koji ste prijavili Banci prilikom ugovaranja ebanking/mbanking usluge.",
        activationCodeC6: "Unesite verifikacioni kod iz SMS poruke u Viber chat i pošaljite ga.",
        activationCodeC7: "Osmislite svoj  4-cifreni PIN. „Addiko chat bot“ će vam tražiti da 2 puta unesete ovaj PIN kako bi ste završili proces aktivacije Addiko Chat Banking-a.",
        activationCodeC8: "NAPOMENA: Ovaj PIN ćete ubuduće koristiti za pristup servisu  Addiko Chat Banking kao i prilikom potvrde transakcija obavljenih putem ovog kanala tako da ga OBAVEZNO zapamtite!.",
        yourActivationCode: "Vaš kod za aktivaciju:",
        step1: 'Postanite pratilac klikom na dugme "Follow". Bićete preusmereni na javni nalog banke na Vajberu',
        step2: 'Vratite se u Ebank. Pokrenite servis klikom na dugme "Aktiviraj"',
        step3: 'Dobili ste sms poruku. Kliknite na aktivacioni link i bićete preusmereni na javni nalog banke',
        step4: 'Kreirajte vaš PIN na Addiko Chat Banking. Koristićete ga prilikom svih prijava i potvrda plaćanja',
        becomeFollower: 'Postani pratilac',
        conditionHeader: "Jednostavna i brza banka na Vajberu",
        conditionHeader2: 'Addiko Chat Banking vam omogućava:',
        text1: 'plaćanja i uvid u stanje',
        text2: 'pregled naloga za plaćanje',
        text3: 'da nađete najbližu ekspozituru ili bankomat',
        text4: 'informacije o aktuelnoj ponudi',
        activeMessage: 'Vaš Addiko Chat Banking nalog je aktivan.',
        mobileNumber: 'Broj telefona za koji je vezan servis',
        activationDate: 'Datum aktivacije servisa',
        successfulActivation: 'Uspešno aktiviran Addiko Chat Banking',
        unsuccessfulActivation: 'Neuspešna aktivacija. Molimo vas pokušajte ponovo. Za dodatnu asitenciju pozovite Kontakt centar na 0800 303 303.',
        successFollower: 'Postanite pratilac Addiko Viber naloga klikom na link koji smo Vam poslali u SMS poruci. Dobro došli.',
        smsSent: 'Aktivirajte Addiko Chat Banking servis klikom na link koji smo Vam poslali u sms poruci.'
  }
    };

    $translateProvider.translations('sr', data);

  }
} ());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      viber: {
        title: "Putem Viber aplikacije možete aktivirati Addiko Chat Banking uslugu",
        activationWay: "Izaberite način aktivacije",
        scanQrCode: "Skeniranje QR koda",
        activationCode: "Aktivacijski kod",
        agree: "Prihvatam Opšte uslove korištenja Addiko EBank usluge",
        activate: "Aktiviraj",
        deactivateText: "Vaš nalog je trenutno aktivan",
        deactivate: "Deaktiviraj",
        deactivateModalText: "Da li ste sigurni da želite deaktivirati uslugu Addiko Chat Banking?",
        cancel: "Odustani",
        activationSuccess: "Usluga Addiko Chat Banking je uspješno deaktivirana.",
        viberCondition1: "Opšti uslovi korištenja za Addiko EBank usluge ",
        viberCondition2: "primenjuju se i na usluge koje Korisnik obavlja korištenjem usluge Addiko Chat Banking. Viber nalog, koji će Korisnik koristiti za pristup ovoj usluzi Banke, biće korišćen u skladu sa ",
        viberCondition3: "uslovima i politikom Viber aplikacije ",
        viberCondition4: ",za koju je Korisnik već dao saglasnost tokom prijave na Viber servis.",
        scanQrCodeC1: "Skenirajte prikazani QR kod putem Viber aplikacije (opcija 'More', 'QR code scanner').",
        scanQrCodeC2: "Nakon skeniranja, automatski ćete biti preusmjereni na javni Viber nalog Addiko banke a aktivacioni kod će biti popunjen u poruci. Pošaljite poruku sa popunjenim aktivacionim kodom.",
        scanQrCodeC3: "Primićete SMS sa verifikacionim kodom na broj telefona koji ste ostavili u Banci za ebanking/mbanking uslugu.",
        scanQrCodeC4: "Unesite jednokratnu lozinku iz SMS poruke u Viber poruku i pošaljite je.",
        scanQrCodeC5: "Izaberite 4-cifreni PIN a zatim ponovite njegov unos kao potvrdu. Aplikacija prihvata unos PINa broj po broj (ne odjednom 4 broja), uz obavijest o isporuci svakog pojedinačnog.",
        scanQrCodeC6: "Ovaj PIN ćete ubuduće koristiti za pristup aplikaciji Addiko Chat Banking kao i prilikom potvrde transakcija obavljenih putem ovog kanala.",
        activationCodeC1: "Pronadjite javni Viber nalog Addiko banke na svojoj Viber aplikaciji i izaberite opciju da postanete pratilac tog naloga.",
        activationCodeC2: "Pokrenite chat opciju.",
        activationCodeC3: "U dnu ekrana uredjaja koji koristite za Viber, nalaze se komande Addiko Chat Banking aplikacije. Pokrenite komandu 'Aktiviraj'.",
        activationCodeC4: "Unesite aktivacioni kod sa Addiko Ebank stranice, u Viber poruku. Pošaljite poruku sa popunjenim aktivacionim kodom.",
        activationCodeC5: "Primićete SMS sa verifikacionim kodom na broj telefona koji ste ostavili u Banci za ebanking/mbanking uslugu.",
        activationCodeC6: "Unesite jednokratnu lozinku iz SMS poruke u Viber poruku i pošaljite je.",
        activationCodeC7: "Izaberite 4-cifreni PIN a zatim ponovite njegov unos kao potvrdu. Aplikacija prihvata unos PINa broj po broj (ne odjednom 4 broja), uz obavijest o isporuci svakog pojedinačnog.",
        activationCodeC8: "Ovaj PIN ćete ubuduće koristiti za pristup aplikaciji Addiko Chat Banking kao i prilikom potvrde transakcija obavljenih putem ovog kanala.",
        yourActivationCode: "Vaš kod za aktivaciju:",
        step1: 'Klikom na dugme "Postani pratilac" bićete preusmjereni na javni nalog Banke na Viber-u. Postanite pratilac klikom na dugme "Follow"',
        step2: 'Vratite se u E-banku i aktivirajte servis klikom na dugme "Aktiviraj"',
        step3: 'Kliknite na aktivacioni link koji ste dobili u sms poruci i bićete preusmereni na javni nalog Banke',
        step4: 'Kreirajte Vaš PIN koji ćete u buduće koristiti prilikom prijave i potvrde plaćanja putem Addiko Chat Banking-a',
        becomeFollower: 'Postani pratilac',
        conditionHeader: "Obavljajte bankarske poslove putem Viber aplikacije jednostavno i brzo",
        conditionHeader2: 'Sa novim servisom "Addiko Chat Banking" možete:',
        text1: 'Pregledati stanja i vršiti plaćanje',
        text2: 'Pregledati naloge za plaćanje',
        text3: 'Pronaći najbližu ekspozituru ili bankomat',
        text4: 'Informisati se o aktuelnoj ponudi banke',
        successfulActivation: 'Uspješna aktivacija',
        unsuccessfulActivation: 'Neuspješna aktivacija',
        smsSent: 'Sms poruka je uspešno poslana. Molimo Vas da kliknete na link koji smo Vam poslali u poruci.'


      }
    };

    $translateProvider.translations('mne', data);

  }
} ());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      viber: {
        title: "Putem aplikacije Viber možete aktivirati uslugu Addiko Chat Banking",
        activationWay: "Odaberite način aktivacije",
        scanQrCode: "Skeniranje QR kôda",
        activationCode: "Aktivacijski kôd",
        agree: "Prihvaćam Opće uvjete korištenja usluga direktnog bankarstva za potrošače",
        activate: "Aktiviraj",
        deactivateText: "Vaš korisnički račun je trenutno aktivan",
        deactivate: "Deaktiviraj",
        deactivateModalText: "Jeste li sigurni da želite deaktivirati uslugu Addiko Chat Banking?",
        cancel: "Odustani",
        activationSuccess: "Usluga Addiko Chat Banking je uspješno deaktivirana",
        viberCondition1: "Opći uvjeti korištenja usluga direktnog bankarstva za potrošače ",
        viberCondition2: " primjenjuju se i na usluge koje se obavljaju putem Addiko Chat Bankinga. Viber korisnički račun koji ćete koristiti za pristup ovoj usluzi Addiko banke, koristit će se u skladu s ",
        viberCondition3: "uvjetima i politikom aplikacije Viber ",
        viberCondition4: "za koju ste već ranije dali suglasnost, prilikom prijave na Viber servis.",
        scanQrCodeC1: "Skenirajte prikazani QR kôd putem aplikacije Viber (opcija 'More', 'QR code scanner').",
        scanQrCodeC2: "Nakon skeniranja ćete automatski biti preusmjereni na javni Viber korisnički račun Addiko banke gdje će Vas dočekati automatska chat aplikacija 'Addiko chat bot' te od Vas zatražiti da potvrdite odnosno pošaljete aktivacijski kôd. Pošaljite kôd putem Viber chat poruke.",
        scanQrCodeC3: "Poruku s verifikacijskim kôdom primit ćete putem SMS poruke na broj telefona koji ste naveli prilikom ugovaranja usluge internetskog ili mobilnog bankarstva.",
        scanQrCodeC4: "Prepišite verifikacijski kôd iz SMS poruke u Viber chat i pošaljite ga.",
        scanQrCodeC5: "Osmislite svoj 4-znamenkasti PIN. 'Addiko chat bot' će od Vas tražiti da ovaj PIN unesete 2 puta kako biste završili proces aktivacije Addiko Viber Chat Bankinga.",
        scanQrCodeC6: "NAPOMENA: Ovaj PIN ćete ubuduće koristiti za pristup usluzi Addiko Viber Chat Banking, kao i prilikom potvrde platnih naloga obavljenih putem Vibera tako da ga obavezno upamtite!",
        activationCodeC1: "Pronađite javni korisnički račun Addiko banke na Viberu i pratite nas! ('Follow' / 'Pratitelj')",
        activationCodeC2: "Pokrenite chat opciju koja se nalazi u gornjem desnom kutu aplikacije Viber.",
        activationCodeC3: "U dnu zaslona uređaja na kojem koristite Viber (mobilni telefon, tablet, računalo) nalaze se opcije za uslugu Addiko Viber Chat Banking. Pokrenite opciju 'Aktiviraj'.",
        activationCodeC4: "Prepišite aktivacijski kôd sa stranice internetskog bankarstva Addiko Ebank u Viber chat. Pošaljite poruku s upisanim aktivacijskim kôdom.",
        activationCodeC5: "Poruku s verifikacijskim kôdom primit ćete putem SMS poruke na broj telefona koji ste naveli prilikom ugovaranja usluge internetskog ili mobilnog bankarstva.",
        activationCodeC6: "Prepišite verifikacijski kôd iz SMS poruke u Viber chat i pošaljite ga.",
        activationCodeC7: "Osmislite svoj 4-znamenkasti PIN. 'Addiko chat bot' će od Vas tražiti da ovaj PIN unesete 2 puta kako biste završili proces aktivacije Addiko Viber Chat Bankinga.",
        activationCodeC8: "NAPOMENA: Ovaj PIN ćete ubuduće koristiti za pristup usluzi Addiko Chat Banking, kao i prilikom potvrde transakcija obavljenih putem Vibera, tako da ga obavezno upamtite!",
        yourActivationCode: "Vaš kôd za aktivaciju:",
        scanQrCodeC7: "Pronađite javni profil Addiko banke (Addiko Bank Hrvatska) u aplikaciji Viber, u dijelu Public Accounts i pratite nas! ('Follow/'Prati')",
        scanQrCodeC8: "Skenirajte prikazani QR kôd putem aplikacije Viber (opcija 'More - QR code scanner' u Viber izborniku). Nakon skeniranja kôda bit ćete preusmjereni na javni profil Addiko banke na Viberu, a aktivacijski kôd će se automatski upisati u poruku. Pošaljite poruku s aktivacijskim kôdom.",
        activationCodeC9: "Pronađite javni profil Addiko banke (Addiko Bank Hrvatska) u aplikaciji Viber, u dijelu Public Accounts i pratite nas! ('Follow/'Prati')",
        activationCodeC10: "Pokrenite chat opciju koja se nalazi u gornjem desnom kutu aplikacije Viber. U dnu zaslona uređaja na kojem koristite Viber nalaze se opcije za uslugu Addiko Chat Banking.  Pokrenite opciju 'Aktiviraj'. Unesite više prikazani aktivacijski kôd u Viber poruku i pošaljite je.",
        additionalActivation1: "Nakon slanja aktivacijskog kôda, putem SMS poruke primit ćete verifikacijski kôd. Poruka će Vam stići na broj mobilnog telefona kojeg ste zadnjeg dali Banci. Prepišite verifikacijski kôd iz SMS poruke u Viber chat  i pošaljite ga.",
        additionalActivation2: "Osmislite svoj 4-znamenkasti PIN. Da biste uspješno završili proces aktivacije, bit će potrebno ovaj PIN unijeti dva puta kako biste ga potvrdili.",
        additionalActivation3: "OBAVEZNO  zapamtite ovaj PIN jer ćete ga ubuduće koristiti za pristup usluzi Addiko Chat Banking na Viberu, kao i prilikom potvrde transakcija obavljenih putem Addiko Chat Bankinga",
        step1: 'Odabirom opcije "Prati/Follow" bit ćete preusmjereni na javni profil Addiko banke na Viberu. Kada pristupite Addiko profilu, odaberite opciju "Prati/Follow" koja će Vam se pojaviti na zaslonu Viber aplikacije.',
        step2: 'Vratite se u internetsko bankarstvo Addiko EBank te aktivirajte Addiko Chat Banking odabirom opcije "Aktiviraj"',
        step3: 'Na Vaš mobilni telefon primili ste SMS poruku s aktivacijskom poveznicom. Dotaknite poveznicu kako biste bili preusmjereni na javni profil Addiko banke.',
        step4: 'Kreirajte Vaš PIN koji ćete ubuduće koristiti prilikom prijave i potvrde plaćanja putem Addiko Chat Bankinga',
        becomeFollower: 'Prati',
        conditionHeader: "Obavljajte bankarske poslove putem Vibera jednostavno i brzo.",
        conditionHeader2: 'Nova usluga "Addiko Chat Banking" omogućuje Vam:',
        text1: 'pregled stanja Vaših računa',
        text2: 'plaćanje putem postojećih predložaka te pregled plaćanja.',
        text3: 'lociranje najbližeg Addiko bankomata ili poslovnice.',
        text4: 'informacije o trenutno aktualnoj Addiko ponudi.',
        activeMessage: 'Vaš Addiko Chat Banking je aktivan.',
        mobileNumber: 'Broj telefona uz koji je povezana usluga Addiko Chat Bankinga.',
        activationDate: 'Datum aktivacije usluge.',
        successfulActivation: 'Uspješna aktivacija.',
        unsuccessfulActivation: 'Neuspješna aktivacija.',
        smsSent: 'Sms poruka je uspešno poslana. Molimo Vas da kliknete na link koji smo Vam poslali u poruci.'
      }
    };

    $translateProvider.translations('hr', data);

  }
} ());



(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      viber: {
        title: "With Viber application you can activate Addiko Chat Banking service",
        activationWay: "Choose the method of activation",
        scanQrCode: "Scan QR code",
        activationCode: "Activation code",
        agree: "I agree with Terms and Conditions of the Addiko Ebank Service",
        activate: "Activate",
        deactivateText: "Your account is active",
        deactivate: "Deactivate",
        deactivateModalText: "You are going to deactivate Addiko Chat Banking service. Are you sure?",
        cancel: "Cancel",
        activationSuccess: "Viber service deactivated successfully!",
        conditionHeader: "Straightforward and agile banking on Viber",
        conditionHeader2: "Addiko Chat Banking enables:",
        viberCondition1: "The User understands and confirms that the Addiko EBank General Terms and Conditions of Addiko Bank",
        viberCondition2: "are applicable also on the  Viber payments service. The Viber order, activated by the User with the purpose of accessing the service, shall be used in the manner envisaged by Terms and Conditions and ",
        viberCondition3: "policy of the Viber application ",
        viberCondition4: "with which the User has already agreed during registration to the Viber service.",
        scanQrCodeC1: "Open Viber (choose options 'More', 'QR code scanner') and scan presented QR code.",
        scanQrCodeC2: "QR scanning will automatically open chat on public Viber account of Addiko bank and fulfill Viber message with activation code that you have scanned. Send Viber message with activation code.",
        scanQrCodeC3: "You will receive SMS with verification code on the phone number registered at the Bank for ebanking/mbanking service.",
        scanQrCodeC4: "Enter (or copy) verification code from SMS message into Viber message and send it.",
        scanQrCodeC5: "Create your 4-digit PIN and repeat entering to confirm it. Entering PIN number should be done one by one digit.",
        scanQrCodeC6: "Once created, this PIN will be used to access Addiko Chat Banking service and confirm transactions initiated from this channel.",
        activationCodeC1: "Open your Viber application, go to Public Accounts option and search for Addiko bank public account. Choose option to become follower.",
        activationCodeC2: "Run Chat option with Addiko bank Viber account.",
        activationCodeC3: "In the bottom of the Viber screen, you will find Addiko Chat Banking menu options. Choose “Aktiviraj” (Activate).",
        activationCodeC4: "Enter activation code from Addiko Ebank activation page into Viber message; send Viber message with activation code.",
        activationCodeC5: "You will receive SMS with verification code on the phone number registered at the Bank for ebanking/mbanking service.",
        activationCodeC6: "Enter (or copy) verification code from SMS message into Viber message and send it.",
        activationCodeC7: "Create your 4-digit PIN and repeat entering to confirm it. Entering PIN number should be done one by one digit.",
        activationCodeC8: "Once created, this PIN will be used to access Addiko Chat Banking service and confirm transactions initiated from this channel.",
        yourActivationCode: "Your activation code:",
        scanQrCodeC7: "Find the Addiko Bank's public account (Addiko Bank Hrvatska) in the Public Accounts area on Viber and follow us!",
        scanQrCodeC8: "Scan this QR code using your Viber app ('More – QR Code Scanner' available in the Viber menu). After successfully scanning the code, you will be redirected to the Addiko Bank's public account on Viber and the activation code is automatically going to be inserted in the Viber message area. Send the message containing the activation code. ",
        activationCodeC9: "Find the Addiko Bank's public account (Addiko Bank Hrvatska) in the Public Accounts area on Viber and follow us!",
        activationCodeC10: "Initiate the chat by tapping the option available in the upper right corner of the Viber app. In the bottom of the device on which you use Viber, there are options available for the service of Addiko Chat Banking.  Tap on the 'Aktiviraj' option (Activate). Enter the activation code shown above and send the message.",
        additionalActivation1: "After sending the activation code, you are going to receive a verification code via SMS. The message is going to be sent to the mobile phone number that you have most recently provided to the Bank. Copy the verification code from the SMS into the Viber chat message and send it.",
        additionalActivation2: "Create your 4-digit PIN. For successful completion of the activation process, you are going to be prompted to enter this PIN twice in order to confirm it. ",
        additionalActivation3: "MEMORIZE this PIN since you are going to use it to access the Addiko Chat Banking service on Viber as well as for approving the transactions conducted via Addiko Chat Banking.      ",
        step1: 'Become a follower by clicking the „Follow“ button. You will be redirected to the Bank’s Public Account on Viber.',
        step2: 'Go back to EBank. Start the service by clicking the "Activate" button.',
        step3: 'You have received a sms message. Click the activation link and you will be redirected to the Bank’s Public Account',
        step4: 'Set up your PIN on Addiko Chat Banking. You will use it for signup and payment confirmations.',
        text1: 'payments and balance insight',
        text2: 'payments overview',
        text3: 'locating nearest branch or ATM',
        text4: 'information about the current offer',
        activeMessage: "Your Addiko Chat Banking account is active.",
        mobileNumber: 'Phone number which is linked to service',
        activationDate: 'Service Activation Date',
        becomeFollower: 'Become a follower',
        successfulActivation: 'Addiko Chat Banking successfully activated',
        unsuccessfulActivation: 'Bezuspješna aktivacija',
        smsSent: 'Sms message successfully sent. Please click on link we sent in message.',
        successFollower: 'You just became a follower of our Addiko Viber Account. Welcome!'
      }
    };

    $translateProvider.translations('en', data);

  }
}());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      viber: {
        title: "Putem Viber aplikacije možete aktivirati Addiko Chat Banking uslugu",
        activationWay: "Izaberite način aktivacije",
        scanQrCode: "Skeniranje QR koda",
        activationCode: "Aktivacijski kod",
        agree: "Prihvatam Opšte uslove/Opće uvjete korištenja Addiko EBank usluge",
        activate: "Aktiviraj",
        deactivateText: "Vaš nalog je trenutno aktivan",
        deactivate: "Deaktiviraj",
        deactivateModalText: "Da li ste sigurni da želite deaktivirati uslugu Addiko Chat Banking?",
        cancel: "Odustani",
        activationSuccess: "Usluga Addiko Chat Banking je uspješno deaktivirana.",
        viberCondition1: "Opšti uslovi korištenja za Addiko EBank Addiko Bank ",
        viberCondition2: "primjenjuju se i na usluge koje Korisnik obavlja korištenjem usluge Addiko Chat Banking. Viber nalog, koji će Korisnik koristiti za pristup ovoj usluzi Banke, biće korišten u skladu sa ",
        viberCondition3: "uslovima i politikom Viber aplikacije ",
        viberCondition4: ",za koju je Korisnik već dao saglasnost tokom prijave na Viber servis.",
        scanQrCodeC1: "Skenirajte prikazani QR kod putem Viber aplikacije (opcija 'More', 'QR code scanner').",
        scanQrCodeC2: "Nakon skeniranja, automatski ćete biti preusmjereni na javni Viber nalog Addiko banke a aktivacioni kod će biti popunjen u poruci. Pošaljite poruku sa popunjenim aktivacionim kodom.",
        scanQrCodeC3: "Primićete SMS sa verifikacijskim kodom na broj telefona koji ste ostavili u Banci za ebanking/mbanking uslugu.",
        scanQrCodeC4: "Unesite jednokratnu lozinku iz SMS poruke u Viber poruku i pošaljite je.",
        scanQrCodeC5: "Izaberite 4-cifreni PIN a zatim ponovite njegov unos kao potvrdu. Aplikacija prihvata unos PINa broj po broj (ne odjednom 4 broja), uz obavijest o isporuci svakog pojedinačnog.",
        scanQrCodeC6: "Ovaj PIN ćete ubuduće koristiti za pristup aplikaciji Addiko Chat Banking kao i prilikom potvrde transakcija obavljenih putem ovog kanala.",
        activationCodeC1: "Pronadjite javni Viber nalog Addiko banke na svojoj Viber aplikaciji i izaberite opciju da postanete pratilac tog naloga.",
        activationCodeC2: "Pokrenite chat opciju.",
        activationCodeC3: "U dnu ekrana uredjaja koji koristite za Viber, nalaze se komande Addiko Chat Banking aplikacije. Pokrenite komandu 'Aktiviraj'.",
        activationCodeC4: "Unesite aktivacioni kod sa Addiko Ebank stranice, u Viber poruku. Pošaljite poruku sa popunjenim aktivacionim kodom.",
        activationCodeC5: "Primićete SMS sa verifikacijskim kodom na broj telefona koji ste ostavili u Banci za ebanking/mbanking uslugu.",
        activationCodeC6: "Unesite jednokratnu lozinku iz SMS poruke u Viber poruku i pošaljite je.",
        activationCodeC7: "Izaberite 4-cifreni PIN a zatim ponovite njegov unos kao potvrdu. Aplikacija prihvata unos PINa broj po broj (ne odjednom 4 broja), uz obavijest o isporuci svakog pojedinačnog.",
        activationCodeC8: "Ovaj PIN ćete ubuduće koristiti za pristup aplikaciji Addiko Chat Banking kao i prilikom potvrde transakcija obavljenih putem ovog kanala.",
        yourActivationCode: "Vaš kod za aktivaciju:",
        activeMessage: 'Vaš Addiko Chat Banking nalog je aktivan.',
        mobileNumber: 'Broj telefona za koji je vezana usluga Addiko Chat Banking',
        activationDate: 'Datum aktivacije usluge',
        step1: 'Klikom na dugme Postani pratilac bićete preusmjereni na javni nalog Addiko banke na Viberu. Postanite pratilac klikom na dugme Follow.',
        step2: 'Vratite se u Addiko EBank i aktivirajte uslugu klikom na dugme Aktiviraj.',
        step3: 'Kliknite na aktivacioni link, koji ste dobili u SMS poruci, i bićete preusmjereni na javni nalog Addiko banke na Viberu.',
        step4: 'Kreirajte PIN, koji ćete ubuduće koristiti prilikom prijave i potvrde plaćanja, koristeći uslugu Addiko Chat Banking.',
        becomeFollower: 'Postani pratilac',
        conditionHeader: "Bankarite putem Viber aplikacije i chata, jednostavno i brzo.",
        conditionHeader2: 'Sa uslugom Addiko Chat Banking možete:',
        text1: 'Pregledati stanja i vršiti plaćanje',
        text2: 'Pregledati naloge za plaćanje',
        text3: 'Pronaći najbližu Addiko poslovnicu i bankomat',
        text4: 'Najbrže saznati sve Adddiko novosti.',
        successfulActivation: 'Uspješna aktivacija',
        unsuccessfulActivation: 'Neuspješna aktivacija',
        smsSent: 'Sms poruka je uspešno poslana. Molimo Vas da kliknete na link koji smo Vam poslali u poruci.'

      }
    };

    $translateProvider.translations('bh', data);

  }
} ());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            transactions:{
                transactionTypes:{
                    credit: "Uplata"
                    ,debit: "Isplata"
                    ,all: "Svi"
                }
            },
          reclamation: {
            title: "Reklamacija",
            number: "Broj reklamacije",
            paymentReference: "Referenca naloga",
            bookingDate: "Datum knjiženja",
            valueDate: "Datum valute",
            amount: "Iznos",
            purpose: "Svrha plaćanja",
            description: "Tekst reklamacije",
            wantComplain: "Želim reklamirati",
            confirm: "Potvrdi",
            cancel: "Odustani"
          }
        };

        $translateProvider
            .translations('sr', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      transactions:{
        transactionTypes:{
          credit: "Prejemki"
          ,debit: "Izdatki"
          ,all: "Vse"
        }
      },
      reclamation: {
        title: "Reklamacija",
        number: "Št. reklamacije",
        paymentReference: "Referenca plačila",
        bookingDate: "Datum knjiženja",
        valueDate: "Datum valute",
        amount: "Znesek",
        purpose: "Namen plačila",
        description: "Razlog reklamacije",
        wantComplain: "Želim reklamirati",
        confirm: "Potrdi",
        cancel: "Prekliči"
      }
    };

    $translateProvider
      .translations('sl', data);

  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            transactions:{
                transactionTypes:{
                    credit: "Uplata"
                    ,debit: "Isplata"
                    ,all: "Svi"
                }
            },
          reclamation: {
            title: "Reklamacija",
            number: "Broj reklamacije",
            paymentReference: "Referenca naloga",
            bookingDate: "Datum knjiženja",
            valueDate: "Datum valute",
            amount: "Iznos",
            purpose: "Svrha plaćanja",
            description: "Tekst reklamacije",
            wantComplain: "Želim reklamirati",
            confirm: "Potvrdi",
            cancel: "Odustani"
          }
        };

        $translateProvider
            .translations('mne', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      transactions:{
        transactionTypes:{
          credit: "Uplata"
          ,debit: "Isplata"
          ,all: "Svi"
        }
      },
      reclamation: {
        title: "Reklamacija",
        number: "Broj reklamacije",
        paymentReference: "Referenca naloga",
        bookingDate: "Datum knjiženja",
        valueDate: "Datum valute",
        amount: "Iznos",
        purpose: "Svrha plaćanja",
        description: "Tekst reklamacije",
        wantComplain: "Želim reklamirati",
        confirm: "Potvrdi",
        cancel: "Odustani"
      }
    };

    $translateProvider
      .translations('hr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      transactions:{
        transactionTypes:{
          credit: "Credit"
          ,debit: "Debit"
          ,all: "All"
        }
      },
      reclamation: {
        title: "Complaint",
        number: "Reclamation number",
        paymentReference: "Payment reference",
        bookingDate: "Booking date",
        valueDate: "Value date",
        amount: "Amount",
        purpose: "Purpose of payment",
        description: "Complaint text",
        wantComplain: "Want to complain",
        confirm: "Confirm",
        cancel: "Cancel"
      }
    };

    $translateProvider
      .translations('en', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      transactions:{
        transactionTypes:{
          credit: "Uplata"
          ,debit: "Isplata"
          ,all: "Svi"
        }
      },
      reclamation: {
        title: "Reklamacija/pritužba",
        number: "Broj reklamacije/pritužbe",
        paymentReference: "Referenca naloga",
        bookingDate: "Datum knjiženja",
        valueDate: "Datum valute",
        amount: "Iznos",
        purpose: "Svrha plaćanja",
        description: "Tekst reklamacije/pritužbe",
        wantComplain: "Želim reklamirati",
        confirm: "Potvrdi",
        cancel: "Odustani"
      }
    };

    $translateProvider
      .translations('bh', data);

  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            timeline: {
                "description": "Opis",
                "amount": "Iznos",
                "availableBalance": "Raspoloživi iznos",
                "accountNumber": "Broj računa",
                "bookingDate": "Datum knjiženja",
                "transactionDetails": "Detalji transakcije",
                "referenceType": "Tip reference",
                "group": "Grupa",
                "valueDate": "Datum valute",
                "einvoiceDetails": "Detalji eRačuna",
                "purpose": "Svrha",
                "creditorName": "Naziv platitelja",
                "tldmMessageDetails": "Detalji poruke:",
                "tldmMessageDate": "Datum kreiranja poruke:",
                "tldmMessageSubject": "Naslov poruke:",
                "debitorName":"Naziv primaoca",
                "creditorAddress":"Adresa platitelja",
                "debitorAddress":"Adresa primaoca",
                "creditorAccount":"Račun platitelja",
                "debitorAccount":"Račun primaoca",
                "Transaction": "Transakcija",
              itemTypeStatus: {
                EInvoice: "EInvoice",
                TransactionCredit: "TransactionCredit",
                TransactionDebit: "TransactionDebit",
                Payment: "Payment",
                MessageIn: "MessageIn",
                MessageOut: "MessageOut",
                Statement: "Statement",
                LoginSuccessful: "LoginSuccessful",
                LoginFailed: "LoginFailed",
                TokenRefresh: "TokenRefresh"
              }
            }
        };

        $translateProvider
            .translations('sr', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            timeline: {
                "description": "Opis",
                "amount": "Znesek",
                "availableBalance": "Razpoložljivo stanje",
                "accountNumber": "Številka računa",
                "bookingDate": "Datum knjiženja",
                "transactionDetails": "Podrobnosti transakcije",
                "referenceType": "Promet",
                "group": "Račun",
                "valueDate": "Datum valute",
                "einvoiceDetails": "Podrobnosti eRačuna",
                "purpose": "Namen",
                "creditorName": "Naziv plačnika",
                "tldmMessageDetails": "Podrobnosti sporočila:",
                "tldmMessageDate": "Datum:",
                "tldmMessageSubject": "Naslov sporočila:",
                "debitorName":"Naziv prejemnika",
                "creditorAddress":"Naslov plačnika",
                "debitorAddress":"Naslov prejemnika",
                "creditorAccount":"Račun plačnika",
                "debitorAccount":"Račun prejemnika",
                "Transaction": "Transakcija",
                itemTypeStatus: {
                  EInvoice: "eRačun",
                  TransactionCredit: "Promet v dobro",
                  TransactionDebit: "Promet v dobro",
                  Payment: "Plačilo",
                  MessageIn: "Prejeto sporočilo",
                  MessageOut: "Poslano sporočilo",
                  Statement: "Izpisek",
                  LoginSuccessful: "Uspešna prijava",
                  LoginFailed: "Neuspešna prijava",
                  TokenRefresh: "Ovežitev generatorja gesel"
                }
            }
        };

        $translateProvider
            .translations('sl', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            timeline: {
                "description": "Opis",
                "amount": "Iznos",
                "availableBalance": "Raspoloživi iznos",
                "accountNumber": "Broj računa",
                "bookingDate": "Datum knjiženja",
                "transactionDetails": "Detalji transakcije",
                "referenceType": "Tip reference",
                "group": "Račun",
                "valueDate": "Datum valute",
                "einvoiceDetails": "Detalji eRačuna",
                "purpose": "Svrha",
                "creditorName": "Naziv platitelja",
                "tldmMessageDetails": "Detalji poruke:",
                "tldmMessageDate": "Datum kreiranja poruke:",
                "tldmMessageSubject": "Naslov poruke:",
                "debitorName":"Primalac",
                "creditorAddress":"Adresa platitelja",
                "debitorAddress":"Adresa primatelja",
                "creditorAccount":"Račun platitelja",
                "debitorAccount":"Račun primatelja",
                "Transaction": "Transakcija",
              itemTypeStatus: {
                EInvoice: "EInvoice",
                TransactionCredit: "TransactionCredit",
                TransactionDebit: "TransactionDebit",
                Payment: "Payment",
                MessageIn: "MessageIn",
                MessageOut: "MessageOut",
                Statement: "Statement",
                LoginSuccessful: "LoginSuccessful",
                LoginFailed: "LoginFailed",
                TokenRefresh: "TokenRefresh"
              }
            }
        };

        $translateProvider
            .translations('mne', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            timeline: {
                "description": "Opis",
                "amount": "Iznos",
                "availableBalance": "Raspoloživi iznos",
                "accountNumber": "Broj računa",
                "bookingDate": "Datum knjiženja",
                "transactionDetails": "Detalji transakcije",
                "referenceType": "Tip reference",
                "group": "Grupa",
                "valueDate": "Datum valute",
                "einvoiceDetails": "Detalji eRačuna",
                "purpose": "Svrha",
                "creditorName": "Naziv platitelja",
                "tldmMessageDetails": "Detalji poruke:",
                "tldmMessageDate": "Datum kreiranja poruke:",
                "tldmMessageSubject": "Naslov poruke:",
                "debitorName":"Naziv primatelja",
                "creditorAddress":"Adresa platitelja",
                "debitorAddress":"Adresa primatelja",
                "creditorAccount":"IBAN platitelja",
                "debitorAccount":"Račun primatelja",
                "Transaction": "Transakcija",
              itemTypeStatus: {
                EInvoice: "EInvoice",
                TransactionCredit: "TransactionCredit",
                TransactionDebit: "TransactionDebit",
                Payment: "Payment",
                MessageIn: "MessageIn",
                MessageOut: "MessageOut",
                Statement: "Statement",
                LoginSuccessful: "LoginSuccessful",
                LoginFailed: "LoginFailed",
                TokenRefresh: "TokenRefresh"
              }
            }
        };

        $translateProvider
            .translations('hr', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            timeline: {
                "description": "Description",
                "amount": "Amount",
                "availableBalance": "Available balance",
                "accountNumber": "Account number",
                "bookingDate": "Booking date",
                "transactionDate": "Transaction date",
                "transactionDetails": "Transaction details",
                "close": "Close",
                "referenceType": "Type",
                "group": "Account",
                "valueDate": "Value date",
                "einvoiceDetails": "eInvoice details",
                "purpose": "Purpose",
                "creditorName": "Payer",
                "tldmMessageDetails": "Message details:",
                "tldmMessageDate": "Message creation date:",
                "tldmMessageSubject": "Message subject:",
                "debitorName":"Recipient",
                "creditorAddress":"Payer address",
                "debitorAddress":"Recipient's address",
                "creditorAccount":"From IBAN",
                "debitorAccount":"To account",
                "Transaction": "Transaction",
              itemTypeStatus: {
                EInvoice: "EInvoice",
                TransactionCredit: "TransactionCredit",
                TransactionDebit: "TransactionDebit",
                Payment: "Payment",
                MessageIn: "MessageIn",
                MessageOut: "MessageOut",
                Statement: "Statement",
                LoginSuccessful: "LoginSuccessful",
                LoginFailed: "LoginFailed",
                TokenRefresh: "TokenRefresh"
              }

            }
        };

        $translateProvider
            .translations('en', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      timeline: {
        "description": "Opis",
        "amount": "Iznos",
        "availableBalance": "Raspoloživi iznos",
        "accountNumber": "Broj računa",
        "bookingDate": "Datum knjiženja",
        "transactionDetails": "Detalji transakcije",
        "referenceType": "Tip reference",
        "group": "Grupa",
        "valueDate": "Datum valute",
        "einvoiceDetails": "Detalji eRačuna",
        "purpose": "Svrha",
        "creditorName": "Naziv platitelja/platioca",
        "tldmMessageDetails": "Detalji poruke:",
        "tldmMessageDate": "Datum kreiranja poruke:",
        "tldmMessageSubject": "Naslov poruke:",
        "debitorName":"Naziv primatelja/primaoca",
        "creditorAddress":"Adresa platitelja/platioca",
        "debitorAddress":"Adresa primatelja/primaoca",
        "creditorAccount":"Račun platitelja/platioca",
        "debitorAccount":"Račun primatelja/primaoca",
        "Transaction": "Transakcija",
        itemTypeStatus: {
          EInvoice: "EInvoice",
          TransactionCredit: "TransactionCredit",
          TransactionDebit: "TransactionDebit",
          Payment: "Payment",
          MessageIn: "MessageIn",
          MessageOut: "MessageOut",
          Statement: "Statement",
          LoginSuccessful: "LoginSuccessful",
          LoginFailed: "LoginFailed",
          TokenRefresh: "TokenRefresh"
        }
      }
    };

    $translateProvider
      .translations('bh', data);

  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            settings: {
                "title": "Podešavanja",
                "tabAccount": "NA",
                "tabNotifications": "NA",
                "tabSecurity": "NA",
                "contactInfo": "Vaši kontaktni podaci",
                "contactInfoBtn": "Promijeni",
                "contactInfoConfirmBtn": "Potvrdi",
                "contactInfoCancelBtn": "Otkaži",
                "contactInfoName": "Ime",
                "contactInfoAddress": "Adresa",
                "contactInfoPhone": "Telefon",
                "blocades": "Blokade",
                "blockLogin": "Blokiranje logiranja u internet bankarstvo",
                "blockMobile": "Blokiranje logiranja u mobilno bankarstvo",
                "blockPayment": "Blokiranje kartice za plaćanje",
                "accountSettings": "Postavke računa",
                "defaultAccount": "Podrazumijevani račun",
                "statementsDelivery": "Dostava izvoda",
                "statementsDeliveryPaper": "Dostava izvoda na kućnu adresu",
                "statementsDeliveryElectronic": "Dostava izvoda u putem internet bankarstva",
                "messagesSettings": "Postavke poruka",
                "messagesSettingsLabel": "Označite ako želite da sve poruke od banke primate i na email",
                "securitySettings": "Sigurnosne postavke",
                "transactionsConfirmation": "Potvrda o transakcijama",
                "transactionsConfirmationSMS": "Slanjem SMS-a na mobitel",
                "transactionsConfirmationOTP": "Generisanjem jednokratne zaporke",
                "notificationSettings": "Postavke obaviještenja",
                "gsm":"GSM",
                "oldPass":"Stara lozinka",
                "newPass":"Nova lozinka",
                "againPass":"Potvrdi novu lozinku",
                "noMatch":"Pogrešna lozinka!",
                "change":"Izmeni"
            }
        };

        $translateProvider.translations('sr', data);

    }
} ());
(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            settings: {
                "title": "Nastavitve",
                "tabAccount": "Račun",
                "tabNotifications": "Obveščanje",
                "tabSecurity": "Varnost",
                "contactInfo": "Osebni podatki",
                "contactInfoBtn": "Spremeni",
                "contactInfoConfirmBtn": "Potrdi",
                "contactInfoCancelBtn": "Prekliči",
                "contactInfoName": "Ime in priimek",
                "contactInfoAddress": "Naslov",
                "contactInfoPhone": "Telefon",
                "blocades": "Blokade",
                "blockLogin": "Blokada vstopa v spletno banko",
                "blockMobile": "Blokada vstopa v mobilno banko",
                "blockPayment": "Blokada plačilne kartice",
                "accountSettings": "Nastavitve računa",
                "defaultAccount": "Privzeti račun",
                "statementsDelivery": "Način dostave izpiskov",
                "statementsDeliveryPaper": "Po pošti na domači naslov",
                "statementsDeliveryElectronic": "V spletno banko",
                "messagesSettings": "Nastavitve sporočil",
                "messagesSettingsLabel": "Označite, če želite vsa sporočila v spletno banko prejeti tudi na email naslov.",
                "securitySettings": "Varnostne nastavitve",
                "transactionsConfirmation": "Način dodatne potrditve plačil",
                "transactionsConfirmationSMS": "Prejem gesla s SMS sporočilom na mobilno številko",
                "transactionsConfirmationOTP": "Geslo z generatorja gesel",
                "transactionsConfirmationText": "Več informacij na temo potrjevanja transakcij je na voljo na naši ",
                "transactionsConfirmationLink": "spletni strani.",
                "notificationSettings": "Nastavitve obveščanja",
                "gsm": "Številka mobilnega telefona",
                "oldPass": "Trenutno geslo",
                "newPass": "Novo geslo",
                "againPass": "Ponovite novo geslo",
                "noMatch": "Ni zadetkov",
                "change": "Spremeni",
                "street": "Ulica",
                "houseNumber": "Hišna št.",
                "postalCode": "Poštna št.",
                "city": "Kraj",
                "streetRequiredErrMsg": "Vnos ulice je obvezen!",
                "houseNumRequiredErrMsg": "Vnos hišne št. je obvezen!",
                "cityOrPostalCodeRequiredErrMsg": "Vnos kraja ali poštne št. je obvezen!",
                "emailRequiredErroMsg": "Vnos emaila je obvezen!",
                "invalidEmailRequiredErroMsg": "Email ni v pravilni obliki!",
                "orderSoftToken": "Naročilo programskega generatorja gesel",
                "setBlockade": "Blokada poslovanja",
                "passwordFromSMS": "Prejem gesla s SMS sporočilom na mobilno številko",
                "passwordFromOTP": "Geslo z generatorja gesel",
                "additionalTransactionsInfo": "Izbira načina dodatnega potrjevanja transakcij",
                "blockadeOfAddikoEbank": "Blokada poslovanja v Addiko EBank/Addiko Mobile",
                "blockadeOfAddikoEBankText": "Za določen ali nedoločen čas lahko onemogočite uporabo Addiko EBanke/Addiko Mobile.",
                "changeUserBasedNotifications": "Obvestila vezana na uporabnika",
                "accountBasedNotifications": "Obvestila vezana na račune",
                "userBasedNotifications": "Obvestila vezana na uporabnika",
                "forAccount": "Za račun",
                "ebankLoginNotice": "Obvestilo o vstopu v Addiko EBanko",
                "maturedTermDeposit": "Obvestilo ob zapadlosti depozitov (5 dni pred zapadlostjo)",
                "maturedSavings": "Obvestilo ob zapadlosti varčevanja (5 dni pred zapadlostjo)",
                "periodicNotice": "Periodično obvestilo o razpoložljivem stanju na računu",
                "accountBalanceUnder": "Obvestilo o razpoložljivem stanju pod izbranim zneskom",
                "accountBalanceAbove": "Obvestilo o razpoložljivem stanju nad izbranim zneskom",
                "accountInflow": "Obvestilo o prilivu na račun",
                "accountOutflow": "Obvestilo o odlivu z računa",
                "ebankSuccessfull": "Obvestilo o uspešni izvedbi plačila prek Addiko EBanke",
                "ebankUnSuccessfull": "Obvestilo o neuspešni izvedbi plačila prek Addiko EBanke",
                "rejectedSEPA": "Obvestilo o zavrnjeni SEPA direktni obremenitvi",
                "newInvoiceNotice": "Obvestilo o prejemu e-računa v Addiko EBanko",
                "enabled": "Vklopljeno",
                "disabled": "Izklopljeno",
                "enableMail": "Prijavi E-pošto",
                "enableSms": "Prijavi SMS",
                "disableSms": "Odjavi SMS",
                "disableMail": "Odjavi E-pošto",
                "successOrder": "Naročilo je bilo uspešno oddano.",
                "notificationsNote": "Preko Addiko EBanke se lahko naročite na prejemanje obvestil in alarmov ob izbranih dogodkih. Obvestila lahko prejemate na mobilni telefon ali e-poštni naslov. Posredovanje SMS sporočil je plačljiva storitev mobilnega operaterja Telekom Slovenije d.d., ustrezno provizijo za posredovanje SMS sporočil in alarmov vam zaračunava Addiko Bank d.d. v skladu z",
                "notificationsNoteLink": "vsakokrat veljavnim cenikom.",
                "changeEMail": "Nastavitev E-poštnega naslova",
                "emailAddress": "E-poštni naslov",
                "noNumber": "Addiko Bank d.d. v svojih evidencah ne razpolaga z vašo številko mobilnega telefona. Za vnos številke se oglasite v eni od poslovalnic.",
                smsModal: {
                    "user": "Uporabnik",
                    "forAccount": "Za račun",
                    "orderDesc": "Želim naročiti",
                    "email": "E-poštni naslov",
                    "orderNoticeStart": "Z vnosom podatkov potrjujem, da se strinjam s prejemanjem naročenih obvestil.",
                    "orderNoticeStop": "Z vnosom podatkov potrjujem, da se strinjam z odjavo prejemanja naročenih obvestil.",
                    "orderSmsStart1": "Z vnosom podatkov potrjujem, da se strinjam s prejemanjem naročenih obvestil. Izjavljam, da sem prebral/a in v celoti sprejemam ter se strinjam s",
                    "orderSmsStartLink": "Splošnimi pogoji za vodenje TRR in opravljanje plačilnih storitev",
                    "orderSmsStart2": ", katerih del je tudi opis SMS storitve.",
                    "next":"Naprej",
                    "cancel":"Prekliči",
                    "back":"Nazaj",
                    "gsm":"Številka mobilnega telefona",
                    "receivingSmsStart":"Prejemanje SMS obvestil",
                    "receivingEmailStart":"Prejemanje e-poštnih obvestil",
                    "receivingSmsStop":"Odjavo prejemanja SMS obvestil",
                    "receivingEmailStop":"Odjavo prejemanja e-poštnih obvestil",
                    "dailyTimePeriod":"Termin dneva",
                    "noticeAmount":"Znesek obveščanja (V EUR)",
                    "noticeAmountUnder":"Znesek obveščanja pod (V EUR)",
                    "noticeAmountAbove":"Znesek obveščanja nad (V EUR)",
                    "agreedToReceiveNotices":"Strinjanje s prejemanjem obvestil",
                    "agreedToGeneralTerms":"Strinjanje s splošnimi pogoji",
                    "agreedToStopTerms":"Strinjanje s prenehanjem prejemanja obvestil",
                    "yes":"Da",
                    "no":"Ne",
                    "orderDate":"Datum naročila",
                    "orderType":"Vrsta naročila",
                    "daily":"Dnevno",
                    "weekly":"Tedensko",
                    "monthly":"Mesečno",
                    "period":"Perioda",
                    "dailyPeriod":"Termin dneva",
                    weekDays:{
                        "monday":"ponedeljek",
                        "tuesday":"torek",
                        "wednesday":"sreda",
                        "thursday":"četrtek",
                        "friday":"petek",
                        "saturday":"sobota",
                        "sunday":"nedelja"
                    },
                    "newOrder":"Novo naročilo",
                    "archive":"Arhiv",
                  "successMsg":"Naročilo je bilo uspešno oddano."
                },
              "unsubscribeHeader":"Odjava od poslovanja z mobilno banko",
              "unsubscribeText":"Odjava od poslovanja z mobilno banko Addiko Mobile bo stopila v veljavo s prvim dnem naslednjega meseca po oddaji vloge. Za ponovno prijavo na poslovanje z mobilno banko Addiko Mobile izvedite prijavo v Addiko Mobile aplikacijo.",
              "unsubscribeButton":"Odjava",
              "unsubscribeAlertHeader":"Ste prepričani, da se želite odjaviti od uporabe Addiko Mobile banke?"

            },
            orderSoftToken: {
                title: "Naročilo programskega generatorja gesel",
                infoTxt1: "Oddate lahko naročilo za programski generator gesel, ki ga lahko uporabljate namesto strojnega generatorja gesel. Programski generator je aplikacija na vašem mobilnem telefonu, ki omogoča generiranje enkratnih gesel za vstop v Addiko EBanko ter Addiko Mobile in lahko v celoti nadomešča strojni generator gesel.",
                infoTxt2: "Po uspešni izvedbi naročila boste v poštni predal Addiko EBanke ter na številko vašega mobilnega telefona prejeli 2 ločena aktivacijska ključa za aktiviranje programskega generatorja gesel (Soft tokena), ki služi generiranju enkratnih gesel. Več informacij o programskem generatorju gesel lahko dobite",
                linkTxt: "na naši spletni strani.",
                emailLbl: "E-poštni naslov:",
                telephoneLbl: "Številka mobilnega telefona:",
                okBtn: "Potrdi",
                nextBtn: "Naprej",
                cancelBtn: "Prekliči",
                successTxt: "Vaše naročilo je bilo uspešno poslano!",
                changeEmail: "Sprememba e-naslova",
                changeGsm: "Sprememba št. mobilnega telefona",
                backBtn:"Nazaj",
                nameAndSurmane: "Ime in priimek"
            },
            mobilePhoneSettings: {
              setMobilePhoneNumber: "Nastavitev številke mobilnega telefona",
              title: "Nastavitev številke mobilnega telefona za obveščanje",
              headerInfoText: 'V spodnje polje vnesena številka mobilnega telefona služi potrjevanju transakcij ter obveščanju ob izbranih dogodkih. V kolikor želite spremeniti tudi vašo splošno številko mobilnega telefona v banki ter številko mobilnega telefona, vezanega na uporabo MasterCard kartic (SMS OTP, SMS obveščanje), lahko to sporočite preko funkcije "Pošlji sporočilo banki" pod sklopom Sporočila.',
              mobilePhoneLabel: "Številka mobilnega telefona",
              confirmMobilePhone: "POTRJUJEM PRAVILNOST PODATKOV O GSM ŠTEVILKI IN SE STRINJAM, DA MI BANKA NA TO GSM ŠTEVILKO POŠILJA VSA OBVESTILA, VEZANA NA SPLETNO BANKO ADDIKO EBANK. HKRATI ŽELIM NA TO GSM ŠTEVILKO PREJEMATI VARNOSTNO KODO ZA POTRJEVANJE TRANSAKCIJ.",
              firstConfirmationTitle: "Prva potrditev obstoječe številke mobilnega telefona",
              firstConfirmationText: "Če Addiko Bank d.d. razpolaga z vašo številko mobilnega telefona, je slednja že vnešena v polje za vnos. Po potrditvi te številke boste preko SMS sporočila prejeli potrditveno kodo, ki jo vnesite v polje za vnos potrditvene kode v naslednjem koraku. S tem boste veljavnost številke mobilnega telefona tudi formalno potrdili.",
              changingExistingNumberTitle: "Sprememba obstoječe številke mobilnega telefona",
              changingExistingNumberText: "Če Addiko Bank d.d. razpolaga z vašo številko mobilnega telefona, je slednja že vnešena v polje za vnos. Če želite številko mobilnega telefona spremeniti, že navedeno številko v polju zbrišite ter vnesite novo. Po potrditvi te številke boste preko SMS sporočila na vašo DOSEDANJO številko mobilnega telefona prejeli sporočilo s potrditveno kodo, ki jo vnesete v polje za vnos potrditvene kode v naslednjem koraku. S tem boste veljavnost NOVE številke mobilnega telefona tudi formalno potrdili. V kolikor dostopa do vaše DOSEDANJE številke mobilnega telefona nimate več, se morate za vnos oziroma spremembo številke mobilnega telefona oglasiti v eni od Addiko poslovalnic. Po podpisu ustreznega obrazca bomo poskrbeli za formalno potrditev številke vašega mobilnega telefona.",
              newPhoneNumberTitle: "Vnos nove številke mobilnega telefona",
              newPhoneNumberText: "Če Addiko Bank d.d. z vašo številko mobilnega telefona še ne razpolaga, se morate za vnos oziroma spremembo številke mobilnega telefona oglasiti v eni od Addiko poslovalnic. Po podpisu ustreznega obrazca bomo poskrbeli za formalno potrditev številke vašega mobilnega telefona.  Po formalni potrditvi številke mobilnega telefona boste lahko preko SMS sporočil prejemali obvestila in kode za potrjevanje transakcij.",

              orderDate: "Datum naročila",
              orderType: "Vrsta naročila",
              orderTypeInfo: "Nastavitev številke mobilnega telefona za obveščanje",
              dataConfirmation: "Potrditev podatkov",
              additionalPaymentConfirmationTitle: "Dodatna potrditev",
              additionalPaymentConfirmationText: "Dodatna potrditev je potrebna pri plačilih, ki niso shranjena med Predlogami (omejitev ne velja za nakazila med imetniškimi in pooblaščenskimi računi) ter pri spreminjanju številke mobilnega telefona.",
              SMSCode: "Vnesite potrditveno kodo, ki ste jo prejeli v SMS sporočilu:",

              gsmPhoneError: "GSM številka ni v pravilnem formatu.",
              requiredField: "Polje je obvezno.",
              SMSCodeRequired: "Potrditvena koda je obvezna.",
              numberChangeSuccess: "Vaša mobilna telefonska številka je bila uspešno spremenjena."
          }
        };

        $translateProvider.translations('sl', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            settings: {
                "title": "Podešavanja",
                "tabAccount": "NA",
                "tabNotifications": "NA",
                "tabSecurity": "NA",
                "contactInfo": "Vaši kontaktni podaci",
                "contactInfoBtn": "Promijeni",
                "contactInfoConfirmBtn": "Potvrdi",
                "contactInfoCancelBtn": "Otkaži",
                "contactInfoName": "Ime",
                "contactInfoAddress": "Adresa",
                "contactInfoPhone": "Telefon",
                "blocades": "Blokade",
                "blockLogin": "Blokiranje logiranja u internet bankarstvo",
                "blockMobile": "Blokiranje logiranja u mobilno bankarstvo",
                "blockPayment": "Blokiranje kartice za plaćanje",
                "accountSettings": "Postavke računa",
                "defaultAccount": "Podrazumijevani račun",
                "statementsDelivery": "Dostava izvoda",
                "statementsDeliveryPaper": "Dostava izvoda na kućnu adresu",
                "statementsDeliveryElectronic": "Dostava izvoda u putem internet bankarstva",
                "messagesSettings": "Postavke poruka",
                "messagesSettingsLabel": "Označite ako želite da sve poruke od banke primate i na email",
                "securitySettings": "Sigurnosne postavke",
                "transactionsConfirmation": "Potvrda o transakcijama",
                "transactionsConfirmationSMS": "Slanjem SMS-a na mobitel",
                "transactionsConfirmationOTP": "Generisanjem jednokratne zaporke",
                "notificationSettings": "Postavke obaviještenja",
                "gsm":"GSM",
                "oldPass":"Stara lozinka",
                "newPass":"Nova lozinka",
                "againPass":"Potvrdi novu lozinku",
                "noMatch":"Lozinke se ne podudaraju!",
                "change":"Promijeni"
            }
        };

        $translateProvider.translations('mne', data);

    }
} ());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            settings: {
                "title": "Postavke",
                "tabAccountHR": "Korisnički profil",
                "tabNotifications": "Obavijesti",
                "tabSecurity": "NA",
                "contactInfo": "Osobni podaci",
                "contactInfoBtn": "Promijeni",
                "contactInfoConfirmBtn": "Potvrdi",
                "contactInfoCancelBtn": "Otkaži",
                "contactInfoName": "Ime",
                "contactInfoAddress": "Adresa",
                "contactInfoPhone": "Telefon",
                "blocades": "Blokade",
                "blockLogin": "Blokiranje logiranja u internet bankarstvo",
                "blockMobile": "Blokiranje logiranja u mobilno bankarstvo",
                "blockPayment": "Blokiranje kartice za plaćanje",
                "accountSettings": "Postavke računa",
                "defaultAccount": "Podrazumijevani račun",
                "statementsDelivery": "Dostava izvoda",
                "statementsDeliveryPaper": "Dostava izvoda na kućnu adresu",
                "statementsDeliveryElectronic": "Dostava izvoda Internet bankarstvom",
                "messagesSettings": "Postavke poruka",
                "messagesSettingsLabel": "Označite ako želite da sve poruke od banke primate i na email",
                "securitySettings": "Sigurnosne postavke",
                "transactionsConfirmation": "Potvrda o transakcijama",
                "transactionsConfirmationSMS": "Slanjem SMS-a na mobitel",
                "transactionsConfirmationOTP": "Generisanjem jednokratne zaporke",
                "notificationSettings": "Postavke obaviještenja",
                "gsm":"GSM",
              "street": "Ulica",
              "houseNumber": "Kućni broj",
              "postalCode": "Poštanski broj",
              "city": "Grad",
              "streetRequiredErrMsg": "Unos ulice je obavezan!",
              "houseNumRequiredErrMsg": "Unos kućnog broja je obavezan!",
              "cityOrPostalCodeRequiredErrMsg": "Unos grada ili poštanskog broja je obavezan!",
              "emailRequiredErroMsg": "e-mail unos je obavezan!",
              "invalidEmailRequiredErroMsg": "e-mail je neispravan!",
              "showNotificationFor":"Želim primati obavijesti:",
              "notificationSmsNumber":"SMS broj za isporuku obavjesti:",
              "notificationMailAddress":"Email adresa za isporuku obavjesti:"
            }
        };

        $translateProvider.translations('hr', data);

    }
} ());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            settings: {
                "title": "Settings",
                "tabAccount": "Account",
                "tabAccountHR": "User profile",
                "tabNotifications": "Notifications",
                "tabSecurity": "Security",
                "contactInfo": "Your contact information",
                "contactInfoBtn": "Edit",
                "contactInfoConfirmBtn": "Confirm",
                "contactInfoCancelBtn": "Cancel",
                "contactInfoName": "Name and surname",
                "contactInfoAddress": "Address",
                "contactInfoPhone": "Phone",
                "blocades": "Blocades",
                "blockLogin": "Block logins to web banking",
                "blockMobile": "Block logins to mobile banking",
                "blockPayment": "Block payment card",
                "accountSettings": "Accounts settings",
                "defaultAccount": "Default account",
                "statementsDelivery": "Statements delivery",
                "statementsDeliveryPaper": "Home delivery of paper statements",
                "statementsDeliveryElectronic": "Electronic statements in web banking",
                "messagesSettings": "Message settings",
                "messagesSettingsLabel": "Select if you want to recieve all messages from bank also to your email account",
                "securitySettings": "Security settings",
                "transactionsConfirmation": "Transactions confirmation",
                "transactionsConfirmationSMS": "Receive password via SMS on mobile phone number",
                "transactionsConfirmationOTP": "Password from OTP password generator",
                "transactionsConfirmationText": "More information on transaction confirmation can be found on ",
                "transactionsConfirmationLink": "our website.",
                "notificationSettings": "Notification settings",
                "gsm": "Mobile phone number",
                "oldPass": "Old password",
                "newPass": "New password",
                "againPass": "Again new password",
                "noMatch": "No match",
                "change": "Change",
                "street": "Street",
                "houseNumber": "House number",
                "postalCode": "Postal code",
                "city": "City",
                "streetRequiredErrMsg": "Street is required!",
                "houseNumRequiredErrMsg": "House number is required!",
                "cityOrPostalCodeRequiredErrMsg": "City or postal code is required!",
                "emailRequiredErroMsg": "e-mail is required!",
                "invalidEmailRequiredErroMsg": "e-mail is not valid!",
                "orderSoftToken": "Order soft token",
                "setBlockade": "Set blockade",
                "passwordFromSMS": "Receive password via SMS on mobile phone",
                "passwordFromOTP": "Password from OTP password generator",
                "additionalTransactionsInfo": "Select additional transaction confirmation",
                "blockadeOfAddikoEbank": "Blockade of Addiko EBank/Addiko Mobile operations",
                "blockadeOfAddikoEBankText": "You can disable the use of the Addiko EBank/Addiko Mobile for a fixed or indefinite period of time.",
                "userBasedNotifications": "User based notifications",
                "accountBasedNotifications": "Account based notifications",
                "forAccount": "For account",
                "ebankLoginNotice": "Addiko EBank login notice",
                "maturedTermDeposit": "Matured term deposit notice (5 days before maturity)",
                "maturedSavings": "Matured saving notice (5 days before maturity)",
                "periodicNotice": "Notice of available balance on account",
                "accountBalanceUnder": "Notice of account balance under the specified amount",
                "accountBalanceAbove": "Notice of account balance above the specified amount",
                "accountInflow": "Account inflow notice",
                "accountOutflow": "Account outflow notice",
                "ebankSuccessfull": "Addiko EBank successful payment notice",
                "ebankUnSuccessfull": "Addiko EBank unsuccessful payment notice",
                "rejectedSEPA": "Rejected SEPA Direct Debit notice",
                "newInvoiceNotice": "New e-invoice notice",
                "enabled": "Enabled",
                "disabled": "Disabled",
                "mothersLastName": "Mothers last name",
                "email": "Email",
                "lengthError":"Password should contain at least 8 characters in the field New password !",
                "lengthOldError":"Password should contain at least 6 characters in the field Old password !",
                "enableMail": "Enable Email",
                "enableSms": "Enable SMS",
                "disableSms": "Disable SMS",
                "disableMail": "Disable Email",
                "successOrder": "Naročilo je bilo uspešno oddano.",
                "notificationsNote": "You can subscribe to receive the selected notifications and message alerts via the Addiko EBank. You can receive the messages to your mobile phone or your e-mail address. Transmission of SMS messages is a payable service of the telephone provider Telekom Slovenije d.d. Fee for the transmission of SMS messages and alerts is charged accordingly by",
                "notificationsNoteLink": "Addiko Bank d.d. pricelist.",
                "changeEMail": "Set E-Mail address",
                "emailAddress": "E-Mail address",
                "noNumber": "Addiko Bank d.d. does not have your mobile phone number in database. In order to change your mobile phone number, you have to visit the branch office.",
                smsModal: {
                  "user": "User",
                  "forAccount": "For account",
                  "orderDesc": "I want to order",
                  "email": "Email address",
                  "orderNoticeStart": "By entering the data, i agree to receive ordered notices.",
                  "orderNoticeStop": "By entering the data, i agree to stop receiving ordered notices.",
                  "orderSmsStart1": "By entering the data, i agree to receive notices. I declare that i have read and fully agree with the ",
                  "orderSmsStartLink": "General terms and Conditions ",
                  "orderSmsStart2": "for managing transaction account and provision of payment services.",
                  "next":"Next",
                  "cancel":"Cancel",
                  "back":"Back",
                  "gsm":"Mobile phone number",
                  "receivingSmsStart":"Receiving of notifications via sms",
                  "receivingEmailStart":"Receiving of notifications via email",
                  "receivingSmsStop":"Disable automated sms notices",
                  "receivingEmailStop":"Disable automated email notices",
                  "dailyTimePeriod":"Daily time period",
                  "noticeAmount":"Notice amount (EUR)",
                  "noticeAmountUnder":"Notice amount under (EUR)",
                  "noticeAmountAbove":"Notice amount above (EUR)",
                  "agreedToReceiveNotices":"I agree to receive notices",
                  "agreedToGeneralTerms":"I agree with the General Terms and Conditions",
                  "agreedToStopTerms":"I agree to stop receiving notices",
                  "yes":"Yes",
                  "no":"No",
                  "orderDate":"Order date",
                  "orderType":"Order type",
                  "daily":"Daily",
                  "weekly":"Weekly",
                  "monthly":"Monthly",
                  "period":"Period",
                  "dailyPeriod":"Daily period",
                  weekDays:{
                    "monday":"Monday",
                    "tuesday":"Tuesday",
                    "wednesday":"Wednesday",
                    "thursday":"Thursday",
                    "friday":"Friday",
                    "saturday":"Saturday",
                    "sunday":"Sunday"
                  },
                  "newOrder":"New order",
                  "archive":"Archive",
                  "successMsg":"Order was successfully submitted."
                },
              "showNotificationFor":"I want to receive notifications:",
              "notificationSmsNumber":"SMS number for delivering notifications:",
              "notificationMailAddress":"Email address for delivering notifications:",
              "unsubscribeHeader":"Unsubscribing from mobile banking",
              "unsubscribeText":"Unsubscribing from Addiko Mobile bank shall enter into force on the first day of the following month. To re-subscribe to Addiko Mobile bank just log in to your Addiko Mobile application.",
              "unsubscribeButton":"Unsubscribe",
              "unsubscribeAlertHeader":"Are you sure you want to unsubscribe from using Addiko Mobile bank?"
            },
            orderSoftToken: {
                title: "Order soft token",
                infoTxt1: "You can place an order for a soft token, which can be used instead of a hard token. Soft token is an application on your mobile phone, which enables a one-time password generation for signing in to Addiko EBank and Addiko Mobile and can fully replace the hard token.",
                infoTxt2: "After the successful submission of your order you will receive two separate activation codes in your Addiko EBank mailbox and on your mobile phone to activate the soft token, which serves to generate one-time passwords. More information about the soft token can be found",
                linkTxt: "on our website.",
                emailLbl: "Email:",
                telephoneLbl: "Mobile telephone number:",
                okBtn: "Confirm",
                nextBtn: "Next",
                cancelBtn: "Cancel",
                successTxt: "Order submitted successfully!",
                changeEmail: "Change email",
                changeGsm: "Change phone",
                backBtn:"Back",
                nameAndSurmane: "Name and surname"
            },
            mobilePhoneSettings: {
              setMobilePhoneNumber: "Set mobile phone number",
              title: "Set mobile phone number for notifications",
              headerInfoText: 'Mobile phone number is used for notifications on selected events and confirmation of transactions. If you want to change your general mobile phone number in banking systems and mobile phone number used for MasterCard activites (OTP SMS, SMS notifications), you can make a request through function "Send message to the bank" under Messages.',
              mobilePhoneLabel: "Mobile phone number",
              confirmMobilePhone: "I AM CONFIRMING THAT MY MOBILE PHONE NUMBER IS VALID AND I AGREE TO RECEIVE ALL NOTIFICATIONS ON THIS MOBILE PHONE NUMBER. I ALSO WISH TO RECEIVE SAFETY CODES FOR CONFIRMATION OF TRANSACTIONS ON THIS PHONE NUMBER.",
              firstConfirmationTitle: "First confirmation of the existing mobile telephone number",
              firstConfirmationText: "If Addiko Bank d.d. holds your mobile telephone number, the latter has already been entered in the input field. After the confirmation of the number you will receive a confirmation code via a SMS message which you need to enter in the field for the confirmation code. In this way you will officially confirm the validity of your mobile phone number.",
              changingExistingNumberTitle: "Changing the existing number of your mobile phone",
              changingExistingNumberText: "If Addiko Bank d.d. holds your mobile phone number, the latter has already been entered in the field. If you would like to change the number of your mobile phone, delete the already entered one and enter the new one. After the confirmation of this number you will receive a SMS message to your OLD mobile phone number with the confirmation code which you need to enter in the field for the confirmation code. In this way you will officially confirm the validity of the NEW mobile phone number. If you no longer have access to your OLD phone number, you need to make arrangements to change it at one of our Addiko branches. After signing the relevant form we will take care of the official confirmation of your new mobile phone number.",
              newPhoneNumberTitle: "New mobile phone number",
              newPhoneNumberText: "If Addiko Bank d.d. does not hold your mobile phone number yet, you will need to visit one of our Addiko branches. After signing the relevant form we will take care of the official confirmation of your mobile phone number. After the official confirmation of your mobile phone number you will be able to receive notifications and codes for the confirmation of your transactions via SMS messages.",

              orderDate: "Order date",
              orderType: "Order type",
              orderTypeInfo: "Set mobile phone number for notifications",
              dataConfirmation: "Data confirmation",
              additionalPaymentConfirmationTitle: "Additional confirmation",
              additionalPaymentConfirmationText: "Additional confirmation is required for payments which are not saved under Templates (restriction does not apply for transfers between the holder and authorized accounts), and for changing mobile phone number.",
              SMSCode: "Enter the verification code you received via SMS message:",

              gsmPhoneError: "Entered mobile phone number is not in the correct format.",
              requiredField: "Required field.",
              SMSCodeRequired: "Confirmation code is required.",
              numberChangeSuccess: "Your mobile phone number was changed successfully."
            }
        };

        $translateProvider.translations('en', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      settings: {
        "title": "Postavke",
        "tabAccount": "NA",
        "tabNotifications": "NA",
        "tabSecurity": "NA",
        "contactInfo": "Vaši kontaktni podaci",
        "contactInfoBtn": "Promijeni",
        "contactInfoConfirmBtn": "Potvrdi",
        "contactInfoCancelBtn": "Otkaži",
        "contactInfoName": "Ime",
        "contactInfoAddress": "Adresa",
        "contactInfoPhone": "Telefon",
        "blocades": "Blokade",
        "blockLogin": "Blokiranje logiranja/logovanja u internet bankarstvo",
        "blockMobile": "Blokiranje logiranja/logovanja u mobilno bankarstvo",
        "blockPayment": "Blokiranje kartice za plaćanje",
        "accountSettings": "Postavke računa",
        "defaultAccount": "Podrazumijevani račun",
        "statementsDelivery": "Dostava izvoda",
        "statementsDeliveryPaper": "Dostava izvoda na kućnu adresu",
        "statementsDeliveryElectronic": "Dostava izvoda u putem internet bankarstva",
        "messagesSettings": "Postavke poruka",
        "messagesSettingsLabel": "Označite ako želite da sve poruke od banke primate i na email",
        "securitySettings": "Sigurnosne postavke",
        "transactionsConfirmation": "Potvrda o transakcijama",
        "transactionsConfirmationSMS": "Slanjem SMS-a na mobitel",
        "transactionsConfirmationOTP": "Generiranjem/Generisanjem jednokratne zaporke/lozinke",
        "notificationSettings": "Postavke obavještenja",
        "gsm":"GSM",
        "oldPass":"Stara lozinka",
        "newPass":"Nova lozinka",
        "againPass":"Potvrdi novu lozinku",
        "noMatch":"Pogrešna lozinka!",
        "change":"Izmijeni",
        "mothersLastName":"Djevojačko prezime majke",
        "email":"Email",
        "lengthError":" Morate unijeti najmanje 8 znakova u polje Nova lozinka !",
        "lengthOldError":" Morate unijeti najmanje 6 znakova u polje Stara lozinka !"
      }
    };

    $translateProvider.translations('bh', data);

  }
} ());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
          sepa: {
            "header": "Nastavitve SEPA direktnih obremenitev",
            "addNew": "Dodaj nastavitev",
            "newSepaHeader":"Dodaj nastavitev",
            "debitAccountSelectLabel":"Za račun",
            "noData":"Ni podatkov",
            "settingType":"Vrsta nastavitve",
            "amountInputLabel":"Znesek",
            "cancelBtnLabel":"Prekliči",
            "confirmBtnLabel":"Potrdi",
            "edit":"Spremeni",
            "transactionsHeader":"Transakcije SEPA direktnih obremenitev",
            "transactionsSetLimits":"Nastavi limite in omejitve",
            "sepaSuccessCreate": "Naročilo je bilo uspešno oddano",
            "complaint":"Ugovor",
            "refund":"Povračilo",
            limitType: "Vrsta nastavitve",
            "back": "Nazaj",
            "isActive": "Vključena",
            "notActive": "Izključena",
            "changeToActivated": "Ali res želite vključiti nastavitev?",
            "changeToDeactivated": "Ali res želite izključiti nastavitev?",
            "activateSuccess": "Nastavitev je uspešno vključena!",
            "deactivateSuccess": "Nastavitev je uspešno izključena!",
            "requiredSettingTypeError":"Vrsta nastavitve ne sme biti prazna.",
            paymentsType: {
              "rejectedTab":"Zavrnjene transakcije",
              "executedTab":"Izvršene transakcije",
              "pendingTab":"Čakajoče transakcije"
            },
            refundComplaint: {
              "paymentStatus": "Status transakcije",
              "executionDate": "Datum izvršitve plačila",
              "valuteDate": "Datum valute",
              "payersAccNumber": "Številka računa plačnika",
              "recipient" :"Naziv prejemnika",
              "uniqueMandateReference": "Enolična referenca mandata",
              "paymentPurpose": "Namen obremenitve",
              "recIdentifier": "Identifikator prejemnika",
              "recAccNumber": "Račun prejemnika",
              "recRefNumber": "Referenca prejemnika",
              "reasonForComplaint": "Razlog za ugovor",
              "additionalExplanation": "Dodatna obrazložitev",
              "refundTitle": "Ugovor na izvršeno transakcijo SEPA DD",
              "complaintTitle": "Ugovor na transakcijo SEPA DD v čakalni vrsti",
              "next": "Naprej",
              "cancel": "Prekliči",
              "orderComment": "Opomba naročila",
              "reasonForRefund": "Razlog za ugovor"
            },
            "loadMore": "Prikaži več transakcij",
            sepaStatus: {
              "Waiting":"V čakalni vrsti",
              "Processed":"Izvršen",
              "Rejected":"Zavrnjen",
              "ProcessedOrRejected":"Izvršen ili Zavrnjen",
              "Opened":"V obdelavi"
            }
          }
        };

        $translateProvider
            .translations('sl', data);
    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
          sepa: {
            header:"Sepa D.D. Ograničenja i zabrane",
            header_CRO:"Ograničenja SEPA izravnog terećenja",
            transactionsHeader: "SEPA Izravna terećenja",
            addNew:"Dodaj novo ograničenje",
            toAccount: "Račun",
            title: "Unos i promjena ograničenja",
            name: "Naziv",
            address: "Adresa",
            place: "Mjesto",
            inputDate: "Datum unosa",
            restrictSEPA: "Zabrana izvršenja svih SEPA izravnih terećenja (račun u potpunosti nedostupan za SDD uslugu)",
            newSepaHint1: "Napomena: Banka naplaćuje unos/promjene ograničenja SEPA izravnih terećenja sukladno",
            newSepaHint2: "Odluci o naknadama za usluge Banke.",
            dateFrom: "Datum od",
            dateTo: "Datum do",
            limitType: "Vrsta ograničenja",
            whiteList: "Bijela lista",
            blackList: "Crna lista",
            amountRestriction: "Ograničenja iznosa i perioda",
            lastChangeDate: "Datum zadnje promjene",
            operater: "Operater",
            delete: "Obriši",
            confirm: "Potvrdi",
            executionConditions: "Uvjeti izvršenja",
            receiverCalculation: "Računanje identifikatora primatelja",
            receiverId: "Identifikator primatelja",
            receiverName: "Naziv primatelja",
            identifierApproval: "Identifikator suglasnosti",
            singleChargeMaxAmount: "Maksimalni iznos pojedinačnog terećenja",
            dynamicExecution: "Dinamika izvršenja",
            settingType: "Tip postavke",
            cancelBtnLabel: "Odustani",
            signSuccessfull: "SEPA obrazac je uspješno potpisan!",
            deactivate: "Deaktiviraj",
            deactivateAlert: "Jeste li sigurni da želite deaktivirati ovo ograničenje?",
            sepaSettingsRestrictions: "Pregled ograničenja izvršenja",
            sepaSettingsHistory: "Povijest ograničenja izvršenja",
            sepaRequestsOverview: "Pregled zahtjeva",
            refusalOrderBtn: "Odbijanje naloga",
            refusalTitle: "Odbijanje nezaprimljenih SDD naloga",
            refusalAcceptedTitle: "Odbijanje zaprimljenih SDD naloga",
            executionDate: "Datum izvršenja",
            amount: "Iznos",
            refusalReceiverName: "Naziv i sjedište primatelja plaćanja",
            receiverAccount: "Račun primatelja plaćanja",
            receiverNumber: "Poziv na broj primatelja",
            status_created: "Kreiran",
            status_recalled: "Otkazan",
            status_processed: "Obrađen",
            status_rejected: "Odbijen",
            activation: "Aktivacija",
            deactivation: "Deaktivacija",
            payerAccount: "Račun platitelja",
            transactionId: "ID naloga",
            transactionDetails: {
              payerAccount: "Račun platitelja",
              receiverAccount: "Račun primatelja",
              creditorId: "Identifikator primatelja"
            },
            sddPaymentReturn: "Povrat SDD naloga",
            sddPaymentReturnInfo: "Zadali ste zahtjev za povrat novčanih sredstava SDD naloga. Želite li nastaviti s transakcijom ?",
            paymentsType: {
              "rejectedTab":"Odbijeni",
              "executedTab":"Obrađeni",
              "pendingTab":"Zaprimljeni"
            },
            directDebitTabs: {
              pending: "Zaprimljeni SDD nalozi",
              processed: "Obrađeni SDD nalozi",
              rejected: "Odbijeni SDD nalozi",
            },
            "executionPeriod": {
              "":"",
              "WEEKLY":"Tjedno",
              "MONTHLY":"Mjesečno",
              "QUARTERLY":"Kvartalno",
              "HALFYEAR":"Polugodišnje",
              "YEARLY":"Godišnje"
            },
            "executionType":{
              "BLOCK_ALL":"Zabrana izvršenja svih SEPA izravnih terećenja",
              "WHITE_LIST":"Bijela lista",
              "BLACK_LIST":"Crna lista",
              "DYNAMIC_LIST":"Ograničenja iznosa i perioda",
              "AMOUNT":"Ograničenje prema iznosu i dinamici izvršenja"
            },
            "isActive": "Aktivan",
            "notActive": "Neaktivan",
            "edit":"Uredi",
            "executionPeriodLabel":"Period izvršenja: ",
            "additionalInfo":"Razlog odbijanja"
          }
        };

        $translateProvider
            .translations('hr', data);
    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      sepa: {
        "header": "SEPA Direct Debit Settings",
        "addNew": "Add a new setting",
        "newSepaHeader": "Add new SEPA direct debit setting",
        "debitAccountSelectLabel": "For account",
        "noData": "No data",
        "settingType": "Setting type",
        "amountInputLabel": "Amount",
        "cancelBtnLabel": "Cancel",
        "confirmBtnLabel": "Confirm",
        "edit": "Edit",
        "transactionsHeader": "SEPA Direct Debit Transactions",
        "transactionsSetLimits": "Set limits and restrictions",
        "sepaSuccessCreate": "Order was successfully submitted",
        "complaint": "Refusal",
        "refund": "Refund",
        "back": "Back",
        "isActive": "Activated",
        "notActive": "Deactivated",
        "changeToActivated": "Do you really want to activate the setting?",
        "changeToDeactivated": "Do you really want to deactivate the setting?",
        "activateSuccess": "Setting is successfully activated!",
        "deactivateSuccess": "Setting is successfully deactivated!",
        "requiredSettingTypeError": "Settings type should not be left empty.",
        // CROATIA
        header_CRO: "SEPA direct debit limit",
        toAccount: "Account",
        title: "Creation and change of limit",
        name: "Name",
        address: "address",
        place: "Place",
        inputDate: "Input date",
        restrictSEPA: "Zabrana izvršenja svih SEPA izravnih terećenja (račun u potpunosti nedostupan za SDD uslugu)",
        newSepaHint1: "Note: Bank is charging entry/change of SEPA direct debit limitations in accordance with the",
        newSepaHint2: "Decision on Bank service charges.",
        dateFrom: "Date from",
        dateTo: "Date to",
        limitType: "Limit type",
        whiteList: "White list",
        blackList: "Black list",
        amountRestriction: "Restrictions on amount and period",
        lastChangeDate: "Date of last change",
        operater: "Operater",
        delete: "Delete",
        confirm: "Confirm",
        executionConditions: "Execution conditions",
        receiverCalculation: "Calculating an identifier of the recipient",
        receiverId: "Receiver identifier",
        receiverName: "Receiver name",
        identifierApproval: "Identifier approval",
        singleChargeMaxAmount: "The maximum amount of single charge",
        dynamicExecution: "Dynamic execution",
        signSuccessfull: "SEPA form is successfully signed!",
        deactivate: "Deactivate",
        deactivateAlert: "Do you really want to deactivate the setting ?",
        sepaSettingsRestrictions: "Overview of execution limit",
        sepaSettingsHistory: "History of execution limits",
        sepaRequestsOverview: "Overview of requests",
        refusalOrderBtn: "Reject order",
        refusalTitle: "Rejection of not accepted SDD orders",
        refusalAcceptedTitle: "Rejection of accepted SDD orders",
        executionDate: "Execution date",
        amount: "Amount",
        refusalReceiverName: "Receiver name and address",
        receiverAccount: "Receiver account",
        receiverNumber: "Receiver number",
        status_created: "Created",
        status_recalled: "Recalled",
        status_processed: "Processed",
        status_rejected: "Rejected",
        activation: "Activation",
        deactivation: "Deactivation",
        payerAccount: "Payer account",
        transactionId: "Transaction ID",
        transactionDetails: {
          payerAccount: "Payer account number",
          receiverAccount: "Receiver account number",
          creditorId: "Creditor identifier"
        },
        sddPaymentReturn: "Refund SDD order",
        sddPaymentReturnInfo: "You have filed a claim for the repayment of SDD money order funds. Want to continue with the transaction ?",
        paymentsType: {
          "rejectedTab": "Rejected transactions",
          "executedTab": "Executed transactions",
          "pendingTab": "Pending transactions"
        },
        directDebitTabs: {
          pending: "Accepted SDD orders",
          processed: "Processed SDD orders",
          rejected: "Rejected SDD orders"
        },
        refundComplaint: {
          "paymentStatus": "Payment status",
          "executionDate": "Date of execution",
          "valuteDate": "Execution date",
          "payersAccNumber": "Payer's account number",
          "uniqueMandateReference": "Unique mandate reference",
          "recipient": "Recipient",
          "recAccNumber": "Recipient's account number",
          "recIdentifier": "Recipient's identifier",
          "paymentPurpose": "Payment purpose",
          "recRefNumber": "Recipient's reference number",
          "reasonForRefund": "Reason for Refund",
          "reasonForComplaint": "Reason for Refusal",
          "additionalExplanation": "Additional explanation",
          "refundTitle": "Refund of SEPA DD transaction",
          "complaintTitle": "Refusal of SEPA DD transaction",
          "next": "Next",
          "cancel": "Cancel",
          "orderComment": "Order comment"
        },
        "loadMore": "Load more payments",
        sepaStatus: {
          "Waiting": "Pending",
          "Processed": "Successfully processed",
          "Rejected": "Rejected",
          "ProcessedOrRejected": "Processed or rejected"
        },
        "executionPeriod": {
          "": "",
          "WEEKLY": "Weekly",
          "MONTHLY": "Monthly",
          "QUARTERLY": "Quarterly",
          "HALFYEAR": "Semi annually",
          "YEARLY": "Annually"
        },
        "executionType": {
          "BLOCK_ALL": "Refuse all SEPA direct debits",
          "WHITE_LIST": "White List",
          "BLACK_LIST": "Black List",
          "DYNAMIC_LIST": "Amount and period limitation",
          "AMOUNT": "Limit by amount and frequency"
        },
        "executionPeriodLabel": "Execution period:",
        "additionalInfo":"Additional info"
      }

    };

    $translateProvider
      .translations('en', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      secure3d: {
        text1: 'Addiko sigurna internetska kupnja je usluga koja Vam, ovisno o kartici koju koristite, pruža najviše ' +
        'sigurnosne standarde Mastercard Secure Code odnosno Verified by Visa, kojima ste zaštićeni od neautorizirane ' +
        'upotrebe Vaših kartica na internetu.',
        text12: ' Uslugu je prije korištenja potrebno aktivirati, a kada ju aktivirate ' +
        'ona vrijedi za sve Addiko kartice. Nije potrebno aktivirati uslugu za svaku pojedinu karticu.',
        text2: 'Aktivacija je obavezna i provodi se na web stranici ',
        text3link: 'Addiko Banke',
        text4: ' gdje možete pročitati sve detalje o usluzi i načinu aktivacije.',
        text5: 'Aktivirajte odmah uslugu sigurne internetske kupnje za sve svoje Addiko kartice i kupujte sigurno!',
        buttonText: 'Želim aktivirati uslugu',
        buttonTitle: 'Sigurna internetska kupnja'
      }
    };

    $translateProvider.translations('hr', data);

  }
}());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
        secure3d: {
          text1: 'Addiko Secure Online Shopping is a service that provides the most secure standards that protect you '+
          'from unauthorized use of your cards on the Internet. Depending on the type of the card that you use, ' +
          'either Mastercard Secure Code or Veryfied by Visa is engaged.',
          text12: 'The service needs to be activated prior to ' +
          'the first use. However, you activate it only once and it is applied to all of your Addiko cards. ' +
          'It is not necessary to activate the service for each card separately.',
          text2: 'The activation is mandatory and is being processed at the ',
          text3link: "Addiko Bank's",
          text4: ' website where you are going to be presented with all the details about the service and the activation procedure.',
          text5: 'Activate your Secure Online Shopping service today and shop safely!',
          buttonText: 'I want to activate the service',
          buttonTitle: 'Sigurna internetska kupnja'
        }
    };

    $translateProvider.translations('en', data);

  }
}());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      payments: {
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayments": "Nalog za prenos",
        "currencyConversion": "Konverzija valuta",
        "internationalPayment": "Internacionalno plaćanje",
        "rejectedPayments": "Odbijene uplate",
        "pendingPayments": "Uplate na čekanju",
        "templates": "Predlošci",
        "searchTemplateName": "Traži predložak po nazivu",
        "topUsed": "Najčešće upotrebljeni",
        "alphabetically": "Po abecedi",
        "to": "ka",
        "showMoreTemplates": "Prikaži više predložaka",
        "eInvoices": "eRačuni",
        "showMoreInvoices": "Prikaži sve eRačune",
        "sepaDirectDebit": "SEPA izravno dugovanje",
        "viewAllTransactions": "Pregled svih transakcija",
        "due": "dospio",
        "allPastPayments": "Pregled svih izvršenih plaćanja",
        "exchangeRatesList": "Tečajna lista",
        "pay": "Plati",
        "internalTransfer": "Interni prenos",
        "noEinvoices": "Nema podataka za eRačune",
        "noTemplates": "Nema podataka za predloške",
        "forCurrencyConversion": "pretvorba valuta",
        "midrate": "srednja stopa",
        "forForeignNotes": "strane bilješke, čekovi",
        "onDate": "dana ",
        "buy": "Kupi",
        "goBackToPayments": "Povratak na plaćanja",
        "currencyName": "Naziv valute",
        "code": "Kod",
        "unit": "Jedinica",
        "buyRate": "Kupovni kurs",
        "middleRate": "Srednji kurs",
        "sellRate": "Prodajni kurs",
        "action": "Akcija",
        "noRejectedPayments": "Za odabrani period nema odbijenih uplata",
        "noPendingPayments": "Za odabrani period nema uplata na čekanju",
        "donationToCharity": "Donacija u dobrotvorne svrhe",
        "subscribe": "Pretplata",
        "settings": "Postavke",
        "moreRejected": "Još odbijenih plaćanja",
        "morePending": "Još plaćanja na čekanju",
        "currencyExchange": "Menjačnica",
        "exchange": "Razmeni",
        "fromAccount": "Sa računa",
        "toAccount": "Na račun",
        "willSell": "Prodaja",
        "willBuy": "Kupovina",
        "available": "Dostupno",
        "delete": "Obriši",
        "edit": "Promeni",
        "loanPayment": "Plaćanje kredita",
        "paymentMode": "Svrha plaćanja",
        "toAcc": "na račun",
        "fromAcc": "s računa",
        "bicNumber": "BIC broj",
        "bicBankName": "Banka primaoca",
        "bicAddress": "BIC adresa",
        "bicCity": "BIC grad",
        "bicCountry":"Država",
        "bicRecipientStatus": "Primalac (osoba)",
        "bicRecipientStatusOptionLegal": "Pravna",
        "bicRecipientStatusOptionPhysical": "Fizička",
        "bicBankCharges": "Troškovna opcija",
        "bicNumberRequired": "BIC adresa je obavezna!",
        "bicBankNameRequired": "Banka primaoca je obavezna!",
        "bicCityRequired": "BIC grad je obavezan!",
        "bicCountryRequired": "Država je obavezna!",
        "resend": "Pošalji ponovo",
        "minimalAccountNumber": "Račun nije ispravan!",
        "cancel": "Odustani",
        "templateSavedSuccessfully": "Uspešno ste kreirali šablon !",
        "templateUpdatedSuccessfully": "Promena šablona je uspešno izvršena !",
        "bankAddressInputRequired": "Bank address is required!."
      },
      paymentsOverview: {
        "pohReciver": " za ",
        "pohAmount": " u iznosu od ",
        "pohDate": " na dan ",
        "povlStatus": "Status",
        "povlId": "Id naloga",
        "povlReceiver": "Naziv primaoca",
        "povlFrom": "Sa računa",
        "povlTo": "Na račun",
        "povlAmount": "Iznos",
        "povlDueDate": "Datum izvršenja",
        "povlValueDate": "Datum valutacije",
        "filterStatus": "Filtriraj po statusu",
        "loadMoreBtn": "Prikaži još naloga",
        "referenceTo": "Model i poziv na broj",
        "titleLabel": "Lista naloga",
        "signatoryName": "Potpisnik",
        "signDate": "Datum akcije",
        "paymentsType": {
          "all": "Svi",
          "opened": "Za potpis",
          "partiallysigned": "Djelimično potpisani",
          "cancelled": "Otkazani",
          "processed": "Izvršeni",
          "rejected": "Odbijeni",
          "closed": "Zatvoreni",
          "signed": "Potpisani",
          "notSigned": "Za potpis",
          "inprocessing": "U obradi",
          "forcancelling": "Za otkazivanje",
          "storned": "Stornirani",
          "rejectedaftercomplaint": "Odbijeni nakon žalbe",
          "acceptedaftercomplaint": "Prihvaćeni nakon žalbe",
          "allTab": "Svi",
          "realizedTab": "Realizovani nalozi",
          "pendingTab": "Nalozi na čekanju",
          "rejectedTab": "Odbijeni nalozi"
        },
        dateRange: "Filtriraj prema razdoblju",
        "dateFrom": "vrijeme od",
        "dateTo": "vrijeme do",
        "filterByPurpose": "Pretraži po namjeni",
        "noPaymentData": "Za odabrani filter nema naloga.",
        "selectAll": "Izaberi sve",
        "selectNone": "Poništi izbor",
        "signSelectedPayments": "Potpiši odabrana plaćanja",
        "povlNote":"Napomena",
        "referenceNumber": "Referentni broj",
        "cancelled": "Opozvan",
        "processed": "Izvršen",
        "rejected": "Odbijen",
        "open": "Kreiran - nepotpisan",
        "inProcessing": "U obradi",
        "waitingQueque": "Na čekanju",
        "signed": "Potpisan",
        "Cancelled": "Opozvan",
        "Processed": "Izvršen",
        "Rejected": "Odbijen",
        "Opened": "Kreiran - nepotpisan",
        "InProcessing": "U obradi",
        "WaitingQueue": "Na čekanju",
        "Signed": "Potpisan"
      },
      domesticPayment: {
        "header": "Nalog za prenos",
        "fromAccountSelectLabel": "Sa računa",
        "availableAmountLabel": "Raspoloživo",
        "purposeCodeSelectLabel": "Šifra plaćanja",
        "purposeOfPaymentInputLabel": "Svrha plaćanja",
        "amountInputLabel": "Iznos",
        "dateInputLabel": "Datum",
        "bicCodeInputLabel": "BIC kod",
        "toAccountInputLabel": "Račun primaoca",
        "toAccountInputLabelSRB": "Račun primaoca",
        "toPayee": "Primalac",
        "toAccountInputBtn": "Dopuni primaoca",
        "referenceNumberLabel": "Model i poziv na broj",
        "referenceModelLabel": "Reference model",
        "receiversNameInputLabel": "Naziv primaoca",
        "receiversAddressInputLabel": "Adresa primaoca",
        "receiversPostalCodeAndCityInputLabel": "Mesto primaoca",
        "receiversCountrySelectLabel": "Zemlja primaoca",
        "payersNameInputLabel": "Ime i prezime pošiljaoca",
        "payersAddressInputLabel": "Adresa pošiljaoca",
        "payersCityInputLabel": "Grad pošiljaoca",
        "amountPlaceholder": "eg. 1.000,00",
        "reviewAndSubmitBtn": "Pregledajte i pošaljite",
        "selectUrgentLabel": "Označite kao hitnu uplatu",
        selectUrgentLabelSRB: "Označite kao hitnu uplatu",
        "urgentPaymentInfo": "Hitna plaćanja se naplaćuju po važećoj Tarifi Banke",
        "processingFeeLabel": "Naknada za obradu naloga",
        "receiverAccountError": "Račun primaoca je obavezan!",
        "receiverAccountErrorHR":"IBAN / Broj računa primaoca je obavezan!",
        "receiverNameError": "Naziv primaoca je obavezan!",
        "receiverCityError": "Grad primaoca je obavezan!!",
        "receiverAddressError": "Adresa primaoca je obavezna!",
        "sepaDebitorLabel": "Stvarni dužnik",
        "sepaReceiverLabel": "Krajnji primalac",
        "confirmBtn": "Potvrdi",
        "selectFromTemplate": "Plaćanje iz šablona",
        "listOfTemplates": "Šabloni",
        "bankCharges": "Provizija",
        "urgentPayment": "Ovaj nalog je hitan",
        "checkBankCharges": "Proveri dodatne naknade",
        "referenceModelInputError": "Poziv na broj je obavezan!",
        "referenceModelInputInvalid": "Poziv na broj nije ispravan!",
        "toPayeeInputError": "Naziv primaoca je obavezan!",
        "toPayee2":"Primalac (naziv/ime i adresa)",
        "newPayment":"Novi nalog",
        "delete":"Obriši",
        "edit":"Promeni",
        "sign":"Potpiši",
        "ibanStructError":"IBAN nije ispravan",
        "taxPayerNumber": "Broj poreznog obveznika",
        "paymentType": "Vrsta uplate",
        "revenueCode": "Vrsta prihoda",
        "municipality": "Općina/opština",
        "taxPeriodFrom": "Poreski period od",
        "taxPeriodTo": "Poreski period do",
        "budgetOrganisation": "Budžetska organizacija",
        "taxPayerError": "Broj poreznog obveznika je obavezan!",
        "revenueCodeError": "Vrsta prihoda je obavezna!",
        "budgetOrganizationError": "Budžetska organizacija je obavezna!",
        "municipalityError": "Općina/opština je obavezna!",
        "municipalityExistanceError": "Općina/opština ne postoji!",
        "taxPeriodRangeError": "Poreski period nije u ispravnom opsegu!",
        "revenueCodeTypeError": "Tip prihoda ne odgovara tipu računa!",
        "revenueCodeExistanceError": "Vrsta prihoda ne postoji!",
        "receiverAccountMinLengthError": "Račun primaoca mora imati 16 karaktera!",
        "receiverAccountModuleError": "Račun primaoca nije korektan!",
        "referenceNumberRequired": "Poziv na broj je obavezan za javne prihode!",
        "referenceNumberMaxLength": "Poziv na broj je prevelik!",
        "referenceNumberError": "Poziv na broj nije validan!"
      },
      internationalPayment: {
        international: "Internacionalno plaćanje",
        "fromAccount": "Sa računa",
        "chargeAccount": "Račun naknade",
        "totalAmount": "Ukupan iznos i valuta",
        "paymentDate": "Datum plaćanja",
        "paymentPurpose": "Svrha uplate",
        "recipient": "Primalac",
        "purposeCode": "Šifra svrhe",
        "recipientStatus": "Status primaoca",
        "companyName": "Ime i prezime ili puni naziv tvrtke",
        "address": "Adresa",
        "city": "Grad",
        "country": "Država",
        "recipientAccount": "Račun primaoca",
        "recipientBank": "Banka primaoca",
        "bankName": "Naziv banke",
        "swiftCode": "SWIFT kod",
        "bankCharges": "Bankovna naknada",
        "sharedCharges": "Zajednički troškovi",
        "payersPaysCharges": "Isplatitelj plaća troškove",
        "beneficiaryPaysCharges": "Korisnik plaća troškove",
        "naturalPerson": "Fizičko lice",
        "legalPerson": "Pravno lice",
        "tooltipInfo": "Trebate pomoć?",
        "fillData": "Popunite podatke o banci",
        "reviewandSubmit": "Pregled i potvrda",
        "companyNameInputError": "Ime i prezime je obavezno!",
        "recipientAddressInputError": "Adresa primaoca je obavezna!",
        "recipientCityInputError": "Grad primaoca je obavezan!",
        "recipientAccountInputError": "Račun primaoca je obavezan!",
        "bankNameInputError": "Naziv banke je obavezan!",
        "bankAddressInputError": "Adresa banke je obevezna!",
        "bankCityInputError": "Grad banke je obavezan!",
        "swiftCodeInputError": "SWIFT kod je obavezan!",
        "payersNameInputLabel": "Ime i prezime pošiljaoca",
        "payersAddressInputLabel": "Adresa pošiljaoca",
        "payersCityInputLabel": "Grad pošiljaoca",
        "sepaDebitorLabel": " Stvarni dužnik",
        "sepaReceiverLabel": "Krajnji primalac",
        "paymentMode": "Svrha plaćanja",
        "toPayee2":"Primalac (naziv/ime i adresa)",
        "toAccountInputLabel": "IBAN / Broj računa primaoca",
        "bicBankName": "Banka primaoca",

      },
      internalTransfer: {
        "transferToAccount": "Prenos na moj račun",
        "fromAccount": "Račun platitelja (IBAN)",
        "toAccount": "Račun primaoca (IBAN)",
        "dueDate": "Datum izvršenja",
        "valueDate": "Datum kreiranja",
        "amount": "Iznos",
        "sign": "Potpiši",
        "saveAsTemplate": "Sačuvaj kao šablon",
        "templateName": "Naziv šablona",
        "newPayment": "Kreiraj novi nalog",
        "toPaymentOverview": "Idi na pregeled svih plaćanja",
        "signSuccess": "Platni nalog je uspješno potpisan.",
        "toAccountInputError": "Račun primaoca je obavezan!",
        "paymentPurposeInputError": "Svrha uplate je obavezna!",
        "amountInputError": "Iznos je obavezan!",
        "dueDateError": "Datum izvršenja je obavezan!",
        "templateNameError": "Naziv je obavezan!",
        "when": "Datum",
        "transferComplete": "Prenos je završen",
        "makeAnotherPayment": "Kreiraj novi nalog",
        "successfullyTransfer": "Uspješno ste prebacili",
        "amountLengthError": "Maksimalni iznos je 9",
        "nodata": "Nema podataka za prikaz"
      },
      paymentSignModal: {
        title: "Potpisivanje",
        challengeResponse: "Unesite kod",
        ok: "Uredu"
      },
      loanPayment: {
        "loanPayment": "Plaćanje kredita",
        "recieverNumber": "Broj primaoca",
        "purpose": "Svrha plaćanja",
        "when":"Datum",
        "exchangeRate":"Kurs",
        "referenceNumber":"Model i poziv na broj"
      },
      currencyConversion: {
        "exchangeOffice": "Kupoprodaja deviza",
        "exchangeRatesCalculator": "Lista valuta i kalkulator",
        "sellingAmount": "Prodaja",
        "buyingAmount": "Kupovina",
        "availableBalance": "Raspoloživo stanje",
        "fromAccount": "Sa računa",
        "toAccount": "Na račun",
        "amount": "Iznos",
        "sign": "Potpiši",
        "confirm": "Potvrdi",
        "back": "Novi nalog",
        "smsAuthentification": "SMS autentifikacija plaćanja",
        "sendSms": "Pošalji SMS kod",
        "smsPassword": "SMS jednokratna šifra",
        "moneyExchangeComplete": "Novčana razmjena je završena",
        "successfullyExchange": "Uspješno ste razmjenili",
        "makeAnotherExchange": "Napravi još jednu razmjenu",
        "goToPayments": "Idi na pregled naloga",
        "exchangeRateRatio": "Kursna lista",
        "exchangeOrder": "Lista naloga za kupoprodaju deviza",
        "signPayment": "Potpiši nalog",
        "deletePayment": "Obriši nalog",
        "recallPayment": "Opozovi nalog",
        "balance":"Stanje računa",
        "exchangeRate":"Kurs menjačnice",
        "bankCharges":"Cenovnik",
        "when":"Datum",
        "buying":"Kupovni kurs",
        "selling":"Prodajni kurs",
        "calculatedAmount":"Preračunati iznos",
        "agreedRate":"Kurs"
      },
      paymentsAndTransferOverview: {
        rejectedLabel:"Poslednji neplaćeni nalozi",
        eInvoicesLabel:"Neplaćeni eRačuni",
        groupedPaymentsLabel:"Grupa naloga za potpis",
        repeatAction:"Ponovi",
        payAction:"Plati",
        signAllAction:"Potpiši sve",
        domPayToSign:"opštih naloga za potpis",
        paymentsToSign: "naloga za potpis",
        "confirm": "Potvrdi"
      },
      ebook: {
        "ebookPayIn":"Uplata na eknjižicu",
        "ebookPayOut": "Isplata sa eknjižice"
      },
      savings: {
        "savingsPayIn": "Interni devizni prenos"
      },
      signPayments: {
        "paymentsInvalidDueDate": "Neka od plaćanja imaju neispravan datum izvršenja. Da li želite da se datumi ažuriraju na prvi ispravan datum prema terminskom planu banke?",
        "singlePaymentInvalidDueDate": "Odabrani nalozi imaju neispravan datum izvršenja. Da li želite da ažurirate datum na prvi naredni radni dan u skladu sa terminskim planom?",
        "updatePaymentsDueDate": "Ažuriraj krajnje datume plaćanja",
        "updatePaymentDueDate": "Ažuriraj datum izvršenja",
        "dateCreated": "Datum kreiranja",
        "dueDate": "Datum izvršenja",
        "confirm": "Potvrdi",
        "challengeResponse": "Kod potvrde",
        "challenge": "Validacijski kod",
        "challengeFirstCode": "Šifra 1 (unosi se u token)",
        "challengeSecondCode": "Šifra 2 (iz tokena)",
        "challengeDescription": "Uključite token, unesite PIN i odmah na prazan ekran (piše samo CHAL na vrhu) unesite broj koji je ispisan na ekranu 'Šifra 1', i kliknite na gumb 'OK'. Token će ispisati šifru 2 koju je potrebno prepisati u polje 'Šifra 2'. Kada ste završili akciju, odaberite gumb 'POTVRDI'.",
        "finalStepSuccessfullySigned": "Uspešno ste potpisali nalog",
        "finalStepPaymentServices": "Za usluge platnog prometa naknada će biti obračunata u skladu sa službenim ",
        "finalStepBankTariff": "cenovnikom Banke.",
        "finalStepStatus": "Status: ",
        "finalStepPaymentID": "Broj transakcije: ",
        "finalStepNumberOfPayments": "Broj naloga: ",
        "finalStepSentForProcessing": "Nalog je poslat u Banku na obradu.",
        "finalStepPaymentSloHeaderEx": "N/A",
        "finalStepPaymentSloHeaderPen": "N/A",
        "finalStepPaymentSloSubHeader": "N/A",
        "finalStepPaymentSloSubHeaderLink": "N/A",
        "finalStepPaymentSloTextEx": "N/A",
        "finalStepPaymentSloTextPen": "N/A",
        "cancel":"Odustani",
        "resendSms": "Ponovo pošalji SMS",
        "SmsCode": "SMS kod",
        "SmsDescription": "SMS poruka je poslata na Vaš uređaj. Unesite kod iz SMS poruke u polje 'SMS kod'. Nakon unosa koda, odaberite opciju 'POTVRDI'. SMS kod važi 120 sekundi i nakon toga se ne može koristiti.",
        "SmsSentSuccessfully": "SMS poruka uspešno poslata!",
        "paymentExecutionDateTitle": "Promena datuma valute",
        "paymentExecutionDateBody": "Obrada naloga je završena. Da li se slažete da se datum valute promeni na sledeći radni dan ?",
        "infoDomSrb0":"Vaše plaćanje će biti izvršeno u skladu sa definisanim vremenskim okvirima ",
        "infoDomSrb1":"(Terminski plan).",
        "infoDomSrbLink":""
      },
      paymentActions: {
        "repeat": "Ponovi nalog",
        "copy": "Dupliraj",
        "delete": "Obriši",
        "print": "Štampa",
        "recall": "Opozovi nalog",
        "sign": "Potpiši",
        "cancel": "Otkaži",
        "rejectRecall": "Odbij zahtjev",
        "approveRecall": "Prihvati zahtjev",
        "edit":"Izmeni",
        "confirmation": "Order confirmation"
      },
      statementConfirmModalTranslations: {
        title: "Izjava",
        p1: "Sukladno Zakonu o međunarodnim mjerama ograničavanja u Banci za provedbu naloga, potrebno je popuniti ovu Izjavu. U protivnom, nalog neće biti proveden.",
        p2: "Pod kaznenom i materijalnom odgovornošću izjavljujem da je, za nalog u iznosu od ",
        p2_2: " za državu",
        p2_0: " osnova plaćanja",
        p2_1: "detaljno obrazloženje (specifikacija)*",
        p4: "Izjava je kreirana u elektroničkom obliku i važeća je bez pečata i potpisa.",
        radioMerchandise: "Roba*",
        radioPresent: "Poklon",
        radioOther: "Ostalo*",
        confirmButton: "Potvrdi",
        cancelButton: "Odustani"
      },
      "currencyCalculator": {
        "exchangeCalculator": "Valutni kalkulator",
        "exchangeRates": "Valutni kurs",
        "msg1": "Tečajna lista primjenjuje se za kupnju i prodaju deviza do iznosa protuvrijednosti od HRK 150.000,00",
        "msg2": "Za veće iznose molimo kontaktirajte Odjel Prodaje proizvoda Riznice Addiko Banke na " +
        "tel.: 01 603 3513, 01 603 1746, 01 603 0616, 01 603 3533. ili 01/603-0889, i za regiju Slavonija i Baranja " +
        "tel: 031/231-553 i 031/231-223.",
        "updated":"Ažurirano"
      },
      paymentsReturn: {
        openedTab: "Za potpis",
        archivedTab: "Arhivirani",
        titleLabel: "Suglasnost za povrat sredstava",
        modalTitle: "Odaberite razlog za povrat sredstava",
        recallReason: "Razlog za povrat",
        additionalInfo: "Dodatne informacije",
        additionalInfoError: "Ovo polje je obavezno",
        reasonTech: "Tehnički problemi koji rezultiraju pogrešnim platnim nalogom kreditnog transfera",
        reasonFrad: "Lažno iniciranje platnog naloga kreditnog transfera (required additiona info field)",
        reasonDupl: "Duplo slanje"
      },
      paymentsFinal: {
        "InProcessing":"U obradi",
        "Signed":"Potpisan",
        "WaitingQueue":"Nalog je poslat na čekanje"
      },
      paymentsTypeGroup: {
        "CurrencyExchange":"Kupo-prodaja",
        "LocalCurrencyTransfer":"Interni prenos",
        }
    };

    $translateProvider
      .translations('sr', data);
  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            payments: {
                "quickPaymentTransfer": "Hitro plačilo ali prenos",
                "domesticPayments": "Univerzalni plačilni nalog (UPN)",
                "currencyConversion": "Menjava valut",
                "internationalPayment": "Plačilo v tujino",
                "rejectedPayments": "Zavrnjena plačila",
                "pendingPayments": "Čakalna vrsta plačil",
                "templates": "Predloge",
                "searchTemplateName": "Išči po imenu predloge",
                "topUsed": "Najpogosteje uporabljene",
                "alphabetically": "Po abecedi",
                "to": "za",
                "showMoreTemplates": "Prikaži več predlog",
                "eInvoices": "eRačuni",
                "showMoreInvoices": "Prikaži vse eRačune",
                "sepaDirectDebit": "SEPA direktne obremenitve",
                "viewAllTransactions": "Pregled vseh transakcij",
                "due": "Rok plačila",
                "allPastPayments": "Pregled vseh izvršenih plačil",
                "exchangeRatesList": "Tečajna lista",
                "pay": "Plačaj",
                "internalTransfer": "Interni prenos",
                "noEinvoices": "Ni eRačunov za prikaz",
                "noTemplates": "Ni shranjenih predlog",
                "forCurrencyConversion": "menjava valut",
                "midrate": "srednji tečaj",
                "forForeignNotes": "tuji čeki",
                "onDate": "dni ",
                "buy": "Kupi",
                "goBackToPayments": "Nazaj na plačila",
                "currencyName": "Naziv valute",
                "code": "Koda",
                "unit": "Enota",
                "buyRate": "Nakupni tečaj",
                "middleRate": "Srednji tečaj",
                "sellRate": "Prodajni tečaj",
                "action": "Akcija",
                "noRejectedPayments": "V izbranem obdobju ni bilo zavrnjenih plačil.",
                "noPendingPayments": "Za izbrano obdobje ni plačil v čakalni vrsti.",
                "donationToCharity": "Plačilo v humanitarne namene",
                "subscribe": "Prijava",
                "settings": "Nastavitve",
                "moreRejected": "Prikaz večih zavrnjenih plačil",
                "morePending": "Prikaz večih plačil v čakalni vrsti",
                "currencyExchange": "Menjalnica",
                "exchange": "Zamenjaj",
                "fromAccount": "Z računa",
                "toAccount": "Na račun",
                "willSell": "Prodaja",
                "willBuy": "Nakup",
                "available": "Na voljo",
                "delete": "Izbriši",
                "edit": "Spremeni",
                "loanPayment": "Plačilo kredita",
                "toAcc": "na račun",
                "paymentMode": "Namen plačila",
                "fromAcc": "z računa",
                "bicNumber": "SWIFT oznaka",
                "bicNumber_SLO": "SWIFT oznaka",
                "bicBankName": "Banka prejemnika",
                "bicAddress": "Naslov banke prejemnika",
                "bicBankAddress": "Naslov banke prejemnika",
                "bicCity": "Kraj banke prejemnika",
                "bicCountry": "Država banke prejemnika",
                "bicCountry_SLO": "Država banke prejemnika",
                "bicRecipientStatus": "Status prejemnika",
                "bicRecipientStatusOptionLegal": "Pravna oseba",
                "bicRecipientStatusOptionPhysical": "Fizična oseba",
                "bicBankCharges": "Stroški plačila",
                "bicNumberRequired": "Vnos BIC kode je obvezen!",
                "bicNumberMaxLength": "Vnos BIC kode mora imeti 8 ali 11 znakov!",
                "bicBankNameRequired": "Vnos banke prejemnika je obvezen!",
                "receiversPostalCodeAndCityInputRequired": "Vnos kraja je obvezen!",
                "bicCityRequired": "Vnos kraja banke je obvezen!",
                "bicCountryRequired": "Vnos države je obvezen!",
                "resend": "Pošlji ponovno",
                "minimalAccountNumber": "Številka računa ni pravilna!",
                "cancel": "Prekliči",
                "templateSavedSuccessfully": "Predloga je uspešno shranjena!",
                "templateUpdatedSuccessfully": "Predloga je uspešno spremenjena!",
                "bankAddressInputRequired": "Vnos naslova banke je obvezen.",
                "paymentDueDateChangedMsg": "Datum izvedbe plačila je spremenjen skladno z Urnikom plačilnih storitev. Prosimo, potrdite spremembo.",
                "cancelledPaymentMsg": 'Plačilo je bilo preklicano in ga banka ne bo izvršila. Preklicano plačilo bo ostalo evidentirano v Pregledu plačil/Izvršena plačila. Lahko ga ponovno pošljete banki v izvršitev, če v Pregledu plačil kliknete na gumb Izvedba.'
            },
            paymentsOverview: {
              "notSupportedPaymentMsg": "Plačilo z izbrano predlogo žal ni več mogoče.",
              "pohReciver": " za ",
                "pohAmount": " znesek od ",
                "pohDate": " na dan ",
                "povlStatus": "Status",
                "povlNote": "Razlog zavrnitve",
                "povlNote_SLO": "Razlog zavrnitve",
                "povlId": "ID naloga",
                "povlReceiver": "Ime prejemnika",
                "povlFrom": "Z računa",
                "povlTo": "Na račun",
                "povlAmount": "Znesek",
                "povlAmountSlo": "Prejeti znesek",
                "povlDueDate": "Datum plačila",
                "povlValueDate": "Datum valutacije",
                "filterStatus": "Filtriraj po statusu",
                "loadMoreBtn": "Prikaži več",
                "referenceTo": "Referenca",
                "titleLabel": "Pregled plačil",
                "signatoryName": "Podpis",
                "signDate": "Datum oddaje",
                "recallerName": "Zahteval/a",
                "recepientInfo": "Podatki o prejemniku",
                "orderPaymentConfirmation": "Naroči potrdilo o plačilu",
                "receiveConfirmation": "Potrdilo bi rad prejel na sledeči naslov",
                "orderComment": "Komentar",
                "orderPaymentConfMsg1": "Banki dovoljujem bremenitev računa za stroške izdelave in pošiljanja potrdila v skladu ",
                "orderPaymentConfMsg2": "s trenutno veljavnim cenikom Addiko Bank d.d.",
                "payerAccNumber": "Št. računa plačnika",
                "recAccNumber": "Št. računa prejemnika",
                "uniMandateRef": "Enolična referenca mandata",
                "dueDate": "Rok plačila",
                "creditorInd": "Identifikator prejemnika",
                "recReference": "Referenca prejemnika",
                "messageAboutError": "Razlog zavrnitve",
                "minLength5": "Minimum length is 5!",
                "orderSuccessAlert":"Naročilo je bilo uspešno oddano.",
                "orderConfirmationBtn":"Naročilo potrdila",
                "reclamationSuccess": "Reklamacija na plačilo je bila uspešno oddana.",
                "paymentsType": {
                    "all": "Vsi",
                    "opened": "Odprti",
                    "partiallysigned": "Delno podpisani",
                    "cancelled": "Preklicani",
                    "processed": "Odobreni",
                    "rejected": "Zavrnjeni",
                    "closed": "Izvršeni",
                    "signed": "Podpisani",
                    "notSigned": "Nepodpisani",
                    "inprocessing": "V izvedbi",
                    "forcancelling": "Čakajo na izvedbo",
                    "storned": "Stornirani",
                    "rejectedaftercomplaint": "Zavrnjeni po pritožbi",
                    "acceptedaftercomplaint": "Izvršeni po pritožbi",
                    "allTab": "Vsa plačila",
                    "realizedTab": "Izvršena plačila",
                    "pendingTab": "Čakalna vrsta plačil",
                    "rejectedTab": "Zavrnjena plačila",
                    "waitingQueque": "Čakalna vrsta"
                },
                "status":{
                    "Opened":"V obdelavi",
                    "Rejected":"Zavrnjen",
                    "WaitingQueue":"Oddan",
                    "Processed":"Izvršen"
                },
                dateRange: "Filtriraj po obdobju",
                "dateFrom": "od",
                "dateTo": "do",
                "filterByPurpose": "Išči po namenu",
                "noPaymentData": "Noben nalog ne ustreza danim pogojem.",
                "selectAll": "Označi vse",
                "selectNone": "Odznači vse",
                "signSelectedPayments": "Podpiši izbrana plačila",
                "referenceNumber": "Referenca",
                "cancelled": "Preklican",
                "processed": "Izvršen",
                "rejected": "Zavrnjen",
                "open": "Odprt",
                "inProcessing": "V obdelavi",
                "signed": "Podpisan",
                "waitingQueque":"Oddan",
                "Cancelled": "Preklican",
                "Processed": "Izvršen",
                "Rejected": "Zavrnjen",
                "Opened": "Odprt",
                "InProcessing": "V obdelavi",
                "Signed": "Podpisan",
                "WaitingQueue":"Oddan",
                "totalPendingSum":"Skupaj v čakalni vrsti:"
            },
            domesticPayment: {
                "header": "Univerzalni plačilni nalog (UPN)",
                "headerSl": "Univerzalni plačilni nalog (UPN)",
                "fromAccountSelectLabel": "Z računa",
                "availableAmountLabel": "Razpoložljivo",
                "purposeCodeSelectLabel": "Koda namena",
                "purposeOfPaymentInputLabel": "Namen plačila",
                "amountInputLabel": "Znesek",
                "dateInputLabel": "Datum",
                "bicCodeInputLabel": "BIC koda",
                "toAccountInputLabel": "IBAN prejemnika",
                "toAccountInputLabelSLO": "IBAN prejemnika",
                "toAccountInputLabelSRB": "Račun prejemnika",
                "toPayee": "Prejemnik",
                "toAccountInputBtn": "Preveri prejemnika",
                "referenceNumberLabel": "Referenca",
                "referenceModelLabel": "Model reference",
                "receiversNameInputLabel": "Ime prejemnika",
                "receiversAddressInputLabel": "Naslov prejemnika",
                "receiversPostalCodeAndCityInputLabel": "Poštna št. in kraj prejemnika",
                "receiversPostalCodeAndCityInputLabelSlo": "Kraj prejemnika",
                "receiversCountrySelectLabel": "Država prejemnika",
                "payersNameInputLabel": "Naziv plačnika",
                "payersAddressInputLabel": "Naslov plačnika",
                "payersCityInputLabel": "Poštna št. in kraj plačnika",
                "amountPlaceholder": "npr. 1.000,00",
                "reviewAndSubmitBtn": "Preverite in potrdite",
                "selectUrgentLabel": "Nujno",
                "selectUrgentLabelSLO": "Nujno",
                "urgentPaymentInfo": "V primeru nujnega naloga se vam bo zaračunalo višje nadomestilo v skladu s Cenikom banke. Prosimo, preverite, ali želite, da se nalog izvrši kot nujni.",
                "processingFeeLabel": "Predviden znesek provizije",
                "receiverAccountError": "Vnos računa prejemnika je obvezen!",
                "receiverAccountErrorHR": "Vnos IBAN računa prejemnika je obvezen!",
                "receiverNameError": "Vnos naslova prejemnika je obvezen!",
                "receiverCityError": "Vnos kraja prejemnika je obvezen!",
                "receiverAddressError": "Vnos naslova prejemnika je obvezen!",
                "receiversPostalCodeAndCityInputError": "Vnos kraja prejemnika je obvezen!",
                "sepaDebitorLabel": "Dolžnik",
                "sepaReceiverLabel": "Upnik",
                "confirmBtn": "Potrdi",
                "selectFromTemplate": "Izberi predlogo",
                "listOfTemplates": "Seznam predlog",
                "bankCharges": "Predviden znesek provizije",
                "urgentPayment": "Plačilo je nujno",
                "checkBankCharges": "Cenik storitev Addiko Bank d.d.",
                "referenceModelInputError": "Vnos reference je obvezen!",
                "referenceModelInputRFError": 'Vsebina "RF" reference ni določena.',
                "referenceModelInputSIError": 'Številka modela "SI" reference ne sme biti prazna.',
                "referenceModelInputInvalid": "Referenca ni pravilna!",
                "toPayeeInputError": "Vnos naziva prejemnika je obvezen!",
                "toPayee2": "Prejemnik (naziv, naslov in kraj)",
                "newPayment": "Novo plačilo",
                "delete": "Izbriši",
                "edit": "Uredi",
                "sign": "Podpiši",
                "ibanStructError": "IBAN ni pravilen.",
                "SEPAcodesLink": "Razlaga SEPA kod namena",
                "timetableForProvisionLink": "Urnik za opravljanje plačilnih storitev",
                "selectHumanitarianOrganisationLabel": "Donacija humanitarni organizaciji (brez provizije)",
                "listOfOrganisations": "Seznam humanitarnih organizacij",
                "bicBankPrejemnika":"BIC banke prejemnika",
                "sepaRegister":"SEPA register",
                "nonWorkingDay":"Izbrani datum ni delavni dan! Prosimo, izberite drug datum.",
                "confirmBtnSlo":"Naprej",
                "toAccountMinlength19": "Dovoljena dolžina je 19 !",
                 "back":"Nazaj",
                changePaymentModal : {
                  "yes":"Da",
                  "no":"Ne",
                  "confirm":"Potrdi",
                  "cancel":"Prekliči",
                  "close":"Zapri",
                  "ok": "V redu"
                },
              "accountEqualityError": "Račun v breme in račun v dobro morata biti različna!",
              "paymentPurposeLengthError": "Vnesen je predolg namen.",
              "paymentPurposeLengthError1": "Najdaljša dovoljena dolžina je",
              "paymentPurposeLengthError2": "znakov.",
              "urgentInfo":"Nalog ste označili kot nujni. V tem primeru se vam bo zaračunalo višje nadomestilo v skladu s Cenikom banke. Prosimo preverite, ali želite, da se nalog izvrši kot nujni.",
              "secondNotInSEPAMessage":"Želite izpolniti nalog za plačilo v tujino?"
            },
            internationalPayment: {
              "maxlength34": "Dovoljen je vnos največ 34 znakov.",
              international: "Nalog za plačilo v tujino",
                "fromAccount": "Z računa",
                "chargeAccount": "Račun za kritje",
                "totalAmount": "Skupni znesek in valuta",
                "paymentDate": "Datum plačila",
                "paymentPurpose": "Namen plačila",
                "recipient": "Prejemnik",
                "purposeCode": "Koda namena",
                "recipientStatus": "Status prejemnika",
                "companyName": "Naziv prejemnika",
                "address": "Naslov",
                "city": "Kraj",
                "country": "Država",
                "recipientAccount": "Račun prejemnika",
                "recipientBank": "Banka prejemnika",
                "bankName": "Naziv banke",
                "swiftCode": "SWIFT koda",
                "bankCharges": "Stroški plačila",
                "sharedCharges": "SHA Deljeni stroški",
                "payersPaysCharges": "OUR Stroške nosim sam",
                "beneficiaryPaysCharges": "Stroške nosi prejemnik",
                "naturalPerson": "Fizična oseba",
                "legalPerson": "Pravna oseba",
                "tooltipInfo": "Potrebujete pomoč?",
                "fillData": "Izpolnite podatke o banki",
                "reviewandSubmit": "Pregled in potrditev",
                "companyNameInputError": "Ime in priimek sta obvezna!",
                "recipientAddressInputError": "Vnos naslova prejemnika je obvezen!",
                "recipientCityInputError": "Vnos kraja prejemnika je obvezen!",
                "recipientAccountInputError": "Vnos računa prejemnika je obvezen!",
                "bankNameInputError": "Vnos naziva banke je obvezen!",
                "bankAddressInputError": "Vnos naslova banke je obvezen!",
                "bankCityInputError": "Vnos kraja banke je obvezen!",
                "swiftCodeInputError": "Vnos SWIFT kode je obvezen!",
                "payersNameInputLabel": "Ime in priimek plačnika",
                "payersAddressInputLabel": "Naslov plačnika",
                "payersCityInputLabel": "Kraj plačnika",
                "sepaDebitorLabel": "Dolžnik",
                "sepaReceiverLabel": "Upnik",
                "paymentMode": "Namen plačila",
                "toPayee2": "Prejemnik (naziv, naslov in kraj)",
                "toAccountInputLabel": "IBAN račun prejemnika",
                "toAccountInputLabel_SLO": "Račun prejemnika (IBAN koda)",
              "bicBankName": "Banka prejemnika",
                "noBicBankInfo": "Opomba",
                "chooseCountry":"Izberite državo",
                "paymentChargesAmount": "Provizija"

            },
            internalTransfer: {
                "transferToAccount": "Prenos na moj račun",
                "fromAccount": "Račun plačnika (IBAN)",
                "toAccount": "Račun prejemnika (IBAN)",
                "dueDate": "Datum izvedbe",
                "valueDate": "Datum kreiranja",
                "amount": "Znesek",
                "sign": "Podpiši",
                "saveAsTemplate": "Shrani kot predlogo",
                "templateName": "Naziv predloge",
                "newPayment": "Novo plačilo ali prenos",
                "toPaymentOverview": "Pregled vseh plačil",
                "signSuccess": "Plačilo je bilo uspešno podpisano.",
                "toAccountInputError": "Vnos računa prejemnika je obvezen!",
                "paymentPurposeInputError": "Vnos namena je obezen!",
                "amountInputError": "Vnos zneska je obvezen!",
                "dueDateError": "Vnos datuma izvedbe je obvezen!",
                "templateNameError": "vnos naziva predloge je obvezen!",
                "when": "Datum",
                "transferComplete": "Prijenos je izvršen",
                "makeAnotherPayment": "Novo plačilo ali prenos",
                "successfullyTransfer": "Prenos je bil uspešno izvršen",
                "amountLengthError": "Najvišji dovoljen znesek je 99.999.999.999,99",
                "nodata": "Ni podatkov za prikaz",
                "minAmount10Error": "Najnižji dovoljeni znesek je ",
                "toAccountNoData": 'Prenos med računi ni mogoč ker imate prijavljen samo en račun. Za menjavo valut v meniju "Plačila" izberite "Menjava valut".'
            },
            paymentSignModal: {
                title: "Podpisovanje plačila",
                challengeResponse: "Vnesite kodo",
                ok: "V redu"
            },
            loanPayment: {
                "loanPayment": "Plačilo kredita",
                "recieverNumber": "Referenca",
                "purpose": "Namen plačila",
                "when": "Datum",
                "exchangeRate": "Tečaj",
                "referenceNumber": "Referenca",
                "defaultPurpose":"Odplačilo posojila"
            },
            currencyConversion: {
                "exchangeOffice": "Menjava valut",
                "exchangeRatesCalculator": "Tečajna lista",
                "sellingAmount": "Prodaja",
                "buyingAmount": "Nakup",
                "availableBalance": "Razpoložljivo stanje",
                "fromAccount": "Z računa",
                "toAccount": "Na račun",
                "amount": "Znesek",
                "amountTo": "Znesek",
                "sign": "Podpiši",
                "confirm": "Potrdi",
                "back": "Novo plačilo",
                "smsAuthentification": "SMS potrditev plačila",
                "sendSms": "Pošlji SMS sporočilo",
                "smsPassword": "Potrditvena koda",
                "moneyExchangeComplete": "Menjava valut je izvedena",
                "successfullyExchange": "Menjava je bila uspešno izvršena",
                "makeAnotherExchange": "Nova menjava valut",
                "goToPayments": "Pregled vseh plačil",
                "exchangeRateRatio": "Tečajna lista",
                "exchangeOrder": "Zahteva za menjavo valut",
                "signPayment": "Podpiši plačilo",
                "deletePayment": "Izbriši plačilo",
                "recallPayment": "Prekliči plačilo",
                "balance": "Stanje na računu",
                "exchangeRate": "Informativni tečaj",
                "bankCharges": "Predviden znesek provizije",
                "when": "Datum",
                "buying": "Nakupni tečaj",
                "selling": "Prodajni tečaj",
                "calculatedAmount":"Preračunan znesek",
                "agreedRate":"Tečaj",
                "bankCurrencyInfoMsg11": "Banka menjavo valut izvaja po menjalniških deviznih tečajih Addiko Bank d.d. za občane v času izvedbe nakupa ali prodaje, ne glede na menjalniški tečaj, veljaven v času oddaje naročila. Trenutno veljavno Tečajno listo Addiko Bank d.d. si lahko ogledate na",
                "bankCurrencyInfoMsg12": "spletnih straneh banke."
            },
            paymentsAndTransferOverview: {
                rejectedLabel: "Zadnji neplačani nalogi",
                eInvoicesLabel: "Neplačani eRačuni",
                groupedPaymentsLabel: "Plačila za podpis",
                repeatAction: "Ponovi",
                payAction: "Plačaj",
                signAllAction: "Podpiši vse",
                domPayToSign: "UPN nalogov za podpis",
                paymentsToSign: "nalogov za podpis",
                "confirm": "Potrdi"
            },
            ebook: {
                "ebookPayIn": "Plačilo na e-knjižico",
                "ebookPayOut": "Plačilo z e-knjižice"
            },
            savings: {
                "savingsPayIn": "Vplačilo na varčevanje"
            },
            signPayments: {
                "paymentsInvalidDueDate": "N/A",
                "singlePaymentInvalidDueDate": "N/A",
                "updatePaymentsDueDate": "N/A",
                "updatePaymentDueDate": "N/A",
                "dateCreated": "Datum kreiranja",
                "dueDate": "Datum izvedbe",
                "confirm": "Potrdi",
                "challengeResponse": "Koda potrditve",
                "challenge": "Validacijska koda",
                "challengeFirstCode": "Geslo 1 (vnese se v generator gesla)",
                "challengeSecondCode": "Geslo 2 (iz generatorja gesel)",
                "challengeDescription": "Vključite generator gesel - vnesite PIN i takoj na prazen ekran (piše samo CHAL na vrhu) vnesite številko, ki je izpisana na ekranu 'Geslo 1' in kliknite na gumb 'V redu'. Generator bo izpisal geslo, ki ga je potrebno prepisati v polje 'Geslo 2' Ko ste zaključili z vnosom, pritisnite gumb 'Potrdi'.",
                "finalStepSuccessfullySigned": "Plačilo je bilo uspešno oddano.",
                "finalStepPaymentServices": "Storitve plačilnega prometa bodo zaračunane skladno s ",
                "finalStepBankTariff": "cenikom Banke.",
                "finalStepStatus": "Status: ",
                "finalStepPaymentID": "Številka plačila: ",
                "finalStepNumberOfPayments": "Številka plačila: ",
                "finalStepSentForProcessing": "Plačilo je poslano v izvedbo.",
                "finalStepPaymentSloHeader": "Plačilo je bilo uspešno oddano.",
                "finalStepPaymentSloSubHeader":"Uspešno obdelavo plačila preverite na strani ",
                "finalStepPaymentSloText": "Če ste oddali plačilo z datumom izvršitve kasnejšim od današnjega datuma, se je plačilo uvrstilo v čakalno vrsto plačil. Na dan plačila sprememba ali preklic plačila nista možna.",
                "cancel": "Prekliči",
                "resendSms": "Ponovno pošlji SMS",
                "resendSmsSlo": "Ponovno pošlji SMS (velja za kodo preko SMS)",
                "SmsCode": "Potrditvena koda",
                "SmsDescription": "SMS sporočilo je poslano na vašo številko. Vnesite geslo iz sporočila v polje 'SMS koda' in kliknite 'Potrdi'.",
                "SmsDescriptionSLO": "Prosimo, vnesite potrditveno kodo, ki ste jo prejeli preko SMS sporočila ali generirali s pomočjo generatorja gesel. Izbrani način potrjevanja transakcij lahko preverite v Nastavitvah.",
                "SmsSentSuccessfully": "SMS sporčilo je uspešno poslano!",
                "paymentExecutionDateTitle": "Zamenjava datuma valute",
                "paymentExecutionDateBody": "Plačilni promet je za danes že zaključen. Vaš nalog bo izvršen naslednji delovni dan banke. Želite nadaljevati s podpisovanjem?"
            },
            paymentActions: {
                "repeat": "Ponovi plačilo",
                "copy": "Kopiraj plačilo",
                "delete": "Izbriši plačilo",
                "printSlo": "Natisni potrdilo",
                "print": "Natisni potrdilo",
                "recall": "Preklic izvedbe",
                "cancelPayment": "Preklic izvedbe",
                "sign": "Podpiši nalog",
                "cancel": "Prekliči",
                "rejectRecall": "Prekliči zahtevo",
                "approveRecall": "Potrdi zahtevo",
                "edit": "Spremeni podatke plačila",
                "complaint": "Reklamacija",
                "confirmation": "Naroči potrdilo",
                "execute":"Izvedba",
                "changePayment": "Sprememba plačila"
            },
            statementConfirmModalTranslations: {
                title: "Izjava",
                p1: "N/A",
                p2: "N/A",
                p2_2: "N/A",
                p2_0: "N/A",
                p2_1: "N/A",
                p4: "N/A",
                radioMerchandise: "N/A",
                radioPresent: "N/A",
                radioOther: "N/A",
                confirmButton: "Potrdi",
                cancelButton: "Prekliči"
            },
            "currencyCalculator": {
                "exchangeCalculator": "Tečajni kalkulator",
                "exchangeRates": "Tečajna lista",
                "msg1": "N/A",
                "msg2": "N/A " +
                    "tel.: N/A",
                "updated":"Spremenjeno"
            },
            paymentsReturn: {
                openedTab: "Odprta plačila",
                archivedTab: "Arhivirana plačila",
                titleLabel: "Strinjanje z vračilom sredstev",
                modalTitle: "Izberite razlog za vračilo sredstev",
                recallReason: "Razlog za vračilo",
                additionalInfo: "Dodatne informacije",
                additionalInfoError: "To polje je obvezno",
                reasonTech: "N/A",
                reasonFrad: "N/A",
                reasonDupl: "N/A"
            },
            paymentsFinal: {
                "InProcessing": "V izvedbi",
                "Signed": "Podpisano",
                "WaitingQueue":"Plačilo je uvrščeno na čakalno vrsto",
                "Opened":"Čaka na izvedbo"
            },
            paymentsTypeGroup: {
                "CurrencyExchange":"Menjava valut",
                "LocalCurrencyTransfer":"Prenos v domači valuti",
            },
            sepa: {
              "header": "Nastavitve SEPA direktnih obremenitev",
              "addNew": "Dodaj nastavitev"
            }
        };

        $translateProvider
            .translations('sl', data);
    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      payments: {
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayments": "Domaći platni promet",
        "currencyConversion": "Konverzija valuta",
        "internationalPayment": "Internacionalno plaćanje",
        "rejectedPayments": "Odbijene uplate",
        "pendingPayments": "Uplate na čekanju",
        "templates": "Šabloni",
        "searchTemplateName": "Traži predložak po nazivu",
        "topUsed": "Najčešće upotrebljeni",
        "alphabetically": "Po abecedi",
        "to": "ka",
        "showMoreTemplates": "Prikaži više šablona",
        "eInvoices": "eRačuni",
        "showMoreInvoices": "Prikaži sve eRačune",
        "sepaDirectDebit": "SEPA izravno dugovanje",
        "viewAllTransactions": "Pregled svih transakcija",
        "due": "dospio",
        "allPastPayments": "Pregled svih izvršenih plaćanja",
        "exchangeRatesList": "Tečajna lista",
        "pay": "Plati",
        "internalTransfer": "Interni prenos",
        "noEinvoices": "Nema podataka za eRačune",
        "noTemplates": "Nema podataka za predloške",
        "forCurrencyConversion": "pretvorba valuta",
        "midrate": "srednja stopa",
        "forForeignNotes": "strane bilješke, čekovi",
        "onDate": "dana ",
        "buy": "Kupi",
        "goBackToPayments": "Povratak na plaćanja",
        "currencyName": "Naziv valute",
        "code": "Kod",
        "unit": "Jedinica",
        "buyRate": "Kupovni kurs",
        "middleRate": "Srednji kurs",
        "sellRate": "Prodajni kurs",
        "action": "Akcija",
        "noRejectedPayments": "Za odabrani period nema odbijenih uplata",
        "noPendingPayments": "Za odabrani period nema uplata na čekanju",
        "donationToCharity": "Donacija u dobrotvorne svrhe",
        "subscribe": "Pretplata",
        "settings": "Postavke",
        "moreRejected": "Još odbijenih plaćanja",
        "morePending": "Još plaćanja na čekanju",
        "currencyExchange": "Mjenjačnica",
        "exchange": "Razmjeni",
        "fromAccount": "Sa računa",
        "toAccount": "Na račun",
        "willSell": "Prodaja",
        "willBuy": "Kupovina",
        "available": "Dostupno",
        "delete": "Obriši",
        "edit": "Promijeni",
        "loanPayment": "Plaćanje kredita",
        "paymentMode": "Svrha plaćanja",
        "toAcc": "na račun",
        "fromAcc": "s računa",
        "bicNumber": "BIC broj",
        "bicBankName": "Banka primatelja",
        "bicAddress": "BIC adresa",
        "bicCity": "BIC grad",
        "bicCountry":"Država",
        "bicRecipientStatus": "Primalac (osoba)",
        "bicRecipientStatusOptionLegal": "Pravna",
        "bicRecipientStatusOptionPhysical": "Fizička",
        "bicBankCharges": "Troškovna opcija",
        "bicNumberRequired": "BIC adresa je obavezna!",
        "bicBankNameRequired": "Banka primatelja je obavezna!",
        "bicCityRequired": "BIC grad je obavezan!",
        "bicCountryRequired": "Država je obavezna!",
        "resend": "Pošalji ponovo",
        "minimalAccountNumber": "Račun nije ispravan!",
        "cancel": "Odustani",
        "templateSavedSuccessfully": "Uspješno ste kreirali šablon !",
        "templateUpdatedSuccessfully": "Promjena šablona je uspješno izvršena!",
        "bankAddressInputRequired": "Bank address is required!."

      },
      paymentsOverview: {
        "pohReciver": " za ",
        "pohAmount": " u iznosu od ",
        "pohDate": " na dan ",
        "povlStatus": "Status",
        "povlId": "Id naloga",
        "povlReceiver": "Naziv primaoca",
                "povlFrom": "Sa računa",
        "povlTo": "Na račun",
        "povlAmount": "Iznos",
        "povlDueDate": "Datum izvršenja",
        "povlValueDate": "Datum valutacije",
        "filterStatus": "Filtriraj po statusu",
        "loadMoreBtn": "Prikaži još naloga",
        "referenceTo": "Referentni broj",
        "titleLabel": "Lista naloga",
        "signatoryName": "Potpisnik",
        "signDate": "Datum akcije",
        "paymentsType": {
          "all": "Svi",
          "opened": "Nepotpisan",
          "partiallysigned": "Djelimično potpisani",
          "cancelled": "Otkazani",
          "processed": "Realizovan",
          "rejected": "Odbijen",
          "closed": "Zatvoren",
          "signed": "Potpisan",
          "notSigned": "Nepotpisani",
          "inprocessing": "U obradi",
          "forcancelling": "Za otkazivanje",
          "storned": "Stornirani",
          "rejectedaftercomplaint": "Odbijeni nakon žalbe",
          "acceptedaftercomplaint": "Prihvaćeni nakon žalbe",
          "allTab": "Svi",
          "realizedTab": "Realizovani nalozi",
          "pendingTab": "Nalozi na čekanju",
          "rejectedTab": "Odbijeni nalozi"
        },
        "status":{
              "Opened":"Nepotpisan",
              "Rejected":"Odbijen",
              "WaitingQueue":"Na čekanju",
              "Processed":"Realizovan",
        },

        "dateFrom": "vrijeme od",
        "dateTo": "vrijeme do",
        "filterByPurpose": "Pretraži po namjeni",
        "noPaymentData": "Za odabrani filter nema naloga.",
        "selectAll": "Označi sve",
        "selectNone": "Odznači sve",
        "signSelectedPayments": "Potpiši odabrana plaćanja",
        "povlNote":"Napomena",
        "referenceNumber": "Referentni broj",
        "cancelled": "Opozvan",
        "processed": "Realizovan",
        "rejected": "Odbijen",
        "open": "Nepotpisan",
        "inProcessing": "U obradi",
        "waitingQueque": "Na čekanju",
        "signed": "Potpisan",
        "Cancelled": "Opozvan",
        "Processed": "Realizovan",
        "Rejected": "Odbijen",
        "Opened": "Nepotpisan",
        "InProcessing": "U obradi",
        "WaitingQueue": "Na čekanju",
        "Signed": "Potpisan"
      },
      domesticPayment: {
        "header": "Domaći platni promet",

                "fromAccountSelectLabel": "Sa računa",
        "availableAmountLabel": "Raspoloživo",
        "purposeCodeSelectLabel": "Šifra plaćanja",
        "purposeOfPaymentInputLabel": "Svrha plaćanja",
        "amountInputLabel": "Iznos",
        "dateInputLabel": "Datum",
        "bicCodeInputLabel": "BIC kod",
        "toAccountInputLabel": "Račun primaoca",
        "toAccountInputLabelSRB": "Račun primaoca",
        "toPayee": "Primalac",
        "toAccountInputBtn": "Dopuni primaoca",
        "referenceNumberLabel": "Poziv na broj (odobrenja)",
        "referenceModelLabel": "Model",
        "receiversNameInputLabel": "Ime primaoca",
        "receiversAddressInputLabel": "Adresa primaoca",
        "receiversPostalCodeAndCityInputLabel": "Poštanski broj i grad primaoca",
        "receiversCountrySelectLabel": "Zemlja primaoca",
        "payersNameInputLabel": "Ime i prezime pošiljaoca",
        "payersAddressInputLabel": "Adresa pošiljaoca",
        "payersCityInputLabel": "Grad pošiljaoca",
        "amountPlaceholder": "eg. 1.000,00",
        "reviewAndSubmitBtn": "Pregledajte i pošaljite",
        "selectUrgentLabel": "Označite kao hitnu uplatu",
        "selectUrgentLabelSRB": "Označite kao hitnu uplatu",
        "urgentPaymentInfo": "Za usluge platnog prometa naknada će biti obračunata u skladu sa Tarifnikom Banke.",
        "processingFeeLabel": "Naknada za obradu naloga",
        "receiverAccountError": "Račun primaoca je obavezan!",
        "receiverAccountErrorHR":"IBAN / Broj računa primatelja je obavezan!",
        "receiverNameError": "Naziv primaoca je obavezan!",
        "receiverCityError": "Grad primaoca je obavezan!",
        "receiverAddressError": "Adresa primaoca je obavezna!",
        "sepaDebitorLabel": " Stvarni dužnik",
        "sepaReceiverLabel": "Krajnji primatelj",
        "confirmBtn": "Potvrdi",
        "selectFromTemplate": "Odaberi iz šablona",
        "listOfTemplates": "Lista šablona",
        "bankCharges": "Provizija",
        "urgentPayment": "Ovaj nalog je hitan",
        "checkBankCharges": "Provjeri dodatne naknade",
        "referenceModelInputError": "Poziv na broj je obavezan!",
        "referenceModelInputInvalid": "Poziv na broj nije ispravan!",
        "toPayeeInputError": "Naziv primaoca je obavezan!",
        "toPayee2":"Primaoc (naziv/ime i adresa)",
        "newPayment":"Novi nalog",
        "delete":"Obriši",
        "edit":"Izmijeni",
        "sign":"Potpiši",
        "ibanStructError":"IBAN nije ispravan"
      },
      internationalPayment: {
        international: "Internacionalno plaćanje",

                "fromAccount": "Sa računa",
        "chargeAccount": "Račun naknade",
        "totalAmount": "Ukupan iznos i valuta",
        "paymentDate": "Datum plaćanja",
        "paymentPurpose": "Svrha uplate",
        "recipient": "Primalac",
        "purposeCode": "Šifra svrhe",
        "recipientStatus": "Status primatelja",
        "companyName": "Ime i prezime ili puni naziv tvrtke",
        "address": "Adresa",
        "city": "Grad",
        "country": "Država",
        "recipientAccount": "Račun primatelja",
        "recipientBank": "Banka primatelja",
        "bankName": "Naziv banke",
        "swiftCode": "SWIFT kod",
        "bankCharges": "Bankovna naknada",
        "sharedCharges": "Zajednički troškovi",
        "payersPaysCharges": "Isplatitelj plaća troškove",
        "beneficiaryPaysCharges": "Korisnik plaća troškove",
        "naturalPerson": "Fizičko lice",
        "legalPerson": "Pravno lice",
        "tooltipInfo": "Trebate pomoć?",
        "fillData": "Popunite podatke o banci",
        "reviewandSubmit": "Pregled i potvrda",
        "companyNameInputError": "Ime i prezime je obavezno!",
        "recipientAddressInputError": "Adresa primatelja je obavezna!",
        "recipientCityInputError": "Grad primatelja je obavezan!",
        "recipientAccountInputError": "Račun primatelja je obavezan!",
        "bankNameInputError": "Naziv banke je obavezan!",
        "bankAddressInputError": "Adresa banke je obevezna!",
        "bankCityInputError": "Grad banke je obavezan!",
        "swiftCodeInputError": "SWIFT kod je obavezan!",
        "payersNameInputLabel": "Ime i prezime pošiljaoca",
        "payersAddressInputLabel": "Adresa pošiljaoca",
        "payersCityInputLabel": "Grad pošiljaoca",
        "sepaDebitorLabel": " Stvarni dužnik",
        "sepaReceiverLabel": "Krajnji primatelj",
        "paymentMode": "Svrha plaćanja",
        "toPayee2":"Primatelj (naziv/ime i adresa)",
        "toAccountInputLabel": "IBAN / Broj računa primatelja",
        "bicBankName": "Banka primatelja",

      },
      internalTransfer: {
        "transferToAccount": "Prenos na moj račun",
        "fromAccount": "Račun platitelja (IBAN)",
        "toAccount": "Račun primatelja (IBAN)",
        "dueDate": "Datum izvršenja",
        "valueDate": "Datum kreiranja",
        "amount": "Iznos",
        "sign": "Potpiši",
        "saveAsTemplate": "Snimi kao šablon",
        "templateName": "Naziv šablona",
        "newPayment": "Kreiraj novi nalog",
        "toPaymentOverview": "Idi na pregeled svih plaćanja",
        "signSuccess": "Platni nalog je uspješno potpisan.",
        "toAccountInputError": "Račun primatelja je obavezan!",
        "paymentPurposeInputError": "Svrha uplate je obavezna!",
        "amountInputError": "Iznos je obavezan!",
        "dueDateError": "Datum izvršenja je obavezan!",
        "templateNameError": "Naziv je obavezan!",
        "when": "Datum",
        "transferComplete": "Prenos je završen",
        "makeAnotherPayment": "Kreiraj novi nalog",
        "successfullyTransfer": "Uspješno ste prebacili",
        "amountLengthError": "Maksimalni iznos je 99.999.999.999,99",
        "nodata": "Nema podataka za prikaz",
        "infoMne0":"Napomena za uplate na Revolving i MasterCard kartice:",
        "infoMne1":"Uplate izvršene do 15:30h će biti proknjižene i sredstva raspoloživa na kartici u toku sledećeg radnog dana.",
        "infoMne2":"Uplate izvršene nakon 15:30h će biti proknjižene i sredstva raspoloživa na kartici u toku sledeća dva radna dana."
      },
      paymentSignModal: {
        title: "Potpisivanje naloga",
        challengeResponse: "Unesite kod",
        ok: "Uredu"
      },
      loanPayment: {
        "loanPayment": "Plaćanje kredita",
        "recieverNumber": "Broj primatelja",
        "purpose": "Svrha plaćanja",
        "when":"Datum",
        "exchangeRate":"Kurs",
        "referenceNumber":"Poziv na broj"
      },
      currencyConversion: {
        "exchangeOffice": "Razmena valute",
        "exchangeRatesCalculator": "Lista valuta i kalkulator",
        "sellingAmount": "Prodaja",
        "buyingAmount": "Kupovina",
        "availableBalance": "Raspoloživo stanje",
        "fromAccount": "Sa računa",
        "toAccount": "Na račun",
        "amount": "Iznos",
        "sign": "Potpiši",
        "confirm": "Potvrdi",
        "back": "Novi nalog",
        "smsAuthentification": "SMS autentifikacija plaćanja",
        "sendSms": "Pošalji SMS kod",
        "smsPassword": "SMS jednokratna šifra",
        "moneyExchangeComplete": "Novčana razmjena je završena",
        "successfullyExchange": "Uspješno ste razmjenili",
        "makeAnotherExchange": "Napravi još jednu razmjenu",
        "goToPayments": "Idi na pregled naloga",
        "exchangeRateRatio": "Kursna lista",
        "exchangeOrder": "Nalog promjene valuta",
        "signPayment": "Potpiši nalog",
        "deletePayment": "Obriši nalog",
        "recallPayment": "Opozovi nalog",
        "balance":"Stanje računa",
        "bankCharges":"Cenovnik",
        "when":"Datum",
        "buying":"Kupovni kurs",
        "selling":"Prodajni kurs",
        "calculatedAmount":"Preračunati iznos",
        "agreedRate":"Kurs"
      },
      paymentsAndTransferOverview: {
        rejectedLabel:"Poslednji neplaćeni nalozi",
        eInvoicesLabel:"Neplaćeni eRačuni",
        groupedPaymentsLabel:"Grupa naloga za potpis",
        repeatAction:"Ponovi",
        payAction:"Plati",
        signAllAction:"Potpiši sve",
        domPayToSign:"opštih naloga za potpis",
        paymentsToSign: "naloga za potpis",
        "confirm": "Potvrdi"
      },
      ebook: {
        "ebookPayIn":"Uplata na eknjižicu",
        "ebookPayOut": "Isplata sa eknjižice"
      },
      savings: {
        "savingsPayIn": "Interni devizni prijenos"
      },
      signPayments: {
        "paymentsInvalidDueDate": "Neka od plaćanja imaju zastarjel krajnji datum plaćanja. Da li želite ažurirati te datume na današnji dan?",
        "singlePaymentInvalidDueDate": "Odabrani nalog ima zastarjeli datum izvršenja. Da li želite ažurirati datum na današnji dan?",
        "updatePaymentsDueDate": "Ažuriraj krajnje datume plaćanja",
        "updatePaymentDueDate": "Ažuriraj datum plaćanja",
        "dateCreated": "Datum kreiranja",
        "dueDate": "Datum izvršenja",
        "confirm": "Potvrdi",
        "challengeResponse": "Kod potvrde",
        "challenge": "Validacijski kod",
        "challengeFirstCode": "Šifra 1 (unosi se u token)",
        "challengeSecondCode": "Šifra 2 (iz tokena)",
        "challengeDescription": "Uključite token, unesite PIN i odmah na prazan ekran (piše samo CHAL na vrhu) unesite broj koji je ispisan na ekranu 'Šifra 1', i kliknite na gumb 'OK'. Token će ispisati šifru 2 koju je potrebno prepisati u polje 'Šifra 2'. Kada ste završili akciju, odaberite gumb 'POTVRDI'.",
        "finalStepSuccessfullySigned": "Uspješno ste potpisali nalog",
        "finalStepPaymentServices": "Za usluge platnog prometa naknada će biti obračunata u skladu sa ",
        "finalStepBankTariff": "Tarifnikom Banke.",
        "finalStepStatus": "Status: ",
        "finalStepPaymentID": "Broj transakcije: ",
        "finalStepNumberOfPayments": "Broj naloga: ",
        "finalStepSentForProcessing": "Status naloga možete povjeriti u Listi plaćanja (pregled naloga).",
        "finalStepPaymentSloHeaderEx": "N/A",
        "finalStepPaymentSloHeaderPen": "N/A",
        "finalStepPaymentSloSubHeader": "N/A",
        "finalStepPaymentSloSubHeaderLink": "N/A",
        "finalStepPaymentSloTextEx": "N/A",
        "finalStepPaymentSloTextPen": "N/A",
        "cancel":"Odustani",
        "resendSms": "Ponovo pošalji SMS",
        "SmsCode": "SMS kod",
        "SmsDescription": "SMS poruka je poslata na Vaš uređaj. Unesite kod iz SMS poruke u polje 'SMS kod'. Nakon unosa koda, odaberite opciju 'POTVRDI'.",
        "SmsSentSuccessfully": "SMS poruka uspješno poslana!",
        "paymentExecutionDateTitle": "Promena datuma valute",
        "paymentExecutionDateBody": "Obrada naloga je završena. Vaše plaćanje će biti poslato na izvršenje prvog sledećeg radnog dana.",
        "infoDomMne0":"Vaše plaćanje će biti izvršeno u skladu sa definisanim vremenskim okvirima ",
        "infoDomMne1":"(Terminski plan).",
        "infoDomMneLink":"https://www.addiko.me/sites/addiko.me/files/content/terminski_plan_obrade_naloga_addiko.xlsx.pdf"
      },
      paymentActions: {
        "repeat": "Ponovi nalog",
        "copy": "Kopiraj nalog",
        "delete": "Obriši",
        "print": "Štampaj nalog",
        "recall": "Opozovi nalog",
        "sign": "Potpiši",
        "cancel": "Otkaži",
        "rejectRecall": "Odbij zahtjev",
        "approveRecall": "Prihvati zahtjev",
        "edit":"Izmijeni",
        "confirmation": "Order confirmation"
      },
      statementConfirmModalTranslations: {
        title: "Izjava",
        p1: "Sukladno Zakonu o međunarodnim mjerama ograničavanja u Banci za provedbu naloga, potrebno je popuniti ovu Izjavu. U protivnom, nalog neće biti proveden.",
        p2: "Pod kaznenom i materijalnom odgovornošću izjavljujem da je, za nalog u iznosu od ",
        p2_2: " za državu",
        p2_0: " osnova plaćanja",
        p2_1: "detaljno obrazloženje (specifikacija)*",
        p4: "Izjava je kreirana u elektroničkom obliku i važeća je bez pečata i potpisa.",
        radioMerchandise: "Roba*",
        radioPresent: "Poklon",
        radioOther: "Ostalo*",
        confirmButton: "Potvrdi",
        cancelButton: "Odustani"
      },
      "currencyCalculator": {
        "exchangeCalculator": "Valutni kalkulator",
        "exchangeRates": "Kursna lista",
        "msg1": "Tečajna lista primjenjuje se za kupnju i prodaju deviza do iznosa protuvrijednosti od HRK 150.000,00",
        "msg2": "Za veće iznose molimo kontaktirajte Odjel Prodaje proizvoda Riznice Addiko Banke na " +
        "tel.: 01 603 3513, 01 603 1746, 01 603 0616, 01 603 3533. ili 01/603-0889, i za regiju Slavonija i Baranja " +
        "tel: 031/231-553 i 031/231-223. ",
        "updated":"Ažurirano"
      },
      paymentsReturn: {
        openedTab: "Otvoreni",
        archivedTab: "Arhivirani",
        titleLabel: "Saglasnost za povrat sredstava",
        modalTitle: "Odaberite razlog za povrat sredstava",
        recallReason: "Razlog za povrat",
        additionalInfo: "Dodatne informacije",
        additionalInfoError: "Ovo polje je obavezno",
        reasonTech: "Tehnički problemi koji rezultiraju pogrešnim platnim nalogom kreditnog transfera",
        reasonFrad: "Lažno iniciranje platnog naloga kreditnog transfera (required additiona info field)",
        reasonDupl: "Duplo slanje"
      },
      paymentsFinal: {
        "InProcessing":"U obradi",
        "Signed":"Potpisan",
        "WaitingQueue":"Nalog je poslat na čekanje"
      },
      paymentsTypeGroup: {
        "CurrencyExchange":"CurrencyExchange",
        "LocalCurrencyTransfer":"LocalCurrencyTransfer",
    }
    };

    $translateProvider
      .translations('mne', data);
  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            payments: {
                "quickPaymentTransfer": "Brzo plaćanje ili transfer",
                "domesticPayments": "Opći nalog",
                "currencyConversion": "Konverzija valuta",
                "internationalPayment": "Devizni nalog",
                "rejectedPayments": "Odbijene uplate",
                "pendingPayments": "Uplate na čekanju",
                "templates": "Predlošci",
                "searchTemplateName": "Traži predložak po nazivu",
                "topUsed": "Najčešće upotrebljeni",
                "alphabetically": "Po abecedi",
                "to": "ka",
                "showMoreTemplates": "Prikaži više predložaka",
                "eInvoices": "eRačuni",
                "showMoreInvoices": "Prikaži sve eRačune",
                "sepaDirectDebit": "SEPA izravno dugovanje",
                "viewAllTransactions": "Pregled svih transakcija",
                "due": "dospio",
                "allPastPayments": "Pregled svih izvršenih plaćanja",
                "exchangeRatesList": "Tečajna lista",
                "pay": "Plati",
                "internalTransfer": "Interni prijenos",
                "noEinvoices": "Nema podataka za eRačune",
                "noTemplates": "Nema podataka za predloške",
                "forCurrencyConversion": "pretvorba valuta",
                "midrate": "srednja stopa",
                "forForeignNotes": "strane bilješke, čekovi",
                "onDate": "dana ",
                "buy": "Kupi",
                "goBackToPayments": "Povratak na plaćanja",
                "currencyName": "Naziv valute",
                "code": "Kod",
                "unit": "Jedinica",
                "buyRate": "Kupovni tečaj",
                "middleRate": "Srednji tečaj",
                "sellRate": "Prodajni tečaj",
                "action": "Akcija",
                "noRejectedPayments": "Za odabrani period nema odbijenih uplata",
                "noPendingPayments": "Za odabrani period nema uplata na čekanju",
                "donationToCharity": "Donacija u dobrotvorne svrhe",
                "subscribe": "Pretplata",
                "settings": "Postavke",
                "moreRejected": "Još odbijenih plaćanja",
                "morePending": "Još plaćanja na čekanju",
                "currencyExchange": "Mjenjačnica",
                "exchange": "Razmjeni",
                "fromAccount": "S računa",
                "toAccount": "Na račun",
                "willSell": "Prodaja",
                "willBuy": "Kupnja",
                "available": "Dostupno",
                "delete": "Izbriši",
                "edit": "Promijeni",
                "loanPayment": "Plaćanje kredita",
                "toAcc": "na račun",
                "paymentMode": "Svrha plaćanja",
                "fromAcc": "s računa",
                "bicNumber": "BIC broj",
                "bicBankName": "Banka primatelja",
                "bicAddress": "BIC adresa",
                "bicCity": "BIC grad",
                "bicCountry": "Država primatelja",
                "bicRecipientStatus": "Primatelj (osoba)",
                "bicRecipientStatusOptionLegal": "Pravna",
                "bicRecipientStatusOptionPhysical": "Fizička",
                "bicBankCharges": "Troškovna opcija",
                "bicNumberRequired": "BIC adresa je obavezna!",
                "bicBankNameRequired": "Banka primatelja je obavezna!",
                "bicCityRequired": "BIC grad je obavezan!",
                "bicCountryRequired": "Država primatelja je obavezna!",
                "resend": "Pošalji ponovo",
                "minimalAccountNumber": "Račun nije ispravan!",
                "cancel": "Odustani",
                "templateSavedSuccessfully": "Uspješno ste kreirali predložak !",
                "templateUpdatedSuccessfully": "Promjena predloška je uspješno  izvršena !",
                "bankAddressInputRequired": "Bank address is required!."

            },
            paymentsOverview: {
                "pohReciver": " za ",
                "pohAmount": " u iznosu od ",
                "pohDate": " na dan ",
                "povlStatus": "Status",
                "povlId": "Id naloga",
                "povlReceiver": "Ime primatelja",
                "povlFrom": "S računa",
                "povlTo": "Na račun",
                "povlAmount": "Iznos",
                "povlDueDate": "Datum naplate",
                "povlValueDate": "Datum valutacije",
                "filterStatus": "Filtriraj po statusu",
                "loadMoreBtn": "Prikaži još naloga",
                "referenceTo": "Poziv na broj",
                "titleLabel": "Pregled naloga",
                "signatoryName": "Potpisao",
                "signDate": "Datum akcije",
                "recallerName": "Opozvao",
                "paymentsType": {
                    "all": "Svi",
                    "opened": "Otvoreni",
                    "partiallysigned": "Djelimično potpisani",
                    "cancelled": "Otkazani",
                    "processed": "Obrađeni",
                    "rejected": "Odbijeni",
                    "closed": "Zatvoreni",
                    "signed": "Potpisani",
                    "notSigned": "Nepotpisani",
                    "inprocessing": "U obradi",
                    "forcancelling": "Za otkazivanje",
                    "storned": "Stornirani",
                    "rejectedaftercomplaint": "Odbijeni nakon žalbe",
                    "acceptedaftercomplaint": "Prihvaćeni nakon žalbe",
                    "allTab": "Svi nalozi",
                    "realizedTab": "Realizirani",
                    "pendingTab": "Nalozi na čekanju",
                    "rejectedTab": "Odbijeni nalozi"
                },
                dateRange: "Filtriraj prema razdoblju",
                "dateFrom": "vrijeme od",
                "dateTo": "vrijeme do",
                "filterByPurpose": "Pretraži po namjeni",
                "noPaymentData": "Za odabrani filter nema naloga.",
                "selectAll": "Označi sve",
                "selectNone": "Odznači sve",
                "signSelectedPayments": "Potpiši odabrana plaćanja",
                "povlNote": "Napomena",
                "referenceNumber": "Referentni broj",
                "cancelled": "Opozvan",
                "processed": "Obrađen",
                "rejected": "Odbijen",
                "open": "Kreiran",
                "inProcessing": "U obradi",
                "waitingQueque": "Na čekanju",
                "signed": "Potpisan",
                "Cancelled": "Opozvan",
                "Processed": "Obrađen",
                "Rejected": "Odbijen",
                "Opened": "Kreiran",
                "InProcessing": "U obradi",
                "WaitingQueue": "Na čekanju",
                "Signed": "Potpisan"
            },
            domesticPayment: {
                "header": "Opći nalog",
                "fromAccountSelectLabel": "S računa",
                "availableAmountLabel": "Raspoloživo",
                "purposeCodeSelectLabel": "Šifra namjene",
                "purposeOfPaymentInputLabel": "Svrha plaćanja",
                "amountInputLabel": "Iznos",
                "dateInputLabel": "Datum",
                "bicCodeInputLabel": "BIC kod",
                "toAccountInputLabel": "IBAN primatelja",
                "toAccountInputLabelSRB": "Račun primatelja",
                "toPayee": "Primatelj",
                "toAccountInputBtn": "Dopuni primatelja",
                "referenceNumberLabel": "Poziv na broj",
                "referenceModelLabel": "Reference model",
                "receiversNameInputLabel": "Ime primatelja",
                "receiversAddressInputLabel": "Adresa primatelja",
                "receiversPostalCodeAndCityInputLabel": "Poštanski kod i grad primatelja",
                "receiversCountrySelectLabel": "Zemlja primatelja",
                "payersNameInputLabel": "Ime i prezime pošiljaoca",
                "payersAddressInputLabel": "Adresa pošiljaoca",
                "payersCityInputLabel": "Grad pošiljaoca",
                "amountPlaceholder": "eg. 1.000,00",
                "reviewAndSubmitBtn": "Pregledajte i pošaljite",
                "selectUrgentLabel": "Označite za hitnu uplatu putem HSVP-a, koja se dodatno naplaćuje po važećoj Tarifi Banke",
                "urgentPaymentInfo": "Hitna plaćanja se naplaćuju po važećoj Tarifi Banke",
                "processingFeeLabel": "Naknada za obradu naloga",
                "receiverAccountError": "Račun primatelja je obavezan!",
                "receiverAccountErrorHR": "IBAN / Broj računa primatelja je obavezan!",
                "receiverNameError": "Naziv primatelja je obavezan!",
                "receiverCityError": "Grad primatelja je obavezan!!",
                "receiverAddressError": "Adresa primatelja je obavezna!",
                "sepaDebitorLabel": " Stvarni dužnik",
                "sepaReceiverLabel": "Krajnji primatelj",
                "confirmBtn": "Potvrdi",
                "selectFromTemplate": "Odaberi iz predloška",
                "listOfTemplates": "Lista predložaka",
                "bankCharges": "Provizija",
                "urgentPayment": "Ovaj nalog je hitan",
                "checkBankCharges": "Provjeri dodatne naknade",
                "referenceModelInputError": "Poziv na broj je obavezan!",
                "referenceModelInputInvalid": "Poziv na broj nije ispravan!",
                "toPayeeInputError": "Naziv primatelja je obavezan!",
                "toPayee2": "Primatelj (naziv/ime i adresa)",
                "newPayment": "Novi nalog",
                "delete": "Izbriši",
                "edit": "Uredi",
                "sign": "Potpiši",
                "ibanStructError": "IBAN nije ispravan",
               "taxPayerNumber": "Broj poreznog obveznika",
               "paymentType": "Vrsta uplate",
               "revenueCode": "Vrsta prihoda",
               "municipality": "Općina/opština",
               "taxPeriodFrom": "Poreski period od",
               "taxPeriodTo": "Poreski period do",
               "budgetOrganisation": "Budžetska organizacija",
               "taxPayerError": "Broj poreznog obveznika je obavezan!",
               "revenueCodeError": "Vrsta prihoda je obavezna!",
               "budgetOrganizationError": "Budžetska organizacija je obavezna!",
               "municipalityError": "Općina/opština je obavezna!",
               "municipalityExistanceError": "Općina/opština ne postoji!",
               "taxPeriodRangeError": "Poreski period nije u ispravnom opsegu!",
               "revenueCodeTypeError": "Tip prihoda ne odgovara tipu računa!",
               "revenueCodeExistanceError": "Vrsta prihoda ne postoji!",
               "receiverAccountLengthError": "Račun primaoca mora imati 16 cifara!",
               "receiverAccountModuleError": "Račun primaoca nije korektan!",
               "referenceNumberRequired": "Poziv na broj je obavezan za javne prihode!",
               "referenceNumberMaxLength": "Poziv na broj je prevelik!",
               "referenceNumberError": "Poziv na broj nije validan!"
            },
            internationalPayment: {
                international: "Devizni nalog",
                "fromAccount": "S računa",
                "chargeAccount": "Račun naknade",
                "totalAmount": "Ukupan iznos i valuta",
                "paymentDate": "Datum plaćanja",
                "paymentPurpose": "Svrha uplate",
                "recipient": "Primatelj",
                "purposeCode": "Šifra svrhe",
                "recipientStatus": "Status primatelja",
                "companyName": "Ime i prezime ili puni naziv tvrtke",
                "address": "Adresa",
                "city": "Grad",
                "country": "Država",
                "recipientAccount": "Račun primatelja",
                "recipientBank": "Banka primatelja",
                "bankName": "Naziv banke",
                "swiftCode": "SWIFT kod",
                "bankCharges": "Bankovna naknada",
                "sharedCharges": "Zajednički troškovi",
                "payersPaysCharges": "Isplatitelj plaća troškove",
                "beneficiaryPaysCharges": "Korisnik plaća troškove",
                "naturalPerson": "Fizičko lice",
                "legalPerson": "Pravno lice",
                "tooltipInfo": "Trebate pomoć?",
                "fillData": "Popunite podatke o banci",
                "reviewandSubmit": "Pregled i potvrda",
                "companyNameInputError": "Ime i prezime je obavezno!",
                "recipientAddressInputError": "Adresa primatelja je obavezna!",
                "recipientCityInputError": "Grad primatelja je obavezan!",
                "recipientAccountInputError": "Račun primatelja je obavezan!",
                "bankNameInputError": "Naziv banke je obavezan!",
                "bankAddressInputError": "Adresa banke je obevezna!",
                "bankCityInputError": "Grad banke je obavezan!",
                "swiftCodeInputError": "SWIFT kod je obavezan!",
                "payersNameInputLabel": "Ime i prezime pošiljaoca",
                "payersAddressInputLabel": "Adresa pošiljaoca",
                "payersCityInputLabel": "Grad pošiljaoca",
                "sepaDebitorLabel": " Stvarni dužnik",
                "sepaReceiverLabel": "Krajnji primatelj",
                "paymentMode": "Svrha plaćanja",
                "toPayee2": "Primatelj (naziv/ime i adresa)",
                "toAccountInputLabel": "IBAN / Broj računa primatelja",
                "bicBankName": "Banka primatelja",
                "noBicBankInfo": "Napomena : Za platne transakcije upućene primateljima plaćanja u EU u korist računa koji nema konstrukciju IBAN-a, " +
                "kao i za platne transakcije u korist računa s nepoznatim BIC-kodom banke primatelja naplaćuje se naknada sukladno " +
                "Tarifi banke za međunarodne i prekogranične platne transakcije.",
            },
            internalTransfer: {
                "transferToAccount": "Prijenos na moj račun",
                "fromAccount": "Račun platitelja (IBAN)",
                "toAccount": "Račun primatelja (IBAN)",
                "dueDate": "Datum izvršenja",
                "valueDate": "Datum kreiranja",
                "amount": "Iznos",
                "sign": "Potpiši",
                "saveAsTemplate": "Pohrani kao predložak",
                "templateName": "Naziv predloška",
                "newPayment": "Kreiraj novi nalog",
                "toPaymentOverview": "Idi na pregeled svih plaćanja",
                "signSuccess": "Platni nalog je uspješno potpisan.",
                "toAccountInputError": "Račun primatelja je obavezan!",
                "paymentPurposeInputError": "Svrha uplate je obavezna!",
                "amountInputError": "Iznos je obavezan!",
                "dueDateError": "Datum izvršenja je obavezan!",
                "templateNameError": "Naziv je obavezan!",
                "when": "Datum",
                "transferComplete": "Prijenos je završen",
                "makeAnotherPayment": "Kreiraj novi nalog",
                "successfullyTransfer": "Uspješno ste prebacili",
                "amountLengthError": "Maksimalni iznos je 99.999.999.999,99",
                "nodata": "Nema podataka za prikaz"
            },
            paymentSignModal: {
                title: "Potpisivanje plaćanja",
                challengeResponse: "Unesite kod",
                ok: "Uredu"
            },
            loanPayment: {
                "loanPayment": "Plaćanje kredita",
                "recieverNumber": "Broj primatelja",
                "purpose": "Svrha uplate",
                "when": "Datum",
                "exchangeRate": "Tečaj",
                "referenceNumber": "Poziv na broj"
            },
            currencyConversion: {
                "exchangeOffice": "Mjenjačnica",
                "exchangeRatesCalculator": "Pregled valuta i tečajni kalkulator",
                "sellingAmount": "Prodaja",
                "buyingAmount": "Kupnja",
                "availableBalance": "Raspoloživo stanje",
                "fromAccount": "S računa",
                "toAccount": "Na račun",
                "amount": "Iznos",
                "sign": "Potpiši",
                "confirm": "Potvrdi",
                "back": "Novi nalog",
                "smsAuthentification": "SMS autentifikacija plaćanja",
                "sendSms": "Pošalji SMS kod",
                "smsPassword": "SMS jednokratna lozinka",
                "moneyExchangeComplete": "Novčana razmjena je završena",
                "successfullyExchange": "Uspješno ste razmjenili",
                "makeAnotherExchange": "Napravi još jednu razmjenu",
                "goToPayments": "Idi na pregled naloga",
                "exchangeRateRatio": "Tečajna lista",
                "exchangeOrder": "Zahtjev za razmjenom valuta",
                "signPayment": "Potpiši nalog",
                "deletePayment": "Izbriši nalog",
                "recallPayment": "Opozovi nalog",
                "balance": "Stanje računa",
                "exchangeRate": "Informativni tečaj",
                "bankCharges": "Cjenik banke",
                "when": "Datum",
                "buying": "Kupovni tečaj",
                "selling": "Prodajni tečaj",
                "calculatedAmount":"Preračunati iznos",
                "agreedRate":"Kurs"
            },
            paymentsAndTransferOverview: {
                rejectedLabel: "Poslednji neplaćeni nalozi",
                eInvoicesLabel: "Neplaćeni eRačuni",
                groupedPaymentsLabel: "Grupa naloga za potpis",
                repeatAction: "Ponovi",
                payAction: "Plati",
                signAllAction: "Potpiši sve",
                domPayToSign: "općih naloga za potpis",
                paymentsToSign: "naloga za potpis",
                "confirm": "Potvrdi"
            },
            ebook: {
                "ebookPayIn": "Uplata na eKnjižicu",
                "ebookPayOut": "Isplata sa eKnjižice"
            },
            savings: {
                "savingsPayIn": "Interni devizni prijenos"
            },
            signPayments: {
                "paymentsInvalidDueDate": "Neki od naloga imaju datum valute manji od tekućeg. Želite li ažurirati te datume na današnji?",
                "singlePaymentInvalidDueDate": "Odabrani nalog ima datum valute manji od tekućeg. Želite li ažurirati datum na današnji?",
                "updatePaymentsDueDate": "Ažuriraj krajnje datume plaćanja",
                "updatePaymentDueDate": "Ažuriraj krajnji datum plaćanja",
                "dateCreated": "Datum kreiranja",
                "dueDate": "Datum izvršenja",
                "confirm": "Potvrdi",
                "challengeResponse": "Kod potvrde",
                "challenge": "Validacijski kod",
                "challengeFirstCode": "Zaporka 1 (unosi se u token)",
                "challengeSecondCode": "Zaporka 2 (iz tokena)",
                "challengeDescription": "Uključite token - unesite PIN i odmah na prazan ekran (piše samo CHAL na vrhu) unesite broj koji je ispisan na ekranu 'Zaporka 1', i kliknite na gumb 'OK'. Token će ispisati zaporku 2 koju je potrebno prepisati u polje 'Zaporka 2'. Kada ste završili akciju, odaberite gumb 'POTVRDI'.",
                "finalStepSuccessfullySigned": "Uspješno ste potpisali nalog",
                "finalStepPaymentServices": "Za usluge platnog prometa naknada će biti obračunata u skladu sa službenim ",
                "finalStepBankTariff": "cjenikom Banke.",
                "finalStepStatus": "Status: ",
                "finalStepPaymentID": "Broj transakcije: ",
                "finalStepNumberOfPayments": "Broj naloga: ",
                "finalStepSentForProcessing": "Nalog je poslan u Banku na obradu.",
                "finalStepPaymentSloHeaderEx": "N/A",
                "finalStepPaymentSloHeaderPen": "N/A",
                "finalStepPaymentSloSubHeader": "N/A",
                "finalStepPaymentSloSubHeaderLink": "N/A",
                "finalStepPaymentSloTextEx": "N/A",
                "finalStepPaymentSloTextPen": "N/A",
                "cancel": "Odustani",
                "resendSms": "Ponovo pošalji SMS",
                "SmsCode": "SMS kod",
                "SmsDescription": "SMS poruka je poslana na vaš uređaj. Unesite kod iz SMS poruke u 'SMS kod' polje. Nakon unosa koda, odaberite gumb 'POTVRDI'.",
                "SmsSentSuccessfully": "SMS poruka uspješno poslana!",
                "paymentExecutionDateTitle": "Promjena datuma valute",
                "paymentExecutionDateBody": "Današnja obrada naloga je završena. Vaš nalog bit će izvršen sukladno terminskom planu Banke. Želite li nastaviti s potpisivanjem zadanog platnog naloga?"
            },
            paymentActions: {
                "repeat": "Ponovi nalog",
                "copy": "Kopiraj nalog",
                "delete": "Izbriši nalog",
                "print": "Ispiši nalog",
                "recall": "Opozovi nalog",
                "sign": "Potpiši nalog",
                "cancel": "Otkaži",
                "rejectRecall": "Odbij zahtjev",
                "approveRecall": "Prihvati zahtjev",
                "edit": "Promijeni nalog",
                "confirmation": "Order confirmation"
            },
            statementConfirmModalTranslations: {
                title: "Izjava",
                p1: "Sukladno Zakonu o međunarodnim mjerama ograničavanja u Banci za provedbu naloga, potrebno je popuniti ovu Izjavu. U protivnom, nalog neće biti proveden.",
                p2: "Pod kaznenom i materijalnom odgovornošću izjavljujem da je, za nalog u iznosu od ",
                p2_2: " za državu",
                p2_0: " osnova plaćanja",
                p2_1: "detaljno obrazloženje (specifikacija)*",
                p4: "Izjava je kreirana u elektroničkom obliku i važeća je bez pečata i potpisa.",
                radioMerchandise: "Roba*",
                radioPresent: "Poklon",
                radioOther: "Ostalo*",
                confirmButton: "Potvrdi",
                cancelButton: "Odustani"
            },
            "currencyCalculator": {
                "exchangeCalculator": "Tečajni kalkulator",
                "exchangeRates": "Kursna lista",
                "msg1": "Tečajna lista primjenjuje se za kupnju i prodaju deviza do iznosa protuvrijednosti od HRK 150.000,00.",
                "msg2": "Za veće iznose molimo kontaktirajte Odjel Prodaje proizvoda Riznice na " +
                    "tel.: 01 603 3513, 01 603 1746, 01 603 0616, 01 603 3533. ili 01/603-5336.",
                "updated":"Updated"
            },
            paymentsReturn: {
                openedTab: "Otvoreni",
                archivedTab: "Arhivirani",
                titleLabel: "Suglasnost za povrat sredstava",
                modalTitle: "Odaberite razlog za povrat sredstava",
                recallReason: "Razlog za povrat",
                additionalInfo: "Dodatne informacije",
                additionalInfoError: "Ovo polje je obavezno",
                reasonTech: "Tehnički problemi koji rezultiraju pogrešnim platnim nalogom kreditnog transfera",
                reasonFrad: "Lažno iniciranje platnog naloga kreditnog transfera (required additiona info field)",
                reasonDupl: "Duplo slanje"
            },
            paymentsFinal: {
                "InProcessing": "U obradi",
                "Signed": "Potpisan",
                "WaitingQueue":"Nalog je poslat na čekanje"
            },
            paymentsTypeGroup: {
                "CurrencyExchange":"CurrencyExchange",
                "LocalCurrencyTransfer":"LocalCurrencyTransfer",
            }
        };

        $translateProvider
            .translations('hr', data);
    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      payments: {
        "quickPaymentTransfer": "Quick payment or transfer",
        "domesticPayments": "Universal payment order",
        "currencyConversion": "Currency conversion",
        "internationalPayment": "International payment",
        "rejectedPayments": "Rejected payments",
        "pendingPayments": "Pending payments",
        "templates": "Templates",
        "searchTemplateName": "Search template by name",
        "topUsed": "Top used",
        "alphabetically": "Alphabetically",
        "to": "to",
        "showMoreTemplates": "Show more templates",
        "eInvoices": "eInvoices",
        "showMoreInvoices": "Show all eInvoices",
        "sepaDirectDebit": "SEPA DD Settings",
        "viewAllTransactions": "View all transactions",
        "due": "due",
        "allPastPayments": "View all past payments",
        "exchangeRatesList": "Exchange rates list",
        "pay": "Pay",
        "internalTransfer": "Internal transfer",
        "noEinvoices": "No eInvoice data",
        "noTemplates": "No template data",
        "forCurrencyConversion": "for currency conversion",
        "midrate": "midrate",
        "forForeignNotes": "for foreign notes, cheques",
        "onDate": "on ",
        "buy": "Buy",
        "goBackToPayments": "Go back to payments",
        "currencyName": "Currency name",
        "code": "Code",
        "unit": "Unit",
        "buyRate": "Buy",
        "middleRate": "Middle",
        "sellRate": "Sell",
        "action": "Action",
        "noRejectedPayments": "No rejected payments for selected period",
        "noPendingPayments": "No pending payments for selected period",
        "donationToCharity": "Donation to charity",
        "subscribe": "Subscribe",
        "settings": "Settings",
        "moreRejected": "More rejected payments",
        "morePending": "More pending payments",
        "currencyExchange": "Currency conversion",
        "exchange": "Exchange",
        "fromAccount": "From account",
        "toAccount": "To account",
        "willSell": "I will sell",
        "willBuy": "I will buy",
        "available": "Available",
        "delete": "Delete",
        "edit": "Edit",
        "loanPayment": "Loan payment",
        "toAcc": "to account",
        "paymentMode": "Payment mode",
        "fromAcc": "from account",
        "bicNumber": "SWIFT Number",
        "bicNumber_SLO": "SWIFT code",
        "bicBankName": "Bank name",
        "bicAddress": "Bank Address",
        "bicCity": "Bank City",
        "bicCountry":"Bank Country",
        "bicCountry_SLO":"Recipient's bank country code",
        "bicRecipientStatus": "Recipient (person)",
        "bicRecipientStatusOptionLegal": "Legal",
        "bicRecipientStatusOptionPhysical": "Physical",
        "bicBankCharges": "Charge option",
        "bicNumberRequired": "BIC number is required!",
        "bicNumberMaxLength": "BIC number must have 8 or 11 digits!",
        "receiversPostalCodeAndCityInputRequired": "Recipient city is required!",
        "bicBankNameRequired": "Bank name is required!",
        "bicCityRequired": "Bank city is required",
        "bicCountryRequired": "Country is required!",
        "bankAddressInputRequired": "Bank address is required!",
        "resend": "Resend",
        "minimalAccountNumber": "Account is invalid!",
        "cancel": "Cancel",
        "templateSavedSuccessfully": "Template saved successfully!",
        "templateUpdatedSuccessfully": "Template updated successfully !",
        "paymentDueDateChangedMsg": "Payment due date has been changed according to Timetable of payment services. Please, confirm.",
        "dueDateChangedMsg1": "Payment due date has been changed",
        "dueDateChangedMsg2": "Please, confirm.",
        "cancelledPaymentMsg": 'The payment was cancelled and will not be executed. The cancelled payment will remain in the List of payments/Realized. You can resend it to the Bank for processing by clicking the "Execute" button.'
      },
      paymentsOverview: {
        "notSupportedPaymentMsg": "Payment with the selected template is not possible anymore.",
        "pohReciver": " to ",
        "pohAmount": " in amount of ",
        "pohDate": " on ",
        "povlStatus": "Status",
        "povlNote": "Note",
        "povlNote_SLO": "Rejection reason",
        "povlId": "Payment id",
        "povlReceiver": "Recipient name",
        "povlFrom": "From account",
        "povlTo": "To account",
        "povlAmount": "Amount",
        "povlAmountSlo": "Buying amount",
        "povlDueDate": "Date of execution",
        "povlValueDate": "Value date",
        "filterStatus": "Filter by status",
        "loadMoreBtn": "Load more",
        "referenceTo": "Reference to",
        "titleLabel": "List of payments",
        "signatoryName": "Signatory",
        "signDate": "Date of action",
        "recallerName": "Recaller",
        "recepientInfo": "Recipient information",
        "orderPaymentConfirmation": "Order payment confirmation",
        "receiveConfirmation": "I would like to receive the confirmation to the following address",
        "orderComment": "Order comment",
        "orderPaymentConfMsg1": "I allow the Bank to debit my account for the costs of producing and sending the Payment confirmation in accordance with the current",
        "orderPaymentConfMsg2": "price list of Addiko Bank d.d.",
        "payerAccNumber": "Payer account number",
        "recAccNumber": "Receiver account number",
        "uniMandateRef": "Unique mandate reference",
        "dueDate": "Due date",
        "creditorInd": "Creditor identifier",
        "recReference": "Receiver reference",
        "messageAboutError": "Rejection reason",
        "minLength5": "Minimum length is 5!",
        "orderSuccessAlert":"Order was successfully submitted.",
        "orderConfirmationBtn":"Order confirmation",
        "reclamationSuccess": "Payment complaint was succesfully submitted.",
        "paymentsType": {
          "all": "All",
          "opened": "Opened",
          "partiallysigned": "Partially signed",
          "cancelled": "Cancelled",
          "processed": "Processed",
          "rejected": "Rejected",
          "closed": "Closed",
          "signed": "Signed",
          "notSigned": "Opened",
          "inprocessing": "In processing",
          "forcancelling": "For cancelling",
          "storned": "Storned",
          "rejectedaftercomplaint": "Rejected after complaint",
          "acceptedaftercomplaint": "Accepted after complaint",
          "allTab": "All",
          "realizedTab": "Realized payments",
          "pendingTab": "Pending payments",
          "rejectedTab": "Rejected payments",
          "waitingQueque": "Waiting queue"
        },
        "status":{
              "Opened":"Opened",
              "Rejected":"Rejected",
              "WaitingQueue":"WaitingQueue",
              "Processed":"Processed"
        },
        dateRange: "Filter by date range",
        "dateFrom": "Date from",
        "dateTo": "Date to",
        "filterByPurpose": "Search by purpose",
        "noPaymentData": "No payment data for selected filter.",
        "selectAll": "Select all",
        "selectNone": "Select none",
        "signSelectedPayments": "Sign selected payments",
        "referenceNumber": "Reference number",
        "cancelled": "Cancelled",
        "processed": "Succesfully processed",
        "rejected": "Rejected",
        "open": "Open",
        "inProcessing": "In process",
        "signed": "Signed",
        "waitingQueque":"Waiting to be processed",
        "Cancelled": "Cancelled",
        "Processed": "Succesfully processed",
        "Rejected": "Rejected",
        "Opened": "Open",
        "InProcessing": "In process",
        "Signed": "Signed",
        "WaitingQueue":"Waiting to be processed",
        "totalPendingSum":"Total pending:"
      },
      domesticPayment: {
        "header": "Domestic payment",
        "headerSl": "Universal payment order",
        "fromAccountSelectLabel": "From account",
        "availableAmountLabel": "Available",
        "purposeCodeSelectLabel": "Purpose code",
        "purposeOfPaymentInputLabel": "Purpose of payment",
        "toPayee": "To recipient",
        "amountInputLabel": "Amount",
        "dateInputLabel": "Date",
        "bicCodeInputLabel": "BIC code",
        "toAccountInputLabel": "IBAN of recipient",
        "toAccountInputLabelSLO": "IBAN of recipient",
        "toAccountInputLabelSRB": "To account",
        "toAccountInputBtn": "Fill recipient",
        "referenceNumberLabel": "Reference number",
        "referenceModelLabel": "Model",
        "receiversNameInputLabel": "Recipient's name",
        "receiversAddressInputLabel": "Recipient's address",
        "receiversPostalCodeAndCityInputLabel": "Recipient's postal code and city",
        "receiversPostalCodeAndCityInputLabelSlo": "Recipient's city",
        "receiversCountrySelectLabel": "Recipient's country",
        "payersNameInputLabel": "Payer's name",
        "payersAddressInputLabel": "Payer's address",
        "payersCityInputLabel": "Payer's city",
        "amountPlaceholder": "eg. 1,000.00",
        "reviewAndSubmitBtn": "Review and submit",
        "selectUrgentLabel": "Check for urgent payment through HSVP which is charged extra by the current Bank's Tariff",
        "selectUrgentLabelSLO": "Urgent",
        "selectUrgentLabelSRB": "Select if this is an urgent payment",
        "urgentPaymentInfo": "Urgent payments are charged by the current Bank's Tarriff.",
        "processingFeeLabel": "Processing fee",
        "receiverAccountError": "Recipient account is required!",
        "receiverAccountErrorHR":"IBAN No. / Account No. of Recipient is required!",
        "receiverNameError": "Recipient name is required!",
        "receiverCityError": "Recipient city is required!",
        "receiverAddressError": "Recipient address is required!",
        "receiversPostalCodeAndCityInputError": "Recipient city is required!",
        "sepaDebitorLabel": "Real debtor",
        "sepaReceiverLabel": "End beneficiary",
        "confirmBtn": "Confirm",
        "selectFromTemplate": "Select from template",
        "listOfTemplates": "List of templates",
        "bankCharges": "Expected fee",
        "urgentPayment": "This payment is urgent",
        "checkBankCharges": "Check the bank charges",
        "referenceModelInputError": "Reference number is required!",
        "referenceModelInputRFError": '"RF" reference is not specified.',
        "referenceModelInputSIError": '"SI" reference should not be left empty.',
        "referenceModelInputInvalid": "Reference number is invalid!",
        "toPayeeInputError": "Recipient is required",
        "toPayee2":"Recipient (company/name and address)",
        "newPayment":"New payment",
        "delete":"Delete",
        "edit":"Edit",
        "sign":"Sign",
        "ibanStructError":" IBAN structure is incorrect.",
        "SEPAcodesLink": "Explanation of SEPA codes",
        "timetableForProvisionLink": "Timetable for the provision of payment services",
        "selectHumanitarianOrganisationLabel": "Select humanitarian organisation (make donation without fee)",
        "listOfOrganisations": "List of organisations",
        "taxPayerNumber": "Taxpayer number",
        "paymentType": "Payment type",
        "revenueCode": "Revenue type",
        "municipality": "Municipality",
        "taxPeriodFrom": "Tax period from",
        "taxPeriodTo": "Tax period to",
        "budgetOrganisation": "Budget organisation",
        "taxPayerError": "Taxpayer is required!",
        "revenueCodeError": "Revenue code is required!",
        "budgetOrganizationError": "Budget organization is required!",
        "municipalityError": "Municipality is required!",
        "municipalityExistanceError": "Municipality doesn't exist!",
        "taxPeriodRangeError": "Tax period range is not correct!",
        "revenueCodeTypeError": "Revenue code type don't match to account type!",
        "revenueCodeExistanceError": "Revenue code type doesn't exist!",
        "receiverAccountLengthError": "Receiver account must have 8 or 16 digits!",
        "domesticReceiverAccountLengthError": "Receiver account must have 16 digits! ",
        "receiverAccountModuleError": "Receiver account invalid!",
        "referenceNumberRequired": "Reference number is required for public revenue!",
        "referenceNumberError": "Reference number is not valid!",
        "referenceNumberMaxLength": "Reference number to long!",
        "bicBankPrejemnika":"Recipient's bank BIC",
        "sepaRegister":"SEPA register",
        "nonWorkingDay":"Choosen date is a non working day! Please select another date.",
        "confirmBtnSlo":"Next",
        "back":"Back",
        "toAccountMinlength19": "IBAN number must have 19 characters !",
        changePaymentModal : {
          "yes":"Yes",
          "no":"No",
          "confirm":"Confirm",
          "cancel":"Cancel",
          "close":"Close",
          "ok": "Ok"
        },
        "accountEqualityError": "Accounts must be different!",
        "paymentPurposeLengthError": "Excessive length",
        "urgentInfo":"You marked the order as urgent. The cost of an urgent payment is higher and priced according to Addiko Bank d.d. pricelist of services. Please check if the order has to be executed as urgent.",
        "secondNotInSEPAMessage":"Would you like to open an international payment?"
      },
      internationalPayment: {
        "maxlength34": "Maximum 34 characters are allowed.",
        international: "International payment",
        "fromAccount": "From account",
        "chargeAccount": "Charge account",
        "totalAmount": "Total amount and currency",
        "paymentDate": "Payment date",
        "paymentPurpose": "Purpose of payment",
        "purposeCode": "Purpose code",
        "recipient": "Recipient",
        "recipientStatus": "Recipient status:",
        "companyName": "Name and surname of full name of the company",
        "address": "Address",
        "city": "City",
        "country": "Country",
        "recipientAccount": "Recipient's account",
        "recipientBank": "Recipient's bank",
        "bankName": "Bank name",
        "swiftCode": "SWIFT Code",
        "bankCharges": "Expected fee",
        "sharedCharges": "Shared charges",
        "payersPaysCharges": "Payers pays charges",
        "beneficiaryPaysCharges": "Recipient pays charges",
        "naturalPerson": "Private",
        "legalPerson": "Legal",
        "tooltipInfo": "Need help?",
        "fillData": "Fill bank info",
        "reviewandSubmit": "Review and submit",
        "companyNameInputError": "Name and surname are required!",
        "recipientAddressInputError": "Recipient address is required!",
        "recipientCityInputError": "Recipient city is required!",
        "recipientAccountInputError": "Recipient account is required!",
        "bankNameInputError": "Bank name is required!",
        "bankAddressInputError": "Bank address is required!",
        "bankCityInputError": "Bank city is required!",
        "swiftCodeInputError": "SWIFT code is required!",
        "payersNameInputLabel": "Payer's name",
        "payersAddressInputLabel": "Payer's address",
        "payersCityInputLabel": "Payer's city",
        "sepaDebitorLabel": "Real debtor",
        "sepaReceiverLabel": "End beneficiary",
        "paymentMode": "Payment mode",
        "toPayee2":"Recipient (company/name and address)",
        "toAccountInputLabel": "IBAN No. / Account No. of Recipient",
        "toAccountInputLabel_SLO": "Recipient's account (IBAN)",
        "bicBankName": "Foreign Bank",
        "noBicBankInfo": "Note: For payment transactions addressed to recipients in the EU payment to the account that does not have the structure of the " +
        "IBAN and the payment transaction to the account of the unknown BIC code of the recipient bank will be charged " +
        "according to the Tariff of the bank for international and cross-border transactions.",
        "chooseCountry":"Choose a country",
        "paymentChargesAmount": "Payment charges amount"
      },
      internalTransfer: {
        "transferToAccount": "Transfer to my account",
        "transferToAccountLink": " Internal payment order",
        "fromAccount": "From account (IBAN)",
        "toAccount": "To account (IBAN)",
        "dueDate": "Due date",
        "valueDate": "Value date",
        "amount": "Amount",
        "sign": "Sign",
        "saveAsTemplate": "Save payment as template",
        "templateName": "Template name",
        "newPayment": "Make a new payment",
        "toPaymentOverview": "Go to payment overview",
        "signSuccess": "Payment is successfully signed.",
        "toAccountInputError": "Receiver account is requred!",
        "paymentPurposeInputError": "Purpose of payment is required!",
        "amountInputError": "Amount is required!",
        "dueDateError": "Due date is required!",
        "templateNameError": "Name is required!",
        "when": "Date",
        "transferComplete": "Transfer complete",
        "makeAnotherPayment": "Make another payment",
        "successfullyTransfer": "You have succesfully transfered",
        "amountLengthError": "Max amount is 99,999,999,999.99",
        "amountLengthErrorBh": "Maximum number of digits is 9.",
        "nodata": "No availabe data",
        "infoMne0":"Note for payments on Revolving and MasterCard:",
        "infoMne1":"Payments made before 15:30h will be booked and funds available on account during next working day.",
        "infoMne2":"Payments made after 15:30h will be booked and funds available on account during next two working days.",
        "minAmount10Error": "Minimal allowed amount is ",
        "toAccountNoData": 'Transfer is not possible with just one account in the EBank. For currency exchange select "Exchange office" in the "Payments" menu.'
      },
      paymentSignModal: {
        title: "Sign payment",
        challengeResponse: "Enter challenge response",
        ok: "Ok"
      },
      loanPayment: {
        "loanPayment": "Loan payment",
        "recieverNumber": "Reference number",
        "purpose": "Purpose",
        "when":"Date",
        "exchangeRate":"Exchange rate",
        "referenceNumber":"Reference number",
        "defaultPurpose":"Loan Repayment"
      },
      currencyConversion: {
        "exchangeOffice": "Exchange office",
        "exchangeRatesCalculator": "Exchange rates and calculator",
        "sellingAmount": "Selling",
        "buyingAmount": "Buying",
        "availableBalance": "Available balance",
        "fromAccount": "From acount",
        "toAccount": "To account",
        "amount": "Amount",
        "amountTo": "Amount to",
        "sign": "Sign",
        "confirm": "Confirm",
        "back": "New payment",
        "smsAuthentification": "Payment SMS authentification",
        "sendSms": "Send sms code",
        "smsPassword": "Confirmation code",
        "moneyExchangeComplete": "Money exchange complete",
        "successfullyExchange": "You have succesfully exchange",
        "makeAnotherExchange": "Make another exchange",
        "goToPayments": "Go to payment overview",
        "exchangeRateRatio": "Exchange rate",
        "exchangeOrder": "Your exchange order",
        "signPayment": "Sign payment",
        "deletePayment": "Delete payment",
        "recallPayment": "Recall payment",
        "balance":"Balance",
        "exchangeRate":"Exchange rates",
        "bankCharges":"Expected fee",
        "when":"Date",
        "buying":"Buying amount",
        "selling":"Selling amount",
        "calculatedAmount":"Calculated amount",
        "agreedRate":"Agreed rate",
        "bankCurrencyInfoMsg11": "Bank carries out currency conversion according to the exchange rates of Addiko Bank d.d. for natural persons at the time of purchase or sale, regardless of the current exchange rate at the time of the order. Consequently, actual value of converted amount could be different than the value calculated in the order. You can view the applicable Addiko Bank d.d. foreign currency exchange rates at the",
        "bankCurrencyInfoMsg12": " bank's website."
      },
      paymentsAndTransferOverview: {
        rejectedLabel:"Last rejected payments",
        eInvoicesLabel:"Unpaid eInvoices",
        groupedPaymentsLabel:"Group of payments to sign",
        repeatAction:"Repeat",
        payAction:"Pay",
        signAllAction:"Sign all",
        domPayToSign:"Universal payment orders to sign",
        paymentsToSign: "payments to sign",
        "confirm": "Confirm"

      },
      ebook: {
        "ebookPayIn":"E-Book pay in",
        "ebookPayOut": "E-Book pay out"
      },
      savings: {
        "savingsPayIn": "Foreign currency transfer"
      },
      signPayments: {
        "paymentsInvalidDueDate": "Some of the payments have old due date. Do you want to update payments to current date?",
        "singlePaymentInvalidDueDate": "Selected payment has old due date. Do you want to update payment to current date?",
        "updatePaymentsDueDate": "Update payments due date",
        "updatePaymentDueDate": "Update payment due date",
        "dateCreated": "Date created",
        "dueDate": "Due date",
        "confirm": "Confirm",
        "challengeResponse": "Challenge response",
        "challenge": "Challenge",
        "challengeFirstCode": "Password 1 (insert in token)",
        "challengeSecondCode": "Password 2 (from token)",
        "challengeSecondCodeBh": "Password (from token)",
        "otpLabel": "OTP",
        "challengeDescription": "Turn your token on, enter the PIN and after that (CHAL is written at the top of the screen) enter the number which you can read on HYPOnet 'Password 1' screen and click on the 'OK' button. Token will calculate and display the Password 2 which you should copy to the 'Password 2' field. After you have entered both numbers select the 'CONFIRM' button.",
        "finalStepSuccessfullySigned": "Payment successfully submitted.",
        "finalStepPaymentServices": "The charge for payment services will be calculated in accordance with the official ",
        "finalStepBankTariff": "bank tariff.",
        "finalStepStatus": "Status: ",
        "finalStepPaymentID": "Payment number: ",
        "finalStepNumberOfPayments": "Number of payments: ",
        "finalStepSentForProcessing": "Payment was sent to bank for processing.",
        "finalStepPaymentSloHeader": "Payment has been successfully submitted.",
        "finalStepPaymentSloSubHeader":"You can check if the payment was processed on the ",
        "finalStepPaymentSloText": "If execution date of your payment is later than the current date, the payment has been placed under Pending payments. On the day of payment change or cancellation of payment is not possible.",
        "cancel":"Cancel",
        "resendSms": "Resend SMS",
        "resendSmsSlo": "Resend SMS (valid for SMS code only)",
        "SmsCode": "Confirmation code",
        "SmsDescription": "Confirmation SMS was sent to your device. Enter the code from SMS into 'SMS code' field. After you have entered number select the 'CONFIRM' button.",
        "SmsDescriptionSLO": "Please enter your confirmation code, which you received with SMS or generated it with your token. Selected way of confirmation of transactions can be checked in Settings.",
        "SmsDescriptionBh": "Confirmation SMS was sent to your device. Enter the code from SMS into 'SMS code' field. After you have entered number select the 'CONFIRM' button. 'SMS code' is valid for 90 seconds.",
        "OtpDescriptionBh": "Confirm sign by entering OTP number from mini token.",
        "SmsSentSuccessfully": "SMS sent successfully!",
        "paymentExecutionDateTitle": "Change currency date",
        "paymentExecutionDateBody": "Todays processing of payment orders is finished. Your payment order will be executed according to time schedule of bank. Do you want to continue with signing of entered payment order?",
        "infoDomMne0":"Your payment will be processed in accordance with defined time frame ",
        "infoDomMne1":"(Time schedule).",
        "infoDomSrb0":"Your payment will be processed in accordance with defined time frame ",
        "infoDomSrb1":"(Time schedule).",
        "infoDomSrbLink":"",
        "infoDomMneLink":"https://www.addiko.me/sites/addiko.me/files/content/terminski_plan_obrade_naloga.pdf"
      },
      paymentActions: {
        "repeat": "Repeat payment",
        "copy": "Copy payment",
        "delete": "Delete payment",
        "printSlo": "Payment Confirmation",
        "print": "Print confirmation",
        "recall": "Recall payment",
        "cancelPayment": "Cancel payment",
        "sign": "Sign payment",
        "cancel":"Cancel",
        "rejectRecall": "Reject recall",
        "approveRecall": "Approve recall",
        "edit":"Edit payment",
        "complaint": "Complaint",
        "confirmation": "Order confirmation",
        "execute":"Execute",
        "changePayment": "Change payment"
      },
      statementConfirmModalTranslations: {
        title: "Statement",
        p1: "In accordance with the Law on international measures of limiting the execution of orders in the Bank, it is necessary to fill out this Statement. If the Statement is not filled out the order will not be executed.",
        p2: "Under criminal and material liability I am stating that the reason for payment, of the order in amount of ",
        p2_2: " for country",
        p2_0: "is the following one",
        p2_1: "* detailed explanation (specification)",
        p4: "Statement is created in electronic form and it is valid without the signature or stamp.",
        radioMerchandise: "Merchandise",
        radioPresent: "Present",
        radioOther: "Other*",
        confirmButton: "Confirm",
        cancelButton: "Cancel"
      },
      "currencyCalculator": {
        "exchangeCalculator": "Exchange calculator",
        "exchangeRates": "Exchange rates",
        "msg1": "The currency rate list is applied for purchase and selling of foreign currencies to maximum amount of HRK 150,000.00",
        "msg2": " For higher amounts please contact the Treasury Sales department in Addiko Bank phone " +
        "nr.: 01 603 3513, 01 603 1746, 01 603 0616, 01 603 3533. and for region Slavonia and Baranya phone " +
        "nr.: 031/231-553 i 031/231-223.  ",
        "updated":"Updated"
      },
      paymentsReturn: {
        openedTab: "Opened",
        archivedTab: "Archived",
        titleLabel: "Payments return confirmation",
        modalTitle: "Choose recall reason",
        recallReason: "Recall reason",
        additionalInfo: "Additional info",
        additionalInfoError: "This field is required",
        reasonTech: "Technical problems resulting in erroneous credit transfer",
        reasonFrad: "Fraudulently originated credit transfer",
        reasonDupl: "Duplicate sending"
      },
      paymentsFinal: {
        "InProcessing":"InProcessing",
        "Signed":"Signed",
        "WaitingQueue":"Waiting",
        "Opened":"Opened"
      },
      paymentsTypeGroup: {
          "CurrencyExchange":"Currency Exchange",
          "LocalCurrencyTransfer":"Local Currency Transfer",
          "DomesticPayment":"Universal Payment Order"
      },
      sepa: {
        "header": "SEPA Direct Debit Settings",
        "addNew": "Add a new setting"
      }

    };

    $translateProvider
      .translations('en', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      payments: {
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayments": "Opći/opšti nalog",
        "currencyConversion": "Konverzija valuta",
        "internationalPayment": "Devizni nalog",
        "rejectedPayments": "Odbijene uplate",
        "pendingPayments": "Uplate na čekanju",
        "templates": "Uzorci",
        "searchTemplateName": "Traži uzorak po nazivu",
        "topUsed": "Najčešće upotrebljeni",
        "alphabetically": "Po abecedi",
        "to": "ka",
        "showMoreTemplates": "Prikaži više uzoraka",
        "eInvoices": "eRačuni",
        "showMoreInvoices": "Prikaži sve eRačune",
        "sepaDirectDebit": "SEPA izravno dugovanje",
        "viewAllTransactions": "Pregled svih transakcija",
        "due": "dospio",
        "allPastPayments": "Pregled svih izvršenih plaćanja",
        "exchangeRatesList": "Tečajna/kursna lista",
        "pay": "Plati",
        "internalTransfer": "Interni prijenos/prenos",
        "noEinvoices": "Nema podataka za eRačune",
        "noTemplates": "Nema podataka za uzorak",
        "forCurrencyConversion": "pretvorba/konverzija valuta",
        "midrate": "srednja stopa",
        "forForeignNotes": "strane bilješke, čekovi",
        "onDate": "dana ",
        "buy": "Kupi",
        "goBackToPayments": "Povratak na plaćanja",
        "currencyName": "Naziv valute",
        "code": "Kod",
        "unit": "Jedinica",
        "buyRate": "Kupovni tečaj/kurs",
        "middleRate": "Srednji tečaj/kurs",
        "sellRate": "Prodajni tečaj/kurs",
        "action": "Akcija",
        "noRejectedPayments": "Za odabrani period nema odbijenih uplata",
        "noPendingPayments": "Za odabrani period nema uplata na čekanju",
        "donationToCharity": "Donacija u dobrotvorne svrhe",
        "subscribe": "Pretplata",
        "settings": "Postavke",
        "moreRejected": "Još odbijenih plaćanja",
        "morePending": "Još plaćanja na čekanju",
        "currencyExchange": "Menjačnica",
        "exchange": "Razmjeni",
        "fromAccount": "Sa računa",
        "toAccount": "Na račun",
        "willSell": "Prodaja",
        "willBuy": "Kupovina",
        "available": "Dostupno",
        "delete": "Obriši",
        "edit": "Promjeni",
        "loanPayment": "Plaćanje kredita",
        "paymentMode": "Svrha plaćanja",
        "toAcc": "na račun",
        "fromAcc": "sa računa",
        "bicNumber": "BIC broj",
        "bicBankName": "Banka primatelja/primaoca",
        "bicAddress": "BIC adresa",
        "bicCity": "BIC grad",
        "bicCountry":"Država primatelja/primaoca",
        "bicRecipientStatus": "Primatelj/Primalac (osoba)",
        "bicRecipientStatusOptionLegal": "Pravna",
        "bicRecipientStatusOptionPhysical": "Fizička",
        "bicBankCharges": "Troškovna opcija",
        "bicNumberRequired": "BIC adresa je obavezna!",
        "bicBankNameRequired": "Banka primatelja/primaoca je obavezna!",
        "bicCityRequired": "BIC grad je obavezan!",
        "bicCountryRequired": "Država primatelja/primaoca je obavezna!",
        "resend": "Pošalji ponovo",
        "minimalAccountNumber": "Račun nije ispravan!",
        "cancel": "Odustani",
        "templateSavedSuccessfully": "Uspješno ste kreirali uzorak!",
        "templateUpdatedSuccessfully": "Promjena uzorka je uspješno izvršena!",
        "bankAddressInputRequired": "Adresa banke je obavezna!."
      },
      paymentsOverview: {
        "pohReciver": " za ",
        "pohAmount": " u iznosu od ",
        "pohDate": " na dan ",
        "povlStatus": "Status",
        "povlId": "Id naloga",
        "povlReceiver": "Naziv primatelja/primaoca",
        "povlFrom": "Sa računa",
        "povlTo": "Na račun",
        "povlAmount": "Iznos",
        "povlDueDate": "Datum izvršenja",
        "povlValueDate": "Datum valutacije",
        "filterStatus": "Filtriraj po statusu",
        "loadMoreBtn": "Prikaži još naloga",
        "referenceTo": "Poziv na broj",
        "titleLabel": "Pregled naloga",
        "signatoryName": "Potpisnik",
        "signDate": "Datum akcije",
        "paymentsType": {
          "all": "Svi",
          "opened": "Otvoreni",
          "partiallysigned": "Djelimično potpisani",
          "cancelled": "Otkazani",
          "processed": "Obrađeni",
          "rejected": "Odbijeni",
          "closed": "Zatvoreni",
          "signed": "Potpisani",
          "notSigned": "Nepotpisani",
          "inprocessing": "U obradi",
          "forcancelling": "Za otkazivanje",
          "storned": "Stornirani",
          "rejectedaftercomplaint": "Odbijeni nakon žalbe",
          "acceptedaftercomplaint": "Prihvaćeni nakon žalbe",
          "allTab": "Svi",
          "realizedTab": "Realizirani/Realizovani nalozi",
          "pendingTab": "Nalozi na čekanju",
          "rejectedTab": "Odbijeni nalozi"
        },
        dateRange: "Filtriraj prema razdoblju",
        "dateFrom": "vrijeme od",
        "dateTo": "vrijeme do",
        "filterByPurpose": "Pretraži po namjeni",
        "noPaymentData": "Za odabrani filter nema naloga.",
        "selectAll": "Odaberi sve",
        "selectNone": "Poništi izbor",
        "signSelectedPayments": "Potpiši odabrana plaćanja",
        "povlNote":"Napomena",
        "referenceNumber": "Referentni broj",
        "cancelled": "Opozvan",
        "processed": "Izvršen",
        "rejected": "Odbijen",
        "open": "Kreiran - nepotpisan",
        "inProcessing": "U obradi",
        "waitingQueque": "Na čekanju",
        "signed": "Potpisan",
        "Cancelled": "Opozvan",
        "Processed": "Izvršen",
        "Rejected": "Odbijen",
        "Opened": "Kreiran - nepotpisan",
        "InProcessing": "U obradi",
        "WaitingQueue": "Na čekanju",
        "Signed": "Potpisan"
      },
      domesticPayment: {
        "header": "Opći/opšti nalog",
        "fromAccountSelectLabel": "Sa računa",
        "availableAmountLabel": "Raspoloživo",
        "purposeCodeSelectLabel": "Šifra plaćanja",
        "purposeOfPaymentInputLabel": "Svrha plaćanja",
        "amountInputLabel": "Iznos",
        "dateInputLabel": "Datum",
        "bicCodeInputLabel": "BIC kod",
        "toAccountInputLabel": "Račun primatelja/primaoca",
        "toAccountInputLabelSRB": "Račun primatelja/primaoca",
        "toPayee": "Primatelj/Primalac",
        "toAccountInputBtn": "Dopuni primatelja/primaoca",
        "referenceNumberLabel": "Poziv na broj",
        "referenceModelLabel": "Reference model",
        "receiversNameInputLabel": "Naziv primatelja/primaoca",
        "receiversAddressInputLabel": "Adresa primatelja/primaoca",
        "receiversPostalCodeAndCityInputLabel": "Poštanski broj i grad primatelja/primaoca",
        "receiversCountrySelectLabel": "Zemlja primatelja/primaoca",
        "payersNameInputLabel": "Ime i prezime pošiljaoca",
        "payersAddressInputLabel": "Adresa pošiljaoca",
        "payersCityInputLabel": "Grad pošiljaoca",
        "amountPlaceholder": "npr. 1.000,00",
        "reviewAndSubmitBtn": "Pregledajte i pošaljite",
        "selectUrgentLabel": "Označite kao hitnu uplatu",
        selectUrgentLabelSRB: "Označite kao hitnu uplatu",
        "urgentPaymentInfo": "Hitna plaćanja se naplaćuju po važećoj Tarifi Banke",
        "processingFeeLabel": "Naknada za obradu naloga",
        "receiverAccountError": "Račun primatelja/primaoca je obavezan!",
        "receiverAccountErrorHR":"IBAN / Broj računa primatelja/primaoca je obavezan!",
        "receiverNameError": "Naziv primatelja/primaoca je obavezan!",
        "receiverCityError": "Grad primatelja/primaoca je obavezan!!",
        "receiverAddressError": "Adresa primatelja/primaoca je obavezna!",
        "sepaDebitorLabel": "Stvarni dužnik",
        "sepaReceiverLabel": "Krajnji primatelj/primalac",
        "confirmBtn": "Potvrdi",
        "selectFromTemplate": "Plaćanje iz uzorka",
        "listOfTemplates": "Uzorci",
        "bankCharges": "Provizija",
        "urgentPayment": "Ovaj nalog je hitan",
        "checkBankCharges": "Provjeri dodatne naknade",
        "referenceModelInputError": "Poziv na broj je obavezan!",
        "referenceModelInputInvalid": "Poziv na broj nije ispravan!",
        "toPayeeInputError": "Naziv primatelja/primaoca je obavezan!",
        "toPayee2":"primatelj/primalac (naziv/ime i adresa)",
        "newPayment":"Novi nalog",
        "delete":"Obriši",
        "edit":"Promjeni",
        "sign":"Potpiši",
        "ibanStructError":"IBAN nije ispravan",
        "taxPayerNumber": "Broj poreznog obveznika",
        "paymentType": "Vrsta uplate",
        "revenueCode": "Vrsta prihoda",
        "municipality": "Općina/opština",
        "taxPeriodFrom": "Poreski period od",
        "taxPeriodTo": "Poreski period do",
        "budgetOrganisation": "Budžetska organizacija",
        "taxPayerError": "Broj poreznog obveznika je obavezan!",
        "revenueCodeError": "Vrsta prihoda je obavezna!",
        "budgetOrganizationError": "Budžetska organizacija je obavezna!",
        "municipalityError": "Općina/opština je obavezna!",
        "municipalityExistanceError": "Općina/opština ne postoji!",
        "taxPeriodRangeError": "Poreski period nije u ispravnom opsegu!",
        "revenueCodeTypeError": "Tip prihoda ne odgovara tipu računa!",
        "revenueCodeExistanceError": "Vrsta prihoda ne postoji!",
        "receiverAccountMinLengthError": "Račun primatelja/primaoca mora imati 8 ili 16 karaktera!",
        "receiverAccountModuleError": "Račun primatelja/primaoca nije ispravan!",
        "referenceNumberRequired": "Poziv na broj je obavezan za javne prihode!",
        "referenceNumberMaxLength": "Poziv na broj je prevelik!",
        "referenceNumberError": "Poziv na broj nije validan!",
        "receiverAccountLengthError": "Račun primatelja/primaoca mora imati 8 ili 16 cifara!",
        "domesticReceiverAccountLengthError": "Račun primatelja/primaoca mora imati 16 cifara!"
      },
      internationalPayment: {
        international: "Devizni nalog",
        "fromAccount": "Sa računa",
        "chargeAccount": "Račun naknade",
        "totalAmount": "Ukupan iznos i valuta",
        "paymentDate": "Datum plaćanja",
        "paymentPurpose": "Svrha uplate",
        "recipient": "primatelj/primalac",
        "purposeCode": "Šifra svrhe",
        "recipientStatus": "Status primatelja/primaoca",
        "companyName": "Ime i prezime ili puni naziv tvrtke",
        "address": "Adresa",
        "city": "Grad",
        "country": "Država",
        "recipientAccount": "Račun primatelja/primaoca",
        "recipientBank": "Banka primatelja/primaoca",
        "bankName": "Naziv banke",
        "swiftCode": "SWIFT kod",
        "bankCharges": "Bankovna naknada",
        "sharedCharges": "Zajednički troškovi",
        "payersPaysCharges": "Isplatitelj/Isplatilac plaća troškove",
        "beneficiaryPaysCharges": "Korisnik plaća troškove",
        "naturalPerson": "Fizičko lice",
        "legalPerson": "Pravno lice",
        "tooltipInfo": "Trebate pomoć?",
        "fillData": "Popunite podatke o banci",
        "reviewandSubmit": "Pregled i potvrda",
        "companyNameInputError": "Ime i prezime je obavezno!",
        "recipientAddressInputError": "Adresa primatelja/primaoca je obavezna!",
        "recipientCityInputError": "Grad primatelja/primaoca je obavezan!",
        "recipientAccountInputError": "Račun primatelja/primaoca je obavezan!",
        "bankNameInputError": "Naziv banke je obavezan!",
        "bankAddressInputError": "Adresa banke je obevezna!",
        "bankCityInputError": "Grad banke je obavezan!",
        "swiftCodeInputError": "SWIFT kod je obavezan!",
        "payersNameInputLabel": "Ime i prezime pošiljatelja/pošiljaoca",
        "payersAddressInputLabel": "Adresa pošiljatelja/pošiljaoca",
        "payersCityInputLabel": "Grad pošiljatelja/pošiljaoca",
        "sepaDebitorLabel": " Stvarni dužnik",
        "sepaReceiverLabel": "Krajnji primatelj/primalac",
        "paymentMode": "Svrha plaćanja",
        "toPayee2":"primatelj/primalac (naziv/ime i adresa)",
        "toAccountInputLabel": "IBAN / Broj računa primatelja/primaoca",
        "bicBankName": "Banka primatelja/primaoca",

      },
      internalTransfer: {
        "transferToAccount": "Prijenos/Prenos na moj račun",
        "transferToAccountLink": "Interni nalog",
        "fromAccount": "Račun platitelja/platioca (IBAN)",
        "toAccount": "Račun primatelja/primaoca (IBAN)",
        "dueDate": "Datum izvršenja",
        "valueDate": "Datum kreiranja",
        "amount": "Iznos",
        "sign": "Potpiši",
        "saveAsTemplate": "Pohrani kao uzorak",
        "templateName": "Naziv uzorak",
        "newPayment": "Kreiraj novi nalog",
        "toPaymentOverview": "Idi na pregeled svih plaćanja",
        "signSuccess": "Platni nalog je uspješno potpisan.",
        "toAccountInputError": "Račun primatelja/primaoca je obavezan!",
        "paymentPurposeInputError": "Svrha uplate je obavezna!",
        "amountInputError": "Iznos je obavezan!",
        "dueDateError": "Datum izvršenja je obavezan!",
        "templateNameError": "Naziv je obavezan!",
        "when": "Datum",
        "transferComplete": "Prenos/prijenos je završen",
        "makeAnotherPayment": "Kreiraj novi nalog",
        "successfullyTransfer": "Uspješno ste prebacili",
        "amountLengthErrorBh": "Maksimalni broj znakova je 9.",
        "nodata": "Nema podataka za prikaz"
      },
      paymentSignModal: {
        title: "Potpisivanje",
        challengeResponse: "Unesite kod",
        ok: "U redu"
      },
      loanPayment: {
        "loanPayment": "Plaćanje kredita",
        "recieverNumber": "Broj primatelja/primaoca",
        "purpose": "Svrha plaćanja",
        "when":"Datum",
        "exchangeRate":"Tečaj/Kurs",
        "referenceNumber":"Poziv na broj"
      },
      currencyConversion: {
        "exchangeOffice": "Kupoprodaja deviza",
        "exchangeRatesCalculator": "Pregled valuta i kalkulator",
        "sellingAmount": "Prodaja",
        "buyingAmount": "Kupovina",
        "availableBalance": "Raspoloživo stanje",
        "fromAccount": "Sa računa",
        "toAccount": "Na račun",
        "amount": "Iznos",
        "sign": "Potpiši",
        "confirm": "Potvrdi",
        "back": "Novi nalog",
        "smsAuthentification": "SMS autentifikacija plaćanja",
        "sendSms": "Pošalji SMS kod",
        "smsPassword": "SMS jednokratna lozinka",
        "moneyExchangeComplete": "Novčana razmjena je završena",
        "successfullyExchange": "Uspješno ste razmjenili",
        "makeAnotherExchange": "Napravi još jednu razmjenu",
        "goToPayments": "Idi na pregled naloga",
        "exchangeRateRatio": "Tečajna/kursna lista",
        "exchangeOrder": "Pregled naloga za kupoprodaju deviza",
        "signPayment": "Potpiši nalog",
        "deletePayment": "Obriši nalog",
        "recallPayment": "Opozovi nalog",
        "balance":"Stanje računa",
        "exchangeRate":"Tečaj/kurs menjačnice",
        "bankCharges":"Cjenovnik",
        "when":"Datum",
        "buying":"Kupovni tečaj/kurs",
        "selling":"Prodajni tečaj/kurs",
        "calculatedAmount":"Preračunati iznos",
        "agreedRate":"Tečaj/kurs"
      },
      paymentsAndTransferOverview: {
        rejectedLabel:"Posljednji neplaćeni nalozi",
        eInvoicesLabel:"Neplaćeni eRačuni",
        groupedPaymentsLabel:"Grupa naloga za potpis",
        repeatAction:"Ponovi",
        payAction:"Plati",
        signAllAction:"Potpiši sve",
        domPayToSign:"općih/opštih naloga za potpis",
        paymentsToSign: "naloga za potpis",
        "confirm": "Potvrdi"
      },
      ebook: {
        "ebookPayIn":"Uplata na eKnjižicu",
        "ebookPayOut": "Isplata sa eKnjižice"
      },
      savings: {
        "savingsPayIn": "Interni devizni prenos/prijenos"
      },
      signPayments: {
        "paymentsInvalidDueDate": "Neki od naloga imaju datum valute manji od tekućeg. Želite li ažurirati te datume na današnji?",
        "singlePaymentInvalidDueDate": "Odabrani nalog ima datum valute manji od tekućeg. Želite li ažurirati datum na današnji?",
        "updatePaymentsDueDate": "Ažuriraj krajnje datume plaćanja",
        "updatePaymentDueDate": "Ažuriraj datum izvršenja",
        "dateCreated": "Datum kreiranja",
        "dueDate": "Datum izvršenja",
        "confirm": "Potvrdi",
        "challengeResponse": "Kod potvrde",
        "challenge": "Validacijski kod",
        "challengeFirstCode": "Šifra 1 (unosi se u token)",
        "otpLabel": "OTP",
        "challengeSecondCode": "Šifra 2 (iz tokena)",
        "challengeSecondCodeBh": "Šifra (iz tokena)",
        "challengeDescription": "Uključite token, unesite PIN i odmah na prazan ekran (piše samo CHAL na vrhu) unesite broj koji je ispisan na ekranu 'Šifra 1', i kliknite na gumb/dugme 'OK'. Token će ispisati šifru 2 koju je potrebno prepisati u polje 'Šifra 2'. Kada ste završili akciju, odaberite gumb/dugme 'POTVRDI'.",
        "finalStepSuccessfullySigned": "Uspješno ste potpisali nalog",
        "finalStepPaymentServices": "Za usluge platnog prometa naknada će biti obračunata u skladu sa službenim ",
        "finalStepBankTariff": "cjenovnikom Banke.",
        "finalStepStatus": "Status: ",
        "finalStepPaymentID": "Broj transakcije: ",
        "finalStepNumberOfPayments": "Broj naloga: ",
        "finalStepSentForProcessing": "Nalog je poslat u Banku na obradu.",
        "finalStepPaymentSloHeaderEx": "N/A",
        "finalStepPaymentSloHeaderPen": "N/A",
        "finalStepPaymentSloSubHeader": "N/A",
        "finalStepPaymentSloSubHeaderLink": "N/A",
        "finalStepPaymentSloTextEx": "N/A",
        "finalStepPaymentSloTextPen": "N/A",
        "cancel":"Odustani",
        "resendSms": "Ponovo pošalji SMS",
        "SmsCode": "SMS kod",
        "SmsDescription": "SMS poruka je poslata na Vaš uređaj. Unesite kod iz SMS poruke u polje 'SMS kod'. Nakon unosa koda, odaberite opciju 'POTVRDI'. SMS kod važi 120 sekundi i nakon toga se ne može koristiti.",
        "SmsDescriptionBh": "SMS poruka je poslata na Vaš uređaj. Unesite kod iz SMS poruke u polje 'SMS kod'. Nakon unosa koda, odaberite opciju 'POTVRDI'. SMS kod važi 90 sekundi i nakon toga se ne može koristiti.",
        "OtpDescriptionBh": "Potvrdite potpis naloga tako sto ćete unijeti dinamičku lozinku (OTP) sa identifikacionog sredstva.",
        "SmsSentSuccessfully": "SMS poruka uspješno poslana!",
        "paymentExecutionDateTitle": "Promjena datuma valute",
        "paymentExecutionDateBody": "Obrada naloga je završena. Da li se slažete da se datum valute promeni na sledeći radni dan ?",
        "infoDomSrb0":"Vaše plaćanje će biti izvršeno u skladu sa definisanim vremenskim okvirima ",
        "infoDomSrb1":"(Terminski plan).",
        "infoDomSrbLink":""
      },
      paymentActions: {
        "repeat": "Ponovi nalog",
        "copy": "Kopiraj",
        "delete": "Obriši",
        "print": "Štampa",
        "recall": "Opozovi nalog",
        "sign": "Potpiši",
        "cancel": "Otkaži",
        "rejectRecall": "Odbij zahtjev",
        "approveRecall": "Prihvati zahtjev",
        "edit":"Izmjeni",
        "confirmation": "Potvrda"
      },
      statementConfirmModalTranslations: {
        title: "Izjava",
        p1: "Sukladno/Prema Zakonu o međunarodnim mjerama ograničavanja u Banci za provedbu naloga, potrebno je popuniti ovu Izjavu. U protivnom, nalog neće biti proveden.",
        p2: "Pod kaznenom i materijalnom odgovornošću izjavljujem da je, za nalog u iznosu od ",
        p2_2: " za državu",
        p2_0: " osnova plaćanja",
        p2_1: "detaljno obrazloženje (specifikacija)*",
        p4: "Izjava je kreirana u elektroničkom obliku i važeća je bez pečata i potpisa.",
        radioMerchandise: "Roba*",
        radioPresent: "Poklon",
        radioOther: "Ostalo*",
        confirmButton: "Potvrdi",
        cancelButton: "Odustani"
      },
      "currencyCalculator": {
        "exchangeCalculator": "Tečajni/kursni kalkulator",
        "exchangeRates": "Tečajna/kursna lista",
        "msg1": "",
        "msg2": "" +
        "tel.:  " +
        "tel: ",
        "updated":"Ažurirano"
      },
      paymentsReturn: {
        openedTab: "Otvoreni",
        archivedTab: "Arhivirani",
        titleLabel: "Suglasnost/Saglasnost za povrat sredstava",
        modalTitle: "Odaberite razlog za povrat sredstava",
        recallReason: "Razlog za povrat",
        additionalInfo: "Dodatne informacije",
        additionalInfoError: "Ovo polje je obavezno",
        reasonTech: "Tehnički problemi koji imaju za rezultat pogrešan platni nalog kreditnog transfera",
        reasonFrad: "Lažno iniciranje platnog naloga kreditnog transfera (required additiona info field)",
        reasonDupl: "Duplo slanje"
      },
      paymentsFinal: {
        "InProcessing":"U obradi",
        "Signed":"Potpisan",
        "WaitingQueue":"Nalog je poslat na čekanje",
        "Opened":"Otvoren"
      },
      paymentsTypeGroup: {
        "CurrencyExchange":"Kupoprodaja",
        "LocalCurrencyTransfer":"Interni prijenos/prenos"
      }
    };

    $translateProvider
      .translations('bh', data);
  }
}());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      paymentTemplates: {
        "payingFrom": "Uplata sa:",
        "payingTo": "Uplata na:",
        "howMuch": "Iznos",
        "description": "Opis",
        "when": "Datum",
        "fullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "showFullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "pay": "Plati",
        "delete": "Obriši",
        "save": "Snimi",
        "signPayment": "Potpiši",
        "cancel": "Odustani",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "dueDate": "Datum dospjeća",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primaoca",
        "receiver": "Primalac",
        "receiverAddress": "Adresa primaoca",
        "amount": "Iznos",
        "signMsg": "Proverite unesene podatke i potpišite",
        "saveTemplate": "Novi šablon",
        "invalidDate": "Datum je nevalidan!",
        "descriptionError": "Opis je obavezan!",
        "templateName": "Naziv šablona",
        "templateIcon": "Slika",
        "deleteSuccess1": "Šablon",
        "deleteSuccess2": "je uspešno obrisan."
      },
      templatesList: {
        "header":"Lista šablona",
        "searchTemplates": "Pretraži šablone",
        "addNewTemplate": "+ Dodaj novi šablon",
        "listOfTemplates":"Šabloni",
        "fromAccount":"Sa računa",
        "amount":"Iznos",
        "toPayee":"Primalac",
        "accountNumber":"Broj računa",
        "payeeStreet":"Adresa primaoca",
        "payeeCity":"Grad primaoca",
        "purposeCode":"Šifra plaćanja",
        "referenceModel":"Model",
        "referenceNumber":"Model i poziv na broj",
        "addTemplateToFavorites":"Dodaj predložak u favorite",
        "edit":"Izmeni",
        "save": "Snimi",
        "cancel": "Odustani"
      }
    };

    $translateProvider
      .translations('sr', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      paymentTemplates: {
        "payingFrom": "Plačilo z:",
        "payingTo": "Plačilo na:",
        "howMuch": "Znesek",
        "description": "Opis",
        "when": "Datum",
        "fullPaymentForm": "Prikaži cel plačilni nalog",
        "showFullPaymentForm": "Prikaži cel plačilni nalog",
        "pay": "Plačaj",
        "delete": "Brisanje",
        "save": "Shrani",
        "signPayment": "Podpiši",
        "cancel": "Prekliči",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Naslov banke",
        "address": "Naslov prejemnika plačila",
        "dueDate": "Rok plačila",
        "fromAccount": "Račun plačnika",
        "toAccount": "Račun prejemnika",
        "receiver": "Prejemnik",
        "receiverAddress": "Naslov prejemnika",
        "amount": "Znesek",
        "signMsg": "Preverite vnesene podatke in potrdite",
        "saveTemplate": "Nova predloga",
        "invalidDate": "Datum je neveljaven!",
        "descriptionError": "Vnos opisa je obvezen!",
        "templateName": "Naziv predloge",
        "templateIcon": "Ikona predloge",
        "deleteSuccess1": "Predloga",
        "deleteSuccess2": "je izbrisana."
      },
      templatesList: {
        "header":"Pregled predlog",
        "searchTemplates": "Išči predlogo",
        "addNewTemplate": "+ Dodaj novo predlogo",
        "listOfTemplates":"Seznam predlog",
        "fromAccount":"Z računa",
        "amount":"Znesek",
        "toPayee":"Prejemnik",
        "accountNumber":"Številka računa",
        "payeeStreet":"Naslov prejemnika",
        "payeeCity":"Kraj prejemnika",
        "purposeCode":"Namen",
        "referenceModel":"Model",
        "referenceNumber":"Referenca",
        "addTemplateToFavorites":"Dodaj predlogo med priljubljene",
        "edit":"Spremeni",
        "save":"Shrani",
        "cancel": "Prekliči",
        "bicBankPrejemnika": "BIC banke prejemnika",
        "pay":"Plačaj",
        "maxLengthReached":"Dosegel največje število znakov!"
      }
    };

    $translateProvider
      .translations('sl', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      paymentTemplates: {
        "payingFrom": "Uplata sa:",
        "payingTo": "Uplata na:",
        "howMuch": "Iznos",
        "description": "Opis",
        "when": "Datum",
        "fullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "showFullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "pay": "Plati",
        "delete": "Obriši",
        "save": "Snimi",
        "signPayment": "Potpiši",
        "cancel": "Odustani",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "dueDate": "Datum dospjeća",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primatelja",
        "receiver": "Primalac",
        "receiverAddress": "Adresa primatelja",
        "amount": "Iznos",
        "signMsg": "Provjerite unesene podatke i potpišite",
        "saveTemplate": "Novi šablon",
        "invalidDate": "Datum je nevalidan!",
        "descriptionError": "Opis je obavezan!",
        "templateName": "Naziv šablona",
        "templateIcon": "Slika šablona",
        "deleteSuccess1": "Šablon",
        "deleteSuccess2": "je uspješno izbrisan."
      },
      templatesList: {
        "header":"Lista mojih šablona",
        "searchTemplates": "Pretraži šablone",
        "addNewTemplate": "+ Dodaj novi predložak",
        "listOfTemplates":"Lista šablona",
        "fromAccount":"S računa",
        "amount":"Iznos",
        "toPayee":"Primalac",
        "accountNumber":"Broj računa",
        "payeeStreet":"Adresa primatelja",
        "payeeCity":"Grad primatelja",
        "purposeCode":"Šifra namjene",
        "referenceModel":"Model",
        "referenceNumber":"Referentni broj",
        "addTemplateToFavorites":"Dodaj šablon u favorite",
        "edit":"Izmijeni",
        "save": "Snimi",
        "cancel": "Odustani"
      }
    };

    $translateProvider
      .translations('mne', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      paymentTemplates: {
        "payingFrom": "Uplata sa:",
        "payingTo": "Uplata na:",
        "howMuch": "Iznos",
        "description": "Opis",
        "when": "Datum",
        "fullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "showFullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "pay": "Plati",
        "delete": "Izbriši",
        "save": "Snimi",
        "signPayment": "Potpiši",
        "cancel": "Odustani",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "dueDate": "Datum dospjeća",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primatelja",
        "receiver": "Primatelj",
        "receiverAddress": "Adresa primatelja",
        "amount": "Iznos",
        "signMsg": "Provjerite unesene podatke i potpišite",
        "saveTemplate": "Novi predložak",
        "invalidDate": "Datum je nevalidan!",
        "descriptionError": "Opis je obavezan!",
        "templateName": "Naziv predloška",
        "templateIcon": "Slika predloška",
        "deleteSuccess1": "Predložok",
        "deleteSuccess2": "je uspješno izbrisan."
      },
      templatesList: {
        "header":"Pregled mojih predložaka",
        "searchTemplates": "Pretraži predloške",
        "addNewTemplate": "+ Dodaj novi predložak",
        "listOfTemplates":"Lista predložaka",
        "fromAccount":"S računa",
        "amount":"Iznos",
        "toPayee":"Primatelj",
        "accountNumber":"Broj računa",
        "payeeStreet":"Adresa primatelja",
        "payeeCity":"Grad primatelja",
        "purposeCode":"Šifra namjene",
        "referenceModel":"Model",
        "referenceNumber":"Poziv na broj",
        "addTemplateToFavorites":"Dodaj predložak u favorite",
        "edit":"Izmijeni",
        "save":"Snimi",
        "cancel": "Odustani"
      }
    };

    $translateProvider
      .translations('hr', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      paymentTemplates: {
        "payingFrom": "Paying from:",
        "payingTo": "Paying to:",
        "howMuch": "How much",
        "description": "Description",
        "when": "When",
        "fullPaymentForm": "Show full payment form",
        "showFullPaymentForm": "Show full payment form",
        "pay": "Pay",
        "delete": "Delete",
        "save": "Save",
        "signPayment": "Sign",
        "cancel": "Cancel",
        "status": "Status",
        "bankName": "Bank name",
        "bankAddress": "Bank address",
        "address": "Recipient's address",
        "dueDate": "Due date",
        "fromAccount": "From account",
        "toAccount": "To account",
        "receiver": "Recipient",
        "receiverAddress": "Recipient's address",
        "amount": "Amount",
        "signMsg": "Verify the information and sign",
        "saveTemplate": "New template",
        "invalidDate": "Date is invalid!",
        "descriptionError": "Description is required!",
        "templateName": "Template name",
        "templateIcon": "Template icon",
        "deleteSuccess1": "Template",
        "deleteSuccess2": "was successfully deleted."
      },
      templatesList: {
        "header":"List of my templates",
        "searchTemplates": "Search templates",
        "addNewTemplate": "+ Add new payment template",
        "listOfTemplates":"List of templates",
        "fromAccount":"From account",
        "amount":"Amount",
        "toPayee":"To recipient",
        "accountNumber":"Account number",
        "payeeStreet":"Recipient's street",
        "payeeCity":"Recipient's city",
        "purposeCode":"Purpose code",
        "referenceModel":"Reference model",
        "referenceNumber":"Reference number",
        "addTemplateToFavorites":"Add this template to favorites",
        "edit":"Edit",
        "save": "Save",
        "cancel": "Cancel",
        "bicBankPrejemnika": "Recipient's bank BIC",
        "pay":"Pay",
        "maxLengthReached":"Max length is reached!"
      }
    };

    $translateProvider
      .translations('en', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      paymentTemplates: {
        "payingFrom": "Uplata sa:",
        "payingTo": "Uplata na:",
        "howMuch": "Iznos",
        "description": "Opis",
        "when": "Datum",
        "fullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "showFullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "pay": "Plati",
        "delete": "Obriši",
        "save": "Snimi",
        "signPayment": "Potpiši",
        "cancel": "Odustani",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "dueDate": "Datum dospjeća",
        "fromAccount": "Račun pošiljatelja/pošiljaoca",
        "toAccount": "Račun primatelja/primaoca",
        "receiver": "Primatelj/primalac",
        "receiverAddress": "Adresa primatelja/primaoca",
        "amount": "Iznos",
        "signMsg": "Provjerite unesene podatke i potpišite",
        "saveTemplate": "Novi uzorak",
        "invalidDate": "Datum nije validan!",
        "descriptionError": "Opis je obavezan!",
        "templateName": "Naziv uzorka",
        "templateIcon": "Slika uzorka",
        "deleteSuccess1": "Uzorak",
        "deleteSuccess2": "je uspješno obrisan."
      },
      templatesList: {
        "header":"Lista uzoraka",
        "searchTemplates": "Pretraži uzorke",
        "addNewTemplate": "+ Dodaj novi uzorak",
        "listOfTemplates":"Uzorci",
        "fromAccount":"Sa računa",
        "amount":"Iznos",
        "toPayee":"Primatelj/Primalac",
        "accountNumber":"Broj računa",
        "payeeStreet":"Adresa primatelja/primaoca",
        "payeeCity":"Grad primatelja/primaoca",
        "purposeCode":"Šifra plaćanja",
        "referenceModel":"Model",
        "referenceNumber":"Model i poziv na broj",
        "addTemplateToFavorites":"Dodaj uzorak u favorite",
        "edit":"Izmijeni",
        "save": "Snimi",
        "cancel": "Odustani"
      }
    };

    $translateProvider
      .translations('bh', data);
  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            orders: {
                "accounts": "Računi",
                "cards": "Kartice",
                "savingsDeposits": "Štednja i depoziti",
                "security": "Sigurnost",
                "loans": "Krediti",
                "payments": "Uplate",
                accountOverdraft: "Promjena dopuštenog prekoračenja računa",
                largeAmount: "Podizanje velikog iznosa gotovine",
                atmWithdrawal: "Promjena limita podizanja na bankomatu",
                "orderMastercard": "Narudžba MasterCard kartičnog plaćanja",
                "changeMastercard": "Promjenite limit MasterCard",
                "makeTermDeposit": "Napravite oročenje",
                "cancelAutomatic": "Odustanite od automatskom produženja oročenja",
                "openSavings": "Otvorite štedni račun",
                "orderSoftToken": "Naručite soft token",
                "getExpressLoan": "Dobavite informacije o mogućnosti kreditiranja",
                "authorizationOrders": "Odobrenje trajnog naloga",
                "cancelAuthorizationOrders": "Odustanite od odobrenja trajnog naloga",
                "goBackToOrders": "Povratak na narudžbe",
                "subscribeEInvoice": "Pretplatite se na novi eRačun ili otkažite postojeću pretplatu",
                "title": "Trajni nalog",
                "dateBegin": "Datum početka",
                "dateCancel": "Datum prestanka",
                "note":"Napomena",
                "note1":"Trajni nalog možete zadati najmanje 8 dana prije dospijeća za izvršenje.",
                "note2":"Ako na dan izvršenja naloga na računu nema raspoloživih sredstava, nalog se neće izvršiti, te Banka za isto ne snosi odgovornosti.",
                "note3":"Naknade pri izvršenju se naplaćuju prema Odluci Banke o naknadama za usluge u poslovanju s građanstvom, na teret nalogodavatelja.",
                "beneficiaryName": "Naziv primaoca",
                "beneficiaryNameRequired": "Naziv primaoca je obavezan!",
                "beneficiaryIBAN": "IBAN primaoca",
                "description": "Opis",
                "standingOrders": "Vremenski prikaz zahtjeva",
                "cancel":"Odustani",
                "descriptionRequired":"Opis je obavezan!",
                "titleConfirmation": "Potvrda trajnog naloga",
                "edit":"Uredi",
                "completeText": "Zahtjev za otvaranje trajnog naloga je uspješno poslan u Banku.",
                "makeNew":"Novi trajni nalog",
                "Opened":"Nepotpisan",
                "Signed":"Potpisan"
            },
            termDeposit: {
                "termDepositHeader": "Oročenje",
                "nameInputLabel": "Ime i prezime:",
                "addressInputLabel": "Adresa:",
                "cityInputLabel": "Grad:",
                "debitAccountSelectLabel": "Račun terećenja:",
                "typeSelectLabel": "Vrsta oročenja:",
                "interestRateOverviewLabel": "Prikaz kamatnih stopa",
                "amountInputLabel": "Iznos:",
                "baseInterestRateInputLabel": "Bazna kamatna stopa:",
                "marginInputLabel": "Marža:",
                "stimulativeInterestRateInputLabel": "Stimulativna kamatna stopa:",
                "totalInterestRateInputLabel": "Ukupna kamatna stopa:",
                "maturityInMonthsSelectLabel": "Rok u mjesecima:",
                "expiryDateInputLabel": "Datum isteka:",
                "interestRatePayoutTypeSelectLabel": "Način isplate kamate:",
                "informativeCalculationLinkLabel": "Izračun efektivne kamatne stope",
                "automaticProlongationRadioOptionLabel": "Automatsko produženje:",
                "automaticProlongationYesOptionLabel": "Da",
                "automaticProlongationNoOptionLabel": "Ne",
                "accountForMaturityInputLabel": "Račun za dospijeće kamate i glavnice:",
                "contractDateInputLabel": "Datum ugovora:",
                "contractDraftLinkLabel": "Nacrt ugovora oročenog štednog uloga - depozita",
                "generalConditionsLinkLabel1": "Prihvaćam opće uvjete poslovanja za oročene štedne uloge - depozite",
                "generalConditionsLinkLabel2": "Prihvaćam opće uvjete poslovanja za zaštićene depozite",
                "confirmBtnLabel": "Potvrdi",
                "cancelBtnLabel": "Odustani",
                "editActionLabel": "Popravi",
                "cancelActionLabel": "Odustani",
                "signActionLabel": "Potpiši",
                "successMsg": "Uspješno!",
                "errorMsg": "Greška!",
                "minAmountLabel": "Minimalan iznos je",
                "month":"mjeseci",
                "oneMonth":"mjesec",
                "signTitle": "Potpis oročenja",
                "request": "zahtjev",
                "newDepositOrder": "Novo oročenje",
                "earlyTermination": "Prijevremeni prekid oročenja"
            },
            cancelDeposit: {
                "cancelDepositHeader": "Oročenje",
                "cancelDepositSubheader": "Zahtjev za prijevremeni raskid oročenog štednog uloga - depozita",
                "capitalAmountLabel": "Iznos glavnice:",
                "approvedInteresLabel": "Priznata kamata:",
                "approvedInteresAmountLabel": "Priznata kamata u iznosu:",
                "chargesLabel": "Naknada za prijevremeni raskid ugovora:",
                "totalAmountLabel": "Ukupan iznos za prijenos:",
                "accountForFundLabel": "Račun za isplatu sredstava:",
                "confirmBtn": "Potvrdi",
                "cancelBtn": "Odustani",
                "successInfoLabel1": "Zahtjev za prijevremeni raskid oročenog štednog uloga - depozita",
                "successInfoLabel2": "je uspješno potpisan i poslan u Banku.",
                "requestBtn": "Pregled zahtjeva",
            },
            orderDetails:{
                "name":"Naziv primaoca",
                "payeeAccount":"IBAN primaoca",
                "amount":"Iznos",
                "orderId":"ID naloga",
                "orderTypeId":"ID tipa naloga",
                "orderTypeDesc":"Opis naloga",
                "dateCreated":"Datum kreiranja",
                "close":"Odustani",
              "purpose":"Svrha"
            },
            addNewExpressLoan: {
              "header": "Information on the possibility to obtain Express loan",
              "cardType": "Duration (in months):",
              "account": "Account:",
              "amount": "Amount:",
              "paymentDay": "Settlement day:",
              "cancel": "Cancel",
              "confirm": "Confirm"
          }
        };

        $translateProvider
            .translations('sr', data);
    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            orders: {
                "accounts": "Računi",
                "cards": "Kartice",
                "savingsDeposits": "Varčevanja in depoziti",
                "security": "Varnost",
                "loans": "Krediti",
                "payments": "Plačila",
                accountOverdraft: "Sprememba dovoljenega limita",
                largeAmount: "Dvig višjega zneska gotovine",
                atmWithdrawal: "Sprememba dnevnega limita na bankomatu in POS terminalu",
                "orderMastercard": "Naročilo plačilne kartice MasterCard",
                "changeMastercard": "Sprememba limita na kartici MasterCard",
                "makeTermDeposit": "Skleni depozit",
                "cancelAutomatic": "Preklic avtomatskega podaljševanja",
                "openSavings": "Odpri varčevalni račun",
                "orderSoftToken": "Naročilo programskega generatorja gesel",
                "getExpressLoan": "Informacija o možnosti pridobitve EXPRESS kredita",
                "authorizationOrders": "Pooblastilo za trajni nalog",
                "cancelAuthorizationOrders": "Ukinitev pooblastila za trajni nalog",
                "goBackToOrders": "Nazaj na naložbe",
                "subscribeEInvoice": "Naročilo na prejemenje eRačunov ali odjava od prejemanja",
                "title": "Trajni nalog",
                "dateBegin": "Datum začetka",
                "dateCancel": "Datum poteka",
                "note": "Opomba",
                "note1": "",
                "note2": "",
                "note3": "",
                "dateRequired": "Vnos datuma je obvezen!",
                "note1Slo": "Trajni nalog za prenos sredstev na poljubni transakcijski račun ali imetniški varčevalni račun uporabnika Addiko EBanke oziroma varčevalni račun, na katerem je imetnik pooblaščen, morate naročiti najmanj 15 dni pred želenim datumom bremenitve. Addiko Bank d.d. vam bo provizijo za izvajanje plačil preko trajnih nalogov zaračunala po vsakokrat veljavnem ",
                "note2SloLink": "Ceniku storitev Addiko Bank d.d.",
                "beneficiaryName": "Naziv prejemnika",
                "beneficiaryNameRequired": "Vnos prejemnika je obvezen!",
                "beneficiaryIBAN": "Račun prejemnika",
                "beneficiaryIBANforSavings":"Varčevalni račun uporabnika Addiko EBanke",
                "description": "Namen",
                "standingOrders": "Trajni nalogi",
                "cancel": "Prekliči",
                "descriptionRequired": "Vnos namena je obvezen!",
                "titleConfirmation": "Potrditev trajnega naloga",
                "edit": "Uredi",
                "completeText": "Naročilo je bilo uspešno oddano.",
                "completeCancelText": "Naročilo je bilo uspešno oddano",
                "makeNew": "Naroči nov trajni nalog",
                "Opened": "Oddan",
                "Signed": "Podpisan",
                "paymentDayOfEachMonth": "Plačilo vsak mesec na dan",
                "nonWorkingDayMsg": "oziroma naslednji delovni dan, če je na ta dan sobota, nedelja, praznik ali drug dela prost dan.",
                "address": "Naslov prejemnika",
                "receviersAddressRequired": "Naslov prejemnika je obvezen!",
                "purpose": "Namen",
                "next": "Naprej",
                "back": "Nazaj",
                "maturityDateChangedConfirm": "Prosimo vas, da z izbiro potrditvenega polja potrdite spremembo datuma.",
                "maturityDateChangedErr": "Datum zapadlosti pade na nedelovni dan, zato je bil spremenjen. Prosimo, potrdite spremembo.",
                "maturityDateNonWorkingErr": "Datum zapadlosti pade na nedelovni dan.",
                "successOrder": "Naročilo je bilo uspešno oddano.",
                "agreeTerms":"Strinjam se, da v primeru, če na dogovorjeni dan ne bom zagotovil/a zadostnega kritja na računu, banka ni obvezana izvršiti nakazila po tem pooblastilu.",
                "cancelAuthorisation": "Ukinitev pooblastila za trajni nalog",
                "permanentAthorisation": "Pooblastilo za trajni nalog",
                "Submitted": "Oddan",
                "Closed": "Zaprt",
                "InProcess": "V obdelavi",
                "Canceled": "Preklican",
                "Executed": "Izvršen",
                "Rejected": "Zavrnjen",
                "InError": "Z napako",
                "PartialySigned": "Delno podpisan",
                "ForProcessing": "Pripravljen za obdelavo",
                "FailureAfterComplaint": "Zavrnjen po pritožbi",
                "SuccessAfterComplaint": "Izvršen po pritožbi",
                types: {
                  "trr":"Transakcijski račun prejemnika",
                  "hypo":"Varčevalni račun uporabnika Addiko EBanke"
                }
            },
            termDeposit: {
                "termDepositHeader": "Vezava depozita",
                "nameInputLabel": "Ime in priimek",
                "addressInputLabel": "Naslov",
                "cityInputLabel": "Kraj",
                "debitAccountSelectLabel": "Z računa",
                "typeSelectLabel": "Vrsta depozita",
                "interestRateOverviewLabel": "Prikaz obrestnih mer",
                "realRate": "Realna obrestna mera",
                "referenceRate": "Referenčna obrestna mera",
                "amountInputLabel": "Znesek",
                "baseInterestRateInputLabel": "Osnovna stopnja obrestne mere",
                "marginInputLabel": "Pribitek",
                "stimulativeInterestRateInputLabel": "Stimulativna stopnja obrestne mere ",
                "totalInterestRateInputLabel": "Skupna obrestna mera",
                "maturityInMonthsSelectLabel": "Rok v mesecih",
                "expiryDateInputLabel": "Datum poteka",
                "interestRatePayoutTypeSelectLabel": "Način izplačila obresti",
                "informativeCalculationLinkLabel": "Izračun efektivne obrestne mere",
                "automaticProlongationRadioOptionLabel": "Automatsko podalševanje",
                "automaticProlongationYesOptionLabel": "Da",
                "automaticProlongationNoOptionLabel": "Ne",
                "accountForMaturityInputLabel": "Račun za dospele obresti in glavnico:",
                "contractDateInputLabel": "Datum pogodbe",
                "contractDraftLinkLabel": "Depozitna pogodba",
                "generalConditionsLinkLabel1": "Potrjujem, da sem seznanjen/a s Splošnimi pogoji depozitov in z njimi soglašam.",
                "generalConditionsLinkLabel2": " ",
                "confirmBtnLabel": "Potrdi",
                "cancelBtnLabel": "Prekliči",
                "editActionLabel": "Spremeni",
                "cancelActionLabel": "Prekliči",
                "signActionLabel": "Podpiši",
                "successMsg": "Uspešno!",
                "errorMsg": "Napaka!",
                "minAmountLabel": "Minimalni znesek je",
                "month": "mesecev",
                "oneMonth": "mesec",
                "signTitle": "Podpis",
                "request": "zahteva",
                "newDepositOrder": "Skleni nov depozit",
                "assignmentOfInterestAnnual": "Letno poročanje",
                "assignmentOfInterestAfter": "Poročanje po poteku",
                "interestPayoutMonthly": "Mesečno",
                "interestPayoutAfterMaturity": "Po poteku",
                "earlyTermination": "Predčasna ukinitev depozita",
                "depositType": "Tip depozita",
                "assignmentOfInterest": "Razmejitev obresti",
                "letnaAssignmentOfInterest": "Letna razmejitev obresti",
                "interestPayout": "Izplačilo obresti",
                "termDepositDuration": "Doba vezave ",
                "durationInDays": "dni",
                "durationOr": "ali",
                "durationInMonths": " mesecev",
                "maturityDate": "Datum zapadlosti",
                "executionDate": "Datum  obdelave",
                "minDepDurationErr": "Najmanjša doba vezave je ",
                "maxDepDurationErr": "Doba vezave je lahko največ ",
                "minRastociDepositDuration": "Najmanjša doba vezave je 31 dni.",
                "maxRastociDepositDuration": "Doba vezave je lahko največ 35 dni.",
                "durationRastociDepozitMsg": "Doba mora biti med 31 in 35 dni.",
                "durationZlataJesenMsg": "Doba mora biti med 488 in 1097 dni.",
                "days": "dni.",
                "termsAndConditions": "Potrjujem, da sem seznanjen/a s  ",
                "termsAndConditions1": "Splošnimi pogoji depozitov",
                "termsAndConditions2": "in z njimi soglašam. Seznanjen/a sem tudi s tipom in trenutnimi pogoji obrestnih mer za izbrani produkt.",
                "taxationOfInterestTitle": "Obdavčitev obresti",
                "taxationOfInterestMsg": "Skladno z določbami Zakona o dohodnini in Zakona o davčnem postopku se v davčno osnovo za obračun dohodnine vštevajo obresti, ki letno presegajo skupni znesek 1.000 EUR. Pri dolgoročnih depozitih banka priporoča, da se odločite za letno poročanje obresti, saj se s tem zmanjša možnost, da ob izteku varčevanja znesek obresti preseže 1.000 EUR. Pri sklenitvi pogodbe o dolgoročnem depozitu se izdela tudi Obvestilo o uveljavljanju davčne osnove po 84. členu ZDoh-2.",
                "headerLink1": "Osnovne informacije o depozitih",
                "headerLink2": "Veljavne obrestne mere",
                "headerLink3": "Jamstva za vloge",
                "wrongDepositCurrency": "Depozita izbranega tipa ni mogoče vezati v tej valuti.",
                "wrongDepositDuration": "Vneseno obdobje ni mogoče pri izbranem depozitu.",
                "wrongDepositAmount": "Vneseni znesek ni dovoljen pri izbranem depozitu.",
                "wrongMinDepositAmount": "Minimalni znesek je ",
                "wrongMaxDepositAmount": "Najvišji znesek je ",
                "makeTermDepositTimelineTitle": "On-line sklenitev",
                "vrstaDepozita": "Vrsta depozita",
              "termDepositStatus": {
                "entered": "Oddan",
                "realised": "Izveden",
                "unrealised": "Neizveden",
                "cancelled": "Preklican",
                "receivednotexecuted":"V izvedbi"
              }
            },
            cancelDeposit: {
                "cancelDepositHeader": "Depozit",
                "cancelDepositSubheader": "Prekinitev avtomatskega podaljševanja sklenjenih depozitov",
                "capitalAmountLabel": "Znesek glavnice:",
                "approvedInteresLabel": "Priznane obresti:",
                "approvedInteresAmountLabel": "Priznane obresti v znesku:",
                "chargesLabel": "Strošek predčasne prejkinitve depozita:",
                "totalAmountLabel": "Skupni znesek za prenos:",
                "accountForFundLabel": "Račun za izplačilo:",
                "confirmBtn": "Potrdi",
                "cancelBtn": "Prekliči",
                "successInfoLabel1": "Naročilo za predčasno prekinitev depozita",
                "successInfoLabel2": "je bilo uspešno oddano",
                "requestBtn": "Pregled oddanih naročil",
            },
            depositDetails: {
                "contractDate": "Datum sklenitve pogodbe",
                "depositType": "Tip depozita",
                "account": "Račun za izplačilo",
                "note": "Opomba",
                "contract": "Pogodba",
                "payoutType": "Način izplačila",
                "domesticType": "Depozit v evrih",
                "foreignType": "Depozit v tuji valuti",
                "termsAndConditions": "Splošni pogoji"

            },
            orderDetails: {
                "name": "Naziv prejemnika",
                "payeeAccount": "IBAN prejemnika",
                "payeeAddress": "Kraj prejemnika",
                "amount": "Znesek",
                "orderId": "ID naročila",
                "orderTypeId": "ID vrsta naročila",
                "orderTypeDesc": "Opis naročila",
                "dateCreated": "Datum vnosa",
                "firstPaymentDate": "Datum prvega plačila",
                "lastPaymentDate": "Datum zadnjega plačila",
                "close": "Zapri",
                "closeMsg": "Nalog uspešno oddan",
                "purpose": "Namen"
            },
            savingsOrder: {
                "title": "Sklenitev varčevanja",
                "headerLink1": "Osnovne informacije o Varčevalnem računu 5 dni",
                "headerLink2": "Osnovne informacije o Addiko Plus varčevanjih",
                "headerLink3": "Veljavne obrestne mere",
                "headerLink4": "Jamstva za vloge",
                "firstPayment": "Prvo plačilo ",
                "lastPayment": "Zadnje plačilo",
                "orderPaymentDay": "Dan plačila trajnega naloga",
                "savingsType": "Vrsta varčevanja",
                "duration": "Doba varčevanja",
                "minSavingDuration": "Najmanjša doba varčevanja je ",
                "maxSavingDuration": "Najdaljša doba varčevanja je ",
                "fromAccount": "Z računa",
                "amount": "Mesečni polog",
                "orderpaymentDay": "Dan plačila trajnega naloga",
                "termsAndConditions": "Potrjujem, da sem seznanjen/a s",
                "termsAndConditions1": " Splošni pogoji varčevanj",
                "termsAndConditions2": " in z njimi soglašam. Seznanjen/a sem tudi s tipom in trenutnimi pogoji obrestnih mer za izbrani produkt.",
                "termsAndConditions3AddikoPlus": " Prav tako se strinjam, da v primeru, da na dogovorjeni dan ne bom zagotovil/a zadostnega kritja na računu, banka ni obvezana izvršiti nakazila po tem pooblastilu za trajni nalog.",
              "newSavingsOrder": "Sklenitev varčevanja",
                "initialDepositAmount": "Prvi polog",
                "monthlyDepositAmount": "Mesečni polog",
              "taxationOfInterestMsg": "Skladno z določbami Zakona o dohodnini in Zakona o davčnem postopku se v davčno osnovo za obračun dohodnine vštevajo obresti, ki letno presegajo skupni znesek 1.000 EUR. Pri dolgoročnih verčevanjih banka priporoča, da se odločite za letno poročanje obresti, saj se s tem zmanjša možnost, da ob izteku varčevanja znesek obresti preseže 1.000 EUR. Pri sklenitvi pogodbe o dolgoročnem varčevanju se izdela tudi Obvestilo o uveljavljanju davčne osnove po 84. členu ZDoh-2.",
                "newSavingsOrderTimelineTitle": "Sklenitev varčevanja",
              "dateOfEntry": "Datum vnosa",
              "executionDate": "Datum zapadlosti",
              "userNumber": "Številka uporabnika",
              "savingsCurrency": "Valuta varčevanja",
              "fromSAccount": "Številka računa",
              "nameAndSurname": "Ime in priimek",
              "initialAmount": "Prvi polog",
              "disbursementAccount": "Račun sprostitve sredstev",
              "receiveMonthlyStatementsVia": "Pošiljanje izpiskov",
              "vpoType": "VPO tip",
              "typeOfSaving": "Oznaka varčevanja",
              "realInterestRate": "Realna obrestna mera",
              "referenceInterestRate": "Referenčna obrestna mera",
              "currency": "Valuta",
              "dateOfOpening": "Datum sklenitve varčevanja",
              "openStandingOrder": "Otvoritev trajnega naloga",
              "orderComment": "Opomba naročila",
              "savingOrderName": "Namen varčevenja"
            },
            addNewExpressLoan: {
                "header": "Informacija o možnosti pridobitve EXPRESS kredita",
                "header_SLO": "Informacija o možnosti pridobitve EXPRESS kredita",
                "note1": "EXPRESS kredit je gotovinski kredit brez dodatne dokumentacije. Banka bo v naslednjih dveh delovnih dneh obravnavala vaše naročilo. Kredit bo v primeru odobritve nakazan na vaš račun po obisku pri osebnem bančniku v vaši poslovalnici, kjer boste podpisali kreditno pogodbo.",
                "note2": "Pogoji za najem EXPRESS kredita so na voljo v vsakokrat veljavnem",
                "noteLink1": "Ceniku storitev Addiko bank d.d.",
                "noteAnd": "ter v",
                "noteLink2": "Obrestnih merah Addiko bank d.d.",
                "cardType": "Doba odplačila (v mesecih)",
                "account": "Račun",
                "amount": "Znesek",
                "paymentDay": "Želeni dan odplačevanja",
                "cancel": "Prekliči",
                "confirm": "Potrdi",
                "approvalDate": "Želeni datum odobritve",
                "paymentAccount": "Račun za plačilo",
                "addNewExpressLoan": "Nov kredit"
            }
        };

        $translateProvider
            .translations('sl', data);
    }
} ());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            orders: {
                "accounts": "Računi",
                "cards": "Kartice",
                "savingsDeposits": "Štednja i depoziti",
                "security": "Sigurnost",
                "loans": "Krediti",
                "payments": "Uplate",
                accountOverdraft: "Promjena dopuštenog prekoračenja računa",
                largeAmount: "Podizanje velikog iznosa gotovine",
                atmWithdrawal: "Promjena limita podizanja na bankomatu",
                "orderMastercard": "Narudžba MasterCard kartičnog plaćanja",
                "changeMastercard": "Promjenite limit MasterCard",
                "makeTermDeposit": "Napravite oročenje",
                "cancelAutomatic": "Odustanite od automatskom produženja oročenja",
                "openSavings": "Otvorite štedni račun",
                "orderSoftToken": "Naručite soft token",
                "getExpressLoan": "Dobavite informacije o mogućnosti kreditiranja",
                "authorizationOrders": "Odobrenje trajnog naloga",
                "cancelAuthorizationOrders": "Odustanite od odobrenja trajnog naloga",
                "goBackToOrders": "Povratak na narudžbe",
                "subscribeEInvoice": "Pretplatite se na novi eRačun ili otkažite postojeću pretplatu",
                "title": "Trajni nalog",
                "dateBegin": "Datum početka",
                "dateCancel": "Datum prestanka",
                "note":"Napomena",
                "note1":"Trajni nalog možete zadati najmanje 8 dana prije dospijeća za izvršenje.",
                "note2":"Ako na dan izvršenja naloga na računu nema raspoloživih sredstava, nalog se neće izvršiti, te Banka za isto ne snosi odgovornosti.",
                "note3":"Naknade pri izvršenju se naplaćuju prema Odluci Banke o naknadama za usluge u poslovanju s građanstvom, na teret nalogodavatelja.",
                "beneficiaryName": "Naziv primatelja",
                "beneficiaryNameRequired": "Naziv primatelja je obavezan!",
                "beneficiaryIBAN": "IBAN primatelja",
                "description": "Opis",
                "timeline":"Vremenski prikaz zahtjeva",
                "standingOrders": "Vremenski prikaz zahtjeva",
                "cancel":"Odustani",
                "descriptionRequired":"Opis je obavezan!",
                "titleConfirmation": "Potvrda trajnog naloga",
                "edit":"Uredi",
                "completeText": "Zahtjev za otvaranje trajnog naloga je uspješno poslan u Banku.",
                "makeNew":"Novi trajni nalog",
                "Opened":"Otvoren",
                "Signed":"Potpisan"
            },
            termDeposit: {
                "termDepositHeader": "Oročenje",
                "nameInputLabel": "Ime i prezime:",
                "addressInputLabel": "Adresa:",
                "cityInputLabel": "Grad:",
                "debitAccountSelectLabel": "Račun terećenja:",
                "typeSelectLabel": "Vrsta oročenja:",
                "interestRateOverviewLabel": "Prikaz kamatnih stopa",
                "amountInputLabel": "Iznos:",
                "baseInterestRateInputLabel": "Bazna kamatna stopa:",
                "marginInputLabel": "Marža:",
                "stimulativeInterestRateInputLabel": "Stimulativna kamatna stopa:",
                "totalInterestRateInputLabel": "Ukupna kamatna stopa:",
                "maturityInMonthsSelectLabel": "Rok u mjesecima:",
                "expiryDateInputLabel": "Datum isteka:",
                "interestRatePayoutTypeSelectLabel": "Način isplate kamate:",
                "informativeCalculationLinkLabel": "Izračun efektivne kamatne stope",
                "automaticProlongationRadioOptionLabel": "Automatsko produženje:",
                "automaticProlongationYesOptionLabel": "Da",
                "automaticProlongationNoOptionLabel": "Ne",
                "accountForMaturityInputLabel": "Račun za dospijeće kamate i glavnice:",
                "contractDateInputLabel": "Datum ugovora:",
                "contractDraftLinkLabel": "Nacrt ugovora oročenog štednog uloga - depozita",
                "generalConditionsLinkLabel1": "Prihvaćam opće uvjete poslovanja za oročene štedne uloge - depozite",
                "generalConditionsLinkLabel2": "Prihvaćam opće uvjete poslovanja za zaštićene depozite",
                "confirmBtnLabel": "Potvrdi",
                "cancelBtnLabel": "Odustani",
                "editActionLabel": "Popravi",
                "cancelActionLabel": "Odustani",
                "signActionLabel": "Potpiši",
                "successMsg": "Uspješno!",
                "errorMsg": "Greška!",
                "minAmountLabel": "Minimalan iznos je",
                "month":"mjeseci",
                "oneMonth":"mjesec",
                "signTitle": "Potpis oročenja",
                "request": "zahtjev",
                "newDepositOrder": "Novo oročenje",
                "earlyTermination": "Prijevremeni prekid oročenja"
            },
            cancelDeposit: {
                "cancelDepositHeader": "Oročenje",
                "cancelDepositSubheader": "Zahtjev za prijevremeni raskid oročenog štednog uloga - depozita",
                "capitalAmountLabel": "Iznos glavnice:",
                "approvedInteresLabel": "Priznata kamata:",
                "approvedInteresAmountLabel": "Priznata kamata u iznosu:",
                "chargesLabel": "Naknada za prijevremeni raskid ugovora:",
                "totalAmountLabel": "Ukupan iznos za prijenos:",
                "accountForFundLabel": "Račun za isplatu sredstava:",
                "confirmBtn": "Potvrdi",
                "cancelBtn": "Odustani",
                "successInfoLabel1": "Zahtjev za prijevremeni raskid oročenog štednog uloga - depozita",
                "successInfoLabel2": "je uspješno potpisan i poslan u Banku.",
                "requestBtn": "Pregled zahtjeva",
            },
            orderDetails:{
                "name":"Naziv primatelja",
                "payeeAccount":"IBAN primatelja",
                "amount":"Iznos",
                "orderId":"ID naloga",
                "orderTypeId":"ID tipa naloga",
                "orderTypeDesc":"Opis naloga",
                "dateCreated":"Datum kreiranja",
                "close":"Odustani",
              "purpose":"Svrha"
            },
            addNewExpressLoan: {
                "header": "Information on the possibility to obtain express loan",
                "cardType": "Duration (in months):",
                "account": "Account:",
                 "amount": "Account for loan disbursement:",
                 "paymentDay": "Settlement day:",
                 "cancel": "Cancel",
                 "confirm": "Confirm"
          }
        };

        $translateProvider
            .translations('mne', data);
    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            orders: {
                "accounts": "Računi",
                "cards": "Kartice",
                "savingsDeposits": "Štednja i depoziti",
                "security": "Sigurnost",
                "loans": "Krediti",
                "payments": "Uplate",
                accountOverdraft: "Promjena dopuštenog prekoračenja računa",
                largeAmount: "Podizanje gotovine",
                atmWithdrawal: "Promjena limita podizanja na bankomatu",
                "orderMastercard": "Narudžba MasterCard kartičnog plaćanja",
                "changeMastercard": "Promjenite limit MasterCard",
                "makeTermDeposit": "Napravite oročenje",
                "cancelAutomatic": "Odustanite od automatskom produženja oročenja",
                "openSavings": "Otvorite štedni račun",
                "orderSoftToken": "Naručite soft token",
                "getExpressLoan": "Dobavite informacije o mogućnosti kreditiranja",
                "authorizationOrders": "Odobrenje trajnog naloga",
                "cancelAuthorizationOrders": "Odustanite od odobrenja trajnog naloga",
                "goBackToOrders": "Povratak na narudžbe",
                "subscribeEInvoice": "Pretplatite se na novi eRačun ili otkažite postojeću pretplatu",
                "title": "Trajni nalog",
                "dateBegin": "Datum početka",
                "dateCancel": "Datum isteka",
                "note":"Napomena",
                "note1":"Trajni nalog možete zadati najmanje 8 dana prije dospijeća za izvršenje.",
                "note2":"Ako na dan izvršenja naloga na računu nema raspoloživih sredstava, nalog se neće izvršiti, te Banka za isto ne snosi odgovornosti.",
                "note3":"Naknade pri izvršenju se naplaćuju prema Odluci Banke o naknadama za usluge u poslovanju s građanstvom, na teret nalogodavatelja.",
                "beneficiaryName": "Naziv primatelja",
                "beneficiaryNameRequired": "Naziv primatelja je obavezan!",
                "beneficiaryIBAN": "IBAN primatelja",
                "description": "Opis",
                "standingOrders": "Povijest zahtjeva",
                "cancel":"Odustani",
                "descriptionRequired":"Opis je obavezan!",
                "titleConfirmation": "Potvrda trajnog naloga",
                "edit":"Uredi",
                "completeText": "Zahtjev za otvaranje trajnog naloga je uspješno poslan u Banku.",
                "makeNew":"Novi trajni nalog",
                "Opened":"Otvoren",
                "Signed":"Potpisan"

            },
            termDeposit: {
                "termDepositHeader": "Oročenje",
                "nameInputLabel": "Ime i prezime:",
                "addressInputLabel": "Adresa:",
                "cityInputLabel": "Grad:",
                "debitAccountSelectLabel": "Račun terećenja:",
                "typeSelectLabel": "Vrsta oročenja:",
                "interestRateOverviewLabel": "Prikaz kamatnih stopa",
                "amountInputLabel": "Iznos:",
                "baseInterestRateInputLabel": "Bazna kamatna stopa:",
                "marginInputLabel": "Marža:",
                "stimulativeInterestRateInputLabel": "Stimulativna kamatna stopa:",
                "totalInterestRateInputLabel": "Ukupna kamatna stopa:",
                "maturityInMonthsSelectLabel": "Rok u mjesecima:",
                "expiryDateInputLabel": "Datum isteka:",
                "interestRatePayoutTypeSelectLabel": "Način isplate kamate:",
                "informativeCalculationLinkLabel": "Izračun efektivne kamatne stope",
                "automaticProlongationRadioOptionLabel": "Automatsko produženje:",
                "automaticProlongationYesOptionLabel": "Da",
                "automaticProlongationNoOptionLabel": "Ne",
                "accountForMaturityInputLabel": "Račun za dospijeće kamate i glavnice:",
                "contractDateInputLabel": "Datum ugovora:",
                "contractDraftLinkLabel": "Nacrt ugovora oročenog štednog uloga - depozita",
                "generalConditionsLinkLabel1": "Prihvaćam opće uvjete poslovanja za oročene štedne uloge - depozite",
                "generalConditionsLinkLabel2": "Prihvaćam opće uvjete poslovanja za zaštićene depozite",
                "confirmBtnLabel": "Potvrdi",
                "cancelBtnLabel": "Odustani",
                "editActionLabel": "Popravi",
                "cancelActionLabel": "Odustani",
                "signActionLabel": "Potpiši",
                "successMsg": "Uspješno!",
                "errorMsg": "Greška!",
                "minAmountLabel": "Minimalan iznos je",
                "month":"mjeseci",
                "oneMonth":"mjesec",
                "signTitle": "Potpis oročenja",
                "request": "zahtjev",
                "newDepositOrder": "Novo oročenje",
                "earlyTermination": "Prijevremeni prekid oročenja"
            },
            cancelDeposit: {
                "cancelDepositHeader": "Oročenje",
                "cancelDepositSubheader": "Zahtjev za prijevremeni raskid oročenog štednog uloga - depozita",
                "capitalAmountLabel": "Iznos glavnice:",
                "approvedInteresLabel": "Priznata kamata:",
                "approvedInteresAmountLabel": "Priznata kamata u iznosu:",
                "chargesLabel": "Naknada za prijevremeni raskid ugovora:",
                "totalAmountLabel": "Ukupan iznos za prijenos:",
                "accountForFundLabel": "Račun za isplatu sredstava:",
                "confirmBtn": "Potvrdi",
                "cancelBtn": "Odustani",
                "successInfoLabel1": "Zahtjev za prijevremeni raskid oročenog štednog uloga - depozita",
                "successInfoLabel2": "je uspješno potpisan i poslan u Banku.",
                "requestBtn": "Pregled zahtjeva",
            },
            depositDetails: {
                "contractDate": "Datum ugovaranja",
                "depositType": "Vrsta oročenja",
                "account": "Račun dospjeća",
                "note": "Napomena",
                "contract":"Ugovor",
                "payoutType":"Način isplate",
                "domesticType":"Kunska oročena štednja",
                "foreignType":"Devizna oročena štednja"

            },
            orderDetails:{
                "name":"Naziv primatelja",
                "payeeAccount":"IBAN primatelja",
                "amount":"Iznos",
                "orderId":"ID naloga",
                "orderTypeId":"ID tipa naloga",
                "orderTypeDesc":"Opis naloga",
                "dateCreated":"Datum kreiranja",
                "close":"Otkaži",
                "closeMsg":"Nalog uspješno otkazan",
              "purpose":"Svrha"
            },
            addNewExpressLoan: {
              "header": "Information on the possibility to obtain express loan",
              "cardType": "Duration (in months):",
              "account": "Account:",
              "amount": "Account for loan disbursement:",
              "paymentDay": "Settlement day:",
              "cancel": "Cancel",
              "confirm": "Confirm"
          }
        };

        $translateProvider
            .translations('hr', data);
    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      orders: {
        "accounts": "Accounts",
        "cards": "Cards",
        "savingsDeposits": "Savings and deposits",
        "security": "Security",
        "loans": "Loans",
        "payments": "Payments",
        "accountOverdraft": "Account overdraft",
        "largeAmount": "Large amount of cash withdrawal",
        "atmWithdrawal": "ATM withdrawal limit change",
        "orderMastercard": "Order MasterCard payment card",
        "changeMastercard": "Change MasterCard limit",
        "makeTermDeposit": "Make a term deposit",
        "cancelAutomatic": "Cancel automatic extensions of term deposit",
        "openSavings": "Open savings account",
        "orderSoftToken": "Order a soft token",
        "getExpressLoan": "Get express loan possibility information",
        "authorizationOrders": "Autorization for standing order",
        "cancelAuthorizationOrders": "Cancel authorization for standing order",
        "goBackToOrders": "Go back to orders",
        "subscribeEInvoice": "Subscribe to a new eInvoice or cancel an existing subscription",
        "beneficiaryName": "Recipient name",
        "beneficiaryNameRequired": "Recipient name is required!",
        "beneficiaryIBAN": "Account number",
        "beneficiaryIBANforSavings":"Addiko EBank user's savings account",
        "descriptionRequired": "Description is required!",
        "dateBegin": "Date of beginning",
        "dateCancel": "Date of cancellation",
        "description": "Order description",
        "standingOrders": "Your standing orders",
        "complete": "Standing order complete",
        "completeText": "Request for opening of standing order is successfully sent to the bank.",
        "completeCancelText": "Request for cancellation of standing order is successfully sent to the bank.",
        "makeNew": "Make new standing order",
        "title": "Standing orders",
        "titleConfirmation": "Standing order confirmation",
        "note": "Note",
        "statusOpen": "Open",
        "dateRequired": "Date is required!",
        "note1": "A standing order for the transfer of funds to any personal bank account or your savings account or savings account on which you are authorized must be requested at least 15 days prior to the desired date of payment, otherwise the Bank cannot ensure that the order will be executed on the payment date.",
        "note2": "Please, check again the correctness of the entered data prior to the final confirmation of the order. Orders which contain false information will not be executed.",
        "note3": "The actual execution of the order for permanent authorization can be checked in the monthly statement in the following month. Addiko Bank d.d. will charge a fee for the execution of payments through standing orders according to the valid Price list of services of Addiko Bank d.d.",
        "note1Slo":"A standing order for the transfer of funds to any personal bank account or your savings account or savings account on which you are authorized must be requested at least 15 days prior to the desired date of payment. Addiko Bank d.d. will charge a fee for the execution of payments through standing orders according to the valid ",
        "note2SloLink":"Price list of services of Addiko Bank d.d.",
        "cancel": "Cancel",
        "edit": "Edit",
        "Opened": "Opened",
        "Signed": "Signed",
        "paymentDayOfEachMonth": "Payment day of each month",
        "nonWorkingDayMsg": "or the next working day if this day is Saturday, Sunday or a holiday or another non-working day.",
        "address": "Receiver's address",
        "receviersAddressRequired": "Receiver's address is required!",
        "purpose": "Purpose",
        "next": "Next",
        "back": "Back",
        "maturityDateChangedConfirm": "Please confirm the changed date by selecting the checkbox.",
        "maturityDateChangedErr": "Maturity date is a non-working day and has been changed. Please confirm the change.",
        "maturityDateNonWorkingErr": "Maturity date is a non-working day.",
        "successOrder": "Order was successfully submitted.",
        "agreeTerms":"I agree that if, on the agreed day i will not provide a sufficient balance on the account, the bank is not required to execute orders under this mandate.",
        "cancelAuthorisation": "Cancellation of authorisation for standing order",
        "permanentAthorisation": "Authorisation for standing order",
        "Submitted": "Submitted",
        "Closed": "Closed",
        "InProcess": "In process",
        "Canceled": "Canceled",
        "Executed": "Executed",
        "Rejected": "Rejected",
        "InError": "In error",
        "PartialySigned": "Partialy signed",
        "ForProcessing": "For processing",
        "FailureAfterComplaint": "Failure after complaint",
        "SuccessAfterComplaint": "Success after complaint",
        types: {
          "trr":"Recipient's bank account",
          "hypo":"Addiko EBank user's savings account"
        }
      },
      termDeposit: {
        "termDepositHeader": "Open term deposit",
        "nameInputLabel": "Name and surname",
        "addressInputLabel": "Address",
        "cityInputLabel": "City",
        "debitAccountSelectLabel": "Debit account",
        "typeSelectLabel": "Term deposit type",
        "interestRateOverviewLabel": "Interest rate overview",
        "realRate": "Real interest rate",
        "referenceRate": "Reference interest rate",
        "amountInputLabel": "Amount",
        "baseInterestRateInputLabel": "Base interest rate",
        "marginInputLabel": "Margin",
        "stimulativeInterestRateInputLabel": "Stimulative interest rate",
        "totalInterestRateInputLabel": "Total interest rate",
        "maturityInMonthsSelectLabel": "Term in months",
        "expiryDateInputLabel": "Expiry date",
        "interestRatePayoutTypeSelectLabel": "Type of interest rate payout",
        "informativeCalculationLinkLabel": "Informative calculation of effective interest rate",
        "automaticProlongationRadioOptionLabel": "Automatic renewal",
        "automaticProlongationYesOptionLabel": "Yes",
        "automaticProlongationNoOptionLabel": "No",
        "accountForMaturityInputLabel": "Account for maturity of interest and capital",
        "contractDateInputLabel": "Contract date",
        "contractDraftLinkLabel": "Contract draft for term deposit",
        "generalConditionsLinkLabel1": "I accept general conditions for term deposit",
        "generalConditionsLinkLabel2": "I accept general conditions for secured deposit",
        "confirmBtnLabel": "Confirm",
        "cancelBtnLabel": "Cancel",
        "editActionLabel": "Edit",
        "cancelActionLabel": "Cancel",
        "signActionLabel": "Sign",
        "successMsg": "Success!",
        "errorMsg": "Error!",
        "minAmountLabel": "Minimal amount is",
        "month": "months",
        "oneMonth": "month",
        "signTitle": "Term deposit sign",
        "request": "request",
        "newDepositOrder": "New deposit order",
        "assignmentOfInterestAnnual": "Annual reporting",
        "assignmentOfInterestAfter": "Report after maturity",
        "interestPayoutMonthly": "Monthly",
        "interestPayoutAfterMaturity": "After maturity",
        "earlyTermination": "Deposit order eary termination",
        "depositType": "Deposit type",
        "assignmentOfInterest": "Assignment of interest",
        "letnaAssignmentOfInterest": "Assignment of interest",
        "interestPayout": "Interest payout",
        "termDepositDuration": "Term deposit duration",
        "durationInDays": "days",
        "durationOr": "or",
        "durationInMonths": " months",
        "maturityDate": "Maturity date",
        "executionDate": "Execution date",
        "minDepDurationErr": "Minimum deposit duration is ",
        "maxDepDurationErr": "Maximum deposit duration is ",
        "minRastociDepositDuration": "Minimum duration is 31 days.",
        "maxRastociDepositDuration": "Maximum duration is 35 days.",
        "durationRastociDepozitMsg": "Duration must be between 31 and 35 days.",
        "durationZlataJesenMsg": "Duration must be between 488 and 1097 days.",
        "days": "days.",
        "termsAndConditions": "I certify that I am aware of",
        "termsAndConditions1": "General terms and conditions of deposits",
        "termsAndConditions2": "and I agree with them. I am also aware of type and current interest rate conditions of selected product.",
        "taxationOfInterestTitle": "Taxation of interest",
        "taxationOfInterestMsg": "In accordance with the Personal Income Tax Act and the Tax Procedure Act interest exceeding the total amount of 1.000 EUR shall be taken into account when calculating the tax base. It is recommended that in the case of long-term deposits you opt for an annual reporting of interest since it reduces the chance that at the end of the saving period your interest would exceed 1.000 EUR. At the conclusion of the long term deposit contract a Notice on the application of the tax base according to Article 84 of the Personal Income Tax Act will be issued.",
        "headerLink1": "Basic information on term deposits",
        "headerLink2": "Applicable interest rates",
        "headerLink3": "Bank guarantee scheme",
        "wrongDepositCurrency": "Deposit of the chosen type is not available for selected currency.",
        "wrongDepositDuration": "This duration is not possible for selected deposit.",
        "wrongDepositAmount": "This amount is not valid for selected deposit.",
        "wrongMinDepositAmount": "Minimum amount is ",
        "wrongMaxDepositAmount": "Maximum amount is ",
        "makeTermDepositTimelineTitle": "Make term deposit",
        "vrstaDepozita": "Deposit type",
        "termDepositStatus": {
          "entered":"Waiting to be processed",
          "realised": "Realised",
          "unrealised": "Unrealised",
          "cancelled": "Cancelled",
          "receivednotexecuted":"In processing"
        }
      },
      cancelDeposit: {
        "cancelDepositHeader": "Term deposit",
        "cancelDepositSubheader": "Request for premature cancellation of term deposit",
        "capitalAmountLabel": "Capital amount:",
        "approvedInteresLabel": "Approved interest:",
        "approvedInteresAmountLabel": "Approved interest in the amount of:",
        "chargesLabel": "Charges for premature cancellation of term deposit:",
        "totalAmountLabel": "Total amount for transfer:",
        "accountForFundLabel": "Account for fund payout:",
        "confirmBtn": "Confirm",
        "cancelBtn": "Cancel",
        "successInfoLabel1": "Request for premature cancellation of term deposit",
        "successInfoLabel2": "was signed successfully and sent to bank.",
        "requestBtn": "Request overview",
      },
      depositDetails: {
        "contractDate": "Contracting date",
        "depositType": "Term deposit type",
        "account": "Maturity account",
        "note": "Note",
        "contract": "Contract",
        "payoutType": "Payout type",
        "domesticType": "Domestic term deposit",
        "foreignType": "Foreign term deposit",
        "termsAndConditions": "Terms and conditions"

      },
      orderDetails: {
        "name": "Recipient name",
        "payeeAccount": "Recipient account",
        "payeeAddress": "Recipient address",
        "amount": "Amount",
        "orderId": "Order ID",
        "orderTypeId": "Order type ID",
        "orderTypeDesc": "Order description",
        "dateCreated": "Date of creation",
        "firstPaymentDate": "First payment date",
        "lastPaymentDate": "Last payment date",
        "close": "Cancel",
        "closeMsg": "Order successfuly closed",
        "purpose": "Purpose"
      },
      savingsOrder: {
        "title": "Open savings account",
        "headerLink1": "Basic information on savings account 5 days",
        "headerLink2": "Basic information on Addiko Plus savings",
        "headerLink3": "Applicable interest rates",
        "headerLink4": "Bank guarantee scheme",
        "savingsType": "Savings type",
        "firstPayment": "First payment",
        "lastPayment": "Last payment",
        "orderPaymentDay": "Standing order payment day",
        "fromAccount": "From account",
        "amount": "Monthly deposit amount",
        "duration": "Savings duration",
        "minSavingDuration": "Minimum savings duration is ",
        "maxSavingDuration": "Maximum savings duration is ",
        "orderpaymentDay": "Standing order payment day",
        "termsAndConditions": "I certify that I am aware of",
        "termsAndConditions1": " General terms and conditions of savings",
        "termsAndConditions2": " and I agree with them. I am also aware of type and current interest rate conditions of selected product.",
        "termsAndConditions3AddikoPlus": " I also agree that if there is not a sufficient balance on the account on the selected day for standing order, the bank is not required to execute my order.",
        "taxationOfInterestMsg": "In accordance with the Personal Income Tax Act and the Tax Procedure Act interest exceeding the total amount of 1.000 EUR shall be taken into account when calculating the tax base. It is recommended that in the case of long-term savings you opt for an annual reporting of interest since it reduces the chance that at the end of the saving period your interest would exceed 1.000 EUR. At the conclusion of the long term savings contract a Notice on the application of the tax base according to Article 84 of the Personal Income Tax Act will be issued.",
        "newSavingsOrder": "New savings order",
        "initialDepositAmount": "Initial amount",
        "monthlyDepositAmount": "Monthly deposit",
        "newSavingsOrderTimelineTitle": "Open Savings account",
        "dateOfEntry": "Date of entry",
        "executionDate": "Maturity date",
        "userNumber": "User number",
        "savingsCurrency": "Savings currency",
        "fromSAccount": "From account",
        "nameAndSurname": "Name and surname",
        "initialAmount": "Initial amount",
        "disbursementAccount": "Disbursement account",
        "receiveMonthlyStatementsVia": "Receive monthly statements via",
        "vpoType": "VPO type",
        "typeOfSaving": "Type of saving",
        "realInterestRate": "Real interest rate",
        "referenceInterestRate": "Reference interest rate",
        "currency": "Currency",
        "dateOfOpening": "Date of opening",
        "openStandingOrder": "Open standing order",
        "orderComment": "Order comment",
        "savingOrderName": "Savings type"
      },
      addNewExpressLoan: {
        "header": "Information on the possibility to obtain Express loan",
        "header_SLO": "Information on the possibility to obtain EXPRESS loan",
        "note1": "An EXPRESS loan is a cash loan without additional documentation. The Bank will consider your request in the next two working days. After your visit with a personal banker in a branch and the signing of the contract, the loan will be disbursed to your account.",
        "note2": "EXPRESS loan approval conditions are available in the",
        "noteLink1": "Price list of services",
        "noteAnd": "and in",
        "noteLink2": "Interest rates act of Addiko bank d.d.",
        "cardType": "Duration (in months)",
        "account": "Account",
        "amount": "Amount",
        "paymentDay": "Settlement day",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "approvalDate": "Desired date of the approval",
        "paymentAccount": "Payment account",
        "addNewExpressLoan": "New loan"
      }
    };

    $translateProvider
      .translations('en', data);
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name navigation
   * @description
   *
   */
  angular
    .module('navigation', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      navigation: {
        "dashboard": "Početna strana",
        "accountsAndCards": "Računi i Kartice",
        "accounts": "Računi",
        "payments": "Plaćanja",
        "deposit": "Štednja",
        "loans": "Krediti",
        "investments": "Investicije",
        "settings": "Podešavanja",
        "messages": "Poruke",
        "hypoClub": "Addiko Club",
        "eTrade": "Addiko ETrade",
        "paymentsAndTransfers" :"Pregled plaćanja i prenosa",
        "domesticPayment": "Nalog za plaćanje",
        "transferToMyAccount": "Prenos na moj račun",
        "internationalPayment": "Internacionalno plaćanje",
        "exchangeOffice" :"Menjačnica",
        "exchangeRates" :"Valutni kurs",
        "standingOrders": "Trajni nalog",
        "eInvoices": "eRačuni",
        "paymentsList": "Poslati nalozi",
        "paymentsReturn": "Povrat plaćanja",
        "directDebitsList": "Lista SEPA izravnih dugovanja",
        "myTemplatesList": "Moji šabloni",
        "allAccountsOverview": "Pregled računa i kartica",
        "allDepositOverview": "Sve štednje",
        "allDeposits": "Štednje",
        "allDepositOverviewSerbMne": "Štednja",
        "loansOverview": "Pregled kredita",
        "investmentsOverview": "Pregled investicija",
        "availableBalance": "Raspoloživi iznos",
        "loanBalance": "Stanje kredita",
        "newMessages": "Nove poruke: ",
        "allowedLoan":"Odobreni iznos",
        "balance": "Stanje računa",
        "newOrder":"Kupnja udjela",
        "viberBanking":"Addiko Chat Banking"
      }
    };

    $translateProvider
      .translations('sr', data);

  }
}());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      navigation: {
        "dashboard": "Prva stran",
        "accountsAndCards": "Računi in kartice",
        "accounts": "Računi",
        "payments": "Plačila",
        "deposit": "Varčevanja in depoziti",
        "loans": "Krediti",
        "investments": "Naložbe",
        "settings": "Nastavitve",
        "messages": "Sporočila",
        "hypoClub": "Addiko Klub",
        "eTrade": "Addiko Broker",
        "paymentsAndTransfers" :"Pregled plačil in prenosov",
        "domesticPaymentSl": "UPN nalog",
        "transferToMyAccount": "Prenos na moj račun",
        "internationalPayment": "Plačilo v tujino",
        "exchangeOffice" :"Menjava valut",
        "exchangeRates" :"Tečajna lista",
        "standingOrders": "Trajni nalog",
        "eInvoicesSlo": "eRačuni / eDokumenti",
        "paymentsList": "Pregled plačil",
        "paymentsReturn": "Vračilo",
        "directDebitsList": "SEPA direktne obremenitve",
        "sepa": "Nastavitve SEPA DD",
        "myTemplatesList": "Predloge",
        "allAccountsOverview": "Pregled vseh računov",
        "allDepositOverview": "Vsa varčevanja",
        "allDeposits": "Varčevanja",
        "allDepositOverviewSerbMne": "Vsi depoziti",
        "loansOverview": "Pregled kreditov",
        "investmentsOverview": "Pregled naložb",
        "availableBalance": "Razpoložljivo stanje",
        "loanBalance": "Stanje kredita",
        "newMessages": "Nova sporočila: ",
        "newMessagesSlo": "Nova osebna sporočila: ",
        "employeePayroll": "Plačilne liste",
        "allowedLoan":"Odobreno posojilo",
        "balance": "Stanje na računu",
        "newOrder":"Nakup delnic",
        "documents":"Dokumenti",
        "sepaTransactions":"Pregled SEPA DD",
        "withdrawal1":"Sprememba limita",
        "withdrawal2":"na računu",
        "changeATMWithdrawal1":"Sprememba limita",
        "changeATMWithdrawal2":"na bankomatu",
        "masterCardOrder":"MasterCard limit"

      }
    };

    $translateProvider
      .translations('sl', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      navigation: {
        "dashboard": "Početna strana",
        "accountsAndCards": "Računi i Kartice",
        "accounts": "Računi",
        "payments": "Plaćanja",
        "deposit": "Štednja",
        "loans": "Krediti",
        "investments": "Investicije",
        "settings": "Podešavanja",
        "messages": "Poruke",
        "hypoClub": "Addiko Club",
        "eTrade": "Addiko ETrade",
        "paymentsAndTransfers" :"Pregled plaćanja i prenosa",
        "domesticPayment": "Nalog za plaćanje",
        "transferToMyAccount": "Prenos na moj račun",
        "internationalPayment": "Internacionalno plaćanje",
        "exchangeOffice" :"Razmena valute",
        "exchangeRates" :"Kursna lista",
        "standingOrders": "Trajni nalog",
        "eInvoices": "eRačuni",
        "paymentsList": "Lista plaćanja",
        "paymentsReturn": "Povrat plaćanja",
        "directDebitsList": "Lista SEPA izravnih dugovanja",
        "myTemplatesList": "Moji šabloni",
        "allAccountsOverview": "Pregled svih računa",
        "allDepositOverview": "Sve štednje",
        "allDeposits": "Štednje",
        "allDepositOverviewSerbMne": "Štednja",
        "loansOverview": "Pregled kredita",
        "investmentsOverview": "Pregled investicija",
        "availableBalance": "Raspoloživi iznos",
        "loanBalance": "Stanje kredita",
        "newMessages": "Nove poruke: ",
        "allowedLoan":"Odobreni iznos",
        "balance": "Stanje računa",
        "newOrder":"Kupnja udjela",
        "viberBanking":"Addiko Chat Banking"
      }
    };

    $translateProvider
      .translations('mne', data);

  }
}());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      navigation: {
        "dashboard": "Početna stranica",
        "accountsAndCards": "Računi i Kartice",
        "accounts": "Računi",
        "payments": "Plaćanja",
        "deposit": "Oročenja i eKnjižice",
        "loans": "Krediti",
        "investments": "Investicije",
        "settings": "Postavke",
        "messages": "Poruke",
        "hypoClub": "Addiko Club",
        "eTrade": "Addiko ETrade",
        "paymentsAndTransfers" :"Pregled plaćanja i prijenosa",
        "domesticPayment": " Opći nalog",
        "transferToMyAccount": "Prijenos na moj račun",
        "internationalPayment": " Devizni nalog",
        "exchangeOffice" :"Mjenjačnica",
        "exchangeRates" :"Tečajna lista",
        "standingOrders": "Trajni nalog",
        "eInvoices": "eRačuni",
        "paymentsList": "Pregled naloga",
        "paymentsReturn": "Povrat priljeva",
        "directDebitsList": "Lista SEPA izravnih dugovanja",
        "myTemplatesList": "Predlošci",
        "allAccountsOverview": "Pregled svih računa",
        "allDepositOverview": "Sve štednje",
         "allDeposits": "Štednja",
        "allDepositOverviewSerbMne": "Oročenja",
        "loansOverview": "Pregled kredita",
        "investmentsOverview": "Pregled investicija",
        "availableBalance": "Raspoloživi iznos",
        "loanBalance": "Stanje kredita",
        "newMessages": "Nove poruke: ",
        "employeePayroll": "Djelatnici",
        "allowedLoan":"Odobreni iznos",
        "balance": "Stanje računa",
        "newOrder":"Kupnja udjela",
        "sepa":"Sepa D.D. ograničenja i zabrane",
        "sepa_CRO": "Ograničenja SEPA izravnog terećenja",
        "sepaTransactions":"SEPA izravno terećenje",
        "sepaTransactions_CRO":"SEPA izravno terećenje",
        "secure3d": "Sigurna internetska kupnja",
        "viberBanking":"Addiko Chat Banking"
      }
    };

    $translateProvider
      .translations('hr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      navigation: {
        "dashboard": "Dashboard",
        "accountsAndCards": "Accounts and Cards",
        "accounts": "Accounts",
        "payments": "Payments",
        "deposit": "Deposit and e-books",
        "loans": "Loans",
        "investments": "Investments",
        "settings": "Settings",
        "messages": "Messages",
        "hypoClub": "Addiko club",
        "eTrade": "Addiko ETrade",
        "paymentsAndTransfers" :"Payments & Transfers overview",
        "domesticPayment": "Domestic payment",
        "domesticPaymentSl":"Universal payment order",
        "transferToMyAccount": "Transfer to my account",
        "internationalPayment": "International payment",
        "exchangeOffice" :"Exchange office",
        "exchangeRates" :"Exchange rates",
        "standingOrders": "Standing orders",
        "eInvoices": "eInvoices",
        "eInvoicesSlo": "EInvoices / eDocuments",
        "paymentsList": "List of payments",
        "paymentsReturn": "Payments return",
        "directDebitsList": "List of SEPA direct debits",
        "myTemplatesList": "List of my templates",
        "allAccountsOverview": "All accounts overview",
        "allDepositOverview": "All savings",
        "allDeposits": "Savings",
        "allDepositOverviewSerbMne": "Deposits",
        "loansOverview": "Loans overview",
        "investmentsOverview": "Investments overview",
        "availableBalance": "Available balance",
        "loanBalance": "Loan balance",
        "newMessages": "New messages: ",
        "newMessagesSlo": "New personal messages: ",
        "employeePayroll": "Employee payroll info",
        "allowedLoan":"Approved amount",
        "balance": "Balance",
        "newOrder":"Buy  stocks",
        "sepa": "SEPA DD Settings",
        "sepa_CRO": "SEPA direct debit limit",
        "documents":"Documents",
        "sepaTransactions":"SEPA DD Overview",
        "sepaTransactions_CRO":"SEPA direct debit",
        "withdrawal1":"Change account",
        "withdrawal2":"overdraft",
        "changeATMWithdrawal1":"Change ATM",
        "changeATMWithdrawal2":"withdrawal limit",
        "masterCardOrder":"MasterCard limit",
        "viberActivation": "Activate Viber",
        "deactivateViber": "Deactivate Viber",
        "viberActivationTxt": "Confirm Viber activation?",
        "viberGenerateNewPassword": "Viber is already activated. Do you want new code for activation?",
        "viberBanking":"Addiko Chat Banking",
        "secure3d": "Secure online shopping"
      }
    };

    $translateProvider
      .translations('en', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      navigation: {
        "dashboard": "Početna strana",
        "accountsAndCards": "Računi i kartice",
        "accounts": "Računi",
        "payments": "Plaćanja",
        "deposit": "Štednja",
        "loans": "Krediti",
        "investments": "Investicije",
        "settings": "Postavke",
        "messages": "Poruke",
        "hypoClub": "Addiko Club",
        "eTrade": "Addiko ETrade",
        "paymentsAndTransfers" :"Pregled plaćanja i prijenosa/prenosa",
        "domesticPayment": "Opći/opšti nalog",
        "transferToMyAccount": "Prijenos/Prenos na moj račun",
        "internationalPayment": "Devizni nalog",
        "exchangeOffice" :"Mjenjačnica",
        "exchangeRates" :"Tečajna/kursna lista",
        "standingOrders": "Trajni nalog",
        "eInvoices": "eRačuni",
        "paymentsList": "Pregled naloga",
        "paymentsReturn": "Povrat priljeva/priliva",
        "directDebitsList": "Lista SEPA izravnih dugovanja",
        "myTemplatesList": "Uzorci",
        "allAccountsOverview": "Pregled računa i kartica",
        "allDepositOverview": "Sve štednje",
        "allDeposits": "Štednje",
        "allDepositOverviewSerbMne": "Oročenja",
        "loansOverview": "Pregled kredita",
        "investmentsOverview": "Pregled investicija",
        "availableBalance": "Raspoloživi iznos",
        "loanBalance": "Stanje kredita",
        "newMessages": "Nove poruke: ",
        "viberActivationTxt": "Potvrdite aktivaciju Vibera?",
        "allowedLoan":"Odobreni iznos",
        "balance": "Stanje računa",
        "newOrder":"Kupnja/Kupovina udjela",
        "viberBanking":"Addiko Chat Banking"
      }
    };

    $translateProvider
      .translations('bh', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

      var data = {
          messages: {
              "createBtn": "Kreiraj novu poruku",
              "receivedTab": "Primljene",
              "sentTab": "Poslate",
              "unreadLabel": "Nepročitane poruke",
              "readLabel": "Pročitane poruke",
              "replyBtn": "Odgovori",
              "printBtn": "Štampaj",
              "deleteBtn": "Obriši",
              "loadMore":"Učitaj više",
              "downloadAttachment": "Preuzmi prilog"
          },
          "newMessage": {
              "titleLabel": "Nova poruka",
              "titleReplyLabel": "Odgovori na poruku",
              "subjectLabel": "Naslov",
              "subjectPlaceholder": "Unesite naslov poruke ovde",
              "bodyLabel": "Sadržaj",
              "header": "Poruke",
              "backBtn": "Nazad",
              "sendBtn": "Pošalji",
              "successLabel1": "Poruka poslana",
              "successLabel2": "Poruka ",
              "successLabel3": " je uspješno poslana!",
              "newLabel": "Kreiraj novu poruku",
              "goToMsgsLabel": "Idi na poruke"
          }
      };

    $translateProvider
      .translations('sr', data);

  }
}());


(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('navigation')
        .config(config);

    function config($translateProvider) {

        var data = {
            messages: {
                "createBtn": "Pošlji sporočilo",
                "receivedPersonalTab": "Prejeta osebna",
                "receivedGlobalTab": "Prejeta globalna",
                "sentTab": "Poslana",
                "unreadLabel": "Neprebrana sporočila",
                "globalLabel": "Globalna sporočila",
                "readLabel": "Prebrana sporočila",
                "replyBtn": "Odgovori",
                "printBtn": "Natisni",
                "deleteBtn": "Izbriši",
                "loadMore":"Prikaži več",
                "noData": "Za izbrano obdobje ni sporočil",
              "paymentCode": "ID plačila:",
                "orderCode":"Številka naročila:",
                "downloadAttachment": "Prenesi priponko"
            },
            "newMessage": {
                "titleLabel": "Pošlji sporočilo",
                "titleReplyLabel": "Odgovori na sporočilo",
                "subjectLabel": "Naslov",
                "subjectPlaceholder": "Vnesite naslov sporočila",
                "bodyLabel": "Vsebina",
                "header": "Sporočila",
                "backBtn": "Nazaj",
                "sendBtn": "Pošlji",
                "successLabel1": "Sporočilo poslano",
                "successLabel2": "Sporočilo ",
                "successLabel3": " je uspešno poslano.",
                "newLabel": "Pošlji sporočilo",
                "goToMsgsLabel": "Pojdi na sporočila"
            }
        };

        $translateProvider
            .translations('sl', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

      var data = {
          messages: {
              "createBtn": "Kreiraj novu poruku",
              "receivedTab": "Primljene",
              "sentTab": "Poslate",
              "unreadLabel": "Nepročitane poruke",
              "readLabel": "Pročitane poruke",
              "replyBtn": "Odgovori",
              "printBtn": "Štampaj",
              "deleteBtn": "Obriši",
              "loadMore":"Učitaj više"
          },
          "newMessage": {
              "titleLabel": "Nova poruka",
              "titleReplyLabel": "Odgovori na poruku",
              "subjectLabel": "Naslov",
              "subjectPlaceholder": "Unesite naslov poruke ovde",
              "bodyLabel": "Sadržaj",
              "header": "Poruke",
              "backBtn": "Nazad",
              "sendBtn": "Pošalji",
              "successLabel1": "Poruka poslana",
              "successLabel2": "Poruka ",
              "successLabel3": " je uspješno poslana.",
              "newLabel": "Kreiraj novu poruku",
              "goToMsgsLabel": "Idi na poruke"
          }
      };

    $translateProvider
      .translations('mne', data);

  }
}());


(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('navigation')
        .config(config);

    function config($translateProvider) {

        var data = {
            messages: {
                "createBtn": "Kreiraj novu poruku",
                "receivedTab": "Primljene",
                "sentTab": "Poslane",
                "unreadLabel": "Nepročitane poruke",
                "readLabel": "Pročitane poruke",
                "replyBtn": "Odgovori",
                "printBtn": "Ispis",
                "deleteBtn": "Izbriši",
                "loadMore":"Prikaži više",
                "downloadAttachment": "Preuzmi privitak"
            },
            "newMessage": {
                "titleLabel": "Nova poruka",
                "titleReplyLabel": "Odgovori na poruku",
                "subjectLabel": "Naslov",
                "subjectPlaceholder": "Unesite naslov poruke ovdje",
                "bodyLabel": "Sadržaj",
                "header": "Poruke",
                "backBtn": "Nazad",
                "sendBtn": "Pošalji",
                "successLabel1": "Poruka poslana",
                "successLabel2": "Poruka ",
                "successLabel3": " je uspješno poslana.",
                "newLabel": "Kreiraj novu poruku",
                "goToMsgsLabel": "Idi na poruke"
            }
        };

        $translateProvider
            .translations('hr', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('navigation')
        .config(config);

    function config($translateProvider) {

        var data = {
            messages: {
                "createBtn": "Create new message",
                "receivedTab": "Received",
                "receivedPersonalTab": "Received personal",
                "receivedGlobalTab": "Received global",
                "sentTab": "Sent",
                "unreadLabel": "Unread messages",
                "globalLabel": "Global messages",
                "readLabel": "Read messages",
                "replyBtn": "Reply",
                "printBtn": "Print",
                "deleteBtn": "Delete",
                "loadMore":"Load more",
                "noData": "No messages for selected period",
                "downloadAttachment": "Download attachment",
                "paymentCode": "Payment code:",
                "orderCode":"Order code:"
            },
            "newMessage": {
                "titleLabel": "New message",
                "titleReplyLabel": "Reply message",
                "subjectLabel": "Subject",
                "subjectPlaceholder": "Enter message subject here",
                "bodyLabel": "Message",
                "header": "Messages",
                "backBtn": "Back",
                "sendBtn": "Send",
                "successLabel1": "Message sent ",
                "successLabel2": "Your message ",
                "successLabel3": " has been sent successfully.",
                "newLabel": "Create new message",
                "goToMsgsLabel": "Go to messages"
            }
        };

        $translateProvider
            .translations('en', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

    var data = {
      messages: {
        "createBtn": "Kreiraj novu poruku",
        "receivedTab": "Primljene",
        "sentTab": "Poslate",
        "unreadLabel": "Nepročitane poruke",
        "readLabel": "Pročitane poruke",
        "replyBtn": "Odgovori",
        "printBtn": "Ispis",
        "deleteBtn": "Izbriši",
        "loadMore":"Učitaj više",
        "downloadAttachment": "Preuzmi privitak/prilog"
      },
      "newMessage": {
        "titleLabel": "Nova poruka",
        "titleReplyLabel": "Odgovori na poruku",
        "subjectLabel": "Naslov",
        "subjectPlaceholder": "Unesite naslov poruke ovdje",
        "bodyLabel": "Sadržaj",
        "header": "Poruke",
        "backBtn": "Nazad",
        "sendBtn": "Pošalji",
        "successLabel1": "Poruka poslana",
        "successLabel2": "Poruka ",
        "successLabel3": " je uspješno poslana!",
        "newLabel": "Kreiraj novu poruku",
        "goToMsgsLabel": "Idi na poruke"
      }
    };

    $translateProvider
      .translations('bh', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      invest: {
        "signInvestment": "Potpiši investiciju",
        "headerNew": "Nova investicija",
        "accountFrom": "S računa",
        "amountInputLabel": "Iznos",
        "quantityInputLabel": "Količina",
        "accountTo": "Isplata na račun",
        "date":"Datum vrednovanja",
        "dateNewOrder":"Datum vrednovanja",
        "dueDate": "Datum vrednovanja",
        "amountPlaceholder": "eg. 1,000.00",
        "accountType": "Vrsta računa",
        "fundName": "Naziv fonda",
        "fundNameReplace": "Fond za zamjenu",
        "comment": "Napomena",
        "bellowComment":"Podnositelj Zahtjeva potvrđuje da je upoznat s ",
        "bellowComment2": "Prospektom, Pravilima i Ključnim informacijama za ulagatelje fonda za koji podnosi Zahtjev",
        "bellowComment3": "  i da dokumente u cijelosti prihvaća.",
        "investor": "Investitor",
        "loan": "Kredit",
        "buyingFond": "Fond kupnje",
        "sellingFond": "Fond prodaje",
        "replacementFond": "Fond zamjene",
        "note": "Napomena",
        "back": "Natrag",
        "amountMinAmountError": "Pogrešan iznos ulaganja.",
        "amountMinAmountError2": "Minimalni iznos ulaganja za odabrani fond je 100,00 Kn.",
        "buyInvestmentPopup1": "Ovom transakcijom otvarate novi račun u fondu {{invFund}}",
        "buyInvestmentPopup2": "Da li želite nastaviti unos?",
        "add":"Potvrdi",
        "alertInfoNoFund": "Ne postoji investicija za odabrani račun.",
        "amountTypeAllShares": "Svi udjeli",
        "amountTypeShareValue": "Vrijednost udjela",
        "amountTypeShareQuantity": "Količina udjela",
        "accounts": "Računi"
      },
      investOverview: {
        "totalShareValue": "Ukupna vrijednost udjela",
        "shareQuantity": " Količina udjela",
        "buyStocks": "Kupnja udjela",
        "sellStocks": "Prodaja udjela",
        "replaceStocks": "Zamjena udjela",
        "transactions": "Transakcije",
        "orders": "Nalozi",
        "sharedAccount": "Zajednički račun:",
        "invAmount": "Iznos investicije:",
        "invDate": "Datum investicije:",
        "buyAccount": "Korisnički račun:",
        "fundName": "Naziv fonda:",
        "noTransactionData": "Nema dostupnih transakcija.",
        "noOrderData": "Nema dostupnih naloga.",
        "shareAccount": "Račun udjela",
        "dateOfEntry": "Datum knjiženja",
        "shareValue": "Vrijednost udjela",
        "shareQuant": "Količina udjela",
        "chargeValue": "Vrijednost naknade",
        "fundType": "Vrsta fonda",
        "sharePrice": "Cijena udjela",
        "copyOrder": "Kopiraj nalog",
        "editOrder": "Promijeni nalog",
        "deleteOrder": "Izbriši nalog",
        "signOrder": "Potpiši nalog",
        "status_created": "Kreiran",
        "status_recalled": "Opozvan",
        "status_processed": "Obrađen",
        "status_rejected": "Odbijen",
        "status_closed": "Zatvoren",
        "status_signed": "Potpisan",
        "status_inProcess": "U Obradi",
        "status_canceled": "Storniran"
      },
      investmentsList: {
        invOverview: "Pregled investicijskih računa",
        "shareQuantity": "Količina dionica"
      },
      accessInvestment: {
        "accession": "Pristupnica investicijskom fondu",
        "nameSurname": "Ime i prezime",
        "address": "Adresa prebivališta",
        "identificationNumber": "Broj identifikacijske isprave",
        "issuer": "Izdavatelj",
        "phone": "Telefon",
        "emailNotification": "Slanje obavjesti E-mailom",
        "bank": "Banka",
        "paymentAccNumber": "Broj računa",
        "plannedYearInvestment": "Planirane godišnje investicije",
        "fundsInvestment": "Sredstva za ulaganje ostvarena su od dohotka od",
        "msg1": "Potpisom ovog Upitnika potvrđujem da su u njemu navedeni podaci istiniti te ovlašćujem društvo Addiko Invest d.d.(dalje Društvo) da provjeri sve ovdje navedene podatke." +
        " Osobno ću vas obavijestiti ukoliko dođe do promjena vezanih uz prije izjavljene podatke i detalje.",
        "msg2": "Potpisom ovog Upitnika dajem izričitu suglasnost Društvu da može poduzimati sve radnje vezano na obradu i razmjenu mojih osobnih podataka navedenih u ovom Upitniku, uključujući i podatak o matičnom broju građana, a što obuhvaća pravo Društva na prikupljanje, spremanje, snimanje, organiziranje, uvid i prijenos osobnih podataka u svrhu obavljanja redovitih poslova Društva.",
        "employee": "Zaposlenik",
        "firm": "Poduzetnik",
        "unemployed": "Nezaposlen",
        "retired": "Umirovljenik",
        "student": "Student",
        "rest": "Ostalo",
        "personalStatus": "Osobni status",
        "employer": "Vrsta poslodavaca",
        "privateSector": "Privatni sektor",
        "civileService": "Državna služba",
        "stateAuth": "Tjela državne/lokalne vlasti",
        "emplTrade": "Državna trgovačka društva",
        "vocation": "Zvanje",
        "profession": "Zanimanje",
        "invEmployment": "Nesamostalni rad",
        "invfreelancing": "Samostalna djelatnost",
        "invLegal": "Imovina i imovinska prava",
        "capital": "Kapital",
        "invInsured": "Osiguranje",
        "inv1": "Do 200.000 kn",
        "inv2": "Do 500.000 kn",
        "inv3": "Do 1.000.000 kn",
        "inv4": "Više od 1.000.000 kn",
        "accountNumberInput": "Broj računa za isplatu",
        "add": "Dodaj"
      },
      salesReplacementTranslation: {
        title: "Poslovanje sa investicijskim fondovima"
      }
    };

    $translateProvider
        .translations('hr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      invest:{
        "signInvestment": "Sign investment",
        "headerNew":"New investment",
        "accountFrom":"From account",
        "amountInputLabel":"Amount",
        "quantityInputLabel": "Quantity",
        "accountTo":"Account to",
        "date":"Validation date",
        "dueDate": "Investment date",
        "dateNewOrder": "Investment date",
        "amountPlaceholder": "eg. 1,000.00",
        "accountType":"Account type",
        "fundName":"Fund name",
        "fundNameReplace": "Fund for replacement",
        "comment":"Comment",
        "bellowComment":"The applicant confirms to be familiar with ",
        "bellowComment2": "the brochure, rules and key information on fund investors",
        "bellowComment3": " and fully accepts all documents.",
        "investor":"Investor",
        "loan":"Loan",
        "buyingFond": "Buying fond",
        "sellingFond": "Selling fond",
        "replacementFond": "Replacement fond",
        "note": "Comment",
        "back": "Back",
        "amountMinAmountError": "Incorrect investment amount.",
        "amountMinAmountError2" : "Minimum amount of investment for the selected fund is 100.00 Kn.",
        "buyInvestmentPopup1": "This transaction opens a new account in the fund {{invFund}}",
        "buyInvestmentPopup2": "Do you want to continue?",
        "add":"Potvrdi",
        "alertInfoNoFund": "There is no available fund for selected account.",
        "amountTypeAllShares": "All shares",
        "amountTypeShareValue": "Share value",
        "amountTypeShareQuantity": "Share quantity",
        "accounts": "Accounts"
      },
      investOverview: {
        "totalShareValue": "Total share value",
        "shareQuantity": "Share quantity",
        "buyStocks": "Buy stocks",
        "sellStocks": "Sell stocks",
        "replaceStocks": "Replace stocks",
        "transactions": "Transactions",
        "orders": "Orders",
        "sharedAccount": "Shared account:",
        "invAmount": "Investment amount:",
        "invDate": "investment date:",
        "buyAccount": "Buy account:",
        "fundName": "Fund name:",
        "noTransactionData": "No transaction data.",
        "noOrderData": "No order data.",
        "shareAccount": "Share account",
        "dateOfEntry": "Date of entry",
        "shareValue": "Share value",
        "shareQuant": "Share quantity",
        "chargeValue": "Charge value",
        "fundType": "Fund type",
        "sharePrice": "Unit price",
        "copyOrder": "Copy order",
        "editOrder": "Edit order",
        "deleteOrder": "Delete order",
        "signOrder": "Sign order",
        "status_created": "Created",
        "status_recalled": "Recalled",
        "status_processed": "Processed",
        "status_rejected": "Rejected",
        "status_closed": "Closed",
        "status_signed": "Signed",
        "status_inProcess": "In Process",
        "status_canceled": "Canceled"
      },
      investmentsList: {
        "invOverview": "Investments overview",
        "shareQuantity": "Share quantity"
      },
      accessInvestment: {
        "accession": "Investment fund application form",
        "nameSurname": "Name and surname",
        "address": "Permanent residence address",
        "identificationNumber": "Number of identification documents",
        "issuer": "Issuer",
        "phone": "Phone",
        "emailNotification": "Slanje obavjesti E-mailom",
        "bank": "Bank",
        "paymentAccNumber": "Account number",
        "plannedYearInvestment": "Planned annual investments",
        "fundsInvestment": "Investment funds are realised from",
        "msg1": "By signing this Questionnaire I am confirming that all data in it are accurate and I am authorising the company Addiko-Invest d.d. (further: Company) to check the data mentioned here." +
        " I will personally inform you about any changes of the afore mentioned data and details.",
        "msg2": "By signing this Questionnaire I am authorising the Company to undertake all actions related to the processing and exchange of my personal data stated in the Questionnaire, including the information about the personal ID. These actions include collecting, storing, recording, organising, access and transfer of personal data for the purpose of conducting regular business operations of the Company.",
        "employee": "Employee",
        "firm": "Entrepreneur",
        "unemployed": "Unemployed",
        "retired": "Retired",
        "student": "Student",
        "rest": "Other",
        "personalStatus": "Personal status",
        "employer": "Type of employer",
        "privateSector": "Private sector",
        "civileService": "Civile service",
        "stateAuth": "State/regional authorities",
        "emplTrade": "State-owned companies",
        "vocation": "Vocation",
        "profession": "Profession",
        "invEmployment": "Employment",
        "invfreelancing": "Freelancing",
        "invLegal": "Ownership and ownership rights",
        "capital": "Capital",
        "invInsured": "Insurance",
        "inv1": "To 200.000 kn",
        "inv2": "To 500.000 kn",
        "inv3": "To 1.000.000 kn",
        "inv4": "More than 1.000.000 kn",
        "accountNumberInput": "Account number",
        "add": "Add"
      },
      salesReplacementTranslation: {
        title: "Business with investment funds"
      }
    };

    $translateProvider
      .translations('en', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      employee:{
        "header":"Platna lista",
        "noTimelineData":"Nema podataka",
        "downloadPdf":"Preuzmi PDF"
      }
    };

    $translateProvider
      .translations('hr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      employee:{
        "header":"Salary statement",
        "noTimelineData":"No data",
        "downloadPdf":"Download PDF"
      }
    };

    $translateProvider
      .translations('en', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      eInvoicesModal: {
        "headerLabel": "Plaćanje eRačuna",
        "instructionLabel": "Odaberite datum naloga i potvrdite plaćanje",
        "issuerLabel": "Nalogodavac:",
        "purposeLabel": "Opis plaćanja:",
        "amountLabel": "Iznos:",
        "refNumberLabel": "Poziv na broj primaoca:",
        "paymentDateLabel": "Datum plaćanja",
        "today": "Današnji datum",
        "dueDate": "Rok za plaćanje",
        "otherDate": "Drugi datum",
        "btnCancel": "Odustani",
        "btnPay": "Plati eRačun",
        "subscribeOrCancel": "Pretplati se na novi eRačun ili otkaži postojeću pretplatu",
        "submitted": "Podneseni zahtjevi",
        "showIssued": "Prikaži eRačune izdane ",
        "showAuthorizedEinvoices": "Prikaži eRačune na ovlaštenim računima",
        "waitingForPayment": "Neplaćeni eRačuni",
        "payedAndRemoved": "Plaćeni i uklonjeni eRačuni",
        "loadMoreEinvoices":"Prikaži još eRačuna",
        "einvoices": "eRačuni",
        "view": "Prikaži",
        "pay": "Plati",
        "noData": "Za odabrani period nema podataka za prikaz",
        "fromAccountPayLabel": "Uplati s računa: ",
        "availableAmountLabel": "Raspoloživi iznos: ",
        "viewEinvoice": "Prikaži eRačun",
        "amountPlaceholder": "npr. 1.000,00",
        "btnSign": "Potpiši",
        "btnEdit": "Uredi",
        "signHeaderLabel": "Proverite i potpišite eRačun",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primaoca",
        "receiver": "Primalac",
        "receiverAddress": "Adresa primaoca",
        "amount": "Iznos",
        "description": "Opis",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "enterComment": "Unesite komentar",
        "delete": "Obriši",
        "edit": "Promeni",
        "sign": "Potpiši"
      },
      eInvoiceDetail: {
        "attachments": "Privici",
        "eInvoicePDF": "E-invoice u PDF formatu",
        "eInvoiceXML": "E-invoice u XML formatu",
        "export": "Preuzimanje",
        "unsubscribeEInvoices": "Otkažite pretplatu na eRačun",
        "detail": "Detaljan pregled eRačuna",
        "unpaidInvoice": "Neplaćena faktura",
        "pay": "Plati",
        "markAsPayed": "Označi kao plaćeno/arhiviraj",
        "issuer": "Izdavatelj",
        "issuerAccount": "Račun izdavatelja",
        "purpose": "Svrha",
        "refNumber": "Poziv na broj primaoca",
        "amount": "Iznos",
        "issueDate": "Datum izdavanja",
        "purposeCode": "Šifra plaćanja",
        "dueDate": "Datum dospeća",
        "digitalSignature": "Status digitalnog potpisa",
        "visibilityDigitalSignature": "Informacije o digitalnom potpisu",
        "signatureId": "ID potpisa",
        "digitalCertNumber": "Broj digitalnog certifikata",
        "signatureName": "Naziv potpisa",
        "certificateIssuer": "Izdavatelj digitalnog certifikata",
        "showInfo": "Prikaži ",
        "hideInfo": "Sakrij ",
        "recipient": "Primalac",
        "recipientAccount": "Račun primaoca",
        "noAttachments": "eRačun nema priloga.",
        "goBack": "Povratak na eRačune",
        "note": "Napomena",
        "download": "Preuzmi PDF"
      },
      eInvoicesIssuersOverview: {
        "submittedApplications": "Aplikacije na koje ste pretplaćeni",
        "header": "Odaberi izdavatelja eRačuna",
        "issuerName": "Naziv izdavatelja",
        "issuerTaxId": "Porezni broj izdavatelja",
        "searchByNamePlaceholder": "Pretraži po nazivu",
        "searchByTaxIdPlaceholder": "Pretraži po poreznom broju",
        "showMore": "Prikaži još izdavatelja",
        "subscribe": "Pretplata",
        "issuerTax": "Porezni broj / Račun",
        "issuerAddress": "Adresa izdavatelja",
        "noData": "Za odabrani period nema podataka za prikaz"
      },
      eInvoicesSubscribe: {
        "goBack": "Povratak na prethodnu stranicu",
        "subscribeToEinvoice": "Pretplati se na eRačun",
        "einvoiceIssuer": "Izdavatelj eRačuna",
        "issuerAddress": "Adresa izdavatelja",
        "issuerAccount": "Račun izdavatelja",
        "referenceFromIssuer": "Model i poziv na broj",
        "einvoiceReceiver": "E-Invoice receiver",
        "receiversName": "Receivers name",
        "receiversAddress": "Receivers address",
        "receiversTaxId": "Receivers Tax ID",
        "yourContactEmail": "Your contact email",
        "tooltipInfo": "Trebate pomoć?",
        "tooltipInfoEmail": "Ukoliko radite promjenu emaila, ona se odnosi samo na registraciju usluge eRačun.",
        "einvoiceReferenceFromIssuerInputError": "Poziv na broj je obavezan!",
        "einvoiceSubscribeEmailInputError": "Vaš kontakt email je obavezan!",
        "reviewandSubmit": "Pregledajte i pošaljite",
        "changeEmail": "Promijeni email",
        "cancel": "Odustani",
        "ok": "OK",
        "termsAndConditions": "Suglasan sam da računi više ne dolaze u papirnatom obliku",
        "specialConditions": "Prihvaćam posebne uvjete izdavatelja"
      },
      eInvoiceStatus:{
        "InProcess":"U obradi",
        "Unregistered":"Neregistrirano",
        "Rejected":"Odbijeni"
      }
    };

    $translateProvider
      .translations('sr', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      eInvoicesModal: {
        "headerLabel": "Plačilo eRačuna",
        "instructionLabel": "Izberite datum in potrdilo plačilo",
        "issuerLabel": "Nalogodajalec",
        "purposeLabel": "Namen plačila",
        "amountLabel": "Znesek",
        "refNumberLabel": "Referenca",
        "paymentDateLabel": "Datum plačila",
        "today": "Današnji datum",
        "dueDate": "Rok plačila",
        "otherDate": "Drugi datum",
        "btnCancel": "Prekliči",
        "btnPay": "Plačaj eRačun",
        "subscribeOrCancel": "Prijava ali odjava prejemnja eRačunov",
        "submitted": "Oddane vloge",
        "showIssued": "Prikaži izdane eRačune ",
        "showAuthorizedEinvoices": "Prikaži eRačune na pooblaščenskih računih",
        "waitingForPaymentSlo": "Prejeti eRačuni",
        "payedAndRemoved": "Plačani in umaknjeni eRačuni",
        "loadMoreEinvoices":"Prikaži več",
        "loadMoreRegistrationsDeregistrations": "Prikaži več",
        "einvoicesSlo": "eRačuni in ostali eDokumenti",
        "view": "Prikaži",
        "pay": "Plačaj",
        "noData": "Za izbrano obdobje ni podatkov za prikaz",
        "fromAccountPayLabel": "Plačaj z računa: ",
        "availableAmountLabel": "Razpoložljivi znesek: ",
        "viewEinvoice": "Prikaži eRačun",
        "amountPlaceholder": "npr. 1.000,00",
        "btnSign": "Podpiši",
        "btnEdit": "Uredi",
        "signHeaderLabel": "Preverite in potrdite plačilo",
        "fromAccount": "Račun plačnika",
        "toAccount": "Račun prejemnika",
        "receiver": "Prejemnik",
        "receiverAddress": "Naslov prejemnika",
        "amount": "Znesek",
        "description": "Namen",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Naslov banke",
        "enterComment": "Vnesite opombo",
        "delete": "Izbriši",
        "edit": "Spremeni",
        "sign": "Podpiši",
        "listOfRegistrations":"Seznam oddanih vlog",
        "processedTabSlo": "Plačani in ostali eRačuni",
        "processed": "Obdelani",
        "archived": "Umaknjeni",
        "rejected": "Zavrnjeni",
        "noAvailableEInvoices": "Ni eRačunov za prikaz",
        "creditorNameSearch": "Iskanje po nazivu izdajatelja",
        "issuerIban":"Številka računa izdajatelja",
        "issuerAddress":"Naslov izdajatelja",
        "requestType":"Tip vloge",
        "gsm":"Vaša telefonska št.",
        "subscribe":"Prijava",
        "unsubscribe":"Odjava",
        "paymentNotPossible": "Plačilo ni možno",
        "paidByOtherMeans": "Plačan na drug način",
        "paymentWithDirectDebit": "Plačilo z direktno obremenitvijo",
        "withdrawn": "Umaknjeni",
        "inProgressByOther": "V obdelavi pri drugem uporabniku",
        "msg1":"Ste prepričani, da želite umakniti izabrani e-račun med plačane in ostale e-račune ?",
        "msg2":"Plačilo tega e-računa preko Addiko EBanke po umiku ne bo več mogoče. ",
        "cancel":"Prekliči",
        "confirm":"Potrdi",
        eDocumentType: {
          'eInvoice': 'eRačun',
          'eProforma':'ePredračun',
          'eWarning':'eOpomin',
          'eCreditNote':'eDobropis',
          'eDebitNote':'eBremepis',
          'ePurchaseOrder':'eNaročilnica',
          'eDeliveryNote':'eDobavnica'
        },
        rejectDocumentAlert: {
          headerText: 'Želite zavrniti izbrani dokument?',
          labelText: 'Prosimo na kratko pojasnite vzrok zavrnitve, ki bo sporočen izdajatelju dokumenta.'
        }
      },
      eInvoiceDetail: {
        "attachments": "Priloge",
        "eInvoicePDF": "eRačun v PDF formatu",
        "eInvoiceXML": "eRačun v XML formatu",
        "export": "Izvoz",
        "unsubscribeEInvoices": "Odjava prejemanja eRačunov",
        "detail": "Pregled podrobnosti eRačuna",
        "unpaidInvoice": "Neplačan eRačun",
        "pay": "Plačaj",
        "markAsPayed": "Označi kot plačano",
        "issuer": "Izdajatelj",
        "issuerAccount": "Račun izdajatelja",
        "purpose": "Namen",
        "refNumber": "Referenca",
        "amount": "Znesek",
        "issueDate": "Datum izdaje",
        "purposeCode": "Koda namena",
        "dueDate": "Rok plačila",
        "digitalSignature": "Status digitalnega podpisa",
        "visibilityDigitalSignature": "Informacije o digitalnem podpisu",
        "signatureId": "ID podpisa",
        "digitalCertNumber": "Št. digitalnega potrdila",
        "signatureName": "Naziv podpisa",
        "certificateIssuer": "Izdajatelj digitalnega potrdila",
        "showInfo": "Prikaži ",
        "hideInfo": "Skrij ",
        "recipient": "Prejemnik",
        "recipientAccount": "Račun prejemnika",
        "noAttachments": "eRačun nima prilog.",
        "noDocAttachments": "eDokument nima prilog.",
        "goBack": "Nazaj na seznam",
        "issueDateOfEinvoice":"Datum izdaje",
        "paymentDesc":"Namen plačila",
        "archive":"Arhiviraj",
        "showDigStatus":"Prikaži status digitalnega potrdila",
        "issuerIBAN":"IBAN izdajatelja",
        "placeOfReg":"Kraj prijave",
        "dateOfReg":"Datum prijave/Datum odjave",
        "cancelReg":"Preklic prijave",
        "cancel":"Prekliči",
        "regAgain":"Ponovno prijavi",
        "regAgainSlo":"Ponovno prijavi/odjavi",
        "rejectReason":"Razlog preklica",
        "inProcess":"V izvedbi",
        "rejected":"Zavrnjen",
        "registered":"Prijavljen",
        "unregistered":"Neregistriran",
        "activeRegs":"Aktivne prijave",
        "cancelledRegs":"Preklicane prijave",
        "noteArchived": "Razlog arhiviranja",
        "noteRejected": "Razlog zavrnitve",
        "serviceName": "Naziv storitve",
        "download": "Prenesi PDF",
        "orderType": "Tip naročila",
        "registration": "Prijava",
        "deregistration": "Odjava",
        "withdraw":"Umakni",
        "valid": "Veljaven",
        "invalid": "Neveljaven",
        "otherInfo": "Ostali podatki",
        "statusOfEApplication": "Status E-računa",
        "statusOfEApplicationOpomina": "Status E-opomina",
        "statusOfEApplicationPredracun": "Status E-predračuna",
        "paymentId": "ID plačila"
      },
      eInvoicesIssuersOverview: {
        "submittedApplications": "Oddane vloge za prijavo in odjavo",
        "header": "Izveri izdajatelja eRačunov",
        "issuerName": "Naziv izdajatelja",
        "issuerTaxId": "Davčna številka izdajatelja",
        "searchByNamePlaceholder": "Išči po nazivu",
        "searchByTaxIdPlaceholder": "Išči po davčni št.",
        "showMore": "Prikaži več izdajateljev",
        "subscribe": "Prijava",
        "issuerTax": "Davčna številka / Račun",
        "issuerAddress": "Naslov izdajatelja",
        "noData": "Za izbrano obdobje ni podatkov za prikaz"
      },
      eInvoicesSubscribe: {
        "goBack": "Nazaj",
        "subscribeToEinvoice": "Naroči se na prejemanje eRačunov",
        "einvoiceIssuer": "Izdajatelj eRačunov",
        "einvoiceIssuerSlo": "Davčna številka izdajatelja - Naziv izdajatelja",
        "issuerAddress": "Naslov izdajatelja",
        "issuerAccount": "Račun izdajatelja",
        "referenceFromIssuer": "ID referenca izdajatelja",
        "einvoiceReceiver": "Prejemnik eRačuna",
        "receiversName": "Naziv prejemnika",
        "receiversAddress": "Naslov prejemnika",
        "receiversTaxId": "Davčna št. prejemnika",
        "yourContactEmail": "Vaš email",
        "tooltipInfo": "Potrebujete pomoč?",
        "tooltipInfoEmail": "Vneseni email se bo uporabljal samo pri prijavi prejemanja eRačunov.",
        "einvoiceReferenceFromIssuerInputError": "Vnos reference je obvezen!",
        "einvoiceSubscribeEmailInputError": "Vnos emaila je obvezen!",
        "reviewandSubmit": "Preverite podatke in potrdite",
        "changeEmail": "Spremeni email",
        "updateEmail": "Spremeni",
        "cancel": "Prekliči",
        "ok": "V redu",
        "statement":"IZJAVA",
        "termsAndConditionsSlo": "Z elektronsko oddajo vloge v Addiko EBanki potrjujem, da sem seznanjen s Splošnimi pogoji poslovanja.",
        "statementTitle":"Splošni pogoji banke ",
        "statementText":"Sprejemam ",
        "statementTextLink1":"Splošne pogoje za vodenje transakcijskega računa in opravljanje plačilnih storitev ",
        "statementTextAnd":"in ",
        "statementTextLink2":"Splošne pogoje za uporabo storitve spletne banke Addiko EBank",
        "statementTextEnd":"ki veljajo in se uporabljajo za storitev e-računi.",
        "specialConditions": "Strinjam se s pogoji izdajatelja",
        "newRegistration": "Vloga za prijavo/odjavo prejemanja eRačunov",
        "selectIssuer":"Izberite izdajatelja",
        "registrationNew":"Nova prijava/odjava",
        "generalTerms":"Strinjam se s pogoji uporabe",
        "register":"Potrdi",
        "applicationComplete": "Uspešna oddana vloga",
        "applicationCompleteTextSlo": "Uspešno ste oddali vlogo za prijavo oz. odjavo prejemanja eRačunov izdajatelja {{name}}.",
        "goToList": "Nazaj na seznam",
        "goToListSlo": "Nazaj na seznam Pregled oddanih vlog",
        "einvoiceIssuerInputError": "Vnos izdajatelja je obvezen!",
        "referenceExplanation":"Check issuers explanations of entering reference",
        "statementTitle2":"Splošni pogoji izdajatelja",
        "statementText2":"Pogoji sodelovanja so objavljeni na naših spletnih straneh"
      },
      eInvoiceRegistration: {
        "all": "Vsi",
        listOfRegistrations: "Pregled oddanih vlog",
        "unregistered": "Odjavljena",
        "Unregistered": "Odjavljena",
        "rejected": "Zavrnjena",
        "Rejected": "Zavrnjena",
        "rejectedSlo": "Zavrnjena",
        "registered": "Prijavljena",
        "Registered": "Prijavljena",
        "inProcess": "Vložena",
        "InProcess":"Vložena",
        "inProcessSlo": "Vložena",
        "sent":"Poslana",
        "Sent":"Poslana",
        "undelivered":"Nedostavljena",
        "Undelivered":"Nedostavljena",
        "Delivered":"Dostavljena",
        "delivered":"Dostavljena"
      },
      eInvoiceOverview:{
        "listOfEinvoices":"Seznam eRačunov",
        "eInvoicesToPay":"eRačuni za plačilo",
        "register":"Prijava/odjava na eRačun",
        "pay":"Plačaj",
        "success":"Uspešno!",
        "archivedEinvoces":"Arhivirani eRačuni",
        "successfulyArchived": "Uspješno ste arhivirali eRačun",
        "copy": "Kopiraj plačilni nalog",
        "inProgress": "V obdelavi",
        "documentsTab": "eDokumenti",
        "umakni": "Umakni",
        "reject": "Zavrni"
      },
      eInvoicePayment: {
        "recAccount":"Račun prejemnika",
        "purpose":"Namen",
        "accNumber":"Številka računa",
        "toPayee":"Prejemnik",
        "recAddress":"Naslov prejemnika",
        "recPostalCity":"Poštna številka"
      },
      eInvoiceStatus:{
        "InProcess":"Vložen",
        "Unregistered":"Odjavljen",
        "Registered":"Prijavljen",
        "Rejected":"Zavrnjen",
        "Undelivered":"Nedostavljen",
        "Delivered":"Dostavljen",
        "Sent":"Vložen",
        "InProgress": "V obdelavi",
        "Inserted":"Prejet",
        "Processed": "Obdelan",
        "Archived": "Umaknjen",
        "PaymentNotPossible": "Plačilo ni možno",
        "PaidByOtherMeans": "Plačan na drug način",
        "PaymentWithDirectDebit": "Plačilo z direktno obremenitvijo/trajnikom",
        "Withdrawn": "Umaknjen",
        "InProgressByOther": "V obdelavi pri drugem uporabniku",
        "Reviewed": "Pregledan",
        "Cancelled": "Plačilo preklicano"
      }
    };

    $translateProvider
      .translations('sl', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      eInvoicesModal: {
        "headerLabel": "Plaćanje eRačuna",
        "instructionLabel": "Odaberite datum naloga i potvrdite plaćanje",
        "issuerLabel": "Nalogodavac:",
        "purposeLabel": "Opis plaćanja:",
        "amountLabel": "Iznos:",
        "refNumberLabel": "Poziv na broj primatelja:",
        "paymentDateLabel": "Datum plaćanja",
        "today": "Današnji datum",
        "dueDate": "Rok za plaćanje",
        "otherDate": "Drugi datum",
        "btnCancel": "Odustani",
        "btnPay": "Plati eRačun",
        "subscribeOrCancel": "Pretplati se na novi eRačun ili otkaži postojeću pretplatu",
        "submitted": "Podneseni zahtjevi",
        "showIssued": "Prikaži eRačune izdane ",
        "showAuthorizedEinvoices": "Prikaži eRačune na ovlaštenim računima",
        "waitingForPayment": "Neplaćeni eRačuni",
        "payedAndRemoved": "Plaćeni i uklonjeni eRačuni",
        "loadMoreEinvoices":"Prikaži još eRačuna",
        "einvoices": "eRačuni",
        "view": "Prikaži",
        "pay": "Plati",
        "noData": "Za odabrani period nema podataka za prikaz",
        "fromAccountPayLabel": "Uplati s računa: ",
        "availableAmountLabel": "Raspoloživi iznos: ",
        "viewEinvoice": "Prikaži eRačun",
        "amountPlaceholder": "npr. 1.000,00",
        "btnSign": "Potpiši",
        "btnEdit": "Uredi",
        "signHeaderLabel": "Provjerite i potpišite eRačun",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primatelja",
        "receiver": "Primalac",
        "receiverAddress": "Adresa primatelja",
        "amount": "Iznos",
        "description": "Opis",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "enterComment": "Unesite komentar",
        "delete": "Obriši",
        "edit": "Promijeni",
        "sign": "Potpiši"
      },
      eInvoiceDetail: {
        "attachments": "Privici",
        "eInvoicePDF": "E-invoice u PDF formatu",
        "eInvoiceXML": "E-invoice u XML formatu",
        "export": "Preuzimanje",
        "unsubscribeEInvoices": "Otkažite pretplatu na eRačun",
        "detail": "Detaljan pregled eRačuna",
        "unpaidInvoice": "Neplaćena faktura",
        "pay": "Plati",
        "markAsPayed": "Označi kao plaćeno/arhiviraj",
        "issuer": "Izdavatelj",
        "issuerAccount": "Račun izdavatelja",
        "purpose": "Svrha",
        "refNumber": "Poziv na broj primatelja",
        "amount": "Iznos",
        "issueDate": "Datum izdavanja",
        "purposeCode": "Šifra namjene",
        "dueDate": "Datum dospijeća",
        "digitalSignature": "Status digitalnog potpisa",
        "visibilityDigitalSignature": "Informacije o digitalnom potpisu",
        "signatureId": "ID potpisa",
        "digitalCertNumber": "Broj digitalnog certifikata",
        "signatureName": "Naziv potpisa",
        "certificateIssuer": "Izdavatelj digitalnog certifikata",
        "showInfo": "Prikaži ",
        "hideInfo": "Sakrij ",
        "recipient": "Primalac",
        "recipientAccount": "Račun primatelja",
        "noAttachments": "eRačun nema priloga.",
        "goBack": "Povratak na eRačune",
        "note": "Napomena",
        "download": "Preuzmi PDF"
      },
      eInvoicesIssuersOverview: {
        "submittedApplications": "Aplikacije na koje ste pretplaćeni",
        "header": "Odaberi izdavatelja eRačuna",
        "issuerName": "Naziv izdavatelja",
        "issuerTaxId": "Porezni broj izdavatelja",
        "searchByNamePlaceholder": "Pretraži po nazivu",
        "searchByTaxIdPlaceholder": "Pretraži po poreznom broju",
        "showMore": "Prikaži još izdavatelja",
        "subscribe": "Pretplata",
        "issuerTax": "Porezni broj / Račun",
        "issuerAddress": "Adresa izdavatelja",
        "noData": "Za odabrani period nema podataka za prikaz"
      },
      eInvoicesSubscribe: {
        "goBack": "Povratak na prethodnu stranicu",
        "subscribeToEinvoice": "Pretplati se na eRačun",
        "einvoiceIssuer": "Izdavatelj eRačuna",
        "issuerAddress": "Adresa izdavatelja",
        "issuerAccount": "Račun izdavatelja",
        "referenceFromIssuer": "Poziv na broj",
        "einvoiceReceiver": "E-Invoice receiver",
        "receiversName": "Receivers name",
        "receiversAddress": "Receivers address",
        "receiversTaxId": "Receivers Tax ID",
        "yourContactEmail": "Your contact email",
        "tooltipInfo": "Trebate pomoć?",
        "tooltipInfoEmail": "Ukoliko radite promjenu emaila, ona se odnosi samo na registraciju usluge eRačun.",
        "einvoiceReferenceFromIssuerInputError": "Poziv na broj je obavezan!",
        "einvoiceSubscribeEmailInputError": "Vaš kontakt email je obavezan!",
        "reviewandSubmit": "Pregledajte i pošaljite",
        "changeEmail": "Promijeni email",
        "cancel": "Odustani",
        "ok": "OK",
        "termsAndConditions": "Suglasan sam da računi više ne dolaze u papirnatom obliku",
        "specialConditions": "Prihvaćam posebne uvjete izdavatelja"
      },
      eInvoiceStatus:{
        "InProcess":"U obradi",
        "Unregistered":"Neregistrirano",
        "Rejected":"Odbijeni"
      }
    };

    $translateProvider
      .translations('mne', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      eInvoicesModal: {
        "headerLabel": "Plaćanje eRačuna",
        "instructionLabel": "Odaberite datum naloga i potvrdite plaćanje",
        "issuerLabel": "Nalogodavac:",
        "purposeLabel": "Opis plaćanja:",
        "amountLabel": "Iznos:",
        "refNumberLabel": "Poziv na broj primatelja:",
        "paymentDateLabel": "Datum plaćanja",
        "today": "Današnji datum",
        "dueDate": "Rok za plaćanje",
        "otherDate": "Drugi datum",
        "btnCancel": "Odustani",
        "btnPay": "Plati eRačun",
        "subscribeOrCancel": "Pretplati se na novi eRačun ili otkaži postojeću pretplatu",
        "submitted": "Podneseni zahtjevi",
        "showIssued": "Prikaži eRačune izdane ",
        "showAuthorizedEinvoices": "Prikaži eRačune na ovlaštenim računima",
        "waitingForPayment": "Neplaćeni eRačuni",
        "payedAndRemoved": "Plaćeni i uklonjeni eRačuni",
        "loadMoreEinvoices":"Prikaži još eRačuna",
        "einvoices": "eRačuni",
        "view": "Prikaži",
        "pay": "Plati",
        "noData": "Za odabrani period nema podataka za prikaz",
        "fromAccountPayLabel": "Uplati s računa: ",
        "availableAmountLabel": "Raspoloživi iznos: ",
        "viewEinvoice": "Prikaži eRačun",
        "amountPlaceholder": "npr. 1.000,00",
        "btnSign": "Potpiši",
        "btnEdit": "Uredi",
        "signHeaderLabel": "Provjerite i potpišite eRačun",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primatelja",
        "receiver": "Primatelj",
        "receiverAddress": "Adresa primatelja",
        "amount": "Iznos",
        "description": "Opis",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "enterComment": "Unesite komentar",
        "delete": "Izbriši",
        "edit": "Promijeni",
        "sign": "Potpiši",
        "listOfRegistrations":"Registrovani računi",
        "processedTab": "Obrađeni eRačuni",
        "processed": "Obrađeni eRačuni",
        "archived": "Arhivirani",
        "rejected": "Odbijeni",
        "noAvailableEInvoices": "Nema raspoloživih eRačuna",
        "creditorNameSearch": "Pretraga po nazivu kreditora"
      },
      eInvoiceDetail: {
        "attachments": "Privici",
        "eInvoicePDF": "eInvoice u PDF formatu",
        "eInvoiceXML": "eInvoice u XML formatu",
        "export": "Preuzimanje",
        "unsubscribeEInvoices": "Otkažite pretplatu na eRačun",
        "detail": "Detaljan pregled eRačuna",
        "unpaidInvoice": "Neplaćena faktura",
        "pay": "Plati",
        "markAsPayed": "Označi kao plaćeno/arhiviraj",
        "issuer": "Izdavatelj",
        "issuerAccount": "Račun izdavatelja",
        "purpose": "Svrha",
        "refNumber": "Poziv na broj primatelja",
        "amount": "Iznos",
        "issueDate": "Datum izdavanja",
        "purposeCode": "Šifra namjene",
        "dueDate": "Datum dospijeća",
        "digitalSignature": "Status digitalnog potpisa",
        "visibilityDigitalSignature": "Informacije o digitalnom potpisu",
        "signatureId": "ID potpisa",
        "digitalCertNumber": "Broj digitalnog certifikata",
        "signatureName": "Naziv potpisa",
        "certificateIssuer": "Izdavatelj digitalnog certifikata",
        "showInfo": "Prikaži ",
        "hideInfo": "Sakrij ",
        "recipient": "Primatelj",
        "recipientAccount": "Račun primatelja",
        "noAttachments": "eRačun nema priloga.",
        "goBack": "Povratak na eRačune",
        "issueDateOfEinvoice":"Datum izdavanja eRačuna",
        "paymentDesc":"Opis plaćanja",
        "archive":"Arhiviraj",
        "showDigStatus":"Prikaži status digitalnog potpisa",
        "issuerIBAN":"IBAN izdavatelja",
        "placeOfReg":"Mjesto registracije",
        "dateOfReg":"Datum registracije",
        "cancelReg":"Otkaži registraciju",
        "cancel":"Odustani",
        "regAgain":"Registriraj ponovo",
        "rejectReason":"Razlog otkazivanja",
        "inProcess":"U obradi",
        "rejected":"Odbijen",
        "registered":"Registriran",
        "unregistered":"Neregistriran",
        "activeRegs":"Aktivne registracije",
        "cancelledRegs":"Otkazane registracije",
        "noteArchived": "Razlog arhiviranja",
        "noteRejected": "Razlog odbijanja",
        "serviceName": "Naziv usluge",
        "download": "Preuzmi PDF"
      },
      eInvoicesIssuersOverview: {
        "submittedApplications": "Aplikacije na koje ste pretplaćeni",
        "header": "Odaberi izdavatelja eRačuna",
        "issuerName": "Naziv izdavatelja",
        "issuerTaxId": "Porezni broj izdavatelja",
        "searchByNamePlaceholder": "Pretraži po nazivu",
        "searchByTaxIdPlaceholder": "Pretraži po poreznom broju",
        "showMore": "Prikaži još izdavatelja",
        "subscribe": "Pretplata",
        "issuerTax": "Porezni broj / Račun",
        "issuerAddress": "Adresa izdavatelja",
        "noData": "Za odabrani period nema podataka za prikaz"
      },
      eInvoicesSubscribe: {
        "goBack": "Povratak na prethodnu stranicu",
        "subscribeToEinvoice": "Pretplati se na eRačun",
        "einvoiceIssuer": "Izdavatelj eRačuna",
        "issuerAddress": "Adresa izdavatelja",
        "issuerAccount": "Račun izdavatelja",
        "referenceFromIssuer": "Poziv na broj",
        "einvoiceReceiver": "eInvoice receiver",
        "receiversName": "Receivers name",
        "receiversAddress": "Receivers address",
        "receiversTaxId": "Receivers Tax ID",
        "yourContactEmail": "e-mail",
        "tooltipInfo": "Trebate pomoć?",
        "tooltipInfoEmail": "Ukoliko radite promjenu emaila, ona se odnosi samo na registraciju usluge eRačun.",
        "einvoiceReferenceFromIssuerInputError": "Poziv na broj je obavezan!",
        "einvoiceSubscribeEmailInputError": "Vaš kontakt email je obavezan!",
        "reviewandSubmit": "Pregledajte i pošaljite",
        "changeEmail": "Promijeni email",
        "updateEmail": "Ažuriraj email",
        "cancel": "Odustani",
        "ok": "OK",
        "termsAndConditions": "Suglasan sam da računi više ne dolaze u papirnatom obliku",
        "specialConditions": "Prihvaćam posebne uvjete izdavatelja",
        "newRegistration": "Registracija eRačuna",
        "selectIssuer":"Izaberite izdavatelja",
        "registrationNew":"Nova registracija",
        "generalTerms":"Prihvaćam uvjete korištenja",
        "register":"Registriraj",
        "applicationComplete": "Zahtjev uspješan",
        "applicationCompleteText": "Uspješno ste poslali zahtjev za eRačun za izdavatelja {{name}}.",
        "goToList": "Povratak na eRačune",
        "einvoiceIssuerInputError": "Izdavatelj je obavezan podatak!"
      },
      eInvoiceRegistration: {
        listOfRegistrations: "Pregled registracija",
        "unregistered": "Otkazane",
        "rejected": "Odbijene",
        "registered": "Obrađene",
        "inProcess": "U obradi"
      },
      eInvoiceOverview:{
        "listOfEinvoices":"Lista eRačuna",
        "eInvoicesToPay":"eRačuni za platiti",
        "register":"Registracija eRačuna",
        "pay":"Plati",
        "success":"Uspješno!",
        "archivedEinvoces":"Arhivirani eRačuni",
        "successfulyArchived": "Uspješno ste arhivirali eRačun",
        "copy": "Kopiraj nalog",
        "inProgress": "U obradi"
      },
      eInvoicePayment: {
        "recAccount":"Račun primatelja",
        "purpose":"Svrha",
        "accNumber":"Broj računa",
        "toPayee":"Primatelj",
        "recAddress":"Adresa primatelja",
        "recPostalCity":"Poštanski kod i grad primatelja"
      },
      eInvoiceStatus:{
        "InProcess":"U obradi",
        "Unregistered":"Otkazana",
        "Registered":"Obrađena",
        "Rejected":"Odbijena"
      }
    };

    $translateProvider
      .translations('hr', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      eInvoicesModal: {
        "headerLabel": "eInvoice Payment",
        "instructionLabel": "Select payment date and confirm payment",
        "issuerLabel": "Issuer",
        "purposeLabel": "Purpose",
        "amountLabel": "Amount",
        "refNumberLabel": "Reference number",
        "paymentDateLabel": "Payment date",
        "today": "Today",
        "dueDate": "Due date",
        "otherDate": "Other date",
        "btnCancel": "Cancel",
        "btnPay": "Pay",
        "subscribeOrCancel": "Subscribe to a new eInvoice or cancel an existing subscription",
        "submitted": "Your submitted applications",
        "showIssued": "Show eInvoices issued in ",
        "showAuthorizedEinvoices": "Show eInvoices on authorized accounts",
        "waitingForPayment": "Unpaid eInvoices",
        "waitingForPaymentSlo": "Received eInvoices",
        "payedAndRemoved": "Payed and removed eInvoices",
        "loadMoreEinvoices":"Load more eInvoices",
        "loadMoreRegistrationsDeregistrations": "Load more",
        "einvoices": "eInvoices",
        "einvoicesSlo": "eInvoices and other eDocuments",
        "view": "View",
        "pay": "Pay",
        "noData": "No eInvoices data for selected period",
        "fromAccountPayLabel": "Pay from account: ",
        "availableAmountLabel": "Available amount: ",
        "viewEinvoice": "View eInvoice",
        "amountPlaceholder": "eg. 1,000.00",
        "btnSign": "Sign",
        "btnEdit": "Edit",
        "signHeaderLabel": "Verify eInvoice and sign",
        "fromAccount": "From account",
        "toAccount": "To account",
        "receiver": "Recipient",
        "receiverAddress": "Recipient's address",
        "amount": "Amount",
        "description": "Description",
        "status": "Status",
        "bankName": "Bank name",
        "bankAddress": "Bank address",
        "enterComment": "Enter comment",
        "delete": "Delete",
        "edit": "Edit",
        "sign": "Sign",
        "listOfRegistrations":"List of registrations and deregistrations",
        "processedTab": "Paid and other e-invoices",
        "processedTabSlo": "Paid and other eDocuments",
        "processed": "Processed",
        "archived": "Archived",
        "rejected": "Rejected",
        "noAvailableEInvoices": "No eInvoices data available",
        "creditorNameSearch": "Search by creditor name",
        "issuerIban":"Issuer IBAN",
        "issuerAddress":"Issuer address",
        "requestType":"Request type",
        "gsm":"Your GSM number",
        "subscribe":"Register",
        "unsubscribe":"Deregister",
        "paymentNotPossible": "Payment not possible",
        "paidByOtherMeans": "Paid by other means",
        "paymentWithDirectDebit": "Payment with direct debit",
        "withdrawn": "Withdrawn",
        "inProgressByOther": "Processing for another user",
        "msg1":"Are you sure you want to remove the selected e-invoice between paid and other e-invoices ?",
        "msg2":"Payment of e-invoice via Addiko EBank after the withdrawal will no longer be possible.",
        "cancel":"Cancel",
        "confirm":"Confirm",
        eDocumentType: {
          'eInvoice': 'eInvoice',
          'eProforma':'eProforma',
          'eWarning':'eWarning',
          'eCreditNote':'eCreditNote',
          'eDebitNote':'eDebitNote',
          'ePurchaseOrder':'ePurchaseOrder',
          'eDeliveryNote':'eDeliveryNote'
        },
        rejectDocumentAlert: {
          headerText: 'Would you like to reject selected document?',
          labelText: 'Please, write a short explanation for the rejection, that will be sent to the document issuer.'
        }
      },
      eInvoiceDetail: {
        "attachments": "Attachments",
        "eInvoicePDF": "eInvoice in PDF",
        "eInvoiceXML": "eInvoice in XML",
        "export": "Export",
        "unsubscribeEInvoices": "Unsubscribe from this eInvoice",
        "detail": "eInvoices details",
        "unpaidInvoice": "Unpaid invoice",
        "pay": "Pay",
        "markAsPayed": "Mark as payed/archive",
        "issuer": "Issuer",
        "issuerAccount": "Issuer account",
        "purpose": "Purpose",
        "refNumber": "Reference number",
        "amount": "Amount",
        "issueDate": "Issue date",
        "purposeCode": "Purpose code",
        "dueDate": "Due date",
        "digitalSignature": "Digital signature status",
        "visibilityDigitalSignature": "Digital signature information",
        "signatureId": "Signature ID",
        "digitalCertNumber": "Digital certificate number",
        "signatureName": "Signature name",
        "certificateIssuer": "Digital certificate issuer",
        "showInfo": "Show ",
        "hideInfo": "Hide ",
        "recipient": "Recipient",
        "recipientAccount": "Recipient account",
        "noAttachments": "eInvoice has no attachments.",
        "noDocAttachments": "eDocument has no attachments.",
        "goBack": "Go back to eInvoices",
        "issueDateOfEinvoice":"Issue date of eInvoice",
        "paymentDesc":"Payment description",
        "archive":"Archive",
        "showDigStatus":"Show digital signature status",
        "issuerIBAN":"Issuer IBAN",
        "placeOfReg":"Place of registration",
        "dateOfReg":"Registration/Deregistration date",
        "cancelReg":"Cancel registration",
        "cancel":"Cancel",
        "regAgain":"Register again",
        "regAgainSlo":"Register/Deregister again",
        "rejectReason":"Reject reason",
        "inProcess":"InProcess",
        "rejected":"Rejected",
        "registered":"Registered",
        "unregistered":"Unregistered",
        "activeRegs":"Active registrations",
        "cancelledRegs":"Cancelled registrations",
        "noteArchived": "Comment",
        "noteRejected": "Comment",
        "serviceName": "Service name",
        "download": "Download",
        "orderType": "Order type",
        "registration": "Registration",
        "deregistration": "Deregistration",
        "withdraw":"Withdraw",
        "valid": "Valid",
        "invalid": "Invalid",
        "otherInfo": "Other information",
        "statusOfEApplication": "Status of E-invoice",
        "statusOfEApplicationOpomina": "Status E-warning",
        "statusOfEApplicationPredracun": "Status E-proforma",
        "paymentId": "Payment ID"

      },
      eInvoicesIssuersOverview: {
        "submittedApplications": "Your submitted applications",
        "header": "Select eInvoice issuer",
        "issuerName": "Issuer name",
        "issuerTaxId": "Issuer tax ID",
        "searchByNamePlaceholder": "Search by name",
        "searchByTaxIdPlaceholder": "Search by tax ID",
        "showMore": "Show more issuers",
        "subscribe": "Subscribe",
        "issuerTax": "Tax ID / Account",
        "issuerAddress": "Issuer address",
        "noData": "No eInvoices issuers data for selected period"

      },
      eInvoicesSubscribe: {
        "goBack": "Go back to previous page",
        "subscribeToEinvoice": "Subscribe to eInvoice",
        "einvoiceIssuer": "eInvoice issuer",
        "einvoiceIssuerSlo": "Issuer tax number - Issuer name",
        "issuerAddress": "Issuer address",
        "issuerAccount": "Issuer account",
        "referenceFromIssuer": "Reference from issuer",
        "einvoiceReceiver": "eInvoice receiver",
        "receiversName": "Receivers name",
        "receiversAddress": "Receivers address",
        "receiversTaxId": "Receivers Tax ID",
        "yourContactEmail": "Your contact email",
        "tooltipInfo": "Need help?",
        "tooltipInfoEmail": "If you are changing the email address - the change will be applied only to the registration of eInvoice service.",
        "einvoiceReferenceFromIssuerInputError": "Reference number is required!",
        "einvoiceSubscribeEmailInputError": "Your contact email is required!",
        "einvoiceIssuerInputError": "Issuer is required!",
        "reviewandSubmit": "Review and submit",
        "changeEmail": "Change email",
        "updateEmail": "Update email",
        "cancel": "Cancel",
        "ok": "OK",
        "statement":"Statement",
        "termsAndConditions": "I agree not to receive the invoices in paper form",
        "termsAndConditionsSlo": "With the electronic submission of my application I am confirming that I am familiar with the above stated General Terms and Conditions.",
        "statementTitle":"General Terms and Conditions of the Bank",
        "statementText":"I accept the ",
        "statementTextLink1":"General Terms and Conditions for Managing the Transaction Account for Private Individuals and Provision of Payment Services ",
        "statementTextAnd":"and ",
        "statementTextLink2":"Addiko EBank Terms and Conditions",
        "statementTextEnd":"",
        "specialConditions": "I accept special terms of the issuer",
        "newRegistration": "New eInvoice registration/deregistration",
        "registrationNew": "New registration",
        "register": "Register",
        "email": "E-mail",
        "applicationComplete": "Application complete",
        "applicationCompleteText": "You have successfully sent the eInvoice application for the issuer {{name}}.",
        "applicationCompleteTextSlo": "Application for e-Invoice registration/deregistration was successfully submitted for the issuer {{name}}.",
        "selectIssuer": "Select issuer",
        "goToList": "Go to eInvoice list",
        "goToListSlo": "Go To List of Registration",
        "generalTerms": "I accept the general terms and conditions",
        "referenceExplanation":"Check issuers explanations of entering reference",
        "statementTitle2":"General Terms and Conditions of the Issuer",
        "statementText2":"General terms are published on our web page"

      },
      eInvoiceRegistration: {
        "all": "All",
        listOfRegistrations: "List of registrations and deregistrations",
        "unregistered": "Unregistered",
        "Unregistered": "Unregistered",
        "rejected": "Rejected",
        "Rejected": "Rejected",
        "rejectedSlo": "Rejected",
        "registered": "Registered",
        "Registered": "Registered",
        "inProcess": "In process",
        "InProcess":"Submitted",
        "inProcessSlo": "Submitted",
        "sent":"Sent",
        "Sent":"Sent",
        "undelivered":"Undelivered",
        "Undelivered":"Undelivered",
        "Delivered":"Delivered",
        "delivered":"Delivered"
      },
      eInvoiceOverview:{
        "listOfEinvoices":"List of eInvoices",
        "eInvoicesToPay":"eInvoices to pay",
        "register":"Register/Deregister issuer",
        "pay":"Pay",
        "success":"Success!",
        "archivedEinvoces":"Archived eInvoices",
        "successfulyArchived": "You have successfuly archived eInvoice",
        "copy": "Copy payment",
        "inProgress": "In progress",
        "documentsTab": "eDocuments",
        "reject": "Reject"
      },
      eInvoicePayment: {
        "recAccount":"Recipient account",
        "purpose":"Purpose",
        "accNumber":"Account number",
        "toPayee":"To recipient",
        "recAddress":"Recipient's address",
        "recPostalCity":"Recipient's postal code and city"
      },
      eInvoiceStatus: {
        "InProcess":"In process",
        "Unregistered":"Unregistered",
        "Registered":"Registered",
        "Rejected":"Rejected",
        "Undelivered":"Undelivered",
        "Delivered":"Delivered",
        "Sent":"Sent",
        "InProgress": "In progress",
        "Inserted":"Inserted",
        "Processed": "Processed",
        "Archived": "Archived",
        "PaymentNotPossible": "Payment not possible",
        "PaidByOtherMeans": "Paid by other means",
        "PaymentWithDirectDebit": "Payment with direct debit",
        "Withdrawn": "Withdrawn",
        "InProgressByOther": "Processing for another user",
        "Reviewed": "Reviewed",
        "Cancelled": "Payment cancelled"
      }
    };

    $translateProvider
      .translations('en', data);
  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
          documents: {
            "header": "Prejeti dokumenti",
            "loadEvents": "Prikaži več dokumentov",
            "noItemData": "Ni podatkov za prikaz",
            "download": "Prenesi",
            "titleModalInfo":"Dokument trenutno ni na voljo",
            "messageModalInfo":"Izbrani dokument trenutno ni na voljo. Prosimo, poskusite kasneje ali pa se obrnite na našo pomoč uporabnikom.",
            "closeModalInfo":"Zapri",
            "documentDownloadFailed": "Izbrani dokument trenutno ni na voljo. Prosimo, poskusite kasneje ali pa se obrnite na našo pomoč uporabnikom."
          }
        };

        $translateProvider
            .translations('sl', data);
    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      documents: {
        "header": "Received documents",
        "loadEvents": "Load more",
        "noItemData": "No data",
        "download": "Download",
        "titleModalInfo":"Document is currently un available",
        "messageModalInfo":"This document is currently unavailable. Please try later or contact our customer helpdesk.",
        "closeModalInfo":"Close",
        "documentDownloadFailed": "This document is currently unavailable. Please try later or contact our customer helpdesk."
      }

    };

    $translateProvider
      .translations('en', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      dashboard: {
        "dashboardHeader": "Početna strana",
        "addNewWidget1": "Označite",
        "addNewWidget2": "Favorite",
        "pendingPayments": "Nalozi na čekanju",
        "show": "Prikaži",
        "hide": "Sakrij",
        "domesticPaymentBtn1": "Nalog za",
        "domesticPaymentBtn2": "plaćanje",
        "transferBtn1": "Prenos na",
        "transferBtn2": "moj račun",
        "templateBtn1": "Plaćanje iz",
        "templateBtn2": "šablona",
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayment": "Kreiraj opći nalog",
        "internalTransfer": "Kreiraj nalog za prenos",
        "payTemplate": "Plati predložak",
        "searchTemplatesPlaceholder": "Pretraži šablone",
        "showAccounts": "Prikaži još računa",
        "instantLoan": "Brzi kredit",
        "instantLoanDescription": "Da li ste znali da se možete prijaviti za brzi unaprijed odobreni novčani kredit do 10.000,00 RSD",
        "apply": "Prijava",
        "contact": "Kontaktirajte nas",
        "hypoClub": "Addiko Club",
        "etrade": "E-Trade",
        "branch": "Pronađite poslovnicu",
        "bankTimeline": "Vremenski prikaz Vašeg poslovanja",
        "loadEvents": "Učitaj starije događaje",
        "noTimelineData": "Za odabrani period nema podataka za prikaz",
        "availableBalance": "Raspoloživo stanje",
        "loanAmount":"Iznos kredita",
        "confirmation": "Potvrda",
        "complaint": "Reklamacija",
        "cashLoan": "Keš kredit",
        "approval": "odobrenje za 1 sat"
      },
      timelineFilter: {
        "placeholder": "Pretraga i filtriranje",
        "all": "Svi",
        "credit": "Uplate",
        "debit": "Isplate",
        "others": "Ostali",
        "amountFrom": "Iznos od",
        "amountTo": "Do",
        "reset": "Poništi",
        "apply": "Primeni"
      },
      header: {
        "dashboard": "Početna strana",
        "accounts": "Računi i kartice",
        "payments": "Plaćanja",
        "orders": "Narudžbe",
        "branches": "Poslovnice i bankomati",
        "settings": "Postavke",
        "notificationMessages": "Poruke",
        "notificationMessagesPlaceholder": "Napišite vaš odgovor",
        "notificationMessagesPlaceholderSubject": "Naslov poruke",
        "notificationMessagesUnread": "Nepročitana",
        "notificationMessagesMarkAsRead": "Označi kao pročitanu",
        "notificationMessagesReply": "Odgovori",
        "notificationMessagesSend": "Pošalji",
        "notificationMessagesCancelSend": "Odustani",
        "notificationMessagesViewAll": "Pregled svih poruka",
        "notificationEInvoices": "Novi eRačuni",
        "notificationEInvoicesDueDate": "datum naplate",
        "notificationEInvoicesPay": "Plati",
        "notificationEInvoicesViewAll": "Pregled svih eRačuna",
        "notificationPendingPayments": "Plaćanja u obradi",
        "notificationPendingPaymentsViewAll": "Pregled svih plaćanja",
        "notificationPendingPaymentsDateLabel": "datum",
        "notificationRejectedPayments": "Odbijena plaćanja",
        "notificationRejectedPaymentsViewAll": "Pregled svih plaćanja",
        "notificationRejectedPaymentsDateLabel": "datum",
        "notificationSettingsLangLabel": "Odaberite jezik:",
        "notificationSettingsViewAllLabel": "Otvorite postavke aplikacije",
        "signedInAs": "Prijavljeni korisnik",
        "lastLogin": "Datum zadnje prijave: ",
        "logout": "Odjava",
        "langEn": "Engleski",
        "langHr": "Hrvatski",
        "langSr": "Srpski",
        "langMtr": "Crnogorski",
        "langBa": "Lokalni",
        "langSl": "Slovenački",
        "langDe": "Njemački",
        "langRu": "Ruski",
        "noMessages": "Nema poruka",
        "noeInvoices": "Nema eRačuna",
        "noPendingPayments": "Nema uplata na čekanju",
        "noRejectedPayments": "Nema odbačenih uplata"
      },
      footer: {
        "freeCall": "Besplatni poziv",
        "internationalCall": "Internacionalni poziv",
        "email": "Pošaljite nam e-mail",
        "notificationDepth": "Dubinska analiza",
        "dearClients": "Poštovani,",
        "modalText1": "dozvolite da Vas informiramo o važnosti ažuriranja Vaših osobnih podataka kako bi se poslovni odnos i nadalje uspješno nastavio.",
        "modalText2": "Podaci kao što su broj i datum valjanosti osobnog identifikacijskog dokumenta (osobna iskaznica, putovnica, dozvola boravka u RH) potrebno je ažurirati u Vama najbližoj poslovnici Banke po isteku njihovog datuma važenja, a sve u skladu s čl.7., Općih uvjeta Addiko Bank d.d.",
        "modalText3": "U svrhu ispravne identifikacije te nužnog ažuriranja Vašeg identifikacijskog dokumenta bit ćemo slobodni obavijestiti Vas o navedenom putem dopisa poslanom na kućnu adresu i/ili porukom proslijeđenom kanalima direktnog bankarstva.",
        "regards": "Srdačan pozdrav",
        "closeButton": "Zatvori",
        "version":"Verzija",
        "server":"Server"
      },
      timeline: {
        msgWith: "Message with subject ",
        msgWithout: "message without subject ",
        msgReceived: " was received on ",
        msgSent: " was sent on "
      },
      templateSearch: {
        favorites: "Favoriti",
        templatesList: "Šabloni"
      },
      dashboardWidgets: {
        current: "Tekući računi i kartice",
        loan: "Krediti",
        deposit: "Štednja",
        savings: "Štedni računi",
        giro: "Žiro računi",
        addBtn: "Potvrdi"
      },
      dashboardNotification: {
        rejected: "odbijenih naloga",
        einvoice: "neplaćenih eRačuna",
        group: "grupnih naloga za potpisati",
        goBtn: "Idi na plaćanja",
        unsigned: "Nepotpisanih naloga"
      }
    };

    $translateProvider
      .translations('sr', data);
  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            dashboard: {
                "dashboardHeader": "Prva stran",
                "addNewWidget1": "Dodaj",
                "addNewWidget2": "Priljubljeni računi",
                "pendingPayments": "Čakalna vrsta plačil",
                "show": "Prikaži",
                "hide": "Skrij",
                "domesticPaymentBtn1": "UPN",
                "domesticPaymentBtn2": "nalog",
                "transferBtn1": "Prenos na",
                "transferBtn2": "moj račun",
                "templateBtn1": "Plačilo iz",
                "templateBtn2": "predloge",
                "quickPaymentTransfer": "Prenos med računi",
                "domesticPayment": "Nov UPN nalog",
                "internalTransfer": "Nov prenos",
                "payTemplate": "Plačilo po predlogi",
                "searchTemplatesPlaceholder": "Išči predlogo",
                "showAccounts": "Prikaži več računov",
                "instantLoan": "Hitri kredit",
                "instantLoanDescription": "Kredit je lahko enostaven. Dali vam bomo jasna navodila o mesečnih obrokih.",
                "apply": "Info",
                "contact": "Kontaktirajte nas",
                "hypoClub": "Addiko Klub",
                "etrade": "Addiko Broker",
                "branch": "Iskanje poslovalnice",
                "bankTimeline": "Časovnica",
                "loadEvents": "Prikaži več",
                "noTimelineData": "Za izbrano obdobje ni podatkov za prikaz",
                "availableBalance": "Razpoložljivo stanje",
                "loanAmount": "Znesek kredita",
                "confirmation": "Potrdilo",
                "complaint": "Reklamacija",
                "cashLoan": "Gotovinski kredit",
                "approval": "odobrenje za 1 leto",
                "loyaltyPointsLbl": "Addiko klub",
                "loyaltyCurrentPoints": "Točke tekočega obdobja",
                "loyaltyPreviousPoints": "Točke preteklega obdobja"
            },
            timelineFilter: {
                "placeholder": "Iskanje ali filtriranje",
                "all": "Vse",
                "credit": "Prejemki",
                "debit": "Izdatki",
                "others": "Ostalo",
                "amountFrom": "Znesek od",
                "amountTo": "Do",
                "reset": "Počisti",
                "apply": "Potrdi"
            },
            header: {
                "dashboard": "Prva stran",
                "accounts": "Računi in kartice",
                "payments": "Plačila",
                "orders": "Naročila",
                "branches": "Poslovalnice in bankomati",
                "settings": "Nastavitve",
                "notificationMessages": "Sporočila",
                "notificationMessagesPlaceholder": "Napišite vaš odgovor",
                "notificationMessagesPlaceholderSubject": "Naslov sporočila",
                "notificationMessagesUnread": "Neprebrana",
                "notificationMessagesMarkAsRead": "Označi kot prebrano",
                "notificationMessagesReply": "Odgovori",
                "notificationMessagesSend": "Pošlji",
                "notificationMessagesCancelSend": "Prekliči",
                "notificationMessagesViewAll": "Pregled vseh sporočil",
                "notificationEInvoices": "Novi eRačuni",
                "notificationEInvoicesDueDate": "datum plačila",
                "notificationEInvoicesPay": "Plačaj",
                "notificationEInvoicesViewAll": "Pregled vseh eRačunov",
                "notificationPendingPayments": "Plačila v izvedbi",
                "notificationPendingPaymentsViewAll": "Pregled vseh plačil",
                "notificationPendingPaymentsDateLabel": "datum",
                "notificationRejectedPayments": "Zavrnjena plačila",
                "notificationRejectedPaymentsViewAll": "Pregled vseh plačil",
                "notificationRejectedPaymentsDateLabel": "datum",
                "notificationSettingsLangLabel": "Izberite jezik:",
                "notificationSettingsViewAllLabel": "Prikaži vse",
                "signedInAs": "Prijavljeni kot",
                "lastLogin": "Datum zadnje prijave: ",
                "logout": "Odjava",
                "langEn": "English",
                "langHr": "Hrvatski",
                "langSr": "Srpski",
                "langMtr": "Crnogorski",
                "langBa": "Lokalni",
                "langSl": "Slovensko",
                "langDe": "Deutsch",
                "langRu": "Ruski",
                "noMessages": "Ni sporočil",
                "noeInvoices": "Ni eRačunov",
                "noPendingPayments": "Ni čakajočih plačil",
                "noRejectedPayments": "Ni zavrnjenih plačil"
            },
            footer: {
                "freeCall": "Telefonska številka",
                "internationalCall": "Mednarodni klic",
                "email": "Pošljite nam e-pošto",
                "notificationDepth": "Poglobljena analiza",
                "dearClients": "",
                "modalText1": "",
                "modalText2": "",
                "modalText3": "",
                "regards": "",
                "closeButton": "Zapri",
                "version": "Verzija",
                "server": "Server"
            },
            timeline: {
                msgWith: "Sporočilo z naslovom ",
                msgWithout: "Sporočilo brez naslova ",
                msgReceived: " je bilo prejeto ",
                msgSent: " je bilo poslano "
            },
            templateSearch: {
                favorites: "Priljubljene predloge",
                templatesList: "Seznam predlog"
            },
            dashboardWidgets: {
                current: "Osebni računi in kartice",
                loan: "Krediti",
                deposit: "Depoziti",
                savings: "Varčevanja",
                savingsTransactions: "Varčevanja",
                giro: "Žiro računi",
                addBtn: "Potrdi"
            },
            dashboardNotification: {
                rejected: "novih zavrnjenih plačil",
                einvoiceSlo: "novih prejetih eRačunov",
                group: "skupinskih nalogov za podpis",
                goBtn: "Pojdi na plačila",
                unsigned: "nalogov v čakalni vrsti",
                pending: "nalogov v čakalni vrsti"
            }
        };

        $translateProvider
            .translations('sl', data);
    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      dashboard: {
        "dashboardHeader": "Početna strana",
        "addNewWidget1": "Označite",
        "addNewWidget2": "Favorite",
        "pendingPayments": "Nalozi na čekanju",
        "show": "Prikaži",
        "hide": "Sakrij",
        "domesticPaymentBtn1": "Nalog za",
        "domesticPaymentBtn2": "plaćanje",
        "transferBtn1": "Prenos na",
        "transferBtn2": "moj račun",
        "templateBtn1": "Plaćanje iz",
        "templateBtn2": "Šablona",
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayment": "Kreiraj opći nalog",
        "internalTransfer": "Kreiraj nalog za prenos",
        "payTemplate": "Plati predložak",
        "searchTemplatesPlaceholder": "Pretraži šablone",
        "showAccounts": "Prikaži još računa",
        "instantLoan": "Brzi kredit",
        "instantLoanDescription": "Da li ste znali da se možete prijaviti za brzi unaprijed odobreni novčani kredit do 10.000,00 RSD",
        "apply": "Prijava",
        "applyMne":"Upoznajte nas",
        "contact": "Kontaktirajte nas",
        "hypoClub": "Addiko Club",
        "etrade": "E-Trade",
        "branch": "Pronađite poslovnicu",
        "bankTimeline": "Vremenski prikaz Vašeg poslovanja",
        "loadEvents": "Učitaj starije događaje",
        "noTimelineData": "Za odabrani period nema podataka za prikaz",
        "availableBalance": "Raspoloživo stanje",
        "loanAmount": "Iznos kredita",
        "confirmation": "Potvrda",
        "complaint": "Reklamacija",
        "cashLoan": "Keš kredit",
        "approval": "odobrenje za 1 sat"
      },
      timelineFilter: {
        "placeholder": "Pretraga i filtriranje",
        "all": "Svi",
        "credit": "Uplate",
        "debit": "Isplate",
        "others": "Ostali",
        "amountFrom": "Iznos od",
        "amountTo": "Do",
        "reset": "Poništi",
        "apply": "Primijeni"
      },
      header: {
        "dashboard": "Početna strana",
        "accounts": "Računi i kartice",
        "payments": "Plaćanja",
        "orders": "Narudžbe",
        "branches": "Poslovnice i bankomati",
        "settings": "Postavke",
        "notificationMessages": "Poruke",
        "notificationMessagesPlaceholder": "Napišite vaš odgovor",
        "notificationMessagesPlaceholderSubject": "Naslov poruke",
        "notificationMessagesUnread": "Nepročitana",
        "notificationMessagesMarkAsRead": "Označi kao pročitanu",
        "notificationMessagesReply": "Odgovori",
        "notificationMessagesSend": "Pošalji",
        "notificationMessagesCancelSend": "Odustani",
        "notificationMessagesViewAll": "Pregled svih poruka",
        "notificationEInvoices": "Novi eRačuni",
        "notificationEInvoicesDueDate": "datum naplate",
        "notificationEInvoicesPay": "Plati",
        "notificationEInvoicesViewAll": "Pregled svih eRačuna",
        "notificationPendingPayments": "Plaćanja u obradi",
        "notificationPendingPaymentsViewAll": "Pregled svih plaćanja",
        "notificationPendingPaymentsDateLabel": "datum",
        "notificationRejectedPayments": "Odbijena plaćanja",
        "notificationRejectedPaymentsViewAll": "Pregled svih plaćanja",
        "notificationRejectedPaymentsDateLabel": "datum",
        "notificationSettingsLangLabel": "Odaberite jezik:",
        "notificationSettingsViewAllLabel": "Otvorite postavke aplikacije",
        "signedInAs": "Prijavljeni korisnik",
        "lastLogin": "Datum zadnje prijave: ",
        "logout": "Odjava",
        "langEn": "Engleski",
        "langHr": "Hrvatski",
        "langSr": "Srpski",
        "langMtr": "Crnogorski",
        "langBa": "Lokalni",
        "langSl": "Slovenački",
        "langDe": "Njemački",
        "langRu": "Ruski",
        "noMessages": "Nema poruka",
        "noeInvoices": "Nema eRačuna",
        "noPendingPayments": "Nema uplata na čekanju",
        "noRejectedPayments": "Nema odbačenih uplata"
      },
      footer: {
        "freeCall": "Kontakt telefon",
        "internationalCall": "Internacionalni poziv",
        "email": "E-mail",
        "notificationDepth": "Dubinska analiza",
        "dearClients": "Poštovani,",
        "modalText1": "dozvolite da Vas informiramo o važnosti ažuriranja Vaših osobnih podataka kako bi se poslovni odnos i nadalje uspješno nastavio.",
        "modalText2": "Podaci kao što su broj i datum valjanosti osobnog identifikacijskog dokumenta (osobna iskaznica, putovnica, dozvola boravka u RH) potrebno je ažurirati u Vama najbližoj poslovnici Banke po isteku njihovog datuma važenja, a sve u skladu s čl.7., Općih uvjeta Addiko Bank d.d.",
        "modalText3": "U svrhu ispravne identifikacije te nužnog ažuriranja Vašeg identifikacijskog dokumenta bit ćemo slobodni obavijestiti Vas o navedenom putem dopisa poslanom na kućnu adresu i/ili porukom proslijeđenom kanalima direktnog bankarstva.",
        "regards": "Srdačan pozdrav",
        "closeButton": "Zatvori",
        "version":"Verzija",
        "server":"Server"
      },
      timeline: {
        msgWith: "Message with subject ",
        msgWithout: "message without subject ",
        msgReceived: " was received on ",
        msgSent: " was sent on "
      },
      templateSearch: {
        favorites: "Favoriti",
        templatesList: "Lista šablona"
      },
      dashboardWidgets: {
        current: "Tekući računi i kartice",
        loan: "Krediti",
        deposit: "Štednja",
        savings: "Štednja",
        savingsTransactions: "Transakcioni štedni računi",
        giro: "Žiro računi",
        addBtn: "Potvrdi"
      },
      dashboardNotification: {
        rejected: "odbijenih naloga",
        einvoice: "neplaćenih eRačuna",
        group: "grupnih naloga za potpisati",
        goBtn: "Idi na plaćanja",
        unsigned: "naloga za potpisivanje"
      }
    };

    $translateProvider
      .translations('mne', data);
  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      dashboard: {
        "dashboardHeader": "Početna strana",
        "addNewWidget1": "Označite",
        "addNewWidget2": "Favorite",
        "pendingPayments": "Nalozi na čekanju",
        "show": "Prikaži",
        "hide": "Sakrij",
        "domesticPaymentBtn1": "Opći",
        "domesticPaymentBtn2": "nalog",
        "transferBtn1": "Prijenos na",
        "transferBtn2": "moj račun",
        "templateBtn1": "Plaćanje iz",
        "templateBtn2": "predloška",
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayment": "Kreiraj opći nalog",
        "internalTransfer": "Kreiraj nalog za prijenos",
        "payTemplate": "Plati predložak",
        "searchTemplatesPlaceholder": "Pretraži predloške",
        "showAccounts": "Prikaži još računa",
        "instantLoan": "Brzi kredit",
        "instantLoanDescription": "Da li ste znali da se možete prijaviti za brzi unaprijed odobreni novčani kredit do 10.000,00 RSD",
        "apply": "Info",
        "contact": "Kontaktirajte nas",
        "hypoClub": "Addiko Club",
        "etrade": "E-Trade",
        "branch": "Pronađite poslovnicu",
        "bankTimeline": "Vremenski prikaz Vašeg poslovanja",
        "loadEvents": "Povijest poslovanja/Povijest događaja",
        "noTimelineData": "Za odabrani period nema podataka za prikaz",
        "availableBalance": "Raspoloživo stanje",
        "loanAmount": "Iznos kredita",
        "confirmation": "Potvrda",
        "complaint": "Reklamacija",
        "cashLoan": "Blic gotovinski kredit.",
        "approval": "Samo uz osobnu iskaznicu."
      },
      timelineFilter: {
        "placeholder": "Pretraga i filtriranje",
        "all": "Svi",
        "credit": "Uplate",
        "debit": "Isplate",
        "others": "Ostali",
        "amountFrom": "Iznos od",
        "amountTo": "Do",
        "reset": "Poništi",
        "apply": "Primijeni"
      },
      header: {
        "dashboard": "Kontrolna ploča",
        "accounts": "Računi i kartice",
        "payments": "Plaćanja",
        "orders": "Narudžbe",
        "branches": "Poslovnice i bankomati",
        "settings": "Postavke",
        "notificationMessages": "Poruke",
        "notificationMessagesPlaceholder": "Napišite vaš odgovor",
        "notificationMessagesPlaceholderSubject": "Naslov poruke",
        "notificationMessagesUnread": "Nepročitana",
        "notificationMessagesMarkAsRead": "Označi kao pročitanu",
        "notificationMessagesReply": "Odgovori",
        "notificationMessagesSend": "Pošalji",
        "notificationMessagesCancelSend": "Odustani",
        "notificationMessagesViewAll": "Pregled svih poruka",
        "notificationEInvoices": "Novi eRačuni",
        "notificationEInvoicesDueDate": "datum naplate",
        "notificationEInvoicesPay": "Plati",
        "notificationEInvoicesViewAll": "Pregled svih eRačuna",
        "notificationPendingPayments": "Plaćanja u obradi",
        "notificationPendingPaymentsViewAll": "Pregled svih plaćanja",
        "notificationPendingPaymentsDateLabel": "datum",
        "notificationRejectedPayments": "Odbijena plaćanja",
        "notificationRejectedPaymentsViewAll": "Pregled svih plaćanja",
        "notificationRejectedPaymentsDateLabel": "datum",
        "notificationSettingsLangLabel": "Odaberite jezik:",
        "notificationSettingsViewAllLabel": "Otvorite postavke aplikacije",
        "signedInAs": "Prijavljeni korisnik",
        "lastLogin": "Datum zadnje prijave: ",
        "logout": "Odjava",
        "langEn": "Engleski",
        "langHr": "Hrvatski",
        "langSr": "Srpski",
        "langMtr": "Crnogorski",
        "langBa": "Lokalni",
        "langSl": "Slovenački",
        "langDe": "Njemački",
        "langRu": "Ruski",
        "noMessages": "Nema poruka",
        "noeInvoices": "Nema eRačuna",
        "noPendingPayments": "Nema uplata na čekanju",
        "noRejectedPayments": "Nema odbačenih uplata"
      },
      footer: {
        "freeCall": "Besplatni poziv",
        "internationalCall": "Internacionalni poziv",
        "email": "Pošaljite nam e-mail",
        "notificationDepth": "Dubinska analiza",
        "dearClients": "Poštovani,",
        "modalText1": "dozvolite da Vas informiramo o važnosti ažuriranja Vaših osobnih podataka kako bi se poslovni odnos i nadalje uspješno nastavio.",
        "modalText2": "Podaci kao što su broj i datum valjanosti osobnog identifikacijskog dokumenta (osobna iskaznica, putovnica, dozvola boravka u RH) potrebno je ažurirati u Vama najbližoj poslovnici Banke po isteku njihovog datuma važenja, a sve u skladu s čl.7., Općih uvjeta Addiko Bank d.d.",
        "modalText3": "U svrhu ispravne identifikacije te nužnog ažuriranja Vašeg identifikacijskog dokumenta bit ćemo slobodni obavijestiti Vas o navedenom putem dopisa poslanom na kućnu adresu i/ili porukom proslijeđenom kanalima direktnog bankarstva.",
        "regards": "Srdačan pozdrav",
        "closeButton": "Zatvori",
        "version":"Verzija",
        "server":"Server"
      },
      timeline: {
        msgWith: "Message with subject ",
        msgWithout: "message without subject ",
        msgReceived: " was received on ",
        msgSent: " was sent on "
      },
      templateSearch: {
        favorites: "Favoriti",
        templatesList: "Lista predložaka"
      },
      dashboardWidgets: {
        current: "Tekući računi i kartice",
        loan: "Kreditni računi",
        deposit: "Depozitni računi",
        savings: "Štedni računi",
        giro: "Žiro računi",
        addBtn: "Potvrdi"
      },
      dashboardNotification: {
        rejected: "odbijenih naloga",
        einvoice: "neplaćenih eRačuna",
        group: "grupnih naloga za potpisati",
        goBtn: "Idi na plaćanja",
        unsigned: "naloga za potpisati"
      }
    };

    $translateProvider
      .translations('hr', data);
  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            dashboard: {
                "dashboardHeader": "Dashboard",
                "addNewWidget1": "Add new",
                "addNewWidget2": "Widget",
                "pendingPayments": "Pending payments",
                "show": "Show",
                "hide": "Hide",
                "domesticPaymentBtn1": "Universal payment",
                "domesticPaymentBtn2": "order",
                "transferBtn1": "Transfer to",
                "transferBtn2": "my account",
                "templateBtn1": "Payment from",
                "templateBtn2": "template",
                "quickPaymentTransfer": "Quick payment or transfer",
                "domesticPayment": "Make a Universal payment order",
                "internalTransfer": "Make an internal transfer",
                "payTemplate": "Pay template",
                "searchTemplatesPlaceholder": "Search templates",
                "showAccounts": "Show more accounts",
                "instantLoan": "Instant loan",
                "instantLoanDescription": "Did you know you can apply for an instant pre approved cash loan up to 10.000,00 RSD",
                "apply": "Apply now",
                "applyMne": "Upoznajte nas",
                "contact": "Contact us",
                "hypoClub": "HYPO Club",
                "etrade": "E-Trade",
                "branch": "Find a branch",
                "bankTimeline": "Activity across all of your accounts",
                "loadEvents": "Load more",
                "noTimelineData": "No timeline data for selected period",
                "availableBalance": "Available balance",
                "loanAmount": "Loan amount",
                "confirmation": "Confirmation",
                "complaint": "Complaint",
                "cashLoan": "Blic cash loan.",
                "approval": "Just one visit to the bank.",
                "loyaltyPointsLbl": "Addiko club",
                "loyaltyCurrentPoints": "Current points",
                "loyaltyPreviousPoints": "Previous points"
            },
            timelineFilter: {
                "placeholder": "Search and filtration",
                "all": "All",
                "credit": "Credit",
                "debit": "Debit",
                "others": "Others",
                "amountFrom": "Amount range from",
                "amountTo": "To",
                "reset": "Reset",
                "apply": "Apply"
            },
            header: {
                "dashboard": "Dashboard",
                "accounts": "Accounts and cards",
                "payments": "Payments",
                "orders": "Orders",
                "branches": "Branches and ATM's",
                "settings": "Settings",
                "notificationMessages": "Messages",
                "notificationMessagesPlaceholder": "Write your reply here",
                "notificationMessagesPlaceholderSubject": "Message subject",
                "notificationMessagesUnread": "Unread",
                "notificationMessagesMarkAsRead": "Mark as read",
                "notificationMessagesReply": "Reply",
                "notificationMessagesSend": "Send",
                "notificationMessagesCancelSend": "Cancel",
                "notificationMessagesViewAll": "View all messages",
                "notificationEInvoices": "New e-Inovices",
                "notificationEInvoicesDueDate": "due",
                "notificationEInvoicesPay": "Pay",
                "notificationEInvoicesViewAll": "View all eInvoices",
                "notificationPendingPayments": "Pending payments",
                "notificationPendingPaymentsViewAll": "View all payments",
                "notificationPendingPaymentsDateLabel": "for",
                "notificationRejectedPayments": "Rejected payments",
                "notificationRejectedPaymentsDateLabel": "for",
                "notificationRejectedPaymentsViewAll": "View all payments",
                "notificationSettingsLangLabel": "Choose language:",
                "notificationSettingsViewAllLabel": "View all settings",
                "signedInAs": "Signed in as",
                "lastLogin": "Last login: ",
                "logout": "Logout",
                "langEn": "English",
                "langHr": "Croatian",
                "langSr": "Serbian",
                "langMtr": "Montenegro",
                "langBa": "Local",
                "langSl": "Slovenian",
                "langDe": "German",
                "langRu": "Russian",
                "noMessages": "No messages",
                "noeInvoices": "No eInvoices",
                "noPendingPayments": "No pending payments",
                "noRejectedPayments": "No rejected payments"
            },
            footer: {
                "freeCall": "Telephone number",
                "freeCallBh": "Contact center ",
                "internationalCall": "International call",
                "email": "Send us an email",
                "notificationDepth": "In-depth analysis",
                "dearClients": "Dear clients,",
                "modalText1": "Please let us inform you on the importance of updating your personal data with the aim of continuing our successful business relations.",
                "modalText2": "Data, such as ID number and validity date of your ID documents(identity card, passport, residence permit) need to be updated in the nearest branch office after expiry in accordance with Article 7 of the General Terms of Addiko Bank d.d.",
                "modalText3": "With the aim of correct identification we will inform you about the document expiry in a letter (sent to your home address) and/or in a message (sent to you via direct banking channels).",
                "regards": "Best regards",
                "closeButton": "Close",
                "version": "Version",
                "server": "Server"
            },
            timeline: {
                msgWith: "Message with subject ",
                msgWithout: "Message without subject ",
                msgReceived: " was recieved on ",
                msgSent: " was sent on "
            },
            templateSearch: {
                favorites: "My favorite templates",
                templatesList: "List of templates"
            },
            dashboardWidgets: {
                current: "Current accounts and cards",
                loan: "Loan accounts",
                deposit: "Deposit accounts",
                savings: "Savings",
                savingsTransactions: "Savings",
                giro: "Giro accounts",
                addBtn: "Add widgets"
            },
            dashboardNotification: {
                rejected: "new rejected payments",
                einvoice: "new received eInvoices",
                einvoiceSlo: "new received eInvoices",
                group: "group payments to sign",
                goBtn: "Go to payments",
                unsigned: "unsigned payments",
                pending: "pending payments" // Currently: Only for Slovenia
            }
        };

        $translateProvider
            .translations('en', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      dashboard: {
        "dashboardHeader": "Početna strana",
        "addNewWidget1": "Označite",
        "addNewWidget2": "Favorite",
        "pendingPayments": "Nalozi na čekanju",
        "show": "Prikaži",
        "hide": "Sakrij",
        "domesticPaymentBtn1": "Nalog za",
        "domesticPaymentBtn2": "plaćanje",
        "transferBtn1": "Prijenos/Prenos na",
        "transferBtn2": "moj račun",
        "templateBtn1": "Plaćanje iz",
        "templateBtn2": "uzorka",
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayment": "Kreiraj opći/opšti nalog",
        "internalTransfer": "Kreiraj nalog za prijenos/prenos",
        "payTemplate": "Plati iz uzorka",
        "searchTemplatesPlaceholder": "Pretraži uzorke",
        "showAccounts": "Prikaži još računa",
        "instantLoan": "Brzi kredit",
        "instantLoanDescription": "",
        "apply": "Prijava",
        "contact": "Kontaktirajte nas",
        "hypoClub": "Addiko Club",
        "etrade": "E-Trade",
        "branch": "Pronađite poslovnicu",
        "bankTimeline": "Vremenski prikaz Vašeg poslovanja",
        "loadEvents": "Učitaj starije događaje",
        "noTimelineData": "Za odabrani period nema podataka za prikaz",
        "availableBalance": "Raspoloživo stanje",
        "loanAmount":"Iznos kredita",
        "confirmation": "Potvrda",
        "complaint": "Reklamacija/Pritužba",
        "cashLoan": "Gotovinski/Keš kredit",
        "approval": "odobrenje za 1 sat"
      },
      timelineFilter: {
        "placeholder": "Pretraga i filtriranje",
        "all": "Svi",
        "credit": "Uplate",
        "debit": "Isplate",
        "others": "Ostali",
        "amountFrom": "Iznos od",
        "amountTo": "Do",
        "reset": "Poništi",
        "apply": "Primjeni"
      },
      header: {
        "dashboard": "Početna strana",
        "accounts": "Računi i kartice",
        "payments": "Plaćanja",
        "orders": "Narudžbe",
        "branches": "Poslovnice i bankomati",
        "settings": "Postavke",
        "notificationMessages": "Poruke",
        "notificationMessagesPlaceholder": "Napišite svoj odgovor",
        "notificationMessagesPlaceholderSubject": "Naslov poruke",
        "notificationMessagesUnread": "Nepročitana",
        "notificationMessagesMarkAsRead": "Označi kao pročitanu",
        "notificationMessagesReply": "Odgovori",
        "notificationMessagesSend": "Pošalji",
        "notificationMessagesCancelSend": "Odustani",
        "notificationMessagesViewAll": "Pregled svih poruka",
        "notificationEInvoices": "Novi eRačuni",
        "notificationEInvoicesDueDate": "datum naplate",
        "notificationEInvoicesPay": "Plati",
        "notificationEInvoicesViewAll": "Pregled svih eRačuna",
        "notificationPendingPayments": "Plaćanja u obradi",
        "notificationPendingPaymentsViewAll": "Pregled svih plaćanja",
        "notificationPendingPaymentsDateLabel": "datum",
        "notificationRejectedPayments": "Odbijena plaćanja",
        "notificationRejectedPaymentsViewAll": "Pregled svih plaćanja",
        "notificationRejectedPaymentsDateLabel": "datum",
        "notificationSettingsLangLabel": "Odaberite jezik:",
        "notificationSettingsViewAllLabel": "Otvorite postavke aplikacije",
        "signedInAs": "Prijavljeni korisnik",
        "lastLogin": "Datum zadnje prijave: ",
        "logout": "Odjava",
        "langEn": "Engleski",
        "langHr": "Lokalni",
        "langSr": "Srpski",
        "langMtr": "Crnogorski",
        "langBa": "Lokalni",
        "langSl": "Slovenački",
        "langDe": "Njemački",
        "langRu": "Ruski",
        "noMessages": "Nema poruka",
        "noeInvoices": "Nema eRačuna",
        "noPendingPayments": "Nema uplata na čekanju",
        "noRejectedPayments": "Nema odbačenih uplata"
      },
      footer: {
        "freeCall": "Besplatni poziv",
        "freeCallBh": "Kontakt centar",
        "internationalCall": "Internacionalni poziv",
        "email": "Pošaljite nam e-mail",
        "notificationDepth": "Dubinska analiza",
        "dearClients": "Poštovani,",
        "modalText1": "dozvolite da Vas informiramo/informišemo o važnosti ažuriranja Vaših osobnih/ličnih podataka kako bi se poslovni odnos i nadalje uspješno nastavio.",
        "modalText2": "Podaci kao što su broj i datum valjanosti osobnog identifikacijskog/ličnog identifikacionog dokumenta (osobna iskaznica/lična karta, putovnica/pasoš, dozvola boravka u BiH) potrebno je ažurirati u Vama najbližoj poslovnici Banke po isteku njihovog datuma važenja, a sve u skladu s pravilima Addiko Bank",
        "modalText3": "U svrhu ispravne identifikacije te nužnog ažuriranja Vašeg identifikacijskog dokumenta, Banka uzima slobodu da Vas obavijesti o navedenom putem dopisa poslanom na kućnu adresu i/ili porukom proslijeđenom kanalima direktnog bankarstva.",
        "regards": "Srdačan pozdrav",
        "closeButton": "Zatvori",
        "version":"Verzija",
        "server":"Server"
      },
      timeline: {
        msgWith: "Poruka ",
        msgWithout: "Poruka bez naslova ",
        msgReceived: " je primljena ",
        msgSent: " je poslana "
      },
      templateSearch: {
        favorites: "Favoriti",
        templatesList: "Lista uzoraka"
      },
      dashboardWidgets: {
        current: "Tekući računi i kartice",
        loan: "Krediti",
        deposit: "Štednja",
        savings: "Štedni računi",
        giro: "Žiro računi",
        addBtn: "Potvrdi"
      },
      dashboardNotification: {
        rejected: "Odbijenih naloga",
        einvoice: "neplaćenih eRačuna",
        group: "grupnih naloga za potpisati",
        goBtn: "Idi na plaćanja",
        unsigned: "Nepotpisanih naloga"
      }
    };

    $translateProvider
      .translations('bh', data);
  }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            // http://www.xe.com/ibancalculator/sample/?ibancountry=serbia
          "filter": {
            maxDateRange: "Maksimalni raspon datuma je jedna godina."
          },
            "inputFields": {
                IBAN: "9999 9999 9999 9999 9"
            },
            core: {
                "moneyFormat": {
                    mask: "#.###.##0,00",
                    placeholder: "eg: 000.000,00"
                },
                "period": {
                    today: "Danas",
                    yesterday: "Juče",
                    thisWeek: "Sedam dana",
                    thisMonth: "Mesec dana",
                    thisYear: "Godina dana",
                    all: "Sve",
                    allMessages: "Sve poruke"
                },
                "paymentOrder": "Nalog broj",
                "investOrder": "Investicija broj",
                "successDelete": "je uspješno izbrisan.",
                "investSuccessDelete": "je uspješno izbrisan.",
                "termDepositPayoutType": {
                    "2": "Pripis kamate po dospijeću",
                    "2e": "(kamata i glavnica zajedno)",
                    "16": "Mjesečna isplata kamate na dan",
                    "16e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakog 15 u mjesecu)",
                    "17": "Tromjesečna isplata kamate na dan",
                    "17e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svaka tri mjeseca 15 u mjesecu)",
                    "18": "Šestomjesečna isplata kamate na dan",
                    "18e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih šest mjeseci 15 u mjesecu)",
                    "19": "Godišnja isplata kamate na dan",
                    "19e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih godinu dana 15 u mjesecu)",
                    "3": "Isplata kamate po dospijeću",
                    "3e": "(samo kod automatskog produženja)"

                },
              "termDepositStatus": {
                "realised": "Realised",
                "unrealised": "Unrealised",
                "cancelled": "Cancelled",
                "receivednotexecuted":"U obradi"
              },
                "confirmation": "Reklamacija na transakciju je uspešno poslana u bazu podataka.",
                "error": "Greška",
              sweetAlertTranslation: {
                yes: "Da",
                no: "Ne",
                areYouSure: "Jeste li sigurni?"
              },
                 logoutModalTranslation: {
                logoutBtn: "Da",
                logoutMsg: "Jeste li sigurni da se želite odjaviti ?",
                "cancel":"Ne"
              },
              "sameAccounts": "Greška: Isti računi!",
              paymentSignedStatus:{
                  "inprocessing":"U obradi"
              },
              "today":"Danas",
              "passwordChangedMsg":"Uspešno ste promenili lozinku!",
              "noAccounts": "Nema dostupnih računa",
              datePicker: {
                "doneBtn":"Uredu",
                "clearBtn":"Obriši"
              }
            }
        };

        $translateProvider
            .translations('sr', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            // http://www.xe.com/ibancalculator/sample/?ibancountry=croatia
            core: {
                "filter": {
                  maxDateRange: "Maksimalna dolžina obdobja je eno leto."
                },
                "inputFields": {
                    IBAN: "9999 9999 9999 9999 9"
                },
                "moneyFormat": {
                    mask: "#.###.##0,00",
                    placeholder: "eg: 000.000,00"
                },
                "period": {
                    today: "Danes",
                    yesterday: "Včeraj",
                    thisWeek: "Teden dni",
                    thisMonth: "Mesec dni",
                    thisYear: "Leto dni",
                    all: "Vse",
                    allMessages: "Vsa sporočila",
                    last6Months: "Zadnjih 6 mesecev"
                },
              "requiredField": "Polje je obavezno.",
              "paymentOrder": "Nalog številka",
                "investOrder": "Investicija številka",
                "ebookOrder": "eKnjižica številka",
                "successDelete": "je uspešno izbrisan.",
                "investSuccessDelete": "je uspešno izbrisana.",
                "termDepositPayoutType": {
                    "2": "Poročanje po poteku",
                    "2e": "(obresti in glavnica hkrati)",
                    "16": "Poročanje po poteku",
                    "16e": "(pojasnilo: za depozit sklenjen npr. 15. v mesecu, je izplačilo obresti vsakega 15. v mesecu)",
                    "17": "Četrtletno izplačilo obresti",
                    "17e": "(pojasnilo: za depozit sklenjen npr. 15. v mesecu, je izplačilo obresti vsake tri mesece 15. v mesecu)",
                    "18": "Polletno izplačilo obresti",
                    "18e": "(pojasnilo: za depozit sklenjen npr. 15. v mesecu, je izplačilo obresti vsakih šest mesecev 15. v mesecu)",
                    "19": "Letno izplačilo obresti",
                    "19e": "(pojasnilo: za depozit sklenjen npr. 15. v mesecu, je izplačilo obresti vsako leto 15. v mesecu sklenitve)",
                    "3": "Izplačilo obresti po dospetju",
                    "3e": "(samo pri avtomatskem podaljševanju)"

                },
              "termDepositStatus": {
                "entered": "Oddan",
                "realised": "Izveden",
                "unrealised": "Neizveden",
                "cancelled": "Preklican",
                "receivednotexecuted":"V izvedbi"
              },
              "confirmation": "Reklamacija na transakcijo je bila oddana.",
              "confirmationSlo": "Reklamacija na transakcijo je bila oddana.",
              "error": "Napaka",
              sweetAlertTranslation: {
                yes: "Da",
                no: "Ne",
                areYouSure: "Ste prepričani?"
              },
              logoutModalTranslation: {
                logoutBtn: "Da",
                logoutMsg: "Ste prepričani, da se želite odjaviti?",
                "cancel":"Ne"
              },
              "sameAccounts": "Napaka: Ista računa!",
              paymentSignedStatus:{
                  "InProcessing":"V obdelavi"
              },
              "today":"Danes",
              "noAccounts": "Ni podatkov o računih",
              "notImplemented":"Not implemented yet!",
              datePicker: {
                "doneBtn":"Potrdi",
                "clearBtn":"Obriši"
              }
            }
        };

        $translateProvider
            .translations('sl', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            // http://www.xe.com/ibancalculator/sample/?ibancountry=serbia
          "filter": {
            maxDateRange: "Maksimalni raspon datuma je jedna godina."
          },
            "inputFields": {
                IBAN: "9999 9999 9999 9999 9"
            },
            core: {
                "moneyFormat": {
                    mask: "#.###.##0,00",
                    placeholder: "eg: 000.000,00"
                },
                "period": {
                    today: "Danas",
                    yesterday: "Juče",
                    thisWeek: "Sedam dana",
                    thisMonth: "Mjesec dana",
                    thisYear: "Godina dana",
                    all: "Sve",
                    allMessages: "Sve poruke"
                },
                "paymentOrder": "Nalog broj",
                "investOrder": "Investicija broj",
                "successDelete": "je uspješno obrisan.",
                "investSuccessDelete": "je uspješno izbrisan.",
                "termDepositPayoutType": {
                    "2": "Pripis kamate po dospijeću",
                    "2e": "(kamata i glavnica zajedno)",
                    "16": "Mjesečna isplata kamate na dan",
                    "16e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakog 15 u mjesecu)",
                    "17": "Tromjesečna isplata kamate na dan",
                    "17e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svaka tri mjeseca 15 u mjesecu)",
                    "18": "Šestomjesečna isplata kamate na dan",
                    "18e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih šest mjeseci 15 u mjesecu)",
                    "19": "Godišnja isplata kamate na dan",
                    "19e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih godinu dana 15 u mjesecu)",
                    "3": "Isplata kamate po dospijeću",
                    "3e": "(samo kod automatskog produženja)"

                },
              "termDepositStatus": {
                "realised": "Realised",
                "unrealised": "Unrealised",
                "cancelled": "Cancelled",
                "receivednotexecuted":"U obradi"
              },
              "confirmation": "Reklamacija na transkaciju je uspiješno poslana u bazu podataka.",
              "error": "Greška",
              sweetAlertTranslation: {
                yes: "Da",
                no: "Ne",
                areYouSure: "Jeste li sigurni?"
              },
              logoutModalTranslation: {
                logoutBtn: "Da",
                logoutMsg: "Jeste li sigurni da se želite odjaviti ?",
                "cancel":"Ne"
              },
              "sameAccounts": "Greška: Isti računi!",
              paymentSignedStatus:{
                  "inprocessing":"U obradi"
              },
              "today":"Danas",
              "passwordChangedMsg":"Uspješno ste promijenili lozinku!",
              "noAccounts": "Nema dostupnih računa",
              datePicker: {
                "doneBtn":"Uredu",
                "clearBtn":"Obriši"
              }
            }
        };

        $translateProvider
            .translations('mne', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            // http://www.xe.com/ibancalculator/sample/?ibancountry=croatia
            core: {
              "filter": {
                maxDateRange: "Maksimalni raspon datuma je jedna godina."
              },
                "inputFields": {
                    IBAN: "9999 9999 9999 9999 9"
                },
                "moneyFormat": {
                    mask: "#.###.##0,00",
                    placeholder: "eg: 000.000,00"
                },
                "period": {
                    today: "Danas",
                    yesterday: "Jučer",
                    thisWeek: "Sedam dana",
                    thisMonth: "Mjesec dana",
                    thisYear: "Godina dana",
                    all: "Sve",
                    allMessages: "Sve poruke"
                },
                "paymentOrder": "Nalog broj",
                "investOrder": "Investicija broj",
                "ebookOrder": "eKnjižica broj",
                "successDelete": "je uspješno izbrisan.",
                "investSuccessDelete": "je uspješno izbrisana.",
                "termDepositPayoutType": {
                    "2": "Pripis kamate po dospijeću",
                    "2e": "(kamata i glavnica zajedno)",
                    "16": "Mjesečna isplata kamate na dan",
                    "16e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakog 15 u mjesecu)",
                    "17": "Tromjesečna isplata kamate na dan",
                    "17e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svaka tri mjeseca 15 u mjesecu)",
                    "18": "Šestomjesečna isplata kamate na dan",
                    "18e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih šest mjeseci 15 u mjesecu)",
                    "19": "Godišnja isplata kamate na dan",
                    "19e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih godinu dana 15 u mjesecu)",
                    "3": "Isplata kamate po dospijeću",
                    "3e": "(samo kod automatskog produženja)"

                },
              "termDepositStatus": {
                "realised": "Realiziran",
                "unrealised": "Neostvaren",
                "cancelled": "Otkazan",
                "receivednotexecuted":"U obradi"
              },
              "confirmation": "Reklamacija na transakciju je uspješno zaprimljena u bazu podataka.",
              "error": "Greška",
              sweetAlertTranslation: {
                yes: "Da",
                no: "Ne",
                areYouSure: "Jeste li sigurni?"
              },
              logoutModalTranslation: {
                logoutBtn: "Da",
                logoutMsg: "Jeste li sigurni da se želite odjaviti ?",
                "cancel":"Ne"
              },
              "sameAccounts": "Greška: Isti računi!",
              paymentSignedStatus:{
                  "InProcessing":"U obradi"
              },
              "today":"Danas",
              "noAccounts": "Nema dostupnih računa",
              datePicker: {
                "doneBtn":"Uredu",
                "clearBtn":"Obriši"
              }
            }
        };

        $translateProvider
            .translations('hr', data);

    }
}());

(function () {
    'use strict';

    config.$inject = ["$translateProvider"];
    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            // Don't know yet
            core: {
                "filter": {
                  maxDateRange: "Maximal date range is one year."
                },
                "inputFields": {
                    IBAN: "9999 9999 9999 9999 9"
                },
                "moneyFormat": {
                    mask: "#,###,##0.00",
                    placeholder: "eg: 000,000.00"
                },
                "period": {
                    today: "Today",
                    yesterday: "Yesterday",
                    thisWeek: "Week",
                    thisMonth: "Month",
                    thisYear: "Year",
                    all: "All",
                    allMessages: "All messages",
                    clear: "Clear",
                    last6Months: "Last 6 months"
                },
                "requiredField": "Field is required.",
                "ebookOrder": "eSaving book order",
                "paymentOrder": "Payment order",
                "investOrder": "Investment order",
                "successDelete": "was successfully deleted.",
                "investSuccessDelete": "was successfully deleted.",
                "termDepositPayoutType": {
                    "2": "Interest rate addition upon maturity",
                    "2e": "(interest and capital together)",
                    "16": "Monthly interest payout on certain date",
                    "16e": "(explanation: if term deposit is agreed on 15, interst payout is performed every 15th in month)",
                    "17": "Quarterly interest payout on certain date",
                    "17e": "(explanation: if term deposit is agreed on 15, interst payout is performed every 15th in month)",
                    "18": "Biannual interest payout on certain date",
                    "18e": "(explanation: if term deposit is agreed on 15, interst payout is performed every 15th in month)",
                    "19": "Annual interest payout on certain date",
                    "19e": "(explanation: if term deposit is agreed on 15, interst payout is performed every 15th in month)",
                    "3": "Payout of interst rate upon maturity",
                    "3e": "(at automatic prolongation only)"

                },
                "termDepositStatus": {
                  "entered":"Entered",
                  "realised": "Realised",
                  "unrealised": "Unrealised",
                  "cancelled": "Cancelled",
                  "receivednotexecuted":"In processing"
                },
                "confirmation": "Reclamation on transaction was successfully received in database.",
                "confirmationSlo": " Complaint was successfully submitted.",
                "error": "Error",
              sweetAlertTranslation: {
                yes: "Yes",
                no: "No",
                areYouSure: "Are you sure?"
              },
              logoutModalTranslation: {
                logoutBtn: "Yes",
                logoutMsg: "Do you really want to log out?",
                "cancel":"No"
              },
              "sameAccounts": "Error: Same accounts!",
              paymentSignedStatus:{
                  "inprocessing":"InProcessing"
              },
              "today":"Today",
              "passwordChangedMsg":"Password successfully changed!",
              "noAccounts": "No available accounts",
              "notImplemented":"Not implemented yet!",
              "additionalDataChangedMsg": "Successfully updated!",
              datePicker: {
                "doneBtn":"Done",
                "clearBtn":"Clear"
              }
            }
        };

        $translateProvider
            .translations('en', data);

    }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      // http://www.xe.com/ibancalculator/sample/?ibancountry=serbia
      "filter": {
        maxDateRange: "Maksimalni raspon datuma je jedna godina."
      },
      "inputFields": {
        IBAN: "9999 9999 9999 9999 9"
      },
      core: {
        "moneyFormat": {
          mask: "#.###.##0,00",
          placeholder: "eg: 000.000,00"
        },
        "period": {
          today: "Danas",
          yesterday: "Jučer/Juče",
          thisWeek: "Sedam dana",
          thisMonth: "Mjesec dana",
          thisYear: "Godina dana",
          all: "Sve",
          allMessages: "Sve poruke"
        },
        "paymentOrder": "Nalog broj",
        "investOrder": "Investicija broj",
        "successDelete": "je uspješno izbrisan.",
        "investSuccessDelete": "je uspješno izbrisana.",
        "termDepositPayoutType": {
          "2": "",
          "2e": "",
          "16": "",
          "16e": "",
          "17": "",
          "17e": "",
          "18": "",
          "18e": "",
          "19": "",
          "19e": "",
          "3": "",
          "3e": ""

        },
        "termDepositStatus": {
          "realised": "Realiziran/Realizovan",
          "unrealised": "Neostvaren",
          "cancelled": "Otkazan",
          "receivednotexecuted":"U obradi"
        },
        "confirmation": "Reklamacija na transakciju je uspješno poslana u bazu podataka.",
        "error": "Greška",
        sweetAlertTranslation: {
          yes: "Da",
          no: "Ne",
          areYouSure: "Jeste li sigurni?"
        },
        logoutModalTranslation: {
          logoutBtn: "Da",
          logoutMsg: "Jeste li sigurni?",
          "cancel":"Ne"
        },
        "sameAccounts": "Greška: Isti računi!",
        paymentSignedStatus:{
          "inprocessing":"U obradi"
        },
        "today":"Danas",
        "passwordChangedMsg":"Uspješno ste promijenili lozinku !",
        "noAccounts": "Nema dostupnih računa",
        "additionalDataChangedMsg": "Podaci su uspješno ažurirani !",
        datePicker: {
          "doneBtn":"Uredu",
          "clearBtn":"Obriši"
        }
      }
    };
    $translateProvider
      .translations('bh', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      blockade: {
        title: "Blokada poslovanja v Addiko EBank/Addiko Mobile",
        timeRestrictedBlockadeText: "Če želite poslovanje kasneje spet omogočiti, morate obiskati eno od poslovalnic Addiko Bank d.d. in izpolniti zahtevek za deblokado poslovanja v Addiko EBanki.",
        info1: "Za določen ali nedoločen čas lahko onemogočite uporabo Addiko EBanke/Addiko Mobile. Opozorilo: V času blokade poslovanje v Addiko EBanki in/ali Addiko Mobile ne bo mogoče. Če izberete blokado za nedoločen čas, je za ponovno aktivacijo delovanja potreben obisk ene od Addiko poslovalnic.",
        info2: "",
        blockadeReason: "Razlog za blokado",
        blockadeOf: "Blokiranje",
        timeRestrictedBlockade: "Časovna omejitev blokade",
        dateFrom: "Od dne",
        dateTo: "Do dne",
        orderDate: "Datum naročila",
        orderTypeLabel: "Vrsta naročila",
        orderTypeText: "Blokada poslovanja",
        and: "in",
        blockadeTypeLabel: "Vrsta blokade",
        blockadeTypeText: "Blokada poslovanja med",
        blockadeUnrestricted: "Časovno neomejena blokada",
        blockadeFinishedTitle: "Blokada je izvršena.",
        blockadeFinishedMsg1: "V času med",
        blockadeFinishedMsg2: "poslovanje v",
        blockadeFinishedMsg3: "ne bo mogoče.",


        errors: {
          requiredField: "Polje je obvezno.",
          blockadeOfErr: "Izbrano mora biti vsaj eno blokiranje.",
          dateToAndFromRequired: "Pri časovno omejeni blokadi morata biti datuma blokade izpolnjena.",
          timeRestrictedBlockadeErr: "The end date of the blockade (to) must be greater than or equal to the start date (from)!"
        }
      }
    };

    $translateProvider
      .translations('sl', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      blockade: {
        title: "Block Addiko EBank/Addiko Mobile",
        timeRestrictedBlockadeText: "If you would like to be able to use Addiko EBank at a later time, you must visit your branch office, where you have applied for Addiko Ebank and fill out the form to unblock Addiko EBank.",
        info1: "You can disable the use of the Addiko EBank/Addiko Mobile for a fixed or indefinite period of time. Note: For the time the application is disabled you will not be able to use Addiko EBank and/or Addiko Mobile. If you choose to disable the application for an indefinite period of time you will have to visit one of the Addiko branch offices to re-activate it.",
        info2: "",
        blockadeReason: "Blockade reason",
        blockadeOf: "Blockade of",
        timeRestrictedBlockade: "Time-restricted blockade",
        dateFrom: "From",
        dateTo: "To",
        orderDate: "Order date",
        orderTypeLabel: "Order type",
        orderTypeText: "Block operations of",
        and: "and",
        blockadeTypeLabel: "Blockade type",
        blockadeTypeText: "Block operations between",
        blockadeUnrestricted: "Time-unrestricted blockade",
        blockadeFinishedTitle: "Blockade has been enabled.",
        blockadeFinishedMsg1: "Between",
        blockadeFinishedMsg2: "operations in",
        blockadeFinishedMsg3: "will not be possible.",

        errors: {
          requiredField: "Required field",
          blockadeOfErr: "At least one blockade option has to be selected.",
          dateToAndFromRequired: "From and To are required fields for time-restricted blockade.",
          timeRestrictedBlockadeErr: "The end date of the blockade (to) must be greater than or equal to the start date (from)!"
        }
      }
    };

    $translateProvider
      .translations('en', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      alert: {
        information: "Informacije",
        areYouSure: "Da li ste sigurni?",
        blockCardInfo: "Do you really want to block your card ?",
        blockCardCost: "It will cost you",
        blockCard: "Blokiraj",
        payment: "Nalog broj",
        template: "Uzorak broj",
        termDeposit: "Oročeni depozit",
        investment: "Investicija broj",
        subscriptionRequest: "Uspješno ste unijeli zahtjev za pretplatu",
        successSign: "Uspešno ste potpisali nalog",
        closeEBook: "Uspešno ste zatvorili eknjižicu",
        cancelRegistration: "Uspešno ste otkazali registraciju",
        ebookOrder: "eknjižica broj",
        archiveEInvoice: "Uspešno ste arhivirali e-račun",
        saveTemplate: "Uspešno ste sačuvali šablon",
        updateTemplate: "Uspešno ste ažurirali šablon",
        deleteAction: "Brisanje",
        cancel: "Zatvori",
        yes: "Da",
        no: "Ne",
        qrCode: "Kreirani QRCode"
      }
    };

    $translateProvider
        .translations('sr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      alert: {
        information: "Informacije",
        areYouSure: "Ste prepričani?",
        blockCardInfo: "Ste prepričani, da želite blokirati kartico?",
        blockCardCost: "To bo stalo",
        blockCard: "Blokiraj",
        payment: "Plačilo številka",
        template: "Predloga številka",
        termDeposit: "Depozit",
        investment: "Investicija številka",
        subscriptionRequest: "Uspešno ste vnesli zahtevo za prijavo",
        successSign: "Plačilo je bilo uspešno oddano.",
        successSignSlo: "Vaše naročilo je bilo uspešno oddano.",
        closeEBook: "Uspešno ste zaprli eKnjižico",
        cancelRegistration: "Uspešno ste preklicali naročnino",
        ebookOrder: "eKnjižica številka",
        archiveEInvoice: "Uspešno ste arhivirali eRačun",
        saveTemplate: "Uspešno ste shranili predlogo",
        updateTemplate: "Uspešno ste spremenili predlogo",
        deleteAction: "Brisanje",
        cancel: "Zapri",
        yes: "Da",
        no: "Ne",
        success: "Uspeh!"
      }
    };

    $translateProvider
        .translations('sl', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      alert: {
        information: "Informacija",
        areYouSure: "Jeste li sigurni?",
        blockCardInfo: "Da li želite blokirati karticu ?",
        blockCardCost: "It will cost you",
        blockCard: "Blokiraj",
        payment: "Nalog broj",
        template: "Uzorak broj",
        termDeposit: "Oročeni depozit",
        investment: "Investicija broj",
        subscriptionRequest: "Uspješno ste unijeli zahtjev za pretplatu",
        successSign: "Uspješno ste potpisali nalog",
        closeEBook: "Uspješno ste zatvorili eknjižicu",
        cancelRegistration: "Uspješno ste otkazali registraciju",
        ebookOrder: "eknjižica broj",
        archiveEInvoice: "Uspješno ste arhivirali e-račun",
        saveTemplate: "Uspješno ste pohranili šablon",
        updateTemplate: "Uspješno ste izmijenili šablon",
        deleteAction: "Brisanje",
        cancel: "Zatvori",
        yes: "Da",
        no: "Ne"
      }
    };

    $translateProvider
        .translations('mne', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      alert: {
        information: "Informacije",
        areYouSure: "Jeste li sigurni?",
        blockCardInfo: "Do you really want to block your card ?",
        blockCardCost: "It will cost you",
        blockCard: "Blokiraj",
        payment: "Nalog broj",
        template: "Predložak broj",
        termDeposit: "Oročenje",
        investment: "Investicija broj",
        subscriptionRequest: "Uspješno ste unijeli zahtjev za pretplatu",
        successSign: "Uspješno ste potpisali nalog",
        closeEBook: "Uspješno ste zatvorili eKnjižicu",
        cancelRegistration: "Uspješno ste otkazali registraciju",
        ebookOrder: "eKnjižica broj",
        archiveEInvoice: "Uspješno ste arhivirali e-račun",
        saveTemplate: "Uspješno ste pohranili predložak",
        updateTemplate: "Uspješno ste ažurirali predložak",
        deleteAction: "Brisanje",
        cancel: "Zatvori",
        yes: "Da",
        no: "Ne",
        paymentsReturnText: 'U izborniku "Plaćanje - Povrat priljeva" postoje neodgovorene poruke.'
      }
    };

    $translateProvider
        .translations('hr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      alert: {
        information: "Information",
        areYouSure: "Are you sure?",
        blockCardInfo: "Do you really want to block your card ?",
        blockCardCost: "It will cost you",
        blockCard: "Block card",
        payment: "Payment order",
        template: "Template order",
        termDeposit: "Term deposit",
        investment: "Investment order",
        subscriptionRequest: "You have successfully entered a request for subscription",
        successSign: "You have successfully signed payment",
        successSignSlo: "Your order has been submitted successfully.",
        closeEBook: "You have successfully closed e-book",
        cancelRegistration: "You have successfully canceled registration",
        ebookOrder: "eSaving book order",
        archiveEInvoice: "You have successfully archived e-invoice",
        saveTemplate: "You have successfully saved template",
        updateTemplate: "You have successfully updated template",
        deleteAction: "Deletion",
        cancel: "Close",
        yes: "Yes",
        no: "No",
        success: "Success!",
        qrCode: "Generated QRCode",
        paymentsReturnText: 'There are unanswered massages in the "Payments - Payments return".'
      }
    };

    $translateProvider
        .translations('en', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      alert: {
        information: "Informacije",
        areYouSure: "Jeste li sigurni?",
        blockCardInfo: "Da li zaista želite da blokirate svoju karticu?",
        blockCardCost: "Ova usluga se naplaćuje.",
        blockCard: "Blokiraj",
        payment: "Nalog broj",
        template: "Broj uzorka",
        termDeposit: "Oročenje",
        investment: "Investicija broj",
        subscriptionRequest: "Uspješno ste unijeli zahtjev za pretplatu",
        successSign: "Uspješno ste potpisali nalog",
        closeEBook: "Uspješno ste zatvorili eKnjižicu",
        cancelRegistration: "Uspješno ste otkazali registraciju",
        ebookOrder: "eKnjižica broj",
        archiveEInvoice: "Uspješno ste arhivirali e-račun",
        saveTemplate: "Uspješno ste sačuvali uzorak.",
        updateTemplate: "Uspješno ste ažurirali uzorak.",
        deleteAction: "Brisanje",
        cancel: "Zatvori",
        yes: "Da",
        no: "Ne"
      }
    };

    $translateProvider
      .translations('bh', data);

  }
}());


(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "accAllAccountsOverview":"Pregled svih računa",
        "accShowAccounts":"Prikaži još računa",
        "accFilter":"Filtriraj po tipu",
        "accAmountRange":"Raspon iznosa",
        "accTo":"Do",
        "accApply":"Primeni",
        "accReset":"Poništi",
        "accPeriod":"Period",
        "accDescription":"Opis",
        "accAmount":"Iznos",
        "accBalance":"Stanje po računu",
        "accShowOnDashboard":"Prikaži na kontrolnoj ploči",
        "accTransactions":"Transakcije",
        "accPdfStatements":"Pdf izvod",
        "accDownloadPdf":"Preuzmi PDF",
        "accChangeName":"Promijeni naziv računa",
        "accResetName":"Postavi originalni naziv",
        "accQuickPayment":"Brzo plaćanje",
        "accRequestLimit":"Zahtijevaj promjenu limita",
        "accAvailableToSpend":"Raspoloživi iznos",
        "accReservations":"Rezervacije",
        "accOverdraftLimit":"Iznos prekoračenja",
        "accOverdraftLimitDue":"Datum isteka prekoračenja",
        "accPayIn":"Uplata",
        "accRepaymentPlan":"Prikaži plan otplate",
        "accLoanAmount":"Odobreni iznos",
        "accLoanBalance":"Stanje kredita",
        "accInterestRate":"Kamatna stopa",
        "accAnnuity":"Iznos anuiteta/rate",
        "accStartDate":"Datum početka",
        "accEndDate":"Datum završetka",
        "accDisbursementDate":"Datum odobrenja",
        "accDuration":"Trajanje",
        "accViewMore":"Prikaži više informacija",
        "accViewLess":"Prikaži manje informacija",
        "accTypeOfRate":"Vrsta kamatne stope",
        "accPenaltyInterests":"Zatezna kamata",
        "accOverpayments":"Preplata",
        "accOtherFees":"Druge naknade",
        "accChangeDate":"Datum zadnje promjene",
        "accAlreadySpent":"Dospeli troškovi",
        "accPayCard":"Kartično plaćanje",
        "accApprovedLimit":"Odobreni limit",
        "accDueDate":"Rok korištenja",
        "accClosingDate":"Datum zatvarnja",
        "accMonthlyDeposit amount":"Iznos mjesečnog depozita",
        "accStatementDeliveryMethod":"Način isporuke obračuna",
        "accAccountForRelease":"Račun za isplatu",
        "accAnnualAssignment":"Godišnja dodjela kamata",
        "accPayOut":"Isplata",
        "accCloseAccount":"Zatvori račun",
        "accOpenNewSavingsAccount":"Otvori novi štedni račun",
        "accEg":"npr",
        "accSearchTransactionsPlaceholder":"Pretraži transakcije",
        "accCancelDeposit":"Otkaži oročenje",
        "accCancelAutoExtension":"Otkaži automatsko produženje",
        "accNewDeposit":"Novo oročenje",
        "accPrincipal":"Glavnica",
        "accInterest":"Kamata",
        "accMaturityDate":"Datum dospeća",
        "accCurrentBalance":"Tekuće stanje",
        "accAtmWithdrawalLimit":"Limit za preuzimanje na bankomatu",
        "accPosPaymentLimit":"Limit za preuzimanje u poslovnici",
        "accDateLastChanged":"Datum zadnje promjene",
        "accBalanceDateLastChanged":"Poslednja promena",
        "accAvailableBalance":"Raspoloživo stanje",
        "accSearchAccountsPlaceholder":"Pretraži račune",
        "accShowMatured":"Prikaži zatvorene račune",
        "accAuthorizedPersons":"Ovlašćena lica",
        "accCardStatus":"Status kartice",
        "accContractNumber":"Broj ugovora",
        "accDepositStartDate":"Datum oročenja",
        "accDepositEndDate":"Datum isteka oročenja",
        "rename": "Preimenuj",
        "accAccountAndCardsMoreDetails": "Detaljni prikaz",
        "accAccountAndCardsMoreDetails1": "Detalji i platne kartice",
        "accAccountAndCardsLessDetails": "Manje detalja",
        "accInstallmentsPayed":"Rata plaćeno",
        "accInstallmentNumber": "Ukupan broj rata",
        "accInstallmentsRemain":"Preostali broj rata",
        "accNextInstallmentDate":"Datum sljedeće rate",
        "accNextInstallmentAmount":"Iznos sljedeće rate",
        "connectedDebitCards": "Povezane kartice",
        "blockCard": "Blokiraj karticu",
        "unblockCard": "Odblokiraj karticu",
          "blockCardRequest": "Blok zahtjev poslan",
        "unblockCardRequest": "Odblokiraj zahtjev poslan",
        "accDueAmount": "Ukupan dospeli dug",
        "accMatureInterest":"Kamata",
        "accNewEbook": "Nova eknjižica",
        "closeEbook": "Zatvaranje eknjižice",
        "accPaymInQue": "Broj nerealizovanih čekova",
        "accReservedAmount": "Rezervisani iznos",
        "accPlanedDebit": "Rezervacija",
        "accDepositInterestRate": "Kamatna stopa na depozit",
        "accDepositTypeExternal": "Deposit Type External",
        "accDepositPrincipal": "Ugovoreni iznos depozita",
        "accLimitValidUntilDate": "Datum isteka kartice",
        "accObligationAmount": "Tekući troškovi",
        "accOutstandingAmount": "Nedospele obaveze na rate",
        "accCardNumber": "Broj kartice",
        "accInstallmentPaidNumber": "Broj plaćenih rata",
        "accNotMatureCapital": "Nedospela glavnica",
        "accNewDebitDate": "Datum iduće obaveze",
        "title": "Informacija",
        "message":"Molimo Vas nazovite Kontakt centar na besplatni broj telefona 0800 14 14 ili na +385 1 6030 000 za pozive iz inozemstva.",
        "close": "Zatvori",
        "accHideTransactions": "Sakrij transakcije",
        "balance": "Stanje računa",
        "accParentAccountIban": "Glavni račun",
        "accAnnuityConverted": "Iznos anuiteta u ",
        "accNotMatureCapitalConverted": "Nedospjela glavnica u ",
        "closeRepaymentPlan":"Zatvori otplatni plan",
        "accHideReservations": "Sakrij rezervacije",
        "depositCantBeCanceledError": "Prijevremeni prekid oročenja moguć je samo za oročenja ugovorena putem usluga direktnog bankarstva. ",
        "Active":"Aktivan",
        "BlockedFromEBank":"Blokirano iz E-banke",
        "expDate":"Datum isteka kartice: ",
        "Closed":"Zatvoren",
        "eBookPayIn": "Uplata na eknjižicu",
        "Blocked":"Blokiran",
        "transDivisionBtn1": "Podjela",
        "transDivisionBtn2": "transakcija"
      },
      repaymentPlan: {
        "instalment": "Rata",
        "loanBalance": "Iznos duga",
        "date": "Datum",
        "dateFrom":"Datum od",
        "dateTo":"Datum do",
        "principalAmount": "Glavnica",
        "paymentAmount": "Anuitet",
        "interestAmount":"Kamata",
        "totalAnnuity":"Ukupan iznos za otplatu ",
        "balance": "Stanje"
      },
      transactions: {
        "description":"Opis",
        "amount":"Iznos",
        "availableAmount":"Raspoloživi iznos",
        "accountNumber":"Broj računa",
        "bookingDate":"Datum knjiženja",
        "valueDate":"Datum valute",
        "cardTransactionDetails":"Detalji transakcije",
        "transactionDetails":"Detalji transakcije",
        "close":"Zatvori",
        "card":"Kartica",
        "iban":"IBAN",
        "noData":"Za odabrani period nema podataka za prikaz",
        "noStatementData":"Za odabrani račun nema podataka za prikaz",
        "retrieval": "Povraćaj",
        "ibanFrom": "IBAN platioca",
        "accountFrom": "Račun platioca",
        "accountTo": "Račun primaoca",
        "referenceNumber":"Referentni broj",
        "creditorName": "Uplatilac",
        "debitorName": "Primalac",
        "creditorAddress": "Adresa uplatioca",
        "debitorAddress": "Adresa primaoca",
        "date":"Datum transakcije"
      },
      ebook: {
        "header": "Zahtjev za otvaranje eknjižice",
        "date": "Datum",
        "fullName": "Ime i prezime",
        "firstName": "Ime",
        "lastName": "Prezime",
        "fromAccount": "Račun",
        "eSavingsBookName": "Naziv eknjižice",
        "termsAndConditions": "Prihvaćam opće uvjete poslovanja",
        "confirm": "Potvrdi",
        "cancel": "Odustani",
        "dateOfCreation":"Datum kreiranja",
        "mainAccount":"Glavni račun",
        "delete":"Obriši",
        "sign":"Potpiši",
        "name":"Naziv",
        "edit":"Promeni",
        "enterName": "Unesite naziv",
        "nameError": "Naziv eknjižice je obavezan!",
        "createEbook": "Kreiraj eknjižicu",
        "successfullRequest": "Uspješno ste kreirali eknjižicu",
        "completeRequest": "Zahtjev uspješan!",
        "eBookRequests": "eKnjižica zahtjevi",
        "createdBy": "Kreirao",
        "iban": "IBAN",
        "requestType": "Tip zahtjeva",
        "status": "Status",
        "timelineHeader":"Vremenski prikaz zahteva za eknjižice",
        "showAllRequests": "Prikaži zahteve za sve račune",
        "ebookNumber": "Račun eknjižice"
      },
      closeEBookPageTranslation: {
        title: "Zahtjev za zatvaranje eknjižice",
        account: "Broj eknjižice",
        accountName: "Naziv eknjižice",
        currency: "Valuta",
        balance: "Stanje",
        recognisedInterestRate: "Priznata kamatna stopa",
        recognisedInterestAmount: "Iznos priznate kamatne stope",
        fee: "Naknada",
        transferAmount: "Iznos za prijenos",
        transferAccount: "Račun za prijenos",
        confirmButton: "Potvrdi",
        cancelButton: "Otkaži"
      },
      accountsOverview: {
        "title": "Pregled svih računa i kartica",
        "newTermDepositButtonLabel": "Dodaj novo oročenje",
        "newESavingAccountButtonLabel": "Dodaj novi eSaving račun"
      },
      depositAccountsOverview: {
        "title": "Pregled svih oročenja i eknjižica",
        "titleForSlo": "Pregled depozitov in varčevanj",
        "titleForSerbAndMne": "Pregled štednih računa"
      },
      laonsOverview: {
        title: "Pregled kredita"
      },
      cashWithdrawalTranslate: {
        title: "Najava podizanja gotovine",
        infoNote1: "Gotovinske isplate stranog / domaćeg efektivnog novca veće od 5.001,00 EUR / 35.001,00 HRK potrebno je najaviti 3 dana unaprijed pisanim zahtjevom putem HYPOneta.",
        infoNote2: "U slučaju nepodizanja gotovine Banka će teretiti Vaš račun za iznos naknade prema važećoj tarifi Banke.",
        fromAccount: "Na teret IBAN-a",
        amount: "Iznos",
        amountRequired: "Iznos je obavezan!",
        dateOfPayout: "Datum isplate",
        phoneNumber: "Telefonski broj",
        placeOfCashTakeover: "Mjesto preuzimanja gotovine",
        placeOfCashTakeoverRequiredMsg: "Mjesto preuzimanja gotovine je obavezno!",
        note: "Napomena",
        confirmBtnLabel: "Potvrdi",
        cancelBtnLabel: "Odustani",
        amountMinAmountError: "Minimalni iznos je "
      },
      reservations: {
        "reservationDate":"Datum rezervacije",
        "transactionType":"Tip transakcije",
        "noData": "Nema dostupnih rezervacija",
        "type": "Type",
        "originAmount": "Original amount"
      },
      transactionDivision: {
        "title": "Podela transakcija",
        "creationDate": "Datum kreiranja zahtjeva",
        "fullName": "Ime i prezime",
        "jmbg": "JMBG",
        "transactionDate": "Datum transakcije",
        "amount": "Iznos",
        "numOfInstallment": "Izaberite broj rata",
        "sellingPlace": "Naziv prodajnog mesta",
        "lastDigits": "Zadnja 4 broja sa kartice",
        "sellingPlaceError": "Naziv prodajnog mesta je obavezno!",
        "lastDigitsError": "Zadnja 4 broja sa kartice su obavezna!",
        "lastDigitsLengthError": "Broj mora imati 4 cifre!",
        "yourTransDiv": "Zahtjevi za podjelu transakcija",
        "transLocation": "Prodajno mjesto",
        "cardNumber": "Broj kartice",
        "status": "Status",
        "creatorName": "Kreator",
        "installmentNumber": "Broj rata"
      }
    };

    $translateProvider
      .translations('sr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "accAllAccountsOverview":"Pregled vseh računov",
        "accAccountsAndCardsOverview": "Pregled vseh računov in kartic",
        "accShowAccounts":"Prikaži več računov",
        "accFilter":"Filtriraj po tipu",
        "accAmountRange":"Razpon zneska",
        "accTo":"Do",
        "accApply":"Potrdi",
        "accReset":"Pobriši filtre",
        "accPeriod":"Obdobje",
        "accDescription":"Opis",
        "accAmount":"Znesek",
        "accBalance":"Porabljen limit",
        "accBalanceSlo":"Odobren limit",
        "accShowOnDashboard":"Prikaži na prvi strani",
        "accTransactions":"Transakcije",
        "accPdfStatements":"PDF izpiski",
        "accDownloadPdf":"Prenesi PDF",
        "accChangeName":"Sprmeni naziv računa",
        "accResetName":"Ponastavi na prvotno ime",
        "accQuickPayment":"Hitro plačilo",
        "accRequestLimit":"Naročilo spremembe limita",
        "accAvailableToSpend":"Razpoložljivo stanje",
        "accReservations":"Rezervacije",
        "accOverdraftLimit":"Limit",
        "accOverdraftLimitDue":"Datum poteka limita",
        "accPayIn":"Vplačilo",
        "accRepaymentPlan":"Plan odplačila",
        "accLoanAmount":"Odobreni znesek",
        "accLoanBalance":"Stanje kredita",
        "accInterestRate":"Obrestna mera",
        "accAnnuity":"Obrok odplačila (anuiteta)",
        "accStartDate":"Datum začetka",
        "accEndDate":"Datum zapadlosti",
        "accDisbursementDate":"Datum odobritve",
        "accDuration":"Čas trajanja",
        "accViewMore":"Prikaži več podatkov",
        "accViewLess":"Prikaži manj podatkov",
        "accTypeOfRate":"Vrsta obrestne mere",
        "accPenaltyInterests":"Zamudne obresti",
        "accOverpayments":"Preplačilo",
        "accOtherFees":"Ostale provizije",
        "accChangeDate":"Datum zadnje spremembe",
        "accAlreadySpent":"Porabljena sredstva",
        "accPayCard":"Poplačilo kartice",
        "accApprovedLimit":"Odobren limit",
        "approvedLimit": "Odobren limit",
        "accDueDate":"Dan plačila porabe",
        "accClosingDate":"Datum poteka",
        "accMonthlyDeposit amount":"N/A",
        "accStatementDeliveryMethod":"Način prejemanja izpiskov",
        "accAccountForRelease":"Račun za sprostitev sredstev",
        "accAnnualAssignment":"Letni pripis obresti",
        "accPayOut":"Izplačilo",
        "accCloseAccount":"Zapri račun",
        "accOpenNewSavingsAccount":"Odpri nov varčevalni račun",
        "accEg":"npr.",
        "accSearchTransactionsPlaceholder":"Išči transakcije",
        "accCancelDeposit":"Prekliči depozit",
        "accCancelAutoExtension":"Prekliči avtomatsko podaljševanje depozita",
        "accNewDeposit":"Nov depozit",
        "accPrincipal":"Glavnica",
        "accInterest":"Obresti",
        "accMaturityDate":"Datum zapadlosti",
        "accCurrentBalance":"Trenutno stanje",
        "accCurrentBalance_SLO":"Razpoložljivo stanje",
        "accAtmWithdrawalLimit":"Dnevni limit za dvige na bankomatu",
        "accPosPaymentLimit":"Prosti limit",
        "accDateLastChanged":"Knjiženo stanje na dan",
        "accBalanceDateLastChanged":"Datum zadnje spremembe",
        "accAvailableBalance":"Razpoložljivo stanje",
        "accSearchAccountsPlaceholder":"Išči račun",
        "accShowMatured":"Prikaži zaprte račune",
        "accAuthorizedPersons":"Pooblaščene osebe",
        "accCardStatus":"Status kartice",
        "accContractNumber":"Številka pogodbe",
        "accDepositStartDate":"Datum sklenitve",
        "accDepositStartDate_SLO":"Datum sklenitve",
        "accDepositEndDate":"Datum zapadlosti",
        "accDepositEndDate_SLO":"Datum zapadlosti",
        "rename": "Preimenuj",
        "accAccountAndCardsMoreDetails": "Prikaz podrobnosti",
        "accAccountAndCardsMoreDetails1": "Prikaz podrobnosti in kartic",
        "accAccountAndCardsLessDetails": "Skrij podatke",
        "accInstallmentsPayed":"Št. plačanih obrokov",
        "accInstallmentNumber": "Skupno število obrokov",
        "accInstallmentsRemain":"Št. preostalih obrokov",
        "accNextInstallmentDate":"Datum sledečega obroka",
        "accNextInstallmentAmount":"Znesek sledečega obroka",
        "connectedDebitCards": "Kartice na računu",
        "blockCard": "Blokiraj kartico",
        "unblockCard": "Odblokiraj kartico",
        "blockCardRequest": "Zahteva za blokado kartice",
        "unblockCardRequest": "Zahteva za deblokado kartice",
        "accDueAmount": "Skupni dolg",
        "accMatureInterest":"Obračunane obresti",
        "accNewEbook": "Nova eKnjižica",
        "closeEbook": "Zapri eKnjižico",
        "accPaymInQue": "Št. nerealiziranih čekov",
        "accReservedAmount": "Rezervirani znesek",
        "accPlanedDebit": "Rezervacija",
        "accDepositInterestRate": "Obrestna mera",
        "accDepositTypeExternal": "Vrsta depozita",
        "accDepositPrincipal": "Glavnica depozita",
        "accLimitValidUntilDate": "Datum poteka kartice",
        "accObligationAmount": "Porabljena sredstva",
        "accOutstandingAmount": "Preostali znesek za plačilo",
        "accCardNumber": "Številka kartice",
        "accInstallmentPaidNumber": "Število plačanih obrokov",
        "accNotMatureCapital": "Nedospela glavnica",
        "accNewDebitDate": "Datum sledečega obroka",
        "title": "Informacija",
        "message":"Blokada oziroma odstranitev blokade kartice prek spletne banke nista mogoči. Prosimo, kontaktirajte banko na telefon +386 1 580 43 00 ali email ebank.si@addiko.com.",
        "message_SLO":"V primeru suma zlorabe, izgube ali kraje kartice morate to takoj prijaviti procesnemu centru, na telefonsko številko +386 (0)1 58 34 183 ali najbližji poslovalnici Addiko banke oziroma kateri koli banki z oznako MasterCard.",
        "close": "Zapri",
        "accHideTransactions": "Skrij transakcije",
        "balance": "Stanje na računu",
        "accParentAccountIban": "Številka računa",
        "accAnnuityConverted": "Obrestna mera",
        "accNotMatureCapitalConverted": "Nedospela glavnica v ",
        "closeRepaymentPlan":"Zapri plan odplačevanja",
        "accHideReservations": "Skrij rezervacije",
        "depositCantBeCanceledError": "Predčasno zaprtje depozita je mogoče samo, če je bil depozit sklenjen prek spletne banke.",
        "Active":"Aktiven",
        "BlockedFromEBank":"Blokirano iz EBanke",
        "expDate":"Datum veljavnosti kartice: ",
        "expDate_SLO":"Veljavnost: ",
        "accTotalMatureConverted": "Skupen dospeli dolg ",
        "Closed":"Odpovedana",
        "eBookPayIn": "Vplačilo na eKnjižico",
        "eBookPayOut": "Izplačilo z eKnjižice",
        "Blocked":"Blokiran",
        "limitForATM": "Limit za dvig gotovine",
        "interestRate": "Obrestna mera",
        "dataNotAvailable": "Podatki niso na voljo",
        "destinationAccount": "Račun sprostitve depozita",
        "interestToDate": "Obresti na dan",
        "extensionType": "Način podaljšanja",
        "depositProlongationNumLeft": "Število preostalih podaljšanj",
        "bindingSpan": "Doba vezave",
        "accountNumber": "Številka računa",
        "untilRevocation": "Do preklica",
        "limitAmountATM": "Dnevni limit za dvige na bankomatih",
        "limitAmountPOS": "Dnevni limit za plačila na POS terminalih",
        "creditCardNumber": "Številka kartice ",
        "BlockedTemporary":"Začasno blokiran",
        "openingDate":"Datum otvoritve",
        "closingDate":"Datum ukinitve",
        "minSavingBalance":"Mesečni polog",
        "minSavingBalance2":"Minimalno stanje na varčevanju",
        "statementDeliveryMethod":"Način pošiljanja izpiskov",
        "annualAssignmentOfInterests":"Letna razmejitev obresti",
        "days": "dni",
        "destinationAccount_SLO": "Račun sprostitve",
        "savedFunds": "Privarčevani znesek",
        "PaidOut":"Izplačan",
        "Extended": "Podaljšan"
      },
      repaymentPlan: {
        "instalment": "Obresti",
        "loanBalance": "Znesek dolga",
        "date": "Datum",
        "dateFrom":"Datum od",
        "dateTo":"Datum do",
        "principalAmount": "Glavnica",
        "paymentAmount": "Anuiteta",
        "interestAmount":"Obresti",
        "totalAnnuity":"Skupen znesek za odplačilo",
        "balance": "Stanje"
      },
      transactions: {
        "description":"Opis",
        "amount":"Znesek",
        "availableAmount":"Razpoložljivi znesek",
        "accountNumber":"Številka računa",
        "bookingDate":"Datum knjiženja",
        "valueDate":"Datum valute",
        "cardTransactionDetails":"Podrobnosti transakcije",
        "transactionDetails":"Podrobnosti transakcije",
        "close":"Zapri",
        "card":"Kartica",
        "iban":"IBAN",
        "noData":"Za izbrano obdobje ni podatkov za prikaz",
        "noStatementData":"Za izbrani račun ni podatkov za prikaz",
        "retrieval": "Vračilo",
        "ibanFrom": "IBAN plačnika",
        "accountFrom": "Z računa",
        "accountTo": "Na račun",
        "referenceNumber":"Referenca",
        "creditorName": "Plačnik",
        "debitorName": "Prejemnik",
        "creditorAddress": "Naslov plačnika",
        "debitorAddress": "Naslov prejemnika",
        "transactionAndOriginalCurrency": "Poraba v originalni valuti",
        "statementDate": "Datum izpiska",
        "creditCardNumber": "Številka kartice",
        "connCardReferenceAccount": "Referenca",
        "payeeCity": "Kraj prejemnika",
        "statementPeriod": "Datum izpiska",
        "balanceSumCredit": "Skupaj v dobro:",
        "balanceSumDebit": "Skupaj v breme:",
        "statementsFilter":"Transakcije z izpiska"

      },
      ebook: {
        "header": "Zahtjev za otvaranje nove eKnjižice",
        "date": "Datum",
        "fullName": "Ime i prezime",
        "firstName": "Ime",
        "lastName": "Prezime",
        "fromAccount": "Račun",
        "eSavingsBookName": "Naziv eKnjižice",
        "termsAndConditions": "Prihvaćam opće uvjete poslovanja",
        "confirm": "Potvrdi",
        "cancel": "Odustani",
        "dateOfCreation":"Datum kreiranja",
        "mainAccount":"Glavni račun",
        "delete":"Izbriši",
        "ebookOrder":"eKnjižica",
        "sign":"Potpiši",
        "name":"Naziv",
        "edit":"Promijeni",
        "enterName": "Unesite naziv",
        "nameError": "Naziv eKnjižice je obavezan!",
        "createEbook": "Kreiraj eKnjižicu",
        "successfullRequest": "Uspješno ste kreirali eKnjižicu",
        "completeRequest": "Zahtjev uspješan!",
        "eBookRequests": "Zahtjevi za eKnjižicu",
        "createdBy": "Kreirao",
        "iban": "IBAN",
        "requestType": "Tip zahtjeva",
        "status": "Status",
        "timelineHeader":"Vremenski prikaz zahtjeva za eKnjižice",
        "showAllRequests": "Prikaži zahteve za vse račune",
        "ebookNumber": "Račun eKnjižice"
      },
      closeEBookPageTranslation: {
        title: "Zahtjev za zatvaranje eKnjižice",
        account: "Broj eKnjižice",
        accountName: "Naziv eKnjižice",
        currency: "Valuta",
        balance: "Stanje",
        recognisedInterestRate: "Priznata kamatna stopa",
        recognisedInterestAmount: "Iznos priznate kamatne stope",
        fee: "Naknada",
        transferAmount: "Iznos za prijenos",
        transferAccount: "Račun za prijenos",
        confirmButton: "Potvrdi",
        cancelButton: "Otkaži"
      },
      accountsOverview: {
        "title": "Pregled osebnih računov in kartic",
        "newTermDepositButtonLabel": "Skleni nov depozit",
        "newESavingAccountButtonLabel": "Dodaj novo eKnjižico",
        "newESavingAccountButtonLabel_SLO": "Skleni novo varčevanje",
        "newSavingButtonLabel_SLO": "Naročilo nove MasterCard kartice",
        "masterCardStateButtonLabel_SLO": "Stanje na predplačniški MasterCard kartici"
      },
      depositAccountsOverview: {
        "title": "Pregled depozitov in varčevanj",
        "titleForSlo": "Pregled depozitov in varčevanj",
        "titleForSerbAndMne": "Pregled vseh depozitov"
      },
      laonsOverview: {
        title: "Pregled kreditov",
        noData: "Ni podatkov za prikaz."
      },
      cashWithdrawalTranslate: {
        title: "Napoved dviga višjega zneska gotovine",
        infoNote1sl: "Za evro (EUR) je potrebno napovedati dvig gotovine za znesek v višini 3.000,00 EUR in več. Za valute: švicarski frank (CHF), britanski funt (GBP), ameriški dolar (USD) in hrvaška kuna (HRK) pa je potrebno napovedati dvig gotovine ne glede na višino zneska. Naročilo je potrebno oddati najmanj dva delovna dneva pred nameravanim dvigom gotovine do 10. ure dopoldne.",
        infoNote2sl: "",
        fromAccount: "Z računa",
        amount: "Znesek",
        amountRequired: "Vnos zneska je obvezen!",
        dateOfPayout: "Datum dviga",
        phoneNumber: "Telefonska številka",
        placeOfCashTakeover: "Poslovalnica",
        placeOfCashTakeoverRequiredMsg: "Izbira poslovalnice je obvezna!",
        note: "Opomba",
        note_SLO: "Gotovino želim prejeti v bankovcih določene višine:",
        confirmBtnLabel: "Potrdi",
        cancelBtnLabel: "Prekliči",
        amountMinAmountError: "Minimalni znesek je ",
        until: "Do 13:00 ure",
        after: "Po 13:00 uri",
        timeOfPayout: "Ura dviga"
      },
      reservations: {
        "reservationDate":"Datum rezervacije",
        "transactionType":"Tip transakcije"
      },
      changeWithdrawal: {
        "header":"Sprememba limita na transakcijskem računu",
        "infoNote1":"Banka bo v naslednjih dneh obravnavala vaše naročilo za pridobitev informacije o možnosti odobritve izrednega limita na transakcijskem računu. O poteku postopka boste v roku 8 delovnih dni obveščeni s strani vašega skrbnika. Stroški odobritve limita se obračunajo po vsakokrat veljavnem",
        "infoNote2":"",
        "infoNote3":"Ceniku storitev Addiko Bank d.d.",
        "fromAccount":"Za račun",
        "amount":"Želena višina prekoračitve sredstev",
        "time":"Za obdobje",
        "spremembo":"Spremembo želim",
        "cancelBtnLabel":"Prekliči",
        "confirmBtnLabel":"Potrdi",
        "amountRequired": "Vnos zneska je obvezen",
        "6months":"6 mesecev",
        "12months":"12 mesecev",
        "option1":"Takoj",
        "option2":"Po poteku obstoječe dovoljene prekoračitve sredstev"
      },
    changeATMWithdrawal: {
      "header": "Sprememba dnevnega limita na bankomatu",
      "infoNote1": "Banka bo vašo vlogo obravnavala v naslednjih dneh. O poteku postopka v zvezi z vašo vlogo boste obveščeni s strani vašega skrbnika.",
      "nameSurname": "Ime",
      "desiredAmount": "Želena višina limita (v EUR)",
      "for": "Za",
      "nameSurnameRequired":"Ime in priimek sta obvezna!"
    },
      savingsSlo: {
        "title":"Open Savings account",
        "infoNote1":"Info 1",
        "infoNote2":"Info 2",
        "infoNote3":"Info 3",
        "vrstaVracevanja":"Vrsta varcevanja",
        "durationInMonths":"Duration in months",
        "maturityDate":"Matrurity date",
        "transfersFromAndToAccount":"Transfers from and to account",
        "initialAmountFromAccount":"Initial amount from account",
        "initialAmount":"Initial account",
        "montlyDepositAmount":"Monthly deposit amount",
        "standingOrderDay":"Standing order day",
        "realInterestRate":"Real interest day",
        "totalInterestRate":"Total interest day",
        "termsAndCondtionsInfo":"I certify that I am aware of Gerenal term and conditions of savings and I agree with them.",
        "info":"Stringam se, da v primeru, če na dogovrjeni....",
        "cancel":"Cancel",
        "confirm":"Confirm"

      },
      masterCard: {
        "header":"Informacija o možnosti pridobitve MasterCard kartice",
        "info":"Banka bo v naslednjih dneh obravnavala vaše naročilo za pridobitev informacije o možnosti pridobitve MasterCard kartice. O poteku postopka v zvezi z vašim naročilom boste obveščeni s strani vašega skrbnika. Stroški se obračunajo po vsakokrat veljavnem ",
        "infoPrice":"Ceniku storitev Addiko Bank d.d.",
        "infoLink1":"Več infromacij o plačilni MasterCard kartici",
        "infoLink2":"Več informacij o zlati MasterCard kartici",
        "infoLink3":"Več infromacij o kreditni MasterCard kartici",
        "cardType":"Tip kartice",
        "creditLimit":"Želeni znesek limita",
        "account":"Račun",
        "paymentDay":"Dan bremenitve",
        "cancel":"Prekliči",
        "confirm":"Potrdi",
        "amount":"Želeni znesek limita",
        cardTypes: {
          "charge":"Addiko plačilna MasterCard kartica",
          "gold":"Addiko zlata MasterCard kartica",
          "revolving":"Addiko kreditna MasterCard kartica",
        },
        "percentType":"Delež obveznosti mesečno"
      },
      masterCardOrder: {
        "orderLimit":"Spremeni limit",
        "header":"Informacija o možnosti spremembe limita na MasterCard kartici",
        "info1": "Limit porabe na MasterCard kartici lahko spremenite za določeno ali nedoločeno časovno obdobje. Informacijo o možnosti spremembe limita porabe lahko pridobite samo za svoj kartični račun. O poteku postopka v zvezi z vašim naročilom boste v roku 8 delovnih dni od dneva oddaje obveščeni s strani vašega skrbnika. Stroški pristopa k storitvi se obračunajo po vsakokrat veljavnem",
        "infoLink": "Ceniku storitev Addiko Bank d.d.",
        "info2":"",
        "cardAccount":"Kartični račun",
        "cardType":"Tip kartice",
        "cardNumber":"Številka plačilne kartice",
        "desiredLimit":"Želeni znesek limita",
        "cancel":"Prekliči",
        "confirm":"Potrdi",
        "amount":"Znesek",
        "limitType":"Vrsta limita",
        "dateFrom":"Od",
        "dateTo":"Do",
        "percentage":"Odstotek od limita osnovne kartice",
        "additional":"Dodatna",
        "basic":"Osnovna"
      }
    };

    $translateProvider
      .translations('sl', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "accAllAccountsOverview":"Pregled svih računa",
        "accShowAccounts":"Prikaži još računa",
        "accFilter":"Filtriraj po tipu",
        "accAmountRange":"Raspon iznosa",
        "accTo":"Do",
        "accApply":"Primijeni",
        "accReset":"Poništi",
        "accPeriod":"Period",
        "accDescription":"Opis",
        "accAmount":"Iznos",
        "accBalance":"Stanje po računu",
        "accShowOnDashboard":"Prikaži na kontrolnoj ploči",
        "accTransactions":"Transakcije",
        "accPdfStatements":"Pdf izvještaji",
        "accDownloadPdf":"Preuzmi PDF",
        "accChangeName":"Promijeni naziv računa",
        "accResetName":"Postavi originalni naziv",
        "accQuickPayment":"Brzo plaćanje",
        "accRequestLimit":"Zahtijevaj promjenu limita",
        "accAvailableToSpend":"Raspoloživi iznos",
        "accReservations":"Rezervacije",
        "accOverdraftLimit":"Iznos prekoračenja",
        "accOverdraftLimitDue":"Datum isteka prekoračenja",
        "accPayIn":"Uplata",
        "accRepaymentPlan":"Prikaži plan otplate",
        "accLoanAmount":"Odobreni iznos",
        "accLoanBalance":"Stanje kredita",
        "accInterestRate":"Kamatna stopa",
        "accAnnuity":"Iznos anuiteta/rate",
        "accStartDate":"Datum početka",
        "accEndDate":"Datum završetka",
        "accDisbursementDate":"Datum odobrenja",
        "accDuration":"Trajanje",
        "accViewMore":"Prikaži više informacija",
        "accViewLess":"Prikaži manje informacija",
        "accTypeOfRate":"Vrsta kamatne stope",
        "accPenaltyInterests":"Zatezna kamata",
        "accOverpayments":"Preplata",
        "accOtherFees":"Druge naknade",
        "accChangeDate":"Poslednja promjena",
        "accAlreadySpent":"Dospjeli troškovi",
        "accPayCard":"Kartično plaćanje",
        "accApprovedLimit":"Odobreni limit",
        "accDueDate":"Rok korištenja",
        "accClosingDate":"Datum zatvarnja",
        "accMonthlyDeposit amount":"Iznos mjesečnog depozita",
        "accStatementDeliveryMethod":"Način isporuke obračuna",
        "accAccountForRelease":"Račun za isplatu",
        "accAnnualAssignment":"Godišnja dodjela kamata",
        "accPayOut":"Isplata",
        "accCloseAccount":"Zatvori račun",
        "accOpenNewSavingsAccount":"Otvori novi štedni račun",
        "accEg":"npr",
        "accSearchTransactionsPlaceholder":"Pretraži transakcije",
        "accCancelDeposit":"Otkaži oročenje",
        "accCancelAutoExtension":"Otkaži automatsko produženje",
        "accNewDeposit":"Novo oročenje",
        "accPrincipal":"Glavnica",
        "accInterest":"Kamata",
        "accMaturityDate":"Datum dospijeća",
        "accCurrentBalance":"Trenutno stanje",
        "accAtmWithdrawalLimit":"Limit za preuzimanje na bankomatu",
        "accPosPaymentLimit":"Limit za preuzimanje u poslovnici",
        "accDateLastChanged":"Poslednja promjena",
        "accBalanceDateLastChanged":"Zadnja promjena stanja",
        "accAvailableBalance":"Raspoloživo stanje",
        "accSearchAccountsPlaceholder":"Pretraži račune",
        "accShowMatured":"Prikaži zatvorene račune",
        "accAuthorizedPersons":"Ovlašćena lica",
        "accCardStatus":"Status kartice",
        "accContractNumber":"Broj ugovora",
        "accDepositStartDate":"Datum oročenja",
        "accDepositEndDate":"Datum isteka oročenja",
        "rename": "Preimenuj",
        "accAccountAndCardsMoreDetails": "Detaljni prikaz",
        "accAccountAndCardsMoreDetails1": "Detalji i platne kartice",
        "accAccountAndCardsLessDetails": "Manje detalja",
        "accInstallmentsPayed":"Rata plaćeno",
        "accInstallmentNumber": "Ukupan broj rata",
        "accInstallmentsRemain":"Preostali broj rata",
        "accNextInstallmentDate":"Datum sljedeće rate",
        "accNextInstallmentAmount":"Iznos sljedeće rate",
        "connectedDebitCards": "Povezane kartice",
        "blockCard": "Blokiraj karticu",
        "unblockCard": "Odblokiraj karticu",
                "blockCardRequest": "Poslat zahtjev za blokadu",
        "unblockCardRequest": "Poslat zahtjev za odblokiranje",
        "accDueAmount": "Ukupan dospjeli dug",
        "accMatureInterest":"Nominalna kamatna stopa",
        "accNewEbook": "Nova eknjižica",
        "closeEbook": "Zatvaranje eknjižice",
        "accPaymInQue": "Broj nerealizovanih čekova",
        "accReservedAmount": "Rezervisani iznos",
        "accPlanedDebit": "Rezervacija",
        "accDepositInterestRate": "Kamatna stopa na depozit",
        "accDepositTypeExternal": "Deposit Type External",
        "accDepositPrincipal": "Ugovoreni iznos depozita",
        "accLimitValidUntilDate": "Datum isteka kartice",
        "accObligationAmount": "Tekući troškovi",
        "accOutstandingAmount": "Nedospjele obaveze na rate",
        "accCardNumber": "Broj kartice",
        "accInstallmentPaidNumber": "Broj plaćenih rata",
        "accNotMatureCapital": "Nedospjela glavnica",
        "accNewDebitDate": "Datum iduće obaveze",
        "title": "Informacija",
        "message":"Molimo Vas nazovite Kontakt centar na besplatni broj telefona 0800 14 14 ili na +385 1 6030 000 za pozive iz inozemstva.",
        "close": "Zatvori",
        "accHideTransactions": "Sakrij transakcije",
        "balance": "Stanje računa",
        "accParentAccountIban": "Glavni račun",
        "accAnnuityConverted": "Iznos anuiteta u ",
        "accNotMatureCapitalConverted": "Nedospjela glavnica u ",
        "closeRepaymentPlan":"Zatvori otplatni plan",
        "accHideReservations": "Sakrij rezervacije",
        "depositCantBeCanceledError": "Prijevremeni prekid oročenja moguć je samo za oročenja ugovorena putem usluga direktnog bankarstva. ",
        "Active":"Aktivan",
        "BlockedFromEBank":"Blokirano iz E-banke",
        "expDate":"Datum isteka kartice: ",
        "Closed":"Zatvoren",
        "eBookPayIn": "Uplata na eknjižicu",
        "Blocked":"Blokiran"
      },
      repaymentPlan: {
        "instalment": "Rata",
        "loanBalance": "Iznos duga",
         "date": "Datum",
        "dateFrom":"Datum od",
        "dateTo":"Datum do",
        "principalAmount": "Glavnica",
        "paymentAmount": "Anuitet",
        "interestAmount":"Kamata",
        "totalAnnuity":"Ukupan iznos za otplatu ",
        "balance": "Stanje"
      },
      transactions: {
        "description":"Opis",
        "amount":"Iznos",
        "availableAmount":"Raspoloživi iznos",
        "accountNumber":"Broj računa",
        "bookingDate":"Datum knjiženja",
        "valueDate":"Datum valute",
        "cardTransactionDetails":"Detalji transakcije",
        "transactionDetails":"Detalji transakcije",
        "close":"Zatvori",
        "card":"Kartica",
        "iban":"IBAN",
        "noData":"Za odabrani period nema podataka za prikaz",
        "noStatementData":"Za odabrani račun nema podataka za prikaz",
        "retrieval": "Povraćaj",
        "ibanFrom": "Račun platioca",
        "accountFrom": "Račun platioca",
        "accountTo": "Račun primaoca",
        "referenceNumber":"Referentni broj",
        "creditorName": "Uplatilac",
        "debitorName": "Primalac",
        "creditorAddress": "Adresa uplatioca",
        "debitorAddress": "Adresa primaoca",
        "date":"Datum transakcije"
      },
      ebook: {
        "header": "Zahtjev za otvaranje eknjižice",
        "date": "Datum",
        "fullName": "Ime i prezime",
        "firstName": "Ime",
        "lastName": "Prezime",
        "fromAccount": "Račun",
        "eSavingsBookName": "Naziv eknjižice",
        "termsAndConditions": "Prihvaćam opće uvjete poslovanja",
        "confirm": "Potvrdi",
        "cancel": "Odustani",
        "dateOfCreation":"Datum kreiranja",
        "mainAccount":"Glavni račun",
        "delete":"Obriši",
        "sign":"Potpiši",
        "name":"Naziv",
        "edit":"Promijeni",
        "enterName": "Unesite naziv",
        "nameError": "Naziv eknjižice je obavezan!",
        "createEbook": "Kreiraj eknjižicu",
        "successfullRequest": "Uspješno ste kreirali eknjižicu",
        "completeRequest": "Zahtjev uspješan!",
        "eBookRequests": "eKnjižica zahtjevi",
        "createdBy": "Kreirao",
        "iban": "IBAN",
        "requestType": "Tip zahtjeva",
        "status": "Status",
        "timelineHeader":"Vremenski prikaz zahtjeva za eknjižice",
        "showAllRequests": "Prikaži zahtjeve za sve račune",
        "ebookNumber": "Račun eknjižice"
      },
      closeEBookPageTranslation: {
        title: "Zahtjev za zatvaranje eknjižice",
        account: "Broj eknjižice",
        accountName: "Naziv eknjižice",
        currency: "Valuta",
        balance: "Stanje",
        recognisedInterestRate: "Priznata kamatna stopa",
        recognisedInterestAmount: "Iznos priznate kamatne stope",
        fee: "Naknada",
        transferAmount: "Iznos za prijenos",
        transferAccount: "Račun za prijenos",
        confirmButton: "Potvrdi",
        cancelButton: "Otkaži"
      },
      accountsOverview: {
        "title": "Pregled svih računa i kartica",
        "newTermDepositButtonLabel": "Dodaj novo oročenje",
        "newESavingAccountButtonLabel": "Dodaj novi eSaving račun"
      },
      depositAccountsOverview: {
        "title": "Pregled svih oročenja i eknjižica",
        "titleForSlo": "Pregled depozitov in varčevanj",
        "titleForSerbAndMne": "Pregled svih oročenja"
      },
      laonsOverview: {
        title: "Pregled kredita"
      },
      cashWithdrawalTranslate: {
        title: "Najava podizanja gotovine",
        infoNote1: "Gotovinske isplate stranog / domaćeg efektivnog novca veće od 5.001,00 EUR / 35.001,00 HRK potrebno je najaviti 3 dana unaprijed pisanim zahtjevom putem HYPOneta.",
        infoNote2: "U slučaju nepodizanja gotovine Banka će teretiti Vaš račun za iznos naknade prema važećoj tarifi Banke.",
        fromAccount: "Na teret IBAN-a",
        amount: "Iznos",
        amountRequired: "Iznos je obavezan!",
        dateOfPayout: "Datum isplate",
        phoneNumber: "Telefonski broj",
        placeOfCashTakeover: "Mjesto preuzimanja gotovine",
        placeOfCashTakeoverRequiredMsg: "Mjesto preuzimanja gotovine je obavezno!",
        note: "Napomena",
        confirmBtnLabel: "Potvrdi",
        cancelBtnLabel: "Odustani",
        amountMinAmountError: "Minimalni iznos je "
      },
      reservations: {
        "reservationDate":"Datum rezervacije",
        "transactionType":"Tip transakcije"
      }
    };

    $translateProvider
      .translations('mne', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "accAllAccountsOverview":"Pregled svih računa",
        "accAccountsAndCardsOverview": "Pregled svih računa i kartica",
        "accShowAccounts":"Prikaži još računa",
        "accFilter":"Filtriraj po tipu",
        "accAmountRange":"Raspon iznosa",
        "accTo":"Do",
        "accApply":"Primijeni",
        "accReset":"Poništi",
        "accPeriod":"Period",
        "accDescription":"Opis",
        "accAmount":"Iznos",
        "accBalance":"Dospjeli troškovi",
        "accShowOnDashboard":"Prikaži na kontrolnoj ploči",
        "accTransactions":"Transakcije",
        "accPdfStatements":"Pdf izvještaji",
        "accDownloadPdf":"Preuzmi PDF",
        "accChangeName":"Promijeni naziv računa",
        "accResetName":"Postavi izvorni naziv",
        "accQuickPayment":"Brzo plaćanje",
        "accRequestLimit":"Zahtijevaj promjenu limita",
        "accAvailableToSpend":"Raspoloživi iznos",
        "accReservations":"Rezervacije",
        "accOverdraftLimit":"Iznos prekoračenja",
        "accOverdraftLimitDue":"Datum isteka prekoračenja",
        "accPayIn":"Uplata",
        "accRepaymentPlan":"Prikaži plan otplate",
        "accLoanAmount":"Odobreni iznos",
        "accLoanBalance":"Stanje kredita",
        "accInterestRate":"Kamatna stopa",
        "accAnnuity":"Iznos anuiteta/rate",
        "accStartDate":"Datum početka",
        "accEndDate":"Datum završetka",
        "accDisbursementDate":"Datum odobrenja",
        "accDuration":"Trajanje",
        "accViewMore":"Prikaži više informacija",
        "accViewLess":"Prikaži manje informacija",
        "accTypeOfRate":"Vrsta kamatne stope",
        "accPenaltyInterests":"Zatezna kamata",
        "accOverpayments":"Preplata",
        "accOtherFees":"Druge naknade",
        "accChangeDate":"Datum zadnje promjene",
        "accAlreadySpent":"Dospjeli troškovi",
        "accPayCard":"Kartično plaćanje",
        "accApprovedLimit":"Odobreni limit",
        "accDueDate":"Rok korištenja",
        "accClosingDate":"Datum zatvarnja",
        "accMonthlyDeposit amount":"Iznos mjesečnog depozita",
        "accStatementDeliveryMethod":"Način isporuke obračuna",
        "accAccountForRelease":"Račun za isplatu",
        "accAnnualAssignment":"Godišnja dodjela kamata",
        "accPayOut":"Isplata",
        "accCloseAccount":"Zatvori račun",
        "accOpenNewSavingsAccount":"Otvori novi štedni račun",
        "accEg":"npr",
        "accSearchTransactionsPlaceholder":"Pretraži transakcije",
        "accCancelDeposit":"Otkaži oročenje",
        "accCancelAutoExtension":"Otkaži automatsko produženje",
        "accNewDeposit":"Novo oročenje",
        "accPrincipal":"Glavnica",
        "accInterest":"Kamata",
        "accMaturityDate":"Datum dospijeća",
        "accCurrentBalance":"Trenutno stanje",
        "accAtmWithdrawalLimit":"Limit za preuzimanje na bankomatu",
        "accPosPaymentLimit":"Limit za preuzimanje u poslovnici",
        "accDateLastChanged":"Datum zadnje promjene",
        "accBalanceDateLastChanged":"Datum zadnje promjene ",
        "accAvailableBalance":"Raspoloživo stanje",
        "accSearchAccountsPlaceholder":"Pretraži račune",
        "accShowMatured":"Prikaži zatvorene račune",
        "accAuthorizedPersons":"Ovlaštene osobe",
        "accCardStatus":"Status kartice",
        "accContractNumber":"Broj ugovora",
        "accDepositStartDate":"Datum oročenja",
        "accDepositEndDate":"Datum isteka oročenja",
        "rename": "Preimenuj",
        "accAccountAndCardsMoreDetails": "Detaljni prikaz",
        "accAccountAndCardsMoreDetails1": "Detalji i platne kartice",
        "accAccountAndCardsLessDetails": "Manje detalja",
        "accInstallmentsPayed":"Rata plaćeno",
        "accInstallmentNumber": "Ukupan broj rata",
        "accInstallmentsRemain":"Preostali broj rata",
        "accNextInstallmentDate":"Datum sljedeće rate",
        "accNextInstallmentAmount":"Iznos sljedeće rate",
        "connectedDebitCards": "Povezane kartice",
        "blockCard": "Blokiraj karticu",
        "unblockCard": "Odblokiraj karticu",
         "blockCardRequest": "Zahtjev za blokadu",
        "unblockCardRequest": "Zahtjev ",
        "accDueAmount": "Ukupan dospjeli dug",
        "accMatureInterest":"Dospjela redovna kamata",
        "accNewEbook": "Nova eKnjižica",
        "closeEbook": "Zatvaranje eKnjižice",
        "accPaymInQue": "Broj nerealiziranih čekova",
        "accReservedAmount": "Rezervirani iznos",
        "accPlanedDebit": "Rezervacija",
        "accDepositInterestRate": "Kamatna stopa na depozit",
        "accDepositTypeExternal": "Deposit Type External",
        "accDepositPrincipal": "Ugovoreni iznos depozita",
        "accLimitValidUntilDate": "Datum isteka kartice",
        "accObligationAmount": "Tekući troškovi",
        "accOutstandingAmount": "Nedospjele obveze na rate",
        "accCardNumber": "Broj kartice",
        "accInstallmentPaidNumber": "Broj plaćenih rata",
        "accNotMatureCapital": "Nedospjela glavnica",
        "accNewDebitDate": "Datum iduće obveze",
        "title": "Informacija",
        "message":"Molimo Vas nazovite Kontakt centar na besplatni broj telefona 0800 14 14 ili na +385 1 6030 000 za pozive iz inozemstva.",
        "close": "Zatvori",
        "accHideTransactions": "Sakrij transakcije",
        "balance": "Stanje računa",
        "accParentAccountIban": "Glavni račun",
        "accAnnuityConverted": "Iznos anuiteta u ",
        "accNotMatureCapitalConverted": "Nedospjela glavnica u ",
        "closeRepaymentPlan":"Zatvori otplatni plan",
        "accHideReservations": "Sakrij rezervacije",
        "depositCantBeCanceledError": "Prijevremeni prekid oročenja moguć je samo za oročenja ugovorena putem usluga direktnog bankarstva. ",
        "Active":"Aktivan",
        "BlockedFromEBank":"Blokirano iz E-banke",
        "expDate":"Datum isteka kartice: ",
        "accTotalMatureConverted": "Ukupan dospjeli dug u ",
         "Closed":"Zatvoren",
        "eBookPayIn": "Uplata na eKnjižicu",
        "eBookPayOut": "Isplata sa eKnjižice",
        "Blocked":"Blokiran",
        "transDivisionBtn1": "Podjela",
        "transDivisionBtn2": "transakcija"
      },
      repaymentPlan: {
        "instalment": "Rata",
        "loanBalance": "Iznos duga",
        "date": "Datum",
        "dateFrom":"Datum od",
        "dateTo":"Datum do",
        "principalAmount": "Glavnica",
        "paymentAmount": "Anuitet",
        "interestAmount":"Kamata",
        "totalAnnuity":"Ukupan iznos za otplatu",
        "balance": "Stanje"
      },
      transactions: {
        "description":"Opis",
        "amount":"Iznos",
        "availableAmount":"Raspoloživi iznos",
        "accountNumber":"Broj računa",
        "bookingDate":"Datum knjiženja",
        "valueDate":"Datum valute",
        "cardTransactionDetails":"Detalji transakcije",
        "transactionDetails":"Detalji transakcije",
        "close":"Zatvori",
        "card":"Kartica",
        "iban":"IBAN",
        "noData":"Za odabrani period nema podataka za prikaz",
        "noStatementData":"Za odabrani račun nema podataka za prikaz",
        "retrieval": "Povrat",
        "ibanFrom": "IBAN platitelja",
        "accountFrom": "Račun platitelja",
        "accountTo": "Račun primatelja",
        "referenceNumber":"Referentni broj",
        "creditorName": "Platitelj",
        "debitorName": "Primatelj",
        "creditorAddress": "Adresa platitelja",
        "debitorAddress": "Adresa primatelja",
        "date":"Datum transakcije"
      },
      ebook: {
        "header": "Zahtjev za otvaranje nove eKnjižice",
        "date": "Datum",
        "fullName": "Ime i prezime",
        "firstName": "Ime",
        "lastName": "Prezime",
        "fromAccount": "Račun",
        "eSavingsBookName": "Naziv eKnjižice",
        "termsAndConditions": "Prihvaćam opće uvjete poslovanja",
        "confirm": "Potvrdi",
        "cancel": "Odustani",
        "dateOfCreation":"Datum kreiranja",
        "mainAccount":"Glavni račun",
        "delete":"Izbriši",
        "ebookOrder":"eKnjižica",
        "sign":"Potpiši",
        "name":"Naziv",
        "edit":"Promijeni",
        "enterName": "Unesite naziv",
        "nameError": "Naziv eKnjižice je obavezan!",
        "createEbook": "Kreiraj eKnjižicu",
        "successfullRequest": "Uspješno ste kreirali eKnjižicu",
        "completeRequest": "Zahtjev uspješan!",
        "eBookRequests": "Zahtjevi za eKnjižicu",
        "createdBy": "Kreirao",
        "iban": "IBAN",
        "requestType": "Tip zahtjeva",
        "status": "Status",
        "timelineHeader":"Vremenski prikaz zahtjeva za eKnjižice",
        "showAllRequests": "Prikaži zahtjeve za sve račune",
        "ebookNumber": "Račun eKnjižice"
      },
      closeEBookPageTranslation: {
        title: "Zahtjev za zatvaranje eKnjižice",
        account: "Broj eKnjižice",
        accountName: "Naziv eKnjižice",
        currency: "Valuta",
        balance: "Stanje",
        recognisedInterestRate: "Priznata kamatna stopa",
        recognisedInterestAmount: "Iznos priznate kamatne stope",
        fee: "Naknada",
        transferAmount: "Iznos za prijenos",
        transferAccount: "Račun za prijenos",
        confirmButton: "Potvrdi",
        cancelButton: "Otkaži"
      },
      accountsOverview: {
        "title": "Pregled svih računa i kartica",
        "newTermDepositButtonLabel": "Dodaj novo oročenje",
        "newESavingAccountButtonLabel": "Dodaj novu eKnjižicu"
      },
      depositAccountsOverview: {
        "title": "Pregled svih oročenja i eKnjižica",
        "titleForSlo": "Pregled depozitov in varčevanj",
        "titleForSerbAndMne": "Pregled svih oročenja"
      },
      laonsOverview: {
        title: "Pregled kredita"
      },
      cashWithdrawalTranslate: {
        title: "Najava podizanja gotovine",
        infoNote1: "Gotovinske isplate stranog / domaćeg efektivnog novca veće od 5.001,00 EUR / 35.001,00 HRK potrebno je najaviti 3 dana unaprijed.",
        infoNote2: "U slučaju nepodizanja gotovine Banka će teretiti Vaš račun za iznos naknade prema važećoj tarifi Banke.",
        fromAccount: "Na teret IBAN-a",
        amount: "Iznos",
        amountRequired: "Iznos je obavezan!",
        dateOfPayout: "Datum isplate",
        phoneNumber: "Telefonski broj",
        placeOfCashTakeover: "Mjesto preuzimanja gotovine",
        placeOfCashTakeoverRequiredMsg: "Mjesto preuzimanja gotovine je obavezno!",
        note: "Napomena",
        confirmBtnLabel: "Potvrdi",
        cancelBtnLabel: "Odustani",
        amountMinAmountError: "Minimalni iznos je "
      },
      reservations: {
        "reservationDate":"Datum rezervacije",
        "transactionType":"Tip transakcije",
        "noData": "Nema dostupnih rezervacija",
        "type": "Type",
        "originAmount": "Original amount"
      },
      transactionDivision: {
        "title": "Podjela transakcija",
        "creationDate": "Datum kreiranja zahtjeva",
        "fullName": "Ime i prezime",
        "jmbg": "JMBG",
        "transactionDate": "Datum transakcije",
        "amount": "Iznos",
        "numOfInstallment": "Izaberite broj rata",
        "sellingPlace": "Naziv prodajnog mjesta",
        "lastDigits": "Zadnja 4 broja sa kartice",
        "sellingPlaceError": "Naziv prodajnog mjesta je obavezno!",
        "lastDigitsError": "Zadnja 4 broja sa kartice su obavezna!",
        "lastDigitsLengthError": "Broj mora imati 4 znamenke!",
        "yourTransDiv": "Zahtjevi za podjelu transakcija",
        "transLocation": "Prodajno mjesto",
        "cardNumber": "Broj kartice",
        "status": "Status",
        "creatorName": "Kreator",
        "installmentNumber": "Broj rata"
      }
    };

    $translateProvider
      .translations('hr', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "accAllAccountsOverview":"All accounts overview",
        "accShowAccounts":"Show more accounts",
        "accFilter":"Filter by type",
        "accAmountRange":"Amount range",
        "accTo":"To",
        "accApply":"Apply",
        "accReset":"Reset",
        "accPeriod":"Period",
        "accDescription":"Description",
        "accAmount":"Amount",
        "accBalance":"Balance",
        "accBalanceSlo":"Approved limit",
        "accShowOnDashboard":"Show on dashboard",
        "accTransactions":"Transactions",
        "accPdfStatements":"Pdf statements",
        "accDownloadPdf":"Download PDF",
        "accChangeName":"Change account name",
        "accResetName":"Reset to original name",
        "accQuickPayment":"Quick payment",
        "accRequestLimit":"Request limit change",
        "accAvailableToSpend":"Available to spend",
        "accReservations":"Reservations",
        "accOverdraftLimit":"Overdraft limit",
        "accOverdraftLimitDue":"Overdraft expiration date",
        "accPayIn":"Pay in",
        "accRepaymentPlan":"View repayment plan",
        "accLoanAmount":"Approved amount",
        "accLoanBalance":"Loan balance",
        "accInterestRate":"Interest rate p.a.",
        "accAnnuity":"Annuity",
        "accStartDate":"Start date",
        "accEndDate":"End date",
        "accDisbursementDate":"Date of approval",
        "accDuration":"Duration",
        "accViewMore":"View more information",
        "accViewLess":"View less information",
        "accTypeOfRate":"Type of interest rates",
        "accPenaltyInterests":"Penalty interests",
        "accOverpayments":"Overpayments",
        "accOtherFees":"Other fees",
        "accChangeDate":"Change date",
        "accAlreadySpent":"You have already spent",
        "accPayCard":"Pay card",
        "accApprovedLimit":"Approved limit",
        "accDueDate":"Due date",
        "accClosingDate":"Closing date",
        "accMonthlyDepositAmount":"Monthly deposit amount",
        "accStatementDeliveryMethod":"Statement delivery method",
        "accAccountForRelease":"Account for release",
        "accAnnualAssignment":"Annual assignment of interest",
        "accPayOut":"Pay out",
        "accCloseAccount":"Close account",
        "accOpenNewSavingsAccount":"Open new savings account",
        "accEg":"eg",
        "accSearchTransactionsPlaceholder":"Search transactions",
        "accCancelDeposit":"Cancel deposit",
        "accCancelAutoExtension":"Cancel auto extension",
        "accNewDeposit":"New deposit",
        "accPrincipal":"Principal",
        "accInterest":"Interest",
        "accMaturityDate":"Maturity date",
        "accCurrentBalance":"Current balance",
        "accCurrentBalance_SLO":"Available balance",
        "accAtmWithdrawalLimit":"ATM withdrawal limit",
        "accPosPaymentLimit":"Available balance",
        "accDateLastChanged":"Closing balance on",
        "accBalanceDateLastChanged":"Last balance change",
        "accAvailableBalance":"Available balance",
        "accSearchAccountsPlaceholder":"Search accounts",
        "accShowMatured":"Show matured accounts",
        "accAuthorizedPersons":"Authorized persons",
        "accCardStatus":"Card status",
        "accContractNumber":"Contract number",
        "accDepositStartDate":"Deposit start date",
        "accDepositStartDate_SLO":"Deposit start date",
        "accDepositEndDate":"Deposit end date",
        "accDepositEndDate_SLO":"Maturity date",
        "rename": "Rename",
        "accAccountAndCardsMoreDetails": "Show additional details",
        "accAccountAndCardsMoreDetails1": "Show additional details and cards",
        "accAccountAndCardsLessDetails": "Less details",
        "accInstallmentsPayed":"Installments payed",
        "accInstallmentNumber": "Installments number",
        "accInstallmentsRemain":"Installments remain",
        "accNextInstallmentDate":"Next installment date",
        "accNextInstallmentAmount":"Next installment amount",
        "connectedDebitCards": "Connected cards",
        "blockCard": "Block card",
        "unblockCard": "Unblock card",
        "blockCardRequest": "Block request sent",
        "unblockCardRequest": "Unblock request sent",
        "accDueAmount": "Total mature debt",
        "accMatureInterest":"Mature interest",
        "accNewEbook": "New e-Book",
        "closeEbook": "Close e-Book",
        "accPaymInQue": "Unprocessed cheques",
        "accReservedAmount": "Reserved amount",
        "accPlanedDebit": "Planed debit",
        "accDepositInterestRate": "Deposit interest rate",
        "accDepositTypeExternal": "Deposit Type External",
        "accDepositPrincipal": "Deposit principal",
        "accLimitValidUntilDate": "Limit valid until date",
        "accObligationAmount": "Obligation amount",
        "accOutstandingAmount": "Outstanding amount",
        "accCardNumber": "Card number",
        "accInstallmentPaidNumber": "Installments paid number",
        "accNotMatureCapital": "Not mature capital",
        "accNewDebitDate": "New debit date",
        "title": "Information",
        "message": "Please call our free Contact center number 0800 14 14 or +385 1 6030 000 for international calls.",
        "message_SLO": "In case of fraud suspicion, loss or theft of the card you must immediately inform processing centre on telephone number +386 (0)1 58 34 183 or nearest branch of Addiko bank or any bank with MasterCard sign.",
        "message_BH": "Card is blocked by Bank. More information at Contact Center.",
        "close": "Close",
        "accHideTransactions": "Hide transactions",
        "balance": "Balance",
        "accParentAccountIban": "Main account",
        "accAnnuityConverted": "Interest rate",
        "accNotMatureCapitalConverted": "Not mature capital in ",
        "closeRepaymentPlan":"Close repayment plan",
        "accHideReservations": "Hide reservations",
        "depositCantBeCanceledError": "Early termination of term deposits is possible only for term contracted through direct banking services.",
        cardStatus: {
          "Active":"Active",
          "BlockedFromEBank":"Blocked From EBank",
          "Closed":"Closed",
          "Blocked":"Blocked"
        },
        "Active":"Active",
         "BlockedFromEBank":"Blocked From EBank",
         "expDate":"Expiry date: ",
         "expDate_SLO":"Valid until: ",
        "accTotalMatureConverted": "Total mature debt in ",
         "Closed":"Closed",
        "eBookPayIn": "Pay in",
        "eBookPayOut": "Pay out",
        "Blocked":"Blocked",
        "dataNotAvailable": "Data not available",
        "approvedLimit": "Approved limit",
        "transDivisionBtn1": "Transaction",
        "transDivisionBtn2": "division",
        "limitForATM": "Limit for ATM cash withdrawal",
        "destinationAccount": "Destination account",
        "interestRate": "Interest rate",
        "interestToDate": "Interests to date",
        "extensionType": "Extension type",
        "depositProlongationNumLeft": "Prolongation left number",
        "bindingSpan": "Binding span",
        "accountNumber": "Account number",
        "untilRevocation": "Until revocation",
        "limitAmountATM": "Limit for daily ATM withdrawals",
        "limitAmountPOS": "Limit for daily POS payments",
        "creditCardNumber": "Credit Card number",
        "BlockedTemporary":"Temporary block",
        "openingDate":"Date of opening",
        "closingDate":"Closing date",
        "minSavingBalance":"Monthly deposit amount",
        "minSavingBalance2":"Minimum deposit amount",
        "statementDeliveryMethod":"Statement delivery method",
        "annualAssignmentOfInterests":"Annual assignment of interests",
        "days": "days",
        "destinationAccount_SLO": "Destination account",
        "savedFunds": "Saved funds",
        "PaidOut":"Paid Out",
        "Extended": "Extended"
      },
      repaymentPlan: {
        "instalment": "Instalment",
        "loanBalance": "Loan balance",
        "date": "Date",
        "dateFrom":"Date from",
        "dateTo":"Date to",
        "principalAmount": "Principal amount",
        "paymentAmount": "Payment amount",
        "interestAmount":"Interest amount",
        "totalAnnuity":"Total annuity",
        "balance": "Balance"
      },
      transactions: {
        "description":"Description",
        "amount":"Amount",
        "availableAmount":"Available amount",
        "accountNumber":"Account number",
        "bookingDate":"Booking date",
        "valueDate":"Value date",
        "cardTransactionDetails":"Card transaction details",
        "transactionDetails":"Transaction details",
        "close":"Close",
        "card":"Card",
        "iban":"IBAN",
        "noData":"No transaction data for selected period",
        "noStatementData":"No statement data for selected account",
        "retrieval": "Retrieval",
        "ibanFrom": "From IBAN",
        "ibanFromBh": "From BBAN/IBAN",
        "accountFrom": "From account",
        "accountTo": "To account",
        "referenceNumber":"Reference number",
        "creditorName": "Payer",
        "debitorName": "Recipient",
        "creditorAddress": "Payer address",
        "debitorAddress": "Recipient address",
        "transactionAndOriginalCurrency": "Transaction in original currency",
        "statementDate": "Statement date",
        "creditCardNumber": "Credit Card number",
        "connCardReferenceAccount": "Reference number",
        "date":"Transaction date",
        "payeeCity": "Recipient city",
        "statementPeriod": "Statement period",
        "balanceSumCredit": "Total credit amount:",
        "balanceSumDebit": "Total debit amount:",
        "statementsFilter":"Transactions from statement"
      },
      ebook: {
        "header": "Create new eSaving book",
        "date": "Date",
        "dateOfCreation":"Date of creation",
        "fullName": "Name and Surname",
        "mainAccount":"Main account",
        "firstName": "First name",
        "lastName": "Last name",
        "fromAccount": "From account",
        "eSavingsBookName": "e-Savings book name",
        "termsAndConditions": "I accept terms and conditions",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "edit":"Edit",
        "delete":"Delete",
        "ebookOrder":"e-Saving book",
        "sign":"Sign",
        "name":"Name",
        "enterName": "Enter name",
        "nameError": "E-Book name is required!",
        "createEbook": "Create e-Saving book",
        "successfullRequest": "You have successfully created e-Savings book",
        "completeRequest": "Request completed!",
        "eBookRequests": "E-Book requests",
        "createdBy": "Created by",
        "iban": "IBAN",
        "requestType": "Request type",
        "status": "Status",
        "timelineHeader":"E-book requests timeline",
        "showAllRequests": "Show requests for all accounts",
        "ebookNumber": "E-book number"
      },
      closeEBookPageTranslation: {
        title: "Request for closing",
        account: "Account",
        accountName: "Account name",
        currency: "Currency",
        balance: "Balance",
        recognisedInterestRate: "Recognised interest rate",
        recognisedInterestAmount: "Recognised interest amount",
        fee: "Fee",
        transferAmount: "Transfer amount",
        transferAccount: "Transfer account",
        confirmButton: "Confirm",
        cancelButton: "Cancel"
      },
      accountsOverview: {
        "title": "Accounts and Cards overview",
        "newTermDepositButtonLabel": "Add new Term Deposit",
        "newESavingAccountButtonLabel": "Add new eSaving book",
        "newESavingAccountButtonLabel_SLO": "Add new Saving",
        "newSavingButtonLabel_SLO": "New MasterCard order",
        "masterCardStateButtonLabel_SLO": "Prepaid MasterCard balance"
      },
      depositAccountsOverview: {
        "title": "Deposits and e-books overview",
        "titleForSlo": "Term deposits and Savings overview",
        "titleForSerbAndMne": "Deposits overview",
        "titleForBh": "Savings overview"
      },
      laonsOverview: {
        title: "Loans overview",
        noData: "No data is available."
      },
      cashWithdrawalTranslate: {
        title: "Order of large cash withdrawal",
        infoNote1: "Cash withdrawals in foreign exchange/kuna exceeding 5.001,00 EUR / 35.001,00 HRK must be announced 3 days in advance.",
        infoNote2: "In case you do not make the announced withdrawal your account will be charged with a corresponding fee ammount in accordance with the Bank Tariff.",
        infoNote1sl: "For withdrawals of cash in euros (EUR), you need to inform us if the amount is equal or higher than 3.000,00 EUR. For Swiss franc (CHF), British pound (GBP), American dollar (USD) and Croatian kuna (HRK) you need to inform us regardless of the amount. The order needs to be submitted at least two working days before the intended cash withdrawal by 10.00 am.",
        infoNote2sl: "",
        fromAccount: "From account",
        amount: "Amount",
        amountRequired: "Amount is required!",
        dateOfPayout: "Date of payout",
        phoneNumber: "Telephone number",
        placeOfCashTakeover: "Branch office",
        placeOfCashTakeoverRequiredMsg: "Branch office is required!",
        note: "Note",
        note_SLO: "I would like to receive cash in notes of the following denominations:",
        confirmBtnLabel: "Confirm",
        cancelBtnLabel: "Cancel",
        amountMinAmountError: "Minimal amount is ",
        until: "Until 13:00",
        after: "After 13:00",
        timeOfPayout: "Time of payout"
      },
      reservations: {
        "reservationDate":"Reservation date",
        "transactionType":"Transaction type",
        "noData": "No reservations data",
        "type": "Type",
        "originAmount": "Original amount"
      },
      transactionDivision: {
        "title": "Transaction division",
        "creationDate": "Creation date",
        "fullName": "Full name",
        "jmbg": "JMBG",
        "transactionId":"Transaction ID",
        "reservationNumber":"Reservation number",
        "transactionDate": "Transaction date",
        "amount": "Amount",
        "numOfInstallment": "Select number of installment",
        "sellingPlace": "Name of selling place",
        "lastDigits": "Last 4 digits of the card",
        "sellingPlaceError": "Selling place is required!",
        "lastDigitsError": "Last 4 digits of the card are required!",
        "lastDigitsLengthError": "Number must have 4 digits!",
        "yourTransDiv": "Your transaction division",
        "transLocation": "Transaction location",
        "cardNumber": "Card number",
        "status": "Status",
        "creatorName": "Creator name",
        "installmentNumber": "Installment number",
        "cancel":"Cancel",
        "confirm":"Confirm",
        "successMessage":"Request successfully submitted.",
        "finalStepStatus":"Status:",
        "finalStepId":"TransactionID:",
        "finalStepSentForProcessing":"Transaction was sent to bank for processing.",
        "makeAnotherPayment":"Make another transaction",
        "Opened":"Opened",
        "Rejected":"Rejected",
        "WaitingQueue":"WaitingQueue",
        "Processed":"Successfully processed",
        "InProcessing":"In process",
        "installmentInfo": "Number of installment"
      },
      changeWithdrawal: {
        "header":"Change personal account overdraft",
        "infoNote1":" The Bank will process your order in the next few days. You will be notified of the progress by your client manager within eight working days. Overdraft approval costs shall be charged according to the valid ",
        "infoNote2":"",
        "infoNote3":"Pricelist of Addiko Bank d.d.",
        "fromAccount":"For account",
        "amount":"Desired overdraft amount",
        "time":"For period",
        "spremembo":"I want the change to take effect",
        "cancelBtnLabel":"Cancel",
        "confirmBtnLabel":"Submit",
        "amountRequired": "Amount required",
        "6months":"6 Months",
        "12months":"12 Months",
        "option1":"Immediately",
        "option2":"After the expiry of the existing authorized overdraft"
      },
      changeATMWithdrawal: {
        "header": "Change ATM withdrawal limit",
        "infoNote1": "The Bank will process your order in the next few days. You will be notified of the progress of your order by your client manager.",
        "nameSurname": "Name and surname",
        "desiredAmount": "Desired amount (in EUR)",
        "for": "For",
        "nameSurnameRequired":"Name and surname are required!"
      },
      savingsSlo: {
        "title":"Open Savings account",
        "infoNote1":"Info 1",
        "infoNote2":"Info 2",
        "infoNote3":"Info 3",
        "vrstaVracevanja":"Vrsta varcevanja",
        "durationInMonths":"Duration in months",
        "maturityDate":"Matrurity date",
        "transfersFromAndToAccount":"Transfers from and to account",
        "initialAmountFromAccount":"Initial amount from account",
        "initialAmount":"Initial account",
        "montlyDepositAmount":"Monthly deposit amount",
        "standingOrderDay":"Standing order day",
        "realInterestRate":"Real interest day",
        "totalInterestRate":"Total interest day",
        "termsAndCondtionsInfo":"I certify that I am aware of Gerenal term and conditions of savings and I agree with them.",
        "info":"Stringam se, da v primeru, če na dogovrjeni....",
        "cancel":"Cancel",
        "confirm":"Confirm"

      },
      masterCard: {
        "header":"Information on the possibility to obtain MasterCard",
        "info":"The bank will process your order to obtain a MasterCard in the next few days. You will be notified of the progress of your order by your client manager. Costs shall be charged according to the valid ",
        "infoPrice":"Addiko Bank d.d. Pricelist",
        "infoLink1":"More information about Addiko Charge MasterCard",
        "infoLink2":"More information about Addiko Gold MasterCard",
        "infoLink3":"More information about Addiko Revolving MasterCard",
        "cardType":"Credit card type",
        "creditLimit":"Desired limit amount",
        "account":"Account",
        "paymentDay":"Payment day",
        "cancel":"Cancel",
        "confirm":"Confirm",
        "amount":"Desired limit amount",
        cardTypes: {
          "charge":"Addiko Charge MasterCard",
          "gold":"Addiko Gold MasterCard",
          "revolving":"Addiko Revolving MasterCard"
        },
        "percentType":"Percentage of used limit to be paid monthly"
      },
      masterCardOrder: {
        "orderLimit":"Change limit",
        "header":"Information on the possibility to change MasterCard limit",
        "info1": "The limit on your MasterCard can be granted for an unlimited duration or for a specific time period. You can only change the limit on your own card account. You will be notified of the progress of your order by your client manager within eight working days. Approval costs shall be charged according to the valid",
        "infoLink": "Pricelist of Addiko Bank d.d.",
        "info2":"",
        "cardAccount":"Card account",
        "cardType":"Card type",
        "cardNumber":"Credit card number",
        "desiredLimit":"Desired limit amount",
        "cancel":"Cancel",
        "confirm":"Confirm",
        "amount":"Amount",
        "limitType":"Limit type",
        "dateFrom":"From",
        "dateTo":"To",
        "percentage":"Precentage of the limit of the general card",
        "additional":"Additional",
        "basic":"General"
      }
    };

    $translateProvider
      .translations('en', data);

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider"];
  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "accAllAccountsOverview":"Pregled svih računa",
        "accShowAccounts":"Prikaži još računa",
        "accFilter":"Filtriraj po tipu",
        "accAmountRange":"Raspon iznosa",
        "accTo":"Do",
        "accApply":"Primjeni",
        "accReset":"Poništi",
        "accPeriod":"Period",
        "accDescription":"Opis",
        "accAmount":"Iznos",
        "accBalance":"Stanje po računu",
        "accShowOnDashboard":"Prikaži na kontrolnoj ploči",
        "accTransactions":"Transakcije",
        "accPdfStatements":"Pdf izvodi",
        "accDownloadPdf":"Preuzmi PDF",
        "accChangeName":"Promijeni naziv računa",
        "accResetName":"Postavi originalni/izvorni naziv",
        "accQuickPayment":"Brzo plaćanje",
        "accRequestLimit":"Zahtjevaj promjenu limita",
        "accAvailableToSpend":"Raspoloživi iznos",
        "accReservations":"Rezervacije",
        "accOverdraftLimit":"Iznos prekoračenja",
        "accOverdraftLimitDue":"Datum isteka prekoračenja",
        "accPayIn":"Uplata",
        "accRepaymentPlan":"Prikaži plan otplate",
        "accLoanAmount":"Odobreni iznos",
        "accLoanBalance":"Stanje kredita",
        "accInterestRate":"Kamatna stopa",
        "accAnnuity":"Iznos anuiteta/rate",
        "accStartDate":"Datum početka",
        "accEndDate":"Datum završetka",
        "accDisbursementDate":"Datum plasmana",
        "accDuration":"Trajanje",
        "accViewMore":"Prikaži više informacija",
        "accViewLess":"Prikaži manje informacija",
        "accTypeOfRate":"Vrsta kamatne stope",
        "accPenaltyInterests":"Zatezna kamata",
        "accOverpayments":"Preplata",
        "accOtherFees":"Druge naknade",
        "accChangeDate":"Datum zadnje promjene",
        "accAlreadySpent":"Dospjeli troškovi",
        "accPayCard":"Kartično plaćanje",
        "accApprovedLimit":"Odobreni limit",
        "accDueDate":"Rok korištenja",
        "accClosingDate":"Datum zatvaranja",
        "accMonthlyDeposit amount":"Iznos mjesečnog depozita",
        "accStatementDeliveryMethod":"Način isporuke obračuna",
        "accAccountForRelease":"Račun za isplatu",
        "accAnnualAssignment":"Godišnja dodjela kamata",
        "accPayOut":"Isplata",
        "accCloseAccount":"Zatvori račun",
        "accOpenNewSavingsAccount":"Otvori novi štedni račun",
        "accEg":"npr",
        "accSearchTransactionsPlaceholder":"Pretraži transakcije",
        "accCancelDeposit":"Otkaži oročenje",
        "accCancelAutoExtension":"Otkaži automatsko produženje",
        "accNewDeposit":"Novo oročenje",
        "accPrincipal":"Glavnica",
        "accInterest":"Kamata",
        "accMaturityDate":"Datum dospjeća",
        "accCurrentBalance":"Trenutno stanje",
        "accAtmWithdrawalLimit":"Limit za preuzimanje na bankomatu",
        "accPosPaymentLimit":"Limit za preuzimanje u poslovnici",
        "accDateLastChanged":"Datum zadnje promjene",
        "accBalanceDateLastChanged":"Datum zadnje promjene",
        "accAvailableBalance":"Raspoloživo stanje",
        "accSearchAccountsPlaceholder":"Pretraži račune",
        "accShowMatured":"Prikaži zatvorene račune",
        "accAuthorizedPersons":"Ovlaštene osobe/lica",
        "accCardStatus":"Status kartice",
        "accContractNumber":"Broj ugovora",
        "accDepositStartDate":"Datum oročenja",
        "accDepositEndDate":"Datum isteka oročenja",
        "rename": "Preimenuj",
        "accAccountAndCardsMoreDetails": "Detaljni prikaz",
        "accAccountAndCardsMoreDetails1": "Detalji i platne kartice",
        "accAccountAndCardsLessDetails": "Manje detalja",
        "accInstallmentsPayed":"Rata plaćeno",
        "accInstallmentNumber": "Ukupan broj rata",
        "accInstallmentsRemain":"Preostali broj anuiteta",
        "accNextInstallmentDate":"Datum sljedeće rate",
        "accNextInstallmentAmount":"Iznos sljedeće rate",
        "connectedDebitCards": "Povezane kartice",
        "blockCard": "Blokiraj karticu",
        "unblockCard": "Odblokiraj karticu",
        "blockCardRequest": "Zahtjev za blokadu poslan",
        "unblockCardRequest": "Zahtjev za deblokadu poslan",
        "accDueAmount": "Iznos dospjelog duga",
        "accMatureInterest":"Kamata",
        "accNewEbook": "Nova eKnjižica",
        "closeEbook": "Zatvaranje eKnjižice",
        "accPaymInQue": "Broj nerealizovanih čekova",
        "accReservedAmount": "Rezervirani/Rezervisani iznos",
        "accPlanedDebit": "Rezervacija",
        "accDepositInterestRate": "Kamatna stopa na depozit",
        "accDepositTypeExternal": "Deposit Type External",
        "accDepositPrincipal": "Ugovoreni iznos depozita",
        "accLimitValidUntilDate": "Datum isteka kartice",
        "accObligationAmount": "Tekući troškovi",
        "accOutstandingAmount": "Nedospjele obaveze na rate",
        "accCardNumber": "Broj kartice",
        "accInstallmentPaidNumber": "Broj obračunatih anuiteta",
        "accNotMatureCapital": "Nedospjela glavnica",
        "accNewDebitDate": "Datum iduće obveze/obaveze",
        "title": "Informacija",
        "message_BH":"Kartica je blokirana u Banci. Molimo obratite se Kontakt centru.",
        "close": "Zatvori",
        "accHideTransactions": "Sakrij transakcije",
        "balance": "Stanje računa",
        "accParentAccountIban": "Glavni račun",
        "accAnnuityConverted": "Iznos anuiteta u ",
        "accNotMatureCapitalConverted": "Nedospjela glavnica u ",
        "closeRepaymentPlan":"Zatvori otplatni plan",
        "accHideReservations": "Sakrij rezervacije",
        "depositCantBeCanceledError": "Prijevremeni prekid oročenja moguć je samo za oročenja ugovorena putem usluga direktnog bankarstva. ",
        "cardStatus": {
          "Active":"Aktivna",
          "BlockedFromEBank":"Blokirano iz E-banke",
          "Closed":"Zatvorena",
          "Blocked":"Blokirana"
        },
        "Active":"Aktivan",
        "BlockedFromEBank":"Blokirano iz E-banke",
        "expDate":"Datum isteka kartice: ",
        "Closed":"Zatvoren",
        "eBookPayIn": "Uplata na eKnjižicu",
        "Blocked":"Blokiran",
        "transDivisionBtn1": "Podjela",
        "transDivisionBtn2": "transakcija",
      },
      repaymentPlan: {
        "instalment": "Rata",
        "loanBalance": "Iznos duga",
        "date": "Datum",
        "dateFrom":"Datum od",
        "dateTo":"Datum do",
        "principalAmount": "Glavnica",
        "paymentAmount": "Anuitet",
        "interestAmount":"Kamata",
        "totalAnnuity":"Ukupan iznos za otplatu ",
        "balance": "Stanje"
      },
      transactions: {
        "description":"Opis",
        "amount":"Iznos",
        "availableAmount":"Raspoloživi iznos",
        "accountNumber":"Broj računa",
        "bookingDate":"Datum knjiženja",
        "valueDate":"Datum valute",
        "cardTransactionDetails":"Detalji transakcije",
        "transactionDetails":"Detalji transakcije",
        "close":"Zatvori",
        "card":"Kartica",
        "iban":"IBAN",
        "noData":"Za odabrani period nema podataka za prikaz",
        "noStatementData":"Za odabrani račun nema podataka za prikaz",
        "retrieval": "Povrat",
        "ibanFromBh": "BBAN/IBAN platitelja/platioca",
        "accountFrom": "Račun platitelja/platioca",
        "accountTo": "Račun primatelja/primaoca",
        "referenceNumber":"Referentni broj",
        "creditorName": "Platitelj/Uplatilac",
        "debitorName": "Primatelj/Primalac",
        "creditorAddress": "Adresa platitelja/uplatioca",
        "debitorAddress": "Adresa primatelja/primaoca",
        "connCardReferenceAccount":"Referentni broj",
        "transactionAndOriginalCurrency":"Iznos u originalnoj valuti"
      },
      ebook: {
        "header": "Zahtjev za otvaranje eKnjižice",
        "date": "Datum",
        "fullName": "Ime i prezime",
        "firstName": "Ime",
        "lastName": "Prezime",
        "fromAccount": "Račun",
        "eSavingsBookName": "Naziv eKnjižice",
        "termsAndConditions": "Saglasan sa općim/opštim uvjetima/uslovima poslovanja",
        "confirm": "Potvrdi",
        "cancel": "Odustani",
        "dateOfCreation":"Datum kreiranja",
        "mainAccount":"Glavni račun",
        "delete":"Obriši",
        "sign":"Potpiši",
        "name":"Naziv",
        "edit":"Promijeni",
        "enterName": "Unesite naziv",
        "nameError": "Naziv eKnjižice je obavezan!",
        "createEbook": "Kreiraj eKnjižicu",
        "successfullRequest": "Uspješno ste kreirali eKnjižicu",
        "completeRequest": "Zahtjev uspješan!",
        "eBookRequests": "Zahtjevi za eKnjižicu",
        "createdBy": "Kreirao",
        "iban": "IBAN",
        "requestType": "Tip zahtjeva",
        "status": "Status",
        "timelineHeader":"Vremenski prikaz zahtjeva za Eknjižice",
        "showAllRequests": "Prikaži zahtjeve za sve račune",
        "ebookNumber": "Račun eKnjižice"
      },
      closeEBookPageTranslation: {
        title: "Zahtjev za zatvaranje eKnjižice",
        account: "Broj eKnjižice",
        accountName: "Naziv eKnjižice",
        currency: "Valuta",
        balance: "Stanje",
        recognisedInterestRate: "Priznata kamatna stopa",
        recognisedInterestAmount: "Iznos priznate kamatne stope",
        fee: "Naknada",
        transferAmount: "Iznos za prijenos/prenos",
        transferAccount: "Račun za prijenos/prenos",
        confirmButton: "Potvrdi",
        cancelButton: "Otkaži"
      },
      accountsOverview: {
        "title": "Pregled svih računa i kartica",
        "newTermDepositButtonLabel": "Dodaj novo oročenje",
        "newESavingAccountButtonLabel": "Dodaj novu eKnjižicu"
      },
      depositAccountsOverview: {
        "title": "Pregled svih oročenja",
        "titleForSlo": "Pregled depozitov in varčevanj",
        "titleForBh": "Pregled štednih računa"
      },
      laonsOverview: {
        title: "Pregled kredita"
      },
      cashWithdrawalTranslate: {
        title: "Najava podizanja gotovine",
        infoNote1: "",
        infoNote2: "",
        fromAccount: "Na teret IBAN-a",
        amount: "Iznos",
        amountRequired: "Iznos je obavezan!",
        dateOfPayout: "Datum isplate",
        phoneNumber: "Telefonski broj",
        placeOfCashTakeover: "Mjesto preuzimanja gotovine",
        placeOfCashTakeoverRequiredMsg: "Mjesto preuzimanja gotovine je obavezno!",
        note: "Napomena",
        confirmBtnLabel: "Potvrdi",
        cancelBtnLabel: "Odustani",
        amountMinAmountError: "Minimalni iznos je "
      },
      reservations: {
        "reservationDate":"Datum rezervacije",
        "transactionType":"Tip transakcije",
        "noData": "Nema dostupnih rezervacija",
        "type": "Type",
        "originAmount": "Original amount"
      },
      transactionDivision: {
        "title": "Podjela transakcija",
        "creationDate": "Datum kreiranja zahtjeva",
        "fullName": "Ime i prezime",
        "jmbg": "JMBG",
        "transactionId":"ID transakcije",
        "reservationNumber":"Broj rezervacije",
        "transactionDate": "Datum transakcije",
        "amount": "Iznos",
        "numOfInstallment": "Izaberite broj rata",
        "sellingPlace": "Naziv prodajnog mjesta",
        "lastDigits": "Zadnja 4 broja sa kartice",
        "sellingPlaceError": "Naziv prodajnog mjesta je obavezno!",
        "lastDigitsError": "Zadnja 4 broja sa kartice su obavezna!",
        "lastDigitsLengthError": "Broj mora imati 4 znamenke/cifre!",
        "yourTransDiv": "Zahtjevi za podjelu transakcija",
        "transLocation": "Prodajno mjesto",
        "cardNumber": "Broj kartice",
        "status": "Status",
        "creatorName": "Kreator",
        "installmentNumber": "Broj rata",
        "cancel":"Odustani",
        "confirm":"Potvrdi",
        "successMessage":"Zahtjev je uspješno podnešen.",
        "finalStepStatus":"Status:",
        "finalStepId":"Broj transakcije:",
        "finalStepSentForProcessing":"Transakcija je poslana u Banku na obradu.",
        "makeAnotherPayment":"Kreiraj novu transakciju",
        "Opened":"Otvoren",
        "Rejected":"Odbijen",
        "WaitingQueue":"Na čekanju",
        "Processed":"Uspješno obrađen",
        "InProcessing":"U obradi",
        "installmentInfo": "Broj rata"
      }
    };

    $translateProvider
      .translations('bh', data);

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name viber
   * @description
   *
   */
  angular
    .module('viber', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('viber')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('viber', {
        url: '/viber',
        templateUrl: 'viber/viber.tpl.html',
        controller: 'ViberCtrl',
        controllerAs: 'viber',
        resolve: {
          checkViberCountry: ["$q", "$state", "ConfigEndpointService", "UserSettingsService", function ($q, $state, ConfigEndpointService, UserSettingsService){
            return ConfigEndpointService.getDefaultData()
              .then(function (response){
                return UserSettingsService.getPage()
                  .then(function (userData){
                    if((response.APILocation == 'sl')|| !userData.result[0].isViberUser){
                      $state.go('dashboard');
                      return $q.reject('Unknown Viber service');
                    }
                  })
              })
          }]
        }
      })
      .state('viber.activate', {
        url: '/activate',
        views: {
          '@': {
            templateUrl: 'viber/viber-activate.tpl.html',
            controller: 'ViberActivateCtrl',
            controllerAs: 'viberActivate',
            resolve: {
              userIsViberActivated: ["$q", "$state", "ViberService", function ($q, $state, ViberService){
                return ViberService.checkActivation()
                  .then(function (response){
                    //in case user is activated navigate to deactivate page
                    if(response.result){
                      $state.go('viber.deactivate');
                      return $q.reject('User is activated!');
                    }
                  })
                  .catch(function (err){

                  });
              }],
              userCountry: ["ConfigEndpointService", "UserSettingsService", function (ConfigEndpointService, UserSettingsService) {
                return ConfigEndpointService.getDefaultData()
                  .then(function (response){
                    return response.APILocation;
                  })
              }]
            }
          }
        }
      })
      .state('viber.deactivate', {
        url: '/deactivated',
        views: {
          '@': {
            templateUrl: 'viber/viber-deactivated.tpl.html',
            controller: 'ViberDeactivatedCtrl',
            controllerAs: 'viberDeactivate',
            resolve: {
              userIsViberActivated: ["$q", "$state", "ViberService", function ($q, $state, ViberService){
                return ViberService.checkActivation()
                  .then(function (response){
                    //in case user is deactivated navigate to eactivate page
                    if(!response.result){
                      $state.go('viber.activate');
                      return $q.reject('User is deactivated!');
                    }
                  })
                  .catch(function (err){

                  });
              }]
            }
          }
        }
      })
      .state('viber.activate-new', {
        url: '/activate-new',
        views: {
          '@': {
            templateUrl: 'viber/viber-activate-new.tpl.html',
            controller: 'ViberActivateNewCtrl',
            controllerAs: 'viberActivateNew'
          }
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name viber.controller:ViberDeactivatedCtrl
   *
   * @description
   *
   */
  ViberDeactivatedCtrl.$inject = ["$rootScope", "$state", "ViberService", "AlertService", "HelperService"];
  angular
    .module('viber')
    .controller('ViberDeactivatedCtrl', ViberDeactivatedCtrl);

  function ViberDeactivatedCtrl($rootScope, $state,ViberService, AlertService, HelperService) {
    var vm = this;

    vm.gsm = '123123';
    vm.date = '12.10.2017';
    function deactivate () {
      var userId = $rootScope.APP_GLOBAL_SETTINGS.userSettings.id;
      ViberService.deactivate(userId, {
        deactivateViberUser: true,
        isWebCall: true
      })
        .then(function (res) {
          AlertService.infoAlert({
            text: "viber.activationSuccess"
          })
            .then(function (){
              //after successful deactivation go to dashboard page
              $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = false;
              $state.go('dashboard');
            });
        })
        .catch(function (err) {
          HelperService.showMessage(err, 'error');
        })
    }

    vm.deactivateViber = function () {
      AlertService.viberDeactivateAlert()
        .then(function (response) {
          if(response) {
            if(response) {
              deactivate();
            }
          }
        })
        .catch(function () {

        });
    };

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name viber.controller:ViberCtrl
   *
   * @description
   *
   */
  ViberCtrl.$inject = ["$rootScope"];
  angular
    .module('viber')
    .controller('ViberCtrl', ViberCtrl);

  function ViberCtrl($rootScope) {
    var vm = this;
    vm.agree = false;
    vm.bankAddition = "";
    vm.conditionLink = "";

    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'bh') {
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.BiHLocation == "Banja Luka") {
        vm.bankAddition = "a.d.";
        vm.conditionLink = "https://www.addiko-rs.ba/sites/addiko.rs.ba/files/content/file/file_download/abrs_oup_e-banking_m_banking_sms_viber_20170215.pdf";
      } else {
        vm.bankAddition = "d.d.";
        vm.conditionLink = "https://www.addiko-fbih.ba/sites/addiko.ba/files/content/file/file_download/abfed_oup_e-banking_m_banking_sms_20170217.pdf";
      }
    } else if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sr') {
      vm.conditionLink = "https://www.addiko-fbih.ba/sites/addiko.ba/files/content/file/file_download/abfed_oup_e-banking_m_banking_sms_20170217.pdf";
    } else if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'mne') {
      vm.conditionLink = "https://www.addiko.me/sites/addiko.me/files/content/opsti_uslovi_koriscenja_usluga_elektronskog_bankarstva_za_fizicka_lica_v.3.00.pdf";

    } else if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr') {
      vm.conditionLink = "https://www.addiko.hr/static/uploads/addiko-opci-uvjeti-koristenja-usluga-direktnog-bankarstva-za-gradane-11.07.2017.pdf";

    }
    vm.checkViberActivation = function () {
      return $rootScope.APP_GLOBAL_SETTINGS.defaultData.ViberSmsActivation;
    };

    function init() {
      console.log("Initiate viber controller");
    };
    init();

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name viber.controller:ViberActivateNewCtrl
   *
   * @description
   *
   */
  ViberActivateNewCtrl.$inject = ["$rootScope", "$state", "$translate", "ViberService", "HelperService"];
  angular
    .module('viber')
    .controller('ViberActivateNewCtrl', ViberActivateNewCtrl);

  function ViberActivateNewCtrl($rootScope, $state, $translate, ViberService, HelperService) {
    var vm = this;
    vm.ctrlName = 'ViberActivateNewCtrl';

    vm.activate = function () {
      ViberService.activate({phoneNumber: "string"})
        .then(function (response) {
            //$rootScope.APP_GLOBAL_SETTINGS.isViberActivated = true;
            //$state.go('viber.deactivate');
            var message = $translate.instant('viber.smsSent');
            HelperService.showTranslatedMessage('success', message);
        })
        .catch(function (err) {
          HelperService.showMessage(err, 'error');
        });
    };

    vm.becomeFollower = function () {
      ViberService.becomeFollower()
        .then(function (response) {
          if(response.result){
            var message = $translate.instant('viber.successFollower');
            HelperService.showTranslatedMessage('success', message);
          }
        })
        .catch(function (err) {
          HelperService.showMessage(err, 'error');
        });
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name viber.controller:ViberActivateCtrl
   *
   * @description
   *
   */
  ViberActivateCtrl.$inject = ["$rootScope", "ViberService", "HelperService", "userCountry"];
  angular
    .module('viber')
    .controller('ViberActivateCtrl', ViberActivateCtrl);

  function ViberActivateCtrl($rootScope, ViberService, HelperService, userCountry) {
    var vm = this;
    vm.qrCodeUrl = "";
    vm.text = "";

    if(userCountry != 'hr') {
      vm.scanQrCodeConditions = ["viber.scanQrCodeC1", "viber.scanQrCodeC2", "viber.scanQrCodeC3", "viber.scanQrCodeC4", "viber.scanQrCodeC5", "viber.scanQrCodeC6"];
      vm.activationCodeConditions = ["viber.activationCodeC1", "viber.activationCodeC2", "viber.activationCodeC3", "viber.activationCodeC4", "viber.activationCodeC5", "viber.activationCodeC6", "viber.activationCodeC7", "viber.activationCodeC8"];
    } else {
      vm.scanQrCodeConditions = ["viber.scanQrCodeC7", "viber.scanQrCodeC8"];
      vm.activationCodeConditions = ["viber.activationCodeC9", "viber.activationCodeC10"];
    }

    vm.additionalActivationConditions = ["viber.additionalActivation1", "viber.additionalActivation2", "viber.additionalActivation3"];


    function init () {
      console.log("Viber activate init controller...");
      ViberService.activate({
        phoneNumber: "string"
      })
        .then(function (response) {
          $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = true;
          vm.qrCodeUrl = response.qrCode;
          vm.text = response.text;
        })
        .catch(function (err){
          HelperService.showMessage(err, 'error');
        });
    };

    init();
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name user
   * @description
   *
   */
  angular
    .module('user', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name user.factory:UserSettingsService
   *
   * @description
   *
   */
  UserSettingsService.$inject = ["EndpointsService", "$q", "$http", "$log", "HelperService"];
  angular
    .module('user')
    .factory('UserSettingsService', UserSettingsService);

  function UserSettingsService(EndpointsService, $q, $http, $log, HelperService) {
    var UserSettingsServiceBase = {};

    UserSettingsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $log.debug("Params:", params);
        $http.get(response.links.userSettings, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    UserSettingsServiceBase.validateUserInfoOrders = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.userInfoOrders_validate, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    UserSettingsServiceBase.updateUserInfoOrders = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.userInfoOrders, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    UserSettingsServiceBase.getAll = function (params) {
      var predefinedParams =
      {
        page: 0
        , pageSize: 1000
      };
      var extended = _.extend(predefinedParams, params);
      return UserSettingsServiceBase.getPage(extended);
    };


    UserSettingsServiceBase.updateInvoiceEmail = function (email, userId) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.userSettings_id.replace('{id}', userId), email)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    UserSettingsServiceBase.userHaveFunds = function () {
      return this.getPage()
        .then(function (response) {
          if (_.isArray(response.result) && response.result[0].fundUserId) {
            return true;
          } else {
            return false;
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
          return false;
        });
    };

    UserSettingsServiceBase.insertUserSettings = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.userSettings_insertUserNotificationSettings, params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };
    UserSettingsServiceBase.updateUserSettings = function (userId, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.userSettings_updateUserNotificationSettings.replace('{id}', userId), params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    UserSettingsServiceBase.updateUserMobileSetting = function (param) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.userSettings.concat("/updateUserMobileSetting?enabled={p}").replace('{p}', param))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    return UserSettingsServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('user')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('user', {
        url: '/user',
        templateUrl: 'user/user.tpl.html',
        controller: 'UserCtrl',
        controllerAs: 'user'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name user.controller:UserCtrl
   *
   * @description
   *
   */
  angular
    .module('user')
    .controller('UserCtrl', UserCtrl);

  function UserCtrl() {
    var vm = this;
    vm.ctrlName = 'UserCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name transactions
   * @description
   *
   */
  angular
    .module('transactions', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name transactions.factory:TransactionsService
   *
   * @description
   *
   */
  TransactionsService.$inject = ["EndpointsService", "$q", "$http", "$log", "HelperService"];
  angular
    .module('transactions')
    .factory('TransactionsService', TransactionsService);

  function TransactionsService(EndpointsService, $q, $http, $log, HelperService) {
    var TransactionsServiceBase = {};

    TransactionsServiceBase.getPage = function(params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function(response){
        $log.debug("Params:", params);
        $http.get(response.links.transactions, { params: params})
          .success(function(data) {
            deferred.resolve(data);
          }).error(function(msg, code) {
            deferred.reject(msg);
          });
      }, function(error){
        deferred.reject(error);
      });
      return deferred.promise;
    };

    TransactionsServiceBase.getById = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.transactions_id.replace('{id}', id), {params: params})
          .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    // New method for transactions downlaoding
    TransactionsServiceBase.getTransactionPdfLink = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.transactions_downloadLink_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    TransactionsServiceBase.downloadTransactionPdf = function(id){
      var nonBlockingWindow = window.open('', '_self');
      TransactionsServiceBase.getTransactionPdfLink(id)
        .then(function (pdfLink) {
          if(pdfLink){
            // If we want to open link in same tab (immediate download)
            // window.location.href = pdfLink.url;

            // Opening in new empty tab
            nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(pdfLink.url);
          }
        })
        .catch(function (error) {
          nonBlockingWindow.close();
          HelperService.showMessage(error, 'error');
          $log.debug(error);
        });
    };

    TransactionsServiceBase.insertComplaint = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.orders, params)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return TransactionsServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('transactions')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('transactions', {
        url: '/transactions',
        abstract: true
        //templateUrl: 'transactions/transactions.tpl.html',
        //controller: 'TransactionsCtrl',
        //controllerAs: 'transactions'
      })
      .state('transactions.reclamation', {
        url: '/reclamation/:transactionId',
        params: {
          transactionId: null,
          accountId: null,
          url: null
        },
        views: {
          '@': {
            templateUrl: 'transactions/transactions-reclamation.tpl.html',
            controller: 'TransactionsReclamationCtrl',
            controllerAs: 'tReclamation'
          }
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name transactions.controller:TransactionsReclamationCtrl
   *
   * @description
   *
   */
  TransactionsReclamationCtrl.$inject = ["$rootScope", "$stateParams", "$log", "$state", "$localStorage", "TransactionsService", "HelperService", "ConfigEndpointService", "MessagesService", "ValidationService"];
  angular
    .module('transactions')
    .controller('TransactionsReclamationCtrl', TransactionsReclamationCtrl);

  function TransactionsReclamationCtrl($rootScope, $stateParams, $log, $state, $localStorage, TransactionsService, HelperService,
                                       ConfigEndpointService, MessagesService, ValidationService) {
    var vm = this;
    vm.tempReclamationObj = {};
    vm.formSubmitted = false;
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

    vm.init = function () {
      if ($stateParams.transactionId) {
        if (!$localStorage.code) {
          getDefaultData();
        }
        loadTransaction($stateParams.transactionId);
      }
    };

    vm.createReclamation = function () {
      var params = {};

      vm.formSubmitted = true;

      switch ($localStorage.code) {

        case 'hr':
        case 'sl':
          params = {
            transactionId: $stateParams.transactionId,
            reclamationText: vm.tempReclamationObj.reclamationInput || " ",
            referenceNumber: vm.tempReclamationObj.referenceNumber
          };
          TransactionsService.insertComplaint(params)
            .then(function (response) {
              if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                HelperService.confirmationReclamationMsg('core.confirmationSlo');
              } else {
                HelperService.confirmationReclamationMsg('core.confirmation');
              }
              $state.go('accounts', {accountId: vm.tempReclamationObj.accountId});
            })
            .catch(function (error) {
              vm.formSubmitted = false;
              HelperService.showMessage(error, 'error');
            });
          break;
        case 'sr':
        case 'bh':
          params = {
            subject: vm.tempReclamationObj.id,
            body: vm.tempReclamationObj.reclamationInput || " "
          };
          MessagesService.sendMessage(params)
            .then(function (response) {
              $state.go('accounts', {accountId: vm.tempReclamationObj.accountId});
            })
            .catch(function (error) {
              vm.formSubmitted = false;
              HelperService.showMessage(error, 'error');
            });
          break;
        case 'mne':
          params = {
            subject: vm.tempReclamationObj.referenceNumber,
            body: vm.tempReclamationObj.reclamationInput || " "
          };
          MessagesService.sendMessage(params)
            .then(function (response) {
              $state.go('accounts', {accountId: vm.tempReclamationObj.accountId});
            })
            .catch(function (error) {
              vm.formSubmitted = false;
              HelperService.showMessage(error, 'error');
            });
          break;
      }
    };

    var loadTransaction = function (id) {
      TransactionsService.getById(id)
        .then(function (response) {
          vm.tempReclamationObj = response;
          $log.debug('Transaction object: ', response);
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    var getDefaultData = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
          if (response.APILocation) {
            $localStorage.code = response.APILocation;
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.cancel = function () {
      if($state.params.accountId && $state.params.url ){
        $state.go($state.params.url,{
           accountId: $state.params.accountId
        });
      }
    }
    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name transactions.controller:TransactionsCtrl
   *
   * @description
   *
   */
  angular
    .module('transactions')
    .controller('TransactionsCtrl', TransactionsCtrl);

  function TransactionsCtrl() {
    var vm = this;
    vm.ctrlName = 'TransactionsCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name timeline
   * @description
   *
   */
  angular
    .module('timeline', [
      'ui.router'
    ]);
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name timeline.factory:TimelineService
     *
     * @description
     *
     */
    TimelineService.$inject = ["EndpointsService", "$q", "$http", "$log", "$uibModal"];
    angular
        .module('timeline')
        .factory('TimelineService', TimelineService);

    function TimelineService(EndpointsService, $q, $http, $log, $uibModal) {
        var TimelineServiceBase = {};

        TimelineServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.timeline, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        TimelineServiceBase.getAll = function (params) {
            var predefinedParams = {
                page: 0,
                pageSize: 1000
            };
            var extended = _.extend(predefinedParams, params);
            return TimelineServiceBase.getPage(extended);
        };

        TimelineServiceBase.openTimelineItemDetailsModal = function (timelineItem) {
            var modalInstance = $uibModal.open({
                templateUrl: 'timeline/timeline-item-details-modal.tpl.html',
                controller: 'TimelineItemDetailsModalCtrl',
                controllerAs: 'tlItemDetailsModal',
                resolve: {
                    timelineItem: function () {
                        return timelineItem;
                    }
                },
                backdrop: 'static'
            });
        };

      TimelineServiceBase.syncTimeline = function () {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.sync)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg, code);
          });
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

        return TimelineServiceBase;


    }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('timeline')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('timeline', {
        url: '/timeline',
        templateUrl: 'timeline/timeline.tpl.html',
        controller: 'TimelineCtrl',
        controllerAs: 'timeline'
      });
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name timeline.controller:TimelineItemDetailsModalCtrl
     *
     * @description
     *
     */
    TimelineItemDetailsModalCtrl.$inject = ["timelineItem", "$log", "TimelineService", "$uibModalInstance", "TransactionsService", "AccountsService", "EInvoiceDocumentsService", "MessagesService"];
    angular
        .module('timeline')
        .controller('TimelineItemDetailsModalCtrl', TimelineItemDetailsModalCtrl);

    function TimelineItemDetailsModalCtrl(timelineItem, $log, TimelineService, $uibModalInstance, TransactionsService, AccountsService, EInvoiceDocumentsService, MessagesService) {
        var vm = this;
        vm.ctrlName = 'TimelineItemDetailsModalCtrl';
        vm.timelineItem = timelineItem;
        vm.closeModal = function () {
            $uibModalInstance.close();
        };

        vm.transaction = {};
        vm.account = {};
        vm.einvoice = {};
        vm.message = {};

        vm.getDateObjectfromDateString = function (dateString) {
            return new Date(dateString);
        };

        vm.init = function () {
            //    alert(1);
            if (timelineItem.referenceType == "Transaction") {
                TransactionsService.getById(timelineItem.referenceId)
                    .then(function (response) {
                        vm.transaction = response;
                        if (response.accountId) {
                            AccountsService.getAccountById(response.accountId)
                                .then(function (response) {
                                    vm.account = response;
                                })
                                .catch(function (error) {
                                    $log.error(error);
                                })
                        }
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            } else if (timelineItem.referenceType == "EInvoice") {
                EInvoiceDocumentsService.getById(timelineItem.referenceId)
                    .then(function (response) {
                      if(response){
                        vm.einvoice = response;
                      }
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            } else if (timelineItem.referenceType == "Message") {
                MessagesService.getById(timelineItem.referenceId)
                    .then(function (response) {
                        vm.message = response;
                        $log.debug("Message object by id", vm.message)
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            }

        }
        vm.init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name timeline.controller:TimelineCtrl
   *
   * @description
   *
   */
  angular
    .module('timeline')
    .controller('TimelineCtrl', TimelineCtrl);

  function TimelineCtrl() {
    var vm = this;
    vm.ctrlName = 'TimelineCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name template
   * @description
   *
   */
  angular
    .module('template', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('template')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('template', {
        url: '/template',
        templateUrl: 'template/template.tpl.html',
        controller: 'TemplateCtrl',
        controllerAs: 'template'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name template.controller:TemplateCtrl
   *
   * @description
   *
   */
  angular
    .module('template')
    .controller('TemplateCtrl', TemplateCtrl);

  function TemplateCtrl() {
    var vm = this;
    vm.ctrlName = 'TemplateCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name statements
   * @description
   *
   */
  angular
    .module('statements', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name statements.factory:StatementsService
   *
   * @description
   *
   */
  StatementsService.$inject = ["$localStorage", "EndpointsService", "$rootScope", "$q", "$http", "$log", "$window", "HelperService"];
  angular
    .module('statements')
    .factory('StatementsService', StatementsService);

  function StatementsService($localStorage, EndpointsService,$rootScope, $q, $http, $log, $window, HelperService) {
    var StatementsServiceBase = {};
    StatementsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.statements, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
            deferred.reject(msg);
          });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    // Old method for download statements
/*    StatementsServiceBase.downloadPdf = function (statementId) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        var link = response.links.statements_id_download.replace("{id}", statementId);
        $window.location.assign(link, {
          statementId: statementId
        });
      });
    };*/

    // New method for statements download...
    StatementsServiceBase.getStatementPdfLink = function (statementId) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.statements_downloadLink_id.replace('{id}', statementId))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    StatementsServiceBase.downloadPdf = function(statementId){
      var nonBlockingWindow = window.open('','_self');
      return StatementsServiceBase.getStatementPdfLink(statementId)
        .then(function (pdfLink) {
          if(pdfLink){
            // If we want to open link in same tab (immediate download)
            // window.location.href = pdfLink.url;
            nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(pdfLink.url);
          }
        })
        .catch(function (error) {
          nonBlockingWindow.close();
          HelperService.showMessage(error, 'error');
          $log.debug(error);
        });
    };

    // API provides link for accessing pdf file
    StatementsServiceBase.downloadPdfStatement = function (url) {
      var nonBlockingWindow = window.open('', '_self');
      return $http.get(url)
        .success(function (pdfLink) {
          if (pdfLink) {
              nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(pdfLink.url);
          }
        }).error(function (msg, code) {
        nonBlockingWindow.close();
      });
    };

    StatementsServiceBase.getStatementDates = function (accountId) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.statements_getStatementDates_id.replace('{id}', accountId))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return StatementsServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('statements')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('statements', {
        url: '/statements',
        templateUrl: 'statements/statements.tpl.html',
        controller: 'StatementsCtrl',
        controllerAs: 'statements'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name statements.controller:StatementsCtrl
   *
   * @description
   *
   */
  angular
    .module('statements')
    .controller('StatementsCtrl', StatementsCtrl);

  function StatementsCtrl() {
    var vm = this;
    vm.ctrlName = 'StatementsCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name settings
   * @description
   *
   */
  angular
    .module('settings', [
      'ui.router'
    ]);
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name settings.factory:SoftTokenOrderService
     *
     * @description
     *
     */
    SoftTokenOrderService.$inject = ["$q", "$http", "EndpointsService", "$log"];
    angular
        .module('settings')
        .factory('SoftTokenOrderService', SoftTokenOrderService);

    function SoftTokenOrderService($q, $http, EndpointsService, $log) {
        var SoftTokenOrderServiceBase = {};

        SoftTokenOrderServiceBase.insertOrder = function (orderObject) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("SoftTokenOrderServiceBase.insertOrder orderObject:", orderObject);
                $http.post(response.links.softTokenOrder, orderObject)
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

      SoftTokenOrderServiceBase.validateSoftTokenOrder = function (object) {
        return $q(function (resolve, reject) {
          return EndpointsService.getLinks().then(function (response) {
            $http.put(response.links.softTokenOrder_validate, object)
              .success(function (data) {
              resolve(data);
            })
              .error(function (error) {
              reject(error);
            })
          }, function (error) {
            reject(error);
          });
        });
      };
        return SoftTokenOrderServiceBase;
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name settings.controller:SmsAndNotificationModalCtrl
   *
   * @description
   *
   */
  SmsAndNotificationModalCtrl.$inject = ["$q", "$uibModalInstance", "SettingsService", "object", "HelperService", "AlertService"];
  angular
    .module('settings')
    .controller('SmsAndNotificationModalCtrl', SmsAndNotificationModalCtrl);

  function SmsAndNotificationModalCtrl($q, $uibModalInstance, SettingsService, object, HelperService, AlertService) {
    var vm = this;
    vm.ctrlName = 'SmsAndNotificationModalCtrl';
    vm.object = object;
    console.log('ORDER OBJECT ',vm.object);

      // user: vm.model.userSettings,
      // orderItem: item,
      // orderObject: obj,
      // type: type,
      // accountBased: accountBased,
      // account: vm.selectedTrrAccount,
      // value: value

    vm.step = 1;
    vm.tempObj = {
      amount: 0,
      showAmount: false
    };
    vm.orderDate = new Date();


    function createMonthDays() {
      var days = [];
      for(var i = 1;i<=new Date(new Date().getFullYear(), new Date().getMonth()+1, 0).getDate(); i++){
        days.push({id:i+".", description:i+"."});
      }
      return days;
    }
    function createDayHours() {
      var hours = [];
      for(var i = 1;i<25;i++){
        hours.push({id:i+"",description:i+":00"});
      }
      return hours;
    }

    vm.periods = {};
    // vm.periods.periodTypes = [
    //   {id: 'D', description: 'settings.smsModal.daily'},{id: 'W', description: 'settings.smsModal.weekly'}, {id:'M', description: 'settings.smsModal.monthly'}
    // ];
    // vm.periods.dailyTimePeriods = createDayHours();
    // vm.periods.weeklyTimePeriods = [{id: 'Monday', description: 'settings.smsModal.weekDays.monday'},
    //   {id: 'Tuesday', description: 'settings.smsModal.weekDays.tuesday'},
    //   {id: 'Wednesday', description: 'settings.smsModal.weekDays.wednesday'},
    //   {id: 'Thursday', description: 'settings.smsModal.weekDays.thursday'},
    //   {id: 'Friday', description: 'settings.smsModal.weekDays.friday'},
    //   {id: 'Saturday', description: 'settings.smsModal.weekDays.saturday'},
    //   {id: 'Sunday', description: 'settings.smsModal.weekDays.sunday'}];
    // vm.periods.monthlyTimePeriods = createMonthDays();

    vm.period = '';
    //vm.periodType = vm.periods.periodTypes[0]; //D, M, W
    // vm.dailyTimePeriod = vm.periods.dailyTimePeriods[0]; //1:00, 2:00, ..
    // vm.weeklyTimePeriod = vm.periods.weeklyTimePeriods[0]; //Monday, Tuesday, ...
    // vm.monthlyTimePeriod = vm.periods.monthlyTimePeriods[0]; //1, 2, 3, ...

    function loadPeriodTypes() {
      var params = null;
      return SettingsService.getPeriodTypes(params)
        .then(function (response) {
          vm.periods.periodTypes = response.result;
          vm.periodType = vm.periods.periodTypes[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }
    function loadDailyTimes() {
      var params = null;
      return SettingsService.getTimeTypes(params)
        .then(function (response) {
          vm.periods.dailyTimePeriods = _.sortBy(response.result, function (day) {
            return parseInt(day.id);
          });
          vm.dailyTimePeriod = vm.periods.dailyTimePeriods[0]; //1:00, 2:00, ..
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }
    function loadWeeklyTimes() {
      var params = null;
      return SettingsService.getPeriodOfWeekTypes(params)
        .then(function (response) {
          vm.periods.weeklyTimePeriods = response.result;
          vm.weeklyTimePeriod = vm.periods.weeklyTimePeriods[0]; //Monday, Tuesday, ...
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }
    function loadMonthlyTimes() {
      var params = null;
      return SettingsService.getPeriodOfMonthTypes(params)
        .then(function (response) {
          vm.periods.monthlyTimePeriods = _.sortBy(response.result, function (month) {
            return parseInt(month.id);
          });
          vm.monthlyTimePeriod = vm.periods.monthlyTimePeriods[0]; //1, 2, 3, ..
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function init() {
      var promises = [];
      if(vm.object.orderObject.subOrderId == '30' || vm.object.orderObject.subOrderId == '40' || vm.object.orderObject.subOrderId == '50'){
        promises.push(loadPeriodTypes(), loadDailyTimes(),loadWeeklyTimes(),loadMonthlyTimes());
      }

      populateSubOrderId70();


      if(promises.length > 0){
        $q.all(promises)
          .then(function(responses){
          populateSubOrderId30();
          populateSubOrderId40Or50();
          console.log('RESPONSENS', responses);
        }).catch(function(error){
          HelperService.showMessage(error, 'error');
        });
      }
    }

    function populateSubOrderId30() {
      if(vm.object.type == 'SMS'){
        angular.extend(vm.object.orderObject, vm.object.orderObject.smsNotification)
      }else{
        angular.extend(vm.object.orderObject, vm.object.orderObject.emailNotificaton)
      }
      if (vm.object.orderObject.subOrderId == '30') {
        var dailyTime = _.find(vm.periods.dailyTimePeriods, {id: vm.object.orderObject.periodHour});
        if (dailyTime)
          vm.dailyTimePeriod = dailyTime;
        else
          vm.dailyTimePeriod = vm.periods.dailyTimePeriods[0];

        vm.periodType = _.find(vm.periods.periodTypes, {id: vm.object.orderObject.periodType});
        if (vm.periodType) {
          if (vm.periodType.id == 'D') {
            vm.period = '';
          }
          if (vm.periodType.id == 'W')
            vm.period = _.find(vm.periods.weeklyTimePeriods, {id: vm.object.orderObject.period});

          if (vm.periodType.id == 'M')
            vm.period = _.find(vm.periods.monthlyTimePeriods, {id: vm.object.orderObject.period+"."});
        } else {
          vm.periodType = vm.periods.periodTypes[0];
          vm.period = '';
        }
      }
    }

    function populateSubOrderId40Or50() {
      if(vm.object.type == 'SMS'){
        angular.extend(vm.object.orderObject, vm.object.orderObject.smsNotification)
      }else{
        angular.extend(vm.object.orderObject, vm.object.orderObject.emailNotificaton)
      }
      if (vm.object.orderObject.subOrderId == '40' || vm.object.orderObject.subOrderId == '50') {
        vm.tempObj.showAmount = true;
        var dailyTimeTemp = _.find(vm.periods.dailyTimePeriods, {id: vm.object.orderObject.periodHour});
        if (dailyTimeTemp)
          vm.dailyTimePeriod = dailyTimeTemp;
        else
          vm.dailyTimePeriod = vm.periods.dailyTimePeriods[0];

        vm.periodType = _.find(vm.periods.periodTypes, {id: 'D'});

        if (vm.object.orderObject.amount)
          vm.tempObj.amount = vm.object.orderObject.amount;
      }


    }

    function populateSubOrderId70() {
      if(vm.object.orderObject.subOrderId == '70'){

        if(vm.object.type == 'SMS'){
          angular.extend(vm.object.orderObject, vm.object.orderObject.smsNotification);
        }else {
          angular.extend(vm.object.orderObject, vm.object.orderObject.emailNotificaton);
        }

        vm.tempObj.showAmount = true;

        if (vm.object.orderObject.amount)
          vm.tempObj.amount = vm.object.orderObject.amount;
      }
    }

    // if(vm.object.orderObject.amount){
    //   vm.tempObj.amount = vm.object.orderObject.amount;
    // }

    function createOrderObject() {

      var temp = {
        "accountId":vm.object.account.accountNumber,
        "description":vm.object.orderObject.description,
        "customerName": vm.object.user.firstName + " " + vm.object.user.lastName,
        "gsm": vm.object.user.gsm,
        "email": vm.object.user.notificationEmail,
        "terms": true,
        "note":"string",
        "notificationSubType": {
          "id": vm.object.orderObject.subOrderId,
          "description": vm.object.orderObject.description
        },
        "notificationType": {
          "id": vm.object.type == 'EMAIL' ? 'SMTP':'SMS',
          "description": "string"
        },
        "disableNotification": vm.object.value


      };

      if(vm.object.orderObject.subOrderId == '30'){
        temp.period = vm.periodType;
        temp.notificationTime = vm.dailyTimePeriod;
        if(temp.period.id == 'W'){
          temp.periodDayOfWeek = vm.weeklyTimePeriod;
        }
        else if(temp.period.id == 'M'){
          temp.periodDayOfMonth = vm.monthlyTimePeriod;
          temp.periodDayOfMonth.id = temp.periodDayOfMonth.id.substring(0,temp.periodDayOfMonth.id.length-1); //when sending { id: "1."... it fails but id:"1" is fine
        }
      }

      if(vm.object.orderObject.subOrderId == '40' || vm.object.orderObject.subOrderId == '50'){
        temp.amount = vm.tempObj.amount;
        temp.period = vm.periodType;
        temp.notificationTime = vm.dailyTimePeriod;
      }

      if(vm.object.orderObject.subOrderId == '70'){
        temp.amount = vm.tempObj.amount;
      }

      return temp;

    }

    vm.next = function () {
      vm.tempObj.formSubmitted = true;
      if(!vm.smsAndNotifForm.$valid)
        return;

      vm.step = 2;

    };

    vm.confirm = function () {
      if (vm.confirmationInProgress) return;
      vm.confirmationInProgress = true;
      if (vm.object.accountBased) {
        SettingsService.changeTrrBasedNotifications(createOrderObject())
          .then(function (response) {
            //vm.step = 3;
            $uibModalInstance.close();
            AlertService.infoAlert({
              text: 'orderSoftToken.successTxt'
            });
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          }).finally(function() {
            vm.confirmationInProgress = false;
        });
      } else {
        SettingsService.changeUserBasedNotifications(createOrderObject())
          .then(function (response) {
            // vm.step = 3;
            $uibModalInstance.close();
            AlertService.infoAlert({
              text: 'orderSoftToken.successTxt'
            });
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          }).finally(function() {
          vm.confirmationInProgress = false;
        });
      }
    };

    init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name settings.factory:SettingsService
   *
   * @description
   *
   */
  SettingsService.$inject = ["$q", "$http", "EndpointsService"];
  angular
    .module('settings')
    .factory('SettingsService', SettingsService);

  function SettingsService($q, $http,EndpointsService) {
    var SettingsServiceBase = {};

    SettingsServiceBase.changePassword = function (object) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
            $http.put(response.links.authenticationAdmin_changePassword,object)
                .success(function (data) {
                    deferred.resolve(data);
                }).error(function (msg, code) {
                    deferred.reject(msg);
                });
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    SettingsServiceBase.getSmsAndNotifications = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.smsAndEmailNotification, {params: params})
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.changeUserBasedNotifications = function (object) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.userBasedNotificationOrder,object)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.changeTrrBasedNotifications = function (object) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.trrBasedNotificationOrder,object)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getAdditionalTransactionConfirmation = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.additionalTransactionConfirmation)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.changeAdditionalTransactionConfirmation = function (object) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.additionalTransactionConfirmation,object)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getPeriodTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderPeriodType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getTimeTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderTimeType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getPeriodOfWeekTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderPeriodOfWeekType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getPeriodOfMonthTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderPeriodOfMonthType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    return SettingsServiceBase;
  }
}());

(function () {
    'use strict';

    config.$inject = ["$stateProvider"];
    angular
        .module('settings')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('settings', {
                url: '/settings',
                templateUrl: 'settings/settings.tpl.html',
                controller: 'SettingsCtrl',
                controllerAs: 'settings',
                resolve: {
                    userSettingsData: ["$rootScope", "UserSettingsService", "ConfigEndpointService", function ($rootScope, UserSettingsService, ConfigEndpointService) {

                      var params = {};
                      if($rootScope.APP_GLOBAL_SETTINGS.defaultData){
                        if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'hr'){
                          params = {includeList: 'UserNotificationDetailsList'};
                        }
                        return UserSettingsService.getPage(params);
                      }else{
                        return ConfigEndpointService.getDefaultData()
                          .then(function (response){
                            if(response && response.APILocation === 'hr'){
                              params = {includeList: 'UserNotificationDetailsList'};
                            }
                            return UserSettingsService.getPage(params);
                          })
                      }
                    }]
                }
            })
            .state('settings.orderSoftToken', {
                url: '/order-soft-token',
                views: {
                    '@': {
                        templateUrl: 'settings/order-soft-token.tpl.html',
                        controller: 'OrderSoftTokenCtrl',
                        controllerAs: 'orderSoftToken',
                        resolve: {
                            country: ["ConfigEndpointService", function (ConfigEndpointService) {
                                return ConfigEndpointService.getDefaultData()
                            }]
                        }
                    }
                }
            })
          .state('settings.gsmSettings', {
            url: '/gsm-settings',
            views: {
              '@': {
                templateUrl: 'settings/mobile-phone-number.tpl.html',
                controller: 'MobilePhoneNumberCtrl',
                controllerAs: 'vm'
                // resolve: {
                //   userSettings: function (UserSettingsService) {
                //     return UserSettingsService.getPage();
                //   }
                // }
              }
            }
          });
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name settings.controller:SettingsCtrl
   *
   * @description
   *
   */
  SettingsCtrl.$inject = ["$scope", "$q", "$rootScope", "$translate", "$uibModal", "$state", "userSettingsData", "UserSettingsService", "ValidationService", "SettingsService", "HelperService", "AlertService", "AccountsService", "GoogleTagManagerHelperService"];
  angular
    .module('settings')
    .controller('SettingsCtrl', SettingsCtrl);

  function SettingsCtrl($scope, $q, $rootScope, $translate, $uibModal, $state, userSettingsData, UserSettingsService, ValidationService, SettingsService, HelperService, AlertService, AccountsService, GoogleTagManagerHelperService) {

    var vm = this;

    vm.tempDompObj = {};

    vm.trrAccounts = [];
    vm.selectedTrrAccount = {};

    vm.inputOptions = {
      minLengthOld: -1,
      maxLength: -1,
      minLength: -1,
      checkForValidation: false
    };

    //vm.selectedTab = "account";

    vm.checkForValidation = function () {
      vm.inputOptions.checkForValidation = true;
    };
    vm.userBasedNotificationsList = [];
    vm.accountBasedNotificationsList = [];
    vm.loadSmsAndNotifications = loadSmsAndNotifications;
    init();

    function prepareNotificationListCRO() {
      vm.notificationsList = {};
      vm.notificationsList.originalList = angular.copy(userSettingsData.result[0].userNotificationDetailsList);
      var brojac = 0;
      _.forEach(vm.notificationsList.originalList, function (item) {
        item.tempId = brojac++;
      });
      vm.notificationsList.modifiedList = angular.copy(vm.notificationsList.originalList);
    }

    function init() {
      vm.model = {};
      vm.model.userSettings = {};
      vm.model.security = {};
      vm.model.security.transactionConfirmation = "0";
      vm.model.userSettingsEditInput = {};
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

      var defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
      vm.country = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
      vm.selectedTab = (vm.country === "hr" || vm.country === "sl") ? "account" : "security";

      if (defaultData.APILocation === 'bh') {
        vm.inputOptions.minLengthOld = 6;
        vm.inputOptions.minLength = 8;
        vm.inputOptions.maxLength = 15;
      }

      if (defaultData.APILocation === 'sl') {
        loadAccounts(); //includes loading SmsAndNotifiacions
        loadAdditionalTransactionInformation();
      }

      if (defaultData.APILocation === 'hr') {
        prepareNotificationListCRO();
      }


      loadData();


    }

    vm.selectTab = function (tab, translateLabel) {
      if (tab == vm.selectedTab) return;
      vm.selectedTab = tab;
      GoogleTagManagerHelperService.pushEvent('Settings', 'Tab', $translate.instant(translateLabel));
    }

    function loadAdditionalTransactionInformation() {
      SettingsService.getAdditionalTransactionConfirmation()
        .then(function (response) {
          vm.model.security.transactionConfirmation = response.result[0].id;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function loadAccounts() {
      AccountsService.getPage({accountTypeGroup: 'CurrentAccount', isOwn: true, isParentAccount: true})
        .then(function (response) {
          vm.trrAccounts = _.filter(response.result, function (account) {
            return account.isOwn;
          });
          vm.trrAccounts = _.uniq(vm.trrAccounts, function (item) {
            return item.iban
          });
          vm.selectedTrrAccount = vm.trrAccounts[0];

          var unregister = $rootScope.$on('appLanguageChangedHeader', function (evt, data) {
            if (vm.selectedTab == "notifications") {
              loadSmsAndNotifications();
            }
          });
          $scope.$on('$destroy', function () {
            unregister();
          });

          loadSmsAndNotifications();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function loadSmsAndNotifications() {

      if (!vm.selectedTrrAccount)
        return;

      SettingsService.getSmsAndNotifications({orderBy: 'subOrderId', accountId: vm.selectedTrrAccount.accountId})
        .then(function (response) {
          vm.userBasedNotificationsList = response.result;
          vm.accountBasedNotificationsList = _.remove(vm.userBasedNotificationsList, function (item) {
            return item.accountId;
          });
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    vm.changeSettings = function (item, value, type, accountBased) {

      return $uibModal.open({
        templateUrl: 'settings/sms-and-notification-modal.tpl.html',
        size: 'lg',
        controller: 'SmsAndNotificationModalCtrl',
        controllerAs: 'smsAndNotificationModal',
        resolve: {
          object: {
            user: vm.model.userSettings,
            //orderItem: item,
            orderObject: item,
            type: type, //SMS or EMAIl
            value: value,
            accountBased: accountBased,
            account: vm.selectedTrrAccount
          }

        },
        backdrop: 'static'
      })
        .result
        .then(function (result) {
          loadSmsAndNotifications();
        });
    };


    function loadData() {
      $rootScope.APP_GLOBAL_SETTINGS.userSettings = userSettingsData.result[0];
      var userSettings = userSettingsData.result[0];
      userSettings.houseNumber = userSettings.address1.split(/[\s]+/).pop().trim();
      userSettings.street = userSettings.address1.replace(new RegExp(userSettings.houseNumber, 'g'), "").trim();
      userSettings.mailUserType = 1;
      vm.model.userSettings = userSettings;
    }

//gsmCountryCode, gsmOperator i gsm
//dayPhoneCountryCode, dayPhoneOperator  i dayPhone
    function prepareDataForUpdate(userSettings) {
      return {
        "email": vm.model.userSettingsEditInput.notificationEmail,
        "dataConfirmation": true,
        "mailUsername": userSettings.firstName + " " + userSettings.lastName,
        "mailStreet": vm.model.userSettingsEditInput.street,
        "mailHouseNumber": vm.model.userSettingsEditInput.houseNumber,
        "mailCity": vm.model.userSettingsEditInput.city,
        "mailPostalCode": vm.model.userSettingsEditInput.postalCode,
        "mailUserType": vm.model.userSettingsEditInput.mailUserType,
        "gsmCountryCode": vm.model.userSettingsEditInput.gsmCountryCode,
        "gsmOperator": vm.model.userSettingsEditInput.gsmOperator,
        "gsm": vm.model.userSettingsEditInput.gsm,
        "dayPhoneCountryCode": vm.model.userSettingsEditInput.dayPhoneCountryCode,
        "dayPhoneOperator": vm.model.userSettingsEditInput.dayPhoneOperator,
        "dayPhone": vm.model.userSettingsEditInput.dayPhone
      };
    }

    vm.confirmUserSettingsEdit = function () {
      vm.editUserSettingsActive = false;
      var updateData = prepareDataForUpdate(vm.model.userSettingsEditInput);
      UserSettingsService.updateUserInfoOrders(updateData)
        .then(function (response) {
          GoogleTagManagerHelperService.pushEvent('Settings', 'Settings updated', 'Settings updated successfully!');
          console.log(response);
          if (response) {
            loadData();
          } else {
            vm.model.userSettings = angular.copy(vm.model.userSettingsEditInput);
          }

        }, function (error) {
          vm.editUserSettingsActive = true;
        });
    };

    vm.editUserSettings = function () {
      vm.editUserSettingsActive = true;
      vm.model.userSettingsEditInput = angular.copy(vm.model.userSettings);
    };

    vm.editUserEmail = function () {
      vm.editEmail = true;
      vm.model.userSettingsEditInput.notificationEmail = angular.copy(vm.model.userSettings.notificationEmail);
    }

    vm.confirmUserEmailChange = function () {
      vm.editEmail = false;
      var updateData = prepareDataForUpdate(vm.model.userSettingsEditInput);
      UserSettingsService.updateUserInfoOrders(updateData)
        .then(function (response) {
          if (response) {
            loadData();
          } else {
            vm.model.userSettings = angular.copy(vm.model.userSettingsEditInput);
          }
          vm.model.userSettings.notificationEmail = angular.copy(vm.model.userSettingsEditInput.notificationEmail);
        }, function (error) {
          vm.editEmail = true;
        });
    };


    vm.cancelUserSettingsEdit = function () {
      vm.editUserSettingsActive = false;
      vm.model.userSettingsEditInput = {};
    };

    vm.compareNewPassword = function () {
      console.log(vm.securityForm);
      if (vm.model.security.newPassword === vm.model.security.confirmNewPassword) {
        vm.securityForm.confirmNewPassword.$setValidity("incorrect", true);
        console.log(vm.securityForm.confirmNewPassword.$valid);
      } else {
        vm.securityForm.confirmNewPassword.$setValidity("incorrect", false);
        console.log(vm.securityForm.confirmNewPassword.$valid);
      }
    };

    var createDompObj = function () {
      return {
        oldPassword: vm.model.security.oldPassword,
        newPassword: vm.model.security.newPassword,
        confirmedNewPassword: vm.model.security.confirmNewPassword
      };
    };

    var clearForm = function () {
      vm.model.security.oldPassword = '';
      vm.model.security.newPassword = '';
      vm.model.security.confirmNewPassword = '';
    };

    vm.change = function () {

      var temp = {};
      temp.email = vm.model.security.email || null;
      temp.mothersLastName = vm.model.security.mothersLastName || null;
      if (temp.email || temp.mothersLastName) {
        UserSettingsService.updateInvoiceEmail(temp, vm.model.userSettings.id)
          .then(function (response) {
            GoogleTagManagerHelperService.pushEvent('Settings', 'Settings updated', 'Settings updated successfully');
            vm.model.userSettings = response;
            clearForm();
            var translatedSuccessMessage = $translate.instant('core.additionalDataChangedMsg');
            HelperService.showTranslatedMessage('success', translatedSuccessMessage, '', 3000, true, 2);
          })
          .catch(function (error) {
            HelperService.showTranslatedMessage('error', error.resultList[0].description, error.resultList[0].key);
          })
          .finally(function () {
          });
      }

      if (vm.securityForm.$valid) {
        var dompObj = createDompObj();
        SettingsService.changePassword(dompObj)
          .then(function (response) {
            var translatedSuccessMessage = $translate.instant('core.passwordChangedMsg');
            HelperService.showTranslatedMessage('success', translatedSuccessMessage, '', 3000, true, 2);
            GoogleTagManagerHelperService.pushEvent('Settings', 'Settings updated', 'Settings updated successfully!');
            if (vm.country === 'sr')
              navigateToDashboard();
          })
          .catch(function (error) {
            //$log.error(error);
            HelperService.showTranslatedMessage('error', error.resultList[0].description, error.resultList[0].key);

          })
          .finally(function () {
            clearForm();
          });
      }
    };

    vm.securityEditConfirm = function () {
      if (vm.confirmButtonPressed) return;
      // DO POST
      vm.confirmButtonPressed = true;
      SettingsService.changeAdditionalTransactionConfirmation({
        id: vm.model.security.transactionConfirmation,
        parameter: vm.model.security.transactionConfirmation == 0 ? 'OTP' : 'SMS'
      })
        .then(function (response) {
          $rootScope.APP_GLOBAL_SETTINGS.userSettings.additionalTransactionConfirmation = response;
          vm.securityEditActive = false;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function () {
        vm.confirmButtonPressed = false;
      });
    };


    vm.securitySetBlockade = function () {
      $state.go("blockade");
    };

    var navigateToDashboard = function () {
      $state.go('dashboard');
    };

    vm.setMobilePhoneNumber = function (phone) {
      if (!phone) {
        AlertService.infoAlert({
          text: 'settings.noNumber'
        });
        return;
      }

      $state.go("settings.gsmSettings");
    };

    function updateSettings(id, updateData) {
      return UserSettingsService.updateUserSettings(id, updateData)
        .then(function (response) {
          //todo
        }, function (error) {
          HelperService.showMessage(error, 'error');
          //refresh list to initial list
          prepareNotificationListCRO();
        });
    }
    function insertSettings(insertData) {
      return UserSettingsService.insertUserSettings(insertData)
        .then(function (response) {
          //todo
        }, function (error) {
          HelperService.showMessage(error, 'error');
          //refresh list to initial list
          prepareNotificationListCRO();
        });
    }

    vm.updateUserSettings = function () {
      var promises = [];

      var userNotificationListForPUT = getLists().putList;

      if (userNotificationListForPUT.length > 0) {
        var updateData = {
          userNotificationList: userNotificationListForPUT
        };
        promises.push(updateSettings(userSettingsData.result[0].id, updateData));
      }

      var userNotificationListForPOST = getLists().postList;
      if(userNotificationListForPOST.length > 0){
        var insertData = {
          userNotificationList: userNotificationListForPOST
        };
       promises.push(insertSettings(insertData));
      }

      $q.all(promises)
        .then(function (responses) {
          //
        })
    };

    vm.updateNotificationItem = function (item, type) {
      if (type === 'sms') {
        if (item.isEmail === true && item.isActive === true)
          item.isEmail = false;
      }
      if (type === 'email') {
        if (item.isEmail === true && item.isActive === true)
          item.isActive = false;
      }
    };

    function getLists() {
      _.sortBy(vm.notificationsList.modifiedList, ['tempId']);
      _.sortBy(vm.notificationsList.originalList, ['tempId']);

      var tempPUTList = [];
      var tempPOSTList = [];

      for (var i = 0; i < vm.notificationsList.originalList.length; i++) {
        if(!vm.notificationsList.originalList[i].userConfigId){
          var item = vm.notificationsList.modifiedList[i];
          var tempItem = {
            accountId: item.accountId || null,
            userConfigId: item.userConfigId,
            isActive: item.isActive || false,
            isEmail: item.isEmail || false,
            notificationType: item.notificationType
          };
          tempPOSTList.push(tempItem);

          continue;
        }

        if (vm.notificationsList.originalList[i].isActive !== vm.notificationsList.modifiedList[i].isActive ||
          vm.notificationsList.originalList[i].isEmail !== vm.notificationsList.modifiedList[i].isEmail) {
          var item = vm.notificationsList.modifiedList[i];
          var tempItem = {
            accountId: item.accountId,
            userConfigId: item.userConfigId,
            isActive: item.isActive || false,
            isEmail: item.isEmail || false,
            notificationType: item.notificationType
          };
          tempPUTList.push(tempItem);
        }
      }

      return {putList: tempPUTList, postList: tempPOSTList};
    }

    vm.updateUserMobileSetting = function () {
      AlertService.updateMobileSetting()
        .then(function (result) {
          if(result){
            UserSettingsService.updateUserMobileSetting(false)
              .then(function (response) {
                  vm.model.userSettings.mobileBankEnabled = response.mobileBankEnabled;
                  // HelperService.showTranslatedMessage('success', 'message','',3000);
                }, function (error) {
                  HelperService.showMessage(error, 'error');
                }
              );
          }
        }, function (error) {

        });


    }

  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name settings.controller:OrderSoftTokenCtrl
     *
     * @description
     *
     */
    OrderSoftTokenCtrl.$inject = ["country", "UserSettingsService", "$log", "SoftTokenOrderService", "AlertService", "$location"];
    angular
        .module('settings')
        .controller('OrderSoftTokenCtrl', OrderSoftTokenCtrl);

    function OrderSoftTokenCtrl(country, UserSettingsService, $log, SoftTokenOrderService, AlertService, $location) {
        var vm = this;
        vm.ctrlName = 'OrderSoftTokenCtrl';

        vm.userSettings = {};
        vm.formSubmitted = false;
        vm.changeEmailButton = false;
        vm.changeGsmButton = false;

        vm.steps = {
          step1: true,
          step2: false
        };

        vm.back = function () {
          vm.steps = {
            step1: true,
            step2: false
          };
        };

        vm.init = function () {
            UserSettingsService.getPage({
                    pageSize: 1000
                })
                .then(function (response) {
                    vm.userSettings = response.result[0];
                vm.notificationEmail = vm.userSettings.notificationEmail;
                vm.gsm = vm.userSettings.gsm;
                    $log.debug("userSettings", vm.userSettings);
                })
                .catch(function (error) {
                    $log.error(error);
                });

          vm.changeEmailButton = true
          vm.changeGsmButton = true;
        };

        vm.changeEmail = function () {
          vm.notificationEmail = vm.userSettings.notificationEmail;
          vm.changeEmailButton = false;
        };

        vm.changeEmailOk = function () {
          if(vm.notificationEmail){
            vm.userSettings.notificationEmail = vm.notificationEmail;
          }
          vm.changeEmailButton = true;
        };

        vm.changeEmailCancel = function () {
          vm.changeEmailButton = true;
          vm.notificationEmail = vm.userSettings.notificationEmail;
        };

        vm.changeGsm = function () {
          vm.gsm = vm.userSettings.gsm;
          vm.changeGsmButton = false;
        };

        vm.changeGsmOk = function () {
          if(vm.gsm) {
            vm.userSettings.gsm = vm.gsm;
          }
          vm.changeGsmButton = true;
        };

        vm.changeGsmCancel = function () {
          vm.changeGsmButton = true;
          vm.gsm = vm.userSettings.gsm;
        };

       function createObject ()
       {
         return {
           "nameAndSurname": vm.userSettings.firstName + " " + vm.userSettings.lastName,
           "email": vm.userSettings.notificationEmail,
           "phoneNumber": vm.userSettings.gsm,
           "note": ""
         }
       };

        vm.submitOrder = function () {
          if (vm.validationInProgress) return;
          vm.formSubmitted = true;
            if (!vm.orderSoftTokenForm.$valid) {
              return;
          }
          var orderObject = createObject();
          vm.validationInProgress = true;
          SoftTokenOrderService.validateSoftTokenOrder(orderObject)
              .then(function (response) {
                vm.responseModel = response;
                vm.steps = {
                  step1: false,
                  step2: true
                };
              })
              .catch(function (error) {
                  $log.error(error);
              }).finally (function (error) {
            vm.validationInProgress = false;
          });
        };

       vm.confirmSoftTokenOrder = function () {
         if (vm.confirmationInProgress) return;
         var orderObject = createObject();
         vm.confirmationInProgress = true;
         SoftTokenOrderService.insertOrder(orderObject)
           .then(function (response) {
           $log.debug("SoftTokenOrderService.insertOrder post response", response);

           AlertService.infoAlert({
             text: 'orderSoftToken.successTxt'
           })
             .then(function () {
             $location.path('/settings');
           });
         })
           .catch(function (error) {
           $log.error(error);
         }).finally(function () {
           vm.confirmationInProgress = false;
         });
       };

        vm.openWebsite = function () {
            var nonBlockingWindow = window.open('', '_blank');
            nonBlockingWindow.location.href = "https://www.addiko.si/pristop-k-spletni-banki-addiko-ebank";
        };

      vm.setMobilePhoneNumber = function (phone) {
        if (!phone) {
          AlertService.infoAlert({
            text: 'settings.noNumber'
          })
          return;
        }

        $state.go("settings.gsmSettings");
      }

        vm.init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name settings.controller:MobilePhoneNumberCtrl
   *
   * @description
   *
   */
  MobilePhoneNumberCtrl.$inject = ["$rootScope", "$state", "$http", "UserSettingsService", "AlertService", "HelperService"];
  angular
    .module('settings')
    .controller('MobilePhoneNumberCtrl', MobilePhoneNumberCtrl);

  function MobilePhoneNumberCtrl($rootScope, $state, $http, UserSettingsService, AlertService, HelperService) {
    var vm = this;
    var userGSM = $rootScope.APP_GLOBAL_SETTINGS.userSettings.gsm;

    vm.steps = {
      input: true,
      resume: false,
      finish: false
    };

    vm.model = {
      gsm: userGSM,
      email: "",
      isConfirmed: false
    };

    function createInputObject() {
      return {
        email: "",
        dataConfirmation: vm.model.isConfirmed,
        gsm: vm.model.gsm
      }
    }

    vm.next = function () {
      if (vm.validationInProgress) return;
      vm.formSubmitted = true;
      if (vm.phoneNumberForm.$invalid) return;
      vm.validationInProgress = true;
      UserSettingsService.validateUserInfoOrders(createInputObject())
        .then(function (response) {
          vm.model.linkList = response.linkList;
          vm.model.gsmPhoneFormatted = vm.model.gsm.replace(/(.{3})/g, '$1 ').trim();
          vm.model.orderDate = new Date();
          vm.steps = {
            input: false,
            resume: true,
            finish: false
          }
        }, function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function (){
          vm.validationInProgress = false;
      })
    }

    vm.confirm = function () {
      if (vm.confirmationInProgress) return;

      vm.resumeFormSubmitted = true;
      if (vm.phoneNumberResumeForm.$invalid) return;
      if (!vm.model.linkList) return;
      vm.confirmationInProgress = true;

      $http.post(vm.model.linkList.itemList.sign, vm.model)
        .then(function (response) {
          AlertService.infoAlert({
            text: "mobilePhoneSettings.numberChangeSuccess"
          }).then(function () {
            $state.go("settings", {}, {reload: true})
          });
        }, function (error) {
          HelperService.showMessage(error.data, 'error');
        }).finally(function() {
        vm.confirmationInProgress = false;
      })

      // UserSettingsService.updateUserInfoOrders(vm.model)
      //   .then(function (response) {
      //     console.log(response);
      //     // signData
      //   }, function (error) {
      //     console.log(error);
      //     HelperService.showMessage(error, 'error');
      //   })
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name sepa
   * @description
   *
   */
  angular
    .module('sepa', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name sepa.controller:SepaTransactionsOverviewCtrl
   *
   * @description
   *
   */
  SepaTransactionsOverviewCtrl.$inject = ["$rootScope", "$http", "$state", "SepaService", "HelperService", "$log", "$translate", "GoogleTagManagerHelperService", "AlertService"];
  angular
    .module('sepa')
    .controller('SepaTransactionsOverviewCtrl', SepaTransactionsOverviewCtrl);

  function SepaTransactionsOverviewCtrl($rootScope, $http, $state, SepaService, HelperService, $log, $translate, GoogleTagManagerHelperService, AlertService) {
    var vm = this;

    vm.paymentsTypeSelected = 1;


    vm.sepaFilter = {
      page: 0,
//      orderBy: 'valuteDateGTE DESC',
      pageSize: 15,
      valuteDateGTE: null,
      valuteDateLTE: null,
      accountId: null,
      userId: null,
      status: "Waiting",
      orderBy: "valuteDate DESC",
      amountGTE: null,
      amountLTE: null
    };

    // ------------------ SEARCH CUSTOM FILTER START ---------------------//
    vm.searchFilterExpanded = false;
    vm.toggleFilterSelection = function () {
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    vm.applyPaymentsFilter = function () {
      getTimelineItemsGrouped(true);
      vm.searchFilterExpanded = false;
    };

    vm.resetPaymentsFilter = function () {
      vm.sepaFilter.amountGTE = null; //ngmodel
      vm.sepaFilter.amountLTE = null; //ngmodel
      getTimelineItemsGrouped(true);
      vm.searchFilterExpanded = false;
    };
    // ------------------ SEARCH CUSTOM FILTER END ---------------------//


    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      }
      , {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }
      , {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }
      , {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }
      , {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
      , {
        item: {
          key: 'all2y',
          description: 'core.period.all'
        }
      }
    ];

    vm.selectedPeriod = vm.periodList[3];
    vm.sepaPeriodFilter = function (item) {
      vm.selectedPeriod = item;
      var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      vm.sepaFilter.valuteDateGTE = timeRange.valueDateGTE;
      vm.sepaFilter.valuteDateLTE = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === "sl" ? timeRange.valueDateLTE : null;
      getTimelineItemsGrouped(true);
      GoogleTagManagerHelperService.pushEvent('SepaOverview', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));

    };
    vm.sepaPeriodFilter(vm.periodList[3]);


    vm.selectPaymentsType = function (type, translateLabel) {
      if (type == vm.selectedTabType) return;
      vm.selectedTabType = type;
      switch (type) {
        case "Waiting":
          vm.sepaFilter.status = "Waiting";
          vm.paymentsTypeSelected = 1;
//          sepaFilter.orderBy = 'dateCreated DESC';
          break;
        case "Rejected":
          vm.sepaFilter.status = "Rejected";
          vm.paymentsTypeSelected = 2;
//          sepaFilter.orderBy = 'modificationDate DESC';
          break;
        case "Processed":
          vm.sepaFilter.status = "Processed";
          vm.paymentsTypeSelected = 3;
//          sepaFilter.orderBy = 'modificationDate DESC';
          break;
        default:
          vm.sepaFilter.status = null;
          vm.paymentsTypeSelected = 1;
//          sepaFilter.orderBy = 'dateCreated DESC';

      }
      GoogleTagManagerHelperService.pushEvent('Sepa Transactions Overview', 'Tab', $translate.instant(translateLabel));

      //clearPaymentsFilter();
      getTimelineItemsGrouped(true);
    };

    vm.paymentsOverviewList = {};

    vm.paymentsOverviewListGrouped = {};

    init();
    function init() {
      if ($state.params.selectedTab == 'Processed') {
        vm.paymentsTypeSelected = 3; //Executed transactions tab must
        vm.sepaFilter.status = "Processed";
      }

      getTimelineItemsGrouped(true);

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr') {
        vm.sepaComplaintDDFilter = {
          page: 0,
          pageSize: 10,
          orderBy: "complaintDate DESC"
        };
        getSepaDDComplaints(true);
      }
    }

    vm.sepaDDComplaints = [];
    vm.loadMoreSepaDDComplaints = function () {
      getSepaDDComplaints(false);
    }

    function getSepaDDComplaints(reset) {
      if (reset) {
        vm.sepaComplaintDDFilter.page = 0;
      } else {
        vm.sepaComplaintDDFilter.page += 1;
      }

      SepaService.getSepaDDComplaints(vm.sepaComplaintDDFilter)
        .then(function (response) {
          vm.sepaDDComplaints = HelperService.mergeRowsForTimeline({
            existingData: vm.sepaDDComplaints,
            newData: response,
            groupFunction: function (item) {
              var date = new Date(item.complaintDate);
              // If we want to group only by date component, without hours
              date.setHours(0, 0, 0, 0);
              return date;
            },
            virtualRowFunction: function (e) {
              var month = new Date(e).getMonth() + 1;
              var day = new Date(e).getDate();
              var virtualRow = {
                isVirtual: true,
                valueDate: new Date(e),
                month: month,
                day: day
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: false
          });
        }).catch(function (error) {
        $log.error(error);
      });
    }

    function getTimelineItemsGrouped(reset) {

      if (reset) {
        vm.sepaFilter.page = 0;
      } else {
        vm.sepaFilter.page += 1;
      }
      SepaService.getPage(vm.sepaFilter)
        .then(function (response) {

          vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
            existingData: vm.timelineListGrouped,
            newData: response,
            groupFunction: function (item) {
              return item.valuteDate;
              //var date = new Date(item.valuteDate);
              // If we want to group only by date component, without hours
              //date.setHours(0, 0, 0, 0);
              //return date;
            },
            virtualRowFunction: function (e) {
              var month = new Date(e).getMonth() + 1;
              var day = new Date(e).getDate();
              var virtualRow = {
                isVirtual: true,
                valueDate: e,
                month: month,
                day: day
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: false
          });

          $log.debug("groupedSepaTimeline", vm.timelineListGrouped);
        }).catch(function (error) {
        $log.error(error);
      });
    }

    vm.loadMore = function () {
      getTimelineItemsGrouped(false);
    };

    vm.showDetails = function (payment) {
      if (payment.selected) {
        payment.selected = false;
        return;
      }

      SepaService.getById(payment.transactionId)
        .then(function (response) {
          angular.extend(payment, response);
          payment.selected = !payment.selected;
        });
    };

    vm.showComplaintDetails = function (item) {
      if (item.selected) {
        item.selected = false;
        return;
      }
      item.selected = true;
    };

    vm.complaint = function (transaction) {
      $state.go("sepa.complaint", {transactionId: transaction.transactionId, status: transaction.status});
    };

    vm.refund = function (transaction) {
      $state.go("sepa.refund", {transactionId: transaction.transactionId, status: transaction.status});
    };

    vm.goToNewSepa = function () {
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === "sl") {
        $state.go("sepa.new");
      } else {
        $state.go("sepa.new-cro");
      }
    };

    vm.refuseSepaOrder = function (transactionId) {
      AlertService.confirmationAlert({
        text: "sepa.sddPaymentReturnInfo"
      })
        .then(function (accept) {
          if (!accept) return;

          $state.go("sepa.order-refund-cro", {transactionId: transactionId});
        });
    }

  }
}());

(function () {
  'use strict';

  SepaService.$inject = ["$log", "$q", "$http", "EndpointsService"];
  angular
    .module('sepa')
    .factory('SepaService', SepaService);

  function SepaService($log, $q, $http, EndpointsService) {

    var SepaServiceBase = {};

    SepaServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.sepaDD, {
          params: params
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDD_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettings = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaDDComplaints = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDComplaint, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettingsById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.addSepaSetting = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.post(response.links.sepaDDSettings, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    SepaServiceBase.addSepaDDComplaint = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.post(response.links.sepaDDComplaint, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.deactivateSepaSetting = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.put(response.links.sepaDDSettings_deactivate, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.signSepaComplaint = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.put(response.links.sepaDDComplaint_sign, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.signSepaSetting = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
      $http.put(response.links.sepaDDSettings_sign, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.updateSepaSetting = function(id, data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.sepaDDSettings_id.replace('{id}', id), data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettingsTypes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettingsTypes, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaSettingsTypesByAccountId = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links["sepaDDSettings_settingTypesList?accountId={accountId}"].replace('{accountId}', id), {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaCreditorsList = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings_creditorsList, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SepaServiceBase.getSepaDDSettingsExecutionPeriodTypes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.sepaDDSettings_executionPeriodTypes, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    SepaServiceBase.getSepaDDComplaintReasonTypes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.sepaDDComplaintReasonTypes, {
          params: params
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return SepaServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('sepa')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('sepa', {
        url: '/sepa',
        // templateUrl: 'sepa/sepa.tpl.html',
        // controller: 'SepaCtrl',
        // controllerAs: 'sepa'
      })
      .state('sepa.new', {
        url: '/new-sepa/:id',
        views: {
          '@': {
            templateUrl: 'sepa/sepa-new.tpl.html',
            controller: 'SepaNewCtrl',
            controllerAs: 'sepa',
            resolve: {
              sepaSettingTypes: ["SepaService", function(SepaService) {
                return SepaService.getSepaSettingsTypes({pageSize: 1000})
              }],
              currentAccounts: ["AccountsService", function(AccountsService) {
                return AccountsService.getPage({accountTypeGroupList: "CurrentAccount", isOwn: true, isParentAccount: true, pageSize: 10000})
              }],
              sepaSetting: ["$q", "$stateParams", "SepaService", function($q, $stateParams, SepaService){
                if($stateParams.id) {
                  return $q(function(resolve, reject) {
                    SepaService.getSepaSettingsById($stateParams.id)
                      .then(function(response){
                        resolve(response);
                      }, function(error) {
                        return reject(error);
                      })
                  })
                }
              }]
            }
          }
        }
      })
      .state('sepa.new-cro', {
        url: '/new',
        views: {
          '@': {
            templateUrl: 'sepa/sepa-new-cro.tpl.html',
            controller: 'SepaNewCroCtrl',
            controllerAs: 'vm'
          }
        }
      })
      .state('sepa.refusal-cro', {
        url: '/sepa-refusal/:id',
        views: {
          '@': {
            templateUrl: 'sepa/sepa-refusal-cro.tpl.html',
            controller: 'SepaRefusalCroCtrl',
            controllerAs: 'vm'
          }
        }
      })
      .state('sepa.accepted-refusal-cro', {
        url: '/sepa-accepted-refusal/:transactionId',
        views: {
          '@': {
            templateUrl: 'sepa/sepa-accepted-refusal-cro.tpl.html',
            controller: 'SepaAcceptedRefusalCroCtrl',
            controllerAs: 'vm'
          }
        }
      })
      .state('sepa.order-refund-cro', {
        url: '/sepa-order-refund/:transactionId',
        views: {
          '@': {
            templateUrl: 'sepa/sepa-order-refund-cro.tpl.html',
            controller: 'SepaOrderRefundCroCtrl',
            controllerAs: 'vm'
          }
        }
      })
      .state('sepa.settings', {
        url: '/settings',
        views: {
          '@': {
            templateUrl: 'sepa/sepa.tpl.html',
            controller: 'SepaCtrl',
            controllerAs: 'sepa',
            resolve: {
              currentAccounts: ["AccountsService", function(AccountsService) {
                return AccountsService.getPage({accountTypeGroupList: "CurrentAccount", isOwn: true, isParentAccount: true, pageSize: 10000})
              }]
            }
          }
        }
      })
      .state('sepa.settings-cro', {
        url: '/sepaSettings',
        views: {
          '@': {
            templateUrl: 'sepa/sepa-cro.tpl.html',
            controller: 'SepaCroCtrl',
            controllerAs: 'vm'
          }
        }
      })
      .state('sepa.transactions', {
        url: '/sepa-overview',
        params: {
          selectedTab: null
        },
        views: {
          '@': {
            templateUrl: 'sepa/sepa-transactions-overview.tpl.html',
            controller: 'SepaTransactionsOverviewCtrl',
            controllerAs: 'sepaTrans'
          }
        }
      })
      .state('sepa.complaint', {
        url: '/sepa-overview/:transactionId/complaint',
        params: {
          type: "complaint",
          status: null
        },
        views: {
          '@': {
            templateUrl: 'sepa/sepa-complaint-refund.tpl.html',
            controller: 'SepaComplaintRefundCtrl',
            controllerAs: 'vm',
            resolve: {
              transaction: ["$stateParams", "SepaService", function($stateParams, SepaService) {
                return SepaService.getById($stateParams.transactionId)
              }],
              validate: ["$q", "transaction", function($q, transaction) {
                if(!transaction) $q.reject();
              }]
            }
          }
        }
     })
      .state('sepa.refund', {
        url: '/sepa-overview/:transactionId/refund',
        params: {
          type: "refund",
          status: null
        },
        views: {
          '@': {
            templateUrl: 'sepa/sepa-complaint-refund.tpl.html',
            controller: 'SepaComplaintRefundCtrl',
            controllerAs: 'vm',
            resolve: {
              transaction: ["$stateParams", "SepaService", function($stateParams, SepaService) {
                return SepaService.getById($stateParams.transactionId)
              }],
              validate: ["$q", "transaction", function($q, transaction) {
               if(!transaction) $q.reject();
              }]
            }
          }
        }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name sepa.controller:SepaRefusalCroCtrl
   *
   * @description
   *
   */
  SepaRefusalCroCtrl.$inject = ["$q", "AccountsService", "SepaService", "HelperService", "$state", "AlertService"];
  angular
    .module('sepa')
    .controller('SepaRefusalCroCtrl', SepaRefusalCroCtrl);

  function SepaRefusalCroCtrl($q, AccountsService, SepaService, HelperService, $state, AlertService) {
    var vm = this;
    vm.pageLoaded = true;
    vm.step = "start";

    vm.model = {
      fromAccountSelect: {},
      executionDate: new Date(),
      amount: "",
      identifierApproval: "", // Identifikator suglasnosti
      receiverId: "", // Identifikator primatelja
      receiverName: "",  // Naziv i sjedište primatelja plaćanja
      receiverAccount: "", // Račun primatelja plaćanja - IBAN
      receiverNumber: "" // Detalji plaćanja (poziv na broj primatelja)
    }

    init();
    function init() {
      loadData();
    }

    function loadData() {
      var promises = [];
      promises.push(SepaService.getSepaCreditorsList({pageSize: 10000}));
      promises.push(AccountsService.getPage({
        accountTypeGroupList: ["CurrentAccount", "GiroAccount"],
        pageSize: 10000,
        currencySymbol: 'HRK'
      }));

      $q.all(promises)
        .then(function (response) {
          vm.sepaCreditorList = response[0].result;

          vm.currentAccounts = response[1].result;
          vm.model.fromAccountSelect = response[1].result[0];
        })
    }

    function prepareDataForInsert(input) {
      var data = {};
      data.accountId = input.fromAccountSelect.accountId;
      data.inputValueDate = input.executionDate;
      data.amount = input.amount;
      data.mandateReference = input.identifierApproval;
      data.receiverIdentificator = input.receiverId;
      data.receiverName = input.receiverName;
      data.receiverAccount = input.receiverAccount;
      data.receiverReference = input.receiverNumber;
      return data;
    }

    vm.setAccountFrom = function (account) {
      vm.model.fromAccountSelect = account;
      vm.fromAccountDropdown = false;
    };

    vm.datesDisabled = function (date, mode) {
      // return (mode === 'day' && (date.getTime() < tomorrow));
    };

    vm.findIdInCreditorList = function (creditorId) {
      var creditor = _.findWhere(vm.sepaCreditorList, {creditorId: creditorId});
      if (creditor) {
        vm.creditorInListExist = true;
        vm.model.receiverName = creditor.name;
      } else {
        vm.creditorInListExist = false;
        vm.model.receiverName = "";
      }
    }

    vm.submit = function (form) {
      vm.formSubmitted = true;
      if (form.$invalid) return;
      vm.submitButtonDisabled = true;
      SepaService.addSepaDDComplaint(prepareDataForInsert(vm.model))
        .then(function (response) {
          vm.step = "resume";
          vm.responseModel = response;
          vm.submitButtonDisabled = false;
        }, function (error) {
          vm.submitButtonDisabled = false;
          HelperService.showMessage(error, 'error');
        })
    }

    vm.confirmSign = function () {
      if (vm.confirmSignBtnDisabled) return;
      vm.confirmSignBtnDisabled = true;
      SepaService.signSepaComplaint({
        "id": vm.responseModel.id,
        "signData": vm.model.insertChallenge
      })
        .then(function (response) {
          console.log(response);

          vm.confirmSignBtnDisabled = false;
          AlertService.infoAlert({
            text: 'sepa.signSuccessfull'
          }).then(function () {
            $state.go("sepa.transactions");
          });
        }, function (error) {
          HelperService.showMessage(error, 'error');
          vm.confirmSignBtnDisabled = false;
        })
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name sepa.controller:SepaRefusalCroCtrl
   *
   * @description
   * Ova forma je identična "sepa-accepted-refusal-cro" ali sam je razdvojio jer uvijek postoji šansa da će se nešto promjeniti!.
   * ~DinoD
   */
  SepaOrderRefundCroCtrl.$inject = ["$q", "$stateParams", "AccountsService", "SepaService", "HelperService", "$state", "AlertService"];
  angular
    .module('sepa')
    .controller('SepaOrderRefundCroCtrl', SepaOrderRefundCroCtrl);

  function SepaOrderRefundCroCtrl($q, $stateParams, AccountsService, SepaService, HelperService, $state, AlertService) {
    var vm = this;
    vm.pageLoaded = false;
    vm.step = "start";

    vm.model = {
      fromAccountSelect: {},
      executionDate: new Date(),
      amount: "",
      identifierApproval: "", // Identifikator suglasnosti
      receiverId: "", // Identifikator primatelja
      receiverName: "",  // Naziv i sjedište primatelja plaćanja
      receiverAccount: "", // Račun primatelja plaćanja - IBAN
      receiverNumber: "" // Detalji plaćanja (poziv na broj primatelja)
    };

    init();
    function init() {
      loadData();
    }

    function loadData() {
      var promises = [];
      if (!$stateParams.transactionId) {
        return;
      }
      promises.push(SepaService.getById($stateParams.transactionId));
      $q.all(promises)
        .then(function (responses) {
          var transaction = responses[0];
          if (transaction) {
            vm.model.accountId = transaction.accountId;
            vm.model.amount = transaction.amount;
            vm.model.executionDate = new Date(transaction.valuteDate);
            vm.model.receiverName = transaction.receiverName;
            vm.model.receiverAccount = transaction.receiverAccount;
            vm.model.receiverNumber = transaction.receiverReference;
            vm.model.transactionId = transaction.transactionId;
            // Račun platitelja / Payer account
            vm.model.senderAccount = transaction.senderAccount; // Samo prikaz

            vm.pageLoaded = true;
          }
        }, function (error) {
          HelperService.showMessage(error, 'error');
          $state.go("sepa.transactions");
        });
    }

    function prepareDataForInsert(input) {
      var data = {};
      data.accountId = input.fromAccountSelect.accountId;
      data.inputValueDate = input.executionDate;
      data.amount = input.amount;
      data.receiverName = input.receiverName;
      data.receiverAccount = input.receiverAccount;
      data.receiverReference = input.receiverNumber;
      data.transactionId = input.transactionId;
      return data;
    }

    vm.submit = function (form) {
      vm.submitButtonDisabled = true;
      SepaService.addSepaDDComplaint(prepareDataForInsert(vm.model))
        .then(function (response) {
          vm.step = "sign";
          vm.responseModel = response;
          vm.submitButtonDisabled = false;
        }, function (error) {
          vm.submitButtonDisabled = false;
          HelperService.showMessage(error, 'error');
        })
    };

    vm.confirmSign = function () {
      if (vm.confirmSignBtnDisabled) return;
      vm.confirmSignBtnDisabled = true;
      SepaService.signSepaComplaint({
        "id": vm.responseModel.id,
        "signData": vm.model.insertChallenge
      })
        .then(function (response) {
          console.log(response);

          vm.confirmSignBtnDisabled = false;
          AlertService.infoAlert({
            text: 'sepa.signSuccessfull'
          }).then(function () {
            $state.go("sepa.transactions");
          });
        }, function (error) {
          HelperService.showMessage(error, 'error');
          vm.confirmSignBtnDisabled = false;
        })
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name sepa.controller:SepaNewCroCtrl
   *
   * @description
   *
   */
  SepaNewCroCtrl.$inject = ["$q", "$state", "AccountsService", "AlertService", "SepaService", "HelperService"];
  angular
    .module('sepa')
    .controller('SepaNewCroCtrl', SepaNewCroCtrl);

  function SepaNewCroCtrl($q, $state, AccountsService,  AlertService, SepaService, HelperService) {
    var vm = this;
    var canUpdate;
    vm.pageLoaded = false;
    vm.step = 'start';

    var tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));

    vm.model = {
      fromAccountSelect: {},
      sepaSettingType: "",
      dateFrom: tomorrow,  // polje „Datum od“ je obavezno polje, minimalni datum koji je moguće unijeti je tekući datum +1
      dateTo: '', //ostaviti ovo polje prazno po defaultu takodjer je moguce da se u POST-u salje prazno
      receiverId: "", // identifikator primatelja
      receiverName: "", // naziv primatelja
      identifierApproval: "", // identifikator suglasnosti (API agreementId ) - polje „Identifikator suglasnosti“ je opcionalno polje
      singleChargeMaxAmount: "", // maksimalni iznos pojedinačnog terećenja
      dynamicExecution: "" // dinamika izvršenja (API executionPeriod )
    };

    vm.responseModel = {};

    init();
    function init() {
      loadData();
    }
    //
    // var cleanLanguageChangeListener = $rootScope.$on('appLanguageChangedHeader', function (evt, data) {
    //   if (vm.model.fromAccountSelect.accountId) {
        // SepaService.getSepaSettingsTypesByAccountId(vm.model.fromAccountSelect.accountId)
        //   .then(function (response) {
        //     var sepaSettingsTypes = response.result;
        //     vm.sepaSettingsTypesOptions = sepaSettingsTypes;
            // vm.model.sepaSettingType = sepaSettingsTypes[0];
            // vm.onSettingTypeChange(sepaSettingsTypes[0]);
          // }, function (error) {
          //
          // })
    //   }
    // });

    // $scope.$on('$destroy', function() {
    //   cleanLanguageChangeListener();
    // });

    function getSepaSettingsTypeByAccountId(id) {
      SepaService.getSepaSettingsTypesByAccountId(id)
        .then(function (response) {
          var sepaSettingsTypes = response.result;
          vm.sepaSettingsTypesOptions = sepaSettingsTypes;
          vm.model.sepaSettingType = sepaSettingsTypes[0];
          vm.onSettingTypeChange(sepaSettingsTypes[0]);
        }, function (error) {

        })
    }

    function loadData() {
      var promises = [];
      promises.push(
        AccountsService.getPage({
          accountTypeGroupList: ["CurrentAccount","GiroAccount"],
          pageSize: 10000,
          includeList: "UserAccountList",
          currencySymbol: "HRK"

        }));
      promises.push(SepaService.getSepaDDSettingsExecutionPeriodTypes());
      promises.push(SepaService.getSepaCreditorsList({pageSize: 10000}));
      $q.all(promises)
        .then(function (response) {
          // --
          // Accounts from
          // --
          var accountsFrom = response[0].result;
          vm.accountsFrom = _.filter(accountsFrom, function (account) {
            return account.isOwn && account.accountNumber.substring(0, 2) != '35';
          });
          vm.model.fromAccountSelect = vm.accountsFrom[0];
          //As default account set one that was selected on previous form (Sepa DD Settings)

          getSepaSettingsTypeByAccountId(vm.model.fromAccountSelect.accountId);

          // --
          // Sepa Execution Period types
          // --
          var executionPeriodTypes = response[1].result;
          executionPeriodTypes.unshift({id: "", description: ""});
          vm.executionPeriodTypesOptions = executionPeriodTypes;
          vm.model.dynamicExecution = executionPeriodTypes[0];

          // --
          // Sepa Creditor List
          // --
          vm.sepaCreditorList = response[2].result;

          // --
          // Other
          // --
          vm.pageLoaded = true;
        }, function (error) {
          HelperService.showMessage(error, 'error');
        })
    }

    vm.findIdInCreditorList = function (creditorId) {
      var creditor =  _.findWhere(vm.sepaCreditorList, {creditorId: creditorId});
      if (creditor) {
        vm.creditorInListExist = true;
        vm.model.receiverName = creditor.name;
      } else {
        vm.creditorInListExist = false;
        vm.model.receiverName = "";
      }
    }

    vm.datesFromDisabled = function (date, mode) {
      return (mode === 'day' && (date.getTime() < tomorrow));
    };

    vm.datesToDisabled = function (date, mode) {
      return (mode === 'day' && (date.getTime() < vm.model.dateFrom));  // 	polje „Datum do“ je opcionalno polje,  ne smije se unijeti datum manji od onog u polju „Datum od“
    };

    vm.onDateFromChange = function () {
      if (vm.model.dateTo < vm.model.dateFrom) {
        vm.model.dateTo = angular.copy(vm.model.dateFrom);
      }
    }

    vm.setAccountFrom = function (account) {
      vm.model.fromAccountSelect = account;
      vm.fromAccountDropdown = false;
      getSepaSettingsTypeByAccountId(account.accountId)
    }

    vm.onSettingTypeChange = function (sepaSettingType) {
      var sepaSettingTypeId = sepaSettingType.id;
      if (sepaSettingType.descriptionAlert == "") {
        vm.settingTypeInvalid = false;
      } else {
        vm.settingTypeInvalid = true;
      }
    }

    function prepareDataForInsert(input) {
      var data = {};
      data.accountId = input.fromAccountSelect.accountId;
      // data.settingType = input.sepaSettingType;
      data.typeId = input.sepaSettingType.id;
      data.dateFrom = input.dateFrom;
      data.dateTo = input.dateTo || '';

      var sepaSettingTypeId = input.sepaSettingType.id;
      if (sepaSettingTypeId === "WHITE_LIST" || sepaSettingTypeId == "AMOUNT") {
        data.receiverId = input.receiverId;
        data.receiverName = input.receiverName;
        data.maxAmount = input.singleChargeMaxAmount;
        data.agreementId = input.identifierApproval;
        data.executionPeriod = input.dynamicExecution.id;
      }
      else if (sepaSettingTypeId === "BLACK_LIST") {
        data.receiverId = input.receiverId;
        data.receiverName = input.receiverName;
      }
      return data;
    }

    vm.submit = function (form) {
      if (vm.sepaBtnDisabled) {
        return;
      }


      if (form.$invalid || vm.settingTypeInvalid) {
        vm.formSubmitted = true;
        return;
      }
      vm.sepaBtnDisabled = true;
      if (!canUpdate) {
        SepaService.addSepaSetting(prepareDataForInsert(vm.model))
          .then(function (response) {
            vm.step = 'resume';
            canUpdate = true;
            vm.responseModel = response;
            vm.sepaBtnDisabled = false;
          }, function (error) {
            vm.sepaBtnDisabled = false;
            HelperService.showMessage(error, 'error');
          })
      } else {
        vm.step = 'resume';
        // SepaService.updateSepaSetting(vm.responseModel.id, prepareDataForInsert(vm.model))
        //   .then(function (response) {
        //     vm.step = 'resume';
        //     canUpdate = true;
        //     vm.sepaBtnDisabled = false;
        //   }, function (error) {
        //     vm.sepaBtnDisabled = false;
        //     HelperService.showMessage(error, 'error');
        //   })
      }
    }

    vm.confirmSign = function () {
      if (vm.confirmSignBtnDisabled) return;
      vm.confirmSignBtnDisabled = true;
      SepaService.signSepaSetting({
        "id": vm.responseModel.id,
        "signData": vm.model.insertChallenge
      })
        .then(function (response) {
          console.log(response);

          vm.confirmSignBtnDisabled = false;
          AlertService.infoAlert({
            text: 'sepa.signSuccessfull'
          }).then(function () {
            $state.go("sepa.settings-cro");
          });
        }, function (error) {
          HelperService.showMessage(error, 'error');
          vm.confirmSignBtnDisabled = false;
        })
    }
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name sepa.controller:SepaNewCtrl
     *
     * @description
     *
     */
    SepaNewCtrl.$inject = ["$rootScope", "$scope", "$state", "HelperService", "sepaSettingTypes", "currentAccounts", "AlertService", "sepaSetting", "SepaService", "PaymentTypesService"];
    angular
        .module('sepa')
        .controller('SepaNewCtrl', SepaNewCtrl);

    function SepaNewCtrl($rootScope, $scope, $state, HelperService, sepaSettingTypes, currentAccounts, AlertService, sepaSetting, SepaService, PaymentTypesService) {
        var vm = this;

        var isEdit = false;
        var sepaSettingId;
        vm.steps = {};
        vm.steps.step1 = true;

        vm.sepaTempObj = {
          formSubmitted: false
        };

        init();

        function init() {
            vm.model = {};
            vm.accountsFrom = [];

            vm.settingType = sepaSettingTypes.result;
            // vm.settingType.shift();
          if (vm.settingType.length) {
            vm.model.settingTypeSelected = vm.settingType[0];
          }
            vm.accountsFrom = currentAccounts.result;


            if (sepaSetting) {
                isEdit = true;
                sepaSettingId = sepaSetting.id;
                vm.model = initModelForEdit();
            } else {
                vm.model.fromAccountSelect = currentAccounts.result[0];
            }
        }

        var cleanLanguageChangeListener = $rootScope.$on('appLanguageChangedHeader', function (evt, data) {
          SepaService.getSepaSettingsTypes({pageSize: 1000})
            .then(function (response) {
              angular.extend(vm.settingType, response.result);
              vm.model.settingTypeSelected = _.findWhere(response.result, {id: vm.model.settingTypeSelected.id})
            }, function (error) {
              HelperService.showMessage(error, 'error');
            })
        });

        $scope.$on('$destroy', function() {
          cleanLanguageChangeListener();
        });

        function initModelForEdit() {
            return {
                amountInput: sepaSetting.maxAmount,
                fromAccountSelect: _.findWhere(currentAccounts.result, {
                    accountId: sepaSetting.accountId
                }),
                settingTypeSelected: _.findWhere(sepaSettingTypes.result, {
                    id: sepaSetting.settingType.id
                })
            }
        }

        function remapForPost() {
            return {
                maxAmount: vm.model.amountInput,
                accountId: vm.model.fromAccountSelect.accountId,
                settingType: vm.model.settingTypeSelected
            }
        }

        function addSepaSetting(data) {

            data.activated = true;
            SepaService.addSepaSetting(data)
                .then(function (response) {
                    AlertService.infoAlert({
                            text: "sepa.sepaSuccessCreate"
                        })
                        .then(function () {
                            $state.go("sepa.settings");
                        })
                }, function (error) {
                    vm.okButtonDisabled = false;
                  vm.sepaTempObj.formSubmitted = false;

                  HelperService.showMessage(error, 'error');
                });
        }

        function updateSepaSetting(data) {
            data.activated = true;
            SepaService.updateSepaSetting(sepaSettingId, data)
                .then(function (response) {
                    AlertService.infoAlert({
                            text: "sepa.sepaSuccessCreate"
                        })
                        .then(function () {
                            $state.go("sepa.settings");
                        })
                }, function (error) {
                    vm.okButtonDisabled = false;
                    vm.sepaTempObj.formSubmitted = false;
                    HelperService.showMessage(error, 'error');
                });
        }

        vm.setAccountFrom = function (item) {
            vm.model.fromAccountSelect = item;
            vm.fromAccountDropdown = false;
        };

        vm.onSettingTypeChange = function () {
          if(vm.model.settingTypeSelected.id == '4') {
            vm.model.amountInput = "";
          }
        };

        vm.confirm = function (sepaForm) {
            vm.sepaTempObj.formSubmitted = true;
            if (!vm.sepaForm.$valid || vm.model.settingTypeSelected.id == '0') {
                return;
            }
            vm.steps = {};
            vm.steps.step2 = true;
        };

        vm.ok = function () {

            vm.okButtonDisabled = true;
            var sepaSetting = remapForPost();
            if (isEdit) {
                updateSepaSetting(sepaSetting);
            } else {
                addSepaSetting(sepaSetting);
            }
        };

        vm.cancel = function () {
          if (vm.cancelInProgress) return;
          vm.cancelInProgress = true;
          $state.go("sepa.settings")
            .finally(function () {
              vm.cancelInProgress = false;
            })
        }

    }
}());

(function () {
  'use strict';
  /**
   * @ngdoc object
   * @name sepa.controller:SepaCtrl
   *
   * @description
   *
   */
  SepaCroCtrl.$inject = ["$q", "$rootScope", "$scope", "$state", "AccountsService", "SepaService", "$log", "HelperService", "UserSettingsService", "PaymentTypesService", "DepositOrdersService", "AlertService"];
  angular
    .module('sepa')
    .controller('SepaCroCtrl', SepaCroCtrl);

  function SepaCroCtrl($q, $rootScope, $scope, $state, AccountsService, SepaService, $log, HelperService, UserSettingsService, PaymentTypesService, DepositOrdersService, AlertService) {
    var vm = this;

    init();

    function init() {
      vm.overviewTabType = 'overview';
      vm.model = {};

      getSepaSettings(true);
    }

    function getSepaSettings(reset) {
      $q.all([
        SepaService.getSepaSettings({
          pageSize: 10000,
          isActivated: true
        }),
        SepaService.getSepaSettings({
          pageSize: 10000,
          // showAll: true,
          isActivated: false,
          orderBy: "dateCreated DESC"
        }),
        SepaService.getSepaSettings({
          pageSize: 10000,
          // showAll: true,
          isActivated: null,
          orderBy: "dateCreated DESC"
        })
      ])
        .then(function (responses) {

          vm.sepaDDSettings = [];

          vm.sepaDDSettings = HelperService.mergeRowsForTimeline({
            existingData: vm.sepaDDSettings,
            newData: {
              result: responses[0].result
            },
            groupFunction: function (item) {
              // var valueDate = new Date(item.dateCreated);
              // valueDate.setHours(0, 0, 0, 0);
              return item.settingType.description;
            },
            virtualRowFunction: function (e) {
              var virtualRow = {
                isVirtual: true,
                description: e
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: false
          }).result;

          vm.sepaDDSettingsHistory = HelperService.mergeRowsForTimeline({
            existingData: vm.sepaDDSettingsHistory,
            newData: {
              result: responses[1].result
            },
            groupFunction: function (item) {
              var valueDate = new Date(item.dateCreated);
              valueDate.setHours(0, 0, 0, 0);
              return valueDate;
            },
            virtualRowFunction: function (e) {
              var virtualRow = {
                isVirtual: true,
                date: new Date(e)
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: false
          }).result;

          vm.sepaDDRequests = HelperService.mergeRowsForTimeline({
            existingData: vm.sepaDDRequests,
            newData: {
              result: responses[2].result
            },
            groupFunction: function (item) {
              var valueDate = new Date(item.dateCreated);
              valueDate.setHours(0, 0, 0, 0);
              return valueDate;
            },
            virtualRowFunction: function (e) {
              var virtualRow = {
                isVirtual: true,
                date: new Date(e)
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: false
          }).result;

        }, function (error) {
          vm.sepaDDSettings = [];
          vm.sepaDDSettingsHistory = [];
          vm.sepaDDRequests = [];
        });

    }

    function getSepaDDRequests() {
      SepaService.getSepaSettings({
        AccountId: vm.model.fromAccountSelect.accountId,
        pageSize: 10000,
        showAll: true,
        isActivated: null,
        orderBy: "dateCreated+DESC"
      }).then(function (response) {
        vm.sepaDDRequests = HelperService.mergeRowsForTimeline({
          existingData: vm.sepaDDRequests,
          newData: {
            result: response.result
          },
          groupFunction: function (item) {
            var valueDate = new Date(item.dateCreated);
            valueDate.setHours(0, 0, 0, 0);
            return valueDate;
          },
          virtualRowFunction: function (e) {
            var virtualRow = {
              isVirtual: true,
              date: new Date(e)
            };
            $log.debug("virtualRow", e, virtualRow);
            return virtualRow;
          },
          reset: reset,
          reverse: false
        }).result;

      }, function (error) {
        vm.sepaDDSettings = [];
        vm.sepaDDSettingsHistory = [];
        vm.sepaDDRequests = [];
      });
    }


    var cleanLanguageChangeListener = $rootScope.$on('appLanguageChangedHeader', function (evt, data) {
      getSepaSettings(true);
    });

    $scope.$on('$destroy', function () {
      cleanLanguageChangeListener();
    });


    vm.setAccountFrom = function (account) {
      vm.model.fromAccountSelect = account;
      vm.fromAccountDropdown = false;
      getSepaSettings(true);
    };

    var selectedToEdit = {};
    vm.edit = function (data) {
      selectedToEdit.editInProgress = false;
      if (data.editInProgress) return;
      selectedToEdit = data;
      data.editInProgress = true;
      $state.go("sepa.new-cro", {
        id: data.accountId
      }).then(function () {
        data.editInProgress = false;
      })
    };

    vm.addNewSetting = function () {
      if (vm.addNewSepaSettingLoading) return;
      vm.addNewSepaSettingLoading = true;
      $state.go("sepa.new-cro")
        .finally(function () {
          vm.addNewSepaSettingLoading = false;
        });
    };

    vm.openSwitchItemActiveStateModal = function (item) {
      var confirmationText = "sepa.changeToActivated";
      var confirmationSuccessText;
      if (item.activated) {
        confirmationText = "sepa.changeToDeactivated";
        confirmationSuccessText = "sepa.deactivateSuccess";
      } else {
        confirmationText = "sepa.changeToActivated";
        confirmationSuccessText = "sepa.activateSuccess";
      }


      AlertService.confirmationAlert({
        text: confirmationText
      })
        .then(function (accept) {
          if (!accept) return;
          var putObject = {
            "id": item.id,
            "accountId": item.accountId,
            "maxAmount": item.maxAmount,
            "settingType": {
              "id": item.settingType.id,
              "description": item.settingType.description
            },
            "note": item.note,
            "activated": !item.activated,
            "changeDate": item.changeDate
          };
          SepaService.updateSepaSetting(item.id, putObject)
            .then(function (response) {
              AlertService.infoAlert({
                text: confirmationSuccessText
              })
                .then(function () {
                  getSepaSettings(true);
                });
            }, function (error) {
              HelperService.showMessage(error, 'error');
            });
        });
    };

    vm.deactivate = function (sepa) {
      AlertService.confirmationAlert({
        text: "sepa.deactivateAlert"
      })
        .then(function (accept) {
          if (!accept) return;

          vm.deactivateBtnDisabled = true;
          SepaService.deactivateSepaSetting(sepa.id)
            .then(function (response) {
              getSepaSettings(true);
            }, function (error) {
              HelperService.showMessage(error, 'error');
              vm.deactivateBtnDisabled = false;
              getSepaDDRequests();
            })
            .finally(function () {
              vm.deactivateBtnDisabled = false;
            })


        }, function (error) {

        })

    }

  }
}());

(function () {
    'use strict';
    /**
     * @ngdoc object
     * @name sepa.controller:SepaCtrl
     *
     * @description
     *
     */
    SepaCtrl.$inject = ["$rootScope", "$scope", "$state", "currentAccounts", "SepaService", "$log", "HelperService", "UserSettingsService", "PaymentTypesService", "DepositOrdersService", "AlertService"];
    angular
        .module('sepa')
        .controller('SepaCtrl', SepaCtrl);

    function SepaCtrl($rootScope, $scope, $state, currentAccounts, SepaService, $log, HelperService, UserSettingsService, PaymentTypesService, DepositOrdersService, AlertService) {
        var vm = this;

        init();

        function init() {
            vm.model = {};
            vm.currentAccounts = currentAccounts.result;
            vm.model.fromAccountSelect = currentAccounts.result[0];
            getSepaSettings(true);
        }

        function getSepaSettings(reset) {
            SepaService.getSepaSettings({
                    AccountId: vm.model.fromAccountSelect.accountId,
                    pageSize: 10000
                })
                .then(function (response) {
                    vm.debitAccountList = [];

                    vm.debitAccountList = HelperService.mergeRowsForTimeline({
                        existingData: vm.debitAccountList,
                        newData: {
                            result: response.result
                        },
                        groupFunction: function (item) {
                            var valueDate = new Date(item.changeDate);
                            valueDate.setHours(0, 0, 0, 0);
                            return valueDate;
                        },
                        virtualRowFunction: function (e) {
                            var virtualRow = {
                                isVirtual: true,
                                date: new Date(e)
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    }).result;
                }, function (error) {
                    vm.debitAccountList = [];
                });
        }

      var cleanLanguageChangeListener = $rootScope.$on('appLanguageChangedHeader', function (evt, data) {
        getSepaSettings(true);
      });

      $scope.$on('$destroy', function() {
        cleanLanguageChangeListener();
      });


        vm.setAccountFrom = function (account) {
            vm.model.fromAccountSelect = account;
            vm.fromAccountDropdown = false;
            getSepaSettings(true);
        };

        var selectedToEdit = {};
        vm.edit = function (data) {
          selectedToEdit.editInProgress = false;
            if (data.editInProgress) return;
          selectedToEdit = data;
          data.editInProgress = true;
            $state.go("sepa.new", {
                id: data.id
            }).then(function () {
              data.editInProgress = false;
            })
        };

        vm.addNewSetting = function () {
          if (vm.addNewSepaSettingLoading) return;
          vm.addNewSepaSettingLoading = true;
          $state.go("sepa.new")
            .finally (function () {
              vm.addNewSepaSettingLoading = false;
            });
        }

        vm.openSwitchItemActiveStateModal = function (item) {
            var confirmationText = "sepa.changeToActivated";
            var confirmationSuccessText;
            if (item.activated) {
                confirmationText = "sepa.changeToDeactivated";
                confirmationSuccessText = "sepa.deactivateSuccess";
            } else {
                confirmationText = "sepa.changeToActivated";
                confirmationSuccessText = "sepa.activateSuccess";
            }


            AlertService.confirmationAlert({
                    text: confirmationText
                })
                .then(function (accept) {
                    if (!accept) return;
                    var putObject = {
                        "id": item.id,
                        "accountId": item.accountId,
                        "maxAmount":item.maxAmount,
                        "settingType": {
                            "id": item.settingType.id,
                            "description": item.settingType.description
                        },
                        "note": item.note,
                        "activated": !item.activated,
                        "changeDate": item.changeDate
                    };
                    SepaService.updateSepaSetting(item.id, putObject)
                        .then(function (response) {
                            AlertService.infoAlert({
                                text: confirmationSuccessText
                                })
                                .then(function () {
                                    getSepaSettings(true);
                                });
                        }, function (error) {
                          HelperService.showMessage(error, 'error');
                        });
                });
        };

    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name sepa.controller:SepaComplaintRefundCtrl
   *
   * @description
   *
   */
  SepaComplaintRefundCtrl.$inject = ["$http", "$state", "transaction", "ValidationService", "HelperService", "SepaService"];
  angular
    .module('sepa')
    .controller('SepaComplaintRefundCtrl', SepaComplaintRefundCtrl);

  function SepaComplaintRefundCtrl($http, $state, transaction, ValidationService, HelperService, SepaService) {
    var vm = this;
    vm.type = $state.params.type;
    vm.status = $state.params.status;
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    vm.formStep = 1;

    vm.model = transaction;
    vm.inputModel = {
      reasonForcomplaint: "",
      extra: ""
    };

    var defaultId  = '';
    var tempId = '';

    init();
    function init() {
      loadData();
    }

    function selectReasonType() {
      var twoMonthsFromDate = new Date().setMonth(new Date().getMonth()-2);
      var thirteenMonthsFromNow = HelperService.setCustomMonthPeriod(new Date(),13);
      if(new Date(vm.model.valuteDate) > twoMonthsFromDate){
        vm.inputModel.reasonForcomplaint = _.findWhere(vm.complaintReasonTypes, {id: "DOD_OBRAZ"});
      }else {
        var temp = _.filter(vm.complaintReasonTypes, function (item) {
          return item.id == 'NEOD_SDD';
        });
        if(temp)
          vm.complaintReasonTypes = temp;
        vm.inputModel.reasonForcomplaint = _.findWhere(vm.complaintReasonTypes, {id: "NEOD_SDD"});
      }
    }

    function loadData() {
      SepaService.getSepaDDComplaintReasonTypes()
        .then(function (response) {
          vm.complaintReasonTypes = response.result;
          vm.inputModel.reasonForcomplaint = _.findWhere(vm.complaintReasonTypes, {id: "DOD_OBRAZ"});

          if($state.params.status == 'Processed'){
            // vm.complaintReasonTypes.push({ id: "DDCOMPLAINT", description: "Ugovor na izvršeno transakcijo SEPA DD" });
            // tempId = 'DDCOMPLAINT';
            selectReasonType();
          }else if($state.params.status == 'Waiting'){
            // vm.complaintReasonTypes.push({ id: "DDCOMPLAINTWQ", description: "Ugovor na transakcijo SEPA DD v čakalni vrsti" });
            // tempId = 'DDCOMPLAINTWQ';
          }
        }, function (error) {
          console.log(error);
        })
    }

    vm.next = function () {
      vm.formSubmitted = true;
      if (vm.refundForm.$invalid) return;
      vm.formStep = 2;
    };

    vm.back = function () {
      vm.formSubmitted = false;
      vm.formStep = 1;
      vm.confirmButtonDisabled = false;
      //vm.inputModel.reasonForcomplaint = defaultId;
    };

    vm.confirm = function () {
      vm.formSubmitted = true;
      if (vm.refundForm.$invalid) return;
      var input = {
        sepaDDComplaintReasonType: vm.inputModel.reasonForcomplaint,
        note: "  ",
        extra: (vm.inputModel.reasonForcomplaint.id == "DOD_OBRAZ") ? vm.inputModel.extra : "",
        status: vm.model.status
      };


      vm.confirmButtonDisabled = true;

      // Workaround - transactionId is hashed "-53593|4" need to get characters behind the |
      transaction.transactionId = transaction.transactionId.substring(transaction.transactionId.indexOf("|") + 1);

      // status must be there, whatever it is!
      var postData = angular.extend(input, transaction);
      postData.reference = postData.receiverReference;
      $http.post(transaction.linkList.itemList.complaint, postData)
        .success(function (data) {
          HelperService.confirmationReclamationMsg('core.confirmation');
          vm.confirmButtonDisabled = false;
          $state.go("sepa.transactions");
        })
        .error(function (error) {
          vm.confirmButtonDisabled = false;
          HelperService.showMessage(error, 'error');
        })
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name sepa.controller:SepaRefusalCroCtrl
   *
   * @description
   *
   */
  SepaAcceptedRefusalCroCtrl.$inject = ["$q", "$stateParams", "AccountsService", "SepaService", "HelperService", "$state", "AlertService"];
  angular
    .module('sepa')
    .controller('SepaAcceptedRefusalCroCtrl', SepaAcceptedRefusalCroCtrl);

  function SepaAcceptedRefusalCroCtrl($q, $stateParams, AccountsService, SepaService, HelperService, $state, AlertService) {
    var vm = this;
    vm.pageLoaded = false;
    vm.step = "start";

    vm.model = {
      fromAccountSelect: {},
      executionDate: new Date(),
      amount: "",
      identifierApproval: "", // Identifikator suglasnosti
      receiverId: "", // Identifikator primatelja
      receiverName: "",  // Naziv i sjedište primatelja plaćanja
      receiverAccount: "", // Račun primatelja plaćanja - IBAN
      receiverNumber: "" // Detalji plaćanja (poziv na broj primatelja)
    };

    init();
    function init() {
      loadData();
    }

    function loadData() {
      var promises = [];
      if (!$stateParams.transactionId) {
        return;
      }
      promises.push(SepaService.getById($stateParams.transactionId));
      $q.all(promises)
        .then(function (responses) {
          var transaction = responses[0];
          if (transaction) {
            vm.model.accountId = transaction.accountId;
            vm.model.amount = transaction.amount;
            vm.model.executionDate = new Date(transaction.valuteDate);
            vm.model.receiverName = transaction.receiverName;
            vm.model.receiverAccount = transaction.receiverAccount;
            vm.model.receiverNumber = transaction.receiverReference;
            vm.model.transactionId = transaction.transactionId;
            // Račun platitelja / Payer account
            vm.model.senderAccount = transaction.senderAccount; // Samo prikaz

            vm.pageLoaded = true;
          }
        }, function (error) {
          HelperService.showMessage(error, 'error');
          $state.go("sepa.transactions");
        });
    }

    function prepareDataForInsert(input) {
      var data = {};
      data.accountId = input.fromAccountSelect.accountId;
      data.inputValueDate = input.executionDate;
      data.amount = input.amount;
      data.receiverName = input.receiverName;
      data.receiverAccount = input.receiverAccount;
      data.receiverReference = input.receiverNumber;
      data.transactionId = input.transactionId;
      return data;
    }

    vm.submit = function (form) {
      vm.submitButtonDisabled = true;
      SepaService.addSepaDDComplaint(prepareDataForInsert(vm.model))
        .then(function (response) {
          vm.step = "sign";
          vm.responseModel = response;
          vm.submitButtonDisabled = false;
        }, function (error) {
          vm.submitButtonDisabled = false;
          HelperService.showMessage(error, 'error');
        })
    };

    vm.confirmSign = function () {
      if (vm.confirmSignBtnDisabled) return;
      vm.confirmSignBtnDisabled = true;
      SepaService.signSepaComplaint({
        "id": vm.responseModel.id,
        "signData": vm.model.insertChallenge
      })
        .then(function (response) {
          console.log(response);

          vm.confirmSignBtnDisabled = false;
          AlertService.infoAlert({
            text: 'sepa.signSuccessfull'
          }).then(function () {
            $state.go("sepa.transactions");
          });
        }, function (error) {
          HelperService.showMessage(error, 'error');
          vm.confirmSignBtnDisabled = false;
        })
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name secure3d
   * @description
   *
   */
  angular
    .module('secure3d', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('secure3d')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('secure3d', {
        url: '/secure3d',
        templateUrl: 'secure3d/secure3d.tpl.html',
        controller: 'Secure3dCtrl',
        controllerAs: 'secure3d',
        resolve:{
          authenticationGuard: ["$rootScope", "$q", "$state", function ($rootScope, $q, $state) {
            var country = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
            if(country !== 'hr'){
              $state.go('dashboard');
              return $q.reject('Forbidden');
            }
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name secure3d.controller:Secure3dCtrl
   *
   * @description
   *
   */
  Secure3dCtrl.$inject = ["$window"];
  angular
    .module('secure3d')
    .controller('Secure3dCtrl', Secure3dCtrl);

  function Secure3dCtrl($window) {
    var vm = this;
    vm.ctrlName = 'Secure3dCtrl';

    vm.goToLink = function () {
      $window.open('https://tridestest.cld.asseco-see.hr/card-management/', '_blank');
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name payments
   * @description
   *
   */
  angular
    .module('payments', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:StatementConfirmModalCtrl
   *
   * @description
   *
   */
  StatementConfirmModalCtrl.$inject = ["$uibModalInstance", "data"];
  angular
    .module('payments')
    .controller('StatementConfirmModalCtrl', StatementConfirmModalCtrl);

  function StatementConfirmModalCtrl($uibModalInstance, data) {

    var vm = this;
    vm.model = {
      stateOption: 0,
      information: ""
    };

    vm.selectedCountry = data;

    vm.confirm = function () {
      vm.statementForm.submitted = true;
      if (!vm.statementForm.$valid) return;
      $uibModalInstance.close(vm.model);
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:SavingsPayInCtrl
   *
   * @description
   *
   */
  SavingsPayInCtrl.$inject = ["$stateParams", "$state", "PaymentsService", "$log", "HelperService", "AccountsService", "PaymentTypesService", "PaymentTemplatesService", "$timeout", "$filter", "CurrencyService", "ExchangeRatesService", "PaymentFilterService", "Notification"];
  angular
    .module('payments')
    .controller('SavingsPayInCtrl', SavingsPayInCtrl);

  function SavingsPayInCtrl($stateParams, $state, PaymentsService, $log, HelperService, AccountsService, PaymentTypesService,
                            PaymentTemplatesService, $timeout, $filter, CurrencyService, ExchangeRatesService,
                            PaymentFilterService, Notification) {
    var vm = this;
    vm.ctrlName = 'SavingsPayInCtrl';

    vm.currentStep = 1;

    vm.paymentObject = {};
    vm.tempObj = {
      fromAccountSelect: {},
      toAccountSelect: {},
      fromAccountAmountInput: '',
      toAccountAmountInput: '',
      dueDateInput: new Date(),
      formSubmitted: false,
      fromCurrencySymbol: '',
      toCurrencySymbol: {},
      purposeOfPaymentInput: '',
      currentDate: HelperService.getYesterday().firstDay
    };

    vm.paymentResponse = {};
    vm.forUpdate = false;
    vm.accountsFrom = [];
    vm.accountTo = [];
    vm.paymentFilter = {};
    vm.currencyList = [];
    vm.fromAccountDropdown = false;
    vm.toAccountDropdown = false;

    vm.datePickerOpened = false;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.toggleFromAccount = function () {
      if (vm.accountsFrom.length > 1) {
        vm.fromAccountDropdown = !vm.fromAccountDropdown;
      }
    };

    vm.toggleToAccount = function () {
      if (vm.accountTo.length > 1) {
        vm.toAccountDropdown = !vm.toAccountDropdown;
      }
    };

    var setToAccountList = function (accountId) {
      vm.accountTo = _.filter(vm.accountsFrom, function (item) {
        return item.accountId != accountId;
      });
    };

    vm.setAccountFrom = function (item) {
      vm.tempObj.fromAccountSelect = item;
      vm.fromAccountDropdown = false;
    };

    vm.setAccountTo = function (item) {
      vm.tempObj.toAccountSelect = item;
      vm.toAccountDropdown = false;
    };

    var setToAccount = function () {
      setToAccountList(vm.tempObj.fromAccountSelect.accountId);
      vm.tempObj.toAccountSelect = vm.accountTo[0];
    };

    /*    var loadAccountById = function (accountId) {
      AccountsService.getAccountById(accountId)
        .then(function (response) {
          vm.tempObj.toAccountSelect = response;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };*/

    vm.tmpSearchText = {
      name: ''
    };
    vm.templateName = '';

    vm.searchTemplate = function () {
      vm.searchTemplateFilterExpanded = true;
      if (vm.searchTemplateFilterExpanded === true) {
        $timeout(function () {
          var searchTemplatesInput = angular.element('#searchTemplatesInput');
          searchTemplatesInput.focus();
        }, 500);
      }
    };

    vm.getPaymentTemplatesPage = function () {
      PaymentTemplatesService.getPage(vm.templatesFilter)
        .then(function (response) {
        vm.templateList = response;
      })
        .catch(function (error) {
        $log.error(error);
      });
    };

    vm.toggleTemplateFilterSelection = function () {
      vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
      if (vm.searchTemplateFilterExpanded) {
        vm.getPaymentTemplatesPage();
      }
    };

    vm.selectTemplate = function (id) {
      var index = _.findIndex(vm.templateList.result, function (item) {
        return item.id == id;
      });

      // load payment form from choosen template
      var currentTemplate = vm.templateList.result[index];
      var fromAccountIndex = _.findIndex(vm.accountsFrom, function (account) {
        return account.accountId == currentTemplate.accountId;
      });

      if (fromAccountIndex != -1) {
        vm.tempObj.fromAccountSelect = vm.accountsFrom[fromAccountIndex];
        setToAccountList(vm.tempObj.fromAccountSelect.accountId);
      };

      var toAccountIndex = _.findIndex(vm.accountTo, function (account) {
        return account.iban == currentTemplate.toAccountNumber;
      });

      if (toAccountIndex != -1) {
        vm.tempObj.toAccountSelect = vm.accountTo[toAccountIndex];
      }
      vm.tempObj.fromAccountAmountInput = $filter('number')(currentTemplate.amount, 2);
      vm.templateName = currentTemplate.name;
      vm.searchFilterExpanded = false;
      vm.searchTemplateFilterExpanded = false;
    };

    var clearInput = function () {
      vm.templateName = '';
      vm.tempObj.fromAccountAmountInput = '';
      vm.tempObj.dueDateInput = new Date();
   //   vm.tempObj.purposeOfPaymentInput = '';
      vm.tempObj.toAccountAmountInput = '';
      vm.tempObj.formSubmitted = false;
      /*      vm.smsPasswordInput = '';
      vm.smsAuthentificate = false;*/
    };

    vm.removeTemplate = function () {
      vm.searchTemplateFilterExpanded = false;
      clearInput();
    };

    var loadCurrencies = function () {
      return CurrencyService.getCurrencyPage({
        pageSize: 1000
      })
        .then(function (response) {
        vm.currencyList = response.result;
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.loadExchangeRatesList = function () {
      ExchangeRatesService.getExchangeRates(vm.exchangeRatesParams)
        .then(function (response) {
        vm.exchangeRatesList = response;
        loadCurrencies();
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    /*    vm.showSMSAuthentification = function () {
      vm.smsAuthentificate = !vm.smsAuthentificate;
    };*/

    ////SUBMIT/////

    var createPaymentObject = function () {
      return {
        accountId: vm.tempObj.fromAccountSelect.accountId,
        //fromAccountNumber: HelperService.parseAccountNumber(vm.tempObj.fromAccountSelect.accountNumber),
        toAccountNumber: HelperService.parseAccountNumber(vm.tempObj.toAccountSelect.accountNumber),
        amount: vm.tempObj.fromAccountAmountInput,
        dueDate: vm.tempObj.dueDateInput,
        currencySymbol: vm.tempObj.fromAccountSelect.currencySymbol,
        paymentTypeGroup: 'ForeignCurrencyTransfer',
       // purpose: vm.tempObj.purposeOfPaymentInput,
        domesticPayment: {
          destinationCurrencySymbol: 'HRK',
          purposeCode: 'I',
          ModalityCode: "1"
        }
      };
    };

    var postPaymentAction = function (response) {
      vm.paymentResponse = response;
      Notification.clearAll();
      vm.currentStep = 2;
    };

    vm.savingsPayInSubmit = function () {
      vm.tempObj.formSubmitted = true;
      if (!vm.savingsPayInForm.$valid) {
        return;
      }
      if ($state.params.editable) {
        vm.paymentResponse.id = $state.params.paymentId;
        vm.forUpdate = true;
      }
      vm.temPaymentObj = createPaymentObject();
      if (vm.forUpdate) {
        PaymentsService.updatePayment(vm.paymentResponse.id, vm.temPaymentObj)
          .then(function (response) {
          postPaymentAction(response);
          vm.forUpdate = false;
        })
          .catch(function (error) {
          HelperService.showMessage(error, 'error');
          vm.forUpdate = false;
        });
      } else {
        PaymentsService.insertPayment(vm.temPaymentObj)
          .then(function (response) {
          postPaymentAction(response);
        })
          .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
      }
    };

    vm.getDebitAccountList = function () {
      return PaymentTypesService.getByGroup(vm.paymentFilter)
        .then(function (response) {
        if (_.isArray(response.result) && response.result.length > 0) {
          var creditList = response.result[0].creditAccountList;
          _.forEach(creditList, function (item) {
            if (item.accountId === $stateParams.accountId) {
              return vm.accountsFrom = response.result[0].debitAccountList;
            }
          })
          if (vm.accountsFrom.length > 0) {
            vm.tempObj.fromAccountSelect = vm.accountsFrom[0];
            _.forEach(vm.accountsFrom, function (item) {
              if (item.accountDescription) {
                item.optionValue = item.accountDescription + ' - ' + item.iban;
              }
            });
          }
        }
      })
        .catch(function (error) {
        $log.error(error);
      });
    };

    vm.getCreditAccountList = function () {
      var tempDebitList = [];
      var tempCreditList = [];
      vm.paymentFilter.currencySymbol = vm.tempObj.fromAccountSelect.currencySymbol;
      return PaymentTypesService.getByGroup(vm.paymentFilter)
        .then(function (response) {
        switch($state.current.name) {
          case 'payments.savingsPayIn':
            vm.accountTo = response.result[0].creditAccountList;
            vm.tempObj.toAccountSelect = vm.accountTo[0];
            break;
          default:
            break;
        }
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.getAccounts = function () {
      AccountsService.getAccountById($stateParams.accountId)
        .then(function (response) {
        switch (response.accountType.group) {
          case 'CurrentAccount':
            vm.tempObj.fromAccountSelect = response;
            vm.tempObj.fromCurrencySymbol = response.currencySymbol;
            vm.accountsFrom.push(vm.tempObj.fromAccountSelect);
            vm.paymentFilter = {
              paymentTypeGroup: 'ForeignCurrencyTransfer',
              currencySymbol: response.currencySymbol,
              masterAccountId: vm.tempObj.fromAccountSelect.accountId
            };
            vm.getCreditAccountList();
            break;
          case 'SavingAccountTypes':
            vm.tempObj.toAccountSelect = response;
            vm.tempObj.toCurrencySymbol = response.currencySymbol;
            vm.accountTo.push(vm.tempObj.toAccountSelect);

            vm.paymentFilter = {
              paymentTypeGroup: 'ForeignCurrencyTransfer',
              currencySymbol: response.currencySymbol
            };
            vm.getDebitAccountList();
            break;
        }
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    var mapWithPaymentResponse = function () {
      vm.tempObj.fromAccountAmountInput = vm.paymentResponse.amount;
     // vm.tempObj.purposeOfPaymentInput = vm.paymentResponse.purpose;
      vm.tempObj.dueDateInput = new Date(vm.paymentResponse.dueDate);
    };

    vm.backTosavingsPayIn = function () {
      clearInput();
      vm.currentStep = 1;
    };

    vm.editPayment = function () {
      mapWithPaymentResponse();
      vm.forUpdate = true;
      vm.currentStep = 1;
    };

    vm.deletePayment = function () {
      PaymentsService.deletePayment(vm.paymentResponse.id)
        .then(function (response) {
        HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], vm.paymentResponse.id);
        $state.go('payments.paymentsOverview');
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    var getDataForAccounts = function (accountId, toAccountNumber, currencySymbol) {
      PaymentTypesService.getByGroup({paymentTypeGroup: 'ForeignCurrencyTransfer', currencySymbol: currencySymbol, masterAccountId: accountId})
        .then(function(paymentTypeResponse) {
        if(paymentTypeResponse.result.length > 0) {
          vm.accountsFrom = paymentTypeResponse.result[0].debitAccountList;
          vm.tempObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(vm.accountsFrom, accountId);
          vm.accountTo = paymentTypeResponse.result[0].creditAccountList;
          var tempAccountNumber = toAccountNumber.replace(/\D+$/g, "");
          vm.tempObj.toAccountSelect = PaymentFilterService.filterToAccountSelect(vm.accountTo, tempAccountNumber);
        }
      })
        .catch(function(error) {
        HelperService.showMessage(error, 'error');
      })
    };

    var populateFieldsWithValues = function () {
      PaymentsService.getById($stateParams.paymentId)
        .then(function (response) {
        vm.paymentObject = response;
        vm.tempObj.fromAccountAmountInput = $filter('number')(response.amount, 2);
     //   vm.tempObj.purposeOfPaymentInput = response.purpose;
        getDataForAccounts(response.accountId, response.toAccountNumber, response.currencySymbol);
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.init = function () {
      if ($state.current.name === 'payments.savingsPayIn.fromPayment') {
        populateFieldsWithValues();
      } else {
        vm.getAccounts();
      }
      vm.loadExchangeRatesList();
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:ReferenceModelService
   *
   * @description
   *
   */
  ReferenceModelService.$inject = ["$q", "EndpointsService", "$log", "$http"];
  angular
    .module('payments')
    .factory('ReferenceModelService', ReferenceModelService);

  function ReferenceModelService($q, EndpointsService, $log, $http) {
    var ReferenceModelServiceBase = {};
    ReferenceModelServiceBase.someValue = 'ReferenceModelService';

    ReferenceModelServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.referenceModels, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
            deferred.reject(msg);
          });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    return ReferenceModelServiceBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:PurposeCodesService
     *
     * @description
     *
     */
    PurposeCodesService.$inject = ["EndpointsService", "$q", "$http", "$log"];
    angular
        .module('payments')
        .factory('PurposeCodesService', PurposeCodesService);

    function PurposeCodesService(EndpointsService, $q, $http, $log) {
        var PurposeCodesServiceBase = {};
        PurposeCodesServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                //$log.debug("Params:", params);
                $http.get(response.links.purposeCodes, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        PurposeCodesServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.purposeCodes_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return PurposeCodesServiceBase;
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:PublicRevenueService
   *
   * @description
   *
   */
  PublicRevenueService.$inject = ["$q", "$http", "EndpointsService"];
  angular
    .module('payments')
    .factory('PublicRevenueService', PublicRevenueService);

  function PublicRevenueService($q, $http, EndpointsService) {
    var PublicRevenueServiceBase = {};
    PublicRevenueServiceBase.getMunicipalities = function (params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.municipalities, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PublicRevenueServiceBase.getRevenueCodes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.revenueCodes, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PublicRevenueServiceBase.getBudgetOrganizations = function (params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.budgetOrganisations, {
              params: params
            })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PublicRevenueServiceBase.getRevenueAccounts = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.revenueAccounts, {
              params: params
            })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    return PublicRevenueServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsSignCtrl
   *
   * @description
   *
   */
  PaymentsSignCtrl.$inject = ["$state", "$log", "$q", "$timeout", "PaymentsService", "PaymentSignListService", "ConfigEndpointService", "$localStorage", "ValidationService", "HelperService", "$sessionStorage", "$rootScope", "$translate"];
  angular
    .module('payments')
    .controller('PaymentsSignCtrl', PaymentsSignCtrl);

  function PaymentsSignCtrl($state, $log, $q,$timeout,
                            PaymentsService, PaymentSignListService, ConfigEndpointService,
                            $localStorage, ValidationService, HelperService, $sessionStorage,
                            $rootScope, $translate) {
    var vm = this;
    vm.signButtonDisabled = true;


    vm.init = function () {

      disableSMSButton();

      vm.countryCode = $localStorage.code;

      vm.objectForSignature = {};

      switch ($state.current.name) {
        case "payments.sign":
          loadPayment($state.params.paymentId)
            .then(function (){
              vm.objectForSignature = vm.selectedPaymentForSign;
              if(vm.selectedPaymentForSign.linkList.itemList.requestOTP){
                requestSMSCode(vm.selectedPaymentForSign);
              }
            });
          break;
        case "payments.groupSign":
          loadGroupOfPayments($state.params.groupId)
            .then(function (){
              vm.objectForSignature = vm.paymentsGroupList;
              if(vm.paymentsGroupList.linkList.itemList.requestOTP){
                requestSMSCode(vm.paymentsGroupList);
              }
            });
          break;
        default:
        // Unknown state
      }
      vm.smsPasswordInput = '';
      vm.challengeResponse = '';

      // Hide SMS/Challenge response input by default.
      vm.showInput = false;

      // If there is no country code, load it
      if (!vm.countryCode || vm.countryCode === '') {
        if($rootScope.APP_GLOBAL_SETTINGS.defaultData){
          vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
          vm.countryCode = vm.defaultData.APILocation;
        }
      }

      //else {
      //  // If country code is not HR, send SMS (SRB and MNE)
      //  if (vm.countryCode && vm.countryCode !== 'hr' && vm.countryCode != 'bh') {
      //    requestSMSCode();
      //  }
      //}

      vm.formSubmitted = false;
      vm.paymentType = $state.params.type || 'other';
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    };

    var loadPayment = function (paymentId) {
      var deferred = $q.defer();
      if($state.params.payment){
        vm.isPaymentDueDateValid = true;
        vm.dueDateUpdateAllowed = true;
        vm.selectedPaymentForSign = $state.params.payment;
        deferred.resolve(vm.selectedPaymentForSign);
      }
      if (paymentId) {
        return PaymentsService.getById(paymentId).then(function (payment) {

          if(vm.countryCode == 'hr' && payment.status == 'Signed'){
            $state.go('payments.finalStep', {paymentObject: payment , paymentId: payment.id, type: 'domestic'});
          }
          
          vm.selectedPaymentForSign = payment;
          if(vm.countryCode !== 'sr'){
            var updateObject = _.find(payment.allowedActionList.itemList, function (item) {
              return item.methodName === 'UpdateOldPaymentDateAllowed';
            });

            if (updateObject) {
              vm.dueDateUpdateAllowed = updateObject.isEnabled;
            }

            // Use only date without hours for compare
            var currentTime = new Date();
            currentTime.setHours(0, 0, 0, 0);
            // Check if all payments have valid due date
            vm.isPaymentDueDateValid = new Date(payment.dueDate) >= currentTime;
          }else{
            vm.isPaymentDueDateValid = true;
            vm.dueDateUpdateAllowed = true;
          }

        }).catch(function (error) {
          $log.error(error);
        });
      }
      return deferred.promise;
    };

    var loadGroupOfPayments = function (paymentGroupId) {
      var deferred = $q.defer();
      if (paymentGroupId) {
        return PaymentSignListService.getSignListById(paymentGroupId).then(function (paymentGroup) {

          vm.paymentsGroupList = paymentGroup;

          if(vm.countryCode !== 'sr'){
            var updateObject = _.find(vm.paymentsGroupList.allowedActionList.itemList, function (item) {
              return item.methodName === 'UpdateOldPaymentDatesAllowed';
            });

            if (updateObject) {
              vm.dueDateUpdateAllowed = updateObject.isEnabled;
            }

            // Use only date without hours for compare
            var currentTime = new Date();
            currentTime.setHours(0, 0, 0, 0);
            // Check if all payments have valid due date
            vm.areAllPaymentsDueDateValid = _.every(vm.paymentsGroupList.paymentList, function (payment) {
              return new Date(payment.dueDate) >= currentTime;
            });
          }else{
            vm.areAllPaymentsDueDateValid = true;
            vm.dueDateUpdateAllowed = true;
          }

        }).catch(function (err) {
          $log.error(err);
        });
      }

      return deferred.promise;
    };

    /*  Single payment */
    vm.updateSinglePaymentDate = function () {
      if (vm.selectedPaymentForSign) {
        // Sign newly created list of payments.
        return PaymentsService.updatePaymentDueDate(vm.selectedPaymentForSign.id).then(function (updatedPayment) {
          if (updatedPayment) {
            // Use only date without hours for compare
            var currentTime = new Date();
            currentTime.setHours(0, 0, 0, 0);
            // Check if all payments have valid due date
            vm.isPaymentDueDateValid = new Date(updatedPayment.dueDate) >= currentTime;
            vm.selectedPaymentForSign = updatedPayment;
          }
        }).catch(function (error) {
          $log.error(error);
        });
      }
    };

    vm.signSinglePayment = function () {
      if (vm.selectedPaymentForSign) {
        vm.formSubmitted = true;

        // Sign newly created list of payments.
        var params = {
          id: vm.selectedPaymentForSign.id
        };

        // SMS for Srb/Mne
        if (vm.smsPasswordInput !== '') {
          params.signData = vm.smsPasswordInput;
        }
        // Challenge for CRO
        if (vm.challengeResponse !== '') {
          params.signData = vm.challengeResponse;
        }

        if(vm.countryCode == 'sl' ){
          params.payment = $state.params.payment;
          if(vm.smsPasswordInput){
            params.payment.signData = vm.smsPasswordInput;
          }else
            params.payment.signData = '';
        }


        return PaymentsService.signPayment(params).then(function (signedPayment) {
          console.log(signedPayment);
          // TODO: Uncomment after API fix - signed payment has no data currently
          // $state.go('payments.finalStep', {paymentId: signedPayment.payment.id, paymentObject: signedPayment.payment, type: vm.paymentType });
          $state.go('payments.finalStep', {paymentObject: signedPayment.payment || signedPayment, paymentId: vm.selectedPaymentForSign.id, type: vm.paymentType});
        }).catch(function (error) {
          $log.error(error);

          if(error && error.resultList[0] && error.resultList[0].key === 'CUTOFF'){
            signLastPayment(error.resultList[0].description, params);
          }else if (error && error.resultList[0] && error.resultList[0].key === 'UpdateOldDate'){
            openUpdateSinglePaymentDueDateModal(params);
          }else{
            HelperService.showMessage(error, 'error');
          }

          // To prevent multiple requests
          vm.formSubmitted = false;
        });
      }
    };

    var signLastPayment = function(message, params){
      if(params){
        PaymentsService.openUpdateCurrencyDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            return PaymentsService.signPayment(params).then(function (signedPayment) {
              console.log(signedPayment);
              // TODO: Uncomment after API fix - signed payment has no data currently
              // $state.go('payments.finalStep', {paymentId: signedPayment.payment.id, paymentObject: signedPayment.payment, type: vm.paymentType });
              $state.go('payments.finalStep', {paymentId: vm.selectedPaymentForSign.id, type: vm.paymentType});
            }).catch(function (error) {
              $log.error(error);
              HelperService.showMessage(error, 'error');
            });
          }
        });
      }
    };

    var openUpdateSinglePaymentDueDateModal = function(params){
      if(params){
        PaymentsService.openUpdatePaymentDueDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            params.useCurrentDate = true;
            return PaymentsService.signPayment(params).then(function (signedPayment) {
              console.log(signedPayment);
              // TODO: Uncomment after API fix - signed payment has no data currently
              // $state.go('payments.finalStep', {paymentId: signedPayment.payment.id, paymentObject: signedPayment.payment, type: vm.paymentType });
              $state.go('payments.finalStep', {paymentId: vm.selectedPaymentForSign.id, type: vm.paymentType});
            }).catch(function (error) {
              $log.error(error);
              HelperService.showMessage(error, 'error');
            });
          }
        });
      }
    };

    /* Group payments */
    vm.updateGroupPaymentDates = function () {
      if (vm.paymentsGroupList) {
        // Update due dates of payments
        return PaymentSignListService.updateGroupPaymentDates(vm.paymentsGroupList.id).then(function (updatedPayments) {
          vm.paymentsGroupList = updatedPayments;

          // Use only date without hours for compare
          var currentTime = new Date();
          currentTime.setHours(0, 0, 0, 0);

          // Check if all payments have valid due date
          vm.areAllPaymentsDueDateValid = _.every(vm.paymentsGroupList.paymentList, function (payment) {
            return new Date(payment.dueDate) >= currentTime;
          });
          console.log(updatedPayments);
        }).catch(function (error) {
          $log.error(error);
        });
      }
    };
    vm.cancelGroupPayments = function () {
      $state.go('payments.paymentsOverview', {myParam: 'not-signed'})
    };

    vm.signGroupPayments = function () {
      if (vm.paymentsGroupList) {
        vm.formSubmitted = true;

        var listForSign = {
          id: vm.paymentsGroupList.id,
          cutoffChecked: false,
          useCurrentDate: false
        };

        if (vm.smsPasswordInput !== '') {
          listForSign.signData = vm.smsPasswordInput;
        }
        if (vm.challengeResponse !== '') {
          listForSign.signData = vm.challengeResponse;
        }

        // Sign newly created list of payments.
        return PaymentSignListService.signAllPaymentsOnList(listForSign).then(function (signedPayments) {
          $state.go('payments.finalStep', {paymentId: vm.paymentsGroupList.id, type: 'group'});
          console.log(signedPayments);
        }).catch(function (error) {
          $log.error(error);
          if(error && error.resultList[0] && error.resultList[0].key === 'CUTOFF'){
            signLastGroupOfPayments(error.resultList[0].description, listForSign);
          }else if (error && error.resultList[0] && error.resultList[0].key === 'UpdateOldDate'){
            openUpdateGroupPaymentsDueDateModal(listForSign);
          }else{
            HelperService.showMessage(error, 'error');
          }

          vm.formSubmitted = false;
        });
      }
    };

    var openUpdateGroupPaymentsDueDateModal = function(params){
      if(params){
        PaymentsService.openUpdatePaymentDueDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            params.useCurrentDate = true;
            return PaymentSignListService.signAllPaymentsOnList(params).then(function (signedPayments) {
              $state.go('payments.finalStep', {paymentId: vm.paymentsGroupList.id, type: 'group'});
              console.log(signedPayments);
            }).catch(function (error) {
              HelperService.showMessage(error, 'error');
              $log.error(error);
            });
          }
        });
      }
    };

    var signLastGroupOfPayments = function(message, params){
      if(params){
        PaymentsService.openUpdateCurrencyDateModal()
          .result.then(function (result) {
          if (result == "confirm") {
            params.cutoffChecked = true;
            return PaymentSignListService.signAllPaymentsOnList(params).then(function (signedPayments) {
              $state.go('payments.finalStep', {paymentId: vm.paymentsGroupList.id, type: 'group'});
              console.log(signedPayments);
            }).catch(function (error) {
              HelperService.showMessage(error, 'error');
              $log.error(error);
            });
          }
        });
      }
    };

    var requestSMSCode = function (payment) {
      // SMS is already sent, no need to send it again on controller init. If user wants to request SMS again, there is button for that action.
      if ($sessionStorage.sentSMS && $sessionStorage.sentSMS !== '') return;
        vm.sendSMS(payment);
    };

    vm.toggleInputVisibility = function () {
      vm.showInput = !vm.showInput;
      var smsInput = document.getElementById("smsInput");
      smsInput.focus();
    };

    vm.sendSMS = function (paymentObj) {
      disableSMSButton();
      var payment = paymentObj || vm.objectForSignature;
      return PaymentsService.requestSMSCode(payment.linkList.itemList.requestOTP)
        .then(function (code) {
          $sessionStorage.sentSMS = true;
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
            var message = $translate.instant('signPayments.SmsSentSuccessfully');
            HelperService.showTranslatedMessage('success', message,'',3000);
          }
        }).catch(function (error) {
          HelperService.showMessage(error, 'error');
          $log.error(error);
        });
    };

    vm.repeatSmsCounter = 0;
    vm.requestSMSCodeForSlo = function () {
      if (vm.resendSMSInProgress || vm.repeatSmsCounter == 3) return;
      vm.resendSMSInProgress = true;
      vm.repeatSmsCounter++;
      PaymentsService.insertPayment($state.params.payment)
        .then(function (response) {
        })
        .catch(function (response, error) {
          if (response && response.hasWarnings) {
            //show action message modal
            PaymentsService.showModalWithActions(response, objectForInsert);
          } else {
            HelperService.showMessage(response, 'error');
          }
        })
        .finally(function () {
          vm.resendSMSInProgress = false;
        });
    }

    // Delete from storage information about sent SMS
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      delete $sessionStorage.sentSMS;
    });

    function disableSMSButton() {
      vm.signButtonDisabled = true;
      $timeout(function () {
        vm.signButtonDisabled = false;
      }, 30000);
    }

    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:PaymentsService
   *
   * @description
   *
   */
  PaymentsService.$inject = ["$state", "$sessionStorage", "EndpointsService", "$q", "$http", "$log", "$uibModal", "PaymentFilterService", "HelperService", "$localStorage", "$rootScope", "PaymentTypesService", "SessionService"];
  angular
    .module('payments')
    .factory('PaymentsService', PaymentsService);

  function PaymentsService($state, $sessionStorage, EndpointsService, $q, $http, $log, $uibModal, PaymentFilterService, HelperService,
                           $localStorage, $rootScope, PaymentTypesService,SessionService) {
    var PaymentsServiceBase = {};

    //TSK-8283
    //ako se prilikom refresha u session storageu nadje neki objekat potrebno ga je POSTati (jer je sesija istekla prije POSTa)
    if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'payment'){
      insertPayment($sessionStorage.paymentStorageObject.object);
    }

    if($sessionStorage.paymentForSignObject && $sessionStorage.paymentForSignObject.t == 'paymentForSign'){
      signPayment($sessionStorage.paymentForSignObject.o);
    }

    PaymentsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.payments, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    PaymentsServiceBase.getAll = function (params) {
      var predefinedParams = {
        page: 0,
        pageSize: 10
      };
      var extended = _.extend(predefinedParams, params);
      return PaymentsServiceBase.getPage(extended);
    };
    PaymentsServiceBase.getRejectedPayments = function (params) {
      var predefinedParams = {
        page: 0,
        status: 'Rejected',
        orderBy: 'dueDate DESC',
        pageSize: 10
      };
      var extended = _.extend(predefinedParams, params);
      return PaymentsServiceBase.getPage(extended);
    };
    PaymentsServiceBase.getPendingPayments = function (params) {
      var predefinedParams = {
        page: 0,
        status: 'InProcessing',
        orderBy: 'dueDate DESC',
        pageSize: 10
      };
      var extended = _.extend(predefinedParams, params);
      return PaymentsServiceBase.getPage(extended);
    };

    function signPayment(params) {
      // Normal payment sign
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $sessionStorage.paymentForSignObject = {
            o: params,
            t: 'paymentForSign'
          };
          $http.put(response.links.payments_sign, params)
            .success(function (data) {
              $rootScope.$broadcast("paymentInserted");
              delete $sessionStorage.paymentForSignObject;
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    PaymentsServiceBase.signPayment = function (params) {
      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {

        //sign changed payment that is already signed
        if(params.payment.paymentIdTemp){
          var tempId = params.payment.paymentIdTemp;
          delete params.payment.paymentIdTemp;
          return _updatePayment(tempId, params.payment);
        }
       return insertPayment(params.payment);
      }

      return signPayment(params);
    };

    PaymentsServiceBase.paymentsAppeal = function (data) {

      // Normal payment sign
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.payments_appeal, data)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.updatePaymentDueDate = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.payments_id_updateOldPaymentDate.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.insertPayment = function (paymentObject) {
      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        return validatePayment(paymentObject);
      }

      return insertPayment(paymentObject);
    };

    function _updatePayment(id, paymentObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.payments_id.replace('{id}', id), paymentObject)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function insertPayment (paymentObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          var link = (paymentObject.linkList) ? paymentObject.linkList.itemList.sign : response.links.payments;
          SessionService.saveStorageObject(paymentObject,'payment');
          $http.post(link, paymentObject)
            .success(function (data) {
              $rootScope.$broadcast("paymentInserted");
              SessionService.removeStorageObject();
              if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                if (!data && !data.id) {
                  deferred.reject({resultList: [ {description: "Error! Something went wrong!" }]});
                } else {
                  deferred.resolve(data);
                }
              } else {
                deferred.resolve(data);
              }
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }


    PaymentsServiceBase.paymentOrderConfirm = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.paymentConfirmOrders, data)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.updatePayment = function (id, request, additionalParam) {

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && additionalParam !== 'changeProcessed') {
        return validatePayment(request);
      }

      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.payments_id.replace('{id}', id), request)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.validatePayment = function (request) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.payments_validate, request)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    function validatePayment (request) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.payments_validate, request)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    PaymentsServiceBase.deletePayment = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.delete(response.links.payments_id.replace('{id}', id))
            .success(function (data) {
              $rootScope.$broadcast("paymentInserted");
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.recallPayment = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.payments_recall, params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.openSignModal = function (paymentId) {
      var modalInstance = $uibModal.open({
        templateUrl: 'payments/payment-sign-modal.tpl.html',
        controller: 'PaymentSignModalCtrl',
        controllerAs: 'paymentSignModal',
        resolve: {
          paymentId: function () {
            return paymentId;
          }
        },
        backdrop: 'static',
        size: 'sm'
      });
      return modalInstance.result;
    };

    PaymentsServiceBase.openStatementConfirmModal = function (selectedCountry) {
      return $uibModal.open({
        templateUrl: 'payments/statement-confirm-modal.tpl.html',
        controller: 'StatementConfirmModalCtrl',
        controllerAs: 'statementConfirmModal',
        resolve: {
          data: function () {
            return selectedCountry;
          }
        }
      });
    };

    PaymentsServiceBase.getById = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        if(params) {
          $http.get(response.links.payments_id.replace('{id}', id), {
              params: params
            })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          $http.get(response.links.payments_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        }
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.getPaymentModes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.paymentModes)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        //   deferred.reject(error);
      });
      return deferred.promise;
    };

    PaymentsServiceBase.getBicBanks = function (id, params) {
      return $q(function (resolve, reject) {
        if (id) {
          EndpointsService.getLinks().then(function (response) {
            $http.get(response.links.bicBanks.replace('{id}', id))
              .success(function (data) {
                resolve(data);
              })
              .error(function (msg) {
                reject(msg);
              })
          })
        } else {
          EndpointsService.getLinks().then(function (response) {
            $http.get(response.links.bicBanks, {params: params})
              .success(function (data) {
                resolve(data);
              })
              .error(function (msg) {
                reject(msg);
              })
          })
        }
      });
    };

    PaymentsServiceBase.getCountries = function (id, params) {
      return $q(function (resolve, reject) {
        if (id) {
          EndpointsService.getLinks().then(function (response) {
            $http.get(response.links.countries_id.replace('{id}', id))
              .success(function (data) {
                resolve(data);
              })
              .error(function (msg) {
                reject(msg);
              })
          })
        } else {
          EndpointsService.getLinks().then(function (response) {
            $http.get(response.links.countries, {params: params})
              .success(function (data) {
                resolve(data);
              })
              .error(function (msg) {
                reject(msg);
              })
          })
        }
      });
    };

    PaymentsServiceBase.loadDomesticPaymentData = function (id, paymentObject, params) {
      var countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

      function commonMapping (response) {
        paymentObject.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountList, response.accountId);
        paymentObject.purposeOfPaymentInput = response.purpose;
        paymentObject.amountInput = response.amount;
        paymentObject.receiversAddressInput = response.receiverAddress1;
        paymentObject.toAccountInput = response.toAccountNumber;
        paymentObject.dueDateTemp = new Date(response.dueDate);
        paymentObject.referenceToTemp = response.referenceTo;
        params.payeeSearchFilter = response.receiverName;
        response.urgency == 1 ? params.urgency = true : params.urgency = false;
        response.paymentSubTypeGroup ? params.isInternal = true : params.isInternal = false;

        if(countryCode == 'sl')
          paymentObject.beneficiarySWIFTCode = response.beneficiarySWIFTCode;

      }

      if(countryCode === 'bh') {
        return this.getById(id, {includeList: ['RevenuePaymentDetails']})
          .then(function (response) {
            // mapping related to public revenue
            if (response.revenuePaymentDetails) {
              paymentObject.budgetOrganization = response.revenuePaymentDetails.budgetOrganization;
              paymentObject.municipality = response.revenuePaymentDetails.municipality;
              paymentObject.priority = response.revenuePaymentDetails.priority;
              paymentObject.revenueCode = response.revenuePaymentDetails.revenueCode;
              paymentObject.taxPayerId = response.revenuePaymentDetails.taxPayerId;
              paymentObject.taxPeriodFrom = new Date(response.revenuePaymentDetails.taxPeriodFrom);
              paymentObject.taxPeriodTo = new Date(response.revenuePaymentDetails.taxPeriodTo);
            }
            commonMapping(response);
            if (response.purposeCodeDPS) {
              paymentObject.purposeCodeSelect = PaymentFilterService.filterPurposeCodeSelect(params.purposeCodeList, response.purposeCodeDPS);
            }
            if(response.revenuePaymentDetails)
              paymentObject.referenceNumberInput = response.revenuePaymentDetails.reference;

          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      } else {
        return this.getById(id)
          .then(function (response) {
            //filterFromAccountSelect(response.fromAccountNumber);
            commonMapping(response);
            paymentObject.receiversPostalCodeAndCityInput = response.receiverCity;
            if (response.referenceTo) {
              var model = response.referenceTo.substring(0, 2);
              var refNumber = response.referenceTo.substring(2);
              paymentObject.referenceNumberInput = refNumber || '';
              paymentObject.referenceModelSelect = PaymentFilterService.filterReferenceModelSelect(params.referenceModelList, model);
            }
            if (response.purposeCodeDPS) {
              if ($localStorage.code === 'sr') { ///jer se na Srbiji šalje 2 ili 9 ispred šifre
                var tempPurpose = response.purposeCodeDPS.substr(1);
              } else {
                tempPurpose = response.purposeCodeDPS;
              }
              paymentObject.purposeCodeSelect = PaymentFilterService.filterPurposeCodeSelect(params.purposeCodeList, tempPurpose);
            }
            //if (response.referenceTo) {
            //  paymentObject.referenceModelSelect = PaymentFilterService.filterReferenceModelSelect(params.referenceModelList, response.referenceTo);
            //}
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          })
      }
    };

    PaymentsServiceBase.loadCurrencyConversionData = function (id, paymentObject, params) {
      //using master account
      function loadAccountsLists (accountId) {
        return PaymentTypesService.getByGroup({
          paymentTypeGroup: 'CurrencyExchange',
          masterAccountId: accountId
        })
          .then(function (response){
              params.fromAccountsList = response.result[0].debitAccountList;
              params.toAccountsList = response.result[0].creditAccountList;
            _.forEach(params.fromAccountsList, function (item) {
              if (item.accountDescription) {
                item.optionValue = item.iban + ' - ' + item.currencySymbol;
              }
            });

            _.forEach(params.toAccountsList, function (item) {
              if (item.accountDescription) {
                item.optionValue = item.accountDescription + ' - ' + item.iban;
              }
            });
          })
          .catch(function (error){
            $log.debug("Error loading accounts: " + error);
          })
      };

      return this.getById(id)
        .then(function (response) {
          return loadAccountsLists(response.accountId)
            .then(function(){
              if (response.amount) {
                paymentObject.fromAccountAmountInput = response.amount;
                params.exchangeType = {
                  from: true,
                  to: false
                };
              } else if (response.transactionAmount2) {
                paymentObject.toAccountAmountInput = response.transactionAmount2;
                params.exchangeType = {
                  from: false,
                  to: true
                };
              }

              //filterFromAccountSelect(response.fromAccountNumber);
              paymentObject.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountsList, response.accountId);
              paymentObject.sellCurrencyInput = paymentObject.fromAccountSelect.currencySymbol;
              //filterToAccountSelect(response.toAccountNumber.split(" ")[0]);
              paymentObject.toAccountSelect = PaymentFilterService.filterToAccountSelect(params.toAccountsList, response.toAccountNumber.split(" ")[0]);
              var tempObj = {
                sellCurrency: paymentObject.sellCurrencyInput,
                localCurrency: params.localCurrency,
                currencyList: params.currencyList,
                destinationCurrency: response.destinationCurrencySymbol
              };
              paymentObject.buyCurrencyInput = PaymentFilterService.filterBuyCurrencyInput(tempObj);
            })
            .catch(function (error){
                $log.debug(error);
            })
        })
        .catch(function (error) {

        });
    };


    PaymentsServiceBase.openCurrencyCalculatorModal = function () {
      var modalScope = $rootScope.$new();
      modalScope.modalInstance = $uibModal.open({
        templateUrl: 'payments/currency-calculator-modal.tpl.html',
        controller: 'CurrencyCalculatorModalCtrl',
        controllerAs: 'currencyCalculator',
        scope: modalScope,
        size: 'lg',
        backdrop: 'static'
      });
    };

    PaymentsServiceBase.getPaymentPdfLink = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.payments_downloadLink_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PaymentsServiceBase.downloadPaymentPdf = function(paymentId){
      var nonBlockingWindow = window.open('', '_self');
      PaymentsServiceBase.getPaymentPdfLink(paymentId)
        .then(function (pdfLink) {
          if(pdfLink){
            // If we want to open link in same tab (immediate download)
            // window.location.href = pdfLink.url;

            // Opening in new empty tab
            nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(pdfLink.url);
          }
        })
        .catch(function (error) {
          nonBlockingWindow.close();
          HelperService.showMessage(error, 'error');
          $log.debug(error);
        });
    };

    PaymentsServiceBase.openRecallReasonModal = function (data) {
      var options = {
        templateUrl: 'payments/payments-recall-modal.tpl.html',
        controller: 'PaymentsRecallModalCtrl',
        controllerAs: 'paymentsRecallModal',
        backdrop: 'static',
        resolve: {
          data: data
        }
      };
      // For Slovenia
      if (data) options.size = "lg";
      return $uibModal.open(options);
    };

    PaymentsServiceBase.requestSMSCode = function (url) {
      var deferred = $q.defer();
      $http.get(url)
        .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
        deferred.reject(msg);
      });
      return deferred.promise;
    };

    PaymentsServiceBase.isVerificationRequiredForSign = function (payment) {
      // Internal transfer in Srb/Mne does not need SMS verification
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation !== 'hr' &&
        ((payment.paymentTypeGroup === 'LocalCurrencyTransfer' && payment.paymentSubTypeGroup != 'DomesticPayment')  || payment.paymentTypeGroup === 'CurrencyExchange' )) {
        return false;
      }
      return true;
    };

    PaymentsServiceBase.openUpdatePaymentDueDateModal = function () {
      return $uibModal.open({
        templateUrl: 'payments/payment-update-date-modal.tpl.html',
        backdrop: 'static',
        size: 'lg'
      });
    };

    // Message - Error message from API that will be displayed. If no message is sent, text from localization will be shown
    PaymentsServiceBase.openUpdateCurrencyDateModal = function (message) {
      return $uibModal.open({
        templateUrl: 'payments/payment-update-currency-date-modal.tpl.html',
        backdrop: 'static',
        size: 'lg',
        controller : ["$scope", function($scope) {
          $scope.errorMessage = message;
        }]
      });
    };

    PaymentsServiceBase.getSignatureList = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.payments_id.replace('{id}', id+'?includeList=Signatures'))
          .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      },
    function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    //endpoint specific to BiH
    PaymentsServiceBase.getBankCharges = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          if (response.links.bankCharges) {
            $http.get(response.links.bankCharges,{
              params: params
            })
              .success(function (data) {
                deferred.resolve(data);
              }).error(function (msg, code) {
              deferred.reject(msg);
            });
          } else {
            deferred.resolve(null);
          }
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.setFromAccountsToDefaulCurrency = function(accountsList){
      if (_.isArray(accountsList) && accountsList.length > 0) {
        return _.find(accountsList, function (item) {
          return item.currencySymbol == $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
        });
      }
    };

    PaymentsServiceBase.showModalWithActions = function (response,paymentObject, isDomestic, isSepaAndUrgent) {
      var obj = {
        msg: response.resultList[0].description,
        type: response.resultList[0].key
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'payments/change-payment-date-modal.tpl.html',
        backdrop: 'static',
        controller: 'ChangePaymentDateModalCtrl',
        controllerAs: 'changePaymentDateModal',
        size: 'lg',
        resolve: {
          obj: function () {
            obj.domestic = isDomestic;
            obj.isSepaAndUrgent = isSepaAndUrgent;
            return obj;
          }
        }
      })
        .result
        .then(function(result){
          console.log(result);
          if(result == "yes" && obj.type=='ToAccountNumber' ) {

            if(paymentObject.paymentTypeGroup == 'ForeignPayment')
              $state.go('payments.domesticPayment.fromInternational', {transactionDetails: paymentObject});

            if(paymentObject.paymentTypeGroup == 'DomesticPayment')
              $state.go('payments.internationalPayment.fromDomestic', {transactionDetails: paymentObject});
          }
          // if(result == "yes" && obj.type=='changeDate'){
          //   //set nonWorkingDate
          //   NonWorkingDays.nextWorkingDate(paymentObject.dueDate)
          //     .then(function (response) {
          //       vm.paymentResponse.dueDate = new Date(response);
          //       vm.steps = {
          //         step1: false,
          //         step2: true,
          //         step3: false
          //       };
          //     })
          //     .catch(function (response) {
          //       HelperService.showMessage(response, 'error');
          //     })
          // }
        });
    };

    return PaymentsServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('payments')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('payments', {
        url: '/payments',
        abstract: true
          //templateUrl: 'payments/payments.tpl.html',
          //controller: 'PaymentsCtrl',
          //controllerAs: 'payments'
      })
      //.state('payments.exchangeRates', {
      //  url: '/payments-exchangeRates',
      //  views: {
      //    '@': {
      //      templateUrl: 'payments/exchange-rates.tpl.html',
      //      controller: 'ExchangeRatesCtrl',
      //      controllerAs: 'exchangeRates'
      //    }
      //  }
      //})

      //state relevant only for MNE environment
      .state('payments.exchangeRates', {
        url: '/exchangeRates',
        views: {
          '@': {
            templateUrl: 'payments/currency-calculator-modal.tpl.html',
            controller: 'CurrencyCalculatorModalCtrl',
            controllerAs: 'currencyCalculator'
          }
        },
        resolve: {
          validateUrl: ["$localStorage", "$location", "ConfigEndpointService", function ($localStorage, $location, ConfigEndpointService) {
              ConfigEndpointService.getDefaultData()
                .then(function (response) {
                  if (response.APILocation !== 'mne') {
                    //redirect to dashboard
                    $location.url('/dashboard');
                  }
                })
                .catch(function (error) {
                  //redirect to dashboard page
                  $location.url('/dashboard');
                })
          }]
        }
      })
      .state('payments.currencyConversion', {
        url: '/currency-conversion',
        views: {
          '@': {
            templateUrl: 'payments/currency-conversion.tpl.html',
            controller: 'CurrencyConversionCtrl',
            controllerAs: 'currencyConversion'
          }
        }
      })
      // load currency conversion from payment
      .state('payments.currencyConversion.fromPayment', {
        url: '/load/:paymentId',
        params: {
          editable: null
        },
        views: {
          '@': {
            templateUrl: 'payments/currency-conversion.tpl.html',
            controller: 'CurrencyConversionCtrl',
            controllerAs: 'currencyConversion'
          }
        }
      })
      // load currency conversion from template
      .state('payments.currencyConversion.fromTemplate', {
        url: '/template/:templateId',
        views: {
          '@': {
            templateUrl: 'payments/currency-conversion.tpl.html',
            controller: 'CurrencyConversionCtrl',
            controllerAs: 'currencyConversion'
          }
        }
      })
      .state('payments.paymentsOverview', {
        url: '/payments-overview',
        views: {
          '@': {
            templateUrl: 'payments/payments-overview.tpl.html',
            controller: 'PaymentsOverviewCtrl',
            controllerAs: 'paymentsOverview'
          }
        },
        params: {
          selected: null,
          myParam: null
        }
      })
      .state('payments.reclamation', {
        url: '/reclamation/:paymentId',
        views: {
          '@': {
            templateUrl: 'payments/payment-reclamation.tpl.html',
            controller: 'PaymentReclamationCtrl',
            controllerAs: 'vm',
            resolve: {
              payment: ["$stateParams", "PaymentsService", function($stateParams, PaymentsService) {
                return PaymentsService.getById($stateParams.paymentId)
              }],
              validate: ["$q", "payment", function ($q, payment) {
                if(!payment) $q.reject();
              }]
            }
          }
        }
      })
      .state('payments.paymentsAndTransferOverview', {
        url: '/payments-and-transfer-overview',
        views: {
          '@': {
            templateUrl: 'payments/payments-and-transfer-overview.tpl.html',
            controller: 'PaymentsAndTransferOverviewCtrl',
            controllerAs: 'patoCtrl'
          }
        }
      })
      //basic domestic payment
      .state('payments.domesticPayment', {
        url: '/domestic-payment',
        params: {
          myParam: null,
          transactionDetails: {}
        },
        views: {
          '@': {
            templateUrl: 'payments/domestic-payment.tpl.html',
            controller: 'DomesticPaymentCtrl',
            controllerAs: 'domesticPayment'
            // resolve: {
            //   defaultLocationData: function ($rootScope,ConfigEndpointService) {
            //     return ConfigEndpointService.getDefaultData();
            //   }
            // }
          }
        }
      })
      //load domestic payment from payment id
      .state('payments.domesticPayment.fromPayment', {
        url: '/load/:paymentId',
        params: {
          editable: null
        },
        views: {
          '@': {
            templateUrl: 'payments/domestic-payment.tpl.html',
            controller: 'DomesticPaymentCtrl',
            controllerAs: 'domesticPayment'
            // resolve: {
            //   defaultLocationData: function (ConfigEndpointService) {
            //     return ConfigEndpointService.getDefaultData();
            //   }
            // }
          }
        }
      })
      //load domestic payment from template
      .state('payments.domesticPayment.fromTemplate', {
        url: '/template/:templateId',
        views: {
          '@': {
            templateUrl: 'payments/domestic-payment.tpl.html',
            controller: 'DomesticPaymentCtrl',
            controllerAs: 'domesticPayment'
            // resolve: {
            //   defaultLocationData: function (ConfigEndpointService) {
            //     return ConfigEndpointService.getDefaultData();
            //   }
            // }
          }
        }
      })
      //load domestic payment from template - Pay - SLO
      .state('payments.domesticPayment.fromTemplatesToPay', {
        url: '/template-pay/:templateId',
        views: {
          '@': {
            templateUrl: 'payments/domestic-payment.tpl.html',
            controller: 'DomesticPaymentCtrl',
            controllerAs: 'domesticPayment'
            // resolve: {
            //   defaultLocationData: function (ConfigEndpointService) {
            //     return ConfigEndpointService.getDefaultData();
            //   }
            // }
          }
        }
      })
    //load domestic payment from current account

      .state('payments.domesticPayment.fromAccount', {
        url: '/from-accounts/:accountId',
        views: {
          '@': {
            templateUrl: 'payments/domestic-payment.tpl.html',
            controller: 'DomesticPaymentCtrl',
            controllerAs: 'domesticPayment'
            // resolve: {
            //   defaultLocationData: function (ConfigEndpointService) {
            //     return ConfigEndpointService.getDefaultData();
            //   }
            // }
          }
        }
      })
      .state('payments.domesticPayment.fromInternational', {
        url: '/from-international',
        params: {
          transactionDetails: {}
        },
        views: {
          '@': {
            templateUrl: 'payments/domestic-payment.tpl.html',
            controller: 'DomesticPaymentCtrl',
            controllerAs: 'domesticPayment'
            // resolve: {
            //   defaultLocationData: function (ConfigEndpointService) {
            //     return ConfigEndpointService.getDefaultData();
            //   }
            // }
          }
        }
      })
      .state('payments.internationalPayment', {
        url: '/international-payment',
        params: {
          editable: null
        },
        views: {
          '@': {
            templateUrl: 'payments/international-payment.tpl.html',
//            controller: 'InternationalPaymentCtrl',
//            controllerAs: 'internationalPayment'
          }
        }
      })
      .state('payments.internationalPayment.fromTemplate', {
        url: '/template/:templateId',
        views: {
          '@': {
            templateUrl: 'payments/international-payment.tpl.html',
//            controller: 'InternationalPaymentCtrl',
//            controllerAs: 'internationalPayment'
          }
        }
      })
      //load international payment from template - Pay - SLO
      .state('payments.internationalPayment.fromTemplatesToPay', {
        url: '/template-pay/:templateId',
        views: {
          '@': {
            templateUrl: 'payments/international-payment.tpl.html',
          }
        }
      })
      .state('payments.internationalPayment.fromPayment', {
        url: '/load/:paymentId',
        params: {
          myParam: null
        },
        views: {
          '@': {
            templateUrl: 'payments/international-payment.tpl.html',
//            controller: 'InternationalPaymentCtrl',
//            controllerAs: 'internationalPayment'
          }
        }
      })
      .state('payments.internationalPayment.fromDomestic', {
        url: '/from-domestic',
        params: {
          transactionDetails: {}
        },
        views: {
          '@': {
            templateUrl: 'payments/international-payment.tpl.html',
            // controller: 'DomesticPaymentCtrl',
            // controllerAs: 'domesticPayment',
            // resolve: {
            //   defaultLocationData: function (ConfigEndpointService) {
            //     return ConfigEndpointService.getDefaultData();
            //   }
            // }
          }
        }
      })
      .state('payments.internalTransfer', {
        url: '/internal-transfer',
        views: {
          '@': {
            templateUrl: 'payments/internal-transfer.tpl.html',
            controller: 'InternalTransferCtrl',
            controllerAs: 'internalTransfer'
          }
        }
      })
      .state('payments.internalTransfer.fromAccounts', { //loan internal transfer from Card account
        url: '/:accountId',
        params: {
          accountId: null
        },
        views: {
          '@': {
            templateUrl: 'payments/internal-transfer.tpl.html',
            controller: 'InternalTransferCtrl',
            controllerAs: 'internalTransfer'
          }
        }
      })
      // load internal transfer from payment
      .state('payments.internalTransfer.fromPayment', {
        url: '/load/:paymentId',
        params: {
          editable: null,
          myParam: null
        },
        views: {
          '@': {
            templateUrl: 'payments/internal-transfer.tpl.html',
            controller: 'InternalTransferCtrl',
            controllerAs: 'internalTransfer'
          }
        }
      })
      // load internal transfer from template
      .state('payments.internalTransfer.fromTemplate', {
        url: '/template/:templateId',
        views: {
          '@': {
            templateUrl: 'payments/internal-transfer.tpl.html',
            controller: 'InternalTransferCtrl',
            controllerAs: 'internalTransfer'
          }
        }
      })
      // loan payment internal transfer
      .state('payments.internalTransfer.loan', {
        url: '/loan/:loanId',
        views: {
          '@': {
            templateUrl: 'payments/internal-transfer.tpl.html',
            controller: 'InternalTransferCtrl',
            controllerAs: 'internalTransfer'
          }
        }
      })
      .state('payments.loanPayment', {
        url: '/loan-payment/:accountId',
        views: {
          '@': {
            templateUrl: 'payments/loan-payment.tpl.html',
            controller: 'LoanPaymentCtrl',
            controllerAs: 'loanPayment'
          }
        }
      })
      .state('payments.ebookPay', {
        url: '/e-book-pay',
        abstract: true,
        views: {
          '@': {
            // templateUrl: 'payments/e-book-pay.tpl.html'
            /* controller: 'EBookPayCtrl',
             controllerAs: 'eBookPay'*/
          }
        }
      })
      .state('payments.ebookPay.payOut', {
        url: '-out/:accountId',
        params: {
          myParam: null,
          paymentId: null,
          editable: false
        },
        views: {
          '@': {
            templateUrl: 'payments/e-book-pay.tpl.html',
            controller: 'EBookPayCtrl',
            controllerAs: 'eBookPay'
          }
        }
      })
      .state('payments.ebookPay.payIn', {
        url: '-in/:accountId',
        params: {
          myParam: null,
          paymentId: null,
          editable: false
        },
        views: {
          '@': {
            templateUrl: 'payments/e-book-pay.tpl.html',
            controller: 'EBookPayCtrl',
            controllerAs: 'eBookPay'
          }
        }
      })
      .state('payments.ebookPay.fromPayment', {
        url: '/:paymentId',
        params: {
          myParam: null,
          accountId: null,
          editable: false
        },
        views: {
          '@': {
            templateUrl: 'payments/e-book-pay.tpl.html',
            controller: 'EBookPayCtrl',
            controllerAs: 'eBookPay'
          }
        }
      })
      .state('payments.savingsPayIn', {
        url: '/foreign-currency-transfer/:accountId',
        params: {
          paymentId: null,
          editable: false
        },
        views: {
          '@': {
            templateUrl: 'payments/savings-pay-in.tpl.html',
            controller: 'SavingsPayInCtrl',
            controllerAs: 'savingsPayIn'
          }
        }
      })
      .state('payments.savingsPayIn.fromPayment', {
      url: '/foreign-currency-transfer/:paymentId',
      params: {
        accountId: null,
        editable: false
      },
      views: {
        '@': {
          templateUrl: 'payments/savings-pay-in.tpl.html',
          controller: 'SavingsPayInCtrl',
          controllerAs: 'savingsPayIn'
        }
      }
    })
      .state('payments.sign', {
        url: '/:paymentId/:type/sign',
        params: {
          payment: null,
          paymentId: null,
          type: 'other'
        },
        views: {
          '@': {
            templateUrl: 'payments/payment-sign.tpl.html',
            controller: 'PaymentsSignCtrl',
            controllerAs: 'paymentsSign'
          }
        }
      })
      .state('payments.groupSign', {
        url: '/:groupId/group-sign',
        views: {
          '@': {
            templateUrl: 'payments/payments-group-sign.tpl.html',
            controller: 'PaymentsSignCtrl',
            controllerAs: 'paymentsSign'
          }
        }
      })
      .state('payments.finalStep', {
        url: '/:paymentId/:type/final-step',
        params: {
          paymentObject: null,
          type: 'other',
          isFromTemplate: null
        },
        views: {
          '@': {
            templateUrl: 'payments/payments-final-step.tpl.html',
            controller: 'PaymentsFinalStepCtrl',
            controllerAs: 'paymentsFinal'
          }
        }
      })
      .state('payments.paymentsReturn', {
        url: '/payments-return',
        views: {
          '@': {
            templateUrl: 'payments/payments-return.tpl.html',
            controller: 'PaymentsReturnCtrl',
            controllerAs: 'paymentsReturn'
          }
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsReturnCtrl
   *
   * @description
   *
   */
  PaymentsReturnCtrl.$inject = ["$state", "$log", "HelperService", "PaymentsService", "CurrencyService", "$localStorage", "ConfigEndpointService", "$window", "$stateParams", "$translate", "GoogleTagManagerHelperService"];
  angular
    .module('payments')
    .controller('PaymentsReturnCtrl', PaymentsReturnCtrl);

  function PaymentsReturnCtrl($state, $log, HelperService, PaymentsService, CurrencyService, $localStorage,
                              ConfigEndpointService, $window,$stateParams, $translate, GoogleTagManagerHelperService) {
    var vm = this;

    vm.init = function () {

      if($localStorage.code){
        vm.countryCode = $localStorage.code;
      }else{
        getDefaultData();
      }

      var timeRange = HelperService.getDateRange('thisMonth');

      vm.paymentsFilter = {
        page: 0,
        orderBy: 'dateCreated DESC',
        status: 'Opened',
        pageSize: 15,
        currencySymbol: null,
        amountGTE: null,
        amountLTE: null,
        dueDateGTE: timeRange.valueDateGTE,
        dueDateLTE: timeRange.valueDateLTE,
        paymentTypeGroupList: "SEPARecall"
      };

      // 1- Opened, 2 - Archived payments
      vm.paymentsTypeSelected = 1;

      vm.paymentsOverviewList = {};

      vm.periodList = [
        {
          item: {
            key: 'today',
            description: 'core.period.today'
          }
        }
        , {
          item: {
            key: 'yesterday',
            description: 'core.period.yesterday'
          }
        }
        , {
          item: {
            key: 'thisWeek',
            description: 'core.period.thisWeek'
          }
        }
        , {
          item: {
            key: 'thisMonth',
            description: 'core.period.thisMonth'
          }
        }
        , {
          item: {
            key: 'thisYear',
            description: 'core.period.thisYear'
          }
        }
        , {
          item: {
            key: 'all',
            description: 'core.period.all'
          }
        }
      ];

      vm.currencySelectObject = {};
      vm.currenciesList = [];
      vm.currenciesFilter = {
        pageSize: 1000
      };

      vm.selectedPeriod = vm.periodList[3];
      vm.searchFilterExpanded = false;

      vm.getCurrenciesListPage();
      vm.getPaymentsPage(true);
    };

    vm.getDefaultData = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
          if (response.APILocation) {
            $localStorage.code = response.APILocation;
            vm.countryCode = $localStorage.code;
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.getPaymentsPage = function (reset) {

      if (reset) {
        vm.paymentsFilter.page = 0;
        vm.paymentsOverviewList = {};
      } else {
        vm.paymentsFilter.page += 1;
      }

      PaymentsService.getPage(vm.paymentsFilter)
        .then(function (response) {
          if (reset) {
            vm.paymentsOverviewList = response;
          } else {
            var tmpList = {};
            tmpList.hasMore = response.hasMore;
            tmpList.result = vm.paymentsOverviewList.result.concat(response.result);
            vm.paymentsOverviewList = tmpList;
          }
          $log.debug("paymentsOverviewList", vm.paymentsOverviewList);
        })
        .catch(function (error) {
          $log.error(error);
        });
    };

    vm.getCurrenciesListPage = function () {
      return CurrencyService.getCurrencyPage(vm.currenciesFilter)
        .then(function (response) {
          vm.currenciesList = response.result;

          var countryIndex = _.findIndex(vm.currenciesList, function (o) {
            if (vm.countryCode == 'hr') {
              return o.symbol == 'HRK';
            }
          });
          vm.currencySelectObject = vm.currenciesList[countryIndex];
          vm.defaultCurrencySelectObject = vm.currenciesList[countryIndex];

          //$log.debug("currenciesList", vm.currenciesList);
        }).catch(function (error) {
        $log.error(error);
      });
    };

    vm.loadMorePayments = function () {
      vm.getPaymentsPage(false);
    };

    vm.pushGtmApproveRecallEvent = function () {
        GoogleTagManagerHelperService.pushEvent('PaymentsReturndConfirmationDetails', 'ApproveRecallAction', $translate.instant('paymentActions.approveRecall'));
    };

    vm.rejectPaymentRecall = function(paymentId){
        GoogleTagManagerHelperService.pushEvent('PaymentsReturndConfirmationDetails', 'RejectRecallAction', $translate.instant('paymentActions.rejectRecall'));
      var params = {
        id: paymentId,
        answer: "N"
      };
      PaymentsService.recallPayment(params)
        .then(function (response) {
          vm.getPaymentsPage(true);
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };

    vm.togglePaymentDetails = function (payment) {
      payment.selected = !payment.selected;
    };

    vm.paymentsPeriodFilter = function (item) {
      vm.selectedPeriod = item;
      var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      vm.paymentsFilter.dueDateGTE = timeRange.valueDateGTE;
      vm.paymentsFilter.dueDateLTE = timeRange.valueDateLTE;
      vm.getPaymentsPage(true);
      GoogleTagManagerHelperService.pushEvent('PaymentsReturn', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));

    };

    vm.toggleFilterSelection = function () {
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    vm.resetPaymentsFilter = function () {
      vm.paymentsFilter.amountGTE = null;
      vm.paymentsFilter.amountLTE = null;
      vm.paymentsFilter.currencySymbol = null;
      vm.currencySelectObject = vm.defaultCurrencySelectObject;
      // $log.debug("paymentsFilter", vm.paymentsFilter);
    };

    vm.applyPaymentsFilter = function () {
      vm.paymentsFilter.currencySymbol = vm.currencySelectObject.symbol;
      $log.debug("paymentsFilter", vm.paymentsFilter);
      vm.getPaymentsPage(true);
      vm.searchFilterExpanded = false;
    };

    vm.printPayment = function (paymentId) {
      PaymentsService.downloadPaymentPdf(paymentId);
    };

    vm.selectedTabType = "open";
    vm.selectPaymentsType = function (type, translateLabel) {
      if (type ==  vm.selectedTabType) return;
      vm.paymentsFilter.statusList = null;
      vm.paymentsFilter.status = null;
      vm.selectedTabType = type;
      vm.selectedTabType = type;
      switch (type) {
        case "open":
          vm.paymentsFilter.status = 'Opened';
          vm.paymentsTypeSelected = 1;
          break;
        case "archived":
          // All statuses except 'Opened'. API does not have other filter to exclude Opened payments
          vm.paymentsFilter.statusList = ['WaitingQueue','Cancelled', 'Processed','Rejected','Closed','Signed', 'InProcessing', 'ForCancelling', 'Storned', 'RejectedAfterComplaint', 'AcceptedAfterComplaint'];
          vm.paymentsTypeSelected = 2;
          break;
        default:
          vm.paymentsFilter.status = 'Opened';
          vm.paymentsTypeSelected = 1;

      }
      GoogleTagManagerHelperService.pushEvent('PaymentsReturn', 'Tab', $translate.instant(translateLabel));

      vm.resetPaymentsFilter();
      vm.getPaymentsPage(true);
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsRecallModalCtrl
   *
   * @description
   *
   */
  PaymentsRecallModalCtrl.$inject = ["$rootScope", "$uibModalInstance", "data"];
  angular
    .module('payments')
    .controller('PaymentsRecallModalCtrl', PaymentsRecallModalCtrl);

  function PaymentsRecallModalCtrl($rootScope, $uibModalInstance, data) {
    var vm = this;

    vm.init = function(){
      vm.payment = angular.copy(data);
      vm.formSubmitted = false;
      vm.recallReasonsList = [{key: 'paymentsReturn.reasonTech', value: "TECH"},{key: 'paymentsReturn.reasonFrad', value: "FRAD"}, {key: 'paymentsReturn.reasonDupl', value: "DUPL"}];
      vm.recallReasonObject = {
        reasonCode: "TECH",
        additionalnfo: ""
      };
    };

    vm.confirm = function () {
      vm.formSubmitted = true;
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') vm.recallReasonObject = {};
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl' && !vm.recallForm.$valid) return;
      $uibModalInstance.close(vm.recallReasonObject);
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsOverviewCtrl
   *
   * @description
   *
   */
  PaymentsOverviewCtrl.$inject = ["$rootScope", "$state", "$log", "HelperService", "PaymentsService", "$translate", "$scope", "CurrencyService", "$localStorage", "ConfigEndpointService", "PaymentSignListService", "$uibModal", "$window", "$stateParams", "CTLocalizationService", "AccountsService", "$http", "$sce", "$filter", "AlertService", "GoogleTagManagerHelperService"];
  angular
    .module('payments')
    .controller('PaymentsOverviewCtrl', PaymentsOverviewCtrl);

  function PaymentsOverviewCtrl($rootScope, $state, $log, HelperService, PaymentsService, $translate, $scope, CurrencyService, $localStorage,
                                 ConfigEndpointService, PaymentSignListService, $uibModal, $window, $stateParams, CTLocalizationService, AccountsService, $http, $sce,$filter, AlertService,
                                GoogleTagManagerHelperService) {
    var vm = this;

    vm.countryCode = $localStorage.code;
    vm.showPaymentId = false;
    vm.selectedTabType  = '';
    vm.signList = [];
    vm.signer = {};
    vm.recaller = {};
    vm.localCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
    vm.viewName = 'payments_overview';
    vm.dateFromOpen = false;
    vm.dateToOpen = false;

    vm.getDefaultData = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
        if (response.APILocation) {
          $localStorage.code = response.APILocation;
          vm.countryCode = $localStorage.code;
        }
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.split = function(input){
      return HelperService.splitReferenceNumber(input);
    };

    vm.init = function () {
      if (vm.countryCode == undefined) {
        vm.getDefaultData();
      }

      vm.getCurrenciesListPage();
      vm.getPaymentsPage(true);

      vm.areAllPaymentsSelected = false;
      vm.areNonePaymentsSelected = true;
    };

    var timeRange = HelperService.getDateRange('thisMonth');

    vm.paymentsFilter = {
      page: 0,
      orderBy: 'dateCreated DESC',
      status: null,
      pageSize: 15,
      currencySymbol: null,
      amountGTE: null,
      amountLTE: null,
      dateCreatedGTE: timeRange.valueDateGTE,
      dateCreatedLTE: timeRange.valueDateLTE,
      statusList: null
    };
    // in case of BiH info for public revenue
    if(vm.countryCode == "bh"){
      vm.paymentsFilter.includeList = "revenuePaymentDetails";
    }

    vm.paymentsOverviewList = {};

    vm.paymentsOverviewListGrouped = {};

    vm.getPaymentsPage = function (reset) {

      if (reset) {
        vm.paymentsFilter.page = 0;
        vm.paymentsOverviewListGrouped = {};
      } else {
        vm.paymentsFilter.page += 1;
      }

      PaymentsService.getPage(vm.paymentsFilter)
        .then(function (response) {
        vm.paymentsOverviewListGrouped = HelperService.mergeRowsForTimeline({
          existingData: vm.paymentsOverviewListGrouped,
          newData: response,
          groupFunction: function (item) {
            if(vm.selectedTabType == 'processed' || vm.selectedTabType == 'rejected'){
              var date = new Date(item.modificationDate);
            }
            else
              var date = new Date(item.dateCreated);
            // If we want to group only by date component, without hours
            date.setHours(0, 0, 0, 0);
            return date;
          },
          virtualRowFunction: function (e) {
            var virtualRow = {
              isVirtual: true,
              date: new Date(e)
            };
            $log.debug("virtualRow", e, virtualRow);
            return virtualRow;
          },
          reset: reset,
          reverse: false
        });

        $log.debug("paymentsOverviewListGrouped", vm.paymentsOverviewListGrouped);
      })
        .catch(function (error) {
        $log.error(error);
      });

    };

    vm.loadMorePayments = function () {
      vm.getPaymentsPage(false);

      // Not signed payments code
      vm.areNonePaymentsSelected = false;
      vm.areAllPaymentsSelected = false;
    };

    vm.selectAllPaymentsForSign = function () {
      //_.forEach(vm.paymentsOverviewList.result, function (payment) {
      _.forEach(vm.paymentsOverviewListGrouped.result, function (payment) {
        payment.isSelectedForSign = true;
      });
      vm.areAllPaymentsSelected = true;
      vm.areNonePaymentsSelected = false;
    };

    vm.selectNonePaymentsForSign = function () {
      //_.forEach(vm.paymentsOverviewList.result, function (payment) {
      _.forEach(vm.paymentsOverviewListGrouped.result, function (payment) {
        payment.isSelectedForSign = false;
      });
      vm.areNonePaymentsSelected = true;
      vm.areAllPaymentsSelected = false;
    };

    vm.signSelectedPaymentsAction = function () {

      var paymentsToSign = [];
      //_.forEach(vm.paymentsOverviewList.result, function (payment) {
      _.forEach(vm.paymentsOverviewListGrouped.result, function (payment) {
        if (payment.isSelectedForSign && !payment.isVirtual) {
          paymentsToSign.push(payment.id);
        }
      });
      if (paymentsToSign.length > 0) {

        // Create new list of payments
        var paymentSignList = {
          paymentIdList: paymentsToSign
        };
        PaymentSignListService.addPaymentSignList(paymentSignList).then(function (response) {
          $state.go('payments.groupSign', {
            groupId: response.id
          });
        })
          .catch(function (err) {
            HelperService.showMessage(err, 'error');
          $log.error(err);
        });
      }
    };

    vm.togglePaymentForSign = function ($event) {
      if ($event) {
        $event.stopPropagation();
      }

      // Check are none payments selected
      //vm.areNonePaymentsSelected = _.every(vm.paymentsOverviewList.result, {
      vm.areNonePaymentsSelected = _.every(vm.paymentsOverviewListGrouped.result, {
        'isSelectedForSign': false
      });

      // Check are all payments selected
      //vm.areAllPaymentsSelected = _.every(vm.paymentsOverviewList.result, {
      vm.areAllPaymentsSelected = _.every(vm.paymentsOverviewListGrouped.result, {
        'isSelectedForSign': true
      });
    };

    vm.recallPaymentAction = function (payment) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.recall"));
      var params = {
        id: payment.id
      };

      if (payment.status === 'InProcessing') {
        recallPayment(params);
      } else {
        PaymentsService.openRecallReasonModal()
          .result.then(function (result) {

          // Add more information to payment object
          if (!result) {
            return;
          }

          // Recall payment with aditional information
          params.additionalnfo = result.additionalnfo;
          params.reasonCode = result.reasonCode;

          recallPayment(params);
        });
      }
    };

    // For Slovenia
    vm.cancelPaymentAction = function (payment) {
      var params = {
        id: payment.id
      };

      if (payment.status === 'InProcessing') {
        recallPayment(params);
      } else {
        PaymentsService.openRecallReasonModal(payment)
          .result.then(function (result) {

          // Add more information to payment object
          if (!result) {
            return;
          }
          recallPayment(params);
        });
      }
    };

    var recallPayment = function (params) {
      return PaymentsService.recallPayment(params)
        .then(function (response) {
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
            AlertService.infoAlert({
              text: 'payments.cancelledPaymentMsg'
            })
            $rootScope.$broadcast("paymentInserted");
          }


        vm.getPaymentsPage(true);
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.togglePaymentDetails = function (payment) {
      // If we are closing payment details, no need to load signature list
      if(payment.selected){
        payment.selected = false;
      }else{
        // Load signature list only for payments in these statuses
        if(payment.status === 'Rejected' || payment.status == "Cancelled" || payment.status === 'InProcessing' || payment.status == 'WaitingQueue' || payment.status === 'Processed') {
          vm.signList = [];
          vm.signer = {};
          vm.recaller = {};
          PaymentsService.getSignatureList(payment.id)
            .then(function(response) {
              vm.signList = response.signaturesList;
              angular.extend(payment, response);
              payment.selected = true;
            }).catch (function (error) {
            HelperService.showMessage(error, 'error');
          });
        //  Othwerwise open payment details without loading signature list
        }else{
          payment.selected = true;
        }
      }
    };

    var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    $rootScope.$on('appLanguageChangedHeader', function () {
      sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    });

    vm.deletePaymentAction = function (paymentId) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.delete"));

      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            PaymentsService.deletePayment(paymentId)
              .then(function (response) {
                AlertService.deletedPaymentAlert({paymentName: paymentId, type: 'payment'})
                  .then(function () {
                    vm.getPaymentsPage(true);
                  });
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });

    };

    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      }
      , {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }
      , {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }
      , {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }
      , {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
      , {
        item: {
          key: $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" ? "all2y" : 'all',
          description: 'core.period.all'
        }
      }
    ];

    vm.selectedPeriod = vm.periodList[3];

    function clearPaymentsFilterOnly() {
      vm.paymentsFilter.amountGTE = null;
      vm.paymentsFilter.amountLTE = null;
      vm.currencySelectObject = vm.defaultCurrencySelectObject;
      vm.paymentsFilter.currencySymbol = null;
      vm.paymentsFilter.purposeFTS = "";
      vm.searchFilterExpanded = false;
      vm.paymentsFilter.dateCreatedGTE = "";
      vm.paymentsFilter.dateCreatedLTE = "";
    }

    vm.paymentsPeriodFilter = function (item) {

      if(vm.countryCode === 'sl' ) {
        clearPaymentsFilterOnly()
      }

      vm.selectedPeriod = item;
      vm.transactionFilterYearDateRangeValid = true;
      var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      vm.paymentsFilter.dateCreatedGTE = timeRange.valueDateGTE;
      vm.paymentsFilter.dateCreatedLTE = timeRange.valueDateLTE;



      vm.getPaymentsPage(true);
      GoogleTagManagerHelperService.pushEvent('PaymentsOverview', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));

    };


    if ($stateParams.myParam === 'not-signed') {
      vm.paymentsFilter.status = 'Opened';
      vm.paymentsTypeSelected = 5;
    } else if ($stateParams.myParam === 'rejected') {
      vm.paymentsFilter.status = 'Rejected';
      vm.paymentsTypeSelected = 4;
    } else if(vm.countryCode =='sl' && $stateParams.myParam === 'pending'){
      vm.paymentsFilter.statusList = ['InProcessing','WaitingQueue','Opened'];
      vm.paymentsTypeSelected = 3;
    } else {
      if ($stateParams.selected != null) {
        vm.paymentsFilter.status = 'Processed';
        vm.paymentsTypeSelected = 2;
      } else {
        vm.paymentsFilter.status = null;
        vm.paymentsTypeSelected = 1;
      }
    }

    var selectedPaymentsType = "all";
    vm.selectPaymentsType = function (type, translateLabel) {
      if (type == selectedPaymentsType) return;
      selectedPaymentsType = type;
      vm.paymentsFilter.statusList = null;
      vm.paymentsFilter.status = null;
      vm.selectedTabType = type;
      switch (type) {
        case "all":
          vm.paymentsFilter.status = null;
          vm.paymentsTypeSelected = 1;
          vm.paymentsFilter.orderBy = 'dateCreated DESC';
          break;
        case "processed":
          vm.paymentsFilter.statusList = ['Processed','Cancelled'];
          vm.paymentsTypeSelected = 2;
          vm.paymentsFilter.orderBy = 'modificationDate DESC';
          break;
        case "pending":
          if(vm.countryCode == 'sl'){
            vm.paymentsFilter.statusList = ['InProcessing','WaitingQueue','Opened'];
          }else{
            vm.paymentsFilter.statusList = ['InProcessing','WaitingQueue'];
          }
          vm.paymentsTypeSelected = 3;
          vm.paymentsFilter.orderBy = 'modificationDate DESC';
          break;
        case "rejected":
          vm.paymentsFilter.status = 'Rejected';
          vm.paymentsTypeSelected = 4;
          vm.paymentsFilter.orderBy = 'modificationDate DESC';
          break;
        case "not-signed":
          vm.paymentsFilter.status = 'Opened';
          vm.paymentsTypeSelected = 5;
          vm.paymentsFilter.orderBy = 'dateCreated desc';
          break;
        default:
          vm.paymentsFilter.status = null;
          vm.paymentsTypeSelected = 1;
          vm.paymentsFilter.orderBy = 'dateCreated DESC';

      }
      GoogleTagManagerHelperService.pushEvent('PaymentsOverview', 'Tab', $translate.instant(translateLabel));

      clearPaymentsFilter();
      vm.getPaymentsPage(true);
    };

    var clearPaymentsFilter = function(){
      vm.paymentsFilter.amountGTE = null;
      vm.paymentsFilter.amountLTE = null;
      vm.currencySelectObject = vm.defaultCurrencySelectObject;
      vm.paymentsFilter.currencySymbol = null;
      vm.paymentsFilter.purposeFTS = "";
      vm.searchFilterExpanded = false;
      vm.paymentsFilter.dateCreatedGTE = "";
      vm.paymentsFilter.dateCreatedLTE = "";
      vm.transactionFilterYearDateRangeValid = true;
      vm.paymentsPeriodFilter(vm.selectedPeriod);
    };

    vm.searchFilterExpanded = false;
    vm.toggleFilterSelection = function () {
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
      if(vm.searchFilterExpanded && vm.currenciesList.length === 0){
        vm.getCurrenciesListPage();
      }
    };

    vm.resetPaymentsFilter = function () {
      clearPaymentsFilter();
      //vm.getPaymentsPage(true);
    };

    vm.applyPaymentsFilter = function () {
      if(!vm.transactionFilterYearDateRangeValid) return;
      if (!vm.paymentsFilter.dateCreatedGTE || !vm.paymentsFilter.dateCreatedLTE) return;
      vm.paymentsFilter.currencySymbol = vm.currencySelectObject.symbol;
      $log.debug("paymentsFilter", vm.paymentsFilter);
      vm.getPaymentsPage(true);
      vm.searchFilterExpanded = false;
    };

    vm.currencySelectObject = {};
    vm.currenciesList = [];
    vm.currenciesFilter = {
      pageSize: 1000
    };

    vm.getCurrenciesListPage = function () {

      CurrencyService.getCurrencyPage(vm.currenciesFilter)
        .then(function (response) {
        vm.currenciesList = response.result;

        //var countryIndex = _.findIndex(vm.currenciesList, function (o) {
        //  if (vm.countryCode == 'hr') {
        //    return o.symbol == 'HRK';
        //  } else if (vm.countryCode == 'sr') {
        //    return o.symbol == 'RSD';
        //  }
        //});
          var countryIndex = _.findIndex(vm.currenciesList, function(item){
            return item.symbol == vm.localCurrency;
          });
        vm.currencySelectObject = vm.currenciesList[countryIndex];
        vm.defaultCurrencySelectObject = vm.currenciesList[countryIndex];

        //$log.debug("currenciesList", vm.currenciesList);
      }).catch(function (error) {
        $log.error(error);
      });
    };

    vm.repeatPayment = function (paymentObj, value) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.copy"));

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && paymentObj.paymentSubTypeGroup == "NotSupportedPayment") {
       AlertService.infoAlert({
          text: "paymentsOverview.notSupportedPaymentMsg"
        })
        return;
      }

      var stateLink;
      var params = {
        paymentId: paymentObj.id,
        accountId: paymentObj.accountId,
        myParam: 'repeat'
      };

      if(value == 'repeatCancelled'){
        params.myParam = value;
      }


      if(paymentObj.paymentSubTypeGroup && paymentObj.paymentSubTypeGroup == 'DomesticPayment' )
        paymentObj.paymentTypeGroup = paymentObj.paymentSubTypeGroup;

      switch (paymentObj.paymentTypeGroup) {
        case "DomesticPayment":
        case "RevenuePayment":
        case "SEPAPayment":
          stateLink = 'payments.domesticPayment.fromPayment';
          break;
        case "LocalCurrencyTransfer":
          // stateLink = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') ? 'payments.domesticPayment.fromPayment' : 'payments.internalTransfer.fromPayment';
          stateLink = 'payments.internalTransfer.fromPayment';
          break;
        case "CurrencyExchange":
          stateLink = 'payments.currencyConversion.fromPayment';
          break;
        case "ForeignPayment":
          stateLink = 'payments.internationalPayment.fromPayment';
          break;
        case "ForeignCurrencyTransfer":
          stateLink = 'payments.savingsPayIn.fromPayment';
          break;
        case "ESavingPayment":
          stateLink = 'payments.ebookPay.fromPayment';
          break;
      }

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
        if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer" && (paymentObj.toAccountNumber.substring(0, 4) != "SI56" || paymentObj.fromAccountNumber.substring(0, 4) != "SI56")) {
          stateLink = 'payments.internalTransfer.fromPayment';
        } else  if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer" && paymentObj.toAccountNumber.substring(0, 4) == "SI56") {
          stateLink = 'payments.domesticPayment.fromPayment'
        }

        // Using subtypeGroup
        // if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer" && paymentObj.paymentSubTypeGroup == "SEPAPayment") {
        //   stateLink = 'payments.domesticPayment.fromPayment';
        // } else if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer"  && paymentObj.paymentSubTypeGroup == "LocalCurrencyTransfer") {
        //   stateLink = 'payments.internalTransfer.fromPayment';
        // }


        if (paymentObj.paymentTypeGroup == "ForeignCurrencyTransfer") {
          stateLink = 'payments.internalTransfer.fromPayment';
        }
      }


      if (stateLink) {
        $state.go(stateLink, params);
      }
    };

    vm.changePaymentAction = function (paymentObj) {
      var stateLink;
      var params = {
        paymentId: paymentObj.id,
        accountId: paymentObj.accountId,
        myParam: 'changeProcessed'
      };

      if(paymentObj.paymentSubTypeGroup && paymentObj.paymentSubTypeGroup == 'DomesticPayment' )
        paymentObj.paymentTypeGroup = paymentObj.paymentSubTypeGroup;

      switch (paymentObj.paymentTypeGroup) {
        case "DomesticPayment":
        case "RevenuePayment":
        case "SEPAPayment":
          stateLink = 'payments.domesticPayment.fromPayment';
          break;
        case "LocalCurrencyTransfer":
          // stateLink = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') ? 'payments.domesticPayment.fromPayment' : 'payments.internalTransfer.fromPayment';
          stateLink = 'payments.internalTransfer.fromPayment';
          break;
        case "CurrencyExchange":
          stateLink = 'payments.currencyConversion.fromPayment';
          break;
        case "ForeignPayment":
          stateLink = 'payments.internationalPayment.fromPayment';
          break;
        case "ForeignCurrencyTransfer":
          stateLink = 'payments.savingsPayIn.fromPayment';
          break;
        case "ESavingPayment":
          stateLink = 'payments.ebookPay.fromPayment';
          break;
      }

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
        if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer" && (paymentObj.toAccountNumber.substring(0, 4) != "SI56" || paymentObj.fromAccountNumber.substring(0, 4) != "SI56")) {
          stateLink = 'payments.internalTransfer.fromPayment';
        } else  if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer" && paymentObj.toAccountNumber.substring(0, 4) == "SI56") {
          stateLink = 'payments.domesticPayment.fromPayment'
        }

        if (paymentObj.paymentTypeGroup == "ForeignCurrencyTransfer") {
          stateLink = 'payments.internalTransfer.fromPayment';
        }
      }

      if (stateLink) {
        $state.go(stateLink, params);
      }
    };



    vm.editPayment = function (paymentObj) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.edit"));

      var stateLink;
      var params = {
        paymentId: paymentObj.id,
        editable: true,
        accountId: paymentObj.accountId,
        myParam: 'edit'
      };

      if(paymentObj.paymentSubTypeGroup && paymentObj.paymentSubTypeGroup == 'DomesticPayment' )
        paymentObj.paymentTypeGroup = paymentObj.paymentSubTypeGroup;

      switch (paymentObj.paymentTypeGroup) {
        case "DomesticPayment":
        case "RevenuePayment":
          stateLink = 'payments.domesticPayment.fromPayment';
          break;
        case "LocalCurrencyTransfer":
          // stateLink = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') ? 'payments.domesticPayment.fromPayment' : 'payments.internalTransfer.fromPayment';
          stateLink = 'payments.internalTransfer.fromPayment';
          break;
        case "CurrencyExchange":
          stateLink = 'payments.currencyConversion.fromPayment';
          break;
        case "ForeignPayment":
          stateLink = 'payments.internationalPayment.fromPayment';
          break;
        case "ForeignCurrencyTransfer":
          stateLink = 'payments.savingsPayIn.fromPayment';
          break;
        case "ESavingPayment":
          stateLink = 'payments.ebookPay.fromPayment';
          break;
      }

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
        if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer" && (paymentObj.toAccountNumber.substring(0, 4) != "SI56" || paymentObj.fromAccountNumber.substring(0, 4) != "SI56")) {
          stateLink = 'payments.internalTransfer.fromPayment';
        } else  if (paymentObj.paymentTypeGroup == "LocalCurrencyTransfer" && paymentObj.toAccountNumber.substring(0, 4) == "SI56") {
          stateLink = 'payments.domesticPayment.fromPayment'
        }

        if (paymentObj.paymentTypeGroup == "ForeignCurrencyTransfer") {
          stateLink = 'payments.internalTransfer.fromPayment';
        }
      }

      if (stateLink) {
        $state.go(stateLink, params);
      }
    };

    vm.printPayment = function (paymentId) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.print"));

      PaymentsService.downloadPaymentPdf(paymentId);
    };

    vm.signPayment = function (payment) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.sign"));

      if (PaymentsService.isVerificationRequiredForSign(payment)) {
        // If verification is required, go to payment sign state
        $state.go('payments.sign', {paymentId: payment.id});
      } else {

        var updateObject = _.find(payment.allowedActionList.itemList, function (item) {
          return item.methodName === 'UpdateOldPaymentDateAllowed';
        });

        if (updateObject) {
          vm.dueDateUpdateAllowed = updateObject.isEnabled;
        }

        // Use only date without hours for compare
        var currentTime = new Date();
        currentTime.setHours(0, 0, 0, 0);
        // Check if all payments have valid due date
        var isPaymentDueDateValid = new Date(payment.dueDate) >= currentTime;


        // If verification is not required, then sign payment and go to final step
        var params = {
          id: payment.id
        };

        if (isPaymentDueDateValid) {
          return PaymentsService.signPayment(params).then(function (signedPayment) {
            // TODO: Use signed payment on response
            $state.go('payments.finalStep', {paymentId: payment.id});
          }).catch(function (error) {
            $log.error(error);
            HelperService.showMessage(error, 'error');
          });
        } else {
          PaymentsService.openUpdatePaymentDueDateModal()
            .result.then(function (result) {
            if (result == "confirm") {
              params.useCurrentDate = true;
              return PaymentsService.signPayment(params).then(function (signedPayment) {
                // TODO: Use signed payment on response
                $state.go('payments.finalStep', {paymentId: payment.id});
              }).catch(function (error) {
                $log.error(error);
                HelperService.showMessage(error, 'error');
              });
            }
          });
        }
      }
    };

    vm.confirmRealizedPayment = function (payment) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.confirmation"));

      var modalInstance = $uibModal.open({
           animation: true,
           templateUrl: 'payments/payment-confirmation-modal-slo.tpl.html',
           controller: 'PaymentConfirmationModalSloCtrl',
           controllerAs: 'vm',
           size: "lg",
           resolve: {
             payment: function () {
               return payment;
             }
           }
         });

         modalInstance.result.then(function (selectedItem) {
           console.log(selectedItem);
         }, function () {
           $log.info('Modal dismissed at: ' + new Date());
         });

    };

    vm.complaintPayment = function (payment) {
      GoogleTagManagerHelperService.pushEvent('PaymentDetails', 'PaymentActionSelection', $translate.instant("paymentActions.complaint"));
      $state.go("payments.reclamation", {paymentId: payment.id});

      // var message = $translate.instant('core.SmsSentSuccessfully');
      // HelperService.showTranslatedMessage('success', message,'',3000);
    };

    vm.checkDate= function (date) {
      return new Date(date) > new Date();
    };

    vm.transactionFilterYearDateRangeValid = true;
    vm.onDateFromChange = function () {
      if (vm.paymentsFilter.dateCreatedLTE < vm.paymentsFilter.dateCreatedGTE) {
        vm.paymentsFilter.dateCreatedLTE = angular.copy(vm.paymentsFilter.dateCreatedGTE);
      }
      // if (vm.paymentsFilter.dateCreatedGTE) {
      //   var yearAfter = new Date(vm.paymentsFilter.dateCreatedGTE.getFullYear() + 1, vm.paymentsFilter.dateCreatedGTE.getMonth(), vm.paymentsFilter.dateCreatedGTE.getDate());
      //   if (yearAfter <= (vm.paymentsFilter.dateCreatedLTE && vm.paymentsFilter.dateCreatedLTE.getTime())) {
      //     vm.paymentsFilter.dateCreatedLTE = yearAfter;
      //   }
      // }

      if (vm.paymentsFilter.dateCreatedGTE && vm.paymentsFilter.dateCreatedLTE) {
        if (daysBetween(vm.paymentsFilter.dateCreatedGTE, vm.paymentsFilter.dateCreatedLTE) < 365) {
          vm.transactionFilterYearDateRangeValid = true;
        } else {
          vm.transactionFilterYearDateRangeValid = false;
        }
      }
    };

    vm.onDateToChange = function () {
        if (daysBetween(vm.paymentsFilter.dateCreatedGTE, vm.paymentsFilter.dateCreatedLTE) < 365) {
          vm.transactionFilterYearDateRangeValid = true;
        } else {
          vm.transactionFilterYearDateRangeValid = false;
        }
    };

    vm.datesToDisabled = function (date, mode) {
      // if (!vm.paymentsFilter.dateCreatedGTE) return true;
      // var yearAfter = new Date(vm.paymentsFilter.dateCreatedGTE.getFullYear() + 1, vm.paymentsFilter.dateCreatedGTE.getMonth(), vm.paymentsFilter.dateCreatedGTE.getDate() + 1);
      // return (mode === 'day' && (date.getTime() < vm.paymentsFilter.dateCreatedGTE || (date.getTime() >= yearAfter)));  // 	polje „Datum do“ je opcionalno polje,  ne smije se unijeti datum manji od onog u polju „Datum od“
      return (mode === 'day' && (date.getTime() < vm.paymentsFilter.dateCreatedGTE));  // 	polje „Datum do“ je opcionalno polje,  ne smije se unijeti datum manji od onog u polju „Datum od“
    };

    function daysBetween (firstDate, secondDate) {
      var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
      var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
      return diffDays;
    }

    vm.init();


  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsFinalStepCtrl
   *
   * @description
   *
   */
  PaymentsFinalStepCtrl.$inject = ["$rootScope", "PaymentTemplatesService", "$sessionStorage", "$state", "$log", "PaymentsService", "PaymentSignListService", "HelperService"];
  angular
    .module('payments')
    .controller('PaymentsFinalStepCtrl', PaymentsFinalStepCtrl);

  function PaymentsFinalStepCtrl($rootScope, PaymentTemplatesService, $sessionStorage, $state, $log, PaymentsService, PaymentSignListService, HelperService) {
    var vm = this;

    vm.selectedPayment = {};
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

    vm.init = function () {

      vm.paymentType = $state.params.type;
      vm.isFromTemplate = $state.params.isFromTemplate;

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData){
        vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
        vm.bankCharges = vm.defaultData.BankCharges;
      }
      if ($state.params.paymentId) {
        vm.selectedPayment.id = $state.params.paymentId;
      }

      // If payment is sent as parameter. No need to load it from database
      if ($state.params.paymentObject) {

        if(vm.paymentType === 'group'){
          vm.paymentsGroupList = $state.params.paymentObject;
          vm.canBeSavedToTemplate = false;
        }else{
          vm.selectedPayment = $state.params.paymentObject;
          if (vm.countryCode == "sl" && vm.isFromTemplate == null) {
            getTemplates();
          } else {
            vm.canBeSavedToTemplate = canBeSavedToTemplate(vm.selectedPayment.paymentTypeGroup, vm.selectedPayment);
          }
        }
      }
      // If user is reloading page, or payment was not sent through params
      else {
        if (vm.paymentType !== 'group') {
          loadPayment($state.params.paymentId);
        }else{
          loadGroupOfPayments($state.params.paymentId);
        }
      }
    };


    function getTemplates () {
      // if (vm.isFromTemplate == null) {
      PaymentTemplatesService.getPage({
        paymentTypeGroup: 'DomesticPayment',
        page: 0,
        pageSize: 1000
      }).then(function (response) {
        var ibanInTemplates = _.some(response.result, function (template) {
          return template.toAccountNumber.replace(/ /g,'') == vm.selectedPayment.toAccountNumber.replace(/ /g,'')
        });
        if (ibanInTemplates) {
          vm.isFromTemplate = true;
        }
        vm.canBeSavedToTemplate = canBeSavedToTemplate(vm.selectedPayment.paymentTypeGroup, vm.selectedPayment);
      }).catch(function (error) {
        $log.error(error);
      });
      // }
    }


    var loadPayment = function (paymentId) {
      if (paymentId) {
        if(vm.countryCode === 'bh'){
          return PaymentsService.getById(paymentId, {includeList: ['RevenuePaymentDetails']}).then(function (payment) {
            vm.selectedPayment = payment;
            vm.canBeSavedToTemplate = canBeSavedToTemplate(vm.selectedPayment.paymentTypeGroup, vm.selectedPayment);
          }).catch(function (error) {
            $log.error(error);
            HelperService.showMessage(error, 'error');
          });
        } else {
          return PaymentsService.getById(paymentId).then(function (payment) {
            vm.selectedPayment = payment;
            if (vm.countryCode == "sl") {
              getTemplates();
            } else {
              vm.canBeSavedToTemplate = canBeSavedToTemplate(vm.selectedPayment.paymentTypeGroup, vm.selectedPayment);
            }          }).catch(function (error) {
            $log.error(error);
            HelperService.showMessage(error, 'error');
          });
        }
      }
    };

    var loadGroupOfPayments = function(paymentGroupId){
      if(paymentGroupId){
        return PaymentSignListService.getSignListById(paymentGroupId).then(function(paymentGroup){
          vm.paymentsGroupList = paymentGroup;
          vm.canBeSavedToTemplate = false;
        }).catch(function(err){
          $log.error(err);
          HelperService.showMessage(error, 'error');
        });
      }
    };

    var canBeSavedToTemplate = function (paymentType,payment) {

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl"){
        if(!vm.isFromTemplate &&
          (paymentType === 'DomesticPayment'
          || paymentType === 'ForeignPayment'
          || paymentType === 'RevenuePayment'
          || paymentType === 'SEPAPayment'
          || (paymentType === 'LocalCurrencyTransfer' && $sessionStorage.paymentSubTypeGroup == 'DomesticPayment')
          )
        ){
          return true;
        }else{
          return false;
        }
      } else{
        if(
          paymentType === 'DomesticPayment'
          || payment.paymentSubTypeGroup == 'DomesticPayment'
          || paymentType === 'ForeignPayment'
          || paymentType === 'RevenuePayment'
          || paymentType === 'SEPAPayment'
          // || (paymentType === 'LocalCurrencyTransfer')
        ){
          return true;
        }
        else
          return false;
      }
      //  || paymentType === 'ForeignCurrencyTransfer'
      // if (
      //   ( paymentType === 'DomesticPayment'
      //   || payment.paymentSubTypeGroup == 'DomesticPayment'
      //   || paymentType === 'ForeignPayment'
      //   || paymentType === 'RevenuePayment'
      //   || paymentType === 'SEPAPayment'
      //   || (paymentType === 'LocalCurrencyTransfer' && $sessionStorage.paymentSubTypeGroup == 'DomesticPayment'))
      //
      //   && ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && !vm.isFromTemplate)
      // ) {
      //   //|| (vm.countryCode == 'sl' && paymentType == 'LocalCurrencyTransfer' && payment.toAccountNumber.substring(0,4) === 'SI56' )
      //   return true;
      // }
      // return false;
    };

    vm.makeAnotherPayment = function () {
      var stateLink = '';
      switch (vm.paymentType) {
        case 'domestic':
        case 'loan':
          stateLink = 'payments.domesticPayment';
          break;
        case 'exchange':
          stateLink = 'payments.currencyConversion';
          break;
        case 'internal':
          stateLink = 'payments.internalTransfer';
          break;
        case 'international':
          stateLink = 'payments.internationalPayment';
          break;
        case 'ebook':
          stateLink = 'newEbook';
          break;
        case 'einvoice':
          stateLink = 'eInvoices.einvoicesOverview';
          break;
        case 'saving':
          stateLink = 'payments.paymentsOverview';
          break;
        default:
          stateLink = 'payments.paymentsOverview';
          break;
      }
      $state.go(stateLink);
    };

    vm.goToListOfPayments = function () {
      $state.go('payments.paymentsOverview',
        {selected: null}
      );
    };
    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsCtrl
   *
   * @description
   *
   */
  PaymentsCtrl.$inject = ["$rootScope", "$log", "$state", "CTLocalizationService", "PaymentTemplatesService", "$scope", "$uibModal", "EInvoiceDocumentsService", "PaymentsService", "$translate", "HelperService", "$localStorage", "ConfigEndpointService"];
  angular
    .module('payments')
    .controller('PaymentsCtrl', PaymentsCtrl);

  function PaymentsCtrl($rootScope, $log, $state, CTLocalizationService, PaymentTemplatesService,
    $scope, $uibModal, EInvoiceDocumentsService, PaymentsService, $translate, HelperService, $localStorage, ConfigEndpointService) {
    var vm = this;
    vm.ctrlName = 'PaymentsCtrl';
    vm.templatesFilter = {
      page: 0,
      pageSize: 10
    };
    vm.templateList = {};
    vm.eInvoiceDocumentsList = {};
    vm.pendingPaymentsList = {};
    vm.rejectedPaymentsList = {};
    vm.busy = false;
    vm.templateAlphabetically = false;
    vm.topUsed = false;
    vm.eInvoiceDocumentsFilter = {
      page: 0,
      orderBy: "valueDate DESC",
      pageSize: 10
    };
    vm.rejectedPaymentsFilter = {
      page: 0,
      pageSize: 5
    };
    vm.pendingPaymentsFilter = {
      page: 0,
      pageSize: 5
    };

    $translate(['core.period.today', 'core.period.yesterday', 'core.period.thisWeek', 'core.period.thisMonth', 'core.period.thisYear', 'core.period.all']).then(function (translations) {

      vm.periodList = [
        {
          item: {
            key: 'today',
            description: translations['core.period.today']
          }
        }
        , {
          item: {
            key: 'yesterday',
            description: translations['core.period.yesterday']
          }
        }
        , {
          item: {
            key: 'thisWeek',
            description: translations['core.period.thisWeek']
          }
        }
        , {
          item: {
            key: 'thisMonth',
            description: translations['core.period.thisMonth']
          }
        }
        , {
          item: {
            key: 'thisYear',
            description: translations['core.period.thisYear']
          }
        }
        , {
          item: {
            key: 'all',
            description: translations['core.period.all']
          }
        }
      ];

      vm.rejectedPeriod = vm.periodList[5];
    });

    vm.countryCode = $localStorage.code;

    vm.getDefaultData = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
        if (response.APILocation) {
          vm.countryCode = $localStorage.code;
        }
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.init = function () {
      vm.getPaymentTemplatesPage(true);
      vm.getPendingPayments(true);
      vm.getRejectedPayments(true);

      if (vm.countryCode == undefined) {
        vm.getDefaultData()
          .then(function () {
            if (vm.countryCode != 'sr' && vm.countryCode != undefined) {
              vm.getEInvoiceDocumentsPage(true);
            }
          })
      } if (vm.countryCode != undefined && vm.countryCode != 'sr') {
        vm.getEInvoiceDocumentsPage(true);
      }
    };


    vm.getPaymentTemplatesPage = function (reset) {
      if (vm.busy)
        return;
      vm.busy = true;
      if (reset) {
        vm.templatesFilter.page = 0;
      } else {
        vm.templatesFilter.page += 1;
      }
      if (vm.templateList.hasMore || vm.templatesFilter.page === 0) {
        PaymentTemplatesService.getPage(vm.templatesFilter)
          .then(function (response) {
            if (reset) {
              vm.templateList = response;
            } else {
              vm.templateList.hasMore = response.hasMore;
              vm.templateList.result = vm.templateList.result.concat(response.result);
            }
            vm.busy = false;
            $log.debug(vm.templateList);
          })
          .catch(function (error) {
            $log.error(error);
          });
      }
    };

    vm.getTemplatesAlphabetically = function () {
      vm.templateAlphabetically = !vm.templateAlphabetically;
      vm.topUsed = false;
      if (vm.templateAlphabetically) {
        vm.templatesFilter.orderBy = 'name ASC';
      } else {
        delete vm.templatesFilter.orderBy;
      }
      vm.getPaymentTemplatesPage(true);
    };

    vm.getTopUsedTemplates = function () {
      vm.topUsed = !vm.topUsed;
      vm.templateAlphabetically = false;
      $log.debug('Not implemented.');
    };

    vm.loadMoreTemplates = function () {
      vm.getPaymentTemplatesPage(false);
    };

    vm.loadMoreEInvoices = function () {
      vm.getEInvoiceDocumentsPage(false);
    };

    vm.loadMoreRejectedPayments = function () {
      vm.getRejectedPayments(false);
    };

    vm.loadMorePendingPayments = function () {
      vm.getPendingPayments(false);
    };

    vm.openTemplateModal = function (paymentTemplate) {
      var clone = _.clone(paymentTemplate, true);
      PaymentTemplatesService.openModal(clone);
    };

    vm.getEInvoiceDocumentsPage = function (reset) {
      if (reset) {
        vm.eInvoiceDocumentsFilter.page = 0;
      } else {
        vm.eInvoiceDocumentsFilter.page += 1;
      }
      if (vm.templateList.hasMore || vm.templatesFilter.page === 0) {
        EInvoiceDocumentsService.getPage(vm.eInvoiceDocumentsFilter)
          .then(function (response) {
            if (reset) {
              vm.eInvoiceDocumentsList = response;
            } else {
              vm.eInvoiceDocumentsList.hasMore = response.hasMore;
              vm.eInvoiceDocumentsList.result = vm.eInvoiceDocumentsList.result.concat(response.result);
            }
            $log.debug(vm.eInvoiceDocumentsList);
          })
          .catch(function (error) {
            $log.error(error);
          });
      }
    };

    vm.openEInvoicesModal = function (eInvoice) {
      EInvoiceDocumentsService.openModal(eInvoice);
    };

    vm.getPendingPayments = function (reset) {
      if (reset) {
        vm.pendingPaymentsFilter.page = 0;
      } else {
        vm.pendingPaymentsFilter.page += 1;
      }
      if (vm.pendingPaymentsList.hasMore || vm.pendingPaymentsFilter.page === 0) {
        PaymentsService.getPendingPayments(vm.pendingPaymentsFilter)
          .then(function (response) {
            if (reset) {
              vm.pendingPaymentsList = response;
            } else {
              vm.pendingPaymentsList.hasMore = response.hasMore;
              vm.pendingPaymentsList.result = vm.pendingPaymentsList.result.concat(response.result);
            }
          })
          .catch(function (error) {
            $log.error(error);
          });
      }
    };

    vm.getRejectedPayments = function (reset) {
      if (reset) {
        vm.rejectedPaymentsFilter.page = 0;
      } else {
        vm.rejectedPaymentsFilter.page += 1;
      }
      if (vm.rejectedPaymentsList.hasMore || vm.rejectedPaymentsFilter.page === 0) {
        PaymentsService.getRejectedPayments(vm.rejectedPaymentsFilter)
          .then(function (response) {
            if (reset) {
              vm.rejectedPaymentsList = response;
            } else {
              vm.rejectedPaymentsList.hasMore = response.hasMore;
              vm.rejectedPaymentsList.result = vm.rejectedPaymentsList.result.concat(response.result);
            }
          })
          .catch(function (error) {
            $log.error(error);
          });
      }
    };

    vm.rejectedPaymentsTimeFilter = function (item) {
      vm.rejectedPeriod = item;
      var timeRange = HelperService.getDateRange(vm.rejectedPeriod.item.key);
      vm.rejectedPaymentsFilter.valueDateGTE = timeRange.valueDateGTE;
      vm.rejectedPaymentsFilter.valueDateLTE = timeRange.valueDateLTE;
      vm.getRejectedPayments(true);
    };

    vm.deleteTemplate = function (id) {
      PaymentTemplatesService.deleteTemplate(id)
        .then(function (response) {
          swal('Success!', 'Payment template deleted succesfully!');
          vm.getPaymentTemplatesPage(true);
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.editTemplate = function (paymentTemplate) {
      var clone = _.clone(paymentTemplate, true);
      clone.forEdit = true;
      PaymentTemplatesService.openModal(clone);
    };

    vm.signPayment = function (paymentId) {
      $log.debug("Sign payment id: ", paymentId);
    };

    vm.deletePayment = function (paymentId) {
      $log.debug("Delete payment id: ", paymentId);
    };

    vm.recallPayment = function (paymentId) {
      $log.debug('Recall payment id: ', paymentId);
    };

    vm.init();
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:PaymentsAndTransferOverviewCtrl
     *
     * @description
     *
     */
    PaymentsAndTransferOverviewCtrl.$inject = ["$state", "$rootScope", "$log", "HelperService", "PaymentsService", "$translate", "$scope", "EInvoiceDocumentsService", "ConfigEndpointService", "$localStorage", "PaymentSignListService"];
    angular
        .module('payments')
        .controller('PaymentsAndTransferOverviewCtrl', PaymentsAndTransferOverviewCtrl);

    function PaymentsAndTransferOverviewCtrl($state, $rootScope, $log, HelperService, PaymentsService, $translate, $scope, EInvoiceDocumentsService, ConfigEndpointService, $localStorage,
                                             PaymentSignListService) {
        var vm = this;
        vm.ctrlName = 'PaymentsAndTransferOverviewCtrl';

        vm.getDefaultData = function () {
          var defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
          $localStorage.code = defaultData.APILocation;
          vm.countryCode = $localStorage.code;
            // return ConfigEndpointService.getDefaultData()
            //     .then(function (response) {
            //         if (response.APILocation) {
            //             $localStorage.code = response.APILocation;
            //             vm.countryCode = $localStorage.code;
            //         }
            //     })
            //     .catch(function (error) {
            //         HelperService.showMessage(error, 'error');
            //     });
        };

        vm.init = function () {
            vm.getRejectedPayments(true);
            vm.geteInvoiceDocumentsPage();
            vm.getDefaultData();
        };

        vm.isRejectedPaymentsPanelOpen = true;
        vm.isEInvoicesPanelOpen = true;
        vm.isGroupedPaymentsPanelOpen = true;

        vm.rejectedPaymentsFilter = {
            page: 0,
            orderBy: 'dateCreated DESC',
            status: 'Rejected',
            pageSize: 10
        };
        vm.rejectedPaymentsList = {};
        vm.getRejectedPayments = function (reset) {

            if (reset) {
                vm.rejectedPaymentsFilter.page = 0;
            } else {
                vm.rejectedPaymentsFilter.page += 1;
            }

            PaymentsService.getPage(vm.rejectedPaymentsFilter)
                .then(function (response) {
                    if (reset) {
                        vm.rejectedPaymentsList = response;
                    } else {
                        var tmpList = {};
                        tmpList.hasMore = response.hasMore;
                        tmpList.result = vm.rejectedPaymentsList.result.concat(response.result);
                        vm.rejectedPaymentsList = tmpList;
                    }
                    $log.debug("rejectedPaymentsList", vm.rejectedPaymentsList);

                })
                .catch(function (error) {
                    $log.error(error);
                });

        };

        //GET E-INVOICES
        vm.eInvoiceDocumentsFilter = {
            page: 0,
            orderBy: "valueDate DESC",
            pageSize: 10
        };
        vm.eInvoiceDocumentsList = {};
        vm.geteInvoiceDocumentsPage = function () {

            EInvoiceDocumentsService.getPage(vm.eInvoiceDocumentsFilter)
                .then(function (response) {
                  if(response){
                    vm.eInvoiceDocumentsList = response;
                    $log.debug("eInvoiceDocumentsList",vm.eInvoiceDocumentsList);
                  }
                })
                .catch(function (error) {
                    $log.error(error);
                });

        };

      vm.groupedPaymentsFilter = {
        page: 0,
        pageSize: 20,
        statusId: 'NotSigned',
        includeList: ['paymentList']
      };

      vm.groupedPayments = {
        payments: [],
        hasMore: false
      };

      vm.getGroupedPayments = function(reset){
        if (reset) {
          vm.groupedPaymentsFilter.page = 0;
        } else {
          vm.groupedPaymentsFilter.page += 1;
        }

        PaymentSignListService.getPage(vm.groupedPaymentsFilter)
          .then(function (response) {

            vm.groupedPayments.hasMore = response.hasMore;

            // NOTE: Uncomment block bwelow to get only payments for one month ago
            // Get date one month ago
            var daysOneMonthAgo = new Date();
            daysOneMonthAgo.setMonth(daysOneMonthAgo.getMonth()-1);
            // Remove old payments (older than one month from current date)

/*            _.forEach(response.result, function(item){
              item.paymentList = item.paymentList.filter(function(payment){
                return payment.dateCreated > daysOneMonthAgo;
              });
            });*/


            // Count total payments amount for every group
            _.forEach(response.result, function(item){
              item.totalPaymentsAmount = 0;
              if(item.paymentList && item.paymentList.length > 0){

                _.forEach(item.paymentList, function(singlePayment){
                  item.totalPaymentsAmount += singlePayment.amount;
                });
              }
            });

            // Logic for loading more payments
            if(reset){
              vm.groupedPayments.payments = response.result;
            }else{
              vm.groupedPayments.payments = vm.groupedPayments.payments.concat(response.result);
            }

          })
          .catch(function (error) {
            $log.error(error);
          });
      };

        vm.getToday = function () {
          return new Date();
        };

      vm.navigateToPaymentForm = function (paymentObj) {
        var stateLink;
        var params = {paymentId: paymentObj.id};
        switch (paymentObj.paymentTypeGroup) {
          case "DomesticPayment":
            //stateLink = 'payments.domesticPayment';
            stateLink = 'payments.domesticPayment.fromPayment';
            break;
          case "LocalCurrencyTransfer":
            stateLink = 'payments.internalTransfer.fromPayment';
            //var strUrl = JSON.stringify({
            //  type: 'payment',
            //  id: paymentObj.id
            //});
            //params = {templateId: strUrl};
            break;
          case "CurrencyExchange":
            stateLink = 'payments.currencyConversion.fromPayment'
            break;
          case "ForeignPayment":
            console.log('Not implemented');
            break;
        }
        if (stateLink) {
          $state.go(stateLink, params);
        }
      };

      vm.navigatoEInvoicePayment = function (eInvoiceId) {
        $state.go('eInvoices.pay', {eInvoiceId: eInvoiceId});
      };

        vm.init();
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:PaymentTypesService
     *
     * @description
     *
     */
    PaymentTypesService.$inject = ["$rootScope", "HelperService", "EndpointsService", "$q", "$http", "$log"];
    angular
        .module('payments')
        .factory('PaymentTypesService', PaymentTypesService);

    function PaymentTypesService($rootScope, HelperService, EndpointsService, $q, $http, $log) {
        var PaymentTypesServiceBase = {};

        PaymentTypesServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.paymentTypes_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        PaymentTypesServiceBase.getByGroup = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.paymentTypes, {
                        params: params
                    })
                    .success(function (data) {
                        if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl'){
                          if(data.result && data.result[0].debitAccountList)
                            data.result[0].debitAccountList = HelperService.sortAccounts(data.result[0].debitAccountList);
                          if(data.result && data.result[0].creditAccountList)
                            data.result[0].creditAccountList = HelperService.sortAccounts(data.result[0].creditAccountList);
                        }
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return PaymentTypesServiceBase;
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentSignModalCtrl
   *
   * @description
   *
   */
  PaymentSignModalCtrl.$inject = ["paymentId", "PaymentsService", "$uibModalInstance"];
  angular
    .module('payments')
    .controller('PaymentSignModalCtrl', PaymentSignModalCtrl);

  function PaymentSignModalCtrl(paymentId, PaymentsService, $uibModalInstance) {
    var vm = this;
    vm.formSubmitted = false;

    vm.signPayment = function () {
      if (!vm.signPaymentForm.$valid) {
        return;
      }
      if(!vm.formSubmitted){
        vm.formSubmitted = true;
        PaymentsService.signPayment(paymentId)
          .then(function (response) {
            $uibModalInstance.close(true);
          })
          .catch(function (error) {
            $uibModalInstance.dismiss(error);
          })
          .finally(function(){
            vm.formSubmitted = false;
          });
      }
    };

    vm.closeModal = function (){
      $uibModalInstance.close(false);
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:PaymentSignListService
   *
   * @description
   *
   */
  PaymentSignListService.$inject = ["$rootScope", "$sessionStorage", "EndpointsService", "$q", "$http", "$log"];
  angular
    .module('payments')
    .factory('PaymentSignListService', PaymentSignListService);

  function PaymentSignListService($rootScope, $sessionStorage, EndpointsService, $q, $http, $log) {
    var PaymentsServiceBase = {};

    if($sessionStorage.paymentsForSign && $sessionStorage.paymentsForSign.t == 'paymentsForSign'){
      signPayment($sessionStorage.paymentsForSign.o);
    }

    PaymentsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.paymentSignLists, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PaymentsServiceBase.addPaymentSignList = function (paymentList) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.paymentSignLists, paymentList)
            .success(function (data) {
              deferred.resolve(data);
            })
            .error(function (msg, code) {
              deferred.reject(msg)
            });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    function signPayment(params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $sessionStorage.paymentsForSign = {
            o: params,
            t: 'paymentsForSign' //paymentS - group sign
          };
          $http.put(response.links.paymentSignLists_action_sign, params)
            .success(function (data) {
              $rootScope.$broadcast("paymentInserted");
              delete $sessionStorage.paymentsForSign;
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    PaymentsServiceBase.signAllPaymentsOnList = function (params) {
      return signPayment(params);
    };

    PaymentsServiceBase.updateGroupPaymentDates = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.paymentSignLists_id_updateOldPaymentDates.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    PaymentsServiceBase.getSignListById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        var paramsObject = {
          includeList: ['PaymentList']
        };

          $http.get(response.links.paymentSignLists_id.replace('{id}', id),{
            params: paramsObject
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    return PaymentsServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentComplaintCtrl
   *
   * @description
   *
   */
  PaymentReclamationCtrl.$inject = ["$state", "payment", "PaymentsService", "HelperService", "ValidationService"];
  angular
    .module('payments')
    .controller('PaymentReclamationCtrl', PaymentReclamationCtrl);

  function PaymentReclamationCtrl($state, payment, PaymentsService, HelperService, ValidationService) {
    var vm = this;
    vm.model = payment;
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

    vm.input = {
      comment: ""
    };

    vm.confirm = function () {
      vm.confirmButtonDisabled = true;

      var data = {
        id: payment.id,
        note: vm.input.comment
      };

      PaymentsService.paymentsAppeal(data)
        .then(function (response) {
          console.log(response);
          HelperService.confirmationReclamationMsg('paymentsOverview.reclamationSuccess');
          $state.go('payments.paymentsOverview');
          vm.confirmButtonDisabled = false;
        }, function (error) {
          vm.confirmButtonDisabled = false;
          HelperService.showTranslatedMessage('error', error);
        })
    };

    vm.cancel = function () {
      $state.go('payments.paymentsOverview');
    }

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name payments.directive:paymentFinalStep
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="payments">
   <file name="index.html">
   <payment-final-step></payment-final-step>
   </file>
   </example>
   *
   */
  paymentFinalStep.$inject = ["$state", "$log", "PaymentTemplatesService", "HelperService"];
  angular
    .module('payments')
    .directive('paymentFinalStep', paymentFinalStep);

  function paymentFinalStep($state, $log, PaymentTemplatesService, HelperService) {
    return {
      restrict: 'EA',
      scope: {
        paymentObject: '=payment',
        closeModal: '&close',
        isModal: '=isModal',
        templateName: '=',
        templateId: '='
      },
      templateUrl: 'payments/payment-final-step-directive.tpl.html',
      replace: false,
      controllerAs: 'paymentFinalStep',
      controller: ["$scope", function ($scope) {
        var vm = this;
        vm.formSubmitted = false;
        vm.tempVal = $scope.templateName || '';

        if ($scope.templateName) {
          vm.templateNameInput = $scope.templateName;
        }
        vm.saveAsTemplate = function () {
          vm.formSubmitted = true;
          if (!vm.templateForm.$valid) {
            return;
          }

          if ($scope.paymentObject) {
            var objectForInsert = prepareObjectForInsert();
            if (vm.tempVal === vm.templateNameInput) {
              PaymentTemplatesService.updateTemplate($scope.templateId, objectForInsert)
                .then(function (response) {
                  $log.debug("Update payment template response", response);
                  swal("Success!", "Template updated successfully!");
                })
                .catch(function (error) {
                  HelperService.showMessage(error, 'error');
                });
            } else {
              PaymentTemplatesService.insertTemplate(objectForInsert)
                .then(function (response) {
                  $log.debug("Insert payment template response", response);
                  swal("Success!", "Template saved successfully!");
                  vm.navigateToPaymentsPage();
                })
                .catch(function (error) {
                  HelperService.showMessage(error, 'error');
                });
            }
          }
        };

        vm.navigateToPaymentsPage = function () {
          if ($state.current.name === "payments") {
            $state.reload();
          } else {
            $state.go('payments.paymentsOverview');
          }
          if ($scope.isModal) {
            $scope.closeModal();
          }
        };

        vm.navigateToAllPaymentsPage = function () {
          $state.go('payments.paymentsOverview');
          if ($scope.isModal) {
            $scope.closeModal();
          }
        };

        var prepareObjectForInsert = function () {
          var objForInsert = {
            accountId: $scope.paymentObject.accountId,
            name: vm.templateNameInput,
            fromAccountNumber: $scope.paymentObject.fromAccountNumber,
            toAccountNumber: $scope.paymentObject.toAccountNumber,
            amount: $scope.paymentObject.amount,
            currencySymbol: $scope.paymentObject.currencySymbol,
            purpose: $scope.paymentObject.purpose,
            paymentTypeGroup: $scope.paymentObject.paymentTypeGroup,
            purposeCodeDPS: $scope.paymentObject.purposeCodeDPS
          };
          var subProperties = {
            receiverName: $scope.paymentObject.receiverName,
            receiverAddress1: $scope.paymentObject.receiverAddress1,
            receiverCity: $scope.paymentObject.receiverCity
          };

          subProperties.referenceTo =  $scope.paymentObject.referenceTo || '99';
          subProperties.referenceFrom = $scope.paymentObject.referenceFrom || '99';

          if ($scope.paymentObject.senderInfo) {
            subProperties.senderName = $scope.paymentObject.senderInfo.senderName;
            subProperties.senderAddress1 = $scope.paymentObject.senderInfo.senderAddress1;
            subProperties.senderCity = $scope.paymentObject.senderInfo.senderCity;
          }
          switch($scope.paymentObject.paymentTypeGroup){
            case "DomesticPayment":
              objForInsert.domesticPayment = subProperties;
                  break;
            case "ForeignPayment":
              objForInsert.foreignPayment = subProperties;
              objForInsert.foreignPayment.beneficiaryBankName = $scope.paymentObject.beneficiaryBankName;
              objForInsert.foreignPayment.beneficiaryBankAddress = $scope.paymentObject.beneficiaryBankAddress;
              objForInsert.foreignPayment.beneficiaryBankCity = $scope.paymentObject.beneficiaryBankCity;
              objForInsert.foreignPayment.beneficiarySWIFTCode = $scope.paymentObject.beneficiarySWIFTCode;
              objForInsert.foreignPayment.beneficiaryBankCountryCode = $scope.paymentObject.beneficiaryBankCountryCode;
              objForInsert.foreignPayment.receiverCountryCode = $scope.paymentObject.receiverCountryCode;
              objForInsert.foreignPayment.paymentCharges = $scope.paymentObject.paymentCharges;
              objForInsert.foreignPayment.payeeLegalForm = $scope.paymentObject.payeeListId;
           //   objForInsert.foreignPayment.paymentType = $scope.paymentObject.formType;
                  break;
          };
          return objForInsert;
        };
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:PaymentFilterService
   *
   * @description
   *
   */
  angular
    .module('payments')
    .factory('PaymentFilterService', PaymentFilterService);

  function PaymentFilterService() {
    var PaymentFilterServiceBase = {};
    PaymentFilterServiceBase.filterFromAccountSelect = function (accountList, accountId){
      var accountIndex = _.findIndex(accountList, function (item){
        return accountId == item.accountId;
      })
      if(accountIndex == -1){
        return accountList[0];
      }
      return accountList[accountIndex];
    };

    PaymentFilterServiceBase.filterToAccountSelect = function (accountList, accountNumber){
      var toAccountIndex = _.findIndex(accountList, function (item){
        return accountNumber == item.accountNumber
      });
      if(toAccountIndex == -1){
        return accountList[0];
      }
      return accountList[toAccountIndex];
    };

    PaymentFilterServiceBase.filterToAccountSelectByIBAN = function (accountList, ibanNumber){
      var toAccountIndex = _.findIndex(accountList, function (item){
        return ibanNumber == item.iban
      });
      if(toAccountIndex == -1){
        return accountList[0];
      }
      return accountList[toAccountIndex];
    };

   /* PaymentFilterServiceBase.filterToAccountList = function (accountsFromList, accountId) {
      var toAccountList = _.filter(accountsFromList, function (item) {
        return item.accountId != accountId;
      });
      return toAccountList;
    };*/

    PaymentFilterServiceBase.filterBuyCurrencyInput = function (params) {
      var buyCurrency = {};
      if (params.sellCurrency != params.localCurrency) {
        buyCurrency.symbol = params.localCurrency;
      } else if (params.currencyList.length > 0) {
        buyCurrency = _.find(params.currencyList, function (item) {
          return item.symbol == params.destinationCurrency;
        });
      }
      if (params.localCurrency == 'RSD' || params.localCurrency == 'EUR' || params.localCurrency == 'BAM') {
        buyCurrency.symbol = params.destinationCurrency;
      }
      return buyCurrency;
    };

    PaymentFilterServiceBase.filterPurposeCodeSelect = function (purposeCodeList, purposeCode){
        var purposeCodeIndex = _.findIndex(purposeCodeList, function (item) {
          return purposeCode == item.id;
        });
      if(purposeCodeIndex == -1) {
        return purposeCodeList[0];
      }
      return purposeCodeList[purposeCodeIndex];
    };

    PaymentFilterServiceBase.filterReferenceModelSelect = function (referenceModelList, modelNumber) {
      var subNumber = modelNumber.substring(0, 2);
      var referenceModelIndex = _.findIndex(referenceModelList, function (item) {
        return subNumber == item;
      });
      if (referenceModelIndex == -1) {
        return referenceModelList[0];
      }
      return referenceModelList[referenceModelIndex];
    };

    return PaymentFilterServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentConfirmationModalSloCtrl
   *
   * @description
   *
   */
  PaymentConfirmationModalSloCtrl.$inject = ["$rootScope", "$uibModalInstance", "AlertService", "payment", "PaymentsService"];
  angular
    .module('payments')
    .controller('PaymentConfirmationModalSloCtrl', PaymentConfirmationModalSloCtrl);

  function PaymentConfirmationModalSloCtrl($rootScope, $uibModalInstance, AlertService, payment, PaymentsService) {

    var vm = this;
    var userInfo = $rootScope.APP_GLOBAL_SETTINGS.userSettings;

    vm.model = {};
    vm.model.address = userInfo.firstName + " " + userInfo.lastName + '\n' + userInfo.address1 + "\n" + userInfo.countryCode + " " + userInfo.state;
    vm.model.note = "";
    vm.payment = payment;

    vm.ok = function (form) {
      if (form.$invalid) return;

      vm.confirmBtnDisabled = true;
      var data = {
        paymentId: payment.id,
        destinationAddress: vm.model.address,
        note: vm.model.note
      };

      PaymentsService.paymentOrderConfirm(data)
        .then(function (response) {

          vm.confirmBtnDisabled = false;
          AlertService.infoAlert({text: "paymentsOverview.orderSuccessAlert"})
          $uibModalInstance.close(payment);
        }, function (error) {
          vm.confirmBtnDisabled = false;
        });

    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };


  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:NonWorkingDays
   *
   * @description
   *
   */
  NonWorkingDays.$inject = ["$q", "$http", "EndpointsService", "ConfigService"];
  angular
    .module('payments')
    .factory('NonWorkingDays', NonWorkingDays);

  function NonWorkingDays($q, $http, EndpointsService, ConfigService) {
    var NonWorkingDaysBase = {};
    NonWorkingDaysBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.nonWorkingDays, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    NonWorkingDaysBase.isWorkingDate = function (date) {
      var deferred = $q.defer();
      var url = ConfigService.url + '/nonWorkingDays/isWorkingDay';
      $http.get(url, {
        params: {
          date: date
        }
      })
        .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
        deferred.reject(msg);
      });
      return deferred.promise;
    };

    NonWorkingDaysBase.nextWorkingDate = function (date) {
      var deferred = $q.defer();
      var url = ConfigService.url + '/nonWorkingDays/nextWorkingDay';
      $http.get(url, {
        params: {
          date: date
        }
      })
        .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
        deferred.reject(msg);
      });
      return deferred.promise;
    };
    return NonWorkingDaysBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:LoanPaymentCtrl
   *
   * @description
   *
   */
  LoanPaymentCtrl.$inject = ["$log", "$state", "$rootScope", "$translate", "PaymentsService", "PaymentTypesService", "HelperService", "$filter", "AccountsService", "ConfigEndpointService", "Notification", "AlertService", "GoogleTagManagerHelperService", "$location"];
  angular
    .module('payments')
    .controller('LoanPaymentCtrl', LoanPaymentCtrl);

  function LoanPaymentCtrl($log, $state, $rootScope, $translate, PaymentsService, PaymentTypesService, HelperService, $filter, AccountsService,
                            ConfigEndpointService, Notification, AlertService, GoogleTagManagerHelperService,$location) {
    var vm = this;
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

    vm.tempLoanObj = {
      fromAccountSelect: {},
      toAccountInput: '',
      amountInput: '',
      purposeCodeSelect: {},
      paymentPurposeInput: '',
      //dueDateInput: $filter('date')(new Date(), 'shortDate'),
      dueDateInput: new Date(),
      receiverNumberCountryCode: '',
      receiverNumber1: '',
      receiverNumber2: '',
      receiverName: '',
      receiverAddress1: '',
      receiverCity: '',
      formSubmitted: false
    };
    vm.purposeCodesList = [];
    vm.datePickerOpened = false;
    vm.referenceNumber = '';
    vm.purposeCodeDPS = null;
    vm.bankCharges = '';
    vm.currentStep = 1;
    vm.forUpdate = false;

    vm.fromAccountDropdown = false;
    vm.maxLength = 12;
    vm.maxAmount = 999999999999.99;

    if(vm.countryCode == 'sl'){
      vm.maxAmount = 99999999999.99;
      vm.maxLength = 14;
    }


    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };
    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };


    // vm.smsAuthentificate = false;

    vm.goBackToPayments = function (){
      $state.go('payments.paymentsOverview');
    };

    vm.init = function () {
      getReceiverDetails()
        .then(function () {
        vm.getDebitAccountList();
        if ($state.params && $state.params.accountId) {
          vm.getLoanTypeCreditInfo($state.params.accountId);
        }
      })
        .catch(function (error) {
        $log.debug('getReceiverDetails()', error);
      });
    };


    vm.getDebitAccountList = function () {
      PaymentTypesService.getByGroup({paymentTypeGroup: 'DomesticPayment'})
        .then(function (response) {
        if (_.isArray(response.result) && response.result.length > 0) {
          vm.accountsFrom = response.result[0].debitAccountList;

          _.forEach(vm.accountsFrom, function (item) {
            if (item.accountDescription) {
              item.optionValue = item.accountDescription + ' - ' + item.iban;
            }
          });

          if (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) {
            vm.tempLoanObj.fromAccountSelect = vm.accountsFrom[0];
          }
        }
      })
        .catch(function (error) {
        $log.error(error);
      });
    };

    vm.getLoanTypeCreditInfo = function (accountId) {
      if (accountId) {
        AccountsService.getPage({accountId: accountId, includeList:['loanAccount']})
          .then(function (response) {
          if (response.result[0].accountNumber && vm.countryCode != 'sl') {
            var letters = response.result[0].accountNumber.split(' ');
            vm.tempLoanObj.receiverNumber1 = letters[0];
            vm.tempLoanObj.receiverNumber2 = letters[1];
            if (response.result[0].ownerName) {
              var numberParts = vm.tempLoanObj.receiverNumber2.split('-');
              vm.tempLoanObj.paymentPurposeInput = numberParts[1] + ' - ' + response.result[0].ownerName;
            }
            vm.tempLoanObj.receiverNumberCountryCode = 'HR';
          }else if(vm.countryCode === 'sl' && response.result[0].loanAccount){
            vm.tempLoanObj.receiverNumberCountryCode = response.result[0].loanAccount.reference.substring(0,2);
            vm.tempLoanObj.receiverNumber1 = response.result[0].loanAccount.reference.substring(2,4);
            vm.tempLoanObj.receiverNumber2 = response.result[0].loanAccount.reference.substring(4);
            vm.purposeCodeDPS = response.result[0].loanAccount.purposeCodeDPS;
          }
          if(response.result[0].loanAccount.totalMatureInLocalCurrency) {
            vm.tempLoanObj.amountInput = response.result[0].loanAccount.totalMatureInLocalCurrency;
          }
        })
          .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
      }
    };

    vm.submitLoanPayment = function () {
      if (vm.nextButtonPressed) return;
      vm.tempLoanObj.formSubmitted = true;
      if (!vm.loanPaymentForm.$valid) {
        return;
      }
      var paymentObject = {};
      vm.referenceNumber =  vm.tempLoanObj.receiverNumber1 + vm.tempLoanObj.receiverNumber2;
      paymentObject = createPaymentObject();
      if(vm.purposeCodeDPS){
        paymentObject.purposeCodeDPS = vm.purposeCodeDPS;
      }
      vm.nextButtonPressed = true;
      if (vm.forUpdate) {
        paymentObject.id = vm.paymentResponse.id;
        PaymentsService.updatePayment(vm.paymentResponse.id, paymentObject)
          .then(function (response) {

            if (response.dueDateChanged) {
              AlertService.confirmationAlert({
                text: "payments.paymentDueDateChangedMsg"
              })
                .then(function (accept) {
                  if (!accept) return;
                  secondValidate(response);
                })
            } else {
              postPaymentAction(response);
              vm.forUpdate = false;
            }
        })
          .catch(function (error) {
          HelperService.showMessage(error, 'error');
          vm.forUpdate = false;
        }).finally(function(){
          vm.nextButtonPressed = false;
        });
      } else {
        PaymentsService.insertPayment(paymentObject)
          .then(function (response) {
            var gtmObject = HelperService.processUrlForGTM('payment');
            GoogleTagManagerHelperService.pushVirtualPageView(gtmObject.url, gtmObject.title, $location.host() + gtmObject.url);
            if (response.dueDateChanged) {
              AlertService.confirmationAlert({
                text: "payments.paymentDueDateChangedMsg"
              })
                .then(function (accept) {
                  if (!accept) return;
                  secondValidate(response);
                })
            } else {
              postPaymentAction(response);
            }
        })
          .catch(function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function(){
          vm.nextButtonPressed = false;
        });
      }
    };

    function secondValidate(validatedUPOrder) {
      if (vm.secondValidateInProgress) return;
      vm.secondValidateInProgress = true;
      PaymentsService.insertPayment(validatedUPOrder)
        .then(function (response) {
          postPaymentAction(response);
        })
        .catch(function (response, error) {
            HelperService.showMessage(response, 'error');
        })
        .finally(function () {
          vm.formSubmitted = false;
          vm.forUpdate = false;
          vm.secondValidateInProgress = false;
        });
    }

    var createPaymentObject = function () {
      var reference = '';
      var referenceFrom = '99';
      var date = new Date();
      if(vm.countryCode == 'sl'){
        reference = 'SI';
        referenceFrom = 'NRC';
        date = vm.tempLoanObj.dueDateInput;
      }

      return {
        accountId: vm.tempLoanObj.fromAccountSelect.accountId,
        fromAccountNumber: vm.tempLoanObj.fromAccountSelect.iban,
        toAccountNumber: vm.tempLoanObj.toAccountInput,
        currencySymbol: vm.tempLoanObj.fromAccountSelect.currencySymbol,
        purpose: vm.tempLoanObj.paymentPurposeInput,
        amount: vm.tempLoanObj.amountInput,
        paymentTypeGroup: 'DomesticPayment',
        dueDate: date,
        domesticPayment: {
          referenceTo: reference+vm.tempLoanObj.receiverNumber1 + vm.tempLoanObj.receiverNumber2,
          //referenceFrom: vm.tempLoanObj.receiverNumberCountryCode + vm.tempLoanObj.receiverNumber1 + vm.tempLoanObj.receiverNumber2,
          referenceFrom: referenceFrom,
          senderName: vm.tempLoanObj.fromAccountSelect.ownerName,
          senderAddress1: vm.tempLoanObj.fromAccountSelect.ownerAddress,
          senderCity: vm.tempLoanObj.fromAccountSelect.ownerCity,
          receiverName: vm.tempLoanObj.receiverName,
          receiverAddress1: vm.tempLoanObj.receiverAddress1,
          receiverCity: vm.tempLoanObj.receiverCity,
          priority: 'LA'
        }
      }
    };

    vm.editPayment = function (){
      mapWithPaymentResponse();
      vm.forUpdate = true;
      vm.currentStep = 1;
    };

    vm.deletePayment = function () {
      PaymentsService.deletePayment(vm.paymentResponse.id)
        .then(function (response) {
        HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], vm.paymentResponse.id);
        $state.go('payments.paymentsOverview');
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    var mapWithPaymentResponse = function (){
      vm.tempLoanObj.toAccountInput = vm.paymentResponse.toAccountNumber;
      vm.tempLoanObj.amountInput = vm.paymentResponse.amount;
      vm.tempLoanObj.paymentPurposeInput = vm.paymentResponse.purpose;
      vm.tempLoanObj.dueDateInput = new Date(vm.paymentResponse.dueDate);

      var accountIndex = _.findIndex(vm.accountsFrom, function (item){
        return vm.paymentResponse.accountId == item.accountId;
      });
      vm.tempLoanObj.fromAccountSelect = vm.accountsFrom[accountIndex];
    };

    /*    vm.signPayment = function () {
      PaymentsService.signPayment(vm.paymentResponse.id)
        .then(function (response) {
          vm.currentStep = 3;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };*/

    vm.toggleFromAccount = function (){
      vm.fromAccountDropdown = !vm.fromAccountDropdown;
    };

    vm.setAccountFrom = function (item){
      vm.tempLoanObj.fromAccountSelect = item;
      vm.fromAccountDropdown = false;
    };

    /*    vm.showSMSAuthentification = function () {
      vm.smsAuthentificate = !vm.smsAuthentificate;
    };*/

    var clearInput = function (){
      vm.tempLoanObj.fromAccountSelect = vm.accountsFrom[0];
      vm.tempLoanObj.amountInput = '';
      vm.tempLoanObj.paymentPurposeInput = '';
      vm.tempLoanObj.formSubmitted = false;
    };

    var postPaymentAction = function (response) {
      vm.paymentResponse = response;
      vm.paymentResponse.paymentTypeGroup = "DomesticPayment";
      vm.paymentResponse.senderInfo = {
        senderName: vm.tempLoanObj.fromAccountSelect.ownerName,
        senderAddress1: vm.tempLoanObj.fromAccountSelect.ownerAddress,
        senderCity: vm.tempLoanObj.fromAccountSelect.ownerCity
      };
      Notification.clearAll();
      vm.currentStep = 2;
    };

    vm.backToLoanPayment = function (){
      clearInput();
      vm.currentStep = 1;
    };

    vm.sign = function () {
      if (vm.confirmButtonPressed) return;
      var params = {
        id: vm.paymentResponse.id,
        payment: vm.paymentResponse
      };
      vm.confirmButtonPressed = true;
      return PaymentsService.signPayment(params)
        .then(function (signedPayment) {
          var id = (signedPayment.id) ? signedPayment.id : vm.paymentResponse.id;
          // TODO: Use signed payment on response
          $state.go('payments.finalStep', {paymentObject:signedPayment, paymentId: id, type: 'loan'});
        }).catch(function (error) {
          $log.error(error);
          HelperService.showMessage(error, 'error');
        }).finally(function() {
          vm.confirmButtonPressed = false;
        });
    };

    var getReceiverDetails = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
        if (response) {
          vm.tempLoanObj.toAccountInput = response.BankAccount;
          vm.tempLoanObj.receiverName = response.BankName,
            vm.tempLoanObj.receiverAddress1 = response.BankAddress;
          vm.tempLoanObj.receiverCity = response.BankCity;
          vm.bankCharges = response.BankCharges;
          vm.countryCode = response.APILocation;
          if(vm.countryCode == 'sl'){
            setDefaultPurpose();
            vm.tempLoanObj.paymentPurposeInput = $translate.instant('loanPayment.defaultPurpose');
          }
        }
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    var setDefaultPurpose = function () {
      $rootScope.$on('$translateChangeSuccess', function () {
        $translate('loanPayment.defaultPurpose').then(function (translations) {
            vm.tempLoanObj.paymentPurposeInput = $translate.instant('loanPayment.defaultPurpose');
        });
      });
    }


    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @author Dino Dujmovic
   * @ngdoc object
   * @name payments.controller:InternationalPaymentSloCtrl
   *
   * @description International Payment Controller for Slovenia
   *
   */
  InternationalPaymentSloCtrl.$inject = ["$rootScope", "$scope", "$state", "$log", "$q", "$timeout", "$filter", "$http", "$uibModal", "$translate", "CTLocalizationService", "UserSettingsService", "BicBanksService", "CountriesService", "PaymentTypesService", "PaymentsService", "HelperService", "PaymentTemplatesService", "CurrencyService", "ValidationService", "CreditAccountRegisterService", "AlertService", "ImagesService"];
  angular
    .module('payments')
    .controller('InternationalPaymentSloCtrl', InternationalPaymentSloCtrl);

  function InternationalPaymentSloCtrl($rootScope, $scope, $state, $log, $q, $timeout, $filter, $http, $uibModal, $translate,
                                       CTLocalizationService, UserSettingsService, BicBanksService, CountriesService, PaymentTypesService,
                                       PaymentsService, HelperService, PaymentTemplatesService, CurrencyService, ValidationService,
                                       CreditAccountRegisterService, AlertService,ImagesService) {

    var vm = this;
    vm.isFromTemplate;
    vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
    // ======================================
    // =          Initialize                =
    // ======================================

    function init() {

      // --
      // Flags
      // --
      vm.forUpdate = false;
      vm.datePickerOpened = false;
      vm.steps = {
        step1: true,
        step2: false,
        step3: false
      };

      vm.tempForpObj = {
        receiversAddressInput: '',
        receiversPostalCodeAndCityInput: '',
        fromAccountSelect: {},
        amountInput: '',
        dueDateInput: new Date(),
        paymentPurposeInput: '',
        paymentMode: '',
        recipientStatusRadiobutton: {
          type: '2'
        },
        fullNameCompanyInput: '',
        recipientAddressInput: '',
        recipientCityInput: '',
        recipientCountrySelect: {},
        recipientAccountInput: '',
        bankNameInput: '',
        bankAddressInput: '',
        bankCityInput: '',
        bankCountrySelect: {},
        swiftCodeInput: '',
        bankChargesRadiobutton: {
          type: '0'
        },
        formSubmitted: false,
        receiversCountry: " " //choose first from the list
      };

      vm.paymentResponse = {};

      vm.templateName = '';
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
      vm.uiMaskOptions = ValidationService.getUiMaskOptions().international.iban;
      // vm.uiMask = ValidationService.getUiMask().sl.internationalSI;
      vm.uiMask = ValidationService.getUiMask().sl.international;

      vm.dateOptions = {
        minDate: new Date(),
        maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
      };


      vm.disableAllFields = false;
      vm.disableAllFieldsForProcessedPayment = false;
      loadAllData();
    }

    // ======================================
    // =          Private methods           =
    // ======================================


    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };


    function loadAllData() {
      getPaymentTemplatesPage();
      getUserSettingsPage();

      var promises = [
        CountriesService.getPage({pageSize: 1000}),
        CurrencyService.getCurrencyPage({pageSize: 1000}),
        getCountries(),
        getDebitAccountList()
      ];

      $q.all(promises)
        .then(function (responses) {
          getPayees();
          vm.countriesOptions = responses[0].result;
          vm.currenciesOptions = responses[1].result;
          vm.currenciesOptions = _.without(vm.currenciesOptions, _.findWhere(vm.currenciesOptions, {symbol: "BAM"}));

          if ($state.params && $state.params.paymentId) {
            loadPaymentData($state.params.paymentId);
          } else if ($state.current && $state.current.name == 'payments.internationalPayment.fromTemplatesToPay' && $state.params.templateId) {
            // vm.setChargeAccount(vm.accountsFrom[0]);
            vm.selectTemplate($state.params.templateId);
          }
          else if ($state.current && $state.current.name == 'payments.internationalPayment.fromDomestic') {
            populatePaymentFieldFromDomestic($state.params.transactionDetails);
          }
          else {
            if (vm.bankCountries.length > 0) {
              vm.tempForpObj.recipientCountrySelect = vm.bankCountries[0];
              vm.tempForpObj.bankCountrySelect = vm.bankCountries[0];
            }
            if (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) {
              vm.tempForpObj.fromAccountSelect = vm.accountsFrom[0];

              vm.tempForpObj.fromAccountSelect = PaymentsService.setFromAccountsToDefaulCurrency(vm.accountsFrom);
              $log.debug(vm.tempForpObj.fromAccountSelect);
              vm.setChargeAccount(vm.tempForpObj.fromAccountSelect);
            }
          }

          loadImages();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    vm.setChargeAccount = function (item) {
      vm.tempForpObj.totalAmountCurrency = item.currencySymbol;
      vm.tempForpObj.chargeAccountInput = item;
      vm.tempForpObj.fromAccountSelect = item;
      vm.chargeAccountOptions = _.findWhere(vm.accountsFrom, {
        iban: item.iban
      });
      // console.log(vm.chargeAccountOptions);
    };

    function validateIBANLengthByAccountNumber(accountNumber) {
      if(!accountNumber) return;
      var ibanSI56 = accountNumber.substring(0, 4);
      if (ibanSI56 == "SI56") {
        vm.uiMask =  ValidationService.getUiMask().sl.internationalSI;
      } else {
        vm.uiMask =  ValidationService.getUiMask().sl.international;
      }
    }

    var populatePaymentFieldFromDomestic = function (payment) {
      var item = payment;
      var fromAccount = _.findWhere(vm.accountsFrom, {accountId: payment.accountId});

      vm.setChargeAccount(fromAccount);

      vm.tempForpObj.amountInput = item.amount;
      vm.tempForpObj.fromAccountSelect = (fromAccount) ? fromAccount : vm.accountsFrom[0];
      var currencyOption = _.findWhere(vm.currenciesOptions, {symbol: payment.currencySymbol});
      vm.tempForpObj.totalAmountCurrency = (currencyOption) ? currencyOption.symbol : 'EUR';

      validateIBANLengthByAccountNumber(item.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim());
      vm.tempForpObj.toAccountInput = item.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
      vm.tempForpObj.receiversAddressInput = item.domesticPayment.receiverAddress1.substring(0, 35);
      vm.tempForpObj.receiversNameInput = item.domesticPayment.receiverName.substring(0, 35);
      vm.tempForpObj.receiversPostalCodeAndCityInput = item.domesticPayment.receiverCity.substring(0, 35);
      vm.tempForpObj.paymentPurposeInput = item.purpose.substring(0, 35);
      // vm.tempForpObj.dueDateInput = new Date(payment.dueDate);
      vm.tempForpObj.dueDateInput = new Date();

      // Populate BIC fields from template
      // vm.tempForpObj.beneficiarySWIFTCode = item.beneficiarySWIFTCode;
      vm.getBicByIban(vm.tempForpObj.toAccountInput);
      var bankCountry = _.findWhere(vm.bankCountries, {countryCode: payment.domesticPayment.receiverCountry});
      vm.tempForpObj.receiversCountry = (bankCountry) ? bankCountry : vm.bankCountries[0];

      vm.onCountrySelect(_.findWhere(vm.countriesOptions, {
        countryCode: item.domesticPayment.receiverCountry
      }));

      vm.searchFilterExpanded = !vm.searchFilterExpanded;
      vm.searchFilterExpanded = false;
      vm.searchTemplateFilterExpanded = false;
    };



    vm.selectCountry = function (input) {
      if (!input) return;
      var prefix = input.substring(0, 2);
      var bankCountry = _.findWhere(vm.bankCountries, {countryCode: prefix});
      vm.tempForpObj.receiversCountry = (bankCountry) ? bankCountry : vm.bankCountries[0];
    };

    function loadPaymentData(paymentId) {
      if (!paymentId)
        return;

      PaymentsService.getById(paymentId)
        .then(function (response) {

          var country = _.findWhere(vm.countriesOptions, {
            code: response.beneficiaryBankCountryCode
          });
          if (country) {
            vm.countrySearchFilter = country.description;
            vm.tempForpObj.bankCountrySelect = country;
          }

          vm.tempForpObj.amountInput = response.amount;
          vm.tempForpObj.toAccountInput = response.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
          vm.tempForpObj.recipientAccountInput = response.toAccountNumber;
          //vm.payeeSearchFilter = response.receiverName;
          vm.tempForpObj.receiversNameInput = response.receiverName;
          vm.tempForpObj.receiversAddressInput = response.receiverAddress1;
          vm.tempForpObj.paymentPurposeInput = response.purpose;
          vm.tempForpObj.fullNameCompanyInput = response.payeeName || '';
          vm.tempForpObj.recipientAddressInput = response.payeeAddress1 || '';
          vm.tempForpObj.recipientCityInput = response.payeeCity || '';
          vm.tempForpObj.bankAddressInput = response.beneficiaryBankAddress;
          vm.tempForpObj.bankCityInput = response.beneficiaryBankCity;
          vm.tempForpObj.bankNameInput = response.beneficiaryBankName;
          vm.tempForpObj.modalityCode = response.modalityCode;
          vm.tempForpObj.bankChargesRadiobutton.type = response.paymentCharges || '0';
          vm.tempForpObj.recipientStatusRadiobutton.type = response.payeeLegalForm || '2';
          vm.tempForpObj.beneficiarySWIFTCode = response.beneficiarySWIFTCode;
          vm.tempForpObj.receiversPostalCodeAndCityInput = response.receiverCity;
          vm.tempForpObj.receiversCountry = _.findWhere(vm.bankCountries, {code: response.receiverCountryCode});
//            vm.bicCodeSearchFilter = response.beneficiarySWIFTCode;
          loadAccountData(response.accountId);
          // vm.setChargeAccount(vm.tempForpObj.fromAccountSelect);

          vm.paymentResponse.id = paymentId;
          if ($state.params.editable)
            vm.forUpdate = true;

          if ($state.params.myParam == 'repeatCancelled') {
            vm.tempForpObj.dueDateInput = new Date(response.dueDate);
            vm.disableAllFields = true;
            vm.disableAllFieldsForProcessedPayment = true;
//select total currency based on response.currencySymbol not on fromAccount.currencySymbol
            if(response.currencySymbol) vm.tempForpObj.totalAmountCurrency = response.currencySymbol;
          }
          if($state.params.myParam == 'changeProcessed'){
            vm.tempForpObj.dueDateInput = new Date(response.dueDate);
            vm.disableAllFields = true;
            vm.disableAllFieldsForProcessedPayment = false;
//select total currency based on response.currencySymbol not on fromAccount.currencySymbol
            if(response.currencySymbol) vm.tempForpObj.totalAmountCurrency = response.currencySymbol;
          }

        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }


    function getUserSettingsPage() {
      UserSettingsService.getPage({page: 0, pageSize: 1000})
        .then(function (response) {
          var userSettings = response.result[0];
          vm.tempForpObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
          vm.tempForpObj.payersAddressInput = userSettings.address1;
          vm.tempForpObj.payersCityInput = userSettings.city;
        })
        .catch(function (error) {
          $log.error(error);
        });
    }

    function getCountries() {
      return CountriesService.getPage({page: 0, pageSize: 1000})
        .then(function (response) {
          vm.bankCountries = response.result;
          vm.bankCountries.unshift({
            code: " ",
            countryCode: " ",
            countryCodeShort: " ",
            description: "internationalPayment.chooseCountry"
          });
          vm.tempForpObj.receiversCountry = vm.bankCountries[0];
        })
        .catch(function (error) {
          $log.error(error);
        });
    }

    function getDebitAccountList() {
      return PaymentTypesService.getByGroup({paymentTypeGroup: 'ForeignPayment'})
        .then(function (response) {
          if (_.isArray(response.result) && response.result.length > 0) {
            vm.accountsFrom = response.result[0].debitAccountList;
            _.forEach(vm.accountsFrom, function (item) {
              if (item.accountDescription) {
                item.optionValue = item.accountDescription + ' - ' + item.iban;
              }
            });
          }
        })
        .catch(function (error) {
          $log.error(error);
        });
    }

    function getPayees() {
      var paymentParams = {
        paymentTypeGroup: 'ForeignPayment',
        orderBy: 'receiverName ASC',
        page: 0,
        pageSize: 1000
      };

      PaymentTemplatesService.getPage(paymentParams)
        .then(function (response) {
          vm.payeeList = response.result;
          if ($state.params && $state.params.templateId) {
            vm.selectTemplate($state.params.templateId);
          }
        }).catch(function (error) {
        $log.error(error);
      });
    }


    function createPaymentObject() {
      var paymentObject = {};
      paymentObject.accountId = vm.tempForpObj.fromAccountSelect.accountId;
      paymentObject.fromAccountNumber = vm.tempForpObj.fromAccountSelect.iban;

      paymentObject.toAccountNumber = (vm.tempForpObj.toAccountInput) ? vm.tempForpObj.toAccountInput.replace(/\s/g, '') : "";
      paymentObject.currencySymbol = vm.tempForpObj.totalAmountCurrency;
      paymentObject.purpose = vm.tempForpObj.paymentPurposeInput;
      paymentObject.dueDate = vm.tempForpObj.dueDateInput;
      paymentObject.amount = vm.tempForpObj.amountInput;
      paymentObject.paymentTypeGroup = 'ForeignPayment';
      paymentObject.foreignPayment = {
        receiverName: vm.tempForpObj.receiversNameInput,
        receiverAddress1: vm.tempForpObj.receiversAddressInput,
        receiverCity: vm.tempForpObj.receiversPostalCodeAndCityInput,
        receiverCountryCode: vm.tempForpObj.receiversCountry.code,
        senderName: vm.tempForpObj.fromAccountSelect.ownerName,
        senderAddress1: vm.tempForpObj.fromAccountSelect.ownerAddress,
        senderCity: vm.tempForpObj.fromAccountSelect.ownerCity,
        beneficiarySWIFTCode: vm.tempForpObj.beneficiarySWIFTCode,
        beneficiaryBankName: vm.tempForpObj.bankNameInput,
        beneficiaryBankAddress: vm.tempForpObj.bankAddressInput,
        beneficiaryBankCity: vm.tempForpObj.bankCityInput,
        beneficiaryBankCountryCode: vm.tempForpObj.bankCountrySelect.code,
        beneficiaryBankCountry: vm.tempForpObj.bankCountrySelect.description,
        //beneficiaryBankCountry: "",
        foreignBankAddress3: "",
        //TODO: Seems like recieverCountryCode selects first country from the list of countries and there is no way to choose one - but is required by backend!!!!!
        //receiverCountryCode: vm.tempForpObj.bankCountrySelect.code,
        //referenceFrom: null,
        referenceTo: null,
        // need to add field on payment form
        chargeAccount: (vm.tempForpObj.bankChargesRadiobutton.type != 2) ? vm.tempForpObj.chargeAccountInput.accountNumber + ' ' + vm.tempForpObj.chargeAccountInput.currencySymbol : "",
        payeeLegalForm: vm.tempForpObj.recipientStatusRadiobutton.type,
        paymentCharges: vm.tempForpObj.bankChargesRadiobutton.type,
        // paymentUsedMode: vm.tempForpObj.paymentUsedMode
        modalityCode: vm.tempForpObj.modalityCode
      };

      if($state.params.myParam == 'changeProcessed'){
        paymentObject.relatedSourceType = 'ChangePayment';
      }

      return paymentObject;
    }

    // ======================================
    // =          Public methods            =
    // ======================================

//    vm.getBankInfo = function () {
//      BicBanksService.getByIban(vm.tempForpObj.recipientAccountInput)
//          .then(function (response) {
//            if (_.isArray(response.result) && response.result.length > 0) {
//              vm.tempForpObj.bankNameInput = response.result[0].institutionName;
//              vm.tempForpObj.bankCityInput = response.result[0].city;
//              vm.tempForpObj.swiftCodeInput = response.result[0].swiftCode;
//            }
//          })
//          .catch(function (error) {
//            HelperService.showMessage(error, 'error');
//          });
//    };

    vm.toggleFilterSelection = function () {
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    vm.searchPayee = function () {
      vm.searchFilterExpanded = true;
    };

    vm.selectPayee = function (id) {
      // var item = _.findWhere(vm.payeeList, {
      //   id: id
      // });
      vm.selectTemplate(id);
      PaymentTemplatesService.getById(id);
        // .then(function (item) {
        //   vm.tempForpObj.toAccountInput = item.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
        //   vm.tempForpObj.receiversAddressInput = item.receiverAddress1;
        //   vm.tempForpObj.receiversNameInput = item.receiverName;
        //   vm.tempForpObj.receiversPostalCodeAndCityInput = item.receiverCity;
        //   /*if(item.amount)
        //    vm.tempForpObj.amountInput = $filter('number')(item.amount, 2);*/
        //   // vm.tempForpObj.recipientCountrySelect.countryCode = item.receiverCountryCode;
        //   var country = _.findWhere(vm.countriesOptions, {
        //     code: item.receiverCountryCode
        //   });
        //   if (country) {
        //     vm.onCountrySelect(country);
        //   }
        //
        //   // Bind to BIC
        //   vm.getBicByIban(vm.tempForpObj.toAccountInput);
        //
        //   vm.tempForpObj.receiversNameInput = item.receiverName;
        //   vm.searchFilterExpanded = !vm.searchFilterExpanded;
        // });
    };

    vm.removeSearch = function () {
      vm.tempForpObj.receiversNameInput = '';
      vm.tempForpObj.toAccountInput = '';
      vm.tempForpObj.receiversAddressInput = '';
      vm.tempForpObj.receiversPostalCodeAndCityInput = '';
      // vm.tempForpObj.swiftCodeInput = "";
      // vm.tempForpObj.bankAddressInput = "";
      // vm.tempForpObj.bankCityInput = "";
      // vm.tempForpObj.bankNameInput = "";
      // vm.countrySearchFilter = '';
      // vm.bicCodeSearchFilter = '';
      // Bank remove ?
    };

    vm.searchPayeeBy = function (searchrow) {
      return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.tempForpObj.receiversNameInput) || '') !== -1 ||
      angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.tempForpObj.receiversNameInput) || '') !== -1);
    };


    /*
     * START: SELECT FROM TEMPLATE - METHODS
     */
    vm.searchTemplate = function () {
      vm.searchTemplateFilterExpanded = true;
      if (vm.searchTemplateFilterExpanded === true) {
        $timeout(function () {
          var searchTemplatesInput = angular.element('#searchTemplatesInput');
          searchTemplatesInput.focus();
        }, 500);
      }
    };

    vm.toggleTemplateFilterSelection = function () {
      getPaymentTemplatesPage();
      vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
    };

    function getPaymentTemplatesPage() {
      var templatesParams = {
        paymentTypeGroup: 'ForeignPayment',
        page: 0,
        pageSize: 1000
      };

      PaymentTemplatesService.getPage(templatesParams)
        .then(function (response) {
          vm.templateList = response;
          if (vm.templateList)
            populateTemplatesWithImages();
          $log.debug(vm.templateList);
        }).catch(function (error) {
        $log.error(error);
      });
    }

    var populateTemplatesWithImages = function () {
      if (vm.images && vm.images.length > 0) {
        _.forEach(vm.templateList.result, function (template) {

          if (template.imageId) {
            var imageObject = _.find(vm.images, function (image) {
              return image.id === template.imageId;
            });
            if (imageObject)
              template.imageDownloadLink = imageObject.downloadLink;
          }

          if (!template.imageId || !template.imageDownloadLink) {
            template.imageId = vm.images[0].id;
            template.imageDownloadLink = vm.images[0].downloadLink;
          }

        });
      }
    };

    vm.selectedTemplate = {};
    vm.selectTemplate = function (id) {
      PaymentTemplatesService.getById(id)
        .then(function (response) {
          var item = response;
          loadAccountData(item.accountId);
          // vm.tempForpObj.amountInput = item.amount;
          vm.tempForpObj.toAccountInput = item.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
          vm.tempForpObj.receiversAddressInput = item.receiverAddress1;
          vm.tempForpObj.receiversNameInput = item.receiverName;
          vm.tempForpObj.receiversPostalCodeAndCityInput = item.receiverCity;
          vm.tempForpObj.paymentPurposeInput = item.purpose;

          // Populate BIC fields from template
          if (item.beneficiarySWIFTCode) {
            vm.tempForpObj.beneficiarySWIFTCode = item.beneficiarySWIFTCode;
          } else {
            vm.getBicByIban(vm.tempForpObj.toAccountInput);
          }
//            vm.bicCodeSearchFilter = item.beneficiarySWIFTCode;
          vm.tempForpObj.bankAddressInput = item.beneficiaryBankAddress;
          vm.tempForpObj.bankCityInput = item.beneficiaryBankCity;
          vm.tempForpObj.bankNameInput = item.beneficiaryBankName;
          vm.tempForpObj.modalityCode = item.modalityCode;
          vm.tempForpObj.bankChargesRadiobutton.type = item.paymentCharges || '0';
          vm.tempForpObj.recipientStatusRadiobutton.type = item.payeeLegalForm || '2';

          var bankCountry = _.findWhere(vm.bankCountries, {code: item.beneficiaryBankCountryCode});
          vm.tempForpObj.receiversCountry = (bankCountry) ? bankCountry : vm.bankCountries[0];

          var country = _.findWhere(vm.countriesOptions, {
            code: item.beneficiaryBankCountryCode
          });
          if (country) {
            console.log(country);
            vm.onCountrySelect(country);
          }
          vm.templateName = item.name;
          //vm.payeeSearchFilter = item.receiverName;
          vm.tempForpObj.receiversNameInput = item.receiverName;
          vm.searchFilterExpanded = !vm.searchFilterExpanded;
          vm.searchFilterExpanded = false;
          vm.searchTemplateFilterExpanded = false;
          vm.bicCodeDisabled = false;
          vm.isFromTemplate = true;

          vm.selectedTemplate.imageId = item.imageId;
          setImage(vm.selectedTemplate);

        }, function (error) {
          AlertService.infoAlert({text: "Loading from template #" + id + " failed!"});
        });
    };

    var setImage = function (selectedTemplate) {
      if (vm.images && vm.images.length > 0) {
        if (selectedTemplate.imageId) {
          var imageObject = _.find(vm.images, function (image) {
            return image.id === selectedTemplate.imageId;
          });
          if (imageObject)
            selectedTemplate.imageDownloadLink = imageObject.downloadLink;
        }

        if (!selectedTemplate.imageId || !selectedTemplate.imageDownloadLink) {
          selectedTemplate.imageId = vm.images[0].id;
          selectedTemplate.imageDownloadLink = vm.images[0].downloadLink;
        }
      }
    };

    vm.removeTemplate = function () {
      vm.searchTemplateFilterExpanded = false;
      vm.templateName = '';
      //vm.payeeSearchFilter = '';
      vm.tempForpObj.receiversNameInput = '';
      vm.countrySearchFilter = '';
      vm.bicCodeSearchFilter = '';
      vm.tempForpObj.swiftCodeInput = "";
      vm.tempForpObj.bankAddressInput = "";
      vm.tempForpObj.bankCityInput = "";
      vm.tempForpObj.bankNameInput = "";
      vm.tempForpObj.beneficiarySWIFTCode = "";
      vm.tempForpObj.paymentPurposeInput = "";
      vm.tempForpObj.receiversCountry = vm.bankCountries[0];
      // vm.tempForpObj = {};
      vm.tempForpObj.toAccountInput = '';
      vm.tempForpObj.receiversAddressInput = '';
      vm.tempForpObj.receiversPostalCodeAndCityInput = '';
      vm.tempForpObj.amountInput = '';
      vm.isFromTemplate = false;
      vm.bicCodeDisabled = false;
      vm.selectedTemplate = '';
    };
    /*
     * END: SELECT FROM TEMPLATE - METHODS
     */

    var fillReceiversInput = function (response) {
      if (response.result.length > 0) {
        vm.tempForpObj.receiversNameInput = response.result[0].receiverName;
        //vm.payeeSearchFilter = response.result[0].receiverName;
        vm.tempForpObj.receiversAddressInput = response.result[0].receiverAddress1;
        vm.tempForpObj.receiversPostalCodeAndCityInput = response.result[0].receiverCity;
        // TODO: Populate bic number (currently request returns nothing)
      }
    };

    vm.fillReceiver = function (toAccountInput) {
      if (!toAccountInput)
        return;
      toAccountInput = toAccountInput.replace(/\s/g, '');
      if (toAccountInput.substring(0, 2) === 'HR') {
        CreditAccountRegisterService.getByIban(toAccountInput)
          .then(function (response) {
            fillReceiversInput(response);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      } else {
        CreditAccountRegisterService.getPage({
          accountNumber: toAccountInput
        })
          .then(function (response) {
            fillReceiversInput(response);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    vm.editPayment = function () {
      vm.forUpdate = true;
      vm.steps = {
        step1: true,
        step2: false,
        step3: false
      };
    };



    var loadAccountData = function (accountId) {
      var fromAccount = _.find(vm.accountsFrom, function (item) {
        return item.accountId == accountId;
      });
      vm.tempForpObj.fromAccountSelect = fromAccount;
      vm.setChargeAccount(fromAccount);
    };

    vm.addSpaceForIban = function (toAccountInput) {
      if (!vm.tempForpObj.toAccountInput)
        return;
      //vm.tempForpObj.toAccountInput = toAccountInput.replace(/[^\dA-Z-/]/g, '').replace(/(.{4})/g, '$1 ').trim();
      validateIBANLength();
    };

    function validateIBANLength () {
      var ibanSI56 = vm.tempForpObj.toAccountInput.substring(0, 4);
      var ibanLength = vm.tempForpObj.toAccountInput.length;
      // var spaceNumber = Math.floor(ibanLength / 4);
      if (ibanSI56 == "SI56") {
        if(ibanLength < 19) {
          vm.uiMask =  ValidationService.getUiMask().sl.internationalSI;
          vm.paymentForm.toAccountInput.$setValidity("minlength", false);
        } else {
          vm.paymentForm.toAccountInput.$setValidity("minlength", true);
        }
        // vm.ibanMaxlength = 19 + spaceNumber;
        vm.ibanMaxlength = 19;
      } else {
        vm.uiMask =  ValidationService.getUiMask().sl.international;
        vm.paymentForm.toAccountInput.$setValidity("minlength", true);
        // vm.ibanMaxlength = 34 + spaceNumber;
        vm.ibanMaxlength = 34;
      }
    }

    vm.getBicByIban = function (iban) {
      if (!iban) {
        vm.bicCodeDisabled = false;
        vm.tempForpObj.beneficiarySWIFTCode = '';
        return;
      }

      iban = iban.replace(/\s/g, '');
      PaymentsService.getBicBanks(undefined, {
        iban: iban,
        paymentTypeGroup: 'ForeignPayment'
      })
        .then(function (response) {
          var bicBank = response.result[0];
          if (bicBank && bicBank.bicCode) {
            vm.tempForpObj.beneficiarySWIFTCode = bicBank.bicCode;
            vm.bicCodeDisabled = true;
          } else {
            vm.bicCodeDisabled = false;
            vm.tempForpObj.beneficiarySWIFTCode = '';
          }
        })
        .catch(function (error) {
          HelperService.showMessage(response, 'error');
          vm.bicCodeDisabled = false;
          vm.tempForpObj.beneficiarySWIFTCode = '';
        });
    };

    vm.checkCountryAndSymbol = function () {
      var code = vm.tempForpObj.bankCountrySelect.code;
      var symbol = vm.tempForpObj.totalAmountCurrency;
      if (!code) {
        vm.EUCountrySelected = false;
      }
      if (!symbol) {
        vm.EUSymbolSelected = false;
      }
      if(!code || !symbol)
        return;

      PaymentsService.getCountries(false,{countryCode: code})
        .then(function (response) {
          var country = response.result[0] || false;
          if (country.countryIsEgp) {
            vm.EUCountrySelected = true;
            PaymentsService.getCountries(false,{countryCurrencySymbol: symbol})
              .then(function (response) {
                var result = response.result;
                var symbolCountry = result[0] || false;
                if(symbolCountry.countryIsEgp){
                  // Disable Charge option if EU country is selected because option must be "SHA"
                  vm.tempForpObj.bankChargesRadiobutton.type = '0';
                  vm.EUSymbolSelected = true;
                }
                else
                  vm.EUSymbolSelected = false;
              })
              .catch(function (error) {
                HelperService.showMessage(response, 'error');
              });

          } else {
            vm.EUCountrySelected = false;
          }
        })
        .catch(function (error) {
        HelperService.showMessage(response, 'error');
      });
    };

    vm.newPayment = function () {
      $state.go('payments.internationalPayment', {}, {reload: true})
    };

    vm.removeBicCodeSearch = function () {
      vm.bicCodeSearchFilter = "";
      vm.tempForpObj.swiftCodeInput = "";
      vm.tempForpObj.bankAddressInput = "";
      vm.tempForpObj.bankCityInput = "";
      vm.tempForpObj.bankNameInput = "";
    };

    /*
     * Countries selectbox - on list click
     * */
    vm.onCountrySelect = function (country) {
      console.log(country);
      vm.countrySearchFilter = country.code + " " + country.description;
      vm.tempForpObj.bankCountrySelect = country;
      vm.countrySearchFilterExpanded = false;

      vm.checkCountryAndSymbol();
      // if (country.countryUnion == "EU") {
      //   vm.EUCountrySelected = true;
      //   // Disable Charge option if EU country is selected because option must be "SHA"
      //   vm.tempForpObj.bankChargesRadiobutton.type = '0';
      // } else {
      //   vm.EUCountrySelected = false;
      // }
    };

    /*
     * Countries selectbox - remove
     * */
    vm.removeSelectedCountry = function () {
      vm.countrySearchFilter = "";
      vm.tempForpObj.bankCountrySelect = {};
      vm.countrySearchFilterExpanded = true;
      vm.EUCountrySelected = false;
      vm.EUSymbolSelected = false;
    };

    // ======================================
    // =          Button methods            =
    // ======================================

    vm.submitInternationalPayment = function (event) {
      // Check if form is valid
      vm.tempForpObj.formSubmitted = true;
      if (!vm.paymentForm.$valid) {
        return false;
      }

      // If form is valid create object for update
      var paymentObject = createPaymentObject();

      // If selected country has amlControl call statement confirmation modal
      if (vm.tempForpObj.bankCountrySelect.amlControl) {
        // PaymentsService.openStatementConfirmModal(vm.tempForpObj.bankCountrySelect)
        PaymentsService.openStatementConfirmModal(vm.tempForpObj)
          .result.then(function (result) {
          // Add more information to payment object
          if (!result)
            return;
          else {
            paymentObject.foreignPayment.beneficiaryBankCountry = result.stateOption;
            paymentObject.foreignPayment.foreignBankAddress3 = result.information;
          }
          upsertInternationalPayment(paymentObject);

        });
        return;
      }

      upsertInternationalPayment(paymentObject);
    };

    function upsertInternationalPayment(paymentObject) {
      if (vm.nextButtonPressed) return;

      if (!vm.formSubmitted) {
        vm.formSubmitted = true;

        vm.nextButtonPressed = true;
        if (vm.forUpdate) {
          paymentObject.id = vm.paymentResponse.id;
          PaymentsService.updatePayment(vm.paymentResponse.id, paymentObject)
            .then(function (response) {
              postPaymentAction(response);
            })
            .catch(function (response) {
              if (response.hasWarnings && response.resultList[0].key == 'ToAccountNumber') {
                //show action message modal
                PaymentsService.showModalWithActions(response, paymentObject);
              }
              else {
                HelperService.showMessage(response, 'error');
              }
            })
            .finally(function () {
              vm.forUpdate = false;
              vm.formSubmitted = false;
              vm.nextButtonPressed = false;
            });
        } else {

          var insertedDueDate = paymentObject.dueDate;

          PaymentsService.insertPayment(paymentObject)
            .then(function (response) {
              var validatedDueDate = new Date(response.dueDate);
              if (response.dueDateChanged) {
                AlertService.confirmationAlert({text: "payments.paymentDueDateChangedMsg"})
                  .then(function (accept) {
                    if (!accept) return;
                    secondValidate(response);
                  })
              } else {
                postPaymentAction(response);
              }
            })
            .catch(function (response) {

              if (response.hasWarnings) {
                //show action message modal
                PaymentsService.showModalWithActions(response, paymentObject);
              }
              else {
                HelperService.showMessage(response, 'error');
              }
            })
            .finally(function () {
              vm.formSubmitted = false;
              vm.nextButtonPressed = false;
            });

        }

      }
    };

    function secondValidate(validatedUPOrder) {
      if (vm.secondValidateInProgress) return;
      vm.secondValidateInProgress = true;
      PaymentsService.insertPayment(validatedUPOrder)
        .then(function (response) {
          postPaymentAction(response);
        })
        .catch(function (response, error) {
          if (response && response.hasWarnings) {
            //show action message modal
            PaymentsService.showModalWithActions(response, objectForInsert);
          } else {
            HelperService.showMessage(response, 'error');
          }
        })
        .finally(function () {
          vm.formSubmitted = false;
          vm.forUpdate = false;
          vm.nextButtonPressed = false;
          vm.secondValidateInProgress = false;
        });
    }

    var sendRequestOTP = function () {
      //TODO: Implementation
    };

    vm.sign = function () {
      if (vm.requestOtpInput)
        vm.paymentResponse.signData = vm.requestOtpInput;
      else
        vm.paymentResponse.signData = '';

      if (vm.actionLinks.sign) {
        $http.post(vm.actionLinks.sign, vm.paymentResponse)
          .then(function (response) {
            vm.insertedPaymentObject = response.data;
            $state.go('payments.finalStep', {
              paymentId: vm.insertedPaymentObject.id,
              paymentObject: vm.insertedPaymentObject,
              type: 'international',
              isFromTemplate: vm.isFromTemplate
            });
            //vm.currentStep = 3;
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          })
          .finally(function () {
            vm.formSubmitted = false;
            vm.forUpdate = false;
            vm.signLink = null;
          });
      }
    };
    // var showModalWithActions = function (msg,paymentObject) {
    //   vm.msg = msg;
    //     var modalInstance = $uibModal.open({
    //       templateUrl: 'payments/change-payment-modal.tpl.html',
    //       backdrop: 'static',
    //       size: 'lg',
    //       scope: $scope
    //     })
    //       .result
    //       .then(function(result){
    //         console.log(result);
    //         if(result == "yes") {
    //           $state.go('payments.domesticPayment.fromInternational', {transactionDetails: paymentObject});
    //         };
    //       });
    //   };
    function postPaymentAction(response) {
      vm.paymentResponse = response;
      vm.tempForpObj.dueDateInput = new Date(response.dueDate);
      vm.paymentResponse.dueDate = new Date(response.dueDate);
      vm.paymentResponse.paymentTypeGroup = 'ForeignPayment';

      if (response.foreignPayment.receiverCountryCode) {
        var recCountry = _.findWhere(vm.countriesOptions, {
          code: response.foreignPayment.receiverCountryCode
        });
        if (recCountry) {
          vm.paymentResponse.foreignPayment.receiverCountry = recCountry.description;
        }
      }

      switch (response.paymentCharges) {
        case "1":
          vm.paymentResponse.bankCharges = "Payers pays charges";
          break;
        case "2":
          vm.paymentResponse.bankCharges = "Beneficiary pays charges";
          break;
        case "3":
          vm.paymentResponse.bankCharges = "Shared charges";
          break;
      }

      var country = _.findWhere(vm.countriesOptions, {
        code: vm.paymentResponse.beneficiaryBankCountryCode
      });
      if (country) {
        vm.paymentResponse.beneficiaryBankCountryCode = country.code + " " + country.description;
      }

      vm.paymentResponse.payeeListId = vm.tempForpObj.recipientStatusRadiobutton.type;
      vm.steps = {
        step1: false,
        step2: true,
        step3: false
      };
    }

    vm.deletePayment = function () {
      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            PaymentsService.deletePayment(vm.paymentResponse.id)
              .then(function (response) {
                AlertService.deletedPaymentAlert({paymentName: vm.paymentResponse.id, type: 'payment'})
                  .then(function () {
                    $state.go('payments.paymentsOverview');
                  });
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });
    };

    vm.signOrFinishPayment = function () {

      var ibanInTemplates =  vm.isFromTemplate || !_.every(vm.templateList.result, function (item) {
          return item.toAccountNumber.replace(/ /g, '') !== vm.tempForpObj.toAccountInput.replace(/ /g, '');
        });

      if($state.params.myParam === 'changeProcessed' && ibanInTemplates){
        updatePayment();
        return;
      }

      if (vm.paymentResponse.linkList && vm.paymentResponse.linkList.itemList && vm.paymentResponse.linkList.itemList.requestOTP) {

        //TSK-114327
        if($state.params.paymentId && $state.params.myParam && $state.params.myParam === 'changeProcessed')
          vm.paymentResponse.paymentIdTemp = $state.params.paymentId;

        $state.go("payments.sign", {
          payment: vm.paymentResponse,
          paymentId: vm.paymentResponse.id,
          type: 'international'
        });
        return;
      }
      // When I make UPN from template, the additional page should not be displayed. (Sign page should not be there)
      // When I make UPN to account, not saved in templates and is outsite Addiko bank, the additional page for OTP confirmation should appear.
      // When I make UPN to internal (SI5633) Addiko bank account of the company, the additional page for OTP confirmation should appear.
      // _.every Returns true if all of the values in the list pass the predicate truth test. Short-circuits and stops traversing the list if a false element is found.
      if (vm.isFromTemplate || !_.every(vm.templateList.result, function (item) {
          return item.toAccountNumber.replace(/ /g, '') != vm.tempForpObj.toAccountInput.replace(/ /g, '')
        })) {
        signPayment();
      } else {

        //TSK-114327
        if($state.params.paymentId && $state.params.myParam && $state.params.myParam === 'changeProcessed')
          vm.paymentResponse.paymentIdTemp = $state.params.paymentId;

        $state.go("payments.sign", {
          payment: vm.paymentResponse,
          paymentId: vm.paymentResponse.id,
          type: 'international'
        });
      }
    };

    function updatePayment() {
      if (vm.signPaymentInProgress) return;
      var params = {
        id: $state.params.paymentId,
        payment: vm.paymentResponse
      };
      vm.signPaymentInProgress = true;
      PaymentsService.updatePayment(params.id, params.payment, 'changeProcessed')
        .then(function (signedPayment) {
          $state.go('payments.finalStep', {
            paymentObject: signedPayment.payment || signedPayment,
            paymentId: signedPayment.id,
            type: "international"
          });
        })
        .catch(function (response, error) {
          if (response && response.hasWarnings) {
            //show action message modal
            PaymentsService.showModalWithActions(response, objectForInsert);
          } else {
            HelperService.showMessage(response, 'error');
          }
        })
        .finally(function () {
          vm.formSubmitted = false;
          vm.forUpdate = false;
          vm.signPaymentInProgress = false;
        });


    }

    function signPayment() {
      if (vm.signPaymentInProgress) return;
      var params = {
        id: vm.paymentResponse.id,
        payment: vm.paymentResponse
      };
      params.payment.signData = "";

      vm.signPaymentInProgress = true;
      PaymentsService.signPayment(params).then(function (signedPayment) {
        $state.go('payments.finalStep', {
          paymentObject: signedPayment.payment || signedPayment,
          paymentId: signedPayment.id,
          type: "international",
          isFromTemplate: vm.isFromTemplate
        });
      }).catch(function (error) {
        $log.error(error);
        if (error && error.resultList[0] && error.resultList[0].key === 'CUTOFF') {
          signLastPayment(error.resultList[0].description, params);
        } else if (error && error.resultList[0] && error.resultList[0].key === 'UpdateOldDate') {
          openUpdateSinglePaymentDueDateModal(params);
        } else {
          HelperService.showMessage(error, 'error');
        }
      }).finally(function() {
        vm.signPaymentInProgress = false;
      });
    }

    vm.checkToAccountInputLength = function () {
      var validLength = true;
      if (vm.tempForpObj.beneficiarySWIFTCode) {
        if (vm.tempForpObj.beneficiarySWIFTCode.length == 8 || vm.tempForpObj.beneficiarySWIFTCode.length == 11) {
          validLength = true;
        } else {
          validLength = false;
        }
      }
      vm.paymentForm.bicAddress.$setValidity('properLength', validLength);
    };

    vm.goBack = function () {
      $state.go('payments.paymentsOverview');
    };

    vm.templateImagesFilter = {
      category: "Templates"
    };
    var loadImages = function () {
      return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
        if (images)
          vm.images = images.result;
      }).catch(function (err) {
        $log.error(err);
      });
    };

    init();

  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:InternationalPaymentCtrl
     *
     * @description
     *
     */
    InternationalPaymentCroCtrl.$inject = ["$rootScope", "$location", "CTLocalizationService", "UserSettingsService", "$state", "$log", "PurposeCodesService", "BanksService", "BicBanksService", "CountriesService", "PaymentTypesService", "PaymentsService", "HelperService", "$q", "$timeout", "PaymentTemplatesService", "ValidationService", "CreditAccountRegisterService", "AlertService", "GoogleTagManagerHelperService"];
    angular
        .module('payments')
        .controller('InternationalPaymentCroCtrl', InternationalPaymentCroCtrl);

    function InternationalPaymentCroCtrl($rootScope, $location, CTLocalizationService, UserSettingsService, $state, $log, PurposeCodesService, BanksService, BicBanksService, CountriesService,
        PaymentTypesService, PaymentsService, HelperService, $q, $timeout, PaymentTemplatesService, ValidationService, CreditAccountRegisterService, AlertService, GoogleTagManagerHelperService) {
        var vm = this;

        vm.paymentResponse = {};

        vm.purposeCodesFilter = {
            page: 0,
            pageSize: 1000
        };

        vm.countriesFilter = {
            page: 0,
            pageSize: 1000
        };

        vm.payeeFilter = {
            paymentTypeGroup: 'ForeignPayment',
            orderBy: 'receiverName ASC',
            page: 0,
            pageSize: 1000
        };

        vm.templateName = '';
        vm.templatesFilter = {
            paymentTypeGroup: 'ForeignPayment',
            page: 0,
            pageSize: 1000
        };

        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
        vm.uiMaskOptions = ValidationService.getUiMaskOptions().international.iban;
        console.log(vm.regexPatterns);
        vm.tempForpObj = {
            payersNameInput: '',
            payersAddressInput: '',
            payersCityInput: '',
            fromAccountSelect: {},
            amountInput: '',
            dueDateInput: new Date(),
            paymentPurposeInput: '',
            paymentMode: '',
            purposeCodeSelect: {},
            recipientStatusRadiobutton: {
                type: '2'
            },
            fullNameCompanyInput: '',
            recipientAddressInput: '',
            recipientCityInput: '',
            recipientCountrySelect: {},
            recipientAccountInput: '',
            bankNameInput: '',
            bankAddressInput: '',
            bankCityInput: '',
            bankCountrySelect: {},
            swiftCodeInput: '',
            bankChargesRadiobutton: {
                type: '3'
            },
            chargeAccountInput: '',
            formSubmitted: false,
            receiversSepaInput1: '',
            receiversSepaInput2: '',
            payersSepaInput1: '',
            payersSepaInput2: '',
            recieverType: '', // Primatelj (osoba)
            spentOption: '' // Tro�kovna opcija
        };

        vm.forUpdate = false;

        vm.datePickerOpened = false;

        vm.goBack = function () {
            $state.go('payments.paymentsOverview');
        };

        vm.dateOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        vm.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        vm.steps = {
            step1: true,
            step2: false,
            step3: false
        };

        vm.goBack = function () {
            $state.go('payments');
        };


        vm.getUserSettingsPage = function () {

            UserSettingsService.getPage(vm.userSettingsFilter)
                .then(function (response) {
                    var userSettings = response.result[0];
                    vm.tempForpObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                    vm.tempForpObj.payersAddressInput = userSettings.address1;
                    vm.tempForpObj.payersCityInput = userSettings.city;


                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.loadPurposeCode = function () {
            return PurposeCodesService.getPage(vm.purposeCodesFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        value.optionValue = value.id + ' - ' + value.description;
                    });
                    vm.purposeCodes = response.result;
                })
                .catch(function (error) {

                });
        };

        vm.loadCountries = function () {
            return CountriesService.getPage(vm.countriesFilter)
                .then(function (response) {
                    vm.bankCountries = response.result;
                })
                .catch(function () {

                });
        };

        vm.getDebitAccountList = function () {
            return PaymentTypesService.getByGroup({
                    paymentTypeGroup: 'ForeignPayment'
                })
                .then(function (response) {
                    if (_.isArray(response.result) && response.result.length > 0) {
                        vm.accountsFrom = response.result[0].debitAccountList;
                        _.forEach(vm.accountsFrom, function (item) {
                            if (item.accountDescription) {
                                item.optionValue = item.accountDescription + ' - ' + item.iban;
                            }
                        });
                    }
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.purposeCodeChange = function (purposeCode) {
            vm.tempForpObj.purposeCodeSelect = purposeCode;
            // vm.tempForpObj.paymentPurposeInput = purposeCode.description;
            var purpose = _.findWhere(vm.purposeCodes, {
                description: vm.tempForpObj.paymentPurposeInput
            });
            if (purpose) {
                vm.tempForpObj.paymentPurposeInput = purposeCode.description;
            }

            // var purposeCode = _.findIndex(vm.purposeCodes, function (item) {
            //   vm.tempForpObj.paymentPurposeInput = item.description;
            //   return item.id == code.id;
            // });
        };

        vm.openDatePicker = function () {
            vm.datePickerOpened = true;
        };

        vm.getBankInfo = function () {
            BicBanksService.getByIban(vm.tempForpObj.recipientAccountInput)
                .then(function (response) {
                    if (_.isArray(response.result) && response.result.length > 0) {
                        vm.tempForpObj.bankNameInput = response.result[0].institutionName;
                        vm.tempForpObj.bankCityInput = response.result[0].city;
                        vm.tempForpObj.swiftCodeInput = response.result[0].swiftCode;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        /////////////////////////////CUSTOM SELECT////////////////////////////

        vm.toggleFilterSelection = function () {
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.searchPayee = function () {
            vm.searchFilterExpanded = true;
        };

        vm.getPayees = function () {
            PaymentTemplatesService.getPage(vm.payeeFilter)
                .then(function (response) {
                    vm.payeeList = response.result;
                    if ($state.params && $state.params.templateId) {
                        vm.selectTemplate($state.params.templateId);
                    }
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.selectPayee = function (id) {
            var item = _.findWhere(vm.payeeList, {
                id: id
            });
            vm.tempForpObj.toAccountInput = item.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
            vm.tempForpObj.receiversAddressInput = item.receiverAddress1;
            vm.tempForpObj.receiversNameInput = item.receiverName;
            vm.tempForpObj.receiversPostalCodeAndCityInput = item.receiverCity;
            /*if(item.amount)
              vm.tempForpObj.amountInput = $filter('number')(item.amount, 2);*/
            // vm.tempForpObj.recipientCountrySelect.countryCode = item.receiverCountryCode;
            var country = _.findWhere(vm.countriesOptions, {
                code: item.receiverCountryCode
            });
            if (country) {
                vm.onCountrySelect(country);
            }

            // Bind to BIC
            vm.getBicByIban(vm.tempForpObj.toAccountInput);

            vm.tempForpObj.receiversNameInput = item.receiverName;
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.removeSearch = function () {
            vm.tempForpObj.receiversNameInput = '';
            vm.tempForpObj.toAccountInput = '';
            vm.tempForpObj.receiversAddressInput = '';
            vm.tempForpObj.receiversPostalCodeAndCityInput = '';
            // vm.tempForpObj.swiftCodeInput = "";
            // vm.tempForpObj.bankAddressInput = "";
            // vm.tempForpObj.bankCityInput = "";
            // vm.tempForpObj.bankNameInput = "";
            // vm.countrySearchFilter = '';
            // vm.bicCodeSearchFilter = '';
            // Bank remove ?
        };

        vm.searchPayeeBy = function (searchrow) {
            return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.tempForpObj.receiversNameInput) || '') !== -1 ||
                angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.tempForpObj.receiversNameInput) || '') !== -1);
        };


        ////////////////select template component//////////////////////
        vm.searchTemplate = function () {
            vm.searchTemplateFilterExpanded = true;
            if (vm.searchTemplateFilterExpanded === true) {
                $timeout(function () {
                    var searchTemplatesInput = angular.element('#searchTemplatesInput');
                    searchTemplatesInput.focus();
                }, 500);
            }
        };

        vm.toggleTemplateFilterSelection = function () {
            vm.getPaymentTemplatesPage();
            vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
        };

        vm.getPaymentTemplatesPage = function () {
            PaymentTemplatesService.getPage(vm.templatesFilter)
                .then(function (response) {
                    vm.templateList = response;
                    $log.debug(vm.templateList);
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.selectTemplate = function (id) {
            GoogleTagManagerHelperService.pushEvent('InternationalPayment', 'PaymentTemplateSelection', 'Template with id ' + id + ' selected');
            var item = _.findWhere(vm.payeeList, {
                id: +id
            });
            loadAccountData(item.accountId);
            vm.tempForpObj.toAccountInput = item.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
            vm.tempForpObj.receiversAddressInput = item.receiverAddress1;
            vm.tempForpObj.receiversNameInput = item.receiverName;
            vm.tempForpObj.receiversPostalCodeAndCityInput = item.receiverCity;
            vm.tempForpObj.paymentPurposeInput = item.purpose;

            if (item.purposeCodeDPS && vm.purposeCodes.length > 0) {
                var index = _.findIndex(vm.purposeCodes, function (value) {
                    return value.id === item.purposeCodeDPS;
                });
                if (index && index != -1) {
                    vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[index];
                } else {
                    vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
                }
            }
            //vm.tempForpObj.amountInput = $filter('number')(item.amount, 2);
            // vm.tempForpObj.recipientCountrySelect.countryCode = item.receiverCountryCode;
            // Bind to BIC
            // vm.getBicByIban(vm.tempForpObj.toAccountInput);


            // Populate BIC fields from template
            vm.tempForpObj.swiftCodeInput = item.beneficiarySWIFTCode;
            vm.bicCodeSearchFilter = item.beneficiarySWIFTCode;
            vm.tempForpObj.bankAddressInput = item.beneficiaryBankAddress;
            vm.tempForpObj.bankCityInput = item.beneficiaryBankCity;
            vm.tempForpObj.bankNameInput = item.beneficiaryBankName;
            vm.tempForpObj.modalityCode = item.modalityCode;
            vm.tempForpObj.bankChargesRadiobutton.type = item.paymentCharges || '3';
            vm.tempForpObj.recipientStatusRadiobutton.type = item.payeeLegalForm || '2';

            var country = _.findWhere(vm.countriesOptions, {
                code: item.beneficiaryBankCountryCode
            });
            if (country) {
                console.log(country);
                vm.onCountrySelect(country);
            }
            vm.templateName = item.name;
            //vm.payeeSearchFilter = item.receiverName;
            vm.tempForpObj.receiversNameInput = item.receiverName;
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
            vm.searchFilterExpanded = false;
            vm.searchTemplateFilterExpanded = false;
        };

        vm.removeTemplate = function () {
            vm.searchTemplateFilterExpanded = false;
            vm.templateName = '';
            //vm.payeeSearchFilter = '';
            vm.tempForpObj.receiversNameInput = '';
            vm.countrySearchFilter = '';
            vm.bicCodeSearchFilter = '';
            vm.tempForpObj.swiftCodeInput = "";
            vm.tempForpObj.bankAddressInput = "";
            vm.tempForpObj.bankCityInput = "";
            vm.tempForpObj.bankNameInput = "";
            vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
            vm.tempForpObj.paymentPurposeInput = vm.purposeCodes[0].description;
            vm.tempForpObj.modalityCode = vm.paymentModeOptions[0];

            // vm.tempForpObj = {};
            vm.tempForpObj.toAccountInput = '';
            vm.tempForpObj.receiversAddressInput = '';
            vm.tempForpObj.receiversPostalCodeAndCityInput = '';
            vm.tempForpObj.amountInput = '';
        };

        var fillReceiversInput = function (response) {
            if (response.result.length > 0) {
                vm.tempForpObj.receiversNameInput = response.result[0].receiverName;
                //vm.payeeSearchFilter = response.result[0].receiverName;
                vm.tempForpObj.receiversAddressInput = response.result[0].receiverAddress1;
                vm.tempForpObj.receiversPostalCodeAndCityInput = response.result[0].receiverCity;
                // TODO: Populate bic number (currently request returns nothing)
            }
        };

        vm.fillReceiver = function (toAccountInput) {
            if (!toAccountInput) return;
            toAccountInput = toAccountInput.replace(/\s/g, '');
            if (toAccountInput.substring(0, 2) === 'HR') {
                CreditAccountRegisterService.getByIban(toAccountInput)
                    .then(function (response) {
                        fillReceiversInput(response);
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            } else {
                CreditAccountRegisterService.getPage({
                        accountNumber: toAccountInput
                    })
                    .then(function (response) {
                        fillReceiversInput(response);
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        /*      vm.signPayment = function () {
         PaymentsService.openSignModal(vm.paymentResponse.id)
         .then(function (signed) {
         if (signed) {
         vm.steps = {
         step1: false,
         step2: false,
         step3: true
         };
         }
         })
         .catch(function (error) {
         HelperService.showMessage(error, 'error');
         });
         };*/

        var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        $rootScope.$on('appLanguageChangedHeader', function () {
            sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        });

        vm.deletePayment = function () {
            //swal({
            //  title: sweetAlertOptions.areYouSure,
            //  type: "info",
            //  showCancelButton: true,
            //  confirmButtonClass: "btn-default",
            //  confirmButtonText: sweetAlertOptions.yes,
            //  cancelButtonText: sweetAlertOptions.no,
            //  closeOnConfirm: true,
            //  closeOnCancel: true
            //}, function (isConfirm) {
            //  if (isConfirm) {
            //    PaymentsService.deletePayment(vm.paymentResponse.id)
            //      .then(function (response) {
            //      HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], vm.paymentResponse.id);
            //      $state.go('payments.paymentsOverview');
            //    })
            //      .catch(function (error) {
            //      HelperService.showMessage(error, 'error');
            //    });
            //  }
            //});

            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        PaymentsService.deletePayment(vm.paymentResponse.id)
                            .then(function (response) {
                                AlertService.deletedPaymentAlert({
                                        paymentName: vm.paymentResponse.id,
                                        type: 'payment'
                                    })
                                    .then(function () {
                                        $state.go('payments.paymentsOverview');
                                    });
                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    }
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });
        };

        vm.editPayment = function () {
            vm.forUpdate = true;
            vm.steps = {
                step1: true,
                step2: false,
                step3: false
            };
        };

        vm.setChargeAccount = function (item) {
            vm.tempForpObj.fromAccountSelect = item;
            vm.tempForpObj.chargeAccountInput = item;
            vm.chargeAccountOptions = _.where(vm.accountsFrom, {
                iban: item.iban
            });
            console.log(vm.chargeAccountOptions);
        };


        vm.clearSepaReceiver = function (e) {
            vm.tempForpObj.receiversSepaInput1 = '';
            vm.tempForpObj.receiversSepaInput2 = '';
        };

        vm.clearSepaPayer = function () {
            vm.tempForpObj.payersSepaInput1 = '';
            vm.tempForpObj.payersSepaInput2 = '';
        };


        var loadAccountData = function (accountId) {
            var fromAccount = _.find(vm.accountsFrom, function (item) {
                return item.accountId == accountId;
            });
            vm.tempForpObj.fromAccountSelect = fromAccount;
        };

        //var loadPaymentDataFromTemplate = function (templateId) {
        //  if (templateId) {
        //    PaymentTemplatesService.getById(templateId)
        //      .then(function (response) {
        //      vm.tempForpObj.amountInput = $filter('number')(response.amount, 2);
        //      vm.tempForpObj.recipientAccountInput = response.toAccountNumber;
        //      vm.tempForpObj.paymentPurposeInput = response.purpose;
        //      vm.tempForpObj.fullNameCompanyInput = response.payeeName || '';
        //      vm.tempForpObj.recipientAddressInput = response.payeeAddress1 || '';
        //      vm.tempForpObj.recipientCityInput = response.payeeCity || '';
        //      loadAccountData(response.accountId);
        //    })
        //      .catch(function (error) {
        //      HelperService.showMessage(error, 'error');
        //    });
        //  }
        //};

        var loadPaymentData = function (paymentId) {
            if (paymentId) {
                PaymentsService.getById(paymentId)
                    .then(function (response) {

                        var country = _.findWhere(vm.countriesOptions, {
                            code: response.beneficiaryBankCountryCode
                        });
                        if (country) {
                            vm.countrySearchFilter = country.description;
                            vm.tempForpObj.bankCountrySelect = country;
                        }

                        vm.tempForpObj.amountInput = response.amount;
                        vm.tempForpObj.toAccountInput = response.toAccountNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
                        vm.tempForpObj.recipientAccountInput = response.toAccountNumber;
                        //vm.payeeSearchFilter = response.receiverName;
                        vm.tempForpObj.receiversNameInput = response.receiverName;
                        vm.tempForpObj.receiversAddressInput = response.receiverAddress1;
                        vm.tempForpObj.paymentPurposeInput = response.purpose;
                        vm.tempForpObj.fullNameCompanyInput = response.payeeName || '';
                        vm.tempForpObj.recipientAddressInput = response.payeeAddress1 || '';
                        vm.tempForpObj.recipientCityInput = response.payeeCity || '';
                        vm.tempForpObj.bankAddressInput = response.beneficiaryBankAddress;
                        vm.tempForpObj.bankCityInput = response.beneficiaryBankCity;
                        vm.tempForpObj.bankNameInput = response.beneficiaryBankName;
                        vm.tempForpObj.modalityCode = response.modalityCode;
                        vm.tempForpObj.bankChargesRadiobutton.type = response.paymentCharges || '3';
                        vm.tempForpObj.recipientStatusRadiobutton.type = response.payeeLegalForm || '2';
                        vm.tempForpObj.swiftCodeInput = response.beneficiarySWIFTCode;
                        vm.tempForpObj.receiversPostalCodeAndCityInput = response.receiverCity;
                        vm.bicCodeSearchFilter = response.beneficiarySWIFTCode;
                        loadAccountData(response.accountId);
                        vm.setChargeAccount(vm.tempForpObj.fromAccountSelect);

                        var index = _.findIndex(vm.purposeCodes, function (item) {
                            return response.purposeCodeDPS === item.id;
                        })
                        if (index) {
                            vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[index];
                        } else {
                            vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
                        }

                        vm.paymentResponse.id = paymentId;
                        if ($state.params.editable)
                            vm.forUpdate = true;
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        // --
        // INITIALIZE
        // --
        var populateFieldsWithData = function () {

        };
        vm.init = function () {
            vm.getPaymentTemplatesPage();
            vm.getUserSettingsPage();
            var promises = [
        PaymentsService.getPaymentModes(),
        CountriesService.getPage({
                    pageSize: 1000
                }),
        vm.loadPurposeCode(),
        vm.loadCountries(),
        vm.getDebitAccountList()
      ];

            $q.all(promises)
                .then(function (responses) {
                    vm.getPayees();
                    // Payment Modes Options
                    vm.paymentModeOptions = responses[0].result;
                    // Countries
                    vm.countriesOptions = responses[1].result;

                    //        if ($state.params && $state.params.templateId) {
                    //          loadPaymentDataFromTemplate($state.params.templateId);
                    //        } else
                    if ($state.params && $state.params.paymentId) {
                        loadPaymentData($state.params.paymentId);
                    } else {
                        if (vm.purposeCodes.length > 0) {
                            vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
                        }
                        if (vm.bankCountries.length > 0) {
                            vm.tempForpObj.recipientCountrySelect = vm.bankCountries[0];
                            vm.tempForpObj.bankCountrySelect = vm.bankCountries[0];
                        }
                        if (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) {
                            vm.tempForpObj.fromAccountSelect = vm.accountsFrom[0];
                            vm.setChargeAccount(vm.tempForpObj.fromAccountSelect);
                        }
                    }

                    if (vm.purposeCodes.length > 0) {
                        vm.tempForpObj.purposeCodeSelect = vm.purposeCodes[0];
                        vm.tempForpObj.paymentPurposeInput = vm.purposeCodes[0].description;
                    }
                    if (vm.bankCountries.length > 0) {
                        vm.tempForpObj.recipientCountrySelect = vm.bankCountries[0];
                        vm.tempForpObj.bankCountrySelect = vm.bankCountries[0];
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        }

        // region Private methods

        /*
         * Create object for POST
         * */
        function createPaymentObject() {
            var paymentObject = {};
            paymentObject.accountId = vm.tempForpObj.fromAccountSelect.accountId;
            paymentObject.fromAccountNumber = vm.tempForpObj.fromAccountSelect.iban;

            paymentObject.toAccountNumber = (vm.tempForpObj.toAccountInput) ? vm.tempForpObj.toAccountInput.replace(/\s/g, '') : "";
            paymentObject.currencySymbol = vm.tempForpObj.fromAccountSelect.currencySymbol;
            paymentObject.purpose = vm.tempForpObj.paymentPurposeInput;
            paymentObject.dueDate = vm.tempForpObj.dueDateInput;
            paymentObject.amount = vm.tempForpObj.amountInput;
            paymentObject.paymentTypeGroup = 'ForeignPayment';
            paymentObject.purposeCodeDPS = vm.tempForpObj.purposeCodeSelect.id;
            paymentObject.foreignPayment = {
                receiverName: vm.tempForpObj.receiversNameInput,
                receiverAddress1: vm.tempForpObj.receiversAddressInput,
                receiverCity: vm.tempForpObj.receiversPostalCodeAndCityInput,
                senderName: vm.tempForpObj.fromAccountSelect.ownerName,
                senderAddress1: vm.tempForpObj.fromAccountSelect.ownerAddress,
                senderCity: vm.tempForpObj.fromAccountSelect.ownerCity,
                beneficiarySWIFTCode: vm.tempForpObj.swiftCodeInput,
                beneficiaryBankName: vm.tempForpObj.bankNameInput,
                beneficiaryBankAddress: vm.tempForpObj.bankAddressInput,
                beneficiaryBankCity: vm.tempForpObj.bankCityInput,
                //beneficiaryBankCountryCode: vm.tempForpObj.bankCountrySelect.code,
                // beneficiaryBankCountry: vm.tempForpObj.bankCountrySelect.description,
                beneficiaryBankCountry: "",
                foreignBankAddress3: "",
                //TODO: Seems like recieverCountryCode selects first country from the list of countries and there is no way to choose one - but is required by backend!!!!!
                receiverCountryCode: vm.tempForpObj.bankCountrySelect.code,
                //referenceFrom: null,
                referenceTo: null,
                // need to add field on payment form
                chargeAccount: (vm.tempForpObj.bankChargesRadiobutton.type != 2) ? vm.tempForpObj.chargeAccountInput.accountNumber + ' ' + vm.tempForpObj.chargeAccountInput.currencySymbol : "",
                payeeLegalForm: vm.tempForpObj.recipientStatusRadiobutton.type,
                paymentCharges: vm.tempForpObj.bankChargesRadiobutton.type,
                // paymentUsedMode: vm.tempForpObj.paymentUsedMode
                modalityCode: vm.tempForpObj.modalityCode
            };
            paymentObject.sepaUpnIdentificators = {
                debtorName: vm.tempForpObj.payersSepaInput1,
                debtorName2: vm.tempForpObj.payersSepaInput2,
                creditorName: vm.tempForpObj.receiversSepaInput1,
                creditorName2: vm.tempForpObj.receiversSepaInput2
            };
            return paymentObject;
        }

        // endregion

        // region Public methods

        /*
         * Autocompletes Bank/BIC data when BIC Number is selected
         * */
        vm.onBicBankSelected = function (bbank) {
            // bicBanks API for Slovenia - returns {bicCode: "BSLJSI2X", id: "21"} - not good
            var bicBank = _.findWhere(vm.bicBankOptions, {
                swiftCode: bbank.swiftCode
            });
            vm.tempForpObj.swiftCodeInput = bicBank.swiftCode;
            vm.tempForpObj.bankAddressInput = bicBank.branchInformation;
            vm.tempForpObj.bankCityInput = bicBank.city;
            vm.tempForpObj.bankNameInput = bicBank.institutionName;

            vm.bicCodeSearchFilter = bicBank.swiftCode;
            vm.bicCodeSearchFilterExpanded = false;

            var country = _.findWhere(vm.countriesOptions, {
                countryCodeShort: bicBank.swiftCode.substring(4, 6)
            });
            if (country) vm.onCountrySelect(country);

        };

        vm.addSpaceForIban = function (toAccountInput) {
            if (!vm.tempForpObj.toAccountInput) return;
            vm.tempForpObj.toAccountInput = toAccountInput.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
        };

        vm.getBicByIban = function (iban) {
            if (!iban) {
                return;
            }
            iban = iban.replace(/\s/g, '');
            PaymentsService.getBicBanks(undefined, {
                    iban: iban
                })
                .then(function (response) {
                    var bicBank = response.result[0];
                    if (bicBank) {
                        vm.bicCodeSearchFilter = bicBank.swiftCode;
                        vm.tempForpObj.swiftCodeInput = bicBank.swiftCode;
                        vm.tempForpObj.bankAddressInput = bicBank.branchInformation;
                        vm.tempForpObj.bankCityInput = bicBank.city;
                        vm.tempForpObj.bankNameInput = bicBank.institutionName;
                        var country = _.findWhere(vm.countriesOptions, {
                            countryCodeShort: bicBank.swiftCode.substring(4, 6)
                        });
                        if (country) vm.onCountrySelect(country);
                    }
                }, function (error) {

                })
        };

        vm.searchBICNumber = function (bicInput) {
            vm.bicCodeSearchFilterExpanded = true;
            vm.tempForpObj.swiftCodeInput = bicInput;
            searchBicNumber(bicInput);
        };

        function searchBicNumber(bicInput) {
            PaymentsService.getBicBanks(undefined, {
                    bicCode: bicInput
                })
                .then(function (response) {
                    vm.bicBankOptions = response.result;
                }, function (error) {

                })
        }

        vm.newPayment = function () {
            $state.go('payments.internationalPayment', {}, {
                reload: true
            })
        };

        vm.removeBicCodeSearch = function () {
            vm.bicCodeSearchFilter = "";
            vm.tempForpObj.swiftCodeInput = "";
            vm.tempForpObj.bankAddressInput = "";
            vm.tempForpObj.bankCityInput = "";
            vm.tempForpObj.bankNameInput = "";
        };

        /*
         * Countries selectbox - on list click
         * */
        vm.onCountrySelect = function (country) {
            console.log(country);
            vm.countrySearchFilter = country.code + " " + country.description;
            vm.tempForpObj.bankCountrySelect = country;
            vm.countrySearchFilterExpanded = false;

            if (country.countryUnion == "EU") {
                vm.EUCountrySelected = true;
                // Disable Charge option if EU country is selected because option must be "SHA"
                vm.tempForpObj.bankChargesRadiobutton.type = '3';
            } else {
                vm.EUCountrySelected = false;
            }
        };

        /*
         * Countries selectbox - remove
         * */
        vm.removeSelectedCountry = function () {
            vm.countrySearchFilter = "";
            vm.tempForpObj.bankCountrySelect = {};
            vm.countrySearchFilterExpanded = true;
            vm.EUCountrySelected = false;
        };


        /*
         * Called when Review and submit button is clicked
         * */
        vm.submitInternationalPayment = function (event) {
            // Check if form is valid
            vm.tempForpObj.formSubmitted = true;
            if (!vm.paymentForm.$valid) {
                return false;
            }


            // If form is valid create object for update
            var paymentObject = createPaymentObject();

            // If selected country has amlControl call statement confirmation modal
            if (vm.tempForpObj.bankCountrySelect.amlControl) {
                // PaymentsService.openStatementConfirmModal(vm.tempForpObj.bankCountrySelect)
                PaymentsService.openStatementConfirmModal(vm.tempForpObj)
                    .result.then(function (result) {
                        // Add more information to payment object
                        if (!result)
                            return;
                        else {
                            paymentObject.foreignPayment.beneficiaryBankCountry = result.stateOption;
                            paymentObject.foreignPayment.foreignBankAddress3 = result.information;
                        }
                        upsertInternationalPayment(paymentObject);

                    });
                return;
            }

            upsertInternationalPayment(paymentObject);
        };

        function upsertInternationalPayment(paymentObject) {
            if (!vm.formSubmitted) {
                vm.formSubmitted = true;
                if (vm.forUpdate) {
                    paymentObject.id = vm.paymentResponse.id;
                    PaymentsService.updatePayment(vm.paymentResponse.id, paymentObject)
                        .then(function (response) {
                            postPaymentAction(response);
                            vm.forUpdate = false;
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            // vm.forUpdate = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                } else {
                    PaymentsService.insertPayment(paymentObject)
                        .then(function (response) {
                            postPaymentAction(response);
                            GoogleTagManagerHelperService.pushVirtualPageView('payments/international-payment/toconfirm', 'payments international-payment toconfirm', $location.host() + $location.host() + 'payments/international-payment/toconfirm');
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                }
            }
        }

        function postPaymentAction(response) {
            vm.paymentResponse = response;
            vm.paymentResponse.dueDate = new Date(response.dueDate);
            vm.paymentResponse.paymentTypeGroup = 'ForeignPayment';
            vm.paymentResponse.purposeCodeValue = vm.tempForpObj.purposeCodeSelect.optionValue;
            switch (response.paymentCharges) {
            case "1":
                vm.paymentResponse.bankCharges = "Payers pays charges";
                break;
            case "2":
                vm.paymentResponse.bankCharges = "Beneficiary pays charges";
                break;
            case "3":
                vm.paymentResponse.bankCharges = "Shared charges";
                break;
            }

            // Remap payment mode
            var modality = _.findWhere(vm.paymentModeOptions, {
                id: vm.paymentResponse.modalityCode
            });
            if (modality) {
                vm.paymentResponse.modalityCode = modality.id + " " + modality.description;
            }

            var country = _.findWhere(vm.countriesOptions, {
                code: vm.paymentResponse.beneficiaryBankCountryCode
            });
            if (country) {
                vm.paymentResponse.beneficiaryBankCountryCode = country.code + " " + country.description;
            }

            vm.paymentResponse.payeeListId = vm.tempForpObj.recipientStatusRadiobutton.type;
            vm.steps = {
                step1: false,
                step2: true,
                step3: false
            };
        }

        // endregion
        vm.init();
    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:InternalTransferCtrl
     *
     * @description
     *
     */
    InternalTransferCtrl.$inject = ["$rootScope", "$sessionStorage", "$state", "CTLocalizationService", "$log", "PaymentTypesService", "HelperService", "PaymentsService", "AccountsService", "$stateParams", "PaymentFilterService", "toastr", "$translate", "Notification", "AlertService", "$location", "PaymentTemplatesService", "GoogleTagManagerHelperService"];
    angular
        .module('payments')
        .controller('InternalTransferCtrl', InternalTransferCtrl);

    function InternalTransferCtrl($rootScope, $sessionStorage, $state, CTLocalizationService, $log, PaymentTypesService, HelperService,
        PaymentsService, AccountsService, $stateParams,
        PaymentFilterService, toastr, $translate, Notification, AlertService, $location, PaymentTemplatesService, GoogleTagManagerHelperService) {
        var vm = this;
        var singleToAccount = false;

        vm.paymentResponse = {};
        vm.fromAccounts = false;
        vm.tempIntObj = {
            fromAccountSelect: {},
            toAccountSelect: '',
            amountInput: '',
            dueDateInput: new Date(),
            formSubmitted: false
        };

        vm.accountsFrom = [];
        vm.accountsTo = [];
        vm.isSameAccounts = false;

        vm.disableAllFields = false;

        vm.datePickerOpened = false;
        vm.dateOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        //vm.bankCharges = '';
        vm.customErrorLabels = [];
        vm.currentStep = 1;
        vm.forUpdate = false;
        vm.fromAccountDropdown = false;
        vm.toAccountDropdown = false;
        vm.templatesFilter = {
            paymentTypeGroup: 'LocalCurrencyTransfer',
            page: 0,
            pageSize: 1000
        };
        //vm.countryCode = $localStorage.code || '';
        vm.fromLoan = false;
        vm.accountChanged = false;

        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.bankCharges = $rootScope.APP_GLOBAL_SETTINGS.defaultData.BankCharges;


        vm.init = function () {
            //vm.getDefaultData();
            loadAccounts();
        };

        var setAccountTo_ = function () {
            AccountsService.getAccountById($stateParams.accountId)
                .then(function (response) {
                    vm.tempIntObj.toAccountSelect = response;
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        var loadInternalTransferData = function (payment, paymentObject, params) {
            paymentObject.amountInput = payment.amount;
            paymentObject.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.accountsFrom, payment.accountId);
            filterAccountToSameCurrency();
            paymentObject.toAccountSelect = PaymentFilterService.filterToAccountSelectByIBAN(vm.accountsTo, payment.toAccountNumber);
            if (vm.countryCode == 'bh')
                paymentObject.dueDateInput = new Date(payment.dueDate);

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {


                vm.tempIntObj.fromAccountSelect = _.find(params.accountsFrom, function (account) {
                        return (account.iban == payment.fromAccountNumber.replace(/ /g, '') && account.currencySymbol == payment.currencySymbol)
                    })
                    // This is used to make "Account to" readonly and to disable AccountToList from changing
                    // AccountTo is not readonly when "Repeating" the payment - Only Execute and Change

                vm.fromLoan = true;
                if ($state.params.myParam == 'repeat') {
                    vm.fromLoan = false;
                }

                PaymentTypesService.getByGroup({
                        paymentTypeGroup: 'LocalCurrencyTransfer',
                        masterAccountId: vm.tempIntObj.fromAccountSelect.accountId
                    })
                    .then(function (response) {
                        if (_.isArray(response.result) && response.result.length > 0) {
                            vm.accountsTo = response.result[0].creditAccountList;
                            filterAccountToSameCurrency();
                            vm.setAccountTo(_.find(vm.accountsTo, function (account) {
                                return (account.iban == payment.toAccountNumber.replace(/ /g, '') && account.currencySymbol == payment.currencySymbol)
                            }));
                            _.forEach(vm.accountsTo, function (item) {
                                if (item.accountDescription) {
                                    item.optionValue = item.accountDescription + ' - ' + item.iban;
                                }
                            });
                        }
                        vm.accountChanged = false;
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });


            }
            if (vm.countryCode == "sl") {
              paymentObject.dueDateInput = new Date(payment.dueDate);
              vm.disableAllFields = true;
              if ($state.params.myParam == 'repeatCancelled') {
                vm.disableAllFieldsForProcessedPayment = true;
              }

              if ($state.params.myParam == 'changeProcessed') {
                vm.disableAllFieldsForProcessedPayment = false;
              }
            }

        };

        var loadDataForCard = function (payment, paymentObject, params, accountObject) {
            paymentObject.amountInput = payment.amount;
            paymentObject.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.accountsFrom, payment.accountId);
            paymentObject.toAccountSelect = accountObject.result[0];
            var tempList = [];
            tempList.push(paymentObject.toAccountSelect);
            vm.accountsTo = tempList;
            singleToAccount = true;
        };

        var removeNonDefaultCurrency = function (list) {
            if (!list) return;
            _.remove(list, function (item) {
                return item.currencySymbol != $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
            });

            if (_.isArray(list) && list.length > 0) {
                vm.tempIntObj.fromAccountSelect = list[0];
            }
        };

        var loadAccounts = function () {
            vm.getDebitAccountList()
                .then(function () {
                    var params = {
                        accountsFrom: vm.accountsFrom
                    };
                    if ($state.current && $state.current.name) {
                        switch ($state.current.name) {
                        case "payments.internalTransfer.fromPayment":
                            PaymentsService.getById($state.params.paymentId) ///dodano zbog uplate na karticu u CRO
                                .then(function (paymentResponse) {
                                    AccountsService.getPage({
                                            accountNumber: paymentResponse.toAccountNumber
                                        })
                                        .then(function (accountResponse) {
                                            if (vm.countryCode === 'hr' && accountResponse.result.length > 0) {
                                                if (accountResponse.result[0].accountType.group === 'CardAccountTypes' || accountResponse.result[0].accountType.group === 'SavingAccountTypes') {
                                                    loadDataForCard(paymentResponse, vm.tempIntObj, params, accountResponse);
                                                }

                                            } else {
                                                loadInternalTransferData(paymentResponse, vm.tempIntObj, params);
                                            }
                                        })
                                        .catch(function (error) {});
                                })
                                .catch(function (error) {
                                    HelperService.showMessage(error, 'error');
                                });
                            break;
                        case "payments.internalTransfer.fromAccounts":
                            var accountsFromExist = (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) ? true : false;
                            AccountsService.getAccountById($state.params.accountId)
                                .then(function (response) {
                                    //set toAccount in case of Card account type
                                    if (
                                        response.accountType.group === 'CardAccountTypes' ||
                                        response.accountType.group === 'SavingAccountTypes' ||
                                        (vm.countryCode == 'mne' && response.accountType.id.substr(0, 2) == '60')
                                    ) {
                                        if (accountsFromExist) {
                                            vm.tempIntObj.fromAccountSelect = vm.accountsFrom[0];
                                        }
                                        vm.tempIntObj.toAccountSelect = '';
                                        vm.tempIntObj.toAccountSelect = response;
                                        vm.fromAccounts = true;
                                        var tempList = [];
                                        tempList.push(vm.tempIntObj.toAccountSelect);
                                        vm.accountsTo = tempList;
                                        singleToAccount = true;

                                        if (vm.countryCode == 'sl' || vm.countryCode == 'bh') {
                                            //remove nonEur currencies from FROM list for savings paying - Andreja TSK 8249
                                            _.remove(vm.accountsFrom, function (item) {
                                                return item.currencySymbol != vm.tempIntObj.toAccountSelect.currencySymbol;
                                            });

                                            if (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) {
                                                vm.tempIntObj.fromAccountSelect = vm.accountsFrom[0];
                                            }

                                        }

                                    } else {
                                        if (accountsFromExist) {
                                            vm.tempIntObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(vm.accountsFrom, $state.params.accountId);
                                        }
                                        //filter to account list
                                        if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != "sl") filterAccountToSameCurrency();
                                        if (_.isArray(vm.accountsTo) && vm.accountsTo.length > 0) {
                                            vm.tempIntObj.toAccountSelect = vm.accountsTo[0];
                                          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                                            vm.accountChanged = true;
                                            setToAccountList (vm.tempIntObj.fromAccountSelect.accountId);
                                          }
                                        }
                                    }

                                })
                                .catch(function (error) {
                                    HelperService.showMessage(error, 'error');
                                });
                            break;
                        case "payments.internalTransfer.loan":
                            vm.fromLoan = true;
                            vm.tempIntObj.fromAccountSelect = vm.accountsFrom[0];
                            if (vm.countryCode == 'sl') {
                                vm.tempIntObj.fromAccountSelect = PaymentsService.setFromAccountsToDefaulCurrency(vm.accountsFrom);
                            }

                            if (vm.countryCode == 'bh')
                                removeNonDefaultCurrency(vm.accountsFrom);

                            loadAccountById($state.params.loanId);
                            break;
                        case "payments.internalTransfer":
                            if (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) {
                                vm.tempIntObj.fromAccountSelect = vm.accountsFrom[0];
                            }
                            if (vm.countryCode == 'sl') {
                                vm.tempIntObj.fromAccountSelect = PaymentsService.setFromAccountsToDefaulCurrency(vm.accountsFrom);
                                vm.accountChanged = true;
                                setToAccountList(vm.tempIntObj.fromAccountSelect.accountId);
                            }


                            filterAccountToSameCurrency();
                            if (_.isArray(vm.accountsTo) && vm.accountsTo.length > 0) {
                                vm.tempIntObj.toAccountSelect = vm.accountsTo[0];
                            }
                            break;

                        case "payments.internalTransfer.fromTemplate":
                            if ($state.params.templateId) {
                                vm.fromTemplate = true;
                                vm.populateFromTemplate($state.params.templateId);
                            }
                            break;
                        }
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.populateFromTemplate = function (id) {
            PaymentTemplatesService.getById(id)
                .then(function (response) {
                  var template = response;
                  if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != "sl") {
                    vm.tempIntObj.amountInput = response.amount;
                  }
                  if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && template.paymentTypeGroup == "ForeignCurrencyTransfer") {


                    var fromAccountFound = _.find(vm.accountsFrom, function (account) {
                      return (account.parentAccountId && (account.parentAccountId.toString() == template.accountId &&  account.currencySymbol == template.currencyCode));
                    })
                    vm.tempIntObj.fromAccountSelect = (fromAccountFound) ? fromAccountFound : {};
                    vm.accountChanged = true;
                    setToAccountList(vm.tempIntObj.fromAccountSelect.accountId)
                      .then(function (response) {
                        console.log(vm.accountsTo);
                        var toAccountFound = _.find(vm.accountsTo, function (account) {
                          return (account.iban.replace(/ /g,'') == response.toAccountNumber.replace(/ /g,'') && account.currencySymbol == template.currencyCode);
                        });
                        vm.tempIntObj.toAccountSelect = (toAccountFound) ? toAccountFound : {};
                      });




                  } else {
                    if (_.isArray(vm.accountsFrom) && vm.accountsFrom.length > 0) {
                      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                        vm.tempIntObj.fromAccountSelect = _.findWhere(vm.accountsFrom, {accountId: response.accountId})
                      } else {
                        vm.tempIntObj.fromAccountSelect = vm.accountsFrom[0];
                      }
                    }

                    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                      vm.tempIntObj.toAccountSelect = _.find(vm.accountsFrom, {iban: response.toAccountNumber.replace(/ /g,''), currencySymbol: response.currencyCode });
                    } else {
                      vm.tempIntObj.toAccountSelect = _.findWhere(vm.accountsTo, {iban: response.toAccountNumber.replace(/ /g,'')});
                    }

                    if (!vm.tempIntObj.toAccountSelect)
                      vm.tempIntObj.toAccountSelect = vm.accountsTo[0];
                  }

                }, function (error) {
                    console.log(error);
                });
        };



        var loadAccountById = function (accountId) {
            AccountsService.getAccountById(accountId)
                .then(function (response) {
                    vm.tempIntObj.toAccountSelect = response;
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                })
        };

        vm.openDatePicker = function () {
            vm.datePickerOpened = true;
        };

        vm.goBack = function () {
            $state.go('payments.paymentsOverview');
        };

        vm.getDebitAccountList = function () {
            return PaymentTypesService.getByGroup({
                    paymentTypeGroup: 'LocalCurrencyTransfer'
                })
                .then(function (response) {
                    if (_.isArray(response.result) && response.result.length > 0) {
                        vm.accountsFrom = response.result[0].debitAccountList;
                        vm.accountsTo = response.result[0].creditAccountList;

                        _.forEach(vm.accountsFrom, function (item) {
                            if (item.accountDescription) {
                                item.optionValue = item.accountDescription + ' - ' + item.iban;
                            }
                        });
                        _.forEach(vm.accountsTo, function (item) {
                            if (item.accountDescription) {
                                item.optionValue = item.accountDescription + ' - ' + item.iban;
                            }
                        });
                    }
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.internalTransferSubmit = function () {
            if (vm.nextButtonPressed) {
              return;
            }

            vm.tempIntObj.formSubmitted = true;
            if ($state.params.editable) {
                vm.forUpdate = true;
                vm.paymentResponse.id = $stateParams.paymentId;
            }
            if (!vm.internalTransferForm.$valid) {
                return;
            }
            if (vm.tempIntObj.fromAccountSelect.accountId == vm.tempIntObj.toAccountSelect.accountId) {
                vm.isSameAccounts = true;
                $translate(['core.sameAccounts']).then(function (translations) {
                    var txt = translations['core.sameAccounts'];
                    toastr.error(txt);
                });
                return;
            } else {
                vm.isSameAccounts = false;
            }

            if (!vm.formSubmitted) {
                if (vm.countryCode == 'sl')
                    $sessionStorage.paymentSubTypeGroup = 'LocalCurrencyTransfer';
                var internalTransferPaymentObject = createPaymentObject();
                vm.nextButtonPressed = true;
                if (vm.forUpdate) {
                    internalTransferPaymentObject.id = vm.paymentResponse.id;
                    PaymentsService.updatePayment(vm.paymentResponse.id, internalTransferPaymentObject)
                        .then(function (response) {
                            postPaymentAction(response);
                            vm.forUpdate = false;
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            vm.forUpdate = false;
                            // vm.internalTransferForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                            vm.nextButtonPressed = false;
                        });
                } else {
                    PaymentsService.insertPayment(internalTransferPaymentObject)
                        .then(function (response) {
                            postPaymentAction(response);
                            var gtmObject = HelperService.processUrlForGTM('payment');
                            GoogleTagManagerHelperService.pushVirtualPageView(gtmObject.url, gtmObject.title, $location.host() + gtmObject.url);
                        })
                        .catch(function (error) {
                            vm.paymentResponse = {};
                            HelperService.showMessage(error, 'error');
                            $log.error("Payment error:", error);
                            // vm.internalTransferForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                            vm.nextButtonPressed = false;
                        });
                }
            }
        };

        var createPaymentObject = function () {
            var tempDueDate = vm.tempIntObj.dueDateInput;
            var tempToAccountNumber = vm.tempIntObj.toAccountSelect.iban;
            var tempPaymentTypeGroup = (vm.tempIntObj.fromAccountSelect.currencySymbol != $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency) ? 'ForeignCurrencyTransfer' : 'LocalCurrencyTransfer';
            if (vm.countryCode == 'sr' || vm.countryCode == 'mne') {
                tempDueDate = new Date();
                if (vm.fromAccounts && vm.countryCode == 'mne') {
                    tempToAccountNumber = vm.tempIntObj.toAccountSelect.accountNumber;
                }
            }

            if (vm.countryCode == 'sl') {
                tempToAccountNumber = vm.tempIntObj.toAccountSelect.accountNumber;
            }


            if (vm.countryCode == 'bh' || vm.countryCode == 'mne' || vm.countryCode == 'sr') {
                tempPaymentTypeGroup = 'LocalCurrencyTransfer';
            }
            return {
                accountId: vm.tempIntObj.fromAccountSelect.accountId,
                fromAccountNumber: vm.tempIntObj.fromAccountSelect.iban,
                toAccountNumber: tempToAccountNumber,
                currencySymbol: vm.tempIntObj.fromAccountSelect.currencySymbol,
                amount: vm.tempIntObj.amountInput,
                paymentTypeGroup: tempPaymentTypeGroup,
                dueDate: tempDueDate
            }
        };

        vm.signPayment = function () {
            if (vm.confirmButtonPressed) return;
            //if route has this param it should request for PUT method
            if ($state.params.myParam == 'changeProcessed') {
                updatePayment();
                return;
            }

            if (PaymentsService.isVerificationRequiredForSign(vm.paymentResponse)) {
                // If verification is required, go to payment sign state
                $state.go('payments.sign', {
                    paymentId: vm.paymentResponse.id,
                    type: 'internal'
                });
            } else {
                // If verification is not required, then sign payment and go to final step
                var params = {
                    id: vm.paymentResponse.id,
                    payment: vm.paymentResponse
                };
                vm.confirmButtonPressed = true;
                return PaymentsService.signPayment(params)
                    .then(function (signedPayment) {
                        var id = (signedPayment.id) ? signedPayment.id : vm.paymentResponse.id;
                        // TODO: Use signed payment on response
                        $state.go('payments.finalStep', {
                            paymentId: id,
                            type: 'internal'
                        });
                    }).catch(function (error) {
                        $log.error(error);
                        HelperService.showMessage(error, 'error');
                    }).finally(function() {
                      vm.confirmButtonPressed = false;
                  });
            }
        };

        function updatePayment() {
            var params = {
                id: $state.params.paymentId,
                payment: vm.paymentResponse
            };

            if ($state.params.myParam == 'changeProcessed') {
                params.payment.relatedSourceType = 'ChangePayment';
            }


            PaymentsService.updatePayment(params.id, params.payment, 'changeProcessed')
                .then(function (signedPayment) {
                    var id = (signedPayment.id) ? signedPayment.id : vm.paymentResponse.id;
                    $state.go('payments.finalStep', {
                        paymentId: id,
                        type: "internal"
                    });
                })
                .catch(function (response, error) {
                    $log.error(error);
                    HelperService.showMessage(error, 'error');
                })
                .finally(function () {
                    vm.formSubmitted = false;
                    vm.forUpdate = false;
                });


        }

        vm.editPayment = function () {
            mapWithPaymentResponse();
            vm.forUpdate = true;
            vm.currentStep = 1;
        };

        var mapWithPaymentResponse = function () {
            vm.tempIntObj.amountInput = vm.paymentResponse.amount;
            vm.tempIntObj.dueDateInput = new Date(vm.paymentResponse.dueDate);

            /*      var accountIndex = _.findIndex(vm.accountsFrom, function (item) {
              return item.accountId == vm.paymentResponse.accountId;
            });

            var accountToIndex = _.findIndex(vm.accountsTo, function (item) {
              return item.iban == vm.paymentResponse.toAccountNumber;
            });

            vm.tempIntObj.fromAccountSelect = vm.accountsFrom[accountIndex];
            vm.tempIntObj.toAccountSelect = vm.accountsTo[accountToIndex];*/

        };


        var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        $rootScope.$on('appLanguageChangedHeader', function () {
            sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        });

        vm.deletePayment = function () {
            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        PaymentsService.deletePayment(vm.paymentResponse.id)
                            .then(function (response) {
                                AlertService.deletedPaymentAlert({
                                        paymentName: vm.paymentResponse.id,
                                        type: 'payment'
                                    })
                                    .then(function () {
                                        $state.go('payments.paymentsOverview');
                                    });
                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    }
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });

        };

        var setToAccountList = function (accountId) {
            if (vm.accountChanged) {

               return PaymentTypesService.getByGroup({
                        paymentTypeGroup: 'LocalCurrencyTransfer',
                        masterAccountId: accountId
                    })
                    .then(function (response) {
                        if (_.isArray(response.result) && response.result.length > 0) {
                            vm.accountsTo = response.result[0].creditAccountList;
                            filterAccountToSameCurrency();
                            vm.setAccountTo(vm.accountsTo[0]);
                            _.forEach(vm.accountsTo, function (item) {
                                if (item.accountDescription) {
                                    item.optionValue = item.accountDescription + ' - ' + item.iban;
                                }
                            });
                        }
                        vm.accountChanged = false;
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            }
        };

        var fromAccountChanged = function () {
            //if($state.current.name !== 'payments.internalTransfer.fromPayment' && $state.current.name !== 'payments.internalTransfer.fromAccounts')
            if (!singleToAccount) {
                setToAccountList(vm.tempIntObj.fromAccountSelect.accountId);
            }
        };

        var postPaymentAction = function (response) {
            vm.paymentResponse = response;
            vm.paymentResponse.paymentTypeGroup = 'LocalCurrencyTransfer';
            Notification.clearAll();
            vm.currentStep = 2;
        };

        vm.toggleFromAccount = function () {
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && vm.fromTemplate) {
            return;
          }
          vm.fromAccountDropdown = !vm.fromAccountDropdown;
        };

        vm.setAccountFrom = function (item) {
            if (item.accountId !== vm.tempIntObj.fromAccountSelect.accountId) {
                vm.accountChanged = true;
            } else {
                vm.accountChanged = false;
            }
            vm.tempIntObj.fromAccountSelect = item;
            vm.fromAccountDropdown = false;
            if (!vm.fromLoan) {
                vm.toAccountDropdown = false;
                fromAccountChanged();
            }
        };

        vm.toggleToAccount = function () {
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && vm.fromTemplate) {
            return;
          }
          if (vm.accountsTo.length > 1)
                vm.toAccountDropdown = !vm.toAccountDropdown;
        };

        vm.setAccountTo = function (item) {
            vm.tempIntObj.toAccountSelect = item;
            vm.fromAccountDropdown = false;
            vm.toAccountDropdown = false;
        };

        var clearInput = function () {
            vm.templateName = '';
            vm.tempIntObj.fromAccountSelect = vm.accountsFrom[0];
            setToAccountList(vm.tempIntObj.fromAccountSelect.accountId);
            vm.tempIntObj.toAccountSelect = vm.accountsTo[0];
            vm.tempIntObj.amountInput = '';
            vm.tempIntObj.dueDateInput = new Date();
            vm.tempIntObj.formSubmitted = false;
            vm.smsPasswordInput = '';
            vm.smsAuthentificate = false;
        };

        vm.backToInternalTransfer = function () {
            clearInput();
            vm.currentStep = 1;
        };

        // in BiH environment accounts must have same currency
        function filterAccountToSameCurrency() {
            if (vm.countryCode !== 'bh' && vm.countryCode !== 'sl') {
                return;
            }
            _.remove(vm.accountsTo, function (item) {
                return item.currencySymbol != vm.tempIntObj.fromAccountSelect.currencySymbol;
            });
            $log.debug("Accounts to ", vm.accountsTo);
        };

        //vm.getDefaultData = function () {
        //  return ConfigEndpointService.getDefaultData()
        //    .then(function (response) {
        //    if (response.APILocation) {
        //      $localStorage.code = response.APILocation;
        //      vm.countryCode = $localStorage.code;
        //      vm.bankCharges = response.BankCharges;
        //    }
        //  })
        //    .catch(function (error) {
        //    HelperService.showMessage(error, 'error');
        //  });
        //};

        vm.init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:HumanitarianService
   *
   * @description
   *
   */
  HumanitarianService.$inject = ["$q", "EndpointsService", "$log", "$http"];
  angular
    .module('payments')
    .factory('HumanitarianService', HumanitarianService);

  function HumanitarianService($q, EndpointsService, $log, $http) {
    var HumanitarianServiceBase = {};

    HumanitarianServiceBase.getAll = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $log.debug("Params:", params);
        $http.get(response.links.payments_humanitarianPayments)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    HumanitarianServiceBase.getById = function (id){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.payments_forHumanitarianPayment_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    return HumanitarianServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:ExchangeRatesService
   *
   * @description
   *
   */
  ExchangeRatesService.$inject = ["EndpointsService", "$http", "$log", "$q", "ConfigService"];
  angular
    .module('payments')
    .factory('ExchangeRatesService', ExchangeRatesService);

  function ExchangeRatesService(EndpointsService, $http, $log, $q, ConfigService) {
    var ExchangeRatesServiceBase = {};

    ExchangeRatesServiceBase.getExchangeRates = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.exchangeRates, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          })
          .error(function (msg, code) {
            deferred.reject(msg);
          })
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    ExchangeRatesServiceBase.calculateExchangeRate = function (params) {
      var deferred = $q.defer();
      var url = ConfigService.url;
      url = url + "exchangeRates/exchangeRateCalculate";
      $http.get(url, {
          params: params
        })
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function (msg) {
          deferred.reject(msg);
        });
      return deferred.promise;
    };

    return ExchangeRatesServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name payments.directive:exchangeRates
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="payments">
       <file name="index.html">
        <exchange-rates></exchange-rates>
       </file>
     </example>
   *
   */
  angular
    .module('payments')
    .directive('exchangeRates', exchangeRates);

  function exchangeRates() {
    return {
      restrict: 'EA',
      scope: {
        exchangeObjectList:'=exchanges',
        currentDate: '=exchangeRatesDate',
        countryCode: '@'
      },
      templateUrl: 'payments/exchange-rates-directive.tpl.html',
      replace: false,
      controllerAs: 'exchangeRates',
      controller: ["$scope", "$log", function ($scope, $log) {
        var vm = this;
        vm.name = 'exchangeRates';
        vm.countryCode = $scope.countryCode;
        vm.currentDate = $scope.currentDate || new Date();
        vm.rateType = {};
        vm.buy = function (item) {
          $log.debug("Buy method is not implemented!");
          $log.debug("Exchange item: " + JSON.stringify(item));
        };
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:ExchangeRatesCtrl
     *
     * @description
     *
     */
    ExchangeRatesCtrl.$inject = ["$state", "$log", "ExchangeRatesService", "HelperService", "$localStorage"];
    angular
        .module('payments')
        .controller('ExchangeRatesCtrl', ExchangeRatesCtrl);

  function ExchangeRatesCtrl($state, $log, ExchangeRatesService, HelperService, $localStorage) {
        var vm = this;
        vm.ctrlName = 'ExchangeRatesCtrl';
        var dateString = HelperService.getDateTimeAsString(HelperService.getYesterday().firstDay);
        vm.exchangeRatesParams = {
            page: 0,
            pageSize: 1000,
            date: '',
            includeList: ['currency']
        };
        vm.currentDate = HelperService.getYesterday().firstDay;
        vm.exchangeRatesList = {};

        vm.init = function () {
            ExchangeRatesService.getExchangeRates(vm.exchangeRatesParams)
                .then(function (response) {
                    vm.exchangeRatesList = response;
                })
                .catch(function () {
                    $log.error('Error loading exchange rates!');
                });
        };

        vm.goBack = function () {
            $state.go('payments.paymentsOverview');
        };

        vm.buy = function () {
            $log.debug("Buy method not implemented.");
        }

        vm.init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:EBookPayCtrl
   *
   * @description
   *
   */
  EBookPayCtrl.$inject = ["$stateParams", "$state", "PaymentsService", "$log", "HelperService", "AccountsService", "PaymentTypesService", "$timeout", "CurrencyService", "ExchangeRatesService", "Notification"];
  angular
    .module('payments')
    .controller('EBookPayCtrl', EBookPayCtrl);

  function EBookPayCtrl($stateParams, $state, PaymentsService, $log, HelperService, AccountsService, PaymentTypesService,
                         $timeout, CurrencyService, ExchangeRatesService, Notification) {
    var vm = this;
    vm.ctrlName = 'EBookPayCtrl';
    vm.currentStep = 1;
    vm.ebookType = $stateParams.payType;

    vm.paymentObject = {};
    vm.tempEbookObj = {
      fromAccountSelect: {},
      toAccountSelect: {},
      fromAccountAmountInput: '',
      toAccountAmountInput: '',
      dueDateInput: new Date(),
      formSubmitted: false,
      fromCurrencySymbol: '',
      toCurrencySymbol: '',
      currentDate: HelperService.getYesterday().firstDay,
      hasEbookWithSelectedCurrency: true
    };

    vm.paymentResponse = {};
    vm.toAccountDropdown = false;
    vm.forUpdate = false;
    vm.accountsFrom = [];
    vm.accountsTo = [];
    vm.currencyList = [];
    var tempId = '';

    vm.templatesFilter = {
      paymentTypeGroup: 'ESavingPayment',
      page: 0,
      pageSize: 1000
    };

    vm.accountsFilter = {
      accountId: $stateParams.accountId,
      accountTypeGroupList: 'CurrentAccount',
      includeList: ['subAccountList']
    };

    vm.datePickerOpened = false;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.toggleToAccount = function () {
      if (vm.accountsTo.length > 1)
        vm.toAccountDropdown = !vm.toAccountDropdown;
    };

    vm.toggleFromAccount = function () {
      if (vm.accountsFrom.length > 1)
        vm.fromAccountDropdown = !vm.fromAccountDropdown;
    };

    var setToAccountList = function (accountId) {
      vm.accountsTo = _.filter(vm.accountsFrom, function (item) {
        return item.accountId != accountId;
      });
    };

    var setToAccount = function (accountNumber) {
      setToAccountList(vm.tempEbookObj.fromAccountSelect.accountId);
      vm.tempEbookObj.toAccountSelect = vm.accountsTo[0];
    };

    vm.setAccountTo = function (item) {
      vm.tempEbookObj.toAccountSelect = item;
      vm.tempEbookObj.toCurrencySymbol = item.currencySymbol;
      vm.tempEbookObj.hasEbookWithSelectedCurrency = true;
      vm.fromAccountDropdown = false;
      vm.toAccountDropdown = false;
      vm.changeSellCurrency();
    };

    vm.setAccountFrom = function (item) {
      vm.tempEbookObj.fromAccountSelect = item;
      vm.tempEbookObj.fromCurrencySymbol = item.currencySymbol;
      vm.fromAccountDropdown = false;
      vm.toAccountDropdown = false;
    };

    vm.getDebitAccountList = function () {
      return PaymentTypesService.getByGroup({
        paymentTypeGroup: 'ESavingPayment'
      })
        .then(function (response) {
        if (_.isArray(response.result) && response.result.length > 0) {
          vm.accountsFrom = response.result[0].debitAccountList;
          _.forEach(vm.accountsFrom, function (item) {
            if (item.accountDescription) {
              item.optionValue = item.accountDescription + ' - ' + item.iban;
            }
          });
        }
      })
        .catch(function (error) {
        $log.error(error);
      });
    };

    var setDefaultCurrency = function () {
      if (vm.tempEbookObj.toAccountSelect) {
        var index = _.findIndex(vm.currencyList, function(item) {
          return item === vm.tempEbookObj.toAccountSelect.currencySymbol;
        });

        if(index != -1) {
          vm.tempEbookObj.toCurrencySymbol = vm.currencyList[index];
        }
      } else {
        vm.tempEbookObj.toCurrencySymbol = vm.currencyList[0].symbol;
      }
    };

    var clearInput = function () {
      vm.templateName = '';
      vm.tempEbookObj.fromAccountAmountInput = '';
      vm.tempEbookObj.dueDateInput = new Date();
      //vm.tempEbookObj.purposeOfPaymentInput = '';
      vm.tempEbookObj.toAccountAmountInput = '';
      setDefaultCurrency();
      vm.tempEbookObj.formSubmitted = false;
    };

    var loadCurrencies = function () {
      return CurrencyService.getCurrencyPage({
        isCurrencyForPayment: true,
        pageSize: 1000
      })
        .then(function (response) {
        _.forEach(response.result, function(item) {
          vm.currencyList.push(item.symbol);
        });
        vm.tempEbookObj.toCurrencySymbol = vm.currencyList[0];
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    var prepareCurrencyExchangeObject = function () {
      var tempObj = {
        currencySymbolFrom: vm.tempEbookObj.fromAccountSelect.currencySymbol,
        amount: vm.tempEbookObj.fromAccountAmountInput,
        currencySymbolTo: vm.tempEbookObj.toCurrencySymbol,
        fixedAmount: 'D'
      };
      return tempObj;
    };

    vm.exchangeCurrency = function (flag) {
      if(vm.tempEbookObj.fromAccountSelect.currencySymbol !== vm.tempEbookObj.toCurrencySymbol) {
        $timeout(function () {
          if (vm.tempEbookObj.fromAccountAmountInput) {
            var exchangeRateParams = prepareCurrencyExchangeObject();
            ExchangeRatesService.calculateExchangeRate(exchangeRateParams)
              .then(function (response) {
              if (exchangeRateParams.fixedAmount === 'D') {
                vm.tempEbookObj.toAccountAmountInput = response.calculatedAmount.toFixed(5);
              }
              if(flag)
                setDefaultCurrency();
            })
              .catch(function (error) {
              HelperService.showMessage(error, 'error');
            });
          }
        }, 0);
      } else {
        vm.tempEbookObj.toAccountAmountInput = vm.tempEbookObj.fromAccountAmountInput;
      }
    };

    vm.changeSellCurrency = function (changedFromList) {

      if(changedFromList && vm.tempEbookObj.toCurrencySymbol){
        // Find first account with selected currency
        var firstAccountWithSelectedCurrency = _.find(vm.accountsTo, function(account){
          return account.currencySymbol == vm.tempEbookObj.toCurrencySymbol && account.accountNumber == vm.tempEbookObj.toAccountSelect.accountNumber
        });

        // Set selected "to account" based on currency (if exists)
        if(firstAccountWithSelectedCurrency){
          vm.tempEbookObj.toAccountSelect = firstAccountWithSelectedCurrency;
          vm.tempEbookObj.hasEbookWithSelectedCurrency = true;
        }else{
          vm.tempEbookObj.hasEbookWithSelectedCurrency = false;
        }
      }

      if (vm.tempEbookObj.fromAccountAmountInput) {
        vm.exchangeCurrency(false);
      }
    };

    ////SUBMIT/////
    var createPaymentObject = function () {
      if(vm.ebookType === 'Pay In') {
        return {
          accountId: vm.tempEbookObj.fromAccountSelect.accountId,
          fromAccountNumber: HelperService.parseAccountNumber(vm.tempEbookObj.fromAccountSelect.accountNumber),
          toAccountNumber: HelperService.parseAccountNumber(vm.tempEbookObj.toAccountSelect.accountNumber),
          amount: vm.tempEbookObj.fromAccountAmountInput,
          dueDate: vm.tempEbookObj.dueDateInput,
          currencySymbol: vm.tempEbookObj.fromAccountSelect.currencySymbol,
          paymentTypeGroup: 'ESavingPayment',
          //purpose: vm.tempEbookObj.purposeOfPaymentInput,
          domesticPayment: {
            destinationCurrencySymbol: vm.tempEbookObj.toCurrencySymbol,
            purposeCode: 'I'
          }
        };
      } else {
        return {
          accountId: vm.tempEbookObj.fromAccountSelect.accountId,
          fromAccountNumber: HelperService.parseAccountNumber(vm.tempEbookObj.fromAccountSelect.accountNumber),
          toAccountNumber: HelperService.parseAccountNumber(vm.tempEbookObj.toAccountSelect.accountNumber),
          amount:vm.tempEbookObj.fromAccountAmountInput,
          dueDate: vm.tempEbookObj.dueDateInput,
          currencySymbol: vm.tempEbookObj.fromAccountSelect.currencySymbol,
          paymentTypeGroup: 'ESavingPayment',
          domesticPayment : {
            destinationCurrencySymbol: vm.tempEbookObj.toAccountSelect.currencySymbol,
            purposeCode: 'O'
          }
        };
      };
    };

    var postPaymentAction = function (response) {
      vm.paymentResponse = response;
      vm.paymentResponse.paymentTypeGroup = 'ESavingPayment';
      Notification.clearAll();
      vm.currentStep = 2;
    };

    vm.eBookPaySubmit = function () {
      vm.tempEbookObj.formSubmitted = true;
      if (!vm.eBookPayForm.$valid) {
        return;
      }
      var temPaymentObj = createPaymentObject();
      tempId = vm.tempEbookObj.toAccountSelect.accountId;
      if ($stateParams.editable) {
        vm.forUpdate = true;
      }

      if (vm.forUpdate) {
        vm.submitButtonDisabled = true;
        if (vm.paymentResponse.id)
          temPaymentObj.id = vm.paymentResponse.id
          else
            temPaymentObj.id = $stateParams.paymentId;

        PaymentsService.updatePayment(temPaymentObj.id, temPaymentObj)
          .then(function (response) {
          postPaymentAction(response);
          vm.forUpdate = false;
          vm.submitButtonDisabled = false;
        })
          .catch(function (error) {
          HelperService.showMessage(error, 'error');
          vm.forUpdate = false;
          vm.submitButtonDisabled = false;
        });
      } else {
        PaymentsService.insertPayment(temPaymentObj)
          .then(function (response) {
          postPaymentAction(response);
          vm.submitButtonDisabled = false;

        })
          .catch(function (error) {
          HelperService.showMessage(error, 'error');
          vm.submitButtonDisabled = false;
        });
      }
    };

    vm.getAccountsFromEbook = function () {
      switch ($state.current.name) {
        case 'payments.ebookPay.payIn':
          AccountsService.getAccountById($stateParams.accountId)
            .then(function (response) {
            vm.tempEbookObj.toAccountSelect = response;
            vm.accountsTo.push(vm.tempEbookObj.toAccountSelect);
            $log.debug('toEbook', response);
            if (response.parentAccountId) {
              vm.getMasterAccountFromPaymentTypes(response.parentAccountId, response.currencySymbol, true, 'ebook', response.accountId);
            }
          })
            .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
          break;
        case 'payments.ebookPay.payOut':
          AccountsService.getAccountById($stateParams.accountId)
            .then(function (response) {
            vm.tempEbookObj.fromAccountSelect = response;
            vm.accountsFrom.push(vm.tempEbookObj.fromAccountSelect);
            $log.debug('fromAccountSelect', response);
            if (response.parentAccountId) {
              vm.getMasterAccountFromPaymentTypes(response.parentAccountId, response.currencySymbol, false);
            }
          })
            .catch(function (error) {
            HelperService.showMessage(error, 'error');
          })
          break;
      }
    };

    vm.getMasterAccountFromPaymentTypes = function (id, symbol, payIn, flag, ebookId) {
      vm.paymentTypesFilter = {
        masterAccountId: id,
        paymentTypeGroup: 'ESavingPayment',
        currencySymbol: symbol,
        payIn: payIn
      };
      PaymentTypesService.getByGroup(vm.paymentTypesFilter)
        .then(function (response) {
        if (!payIn) {
          vm.accountsTo = response.result[0].creditAccountList;
          if(vm.accountsTo.length > 0) {
            var index = _.findIndex(vm.accountsTo, function(item) {
              return item.currencySymbol === symbol;
            });
            if(index != -1) {
              vm.tempEbookObj.toAccountSelect = vm.accountsTo[index];
            } else {
              vm.tempEbookObj.toAccountSelect = vm.accountsTo[0];
            }
          }
        } else {
          vm.accountsFrom = response.result[0].debitAccountList;
          vm.accountsTo = response.result[0].creditAccountList;
          if(vm.accountsFrom.length > 0) {
            var index = _.findIndex(vm.accountsFrom, function(item) {
              return item.currencySymbol === symbol;
            });
            if(index != -1) {
              vm.tempEbookObj.fromAccountSelect = vm.accountsFrom[index];
            } else {
              vm.tempEbookObj.fromAccountSelect = vm.accountsFrom[0];
            }
          }
          if(vm.accountsTo.length > 0) {
            var index = _.findIndex(vm.accountsTo, function(item) {
              if(ebookId) {
                return item.currencySymbol === symbol && item.accountId === ebookId;
              } else {
                return item.currencySymbol === symbol;
              }
            });
            if(index != -1) {
              vm.tempEbookObj.toAccountSelect = vm.accountsTo[index];
            } else {
              vm.tempEbookObj.toAccountSelect = vm.accountsTo[0];
            }

            //ako se dolazi s ebook na pay in, da ostane samo ta knjizica u to account
            if(flag=='ebook') {
              vm.accountsTo = [];
              vm.accountsTo.push(vm.tempEbookObj.toAccountSelect);
            }
            //ako se dolazi s current na pay in, da ostane samo taj racun u from account
            if(flag=='current') {
              vm.accountsFrom = [];
              vm.accountsFrom.push(vm.tempEbookObj.fromAccountSelect);
            }
          }
          if(vm.tempEbookObj.fromAccountSelect && vm.tempEbookObj.fromAccountSelect.currencySymbol !== 'HRK'){
            filterCurrencyList();
          }
          setDefaultCurrency();
        }
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    }

    vm.getAccountsFromCurrent = function (id, symbol) {
      vm.getMasterAccountFromPaymentTypes(id, symbol, true, 'current');
    };

    var mapWithPaymentResponse = function () {
      vm.tempEbookObj.fromAccountAmountInput = vm.paymentResponse.amount.toFixed(5);
      vm.tempEbookObj.dueDateInput = new Date(vm.paymentResponse.dueDate);
    };

    vm.backToEbookPay = function () {
      clearInput();
      vm.currentStep = 1;
    };

    vm.editPayment = function () {
      mapWithPaymentResponse();
      vm.forUpdate = true;
      vm.currentStep = 1;
    };

    vm.deletePayment = function () {
      PaymentsService.deletePayment(vm.paymentResponse.id)
        .then(function (response) {
        HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], vm.paymentResponse.id);
        $state.go('payments.paymentsOverview');
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.getAccountsFromPayment = function (accountId, toAccountNumber) {
      AccountsService.getAccountById(accountId)
        .then (function (response) {
        if(response.accountType.group === 'CurrentAccount') {
          vm.ebookType = 'Pay In';
          vm.tempEbookObj.fromAccountSelect = response;
          vm.accountsFrom.push(vm.tempEbookObj.fromAccountSelect);
          loadCurrencies()
            .then(function(res) {
            PaymentTypesService.getByGroup({
              paymentTypeGroup: 'ESavingPayment',
              payIn: true,
              masterAccountId: accountId,
              currencySymbol: response.currencySymbol
            })
              .then(function(paymentTypeResponse) {
              if(paymentTypeResponse.result[0].creditAccountList.length > 0) {
                var index = _.findIndex(paymentTypeResponse.result[0].creditAccountList, function(item) {
                  var temp = toAccountNumber.replace(/\D+$/g, "");
                  return item.accountNumber === temp;
                });
                vm.tempEbookObj.toAccountSelect = paymentTypeResponse.result[0].creditAccountList[index];
                vm.accountsTo.push(vm.tempEbookObj.toAccountSelect);
                vm.tempEbookObj.toCurrencySymbol = vm.tempEbookObj.toAccountSelect.currencySymbol;
                vm.exchangeCurrency(true);
              }
            })
              .catch(function (error) {
              HelperService.showMessage(error, 'error');
            });
          })
            .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });

        }  else {
          vm.ebookType = 'Pay Out';
          vm.tempEbookObj.fromAccountSelect = response;
          vm.accountsFrom.push(vm.tempEbookObj.fromAccountSelect);
          AccountsService.getAccountById(response.parentAccountId)
            .then(function(response) {
            vm.tempEbookObj.toAccountSelect = response;
            vm.accountsTo.push(vm.tempEbookObj.toAccountSelect);
          })
            .catch(function(error) {
            HelperService.showMessage(error, 'error');
          });
        }
      })
        .catch(function(error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.init = function () {
      switch ($state.current.name) {
        case 'payments.ebookPay.payIn':
          vm.ebookType = 'Pay In';
          loadCurrencies()
            .then(function (response) {
            AccountsService.getAccountById($stateParams.accountId)
              .then(function (accountResponse) {
              if (!accountResponse.parentAccountId) {
                vm.getAccountsFromCurrent(accountResponse.accountId, accountResponse.currencySymbol);
              }
              if (accountResponse.parentAccountId && accountResponse.accountType.group === 'SavingAccountTypes') {
                vm.getAccountsFromEbook();
              }
            })
              .catch(function (error) {
              HelperService.showMessage(error, 'error');
            });
          })
            .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
          break;
        case 'payments.ebookPay.payOut':
          vm.ebookType = 'Pay Out';
          vm.getAccountsFromEbook();
          break;
        case 'payments.ebookPay.fromPayment':
          if($stateParams.paymentId) {
            PaymentsService.getById($stateParams.paymentId)
              .then(function(response) {
              vm.paymentObject = response;
              vm.tempEbookObj.fromAccountAmountInput = response.amount;
              vm.getAccountsFromPayment(response.accountId, response.toAccountNumber);
            })
              .catch(function(error) {
              HelperService.showMessage(error, 'error');
            });
          }
          break;
      }
    };

    // If from account currency symbol is not HRK, use only HRK and that value.
    var filterCurrencyList = function(){
      vm.currencyList = _.filter(vm.currencyList, function(item){
        return item === 'HRK' || item === vm.tempEbookObj.fromAccountSelect.currencySymbol;
      });
    };

    vm.init();
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:DomesticPaymentSrbCtrl
     *
     * @description
     *
     */
    DomesticPaymentSrbCtrl.$inject = ["$rootScope", "$location", "CTLocalizationService", "UserSettingsService", "$state", "$log", "HelperService", "ValidationService", "PurposeCodesService", "BanksService", "CountriesService", "PaymentTypesService", "PaymentsService", "CreditAccountRegisterService", "$q", "PaymentTemplatesService", "ConfigEndpointService", "$timeout", "ReferenceModelService", "$stateParams", "PaymentFilterService", "Notification", "AlertService", "ImagesService", "GoogleTagManagerHelperService"];
    angular
        .module('payments')
        .controller('DomesticPaymentSrbCtrl', DomesticPaymentSrbCtrl);

    function DomesticPaymentSrbCtrl($rootScope, $location, CTLocalizationService, UserSettingsService, $state, $log, HelperService,
        ValidationService, PurposeCodesService, BanksService, CountriesService,
        PaymentTypesService, PaymentsService, CreditAccountRegisterService, $q,
        PaymentTemplatesService, ConfigEndpointService, $timeout, ReferenceModelService,
        $stateParams, PaymentFilterService, Notification, AlertService, ImagesService, GoogleTagManagerHelperService) {
        var vm = this;
        vm.ctrlName = 'DomesticPaymentSrbCtrl';
        vm.images = {};
        vm.isRetrieval = false;
        if ($stateParams.myParam == 'retrieval') {
            vm.isRetrieval = true;
        }

        vm.currentStep = 1;

        vm.paymentObject = {};
        vm.tempDompObj = {
            fromAccountSelect: {},
            purposeCodeSelect: {},
            purposeOfPaymentInput: '',
            amountInput: '',
            dateInput: new Date(),
            bicCodeInput: '',
            toAccountInput: '',
            referenceCodeInput: '',
            referenceModelSelect: {},
            referenceNumberInput: '',
            payersNameInput: '',
            payersAddressInput: '',
            payersCityInput: '',
            payersSepaInput1: '',
            payersSepaInput2: '',
            receiversNameInput: '',
            receiversAddressInput: '',
            receiversPostalCodeAndCityInput: '',
            receiversCountrySelect: {},
            receiversSepaInput1: '',
            receiversSepaInput2: '',
            isUrgentPaymentCheckbox: false,
            formSubmitted: false
        };

        vm.split = function (input) {
            return HelperService.splitReferenceNumber(input);
        }

        vm.defaultCurrency = '';
        vm.forUpdate = false;
        vm.smsAuthentificate = false;
        vm.smsPasswordInput = '';
        vm.bankCharges = '';

        vm.datePickerOpened = false;
        vm.dateOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        /*vm.disabled = function (date, mode) {
            if(vm.countryCode != 'sr')
                return (mode === 'day' && (date.getDay() === 0));
            return;
        };*/

        vm.openDatePicker = function () {
            vm.datePickerOpened = true;
        };

        vm.paymentTypeGroupDomestic = {};
        vm.paymentTypesGroupFilter = {
            paymentTypeGroup: 'DomesticPayment'
        };

        vm.purposeCodesList = {};
        vm.purposeCodesFilter = {
            pageSize: 1000
        };

        vm.banksList = {};
        vm.banksFilter = {
            pageSize: 1000
        };

        vm.countriesCodeList = {};
        vm.countriesCodeFilter = {
            pageSize: 1000
        };

        vm.referenceModelList = [];
        vm.referenceModelFilter = {
            pageSize: 1000
        };

        vm.payeeFilter = {
            paymentTypeGroup: 'DomesticPayment',
            orderBy: 'receiverName ASC',
            page: 0,
            pageSize: 1000
        };

        vm.templatesFilter = {
            paymentTypeGroup: 'DomesticPayment',
            page: 0,
            pageSize: 1000
        };

        vm.templateList = {};

        vm.tmpSearchText = {
            name: ''
        };

        vm.templateName = '';

        vm.fromAccountDropdown = false;
        vm.onlyNumbers = /^[0-9 ]+$/;
        vm.payeeInputField = /[^A-Za-zČčĐđŽžŠšĆć\+]*$/;

        vm.searchFilterExpanded = false;

        vm.paymentTypeGroupDomestic = {};
        vm.paymentTypesGroupFilter = {
            paymentTypeGroup: 'DomesticPayment'
        };

        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

        vm.checkModul97Reference = function (reference) {
            var isValid = ValidationService.checkModul97Reference(reference);
            vm.domesticPaymentForm.referenceNumberInput.$setValidity('modul97reference', isValid)
        };

        vm.getPaymentTypeGroup = function () {
            return PaymentTypesService.getByGroup(vm.paymentTypesGroupFilter)
                .then(function (response) {
                    vm.paymentTypeGroupDomestic = response;

                    _.forEach(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (value) {
                        value.optionValue = value.accountDescription + ' - ' + value.iban;
                    });

                    $log.debug("paymentTypeGroupDomestic", vm.paymentTypeGroupDomestic);
                    if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                        vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                    }
                })
                .catch(function () {
                    $log.error('Error loading paymentTypeGroupDomestic!');
                });
        };

        vm.getPurposeCodesPage = function () {
            return PurposeCodesService.getPage(vm.purposeCodesFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        value.optionValue = value.id + ' - ' + value.description;
                        vm.tempDompObj.purposeOfPaymentInput = value.description
                    });
                    vm.purposeCodesList = response;
                    /*if (vm.purposeCodesList.result.length > 0) {
            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
          }
*/
                    if (vm.purposeCodesList.result.length > 0) {
                        var index = _.findIndex(vm.purposeCodesList.result, function (item) {
                            return item.id === '89';
                        });
                        console.log("Ovdje", index)
                        vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[index];
                        vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[index].description;
                    }
                    $log.debug("purposeCodesList", vm.purposeCodesList);
                })
                .catch(function () {
                    $log.error('Error loading purpose codes!');
                });
        };

        vm.getBanksPage = function () {
            return BanksService.getPage(vm.banksFilter)
                .then(function (response) {
                    vm.banksList = response;
                    $log.debug("banksList", vm.banksList);
                })
                .catch(function () {
                    $log.error('Error loading banks codes!');
                });
        };

        vm.changePurpose = function (purposeChange) {
            // Check if input is coming from purpose code list
            var purpose = _.findWhere(vm.purposeCodesList.result, {
                description: vm.tempDompObj.purposeOfPaymentInput
            });
            if (purpose) {
                vm.tempDompObj.purposeOfPaymentInput = purposeChange.description;
            }
            // var purposeCode = _.findIndex(vm.purposeCodesList.result, function (item) {
            //     vm.tempDompObj.purposeOfPaymentInput = item.description;
            //     return item.id == code.id;
            // });
        };

        vm.getCountriesPage = function () {
            return CountriesService.getPage(vm.countriesCodeFilter)
                .then(function (response) {
                    vm.countriesCodeList = response;
                    var countryIndex = _.findIndex(vm.countriesCodeList.result, function (o) {
                        return o.code == '191';
                    });
                    vm.tempDompObj.receiversCountrySelect = vm.countriesCodeList.result[countryIndex];

                    $log.debug("countriesCodeList", vm.countriesCodeList);
                })
                .catch(function () {
                    $log.error('Error loading bic banks codes!');
                });
        };
        vm.getUserSettingsPage = function () {
            UserSettingsService.getPage(vm.userSettingsFilter)
                .then(function (response) {
                    var userSettings = response.result[0];
                    vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                    vm.tempDompObj.payersAddressInput = userSettings.address1;
                    vm.tempDompObj.payersCityInput = userSettings.city;
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        var createPaymentObject = function () {
            var paymentObject = {};
            paymentObject.domesticPayment = {};
            paymentObject.accountId = vm.tempDompObj.fromAccountSelect.accountId;
            paymentObject.fromAccountNumber = vm.tempDompObj.fromAccountSelect.iban;
            paymentObject.toAccountNumber = vm.tempDompObj.toAccountInput.replace(/-/g, '');
            paymentObject.currencySymbol = vm.tempDompObj.fromAccountSelect.currencySymbol;
            paymentObject.purpose = vm.tempDompObj.purposeOfPaymentInput;
            paymentObject.dueDate = vm.tempDompObj.dateInput;
            paymentObject.amount = vm.tempDompObj.amountInput;
            paymentObject.paymentTypeGroup = 'DomesticPayment';
            paymentObject.domesticPayment.receiverName = vm.tempDompObj.receiversNameInput;
            paymentObject.domesticPayment.receiverAddress1 = vm.tempDompObj.receiversAddressInput;
            paymentObject.domesticPayment.receiverCity = vm.tempDompObj.receiversPostalCodeAndCityInput;
            paymentObject.domesticPayment.referenceFrom = "";
            paymentObject.domesticPayment.urgency = vm.tempDompObj.isUrgentPaymentCheckbox ? '1' : '0';

            // if (vm.tempDompObj.referenceModelSelect) {
            //     if (vm.tempDompObj.referenceModelSelect === "  ") {
            //         paymentObject.domesticPayment.referenceTo = '00' + vm.tempDompObj.referenceNumberInput;
            //     } else
            //         paymentObject.domesticPayment.referenceTo =
            //         //vm.tempDompObj.referenceModelSelect + ' ' + vm.tempDompObj.referenceNumberInput;
            //         vm.tempDompObj.referenceModelSelect.concat(vm.tempDompObj.referenceNumberInput);
            // } else if ((!vm.tempDompObj.referenceModelSelect) && (vm.tempDompObj.referenceNumberInput)) {
            //     vm.tempDompObj.referenceModelSelect = '00';
            //     /** paymentObject.domesticPayment.referenceTo = vm.tempDompObj.referenceModelSelect + ' ' + vm.tempDompObj.referenceNumberInput;**/
            //     vm.tempDompObj.referenceModelSelect.concat(vm.tempDompObj.referenceNumberInput);
            // } else {
            //     paymentObject.domesticPayment.referenceTo = '00';
            // }
            if (!vm.tempDompObj.referenceModelSelect && !vm.tempDompObj.referenceNumberInput) {
                paymentObject.domesticPayment.referenceTo = '00';
            } else if (!vm.tempDompObj.referenceModelSelect && vm.tempDompObj.referenceNumberInput) {
                paymentObject.domesticPayment.referenceTo = '00' + vm.tempDompObj.referenceNumberInput;
            } else
                paymentObject.domesticPayment.referenceTo = "" + vm.tempDompObj.referenceModelSelect + vm.tempDompObj.referenceNumberInput;

            ///zbog povrata
            if (vm.isRetrieval) {
                paymentObject.purposeCodeDPS = '9' + vm.tempDompObj.purposeCodeSelect.id;
            } else {
                paymentObject.purposeCodeDPS = '2' + vm.tempDompObj.purposeCodeSelect.id;
            }
            return paymentObject;
        };

        vm.insertedPaymentObject = {};
        vm.insertedPaymentObjectDomp = {};

        var postPaymentAction = function (response) {
            vm.insertedPaymentObject = response;
            vm.insertedPaymentObject.paymentTypeGroup = "DomesticPayment";
            vm.insertedPaymentObject.senderInfo = {
                senderName: vm.tempDompObj.fromAccountSelect.ownerName,
                senderAddress1: vm.tempDompObj.fromAccountSelect.ownerAddress,
                senderCity: vm.tempDompObj.fromAccountSelect.ownerCity
            };
            vm.insertedPaymentObject.debtorName = vm.tempDompObj.payersSepaInput1;
            vm.insertedPaymentObject.debtorName2 = vm.tempDompObj.payersSepaInput2;
            vm.insertedPaymentObject.creditorName = vm.tempDompObj.receiversSepaInput1;
            vm.insertedPaymentObject.creditorName2 = vm.tempDompObj.receiversSepaInput2;
            vm.insertedPaymentObject.purposeCodeValue = vm.tempDompObj.purposeCodeSelect;

            vm.insertedPaymentObject.receiversNameInput = vm.tempDompObj.receiversNameInput;
            vm.insertedPaymentObjectDomp.referenceTo = vm.insertedPaymentObject.referenceTo;
            if (vm.insertedPaymentObject.referenceTo) {
                var model = vm.insertedPaymentObject.referenceTo.substring(0, 2);
                var number = vm.insertedPaymentObject.referenceTo.substring(2);
                if (model === "00") {
                    vm.insertedPaymentObject.referenceTo = number;
                }
            }
            Notification.clearAll();
            vm.currentStep = 2;

            HelperService.scrollToTop();

        };

        vm.submitPayment = function () {
            vm.tempDompObj.formSubmitted = true;
            if (!vm.domesticPaymentForm.$valid) {
                return;
            }

            if (!vm.formSubmitted) {
                var objectForInsert = createPaymentObject();

                if (vm.forUpdate) {
                    objectForInsert.id = vm.insertedPaymentObject.id;
                    PaymentsService.updatePayment(vm.insertedPaymentObject.id, objectForInsert)
                        .then(function (response) {
                            postPaymentAction(response);
                            vm.forUpdate = false;
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            vm.forUpdate = false;
                            // vm.domesticPaymentForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                } else {
                    PaymentsService.insertPayment(objectForInsert)
                        .then(function (response) {
                            postPaymentAction(response);

                            GoogleTagManagerHelperService.pushVirtualPageView('payments/domestic-payment/toconfirm', 'domestic-payment toconfirm', $location.host() + 'payments/domestic-payment/toconfirm');
                        })

                    .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            // vm.domesticPaymentForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                }
            }
        };

        var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        $rootScope.$on('appLanguageChangedHeader', function () {
            sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        });

        vm.deletePayment = function () {
            //swal({
            //  title: sweetAlertOptions.areYouSure,
            //  type: "info",
            //  showCancelButton: true,
            //  confirmButtonClass: "btn-default",
            //  confirmButtonText: sweetAlertOptions.yes,
            //  cancelButtonText: sweetAlertOptions.no,
            //  closeOnConfirm: true,
            //  closeOnCancel: true
            //}, function (isConfirm) {
            //  if (isConfirm) {
            //    PaymentsService.deletePayment(vm.insertedPaymentObject.id)
            //      .then(function (response) {
            //      HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], vm.insertedPaymentObject.id);
            //      $state.go('payments.paymentsOverview');
            //    })
            //      .catch(function (error) {
            //      HelperService.showMessage(error, 'error');
            //    });
            //  }
            //});

            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        PaymentsService.deletePayment(vm.insertedPaymentObject.id)
                            .then(function (response) {
                                AlertService.deletedPaymentAlert({
                                        paymentName: vm.insertedPaymentObject.id,
                                        type: 'payment'
                                    })
                                    .then(function () {
                                        $state.go('payments.paymentsOverview');
                                    });
                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    }
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });
        };

        var mapWithPaymentResponse = function () {
            vm.tempDompObj.amountInput = vm.insertedPaymentObject.amount
            vm.tempDompObj.receiversNameInput = vm.insertedPaymentObject.receiverName;
            vm.tempDompObj.receiversAddressInput = vm.insertedPaymentObject.receiverAddress1;
            vm.tempDompObj.receiversPostalCodeAndCityInput = vm.insertedPaymentObject.receiverCity;
            vm.tempDompObj.toAccountInput = vm.insertedPaymentObject.toAccountNumber;
            vm.tempDompObj.dateInput = new Date(vm.insertedPaymentObject.dueDate);
            vm.tempDompObj.purposeOfPaymentInput = vm.insertedPaymentObject.purpose;

            var accountIndex = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
                return item.accountId == vm.insertedPaymentObject.accountId;
            });

            var purposeCodeIndex = _.findIndex(vm.purposeCodesList.result, function (item) {
                return item.id == vm.insertedPaymentObject.purposeCodeDPS;
            });

            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[accountIndex];
            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[purposeCodeIndex];
        };

        vm.editPayment = function () {
            vm.forUpdate = true;
            vm.currentStep = 1;

            if (vm.tempDompObj.referenceModelSelect === "00") {
                vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
            } else {
                var index = _.findIndex(vm.referenceModelList, function (item) {
                    return item == vm.tempDompObj.referenceModelSelect;
                });
                vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];
            }

            // mapWithPaymentResponse();
        };

        vm.signPayment = function () {
            PaymentsService.signPayment(vm.insertedPaymentObject.id)
                .then(function (response) {
                    vm.currentStep = 3;
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        var loadAccountData = function (accountId) {
            var index = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
                return item.accountId == accountId;
            });
            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[index];
        };

        //var loadPaymentDataFromTemplate = function (templateId) {
        //  if (templateId) {
        //    PaymentTemplatesService.getById(templateId)
        //      .then(function (response) {
        //        vm.tempDompObj.amountInput = $filter('number')(response.amount, 2);
        //        vm.tempDompObj.toAccountInput = response.toAccountNumber;
        //        vm.tempDompObj.purposeOfPaymentInput = response.purpose;
        //        vm.tempDompObj.receiversNameInput = response.receiverName || '';
        //        vm.tempDompObj.receiversAddressInput = response.receiverAddress1 || '';
        //        vm.tempDompObj.receiversPostalCodeAndCityInput = response.receiverCity || '';
        //        loadAccountData(response.accountId);
        //      })
        //      .catch(function (error) {
        //        HelperService.showMessage(error, 'error');
        //      });
        //  }
        //};

        //////////////////////////CUSTOM SELECT//////////////////////
        vm.searchFilterExpanded = false;

        vm.toggleFilterSelection = function () {
            if (!vm.isRetrieval) {
                vm.searchFilterExpanded = !vm.searchFilterExpanded;
            }
        };

        vm.searchPayee = function () {
            vm.searchFilterExpanded = true;
        };

        vm.getPayees = function () {
            PaymentTemplatesService.getPage(vm.payeeFilter)
                .then(function (response) {
                    vm.payeeList = response.result;
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.selectPayee = function (id) {
            var index = _.findIndex(vm.payeeList, function (item) {
                vm.tempDompObj.toAccountInput = item.toAccountNumber;
                vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
                vm.tempDompObj.receiversNameInput = item.receiverName;
                vm.tempDompObj.receiversPostalCodeAndCityInput = item.receiverCity;
                return item.id == id;
            });

            vm.formatAccountNumber(vm.payeeList[index].toAccountNumber);
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.removeSearch = function () {
            vm.tempDompObj.receiversNameInput = '';
        };

        vm.searchPayeeBy = function (searchrow) {
            return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1 ||
                angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1);
        };

        ///select template component

        vm.searchTemplate = function () {
            vm.searchTemplateFilterExpanded = true;

            if (vm.searchTemplateFilterExpanded === true) {

                $timeout(function () {
                    var searchTemplatesInput = angular.element('#searchTemplatesInput');
                    searchTemplatesInput.focus();
                }, 500);
            }
        };

        vm.toggleTemplateFilterSelection = function () {
            if (!vm.isRetrieval) {
                vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
                if (vm.searchTemplateFilterExpanded && (!vm.templateList.result || vm.templateList.result.length === 0)) {
                    vm.getPaymentTemplatesPage();
                }
            }
        };

        vm.getPaymentTemplatesPage = function () {
            PaymentTemplatesService.getPage(vm.templatesFilter)
                .then(function (response) {
                    vm.templateList = response;
                    if (vm.templateList)
                        populateTemplatesWithImages();
                    $log.debug(vm.templateList);
                }).catch(function (error) {
                    $log.error(error);
                });
        };
        vm.selectedTemplate = {};
        vm.selectTemplate = function (id) {
            GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentTemplateSelection', 'Template with id ' + id + ' selected');
            var item = _.findWhere(vm.payeeList, {
                id: id
            });
            vm.templateName = item.name;
            vm.tempDompObj.toAccountInput = item.toAccountNumber;
            vm.formatAccountNumber(item.toAccountNumber);
            vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
            vm.tempDompObj.receiversNameInput = item.receiverName;
            vm.tempDompObj.receiversPostalCodeAndCityInput = item.receiverCity;
            //vm.tempDompObj.amountInput = $filter('number')(item.amount, 2);

            if (item.referenceTo) {
                if (item.referenceTo.length > 2) {
                    vm.tempDompObj.referenceModelSelect = item.referenceTo.substring(0, 2);
                    vm.tempDompObj.referenceNumberInput = item.referenceTo.substring(2);
                } else {
                    vm.tempDompObj.referenceModelSelect = item.referenceTo;
                    vm.tempDompObj.referenceNumberInput = "";
                }
            }
            if (item.purposeCodeDPS && vm.purposeCodesList.result) {

                // Remove leading character from string
                var leading_char = item.purposeCodeDPS.substring(0, 1);
                if (item.purposeCodeDPS.length > 2 && leading_char === '2' || leading_char === '9') {
                    item.purposeCodeDPS = item.purposeCodeDPS.substring(1);
                }

                var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
                    return purpose.id == item.purposeCodeDPS;
                });
                if (purpose) {
                    vm.tempDompObj.purposeCodeSelect = purpose;
                    vm.tempDompObj.purposeOfPaymentInput = item.purpose || purpose.description;
                }
            }

            vm.tempDompObj.receiversNameInput = item.receiverName;
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
            vm.searchFilterExpanded = false;
            vm.searchTemplateFilterExpanded = false;

            vm.selectedTemplate.imageId = item.imageId;
            setImage(vm.selectedTemplate);
        };

        var setImage = function (selectedTemplate) {
            if (vm.images && vm.images.length > 0) {
                if (selectedTemplate.imageId) {
                    var imageObject = _.find(vm.images, function (image) {
                        return image.id === selectedTemplate.imageId;
                    });
                    if (imageObject)
                        selectedTemplate.imageDownloadLink = imageObject.downloadLink;
                }

                if (!selectedTemplate.imageId || !selectedTemplate.imageDownloadLink) {
                    selectedTemplate.imageId = vm.images[0].id;
                    selectedTemplate.imageDownloadLink = vm.images[0].downloadLink;
                }
            }
        }
        vm.removeTemplate = function () {
            vm.searchTemplateFilterExpanded = false;
            vm.templateName = '';
            vm.tempDompObj.receiversNameInput = '';
            vm.tempDompObj.toAccountInput = '';
            vm.tempDompObj.receiversAddressInput = '';
            vm.tempDompObj.receiversPostalCodeAndCityInput = '';
            vm.tempDompObj.amountInput = '';
            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
            vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
            vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
            vm.tempDompObj.referenceNumberInput = '';
            vm.selectedTemplate = {};

        };

        //from account component
        vm.toggleFromAccount = function () {
            if (!vm.isRetrieval) {
                vm.fromAccountDropdown = !vm.fromAccountDropdown;
            }
        };

        vm.setAccountFrom = function (item) {
            vm.tempDompObj.fromAccountSelect = item;
            vm.fromAccountDropdown = false;
        };

        vm.showSMSAuthentification = function () {
            vm.smsAuthentificate = !vm.smsAuthentificate;
        };

        vm.onlyNumbers = /^[0-9 ]+$/;
        vm.payeeInputField = /[^A-Za-zČčĐđŽžŠšĆć\+]*$/;

        vm.getReferenceModels = function () {
            return ReferenceModelService.getPage(vm.referenceModelFilter)
                .then(function (response) {
                    vm.referenceModelList.push(""); //First item in refModelList is empty string
                    _.forEach(response.result, function (value) {
                        vm.referenceModelList.push(value.model);
                    });
                    vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
                })
                .catch(function () {
                    $log.error('Error loading bic banks codes!');
                });
        };

        vm.formatAccountNumber = function (accountNumber) {
            if (!accountNumber) return;
            var accountNumber = accountNumber.replace(/-/g, ""); // remove dashes
            if (accountNumber.length < 6) {
                vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", false);
                return;
            } else {
                vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", true);
            }
            var str1 = accountNumber.substring(0, 3);
            var str2 = ("0000000000000" + accountNumber.substring(3, accountNumber.length - 2)).slice(-13); // if 5 returns 0000..005
            var str3 = accountNumber.substring(accountNumber.length - 2);

            vm.tempDompObj.toAccountInput = str1 + "-" + str2 + "-" + str3;
        };

        vm.fillReceiver = function (toAccountInput) {
            if (!toAccountInput) return;
            if (vm.domesticPaymentForm.toAccountInput.$valid) {
                vm.formatAccountNumber(vm.tempDompObj.toAccountInput);
                //CreditAccountRegisterService.getPage({accountNumber: toAccountInput.replace(/-/g, '')})
                CreditAccountRegisterService.getPage({
                        accountNumber: vm.tempDompObj.toAccountInput.replace(/-/g, '')
                    })
                    .then(function (response) {

                        if (response.result.length > 0) {
                            var rName = response.result[0].receiverName;
                            var rAddressInput = response.result[0].receiverAddress1;
                            var rPostalCodeAndCityInput = response.result[0].receiverCity;
                            vm.tempDompObj.receiversNameInput = rName.substring(0, 35);
                            vm.tempDompObj.receiversAddressInput = rAddressInput.substring(0, 35);
                            vm.tempDompObj.receiversPostalCodeAndCityInput = rPostalCodeAndCityInput.substring(0, 35);
                        } else {
                            vm.tempDompObj.receiversNameInput = '';
                            vm.tempDompObj.receiversAddressInput = '';
                            vm.tempDompObj.receiversPostalCodeAndCityInput = '';
                        }
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.getDefaultDetails = function () {
            return ConfigEndpointService.getDefaultData()
                .then(function (response) {
                    if (response) {
                        vm.defaultCurrency = response.DefaultCurrency;
                        vm.bankCharges = response.BankCharges;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.newPayment = function () {
            clearInput();
            vm.tempDompObj.formSubmitted = false;
            vm.forUpdate = false;
            vm.currentStep = 1;
        }

        var clearInput = function () {
            vm.searchTemplateFilterExpanded = false;
            vm.templateName = '';
            vm.tempDompObj.receiversNameInput = '';
            vm.tempDompObj.toAccountInput = '';
            vm.tempDompObj.receiversAddressInput = '';
            vm.tempDompObj.receiversPostalCodeAndCityInput = '';
            vm.tempDompObj.amountInput = '';
            vm.tempDompObj.dateInput = new Date();
            vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
            vm.tempDompObj.referenceNumberInput = '';

            var index = _.findIndex(vm.purposeCodesList.result, function (item) {
                return item.id === '89';
            });

            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[index];
            vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[index].description;

            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
        }

        vm.init = function () {

            if ($state.params.editable) {
                vm.insertedPaymentObject.id = $state.params.paymentId;
                vm.forUpdate = true;
            }

            ////AKO JE POVRAT/////
            if (vm.isRetrieval) {
                var promises = [vm.getPurposeCodesPage(), vm.getReferenceModels(), vm.getDefaultDetails(), vm.getPaymentTypeGroup(), loadImages()];
                $q.all(promises)
                    .then(function () {
                        if (vm.purposeCodesList.result.length > 0) {
                            var index = _.findIndex(vm.purposeCodesList.result, function (item) {
                                return item.id === '89';
                            });

                            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[index];
                            vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[index].description;
                        }
                        vm.tempDompObj.amountInput = $stateParams.transactionDetails.amount;
                        vm.tempDompObj.toAccountInput = $stateParams.transactionDetails.detail.toAccountNumber;
                        vm.tempDompObj.fromAccountSelect = $stateParams.transactionDetails.account;
                        vm.tempDompObj.receiversAddressInput = $stateParams.transactionDetails.detail.payeeAddress1;
                        vm.tempDompObj.receiversNameInput = $stateParams.transactionDetails.detail.payeeName;

                    })
            } else {
                vm.getPayees();
                // vm.getUserSettingsPage();
                // , vm.getDefaultDetails()

                if ($rootScope.APP_GLOBAL_SETTINGS.defaultData) {
                    vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
                    vm.defaultCurrency = vm.defaultData.DefaultCurrency;
                    vm.bankCharges = vm.defaultData.BankCharges;
                }

                if ($rootScope.APP_GLOBAL_SETTINGS.userSettings) {
                    var userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
                    vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                    vm.tempDompObj.payersAddressInput = userSettings.address1;
                    vm.tempDompObj.payersCityInput = userSettings.city;
                }

                var promises = [vm.getPurposeCodesPage(), vm.getBanksPage(), vm.getCountriesPage(), vm.getPaymentTypeGroup(), vm.getReferenceModels(), loadImages()];
                $q.all(promises)
                    .then(function () {
                        //set default form params

                        var params = {
                            fromAccountList: vm.paymentTypeGroupDomestic.result[0].debitAccountList,
                            purposeCodeList: vm.purposeCodesList.result,
                            referenceModelList: vm.referenceModelList
                        };

                        switch ($state.current && $state.current.name) {
                        case 'payments.domesticPayment.fromTemplate':
                            PaymentTemplatesService.loadDomesticPaymentData($state.params.templateId, vm.tempDompObj, params)
                                .then(function () {
                                    vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                                })
                                .catch(function (error) {
                                    $log.error('loadDomesticPaymentData', error);
                                });
                            break;
                        case 'payments.domesticPayment.fromPayment':
                            PaymentsService.loadDomesticPaymentData($state.params.paymentId, vm.tempDompObj, params)
                                .then(function () {
                                    vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                                })
                                .catch(function (error) {
                                    $log.error('loadDomesticPaymentData()', error);
                                });
                            break;
                        case 'payments.domesticPayment':
                            if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                                vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                            }
                            if (vm.purposeCodesList.result.length > 0) {
                                vm.tempDompObj.purposeCodeSelect = PaymentFilterService.filterPurposeCodeSelect(vm.purposeCodesList.result, '89');
                                vm.tempDompObj.purposeOfPaymentInput = vm.tempDompObj.purposeCodeSelect.description;
                            }
                            break;
                        case 'payments.domesticPayment.fromAccount':
                            if ($state.params.accountId) {
                                vm.tempDompObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountList, $state.params.accountId);
                            }
                            break;
                        }

                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.templateImagesFilter = {
            category: "Templates"
        };

        var loadImages = function () {
            return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
                console.log(JSON.stringify(images));
                vm.images = images.result;
            }).catch(function (err) {
                $log.error(err);
            });
        };

        var populateTemplatesWithImages = function () {
            if (vm.images && vm.images.length > 0) {
                _.forEach(vm.templateList.result, function (template) {

                    if (template.imageId) {
                        var imageObject = _.find(vm.images, function (image) {
                            return image.id === template.imageId;
                        });
                        if (imageObject)
                            template.imageDownloadLink = imageObject.downloadLink;
                    }

                    if (!template.imageId || !template.imageDownloadLink) {
                        template.imageId = vm.images[0].id;
                        template.imageDownloadLink = vm.images[0].downloadLink;
                    }

                });
            }
        };
        
        vm.pushGtmUrgentPaymentEvent = function () {
            GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentIsUrgentSelection', (vm.tempDompObj.isUrgentPaymentCheckbox)?'Urgent payment checked':'Urgent payment unchecked');
        };
        vm.init();

    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:DomesticPaymentSloCtrl
     *
     * @description
     *
     */
    DomesticPaymentSloCtrl.$inject = ["$rootScope", "$sessionStorage", "$translate", "CTLocalizationService", "UserSettingsService", "$state", "$log", "HelperService", "PurposeCodesService", "BanksService", "CountriesService", "PaymentTypesService", "PaymentsService", "ValidationService", "CreditAccountRegisterService", "$q", "PaymentTemplatesService", "ConfigEndpointService", "$timeout", "ReferenceModelService", "PaymentFilterService", "Notification", "AlertService", "ImagesService", "HumanitarianService"];
    angular
        .module('payments')
        .controller('DomesticPaymentSloCtrl', DomesticPaymentSloCtrl);

    function DomesticPaymentSloCtrl($rootScope,$sessionStorage, $translate, CTLocalizationService, UserSettingsService, $state, $log, HelperService,
        PurposeCodesService, BanksService, CountriesService,
        PaymentTypesService, PaymentsService, ValidationService,
        CreditAccountRegisterService, $q, PaymentTemplatesService,
        ConfigEndpointService, $timeout, ReferenceModelService, PaymentFilterService,
        Notification, AlertService, ImagesService, HumanitarianService) {
        var vm = this;
        vm.isFromTemplate = false;
        vm.isSecondaryTemplateResponseEmpty = false;
        vm.images = {};

        vm.currentStep = 1;

        vm.paymentObject = {};
        vm.tempDompObj = {
            fromAccountSelect: {},
            purposeCodeSelect: {},
            purposeOfPaymentInput: '',
            amountInput: '',
            dateInput: new Date(),
            bicCodeInput: '',
            // n = number ~ workaround for SI init
            toAccountInput: 'SI56',
            referenceCodeInput: '',
            referenceModelSelect: {},
            referenceNumberInput: '',
            payersNameInput: '',
            payersAddressInput: '',
            payersCityInput: '',
            payersSepaInput1: '',
            receiversNameInput: '',
            receiversAddressInput: '',
            receiversPostalCodeAndCityInput: '',
            receiversCountrySelect: {},
            receiversSepaInput1: '',
            isUrgentPaymentCheckbox: false,
            formSubmitted: false,
            receiversCountry: "SI"
        };

        vm.paymentType = 'DomesticPayment';
        vm.toAccountDisabled = false;
        vm.defaultCurrency = '';
        vm.forUpdate = false;
        vm.actionLinks = null;

      vm.paymentTypeIsLoar = false;
        vm.disableAllFields = false;
        vm.disableAllFieldsForProcessedPayment = false;
        vm.disableAllFieldsForChange = false;
        // Disabled country field by default because default IBAN (SI56) is already set
        vm.recieversCountrySelectDisabled = true;
        vm.checkingForNaturalPerson = false;

      vm.referenceList = [
        {
          value: "SI",
          name: "SI"
        },
        {
          value: "RF",
          name: "RF"
        },
        {
          value: "NRC",
          name: "NRC"
        }
      ];

      /*    vm.smsAuthentificate = false;
       vm.smsPasswordInput = '';*/
        vm.hideUrgency = false;
        vm.naturalPerson = false;
        vm.split = function (input) {
            return HelperService.splitReferenceNumber(input);
        };

        vm.datePickerOpened = false;
        vm.dateOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        vm.disabledSunday = true;
        vm.disabledSaturday = true;
        vm.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        vm.bankCharges = '';
        vm.openDatePicker = function () {
            vm.datePickerOpened = true;
        };

        vm.paymentTypeGroupDomestic = {};
        vm.paymentTypesGroupFilter = {
            paymentTypeGroup: 'DomesticPayment',
            currencySymbol: "EUR"
        };

        vm.purposeCodesList = {};
        vm.purposeCodesFilter = {
            pageSize: 1000
        };

        vm.banksList = {};
        vm.banksFilter = {
            pageSize: 1000
        };

        vm.countriesCodeList = {};
        vm.countriesCodeFilter = {
            pageSize: 1000
        };

        vm.referenceModelList = [];
        vm.referenceModelFilter = {
            pageSize: 1000
        };

        vm.payeeFilter = {
            paymentTypeGroup: 'DomesticPayment',
            orderBy: 'receiverName ASC',
            page: 0,
            pageSize: 1000
        };

        vm.templateList = {};

        vm.tmpSearchText = {
            name: ''
        };

        vm.templateName = '';

        vm.fromAccountDropdown = false;
        vm.onlyNumbers = /^[0-9 ]+$/;
        vm.payeeInputField = /[^A-Za-zČčĐđŽžŠšĆć\+]*$/;

        vm.searchFilterExpanded = false;

        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
        vm.uiMaskOptions = ValidationService.getUiMaskOptions().international.iban;
        // vm.uiMask = ValidationService.getUiMask().sl.domesticSI;
        vm.uiMask = ValidationService.getUiMask().sl.domestic;
        vm.humaniOrgList = [
            {
                name: "Humanitarna org 1"
            },
            {
                name: "Humanitarna org 2"
            },
            {
                name: "Humanitarna org 3"
            }
    ];

        var loadAccountData = function (accountId) {
            var index = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
                return item.accountId == accountId;
            });
            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[index];
        };

        //var loadPaymentDataFromTemplate = function (templateId) {
        //  if (templateId) {
        //    PaymentTemplatesService.getById(templateId)
        //      .then(function (response) {
        //        vm.tempDompObj.amountInput = $filter('number')(response.amount, 2);
        //        vm.tempDompObj.toAccountInput = response.toAccountNumber;
        //        vm.tempDompObj.purposeOfPaymentInput = response.purpose;
        //        vm.tempDompObj.receiversNameInput = response.receiverName || '';
        //        vm.tempDompObj.receiversAddressInput = response.receiverAddress1 || '';
        //        vm.tempDompObj.receiversPostalCodeAndCityInput = response.receiverCity || '';
        //        loadAccountData(response.accountId);
        //      })
        //      .catch(function (error) {
        //        HelperService.showMessage(error, 'error');
        //      });
        //  }
        //};

        function validateIBANLength () {
          var ibanSI56 = vm.tempDompObj.toAccountInput.substring(0, 4);
          var ibanLength = vm.tempDompObj.toAccountInput.length;
          //var spaceNumber = Math.floor(ibanLength / 4);
          console.log(ibanSI56);
          if (ibanSI56 == "SI56") {

            vm.uiMask = ValidationService.getUiMask().sl.domesticSI;
            if(ibanLength < 19) {
              vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", false);
            } else {
              vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", true);
            }
            //vm.ibanMaxlength = 19 + spaceNumber;
          } else {
            vm.uiMask = ValidationService.getUiMask().sl.domestic;
            vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", true);
            //vm.ibanMaxlength = 34 + spaceNumber;

          }
        }

        vm.getPaymentTypeGroup = function () {
            return PaymentTypesService.getByGroup(vm.paymentTypesGroupFilter)
                .then(function (response) {
                    vm.paymentTypeGroupDomestic = response;

                    _.forEach(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (value) {
                        value.optionValue = value.accountDescription + ' - ' + value.iban;
                    });

                    $log.debug("paymentTypeGroupDomestic", vm.paymentTypeGroupDomestic);
                    if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                        vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                    }
                })
                .catch(function () {
                    $log.error('Error loading paymentTypeGroupDomestic!');
                });
        };

        vm.getPurposeCodesPage = function () {
            return PurposeCodesService.getPage(vm.purposeCodesFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        value.optionValue = value.id + ' - ' + value.description;
                        //  value.optionValue = value.id;
                        // vm.tempDompObj.purposeCodeSelect = value.id;
                        // vm.tempDompObj.purposeOfPaymentInput = value.description
                    });
                    vm.purposeCodesList = response;
                    if (vm.purposeCodesList.result.length > 0) {
                        vm.tempDompObj.purposeCodeSelect = _.findWhere(vm.purposeCodesList.result, {
                            id: 'OTHR'
                        });
                    }
                    $log.debug("purposeCodesList", vm.purposeCodesList);
                })
                .catch(function () {
                    $log.error('Error loading purpose codes!');
                });
        };

        vm.getBanksPage = function () {
            return BanksService.getPage(vm.banksFilter)
                .then(function (response) {
                    vm.banksList = response;
                    $log.debug("banksList", vm.banksList);
                })
                .catch(function () {
                    $log.error('Error loading banks codes!');
                });
        };

        vm.changePurpose = function (purposeChange) {
            var purpose = _.findWhere(vm.purposeCodesList.result, {
                description: vm.tempDompObj.purposeOfPaymentInput
            });
            if (purpose) {
                vm.tempDompObj.purposeOfPaymentInput = purposeChange.description;
            }
        };

        vm.getCountriesPage = function () {
            return CountriesService.getPage(vm.countriesCodeFilter)
                .then(function (response) {

                    vm.countriesCodeList = response;
                  vm.countriesCodeList.result.unshift({
                    code: " ",
                    countryCode: " ",
                    countryCodeShort: " ",
                    description: "internationalPayment.chooseCountry"
                  });

                    $log.debug("countriesCodeList", vm.countriesCodeList);
                })
                .catch(function () {
                    $log.error('Error loading bic banks codes!');
                });
        };

        vm.getUserSettingsPage = function () {
            UserSettingsService.getPage(vm.userSettingsFilter)
                .then(function (response) {
                    var userSettings = response.result[0];
                    vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                    vm.tempDompObj.payersAddressInput = userSettings.address1;
                    vm.tempDompObj.payersCityInput = userSettings.city;
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.insertedPaymentObjectDomp = {};
        var createPaymentObject = function () {

            var paymentObject = {};
            paymentObject.domesticPayment = {};
            paymentObject.sepaUpnIdentificators = {};
            paymentObject.accountId = vm.tempDompObj.fromAccountSelect.accountId;
            paymentObject.fromAccountNumber = vm.tempDompObj.fromAccountSelect.iban;
            paymentObject.toAccountNumber = (vm.tempDompObj.toAccountInput) ? vm.tempDompObj.toAccountInput.replace(/\s/g, '').toUpperCase() : "";
            paymentObject.currencySymbol = vm.tempDompObj.fromAccountSelect.currencySymbol;
            paymentObject.purpose = vm.tempDompObj.purposeOfPaymentInput;
            paymentObject.dueDate = vm.tempDompObj.dateInput;
            paymentObject.amount = vm.tempDompObj.amountInput;
            //paymentObject.paymentTypeGroup = 'DomesticPayment';
            paymentObject.paymentTypeGroup = vm.paymentType;
            paymentObject.purposeCodeDPS = vm.tempDompObj.purposeCodeSelect.id;
            paymentObject.domesticPayment.receiverName = vm.tempDompObj.receiversNameInput;
            paymentObject.domesticPayment.receiverAddress1 = vm.tempDompObj.receiversAddressInput;
            paymentObject.domesticPayment.receiverCity = vm.tempDompObj.receiversPostalCodeAndCityInput;
            paymentObject.domesticPayment.receiverCountry = vm.tempDompObj.receiversCountry;
            paymentObject.domesticPayment.urgency = vm.tempDompObj.isUrgentPaymentCheckbox ? '1' : '0';
            paymentObject.domesticPayment.referenceFrom = 'NRC';

            paymentObject.sepaUpnIdentificators.debtorName = vm.tempDompObj.payersSepaInput1;
            //paymentObject.sepaUpnIdentificators.debtorName2 = vm.tempDompObj.payersSepaInput2;
            paymentObject.sepaUpnIdentificators.creditorName = vm.tempDompObj.receiversSepaInput1;
            //paymentObject.sepaUpnIdentificators.creditorName2 = vm.tempDompObj.receiversSepaInput2;

            //paymentObject.paymentSubTypeGroup = "DomesticPayment";

            var referenceNumber = vm.referenceHR + vm.tempDompObj.referenceModelSelect;

            if (vm.tempDompObj.referenceModelSelect) {
                if (vm.tempDompObj.referenceModelSelect === "  " && vm.referenceHR != 'NRC') {
                    paymentObject.domesticPayment.referenceTo = vm.referenceHR + '00' + vm.tempDompObj.referenceNumberInput;
                } else
                    paymentObject.domesticPayment.referenceTo = referenceNumber.concat(vm.tempDompObj.referenceNumberInput);
            } else if ((!referenceNumber) && (vm.tempDompObj.referenceNumberInput)) {
                referenceNumber = '00';
                paymentObject.domesticPayment.referenceTo = referenceNumber.concat(vm.tempDompObj.referenceNumberInput);
            } else {
                paymentObject.domesticPayment.referenceTo = vm.referenceHR + '00';
            }

            if (vm.referenceHR == 'RF')
                paymentObject.domesticPayment.referenceTo = vm.referenceHR + vm.tempDompObj.referenceNumberInput;

            if (vm.referenceHR == 'NRC')
                paymentObject.domesticPayment.referenceTo = vm.referenceHR;

            paymentObject.beneficiarySWIFTCode = vm.tempDompObj.beneficiarySWIFTCode;


            if($state.params.myParam == 'changeProcessed'){
              paymentObject.relatedSourceType = 'ChangePayment';
            }

            return paymentObject;

        };

        vm.insertedPaymentObject = {};


        function postPaymentAction(response) {
            vm.insertedPaymentObject = response;
            vm.insertedPaymentObjectDomp.referenceTo = vm.insertedPaymentObject.referenceTo;
            Notification.clearAll();
            vm.currentStep = 2;
        }
        vm.submitPayment = function () {

          //workaround for situation when ng-blur is triggered by submitPayment
          //requests collision happens
          if(vm.checkingForNaturalPerson) {//wait for checkIfNaturalPerson to finish - then vm.checkingForNaturalPerson will be false
            setTimeout(vm.submitPayment, 50);//wait 50 millisecnds then recheck
            return;
          }

          if (vm.nextButtonPressed || vm.checkingForNaturalPerson) {
            return;
          }
            vm.tempDompObj.formSubmitted = true;
            validateIBANLength();
            if (!vm.domesticPaymentForm.$valid) {
                return;
            }
            // If not natural person (not mini form) - don't check
            if (!vm.naturalPerson && (vm.referenceHR == "SI" && vm.tempDompObj.referenceModelSelect.split(' ').join('') === '')) {
              return;
            }

            if (!vm.formSubmitted) {
                vm.formSubmitted = true;
                var objectForInsert = createPaymentObject();
                $sessionStorage.paymentSubTypeGroup = 'DomesticPayment';

                if(!$state.params.myParam || $state.params.myParam !== 'changeProcessed' )
                  var insertedDueDate = objectForInsert.dueDate;

              vm.nextButtonPressed = true;
              PaymentsService.insertPayment(objectForInsert)
                      .then(function (response) {
                          if (response.dueDateChanged) {
                              AlertService.confirmationAlert({
                                      text: "payments.paymentDueDateChangedMsg"
                                  })
                                  .then(function (accept) {
                                      if (!accept) return;
                                      secondValidate(response);
                                  })
                          } else {
                              postPaymentAction(response);
                          }
                      })
                      .catch(function (response, error) {
                          if(response && response.hasErrors){
                              HelperService.showMessage(response, 'error');
                          }
                          else if (response && response.hasWarnings) {
                              //show action message modal
                              PaymentsService.showModalWithActions(response, objectForInsert, true, objectForInsert.domesticPayment.urgency);
                          } else {
                              HelperService.showMessage(response, 'error');
                          }
                      })
                      .finally(function () {
                          vm.formSubmitted = false;
                          vm.forUpdate = false;
                          vm.nextButtonPressed = false;
                      });
                }
        };

        function secondValidate(validatedUPOrder) {
            if (vm.secondValidateInProgress) return;
            vm.secondValidateInProgress = true;
            PaymentsService.insertPayment(validatedUPOrder)
                .then(function (response) {
                    postPaymentAction(response);
                })
                .catch(function (response, error) {
                    if (response && response.hasWarnings) {
                        //show action message modal
                        PaymentsService.showModalWithActions(response, objectForInsert, true, validatedUPOrder.domesticPayment.urgency);
                    } else {
                        HelperService.showMessage(response, 'error');
                    }
                })
                .finally(function () {
                    vm.formSubmitted = false;
                    vm.forUpdate = false;
                    vm.nextButtonPressed = false;
                    vm.secondValidateInProgress = false;
                });
        }


        var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        $rootScope.$on('appLanguageChangedHeader', function () {
            sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        });

        vm.deletePayment = function () {
            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        PaymentsService.deletePayment(vm.insertedPaymentObject.id)
                            .then(function (response) {
                                AlertService.deletedPaymentAlert({
                                        paymentName: vm.insertedPaymentObject.id,
                                        type: 'payment'
                                    })
                                    .then(function () {
                                        $state.go('payments.paymentsOverview');
                                    });
                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    }
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });
        };

        vm.editPayment = function () {
            vm.forUpdate = true;
            vm.currentStep = 1;
            //      mapWithPaymentResponse();
        };

        var fillReceiversInput = function (response) {
            if (response.result.length > 0) {
                var rName = response.result[0].receiverName;
                var rAddressInput = response.result[0].receiverAddress1;
                var rPostalCodeAndCityInput = response.result[0].receiverCity;
                vm.tempDompObj.receiversNameInput = rName.substring(0, 70);
                vm.tempDompObj.receiversAddressInput = rAddressInput.substring(0, 35);
                vm.tempDompObj.receiversPostalCodeAndCityInput = rPostalCodeAndCityInput.substring(0, 35);
            } else {
                vm.tempDompObj.receiversNameInput = '';
                vm.tempDompObj.receiversAddressInput = '';
                vm.tempDompObj.receiversPostalCodeAndCityInput = '';
            }
        };

        vm.clearSepaReceiver = function () {
            vm.tempDompObj.receiversSepaInput1 = '';
        };

        vm.clearSepaPayer = function () {
            vm.tempDompObj.payersSepaInput1 = '';
        };

        /////////////////////////////CUSTOM SELECT////////////////////////////

        vm.toggleFilterSelection = function () {
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.searchPayee = function () {
            vm.searchFilterExpanded = true;
        };

        vm.getPayees = function () {
            PaymentTemplatesService.getPage(vm.payeeFilter)
                .then(function (response) {
                    vm.payeeList = response.result;
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.selectPayee = function (id) {
            var payee = _.findWhere(vm.payeeList, {
                id: id
            });

          PaymentTemplatesService.getById(id)
            .then(function (response) {

              var item = response;

              vm.searchFilterExpanded = !vm.searchFilterExpanded;

              populateCommonFields(item);
              populatePurpose(item);
              populateRefNumber(item.referenceTo);

              // vm.tempDompObj.toAccountInput = payee.toAccountNumber;
              // vm.tempDompObj.receiversAddressInput = payee.receiverAddress1;
              // vm.tempDompObj.receiversNameInput = payee.receiverName;
              // vm.tempDompObj.receiversPostalCodeAndCityInput = payee.receiverCity;
              vm.isFromTemplate = true;

              if(vm.tempDompObj.toAccountInput){
                //dodano zbog disable-anja hitnog plaćanja
                checkForUrgency();

                vm.toAccountDisabled = true;

                vm.checkIfNaturalPersonWithoutFieldsInit(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
                // vm.getBicByIban(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));

                selectCountryByAccount(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
              }

              // vm.getBicByIban(vm.tempDompObj.toAccountInput);

              vm.checkAccountsEquality();

            }, function (error) {
              console.log(error);
            });




        };

        vm.removeSearch = function () {
            vm.tempDompObj.receiversNameInput = '';
            vm.tempDompObj.beneficiarySWIFTCode = '';
            vm.tempDompObj.toAccountInput = '';
            vm.naturalPerson = false;
            vm.isFromTemplate = false;
        };

        vm.searchPayeeBy = function (searchrow) {
            return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1 ||
                angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1);
        };

        ////////////////select template component//////////////////////
        vm.searchTemplate = function () {
            vm.searchTemplateFilterExpanded = true;
            if (vm.searchTemplateFilterExpanded === true) {
                $timeout(function () {
                    var searchTemplatesInput = angular.element('#searchTemplatesInput');
                    searchTemplatesInput.focus();
                }, 500);
            }
        };

        vm.toggleTemplateFilterSelection = function () {
            vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
            // if (vm.searchTemplateFilterExpanded && (!vm.templateList.result || vm.templateList.result.length === 0)) {
            //     vm.getPaymentTemplatesPage();
            // }
        };

        vm.getPaymentTemplatesPage = function () {
           return PaymentTemplatesService.getPage({
                paymentTypeGroup: 'DomesticPayment',
                page: 0,
                pageSize: 1000
            }).then(function (response) {
                vm.templateList = response;
                if (vm.templateList)
                    populateTemplatesWithImages();
                $log.debug(vm.templateList);
            }).catch(function (error) {
                $log.error(error);
            });
        };

        vm.selectedTemplate = {};

      function checkForUrgency() {
        var temp = vm.tempDompObj.toAccountInput.substring(4, 11);
        if (temp === '2500009') {
          vm.hideUrgency = true;
          vm.disabledSunday = false;
        } else {
          vm.hideUrgency = false;
          vm.disabledSunday = true;
          vm.disabled(vm.tempDompObj.dateInput, 'day');
          if (vm.tempDompObj.dateInput.getDay() === 0) {
            vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1);
          }
        }
      }

      vm.selectTemplate = function (id) {
        clearForm();
        PaymentTemplatesService.getById(id)
          .then(function (response) {

            vm.searchFilterExpanded = !vm.searchFilterExpanded;
            vm.searchFilterExpanded = false;
            vm.searchTemplateFilterExpanded = false;

                    var item = response;

                    vm.templateName = item.name;

                    populateCommonFields(item);
                    populatePurpose(item);
                    populateRefNumber(item.referenceTo);

                    if (vm.tempDompObj.toAccountInput) {
                        //dodano zbog disable-anja hitnog plaćanja
                      checkForUrgency();

                        vm.toAccountDisabled = true;

                        vm.checkIfNaturalPersonWithoutFieldsInit(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
                      // vm.getBicByIban(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));

                      selectCountryByAccount(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
                    }


                    // vm.checkIban(vm.tempDompObj.toAccountInput);

                    vm.selectedTemplate.imageId = item.imageId;
                    setImage(vm.selectedTemplate);

                    vm.isFromTemplate = true;
                    vm.checkAccountsEquality();


                }, function (error) {
                    console.log(error);
                });
        };

        function populatePurpose(item) {
            if (item.purposeCode && vm.purposeCodesList.result) {
                var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
                    return purpose.id == item.purposeCode;
                });
                if (purpose) {
                    vm.tempDompObj.purposeCodeSelect = purpose;
                    vm.tempDompObj.purposeOfPaymentInput = item.purpose || purpose.description;
                }
            }
        }

        function populatePurposeDPS(item) { //humanitarian payment contains purposeCodeDPS instead of purposeCode
            if (item.purposeCodeDPS && vm.purposeCodesList.result) {
                var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
                    return purpose.id == item.purposeCodeDPS;
                });
                if (purpose) {
                    vm.tempDompObj.purposeCodeSelect = purpose;
                    vm.tempDompObj.purposeOfPaymentInput = item.purpose || purpose.description;
                }
            }
        }

        function populateCommonFields(item) {
            vm.tempDompObj.toAccountInput = item.toAccountNumber;
            // vm.tempDompObj.amountInput = item.amount;

            vm.setAccountFrom(_.findWhere(vm.paymentTypeGroupDomestic.result[0].debitAccountList, {
                accountId: item.accountId
            }));

            if (item.foreignPayment) {
                vm.tempDompObj.receiversAddressInput = item.foreignPayment.receiverAddress1;
                vm.tempDompObj.receiversNameInput = item.foreignPayment.receiverName;
                vm.tempDompObj.receiversPostalCodeAndCityInput = item.foreignPayment.receiverCity;
                vm.tempDompObj.payersSepaInput1 = item.foreignPayment.debtorName;
                //vm.tempDompObj.payersSepaInput2 = item.foreignPayment.debtorName2;
                vm.tempDompObj.receiversSepaInput1 = item.foreignPayment.creditorName;
                //vm.tempDompObj.receiversSepaInput2 = item.foreignPayment.creditorName2;
            } else {
                vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
                vm.tempDompObj.receiversNameInput = item.receiverName;
                vm.tempDompObj.receiversPostalCodeAndCityInput = item.receiverCity;
                vm.tempDompObj.payersSepaInput1 = item.sepaUpnIdentificators.debtorName;
                  //vm.tempDompObj.payersSepaInput2 = item.debtorName2;
                vm.tempDompObj.receiversSepaInput1 = item.sepaUpnIdentificators.creditorName;
                //vm.tempDompObj.receiversSepaInput2 = item.creditorName2;
              var receiversCountry = _.findWhere(vm.countriesCodeList.result, {code: item.receiverCountryCode});
              if(receiversCountry) vm.tempDompObj.receiversCountry = receiversCountry.countryCode;
            }
            if (item.paymentTypeGroup == "LocalCurrencyTransfer") {
                vm.tempDompObj.purposeOfPaymentInput = item.purpose;
            }

             validateIBANLength();
        }

        var populatePaymentFields = function (payment) {

            var item = payment;

            populateCommonFields(item);
            if (item.foreignPayment) {
                populateRefNumber(item.foreignPayment.referenceTo);
            }
            populatePurpose(item);
            vm.checkIban(vm.tempDompObj.toAccountInput);

            // vm.tempDompObj.purposeOfPaymentInput = item.purpose;

            var fromAcc = _.find(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (account) {
                return account.accountId == item.accountId;
            });

            if (fromAcc)
                vm.tempDompObj.fromAccountSelect = fromAcc;


            if (vm.tempDompObj.toAccountInput) {
                //dodano zbog disable-anja hitnog plaćanja
                var temp = vm.tempDompObj.toAccountInput.substring(4, 11);
                if (temp === '2500009') {
                    vm.hideUrgency = true;
                    vm.disabledSunday = false;
                } else {
                    vm.hideUrgency = false;
                    vm.disabledSunday = true;
                    vm.disabled(vm.tempDompObj.dateInput, 'day');
                    if (vm.tempDompObj.dateInput.getDay() === 0) {
                        vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1);
                    }
                }

                vm.getBicByIban(vm.tempDompObj.toAccountInput);

            }


        };

        vm.humanitarianName = '';
        vm.selectedHumanitarian = {};
        vm.selectHumanitarian = function (selectedItem) {
            clearForm();

            HumanitarianService.getById(selectedItem.id)
                .then(function (response) {
                    vm.donationTemplateListExpanded = false;
                    vm.humanitarianName = selectedItem.name;

                    var item = response;

                    populateCommonFields(item);
                    populateRefNumber(item.referenceTo);
                    populatePurposeDPS(item);

                    if (vm.tempDompObj.toAccountInput) {
                        //dodano zbog disable-anja hitnog plaćanja
                        var temp = vm.tempDompObj.toAccountInput.substring(4, 11);
                        if (temp === '2500009') {
                            vm.hideUrgency = true;
                            vm.disabledSunday = false;
                        } else {
                            vm.hideUrgency = false;
                            vm.disabledSunday = true;
                            vm.disabled(vm.tempDompObj.dateInput, 'day');
                            if (vm.tempDompObj.dateInput.getDay() === 0) {
                                vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1);
                            }
                        }
                        vm.toAccountDisabled = true;
                        //vm.getBicByIban(vm.tempDompObj.toAccountInput);
                        vm.checkIfNaturalPersonWithoutFieldsInit(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
                        selectCountryByAccount(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
                    }


                    if (!vm.hideUrgency) {
                        vm.tempDompObj.isUrgentPaymentCheckbox = (item.urgency === "0") ? false : true;
                    }

                  vm.isFromTemplate = true;
                  vm.checkAccountsEquality();

                }, function (error) {
                    console.log(error);
                });


        };
        // var populateRefNumber = function (number) {
        //   if (!number) return;
        //   var prefix3letters = number.substring(0, 3);
        //   var temp = vm.referenceList.find(function (item) {
        //     return item.name == prefix3letters;
        //   });
        //
        //   if (temp) {
        //     vm.referenceHR = temp.name;
        //     vm.referenceModelSelect = number.substring(3, 5);
        //     vm.referenceNumberInput = number.substring(5);
        //   } else {
        //     vm.referenceHR = number.substring(0, 2);
        //     vm.referenceModelSelect = number.substring(2, 4);
        //     vm.referenceNumberInput = number.substring(4);
        //   }
        // };

        var populateRefNumber = function (number) {
            if (!number) return;
            if (number.substring(0, 3) == "NRC") {
                vm.referenceHR = number.substring(0, 3);
                vm.tempDompObj.referenceModelSelect = number.substring(3, 5);
                vm.tempDompObj.referenceNumberInput = number.substring(5);
            } else if (number.substring(0, 2) == "SI") {
                vm.referenceHR = number.substring(0, 2);
                vm.tempDompObj.referenceModelSelect = number.substring(2, 4);
                vm.tempDompObj.referenceNumberInput = number.substring(4);
            } else if (number.substring(0, 2) == "RF") {
                vm.referenceHR = number.substring(0, 2);
                vm.tempDompObj.referenceModelSelect = "";
                vm.tempDompObj.referenceNumberInput = number.substring(2);
            }
        };

        function clearForm() {
            vm.donationTemplateListExpanded = false;
            vm.humanitarianName = '';
            vm.searchTemplateFilterExpanded = false;
            vm.templateName = '';
            vm.toAccountDisabled = false;
            vm.selectedHumanitarian = {};
            vm.selectedTemplate = {};

            vm.tempDompObj.receiversNameInput = '';
            vm.tempDompObj.toAccountInput = 'SI56';
            vm.tempDompObj.receiversAddressInput = '';
            vm.tempDompObj.receiversPostalCodeAndCityInput = '';
            vm.tempDompObj.amountInput = '';
            vm.tempDompObj.purposeCodeSelect = _.findWhere(vm.purposeCodesList.result, {
                id: 'OTHR'
            });
            vm.tempDompObj.purposeOfPaymentInput = "";
            vm.tempDompObj.referenceNumberInput = '';
            vm.tempDompObj.beneficiarySWIFTCode = '';

            vm.isFromTemplate = false;
            vm.checkIban(vm.tempDompObj.toAccountInput);
        }

        vm.removeHumanitarian = function () {
            vm.naturalPerson = false;
            clearForm();
        };

        vm.removeTemplate = function () {
            vm.naturalPerson = false;
            clearForm();
        };

        var setImage = function (selectedTemplate) {
            if (vm.images && vm.images.length > 0) {
                if (selectedTemplate.imageId) {
                    var imageObject = _.find(vm.images, function (image) {
                        return image.id === selectedTemplate.imageId;
                    });
                    if (imageObject)
                        selectedTemplate.imageDownloadLink = imageObject.downloadLink;
                }

                if (!selectedTemplate.imageId || !selectedTemplate.imageDownloadLink) {
                    selectedTemplate.imageId = vm.images[0].id;
                    selectedTemplate.imageDownloadLink = vm.images[0].downloadLink;
                }
            }
        };

        /////////////////from account component///////////////////////////
        vm.toggleFromAccount = function () {
            vm.fromAccountDropdown = !vm.fromAccountDropdown;
        };

        vm.setAccountFrom = function (item) {
            vm.tempDompObj.fromAccountSelect = (item) ? item : vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
            vm.fromAccountDropdown = false;
            if (vm.tempDompObj.fromAccountSelect && vm.tempDompObj.toAccountInput) {
                if (vm.tempDompObj.fromAccountSelect.iban && vm.tempDompObj.fromAccountSelect.iban.trim() == vm.tempDompObj.toAccountInput.trim()) {
                    vm.tempDompObj.toAccountInput = "SI56";
                }
            }
            vm.checkAccountsEquality();
        };

        /*
         vm.showSMSAuthentification = function () {
         vm.smsAuthentificate = !vm.smsAuthentificate;
         };
         */

        vm.getReferenceModels = function () {
            return ReferenceModelService.getPage(vm.referenceModelFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        vm.referenceModelList.push(value.model);
                    });
                    var index = _.findIndex(vm.referenceModelList, function (item) {
                        return item.model === '99';
                    });

                    if (index) {
                        vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];
                    } else {
                        vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
                    }
                })
                .catch(function () {
                    $log.error('Error loading bic banks codes!');
                });
        };

        vm.newPayment = function () {
            $state.go($state.current, {}, {
                reload: true
            })
        };

        vm.getDefaultDetails = function () {
            return ConfigEndpointService.getDefaultData()
                .then(function (response) {
                    if (response) {
                        vm.defaultCurrency = response.DefaultCurrency;
                        vm.bankCharges = response.BankCharges;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.init = function () {

            /* defaultno omogucena nedjelja (disable-a se ako nalog nema 2500009)
             if (vm.tempDompObj.dateInput.getDay() == 0) {
             vm.tempDompObj.dateInput = new Date(vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1));
             }*/

            //vm.naturalPerson = true;

            if ($state.params.editable) {
                vm.insertedPaymentObject.id = $state.params.paymentId;
                vm.forUpdate = true;
            }

            vm.getPayees();
            // vm.getUserSettingsPage();

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData) {
                vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
                vm.defaultCurrency = vm.defaultData.DefaultCurrency;
                vm.bankCharges = vm.defaultData.BankCharges;
            }

            if ($rootScope.APP_GLOBAL_SETTINGS.userSettings) {
                var userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
                vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                vm.tempDompObj.payersAddressInput = userSettings.address1;
                vm.tempDompObj.payersCityInput = userSettings.city;
            }

            // , vm.getDefaultDetails()
            var promises = [vm.getPurposeCodesPage(), vm.getBanksPage(), vm.getCountriesPage(), vm.getPaymentTypeGroup(), vm.getReferenceModels(), vm.getHumanitarian(), loadImages(), vm.getPaymentTemplatesPage()];
            $q.all(promises)
                .then(function () {
                    //set default form params
                    var params = {
                        fromAccountList: vm.paymentTypeGroupDomestic.result[0].debitAccountList,
                        purposeCodeList: vm.purposeCodesList.result,
                        referenceModelList: vm.referenceModelList
                    };

                    switch ($state.current && $state.current.name) {
                    case 'payments.domesticPayment.fromTemplate':
                        if ($state.params.templateId) {
                          vm.selectTemplate($state.params.templateId);
                        }

                        // PaymentTemplatesService.loadDomesticPaymentData($state.params.templateId, vm.tempDompObj, params)
                        //     .then(function () {
                        //         vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                        //
                        //     })
                        //     .catch(function () {
                        //         $log.error('loadDomesticPaymentData', error);
                        //     });
                        break;
                    case 'payments.domesticPayment.fromPayment':
                        PaymentsService.loadDomesticPaymentData($state.params.paymentId, vm.tempDompObj, params)
                            .then(function () {
                                vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                                if ($state.params.myParam == 'repeatCancelled') {
                                    vm.tempDompObj.dateInput = new Date(vm.tempDompObj.dueDateTemp);
                                    vm.disableAllFields = true;
                                    vm.disableAllFieldsForProcessedPayment = true;
                                    vm.isFromTemplate = true;
                                }
                                if($state.params.myParam === 'changeProcessed'){
                                  vm.tempDompObj.dateInput = new Date(vm.tempDompObj.dueDateTemp);

                                  vm.disableAllFields = true;
                                  vm.disableAllFieldsForProcessedPayment = false;
                                  // vm.isFromTemplate = true;


                                  if(vm.tempDompObj.purposeCodeSelect.id === 'LOAR'){
                                    vm.paymentTypeIsLoar = true;
                                    vm.disableAllFieldsForChange = true;
                                  }
                                }

                              if(vm.tempDompObj.purposeCodeSelect.id === 'LOAR'){
                                vm.checkIfNaturalPerson(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
                              }else {
                                vm.checkIfNaturalPersonWithoutFieldsInit(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
                              }

                                populateRefNumber(vm.tempDompObj.referenceToTemp);
                                selectCountryByAccount(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));

                            })
                            .catch(function (error) {
                                $log.error('loadDomesticPaymentData()', error);
                            });
                        break;
                    case 'payments.domesticPayment':
                        if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                        }
                        if (vm.purposeCodesList.result.length > 0) {
                            //vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
                            //vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
                            vm.tempDompObj.purposeCodeSelect = _.findWhere(vm.purposeCodesList.result, {
                                id: 'OTHR'
                            });
                            vm.tempDompObj.purposeOfPaymentInput = '';
                        }
                        if (vm.referenceModelList.length > 0) {
                            // var index = _.findIndex(vm.referenceModelList, function (o) {
                            //   return o === '99';
                            // });
                            // vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];

                            //default value should be empty
                            vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
                        }
                        break;
                    case 'payments.domesticPayment.fromAccount':
                        if ($state.params.accountId) {
                            vm.tempDompObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountList, $state.params.accountId);
                        }
                        break;
                    case 'payments.domesticPayment.fromTemplatesToPay':
                        if ($state.params.templateId) {
                            vm.selectTemplate($state.params.templateId);
                        }
                        break;
                    case 'payments.domesticPayment.fromInternational':
                      populatePaymentFieldFromInternational($state.params.transactionDetails);
                        break;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

      var isFromInternational;
      var populatePaymentFieldFromInternational = function (payment) {
        var item = payment;
        isFromInternational = true;
        populateCommonFields(item);
        if(payment.currencySymbol == "EUR") {
          vm.tempDompObj.amountInput = payment.amount;
        }
        vm.tempDompObj.purposeOfPaymentInput = payment.purpose;
        if (item.foreignPayment) {
          populateRefNumber(item.foreignPayment.referenceTo);
        }
        populatePurpose(item);
        vm.checkIban(vm.tempDompObj.toAccountInput);

        var fromAcc = _.find( vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (account) {
          return account.accountId == item.accountId;
        });
        if (fromAcc)
          vm.tempDompObj.fromAccountSelect = fromAcc;
         var receiversCountry = _.findWhere(vm.countriesCodeList.result, {code: payment.foreignPayment.receiverCountryCode});
        if(receiversCountry) vm.tempDompObj.receiversCountry = receiversCountry.countryCode;
        if (vm.tempDompObj.toAccountInput) {
          //dodano zbog disable-anja hitnog plaćanja
          var temp = vm.tempDompObj.toAccountInput.substring(4, 11);
          if (temp === '2500009') {
            vm.hideUrgency = true;
            vm.disabledSunday = false;
          } else {
            vm.hideUrgency = false;
            vm.disabledSunday = true;
            vm.disabled(vm.tempDompObj.dateInput, 'day');
            if (vm.tempDompObj.dateInput.getDay() === 0) {
              vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1);
            }
          }

          // vm.getBicByIban(vm.tempDompObj.toAccountInput);
          selectCountryByAccount(vm.tempDompObj.toAccountInput.replace(/\s/g, ''));
        }
      };

        // vm.checkPurposeOfPaymentLength = function () {
        //     if (vm.referenceHR == "RF") {
        //         vm.tempDompObj.referenceModelSelect = '';
        //     }
        //     if (vm.referenceHR != "NRC") {
        //         vm.tempDompObj.purposeOfPaymentInput = vm.tempDompObj.purposeOfPaymentInput.substring(0, 34)
        //     } else {
        //         vm.tempDompObj.referenceModelSelect = '';
        //         vm.tempDompObj.referenceNumberInput = '';
        //     }
        // };

        vm.setPurposeMaxlengthValue = function () {
            if (vm.referenceHR == "NRC") {
                vm.purposeMaxlengthValue = 140;
            }
            if (vm.referenceHR == 'SI' && vm.tempDompObj.referenceModelSelect == '99') {
                vm.purposeMaxlengthValue = 140;
            }
            if (vm.referenceHR != "NRC" && vm.tempDompObj.referenceModelSelect != "99") {
                vm.purposeMaxlengthValue = 140;
            }
        };

        vm.clearReferenceNumber = function () {
            if (vm.tempDompObj.referenceModelSelect == '99') {
                vm.tempDompObj.referenceNumberInput = '';
            }
        };

        vm.setRefModelToDefault = function () {
          vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
        };


        vm.templateImagesFilter = {
            category: "Templates"
        };
        var loadImages = function () {
            return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
                if (images)
                    vm.images = images.result;
            }).catch(function (err) {
                $log.error(err);
            });
        };


        // vm.referenceHR = vm.referenceList[0].name;

        var populateTemplatesWithImages = function () {
            if (vm.images && vm.images.length > 0) {
                _.forEach(vm.templateList.result, function (template) {

                    if (template.imageId) {
                        var imageObject = _.find(vm.images, function (image) {
                            return image.id === template.imageId;
                        });
                        if (imageObject)
                            template.imageDownloadLink = imageObject.downloadLink;
                    }

                    if (!template.imageId || !template.imageDownloadLink) {
                        template.imageId = vm.images[0].id;
                        template.imageDownloadLink = vm.images[0].downloadLink;
                    }

                });
            }
        };

        vm.getHumanitarian = function () {
            return HumanitarianService.getAll().then(function (response) {
                vm.humaniOrgList = response.result;
            }).catch(function (err) {
                $log.error(err);
            });
        };

        vm.checkIban = function (accountNumber) {

          //prevent ng-blur functions with disabled and populated fields
          //mainly, API requests
          if(vm.disableAllFields)
            return;

          if(!accountNumber) return;
          // If iban starts with SI56 - remove "SI" option from reference number!
          if (vm.tempDompObj.toAccountInput.substring(0, 2) != "SI") {
            vm.referenceList = [
              {
                value: "RF",
                name: "RF"
              },
              {
                value: "NRC",
                name: "NRC"
              }
            ];
            vm.referenceHR = "NRC";
          } else {
            vm.referenceList = [
              {
                value: "SI",
                name: "SI"
              },
              {
                value: "RF",
                name: "RF"
              },
              {
                value: "NRC",
                name: "NRC"
              }
            ];
            vm.referenceHR = "SI";
          }

          if (!accountNumber) {
            vm.referenceHR = 'NRC';
            return;
          }
          vm.tempDompObj.referenceModelSelect = vm.tempDompObj.referenceModelSelect || "";
          vm.tempDompObj.referenceNumberInput= vm.tempDompObj.referenceNumberInput || "";
        };
        vm.checkIban(vm.tempDompObj.toAccountInput);


      function selectCountryByAccount(iban) {
        var countryCode = iban.substring(0, 2).toUpperCase();
        var country;
        if (countryCode == "SI") {
          vm.tempDompObj.receiversCountry = "SI";
          //vm.recieversCountrySelectDisabled = true;
        } else {
          country = _.findWhere(vm.countriesCodeList.result, {countryCode: countryCode});
          vm.tempDompObj.receiversCountry = (country) ? country.countryCode : "";
          //vm.recieversCountrySelectDisabled = (country) ? true : false;
        }
      }

      vm.getBicByIban = function (iban) {
        if (!iban) {
                vm.tempDompObj.beneficiarySWIFTCode = "";
                return;
            }
            // Check if IBAN to is == iban From
            if (vm.tempDompObj.fromAccountSelect.iban) {
                if (vm.tempDompObj.fromAccountSelect.iban.trim() == vm.tempDompObj.toAccountInput.trim()) {
                    vm.tempDompObj.toAccountInput = "SI56";
                    return;
                }
            }

            //prevent ng-blur functions with disabled and populated fields
            //mainly, API requests
            if(vm.disableAllFields)
              return;

        selectCountryByAccount(iban);

        iban = iban.replace(/\s/g, '');
            vm.checkIfNaturalPerson(iban);
            PaymentsService.getBicBanks(undefined, {
                    iban: iban
                })
                .then(function (response) {
                    var bicBank = response.result[0];
                    if (bicBank) {
                        vm.tempDompObj.beneficiarySWIFTCode = bicBank.bicCode;
                    } else {
                        vm.tempDompObj.beneficiarySWIFTCode = "";
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.checkIfNaturalPersonWithoutFieldsInit = function (iban) {
        CreditAccountRegisterService.getById(iban)
          .then(function (response) {
            if (_.isEmpty(response) && (iban && iban.substring(0, 6) == 'SI5633')) {
              vm.paymentType = 'LocalCurrencyTransfer';
              //vm.tempDompObj.dateInput = new Date();
              vm.disabledSunday = false;
              vm.naturalPerson = true;
            } else if (response.iban && (iban && iban.substring(0, 6) == 'SI5633')) {
              vm.paymentType = 'DomesticPayment';
              vm.disabledSunday = true;
              vm.naturalPerson = false;
            } else if (response.iban && (iban && iban.substring(0, 4) == 'SI56')) {
              vm.paymentType = 'DomesticPayment';
              vm.disabledSunday = true;
              vm.naturalPerson = false;
            } else if (_.isEmpty(response) && isFromInternational) {
              return;
            }
            else {
              vm.paymentType = 'DomesticPayment';
              //vm.tempDompObj.dateInput = new Date();
              vm.disabledSunday = false;
              vm.naturalPerson = false;
            }
            // if($state.params.myParam == 'changeProcessed' && vm.tempDompObj.purposeCodeSelect.id == 'LOAR'){
            //   vm.naturalPerson = false;
            // }
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
       };

        vm.checkIfNaturalPerson = function (iban) {
            // ako je si56 33.. i ne vrati podatke onda je fizicko lice, - i nalog je  local  internal transfer
            // ako je si56 33.. i vrati podatke onda je pravno lice  i nalog je DPS
            // ako je si56 .... i vrati podatke onda je pravno lice
            // (moze biti i fizicko), ali su nazivi primatelji obavezni, jer je to nalog u drugu banku
            // i taj nalog je dps 
            vm.checkingForNaturalPerson = true;
            CreditAccountRegisterService.getById(iban)
                .then(function (response) {
                  vm.checkingForNaturalPerson = false;
                    if (_.isEmpty(response) && (iban && iban.substring(0, 6) == 'SI5633')) {
                        vm.tempDompObj.receiversNameInput = vm.tempDompObj.receiversNameInput || '';
                        vm.tempDompObj.receiversAddressInput = vm.tempDompObj.receiversAddressInput || '';
                        vm.tempDompObj.receiversPostalCodeAndCityInput = vm.tempDompObj.receiversPostalCodeAndCityInput || '';
                        vm.paymentType = 'LocalCurrencyTransfer';
                        //vm.tempDompObj.dateInput = new Date();
                        vm.disabledSunday = false;
                        vm.naturalPerson = true;
                    } else if (response.iban && (iban && iban.substring(0, 6) == 'SI5633')) {
                        vm.paymentType = 'DomesticPayment';
                        vm.tempDompObj.receiversNameInput = response.receiverName || '';
                        vm.tempDompObj.receiversAddressInput = response.receiverAddress1 || '';
                        vm.tempDompObj.receiversPostalCodeAndCityInput = response.receiverCity || '';
                        vm.disabledSunday = true;

                        vm.naturalPerson = false;
                    } else if (response.iban && (iban && iban.substring(0, 4) == 'SI56')) {
                        vm.tempDompObj.receiversNameInput = response.receiverName || '';
                        vm.tempDompObj.receiversAddressInput = response.receiverAddress1 || '';
                        vm.tempDompObj.receiversPostalCodeAndCityInput = response.receiverCity || '';
                        vm.paymentType = 'DomesticPayment';
                        vm.disabledSunday = true;
                        vm.naturalPerson = false;
                    } else if (_.isEmpty(response) && isFromInternational) {
                      return;
                    } else {
                      vm.tempDompObj.receiversNameInput =  vm.tempDompObj.receiversNameInput || '';
                      vm.tempDompObj.receiversAddressInput = vm.tempDompObj.receiversAddressInput || '';
                      vm.tempDompObj.receiversPostalCodeAndCityInput = vm.tempDompObj.receiversPostalCodeAndCityInput || '';
                      vm.paymentType = 'DomesticPayment';
                      //vm.tempDompObj.dateInput = new Date();
                      vm.disabledSunday = false;
                      vm.naturalPerson = false;
                    }


                    if (vm.isFromTemplate && _.isEmpty(response)) {
                      //vm.isFromTemplate = false;
                      vm.isSecondaryTemplateResponseEmpty = true;
                    }else{
                      vm.isSecondaryTemplateResponseEmpty = false;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.signOrFinishPayment = function () {

          // Returns true if any of the values in the list pass the predicate truth test.
          var ibanInTemplates = _.some(vm.templateList.result, function (template) {
            return template.toAccountNumber.replace(/ /g,'') == vm.tempDompObj.toAccountInput.replace(/ /g,'')
          });

          //when Changing/updating: PaymentType LOAN doesnt have otp and goes directly to final-step
          if($state.params.myParam === 'changeProcessed' && vm.paymentTypeIsLoar){
            //check if fromTemplate
            updatePayment();
            return;
          }

          //if route has this param it should request for PUT method
          if($state.params.myParam == 'changeProcessed' && (ibanInTemplates || vm.isFromTemplate)){
            //check if fromTemplate
            updatePayment();
            return;
          }

            // When I make UPN from template, the additional page should not be displayed. (Sign page should not be there)
            // When I make UPN to account, not saved in templates and is outsite Addiko bank, the additional page for OTP confirmation should appear.
            // When I make UPN to internal (SI5633) Addiko bank account of the company, the additional page for OTP confirmation should appear.
            // _.every Returns true if all of the values in the list pass the predicate truth test. Short-circuits and stops traversing the list if a false element is found.
            if (vm.insertedPaymentObject &&
              vm.insertedPaymentObject.linkList &&
              vm.insertedPaymentObject.linkList.itemList &&
              vm.insertedPaymentObject.linkList.itemList.requestOTP) {

              //TSK-114327
              if($state.params.paymentId && $state.params.myParam && $state.params.myParam === 'changeProcessed')
                vm.insertedPaymentObject.paymentIdTemp = $state.params.paymentId;

            $state.go("payments.sign", {
                payment: vm.insertedPaymentObject,
                paymentId: vm.insertedPaymentObject.id,
                type: 'domestic'
              });

            } else {
              signPayment();
            }
        };

        function signPayment() {
            if (vm.confirmButtonPressed) return;
            var params = {
                id: vm.insertedPaymentObject.id,
                payment: vm.insertedPaymentObject
            };
            //TSK-114327
            if($state.params.paymentId && $state.params.myParam && $state.params.myParam === 'changeProcessed')
              vm.insertedPaymentObject.paymentIdTemp = $state.params.paymentId;

            // Returns true if any of the values in the list pass the predicate truth test.
            var ibanInTemplates = _.some(vm.templateList.result, function (template) {
              return template.toAccountNumber.replace(/ /g,'') == vm.tempDompObj.toAccountInput.replace(/ /g,'')
            });
            if (ibanInTemplates) {
              vm.isFromTemplate = true;
            }

            params.payment.signData = "";
            vm.confirmButtonPressed = true;
          PaymentsService.signPayment(params).then(function (signedPayment) {
                $state.go('payments.finalStep', {
                    paymentObject: signedPayment.payment || signedPayment,
                    paymentId: signedPayment.id,
                    type: "domestic",
                    isFromTemplate: vm.isFromTemplate
                });
            }).catch(function (error) {
                $log.error(error);
                if (error && error.resultList[0] && error.resultList[0].key === 'CUTOFF') {
                    signLastPayment(error.resultList[0].description, params);
                } else if (error && error.resultList[0] && error.resultList[0].key === 'UpdateOldDate') {
                    openUpdateSinglePaymentDueDateModal(params);
                } else {
                    HelperService.showMessage(error, 'error');
                }
            }).finally(function() {
            vm.confirmButtonPressed = false;
          });
        }

        function updatePayment() {
          if (vm.confirmButtonPressed) return;
          var params = {
            id: $state.params.paymentId,
            payment: vm.insertedPaymentObject
          };
          vm.confirmButtonPressed = true;
          PaymentsService.updatePayment(params.id, params.payment, 'changeProcessed')
            .then(function (signedPayment) {
                $state.go('payments.finalStep', {
                  paymentObject: signedPayment.payment || signedPayment,
                  paymentId: signedPayment.id,
                  type: "domestic"
                });
            })
            .catch(function (response, error) {
              if (response && response.hasWarnings) {
                //show action message modal
                PaymentsService.showModalWithActions(response, objectForInsert, true, params.payment.domesticPayment.urgency);
              } else {
                HelperService.showMessage(response, 'error');
              }
            })
            .finally(function () {
              vm.formSubmitted = false;
              vm.forUpdate = false;
              vm.confirmButtonPressed = false;
            });


        }

        vm.addSpaceForIban = function (toAccountInput) {
          console.log(toAccountInput);

          if (!vm.tempDompObj.toAccountInput){
            vm.uiMask = ValidationService.getUiMask().sl.domestic;
            vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", true);
            console.log("ADD SPACE FOR IBAN EMPTY");
            return;
          }
          // vm.tempDompObj.toAccountInput = vm.tempDompObj.toAccountInput.toUpperCase();
          //   vm.tempDompObj.toAccountInput = toAccountInput.replace(/[^\dA-Za-z]/g, '').replace(/(.{4})/g, '$1 ').trim();
            validateIBANLength();
        };


        vm.checkAccountsEquality = function () {
            var equal = false;
            var toAccountVal = (vm.tempDompObj.toAccountInput) ? vm.tempDompObj.toAccountInput.replace(/\s/g, '') : "";
            if (vm.tempDompObj.fromAccountSelect.iban == toAccountVal) {
                equal = true;
            }
            vm.domesticPaymentForm.toAccountInput.$setValidity('accountEquality', !equal);
        };

        vm.purposeMaxlengthValue = 34;

        vm.showInfo = function () {
          var message = $translate.instant('domesticPayment.urgentInfo');
          var temp = {"resultList":[{"key":"Info","description":message}]};
          if(vm.tempDompObj.isUrgentPaymentCheckbox){
            //HelperService.showMessage(temp, 'info');
            PaymentsService.showModalWithActions(temp,null, null, null);
          }

        };

      vm.formatReferenceNumber = function (referenceNumber) {
        var referenceNumberFormatted;
        var referenceNumberP1 = referenceNumber.substring(0, 2);
        var referenceNumberP2;
        var referenceNumberP3;

        if (referenceNumberP1 == 'SI') {
          referenceNumberP2 = referenceNumber.substring(2, 4);
          referenceNumberP3 = referenceNumber.substring(4);
          referenceNumberFormatted = referenceNumberP1 + " " + referenceNumberP2 + " " + referenceNumberP3;
        } else if (referenceNumberP1 == "RF") {
          referenceNumberP2 = referenceNumber.substring(2);
          referenceNumberFormatted = referenceNumberP1 + " " + referenceNumberP2;
        } else {
          referenceNumberFormatted = referenceNumber.substring(0, 3);
        }

        return referenceNumberFormatted;
      };

        vm.init();
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:DomesticPaymentMneCtrl
     *
     * @description
     *
     */
    DomesticPaymentMneCtrl.$inject = ["$rootScope", "CTLocalizationService", "UserSettingsService", "$state", "$log", "HelperService", "PurposeCodesService", "BanksService", "CountriesService", "PaymentTypesService", "PaymentsService", "ValidationService", "PaymentFilterService", "CreditAccountRegisterService", "$q", "PaymentTemplatesService", "ConfigEndpointService", "$timeout", "ReferenceModelService", "Notification", "AlertService", "ImagesService", "GoogleTagManagerHelperService"];
    angular
        .module('payments')
        .controller('DomesticPaymentMneCtrl', DomesticPaymentMneCtrl);

    function DomesticPaymentMneCtrl($rootScope, CTLocalizationService, UserSettingsService, $state, $log, HelperService,
        PurposeCodesService, BanksService, CountriesService, PaymentTypesService, PaymentsService,
        ValidationService, PaymentFilterService, CreditAccountRegisterService, $q,
        PaymentTemplatesService, ConfigEndpointService, $timeout, ReferenceModelService,
                                     Notification, AlertService,ImagesService, GoogleTagManagerHelperService) {
        var vm = this;
        vm.images = {};
        vm.ctrlName = 'DomesticPaymentMneCtrl';

        vm.currentStep = 1;

        vm.paymentObject = {};
        vm.tempDompObj = {
            fromAccountSelect: {},
            purposeCodeSelect: {},
            purposeOfPaymentInput: '',
            amountInput: '',
            dateInput: new Date(),
            bicCodeInput: '',
            toAccountInput: '',
            referenceCodeInput: '',
            referenceModelSelect: {},
            referenceNumberInput: '',
            payersNameInput: '',
            payersAddressInput: '',
            payersCityInput: '',
            payersSepaInput1: '',
            payersSepaInput2: '',
            receiversNameInput: '',
            receiversAddressInput: '',
            receiversPostalCodeAndCityInput: '',
            receiversCountrySelect: {},
            receiversSepaInput1: '',
            receiversSepaInput2: '',
            isUrgentPaymentCheckbox: false,
            formSubmitted: false
        };

        vm.split = function (input) {
            return HelperService.splitReferenceNumber(input);
        };
        vm.defaultCurrency = '';
        vm.forUpdate = false;
        /*    vm.smsAuthentificate = false;
        vm.smsPasswordInput = '';*/
        vm.bankCharges = '';
        vm.datePickerOpened = false;
        vm.dateOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        vm.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0));
        };

        vm.openDatePicker = function () {
            vm.datePickerOpened = true;
        };

        vm.paymentTypeGroupDomestic = {};
        vm.paymentTypesGroupFilter = {
            paymentTypeGroup: 'DomesticPayment'
        };

        vm.purposeCodesList = {};
        vm.purposeCodesFilter = {
            pageSize: 1000
        };

        vm.banksList = {};
        vm.banksFilter = {
            pageSize: 1000
        };

        vm.countriesCodeList = {};
        vm.countriesCodeFilter = {
            pageSize: 1000
        };

        vm.referenceModelList = [];
        vm.referenceModelFilter = {
            pageSize: 1000
        };

        vm.payeeFilter = {
            paymentTypeGroup: 'DomesticPayment',
            orderBy: 'receiverName ASC',
            page: 0,
            pageSize: 1000
        };

        vm.templatesFilter = {
            paymentTypeGroup: 'DomesticPayment',
            page: 0,
            pageSize: 1000
        };

        vm.templateList = {};

        vm.tmpSearchText = {
            name: ''
        };

        vm.templateName = '';

        vm.fromAccountDropdown = false;
        vm.onlyNumbers = /^[0-9 ]+$/;
        vm.payeeInputField = /[^A-Za-zČčĐđŽžŠšĆć\+]*$/;

        vm.searchFilterExpanded = false;

        vm.datePickerOpened = false;

        vm.openDatePicker = function () {
            vm.datePickerOpened = true;
        };

        vm.paymentTypeGroupDomestic = {};
        vm.paymentTypesGroupFilter = {
            paymentTypeGroup: 'DomesticPayment'
        };

        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

        vm.checkAllowedCharsDPS = function (event) {
            HelperService.checkAllowedCharsDPS(event)
        };

        vm.checkAllowedCharsForPoziv = function (event) {
            HelperService.checkAllowedCharsForPoziv(event)
        };

        vm.getPaymentTypeGroup = function () {
            return PaymentTypesService.getByGroup(vm.paymentTypesGroupFilter)
                .then(function (response) {
                    vm.paymentTypeGroupDomestic = response;

                    _.forEach(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (value) {
                        value.optionValue = value.accountDescription + ' - ' + value.iban;
                    });

                    $log.debug("paymentTypeGroupDomestic", vm.paymentTypeGroupDomestic);
                    if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                        vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                    }
                })
                .catch(function () {
                    $log.error('Error loading paymentTypeGroupDomestic!');
                });
        };

        vm.getPurposeCodesPage = function () {
            return PurposeCodesService.getPage(vm.purposeCodesFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        value.optionValue = value.id + ' - ' + value.description;
                        //  value.optionValue = value.id;
                        vm.tempDompObj.purposeCodeSelect = value.id;
                        vm.tempDompObj.purposeOfPaymentInput = value.description
                    });
                    vm.purposeCodesList = response;
                    if (vm.purposeCodesList.result.length > 0) {
                        // vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
                        setDefaultPurposeCode();
                    }

                    $log.debug("purposeCodesList", vm.purposeCodesList);
                })
                .catch(function () {
                    $log.error('Error loading purpose codes!');
                });
        };

        function setDefaultPurposeCode() {
            vm.tempDompObj.purposeCodeSelect = _.find(vm.purposeCodesList.result, function (item) {
                return item.id === '163';
            });

            vm.changePurpose(vm.tempDompObj.purposeCodeSelect);
        }

        vm.getBanksPage = function () {
            return BanksService.getPage(vm.banksFilter)
                .then(function (response) {
                    vm.banksList = response;
                    $log.debug("banksList", vm.banksList);
                })
                .catch(function () {
                    $log.error('Error loading banks codes!');
                });
        };

        vm.changePurpose = function (purposeChange) {
            // Check if input is coming from purpose code list
            var purpose = _.findWhere(vm.purposeCodesList.result, {
                description: vm.tempDompObj.purposeOfPaymentInput
            });
            if (purpose) {
                vm.tempDompObj.purposeOfPaymentInput = purposeChange.description;
            }
            // var purposeCode = _.findIndex(vm.purposeCodesList.result, function (item) {
            //   vm.tempDompObj.purposeOfPaymentInput = item.description;
            //   return item.id == code.id;
            // });
        };

        vm.getCountriesPage = function () {
            return CountriesService.getPage(vm.countriesCodeFilter)
                .then(function (response) {
                    vm.countriesCodeList = response;
                    var countryIndex = _.findIndex(vm.countriesCodeList.result, function (o) {
                        return o.code == '191';
                    });
                    vm.tempDompObj.receiversCountrySelect = vm.countriesCodeList.result[countryIndex];

                    $log.debug("countriesCodeList", vm.countriesCodeList);
                })
                .catch(function () {
                    $log.error('Error loading bic banks codes!');
                });
        };
        vm.getUserSettingsPage = function () {
            UserSettingsService.getPage(vm.userSettingsFilter)
                .then(function (response) {
                    var userSettings = response.result[0];
                    vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                    vm.tempDompObj.payersAddressInput = userSettings.address1;
                    vm.tempDompObj.payersCityInput = userSettings.city;
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        var createPaymentObject = function () {
            var paymentObject = {};
            paymentObject.domesticPayment = {};
            paymentObject.accountId = vm.tempDompObj.fromAccountSelect.accountId;
            paymentObject.fromAccountNumber = vm.tempDompObj.fromAccountSelect.iban;
            paymentObject.toAccountNumber = vm.tempDompObj.toAccountInput.replace(/-/g, '');
            paymentObject.currencySymbol = vm.tempDompObj.fromAccountSelect.currencySymbol;
            paymentObject.purpose = vm.tempDompObj.purposeOfPaymentInput;
            paymentObject.dueDate = vm.tempDompObj.dateInput;
            paymentObject.amount = vm.tempDompObj.amountInput;
            paymentObject.paymentTypeGroup = 'DomesticPayment';
            paymentObject.purposeCodeDPS = vm.tempDompObj.purposeCodeSelect.id;
            paymentObject.domesticPayment.receiverName = vm.tempDompObj.receiversNameInput;
            paymentObject.domesticPayment.receiverAddress1 = vm.tempDompObj.receiversAddressInput;
            paymentObject.domesticPayment.receiverCity = vm.tempDompObj.receiversPostalCodeAndCityInput;
            paymentObject.domesticPayment.referenceFrom = "";
            paymentObject.domesticPayment.urgency = vm.tempDompObj.isUrgentPaymentCheckbox ? '1' : '0'

            if (vm.tempDompObj.referenceModelSelect) {
                if (vm.tempDompObj.referenceModelSelect === "  ") {
                    paymentObject.domesticPayment.referenceTo = '00' + vm.tempDompObj.referenceNumberInput;
                } else
                    paymentObject.domesticPayment.referenceTo =
                    //vm.tempDompObj.referenceModelSelect + ' ' + vm.tempDompObj.referenceNumberInput;
                    vm.tempDompObj.referenceModelSelect.concat(vm.tempDompObj.referenceNumberInput);
            } else if ((!vm.tempDompObj.referenceModelSelect) && (vm.tempDompObj.referenceNumberInput)) {
                vm.tempDompObj.referenceModelSelect = '00';
                paymentObject.domesticPayment.referenceTo = vm.tempDompObj.referenceModelSelect.concat(vm.tempDompObj.referenceNumberInput);
            } else {
                paymentObject.domesticPayment.referenceTo = '00';
            }

            return paymentObject;
        };

        vm.insertedPaymentObject = {};
        vm.insertedPaymentObjectDomp = {};
        var postPaymentAction = function (response) {
            vm.insertedPaymentObject = response;
            vm.insertedPaymentObject.paymentTypeGroup = "DomesticPayment";
            vm.insertedPaymentObject.senderInfo = {
                senderName: vm.tempDompObj.fromAccountSelect.ownerName,
                senderAddress1: vm.tempDompObj.fromAccountSelect.ownerAddress,
                senderCity: vm.tempDompObj.fromAccountSelect.ownerCity
            };
            vm.insertedPaymentObject.debtorName = vm.tempDompObj.payersSepaInput1;
            vm.insertedPaymentObject.debtorName2 = vm.tempDompObj.payersSepaInput2;
            vm.insertedPaymentObject.creditorName = vm.tempDompObj.receiversSepaInput1;
            vm.insertedPaymentObject.creditorName2 = vm.tempDompObj.receiversSepaInput2;
            vm.insertedPaymentObject.purposeCodeValue = vm.tempDompObj.purposeCodeSelect;
            vm.insertedPaymentObject.receiversNameInput = vm.tempDompObj.receiversNameInput;
            vm.insertedPaymentObjectDomp.referenceTo = vm.insertedPaymentObject.referenceTo; //referenceTo formatting
            var model = vm.insertedPaymentObject.referenceTo.substring(0, 2);
            var number = vm.insertedPaymentObject.referenceTo.substring(2);
            if (model === "00") {
                vm.insertedPaymentObject.referenceTo = number;
            }
            Notification.clearAll();
            vm.currentStep = 2;

            HelperService.scrollToTop();

        };

        vm.submitPayment = function () {
            vm.tempDompObj.formSubmitted = true;
            if (!vm.domesticPaymentForm.$valid) {
                return;
            }

            if (!vm.formSubmitted) {
                vm.formSubmitted = true;
                var objectForInsert = createPaymentObject();

                if (vm.forUpdate) {
                    objectForInsert.id = vm.insertedPaymentObject.id;
                    PaymentsService.updatePayment(vm.insertedPaymentObject.id, objectForInsert)
                        .then(function (response) {
                            postPaymentAction(response);
                            vm.forUpdate = false;
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            vm.forUpdate = false;
                            // vm.domesticPaymentForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                } else {
                    PaymentsService.insertPayment(objectForInsert)
                        .then(function (response) {
                            postPaymentAction(response);
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            // vm.domesticPaymentForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                }
            }

        };

        var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        $rootScope.$on('appLanguageChangedHeader', function () {
            sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        });

        vm.deletePayment = function () {
            //swal({
            //  title: sweetAlertOptions.areYouSure,
            //  type: "info",
            //  showCancelButton: true,
            //  confirmButtonClass: "btn-default",
            //  confirmButtonText: sweetAlertOptions.yes,
            //  cancelButtonText: sweetAlertOptions.no,
            //  closeOnConfirm: true,
            //  closeOnCancel: true
            //}, function (isConfirm) {
            //  if (isConfirm) {
            //    PaymentsService.deletePayment(vm.insertedPaymentObject.id)
            //      .then(function (response) {
            //      HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], vm.insertedPaymentObject.id);
            //      $state.go('payments.paymentsOverview');
            //    })
            //      .catch(function (error) {
            //      HelperService.showMessage(error, 'error');
            //    });
            //  }
            //});

            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        PaymentsService.deletePayment(vm.insertedPaymentObject.id)
                            .then(function (response) {
                                AlertService.deletedPaymentAlert({
                                        paymentName: vm.insertedPaymentObject.id,
                                        type: 'payment'
                                    })
                                    .then(function () {
                                        $state.go('payments.paymentsOverview');
                                    });
                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    }
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });
        };

        vm.formatAccountNumber = function (accountNumber) {
            if (!accountNumber) return;
            var accountNumber = accountNumber.replace(/-/g, ""); // remove dashes
            if (accountNumber.length < 6) {
                vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", false);
                return;
            } else {
                vm.domesticPaymentForm.toAccountInput.$setValidity("minlength", true);
            }
            var str1 = accountNumber.substring(0, 3);
            var str2 = ("0000000000000" + accountNumber.substring(3, accountNumber.length - 2)).slice(-13); // if 5 returns 0000..005
            var str3 = accountNumber.substring(accountNumber.length - 2);

            vm.tempDompObj.toAccountInput = str1 + "-" + str2 + "-" + str3;
            //vm.fillReceiver(vm.tempDompObj.toAccountInput);
        };

        vm.fillReceiver = function (toAccountInput) {
            if (!toAccountInput) return;
            if (vm.domesticPaymentForm.toAccountInput.$valid) {
                vm.formatAccountNumber(vm.tempDompObj.toAccountInput);
                //CreditAccountRegisterService.getPage({accountNumber: toAccountInput.replace(/-/g, '')})
                CreditAccountRegisterService.getPage({
                        accountNumber: vm.tempDompObj.toAccountInput.replace(/-/g, '')
                    })
                    .then(function (response) {

                        if (response.result.length > 0) {
                            var rName = response.result[0].receiverName;
                            var rAddressInput = response.result[0].receiverAddress1;
                            var rPostalCodeAndCityInput = response.result[0].receiverCity;
                            vm.tempDompObj.receiversNameInput = rName.substring(0, 35);
                            vm.tempDompObj.receiversAddressInput = rAddressInput.substring(0, 35);
                            vm.tempDompObj.receiversPostalCodeAndCityInput = rPostalCodeAndCityInput.substring(0, 35);
                        } else {
                            vm.tempDompObj.receiversNameInput = '';
                            vm.tempDompObj.receiversAddressInput = '';
                            vm.tempDompObj.receiversPostalCodeAndCityInput = '';
                        }
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.newPayment = function () {
            clearInput();
            vm.tempDompObj.formSubmitted = false;
            vm.forUpdate = false;
            vm.currentStep = 1;
        }

        var clearInput = function () {
            vm.searchTemplateFilterExpanded = false;
            vm.templateName = '';
            vm.tempDompObj.receiversNameInput = '';
            vm.tempDompObj.toAccountInput = '';
            vm.tempDompObj.receiversAddressInput = '';
            vm.tempDompObj.receiversPostalCodeAndCityInput = '';
            vm.tempDompObj.amountInput = '';
            vm.tempDompObj.dateInput = new Date();
            vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
            vm.tempDompObj.referenceNumberInput = '';

            setDefaultPurposeCode();

            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
        }

        var mapWithPaymentResponse = function () {
            vm.tempDompObj.amountInput = vm.insertedPaymentObject.amount;
            vm.tempDompObj.receiversNameInput = vm.insertedPaymentObject.receiverName;
            vm.tempDompObj.receiversAddressInput = vm.insertedPaymentObject.receiverAddress1;
            vm.tempDompObj.receiversPostalCodeAndCityInput = vm.insertedPaymentObject.receiverCity;
            vm.tempDompObj.toAccountInput = vm.insertedPaymentObject.toAccountNumber;
            vm.tempDompObj.dateInput = new Date(vm.insertedPaymentObject.dueDate);
            vm.tempDompObj.purposeOfPaymentInput = vm.insertedPaymentObject.purpose;

            var accountIndex = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
                return item.accountId == vm.insertedPaymentObject.accountId;
            });

            var purposeCodeIndex = _.findIndex(vm.purposeCodesList.result, function (item) {
                return item.id == vm.insertedPaymentObject.purposeCodeDPS;
            });

            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[accountIndex];
            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[purposeCodeIndex];
        };

        vm.editPayment = function () {
            vm.forUpdate = true;
            vm.currentStep = 1;

            if (vm.tempDompObj.referenceModelSelect === "00") {
                vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
            } else {
                var index = _.findIndex(vm.referenceModelList, function (item) {
                    return item == vm.tempDompObj.referenceModelSelect;
                });
                vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];
            }

            // mapWithPaymentResponse();
        };

        /*    vm.signPayment = function () {
          PaymentsService.signPayment(vm.insertedPaymentObject.id)
            .then(function (response) {
            vm.currentStep = 3;
          })
            .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
        };*/

        var loadAccountData = function (accountId) {
            var index = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
                return item.accountId == accountId;
            });
            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[index];
        };

        //var loadPaymentDataFromTemplate = function (templateId) {
        //  if (templateId) {
        //    PaymentTemplatesService.getById(templateId)
        //      .then(function (response) {
        //      vm.tempDompObj.amountInput = $filter('number')(response.amount, 2);
        //      vm.tempDompObj.toAccountInput = response.toAccountNumber;
        //      vm.tempDompObj.purposeOfPaymentInput = response.purpose;
        //      vm.tempDompObj.receiversNameInput = response.receiverName || '';
        //      vm.tempDompObj.receiversAddressInput = response.receiverAddress1 || '';
        //      vm.tempDompObj.receiversPostalCodeAndCityInput = response.receiverCity || '';
        //      loadAccountData(response.accountId);
        //    })
        //      .catch(function (error) {
        //      HelperService.showMessage(error, 'error');
        //    });
        //  }
        //};

        //////////////////////////CUSTOM SELECT//////////////////////
        vm.searchFilterExpanded = false;

        vm.toggleFilterSelection = function () {
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.searchPayee = function () {
            vm.searchFilterExpanded = true;
        };

        vm.getPayees = function () {
            PaymentTemplatesService.getPage(vm.payeeFilter)
                .then(function (response) {
                    vm.payeeList = response.result;
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.selectPayee = function (id) {
            var index = _.findIndex(vm.payeeList, function (item) {
                vm.tempDompObj.toAccountInput = item.toAccountNumber;
                vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
                vm.tempDompObj.receiversNameInput = item.receiverName;
                vm.tempDompObj.receiversPostalCodeAndCityInput = item.receiverCity;
                return item.id == id;
            });

            vm.formatAccountNumber(vm.payeeList[index].toAccountNumber);
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        vm.removeSearch = function () {
            vm.tempDompObj.receiversNameInput = '';
        };

        vm.searchPayeeBy = function (searchrow) {
            return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1 ||
                angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1);
        };

        ///select template component

        vm.searchTemplate = function () {
            vm.searchTemplateFilterExpanded = true;

            if (vm.searchTemplateFilterExpanded === true) {

                $timeout(function () {
                    var searchTemplatesInput = angular.element('#searchTemplatesInput');
                    searchTemplatesInput.focus();
                }, 500);
            }
        };

        vm.toggleTemplateFilterSelection = function () {
            vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
            if (vm.searchTemplateFilterExpanded && (!vm.templateList.result || vm.templateList.result.length === 0)) {
                vm.getPaymentTemplatesPage();
            }
        };

        vm.getPaymentTemplatesPage = function () {
            PaymentTemplatesService.getPage(vm.templatesFilter)
                .then(function (response) {
                    vm.templateList = response;
                    if(vm.templateList)
                      populateTemplatesWithImages();
                    $log.debug(vm.templateList);
                }).catch(function (error) {
                    $log.error(error);
                });
        };
      vm.selectedTemplate = {};
        vm.selectTemplate = function (id) {
            
            GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentTemplateSelection', 'Template with id ' + id + ' selected');

            var item = _.findWhere(vm.payeeList, {
                id: id
            });
            //      vm.tempDompObj.toAccountInput = item.toAccountNumber;
            vm.formatAccountNumber(item.toAccountNumber);
            vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
            vm.tempDompObj.receiversNameInput = item.receiverName;
            vm.tempDompObj.receiversPostalCodeAndCityInput = item.receiverCity;
            //vm.tempDompObj.amountInput = $filter('number')(item.amount, 2);
            vm.templateName = item.name;
            if (item.referenceTo) {
                if (item.referenceTo.length > 2) {
                    vm.tempDompObj.referenceModelSelect = item.referenceTo.substring(0, 2);
                    vm.tempDompObj.referenceNumberInput = item.referenceTo.substring(2);
                } else {
                    vm.tempDompObj.referenceModelSelect = item.referenceTo;
                    vm.tempDompObj.referenceNumberInput = "";
                }
            }
            if (item.purposeCodeDPS && vm.purposeCodesList.result) {

                var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
                    return purpose.id == item.purposeCodeDPS;
                });
                if (purpose) {
                    vm.tempDompObj.purposeCodeSelect = purpose;
                    vm.tempDompObj.purposeOfPaymentInput = item.purpose || purpose.description;
                }
            }
            vm.tempDompObj.receiversNameInput = item.receiverName;

            vm.searchFilterExpanded = !vm.searchFilterExpanded;
            vm.searchFilterExpanded = false;
            vm.searchTemplateFilterExpanded = false;

            vm.selectedTemplate.imageId = item.imageId;
            setImage(vm.selectedTemplate);
        };

      var setImage = function (selectedTemplate) {
        if (vm.images && vm.images.length > 0) {
          if (selectedTemplate.imageId) {
            var imageObject = _.find(vm.images, function (image) {
              return image.id === selectedTemplate.imageId;
            });
            if (imageObject)
              selectedTemplate.imageDownloadLink = imageObject.downloadLink;
          }

          if (!selectedTemplate.imageId || !selectedTemplate.imageDownloadLink) {
            selectedTemplate.imageId = vm.images[0].id;
            selectedTemplate.imageDownloadLink = vm.images[0].downloadLink;
          }
        }
      }

        vm.removeTemplate = function () {
            vm.searchTemplateFilterExpanded = false;
            vm.templateName = '';
            vm.tempDompObj.receiversNameInput = '';
            vm.tempDompObj.toAccountInput = '';
            vm.tempDompObj.receiversAddressInput = '';
            vm.tempDompObj.receiversPostalCodeAndCityInput = '';
            vm.tempDompObj.amountInput = '';
            //vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
            //vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
            setDefaultPurposeCode();

            vm.tempDompObj.referenceNumberInput = '';
            vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
            vm.selectedTemplate = {};
        };

        //from account component
        vm.toggleFromAccount = function () {
            vm.fromAccountDropdown = !vm.fromAccountDropdown;
        };

        vm.setAccountFrom = function (item) {
            vm.tempDompObj.fromAccountSelect = item;
            vm.fromAccountDropdown = false;
        };

        /*    vm.showSMSAuthentification = function () {
          vm.smsAuthentificate = !vm.smsAuthentificate;
        };*/

        vm.onlyNumbers = /^[0-9 ]+$/;
        vm.payeeInputField = /[^A-Za-zČčĐđŽžŠšĆć\+]*$/;

        vm.referenceModelList.push(""); //First item in refModelList is empty string
        vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
        vm.getReferenceModels = function () {
            return ReferenceModelService.getPage(vm.referenceModelFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        vm.referenceModelList.push(value.model);
                    });
                    vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
                })
                .catch(function () {
                    $log.error('Error loading bic banks codes!');
                });
        };

        /*    vm.getDefaultDetails = function () {
              return ConfigEndpointService.getDefaultData()
                .then(function (response) {
                if (response) {
                  vm.defaultCurrency = response.DefaultCurrency;
                  vm.bankCharges = response.BankCharges;
                }
              })
                .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
            };*/

        vm.init = function () {

            if ($state.params.editable) {
                vm.insertedPaymentObject.id = $state.params.paymentId;
                vm.forUpdate = true;
            }

            vm.getPayees();
            // vm.getUserSettingsPage();

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData) {
                vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
                vm.defaultCurrency = vm.defaultData.DefaultCurrency;
                vm.bankCharges = vm.defaultData.BankCharges;
            }

            if ($rootScope.APP_GLOBAL_SETTINGS.userSettings) {
                var userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
                vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
                vm.tempDompObj.payersAddressInput = userSettings.address1;
                vm.tempDompObj.payersCityInput = userSettings.city;
            }

            // , vm.getDefaultDetails()
            var promises = [vm.getPurposeCodesPage(), vm.getBanksPage(), vm.getCountriesPage(), vm.getPaymentTypeGroup(), vm.getReferenceModels(),loadImages()];
            $q.all(promises)
                .then(function () {
                    //set default form params
                    //set default form params

                    var params = {
                        fromAccountList: vm.paymentTypeGroupDomestic.result[0].debitAccountList,
                        purposeCodeList: vm.purposeCodesList.result,
                        referenceModelList: vm.referenceModelList
                    };

                    switch ($state.current && $state.current.name) {
                    case 'payments.domesticPayment.fromTemplate':
                        PaymentTemplatesService.loadDomesticPaymentData($state.params.templateId, vm.tempDompObj, params)
                            .then(function () {
                                vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                            })
                            .catch(function () {
                                $log.error('loadDomesticPaymentData', error);
                            });
                        break;
                    case 'payments.domesticPayment.fromPayment':
                        PaymentsService.loadDomesticPaymentData($state.params.paymentId, vm.tempDompObj, params)
                            .then(function () {
                                vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                            })
                            .catch(function (error) {
                                $log.error('loadDomesticPaymentData()', error);
                            });
                        break;
                    case 'payments.domesticPayment':
                        if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                        }
                        break;
                    case 'payments.domesticPayment.fromAccount':
                        if ($state.params.accountId) {
                            vm.tempDompObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountList, $state.params.accountId);
                        }
                        break;
                    }

                    //  if ($state.params && $state.params.paymentId) {
                    //    var params = {
                    //      fromAccountList: vm.paymentTypeGroupDomestic.result[0].debitAccountList
                    //    };
                    //    PaymentsService.loadDomesticPaymentData($state.params.paymentId, vm.tempDompObj, params)
                    //      .then(function () {
                    //        vm.payeeSearchFilter = params.payeeSearchFilter;
                    //      })
                    //      .catch(function (error) {
                    //        $log.error('loadDomesticPaymentData()', error);
                    //      });
                    //  } else {
                    //  if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                    //    vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                    //  }
                    //  if (vm.purposeCodesList.result.length > 0) {
                    //    vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
                    //    vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
                    //  }
                    //  if (vm.referenceModelList.length > 0) {
                    //    var index = _.findIndex(vm.referenceModelList, function (o) {
                    //      return o === "  ";
                    //    });
                    //    vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];
                    //  }
                    //}
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

      vm.templateImagesFilter = {
        category: "Templates"
      };
      var loadImages = function () {
        return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
          console.log(JSON.stringify(images));
          vm.images = images.result;
        }).catch(function (err) {
          $log.error(err);
        });
      };

      var populateTemplatesWithImages = function () {
        if (vm.images && vm.images.length > 0) {
          _.forEach(vm.templateList.result, function (template) {

            if (template.imageId) {
              var imageObject = _.find(vm.images, function (image) {
                return image.id === template.imageId;
              });
              if (imageObject)
                template.imageDownloadLink = imageObject.downloadLink;
            }

            if (!template.imageId || !template.imageDownloadLink) {
              template.imageId = vm.images[0].id;
              template.imageDownloadLink = vm.images[0].downloadLink;
            }

          });
        }
      };
        
        vm.pushGtmUrgentPaymentEvent = function () {
            GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentIsUrgentSelection', (vm.tempDompObj.isUrgentPaymentCheckbox)?'Urgent payment checked':'Urgent payment unchecked');
        };

        vm.init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:DomesticPaymentCroCtrl
   *
   * @description
   *
   */
  DomesticPaymentCroCtrl.$inject = ["$rootScope", "CTLocalizationService", "UserSettingsService", "$state", "$log", "HelperService", "PurposeCodesService", "BanksService", "CountriesService", "PaymentTypesService", "PaymentsService", "ValidationService", "CreditAccountRegisterService", "$q", "PaymentTemplatesService", "ConfigEndpointService", "$timeout", "ReferenceModelService", "PaymentFilterService", "Notification", "AlertService", "ImagesService", "GoogleTagManagerHelperService", "$location"];
  angular
    .module('payments')
    .controller('DomesticPaymentCroCtrl', DomesticPaymentCroCtrl);

  function DomesticPaymentCroCtrl($rootScope, CTLocalizationService, UserSettingsService, $state, $log, HelperService,
                                  PurposeCodesService, BanksService, CountriesService,
                                  PaymentTypesService, PaymentsService, ValidationService,
                                  CreditAccountRegisterService, $q, PaymentTemplatesService,
                                  ConfigEndpointService, $timeout, ReferenceModelService, PaymentFilterService,
                                   Notification, AlertService,ImagesService,GoogleTagManagerHelperService,$location) {
    var vm = this;
    vm.images = {};

    vm.currentStep = 1;

    vm.paymentObject = {};
    vm.tempDompObj = {
      fromAccountSelect: {},
      purposeCodeSelect: {},
      purposeOfPaymentInput: '',
      amountInput: '',
      dateInput: new Date(),
      bicCodeInput: '',
      toAccountInput: '',
      referenceCodeInput: '',
      referenceModelSelect: {},
      referenceNumberInput: '',
      payersNameInput: '',
      payersAddressInput: '',
      payersCityInput: '',
      payersSepaInput1: '',
      payersSepaInput2: '',
      receiversNameInput: '',
      receiversAddressInput: '',
      receiversPostalCodeAndCityInput: '',
      receiversCountrySelect: {},
      receiversSepaInput1: '',
      receiversSepaInput2: '',
      isUrgentPaymentCheckbox: false,
      formSubmitted: false
    };
    vm.referenceHR = "HR";

    vm.defaultCurrency = '';
    vm.forUpdate = false;
    /*    vm.smsAuthentificate = false;
     vm.smsPasswordInput = '';*/
    vm.hideUrgency = false;

    vm.split = function (input) {
      return HelperService.splitReferenceNumber(input);
    };

    vm.datePickerOpened = false;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.disabledSunday = false;
    vm.disabled = function (date, mode) {
      return (mode === 'day' && (date.getDay() === 0));
    };

    vm.bankCharges = '';
    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.paymentTypeGroupDomestic = {};
    vm.paymentTypesGroupFilter = {
      paymentTypeGroup: 'DomesticPayment'
    };

    vm.purposeCodesList = {};
    vm.purposeCodesFilter = {
      pageSize: 1000
    };

    vm.banksList = {};
    vm.banksFilter = {
      pageSize: 1000
    };

    vm.countriesCodeList = {};
    vm.countriesCodeFilter = {
      pageSize: 1000
    };

    vm.referenceModelList = [];
    vm.referenceModelFilter = {
      pageSize: 1000
    };

    vm.payeeFilter = {
      paymentTypeGroup: 'DomesticPayment',
      orderBy: 'receiverName ASC',
      page: 0,
      pageSize: 1000
    };

    vm.templatesFilter = {
      paymentTypeGroup: 'DomesticPayment',
      page: 0,
      pageSize: 1000
    };

    vm.templateList = {};

    vm.tmpSearchText = {
      name: ''
    };

    vm.templateName = '';

    vm.fromAccountDropdown = false;
    vm.onlyNumbers = /^[0-9 ]+$/;
    vm.payeeInputField = /[^A-Za-zČčĐđŽžŠšĆć\+]*$/;

    vm.searchFilterExpanded = false;

    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    vm.uiMaskOptions = ValidationService.getUiMaskOptions().croatia.iban;

    var loadAccountData = function (accountId) {
      var index = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
        return item.accountId == accountId;
      });
      vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[index];
    };

    //var loadPaymentDataFromTemplate = function (templateId) {
    //  if (templateId) {
    //    PaymentTemplatesService.getById(templateId)
    //      .then(function (response) {
    //        vm.tempDompObj.amountInput = $filter('number')(response.amount, 2);
    //        vm.tempDompObj.toAccountInput = response.toAccountNumber;
    //        vm.tempDompObj.purposeOfPaymentInput = response.purpose;
    //        vm.tempDompObj.receiversNameInput = response.receiverName || '';
    //        vm.tempDompObj.receiversAddressInput = response.receiverAddress1 || '';
    //        vm.tempDompObj.receiversPostalCodeAndCityInput = response.receiverCity || '';
    //        loadAccountData(response.accountId);
    //      })
    //      .catch(function (error) {
    //        HelperService.showMessage(error, 'error');
    //      });
    //  }
    //};

    vm.getPaymentTypeGroup = function () {
      return PaymentTypesService.getByGroup(vm.paymentTypesGroupFilter)
        .then(function (response) {
          vm.paymentTypeGroupDomestic = response;

          _.forEach(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (value) {
            value.optionValue = value.accountDescription + ' - ' + value.iban;
          });

          $log.debug("paymentTypeGroupDomestic", vm.paymentTypeGroupDomestic);
          if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
          }
        })
        .catch(function () {
          $log.error('Error loading paymentTypeGroupDomestic!');
        });
    };

    vm.getPurposeCodesPage = function () {
      return PurposeCodesService.getPage(vm.purposeCodesFilter)
        .then(function (response) {
          _.forEach(response.result, function (value) {
            value.optionValue = value.id + ' - ' + value.description;
            //  value.optionValue = value.id;
            vm.tempDompObj.purposeCodeSelect = value.id;
            vm.tempDompObj.purposeOfPaymentInput = value.description
          });
          vm.purposeCodesList = response;
          if (vm.purposeCodesList.result.length > 0) {
            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
            vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
          }
          $log.debug("purposeCodesList", vm.purposeCodesList);
        })
        .catch(function () {
          $log.error('Error loading purpose codes!');
        });
    };

    vm.getBanksPage = function () {
      return BanksService.getPage(vm.banksFilter)
        .then(function (response) {
          vm.banksList = response;
          $log.debug("banksList", vm.banksList);
        })
        .catch(function () {
          $log.error('Error loading banks codes!');
        });
    };

    vm.changePurpose = function (purposeChange) {
      var purpose = _.findWhere(vm.purposeCodesList.result, {
        description: vm.tempDompObj.purposeOfPaymentInput
      });
      if (purpose) {
        vm.tempDompObj.purposeOfPaymentInput = purposeChange.description;
      }
      // var purposeCode = _.findIndex(vm.purposeCodesList.result, function (item) {
      //   vm.tempDompObj.purposeOfPaymentInput = item.description;
      //   return item.id == code.id;
      // });
    };

    vm.getCountriesPage = function () {
      return CountriesService.getPage(vm.countriesCodeFilter)
        .then(function (response) {
          vm.countriesCodeList = response;

          $log.debug("countriesCodeList", vm.countriesCodeList);
        })
        .catch(function () {
          $log.error('Error loading bic banks codes!');
        });
    };

    vm.getUserSettingsPage = function () {
      UserSettingsService.getPage(vm.userSettingsFilter)
        .then(function (response) {
          var userSettings = response.result[0];
          vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
          vm.tempDompObj.payersAddressInput = userSettings.address1;
          vm.tempDompObj.payersCityInput = userSettings.city;
        })
        .catch(function (error) {
          $log.error(error);
        });
    };

    vm.insertedPaymentObjectDomp = {};
    var createPaymentObject = function () {

      if (vm.tempDompObj.toAccountInput.substring(0, 2) !== 'HR') {
        vm.tempDompObj.toAccountInput = "HR" + vm.tempDompObj.toAccountInput;
      }

      var paymentObject = {};
      paymentObject.domesticPayment = {};
      paymentObject.sepaUpnIdentificators = {};
      paymentObject.accountId = vm.tempDompObj.fromAccountSelect.accountId;
      paymentObject.fromAccountNumber = vm.tempDompObj.fromAccountSelect.iban;
      paymentObject.toAccountNumber = vm.tempDompObj.toAccountInput;
      paymentObject.currencySymbol = vm.tempDompObj.fromAccountSelect.currencySymbol;
      paymentObject.purpose = vm.tempDompObj.purposeOfPaymentInput;
      paymentObject.dueDate = vm.tempDompObj.dateInput;
      paymentObject.amount = vm.tempDompObj.amountInput;
      paymentObject.paymentTypeGroup = 'DomesticPayment';
      paymentObject.purposeCodeDPS = vm.tempDompObj.purposeCodeSelect.id;
      paymentObject.domesticPayment.receiverName = vm.tempDompObj.receiversNameInput;
      paymentObject.domesticPayment.receiverAddress1 = vm.tempDompObj.receiversAddressInput;
      paymentObject.domesticPayment.receiverCity = vm.tempDompObj.receiversPostalCodeAndCityInput;
      paymentObject.domesticPayment.urgency = vm.tempDompObj.isUrgentPaymentCheckbox ? '1' : '0'
      paymentObject.domesticPayment.referenceFrom = '99';

      paymentObject.sepaUpnIdentificators.debtorName = vm.tempDompObj.payersSepaInput1;
      paymentObject.sepaUpnIdentificators.debtorName2 = vm.tempDompObj.payersSepaInput2;
      paymentObject.sepaUpnIdentificators.creditorName = vm.tempDompObj.receiversSepaInput1;
      paymentObject.sepaUpnIdentificators.creditorName2 = vm.tempDompObj.receiversSepaInput2;

      if (vm.tempDompObj.referenceModelSelect) {
        if (vm.tempDompObj.referenceModelSelect === "  ") {
          paymentObject.domesticPayment.referenceTo = '00' + vm.tempDompObj.referenceNumberInput;
        } else
          paymentObject.domesticPayment.referenceTo = vm.tempDompObj.referenceModelSelect.concat(vm.tempDompObj.referenceNumberInput);
      } else if ((!vm.tempDompObj.referenceModelSelect) && (vm.tempDompObj.referenceNumberInput)) {
        vm.tempDompObj.referenceModelSelect = '00';
        paymentObject.domesticPayment.referenceTo = vm.tempDompObj.referenceModelSelect.concat(vm.tempDompObj.referenceNumberInput);
      } else {
        paymentObject.domesticPayment.referenceTo = '00';
      }


      return paymentObject;
    };

    vm.insertedPaymentObject = {};

    var postPaymentAction = function (response) {
      vm.insertedPaymentObject = response;
      vm.insertedPaymentObject.paymentTypeGroup = "DomesticPayment";
      vm.insertedPaymentObject.senderInfo = {
        senderName: vm.tempDompObj.fromAccountSelect.ownerName,
        senderAddress1: vm.tempDompObj.fromAccountSelect.ownerAddress,
        senderCity: vm.tempDompObj.fromAccountSelect.ownerCity
      };

      vm.insertedPaymentObjectDomp.referenceTo = vm.insertedPaymentObject.referenceTo;
      Notification.clearAll();
      vm.currentStep = 2;
    };

    vm.submitPayment = function () {
      vm.tempDompObj.formSubmitted = true;
      if (!vm.domesticPaymentForm.$valid) {
        return;
      }

      if (!vm.formSubmitted) {
        vm.formSubmitted = true;
        var objectForInsert = createPaymentObject();

        if (vm.forUpdate) {
          objectForInsert.id = vm.insertedPaymentObject.id;
          PaymentsService.updatePayment(vm.insertedPaymentObject.id, objectForInsert)
            .then(function (response) {
              postPaymentAction(response);
              vm.forUpdate = false;
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
              // vm.domesticPaymentForm.$valid = false;
              vm.forUpdate = false;
            })
            .finally(function () {
              vm.formSubmitted = false;
            });
        } else {
          PaymentsService.insertPayment(objectForInsert)
            .then(function (response) {
              postPaymentAction(response);
              var gtmObject = HelperService.processUrlForGTM('payment');
              GoogleTagManagerHelperService.pushVirtualPageView(gtmObject.url, gtmObject.title, $location.host() + gtmObject.url);
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
              // vm.domesticPaymentForm.$valid = false;
            })
            .finally(function () {
              vm.formSubmitted = false;
            });
        }
      }
    };


    var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    $rootScope.$on('appLanguageChangedHeader', function () {
      sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    });

    vm.deletePayment = function () {
      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            PaymentsService.deletePayment(vm.insertedPaymentObject.id)
              .then(function (response) {
                AlertService.deletedPaymentAlert({
                  paymentName: vm.insertedPaymentObject.id,
                  type: 'payment'
                })
                  .then(function () {
                    $state.go('payments.paymentsOverview');
                  });
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });
    };

    var mapWithPaymentResponse = function () {
      vm.tempDompObj.amountInput = vm.insertedPaymentObject.amount;
      vm.tempDompObj.receiversNameInput = vm.insertedPaymentObject.receiverName;
      vm.tempDompObj.receiversAddressInput = vm.insertedPaymentObject.receiverAddress1;
      vm.tempDompObj.receiversPostalCodeAndCityInput = vm.insertedPaymentObject.receiverCity;
      vm.tempDompObj.toAccountInput = vm.insertedPaymentObject.toAccountNumber;
      vm.tempDompObj.dateInput = new Date(vm.insertedPaymentObject.dueDate);
      vm.tempDompObj.purposeOfPaymentInput = vm.insertedPaymentObject.purpose;

      var accountIndex = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
        return item.accountId == vm.insertedPaymentObject.accountId;
      });

      var purposeCodeIndex = _.findIndex(vm.purposeCodesList.result, function (item) {
        return item.id == vm.insertedPaymentObject.purposeCodeDPS;
      });

      vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[accountIndex];
      vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[purposeCodeIndex];
      vm.tempDompObj.payersSepaInput1 = vm.insertedPaymentObject.debtorName;
      vm.tempDompObj.payersSepaInput2 = vm.insertedPaymentObject.debtorName2;
      vm.tempDompObj.receiversSepaInput1 = vm.insertedPaymentObject.creditorName;
      vm.tempDompObj.receiversSepaInput2 = vm.insertedPaymentObject.creditorName2;
    };

    vm.editPayment = function () {
      vm.forUpdate = true;
      vm.currentStep = 1;
      mapWithPaymentResponse();
    };

    var fillReceiversInput = function (response) {
      if (response.result.length > 0) {
        var rName = response.result[0].receiverName;
        var rAddressInput = response.result[0].receiverAddress1;
        var rPostalCodeAndCityInput = response.result[0].receiverCity;
        vm.tempDompObj.receiversNameInput = rName.substring(0, 70);
        vm.tempDompObj.receiversAddressInput = rAddressInput.substring(0, 35);
        vm.tempDompObj.receiversPostalCodeAndCityInput = rPostalCodeAndCityInput.substring(0, 35);
      } else {
        vm.tempDompObj.receiversNameInput = '';
        vm.tempDompObj.receiversAddressInput = '';
        vm.tempDompObj.receiversPostalCodeAndCityInput = '';
      }
    };

    vm.fillReceiver = function (toAccountInput) {
      if (!toAccountInput) return;
      if (toAccountInput.substring(0, 2) != 'HR') {
        toAccountInput = "HR" + toAccountInput;
      }
      //dodano zbog disable-anja hitnog plaćanja i omogucene nedjelje na internim nalozima
      var temp = toAccountInput.substring(4, 11);
      if (temp === '2500009') {
        vm.hideUrgency = true;
        vm.disabledSunday = false;
      } else {
        vm.hideUrgency = false;
        vm.disabledSunday = true;
        vm.disabled(vm.tempDompObj.dateInput, 'day');
        if (vm.tempDompObj.dateInput.getDay() === 0) {
          vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1);
        }
      }

      vm.tempDompObj.toAccountInput = toAccountInput;
      if (toAccountInput.length == 21) {
        if (toAccountInput.substring(0, 2) === 'HR') {
          CreditAccountRegisterService.getByIban(toAccountInput)
            .then(function (response) {
              fillReceiversInput(response);
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
            });
        } else {
          CreditAccountRegisterService.getPage({
            accountNumber: toAccountInput
          })
            .then(function (response) {
              fillReceiversInput(response);
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
            });
        }
      } else {
        return false;
      }
    };

    vm.clearSepaReceiver = function () {
      vm.tempDompObj.receiversSepaInput1 = '';
      vm.tempDompObj.receiversSepaInput2 = '';
    };

    vm.clearSepaPayer = function () {
      vm.tempDompObj.payersSepaInput1 = '';
      vm.tempDompObj.payersSepaInput2 = '';
    };

    /////////////////////////////CUSTOM SELECT////////////////////////////

    vm.toggleFilterSelection = function () {
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    vm.searchPayee = function () {
      vm.searchFilterExpanded = true;
    };

    vm.getPayees = function () {
      PaymentTemplatesService.getPage(vm.payeeFilter)
        .then(function (response) {
          vm.payeeList = response.result;
        }).catch(function (error) {
        $log.error(error);
      });
    };

    vm.selectPayee = function (id) {
      var index = _.findIndex(vm.payeeList, function (item) {
        vm.tempDompObj.toAccountInput = item.toAccountNumber;
        vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
        vm.tempDompObj.receiversNameInput = item.receiverName;
        vm.tempDompObj.receiversPostalCodeAndCityInput = item.receiverCity;
        return item.id == id;
      });
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    vm.removeSearch = function () {
      vm.tempDompObj.receiversNameInput = '';
    };

    vm.searchPayeeBy = function (searchrow) {
      return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1 ||
      angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1);
    };

    ////////////////select template component//////////////////////
    vm.searchTemplate = function () {
      vm.searchTemplateFilterExpanded = true;
      if (vm.searchTemplateFilterExpanded === true) {
        $timeout(function () {
          var searchTemplatesInput = angular.element('#searchTemplatesInput');
          searchTemplatesInput.focus();
        }, 500);
      }
    };

    vm.toggleTemplateFilterSelection = function () {
      vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
      if (vm.searchTemplateFilterExpanded && (!vm.templateList.result || vm.templateList.result.length === 0)) {
        vm.getPaymentTemplatesPage();
      }
    };

    vm.getPaymentTemplatesPage = function () {
      PaymentTemplatesService.getPage(vm.templatesFilter)
        .then(function (response) {
          vm.templateList = response;
          if (vm.templateList)
            populateTemplatesWithImages();
          $log.debug(vm.templateList);
        }).catch(function (error) {
        $log.error(error);
      });
    };
    vm.selectedTemplate = {};
    vm.selectTemplate = function (id) {
        GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentTemplateSelection', 'Template with id ' + id + ' selected');
      var item = _.findWhere(vm.payeeList, {
        id: id
      });
      vm.templateName = item.name;
      vm.tempDompObj.toAccountInput = item.toAccountNumber;
      vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
      vm.tempDompObj.receiversNameInput = item.receiverName;
      vm.tempDompObj.receiversPostalCodeAndCityInput = item.receiverCity;
      vm.tempDompObj.payersSepaInput1 = item.debtorName;
      vm.tempDompObj.payersSepaInput2 = item.debtorName2;
      vm.tempDompObj.receiversSepaInput1 = item.creditorName;
      vm.tempDompObj.receiversSepaInput2 = item.creditorName2;
      //vm.tempDompObj.amountInput = $filter('number')(item.amount, 2);

      if (item.referenceTo) {
        if (item.referenceTo.length > 2) {
          vm.tempDompObj.referenceModelSelect = item.referenceTo.substring(0, 2);
          vm.tempDompObj.referenceNumberInput = item.referenceTo.substring(2);
        } else {
          vm.tempDompObj.referenceModelSelect = item.referenceTo;
          vm.tempDompObj.referenceNumberInput = "";
        }
      }

      if (item.purposeCodeDPS && vm.purposeCodesList.result) {

        var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
          return purpose.id == item.purposeCodeDPS;
        });
        if (purpose) {
          vm.tempDompObj.purposeCodeSelect = purpose;
          vm.tempDompObj.purposeOfPaymentInput = purpose.description;
        }
      }

      if (vm.tempDompObj.purposeOfPaymentInput === '' || item.purpose !== vm.tempDompObj.purposeOfPaymentInput) {
        vm.tempDompObj.purposeOfPaymentInput = item.purpose;
      }

      vm.tempDompObj.receiversNameInput = item.receiverName;
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
      vm.searchFilterExpanded = false;
      vm.searchTemplateFilterExpanded = false;

      if (vm.tempDompObj.toAccountInput) {
        //dodano zbog disable-anja hitnog plaćanja
        var temp = vm.tempDompObj.toAccountInput.substring(4, 11);
        if (temp === '2500009') {
          vm.hideUrgency = true;
          vm.disabledSunday = false;
        } else {
          vm.hideUrgency = false;
          vm.disabledSunday = true;
          vm.disabled(vm.tempDompObj.dateInput, 'day');
          if (vm.tempDompObj.dateInput.getDay() === 0) {
            vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1);
          }
        }
      }

      vm.selectedTemplate.imageId = item.imageId;
      setImage(vm.selectedTemplate);
    };

    var setImage = function (selectedTemplate) {
      if (vm.images && vm.images.length > 0) {
        if (selectedTemplate.imageId) {
          var imageObject = _.find(vm.images, function (image) {
            return image.id === selectedTemplate.imageId;
          });
          if (imageObject)
            selectedTemplate.imageDownloadLink = imageObject.downloadLink;
        }

        if (!selectedTemplate.imageId || !selectedTemplate.imageDownloadLink) {
          selectedTemplate.imageId = vm.images[0].id;
          selectedTemplate.imageDownloadLink = vm.images[0].downloadLink;
        }
      }
    }

    vm.removeTemplate = function () {
      vm.searchTemplateFilterExpanded = false;
      vm.templateName = '';
      vm.tempDompObj.receiversNameInput = '';
      vm.tempDompObj.toAccountInput = '';
      vm.tempDompObj.receiversAddressInput = '';
      vm.tempDompObj.receiversPostalCodeAndCityInput = '';
      vm.tempDompObj.amountInput = '';
      vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
      vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
      vm.tempDompObj.referenceNumberInput = '';

      var index = _.findIndex(vm.referenceModelList, function (item) {
        return item === '99';
      });

      if (index) {
        vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];
      } else {
        vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
      }

      vm.selectedTemplate = {};
    };

    /////////////////from account component///////////////////////////
    vm.toggleFromAccount = function () {
      vm.fromAccountDropdown = !vm.fromAccountDropdown;
    };

    vm.setAccountFrom = function (item) {
      vm.tempDompObj.fromAccountSelect = item;
      vm.fromAccountDropdown = false;
    };

    /*
     vm.showSMSAuthentification = function () {
     vm.smsAuthentificate = !vm.smsAuthentificate;
     };
     */

    vm.getReferenceModels = function () {
      return ReferenceModelService.getPage(vm.referenceModelFilter)
        .then(function (response) {
          _.forEach(response.result, function (value) {
            vm.referenceModelList.push(value.model);
          });
          var index = _.findIndex(vm.referenceModelList, function (item) {
            return item.model === '99';
          });

          if (index) {
            vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];
          } else {
            vm.tempDompObj.referenceModelSelect = vm.referenceModelList[0];
          }
        })
        .catch(function () {
          $log.error('Error loading bic banks codes!');
        });
    };

    vm.newPayment = function () {
      $state.go($state.current, {}, {
        reload: true
      })
    };

    vm.getDefaultDetails = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
          if (response) {
            vm.defaultCurrency = response.DefaultCurrency;
            vm.bankCharges = response.BankCharges;
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.init = function () {

      /* defaultno omogucena nedjelja (disable-a se ako nalog nema 2500009)
       if (vm.tempDompObj.dateInput.getDay() == 0) {
       vm.tempDompObj.dateInput = new Date(vm.tempDompObj.dateInput.setDate(vm.tempDompObj.dateInput.getDate() + 1));
       }*/

      if ($state.params.editable) {
        vm.insertedPaymentObject.id = $state.params.paymentId;
        vm.forUpdate = true;
      }

      vm.getPayees();
      // vm.getUserSettingsPage();

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData) {
        vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
        vm.defaultCurrency = vm.defaultData.DefaultCurrency;
        vm.bankCharges = vm.defaultData.BankCharges;
      }

      if ($rootScope.APP_GLOBAL_SETTINGS.userSettings) {
        var userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
        vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
        vm.tempDompObj.payersAddressInput = userSettings.address1;
        vm.tempDompObj.payersCityInput = userSettings.city;
      }

      // , vm.getDefaultDetails()
      var promises = [vm.getPurposeCodesPage(), vm.getBanksPage(), vm.getCountriesPage(), vm.getPaymentTypeGroup(), vm.getReferenceModels(),loadImages()];
      $q.all(promises)
        .then(function () {
          //set default form params
          var params = {
            fromAccountList: vm.paymentTypeGroupDomestic.result[0].debitAccountList,
            purposeCodeList: vm.purposeCodesList.result,
            referenceModelList: vm.referenceModelList
          };

          switch ($state.current && $state.current.name) {
            case 'payments.domesticPayment.fromTemplate':
              PaymentTemplatesService.loadDomesticPaymentData($state.params.templateId, vm.tempDompObj, params)
                .then(function () {
                  vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                })
                .catch(function () {
                  $log.error('loadDomesticPaymentData', error);
                });
              break;
            case 'payments.domesticPayment.fromPayment':
              PaymentsService.loadDomesticPaymentData($state.params.paymentId, vm.tempDompObj, params)
                .then(function () {
                  vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                })
                .catch(function (error) {
                  $log.error('loadDomesticPaymentData()', error);
                });
              break;
            case 'payments.domesticPayment':
              if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
              }
              if (vm.purposeCodesList.result.length > 0) {
                vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
                vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
              }
              if (vm.referenceModelList.length > 0) {
                var index = _.findIndex(vm.referenceModelList, function (o) {
                  return o === '99';
                });
                vm.tempDompObj.referenceModelSelect = vm.referenceModelList[index];
              }
              break;
            case 'payments.domesticPayment.fromAccount':
              if ($state.params.accountId) {
                vm.tempDompObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountList, $state.params.accountId);
              }
              break;
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.clearReferenceNumber = function () {
      if (vm.tempDompObj.referenceModelSelect === '99') {
        vm.tempDompObj.referenceNumberInput = '';
      }
      ;
    };


    vm.templateImagesFilter = {
      category: "Templates"
    };
    var loadImages = function () {
      return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
        vm.images = images.result;
      }).catch(function (err) {
        $log.error(err);
      });
    };

    var populateTemplatesWithImages = function () {
      if (vm.images && vm.images.length > 0) {
        _.forEach(vm.templateList.result, function (template) {

          if (template.imageId) {
            var imageObject = _.find(vm.images, function (image) {
              return image.id === template.imageId;
            });
            if (imageObject)
              template.imageDownloadLink = imageObject.downloadLink;
          }

          if (!template.imageId || !template.imageDownloadLink) {
            template.imageId = vm.images[0].id;
            template.imageDownloadLink = vm.images[0].downloadLink;
          }

        });
      }
    };

      vm.pushGtmUrgentPaymentEvent = function () {
          GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentIsUrgentSelection', (vm.tempDompObj.isUrgentPaymentCheckbox)?'Urgent payment checked':'Urgent payment unchecked');
      };
    vm.init();

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:DomesticPaymentCtrl
   *
   * @description
   *
   */
  DomesticPaymentCtrl.$inject = ["$rootScope"];
  angular
    .module('payments')
    .controller('DomesticPaymentCtrl', DomesticPaymentCtrl);

  function DomesticPaymentCtrl($rootScope) {
    var vm = this;
    vm.ctrlName = 'DomesticPaymentCtrl';
    vm.location =  $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:DomesticPaymentBhCtrl
   *
   * @description
   *
   */
  DomesticPaymentBhCtrl.$inject = ["$rootScope", "CTLocalizationService", "UserSettingsService", "$state", "$log", "HelperService", "ValidationService", "PurposeCodesService", "BanksService", "CountriesService", "PaymentTypesService", "PaymentsService", "CreditAccountRegisterService", "$q", "PaymentTemplatesService", "ConfigEndpointService", "$timeout", "ReferenceModelService", "$stateParams", "PaymentFilterService", "Notification", "AlertService", "ImagesService", "PublicRevenueService", "GoogleTagManagerHelperService", "$location"];
  angular
    .module('payments')
    .controller('DomesticPaymentBhCtrl', DomesticPaymentBhCtrl);

  function DomesticPaymentBhCtrl($rootScope, CTLocalizationService, UserSettingsService, $state, $log, HelperService,
                                 ValidationService, PurposeCodesService, BanksService, CountriesService,
                                 PaymentTypesService, PaymentsService, CreditAccountRegisterService, $q,
                                 PaymentTemplatesService, ConfigEndpointService, $timeout, ReferenceModelService,
                                  $stateParams, PaymentFilterService, Notification, AlertService, ImagesService, PublicRevenueService, GoogleTagManagerHelperService, $location) {
    var vm = this;
    vm.images = {};
    vm.isRetrieval = false;
    if ($stateParams.myParam == 'retrieval') {
      vm.isRetrieval = true;
    }

    vm.currentStep = 1;

    vm.paymentObject = {};
    vm.tempDompObj = {
      fromAccountSelect: {},
      purposeCodeSelect: {},
      purposeOfPaymentInput: '',
      amountInput: '',
      dateInput: new Date(),
      bicCodeInput: '',
      toAccountInput: '',
      referenceCodeInput: '',
      //referenceModelSelect: {},
      referenceNumberInput: '',
      payersNameInput: '',
      payersAddressInput: '',
      payersCityInput: '',
      payersSepaInput1: '',
      payersSepaInput2: '',
      receiversNameInput: '',
      receiversAddressInput: '',
      receiversPostalCodeAndCityInput: '',
      receiversCountrySelect: {},
      receiversSepaInput1: '',
      receiversSepaInput2: '',
      isUrgentPaymentCheckbox: false,
      formSubmitted: false,
      // related to public revenue payment
      selectedRevenueAccount: '',
      taxPeriodFrom: new Date(),
      taxPeriodTo: new Date(),
      taxPayerId: '',
      revenueCode: '',
      municipality: '',
      reference: '',
      budgetOrganization: '',
      municipalities: [],
      budgetOrganizations: [],
      revenueCodes: [],
      paymentTypes: ['0', '1', '2', '3', '5', '6', '7', '8', '9'],
      //internal transfer
      isInternal: false
    };
    vm.tempDompObj.paymentType = vm.tempDompObj.paymentTypes[0];
    vm.revenueAccounts = [];
    vm.revenueAccountsLoaded = false;
    vm.toAccountInputLength = 16;
    vm.split = function (input) {
      return HelperService.splitReferenceNumber(input);
    }

    vm.defaultCurrency = '';
    vm.forUpdate = false;
    vm.smsAuthentificate = false;
    vm.smsPasswordInput = '';
    vm.bankCharges = '';

    vm.datePickerOpened = false;
    vm.taxPeriodFromOpened = false;
    vm.taxPeriodToOpened = false;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.publicRevenueDateOptions = {
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.openTaxPeriodFrom = function () {
      vm.taxPeriodFromOpened = true;
    };

    vm.openTaxPeriodTo = function () {
      vm.taxPeriodToOpened = true;
    };

    vm.paymentTypeGroupDomestic = {};
    vm.paymentTypesGroupFilter = {
      paymentTypeGroup: 'DomesticPayment'
    };

    vm.purposeCodesList = {};
    vm.purposeCodesFilter = {
      pageSize: 1000
    };

    vm.banksList = {};
    vm.banksFilter = {
      pageSize: 1000
    };

    vm.countriesCodeList = {};
    vm.countriesCodeFilter = {
      pageSize: 1000
    };

    vm.payeeFilter = {
      paymentTypeGroupList: ['DomesticPayment', 'RevenuePayment'],
      orderBy: 'receiverName ASC',
      page: 0,
      pageSize: 1000
    };

    vm.templatesFilter = {
      paymentTypeGroupList: ['DomesticPayment', 'RevenuePayment'],
      page: 0,
      pageSize: 1000,
      orderBy: 'name ASC'
    };

    vm.templateList = {};

    vm.tmpSearchText = {
      name: ''
    };

    vm.templateName = '';

    vm.fromAccountDropdown = false;
    vm.onlyNumbers = /^[0-9 ]+$/;
    vm.payeeInputField = /[^A-Za-zČčĐđŽžŠšĆć\+]*$/;

    vm.searchFilterExpanded = false;

    vm.paymentTypeGroupDomestic = {};
    vm.paymentTypesGroupFilter = {
      paymentTypeGroup: 'DomesticPayment'
    };

    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

    //default validation for reference number
    vm.referenceMaxLength = 22;
    vm.referencePattern = vm.regexPatterns.onlyNumbersAndDashes;

    //function checkModul97Reference() {
    //  var isValid = ValidationService.checkModul97Reference(vm.tempDompObj.toAccountInput);
    //  vm.domesticPaymentForm.referenceNumberInput.$setValidity('modul97reference', isValid)
    //};

    vm.getPaymentTypeGroup = function () {
      return PaymentTypesService.getByGroup(vm.paymentTypesGroupFilter)
        .then(function (response) {
          vm.paymentTypeGroupDomestic = response;

          _.forEach(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (value) {
            value.optionValue = value.accountDescription + ' - ' + value.iban;
          });

          $log.debug("paymentTypeGroupDomestic", vm.paymentTypeGroupDomestic);
          if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
          }
        })
        .catch(function () {
          $log.error('Error loading paymentTypeGroupDomestic!');
        });
    };

    vm.getPurposeCodesPage = function () {
      return PurposeCodesService.getPage(vm.purposeCodesFilter)
        .then(function (response) {
          _.forEach(response.result, function (value) {
            value.optionValue = value.id + ' - ' + value.description;
            vm.tempDompObj.purposeOfPaymentInput = value.description
          });
          vm.purposeCodesList = response;
          if (vm.purposeCodesList.result.length > 0) {
            vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
            vm.tempDompObj.purposeOfPaymentInput = vm.tempDompObj.purposeCodeSelect.description;
          }
          $log.debug("purposeCodesList", vm.purposeCodesList);
        })
        .catch(function () {
          $log.error('Error loading purpose codes!');
        });
    };

    vm.getBanksPage = function () {
      return BanksService.getPage(vm.banksFilter)
        .then(function (response) {
          vm.banksList = response;
          $log.debug("banksList", vm.banksList);
        })
        .catch(function () {
          $log.error('Error loading banks codes!');
        });
    };

    vm.changePurpose = function (purposeChange) {
      // Check if input is coming from purpose code list
      var purpose = vm.purposeCodesList.result.find(function(item) {
        return item.id == purposeChange.id;
      });
      if (purpose) {
        vm.tempDompObj.purposeOfPaymentInput = purposeChange.description;
      }
    };

    vm.getCountriesPage = function () {
      return CountriesService.getPage(vm.countriesCodeFilter)
        .then(function (response) {
          vm.countriesCodeList = response;
          var countryIndex = _.findIndex(vm.countriesCodeList.result, function (o) {
            return o.code == '191';
          });
          vm.tempDompObj.receiversCountrySelect = vm.countriesCodeList.result[countryIndex];

          $log.debug("countriesCodeList", vm.countriesCodeList);
        })
        .catch(function () {
          $log.error('Error loading bic banks codes!');
        });
    };
    vm.getUserSettingsPage = function () {
      UserSettingsService.getPage(vm.userSettingsFilter)
        .then(function (response) {
          var userSettings = response.result[0];
          vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
          vm.tempDompObj.payersAddressInput = userSettings.address1;
          vm.tempDompObj.payersCityInput = userSettings.city;
        })
        .catch(function (error) {
          $log.error(error);
        });
    };

    var createPaymentObject = function () {
      var paymentObject = {};
      paymentObject.accountId = vm.tempDompObj.fromAccountSelect.accountId;
      paymentObject.fromAccountNumber = vm.tempDompObj.fromAccountSelect.iban;
      paymentObject.toAccountNumber = vm.tempDompObj.toAccountInput.replace(/-/g, '');
      paymentObject.currencySymbol = vm.tempDompObj.fromAccountSelect.currencySymbol;
      paymentObject.purpose = vm.tempDompObj.purposeOfPaymentInput;
      paymentObject.dueDate = vm.tempDompObj.dateInput;
      paymentObject.amount = vm.tempDompObj.amountInput;


      //map payment as LocalCurrencyTransfer
      if (vm.tempDompObj.isInternal) {
        paymentObject.paymentTypeGroup = "LocalCurrencyTransfer";
        paymentObject.domesticPayment = {
          receiverName: vm.tempDompObj.receiversNameInput
        };
        paymentObject.paymentSubTypeGroup = 'DomesticPayment';
      } else {
        paymentObject.domesticPayment = {};
        paymentObject.purposeCodeDPS = vm.tempDompObj.purposeCodeSelect.id;
        paymentObject.paymentTypeGroup = 'DomesticPayment';
        paymentObject.domesticPayment.receiverName = vm.tempDompObj.receiversNameInput;
        paymentObject.domesticPayment.receiverAddress1 = vm.tempDompObj.receiversAddressInput;
        paymentObject.domesticPayment.urgency = vm.tempDompObj.isUrgentPaymentCheckbox ? '1' : '0';
        paymentObject.domesticPayment.destinationCurrencySymbol = vm.tempDompObj.fromAccountSelect.currencySymbol;
        if (vm.tempDompObj.referenceNumberInput) {
          paymentObject.domesticPayment.reference = vm.tempDompObj.referenceNumberInput;
        }

        //mapping for public revenue
        if (vm.tempDompObj.selectedRevenueAccount) {
          paymentObject.paymentTypeGroup = 'RevenuePayment';
          paymentObject.domesticPayment.taxPayerId = vm.tempDompObj.taxPayerId;
          paymentObject.domesticPayment.revenuePaymentType = vm.tempDompObj.paymentType;
          paymentObject.domesticPayment.revenueCode = vm.tempDompObj.revenueCode;
          paymentObject.domesticPayment.municipality = vm.tempDompObj.municipality;
          paymentObject.domesticPayment.budgetOrganization = vm.tempDompObj.budgetOrganization;
          paymentObject.domesticPayment.taxPeriodFrom = vm.tempDompObj.taxPeriodFrom;
          paymentObject.domesticPayment.taxPeriodTo = vm.tempDompObj.taxPeriodTo;
          paymentObject.domesticPayment.purposeCode = vm.tempDompObj.purposeCodeSelect.id;
        }
      }


      return paymentObject;
    };

    vm.insertedPaymentObject = {};

    var postPaymentAction = function (response) {
      //vm.insertedPaymentObject.paymentTypeGroup = "DomesticPayment";
      Notification.clearAll();
      vm.currentStep = 2;
      HelperService.scrollToTop();
    };

    vm.submitPayment = function () {
      vm.tempDompObj.formSubmitted = true;
      if (!vm.domesticPaymentForm.$valid) {
        return;
      }

      if (!vm.formSubmitted) {
        var objectForInsert = createPaymentObject();

        if (vm.forUpdate) {
          objectForInsert.id = vm.insertedPaymentObject.id;
          PaymentsService.updatePayment(vm.insertedPaymentObject.id, objectForInsert)
            .then(function (response) {
              vm.insertedPaymentObject = response;
              loadBankCharges(response)
                .then(function () {
                  postPaymentAction(response);
                  vm.forUpdate = false;
                });
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
              vm.forUpdate = false;
              // vm.domesticPaymentForm.$valid = false;
            })
            .finally(function () {
              vm.formSubmitted = false;
            });
        } else {
          PaymentsService.insertPayment(objectForInsert)
            .then(function (response) {
              var gtmObject = HelperService.processUrlForGTM('payment');
              GoogleTagManagerHelperService.pushVirtualPageView(gtmObject.url, gtmObject.title, $location.host() + gtmObject.url);
              vm.insertedPaymentObject = response;
              loadBankCharges(response)
                .then(function () {
                  postPaymentAction(response);
                })
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
              // vm.domesticPaymentForm.$valid = false;
            })
            .finally(function () {
              vm.formSubmitted = false;
            });
        }
      }
    };

    var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    $rootScope.$on('appLanguageChangedHeader', function () {
      sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    });

    vm.deletePayment = function () {
      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            PaymentsService.deletePayment(vm.insertedPaymentObject.id)
              .then(function (response) {
                AlertService.deletedPaymentAlert({
                  paymentName: vm.insertedPaymentObject.id,
                  type: 'payment'
                })
                  .then(function () {
                    $state.go('payments.paymentsOverview');
                  });
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });
    };

    var mapWithPaymentResponse = function () {
      vm.tempDompObj.amountInput = vm.insertedPaymentObject.amount;
      vm.tempDompObj.toAccountInput = vm.insertedPaymentObject.toAccountNumber;
      vm.tempDompObj.dateInput = new Date(vm.insertedPaymentObject.dueDate);
      vm.tempDompObj.purposeOfPaymentInput = vm.insertedPaymentObject.purpose;
      var accountIndex = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
        return item.accountId == vm.insertedPaymentObject.accountId;
      });
      vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[accountIndex];

      if (vm.insertedPaymentObject.paymentTypeGroup !== "LocalCurrencyTransfer") {
        vm.tempDompObj.receiversNameInput = vm.insertedPaymentObject.receiverName;
        vm.tempDompObj.receiversAddressInput = vm.insertedPaymentObject.receiverAddress1;
        var purposeCodeIndex = _.findIndex(vm.purposeCodesList.result, function (item) {
          return item.id == vm.insertedPaymentObject.purposeCodeDPS;
        });
        vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[purposeCodeIndex];

        // mapping related to public revenue
        if (vm.insertedPaymentObject.revenuePaymentDetails) {
          vm.tempDompObj.budgetOrganization = vm.insertedPaymentObject.revenuePaymentDetails.budgetOrganization;
          vm.tempDompObj.municipality = vm.insertedPaymentObject.revenuePaymentDetails.municipality;
          vm.tempDompObj.referenceNumberInput = vm.insertedPaymentObject.revenuePaymentDetails.reference;
          vm.tempDompObj.revenueCode = vm.insertedPaymentObject.revenuePaymentDetails.revenueCode;
          vm.tempDompObj.taxPayerId = vm.insertedPaymentObject.revenuePaymentDetails.taxPayerId;
          vm.tempDompObj.taxPeriodFrom = new Date(vm.insertedPaymentObject.revenuePaymentDetails.taxPeriodFrom);
          vm.tempDompObj.taxPeriodTo = new Date(vm.insertedPaymentObject.revenuePaymentDetails.taxPeriodTo);
          vm.tempDompObj.paymentType = _.find(vm.tempDompObj.paymentTypes, function (item) {
            return item == vm.insertedPaymentObject.revenuePaymentDetails.priority;
          })
        }
      } else {
        vm.tempDompObj.isInternal = true;
      }

    };

    vm.editPayment = function () {
      vm.forUpdate = true;
      vm.currentStep = 1;
      mapWithPaymentResponse();
    };

    vm.signPayment = function () {
      PaymentsService.signPayment(vm.insertedPaymentObject.id)
        .then(function (response) {
          vm.currentStep = 3;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    var loadAccountData = function (accountId) {
      var index = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
        return item.accountId == accountId;
      });
      vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[index];
    };

    //////////////////////////CUSTOM SELECT//////////////////////
    vm.searchFilterExpanded = false;

    vm.toggleFilterSelection = function () {
      if (!vm.isRetrieval) {
        vm.searchFilterExpanded = !vm.searchFilterExpanded;
      }
    };

    vm.searchPayee = function () {
      vm.searchFilterExpanded = true;
    };

    vm.getPayees = function () {
      PaymentTemplatesService.getPage(vm.payeeFilter)
        .then(function (response) {
          vm.payeeList = response.result;
        }).catch(function (error) {
        $log.error(error);
      });
    };

    function isRevenueAccount() {
      vm.tempDompObj.selectedRevenueAccount = _.find(vm.revenueAccounts, function (item) {
        return vm.tempDompObj.toAccountInput == item.revenueAccountNumber;
      });
      if (vm.tempDompObj.selectedRevenueAccount) {
        vm.referenceMaxLength = 10;
        vm.referencePattern = vm.regexPatterns.onlyNumbers;
      } else {
        vm.referenceMaxLength = 22;
        vm.referencePattern = vm.regexPatterns.onlyNumbersAndDashes;
      }
    };

    vm.selectPayee = function (payeeItem) {
      populateTemplate(payeeItem);
    };

    vm.removeSearch = function () {
      vm.tempDompObj.receiversNameInput = '';
    };

    vm.searchPayeeBy = function (searchrow) {
      return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1 ||
      angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.tempDompObj.receiversNameInput) || '') !== -1);
    };

    ///select template component

    vm.searchTemplate = function () {
      vm.searchTemplateFilterExpanded = true;

      if (vm.searchTemplateFilterExpanded === true) {

        $timeout(function () {
          var searchTemplatesInput = angular.element('#searchTemplatesInput');
          searchTemplatesInput.focus();
        }, 500);
      }
    };

    vm.toggleTemplateFilterSelection = function () {
      if (!vm.isRetrieval) {
        vm.searchTemplateFilterExpanded = !vm.searchTemplateFilterExpanded;
        if (vm.searchTemplateFilterExpanded && (!vm.templateList.result || vm.templateList.result.length === 0)) {
          vm.getPaymentTemplatesPage();
        }
      }
    };

    vm.getPaymentTemplatesPage = function () {
      PaymentTemplatesService.getPage(vm.templatesFilter)
        .then(function (response) {
          vm.templateList = response;
          if (vm.templateList)
            populateTemplatesWithImages();
          $log.debug(vm.templateList);
        }).catch(function (error) {
        $log.error(error);
      });
    };
    vm.selectedTemplate = {};

    function populateTemplate(item) {

      vm.tempDompObj.amountInput = '';
      vm.tempDompObj.toAccountInput = item.toAccountNumber;
      //check is revenue account
      isRevenueAccount();
      vm.tempDompObj.receiversAddressInput = item.receiverAddress1;
      vm.tempDompObj.receiversNameInput = item.receiverName;
      vm.tempDompObj.purposeOfPaymentInput = item.purpose;

      if (item.purposeCodeDPS && vm.purposeCodesList.result) {
        var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
          return purpose.id == item.purposeCodeDPS;
        });
        if (purpose) {
          vm.tempDompObj.purposeCodeSelect = purpose;
          vm.tempDompObj.purposeOfPaymentInput = item.purpose || purpose.description;
        }
      }

      vm.tempDompObj.referenceNumberInput = item.reference;
      vm.validateReferenceNumber();
      vm.tempDompObj.receiversNameInput = item.receiverName;
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
      vm.searchFilterExpanded = false;
      vm.searchTemplateFilterExpanded = false;

      if (item.imageId) {
        vm.selectedTemplate.imageId = item.imageId;
        setImage(vm.selectedTemplate);
      }

      // in case of revenue payment
      if (item.paymentTypeGroup == "RevenuePayment") {
        vm.tempDompObj.budgetOrganization = item.budgetOrganization;
        vm.tempDompObj.municipality = item.municipality;
        vm.tempDompObj.revenueCode = item.revenueCode;
        vm.tempDompObj.taxPayerId = item.taxPayerId;
        vm.tempDompObj.paymentType = _.find(vm.tempDompObj.paymentTypes, function (val) {
          return item.revenuePaymentType = val;
        });
        vm.tempDompObj.taxPeriodFrom = new Date(item.taxPeriodFrom);
        vm.tempDompObj.taxPeriodTo = new Date(item.taxPeriodTo);
      }

      item.urgency == 1 ? vm.tempDompObj.isUrgentPaymentCheckbox = true : vm.tempDompObj.isUrgentPaymentCheckbox = false;
    };

    vm.selectTemplate = function (id) {

        GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentTemplateSelection', 'Template with id ' + id + ' selected');

      var item = _.findWhere(vm.payeeList, {
        id: id
      });

      vm.templateName = item.name;

      populateTemplate(item);

    };

    var setImage = function (selectedTemplate) {
      if (vm.images && vm.images.length > 0) {
        if (selectedTemplate.imageId) {
          var imageObject = _.find(vm.images, function (image) {
            return image.id === selectedTemplate.imageId;
          });
          if (imageObject)
            selectedTemplate.imageDownloadLink = imageObject.downloadLink;
        }

        if (!selectedTemplate.imageId || !selectedTemplate.imageDownloadLink) {
          selectedTemplate.imageId = vm.images[0].id;
          selectedTemplate.imageDownloadLink = vm.images[0].downloadLink;
        }
      }
    }
    vm.removeTemplate = function () {
      vm.searchTemplateFilterExpanded = false;
      vm.templateName = '';
      vm.tempDompObj.receiversNameInput = '';
      vm.tempDompObj.toAccountInput = '';
      vm.tempDompObj.receiversAddressInput = '';
      vm.tempDompObj.receiversPostalCodeAndCityInput = '';
      vm.tempDompObj.amountInput = '';
      vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
      vm.tempDompObj.purposeOfPaymentInput = '';
      vm.tempDompObj.referenceNumberInput = '';
      vm.selectedTemplate = {};

    };

    //from account component
    vm.toggleFromAccount = function () {
      if (!vm.isRetrieval) {
        vm.fromAccountDropdown = !vm.fromAccountDropdown;
      }
    };

    vm.setAccountFrom = function (item) {
      vm.tempDompObj.fromAccountSelect = item;
      vm.fromAccountDropdown = false;
    };

    vm.showSMSAuthentification = function () {
      vm.smsAuthentificate = !vm.smsAuthentificate;
    };


    function fillReceiver() {
      if (!vm.tempDompObj.toAccountInput) return;
      if (vm.domesticPaymentForm.toAccountInput.$valid) {
        CreditAccountRegisterService.getPage({
          accountNumber: vm.tempDompObj.toAccountInput.replace(/-/g, '')
        })
          .then(function (response) {

            if (response.result.length > 0) {
              vm.tempDompObj.receiversNameInput = response.result[0].receiverName.substring(0, 35);
              vm.tempDompObj.receiversAddressInput = response.result[0].receiverAddress1.substring(0, 35);
            }
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    vm.getDefaultDetails = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
          if (response) {
            vm.defaultCurrency = response.DefaultCurrency;
            vm.bankCharges = response.BankCharges;
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.newPayment = function () {
      clearInput();
      vm.tempDompObj.formSubmitted = false;
      vm.forUpdate = false;
      vm.tempDompObj.selectedRevenueAccount = null;
      vm.currentStep = 1;
    };

    var clearInput = function () {
      vm.searchTemplateFilterExpanded = false;
      vm.templateName = '';
      vm.tempDompObj.receiversNameInput = '';
      vm.tempDompObj.toAccountInput = '';
      vm.tempDompObj.receiversAddressInput = '';
      vm.tempDompObj.receiversPostalCodeAndCityInput = '';
      vm.tempDompObj.amountInput = '';
      vm.tempDompObj.dateInput = new Date();
      vm.tempDompObj.referenceNumberInput = '';
      vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
      vm.tempDompObj.purposeOfPaymentInput = '';
      vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
      //fields relative to public revenue
      vm.tempDompObj.revenueCode = '';
      vm.tempDompObj.municipality = '';
      vm.tempDompObj.budgetOrganization = '';
      vm.tempDompObj.taxPayerId = '';
      vm.tempDompObj.taxPeriodFrom = new Date();
      vm.tempDompObj.taxPeriodTo = new Date();
      vm.tempDompObj.paymentType = vm.tempDompObj.paymentTypes[0];
      vm.tempDompObj.isUrgentPaymentCheckbox = false;

    };

    vm.init = function () {
      if ($state.params.editable) {
        vm.insertedPaymentObject.id = $state.params.paymentId;
        vm.forUpdate = true;
      }

      ////AKO JE POVRAT/////
      if (vm.isRetrieval) {
        var promises = [vm.getPurposeCodesPage(), vm.getDefaultDetails(), vm.getPaymentTypeGroup(), getRevenueAccounts()];
        $q.all(promises)
          .then(function () {
            if (vm.purposeCodesList.result.length > 0) {
              //var index = _.findIndex(vm.purposeCodesList.result, function (item) {
              //  return item.id === '89';
              //});

              vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
              vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
            }
            vm.tempDompObj.amountInput = $stateParams.transactionDetails.amount;
            vm.tempDompObj.toAccountInput = $stateParams.transactionDetails.detail.toAccountNumber;
            vm.tempDompObj.fromAccountSelect = $stateParams.transactionDetails.account;
            vm.tempDompObj.receiversAddressInput = $stateParams.transactionDetails.detail.payeeAddress1;
            vm.tempDompObj.receiversNameInput = $stateParams.transactionDetails.detail.payeeName;

          })
      } else {
        vm.getPayees();

        // related to public revenue payment
        getMunicipalities();
        getRevenueCodes();
        getBudgetOrganizations();


        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData) {
          vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
          vm.defaultCurrency = vm.defaultData.DefaultCurrency;
          vm.bankCharges = vm.defaultData.BankCharges;
        }

        if ($rootScope.APP_GLOBAL_SETTINGS.userSettings) {
          var userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
          vm.tempDompObj.payersNameInput = userSettings.firstName + ' ' + userSettings.lastName;
          vm.tempDompObj.payersAddressInput = userSettings.address1;
          vm.tempDompObj.payersCityInput = userSettings.city;
        }

        var promises = [vm.getPurposeCodesPage(), vm.getBanksPage(), vm.getCountriesPage(), vm.getPaymentTypeGroup(), getRevenueAccounts()];
        $q.all(promises)
          .then(function () {
            //set default form params

            var params = {
              fromAccountList: vm.paymentTypeGroupDomestic.result[0].debitAccountList,
              purposeCodeList: vm.purposeCodesList.result
              //referenceModelList: vm.referenceModelList
            };

            switch ($state.current && $state.current.name) {
              case 'payments.domesticPayment.fromTemplate':
                PaymentTemplatesService.loadDomesticPaymentData($state.params.templateId, vm.tempDompObj, params)
                  .then(function () {
                    vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                    vm.tempDompObj.isUrgentPaymentCheckbox = params.urgency;
                    isRevenueAccount();
                  })
                  .catch(function (error) {
                    $log.error('loadDomesticPaymentData', error);
                  });
                break;
              case 'payments.domesticPayment.fromPayment':
                PaymentsService.loadDomesticPaymentData($state.params.paymentId, vm.tempDompObj, params)
                  .then(function () {
                    vm.tempDompObj.receiversNameInput = params.payeeSearchFilter;
                    vm.tempDompObj.isUrgentPaymentCheckbox = params.urgency;
                    vm.tempDompObj.isInternal = params.isInternal;
                    if($state.params.myParam == 'edit'){
                      vm.tempDompObj.dateInput = new Date(vm.tempDompObj.dueDateTemp);
                    }
                    isRevenueAccount();
                  })
                  .catch(function (error) {
                    $log.error('loadDomesticPaymentData()', error);
                  });
                break;
              case 'payments.domesticPayment':
                if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
                  vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
                }
                if (vm.purposeCodesList.result.length > 0) {
                  //vm.tempDompObj.purposeCodeSelect = PaymentFilterService.filterPurposeCodeSelect(vm.purposeCodesList.result, '89');
                  vm.tempDompObj.purposeCodeSelect = vm.purposeCodesList.result[0];
                  vm.tempDompObj.purposeOfPaymentInput = vm.purposeCodesList.result[0].description;
                }
                break;
              case 'payments.domesticPayment.fromAccount':
                if ($state.params.accountId) {
                  vm.tempDompObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountList, $state.params.accountId);
                }
                break;
            }

          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    vm.templateImagesFilter = {
      category: "Templates"
    };

    var loadImages = function () {
      return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
        console.log(JSON.stringify(images));
        vm.images = images.result;
      }).catch(function (err) {
        $log.error(err);
      });
    };

    var populateTemplatesWithImages = function () {
      if (vm.images && vm.images.length > 0) {
        _.forEach(vm.templateList.result, function (template) {

          if (template.imageId) {
            var imageObject = _.find(vm.images, function (image) {
              return image.id === template.imageId;
            });
            if (imageObject)
              template.imageDownloadLink = imageObject.downloadLink;
          }

          if (!template.imageId || !template.imageDownloadLink) {
            template.imageId = vm.images[0].id;
            template.imageDownloadLink = vm.images[0].downloadLink;
          }

        });
      }
    };

    function getMunicipalities() {
      PublicRevenueService.getMunicipalities({
        page: 0,
        pageSize: 1000
      })
        .then(function (response) {
          vm.tempDompObj.municipalities = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    function getRevenueCodes() {
      PublicRevenueService.getRevenueCodes({
        page: 0,
        pageSize: 6000
      })
        .then(function (response) {
          vm.tempDompObj.revenueCodes = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };

    function getBudgetOrganizations() {
      PublicRevenueService.getBudgetOrganizations({
        page: 0,
        pageSize: 1000
      })
        .then(function (response) {
          vm.tempDompObj.budgetOrganizations = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };

    // custom municipalities autocomplete
    vm.municipalityFilterExpanded = false;
    vm.openMunicipalities = function () {
      vm.municipalityFilterExpanded = true;
      validateMunicipalityExistance();
    };

    vm.toggleMunicipalities = function () {
      vm.municipalityFilterExpanded = !vm.municipalityFilterExpanded;
    };

    vm.removeMunicipalities = function () {
      vm.tempDompObj.municipality = '';
    };

    vm.selectMunicipality = function (municipality) {
      vm.tempDompObj.municipality = municipality.codeString;
      vm.municipalityFilterExpanded = false;
      validateMunicipalityExistance();
    };

    // fcn for filtering municipalities
    vm.filterMunicipalities = function (item) {
      return (angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempDompObj.municipality) || '') !== -1 ||
      angular.lowercase(item.codeString).indexOf(angular.lowercase(vm.tempDompObj.municipality) || '') !== -1);
    };

    // custom revenue type autocomplete
    vm.revenueCodeFilterExpanded = false;
    vm.openRevenueCodes = function () {
      vm.revenueCodeFilterExpanded = true;
      vm.tempDompObj.selectedRevenueCode = null;
      validateRevenueCodeExistance();
      validateRevenueCodeType();
    };

    vm.toggleRevenueCodes = function () {
      vm.revenueCodeFilterExpanded = !vm.revenueCodeFilterExpanded;
    };

    vm.closeRevenueCodes = function () {
      vm.tempDompObj.revenueCode = '';
    };

    vm.selectRevenueCode = function (revenueCode) {
      vm.tempDompObj.revenueCode = revenueCode.code;
      vm.tempDompObj.selectedRevenueCode = revenueCode;
      vm.revenueCodeFilterExpanded = false;
      validateRevenueCodeExistance();
      validateRevenueCodeType();
    };

    // fcn for filtering revenue codes
    vm.filterRevenueCodes = function (item) {
      return (angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempDompObj.revenueCode) || '') !== -1 ||
      angular.lowercase(item.code.toString()).indexOf(angular.lowercase(vm.tempDompObj.revenueCode) || '') !== -1);
    };

    // custom budget organizations autocomplete
    vm.budgetOrganizationFilterExpanded = false;
    vm.openBudgetOrganizations = function () {
      vm.budgetOrganizationFilterExpanded = true;
    };

    vm.toggleBudgetOrganizations = function () {
      vm.budgetOrganizationFilterExpanded = !vm.budgetOrganizationFilterExpanded;
    };

    vm.closeBudgetOrganization = function () {
      vm.tempDompObj.budgetOrganization = '';
    };

    vm.selectBudgetOrganization = function (budgetOrg) {
      vm.tempDompObj.budgetOrganization = budgetOrg.budgetOrganisationNumber;
      vm.budgetOrganizationFilterExpanded = false;
    };

    vm.toggleInternalPayment = function () {

    GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentIsInternalSelection', (vm.tempDompObj.isInternal)?"Internal payment selected":"Internal payment deselected");
      clearInput();
      if (vm.forUpdate) {
        vm.forUpdate = false;
      }
    };

    // fcn for filtering revenue codes
    vm.filterBudgetOrganizations = function (item) {
      return (angular.lowercase(item.budgetOrganisationNumber).indexOf(angular.lowercase(vm.tempDompObj.budgetOrganization) || '') !== -1 ||
      angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempDompObj.budgetOrganization) || '') !== -1);
    };

    function getRevenueAccounts() {
      PublicRevenueService.getRevenueAccounts({
        page: 0,
        pageSize: 2000
      })
        .then(function (response) {
          vm.revenueAccounts = response.result;
          vm.revenueAccountsLoaded = true;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    // custom form validation related to public revenue
    vm.checkIsRevenueAccount = function () {
      if (!vm.tempDompObj.isInternal) {
        isRevenueAccount();
        fillReceiver();
        vm.validateReferenceNumber();
        validateRevenueCodeType();
      }
    };

    vm.checkToAccountInputLength = function () {
      var validLength = true;
      vm.tempDompObj.referenceNumberInput = '';
      if (vm.tempDompObj.toAccountInput) {
        if (vm.tempDompObj.isInternal) {
          if (vm.tempDompObj.toAccountInput && (vm.tempDompObj.toAccountInput.substr(0, 3) === "552" || vm.tempDompObj.toAccountInput.substr(0, 3) === "306")) {
            vm.toAccountInputLength = 16;
          } else {
            vm.toAccountInputLength = 8;
          }
        } else {
          vm.toAccountInputLength = 16;
        }
        if (vm.tempDompObj.toAccountInput.length == vm.toAccountInputLength) {
          validLength = true;
        } else {
          validLength = false;
        }
      }
      vm.domesticPaymentForm.toAccountInput.$setValidity('properLength', validLength);
    };

    vm.validateTaxPeriod = function () {
      var isRangeValid = false;
      if (vm.tempDompObj.taxPeriodFrom <= vm.tempDompObj.taxPeriodTo) {
        isRangeValid = true;
      }
      vm.domesticPaymentForm.taxPeriodFrom.$setValidity('taxPeriodRange', isRangeValid);
    };

    function checkRevenueItemsType (code, type) {
      if(!code){
        return true;
      }
      var codes = _.filter(vm.tempDompObj.revenueCodes, function (item){
        return item.code == code;
      });
      for(var i=0; i<codes.length; i++){
        if(type == codes[i].type){
          return true;
        }
      }
      return false;
    };

    function validateRevenueCodeType() {
      if (vm.tempDompObj.selectedRevenueAccount) {
        var correctRevenueCode = false;
        if (vm.tempDompObj.revenueCode === '000000') {
          correctRevenueCode = true;
        } else {
          correctRevenueCode = checkRevenueItemsType(vm.tempDompObj.revenueCode,vm.tempDompObj.selectedRevenueAccount.revenueType);
        }

        if (vm.domesticPaymentForm.revenueCodeFilter) {
          vm.domesticPaymentForm.revenueCodeFilter.$setValidity('revenueCodeType', correctRevenueCode);
        }
      }
    };

    function checkIfRevenueCodeExists() {
      var exists = _.find(vm.tempDompObj.revenueCodes, function (item) {
        return vm.tempDompObj.revenueCode == item.code;
      });
      if (exists) {
        return true;
      }
      return false;
    };

    function checkIfMunicipalityExists() {
      var exists = _.find(vm.tempDompObj.municipalities, function (item) {
        return vm.tempDompObj.municipality == item.codeString;
      });
      if (exists) {
        return true;
      }
      return false;
    };

    function validateRevenueCodeExistance() {
      var exist = checkIfRevenueCodeExists();
      if (!vm.tempDompObj.revenueCode) {
        exist = true;
      }
      vm.domesticPaymentForm.revenueCodeFilter.$setValidity('revenueCodeExistance', exist);
    };

    function validateMunicipalityExistance() {
      var exist = checkIfMunicipalityExists();
      if (!vm.tempDompObj.municipality) {
        exist = true;
      }
      vm.domesticPaymentForm.municipalityFilter.$setValidity('municipalityExistance', exist);
    };

    vm.completeReferenceNumber = function () {
      if (vm.tempDompObj.selectedRevenueAccount && vm.domesticPaymentForm.referenceNumberInput.$valid) {
        if (!vm.tempDompObj.referenceNumberInput) {
          vm.tempDompObj.referenceNumberInput = '';
        }
        var refLength = vm.tempDompObj.referenceNumberInput.length;
        var zeros = '';
        if (refLength < 10) {
          for (var i = 0; i < (10 - refLength); i++) {
            zeros += '0';
          }
        }
        vm.tempDompObj.referenceNumberInput = zeros + vm.tempDompObj.referenceNumberInput;
      }
    };

    vm.validateReferenceNumber = function () {
      var requiredReference = true;
      if (vm.tempDompObj.selectedRevenueAccount && (vm.tempDompObj.selectedRevenueAccount.revenueType === '92' || vm.tempDompObj.selectedRevenueAccount.revenueType === '91')) {
        requiredReference = vm.tempDompObj.referenceNumberInput ? true : false;
      }
      vm.domesticPaymentForm.referenceNumberInput.$setValidity('referenceNumberRequired', requiredReference);
    };

    vm.checkReferenceNumber = function () {
      // var allZeros = false;
      // if (vm.tempDompObj.referenceNumberInput) {
      //   allZeros = true;
      //   for (var i = 0; i < vm.tempDompObj.referenceNumberInput.length; i++) {
      //     //moguce je unijeti samo jednu nulu i potrebno je da je to validan unos - naredna logika je u completeReferenceNumber();
      //     if(i === 0 &&
      //       vm.tempDompObj.referenceNumberInput[i] === '0' && $rootScope.APP_GLOBAL_SETTINGS.defaultData.BiHLocation === 'Banja Luka' &&
      //       (vm.tempDompObj.selectedRevenueAccount.revenueType === '70' ||
      //       vm.tempDompObj.selectedRevenueAccount.revenueType === '21')){
      //       allZeros = false;
      //     }
      //     else if (vm.tempDompObj.referenceNumberInput[i] !== '0') {
      //       allZeros = false;
      //       break;
      //     }
      //   }
      // }
      // vm.domesticPaymentForm.referenceNumberInput.$setValidity('validReferenceNumber', !allZeros);
      var validReferenceNumber = true;
      if(vm.tempDompObj.referenceNumberInput){

        var specificRevenueType = vm.tempDompObj.selectedRevenueAccount.revenueType === '91' || vm.tempDompObj.selectedRevenueAccount.revenueType === '92';
        var banjaLuka = $rootScope.APP_GLOBAL_SETTINGS.defaultData.BiHLocation === 'Banja Luka';

        //if Banja Luka and revenueType is 91 or 92 OR if isNOT Banja Luka then check if referenceNumber have one number different from zero
        //this means:
        //if Banja Luka i revenueType 91 or 92 AND referenceNumber (00000) shouldnt be valid
        //OR
        //if isNOT Banja Luka referenceNumber (00000) shouldnt be valid also


        if((banjaLuka && specificRevenueType) || !banjaLuka){
          validReferenceNumber = checkIfReferenceNumberHaveOneNumberDifferentFromZero(vm.tempDompObj.referenceNumberInput);
        }

        vm.domesticPaymentForm.referenceNumberInput.$setValidity('validReferenceNumber', validReferenceNumber);
      }
    };

    function checkIfReferenceNumberHaveOneNumberDifferentFromZero(referenceNumber) {
      for (var i = 0; i < referenceNumber.length; i++) {
        if(referenceNumber[i] !== '0') return true;
      }
      return false;
    }

    function loadBankCharges(data) {
      var urg = true;
      data.urgency === "1" ? urg = true : urg = false;
      var params = {
        isUrgent: urg,
        amount: data.amount,
        internalAccount: data.toAccountNumber.substr(0, 3)
      };

      return PaymentsService.getBankCharges(params)
        .then(function (response) {
          vm.insertedPaymentObject.bankCharges = response.result[0];

          //vm.bankChargesList = response.result;
          // var accountCode = data.toAccountNumber.substr(0, 3);
          // if (data.urgency === "1") {
          //   vm.insertedPaymentObject.bankCharges = _.find(vm.bankChargesList, function (item) {
          //     return item.isUrgent == true;
          //   });
          // } else if (accountCode != "306" || accountCode != "552") {
          //   vm.insertedPaymentObject.bankCharges = _.find(vm.bankChargesList, function (item) {
          //     return item.isInternal == true;
          //   });
          // }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.init();

      vm.pushGtmUrgentPaymentEvent = function () {
          GoogleTagManagerHelperService.pushEvent('DomesticPayment', 'PaymentIsUrgentSelection', (vm.tempDompObj.isUrgentPaymentCheckbox)?'Urgent payment checked':'Urgent payment unchecked');
      };

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name payments.factory:CurrencyService
   *
   * @description
   *
   */
  CurrencyService.$inject = ["EndpointsService", "$q", "$http", "$log"];
  angular
    .module('payments')
    .factory('CurrencyService', CurrencyService);

  function CurrencyService(EndpointsService, $q, $http, $log) {
    var CurrencyServiceBase = {};

    CurrencyServiceBase.getCurrencyPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        //$log.debug("Params:", params);
        $http.get(response.links.currencies, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          })
          .error(function (msg, code) {
            deferred.reject(msg);
          })
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return CurrencyServiceBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name payments.controller:CurrencyConversionCtrl
     *
     * @description
     *
     */
    CurrencyConversionCtrl.$inject = ["$rootScope", "$log", "$location", "CTLocalizationService", "ExchangeRatesService", "$state", "HelperService", "PaymentTypesService", "ConfigEndpointService", "$localStorage", "$filter", "$timeout", "AccountsService", "CurrencyService", "PaymentsService", "PaymentTemplatesService", "$translate", "PaymentFilterService", "$q", "Notification", "AlertService", "GoogleTagManagerHelperService"];
    angular
        .module('payments')
        .controller('CurrencyConversionCtrl', CurrencyConversionCtrl);

    function CurrencyConversionCtrl($rootScope, $log, $location, CTLocalizationService, ExchangeRatesService, $state, HelperService, PaymentTypesService,
        ConfigEndpointService, $localStorage, $filter, $timeout, AccountsService,
        CurrencyService, PaymentsService, PaymentTemplatesService, $translate, PaymentFilterService, $q, Notification, AlertService, GoogleTagManagerHelperService) {
        var vm = this;
        var noToAccount = false;
        var currencyExchangeInProgress;

        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.localCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;

        vm.paymentResponse = {};
        vm.exchangeRatesParams = {
            page: 0,
            pageSize: 1000,
            date: '',
            includeList: ['currency']
        };
        vm.showPaymentId = false;
        vm.currencyExchangeObject = {};
        vm.exchangeRatesList = {};
        vm.currentDate = HelperService.getYesterday().firstDay;
        vm.fromAccountsList = [];
        vm.toAccountsList = [];
        vm.domesticCurrencyAccounts = [];
        vm.foreignCurrencyAccounts = [];
        vm.currencyList = [];

        vm.disableInputFields = true;

        vm.accountChanged = false;

        vm.tempExchangeObj = {
            sellCurrencyInput: '',
            buyCurrencyInput: {},
            currentDate: HelperService.getYesterday().firstDay,
            fromAccountSelect: {},
            toAccountSelect: {},
            fromAccountAmountInput: '',
            toAccountAmountInput: '',
            fixedAmount: 'D',
            formSubmitted: false
        };

        vm.currentStep = 1;
        vm.calculationRate = '';
        vm.foreignCurrency = '';
        vm.fromAccountDropdown = false;
        vm.toAccountDropdown = false;
        vm.bankCharges = '';
        vm.exchangeType = {
            from: true,
            to: false
        };

        /*        vm.smsAuthentificate = false;
         vm.smsPasswordInput = '';*/

        vm.currencyExchangeFilter = {
            page: 0,
            paymentTypeGroup: 'CurrencyExchange',
            orderBy: 'dateCreated DESC',
            pageSize: 10
        };

        vm.currencyExchangeListGrouped = {};

        // date picker
        vm.datePickerOpened1 = false;
        vm.datePickerOpened2 = false;
        vm.forUpdate = false;

        vm.openDatePicker1 = function () {
            vm.datePickerOpened1 = !vm.datePickerOpened1;
        };
        vm.dateOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        vm.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0));
        };

        vm.bankCharges = '';
        var tempToAccountNumber;
        vm.toAccountForInsert = '';

        vm.openDatePicker1 = function () {
            vm.datePickerOpened1 = true;
        };
        vm.openDatePicker2 = function () {
            vm.datePickerOpened2 = true;
        };


        vm.periodList = [
            {
                item: {
                    key: 'today',
                    description: 'core.period.today'
                }
      }
      , {
                item: {
                    key: 'yesterday',
                    description: 'core.period.yesterday'
                }
      }
      , {
                item: {
                    key: 'thisWeek',
                    description: 'core.period.thisWeek'
                }
      }
      , {
                item: {
                    key: 'thisMonth',
                    description: 'core.period.thisMonth'
                }
      }
      , {
                item: {
                    key: 'thisYear',
                    description: 'core.period.thisYear'
                }
      }
      , {
                item: {
                    key: $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" ? "all2y" : 'all',
                    description: 'core.period.all'
                }
      }
    ];

        vm.selectedPeriod = vm.periodList[3];

        //set time filter to current month
        var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
        vm.currencyExchangeFilter.dueDateGTE = timeRange.valueDateGTE;
        vm.currencyExchangeFilter.dueDateLTE = timeRange.valueDateLTE;

        vm.init = function () {
            getCurrencyExchangePayments(true);
            vm.loadExchangeRatesList();
            setBankCharges();
        };

        vm.loadExchangeRatesList = function () {
            ExchangeRatesService.getExchangeRates(vm.exchangeRatesParams)
                .then(function (response) {
                    vm.exchangeRatesList = response;
                    loadCurrencies()
                        .then(function () {
                            vm.getDebitAccountList();
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                        });
                })
                .catch(function () {
                    $log.error('Error loading exchange rates!');
                });
        };

        vm.getDebitAccountList = function () {

            var params = {
                fromAccountsList: [],
                localCurrency: vm.localCurrency,
                currencyList: vm.currencyList,
                toAccountsList: []
            };

            if ($state.current && $state.current.name) {
                switch ($state.current.name) {
                case "payments.currencyConversion.fromTemplate":
                    PaymentTemplatesService.loadCurrencyConversionData($state.params.templateId, vm.tempExchangeObj, params)
                        .then(function () {
                            vm.fromAccountsList = params.fromAccountsList;
                            vm.toAccountsList = params.toAccountsList;
                            if (vm.countryCode == 'sl') {
                                vm.tempExchangeObj.fromAccountSelect = PaymentsService.setFromAccountsToDefaulCurrency(vm.fromAccountsList);
                                vm.accountChanged = true;
                                setToAccountList(vm.tempExchangeObj.fromAccountSelect.accountId);
                            }
                            getCurrencyRatio();
                            vm.exchangeCurrency();
                        })
                        .catch(function (error) {
                            $log.error('loadCurrencyConversionDataFromTemplate()', error);
                        });
                    break;
                case "payments.currencyConversion.fromPayment":
                    PaymentsService.loadCurrencyConversionData($state.params.paymentId, vm.tempExchangeObj, params)
                        .then(function () {

                            vm.fromAccountsList = params.fromAccountsList;
                            vm.toAccountsList = params.toAccountsList;
                            vm.exchangeType = params.exchangeType;

                            if (vm.countryCode == 'sl') {
                                vm.tempExchangeObj.fromAccountSelect = PaymentsService.setFromAccountsToDefaulCurrency(vm.fromAccountsList);
                                vm.accountChanged = true;
                                setToAccountList(vm.tempExchangeObj.fromAccountSelect.accountId);
                            } else {
                                vm.disableInputFields = false;
                            }

                            getCurrencyRatio();
                            vm.exchangeCurrency();

                        })
                        .catch(function (error) {
                            $log.error('loadCurrencyConversionDataFromPayment()', error);
                        });
                    break;
                case "payments.currencyConversion":
                    PaymentTypesService.getByGroup({
                            paymentTypeGroup: 'CurrencyExchange'
                        })
                        .then(function (response) {
                            vm.fromAccountsList = response.result[0].debitAccountList;
                            vm.toAccountsList = response.result[0].creditAccountList;

                            _.forEach(vm.fromAccountsList, function (item) {
                                if (item.accountDescription) {
                                    item.optionValue = item.iban + ' - ' + item.currencySymbol;
                                }
                            });

                            _.forEach(vm.toAccountsList, function (item) {
                                if (item.accountDescription) {
                                    item.optionValue = item.accountDescription + ' - ' + item.iban;
                                }
                            });

                            if (_.isArray(vm.fromAccountsList) && vm.fromAccountsList.length > 0) {
                                vm.tempExchangeObj.fromAccountSelect = vm.fromAccountsList[0];
                                vm.tempExchangeObj.sellCurrencyInput = vm.fromAccountsList[0].currencySymbol;
                                if (vm.countryCode == 'sl') {
                                    vm.tempExchangeObj.fromAccountSelect = PaymentsService.setFromAccountsToDefaulCurrency(vm.fromAccountsList);
                                    vm.tempExchangeObj.sellCurrencyInput = vm.tempExchangeObj.fromAccountSelect.currencySymbol;
                                    vm.accountChanged = true;
                                    setToAccountList(vm.tempExchangeObj.fromAccountSelect.accountId);
                                }
                                filterBuyCurrency();
                                getCurrencyRatio();
                            }

                        })
                }
            }
            //}
            //})
        };


        var fromAccountChanged = function () {
            vm.tempExchangeObj.sellCurrencyInput = vm.tempExchangeObj.fromAccountSelect.currencySymbol;
            setToAccountList(vm.tempExchangeObj.fromAccountSelect.accountId)
                .then(function () {
                    filterBuyCurrency();
                });
        };

        vm.exchangeCurrency = function (event) {
            $timeout(function () {
                if (vm.tempExchangeObj.fromAccountAmountInput || vm.tempExchangeObj.toAccountAmountInput) {

                    var exchangeRateParams = prepareCurrencyExchangeObject();
                    var params = [];
                    params.push(ExchangeRatesService.calculateExchangeRate(exchangeRateParams));
                    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                        currencyExchangeInProgress = true;
                        var paramsToEur = prepareConversionToEur();
                        params.push(ExchangeRatesService.calculateExchangeRate(paramsToEur));
                    }
                    $q.all(params)
                        .then(function (responses) {

                            if (vm.exchangeType.from) {
                                vm.tempExchangeObj.toAccountAmountInput = responses[0].calculatedAmount;
                            } else if (vm.exchangeType.to) {
                                vm.tempExchangeObj.fromAccountAmountInput = responses[0].calculatedAmount;
                            }
                            lastFromCurrency = angular.copy(vm.tempExchangeObj.fromAccountAmountInput);
                            lastToCurrency = angular.copy(vm.tempExchangeObj.toAccountAmountInput);

                            if (responses[1]) {
                                var calculatedAmount = responses[1].calculatedAmount;
                                validateAmount(calculatedAmount);
                                currencyExchangeInProgress = false;
                            }

                          if(event && event.type == 'keyup'){
                            vm.submitCurrencyConversion();
                          }
                        })
                }
            }, 0);
        };

        function validateAmount(calculatedAmount) {
            if (!vm.tempExchangeObj.toAccountAmountInput || !vm.tempExchangeObj.fromAccountAmountInput) {
                vm.currencyForm.amountInput.$setValidity("maximalAmount", true);
                vm.currencyForm.toAmountInput.$setValidity("maximalAmount", true);
                vm.currencyForm.amountInput.$setValidity("minimalAmount", true);
                vm.currencyForm.toAmountInput.$setValidity("minimalAmount", true);
                return;
            }

            if (calculatedAmount > 99999999999.999) {
                vm.currencyForm.amountInput.$setValidity("maximalAmount", false);
                vm.currencyForm.toAmountInput.$setValidity("maximalAmount", false);
            } else {
                vm.currencyForm.amountInput.$setValidity("maximalAmount", true);
                vm.currencyForm.toAmountInput.$setValidity("maximalAmount", true);
            }

            if (calculatedAmount < 10) {
                vm.currencyForm.amountInput.$setValidity("minimalAmount", false);
                vm.currencyForm.toAmountInput.$setValidity("minimalAmount", false);
            } else {
                vm.currencyForm.amountInput.$setValidity("minimalAmount", true);
                vm.currencyForm.toAmountInput.$setValidity("minimalAmount", true);
            }
        }

        function prepareConversionToEur() {
            var tempObj = {};
            if (vm.exchangeType.from) {
                tempObj.amount = vm.tempExchangeObj.fromAccountAmountInput;
                tempObj.currencySymbolFrom = "EUR";
                tempObj.currencySymbolTo = vm.tempExchangeObj.sellCurrencyInput;
                tempObj.fixedAmount = 'C';

            } else if (vm.exchangeType.to) {
                tempObj.amount = vm.tempExchangeObj.toAccountAmountInput;
                tempObj.currencySymbolFrom = "EUR";
                tempObj.currencySymbolTo = vm.tempExchangeObj.buyCurrencyInput.symbol;
                tempObj.fixedAmount = 'C';
            }
            return tempObj;
        }

        vm.goBack = function () {
            $state.go('payments.paymentsOverview');
        };

        /*var setCountryCodeCurrency = function () {  Poziva(la) se na dva mjesta!!
         //var localCountry = $localStorage.code;
         switch (vm.countryCode) {
         case 'hr':
         vm.localCurrency = 'HRK';
         break;
         case 'sr':
         vm.localCurrency = 'RSD';
         break;
         case 'mne':
         vm.localCurrency = 'EUR';
         break;
         }
         };*/

        var prepareCurrencyExchangeObject = function () {
            var tempObj = {
                currencySymbolFrom: vm.tempExchangeObj.sellCurrencyInput,
                currencySymbolTo: vm.tempExchangeObj.buyCurrencyInput.symbol
            };
            if (vm.exchangeType.from) {
                tempObj.amount = vm.tempExchangeObj.fromAccountAmountInput;
                tempObj.fixedAmount = 'D';
            } else if (vm.exchangeType.to) {
                tempObj.amount = vm.tempExchangeObj.toAccountAmountInput;
                tempObj.fixedAmount = 'C';
            }
            return tempObj;
        };

        // var filterRecipientAccounts = function () {
        //     vm.domesticCurrencyAccounts = _.filter(vm.fromAccountsList, function (item) {
        //         return item.currencySymbol == vm.localCurrency;
        //     });
        //     vm.foreignCurrencyAccounts = _.filter(vm.fromAccountsList, function (item) {
        //         return item.currencySymbol != vm.localCurrency;
        //     });
        // };

        vm.toggleFromAccount = function () {
            vm.fromAccountDropdown = !vm.fromAccountDropdown;
        };

        vm.toggleToAccount = function () {
            vm.toAccountDropdown = !vm.toAccountDropdown;
        };

        vm.setAccountFrom = function (item) {
            if (item.accountId !== vm.tempExchangeObj.fromAccountSelect.accountId) {
                vm.accountChanged = true;
            } else {
                vm.accountChanged = false;
            }
            vm.tempExchangeObj.fromAccountSelect = item;
            vm.fromAccountDropdown = false;
            vm.toAccountDropdown = false;
            fromAccountChanged();
            if (vm.tempExchangeObj.fromAccountAmountInput) {
                vm.exchangeCurrency();
            }
            getCurrencyRatio();
        };

        vm.setAccountTo = function (item) {
            vm.tempExchangeObj.toAccountSelect = item;
            vm.fromAccountDropdown = false;
            vm.toAccountDropdown = false;
            if (vm.tempExchangeObj.buyCurrencyInput.symbol != vm.localCurrency && vm.localCurrency === "HRK") {
                var toAccountCurrencyIndex = _.findIndex(vm.currencyList, function (item) {
                    return vm.tempExchangeObj.toAccountSelect.currencySymbol == item.symbol;
                });
                if (toAccountCurrencyIndex != -1) {
                    vm.tempExchangeObj.buyCurrencyInput = vm.currencyList[toAccountCurrencyIndex];
                }
            } else if (vm.localCurrency === "RSD" || vm.localCurrency === "EUR" || $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'bh') {
                if (vm.tempExchangeObj.buyCurrencyInput && vm.tempExchangeObj.toAccountSelect) {
                    // quickfix - sometimes empty symbol variable
                    vm.tempExchangeObj.buyCurrencyInput = {
                        symbol: ""
                    };
                    vm.tempExchangeObj.buyCurrencyInput.symbol = vm.tempExchangeObj.toAccountSelect.currencySymbol;
                }
            }

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                vm.tempExchangeObj.buyCurrencyInput = _.findWhere(vm.currencyList, {
                    symbol: vm.tempExchangeObj.toAccountSelect.currencySymbol
                });
            }
            if (vm.tempExchangeObj.fromAccountAmountInput) {
                vm.exchangeCurrency();
            }
            getCurrencyRatio();
        };


        if ($state.params.editable) {
            vm.paymentResponse.id = $state.params.paymentId;
            vm.forUpdate = true;
        }


        vm.submitCurrencyConversion = function () {
            if (vm.nextButtonPressed) return;
            if (!vm.currencyForm.$valid || ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === "sl" && currencyExchangeInProgress)) {
                if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === "sl" && currencyExchangeInProgress)
                  setTimeout(vm.submitCurrencyConversion, 50);//wait 50 millisecnds then recheck
                return;
            }

            if (vm.countryCode != 'hr' && vm.toAccountsList.length == 0) {
                return;
            }

            if (!vm.formSubmitted) {
                vm.tempExchangeObj.formSubmitted = true;
                vm.formSubmitted = true;


                var tempPaymentObj = createPaymentObject();
                vm.nextButtonPressed = true;
                if (vm.forUpdate) {
                    tempPaymentObj.id = vm.paymentResponse.id;
                    PaymentsService.updatePayment(vm.paymentResponse.id, tempPaymentObj)
                        .then(function (response) {
                            vm.paymentResponse = response;
                            Notification.clearAll();
                            vm.currentStep = 2;
                            vm.forUpdate = false;
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            vm.forUpdate = false;
                            // vm.currencyForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                            vm.nextButtonPressed = false;
                        });
                } else {
                    PaymentsService.insertPayment(tempPaymentObj)
                        .then(function (response) {
                            vm.paymentResponse = response;
                            $log.debug('Insert payment object', response);
                            Notification.clearAll();
                            vm.currentStep = 2;

                            GoogleTagManagerHelperService.pushVirtualPageView('payments/currency-conversion/toconfirm', 'currency-conversion toconfirm', $location.host() + 'payments/currency-conversion/toconfirm');
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            // vm.currencyForm.$valid = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                            vm.nextButtonPressed = false;
                        });
                }
            }

        };

        var loadCurrencies = function () {
            var deferred = $q.defer();
            var countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
            if (countryCode == 'hr' || countryCode == 'sl') {
                return CurrencyService.getCurrencyPage({
                        isCurrencyForPayment: true,
                        pageSize: 1000
                    })
                    .then(function (response) {
                        vm.currencyList = response.result;
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
            deferred.resolve();
            return deferred.promise;
        };

        var createPaymentObject = function () {
            var paymentForInsert = {
                accountId: vm.tempExchangeObj.fromAccountSelect.accountId,
                fromAccountNumber: HelperService.parseAccountNumber(vm.tempExchangeObj.fromAccountSelect.accountNumber),
                //toAccountNumber: HelperService.parseAccountNumber(vm.tempExchangeObj.toAccountSelect.accountNumber),
                dueDate: new Date(),
                currencySymbol: vm.tempExchangeObj.fromAccountSelect.currencySymbol,
                paymentTypeGroup: 'CurrencyExchange',
                currencyExchange: {
                    destinationCurrencySymbol: vm.tempExchangeObj.buyCurrencyInput.symbol
                }
            };
            // check in case user choose currency with no related to account
            if (vm.tempExchangeObj.toAccountSelect) {
                paymentForInsert.toAccountNumber = HelperService.parseAccountNumber(vm.tempExchangeObj.toAccountSelect.accountNumber);
            } else {
                paymentForInsert.toAccountNumber = vm.toAccountForInsert.accountNumber;
            }

            if (vm.exchangeType.from) {
                paymentForInsert.amount = vm.tempExchangeObj.fromAccountAmountInput;
            } else if (vm.exchangeType.to) {
                paymentForInsert.currencyExchange.transactionAmount2 = vm.tempExchangeObj.toAccountAmountInput;
            }
            return paymentForInsert;
        };

        var filterBuyCurrency = function () {
            vm.tempExchangeObj.buyCurrencyInput = {};
            if (vm.toAccountsList && vm.toAccountsList[0]) {
                vm.tempExchangeObj.toAccountSelect = vm.toAccountsList[0];
            }
            if (vm.tempExchangeObj.sellCurrencyInput != vm.localCurrency) {
                vm.tempExchangeObj.buyCurrencyInput.symbol = vm.localCurrency;
            } else if (vm.currencyList.length > 0 && vm.tempExchangeObj.toAccountSelect) {
                vm.tempExchangeObj.buyCurrencyInput = _.find(vm.currencyList, function (item) {
                    return item.symbol == vm.tempExchangeObj.toAccountSelect.currencySymbol;
                });
            } else if (vm.currencyList.length > 0) {
                var tempCurrencySymbol = _.find(vm.currencyList, function (item) {
                    return vm.localCurrency != item.symbol;
                });
                vm.tempExchangeObj.buyCurrencyInput = tempCurrencySymbol;
            }

            if (vm.localCurrency === 'RSD' || vm.localCurrency === 'EUR' || $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'bh') {
                vm.tempExchangeObj.buyCurrencyInput.symbol = vm.tempExchangeObj.toAccountSelect.currencySymbol;
            }
            //variable for displaying on GUI
            //vm.buyCurrencyToAccountSelect = vm.tempExchangeObj.toAccountSelect;
        };

        var clearInput = function () {
            // vm.smsAuthentificate = false;
            // vm.smsPasswordInput = '';
            vm.tempExchangeObj.fromAccountAmountInput = '';
            vm.tempExchangeObj.toAccountAmountInput = '';
            vm.tempExchangeObj.fromAccountSelect = vm.fromAccountsList[0];
            vm.tempExchangeObj.sellCurrencyInput = vm.fromAccountsList[0].currencySymbol;
            vm.tempExchangeObj.formSubmitted = false;
            vm.fromAccountDropdown = false;
            vm.toAccountDropdown = false;
            vm.selectedPeriod = vm.periodList[3];
            var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
            vm.currencyExchangeListGrouped = {};
            vm.currencyExchangeFilter.dueDateGTE = timeRange.valueDateGTE;
            vm.currencyExchangeFilter.dueDateLTE = timeRange.valueDateLTE;
            getCurrencyExchangePayments(true);
            filterBuyCurrency();
        };

        var mapWithPaymentResponse = function () {
            vm.tempExchangeObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(vm.fromAccountsList, vm.paymentResponse.accountId);
            vm.tempExchangeObj.sellCurrencyInput = vm.tempExchangeObj.fromAccountSelect.currencySymbol;
            if (vm.paymentResponse.amount) {
                vm.tempExchangeObj.fromAccountAmountInput = angular.copy(vm.paymentResponse.amount);
            }
            if (vm.paymentResponse.transactionAmount2) {
                vm.tempExchangeObj.toAccountAmountInput = angular.copy(vm.paymentResponse.transactionAmount2);
            }

            setToAccountList(vm.paymentResponse.accountId);
            if (!noToAccount)
                vm.tempExchangeObj.toAccountSelect = PaymentFilterService.filterToAccountSelect(vm.toAccountsList, vm.paymentResponse.toAccountNumber.split(" ")[0]);
            var params = {
                sellCurrency: vm.tempExchangeObj.sellCurrencyInput,
                localCurrency: vm.localCurrency,
                currencyList: vm.currencyList,
                //destinationCurrency: vm.tempExchangeObj.toAccountSelect.currencySymbol
                destinationCurrency: vm.paymentResponse.destinationCurrencySymbol
            };

            if (!vm.paymentResponse.destinationCurrencySymbol && vm.paymentResponse.currencyExchange.destinationCurrencySymbol)
                params.destinationCurrency = vm.paymentResponse.currencyExchange.destinationCurrencySymbol;

            vm.tempExchangeObj.buyCurrencyInput = PaymentFilterService.filterBuyCurrencyInput(params);
        };

        var setToAccountList = function (accountId) {
            var deferred = $q.defer();
            if (vm.accountChanged) {
                return PaymentTypesService.getByGroup({
                        paymentTypeGroup: 'CurrencyExchange',
                        masterAccountId: accountId
                    })
                    .then(function (response) {
                        if (_.isArray(response.result) && response.result.length > 0) {
                            vm.toAccountsList = response.result[0].creditAccountList;
                            //vm.toAccountsList = [];
                            vm.setAccountTo(vm.toAccountsList[0]);
                            _.forEach(vm.accountsTo, function (item) {
                                if (item.accountDescription) {
                                    item.optionValue = item.accountDescription + ' - ' + item.iban;
                                }
                            });

                            vm.disableInputFields = false;

                        }
                        vm.accountChanged = false;
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            } else {
                deferred.resolve(vm.setAccountTo(vm.tempExchangeObj.fromAccountSelect));
            }
            return deferred.promise;
        };

        vm.editPayment = function () {
            vm.forUpdate = true;
            // mapWithPaymentResponse();
            vm.currentStep = 1;
        };


        vm.backToCurrencyConversion = function () {
            clearInput();
            vm.currentStep = 1;
        };

        var getCurrencyRatio = function () {
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
              getCurrencyRatioSlovenia();
            } else {
              getCurrencyRatioOther();
            }
        };

        function getCurrencyRatioOther() {
          var fromAccountExchangeRate = _.findWhere(vm.exchangeRatesList.result, {
            currencySymbol: vm.tempExchangeObj.fromAccountSelect.currencySymbol
          });
          if (fromAccountExchangeRate) vm.fromAccountCalculationRate = fromAccountExchangeRate.sellRate;

          var toAccountExchangeRate = _.findWhere(vm.exchangeRatesList.result, {
            currencySymbol: vm.tempExchangeObj.toAccountSelect.currencySymbol
          });
          if (toAccountExchangeRate) vm.toAccountCalculationRate = toAccountExchangeRate.buyRate;

          if (fromAccountExchangeRate && (fromAccountExchangeRate.currencySymbol != vm.localCurrency)) {
            vm.foreignCurrency = fromAccountExchangeRate.currencySymbol;
            vm.fixedAmount = (checkForCountry()) ? fromAccountExchangeRate.buyRate : fromAccountExchangeRate.calculationRate;
          } else if (toAccountExchangeRate && (toAccountExchangeRate.currencySymbol != vm.localCurrency)) {
            vm.foreignCurrency = toAccountExchangeRate.currencySymbol;
            vm.fixedAmount = (checkForCountry()) ? toAccountExchangeRate.sellRate : toAccountExchangeRate.calculationRate;
          }
        }

        function getCurrencyRatioSlovenia () {
          var fromAccountExchangeRate = _.findWhere(vm.exchangeRatesList.result, {
            currencySymbol: vm.tempExchangeObj.fromAccountSelect.currencySymbol
          });
          if (fromAccountExchangeRate) {
            vm.foreignCurrency = fromAccountExchangeRate.currencySymbol;
            vm.fromAccountCalculationRate = fromAccountExchangeRate.buyRate;
          }

          var toAccountExchangeRate = _.findWhere(vm.exchangeRatesList.result, {
            currencySymbol: vm.tempExchangeObj.toAccountSelect.currencySymbol

          });
          if (toAccountExchangeRate) {
            vm.foreignCurrency = toAccountExchangeRate.currencySymbol;
            vm.toAccountCalculationRate = toAccountExchangeRate.sellRate;

          }

          //vm.fixedAmount = vm.toAccountCalculationRate;


          if (fromAccountExchangeRate && (fromAccountExchangeRate.currencySymbol != vm.localCurrency)) {
            vm.fixedAmount =  toAccountExchangeRate.sellRate;
            //TSK-10085 SLOW 485 - Currency exchange - tecaj valute kupnje nije ispravan - promjenjeno na SELL RATE

          }
          else if (toAccountExchangeRate && (toAccountExchangeRate.currencySymbol != vm.localCurrency)) {
            vm.fixedAmount = toAccountExchangeRate.sellRate;

          }
        }

        var checkForCountry = function () {
          var c = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
          return (c == 'hr' || c == 'mne' || c == 'sr');

        };

        var getCurrencyExchangePayments = function (reset) {
            if (reset) {
                vm.currencyExchangeFilter.page = 0;
            } else {
                vm.currencyExchangeFilter.page += 1;
            }

            PaymentsService.getPage(vm.currencyExchangeFilter)
                .then(function (response) {

                    vm.currencyExchangeListGrouped = HelperService.mergeRowsForTimeline({
                        existingData: vm.currencyExchangeListGrouped,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.dueDate);
                            date.setHours(0, 0, 0, 0);
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                date: new Date(e),
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });

                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.changeSellCurrency = function () {
            console.log(vm.currencyForm);
            if (vm.tempExchangeObj.fromAccountAmountInput) {
                vm.exchangeCurrency();
            }
            getCurrencyRatio();
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr' || $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                displayToAccountRelatedToBuyCurrency();
            }
        };

        vm.loadMoreTimelineItems = function () {
            getCurrencyExchangePayments(false);
        };

        vm.getDefaultData = function () {
            return ConfigEndpointService.getDefaultData()
                .then(function (response) {
                    if (response.APILocation) {
                        $localStorage.code = response.APILocation;
                        vm.bankCharges = response.BankCharges;
                        vm.localCurrency = response.DefaultCurrency;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        var setBankCharges = function () {
            return ConfigEndpointService.getDefaultData()
                .then(function (response) {
                    if (response.BankCharges) {
                        vm.bankCharges = response.BankCharges;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.timelineTimeFilter = function (item) {
            vm.selectedPeriod = item;
            var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
            vm.currencyExchangeFilter.dueDateGTE = timeRange.valueDateGTE;
            vm.currencyExchangeFilter.dueDateLTE = timeRange.valueDateLTE;
            getCurrencyExchangePayments(true);

          GoogleTagManagerHelperService.pushEvent('CurrencyConversion', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));
        };

        // Actions for payments in timeline

        var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        $rootScope.$on('appLanguageChangedHeader', function () {
            sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
        });


        vm.deletePaymentAction = function (paymentId, type) {
            var paymentForDelete = paymentId || vm.paymentResponse.id;

            //  swal({
            //   title: sweetAlertOptions.areYouSure,
            //   type: "info",
            //   showCancelButton: true,
            //   confirmButtonClass: "btn-default",
            //   confirmButtonText: sweetAlertOptions.yes,
            //   cancelButtonText: sweetAlertOptions.no,
            //   closeOnConfirm: true,
            //   closeOnCancel: true
            // }, function (isConfirm) {
            //   if (isConfirm) {
            //PaymentsService.deletePayment(paymentForDelete)
            //  .then(function (response) {
            //    HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], paymentForDelete);
            //    if(type === 'timeline'){
            //      getCurrencyExchangePayments(true);
            //    } else if (type === 'step2'){
            //      vm.backToCurrencyConversion();
            //      vm.currentStep = 1;
            //    }
            //  })
            //  .catch(function (error) {
            //    HelperService.showMessage(error, 'error');
            //  });
            //   }
            // });

            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        PaymentsService.deletePayment(paymentForDelete)
                            .then(function (response) {
                                AlertService.deletedPaymentAlert({
                                        paymentName: paymentForDelete,
                                        type: 'payment'
                                    })
                                    .then(function () {
                                        if (type === 'timeline') {
                                            getCurrencyExchangePayments(true);
                                        } else if (type === 'step2') {
                                            vm.backToCurrencyConversion();
                                            vm.currentStep = 1;
                                        }
                                    });

                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    }
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });
        };

        //       Old method for sign
        /*      vm.signPaymentAction = function (paymentId) {
         PaymentsService.openSignModal(paymentId)
         .then(function (signed) {
         if (signed) {
         getCurrencyExchangePayments(true);
         }
         })
         .catch(function (error) {
         HelperService.showMessage(error, 'error');
         });
         };*/


        vm.signPaymentAction = function (payment) {
            if (vm.confirmButtonPressed) return;
            if (PaymentsService.isVerificationRequiredForSign(payment)) {
                // If verification is required, go to payment sign state
                $state.go('payments.sign', {
                    paymentId: payment.id,
                    type: 'exchange'
                });
            } else {

                if (payment.allowedActionList) {
                    var updateObject = _.find(payment.allowedActionList.itemList, function (item) {
                        return item.methodName === 'UpdateOldPaymentDateAllowed';
                    });

                    if (updateObject) {
                        vm.dueDateUpdateAllowed = updateObject.isEnabled;
                    }
                }


                // Use only date without hours for compare
                var currentTime = new Date();
                currentTime.setHours(0, 0, 0, 0);
                // Check if all payments have valid due date
                var isPaymentDueDateValid = new Date(payment.dueDate) >= currentTime;


                // If verification is not required, then sign payment and go to final step
                var params = {
                    id: payment.id,
                    payment: payment
                };

                vm.confirmButtonPressed = true;
                if (isPaymentDueDateValid) {
                    return PaymentsService.signPayment(params).then(function (signedPayment) {
                        // TODO: Use signed payment on response
                        var id = (signedPayment.id) ? signedPayment.id : vm.paymentResponse.id;
                        $state.go('payments.finalStep', {
                            paymentId: id,
                            type: 'exchange'
                        });
                    }).catch(function (error) {
                        $log.error(error);
                        HelperService.showMessage(error, 'error');
                    }).finally(function() {
                      vm.confirmButtonPressed = false;
                    });
                } else {
                    PaymentsService.openUpdatePaymentDueDateModal()
                        .result.then(function (result) {
                            if (result == "confirm") {
                                params.useCurrentDate = true;
                                return PaymentsService.signPayment(params).then(function (signedPayment) {

                                  // TODO: Use signed payment on response
                                    $state.go('payments.finalStep', {
                                        paymentId: payment.id,
                                        type: 'exchange'
                                    });
                                  vm.confirmButtonPressed = false;
                                }).catch(function (error) {
                                    $log.error(error);
                                    HelperService.showMessage(error, 'error');
                                  vm.confirmButtonPressed = false;
                                })
                            }
                        });
                }
            }
        };

        vm.recallPaymentAction = function (paymentId) {
            var params = {
                id: paymentId
            };
            PaymentsService.recallPayment(params)
                .then(function (response) {
                    getCurrencyExchangePayments(true);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                })
        };

        vm.openCurrencyCalculate = function () {
            GoogleTagManagerHelperService.pushEvent('ExchangeRatesCalculator', 'OpenExhangeRatesCalculator', $translate.instant("currencyConversion.exchangeRatesCalculator"));
            PaymentsService.openCurrencyCalculatorModal();
        };



        //from account activated
        var lastFromCurrency;
        var lastToCurrency;
        vm.setFromCurrency = function (event) {
            vm.exchangeType = {
                from: true,
                to: false
            };

            if (vm.countryCode === 'sl') {
              vm.exchangeCurrency(event);
            }
            else if (lastFromCurrency !== vm.tempExchangeObj.fromAccountAmountInput) {
              vm.exchangeCurrency(event);
            }
        };


        //to account activated
        vm.setToCurrency = function (event) {

            vm.exchangeType = {
                from: false,
                to: true
            };

            if (vm.countryCode === 'sl') {
              vm.exchangeCurrency(event);
            }
            else if (lastToCurrency !== vm.tempExchangeObj.toAccountAmountInput) {
              vm.exchangeCurrency(event);
            }
        };

        var displayToAccountRelatedToBuyCurrency = function () {
            //vm.buyCurrencyToAccountSelect = _.find(vm.toAccountsList, function (item) {
            //  return item.currencySymbol == vm.tempExchangeObj.buyCurrencyInput.symbol;
            //});
            //if (vm.buyCurrencyToAccountSelect) {
            //  vm.tempExchangeObj.toAccountSelect = vm.buyCurrencyToAccountSelect;
            //}

            tempToAccountNumber = _.find(vm.toAccountsList, function (item) {
                return item.currencySymbol == vm.tempExchangeObj.buyCurrencyInput.symbol;
            });
            //if(tempToAccount){
            //  vm.tempExchangeObj.toAccountSelect = tempToAccount;
            //}
            if (!tempToAccountNumber) {
                noToAccount = true;
                vm.toAccountForInsert = vm.tempExchangeObj.fromAccountSelect;
            } else {
                noToAccount = false;
            }
            vm.tempExchangeObj.toAccountSelect = tempToAccountNumber;
        };

        vm.init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:CurrencyCalculatorModalCtrl
   *
   * @description
   *
   */
  CurrencyCalculatorModalCtrl.$inject = ["$rootScope", "$scope", "$log", "$filter", "$timeout", "$localStorage", "ExchangeRatesService", "CurrencyService", "HelperService", "ConfigEndpointService", "GoogleTagManagerHelperService", "$translate"];
  angular
    .module('payments')
    .controller('CurrencyCalculatorModalCtrl', CurrencyCalculatorModalCtrl);

  function CurrencyCalculatorModalCtrl($rootScope, $scope, $log, $filter, $timeout, $localStorage, ExchangeRatesService,
                                        CurrencyService, HelperService, ConfigEndpointService, GoogleTagManagerHelperService, $translate) {
    var vm = this;
    var currenciesFilter = {
      pageSize: 1000
    };
    vm.exchangeRatesList = {};
    vm.ratesDate = null;
    vm.fromCurrencyList = [];
    vm.toCurrencyList = [];
    vm.fromCurrencySelect = {};
    vm.localCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;;
    vm.toCurrencySelect = {};
    vm.fromAmountInput = '';
    vm.toAmountInput = '';
    vm.currencyList = []; //all currencies
    vm.exchangeType = {
      from: false,
      to: false
    };
    //vm.countryCode = $localStorage.code;
    vm.countryCode =  $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
    vm.exchangeRatesFilter = {
        includeList : ['currency']
    };

    var loadExchangeRatesList = function () {
      return ExchangeRatesService.getExchangeRates(vm.exchangeRatesFilter)
        .then(function (response) {
          if(vm.countryCode === 'sl' ) vm.ratesDate = findTimeOfUpdate(response);
          vm.exchangeRatesList = response;
        })
        .catch(function () {
          $log.error('Error loading exchange rates!');
        });
    };

    var findTimeOfUpdate = function (currencyList) {
      var maxDate = currencyList.result[0].date;
      _.forEach(currencyList.result, function (item) {
        if(new Date(item.date) > new Date(maxDate)){
          maxDate = item.date;
        }
      });

      return maxDate;
    };

    var loadCurrencies = function () {
      CurrencyService.getCurrencyPage(currenciesFilter)
        .then(function (response) {
          vm.currencyList = response.result;
          setSelectedFrom();
          setToListDifferentFromLocal();
          //filterToCurrenciesList(vm.currencyList);
          //vm.toCurrencySelect = vm.toCurrencyList[0];

        }).catch(function (error) {
          $log.error(error);
        });
    };

    var setSelectedFrom = function () {
      vm.fromCurrencyList = vm.currencyList;
      var index = _.findIndex(vm.fromCurrencyList, function (item) {
        return item.symbol == vm.localCurrency;
      });
      vm.fromCurrencySelect = vm.fromCurrencyList[index];

    };

    var filterFromCurrenciesList = function (currencyList) {
      vm.fromCurrencyList = _.filter(currencyList, function (item) {
        return item.symbol != vm.toCurrencySelect.symbol;
      });
      //vm.fromCurrencySelect = vm.fromCurrencyList[0];

    };

    var filterToCurrenciesList = function (currencyList) {
      vm.toCurrencyList = _.filter(currencyList, function (item) {
        return item.symbol != vm.fromCurrencySelect.symbol;
      });
      //vm.toCurrencySelect = vm.toCurrencyList[0];

    };


    vm.setFromCurrency = function () {
      vm.exchangeType = {
        from: true,
        to: false
      };
      vm.calculateCurrency();
    };

    vm.setToCurrency = function () {

      vm.exchangeType = {
        from: false,
        to: true
      };
      vm.calculateCurrency();
    };

    var prepareChangeObject = function () {

      if (vm.exchangeType.from) {
        return {
          currencySymbolFrom: vm.fromCurrencySelect.symbol,
          amount: vm.fromAmountInput,
          currencySymbolTo: vm.toCurrencySelect.symbol,
          fixedAmount: 'D'
        };
      } else if (vm.exchangeType.to) {
        return {
          currencySymbolFrom: vm.fromCurrencySelect.symbol,
          amount: vm.toAmountInput,
          currencySymbolTo: vm.toCurrencySelect.symbol,
          fixedAmount: 'C'
        };
      }
    };

    vm.closeModal = function () {
      //$uibModalInstance.close();
        GoogleTagManagerHelperService.pushEvent('ExchangeRatesCalculator', 'CloseExhangeRatesCalculator', 'Close button clicked');
      $scope.$parent.modalInstance.close();
    };

    vm.init = function () {
      //if (!$localStorage.code) {
      //  loadDefaultData().then(function () {
      //    loadBasicInfo();
      //  });
      //} else {
      //  loadBasicInfo();
      //}
      loadBasicInfo();
    };

    vm.calculateCurrency = function () {
      $timeout(function () {
        if (vm.fromAmountInput || vm.toAmountInput) {
          ExchangeRatesService.calculateExchangeRate(prepareChangeObject())
            .then(function (response) {
              if (vm.exchangeType.from)
                vm.toAmountInput = response.calculatedAmount;
              else if (vm.exchangeType.to)
                vm.fromAmountInput = response.calculatedAmount;
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
            });
        }
      }, 0);
    };

    var loadBasicInfo = function () {
      loadExchangeRatesList();
      if ($localStorage.code != 'mne') {
        //setLocalCurrency();
        loadCurrencies();
      }
    };

    var setToListDifferentFromLocal = function () {
      vm.toCurrencyList = vm.currencyList;
      var index = _.findIndex(vm.currencyList, function (item) {
        return item.symbol != vm.localCurrency;
      });
      vm.toCurrencySelect = vm.currencyList[index];
    };
    var setToListToLocal = function () {
      vm.toCurrencyList = vm.currencyList;
      var index = _.findIndex(vm.currencyList, function (item) {
        return item.symbol == vm.localCurrency;
      });
      vm.toCurrencySelect = vm.currencyList[index];
    };

    var setFromListDifferentFromLocal = function () {
      vm.fromCurrencyList = vm.currencyList;
      var index = _.findIndex(vm.currencyList, function (item) {
        return item.symbol != vm.localCurrency;
      });
      vm.fromCurrencySelect = vm.currencyList[index];
    };

    var setFromListToLocal = function () {
      vm.fromCurrencyList = vm.currencyList;
      var index = _.findIndex(vm.currencyList, function (item) {
        return item.symbol == vm.localCurrency;
      });
      vm.fromCurrencySelect = vm.currencyList[index];
    };

    vm.toCurrencyChange = function () {
      if (vm.toCurrencySelect.symbol == vm.localCurrency) {
        if (vm.fromCurrencySelect.symbol == vm.localCurrency)
          setFromListDifferentFromLocal();
      } else {
        setFromListToLocal();
      }
      vm.setToCurrency();
      //vm.calculateCurrency();
    };

    vm.fromCurrencyChange = function () {
      //vm.selectedFrom = vm.fromCurrencySelect;
      if (vm.fromCurrencySelect.symbol == vm.localCurrency) {
        if (vm.toCurrencySelect.symbol == vm.localCurrency)
          setToListDifferentFromLocal();
      } else {
        setToListToLocal();
      }
      //filterFromCurrenciesList(vm.currencyList);
      vm.setFromCurrency();
      //vm.calculateCurrency();
    };

    var loadDefaultData = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
          if (response.APILocation) {
            $localStorage.code = response.APILocation;
            vm.countryCode = $localStorage.code;
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    //var setLocalCurrency = function () {
    //  switch ($localStorage.code) {
    //    case "hr":
    //      vm.localCurrency = "HRK";
    //      break;
    //    case "sr":
    //      vm.localCurrency = "RSD";
    //      break;
    //    case "mne":
    //      vm.localCurrency = "EUR";
    //      break;
    //    case "sl":
    //      vm.localCurrency = "EUR";
    //      break;
    //  }
    //};

    vm.init();

  }
} ());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:CreditAccountRegisterService
     *
     * @description
     *
     */
    CreditAccountRegisterService.$inject = ["EndpointsService", "$q", "$http", "$log"];
    angular
        .module('payments')
        .factory('CreditAccountRegisterService', CreditAccountRegisterService);

    function CreditAccountRegisterService(EndpointsService, $q, $http, $log) {
        var CreditAccountRegisterServiceBase = {};
        CreditAccountRegisterServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                //$log.debug("Params:", params);
                $http.get(response.links.creditAccountRegister, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        CreditAccountRegisterServiceBase.getByIban = function (iban) {
            var predefinedParams = {
                iban: iban
            };
            return CreditAccountRegisterServiceBase.getPage(predefinedParams);
        };

        CreditAccountRegisterServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.creditAccountRegister_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return CreditAccountRegisterServiceBase;
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:CountriesService
     *
     * @description
     *
     */
    CountriesService.$inject = ["EndpointsService", "$q", "$http", "$log"];
    angular
        .module('payments')
        .factory('CountriesService', CountriesService);

    function CountriesService(EndpointsService, $q, $http, $log) {
        var CountriesServiceBase = {};
        CountriesServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                //$log.debug("Params:", params);
                $http.get(response.links.countries, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        CountriesServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.countries_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return CountriesServiceBase;
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:ChangePaymentDateModalCtrl
   *
   * @description
   *
   */
  ChangePaymentDateModalCtrl.$inject = ["obj"];
  angular
    .module('payments')
    .controller('ChangePaymentDateModalCtrl', ChangePaymentDateModalCtrl);

  function ChangePaymentDateModalCtrl(obj) {
    var vm = this;
    vm.ctrlName = 'ChangePaymentDateModalCtrl';
    vm.obj = obj;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:BicBanksService
     *
     * @description
     *
     */
    BicBanksService.$inject = ["EndpointsService", "$q", "$http", "$log"];
    angular
        .module('payments')
        .factory('BicBanksService', BicBanksService);

    function BicBanksService(EndpointsService, $q, $http, $log) {
        var BicBanksServiceBase = {};
        BicBanksServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("Params:", params);
                $http.get(response.links.bicBanks, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        BicBanksServiceBase.getByIban = function (iban){
          var predefinedParams = {
            iban: iban
          };
          return BicBanksServiceBase.getPage(predefinedParams);
        };

        BicBanksServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.bicBanks_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return BicBanksServiceBase;
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:BanksService
     *
     * @description
     *
     */
    BanksService.$inject = ["EndpointsService", "$q", "$http", "$log"];
    angular
        .module('payments')
        .factory('BanksService', BanksService);

    function BanksService(EndpointsService, $q, $http, $log) {
        var BanksServiceBase = {};
        BanksServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("Params:", params);
                $http.get(response.links.banks, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        BanksServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.banks_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return BanksServiceBase;
    }
}());
(function () {
  'use strict';

  /* @ngdoc object
   * @name paymentTemplates
   * @description
   *
   */
  angular
    .module('paymentTemplates', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name paymentTemplates.controller:TemplateListOverviewCtrl
   *
   * @description
   *
   */
  TemplateListOverviewSloCtrl.$inject = ["$rootScope", "$state", "CTLocalizationService", "PaymentTemplatesService", "$log", "AccountsService", "HelperService", "ValidationService", "PaymentsService", "PurposeCodesService", "ConfigEndpointService", "$localStorage", "ReferenceModelService", "CountriesService", "CreditAccountRegisterService", "PaymentTypesService", "ImagesService", "$q", "AlertService", "PublicRevenueService"];
  angular
    .module('paymentTemplates')
    .controller('TemplateListOverviewSloCtrl', TemplateListOverviewSloCtrl);

  function TemplateListOverviewSloCtrl($rootScope, $state, CTLocalizationService, PaymentTemplatesService, $log, AccountsService, HelperService, ValidationService, PaymentsService,
                                       PurposeCodesService, ConfigEndpointService, $localStorage, ReferenceModelService, CountriesService,
                                       CreditAccountRegisterService, PaymentTypesService, ImagesService, $q, AlertService, PublicRevenueService) {
    var vm = this;

    vm.tempObj = {
      toAccountInput: '',
      fromAccountNumber: '',
      currencySymbol: '',
      formSubmitted: false,
      purposeOfPaymentInput: '',
      currentDate: HelperService.getYesterday().firstDay,
      receiversNameInput: '',
      receiversAddressInput: '',
      receiversPostalCodeAndCityInput: '',
      bankChargesRadiobutton: {
        type: '3'
      },
      recipientStatusRadiobutton: {
        type: '2'
      },
      referenceModelSelect: '',
      referenceNumberInput: '',
      payersSepaInput1: '',
      receiversSepaInput1: '',
      //related to public revenue
      tayPayerId: '',
      revenueCode: '',
      municipality: '',
      taxPeriodFrom: new Date(),
      taxPeriodTo: new Date(),
      budgetOrganization: '',
      paymentTypes: ['0', '1', '2', '3', '5', '6', '7', '8', '9']
    };
    vm.tempObj.paymentType = vm.tempObj.paymentTypes[0];

    vm.selectedImage = {};
    vm.templateList = {};
    vm.account = {};
    vm.searchTemplateList = '';
    vm.searchTemplateListApi = '';
    vm.templatesFilter = {
      page: 0,
      pageSize: 10,
      orderBy: "name asc",
      // paymentTypeGroupList: ['DomesticPayment','LocalCurrencyTransfer','ForeignPayment']
    };
    var pageSize = 10;

    vm.purposeCodesList = {};
    vm.purposeCodesFilter = {
      pageSize: 1000
    };
    vm.referenceModelList = [];
    vm.referenceModelFilter = {
      pageSize: 1000
    };
    //vm.countryCode = $localStorage.code;
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

    vm.isEnabled = false;
    vm.updateResponse = {};
    vm.croIbanMaskOptions = ValidationService.getUiMaskOptions().croatia.iban;
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    // default reference number validation params for BiH environment
    vm.referencePattern = vm.regexPatterns.onlyNumbersAndDashes;
    vm.referenceMaxLength = 22;

    vm.init = function () {

      // related to public revenue in BiH environment
      if (vm.countryCode === 'bh') {
        getMunicipalities();
        getRevenueCodes();
        getBudgetOrganizations();
        getRevenueAccounts();
      }

      var promises = [
        vm.getPaymentTemplatesPage(true),
        getPurposeCodesPage(),
        getReferenceModels(),
        getPaymentModes(),
        getCountries(),
        loadImages()
      ];

      if (vm.countryCode == 'hr' || vm.countryCode == 'sl') {
        promises.push(getDebitAccountList());
      }

      $q.all(promises)
        .then(function () {
          populateTemplatesWithImages();
        }).catch(function (error) {
        $log.error(error);
      });

      //if ($localStorage.code) {
      //  vm.countryCode = $localStorage.code;
      //  setInputMasks();
      //} else {
      //  getDefaultData();
      //}
      setInputMasks();

    };

    vm.referenceList = [
      {
        value: "SI",
        name: "SI"
      },
      {
        value: "RF",
        name: "RF"
      },
      {
        value: "NRC",
        name: "NRC"
      }
    ];
    vm.tempObj.referenceModelSelect = "SI";

    vm.checkIban = function (accountNumber) {
      // If iban starts with SI56 - remove "SI" option from reference number!
      if (vm.tempDompObj.toAccountInput.substring(0, 2) != "SI") {
        vm.referenceList = [
          {
            value: "RF",
            name: "RF"
          },
          {
            value: "NRC",
            name: "NRC"
          }
        ];
        vm.referenceHR = "NRC";
      } else {
        vm.referenceList = [
          {
            value: "SI",
            name: "SI"
          },
          {
            value: "RF",
            name: "RF"
          },
          {
            value: "NRC",
            name: "NRC"
          }
        ];
        vm.referenceHR = "SI";
      }

      if (!accountNumber) {
        vm.referenceHR = 'NRC';
        return;
      }
      vm.tempDompObj.referenceModelSelect = "";
      vm.tempDompObj.referenceNumberInput= "";
    };

    var setInputMasks = function () {
      vm.uiMask = 'SI ?? ???? ???? ???? ???'
    }

    var populateTemplatesWithImages = function () {
      if (vm.images && vm.images.length > 0) {
        _.forEach(vm.templateList.result, function (template) {

          if (template.imageId) {
            var imageObject = _.find(vm.images, function (image) {
              return image.id === template.imageId;
            });
            if (imageObject)
              template.imageDownloadLink = imageObject.downloadLink;
          }

          if (!template.imageId || !template.imageDownloadLink) {
            template.imageId = vm.images[0].id;
            template.imageDownloadLink = vm.images[0].downloadLink;
          }

        });
      }
    };

    var ModifyReferenceModel = function () {
      if (vm.countryCode !== 'hr') {
        _.forEach(vm.templateList.result, function (item) {
          if (!item.referenceTo) return;
          if (item.referenceTo.length == 2 && item.referenceTo == '00') {
            item.referenceTo = "";
          }
          else if (item.referenceTo.length > 2 && item.referenceTo.substr(0, 2) === '00') {
            vm.tempObj.referenceModelSelect = vm.referenceModelList[0];
            item.referenceTo = item.referenceTo.substr(2);
          }
        })
      }
    };

    vm.getPaymentTemplatesPage = function (reset) {
      //var params;


      if (reset) {
        // params = {page: 0, pageSize: pageSize, orderBy: "name asc"};
        vm.templatesFilter.page = 0;

        if (vm.searchTemplateListApi)
          vm.templatesFilter.nameGTE = vm.searchTemplateListApi;
        else
          vm.templatesFilter.nameGTE = null;

      } else {
        vm.templatesFilter.page += 1;

        // pageSize += 10;
        // params = vm.templatesFilter;

        if (vm.searchTemplateListApi)
          vm.templatesFilter.nameGTE = vm.searchTemplateListApi;
        else
          vm.templatesFilter.nameGTE = null;
      }
//      Remove cuz Template will not refresh after update!.
//      if (vm.templateList.hasMore || vm.templatesFilter.page === 0) {
      return PaymentTemplatesService.getPage(vm.templatesFilter)
        .then(function (response) {

          if (reset) {
            _.forEach(response.result, function (item) {
              item.editable = false;
            });
            vm.templateList = response;
            ModifyReferenceModel();

          } else {
            vm.templateList.hasMore = response.hasMore;
            vm.templateList.result = vm.templateList.result.concat(response.result);
            ModifyReferenceModel();
          }
          populateTemplatesWithImages();
          /*            _.forEach(vm.templateList, function (value) {
           $log.debug(value);
           });*/
        })
        .catch(function (error) {
          $log.error(error);
        });
//      }
    };

    vm.toggleDetails = function (template) {
      var previousState = template.openedDetails;
      // Close all other templates if they were opened
      _.forEach(vm.templateList.result, function (tpl) {
        tpl.openedDetails = false;
        tpl.editable = false;
      });

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        PaymentTemplatesService.getById(template.id)
          .then(function (response) {
            angular.extend(template, response);
            vm.openedTemplate = angular.extend(template, response);
            // Amount cannot be empty and must be 0.01 or bigger!
            template.amount = (!template.amount) ? 0.01 : template.amount;
            template.openedDetails = !previousState;

            var country = _.findWhere(vm.countriesOptions, {code: template.beneficiaryBankCountryCode});
            if (country) {
              template.recipientCountry = country;
            }

            console.log(template);
            if (template.openedDetails) {
              if (template.modalityCode) {
                var modality = _.findWhere(vm.paymentModeOptions, {id: template.modalityCode});
                if (modality) {
                  template.modalityFullName = modality.id + " - " + modality.description;
                }
              }
            }
            if (!vm.account || (template.openedDetails && vm.account.id !== template.accountId)) {
              vm.getAccountById(template.accountId);
            }


          }, function (error) {
            console.log(error);
          });
      } else {
        template.openedDetails = !previousState;
        if (template.openedDetails) {
          if (template.modalityCode) {
            var modality = _.findWhere(vm.paymentModeOptions, {id: template.modalityCode});
            if (modality) {
              template.modalityFullName = modality.id + " - " + modality.description;
            }
          }
        }

        // Load account for this template
        if (!vm.account || (template.openedDetails && vm.account.id !== template.accountId)) {
          vm.getAccountById(template.accountId);
        }
      }

    };

    vm.formatReferenceNumber = function (referenceNumber) {
      var referenceNumberFormatted;
      var referenceNumberP1 = referenceNumber.substring(0, 2);
      var referenceNumberP2;
      var referenceNumberP3;

      if (referenceNumberP1 == 'SI') {
        referenceNumberP2 = referenceNumber.substring(2, 4);
        referenceNumberP3 = referenceNumber.substring(4);
        referenceNumberFormatted = referenceNumberP1 + " " + referenceNumberP2 + " " + referenceNumberP3;
      } else if (referenceNumberP1 == "RF") {
        referenceNumberP2 = referenceNumber.substring(2);
        referenceNumberFormatted = referenceNumberP1 + " " + referenceNumberP2;
      } else {
        referenceNumberFormatted = referenceNumber.substring(0, 3);
      }

      return referenceNumberFormatted;
    }

    var populateRefNumber = function (number) {
      if (!number) return;
      if (number.substring(0, 3) == "NRC") {
        vm.tempObj.referenceModelSelect = number.substring(0, 3);
        vm.referenceModelListSelect = "";
        vm.tempObj.referenceNumberInput = "";
      } else if (number.substring(0, 2) == "SI") {
        vm.tempObj.referenceModelSelect = number.substring(0, 2);
        vm.referenceModelListSelect = number.substring(2, 4);
        vm.tempObj.referenceNumberInput = number.substring(4);
      } else if (number.substring(0, 2) == "RF") {
        vm.tempObj.referenceModelSelect = number.substring(0, 2);
        vm.referenceModelListSelect = "";
        vm.tempObj.referenceNumberInput = number.substring(2);
      }
    };


    vm.getAccountById = function (id) {
      return AccountsService.getAccountById(id)
        .then(function (response) {
          vm.account = response;
          vm.tempObj.fromAccountNumber = response.accountNumber;
          vm.tempObj.currencySymbol = response.currencySymbol;
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
            angular.extend(vm.openedTemplate, response);
          }
        })
        .catch(function (error) {
          $log.error(error);
        })
    };

    var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    $rootScope.$on('appLanguageChangedHeader', function () {
      sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    });

    vm.deleteTemplate = function (template) {
      if (template.templateDeleteInProgress) return;
      template.templateDeleteInProgress = true;
      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            PaymentTemplatesService.deleteTemplate(template.id)
              .then(function (response) {
                AlertService.deletedPaymentAlert({paymentName: template.name, type: 'template'})
                  // .then(function () {
                  //   vm.getPaymentTemplatesPage(true);
                  //   return;
                  // });
                vm.getPaymentTemplatesPage(true);
              })
              .catch(function (error) {
                template.templateDeleteInProgress = false;
                HelperService.showMessage(error, 'error');
              }).finally (function (){
          });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        })

    };

    vm.searchTemplate = function (searchrow) {
      vm.getPaymentTemplatesPage(true, searchrow);
    };

    vm.loadMoreTemplates = function () {
      vm.getPaymentTemplatesPage(false);
    };

    vm.selectImage = function (image) {
      if (image) {
        vm.selectedImage = image;
      }
    };

    var prepareTemplateForUpdate = function (paymentObject) {

      if (paymentObject.paymentTypeGroup === 'DomesticPayment' || paymentObject.paymentTypeGroup === 'SEPAPayment') {
        vm.tempObj.receiversNameInput = vm.payeeSearchFilter;
        if (vm.tempObj.receiversPostalCodeAndCityInput === '') {
          vm.tempObj.receiversPostalCodeAndCityInput = paymentObject.receiverCity;
        }
        if (vm.tempObj.receiversAddressInput === '') {
          vm.tempObj.receiversAddressInput = paymentObject.receiverAddress1;
        }
      }

      if (vm.tempObj.toAccountInput == '') {
        vm.tempObj.toAccountInput = paymentObject.toAccountNumber;
      }

      if (vm.tempObj.referenceModelSelect == "SI") {
        vm.tempObj.referenceTo = vm.tempObj.referenceModelSelect + vm.referenceModelListSelect + vm.tempObj.referenceNumberInput;
      } else if (vm.tempObj.referenceModelSelect == "RF") {
        vm.tempObj.referenceTo = vm.tempObj.referenceModelSelect + vm.tempObj.referenceNumberInput;
      } else if (vm.tempObj.referenceModelSelect == "NRC") {
        vm.tempObj.referenceTo = vm.tempObj.referenceModelSelect;
      }

      var tempForUpdate = {
        name: vm.tempObj.templateName,
        accountId: paymentObject.accountId,
        fromAccountNumber: vm.tempObj.fromAccountNumber,
        toAccountNumber: vm.tempObj.toAccountInput,
        currencySymbol: vm.tempObj.currencySymbol,
        amount: HelperService.parseAmountInput(paymentObject.amount),
        paymentTypeGroup: paymentObject.paymentTypeGroup,
        purpose: vm.tempObj.purposeOfPaymentInput,
        purposeCodeDPS: vm.tempObj.purposeCodeSelect.id
      };

      if (vm.selectedImage.id) {
        tempForUpdate.imageId = vm.selectedImage.id;
      }

      var subProperties = {
        receiverAddress1: vm.tempObj.receiversAddressInput,
        receiverName: vm.payeeSearchFilter
      };

      if (vm.countryCode !== 'bh') {
        subProperties.receiverCity = vm.tempObj.receiversPostalCodeAndCityInput;
        subProperties.senderName = paymentObject.senderName;
        subProperties.senderAddress1 = paymentObject.senderAddress1;
        subProperties.senderCity = paymentObject.senderCity;
        subProperties.referenceTo = vm.tempObj.referenceTo;
      } else {
        subProperties.reference = vm.tempObj.referenceNumberInput;
      }

      var sepaProperties = {
        debtorName: vm.tempObj.payersSepaInput1,
        creditorName: vm.tempObj.receiversSepaInput1
      };

      tempForUpdate.sepaUpnIdentificators = sepaProperties;
      switch (paymentObject.paymentTypeGroup) {
        case 'DomesticPayment':
        case 'SEPAPayment':
          tempForUpdate.domesticPayment = subProperties;
          if (vm.tempObj.beneficiarySWIFTCode)
            tempForUpdate.beneficiarySWIFTCode = vm.tempObj.beneficiarySWIFTCode;
          break;
        case 'ForeignPayment':
          tempForUpdate.foreignPayment = subProperties;
          tempForUpdate.foreignPayment.beneficiaryBankName = vm.tempObj.bankNameInput;
          tempForUpdate.foreignPayment.beneficiaryBankAddress = vm.tempObj.bankAddressInput;
          tempForUpdate.foreignPayment.beneficiaryBankCity = vm.tempObj.bankCityInput;
          tempForUpdate.foreignPayment.beneficiarySWIFTCode = vm.tempObj.swiftCodeInput;
          tempForUpdate.foreignPayment.paymentCharges = vm.tempObj.bankChargesRadiobutton.type;
          tempForUpdate.foreignPayment.payeeLegalForm = vm.tempObj.recipientStatusRadiobutton.type;
          tempForUpdate.foreignPayment.receiverCountryCode = paymentObject.receiverCountryCode;
          tempForUpdate.foreignPayment.chargeAccount = vm.account.accountNumber + ' ' + vm.account.currencySymbol;
          tempForUpdate.foreignPayment.modalityCode = vm.tempObj.modalityCode;
          if (vm.tempObj.bankCountrySelect) {
            tempForUpdate.foreignPayment.beneficiaryBankCountryCode = vm.tempObj.bankCountrySelect.code;
          }
          break;
        case "RevenuePayment":
          subProperties.taxPayerId = vm.tempObj.taxPayerId;
          subProperties.budgetOrganization = vm.tempObj.budgetOrganization;
          subProperties.municipality = vm.tempObj.municipality;
          subProperties.revenueCode = vm.tempObj.revenueCode;
          subProperties.paymentType = vm.tempObj.paymentType;
          subProperties.taxPeriodFrom = vm.tempObj.taxPeriodFrom;
          subProperties.taxPeriodTo = vm.tempObj.taxPeriodTo;
          subProperties.taxPeriodTo = vm.tempObj.taxPeriodTo;
          tempForUpdate.domesticPayment = subProperties;
          break;
      }
      return tempForUpdate;
    };

    vm.saveTemplate = function (template, index) {
      if (vm.saveButtonPressed) {
        return;
      }

      vm.tempObj.formSubmitted = true;
      if (!vm.templatesListForm.$valid) {
        return;
      }

      var templateForSaveObj = prepareTemplateForUpdate(template);
      vm.saveButtonPressed = true;
      PaymentTemplatesService.updateTemplate(template.id, templateForSaveObj)
        .then(function (response) {
          //swal(templateUpdatedSuccessfully);
          //swal.collapse;
          AlertService.infoAlert({
            text: 'alert.updateTemplate'
          })
            .then(function () {
              template.editable = false;
              vm.getPaymentTemplatesPage(true);
              vm.updateResponse = response;
              clearAllFields();
            });
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
        .finally(function() {
          vm.saveButtonPressed = false;
        });
    };

    vm.editTemplate = function (template) {
      _.forEach(vm.templateList.result, function (template) {
        template.editable = false;
      });
      template.editable = true;
      vm.currentTemplate = _.findWhere(vm.templateList.result, {id: template.id});
      populateEditableFields(vm.currentTemplate);

    };

    vm.cancel = function (template) {
      template.editable = false;
      clearAllFields();
    };

    vm.checkInputChanges = function (group) {
      if (group === 'DomesticPayment') {
        if (!vm.tempObj.toAccountInput && !vm.tempObj.receiversPostalCodeAndCityInput && !vm.tempObj.receiversAddressInput && !vm.tempObj.receiversNameInput)
          vm.isEnabled = false;
        else
          vm.isEnabled = true;
      } else {
        if (!vm.tempObj.toAccountInput)
          vm.isEnabled = false;
        else
          vm.isEnabled = true;
      }
    };

    vm.searchPayee = function () {
      vm.searchFilterExpanded = true;
    };

    vm.removeSearch = function () {
      vm.payeeSearchFilter = '';
      vm.tempObj.toAccountInput = '';
      vm.tempObj.receiversAddressInput = '';
      vm.tempObj.receiversPostalCodeAndCityInput = '';
    };

    vm.searchPayeeBy = function (searchrow) {
      return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.payeeSearchFilter) || '') !== -1 ||
      angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.payeeSearchFilter) || '') !== -1);
    };

    vm.toggleFilterSelection = function () {
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    vm.selectPayee = function (id) {

      var payee = _.find(vm.payeeList, function (item) {
        return item.id == id;
      });

      if (payee) {
        vm.tempObj.toAccountInput = payee.toAccountNumber;
        vm.tempObj.receiversAddressInput = payee.receiverAddress1;
        vm.tempObj.receiversNameInput = payee.receiverName;
        vm.tempObj.receiversPostalCodeAndCityInput = payee.receiverCity;
        vm.payeeSearchFilter = payee.receiverName;
      }

      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    var fillReceiversInput = function (response) {
      if (response.result.length > 0) {
        vm.tempObj.receiversNameInput = response.result[0].receiverName;
        vm.payeeSearchFilter = response.result[0].receiverName;
        vm.tempObj.receiversAddressInput = response.result[0].receiverAddress1;
        vm.tempObj.receiversPostalCodeAndCityInput = response.result[0].receiverCity;
      }
    };

    vm.templateImagesFilter = {
      category: "Templates"
    };

    var loadImages = function () {
      return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
        if (images)
          vm.images = images.result;
      }).catch(function (err) {
        $log.error(err);
      });
    };

    vm.fillReceiver = function (toAccountInput) {
      if (!toAccountInput) return;
      toAccountInput = toAccountInput.replace(/\s/g, '');
      if (toAccountInput.substring(0, 2) === 'HR') {
        CreditAccountRegisterService.getByIban(toAccountInput)
          .then(function (response) {
            fillReceiversInput(response);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      } else {
        CreditAccountRegisterService.getPage({
          accountNumber: toAccountInput
        })
          .then(function (response) {
            fillReceiversInput(response);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    var getPurposeCodesPage = function () {
      return PurposeCodesService.getPage(vm.purposeCodesFilter)
        .then(function (response) {
          _.forEach(response.result, function (item) {
            item.optionValue = item.id + ' - ' + item.description;
          });
          vm.purposeCodesList = response;

          $log.debug("purposeCodesList", vm.purposeCodesList);
        })
        .catch(function () {
          $log.error('Error loading purpose codes!');
        });
    };

    var getPaymentModes = function () {
      return PaymentsService.getPaymentModes().then(function (response) {
        vm.paymentModeOptions = response.result;
      })
        .catch(function (err) {
          $log.error('Error loading bic banks codes!');
        });
    };

    var getCountries = function () {
      return CountriesService.getPage({pageSize: 1000}).then(function (response) {
        vm.countriesOptions = response.result;
      }).catch(function (err) {
        $log.error(err);
      });
    };

    var emptyReferenceModel = {
      description: " ",
      model: "  "
    };

    var getReferenceModels = function () {
      return ReferenceModelService.getPage(vm.referenceModelFilter)
        .then(function (response) {
          if (vm.countryCode && vm.countryCode !== 'hr' && vm.countryCode !== 'sl') {
            vm.referenceModelList.push(emptyReferenceModel.model);
          }
          _.forEach(response.result, function (value) {
            vm.referenceModelList.push(value.model);
          });
          vm.tempObj.referenceModelSelect = vm.referenceModelList[0];
        })
        .catch(function () {
          $log.error('Error loading bic banks codes!');
        });
    };

    var getDebitAccountList = function () {
      return PaymentTypesService.getByGroup({
        paymentTypeGroup: 'ForeignPayment'
      })
        .then(function (response) {
          if (_.isArray(response.result) && response.result.length > 0) {
            vm.accountsFrom = response.result[0].debitAccountList;
            // vm.chargeAccountOptions = _.where(vm.accountsFrom, {iban: item.iban});
            _.forEach(vm.accountsFrom, function (item) {
              if (item.accountDescription) {
                item.optionValue = item.accountDescription + ' - ' + item.iban;
              }
            });
          }
        })
        .catch(function (error) {
          $log.error(error);
        });
    };

    var clearAllFields = function () {
      vm.tempObj.receiversNameInput = '';
      vm.tempObj.receiversPostalCodeAndCityInput = '';
      vm.tempObj.receiversAddressInput = '';
      vm.tempObj.toAccountInput = '';

      // Foreign specific fields
      vm.countrySearchFilter = '';
      vm.bicCodeSearchFilter = '';
      vm.tempObj.swiftCodeInput = "";
      vm.tempObj.bankAddressInput = "";
      vm.tempObj.bankCityInput = "";
      vm.tempObj.bankNameInput = "";
    };

    vm.changePurpose = function (code) {
      var purposeCode = _.find(vm.purposeCodesList.result, function (item) {
        return item.id == code.id;
      });
      if (purposeCode && $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
        vm.tempObj.purposeOfPaymentInput = purposeCode.description;
      }
    };

    vm.onBicBankSelected = function (bicCode) {
      var bicBank = _.findWhere(vm.bicBankOptions, {bicCode: bicCode});
      vm.tempObj.swiftCodeInput = bicBank.bicCode;
      vm.tempObj.bankAddressInput = bicBank.branchInformation;
      vm.tempObj.bankCityInput = bicBank.city;
      vm.tempObj.bankNameInput = bicBank.institutionName;

      vm.bicCodeSearchFilter = bicBank.bicCode;
      vm.bicCodeSearchFilterExpanded = false;
    };

    vm.addSpaceForIban = function (toAccountInput) {
      if (!vm.tempObj.toAccountInput) return;
      vm.tempObj.toAccountInput = toAccountInput.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    };

    vm.getBicByIban = function (iban) {
      if (!iban) {
        return;
      }
      iban = iban.replace(/\s/g, '');
      PaymentsService.getBicBanks(undefined, {iban: iban})
        .then(function (response) {
          var bicBank = response.result[0];
          if (bicBank) {
            vm.bicCodeSearchFilter = bicBank.bicCode;
            vm.tempObj.swiftCodeInput = bicBank.bicCode;
            vm.tempObj.bankAddressInput = bicBank.branchInformation;
            vm.tempObj.bankCityInput = bicBank.city;
            vm.tempObj.bankNameInput = bicBank.institutionName;
          }
        }, function (error) {

        })
    };

    vm.searchBICNumber = function (bicInput) {
      vm.bicCodeSearchFilterExpanded = true;
      vm.tempObj.swiftCodeInput = bicInput;
      searchBicNumber(bicInput);
    };

    var searchBicNumber = function (bicInput) {
      PaymentsService.getBicBanks(undefined, {bicCode: bicInput})
        .then(function (response) {
          vm.bicBankOptions = response.result;
        }, function (error) {

        })
    };

    vm.removeBicCodeSearch = function () {
      vm.bicCodeSearchFilter = "";
      vm.tempObj.swiftCodeInput = "";
      vm.tempObj.bankAddressInput = "";
      vm.tempObj.bankCityInput = "";
      vm.tempObj.bankNameInput = "";
    };


    // Country selection

    vm.onCountrySelect = function (country) {
      vm.countrySearchFilter = country.code + " " + country.description;
      vm.tempObj.bankCountrySelect = country;
      vm.countrySearchFilterExpanded = false;
    };

    vm.removeSelectedCountry = function () {
      vm.countrySearchFilter = "";
      vm.tempObj.bankCountrySelect = {};
      vm.countrySearchFilterExpanded = true;
    };

    vm.setChargeAccount = function (item) {
      vm.tempObj.fromAccountSelect = item;
      vm.tempObj.chargeAccountInput = item;
      vm.chargeAccountOptions = _.where(vm.accountsFrom, {iban: item.iban});
    };

    var populateEditableFields = function (template) {

      vm.payeeList = _.filter(vm.templateList.result, function (item) {
        return item.paymentTypeGroup === template.paymentTypeGroup;
      });

      if (template.referenceTo) {
        if (template.referenceTo.length > 2) {
          var i = template.referenceTo.substr(2);
          vm.tempObj.referenceModelSelect = template.referenceTo.substr(0, 2);
          vm.tempObj.referenceNumberInput = i;
        } else {
          vm.tempObj.referenceModelSelect = template.referenceTo;
          vm.tempObj.referenceNumberInput = "";
        }
      }

      var index = _.findIndex(vm.referenceModelList, function (item) {
        return item === vm.tempObj.referenceModelSelect;
      });

      if (index != -1) {
        vm.tempObj.referenceModelSelect = vm.referenceModelList[index];
      } else {
        vm.tempObj.referenceModelSelect = vm.referenceModelList[0];
        vm.tempObj.referenceNumberInput = template.referenceTo;
      }

      vm.tempObj.toAccountInput = template.toAccountNumber;
      vm.tempObj.receiversAddressInput = template.receiverAddress1;
      vm.tempObj.receiversNameInput = template.receiverName;
      vm.tempObj.receiversPostalCodeAndCityInput = template.receiverCity;
      vm.tempObj.modalityCode = template.modalityCode;
      vm.tempObj.templateName = template.name;
      vm.tempObj.payersSepaInput1 = template.sepaUpnIdentificators.debtorName;
      vm.tempObj.receiversSepaInput1 = template.sepaUpnIdentificators.creditorName;


      // Populate BIC fields from template
      if (template.paymentTypeGroup === 'ForeignPayment') {
        vm.tempObj.swiftCodeInput = template.beneficiarySWIFTCode;
        vm.bicCodeSearchFilter = template.beneficiarySWIFTCode;
        vm.tempObj.bankAddressInput = template.beneficiaryBankAddress;
        vm.tempObj.bankCityInput = template.beneficiaryBankCity;
        vm.tempObj.bankNameInput = template.beneficiaryBankName;
        vm.tempObj.bankChargesRadiobutton.type = template.paymentCharges || '3';
        vm.tempObj.recipientStatusRadiobutton.type = template.payeeLegalForm || '2';

        // vm.tempObj.chargeAccountInput = template.


        var country = _.findWhere(vm.countriesOptions, {code: template.beneficiaryBankCountryCode});
        if (country) {
          vm.countrySearchFilter = country.code + " " + country.description;
          vm.tempObj.bankCountrySelect = country;
        }

        vm.fieldMaxLength = "34";
      } else {
        vm.fieldMaxLength = "70";
      }

      vm.payeeSearchFilter = template.receiverName;
      vm.searchFilterExpanded = false;
      // vm.searchTemplateFilterExpanded = false;

      if ((template.purposeCode || template.purposeCodeDPS) && vm.purposeCodesList.result) {
        var purposeCode;
        // Remove leading character from string
        if (template.purposeCodeDPS && vm.countryCode != 'bh') {
          var leading_char = template.purposeCodeDPS.substring(0, 1);
          if (template.purposeCodeDPS.length > 2 && leading_char === '2' || leading_char === '9') {
            template.purposeCodeDPS = template.purposeCodeDPS.substring(1);
            purposeCode = template.purposeCodeDPS;
          }
        } else if (template.purposeCodeDPS && vm.countryCode == 'bh') {
          purposeCode = template.purposeCodeDPS;
        } else {
          purposeCode = template.purposeCode;
        }

        var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
          // In slovenia purpose code is returned in purposeCode property, but in croatia for example purposeCodeDPS is used
          return purpose.id == purposeCode;
        });
        if (purpose) {
          vm.tempObj.purposeCodeSelect = purpose;
          vm.tempObj.purposeOfPaymentInput = purpose.description;
        }
      } else {
        // add empty one
        vm.tempObj.purposeCodeSelect = vm.purposeCodesList.result[0];
      }

      if (vm.tempObj.purposeOfPaymentInput === '' || template.purpose !== vm.tempObj.purposeOfPaymentInput) {
        vm.tempObj.purposeOfPaymentInput = template.purpose;
      }

      // Set selected template image
      if (template.imageId) {
        // Set selected image
        vm.selectedImage = {
          downloadLink: template.imageDownloadLink,
          id: template.imageId
        };
      } else {
        // If there was no image, set it to first from list (default image)
        if (vm.images && vm.images.length > 0) {
          vm.selectedImage = {
            downloadLink: vm.images[0].imageDownloadLink,
            id: vm.images[0].id
          }
        }
      }

      if (template.beneficiarySWIFTCode) {
        vm.tempObj.beneficiarySWIFTCode = template.beneficiarySWIFTCode;

      }

      // populate public revenue fields
      if (template.paymentTypeGroup == "RevenuePayment") {
        vm.tempObj.taxPayerId = template.taxPayerId;
        vm.tempObj.paymentType = template.paymentType || vm.tempObj.paymentTypes[0];
        vm.tempObj.revenueCode = template.revenueCode;
        vm.tempObj.municipality = template.municipality;
        vm.tempObj.taxPeriodFrom = new Date(template.taxPeriodFrom);
        vm.tempObj.taxPeriodTo = new Date(template.taxPeriodTo);
        vm.tempObj.budgetOrganization = template.budgetOrganization;
        vm.tempObj.selectedRevenueAccount = _.find(vm.revenueAccounts, function (item) {
          return vm.tempObj.toAccountInput == item.revenueAccountNumber;
        });
        vm.referenceMaxLength = 10;
        vm.referencePattern = vm.regexPatterns.onlyNumbers;

      }
      populateRefNumber(template.referenceTo);
      vm.getBicByIban2(vm.tempObj.toAccountInput);

    };

    // related to Public Revenue
    function getMunicipalities() {
      PublicRevenueService.getMunicipalities({
        page: 0,
        pageSize: 1000
      })
        .then(function (response) {
          vm.tempObj.municipalities = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    function getRevenueCodes() {
      PublicRevenueService.getRevenueCodes({
        page: 0,
        pageSize: 1000
      })
        .then(function (response) {
          vm.tempObj.revenueCodes = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };

    function getBudgetOrganizations() {
      PublicRevenueService.getBudgetOrganizations({
        page: 0,
        pageSize: 1000
      })
        .then(function (response) {
          vm.tempObj.budgetOrganizations = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };

    // custom municipalities autocomplete
    vm.municipalityFilterExpanded = false;
    vm.openMunicipalities = function () {
      vm.municipalityFilterExpanded = true;
      validateMunicipalityExistance();
    };

    vm.toggleMunicipalities = function () {
      vm.municipalityFilterExpanded = !vm.municipalityFilterExpanded;
    };

    vm.removeMunicipalities = function () {
      vm.tempObj.municipality = '';
    };

    vm.selectMunicipality = function (municipality) {
      vm.tempObj.municipality = municipality.codeString;
      vm.municipalityFilterExpanded = false;
      validateMunicipalityExistance();
    };

    vm.filterMunicipalities = function (item) {
      return (angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempObj.municipality) || '') !== -1 ||
      angular.lowercase(item.codeString).indexOf(angular.lowercase(vm.tempObj.municipality) || '') !== -1);
    };

    // custom revenue type autocomplete
    vm.revenueCodeFilterExpanded = false;
    vm.openRevenueCodes = function () {
      vm.revenueCodeFilterExpanded = true;
      vm.tempObj.selectedRevenueCode = null;
      validateRevenueCodeExistance();
    };

    vm.toggleRevenueCodes = function () {
      vm.revenueCodeFilterExpanded = !vm.revenueCodeFilterExpanded;
    };

    vm.closeRevenueCodes = function () {
      vm.tempObj.revenueCode = '';
    };

    vm.selectRevenueCode = function (revenueCode) {
      vm.tempObj.revenueCode = revenueCode.code;
      vm.revenueCodeFilterExpanded = false;
      vm.tempObj.selectedRevenueCode = revenueCode;
      validateRevenueCodeExistance();
    };

    // fcn for filtering revenue codes
    vm.filterRevenueCodes = function (item) {
      return (angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempObj.revenueCode) || '') !== -1 ||
      angular.lowercase(item.code.toString()).indexOf(angular.lowercase(vm.tempObj.revenueCode) || '') !== -1);
    };

    // custom budget organizations autocomplete
    vm.budgetOrganizationFilterExpanded = false;
    vm.openBudgetOrganizations = function () {
      vm.budgetOrganizationFilterExpanded = true;
    };

    vm.toggleBudgetOrganizations = function () {
      vm.budgetOrganizationFilterExpanded = !vm.budgetOrganizationFilterExpanded;
    };

    vm.closeBudgetOrganization = function () {
      vm.tempObj.budgetOrganization = '';
    };

    vm.selectBudgetOrganization = function (budgetOrg) {
      vm.tempObj.budgetOrganization = budgetOrg.budgetOrganisationNumber;
      vm.budgetOrganizationFilterExpanded = false;
    };

    // fcn for filtering revenue codes
    vm.filterBudgetOrganizations = function (item) {
      return (angular.lowercase(item.budgetOrganisationNumber).indexOf(angular.lowercase(vm.tempObj.budgetOrganization) || '') !== -1 ||
      angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempObj.budgetOrganization) || '') !== -1);
    };

    vm.taxPeriodFromOpened = false;
    vm.taxPeriodToOpened = false;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.openTaxPeriodFrom = function () {
      vm.taxPeriodFromOpened = true;
    };

    vm.openTaxPeriodTo = function () {
      vm.taxPeriodToOpened = true;
    };

    function getRevenueAccounts() {
      PublicRevenueService.getRevenueAccounts({
        page: 0,
        pageSize: 1000
      })
        .then(function (response) {
          vm.revenueAccounts = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.checkIsRevenueAccount = function () {
      //isRevenueAccount();
      validateRevenueCodeType();
    };

    //custom validation
    vm.validateTaxPeriod = function () {
      var isRangeValid = false;
      if (vm.tempObj.taxPeriodFrom <= vm.tempObj.taxPeriodTo) {
        isRangeValid = true;
      }
      vm.templatesListForm.taxPeriodFrom.$setValidity('taxPeriodRange', isRangeValid);
    };

    function checkIfMunicipalityExists() {
      var exists = _.find(vm.tempObj.municipalities, function (item) {
        return vm.tempObj.municipality == item.codeString;
      });
      if (exists) {
        return true;
      }
      return false;
    };

    function validateMunicipalityExistance() {
      var exist = checkIfMunicipalityExists();
      if (!vm.tempObj.municipality) {
        exist = true;
      }
      vm.templatesListForm.municipalityFilter.$setValidity('municipalityExistance', exist);
    };

    function checkIfRevenueCodeExists() {
      var exists = _.find(vm.tempObj.revenueCodes, function (item) {
        return vm.tempObj.revenueCode == item.code;
      });
      if (exists) {
        return true;
      }
      return false;
    };

    function validateRevenueCodeExistance() {
      var exist = checkIfRevenueCodeExists();
      if (!vm.tempObj.revenueCode) {
        exist = true;
      }
      vm.templatesListForm.revenueCodeFilter.$setValidity('revenueCodeExistance', exist);
    };

    function validateRevenueCodeType() {
      if (vm.tempObj.selectedRevenueAccount) {
        var correctRevenueCode = false;
        if (vm.tempObj.revenueCode === '000000') {
          correctRevenueCode = true;
        } else {
          var revenueCode = _.find(vm.tempObj.revenueCodes, function (item) {
            return vm.tempObj.revenueCode == item.code;
          });
          if (revenueCode) {
            var equalityCriteria = vm.tempObj.selectedRevenueCode ? vm.tempObj.selectedRevenueCode : revenueCode;
            if (vm.tempObj.selectedRevenueAccount.revenueType === equalityCriteria.type) {
              correctRevenueCode = true;
            }
          }
        }
        if (!vm.tempObj.revenueCode) {
          correctRevenueCode = true;
        }
        if (vm.templatesListForm.revenueCodeFilter) {
          vm.templatesListForm.revenueCodeFilter.$setValidity('revenueCodeType', correctRevenueCode);
        }
      }
    };

    // validation of reference number BiH environment

    vm.completeReferenceNumber = function () {
      if (vm.tempObj.selectedRevenueAccount && !vm.templatesListForm.referenceNumberInput.$valid) {
        if (!vm.tempObj.referenceNumberInput) {
          vm.tempObj.referenceNumberInput = '';
        }
        var refLength = vm.tempObj.referenceNumberInput.length;
        var zeros = '';
        if (refLength < 10) {
          for (var i = 0; i < (10 - refLength); i++) {
            zeros += '0';
          }
        }
        vm.tempObj.referenceNumberInput = zeros + vm.tempObj.referenceNumberInput;
      }
    };

    vm.validateReferenceNumber = function () {
      var requiredReference = true;
      if (vm.tempObj.selectedRevenueAccount && (vm.tempObj.selectedRevenueAccount.revenueType == '92' || vm.tempObj.selectedRevenueAccount.revenueType == '91')) {
        requiredReference = vm.tempObj.referenceNumberInput ? true : false;
      }
      vm.templatesListForm.referenceNumberInput.$setValidity('referenceNumberRequired', requiredReference);
    };

    vm.checkReferenceNumber = function () {
      var allZeros = false;
      if (vm.tempObj.referenceNumberInput) {
        allZeros = true;
        for (var i = 0; i < vm.tempObj.referenceNumberInput.length; i++) {
          if (vm.tempObj.referenceNumberInput[i] != '0') {
            allZeros = false;
            break;
          }
        }
      }
      vm.templatesListForm.referenceNumberInput.$setValidity('validReferenceNumber', !allZeros);
    };

    // vm.checkPurposeOfPaymentLength = function () {
    //   if (vm.tempObj.referenceModelSelect == "RF") {
    //     vm.referenceModelListSelect = '';
    //   }
    //   if (vm.tempObj.referenceModelSelect != "NRC") {
    //     vm.tempObj.purposeOfPaymentInput = vm.tempObj.purposeOfPaymentInput.substring(0, 34)
    //   } else {
    //     vm.tempObj.referenceNumberInput = '';
    //     vm.referenceModelListSelect = '';
    //   }
    //
    // };


    vm.getBicByIban2 = function (iban) {
      if (!iban) {
        return;
      }
      iban = iban.replace(/\s/g, '');
      PaymentsService.getBicBanks(undefined, {
        iban: iban
      })
        .then(function (response) {
          var bicBank = response.result[0];
          if (bicBank) {
            vm.tempObj.beneficiarySWIFTCode = bicBank.bicCode;
          }
        }, function (error) {

        })
    };

    vm.goToPayment = function (template) {
      var params = {
        templateId: template.id
      };
      if (template.paymentSubTypeGroup == "NotSupportedPayment") {
        AlertService.infoAlert({
          text: "paymentsOverview.notSupportedPaymentMsg"
        })
        return;
      }
      if (template.paymentTypeGroup == 'DomesticPayment' || template.paymentTypeGroup == 'SEPAPayment' || template.paymentTypeGroup == 'LocalCurrencyTransfer') {
        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {

          if (template.paymentTypeGroup == "LocalCurrencyTransfer" && template.paymentSubTypeGroup == "SEPAPayment") {
              $state.go('payments.domesticPayment.fromTemplatesToPay', params);
          } else if (template.paymentTypeGroup == "LocalCurrencyTransfer"  && template.paymentSubTypeGroup == "LocalCurrencyTransfer") {
              $state.go('payments.internalTransfer.fromTemplate', params);
          } else {
            $state.go('payments.domesticPayment.fromTemplatesToPay', params);
          }

          // if (template.paymentTypeGroup == "LocalCurrencyTransfer" && (template.toAccountNumber.substring(0, 4) != "SI56" || (template.iban && template.iban.substring(0, 4) != "SI56"))) {
          //   $state.go('payments.internalTransfer.fromTemplate', params);
          // } else  if (template.paymentTypeGroup == "LocalCurrencyTransfer" && template.toAccountNumber.substring(0, 4) == "SI56") {
          //   $state.go('payments.domesticPayment.fromTemplatesToPay', params);
          // } else {
          //   $state.go('payments.domesticPayment.fromTemplatesToPay', params);
          // }


          } else {
          $state.go('payments.domesticPayment.fromTemplatesToPay', params);
        }
      }

      if (template.paymentTypeGroup == 'ForeignPayment')
        $state.go('payments.internationalPayment.fromTemplatesToPay', params);
      if(template.paymentTypeGroup ==  "ForeignCurrencyTransfer")
        $state.go('payments.internalTransfer.fromTemplate', params);
    }

    vm.init();
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name paymentTemplates.controller:TemplateListOverviewCtrl
   *
   * @description
   *
   */
  TemplateListOverviewOtherCtrl.$inject = ["$rootScope", "$state", "CTLocalizationService", "PaymentTemplatesService", "$log", "AccountsService", "HelperService", "ValidationService", "PaymentsService", "PurposeCodesService", "ConfigEndpointService", "$localStorage", "ReferenceModelService", "CountriesService", "CreditAccountRegisterService", "PaymentTypesService", "ImagesService", "$q", "AlertService", "PublicRevenueService"];
  angular
    .module('paymentTemplates')
    .controller('TemplateListOverviewOtherCtrl', TemplateListOverviewOtherCtrl);

  function TemplateListOverviewOtherCtrl($rootScope, $state, CTLocalizationService, PaymentTemplatesService, $log, AccountsService, HelperService, ValidationService, PaymentsService,
                                    PurposeCodesService, ConfigEndpointService, $localStorage, ReferenceModelService, CountriesService,
                                    CreditAccountRegisterService, PaymentTypesService, ImagesService, $q, AlertService, PublicRevenueService)
  {
    var vm = this;

    vm.tempObj = {
      toAccountInput: '',
      fromAccountNumber: '',
      currencySymbol: '',
      formSubmitted: false,
      purposeOfPaymentInput: '',
      currentDate: HelperService.getYesterday().firstDay,
      receiversNameInput: '',
      receiversAddressInput: '',
      receiversPostalCodeAndCityInput: '',
      bankChargesRadiobutton: {
        type: '3'
      },
      recipientStatusRadiobutton: {
        type: '2'
      },
      referenceModelSelect: '',
      referenceNumberInput: '',
      payersSepaInput1: '',
      payersSepaInput2: '',
      receiversSepaInput1: '',
      receiversSepaInput2: '',
      //related to public revenue
      tayPayerId: '',
      revenueCode: '',
      municipality: '',
      taxPeriodFrom: new Date(),
      taxPeriodTo: new Date(),
      budgetOrganization: '',
      paymentTypes: ['0', '1', '2', '3', '5', '6', '7', '8', '9']
    };
    vm.tempObj.paymentType = vm.tempObj.paymentTypes[0];

    vm.selectedImage = {};
    vm.templateList = {};
    vm.account = {};
    vm.searchTemplateList = '';
    vm.searchTemplateListApi = '';
    vm.templatesFilter = {
      page: 0,
      pageSize: 10,
      orderBy: "name asc"
    };
    var pageSize = 10;

    vm.purposeCodesList = {};
    vm.purposeCodesFilter = {
      pageSize: 1000
    };
    vm.referenceModelList = [];
    vm.referenceModelFilter = {
      pageSize: 1000
    };
    //vm.countryCode = $localStorage.code;
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

    vm.isEnabled = false;
    vm.updateResponse = {};
    vm.croIbanMaskOptions = ValidationService.getUiMaskOptions().croatia.iban;
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    // default reference number validation params for BiH environment
    vm.referencePattern = vm.regexPatterns.onlyNumbersAndDashes;
    vm.referenceMaxLength = 22;

    vm.init = function () {

      // related to public revenue in BiH environment
      if(vm.countryCode === 'bh'){
        getMunicipalities();
        getRevenueCodes();
        getBudgetOrganizations();
        getRevenueAccounts();
      }

      var promises = [
        vm.getPaymentTemplatesPage(true),
        getPurposeCodesPage(),
        getReferenceModels(),
        getPaymentModes(),
        getCountries(),
        loadImages()
      ];

      if(vm.countryCode == 'hr' || vm.countryCode == 'sl'){
        promises.push(getDebitAccountList());
      }

      $q.all(promises)
        .then(function(){
          populateTemplatesWithImages();
        }).catch(function (error) {
        $log.error(error);
      });

      //if ($localStorage.code) {
      //  vm.countryCode = $localStorage.code;
      //  setInputMasks();
      //} else {
      //  getDefaultData();
      //}
      setInputMasks();

    };
    var setInputMasks = function () {
      if(vm.countryCode == 'sl')
        vm.uiMask = 'SI ?? ???? ???? ???? ???'
      else if(vm.countryCode == 'hr')
        vm.uiMask = 'HR ?? ???? ???? ???? ???? ?';
    }
    var populateTemplatesWithImages = function () {
      if (vm.images && vm.images.length > 0) {
        _.forEach(vm.templateList.result, function (template) {

          if (template.imageId) {
            var imageObject = _.find(vm.images, function (image) {
              return image.id === template.imageId;
            });
            if (imageObject)
              template.imageDownloadLink = imageObject.downloadLink;
          }

          if (!template.imageId || !template.imageDownloadLink) {
            template.imageId = vm.images[0].id;
            template.imageDownloadLink = vm.images[0].downloadLink;
          }

        });
      }
    };

    var ModifyReferenceModel = function () {
      if(vm.countryCode !== 'hr') {
        _.forEach(vm.templateList.result, function (item) {
          if (!item.referenceTo) return;
          if (item.referenceTo.length == 2 && item.referenceTo == '00') {
            item.referenceTo = "";
          }
          else if (item.referenceTo.length > 2 && item.referenceTo.substr(0,2) === '00') {
            vm.tempObj.referenceModelSelect = vm.referenceModelList[0];
            item.referenceTo = item.referenceTo.substr(2);
          }
        })
      }
    };

    vm.getPaymentTemplatesPage = function (reset) {
      var params;
      if (reset) {
        params = {page: 0, pageSize: pageSize, orderBy: "name asc"};
        if(vm.searchTemplateListApi)
          params.nameGTE = vm.searchTemplateListApi;
      } else {
        vm.templatesFilter.page += 1;
        vm.templatesFilter.pageSize = 10;
        pageSize += 10;
        params = vm.templatesFilter;
        if(vm.searchTemplateListApi)
          params.nameGTE = vm.searchTemplateListApi;
      }
//      Remove cuz Template will not refresh after update!.
//      if (vm.templateList.hasMore || vm.templatesFilter.page === 0) {
      return PaymentTemplatesService.getPage(params)
        .then(function (response) {

          if (reset) {
            _.forEach(response.result, function (item) {
              item.editable = false;
            });
            vm.templateList = response;
            ModifyReferenceModel();

          } else {
            vm.templateList.hasMore = response.hasMore;
            vm.templateList.result = vm.templateList.result.concat(response.result);
            ModifyReferenceModel();
          }
          populateTemplatesWithImages();
          /*            _.forEach(vm.templateList, function (value) {
           $log.debug(value);
           });*/
        })
        .catch(function (error) {
          $log.error(error);
        });
//      }
    };

    vm.toggleDetails = function (template) {
      var previousState = template.openedDetails;
      // Close all other templates if they were opened
      _.forEach(vm.templateList.result, function (tpl) {
        tpl.openedDetails = false;
        tpl.editable = false;
      });

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" ) {
        PaymentTemplatesService.getById(template.id)
          .then(function(response){
            angular.extend(template, response);
            // Amount cannot be empty and must be 0.01 or bigger!
            template.amount = (!template.amount) ? 0.01 : template.amount;
            template.openedDetails = !previousState;
            if(template.openedDetails){
              if(template.modalityCode){
                var modality = _.findWhere(vm.paymentModeOptions, {id: template.modalityCode});
                if (modality) {
                  template.modalityFullName = modality.id + " - " + modality.description;
                }
              }
            }
            if (!vm.account || (template.openedDetails && vm.account.id !== template.accountId)) {
              vm.getAccountById(template.accountId);
            }


          }, function(error)  {
            console.log(error);
          });
      } else {
        template.openedDetails = !previousState;
        if(template.openedDetails){
          if(template.modalityCode){
            var modality = _.findWhere(vm.paymentModeOptions, {id: template.modalityCode});
            if (modality) {
              template.modalityFullName = modality.id + " - " + modality.description;
            }
          }
        }

        // Load account for this template
        if (!vm.account || (template.openedDetails && vm.account.id !== template.accountId)) {
          vm.getAccountById(template.accountId);
        }
      }

    };

    vm.formatReferenceNumber = function (referenceNumber) {
      var referenceNumberFormatted;
      var referenceNumberP1 = referenceNumber.substring(0, 2);
      var referenceNumberP2;
      var referenceNumberP3;

      if(referenceNumberP1 == 'SI') {
        referenceNumberP2 = referenceNumber.substring(2, 4);
        referenceNumberP3 = referenceNumber.substring(4);
        referenceNumberFormatted = referenceNumberP1 + " " + referenceNumberP2 + " " + referenceNumberP3;
      } else if (referenceNumberP1 == "RF" ) {
        referenceNumberP2 = referenceNumber.substring(2);
        referenceNumberFormatted = referenceNumberP1 + " " + referenceNumberP2;
      } else {
        referenceNumberFormatted = referenceNumber.substring(0, 3);
      }

      return referenceNumberFormatted;
    }

    var populateRefNumber = function (number) {
      if (number.substring(0, 3) == "NRC") {
        vm.tempObj.referenceModelSelect = number.substring(0, 3);
        vm.referenceModelListSelect = "";
        vm.tempObj.referenceNumberInput = "";
      } else if (number.substring(0, 2) == "SI") {
        vm.tempObj.referenceModelSelect = number.substring(0, 2);
        vm.referenceModelListSelect = number.substring(2, 4);
        vm.tempObj.referenceNumberInput = number.substring(4);
      } else if (number.substring(0,2) == "RF") {
        vm.tempObj.referenceModelSelect = number.substring(0, 2);
        vm.referenceModelListSelect = "";
        vm.tempObj.referenceNumberInput = number.substring(2);
      }
    };

    vm.getAccountById = function (id) {
      return AccountsService.getAccountById(id)
        .then(function (response) {
          vm.account = response;
          vm.tempObj.fromAccountNumber = response.accountNumber;
          vm.tempObj.currencySymbol = response.currencySymbol;
        })
        .catch(function (error) {
          $log.error(error);
        })
    };

    var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    $rootScope.$on('appLanguageChangedHeader', function () {
      sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    });

    vm.deleteTemplate = function (template) {
      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            PaymentTemplatesService.deleteTemplate(template.id)
              .then(function (response) {
                AlertService.deletedPaymentAlert({paymentName: template.name, type: 'template'})
                  .then(function () {
                    vm.getPaymentTemplatesPage(true);
                  });
                vm.getPaymentTemplatesPage(true);
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });

    };

    vm.searchTemplate = function (searchrow) {

      vm.getPaymentTemplatesPage(true,searchrow);

      // return (angular.lowercase(searchrow.name).indexOf(angular.lowercase(vm.searchTemplateList) || '') !== -1 ||
      //         angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.searchTemplateList) || '') !== -1);
    };

    vm.loadMoreTemplates = function () {
      vm.getPaymentTemplatesPage(false);
    };

    vm.selectImage = function (image) {
      if (image) {
        vm.selectedImage = image;
      }
    };

    var prepareTemplateForUpdate = function (paymentObject) {
      $log.debug('Payment object', paymentObject);
      if (paymentObject.paymentTypeGroup === 'DomesticPayment' || paymentObject.paymentTypeGroup === 'SEPAPayment') {
        vm.tempObj.receiversNameInput = vm.payeeSearchFilter;
        if (vm.tempObj.receiversPostalCodeAndCityInput === '') {
          vm.tempObj.receiversPostalCodeAndCityInput = paymentObject.receiverCity;
        }
        if (vm.tempObj.receiversAddressInput === '') {
          vm.tempObj.receiversAddressInput = paymentObject.receiverAddress1;
        }
      }

      if (vm.tempObj.toAccountInput === '') {
        vm.tempObj.toAccountInput = paymentObject.toAccountNumber;
      }

      // reference model select not used in BiH environment
      if(vm.countryCode != 'bh'){
        if (vm.tempObj.referenceModelSelect) {
          if (vm.tempObj.referenceModelSelect === "  ") {
            vm.tempObj.referenceModelSelect = '00';
            vm.tempObj.referenceTo = vm.tempObj.referenceModelSelect + vm.tempObj.referenceNumberInput;
            vm.tempObj.referenceModelSelect = vm.referenceModelList[0];
          } else {
            vm.tempObj.referenceTo = vm.tempObj.referenceModelSelect.concat(vm.tempObj.referenceNumberInput);
          }
        } else if ((!vm.tempObj.referenceModelSelect) && (vm.tempObj.referenceNumberInput)) {
          vm.tempObj.referenceTo = '00' + vm.tempObj.referenceNumberInput;
        } else {
          vm.tempObj.referenceTo = '00';
        }

        if(vm.countryCode == 'sl') {
          vm.tempObj.referenceTo = vm.tempObj.referenceModelSelect + vm.referenceModelListSelect +  vm.tempObj.referenceNumberInput;
        }
      }

//ubaceno

      ////ZA CRO///
      if(vm.countryCode === 'hr' && vm.tempObj.referenceModelSelect === '99') {
        vm.tempObj.referenceTo = vm.tempObj.referenceModelSelect;
        vm.tempObj.referenceNumberInput = '';
      }

      var tempForUpdate = {
        name: vm.tempObj.templateName,
        accountId: paymentObject.accountId,
        fromAccountNumber: vm.tempObj.fromAccountNumber,
        toAccountNumber: vm.tempObj.toAccountInput,
        currencySymbol: vm.tempObj.currencySymbol,
        amount: HelperService.parseAmountInput(paymentObject.amount),
        paymentTypeGroup: paymentObject.paymentTypeGroup,
        purpose: vm.tempObj.purposeOfPaymentInput,
        purposeCodeDPS: vm.tempObj.purposeCodeSelect.id
      };

      /*      if(paymentObject.imageId){
       tempForUpdate.imageId = paymentObject.imageId;
       }*/

      if(vm.selectedImage.id){
        tempForUpdate.imageId = vm.selectedImage.id;
      }

      var subProperties = {
        receiverAddress1: vm.tempObj.receiversAddressInput,
        receiverName: vm.payeeSearchFilter
      };

      if(vm.countryCode !== 'bh') {
        subProperties.receiverCity = vm.tempObj.receiversPostalCodeAndCityInput;
        subProperties.senderName = paymentObject.senderName;
        subProperties.senderAddress1 = paymentObject.senderAddress1;
        subProperties.senderCity = paymentObject.senderCity;
        subProperties.referenceTo = vm.tempObj.referenceTo;
      } else {
        subProperties.reference = vm.tempObj.referenceNumberInput;
      }

      var sepaProperties = {
        debtorName: vm.tempObj.payersSepaInput1,
        debtorName2: vm.tempObj.payersSepaInput2,
        creditorName: vm.tempObj.receiversSepaInput1,
        creditorName2: vm.tempObj.receiversSepaInput2
      };



      switch (paymentObject.paymentTypeGroup) {
        case 'DomesticPayment':
        case 'SEPAPayment':
          tempForUpdate.domesticPayment = subProperties;
          if(vm.countryCode != 'bh') {
            tempForUpdate.sepaUpnIdentificators = sepaProperties;
          }
          if(vm.tempObj.beneficiarySWIFTCode && vm.countryCode == 'sl')
            tempForUpdate.beneficiarySWIFTCode = vm.tempObj.beneficiarySWIFTCode;
          break;
        case 'ForeignPayment':
          tempForUpdate.foreignPayment = subProperties;
          tempForUpdate.foreignPayment.beneficiaryBankName = vm.tempObj.bankNameInput;
          tempForUpdate.foreignPayment.beneficiaryBankAddress = vm.tempObj.bankAddressInput;
          tempForUpdate.foreignPayment.beneficiaryBankCity = vm.tempObj.bankCityInput;
          tempForUpdate.foreignPayment.beneficiarySWIFTCode = vm.tempObj.swiftCodeInput;
          tempForUpdate.foreignPayment.paymentCharges = vm.tempObj.bankChargesRadiobutton.type;
          tempForUpdate.foreignPayment.payeeLegalForm = vm.tempObj.recipientStatusRadiobutton.type;
          tempForUpdate.foreignPayment.receiverCountryCode = paymentObject.receiverCountryCode;
          tempForUpdate.foreignPayment.chargeAccount = vm.account.accountNumber + ' ' + vm.account.currencySymbol;
          tempForUpdate.foreignPayment.modalityCode = vm.tempObj.modalityCode;
          if(vm.tempObj.bankCountrySelect){
            tempForUpdate.foreignPayment.beneficiaryBankCountryCode = vm.tempObj.bankCountrySelect.code;
          }
          break;
        case "RevenuePayment":
          subProperties.taxPayerId = vm.tempObj.taxPayerId;
          subProperties.budgetOrganization = vm.tempObj.budgetOrganization;
          subProperties.municipality = vm.tempObj.municipality;
          subProperties.revenueCode = vm.tempObj.revenueCode;
          subProperties.paymentType = vm.tempObj.paymentType;
          subProperties.taxPeriodFrom = vm.tempObj.taxPeriodFrom;
          subProperties.taxPeriodTo = vm.tempObj.taxPeriodTo;
          subProperties.taxPeriodTo = vm.tempObj.taxPeriodTo;
          tempForUpdate.domesticPayment = subProperties;
          break;
      }
      return tempForUpdate;
    };

    vm.saveTemplate = function (template, index) {
      vm.tempObj.formSubmitted = true;
      if (!vm.templatesListForm.$valid) {
        return;
      }

      var templateForSaveObj = prepareTemplateForUpdate(template);
      console.log(JSON.stringify(templateForSaveObj));
      PaymentTemplatesService.updateTemplate(template.id, templateForSaveObj)
        .then(function (response) {
          //swal(templateUpdatedSuccessfully);
          //swal.collapse;
          AlertService.infoAlert({
            text: 'alert.updateTemplate'
          })
            .then(function (){
              template.editable = false;
              vm.getPaymentTemplatesPage(true);
              vm.updateResponse = response;
              clearAllFields();
            });
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.editTemplate = function (template) {
      _.forEach(vm.templateList.result, function (template) {
        template.editable = false;
      });
      template.editable = true;
      vm.currentTemplate = _.findWhere(vm.templateList.result, {id: template.id});
      populateEditableFields(vm.currentTemplate);

    };

    vm.cancel = function(template){
      template.editable = false;
      clearAllFields();
    };

    vm.checkInputChanges = function (group) {
      if (group === 'DomesticPayment') {
        if (!vm.tempObj.toAccountInput && !vm.tempObj.receiversPostalCodeAndCityInput && !vm.tempObj.receiversAddressInput && !vm.tempObj.receiversNameInput)
          vm.isEnabled = false;
        else
          vm.isEnabled = true;
      } else {
        if (!vm.tempObj.toAccountInput)
          vm.isEnabled = false;
        else
          vm.isEnabled = true;
      }
    };

    vm.searchPayee = function () {
      vm.searchFilterExpanded = true;
    };

    vm.removeSearch = function () {
      vm.payeeSearchFilter = '';
      vm.tempObj.toAccountInput = '';
      vm.tempObj.receiversAddressInput = '';
      vm.tempObj.receiversPostalCodeAndCityInput = '';
    };

    vm.searchPayeeBy = function (searchrow) {
      return (angular.lowercase(searchrow.receiverName).indexOf(angular.lowercase(vm.payeeSearchFilter) || '') !== -1 ||
      angular.lowercase(searchrow.toAccountNumber).indexOf(angular.lowercase(vm.payeeSearchFilter) || '') !== -1);
    };

    vm.toggleFilterSelection = function () {
      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    vm.selectPayee = function (id) {

      var payee = _.find(vm.payeeList, function (item) {
        return item.id == id;
      });

      if (payee) {
        vm.tempObj.toAccountInput = payee.toAccountNumber;
        vm.tempObj.receiversAddressInput = payee.receiverAddress1;
        vm.tempObj.receiversNameInput = payee.receiverName;
        vm.tempObj.receiversPostalCodeAndCityInput = payee.receiverCity;
        vm.payeeSearchFilter = payee.receiverName;
      }

      vm.searchFilterExpanded = !vm.searchFilterExpanded;
    };

    var fillReceiversInput = function (response) {
      if (response.result.length > 0) {
        vm.tempObj.receiversNameInput = response.result[0].receiverName;
        vm.payeeSearchFilter = response.result[0].receiverName;
        vm.tempObj.receiversAddressInput = response.result[0].receiverAddress1;
        vm.tempObj.receiversPostalCodeAndCityInput = response.result[0].receiverCity;
      }
    };

    vm.templateImagesFilter = {
      category: "Templates"
    };

    var loadImages = function () {
      return ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
        if(images)
          vm.images = images.result;
      }).catch(function (err) {
        $log.error(err);
      });
    };

    vm.fillReceiver = function (toAccountInput) {
      if (!toAccountInput) return;
      toAccountInput = toAccountInput.replace(/\s/g, '');
      if (toAccountInput.substring(0, 2) === 'HR') {
        CreditAccountRegisterService.getByIban(toAccountInput)
          .then(function (response) {
            fillReceiversInput(response);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      } else {
        CreditAccountRegisterService.getPage({
          accountNumber: toAccountInput
        })
          .then(function (response) {
            fillReceiversInput(response);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    var getPurposeCodesPage = function () {
      return PurposeCodesService.getPage(vm.purposeCodesFilter)
        .then(function (response) {
          _.forEach(response.result, function(item){
            item.optionValue = item.id + ' - ' + item.description;
          });
          vm.purposeCodesList = response;

          $log.debug("purposeCodesList", vm.purposeCodesList);
        })
        .catch(function () {
          $log.error('Error loading purpose codes!');
        });
    };

    //var getDefaultData = function () {
    //  return ConfigEndpointService.getDefaultData()
    //    .then(function (response) {
    //    if (response.APILocation) {
    //      $localStorage.code = response.APILocation;
    //      vm.countryCode = $localStorage.code;
    //      setInputMasks();
    //    }
    //  })
    //    .catch(function (error) {
    //    HelperService.showMessage(error, 'error');
    //  });
    //};

    var getPaymentModes = function () {
      return PaymentsService.getPaymentModes().then(function (response) {
        vm.paymentModeOptions = response.result;
      })
        .catch(function (err) {
          $log.error('Error loading bic banks codes!');
        });
    };

    var getCountries = function(){
      return CountriesService.getPage({pageSize: 1000}).then(function(response){
        vm.countriesOptions = response.result;
      }).catch(function(err){
        $log.error(err);
      });
    };

    var emptyReferenceModel = {
      description: " ",
      model: "  "
    };

    var getReferenceModels = function () {
      return ReferenceModelService.getPage(vm.referenceModelFilter)
        .then(function (response) {
          if(vm.countryCode && vm.countryCode !== 'hr' && vm.countryCode !== 'sl') {
            vm.referenceModelList.push(emptyReferenceModel.model);
          }
          _.forEach(response.result, function (value) {
            vm.referenceModelList.push(value.model);
          });
          vm.tempObj.referenceModelSelect = vm.referenceModelList[0];
        })
        .catch(function () {
          $log.error('Error loading bic banks codes!');
        });
    };

    var getDebitAccountList = function () {
      return PaymentTypesService.getByGroup({
        paymentTypeGroup: 'ForeignPayment'
      })
        .then(function (response) {
          if (_.isArray(response.result) && response.result.length > 0) {
            vm.accountsFrom = response.result[0].debitAccountList;
            // vm.chargeAccountOptions = _.where(vm.accountsFrom, {iban: item.iban});
            _.forEach(vm.accountsFrom, function (item) {
              if (item.accountDescription) {
                item.optionValue = item.accountDescription + ' - ' + item.iban;
              }
            });
          }
        })
        .catch(function (error) {
          $log.error(error);
        });
    };

    var clearAllFields = function () {
      vm.tempObj.receiversNameInput = '';
      vm.tempObj.receiversPostalCodeAndCityInput = '';
      vm.tempObj.receiversAddressInput = '';
      vm.tempObj.toAccountInput = '';

      // Foreign specific fields
      vm.countrySearchFilter = '';
      vm.bicCodeSearchFilter = '';
      vm.tempObj.swiftCodeInput = "";
      vm.tempObj.bankAddressInput = "";
      vm.tempObj.bankCityInput = "";
      vm.tempObj.bankNameInput = "";
    };

    vm.changePurpose = function (code) {
      var purposeCode = _.find(vm.purposeCodesList.result, function (item) {
        return item.id == code.id;
      });
      if (purposeCode && $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
        vm.tempObj.purposeOfPaymentInput = purposeCode.description;
      }
    };

    vm.onBicBankSelected = function (bicCode) {
      var bicBank = _.findWhere(vm.bicBankOptions, {bicCode: bicCode});
      vm.tempObj.swiftCodeInput = bicBank.bicCode;
      vm.tempObj.bankAddressInput = bicBank.branchInformation;
      vm.tempObj.bankCityInput = bicBank.city;
      vm.tempObj.bankNameInput = bicBank.institutionName;

      vm.bicCodeSearchFilter = bicBank.bicCode;
      vm.bicCodeSearchFilterExpanded = false;
    };

    vm.addSpaceForIban = function (toAccountInput) {
      if (!vm.tempObj.toAccountInput) return;
      vm.tempObj.toAccountInput = toAccountInput.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    };

    vm.getBicByIban = function (iban) {
      if (!iban) {
        return;
      }
      iban = iban.replace(/\s/g, '');
      PaymentsService.getBicBanks(undefined, {iban: iban})
        .then(function (response) {
          var bicBank = response.result[0];
          if (bicBank) {
            vm.bicCodeSearchFilter = bicBank.bicCode;
            vm.tempObj.swiftCodeInput = bicBank.bicCode;
            vm.tempObj.bankAddressInput = bicBank.branchInformation;
            vm.tempObj.bankCityInput = bicBank.city;
            vm.tempObj.bankNameInput = bicBank.institutionName;
          }
        }, function (error) {

        })
    };

    vm.searchBICNumber = function (bicInput) {
      vm.bicCodeSearchFilterExpanded = true;
      vm.tempObj.swiftCodeInput = bicInput;
      searchBicNumber(bicInput);
    };

    var searchBicNumber = function(bicInput) {
      PaymentsService.getBicBanks(undefined, {bicCode: bicInput})
        .then(function (response) {
          vm.bicBankOptions = response.result;
        }, function (error) {

        })
    };

    vm.removeBicCodeSearch = function () {
      vm.bicCodeSearchFilter = "";
      vm.tempObj.swiftCodeInput = "";
      vm.tempObj.bankAddressInput = "";
      vm.tempObj.bankCityInput = "";
      vm.tempObj.bankNameInput = "";
    };


    // Country selection

    vm.onCountrySelect = function (country) {
      vm.countrySearchFilter = country.code + " " + country.description;
      vm.tempObj.bankCountrySelect = country;
      vm.countrySearchFilterExpanded = false;
    };

    vm.removeSelectedCountry = function () {
      vm.countrySearchFilter = "";
      vm.tempObj.bankCountrySelect = {};
      vm.countrySearchFilterExpanded = true;
    };

    vm.setChargeAccount = function (item) {
      vm.tempObj.fromAccountSelect = item;
      vm.tempObj.chargeAccountInput = item;
      vm.chargeAccountOptions = _.where(vm.accountsFrom, {iban: item.iban});
    };

    var populateEditableFields = function (template) {

      vm.payeeList = _.filter(vm.templateList.result, function(item){
        return item.paymentTypeGroup === template.paymentTypeGroup;
      });

      if(template.referenceTo) {
        if(template.referenceTo.length > 2) {
          var i = template.referenceTo.substr(2);
          vm.tempObj.referenceModelSelect = template.referenceTo.substr(0,2);
          vm.tempObj.referenceNumberInput = i;
        } else {
          vm.tempObj.referenceModelSelect = template.referenceTo;
          vm.tempObj.referenceNumberInput = "";
        }
      }

      var index = _.findIndex(vm.referenceModelList, function (item) {
        return item === vm.tempObj.referenceModelSelect;
      });

      if(index != -1) {
        vm.tempObj.referenceModelSelect = vm.referenceModelList[index];
      } else {
        vm.tempObj.referenceModelSelect = vm.referenceModelList[0];
        vm.tempObj.referenceNumberInput = template.referenceTo;
      }

      vm.tempObj.toAccountInput = template.toAccountNumber;
      vm.tempObj.receiversAddressInput = template.receiverAddress1;
      vm.tempObj.receiversNameInput = template.receiverName;
      vm.tempObj.receiversPostalCodeAndCityInput = template.receiverCity;
      vm.tempObj.modalityCode = template.modalityCode;
      vm.tempObj.templateName = template.name;
      vm.tempObj.payersSepaInput1 = template.debtorName;
      vm.tempObj.payersSepaInput2 = template.debtorName2;
      vm.tempObj.receiversSepaInput1 = template.creditorName;
      vm.tempObj.receiversSepaInput2 = template.creditorName2;

      // Populate BIC fields from template
      if(template.paymentTypeGroup === 'ForeignPayment'){
        vm.tempObj.swiftCodeInput = template.beneficiarySWIFTCode;
        vm.bicCodeSearchFilter = template.beneficiarySWIFTCode;
        vm.tempObj.bankAddressInput = template.beneficiaryBankAddress;
        vm.tempObj.bankCityInput = template.beneficiaryBankCity;
        vm.tempObj.bankNameInput = template.beneficiaryBankName;
        vm.tempObj.bankChargesRadiobutton.type = template.paymentCharges || '3';
        vm.tempObj.recipientStatusRadiobutton.type = template.payeeLegalForm || '2';

        // vm.tempObj.chargeAccountInput = template.


        var country = _.findWhere(vm.countriesOptions, {code: template.beneficiaryBankCountryCode});
        if (country) {
          vm.countrySearchFilter = country.code + " " + country.description;
          vm.tempObj.bankCountrySelect = country;
        }
      }

      vm.payeeSearchFilter = template.receiverName;
      vm.searchFilterExpanded = false;
      // vm.searchTemplateFilterExpanded = false;

      if ((template.purposeCode || template.purposeCodeDPS) && vm.purposeCodesList.result) {
        var purposeCode;
        // Remove leading character from string
        if(template.purposeCodeDPS && vm.countryCode != 'bh') {
          var leading_char = template.purposeCodeDPS.substring(0, 1);
          if (template.purposeCodeDPS.length > 2 && leading_char === '2' || leading_char === '9') {
            template.purposeCodeDPS = template.purposeCodeDPS.substring(1);
            purposeCode = template.purposeCodeDPS;
          }
        } else if(template.purposeCodeDPS && vm.countryCode == 'bh') {
          purposeCode = template.purposeCodeDPS;
        } else {
          purposeCode = template.purposeCode;
        }

        var purpose = _.find(vm.purposeCodesList.result, function (purpose) {
          // In slovenia purpose code is returned in purposeCode property, but in croatia for example purposeCodeDPS is used
          return purpose.id == purposeCode;
        });
        if (purpose) {
          vm.tempObj.purposeCodeSelect = purpose;
          vm.tempObj.purposeOfPaymentInput = purpose.description;
        }
      } else {
        // add empty one
        vm.tempObj.purposeCodeSelect = vm.purposeCodesList.result[0];
      }

      if(vm.tempObj.purposeOfPaymentInput === '' || template.purpose !== vm.tempObj.purposeOfPaymentInput){
        vm.tempObj.purposeOfPaymentInput = template.purpose;
      }

      // Set selected template image
      if (template.imageId) {
        // Set selected image
        vm.selectedImage = {
          downloadLink: template.imageDownloadLink,
          id: template.imageId
        };
      }else{
        // If there was no image, set it to first from list (default image)
        if(vm.images && vm.images.length > 0){
          vm.selectedImage = {
            downloadLink: vm.images[0].imageDownloadLink,
            id: vm.images[0].id
          }
        }
      }

      if(template.beneficiarySWIFTCode){
        vm.tempObj.beneficiarySWIFTCode = template.beneficiarySWIFTCode;

      }

      if(vm.countryCode == 'bh'){
        vm.tempObj.referenceNumberInput = template.reference;
        if(template.paymentTypeGroup == "DomesticPayment"){
          vm.referenceMaxLength = 22;
          vm.referencePattern = vm.regexPatterns.onlyNumbersAndDashes;
          vm.tempObj.selectedRevenueAccount = '';
        }
      }

      // populate public revenue fields
      if(template.paymentTypeGroup == "RevenuePayment"){
        vm.tempObj.taxPayerId = template.taxPayerId;
        vm.tempObj.paymentType = template.paymentType || vm.tempObj.paymentTypes[0];
        vm.tempObj.revenueCode = template.revenueCode;
        vm.tempObj.municipality = template.municipality;
        vm.tempObj.taxPeriodFrom = new Date(template.taxPeriodFrom);
        vm.tempObj.taxPeriodTo = new Date(template.taxPeriodTo);
        vm.tempObj.budgetOrganization = template.budgetOrganization;
        vm.tempObj.selectedRevenueAccount = _.find(vm.revenueAccounts, function (item) {
          return vm.tempObj.toAccountInput == item.revenueAccountNumber;
        });
        vm.referenceMaxLength = 10;
        vm.referencePattern = vm.regexPatterns.onlyNumbers;

      }

      if(vm.countryCode == 'sl'){
        populateRefNumber(template.referenceTo);
        vm.getBicByIban2(vm.tempObj.toAccountInput);
      }



    };

    // related to Public Revenue
    function getMunicipalities () {
      PublicRevenueService.getMunicipalities({
        page: 0,
        pageSize: 1000
      })
        .then(function (response){
          vm.tempObj.municipalities = response.result;
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        });
    };

    function getRevenueCodes () {
      PublicRevenueService.getRevenueCodes({
        page: 0,
        pageSize: 1000
      })
        .then(function (response){
          vm.tempObj.revenueCodes = response.result;
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        })
    };

    function getBudgetOrganizations () {
      PublicRevenueService.getBudgetOrganizations({
        page: 0,
        pageSize: 1000
      })
        .then(function (response){
          vm.tempObj.budgetOrganizations = response.result;
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        })
    };

    // custom municipalities autocomplete
    vm.municipalityFilterExpanded = false;
    vm.openMunicipalities = function () {
      vm.municipalityFilterExpanded = true;
      validateMunicipalityExistance();
    };

    vm.toggleMunicipalities = function () {
      vm.municipalityFilterExpanded = !vm.municipalityFilterExpanded;
    };

    vm.removeMunicipalities = function () {
      vm.tempObj.municipality = '';
    };

    vm.selectMunicipality = function (municipality) {
      vm.tempObj.municipality = municipality.codeString;
      vm.municipalityFilterExpanded = false;
      validateMunicipalityExistance();
    };

    vm.filterMunicipalities = function (item) {
      return (angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempObj.municipality) || '') !== -1 ||
      angular.lowercase(item.codeString).indexOf(angular.lowercase(vm.tempObj.municipality) || '') !== -1);
    };

    // custom revenue type autocomplete
    vm.revenueCodeFilterExpanded = false;
    vm.openRevenueCodes = function () {
      vm.revenueCodeFilterExpanded = true;
      vm.tempObj.selectedRevenueCode = null;
      validateRevenueCodeExistance();
    };

    vm.toggleRevenueCodes = function () {
      vm.revenueCodeFilterExpanded = !vm.revenueCodeFilterExpanded;
    };

    vm.closeRevenueCodes = function () {
      vm.tempObj.revenueCode = '';
    };

    vm.selectRevenueCode = function (revenueCode) {
      vm.tempObj.revenueCode = revenueCode.code;
      vm.revenueCodeFilterExpanded = false;
      vm.tempObj.selectedRevenueCode = revenueCode;
      validateRevenueCodeExistance();
    };

    // fcn for filtering revenue codes
    vm.filterRevenueCodes = function (item) {
      return (angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempObj.revenueCode) || '') !== -1 ||
      angular.lowercase(item.code.toString()).indexOf(angular.lowercase(vm.tempObj.revenueCode) || '') !== -1);
    };

    // custom budget organizations autocomplete
    vm.budgetOrganizationFilterExpanded = false;
    vm.openBudgetOrganizations = function () {
      vm.budgetOrganizationFilterExpanded = true;
    };

    vm.toggleBudgetOrganizations = function () {
      vm.budgetOrganizationFilterExpanded = !vm.budgetOrganizationFilterExpanded;
    };

    vm.closeBudgetOrganization = function () {
      vm.tempObj.budgetOrganization = '';
    };

    vm.selectBudgetOrganization = function (budgetOrg) {
      vm.tempObj.budgetOrganization = budgetOrg.budgetOrganisationNumber;
      vm.budgetOrganizationFilterExpanded = false;
    };

    // fcn for filtering revenue codes
    vm.filterBudgetOrganizations = function (item) {
      return (angular.lowercase(item.budgetOrganisationNumber).indexOf(angular.lowercase(vm.tempObj.budgetOrganization) || '') !== -1 ||
      angular.lowercase(item.description).indexOf(angular.lowercase(vm.tempObj.budgetOrganization) || '') !== -1);
    };

    vm.taxPeriodFromOpened = false;
    vm.taxPeriodToOpened = false;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.openTaxPeriodFrom = function () {
      vm.taxPeriodFromOpened = true;
    };

    vm.openTaxPeriodTo = function () {
      vm.taxPeriodToOpened = true;
    };

    function getRevenueAccounts() {
      PublicRevenueService.getRevenueAccounts({
        page: 0,
        pageSize: 1000
      })
        .then(function (response) {
          vm.revenueAccounts = response.result;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.checkIsRevenueAccount = function () {
      //isRevenueAccount();
      validateRevenueCodeType();
    };

    //custom validation
    vm.validateTaxPeriod = function () {
      var isRangeValid = false;
      if (vm.tempObj.taxPeriodFrom <= vm.tempObj.taxPeriodTo) {
        isRangeValid = true;
      }
      vm.templatesListForm.taxPeriodFrom.$setValidity('taxPeriodRange', isRangeValid);
    };

    function checkIfMunicipalityExists() {
      var exists = _.find(vm.tempObj.municipalities, function (item) {
        return vm.tempObj.municipality == item.codeString;
      });
      if(exists){
        return true;
      }
      return false;
    };

    function validateMunicipalityExistance() {
      var exist = checkIfMunicipalityExists();
      if(!vm.tempObj.municipality){
        exist = true;
      }
      vm.templatesListForm.municipalityFilter.$setValidity('municipalityExistance', exist);
    };

    function checkIfRevenueCodeExists() {
      var exists = _.find(vm.tempObj.revenueCodes, function (item) {
        return vm.tempObj.revenueCode == item.code;
      });
      if (exists) {
        return true;
      }
      return false;
    };

    function validateRevenueCodeExistance() {
      var exist = checkIfRevenueCodeExists();
      if (!vm.tempObj.revenueCode) {
        exist = true;
      }
      vm.templatesListForm.revenueCodeFilter.$setValidity('revenueCodeExistance', exist);
    };

    function validateRevenueCodeType() {
      if (vm.tempObj.selectedRevenueAccount) {
        var correctRevenueCode = false;
        if (vm.tempObj.revenueCode === '000000') {
          correctRevenueCode = true;
        } else {
          var revenueCode = _.find(vm.tempObj.revenueCodes, function (item) {
            return vm.tempObj.revenueCode == item.code;
          });
          if (revenueCode) {
            var equalityCriteria = vm.tempObj.selectedRevenueCode ? vm.tempObj.selectedRevenueCode : revenueCode;
            if (vm.tempObj.selectedRevenueAccount.revenueType === equalityCriteria.type) {
              correctRevenueCode = true;
            }
          }
        }
        if (!vm.tempObj.revenueCode) {
          correctRevenueCode = true;
        }
        if (vm.templatesListForm.revenueCodeFilter) {
          vm.templatesListForm.revenueCodeFilter.$setValidity('revenueCodeType', correctRevenueCode);
        }
      }
    };

    // validation of reference number BiH environment

    vm.completeReferenceNumber = function () {
      if (vm.tempObj.selectedRevenueAccount && !vm.templatesListForm.referenceNumberInput.$valid) {
        if(!vm.tempObj.referenceNumberInput){
          vm.tempObj.referenceNumberInput = '';
        }
        var refLength = vm.tempObj.referenceNumberInput.length;
        var zeros = '';
        if (refLength < 10) {
          for (var i = 0; i < (10 - refLength); i++) {
            zeros += '0';
          }
        }
        vm.tempObj.referenceNumberInput = zeros + vm.tempObj.referenceNumberInput;
      }
    };

    vm.validateReferenceNumber = function () {
      var requiredReference = true;
      if (vm.tempObj.selectedRevenueAccount && (vm.tempObj.selectedRevenueAccount.revenueType == '92' || vm.tempObj.selectedRevenueAccount.revenueType == '91')) {
        requiredReference = vm.tempObj.referenceNumberInput ? true : false;
      }
      vm.templatesListForm.referenceNumberInput.$setValidity('referenceNumberRequired', requiredReference);
    };

    vm.checkReferenceNumber = function () {
      var allZeros = false;
      if (vm.tempObj.referenceNumberInput) {
        allZeros = true;
        for (var i = 0; i < vm.tempObj.referenceNumberInput.length; i++) {
          if (vm.tempObj.referenceNumberInput[i] != '0') {
            allZeros = false;
            break;
          }
        }
      }
      vm.templatesListForm.referenceNumberInput.$setValidity('validReferenceNumber', !allZeros);
    };

    vm.checkPurposeOfPaymentLength = function () {
      if (vm.tempObj.referenceModelSelect == "RF") {
        vm.referenceModelListSelect = '';
      }
      if (vm.tempObj.referenceModelSelect != "NRC") {
        vm.tempObj.purposeOfPaymentInput = vm.tempObj.purposeOfPaymentInput.substring(0, 34)
      }else{
        vm.tempObj.referenceNumberInput = '';
        vm.referenceModelListSelect = '';
      }

    };


    vm.getBicByIban2 = function (iban) {
      if (!iban) {
        return;
      }
      iban = iban.replace(/\s/g, '');
      PaymentsService.getBicBanks(undefined, {
        iban: iban
      })
        .then(function (response) {
          var bicBank = response.result[0];
          if (bicBank) {
            vm.tempObj.beneficiarySWIFTCode = bicBank.bicCode;
          }
        }, function (error) {

        })
    };

    vm.goToPayment = function (template) {
      var params = {
        templateId: template.id
      };
      if(template.paymentTypeGroup == 'DomesticPayment' || template.paymentTypeGroup == 'SEPAPayment' || template.paymentTypeGroup == 'LocalCurrencyTransfer')
        $state.go('payments.domesticPayment.fromTemplatesToPay', params)
      if(template.paymentTypeGroup == 'ForeignPayment')
        $state.go('payments.internationalPayment.fromTemplatesToPay', params)
    }
    vm.init();
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name paymentTemplates.controller:TemplateListOverviewCtrl
   *
   * @description
   *
   */
  TemplateListOverviewCtrl.$inject = ["$rootScope"];
  angular
    .module('paymentTemplates')
    .controller('TemplateListOverviewCtrl', TemplateListOverviewCtrl);

  function TemplateListOverviewCtrl($rootScope) {
    var vm = this;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name paymentTemplates.factory:PaymentTemplatesService
     *
     * @description
     *
     */
    PaymentTemplatesService.$inject = ["EndpointsService", "$q", "$http", "$log", "$uibModal", "$filter", "PaymentFilterService", "PaymentTypesService"];
    angular
        .module('paymentTemplates')
        .factory('PaymentTemplatesService', PaymentTemplatesService);

    function PaymentTemplatesService(EndpointsService, $q, $http, $log, $uibModal, $filter, PaymentFilterService, PaymentTypesService) {
        var PaymentTemplatesServiceBase = {};

        PaymentTemplatesServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            var predefinedParams = {
              orderBy: 'name ASC'
            };
            var extended = _.extend(predefinedParams, params);
            EndpointsService.getLinks().then(function (response) {
                $log.debug("Params:", extended);
                $http.get(response.links.paymentTemplates, {
                        params: extended
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        PaymentTemplatesServiceBase.getAll = function(params){
            var predefinedParams =
                {
                    page: 0
                    ,pageSize: 1000
                };
            var extended = _.extend(predefinedParams, params);
            return PaymentTemplatesServiceBase.getPage(extended);
        };

        PaymentTemplatesServiceBase.getById = function (id){
          var deferred = $q.defer();
          EndpointsService.getLinks().then(function (response) {
            $http.get(response.links.paymentTemplates_id.replace('{id}', id))
              .success(function (data) {
                deferred.resolve(data);
              }).error(function (msg, code) {
              deferred.reject(msg);
            });
          }, function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PaymentTemplatesServiceBase.openModal = function (paymentTemplate) {
          var modalInstance = $uibModal.open({
            templateUrl: 'payment-templates/payment-templates-modal.tpl.html',
            controller: 'PaymentTemplatesModalCtrl',
            controllerAs: 'paymentTemplatesModal',
            resolve: {
              paymentTemplate: function () {
                return paymentTemplate;
              }
            },
            backdrop: 'static'
          });
        };

      PaymentTemplatesServiceBase.insertTemplate = function (templateObject) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
            $http.post(response.links.paymentTemplates, templateObject)
              .success(function (data) {
                deferred.resolve(data);
              })
              .error(function (msg, code) {
                deferred.reject(msg)
              });
          },
          function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      PaymentTemplatesServiceBase.updateTemplate = function (id, updateObject) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
            $http.put(response.links.paymentTemplates_id.replace('{id}', id), updateObject)
              .success(function (data) {
                deferred.resolve(data);
              })
              .error(function (msg, code) {
                deferred.reject(msg)
              });
          },
          function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      PaymentTemplatesServiceBase.deleteTemplate = function (id) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
            $http.delete(response.links.paymentTemplates_id.replace('{id}', id))
              .success(function (data) {
                deferred.resolve(data);
              }).error(function (msg, code) {
              deferred.reject(msg);
            });
          },
          function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      PaymentTemplatesServiceBase.loadInternalTransferData = function (id, paymentObject, params) {
        return this.getById(id)
          .then(function (response) {
            paymentObject.amountInput = response.amount;
            //filterFromAccountSelect(response.accountId);
            //filterToAccountSelect(response.toAccountNumber);
            paymentObject.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.accountsFrom, response.accountId);
            params.toAccountList = PaymentFilterService.filterToAccountList(params.accountsFrom, paymentObject.fromAccountSelect.accountId);
            paymentObject.toAccountSelect = PaymentFilterService.filterToAccountSelect(params.toAccountList, response.toAccountNumber);
          })
          .catch(function (error) {
            $log.error("loadInternaTransferData()", error);
          })
      };

      PaymentTemplatesServiceBase.loadCurrencyConversionData = function (id, paymentObject, params) {
        //var filterToAccountSelect = function (accountNumber) {
        //  if (paymentObject.fromAccountSelect.currencySymbol != params.localCurrency) {
        //    params.accountsList = params.domesticCurrencyAccounts;
        //  } else {
        //    params.accountsList = params.foreignCurrencyAccounts;
        //  }
        //  paymentObject.toAccountSelect = PaymentFilterService.filterToAccountSelect(params.accountsList, accountNumber);
        //};
        function loadAccountsLists(accountId) {
          return PaymentTypesService.getByGroup({
              paymentTypeGroup: 'CurrencyExchange',
              masterAccountId: accountId
            })
            .then(function (response) {
              params.fromAccountsList = response.result[0].debitAccountList;
              params.toAccountsList = response.result[0].creditAccountList;
              _.forEach(params.fromAccountsList, function (item) {
                if (item.accountDescription) {
                  item.optionValue = item.iban + ' - ' + item.currencySymbol;
                }
              });

              _.forEach(params.toAccountsList, function (item) {
                if (item.accountDescription) {
                  item.optionValue = item.accountDescription + ' - ' + item.iban;
                }
              });
            })
            .catch(function (error) {
              $log.debug("Error loading accounts: " + error);
            })
        };
        return this.getById(id)
          .then(function (response) {
            return loadAccountsLists()
              .then(function () {
                paymentObject.sellCurrencyInput = response.currencySymbol;
                paymentObject.fromAccountAmountInput = response.amount;
                //filterFromAccountSelect(response.accountId);
                paymentObject.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountsList, response.accountId);
                paymentObject.sellCurrencyInput = paymentObject.fromAccountSelect.currencySymbol;
                //filterToAccountSelect(response.toAccountNumber.split(" ")[0]);
                paymentObject.toAccountSelect = PaymentFilterService.filterToAccountSelect(params.toAccountsList, response.toAccountNumber.split(" ")[0]);
                //filterBuyCurrencyInput();
                paymentObject.buyCurrencyInput = PaymentFilterService.filterBuyCurrencyInput(paymentObject.sellCurrencyInput, params.localCurrency, params.currencyList, paymentObject.toAccountSelect.currencySymbol);
              })
              .catch(function (error) {
                $log.error("Error: " + error);
              });
          })
          .catch(function (error) {

          });
      };

      PaymentTemplatesServiceBase.loadDomesticPaymentData = function (id, paymentObject, params) {
        return this.getById(id)
          .then(function (response) {
            //filterFromAccountSelect(response.accountId);
            paymentObject.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(params.fromAccountList, response.accountId);
            paymentObject.purposeOfPaymentInput = response.purpose;
            paymentObject.amountInput = $filter('number')(response.amount, 2);
            paymentObject.receiversAddressInput = response.receiverAddress1;
            response.urgency == 1 ? params.urgency = true : params.urgency = false;

            if(response.receiverCity){
              paymentObject.receiversPostalCodeAndCityInput = response.receiverCity;
            }
            paymentObject.toAccountInput = response.toAccountNumber;
            paymentObject.referenceNumberInput = response.referenceNumber || '';
            params.payeeSearchFilter = response.receiverName;
            if (response.purposeCodeDPS) {
              //filterPurposeCodeSelect(response.purposeCodeDPS);
              paymentObject.purposeCodeSelect = PaymentFilterService.filterPurposeCodeSelect(params.purposeCodeList, response.purposeCodeDPS);
            }
            if (response.referenceTo) {
              //filterReferenceModelSelect(response.referenceTo);
              paymentObject.referenceModelSelect = PaymentFilterService.filterReferenceModelSelect(params.referenceModelList, response.referenceTo);
              // in case of longer referenceTo load
              if(response.referenceTo.length > 2) {
                paymentObject.referenceNumberInput = response.referenceTo.substring(2);
              }
            } else if (response.reference) {
              paymentObject.referenceNumberInput = response.reference;
            }
            // in case of public revenue payment
            if(response.paymentTypeGroup == "RevenuePayment"){
              var paymentTypes = ["0", "1", "2", "3", "5", "6", "7", "8", "9"];
              paymentObject.budgetOrganization = response.budgetOrganization;
              paymentObject.municipality = response.municipality;
              paymentObject.paymentType = _.find(paymentTypes, function (item){
                return response.revenuePaymentType == item;
              });
              paymentObject.revenueCode = response.revenueCode;
              paymentObject.taxPayerId = response.taxPayerId;
              paymentObject.taxPeriodFrom = new Date(response.taxPeriodFrom);
              paymentObject.taxPeriodTo = new Date(response.taxPeriodTo);
            }
          })
          .catch(function (error) {
            $log.error('loadDomesticPaymentData()', error)
          })
      };

        return PaymentTemplatesServiceBase;
    }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('paymentTemplates')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('paymentTemplates', {
        url: '/payment-templates',
        templateUrl: 'payment-templates/payment-templates.tpl.html',
        controller: 'PaymentTemplatesCtrl',
        controllerAs: 'paymentTemplates'
      })
      .state('paymentTemplates.templateListOverview', {
        url: '/template-list-overview',
        views: {
          '@': {
            templateUrl: 'payment-templates/template-list-overview.tpl.html',
            controller: 'TemplateListOverviewCtrl',
            controllerAs: 'templateListOverview'
          }
        }
      })
      .state('paymentTemplates.saveTemplate', {
        url: '/:paymentId/:type/save-template',
        params: {
          paymentObject: null,
          type: 'other'
        },
        views: {
          '@': {
            templateUrl: 'payment-templates/payment-new-template.tpl.html',
            controller: 'PaymentNewTemplateCtrl',
            controllerAs: 'newTemplate'
          }
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name paymentTemplates.controller:PaymentTemplatesModalCtrl
   *
   * @description
   *
   */
  PaymentTemplatesModalCtrl.$inject = ["paymentTemplate", "$log", "AccountsService", "$uibModalInstance", "$filter", "PaymentTypesService", "PaymentsService", "HelperService", "$state", "PaymentTemplatesService"];
  angular
    .module('paymentTemplates')
    .controller('PaymentTemplatesModalCtrl', PaymentTemplatesModalCtrl);

  function PaymentTemplatesModalCtrl(paymentTemplate, $log, AccountsService,
                                     $uibModalInstance, $filter, PaymentTypesService, PaymentsService, HelperService,
                                     $state, PaymentTemplatesService) {
    var vm = this;
    vm.validDate = true;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.signSuccess = false;

    if (paymentTemplate.amount) {
      paymentTemplate.amount = $filter('number')(paymentTemplate.amount, 2);
    } else {
      paymentTemplate.amount = $filter('number')(0, 2)
    }

    vm.paymentObject = paymentTemplate;
    vm.paymentObject.dueDate = new Date();
    vm.datePickerOpened = false;

    vm.init = function () {
      if (paymentTemplate.accountId) {
        vm.loadUsersAccount();
      }
      if (paymentTemplate.formType) {
        vm.getPaymentTypeById(paymentTemplate.formType);
      }
    };

    vm.getPaymentTypeById = function (id) {
      PaymentTypesService.getById(id)
        .then(function(response){
            vm.paymentObject.paymentTypeGroup = response.paymentTypeGroup;
        })
        .catch(function(error){
          $log.error(error);
        });
    };

    vm.loadUsersAccount = function () {
      AccountsService.getAccountById(paymentTemplate.accountId)
        .then(function (response) {
          vm.paymentObject.fromAccount = response.accountDescription;
          vm.paymentObject.fromAccountNumber = response.iban;
          vm.paymentObject.accountCurrency = response.currencySymbol;
          vm.paymentObject.senderName = response.ownerName;
          vm.paymentObject.senderAddress1 = response.ownerAddress;
          vm.paymentObject.senderCity = response.ownerCity;
        })
        .catch(function () {
          $log.error('Error loading account');
        })
    };

    vm.executePayment = function () {
      vm.validDate = HelperService.validatePaymentDate(vm.paymentObject.dueDate);
      if (!vm.validDate || !vm.templateForm.$valid) {
        return;
      }

      var paymentObject = createPaymentObject();
      PaymentsService.insertPayment(paymentObject)
        .then(function (response) {
          vm.paymentResponse = response;
          vm.paymentResponse.paymentTypeGroup = paymentObject.paymentTypeGroup;
          vm.paymentResponse.senderInfo = {
            senderName: vm.paymentObject.senderName,
            senderAddress1: vm.paymentObject.senderAddress1,
            senderCity: vm.paymentObject.senderCity
          };
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    var createPaymentObject = function () {
      var objForInsert = {
        accountId: vm.paymentObject.accountId,
        fromAccountNumber: vm.paymentObject.fromAccountNumber,
        toAccountNumber: vm.paymentObject.toAccountNumber,
        currencySymbol: vm.paymentObject.accountCurrency,
        purpose: vm.paymentObject.purpose,
        dueDate: vm.paymentObject.dueDate,
        amount: HelperService.parseAmountInput(vm.paymentObject.amount),
        paymentTypeGroup: vm.paymentObject.paymentTypeGroup
      };

      var subProperties = {
        receiverName: vm.paymentObject.payeeName,
        receiverAddress1: vm.paymentObject.payeeAddress1,
        receiverCity: vm.paymentObject.payeeCity,
        reference: '99',
        referenceFrom: '99',
        senderName: vm.paymentObject.senderName,
        senderAddress1: vm.paymentObject.senderAddress1,
        senderCity: vm.paymentObject.senderCity
      };

      switch (vm.paymentObject.paymentTypeGroup) {
        case "DomesticPayment":
          objForInsert.domesticPayment = subProperties;
          break;
        case "ForeignPayment":
          objForInsert.foreignPayment = subProperties;
          break;
      }
      return objForInsert;
    };

    vm.signPayment = function () {
      PaymentsService.signPayment(vm.paymentResponse.id)
        .then(function (response) {
          vm.signSuccess = true;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.deleteTemplate = function () {
      PaymentTemplatesService.deleteTemplate(vm.paymentObject.id)
        .then(function (response) {
          swal('Success!', 'Payment template deleted succesfully!');
          vm.closeModal();
          $state.reload('payments');
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.saveTemplate = function () {
      var templateForSaveObj = prepareTemplateForUpdate();
      PaymentTemplatesService.updateTemplate(vm.paymentObject.id, templateForSaveObj)
        .then(function (response) {
          swal('Success!', "Template updated successfully!");
          vm.closeModal();
          $state.reload();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    var prepareTemplateForUpdate = function () {
      $log.debug('Payment object', vm.paymentObject);
      var tempForUpdate = {
        name: vm.paymentObject.name,
        accountId: vm.paymentObject.accountId,
        fromAccountNumber: vm.paymentObject.fromAccountNumber,
        toAccountNumber: vm.paymentObject.toAccountNumber,
        dueDate: new Date(vm.paymentObject.dueDate),
        currencySymbol: vm.paymentObject.accountCurrency,
        amount: HelperService.parseAmountInput(vm.paymentObject.amount),
        paymentTypeGroup: vm.paymentObject.paymentTypeGroup,
        purpose: vm.paymentObject.purpose
      };

      var subProperties = {
        receiverName: vm.paymentObject.payeeName,
        receiverAddress1: vm.paymentObject.payeeAddress1,
        receiverCity: vm.paymentObject.payeeCity,
        senderName: vm.paymentObject.senderName,
        senderAddress1: vm.paymentObject.senderAddress1,
        senderCity: vm.paymentObject.senderCity,
        reference: '99',
        referenceFrom: '99'
      };

      switch (vm.paymentObject.paymentTypeGroup) {
        case 'DomesticPayment':
          tempForUpdate.domesticPayment = subProperties;
          break;
      }
      return tempForUpdate;
    };

    vm.navigateToFullPaymentsForm = function () {
      var navigateTo = '';
      vm.closeModal();
      switch (vm.paymentObject.paymentTypeGroup) {
        case "DomesticPayment":
          navigateTo = 'payments.domesticPayment';
          break;
        case "LocalCurrencyTransfer":
          navigateTo = 'payments.internalTransfer';
          break;
        case "ForeignPayment":
          navigateTo = 'payments.internationalPayment';
          break;
        case "CurrencyExchange":
          navigateTo = 'payments.currencyConversion';
          break;
      };
      $state.go(navigateTo, {templateId: vm.paymentObject.id});
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name paymentTemplates.controller:PaymentTemplatesCtrl
   *
   * @description
   *
   */
  angular
    .module('paymentTemplates')
    .controller('PaymentTemplatesCtrl', PaymentTemplatesCtrl);

  function PaymentTemplatesCtrl() {
    var vm = this;
    vm.ctrlName = 'PaymentTemplatesCtrl';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name paymentTemplates.controller:PaymentNewTemplateCtrl
   *
   * @description
   *
   */
  PaymentNewTemplateCtrl.$inject = ["$rootScope", "$state", "$log", "PaymentsService", "PaymentTemplatesService", "ImagesService", "HelperService", "$translate", "AlertService", "GoogleTagManagerHelperService"];
  angular
    .module('paymentTemplates')
    .controller('PaymentNewTemplateCtrl', PaymentNewTemplateCtrl);

  function PaymentNewTemplateCtrl($rootScope, $state, $log, PaymentsService, PaymentTemplatesService, ImagesService, HelperService,
                                   $translate, AlertService, GoogleTagManagerHelperService) {
    var vm = this;

    vm.init = function () {

      vm.paymentType = $state.params.type;
      vm.templateNameInput = '';
      vm.selectedImage = {};
      vm.templateImagesFilter = {
        category: "Templates"
      };
      vm.countryCode =  $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

      loadImages();

      if ($state.params.paymentObject) {
        vm.paymentObject = $state.params.paymentObject;
      } else {
        if ($state.params.paymentId) {
          loadPayment($state.params.paymentId);
        }
      }

    };

    var loadImages = function () {
      ImagesService.getImages(vm.templateImagesFilter).then(function (images) {
        console.log(JSON.stringify(images));
        if(images){
          vm.images = images.result;

          // Set selected image as default image (first from list)
          vm.selectedImage = vm.images[0];

        }
      }).catch(function (err) {
        $log.error(err);
      });
    };

    var loadPayment = function (paymentId) {
      if (paymentId) {
        if(vm.countryCode === 'bh') {
          PaymentsService.getById(paymentId, {includeList: ['RevenuePaymentDetails']}).then(function (payment) {
            vm.paymentObject = payment;
          }).catch(function (error) {
            $log.error(error);
          });
        } else {
          PaymentsService.getById(paymentId).then(function (payment) {
            vm.paymentObject = payment;
          }).catch(function (error) {
            $log.error(error);
          });
        }
      }
    };

    vm.selectImage = function (image) {
      if (image) {
        vm.selectedImage = image;
      }
    };

    vm.saveAsTemplate = function () {
      /*      if (!vm.templateForm.$valid) {
       return;
       }*/

      if(!vm.formSubmitted){
        vm.formSubmitted = true;
        var objectForInsert = prepareObjectForInsert();
        console.log(JSON.stringify(objectForInsert));

        PaymentTemplatesService.insertTemplate(objectForInsert)
          .then(function (response) {
            vm.formSubmitted = false;
            $log.debug("Insert payment template response", response);
            //$state.go('paymentTemplates.templateListOverview');
            //var title = $translate.instant('payments.templateSavedSuccessfully');
            //swal(title);
            AlertService.infoAlert({
              text: 'alert.saveTemplate'
            })
              .then(function (){
                $state.go('paymentTemplates.templateListOverview');
              })

            GoogleTagManagerHelperService.pushEvent('NewTemplate', 'SaveNewTemplate', $translate.instant("alert.saveTemplate"));

          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
            vm.formSubmitted = false;
          });
      }
    };

    var prepareObjectForInsert = function () {
      var objForInsert = {
        name: vm.templateNameInput,
        accountId: vm.paymentObject.accountId,
        fromAccountNumber: vm.paymentObject.fromAccountNumber,
        toAccountNumber: vm.paymentObject.toAccountNumber,
        amount: vm.paymentObject.amount,
        currencySymbol: vm.paymentObject.currencySymbol,
        purpose: vm.paymentObject.purpose,
        paymentTypeGroup: vm.paymentObject.paymentTypeGroup,
        purposeCodeDPS: vm.paymentObject.purposeCodeDPS
      };

      if(!_.isEmpty(vm.selectedImage)){
        objForInsert.imageId = vm.selectedImage.id;
      }

      var subProperties = {
        receiverName: vm.paymentObject.receiverName,
        receiverAddress1: vm.paymentObject.receiverAddress1,
        receiverCity: vm.paymentObject.receiverCity,
        destinationCurrencySymbol: vm.paymentObject.destinationCurrencySymbol
      };

      if(vm.countryCode != 'bh') {
        subProperties.referenceFrom = vm.paymentObject.referenceFrom || '99';
      }

      var sepaProperties = {};
      if (vm.paymentObject.debtorName || vm.paymentObject.sepaUpnIdentificators) sepaProperties.debtorName = vm.paymentObject.debtorName || vm.paymentObject.sepaUpnIdentificators.debtorName;
      if (vm.paymentObject.debtorName2 || vm.paymentObject.sepaUpnIdentificators) sepaProperties.debtorName2 = vm.paymentObject.debtorName2 || vm.paymentObject.sepaUpnIdentificators.debtorName2;
      if (vm.paymentObject.creditorName || vm.paymentObject.sepaUpnIdentificators) sepaProperties.creditorName = vm.paymentObject.creditorName || vm.paymentObject.sepaUpnIdentificators.creditorName;
      if (vm.paymentObject.creditorName2 || vm.paymentObject.sepaUpnIdentificators) sepaProperties.creditorName2 = vm.paymentObject.creditorName2 || vm.paymentObject.sepaUpnIdentificators.creditorName2;

      var toAccount = vm.paymentObject.toAccountNumber.split(" ");

      if (vm.paymentObject.referenceTo) {
        subProperties.referenceTo = vm.paymentObject.referenceTo || '99';
      }

      if (vm.paymentObject.senderInfo) {
        subProperties.senderName = vm.paymentObject.senderInfo.senderName;
        subProperties.senderAddress1 = vm.paymentObject.senderInfo.senderAddress1;
        subProperties.senderCity = vm.paymentObject.senderInfo.senderCity;
      }
      switch (vm.paymentObject.paymentTypeGroup) {
        case "DomesticPayment":
        case "SEPAPayment":

            objForInsert.domesticPayment = subProperties;
            if(vm.countryCode != 'bh') {
              objForInsert.sepaUpnIdentificators = sepaProperties;
            }


          break;
        case "ForeignPayment":
          objForInsert.foreignPayment = subProperties;
          objForInsert.foreignPayment.beneficiaryBankName = vm.paymentObject.beneficiaryBankName;
          objForInsert.foreignPayment.beneficiaryBankAddress = vm.paymentObject.beneficiaryBankAddress;
          objForInsert.foreignPayment.beneficiaryBankCity = vm.paymentObject.beneficiaryBankCity;
          objForInsert.foreignPayment.beneficiarySWIFTCode = vm.paymentObject.beneficiarySWIFTCode;
          objForInsert.foreignPayment.beneficiaryBankCountryCode = vm.paymentObject.beneficiaryBankCountryCode;
          objForInsert.foreignPayment.receiverCountryCode = vm.paymentObject.receiverCountryCode;
          objForInsert.foreignPayment.paymentCharges = vm.paymentObject.paymentCharges;
          objForInsert.foreignPayment.payeeLegalForm = vm.paymentObject.payeeLegalForm;
          objForInsert.foreignPayment.chargeAccount = vm.paymentObject.chargeAccount;
          objForInsert.foreignPayment.reference = vm.paymentObject.referenceNumber;
          objForInsert.foreignPayment.modalityCode = vm.paymentObject.modalityCode;
          //   objForInsert.foreignPayment.paymentType = vm.paymentObject.formType;
          break;
        case "CurrencyExchange":
          objForInsert.currencyExchange = subProperties;
          if(toAccount[0]){
            objForInsert.toAccountNumber = toAccount[0];
          }
              break;
        case "RevenuePayment":
          subProperties.budgetOrganization = vm.paymentObject.revenuePaymentDetails.budgetOrganization;
          subProperties.municipality = vm.paymentObject.revenuePaymentDetails.municipality;
          subProperties.priority = vm.paymentObject.revenuePaymentDetails.priority;
          subProperties.revenueCode = vm.paymentObject.revenuePaymentDetails.revenueCode;
          subProperties.taxPayerId = vm.paymentObject.revenuePaymentDetails.taxPayerId;
          subProperties.taxPeriodFrom = new Date(vm.paymentObject.revenuePaymentDetails.taxPeriodFrom);
          subProperties.taxPeriodTo = new Date(vm.paymentObject.revenuePaymentDetails.taxPeriodTo);
          if(vm.paymentObject.revenuePaymentDetails.reference) {
            subProperties.reference = vm.paymentObject.revenuePaymentDetails.reference;
          }
          objForInsert.domesticPayment = subProperties;
          break;
      }
      return objForInsert;
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name orders
   * @description
   *
   */
  angular
    .module('orders', [
      'ui.router'
    ]);
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name orders.controller:TermDepositCtrlSlo
     *
     * @description
     *
     */
    TermDepositCtrlSlo.$inject = ["$state", "$rootScope", "AccountsService", "$log", "$q", "DepositOrderTypesService", "CurrencyService", "$scope", "$timeout", "DepositOrdersService", "HelperService", "$translate", "$filter", "ConfigEndpointService", "$window", "ValidationService", "UserSettingsService", "AlertService", "$localStorage", "GoogleTagManagerHelperService"];
    angular
      .module('orders')
      .controller('TermDepositCtrlSlo', TermDepositCtrlSlo);

    function TermDepositCtrlSlo($state, $rootScope, AccountsService, $log, $q, DepositOrderTypesService, CurrencyService, $scope, $timeout, DepositOrdersService, HelperService,
                                $translate, $filter, ConfigEndpointService, $window, ValidationService, UserSettingsService, AlertService, $localStorage, GoogleTagManagerHelperService) {
      var vm = this;
      var selectedLanguage = $localStorage.appLanguage;
      var depositTypes = [];
      var accountsFrom = [];
      var daysBetweenMonths = 0;
      // Depozit Zlata Jesen - default
      vm.depositTypeGroup = 3;
      var depositFindParams = {
        currency: "",
        duration: "",
        interestPayout: ""
      };

      vm.dateOptions = {
        minDate: new Date()
      };

      vm.accountsFrom = {};
      vm.assignmentOfInterestisShown = true;
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
      vm.model = {
        depositType: "",
        fromAccountSelect: {},
        totalInterestRate: 0,
        maturityDate: new Date(),
        amount: "",
        currencyCode: "",
        assignmentRange: "",
        interestPayout: "",
        maturityInDays: ""
      };

      vm.responseModel = {};

      // For interestRange property
      var assignmentOfInterestOptionsEnglish = [
        {id: 1, value: "termDeposit.assignmentOfInterestAnnual", name: "Annual reporting"},
        {id: 2, value: "termDeposit.assignmentOfInterestAfter", name: "Report after maturity"}
      ];

      var assignmentOfInterestOptionsSlovenian = [
        {id: 1, value: "termDeposit.assignmentOfInterestAnnual", name: "Letno poročanje"},
        {id: 2, value: "termDeposit.assignmentOfInterestAfter", name: "Poročanje po poteku"}
      ];

      vm.assignmentOfInterestOptions = [
        {id: 1, value: "termDeposit.assignmentOfInterestAnnual"},
        {id: 2, value: "termDeposit.assignmentOfInterestAfter"}
      ];

      vm.assignmentOfInterestId = vm.assignmentOfInterestOptions[0].id;

      vm.steps = {
        step1: true,
        step2: false,
        step3: false
      };

      vm.disabled = function (date, mode) {
        return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
      };

      $rootScope.$on('$translateChangeEnd', function (evt, data) {
        selectedLanguage = data.language;
      });

      vm.interestPayoutOptions = [
        {
          id: 0,
          value: "termDeposit.interestPayoutMonthly",
          name: "Monthly"
        },
        {
          id: 1,
          value: "termDeposit.interestPayoutAfterMaturity",
          name: "After maturity"
        }
      ]
      vm.model.interestPayout = vm.interestPayoutOptions[1];

      // ===========
      // INITIALIZE
      // ===========
      init();
      function init() {
        loadData();
      };

      function loadData() {
        var promises = [];
        promises.push(DepositOrderTypesService.getAll({
          pageSize: 1000,
          includeList: ["depositOrderTypeCalculationList"],
          orderBy: "sortOrderId"
        }));
        promises.push(AccountsService.getDepositOrderAccounts({pageSize: 1000}));
        // promises.push(CurrencyService.getCurrencyPage({pageSize: 5000}));

        $q.all(promises)
          .then(function (responses) {
            // ==========
            // Request 1
            // ==========
            vm.depositOrderGroupOptions = _.groupBy(responses[0].result, 'groupDescription');
            // Select first by default
            for (var key in vm.depositOrderGroupOptions) {
              depositTypes = vm.depositOrderGroupOptions[key];
              vm.depositGroup = vm.depositOrderGroupOptions[key];
              break;
            }
            findAndSetMinPeriod(depositTypes);

            // ==========
            // Request 2
            // ==========
            var accounts = responses[1].result;
            accounts = _.filter(accounts, function (account) {
              return account.isOwn;
            })

            _.each(accounts, function (account) {
              accountsFrom.push(account);
              _.each(account.subAccountList, function (subAccount) {
                if (account.isOwn) subAccount.isOwn = true;
                if (subAccount.currencySymbol == "CHF" || subAccount.currencySymbol == "USD" || subAccount.currencySymbol == "GBP") accountsFrom.push(subAccount);
              })
            })

            vm.accountsFrom = accountsFrom;
            vm.setAccountFrom(vm.accountsFrom[0]);

            vm.onDepositGroupChange(vm.depositGroup);
            // findDeposit();
            vm.isPageLoaded = true;
          }, function (error) {
            console.log(error);
          })
      }

      // ========
      // VIEW
      // ========

      function findAndSetMinPeriod(depositTypes) {
        // Za Depozit Zlatna jesen i Addiko Rastuci - defaultno minimalni broj dana postaviti
        if (depositTypes[0].group != 2 && depositTypes[0].group != 3) {
          vm.model.maturityInDays = 365;
          return;
        }
        var minDurations = [];
        _.each(depositTypes, function (deposit) {
          minDurations.push(parseInt(deposit.depositOrderTypeCalculationList[0].periodFrom));
        })
        vm.model.maturityInDays = _.min(minDurations);
      }

      function findDeposit() {
        depositFindParams.currency = vm.model.currency;
        depositFindParams.interestPayout = vm.model.interestPayout.id;
        depositFindParams.duration = daysBetweenMonths;

        // Don't ask !!

        // First - Find deposits by currency
        var depositsByCurrency = _.filter(depositTypes, function (depositType) {
          return (depositType.currency == depositFindParams.currency);
        })
        if (depositsByCurrency.length) {
          vm.termDepositForm.amount.$setValidity("currency", true);
        } else {
          vm.termDepositForm.amount.$setValidity("currency", false);
        }

        // Then - find deposits by duration
        var depositsByDuration = _.filter(depositsByCurrency, function (depositType) {
          var minDuration = parseInt(depositType.depositOrderTypeCalculationList[0].periodFrom);
          var maxDuration = parseInt(depositType.depositOrderTypeCalculationList[0].periodTo);
          return (minDuration <= parseInt(depositFindParams.duration) && parseInt(depositFindParams.duration) <= maxDuration)
        })
        if (depositsByDuration.length) {
          vm.termDepositForm.maturityInDays.$setValidity("duration", true);
        } else {
          vm.termDepositForm.maturityInDays.$setValidity("duration", false);
        }

        // Hide duration error message if there are no deposits for selected currency
        if (!depositsByCurrency.length) {
          vm.termDepositDurationMessageShown = false;
        } else {
          vm.termDepositDurationMessageShown = true;
        }

        // Then - if theres multiple results filter by monthly release, if not select only 1
        var finalResult;
        // ako je na osnovi ostalih parametra moguč samo jedan tip depozita, koji ima monthlyRelease = 1, onda samo value "After maturity" je moguč u dropdownu;
        // ako su moguče depozit types, koji neki imaju monthlyRelease = 1 i neki monthlyRelease = 0, onda u dropdownu možeš birati "Monthly",  i  "After maturity";
        if (depositsByDuration.length > 1) {
          finalResult = _.find(depositsByDuration, function (depositType) {
            return (depositType.monthlyRelease == depositFindParams.interestPayout)
          })
          vm.interestPayoutDisabled = false;
        } else if (depositsByDuration.length == 1) {
          finalResult = depositsByDuration[0];
          // Select Interest payout for specific term deposit and disable selection of Ipayout (not needed)
          vm.model.interestPayout = _.findWhere(vm.interestPayoutOptions, {id: +finalResult.monthlyRelease});
          vm.interestPayoutDisabled = true;
        } else {
          vm.interestPayoutDisabled = false;
        }

        // Lock for deposit type
        if (vm.depositTypeGroup == 3) {
          vm.interestPayoutDisabled = true;
        }

        // Select deposit
        vm.model.depositType = finalResult;
        if (vm.model.depositType && vm.model.depositType.depositOrderTypeCalculationList) {
          vm.model.depositType.depositOrderTypeCalculationList = _.sortBy(vm.model.depositType.depositOrderTypeCalculationList, function (item) {
            return item.fromAmount;
          })
          vm.model.depositType.depositOrderTypeCalculationList = vm.model.depositType.depositOrderTypeCalculationList.reverse();
        }
        onDepositTypeChange(vm.model.depositType);
      }

      vm.setAccountFrom = function (item) {
        vm.model.fromAccountSelect = item;
        vm.model.currency = vm.model.fromAccountSelect.currencySymbol;
        // vm.depositsFilter.accountId = item.accountId;
        vm.fromAccountDropdown = false;
        vm.paymentsPeriodFilter(vm.selectedPeriod);
        // vm.getTimelineItemsGrouped(true);
        findDeposit();
      };

      vm.toggleFromAccount = function () {
        vm.fromAccountDropdown = !vm.fromAccountDropdown;
      };

      vm.onDepositGroupChange = function (depositGroup) {
        depositTypes = angular.copy(depositGroup);
        vm.depositTypeGroupName = depositGroup[0].groupDescription;
        vm.depositTypeGroup = depositGroup[0].group;
        findAndSetMinPeriod(depositTypes);
        if (vm.depositTypeGroup == 3) {
          // For groupDescription "DEPOZIT ZLATA JESEN", we only get monthlyRelease "1", so only 'After maturity" should be available in dropdown Interest payout.
          vm.model.interestPayout = vm.interestPayoutOptions[1];
          vm.interestPayoutDisabled = true;

          vm.accountsFrom = _.filter(accountsFrom, function (account) {
            return (account.currencySymbol == "EUR")
          })
          if (!_.findWhere(vm.accountsFrom, {accountId: vm.model.fromAccountSelect.accountId})) {
            vm.model.fromAccountSelect = vm.accountsFrom[0];
            vm.model.currency = vm.model.fromAccountSelect.currencySymbol;
            // vm.depositsFilter.accountId = vm.model.fromAccountSelect.accountId;
            vm.fromAccountDropdown = false;
          }
        } else if (vm.depositTypeGroup == 2) {
          vm.accountsFrom = _.filter(accountsFrom, function (account) {
            return (account.currencySymbol == "EUR")
          })
        } else {
          vm.accountsFrom = angular.copy(accountsFrom);
          vm.interestPayoutDisabled = false;
        }

        vm.calculateMaturityDateWithDays(vm.model.maturityInDays)
        findDeposit();
      }

      vm.onInterestPayoutChange = function () {
        findDeposit();
      }

      function onDepositTypeChange(depositType) {
        if (!depositType) {
          vm.assignmentOfInterestOptions = [
            {id: 1, value: "termDeposit.assignmentOfInterestAnnual"},
            {id: 2, value: "termDeposit.assignmentOfInterestAfter"}
          ];
          vm.model.assignmentOfInterest = vm.assignmentOfInterestOptions[0].id;
          vm.assignmentOfInterestisShown = true;
          vm.assignemntOfInterestIsDisabled = false;
          vm.durationReadonly = false;
          return;
        }

        // // "revewal" = "1" i ako ima, stavi input field za periodu na READ-ONLY i popuni ga sa value "periodFrom / 30", tako da dobije broj mjeseca.
        // if (depositType.renewal == 1) {
        //   vm.model.maturityInDays = depositType.depositOrderTypeCalculationList[0].periodFrom;
        //   vm.model.maturityInMonths = Math.round(depositType.depositOrderTypeCalculationList[0].periodFrom / 30);
        //   vm.durationReadonly = true;
        // } else {
        //   vm.durationReadonly = false;
        // }

        calculateInterestRate();
        vm.model.currencyCode = depositType.currencyCode;

        // K = 1
        // D = 2
        if (depositType.periodType == 1) {
          vm.assignmentOfInterestOptions = [
            {id: 2, value: "termDeposit.assignmentOfInterestAfter"}
          ];
          vm.assignmentOfInterestId = vm.assignmentOfInterestOptions[0].id;
          vm.assignmentOfInterestisShown = true;
          vm.assignemntOfInterestIsDisabled = true;
        }
        else if (depositType.periodType == 2) {
          vm.assignmentOfInterestOptions = [
            {id: 1, value: "termDeposit.assignmentOfInterestAnnual"},
            {id: 2, value: "termDeposit.assignmentOfInterestAfter"}
          ];
          vm.model.assignmentOfInterest = vm.assignmentOfInterestOptions[0].id;
          vm.assignmentOfInterestisShown = true;
          vm.assignemntOfInterestIsDisabled = false;
        } else if (!depositType.periodType) {
          vm.model.assignmentOfInterest = "";
          vm.assignmentOfInterestisShown = false;
          vm.assignemntOfInterestIsDisabled = false;
        }
        // validate amount
        vm.amountChanged(vm.model.amount);
      }

      vm.amountChanged = function (amount) {
        if (!amount) amount = 0;
        if (vm.model.depositType && (amount < parseInt(vm.model.depositType.minAmount))) {
          vm.model.totalInterestRate = 0;
          vm.termDepositForm.amount.$setValidity("minamount", false);
        } else {
          calculateInterestRate();
          vm.termDepositForm.amount.$setValidity("minamount", true);
        }
      }

      function calculateInterestRate() {
        if (!vm.model.depositType) {
          vm.model.totalInterestRate = 0;
          return;
        }
        var dl = angular.copy(vm.model.depositType.depositOrderTypeCalculationList);
        for (var i = 0; i < dl.length; i++) {
          var item = dl[i];
          // First one that is bigger than amount
          if (vm.model.amount >= item.fromAmount) {
            vm.model.totalInterestRate = item.interestRateString;
            break;
          } else {
            vm.model.totalInterestRate = 0;
          }
        }
      }

      vm.calculateMaturityDays = function (date) {
        vm.model.maturityInMonths = "";
        daysBetweenMonths = vm.model.maturityInDays = Math.round(( date - new Date()) / 86400000);
        findDeposit();
      }

      vm.calculateMaturityDate = function (durationInMonths) {
        if (!durationInMonths) {
          return;
        }
        if (durationInMonths.length > 3) return;

        // resetMaturityDateValidation();
        vm.model.maturityDate = HelperService.setCustomMonthPeriod(new Date(), parseInt(durationInMonths));
        daysBetweenMonths = Math.round(( vm.model.maturityDate - new Date()) / 86400000);
        vm.model.maturityInDays = daysBetweenMonths;
        findDeposit();
        // validateMaturityDate(daysBetweenMonths);
      }

      vm.calculateMaturityDateWithDays = function (durationInDays) {
        if (!durationInDays) {
          durationInDays = 0;
        }

        if (daysBetweenMonths != durationInDays) {
          vm.model.maturityInMonths = "";
        }

        if (durationInDays.length > 6) return;
        // resetMaturityDateValidation();
        daysBetweenMonths = durationInDays;
        vm.model.maturityDate = HelperService.setCustomMonthPeriodByDays(new Date, parseInt(durationInDays));
        findDeposit();
        // validateMaturityDate(durationInDays);
      }

      // function validateMaturityDate(daysBetweenMonths) {
      //   if (vm.minDurationInDays > parseInt(daysBetweenMonths)) {
      //     vm.termDepositForm.maturityInMonths.$setValidity("minvalue", false);
      //   } else {
      //     vm.termDepositForm.maturityInMonths.$setValidity("minvalue", true);
      //   }
      //
      //   if (daysBetweenMonths > parseInt(vm.maxDurationInDays)) {
      //     vm.termDepositForm.maturityInMonths.$setValidity("maxvalue", false);
      //   } else {
      //     vm.termDepositForm.maturityInMonths.$setValidity("maxvalue", true);
      //   }
      // }

      // function resetMaturityDateValidation() {
      //   vm.termDepositForm.maturityInMonths.$setValidity("minvalue", true);
      //   vm.termDepositForm.maturityInMonths.$setValidity("maxvalue", true);
      // }

      vm.showOrderDetails = function (term) {
        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != "sl") {
          term.selected = !term.selected;
          return;
        }
        if (!term.selected) {
          DepositOrdersService.getManualDepositOrdersById(term.id)
            .then(function (response) {
              angular.extend(term, response);
              term.translatedStatus = "orders." + term.status;
              term.payoutTypeTranslate = 'core.termDepositPayoutType.' + term.payoutType;
              term.selected = !term.selected;
            }, function (error) {
              console.log(error);
            });
        } else {
          term.selected = false;
        }
      };


      vm.loadAllAccountsTimeline = function () {
        vm.getTimelineItemsGrouped(true);
      };

      function createInsertObject() {
        // if (selectedLanguage == "en") {
        //   vm.model.interestRange = _.findWhere(assignmentOfInterestOptionsEnglish, {id: vm.assignmentOfInterestId});
        // } else if (selectedLanguage == "sl") {
        //   vm.model.interestRange = _.findWhere(assignmentOfInterestOptionsSlovenian, {id: vm.assignmentOfInterestId});
        // }
        vm.model.interestRange = _.findWhere(assignmentOfInterestOptionsSlovenian, {id: vm.assignmentOfInterestId});

        return {
          accountId: vm.model.fromAccountSelect.iban,
          amount: vm.model.amount,
          currencyCode: vm.model.currencyCode,
          depositType: vm.model.depositType.typeCode,
          maturityDate: vm.model.maturityDate,
          interestPayout: vm.model.interestPayout.id,
          termPeriod: vm.model.maturityInDays,
          interestRange: {
            id: vm.model.interestRange.name,
            description: vm.model.interestRange.name
          },
          // assignmentOfInterest: vm.model.assignmentOfInterest.id,

          depositNrOfExtensions: 0,
          jobPurpose: " ",
          isRenewal: "true"
        };
      }

      vm.next = function () {
        if(vm.nextButtonPressed) return;
        if (vm.termDepositForm.$invalid) {
          return;
        }
        vm.formSubmitted = true;

        vm.nextButtonPressed = true;
        DepositOrdersService.validateManualDepositOrder(createInsertObject()).then(function (response) {
          if (response.changedDate) {
            AlertService.confirmationAlert({text: "orders.maturityDateChangedErr"})
              .then(function (accept) {
                if (!accept) return;
                vm.model.maturityDate = new Date(response.maturityDate);
                vm.calculateMaturityDays(vm.model.maturityDate);
                vm.responseModel = angular.copy(vm.model);
                vm.steps = {
                  step1: false,
                  step2: true,
                  step3: false
                };
              })
          } else {
            vm.responseModel = angular.copy(vm.model);
            vm.steps = {
              step1: false,
              step2: true,
              step3: false
            };
          }

        }).catch(function (error) {
          // vm.calculateMaturityDate(vm.model.maturityInMonths);
          HelperService.showMessage(error, 'error');
        }).finally( function (error) {
          vm.nextButtonPressed = false;
        });
      };

      vm.confirm = function () {
        if (vm.confirmButtonPressed) return;
        vm.confirmButtonPressed = true;
        DepositOrdersService.insertManualDepositOrder(createInsertObject()).then(function (response) {
          vm.steps = {
            step1: false,
            step2: false,
            step3: true
          };
        }).catch(function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function () {
          vm.confirmButtonPressed = false;
        });
      }

      vm.back = function () {
        vm.steps = {
          step1: true,
          step2: false,
          step3: false
        };
      };

      vm.newTermDeposit = function () {
        $state.go("orders.termDeposit", {}, {reload: true});
      }


      // =========================
      // START Timeline settings
      // =========================

      vm.recompile = {
        timeline: true
      };
      vm.timelineListGrouped = {};

      vm.loadMoreTimelineItemsGrouped = function () {
        vm.getTimelineItemsGrouped(false);
      };

      var timeRange = HelperService.getDateRange('thisMonth');
      vm.selectedAccountId = '';
      vm.depositsFilter = {
        page: 0,
        orderBy: 'dateCreated DESC', //signDate
        pageSize: 15,
        signDateGTE: null,
        signDateLTE: null,
        accountId: null,
        userId: null,
      };

      vm.userSettingsFilter = {
        page: 0,
        pageSize: 1000
      };

      vm.periodList = [
        {
          item: {
            key: 'today',
            description: 'core.period.today'
          }
        }
        , {
          item: {
            key: 'yesterday',
            description: 'core.period.yesterday'
          }
        }
        , {
          item: {
            key: 'thisWeek',
            description: 'core.period.thisWeek'
          }
        }
        , {
          item: {
            key: 'thisMonth',
            description: 'core.period.thisMonth'
          }
        }
        , {
          item: {
            key: 'thisYear',
            description: 'core.period.thisYear'
          }
        }
        , {
          item: {
            key: 'all',
            description: 'core.period.all'
          }
        }
      ];

      vm.selectedPeriod = vm.periodList[3];

      vm.paymentsPeriodFilter = function (item) {
        vm.selectedPeriod = item;
        var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
        vm.depositsFilter.signDateGTE = timeRange.valueDateGTE;
        vm.depositsFilter.signDateLTE = timeRange.valueDateLTE;
        vm.getTimelineItemsGrouped(true);
        GoogleTagManagerHelperService.pushEvent('TermDeposit', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));

      };

      vm.togglePaymentDetails = function (payment) {
        payment.selected = !payment.selected;
      };

      var translatePaymentProperties = function (orders) {
        _.forEach(orders, function (item) {
          item.translatedStatus = "orders." + item.status;
          item.payoutTypeTranslate = 'core.termDepositPayoutType.' + item.payoutType;
        });
      };

      vm.getTimelineItemsGrouped = function (reset) {

        if (reset) {
          vm.depositsFilter.page = 0;
        } else {
          vm.depositsFilter.page += 1;
        }


        // if (vm.allRequests) {
        //   vm.depositsFilter.accountId = null;
        // } else {
        //   if (vm.model.fromAccountSelect)
        //     vm.depositsFilter.accountId = vm.model.fromAccountSelect.accountId;
        //
        // }

        //vm.depositsFilter.userId = vm.userSettings.id;

        DepositOrdersService.getManualDepositOrders(vm.depositsFilter)
          .then(function (response) {
            translatePaymentProperties(response.result);
            vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
              existingData: vm.timelineListGrouped,
              newData: response,
              groupFunction: function (item) {
                var date = new Date(item.dateCreated);
                // If we want to group only by date component, without hours
                date.setHours(0, 0, 0, 0);
                return date;
              },
              virtualRowFunction: function (e) {
                var month = new Date(e).getMonth() + 1;
                var day = new Date(e).getDate();
                var virtualRow = {
                  isVirtual: true,
                  valueDate: new Date(e),
                  month: month,
                  day: day
                };
                $log.debug("virtualRow", e, virtualRow);
                return virtualRow;
              },
              reset: reset,
              reverse: false
            });
            $log.debug("groupedEDespositOrdersTimeline", vm.timelineListGrouped);
            //alert(2);
            vm.recompile.timeline = true;
          }).catch(function (error) {
          $log.error(error);
        });
      };
      // =========================
      // END Timeline settings
      // =========================

      vm.downloadContract = function (id) {
        DepositOrdersService.downloadContract(id)
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }

      vm.downloadTermsAndConditions = function (id) {
        DepositOrdersService.downloadTermsAndConditions(id)
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }

    }
  }
  ()
)
;

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name orders.controller:TermDepositCtrlOther
     *
     * @description
     *
     */
    TermDepositCtrlOther.$inject = ["$state", "$rootScope", "AccountsService", "$log", "DepositOrderTypesService", "CurrencyService", "$scope", "$timeout", "DepositOrdersService", "HelperService", "$translate", "$filter", "ConfigEndpointService", "$window", "ValidationService", "UserSettingsService", "AlertService", "GoogleTagManagerHelperService", "$location"];
    angular
        .module('orders')
        .controller('TermDepositCtrlOther', TermDepositCtrlOther);

    function TermDepositCtrlOther($state, $rootScope, AccountsService, $log, DepositOrderTypesService, CurrencyService, $scope, $timeout, DepositOrdersService, HelperService,
        $translate, $filter, ConfigEndpointService, $window, ValidationService, UserSettingsService, AlertService, GoogleTagManagerHelperService, $location) {
        var vm = this;
        vm.ctrlName = 'TermDepositCtrlOther';
        vm.userSettings = {};
        vm.configData = {};
        vm.allRequests = false;
        vm.getConfigData = function () {
            ConfigEndpointService.getDefaultData()
                .then(function (response) {

                    vm.configData = response;

                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.openConditionsLink = function (url) {
            GoogleTagManagerHelperService.pushEvent('NewTermDeposit', 'ExternalLink', url);
            $window.open(url, "_blank");
        };

        vm.steps = {
            step1: true,
            step2: false,
            step3: false
        };

        // ---------------------------------- start of timeline settings
        vm.recompile = {
            timeline: true
        };
        vm.timelineListGrouped = {};

        vm.loadMoreTimelineItemsGrouped = function () {
            vm.getTimelineItemsGrouped(false);
        };

        var timeRange = HelperService.getDateRange('thisMonth');
        vm.selectedAccountId = '';
        vm.depositsFilter = {
            page: 0,
            orderBy: 'signDate DESC', //signDate
            pageSize: 15,
            signDateGTE: null,
            signDateLTE: null,
            accountId: null,
            userId: null,
        };

        vm.userSettingsFilter = {
            page: 0,
            pageSize: 1000
        };

        getUserSettingsPage();
        function getUserSettingsPage () {
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr') {
              vm.userSettingsFilter.includeList = 'UserDetailsList'
            }
            return UserSettingsService.getPage(vm.userSettingsFilter)
                .then(function (response) {
                    vm.userSettings = response.result[0];
                    init();
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };
        vm.tempTermDepositObj = {
            fromAccountSelect: {
                currencySymbol: "HRK"
            },
            interestRate: 0,
            stimulativeInterestRate: 0,
            totalInterestRate: 0,
            amount: '',
            currency: "HRK",


        };


        vm.periodList = [
            {
                item: {
                    key: 'today',
                    description: 'core.period.today'
                }
      }
      , {
                item: {
                    key: 'yesterday',
                    description: 'core.period.yesterday'
                }
      }
      , {
                item: {
                    key: 'thisWeek',
                    description: 'core.period.thisWeek'
                }
      }
      , {
                item: {
                    key: 'thisMonth',
                    description: 'core.period.thisMonth'
                }
      }
      , {
                item: {
                    key: 'thisYear',
                    description: 'core.period.thisYear'
                }
      }
      , {
                item: {
                    key: 'all',
                    description: 'core.period.all'
                }
      }
    ];

        vm.selectedPeriod = vm.periodList[5];

        vm.paymentsPeriodFilter = function (item) {
            vm.selectedPeriod = item;
            var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
            vm.depositsFilter.signDateGTE = timeRange.valueDateGTE;
            vm.depositsFilter.signDateLTE = timeRange.valueDateLTE;
            vm.getTimelineItemsGrouped(true);
            GoogleTagManagerHelperService.pushEvent('TermDeposit', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));
        }

        vm.togglePaymentDetails = function (payment) {
            payment.selected = !payment.selected;
        };
        vm.getTimelineItemsGrouped = function (reset) {

            if (reset) {
                vm.depositsFilter.page = 0;
            } else {
                vm.depositsFilter.page += 1;
            }


            if (vm.allRequests) {
                vm.depositsFilter.accountId = null;
            } else {
                if (vm.tempTermDepositObj.fromAccountSelect)
                    vm.depositsFilter.accountId = vm.tempTermDepositObj.fromAccountSelect.accountId;

            }

            //vm.depositsFilter.userId = vm.userSettings.id;

            DepositOrdersService.getPage(vm.depositsFilter)
                .then(function (response) {
                    translatePaymentProperties(response.result);
                    vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
                        existingData: vm.timelineListGrouped,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.signDate);
                            // If we want to group only by date component, without hours
                            date.setHours(0, 0, 0, 0);
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                valueDate: new Date(e),
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });

                    /*
                    var todayDateRange = HelperService.getTodayWithoutOffset();
                    var yesterdayDateRange = HelperService.getYesterdayWithoutOffset();


                    _.forEach(vm.timelineListGrouped.result, function (item) {
                      item.dateValue = new Date(item.date);
                      if (item.dateValue >= todayDateRange.firstDay && item.dateValue <= todayDateRange.lastDay) {
                        item.showText = true;
                        item.dateLabel = 'core.period.today';
                      }
                      else if (item.dateValue >= yesterdayDateRange.firstDay && item.dateValue < yesterdayDateRange.lastDay) {
                        item.showText = true;
                        item.dateLabel = 'core.period.yesterday';
                      }
                      else {
                        item.showDate = true;
                      }
                    });
                    */
                    $log.debug("groupedEDespositOrdersTimeline", vm.timelineListGrouped);
                    //alert(2);
                    vm.recompile.timeline = true;
                }).catch(function (error) {
                    $log.error(error);
                });
        };
        // ---------------------------------------------------  end of timeline settings

        vm.goBackToOrders = function () {
            $state.go('orders');
        };

        vm.accountsFrom = {};

        function init() {
            vm.contryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
            // getUserSettingsPage();
            vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
            CurrencyService.getCurrencyPage({
                pageSize: 5000
            }).then(function (response) {
                vm.currenciesList = response.result;

                vm.getTermDepositAccountsFrom();
                /*vm.getTimelineItemsGrouped(true);*/

            }).catch(function (error) {
                $log.error(error);
            });
            vm.getConfigData();

        };

        vm.depositOrderTypesFilter = {
            pageSize: 1000,
            includeList: ["depositOrderTypeCalculationList"]
        };

        vm.depositOrderTypesList = [];
        vm.maturityInMonthsList = [];

        vm.currenciesList = [];


        var getInterestRateByAmount = function (amount) {

            _.forEach(vm.tempTermDepositObj.maturityInMonths.depositOrderTypeCalculationList, function (calculationObject) {

                var fromAmount = 0;
                var toAmount = 999999999999999;
                if (vm.tempTermDepositObj.fromAccountSelect.currencyCode === calculationObject.currencyCode) {
                    if (calculationObject.fromAmount) {
                        fromAmount = calculationObject.fromAmount;
                    }
                    if (calculationObject.toAmount) {
                        toAmount = calculationObject.toAmount;
                    }

                    if (amount >= fromAmount && amount <= toAmount) {
                        vm.tempTermDepositObj.interestRate = calculationObject.interestRate;
                        vm.tempTermDepositObj.stimulativeInterestRate = vm.tempTermDepositObj.maturityInMonths.stimulInterestRate;
                      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr' && vm.userSettings.userDetailsList.length) {
                          var userDetailStimulInterestRate = _.filter(vm.userSettings.userDetailsList, function(item) {
                            return item.serviceId.toLowerCase() == "hyponet" && item.deleted.toLowerCase() == "n" && item.depositJobPurpose == vm.tempTermDepositObj.maturityInMonths.id;
                          });
                          if (userDetailStimulInterestRate.length && (userDetailStimulInterestRate[0].stimulInterestRate > vm.tempTermDepositObj.stimulativeInterestRate)) {
                            vm.tempTermDepositObj.stimulativeInterestRate = angular.copy(vm.userSettings.userDetailsList[0].stimulInterestRate);
                          }
                      }
                        vm.tempTermDepositObj.totalInterestRate = vm.tempTermDepositObj.stimulativeInterestRate + vm.tempTermDepositObj.interestRate;
                        vm.tempTermDepositObj.totalInterestRate = vm.tempTermDepositObj.totalInterestRate.toFixed(2);
                    }
                }
            });

        };

        var getTermDepositPayoutTypeList = function (periodObject) {
            var allowedPayoutTypesList = periodObject.payoutType.split(',');
            _.forEach(allowedPayoutTypesList, function (allowedPayoutTypes) {
                if (allowedPayoutTypes !== '3') {
                    var termDepositPayoutTypeCodebookIndex = _.findIndex(vm.termDepositPayoutTypeCodebook, function (o) {
                        return o.payoutType == allowedPayoutTypes;
                    });
                    if (allowedPayoutTypes == '2') {
                        vm.termDepositPayoutTypeList.unshift(vm.termDepositPayoutTypeCodebook[termDepositPayoutTypeCodebookIndex]);
                    } else {
                        vm.termDepositPayoutTypeList.push(vm.termDepositPayoutTypeCodebook[termDepositPayoutTypeCodebookIndex]);
                    }

                }
            });

            $log.debug("termDepositPayoutTypeList", vm.termDepositPayoutTypeList);
            vm.selectedTermDepositPayoutType = vm.termDepositPayoutTypeList[0];

            getInterestRateByAmount(vm.tempTermDepositObj.amount);

        };
        var getCurrencyCodeBySymbol = function (currencySymbol) {
            var currencyIndex = _.findIndex(vm.currenciesList, function (o) {
                return o.symbol == currencySymbol;
            });
            var currencyCode = vm.currenciesList[currencyIndex].code;
            return currencyCode;
        };

        var getPeriodsFromDepositOrderListByAccountCurrency = function (accountCurrencySymbol) {

            var currencyCode = getCurrencyCodeBySymbol(accountCurrencySymbol);

            _.forEach(vm.depositOrderTypesList, function (value) {
                var currenciesArray = value.currencyCode.split(',');
                _.forEach(currenciesArray, function (currency) {
                    if (currency === currencyCode) {
                        vm.maturityInMonthsList.push(value);
                    }

                });
            });

            $log.debug("maturityInMonthsList", vm.maturityInMonthsList);
            vm.tempTermDepositObj.maturityInMonths = vm.maturityInMonthsList[0];
            getTermDepositPayoutTypeList(vm.tempTermDepositObj.maturityInMonths);
        };

        vm.getDepositOrderTypes = function () {
            DepositOrderTypesService.getAll(vm.depositOrderTypesFilter)
                .then(function (response) {

                    _.forEach(response.result, function (value) {
                        if (value.typeCode === 2) {
                            vm.depositOrderTypesList.push(value);
                        }
                    });

                    getPeriodsFromDepositOrderListByAccountCurrency(vm.tempTermDepositObj.fromAccountSelect.currencySymbol);

                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.getTermDepositAccountsFrom = function () {
            AccountsService.getDepositOrderAccounts({
                    pageSize: 1000
                })
                .then(function (response) {
                    $log.debug("getTermDepositAccountsFrom", response);
                    if (_.isArray(response.result) && response.result.length > 0) {
                        vm.accountsFrom = response.result;
                        _.forEach(vm.accountsFrom, function (item) {
                            if (item.accountDescription) {
                                item.optionValue = item.accountDescription + ' - ' + item.iban;
                            }
                        });
                        vm.tempTermDepositObj.fromAccountSelect = response.result[0];
                        vm.tempTermDepositObj.currency = vm.tempTermDepositObj.fromAccountSelect.currencySymbol;


                        vm.getDepositOrderTypes();
                        vm.getTimelineItemsGrouped(true);
                    }


                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.showOrderDetails = function (term) {
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != "sl") {
                term.selected = !term.selected;
                return;
            }
            if (!term.selected) {
                DepositOrdersService.getById(term.id)
                    .then(function (response) {
                        angular.extend(term, response);
                        term.translatedStatus = "core.termDepositStatus." + term.status.toLowerCase();
                        term.payoutTypeTranslate = 'core.termDepositPayoutType.' + term.payoutType;
                        term.selected = !term.selected;
                    }, function (error) {
                        console.log(error);
                    });
            } else {
                term.selected = false;
            }
        };

        vm.fromAccountDropdown = false;
        vm.toggleFromAccount = function () {
            vm.fromAccountDropdown = !vm.fromAccountDropdown;
        };

        vm.setAccountFrom = function (item) {
            vm.tempTermDepositObj.fromAccountSelect = item;
            vm.depositsFilter.accountId = item.accountId;
            vm.getTimelineItemsGrouped(true);
            vm.toggleFromAccount();
        };
        vm.loadAllAccountsTimeline = function () {
            vm.getTimelineItemsGrouped(true);
        };
        vm.isPayoutTypeSelectionCollapsed = true;

        vm.selectPayoutType = function (item) {
            vm.selectedTermDepositPayoutType = item;
            vm.isPayoutTypeSelectionCollapsed = true;
        };

        vm.termDepositPayoutTypeList = [];
        vm.termDepositPayoutTypeCodebook = [
            {
                payoutType: 2,
                description: 'core.termDepositPayoutType.2',
                explanation: 'core.termDepositPayoutType.2e'

      }, {
                payoutType: 3,
                description: 'core.termDepositPayoutType.3',
                explanation: 'core.termDepositPayoutType.3e'

      }, {
                payoutType: 16,
                description: 'core.termDepositPayoutType.16',
                explanation: 'core.termDepositPayoutType.16e'
      }, {
                payoutType: 17,
                description: 'core.termDepositPayoutType.17',
                explanation: 'core.termDepositPayoutType.17e'

      }, {
                payoutType: 18,
                description: 'core.termDepositPayoutType.18',
                explanation: 'core.termDepositPayoutType.18e'

      }, {
                payoutType: 19,
                description: 'core.termDepositPayoutType.19',
                explanation: 'core.termDepositPayoutType.19e'

      }
    ];


        vm.getToday = function () {
            return new Date();
        };


        /*CHANGE EVENTS*/
        vm.changeCountFromAccountSelect = 0;
        $scope.$watch('termDeposit.tempTermDepositObj.fromAccountSelect', function (newValue) {
            vm.changeCountFromAccountSelect = vm.changeCountFromAccountSelect + 1
            $log.debug("changeCountFromAccountSelect", vm.changeCountFromAccountSelect);
            if (vm.changeCountFromAccountSelect >= 3) {
                vm.termDepositPayoutTypeList = [];
                vm.maturityInMonthsList = [];
                getPeriodsFromDepositOrderListByAccountCurrency(newValue.currencySymbol);
            }
        }, true);


        vm.changeCountmaturityInMonths = 0;
        $scope.$watch('termDeposit.tempTermDepositObj.maturityInMonths', function (newValue) {
          // vm.tempTermDepositObj.maturityInMonths = newValue;
          console.log("NEW VALUE" + newValue);
            vm.changeCountmaturityInMonths = vm.changeCountmaturityInMonths + 1
            $log.debug("changeCountmaturityInMonths", vm.changeCountmaturityInMonths);

            if (vm.changeCountmaturityInMonths >= 3) {
                vm.termDepositPayoutTypeList = [];
                getTermDepositPayoutTypeList(newValue);
            }
        }, true);

      // vm.maturityInMonthsChanged = function (newValue) {
      //   vm.tempTermDepositObj.maturityInMonths = newValue;
      //   vm.changeCountmaturityInMonths = vm.changeCountmaturityInMonths + 1
      //   $log.debug("changeCountmaturityInMonths", vm.changeCountmaturityInMonths);
      //
      //   if (vm.changeCountmaturityInMonths >= 3) {
      //     vm.termDepositPayoutTypeList = [];
      //     getTermDepositPayoutTypeList(newValue);
      //   }
      // };

        /*
        vm.changeCountAmount = 0;
        $scope.$watch('termDeposit.tempTermDepositObj.amount', function (newValue) {
            vm.changeCountAmount = vm.changeCountAmount + 1
            $log.debug("changeCountAmount", vm.changeCountAmount);

            if (newValue && newValue > 0) {
                getInterestRateByAmount(newValue);
            }
        }, true);
        */

        vm.amountChanged = function (newValue) {
            if (newValue && newValue > 0) {
                getInterestRateByAmount(newValue);
            }
        };

        var createInsertObject = function () {
            var insertObject = {
                "accountId": vm.tempTermDepositObj.fromAccountSelect.accountId,
                "currencyCode": getCurrencyCodeBySymbol(vm.tempTermDepositObj.fromAccountSelect.currencySymbol),
                "payoutType": vm.selectedTermDepositPayoutType.payoutType,
                "amount": vm.tempTermDepositObj.amount,
                "jobPurpose": vm.tempTermDepositObj.maturityInMonths.id,
                "termPeriod": vm.tempTermDepositObj.maturityInMonths.periodFrom,
                "isRenewal": "N",
                "depositType": "2",
                "depositNrOfExtensions": 0
            };


            return insertObject;

        };

        var getCurrencyCodeBySymbol = function (currencySymbol) {
            var currencyIndex = _.findIndex(vm.currenciesList, function (o) {
                return o.symbol == currencySymbol;
            });
            var currencyCode = vm.currenciesList[currencyIndex].code;
            return currencyCode;
        };

        var getMinAmount = function (amount) {
            var result = '0';
            var minAmount = vm.tempTermDepositObj.maturityInMonths.minAmount;
            var minAmountArray = minAmount.split(",");
            _.forEach(minAmountArray, function (value) {
                var currAndAmountArray = value.split("=");
                if (currAndAmountArray[0] === vm.tempTermDepositObj.fromAccountSelect.currencySymbol) {
                    if (currAndAmountArray[1]) {
                        result = currAndAmountArray[1];
                    } else {
                        result = '50000';
                    }

                } else {
                    result = '50000';
                }
            });
            result = result / 100;
            return parseFloat(result);
        };

        vm.isCondition1Checked = false;
        vm.isCondition2Checked = false;

        vm.insertDepositOrderResponse = {};
        vm.confirmAction = function () {
            var minAmount = getMinAmount();

            if (vm.tempTermDepositObj.amount >= minAmount) {
                if (vm.isTermDepositEdit) {
                    DepositOrdersService.updateDepositOrderById(vm.insertDepositOrderResponse.id, createInsertObject()).then(function (response) {
                            vm.steps = {
                                step1: false,
                                step2: true,
                                step3: false
                            };
                            vm.insertDepositOrderResponse = response;
                            $log.debug("updateDepositOrderById", vm.insertDepositOrderResponse);
                            vm.isTermDepositEdit = false;
                        })
                        .catch(function (error) {
                            $log.error(error);
                        });
                } else {
                    DepositOrdersService.insertDepositOrder(createInsertObject()).then(function (response) {
                            var gtmObject = HelperService.processUrlForGTM('payment');
                            GoogleTagManagerHelperService.pushVirtualPageView(gtmObject.url, gtmObject.title, $location.host() + gtmObject.url);

                            vm.steps = {
                                step1: false,
                                step2: true,
                                step3: false
                            };
                            vm.insertDepositOrderResponse = response;
                            $log.debug("insertDepositOrderResponse", vm.insertDepositOrderResponse);
                        })
                        .catch(function (error) {
                            $log.error(error);
                            HelperService.showMessage(error, 'error');
                        });
                }
            } else {
                $translate('termDeposit.minAmountLabel').then(function (translation) {
                    var errorMessage = translation + ' ' + $filter('number')(minAmount, 2) + ' ' + vm.tempTermDepositObj.fromAccountSelect.currencySymbol + "!";
                    HelperService.showTranslatedMessage('error', errorMessage);
                    /*          $.growl.error({
                                message: translation + ' ' + $filter('number')(minAmount, 2) + ' ' + vm.tempTermDepositObj.fromAccountSelect.currencySymbol + "!"
                              });*/
                });
            }

        };

        vm.isTermDepositEdit = false;

        vm.editAction = function () {
            vm.isCondition1Checked = false;
            vm.isCondition2Checked = false;
            vm.isTermDepositEdit = true;
            vm.steps = {
                step1: true,
                step2: false,
                step3: false
            };
        };

        vm.cancelAction = function () {
            AlertService.confirmationAlert()
                .then(function (result) {
                    DepositOrdersService.deleteDepositOrderById(vm.insertDepositOrderResponse.id)
                        .then(function (response) {
                            AlertService.deletedPaymentAlert({
                                    paymentName: vm.insertDepositOrderResponse.id,
                                    type: 'termDeposit'
                                })
                                .then(function () {
                                    $state.reload();
                                });
                        })
                        .catch(function (error) {
                            $log.error(error);
                        });
                })
                .catch(function () {
                    $log.debug('Example failed!');
                });


        };

        vm.signAction = function () {
            vm.steps = {
                step1: false,
                step2: false,
                step3: true
            };
        };

        vm.signConfirmAction = function () {
            DepositOrdersService.signDepositOrderById(vm.insertDepositOrderResponse.id, vm.challengeResponse)
                .then(function (response) {
                GoogleTagManagerHelperService.pushEvent('NewTermDeposit', 'NewTermDepositRequestSubmited', 'New term deposit request submited successfully');
                    AlertService.infoAlert({
                            text: 'alert.successSign'
                        })
                        .then(function () {
                            $state.reload();
                        });
                })
                .catch(function (error) {
                    $log.error(error);
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.getContractDraft = function () {
            var minAmount = getMinAmount();
            if (vm.tempTermDepositObj.amount >= minAmount) {
                DepositOrdersService.getContractOverviewLink(createInsertObject());
            } else {
                $translate('termDeposit.minAmountLabel').then(function (translation) {
                    var error = translation + ' ' + $filter('number')(minAmount, 2) + ' ' + vm.tempTermDepositObj.fromAccountSelect.currencySymbol + "!";
                    HelperService.showTranslatedMessage('error', error);
                    /*          $.growl.error({
                                message: translation + ' ' + $filter('number')(minAmount, 2) + ' ' + vm.tempTermDepositObj.fromAccountSelect.currencySymbol + "!"
                              });*/
                });
            }
        };

        vm.challengeResponse = '';


        //add translation
        var translatePaymentProperties = function (orders) {
            _.forEach(orders, function (item) {
                item.translatedStatus = "core.termDepositStatus." + item.status.toLowerCase();
                item.payoutTypeTranslate = 'core.termDepositPayoutType.' + item.payoutType;
            });
        };


        // vm.init();
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name orders.controller:TermDepositCtrl
     *
     * @description
     *
     */
    angular
        .module('orders')
        .controller('TermDepositCtrl', TermDepositCtrl);

    function TermDepositCtrl() {
        var vm = this;
        vm.ctrlName = 'TermDepositCtrl';
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name orders.service:SavingsOrdersService
   *
   * @description
   *
   */
  SavingsOrdersService.$inject = ["$rootScope", "$http", "$q", "EndpointsService", "HelperService"];
  angular
    .module('orders')
    .service('SavingsOrdersService', SavingsOrdersService);

  function SavingsOrdersService($rootScope, $http, $q, EndpointsService, HelperService) {

    var SavingsOrdersServiceBase = {};

    SavingsOrdersServiceBase.getSavingsOrders = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.savingOrder, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SavingsOrdersServiceBase.getSavingsOrderById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.savingOrder_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SavingsOrdersServiceBase.downloadContract = function (id) {
      var deferred = $q.defer();
      var nonBlockingWindow = window.open('', '_self');
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.savingOrder_downloadLink_id.replace('{id}', id))
            .success(function (data) {
              if (data && data.url) {
                nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
              } else {
                nonBlockingWindow.close();
              }
              deferred.resolve();
            }).error(function (msg, code) {
            nonBlockingWindow.close();
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    SavingsOrdersServiceBase.downloadTermsAndConditions = function (id) {
      var deferred = $q.defer();
      var nonBlockingWindow = window.open('', '_self');
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.savingOrder_downloadTermsLink_id.replace('{id}', id))
            .success(function (data) {
              if (data && data.url) {
                nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
              } else {
                nonBlockingWindow.close();
              }
              deferred.resolve();
            }).error(function (msg, code) {
            nonBlockingWindow.close();
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    SavingsOrdersServiceBase.getSavingsOrderTypes = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.savingOrderTypes, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SavingsOrdersServiceBase.validateSavingsOrder = function (insertObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.savingOrder_validate, insertObject, {headers: {"Accept-language": "sl"}})
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SavingsOrdersServiceBase.insertSavingOrder = function (insertObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.savingOrder, insertObject, {headers: {"Accept-language": "sl"}})
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return SavingsOrdersServiceBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name orders.factory:OrdersService
     *
     * @description
     *
     */
    PermanentOrderTypesService.$inject = ["EndpointsService", "$q", "$http"];
    angular
        .module('orders')
        .factory('PermanentOrderTypesService', PermanentOrderTypesService);

    function PermanentOrderTypesService(EndpointsService, $q, $http) {
        var PermanentOrderTypesService = {};

        PermanentOrderTypesService.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.permanentOrderTypes, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return PermanentOrderTypesService;
    }
}());


(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name orders.factory:OrdersService
   *
   * @description
   *
   */
  PermanentOrdersService.$inject = ["$q", "$http", "$sessionStorage", "$rootScope", "EndpointsService", "SessionService"];
  angular
    .module('orders')
    .factory('PermanentOrdersService', PermanentOrdersService);

  function PermanentOrdersService($q, $http,$sessionStorage, $rootScope, EndpointsService, SessionService) {
    var PermanentOrdersService = {};

    if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'permanentOrder'){
      insert($sessionStorage.paymentStorageObject.object);
    }

    PermanentOrdersService.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.openingPermanentOrders, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PermanentOrdersService.getClosingPermanentOrders = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.closingPermanentOrders, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PermanentOrdersService.getById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.openingPermanentOrders_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PermanentOrdersService.getClosingPermanentOrdersById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.closingPermanentOrders_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PermanentOrdersService.getAll = function (params) {
      var predefinedParams = {
        page: 0,
        pageSize: 1000
      };
      var extended = _.extend(predefinedParams, params);
      return PermanentOrdersService.getPage(extended);
    };


    function insert(order) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        SessionService.saveStorageObject(order, 'permanentOrder');
        $http.post(response.links.openingPermanentOrders, order)
          .success(function (data) {
            SessionService.removeStorageObject();
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function validate(order) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.openingPermanentOrders_validate, order)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    PermanentOrdersService.create = function (order) {
      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl'){
        return validate(order);
      }

      return insert(order);
    };



    PermanentOrdersService.close = function (order) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.closingPermanentOrders, order)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PermanentOrdersService.validateClose = function (order) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.closingPermanentOrders_validate, order)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    PermanentOrdersService.update = function (id, order) {
      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        return validate(order);
      }

      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.openingPermanentOrders_id.replace('{id}', id), order)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    PermanentOrdersService.sign = function (order) {

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        return insert(order);
      }

      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.openingPermanentOrders_sign, order)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    PermanentOrdersService.remove = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.delete(response.links.orders_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return PermanentOrdersService;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name orders.controller:OrdersSloCtrl
   *
   * @description
   *
   */
  OrdersSloCtrl.$inject = ["$state", "$rootScope", "$location", "$translate", "HelperService", "AccountsService", "PaymentTypesService", "ConfigEndpointService", "ValidationService", "ReferenceModelService", "PermanentOrdersService", "PermanentOrderTypesService", "$log", "$q", "$timeout", "$filter", "GoogleTagManagerHelperService"];
  angular
    .module('orders')
    .controller('OrdersSloCtrl', OrdersSloCtrl);

  function OrdersSloCtrl($state, $rootScope, $location, $translate, HelperService, AccountsService, PaymentTypesService, ConfigEndpointService, ValidationService, ReferenceModelService,
                          PermanentOrdersService, PermanentOrderTypesService, $log, $q, $timeout, $filter, GoogleTagManagerHelperService) {

    var vm = this;
    vm.ctrlName = 'OrdersCtrl';
    vm.orderType = {};
    vm.fromAccountDropdown = false;
    vm.amountInput = '';
    vm.dayOfBeginning = 8;
    vm.dateBegin = new Date().setDate(vm.dayOfBeginning);
    vm.dateCancel = new Date(vm.dateBegin);
    vm.formSubmitted = false;
    vm.referenceModelList = [];
    vm.orderTypes = [];
    vm.referenceModelSelect = {};
    vm.currentOrder = null;
    vm.step = 'order';
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    vm.uiMaskOptions = ValidationService.getUiMaskOptions().croatia.iban;
    vm.uiMask = ValidationService.getUiMask().sl.orders;
    vm.ordersListGrouped = {};
    vm.referenceNumber = '';
    vm.descriptionMaxLength = 50;

    vm.forUpdate = false;

    var timeRange = HelperService.getDateRange('thisMonth');

    vm.ordersFilter = {
      page: 0,
      orderBy: 'dateCreated DESC',
      pageSize: 10,
      dateCreatedGTE: timeRange.valueDateGTE,
      dateCreatedLTE: timeRange.valueDateLTE
    };

    vm.authorizationTypeOptions = [
      {id: 1, description: "orders.permanentAthorisation"},
      {id: 0, description: "orders.cancelAuthorisation"}
    ];
    vm.authorisationTypeId = 1;

    vm.disabled = function (date, mode) {
      if (vm.authorisationTypeId == 1) return false;
      return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
    };

    vm.dateOfBeginningChange = function () {
      //vm.dateCancel = new Date(vm.dateBegin);
      //vm.dateOptions.minDate = new Date(vm.dateBegin);
      //vm.dateOptions.maxDate = HelperService.setCustomMonthPeriod(new Date(vm.dateBegin), 5);
      vm.dateCancel = new Date(new Date(vm.dateBegin).setMonth(new Date(vm.dateBegin).getMonth() + 5));
      vm.dateOfCancellationOptions = {
        minDate: new Date(vm.dateCancel)
      }
    };

    vm.modifyDate = function () {
      var minDate;
      var today = new Date();
      today.setDate(today.getDate() + 5);
      var fiveDaysFromToday = today.getDate();
      if (fiveDaysFromToday < vm.dayOfBeginning) {
        vm.dateBegin = new Date(new Date().setDate(vm.dayOfBeginning));
      } else {
        minDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
        vm.dateBegin = new Date(new Date(minDate).setDate(vm.dayOfBeginning));
      }

      vm.dateOfBeginningOptions = {
        minDate: new Date(vm.dateBegin)
        //maxDate: HelperService.setCustomMonthPeriod(new Date(vm.dateBegin), 5)
      };
      vm.dateOfBeginningChange();
    };

    vm.onAuthorisationTypeChange = function () {
      if (vm.authorisationTypeId == 1) {
        vm.dateOfBeginningOptions = {
          minDate: new Date()
        };
        vm.dateOfCancellationOptions = {
          minDate: new Date(),
          maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };
        vm.dayOfBeginning = 8;
        vm.dateBegin = new Date().setDate(vm.dayOfBeginning);
        vm.dateCancel = new Date(vm.dateBegin);
        vm.modifyDate();
      } else {
        vm.dateOfCancellationOptions = {
          minDate: new Date()
        };
        vm.dateCancel = new Date();
      }

      getOrders(true);
    }
    vm.onAuthorisationTypeChange();

    vm.inputOptions = {
      receviersAddress: {
        maxLength: -1
      },
      beneficiaryName: {
        maxLength: -1
      }
    };


    vm.timelineTimeFilter = timelineTimeFilter;
    vm.loadMoreTimelineItems = loadMoreTimelineItems;


    vm.defaultCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
    vm.bankAccount = $rootScope.APP_GLOBAL_SETTINGS.defaultData.BankAccount;
    vm.bankName = $rootScope.APP_GLOBAL_SETTINGS.defaultData.BankName;

    vm.beneficiaryIBANPrefix = 'HR';
    if (vm.countryCode == 'sl') {
      vm.beneficiaryIBAN = 'SI56';
      vm.inputOptions = {
        receviersAddress: {
          maxLength: 50
        },
        beneficiaryName: {
          maxLength: 50
        }
      };
    }


    vm.dateDisabled = function (date, mode) {
      if (date.getDate() == vm.dayOfBeginning) {
        //Sunday
        if (date.getDay() == 0) {
          return false;
        }
        if (date.getDay() == 6) {
          return true;
        }
        return false;
      }
      return true;
    };


    vm.dayOfBeginningSelectOptions = [
      {
        text: "8.",
        value: 8
      },
      {
        text: "18.",
        value: 18
      },
      {
        text: "28.",
        value: 28
      }
    ];

    vm.setAccountFrom = setAccountFrom;


    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      }
      , {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }
      , {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }
      , {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }
      , {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
      , {
        item: {
          key: 'all',
          description: 'core.period.all'
        }
      }
    ];
    vm.selectedPeriod = vm.periodList[3];

    function getPaymentTypeGroup() {
      var paymentTypesGroupFilter = {
        paymentTypeGroup: 'DomesticPayment'
      };
      return PaymentTypesService.getByGroup(paymentTypesGroupFilter)
        .then(function (response) {
          vm.accountList = response.result[0].debitAccountList;
          vm.ordersFilter.accountId = response.result[0].debitAccountList[0].accountId;
          _.forEach(vm.accountList, function (value) {
            value.optionValue = value.accountDescription + ' - ' + value.iban;
          });

          if (vm.accountList.length > 0) {
            vm.fromAccountSelect = vm.accountList[0];
          }
        })
        .catch(function () {
          $log.error('Error loading paymentTypeGroupDomestic!');
        });
    }

    function getReferenceModels() {
      var referenceModelFilter = {
        pageSize: 1000
      };
      return ReferenceModelService.getPage(referenceModelFilter)
        .then(function (response) {
          _.forEach(response.result, function (value) {
            vm.referenceModelList.push(value.model);
          });
        })
        .catch(function () {
          $log.error('Error loading bic banks codes!');
        });
    }

    vm.setOrderType = function () {
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
        //getFromAccountList(vm.orderType.detailsList);

        if (vm.orderType.typeId == 'trr') {
          vm.beneficiaryIBAN = 'SI56';
        }
      }
      setDefaultIBAN();
    };

    function loadSavingAccounts() {
      AccountsService.getPage({
        accountTypeGroup: 'SavingAccountTypes',
        currencySymbol: $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency
      }) //12.11.2016 - filter by currencySymbol doesnt work
        .then(function (response) {
          vm.savingAccounts = response.result;

          // _.forEach(vm.accountList, function (value) {
          //   value.optionValue = value.accountDescription + ' - ' + value.iban;
          // });

          if (vm.savingAccounts) {
            var tempList = _.filter(vm.savingAccounts, function (item) {
              return item.currencySymbol == $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
            });
            if (tempList)
              vm.savingAccounts = tempList;
          }

          if (vm.savingAccounts.length > 0) {
            vm.selectedSavingAccount = vm.savingAccounts[0];
          }
        }, function (error) {
          console.log(error);
        })
    }

    function setDefaultIBAN() {
      if (vm.orderType.typeId == "JO_HRK_10") {
        vm.beneficiaryIBAN = vm.bankAccount;
        vm.beneficiaryName = vm.bankName;
      } else if (vm.beneficiaryIBAN == vm.bankAccount) {
        vm.beneficiaryIBAN = '';
        vm.beneficiaryName = '';
      }
    }

    function getOrderTypes() {
      var orderTypeFilter = {
        pageSize: 1000
      };
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
        orderTypeFilter.includeList = ['DetailsList']
      }
      return PermanentOrderTypesService.getPage(orderTypeFilter)
        .then(function (response) {
          vm.orderTypes = response.result;
          vm.orderType = vm.orderTypes[0]; //typeId = "JO_HRK_10"
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
            getFromAccountList(vm.orderType.detailsList);
            loadSavingAccounts();
          }
          setDefaultIBAN();
        })
        .catch(function () {
          $log.error('Error loading order types');
        });
    }

    function getFromAccountList(accountIdList) {
      AccountsService.getPage({
        accountTypeGroup: 'CurrentAccount',
        isOwn: true,
        currencySymbol: $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency
      }) //12.11.2016 - filter by currencySymbol doesnt work
        .then(function (response) {
          vm.accountList = response.result;
          vm.ordersFilter.accountId = vm.accountList.accountId;
          _.forEach(vm.accountList, function (value) {
            value.optionValue = value.accountDescription + ' - ' + value.iban;
          });

          if (vm.countryCode == 'sl') {
            filterAccountsToEurAccount(); //12.11.2016 - filter by currencySymbol doesnt work
          }

          if (vm.accountList.length > 0) {
            vm.fromAccountSelect = vm.accountList[0];
          }
        }, function (error) {
          console.log(error);
        })
    }

    function filterAccountsToEurAccount() {
      if (vm.accountList) {
        var tempList = _.filter(vm.accountList, function (item) {
          return item.currencySymbol == $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
        });
        if (tempList)
          vm.accountList = tempList;
      }
    }

    function getOrders(reset) {
      if (reset) {
        vm.ordersFilter.page = 0;
        vm.ordersListGrouped = {};
      } else {
        vm.ordersFilter.page += 1;
      }

      if (vm.authorisationTypeId == 1) {
        PermanentOrdersService.getPage(vm.ordersFilter)
          .then(function (response) {
            if (response) {
              if (reset) {
                vm.ordersListGrouped = response;
              } else {
                vm.ordersListGrouped.result = vm.ordersListGrouped.result.concat(response.result);
                vm.ordersListGrouped.hasMore = response.hasMore;
              }
            }

          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      } else {
        PermanentOrdersService.getClosingPermanentOrders(vm.ordersFilter)
          .then(function (response) {
            if (response) {
              if (reset) {
                vm.ordersListGrouped = response;
              } else {
                vm.ordersListGrouped.result = vm.ordersListGrouped.result.concat(response.result);
                vm.ordersListGrouped.hasMore = response.hasMore;
              }
            }

          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    }

    function loadMoreTimelineItems() {
      getOrders(false);
    }

    function timelineTimeFilter(item) {
      vm.selectedPeriod = item;
      var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      vm.ordersFilter.dateCreatedGTE = timeRange.valueDateGTE;
      vm.ordersFilter.dateCreatedLTE = timeRange.valueDateLTE;
      getOrders(true);

      GoogleTagManagerHelperService.pushEvent('Orders', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));
    }

    function setAccountFrom(item) {
      vm.fromAccountSelect = item;
      vm.ordersFilter.accountId = vm.fromAccountSelect.accountId;
      getOrders(true);
      vm.fromAccountDropdown = false;
    }

    vm.openPermanentOrder = function () {
      if (vm.nextButtonPressed) return;
      vm.formSubmitted = true;
      if (!vm.orderForm.$valid) {
        return;
      }

      vm.nextButtonPressed = true;
      if (vm.formSubmitted) {
        var order = createOrderObject();

        if (vm.forUpdate) {
          order.id = vm.insertedOrderObject.id;
          PermanentOrdersService.update(vm.insertedOrderObject.id, order)
            .then(function (response) {
              postOrderAction(response);
              vm.forUpdate = false;
              vm.step = 'confirm';
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
              // vm.orderForm.$valid = false;
              vm.forUpdate = false;
            })
            .finally(function () {
              vm.formSubmitted = false;
              vm.nextButtonPressed = false;
            });
        } else {
          PermanentOrdersService.create(order)
            .then(function (response) {
              postOrderAction(response);
              vm.step = 'confirm';

              GoogleTagManagerHelperService.pushVirtualPageView('orders/toconfirm', 'orders toconfirm', $location.host() + 'orders/toconfirm');

            })
            .catch(function (error) {
              if (error && error.resultList && error.resultList.length > 0) {
                HelperService.showMessage(error, 'error');
                // vm.orderForm.$valid = false;
              }
            })
            .finally(function () {
              vm.formSubmitted = false;
              vm.nextButtonPressed = false;
            });
        }
      }
    };


    function createCancelAuthorisationInputObject() {
      var paymentObject = {
        fromAccountNumber: vm.fromAccountSelect.iban,
        orderId: 0,
        payeeAccount: (vm.beneficiaryIBAN) ? vm.beneficiaryIBAN.replace(/\s/g, '') : "",
        payeeAccountType: vm.orderType.typeId,
        payeeName: vm.beneficiaryName,
        payeeAddress: vm.receviersAddress,
        amount: HelperService.parseAmountInput(vm.amountInput),
        currencySymbol: vm.fromAccountSelect.currencySymbol,
        lastPaymentDate: new Date(vm.dateCancel),
        note: " "
      };
      if (vm.orderType.typeId == 'hypo') {
        paymentObject.payeeAccount = vm.selectedSavingAccount.iban;
        // Must be uppercase
        paymentObject.payeeAccountType = vm.orderType.typeId.toUpperCase();
      }
      return paymentObject;
    }

    vm.validateClosePermanentOrder = function () {

      vm.formSubmitted = true;
      if (!vm.orderForm.$valid) {
        return;
      }

      PermanentOrdersService.validateClose(createCancelAuthorisationInputObject())
        .then(function (response) {
          vm.step = 'confirm';
          postOrderAction(response);

          GoogleTagManagerHelperService.pushVirtualPageView('orders/toconfirm', 'orders toconfirm', $location.host() + 'orders/toconfirm');
        }, function (error) {
          if (error && error.resultList && error.resultList.length > 0) {
            HelperService.showMessage(error, 'error');
          }
        })
    };

    vm.confirmClosePermanentOrder = function () {
      PermanentOrdersService.close(createCancelAuthorisationInputObject())
        .then(function (response) {
          vm.step = 'complete';
          GoogleTagManagerHelperService.pushVirtualPageView('orders/toconfirm', 'orders toconfirm', $location.host() + 'orders/toconfirm');
        })
        .catch(function (error) {
          if (error && error.resultList && error.resultList.length > 0) {
            HelperService.showMessage(error, 'error');
          }
        })
    };

    vm.insertedOrderObject = {};

    var postOrderAction = function (response) {
      vm.insertedOrderObject = response;
      //vm.insertedOrderObject.orderTypeId = vm.orderType.typeId;
      vm.insertedOrderObject.fromAccountNumber = response.fromAccountNumber || vm.fromAccountSelect.iban; //SLO or HR
      vm.insertedOrderObject.payeeName = vm.beneficiaryName;
      vm.insertedOrderObject.amount = HelperService.parseAmountInput(vm.amountInput);
      vm.insertedOrderObject.currencySymbol = vm.defaultCurrency;
      vm.insertedOrderObject.firstPaymentDate = vm.dateBegin;
      vm.insertedOrderObject.lastPaymentDate = vm.dateCancel;
      vm.insertedOrderObject.purpose = vm.description;
      vm.insertedOrderObject.note = vm.description;
    };

    function createOrderObject() {
      var paymentObject = {
        orderTypeId: vm.orderType.typeId,
        payeeAccount: (vm.beneficiaryIBAN) ? vm.beneficiaryIBAN.replace(/\s/g, '') : "",
        payeeName: vm.beneficiaryName,
        amount: HelperService.parseAmountInput(vm.amountInput),
        currencySymbol: vm.defaultCurrency,
        firstPaymentDate: new Date(vm.dateBegin),
        purpose: vm.description,
        note: vm.description
      };

      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        paymentObject.fromAccountNumber = vm.fromAccountSelect.iban;
        paymentObject.lastPaymentDate = new Date(vm.dateCancel);
        paymentObject.payeeAddress = vm.receviersAddress;

        if (vm.orderType.typeId != 'trr')
          paymentObject.payeeAccount = vm.selectedSavingAccount.iban;
      } else {
        paymentObject.fromAccountNumber = vm.fromAccountSelect.accountId;
      }

      return paymentObject;
    }

    vm.back = function () {
      vm.step = 'order';
      vm.formSubmitted = false;
    };

    vm.editOrder = function () {
      vm.forUpdate = true;
      vm.step = 'order';
      vm.agreedWithTerms = false;
      mapWithOrderResponse();
      //setDefaultIBAN();
    };

    var mapWithOrderResponse = function () {
      vm.orderType.typeId = vm.insertedOrderObject.orderTypeId || vm.insertedOrderObject.payeeAccountType;
      vm.beneficiaryName = vm.insertedOrderObject.payeeName;
      vm.amountInput = vm.insertedOrderObject.amount;
      vm.defaultCurrency = vm.insertedOrderObject.currencySymbol;
      vm.dateBegin = new Date(vm.insertedOrderObject.firstPaymentDate);
      vm.dateCancel = new Date(vm.insertedOrderObject.lastPaymentDate);
      vm.description = vm.insertedOrderObject.purpose;
      vm.note = vm.insertedOrderObject.note;
      vm.beneficiaryIBAN = vm.insertedOrderObject.payeeAccount;

      var accountIndex = _.findIndex(vm.accountList, function (item) {
        return item.accountId == vm.insertedOrderObject.accountId;
      });

      vm.fromAccountSelect = vm.accountList[accountIndex];
    };

    vm.sign = function () {
      if (vm.confirmButtonPressed) return;
      vm.insertedOrderObject.statusId = 6;

      vm.signOrder = vm.insertedOrderObject;
      if (vm.countryCode != 'sl') {
        vm.signOrder = {};
        vm.signOrder.id = vm.insertedOrderObject.id;
        vm.signOrder.signData = vm.model.password2;
      }

      vm.confirmSignedButtonDisabled = true;
      vm.confirmButtonPressed = true;
      PermanentOrdersService.sign(vm.signOrder)
        .then(function (response) {
          vm.insertedOrderObject = response;
          vm.step = 'complete';
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
        .finally(function (error) {
          vm.confirmButtonPressed = false;
        });
    };

    /**
     * Resets order form and shows first step.
     */
    vm.newOrder = function () {
      $state.go("orders", {}, {reload: true})
      // vm.step = 'order';
      // vm.amountInput = '';
      // vm.description = '';
      // vm.beneficiaryIBAN = '';
      // vm.beneficiaryName = '';
      // vm.dateBegin = new Date();
      // vm.dateCancel = new Date();
      // vm.formSubmitted = false;
      // vm.forUpdate = false;
      // vm.orderSigned = false;
      // vm.receviersAddress = '';
      // vm.note = '';
      // setDefaultIBAN();
    };


    vm.deleteOrder = function () {
      PermanentOrdersService.remove(vm.insertedOrderObject.id)
        .then(function (response) {
          vm.newOrder();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.closeOrder = function (orderId) {
      if (orderId) {
        var order = {};
        order.orderId = orderId;
        PermanentOrdersService.close(order)
          .then(function (response) {
            getOrders(true);
            var text = $translate.instant('orderDetails.closeMsg');
            HelperService.showTranslatedMessage('info', text, '');
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    vm.init = function () {
      var promises = [getReferenceModels()]; //getDefaultDetails(),
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
        promises.push(getPaymentTypeGroup());
      }
      $q.all(promises)
        .then(function () {
          getOrders(true);
          getOrderTypes();

          if (vm.referenceModelList.length > 0) {
            var index = _.findIndex(vm.referenceModelList, function (o) {
              return o === '99';
            });
            vm.referenceModelSelect = vm.referenceModelList[index];
          }
        });
    };

    vm.init();


    vm.addSpaceForIban = function (toAccountInput) {
      if (!toAccountInput)
        return;
      vm.beneficiaryIBAN = toAccountInput.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    };


    vm.expandDetails = function (order) {
      if (!order.selected) {
        if (vm.authorisationTypeId == 1) {
          PermanentOrdersService.getById(order.id)
            .then(function (response) {
              angular.extend(order, response);
            }, function (error) {
              console.log(error);
            });
        } else {
          PermanentOrdersService.getClosingPermanentOrdersById(order.id)
            .then(function (response) {
              angular.extend(order, response);
            }, function (error) {
              console.log(error);
            });
        }
      }
    };
  }
}());

(function () {
    'use strict';

    config.$inject = ["$stateProvider"];
    angular
        .module('orders')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('orders', {
                url: '/orders',
                templateUrl: 'orders/orders.tpl.html',
                controller: 'OrdersCtrl',
                controllerAs: 'vm'
            })
            .state('orders.termDeposit', {
                url: '/term-deposit',
                views: {
                    '@': {
                        templateUrl: 'orders/term-deposit.tpl.html',
                        controller: 'TermDepositCtrl',
                        controllerAs: 'termDeposit'
                    }
                }
            })
          .state('orders.newSavingsOrder', {
                url: '/savings-order',
                views: {
                    '@': {
                        templateUrl: 'orders/new-savings-order-slo.tpl.html',
                        controller: 'NewSavingsOrderCtrlSlo',
                        controllerAs: 'savingsAccount'
                    }
                }
            })
            .state('orders.cancelDeposit', {
                url: '/cancel-deposit/:accountId',
                views: {
                    '@': {
                        templateUrl: 'orders/cancel-deposit.tpl.html',
                        controller: 'CancelDepositCtrl',
                        controllerAs: 'cancelDeposit'
                    }
                }
            })
            .state('orders.addNewExpressLoan', {
                url: '/express-loan',
                views: {
                    '@': {
                        templateUrl: 'orders/add-new-express-loan.tpl.html',
                        controller: 'AddNewExpressLoanCtrl',
                        controllerAs: 'addNewExpressLoan'
                    }
                }
            });
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name orders.controller:OrdersOtherCtrl
     *
     * @description
     *
     */
    OrdersOtherCtrl.$inject = ["$rootScope", "$location", "$translate", "HelperService", "AccountsService", "PaymentTypesService", "ConfigEndpointService", "ValidationService", "ReferenceModelService", "PermanentOrdersService", "PermanentOrderTypesService", "$log", "$q", "$timeout", "$filter", "GoogleTagManagerHelperService"];
    angular
        .module('orders')
        .controller('OrdersOtherCtrl', OrdersOtherCtrl);

    function OrdersOtherCtrl($rootScope, $location, $translate, HelperService, AccountsService, PaymentTypesService, ConfigEndpointService, ValidationService, ReferenceModelService,
                              PermanentOrdersService, PermanentOrderTypesService, $log, $q, $timeout, $filter, GoogleTagManagerHelperService) {
        var vm = this;
        vm.ctrlName = 'OrdersCtrl';
        vm.orderType = {};
        vm.fromAccountDropdown = false;
        vm.amountInput = '';
        vm.dayOfBeginning = 8;
        vm.dateBegin = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') ? new Date() : new Date().setDate(vm.dayOfBeginning);
        vm.dateCancel = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') ? new Date() : new Date(vm.dateBegin);
        vm.formSubmitted = false;
        vm.referenceModelList = [];
        vm.orderTypes = [];
        vm.referenceModelSelect = {};
        vm.currentOrder = null;
        vm.step = 'order';
        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
        vm.uiMaskOptions = ValidationService.getUiMaskOptions().croatia.iban;
        vm.ordersListGrouped = {};
        vm.referenceNumber = '';
        vm.descriptionMaxLength = 50;

        vm.inputOptions = {
            receviersAddress: {
                maxLength: -1
            },
            beneficiaryName: {
                maxLength: -1
            }
        };

        vm.forUpdate = false;

        var timeRange = HelperService.getDateRange('thisMonth');

        vm.ordersFilter = {
            page: 0,
            orderBy: 'dateCreated DESC',
            pageSize: 10,
            dateCreatedGTE: timeRange.valueDateGTE,
            dateCreatedLTE: timeRange.valueDateLTE
        };

        vm.timelineTimeFilter = timelineTimeFilter;
        vm.loadMoreTimelineItems = loadMoreTimelineItems;

        vm.dateOfBeginningOptions = {
            minDate: new Date()
        };

        vm.dateOfCancellationOptions = {
            minDate: new Date(),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        vm.defaultCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.bankAccount = $rootScope.APP_GLOBAL_SETTINGS.defaultData.BankAccount;
        vm.bankName = $rootScope.APP_GLOBAL_SETTINGS.defaultData.BankName;

        vm.beneficiaryIBANPrefix = 'HR';


        vm.dateBegin = HelperService.setCustomMonthPeriodByDays(new Date(), 9);
        vm.dateOptions = {
            minDate: new Date(vm.dateBegin),
            maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };
        vm.descriptionMaxLength = 200;

        vm.setAccountFrom = setAccountFrom;

        vm.periodList = [
            {
                item: {
                    key: 'today',
                    description: 'core.period.today'
                }
      }
      , {
                item: {
                    key: 'yesterday',
                    description: 'core.period.yesterday'
                }
      }
      , {
                item: {
                    key: 'thisWeek',
                    description: 'core.period.thisWeek'
                }
      }
      , {
                item: {
                    key: 'thisMonth',
                    description: 'core.period.thisMonth'
                }
      }
      , {
                item: {
                    key: 'thisYear',
                    description: 'core.period.thisYear'
                }
      }
      , {
                item: {
                    key: 'all',
                    description: 'core.period.all'
                }
      }
    ];
        vm.selectedPeriod = vm.periodList[3];

        function getPaymentTypeGroup() {
            var paymentTypesGroupFilter = {
                paymentTypeGroup: 'DomesticPayment'
            };
            return PaymentTypesService.getByGroup(paymentTypesGroupFilter)
                .then(function (response) {
                    vm.accountList = response.result[0].debitAccountList;
                    vm.ordersFilter.accountId = response.result[0].debitAccountList[0].accountId;
                    _.forEach(vm.accountList, function (value) {
                        value.optionValue = value.accountDescription + ' - ' + value.iban;
                    });

                    if (vm.accountList.length > 0) {
                        vm.fromAccountSelect = vm.accountList[0];
                    }
                })
                .catch(function () {
                    $log.error('Error loading paymentTypeGroupDomestic!');
                });
        }

        function getReferenceModels() {
            var referenceModelFilter = {
                pageSize: 1000
            };
            return ReferenceModelService.getPage(referenceModelFilter)
                .then(function (response) {
                    _.forEach(response.result, function (value) {
                        vm.referenceModelList.push(value.model);
                    });
                })
                .catch(function () {
                    $log.error('Error loading bic banks codes!');
                });
        }

        // vm.setOrderType = function () {
        //   if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
        //     //getFromAccountList(vm.orderType.detailsList);
        //
        //     if (vm.orderType.typeId == 'trr') {
        //       vm.beneficiaryIBAN = 'SI56';
        //     }
        //   }
        //   //setDefaultIBAN();
        // };

        function loadSavingAccounts() {
            AccountsService.getPage({
                    accountTypeGroup: 'SavingAccountTypes',
                    currencySymbol: $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency
                }) //12.11.2016 - filter by currencySymbol doesnt work
                .then(function (response) {
                    vm.savingAccounts = response.result;

                    // _.forEach(vm.accountList, function (value) {
                    //   value.optionValue = value.accountDescription + ' - ' + value.iban;
                    // });

                    if (vm.savingAccounts) {
                        var tempList = _.filter(vm.savingAccounts, function (item) {
                            return item.currencySymbol == $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
                        });
                        if (tempList)
                            vm.savingAccounts = tempList;
                    }

                    if (vm.savingAccounts.length > 0) {
                        vm.selectedSavingAccount = vm.savingAccounts[0];
                    }
                }, function (error) {
                    console.log(error);
                })
        }

        function setDefaultIBAN() {
            if (vm.orderType.typeId == "JO_HRK_10") {
                vm.beneficiaryIBAN = vm.bankAccount;
                vm.beneficiaryName = vm.bankName;
            } else if (vm.beneficiaryIBAN == vm.bankAccount) {
                vm.beneficiaryIBAN = '';
                vm.beneficiaryName = '';
            }
        }

        function getOrderTypes() {
            var orderTypeFilter = {
                pageSize: 1000
            };

            return PermanentOrderTypesService.getPage(orderTypeFilter)
                .then(function (response) {
                    vm.orderTypes = response.result;
                    vm.orderType = vm.orderTypes[0]; //typeId = "JO_HRK_10"
                    //setDefaultIBAN();
                })
                .catch(function () {
                    $log.error('Error loading order types');
                });
        }

        function getFromAccountList(accountIdList) {
            AccountsService.getPage({
                    accountTypeGroup: 'CurrentAccount',
                    isOwn: true,
                    currencySymbol: $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency
                }) //12.11.2016 - filter by currencySymbol doesnt work
                .then(function (response) {
                    vm.accountList = response.result;
                    vm.ordersFilter.accountId = vm.accountList.accountId;
                    _.forEach(vm.accountList, function (value) {
                        value.optionValue = value.accountDescription + ' - ' + value.iban;
                    });

                    if (vm.countryCode == 'sl') {
                        filterAccountsToEurAccount(); //12.11.2016 - filter by currencySymbol doesnt work
                    }

                    if (vm.accountList.length > 0) {
                        vm.fromAccountSelect = vm.accountList[0];
                    }
                }, function (error) {
                    console.log(error);
                })
        }

        function filterAccountsToEurAccount() {
            if (vm.accountList) {
                var tempList = _.filter(vm.accountList, function (item) {
                    return item.currencySymbol == $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
                });
                if (tempList)
                    vm.accountList = tempList;
            }
        }

        function getOrders(reset) {
            if (reset) {
                vm.ordersFilter.page = 0;
                vm.ordersListGrouped = {};
            } else {
                vm.ordersFilter.page += 1;
            }

            PermanentOrdersService.getPage(vm.ordersFilter)
                .then(function (response) {
                    if (response) {
                        if (reset) {
                            vm.ordersListGrouped = response;
                        } else {
                            vm.ordersListGrouped.result = vm.ordersListGrouped.result.concat(response.result);
                            vm.ordersListGrouped.hasMore = response.hasMore;
                        }
                    }

                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        }

        function loadMoreTimelineItems() {
            getOrders(false);
        }

        function timelineTimeFilter(item) {
            vm.selectedPeriod = item;
            var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
            vm.ordersFilter.dateCreatedGTE = timeRange.valueDateGTE;
            vm.ordersFilter.dateCreatedLTE = timeRange.valueDateLTE;
            getOrders(true);
            GoogleTagManagerHelperService.pushEvent('Orders', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));
        }

        function setAccountFrom(item) {
            vm.fromAccountSelect = item;
            vm.ordersFilter.accountId = vm.fromAccountSelect.accountId;
            getOrders(true);
            vm.fromAccountDropdown = false;
        }

        vm.confirm = function () {
            vm.formSubmitted = true;
            if (!vm.orderForm.$valid) {
                return;
            }

            if (vm.formSubmitted) {
                var order = createOrderObject();

                if (vm.forUpdate) {
                    order.id = vm.insertedOrderObject.id;
                    PermanentOrdersService.update(vm.insertedOrderObject.id, order)
                        .then(function (response) {
                            postOrderAction(response);
                            vm.forUpdate = false;
                            vm.step = 'confirm';
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                            // vm.orderForm.$valid = false;
                            vm.forUpdate = false;
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                } else {
                    PermanentOrdersService.create(order)
                        .then(function (response) {
                            postOrderAction(response);
                            vm.step = 'confirm';

                            GoogleTagManagerHelperService.pushVirtualPageView('orders/toconfirm', 'orders toconfirm', $location.host() + 'orders/toconfirm');
                        })
                        .catch(function (error) {
                            if (error && error.resultList && error.resultList.length > 0) {
                                HelperService.showMessage(error, 'error');
                                // vm.orderForm.$valid = false;
                            }
                        })
                        .finally(function () {
                            vm.formSubmitted = false;
                        });
                }
            }
        };

        vm.insertedOrderObject = {};

        var postOrderAction = function (response) {
            vm.insertedOrderObject = response;
            //vm.insertedOrderObject.orderTypeId = vm.orderType.typeId;
            vm.insertedOrderObject.fromAccountNumber = response.fromAccountNumber || vm.fromAccountSelect.iban; //SLO or HR
            vm.insertedOrderObject.payeeName = vm.beneficiaryName;
            vm.insertedOrderObject.amount = HelperService.parseAmountInput(vm.amountInput);
            vm.insertedOrderObject.currencySymbol = vm.defaultCurrency;
            vm.insertedOrderObject.firstPaymentDate = vm.dateBegin;
            vm.insertedOrderObject.lastPaymentDate = vm.dateCancel;
            vm.insertedOrderObject.purpose = vm.description;
            vm.insertedOrderObject.note = vm.description;
        };

        function createOrderObject() {
            var paymentObject = {
                orderTypeId: vm.orderType.typeId,
                payeeAccount: (vm.beneficiaryIBAN) ? vm.beneficiaryIBAN.replace(/\s/g, '') : "",
                payeeName: vm.beneficiaryName,
                amount: HelperService.parseAmountInput(vm.amountInput),
                currencySymbol: vm.defaultCurrency,
                firstPaymentDate: new Date(vm.dateBegin),
                purpose: vm.description,
                note: vm.description,
                referenceModel: vm.referenceModelSelect,
                referenceNumber: vm.referenceNumber
            };

            paymentObject.fromAccountNumber = vm.fromAccountSelect.accountId;


            if (vm.countryCode == 'hr' && !vm.forUpdate) {
                paymentObject.payeeAccount = vm.beneficiaryIBANPrefix + vm.beneficiaryIBAN
            }

            return paymentObject;
        }

        vm.back = function () {
            vm.step = 'order';
            vm.formSubmitted = false;
        };

        vm.editOrder = function () {
            vm.forUpdate = true;
            vm.step = 'order';
            vm.agreedWithTerms = false;
            mapWithOrderResponse();
            //setDefaultIBAN();
        };

        var mapWithOrderResponse = function () {
            vm.orderType.typeId = vm.insertedOrderObject.orderTypeId || vm.insertedOrderObject.payeeAccountType;
            vm.beneficiaryName = vm.insertedOrderObject.payeeName;
            vm.amountInput = vm.insertedOrderObject.amount;
            vm.defaultCurrency = vm.insertedOrderObject.currencySymbol;
            vm.dateBegin = new Date(vm.insertedOrderObject.firstPaymentDate);
            vm.dateCancel = new Date(vm.insertedOrderObject.lastPaymentDate);
            vm.description = vm.insertedOrderObject.purpose;
            vm.note = vm.insertedOrderObject.note;
            vm.beneficiaryIBAN = vm.insertedOrderObject.payeeAccount;

            var accountIndex = _.findIndex(vm.accountList, function (item) {
                return item.accountId == vm.insertedOrderObject.accountId;
            });

            vm.fromAccountSelect = vm.accountList[accountIndex];
        };

        vm.sign = function () {
            vm.insertedOrderObject.statusId = 6;

            vm.signOrder = vm.insertedOrderObject;
            if (vm.countryCode != 'sl') {
                vm.signOrder = {};
                vm.signOrder.id = vm.insertedOrderObject.id;
                vm.signOrder.signData = vm.model.password2;
            }

            vm.confirmSignedButtonDisabled = true;
            PermanentOrdersService.sign(vm.signOrder)
                .then(function (response) {
                    vm.insertedOrderObject = response;
                    vm.confirmSignedButtonDisabled = false;
                    vm.step = 'complete';
                })
                .catch(function (error) {
                    vm.confirmSignedButtonDisabled = false;
                    HelperService.showMessage(error, 'error');
                });
        };

        /**
         * Resets order form and shows first step.
         */
        vm.newOrder = function () {
            vm.step = 'order';
            vm.amountInput = '';
            vm.description = '';
            vm.beneficiaryIBAN = '';
            vm.beneficiaryName = '';
            vm.dateBegin = new Date();
            vm.dateCancel = new Date();
            vm.formSubmitted = false;
            vm.forUpdate = false;
            vm.orderSigned = false;
            vm.receviersAddress = '';
            vm.note = '';
            //setDefaultIBAN();
        };


        vm.deleteOrder = function () {
            PermanentOrdersService.remove(vm.insertedOrderObject.id)
                .then(function (response) {
                    vm.newOrder();
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.closeOrder = function (orderId) {
            if (orderId) {
                var order = {};
                order.orderId = orderId;
                PermanentOrdersService.close(order)
                    .then(function (response) {
                        getOrders(true);
                        var text = $translate.instant('orderDetails.closeMsg');
                        HelperService.showTranslatedMessage('info', text, '');
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.init = function () {
            var promises = [getReferenceModels()]; //getDefaultDetails(),
            promises.push(getPaymentTypeGroup());

            $q.all(promises)
                .then(function () {
                    getOrders(true);
                    getOrderTypes();

                    if (vm.referenceModelList.length > 0) {
                        var index = _.findIndex(vm.referenceModelList, function (o) {
                            return o === '99';
                        });
                        vm.referenceModelSelect = vm.referenceModelList[index];
                    }
                });
        };

        vm.init();


        vm.addSpaceForIban = function (toAccountInput) {
            if (!toAccountInput)
                return;
            vm.beneficiaryIBAN = toAccountInput.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
        };


        vm.expandDetails = function (order) {
            // if (vm.countryCode == 'sl' && !order.selected) {
            //   PermanentOrdersService.getById(order.id)
            //     .then(function (response) {
            //       angular.extend(order, response);
            //     }, function (error) {
            //       console.log(error);
            //     });
            // }
        };
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name orders.controller:OrdersCtrl
   *
   * @description
   *
   */
  angular
    .module('orders')
    .controller('OrdersCtrl', OrdersCtrl)
    .filter('orderStatusString', orderStatusString);

  function OrdersCtrl() {
    console.log("ORDERS CTRL");
  }

  function orderStatusString() {
    return function (input) {
      var status = ['orders.statusOpen'];
      var out = '';
      for (var i = 0; i < status.length; i++) {
        if (i === parseInt(input))
          out = status[i];
      }
      return out;
    };
  }

}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name orders.controller:NewSavingsOrderCtrlSlo
   *
   * @description
   *
   */
  NewSavingsOrderCtrlSlo.$inject = ["$state", "$rootScope", "$q", "$translate", "$filter", "$log", "$localStorage", "$timeout", "AlertService", "AccountsService", "SavingsOrdersService", "CurrencyService", "DepositOrdersService", "HelperService", "ValidationService", "GoogleTagManagerHelperService"];
  angular
    .module('orders')
    .controller('NewSavingsOrderCtrlSlo', NewSavingsOrderCtrlSlo);

  function NewSavingsOrderCtrlSlo($state, $rootScope, $q, $translate, $filter, $log, $localStorage, $timeout,
                                  AlertService, AccountsService, SavingsOrdersService, CurrencyService, DepositOrdersService, HelperService, ValidationService, GoogleTagManagerHelperService) {
    var vm = this;
    var selectedLanguage = $localStorage.appLanguage;
    var savingTypesGroup;
    vm.accountsFrom = [];
    vm.assignmentOfInterestisShown = true;
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();

    vm.model = {
      savingsType: {},
      fromAccountSelect: {},
      totalInterestRate: 0,
      maturityDate: new Date(),
      amount: "",
      currency: "",
      assignmentOfInterest: "",
      interestPayout: "",
      standingOrderPayment: "",
      maturityInDays: "",
      maturityInMonths: "",
      dateChanged: false
    };

    vm.responseModel = {};

    vm.standingOrderPaymentDayOptions = [
      {id: 1, name: "8.", value: 8},
      {id: 2, name: "18.", value: 18},
      {id: 3, name: "28.", value: 28}
    ];

    // For interestRange property
    var assignmentOfInterestOptionsEnglish = [
      {id: 1, value: "termDeposit.assignmentOfInterestAnnual", name: "Annual reporting"},
      {id: 2, value: "termDeposit.assignmentOfInterestAfter", name: "Report after maturity"}
    ];

    var assignmentOfInterestOptionsSlovenian = [
      {id: 1, value: "termDeposit.assignmentOfInterestAnnual", name: "Letno poročanje"},
      {id: 2, value: "termDeposit.assignmentOfInterestAfter", name: "Poročanje po poteku"}
    ];

    vm.assignmentOfInterestOptions = [
      {id: 1, value: "termDeposit.assignmentOfInterestAnnual"},
      {id: 2, value: "termDeposit.assignmentOfInterestAfter"}
    ];

    vm.assignmentOfInterestId = vm.assignmentOfInterestOptions[0].id;


    vm.steps = {
      step1: true,
      step2: false,
      step3: false
    };

    vm.disabled = function (date, mode) {
      return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
    };

    vm.dateOptions = {
      minDate: new Date()
    };

    $rootScope.$on('$translateChangeEnd', function (evt, data) {
      selectedLanguage = data.language;
    });

    init();
    function init() {
      loadData();
    }

    function loadData() {
      var promises = [];
      promises.push(SavingsOrdersService.getSavingsOrderTypes({
        pageSize: 1000,
        orderBy: "sortOrder"
      }));
      promises.push(AccountsService.getDepositOrderAccounts({pageSize: 1000}));

      $q.all(promises)
        .then(function (responses) {
          // ==========
          // Request 1
          // ==========
          // Group array by "savingGroupDescription
          vm.savingOrderTypesGroupOptions = _.groupBy(responses[0].result, 'savingGroupDescription');
          // Select first group by default
          for (var key in vm.savingOrderTypesGroupOptions) {
            vm.savingTypesGroup = vm.savingOrderTypesGroupOptions[key];
            break;
          }

          // ==========
          // Request 2
          // ==========
          // Only owned accounts and EUR currency should be possible!!
          vm.accountsFrom = _.filter(responses[1].result, function (account) {
            return (account.currencySymbol == "EUR" && account.isOwn);
          });
          // Set first account as default
          vm.setAccountFrom(vm.accountsFrom[0]);

          vm.getTimelineItemsGrouped(true);

          vm.onSavingOrderTypesGroupChange(vm.savingTypesGroup);
          vm.isPageLoaded = true;
        }, function (error) {
          console.log(error);
        })
    }


    // ===
    // MAIN
    // ====
    vm.onSavingOrderTypesGroupChange = function (savingOrderTypesGroup) {
      // savingTypesGroup = angular.copy(savingOrderTypesGroup);
      // Set group Id
      vm.selectedSavingTypesGroupId = savingOrderTypesGroup[0].savingGroup;

      // Find and set minimal duration of selected group
      var minDurations = [];
      var maxDurations = [];
      _.each(savingOrderTypesGroup, function (savingType) {
        minDurations.push(parseInt(savingType.minSavingDays));
        maxDurations.push(parseInt(savingType.maxSavingDays))
      });
      vm.maxSavingDuration = _.max(maxDurations);
      var min = _.min(minDurations);
      vm.model.maturityInDays = min;
      vm.minimalDurationForSelectedGroup = min;
      findSavingsType();
    };

    function findSavingsType() {
      // Find saving type by duration !!!
      var savingsType = _.filter(vm.savingTypesGroup, function (savingType) {
        var minDuration = parseInt(savingType.minSavingDays);
        var maxDuration = parseInt(savingType.maxSavingDays);
        if (savingType.minSavingDays == "") {
          minDuration = 0;
        }
        if (savingType.maxSavingDays == "") {
          maxDuration = Infinity;
        }
        return (minDuration <= parseInt(vm.model.maturityInDays) && parseInt(vm.model.maturityInDays) <= maxDuration)
      });

      if (savingsType.length) {
        vm.onSavingsTypeChange(savingsType[0]);
      } else {
        vm.model.savingsType = {};
        vm.model.totalInterestRate = 0;
      }
    }


    vm.setAccountFrom = function (item) {
      vm.model.fromAccountSelect = item;
      vm.model.currency = vm.model.fromAccountSelect.currencySymbol;
      // vm.depositsFilter.accountId = item.accountId;
      vm.fromAccountDropdown = false;
    };

    vm.toggleFromAccount = function () {
      vm.fromAccountDropdown = !vm.fromAccountDropdown;
    };

    vm.onSavingsTypeChange = function (savingsType) {
      vm.model.savingsType = savingsType;
      if (savingsType.savingOrderTypeCalculationList[0]) {
        vm.model.totalInterestRate = savingsType.savingOrderTypeCalculationList[0].totalRate;
      } else {
        vm.model.totalInterestRate = 0;
      }

      // If one of fields “minSavingDays” and “maxSavingDays“ is empty, then this field is hidden.
      if (savingsType.minSavingDays != "" && savingsType.maxSavingDays != "") {
        // vm.minDurationInDays = savingsType.minSavingDays;
        // vm.maxDurationInDays = savingsType.maxSavingDays;
        // vm.model.maturityInDays = savingsType.minSavingDays;
        // vm.calculateMaturityDateWithDays(savingsType.minSavingDays);
        vm.durationInputHidden = false;
      } else {
        vm.model.maturityInDays = "";
        vm.model.maturityInMonths = "";
        vm.model.maturityDate = new Date();
        vm.durationInputHidden = true;
      }

      // If all savings of the selected Savings type have the same period and all have “minSavingDays” = “maxSavingDays“ ± 12 days
      // then this is READ-ONLY with value of “minSavingDays” converted to months (too hard to convert days in months ?)
      // if ((savingsType.minSavingDays != "" && savingsType.maxSavingDays != "") && savingsType.maxSavingDays - savingsType.minSavingDays <= 12) {
      //   vm.model.maturityInDays = savingsType.minSavingDays;
      //   vm.calculateMaturityDateWithDays(savingsType.minSavingDays);
      //   vm.maturityInputDisabled = true;
      // } else {
      //   vm.maturityInputDisabled = false;
      // }

      vm.savingsPeriodType = savingsType.periodType;

      if (savingsType.periodType == "K") {
        vm.assignmentOfInterestOptions = [
          {id: 2, value: "termDeposit.assignmentOfInterestAfter"}
        ];
        vm.assignmentOfInterestId = vm.assignmentOfInterestOptions[0].id;
        vm.assignmentOfInterestisShown = true;
        vm.assignemntOfInterestIsDisabled = true;
      }
      else if (savingsType.periodType == "D") {
        vm.assignmentOfInterestOptions = [
          {id: 1, value: "termDeposit.assignmentOfInterestAnnual"},
          {id: 2, value: "termDeposit.assignmentOfInterestAfter"}
        ];
        vm.model.assignmentOfInterest = vm.assignmentOfInterestOptions[0].id;
        vm.assignmentOfInterestisShown = true;
        vm.assignemntOfInterestIsDisabled = false;
      } else if (!savingsType.periodType) {
        vm.model.assignmentOfInterest = "";
        vm.assignmentOfInterestisShown = false;
        vm.assignemntOfInterestIsDisabled = false;
      }

      vm.onStndOrderPaymentDayChange(vm.standingOrderPaymentDayOptions[0].value);

      if (savingsType.periodType == "K") {
        vm.model.standingOrderPayment = "";
      } else {
        vm.model.standingOrderPayment = vm.standingOrderPaymentDayOptions[0];
      }

      if (savingsType.savingType == 1) {
        vm.model.assignmentOfInterest = "";
        vm.assignmentOfInterestisShown = false;
        vm.model.maturityDate = "";
        vm.model.maturityInDays = "";
      }

      // Init date values
      vm.model.maturityDate = HelperService.setCustomMonthPeriodByDays(new Date, parseInt(vm.model.maturityInDays));
      vm.onStndOrderPaymentDayChange(vm.model.standingOrderPayment.value);
      validateMaturityDate(vm.model.maturityInDays);
      vm.amountChanged(vm.model.amount);
    };

    var daysBetweenMonths;
    vm.calculateMaturityDate = function (durationInMonths) {
      if (!durationInMonths) {
        return;
      }
      if (durationInMonths.length > 3) return;

      // resetMaturityDateValidation();
      vm.model.maturityDate = HelperService.setCustomMonthPeriod(new Date(), parseInt(durationInMonths));
      daysBetweenMonths = Math.round(( vm.model.maturityDate - new Date()) / 86400000);
      vm.model.maturityInDays = daysBetweenMonths;
      vm.calculateMaturityDateWithDays(daysBetweenMonths);

      // vm.onStndOrderPaymentDayChange(vm.model.standingOrderPayment.value);
      // vm.model.maturityInDays = daysBetweenMonths;
      // vm.model.maturityInDays = daysBetweenMonths;
      // validateMaturityDate(daysBetweenMonths);
    };

    vm.calculateMaturityDays = function (date) {
      vm.model.maturityInMonths = "";
      daysBetweenMonths = vm.model.maturityInDays = Math.round(( date - new Date()) / 86400000);
      findSavingsType();
      validateMaturityDate(daysBetweenMonths);
    };

    vm.calculateMaturityDateWithDays = function (durationInDays) {
      if (!durationInDays) {
        durationInDays = 0;
      }

      if (daysBetweenMonths != durationInDays) {
        vm.model.maturityInMonths = "";
      }

      if (durationInDays.length > 6) return;

      // resetMaturityDateValidation();
      vm.model.maturityDate = HelperService.setCustomMonthPeriodByDays(new Date, parseInt(durationInDays));
      vm.onStndOrderPaymentDayChange(vm.model.standingOrderPayment.value);
      findSavingsType();
      validateMaturityDate(durationInDays);
    };

    function validateMaturityDate(daysBetweenMonths) {
      if (vm.selectedSavingTypesGroupId == 1) return;
      $timeout(function () {
        if (vm.minimalDurationForSelectedGroup > parseInt(daysBetweenMonths)) {
          vm.savingsOrderForm.maturityInMonths.$setValidity("minvalue", false);
        } else {
          vm.savingsOrderForm.maturityInMonths.$setValidity("minvalue", true);
        }

        if (vm.maxSavingDuration < parseInt(daysBetweenMonths)) {
          vm.savingsOrderForm.maturityInMonths.$setValidity("maxvalue", false);
        } else {
          vm.savingsOrderForm.maturityInMonths.$setValidity("maxvalue", true);
        }

        // if (daysBetweenMonths > parseInt(vm.maxDurationInDays)) {
        //   vm.savingsOrderForm.maturityInMonths.$setValidity("maxvalue", false);
        // } else {
        //   vm.savingsOrderForm.maturityInMonths.$setValidity("maxvalue", true);
        // }
      })
    }

    // function resetMaturityDateValidation() {
    //   vm.savingsOrderForm.maturityInMonths.$setValidity("minvalue", true);
    //   vm.savingsOrderForm.maturityInMonths.$setValidity("maxvalue", true);
    // }


    vm.amountChanged = function (amount) {
      if (!amount) amount = 0;
      if (vm.model.savingsType && (amount < parseInt(vm.model.savingsType.minInstalment))) {
        vm.savingsOrderForm.amount.$setValidity("minamount", false);
      } else {
        vm.savingsOrderForm.amount.$setValidity("minamount", true);
      }
    };
    //
    // function calculateInterestRate() {
    //   if (!vm.model.depositType) {
    //     vm.model.totalInterestRate = 0;
    //     return;
    //   }
    //   var dl = angular.copy(vm.model.depositType.depositOrderTypeCalculationList);
    //   for (var i = 0; i < dl.length; i++) {
    //     var item = dl[i];
    //     // First one that is bigger than amount
    //     if (vm.model.amount > item.fromAmount) {
    //       vm.model.totalInterestRate = item.interestRate;
    //       break;
    //     } else {
    //       vm.model.totalInterestRate = 0;
    //     }
    //   }
    // }


    vm.showOrderDetails = function (saving) {
      if (!saving.selected) {
        SavingsOrdersService.getSavingsOrderById(saving.id)
          .then(function (response) {
            angular.extend(saving, response);
            saving.translatedStatus = "orders." + saving.status;
            saving.payoutTypeTranslate = 'core.termDepositPayoutType.' + saving.payoutType;
            saving.endDate = (saving.endDate && new Date(saving.endDate).getFullYear() > 100) ? new Date (saving.endDate) : undefined;
            saving.selected = !saving.selected;
          }, function (error) {
            console.log(error);
          });
      } else {
        saving.selected = false;
      }
    };


    vm.loadAllAccountsTimeline = function () {
      vm.getTimelineItemsGrouped(true);
    };

    var createInsertObject = function () {
      if (!vm.model.savingsType) return;

      // if (selectedLanguage == "en") {
      //   vm.model.interestRange = _.findWhere(assignmentOfInterestOptionsEnglish, {id: vm.assignmentOfInterestId});
      // } else if (selectedLanguage == "sl") {
      //   vm.model.interestRange = _.findWhere(assignmentOfInterestOptionsSlovenian, {id: vm.assignmentOfInterestId});
      // }

      vm.model.interestRange = _.findWhere(assignmentOfInterestOptionsSlovenian, {id: vm.assignmentOfInterestId});


      var refInterestRate = vm.model.savingsType.savingOrderTypeCalculationList[0].referenceRateAmount;
      var savingRate = vm.model.savingsType.savingOrderTypeCalculationList[0].realRate;
      var data = {
        savingTypeId: vm.model.savingsType.savingType,
        destAccount: vm.model.fromAccountSelect.iban,
        durationInMonths: Math.round(vm.model.maturityInDays / 30),
        demarcationOfInterest: {
          id: vm.model.interestRange.name,
          description: vm.model.interestRange.name
        },
        savingRate: (savingRate) ? savingRate : 0,
        refInterestRate: (refInterestRate) ? refInterestRate : 0,
        endDate: vm.model.maturityDate,
        accountID: vm.model.fromAccountSelect.accountId,
        termsAndConditions: vm.userApproves,
        endDateChanged: vm.model.dateChanged,
        stOrdFirstPaymentMonth: vm.model.firstPaymentDate.getMonth() + 1,
        stOrdFirstPaymentYear: vm.model.firstPaymentDate.getFullYear(),
        stOrdFirstPaymentDate: vm.model.firstPaymentDate,
        stOrdLastPaymentDate: vm.model.lastPaymentDate,
        // stOrdAccount: vm.model.fromAccountSelect.iban,
        stOrdTearDate: vm.model.standingOrderPayment.value,
        // "depositPurchaseDate": "2016-11-16T09:16:38.108Z"
      };

      if (vm.model.savingsType.periodType == "K") {
        data.firstDepositAmount = vm.model.amount;
        data.monthlyDepositAmount = undefined;
        data.stOrdAmount = 0;
        data.stOrdIsRequested = undefined;
      } else if (vm.model.savingsType.periodType == "D") {
        data.firstDepositAmount = undefined;
        data.monthlyDepositAmount = vm.model.amount;
        data.stOrdAmount = vm.model.amount;
        data.stOrdIsRequested = true;
      }
      return data;
    };

    vm.next = function () {
      if (vm.nextButtonPressed) return;

      if (vm.savingsOrderForm.$invalid) {
        return;
      }
      vm.formSubmitted = true;
      vm.nextButtonPressed = true;
      SavingsOrdersService.validateSavingsOrder(createInsertObject()).then(function (response) {
        if (response.endDateChanged == "true") {
          AlertService.confirmationAlert({text: "orders.maturityDateChangedErr"})
            .then(function (accept) {
              if (!accept) return;
              vm.model.maturityDate = new Date(response.endDate);
              vm.model.firstPaymentDate = new Date(response.stOrdFirstPaymentDate);
              vm.model.lastPaymentDate = new Date(response.stOrdLastPaymentDate);
              vm.calculateMaturityDays(vm.model.maturityDate);
              vm.responseModel = angular.copy(vm.model);

              vm.steps = {
                step1: false,
                step2: true,
                step3: false
              };
            })
        } else {
          vm.responseModel = angular.copy(vm.model);
          vm.steps = {
            step1: false,
            step2: true,
            step3: false
          };
          vm.model.dateOfOpening = new Date();
          vm.model.firstPaymentDate = new Date(response.stOrdFirstPaymentDate);
          vm.model.lastPaymentDate = new Date(response.stOrdLastPaymentDate);
        }
      }).catch(function (error) {
        HelperService.showMessage(error, 'error');
      }).finally(function () {
        vm.nextButtonPressed = false;
      });
    };

    vm.confirm = function () {
      if (vm.confirmButtonPressed) return;
      vm.confirmButtonPressed = true;
      SavingsOrdersService.insertSavingOrder(createInsertObject()).then(function (response) {
        vm.steps = {
          step1: false,
          step2: false,
          step3: true
        };
      }).catch(function (error) {
        HelperService.showMessage(error, 'error');
      }).finally(function() {
        vm.confirmButtonPressed = false;
      });
    };

    vm.back = function () {
      vm.steps = {
        step1: true,
        step2: false,
        step3: false
      };
    };

    vm.newSavingsOrder = function () {
      $state.go("orders.newSavingsOrder", {}, {reload: true});
    };

    vm.onStndOrderPaymentDayChange = function (paymentDay) {
      var today = new Date();
      var maturityDate = vm.model.maturityDate;
      // Uzme se izabrani dan (8/18/28) u sljedečem mjesecu od trenutnog
      var firstPaymentDate = new Date(today.getFullYear(), today.getMonth() + 1, paymentDay);
      // Ne može biti preko maturity date, tako da se uzme zadnji moguči dan (8/18/28) prije maturity date
      var lastPaymentDate = new Date(maturityDate.getFullYear(), today.getMonth(), paymentDay);
      if (lastPaymentDate.getTime() > maturityDate.getTime()) {
        lastPaymentDate = new Date(maturityDate.getFullYear(), today.getMonth() - 1, paymentDay);
      }

      vm.model.firstPaymentDate = firstPaymentDate;
      vm.model.lastPaymentDate = lastPaymentDate;
      // vm.model.lastPaymentDate =
      console.log(paymentDay);
    };

    // =========================
    // START Timeline settings
    // =========================
    vm.recompile = {
      timeline: true
    };
    vm.timelineListGrouped = {};

    vm.loadMoreTimelineItemsGrouped = function () {
      vm.getTimelineItemsGrouped(false);
    };

    var timeRange = HelperService.getDateRange('thisMonth');
    vm.selectedAccountId = '';
    vm.depositsFilter = {
      page: 0,
      orderBy: 'savingEnteredDate DESC', //signDate
      pageSize: 15,
      signDateGTE: null,
      signDateLTE: null,
      accountId: null,
      userId: null,
      includeList: ["SavingOrderType"]
    };

    vm.userSettingsFilter = {
      page: 0,
      pageSize: 1000
    };

    // var getUserSettingsPage = function () {
    //   return UserSettingsService.getPage(vm.userSettingsFilter)
    //     .then(function (response) {
    //       vm.userSettings = response.result;
    //     })
    //     .catch(function (error) {
    //       $log.error(error);
    //     });
    // };

    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      }
      , {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }
      , {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }
      , {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }
      , {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
      , {
        item: {
          key: 'all',
          description: 'core.period.all'
        }
      }
    ];

    vm.selectedPeriod = vm.periodList[5];

    vm.paymentsPeriodFilter = function (item) {
      vm.selectedPeriod = item;
      var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      vm.depositsFilter.signDateGTE = timeRange.valueDateGTE;
      vm.depositsFilter.signDateLTE = timeRange.valueDateLTE;
      vm.getTimelineItemsGrouped(true);

      GoogleTagManagerHelperService.pushEvent('SavingsOrder', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));
    }

    vm.togglePaymentDetails = function (payment) {
      payment.selected = !payment.selected;
    };
    vm.getTimelineItemsGrouped = function (reset) {

      if (reset) {
        vm.depositsFilter.page = 0;
      } else {
        vm.depositsFilter.page += 1;
      }


      // if (vm.allRequests) {
      //   vm.depositsFilter.accountId = null;
      // } else {
        // if (vm.model.fromAccountSelect)
        //   vm.depositsFilter.accountId = vm.model.fromAccountSelect.accountId;

      // }

      var translatePaymentProperties = function (orders) {
        _.forEach(orders, function (item) {
          item.translatedStatus = "orders." + item.status;
          item.payoutTypeTranslate = 'core.termDepositPayoutType.' + item.payoutType;
        });
      };
      //vm.depositsFilter.userId = vm.userSettings.id;

      SavingsOrdersService.getSavingsOrders(vm.depositsFilter)
        .then(function (response) {
          translatePaymentProperties(response.result);
          vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
            existingData: vm.timelineListGrouped,
            newData: response,
            groupFunction: function (item) {
              var date = new Date(item.savingEnteredDate);
              // If we want to group only by date component, without hours
              date.setHours(0, 0, 0, 0);
              return date;
            },
            virtualRowFunction: function (e) {
              var month = new Date(e).getMonth() + 1;
              var day = new Date(e).getDate();
              var virtualRow = {
                isVirtual: true,
                valueDate: new Date(e),
                month: month,
                day: day
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: false
          });

          vm.recompile.timeline = true;
        }).catch(function (error) {
        $log.error(error);
      });
    };
    // =========================
    // END Timeline settings
    // =========================


    vm.downloadContract = function (id) {
      SavingsOrdersService.downloadContract(id)
        .catch(function(error){
          HelperService.showMessage(error, 'error');
        });
    }

    vm.downloadTermsAndConditions = function (id) {
      SavingsOrdersService.downloadTermsAndConditions(id)
        .catch(function(error){
          HelperService.showMessage(error, 'error');
        });
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name orders.factory:DepositOrdersService
   *
   * @description
   *
   */
  DepositOrdersService.$inject = ["$rootScope", "$sessionStorage", "EndpointsService", "$q", "$http", "ConfigService", "$localStorage", "$window", "HelperService", "$log", "SessionService"];
  angular
    .module('orders')
    .factory('DepositOrdersService', DepositOrdersService);

  function DepositOrdersService($rootScope, $sessionStorage,EndpointsService, $q, $http, ConfigService, $localStorage, $window, HelperService, $log, SessionService) {
    var DepositOrdersServiceBase = {};

    if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'depositOrder'){
      insert($sessionStorage.paymentStorageObject.object);
    }

    DepositOrdersServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.depositOrders, {
            params: params
          })
          .success(function (data) {
            if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl'){
              if(data.result)
                data.result = HelperService.sortAccounts(data.result);
            }
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.getManualDepositOrders = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.manualDepositOrders, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.getManualDepositOrdersById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.manualDepositOrders_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    DepositOrdersServiceBase.getDepositOrderInterestRangeType = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.depositOrderInterestRangeType, {
            params: params,
            headers: {
              "Accept-Language": $localStorage.appLanguage
            }
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.getAll = function (params) {
      var predefinedParams = {
        page: 0,
        pageSize: 1000
      };
      var extended = _.extend(predefinedParams, params);
      return DepositOrdersServiceBase.getPage(extended);
    };

    DepositOrdersServiceBase.getById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.depositOrders_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    function insert(insertObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        SessionService.saveStorageObject(insertObject, 'depositOrder');
        $http.post(response.links.depositOrders, insertObject)
          .success(function (data) {
            SessionService.removeStorageObject();
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    DepositOrdersServiceBase.insertDepositOrder = function (insertObject) {
      return insert(insertObject);
    };

    DepositOrdersServiceBase.insertManualDepositOrder = function (insertObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        SessionService.saveStorageObject(insertObject, 'depositOrder');
        $http.post(response.links.manualDepositOrders, insertObject, {headers: {"Accept-language": "sl"}})
          .success(function (data) {
            SessionService.removeStorageObject();
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.validateDepositOrder = function (insertObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.depositOrders_validate, insertObject)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.validateManualDepositOrder = function (insertObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.manualDepositOrders_validate, insertObject, {headers: {"Accept-language": "sl"}})
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.updateDepositOrderById = function (id, insertOsject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.depositOrders_id.replace('{id}', id), insertOsject)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.cancelDepositOrderById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.depositOrders_id.replace('{id}', id), {
            cancelDepositOrder: true
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.deleteDepositOrderById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.delete(response.links.depositOrders_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.signDepositOrderById = function (id, challengeResponse) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.depositOrders_sign, {
            id: id,
            signData: challengeResponse
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.getContractOverviewLink = function (insertObject) {
      var nonBlockingWindow = window.open('', '_self');
      var params = {
        AccountId: insertObject.accountId,
        CurrencyCode: insertObject.currencyCode,
        PayoutType: insertObject.payoutType,
        Amount: insertObject.amount,
        JobPurpose: insertObject.jobPurpose,
        TermPeriod: insertObject.termPeriod,
        IsRenewal: insertObject.isRenewal
      };

      var url = ConfigService.url + 'depositOrders/downloadLinkDraft';

      var deferred = $q.defer();
      $http.get(url, {
          params: params
        })
        .success(function (data) {
          if(data && data.url){
            nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
          } else {
            nonBlockingWindow.close();
          }
          deferred.resolve();
        }).error(function (msg, code) {
        nonBlockingWindow.close();
        deferred.reject(msg);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.downloadContract = function (contractName) {
      var nonBlockingWindow = window.open('', '_self');
      DepositOrdersServiceBase.getContractPdfLink(contractName)
        .then(function (pdfLink) {
          if (pdfLink) {
            // If we want to open link in same tab (immediate download)
            // window.location.href = pdfLink.url;
            // Opening in new empty tab
            nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(pdfLink.url);
          }
        })
        .catch(function (error) {
          nonBlockingWindow.close();
          HelperService.showMessage(error, 'error');
          $log.debug(error);
        });
    };

    // New method for statements download...
    DepositOrdersServiceBase.getContractPdfLink = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.manualDepositOrders_downloadLink_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DepositOrdersServiceBase.depositAccountCloseOverView = function (params) {

      var url = ConfigService.url;
      url = url + "accounts/depositAccountCloseOverView";

      var deferred = $q.defer();
      // TODO: Remove endpoints service call, no need for that
      EndpointsService.getLinks().then(function (response) {
        $http.get(url, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    };

    DepositOrdersServiceBase.downloadContract = function (id) {
      var deferred = $q.defer();
      var nonBlockingWindow = window.open('', '_self');
      EndpointsService.getLinks().then(function (response) {
        var link = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') ? response.links.manualDepositOrders_downloadLink_id : response.links.depositOrders_downloadLink_id;
          $http.get(link.replace('{id}', id))
            .success(function (data) {
              if (data && data.url) {
                nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
              } else {
                nonBlockingWindow.close();
              }
              deferred.resolve();
            }).error(function (msg, code) {
            nonBlockingWindow.close();
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    DepositOrdersServiceBase.downloadTermsAndConditions = function (id) {
      var deferred = $q.defer();
      var nonBlockingWindow = window.open('', '_self');
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.manualDepositOrders_downloadTermsLink_id.replace('{id}', id))
            .success(function (data) {
              if (data && data.url) {
                nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
              } else {
                nonBlockingWindow.close();
              }
              deferred.resolve();
            }).error(function (msg, code) {
            nonBlockingWindow.close();
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };


    return DepositOrdersServiceBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name orders.factory:DepositOrderTypesService
     *
     * @description
     *
     */
    DepositOrderTypesService.$inject = ["EndpointsService", "$q", "$http"];
    angular
        .module('orders')
        .factory('DepositOrderTypesService', DepositOrderTypesService);

    function DepositOrderTypesService(EndpointsService, $q, $http) {
        var DepositOrderTypesServiceBase = {};

        DepositOrderTypesServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.depositOrderTypes, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        DepositOrderTypesServiceBase.getAll = function (params) {
            var predefinedParams = {
                page: 0,
                pageSize: 1000
            };
            var extended = _.extend(predefinedParams, params);
            return DepositOrderTypesServiceBase.getPage(extended);
        };

        DepositOrderTypesServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.depositOrderTypes_id.replace('{id}', id))
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        
        
        
        


        return DepositOrderTypesServiceBase;
    }
}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name orders.controller:CancelDepositCtrl
   *
   * @description
   *
   */
  CancelDepositCtrl.$inject = ["$rootScope", "HelperService", "$log", "$state", "DepositOrdersService", "$translate", "CurrencyService", "AccountsService", "AlertService"];
  angular
    .module('orders')
    .controller('CancelDepositCtrl', CancelDepositCtrl);

  function CancelDepositCtrl($rootScope, HelperService, $log, $state, DepositOrdersService, $translate, CurrencyService, AccountsService, AlertService ) {
    var vm = this;
    vm.ctrlName = 'CancelDepositCtrl';

    vm.steps = {
      step1: true,
      step2: false
    };

    vm.depositReferenceNumber = '';
    vm.depositOrder = {};
    vm.canceledDepositOrder = {};

    vm.depositAccountCloseOverViewResponse = {};

    vm.depositAccount = {};
    vm.accountId = '';
    vm.currenciesList = [];

    vm.init = function () {
      CurrencyService.getCurrencyPage({
        pageSize: 5000
      }).then(function (response) {
        vm.currenciesList = response.result;
        if ($state.params.accountId) {
          vm.accountId = $state.params.accountId;

          AccountsService.getAccountById(vm.accountId).then(function (response) {
            vm.depositAccount = response;
            vm.depositReferenceNumber = vm.depositAccount.depositAccount.depositIdExternal;
            vm.getDepositOrderByReference();
          }).catch(function (error) {
            HelperService.showMessage(error, "error");
          });
        }
      }).catch(function (error) {
        $log.error(error);
      });
    };

    vm.confirmCancelDeposit = function () {
      if (vm.depositOrder) {

        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr') {
          AlertService.confirmationAlert()
            .then(function (result) {
              if (result) {
                DepositOrdersService.cancelDepositOrderById(vm.depositOrder.id)
                  .then(function (response) {
                    vm.canceledDepositOrder = response;
                    AlertService.infoAlert({
                      text: 'cancelDeposit.successInfoLabel1',
                      id: vm.canceledDepositOrder.id,
                      text2: 'cancelDeposit.successInfoLabel2'
                    })
                      .then(function () {
                        $state.go("depositAccountsOverview");
                      })
                  }, function (error) {
                    HelperService.showMessage(error, 'error')
                  })
              }
            })
            .catch(function () {
              $log.debug('Example failed!');
            });
        } else {

          DepositOrdersService.cancelDepositOrderById(vm.depositOrder.id).then(function (response) {
            vm.canceledDepositOrder = response;
            vm.steps = {
              step1: false,
              step2: true
            };
          })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
              $log.error(error);
            });

        }
      }
    };

    vm.getDepositAccountCloseOverview = function (params) {
      DepositOrdersService.depositAccountCloseOverView(params).then(function (response) {
        $log.debug('depositAccountCloseOverView', response);
        if(response){
          vm.depositAccountCloseOverViewResponse = response.depositAccountClose;
        }
      }).catch(function (error) {
        HelperService.showMessage(error, "error");
      });
    };

    vm.getDepositOrderByReference = function () {
      DepositOrdersService.getPage({
        referenceNumber: vm.depositReferenceNumber
      }).then(function (response) {
        if (response && response.result[0]) {
          vm.depositOrder = response.result[0];
          var currencyList = _.find(vm.currenciesList, function (o) {
            return o.code == vm.depositOrder.currencyCode
          });

          if (currencyList) {
            vm.depositOrder.currencySymbol = currencyList.symbol;
          }
          $log.debug('depositOrder', vm.depositOrder);

          var params = {};
          params.AccountId = vm.depositAccount.accountId;
          params.DepositIdExternal = vm.depositAccount.depositAccount.depositIdExternal;
          params.DepositStartDate = new Date(vm.depositAccount.depositAccount.depositStartDate);

          vm.getDepositAccountCloseOverview(params);
        } else {
          // TODO: Response empty...
        }

      }).catch(function (error) {
        HelperService.showMessage(error, "error");
      });
    };

    vm.backToAccount = function () {
      $state.go('accounts', {accountId: vm.accountId});
    };

    vm.init();
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name orders.controller:AddNewExpressLoanCtrl
     *
     * @description
     *
     */
    AddNewExpressLoanCtrl.$inject = ["$q", "$log", "AccountsService", "HelperService", "UserSettingsService", "AlertService", "ValidationService", "$state"];
    angular
        .module('orders')
        .controller('AddNewExpressLoanCtrl', AddNewExpressLoanCtrl);

  function AddNewExpressLoanCtrl($q, $log, AccountsService, HelperService, UserSettingsService, AlertService, ValidationService, $state) {
        var vm = this;
        vm.ctrlName = 'AddNewExpressLoanCtrl';
        vm.tempObj = {
          dateInput: HelperService.setCustomMonthPeriodByDays(new Date(), 1)
        };
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    vm.selectedAccount = {};
        vm.paymentDays = [];
        vm.currencySymbol = 'EUR';
        vm.formSubmitted = false;
        vm.accountList = [];

        vm.disabled = function (date, mode) {
          return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        vm.numberOfMonths = [{
            description: 4
        }, {
            description: 5
        }, {
            description: 6
        }, {
            description: 7
        }, {
            description: 8
        }, {
            description: 9
        }, {
            description: 10
        }, {
            description: 11
        }, {
            description: 12
        }];

        vm.steps = {
          step1: true,
          step2: false,
          step3: false
        };

        var today = new Date(); // Friday
        //alert(today);
        today.setDate(today.getDate()+2); // t+2
        while (today.getDay() == 6 || today.getDay() == 0) today.setDate(today.getDate() + 1);
        //alert(today);

        vm.dateOptions = {
          // minDate: HelperService.setCustomMonthPeriodByDays(new Date(), 5),
          minDate: new Date(today),
          maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
        };

        vm.tempObj.dateInput = new Date(today);


        vm.datePickerOpened = false;
        vm.openDatePicker = function () {
          vm.datePickerOpened = true;
        };

        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
        // vm.tempObj.monthsOfCredit = vm.numberOfMonths[0];
        vm.tempObj.monthsOfCredit = "";

        vm.back = function () {
          vm.steps = {
            step1: true,
            step2: false,
            step3: false
          };
        };

        vm.addNewExpressLoan = function () {
          $state.go("orders.addNewExpressLoan", {}, {reload: true});
        };

        function loadPaymentDays() {
            var params = null;
            return AccountsService.creditPossibilityOrderTearDateType(params)
                .then(function (response) {
                    vm.paymentDays = _.sortBy(response.result, function(day) {
                      return parseInt(day.id.replace(/\D+/g, ''));
                    });
                    vm.tempObj.paymentDay = vm.paymentDays[0];
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        }

        function init() {
            var promises = [
                AccountsService.getPage({
                    accountTypeGroupList: 'CurrentAccount'
                }),
                UserSettingsService.getPage(),
                loadPaymentDays()
            ];

            $q.all(promises).then(function (responses) {

              _.forEach(responses[0].result, function (account) {
                if (account.isOwn && account.currencySymbol == "EUR")
                  vm.accountList.push(account);
              });

              if(vm.accountList.length > 0) {
                  vm.selectedAccount = vm.accountList[0];
                }

                vm.tempObj.userSettings = responses[1].result[0];

            }).catch(function (error) {
                HelperService.showMessage(error, 'error');
            });

        }

        vm.selectAccount = function (account) {
            if (!account) return;
            vm.selectedAccount = account;
        };

        function createObject() {

            return {
                creditTransferAccount: vm.selectedAccount.iban,
                paymentAccount: vm.selectedAccount.iban,
                approvalDate: vm.tempObj.dateInput,
                amount: vm.tempObj.amount,
                phoneNumber: vm.tempObj.userSettings.gsm,
                email: vm.tempObj.userSettings.email,
                period: vm.tempObj.monthsOfCredit,
                orderTearDate: {
                  id: vm.tempObj.paymentDay.id,
                  description: vm.tempObj.paymentDay.description
                },
                notificationType: {
                  id: "phone",
                  description: "string"
                },
              note: " "
            };
        }

          vm.validateCreditPossibilityOrder = function () {
            if(vm.nextButtonPressed) return;

            vm.formSubmitted = true;
            if (!vm.newExpressLoanForm.$valid) {
                return;
            }
            var obj = createObject();
            vm.nextButtonPressed = true;
            AccountsService.validateCreditPossibilityOrder(obj)
                .then(function (response) {
              vm.responseModel = response;
              vm.steps = {
                step1: false,
                step2: true,
                step3: false
              };
            })
            .catch(function (error) {
                HelperService.showMessage(error, 'error');
            }).finally(function() {
              vm.nextButtonPressed = false;
            });

        };

        vm.confirmCreditPossibilityOrder = function () {
          if (vm.confirmButtonPressed) return;
          vm.confirmButtonPressed = true;
          AccountsService.creditPossibilityOrder(createObject()).then(function (response) {
            vm.steps = {
              step1: false,
              step2: false,
              step3: true
            };
          }).catch(function (error) {
            HelperService.showMessage(error, 'error');
          }).finally(function () {
            vm.confirmButtonPressed = false;
          });
        };


        init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name navigation.factory:NotificationCountService
   *
   * @description
   *
   */
  NotificationCountService.$inject = ["$q", "$http", "$log", "EndpointsService"];
  angular
    .module('navigation')
    .factory('NotificationCountService', NotificationCountService);

  function NotificationCountService($q, $http, $log, EndpointsService) {
    var NotificationCountServiceBase = {};

    function getRequestUrl(type, links) {
      var url = "";
      switch (type) {
        case "Payments":
          url = links.payments_count;
          break;
        case "eInvoiceDocuments":
          url = links.eInvoiceDocuments_count;
          break;
        case "Messages":
          url = links.messages_count;
          break;
      }
      return url;
    };

    NotificationCountServiceBase.getNotificationCount = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        var url = getRequestUrl(params.type, response.links);
        if(url) {
          $http.head(url, {
            params: params.query
          }).success(function (data, status, headers) {
            deferred.resolve(headers('x-total-count'));
          }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(0);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return NotificationCountServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('navigation')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('navigation', {
        url: '/navigation',
        templateUrl: 'navigation/navigation.tpl.html',
        controller: 'NavigationCtrl',
        controllerAs: 'navigation'
      });
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name navigation.controller:NavigationCtrl
     *
     * @description
     *
     */
    NavigationCtrl.$inject = ["$log", "$window", "UserSettingsService", "AlertService", "AccountsService", "ConfigEndpointService", "$localStorage", "HelperService", "$rootScope", "CTLocalizationService", "$filter", "$q", "$uibModal", "SessionService", "FundsService", "$state", "ConfigService", "NotificationCountService", "EndpointsService", "ViberService", "GoogleTagManagerHelperService", "$translate"];
    angular
        .module('navigation')
        .controller('NavigationCtrl', NavigationCtrl);

    function NavigationCtrl($log, $window, UserSettingsService, AlertService, AccountsService, ConfigEndpointService,
        $localStorage, HelperService, $rootScope, CTLocalizationService, $filter,
        $q, $uibModal, SessionService, FundsService, $state, ConfigService, NotificationCountService,
        EndpointsService, ViberService, GoogleTagManagerHelperService, $translate) {
        var vm = this;
        vm.eInvoices = '';
        vm.countryCode = '';
        vm.eInvoiceNotifications = 0;
        vm.rejectedPaymentsNotifications = 0;
        vm.unsignedPaymentsNotifications = 0;
        vm.totalNotificationsCount = 0;
        // vm.groupPaymentsNotifications = 0;
        vm.changeLanguage = '';
        // Controller init function
        vm.selectedLanguage = '';

        vm.init = function () {
            vm.userSettings = {};
            vm.userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
            vm.userSettingsFilter = {
                page: 0,
                pageSize: 1000
            };
            vm.generalTerms = '';
            vm.isSecondaryNavigationOpen = false;
            vm.isPrimaryNavigationOpen = false;
            vm.isMobilePrimaryNavigationOpen = false;
            vm.isMobileSecondaryNavigationOpen = false;
            vm.navigationSubItems = [];
            vm.currentNavigationItem = '';

            /*      getDefaultData();
             getUserSettingsPage();*/

            if ($localStorage.appLanguage) {
                vm.selectedLanguage = _.find(vm.languageOptions, function (language) {
                    return language.code === $localStorage.appLanguage;
                });
            }
            EndpointsService.getLinks()
                .then(function (data) {
                    vm.links = data.links;
                });
            getUserSettingsPage();
            getDefaultData();
            getNotificationsCount();

            // var promises = [getDefaultData(), getUserSettingsPage()]; //
            // $q.all(promises)
            //   .then(function (data) {
            //     getNotificationsCount();
            //   })
            //   .catch(function (error) {
            //     HelperService.showMessage(error, 'error');
            //   });

            vm.allAccounts = [];
            // getNotificationsCount();


        };

        var getUserSettingsPage = function () {
            // return UserSettingsService.getPage(vm.userSettingsFilter)
            //   .then(function (response) {
            //     vm.userSettings = response;
            //   })
            //   .catch(function (error) {
            //     $log.error(error);
            //   });
        };

        vm.pushGtmNavigationEvent = function (navigationItem, isSecondaryNavigation) {
            var navItemLabel = '';
            if (isSecondaryNavigation) {
                switch (navigationItem) {
                case "AccountsOverview":
                    navItemLabel = $translate.instant("navigation.allAccountsOverview");
                    break;
                case "DepositAccountsOverview":
                    if (vm.countryCode != 'sr' && vm.countryCode != 'mne') {
                        navItemLabel = $translate.instant("navigation.allDepositOverview");
                    } else {
                        navItemLabel = $translate.instant("navigation.allDepositOverviewSerbMne");
                    }
                    break;
                case "PaymentsOverview":
                    navItemLabel = $translate.instant("navigation.paymentsList");
                    break;
                case "DomesticPayment":
                    if (vm.countryCode != 'sl') {
                        navItemLabel = $translate.instant("navigation.domesticPayment");
                    } else {
                        navItemLabel = $translate.instant("navigation.domesticPaymentSl");
                    }
                    break;
                case "TransferToMyAccount":
                    navItemLabel = $translate.instant("navigation.transferToMyAccount");
                    break;
                case "InternationalPayment":
                    navItemLabel = $translate.instant("navigation.internationalPayment");
                    break;
                case "CurrencyConversion":
                    navItemLabel = $translate.instant("navigation.exchangeOffice");
                    break;
                case "ExchangeRates":
                    navItemLabel = $translate.instant("navigation.exchangeRates");
                    break;
                case "eInvoicesOverview":
                    navItemLabel = $translate.instant("navigation.eInvoices");
                    break;
                case "TemplateListOverview":
                    navItemLabel = $translate.instant("navigation.myTemplatesList");
                    break;
                case "StandingOrders":
                    navItemLabel = $translate.instant("navigation.standingOrders");
                    break;
                case "PaymentsReturn":
                    navItemLabel = $translate.instant("navigation.paymentsReturn");
                    break;
                case "SepaTransactions":
                    navItemLabel = $translate.instant("navigation.sepaTransactions");
                    break;
                case "SepaSettings":
                    navItemLabel = $translate.instant("navigation.sepa");
                    break;
                case "LoansOverview":
                    navItemLabel = $translate.instant("navigation.loansOverview");
                    break;
                case "InvestmentsOverview":
                    navItemLabel = $translate.instant("navigation.investmentsOverview");
                    break;
                case "Settings":
                    navItemLabel = $translate.instant("navigation.settings");
                    break;
                case "NewTermDeposit":
                    navItemLabel = $translate.instant("accountsOverview.newTermDepositButtonLabel");
                    break;
                case "eSavingBookRequests":
                    if (vm.countryCode == 'sl') {
                        navItemLabel = $translate.instant("accountsOverview.newSavingButtonLabel_SLO");
                    } else {
                        navItemLabel = $translate.instant("accountsOverview.newESavingAccountButtonLabel");
                    }
                    break;
                default:
                    navItemLabel = navigationItem;
                }

                GoogleTagManagerHelperService.pushEvent(navigationItem, 'SecondaryNavigationItem', navItemLabel);
            } else {
                switch (navigationItem) {
                case "Dashboard":
                    navItemLabel = $translate.instant("navigation.dashboard");
                    break;
                case "Accounts":
                    navItemLabel = $translate.instant("navigation.accountsAndCards");
                    break;
                case "Payments":
                    navItemLabel = $translate.instant("navigation.payments");
                    break;
                case "Deposit":
                    navItemLabel = $translate.instant("navigation.deposit");
                    break;
                case "Loans":
                    navItemLabel = $translate.instant("navigation.loans");
                    break;
                case "Settings":
                    navItemLabel = $translate.instant("navigation.settings");
                    break;
                case "Messages":
                    navItemLabel = $translate.instant("navigation.messages");
                    break;
                case "Investments":
                    navItemLabel = $translate.instant("navigation.investments");
                    break;
                case "Viber":
                    navItemLabel = navigationItem;
                    break;
                case "EmployeePayroll":
                    navItemLabel = $translate.instant("navigation.employeePayroll");
                    break;
                case "Documents":
                    navItemLabel = $translate.instant("navigation.documents");
                    break;
                default:
                    navItemLabel = navigationItem;
                }

                GoogleTagManagerHelperService.pushEvent(navigationItem, 'PrimaryNavigationItem', navItemLabel);
            }


        };

        vm.toggleSecondaryNavigation = function (mainItem, mobileNavigation) {

            if (mobileNavigation) {
                vm.isMobilePrimaryNavigationOpen = false;
                vm.isMobileSecondaryNavigationOpen = true;
            } else {

                // Close primary navigation if same item is clicked, or if navigation is opening first time
                if (mainItem && mainItem === vm.currentNavigationItem || vm.currentNavigationItem === '') {
                    vm.isSecondaryNavigationOpen = !vm.isSecondaryNavigationOpen;
                }
            }

            // Populate secondary navigation items, or reset variables if secondary navigation is closing
            if (mainItem && (vm.isSecondaryNavigationOpen || vm.isMobileSecondaryNavigationOpen)) {
                populateSubItems(mainItem);
            } else {
                clearSecondaryNavigationItems();
            }

            vm.pushGtmNavigationEvent(mainItem);
        };

        var clearSecondaryNavigationItems = function () {
            vm.navigationSubItems = [];
            vm.currentNavigationItem = '';
        };

        vm.closeSecondaryNavigation = function () {
            vm.isSecondaryNavigationOpen = false;
            clearSecondaryNavigationItems();
        };

        vm.closeMobileNavigation = function () {
            vm.isMobilePrimaryNavigationOpen = false;
            vm.isMobileSecondaryNavigationOpen = false;
            clearSecondaryNavigationItems();
        };

        vm.openPrimaryNavigation = function () {
            vm.isMobilePrimaryNavigationOpen = true;
            vm.isMobileSecondaryNavigationOpen = false;
        };

        vm.closeMobilePrimaryNavigation = function () {
            vm.isMobilePrimaryNavigationOpen = false;
        };

        vm.backToPrimaryNavigation = function () {
            vm.isMobilePrimaryNavigationOpen = true;
            vm.isMobileSecondaryNavigationOpen = false;
            clearSecondaryNavigationItems();
        };


        var populateSubItems = function (name) {

            vm.currentNavigationItem = name;
            vm.navigationSubItems = [];


            // Only if some of these items is opened, populate secondary navigation items
            if (name === 'Accounts' || name === 'Deposit' || name === 'Loans') {

                var accountsFilter = {
                    page: 0,
                    pageSize: 100,
                    orderBy: 'isFavorite desc,accountType,iban,currencySymbol'
                };

                switch (name) {
                case "Accounts":
                    accountsFilter.notInAccountTypeGroupList = ['LoanAccountType', 'SavingAccountTypes', 'DepositAccountTypes'];
                    break;
                case "Deposit":
                    accountsFilter.includeList = ['depositAccount'];
                    accountsFilter.accountTypeGroupList = ['SavingAccountTypes', 'DepositAccountTypes'];
                    break;
                case "Loans":
                    accountsFilter.includeList = ['loanAccount'];
                    accountsFilter.accountTypeGroupList = ['LoanAccountType'];
                    break;
                }

                // Load accounts
                AccountsService.getPage(accountsFilter)
                    .then(function (response) {
                        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                            switch (name) {
                            case "Deposit":
                                response.result = $filter('orderBy')(response.result, ['-isFavorite', '-isOwn', '-accountType.group'])
                                break;
                            case "Accounts":
                                response.result = $filter('orderBy')(response.result, ['-accountType.group', '-isOwn', 'sortOrderId'])
                                break;
                            }
                        }
                        vm.navigationSubItems = response.result;
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            }

            // Load investments
            if (name === 'Investments') {
                getFunds();
            }

        };

        var setAppLanguage = function () {
            var lang = $localStorage.appLanguage;

            if (lang == undefined) {
                if (ConfigService.defaultLocale == undefined || ConfigService.defaultLocale == 'undefined') {
                    $localStorage.appLanguage = angular.copy($localStorage.code);
                } else {
                    //                    $localStorage.appLanguage = ConfigService.defaultLocale;
                    $localStorage.appLanguage = angular.copy($localStorage.code);
                }
                lang = $localStorage.appLanguage;
            }

            vm.selectedLanguage = _.find(vm.languageOptions, function (language) {
                return language.code === lang;
            });


            if (!vm.selectedLanguage)
                vm.selectedLanguage = vm.languageOptions[0];

            vm.changeLanguage(lang);
        };

        $rootScope.$on("markAsRead", function (evt, data) {
            getUnreadMessagesNotification();
        });

        var getDefaultData = function () {

            var defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
            if (defaultData.APILocation) {
                $localStorage.code = defaultData.APILocation;
                vm.countryCode = defaultData.APILocation;
                vm.clubLink = defaultData.AddikoClub;
                vm.eTradeLink = defaultData.eTrade;
                vm.generalTerms = defaultData.GeneralTerms;
                vm.languageOptions = CTLocalizationService.getLocalLanguageOptions(vm.countryCode);
                setAppLanguage();
            } else {
                vm.languageOptions = CTLocalizationService.getLanguageOptions();
                setAppLanguage();
            }

            // return ConfigEndpointService.getDefaultData()
            //   .then(function (response) {
            //     if (response.APILocation) {
            //       $localStorage.code = response.APILocation;
            //       vm.countryCode = $localStorage.code;
            //       vm.clubLink = response.AddikoClub;
            //       vm.eTradeLink = response.eTrade;
            //       vm.generalTerms = response.GeneralTerms;
            //
            //       vm.languageOptions = CTLocalizationService.getLocalLanguageOptions(vm.countryCode);
            //       setAppLanguage();
            //     } else {
            //       vm.languageOptions = CTLocalizationService.getLanguageOptions();
            //       setAppLanguage();
            //     }
            //   })
            //   .catch(function (error) {
            //     HelperService.showMessage(error, 'error');
            //   });
        };

        // List of available languages
        //vm.languageOptions = CTLocalizationService.getLanguageOptions();

        // Listen to language changes from header
        $rootScope.$on('appLanguageChangedHeader', function (evt, lang) {
            if (lang && lang.langCode) {
                vm.selectedLanguage = _.find(vm.languageOptions, function (language) {
                    return language.code === lang.langCode;
                });
            }
        });

        // If user changes language from navigation
        vm.changeLanguage = function () {
            CTLocalizationService.setLanguage(vm.selectedLanguage.code);
            $rootScope.$broadcast('appLanguageChangedNavigation', {
                langCode: vm.selectedLanguage.code
            });
        };


        // Notifications
        var getNotificationsCount = function () {

            var promises = [
        getRejectedPaymentsNotifications(),
        getUnsignedPaymentsNotifications()
        // getGroupPaymentsNotifications()
      ];

            //if (vm.countryCode !== 'sr' && vm.countryCode !== 'mne') {
            //  promises.push(getInvoiceDocumentNotifications());
            //}
            promises.push(getInvoiceDocumentNotifications());
            $q.all(promises)
                .then(function () {
                    vm.totalNotificationsCount = vm.eInvoiceNotifications + vm.rejectedPaymentsNotifications + vm.unsignedPaymentsNotifications;
                    $rootScope.APP_GLOBAL_SETTINGS.counters.eInvoiceNotifications = angular.copy(vm.eInvoiceNotifications);
                    $rootScope.APP_GLOBAL_SETTINGS.counters.rejectedPaymentsNotifications = angular.copy(vm.rejectedPaymentsNotifications);
                    $rootScope.APP_GLOBAL_SETTINGS.counters.unsignedPaymentsNotifications = angular.copy(vm.unsignedPaymentsNotifications);
                    $rootScope.APP_GLOBAL_SETTINGS.counters.countersLoaded = true;

                }).catch(function (error) {
                    $log.debug("Total notification error: ", error);
                });
            getUnreadMessagesNotification();
        };

        // $rootScope.$on("eInvoiceSubAdded", function () {
        //   getNotificationsCount();
        // })

        $rootScope.$on("paymentInserted", function (evt, data) {
          // GET REJECTED PAYMENTS
          // GET PENDING PAYMETNS NUMBER
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
            getUnsignedPaymentsNotifications();
          } else {
            getNotificationsCount();
          }
        });


        var getInvoiceDocumentNotifications = function () {
            var notifyParams = {
                type: 'eInvoiceDocuments',
                query: {
                    status: 'Inserted'
                }
            };

            if (vm.userSettings.lastLoginDate) {
                notifyParams.query.valueDateGTE = new Date(vm.userSettings.lastLoginDate);
            }

            if (vm.countryCode == 'sl') { //temporarly put first day of the current year
                var date = new Date();
                date.setDate(new Date().getDate() - 365);
                notifyParams.query.valueDateGTE = new Date(date);
            }

            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.eInvoiceNotifications = +response;
                })
                .catch(function (error) {
                    vm.eInvoiceNotifications = 0;
                    $log.error(error);
                });
        };

        var getRejectedPaymentsNotifications = function () {
            var notifyParams = {
                type: 'Payments',
                query: {
                    status: 'Rejected'
                }
            };

            if (vm.userSettings.lastLoginDate) {

                if (vm.countryCode == 'sl') {
                    notifyParams.query.dueDateGTE = new Date(vm.userSettings.lastLoginDate);
                } else {
                    notifyParams.query.dateCreatedGTE = new Date(vm.userSettings.lastLoginDate);
                }
            }



            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.rejectedPaymentsNotifications = +response;
                })
                .catch(function (error) {
                    vm.rejectedPaymentsNotifications = 0;
                    $log.error(error);
                });
        };

        var getUnsignedPaymentsNotifications = function () {
            var notifyParams = {
                type: "Payments",
                query: {
                    status: "Opened"
                }
            };

            if (vm.countryCode == 'sl') {
                notifyParams.query.status = '';
                notifyParams.query.statusList = ['InProcessing', 'WaitingQueue', 'Opened'];
            }

            if (vm.userSettings.lastLoginDate && vm.countryCode != 'sl') {
                notifyParams.query.dateCreatedGTE = new Date(vm.userSettings.lastLoginDate);
            }
            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.unsignedPaymentsNotifications = +response;

                    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                      vm.totalNotificationsCount = vm.eInvoiceNotifications + vm.rejectedPaymentsNotifications + vm.unsignedPaymentsNotifications;
                      $rootScope.APP_GLOBAL_SETTINGS.counters.eInvoiceNotifications = angular.copy(vm.eInvoiceNotifications);
                      $rootScope.APP_GLOBAL_SETTINGS.counters.rejectedPaymentsNotifications = angular.copy(vm.rejectedPaymentsNotifications);
                      $rootScope.APP_GLOBAL_SETTINGS.counters.unsignedPaymentsNotifications = angular.copy(vm.unsignedPaymentsNotifications);
                    }
                })
                .catch(function (error) {
                    vm.unsignedPaymentsNotifications = 0;
                    $log.error(error);
                });
        };

        var getUnreadMessagesNotification = function () {
            var notifyParams = {
                type: 'Messages',
                query: {
                    unreadMessages: true,
                    messageStatus: "Received"
                }
            };
            // Filter only unread messages from last login
            if (vm.userSettings.lastLoginDate) {
                notifyParams.query.creationDateGTE = new Date(vm.userSettings.lastLoginDate);
            }
            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.unreadMessagesNotification = +response;
                })
                .catch(function (error) {
                    vm.unreadMessagesNotification = 0;
                    $log.error(error);
                });
        };

        var getFunds = function () {
            FundsService.getPage()
                .then(function (response) {
                    if (response.result && response.result.length > 0) {
                        vm.navigationSubItems = response.result;
                    }
                })
                .catch(function (error) {
                    //          HelperService.showMessage(error, 'error');
                    $log.debug("Funds:", error);
                })
        };

        vm.gotoNewOrder = function () {
            GoogleTagManagerHelperService.pushEvent('BuyStocks', 'SecondaryNavigationItem', $translate.instant('navigation.newOrder'));
            $state.go('investments.form.new', {
                orderType: 'new',
                fundId: undefined
            }, {
                reload: true
            });
            vm.closeSecondaryNavigation();
        };

        vm.logOut = function () {

            var modalInstance = $uibModal.open({
                    templateUrl: 'core/logout-confirm-modal.tpl.html',
                    backdrop: 'static',
                    size: 'lg'
                })
                .result.then(function (result) {
                    console.log(result);
                    if (result == "logout") SessionService.logout();
                });
        };

        vm.notYetImplemented = function () {
            AlertService.infoAlert({
                text: "Not yet implemented!"
            });
        };

        vm.openPayLifeBalancePage = function () {
            $window.open($rootScope.APP_GLOBAL_SETTINGS.defaultData.PayLifeBalanceInquiry, '_blank');
        };

        vm.deactivateViber = function () {
            var userId = $rootScope.APP_GLOBAL_SETTINGS.userSettings.id;
            ViberService.deactivate(userId, {
                    deactivateViberUser: true,
                    isWebCall: true
                })
                .then(function (res) {
                    AlertService.infoAlert({
                        text: "Viber service deactivated successfully!"
                    });
                })
                .catch(function (err) {
                    HelperService.showMessage(err, 'error');
                })
        };

      // Viber functionality is just for BiH environment
      vm.checkUserViberActivation = function () {
        var stateToGo = $rootScope.APP_GLOBAL_SETTINGS.isViberActivated ? 'viber.deactivate' : 'viber';
        console.log("State to go");
        $state.go(stateToGo);
      };


        vm.init();
    }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name messages
   * @description
   *
   */
  angular
    .module('messages', [
      'ui.router'
    ]);
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name messages.controller:NewMessageCtrl
     *
     * @description
     *
     */
    NewMessageCtrl.$inject = ["$rootScope", "MessagesService", "ValidationService", "$log", "$timeout", "$state", "HelperService", "GoogleTagManagerHelperService"];
    angular
            .module('messages')
            .controller('NewMessageCtrl', NewMessageCtrl);

    function NewMessageCtrl($rootScope, MessagesService, ValidationService, $log, $timeout, $state, HelperService, GoogleTagManagerHelperService) {
        var vm = this;
        vm.ctrlName = 'NewMessageCtrl';
        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.isReplyMessage = false;
        vm.inputOptions = {
          maxLength: ''
        };

        if(vm.countryCode != 'hr'){ //only BH, SR, MNE have maxlength , SLO dont have subject
          vm.inputOptions.maxLength = 60;
        }

        vm.init = function () {
            vm.regex = ValidationService.getRegexPatternsForValidation();

            if ($state.params.messageId) {
                MessagesService.getById($state.params.messageId)
                        .then(function (response) {
                            $log.debug("messageByID", response);

                            vm.sendMessageObject.subject = "RE: " + response.subject;
                            vm.sendMessageObject.body = HelperService.formatResponseBody(response.body, true);

                            vm.isReplyMessage = true;
                            $timeout(function () {
                                setCaretToPos(document.getElementById("msgBody"), 0);
                            });
                        })
                        .catch(function (error) {
                            $log.error(error);
                        });

            }
        };

        vm.showSuccessSection = false;

        vm.sendMessageObject = {
            subject: "",
            body: ""
        };

        vm.resetSendMessageObject = function () {
            vm.sendMessageObject.subject = "";
            vm.sendMessageObject.body = "";
        };

        vm.successfulMessageSubject = "";




        vm.sendMessage = function (sendMessageForm) {
          if (vm.sendButtonPressed) return;
          if(sendMessageForm.$invalid) return;
            vm.sendButtonPressed = true;
            MessagesService.sendMessage(vm.sendMessageObject)
                    .then(function (response) {
                        $log.debug("message send response", response);
                        vm.showSuccessSection = true;
                        vm.resetSendMessageObject();
                        vm.successfulMessageSubject = response.subject;
                        GoogleTagManagerHelperService.pushEvent('Messages', 'MessageSent', 'Message sent successfully!');
                    })
                    .catch(function (error) {
                        $log.error(error);
                    })
                    .finally(function () {
                      vm.sendButtonPressed = true;
                    });
        };

        vm.createNewMessage = function () {
          vm.showSuccessSection = false;
          vm.isReplyMessage = false;
          $state.go("newMessage", {}, {reload: true})
        }

        function setSelectionRange(input, selectionStart, selectionEnd) {
            if (input.setSelectionRange) {
                input.focus();
                input.setSelectionRange(selectionStart, selectionEnd);
            } else if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', selectionEnd);
                range.moveStart('character', selectionStart);
                range.select();
            }
        }

        function setCaretToPos(input, pos) {
            setSelectionRange(input, pos, pos);
        }

        /*function formatResponseBody(body) {
         var replyText ="\n\n----------------------------------------------------------------------------------------------------------------------------";
         body = body ? '\n' + String(body).replace(/<[^>]+>/gm, '') : '';
         return replyText + body;
         }*/

        vm.init();
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name messages.factory:MessagesService
     *
     * @description
     *
     */
    MessagesService.$inject = ["$rootScope", "$sessionStorage", "EndpointsService", "$q", "$http", "$log", "SessionService", "HelperService"];
    angular
        .module('messages')
        .factory('MessagesService', MessagesService);

    function MessagesService($rootScope, $sessionStorage,EndpointsService, $q, $http, $log, SessionService, HelperService) {
        var MessagesServiceBase = {};

      if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'message'){
        insert($sessionStorage.paymentStorageObject.object);
      }

        MessagesServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.messages, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        MessagesServiceBase.getById = function (messageId) {

            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                    $http.get(response.links.messages_id.replace('{id}', messageId))
                        .success(function (data) {
                            deferred.resolve(data);
                        }).error(function (msg, code) {
                            deferred.reject(msg);
                        });
                },
                function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        MessagesServiceBase.deleteMessageById = function (messageId) {

            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                    $http.delete(response.links.messages_id.replace('{id}', messageId))
                        .success(function (data) {
                            deferred.resolve(data);
                        }).error(function (msg, code) {
                            deferred.reject(msg);
                        });
                },
                function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        MessagesServiceBase.markAsRead = function (messageId) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.put(response.links.messages_id_markAsRead.replace("{id}", messageId))
                    .success(function (data) {
                        if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl' )
                          $rootScope.$broadcast("markAsRead");
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

      function insert(sendObject) {
        var insert = {};
        insert.subject = sendObject.subject;
        insert.body = sendObject.body;
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
            SessionService.saveStorageObject(sendObject, 'message');
            $http.post(response.links.messages, insert)
              .success(function (data) {
                SessionService.removeStorageObject();
                deferred.resolve(data);
              }).error(function (msg, code) {
              deferred.reject(msg);
            });
          },
          function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      }

      MessagesServiceBase.sendMessage = function (sendObject) {
        return insert(sendObject);
        };

      MessagesServiceBase.printMessage = function (id) {
        var deferred = $q.defer();
        var nonBlockingWindow = window.open('', '_self');
        EndpointsService.getLinks().then(function (response) {
            $http.get(response.links.messages_downloadLink_id.replace('{id}', id))
              .success(function (data) {
                if (data && data.url) {
                  nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
                } else {
                  nonBlockingWindow.close();
                }
                deferred.resolve();
              }).error(function (msg, code) {
              nonBlockingWindow.close();
              deferred.reject(msg);
            });
          },
          function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      MessagesServiceBase.downloadMessageAttachment = function (url) {
        var deferred = $q.defer();
        var nonBlockingWindow = window.open('', '_self');
        $http.get(url)
          .success(function (data) {
            if (data && data.url) {
              nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
            } else {
              nonBlockingWindow.close();
            }
            deferred.resolve();
          }).error(function (msg, code) {
          nonBlockingWindow.close();
          deferred.reject(msg);
        });
        return deferred.promise;
      };

      MessagesServiceBase.getOrderById = function (id) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.orders_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };


        return MessagesServiceBase;
    }
}());

(function () {
    'use strict';

    config.$inject = ["$stateProvider"];
    angular
        .module('messages')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('messages', {
                url: '/messages',
                templateUrl: 'messages/messages.tpl.html',
                controller: 'MessagesCtrl',
                controllerAs: 'messages'
            })
            .state('newMessage', {
                url: '/new-message/:messageId',
                views: {
                    '@': {
                        templateUrl: 'messages/new-message.tpl.html',
                        controller: 'NewMessageCtrl',
                        controllerAs: 'newMessage'
                    }
                }
            });
    }
}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name messages.controller:MessagesCtrl
   *
   * @description
   *
   */
  MessagesCtrl.$inject = ["$rootScope", "$q", "MessagesService", "PaymentsService", "$log", "$scope", "$state", "HelperService", "$window", "GoogleTagManagerHelperService", "$translate"];
  angular
      .module('messages')
      .controller('MessagesCtrl', MessagesCtrl);

  function MessagesCtrl($rootScope, $q, MessagesService, PaymentsService, $log, $scope, $state, HelperService, $window, GoogleTagManagerHelperService, $translate) {
    var vm = this;
    vm.expandMessage = expandMessage;
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

    vm.messageSelectedTab = 1;

    vm.init = function () {
      loadMessages();
    };


    vm.messageSearchInput = {
      subject: ""
    };

    $scope.$watch('messages.messageSearchInput', function (newValue) {
      $log.debug(newValue);
    }, true);


    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      },
      {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }, {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }, {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }, {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }, {
        item: {
          key: $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" ? "all2y" : 'all',
          description: 'core.period.allMessages'
        }
      }
    ];

    vm.selectedPeriod = vm.periodList[5];
    vm.numberOfMessagesToShow = 10;
    vm.messageToShow = {};
    vm.openReplySection = false;
    vm.messageSuccessfullySent = false;


    vm.timeFilter = function (item) {
      vm.selectedPeriod = item;
      var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      if(vm.messageSelectedTab == 1){
        vm.unreadMessagesFilter.creationDateGTE = timeRange.valueDateGTE;
        vm.unreadMessagesFilter.creationDateLTE = timeRange.valueDateLTE;
        vm.readMessagesFilter.creationDateGTE = timeRange.valueDateGTE;
        vm.readMessagesFilter.creationDateLTE = timeRange.valueDateLTE;
        vm.getUnreadMessagesPage(true);
        vm.getReadMessagesPage(true);
      }

      if(vm.messageSelectedTab == 2){
        vm.sentMessagesFilter.creationDateGTE = timeRange.valueDateGTE;
        vm.sentMessagesFilter.creationDateLTE = timeRange.valueDateLTE;
        vm.getSentMessagesPage(true);
      }

      if(vm.messageSelectedTab == 3){
        vm.globalMessagesFilter.creationDateGTE = timeRange.valueDateGTE;
        vm.globalMessagesFilter.creationDateLTE = timeRange.valueDateLTE;
        vm.getGlobalMessagesPage(true);
      }
      GoogleTagManagerHelperService.pushEvent('Messages', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));

      //loadMessages();
    };

    vm.selectTab = function (tabIndex, translateLabel) {
      if (tabIndex == vm.messageSelectedTab) return;
      vm.messageSelectedTab = tabIndex;
      GoogleTagManagerHelperService.pushEvent('Messages', 'Tab', $translate.instant(translateLabel));
    }


    vm.replyToMessage = function (messageId) {
      $state.go('newMessage', {
        messageId: messageId
      });
    };


    vm.deleteMessage = function (messageId, reloadList) {

      MessagesService.deleteMessageById(messageId)
          .then(function (response) {
            if (response === true) {
              $log.debug("deleteMessage", response);
              if (response) {
                switch (reloadList) {
                  case "unread":
                    vm.getUnreadMessagesPage();
                    break;
                  case "read":
                    vm.getReadMessagesPage();
                    break;
                  case "sent":
                    vm.getSentMessagesPage();
                    break;
                  default:
                    vm.getUnreadMessagesPage();
                    vm.getReadMessagesPage();
                    vm.getSentMessagesPage();
                    break;
                }
              }
            }

          })
          .catch(function (error) {
            $log.error(error);
          });
    };

    function getMessage(message,section) {
      var promises = [];
      promises.push(MessagesService.getById(message.id));
      // if(message.messageType == "Order" && message.objectId) {
      //   promises.push(MessagesService.getOrderById(message.objectId));
      // }
      $q.all(promises)
        .then(function(response) {
          angular.extend(message, response[0]);
          // if(response[1]) {
          //   angular.extend(message, response[1]);
          // }
          console.log(message);

          message.selected = !message.selected;
          message.wasSelected = true;

          if (section === 'unread' && message.selected) {
            markMessageAsRead(message);
          }

        }, function (error) {
          $log.info(error);
        });
    }


    function markMessageAsRead(message) {
      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && message.messageType == 'Global'){
        return;
      }

      MessagesService.markAsRead(message.id)
          .then(function (response) {
            if (response === true) {
              $log.debug("markAsRead Response ", response);
            }
          })
          .catch(function (error) {
            $log.error(error);
          });

      vm.openReplySection = false;
      vm.messageToShow = {};
    }

    vm.unreadMessagesFilter = {
      page: 0,
      unreadMessages: true,
      messageStatus: "Received",
      creationDateGTE: null,
      creationDateLTE: null,
      orderBy: "creationDate DESC",
      pageSize: 10
    };
    vm.readMessagesFilter = {
      page: 0,
      unreadMessages: false,
      messageStatus: "Received",
      creationDateGTE: null,
      creationDateLTE: null,
      orderBy: "creationDate DESC",
      pageSize: 10
    };
    vm.sentMessagesFilter = {
      page: 0,
      messageStatus: "Sent",
      creationDateGTE: null,
      creationDateLTE: null,
      orderBy: "creationDate DESC",
      pageSize: 10
    };

    vm.globalMessagesFilter = {
      page: 0,
      pageSize: 10,
      messageType: "Global",
      messageStatus: "Received",
      creationDateGTE: null,
      creationDateLTE: null,
      orderBy: "creationDate DESC"

    };

    if(vm.countryCode === 'bh'){
      vm.unreadMessagesFilter.includeList = 'attachmentList';
      vm.readMessagesFilter.includeList = 'attachmentList';
    }

    vm.unreadMessagesList = {};
    vm.readMessagesList = {};
    vm.sentMessagesList = {};
    vm.globalMessagesList = {};

    if(vm.countryCode== 'sl'){
      vm.messageSelectedTab = 3;

      vm.unreadMessagesList.result = [];
      vm.readMessagesList.result = [];

      //--------  CLIENT MESSAGES FILTER OPTIONS START
      vm.unreadMessagesPage = 1;
      vm.unreadMessagesPageSize = 10;
      vm.paginationLimitUnread = function(data) {
        if(vm.countryCode != 'sl')
          return;

        return vm.unreadMessagesPageSize * vm.unreadMessagesPage;
      };
      vm.hasMoreItemsToShowUnread = function() {
        return vm.unreadMessagesPage < (vm.unreadMessagesList.result.length / vm.unreadMessagesPageSize);
      };
      vm.showMoreItemsUnread = function() {
        vm.unreadMessagesPage = vm.unreadMessagesPage + 1;
      };

      vm.readMessagesPage = 1;
      vm.readMessagesPageSize = 10;
      vm.paginationLimitRead = function() {
        if(vm.countryCode != 'sl')
          return;

        return vm.readMessagesPageSize * vm.readMessagesPage;
      };
      vm.hasMoreItemsToShowRead = function() {
        return vm.readMessagesPage < (vm.readMessagesList.result.length / vm.readMessagesPageSize);
      };
      vm.showMoreItemsRead = function() {
        vm.readMessagesPage = vm.readMessagesPage + 1;
      };

      //---------- CLIENT FILTER END

    }



    function getUnreadMessagesPageSLO(reset) {
      vm.unreadMessagesFilter.page = null;
      vm.unreadMessagesFilter.pageSize = null;

      MessagesService.getPage(vm.unreadMessagesFilter)
        .then(function (response) {
            vm.unreadMessagesList = response;
            vm.unreadMessagesList.result = _.filter(response.result, function (message) {
              return message.messageType != 'Global';
            });
        })
        .catch(function (error) {
          $log.error(error);
        });
    }

    function getReadMessagesPageSLO(reset) {
      vm.readMessagesFilter.page = null;
      vm.readMessagesFilter.pageSize = null;

      MessagesService.getPage(vm.readMessagesFilter)
        .then(function (response) {
            vm.readMessagesList = response;
            vm.readMessagesList.result = _.filter(response.result, function (message) {
              return message.messageType != 'Global';
            });
        })
        .catch(function (error) {
          $log.error(error);
        });
    }

    vm.getUnreadMessagesPage = function (reset) {
      if(vm.countryCode == 'sl'){
        getUnreadMessagesPageSLO(reset);
        return;
      }

      if (reset) {
        vm.unreadMessagesFilter.page = 0;
      } else {
        vm.unreadMessagesFilter.page += 1;
      }
      if (vm.unreadMessagesList.hasMore || vm.unreadMessagesFilter.page === 0) {
        MessagesService.getPage(vm.unreadMessagesFilter)
            .then(function (response) {
              if (reset) {
                vm.unreadMessagesList = response;
                $log.debug("vm.unreadMessagesList", vm.unreadMessagesList);
              } else {
                vm.unreadMessagesList.hasMore = response.hasMore;
                vm.unreadMessagesList.result = vm.unreadMessagesList.result.concat(response.result);
              }
            })
            .catch(function (error) {
              $log.error(error);
            });
      }
    };
    vm.getReadMessagesPage = function (reset) {
      if(vm.countryCode == 'sl'){
        getReadMessagesPageSLO(reset);
        return;
      }

      if (reset) {
        vm.readMessagesFilter.page = 0;
      } else {
        vm.readMessagesFilter.page += 1;
      }
      if (vm.readMessagesList.hasMore || vm.readMessagesFilter.page === 0) {
        MessagesService.getPage(vm.readMessagesFilter)
            .then(function (response) {
              if (reset) {
                vm.readMessagesList = response;
                $log.debug("vm.readMessagesList", vm.readMessagesList);
              } else {
                vm.readMessagesList.hasMore = response.hasMore;
                vm.readMessagesList.result = vm.readMessagesList.result.concat(response.result);
              }
            })
            .catch(function (error) {
              $log.error(error);
            });
      }

    };
    vm.getSentMessagesPage = function (reset) {
      if (reset) {
        vm.sentMessagesFilter.page = 0;
      } else {
        vm.sentMessagesFilter.page += 1;
      }
      if (vm.sentMessagesList.hasMore || vm.sentMessagesFilter.page === 0) {
        MessagesService.getPage(vm.sentMessagesFilter)
            .then(function (response) {
              if (reset) {
                vm.sentMessagesList = response;
                $log.debug("vm.sentMessagesList", vm.sentMessagesList);
              } else {
                vm.sentMessagesList.hasMore = response.hasMore;
                vm.sentMessagesList.result = vm.sentMessagesList.result.concat(response.result);
              }
            })
            .catch(function (error) {
              $log.error(error);
            });
      }
    };
    vm.getGlobalMessagesPage = function (reset) {
      if (reset) {
        vm.globalMessagesFilter.page = 0;
      } else {
        vm.globalMessagesFilter.page += 1;
      }
      if (vm.globalMessagesList.hasMore || vm.globalMessagesFilter.page === 0) {
        MessagesService.getPage(vm.globalMessagesFilter)
          .then(function (response) {
            if (reset) {

              vm.globalMessagesList = response;
              $log.debug("vm.globalMessagesList", vm.globalMessagesList);
            } else {
              vm.globalMessagesList.hasMore = response.hasMore;
              vm.globalMessagesList.result = vm.globalMessagesList.result.concat(response.result);
            }
          })
          .catch(function (error) {
            $log.error(error);
          });
      }
    };
    vm.openMessagesNotificationLink = function () {
      vm.messageToShow = {};
      vm.openReplySection = false;
      vm.messageSuccessfullySent = false;
    };

    vm.openReplySectionAction = function (e, message) {
      vm.openReplySection = true;
      e.preventDefault();
      vm.messageToShow = message;
      vm.sendMessageObject.subject = "RE: " + message.subject;
    };
    vm.cancelReply = function () {
      vm.messageSuccessfullySent = false;
      vm.openReplySection = false;
      vm.messageToShow = {};
      vm.resetSendMessageObject();

    };

    vm.loadMoreMessages = function (type) {
      switch (type) {
        case "u":
          vm.getUnreadMessagesPage(false);
          break;
        case "r":
          vm.getReadMessagesPage(false);
          break;
        case "s":
          vm.getSentMessagesPage(false);
          break;
        case "global":
          vm.getGlobalMessagesPage(false);
          break;
      }
    };

    vm.printMessage = function (messageId) {
      //MessagesService.printMessage(messageId)
      //  .then(function (link) {
      //    if (link) {
      //      $window.open(link, '_blank');
      //    }
      //  })
      //  .catch(function (error) {
      //    HelperService.showMessage(error, 'error');
      //  })
      MessagesService.printMessage(messageId);
    };


    function expandMessage(message, section) {

      // SLO Api does not return message content, so it is required to get it separatedly
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && !message.wasSelected) {
        getMessage(message, section);
      } else {
        message.selected = !message.selected;

        // Mark unread messages as read when expanded
        if (section === 'unread' && message.selected) {
          markMessageAsRead(message);
        }
      }
    }

    vm.openPayment = function(data){
      if  (data.messageType == "Payment") {
          PaymentsService.downloadPaymentPdf(data.objectId);
        } else {
          // Order
        return;
      }
    };


    vm.downloadMessageAttachment = function (link) {
      if (link.itemList) {
        MessagesService.downloadMessageAttachment(link.itemList.linkAttachment);
      }
    };


    function loadMessages() {
      vm.getUnreadMessagesPage(true);
      vm.getReadMessagesPage(true);

      if(vm.countryCode == 'sl'){
        vm.selectedPeriod = vm.periodList[5];
        var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
        vm.sentMessagesFilter.creationDateGTE = timeRange.valueDateGTE;
        vm.sentMessagesFilter.creationDateLTE = timeRange.valueDateLTE;

        vm.getGlobalMessagesPage(true);
      }

      vm.getSentMessagesPage(true);
    }


    vm.init();
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name materialAdmin
   * @description
   *
   */
  angular
    .module('materialAdmin', [
      //'ngAnimate', --if we enable this. current version of ui.bootstrap and angular prevents carousel from working!!!
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'angular-loading-bar',
      'oc.lazyLoad',
      'nouislider',
      'ngTable'
    ])
    .config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider){
      cfpLoadingBarProvider.includeBar = false;

    }]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name materialAdmin.service:Services
   *
   * @description
   *
   */
  angular
    .module('materialAdmin')

    // =========================================================================
    // Header Messages and Notifications list Data
    // =========================================================================

    .service('messageService', ['$resource', function($resource){
        this.getMessage = function(img, user, text) {
            var gmList = $resource("data/messages-notifications.json");

            return gmList.get({
                img: img,
                user: user,
                text: text
            });
        }
    }])


    // =========================================================================
    // Best Selling Widget Data (Home Page)
    // =========================================================================

    .service('bestsellingService', ['$resource', function($resource){
        this.getBestselling = function(img, name, range) {
            var gbList = $resource("data/best-selling.json");

            return gbList.get({
                img: img,
                name: name,
                range: range,
            });
        }
    }])


    // =========================================================================
    // Todo List Widget Data
    // =========================================================================

    .service('todoService', ['$resource', function($resource){
        this.getTodo = function(todo) {
            var todoList = $resource("data/todo.json");

            return todoList.get({
                todo: todo
            });
        }
    }])


    // =========================================================================
    // Recent Items Widget Data
    // =========================================================================

    .service('recentitemService', ['$resource', function($resource){
        this.getRecentitem = function(id, name, price) {
            var recentitemList = $resource("data/recent-items.json");

            return recentitemList.get ({
                id: id,
                name: name,
                price: price
            })
        }
    }])


    // =========================================================================
    // Recent Posts Widget Data
    // =========================================================================

    .service('recentpostService', ['$resource', function($resource){
        this.getRecentpost = function(img, user, text) {
            var recentpostList = $resource("data/messages-notifications.json");

            return recentpostList.get ({
                img: img,
                user: user,
                text: text
            })
        }
    }])

    // =========================================================================
    // Data Table
    // =========================================================================

//    .service('tableService', [function(){
//        this.data = {
//            "hasMore": false,
//            "result": [
//                {
//                    "id": 1604169919,
//                    "accountId": "1012927152",
//                    "payeeName": "",
//                    "payeeAddress1": "",
//                    "toAccountNumber": "3061153903179275",
//                    "name": "azra opci",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 1604169935,
//                    "accountId": "1012927152",
//                    "formType": "8889",
//                    "payeeName": "",
//                    "payeeAddress1": "",
//                    "toAccountNumber": "1340100000001672",
//                    "name": "Hamobaksuz",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 2000000257,
//                    "accountId": "1015276919",
//                    "formType": "5050",
//                    "payeeName": "PRIMATELJ N",
//                    "payeeAddress1": "",
//                    "toAccountNumber": "3061153903179275",
//                    "amount": 22,
//                    "name": "uzorak n",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 2000000262,
//                    "accountId": "1000006406",
//                    "formType": "8889",
//                    "payeeName": "PPPPP",
//                    "payeeAddress1": "DDDDD",
//                    "toAccountNumber": "3061153700162931",
//                    "amount": 333,
//                    "name": "opci n",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100000621,
//                    "accountId": "289868642",
//                    "formType": "5050",
//                    "payeeName": "ydfdsf",
//                    "payeeAddress1": "",
//                    "toAccountNumber": "BA393061123785732695",
//                    "amount": 120,
//                    "name": "uzorak",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100001094,
//                    "accountId": "289868642",
//                    "formType": "5050",
//                    "payeeName": "ydfdsf",
//                    "payeeAddress1": "",
//                    "toAccountNumber": "BA393061123785732695",
//                    "amount": 120,
//                    "name": "Int",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100001109,
//                    "accountId": "1012927152",
//                    "formType": "8889",
//                    "payeeName": "GGGGG",
//                    "payeeAddress1": "JJJJJ",
//                    "toAccountNumber": "3061153903179275",
//                    "amount": 10,
//                    "name": "neki",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100001710,
//                    "accountId": "278547259",
//                    "formType": "8889",
//                    "payeeName": "FFFFFFFFFFFF",
//                    "payeeAddress1": "GGGGGGGGGGGGG",
//                    "toAccountNumber": "3061153903179275",
//                    "amount": 22333,
//                    "name": "grickavac novi",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100001725,
//                    "accountId": "1012927152",
//                    "formType": "8889",
//                    "payeeName": "GGGGG",
//                    "payeeAddress1": "JJJJJ",
//                    "toAccountNumber": "3061153903179275",
//                    "amount": 10,
//                    "name": "mrn",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100001728,
//                    "accountId": "278547259",
//                    "formType": "8889",
//                    "payeeName": "FFFFFFFFFFFF",
//                    "payeeAddress1": "GGGGGGGGGGGGG",
//                    "toAccountNumber": "3061153903179275",
//                    "amount": 22333,
//                    "name": "kod",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100001736,
//                    "accountId": "1012927152",
//                    "formType": "8888",
//                    "payeeName": "WQ",
//                    "payeeAddress1": "WE",
//                    "toAccountNumber": "1340100000001672",
//                    "amount": 120,
//                    "name": "uzorak",
//                    "payeeCity": "",
//                    "taxPayerId": "9999999999999",
//                    "revenuePaymentType": "0",
//                    "revenueCode": "000000",
//                    "municipality": "000",
//                    "reference": "0000000001",
//                    "budgetOrganization": "0000000",
//                    "taxPeriodFrom": "2014-05-30T00:00:00+02:00",
//                    "taxPeriodTo": "2014-05-30T00:00:00+02:00"
//                },
//                {
//                    "id": 9100002918,
//                    "accountId": "1012927152",
//                    "formType": "8889",
//                    "payeeName": "ORC 2 TEST",
//                    "payeeAddress1": "INCIDENT 6622",
//                    "toAccountNumber": "3060190000395672",
//                    "name": "asdadas",
//                    "payeeCity": "",
//                    "revenueCode": "      "
//                },
//                {
//                    "id": 9100002921,
//                    "accountId": "1012927152",
//                    "formType": "8888",
//                    "payeeName": "WQ",
//                    "payeeAddress1": "WE",
//                    "toAccountNumber": "1340100000001672",
//                    "name": "samra",
//                    "payeeCity": "",
//                    "taxPayerId": "9999999999999",
//                    "revenuePaymentType": "0",
//                    "revenueCode": "000000",
//                    "municipality": "000",
//                    "reference": "0000000001",
//                    "budgetOrganization": "0000000",
//                    "taxPeriodFrom": "2014-05-30T00:00:00+02:00",
//                    "taxPeriodTo": "2014-05-30T00:00:00+02:00"
//                }
//            ]
//        }
//        ;
        /*this.data = [
            {
                "id": 10238,
                "name": "Marc Barnes",
                "email": "marc.barnes54@example.com",
                "username": "MarcBarnes",
                "contact": "(382)-122-5003"
            },
            {
                "id": 10243,
                "name": "Glen Curtis",
                "email": "glen.curtis11@example.com",
                "username": "GlenCurtis",
                "contact": "(477)-981-4948"
            },
            {
                "id": 10248,
                "name": "Beverly Gonzalez",
                "email": "beverly.gonzalez54@example.com",
                "username": "BeverlyGonzalez",
                "contact": "(832)-255-5161"
            },
            {
                "id": 10253,
                "name": "Yvonne Chavez",
                "email": "yvonne.chavez@example.com",
                "username": "YvonneChavez",
                "contact": "(477)-446-3715"
            },
            {
                "id": 10234,
                "name": "Melinda Mitchelle",
                "email": "melinda@example.com",
                "username": "MelindaMitchelle",
                "contact": "(813)-716-4996"

            },
            {
                "id": 10239,
                "name": "Shannon Bradley",
                "email": "shannon.bradley42@example.com",
                "username": "ShannonBradley",
                "contact": "(774)-291-9928"
            },
            {
                "id": 10244,
                "name": "Virgil Kim",
                "email": "virgil.kim81@example.com",
                "username": "VirgilKim",
                "contact": "(219)-181-7898"
            },
            {
                "id": 10249,
                "name": "Letitia Robertson",
                "email": "letitia.rober@example.com",
                "username": "Letitia Robertson",
                "contact": "(647)-209-4589"
            },
            {
                "id": 10237,
                "name": "Claude King",
                "email": "claude.king22@example.com",
                "username": "ClaudeKing",
                "contact": "(657)-988-8701"
            },
            {
                "id": 10242,
                "name": "Roland Craig",
                "email": "roland.craig47@example.com",
                "username": "RolandCraig",
                "contact": "(932)-935-9471"
            },
            {
                "id": 10247,
                "name": "Colleen Parker",
                "email": "colleen.parker38@example.com",
                "username": "ColleenParker",
                "contact": "(857)-459-2792"
            },
            {
                "id": 10252,
                "name": "Leah Jensen",
                "email": "leah.jensen27@example.com",
                "username": "LeahJensen",
                "contact": "(861)-275-4686"
            },
            {
                "id": 10236,
                "name": "Harold Martinez",
                "email": "martinez67@example.com",
                "username": "HaroldMartinez",
                "contact": "(836)-634-9133"
            },
            {
                "id": 10241,
                "name": "Keith Lowe",
                "email": "keith.lowe96@example.com",
                "username": "KeithLowe",
                "contact": "(778)-787-3100"
            },
            {
                "id": 10246,
                "name": "Charles Walker",
                "email": "charles.walker90@example.com",
                "username": "CharlesWalker",
                "contact": "(486)-440-4716"
            },
            {
                "id": 10251,
                "name": "Lillie Curtis",
                "email": "lillie.curtis12@example.com",
                "username": "LillieCurtis",
                "contact": "(342)-510-2258"
            },
            {
                "id": 10235,
                "name": "Genesis Reynolds",
                "email": "genesis@example.com",
                "username": "GenesisReynolds",
                "contact": "(339)-375-1858"
            },
            {
                "id": 10240,
                "name": "Oscar Palmer",
                "email": "oscar.palmer24@example.com",
                "username": "OscarPalmer",
                "contact": "(544)-270-9912"
            },
            {
                "id": 10245,
                "name": "Lena Bishop",
                "email": "Lena Bishop",
                "username": "LenaBishop",
                "contact": "(177)-521-1556"
            },
            {
                "id": 10250,
                "name": "Kent Nguyen",
                "email": "kent.nguyen34@example.com",
                "username": "KentNguyen",
                "contact": "(506)-533-6801"
            }
        ];*/
//    }])


    // =========================================================================
    // Malihu Scroll - Custom Scroll bars
    // =========================================================================
    .service('scrollService', function() {
        var ss = {};
        ss.malihuScroll = function scrollBar(selector, theme, mousewheelaxis) {
            $(selector).mCustomScrollbar({
                theme: theme,
                scrollInertia: 100,
                axis:'yx',
                mouseWheel: {
                    enable: true,
                    axis: mousewheelaxis,
                    preventDefault: true
                }
            });
        }

        return ss;
    })


    //==============================================
    // BOOTSTRAP GROWL
    //==============================================

    .service('growlService', function(){
        var gs = {};
        gs.growl = function(message, type) {
            $.growl({
                message: message
            },{
                type: type,
                allow_dismiss: true,
                label: 'Cancel',
                className: 'btn-xs btn-inverse',
                placement: {
                    from: 'top',
                    align: 'right'
                },
                delay: 2500,
                animate: {
                        enter: 'animated bounceIn',
                        exit: 'animated bounceOut'
                },
                offset: {
                    x: 20,
                    y: 85
                }
            });
        }

        return gs;
    })

}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('materialAdmin')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('materialAdmin', {
        url: '/material-admin',
        templateUrl: 'material-admin/material-admin.tpl.html',
        controller: 'MaterialAdminCtrl',
        controllerAs: 'mactrl'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name materialAdmin.controller:MaterialAdminCtrl
   *
   * @description
   *
   */
  angular
    .module('materialAdmin')
/*    .controller('MaterialAdminCtrl', MaterialAdminCtrl);

  function MaterialAdminCtrl() {
    var vm = this;
    vm.ctrlName = 'MaterialAdminCtrl';
  }

  materialAdmin*/
    // =========================================================================
    // Base controller for common functions
    // =========================================================================

      .controller('MaterialAdminCtrl', ["$scope", "$timeout", "$state", "growlService", "$uibModal", "$log", function($scope,$timeout, $state, growlService, $uibModal, $log){
      //DEJAN
      console.log($scope);
      $scope.items = ['item1', 'item2', 'item3'];

      $scope.animationsEnabled = true;

      $scope.openTlItemModal = function (selectedTlItem, size) {
          console.log(selectedTlItem);
          var modalInstance = $uibModal.open({
              animation: $scope.animationsEnabled,
              templateUrl: 'tlItemModalContent.html',
              controller: tlModalInstanceCtrl,
              size: size,
              resolve: {
                  tlItem: function () {
                      return selectedTlItem;
                  }
              }
          });

          modalInstance.result.then(function (selectedItem) {
              $scope.selected = selectedItem;
          }, function () {
              $log.info('Modal dismissed at: ' + new Date());
          });
      };

      $scope.toggleAnimation = function () {
          $scope.animationsEnabled = !$scope.animationsEnabled;
      };
      var tlModalInstanceCtrl = function ($scope, $uibModalInstance, tlItem) {
          console.log(tlItem);
          $scope.tlItem = tlItem;

          /*$scope.ok = function () {
              $uibModalInstance.close($scope.selected.item);
          };*/

          $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
          };
      };
      tlModalInstanceCtrl.$inject = ["$scope", "$uibModalInstance", "tlItem"];





        //Welcome Message
        //growlService.growl('Welcome back Mallinda!', 'inverse')


        // Detact Mobile Browser
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
           angular.element('html').addClass('ismobile');
        }

        // By default Sidbars are hidden in boxed layout and in wide layout only the right sidebar is hidden.
        this.sidebarToggle = {
            left: false,
            right: false
        }

        // By default template has a boxed layout
        this.layoutType = localStorage.getItem('ma-layout-status');

        // For Mainmenu Active Class
        this.$state = $state;

        //Close sidebar on click
        this.sidebarStat = function(event) {
            if (!angular.element(event.target).parent().hasClass('active')) {
                this.sidebarToggle.left = false;
            }
        }

        //Listview Search (Check listview pages)
        this.listviewSearchStat = false;

        this.lvSearch = function() {
            this.listviewSearchStat = true;
        }

        //Listview menu toggle in small screens
        this.lvMenuStat = false;

        //Blog
        this.wallCommenting = [];

        this.wallImage = false;
        this.wallVideo = false;
        this.wallLink = false;
        this.amelTest="AMEL";
        //Skin Switch
        this.currentSkin = 'blue';

        this.skinList = [
            'lightblue',
            'bluegray',
            'cyan',
            'teal',
            'green',
            'orange',
            'blue',
            'purple'
        ];

        this.skinSwitch = function (color) {
            this.currentSkin = color;
        }

    }])


    // =========================================================================
    // Best Selling Widget
    // =========================================================================

    .controller('bestsellingCtrl', ["bestsellingService", function(bestsellingService){
        // Get Best Selling widget Data
        this.img = bestsellingService.img;
        this.name = bestsellingService.name;
        this.range = bestsellingService.range;

        this.bsResult = bestsellingService.getBestselling(this.img, this.name, this.range);
    }])


    // =========================================================================
    // Todo List Widget
    // =========================================================================

    .controller('todoCtrl', ["todoService", function(todoService){

        //Get Todo List Widget Data
        this.todo = todoService.todo;

        this.tdResult = todoService.getTodo(this.todo);

        //Add new Item (closed by default)
        this.addTodoStat = false;
    }])


    // =========================================================================
    // Recent Items Widget
    // =========================================================================

    .controller('recentitemCtrl', ["recentitemService", function(recentitemService){

        //Get Recent Items Widget Data
        this.id = recentitemService.id;
        this.name = recentitemService.name;
        this.parseInt = recentitemService.price;

        this.riResult = recentitemService.getRecentitem(this.id, this.name, this.price);
    }])


    // =========================================================================
    // Recent Posts Widget
    // =========================================================================

    .controller('recentpostCtrl', ["recentpostService", function(recentpostService){

        //Get Recent Posts Widget Items
        this.img = recentpostService.img;
        this.user = recentpostService.user;
        this.text = recentpostService.text;

        this.rpResult = recentpostService.getRecentpost(this.img, this.user, this.text);
    }])


    //=================================================
    // Profile
    //=================================================

    .controller('profileCtrl', ["growlService", function(growlService){

        //Get Profile Information from profileService Service

        //User
        this.profileSummary = "Sed eu est vulputate, fringilla ligula ac, maximus arcu. Donec sed felis vel magna mattis ornare ut non turpis. Sed id arcu elit. Sed nec sagittis tortor. Mauris ante urna, ornare sit amet mollis eu, aliquet ac ligula. Nullam dolor metus, suscipit ac imperdiet nec, consectetur sed ex. Sed cursus porttitor leo.";

        this.fullName = "Mallinda Hollaway";
        this.gender = "female";
        this.birthDay = "23/06/1988";
        this.martialStatus = "Single";
        this.mobileNumber = "00971123456789";
        this.emailAddress = "malinda.h@gmail.com";
        this.twitter = "@malinda";
        this.twitterUrl = "twitter.com/malinda";
        this.skype = "malinda.hollaway";
        this.addressSuite = "44-46 Morningside Road";
        this.addressCity = "Edinburgh";
        this.addressCountry = "Scotland";

        //Edit
        this.editSummary = 0;
        this.editInfo = 0;
        this.editContact = 0;


        this.submit = function(item, message) {
            if(item === 'profileSummary') {
                this.editSummary = 0;
            }

            if(item === 'profileInfo') {
                this.editInfo = 0;
            }

            if(item === 'profileContact') {
                this.editContact = 0;
            }

            growlService.growl(message+' has updated Successfully!', 'inverse');
        }

    }])



    //=================================================
    // LOGIN
    //=================================================

    .controller('loginCtrl', function(){

        //Status

        this.login = 1;
        this.register = 0;
        this.forgot = 0;
    })


    //=================================================
    // CALENDAR
    //=================================================

    .controller('calendarCtrl', ["$modal", function($modal){

        //Create and add Action button with dropdown in Calendar header.
        this.month = 'month';

        this.actionMenu = '<ul class="actions actions-alt" id="fc-actions">' +
                            '<li class="dropdown" dropdown>' +
                                '<a href="" dropdown-toggle><i class="zmdi zmdi-more-vert"></i></a>' +
                                '<ul class="dropdown-menu dropdown-menu-right">' +
                                    '<li class="active">' +
                                        '<a data-calendar-view="month" href="">Month View</a>' +
                                    '</li>' +
                                    '<li>' +
                                        '<a data-calendar-view="basicWeek" href="">Week View</a>' +
                                    '</li>' +
                                    '<li>' +
                                        '<a data-calendar-view="agendaWeek" href="">Agenda Week View</a>' +
                                    '</li>' +
                                    '<li>' +
                                        '<a data-calendar-view="basicDay" href="">Day View</a>' +
                                    '</li>' +
                                    '<li>' +
                                        '<a data-calendar-view="agendaDay" href="">Agenda Day View</a>' +
                                    '</li>' +
                                '</ul>' +
                            '</div>' +
                        '</li>';


        //Open new event modal on selecting a day
        this.onSelect = function(argStart, argEnd) {
            var modalInstance  = $modal.open({
                templateUrl: 'addEvent.html',
                controller: 'addeventCtrl',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    calendarData: function() {
                        var x = [argStart, argEnd];
                        return x;
                    }
                }
            });
        }
    }])

    //Add event Controller (Modal Instance)
    .controller('addeventCtrl', ["$scope", "$modalInstance", "calendarData", function($scope, $modalInstance, calendarData){

        //Calendar Event Data
        $scope.calendarData = {
            eventStartDate: calendarData[0],
            eventEndDate:  calendarData[1]
        };

        //Tags
        $scope.tags = [
            'bgm-teal',
            'bgm-red',
            'bgm-pink',
            'bgm-blue',
            'bgm-lime',
            'bgm-green',
            'bgm-cyan',
            'bgm-orange',
            'bgm-purple',
            'bgm-gray',
            'bgm-black',
        ]

        //Select Tag
        $scope.currentTag = '';

        $scope.onTagClick = function(tag, $index) {
            $scope.activeState = $index;
            $scope.activeTagColor = tag;
        }

        //Add new event
        $scope.addEvent = function() {
            if ($scope.calendarData.eventName) {

                //Render Event
                $('#calendar').fullCalendar('renderEvent',{
                    title: $scope.calendarData.eventName,
                    start: $scope.calendarData.eventStartDate,
                    end:  $scope.calendarData.eventEndDate,
                    allDay: true,
                    className: $scope.activeTagColor

                },true ); //Stick the event

                $scope.activeState = -1;
                $scope.calendarData.eventName = '';
                $modalInstance.close();
            }
        }

        //Dismiss
        $scope.eventDismiss = function() {
            $modalInstance.dismiss();
        }
    }])

    // =========================================================================
    // COMMON FORMS
    // =========================================================================

    .controller('formCtrl', function(){

        //Input Slider
        this.nouisliderValue = 4;
        this.nouisliderFrom = 25;
        this.nouisliderTo = 80;
        this.nouisliderRed = 35;
        this.nouisliderBlue = 90;
        this.nouisliderCyan = 20;
        this.nouisliderAmber = 60;
        this.nouisliderGreen = 75;

        //Color Picker
        this.color = '#03A9F4';
        this.color2 = '#8BC34A';
        this.color3 = '#F44336';
        this.color4 = '#FFC107';
    })


    // =========================================================================
    // PHOTO GALLERY
    // =========================================================================

    .controller('photoCtrl', function(){

        //Default grid size (2)
        this.photoColumn = 'col-md-2';
        this.photoColumnSize = 2;

        this.photoOptions = [
            { value: 2, column: 6 },
            { value: 3, column: 4 },
            { value: 4, column: 3 },
            { value: 1, column: 12 },
        ]

        //Change grid
        this.photoGrid = function(size) {
            this.photoColumn = 'col-md-'+size;
            this.photoColumnSize = size;
        }

    })


    // =========================================================================
    // ANIMATIONS DEMO
    // =========================================================================
    .controller('animCtrl', ["$timeout", function($timeout){

        //Animation List
        this.attentionSeekers = [
            { animation: 'bounce', target: 'attentionSeeker' },
            { animation: 'flash', target: 'attentionSeeker' },
            { animation: 'pulse', target: 'attentionSeeker' },
            { animation: 'rubberBand', target: 'attentionSeeker' },
            { animation: 'shake', target: 'attentionSeeker' },
            { animation: 'swing', target: 'attentionSeeker' },
            { animation: 'tada', target: 'attentionSeeker' },
            { animation: 'wobble', target: 'attentionSeeker' }
        ]
        this.flippers = [
            { animation: 'flip', target: 'flippers' },
            { animation: 'flipInX', target: 'flippers' },
            { animation: 'flipInY', target: 'flippers' },
            { animation: 'flipOutX', target: 'flippers' },
            { animation: 'flipOutY', target: 'flippers'  }
        ]
         this.lightSpeed = [
            { animation: 'lightSpeedIn', target: 'lightSpeed' },
            { animation: 'lightSpeedOut', target: 'lightSpeed' }
        ]
        this.special = [
            { animation: 'hinge', target: 'special' },
            { animation: 'rollIn', target: 'special' },
            { animation: 'rollOut', target: 'special' }
        ]
        this.bouncingEntrance = [
            { animation: 'bounceIn', target: 'bouncingEntrance' },
            { animation: 'bounceInDown', target: 'bouncingEntrance' },
            { animation: 'bounceInLeft', target: 'bouncingEntrance' },
            { animation: 'bounceInRight', target: 'bouncingEntrance' },
            { animation: 'bounceInUp', target: 'bouncingEntrance'  }
        ]
        this.bouncingExits = [
            { animation: 'bounceOut', target: 'bouncingExits' },
            { animation: 'bounceOutDown', target: 'bouncingExits' },
            { animation: 'bounceOutLeft', target: 'bouncingExits' },
            { animation: 'bounceOutRight', target: 'bouncingExits' },
            { animation: 'bounceOutUp', target: 'bouncingExits'  }
        ]
        this.rotatingEntrances = [
            { animation: 'rotateIn', target: 'rotatingEntrances' },
            { animation: 'rotateInDownLeft', target: 'rotatingEntrances' },
            { animation: 'rotateInDownRight', target: 'rotatingEntrances' },
            { animation: 'rotateInUpLeft', target: 'rotatingEntrances' },
            { animation: 'rotateInUpRight', target: 'rotatingEntrances'  }
        ]
        this.rotatingExits = [
            { animation: 'rotateOut', target: 'rotatingExits' },
            { animation: 'rotateOutDownLeft', target: 'rotatingExits' },
            { animation: 'rotateOutDownRight', target: 'rotatingExits' },
            { animation: 'rotateOutUpLeft', target: 'rotatingExits' },
            { animation: 'rotateOutUpRight', target: 'rotatingExits'  }
        ]
        this.fadeingEntrances = [
            { animation: 'fadeIn', target: 'fadeingEntrances' },
            { animation: 'fadeInDown', target: 'fadeingEntrances' },
            { animation: 'fadeInDownBig', target: 'fadeingEntrances' },
            { animation: 'fadeInLeft', target: 'fadeingEntrances' },
            { animation: 'fadeInLeftBig', target: 'fadeingEntrances'  },
            { animation: 'fadeInRight', target: 'fadeingEntrances'  },
            { animation: 'fadeInRightBig', target: 'fadeingEntrances'  },
            { animation: 'fadeInUp', target: 'fadeingEntrances'  },
            { animation: 'fadeInBig', target: 'fadeingEntrances'  }
        ]
        this.fadeingExits = [
            { animation: 'fadeOut', target: 'fadeingExits' },
            { animation: 'fadeOutDown', target: 'fadeingExits' },
            { animation: 'fadeOutDownBig', target: 'fadeingExits' },
            { animation: 'fadeOutLeft', target: 'fadeingExits' },
            { animation: 'fadeOutLeftBig', target: 'fadeingExits'  },
            { animation: 'fadeOutRight', target: 'fadeingExits'  },
            { animation: 'fadeOutRightBig', target: 'fadeingExits'  },
            { animation: 'fadeOutUp', target: 'fadeingExits'  },
            { animation: 'fadeOutUpBig', target: 'fadeingExits'  }
        ]
        this.zoomEntrances = [
            { animation: 'zoomIn', target: 'zoomEntrances' },
            { animation: 'zoomInDown', target: 'zoomEntrances' },
            { animation: 'zoomInLeft', target: 'zoomEntrances' },
            { animation: 'zoomInRight', target: 'zoomEntrances' },
            { animation: 'zoomInUp', target: 'zoomEntrances'  }
        ]
        this.zoomExits = [
            { animation: 'zoomOut', target: 'zoomExits' },
            { animation: 'zoomOutDown', target: 'zoomExits' },
            { animation: 'zoomOutLeft', target: 'zoomExits' },
            { animation: 'zoomOutRight', target: 'zoomExits' },
            { animation: 'zoomOutUp', target: 'zoomExits'  }
        ]

        //Animate
        this.ca = '';

        this.setAnimation = function(animation, target) {
            if (animation === "hinge") {
                animationDuration = 2100;
            }
            else {
                animationDuration = 1200;
            }

            angular.element('#'+target).addClass(animation);

            $timeout(function(){
                angular.element('#'+target).removeClass(animation);
            }, animationDuration);
        }

    }])

    // =========================================================================
    // LAYOUT
    // =========================================================================

    .directive('changeLayout', function(){

        return {
            restrict: 'A',
            scope: {
                changeLayout: '='
            },

            link: function(scope, element, attr) {

                //Default State
                if(scope.changeLayout === '1') {
                    element.prop('checked', true);
                }

                //Change State
                element.on('change', function(){
                    if(element.is(':checked')) {
                        localStorage.setItem('ma-layout-status', 1);
                        scope.$apply(function(){
                            scope.changeLayout = '1';
                        })
                    }
                    else {
                        localStorage.setItem('ma-layout-status', 0);
                        scope.$apply(function(){
                            scope.changeLayout = '0';
                        })
                    }
                })
            }
        }
    })



    // =========================================================================
    // MAINMENU COLLAPSE
    // =========================================================================

    .directive('toggleSidebar', function(){

        return {
            restrict: 'A',
            scope: {
                modelLeft: '=',
                modelRight: '='
            },

            link: function(scope, element, attr) {
                element.on('click', function(){

                    if (element.data('target') === 'mainmenu') {
                        if (scope.modelLeft === false) {
                            scope.$apply(function(){
                                scope.modelLeft = true;
                            })
                        }
                        else {
                            scope.$apply(function(){
                                scope.modelLeft = false;
                            })
                        }
                    }

                    if (element.data('target') === 'chat') {
                        if (scope.modelRight === false) {
                            scope.$apply(function(){
                                scope.modelRight = true;
                            })
                        }
                        else {
                            scope.$apply(function(){
                                scope.modelRight = false;
                            })
                        }

                    }
                })
            }
        }

    })



    // =========================================================================
    // SUBMENU TOGGLE
    // =========================================================================

    .directive('toggleSubmenu', function(){

        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.click(function(){
                    element.next().slideToggle(200);
                    element.parent().toggleClass('toggled');
                });
            }
        }
    })


    // =========================================================================
    // STOP PROPAGATION
    // =========================================================================

    .directive('stopPropagate', function(){
        return {
            restrict: 'C',
            link: function(scope, element) {
                element.on('click', function(event){
                    event.stopPropagation();
                });
            }
        }
    })

    .directive('aPrevent', function(){
        return {
            restrict: 'C',
            link: function(scope, element) {
                element.on('click', function(event){
                    event.preventDefault();
                });
            }
        }
    })


    // =========================================================================
    // PRINT
    // =========================================================================

    .directive('print', function(){
        return {
            restrict: 'A',
            link: function(scope, element){
                element.click(function(){
                    window.print();
                })
            }
        }
    })

    // =========================================================================
    // SPARKLINE CHARTS
    // =========================================================================

    //Bar Chart

    .directive('sparklineBar', function(){

        return {
            restrict: 'A',
            link: function(scope, element) {
                function sparkLineBar(selector, values, height, barWidth, barColor, barSpacing) {
                   $(selector).sparkline(values, {
                        type: 'bar',
                        height: height,
                        barWidth: barWidth,
                        barColor: barColor,
                        barSpacing: barSpacing
                   });
                }

                sparkLineBar('.stats-bar', [6,4,8,6,5,6,7,8,3,5,9,5,8,4,3,6,8], '45px', 3, '#fff', 2);
                sparkLineBar('.stats-bar-2', [4,7,6,2,5,3,8,6,6,4,8,6,5,8,2,4,6], '45px', 3, '#fff', 2);
            }
        }
    })


    //Line Chart

    .directive('sparklineLine', function(){

        return {
            restrict: 'A',
            link: function(scope, element) {
                function sparkLineLine(selector, values, width, height, lineColor, fillColor, lineWidth, maxSpotColor, minSpotColor, spotColor, spotRadius, hSpotColor, hLineColor) {
                    $(selector).sparkline(values, {
                        type: 'line',
                        width: width,
                        height: height,
                        lineColor: lineColor,
                        fillColor: fillColor,
                        lineWidth: lineWidth,
                        maxSpotColor: maxSpotColor,
                        minSpotColor: minSpotColor,
                        spotColor: spotColor,
                        spotRadius: spotRadius,
                        highlightSpotColor: hSpotColor,
                        highlightLineColor: hLineColor
                    });
                }

                sparkLineLine('.stats-line', [9,4,6,5,6,4,5,7,9,3,6,5], 85, 45, '#fff', 'rgba(0,0,0,0)', 1.25, 'rgba(255,255,255,0.4)', 'rgba(255,255,255,0.4)', 'rgba(255,255,255,0.4)', 3, '#fff', 'rgba(255,255,255,0.4)');
                sparkLineLine('.stats-line-2', [5,6,3,9,7,5,4,6,5,6,4,9], 85, 45, '#fff', 'rgba(0,0,0,0)', 1.25, 'rgba(255,255,255,0.4)', 'rgba(255,255,255,0.4)', 'rgba(255,255,255,0.4)', 3, '#fff', 'rgba(255,255,255,0.4)');
                sparkLineLine('.dash-widget-visits', [9,4,6,5,6,4,5,7,9,3,6,5], '100%', '95px', 'rgba(255,255,255,0.7)', 'rgba(0,0,0,0)', 2, 'rgba(255,255,255,0.4)', 'rgba(255,255,255,0.4)', 'rgba(255,255,255,0.4)', 5, 'rgba(255,255,255,0.4)', '#fff');

            }
        }
    })


    // Pie Charts

    .directive('sparklinePie', function(){
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                function sparklinePie(select, values, width, height, sliceColors) {
                    $(select).sparkline(values, {
                        type: 'pie',
                        width: width,
                        height: height,
                        sliceColors: sliceColors,
                        offset: 0,
                        borderWidth: 0
                    });
                }

                if ($('.stats-pie')[0]) {
                    sparklinePie('.stats-pie', [20, 35, 30, 5], 45, 45, ['#fff', 'rgba(255,255,255,0.7)', 'rgba(255,255,255,0.4)', 'rgba(255,255,255,0.2)']);
                }
            }
        }
    })



    // =========================================================================
    // EASY PIE CHARTS
    // =========================================================================

    .directive('easypieChart', function(){
        return {
            restrict: 'A',
            link: function(scope, element) {
                function easyPieChart(selector, trackColor, scaleColor, barColor, lineWidth, lineCap, size) {
                    $(selector).easyPieChart({
                        trackColor: trackColor,
                        scaleColor: scaleColor,
                        barColor: barColor,
                        lineWidth: lineWidth,
                        lineCap: lineCap,
                        size: size
                    });
                }

                easyPieChart('.main-pie', 'rgba(255,255,255,0.2)', 'rgba(255,255,255,0.5)', 'rgba(255,255,255,0.7)', 7, 'butt', 148);
                easyPieChart('.sub-pie-1', '#eee', '#ccc', '#2196F3', 4, 'butt', 95);
                easyPieChart('.sub-pie-2', '#eee', '#ccc', '#FFC107', 4, 'butt', 95);
            }
        }
    })
 .directive('curvedlineChart', function(){
        return {
            restrict: 'A',
            link: function(scope, element) {

                /* Make some random data for the Chart*/

                var d1 = [];
                var d2 = [];
                var d3 = [];

                for (var i = 0; i <= 10; i += 1) {
                    d1.push([i, parseInt(Math.random() * 30)]);
                }

                for (var i = 0; i <= 20; i += 1) {
                    d2.push([i, parseInt(Math.random() * 30)]);
                }

                for (var i = 0; i <= 10; i += 1) {
                    d3.push([i, parseInt(Math.random() * 30)]);
                }


                /* Chart Options */

                var options = {
                    series: {
                        shadowSize: 0,
                        curvedLines: { //This is a third party plugin to make curved lines
                            apply: true,
                            active: true,
                            monotonicFit: true
                        },
                        lines: {
                            show: false,
                            lineWidth: 0,
                        },
                    },
                    grid: {
                        borderWidth: 0,
                        labelMargin:10,
                        hoverable: true,
                        clickable: true,
                        mouseActiveRadius:6,

                    },
                    xaxis: {
                        tickDecimals: 0,
                        ticks: false
                    },

                    yaxis: {
                        tickDecimals: 0,
                        ticks: false
                    },

                    legend: {
                        show: false
                    }
                };

                /* Let's create the chart */

                $.plot($(element), [
                    {data: d1, lines: { show: true, fill: 0.98 }, label: 'Product 1', stack: true, color: '#e3e3e3' },
                    {data: d3, lines: { show: true, fill: 0.98 }, label: 'Product 2', stack: true, color: '#f1dd2c' }
                ], options);

                /* Tooltips for Flot Charts */

                if ($(".flot-chart")[0]) {
                    $(".flot-chart").bind("plothover", function (event, pos, item) {
                        if (item) {
                            var x = item.datapoint[0].toFixed(2),
                                y = item.datapoint[1].toFixed(2);
                            $(".flot-tooltip").html(item.series.label + " of " + x + " = " + y).css({top: item.pageY+5, left: item.pageX+5}).show();
                        }
                        else {
                            $(".flot-tooltip").hide();
                        }
                    });

                    $("<div class='flot-tooltip' class='chart-tooltip'></div>").appendTo("body");
                }
            }
        }
    })


    // =========================================================================
    // Regular Line Charts
    // =========================================================================

    .directive('lineChart', function(){
        return {
            restrict: 'A',
            link: function(scope, element){

                /* Make some random data for Recent Items chart */

                var data = [];
                var totalPoints = 100;
                var updateInterval = 30;

                function getRandomData() {
                    if (data.length > 0)
                        data = data.slice(1);

                    while (data.length < totalPoints) {

                        var prev = data.length > 0 ? data[data.length - 1] : 50,
                            y = prev + Math.random() * 10 - 5;
                        if (y < 0) {
                            y = 0;
                        } else if (y > 90) {
                            y = 90;
                        }

                        data.push(y);
                    }

                    var res = [];
                    for (var i = 0; i < data.length; ++i) {
                        res.push([i, data[i]])
                    }

                    return res;
                }

                /* Make some random data for Flot Line Chart */

                var d1 = [];
                var d2 = [];
                var d3 = [];

                for (var i = 0; i <= 10; i += 1) {
                    d1.push([i, parseInt(Math.random() * 30)]);
                }

                for (var i = 0; i <= 20; i += 1) {
                    d2.push([i, parseInt(Math.random() * 30)]);
                }

                for (var i = 0; i <= 10; i += 1) {
                    d3.push([i, parseInt(Math.random() * 30)]);
                }

                /* Chart Options */

                var options = {
                    series: {
                        shadowSize: 0,
                        lines: {
                            show: false,
                            lineWidth: 0,
                        },
                    },
                    grid: {
                        borderWidth: 0,
                        labelMargin:10,
                        hoverable: true,
                        clickable: true,
                        mouseActiveRadius:6,

                    },
                    xaxis: {
                        tickDecimals: 0,
                        ticks: false
                    },

                    yaxis: {
                        tickDecimals: 0,
                        ticks: false
                    },

                    legend: {
                        show: false
                    }
                };

                /* Regular Line Chart */
                if ($("#line-chart")[0]) {
                    $.plot($("#line-chart"), [
                        {data: d1, lines: { show: true, fill: 0.98 }, label: 'Product 1', stack: true, color: '#e3e3e3' },
                        {data: d3, lines: { show: true, fill: 0.98 }, label: 'Product 2', stack: true, color: '#FFC107' }
                    ], options);
                }

                /* Recent Items Table Chart */
                if ($("#recent-items-chart")[0]) {
                    $.plot($("#recent-items-chart"), [
                        {data: getRandomData(), lines: { show: true, fill: 0.8 }, label: 'Items', stack: true, color: '#00BCD4' },
                    ], options);
                }
            }
        }
    })



    //-----------------------------------------------
    // BAR CHART
    //-----------------------------------------------

    .directive('barChart', function(){
        return {
            restrict: 'A',
            link: function(scope, element, attrs){
                var data1 = [[1,60], [2,30], [3,50], [4,100], [5,10], [6,90], [7,85]];
                var data2 = [[1,20], [2,90], [3,60], [4,40], [5,100], [6,25], [7,65]];
                var data3 = [[1,100], [2,20], [3,60], [4,90], [5,80], [6,10], [7,5]];

                /* Create an Array push the data + Draw the bars*/

                var barData = new Array();

                barData.push({
                    data : data1,
                    label: 'Tokyo',
                    bars : {
                        show : true,
                        barWidth : 0.08,
                        order : 1,
                        lineWidth: 0,
                        fillColor: '#8BC34A'
                    }
                });

                barData.push({
                    data : data2,
                    label: 'Seoul',
                    bars : {
                        show : true,
                        barWidth : 0.08,
                        order : 2,
                        lineWidth: 0,
                        fillColor: '#00BCD4'
                    }
                });

                barData.push({
                    data : data3,
                    label: 'Beijing',
                    bars : {
                        show : true,
                        barWidth : 0.08,
                        order : 3,
                        lineWidth: 0,
                        fillColor: '#FF9800'
                    }
                });

                /* Let's create the chart */
                $.plot($(element), barData, {
                    grid : {
                            borderWidth: 1,
                            borderColor: '#eee',
                            show : true,
                            hoverable : true,
                            clickable : true
                    },

                    yaxis: {
                        tickColor: '#eee',
                        tickDecimals: 0,
                        font :{
                            lineHeight: 13,
                            style: "normal",
                            color: "#9f9f9f",
                        },
                        shadowSize: 0
                    },

                    xaxis: {
                        tickColor: '#fff',
                        tickDecimals: 0,
                        font :{
                            lineHeight: 13,
                            style: "normal",
                            color: "#9f9f9f"
                        },
                        shadowSize: 0,
                    },

                    legend:{
                        container: '.flc-bar',
                        backgroundOpacity: 0.5,
                        noColumns: 0,
                        backgroundColor: "white",
                        lineWidth: 0
                    }
                });
            }
        }
    })



    //-----------------------------------------------
    // DYNAMIC CHART
    //-----------------------------------------------

    .directive('dynamicChart', function(){
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {

                /* Make some random data*/

                var data = [];
                var totalPoints = 300;
                var updateInterval = 30;

                function getRandomData() {
                    if (data.length > 0)
                        data = data.slice(1);

                    while (data.length < totalPoints) {

                        var prev = data.length > 0 ? data[data.length - 1] : 50,
                            y = prev + Math.random() * 10 - 5;
                        if (y < 0) {
                            y = 0;
                        } else if (y > 90) {
                            y = 90;
                        }

                        data.push(y);
                    }

                    var res = [];
                    for (var i = 0; i < data.length; ++i) {
                        res.push([i, data[i]])
                    }

                    return res;
                }

                /* Create Chart */

                var plot = $.plot(element, [ getRandomData() ], {
                    series: {
                        label: "Server Process Data",
                        lines: {
                            show: true,
                            lineWidth: 0.2,
                            fill: 0.6
                        },

                        color: '#00BCD4',
                        shadowSize: 0,
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        tickColor: '#eee',
                        font :{
                            lineHeight: 13,
                            style: "normal",
                            color: "#9f9f9f",
                        },
                        shadowSize: 0,

                    },
                    xaxis: {
                        tickColor: '#eee',
                        show: true,
                        font :{
                            lineHeight: 13,
                            style: "normal",
                            color: "#9f9f9f",
                        },
                        shadowSize: 0,
                        min: 0,
                        max: 250
                    },
                    grid: {
                        borderWidth: 1,
                        borderColor: '#eee',
                        labelMargin:10,
                        hoverable: true,
                        clickable: true,
                        mouseActiveRadius:6,
                    },
                    legend:{
                        container: '.flc-dynamic',
                        backgroundOpacity: 0.5,
                        noColumns: 0,
                        backgroundColor: "white",
                        lineWidth: 0
                    }
                });

                /* Update */
                function update() {
                    plot.setData([getRandomData()]);
                    // Since the axes don't change, we don't need to call plot.setupGrid()

                    plot.draw();
                    setTimeout(update, updateInterval);
                }
                update();
            }
        }
    })


    //-----------------------------------------------
    // PIE AND DONUT
    //-----------------------------------------------

    .directive('pieDonut', function(){
        return {
            restrict: 'A',
            link: function(scope, element, attrs){
                var pieData = [
                    {data: 1, color: '#F44336', label: 'Toyota'},
                    {data: 2, color: '#03A9F4', label: 'Nissan'},
                    {data: 3, color: '#8BC34A', label: 'Hyundai'},
                    {data: 4, color: '#FFEB3B', label: 'Scion'},
                    {data: 4, color: '#009688', label: 'Daihatsu'},
                ];

                /* Pie Chart */

                if($('#pie-chart')[0]){
                    $.plot('#pie-chart', pieData, {
                        series: {
                            pie: {
                                show: true,
                                stroke: {
                                    width: 2,
                                },
                            },
                        },
                        legend: {
                            container: '.flc-pie',
                            backgroundOpacity: 0.5,
                            noColumns: 0,
                            backgroundColor: "white",
                            lineWidth: 0
                        },
                        grid: {
                            hoverable: true,
                            clickable: true
                        },
                        tooltip: true,
                        tooltipOpts: {
                            content: "%p.0%, %s", // show percentages, rounding to 2 decimal places
                            shifts: {
                                x: 20,
                                y: 0
                            },
                            defaultTheme: false,
                            cssClass: 'flot-tooltip'
                        }

                    });
                }

                /* Donut Chart */

                if($('#donut-chart')[0]){
                    $.plot('#donut-chart', pieData, {
                        series: {
                            pie: {
                                innerRadius: 0.5,
                                show: true,
                                stroke: {
                                    width: 2,
                                },
                            },
                        },
                        legend: {
                            container: '.flc-donut',
                            backgroundOpacity: 0.5,
                            noColumns: 0,
                            backgroundColor: "white",
                            lineWidth: 0
                        },
                        grid: {
                            hoverable: true,
                            clickable: true
                        },
                        tooltip: true,
                        tooltipOpts: {
                            content: "%p.0%, %s", // show percentages, rounding to 2 decimal places
                            shifts: {
                                x: 20,
                                y: 0
                            },
                            defaultTheme: false,
                            cssClass: 'flot-tooltip'
                        }

                    });
                }
            }
        }
    })


}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name materialAdmin.controller:HeaderCtrl
   *
   * @description
   *
   */
  HeaderCtrl.$inject = ["$rootScope", "$state", "$timeout", "MessagesService", "messageService", "$log", "EInvoiceDocumentsService", "CTLocalizationService", "$localStorage", "UserSettingsService", "ConfigService", "PaymentsService", "growlService", "HelperService", "ConfigEndpointService", "$scope", "SessionService", "$uibModal", "GoogleTagManagerHelperService"];
  angular
    .module('materialAdmin')
    .controller('headerCtrl', HeaderCtrl);

  function HeaderCtrl($rootScope, $state, $timeout, MessagesService, messageService, $log, EInvoiceDocumentsService,
                      CTLocalizationService, $localStorage, UserSettingsService, ConfigService, PaymentsService,
                       growlService, HelperService, ConfigEndpointService, $scope, SessionService, $uibModal, GoogleTagManagerHelperService) {

    var vm = this;
    vm.ctrlName = 'HeaderCtrl';

    var setAppLanguage = function () {
      var lang = $localStorage.appLanguage;

        if (lang == undefined) {
          if (ConfigService.defaultLocale == undefined || ConfigService.defaultLocale == 'undefined') {
            $localStorage.appLanguage = angular.copy($localStorage.code);

          } else {
//                    $localStorage.appLanguage = ConfigService.defaultLocale;
            $localStorage.appLanguage = angular.copy($localStorage.code);
          }
          lang = $localStorage.appLanguage;
        }


      vm.changeLanguage(lang);
    };

    vm.getDate = function () {
      return new Date();
    };

    this.isModuleActive = function (moduleList) {
      return $state.includes(moduleList);
    };

    //GET UNREAD MESSAGES

    vm.numberOfMessagesToShow = 10;
    vm.messageToShow = {};
    vm.openReplySection = false;
    vm.messageMarkedAsReadId = null;
    vm.messageSuccessfullySent = false;

    vm.sendMessageObject = {
      subject: "",
      body: ""
    };

    vm.resetSendMessageObject = function () {
      vm.sendMessageObject.subject = "";
      vm.sendMessageObject.body = "";
    };

    vm.sendMessage = function (e) {

      MessagesService.sendMessage(vm.sendMessageObject)
        .then(function (response) {
            $log.debug("message send response", response);
            vm.messageSuccessfullySent = true;
            $timeout(function () {
              vm.openReplySection = false;
              vm.messageToShow = {};
              vm.resetSendMessageObject();
            }, 900);

          }
          /*, function (error) {
           console.log(error);
           }*/
        )
        .catch(function (error) {
          $log.error(error);
        });

    };

    vm.markMessageAsRead = function (message) {

      MessagesService.markAsRead(message.id)
        .then(function (response) {
            if (response === true) {
              $log.debug("markAsRead Response ", response);
              vm.messageMarkedAsReadId = message.id;
              $timeout(function () {
                vm.messageMarkedAsReadId = null;
                vm.getMessagesPage();
              }, 900);


            }

          }
          /*, function (error) {
           console.log(error);
           }*/
        )
        .catch(function (error) {
          $log.error(error);
        });

      vm.openReplySection = false;
      vm.messageToShow = {};
    };

    vm.messagesFilter = {
      page: 0,
      unreadMessages: true,
      orderBy: "creationDate DESC",
      pageSize: 10
    };

    vm.messagesList = {};
    vm.getMessagesPage = function () {

      MessagesService.getPage(vm.messagesFilter)
        .then(function (response) {
            vm.messagesList = response;
            //$log.debug("messagesList", vm.messagesList);
          }
          /*, function (error) {
           console.log(error);
           }*/
        )
        .catch(function (error) {
          $log.error(error);
        });

    };

    vm.openMessagesNotificationLink = function () {
      vm.messageToShow = {};
      vm.openReplySection = false;
      vm.messageSuccessfullySent = false;
    };

    vm.openReplySectionAction = function (e, message) {
      vm.openReplySection = true;
      e.preventDefault();
      vm.messageToShow = message;
      vm.sendMessageObject.subject = "RE: " + message.subject;
    };
    vm.cancelReply = function () {
      vm.messageSuccessfullySent = false;
      vm.openReplySection = false;
      vm.messageToShow = {};
      vm.resetSendMessageObject();

    };

    //GET E-INVOICES
    vm.eInvoiceDocumentsFilter = {
      page: 0,
      orderBy: "valueDate DESC",
      pageSize: 1000
    };
    vm.eInvoiceDocumentsList = {};
    vm.geteInvoiceDocumentsPage = function () {

      EInvoiceDocumentsService.getPage(vm.eInvoiceDocumentsFilter)
        .then(function (response) {
            if (response) {
              vm.eInvoiceDocumentsList = response;
              //$log.debug(vm.eInvoiceDocumentsList);
            }
          }
          /*, function (error) {
           console.log(error);
           }*/
        )
        .catch(function (error) {
          $log.error(error);
        });

    };

    vm.openEInvoicesModal = function (eInvoice) {
      EInvoiceDocumentsService.openModal(eInvoice);
    };

    //GET REJECTED PAYMENTS
    vm.rejectedPaymentsFilter = {
      page: 0,
      status: 'Rejected',
      orderBy: 'dueDate DESC',
      pageSize: 10
    };
    vm.rejectedPaymentsList = {};
    vm.getRejectedPaymentsPage = function () {

      PaymentsService.getRejectedPayments(vm.rejectedPaymentsFilter)
        .then(function (response) {
            vm.rejectedPaymentsList = response;
            //$log.debug("rejectedPaymentsList", vm.rejectedPaymentsList);
          }
          /*, function (error) {
           console.log(error);
           }*/
        )
        .catch(function (error) {
          $log.error(error);
        });

    };
    //GET PENDING PAYMENTS
    vm.pendingPaymentsFilter = {
      page: 0,
      status: 'InProcessing',
      orderBy: 'dueDate DESC',
      pageSize: 10
    };
    vm.pendingPaymentsList = {};
    vm.getPendingPaymentsPage = function () {

      PaymentsService.getPendingPayments(vm.pendingPaymentsFilter)
        .then(function (response) {
            vm.pendingPaymentsList = response;
            //$log.debug("pendingPaymentsList", vm.pendingPaymentsList);
          }
          /*, function (error) {
           console.log(error);
           }*/
        )
        .catch(function (error) {
          $log.error(error);
        });

    };

    vm.openEInvoicesModal = function (eInvoice) {
      EInvoiceDocumentsService.openModal(eInvoice);
    };

    //LANG SETTINGS
    vm.changeLanguage = function (lang) {
      CTLocalizationService.setLanguage(lang);
      vm.selectedLanguage = _.find(vm.languageOptions, function (language) {
        return language.code === lang;
      });
      CTLocalizationService.translateSweetAlertOptions();
      $rootScope.$broadcast('appLanguageChangedHeader', {langCode: lang});
      GoogleTagManagerHelperService.pushEvent('AppHeader', 'TabLanguageFilter', lang);
    };

    $rootScope.$on('appLanguageChangedNavigation', function (evt, lang) {
      if (lang && lang.langCode) {
        vm.selectedLanguage = _.find(vm.languageOptions, function (language) {
          return language.code === lang.langCode;
        });
      }
    });

    //USER SETTINGS

    vm.userSettings = {};
    vm.userSettingsFilter = {
      page: 0,
      pageSize: 1000
    };

    vm.getUserSettingsPage = function () {
      vm.userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
//       UserSettingsService.getPage(vm.userSettingsFilter)
//         .then(function (response) {
//             vm.userSettings = response;
// /*          var daysOneMonthAgo = new Date();
//            daysOneMonthAgo.setMonth(daysOneMonthAgo.getMonth() - 2);
//            vm.userSettings.result[0].lastLoginDate = daysOneMonthAgo;*/
//             $log.debug("userSettings", vm.userSettings);
//           }
//         )
//         .catch(function (error) {
//           $log.error(error);
//         });
    };


    //CONTROLLER INIT
    vm.init = function () {
      vm.getMessagesPage();
      vm.getUserSettingsPage();
//          Commented on 18.06. Not used anymore?!
      /*            vm.getPendingPaymentsPage();
       vm.getRejectedPaymentsPage();
       vm.geteInvoiceDocumentsPage();*/
      getDefaultData();
    };


    vm.countryCode = '';
    function getDefaultData() {
      var defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
      if (defaultData.APILocation) {
        $localStorage.code = defaultData.APILocation;
        vm.countryCode = defaultData.APILocation;
        vm.languageOptions = CTLocalizationService.getLocalLanguageOptions(vm.countryCode);
        setAppLanguage();
      } else {
        vm.languageOptions = CTLocalizationService.getLanguageOptions();
        setAppLanguage();
      }

      // return ConfigEndpointService.getDefaultData()
      //   .then(function (response) {
      //     if (response.APILocation) {
      //       $localStorage.code = response.APILocation;
      //       vm.countryCode = response.APILocation;
      //       vm.languageOptions = CTLocalizationService.getLocalLanguageOptions(vm.countryCode);
      //       setAppLanguage();
      //     } else {
      //       vm.languageOptions = CTLocalizationService.getLanguageOptions();
      //       setAppLanguage();
      //     }
      //   })
      //   .catch(function (error) {
      //     HelperService.showMessage(error, 'error');
      //   });
    }

    vm.logOut = function () {

        GoogleTagManagerHelperService.pushEvent('Dashboard', 'LogOut', 'Open');

      var modalInstance = $uibModal.open({
        templateUrl: 'core/logout-confirm-modal.tpl.html',
        backdrop: 'static',
        size: 'lg'
      })
        .result.then(function(result){
        if(result == "logout"){
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'LogOut', 'SignedOut');
            SessionService.logout();
        }else{
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'LogOut', 'Stayed');
        }
      });



      /*SessionService.clearSession()
       .then(function (response) {
       console.log(response.msg);
       SessionService.authorize();
       });*/
    };

    vm.init();

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name materialAdmin.factory:FooterService
   *
   * @description
   *
   */
  FooterService.$inject = ["$uibModal"];
  angular
    .module('materialAdmin')
    .factory('FooterService', FooterService);

  function FooterService($uibModal) {
    var FooterServiceBase = {};

    FooterServiceBase.openModal = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'material-admin/in-depth-modal.tpl.html',
        controller: 'FooterCtrl',
        controllerAs: 'footer',

        backdrop: 'static'
      });
    };
    return FooterServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name materialAdmin.controller:FooterCtrl
   *
   * @description
   *
   */
  FooterCtrl.$inject = ["$rootScope", "$localStorage", "ConfigEndpointService", "HelperService", "FooterService", "version", "ConfigService", "GoogleTagManagerHelperService"];
  angular
    .module('materialAdmin')
    .controller('FooterCtrl', FooterCtrl);

    function FooterCtrl($rootScope, $localStorage, ConfigEndpointService, HelperService, FooterService, version, ConfigService, GoogleTagManagerHelperService) {
    var vm = this;
    //vm.getConfigData = function () {
    //  ConfigEndpointService.getDefaultData()
    //    .then(function (response) {
    //      vm.configData = response;
    //      vm.countryCode = response.APILocation;
    //      vm.clubLink = response.AddikoClub;
    //      vm.eTradeLink = response.eTrade;
    //    })
    //    .catch(function (error) {
    //      HelperService.showMessage(error, 'error');
    //    });
    //};

    vm.init = function () {
      //vm.getConfigData();
      vm.configData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
      vm.countryCode = vm.configData.APILocation;
      vm.clubLink = vm.configData.AddikoClub;
      vm.eTradeLink = vm.configData.eTrade;
      vm.appVersion = version;
      vm.serverVersion = ConfigService.serverId;
    };

    vm.openModal = function () {
      FooterService.openModal();
    };
      
    vm.pushGtmEmailEvent = function () {
        GoogleTagManagerHelperService.pushEvent('Dashboard', 'MailTo', 'Open');  
    };

    vm.init();

  }
}());

(function () {
  'use strict';

  config.$inject = ["$translateProvider", "$provide", "$localeProvider", "tmhDynamicLocaleProvider", "ConfigServiceProvider"];
  angular
    .module('localization'
      )
    .config(config);

  function config($translateProvider, $provide, $localeProvider, tmhDynamicLocaleProvider, ConfigServiceProvider) {
    $translateProvider
      .preferredLanguage(ConfigServiceProvider.defaultLocale)
      .fallbackLanguage(ConfigServiceProvider.defaultLocale);
    $translateProvider.useSanitizeValueStrategy('escape'); //escape //sanitize
    //tmhDynamicLocaleProvider.defaultLocale(ConfigServiceProvider.defaultLocale);
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name localization.factory:CtlocalizationService
   *
   * @description
   *
   */
  CTLocalizationService.$inject = ["$translate", "tmhDynamicLocale", "$localStorage", "$http", "ConfigService"];
  angular
      .module('localization')
      .factory('CTLocalizationService', CTLocalizationService);

    function CTLocalizationService($translate, tmhDynamicLocale, $localStorage,$http, ConfigService) {
    var CtlocalizationServiceBase = {};
    var sweetAlertOptions = {};
    var languageOptions = [
      {
        translate: 'header.langEn',
        code: 'en',
        flag: 'en.png'
      },
      {
        translate: 'header.langHr',
        code: 'hr',
        flag: 'hr.png'
      },
      {
        translate: 'header.langSr',
        code: 'sr',
        flag: 'sr.png'
      },
      {
        translate: 'header.langMtr',
        code: 'mne',
        flag: 'mtr.png'
      },
      {
        translate: 'header.langSl',
        code: 'sl',
        flag: 'mtr.png'
      },
      {
        translate: 'header.langDe',
        code: 'de',
        flag: 'de.png'
      },
      {
        translate: 'header.langRu',
        code: 'ru',
        flag: 'ru.png'
      },
      {
        translate: 'header.langBa',
        code: 'bh',
        flag: 'ba.png'
      }
    ];

      // console.log("LocalCityCode: " + ConfigService.localCityCode);
      // if(ConfigService.localCityCode) {
      //     languageOptions.push({
      //       translate: 'header.langBa',
      //       code: ConfigService.localCityCode,
      //       flag: 'ba.png'
      //     })
      // }

    CtlocalizationServiceBase.translateSweetAlertOptions = function() {
      $translate(["core.sweetAlertTranslation.yes",
        "core.sweetAlertTranslation.no",
        "core.sweetAlertTranslation.areYouSure"])
          .then(function (translations) {
            sweetAlertOptions.yes = translations["core.sweetAlertTranslation.yes"];
            sweetAlertOptions.no = translations["core.sweetAlertTranslation.no"];
            sweetAlertOptions.areYouSure = translations["core.sweetAlertTranslation.areYouSure"];
          });
    };

    CtlocalizationServiceBase.getSweetAlertOptions = function() {
      return sweetAlertOptions;
    };

    CtlocalizationServiceBase.setLanguage = function (langKey) {
      $translate.use(langKey);
      tmhDynamicLocale.set(langKey);
      $localStorage.appLanguage = langKey;
        $http.defaults.headers.common["Accept-Language"] = $localStorage.appLanguage;
    };

    CtlocalizationServiceBase.getLanguageOptions = function(){
      return languageOptions;
    };


    CtlocalizationServiceBase.getLocalLanguageOptions = function(countryCode){
      var languages = [];

      for(var i in languageOptions) {
        // Map location for Montenegro mne to language code mn
        if(languageOptions[i].code === countryCode || languageOptions[i].code === 'en' || (countryCode === 'mne' && languageOptions[i].code === 'mn')) {
          languages.push(languageOptions[i]);
        }
      }
      return languages;
    };


    return CtlocalizationServiceBase;


  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name investments
   * @description
   *
   */
  angular
    .module('investments', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('investments')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('investments', {
          url: '/investments',
          abstract: true,
          template: '<ui-view/>'
        })
        .state('investments.accession', {
          url: '/accession',
          templateUrl: 'investments/access-investments.tpl.html',
          controllerAs: 'accessInv',
          controller: 'AccessInvestmentsCtrl'
        })
        .state('investments.list', {
          url: '/list',
          templateUrl: 'investments/investments-list.tpl.html',
          controller: 'InvestmentsListCtrl',
          controllerAs: 'investmentsList',
          resolve: {
            // if user has no funds he should be redirected to fund accesssion
            userHaveFunds: ["$q", "$state", "UserSettingsService", function ($q, $state, UserSettingsService) {
              return UserSettingsService.userHaveFunds()
                  .then(function (response) {
                    if (!response) {
                      $state.go('investments.accession');
                      return $q.reject('User has no funds');
                    }
                  });
            }]
          }
        })
        .state('investments.overview', {
          url: '/overview/:fundId',
          templateUrl: 'investments/investments-overview.tpl.html',
          controller: 'InvestmentsOverviewCtrl',
          controllerAs: 'investmentsOverview',
          resolve: {
//            selectedFund: function ($stateParams, FundsService) {
//              FundsService.getFundById($stateParams.fundId)
//            }
          }
        })
        .state('investments.form', {
          url: '/:orderType',
          abstract: true,
          controller: 'InvestmentCtrl',
          controllerAs: 'investment',
          templateUrl: 'investments/investment-base.tpl.html',
          resolve: {
            orderType: ["$q", "$stateParams", function ($q, $stateParams) {
              var options = ["new", "sell", "replace"];
              if (!_.contains(options, $stateParams.orderType)) {
                return $q.reject("Invalid");
              }
              return $q.resolve($stateParams.orderType);
            }],
            //fundList: function (FundsService) {
            //  return FundsService.getPage();
            //},
            configData: ["ConfigEndpointService", function (ConfigEndpointService) {
              return ConfigEndpointService.getDefaultData();
            }],
            // if user has no funds he should be redirected to fund accesssion
            userHaveFunds: ["$q", "$state", "UserSettingsService", function ($q, $state, UserSettingsService) {
              return UserSettingsService.userHaveFunds()
                  .then(function (response) {
                    if (!response) {
                      $state.go('investments.accession');
                      return $q.reject('User has no funds');
                    } else {
                      return response;
                    }
                  })
                  .catch(function () {
                    return $q.reject("Error loading user funds!");
                  })
            }]
          }
        })
        .state('investments.form.new', {
          url: '?fundId',
          templateUrl: 'investments/investment-form.tpl.html',
          resolve: {
            validate: ["$q", "$stateParams", "$location", "orderType", function ($q, $stateParams, $location, orderType) {
              // if orderType is sell or replace - fundId is required!
              if (orderType != "new" && !$stateParams.fundId) {
                $location.go("/investments/new");
                return $q.reject("Invalid");
              }
              // if orderType is new $stateParams id is optional

              //else if ($stateParams.fundId) {
              //  var fund = _.findWhere(fundList.result, {id: $stateParams.fundId});
              //  if (!fund) {
              //    return $q.reject("Invalid");
              //  }
              //}
            }]
          }
        })
        .state('investments.form.resume', {
          url: '/investment-details',
          templateUrl: 'investments/investment-resume.tpl.html',
          params: {
            editMode: false
          },
          resolve: {
            authorize: ["$location", "$stateParams", function ($location, $stateParams) {
              // Forbid user navigation from "URL"
              if (!$stateParams.editMode) {
                $location.url("/investments/" + $stateParams.orderType);
              }
            }]
          }
        })
        // This state is for edit!
        .state('investments.form.edit', {
          url: '/orders/:action?orderId?fundId',
          templateUrl: 'investments/investment-form.tpl.html',
          resolve: {
            orderType: ["$q", "$stateParams", function ($q, $stateParams) {
              var options = ["new", "sell", "replace"];
              if (!_.contains(options, $stateParams.orderType)) {
                return $q.reject("Invalid");
              }
              return $q.resolve($stateParams.orderType);
            }],
            validate: ["$q", "$stateParams", "$location", "orderType", function ($q, $stateParams, $location, orderType) {

              console.log($stateParams.orderId);
              // if orderType is sell or replace - fundId is required!
//              if (orderType != "new" && !$stateParams.fundId) {
//                $location.go("/investments/new");
//                return $q.reject("Invalid");
//              }
              // if orderType is new $stateParams id is optional

              //else if ($stateParams.fundId) {
              //  var fund = _.findWhere(fundList.result, {id: $stateParams.fundId});
              //  if (!fund) {
              //    return $q.reject("Invalid");
              //  }
              //}
            }]
          }
        })
        .state('investments.sign', {
          url: '/:orderId/sign/:fundId',
          templateUrl: 'investments/investment-sign.tpl.html',
          controller: 'InvestmentSignCtrl',
          controllerAs: 'investmentSign',
          resolve: {
            data: ["$q", "$stateParams", "FundsService", "InvestmentOrdersService", function ($q, $stateParams, FundsService, InvestmentOrdersService) {
              if ($stateParams.orderId) {
                return $q.all([InvestmentOrdersService.getInvestmentById($stateParams.orderId), FundsService.getFundById($stateParams.fundId)]);
              } else {
                return $q.reject("Invalid");
              }
            }]
          }
        })

//        .state('funds-sales-replacement', {
//          url: '/sales-replacement-funds',
//          abstract: true,
//          templateUrl: 'investments/sales-replacement-funds.tpl.html',
//          controller: 'SalesReplacementFundsCtrl',
//          controllerAs: 'salesReplacement'
//        })
//        .state('funds-sales-replacement.form', {
//          url: '/form',
//          templateUrl: 'investments/sales-replacement-funds-form.tpl.html'
//        })
//        .state('funds-sales-replacement.resume', {
//          url: '/sales-replacement-funds-details',
//          templateUrl: 'investments/sales-replacement-funds-resume.tpl.html',
//          params: {
//            editMode: false
//          },
//          resolve: {
//            authorize: function ($location, $stateParams) {
//              // Forbid user navigation from "URL"
//              if (!$stateParams.editMode) {
//                $location.url("/sales-replacement-funds/form");
//              }
//            }
//          }
//        });

  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name investments.controller:InvestmentsOverviewCtrl
     *
     * @description
     *
     */
    InvestmentsOverviewCtrl.$inject = ["$stateParams", "$state", "$log", "FundsService", "AlertService", "InvestmentOrdersService", "HelperService", "$translate", "GoogleTagManagerHelperService"];
    angular
        .module('investments')
        .controller('InvestmentsOverviewCtrl', InvestmentsOverviewCtrl);

    function InvestmentsOverviewCtrl($stateParams, $state, $log, FundsService, AlertService, InvestmentOrdersService, HelperService, $translate, GoogleTagManagerHelperService) {
        var vm = this;
        var fundId = $stateParams.fundId;
        vm.currentIndex = 0;
        var investmentOrderFilter = {
            page: 0,
            pageSize: 10,
            orderBy: "invAmountDate desc"
        };

        var investmentTransactionFilter = {
            page: 0,
            pageSize: 10,
            orderBy: "valueDate desc"
        };

        vm.selectedFund = null;
        vm.fundList = [];
        vm.investmentOrderListGrouped = [];
        vm.selectedTab = 2;

        //TODO: load transactions from API
        vm.investmentTransactionListGrouped = {};
        vm.investmentTransactionListGrouped.result = [];

        var init = function () {
            if ($stateParams.fundId) {
                getSelectedFund()
                    .then(function () {
                        getAllFunds()
                            .then(function () {
                                findCurrentFundIndex();
                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                        getInvestmentOrders(true);
                        getInvestmentTransactions(true);
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        var getSelectedFund = function () {
            return FundsService.getFundById($stateParams.fundId)
                .then(function (response) {
                    vm.selectedFund = response;
                })
                .catch(function (error) {
                    vm.selectedFund = null;
                    HelperService.showMessage(error, 'error');
                });
        };

        var getAllFunds = function () {
            return FundsService.getPage()
                .then(function (response) {
                    if (_.isArray(response.result) && response.result.length > 0) {
                        vm.fundList = response.result;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        }


        var findCurrentFundIndex = function () {

            var currIndex = 0;
            _.forEach(vm.fundList, function (item) {
                item.index = currIndex++;
            });

            vm.currentIndex = _.findIndex(vm.fundList, function (item) {
                return vm.selectedFund.id === item.id;
            });

            checkCarouselIndex();
        };

        var setSelectedFund = function () {
            vm.selectedFund = _.find(vm.fundList)
        };

        vm.chooseFromCarousel = function (fundId) {
            vm.currentIndex = _.findIndex(vm.fundList, function (item) {
                return item.id === fundId;
            });
            checkCarouselIndex();
            navigateToFund();
        };

        var checkCarouselIndex = function () {
            vm.isNextButtonVisible = vm.currentIndex < vm.fundList.length - 1;
            vm.isPreviousButtonVisible = vm.currentIndex > 0;
        };

        var navigateToFund = function () {
            $state.go('investments.overview', {
                fundId: vm.fundList[vm.currentIndex].id
            }, {
                notify: false
            });
            vm.selectedFund = vm.fundList[vm.currentIndex];
            getInvestmentOrders(true);
            getInvestmentTransactions(true);
        };

        vm.goToNextItem = function () {
            GoogleTagManagerHelperService.pushEvent('Investments', 'Carousel', 'NextSlide');
            vm.currentIndex++;
            checkCarouselIndex();
            if (vm.currentIndex <= vm.fundList.length - 1) {
                navigateToFund();
            }
        };

        vm.goToPreviousItem = function () {
            GoogleTagManagerHelperService.pushEvent('Investments', 'Carousel', 'PreviousSlide');
            vm.currentIndex--;
            checkCarouselIndex();
            if (vm.currentIndex >= 0) {
                navigateToFund();
            }
        };

        vm.editOrder = function (fundId, order) {
            var orderType = getOrderType(order);
            $state.go("investments.form.edit", {
                action: "edit",
                fundId: fundId,
                orderType: orderType,
                orderId: order.orderId
            });
        };


        vm.copyOrder = function (fundId, order) {
            var orderType = getOrderType(order);
            $state.go("investments.form.edit", {
                action: "copy",
                fundId: fundId,
                orderType: orderType,
                orderId: order.orderId
            });
        };

        function getOrderType(order) {
            var orderType;
            switch (order.orderType) {
            case 1:
                orderType = "new";
                break;
            case 2:
                orderType = "sell";
                break;
            case 3:
                orderType = "replace"
                break;
            }
            return orderType;
        }

        vm.signOrder = function (order) {
            $state.go("investments.sign", {
                orderId: order.orderId,
                fundId: fundId
            });
        };

        var getInvestmentOrders = function (reset) {
            if (reset) {
                investmentOrderFilter.page = 0;
            } else {
                investmentOrderFilter.page++;
            }
            investmentOrderFilter.fundId = vm.selectedFund.fundId;
            InvestmentOrdersService.getPage(investmentOrderFilter)
                .then(function (response) {
                    vm.investmentOrderListGrouped = HelperService.mergeRowsForTimeline({
                        existingData: vm.investmentOrderListGrouped,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.invAmountDate);
                            date.setHours(0, 0, 0, 0);
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                date: new Date(e),
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });

                    $log.debug("Investment order list grouped")

                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        var getInvestmentTransactions = function (reset) {
            if (reset) {
                investmentTransactionFilter.page = 0;
            } else {
                investmentTransactionFilter.page++;
            }
            investmentTransactionFilter.fundId = vm.selectedFund.fundId;
            InvestmentOrdersService.getInvestmentTransactions(investmentTransactionFilter)
                .then(function (response) {
                    vm.investmentTransactionListGrouped = HelperService.mergeRowsForTimeline({
                        existingData: vm.investmentTransactionListGrouped.result,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.valueDate);
                            date.setHours(0, 0, 0, 0);
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                date: new Date(e),
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });
                    $log.debug("Investment transaction list grouped")

                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.selectTab = function (tab, translateLabel) {
            if (tab == vm.selectedTab) return;
            vm.selectedTab = tab;
            GoogleTagManagerHelperService.pushEvent('InvestmentsOverview', 'Tab', $translate.instant(translateLabel));
        }

        vm.loadMoreInvestmentTransaction = function () {
            getInvestmentTransactions(false);
        };

        vm.loadMoreInvestmentOrders = function () {
            getInvestmentOrders(false);
        };

        vm.deleteInvestment = function (id) {
            AlertService.confirmationAlert()
                .then(function (result) {
                    if (result) {
                        vm.deleteButtonDisabled = true;
                        InvestmentOrdersService.deleteInvestment(id)
                            .then(function (response) {
                                vm.investmentOrderListGrouped.result = _.without(vm.investmentOrderListGrouped.result, _.findWhere(vm.investmentOrderListGrouped.result, {
                                    orderId: id
                                }));
                                // Clean virtual
                                for (var i = 0; i < vm.investmentOrderListGrouped.result.length; i++) {
                                    if (vm.investmentOrderListGrouped.result[i].isVirtual && (!vm.investmentOrderListGrouped.result[i + 1] || vm.investmentOrderListGrouped.result[i + 1].isVirtual)) {
                                        vm.investmentOrderListGrouped.result = _.without(vm.investmentOrderListGrouped.result, vm.investmentOrderListGrouped.result[i]);
                                    }
                                }
                                vm.deleteButtonDisabled = false;
                                AlertService.deletedPaymentAlert({
                                    paymentName: id,
                                    type: 'investment'
                                });

                            }, function (error) {
                                vm.deleteButtonDisabled = false;
                            });
                    }
                });
        };
        vm.pushGTMevent = function (type) {
            GoogleTagManagerHelperService.pushEvent('InvestmentsOverview', type, type + 'button selected');
        };
        vm.toggleGtmDetailsOpenEvent = function (condition) {
            GoogleTagManagerHelperService.pushEvent('InvestmentsOverview', 'InvestmentDetails', (condition) ? 'Show additional details' : 'Hide additional details');
        };

        init();
    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name investments.controller:InvestmentsListCtrl
     *
     * @description
     *
     */
    InvestmentsListCtrl.$inject = ["$log", "$state", "FundsService", "HelperService"];
    angular
            .module('investments')
            .controller('InvestmentsListCtrl', InvestmentsListCtrl);

    function InvestmentsListCtrl($log, $state, FundsService, HelperService) {
        var vm = this;
        vm.fundsList = [];
        vm.fundFilter = {
            page: 0,
            pageSize: 1000
        };

        var init = function () {
            //if(userHaveFunds){
            //    loadInvestmentAccounts();
            //} else {
            //    $state.go('investments.accession');
            //}
          loadInvestmentAccounts();
        };
        var loadInvestmentAccounts = function () {
            FundsService.getPage()
                    .then(function (response) {
                        vm.fundsList = response.result;
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
        };

        init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name investments.controller:InvestmentSignCtrl
   *
   * @description
   *
   */
  InvestmentSignCtrl.$inject = ["$state", "data", "InvestmentOrdersService", "HelperService"];
  angular
      .module('investments')
      .controller('InvestmentSignCtrl', InvestmentSignCtrl);

  function InvestmentSignCtrl($state, data, InvestmentOrdersService, HelperService) {
    var vm = this;
    vm.model = {};
    vm.model.password2 = "";
    vm.investment = data[0];



    vm.confirmSignedInvestment = function () {
      vm.confirmSignedButtonDisabled = true;
      InvestmentOrdersService.confirmSignInvestment(vm.investment.orderId, vm.model.password2)
          .then(function (response) {
            vm.confirmSignedButtonDisabled = false;
            $state.go("investments.overview", {fundId: $state.params.fundId});
          }, function (error) {
            HelperService.showMessage(error, "error");
            vm.confirmSignedButtonDisabled = false;
          });
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name investments.factory:InvestmentOrdersService
   *
   * @description
   *
   */
  InvestmentOrdersService.$inject = ["$http", "$q", "$sessionStorage", "EndpointsService", "SessionService"];
  angular
      .module('investments')
      .factory('InvestmentOrdersService', InvestmentOrdersService);

  function InvestmentOrdersService($http, $q, $sessionStorage, EndpointsService, SessionService) {
    var InvestmentOrdersServiceBase = {};

    if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'investmentOrder'){
      insert($sessionStorage.paymentStorageObject.object);
    }

    InvestmentOrdersServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.investmentOrders, {
          params: params
        })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
          deferred.reject(msg);
        });
      },
          function (error) {
            deferred.reject(error);
          });
      return deferred.promise;
    };


    InvestmentOrdersServiceBase.getInvestmentById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.investmentOrders_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
          deferred.reject(msg);
        });
      },
          function (error) {
            deferred.reject(error);
          });
      return deferred.promise;
    };

    function insert(investment) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          SessionService.saveStorageObject(investment, 'investmentOrder');
          $http.post(response.links.investmentOrders, investment)
            .success(function (data) {
              SessionService.removeStorageObject();
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    InvestmentOrdersServiceBase.insertInvestment = function (investment) {
      return insert(investment);
    };

    InvestmentOrdersServiceBase.deleteInvestment = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.delete(response.links.investmentOrders_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
          deferred.reject(msg);
        });
      },
          function (error) {
            deferred.reject(error);
          });
      return deferred.promise;
    };

    InvestmentOrdersServiceBase.updateInvestment = function (id, investment) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.investmentOrders_id.replace('{id}', id), investment)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
          deferred.reject(msg);
        });
      },
          function (error) {
            deferred.reject(error);
          });
      return deferred.promise;
    };

    InvestmentOrdersServiceBase.confirmSignInvestment = function (id, signData) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.investmentOrders_sign, {id: id, signData: signData})
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    InvestmentOrdersServiceBase.getInvestmentTransactions = function (params) {
      return $q(function (resolve, reject) {
        EndpointsService.getLinks()
          .then(function (response) {
            $http.get(response.links.investmentTransactions, {
                params: params
              })
              .success(function (data) {
                resolve(data);
              })
              .error(function (error) {
                reject(error);
              });
          }, function (error) {
            reject(error);
          });
      });
    };

    return InvestmentOrdersServiceBase;
  }
}());

(function () {
  'use strict';
  /**
   * @ngdoc object
   * @name investments.controller:SalesReplacementFundsCtrl
   *
   * @description
   *
   */
  InvestmentCtrl.$inject = ["$rootScope", "$scope", "$timeout", "$uibModal", "$q", "$filter", "$state", "orderType", "configData", "AccountsService", "CTLocalizationService", "InvestmentOrdersService", "ValidationService", "HelperService", "FundsService", "AlertService", "userHaveFunds", "GoogleTagManagerHelperService", "$location"];
  angular
      .module('investments')
      .controller('InvestmentCtrl', InvestmentCtrl);
  function InvestmentCtrl($rootScope, $scope, $timeout, $uibModal, $q, $filter, $state, orderType, configData,
      AccountsService, CTLocalizationService, InvestmentOrdersService, ValidationService,
                           HelperService, FundsService, AlertService, userHaveFunds, GoogleTagManagerHelperService, $location) {

    var vm = this;
    var editMode;
    var FundId;
    var action = $state.params.action;

    init();
    function init() {
      editMode = false;
      vm.orderId = $state.params.orderId;
      vm.fundId = $state.params.fundId;
      vm.orderTypeText = orderType;
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
      vm.dateOptions = {
        minDate: new Date(),
        maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
      };
      vm.amountTypes = [
        {id: 1, name: "invest.amountTypeAllShares"},
        {id: 2, name: "invest.amountTypeShareValue"},
        {id: 3, name: "invest.amountTypeShareQuantity"}
      ];

      vm.investmentAccountList = [];

      vm.model = {
        orderType: "",
        fromAccountSelect: "",
        fundSelect: "",
        fundSelectReplace: "",
        toAccountInput: "",
        dueDateInput: new Date(),
        amountInput: "",
        accountType: "1",
        comment: "",
        amountType: 2,
        invQuantity: null,
        investmentAccount: ""
      };

      switch (orderType) {
        case "new":
          vm.model.orderType = 1;
          break;
        case "sell":
          vm.model.orderType = 2;
          break;
        case "replace":
          vm.model.orderType = 3;
          break;
      }

      loadAllData();
    }

    function loadAllData() {
      var promises = [];
      promises.push(AccountsService.getOrderInvAccounts());
      if (vm.fundId) {
        promises.push(FundsService.getFundById(vm.fundId));
      }
      if (vm.orderId) {
        promises.push(InvestmentOrdersService.getInvestmentById(vm.orderId));
      }
      $q.all(promises)
          .then(function (responses) {
            // 1. response
            var investmentAccounts = responses[0].result;
            if (_.isArray(investmentAccounts) && investmentAccounts.length > 0) {
              vm.accountsFromList = investmentAccounts;
              vm.model.fromAccountSelect = investmentAccounts[0];
              // 2. response
              if (responses[1]) {
                var fund = responses[1];
                FundId = fund.fundId.toString();
                vm.model.accountType = (fund.accountType == "Investitor") ? "1" : "2"
              }

              // 3. response
              if (responses[2]) {

                editMode = (action == "copy") ? false : true;
                var data = responses[2];
                if (data.accountId) {
                  vm.model.fromAccountSelect = _.findWhere(investmentAccounts, {accountId: data.accountId.toString()})
                } else {
                  vm.model.fromAccountSelect = investmentAccounts[0];
                }
                vm.model.orderType = data.orderType;
                vm.model.toAccountInput = data.toAccountInput;
                vm.model.dueDateInput = new Date(data.invAmountDate);
                vm.model.amountInput = data.invAmount;
                vm.model.comment = data.note;
                vm.model.amountType = data.amountType;
                vm.model.invQuantity = data.invAmount;


                if (data.amountType == 1) {
                  vm.model.invQuantity = null;
                  vm.model.amountInput = "";
                } else if (data.amountType == 2) {
                  vm.model.invQuantity = null;
                } else if (data.amountType == 3) {
                  vm.model.amountInput = "";
                }
              }
              /*
               * If buy/replace - sale: "N"
               * If sell - sale - "Y"
               */
              getFundAccounts({
                "request.sale": (vm.model.orderType == 2) ? "Y" : "N",
                "request.currencySymbol": vm.model.fromAccountSelect.currencySymbol
              }).then(function(){
                if (vm.model.orderType == 3 && editMode) {
                    vm.model.fundSelectReplace = _.findWhere(vm.fundReplacementList, {accountId: data.invSellAccId});
                    vm.fundSelectReplaceChange(vm.model.fundSelectReplace);
                }
              });
            }
          }, function (error) {
            HelperService.showMessage(error, 'error');
          });
    }

    function getFundAccounts(params) {
     return FundsService.getFundAccounts(params)
          .then(function (response) {

            vm.fundList = response.result;
            //Init funds
            if (FundId && !vm.model.fundSelect) {
              vm.model.fundSelect = _.findWhere(response.result, {id: FundId});
            } else if (vm.model.fundSelect) {
              vm.model.fundSelect = _.findWhere(response.result, {id: vm.model.fundSelect.id});
            }

            if (vm.model.fundSelect) {
//              vm.model.fundSelect = _.findWhere(response.result, {id: vm.model.fundSelect.id});
              vm.onFundSelect(vm.model.fundSelect);
              vm.fundReplacementList = _.without(response.result, vm.model.fundSelect);
              // Init fundSelectReplace after refresh
              if (vm.model.orderType == 3 && vm.model.fundSelectReplace) {
                vm.model.fundSelectReplace = _.findWhere(vm.fundList, {id: vm.model.fundSelectReplace.id, accountId: vm.model.fundSelectReplace.accountId})
              }
              vm.submitButtonDisabled = false;

            } else if (vm.model.orderType == 2 && !vm.model.fundSelect) {
              vm.submitButtonDisabled = true;
              vm.model.toAccountInput = "";

              AlertService.infoAlert({
                text: "invest.alertInfoNoFund"
              });
            }
          }, function (err) {
            HelperService.showMessage(error, 'error');
          });
    }

    function remapDataForUpdate() {
      var data = {
        accountId: vm.model.fromAccountSelect.accountId,
        amountCurCode: vm.model.fromAccountSelect.currencySymbol,
        invAmountDate: vm.model.dueDateInput,
        note: vm.model.comment,
        invBuyAccId: "",
        invSellAccId: "",
        orderType: +vm.model.orderType,
        invAmount: vm.model.amountInput,
        amountType: vm.model.amountType,
        accType: vm.model.accountType,
        invQuantity: vm.model.invQuantity
      };
      if (vm.model.orderType == 1) {
        //data.invBuyAccId = (vm.model.fundSelect.accountId) ? vm.model.fundSelect.accountId : null;
        data.invBuyAccId = vm.model.investmentAccount ? vm.model.investmentAccount.accountId : null;
        data.invSellAccId = null;
      } else if (vm.model.orderType == 2) {
        data.invBuyAccId = null; // servis ne podrzava null
        //data.invSellAccId = vm.model.fundSelect.accountId;
        data.invSellAccId = vm.investmentAccount ? vm.model.investmentAccount.accountId : null;
        data.payeeTo = vm.model.fundSelect.id;
      } else if (vm.model.orderType == 3) {
        //data.invBuyAccId = vm.model.fundSelectReplace.accountId;
        data.invBuyAccId = vm.model.investmentAccount ? vm.model.investmentAccount.accountId : null;
        data.invSellAccId = vm.model.fundSelect.accountId;
        data.payeeFrom = vm.model.fundSelect.id;
      }

      if (vm.model.accountType != "1") {
        if (vm.model.orderType == 1) {
          //data.selectedAccId = (vm.model.fundSelect.accountId) ? vm.model.fundSelect.accountId : null;
          data.selectedAccId = vm.model.investmentAccount ? vm.model.investmentAccount.accountId : null;
        } else if (vm.model.orderType == 3) {
          //data.selectedAccId = vm.model.fundSelectReplace.accountId;
          data.selectedAccId = vm.model.investmentAccount ? vm.model.investmentAccount.accountId : null;
        }
      }
      return data;
    }

    function insertInvestment(updateData) {
      InvestmentOrdersService.insertInvestment(updateData)
          .then(function (response) {
            editMode = true;
            vm.submitButtonDisabled = false;
            vm.responseModel = response;
            $state.go('investments.form.resume', {orderType: $state.params.orderType, editMode: editMode});
          })
          .catch(function (error) {
            vm.submitButtonDisabled = false;
            HelperService.showMessage(error, 'error');
          });
    }

    vm.onAmountTypeChange = function (amountType) {
      if (amountType == 1) {
        vm.model.invQuantity = null;
        vm.model.amountInput = "";
      } else if (amountType == 2) {
        vm.model.invQuantity = null;
      } else if (amountType == 3) {
        vm.model.amountInput = "";
      }
      vm.formSubmitted = false;
    };

    vm.dateDisabled = function (date, mode) {
      return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
    };

    vm.setAccountFrom = function (account) {
      vm.model.fromAccountSelect = account;
      getFundAccounts({
        "request.sale": (vm.model.orderType == 2) ? "Y" : "N",
        "request.currencySymbol": vm.model.fromAccountSelect.currencySymbol
      });
    };

    vm.onFundSelect = function (fund) {
      //vm.model.toAccountInput = (vm.model.orderType != 3) ? fund.iban.replace(/-/g, '') : null;
      if (fund) {
        vm.model.toAccountInput = fund.iban.replace(/-/g, '');
//        vm.submitButtonDisabled = false;
      } else {
        vm.model.toAccountInput = "";
//        vm.submitButtonDisabled = true;
      }
      vm.getUserInvestmentAccounts();
    };

//    vm.checkAmountValue = function () {
//      var amount = document.getElementById('amountInput').value;
//      if (HelperService.parseAmountInput(amount) < 100) {
//        vm.fundsForm.amountInput.$setValidity("min", false);
//      } else {
//        vm.fundsForm.amountInput.$setValidity("min", true);
//      }
//    };

    vm.openBrochure = function () {
      window.open(configData.InvestmentLink, '_blank');
    };

    vm.submit = function () {
      vm.formSubmitted = true;
      if (vm.fundsForm.$invalid)
        return;
      vm.submitButtonDisabled = true;
      var updateData = remapDataForUpdate();
      if (orderType != 'sell') {
        checkUsersFund(updateData);
      } else {
        if (!editMode) {
          insertInvestment(updateData);
        } else {
          updateInvestmentData(updateData);
        }

      }
    };

    function insertInvestment(updateData) {
      return  InvestmentOrdersService.insertInvestment(updateData)
          .then(function (response) {
            editMode = true;
            vm.submitButtonDisabled = false;
            vm.responseModel = response;
            $state.go('investments.form.resume', {orderType: $state.params.orderType, editMode: editMode});
          var gtmObject = HelperService.processUrlForGTM('payment');
          GoogleTagManagerHelperService.pushVirtualPageView(gtmObject.url, gtmObject.title, $location.host() + gtmObject.url);
          })
          .catch(function (error) {
            vm.submitButtonDisabled = false;
            HelperService.showMessage(error, 'error');
          });
    }


    function updateInvestmentData(updateData) {
      return  InvestmentOrdersService.updateInvestment((vm.responseModel) ? vm.responseModel.orderId : vm.orderId, updateData)
          .then(function (response) {
            vm.responseModel = response;
            vm.submitButtonDisabled = false;
            $state.go('investments.form.resume', {orderType: $state.params.orderType, editMode: true});
          })
          .catch(function (error) {
            vm.submitButtonDisabled = false;
            HelperService.showMessage(error, 'error');
          });
    }


    var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    $rootScope.$on('appLanguageChangedHeader', function () {
      sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    });

    vm.delete = function () {
      AlertService.confirmationAlert()
          .then(function (result) {
            if (result) {
              vm.deleteButtonDisabled = true;
              InvestmentOrdersService.deleteInvestment(vm.responseModel.orderId)
                  .then(function (response) {
                    AlertService.deletedPaymentAlert({paymentName: vm.responseModel.orderId, type: 'investment'})
                        .then(function () {
                          $state.go("investments.form.new", {orderType: $state.params.orderType, fundId: vm.fundId}, {reload: true});
                          vm.deleteButtonDisabled = false;
                        });
                  })
                  .catch(function (error) {
                    vm.deleteButtonDisabled = false;
                    HelperService.showMessage(error, 'error');
                  });
            }
          })
          .catch(function () {
            $log.debug('Example failed!');
          });
    };

    vm.confirmSignedInvestment = function () {
      vm.confirmSignedButtonDisabled = true;
      InvestmentOrdersService.confirmSignInvestment(vm.responseModel.orderId, vm.model.password2)
          .then(function (response) {
            vm.confirmSignedButtonDisabled = false;
            var customFundId = '';
            if(response.investmentOrder.invBuyAccId && response.investmentOrder.fundId)
              customFundId = response.investmentOrder.invBuyAccId + '_' + response.investmentOrder.fundId;

            $state.go("investments.overview", {fundId: vm.fundId ? vm.fundId : customFundId});
          }, function (error) {
            HelperService.showMessage(error, "error");
            vm.confirmSignedButtonDisabled = false;
          });
    };

    vm.fundSelectReplaceChange = function (fundSelect) {
      if(fundSelect) {
        vm.model.fundSelectReplaceInput = fundSelect.iban.replace(/-/g, '');
      }
      vm.getUserInvestmentAccounts();
    };

    //var loadUserFunds = function () {
    //  return FundsService.getPage()
    //      .then(function (response) {
    //        if (response.result && response.result.length > 0) {
    //          vm.fundList = response.result;
    //          vm.model.fundSelect = _.findWhere(vm.fundList, {id: $state.params.fundId});
    //          if (vm.model.fundSelect) {
    //            vm.onFundSelect(vm.model.fundSelect);
    //            vm.fundReplacementList = _.without(vm.fundList, vm.model.fundSelect);
    //          }
    //        }
    //      })
    //      .catch(function (error) {
    //        HelperService.showMessage(error, 'error');
    //      });
    //};

    var checkUsersFund = function (data) {
      var tempFundObj = {};
      if (orderType == "replace") {
        tempFundObj = vm.model.fundSelectReplace;
      } else {
        tempFundObj = vm.model.fundSelect;
      }

      var fundRelatedAccount = vm.model.investmentAccount ? vm.model.investmentAccount.accountId : null;

      if (fundRelatedAccount || vm.model.accountType === '2') {
        if (!editMode) {
          insertInvestment(data)
        } else
          updateInvestmentData(data);

      } else {
        $rootScope.investmentFundName = vm.model.fundSelect.fundName;
        $uibModal.open({
          templateUrl: 'investments/investment-confirm-modal.tpl.html',
          backdrop: 'static',
          size: 'md'
        }).result.then(function (result) {
          if (!result) {
            vm.submitButtonDisabled = false;
            return;
          }
          data.payeeTo = tempFundObj.id;
          data.invBuyAccId = null;
          if (editMode) {
            updateInvestmentData(data)
                .then(function () {
                  getFundAccounts({
                    "request.sale": (vm.model.orderType == 2) ? "Y" : "N",
                    "request.currencySymbol": vm.model.fromAccountSelect.currencySymbol
                  });
                })
          } else {
            insertInvestment(data)
                .then(function () {
                  getFundAccounts({
                    "request.sale": (vm.model.orderType == 2) ? "Y" : "N",
                    "request.currencySymbol": vm.model.fromAccountSelect.currencySymbol
                  });
                })
          }
        });
      }
    };

    vm.getUserInvestmentAccounts = function () {
      var requestObj = {
        accountType: vm.model.accountType
      };
      if (vm.model.orderType == 3) {
        requestObj.fundId = vm.model.fundSelectReplace.id;
      } else {
        requestObj.fundId = vm.model.fundSelect.id;
      }

      FundsService.getUserInvestmentAccountsByFundId(requestObj)
        .then(function (response) {
          if (response && response.result) {
            vm.investmentAccountList = response.result;
            vm.model.investmentAccount = vm.investmentAccountList[0];
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name investments.factory:FundsService
   *
   * @description
   *
   */
  FundsService.$inject = ["$http", "$q", "EndpointsService", "ConfigService"];
  angular
    .module('investments')
    .factory('FundsService', FundsService);

  function FundsService($http, $q, EndpointsService, ConfigService) {
    var FundsServiceBase = {};

    FundsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.funds, {
              params: params
            })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    FundsServiceBase.getFundById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.funds_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    FundsServiceBase.getUserFundById = function (accountId) {
      var deferred = $q.defer();
      var url = ConfigService.url + 'funds/getUserFundAccountById';
      $http.get(url, {
          params: {
            AccountId: accountId
          }
        })
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function (msg, code) {
          deferred.reject(msg);
        });
      return deferred.promise;
    };

    FundsServiceBase.insertFundUserDetail = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.funds_insertFundUserDetail, params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    FundsServiceBase.getFundAccounts = function(params){
       var deferred = $q.defer();
      var url = ConfigService.url + 'funds/getFundAccounts';
      $http.get(url, {
          params: params
        })
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function (msg, code) {
          deferred.reject(msg);
        });
      return deferred.promise;
    }

    FundsServiceBase.getUserInvestmentAccountsByFundId = function (params) {
      var deferred = $q.defer();
      var url = ConfigService.url + 'funds/getUserInvestmentAccountsByFundId';
      $http.get(url, {
          params: params
        })
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function (msg, code) {
          deferred.reject(msg);
        });
      return deferred.promise;
    };

    return FundsServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name investments.controller:AccessInvestmentsCtrl
   *
   * @description
   *
   */
  AccessInvestmentsCtrl.$inject = ["$log", "HelperService", "FundsService", "ConfigEndpointService", "UserSettingsService", "$state", "$translate"];
  angular
    .module('investments')
    .controller('AccessInvestmentsCtrl', AccessInvestmentsCtrl);

  function AccessInvestmentsCtrl($log, HelperService, FundsService, ConfigEndpointService, UserSettingsService,
                                 $state, $translate) {
    var vm = this;

// form dropdown available options
    vm.personalStatusData = [
      {
        key: 'accessInvestment.employee',
        val: 0
      },
      {
        key: 'accessInvestment.firm',
        val: 1
      },
      {
        key: 'accessInvestment.unemployed',
        val: 2
      },
      {
        key: 'accessInvestment.retired',
        val: 3
      },
      {
        key: 'accessInvestment.student',
        val: 4
      },
      {
        key: 'accessInvestment.rest',
        val: 99
      }
    ];

    vm.employerTypeData = [
      {
        key: 'accessInvestment.privateSector',
        val: 0
      },
      {
       key: 'accessInvestment.civileService',
        val: 1
      },
      {
        key: 'accessInvestment.stateAuth',
        val: 2
      },
      {
        key: 'accessInvestment.emplTrade',
        val: 3
      }
    ];

    vm.plannedInvestmentsType = [
      {
        key: 'accessInvestment.inv1',
        val: 0
      },
      {
        key: 'accessInvestment.inv2',
        val: 1
      },
      {
        key: 'accessInvestment.inv3',
        val: 2
      },
      {
        key: 'accessInvestment.inv4',
        val: 3
      }
    ];

    vm.investFromType = [
      {
        key: 'accessInvestment.invEmployment',
        val: 0
      },
      {
        key: 'accessInvestment.invfreelancing',
        val: 1
      },
      {
        key: 'accessInvestment.invLegal',
        val: 2
      },
      {
        key: 'accessInvestment.capital',
        val: 3
      },
      {
        key: 'accessInvestment.invInsured',
        val: 4
      },
      {
        key: 'accessInvestment.rest',
        val: 5
      }
    ];


    vm.tempAccessionObj = {
      nameSurnameInput: '',
      addressInput: '',
      identificationNumberInput: '',
      personalHomePhoneInput: '',
      issuerInput: '',
      personalEmailInput: '',
      personalStatus: vm.personalStatusData[0],
      employerType: vm.employerTypeData[0],
      plannedInvestments: vm.plannedInvestmentsType[0],
      investFrom: vm.investFromType[0],
      bankInput: '',
      toAccount1Input: '2500009',
      toAccount2Input: '',
      professionInput: '',
      occupationInput: '',
      sendViaEmail: false
    };

    var defaultData = {}, userSettings = {};

    var init = function (){
      getDefaultData();
      getUserSettings();
    };

    var createInsertObject = function () {
      var insertObj = {
        personalHomePhone: vm.tempAccessionObj.personalHomePhoneInput,
        personalEmail: userSettings.email,
        toAccount1: vm.tempAccessionObj.toAccount1Input,
        toAccount2: vm.tempAccessionObj.toAccount2Input,
        personalStatus: vm.tempAccessionObj.personalStatus.val,
        personalStatusDesc: $translate.instant(vm.tempAccessionObj.personalStatus.key),
        employerType: vm.tempAccessionObj.employerType.val,
        employerTypeDesc: $translate.instant(vm.tempAccessionObj.employerType.key),
        profession: vm.tempAccessionObj.professionInput,
        occupation: vm.tempAccessionObj.occupationInput,
        plannedInvestments: vm.tempAccessionObj.plannedInvestments.val,
        plannedInvestmentsDesc: $translate.instant(vm.tempAccessionObj.plannedInvestments.key),
        investFrom: vm.tempAccessionObj.investFrom.val,
        investFromDesc: $translate.instant(vm.tempAccessionObj.investFrom.key),
        oib: '',
        mb: '',
        sendViaEmail: vm.tempAccessionObj.sendViaEmail,
        bank: vm.tempAccessionObj.bankInput,
        deliveryMailAddress: vm.tempAccessionObj.personalEmailInput,
        fondPmxID: vm.tempAccessionObj.identificationNumberInput,
        fondPmxID1: vm.tempAccessionObj.issuerInput
      };

      return insertObj;
    };

    vm.submit = function (){
      FundsService.insertFundUserDetail(createInsertObject())
        .then(function (response){
          $state.go('dashboard');
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        });
    };

    var getDefaultData = function (){
      return ConfigEndpointService.getDefaultData()
        .then(function (response){
          defaultData = response;
          vm.tempAccessionObj.bankInput = response.BankName;
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        })
    };

    var getUserSettings = function () {
      return UserSettingsService.getPage()
        .then(function (response){
          if(response.result && response.result.length > 0) {
            userSettings = response.result[0];
            vm.tempAccessionObj.nameSurnameInput = userSettings.firstName + ' ' + userSettings.lastName;
            vm.tempAccessionObj.addressInput = userSettings.address2;
            vm.tempAccessionObj.personalEmailInput = userSettings.email;
          }
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        })
    };

    init();
  }
}());

// https://github.com/angular/angular.js/blob/master/src/ngLocale/angular-locale_sr-latn.js
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "pre podne",
      "po podne"
    ],
    "DAY": [
      "nedelja",
      "ponedeljak",
      "utorak",
      "sreda",
      "\u010detvrtak",
      "petak",
      "subota"
    ],
    "ERANAMES": [
      "pre nove ere",
      "nove ere"
    ],
    "ERAS": [
      "p. n. e.",
      "n. e."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "januar",
      "februar",
      "mart",
      "april",
      "maj",
      "jun",
      "jul",
      "avgust",
      "septembar",
      "oktobar",
      "novembar",
      "decembar"
    ],
    "SHORTDAY": [
      "ned",
      "pon",
      "uto",
      "sre",
      "\u010det",
      "pet",
      "sub"
    ],
    "SHORTMONTH": [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "avg",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "STANDALONEMONTH": [
      "januar",
      "februar",
      "mart",
      "april",
      "maj",
      "jun",
      "jul",
      "avgust",
      "septembar",
      "oktobar",
      "novembar",
      "decembar"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, dd. MMMM y.",
    "longDate": "dd. MMMM y.",
//    "medium": "dd.MM.y. HH.mm.ss",
    "medium": "dd.MM.yyyy HH.mm.ss",
    "mediumDate": "dd.MM.y.",
    "mediumTime": "HH.mm.ss",
    "short": "d.M.yy. HH.mm",
    "shortDate": "dd.MM.yyyy",
    "shortTime": "HH.mm",
    "shortDate2": "dd.MM.yyyy"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "din",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "sr-latn",
  "localeID": "sr_Latn",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11 || vf.f % 10 == 1 && vf.f % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14) || vf.f % 10 >= 2 && vf.f % 10 <= 4 && (vf.f % 100 < 12 || vf.f % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "dop.",
      "pop."
    ],
    "DAY": [
      "nedelja",
      "ponedeljek",
      "torek",
      "sreda",
      "\u010detrtek",
      "petek",
      "sobota"
    ],
    "ERANAMES": [
      "pred Kristusom",
      "na\u0161e \u0161tetje"
    ],
    "ERAS": [
      "pr. Kr.",
      "po n. \u0161t."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "januar",
      "februar",
      "marec",
      "april",
      "maj",
      "junij",
      "julij",
      "avgust",
      "september",
      "oktober",
      "november",
      "december"
    ],
    "SHORTDAY": [
      "ned.",
      "pon.",
      "tor.",
      "sre.",
      "\u010det.",
      "pet.",
      "sob."
    ],
    "SHORTMONTH": [
      "jan.",
      "feb.",
      "mar.",
      "apr.",
      "maj",
      "jun.",
      "jul.",
      "avg.",
      "sep.",
      "okt.",
      "nov.",
      "dec."
    ],
    "STANDALONEMONTH": [
      "januar",
      "februar",
      "marec",
      "april",
      "maj",
      "junij",
      "julij",
      "avgust",
      "september",
      "oktober",
      "november",
      "december"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, dd. MMMM yyyy",
    "longDate": "dd. MMMM yyyy",
    "medium": "d. MMM y HH:mm:ss",
    "mediumDate": "d. MMM yyyy",
    "mediumTime": "HH:mm:ss",
    "short": "d.M.yyyy HH:mm",
    "shortDate": "d.M.yyyy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "sl",
  "localeID": "sl",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 100 == 1) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 100 == 2) {    return PLURAL_CATEGORY.TWO;  }  if (vf.v == 0 && i % 100 >= 3 && i % 100 <= 4 || vf.v != 0) {    return PLURAL_CATEGORY.FEW;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

// https://github.com/angular/angular.js/blob/master/src/ngLocale/angular-locale_sr-latn-me.js
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "pre podne",
      "po podne"
    ],
    "DAY": [
      "nedelja",
      "ponedeljak",
      "utorak",
      "sreda",
      "\u010detvrtak",
      "petak",
      "subota"
    ],
    "ERANAMES": [
      "pre nove ere",
      "nove ere"
    ],
    "ERAS": [
      "p. n. e.",
      "n. e."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "januar",
      "februar",
      "mart",
      "april",
      "maj",
      "jun",
      "jul",
      "avgust",
      "septembar",
      "oktobar",
      "novembar",
      "decembar"
    ],
    "SHORTDAY": [
      "ned",
      "pon",
      "uto",
      "sre",
      "\u010det",
      "pet",
      "sub"
    ],
    "SHORTMONTH": [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "avg",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "STANDALONEMONTH": [
      "januar",
      "februar",
      "mart",
      "april",
      "maj",
      "jun",
      "jul",
      "avgust",
      "septembar",
      "oktobar",
      "novembar",
      "decembar"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, dd. MMMM y.",
    "longDate": "dd. MMMM y.",
//    "medium": "dd.MM.y. HH.mm.ss",
    "medium": "dd.MM.yyyy HH.mm.ss",
    "mediumDate": "dd.MM.y.",
    "mediumTime": "HH.mm.ss",
    "short": "d.M.yy. HH.mm",
    "shortDate": "d.M.yy.",
    "shortTime": "HH.mm",
    "shortDate2": "d.M.y"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "sr-latn-me",
  "localeID": "sr_Latn_ME",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11 || vf.f % 10 == 1 && vf.f % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14) || vf.f % 10 >= 2 && vf.f % 10 <= 4 && (vf.f % 100 < 12 || vf.f % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);
// https://github.com/angular/angular.js/blob/master/src/ngLocale/angular-locale_sr-latn-me.js
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "pre podne",
      "po podne"
    ],
    "DAY": [
      "nedelja",
      "ponedeljak",
      "utorak",
      "sreda",
      "\u010detvrtak",
      "petak",
      "subota"
    ],
    "ERANAMES": [
      "pre nove ere",
      "nove ere"
    ],
    "ERAS": [
      "p. n. e.",
      "n. e."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "januar",
      "februar",
      "mart",
      "april",
      "maj",
      "jun",
      "jul",
      "avgust",
      "septembar",
      "oktobar",
      "novembar",
      "decembar"
    ],
    "SHORTDAY": [
      "ned",
      "pon",
      "uto",
      "sre",
      "\u010det",
      "pet",
      "sub"
    ],
    "SHORTMONTH": [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "avg",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "STANDALONEMONTH": [
      "januar",
      "februar",
      "mart",
      "april",
      "maj",
      "jun",
      "jul",
      "avgust",
      "septembar",
      "oktobar",
      "novembar",
      "decembar"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, dd. MMMM y.",
    "longDate": "dd. MMMM y.",
//    "medium": "dd.MM.y. HH.mm.ss",
    "medium": "dd.MM.yyyy HH.mm.ss",
    "mediumDate": "dd.MM.y.",
    "mediumTime": "HH.mm.ss",
    "short": "d.M.yy. HH.mm",
    "shortDate": "d.M.yy.",
    "shortTime": "HH.mm",
    "shortDate2": "d.M.y"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "sr-latn-me",
  "localeID": "sr_Latn_ME",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11 || vf.f % 10 == 1 && vf.f % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14) || vf.f % 10 >= 2 && vf.f % 10 <= 4 && (vf.f % 100 < 12 || vf.f % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "nedjelja",
      "ponedjeljak",
      "utorak",
      "srijeda",
      "\u010detvrtak",
      "petak",
      "subota"
    ],
    "ERANAMES": [
      "Prije Krista",
      "Poslije Krista"
    ],
    "ERAS": [
      "pr. Kr.",
      "p. Kr."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "sije\u010dnja",
      "velja\u010de",
      "o\u017eujka",
      "travnja",
      "svibnja",
      "lipnja",
      "srpnja",
      "kolovoza",
      "rujna",
      "listopada",
      "studenoga",
      "prosinca"
    ],
    "SHORTDAY": [
      "ned",
      "pon",
      "uto",
      "sri",
      "\u010det",
      "pet",
      "sub"
    ],
    "SHORTMONTH": [
      "sij",
      "velj",
      "o\u017eu",
      "tra",
      "svi",
      "lip",
      "srp",
      "kol",
      "ruj",
      "lis",
      "stu",
      "pro"
    ],
    "STANDALONEMONTH": [
      "sije\u010danj",
      "velja\u010da",
      "o\u017eujak",
      "travanj",
      "svibanj",
      "lipanj",
      "srpanj",
      "kolovoz",
      "rujan",
      "listopad",
      "studeni",
      "prosinac"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, d. MMMM y.",
    "longDate": "d. MMMM y.",
//    "medium": "d. MMM y. HH:mm:ss",
    "medium": "dd.MM.yyyy HH:mm:ss",
    "mediumDate": "d. MMM y.",
    "mediumTime": "HH:mm:ss",
    "short": "dd.MM",
    "shortDate": "dd.MM.y",
    "shortTime": "HH:mm",
    "shortDate2": "dd.MM.y"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "kn",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "hr",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11 || vf.f % 10 == 1 && vf.f % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14) || vf.f % 10 >= 2 && vf.f % 10 <= 4 && (vf.f % 100 < 12 || vf.f % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
//    "medium": "MMM d, y h:mm:ss a",
    "medium": "dd.MM.yyyy h:mm:ss",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "MMM, dd",
//    "shortDate": "M/d/yy",  // Override with local date!
    "shortDate": "dd.MM.yyyy",
    "shortTime": "h:mm a",
	"shortDate2": "M/d/yy"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  function getDecimals(n) {
    n = n + '';
    var i = n.indexOf('.');
    return (i == -1) ? 0 : n.length - i - 1;
  }

  function getVF(n, opt_precision) {
    var v = opt_precision;

    if (undefined === v) {
      v = Math.min(getDecimals(n), 3);
    }

    var base = Math.pow(10, v);
    var f = ((n * base) | 0) % base;
    return {v: v, f: f};
  }

  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "prije podne",
        "popodne"
      ],
      "DAY": [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010detvrtak",
        "petak",
        "subota"
      ],
      "ERANAMES": [
        "Prije nove ere",
        "Nove ere"
      ],
      "ERAS": [
        "p. n. e.",
        "n. e."
      ],
      "FIRSTDAYOFWEEK": 0,
      "MONTH": [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
      ],
      "SHORTDAY": [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010det",
        "pet",
        "sub"
      ],
      "SHORTMONTH": [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "STANDALONEMONTH": [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, dd. MMMM y.",
      "longDate": "dd. MMMM y.",
      "medium": "dd.MM.yyyy HH.mm.ss",
      "mediumDate": "dd.MM.y.",
      "mediumTime": "HH:mm:ss",
      "short": "dd.MM.yy. HH:mm",
      "shortDate": "dd.MM.yyyy",
      "shortTime": "HH:mm",
      "shortDate2": "dd.MM.yyyy"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "KM",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "\u00a0\u00a4",
          "posPre": "",
          "posSuf": "\u00a0\u00a4"
        }
      ]
    },
    "id": "bs",
    "localeID": "bs",
    "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11 || vf.f % 10 == 1 && vf.f % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14) || vf.f % 10 >= 2 && vf.f % 10 <= 4 && (vf.f % 100 < 12 || vf.f % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

(function () {
  'use strict';

  /* @ngdoc object
   * @name home
   * @description
   *
   */
  angular
    .module('home', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('home')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'home/home.tpl.html',
        controller: 'HomeCtrl',
        controllerAs: 'home'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.controller:HomeCtrl
   *
   * @description
   *
   */
  HomeCtrl.$inject = ["$scope", "$http", "$resource", "EndpointsService"];
  angular
    .module('home')
    .controller('HomeCtrl', HomeCtrl);

  function HomeCtrl($scope, $http,$resource, EndpointsService) {
    var vm = this;
    vm.ctrlName = EndpointsService.url;
  }
}());

/* jquery.sparkline 2.1.2 - http://omnipotent.net/jquery.sparkline/ 
** Licensed under the New BSD License - see above site for details */

(function(a,b,c){(function(a){typeof define=="function"&&define.amd?define(["jquery"],a):jQuery&&!jQuery.fn.sparkline&&a(jQuery)})(function(d){"use strict";var e={},f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L=0;f=function(){return{common:{type:"line",lineColor:"#00f",fillColor:"#cdf",defaultPixelsPerValue:3,width:"auto",height:"auto",composite:!1,tagValuesAttribute:"values",tagOptionsPrefix:"spark",enableTagOptions:!1,enableHighlight:!0,highlightLighten:1.4,tooltipSkipNull:!0,tooltipPrefix:"",tooltipSuffix:"",disableHiddenCheck:!1,numberFormatter:!1,numberDigitGroupCount:3,numberDigitGroupSep:",",numberDecimalMark:".",disableTooltips:!1,disableInteraction:!1},line:{spotColor:"#f80",highlightSpotColor:"#5f5",highlightLineColor:"#f22",spotRadius:1.5,minSpotColor:"#f80",maxSpotColor:"#f80",lineWidth:1,normalRangeMin:c,normalRangeMax:c,normalRangeColor:"#ccc",drawNormalOnTop:!1,chartRangeMin:c,chartRangeMax:c,chartRangeMinX:c,chartRangeMaxX:c,tooltipFormat:new h('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{y}}{{suffix}}')},bar:{barColor:"#3366cc",negBarColor:"#f44",stackedBarColor:["#3366cc","#dc3912","#ff9900","#109618","#66aa00","#dd4477","#0099c6","#990099"],zeroColor:c,nullColor:c,zeroAxis:!0,barWidth:4,barSpacing:1,chartRangeMax:c,chartRangeMin:c,chartRangeClip:!1,colorMap:c,tooltipFormat:new h('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{value}}{{suffix}}')},tristate:{barWidth:4,barSpacing:1,posBarColor:"#6f6",negBarColor:"#f44",zeroBarColor:"#999",colorMap:{},tooltipFormat:new h('<span style="color: {{color}}">&#9679;</span> {{value:map}}'),tooltipValueLookups:{map:{"-1":"Loss",0:"Draw",1:"Win"}}},discrete:{lineHeight:"auto",thresholdColor:c,thresholdValue:0,chartRangeMax:c,chartRangeMin:c,chartRangeClip:!1,tooltipFormat:new h("{{prefix}}{{value}}{{suffix}}")},bullet:{targetColor:"#f33",targetWidth:3,performanceColor:"#33f",rangeColors:["#d3dafe","#a8b6ff","#7f94ff"],base:c,tooltipFormat:new h("{{fieldkey:fields}} - {{value}}"),tooltipValueLookups:{fields:{r:"Range",p:"Performance",t:"Target"}}},pie:{offset:0,sliceColors:["#3366cc","#dc3912","#ff9900","#109618","#66aa00","#dd4477","#0099c6","#990099"],borderWidth:0,borderColor:"#000",tooltipFormat:new h('<span style="color: {{color}}">&#9679;</span> {{value}} ({{percent.1}}%)')},box:{raw:!1,boxLineColor:"#000",boxFillColor:"#cdf",whiskerColor:"#000",outlierLineColor:"#333",outlierFillColor:"#fff",medianColor:"#f00",showOutliers:!0,outlierIQR:1.5,spotRadius:1.5,target:c,targetColor:"#4a2",chartRangeMax:c,chartRangeMin:c,tooltipFormat:new h("{{field:fields}}: {{value}}"),tooltipFormatFieldlistKey:"field",tooltipValueLookups:{fields:{lq:"Lower Quartile",med:"Median",uq:"Upper Quartile",lo:"Left Outlier",ro:"Right Outlier",lw:"Left Whisker",rw:"Right Whisker"}}}}},E='.jqstooltip { position: absolute;left: 0px;top: 0px;visibility: hidden;background: rgb(0, 0, 0) transparent;background-color: rgba(0,0,0,0.6);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);-ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000)";color: white;font: 10px arial, san serif;text-align: left;white-space: nowrap;padding: 5px;border: 1px solid white;z-index: 10000;}.jqsfield { color: white;font: 10px arial, san serif;text-align: left;}',g=function(){var a,b;return a=function(){this.init.apply(this,arguments)},arguments.length>1?(arguments[0]?(a.prototype=d.extend(new arguments[0],arguments[arguments.length-1]),a._super=arguments[0].prototype):a.prototype=arguments[arguments.length-1],arguments.length>2&&(b=Array.prototype.slice.call(arguments,1,-1),b.unshift(a.prototype),d.extend.apply(d,b))):a.prototype=arguments[0],a.prototype.cls=a,a},d.SPFormatClass=h=g({fre:/\{\{([\w.]+?)(:(.+?))?\}\}/g,precre:/(\w+)\.(\d+)/,init:function(a,b){this.format=a,this.fclass=b},render:function(a,b,d){var e=this,f=a,g,h,i,j,k;return this.format.replace(this.fre,function(){var a;return h=arguments[1],i=arguments[3],g=e.precre.exec(h),g?(k=g[2],h=g[1]):k=!1,j=f[h],j===c?"":i&&b&&b[i]?(a=b[i],a.get?b[i].get(j)||j:b[i][j]||j):(n(j)&&(d.get("numberFormatter")?j=d.get("numberFormatter")(j):j=s(j,k,d.get("numberDigitGroupCount"),d.get("numberDigitGroupSep"),d.get("numberDecimalMark"))),j)})}}),d.spformat=function(a,b){return new h(a,b)},i=function(a,b,c){return a<b?b:a>c?c:a},j=function(a,c){var d;return c===2?(d=b.floor(a.length/2),a.length%2?a[d]:(a[d-1]+a[d])/2):a.length%2?(d=(a.length*c+c)/4,d%1?(a[b.floor(d)]+a[b.floor(d)-1])/2:a[d-1]):(d=(a.length*c+2)/4,d%1?(a[b.floor(d)]+a[b.floor(d)-1])/2:a[d-1])},k=function(a){var b;switch(a){case"undefined":a=c;break;case"null":a=null;break;case"true":a=!0;break;case"false":a=!1;break;default:b=parseFloat(a),a==b&&(a=b)}return a},l=function(a){var b,c=[];for(b=a.length;b--;)c[b]=k(a[b]);return c},m=function(a,b){var c,d,e=[];for(c=0,d=a.length;c<d;c++)a[c]!==b&&e.push(a[c]);return e},n=function(a){return!isNaN(parseFloat(a))&&isFinite(a)},s=function(a,b,c,e,f){var g,h;a=(b===!1?parseFloat(a).toString():a.toFixed(b)).split(""),g=(g=d.inArray(".",a))<0?a.length:g,g<a.length&&(a[g]=f);for(h=g-c;h>0;h-=c)a.splice(h,0,e);return a.join("")},o=function(a,b,c){var d;for(d=b.length;d--;){if(c&&b[d]===null)continue;if(b[d]!==a)return!1}return!0},p=function(a){var b=0,c;for(c=a.length;c--;)b+=typeof a[c]=="number"?a[c]:0;return b},r=function(a){return d.isArray(a)?a:[a]},q=function(b){var c;a.createStyleSheet?a.createStyleSheet().cssText=b:(c=a.createElement("style"),c.type="text/css",a.getElementsByTagName("head")[0].appendChild(c),c[typeof a.body.style.WebkitAppearance=="string"?"innerText":"innerHTML"]=b)},d.fn.simpledraw=function(b,e,f,g){var h,i;if(f&&(h=this.data("_jqs_vcanvas")))return h;if(d.fn.sparkline.canvas===!1)return!1;if(d.fn.sparkline.canvas===c){var j=a.createElement("canvas");if(!j.getContext||!j.getContext("2d")){if(!a.namespaces||!!a.namespaces.v)return d.fn.sparkline.canvas=!1,!1;a.namespaces.add("v","urn:schemas-microsoft-com:vml","#default#VML"),d.fn.sparkline.canvas=function(a,b,c,d){return new J(a,b,c)}}else d.fn.sparkline.canvas=function(a,b,c,d){return new I(a,b,c,d)}}return b===c&&(b=d(this).innerWidth()),e===c&&(e=d(this).innerHeight()),h=d.fn.sparkline.canvas(b,e,this,g),i=d(this).data("_jqs_mhandler"),i&&i.registerCanvas(h),h},d.fn.cleardraw=function(){var a=this.data("_jqs_vcanvas");a&&a.reset()},d.RangeMapClass=t=g({init:function(a){var b,c,d=[];for(b in a)a.hasOwnProperty(b)&&typeof b=="string"&&b.indexOf(":")>-1&&(c=b.split(":"),c[0]=c[0].length===0?-Infinity:parseFloat(c[0]),c[1]=c[1].length===0?Infinity:parseFloat(c[1]),c[2]=a[b],d.push(c));this.map=a,this.rangelist=d||!1},get:function(a){var b=this.rangelist,d,e,f;if((f=this.map[a])!==c)return f;if(b)for(d=b.length;d--;){e=b[d];if(e[0]<=a&&e[1]>=a)return e[2]}return c}}),d.range_map=function(a){return new t(a)},u=g({init:function(a,b){var c=d(a);this.$el=c,this.options=b,this.currentPageX=0,this.currentPageY=0,this.el=a,this.splist=[],this.tooltip=null,this.over=!1,this.displayTooltips=!b.get("disableTooltips"),this.highlightEnabled=!b.get("disableHighlight")},registerSparkline:function(a){this.splist.push(a),this.over&&this.updateDisplay()},registerCanvas:function(a){var b=d(a.canvas);this.canvas=a,this.$canvas=b,b.mouseenter(d.proxy(this.mouseenter,this)),b.mouseleave(d.proxy(this.mouseleave,this)),b.click(d.proxy(this.mouseclick,this))},reset:function(a){this.splist=[],this.tooltip&&a&&(this.tooltip.remove(),this.tooltip=c)},mouseclick:function(a){var b=d.Event("sparklineClick");b.originalEvent=a,b.sparklines=this.splist,this.$el.trigger(b)},mouseenter:function(b){d(a.body).unbind("mousemove.jqs"),d(a.body).bind("mousemove.jqs",d.proxy(this.mousemove,this)),this.over=!0,this.currentPageX=b.pageX,this.currentPageY=b.pageY,this.currentEl=b.target,!this.tooltip&&this.displayTooltips&&(this.tooltip=new v(this.options),this.tooltip.updatePosition(b.pageX,b.pageY)),this.updateDisplay()},mouseleave:function(){d(a.body).unbind("mousemove.jqs");var b=this.splist,c=b.length,e=!1,f,g;this.over=!1,this.currentEl=null,this.tooltip&&(this.tooltip.remove(),this.tooltip=null);for(g=0;g<c;g++)f=b[g],f.clearRegionHighlight()&&(e=!0);e&&this.canvas.render()},mousemove:function(a){this.currentPageX=a.pageX,this.currentPageY=a.pageY,this.currentEl=a.target,this.tooltip&&this.tooltip.updatePosition(a.pageX,a.pageY),this.updateDisplay()},updateDisplay:function(){var a=this.splist,b=a.length,c=!1,e=this.$canvas.offset(),f=this.currentPageX-e.left,g=this.currentPageY-e.top,h,i,j,k,l;if(!this.over)return;for(j=0;j<b;j++)i=a[j],k=i.setRegionHighlight(this.currentEl,f,g),k&&(c=!0);if(c){l=d.Event("sparklineRegionChange"),l.sparklines=this.splist,this.$el.trigger(l);if(this.tooltip){h="";for(j=0;j<b;j++)i=a[j],h+=i.getCurrentRegionTooltip();this.tooltip.setContent(h)}this.disableHighlight||this.canvas.render()}k===null&&this.mouseleave()}}),v=g({sizeStyle:"position: static !important;display: block !important;visibility: hidden !important;float: left !important;",init:function(b){var c=b.get("tooltipClassname","jqstooltip"),e=this.sizeStyle,f;this.container=b.get("tooltipContainer")||a.body,this.tooltipOffsetX=b.get("tooltipOffsetX",10),this.tooltipOffsetY=b.get("tooltipOffsetY",12),d("#jqssizetip").remove(),d("#jqstooltip").remove(),this.sizetip=d("<div/>",{id:"jqssizetip",style:e,"class":c}),this.tooltip=d("<div/>",{id:"jqstooltip","class":c}).appendTo(this.container),f=this.tooltip.offset(),this.offsetLeft=f.left,this.offsetTop=f.top,this.hidden=!0,d(window).unbind("resize.jqs scroll.jqs"),d(window).bind("resize.jqs scroll.jqs",d.proxy(this.updateWindowDims,this)),this.updateWindowDims()},updateWindowDims:function(){this.scrollTop=d(window).scrollTop(),this.scrollLeft=d(window).scrollLeft(),this.scrollRight=this.scrollLeft+d(window).width(),this.updatePosition()},getSize:function(a){this.sizetip.html(a).appendTo(this.container),this.width=this.sizetip.width()+1,this.height=this.sizetip.height(),this.sizetip.remove()},setContent:function(a){if(!a){this.tooltip.css("visibility","hidden"),this.hidden=!0;return}this.getSize(a),this.tooltip.html(a).css({width:this.width,height:this.height,visibility:"visible"}),this.hidden&&(this.hidden=!1,this.updatePosition())},updatePosition:function(a,b){if(a===c){if(this.mousex===c)return;a=this.mousex-this.offsetLeft,b=this.mousey-this.offsetTop}else this.mousex=a-=this.offsetLeft,this.mousey=b-=this.offsetTop;if(!this.height||!this.width||this.hidden)return;b-=this.height+this.tooltipOffsetY,a+=this.tooltipOffsetX,b<this.scrollTop&&(b=this.scrollTop),a<this.scrollLeft?a=this.scrollLeft:a+this.width>this.scrollRight&&(a=this.scrollRight-this.width),this.tooltip.css({left:a,top:b})},remove:function(){this.tooltip.remove(),this.sizetip.remove(),this.sizetip=this.tooltip=c,d(window).unbind("resize.jqs scroll.jqs")}}),F=function(){q(E)},d(F),K=[],d.fn.sparkline=function(b,e){return this.each(function(){var f=new d.fn.sparkline.options(this,e),g=d(this),h,i;h=function(){var e,h,i,j,k,l,m;if(b==="html"||b===c){m=this.getAttribute(f.get("tagValuesAttribute"));if(m===c||m===null)m=g.html();e=m.replace(/(^\s*<!--)|(-->\s*$)|\s+/g,"").split(",")}else e=b;h=f.get("width")==="auto"?e.length*f.get("defaultPixelsPerValue"):f.get("width");if(f.get("height")==="auto"){if(!f.get("composite")||!d.data(this,"_jqs_vcanvas"))j=a.createElement("span"),j.innerHTML="a",g.html(j),i=d(j).innerHeight()||d(j).height(),d(j).remove(),j=null}else i=f.get("height");f.get("disableInteraction")?k=!1:(k=d.data(this,"_jqs_mhandler"),k?f.get("composite")||k.reset():(k=new u(this,f),d.data(this,"_jqs_mhandler",k)));if(f.get("composite")&&!d.data(this,"_jqs_vcanvas")){d.data(this,"_jqs_errnotify")||(alert("Attempted to attach a composite sparkline to an element with no existing sparkline"),d.data(this,"_jqs_errnotify",!0));return}l=new(d.fn.sparkline[f.get("type")])(this,e,f,h,i),l.render(),k&&k.registerSparkline(l)};if(d(this).html()&&!f.get("disableHiddenCheck")&&d(this).is(":hidden")||!d(this).parents("body").length){if(!f.get("composite")&&d.data(this,"_jqs_pending"))for(i=K.length;i;i--)K[i-1][0]==this&&K.splice(i-1,1);K.push([this,h]),d.data(this,"_jqs_pending",!0)}else h.call(this)})},d.fn.sparkline.defaults=f(),d.sparkline_display_visible=function(){var a,b,c,e=[];for(b=0,c=K.length;b<c;b++)a=K[b][0],d(a).is(":visible")&&!d(a).parents().is(":hidden")?(K[b][1].call(a),d.data(K[b][0],"_jqs_pending",!1),e.push(b)):!d(a).closest("html").length&&!d.data(a,"_jqs_pending")&&(d.data(K[b][0],"_jqs_pending",!1),e.push(b));for(b=e.length;b;b--)K.splice(e[b-1],1)},d.fn.sparkline.options=g({init:function(a,b){var c,f,g,h;this.userOptions=b=b||{},this.tag=a,this.tagValCache={},f=d.fn.sparkline.defaults,g=f.common,this.tagOptionsPrefix=b.enableTagOptions&&(b.tagOptionsPrefix||g.tagOptionsPrefix),h=this.getTagSetting("type"),h===e?c=f[b.type||g.type]:c=f[h],this.mergedOptions=d.extend({},g,c,b)},getTagSetting:function(a){var b=this.tagOptionsPrefix,d,f,g,h;if(b===!1||b===c)return e;if(this.tagValCache.hasOwnProperty(a))d=this.tagValCache.key;else{d=this.tag.getAttribute(b+a);if(d===c||d===null)d=e;else if(d.substr(0,1)==="["){d=d.substr(1,d.length-2).split(",");for(f=d.length;f--;)d[f]=k(d[f].replace(/(^\s*)|(\s*$)/g,""))}else if(d.substr(0,1)==="{"){g=d.substr(1,d.length-2).split(","),d={};for(f=g.length;f--;)h=g[f].split(":",2),d[h[0].replace(/(^\s*)|(\s*$)/g,"")]=k(h[1].replace(/(^\s*)|(\s*$)/g,""))}else d=k(d);this.tagValCache.key=d}return d},get:function(a,b){var d=this.getTagSetting(a),f;return d!==e?d:(f=this.mergedOptions[a])===c?b:f}}),d.fn.sparkline._base=g({disabled:!1,init:function(a,b,e,f,g){this.el=a,this.$el=d(a),this.values=b,this.options=e,this.width=f,this.height=g,this.currentRegion=c},initTarget:function(){var a=!this.options.get("disableInteraction");(this.target=this.$el.simpledraw(this.width,this.height,this.options.get("composite"),a))?(this.canvasWidth=this.target.pixelWidth,this.canvasHeight=this.target.pixelHeight):this.disabled=!0},render:function(){return this.disabled?(this.el.innerHTML="",!1):!0},getRegion:function(a,b){},setRegionHighlight:function(a,b,d){var e=this.currentRegion,f=!this.options.get("disableHighlight"),g;return b>this.canvasWidth||d>this.canvasHeight||b<0||d<0?null:(g=this.getRegion(a,b,d),e!==g?(e!==c&&f&&this.removeHighlight(),this.currentRegion=g,g!==c&&f&&this.renderHighlight(),!0):!1)},clearRegionHighlight:function(){return this.currentRegion!==c?(this.removeHighlight(),this.currentRegion=c,!0):!1},renderHighlight:function(){this.changeHighlight(!0)},removeHighlight:function(){this.changeHighlight(!1)},changeHighlight:function(a){},getCurrentRegionTooltip:function(){var a=this.options,b="",e=[],f,g,i,j,k,l,m,n,o,p,q,r,s,t;if(this.currentRegion===c)return"";f=this.getCurrentRegionFields(),q=a.get("tooltipFormatter");if(q)return q(this,a,f);a.get("tooltipChartTitle")&&(b+='<div class="jqs jqstitle">'+a.get("tooltipChartTitle")+"</div>\n"),g=this.options.get("tooltipFormat");if(!g)return"";d.isArray(g)||(g=[g]),d.isArray(f)||(f=[f]),m=this.options.get("tooltipFormatFieldlist"),n=this.options.get("tooltipFormatFieldlistKey");if(m&&n){o=[];for(l=f.length;l--;)p=f[l][n],(t=d.inArray(p,m))!=-1&&(o[t]=f[l]);f=o}i=g.length,s=f.length;for(l=0;l<i;l++){r=g[l],typeof r=="string"&&(r=new h(r)),j=r.fclass||"jqsfield";for(t=0;t<s;t++)if(!f[t].isNull||!a.get("tooltipSkipNull"))d.extend(f[t],{prefix:a.get("tooltipPrefix"),suffix:a.get("tooltipSuffix")}),k=r.render(f[t],a.get("tooltipValueLookups"),a),e.push('<div class="'+j+'">'+k+"</div>")}return e.length?b+e.join("\n"):""},getCurrentRegionFields:function(){},calcHighlightColor:function(a,c){var d=c.get("highlightColor"),e=c.get("highlightLighten"),f,g,h,j;if(d)return d;if(e){f=/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(a)||/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(a);if(f){h=[],g=a.length===4?16:1;for(j=0;j<3;j++)h[j]=i(b.round(parseInt(f[j+1],16)*g*e),0,255);return"rgb("+h.join(",")+")"}}return a}}),w={changeHighlight:function(a){var b=this.currentRegion,c=this.target,e=this.regionShapes[b],f;e&&(f=this.renderRegion(b,a),d.isArray(f)||d.isArray(e)?(c.replaceWithShapes(e,f),this.regionShapes[b]=d.map(f,function(a){return a.id})):(c.replaceWithShape(e,f),this.regionShapes[b]=f.id))},render:function(){var a=this.values,b=this.target,c=this.regionShapes,e,f,g,h;if(!this.cls._super.render.call(this))return;for(g=a.length;g--;){e=this.renderRegion(g);if(e)if(d.isArray(e)){f=[];for(h=e.length;h--;)e[h].append(),f.push(e[h].id);c[g]=f}else e.append(),c[g]=e.id;else c[g]=null}b.render()}},d.fn.sparkline.line=x=g(d.fn.sparkline._base,{type:"line",init:function(a,b,c,d,e){x._super.init.call(this,a,b,c,d,e),this.vertices=[],this.regionMap=[],this.xvalues=[],this.yvalues=[],this.yminmax=[],this.hightlightSpotId=null,this.lastShapeId=null,this.initTarget()},getRegion:function(a,b,d){var e,f=this.regionMap;for(e=f.length;e--;)if(f[e]!==null&&b>=f[e][0]&&b<=f[e][1])return f[e][2];return c},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:this.yvalues[a]===null,x:this.xvalues[a],y:this.yvalues[a],color:this.options.get("lineColor"),fillColor:this.options.get("fillColor"),offset:a}},renderHighlight:function(){var a=this.currentRegion,b=this.target,d=this.vertices[a],e=this.options,f=e.get("spotRadius"),g=e.get("highlightSpotColor"),h=e.get("highlightLineColor"),i,j;if(!d)return;f&&g&&(i=b.drawCircle(d[0],d[1],f,c,g),this.highlightSpotId=i.id,b.insertAfterShape(this.lastShapeId,i)),h&&(j=b.drawLine(d[0],this.canvasTop,d[0],this.canvasTop+this.canvasHeight,h),this.highlightLineId=j.id,b.insertAfterShape(this.lastShapeId,j))},removeHighlight:function(){var a=this.target;this.highlightSpotId&&(a.removeShapeId(this.highlightSpotId),this.highlightSpotId=null),this.highlightLineId&&(a.removeShapeId(this.highlightLineId),this.highlightLineId=null)},scanValues:function(){var a=this.values,c=a.length,d=this.xvalues,e=this.yvalues,f=this.yminmax,g,h,i,j,k;for(g=0;g<c;g++)h=a[g],i=typeof a[g]=="string",j=typeof a[g]=="object"&&a[g]instanceof Array,k=i&&a[g].split(":"),i&&k.length===2?(d.push(Number(k[0])),e.push(Number(k[1])),f.push(Number(k[1]))):j?(d.push(h[0]),e.push(h[1]),f.push(h[1])):(d.push(g),a[g]===null||a[g]==="null"?e.push(null):(e.push(Number(h)),f.push(Number(h))));this.options.get("xvalues")&&(d=this.options.get("xvalues")),this.maxy=this.maxyorg=b.max.apply(b,f),this.miny=this.minyorg=b.min.apply(b,f),this.maxx=b.max.apply(b,d),this.minx=b.min.apply(b,d),this.xvalues=d,this.yvalues=e,this.yminmax=f},processRangeOptions:function(){var a=this.options,b=a.get("normalRangeMin"),d=a.get("normalRangeMax");b!==c&&(b<this.miny&&(this.miny=b),d>this.maxy&&(this.maxy=d)),a.get("chartRangeMin")!==c&&(a.get("chartRangeClip")||a.get("chartRangeMin")<this.miny)&&(this.miny=a.get("chartRangeMin")),a.get("chartRangeMax")!==c&&(a.get("chartRangeClip")||a.get("chartRangeMax")>this.maxy)&&(this.maxy=a.get("chartRangeMax")),a.get("chartRangeMinX")!==c&&(a.get("chartRangeClipX")||a.get("chartRangeMinX")<this.minx)&&(this.minx=a.get("chartRangeMinX")),a.get("chartRangeMaxX")!==c&&(a.get("chartRangeClipX")||a.get("chartRangeMaxX")>this.maxx)&&(this.maxx=a.get("chartRangeMaxX"))},drawNormalRange:function(a,d,e,f,g){var h=this.options.get("normalRangeMin"),i=this.options.get("normalRangeMax"),j=d+b.round(e-e*((i-this.miny)/g)),k=b.round(e*(i-h)/g);this.target.drawRect(a,j,f,k,c,this.options.get("normalRangeColor")).append()},render:function(){var a=this.options,e=this.target,f=this.canvasWidth,g=this.canvasHeight,h=this.vertices,i=a.get("spotRadius"),j=this.regionMap,k,l,m,n,o,p,q,r,s,u,v,w,y,z,A,B,C,D,E,F,G,H,I,J,K;if(!x._super.render.call(this))return;this.scanValues(),this.processRangeOptions(),I=this.xvalues,J=this.yvalues;if(!this.yminmax.length||this.yvalues.length<2)return;n=o=0,k=this.maxx-this.minx===0?1:this.maxx-this.minx,l=this.maxy-this.miny===0?1:this.maxy-this.miny,m=this.yvalues.length-1,i&&(f<i*4||g<i*4)&&(i=0);if(i){G=a.get("highlightSpotColor")&&!a.get("disableInteraction");if(G||a.get("minSpotColor")||a.get("spotColor")&&J[m]===this.miny)g-=b.ceil(i);if(G||a.get("maxSpotColor")||a.get("spotColor")&&J[m]===this.maxy)g-=b.ceil(i),n+=b.ceil(i);if(G||(a.get("minSpotColor")||a.get("maxSpotColor"))&&(J[0]===this.miny||J[0]===this.maxy))o+=b.ceil(i),f-=b.ceil(i);if(G||a.get("spotColor")||a.get("minSpotColor")||a.get("maxSpotColor")&&(J[m]===this.miny||J[m]===this.maxy))f-=b.ceil(i)}g--,a.get("normalRangeMin")!==c&&!a.get("drawNormalOnTop")&&this.drawNormalRange(o,n,g,f,l),q=[],r=[q],z=A=null,B=J.length;for(K=0;K<B;K++)s=I[K],v=I[K+1],u=J[K],w=o+b.round((s-this.minx)*(f/k)),y=K<B-1?o+b.round((v-this.minx)*(f/k)):f,A=w+(y-w)/2,j[K]=[z||0,A,K],z=A,u===null?K&&(J[K-1]!==null&&(q=[],r.push(q)),h.push(null)):(u<this.miny&&(u=this.miny),u>this.maxy&&(u=this.maxy),q.length||q.push([w,n+g]),p=[w,n+b.round(g-g*((u-this.miny)/l))],q.push(p),h.push(p));C=[],D=[],E=r.length;for(K=0;K<E;K++)q=r[K],q.length&&(a.get("fillColor")&&(q.push([q[q.length-1][0],n+g]),D.push(q.slice(0)),q.pop()),q.length>2&&(q[0]=[q[0][0],q[1][1]]),C.push(q));E=D.length;for(K=0;K<E;K++)e.drawShape(D[K],a.get("fillColor"),a.get("fillColor")).append();a.get("normalRangeMin")!==c&&a.get("drawNormalOnTop")&&this.drawNormalRange(o,n,g,f,l),E=C.length;for(K=0;K<E;K++)e.drawShape(C[K],a.get("lineColor"),c,a.get("lineWidth")).append();if(i&&a.get("valueSpots")){F=a.get("valueSpots"),F.get===c&&(F=new t(F));for(K=0;K<B;K++)H=F.get(J[K]),H&&e.drawCircle(o+b.round((I[K]-this.minx)*(f/k)),n+b.round(g-g*((J[K]-this.miny)/l)),i,c,H).append()}i&&a.get("spotColor")&&J[m]!==null&&e.drawCircle(o+b.round((I[I.length-1]-this.minx)*(f/k)),n+b.round(g-g*((J[m]-this.miny)/l)),i,c,a.get("spotColor")).append(),this.maxy!==this.minyorg&&(i&&a.get("minSpotColor")&&(s=I[d.inArray(this.minyorg,J)],e.drawCircle(o+b.round((s-this.minx)*(f/k)),n+b.round(g-g*((this.minyorg-this.miny)/l)),i,c,a.get("minSpotColor")).append()),i&&a.get("maxSpotColor")&&(s=I[d.inArray(this.maxyorg,J)],e.drawCircle(o+b.round((s-this.minx)*(f/k)),n+b.round(g-g*((this.maxyorg-this.miny)/l)),i,c,a.get("maxSpotColor")).append())),this.lastShapeId=e.getLastShapeId(),this.canvasTop=n,e.render()}}),d.fn.sparkline.bar=y=g(d.fn.sparkline._base,w,{type:"bar",init:function(a,e,f,g,h){var j=parseInt(f.get("barWidth"),10),n=parseInt(f.get("barSpacing"),10),o=f.get("chartRangeMin"),p=f.get("chartRangeMax"),q=f.get("chartRangeClip"),r=Infinity,s=-Infinity,u,v,w,x,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R;y._super.init.call(this,a,e,f,g,h);for(A=0,B=e.length;A<B;A++){O=e[A],u=typeof O=="string"&&O.indexOf(":")>-1;if(u||d.isArray(O))J=!0,u&&(O=e[A]=l(O.split(":"))),O=m(O,null),v=b.min.apply(b,O),w=b.max.apply(b,O),v<r&&(r=v),w>s&&(s=w)}this.stacked=J,this.regionShapes={},this.barWidth=j,this.barSpacing=n,this.totalBarWidth=j+n,this.width=g=e.length*j+(e.length-1)*n,this.initTarget(),q&&(H=o===c?-Infinity:o,I=p===c?Infinity:p),z=[],x=J?[]:z;var S=[],T=[];for(A=0,B=e.length;A<B;A++)if(J){K=e[A],e[A]=N=[],S[A]=0,x[A]=T[A]=0;for(L=0,M=K.length;L<M;L++)O=N[L]=q?i(K[L],H,I):K[L],O!==null&&(O>0&&(S[A]+=O),r<0&&s>0?O<0?T[A]+=b.abs(O):x[A]+=O:x[A]+=b.abs(O-(O<0?s:r)),z.push(O))}else O=q?i(e[A],H,I):e[A],O=e[A]=k(O),O!==null&&z.push(O);this.max=G=b.max.apply(b,z),this.min=F=b.min.apply(b,z),this.stackMax=s=J?b.max.apply(b,S):G,this.stackMin=r=J?b.min.apply(b,z):F,f.get("chartRangeMin")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMin")<F)&&(F=f.get("chartRangeMin")),f.get("chartRangeMax")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMax")>G)&&(G=f.get("chartRangeMax")),this.zeroAxis=D=f.get("zeroAxis",!0),F<=0&&G>=0&&D?E=0:D==0?E=F:F>0?E=F:E=G,this.xaxisOffset=E,C=J?b.max.apply(b,x)+b.max.apply(b,T):G-F,this.canvasHeightEf=D&&F<0?this.canvasHeight-2:this.canvasHeight-1,F<E?(Q=J&&G>=0?s:G,P=(Q-E)/C*this.canvasHeight,P!==b.ceil(P)&&(this.canvasHeightEf-=2,P=b.ceil(P))):P=this.canvasHeight,this.yoffset=P,d.isArray(f.get("colorMap"))?(this.colorMapByIndex=f.get("colorMap"),this.colorMapByValue=null):(this.colorMapByIndex=null,this.colorMapByValue=f.get("colorMap"),this.colorMapByValue&&this.colorMapByValue.get===c&&(this.colorMapByValue=new t(this.colorMapByValue))),this.range=C},getRegion:function(a,d,e){var f=b.floor(d/this.totalBarWidth);return f<0||f>=this.values.length?c:f},getCurrentRegionFields:function(){var a=this.currentRegion,b=r(this.values[a]),c=[],d,e;for(e=b.length;e--;)d=b[e],c.push({isNull:d===null,value:d,color:this.calcColor(e,d,a),offset:a});return c},calcColor:function(a,b,e){var f=this.colorMapByIndex,g=this.colorMapByValue,h=this.options,i,j;return this.stacked?i=h.get("stackedBarColor"):i=b<0?h.get("negBarColor"):h.get("barColor"),b===0&&h.get("zeroColor")!==c&&(i=h.get("zeroColor")),g&&(j=g.get(b))?i=j:f&&f.length>e&&(i=f[e]),d.isArray(i)?i[a%i.length]:i},renderRegion:function(a,e){var f=this.values[a],g=this.options,h=this.xaxisOffset,i=[],j=this.range,k=this.stacked,l=this.target,m=a*this.totalBarWidth,n=this.canvasHeightEf,p=this.yoffset,q,r,s,t,u,v,w,x,y,z;f=d.isArray(f)?f:[f],w=f.length,x=f[0],t=o(null,f),z=o(h,f,!0);if(t)return g.get("nullColor")?(s=e?g.get("nullColor"):this.calcHighlightColor(g.get("nullColor"),g),q=p>0?p-1:p,l.drawRect(m,q,this.barWidth-1,0,s,s)):c;u=p;for(v=0;v<w;v++){x=f[v];if(k&&x===h){if(!z||y)continue;y=!0}j>0?r=b.floor(n*(b.abs(x-h)/j))+1:r=1,x<h||x===h&&p===0?(q=u,u+=r):(q=p-r,p-=r),s=this.calcColor(v,x,a),e&&(s=this.calcHighlightColor(s,g)),i.push(l.drawRect(m,q,this.barWidth-1,r-1,s,s))}return i.length===1?i[0]:i}}),d.fn.sparkline.tristate=z=g(d.fn.sparkline._base,w,{type:"tristate",init:function(a,b,e,f,g){var h=parseInt(e.get("barWidth"),10),i=parseInt(e.get("barSpacing"),10);z._super.init.call(this,a,b,e,f,g),this.regionShapes={},this.barWidth=h,this.barSpacing=i,this.totalBarWidth=h+i,this.values=d.map(b,Number),this.width=f=b.length*h+(b.length-1)*i,d.isArray(e.get("colorMap"))?(this.colorMapByIndex=e.get("colorMap"),this.colorMapByValue=null):(this.colorMapByIndex=null,this.colorMapByValue=e.get("colorMap"),this.colorMapByValue&&this.colorMapByValue.get===c&&(this.colorMapByValue=new t(this.colorMapByValue))),this.initTarget()},getRegion:function(a,c,d){return b.floor(c/this.totalBarWidth)},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:this.values[a]===c,value:this.values[a],color:this.calcColor(this.values[a],a),offset:a}},calcColor:function(a,b){var c=this.values,d=this.options,e=this.colorMapByIndex,f=this.colorMapByValue,g,h;return f&&(h=f.get(a))?g=h:e&&e.length>b?g=e[b]:c[b]<0?g=d.get("negBarColor"):c[b]>0?g=d.get("posBarColor"):g=d.get("zeroBarColor"),g},renderRegion:function(a,c){var d=this.values,e=this.options,f=this.target,g,h,i,j,k,l;g=f.pixelHeight,i=b.round(g/2),j=a*this.totalBarWidth,d[a]<0?(k=i,h=i-1):d[a]>0?(k=0,h=i-1):(k=i-1,h=2),l=this.calcColor(d[a],a);if(l===null)return;return c&&(l=this.calcHighlightColor(l,e)),f.drawRect(j,k,this.barWidth-1,h-1,l,l)}}),d.fn.sparkline.discrete=A=g(d.fn.sparkline._base,w,{type:"discrete",init:function(a,e,f,g,h){A._super.init.call(this,a,e,f,g,h),this.regionShapes={},this.values=e=d.map(e,Number),this.min=b.min.apply(b,e),this.max=b.max.apply(b,e),this.range=this.max-this.min,this.width=g=f.get("width")==="auto"?e.length*2:this.width,this.interval=b.floor(g/e.length),this.itemWidth=g/e.length,f.get("chartRangeMin")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMin")<this.min)&&(this.min=f.get("chartRangeMin")),f.get("chartRangeMax")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMax")>this.max)&&(this.max=f.get("chartRangeMax")),this.initTarget(),this.target&&(this.lineHeight=f.get("lineHeight")==="auto"?b.round(this.canvasHeight*.3):f.get("lineHeight"))},getRegion:function(a,c,d){return b.floor(c/this.itemWidth)},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:this.values[a]===c,value:this.values[a],offset:a}},renderRegion:function(a,c){var d=this.values,e=this.options,f=this.min,g=this.max,h=this.range,j=this.interval,k=this.target,l=this.canvasHeight,m=this.lineHeight,n=l-m,o,p,q,r;return p=i(d[a],f,g),r=a*j,o=b.round(n-n*((p-f)/h)),q=e.get("thresholdColor")&&p<e.get("thresholdValue")?e.get("thresholdColor"):e.get("lineColor"),c&&(q=this.calcHighlightColor(q,e)),k.drawLine(r,o,r,o+m,q)}}),d.fn.sparkline.bullet=B=g(d.fn.sparkline._base,{type:"bullet",init:function(a,d,e,f,g){var h,i,j;B._super.init.call(this,a,d,e,f,g),this.values=d=l(d),j=d.slice(),j[0]=j[0]===null?j[2]:j[0],j[1]=d[1]===null?j[2]:j[1],h=b.min.apply(b,d),i=b.max.apply(b,d),e.get("base")===c?h=h<0?h:0:h=e.get("base"),this.min=h,this.max=i,this.range=i-h,this.shapes={},this.valueShapes={},this.regiondata={},this.width=f=e.get("width")==="auto"?"4.0em":f,this.target=this.$el.simpledraw(f,g,e.get("composite")),d.length||(this.disabled=!0),this.initTarget()},getRegion:function(a,b,d){var e=this.target.getShapeAt(a,b,d);return e!==c&&this.shapes[e]!==c?this.shapes[e]:c},getCurrentRegionFields:function(){var a=this.currentRegion;return{fieldkey:a.substr(0,1),value:this.values[a.substr(1)],region:a}},changeHighlight:function(a){var b=this.currentRegion,c=this.valueShapes[b],d;delete this.shapes[c];switch(b.substr(0,1)){case"r":d=this.renderRange(b.substr(1),a);break;case"p":d=this.renderPerformance(a);break;case"t":d=this.renderTarget(a)}this.valueShapes[b]=d.id,this.shapes[d.id]=b,this.target.replaceWithShape(c,d)},renderRange:function(a,c){var d=this.values[a],e=b.round(this.canvasWidth*((d-this.min)/this.range)),f=this.options.get("rangeColors")[a-2];return c&&(f=this.calcHighlightColor(f,this.options)),this.target.drawRect(0,0,e-1,this.canvasHeight-1,f,f)},renderPerformance:function(a){var c=this.values[1],d=b.round(this.canvasWidth*((c-this.min)/this.range)),e=this.options.get("performanceColor");return a&&(e=this.calcHighlightColor(e,this.options)),this.target.drawRect(0,b.round(this.canvasHeight*.3),d-1,b.round(this.canvasHeight*.4)-1,e,e)},renderTarget:function(a){var c=this.values[0],d=b.round(this.canvasWidth*((c-this.min)/this.range)-this.options.get("targetWidth")/2),e=b.round(this.canvasHeight*.1),f=this.canvasHeight-e*2,g=this.options.get("targetColor");return a&&(g=this.calcHighlightColor(g,this.options)),this.target.drawRect(d,e,this.options.get("targetWidth")-1,f-1,g,g)},render:function(){var a=this.values.length,b=this.target,c,d;if(!B._super.render.call(this))return;for(c=2;c<a;c++)d=this.renderRange(c).append(),this.shapes[d.id]="r"+c,this.valueShapes["r"+c]=d.id;this.values[1]!==null&&(d=this.renderPerformance().append(),this.shapes[d.id]="p1",this.valueShapes.p1=d.id),this.values[0]!==null&&(d=this.renderTarget().append(),this.shapes[d.id]="t0",this.valueShapes.t0=d.id),b.render()}}),d.fn.sparkline.pie=C=g(d.fn.sparkline._base,{type:"pie",init:function(a,c,e,f,g){var h=0,i;C._super.init.call(this,a,c,e,f,g),this.shapes={},this.valueShapes={},this.values=c=d.map(c,Number),e.get("width")==="auto"&&(this.width=this.height);if(c.length>0)for(i=c.length;i--;)h+=c[i];this.total=h,this.initTarget(),this.radius=b.floor(b.min(this.canvasWidth,this.canvasHeight)/2)},getRegion:function(a,b,d){var e=this.target.getShapeAt(a,b,d);return e!==c&&this.shapes[e]!==c?this.shapes[e]:c},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:this.values[a]===c,value:this.values[a],percent:this.values[a]/this.total*100,color:this.options.get("sliceColors")[a%this.options.get("sliceColors").length],offset:a}},changeHighlight:function(a){var b=this.currentRegion,c=this.renderSlice(b,a),d=this.valueShapes[b];delete this.shapes[d],this.target.replaceWithShape(d,c),this.valueShapes[b]=c.id,this.shapes[c.id]=b},renderSlice:function(a,d){var e=this.target,f=this.options,g=this.radius,h=f.get("borderWidth"),i=f.get("offset"),j=2*b.PI,k=this.values,l=this.total,m=i?2*b.PI*(i/360):0,n,o,p,q,r;q=k.length;for(p=0;p<q;p++){n=m,o=m,l>0&&(o=m+j*(k[p]/l));if(a===p)return r=f.get("sliceColors")[p%f.get("sliceColors").length],d&&(r=this.calcHighlightColor(r,f)),e.drawPieSlice(g,g,g-h,n,o,c,r);m=o}},render:function(){var a=this.target,d=this.values,e=this.options,f=this.radius,g=e.get("borderWidth"),h,i;if(!C._super.render.call(this))return;g&&a.drawCircle(f,f,b.floor(f-g/2),e.get("borderColor"),c,g).append();for(i=d.length;i--;)d[i]&&(h=this.renderSlice(i).append(),this.valueShapes[i]=h.id,this.shapes[h.id]=i);a.render()}}),d.fn.sparkline.box=D=g(d.fn.sparkline._base,{type:"box",init:function(a,b,c,e,f){D._super.init.call(this,a,b,c,e,f),this.values=d.map(b,Number),this.width=c.get("width")==="auto"?"4.0em":e,this.initTarget(),this.values.length||(this.disabled=1)},getRegion:function(){return 1},getCurrentRegionFields:function(){var a=[{field:"lq",value:this.quartiles[0]},{field:"med",value:this.quartiles
[1]},{field:"uq",value:this.quartiles[2]}];return this.loutlier!==c&&a.push({field:"lo",value:this.loutlier}),this.routlier!==c&&a.push({field:"ro",value:this.routlier}),this.lwhisker!==c&&a.push({field:"lw",value:this.lwhisker}),this.rwhisker!==c&&a.push({field:"rw",value:this.rwhisker}),a},render:function(){var a=this.target,d=this.values,e=d.length,f=this.options,g=this.canvasWidth,h=this.canvasHeight,i=f.get("chartRangeMin")===c?b.min.apply(b,d):f.get("chartRangeMin"),k=f.get("chartRangeMax")===c?b.max.apply(b,d):f.get("chartRangeMax"),l=0,m,n,o,p,q,r,s,t,u,v,w;if(!D._super.render.call(this))return;if(f.get("raw"))f.get("showOutliers")&&d.length>5?(n=d[0],m=d[1],p=d[2],q=d[3],r=d[4],s=d[5],t=d[6]):(m=d[0],p=d[1],q=d[2],r=d[3],s=d[4]);else{d.sort(function(a,b){return a-b}),p=j(d,1),q=j(d,2),r=j(d,3),o=r-p;if(f.get("showOutliers")){m=s=c;for(u=0;u<e;u++)m===c&&d[u]>p-o*f.get("outlierIQR")&&(m=d[u]),d[u]<r+o*f.get("outlierIQR")&&(s=d[u]);n=d[0],t=d[e-1]}else m=d[0],s=d[e-1]}this.quartiles=[p,q,r],this.lwhisker=m,this.rwhisker=s,this.loutlier=n,this.routlier=t,w=g/(k-i+1),f.get("showOutliers")&&(l=b.ceil(f.get("spotRadius")),g-=2*b.ceil(f.get("spotRadius")),w=g/(k-i+1),n<m&&a.drawCircle((n-i)*w+l,h/2,f.get("spotRadius"),f.get("outlierLineColor"),f.get("outlierFillColor")).append(),t>s&&a.drawCircle((t-i)*w+l,h/2,f.get("spotRadius"),f.get("outlierLineColor"),f.get("outlierFillColor")).append()),a.drawRect(b.round((p-i)*w+l),b.round(h*.1),b.round((r-p)*w),b.round(h*.8),f.get("boxLineColor"),f.get("boxFillColor")).append(),a.drawLine(b.round((m-i)*w+l),b.round(h/2),b.round((p-i)*w+l),b.round(h/2),f.get("lineColor")).append(),a.drawLine(b.round((m-i)*w+l),b.round(h/4),b.round((m-i)*w+l),b.round(h-h/4),f.get("whiskerColor")).append(),a.drawLine(b.round((s-i)*w+l),b.round(h/2),b.round((r-i)*w+l),b.round(h/2),f.get("lineColor")).append(),a.drawLine(b.round((s-i)*w+l),b.round(h/4),b.round((s-i)*w+l),b.round(h-h/4),f.get("whiskerColor")).append(),a.drawLine(b.round((q-i)*w+l),b.round(h*.1),b.round((q-i)*w+l),b.round(h*.9),f.get("medianColor")).append(),f.get("target")&&(v=b.ceil(f.get("spotRadius")),a.drawLine(b.round((f.get("target")-i)*w+l),b.round(h/2-v),b.round((f.get("target")-i)*w+l),b.round(h/2+v),f.get("targetColor")).append(),a.drawLine(b.round((f.get("target")-i)*w+l-v),b.round(h/2),b.round((f.get("target")-i)*w+l+v),b.round(h/2),f.get("targetColor")).append()),a.render()}}),G=g({init:function(a,b,c,d){this.target=a,this.id=b,this.type=c,this.args=d},append:function(){return this.target.appendShape(this),this}}),H=g({_pxregex:/(\d+)(px)?\s*$/i,init:function(a,b,c){if(!a)return;this.width=a,this.height=b,this.target=c,this.lastShapeId=null,c[0]&&(c=c[0]),d.data(c,"_jqs_vcanvas",this)},drawLine:function(a,b,c,d,e,f){return this.drawShape([[a,b],[c,d]],e,f)},drawShape:function(a,b,c,d){return this._genShape("Shape",[a,b,c,d])},drawCircle:function(a,b,c,d,e,f){return this._genShape("Circle",[a,b,c,d,e,f])},drawPieSlice:function(a,b,c,d,e,f,g){return this._genShape("PieSlice",[a,b,c,d,e,f,g])},drawRect:function(a,b,c,d,e,f){return this._genShape("Rect",[a,b,c,d,e,f])},getElement:function(){return this.canvas},getLastShapeId:function(){return this.lastShapeId},reset:function(){alert("reset not implemented")},_insert:function(a,b){d(b).html(a)},_calculatePixelDims:function(a,b,c){var e;e=this._pxregex.exec(b),e?this.pixelHeight=e[1]:this.pixelHeight=d(c).height(),e=this._pxregex.exec(a),e?this.pixelWidth=e[1]:this.pixelWidth=d(c).width()},_genShape:function(a,b){var c=L++;return b.unshift(c),new G(this,c,a,b)},appendShape:function(a){alert("appendShape not implemented")},replaceWithShape:function(a,b){alert("replaceWithShape not implemented")},insertAfterShape:function(a,b){alert("insertAfterShape not implemented")},removeShapeId:function(a){alert("removeShapeId not implemented")},getShapeAt:function(a,b,c){alert("getShapeAt not implemented")},render:function(){alert("render not implemented")}}),I=g(H,{init:function(b,e,f,g){I._super.init.call(this,b,e,f),this.canvas=a.createElement("canvas"),f[0]&&(f=f[0]),d.data(f,"_jqs_vcanvas",this),d(this.canvas).css({display:"inline-block",width:b,height:e,verticalAlign:"top"}),this._insert(this.canvas,f),this._calculatePixelDims(b,e,this.canvas),this.canvas.width=this.pixelWidth,this.canvas.height=this.pixelHeight,this.interact=g,this.shapes={},this.shapeseq=[],this.currentTargetShapeId=c,d(this.canvas).css({width:this.pixelWidth,height:this.pixelHeight})},_getContext:function(a,b,d){var e=this.canvas.getContext("2d");return a!==c&&(e.strokeStyle=a),e.lineWidth=d===c?1:d,b!==c&&(e.fillStyle=b),e},reset:function(){var a=this._getContext();a.clearRect(0,0,this.pixelWidth,this.pixelHeight),this.shapes={},this.shapeseq=[],this.currentTargetShapeId=c},_drawShape:function(a,b,d,e,f){var g=this._getContext(d,e,f),h,i;g.beginPath(),g.moveTo(b[0][0]+.5,b[0][1]+.5);for(h=1,i=b.length;h<i;h++)g.lineTo(b[h][0]+.5,b[h][1]+.5);d!==c&&g.stroke(),e!==c&&g.fill(),this.targetX!==c&&this.targetY!==c&&g.isPointInPath(this.targetX,this.targetY)&&(this.currentTargetShapeId=a)},_drawCircle:function(a,d,e,f,g,h,i){var j=this._getContext(g,h,i);j.beginPath(),j.arc(d,e,f,0,2*b.PI,!1),this.targetX!==c&&this.targetY!==c&&j.isPointInPath(this.targetX,this.targetY)&&(this.currentTargetShapeId=a),g!==c&&j.stroke(),h!==c&&j.fill()},_drawPieSlice:function(a,b,d,e,f,g,h,i){var j=this._getContext(h,i);j.beginPath(),j.moveTo(b,d),j.arc(b,d,e,f,g,!1),j.lineTo(b,d),j.closePath(),h!==c&&j.stroke(),i&&j.fill(),this.targetX!==c&&this.targetY!==c&&j.isPointInPath(this.targetX,this.targetY)&&(this.currentTargetShapeId=a)},_drawRect:function(a,b,c,d,e,f,g){return this._drawShape(a,[[b,c],[b+d,c],[b+d,c+e],[b,c+e],[b,c]],f,g)},appendShape:function(a){return this.shapes[a.id]=a,this.shapeseq.push(a.id),this.lastShapeId=a.id,a.id},replaceWithShape:function(a,b){var c=this.shapeseq,d;this.shapes[b.id]=b;for(d=c.length;d--;)c[d]==a&&(c[d]=b.id);delete this.shapes[a]},replaceWithShapes:function(a,b){var c=this.shapeseq,d={},e,f,g;for(f=a.length;f--;)d[a[f]]=!0;for(f=c.length;f--;)e=c[f],d[e]&&(c.splice(f,1),delete this.shapes[e],g=f);for(f=b.length;f--;)c.splice(g,0,b[f].id),this.shapes[b[f].id]=b[f]},insertAfterShape:function(a,b){var c=this.shapeseq,d;for(d=c.length;d--;)if(c[d]===a){c.splice(d+1,0,b.id),this.shapes[b.id]=b;return}},removeShapeId:function(a){var b=this.shapeseq,c;for(c=b.length;c--;)if(b[c]===a){b.splice(c,1);break}delete this.shapes[a]},getShapeAt:function(a,b,c){return this.targetX=b,this.targetY=c,this.render(),this.currentTargetShapeId},render:function(){var a=this.shapeseq,b=this.shapes,c=a.length,d=this._getContext(),e,f,g;d.clearRect(0,0,this.pixelWidth,this.pixelHeight);for(g=0;g<c;g++)e=a[g],f=b[e],this["_draw"+f.type].apply(this,f.args);this.interact||(this.shapes={},this.shapeseq=[])}}),J=g(H,{init:function(b,c,e){var f;J._super.init.call(this,b,c,e),e[0]&&(e=e[0]),d.data(e,"_jqs_vcanvas",this),this.canvas=a.createElement("span"),d(this.canvas).css({display:"inline-block",position:"relative",overflow:"hidden",width:b,height:c,margin:"0px",padding:"0px",verticalAlign:"top"}),this._insert(this.canvas,e),this._calculatePixelDims(b,c,this.canvas),this.canvas.width=this.pixelWidth,this.canvas.height=this.pixelHeight,f='<v:group coordorigin="0 0" coordsize="'+this.pixelWidth+" "+this.pixelHeight+'"'+' style="position:absolute;top:0;left:0;width:'+this.pixelWidth+"px;height="+this.pixelHeight+'px;"></v:group>',this.canvas.insertAdjacentHTML("beforeEnd",f),this.group=d(this.canvas).children()[0],this.rendered=!1,this.prerender=""},_drawShape:function(a,b,d,e,f){var g=[],h,i,j,k,l,m,n;for(n=0,m=b.length;n<m;n++)g[n]=""+b[n][0]+","+b[n][1];return h=g.splice(0,1),f=f===c?1:f,i=d===c?' stroked="false" ':' strokeWeight="'+f+'px" strokeColor="'+d+'" ',j=e===c?' filled="false"':' fillColor="'+e+'" filled="true" ',k=g[0]===g[g.length-1]?"x ":"",l='<v:shape coordorigin="0 0" coordsize="'+this.pixelWidth+" "+this.pixelHeight+'" '+' id="jqsshape'+a+'" '+i+j+' style="position:absolute;left:0px;top:0px;height:'+this.pixelHeight+"px;width:"+this.pixelWidth+'px;padding:0px;margin:0px;" '+' path="m '+h+" l "+g.join(", ")+" "+k+'e">'+" </v:shape>",l},_drawCircle:function(a,b,d,e,f,g,h){var i,j,k;return b-=e,d-=e,i=f===c?' stroked="false" ':' strokeWeight="'+h+'px" strokeColor="'+f+'" ',j=g===c?' filled="false"':' fillColor="'+g+'" filled="true" ',k='<v:oval  id="jqsshape'+a+'" '+i+j+' style="position:absolute;top:'+d+"px; left:"+b+"px; width:"+e*2+"px; height:"+e*2+'px"></v:oval>',k},_drawPieSlice:function(a,d,e,f,g,h,i,j){var k,l,m,n,o,p,q,r;if(g===h)return"";h-g===2*b.PI&&(g=0,h=2*b.PI),l=d+b.round(b.cos(g)*f),m=e+b.round(b.sin(g)*f),n=d+b.round(b.cos(h)*f),o=e+b.round(b.sin(h)*f);if(l===n&&m===o){if(h-g<b.PI)return"";l=n=d+f,m=o=e}return l===n&&m===o&&h-g<b.PI?"":(k=[d-f,e-f,d+f,e+f,l,m,n,o],p=i===c?' stroked="false" ':' strokeWeight="1px" strokeColor="'+i+'" ',q=j===c?' filled="false"':' fillColor="'+j+'" filled="true" ',r='<v:shape coordorigin="0 0" coordsize="'+this.pixelWidth+" "+this.pixelHeight+'" '+' id="jqsshape'+a+'" '+p+q+' style="position:absolute;left:0px;top:0px;height:'+this.pixelHeight+"px;width:"+this.pixelWidth+'px;padding:0px;margin:0px;" '+' path="m '+d+","+e+" wa "+k.join(", ")+' x e">'+" </v:shape>",r)},_drawRect:function(a,b,c,d,e,f,g){return this._drawShape(a,[[b,c],[b,c+e],[b+d,c+e],[b+d,c],[b,c]],f,g)},reset:function(){this.group.innerHTML=""},appendShape:function(a){var b=this["_draw"+a.type].apply(this,a.args);return this.rendered?this.group.insertAdjacentHTML("beforeEnd",b):this.prerender+=b,this.lastShapeId=a.id,a.id},replaceWithShape:function(a,b){var c=d("#jqsshape"+a),e=this["_draw"+b.type].apply(this,b.args);c[0].outerHTML=e},replaceWithShapes:function(a,b){var c=d("#jqsshape"+a[0]),e="",f=b.length,g;for(g=0;g<f;g++)e+=this["_draw"+b[g].type].apply(this,b[g].args);c[0].outerHTML=e;for(g=1;g<a.length;g++)d("#jqsshape"+a[g]).remove()},insertAfterShape:function(a,b){var c=d("#jqsshape"+a),e=this["_draw"+b.type].apply(this,b.args);c[0].insertAdjacentHTML("afterEnd",e)},removeShapeId:function(a){var b=d("#jqsshape"+a);this.group.removeChild(b[0])},getShapeAt:function(a,b,c){var d=a.id.substr(8);return d},render:function(){this.rendered||(this.group.innerHTML=this.prerender,this.rendered=!0)}})})})(document,Math);
var bigInt=function(E){function k(a,b){if("undefined"===typeof a)return k[0];if("undefined"!==typeof b){var c;if(10===+b)c=l(a);else{c=b;var n=k[0],f=k[1],d=a.length;if(2<=c&&36>=c&&d<=ga/Math.log(c))c=new e(parseInt(a,c));else{c=l(c);var d=[],g,h="-"===a[0];for(g=h?1:0;g<a.length;g++){var q=a[g].toLowerCase(),u=q.charCodeAt(0);if(48<=u&&57>=u)d.push(l(q));else if(97<=u&&122>=u)d.push(l(q.charCodeAt(0)-87));else if("<"===q){q=g;do g++;while(">"!==a[g]);d.push(l(a.slice(q+1,g)))}else throw Error(q+
" is not a valid character");}d.reverse();for(g=0;g<d.length;g++)n=n.add(d[g].times(f)),f=f.times(c);c=h?n.negate():n}}return c}return l(a)}function d(a,b){this.value=a;this.sign=b;this.isSmall=!1}function e(a){this.value=a;this.sign=0>a;this.isSmall=!0}function w(a){return-9007199254740992<a&&9007199254740992>a}function z(a){return 1E7>a?[a]:1E14>a?[a%1E7,Math.floor(a/1E7)]:[a%1E7,Math.floor(a/1E7)%1E7,Math.floor(a/1E14)]}function y(a){D(a);var b=a.length;if(4>b&&0>A(a,P))switch(b){case 0:return 0;
case 1:return a[0];case 2:return a[0]+1E7*a[1];default:return a[0]+1E7*(a[1]+1E7*a[2])}return a}function D(a){for(var b=a.length;0===a[--b];);a.length=b+1}function K(a){for(var b=Array(a),c=-1;++c<a;)b[c]=0;return b}function B(a){return 0<a?Math.floor(a):Math.ceil(a)}function S(a,b){var c=a.length,d=b.length,f=Array(c),m=0,g,e;for(e=0;e<d;e++)g=a[e]+b[e]+m,m=1E7<=g?1:0,f[e]=g-1E7*m;for(;e<c;)g=a[e]+m,m=1E7===g?1:0,f[e++]=g-1E7*m;0<m&&f.push(m);return f}function F(a,b){return a.length>=b.length?S(a,
b):S(b,a)}function L(a,b){var c=a.length,d=Array(c),f,e;for(e=0;e<c;e++)f=a[e]-1E7+b,b=Math.floor(f/1E7),d[e]=f-1E7*b,b+=1;for(;0<b;)d[e++]=b%1E7,b=Math.floor(b/1E7);return d}function G(a,b){var c=a.length,d=b.length,f=Array(c),e=0,g,h;for(g=0;g<d;g++)h=a[g]-e-b[g],0>h?(h+=1E7,e=1):e=0,f[g]=h;for(g=d;g<c;g++){h=a[g]-e;if(0>h)h+=1E7;else{f[g++]=h;break}f[g]=h}for(;g<c;g++)f[g]=a[g];D(f);return f}function M(a,b,c){var n=a.length,f=Array(n);b=-b;var m,g;for(m=0;m<n;m++)g=a[m]+b,b=Math.floor(g/1E7),g%=
1E7,f[m]=0>g?g+1E7:g;f=y(f);return"number"===typeof f?(c&&(f=-f),new e(f)):new d(f,c)}function Q(a,b){var c=a.length,d=b.length,f=K(c+d),e,g,h,k;for(h=0;h<c;++h){k=a[h];for(var l=0;l<d;++l)e=b[l],e=k*e+f[h+l],g=Math.floor(e/1E7),f[h+l]=e-1E7*g,f[h+l+1]+=g}D(f);return f}function H(a,b){var c=a.length,d=Array(c),f=0,e,g;for(g=0;g<c;g++)e=a[g]*b+f,f=Math.floor(e/1E7),d[g]=e-1E7*f;for(;0<f;)d[g++]=f%1E7,f=Math.floor(f/1E7);return d}function T(a,b){for(var c=[];0<b--;)c.push(0);return c.concat(a)}function N(a,
b){var c=Math.max(a.length,b.length);if(30>=c)return Q(a,b);var c=Math.ceil(c/2),d=a.slice(c),f=a.slice(0,c),e=b.slice(c),g=b.slice(0,c),h=N(f,g),k=N(d,e),d=N(F(f,d),F(g,e)),c=F(F(h,T(G(G(d,h),k),c)),T(k,2*c));D(c);return c}function U(a,b,c){return 1E7>a?new d(H(b,a),c):new d(Q(b,z(a)),c)}function V(a){var b=a.length,c=K(b+b),d,f,e,g;for(e=0;e<b;e++){g=a[e];for(var h=0;h<b;h++)d=a[h],d=g*d+c[e+h],f=Math.floor(d/1E7),c[e+h]=d-1E7*f,c[e+h+1]+=f}D(c);return c}function W(a,b){var c=a.length,d=K(c),f,
e;e=0;for(--c;0<=c;--c)e=1E7*e+a[c],f=B(e/b),e-=f*b,d[c]=f|0;return[d,e|0]}function I(a,b){var c,n=l(b),f=a.value;c=n.value;if(0===c)throw Error("Cannot divide by zero");if(a.isSmall)return n.isSmall?[new e(B(f/c)),new e(f%c)]:[k[0],a];if(n.isSmall){if(1===c)return[a,k[0]];if(-1==c)return[a.negate(),k[0]];c=Math.abs(c);if(1E7>c)return c=W(f,c),f=y(c[0]),c=c[1],a.sign&&(c=-c),"number"===typeof f?(a.sign!==n.sign&&(f=-f),[new e(f),new e(c)]):[new d(f,a.sign!==n.sign),new e(c)];c=z(c)}var m=A(f,c);if(-1===
m)return[k[0],a];if(0===m)return[k[a.sign===n.sign?1:-1],k[0]];if(200>=f.length+c.length){var g=c,h=f.length;c=g.length;var m=K(g.length),q=g[c-1],u=Math.ceil(1E7/(2*q)),f=H(f,u),g=H(g,u),p,r,x,t,v,w;f.length<=h&&f.push(0);g.push(0);q=g[c-1];for(p=h-c;0<=p;p--){h=9999999;f[p+c]!==q&&(h=Math.floor((1E7*f[p+c]+f[p+c-1])/q));x=r=0;v=g.length;for(t=0;t<v;t++)r+=h*g[t],w=Math.floor(r/1E7),x+=f[p+t]-(r-1E7*w),r=w,0>x?(f[p+t]=x+1E7,x=-1):(f[p+t]=x,x=0);for(;0!==x;){--h;for(t=r=0;t<v;t++)r+=f[p+t]-1E7+g[t],
0>r?(f[p+t]=r+1E7,r=0):(f[p+t]=r,r=1);x+=r}m[p]=h}f=W(f,u)[0];c=[y(m),y(f)]}else{m=f.length;q=c.length;u=[];for(g=[];m;)if(g.unshift(f[--m]),0>A(g,c))u.push(0);else{h=g.length;p=1E7*g[h-1]+g[h-2];r=1E7*c[q-1]+c[q-2];h>q&&(p=1E7*(p+1));h=Math.ceil(p/r);do{p=H(c,h);if(0>=A(p,g))break;h--}while(h);u.push(h);g=G(g,p)}u.reverse();c=[y(u),y(g)]}f=c[0];n=a.sign!==n.sign;c=c[1];m=a.sign;"number"===typeof f?(n&&(f=-f),f=new e(f)):f=new d(f,n);"number"===typeof c?(m&&(c=-c),c=new e(c)):c=new d(c,m);return[f,
c]}function A(a,b){if(a.length!==b.length)return a.length>b.length?1:-1;for(var c=a.length-1;0<=c;c--)if(a[c]!==b[c])return a[c]>b[c]?1:-1;return 0}function X(a){a=a.abs();if(a.isUnit())return!1;if(a.equals(2)||a.equals(3)||a.equals(5))return!0;if(a.isEven()||a.isDivisibleBy(3)||a.isDivisibleBy(5))return!1;if(a.lesser(25))return!0}function Y(a){return("number"===typeof a||"string"===typeof a)&&1E7>=+Math.abs(a)||a instanceof d&&1>=a.value.length}function R(a,b,c){b=l(b);var d=a.isNegative(),e=b.isNegative(),
m=d?a.not():a,g=e?b.not():b;b=[];a=[];for(var h=!1,k=!1;!h||!k;)m.isZero()?(h=!0,b.push(d?1:0)):d?b.push(m.isEven()?1:0):b.push(m.isEven()?0:1),g.isZero()?(k=!0,a.push(e?1:0)):e?a.push(g.isEven()?1:0):a.push(g.isEven()?0:1),m=m.over(2),g=g.over(2);d=[];for(e=0;e<b.length;e++)d.push(c(b[e],a[e]));for(c=bigInt(d.pop()).negate().times(bigInt(2).pow(d.length));d.length;)c=c.add(bigInt(d.pop()).times(bigInt(2).pow(d.length)));return c}function O(a){a=a.value;a="number"===typeof a?a|1073741824:a[0]+1E7*
a[1]|1073758208;return a&-a}function Z(a,b){a=l(a);b=l(b);return a.greater(b)?a:b}function aa(a,b){a=l(a);b=l(b);return a.lesser(b)?a:b}function ba(a,b){a=l(a).abs();b=l(b).abs();if(a.equals(b))return a;if(a.isZero())return b;if(b.isZero())return a;for(var c=k[1],d;a.isEven()&&b.isEven();)d=Math.min(O(a),O(b)),a=a.divide(d),b=b.divide(d),c=c.multiply(d);for(;a.isEven();)a=a.divide(O(a));do{for(;b.isEven();)b=b.divide(O(b));a.greater(b)&&(d=b,b=a,a=d);b=b.subtract(a)}while(!b.isZero());return c.isUnit()?
a:a.multiply(c)}function ca(a){a=a.value;"number"===typeof a&&(a=[a]);return 1===a.length&&35>=a[0]?"0123456789abcdefghijklmnopqrstuvwxyz".charAt(a[0]):"<"+a+">"}function da(a,b){b=bigInt(b);if(b.isZero()){if(a.isZero())return"0";throw Error("Cannot convert nonzero numbers to base 0.");}if(b.equals(-1))return a.isZero()?"0":a.isNegative()?Array(1-a).join("10"):"1"+Array(+a).join("01");var c="";a.isNegative()&&b.isPositive()&&(c="-",a=a.abs());if(b.equals(1))return a.isZero()?"0":c+Array(+a+1).join(1);
for(var d=[],e=a,k;e.isNegative()||0<=e.compareAbs(b);)k=e.divmod(b),e=k.quotient,k=k.remainder,k.isNegative()&&(k=b.minus(k).abs(),e=e.next()),d.push(ca(k));d.push(ca(e));return c+d.reverse().join("")}function ea(a){if(w(+a)){var b=+a;if(b===B(b))return new e(b);throw"Invalid integer: "+a;}(b="-"===a[0])&&(a=a.slice(1));var c=a.split(/e/i);if(2<c.length)throw Error("Invalid integer: "+c.join("e"));if(2===c.length){a=c[1];"+"===a[0]&&(a=a.slice(1));a=+a;if(a!==B(a)||!w(a))throw Error("Invalid integer: "+
a+" is not a valid exponent.");var c=c[0],n=c.indexOf(".");0<=n&&(a-=c.length-n-1,c=c.slice(0,n)+c.slice(n+1));if(0>a)throw Error("Cannot include negative exponent part for integers");a=c+=Array(a+1).join("0")}if(!/^([0-9][0-9]*)$/.test(a))throw Error("Invalid integer: "+a);for(var c=[],n=a.length,f=n-7;0<n;)c.push(+a.slice(f,n)),f-=7,0>f&&(f=0),n-=7;D(c);return new d(c,b)}function l(a){if("number"===typeof a){if(w(a)){if(a!==B(a))throw Error(a+" is not an integer.");a=new e(a)}else a=ea(a.toString());
return a}return"string"===typeof a?ea(a):a}var P=z(9007199254740992),ga=Math.log(9007199254740992);d.prototype=Object.create(k.prototype);e.prototype=Object.create(k.prototype);d.prototype.add=function(a){a=l(a);if(this.sign!==a.sign)return this.subtract(a.negate());var b=this.value,c=a.value;return a.isSmall?new d(L(b,Math.abs(c)),this.sign):new d(F(b,c),this.sign)};d.prototype.plus=d.prototype.add;e.prototype.add=function(a){a=l(a);var b=this.value;if(0>b!==a.sign)return this.subtract(a.negate());
var c=a.value;if(a.isSmall){if(w(b+c))return new e(b+c);c=z(Math.abs(c))}return new d(L(c,Math.abs(b)),0>b)};e.prototype.plus=e.prototype.add;d.prototype.subtract=function(a){var b=l(a);if(this.sign!==b.sign)return this.add(b.negate());a=this.value;var c=b.value;if(b.isSmall)return M(a,Math.abs(c),this.sign);b=this.sign;0<=A(a,c)?a=G(a,c):(a=G(c,a),b=!b);a=y(a);"number"===typeof a?(b&&(a=-a),a=new e(a)):a=new d(a,b);return a};d.prototype.minus=d.prototype.subtract;e.prototype.subtract=function(a){a=
l(a);var b=this.value;if(0>b!==a.sign)return this.add(a.negate());var c=a.value;return a.isSmall?new e(b-c):M(c,Math.abs(b),0<=b)};e.prototype.minus=e.prototype.subtract;d.prototype.negate=function(){return new d(this.value,!this.sign)};e.prototype.negate=function(){var a=this.sign,b=new e(-this.value);b.sign=!a;return b};d.prototype.abs=function(){return new d(this.value,!1)};e.prototype.abs=function(){return new e(Math.abs(this.value))};d.prototype.multiply=function(a){var b=l(a);a=this.value;var c=
b.value,e=this.sign!==b.sign;if(b.isSmall){if(0===c)return k[0];if(1===c)return this;if(-1===c)return this.negate();c=Math.abs(c);if(1E7>c)return new d(H(a,c),e);c=z(c)}var b=a.length,f=c.length;return 0<-.012*b-.012*f+1.5E-5*b*f?new d(N(a,c),e):new d(Q(a,c),e)};d.prototype.times=d.prototype.multiply;e.prototype._multiplyBySmall=function(a){return w(a.value*this.value)?new e(a.value*this.value):U(Math.abs(a.value),z(Math.abs(this.value)),this.sign!==a.sign)};d.prototype._multiplyBySmall=function(a){return 0===
a.value?k[0]:1===a.value?this:-1===a.value?this.negate():U(Math.abs(a.value),this.value,this.sign!==a.sign)};e.prototype.multiply=function(a){return l(a)._multiplyBySmall(this)};e.prototype.times=e.prototype.multiply;d.prototype.square=function(){return new d(V(this.value),!1)};e.prototype.square=function(){var a=this.value*this.value;return w(a)?new e(a):new d(V(z(Math.abs(this.value))),!1)};d.prototype.divmod=function(a){a=I(this,a);return{quotient:a[0],remainder:a[1]}};e.prototype.divmod=d.prototype.divmod;
d.prototype.divide=function(a){return I(this,a)[0]};e.prototype.over=e.prototype.divide=d.prototype.over=d.prototype.divide;d.prototype.mod=function(a){return I(this,a)[1]};e.prototype.remainder=e.prototype.mod=d.prototype.remainder=d.prototype.mod;d.prototype.pow=function(a){var b=l(a),c=this.value;a=b.value;var d;if(0===a)return k[1];if(0===c)return k[0];if(1===c)return k[1];if(-1===c)return b.isEven()?k[1]:k[-1];if(b.sign)return k[0];if(!b.isSmall)throw Error("The exponent "+b.toString()+" is too large.");
if(this.isSmall&&w(d=Math.pow(c,a)))return new e(B(d));d=this;for(b=k[1];;){a&1&&(b=b.times(d),--a);if(0===a)break;a/=2;d=d.square()}return b};e.prototype.pow=d.prototype.pow;d.prototype.modPow=function(a,b){a=l(a);b=l(b);if(b.isZero())throw Error("Cannot take modPow with modulus 0");for(var c=k[1],d=this.mod(b);a.isPositive();){if(d.isZero())return k[0];a.isOdd()&&(c=c.multiply(d).mod(b));a=a.divide(2);d=d.square().mod(b)}return c};e.prototype.modPow=d.prototype.modPow;d.prototype.compareAbs=function(a){a=
l(a);return a.isSmall?1:A(this.value,a.value)};e.prototype.compareAbs=function(a){a=l(a);var b=Math.abs(this.value),c=a.value;return a.isSmall?(c=Math.abs(c),b===c?0:b>c?1:-1):-1};d.prototype.compare=function(a){if(Infinity===a)return-1;if(-Infinity===a)return 1;a=l(a);return this.sign!==a.sign?a.sign?1:-1:a.isSmall?this.sign?-1:1:A(this.value,a.value)*(this.sign?-1:1)};d.prototype.compareTo=d.prototype.compare;e.prototype.compare=function(a){if(Infinity===a)return-1;if(-Infinity===a)return 1;a=l(a);
var b=this.value,c=a.value;return a.isSmall?b==c?0:b>c?1:-1:0>b!==a.sign?0>b?-1:1:0>b?1:-1};e.prototype.compareTo=e.prototype.compare;d.prototype.equals=function(a){return 0===this.compare(a)};e.prototype.eq=e.prototype.equals=d.prototype.eq=d.prototype.equals;d.prototype.notEquals=function(a){return 0!==this.compare(a)};e.prototype.neq=e.prototype.notEquals=d.prototype.neq=d.prototype.notEquals;d.prototype.greater=function(a){return 0<this.compare(a)};e.prototype.gt=e.prototype.greater=d.prototype.gt=
d.prototype.greater;d.prototype.lesser=function(a){return 0>this.compare(a)};e.prototype.lt=e.prototype.lesser=d.prototype.lt=d.prototype.lesser;d.prototype.greaterOrEquals=function(a){return 0<=this.compare(a)};e.prototype.geq=e.prototype.greaterOrEquals=d.prototype.geq=d.prototype.greaterOrEquals;d.prototype.lesserOrEquals=function(a){return 0>=this.compare(a)};e.prototype.leq=e.prototype.lesserOrEquals=d.prototype.leq=d.prototype.lesserOrEquals;d.prototype.isEven=function(){return 0===(this.value[0]&
1)};e.prototype.isEven=function(){return 0===(this.value&1)};d.prototype.isOdd=function(){return 1===(this.value[0]&1)};e.prototype.isOdd=function(){return 1===(this.value&1)};d.prototype.isPositive=function(){return!this.sign};e.prototype.isPositive=function(){return 0<this.value};d.prototype.isNegative=function(){return this.sign};e.prototype.isNegative=function(){return 0>this.value};d.prototype.isUnit=function(){return!1};e.prototype.isUnit=function(){return 1===Math.abs(this.value)};d.prototype.isZero=
function(){return!1};e.prototype.isZero=function(){return 0===this.value};d.prototype.isDivisibleBy=function(a){a=l(a);var b=a.value;return 0===b?!1:1===b?!0:2===b?this.isEven():this.mod(a).equals(k[0])};e.prototype.isDivisibleBy=d.prototype.isDivisibleBy;d.prototype.isPrime=function(){var a=X(this);if(a!==E)return a;for(var a=this.abs(),b=a.prev(),c=[2,3,5,7,11,13,17,19],d=b,e,l,g,h;d.isEven();)d=d.divide(2);for(g=0;g<c.length;g++)if(h=bigInt(c[g]).modPow(d,a),!h.equals(k[1])&&!h.equals(b)){l=!0;
for(e=d;l&&e.lesser(b);e=e.multiply(2))h=h.square().mod(a),h.equals(b)&&(l=!1);if(l)return!1}return!0};e.prototype.isPrime=d.prototype.isPrime;d.prototype.isProbablePrime=function(a){var b=X(this);if(b!==E)return b;b=this.abs();a=a===E?5:a;for(var c=0;c<a;c++)if(!bigInt.randBetween(2,b.minus(2)).modPow(b.prev(),b).isUnit())return!1;return!0};e.prototype.isProbablePrime=d.prototype.isProbablePrime;d.prototype.next=function(){var a=this.value;return this.sign?M(a,1,this.sign):new d(L(a,1),this.sign)};
e.prototype.next=function(){var a=this.value;return 9007199254740992>a+1?new e(a+1):new d(P,!1)};d.prototype.prev=function(){var a=this.value;return this.sign?new d(L(a,1),!0):M(a,1,this.sign)};e.prototype.prev=function(){var a=this.value;return-9007199254740992<a-1?new e(a-1):new d(P,!0)};for(var v=[1];1E7>=v[v.length-1];)v.push(2*v[v.length-1]);var J=v.length,fa=v[J-1];d.prototype.shiftLeft=function(a){if(!Y(a))throw Error(String(a)+" is too large for shifting.");a=+a;if(0>a)return this.shiftRight(-a);
for(var b=this;a>=J;)b=b.multiply(fa),a-=J-1;return b.multiply(v[a])};e.prototype.shiftLeft=d.prototype.shiftLeft;d.prototype.shiftRight=function(a){var b;if(!Y(a))throw Error(String(a)+" is too large for shifting.");a=+a;if(0>a)return this.shiftLeft(-a);for(b=this;a>=J;){if(b.isZero())return b;b=I(b,fa);b=b[1].isNegative()?b[0].prev():b[0];a-=J-1}b=I(b,v[a]);return b[1].isNegative()?b[0].prev():b[0]};e.prototype.shiftRight=d.prototype.shiftRight;d.prototype.not=function(){return this.negate().prev()};
e.prototype.not=d.prototype.not;d.prototype.and=function(a){return R(this,a,function(a,c){return a&c})};e.prototype.and=d.prototype.and;d.prototype.or=function(a){return R(this,a,function(a,c){return a|c})};e.prototype.or=d.prototype.or;d.prototype.xor=function(a){return R(this,a,function(a,c){return a^c})};e.prototype.xor=d.prototype.xor;d.prototype.toString=function(a){a===E&&(a=10);if(10!==a)return da(this,a);a=this.value;for(var b=a.length,c=String(a[--b]),d;0<=--b;)d=String(a[b]),c+="0000000".slice(d.length)+
d;return(this.sign?"-":"")+c};e.prototype.toString=function(a){a===E&&(a=10);return 10!=a?da(this,a):String(this.value)};d.prototype.valueOf=function(){return+this.toString()};d.prototype.toJSNumber=d.prototype.valueOf;e.prototype.valueOf=function(){return this.value};e.prototype.toJSNumber=e.prototype.valueOf;for(var C=0;1E3>C;C++)k[C]=new e(C),0<C&&(k[-C]=new e(-C));k.one=k[1];k.zero=k[0];k.minusOne=k[-1];k.max=Z;k.min=aa;k.gcd=ba;k.lcm=function(a,b){a=l(a).abs();b=l(b).abs();return a.divide(ba(a,
b)).multiply(b)};k.isInstance=function(a){return a instanceof d||a instanceof e};k.randBetween=function(a,b){a=l(a);b=l(b);var c=aa(a,b),k=Z(a,b).subtract(c);if(k.isSmall)return c.add(Math.round(Math.random()*k));for(var f=[],m=!0,g=k.value.length-1;0<=g;g--){var h=m?k.value[g]:1E7,q=B(Math.random()*h);f.unshift(q);q<h&&(m=!1)}f=y(f);return c.add("number"===typeof f?new e(f):new d(f,!1))};return k}();"undefined"!==typeof module&&module.hasOwnProperty("exports")&&(module.exports=bigInt);
/*!
 * headroom.js v0.8.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2016 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

!function(a,b){"use strict";"function"==typeof define&&define.amd?define([],b):"object"==typeof exports?module.exports=b():a.Headroom=b()}(this,function(){"use strict";function a(a){this.callback=a,this.ticking=!1}function b(a){return a&&"undefined"!=typeof window&&(a===window||a.nodeType)}function c(a){if(arguments.length<=0)throw new Error("Missing arguments in extend function");var d,e,f=a||{};for(e=1;e<arguments.length;e++){var g=arguments[e]||{};for(d in g)"object"!=typeof f[d]||b(f[d])?f[d]=f[d]||g[d]:f[d]=c(f[d],g[d])}return f}function d(a){return a===Object(a)?a:{down:a,up:a}}function e(a,b){b=c(b,e.options),this.lastKnownScrollY=0,this.elem=a,this.tolerance=d(b.tolerance),this.classes=b.classes,this.offset=b.offset,this.scroller=b.scroller,this.initialised=!1,this.onPin=b.onPin,this.onUnpin=b.onUnpin,this.onTop=b.onTop,this.onNotTop=b.onNotTop,this.onBottom=b.onBottom,this.onNotBottom=b.onNotBottom}var f={bind:!!function(){}.bind,classList:"classList"in document.documentElement,rAF:!!(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame)};return window.requestAnimationFrame=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame,a.prototype={constructor:a,update:function(){this.callback&&this.callback(),this.ticking=!1},requestTick:function(){this.ticking||(requestAnimationFrame(this.rafCallback||(this.rafCallback=this.update.bind(this))),this.ticking=!0)},handleEvent:function(){this.requestTick()}},e.prototype={constructor:e,init:function(){return e.cutsTheMustard?(this.debouncer=new a(this.update.bind(this)),this.elem.classList.add(this.classes.initial),setTimeout(this.attachEvent.bind(this),100),this):void 0},destroy:function(){var a=this.classes;this.initialised=!1,this.elem.classList.remove(a.unpinned,a.pinned,a.top,a.notTop,a.initial),this.scroller.removeEventListener("scroll",this.debouncer,!1)},attachEvent:function(){this.initialised||(this.lastKnownScrollY=this.getScrollY(),this.initialised=!0,this.scroller.addEventListener("scroll",this.debouncer,!1),this.debouncer.handleEvent())},unpin:function(){var a=this.elem.classList,b=this.classes;!a.contains(b.pinned)&&a.contains(b.unpinned)||(a.add(b.unpinned),a.remove(b.pinned),this.onUnpin&&this.onUnpin.call(this))},pin:function(){var a=this.elem.classList,b=this.classes;a.contains(b.unpinned)&&(a.remove(b.unpinned),a.add(b.pinned),this.onPin&&this.onPin.call(this))},top:function(){var a=this.elem.classList,b=this.classes;a.contains(b.top)||(a.add(b.top),a.remove(b.notTop),this.onTop&&this.onTop.call(this))},notTop:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notTop)||(a.add(b.notTop),a.remove(b.top),this.onNotTop&&this.onNotTop.call(this))},bottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.bottom)||(a.add(b.bottom),a.remove(b.notBottom),this.onBottom&&this.onBottom.call(this))},notBottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notBottom)||(a.add(b.notBottom),a.remove(b.bottom),this.onNotBottom&&this.onNotBottom.call(this))},getScrollY:function(){return void 0!==this.scroller.pageYOffset?this.scroller.pageYOffset:void 0!==this.scroller.scrollTop?this.scroller.scrollTop:(document.documentElement||document.body.parentNode||document.body).scrollTop},getViewportHeight:function(){return window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight},getElementPhysicalHeight:function(a){return Math.max(a.offsetHeight,a.clientHeight)},getScrollerPhysicalHeight:function(){return this.scroller===window||this.scroller===document.body?this.getViewportHeight():this.getElementPhysicalHeight(this.scroller)},getDocumentHeight:function(){var a=document.body,b=document.documentElement;return Math.max(a.scrollHeight,b.scrollHeight,a.offsetHeight,b.offsetHeight,a.clientHeight,b.clientHeight)},getElementHeight:function(a){return Math.max(a.scrollHeight,a.offsetHeight,a.clientHeight)},getScrollerHeight:function(){return this.scroller===window||this.scroller===document.body?this.getDocumentHeight():this.getElementHeight(this.scroller)},isOutOfBounds:function(a){var b=0>a,c=a+this.getScrollerPhysicalHeight()>this.getScrollerHeight();return b||c},toleranceExceeded:function(a,b){return Math.abs(a-this.lastKnownScrollY)>=this.tolerance[b]},shouldUnpin:function(a,b){var c=a>this.lastKnownScrollY,d=a>=this.offset;return c&&d&&b},shouldPin:function(a,b){var c=a<this.lastKnownScrollY,d=a<=this.offset;return c&&b||d},update:function(){var a=this.getScrollY(),b=a>this.lastKnownScrollY?"down":"up",c=this.toleranceExceeded(a,b);this.isOutOfBounds(a)||(a<=this.offset?this.top():this.notTop(),a+this.getViewportHeight()>=this.getScrollerHeight()?this.bottom():this.notBottom(),this.shouldUnpin(a,c)?this.unpin():this.shouldPin(a,c)&&this.pin(),this.lastKnownScrollY=a)}},e.options={tolerance:{up:0,down:0},offset:0,scroller:window,classes:{pinned:"headroom--pinned",unpinned:"headroom--unpinned",top:"headroom--top",notTop:"headroom--not-top",bottom:"headroom--bottom",notBottom:"headroom--not-bottom",initial:"headroom"}},e.cutsTheMustard="undefined"!=typeof f&&f.rAF&&f.bind&&f.classList,e});
(function () {
  'use strict';

  /* @ngdoc object
   * @name employeePayroll
   * @description
   *
   */
  angular
    .module('employeePayroll', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name employeePayroll.factory:EmployeePayrollService
   *
   * @description
   *
   */
  EmployeePayrollService.$inject = ["$http", "$q", "$log", "EndpointsService", "HelperService"];
  angular
    .module('employeePayroll')
    .factory('EmployeePayrollService', EmployeePayrollService);

  function EmployeePayrollService($http, $q, $log, EndpointsService, HelperService) {
    var EmployeePayrollServiceBase = {};

    EmployeePayrollServiceBase.getEmployeePayrolls = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.employeePayrolls, {
              params: params
            })
            .success(function (data) {
              deferred.resolve(data);
            })
            .error(function (msg, code) {
              deferred.reject(msg)
            });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    EmployeePayrollServiceBase.getEmployeePdfLink = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.employeePayrolls_downloadLink_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EmployeePayrollServiceBase.downloadEmployeePdf = function (id) {
      var nonBlockingWindow = window.open('', '_self');
      EmployeePayrollServiceBase.getEmployeePdfLink(id)
        .then(function (pdfLink) {
          if (pdfLink) {
            // If we want to open link in same tab (immediate download)
            // window.location.href = pdfLink.url;
            // Opening in new empty tab
            nonBlockingWindow.location.href = pdfLink.url;
          }
        })
        .catch(function (error) {
          nonBlockingWindow.close();
          HelperService.showMessage(error, 'error');
          $log.debug(error);
        });
    };

    return EmployeePayrollServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('employeePayroll')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('employeePayroll', {
        url: '/employee-payroll',
        templateUrl: 'employee-payroll/employee-payroll.tpl.html',
        controller: 'EmployeePayrollCtrl',
        controllerAs: 'employeePayroll'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name employeePayroll.controller:EmployeePayrollCtrl
   *
   * @description
   *
   */
  EmployeePayrollCtrl.$inject = ["$translate", "HelperService", "$log", "EmployeePayrollService"];
  angular
    .module('employeePayroll')
    .controller('EmployeePayrollCtrl', EmployeePayrollCtrl);

  function EmployeePayrollCtrl($translate,HelperService, $log, EmployeePayrollService) {
    var vm = this;
    vm.ctrlName = 'EmployeePayrollCtrl';

    vm.timelineFilter = {
      page: 0,
      amountGTE: null,
      amountLTE: null,
      orderBy: 'dateCreated desc',
      pageSize: 10
    };
    vm.recompile = {
      timeline: true
    };
    vm.timelineListGrouped = {};


    vm.loadMoreTimelineItemsGrouped = function () {
      vm.getTimelineItemsGrouped(false);

    };

    vm.getTimelineItemsGrouped = function (reset) {

      if (reset) {
        vm.timelineFilter.page = 0;
      } else {
        vm.timelineFilter.page += 1;
      }


      EmployeePayrollService.getEmployeePayrolls(vm.timelineFilter)
        .then(function (response) {
          vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
            existingData: vm.timelineListGrouped,
            newData: response,
            groupFunction: function (item) {

              var dateYear = item.fileYear;
              item.customDate = new Date(item.fileMonth+"-01-"+item.fileYear);
              // If we want to group only by date component, without hours
              //date.setHours(0, 0, 0, 0);
              return dateYear;
            },
            virtualRowFunction: function (e) {
              var year = new Date(e).getFullYear();
              var virtualRow = {
                isVirtual: true,
                date: e,
                year: year
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: true
          });

          /*
          var todayDateRange = HelperService.getTodayWithoutOffset();
          var yesterdayDateRange = HelperService.getYesterdayWithoutOffset();


          _.forEach(vm.timelineListGrouped.result, function (item) {
            item.dateValue = new Date(item.date);
            if (item.dateValue >= todayDateRange.firstDay && item.dateValue <= todayDateRange.lastDay) {
              item.showText = true;
              item.dateLabel = 'core.period.today';
            }
            else if (item.dateValue >= yesterdayDateRange.firstDay && item.dateValue < yesterdayDateRange.lastDay) {
              item.showText = true;
              item.dateLabel = 'core.period.yesterday';
            }
            else {
              item.showDate = true;
            }
          });
          */
          $log.debug("groupedEmployeePayrollTimeline", vm.timelineListGrouped);
          //alert(2);
          vm.recompile.timeline = true;
        }).catch(function (error) {
          $log.error(error);
        });
    };

    vm.downloadPdf= function (id) {
      EmployeePayrollService.downloadEmployeePdf(id);
    };
    vm.init = function () {
      vm.getTimelineItemsGrouped(true);
    };

    vm.init();
  }
} ());

(function () {
  'use strict';

  /* @ngdoc object
   * @name eInvoices
   * @description
   *
   */
  angular
    .module('eInvoices', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name eInvoices.controller:EinvoicesRegisterCtrl
   *
   * @description
   *
   */
  EinvoicesRegisterCtrl.$inject = ["$rootScope", "$state", "$q", "$log", "EinvoicesIssuersOverviewService", "EinvoiceSubscriptionsService", "UserSettingsService", "HelperService", "AlertService", "AccountsService"];
  angular
    .module('eInvoices')
    .controller('EinvoicesRegisterCtrl', EinvoicesRegisterCtrl);

  function EinvoicesRegisterCtrl($rootScope, $state, $q, $log, EinvoicesIssuersOverviewService, EinvoiceSubscriptionsService, UserSettingsService,
                                  HelperService, AlertService, AccountsService) {
    var vm = this;
    vm.ctrlName = 'EinvoicesRegisterCtrl';
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
    vm.issuers = [];
    vm.issuer = null;
    vm.userAgrees = false;
    vm.userApproves = false;
    vm.formSubmitted = false;
    vm.step = 'register';
    vm.editingEmail = false;
    vm.taxIdSearch = "";
    vm.issuerSearchInput = "";

    var issuerParams = {
      identificationNumberFTS: "",
      nameFTS: ""
    };

    vm.tempDompObj = {
      fromAccountSelect: {}
    };

    vm.register = register;
    vm.registerNew = registerNew;
    vm.editEmail = editEmail;
    vm.updateEmail = updateEmail;
    vm.cancelEmail = cancelEmail;
    vm.disabled = true;

    vm.requestTypes = [
      { value: "eInvoicesModal.subscribe", name: "subscribe" },
      { value: "eInvoicesModal.unsubscribe", name: "unsubscribe" }
    ];

    function getIssuers() {
      var filter = {
        page: 0,
        pageSize: 10000,
        orderBy: 'name asc'
      };
      return EinvoicesIssuersOverviewService.getPage(filter)
        .then(function (response) {
        vm.issuers = response.result;
        $log.debug("list", vm.einvoicesIssuersList);
      });
    };

    function getSubscriptionsPage() {
      var subscriptionsFilter = {
        page: 0,
        pageSize: 1000
      };

      return EinvoiceSubscriptionsService.getPage(subscriptionsFilter)
        .then(function (response) {
        vm.subscriptionObjectList = response;
      })
        .catch(function (error) {
        $log.debug("error", error);
      });
    }

    function getUserSettingsPage() {
      var userSettingsFilter = {
        page: 0,
        pageSize: 1
      };
      UserSettingsService.getPage(userSettingsFilter)
        .then(function (response) {
        // vm.email = response.result[0].eInvoiceEmail;
        vm.email = response.result[0].notificationEmail;
        vm.gsm = response.result[0].gsm;
        vm.userId = response.result[0].id;
        $log.debug("E-invoice email", vm.email);
      }).catch(function (error) {
        $log.error(error);
      });
    };

    function register() {
      if (vm.registerButtonPressed) return;
      vm.formSubmitted = true;

      if (!vm.einvoiceSubscribeForm.$valid) {
        return;
      }

      var object = createRequestObject();
      if(vm.countryCode == 'sl'){
        object.requestType = vm.requestType.name;
        object.phoneNumber = vm.gsm;
        object.accountId = vm.tempDompObj.fromAccountSelect.accountId;
        object.email = vm.email;
      }
      vm.registerButtonPressed = true;
      EinvoiceSubscriptionsService.insertSubscriptionRequest(object)
        .then(function (response) {
          if(vm.countryCode != 'sl'){
            AlertService.infoAlert({
              text: 'alert.subscriptionRequest'
            })
              .then(function (response) {
                vm.userApproves = false;
                vm.step = 'done';
              });
          }else{
            vm.userApproves = false;
            vm.step = 'done';
          }

      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
        $log.error("Subscription error:", error);
      }).finally(function (){
        vm.registerButtonPressed = false;
      });
    };

    vm.resume = function () {
      vm.formSubmitted = true;

      if (!vm.einvoiceSubscribeForm.$valid) {
        return;
      }

      if(vm.countryCode === 'sl')
        validateEInvoice();
      else
        vm.step = 'resume';
    };

    function validateEInvoice() {
      var object = createRequestObject();
      object.requestType = vm.requestType.name;
      object.phoneNumber = vm.gsm;
      object.accountId = vm.tempDompObj.fromAccountSelect.accountId;
      object.email = vm.email;

      EinvoiceSubscriptionsService.validateSubscriptionRequest(object)
        .then(function (response) {
          vm.step = 'resume';
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    }


    function registerNew() {
      // Reset input fields
      // vm.step = 'register';
      // vm.formSubmitted = false;
      // vm.userAgrees = false;
      // vm.userApproves = false;
      // vm.referenceNumber = '';
      // vm.issuer = '';
      // vm.email = '';
      // vm.emailConfirmation = '';
      $state.go("eInvoices.einvoicesRegisterNew", {}, {reload: true});
    };

    function editEmail() {
      this.originalEmail = vm.email;
      vm.editingEmail = true;
    };

    function updateEmail() {
      var request = {
        updateInvoicingEmail: true,
        invoicingEmail: vm.email
      };
      UserSettingsService.updateInvoiceEmail(request, vm.userId)
        .then(function (response) {
        vm.editingEmail = false;
        $log.debug("updated e-invoiceMail", response);
      }).catch(function (error) {
        $log.error(error);
      });
    };


    function cancelEmail() {
      vm.editingEmail = false;
      vm.email = this.originalEmail;
    };

    function createRequestObject() {
      return {
        paymentReferenceNumber: vm.referenceNumber,
        issuerId: vm.issuer.id,
        userApproves: vm.userApproves
    /*  requestType: vm.subscriptionObject.settingType,
        userServiceId: vm.referenceNumber,
        serviceType: vm.subscriptionObject.serviceType,
        serviceState: vm.subscriptionObject.serviceState,
        services: null,
        userApproves: vm.userApproves */
      };
    };

    vm.issuerSelected = function (issuer) {
      vm.issuer = issuer;
      vm.taxIdSearch = issuer.identificationNumber;
      vm.issuerSearchInput = issuer.name;
      vm.searchExpanded = false;

    };

    vm.checkDisabled = function () {
      if(vm.userApproves == true && vm.issuer && !vm.issuer.termsOfServiceLink) {
        vm.disabled = false;
      } else if (vm.userApproves == true && vm.issuer && vm.issuer.termsOfServiceLink && vm.userAgrees == true) {
        vm.disabled = false;
      }
      else if (vm.countryCode == 'sl' && vm.issuer && vm.userApproves == true){
        vm.disabled = false;
      }
      else {
        vm.disabled = true;
      }
    };

    vm.removeSelectedIssuer = function() {
      vm.issuer = null;
      vm.issuerSearchInput = "";
      vm.taxIdSearch = "";
      vm.userApproves = false;
      vm.userAgrees = false;
      vm.referenceNumber = '';
      vm.checkDisabled();
      vm.einvoiceSubscribeForm.referenceNumber.$setValidity("referenceRequired", true);
    };

    vm.searchIssuers = function (searchBy) {

      if (searchBy == "id" && vm.taxIdSearch && vm.taxIdSearch.length < 3) {
        if (vm.issuerSearchInput.length < 3) return;
      }
      if (searchBy == "name" && vm.issuerSearchInput && vm.issuerSearchInput.length < 3) {
        if (vm.taxIdSearch.length < 3) return;
      }

      // if (searchBy == "id") {
      //   if (vm.taxIdSearch.length > 3)  {}// CONTINUE;
      //   if (vm.issuerSearchInput.length > 3) {}
      // }


      // if (searchBy == "name" && vm.issuerSearchInput.length < 3 && vm.taxIdSearch.length < 3) return;
      var filter = {
        nameFTS: vm.issuerSearchInput,
        identificationNumberFTS: vm.taxIdSearch
      };

      return EinvoicesIssuersOverviewService.getPage(filter)
        .then(function (response) {
          if (response.result.length) {
            vm.issuers = response.result;
            vm.searchExpanded = true;
          } else {
            vm.issuers = [];
          }
        });
    };


    vm.init = function() {
      $log.debug('EinvoicesRegisterCtrl init()');
      //getIssuers();
      getUserSettingsPage();
      //getSubscriptionsPage();
      var promises = [getSubscriptionsPage()];
       if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation !== 'sl') promises.push(getIssuers());
       else  promises.push(loadAccounts());
      $q.all(promises)
        .then(function (){

        if (!_.isEmpty($state.params.myParam)) {
          vm.registrationObject = $state.params.myParam;
          vm.referenceNumber = vm.registrationObject.paymentReferenceNumber;
          vm.requestType = (vm.registrationObject.serviceType.toLowerCase() === "registration") ? vm.requestTypes[0] : vm.requestTypes[1];

          // TSK-11078 (SLOW-384) e-invoice Register again
          // Select account by accountId (swagger model returns accountId for eInvoiceSubscription
          vm.setAccountFrom(_.findWhere(vm.accounts, {accountId: vm.registrationObject.accountId}));
          var filter = {
            identificationNumberFTS: vm.registrationObject.eInvoiceIssuer.identificationNumber,
            nameFTS: vm.registrationObject.issuerName
          };
          EinvoicesIssuersOverviewService.getPage(filter)
            .then(function (response) {
              if (response.result.length) {
                vm.issuers = response.result;
                vm.issuerSelected(vm.issuers[0]);
              } else {
                vm.issuers = [];
              }
            });
        } else {
          vm.requestType = vm.requestTypes[0];
        }
      })
        .catch(function (error){
        HelperService.showMessage(error, 'error');
      });
    };


    /////////////////from account component///////////////////////////
    var accountsFilter = {
      accountTypeGroupList: ['CurrentAccount'],
      isParentAccount: true,
      isOwn: true
    };

    vm.accounts = [];

    // Load accounts
    var loadAccounts = function () {
      AccountsService.getPage(accountsFilter)
        .then(function (response) {
          vm.accounts = response.result;
          if(vm.accounts)
            vm.tempDompObj.fromAccountSelect = vm.accounts[0];
        })
        .catch(function (error) {
          $log.error(error);
        });
    };


    vm.toggleFromAccount = function () {
      vm.fromAccountDropdown = !vm.fromAccountDropdown;
    };

    vm.setAccountFrom = function (item) {
      vm.tempDompObj.fromAccountSelect = (item) ? item: vm.accounts[0];
      vm.fromAccountDropdown = false;
    };

    vm.checkIfRequiredAndValid = function (referenceInput) {
      if(vm.issuer && vm.issuer.referenceRequired && !referenceInput){
        vm.einvoiceSubscribeForm.referenceNumber.$setValidity("referenceRequired", false);
      }else{
        vm.einvoiceSubscribeForm.referenceNumber.$setValidity("referenceRequired", true);
      }
    };

    vm.goToEInvoices = function () {
      if(vm.countryCode == 'sl')
        $state.go('eInvoices.einvoicesOverview',{tabToSelect: 2}); //0,1,2 - 2 is Third
      else
        $state.go('eInvoices.einvoicesOverview');
    };



    vm.init();
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name eInvoices.controller:EinvoicesPayCtrl
   *
   * @description
   *
   */
  EinvoicesPayCtrl.$inject = ["$rootScope", "$http", "CTLocalizationService", "$state", "EInvoiceDocumentsService", "PaymentTypesService", "PaymentsService", "HelperService", "ConfigEndpointService", "$log", "$filter", "$q", "AlertService", "$translate", "Notification"];
  angular
    .module('eInvoices')
    .controller('EinvoicesPayCtrl', EinvoicesPayCtrl);

  function EinvoicesPayCtrl($rootScope, $http, CTLocalizationService, $state, EInvoiceDocumentsService, PaymentTypesService, PaymentsService, HelperService,
                             ConfigEndpointService, $log, $filter, $q, AlertService, $translate, Notification) {
    var vm = this;
    vm.ctrlName = 'EinvoicesPayCtrl';
    vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
    vm.countryCode = '';
    vm.invoice = {};
    vm.step = 'pay';
    // vm.smsAuthentificate = false;
    vm.fromAccountDropdown = false;
    vm.formSubmitted = false;
    vm.setAccountFrom = setAccountFrom;
    vm.goBack = goBack;
    vm.bankCharges = '';
    var forUpdate = false;
    vm.isUrgentPaymentCheckbox = false;
    vm.hideUrgency = false;

    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
      vm.disabled = function (date, mode) {
        return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
      };
    }

    function init() {
      $log.debug('EinvoicesPayCtrl init()');
      if ($state.params.eInvoiceId) {
        // Pay invoice
        getEInvoiceById($state.params.eInvoiceId);
        getPaymentForEInvoice($state.params.eInvoiceId);
        getDefaultDetails();
      }
    };

    vm.showInfo = function () {
      var message = $translate.instant('domesticPayment.urgentInfo');
      var temp = {"resultList":[{"key":"Info","description":message}]};
      if(vm.isUrgentPaymentCheckbox){
        PaymentsService.showModalWithActions(temp,null);
      }
    };

    function getEInvoiceById(id) {
     return EInvoiceDocumentsService.getById(id)
        .then(function (response) {
          if(response){
            console.log("ovdje",response);
            vm.invoice = response;
            vm.amountInput = vm.invoice.amount
            vm.invoice.creditorAccount = vm.invoice.creditorAccount.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
            vm.dateInput = new Date(); // vm.invoice.dueDate
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function getPaymentForEInvoice(invoiceId) {
     return EInvoiceDocumentsService.getEinvoiceForPaymentById(invoiceId)
        .then(function (response) {
          vm.invoicePayment = response;
          getPaymentTypeGroup();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function getDefaultDetails() {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
          if (response) {
            vm.defaultCurrency = response.DefaultCurrency;
            if (response.APILocation) {
              vm.countryCode = response.APILocation;
                vm.bankCharges = response.BankCharges;
            }
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function getPaymentTypeGroup() {
      var paymentTypesGroupFilter = {
        paymentTypeGroup: 'DomesticPayment',
        currencySymbol: ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") ? "EUR" : undefined
      };
      return PaymentTypesService.getByGroup(paymentTypesGroupFilter)
        .then(function (response) {
          vm.paymentTypeGroupDomestic = response;

          _.forEach(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function(value){
            value.optionValue = value.accountDescription + ' - ' + value.iban;
          });

          $log.debug("paymentTypeGroupDomestic", vm.paymentTypeGroupDomestic);
          if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {
            console.log(vm.invoice);
            vm.fromAccountSelect = _.findWhere(vm.paymentTypeGroupDomestic.result[0].debitAccountList,
              {iban: vm.invoicePayment.fromAccountNumber ? vm.invoicePayment.fromAccountNumber.replace(/ /g,'') : ''});
          }

          if(!vm.fromAccountSelect && vm.paymentTypeGroupDomestic.result[0].debitAccountList)
            vm.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
          $log.error('Error loading paymentTypeGroupDomestic!');
        });
    }

    function setAccountFrom(item) {
      vm.fromAccountSelect = item;
      vm.fromAccountDropdown = false;
    };

    function postPaymentAction(response) {
      vm.paymentResponse = response;
      if(!vm.paymentResponse.domesticPayment){
        vm.paymentResponse.domesticPayment = {};
        angular.extend(vm.paymentResponse.domesticPayment, vm.paymentResponse);
      }
      Notification.clearAll();
      vm.step = 'verify';
    };

    vm.confirmPayment = function () {
      if (vm.validateInProgress) return;

      if (!vm.paymentForm.$valid) {
        return;
      }

      if (!vm.formSubmitted) {
        vm.formSubmitted = true;
        var paymentObj = createPaymentObject();

        vm.validateInProgress = true;
        if (forUpdate) {
          paymentObj.id = vm.paymentResponse.id;
          PaymentsService.updatePayment(vm.paymentResponse.id, paymentObj)
            .then(function (response) {
              vm.paymentResponse = response;
              if(!vm.paymentResponse.domesticPayment){

                vm.paymentResponse.domesticPayment = {};
                angular.extend(vm.paymentResponse.domesticPayment, vm.paymentResponse);
              }
              vm.step = 'verify';
              forUpdate = false;
            })
            .catch(function (error) {
              HelperService.showMessage(error, 'error');
              forUpdate = false;
            })
            .finally(function(){
              vm.formSubmitted = false;
              vm.validateInProgress = false;
            });
        } else {
          PaymentsService.insertPayment(paymentObj)
            .then(function (response) {
            if (response.dueDateChanged) {
              AlertService.confirmationAlert({
                text: "payments.paymentDueDateChangedMsg"
              })
                .then(function (accept) {
                if (!accept) return;
                secondValidate(response);
              })
            } else {
              postPaymentAction(response);

            }
            })
            .catch(function (error) {
                HelperService.showMessage(error, 'error');
            })
            .finally(function(){
              vm.formSubmitted = false;
              vm.validateInProgress = false;
            });
        }
      }
    };

    function secondValidate(validatedUPOrder) {
      if (vm.secondValidationInProgress) return;
      var paymentObj = createPaymentObject();
      vm.secondValidationInProgress = true;
      PaymentsService.insertPayment(validatedUPOrder)
        .then(function (response) {
        postPaymentAction(response);
      })
        .catch(function (response, error) {
        if (response && response.hasWarnings) {
          //show action message modal
          PaymentsService.showModalWithActions(response, paymentObj);
        } else {
          HelperService.showMessage(response, 'error');
        }
      })
        .finally(function () {
        vm.formSubmitted = false;
        vm.forUpdate = false;
          vm.secondValidationInProgress = false;
        });
    };

    function goBack() {
      $state.go('eInvoices.einvoicesOverview');
    }

    function createPaymentObject() {
      var paymentObject = {
        domesticPayment: {
          receiverName: vm.invoice.creditorName,
          receiverAddress1: vm.invoice.creditorAddress,
          receiverCity: vm.invoice.creditorCity,
          beneficiarySWIFTCode: vm.invoice.ultimateCreditorBIC,
          referenceTo: vm.invoicePayment.referenceTo,
          urgency: vm.isUrgentPaymentCheckbox ? '1' : '0'
        },
        accountId: vm.fromAccountSelect.accountId,
        fromAccountNumber: vm.fromAccountSelect.iban,
        toAccountNumber: vm.invoicePayment.toAccountNumber, //'HR2325000091501135368'
        currencySymbol: vm.fromAccountSelect.currencySymbol,
        purpose: vm.invoice.purpose,
        amount: vm.amountInput,
        paymentTypeGroup: 'DomesticPayment',
        paymentSourceType: vm.invoicePayment.paymentSourceType,
        relatedSourceId: vm.invoicePayment.relatedSourceId,
        relatedSourceType: vm.invoicePayment.relatedSourceType
          //purposeCodeDPS:  vm.invoicePayment.purposeCodeSelect || '' //'ACCT'
      };

      paymentObject.dueDate = vm.dateInput;
      /*if(vm.paymentDateOption.val==1 || vm.paymentDateOption.val==3) {
       } else {
       paymentObject.dueDate = vm.eInvoiceObject.valueDate;
       }*/
      return paymentObject;
    }

      function mapWithPaymentResponse() {
        vm.amountInput = vm.paymentResponse.amount;
        vm.dateInput = new Date(vm.paymentResponse.dueDate);
        // filter account number
        var fromAccountIndex = _.findIndex(vm.paymentTypeGroupDomestic.result[0].debitAccountList, function (item) {
          return item.accountNumber == vm.paymentResponse.fromAccountNumber.split(" ")[0];
        });
        if (fromAccountIndex != -1) {
          vm.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[fromAccountIndex];
        }
      };

      var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
       $rootScope.$on('appLanguageChangedHeader', function () {
         sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
       });

       vm.deletePayment = function () {
         AlertService.confirmationAlert()
           .then(function (result) {
             if (result) {
               PaymentsService.deletePayment(vm.paymentResponse.id)
                 .then(function (response) {
                   AlertService.deletedPaymentAlert({paymentName: vm.paymentResponse.id, type: 'payment'})
                     .then(function () {
                       $state.go('eInvoices.einvoicesOverview');
                     });
                 })
                 .catch(function (error) {
                   HelperService.showMessage(error, 'error');
                 });
             }
           })
           .catch(function () {
             $log.debug('Example failed!');
           });


       };

    vm.editPayment = function () {
      mapWithPaymentResponse();
      forUpdate = true;
      vm.step = "pay";
    };

   vm.signPayment = function (){
     if (vm.confirmationInProgress) return;
     vm.confirmationInProgress = true;
      $http.post(vm.paymentResponse.linkList.itemList.sign, vm.paymentResponse)
        .then(function(response){
          $state.go("payments.finalStep", {paymentObject: response.data, paymentId: response.data.id, type: 'einvoice'});
         })
        .catch(function (error) {
          HelperService.showMessage(error.data, 'error');
      }).finally(function () {
        vm.confirmationInProgress = false;
      });

       // PaymentsService.signPayment(vm.paymentResponse.id)
       // .then(function (response) {
       //   vm.step = "final";
       // })
       // .catch(function (error) {
       // HelperService.showMessage(error, 'error');
       // });
     };

    /*    vm.showSMSAuthentification = function () {
     vm.smsAuthentificate = !vm.smsAuthentificate;
     };*/

    init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name eInvoices.controller:EinvoicesOverviewCtrl
   *
   * @description
   *
   */
  EinvoicesOverviewCtrl.$inject = ["$scope", "$state", "$rootScope", "EInvoiceDocumentsService", "EinvoiceSubscriptionsService", "$log", "$translate", "HelperService", "$timeout", "EinvoicesIssuersOverviewService", "CTLocalizationService", "AlertService", "GoogleTagManagerHelperService", "EGeneralDocumentsService"];
  angular
    .module('eInvoices')
    .controller('EinvoicesOverviewCtrl', EinvoicesOverviewCtrl);

  function EinvoicesOverviewCtrl($scope, $state, $rootScope, EInvoiceDocumentsService, EinvoiceSubscriptionsService, $log, $translate,
                                 HelperService, $timeout, EinvoicesIssuersOverviewService,
                                 CTLocalizationService, AlertService, GoogleTagManagerHelperService, EGeneralDocumentsService) {
    var vm = this;
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
    vm.loadMoreEinvoicesFirstTab = loadMoreEinvoicesFirstTab;
    vm.loadMoreEinvoicesSecondTab = loadMoreEinvoicesSecondTab;
    vm.pay = pay;
    vm.registerIssuer = registerIssuer;

    vm.ctrlName = 'EinvoicesOverviewCtrl';
    vm.einvoicesListFirstTab = {};
    vm.einvoicesListSecondTab = {};
    vm.registrationsListActive = {};
    vm.registrationsListCancelled = {};
    vm.documentsListTab = {};

    vm.showSubmenuItemType = 'unpaidTab';

    vm.einvoicesFilterToPay = {};
    vm.processedRegsFilterList = [];
    vm.einvoicesFilterArchived = {
      page: 0,
      statusList: ['Archived', 'Processed', 'Rejected', 'PaidByOtherMeans', 'PaymentWithDirectDebit',
        'PaymentNotPossible', 'Withdrawn', 'InProgressByOther', 'Cancelled'],
      orderBy: 'valueDate DESC',
      pageSize: 10
    };

    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
      vm.einvoicesFilterArchived.statusList = ['Processed'];
    }


    vm.einvoicesPeriod = {};
    vm.registrationsFilterCancelled = {};

    vm.archiveObj = {
      archiveCtnOpened: false,
      userComment: ''
    };
    vm.issuers = [];
    vm.registrationDetails = [];

    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
      vm.processedFilterList = [
        {
          item: {
            key: 'processed',
            description: 'eInvoicesModal.processed'
          }
        },
        {
          item: {
            key: 'archived',
            description: 'eInvoicesModal.archived'
          }
        },
        {
          item: {
            key: 'rejected',
            description: 'eInvoicesModal.rejected'
          }
        }
      ];
    } else {
      vm.processedFilterList = [
        {
          item: {
            key: 'all',
            description: 'core.period.all'
          }
        },
        {
          item: {
            key: 'processed',
            description: 'eInvoicesModal.processed'
          }
        },
        {
          item: {
            key: 'cancelled',
            description: 'eInvoiceStatus.Cancelled'
          }
        },
        // {
        //   item: {
        //     key: 'archived',
        //     description: 'eInvoicesModal.archived'
        //   }
        // },
        {
          item: {
            key: 'rejected',
            description: 'eInvoicesModal.rejected'
          }
        },
        {
          item: {
            key: 'PaymentNotPossible',
            description: 'eInvoicesModal.paymentNotPossible'
          }
        },
        {
          item: {
            key: 'PaidByOtherMeans',
            description: 'eInvoicesModal.paidByOtherMeans'
          }
        },
        {
          item: {
            key: 'PaymentWithDirectDebit',
            description: 'eInvoicesModal.paymentWithDirectDebit'
          }
        },
        {
          item: {
            key: 'Withdrawn',
            description: 'eInvoicesModal.withdrawn'
          }
        },
        // {
        //   item: {
        //     key: 'Reviewed',
        //     description: 'eInvoicesModal.reviewed'
        //   }
        // },
        {
          item: {
            key: 'InProgressByOther',
            description: 'eInvoicesModal.inProgressByOther'
          }
        }
      ];
    }

    vm.processedFilter = vm.processedFilterList[0];

    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      }
      , {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }
      , {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }
      , {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }
      , {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
      , {
        item: {
          key: 'all',
          description: 'core.period.all'
        }
      }
    ];
    vm.einvoicesPeriod = vm.periodList[2];

    ///registrations
    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl') {
      vm.processedRegsFilterList.push(
        {
          item: {
            key: 'registered',
            description: 'eInvoiceRegistration.registered'
          }
        },
        {
          item: {
            key: 'inProcess',
            description: 'eInvoiceRegistration.inProcess'
          }
        },
        {
          item: {
            key: 'rejected',
            description: 'eInvoiceRegistration.rejected'
          }
        },
        {
          item: {
            key: 'unregistered',
            description: 'eInvoiceRegistration.unregistered'
          }
        }
      );

    }

    vm.registrationsFilterActive = {
      page: 0,
      serviceState: 'Registered',
      pageSize: 10,
      orderBy: 'issuerServiceName asc'
    };

    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
      vm.registrationsFilterActive.includeList = ["EInvoiceIssuer"];
    }

    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
      vm.processedRegsFilterList.push(
        {
          item: {
            key: '',
            description: 'eInvoiceRegistration.all'
          }
        },
        {
          item: {
            key: 'registered',
            description: 'eInvoiceRegistration.registered'
          }
        },
        {
          item: {
            key: 'inProcess',
            description: 'eInvoiceRegistration.inProcessSlo'
          }
        },
        {
          item: {
            key: 'delivered',
            description: 'eInvoiceRegistration.delivered'
          }
        },
        {
          item: {
            key: 'undelivered',
            description: 'eInvoiceRegistration.undelivered'
          }
        },
        {
          item: {
            key: 'rejected',
            description: 'eInvoiceRegistration.rejectedSlo'
          }
        }
      );

      vm.registrationsFilterActive = {
        page: 0,
        pageSize: 10,
        orderBy: 'acceptedDate desc'
      };
    }
    vm.processedRegsFilter = vm.processedRegsFilterList[0];

    function loadMoreEinvoicesFirstTab(reset) {
      vm.einvoicesFilterToPay = {
        page: 0,
        statusList: ['Inserted', 'InProgress'],
        orderBy: 'valueDate DESC',
        pageSize: 10
      };
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        vm.einvoicesFilterToPay.statusList.push("Reviewed");
      }
      getEinvoices(vm.einvoicesFilterToPay, reset, 'einvoicesListFirstTab');
    }

    function loadMoreEinvoicesSecondTab(reset) {
      getEinvoices(vm.einvoicesFilterArchived, reset, 'einvoicesListSecondTab');
    }

    vm.loadMoreEinvoicesThirdTab = function (reset) {
      var filter = vm.registrationsFilterActive;
      if (reset) {
        filter.page = 0;
      } else {
        filter.page += 1;
      }

      getFilteredSubscriptions(filter, 'registrationsListActive', reset);
    };


    function loadEinvoicesOnTabChange() {
      // Invoices with status: Inserted, InProgress
      vm.einvoicesFilterToPay = {
        page: 0,
        statusList: ['Inserted', 'InProgress'],
        orderBy: 'valueDate DESC',
        pageSize: 10
      };
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        vm.einvoicesFilterToPay.statusList.push("Reviewed");
      }

      getFilteredEInvoices(vm.einvoicesFilterToPay, vm.einvoicesPeriod, 'einvoicesListFirstTab');
      // getFilteredEInvoices(vm.einvoicesFilterArchived, vm.einvoicesPeriod, 'einvoicesListSecondTab');
    }

    function getEinvoices(filter, reset, tab) {
      if (reset) {
        filter.page = 0;
      } else {
        filter.page += 1;
      }
      if (vm[tab].hasMore || filter.page === 0) {
        EInvoiceDocumentsService.getEinvoicesPageByFilter(filter)
          .then(function (response) {
            if (reset) {
              vm[tab] = response;
            } else {
              vm[tab].hasMore = response.hasMore;
              vm[tab].result = vm[tab].result.concat(response.result);
            }
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    }

    function getFilteredEInvoices(filter, item, tab) {
      vm.einvoicesPeriod = item;
      getEinvoices(filter, true, tab);
    }

    //get issuers for registration details
    function getIssuers() {
      var filter = {
        page: 0,
        pageSize: 10,
        orderBy: 'name asc'
      };

      return EinvoicesIssuersOverviewService.getPage(filter)
        .then(function (response) {
          vm.issuers = response.result;
          $log.debug("list", vm.einvoicesIssuersList);
        });
    }

    function getFilteredSubscriptions(filter, tab, reset) {
      if (reset) {
        filter.page = 0;
      }
      EinvoiceSubscriptionsService.getPage(filter)
        .then(function (response) {
          ///obtain IBAN for GUI
          if (vm.issuers.length > 0 && $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != "sl") {
            _.forEach(response.result, function (item) {
              for (var i = 0; i < vm.issuers.length; i++) {
                if (item.issuerId === vm.issuers[i].id)
                  item.iban = vm.issuers[i].iban;
              }
            });
          }

          if (reset) {
            vm[tab] = response;
          } else {
            vm[tab].hasMore = response.hasMore;
            vm[tab].result = vm[tab].result.concat(response.result);
          }

          //vm[tab] = response;
          //  filterRegistrationsByPeriod(response);
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    var filterRegistrationsByPeriod = function (filter, item, tab) {
      vm.processedRegsFilter = item;
      getFilteredSubscriptions(filter, tab, true);
    };

    function loadRegsitrations(filter) {
      if (vm.countryCode != 'sl')
        getIssuers();
      // Active registrations
      vm.registrationsFilterActive = filter;

      getFilteredSubscriptions(vm.registrationsFilterActive, 'registrationsListActive', true);

    }

    function pay(eInvoice, $event) {
      $event.stopPropagation();
      $state.go('eInvoices.pay', {eInvoiceId: eInvoice.id});
    }

    function registerIssuer() {
      GoogleTagManagerHelperService.pushEvent('EInvoices Overview', 'Register/Deregister issuer', 'Clicked');
      $state.go('eInvoices.einvoicesRegisterNew');
    }


    vm.archiveEInvoice = function (eInvoice) {
      var id = eInvoice.id;
      if (eInvoice.archiveEInvoiceInProgress) return;
      eInvoice.archiveEInvoiceInProgress = true;
      if (vm.countryCode === 'sl') {
        AlertService.eInvoiceArchiveAlert({
          text: "payments.paymentDueDateChangedMsg"
        })
          .then(function (accept) {
            if (!accept) {
              eInvoice.archiveEInvoiceInProgress = false;
              return;
            }
            EInvoiceDocumentsService.archiveEInvoice(id, vm.archiveObj.userComment)
              .then(function (response) {
                vm.archiveObj.archiveCtnOpened = false;
                //$translate('eInvoiceOverview.successfulyArchived').then(function (translation) {
                //  swal(translation);
                //});
                AlertService.infoAlert({
                  text: 'alert.archiveEInvoice'
                })
                  .then(function () {
                    loadMoreEinvoicesFirstTab(true);
                    loadMoreEinvoicesSecondTab(true)
                  })
              })
              .catch(function (error) {
                eInvoice.archiveEInvoiceInProgress = false;
                HelperService.showMessage(error, 'error');
              });
          })
      } else {
        EInvoiceDocumentsService.archiveEInvoice(id, vm.archiveObj.userComment)
          .then(function (response) {
            vm.archiveObj.archiveCtnOpened = false;
            //$translate('eInvoiceOverview.successfulyArchived').then(function (translation) {
            //  swal(translation);
            //});
            AlertService.infoAlert({
              text: 'alert.archiveEInvoice'
            })
              .then(function () {
                loadMoreEinvoicesFirstTab(true);
                loadMoreEinvoicesSecondTab(true)
              })
          })
          .catch(function (error) {
            eInvoice.archiveEInvoiceInProgress = false;
            HelperService.showMessage(error, 'error');
          });
      }
    };

    var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    $rootScope.$on('appLanguageChangedHeader', function () {
      sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
    });

    vm.cancelRegistration = function (registration) {

      AlertService.confirmationAlert()
        .then(function (result) {
          registration.cancelInProgress = true;
          if (result) {
            EinvoiceSubscriptionsService.updateInvoiceSubscription(registration.id, {"unRegisterIssuer": true})
              .then(function (response) {
                AlertService.infoAlert({
                  text: 'alert.cancelRegistration'
                })
                  .then(function () {
                    registration.cancelInProgress = false;
                    getFilteredSubscriptions(vm.registrationsFilterActive, 'registrationsListActive', true);
                    getFilteredSubscriptions(vm.registrationsFilterCancelled, 'registrationsListCancelled', true);
                  });
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });

    };

    vm.processedFilterChange = function (filter) {
      vm.processedFilter = filter;
      switch (filter.item.key) {
        case 'processed':
          vm.einvoicesFilterArchived.statusList = ['Processed'];
          break;
        case 'archived':
          vm.einvoicesFilterArchived.statusList = ['Archived'];
          break;
        case 'rejected':
          vm.einvoicesFilterArchived.statusList = ['Rejected'];
          break;
        case 'PaymentNotPossible':
          vm.einvoicesFilterArchived.statusList = ['PaymentNotPossible'];
          break;
        case 'PaidByOtherMeans':
          vm.einvoicesFilterArchived.statusList = ['PaidByOtherMeans'];
          break;
        case 'PaymentWithDirectDebit':
          vm.einvoicesFilterArchived.statusList = ['PaymentWithDirectDebit'];
          break;
        case 'Withdrawn':
          vm.einvoicesFilterArchived.statusList = ['Withdrawn'];
          break;
        // case 'Reviewed':
        //   vm.einvoicesFilterArchived.statusList = ['Reviewed'];
        //   break;
        case 'InProgressByOther':
          vm.einvoicesFilterArchived.statusList = ['InProgressByOther'];
          break;
        case 'cancelled':
          vm.einvoicesFilterArchived.statusList = ['Cancelled'];
          break;
        case 'all':
          vm.einvoicesFilterArchived.statusList = ['Archived', 'Processed', 'Rejected', 'PaidByOtherMeans', 'PaymentWithDirectDebit', 'PaymentNotPossible', 'Withdrawn', 'InProgressByOther', 'Cancelled'];
          break;
      }
      getFilteredEInvoices(vm.einvoicesFilterArchived, vm.einvoicesPeriod, 'einvoicesListSecondTab');
    };

    vm.processedRegsFilterChange = function (filter) {
      vm.processedRegsFilter = filter;
      switch (filter.item.key) {
        case 'inProcess':
          vm.registrationsFilterActive.serviceState = 'InProcess';
          break;
        case 'registered':
          vm.registrationsFilterActive.serviceState = 'Registered';
          break;
        case 'unregistered':
          vm.registrationsFilterActive.serviceState = 'Unregistered';
          break;
        case 'rejected':
          vm.registrationsFilterActive.serviceState = 'Rejected';
          break;
        case 'delivered':
          vm.registrationsFilterActive.serviceState = 'Delivered';
          break;
        case 'undelivered':
          vm.registrationsFilterActive.serviceState = 'Undelivered';
          break;
        case 'sent':
          vm.registrationsFilterActive.serviceState = 'Sent';
          break;
        default:
          vm.registrationsFilterActive.serviceState = null;
          break;
      }
      getFilteredSubscriptions(vm.registrationsFilterActive, 'registrationsListActive', true);
    };

    vm.registerAgain = function (registration) {
      $state.go('eInvoices.einvoicesRegisterNew', {myParam: registration});
    };

    vm.withdrawEInvoice = function () {
      var message = $translate.instant('core.notImplemented');
      HelperService.showTranslatedMessage('error', message, '', 3000);
    };

    vm.toggleArchiveContainer = function () {
      vm.archiveObj.archiveCtnOpened = !vm.archiveObj.archiveCtnOpened;
      vm.archiveObj.userComment = '';
    };

    vm.showEInvoiceDetails = function (eInvoice) {
      if (!eInvoice.isCollapsed1) {
        EInvoiceDocumentsService.getById(eInvoice.id, {includeList: "EInvoiceDocumentDigitalSignaturesAdded"})
          .then(function (response) {
            eInvoice.isCollapsed1 = !eInvoice.isCollapsed1;
            vm.archiveObj.archiveCtnOpened = false;
            angular.extend(eInvoice, response);
            console.log(eInvoice);
          })
      } else {
        eInvoice.isCollapsed1 = !eInvoice.isCollapsed1;
      }

    };

    vm.init = function () {

      vm.einvoicesPeriod = {
        item: {
          key: 'thisYear'
        }
      };
      // loadRegsitrations(vm.registrationsFilterActive);
      if ($state.params.tabToSelect) {
        //vm.showSubmenuItemType = 'listTab';
        vm.selectTab('listTab', 'eInvoiceRegistration.listOfRegistrations');
      }else{
        loadEinvoicesOnTabChange();
      }
    };

    vm.openEInvoicesModal = function (eInvoice) {
      EInvoiceDocumentsService.openModal(eInvoice);
    };

    vm.downloadPdf = function (id) {
      if (vm.downloadButtonPressed) return;
      $log.debug("EInvoice Id: ", id);
      vm.downloadButtonPressed = true;
      EInvoiceDocumentsService.downloadLink(id)
        .then(function () {

        })
        .finally(function () {
          vm.downloadButtonPressed = false;
        });
    };

    vm.downloadDocumentPdf = function (id, childId) {
      if (vm.downloadButtonPressed) return;
      vm.downloadButtonPressed = true;

      EGeneralDocumentsService.downloadDocumentPdf(id, childId)
        .then(function () {
        })
        .finally(function () {
          vm.downloadButtonPressed = false;
        });
    };

    vm.selectTab = function (show, translateLabel) {
      if (show === vm.showSubmenuItemType) return;

      if (show === 'unpaidTab') {
        vm.showSubmenuItemType = 'unpaidTab';
        getFilteredEInvoices(vm.einvoicesFilterToPay, vm.einvoicesPeriod, 'einvoicesListFirstTab');
      } else if (show === 'processedTab') {
        vm.showSubmenuItemType = 'processedTab';
        getFilteredEInvoices(vm.einvoicesFilterArchived, vm.einvoicesPeriod, 'einvoicesListSecondTab');
      } else if (show === 'listTab') {
        vm.showSubmenuItemType = 'listTab';
        loadRegsitrations(vm.registrationsFilterActive);
      } else if (show === 'documentsTab') {
        vm.showSubmenuItemType = 'documentsTab';
        vm.loadMoreEInvoicesFourthTab(true);
      }


      GoogleTagManagerHelperService.pushEvent('EInvoices Overview', 'Tab', $translate.instant(translateLabel));

    };

    vm.reject = function (item, $event) {
      $event.stopPropagation();
      AlertService.showRejectEDocumentWarning()
        .then(function (text) {
          if (text) {

            EGeneralDocumentsService.rejectEDocument(item.id, text)
              .then(function (response) {
                //HelperService.showMessage(error, 'success');
                if (vm.showSubmenuItemType === 'documentType')
                  loadMoreEInvoicesFourthTab(true);
                if (vm.showSubmenuItemType === 'unpaidTab')
                  loadMoreEinvoicesFirstTab(true);
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');

              })
          }
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };

    // -------------------------
    // FOURTH TAB OPTIONS START
    // -------------------------

    vm.searchEDocumentToPay = {
      creditorName: ''
    };

    vm.archiveEDocument = function (eDocument) {
      var id = eDocument.id;
      if (eDocument.archiveEInvoiceInProgress) return;
      eDocument.archiveEInvoiceInProgress = true;

      AlertService.eInvoiceArchiveAlert({
        text: "payments.paymentDueDateChangedMsg"
      })
        .then(function (accept) {
          if (!accept) {
            eDocument.archiveEInvoiceInProgress = false;
            return;
          }
          EGeneralDocumentsService.archiveEDocument(id, vm.archiveObj.userComment)
            .then(function (response) {
              vm.archiveObj.archiveCtnOpened = false;

              AlertService.infoAlert({
                text: 'alert.archiveEInvoice'
              })
                .then(function () {
                  loadMoreEinvoicesFirstTab(true);
                  loadMoreEinvoicesSecondTab(true)
                })
            })
            .catch(function (error) {
              eDocument.archiveEInvoiceInProgress = false;
              HelperService.showMessage(error, 'error');
            });
        })
    };

    vm.showEDocumentDetails = function (eInvoice) {
      if (!eInvoice.isCollapsed1) {
        EGeneralDocumentsService.getById(eInvoice.id, {includeList: "EInvoiceDocumentAttachmentList"})
          .then(function (response) {
            eInvoice.isCollapsed1 = !eInvoice.isCollapsed1;
            vm.archiveObj.archiveCtnOpened = false;
            angular.extend(eInvoice, response);
            console.log(eInvoice);
          })
      } else {
        eInvoice.isCollapsed1 = !eInvoice.isCollapsed1;
      }

    };

    vm.documentsFilterActive = {
      page: 0,
      pageSize: 10,
      orderBy: 'postedDate desc'
    };

    vm.loadMoreEInvoicesFourthTab = function (reset) {
      var filter = vm.documentsFilterActive;
      if (reset) {
        filter.page = 0;
      } else {
        filter.page += 1;
      }
      EGeneralDocumentsService.getPage(filter)
        .then(function (response) {

          if (reset) {
            vm.documentsListTab = response;
          } else {
            vm.documentsListTab.hasMore = response.hasMore;
            vm.documentsListTab.result = vm.documentsListTab.result.concat(response.result);
          }

        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    };

    // -------------------------
    // FOURTH TAB OPTIONS END
    // -------------------------


    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name eInvoices.factory:EinvoicesIssuersOverviewService
   *
   * @description
   *
   */
  EinvoicesIssuersOverviewService.$inject = ["EndpointsService", "$http", "$q"];
  angular
    .module('eInvoices')
    .factory('EinvoicesIssuersOverviewService', EinvoicesIssuersOverviewService);

  function EinvoicesIssuersOverviewService(EndpointsService, $http, $q) {
    var EinvoicesIssuersOverviewServiceBase = {};


    EinvoicesIssuersOverviewServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.eInvoiceIssuers, {
          params: params
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EinvoicesIssuersOverviewServiceBase.getById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.eInvoiceIssuers_id.replace('{id}', id))
          .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return EinvoicesIssuersOverviewServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name eInvoices.controller:EinvoicesIssuersOverviewCtrl
   *
   * @description
   *
   */
  EinvoicesIssuersOverviewCtrl.$inject = ["$state", "EinvoicesIssuersOverviewService", "$log"];
  angular
    .module('eInvoices')
    .controller('EinvoicesIssuersOverviewCtrl', EinvoicesIssuersOverviewCtrl);

  function EinvoicesIssuersOverviewCtrl($state, EinvoicesIssuersOverviewService, $log) {
    var vm = this;
    vm.ctrlName = 'EinvoicesIssuersOverviewCtrl';

    vm.goBack = function () {
      $state.go('eInvoices.einvoicesOverview');
    };

    vm.einvoicesIssuersSearchFilter = {
      searchByName: '',
      searchById: ''
    }


    vm.einvoicesIssuersList = {};
    vm.einvoicesFilter = {
      page: 0,
      pageSize: 1000
    };

    vm.loadMoreIssuers = function () {
      vm.getEinvoicesIssuers(false);
    };

    vm.init = function () {
      vm.getEinvoicesIssuers(true);
    };

    vm.getEinvoicesIssuers = function (reset) {
      if (reset) {
        vm.einvoicesFilter.page = 0;
      } else {
        vm.einvoicesFilter.page += 1;
      }
      EinvoicesIssuersOverviewService.getPage(vm.einvoicesFilter)
        .then(function (response) {
        if (!reset) {
          vm.einvoicesIssuersList.hasMore = response.hasMore;
          vm.einvoicesIssuersList.result = vm.einvoicesIssuersList.result.concat(response.result);
        } else {
          vm.einvoicesIssuersList = response;
        }
        $log.debug("list", vm.einvoicesIssuersList);
      })
    };



    vm.init();
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name eInvoices.controller:EinvoicesArchiveCtrl
     *
     * @description
     *
     */
    EInvoicesArchiveCtrl.$inject = ["$state", "EInvoiceDocumentsService", "$log", "$translate", "HelperService", "$scope"];
    angular
        .module('eInvoices')
        .controller('EInvoicesArchiveCtrl', EInvoicesArchiveCtrl);

    function EInvoicesArchiveCtrl($state, EInvoiceDocumentsService, $log, $translate, HelperService, $scope) {
        var vm = this;
        vm.goBack = goBack;

        vm.ctrlName = 'EinvoicesArchiveCtrl';

        init();


        function init() {

        }

        function goBack() {
            $state.go('eInvoices');
        }

    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name eInvoices.factory:EinvoiceSubscriptionsService
   *
   * @description
   *
   */
  EinvoiceSubscriptionsService.$inject = ["$rootScope", "$sessionStorage", "$http", "$q", "EndpointsService", "SessionService"];
  angular
    .module('eInvoices')
    .factory('EinvoiceSubscriptionsService', EinvoiceSubscriptionsService);

  function EinvoiceSubscriptionsService($rootScope, $sessionStorage, $http, $q, EndpointsService, SessionService) {
    var EinvoiceSubscriptionsServiceBase = {};
    EinvoiceSubscriptionsServiceBase.someValue = 'EinvoiceSubscriptionsService';
    EinvoiceSubscriptionsServiceBase.someMethod = function () {
      return 'EinvoiceSubscriptionsService';
    };

    if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'einvoice'){
      insert($sessionStorage.paymentStorageObject.object);
    }

    EinvoiceSubscriptionsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.eInvoiceSubscriptions, {
          params: params
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EinvoiceSubscriptionsServiceBase.getById = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.eInvoiceSubscriptions_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
            deferred.reject(msg);
          });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    function insert(subscriptionObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          SessionService.saveStorageObject(subscriptionObject, 'einvoice');
          $http.post(response.links.eInvoiceSubscriptions, subscriptionObject)
            .success(function (data) {
              $rootScope.$broadcast("eInvoiceSubAdded");
              SessionService.removeStorageObject();
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    EinvoiceSubscriptionsServiceBase.insertSubscriptionRequest = function (subscriptionObject) {
      return insert(subscriptionObject);
    };

    EinvoiceSubscriptionsServiceBase.updateInvoiceSubscription = function (id, data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.eInvoiceSubscriptions_id.replace('{id}', id), data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EinvoiceSubscriptionsServiceBase.updateInvoiceEmail = function (email) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.eInvoiceSubscriptions_updateInvoiceEmail, email)
          .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      },
      function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    EinvoiceSubscriptionsServiceBase.validateSubscriptionRequest = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.eInvoiceSubscriptions_validate, data)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return EinvoiceSubscriptionsServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name eInvoices.controller:EinvoiceSubscribeCtrl
   *
   * @description
   *
   */
  EinvoiceSubscribeCtrl.$inject = ["$state", "$log", "EinvoicesIssuersOverviewService", "UserSettingsService", "HelperService", "EinvoiceSubscriptionsService"];
  angular
    .module('eInvoices')
    .controller('EinvoiceSubscribeCtrl', EinvoiceSubscribeCtrl);

  function EinvoiceSubscribeCtrl($state, $log, EinvoicesIssuersOverviewService, UserSettingsService, HelperService, EinvoiceSubscriptionsService) {
    var vm = this;
    vm.ctrlName = 'EinvoiceSubscribeCtrl';
    vm.issuerObject = {};
    vm.userSettings = {};
    vm.subscriptionObjectList = {};
    vm.subscriptionObject = {};

    vm.tempObj = {
      einvoiceSubscribeEmailInput: '',
      einvoiceReferenceFromIssuerInput: null,
      userApproves: false,
      formSubmitted: false
    }
    vm.originalEmail = '';
    vm.changeEmailButton = true;
    vm.goBack = function () {
      $state.go('eInvoices.einvoicesIssuersOverview');
    };

    vm.specialConditionsApprovement = false;
    vm.specialConditionsApprovementVisible = false;

    vm.customErrorLabels = [];
    vm.steps = {
      step1: true,
      step2: false,
      step3: false
    };

    vm.init = function () {
      $log.debug('Issuer detail init()');
      if ($state.params.issuerId) {
        vm.getUserSettingsPage();
        vm.getIssuerById($state.params.issuerId);
        vm.getSubscriptionsPage();
      }
    };

    vm.getIssuerById = function (id) {
      EinvoicesIssuersOverviewService.getById(id)
        .then(function (response) {
          vm.issuerObject = response;
        })
        .catch(function (error) {
          $log.debug("error", error);
        });
    };

    vm.subscriptionsFilter = {
      page: 0,
      pageSize: 1000
    };

    vm.getSubscriptionsPage = function () {
      EinvoiceSubscriptionsService.getPage(vm.subscriptionsFilter)
        .then(function (response) {
          vm.subscriptionObjectList = response;
          if (vm.subscriptionObjectList.result.length > 0) {
            for (var i = 0; i < vm.subscriptionObjectList.result.length; i++) {
              if (vm.subscriptionObjectList.result[i].issuerId == vm.issuerObject.id)
                vm.subscriptionObject = vm.subscriptionObjectList.result[i];
              $log.debug("subscribe object", JSON.stringify(vm.subscriptionObject));
            }
          }
        })
        .catch(function (error) {
          $log.debug("error", error);
        });
    };

    var createRequestObject = function () {
      return {
        requestType: vm.subscriptionObject.settingType,
        paymentReferenceNumber: vm.tempObj.einvoiceReferenceFromIssuerInput,
        issuerId: vm.issuerObject.id,
        userServiceId: vm.tempObj.einvoiceReferenceFromIssuerInput,
        serviceType: vm.subscriptionObject.serviceType,
        serviceState: vm.subscriptionObject.serviceState,
        services: null,
        userApproves: vm.tempObj.userApproves
      }
    };

    vm.einvoiceSubscribeSubmit = function () {
      vm.tempObj.formSubmitted = true;

      if (!vm.einvoiceSubscribeForm.$valid) {
        return;
      }
      var eInvoiceSubscriptionInsertRequestObject = createRequestObject();
      EinvoiceSubscriptionsService.insertSubscriptionRequest(eInvoiceSubscriptionInsertRequestObject)
        .then(function (response) {
          vm.subscriptionResponse = response;
          //swal("Success!");
          $log.debug("Subscription response object:", response);
          vm.steps = {
            step1: false,
            step2: true,
            step3: false
          };
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
          $log.error("Subscription error:", error);
        });
    };

    vm.userSettingsFilter = {
      page: 0,
      pageSize: 1
    };

    vm.getUserSettingsPage = function () {
      UserSettingsService.getPage(vm.userSettingsFilter)
        .then(function (response) {
          vm.userSettings = response;
          vm.tempObj.einvoiceSubscribeEmailInput = response.result[0].eInvoiceEmail;
          vm.originalEmail = response.result[0].eInvoiceEmail;
          $log.debug("userSettings", vm.userSettings);
        }).catch(function (error) {
          $log.error(error);
        });
    };

    vm.changeEmail = function () {
      vm.changeEmailButton = false;
    };
    vm.changeEmailOk = function () {
      if (vm.tempObj.einvoiceSubscribeEmailInput != vm.originalEmail) {
        var email = {
          invoicingEmail: vm.tempObj.einvoiceSubscribeEmailInput
        };

        EinvoiceSubscriptionsService.updateInvoiceEmail(email)
        .then(function (response) {
          $log.debug("einvoiceMail", response);
          $log.debug("mail", email);

        }).catch(function (error) {
          $log.error(error);
        });
      }
      vm.changeEmailButton = true;
    };
    vm.changeEmailCancel = function () {
      vm.changeEmailButton = true;
      vm.tempObj.einvoiceSubscribeEmailInput = vm.originalEmail;
    }


    vm.init();
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('eInvoices')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('eInvoices', {
      url: '/e-invoices'
      // templateUrl: 'e-invoices/e-invoices.tpl.html',
      // controller: 'EInvoicesCtrl',
      // controllerAs: 'eInvoices'
    })
      .state('eInvoices.detail', {
      url: '/detail/:eInvoiceId',
      views: {
        '@': {
          templateUrl: 'e-invoices/e-invoices-detail.tpl.html',
          controller: 'EInvoicesDetailCtrl',
          controllerAs: 'eInvoicesDetail'
        }
      }
    })
      .state('eInvoices.einvoicesOverview', {
      url: '/overview',
        params: {
          tabToSelect: null
        },
      views: {
        '@': {
          templateUrl: 'e-invoices/einvoices-overview.tpl.html',
          controller: 'EinvoicesOverviewCtrl',
          controllerAs: 'einvoicesOverview'
        }
      }
    }).state('eInvoices.einvoicesIssuersOverview', {
      url: '/issuers-overview',
      views: {
        '@': {
          templateUrl: 'e-invoices/einvoices-issuers-overview.tpl.html',
          controller: 'EinvoicesIssuersOverviewCtrl',
          controllerAs: 'einvoicesIssuersOverview'
        }
      }
    }).state('eInvoices.einvoiceSubscribe', {
      url: '/subscribe/:issuerId',
      views: {
        '@': {
          templateUrl: 'e-invoices/einvoice-subscribe.tpl.html',
          controller: 'EinvoiceSubscribeCtrl',
          controllerAs: 'einvoiceSubscribe'
        }
      }
    }).state('eInvoices.einvoicesRegisterNew', {
      url: '/register',
      params: {
        myParam: {}
      },
      views: {
        '@': {
          templateUrl: 'e-invoices/einvoices-register.tpl.html',
          controller: 'EinvoicesRegisterCtrl',
          controllerAs: 'vm'
        }
      }
    }).state('eInvoices.archive', {
      url: '/archive/:eInvoiceId',
      views: {
        '@': {
          templateUrl: 'e-invoices/e-invoice-archive.tpl.html',
          controller: 'EInvoicesArchiveCtrl',
          controllerAs: 'eInvoicesArchive'
        }
      }
    }).state('eInvoices.pay', {
      url: '/pay/:eInvoiceId',
      views: {
        '@': {
          templateUrl: 'e-invoices/e-invoices-pay.tpl.html',
          controller: 'EinvoicesPayCtrl',
          controllerAs: 'vm'
        }
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name eInvoices.controller:EInvoicesModalCtrl
   *
   * @description
   *
   */
  EInvoicesModalCtrl.$inject = ["eInvoice", "$uibModalInstance", "$log", "$state", "HelperService", "PaymentsService", "PaymentTypesService", "$filter"];
  angular
    .module('eInvoices')
    .controller('EInvoicesModalCtrl', EInvoicesModalCtrl);

  function EInvoicesModalCtrl(eInvoice, $uibModalInstance, $log, $state, HelperService, PaymentsService, PaymentTypesService, $filter) {
    var vm = this;
    vm.paymentDateOption = {};
    vm.eInvoiceObject = eInvoice;
    vm.datePickerOpened = false;
    vm.signSuccess = false;
    vm.dateOptions = {
      minDate: new Date(),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };
    vm.goBack = function () {
      vm.signSuccess = false;
    };

    vm.openDatePicker = function () {
      vm.datePickerOpened = true;
    };

    vm.goToEInvoiceDetail = function () {
      vm.closeModal();
      $state.go('eInvoices.detail', {
        eInvoiceId: vm.eInvoiceObject.id
      });
    };


    vm.tempDompObj = {
      fromAccountSelect: {},
      //fromAccountSelect: 'HR6725000093200408415',
      amount: vm.eInvoiceObject.amount,
      dateInput: new Date(),
      purposeCodeSelect: 'ACCT',
      toAccountInput: 'HR2325000091501135368',
      referenceCodeInput: 'HRK',
      referenceModel: 'HR',
      referenceNumber: '99',
    };

    vm.paymentTypeGroupDomestic = {};
    vm.paymentTypesGroupFilter = {
      paymentTypeGroup: 'DomesticPayment'
    };
    vm.fromAccountNumber = {};

    vm.getPaymentTypeGroup = function () {
      PaymentTypesService.getByGroup(vm.paymentTypesGroupFilter)
        .then(function (response) {
        vm.paymentTypeGroupDomestic = response;
          $log.debug("paymentTypeGroupDomestic", vm.paymentTypeGroupDomestic);

          if (vm.paymentTypeGroupDomestic.result[0].debitAccountList.length > 0) {

            _.forEach(response.result[0].debitAccountList, function(value){
              value.optionValue = value.accountDescription + ' - ' + value.accountNumber;
            });

            vm.tempDompObj.fromAccountSelect = vm.paymentTypeGroupDomestic.result[0].debitAccountList[0];
          }
        })
        .catch(function () {
          $log.error('Error loading paymentTypeGroupDomestic!');
        });
    };

    vm.init = function () {
      vm.getPaymentTypeGroup();

    };
    vm.init();

    vm.paymentObject = {};
    var createPaymentObject = function () {

      vm.paymentObject.domesticPayment = {};
      vm.paymentObject.accountId = vm.tempDompObj.fromAccountSelect.accountId;
      vm.paymentObject.fromAccountNumber = vm.tempDompObj.fromAccountSelect.iban;
      vm.paymentObject.toAccountNumber = vm.tempDompObj.toAccountInput;
      vm.paymentObject.currencySymbol = vm.tempDompObj.fromAccountSelect.currencySymbol;
      vm.paymentObject.purpose = vm.eInvoiceObject.purpose;
      vm.paymentObject.amount = parseFloat(vm.tempDompObj.amount);
      vm.paymentObject.paymentTypeGroup = 'DomesticPayment';
      vm.paymentObject.purposeCodeDPS = vm.tempDompObj.purposeCodeSelect;
      vm.paymentObject.domesticPayment.receiverName = vm.eInvoiceObject.creditorName;
      vm.paymentObject.domesticPayment.receiverAddress1 = vm.eInvoiceObject.creditorAddress;
      vm.paymentObject.domesticPayment.receiverCity = vm.eInvoiceObject.creditorCity;
      vm.paymentObject.domesticPayment.referenceTo = vm.tempDompObj.referenceModel;
      vm.paymentObject.domesticPayment.referenceFrom = vm.tempDompObj.referenceNumber;

      if(vm.paymentDateOption.val==1 || vm.paymentDateOption.val==3) {
        vm.paymentObject.dueDate = vm.tempDompObj.dateInput;
      } else {
        vm.paymentObject.dueDate = vm.eInvoiceObject.valueDate;
      }

      return vm.paymentObject;

    };

    vm.paymentResponse = {};
    vm.executePayment = function () {

      PaymentsService.insertPayment(createPaymentObject())
        .then(function (response) {
        vm.paymentResponse = response;
        vm.signSuccess = true;
      })
        .catch(function (error) {
        errorFcn(error);
      });

      var errorFcn = function (error) {
        if (error && error.resultList && error.resultList.length > 0) {
          HelperService.showMessage(error, 'error');
        }
      };

      $log.debug("Temporary Domestic payment object: ", vm.tempDompObj);
    };

    vm.signPayment = function () {
      PaymentsService.signPayment(vm.paymentResponse.id)
        .then(function (response) {
       vm.closeModal();
        swal("Success!");
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name eInvoices.controller:EInvoicesDetailCtrl
   *
   * @description
   *
   */
  EInvoicesDetailCtrl.$inject = ["$state", "$log", "EInvoiceDocumentsService", "HelperService", "$translate"];
  angular
    .module('eInvoices')
    .controller('EInvoicesDetailCtrl', EInvoicesDetailCtrl);

  function EInvoicesDetailCtrl($state, $log, EInvoiceDocumentsService, HelperService,$translate) {
    var vm = this;
    vm.eInvoiceObject = {};
    vm.signatureDetail = false;
    //vm.translateName = 'eInvoiceDetail.showInfo';
    vm.init = function(){
      $log.debug('EInvoices detail init()');
      if($state.params.eInvoiceId){
        vm.getEInvoiceById($state.params.eInvoiceId);
      }
    }

    vm.getEInvoiceById = function (id) {
      EInvoiceDocumentsService.getById(id)
        .then(function (response) {
          if(response){
            vm.eInvoiceObject = response;
          }
        })
        .catch(function (error) {
          errorFcn(error);
        });
    };

    var errorFcn = function (error) {
      if (error && error.resultList && error.resultList.length > 0) {
        HelperService.showMessage(error, 'error');
      }
    };

    vm.openEInvoiceModal = function () {
      EInvoiceDocumentsService.openModal(vm.eInvoiceObject);
    };

    vm.toggleSignatureDetailView = function(){
      vm.signatureDetail = !vm.signatureDetail;
    };

    vm.goBack = function () {
      $state.go('eInvoices.einvoicesOverview');
    };

    vm.init();

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name eInvoices.factory:EInvoiceDocumentsService
   *
   * @description
   *
   */
  EInvoiceDocumentsService.$inject = ["EndpointsService", "$q", "$http", "$log", "$uibModal", "AlertService", "HelperService"];
  angular
    .module('eInvoices')
    .factory('EInvoiceDocumentsService', EInvoiceDocumentsService);

  function EInvoiceDocumentsService(EndpointsService, $q, $http, $log, $uibModal, AlertService, HelperService) {
    var EInvoiceDocumentsServiceBase = {};

    EInvoiceDocumentsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      //if(HelperService.isEndpointAvailable('eInvoiceDocuments')) {
        EndpointsService.getLinks().then(function (response) {
          if(response.links.eInvoiceDocuments){
            $http.get(response.links.eInvoiceDocuments, {
                params: params
              })
              .success(function (data) {
                deferred.resolve(data);
              }).error(function (msg, code) {
              deferred.reject(msg);
            });
          } else {
            deferred.resolve(null);
          }
        }, function (error) {
          deferred.reject(error);
        });
      //};
      return deferred.promise;
    };

    EInvoiceDocumentsServiceBase.openModal = function (eInvoice) {
      var modalInstance = $uibModal.open({
        templateUrl: 'e-invoices/e-invoices-modal.tpl.html',
        controller: 'EInvoicesModalCtrl',
        controllerAs: 'eInvoicesModal',
        resolve: {
          eInvoice: function () {
            return eInvoice;
          }
        },
        backdrop: 'static'
      });
    };

    EInvoiceDocumentsServiceBase.getById = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eInvoiceDocuments_id){
          $http.get(response.links.eInvoiceDocuments_id.replace('{id}', id), {params: params})
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(null);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EInvoiceDocumentsServiceBase.getEinvoicesPageByFilter = function (params) {
      return EInvoiceDocumentsServiceBase.getPage(params);
    };

    EInvoiceDocumentsServiceBase.getEinvoiceForPaymentById = function (einvoiceId) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.payments_forEInvoice_id.replace('{id}', einvoiceId))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
            deferred.reject(msg);
          });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EInvoiceDocumentsServiceBase.archiveEInvoice = function (id, comment) {
      var deferred = $q.defer();
      var params = {
        archiveEInvoicePayment: true,
        userComment: comment
      };
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eInvoiceDocuments_id){
          $http.put(response.links.eInvoiceDocuments_id.replace('{id}', id), params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(null);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EInvoiceDocumentsServiceBase.downloadLink = function (id) {
      var nonBlockingWindow = window.open('', '_self');
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eInvoiceDocuments_downloadLink_id){
          $http.get(response.links.eInvoiceDocuments_downloadLink_id.replace('{id}', id))
            .success(function (data) {
              if(data && data.url) {
                nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
              }
              deferred.resolve();
            }).error(function (msg, code) {
              AlertService.infoAlert({
                  text: 'eInvoiceDetail.noAttachments'
                });
            nonBlockingWindow.close();
            deferred.reject();
          });
        } else {
          nonBlockingWindow.close();
          deferred.resolve(null);
        }
      }, function (error) {
        nonBlockingWindow.close();
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return EInvoiceDocumentsServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name eInvoices.factory:EGeneralDocumentsService
   *
   * @description
   *
   */
  EGeneralDocumentsService.$inject = ["EndpointsService", "$q", "$http", "AlertService", "$sessionStorage", "HelperService"];
  angular
    .module('eInvoices')
    .factory('EGeneralDocumentsService', EGeneralDocumentsService);

  function EGeneralDocumentsService(EndpointsService,$q, $http, AlertService, $sessionStorage, HelperService) {
    var EGeneralDocumentsServiceBase = {};

    EGeneralDocumentsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eGeneralDocuments){
          $http.get(response.links.eGeneralDocuments, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(null);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    EGeneralDocumentsServiceBase.getById = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eGeneralDocuments_id){
          $http.get(response.links.eGeneralDocuments_id.replace('{id}', id), {params: params})
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(null);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    EGeneralDocumentsServiceBase.rejectEDocument = function (id, comment) {
      var deferred = $q.defer();
      var params = {
        acceptEGeneralDocument: false,
        rejectEGeneralDocument: true,
        userComment: comment
      };
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eGeneralDocuments_id){
          $http.put(response.links.eGeneralDocuments_id.replace('{id}', id), params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(null);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    EGeneralDocumentsServiceBase.archiveEDocument = function (id, comment) {
      var deferred = $q.defer();
      var params = {
        acceptEGeneralDocument: true,
        rejectEGeneralDocument: false,
        userComment: comment
      };
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eGeneralDocuments_id){
          $http.put(response.links.eGeneralDocuments_id.replace('{id}', id), params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(null);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    EGeneralDocumentsServiceBase.downloadDocumentPdf = function (id, childId) {
      var nonBlockingWindow = window.open('', '_self');
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        if(response.links.eGeneralDocuments){
          var fullUrl = response.links.eGeneralDocuments + '/downloadLink/' + id + '/attachment/' + childId;
          $http.get(fullUrl)
            .success(function (data) {
              if(data && data.url) {
                nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(data.url);
              }
              deferred.resolve();
            }).error(function (msg, code) {
            AlertService.infoAlert({
              text: 'eInvoiceDetail.noDocAttachments'
            });
            nonBlockingWindow.close();
            deferred.reject();
          });
        } else {
          nonBlockingWindow.close();
          deferred.resolve(null);
        }
      }, function (error) {
        nonBlockingWindow.close();
        deferred.reject(error);
      });
      return deferred.promise;
    };
    return EGeneralDocumentsServiceBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name documents
   * @description
   *
   */
  angular
    .module('documents', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name documents.factory:DocumentsService
   *
   * @description
   *
   */
  DocumentsService.$inject = ["$rootScope", "$http", "$q", "$log", "AlertService", "EndpointsService", "HelperService"];
  angular
    .module('documents')
    .factory('DocumentsService', DocumentsService);

  function DocumentsService($rootScope, $http, $q, $log, AlertService, EndpointsService, HelperService) {
    var DocumentsServiceBase = {};

    DocumentsServiceBase.getDocuments = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.documents, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            })
            .error(function (msg, code) {
              deferred.reject(msg)
            });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    DocumentsServiceBase.getDocumentPdfLink = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.documents_downloadLink_id.replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    DocumentsServiceBase.downloadDocumentPdf= function (id) {
      var nonBlockingWindow = window.open('', '_self');
      return $q(function(resolve, reject) {
        DocumentsServiceBase.getDocumentPdfLink(id)
          .then(function (pdfLink) {
            if (pdfLink) {
              // If we want to open link in same tab (immediate download)
              // window.location.href = pdfLink.url;
              // Opening in new empty tab
              nonBlockingWindow.location.href = HelperService.prepareDownloadLinkSlo(pdfLink.url);
            }
            resolve("success");
          })
          .catch(function (error) {
            nonBlockingWindow.close();
            reject();
            // HelperService.showMessage(error, 'error');
            $log.debug(error);
          });
        })
    };

    return DocumentsServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('documents')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('documents', {
        url: '/documents',
        templateUrl: 'documents/documents.tpl.html',
        controller: 'DocumentsCtrl',
        controllerAs: 'documents'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name documents.controller:DocumentsInfoCtrl
   *
   * @description
   *
   */
  angular
    .module('documents')
    .controller('DocumentsInfoCtrl', DocumentsInfoCtrl);

  function DocumentsInfoCtrl() {
    var vm = this;
    vm.ctrlName = 'DocumentsInfoCtrl';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name documents.controller:DocumentsCtrl
   *
   * @description
   *
   */
  DocumentsCtrl.$inject = ["$uibModal", "$log", "HelperService", "AlertService", "DocumentsService", "$translate", "GoogleTagManagerHelperService"];
  angular
    .module('documents')
    .controller('DocumentsCtrl', DocumentsCtrl);

  function DocumentsCtrl($uibModal, $log, HelperService, AlertService, DocumentsService, $translate, GoogleTagManagerHelperService) {
    var vm = this;
    vm.ctrlName = 'DocumentsCtrl';

    vm.selectPeriod = function (item) {
      vm.selectedPeriod = item;

      //var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      //vm.timelineFilter.dateGTE = timeRange.valueDateGTE;
      //vm.timelineFilter.dateLTE = timeRange.valueDateLTE;

      vm.resetTimelineFilter();
      vm.timelineFilter.dateGTE = HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateGTE;
      vm.timelineFilter.dateLTE = HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateLTE;
      vm.getTimelineItemsGrouped(true);
      GoogleTagManagerHelperService.pushEvent('Documents', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));
    };

    vm.resetTimelineFilter = function () {

      vm.searchFilterExpanded = false;
    };


    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      },
      {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }, {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }, {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }, {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
    ];

    vm.selectedPeriod = vm.periodList[3];

    vm.timelineFilter = {
      page: 0,
      dateGTE: HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateGTE,
      dateLTE: HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateLTE,
      orderBy: 'date desc',
      pageSize: 10
    };
    vm.recompile = {
      timeline: true
    };
    vm.timelineListGrouped = {};


    vm.loadMoreTimelineItemsGrouped = function () {
      vm.getTimelineItemsGrouped(false);

    };

    vm.getTimelineItemsGrouped = function (reset) {

      if (reset) {
        vm.timelineFilter.page = 0;
      } else {
        vm.timelineFilter.page += 1;
      }


      DocumentsService.getDocuments(vm.timelineFilter)
        .then(function (response) {
          vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
            existingData: vm.timelineListGrouped,
            newData: response,
            groupFunction: function (item) {

              var dateYear = new Date(item.date);

              // If we want to group only by date component, without hours
              dateYear.setHours(0, 0, 0, 0);
              return dateYear;
            },
            virtualRowFunction: function (e) {
              var year = new Date(e).getFullYear();
              var virtualRow = {
                isVirtual: true,
                date: year
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: true
          });

          /*
           var todayDateRange = HelperService.getTodayWithoutOffset();
           var yesterdayDateRange = HelperService.getYesterdayWithoutOffset();


           _.forEach(vm.timelineListGrouped.result, function (item) {
           item.dateValue = new Date(item.date);
           if (item.dateValue >= todayDateRange.firstDay && item.dateValue <= todayDateRange.lastDay) {
           item.showText = true;
           item.dateLabel = 'core.period.today';
           }
           else if (item.dateValue >= yesterdayDateRange.firstDay && item.dateValue < yesterdayDateRange.lastDay) {
           item.showText = true;
           item.dateLabel = 'core.period.yesterday';
           }
           else {
           item.showDate = true;
           }
           });
           */
          $log.debug("groupedDocumentsTimeline", vm.timelineListGrouped);
          vm.recompile.timeline = true;
        }).catch(function (error) {
        $log.error(error);
      });
    };

    vm.downloadPdf= function (item) {
      var id = item.id;
      if (item.downloadPdfInProgress) return;
      item.downloadPdfInProgress = true;
      DocumentsService.downloadDocumentPdf(id)
        .then(function(){},
        function(error){
          AlertService.infoAlert({
            text: 'documents.documentDownloadFailed'
          });
        }).finally(function() {
        item.downloadPdfInProgress = false;
      })
    };
    vm.init = function () {
      vm.getTimelineItemsGrouped(true);
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name dashboard
   * @description
   *
   */
  angular
    .module('dashboard', [
      'ui.router',
      'accounts'
    ]);
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name dashboard.factory:QuickPaymentModalService
     *
     * @description
     *
     */
    QuickPaymentModalService.$inject = ["$uibModal", "$log"];
    angular
        .module('dashboard')
        .factory('QuickPaymentModalService', QuickPaymentModalService);

    function QuickPaymentModalService($uibModal, $log) {
        var QuickPaymentModalServiceBase = {};
        QuickPaymentModalServiceBase.someValue = 'QuickPaymentModalService';
        QuickPaymentModalServiceBase.openQPModal = function () {

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'dashboard/quick-payment-modal.tpl.html',
                controller: 'QuickPaymentModalCtrl',
                controllerAs: 'qpModalCtrl',
                size: 'lg'
            });

            modalInstance.result.then(function (selectedItem) {
                
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });


            return 'QuickPaymentModalService';
        };
        return QuickPaymentModalServiceBase;
    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name dashboard.controller:QuickPaymentModalCtrl
     *
     * @description
     *
     */
    QuickPaymentModalCtrl.$inject = ["$scope", "$uibModalInstance"];
    angular
        .module('dashboard')
        .controller('QuickPaymentModalCtrl', QuickPaymentModalCtrl);

    function QuickPaymentModalCtrl($scope, $uibModalInstance) {
        var vm = this;
        vm.ctrlName = 'QuickPaymentModalCtrl';

        vm.qpModalDate = null;
        vm.getDate = function () {
            vm.qpModalDate =  new Date();
        };
        vm.getDate();
        vm.datepickerPopup = {
            opened: false
        };
        vm.openDatepicker = function() {
            vm.datepickerPopup.opened = true;
        };
        vm.dateOptions = {
            dateDisabled: disabled,
            formatYear: 'yy',
            minDate: new Date(),
            maxDate: vm.qpModalDate.getMonth+6,
            startingDay: 1
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        vm.toAccountType = 1;

        vm.closeQPModal = function(){
            $uibModalInstance.close();
        };

    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name dashboard.factory:LoyaltyPointsService
     *
     * @description
     *
     */
    LoyaltyPointsService.$inject = ["$q", "$http", "EndpointsService", "$log"];
    angular
        .module('dashboard')
        .factory('LoyaltyPointsService', LoyaltyPointsService);

    function LoyaltyPointsService($q, $http, EndpointsService, $log) {
        var LoyaltyPointsServiceBase = {};
        LoyaltyPointsServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.loyaltyPoints, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return LoyaltyPointsServiceBase;
    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name dashboard.factory:DashboardWidgetModalService
     *
     * @description
     *
     */
    DashboardWidgetModalService.$inject = ["$uibModal", "$log"];
    angular
        .module('dashboard')
        .factory('DashboardWidgetModalService', DashboardWidgetModalService);

    function DashboardWidgetModalService($uibModal, $log) {
        var DashboardWidgetModalServiceBase = {};
        DashboardWidgetModalServiceBase.openDashboardWidgetModal = function (accountsList) {

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'dashboard/dashboard-widget-modal.tpl.html',
                controller: 'DashboardWidgetModalCtrl',
                controllerAs: 'dwModalCtrl',
                size: 'lg',
                resolve: {
                    accountsList: function () {
                        return accountsList
                    }
                },
                backdrop: 'static'
            });
            return modalInstance.result;
        };
        return DashboardWidgetModalServiceBase;
    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name dashboard.controller:DashboardWidgetModalCtrl
     *
     * @description
     *
     */
    DashboardWidgetModalCtrl.$inject = ["$rootScope", "accountsList", "$filter", "$uibModalInstance", "AccountsService", "$log", "HelperService"];
    angular
        .module('dashboard')
        .controller('DashboardWidgetModalCtrl', DashboardWidgetModalCtrl);

    function DashboardWidgetModalCtrl($rootScope, accountsList, $filter, $uibModalInstance, AccountsService, $log,HelperService) {
        var vm = this;
        vm.ctrlName = 'DashboardWidgetModalCtrl';

        vm.accountsList = accountsList;

        vm.currentAndCreditAccounts = [];
        vm.loanAccounts = [];
        vm.depositAccounts = [];
        vm.savingAccounts = [];
        vm.giroAccounts = [];

        if (vm.accountsList.result.length !== 0) {
          _.forEach(vm.accountsList.result, function(value){
            if (value.accountType.group === 'CardAccountTypes' || value.accountType.group === 'CurrentAccount') {
              vm.currentAndCreditAccounts.push(value);
            } else if (value.accountType.group === 'LoanAccountType') {
              vm.loanAccounts.push(value);
            } else if (value.accountType.group === 'DepositAccountTypes') {
              vm.depositAccounts.push(value);
            } else if (value.accountType.group === 'SavingAccountTypes') {
              vm.savingAccounts.push(value);
            } else if (value.accountType.group === 'GiroAccount') {
              vm.giroAccounts.push(value);
            }
          });
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
            vm.currentAndCreditAccounts = $filter('orderBy')(vm.currentAndCreditAccounts, ['-accountType.group', '-isOwn', 'sortOrderId'])
            vm.depositAccounts = $filter('orderBy')(vm.depositAccounts, [ '-isFavorite', '-isOwn', '-accountType.group'])
            vm.savingAccounts = $filter('orderBy')(vm.savingAccounts, [ '-isFavorite', '-isOwn', '-accountType.group'])
          }

        }

        vm.markAccountAsFavorite = function (accountObj) {
            if (vm.markAsFavoriteInProgress) return;
            vm.markAsFavoriteInProgress = true;
            AccountsService.updateAccount(accountObj.accountId, { "isFavorite": accountObj.isFavorite} )
                .then(function (response) {
                    $log.debug("marked success ", response);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                    $log.error(error);
                })
              .finally(function () {
                vm.markAsFavoriteInProgress = false;
              })
        };

        vm.closeDashboardWidgetModal = function (broadcastCloseEvent) {
            $uibModalInstance.close(broadcastCloseEvent);
        };
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name dashboard.controller:DashboardTimelineCtrl
   *
   * @description
   *
   */
  angular
    .module('dashboard')
    .controller('DashboardTimelineCtrl', DashboardTimelineCtrl);

  function DashboardTimelineCtrl() {
    var vm = this;
    vm.ctrlName = 'DashboardTimelineCtrl';

  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('dashboard')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('dashboard', {
        url: '/dashboard',
        templateUrl: 'dashboard/dashboard.tpl.html',
        controller: 'DashboardCtrl',
        controllerAs: 'dashboard'
      })
      .state('dashboard.timeline', {
        url: '/dashboard-timeline',
        views: {
          '@': {
            templateUrl: 'dashboard/dashboard-timeline.tpl.html',
            controller: 'DashboardTimelineCtrl',
            controllerAs: 'dashboardTimeline'
          }
        }
      });
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name dashboard.controller:DashboardCtrl
     *
     * @description
     *
     */
    DashboardCtrl.$inject = ["$rootScope", "$log", "$state", "$translate", "CTLocalizationService", "AccountsService", "PaymentTemplatesService", "QuickPaymentModalService", "TimelineService", "HelperService", "EInvoiceDocumentsService", "TransactionsService", "MessagesService", "DashboardWidgetModalService", "CurrencyService", "$timeout", "PaymentsService", "$sessionStorage", "$q", "ImagesService", "NotificationCountService", "LoyaltyPointsService", "$filter", "$window", "AlertService", "ViberService", "base64", "GoogleTagManagerHelperService"];
    angular
        .module('dashboard')
        .controller('DashboardCtrl', DashboardCtrl);

    function DashboardCtrl($rootScope, $log, $state, $translate, CTLocalizationService, AccountsService, PaymentTemplatesService,
        QuickPaymentModalService, TimelineService, HelperService, EInvoiceDocumentsService,
        TransactionsService, MessagesService, DashboardWidgetModalService, CurrencyService,
        $timeout, PaymentsService, $sessionStorage, $q, ImagesService,
        NotificationCountService, LoyaltyPointsService, $filter, $window, AlertService, ViberService, base64, GoogleTagManagerHelperService) {
        var vm = this;
        vm.localCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.recompile = {
            timeline: true
        };

        vm.currencySelectObject = {};
        vm.currenciesList = [];
        vm.currenciesFilter = {
          pageSize: 1000
        };


        vm.currentLang = '';
        if(vm.countryCode === 'hr' || vm.countryCode === 'bh'){
          vm.currentLang = $translate.proposedLanguage() || $translate.use();
          $rootScope.$on('appLanguageChangedNavigation', function (evt, lang) {
            if (lang && lang.langCode) {
              vm.currentLang = $translate.proposedLanguage() || $translate.use();
              console.log("lang", vm.currentLang);
            }
          });
          $rootScope.$on('appLanguageChangedHeader', function (evt, lang) {
            if (lang && lang.langCode) {
              vm.currentLang = $translate.proposedLanguage() || $translate.use();

              console.log("lang", vm.currentLang);
            }
          });
        }

        vm.periodList = [
            {
                item: {
                    key: 'today',
                    description: 'core.period.today'
                }
      },
            {
                item: {
                    key: 'yesterday',
                    description: 'core.period.yesterday'
                }
      }, {
                item: {
                    key: 'thisWeek',
                    description: 'core.period.thisWeek'
                }
      }, {
                item: {
                    key: 'thisMonth',
                    description: 'core.period.thisMonth'
                }
      }
    ];

        if(vm.countryCode !== 'sl'){
          vm.periodList.push({
            item: {
              key: 'thisYear',
              description: 'core.period.thisYear'
            }
          });
        }

      vm.periodList.push({
        item: {
          key: 'all',
          description: vm.countryCode === 'sl' ? 'core.period.last6Months' : 'core.period.all'
        }
      });

        vm.selectedPeriod = vm.periodList[3];

        vm.timelineTimeFilter = function (item) {
            vm.selectedPeriod = item;
            appendTimeRangeTlFilter();
            vm.resetTimelineFilter();
            vm.timelineFilter.itemTypeList = null;

            if(vm.countryCode === 'sl')
              vm.timelineFilter.currency = vm.currencySelectObject.symbol;

            vm.getTimelineItemsGrouped(true);

            GoogleTagManagerHelperService.pushEvent('Dashboard', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));

        };

        vm.getDateFromDatestring = function (datestring) {
            return new Date(datestring);
        };

        vm.getGroupDateTitle = function (tlItem) {
            var date = new Date(tlItem.date);
        };

        vm.tmpSearchText = {
            name: ''
        };

        vm.showFavoriteTemplates = true;
        vm.showTemplatesView = false;
        vm.toggleTemplatesView = function () {

            vm.showTemplatesView = !vm.showTemplatesView;

            if (vm.showTemplatesView === true) {

                if (!vm.templateList.result || vm.templateList.result.length === 0) {
                    vm.getPaymentTemplatesPage();
                }

                $timeout(function () {
                    var searchTemplatesInput = angular.element('#searchTemplatesInput');
                    searchTemplatesInput.focus();
                }, 500);
            }
        };

        vm.toggleFavoriteTemplates = function (searchValue) {

            if (searchValue != '') {
                vm.showFavoriteTemplates = false;
            } else {
                vm.showFavoriteTemplates = true;
            }
        };

        vm.changeLanguage = function (langKey) {
            CTLocalizationService.setLanguage(langKey);
        };

        vm.accountsFilter = {
            page: 0,
            pageSize: 1000,
            isFavorite: true,
            includeList: ['loanAccount']
        };

        // account filter for BiH environment
        if (vm.countryCode === 'bh') {
            vm.accountsFilter.orderBy = 'accountType';
        } else {
            vm.accountsFilter.orderBy = 'accountType, iban';
        }

        vm.templatesFilter = {
            page: 0,
            pageSize: 1000
        };
        vm.timelineFilter = {
            page: 0,
            amountGTE: null,
            amountLTE: null,
            orderBy: 'date desc',
            pageSize: 10
        };

        var appendTimeRangeTlFilter = function () {
            var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'sl' && vm.selectedPeriod.item.key === 'all') {
                timeRange = HelperService.getDateRange('6months');
            }
            vm.timelineFilter.dateGTE = timeRange.valueDateGTE;
            vm.timelineFilter.dateLTE = timeRange.valueDateLTE;
        };

        appendTimeRangeTlFilter();
        vm.busy = false;

        vm.accountList = {};
        vm.accountListAll = {};
        vm.templateList = {};
        vm.timelineList = {};
        vm.timelineListGrouped = {};

      function showPaymentsReturnInfo() {
        var filter = {
          page: 0,
          orderBy: 'dateCreated DESC',
          status: 'Opened',
          pageSize: 15,
          paymentTypeGroupList: 'SEPARecall'
        };
        PaymentsService.getPage(filter)
          .then(function (response) {
            if(response.result && response.result.length > 0){
              $sessionStorage.paymentsReturnInfoViewed =true;
              AlertService.paymentsReturnInfo();

            }
          })
          .catch(function (error) {
            $log.error(error);
          });
      }

      vm.init = function () {

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData) {
                vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
                vm.countryCode = vm.defaultData.APILocation;
            }

            if ($rootScope.APP_GLOBAL_SETTINGS.userSettings) {
                vm.userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
                // console.log("USEEEEERR", vm.userSettings);
            }

            // getNotificationsCount();
            vm.getAccountsPage(true);
            //vm.getAccountsPageAll();
            loadBannerImages();

          if (vm.countryCode == 'sl') {
            vm.getLoyaltyPointsPage();
          }

          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.SyncEnabled && $rootScope.APP_GLOBAL_SETTINGS.defaultData.SyncEnabled == 'false') {
              vm.getTimelineItemsGrouped(true);
          } else {
            // Sync timeline to ensure that timeline is up to date
            syncTimeline().then(function () {
              vm.getTimelineItemsGrouped(true);
            });
          }

          vm.getExchangeListPage();

          if(vm.countryCode == 'hr' && !$sessionStorage.paymentsReturnInfoViewed){
            showPaymentsReturnInfo();
          }

        };



        var syncTimeline = function () {
            return TimelineService.syncTimeline()
                .then(function (response) {
                    $rootScope.APP_GLOBAL_SETTINGS.loginInfo = response[0];
                    console.log("Synced: ");
                }).catch(function (error) {
                    console.log("Error: " + error);
                });
        };

        vm.loadMoreAccounts = function () {
            vm.getAccountsPage(false);
        };

        vm.loadMoreTimelineItemsGrouped = function () {
            vm.getTimelineItemsGrouped(false);
        };

        vm.getAccountsPage = function (reset) {
            if (vm.busy) return;
            vm.busy = true;
            if (reset) {
                vm.accountsFilter.page = 0;
            } else {
                vm.accountsFilter.page += 1;
            }

            if (vm.accountList.hasMore || vm.accountsFilter.page === 0) {
                AccountsService.getPage(vm.accountsFilter)
                    .then(function (response) {
                        if (!reset) {
                            vm.accountList.hasMore = response.hasMore;
                            vm.accountList.result = vm.accountList.result.concat(response.result);
                        } else {
                            vm.accountList = response;
                        }

                        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                            sortAccountsForSloDashboard();
                        }
                        vm.busy = false;
                        $log.debug(vm.accountList);
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            }
        };

        function sortAccountsForSloDashboard() {
            vm.currentAndCreditAccounts = [];
            vm.loanAccounts = [];
            vm.depositAccounts = [];
            vm.savingAccounts = [];
            vm.giroAccounts = [];

            if (vm.accountList.result.length !== 0) {
                _.forEach(vm.accountList.result, function (value) {
                    if (value.accountType.group === 'CardAccountTypes' || value.accountType.group === 'CurrentAccount') {
                        vm.currentAndCreditAccounts.push(value);
                    } else if (value.accountType.group === 'LoanAccountType') {
                        vm.loanAccounts.push(value);
                    } else if (value.accountType.group === 'DepositAccountTypes') {
                        vm.depositAccounts.push(value);
                    } else if (value.accountType.group === 'SavingAccountTypes') {
                        vm.savingAccounts.push(value);
                    } else if (value.accountType.group === 'GiroAccount') {
                        vm.giroAccounts.push(value);
                    }
                });
                vm.currentAndCreditAccounts = $filter('orderBy')(vm.currentAndCreditAccounts, ['-accountType.group', '-isOwn', 'sortOrderId'])
                vm.depositAccounts = $filter('orderBy')(vm.depositAccounts, ['-isFavorite', '-isOwn', '-accountType.group'])
                vm.savingAccounts = $filter('orderBy')(vm.savingAccounts, ['-isFavorite', '-isOwn', '-accountType.group'])
            }
        }

        vm.getAccountsPageAll = function () {
            var deferred = $q.defer();
            AccountsService.getAll()
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        vm.getPaymentTemplatesPage = function () {
            // if(vm.countryCode == 'sl'){
            //   vm.templatesFilter = {
            //     paymentTypeGroupList: ['DomesticPayment','LocalCurrencyTransfer','ForeignPayment']
            //   }
            // }

            PaymentTemplatesService.getPage(vm.templatesFilter)
                .then(function (response) {
                        vm.templateList = response;
                        $log.debug(vm.templateList);
                    }
                    /*, function (error) {
                     console.log(error);
                     }*/
                )
                .catch(function (error) {
                    $log.error(error);
                });

        };

        // vm.markedLastLogin = false;
        vm.getTimelineItemsGrouped = function (reset) {
            if (reset) {
                vm.timelineFilter.page = 0;
            } else {
                vm.timelineFilter.page += 1;
            }
            console.log(vm.timelineFilter);

            var searchFilter = angular.extend(vm.timelineSearchFilter, vm.timelineFilter);

            TimelineService.getPage(vm.timelineSearchFilter)
                .then(function (response) {
                    $(response.result).each(function (i, e) {
                        if (e.itemType == "TransactionCredit") {
                            e.credit = e.amount;
                            e.debit = null;
                        } else if (e.itemType == "TransactionDebit") {
                            e.credit = null;
                            e.debit = e.amount;
                        } else {
                            e.credit = null;
                            e.debit = null;
                        }
                    });

                    vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
                        existingData: vm.timelineListGrouped,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.date);
                            // If we want to group only by date component, without hours
                            date.setHours(0, 0, 0, 0);
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                date: e,
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });

                    var todayDateRange = HelperService.getTodayWithoutOffset();
                    var yesterdayDateRange = HelperService.getYesterdayWithoutOffset();


                    _.forEach(vm.timelineListGrouped.result, function (item) {
                        item.dateValue = new Date(item.date);
                        if (item.dateValue >= todayDateRange.firstDay && item.dateValue <= todayDateRange.lastDay) {
                            item.showText = true;
                            item.dateLabel = 'core.period.today';
                        } else if (item.dateValue >= yesterdayDateRange.firstDay && item.dateValue < yesterdayDateRange.lastDay) {
                            item.showText = true;
                            item.dateLabel = 'core.period.yesterday';
                        } else {
                            item.showDate = true;
                        }
                    });

                    // Timeline items are sorted by date descending. Find first login item in results list and mark it as last login item.
                    var lastLoginItem = _.find(vm.timelineListGrouped.result, function (item) {
                        return item.itemType === 'LoginSuccessful';
                    });
                    if (lastLoginItem) {
                        lastLoginItem.lastLogin = true;
                    }

                    $log.debug("groupedTimeline", vm.timelineListGrouped);
                    //alert(2);
                    vm.recompile.timeline = true;
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.gotoAccount = function (accountId) {
            $state.go('accounts', {
                accountId: accountId
            });
        };
        vm.gotoAccountFromTimelineSearch = function (timelineItemId) {
            var temp = timelineItemId.split('_');
            var accountId = temp[1];


            $state.go('accounts', {
                accountId: accountId
            });
        };

        vm.gotoEInvoiceFromTimelineSearch = function (timelineItemId) {
            $state.go('eInvoices.detail', {
                eInvoiceId: timelineItemId
            });
        };

        vm.openQPModal = function () {
            QuickPaymentModalService.openQPModal();

        };

        vm.navigateToPaymentForm = function (templateParams) {
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && templateParams.template.paymentSubTypeGroup == "NotSupportedPayment") {
            AlertService.infoAlert({
              text: "paymentsOverview.notSupportedPaymentMsg"
            })
            return;
          }
            var stateLink;
            var params = {
                templateId: templateParams.id
            };
            var template = templateParams.template;
            //var strObj = JSON.stringify({
            //  id: templateParams.id,
            //  type: 'template'
            //});
            switch (templateParams.type) {
            case "LocalCurrencyTransfer":
                stateLink = "payments.internalTransfer.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.domesticPayment.fromTemplatesToPay";
                }
                break;
            case "ForeignCurrencyTransfer":
                stateLink = "payments.internalTransfer.fromTemplate";
                break;
            case "DomesticPayment":
            case "SEPAPayment":
            case "RevenuePayment":
                stateLink = "payments.domesticPayment.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.domesticPayment.fromTemplatesToPay";
                }
                break;
            case "CurrencyExchange":
                stateLink = "payments.currencyConversion.fromTemplate";
                break;
            case "ForeignPayment":
                stateLink = "payments.internationalPayment.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.internationalPayment.fromTemplatesToPay";
                }
                break;
            }


          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
            // AccountsService.getAccountById(template.accountId)
            //   .then (function (response) {
            //     angular.extend (template, response);
                // if (template.paymentTypeGroup == "LocalCurrencyTransfer" && (template.toAccountNumber.substring(0, 4) != "SI56" || template.fromAccountNumber.substring(0, 4) != "SI56")) {
                //   stateLink = 'payments.internalTransfer.fromTemplate';
                // } else if (template.paymentTypeGroup == "LocalCurrencyTransfer" && template.toAccountNumber.substring(0, 4) == "SI56") {
                //   stateLink = 'payments.domesticPayment.fromTemplate'
                // }


                if (template.paymentTypeGroup == "LocalCurrencyTransfer" && template.paymentSubTypeGroup == "SEPAPayment") {
                  stateLink = 'payments.domesticPayment.fromTemplate';
                } else if (template.paymentTypeGroup == "LocalCurrencyTransfer"  && template.paymentSubTypeGroup == "LocalCurrencyTransfer") {
                  stateLink = 'payments.internalTransfer.fromTemplate';
                }


              // }).finally(function () {
              if (stateLink) {
                $state.go(stateLink, params);
              }
            // })

          } else {
            if (stateLink) {
              $state.go(stateLink, params);
            }
          }
        };

        vm.getTransactionDetails = function (timelineItem) {
            if (timelineItem.selected) {
                TransactionsService.getById(timelineItem.referenceId)
                    .then(function (response) {
                        timelineItem.transaction = response;
                        if (response.accountId) {
                            AccountsService.getAccountById(response.accountId)
                                .then(function (response) {
                                    timelineItem.account = response;
                                })
                                .catch(function (error) {
                                    $log.error(error);
                                })
                        }
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.getEinvoiceDetails = function (timelineItem) {
            EInvoiceDocumentsService.getById(timelineItem.referenceId)
                .then(function (response) {
                    if (response) {
                        timelineItem.einvoiceDetails = response;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.getMessageDetails = function (timelineItem) {
            var id;
            if (timelineItem.referenceType == 'Payment') {
                id = timelineItem.id.split('_')[0];
            } else {
                id = timelineItem.referenceId;
            }

            if (timelineItem.selected) {
                MessagesService.getById(id)
                    .then(function (response) {
                        timelineItem.messageDetails = response;
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.openPayment = function (paymentId) {
            PaymentsService.downloadPaymentPdf(paymentId);
        };

        vm.formatText = function (text) {
            return HelperService.formatResponseBody(text, false);
        };

        vm.searchInputExpanded = true;
        vm.searchFilterExpanded = false;

        vm.showSearchResultWrapper = false;

        vm.expandSearch = function () {
            vm.timelineFilter.itemType = '';
            vm.resetTimelineFilter();


            if (vm.searchInputExpanded === false && vm.searchFilterExpanded === false) {
                vm.searchInputExpanded = !vm.searchInputExpanded;
                vm.searchFilterExpanded = !vm.searchFilterExpanded;

                $timeout(function () {
                    var searchTimelineInput = angular.element('#searchTimelineInput');
                    searchTimelineInput.focus();
                }, 500);

            } else if (vm.searchInputExpanded === true && vm.searchFilterExpanded === true) {
                vm.searchInputExpanded = !vm.searchInputExpanded;
                vm.searchFilterExpanded = !vm.searchFilterExpanded;
                vm.getTimelineItemsGrouped(true);

            } else if (vm.searchInputExpanded === true && vm.searchFilterExpanded === false) {
                vm.searchInputExpanded = !vm.searchInputExpanded;
                vm.getTimelineItemsGrouped(true);

            } else if (vm.searchInputExpanded === false && vm.searchFilterExpanded === true) {
                vm.searchFilterExpanded = !vm.searchFilterExpanded;

            }
        };

        vm.toggleFilterSelection = function () {
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
            vm.timelineSearchFilter.descriptionFTS = '';

            if (vm.searchFilterExpanded && vm.currenciesList.length === 0) {
                // Load currencies only when user opens filter
                vm.getExchangeListPage();
            }
        };

        vm.timelineItemTypeSelected = 1;

        vm.selectTimelineItemType = function (type) {
            switch (type) {
            case "all":
                vm.timelineFilter.itemTypeList = null;
                vm.timelineItemTypeSelected = 1;
                break;
            case "credit":
                vm.timelineFilter.itemTypeList = ['TransactionCredit'];
                vm.timelineItemTypeSelected = 2;
                break;
            case "debit":
                vm.timelineFilter.itemTypeList = ['TransactionDebit'];
                vm.timelineItemTypeSelected = 3;
                break;
            case "others":
                vm.timelineFilter.itemTypeList = ['MessageIn', 'MessageOut', 'EInvoice', 'LoginSuccessful', 'LoginFailed'];
                vm.timelineItemTypeSelected = 4;
                break;
            default:
                vm.timelineFilter.itemTypeList = null;
                vm.timelineItemTypeSelected = 1;

            }
          // $translate.instant(vm.selectedPeriod.item.description)
          GoogleTagManagerHelperService.pushEvent('Dashboard', 'TimelineFilterCategorySelection', $translate.instant("timelineFilter." + type));

          vm.resetTimelineFilter();
            //vm.getTimelineItemsGrouped(true)

        };

        vm.resetTimelineFilter = function () {
            vm.timelineFilter.amountGTE = null;
            vm.timelineFilter.amountLTE = null;
            vm.timelineFilter.currency = null;
            vm.timelineSearchFilter.descriptionFTS = "";
            setDefaultCurrencyOnFilter();
        };
        vm.applyTimelineFilter = function () {
            console.log(vm.timelineFilter);
            if (vm.timelineFilter.amountGTE || vm.timelineFilter.amountLTE) {
                vm.timelineFilter.currency = vm.currencySelectObject.symbol;
            }

            if(vm.countryCode === 'sl'){
              vm.timelineFilter.currency = vm.currencySelectObject.symbol;
            }

            $log.debug("timelineFiler", vm.timelineFilter);
            vm.getTimelineItemsGrouped(true);
            vm.searchFilterExpanded = false;
            // vm.numberOfPendingPaymentsToShow = 0;
        };

        vm.openWidgetsModal = function () {
            vm.getAccountsPageAll()
                .then(function (response) {
                    vm.accountListAll = response;
                    DashboardWidgetModalService.openDashboardWidgetModal(vm.accountListAll).then(function (closed) {
                            if (closed) {
                                vm.getAccountsPage(true);
                            }
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                        });
                });

            GoogleTagManagerHelperService.pushEvent('Dashboard', 'FavoritesButton', 'Favorites button clicked');
        };

        vm.timelineSearchFilter = {
            descriptionFTS: '',
            pageSize: 20,
            orderBy: 'date DESC'
        };
        vm.timelineSearchResult = [];
        vm.getTimelineSearchPage = function () {
            TimelineService.getPage(vm.timelineSearchFilter)
                .then(function (response) {

                    vm.timelineSearchResult = response.result;

                    if (vm.timelineSearchResult.length !== 0) {
                        vm.showSearchResultWrapper = true;
                        vm.searchFilterExpanded = false;
                    } else {
                        vm.showSearchResultWrapper = false;
                        vm.searchFilterExpanded = false;
                    }

                    $log.debug("timeline search result", response);
                    vm.recompile.timeline = true;
                }).catch(function (error) {
                    $log.error(error);
                });
        };


      function setDefaultCurrencyOnFilter() {
        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
          vm.currencySelectObject = vm.currenciesList[0];
        } else {
          vm.currencySelectObject = _.find(vm.currenciesList, function (item) {
            return item.symbol === vm.localCurrency;
          });
        }
      }

      vm.getExchangeListPage = function () {

            CurrencyService.getCurrencyPage(vm.currenciesFilter)
                .then(function (response) {
                    vm.currenciesList = response.result;
                    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                      vm.currenciesList.unshift({code: "", symbol: ""});
                    }
                  setDefaultCurrencyOnFilter();
                    //$log.debug("currenciesList", vm.currenciesList);
                }).catch(function (error) {
                    $log.error(error);
                });

        };

        //GET PENDING PAYMENTS
        vm.pendingPaymentsFilter = {
            page: 0,
            status: null,
            statusList: ['InProcessing', 'WaitingQueue'],
            orderBy: 'dateCreated DESC',
            pageSize: 10
        };
        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
            vm.pendingPaymentsFilter.pageSize = 100;
        }

        if (vm.countryCode == 'sl')
            vm.pendingPaymentsFilter.statusList = ['InProcessing', 'WaitingQueue', 'Opened'];

        vm.pendingPaymentsList = {};
        vm.getPendingPaymentsPage = function () {

            PaymentsService.getPendingPayments(vm.pendingPaymentsFilter)
                .then(function (response) {
                    vm.pendingPaymentsList = response;
                    vm.pendingPaymentsOpened = true;
                    $log.debug("pendingPaymentsList", vm.pendingPaymentsList);
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.showPendingPayments = function () {
            if (!vm.pendingPaymentsList.result || vm.pendingPaymentsList.result.length === 0) {
                vm.getPendingPaymentsPage();
            } else {
                vm.pendingPaymentsOpened = true;
            }
        };

        vm.hidePendingPayments = function () {
            vm.pendingPaymentsOpened = false;
        };

        vm.recallPaymentAction = function (paymentId) {
            var params = {
                id: paymentId
            };
            PaymentsService.recallPayment(params)
                .then(function (response) {
                    vm.getPaymentsPage(true);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                })
        };

        vm.signPaymentAction = function (paymentId) {
            PaymentsService.openSignModal(paymentId)
                .then(function (signed) {
                    if (signed) {
                        vm.getPaymentsPage(true);
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.deletePaymentAction = function (paymentId) {
            PaymentsService.deletePayment(paymentId)
                .then(function (response) {
                    HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], paymentId);
                    vm.getPaymentsPage(true);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

      vm.showNotificationsPanel = ($sessionStorage.hasOwnProperty("showNotificationsPanel")) ? $sessionStorage.showNotificationsPanel : true;

        //NOTIFICATIONS

        var geteInvoiceDocumentsPage = function () {
            var notifyParams = {
                type: "eInvoiceDocuments",
                query: {
                    status: "Inserted"
                }
            };
            if (vm.userSettings.lastLoginDate) {
                notifyParams.query.valueDateGTE = new Date(vm.userSettings.lastLoginDate);
            }

            if (vm.countryCode == 'sl') { //temporarly put first day of the current year
                var date = new Date();
                date.setDate(new Date().getDate() - 365);
                notifyParams.query.valueDateGTE = new Date(date);
            }

            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.eInvoiceNotifications = +response;
                })
                .catch(function (error) {
                    vm.eInvoiceNotifications = 0;
                    $log.error(error);
                });
        };

        var getRejectedPaymentsPage = function () {
            var notifyParams = {
                type: 'Payments',
                query: {
                    status: "Rejected"
                }
            };

            if (vm.userSettings.lastLoginDate) {
                if (vm.countryCode == 'sl') {
                    notifyParams.query.dueDateGTE = new Date(vm.userSettings.lastLoginDate);
                } else {
                    notifyParams.query.dateCreatedGTE = new Date(vm.userSettings.lastLoginDate);
                }
            }
            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.rejectedPaymentsNotifications = +response;
                })
                .catch(function (error) {
                    vm.rejectedPaymentsNotifications = 0;
                    $log.error(error);
                });
        };

        vm.dismissNotifications = function () {
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'MessagesNotices', 'Discard');
          vm.showNotificationsPanel = false;
          $sessionStorage.showNotificationsPanel = false;
        };

        vm.pushNotificationsGtmEvent = function (desc) {
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'MessagesNotices', desc);
        };

        vm.downloadTransactionReport = function (transaction) {
            var id = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") ? transaction.transactionId : transaction.id;
            TransactionsService.downloadTransactionPdf(id);
        };

      vm.timelineSearchAction = function () {

        if(vm.countryCode === 'sl'){
          vm.timelineFilter.currency = vm.currencySelectObject.symbol;
        }

        vm.getTimelineItemsGrouped(true);


        // if (vm.timelineSearchFilter.descriptionFTS === '') {
        //     vm.showSearchResultWrapper = false;
        //     vm.showDeleteInputBtn = false;
        //     vm.getTimelineItemsGrouped(true);
        // } else {
        //     console.log(vm.pendingPaymentsList.result);
        //     console.log(vm.timelineListGrouped.result);
        //     vm.getTimelineItemsGrouped(true)
        //     vm.getTimelineSearchPage();
        //     vm.showDeleteInputBtn = true;
        // }
      };

        var getUnsignedPaymentsNotifications = function () {
            var notifyParams = {
                type: "Payments",
                query: {
                    status: "Opened"
                }
            }

            if (vm.countryCode == 'sl') {
                notifyParams.query.status = '';
                notifyParams.query.statusList = ['InProcessing', 'WaitingQueue', 'Opened'];
            }

            if (vm.userSettings.lastLoginDate && vm.countryCode != 'sl') {
                notifyParams.query.dateCreatedGTE = new Date(vm.userSettings.lastLoginDate);
            }
            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.unsignedPaymentsNotifications = +response;
                })
                .catch(function (error) {
                    vm.unsignedPaymentsNotifications = 0;
                    $log.error(error);
                });
        };

        var getNotificationsCount = function () {
            //
            // getGroupPaymentsNotifications();

            var promises = [getRejectedPaymentsPage(), getUnsignedPaymentsNotifications(), geteInvoiceDocumentsPage()];

            // If notifications were loaded once, don't load them again
            if (!$sessionStorage.notificationsLoaded) {
                $q.all(promises).then(function (data) {
                    vm.showNotificationsPanel = true;
                }).catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
            }

        };

        var loadBannerImages = function () {
            ImagesService.getImages({
                    pageSize: 2,
                    category: 'MarketingMessages'
                })
                .then(function (response) {
                    if (response) {
                        if (response.result[0]) {
                            vm.bannerImageUrl = response.result[0].downloadLink;
                            //vm.bannerImageUrl = "img/hypo/201611-Addiko-12048-e-banking-438x168-papiri-HR-01.png";
                        }
                        if (response.result[1]) {
                            vm.viberImageUrl = response.result[1].downloadLink;
                        }
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                })
        };

        vm.loyaltyPointsResult = {};
        vm.getLoyaltyPointsPage = function () {
            LoyaltyPointsService.getPage({
                    pageSize: 1000
                })
                .then(function (response) {
                    vm.loyaltyPointsResult = response.result[0];
                    $log.debug("loyaltyPointsResult ", vm.loyaltyPointsResult);
                })
                .catch(function (error) {
                    $log.error(error);
                });

        };

        vm.openAddikoClubSl = function () {
            $window.open("http://www.klub.addiko.si/", "_blank");
        };

        //activate Viber service
        // vm.activateViber = function () {
        //
        //     // TEST QR CODE
        //     // AlertService.infoAlert({text: "iVBORw0KGgoAAAANSUhEUgAAAiMAAAIjAQMAAADr5InyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURQAAAP///6XZn90AAAAJcEhZcwAADsMAAA7DAcdvqGQAAAIzSURBVHja7dxBcsIwDIVhZVhkyRFyFI7WHo2j5AhdsmBwi2zFUuIydNPG9H8bCHU+ZrrRSDaRRt7STV+nlPMhckpJ5KBXZ3kuKCgoKCgdKIfkM9+VJe8yqPKVlK4iR1XCDRcUFBQUlK6VvE5kLMpN3zpFK4lU5VpuGFBQUFBQXlDJ0bfH0kIs3QQKCgoKyssr072SLAndBAoKCgrKDhQXmwVdyn5ArgEuP5oooaCgoKDsW9nEZkFz6ANcJXkqKCgoKCi7V9LD6H5Ao3ykVfVBQUFBQelRWZeDOVQSqYrldL/eTpRQUFBQUPpTdJGd/MmHgdZpnAtyQUFBQUHpWLGqIHWMlGqZWc6GGmiZKjSjoKCgoPSrWIFw28kSFEs8JlrPHqGgoKCg9Kmk0E2EHYKYQwDFlxwUFBQUlN9Wch9wKp9MdSM4NZ/yoLnWXw+MvptAQUFBQelOcWP+eXs2VOpGcFb0I2sYUFBQUFC6VaxJcHvCWj4uYeJv+aiglG4ioaCgoKD0qtgfNY2J0lC/o50RBQUFBaVrZZ3cQtjMyI2R1hOlwVcSFBQUFJTOlEbC84JS2E620ZN1Ezf5NigoKCgoHSjPPDPu3NxZTmUhCgoKCkrHSpwoOcUdNLLy4bKqJCgoKCgof6u4WdCiuIV6PaOg8N9FQfkfyrkutHNB1iWEs6EoKCgoKN0pLrFAuN8H6OsxrPV7wigoKCgoPSqb6K1jWXmr+wGpVhJTHgQFBQUFZd+KyCcRSzSqLXRnTAAAAABJRU5ErkJggg=="});
        //
        //     // If user already activated Viber, show dialog and ask if he wants new password
        //     if ($rootScope.APP_GLOBAL_SETTINGS.isViberActivated) {
        //         AlertService.confirmationAlert({
        //                 text: "navigation.viberGenerateNewPassword"
        //             })
        //             .then(function (response) {
        //                 if (response) {
        //                     var userId = $rootScope.APP_GLOBAL_SETTINGS.userSettings.id;
        //                     ViberService.resendActivation(userId, {
        //                             deactivateViberUser: false,
        //                             isWebCall: true
        //                         })
        //                         .then(function (response) {
        //                             $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = true;
        //                             AlertService.imageAlert({
        //                                 baseUrl: response.qrCode
        //                             });
        //                         })
        //                         .catch(function (error) {
        //                             HelperService.showMessage(error, 'error');
        //                         });
        //                 }
        //             });
        //     } else {
        //         // User does not have Viber activated, ask to confirm activation process
        //         AlertService.confirmationAlert({
        //                 text: "navigation.viberActivationTxt"
        //             })
        //             .then(function (response) {
        //                 if (response) {
        //                     ViberService.activate({
        //                             phoneNumber: "string"
        //                         })
        //                         .then(function (response) {
        //                             $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = true;
        //                             AlertService.imageAlert({
        //                                 baseUrl: response.qrCode
        //                             });
        //                         })
        //                         .catch(function (error) {
        //                             HelperService.showMessage(error, 'error');
        //                         });
        //                 }
        //             });
        //     }
        //
        //
        // };

        vm.pushGtmLinkEvent = function(linkDesc){
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'ExternalLink', linkDesc);
        };

      // Viber functionality is just for BiH environment
      vm.checkUserViberActivation = function () {
        var stateToGo = $rootScope.APP_GLOBAL_SETTINGS.isViberActivated ? 'viber.deactivate' : 'viber';
        console.log("State to go");
        $state.go(stateToGo);
      };

      vm.downloadMessageAttachment = function (link) {
        if (link.itemList) {
          MessagesService.downloadMessageAttachment(link.itemList.linkAttachment);
        }
      };


        vm.init();

    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:ViberService
   *
   * @description
   *
   */
  ViberService.$inject = ["$http", "$q", "EndpointsService"];
  angular
    .module('core')
    .factory('ViberService', ViberService);

  function ViberService($http, $q, EndpointsService) {
    var ViberServiceBase = {};

    ViberServiceBase.checkActivation = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.authenticationAdmin_checkUserViberActivation)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    ViberServiceBase.activate = function (params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.authenticationAdmin, params)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    ViberServiceBase.deactivate = function (id, params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.authenticationAdmin_id.replace('{id}', id), params)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    ViberServiceBase.resendActivation = function (id, params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.authenticationAdmin_id.replace('{id}', id), params)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    ViberServiceBase.becomeFollower = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.authenticationAdmin_requestViberSms)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return ViberServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:ValidationService
   *
   * @description
   *
   */
  ValidationService.$inject = ["$rootScope"];
  angular
    .module('core')
    .factory('ValidationService', ValidationService);

  function ValidationService($rootScope) {
    var ValidationServiceBase = {};

    ValidationServiceBase.getUiMaskOptions = function () {
      return {
        "croatia": {
          "iban": {
//            "maskDefinitions": {'H': /H|h/, 'R': /R|r/},
            "allowInvalidValue": true,
            "clearOnBlur": false
          }
        },
        "international": {
          "iban": {
            "allowInvalidValue": true,
            "clearOnBlur": false
          }
        }
      }
    };

    ValidationServiceBase.getUiMask = function () {
      return {
        sl: {
          orders: "?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?*",
          domesticSI: "?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*",
          domestic: "?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ",
          internationalSI: "?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*",
          international: "?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*"
        }
      }

    };

    /*
     * Return Regex pattern for validation with ng-pattern-require directive
     * */
    ValidationServiceBase.getRegexPatternsForValidation = function () {
      // ^$|^[^-| ]
      // ^$ allows empty space input
      // [^-| ] dissallows first character of input as - or space

      return {
        "onlyNumbers": "^[0-9]*$",
        "onlyNumbersAndDashes": "^$|^[0-9][- 0-9]*$",
        "onlyNumbersAndLetters": "^[A-Za-z0-9]*$",
        "onlyNumbersAndLettersWithSuskavci": "^$|^[A-Za-z0-9ČčĆćžĐđŽžŠš][ A-Za-z0-9ČčĆćžĐđŽžŠš]*$",
        "allLettersNumbersSpaces": "^[A-Za-z0-9 ]*$",
        "allLettersNumbersSpacesIntlCro": "^(?!HR$|hr$)([A-Za-z0-9 ])*$", //HRxxx construction should be forbidden on Intl payment TSK-114339
        "allLettersNumbersDashes": "^[A-Za-z0-9-]*$", // Allowed all letters and numbers and dashes like (Chars DPS Serbia method)
        "allLettersNumbersDashesSlo": "^[A-Za-z0-9-/ ]*$", // Allowed all letters and numbers and dashes like (Chars DPS Serbia method)
        "allNumbersDashes": "^[0-9-]*$",  // Allowed numbers and dashes like (Chars DPS method)
        "phoneValidation": "^$|^[0-9][0-9-]*$", // Allow numbers 0-9, dashes spaces but disallow - and spaces as first entry
        "allowedCharsDPS": "^$|^[A-Za-z0-9.ČčĆćžĐđŽžŠš][- A-Za-z0-9.ČčĆćžĐđŽžŠš]*$",  // Allowed letters (A-Za-z) and numbers (0-9) and signs )(?'-/:ČćČćĐđŽž and space ( )
        "allowedCharsDPStextArea": "^$|^[A-Za-z0-9.ČčĆćžĐđŽžŠš][- A-Za-z0-9.ČčĆćžĐđŽžŠš\n]*$", // Allowed enter for textareas
        "allowedCharsDPSwithoutSuskavci": "^$|^[A-Za-z0-9.][- A-Za-z0-9.]*$", // [^-| ] EXCLUDE IF - is first character and
        "purposeOfPaymentValidation": ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'sr') ?  "^$|^[A-Za-z0-9.,ČčĆćžĐđŽžŠš][- A-Za-z0-9)(/;=@,ČčĆćžĐđŽžŠš]*$" : "^$|^[A-Za-z0-9.,ČčĆćžĐđŽžŠš][- A)(/-Za-z0-9.,ČčĆćžĐđŽžŠš]*$",
        "serbiaIbanValidation": "^[A-Za-z][A-Za-z][0-9-]*$",
        "phoneValidationWithPlus": "^$|^[+0-9][0-9-]*$",
        "disallowStarQutoesEtc": ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'sl') ? "^[^\"*\';#$%]*$" : "^[^\"*\';]*$",

        // Slovenia Specific
        "onlyNumbersWithoutFirstZero": "^$|^[1-9][0-9]*$",
        "standardInput": "^$|^[a-zA-Z0-9čČćĆžŽšŠđĐäÄëËïÏöÖüÜÿŸÁáéÉíÍóÓúÚýÝàÀèÈìÌòÒùÙâÂêÊîÎôÔûÛőŐűŰñÑõÕåÅůŮøØæÆœŒăĂşŞţŢżŻąĄßřŘŁłĽľŚśŤťŹźŔŕĹĺĘęĚěĎďŃńŇňçÇ£¥/_€?:().,'+&][-\\\\ a-zA-Z0-9čČćĆžŽšŠđĐäÄëËïÏöÖüÜÿŸÁáéÉíÍóÓúÚýÝàÀèÈìÌòÒùÙâÂêÊîÎôÔûÛőŐűŰñÑõÕåÅůŮøØæÆœŒăĂşŞţŢżŻąĄßřŘŁłĽľŚśŤťŹźŔŕĹĺĘęĚěĎďŃńŇňçÇ£¥/_€?:().,'+&]*$",
        "receiverNameInput": "^$|^[a-zA-Z0-9ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţ$/_€?:().,'+&][ a-zA-Z0-9ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţ$/_€?:().,'+&]*$",
        "receiverIbanInput":"^$|^[a-zA-Z0-9čČćĆžŽšŠđĐ/_€?:().,'+&][ a-zA-Z0-9čČćĆžŽšŠđĐ/_€?:().,'+&]*$",
        "allowedCharsText": "^$|^[A-Za-z0-9.ČčĆćžĐđŽžŠš!?][- A-Za-z0-9.ČčĆćžĐđŽžŠš!?]*$",
        "standardInputFriendlyName": "^$|^[a-zA-Z0-9čČćĆžŽšŠđĐäÄëËïÏöÖüÜÿŸÁáéÉíÍóÓúÚýÝàÀèÈìÌòÒùÙâÂêÊîÎôÔûÛőŐűŰñÑõÕåÅůŮøØæÆœŒăĂşŞţŢżŻąĄßřŘŁłĽľŚśŤťŹźŔŕĹĺĘęĚěĎďŃńŇňçÇ£¥/_€?:().,'\\\"+&%][-\\\\ a-zA-Z0-9čČćĆžŽšŠđĐäÄëËïÏöÖüÜÿŸÁáéÉíÍóÓúÚýÝàÀèÈìÌòÒùÙâÂêÊîÎôÔûÛőŐűŰñÑõÕåÅůŮøØæÆœŒăĂşŞţŢżŻąĄßřŘŁłĽľŚśŤťŹźŔŕĹĺĘęĚěĎďŃńŇňçÇ£¥/_€?:().,'+&\\\"%]*$",

      }
    };

    ValidationServiceBase.checkAllowedCharsDPS = function (e) {
      if (/Firefox/.test(navigator.userAgent)) {
        var charCode = e.charCode;
        if (e.keyCode != 0) return true;
      }
      else
        var charCode = e.keyCode;

      if (!(charCode == 32 || charCode == 40 || charCode == 41 || charCode == 63 ||
        (charCode >= 43 && charCode <= 58) || (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode == 353 || charCode == 352 || charCode == 272 ||
        charCode == 273 || charCode == 267 || charCode == 268 || charCode == 269 || charCode == 262 ||
        charCode == 263 || charCode == 381 || charCode == 382))) {
        e.preventDefault();
      }
    };

    /*
     * This method validates only numbers (0-9) and (-) charactes
     * */
    ValidationServiceBase.checkAllowedCharsForPoziv = function (e) {
      if (/Firefox/.test(navigator.userAgent)) {
        var charCode = e.charCode;
        if (e.keyCode != 0) return true;
      }
      else
        var charCode = e.keyCode;

      if ((charCode >= 48 && charCode <= 57 || charCode == 45)) {
        return true;
      }
      e.preventDefault();
    };

    /*
     * This method validates only numbers (0-9) and (-) and letters charactes
     * */
    ValidationServiceBase.checkAllowedCharsForSerbiaPoziv = function (e) {
      if (/Firefox/.test(navigator.userAgent)) {
        var charCode = e.charCode;
        if (e.keyCode != 0) return true;
      }
      else
        var charCode = e.keyCode;

      if ((charCode >= 48 && charCode <= 57 || charCode == 45 ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122))) {
        return true;
      }
      e.preventDefault();
    };

    /*
     * Returns iban modul 97 validation
     * */
    ValidationServiceBase.checkModul97Reference = function (reference) {
      if (reference.substring(2).length > 23) {
        return false;
      }

      //if (!char.IsLetter(reference[0]) || !char.IsLetter(reference[1]))
      //{
      //    return false;
      //}

      //if (!char.IsNumber(reference[2]) || !char.IsNumber(reference[3]))
      //{
      //    return false;
      //}
      reference = reference.toUpperCase();//we only process big letters
      var model = reference.substring(0, 2);//javascript original include char[0],char[1] -> iban.substring(0, 2);
      var checksum = reference.substring(2, 4).replace(/^0+/, "");//javascript original include char[2],char[3] -> iban.substring(2, 4);  >> trim leading zeros ex. "08" to "8"
      var modul97Check = reference.substring(4).replace(/\-/g, "");//javascript original include from char[4] afterwards -> iban.substring(4);

      var digits = "";

      for (var i = 0; i < modul97Check.length; i++) {
        var ch = modul97Check[i];

        if ('0' <= ch && ch <= '9') {
          digits = digits + ch;
        }
        else {
          digits = digits + Capital2Digits(ch);
        }
      }

      digits = digits.toString() + "00";

      var bigDigit = bigInt(digits).mod(97).toString();
      var checksum1 = bigInt(98).minus(bigDigit).toString();

      if (checksum1 == checksum) {
        return true;
      }
      else {
        return false;
      }
    };

    function Capital2Digits(ch) {
      var capitals = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var value = 0;
      for (var i = 0; i < capitals.length; i++) {
        value = i;
        if (ch == capitals[i]) {
          break;
        }
      }
      value = value + 10;
      return value;
    }

    return ValidationServiceBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name core.factory:SessionService
     *
     * @description
     *
     */
    SessionService.$inject = ["$sessionStorage", "$rootScope", "ConfigService", "$interval"];
    angular
        .module('core')
        .factory('SessionService', SessionService);

    function SessionService($sessionStorage, $rootScope, ConfigService, $interval) {

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        var SessionServiceBase = {};
        SessionServiceBase.errorKey = "";
        SessionServiceBase.errorDescription = "";

        SessionServiceBase.init = function () {
            console.log("Session service init() -- start");
            //Performs storing of data
            SessionServiceBase.errorKey = "";
            SessionServiceBase.errorDescription = "";

            // var data = $location.hash(); //all data retreived from oauth2
            var data = window.location.hash;
            //var tempUrl = window.location.href;
            //var data = tempUrl.split("#");
            console.log("Data from Oauth: " + data);

            if (data != "") {
                var dataList = data.split('&');

                console.log("dataList=" + dataList);
                //now we have all parts, and we should add it to session
                console.log("Item 1", dataList[0]);
                console.log("Item 2", dataList[1]);
                console.log("Item 3", dataList[2]);
                console.log("Item 4", dataList[3]);

                var accessTokenData = dataList[0].split('=');
                var tokenTypeData = dataList[1].split('=');
                var expiresInData = dataList[2].split('=');
                var stateData = dataList[3].split('=');


                /*var accessTokenArray = accessTokenData[1].split(".");
                var dataToken = accessTokenArray[1];
                console.log("accessTokenArray", accessTokenArray);
                console.log("dataToken", dataToken);
                var ataLength = dataToken.length;
                var ataModulo = ataLength % 4;
                if (ataModulo == 0) {
                    dataToken = dataToken + "";
                } else if (ataModulo == 1) {
                    dataToken = dataToken + "===";
                } else if (ataModulo == 2) {
                    dataToken = dataToken + "==";
                } else if (ataModulo == 3) {
                    dataToken = dataToken + "=";
                }
                var tokenData = base64.decode(dataToken);
                console.log("Token Data: ", tokenData);
                var jsonObject = JSON.parse(tokenData);
                $rootScope.GTM_DATA_USERID = jsonObject.unique_name;
                console.log("Token userId: ", $rootScope.GTM_DATA_USERID);*/


                $sessionStorage.ct_accessToken = accessTokenData[1];
                $sessionStorage.token_type = tokenTypeData[1];
                $sessionStorage.expires_in = expiresInData[1];
                $sessionStorage.state = stateData[1];

                var host = window.location;
                var pathname = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
                var redirectUrl = host.protocol + '//' + host.host + pathname + '/';

                console.log('new redirecting to: ' + redirectUrl);
                console.log($sessionStorage.ct_accessToken);
                console.log($sessionStorage.token_type);
                console.log($sessionStorage.expires_in);
                console.log($sessionStorage.state);

                // flush storage
                $sessionStorage.$apply();

                // If there was previous
                if ($sessionStorage.lastUrl) {
                    var lastUrl = $sessionStorage.lastUrl;
                    delete $sessionStorage.lastUrl;
                    // window.location.href = lastUrl;
                    this.waitForAccessTokenChangeAndRedirect(accessTokenData[1], lastUrl);
                } else {
                    // window.location.href = redirectUrl;
                    this.waitForAccessTokenChangeAndRedirect(accessTokenData[1], redirectUrl);
                }

                return true;
            } else {
                console.log("Session service -- no data from OAuth");

                SessionServiceBase.errorKey = getParameterByName("error");
                SessionServiceBase.errorDescription = getParameterByName("error_description");

                return false;
            }
        };

        SessionServiceBase.authorize = function () {
            console.log("Session service authorize()");
            console.log(ConfigService.authorizationUrl);
            console.log("Session service authorizeUrl: " + ConfigService.authorizationUrl);
            window.location.href = ConfigService.authorizationUrl;
        };

        function clearSession() {
            localStorage.clear();
            sessionStorage.clear();
        }

        SessionServiceBase.saveCurrentState = function () {
            if (!$sessionStorage.lastUrl) {
              var countryCode = ($rootScope.APP_GLOBAL_SETTINGS.defaultData) ? $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation : null ;
              $sessionStorage.lastUrl = (!countryCode || countryCode !== 'sl') ? window.location.href : (window.location.href.split('/#!')[0] + '/#!/dashboard');
            }
        };

        SessionServiceBase.saveStorageObject = function (o, t) {
            $sessionStorage.paymentStorageObject = {
                object: o,
                type: t
            };

        };

        SessionServiceBase.removeStorageObject = function () {
            delete $sessionStorage.paymentStorageObject;
        };


        SessionServiceBase.logout = function () {
            clearSession();
            console.log(ConfigService.logoutUrl);
            window.location.href = ConfigService.logoutUrl;
        };

        SessionServiceBase.waitForAccessTokenChangeAndRedirect = function (value, url) {
            if (JSON.parse(sessionStorage.getItem('ngStorage-ct_accessToken')) == value) {
                window.location.href = url;
                return;
            }

            var interval = $interval(function () {
                if (JSON.parse(sessionStorage.getItem('ngStorage-ct_accessToken')) == value) {
                    $interval.cancel(interval);
                    window.location.href = url;
                }
            }, 100);
        };

        return SessionServiceBase;
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:SessionInjectorService
   *
   * @description
   *
   */
  SessionInjectorService.$inject = ["$rootScope", "$log", "$sessionStorage", "ConfigService", "SessionService", "$q"];
  angular
    .module('core')
    .factory('SessionInjectorService', SessionInjectorService);

  function SessionInjectorService($rootScope, $log, $sessionStorage, ConfigService, SessionService, $q) {
    $rootScope.$on('$stateChangeSuccess', function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    var SessionInjectorServiceBase = {};
    SessionInjectorServiceBase.request = function (config) {
      //$log.debug($sessionStorage.ct_accessToken);
      //$log.debug($sessionStorage.expires_in);


      if ($sessionStorage.ct_accessToken != null) {
        config.headers.authorization = "Bearer " + $sessionStorage.ct_accessToken;
        $log.debug("SessionInjectorService; Bearer= " + config.headers.authorization);

      }
      //else {
      //  SessionService.authorize();
      //}
      //$log.debug("SessionInjectorService; headers = " + JSON.stringify(config.headers));

      return config;
    };

    SessionInjectorServiceBase.response = function (response) {
      //console.log("Response", response);
      // No need to handle 401/403 status codes here. They are already handled in responseError function
      //if(response.status === 401 || response.status === 403) {
      //   //alert('err r');
      //  $log.debug("SessionInjectorService; Response code = " + response.status);
      //   SessionService.authorize();
      // }
      return response;
    };

    SessionInjectorServiceBase.responseError = function (response) {

      console.log("ResponseError", response);
      if (response.status === 401 || response.status === 403) {
        $log.debug("SessionInjectorService; Response error code = " + response.status);
        // Save current state before redirecting user
        SessionService.saveCurrentState();
        SessionService.authorize();
      }
      return $q.reject(response);
    };

    return SessionInjectorServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:scrollable
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="core">
       <file name="index.html">
        <scrollable></scrollable>
       </file>
     </example>
   *
   */
  angular
    .module('core')
    .directive('scrollable', scrollable);

  function scrollable() {
    return {
      restrict: 'A',
      scope: {},
      replace: false,
      link: function (scope, element, attrs) {
        element.mCustomScrollbar({
          autoHideScrollbar: false,
          theme: 'minimal-dark',
          advanced:{
            updateOnContentResize: true
          }
        });
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:replaceSuskavciWithNormal
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="core">
   <file name="index.html">
   <replace-suskavci-with-normal></replace-suskavci-with-normal>
   </file>
   </example>
   *
   */
  angular
    .module('core')
    .directive('replaceSpecificChars', replaceSuskavciWithNormal);

  function replaceSuskavciWithNormal() {
    return {
      require: "ngModel",
      link: function (scope, element, attrs, modelCtrl) {
        var replaceSuskavci = function (inputValue) {
          if (inputValue == undefined) inputValue = '';
          var capitalized = inputValue.replace(/Č|č|Ć|ć|Đ|đ|Ž|ž|Š|š/gi, function (x) {
            var replaced;
            if (x == "Č" || x == "Ć") {
              replaced = "C";
            } else if (x == "č" || x == "ć") {
              replaced = "c"
            } else if (x == "Š") {
              replaced = "S"
            } else if (x == "š") {
              replaced = "s";
            } else if (x == "Đ") {
              replaced = "D"
            } else if (x == "đ") {
              replaced = "d"
            } else if (x == "Ž") {
              replaced = "Z"
            } else if (x == "ž") {
              replaced = "z"
            }
            return replaced;
          });
          // var capitalized = inputValue.toUpperCase();
          if (capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        };
        modelCtrl.$parsers.push(replaceSuskavci);
        replaceSuskavci(scope[attrs.ngModel]); // capitalize initial value
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:recompile
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="core">
       <file name="index.html">
        <recompile></recompile>
       </file>
     </example>
   *
   */
  recompile.$inject = ["$compile", "$rootScope", "$parse", "$log"];
  angular
    .module('core')
    .directive('kcdRecompile', recompile);

  function recompile($compile, $rootScope, $parse, $log) {
    return {
      restrict: 'A',
      scope: true,
      compile: function(el) {
        var template = getElementAsHtml(el);
        return function link(scope, $el, attrs) {
          var stopWatching = scope.$parent.$watch(attrs.kcdRecompile, function(_new, _old) {
            var useBoolean = attrs.hasOwnProperty('useBoolean');
            if ((useBoolean && (!_new || _new === 'false')) || (!useBoolean && (!_new || _new === _old))) {
              return;
            }
            // reset kcdRecompile to false if we're using a boolean
            if (useBoolean) {
              $parse(attrs.kcdRecompile).assign(scope.$parent, false);
            }

            // recompile
            var newEl = $compile(template)(scope.$parent);
            $el.replaceWith(newEl);

            // Destroy old scope, reassign new scope.
            stopWatching();
            scope.$destroy();
          });
        };
      }

    };
  }

  function getElementAsHtml(el) {
    return angular.element('<a></a>').append(el.clone()).html();
  }
}());

angular.module("app.constants", [])

.constant("version", "0.0.81")

;
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name core.controller:LoginCtrl
   *
   * @description
   *
   */
  LoginCtrl.$inject = ["$log", "SessionService"];
  angular
    .module('core')
    .controller('LoginCtrl', LoginCtrl);

  function LoginCtrl($log, SessionService) {
    var vm = this;
/*    vm.errorKey = "";
    vm.errorDescription = "";*/

    $log.debug("Login handler -- start");
    var result = SessionService.init();

/*    if(!result){
      vm.errorKey = SessionService.errorKey;
      vm.errorDescription = SessionService.errorDescription;
    }*/

    //if(result == false){
    //  $scope.errorKey = SessionService.errorKey;
    //  $scope.errorDescription = SessionService.errorDescription;
    //}else{
    //  TimelineService.syncTimeline().then(function(response){
    //    console.log("Synced");
    //  }).catch(function(err){
    //    console.log("Error: " + err);
    //  });
    //}
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:inputMask
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="core">
       <file name="index.html">
        <input-mask></input-mask>
       </file>
     </example>
   *
   */
  inputMask.$inject = ["$log", "$translate"];
  angular
    .module('core')
    .directive('inputMask', inputMask);

  function inputMask($log, $translate) {
    return {
      restrict: 'A',
      scope: {
        inputMask: '='
        ,inputMaskOptions: '=',
        maskVal: '='
      },
      controllerAs: 'inputMask',
      controller: function () {

      },
      link: function (scope, element, attrs) {
        //var im = new Inputmask(scope.inputMask);

        function translateInputMask() {
          $translate([scope.inputMask]).then(function (translations) {
            element.mask(translations['core.moneyFormat.mask'], scope.inputMaskOptions);
            if(scope.maskVal) {
              scope.maskVal = element.val();
            }
          });
        };

        if(scope.inputMaskOptions !== undefined && scope.inputMaskOptions.reverse === true){
          $( element ).css( "text-align", "right" );
        }
        var inputMask = undefined;
        var mask = String(scope.inputMask);
        //str.match("^Hello")
        // translation of input mask example
        if(mask.match("^core.")){
          //$translate([scope.inputMask]).then(function (translations) {
          //  element.mask(translations['core.moneyFormat.mask'], scope.inputMaskOptions);
          //});
          translateInputMask();
        }
        else {
          inputMask = scope.inputMask.mask;
          element.mask(scope.inputMask.mask, scope.inputMaskOptions);
        }

        scope.$root.$on('appLanguageChangedHeader', function (evt, data){
            translateInputMask();
        });

      }
    };
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:infiniteScroll
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="core">
       <file name="index.html">
        <infinite-scroll></infinite-scroll>
       </file>
     </example>
   *
   */
  infiniteScroll.$inject = ["$rootScope", "$window", "$timeout", "$log"];
  angular
    .module('core')
    .directive('infiniteScroll', infiniteScroll);

  function infiniteScroll($rootScope, $window, $timeout, $log) {
    return {
      restrict: 'A',
      scope: {},
      replace: false,
      controllerAs: 'infiniteScroll',
      controller: function () {
        var vm = this;
        vm.name = 'infiniteScroll';
      },
      link: function(scope, elem, attrs) {
        var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
        $window = angular.element($window);
        scrollDistance = 0;
        if (attrs.infiniteScrollDistance != null) {
          scope.$watch(attrs.infiniteScrollDistance, function(value) {
            return scrollDistance = parseInt(value, 10);
          });
        }
        scrollEnabled = true;
        checkWhenEnabled = false;
        if (attrs.infiniteScrollDisabled != null) {
          scope.$watch(attrs.infiniteScrollDisabled, function(value) {
            scrollEnabled = !value;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return handler();
            }
          });
        }
        handler = function() {

          var elementBottom, remaining, shouldScroll, windowBottom;
          windowBottom = $window.height() + $window.scrollTop();
          elementBottom = elem.offset().top + elem.height();
          remaining = elementBottom - windowBottom;
          shouldScroll = remaining <= $window.height() * scrollDistance;
          $log.debug("entered scroll, should scroll:", shouldScroll);
          if (shouldScroll && scrollEnabled) {
            $log.debug(attrs.infiniteScroll);
            if ($rootScope.$$phase) {
              return scope.$parent.$eval(attrs.infiniteScroll);
            } else {
              return scope.$parent.$apply(attrs.infiniteScroll);
            }
          } else if (shouldScroll) {
            return checkWhenEnabled = true;
          }
        };
        $window.on('scroll', handler);
        scope.$on('$destroy', function() {
          return $window.off('scroll', handler);
        });
        return $timeout((function() {
          if (attrs.infiniteScrollImmediateCheck) {
            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
              return handler();
            }
          } else {
            return handler();
          }
        }), 0);
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:ImagesService
   *
   * @description
   *
   */
  ImagesService.$inject = ["EndpointsService", "$q", "$http", "$log", "ConfigService"];
  angular
    .module('core')
    .factory('ImagesService', ImagesService);

  function ImagesService(EndpointsService, $q, $http, $log, ConfigService) {
    var ImagesServiceBase = {};

    var rootUrl = ConfigService.url + 'images/';

    ImagesServiceBase.getImages = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        if(response.links.images) {
          $http.get(response.links.images,
            { params: params})
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        } else {
          deferred.resolve(null);
        }
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    return ImagesServiceBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name core.factory:HelperService
     *
     * @description
     *
     */
    HelperService.$inject = ["$rootScope", "$localStorage", "$log", "$location", "$filter", "EndpointsService", "$uibModal", "ConfigService", "$translate", "Notification", "$window"];
    angular
        .module('core')
        .factory('HelperService', HelperService);

    function HelperService($rootScope,$localStorage, $log, $location, $filter, EndpointsService, $uibModal, ConfigService, $translate, Notification, $window) {
        var HelperServiceBase = {};

        HelperServiceBase.getAmountClean = function (amountString) {
            if (amountString != undefined) {
                if (amountString.indexOf(",") != -1) {
                    var amount = (amountString.replace('.', '').replace(',', '')) / 100;
                    //$log.debug(amountString, amount);
                    return amount;
                } else {
                    //$log.debug(amountString);
                    return amountString;
                }
            }
        };

        HelperServiceBase.getToday = function () {
            //var firstday = new Date(new Date().toJSON().slice(0, 10));
            var firstday = new Date();
            firstday.setHours(0, 0, 0, 0);
            var lastday = new Date();
            //var timeOffset = lastDay.getTimezoneOffset() * 60000;
            //if (timeOffset < 0) {
            //  var lastDayWithOffset = new Date(lastDay.getTime() - timeOffset);
            //} else if (timeOffset > 0) {
            //  var lastDayWithOffset = new Date(lastDay.getTime() + timeOffset);
            //}
            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        HelperServiceBase.getTodayWithoutOffset = function () {
            var firstday = new Date(),
                lastDay = new Date;
            firstday.setHours(0, 0, 0, 0);
            return {
                firstDay: firstday,
                lastDay: lastDay
            }
        };

        HelperServiceBase.getYesterdayWithoutOffset = function () {

            var curr = new Date();
            var firstday = new Date(curr.setDate(curr.getDate() - 1));
            firstday.setHours(0, 0, 0, 0);
            var lastday = new Date(firstday);
            lastday.setHours(23, 59, 59, 999);

            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        HelperServiceBase.getYesterday = function () {
            var curr1 = new Date();
            var curr2 = new Date();
            //var lastDayWithOffset, firstDayOffset;
            //var firstDayWithOffset;
            var firstDay = new Date(curr1.setDate(new Date().getDate() - 1));
            firstDay.setHours(0, 0, 0, 0);
            var lastDay = new Date(curr2.setDate(new Date().getDate() - 1));
            lastDay.setHours(23, 59, 59, 999);
            //firstDayOffset = firstDay.getTimezoneOffset() * 60000;

            //if(firstDayOffset < 0){
            //  firstDayWithOffset = new Date(firstDay.getTime() - firstDayOffset);
            //} else if (firstDayOffset > 0){
            //  firstDayWithOffset = new Date(firstDay.getTime() + firstDayOffset)
            //}
            //
            //var timeOffset = lastDay.getTimezoneOffset() * 60000;
            //if (timeOffset < 0) {
            //  lastDayWithOffset = new Date(lastDay.getTime() - timeOffset);
            //} else if (timeOffset > 0) {
            //  lastDayWithOffset = new Date(lastDay.getTime() + timeOffset);
            //}
            return {
                firstDay: firstDay,
                lastDay: lastDay
            }
        };

        HelperServiceBase.getThisWeek = function () {
            var curr = new Date();
            /*var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
            var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));*/

            var firstday = new Date(curr.setDate(curr.getDate() - 7));
            firstday.setHours(0, 0, 0, 0, 0);
            var lastday = new Date();
            lastday.setHours(23, 59, 59, 999);

            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        HelperServiceBase.getThisMonth = function () {
            /* var date = new Date();
             date.setMonth(date.getMonth() - 1);
             date.setHours(0,0,0,0);

             var firstday = date;
             var lastday = new Date();*/
            var curr = new Date();
            curr.setHours(0, 0, 0, 0);

            var firstday = new Date(curr.setDate(curr.getDate() - 30));
            firstday.setHours(0, 0, 0, 0);
            var lastday = new Date();
            lastday.setHours(23, 59, 59, 999);

            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        // This month will return last 30 days
        HelperServiceBase.getLast30Days = function () {
            var curr = new Date();
            var firstDay = new Date(curr.setDate(curr.getDate() - 30))
            var lastDay = new Date();
            return {
                firstDay: firstDay,
                lastDay: lastDay
            }
        };

        HelperServiceBase.getThisYear = function () {
            var date = new Date();
            var firstday = new Date(date.getFullYear(), 0, 1);
            var lastday = new Date(date.getFullYear(), 11, 31);

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl' || $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr' || $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'bh') {
                date.setDate(new Date().getDate() - 365);
                firstday = new Date(date);
                lastday = new Date();
            }

            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        HelperServiceBase.getAllFrom2LastYears = function () {
            var date = new Date();
            var firstday = new Date(date.getFullYear() - 2, date.getMonth(), date.getDay());
            var lastday = new Date();
            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        HelperServiceBase.get6Months = function () {
            var date = new Date();
            var firstday = new Date(date.getFullYear(), date.getMonth()-6, date.getDay());
            var lastday = new Date();
            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        HelperServiceBase.getAllFrom3LastYears = function () {
            var date = new Date();
            var firstday = new Date(date.getFullYear() - 3, date.getMonth(), date.getDay());
            var lastday = new Date();
            return {
                firstDay: firstday,
                lastDay: lastday
            }
        };

        HelperServiceBase.setCustomMonthPeriodByDays = function (date, days) {
            date.setDate(date.getDate() + days);
            return date;
        };

        HelperServiceBase.setCustomMonthPeriod = function (date, months) {
            date.setMonth(date.getMonth() + months);
            return date;
        };

        HelperServiceBase.setCustomNegativeMonthPeriod = function (date, months) {
            date.setMonth(date.getMonth() - months);
            return date;
        };

        HelperServiceBase.parseAmountInput = function (amount) {
            if (typeof amount === 'number') {
                amount = amount.toString();
            }
            var lng = $translate.use();
            if (amount) {
                if (lng === 'hr' || lng === 'sr' || lng === 'mn' || lng === 'mne') {
                    return parseFloat(amount.replace('.', '').replace(',', '.'));
                }
                return parseFloat(amount.replace(',', ''));
            }
        };

        HelperServiceBase.mergeRowsForTimeline = function (params) {

            var existingData, newData, groupFunction, virtualRowFunction, reverseGroupation;
            existingData = params.existingData;
            newData = params.newData;
            groupFunction = params.groupFunction;
            virtualRowFunction = params.virtualRowFunction;
            if (params.reverse === undefined) {
                reverseGroupation = true;
            } else {
                reverseGroupation = params.reverse;
            }


            if (existingData == undefined || params.reset) {
                existingData = {
                    hasMore: false,
                    result: []
                };
            }

            var all = [];
            var index = 0;

            if (existingData != undefined && existingData.result != undefined && existingData.result.length > 0) {
                index = existingData.result[existingData.result.length - 1].virtualIndex;
            }
            $(newData.result).each(function (i, e) {
                index++;
                e.virtualIndex = index;
            });
            var groupedData = _.groupBy(newData.result, function (item) {
                var groupationKey = groupFunction(item);
                return groupationKey;
            });

            var keys = _.keys(groupedData); //.reverse();
            if (params.reverse !== undefined && params.reverse === true) {
                keys = _.keys(groupedData).reverse();
            }

            //$log.debug("Grouped data: ", groupedData, "keys:", keys);

            $(keys).each(function (i, e) {
                var items = groupedData[e];
                //$log.debug("children: ", e, items);
                var newItem = virtualRowFunction(e);
                newItem.virtualGroupationKey = e;
                all.push(newItem);
                $(items).each(function (j, je) {
                    je.virtualGroupationKey = e;
                    all.push(je);
                });
            });

            //$log.debug("all: ", all);

            if (existingData != undefined) {
                if (existingData.result != undefined && existingData.result.length > 0 && all.length > 0) {
                    var virtualGroupationKeyFromLastExistingElement = existingData.result[existingData.result.length - 1].virtualGroupationKey;
                    var virtualGroupationKeyFromFirstNewElement = all[0];

                    if (virtualGroupationKeyFromLastExistingElement == virtualGroupationKeyFromFirstNewElement) {
                        //add items to existing group
                    }
                }
            }
            var concatenatedData = [];
            if (existingData != undefined && existingData.result != undefined) {
                concatenatedData = existingData.result.concat(all);
            } else {
                concatenatedData = concatenatedData.concat(all);
            }


            //$log.debug("result: ", newData, "all: ", all, "concatenated: ", concatenatedData);
            return {
                hasMore: newData.hasMore,
                result: concatenatedData
            };
        };

        HelperServiceBase.getDateTimeAsString = function (dateTime) {
            var isoDate = dateTime.toISOString();
            var time = isoDate.split("T");
            return {
                date: time[0],
                time: time[1]
            };
        };

        HelperServiceBase.getDateRange = function (timePeriod) {
            var range = null;
            switch (timePeriod) {
            case "today":
                range = HelperServiceBase.getToday();
                break;
            case "yesterday":
                range = HelperServiceBase.getYesterday();
                break;
            case "thisWeek":
                range = HelperServiceBase.getThisWeek();
                break;
            case "thisMonth":
                range = HelperServiceBase.getThisMonth();
                break;
            case "thisYear":
                range = HelperServiceBase.getThisYear();
                break;
            case "all2y":
                range = HelperServiceBase.getAllFrom2LastYears();
                break;
            case "all":
                // if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                //   range = HelperServiceBase.getAllFrom3LastYears();
                // }
                break;
            case "6months":
                range = HelperServiceBase.get6Months();
                break;
            }

            if (range) {
                return {
                    valueDateGTE: range.firstDay,
                    valueDateLTE: range.lastDay
                }
            } else {
                return {
                    valueDateGTE: null,
                    valueDateLTE: null
                }
            }
        };

        // Messages from API
        HelperServiceBase.showMessage = function (error, type, replaceMessage, maxCount) {
            if (error && error.resultList && error.resultList.length > 0) {
                var text = error.resultList[0].description;
                if (text.length >= 200) {
                    text = text.substring(0, 200);
                }

                //Default values from NotificationProvider
                var replaceMessageTemp = true;
                if (replaceMessage)
                    replaceMessageTemp = false;

                var maxCountTemp = 1;
                if (maxCount)
                    maxCountTemp = maxCount;

                switch (type) {
                case "error":
                    // var errorTitle = $translate.instant('core.error');
                    // Notification.error({title: errorTitle, message: text, templateUrl: "core/error-alert-template.tpl.html"});
                    Notification.error({
                        message: text,
                        templateUrl: "core/error-alert-template.tpl.html",
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                case "warning":
                    Notification.warning({
                        message: text,
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                case "success":
                    Notification.success({
                        message: text,
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                default:
                    Notification.info({
                        message: text,
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                }
            }
        };

        // Already translated messages, just show text
        HelperServiceBase.showTranslatedMessage = function (type, text, title, delay, replaceMessage, maxCount) {
            if (text) {
                // var text = $translate.instant(errorToTranslate);
                if (text.length >= 200) {
                    text = text.substring(0, 200);
                }
                var d = null;
                if (delay) {
                    d = delay;
                }

                //Default values from NotificationProvider
                var replaceMessageTemp = true;
                if (replaceMessage)
                    replaceMessageTemp = false;

                var maxCountTemp = 1;
                if (maxCount)
                    maxCountTemp = maxCount;

                switch (type) {
                case "error":
                    /*if(!title){
                      title = $translate.instant('core.error');
                    }
                    Notification.error({title: title, message: text, templateUrl: "core/error-alert-template.tpl.html"});*/
                    Notification.error({
                        message: text,
                        templateUrl: "core/error-alert-template.tpl.html",
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                case "warning":
                    Notification.warning({
                        message: text,
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                case "success":
                    Notification.success({
                        message: text,
                        delay: d,
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                case "info":
                    Notification.info({
                        message: text,
                        templateUrl: "core/error-alert-template.tpl.html",
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                default:
                    Notification.info({
                        message: text,
                        replaceMessage: replaceMessageTemp,
                        maxCount: maxCountTemp
                    });
                    break;
                }
            }
        };

        HelperServiceBase.validatePaymentDate = function (date) {
            var t = new Date();
            t.setHours(0);
            t.setMinutes(0);
            t.setSeconds(0);
            if (date < t) {
                return false;
            } else {
                return true;
            }
        };

        //HelperServiceBase.isEndpointAvailable = function (endpoint) {
        //  if (_.isArray(ConfigService.disabledEndpoints) && ConfigService.disabledEndpoints.length > 0) {
        //    var element = _.find(ConfigService.disabledEndpoints, function (item){
        //      return item === endpoint;
        //    });
        //    if(element){
        //      return false;
        //    }
        //    return true;
        //  } else {
        //    return true;
        //  }
        //
        //};

        HelperServiceBase.groupAccounts = function (accounts) {
            var accounts = accounts;
            var groupAccountsByIban = _.groupBy(accounts, function (account) {
                return account.iban;
            });
            //$log.debug('Grouped account', groupAccountsByIban);
            var multiAccounts = [];
            var singleAccounts = [];
            for (var key in groupAccountsByIban) {
                // if iban is empty string - add to singleAccounts!
                if (groupAccountsByIban[key].length > 1 && key !== "") {
                    var tempObj = {
                        iban: key,
                        accounts: groupAccountsByIban[key]
                    };
                    multiAccounts.push(tempObj);
                } else {
                    _.each(groupAccountsByIban[key], function (account) {
                        singleAccounts.push(account);
                    })
                }
            }

            return {
                multiAccounts: multiAccounts,
                singleAccounts: singleAccounts
            };
        };

        HelperServiceBase.parseAccountNumber = function (accountNumber) {
            if (accountNumber) {
                return accountNumber.split(" ")[0];
            }
            return '';
        };

        HelperServiceBase.separateDecimals = function (amount) {
            if (amount) {
                var lng = $translate.use();
                if (typeof amount === 'number') {
                    amount = amount.toString();
                }
                var numbers = [];
                if (lng == 'en') {
                    numbers = amount.split('.');
                    numbers.push('.');
                } else {
                    numbers = amount.split(',');
                    numbers.push(',');
                }
                return numbers;
            }
        };

        HelperServiceBase.deleteInformationMsg = function (translationStrings, paymentId) {
            $translate(translationStrings).then(function (translations) {
                //var txt = translations['core.paymentOrder'] + ' @' + paymentId + ' ' + translations['core.successDelete'];
                if (_.isArray(translationStrings) && translationStrings.length > 1) {
                    var txt = translations[translationStrings[0]] + ' "' + paymentId + '" ' + translations[translationStrings[1]];
                    swal(txt);
                }
            });

        };

        HelperServiceBase.confirmationReclamationMsg = function (translationString) {
            $translate(translationString).then(function (tranlate) {
                if (tranlate)
                    swal(tranlate);
            });

        };

        HelperServiceBase.splitReferenceNumber = function (input) {
            console.log("SPLITIN'", input);
            var refModel = '';
            var refNum = '';
            if (input) {
                if (input.length > 2) {
                    refModel = input.substr(0, 2);
                    refNum = input.substr(2);
                } else {
                    refModel = input.substr(0, 2);
                }
                if (refModel == '00')
                    refModel = '';

                return refModel + ' ' + refNum;
            }
            return input;
        };

        // TODO: Instead of using 2 replace, do it with one. Eman
        HelperServiceBase.formatResponseBody = function (body, addReplyText) {
            var regex = /<br\s*[\/]?>/gi;
            if (body && addReplyText) {
                var replyText = "\n------------------------------------------------------------------------------------";
                body = String(body).replace(regex, "\n");
                body = body ? '\n' + String(body).replace(/<[^>]+>/gm, '') : '';
                body = body.replace(/&nbsp;/g, ' ');
                return replyText + body;
            }
            if (body) {
                body = String(body).replace(regex, "\n");

                body = body ? String(body).replace(/<[^>]+>/gm, '') : '';
                body = body.replace('↵', "\n");
                body = body.replace(/&nbsp;/g, ' ');
            }
            return body;
        };

        HelperServiceBase.scrollToTop = function () {
            console.log('"Vrooom" - Scrolled to top!');
            $window.scrollTo(0, 0);
        };

        // Google Tag Manager tracking using url
        HelperServiceBase.processUrlForGTM = function (type) {
            var title = $location.url().substring(1, $location.url().length);
            var urlParts = title.split("/");
            for (var i = 0; i < urlParts.length; i++) {
                var match = urlParts[i].match(/\d+/g);
                if (match) {
                    urlParts.splice(i, 1);
                }
            }
            //$log.debug("UrlParts: ", urlParts);
            var url = "";
            for (var i = 0; i < urlParts.length; i++) {
                url = url + "/" + urlParts[i];
            }
            url = url.replace("/", "");
            if (type === "payment") {
                url = url + '/toconfirm';
            } else if (type === "pageView") {
                url = $location.url();
            }
            var urlWithoutId ="";
            var titleWithoutId ="";
            var splitUrl = url.split("/");
            var lastPart = splitUrl[splitUrl.length - 1];
            if (!isNaN(lastPart)) {
                var negSlice = lastPart.length - (lastPart.length * 2);
                negSlice = negSlice - 1;
                urlWithoutId = url.slice(0, negSlice);
            }else{
                urlWithoutId = url;
            }
            //$log.debug("Url:", url);
            //$log.debug("urlWithoutId:", urlWithoutId);
            title = url.replace(/\//g, " ");
            titleWithoutId = urlWithoutId.replace(/\//g, " ");

            //$log.debug("Title:", title);
           //$log.debug("titleWithoutId:", titleWithoutId);



            return {
                titleWithoutId: titleWithoutId,
                title: title,
                urlWithoutId: urlWithoutId,
                url: url
            };
        };

        HelperServiceBase.formatIban = function (iban) {
            return iban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
        };

        HelperServiceBase.sortAccounts = function (accountList) { //only for SLO, sort by isFavourite DESC, isOwn DESC, EUR, nonEUR

            // START Add property for "eur" first filtering
            _.each(accountList, function (account) {
                // if (account.isParentAccount) {
                account.sortOrderId = (account.currencySymbol == "EUR") ? 1 : 2;
                // }
            });
            // END Add property for "eur" first filtering
            accountList  = $filter('orderBy')(accountList, ['-isFavorite', 'accountType.group',  '-isOwn', 'sortOrderId', 'currencySymbol']);

            return accountList;
        };
        //
        HelperServiceBase.prepareDownloadLinkSlo = function (url) {
          if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation !== 'sl') return url;
          return [url, 'headerAcceptLanguage=' + $localStorage.appLanguage].join('&');
        };

        return HelperServiceBase;
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:headroom
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="core">
       <file name="index.html">
        <headroom></headroom>
       </file>
     </example>
   *
   */
  angular
    .module('core')
    .directive('headroom', headroom);

  function headroom() {
      return {
          restrict: 'EA',
          scope: {
              tolerance: '=',
              offset: '=',
              classes: '=',
              scroller: '@'
          },
          link: function(scope, element) {
              var options = {};
              angular.forEach(Headroom.options, function(value, key) {
                  options[key] = scope[key] || Headroom.options[key];
              });
              /*if (options.scroller) {
                  options.scroller = document.querySelector(options.scroller);
              }*/
              var headroom = new Headroom(element[0], options);
              headroom.init();
              scope.$on('$destroy', function() {
                  headroom.destroy();
              });
          }
      };
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name core.factory:GoogleTagManagerHelperService
     *
     * @description
     *
     */
    GoogleTagManagerHelperService.$inject = ["$rootScope", "$translate"];
    angular
        .module('core')
        .factory('GoogleTagManagerHelperService', GoogleTagManagerHelperService);

    function GoogleTagManagerHelperService($rootScope, $translate) {
        var GoogleTagManagerHelperServiceBase = {};
        GoogleTagManagerHelperServiceBase.pushEvent = function (eventCategory, eventAction, eventLabel) {
            //gtm analytics
            if ($rootScope.APP_GLOBAL_SETTINGS.userSettings !== undefined) {
              if (!window.dataLayer) return;
                dataLayer.push({
                    'event': 'ctebevent',
                    'userId': $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId,
                    'eventCategory': eventCategory,
                    'eventAction': eventAction,
                    'eventLabel': eventLabel
                });
            }
        };
        GoogleTagManagerHelperServiceBase.pushVirtualPageView = function (page, title, url) {
            //gtm analytics
            if ($rootScope.APP_GLOBAL_SETTINGS.userSettings !== undefined) {
              if (!window.dataLayer) return;
              dataLayer.push({
                    'event': 'virtualPageview',
                    'userId': $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId,
                    'page': page,
                    'title': title,
                    'url': url
                });
            }
        };
        return GoogleTagManagerHelperServiceBase;
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc filter
   * @name core.filter:formatIban
   *
   * @description
   *
   * @param {Array} input The array to filter
   * @returns {Array} The filtered array
   *
   */
  formatIban.$inject = ["$rootScope"];
  angular
    .module('core')
    .filter('formatIban', formatIban);

  function formatIban($rootScope) {
    return function (input) {
      if(input && input.substring(0, 4) == "SI56" && $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl')
        return input.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
      return input;
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:EndpointsService
   *
   * @description
   *
   */
  EndpointsService.$inject = ["$http", "$q", "$log", "ConfigService"];
  angular
    .module('core')
    .factory('EndpointsService', EndpointsService);

  function EndpointsService($http, $q, $log, ConfigService) {
    var EndpointsServiceBase = {};
    /*var url = window.location.search.match(/url=([^&]+)/);
     if (url && url.length > 1) {
     url = decodeURIComponent(url[1]);
     }*/

    var linkList = {};
    $log.debug("ConfigService.url: "+ConfigService.url);
    EndpointsServiceBase.url = ConfigService.url;

    EndpointsServiceBase.links = null;

    EndpointsServiceBase.getLinks = function(){
      var deferred = $q.defer();
      //we show cached version if existing
      if(EndpointsServiceBase.links != null){
        deferred.resolve(EndpointsServiceBase.links);
      }
      else{
        $http.get(EndpointsServiceBase.url)
          .success(function(data) {
              EndpointsServiceBase.links = data;
              deferred.resolve(data);
          }).error(function(msg, code) {
            deferred.reject(msg);
            $log.error(msg, code);
          });

      }
      return deferred.promise;
    };
    return EndpointsServiceBase;
  }
}());

(function () {
  'use strict';
  doubleSubmitBlocker.$inject = ["$log"];
  angular
    .module('core')
    .directive('doubleSubmitBlocker', doubleSubmitBlocker);
  function doubleSubmitBlocker($log) {
    return {
      require: '^form',
      priority: -1,
      restrict: 'A',
      link: function (scope, element, attrs, form) {
        $log.debug('Initiating double submit blocker');
        // adds disabled class while form is in submitting state
        scope.$watch(
          function () {
            return element.data('submitting');
          },
          function (submitting) {
            if (submitting) {
              element.addClass('disabled');
              $log.debug('Added class disabled');
            } else {
              if (!attrs.ngDisabled || !scope.$eval(attrs.ngDisabled)) {
                element.removeClass('disabled');
                $log.debug('Removed class disabled');
              }
            }
          }
        );
        // blocks additional clicks and sets submitting data when element is clicked
        element.bind('click', function (e) {
          scope.$apply(function () {
            if (element.data('submitting')) {
              e.stopImmediatePropagation();
              e.preventDefault();
              $log.debug('Submit blocked');
              return false;
            }
            element.data('submitting', true);
            $log.debug('Submit passed');
            return true;
          });
        });
        // enables form resubmit in case of errors
        scope.$watch(
          function () {
            return form.$valid;
          },
          function (value) {
            if (value) {
              $log.debug('Form errors cleared submit enabled');
              element.data('submitting', false);
            }
          }
        );
        //specific case for internal transfer same account validation
        scope.$watch(function (){
          return (element.attr('is-same-account')==='true');
        }, function(value){
          if(value){
            element.data('submitting', false);
          }
        });

      }
    };
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:dnCustomLength
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="core">
   <file name="index.html">
   <input type="text" class="form-control" ng-model="vm.input" dn-custom-maxlength="5" dn-exclude="-">
   </file>
   </example>
   *
   */
  angular
    .module('core')
    .directive('dnCustomMaxlength', dnCustomMaxlength);

  function dnCustomMaxlength() {
    return {
      scope: {
        model: "=ngModel"
      },
      link: function (scope, element, attrs) {
        var maxlength = +attrs["dnCustomMaxlength"];
        var exclude;
        if (attrs["dnExclude"]) {
          exclude = new RegExp(attrs["dnExclude"], 'g');
        } else {
          exclude = "";
        }
        scope.$watch("model", function (newVal) {
          if (newVal) {
            if (newVal.replace(exclude, "").length == maxlength) {
              console.log(element);
              element.attr('maxlength', maxlength);
            } else {
              element.attr('maxlength', "");
            }
          }
        });
      }
    }
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('core')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('core', {
        url: '/core',
        templateUrl: 'core/core.tpl.html',
        controller: 'CoreCtrl',
        controllerAs: 'core'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name core.controller:CoreCtrl
   *
   * @description
   *
   */
  angular
    .module('core')
    .controller('CoreCtrl', CoreCtrl);

  function CoreCtrl() {
    var vm = this;
    vm.ctrlName = 'CoreCtrl';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:ConfigEndpointService
   *
   * @description
   *
   */
  ConfigEndpointService.$inject = ["$q", "$http", "EndpointsService"];
  angular
    .module('core')
    .factory('ConfigEndpointService', ConfigEndpointService);

  function ConfigEndpointService($q, $http, EndpointsService) {
    var ConfigEndpointServiceBase = {};

    ConfigEndpointServiceBase.getDefaultData = function (){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.config)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return ConfigEndpointServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:capitalize
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="core">
   <file name="index.html">
   <capitalize></capitalize>
   </file>
   </example>
   *
   */
  angular
    .module('core')
    .directive('capitalize', capitalize);

  function capitalize() {
    return {
      require: "ngModel",
      link: function (scope, element, attrs, modelCtrl) {
        var capitalize = function (inputValue) {
          if (inputValue == undefined) inputValue = '';
          var capitalized = inputValue.toUpperCase();
          if (capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        };
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]); // capitalize initial value
      }
    };
  }
}());





(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:autoFocus
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="core">
       <file name="index.html">
        <auto-focus></auto-focus>
       </file>
     </example>
   *
   */
  autoFocus.$inject = ["$timeout"];
  angular
    .module('core')
    .directive('autoFocus', autoFocus);

  function autoFocus($timeout) {
    return {
      restrict: 'EA',
      scope: {},
      templateUrl: 'core/auto-focus-directive.tpl.html',
      replace: false,
      controllerAs: 'autoFocus',
      controller: function () {
        var vm = this;
        vm.name = 'autoFocus';
      },
      link: function(scope, element) {
        $timeout(function(){
          element[0].focus();
        }, 0);
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name core.directive:amountInputMask
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="core">
   <file name="index.html">
   <amount-input-mask></amount-input-mask>
   </file>
   </example>
   *
   */
  amountInputMask.$inject = ["$rootScope", "$filter", "$timeout", "$locale"];
  angular
      .module('core')
      .directive('amountInputMask', amountInputMask);

  function amountInputMask($rootScope, $filter, $timeout, $locale) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        "allowEmpty": "@allowEmpty"
      },
      link: function (scope, element, attrs, ngModel) {

        var regex;
        var oldValue;

        $rootScope.$on('$translateChangeEnd', function (evt, data) {
          // For some reason $locale is not updated after translate change end
          // so little bit timeout is needed to reformat input after language change
          $timeout(function () {
            reformatViewValue();
          }, 100);
        });

        // Replace comma with dot or dot with comma - depends on selected language
        // Example: en - comma to dot, others - dot to comma
        element.on("keypress", function (evt) {
          var position = element[0].selectionStart;
          var keycode = evt.which || evt.keyCode;

          if ($locale.id == "en") {
            // keycode 44 (comma)
            if (keycode == 44) {
              replaceSeparator(".", position);
              element[0].setSelectionRange(position + 1, position + 1);
              evt.preventDefault();
              return false;
            }
          } else {
            // keycode 46 (dot)
            if (keycode == 46) {
              replaceSeparator(",", position);
              element[0].setSelectionRange(position + 1, position + 1);
              evt.preventDefault();
              return false;
            }
          }
        });

        function replaceSeparator(character, position) {
          var value = element.val();
          var newValue = value.substr(0, position) + character + value.substr(position);
          ngModel.$setViewValue(newValue);
          ngModel.$render();
        }

        if (attrs.ngCurrency === 'false')
          return;

        attrs.$observe('min', function (v) {
          scope.min = v;
        });
        attrs.$observe('max', function (v) {
          scope.max = v;
        });

        attrs.$observe('ngRequired', function (v) {
          scope.ngRequired = v;
        });

        // attrs.$observe('allowEmpty', function (v) {
        //   scope.allowEmpty = v;
        // });

        attrs.$observe('maxlength', function (v) {
          scope.maxlength = v;
        });

        attrs.$observe('maxAmount', function(v){
          scope.maxAmount = v;
        });

        attrs.$observe('minAmount', function(v){
          scope.minAmount = v;
        });

        // number of decimals - default is 2
        scope.fraction = (typeof attrs.fraction !== 'undefined') ? +attrs.fraction : 2;


        function decimalRex(dChar) {
          return RegExp("\\d|\\-|\\" + dChar, 'g');
        }

        function clearRex(dChar) {
          return RegExp("\\-{0,1}((\\" + dChar + ")|([0-9]{1,}\\" + dChar + "?))&?[0-9]{0," + scope.fraction + "}", 'g');
        }

        function clearValue(value) {
          value = String(value);
          var dSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
          var cleared = null;

          if (value.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP) == -1 &&
              value.indexOf('.') != -1 &&
              scope.fraction)
          {
            dSeparator = '.';
          }

          // Replace negative pattern to minus sign (-)
//          var neg_dummy = $filter('currency')("1", undefined, scope.fraction);
          var neg_regexp = RegExp("[0-9." + $locale.NUMBER_FORMATS.DECIMAL_SEP + $locale.NUMBER_FORMATS.GROUP_SEP + "]+");
//          var neg_dummy_txt = neg_dummy.replace(neg_regexp.exec(neg_dummy), "");
          var value_dummy_txt = value.replace(neg_regexp.exec(value), "");


          if (decimalRex(dSeparator).test(value))
          {
            cleared = value.match(decimalRex(dSeparator))
                .join("").match(clearRex(dSeparator));
            cleared = cleared ? cleared[0].replace(dSeparator, ".") : null;
          }

          return cleared;
        }


        function reformatViewValue() {
          var formatters = ngModel.$formatters,
              idx = formatters.length;

          var viewValue = ngModel.$$rawModelValue;
          while (idx--) {
            viewValue = formatters[idx](viewValue);
          }

          ngModel.$setViewValue(viewValue);
          ngModel.$render();
        }

        ngModel.$parsers.push(function (viewValue) {
          // Validate and only allow numbers, dot and commas
          // TODO: It would be good to allow only one dot or coma decimal separator!
          regex = new RegExp(/^[\d,.]*$/i);
          if (regex.test(viewValue)) {
            oldValue = viewValue;
          } else {
            ngModel.$setViewValue(oldValue);
            ngModel.$render();
          }
          return viewValue;
        });

        ngModel.$parsers.push(function (viewValue) {
          var cVal = clearValue(viewValue);
          // Check for fast digitation (-. or .)
          if (cVal == "." || cVal == "-.")
          {
            cVal = ".0";
          }
          return parseFloat(cVal);
        });

        element.on("blur", function () {
          ngModel.$commitViewValue();
          reformatViewValue();
        });

        ngModel.$formatters.push(function (value) {
          if (value == "" || typeof value == "undefined" || value == null)
            return;
          return $filter('currency')(value, '', scope.fraction).trim();
        });

        ngModel.$validators.min = function (cVal) {
          if (!scope.ngRequired && isNaN(cVal)) {
            return true;
          }
          if (typeof scope.min !== 'undefined') {
            return cVal >= parseFloat(scope.min);
          }
          return true;
        };

        ngModel.$validators.maxAmount = function(cVal) {
          if(cVal > scope.maxAmount) return false;
          return true;
        };


         ngModel.$validators.minAmount = function(cVal) {
          if(cVal < scope.minAmount) return false;
          return true;
        };

        scope.$watch('min', function (val) {
          ngModel.$validate();
        });

        ngModel.$validators.max = function (cVal) {
          if (!scope.ngRequired && isNaN(cVal)) {
            return true;
          }
          if (typeof scope.max !== 'undefined') {
            return cVal <= parseFloat(scope.max);
          }
          return true;
        };

        ngModel.$validators.maxlength = function (cVal) {
          if (scope.allowEmpty && scope.allowEmpty.toLowerCase() == 'true') {
            return true;
          }

          var valueLen;
          if (!cVal)
            return false;

          if (cVal % 1 != 0) {
            valueLen = cVal.toString().length;
          } else {
            // +1 is for dot
            valueLen = cVal.toString().length + scope.fraction + 1;
          }

          if (valueLen > scope.maxlength)
            return false;
          return true;
        };

        scope.$watch('max', function (val) {
          ngModel.$validate();
        });


//        ngModel.$validators.fraction = function (cVal) {
//          if (!!cVal && isNaN(cVal)) {
//            return false;
//          }
//
//          return true;
//        };

        scope.$on('currencyRedraw', function () {
          ngModel.$commitViewValue();
          reformatViewValue();
        });

        element.on('focus', function () {
          var viewValue = ngModel.$$rawModelValue;

          if (isNaN(viewValue) || viewValue === '' || viewValue == null)
          {
            viewValue = '';
          } else
          {
            viewValue = parseFloat(viewValue).toFixed(scope.fraction).toString().replace(".", $locale.NUMBER_FORMATS.DECIMAL_SEP);
          }
          ngModel.$setViewValue(viewValue);
          ngModel.$render();
        });
      }
    };
  }
}());




(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name core.directive:amountFormatter
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="core">
     <file name="index.html">
     <amount-formatter></amount-formatter>
     </file>
     </example>
     *
     */
    amountFormatter.$inject = ["HelperService", "$filter", "$log"];
    angular
        .module('core')
        .directive('amountFormatter', amountFormatter);

    function amountFormatter(HelperService, $filter, $log) {
        return {
            restrict: 'EA',
            scope: {
                amountInput: '@amount',
                customClasses: '@',
                currency: '@',
                fromType: '@',
                hasUnderline: '@',
                aditionalVal: '@'
            },
            templateUrl: 'core/amount-formatter-directive.tpl.html',
            replace: false,
            controllerAs: 'amountFormatter',
            controller: ["$scope", function ($scope) {
                var vm = this;
                vm.amountObj = {};
                vm.customCss = '';
                vm.fontClasses = [];
                vm.hasUnderline = false;

                // use $watch, format needs to be changed on language change!
                $scope.$watchGroup(['amountInput', 'aditionalVal'], function (newValues) {
                    if (!$scope.amountInput) {
                        $scope.amountInput = $filter('currency')(0, "");
                    }
                    var numbers = HelperService.separateDecimals($scope.amountInput || $scope.aditionalVal);
                    if (_.isArray(numbers) && numbers.length > 2) {
                        vm.amountObj.intPart = numbers[0];
                        vm.amountObj.decimal = numbers[2] + numbers[1] + ' ' + $scope.currency;
                        vm.customCss = $scope.customClasses;
                        if ($scope.fromType === 'navigation') {
                            vm.fontClasses = ['f-18 bold-font', 'f-14'];
                        } else if ($scope.fromType === 'dashboard') {
                            vm.fontClasses = ['f-size-35 bold-font', 'f-size-25'];
                        } else if ($scope.fromType === 'addikoKlub') {
                            vm.fontClasses = ['f-20 bold-font', 'f-15'];
                        }
                    }
                    if ($scope.hasUnderline === "true") {
                        vm.hasUnderline = true;
                    } else {
                        vm.hasUnderline = false;
                    }
                });
            }],
            link: function (scope, element, attrs) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */
            }
        };
    }
}());
(function () {
  'use strict';

  /* @ngdoc object
   * @name blockade
   * @description
   *
   */
  angular
    .module('blockade', []);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('blockade')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('blockade', {
        url: '/blockade',
        templateUrl: 'blockade/blockade.tpl.html',
        controller: 'BlockadeCtrl',
        controllerAs: 'vm'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name blockade.factory:Blockade
   *
   * @description
   *
   */
  BlockadeService.$inject = ["EndpointsService", "$http", "$q"];
  angular
    .module('blockade')
    .factory('BlockadeService', BlockadeService);

  function BlockadeService(EndpointsService, $http, $q) {
    var BlockadeServiceBase = {};

    BlockadeServiceBase.validateBlockadeOrder = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.blockadeOrder_validate, data)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    BlockadeServiceBase.createAddikoEBankOrMobileBlockade = function (data) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.blockadeOrder, data)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    return BlockadeServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name blockade.controller:BlockadeCtrl
   *
   * @description
   *
   */
  BlockadeCtrl.$inject = ["SessionService", "HelperService", "BlockadeService"];
  angular
    .module('blockade')
    .controller('BlockadeCtrl', BlockadeCtrl);

  function BlockadeCtrl(SessionService, HelperService, BlockadeService) {
    var vm = this;

    vm.steps = {
      input: true,
      resume: false,
      finish: false
    }

    vm.model = {
      reason: "",
      temporary: false,
      blockWeb: false,
      blockMobile: false,
      dateFrom: "",
      dateTo: "",
      dateCreated: ""
    };

    vm.dateToOptions = {
      minDate: new Date()
    }

    vm.dateFromOptions = {
      minDate: new Date()
    }

    init();
    function init() {
    }

    function createInsertObject() {
      return {
        reason: vm.model.reason,
        temporary: vm.model.temporary,
        blockWeb: vm.model.blockWeb,
        blockMobile: vm.model.blockMobile,
        dateFrom: (vm.model.temporary) ? vm.model.dateFrom : undefined,
        dateTo: (vm.model.temporary) ? vm.model.dateTo : undefined,
        dateCreated: vm.model.dateCreated
      }
    }

    vm.onDateFromChange = function () {
      vm.dateToOptions.minDate = vm.model.dateFrom;
      // if dateTo empty - set dateFrom as default value
      if (!vm.model.dateTo || (vm.model.dateTo.getTime() < vm.model.dateFrom.getTime())) {
        vm.model.dateTo = angular.copy(vm.model.dateFrom);
      }
    }

    vm.next = function () {
      vm.formSubmitted = true;
      if (vm.blockadeForm.$invalid) return;

      vm.model.dateCreated = new Date();
      BlockadeService.validateBlockadeOrder(createInsertObject())
        .then(function (response) {
          vm.steps = {
            input: false,
            resume: true,
            finish: false
          }
        }, function (error) {
          HelperService.showMessage(error, 'error');
        })
    }

    vm.confirm = function () {
      if (vm.blockadeForm.$invalid) return;

      BlockadeService.createAddikoEBankOrMobileBlockade(createInsertObject())
        .then(function (response) {
          vm.steps = {
            input: false,
            resume: false,
            finish: true
          }
        }, function (error) {
          // HelperService.showMessage(error, 'error');
          if (error.resultList.length) {
            if (error.resultList[0].description.search("E_LOGIN_BLOCKED") > -1) {
              SessionService.logout()
            }
          }
        })
    }
  }

}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name alert
   * @description
   *
   */
  angular
    .module('alert', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name alert.factory:AlertService
   *
   * @description
   *
   */
  AlertService.$inject = ["$uibModal"];
  angular
      .module('alert')
      .factory('AlertService', AlertService);

  function AlertService($uibModal) {

    var AlertServiceBase = {};

    AlertServiceBase.infoAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/info-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: ["data", function (data) {
          this.data = data;
        }],
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.confirmationAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/confirmation-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: ["data", function (data) {
          this.data = data;
        }],
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.eInvoiceArchiveAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/archive-einvoice-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: ["data", function (data) {
          this.data = data;
        }],
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    /*
     *  Required data:
     *  {paymentName: "Name"}
     */
    AlertServiceBase.deletedPaymentAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/deleted-payment-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: ["data", function (data) {
          this.data = data;
        }],
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.blockCardAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/block-card-alert.tpl-html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: ["data", function (data) {
          this.data = data;
        }],
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.imageAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/image-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: ["data", function (data) {
          this.data = data;
        }],
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.viberDeactivateAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/viber-deactivation.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: ["data", function (data) {
          this.data = data;
        }],
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.paymentsReturnInfo = function () {
      return $uibModal.open({
        templateUrl: 'alert/payments-return-info.tpl.html',
        size: 'md',
        bindToController: true,
        controllerAs: 'vm',
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.updateMobileSetting = function () {
      return $uibModal.open({
        templateUrl: 'alert/update-mobile-setting.tpl.html',
        size: 'lg',
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.showRejectEDocumentWarning = function () {
      return $uibModal.open({
        templateUrl: 'alert/reject-e-document-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function () {
          var vm = this;
          vm.tempObj = {
            note: ''
          }
        },
        resolve: {

        },
        backdrop: 'static'
      }).result;
    };

    return AlertServiceBase;
  }

}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name alert.controller:AlertCtrl
   *
   * @description
   *
   */
  angular
    .module('alert')
    .controller('AlertCtrl', AlertCtrl);

  function AlertCtrl() {
    var vm = this;
    vm.ctrlName = 'AlertCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name accounts
   * @description
   *
   */
  angular
    .module('accounts', [
      'ui.router',
      'core'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name accounts.directive:transactionsFilter
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="accounts">
   <file name="index.html">
   <transactions-filter></transactions-filter>
   </file>
   </example>
   *
   */
  angular
      .module('accounts')
      .directive('transactionsFilter', transactionsFilter);

  function transactionsFilter() {
    return {
      restrict: 'EA',
      scope: {
        statements: "=statements",
        defaultDates: "=defaultDates"
      },
      bindToController: {
        transactions: "=transactions",
        currenciesList: "=transactionCurrencyList",
        transactionFilterChange: "&transactionFilterChange",
        currency: "=currency",
        allowCustomDatepicker: "=allowCustomDatepicker",
        statementDates: "=statementDates"
      },
      controllerAs: "vm",
      templateUrl: 'accounts/transactions-filter-directive.tpl.html',
      controller: ["$rootScope", "$scope", function ($rootScope, $scope) {
        var vm = this;

        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.showStatementsFilter = false;
        $scope.$watch('statements', function (newValue) {
          vm.showStatementsFilter = newValue;
        }, true);

        $scope.$watch('defaultDates', function (newValue) {
          vm.transactionFilterOptions.dateFrom = newValue.dateFrom;
          vm.transactionFilterOptions.dateTo = newValue.dateTo;
        }, true);
        // Init values
        vm.showFilterOptionsWrapper = false;
        vm.transactionFilterOptions = {
          genericSearch: "",
          transactionType: undefined,
          amountGTE: undefined,
          amountLTE: undefined,
          currencySymbol: undefined,
          dateFrom: undefined,
          dateTo: undefined,
          selectedStatementDate: undefined
        };

        var currency = _.find(vm.currenciesList, {symbol: vm.currency});
        if (currency) {
          vm.transactionFilterOptions.currencySymbol = currency.symbol;
        }

        // if(vm.statementDates){
        //   vm.transactionFilterOptions.selectedStatementDate = vm.statementDates[0];
        // }

        var setDefaultCurrency = function () {
          var currency = _.find(vm.currenciesList, {symbol: vm.currency});
          if (currency) {
            vm.transactionFilterOptions.currencySymbol = currency.symbol;
          }
        };

        // vm.datesFromDisabled = function (date, mode) {
        //   return (mode === 'day' && (date.getTime() < tomorrow));
        // };

        vm.datesToDisabled = function (date, mode) {
          return (mode === 'day' && (date.getTime() < vm.transactionFilterOptions.dateFrom));  // 	polje „Datum do“ je opcionalno polje,  ne smije se unijeti datum manji od onog u polju „Datum od“
        };

        vm.onDateFromChange = function () {
          if (vm.transactionFilterOptions.dateTo < vm.transactionFilterOptions.dateFrom) {
            vm.transactionFilterOptions.dateTo = angular.copy(vm.transactionFilterOptions.dateFrom);
          }
        };


        vm.applyFilter = function () {
          vm.showFilterOptionsWrapper = false;
          vm.transactionFilterChange({filterParams: vm.transactionFilterOptions});
        };

        vm.search = function () {
          vm.transactionFilterChange({filterParams: {genericSearch: vm.transactionFilterOptions.genericSearch}});
        };

        vm.clearSearch = function () {
          vm.transactionFilterOptions.genericSearch = '';
          vm.transactionFilterChange({filterParams: {genericSearch: vm.transactionFilterOptions.genericSearch}});
        };

        vm.resetFilter = function () {
          vm.showFilterOptionsWrapper = false;
          vm.transactionFilterOptions.genericSearch = undefined;
          vm.transactionFilterOptions.transactionType = undefined;
          vm.transactionFilterOptions.amountGTE = undefined;
          vm.transactionFilterOptions.amountLTE = undefined;
          vm.transactionFilterOptions.currencySymbol = undefined;
          vm.transactionFilterOptions.dateTo = undefined;
          vm.transactionFilterOptions.dateFrom = undefined;
          vm.transactionFilterChange({filterParams: vm.transactionFilterOptions});
          setDefaultCurrency();
        };

      }]
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name accounts.factory:TransactionDivisionService
   *
   * @description
   *
   */
  TransactionDivisionService.$inject = ["$http", "$q", "EndpointsService"];
  angular
    .module('accounts')
    .factory('TransactionDivisionService', TransactionDivisionService);

  function TransactionDivisionService($http, $q, EndpointsService) {
    var TransactionDivisionServiceBase = {};
    TransactionDivisionServiceBase.getById = function (id){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.transactionDivisions_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };
    TransactionDivisionServiceBase.getPage = function (params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.transactionDivisions, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };
    TransactionDivisionServiceBase.insertTransaction = function (transactionObj) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.transactionDivisions, transactionObj)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };
    TransactionDivisionServiceBase.updateTransaction = function (id, transactionObj) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.transactionDivisions_id.replace('{id}', id), transactionObj)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };
    TransactionDivisionServiceBase.deleteTransaction = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.delete(response.links.transactionDivisions_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };
    TransactionDivisionServiceBase.signTransaction = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.transactionDivisions_action_sign, {id: id})
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    return TransactionDivisionServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:TransactionDivisionCtrl
   *
   * @description
   *
   */
  TransactionDivisionCtrl.$inject = ["$rootScope", "$filter", "$log", "$state", "$stateParams", "TransactionDivisionService", "ValidationService", "HelperService", "AlertService", "TransactionsService", "ReservationsService"];
  angular
    .module('accounts')
    .controller('TransactionDivisionCtrl', TransactionDivisionCtrl);

  function TransactionDivisionCtrl($rootScope, $filter, $log, $state, $stateParams, TransactionDivisionService, ValidationService,
                                   HelperService, AlertService, TransactionsService, ReservationsService ) {
    var vm = this;
    vm.defaultCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
    var userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
    vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
    vm.installmentRange = ['2', '3', '4', '5', '6', '7','8', '9','10', '11', '12'];
    vm.tempTransDivObj = {
      creationDate: $filter('date')(new Date(), 'shortDate'),
      fullName: userSettings.firstName + ' ' + userSettings.lastName,
      jmbg: userSettings.taxId,
      transactionDate: new Date(),
      amountInput: '',
      installmentNumber: vm.installmentRange[0],
      transactionLocation: '',
      cardNumber: '',
      id: ''
    };

    vm.step = '';
    vm.transactionId = null;
    vm.reservationId = null;

    var forUpdate = false;
    var step2 = false;
    var transactionDivisionFilter = {
      page: 0,
      pageSize: 10,
      orderBy: 'creationDate desc'
    };
    vm.datePickerBeginOpened = false;

    var currentTime = new Date();
    vm.dateOptions = {
      // minDate: HelperService.setCustomNegativeMonthPeriod(new Date(), 1),
      minDate: new Date(currentTime.getFullYear(), currentTime.getMonth(), +1),
      maxDate: new Date()
    };

    vm.transactionDivisionGrouped = [];

    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      }
      , {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }
      , {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }
      , {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }
      , {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
      , {
        item: {
          key: 'all',
          description: 'core.period.all'
        }
      }
    ];

    vm.selectedPeriod = vm.periodList[3];

    //set time filter to current month
    var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
    transactionDivisionFilter.creationDateGTE = timeRange.valueDateGTE;
    transactionDivisionFilter.creationDateLTE = timeRange.valueDateLTE;

    function loadTransactionDivisions (reset) {
      if(reset){
        transactionDivisionFilter.page=0;
      } else {
        transactionDivisionFilter.page++;
      }
      TransactionDivisionService.getPage(transactionDivisionFilter)
        .then(function (response){
          vm.transactionDivisionGrouped = HelperService.mergeRowsForTimeline({
            existingData: vm.transactionDivisionGrouped,
            newData: response,
            groupFunction: function (item) {
              var date = new Date(item.creationDate);
              date.setHours(0,0,0,0);
              return date;
            },
            virtualRowFunction: function (e) {
              var month = new Date(e).getMonth() + 1;
              var day = new Date(e).getDate();
              var virtualRow = {
                isVirtual: true,
                date: new Date(e),
                month: month,
                day: day
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: false
          });
          $log.debug("Transaction division grouped: " + vm.transactionDivisionGrouped);
        })
        .catch(function (){

        });
    };

    vm.timelineTimeFilter = function (period) {
      vm.selectedPeriod = period;
      var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      transactionDivisionFilter.creationDateGTE = timeRange.valueDateGTE;
      transactionDivisionFilter.creationDateLTE = timeRange.valueDateLTE;
      loadTransactionDivisions(true);
    };

    vm.loadMoreTimelineItems = function (){
      loadTransactionDivisions(false);
    };


    function init() {
      vm.step = '';
      vm.transactionId = $state.params.transactionId;
      vm.reservationId = $state.params.reservationId;
      if((vm.transactionId) && !forUpdate){

        TransactionsService.getById(vm.transactionId || vm.reservationId, {includeList: ['TransactionDivision']})
          .then(function (response) {
            populateFields(response);
          }, function (error) {
            HelperService.showMessage(error, 'error');
          });
      }else if(vm.reservationId  && !forUpdate){
        ReservationsService.getById(vm.reservationId, {includeList: ['TransactionDivision']})
          .then(function (response) {
            populateFields(response);
          }, function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
      loadTransactionDivisions(true);
    }

    function populateFields(transaction) {
      //vm.tempTransDivObj = transaction;
      vm.tempTransDivObj.transactionDate = new Date(transaction.valueDate);
      vm.tempTransDivObj.amountInput = transaction.amount;
      // vm.tempTransDivObj.transactionLocation = transaction.transactionLocation;
      // vm.tempTransDivObj.cardNumber = transaction.cardNumber;
      vm.tempTransDivObj.cardNumber =  $state.params.card;
      vm.tempTransDivObj.reservationID = transaction.reservationID;
    }

    function createInsertObject () {
      return {
        installmentNumber: vm.tempTransDivObj.installmentNumber,
        amount: vm.tempTransDivObj.amountInput,
        transactionLocation: vm.tempTransDivObj.transactionLocation,
        cardNumber: vm.tempTransDivObj.cardNumber,
        valueDate: vm.tempTransDivObj.transactionDate
      }
    };


    vm.confirm = function () {
      vm.formSubmitted = true;
      if (!vm.tDivForm.$valid) {
        return;
      }
      var insertObj = createInsertObject();

      if(vm.transactionId){
        insertObj.trasactionId = vm.transactionId;
        insertObj.reservationID = vm.tempTransDivObj.reservationID;
      }else if(vm.reservationId){
        insertObj.reservationID = vm.reservationId;
      }

      if (forUpdate) {
        //update transaction division
        insertObj.id = vm.postResponseObj.id;
        TransactionDivisionService.updateTransaction(vm.postResponseObj.id, insertObj)
          .then(function (response) {
            postPaymentAction(response);
          })
          .catch(function (error){
            HelperService.showMessage(error, 'error');
          });
      } else {
        //insert transaction division
        TransactionDivisionService.insertTransaction(insertObj)
          .then(function (response) {
            postPaymentAction(response);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    function postPaymentAction(response) {
      vm.postResponseObj = response;
      step2 = true;
      $state.go('transactionDivison.resume', {
        resume: step2
      });
      forUpdate = false;
    }

    function clearInput () {
      vm.tempTransDivObj.amountInput = '';
      vm.tempTransDivObj.cardNumber = '';
      vm.tempTransDivObj.transactionDate = new Date();
      vm.tempTransDivObj.installmentNumber = vm.installmentRange[0];
      vm.tempTransDivObj.transactionLocation = '';
    }

    vm.new = function () {
      clearInput();
      vm.formSubmitted = false;
      forUpdate = false;
      step2 = false;
      vm.transactionId = null;
      $state.go('transactionDivison.create');
      loadTransactionDivisions(true);
    };

    function mapWithPaymentResponse () {
      vm.tempTransDivObj.amountInput = vm.postResponseObj.amount;
      vm.tempTransDivObj.cardNumber = vm.postResponseObj.cardNumber;
      vm.tempTransDivObj.transactionDate = new Date(vm.postResponseObj.valueDate);
      vm.tempTransDivObj.installmentNumber = _.find(vm.installmentRange, function (item){
        return item == vm.postResponseObj.installmentNumber;
      });
      vm.tempTransDivObj.transactionLocation = vm.postResponseObj.transactionLocation;
      //vm.tempTransDivObj.id = vm.postResponseObj.id;
    };

    vm.edit = function () {
      forUpdate = true;
      step2 = false;
      mapWithPaymentResponse();
      $state.go('transactionDivison.create', {transactionId: vm.transactionId});
      loadTransactionDivisions(true);
    };

    vm.delete = function (id) {
      var objId = id || vm.postResponseObj.id;
      forUpdate = false;
      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            TransactionDivisionService.deleteTransaction(objId)
              .then(function (response) {
                AlertService.deletedPaymentAlert({
                    paymentName: objId,
                    type: 'payment'
                  })
                  .then(function () {
                    if(vm.transactionId) {
                      $state.go('transactionDivison.create', {transactionId: vm.transactionId});
                      init();
                    }
                    else{
                      $state.go('transactionDivison.create');
                      clearInput();
                      vm.formSubmitted = false;
                      loadTransactionDivisions(true);
                    }


                  });
              })
              .catch(function (error) {
                HelperService.showMessage(error, 'error');
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });
    };

    vm.sign = function (id) {
      var objId = id || vm.postResponseObj.id;
      TransactionDivisionService.signTransaction(objId)
        .then(function (response) {
          vm.step = 'final';
          $state.go('transactionDivison.final',
            {
              final: true
            });
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.editFromTimeline = function (id){
      TransactionDivisionService.getById(id)
        .then(function(response){
          vm.postResponseObj = response;
          mapWithPaymentResponse();
          forUpdate = true;
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        });
    };

    vm.goToCreatePage = function () {
      vm.step = '';
      clearInput();
      vm.formSubmitted = false;
      $state.go('transactionDivison.create');
    };

    init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:SavingsSloCtrl
   *
   * @description
   *
   */
  SavingsSloCtrl.$inject = ["$filter"];
  angular
    .module('accounts')
    .controller('SavingsSloCtrl', SavingsSloCtrl);

  function SavingsSloCtrl($filter) {
    var vm = this;

    vm.currencySymbol = "EUR";

    vm.vrstaVracevanja = [
      {value: "0", name:"ADDIKO VARČEVALNI RAČUN 5 DNI" },
      {value: "1", name:"ADDIKO VARČEVANJE PLUS"}
    ];
    vm.durationInMonths = [
      {value: "12", name:"12" },
      {value: "24", name:"24"}
    ];
    vm.standingOrderDays = [
      {value: "4", name:"4" },
      {value: "8", name:"8."}
    ];


    vm.vrstaVracevanjaSelect = vm.vrstaVracevanja[0];
    vm.durationInMonthsSelect = vm.durationInMonths[0];
    vm.standingOrderDaysSelect = vm.standingOrderDays[0];
    vm.maturityDate = $filter('date')(new Date(), 'shortDate');

    vm.realInterestRate = "2.33%";
    vm.totalInterestRate = "2.33%";



  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name accounts.service:ReservationsService
   *
   * @description
   *
   */
  ReservationsService.$inject = ["EndpointsService", "$q", "$http", "$log", "HelperService"];
  angular
    .module('accounts')
    .service('ReservationsService', ReservationsService);

  function ReservationsService(EndpointsService, $q, $http, $log, HelperService) {
    var ReservationsServiceBase = {};

    ReservationsServiceBase.getPage = function(params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function(response){
        //$log.debug("Params:", params);
        $http.get(response.links.cardReservation, { params: params})
          .success(function(data) {
            deferred.resolve(data);
          }).error(function(msg, code) {
            deferred.reject(msg);
          });
      }, function(error){
        deferred.reject(error);
      });
      return deferred.promise;
    };


    ReservationsServiceBase.getById = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.cardReservation_id.replace('{id}', id), {params: params})
          .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    return ReservationsServiceBase;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:NewEBookSavingsDividerCtrl
   *
   * @description
   *
   */
  NewEBookSavingsDividerCtrl.$inject = ["$rootScope"];
  angular
    .module('accounts')
    .controller('NewEBookSavingsDividerCtrl', NewEBookSavingsDividerCtrl);

  function NewEBookSavingsDividerCtrl($rootScope) {
    var vm = this;
    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:NewEBookCtrl
   *
   * @description
   *
   */
  NewEBookCtrl.$inject = ["$rootScope", "CTLocalizationService", "AccountsService", "$state", "$log", "ESavingBookRequestsService", "$localStorage", "HelperService", "PaymentFilterService", "Notification", "ConfigEndpointService", "AlertService", "GoogleTagManagerHelperService", "$location"];
  angular
    .module('accounts')
    .controller('NewEBookCtrl', NewEBookCtrl);

  function NewEBookCtrl($rootScope, CTLocalizationService, AccountsService, $state, $log, ESavingBookRequestsService,
                         $localStorage, HelperService, PaymentFilterService, Notification, ConfigEndpointService, AlertService,GoogleTagManagerHelperService,$location) {
    var vm = this;
    vm.ctrlName = 'NewEBookCtrl';
    vm.forUpdate = false;
    vm.currentStep = 1;
    vm.countryCode = $localStorage.code;
    vm.generalTerms = $state.params.myParam;
    vm.eBookRequests = true;
    vm.tempObj = {
      fromAccountSelect: {},
      nameInput: '',
      formSubmitted: false,
      checked: false
    };

    vm.eSavingBookRequestsFilter = {};
    vm.allRequests = false;
    vm.fromAccountDropdown = false;
    vm.accountsFrom = [];

    vm.currentAccountFilter = {
      page: 0,
      pageSize: 1000,
      accountTypeGroup: 'CurrentAccount',
      currencySymbol: ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "hr") ? "HRK" : null
    };

    vm.toggleFromAccount = function () {
      vm.fromAccountDropdown = !vm.fromAccountDropdown;
    };

    vm.getCurrentAccountPage = function () {
      AccountsService.getPage(vm.currentAccountFilter)
        .then(function (response) {
          vm.accountsFrom = response.result;
          if (vm.accountsFrom.length > 0) {
            vm.tempObj.fromAccountSelect = PaymentFilterService.filterFromAccountSelect(vm.accountsFrom, $state.params.accountId);
            if (vm.allRequests === false) {
              vm.eSavingBookRequestsFilter = {
                page: 0,
                pageSize: 10,
                accountId: vm.tempObj.fromAccountSelect.accountId,
                orderBy: 'dateOfCreation desc'
              };
            } else {
              vm.eSavingBookRequestsFilter = {
                page: 0,
                pageSize: 10,
                orderBy: 'dateOfCreation desc'
              };
            }
          }
        })
        .catch(function (error) {
          $log.error(error);
        });
    };

    var createPaymentObject = function () {
      return {
        eSavingBookName: vm.tempObj.nameInput,
        mainAccountId: vm.tempObj.fromAccountSelect.accountId
      };
    };


      var sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
       $rootScope.$on('appLanguageChangedHeader', function () {
         sweetAlertOptions = CTLocalizationService.getSweetAlertOptions();
       });

       vm.deletePayment = function () {
         //swal({
         //  title: sweetAlertOptions.areYouSure,
         //  type: "info",
         //  showCancelButton: true,
         //  confirmButtonClass: "btn-default",
         //  confirmButtonText: sweetAlertOptions.yes,
         //  cancelButtonText: sweetAlertOptions.no,
         //  closeOnConfirm: true,
         //  closeOnCancel: true
         //}, function (isConfirm) {
         //  if (isConfirm) {
         //   ESavingBookRequestsService.deleteESavingBookRequest(vm.insertedPaymentObject.id)
         //     .then(function (response) {
         //       HelperService.deleteInformationMsg(['core.ebookOrder', 'core.successDelete'], vm.insertedPaymentObject.id);
         //       $state.go('dashboard');
         //     })
         //     .catch(function (error) {
         //       HelperService.showMessage(error, 'error');
         //     });
         //  }
         //});

         AlertService.confirmationAlert()
           .then(function (result) {
             if (result) {
                  ESavingBookRequestsService.deleteESavingBookRequest(vm.insertedPaymentObject.id)
                    .then(function (response) {
                      AlertService.deletedPaymentAlert({paymentName: vm.insertedPaymentObject.id, type: 'eSavingBook'})
                        .then(function () {
                          $state.go('dashboard');
                        });
                    })
                    .catch(function (error) {
                      HelperService.showMessage(error, 'error');
                    });
             }
           })
           .catch(function () {
             $log.debug('Example failed!');
           });

       };

    var mapWithPaymentResponse = function () {
      vm.tempObj.nameInput = vm.insertedPaymentObject.eSavingBookName;
      vm.tempObj.checked = false;
    };

    vm.editPayment = function () {
      vm.forUpdate = true;
      vm.currentStep = 1;
      mapWithPaymentResponse();
    };

    vm.insertedPaymentObject = {};
    var postPaymentAction = function (response) {

      vm.insertedPaymentObject = response;
      vm.insertedPaymentObject.createdBy = response.createdBy;
      vm.insertedPaymentObject.dateOfCreation = response.dateOfCreation;
      vm.insertedPaymentObject.id = response.id;
      vm.insertedPaymentObject.mainAccountNumber = response.mainAccountNumber;
      vm.insertedPaymentObject.eSavingBookName = response.eSavingBookName;
      Notification.clearAll();

    };

    vm.newRequestSubmit = function () {
      vm.tempObj.formSubmitted = true;
      if (!vm.newEBookForm.$valid) {
        return;
      }
      var tempEbookObj = createPaymentObject();

      if (vm.forUpdate) {
        tempEbookObj.id = vm.insertedPaymentObject.id;
        ESavingBookRequestsService.updateESavingBookRequest(vm.insertedPaymentObject.id, tempEbookObj)
          .then(function (response) {
            postPaymentAction(response);
            vm.currentStep = 2;
            vm.forUpdate = false;
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
            vm.forUpdate = false;
          });
      } else {
        ESavingBookRequestsService.insertEbook(tempEbookObj)
          .then(function (response) {
            postPaymentAction(response);
            vm.currentStep = 2;
            var gtmObject = HelperService.processUrlForGTM('payment');
            GoogleTagManagerHelperService.pushVirtualPageView(gtmObject.url, gtmObject.title, $location.host() + gtmObject.url);
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          });
      }
    };

    vm.setAccountFrom = function (item) {
      vm.tempObj.fromAccountSelect = item;
      vm.fromAccountDropdown = false;
      vm.loadRequestsOnCheckbox();
    };

    vm.sign = function () {
      ESavingBookRequestsService.signESavingBookRequest(vm.insertedPaymentObject.id)
        .then(function (response) {
          vm.currentStep = 3;
          GoogleTagManagerHelperService.pushEvent('NewEbook', 'NewEbookRequestSubmited', 'New Ebook request submited successfully');
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    var filterEBookSavingRequest = function (reset) {
      if (vm.eBookSavingsRequests.result && vm.eBookSavingsRequests.result.length > 0) {
        vm.eBookSavingsGrouped = HelperService.mergeRowsForTimeline({
          existingData: vm.eBookSavingsGrouped,
          newData: vm.eBookSavingsRequests,
          groupFunction: function (item) {
            var date = new Date(item.dateOfCreation);
            date.setHours(0, 0, 0, 0);
            return date;
          },
          virtualRowFunction: function (e) {
            var month = new Date(e).getMonth() + 1;
            var day = new Date(e).getDate();
            var virtualRow = {
              isVirtual: true,
              date: new Date(e),
              month: month,
              day: day
            };
            $log.debug("virtualRow", e, virtualRow);
            return virtualRow;
          },
          reset: reset,
          reverse: false
        });
        $log.debug("eBookSavingsGrouped", vm.eBookSavingsGrouped);
      }
    };

    var loadeSavingBookRequests = function (reset) {
      if (reset) {
        vm.eSavingBookRequestsFilter.page = 0;
      } else {
        vm.eSavingBookRequestsFilter.page += 1;
      }

      ESavingBookRequestsService.getESavingBookRequests(vm.eSavingBookRequestsFilter)
        .then(function (response) {
          vm.eBookSavingsRequests = response;
          filterEBookSavingRequest(reset);
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.loadMoreSavingBookRequests = function () {
      loadeSavingBookRequests(false);
    };


    vm.displayeBookSavingRequest = true;
    /* vm.showeSavingBookRequests = function (){
      vm.displayeBookSavingRequest = !vm.displayeBookSavingRequest;
    };
*/
    vm.loadRequestsOnCheckbox = function () {
      if (vm.allRequests === false) {
        vm.eSavingBookRequestsFilter = {
          page: 0,
          pageSize: 10,
          accountId: vm.tempObj.fromAccountSelect.accountId,
          orderBy: 'dateOfCreation desc'
        };
      } else {
        vm.eSavingBookRequestsFilter = {
          page: 0,
          pageSize: 10,
          orderBy: 'dateOfCreation desc'
        };
      }
      loadeSavingBookRequests(true);
    };

    var getDefaultData = function () {
      return ConfigEndpointService.getDefaultData()
        .then(function (response) {
        if (response.APILocation) {
          vm.generalTerms = response.GeneralTerms;
        }
      })
        .catch(function (error) {
        HelperService.showMessage(error, 'error');
      });
    };

    vm.init = function () {
      vm.getCurrentAccountPage();
      if(!$state.params.myParam) {
        getDefaultData();
      }
      if (vm.countryCode === 'hr') {
        loadeSavingBookRequests(true);
      }
    };
      
    vm.pushGtmLinkEvent = function (link) {
        GoogleTagManagerHelperService.pushEvent('NewEbook', 'ExternalLink', link);
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:MasterCardOrderLimitCtrl
   *
   * @description
   *
   */
  MasterCardOrderLimitCtrl.$inject = ["$q", "$state", "$translate", "AlertService", "HelperService", "AccountsService", "UserSettingsService"];
  angular
    .module('accounts')
    .controller('MasterCardOrderLimitCtrl', MasterCardOrderLimitCtrl);

  function MasterCardOrderLimitCtrl($q, $state, $translate, AlertService, HelperService, AccountsService, UserSettingsService) {
    var vm = this;
    vm.ctrlName = 'MasterCardOrderLimitCtrl';

    vm.step = 1;

    vm.selectedAccount = {
      currencySymbol: 'EUR'
    };


    vm.cardTypes = [
      {id: 'basic',description:'masterCardOrder.basic'},
      {id: 'additional',description:'masterCardOrder.additional'}
    ];

    vm.selectedAccount.cardType = vm.cardTypes[0];

    vm.tempObj = {
      dateFrom: new Date(),
      dateTo: new Date()
    };
    vm.dateOptions = {
      dateFrom: {
        minDate: new Date()
      },
      dateTo: {
        //
      }
    };

    vm.tempObj = {
      cardAccount: ''
    };

    var selectCardbyId = function (id) {
      var card = _.find(vm.selectedAccount.cardList, function (item) {
        return item.cardId == id;
      });
      if(card)
        vm.selectedAccount.selectedCard = card;
      else
        vm.selectedAccount.selectedCard = vm.selectedAccount.cardList[0];

    };

    function loadPerceontOfLimitTypes() {
      var params = null;
      return AccountsService.creditCardLimitOrderPercentOfLimitType(params)
        .then(function (response) {
          vm.limits = response.result;
          vm.tempObj.limit = vm.limits[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }
    function loadLimitTypeTypes() {
      var params = null;
      return AccountsService.creditCardLimitOrderLimitTypeType(params)
        .then(function (response) {
          vm.limitTypes = response.result;
          vm.tempObj.limitType = vm.limitTypes[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    var init = function () {
      var params = {
        includeList: ['CardAccount','cardList','ParentAccount'],
        isOwn: true
      };
      var promises = [
        AccountsService.getAccountById($state.params.accountId,params),
        UserSettingsService.getPage({pageSize: 1000}),
        loadPerceontOfLimitTypes(),
        loadLimitTypeTypes()
      ];

      $q.all(promises).then(function(responses){
        vm.selectedAccount = responses[0];
        selectCardbyId($state.params.cardId);

        //TODO
        vm.selectedAccount.cardType = vm.cardTypes[vm.selectedAccount.selectedCard.cardType]; // 0 for basic , 1 for additional

        vm.tempObj.cardAccount = vm.selectedAccount.accountNumber + " " + vm.selectedAccount.friendlyName;

          vm.userSettings = responses[1].result[0];
      }).catch(function(error){
        HelperService.showMessage(error, 'error');
      });
    };

    function createObject () {

      var tempObj = {
        "amount": vm.tempObj.amount,
        "cardNumber": vm.selectedAccount.selectedCard.cardNumber,
        "cardType": vm.selectedAccount.selectedCard.cardType,
        "limitType": {
          "id": vm.tempObj.limitType.id,
          "description": vm.tempObj.limitType.description
        },
        "emailAddress": vm.userSettings.email,
        "note": " ",
        "accountId": vm.selectedAccount.accountId,
        "limitTypeTempDateFrom": new Date(),
        "limitTypeTempDateTo": new Date()
      };

      if(vm.selectedAccount.cardType.id == 'additional'){
        tempObj.percentOfLimit =  {
          "id": vm.tempObj.limit.id,
          "description": vm.tempObj.limit.description
        };
      }

      if(vm.tempObj.limitType.id == 'Temporary'){
        tempObj.limitTypeTempDateFrom = vm.tempObj.dateFrom;
        tempObj.limitTypeTempDateTo = vm.tempObj.dateTo;
      }

      return tempObj;
    }

    vm.validate = function () {
      if (vm.nextButtonPressed) return;
      vm.formSubmitted = true;
      if(!vm.masterCardOrderForm.$valid){
        return;
      }
      vm.insertedOrderObject = createObject();
      vm.nextButtonPressed = true;
      AccountsService.validateCreditCardLimitOrder(vm.insertedOrderObject)
        .then(function (response) {
          vm.step = 2;
          vm.insertedOrderObject = angular.extend(response);
          // amount missing in response
          vm.insertedOrderObject.amount = vm.tempObj.amount;
        }, function (error) {
          HelperService.showMessage(error, 'error');
        })
        .finally(function () {
          vm.nextButtonPressed = false;
        });
    };
    vm.confirm = function () {
      if (vm.confirmButtonPressed) return;
      vm.confirmButtonPressed = true;
      AccountsService.creditCardLimitOrder(vm.insertedOrderObject)
        .then(function (response) {
          AlertService.infoAlert({
            text: 'orderSoftToken.successTxt'
          })
            .then(function () {
              vm.goBackToAccount();
            });
        }, function (error) {
          HelperService.showMessage(error, 'error');
        })
        .finally(function () {
          vm.confirmButtonPressed = true;
        });
    };
    vm.edit = function () {
      vm.step = 1;
    };

    vm.goBackToAccount = function () {
      $state.go('accounts', {
        accountId: $state.params.accountId
      });
    };

    init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:MasterCardNewCtrl
   *
   * @description
   *
   */
  MasterCardNewCtrl.$inject = ["$q", "$log", "$state", "$rootScope", "AccountsService", "HelperService", "UserSettingsService", "AlertService"];
  angular
    .module('accounts')
    .controller('MasterCardNewCtrl', MasterCardNewCtrl);

  function MasterCardNewCtrl($q, $log, $state, $rootScope, AccountsService, HelperService, UserSettingsService, AlertService) {
    var vm = this;
    vm.ctrlName = 'MasterCardNewCtrl';
    vm.tempObj = {};
    vm.selectedAccount = {};
    vm.accountList = [];
    vm.cardTypes = [];
    vm.paymentDays = [];
    vm.percentTypes = [];
    vm.currencySymbol = 'EUR';
    vm.formSubmitted = false;
    vm.step = 1;

    vm.insertedOrder = {};

    function loadCardTypes() {
      var params = null;
      return AccountsService.newCreditCardOrderCardTypeType(params)
        .then(function (response) {
          vm.cardTypes = response.result;
          vm.tempObj.cardType = vm.cardTypes[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }
    function loadPaymentDays() {
      var params = null;
      return AccountsService.newCreditCardOrderTearDateType(params)
        .then(function (response) {
          vm.paymentDays = response.result;

          _.each(vm.paymentDays,function (item) {
            console.log('Int parse',item.description.replace('.',''));
            item.description = parseInt(item.description.replace('.','')); //15.11.2016 backend doesnt sort numbers in string format properly :(
          });
          vm.paymentDays.sort(function (a, b) {
            return a.description - b.description;
          });

          vm.tempObj.paymentDay = vm.paymentDays[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }
    function loadPercentTypes() {
      var params = null;
      return AccountsService.newCardOrderMonthlyShareOfLiabilitiesType(params)
        .then(function (response) {
          vm.percentTypes = response.result;
          vm.tempObj.percentType = vm.percentTypes[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function init() {
      var promises = [
        AccountsService.getPage({accountTypeGroupList: 'CurrentAccount', isOwn: true}),
        UserSettingsService.getPage(),
        loadCardTypes(),
        loadPaymentDays(),
        loadPercentTypes()
      ];

      $q.all(promises).then(function(responses){
        //vm.accountList = responses[0].result;
        setAccountsToDefaultCurrency(responses[0].result);
        vm.tempObj.userSettings = responses[1].result[0];

      }).catch(function(error){
        HelperService.showMessage(error, 'error');
      });

    }
    function setAccountsToDefaultCurrency(list) {
      if(list){
        var accs = _.filter(list, function (item) {
          return item.currencySymbol == $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
        });
        if (accs)
          vm.accountList = accs;
          vm.selectedAccount = vm.accountList[0];
      }
      else{
        vm.accountList = [];
      }
    }

    vm.selectAccount = function (account) {
      if (!account) return;
      vm.selectedAccount = account;
    };

    function createObject() {
      var temp = {
        creditCardType:{
          id:vm.tempObj.cardType.id,
          description: vm.tempObj.cardType.description
        },
        phoneNumber:vm.tempObj.userSettings.gsm,
        email:vm.tempObj.userSettings.email,
        taxId:vm.tempObj.userSettings.taxId,
        nameAndSurname:vm.tempObj.userSettings.firstName+ " "+ vm.tempObj.userSettings.lastName,
        limitAmount:vm.tempObj.amount,
        orderTearDate:{
          id: vm.tempObj.paymentDay.id,
          description:vm.tempObj.paymentDay.description
        },
        account: vm.selectedAccount.iban,
        note: " "
      };

      if(vm.tempObj.cardType.id == 'creditMasterCard'){
        temp.monthlyShareOfLiabilities = vm.tempObj.percentType;
      }

      return temp;
    }


    vm.validateMasterCardNew = function () {
      if (vm.nextButtonPressed) return;
      vm.formSubmitted = true;
      if (!vm.masterCardForm.$valid) {
        return;
      }
      vm.insertedOrder = createObject();

      //TODO: Trenutno je POST metoda, nije validate (PUT)
      vm.nextButtonPressed = true;
      AccountsService.validateNewCreditCardOrder(vm.insertedOrder)
        .then(function (response) {
          vm.insertedOrder = angular.extend(response);
          vm.step = 2;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function() {
        vm.nextButtonPressed = false;
      });
    };
    vm.confirmMasterCardNew = function () {
      if (vm.confirmButtonPressed) return;

      vm.confirmButtonPressed = true;
      AccountsService.newCreditCardOrder(vm.insertedOrder)
        .then(function (response) {
          AlertService.infoAlert({
            text: 'orderSoftToken.successTxt'
          })
            .then(function () {
              $state.go('accountsOverview');
            });
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function() {
        vm.confirmButtonPressed = false;
      });
    };
    vm.editMasterCardNew = function () {
      vm.step = 1;
    };



    init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:LoansOverviewCtrl
   *
   * @description
   *
   */
  LoansOverviewCtrl.$inject = ["AccountsService", "$state", "$localStorage"];
  angular
    .module('accounts')
    .controller('LoansOverviewCtrl', LoansOverviewCtrl);

  function LoansOverviewCtrl(AccountsService, $state, $localStorage) {

    var vm = this;
    var accounts;
    vm.countryCode = $localStorage.code;

    init();
    function init() {

      loadData();
    }

    // region Private methods

    function loadData() {
      AccountsService.getPage({
        pageSize: 1000,
        page: 0,
        accountTypeGroupList: ["LoanAccountType"],
        orderby: "iban DESC",
        includeList: ['loanAccount']
      })
        .then(function (response) {
          vm.accounts = response.result;
        })
    }

    vm.goToAccount = function (accountId) {
      $state.go('accounts', {
        accountId: accountId
      });
    };

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name accounts.factory:ESavingBookRequestsService
   *
   * @description
   *
   */
  ESavingBookRequestsService.$inject = ["$q", "$sessionStorage", "EndpointsService", "$http", "SessionService"];
  angular
    .module('accounts')
    .factory('ESavingBookRequestsService', ESavingBookRequestsService);

  function ESavingBookRequestsService($q, $sessionStorage, EndpointsService, $http, SessionService) {
    var ESavingBookRequestsServiceBase = {};

    if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'savingBook'){
      insert($sessionStorage.paymentStorageObject.object);
    }

    function insert(eBook) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          SessionService.saveStorageObject(eBook, 'savingBook');
          $http.post(response.links.eSavingBookRequests, eBook)
            .success(function (data) {
              SessionService.removeStorageObject();
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    ESavingBookRequestsServiceBase.insertEbook = function (eBook) {
      return insert(eBook);
    };

    ESavingBookRequestsServiceBase.getESavingBookRequests = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.eSavingBookRequests, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    ESavingBookRequestsServiceBase.deleteESavingBookRequest = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.delete(response.links.eSavingBookRequests_id.replace('{id}', id))
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    ESavingBookRequestsServiceBase.updateESavingBookRequest = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.eSavingBookRequests_id.replace('{id}', id), params)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };

    ESavingBookRequestsServiceBase.signESavingBookRequest = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.eSavingBookRequests_sign, {id: id})
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    };



    return ESavingBookRequestsServiceBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name accounts.controller:DepositAccountsOverviewCtrl
     *
     * @description
     *
     */
    DepositAccountsOverviewCtrl.$inject = ["$rootScope", "$state", "AccountsService", "GoogleTagManagerHelperService", "$translate"];
    angular
        .module('accounts')
        .controller('DepositAccountsOverviewCtrl', DepositAccountsOverviewCtrl);

    function DepositAccountsOverviewCtrl($rootScope, $state, AccountsService, GoogleTagManagerHelperService, $translate) {
        var vm = this;
        var accounts;
        vm.depositAccounts = []; // object array

        init();

        function init() {
            vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
            getAllAccountsAndCards();
        }

        // region Private methods

        function getAllAccountsAndCards() {
            AccountsService.getPage({
                    pageSize: 1000,
                    page: 0,
                    accountTypeGroupList: ["DepositAccountTypes", "SavingAccountTypes"],
                    orderby: "accountType"
                })
                .then(function (response) {
                    vm.accounts = response.result;
                })
        }

        vm.goToAccount = function (accountId) {
            $state.go('accounts', {
                accountId: accountId
            });
        };

        vm.pushGtmNavEvent = function (type) {
            if (type == 'termDeposit') {
                GoogleTagManagerHelperService.pushEvent('DepositAccountsOverview', 'NewTermDeposit', $translate.instant("accountsOverview.newTermDepositButtonLabel"));
            } else {
                if (vm.countryCode == 'sl') {
                    GoogleTagManagerHelperService.pushEvent('DepositAccountsOverview', 'NewEbook', $translate.instant("accountsOverview.newSavingButtonLabel_SLO"));
                } else {
                    GoogleTagManagerHelperService.pushEvent('DepositAccountsOverview', 'NewEbook', $translate.instant("accountsOverview.newESavingAccountButtonLabel"));
                }

            }
        };
    }
}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:ConnectedCardsBlockModalCtrl
   *
   * @description
   *
   */
  angular
    .module('accounts')
    .controller('ConnectedCardsBlockModalCtrl', ConnectedCardsBlockModalCtrl);

  function ConnectedCardsBlockModalCtrl() {
    var vm = this;
    vm.ctrlName = 'ConnectedCardsBlockModalCtrl';
    console.log("Ja sam modal");
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:CloseEBookCtrl
   *
   * @description
   *
   */
  CloseEBookCtrl.$inject = ["$rootScope", "$state", "$stateParams", "$translate", "AccountsService", "HelperService", "AlertService"];
  angular
    .module('accounts')
    .controller('CloseEBookCtrl', CloseEBookCtrl);

  function CloseEBookCtrl($rootScope, $state, $stateParams, $translate, AccountsService, HelperService, AlertService) {
    var vm = this;
    vm.model;
    var accountId;
    var sweetAlertOptions;
    vm.ebookName = '';
    vm.ebookNumber = '';
    vm.transferToAccount = '';

    init();

    function init() {
      vm.model = {};
      sweetAlertOptions = {};
      accountId = $stateParams.accountId;
      translateSweetAlert();
      loadData();
    }

    function loadData() {
      AccountsService.eSavingBookCloseOverview(accountId)
        .then(function (response) {
          vm.eSavingBookCloseList = response.eSavingBookCloseList;
          /*
           * DUMMY DATA
           * */
         /* vm.eSavingBookCloseList = [
            {
              accountId: '101062893-6240070073',
              accountName: "TEST VLASNIK RAČUNA"
          },
            {
              balance: 2500,
              currencySymbol: "HRK",
              recognisedInterestAmount: 59.94,
              recognisedInterestRate: 1.75,
              transferAccount: "3210043150",
              transferAmount: 2559.94
          },
            {
              balance: 927.45,
              currencySymbol: "EUR",
              recognisedInterestAmount: 59.94,
              recognisedInterestRate: 6,
              transferAccount: "3210043150",
              transferAmount: 931.94
          }
        ];
*/
          if (vm.eSavingBookCloseList.length > 0) {
            vm.ebookName = vm.eSavingBookCloseList[0].accountName;
            vm.ebookNumber = vm.eSavingBookCloseList[0].accountId;
            vm.transferToAccount = vm.eSavingBookCloseList[1].transferAccount;
            var tempList = [];
            for (var i = 1; i < vm.eSavingBookCloseList.length; i++) {
              tempList[i-1] = vm.eSavingBookCloseList[i];
            }
            vm.eSavingBookCloseList = tempList;
          }
        }, function (error) {});
    }

    function translateSweetAlert() {
      $translate(["core.sweetAlertTranslation.yes", "core.sweetAlertTranslation.no", "core.sweetAlertTranslation.areYouSure"]).then(function (translations) {
        sweetAlertOptions.yes = translations["core.sweetAlertTranslation.yes"];
        sweetAlertOptions.no = translations["core.sweetAlertTranslation.no"];
        sweetAlertOptions.areYouSure = translations["core.sweetAlertTranslation.areYouSure"];
      });
    }

    /*
     * Triggered when language is changed
     * */
    $rootScope.$on("appLanguageChangedHeader", function () {
      translateSweetAlert();
    });

    vm.confirm = function () {
      //swal({
      //    title: sweetAlertOptions.areYouSure,
      //    type: "info",
      //    showCancelButton: true,
      //    confirmButtonClass: "btn-default",
      //    confirmButtonText: sweetAlertOptions.yes,
      //    cancelButtonText: sweetAlertOptions.no,
      //    closeOnConfirm: true,
      //    closeOnCancel: true
      //  },
      //  function (isConfirm) {
      //    if (isConfirm) {
      //      AccountsService.updateAccount(accountId, {
      //          "closeESavingBook": true
      //        })
      //        .then(function (response) {
      //        $state.go("depositAccountsOverview");
      //        }, function (error) {
      //          HelperService.showMessage(error, 'error')
      //        })
      //    }
      //  });

      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            AccountsService.updateAccount(accountId, {
                "closeESavingBook": true
              })
              .then(function (response) {
                AlertService.infoAlert({
                  text: 'alert.closeEBook'
                })
                  .then(function (){
                    $state.go("depositAccountsOverview");
                  })
              }, function (error) {
                HelperService.showMessage(error, 'error')
              })
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });

    };

    vm.cancel = function () {
      $state.go("accounts", {
        accountId: accountId
      });
    }

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:ChangeWithdrawalLimitCtrl
   *
   * @description
   *
   */
  ChangeWithdrawalLimitCtrl.$inject = ["$log", "$state", "$rootScope", "HelperService", "AccountsService", "AccountLimitOrderService", "AccountLimitOrderPeriodTypeService", "AccountLimitOrderNotificationTypeService", "AccountLimitOrderEffectiveTypeService", "UserSettingsService", "$window", "AlertService", "$translate", "$localStorage"];
  angular
    .module('accounts')
    .controller('ChangeWithdrawalLimitCtrl', ChangeWithdrawalLimitCtrl);

  function ChangeWithdrawalLimitCtrl($log, $state, $rootScope, HelperService, AccountsService, AccountLimitOrderService, AccountLimitOrderPeriodTypeService, AccountLimitOrderNotificationTypeService, AccountLimitOrderEffectiveTypeService, UserSettingsService, $window, AlertService, $translate, $localStorage) {
    var vm = this;
    vm.ctrlName = 'ChangeWithdrawalLimitCtrl';
    vm.selectedAccount = {};
    vm.tempObj = {};
    vm.insertedOrderObject = {};

    vm.formSubmitted = false;
    vm.currencySymbol = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
    vm.confirmchangeWithdrawalBtnDisabled = true;

    vm.timeLimits = [];
    vm.typeOptions = [];
    vm.notificationTypeOptions = [];

    vm.tempObj.amount = "";
    vm.step = 1;
    vm.goBackToAccount = function () {
      $state.go('accounts', {
        accountId: $state.params.accountId
      });
    };

    vm.loadAccount = function () {
      AccountsService.getAccountById($state.params.accountId)
        .then(function (response) {
          vm.selectedAccount = response;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    };

    vm.validateCashWithdrawing = function () {
      if (vm.nextButtonPressed) return;
      vm.formSubmitted = true;
      if (vm.changeWithdrawalForm.$valid) {
        vm.insertedOrderObject = {
          "account": vm.selectedAccount.iban.split(" ").join(""),
          "amount": vm.tempObj.amount,
          "effective": {
            "id": vm.tempObj.typeOption.id,
            "description": vm.tempObj.typeOption.description
          },
          "period": {
            "id": vm.tempObj.timeLimit.id,
            "description": vm.tempObj.timeLimit.description
          },
          "emailAddress": vm.userSettings.notificationEmail,
          "notificationType": {
            "id": vm.tempObj.notificationTypeOption.id,
            "description": vm.tempObj.notificationTypeOption.description
          },
          "note": " "
        };
        vm.nextButtonPressed = true;
        AccountLimitOrderService.validateOrder(vm.insertedOrderObject)
          .then(function (response) {
            vm.insertedOrderObject = angular.extend(response);
            vm.step = 2;
          })
          .catch(function (error) {
            HelperService.showMessage(error, 'error');
          })
          .finally(function () {
            vm.nextButtonPressed = false;
          });
      }

    };
    vm.confirmCashWithdrawing = function () {
      if (vm.confirmButtonPressed) return;
      vm.confirmButtonPressed = true;
      AccountLimitOrderService.insertOrder(vm.insertedOrderObject)
        .then(function (response) {
          $log.debug("AccountLimitOrderService.insertOrder inserted object ", response);
          AlertService.infoAlert({
            text: 'orderSoftToken.successTxt'
          })
            .then(function () {
              $window.history.back();
            });
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        }).finally(function (){
        vm.confirmButtonPressed = false;
      });
    };
    vm.editCashWithdrawing = function () {
      vm.step = 1;
    };
    vm.goBackToAccount = function () {
      $window.history.back();
    };

    vm.loadAccountLimitOrderTypes = function () {
      AccountLimitOrderEffectiveTypeService.getPage({
        pageSize: 1000
      })
        .then(function (response) {
          $log.debug("AccountLimitOrderEffectiveTypeService.getPage result", response);
          vm.typeOptions = response.result;
          vm.tempObj.typeOption = vm.typeOptions[1];
        })
        .catch(function (error) {
          $log.error(error);
        });

      AccountLimitOrderNotificationTypeService.getPage({
        pageSize: 1000
      })
        .then(function (response) {
          $log.debug("AccountLimitOrderNotificationTypeService.getPage result", response);
          vm.notificationTypeOptions = response.result;
          vm.tempObj.notificationTypeOption = vm.notificationTypeOptions[0];
        })
        .catch(function (error) {
          $log.error(error);
        });

      AccountLimitOrderPeriodTypeService.getPage({
        pageSize: 1000
      })
        .then(function (response) {
          $log.debug("AccountLimitOrderPeriodTypeService.getPage result", response);
          // vm.timeLimits = response.result;
          vm.timeLimits = _.sortBy(response.result, function(time) {
            return parseInt(time.id.replace(/\D+/g, ''));
          });
          vm.tempObj.timeLimit = vm.timeLimits[0];
        })
        .catch(function (error) {
          $log.error(error);
        });
    };

    vm.userSettings = {};


    var init = function () {
      vm.loadAccount();
      vm.loadAccountLimitOrderTypes();
      UserSettingsService.getPage({
        pageSize: 1000
      })
        .then(function (response) {
          vm.userSettings = response.result[0];
          $log.debug("userSettings", vm.userSettings);
        })
        .catch(function (error) {
          $log.error(error);
        });

    };
    var lastSelectedLanguage = $localStorage.appLanguage;
    $rootScope.$on('$translateChangeEnd', function (evt, data) {
      if (lastSelectedLanguage != data.language) {
        vm.loadAccountLimitOrderTypes();
      }
      lastSelectedLanguage = data.language;
    });

    init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:ChangeAtmWithdrawalLimitCtrl
   *
   * @description
   *
   */
  ChangeAtmWithdrawalLimitCtrl.$inject = ["$rootScope", "$state", "AlertService", "AccountsService", "HelperService", "AccountLimitOrderService"];
  angular
    .module('accounts')
    .controller('ChangeAtmWithdrawalLimitCtrl', ChangeAtmWithdrawalLimitCtrl);

  function ChangeAtmWithdrawalLimitCtrl($rootScope, $state, AlertService, AccountsService, HelperService, AccountLimitOrderService) {
    var vm = this;
    //TODO: load this info from API
    vm.selectedDesiredAmount = {};
    vm.step = 1;
    vm.type = {};
    vm.selectedUser = '';
    vm.formSubmitted = false;
    function loadAccount () {
      AccountsService.getAccountById($state.params.accountId)
        .then(function (response) {
          vm.selectedAccount = response;
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function createPostObj (){
      return {
        account: vm.selectedAccount.iban,
        name: vm.user,
        personType: {
          id: vm.type.id,
          description: vm.type.description
        },
        amount: {
          id: vm.selectedDesiredAmount.id,
          description: vm.selectedDesiredAmount.description
        },
        note: " "
      };
    }

    vm.validate = function () {
      if (vm.nextButtonPressed) return;
      vm.formSubmitted = true;
      if(!vm.changeATMWithdrawalForm.$valid)
        return;

      vm.insertedOrderObject = createPostObj();
      vm.nextButtonPressed = true;
      AccountLimitOrderService.validateAccountLimitPosTerminalOrder(vm.insertedOrderObject)
        .then(function (response){
          vm.insertedOrderObject = angular.extend(response);
          vm.formSubmitted = false;
          vm.step = 2;
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        }).finally(function () {
        vm.nextButtonPressed = false;
      })
    };
    vm.edit = function () {
      vm.step = 1;
    };
    vm.submit = function () {
      if (vm.submitButtonPressed) return;
      vm.submitButtonPressed = true;
      AccountLimitOrderService.insertPosTerminalOrder(vm.insertedOrderObject)
        .then(function (response){
          AlertService.infoAlert({
            text: 'orderSoftToken.successTxt'
          })
            .then(function () {
              vm.goBackToAccount();
            });
        })
        .catch(function (error){
          HelperService.showMessage(error, 'error');
        }).finally(function(){
        vm.submitButtonPressed = false;
      })
    };

    vm.goBackToAccount = function () {
      $state.go('accounts', {
        accountId: $state.params.accountId
      });
    };

    function loadDesiredAmount() {
      var params = {
        orderBy: 'description asc',
        accountId: ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') ? $state.params.accountId : undefined
      };
      return AccountLimitOrderService.accountLimitPosTerminalOrderAmountType(params)
        .then(function (response) {
          vm.desiredAmounts = response.result;
          vm.selectedDesiredAmount = vm.desiredAmounts[0];
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });
    }

    function loadUsers() {
      var params = null;
      return AccountLimitOrderService.accountLimitPosTerminalOrderPersonType()
        .then(function (response) {
          vm.forOptions = response.result;
          setDefaultForOption();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        });

    }

    vm.selectForOption= function() {
      if(vm.type.id == 'uporabnik')
        vm.user = vm.selectedUser;
    };

    function setDefaultForOption() {
      if(vm.forOptions){
        var temp = _.find(vm.forOptions, function (item) {
          return item.id == 'uporabnik';
        });
        if(temp){
          vm.type = temp;
          vm.user = vm.selectedUser;
        }

      }
    }


    function init () {

      var userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
      vm.selectedUser = userSettings.firstName + " " + userSettings.lastName;

      loadAccount();
      loadDesiredAmount();
      loadUsers();

    }
    init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:CashWithdrawalCtrl
   *
   * @description
   *
   */
  CashWithdrawalCtrl.$inject = ["$rootScope", "$q", "$localStorage", "$state", "$stateParams", "$translate", "AccountsService", "HelperService", "ValidationService", "PaymentTypesService", "BanksService", "AlertService"];
  angular
    .module('accounts')
    .controller('CashWithdrawalCtrl', CashWithdrawalCtrl);

  function CashWithdrawalCtrl($rootScope, $q, $localStorage, $state, $stateParams, $translate, AccountsService, HelperService, ValidationService,
                              PaymentTypesService, BanksService, AlertService) {

    var vm = this;
    var editMode = false;
    var signMode = false;
    var sweetAlertOptions = {};
    var allowedCurrenciesSlo = ["EUR", "HRK", "CHF", "GBP", "USD"];
    var tomorrowDate;
    vm.amountInputSettings = {
      maxLength: 12,
      maxAmount: null
    };


    var withdrawalTimesEnglish = [
      { id: 1, value: "cashWithdrawalTranslate.until", name: "Until 13:00" },
      { id: 2, value: "cashWithdrawalTranslate.after", name: "After 13:00" }
    ];

    var withdrawalTimesSlovenian = [
      { id: 1, value: "cashWithdrawalTranslate.until", name: "Do 13. ure" },
      { id: 2, value: "cashWithdrawalTranslate.after", name: "Po 13. uri" }
    ];

    vm.withdrawalTimes = [
      { id: 1, value: "cashWithdrawalTranslate.until"},
      { id: 2, value: "cashWithdrawalTranslate.after"}
    ];
    vm.withdrawalTimeId = vm.withdrawalTimes[0].id;

    vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;

    if(vm.countryCode == 'sl'){
      vm.amountInputSettings.maxAmount = 99999999999.99;
      vm.amountInputSettings.maxLength = 14;
    }

    var setLimitForSLO = function () {
      if(vm.countryCode == 'sl'){
        if(vm.model.currencySymbol == "EUR") {
          vm.minAmount = 3000;
        } else {
          vm.minAmount = 0.01;
        }
      }
    };

    vm.formatIban = HelperService.formatIban;

    init();
    function init() {
      vm.minAmount = 100.00;
      vm.maxlength = null;


      tomorrowDate = new Date(new Date().setDate(new Date().getDate() + 3));

      // if(vm.countryCode == 'sl') {
      //     tomorrowDate = new Date(new Date().setDate(new Date().getDate() + 2));
      // }

      if (tomorrowDate.getDay() == 0) {
        tomorrowDate = tomorrowDate.setDate(tomorrowDate.getDate() + 1);
      }
      else if (tomorrowDate.getDay() == 6) {
        tomorrowDate = tomorrowDate.setDate(tomorrowDate.getDate() + 2);
      }


      vm.model = {
        fromAccountNumber: "",
        amount: "",
        currencySymbol: "",
        withdrawalNotes: "",
        withdrawalDate: new Date(tomorrowDate),
        withdrawalTime: "",
        branchId: "",
        note: " ",
        phoneNumber: ""
      };

      // Response that will be returned after update
      vm.updateResponse = {};

      vm.datePickerOptions = {
        minDate: new Date(tomorrowDate),
      maxDate: HelperService.setCustomMonthPeriod(new Date(), 6)
      };
      // Regex for input validation
      vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
      translateSweetAlert();
      initAllData();
    }

    var selectedLanguage = $localStorage.appLanguage;
    $rootScope.$on('$translateChangeEnd', function (evt, data) {
      selectedLanguage = data.language;
      // Change if language is change on Withdrawal resume!
      if(selectedLanguage == "en") {
        vm.updateResponse.withdrawalTime = _.findWhere(withdrawalTimesEnglish , {id: vm.withdrawalTimeId}).name;
      } else if (selectedLanguage == "sl") {
        vm.updateResponse.withdrawalTime = _.findWhere(withdrawalTimesSlovenian , {id: vm.withdrawalTimeId}).name;
      }
    });

    vm.onTimeOfPayoutChange = function () {
      if (vm.withdrawalTimeId == 1) {
        tomorrowDate = new Date(new Date().setDate(new Date().getDate() + 3));
      } else {
        tomorrowDate = new Date(new Date().setDate(new Date().getDate() + 2));
      }

      if (tomorrowDate.getDay() == 0) {
        tomorrowDate = tomorrowDate.setDate(tomorrowDate.getDate() + 1);
      }
      else if (tomorrowDate.getDay() == 6) {
        tomorrowDate = tomorrowDate.setDate(tomorrowDate.getDate() + 2);
      }

      vm.datePickerOptions.minDate = new Date(tomorrowDate);

      // if(vm.model.withdrawalDate.getTime() <= vm.datePickerOptions.minDate.getTime()) {
        vm.model.withdrawalDate = new Date(tomorrowDate);
      // }



    };

    function initAllData() {
      var promises = [];
      promises.push(AccountsService.getPage({accountTypeGroupList: 'CurrentAccount'}));
      promises.push(BanksService.getPage({pageSize: 10000, isValidForCashWithdrawal: "Y"}));
      // Init after "resume" refresh
      // if ($state.params.cashWithdrawalId) promises.push(AccountsService.getCashWithdrawalOrder($state.params.cashWithdrawalId));

      $q.all(promises)
        .then(function (responses) {

          // 1. response
          vm.accountList = responses[0].result;
          if (vm.accountList.length) {
            _.each(vm.accountList, function (account) {
              account.optionValue = account.accountDescription + ' - ' + account.iban;
            });

            if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
              vm.accountList = _.filter(vm.accountList, function (account) {
                return _.contains(allowedCurrenciesSlo, account.currencySymbol);
              });
            }

            vm.selectedAccount = _.findWhere(vm.accountList, {accountId: $stateParams.accountId});
            if (!vm.selectedAccount) {
              vm.selectedAccount = vm.accountList[0];
            }
            vm.selectAccount(vm.selectedAccount);
          }

          //  2. response
          vm.branchList = responses[1].result;


        }, function (error) {
          // HANDLE ERROR
        })
    }

    function translateSweetAlert() {
      $translate(["core.sweetAlertTranslation.yes", "core.sweetAlertTranslation.no", "core.sweetAlertTranslation.areYouSure"]).then(function (translations) {
        sweetAlertOptions.yes = translations["core.sweetAlertTranslation.yes"];
        sweetAlertOptions.no = translations["core.sweetAlertTranslation.no"];
        sweetAlertOptions.areYouSure = translations["core.sweetAlertTranslation.areYouSure"];
      });
    }

    /*
     * Disable weekends in datepicker
     * */
    vm.dateDisabled = function (obj) {
      return ( obj.mode === 'day' && ( obj.date.getDay() === 0 || obj.date.getDay() === 6 ) );
    };


    vm.selectAccount = function (account) {
      if (!account) return;
      vm.selectedAccount = account;
      vm.model.fromAccountNumber = account.accountNumber;
      vm.model.currencySymbol = account.currencySymbol;
//      vm.validateAmount();

        if(vm.model.currencySymbol == "EUR") {
          vm.minAmount = 5001.00;
        } else if (vm.model.currencySymbol == "HRK") {
          vm.minAmount = 35001.00;
        } else {
          vm.minAmount = 100.00;
        }
        setLimitForSLO();
    };

    vm.confirmCashWithdrawing = function () {
      vm.formSubmitted = true;
      if (!vm.cashWithdrawalForm.$valid) {
        return;
      }
      vm.confirmCashWithdrawalBtnDisabled = true;

      if(selectedLanguage == "en") {
        vm.model.withdrawalTime = _.findWhere(withdrawalTimesEnglish , {id: vm.withdrawalTimeId}).name;
      } else if (selectedLanguage == "sl") {
        vm.model.withdrawalTime = _.findWhere(withdrawalTimesSlovenian , {id: vm.withdrawalTimeId}).name;
      }


      if(vm.countryCode != 'sl'){
        vm.model.withdrawalTime = '';
      }
      if (!editMode) {
        AccountsService.confirmCashWithdrawalOrder(vm.model)
          .then(function (response) {
            vm.updateResponse = response;
            // Remap iban (because it's not returned from response)
            vm.updateResponse.iban = vm.selectedAccount.iban;
            vm.confirmCashWithdrawalBtnDisabled = false;

            editMode = true;
            if(!vm.updateResponse.branchName){
              // var branchName  = vm.branchList.find(function (item) {
              //   return item.id == vm.updateResponse.branchId;
              // });

              var branchName = _.find(vm.branchList, function (item) {
                return item.id == vm.updateResponse.branchId;
              });

              vm.updateResponse.branchName = branchName.name;
            }
            $state.go('cashWithdrawalPage.resume', {editMode: editMode});

          }, function (error) {
            vm.confirmCashWithdrawalBtnDisabled = false;
            HelperService.showMessage(error, 'error');
          });
      } else {
        AccountsService.updateCashWithdrawalOrder(vm.updateResponse.id, vm.model)
          .then(function (response) {
            vm.updateResponse = response;
            vm.updateResponse.iban = vm.selectedAccount.iban;
            vm.confirmCashWithdrawalBtnDisabled = false;
            var branchName  = vm.branchList.find(function (item) {
              return item.id == vm.updateResponse.branchId;
            });
            vm.updateResponse.branchName = branchName.name;

            $state.go('cashWithdrawalPage.resume', {editMode: editMode});
          }, function (error) {
            vm.confirmCashWithdrawalBtnDisabled = false;
            HelperService.showMessage(error, 'error');
          })
      }
    };


    vm.editCashWithdrawing = function () {
      $state.go('cashWithdrawalPage.form');
    };

    vm.deleteCashWithdrawing = function () {
      //swal({
      //    title: sweetAlertOptions.areYouSure,
      //    type: "info",
      //    showCancelButton: true,
      //    confirmButtonClass: "btn-default",
      //    confirmButtonText: sweetAlertOptions.yes,
      //    cancelButtonText: sweetAlertOptions.no,
      //    closeOnConfirm: true,
      //    closeOnCancel: true
      //  },
      //  function (isConfirm) {
      //    if (isConfirm) {
      //      vm.deleteCashWithdrawingBtnDisabled = true;
      //      AccountsService.deleteCashWithdrawalOrder(vm.updateResponse.id)
      //        .then(function (response) {
      //          vm.deleteCashWithdrawingBtnDisabled = false;
      //          $state.go("accounts", {accountId: vm.selectedAccount.accountId});
      //        }, function (error) {
      //          vm.deleteCashWithdrawingBtnDisabled = false;
      //        })
      //    }
      //  });

      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            vm.deleteCashWithdrawingBtnDisabled = true;
            AccountsService.deleteCashWithdrawalOrder(vm.updateResponse.id)
              .then(function (response) {
                AlertService.deletedPaymentAlert({paymentName: vm.updateResponse.id, type: 'payment'})
                  .then(function () {
                    vm.deleteCashWithdrawingBtnDisabled = false;
                    $state.go("accounts", {accountId: vm.selectedAccount.accountId});
                  });
              }, function (error) {
                vm.deleteCashWithdrawingBtnDisabled = false;
              });
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });
    };

    vm.cancelCashWithdrawing = function () {
      $state.go("accounts", {accountId: vm.selectedAccount.accountId})
    };

    vm.sendCashWithdrawing = function () {

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        vm.signCashWithdrawingBtnDisabled = true;
        AccountsService.signCashWithdrawalOrder({id: vm.updateResponse.id},vm.updateResponse)
          .then(function (response) {
            if(vm.countryCode == 'sl'){
              AlertService.infoAlert({
                text: "alert.successSignSlo"
              })
                .then(function (){
                  vm.signCashWithdrawingBtnDisabled = false;
                  $state.go("accounts", {accountId: vm.selectedAccount.accountId})
                });
            }else{
              AlertService.infoAlert({
                text: "alert.successSign"
              })
                .then(function (){
                  vm.signCashWithdrawingBtnDisabled = false;
                  $state.go("accounts", {accountId: vm.selectedAccount.accountId})
                });
            }

          }, function (error) {
            vm.signCashWithdrawingBtnDisabled = false;
            HelperService.showMessage(error, 'error');
          });
        return;
      }

      AlertService.confirmationAlert()
        .then(function (result) {
          if (result) {
            vm.signCashWithdrawingBtnDisabled = true;
            AccountsService.signCashWithdrawalOrder({id: vm.updateResponse.id},vm.updateResponse)
              .then(function (response) {
                if(vm.countryCode == 'sl'){
                  AlertService.infoAlert({
                    text: "alert.successSignSlo"
                  })
                    .then(function (){
                      vm.signCashWithdrawingBtnDisabled = false;
                      $state.go("accounts", {accountId: vm.selectedAccount.accountId})
                    });
                }else{
                  AlertService.infoAlert({
                    text: "alert.successSign"
                  })
                    .then(function (){
                      vm.signCashWithdrawingBtnDisabled = false;
                      $state.go("accounts", {accountId: vm.selectedAccount.accountId})
                    });
                }

              }, function (error) {
                vm.signCashWithdrawingBtnDisabled = false;
                HelperService.showMessage(error, 'error');
              })
          }
        })
        .catch(function () {
          $log.debug('Example failed!');
        });

    }
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name accounts.controller:AccountsTransactionsCtrl
     *
     * @description
     *
     */
    AccountsTransactionsCtrl.$inject = ["$scope", "$translate", "$log", "$stateParams", "AccountsService", "TransactionsService", "HelperService"];
    angular
        .module('accounts')
        .controller('AccountsTransactionsCtrl', AccountsTransactionsCtrl);

    function AccountsTransactionsCtrl($scope, $translate, $log, $stateParams, AccountsService, TransactionsService, HelperService) {

        var vm = this;

        vm.numberOfAccountsToShow = 4;

        vm.selectedAccount = {};
        vm.selectedAccount = {
            transactions: {
                hasMore: false
            }
        };
        vm.accountList = [];
        vm.accountTransactionsFilter = {
            accountId: undefined,
            orderBy: 'ValueDate DESC',
            page: 0,
            pageSize: 100
        };

        vm.busy = false; //marks is request already fired

        vm.defaultAccountTransactionsTempFilter = {
            selectedTransactionType: 'all',
            amountGTE: null,
            amountLTE: null,
            genericSearch: null
        };


        vm.accountTransactionsTempFilter = {

        };

        vm.accountTransactionsTempFilter = _.extend(vm.accountTransactionsTempFilter, vm.defaultAccountTransactionsTempFilter);


        $translate(['transactions.transactionTypes.credit', 'transactions.transactionTypes.debit', 'transactions.transactionTypes.all']).then(function (translations) {

            vm.transactionTypeFilterList = [
                {
                    id: 'all',
                    description: translations['transactions.transactionTypes.all']
                }
        , {
                    id: 'credit',
                    description: translations['transactions.transactionTypes.credit']
                }
        , {
                    id: 'debit',
                    description: translations['transactions.transactionTypes.debit']
                }
      ];
        });



        vm.periodList = [
            {
                item: {
                    key: 'today',
                    description: 'core.period.today'
                }
            }
        , {
                item: {
                    key: 'yesterday',
                    description: 'core.period.yesterday'
                }
            }
        , {
                item: {
                    key: 'thisWeek',
                    description: 'core.period.thisWeek'
                }
            }
        , {
                item: {
                    key: 'thisMonth',
                    description: 'core.period.thisMonth'
                }
            }
        , {
                item: {
                    key: 'thisYear',
                    description: 'core.period.thisYear'
                }
            }
        , {
                item: {
                    key: 'all',
                    description: 'core.period.all'
                }
            }
      ];

        vm.selectedPeriod = vm.periodList[2];





        vm.init = function () {
            var index = 0;
            var selectedAccountIndex = 0;
            $log.debug($stateParams);
            AccountsService.getAll()
                .then(function (response) {
                    $(response.result).each(function (i, e) {
                        e.index = index++;
                        if ($stateParams.accountId !== undefined) {
                            if ($stateParams.accountId == e.accountId) {
                                selectedAccountIndex = e.index;

                            }
                        }
                    });
                    vm.accountList = response.result;
                    vm.selectAccount(selectedAccountIndex);

                    vm.getTransactions(true);
                })
                .catch(function (error) {
                    $log.error(error);
                    //alert('last catch');
                });
        };

        vm.selectAccount = function (index) {
            vm.selectedAccount = vm.accountList[index];
            vm.accountList[index].active = true;

            var selectedAccountIndex = vm.selectedAccount.index + 1;
            //vm.numberOfAccountsToShow = vm.selectedAccount.index + 1;
            if (vm.numberOfAccountsToShow < selectedAccountIndex) {
                vm.numberOfAccountsToShow = vm.selectedAccount.index + 1;
            }
            vm.getTransactions(true);
            console.log("DEJAN    " + JSON.stringify(vm.selectedAccount));
        };


        $scope.$watch('accountsTransactions.selectedPeriod', function (newValue) {
            // do something here
            vm.busy = false;
            vm.getTransactions(true);
        }, true);

        /*$scope.$watch('accountsTransactions.accountList', function(newValue) {
          // do something here
          $(newValue).each(function(i, e){
            if(e.active == true && e.accountId != vm.selectedAccount.accountId){
              vm.busy = false;
              vm.selectedAccount = e;
              vm.getTransactions(true);
            }
          });
        }, true);*/

        vm.getTransactions = function (reset) {

            if (vm.selectedAccount.accountId == undefined) {
                $log.debug("return", vm.selectedAccount)
                return;
            }

            if (!reset && vm.selectedAccount.transactions != undefined && vm.selectedAccount.transactions.hasMore != undefined && vm.selectedAccount.transactions.hasMore == false) {
                return;
            }

            if (vm.busy) return;
            vm.busy = true;

            if (reset) {
                vm.accountTransactionsFilter.page = 0;
            } else {
                vm.accountTransactionsFilter.page += 1;
            }
            //convert period to dates

            if (vm.selectedPeriod.item.key == 'today') {
                var range = HelperService.getToday();
                vm.accountTransactionsFilter.valueDateGTE = range.firstDay;
                vm.accountTransactionsFilter.valueDateLTE = range.lastDay;
            } else if (vm.selectedPeriod.item.key == 'yesterday') {
                var range = HelperService.getYesterday();
                vm.accountTransactionsFilter.valueDateGTE = range.firstDay;
                vm.accountTransactionsFilter.valueDateLTE = range.lastDay;
            } else if (vm.selectedPeriod.item.key == 'thisWeek') {
                var range = HelperService.getThisWeek();
                vm.accountTransactionsFilter.valueDateGTE = range.firstDay;
                vm.accountTransactionsFilter.valueDateLTE = range.lastDay;
            } else if (vm.selectedPeriod.item.key == 'thisMonth') {
                var range = HelperService.getThisMonth();
                vm.accountTransactionsFilter.valueDateGTE = range.firstDay;
                vm.accountTransactionsFilter.valueDateLTE = range.lastDay;
            } else if (vm.selectedPeriod.item.key == 'thisYear') {
                var range = HelperService.getThisYear();
                vm.accountTransactionsFilter.valueDateGTE = range.firstDay;
                vm.accountTransactionsFilter.valueDateLTE = range.lastDay;
            } else if (vm.selectedPeriod.item.key == 'all') {
                vm.accountTransactionsFilter.valueDateGTE = null;
                vm.accountTransactionsFilter.valueDateLTE = null;
            }

            if (vm.accountTransactionsTempFilter.selectedTransactionType == "all") {
                vm.accountTransactionsFilter.transactionType = null;
            } else if (vm.accountTransactionsTempFilter.selectedTransactionType == "credit") {
                vm.accountTransactionsFilter.transactionType = "Credit";
            } else if (vm.accountTransactionsTempFilter.selectedTransactionType == "debit") {
                vm.accountTransactionsFilter.transactionType = "Debit";
            } else {
                throw "Unhandled transaction type";
            }

            vm.accountTransactionsFilter.amountGTE = HelperService.getAmountClean(vm.accountTransactionsTempFilter.amountGTE);
            vm.accountTransactionsFilter.amountLTE = HelperService.getAmountClean(vm.accountTransactionsTempFilter.amountLTE);
            vm.accountTransactionsFilter.accountId = vm.selectedAccount.accountId;
            vm.accountTransactionsFilter.genericSearch = vm.accountTransactionsTempFilter.genericSearch;

            $log.debug("before group", vm.accountTransactionsTempFilter, vm.accountTransactionsFilter);

            vm.groupByTransactions(reset);
        };


        vm.groupByTransactions = function (reset) {

            TransactionsService.getPage(vm.accountTransactionsFilter)
                .then(function (response) {
                    vm.busy = false;

                    $(response.result).each(function (i, e) {
                        if (e.transactionType == "Credit") {
                            e.credit = e.amount;
                            e.debit = null;
                        } else {
                            e.credit = null;
                            e.debit = e.amount;
                        }
                    });

                    vm.selectedAccount.transactions = HelperService.mergeRowsForTimeline({
                        existingData: vm.selectedAccount.transactions,
                        newData: response,
                        groupFunction: function (item) {
                            var valueDate = new Date(item.valueDate);
                            valueDate.setHours(0,0,0,0);
                            return valueDate;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                valueDate: e,
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });

                    //$log.debug("transactions", vm.selectedAccount.transactions);
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.getSelectedAccountId = function () {
            return {
                accountId: vm.selectedAccount.accountId
            }
        };

        vm.loadMoreTransactions = function (reset) {
            vm.getTransactions(reset);
        };

        vm.resetTransactionsFilter = function () {
            vm.accountTransactionsTempFilter = _.extend(vm.accountTransactionsTempFilter, vm.defaultAccountTransactionsTempFilter);
        };


        vm.init();
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:AccountsStatementsCtrl
   *
   * @description
   *
   */
  AccountsStatementsCtrl.$inject = ["$scope", "$http", "$q", "$log", "$stateParams", "AccountsService", "TransactionsService", "StatementsService", "HelperService"];
  angular
    .module('accounts')
    .controller('AccountsStatementsCtrl', AccountsStatementsCtrl);

  function AccountsStatementsCtrl($scope, $http, $q, $log, $stateParams, AccountsService, TransactionsService, StatementsService, HelperService) {
    var vm = this;
    vm.selectedAccount = {
      statements: {
        hasMore:false
      }
    };

    vm.accountList = [];

    vm.statementsFilter = {
      accountId: undefined
      ,orderBy: 'CloseDate DESC'
      ,page:0
      ,pageSize:100
    };
    vm.busy = false;


    vm.init = function(){
      var index = 0;
      var selectedAccountIndex = 0;
      $log.debug($stateParams);
      AccountsService.getAll()
        .then(function(response){
          $(response.result).each(function(i, e){
            e.index = index++;
            e.active = false;
            if($stateParams.accountId !== undefined){
              if($stateParams.accountId == e.accountId){
                selectedAccountIndex = e.index;
                //e.active = true;
              }
            }
          });
          vm.accountList = response.result;
          vm.selectAccount(selectedAccountIndex);

          vm.getStatements(true);
        })
        .catch(function(error){
          $log.error(error);
          //alert('last catch');
        });
    };

    vm.selectAccount = function(index){
      vm.selectedAccount = vm.accountList[index];
      vm.accountList[index].active = true;
        vm.getStatements(true);
    };


    /*$scope.$watch('accountsStatements.accountList', function(newValue) {
      // do something here
      $(newValue).each(function(i, e){
        if(e.active == true && e.accountId != vm.selectedAccount.accountId){
          vm.selectedAccount = e;
          vm.getStatements(true);
        }
      });
    }, true);*/

    vm.loadMoreStatements = function(){

      if(vm.selectedAccount.statements.hasMore !== false) {
        $log.debug("load");
        vm.statementsFilter.page += 1;
        vm.getStatements(false);
      }
      else{
        $log.debug("no more data");
      }

    };

    vm.getStatements = function(reset){

      if (vm.busy) return;
      vm.busy = true;

      if(reset){
        vm.statementsFilter.page = 0;
      }
      vm.statementsFilter.accountId = vm.selectedAccount.accountId;
      vm.groupByStatements(reset);
    };

    vm.groupByStatements = function (reset) {

      StatementsService.getPage(vm.statementsFilter)
        .then(function(response){
          vm.busy = false;


          if(vm.selectedAccount != undefined){

            vm.selectedAccount.statements = HelperService.mergeRowsForTimeline(
              {
                existingData: vm.selectedAccount.statements
                , newData: response
                ,groupFunction: function(item){
                  return  new Date(item.closeDate).getFullYear();
                },
                virtualRowFunction:function (e) {
                  return {isVirtual: true, closeDateYear:e}
                }
                ,reset: reset
                ,reverse: true
              });

          }

          //$log.debug("statements",vm.selectedAccount.statements);
        }).catch(function(error){
          $log.error(error);
        });
    };

    vm.getSelectedAccountId = function(){
      return {accountId:  vm.selectedAccount.accountId }
    };

    vm.init();
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name accounts.factory:AccountsService
   *
   * @description
   *
   */
  AccountsService.$inject = ["$rootScope", "$sessionStorage", "EndpointsService", "$q", "$localStorage", "$http", "$log", "$uibModal", "SessionService", "HelperService"];
  angular
    .module('accounts')
    .factory('AccountsService', AccountsService);

  function AccountsService($rootScope, $sessionStorage, EndpointsService, $q, $localStorage, $http, $log, $uibModal, SessionService, HelperService) {
    var AccountsServiceBase = {};

    if($sessionStorage.paymentStorageObject && $sessionStorage.paymentStorageObject.type == 'cashWithdrawalOrder'){
      insert($sessionStorage.paymentStorageObject.object);
    }

    AccountsServiceBase.getPage = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.accounts, {
            params: params
          })
          .success(function (data) {
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
              // START Add property for "eur" first filtering
              _.each (data.result, function (account) {
                if (account.isParentAccount) {
                  account.sortOrderId = (account.currencySymbol == "EUR") ? 1 : 2;
                  _.each (account.subAccountList, function (subAcc) {
                    subAcc.sortOrderId = (subAcc.currencySymbol == "EUR") ? 1 : 2;
                  })
                }
              });
              // END Add property for "eur" first filtering
            }

            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.getAll = function (params) {
      var predefinedParams = {
        page: 0,
        pageSize: 1000,
        orderBy: 'accountType asc,iban,currencySymbol, accountDescription'
      };
      var extended = _.extend(predefinedParams, params);
      return AccountsServiceBase.getPage(extended);
    };

    AccountsServiceBase.openModal = function (modalObject) {
      var modalInstance = $uibModal.open({
        templateUrl: 'accounts/acc-trans-detail-modal.tpl.html',
        controller: 'AccTransDetailModalCtrl',
        controllerAs: 'accTransDetailModal',
        resolve: {
          transaction: function () {
            return modalObject.transaction
          },
          account: function () {
            return modalObject.account
          }
        },
        backdrop: 'static'
      });
    };

    AccountsServiceBase.openBlockModal = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'accounts/connected-cards-block-modal.tpl.html',
        controller: 'ConnectedCardsBlockModalCtrl',
        controllerAs: 'connectedCardsBlockModal',
        backdrop: 'static'
      });
    };

    var paramsObject = {
      includeList: ['PaymentList']
    };

    AccountsServiceBase.getAccountById = function (id, paramsObject) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.accounts_id.replace('{id}', id), {
          params: paramsObject
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.eSavingBookCloseOverview = function (id) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links["accounts_eSavingBookCloseOverView?id=id"].replace('{id}', id))
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.updateAccount = function (id, params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.accounts_id.replace('{id}', id), params)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.openEbookRequestModal = function (ebook) {
      var modalInstance = $uibModal.open({
        templateUrl: 'accounts/e-book-request-modal.tpl.html',
        controller: 'EBookRequestModalCtrl',
        controllerAs: 'eBookRequestModal',
        resolve: {
          ebook: function () {
            return ebook
          }
        },
        backdrop: 'static'
      });
    };

    // Method to load all account and set all accounts ids in session storage (for carousel)
    AccountsServiceBase.loadAllAccounts = function () {
      var deferred = $q.defer();

        var accountsQuery = {
          page: 0,
          pageSize: 100,
          orderBy: 'isFavorite desc,accountType,iban,currencyCode',
          //space required - if accountType,iban,... uses desc/asc, filter should be: 'isFavorite desc, accountType desc,iban, currencyCode desc'
          includeList: ['loanAccount', 'depositAccount', 'cardList', 'userAccountList']
        };

        // Include list for Cro is different than for Srb/Mne
        if ($localStorage.code !== "sr" && $localStorage.code !== "mne") {
          accountsQuery.includeList = ['loanAccount', 'depositAccount', 'cardList', 'userAccountList', 'cardAccount'];
        }

        this.getPage(accountsQuery).then(function (response) {
          deferred.resolve(response.result);
/*          var allAccountIds = [];
          _.forEach(response.result, function(account){
            allAccountIds.push({id: account.accountId, type: account.accountType.group });
          });
          sessionStorage.setItem('accounts', JSON.stringify({accountObjects: allAccountIds}));*/

        }).catch(function (err) {
          $log.error(err);
        });

      return deferred.promise;
    };

/*
    AccountsServiceBase.refreshAccountsStorage = function (items) {
      sessionStorage.removeItem('accounts');

      // If we are just updating current list. No need for API call
      if (items) {
        sessionStorage.setItem('accounts', JSON.stringify({accountObjects: items}));
      } else {
        // In case we want full reload of all accounts
        return this.loadAllAccounts();
      }
    };*/

    AccountsServiceBase.updateCardStatus = function (accountId, card) {

      var data = {
//        blockCard: (card.temporaryStatus == 'SentUnblockRequest') ? true : false,
        cardId: card.cardId
      };
      if(card.temporaryStatus) {
        data.BlockCard = (card.temporaryStatus == 'SentUnblockRequest') ? true : false;
      } else {
        data.BlockCard = (card.cardStatus === 'Active') ? true : false;
      }

      return EndpointsService.getLinks().then(function (response) {
        return $http.put(response.links.accounts_id.replace('{id}', accountId), data);
      })
    };

    AccountsServiceBase.getCashWithdrawalOrder = function (id) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.cashWithdrawalOrders_id.replace('{id}', id))
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    };

    function insert(order) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          SessionService.saveStorageObject(order, 'cashWithdrawalOrder');
          $http.post(response.links.cashWithdrawalOrders, order)
            .success(function (data) {
              SessionService.removeStorageObject();
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    }

    AccountsServiceBase.confirmCashWithdrawalOrder = function (order) {
      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        return validateOrder(order);
      }
      return insert(order);
    };

    function validateOrder (request) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.cashWithdrawalOrders_validate, request)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    AccountsServiceBase.updateCashWithdrawalOrder = function (id, order) {

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        return validateOrder(order);
      }

      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.cashWithdrawalOrders_id.replace('{id}', id), order)
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    };

    AccountsServiceBase.deleteCashWithdrawalOrder = function (id) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.delete(response.links.cashWithdrawalOrders_id.replace('{id}', id))
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    };

    AccountsServiceBase.signCashWithdrawalOrder = function (params,payment) {

      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        return insert(payment);
      }


      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          console.log(response);
          $http.put(response.links.cashWithdrawalOrders_sign, params)
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    };

    AccountsServiceBase.getDepositOrderAccounts = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.accounts_depositOrderAccounts, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.getOrderInvAccounts = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.accounts_getOrderInvAccounts, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    AccountsServiceBase.getAllCards = function (params) {
    var deferred = $q.defer();
    EndpointsService.getLinks().then(function (response) {
      $http.get(response.links.cards, {
          params: params
        })
        .success(function (data) {
          deferred.resolve(data);
        }).error(function (msg, code) {
        deferred.reject(msg);
      });
    }, function (error) {
      deferred.reject(error);
    });
    return deferred.promise;
  };

    AccountsServiceBase.getReservations = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.reservations, {
            params: params
          })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.newCardOrderMonthlyShareOfLiabilitiesType = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.newCardOrderMonthlyShareOfLiabilitiesType, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    AccountsServiceBase.newCreditCardOrderCardTypeType = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.newCreditCardOrderCardTypeType, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.newCreditCardOrderTearDateType = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.newCreditCardOrderTearDateType, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    AccountsServiceBase.newCreditCardOrder = function (object) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.newCreditCardOrder, object)
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    };

    AccountsServiceBase.validateNewCreditCardOrder = function (object) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.newCreditCardOrder_validate, object)
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })
        }, function (error) {
          reject(error);
        });
      });
    };

    AccountsServiceBase.creditPossibilityOrder = function (object) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.creditPossibilityOrder, object)
            .success(function (data) {
            resolve(data);
          })
            .error(function (error) {
            reject(error);
          })

        }, function (error) {
          reject(error);
        });
      });
    };

    AccountsServiceBase.validateCreditPossibilityOrder = function (object) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.creditPossibilityOrder_validate, object)
            .success(function (data) {
            resolve(data);
          })
            .error(function (error) {
            reject(error);
          })
        }, function (error) {
          reject(error);
        });
      });
    };

    AccountsServiceBase.creditPossibilityOrderTearDateType = function (params) {
          var deferred = $q.defer();
          EndpointsService.getLinks().then(function (response) {
              $http.get(response.links.creditPossibilityOrderTearDateType, {
                  params: params
              })
                  .success(function (data) {
                  deferred.resolve(data);
              }).error(function (msg, code) {
                  deferred.reject(msg);
              });
          }, function (error) {
              deferred.reject(error);
          });
          return deferred.promise;
      };


    AccountsServiceBase.creditCardLimitOrderLimitTypeType = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.creditCardLimitOrderLimitTypeType, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    AccountsServiceBase.creditCardLimitOrderPercentOfLimitType = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.creditCardLimitOrderPercentOfLimitType, {
          params: params
        })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };
    AccountsServiceBase.validateCreditCardLimitOrder = function (object) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.put(response.links.creditCardLimitOrder_validate, object)
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    };
    AccountsServiceBase.creditCardLimitOrder = function (object) {
      return $q(function (resolve, reject) {
        return EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.creditCardLimitOrder, object)
            .success(function (data) {
              resolve(data);
            })
            .error(function (error) {
              reject(error);
            })

        }, function (error) {
          reject(error);
        });
      });
    };

    return AccountsServiceBase;
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('accounts')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('accounts', {
      url: '/accounts/{accountId}',
      templateUrl: 'accounts/accounts.tpl.html',
      controller: 'AccountsCtrl',
      controllerAs: 'accounts'
    })
      .state('accountsOverview', {
      url: '/accounts-overview',
      views: {
        '@': {
          templateUrl: 'accounts/accounts-overview.tpl.html',
          controller: 'AccountsOverviewCtrl',
          controllerAs: 'accountsOverview'
          // resolve: {
          //   currentCountry: function (ConfigEndpointService) {
          //     return ConfigEndpointService.getDefaultData();
          //   }
          // }
        }
      }
    })
      .state('depositAccountsOverview', {
      url: '/deposit-accounts-overview',
      views: {
        '@': {
          templateUrl: 'accounts/deposit-accounts-overview.tpl.html',
          controller: 'DepositAccountsOverviewCtrl',
          controllerAs: 'depositAccountsOverview'
          // resolve: {
          //   currentCountry: function (ConfigEndpointService) {
          //     return ConfigEndpointService.getDefaultData();
          //   }
          // }
        }
      }
    })
      .state('loansOverview', {
      url: '/loans-overview',
      views: {
        '@': {
          templateUrl: 'accounts/loans-overview.tpl.html',
          controller: 'LoansOverviewCtrl',
          controllerAs: 'loansOverview'
        }
      }
    })
      .state('newEbook', {
      url: '/new-ebook/:accountId',
      params: {
        myParam:null
      },
      views: {
        '@': {
          templateUrl: 'accounts/new-e-book.tpl.html',
          //controller: 'NewEBookCtrl',
          //controllerAs: 'newEBook'
          controller: 'NewEBookSavingsDividerCtrl',
          controllerAs: 'newEBookSavingsDivider'
        }
      }
    })
      .state('closeEbook', {
      url: '/close-ebook',
      templateUrl: 'accounts/close-e-book.tpl.html',
      controller: 'CloseEBookCtrl',
      controllerAs: 'ebookAccount',
      params: {
        accountId: null
      },
      resolve: {
        authorize: ["$q", "$location", "$state", "$stateParams", function ($q, $location, $state, $stateParams) {
          console.log($state);
          console.log($stateParams);
          if (!$stateParams.accountId) {
            $location.url("/deposit-accounts-overview");
            // return $q.reject("Not Authorized");
          }
        }]
      }
    })
      .state('cashWithdrawalPage', {
      abstract: true,
      url: '/cash-withdrawal/:accountId',
      controller: 'CashWithdrawalCtrl',
      controllerAs: 'cashWithdrawal',
      templateUrl: 'accounts/cash-withdrawal.tpl.html',
      resolve: {
        isCroatia: ["$q", "$rootScope", "$location", function ($q, $rootScope, $location) {
          // This is not safe! Validate this from a call to the server!
          var defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
          if (defaultData.APILocation != 'hr' && defaultData.APILocation != 'sl') {
            $location.url("/accounts-overview");
          }
        }]
      }
    })
      .state('cashWithdrawalPage.form', {
      url: '/form',
      templateUrl: 'accounts/cash-withdrawal-form.tpl.html'
    })
      .state('cashWithdrawalPage.resume', {
      url: '/resume',
      templateUrl: 'accounts/cash-withdrawal-resume.tpl.html',
      params: {
        editMode: false
      },
      resolve: {
        authorize: ["$location", "$stateParams", function ($location, $stateParams) {
          // Forbid user navigation from "URL"
          if (!$stateParams.editMode) {
            $location.url("/cash-withdrawal/" + $stateParams.accountId + "/form");
          }
        }]
      }
    })
      // related to accounts transaction division (for BiH environment)
      .state('transactionDivison', {
        abstract: true,
        url: '/division',
        controller: 'TransactionDivisionCtrl',
        controllerAs: 'transactionDivision',
        templateUrl: 'accounts/transaction-division-base.tpl.html',
        resolve: {
          checkCountry: ["$q", "$rootScope", "$location", "ConfigEndpointService", function($q, $rootScope, $location, ConfigEndpointService){
            // transaction divisions are relevant only for BiH environment
            ConfigEndpointService.getDefaultData()
              .then(function (response){
                if(response && response.APILocation !== 'bh'){
                  $location.url("/dashboard");
                  return $q.reject();
                }
              })
          }]
        }
      })
      .state('transactionDivison.create', {
        url: '/create',
        params: {
          transactionId: null,
          reservationId: null,
          card: null
        },
        templateUrl: 'accounts/transaction-division.tpl.html'
      })
      .state('transactionDivison.resume', {
        url: '/resume',
        templateUrl: 'accounts/transaction-division-resume.tpl.html',
        params: {
          resume: false
        },
        resolve: {
          authorize: ["$location", "$stateParams", function ($location, $stateParams) {
            if(!$stateParams.resume){
              $location.url("/division/create");
            }
          }]
        }
      })
      .state('transactionDivison.final', {
        url: '/final',
        templateUrl: 'accounts/transaction-division-final.tpl.html',
        params: {
          final: false
        },
        resolve: {
          authorize: ["$location", "$stateParams", function ($location, $stateParams) {
            if(!$stateParams.final){
              $location.url("/division/create");
            }
          }]
        }
      })
      .state('changeWithdrawal', {
        url: '/change-withdrawal/:accountId',
        controller: 'ChangeWithdrawalLimitCtrl',
        controllerAs: 'changeWithdrawal',
        templateUrl: 'accounts/change-withdrawal-limit.tpl.html'
      })
      .state('masterCardNew', {
        url: '/master-card-new',
        controller: 'MasterCardNewCtrl',
        controllerAs: 'masterCard',
        templateUrl: 'accounts/master-card-new.tpl.html'
      })
      .state('changeATMWithdrawal', {
        url: '/change-atm-withdrawal/:accountId',
        controller: 'ChangeAtmWithdrawalLimitCtrl',
        controllerAs: 'changeATM',
        templateUrl: 'accounts/change-atm-withdrawal-limit.tpl.html'
      })
      .state('masterCardOrder', {
        url: '/master-card-order/:accountId',
        params: {
          cardId: null
        },
        controller: 'MasterCardOrderLimitCtrl',
        controllerAs: 'masterCardOrder',
        templateUrl: 'accounts/master-card-order-limit.tpl.html'
      })

  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:AccountsOverviewCtrl
   *
   * @description
   *
   */
  AccountsOverviewCtrl.$inject = ["$rootScope", "$q", "$state", "$window", "AlertService", "AccountsService", "HelperService", "$translate", "GoogleTagManagerHelperService"];
  angular
      .module('accounts')
      .controller('AccountsOverviewCtrl', AccountsOverviewCtrl);

  function AccountsOverviewCtrl($rootScope, $q, $state, $window, AlertService, AccountsService, HelperService, $translate, GoogleTagManagerHelperService) {
    var vm = this;

    var accounts;
    var cards;
    vm.singleAccounts; // object array
    vm.multiAccounts;

    init();
    function init() {
      vm.currentCountry = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
      getAllAccountsAndCards();
    }

    // region Private methods

    function getAllAccountsAndCards() {
      var promises = [];
      var defaultOrder = "isFavorite desc,accountType,iban,currencySymbol";
      if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl")
        defaultOrder = 'isFavorite desc,isParentAccount desc';
      promises.push(AccountsService.getPage({
        pageSize: 1000,
        page: 0,
        // { notInAccountTypeGroupList: "LoanAccountType" } - Isključi račune koji su krediti
        notInAccountTypeGroupList: ["LoanAccountType", "SavingAccountTypes", "DepositAccountTypes"],
        orderby: defaultOrder
      }));
      if (vm.currentCountry == 'sr' || vm.currentCountry == 'mne' || vm.currentCountry == 'sl' || vm.currentCountry == 'bh') {
        promises.push(AccountsService.getAllCards({
          pageSize: 1000,
          page: 0
        }));
      }

      $q.all(promises)
          .then(function (responses) {
            // 1. response
            if (responses[0]) {
              accounts = responses[0].result;
              if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                accounts = _.each(accounts, function(account) {
                  account.iban = account.iban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
                });

                vm.cardAccounts = _.filter(accounts, function(account) {
                  return account.accountType.group == "CardAccountTypes";
                });
                vm.multiAccounts = _.filter(accounts, function (account) {
                  return !account.parentAccountId && account.accountType.group == "CurrentAccount";
                });

              } else {
                var sepAccounts = HelperService.groupAccounts(responses[0].result);
                vm.singleAccounts = sepAccounts.singleAccounts;
                vm.multiAccounts = sepAccounts.multiAccounts;
              }
            }

            // 2. response
            if (responses[1]) {
              cards = responses[1].result;
              vm.cards = cards;
              addAccountNameToCard();
            }
          }, function (error) {
            console.log(error);
          });
    }

    function refreshCards() {
      AccountsService.getAllCards({
        pageSize: 1000,
        page: 0
      }).then(function (response) {
        vm.cards = response.result;
        addAccountNameToCard();
      });
    }

    function addAccountNameToCard() {
      _.map(vm.cards, function (card) {
        var account = _.findWhere(accounts, {accountId: card.accountId.toString()});
        if (account) {
          card.accountName = account.friendlyName;
        }
      });
    }

    // endregion

    // region Public methods

    vm.goToAccount = function (accountId) {
      $state.go('accounts', {
        accountId: accountId
      });
    };

    vm.updateCardStatus = function (card) {
      
      if(vm.currentCountry == 'sl' || card.cardStatusStr == 2){
        AccountsService.openBlockModal();
        return;
      }

      card.selected = true;
      console.log(card);
      AccountsService.updateCardStatus(card.accountId, card)
          .then(function (response) {

            var BlockCard;
            if(card.temporaryStatus) {
              BlockCard = (card.temporaryStatus == 'SentUnblockRequest') ? true : false;
            } else {
              BlockCard = (card.cardStatus === 'Active') ? true : false;
            }
            GoogleTagManagerHelperService.pushEvent('AccountsOverview', 'BlockCardSelection', (BlockCard) ? "Block card" : "Unblock card");
            refreshCards();
            card.selected = false;
          })
          .catch(function (error) {
            card.selected = false;
            HelperService.showMessage(error, 'error');
          });
    };

    vm.openNewSavingOrMasterCard = function (){
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
        $state.go("masterCardNew");
      } else {
        $state.go("newEbook");
      }
    };

    vm.openPayLifeBalancePage = function() {
      $window.open($rootScope.APP_GLOBAL_SETTINGS.defaultData.PayLifeBalanceInquiry, '_blank');
    };
    // endregion

  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name accounts.controller:AccountsCtrl
     *
     * @description
     *
     */
    AccountsCtrl.$inject = ["$rootScope", "$translate", "$log", "$stateParams", "AccountsService", "TransactionsService", "HelperService", "StatementsService", "$state", "CurrencyService", "ValidationService", "ESavingBookRequestsService", "PaymentTemplatesService", "$filter", "AlertService", "DepositOrdersService", "ReservationsService", "EndpointsService", "GoogleTagManagerHelperService"];
    angular
        .module('accounts')
        .controller('AccountsCtrl', AccountsCtrl);

    function AccountsCtrl($rootScope, $translate, $log, $stateParams, AccountsService, TransactionsService,
        HelperService, StatementsService, $state, CurrencyService,ValidationService,
        ESavingBookRequestsService, PaymentTemplatesService, $filter, AlertService,
                           DepositOrdersService, ReservationsService, EndpointsService, GoogleTagManagerHelperService) {

        var vm = this;
        vm.links = {};
        var defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
        var allowedCurrenciesSlo = ["EUR", "HRK", "CHF", "GBP", "USD"];

        vm.regexPatterns = ValidationService.getRegexPatternsForValidation();
        vm.countryCode = defaultData.APILocation;
        vm.defaultCurrency = defaultData.DefaultCurrency;

        vm.showTemplatesView = false;
        vm.eBookRequests = true;
        vm.collapsed = false;

        vm.showRepaymentPlan = false;
        vm.repaymentLoaded = false;
        vm.multiCurrency = false;
        vm.showField = false;
        vm.showConvertedLoansFields = false;
        vm.accountLoaded = false;
        vm.searchFilterExpanded = false;
        vm.defaultDates = {};


        //-------------------------------------------
        //        TRANSACTION FILTER OPTIONS START
        //-------------------------------------------
        vm.showFilterOptionsWrapper = false;
        vm.dateFromOpen = false;
        vm.dateToOpen = false;
        vm.transactionFilterOptions = {
          genericSearch: "",
          transactionType: undefined,
          amountGTE: undefined,
          amountLTE: undefined,
          currencySymbol: undefined,
          dateFrom: undefined,
          dateTo: undefined,
          datePeriodStart: undefined
        };

        vm.datesToDisabled = function (date, mode) {
            // if (!vm.transactionFilterOptions.dateFrom) return true;
            // var yearAfter = new Date(vm.transactionFilterOptions.dateFrom.getFullYear() + 1, vm.transactionFilterOptions.dateFrom.getMonth(), vm.transactionFilterOptions.dateFrom.getDate() + 1);
            // return (mode === 'day' && (date.getTime() < vm.transactionFilterOptions.dateFrom || (date.getTime() >= yearAfter)));  // 	polje „Datum do“ je opcionalno polje,  ne smije se unijeti datum manji od onog u polju „Datum od“
            return (mode === 'day' && (date.getTime() < vm.transactionFilterOptions.dateFrom));  // 	polje „Datum do“ je opcionalno polje,  ne smije se unijeti datum manji od onog u polju „Datum od“
        };

      vm.transactionFilterYearDateRangeValid = true;
        vm.onDateFromChange = function () {
          if (!vm.transactionFilterOptions.dateTo) return;
          if (vm.transactionFilterOptions.dateTo < vm.transactionFilterOptions.dateFrom) {
            vm.transactionFilterOptions.dateTo = angular.copy(vm.transactionFilterOptions.dateFrom);
          }
          // if (vm.transactionFilterOptions.dateFrom) {
          //   var yearAfter = new Date(vm.transactionFilterOptions.dateFrom.getFullYear() + 1, vm.transactionFilterOptions.dateFrom.getMonth(), vm.transactionFilterOptions.dateFrom.getDate());
          //   if (yearAfter <= (vm.transactionFilterOptions.dateTo && vm.transactionFilterOptions.dateTo.getTime())) {
          //     vm.transactionFilterOptions.dateTo = yearAfter;
          //   }
          // }
          if (vm.transactionFilterOptions.dateFrom && vm.transactionFilterOptions.dateTo) {
            if (daysBetween(vm.transactionFilterOptions.dateFrom, vm.transactionFilterOptions.dateTo) < 365) {
              vm.transactionFilterYearDateRangeValid = true;
            } else {
              vm.transactionFilterYearDateRangeValid = false;
            }
          }
        };
        vm.onDateToChange = function () {
          if (!vm.transactionFilterOptions.dateFrom) return;
          if (daysBetween(vm.transactionFilterOptions.dateFrom, vm.transactionFilterOptions.dateTo) < 365) {
            vm.transactionFilterYearDateRangeValid = true;
          } else {
            vm.transactionFilterYearDateRangeValid = false;
          }
        }

        function daysBetween (firstDate, secondDate) {
          var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
          var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
          return diffDays;
        }

        vm.applyFilter = function () {
          if (!vm.transactionFilterYearDateRangeValid) return;
          if (!vm.transactionFilterOptions.datePeriodStart && (!vm.transactionFilterOptions.dateFrom || !vm.transactionFilterOptions.dateTo)) return;
          vm.showFilterOptionsWrapper = false;
          console.log(vm.transactionFilterOptions);
          vm.refreshTransactionsByFilter(vm.transactionFilterOptions);
          //vm.transactionFilterChange({filterParams: vm.transactionFilterOptions});
        };
        vm.clearSearch = function () {
          vm.transactionFilterOptions.genericSearch = '';
          angular.extend(accountsFilter, vm.transactionFilterOptions);

          vm.getTransactions(true);
          //setTransactionFilterDatesAsDropdown();
        };
        vm.resetFilter = function () {
          vm.showFilterOptionsWrapper = false;
          vm.transactionFilterOptions.genericSearch = '';
          vm.transactionFilterOptions.transactionType = undefined;
          vm.transactionFilterOptions.amountGTE = undefined;
          vm.transactionFilterOptions.amountLTE = undefined;
          vm.transactionFilterOptions.currencySymbol = undefined;
          vm.transactionFilterOptions.dateTo = undefined;
          vm.transactionFilterOptions.dateFrom = undefined;
          vm.transactionFilterOptions.datePeriodStart = undefined;
          vm.transactionFilterYearDateRangeValid = true;
          angular.extend(accountsFilter, vm.transactionFilterOptions);

          setTransactionFilterDatesAsDropdown();
          setDefaultCurrencyToFilter();
        };
        vm.search = function () {
          angular.extend(accountsFilter, vm.transactionFilterOptions);
          if(vm.transactionFilterOptions.datePeriodStart){
            accountsFilter.valueDateGTE = undefined;
            accountsFilter.valueDateLTE = undefined;
          }

          if (vm.transactionFilterOptions.dateFrom && vm.transactionFilterOptions.dateTo) {
            accountsFilter.valueDateGTE = vm.transactionFilterOptions.dateFrom;
            accountsFilter.valueDateLTE = vm.transactionFilterOptions.dateTo;
            // Clean extended properties
            accountsFilter.dateFrom = undefined;
            accountsFilter.dateTo = undefined;
          }

          if(vm.transactionFilterOptions.genericSearch){
            // For Slo valueDateGTE and valueDateLTE is needed
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation !== 'sl') {
            accountsFilter.valueDateGTE = undefined;
              accountsFilter.valueDateLTE = undefined;
              if(vm.transactionFilterOptions.dateFrom || vm.transactionFilterOptions.dateTo){
                accountsFilter.dateFrom = vm.transactionFilterOptions.dateFrom;
                accountsFilter.dateTo = vm.transactionFilterOptions.dateTo;
              }
            }
          }



          accountsFilter.page = 0; //TSK-114366

          vm.getTransactions(true);
        };

        function setTransactionFilterDatesAsDropdown() {
          setPeriod();
          vm.transactionFilterOptions.dateTo = accountsFilter.valueDateLTE;
          vm.transactionFilterOptions.dateFrom = accountsFilter.valueDateGTE;
        }

        var setDefaultCurrencyToFilter = function () {
          var currency = _.find(vm.currenciesList, {symbol: vm.defaultCurrency});
          if (currency) {
            vm.transactionFilterOptions.currencySymbol = currency.symbol;
          }
        };

        vm.clearStatementDate = function () {
          if(vm.transactionFilterOptions.dateTo || vm.transactionFilterOptions.dateFrom)
            vm.transactionFilterOptions.datePeriodStart = undefined;
        };

        //-------------------------------------------
        //        TRANSACTION FILTER OPTIONS END
        //-------------------------------------------


        //-------------------------------------------
        //    CARDS TRANSACTION FILTER OPTIONS START
        //-------------------------------------------
        vm.showCardsFilterOptionsWrapper = false;
        vm.transactionCardsFilterOptions = {
          genericSearch: "",
          transactionType: undefined,
          amountGTE: undefined,
          amountLTE: undefined,
          currencySymbol: undefined,
          datePeriodStart: undefined,
          dateFrom: undefined,
          dateTo: undefined,
        };

      vm.transactionCards = {
        dateFromOpen: false,
        dateToOpen: false,
        transactionFilterYearDateRangeValid: true
      };
      vm.transactionCards.datesToDisabled = function (date, mode) {
        // if (!vm.transactionCardsFilterOptions.dateFrom) return true;
        // var yearAfter = new Date(vm.transactionCardsFilterOptions.dateFrom.getFullYear() + 1, vm.transactionCardsFilterOptions.dateFrom.getMonth(), vm.transactionCardsFilterOptions.dateFrom.getDate() + 1);
        return (mode === 'day' && (date.getTime() < vm.transactionCardsFilterOptions.dateFrom));  // 	polje „Datum do“ je opcionalno polje,  ne smije se unijeti datum manji od onog u polju „Datum od“
      };

      vm.transactionCards.onDateFromChange = function () {
        if (!vm.transactionCardsFilterOptions.dateTo) return;
        if (vm.transactionCardsFilterOptions.dateTo < vm.transactionCardsFilterOptions.dateFrom) {
          vm.transactionCardsFilterOptions.dateTo = angular.copy(vm.transactionCardsFilterOptions.dateFrom);
        }
        // if (vm.transactionCardsFilterOptions.dateFrom) {
        //   var yearAfter = new Date(vm.transactionCardsFilterOptions.dateFrom.getFullYear() + 1, vm.transactionCardsFilterOptions.dateFrom.getMonth(), vm.transactionCardsFilterOptions.dateFrom.getDate());
        //   if (yearAfter <= (vm.transactionCardsFilterOptions.dateTo && vm.transactionCardsFilterOptions.dateTo.getTime())) {
        //     vm.transactionCardsFilterOptions.dateTo = yearAfter;
        //   }
        // }

          if (daysBetween(vm.transactionCardsFilterOptions.dateFrom, vm.transactionCardsFilterOptions.dateTo) < 365) {
            vm.transactionCards.transactionFilterYearDateRangeValid = true;
          } else {
            vm.transactionCards.transactionFilterYearDateRangeValid = false;
          }
      };
      vm.transactionCards.onDateToChange = function () {
        if (!vm.transactionCardsFilterOptions.dateFrom) return;
        if (daysBetween(vm.transactionCardsFilterOptions.dateFrom, vm.transactionCardsFilterOptions.dateTo) < 365) {
            vm.transactionCards.transactionFilterYearDateRangeValid = true;
          } else {
            vm.transactionCards.transactionFilterYearDateRangeValid = false;
          }
      }

      vm.transactionCards.clearStatementDate = function () {
        if(vm.transactionCardsFilterOptions.dateTo || vm.transactionCardsFilterOptions.dateFrom)
          vm.transactionCardsFilterOptions.datePeriodStart = undefined;
      };


        vm.applyCardsFilter = function () {
          if (!vm.transactionCards.transactionFilterYearDateRangeValid) return;
          if (!vm.transactionCardsFilterOptions.datePeriodStart && (!vm.transactionCardsFilterOptions.dateFrom || !vm.transactionCardsFilterOptions.dateTo)) return;
          if (vm.transactionCardsFilterOptions.dateFrom && vm.transactionCardsFilterOptions.dateTo) {
            vm.transactionCardsFilterOptions.valueDateGTE =  vm.transactionCardsFilterOptions.dateFrom;
            vm.transactionCardsFilterOptions.valueDateLTE =  vm.transactionCardsFilterOptions.dateTo;
          }


          vm.showCardsFilterOptionsWrapper = false;
          if (vm.transactionCardsFilterOptions.datePeriodStart) {
            this.transactionCardsFilterOptions.valueDateGTE = undefined;
            this.transactionCardsFilterOptions.valueDateLTE = undefined;
          }
          if(vm.transactionFilterOptions.genericSearch && $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != "sl"){
            accountsFilter.valueDateGTE = undefined;
            accountsFilter.valueDateLTE = undefined;
            if(params.dateFrom || params.dateTo){
              accountsFilter.dateFrom = params.dateFrom;
              accountsFilter.dateTo = params.dateTo;
            }
          }

          var filter = angular.copy(vm.transactionCardsFilterOptions);
          filter.dateTo = undefined;
          filter.dateFrom = undefined;
          vm.refreshCardTransactionsByFilter(filter);
          //vm.transactionFilterChange({filterParams: vm.transactionFilterOptions});
        };
        vm.clearCardsSearch = function () {
          vm.transactionCardsFilterOptions.genericSearch = '';
          angular.extend(vm.connectedCardTransactionsFilter, vm.transactionCardsFilterOptions);
          vm.getConnectedCardsTransactions(true);
        };
        vm.resetCardsFilter = function () {
          vm.showCardsFilterOptionsWrapper = false;
          vm.transactionCardsFilterOptions.genericSearch = '';
          vm.transactionCardsFilterOptions.transactionType = undefined;
          vm.transactionCardsFilterOptions.amountGTE = undefined;
          vm.transactionCardsFilterOptions.amountLTE = undefined;
          vm.transactionCardsFilterOptions.currencySymbol = undefined;
          vm.transactionCardsFilterOptions.datePeriodStart = undefined;
          vm.transactionCards.transactionFilterYearDateRangeValid = true;
          angular.extend(vm.connectedCardTransactionsFilter, vm.transactionCardsFilterOptions);
          // Clear
          vm.connectedCardTransactionsFilter.dateFrom = undefined;
          vm.connectedCardTransactionsFilter.dateTo = undefined;

          setDefaultCurrencyToCardsFilter();
          getDatesFromConnectedCardsSelectedPeriod();

          vm.getConnectedCardsTransactions(true);
        };
        vm.searchCards = function () {
          angular.extend(vm.connectedCardTransactionsFilter, vm.transactionCardsFilterOptions);
          vm.connectedCardTransactionsFilter.accountId = vm.selectedAccount.accountId;

          if(vm.transactionCardsFilterOptions.genericSearch){
            // For Slo valueDateGTE and valueDateLTE is needed
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation !== 'sl') {
              vm.connectedCardTransactionsFilter.valueDateLTE = undefined;
              vm.connectedCardTransactionsFilter.valueDateGTE = undefined;
            } else {
              vm.connectedCardTransactionsFilter.dateFrom = undefined;
              vm.connectedCardTransactionsFilter.dateTo = undefined;
            }

          }
          vm.connectedCardTransactionsFilter.accountId = vm.selectedAccount.accountId;
          vm.groupByConnectedCardTransactions(true);
          // vm.getConnectedCardsTransactions(true);
        };

        var setDefaultCurrencyToCardsFilter = function () {
          var currency = _.find(vm.currenciesList, {symbol: vm.defaultCurrency});
          if (currency) {
            vm.transactionCardsFilterOptions.currencySymbol = currency.symbol;
          }
        };

        //-------------------------------------------
        //    CARDS TRANSACTION FILTER OPTIONS END
        //-------------------------------------------

        vm.toggleFilterSelection = function () {
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
        };

        var loadAccountInfo = function () {
          vm.transactionFilterYearDateRangeValid = true;

          if (vm.selectedAccount.accountType.group === 'CurrentAccount' && vm.selectedAccount.currencySymbol == defaultData.DefaultCurrency) {
                vm.showField = true;
            } else {
                vm.showField = false;
            }

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                if (_.contains(allowedCurrenciesSlo, vm.selectedAccount.currencySymbol)) {
                    vm.selectedAccount.canCashWithDrawal = true;
                } else {
                    vm.selectedAccount.canCashWithDrawal = false;
                }

                if(vm.selectedAccount.accountType.group === 'CardAccountTypes')
                  loadStatementsDates(vm.selectedAccount.accountId);
            }

            if (vm.selectedAccount.loanAccount && vm.selectedAccount.loanAccount.installmentCurrencySymbol != vm.selectedAccount.currencySymbol && defaultData.APILocation === 'hr') {
                vm.showConvertedLoansFields = true;
            }

            vm.selectedAccount.transactions = {
                hasMore: false
            };
            vm.selectedAccount.statements = {
                hasMore: false
            };



            loadStatementsAndTransactions();
            if (vm.countryCode === 'bh' && vm.selectedAccount.linkList && vm.selectedAccount.linkList.itemList.payInReservations) {
                loadAccountReservations(true);
            } else if (vm.showSubmenuItemType == 'reservations') {
                vm.showSubmenuItemType = 'transactions';
            }
            vm.eSavingBookRequestsFilter = {
                page: 0,
                pageSize: 10,
                accountId: vm.selectedAccount.accountId,
                orderBy: 'dateOfCreation desc'
            };

            vm.eBookSavingsRequests = {};

            if (vm.selectedAccount.cardList) {
                _.forEach(vm.selectedAccount.cardList, function (trn) {
                    trn.collapsed = false;
                });
            }

            // If user account list length is 1, then it is only owner in that list.
            // If there are more users in list, we need to display only authorized persons, without owner

            if (vm.selectedAccount.userAccountList && vm.selectedAccount.userAccountList.length > 1) {
                vm.selectedAccount.userAccountListFiltered = _.filter(vm.selectedAccount.userAccountList, function (item) {
                    return item.userAccountType !== 'Owner';
                });
            } else { //if there are no authorized persons, there should be "-" on GUI
                vm.selectedAccount.userAccountListFiltered = vm.selectedAccount.userAccountList;
                vm.selectedAccount.userAccountListFiltered[0].user.firstName = '-';
                vm.selectedAccount.userAccountListFiltered[0].user.lastName = '';
            }

            checkIfMultiCurrency();
            vm.isFavoriteAccount = vm.selectedAccount.isFavorite;
            vm.selectedAccount.loanAccountPaymentPlanList = _.sortBy(vm.selectedAccount.loanAccountPaymentPlanList, "nextInstallmentDate").reverse();
            vm.displayeBookSavingRequest = false;
        };

        // Load all accounts for user (carousel)
        var loadAccountsForCarousel = function () {
            vm.tempTransactionsList = [];
            vm.accountsForCarousel = [];
            //vm.allAccounts = [];

            var carouselListFilter = function () {
                var filter = {
                    page: 0,
                    pageSize: 100,
                    orderBy: 'isFavorite desc,accountType,iban,currencyCode'
                };
                if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'hr' || $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'sl') {
                    filter.includeList = ['cardList', 'userAccountList', 'cardAccount'];
                } else {
                    filter.includeList = ['cardList', 'userAccountList'];
                }
                if (vm.selectedAccount.accountType.group == 'LoanAccountType') {
                    filter.accountTypeGroup = 'LoanAccountType';
                    filter.includeList.push('loanAccount');
                } else if (vm.selectedAccount.accountType.group == 'DepositAccountTypes' || vm.selectedAccount.accountType.group == 'SavingAccountTypes') {
                    filter.includeList.push('parentAccount');
                    // For every other country filter Deposit and Saving account types
                    if (defaultData.APILocation != 'sr' && defaultData.APILocation != 'mne') {
                        filter.accountTypeGroupList = ['DepositAccountTypes', 'SavingAccountTypes'];
                        filter.includeList.push('depositAccount');
                    }
                    // For serbia and mne show only deposit account types
                    else if (defaultData.APILocation == 'sr' || defaultData.APILocation == 'mne') {
                        filter.accountTypeGroup = 'DepositAccountTypes';
                        filter.includeList.push('depositAccount');
                    }
                } else {
                    // SHOW ALL LEFT
                    filter.notInAccountTypeGroupList = ['LoanAccountType', 'DepositAccountTypes', 'SavingAccountTypes'];
                }
                return filter;
            };

            var findAccountFilter = {};
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'hr' || $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                findAccountFilter = {
                    includeList: ['CardAccount', 'LoanAccount', 'depositAccount', 'cardList', 'UserAccountList', 'ParentAccount', 'DepositAccountInterests']
                };
            } else {
                findAccountFilter = {
                    includeList: ['LoanAccount', 'depositAccount', 'cardList', 'UserAccountList', 'ParentAccount']
                };
            }
            AccountsService.getAccountById($stateParams.accountId, findAccountFilter)
                .then(function (response) {
                    vm.selectedAccount = response;
                    vm.selectedAccount.iban = (vm.selectedAccount.iban, vm.selectedAccount) ? vm.formatIban(response.iban, vm.selectedAccount) : "";
                    vm.accountLoaded = true;
                    //load carousel array accounts
                    AccountsService.getPage(carouselListFilter())
                        .then(function (response) {
                            vm.accountsForCarousel = response.result;
                            _.each(response.result, function (account) {
                                account.iban = (account.iban) ? vm.formatIban(account.iban, account) : "";
                            })
                            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                                vm.accountsForCarousel = $filter('orderBy')(response.result, ['-accountType.group', '-isOwn', 'sortOrderId'])
                            }
                            setCurrentAccount();
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                        });

                    loadAccountInfo();

                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        var checkIfMultiCurrency = function () {
            vm.multiCurrency = false;
            if (vm.selectedAccount.accountType.group === 'CurrentAccount' && defaultData.APILocation === 'hr' && defaultData.DefaultCurrency && vm.selectedAccount.currencySymbol && defaultData.DefaultCurrency !== vm.selectedAccount.currencySymbol) {
                vm.multiCurrency = true;
            }
        };

        loadCurrencies();

        function loadCurrencies() {
            CurrencyService.getCurrencyPage({
                    pageSize: 1000
                })
                .then(function (response) {
                    vm.currenciesList = response.result;

                    var countryIndex = _.findIndex(vm.currenciesList, function (o) {
                        if (defaultData.APILocation == 'hr') {
                            return o.symbol == 'HRK';
                        } else if (defaultData.APILocation == 'sr') {
                            return o.symbol == 'RSD';
                        }
                    });
                    vm.currencySelectObject = vm.currenciesList[countryIndex];

                    setDefaultCurrencyToFilter();
                    setDefaultCurrencyToCardsFilter();

                    //$log.debug("currenciesList", vm.currenciesList);
                }).catch(function (error) {
                    $log.error(error);
                });
        }

        var setCurrentAccount = function (accountId) {
            var filteredBy = accountId ? accountId : $stateParams.accountId;
            var currIndex = 0;
            _.forEach(vm.accountsForCarousel, function (item) {
                item.index = currIndex++;
            });

            vm.currentIndex = _.findIndex(vm.accountsForCarousel, function (item) {
                return filteredBy === item.accountId;
            });

            vm.isNextButtonVisible = vm.currentIndex < vm.accountsForCarousel.length - 1;
            vm.isPreviousButtonVisible = vm.currentIndex > 0;
        };

        vm.chooseFromCarousel = function (accountId) {
            setCurrentAccount(accountId);
            vm.selectedAccount = vm.accountsForCarousel[vm.currentIndex];
            vm.isEditable = false;
            $state.go('accounts', {
                accountId: vm.selectedAccount.accountId
            }, {
                notify: false
            });
            loadAccountInfo();
        };

        vm.goToNextItem = function () {

            GoogleTagManagerHelperService.pushEvent('Accounts', 'Carousel', 'NextSlide');

            vm.currentIndex++;
            vm.isPreviousButtonVisible = vm.currentIndex > 0;
            vm.isNextButtonVisible = vm.currentIndex < vm.accountsForCarousel.length - 1;
            if (vm.currentIndex <= vm.accountsForCarousel.length - 1) {
                var nextAccountId = vm.accountsForCarousel[vm.currentIndex].accountId;
                if (nextAccountId) {
                    $state.go('accounts', {
                        accountId: nextAccountId
                    }, {
                        notify: false
                    });
                }
                vm.selectedAccount = vm.accountsForCarousel[vm.currentIndex];
                vm.isEditable = false;
                //findAccountFromCarousel(nextAccountId);
                loadAccountInfo();
            }
        };

        vm.goToPreviousItem = function () {

            GoogleTagManagerHelperService.pushEvent('Accounts', 'Carousel', 'PreviousSlide');

            vm.currentIndex--;
            vm.isPreviousButtonVisible = vm.currentIndex > 0;
            vm.isNextButtonVisible = vm.currentIndex < vm.accountsForCarousel.length - 1;
            if (vm.currentIndex >= 0) {
                var previousAccountId = vm.accountsForCarousel[vm.currentIndex].accountId;
                if (previousAccountId) {
                    $state.go('accounts', {
                        accountId: previousAccountId
                    }, {
                        notify: false
                    });
                }
                vm.selectedAccount = vm.accountsForCarousel[vm.currentIndex];
                vm.isEditable = false;
                //findAccountFromCarousel(previousAccountId);
                loadAccountInfo();
            }
        };

        vm.isAccountDetailsOpen = false;

        vm.toggleAccountDetails = function () {
            vm.isAccountDetailsOpen = !vm.isAccountDetailsOpen;
            GoogleTagManagerHelperService.pushEvent('AccountDetails', 'ShowAccountDetails', (vm.isAccountDetailsOpen) ? "Show additional details" : "Less details");
        };

        vm.goToCashWithdrawal = function () {
            $state.go('cashWithdrawalPage.form', {
                accountId: vm.selectedAccount.accountId
            })
        };

        vm.isAccountDetailsOpen = false;

        vm.numberOfAccountsToShow = 4;

        vm.showSubmenuItemType = 'transactions';

        vm.all = false;
        //vm.countryCode = $localStorage.code;

        vm.showSubmenu = function (show) {
            if (show == vm.showSubmenuItemType) return;

            if (show == 'transactions') {
                vm.showSubmenuItemType = 'transactions';
            } else if (show == 'statements') {
                vm.showSubmenuItemType = 'statements';
            } else if (show == 'reservations') {
                vm.showSubmenuItemType = 'reservations';
            }

            GoogleTagManagerHelperService.pushEvent('Accounts', 'Tab', vm.showSubmenuItemType);
        };

        vm.tmpSearchText = {
            name: ''
        };

        vm.accountList = [];
        var accountsFilter = {
            accountId: undefined,
            orderBy: 'ValueDate DESC, referenceNumber desc',
            page: 0,
            pageSize: 10,
            isCardTransaction: false
        };

        vm.allAccountsFilter = {
            page: 0,
            pageSize: 1000,
            includeList: ['userAccountList']
        };

        vm.busy = false; //marks is request already fired

        vm.defaultaccountsTempFilter = {
            selectedTransactionType: 'all',
            amountGTE: null,
            amountLTE: null,
            genericSearch: null
        };

        vm.accountsTempFilter = {};

        vm.accountsTempFilter = _.extend(vm.accountsTempFilter, vm.defaultaccountsTempFilter);

        vm.accountsSearchFilter = {
            searchAccounts: ''
        };

        vm.isEditable = false;

        $translate(['transactions.transactionTypes.credit', 'transactions.transactionTypes.debit', 'transactions.transactionTypes.all']).then(function (translations) {

            vm.transactionTypeFilterList = [
                {
                    id: 'all',
                    description: translations['transactions.transactionTypes.all']
        }
        , {
                    id: 'credit',
                    description: translations['transactions.transactionTypes.credit']
        }
        , {
                    id: 'debit',
                    description: translations['transactions.transactionTypes.debit']
        }
      ];
        });

        vm.periodList = [
            {
                key: 'today',
                description: 'core.period.today'
      }
      , {
                key: 'yesterday',
                description: 'core.period.yesterday'
      }
      , {
                key: 'thisWeek',
                description: 'core.period.thisWeek'
      }
      , {
                key: 'thisMonth',
                description: 'core.period.thisMonth'
      }
      , {
                key: 'thisYear',
                description: 'core.period.thisYear'
      }
      , {
                key: 'all',
                description: 'core.period.all'
      }
    ];

        vm.selectedPeriod = vm.periodList[2];
        vm.connectedCardsSelectedPeriod = vm.periodList[2];

      vm.detailedFilter = {
        statementDates: [],
        valueDateGTE: '',
        valueDateLTE: ''
      };

      function loadStatementsDates(accountId) {
        StatementsService.getStatementDates(accountId)
          .then(function (response) {
            vm.statementDates = response;
          })
          .catch(function (error) {
            HelperService.showMessage('error',error);
          });
      }


      vm.init = function () {
        EndpointsService.getLinks()
          .then(function (data) {
            vm.links = data.links;
          });



        if ($stateParams.accountId) {
          loadAccountsForCarousel();
        }
      };

      var loadStatementsAndTransactions = function () {
        vm.getStatements(true);
        //vm.getTransactions(true);
        //setPeriod();
        vm.resetFilter();
      };


      //next method sets accountsFilter.valueDateGTE & accountsFilter.valueDateLTE based on selected period
        function setPeriod() {

          if (vm.selectedPeriod.key == 'today') {
            var range = HelperService.getToday();
            accountsFilter.valueDateGTE = range.firstDay;
            accountsFilter.valueDateLTE = range.lastDay;
          } else if (vm.selectedPeriod.key == 'yesterday') {
            var range = HelperService.getYesterday();
            accountsFilter.valueDateGTE = range.firstDay;
            accountsFilter.valueDateLTE = range.lastDay;
          } else if (vm.selectedPeriod.key == 'thisWeek') {
            var range = HelperService.getThisWeek();
            accountsFilter.valueDateGTE = range.firstDay;
            accountsFilter.valueDateLTE = range.lastDay;
          } else if (vm.selectedPeriod.key == 'thisMonth') {
            var range = HelperService.getLast30Days();
            accountsFilter.valueDateGTE = range.firstDay;
            accountsFilter.valueDateLTE = range.lastDay;
          } else if (vm.selectedPeriod.key == 'thisYear') {
            var range = HelperService.getThisYear();
            accountsFilter.valueDateGTE = range.firstDay;
            accountsFilter.valueDateLTE = range.lastDay;
          } else if (vm.selectedPeriod.key == 'all') {
            accountsFilter.valueDateGTE = null;
            accountsFilter.valueDateLTE = null;

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
              var range;
              switch (vm.selectedAccount.accountType.group) {
                case 'SavingAccountTypes':
                case 'CardAccountTypes':
                  range = HelperService.getAllFrom2LastYears();
                  break;
                default:
                  range = HelperService.getThisYear();

              }

              accountsFilter.valueDateGTE = range.firstDay;
              accountsFilter.valueDateLTE = range.lastDay;
            }
          }

          vm.getTransactions(true);
        }

        vm.getTransactions = function (reset) {

            if (!vm.selectedAccount || !vm.selectedAccount.accountId) {
                $log.debug("return", vm.selectedAccount);
                return;
            }

            if (!reset && vm.selectedAccount.transactions != undefined && vm.selectedAccount.transactions.hasMore != undefined && vm.selectedAccount.transactions.hasMore == false) {
                return;
            }

            if (reset) {
                accountsFilter.page = 0;
            } else {
                accountsFilter.page += 1;
            }


            if(vm.transactionFilterOptions.datePeriodStart){
              accountsFilter.valueDateGTE = undefined;
              accountsFilter.valueDateLTE = undefined;
            }

            // if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'sl') {
            //   vm.transactionFilterOptions.dateFrom = accountsFilter.valueDateGTE;
            //   vm.transactionFilterOptions.dateTo = accountsFilter.valueDateLTE;
            //   //setTransactionFilterDatesAsDropdown();
            // }
            accountsFilter.accountId = vm.selectedAccount.accountId;
            vm.groupByTransactions(reset);
        };


      vm.changeTransactionPeriod = function (period) {
        // TODO: accountsFilter refresh after Period change is a problem
        if (period) {
          vm.selectedPeriod = period;
          vm.transactionFilterYearDateRangeValid = true;
          vm.busy = false;
          // vm.getTransactions(true);
          // setPeriod();
          vm.resetFilter();
          GoogleTagManagerHelperService.pushEvent('Accounts', 'TabPeriodFilter', $translate.instant(period.description));
        }
      };



        vm.refreshTransactionsByFilter = function (params) {
          angular.extend(accountsFilter, params);
          if (params.dateFrom && params.dateTo) {
            accountsFilter.valueDateGTE = params.dateFrom;
            accountsFilter.valueDateLTE = params.dateTo;
            // Clean extended properties
            accountsFilter.dateFrom = undefined;
            accountsFilter.dateTo = undefined;
          }

          if(vm.transactionFilterOptions.datePeriodStart){
            accountsFilter.valueDateGTE = undefined;
            accountsFilter.valueDateLTE = undefined;
          }

          // For Slo valueDateGTE and valueDateLTE is needed !!
          if(vm.transactionFilterOptions.genericSearch && $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != "sl"){
            accountsFilter.valueDateGTE = undefined;
            accountsFilter.valueDateLTE = undefined;
            if(params.dateFrom || params.dateTo){
              accountsFilter.dateFrom = params.dateFrom;
              accountsFilter.dateTo = params.dateTo;
            }
          }

          accountsFilter.page = 0; //TSK-114366

          var type = (params.transactionType) ? $translate.instant("timelineFilter." + params.transactionType.toLowerCase()) : $translate.instant("timelineFilter.all");
          GoogleTagManagerHelperService.pushEvent('Accounts', 'TimelineFilterCategorySelection', type);
          vm.groupByTransactions(true);
        };

        vm.groupByTransactions = function (reset) {

            TransactionsService.getPage(accountsFilter)
                .then(function (response) {
                    vm.busy = false;

                    $(response.result).each(function (i, e) {
                        if (e.transactionType == "Credit") {
                            e.credit = e.amount;
                            e.debit = null;
                        } else {
                            e.credit = null;
                            e.debit = e.amount;
                        }
                    });

                    vm.selectedAccount.transactions = HelperService.mergeRowsForTimeline({
                        existingData: vm.selectedAccount.transactions,
                        newData: response,
                        groupFunction: function (item) {
                            var valueDate = new Date(item.valueDate);
                            valueDate.setHours(0, 0, 0, 0);
                            return valueDate;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                valueDate: e,
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });
                    _.each(vm.selectedAccount.transactions.result, function (item) {
                        item.valueDate = new Date(item.valueDate);
                    });

                    if (defaultData.APILocation === 'hr' && vm.selectedAccount.accountType.group === 'SavingAccountTypes' && vm.selectedAccount.accountType.id === 'SVGSUB' && vm.selectedAccount.parentAccountId) {
                        var tempAccNumber = '';
                        AccountsService.getAccountById(vm.selectedAccount.parentAccountId)
                            .then(function (response) {
                                tempAccNumber = response.accountNumber;

                                _.forEach(vm.selectedAccount.transactions.result, function (item) {
                                    if (item.transactionType === 'Credit') {
                                        item.fromAccountNumber = tempAccNumber;
                                        item.toAccountNumber = vm.selectedAccount.accountNumber;
                                    } else if (item.transactionType === 'Debit') {
                                        item.toAccountNumber = tempAccNumber;
                                        item.fromAccountNumber = vm.selectedAccount.accountNumber;
                                    }
                                });

                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    }

                    //$log.debug("transactions", vm.selectedAccount.transactions);

                    ///////////PROVJERA ZA POVRAT SREDSTAVA SRB//////////////
                    if (defaultData.APILocation == 'sr' && vm.selectedAccount.transactions.result.length > 0) {
                        _.forEach(vm.selectedAccount.transactions.result, function (transactionItem) {
                            if (transactionItem.transactionType == 'Credit') {
                                if (transactionItem.detail.toAccountNumber != undefined && transactionItem.detail.toAccountNumber != '') {
                                    var firstNumbers = transactionItem.detail.toAccountNumber.substr(0, 3);
                                    if (firstNumbers !== '165' && firstNumbers !== '700' && firstNumbers !== '908') {
                                        transactionItem.retrieval = true;
                                        vm.tempTransactionsList.push(transactionItem)
                                    } else {
                                        vm.tempTransactionsList.push(transactionItem);
                                    }
                                } else {
                                    vm.tempTransactionsList.push(transactionItem);
                                }

                            } else {
                                vm.tempTransactionsList.push(transactionItem);
                            }
                        });
                        if (vm.tempTransactionsList.length > 0) {
                            vm.selectedAccount.transactions.result = vm.tempTransactionsList;
                            vm.tempTransactionsList = [];
                        }
                    }

                }).catch(function (error) {
                    $log.error(error);
                    $log.debug("Transactions loading error");
                });
        };


        vm.loadMoreTransactions = function (reset) {
            vm.getTransactions(reset);
        };

        vm.resetTransactionsFilter = function () {
            vm.accountsTempFilter = _.extend(vm.accountsTempFilter, vm.defaultaccountsTempFilter);
        };

        //---------------------STATEMENTS-------------------------//

        vm.statementsFilter = {
            accountId: undefined,
            orderBy: 'closeDate DESC',
            page: 0,
            pageSize: 10
        };

        vm.loadMoreStatements = function () {

            if (vm.selectedAccount.statements.hasMore !== false) {
                $log.debug("load");
                vm.statementsFilter.page += 1;
                vm.getStatements(false);
            } else {
                $log.debug("no more data");
            }

        };

        vm.getStatements = function (reset) {
            if (reset) {
                vm.statementsFilter.page = 0;
            }
            vm.statementsFilter.accountId = vm.selectedAccount.accountId;
            vm.groupByStatements(reset);
        };

        vm.groupByStatements = function (reset) {

            StatementsService.getPage(vm.statementsFilter)
                .then(function (response) {
                    vm.busy = false;

                    if (vm.selectedAccount != undefined) {

                        vm.selectedAccount.statements = HelperService.mergeRowsForTimeline({
                            existingData: vm.selectedAccount.statements,
                            newData: response,
                            groupFunction: function (item) {
                                return new Date(item.closeDate).getFullYear();
                            },
                            virtualRowFunction: function (e) {
                                return {
                                    isVirtual: true,
                                    closeDateYear: e
                                }
                            },
                            reset: reset,
                            reverse: true
                        });

                    }

                    //$log.debug("statements", vm.selectedAccount.statements);
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.getSelectedAccountId = function () {
            return {
                accountId: vm.selectedAccount.accountId
            }
        };

        vm.getTransactionDetails = function (timelineItem) {
            timelineItem.account = vm.selectedAccount;
            timelineItem.countryCode = defaultData.APILocation;
        };

        vm.DownloadPDFStatement = function (params, statement) {
            // link for download statement is provided (BiH environment)
          if (vm.countryCode === "bh") {
                StatementsService.downloadPdfStatement(params)
            } else {
            if (statement.downloadInProgress) return;
            statement.downloadInProgress = true;

            StatementsService.downloadPdf(params)
                  .finally(function() {
                    statement.downloadInProgress = false;
                  });
            }
            GoogleTagManagerHelperService.pushEvent('AccountDetails', 'ExternalLink', $translate.instant("accounts.accDownloadPdf"));
        };

        vm.goToEbookPay = function (payType) {
            if (payType === 'Pay In') {
                $state.go('payments.ebookPay.payIn', {
                    accountId: vm.selectedAccount.accountId,
                    myParam: vm.selectedAccount.accountType.group
                });
                GoogleTagManagerHelperService.pushEvent('Account', 'EbookPayIn', 'Ebook PayIn button clicked');
            }
            if (payType === 'Pay Out') {
                $state.go('payments.ebookPay.payOut', {
                    accountId: vm.selectedAccount.accountId,
                    myParam: vm.selectedAccount.accountType.group
                });
                GoogleTagManagerHelperService.pushEvent('Account', 'EbookPayOut', 'Ebook PayOut button clicked');
            }
        };

        vm.goToNewEbook = function () {
            GoogleTagManagerHelperService.pushEvent('Account', 'NewEbook', 'New Ebook button clicked');
            $state.go('newEbook', {
                accountId: vm.selectedAccount.accountId
            });
        };

        vm.closeEbook = function (accountId) {
            $state.go('closeEbook', {
                accountId: accountId
            });
        };

        vm.goToSavingsPayIn = function () {
            //in case of BiH environment navigate to internal transfer
            if (defaultData.APILocation === 'bh') {
                $state.go('payments.internalTransfer.fromAccounts', {
                    accountId: vm.selectedAccount.accountId
                });
            } else {
                if (vm.selectedAccount.currencySymbol != defaultData.DefaultCurrency) {
                    $state.go('payments.savingsPayIn', {
                        accountId: vm.selectedAccount.accountId
                    });
                } else {
                    $state.go('payments.internalTransfer.fromAccounts', {
                        accountId: vm.selectedAccount.accountId
                    });
                }
            }
        };

        vm.goToLoanPayment = function () {
            switch (defaultData.APILocation) {
            case 'hr':
                $state.go('payments.loanPayment', {
                    accountId: vm.selectedAccount.accountId
                });
                break;
            case 'sr':
            case 'mne':
            case 'bh':
                $state.go('payments.internalTransfer.loan', {
                    loanId: vm.selectedAccount.accountId
                });
                break;

            case 'sl':
                $state.go('payments.loanPayment', {
                    accountId: vm.selectedAccount.accountId
                });
                break;
            }
        };

        vm.goToInternalPayment = function () {
            $state.go('payments.internalTransfer.fromAccounts', {
                accountId: vm.selectedAccount.accountId
            });
        };

        vm.goToChangeWithdrawal = function () {
            $state.go('changeWithdrawal', {
                accountId: vm.selectedAccount.accountId
            });
        }

        vm.cancelDepositAction = function () {
            console.log(vm.selectedAccount);
            if (vm.selectedAccount.depositAccount.depositIdExternal) {
                /*
                 Deposit order can be canceled only if it is opened from e-banking system.
                 We don't have information if it is opened from e-banking, or in bank directly (there is currently no flag),
                 so we need to try to load deposit order, and if we get result, go to cancel deposit screen.
                 * */
                DepositOrdersService.getPage({
                    referenceNumber: vm.selectedAccount.depositAccount.depositIdExternal
                }).then(function (response) {
                    if (response && response.result[0]) {
                        // Go to cancel deposit screen
                        $state.go('orders.cancelDeposit', {
                            accountId: vm.selectedAccount.accountId
                        });
                    } else {
                        //  Show message to user if there is no result
                        var message = $translate.instant('accounts.depositCantBeCanceledError');
                        HelperService.showTranslatedMessage('info', message);
                    }
                }).catch(function (error) {
                    HelperService.showMessage(error, "error");
                });
            }
        };

        vm.markAsFavorite = function () {
            AccountsService.updateAccount(vm.selectedAccount.accountId, {
                    "isFavorite": !vm.isFavoriteAccount
                })
                .then(function (response) {
                    vm.isFavoriteAccount = response.isFavorite;
                  GoogleTagManagerHelperService.pushEvent('Accounts', 'FavoriteAccountSelection', (response.isFavorite) ? "Marked as favorite" : "Unmarked as favorite");
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.resetAccountName = function () {
            vm.newDescription = vm.selectedAccount.accountDescription;
            vm.editAccount();
        };

        vm.showEditAccount = function () {
            vm.isEditable = true;
            vm.newDescription = vm.selectedAccount.friendlyName;
        };

        vm.editAccount = function () {
            AccountsService.updateAccount(vm.selectedAccount.accountId, {
                    "accountDescription": vm.newDescription
                })
                .then(function (response) {
                    vm.isEditable = false;
                    vm.selectedAccount.friendlyName = vm.newDescription;
                GoogleTagManagerHelperService.pushEvent('Accounts', 'RenameAccount', 'Submit');
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        // TODO: It seems service doesn't work well. It returns card as "Active" even after update is successfull
        vm.updateCardStatus = function (accountId, card) {
          if (card.cardStatusStr == 2) {
            vm.updateCardStatusCro();
            return;
          }

          // If card is selected disable button until updateCardStatus is resolved

            card.selected = true;
            //dummyUpdate(card);
            if (card.temporaryStatus) {
                return;
            } else {


                AccountsService.updateCardStatus(accountId, card)
                    .then(function (response) {
                        console.log(response);
                        //card.cardStatus = response.data.status;
                        // GoogleTagManagerHelperService.pushEvent('AccountsOverview', 'Tab', $translate.instant(translateLabel));

                      var selectedCard = _.find(response.data.cardList, function (c) {
                        return c.cardId == card.cardId;
                      });


                      if (selectedCard && selectedCard.temporaryStatus) {
                            card.temporaryStatus = selectedCard.temporaryStatus;
                        } else {
                            card.temporaryStatus = null;
                        }

                      var BlockCard;
                      if(card.temporaryStatus) {
                        BlockCard = (card.temporaryStatus == 'SentUnblockRequest') ? true : false;
                      } else {
                        BlockCard = (card.cardStatus === 'Active') ? true : false;
                      }
                      GoogleTagManagerHelperService.pushEvent('Accounts', 'BlockCardSelection', (BlockCard) ? "Block card" : "Unblock card");
                      //refreshCards()
                        card.selected = false;
                    })
                    .catch(function (error) {
                        card.selected = false;
                        HelperService.showMessage(error, 'error');
                    })
            };
        };


        vm.updateCardStatusCro = function () {
            AccountsService.openBlockModal();
        };

        vm.downloadTransactionReport = function (transaction) {
            var id = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") ? transaction.transactionId : transaction.id;
            TransactionsService.downloadTransactionPdf(id);
        };

        vm.navigateToReclamationForm = function (transaction) {
            var id = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") ? transaction.transactionId : transaction.id;
            $state.go('transactions.reclamation', {
                transactionId: id,
                accountId: $state.params.accountId,
                url: $state.current.name
            });
        };


        //// RETRIEVAL SRB /////

        vm.retrievalRequest = function (item) {
            $state.go('payments.domesticPayment', {
                myParam: 'retrieval',
                transactionDetails: item
            });
        };

        vm.getPaymentTemplatesPage = function () {
            PaymentTemplatesService.getPage()
                .then(function (response) {
                        vm.templateList = response;
                        $log.debug(vm.templateList);
                    }
                    /*, function (error) {
                     console.log(error);
                     }*/
                )
                .catch(function (error) {
                    $log.error(error);
                });
        };

        var filterEBookSavingRequest = function (reset) {
            if (vm.eBookSavingsRequests.result && vm.eBookSavingsRequests.result.length > 0) {
                vm.eBookSavingsGrouped = HelperService.mergeRowsForTimeline({
                    existingData: vm.eBookSavingsGrouped,
                    newData: vm.eBookSavingsRequests,
                    groupFunction: function (item) {
                        var date = new Date(item.dateOfCreation);
                        date.setHours(0, 0, 0, 0);
                        return date;
                    },
                    virtualRowFunction: function (e) {
                        var month = new Date(e).getMonth() + 1;
                        var day = new Date(e).getDate();
                        var virtualRow = {
                            isVirtual: true,
                            date: new Date(e),
                            month: month,
                            day: day
                        };
                        $log.debug("virtualRow", e, virtualRow);
                        return virtualRow;
                    },
                    reset: reset,
                    reverse: false
                });
                $log.debug("eBookSavingsGrouped", vm.eBookSavingsGrouped);
            }
        };


        vm.navigateToPaymentForm = function (templateParams) {
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && templateParams.template.paymentSubTypeGroup == "NotSupportedPayment") {
            AlertService.infoAlert({
              text: "paymentsOverview.notSupportedPaymentMsg"
            })
            return;
          }

            var stateLink;
            var params = {
                templateId: templateParams.id
            };
            var template = templateParams.template;

            switch (templateParams.type) {
            case "LocalCurrencyTransfer":
                stateLink = "payments.internalTransfer.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.domesticPayment.fromTemplatesToPay";
                }
                break;
            case "SEPAPayment":
            case "DomesticPayment":
            case "RevenuePayment":
                stateLink = "payments.domesticPayment.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.domesticPayment.fromTemplatesToPay";
                }
                break;
            case "CurrencyExchange":
                stateLink = "payments.currencyConversion.fromTemplate";;
                break;
            case "ForeignCurrencyTransfer":
                stateLink = "payments.internalTransfer.fromTemplate";
                break;
            case "ForeignPayment":
                stateLink = "payments.internationalPayment.fromTemplate";
                if (vm.countryCode === 'sl') {
                  stateLink = "payments.internationalPayment.fromTemplatesToPay";
                }
                break;
            }


          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
            if (template.paymentTypeGroup == "LocalCurrencyTransfer" && template.paymentSubTypeGroup == "SEPAPayment") {
              stateLink = 'payments.domesticPayment.fromTemplate';
            } else if (template.paymentTypeGroup == "LocalCurrencyTransfer"  && template.paymentSubTypeGroup == "LocalCurrencyTransfer") {
              stateLink = 'payments.internalTransfer.fromTemplate';
            }
            if (stateLink) {
              $state.go(stateLink, params);
            }

          } else {
            if (stateLink) {
              $state.go(stateLink, params);
            }
          }
        };


        var loadeSavingBookRequests = function (reset) {
            if (reset) {
                vm.eSavingBookRequestsFilter.page = 0;
            } else {
                vm.eSavingBookRequestsFilter.page += 1;
            }

            ESavingBookRequestsService.getESavingBookRequests(vm.eSavingBookRequestsFilter)
                .then(function (response) {
                    vm.eBookSavingsRequests = response;
                    filterEBookSavingRequest(reset);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.loadMoreSavingBookRequests = function () {
            loadeSavingBookRequests(false);
        };

        vm.showeSavingBookRequests = function () {
            vm.displayeBookSavingRequest = !vm.displayeBookSavingRequest;
            GoogleTagManagerHelperService.pushEvent('Account', 'EbookRequest', (vm.displayeBookSavingRequest)?'Show Ebook Requests button clicked':'Hide Ebook Requests button clicked');
            if (!vm.eBookSavingsRequests.result) {
                loadeSavingBookRequests(true);
            }
        };

        /////////////////////connected cards transactions for SRB and MNE///////////////////////

        vm.connectedCardTransactionsList = [];
        vm.connectedCardTransactionsFilter = {};

        vm.refreshCardTransactionsByFilter = function (params) {
            angular.extend(vm.connectedCardTransactionsFilter, params);

            vm.connectedCardTransactionsFilter.page = 0; //TSK-114366

            if(vm.transactionCardsFilterOptions.genericSearch){
              // For Slo valueDateGTE and valueDateLTE is needed
              if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation !== 'sl') {
                vm.connectedCardTransactionsFilter.valueDateLTE = undefined;
                vm.connectedCardTransactionsFilter.valueDateGTE = undefined;
              } else {
                vm.connectedCardTransactionsFilter.dateFrom = undefined;
                vm.connectedCardTransactionsFilter.dateTo = undefined;
              }
            }

            vm.connectedCardTransactionsFilter.accountId = vm.selectedAccount.accountId;

            // if(vm.countryCode === 'sl' && params.selectedStatementDate){
            //   vm.connectedCardTransactionsFilter.datePeriodStart = params.selectedStatementDate;
            //   vm.connectedCardTransactionsFilter.selectedStatementDate = undefined;
            // }

            var type = (params.transactionType) ? $translate.instant("timelineFilter." + params.transactionType.toLowerCase()) : $translate.instant("timelineFilter.all");
            GoogleTagManagerHelperService.pushEvent('Accounts ConnectedCards', 'TimelineFilterCategorySelection', type);
            vm.groupByConnectedCardTransactions(true);
        };

        vm.getConnectedCardsTransactions = function (reset) {

            if (!reset && vm.connectedCardTransactionsList != undefined && vm.connectedCardTransactionsList.hasMore != undefined && vm.connectedCardTransactionsList.hasMore == false) {
                return;
            }

            if (reset) {
                vm.connectedCardTransactionsFilter.page = 0;
            } else {
                vm.connectedCardTransactionsFilter.page += 1;
            }

            //getDatesFromConnectedCardsSelectedPeriod();
            vm.connectedCardTransactionsFilter.accountId = vm.selectedAccount.accountId;

            vm.groupByConnectedCardTransactions(reset);
        };

        function getDatesFromConnectedCardsSelectedPeriod() {
          if (vm.connectedCardsSelectedPeriod.key == 'today') {
            var range = HelperService.getToday();
            vm.connectedCardTransactionsFilter.valueDateGTE = range.firstDay;
            vm.connectedCardTransactionsFilter.valueDateLTE = range.lastDay;
          } else if (vm.connectedCardsSelectedPeriod.key == 'yesterday') {
            var range = HelperService.getYesterday();
            vm.connectedCardTransactionsFilter.valueDateGTE = range.firstDay;
            vm.connectedCardTransactionsFilter.valueDateLTE = range.lastDay;
          } else if (vm.connectedCardsSelectedPeriod.key == 'thisWeek') {
            var range = HelperService.getThisWeek();
            vm.connectedCardTransactionsFilter.valueDateGTE = range.firstDay;
            vm.connectedCardTransactionsFilter.valueDateLTE = range.lastDay;
          } else if (vm.connectedCardsSelectedPeriod.key == 'thisMonth') {
            var range = HelperService.getLast30Days();
            vm.connectedCardTransactionsFilter.valueDateGTE = range.firstDay;
            vm.connectedCardTransactionsFilter.valueDateLTE = range.lastDay;
          } else if (vm.connectedCardsSelectedPeriod.key == 'thisYear') {
            var range = HelperService.getThisYear();
            vm.connectedCardTransactionsFilter.valueDateGTE = range.firstDay;
            vm.connectedCardTransactionsFilter.valueDateLTE = range.lastDay;
          } else if (vm.connectedCardsSelectedPeriod.key == 'all') {
            vm.connectedCardTransactionsFilter.valueDateGTE = null;
            vm.connectedCardTransactionsFilter.valueDateLTE = null;

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
              var range;
              switch (vm.selectedAccount.accountType.group) {
                case 'SavingAccountTypes':
                case 'CardAccountTypes':
                  range = HelperService.getAllFrom2LastYears();
                  break;
                default:
                  range = HelperService.getThisYear();

              }
              vm.connectedCardTransactionsFilter.valueDateGTE = range.firstDay;
              vm.connectedCardTransactionsFilter.valueDateLTE = range.lastDay;
            }
          }
          if (!vm.transactionCardsFilterOptions.datePeriodStart) {
            vm.transactionCardsFilterOptions.dateFrom = angular.copy(vm.connectedCardTransactionsFilter.valueDateGTE);
            vm.transactionCardsFilterOptions.dateTo = angular.copy(vm.connectedCardTransactionsFilter.valueDateLTE);
          }
        }

        vm.changeConnectedCardsTransactionPeriod = function (period) {
            if (period) {
                vm.connectedCardsSelectedPeriod = period;
              vm.transactionCards.transactionFilterYearDateRangeValid = true;
              vm.busy = false;
                //vm.getConnectedCardsTransactions(true);
                vm.resetCardsFilter();
            }
          GoogleTagManagerHelperService.pushEvent('Accounts ConnectedCards', 'TabPeriodFilter', $translate.instant(period.description));

        };

        vm.groupByConnectedCardTransactions = function (reset) {

            TransactionsService.getPage(vm.connectedCardTransactionsFilter)
                .then(function (response) {
                    vm.busy = false;

                    $(response.result).each(function (i, e) {
                        if (e.transactionType == "Credit") {
                            e.credit = e.amount;
                            e.amount = $filter('number')(e.amount, 2);
                            e.debit = null;
                        } else {
                            e.credit = null;
                            e.debit = e.amount;
                            e.amount = $filter('number')(e.amount, 2);
                        }
                    });

                    vm.connectedCardTransactionsList = HelperService.mergeRowsForTimeline({
                        existingData: vm.connectedCardTransactionsList,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.valueDate);
                            date.setHours(0, 0, 0, 0); //sort only by date, not hours
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                valueDate: e,
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });
                    _.each(vm.connectedCardTransactionsList.result, function (item) {
                        item.valueDate = new Date(item.valueDate);
                    })
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.openCardTransactions = function (accountId, card, $event) {


            if (vm.selectedAccount.cardList) {
                var previousState = card.collapsed;
                // Close all other transactions if they were opened, and open/close trnsactions for selected card
                _.forEach(vm.selectedAccount.cardList, function (trn) {
                    if (trn.cardId !== card.cardId) {
                        trn.collapsed = false;
                    }
                    if (trn.cardId === card.cardId) {
                        trn.collapsed = !previousState;
                    }
                    vm.connectedCardsSelectedPeriod = vm.periodList[2];
                });
            }

            if (card.collapsedRes)
                card.collapsedRes = false;

            vm.transactionCardsFilterOptions = {
              genericSearch: "",
              transactionType: undefined,
              amountGTE: undefined,
              amountLTE: undefined,
              datePeriodStart: undefined
            };

            vm.connectedCardTransactionsFilter = {
                accountId: accountId,
                cardId: card.cardId,
                page: 0,
                pageSize: 10,
                orderBy: 'ValueDate DESC',
                isCardTransaction: true
            };

            setDefaultCurrencyToCardsFilter();

            angular.extend(vm.connectedCardTransactionsFilter, vm.transactionCardsFilterOptions);

            if(vm.countryCode == 'bh')
              vm.connectedCardTransactionsFilter.includeList = ['transactionDivision'];


            if (card.collapsed) {
                getDatesFromConnectedCardsSelectedPeriod();
                vm.getConnectedCardsTransactions(true);
                var e = angular.element($event.currentTarget);
                // e[0].scrollIntoView();
                e.scrollTop = 0;
                e.scrollTop += 100;
                /* var viewportOffset = e[0].getBoundingClientRect();
                 // these are relative to the viewport, i.e. the window
                 var top = viewportOffset.top;
                 var left = viewportOffset.left;
                 $window.scrollTo(top-100, left);*/
            }
        };

        vm.loadMoreConnectedCardsTransactions = function (reset) {
            if (vm.connectedCardTransactionsList.result && vm.connectedCardTransactionsList.result.length > 0 && !vm.collapsed) {
                vm.getConnectedCardsTransactions(false);
            }
        };
        /////////////////////connected cards reservations for SRB and MNE ////////////////////////////////////////////////////////////////
        vm.collapsedRes = false;
        vm.connectedCardReservationsList = [];
        vm.connectedCardReservationsFilter = {};

        vm.getConnectedCardsReservations = function (reset) {

            if (!reset && vm.connectedCardReservationsList != undefined && vm.connectedCardReservationsList.hasMore != undefined && vm.connectedCardReservationsList.hasMore == false) {
                return;
            }

            if (reset) {
                vm.connectedCardReservationsFilter.page = 0;
            } else {
                vm.connectedCardReservationsFilter.page += 1;
            }

            if (vm.connectedCardsSelectedPeriod.key == 'today') {
                var range = HelperService.getToday();
                vm.connectedCardReservationsFilter.valueDateGTE = range.firstDay;
                vm.connectedCardReservationsFilter.valueDateLTE = range.lastDay;
            } else if (vm.connectedCardsSelectedPeriod.key == 'yesterday') {
                var range = HelperService.getYesterday();
                vm.connectedCardReservationsFilter.valueDateGTE = range.firstDay;
                vm.connectedCardReservationsFilter.valueDateLTE = range.lastDay;
            } else if (vm.connectedCardsSelectedPeriod.key == 'thisWeek') {
                var range = HelperService.getThisWeek();
                vm.connectedCardReservationsFilter.valueDateGTE = range.firstDay;
                vm.connectedCardReservationsFilter.valueDateLTE = range.lastDay;
            } else if (vm.connectedCardsSelectedPeriod.key == 'thisMonth') {
                var range = HelperService.getLast30Days();
                vm.connectedCardReservationsFilter.valueDateGTE = range.firstDay;
                vm.connectedCardReservationsFilter.valueDateLTE = range.lastDay;
            } else if (vm.connectedCardsSelectedPeriod.key == 'thisYear') {
                var range = HelperService.getThisYear();
                vm.connectedCardReservationsFilter.valueDateGTE = range.firstDay;
                vm.connectedCardReservationsFilter.valueDateLTE = range.lastDay;
            } else if (vm.connectedCardsSelectedPeriod.key == 'all') {
                vm.connectedCardReservationsFilter.valueDateGTE = null;
                vm.connectedCardReservationsFilter.valueDateLTE = null;
            }

            //vm.connectedCardReservationsFilter.accountId = vm.selectedAccount.accountId;

            vm.groupByConnectedCardReservations(reset);
        };

        vm.changeConnectedCardsReservationPeriod = function (period) {
            if (period) {
                vm.connectedCardsSelectedPeriod = period;
                vm.busy = false;
                vm.getConnectedCardsReservations(true);
            }
        };

        vm.groupByConnectedCardReservations = function (reset) {
            ReservationsService.getPage(vm.connectedCardReservationsFilter)
                .then(function (response) {
                    vm.busy = false;

                    $(response.result).each(function (i, e) {
                        if (e.transactionType == "C") {
                            e.credit = e.amount;
                            e.amount = $filter('number')(e.amount, 2);
                            e.debit = null;
                        } else {
                            e.credit = null;
                            e.debit = e.amount;
                            e.amount = $filter('number')(e.amount, 2);
                        }
                    });

                    vm.connectedCardReservationsList = HelperService.mergeRowsForTimeline({
                        existingData: vm.connectedCardReservationsList,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.valueDate);
                            date.setHours(0, 0, 0, 0); //sort only by date, not hours
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                valueDate: new Date(e),
                                month: month,
                                day: day
                            };
                            //$log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });

                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.openCardReservations = function (accountId, card, $event) {
            if (vm.selectedAccount.cardList) {
                var previousState = card.collapsedRes;
                vm.collapsedRes = card.collapsedRes;
                // Close all other transactions if they were opened, and open/close trnsactions for selected card
                _.forEach(vm.selectedAccount.cardList, function (trn) {
                    if (trn.cardId !== card.cardId) {
                        trn.collapsedRes = false;
                    }
                    if (trn.cardId === card.cardId) {
                        trn.collapsedRes = !previousState;
                    }
                    vm.connectedCardsSelectedPeriod = vm.periodList[2];
                });
            }

            if (card.collapsed)
                card.collapsed = false;

            vm.connectedCardReservationsFilter = {
                accountId: accountId,
                cardId: card.cardId,
                /*isCardTransaction: true,*/
                page: 0,
                pageSize: 10,
                orderBy: 'ValueDate DESC',
            };

            if(vm.countryCode == 'bh'){
              vm.connectedCardReservationsFilter.includeList = ['transactionDivision'];
            }

            if (card.collapsedRes) {
                vm.getConnectedCardsReservations(true);
                var e = angular.element($event.currentTarget);

                e.scrollTop = 0;
                e.scrollTop += 100;

            }
        };

        vm.loadMoreConnectedCardsReservations = function (reset) {
            if (vm.connectedCardReservationsList.result && vm.connectedCardReservationsList.result.length > 0 && !vm.collapsedRes) {
                vm.getConnectedCardsReservations(reset);
            }
        };

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////// not finished yet - api side

        // Method to load only paymentPlanList for selected account. Added for optimization
        vm.toggleRepaymentPlan = function () {

            var gtmDescLabel = (!vm.showRepaymentPlan) ? $translate.instant("accounts.accRepaymentPlan") : $translate.instant("accounts.closeRepaymentPlan");
            GoogleTagManagerHelperService.pushEvent('AccountDetails', 'LoanAccountRepaymentPlanSelection', gtmDescLabel);

            // If we have already loaded repayment plan list, no need to load it again.
            if (vm.repaymentLoaded) {
                vm.showRepaymentPlan = !vm.showRepaymentPlan;
            } else {
                var paymentPlanFilter = {
                    includeList: ['loanAccountPaymentPlanList']
                };
                return AccountsService.getAccountById(vm.selectedAccount.accountId, paymentPlanFilter).then(function (response) {
                    if (response && response.loanAccountPaymentPlanList) {
                        vm.selectedAccount.loanAccountPaymentPlanList = response.loanAccountPaymentPlanList;
                        vm.repaymentLoaded = true;
                        vm.showRepaymentPlan = true;
                    }
                }).catch(function (err) {
                    HelperService.showMessage(err, 'error');
                });
            }

        };

        vm.goToForeignCurrencyTransfer = function () {
            $state.go('payments.savingsPayIn', {
                accountId: vm.selectedAccount.accountId
            });
        };

        vm.downloadContract = function () {
            DepositOrdersService.downloadContract(vm.selectedAccount.depositAccount.depositIdExternal);
        };

        vm.loadPaymentTemplates = function () {
            vm.showTemplatesView = !vm.showTemplatesView;
            if (vm.showTemplatesView) {
                if (!vm.templateList) {
                    vm.getPaymentTemplatesPage();
                }
            }
        };

        // reservation list related to BiH environment
        var reservationsFilter = {
            page: 0,
            pageSize: 10,
            orderBy: 'reservationDate DESC'
        };

        function loadAccountReservations(reset) {
            if (reset) {
                reservationsFilter.page = 0;
            } else {
                reservationsFilter.page++;
            }
            reservationsFilter.accountId = vm.selectedAccount.accountId;
            AccountsService.getReservations(reservationsFilter)
                .then(function (response) {
                    vm.selectedAccount.reservations = HelperService.mergeRowsForTimeline({
                        existingData: vm.selectedAccount.reservations,
                        newData: response,
                        groupFunction: function (item) {
                            var valueDate = new Date(item.reservationDate);
                            valueDate.setHours(0, 0, 0, 0);
                            return valueDate;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                valueDate: new Date(e),
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });
                    $log.debug("Accounts reservations: ", vm.selectedAccount.reservations);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        }

        vm.formatIban = function (iban, account) {
            // if($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
            if (account && (account.accountType.group == "CardAccountTypes" || account.accountType.group == "CurrentAccount") && vm.countryCode != 'bh') {
                return iban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
            } else {
                return iban
            }
        };

        vm.formatCardNumber = function (cn) {
            return cn.replace(/(.{4})/g, '$1 ').trim()
        };

        vm.loadMoreReservations = function () {
            loadAccountReservations(false);
        };

        //bosnia specific TSK-9380 Pdf tab - za prikaz izvoda na aplikaciji ebank - retail
        vm.checkForAccountTypeId = function (id) {
            return _.contains(['1040', '1041', '1042'], id);
        };

        vm.pushGtmPayInEvent = function (accType) {
            GoogleTagManagerHelperService.pushEvent('AccountDetails', accType + 'PayIn', accType + ' PayIn button clicked');
        };

        vm.additionalCheck = function (transaction, accountTypeId) {
          var thisMonth = HelperService.getThisMonth();
          if(transaction.valueDate > thisMonth.firstDay && transaction.valueDate < thisMonth.lastDay){
            return _.contains(['1041', '1042'], accountTypeId);
          }else{
            return false;
          }
        };


        vm.init();
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name accounts.factory:AccountLimitOrderService
     *
     * @description
     *
     */
    AccountLimitOrderService.$inject = ["$q", "$http", "EndpointsService", "$log"];
    angular
        .module('accounts')
        .factory('AccountLimitOrderService', AccountLimitOrderService);

    function AccountLimitOrderService($q, $http, EndpointsService, $log) {
        var AccountLimitOrderServiceBase = {};

      AccountLimitOrderServiceBase.insertOrder = function (orderObject) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("AccountLimitOrderServiceBase.insertOrder object:", orderObject);
                $http.post(response.links.accountLimitOrder, orderObject)
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
      AccountLimitOrderServiceBase.validateOrder = function (orderObject) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
          $log.debug("AccountLimitOrderServiceBase.insertOrder object:", orderObject);
          $http.put(response.links.accountLimitOrder_validate, orderObject)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      AccountLimitOrderServiceBase.accountLimitPosTerminalOrderAmountType = function (params) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.accountLimitPosTerminalOrderAmountType, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };
      AccountLimitOrderServiceBase.accountLimitPosTerminalOrderPersonType = function (params) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
          $http.get(response.links.accountLimitPosTerminalOrderPersonType, {
            params: params
          })
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };
      AccountLimitOrderServiceBase.validateAccountLimitPosTerminalOrder = function (orderObject) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
          $log.debug("AccountLimitOrderServiceBase.insertOrder object:", orderObject);
          $http.put(response.links.accountLimitPosTerminalOrder_validate, orderObject)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };
      AccountLimitOrderServiceBase.insertPosTerminalOrder = function (order) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
          $http.post(response.links.accountLimitPosTerminalOrder, order)
            .success(function (data) {
              deferred.resolve(data);
            }).error(function (msg, code) {
            deferred.reject(msg);
          });
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      return AccountLimitOrderServiceBase;
    }
}());

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name accounts.factory:AccountLimitOrderPeriodTypeService
     *
     * @description
     *
     */
    AccountLimitOrderPeriodTypeService.$inject = ["$q", "$http", "EndpointsService", "$log"];
    angular
        .module('accounts')
        .factory('AccountLimitOrderPeriodTypeService', AccountLimitOrderPeriodTypeService);

    function AccountLimitOrderPeriodTypeService($q, $http, EndpointsService, $log) {
        var AccountLimitOrderPeriodTypeServiceBase = {};
        AccountLimitOrderPeriodTypeServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("AccountLimitOrderPeriodTypeServiceBase.getPage:", params);
                $http.get(response.links.accountLimitOrderPeriodType, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return AccountLimitOrderPeriodTypeServiceBase;
    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name accounts.factory:AccountLimitOrderNotificationTypeService
     *
     * @description
     *
     */
    AccountLimitOrderNotificationTypeService.$inject = ["$q", "$http", "EndpointsService", "$log"];
    angular
        .module('accounts')
        .factory('AccountLimitOrderNotificationTypeService', AccountLimitOrderNotificationTypeService);

    function AccountLimitOrderNotificationTypeService($q, $http, EndpointsService, $log) {
        var AccountLimitOrderNotificationTypeServiceBase = {};
        AccountLimitOrderNotificationTypeServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("AccountLimitOrderNotificationTypeServiceBase.getPage:", params);
                $http.get(response.links.accountLimitOrderNotificationType, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return AccountLimitOrderNotificationTypeServiceBase;
    }
}());
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name accounts.factory:AccountLimitOrderEffectiveTypeService
     *
     * @description
     *
     */
    AccountLimitOrderEffectiveTypeService.$inject = ["$q", "$http", "EndpointsService", "$log"];
    angular
        .module('accounts')
        .factory('AccountLimitOrderEffectiveTypeService', AccountLimitOrderEffectiveTypeService);

    function AccountLimitOrderEffectiveTypeService($q, $http, EndpointsService, $log) {
        var AccountLimitOrderEffectiveTypeServiceBase = {};
        AccountLimitOrderEffectiveTypeServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("AccountLimitOrderEffectiveTypeServiceBase.getPage:", params);
                $http.get(response.links.accountLimitOrderEffectiveType, {
                        params: params
                    })
                    .success(function (data) {
                        deferred.resolve(data);
                    }).error(function (msg, code) {
                        deferred.reject(msg);
                    });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return AccountLimitOrderEffectiveTypeServiceBase;
    }
}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:AccTransDetailModalCtrl
   *
   * @description
   *
   */
  AccTransDetailModalCtrl.$inject = ["transaction", "account", "$uibModalInstance", "HelperService", "$localStorage"];
  angular
    .module('accounts')
    .controller('AccTransDetailModalCtrl', AccTransDetailModalCtrl);

  function AccTransDetailModalCtrl(transaction, account, $uibModalInstance, HelperService, $localStorage) {
    var vm = this;
    vm.ctrlName = 'AccTransDetailModalCtrl';
    vm.transaction = transaction;
    vm.account = account;

    vm.countryCode = $localStorage.code;

    vm.closeModal = function(){
      $uibModalInstance.close();
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:AccountsCtrl
   *
   * @description
   *
   */
  MainController.$inject = ["$rootScope", "$q", "UserSettingsService", "ConfigEndpointService", "$log", "ViberService", "EndpointsService", "HelperService"];
  angular
      .module('core')
      .controller('MainController', MainController);

  function MainController($rootScope, $q, UserSettingsService, ConfigEndpointService,
                          $log, ViberService, EndpointsService, HelperService) {

    var vm = this;
    vm.isAuthenticated = false;
    $rootScope.APP_GLOBAL_SETTINGS = {};

    //$q.all([TimelineService.syncTimeline()])
    //    .then(function (responses) {
    //      var loginInfoTime = responses[0];
    //      $rootScope.APP_GLOBAL_SETTINGS.loginInfo = loginInfoTime;
    //      loadGlobalSettings();
    //    })
    //    .catch(function (error, status) {
    //      $log.debug("Error: ", error);
    //      $log.debug("Status: ", status);
    //      if(status !== 401 && status !== 403) {
    //        loadGlobalSettings();
    //      }
    //      //vm.isAuthenticated = false;
    //      //SessionService.authorize();
    //
    //    });

    function init() {
      EndpointsService.getLinks()
        .then(function (response) {
          loadGlobalSettings();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    }


    /*
    POSTO POZIV NA API IDE SAMO RADI loginInfo a zatim se na Dashboardu ponovo poziva - dodao sam da se ovaj podatak pokupi u dashboard controlleru
    TimelineService.syncTimeline()
      .then(function (response){
        $rootScope.APP_GLOBAL_SETTINGS.loginInfo = response[0];
      })
      .catch(function (error){
        $log.debug("Sync Error: ", error);
      });
    */

    function loadGlobalSettings() {
      $rootScope.APP_GLOBAL_SETTINGS.counters = {};

      $q.all([ConfigEndpointService.getDefaultData(), UserSettingsService.getPage()])
          .then(function (responses) {
            // 1. response
            var defaultData = responses[0];
            $rootScope.APP_GLOBAL_SETTINGS.defaultData = defaultData;
            // 2. response
            var userSettings = responses[1].result[0];
            $rootScope.APP_GLOBAL_SETTINGS.userSettings = userSettings;
          $log.debug("$rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId", $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId);
            //check if user activated Viber only for BiH environment
            if(defaultData.APILocation != 'sl'){
              ViberService.checkActivation()
                .then(function (response){
                  $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = response.result;
                })
                .catch(function (error) {
                  HelperService.showMessage(error, 'error');
                });
            }

            vm.isAuthenticated = true;
          })
          .catch(function (error) {
            //vm.isAuthenticated = false;
            $log.debug("loadGlobalSettings error: ", error);
          });
    }


    init();
  }
}());

(function () {
    'use strict';

    config.$inject = ["$urlRouterProvider", "$httpProvider", "$locationProvider", "NotificationProvider", "$compileProvider", "ConfigServiceProvider"];
    angular
        .module('comtradeBankingWeb')
        .config(config)
        .run(['$rootScope', '$log', '$location', 'SessionService', 'TimelineService', '$sessionStorage', 'ConfigService', 'ConfigEndpointService', 'Notification', 'HelperService', 'AccountsService',
          function ($rootScope, $log, $location, SessionService, TimelineService, $sessionStorage, ConfigService, ConfigEndpointService, Notification, HelperService, AccountsService) {

                //$rootScope.appGlobalSettings = {};
                // If user is logged, sync data

                //if(ConfigService.authDebug || $sessionStorage.ct_accessToken){
                //  TimelineService.syncTimeline().then(function(response){
                //    console.log("Synced: ");
                //    // $rootScope.$emit('timelineSynced');
                //  }).catch(function(err){
                //    console.log("Error: " + err);
                //  });
                //}

                //$rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams, $httpProvider) {
                //  if(!ConfigService.authDebug && !$sessionStorage.ct_accessToken){
                //    $rootScope.appGlobalSettings.isAuthenticated = false;
                //    SessionService.authorize();
                //  } else {
                //    $rootScope.appGlobalSettings.isAuthenticated = true;
                //  }
                //});

                //initialize Google Analytics
                //$window.ga('create', 'UA-81145963-1', 'auto');

                $rootScope.$on('$stateChangeSuccess',  function  () {
                    //removing numeric values from url paths
                    //                var title = $location.url().substring(1, $location.url().length);
                    //                var urlParts = title.split("/");
                    //                for(var i=0; i<urlParts.length; i++){
                    //                  var match = urlParts[i].match(/\d+/g);
                    //                  if(match){
                    //                    urlParts.splice(i, 1);
                    //                  }
                    //                }
                    //                console.log("UrlParts: " + urlParts);
                    //                var url = "";
                    //                for(var i=0; i<urlParts.length; i++){
                    //                  url = url + "/" + urlParts[i];
                    //                }
                    //                console.log("Url:" + url);
                    ////                title = url.replace('/', "");
                    //                title = url.replace(/\//g, " ");
                    //                console.log("Title:" + title);
                    var gtmObject = HelperService.processUrlForGTM('pageView');

                    var array = gtmObject.title.split(" ");
                    if (array[1] == "accounts" && array[2] != undefined) {
                        var accId = array[2];
                        AccountsService.getAccountById(accId)
                            .then(function (response) {


                                gtmObject.title = array[1] + " - " + response.accountType.group;
                                Notification.clearAll();
                                if ($rootScope.APP_GLOBAL_SETTINGS.userSettings !== undefined && window.dataLayer) {
                                    dataLayer.push({
                                        'event': 'virtualPageview',
                                        'userId': $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId,
                                        'page': gtmObject.urlWithoutId,
                                        'title': gtmObject.title,
                                        'url': $location.host() + gtmObject.urlWithoutId
                                    });
                                }

                            })
                            .catch(function (error) {
                                HelperService.showMessage(error, 'error');
                            });
                    } else {

                        Notification.clearAll();
                        //register dataLayer for page tracking
                        if ($rootScope.APP_GLOBAL_SETTINGS.userSettings !== undefined && window.dataLayer) {
                            dataLayer.push({
                                'event': 'virtualPageview',
                                'userId': $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId,
                                'page': gtmObject.urlWithoutId,
                                'title': gtmObject.titleWithoutId,
                                'url': $location.host() + gtmObject.urlWithoutId
                            });
                        }
                    }
                });

    }]);

    function config($urlRouterProvider, $httpProvider, $locationProvider, NotificationProvider, $compileProvider, ConfigServiceProvider) {
        $httpProvider.interceptors.push('SessionInjectorService');
        $urlRouterProvider.otherwise('/dashboard');
        $httpProvider.defaults.useXDomain = true;
        $httpProvider.defaults.headers.common = {};
        $httpProvider.defaults.headers.post = {};
        $httpProvider.defaults.headers.put = {};
        $httpProvider.defaults.headers.patch = {};

        $httpProvider.defaults.useXDomain = true;
        delete $httpProvider.defaults.headers.common["X-Requested-With"];

        //NOTE: Disabling POST options with this, TODO: Check on IIS
        //$httpProvider.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        //$httpProvider.defaults.headers.common["Accept"] = "*/*";
        $httpProvider.defaults.headers.common["content-type"] = "application/json";

        //$httpProvider.defaults.headers.common['X-User-Agent'] = "MyClient" ;
        //$locationProvider.html5Mode(true).hashPrefix('!');
        $locationProvider.hashPrefix('!');
        //alert(SessionService.accessToken);

        //$sessionStorageProvider.set('ct.accessToken', 'token-something1');

        NotificationProvider.setOptions({
            delay: null,
            startTop: 70,
            startRight: 0,
            verticalSpacing: 20,
            horizontalSpacing: 20,
            positionX: 'center',
            positionY: 'top',
            replaceMessage: null,
            maxCount: null
        });

        if (!ConfigServiceProvider.debugInfoEnabled) {
            $compileProvider.debugInfoEnabled(false);
        }

    }
}());
